import * as i0 from '@angular/core';
import { Injectable, Directive, Input, HostListener, EventEmitter, InjectionToken, isDevMode, inject, PLATFORM_ID, Inject, ElementRef, ViewContainerRef, createComponent, Output, HostBinding, Self, Optional, booleanAttribute, SecurityContext, DestroyRef, Component, ContentChildren, ContentChild, RendererStyleFlags2, Pipe, ViewChild, LOCALE_ID, forwardRef, Host, QueryList, ViewChildren, TemplateRef, ChangeDetectionStrategy, SimpleChange, ChangeDetectorRef, NgZone, SkipSelf, reflectComponentType, NgModule } from '@angular/core';
import * as i4 from '@angular/forms';
import { NgModel, NgControl, FormControlName, NG_VALUE_ACCESSOR, Validators, NG_VALIDATORS, FormGroup, FormsModule, RequiredValidator, MinValidator, MaxValidator, EmailValidator, MinLengthValidator, MaxLengthValidator, PatternValidator, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable, NEVER, Subject, fromEvent, BehaviorSubject, interval, animationFrameScheduler, noop, merge, Subscription, timer, sampleTime, filter as filter$1, pipe } from 'rxjs';
import { takeUntil, filter, throttle, throttleTime, first as first$2, startWith, take, debounce, tap, switchMap, skipLast, debounceTime, map, shareReplay, takeWhile, timeout, pluck } from 'rxjs/operators';
import { isPlatformBrowser, formatDate as formatDate$1, CurrencyPipe, FormatWidth, getLocaleDateFormat, formatPercent, formatNumber, getLocaleCurrencyCode, DatePipe, getLocaleDateTimeFormat, DOCUMENT, NgTemplateOutlet, NgClass, TitleCasePipe, getLocaleFirstDayOfWeek, NgStyle, getLocaleCurrencySymbol, formatCurrency as formatCurrency$1, getLocaleNumberFormat, NumberFormatStyle, DecimalPipe, PercentPipe, getCurrencySymbol, AsyncPipe } from '@angular/common';
import { mergeWith, isEqual as isEqual$1 } from 'lodash-es';
import { strToU8, zip } from 'fflate';
import { scaleInVerTop, scaleOutVerTop, AnimationUtil, fadeIn, fadeOut, slideInTop, slideOutTop, slideInBottom, slideOutBottom, scaleInHorRight, scaleOutHorRight, scaleInHorLeft, scaleOutHorLeft, scaleInVerBottom, scaleOutVerBottom, scaleInCenter, growVerIn, growVerOut, slideInLeft } from '@infragistics/igniteui-angular/animations';
import * as i1 from '@angular/animations';
import { style, animate, useAnimation } from '@angular/animations';
import * as i1$1 from '@angular/platform-browser';
import { ɵgetDOM as _getDOM, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as i2 from '@angular/common/http';
import { addRow, addChild, pinLeft, unpinLeft, jumpDown, jumpUp, caseSensitive, editor } from '@igniteui/material-icons-extended';
import { __decorate, __param } from 'tslib';

/**
 * Common service to be injected between components where those implementing common
 * ToggleView interface can register and toggle directives can call their methods.
 * TODO: Track currently active? Events?
 */
const _c0 = ["*"];
function IgxIconComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxIconComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.iconRef.name);
  }
}
function IgxIconComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.getSvg, i0.ɵɵsanitizeHtml);
  }
}
const _c1 = [[["igx-hint"], ["", "igxHint", ""]], [["", "igxLabel", ""]], [["", "igxInput", ""]], [["igx-prefix"], ["", "igxPrefix", ""]], [["igx-suffix"], ["", "igxSuffix", ""]]];
const _c2 = ["igx-hint, [igxHint]", "[igxLabel]", "[igxInput]", "igx-prefix, [igxPrefix]", "igx-suffix, [igxSuffix]"];
const _c3 = a0 => ({
  "igx-input-group__upload-button": a0
});
function IgxInputGroupComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, IgxInputGroupComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxInputGroupComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxInputGroupComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxInputGroupComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxInputGroupComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function IgxInputGroupComponent_ng_template_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-prefix", 14)(1, "button", 15);
    i0.ɵɵlistener("click", function IgxInputGroupComponent_ng_template_10_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.uploadButtonHandler());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r3.disabled)("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r3.isTypeLine));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.resourceStrings.igx_input_upload_button, " ");
  }
}
function IgxInputGroupComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_10_Conditional_0_Template, 3, 5, "igx-prefix", 14);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxInputGroupComponent_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r3.fileNames);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.fileNames);
  }
}
function IgxInputGroupComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_12_Conditional_0_Template, 3, 2, "div", 16);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxInputGroupComponent_ng_template_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 18);
    i0.ɵɵlistener("click", function IgxInputGroupComponent_ng_template_14_Conditional_0_Template_igx_suffix_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    })("keydown.Enter", function IgxInputGroupComponent_ng_template_14_Conditional_0_Template_igx_suffix_keydown_Enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    });
    i0.ɵɵelement(1, "igx-icon", 19);
    i0.ɵɵelementEnd();
  }
}
function IgxInputGroupComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_14_Conditional_0_Template, 2, 0, "igx-suffix", 17);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType && ctx_r3.isFilled ? 0 : -1);
  }
}
function IgxInputGroupComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 4);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_18_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxInputGroupComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, IgxInputGroupComponent_ng_template_18_ng_container_2_Template, 1, 0, "ng-container", 13)(3, IgxInputGroupComponent_ng_template_18_ng_container_3_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(4);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵtemplate(6, IgxInputGroupComponent_ng_template_18_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵtemplate(8, IgxInputGroupComponent_ng_template_18_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxInputGroupComponent_ng_template_18_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 24);
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵtemplate(12, IgxInputGroupComponent_ng_template_18_ng_container_12_Template, 1, 0, "ng-container", 13)(13, IgxInputGroupComponent_ng_template_18_ng_container_13_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, IgxInputGroupComponent_ng_template_18_Conditional_14_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 14 : -1);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_20_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxInputGroupComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_20_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxInputGroupComponent_ng_template_20_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxInputGroupComponent_ng_template_20_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 23);
    i0.ɵɵtemplate(6, IgxInputGroupComponent_ng_template_20_ng_container_6_Template, 1, 0, "ng-container", 13)(7, IgxInputGroupComponent_ng_template_20_ng_container_7_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 25);
    i0.ɵɵtemplate(9, IgxInputGroupComponent_ng_template_20_ng_container_9_Template, 1, 0, "ng-container", 13)(10, IgxInputGroupComponent_ng_template_20_ng_container_10_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, IgxInputGroupComponent_ng_template_20_Conditional_11_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 11 : -1);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_22_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxInputGroupComponent_ng_template_22_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxInputGroupComponent_ng_template_22_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxInputGroupComponent_ng_template_22_ng_container_5_Template, 1, 0, "ng-container", 13)(6, IgxInputGroupComponent_ng_template_22_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵtemplate(8, IgxInputGroupComponent_ng_template_22_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxInputGroupComponent_ng_template_22_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_24_Case_0_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const bootstrapBundle_r13 = i0.ɵɵreference(23);
    i0.ɵɵproperty("ngTemplateOutlet", bootstrapBundle_r13);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_24_Case_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_24_Case_2_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxInputGroupComponent_ng_template_24_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_24_Case_3_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const materialBundle_r15 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", materialBundle_r15);
  }
}
function IgxInputGroupComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxInputGroupComponent_ng_template_24_Case_0_Template, 1, 1, "ng-container")(1, IgxInputGroupComponent_ng_template_24_Case_1_Template, 1, 1, "ng-container")(2, IgxInputGroupComponent_ng_template_24_Case_2_Template, 1, 1, "ng-container")(3, IgxInputGroupComponent_ng_template_24_Case_3_Template, 1, 1, "ng-container");
  }
  if (rf & 2) {
    let tmp_12_0;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_12_0 = ctx_r3.theme) === "bootstrap" ? 0 : tmp_12_0 === "fluent" ? 1 : tmp_12_0 === "indigo" ? 2 : 3);
  }
}
const _c4 = ["display_container"];
function DisplayContainerComponent_ng_template_0_Template(rf, ctx) {}
const _c5 = ["horizontal_container"];
const _c6 = ["container"];
const _c7 = ["checkbox"];
const _c8 = ["label"];
const _c9 = ["placeholderLabel"];
const _c10 = [[["igx-expansion-panel-title"]], [["igx-expansion-panel-description"]], "*", [["igx-expansion-panel-icon"]]];
const _c11 = ["igx-expansion-panel-title", "igx-expansion-panel-description", "*", "igx-expansion-panel-icon"];
function IgxExpansionPanelHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function IgxExpansionPanelHeaderComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.panel.collapsed ? "expand" : "collapse");
    i0.ɵɵattribute("aria-hidden", true);
  }
}
const _c12 = [[["igx-expansion-panel-header"]], [["igx-expansion-panel-body"]]];
const _c13 = ["igx-expansion-panel-header", "igx-expansion-panel-body"];
function IgxExpansionPanelComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c14 = [[["igx-expansion-panel"]]];
const _c15 = ["igx-expansion-panel"];
const _c16 = [[["igx-drop-down-item"]]];
const _c17 = ["igx-drop-down-item"];
const _c18 = [[["igx-prefix"], ["", "igxPrefix", ""]], "*", [["igx-suffix"], ["", "igxSuffix", ""]], [["igx-divider"]]];
const _c19 = ["igx-prefix, [igxPrefix]", "*", "igx-suffix, [igxSuffix]", "igx-divider"];
const _c20 = ["scrollContainer"];
function IgxDropDownComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c21 = ["menuItemTemplate"];
function IgxGridActionButtonComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("family", ctx_r1.iconSet)("name", ctx_r1.iconName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.iconName);
  }
}
function IgxGridActionButtonComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.iconName);
  }
}
function IgxGridActionButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function IgxGridActionButtonComponent_Conditional_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleClick($event));
    })("mousedown", function IgxGridActionButtonComponent_Conditional_0_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.preventEvent($event));
    });
    i0.ɵɵtemplate(1, IgxGridActionButtonComponent_Conditional_0_Conditional_1_Template, 2, 3, "igx-icon", 4)(2, IgxGridActionButtonComponent_Conditional_0_Conditional_2_Template, 2, 1, "igx-icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.labelText);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.iconSet ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.iconSet ? 2 : -1);
  }
}
function IgxGridActionButtonComponent_ng_template_1_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("family", ctx_r1.iconSet)("name", ctx_r1.iconName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.iconName);
  }
}
function IgxGridActionButtonComponent_ng_template_1_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.iconName);
  }
}
function IgxGridActionButtonComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5, 1);
    i0.ɵɵtemplate(2, IgxGridActionButtonComponent_ng_template_1_Conditional_0_Conditional_2_Template, 2, 3, "igx-icon", 4)(3, IgxGridActionButtonComponent_ng_template_1_Conditional_0_Conditional_3_Template, 2, 1, "igx-icon");
    i0.ɵɵelementStart(4, "label", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("className", ctx_r1.containerClass);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.iconSet ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.iconSet ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labelText);
  }
}
function IgxGridActionButtonComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridActionButtonComponent_ng_template_1_Conditional_0_Template, 6, 4, "div", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.asMenuItem ? 0 : -1);
  }
}
function IgxCheckboxComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵelement(1, "rect", 9)(2, "path", 10);
    i0.ɵɵelementEnd();
  }
}
function IgxCheckboxComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵelement(1, "path", 11);
    i0.ɵɵelementEnd();
  }
}
const _c22 = ["igxDirRef"];
const _c23 = ["cell"];
const _c24 = ["dropdown"];
const _c25 = a0 => ({
  $implicit: a0
});
function _forTrack0($index, $item) {
  return this.trackMenuItem($item);
}
function IgxActionStripComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function IgxActionStripComponent_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelement(1, "igx-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const dropdown_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("igxToggleAction", dropdown_r3)("overlaySettings", ctx_r1.menuOverlaySettings)("title", ctx_r1.resourceStrings.igx_action_strip_button_more_title)("igxDropDownItemNavigation", dropdown_r3);
  }
}
function IgxActionStripComponent_For_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxActionStripComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 3)(1, "div", 6);
    i0.ɵɵtemplate(2, IgxActionStripComponent_For_6_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", item_r4.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, item_r4));
  }
}
function IgxGridEditingActionsComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 4);
    i0.ɵɵlistener("actionClick", function IgxGridEditingActionsComponent_Conditional_0_Conditional_0_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.startEdit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_edit_label);
  }
}
function IgxGridEditingActionsComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 5);
    i0.ɵɵlistener("actionClick", function IgxGridEditingActionsComponent_Conditional_0_Conditional_1_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addRowHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_add_label);
  }
}
function IgxGridEditingActionsComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 6);
    i0.ɵɵlistener("actionClick", function IgxGridEditingActionsComponent_Conditional_0_Conditional_2_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addRowHandler($event, true));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_add_child_label);
  }
}
function IgxGridEditingActionsComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 7);
    i0.ɵɵlistener("actionClick", function IgxGridEditingActionsComponent_Conditional_0_Conditional_3_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteRowHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_delete_label);
  }
}
function IgxGridEditingActionsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridEditingActionsComponent_Conditional_0_Conditional_0_Template, 1, 2, "igx-grid-action-button", 0)(1, IgxGridEditingActionsComponent_Conditional_0_Conditional_1_Template, 1, 2, "igx-grid-action-button", 1)(2, IgxGridEditingActionsComponent_Conditional_0_Conditional_2_Template, 1, 2, "igx-grid-action-button", 2)(3, IgxGridEditingActionsComponent_Conditional_0_Conditional_3_Template, 1, 2, "igx-grid-action-button", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.disabled && ctx_r1.editRow ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.addRow && ctx_r1.isRootRow ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.addChild && ctx_r1.hasChildren ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.disabled && ctx_r1.deleteRow ? 3 : -1);
  }
}
function IgxGridPinningActionsComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 4);
    i0.ɵɵlistener("actionClick", function IgxGridPinningActionsComponent_Conditional_0_Conditional_0_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scrollToRow($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_jumpDown_label);
  }
}
function IgxGridPinningActionsComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 5);
    i0.ɵɵlistener("actionClick", function IgxGridPinningActionsComponent_Conditional_0_Conditional_1_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scrollToRow($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_jumpUp_label);
  }
}
function IgxGridPinningActionsComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 6);
    i0.ɵɵlistener("actionClick", function IgxGridPinningActionsComponent_Conditional_0_Conditional_2_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pin($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_pin_label);
  }
}
function IgxGridPinningActionsComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-action-button", 7);
    i0.ɵɵlistener("actionClick", function IgxGridPinningActionsComponent_Conditional_0_Conditional_3_Template_igx_grid_action_button_actionClick_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.unpin($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("asMenuItem", ctx_r1.asMenuItems)("labelText", ctx_r1.grid.resourceStrings.igx_grid_actions_unpin_label);
  }
}
function IgxGridPinningActionsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridPinningActionsComponent_Conditional_0_Conditional_0_Template, 1, 2, "igx-grid-action-button", 0)(1, IgxGridPinningActionsComponent_Conditional_0_Conditional_1_Template, 1, 2, "igx-grid-action-button", 1)(2, IgxGridPinningActionsComponent_Conditional_0_Conditional_2_Template, 1, 2, "igx-grid-action-button", 2)(3, IgxGridPinningActionsComponent_Conditional_0_Conditional_3_Template, 1, 2, "igx-grid-action-button", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.inPinnedArea && ctx_r1.pinnedTop ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.inPinnedArea && !ctx_r1.pinnedTop ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.pinned ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.pinned ? 3 : -1);
  }
}
const _c26 = ["defaultTemplate"];
const _c27 = ["imageTemplate"];
const _c28 = ["initialsTemplate"];
const _c29 = ["iconTemplate"];
function IgxAvatarComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxAvatarComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6, 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-image", ctx_r0.getSrcUrl());
  }
}
function IgxAvatarComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.initials.substring(0, 2));
  }
}
function IgxAvatarComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon);
  }
}
function IgxAvatarComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxBadgeComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function IgxBadgeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon);
  }
}
function IgxBadgeComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("family", ctx_r0.iconSet)("name", ctx_r0.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon);
  }
}
const _c30 = ["expansionPanel"];
const _c31 = ["*", [["igx-icon"]], [["igx-banner-actions"]]];
const _c32 = ["*", "igx-icon", "igx-banner-actions"];
function IgxBannerComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function IgxBannerComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function IgxBannerComponent_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.resourceStrings.igx_banner_button_dismiss, " ");
  }
}
function IgxBannerComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxButtonGroupComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r1.icon);
  }
}
function IgxButtonGroupComponent_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r1.label);
  }
}
function IgxButtonGroupComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 1)(1, "span");
    i0.ɵɵtemplate(2, IgxButtonGroupComponent_For_2_Conditional_2_Template, 2, 1, "igx-icon")(3, IgxButtonGroupComponent_For_2_Conditional_3_Template, 2, 1, "span", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", button_r1.selected)("disabled", ctx_r1.disabled || button_r1.disabled)("igxLabel", button_r1.label)("igxRipple", button_r1.ripple);
    i0.ɵɵattribute("data-togglable", button_r1.togglable);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("igx-button-group__item-content ", ctx_r1.itemContentCssClass, "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r1.icon ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r1.label ? 3 : -1);
  }
}
function IgxMonthsViewComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3, 0);
    i0.ɵɵlistener("itemSelection", function IgxMonthsViewComponent_For_2_Template_span_itemSelection_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectDate($event));
    })("mousedown", function IgxMonthsViewComponent_For_2_Template_span_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMouseDown());
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const month_r3 = ctx.$implicit;
    const item_r4 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", month_r3)("date", ctx_r1.date)("showActive", ctx_r1.showActive);
    i0.ɵɵattribute("id", month_r3.getTime())("aria-label", ctx_r1.formattedMonth(month_r3).long)("aria-selected", item_r4.isSelected);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, ctx_r1.formattedMonth(month_r3).formatted), " ");
  }
}
function IgxYearsViewComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3, 0);
    i0.ɵɵlistener("itemSelection", function IgxYearsViewComponent_For_2_Template_span_itemSelection_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectDate($event));
    })("mousedown", function IgxYearsViewComponent_For_2_Template_span_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMouseDown());
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const year_r3 = ctx.$implicit;
    const item_r4 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", year_r3)("date", ctx_r1.date)("showActive", ctx_r1.showActive);
    i0.ɵɵattribute("id", year_r3.getTime())("aria-label", ctx_r1.formattedYear(year_r3).long)("aria-selected", item_r4.isSelected)("aria-current", item_r4.isCurrent);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formattedYear(year_r3).formatted, " ");
  }
}
const _c33 = ["yearsBtn"];
const _forTrack1 = ($index, $item) => $item.long;
function IgxDaysViewComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span")(2, "i");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, ctx_r0.weekNumberHeader.short));
  }
}
function IgxDaysViewComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dayName_r2 = ctx.$implicit;
    i0.ɵɵattribute("aria-label", dayName_r2.long);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, dayName_r2.formatted), " ");
  }
}
function IgxDaysViewComponent_For_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const week_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getWeekNumber(week_r3[0]), " ");
  }
}
function IgxDaysViewComponent_For_6_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-day-item", 9, 0);
    i0.ɵɵlistener("click", function IgxDaysViewComponent_For_6_For_3_Template_igx_day_item_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleDateClick(item_r5));
    })("mouseEnter", function IgxDaysViewComponent_For_6_For_3_Template_igx_day_item_mouseEnter_0_listener() {
      const day_r6 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changePreviewRange(day_r6.native));
    })("mouseLeave", function IgxDaysViewComponent_For_6_For_3_Template_igx_day_item_mouseLeave_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.clearPreviewRange());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r6 = ctx.$implicit;
    const item_r5 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("date", day_r6)("viewDate", ctx_r0.viewDate)("selection", ctx_r0.selection)("selected", ctx_r0.isSelected(day_r6))("isActive", ctx_r0.isActiveDate(day_r6))("isLastInRange", ctx_r0.isLastInRange(day_r6))("isFirstInRange", ctx_r0.isFirstInRange(day_r6))("isWithinRange", ctx_r0.isWithinRange(day_r6.native, true))("isWithinPreviewRange", ctx_r0.isWithinPreviewRange(day_r6.native))("disabledDates", ctx_r0.disabledDates)("specialDates", ctx_r0.specialDates)("hideLeadingDays", ctx_r0.hideLeadingDays)("hideTrailingDays", ctx_r0.hideTrailingDays);
    i0.ɵɵattribute("id", item_r5.isCurrentMonth && day_r6.timestamp)("aria-selected", ctx_r0.isSelected(day_r6))("aria-disabled", ctx_r0.isDateDisabled(day_r6.native))("aria-label", ctx_r0.isFirstInRange(day_r6) ? day_r6.native.toDateString() + ", " + ctx_r0.resourceStrings.igx_calendar_range_start : ctx_r0.isLastInRange(day_r6) ? day_r6.native.toDateString() + ", " + ctx_r0.resourceStrings.igx_calendar_range_end : day_r6.native.toDateString())("tabindex", -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedDate(day_r6.native), " ");
  }
}
function IgxDaysViewComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, IgxDaysViewComponent_For_6_Conditional_1_Template, 3, 1, "div", 6);
    i0.ɵɵrepeaterCreate(2, IgxDaysViewComponent_For_6_For_3_Template, 3, 19, "igx-day-item", 7, i0.ɵɵcomponentInstance().dateTracker, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showWeekNumbers ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(week_r3);
  }
}
const _c34 = ["wrapper"];
const _c35 = ["decade"];
const _c36 = ["months"];
const _c37 = ["days"];
const _c38 = ["prevPageBtn"];
const _c39 = ["nextPageBtn"];
const _c40 = ["monthsBtn"];
function IgxCalendarComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.resourceStrings.igx_calendar_select_date);
  }
}
function IgxCalendarComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.resourceStrings.igx_calendar_range_placeholder);
  }
}
function IgxCalendarComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_ng_template_0_Conditional_0_Template, 2, 1, "span")(1, IgxCalendarComponent_ng_template_0_Conditional_1_Template, 2, 1, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.selection === "single" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selection === "range" ? 1 : -1);
  }
}
function IgxCalendarComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.getFormattedDate().weekday, ",\xA0");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getFormattedDate().monthday);
  }
}
function IgxCalendarComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "\xA0-\xA0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.selectedDates.length === 0 ? "Start" : ctx_r0.getFormattedRange().start);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.selectedDates.length <= 1 ? "End" : ctx_r0.getFormattedRange().end);
  }
}
function IgxCalendarComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_ng_template_2_Conditional_0_Template, 4, 2)(1, IgxCalendarComponent_ng_template_2_Conditional_1_Template, 6, 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.selection === "single" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selection === "range" ? 1 : -1);
  }
}
function IgxCalendarComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 28, 14);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵlistener("keydown", function IgxCalendarComponent_ng_template_4_Template_span_keydown_0_listener($event) {
      const obj_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onActiveViewYearKB(obj_r3.date, $event, obj_r3.index));
    })("mousedown", function IgxCalendarComponent_ng_template_4_Template_span_mousedown_0_listener($event) {
      const obj_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onActiveViewYear($event, obj_r3.date, obj_r3.index));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 2, obj_r3.date, "LLLL") + ", " + ctx_r0.resourceStrings.igx_calendar_select_month);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedMonth(obj_r3.date), " ");
  }
}
function IgxCalendarComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.formattedYear(obj_r5.date));
  }
}
function IgxCalendarComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxCalendarComponent_ng_template_6_Conditional_0_Template, 2, 1, "span", 29);
    i0.ɵɵelementStart(1, "span", 28, 15);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵlistener("keydown", function IgxCalendarComponent_ng_template_6_Template_span_keydown_1_listener($event) {
      const obj_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onActiveViewDecadeKB(obj_r5.date, $event, obj_r5.index));
    })("mousedown", function IgxCalendarComponent_ng_template_6_Template_span_mousedown_1_listener($event) {
      const obj_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onActiveViewDecade($event, obj_r5.date, obj_r5.index));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.activeView === "year" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 3, obj_r5.date, "yyyy") + ", " + ctx_r0.resourceStrings.igx_calendar_select_year);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formattedYear(obj_r5.date), " ");
  }
}
function IgxCalendarComponent_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monthsViewNumber > 1 ? ctx_r0.resourceStrings.igx_calendar_first_picker_of.replace("{0}", ctx_r0.monthsViewNumber.toString()) + " " + i0.ɵɵpipeBind2(2, 1, obj_r6.date, "LLLL yyyy") : ctx_r0.resourceStrings.igx_calendar_selected_month_is + i0.ɵɵpipeBind2(3, 4, obj_r6.date, "LLLL yyyy"), " ");
  }
}
function IgxCalendarComponent_ng_template_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_ng_template_8_Conditional_0_Template, 4, 7, "span", 29)(1, IgxCalendarComponent_ng_template_8_ng_container_1_Template, 1, 0, "ng-container", 30)(2, IgxCalendarComponent_ng_template_8_ng_container_2_Template, 1, 0, "ng-container", 30);
  }
  if (rf & 2) {
    const obj_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultMonth_r7 = i0.ɵɵreference(5);
    const defaultYear_r8 = i0.ɵɵreference(7);
    i0.ɵɵconditional(ctx_r0.monthsViewNumber < 2 || obj_r6.index < 1 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultMonth_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c25, obj_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultYear_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c25, obj_r6));
  }
}
function IgxCalendarComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.getDecadeRange().start, " - ", ctx_r0.getDecadeRange().end, "");
  }
}
function IgxCalendarComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 31);
  }
}
function IgxCalendarComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 32);
  }
}
function IgxCalendarComponent_ng_template_16_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33, 16);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵlistener("keydown", function IgxCalendarComponent_ng_template_16_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtemplate(3, IgxCalendarComponent_ng_template_16_ng_container_3_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const prevArrow_r10 = i0.ɵɵreference(13);
    i0.ɵɵproperty("startScroll", ctx_r0.startPrevPageScroll)("stopScroll", ctx_r0.stopPageScroll);
    i0.ɵɵattribute("aria-label", ctx_r0.prevNavLabel(i0.ɵɵpipeBind2(2, 4, ctx_r0.getPrevMonth(ctx_r0.viewDate), "LLLL")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prevArrow_r10);
  }
}
function IgxCalendarComponent_ng_template_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35, 17);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵlistener("keydown", function IgxCalendarComponent_ng_template_18_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtemplate(3, IgxCalendarComponent_ng_template_18_ng_container_3_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const nextArrow_r12 = i0.ɵɵreference(15);
    i0.ɵɵproperty("startScroll", ctx_r0.startNextPageScroll)("stopScroll", ctx_r0.stopPageScroll);
    i0.ɵɵattribute("aria-label", ctx_r0.nextNavLabel(i0.ɵɵpipeBind2(2, 4, ctx_r0.getNextMonth(ctx_r0.viewDate, ctx_r0.monthsViewNumber), "LLLL")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", nextArrow_r12);
  }
}
function IgxCalendarComponent_ng_template_20_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_20_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_20_Conditional_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_20_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, IgxCalendarComponent_ng_template_20_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 34)(2, IgxCalendarComponent_ng_template_20_Conditional_4_ng_container_2_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const prevPageButton_r13 = i0.ɵɵreference(17);
    const nextPageButton_r14 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", prevPageButton_r13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextPageButton_r14);
  }
}
function IgxCalendarComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 36)(1, "div", 37);
    i0.ɵɵpipe(2, "IgxGetViewDate");
    i0.ɵɵtemplate(3, IgxCalendarComponent_ng_template_20_ng_container_3_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxCalendarComponent_ng_template_20_Conditional_4_Template, 3, 2, "div", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r15 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultMonthYear_r16 = i0.ɵɵreference(9);
    i0.ɵɵstyleProp("--calendar-row-start", 1 + 2 * i_r15);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-month", i0.ɵɵpipeBind3(2, 6, i_r15, ctx_r0.viewDate, false));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.subheaderTemplate ? ctx_r0.subheaderTemplate : defaultMonthYear_r16)("ngTemplateOutletContext", ctx_r0.getContext(i_r15));
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.orientation === "horizontal" ? i_r15 === ctx_r0.monthsViewNumber - 1 : i_r15 === 0) ? 4 : -1);
  }
}
function IgxCalendarComponent_ng_template_22_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_22_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_22_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 36)(1, "div", 37);
    i0.ɵɵtemplate(2, IgxCalendarComponent_ng_template_22_ng_container_2_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵtemplate(4, IgxCalendarComponent_ng_template_22_ng_container_4_Template, 1, 0, "ng-container", 34)(5, IgxCalendarComponent_ng_template_22_ng_container_5_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultYear_r8 = i0.ɵɵreference(7);
    const prevPageButton_r13 = i0.ɵɵreference(17);
    const nextPageButton_r14 = i0.ɵɵreference(19);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.subheaderTemplate ? ctx_r0.subheaderTemplate : defaultYear_r8)("ngTemplateOutletContext", ctx_r0.getContext(0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prevPageButton_r13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextPageButton_r14);
  }
}
function IgxCalendarComponent_ng_template_24_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_24_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_24_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 36)(1, "div", 39);
    i0.ɵɵtemplate(2, IgxCalendarComponent_ng_template_24_ng_container_2_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵtemplate(4, IgxCalendarComponent_ng_template_24_ng_container_4_Template, 1, 0, "ng-container", 34)(5, IgxCalendarComponent_ng_template_24_ng_container_5_Template, 1, 0, "ng-container", 34);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultDecade_r17 = i0.ɵɵreference(11);
    const prevPageButton_r13 = i0.ɵɵreference(17);
    const nextPageButton_r14 = i0.ɵɵreference(19);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.subheaderTemplate ? ctx_r0.subheaderTemplate : defaultDecade_r17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prevPageButton_r13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextPageButton_r14);
  }
}
function IgxCalendarComponent_Conditional_26_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_Conditional_26_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 21)(1, "h5", 40);
    i0.ɵɵtemplate(2, IgxCalendarComponent_Conditional_26_ng_container_2_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h2", 41);
    i0.ɵɵtemplate(4, IgxCalendarComponent_Conditional_26_ng_container_4_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_15_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultHeaderTitle_r18 = i0.ɵɵreference(1);
    const defaultHeaderDate_r19 = i0.ɵɵreference(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_15_0 = ctx_r0.headerTitleTemplate) !== null && tmp_15_0 !== undefined ? tmp_15_0 : defaultHeaderTitle_r18)("ngTemplateOutletContext", ctx_r0.headerContext);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate ? ctx_r0.headerTemplate : defaultHeaderDate_r19)("ngTemplateOutletContext", ctx_r0.headerContext);
  }
}
function IgxCalendarComponent_Conditional_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monthsViewNumber && ctx_r0.monthsViewNumber > 1 ? ctx_r0.resourceStrings.igx_calendar_multi_selection.replace("{0}", ctx_r0.monthsViewNumber.toString()) : ctx_r0.resourceStrings.igx_calendar_singular_multi_selection, " ");
  }
}
function IgxCalendarComponent_Conditional_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monthsViewNumber && ctx_r0.monthsViewNumber > 1 ? ctx_r0.resourceStrings.igx_calendar_range_selection.replace("{0}", ctx_r0.monthsViewNumber.toString()) : ctx_r0.resourceStrings.igx_calendar_singular_range_selection, " ");
  }
}
function IgxCalendarComponent_Conditional_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.monthsViewNumber && ctx_r0.monthsViewNumber > 1 ? ctx_r0.resourceStrings.igx_calendar_single_selection.replace("{0}", ctx_r0.monthsViewNumber.toString()) : ctx_r0.resourceStrings.igx_calendar_singular_single_selection, " ");
  }
}
function IgxCalendarComponent_Conditional_34_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_Conditional_34_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_Conditional_34_For_1_ng_container_0_Template, 1, 0, "ng-container", 30);
  }
  if (rf & 2) {
    const ɵ$index_183_r20 = ctx.$index;
    i0.ɵɵnextContext(2);
    const calendarDaysPicker_r21 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", calendarDaysPicker_r21)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ɵ$index_183_r20));
  }
}
function IgxCalendarComponent_Conditional_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxCalendarComponent_Conditional_34_For_1_Template, 1, 4, "ng-container", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵpipe(2, "IgxMonthViewSlots");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r0.monthsViewNumber));
  }
}
function IgxCalendarComponent_Conditional_35_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_Conditional_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_Conditional_35_ng_container_0_Template, 1, 0, "ng-container", 34);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const calendarYearPicker_r22 = i0.ɵɵreference(23);
    i0.ɵɵproperty("ngTemplateOutlet", calendarYearPicker_r22);
  }
}
function IgxCalendarComponent_Conditional_36_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarComponent_Conditional_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarComponent_Conditional_36_ng_container_0_Template, 1, 0, "ng-container", 34);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const calendarDecadePicker_r23 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", calendarDecadePicker_r23);
  }
}
function IgxCalendarComponent_Conditional_38_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-days-view", 43, 18);
    i0.ɵɵpipe(2, "IgxGetViewDate");
    i0.ɵɵtwoWayListener("activeDateChange", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.activeDate, $event) || (ctx_r0.activeDate = $event);
      return i0.ɵɵresetView($event);
    })("previewRangeDateChange", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_previewRangeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.previewRangeDate, $event) || (ctx_r0.previewRangeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("swiperight", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_swiperight_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.previousPage());
    })("swipeleft", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_swipeleft_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.nextPage());
    })("dateSelected", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleDateSelection($event));
    })("mousedown", function IgxCalendarComponent_Conditional_38_For_1_Template_igx_days_view_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_202_r25 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--calendar-row-start", (ɵ$index_202_r25 + 1) * 2);
    i0.ɵɵproperty("tabIndex", -1)("selection", ctx_r0.selection)("locale", ctx_r0.locale)("value", ctx_r0.value);
    i0.ɵɵtwoWayProperty("activeDate", ctx_r0.activeDate)("previewRangeDate", ctx_r0.previewRangeDate);
    i0.ɵɵproperty("viewDate", i0.ɵɵpipeBind2(2, 19, ɵ$index_202_r25, ctx_r0.viewDate))("weekStart", ctx_r0.weekStart)("formatOptions", ctx_r0.formatOptions)("formatViews", ctx_r0.formatViews)("disabledDates", ctx_r0.disabledDates)("specialDates", ctx_r0.specialDates)("hideLeadingDays", ctx_r0.hideOutsideDays || ɵ$index_202_r25 !== 0)("hideTrailingDays", ctx_r0.hideOutsideDays || ɵ$index_202_r25 !== ctx_r0.monthsViewNumber - 1)("showWeekNumbers", ctx_r0.showWeekNumbers)("showActiveDay", ctx_r0.showActiveDay)("standalone", false);
  }
}
function IgxCalendarComponent_Conditional_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxCalendarComponent_Conditional_38_For_1_Template, 3, 22, "igx-days-view", 42, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵpipe(2, "IgxMonthViewSlots");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r0.monthsViewNumber));
  }
}
function IgxCalendarComponent_Conditional_39_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-months-view", 44, 19);
    i0.ɵɵlistener("swiperight", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_swiperight_0_listener() {
      i0.ɵɵrestoreView(_r26);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.previousPage());
    })("swipeleft", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_swipeleft_0_listener() {
      i0.ɵɵrestoreView(_r26);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.nextPage());
    })("pageChanged", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_pageChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.updateYear($event));
    })("activeDateChanged", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_activeDateChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.updateActiveDescendant($event));
    })("selected", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changeMonth($event));
    })("mousedown", function IgxCalendarComponent_Conditional_39_Template_igx_months_view_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabIndex", -1)("date", ctx_r0.viewDate)("locale", ctx_r0.locale)("formatView", ctx_r0.formatViews.month)("monthFormat", ctx_r0.formatOptions.month)("showActive", ctx_r0.showActiveDay)("standalone", false);
  }
}
function IgxCalendarComponent_Conditional_40_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-years-view", 45, 20);
    i0.ɵɵlistener("swiperight", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_swiperight_0_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.previousPage());
    })("swipeleft", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_swipeleft_0_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.nextPage());
    })("pageChanged", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_pageChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.updateYear($event));
    })("activeDateChanged", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_activeDateChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.updateActiveDescendant($event));
    })("selected", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changeYear($event));
    })("mousedown", function IgxCalendarComponent_Conditional_40_Template_igx_years_view_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabIndex", -1)("date", ctx_r0.viewDate)("locale", ctx_r0.locale)("formatView", ctx_r0.formatViews.year)("yearFormat", ctx_r0.formatOptions.year)("showActive", ctx_r0.showActiveDay)("standalone", false);
  }
}
function IgxMonthPickerComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 20);
  }
}
function IgxMonthPickerComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 21);
  }
}
function IgxMonthPickerComponent_ng_template_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22, 9);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵlistener("mousedown", function IgxMonthPickerComponent_ng_template_4_Template_div_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previousPage());
    })("keydown", function IgxMonthPickerComponent_ng_template_4_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changePageKB($event, false));
    });
    i0.ɵɵtemplate(3, IgxMonthPickerComponent_ng_template_4_ng_container_3_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const prevArrow_r3 = i0.ɵɵreference(1);
    i0.ɵɵattribute("aria-label", ctx_r1.prevNavLabel(i0.ɵɵpipeBind2(2, 2, ctx_r1.getPrevYearDate(ctx_r1.viewDate), "YYYY")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prevArrow_r3);
  }
}
function IgxMonthPickerComponent_ng_template_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24, 10);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵlistener("mousedown", function IgxMonthPickerComponent_ng_template_6_Template_div_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextPage());
    })("keydown", function IgxMonthPickerComponent_ng_template_6_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changePageKB($event));
    });
    i0.ɵɵtemplate(3, IgxMonthPickerComponent_ng_template_6_ng_container_3_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const nextArrow_r5 = i0.ɵɵreference(3);
    i0.ɵɵattribute("aria-label", ctx_r1.nextNavLabel(i0.ɵɵpipeBind2(2, 2, ctx_r1.getNextYearDate(ctx_r1.viewDate), "YYYY")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", nextArrow_r5);
  }
}
function IgxMonthPickerComponent_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formattedYear(obj_r7.date));
  }
}
function IgxMonthPickerComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxMonthPickerComponent_ng_template_8_Conditional_0_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(1, "span", 26, 11);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵlistener("keydown", function IgxMonthPickerComponent_ng_template_8_Template_span_keydown_1_listener($event) {
      const obj_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onActiveViewDecadeKB(obj_r7.date, $event, obj_r7.index));
    })("mousedown", function IgxMonthPickerComponent_ng_template_8_Template_span_mousedown_1_listener($event) {
      const obj_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onActiveViewDecade($event, obj_r7.date, obj_r7.index));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const obj_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.activeView === "year" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 3, obj_r7.date, "yyyy") + ", " + ctx_r1.resourceStrings.igx_calendar_select_year);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formattedYear(obj_r7.date), " ");
  }
}
function IgxMonthPickerComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.getDecadeRange().start, " - ", ctx_r1.getDecadeRange().end, "");
  }
}
function IgxMonthPickerComponent_ng_template_12_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_12_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_12_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 27)(1, "div", 28);
    i0.ɵɵtemplate(2, IgxMonthPickerComponent_ng_template_12_ng_container_2_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtemplate(4, IgxMonthPickerComponent_ng_template_12_ng_container_4_Template, 1, 0, "ng-container", 23)(5, IgxMonthPickerComponent_ng_template_12_ng_container_5_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const prevPageButton_r8 = i0.ɵɵreference(5);
    const nextPageButton_r9 = i0.ɵɵreference(7);
    const defaultYear_r10 = i0.ɵɵreference(9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", defaultYear_r10)("ngTemplateOutletContext", ctx_r1.getContext(0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prevPageButton_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextPageButton_r9);
  }
}
function IgxMonthPickerComponent_ng_template_14_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_14_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_14_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 27)(1, "div", 31);
    i0.ɵɵtemplate(2, IgxMonthPickerComponent_ng_template_14_ng_container_2_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtemplate(4, IgxMonthPickerComponent_ng_template_14_ng_container_4_Template, 1, 0, "ng-container", 23)(5, IgxMonthPickerComponent_ng_template_14_ng_container_5_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const prevPageButton_r8 = i0.ɵɵreference(5);
    const nextPageButton_r9 = i0.ɵɵreference(7);
    const defaultDecade_r11 = i0.ɵɵreference(11);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", defaultDecade_r11);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prevPageButton_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nextPageButton_r9);
  }
}
function IgxMonthPickerComponent_Conditional_21_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxMonthPickerComponent_Conditional_21_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const calendarYearPicker_r12 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", calendarYearPicker_r12);
  }
}
function IgxMonthPickerComponent_Conditional_22_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxMonthPickerComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxMonthPickerComponent_Conditional_22_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const calendarDecadePicker_r13 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", calendarDecadePicker_r13);
  }
}
function IgxMonthPickerComponent_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-months-view", 32, 12);
    i0.ɵɵlistener("swiperight", function IgxMonthPickerComponent_Conditional_24_Template_igx_months_view_swiperight_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previousPage());
    })("swipeleft", function IgxMonthPickerComponent_Conditional_24_Template_igx_months_view_swipeleft_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextPage());
    })("selected", function IgxMonthPickerComponent_Conditional_24_Template_igx_months_view_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectMonth($event));
    })("pageChanged", function IgxMonthPickerComponent_Conditional_24_Template_igx_months_view_pageChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateDate($event));
    })("mousedown", function IgxMonthPickerComponent_Conditional_24_Template_igx_months_view_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtext(2, " > ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabIndex", -1)("date", ctx_r1.viewDate)("locale", ctx_r1.locale)("formatView", ctx_r1.formatViews.month)("monthFormat", ctx_r1.formatOptions.month)("showActive", ctx_r1.showActiveDay)("standalone", false);
  }
}
function IgxMonthPickerComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-years-view", 33, 13);
    i0.ɵɵlistener("swiperight", function IgxMonthPickerComponent_Conditional_25_Template_igx_years_view_swiperight_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previousPage());
    })("swipeleft", function IgxMonthPickerComponent_Conditional_25_Template_igx_years_view_swipeleft_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextPage());
    })("selected", function IgxMonthPickerComponent_Conditional_25_Template_igx_years_view_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectYear($event));
    })("pageChanged", function IgxMonthPickerComponent_Conditional_25_Template_igx_years_view_pageChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateDate($event));
    })("mousedown", function IgxMonthPickerComponent_Conditional_25_Template_igx_years_view_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabIndex", -1)("date", ctx_r1.viewDate)("locale", ctx_r1.locale)("formatView", ctx_r1.formatViews.year)("yearFormat", ctx_r1.formatOptions.year)("showActive", ctx_r1.showActiveDay)("standalone", false);
  }
}
const _c41 = [[["igx-avatar"], ["igx-card-media"], ["", "igxCardThumbnail", ""]], [["", "igxCardHeaderTitle", ""], ["", "igxCardHeaderSubtitle", ""], ["", 8, "igx-card-header__title"], ["", 8, "igx-card-header__title--small"], ["", 8, "igx-card-header__subtitle"]], "*"];
const _c42 = ["igx-avatar, igx-card-media, [igxCardThumbnail]", "\n        [igxCardHeaderTitle],\n        [igxCardHeaderSubtitle],\n        .igx-card-header__title,\n        .igx-card-header__title--small,\n        .igx-card-header__subtitle", "*"];
const _c43 = [[["", "igxStart", ""], ["", "igxButton", "", 3, "igxEnd", ""]], "*", [["", "igxEnd", ""], ["", "igxIconButton", "", 3, "igxStart", ""], ["igx-icon", 3, "igxStart", ""]]];
const _c44 = ["[igxStart], [igxButton]:not([igxEnd])", "*", "[igxEnd], [igxIconButton]:not([igxStart]), igx-icon:not([igxStart])"];
const _c45 = ["defaultIndicator"];
const _c46 = ["defaultNextButton"];
const _c47 = ["defaultPrevButton"];
const _c48 = ["indicators"];
function IgxCarouselComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const slide_r1 = ctx.$implicit;
    i0.ɵɵclassProp("igx-nav-dot--active", slide_r1.active);
  }
}
function IgxCarouselComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 10);
  }
}
function IgxCarouselComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 11);
  }
}
function IgxCarouselComponent_Conditional_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCarouselComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function IgxCarouselComponent_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.prev());
    })("keydown", function IgxCarouselComponent_Conditional_6_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeydownPrev($event));
    });
    i0.ɵɵtemplate(1, IgxCarouselComponent_Conditional_6_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.prevButtonDisabled);
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_carousel_previous_slide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.getPrevButtonTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c25, ctx_r2.prevButtonDisabled));
  }
}
function IgxCarouselComponent_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCarouselComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function IgxCarouselComponent_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.next());
    })("keydown", function IgxCarouselComponent_Conditional_7_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeydownNext($event));
    });
    i0.ɵɵtemplate(1, IgxCarouselComponent_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.nextButtonDisabled);
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_carousel_next_slide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.getNextButtonTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c25, ctx_r2.nextButtonDisabled));
  }
}
function IgxCarouselComponent_Conditional_8_For_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCarouselComponent_Conditional_8_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17, 3);
    i0.ɵɵlistener("click", function IgxCarouselComponent_Conditional_8_For_2_Template_div_click_0_listener() {
      const slide_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.select(slide_r7));
    });
    i0.ɵɵtemplate(2, IgxCarouselComponent_Conditional_8_For_2_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const slide_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", "tab-" + slide_r7.index + "-" + ctx_r2.total);
    i0.ɵɵattribute("role", "tab")("tabindex", slide_r7.active ? 0 : -1)("aria-label", ctx_r2.resourceStrings.igx_carousel_slide + " " + (slide_r7.index + 1) + " " + ctx_r2.resourceStrings.igx_carousel_of + " " + ctx_r2.total)("aria-controls", "panel-" + slide_r7.index)("aria-selected", slide_r7.active);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.getIndicatorTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c25, slide_r7));
  }
}
function IgxCarouselComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("keyup", function IgxCarouselComponent_Conditional_8_Template_div_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyUp($event));
    })("focusout", function IgxCarouselComponent_Conditional_8_Template_div_focusout_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleFocusOut($event));
    })("click", function IgxCarouselComponent_Conditional_8_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick());
    })("keydown", function IgxCarouselComponent_Conditional_8_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeydown($event));
    });
    i0.ɵɵrepeaterCreate(1, IgxCarouselComponent_Conditional_8_For_2_Template, 3, 10, "div", 16, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.indicatorsClass);
    i0.ɵɵattribute("role", "tablist");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.slides);
  }
}
function IgxCarouselComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.indicatorsClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.getCarouselLabel);
  }
}
const _c49 = ["chipArea"];
const _c50 = ["defaultRemoveIcon"];
const _c51 = ["defaultSelectIcon"];
const _c52 = [[["igx-prefix"], ["", "igxPrefix", ""]], "*", [["igx-suffix"], ["", "igxSuffix", ""]]];
const _c53 = ["igx-prefix,[igxPrefix]", "*", "igx-suffix,[igxSuffix]"];
const _c54 = a0 => ({
  chip: a0
});
function IgxChipComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxChipComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, IgxChipComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.selectClass(ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectIconTemplate);
  }
}
function IgxChipComponent_Conditional_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxChipComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("keydown", function IgxChipComponent_Conditional_10_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveBtnKeyDown($event));
    })("pointerdown", function IgxChipComponent_Conditional_10_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveMouseDown($event));
    })("mousedown", function IgxChipComponent_Conditional_10_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveMouseDown($event));
    })("click", function IgxChipComponent_Conditional_10_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveClick($event));
    })("touchmove", function IgxChipComponent_Conditional_10_Template_div_touchmove_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveTouchMove());
    })("touchend", function IgxChipComponent_Conditional_10_Template_div_touchend_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveTouchEnd($event));
    });
    i0.ɵɵtemplate(1, IgxChipComponent_Conditional_10_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabIndex", ctx_r1.tabIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.removeButtonTemplate);
  }
}
function IgxChipComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.resourceStrings.igx_chip_select);
  }
}
function IgxChipComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.resourceStrings.igx_chip_remove);
  }
}
function IgxComboItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-checkbox", 2);
    i0.ɵɵlistener("click", function IgxComboItemComponent_Conditional_0_Template_igx_checkbox_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.disableCheck($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r1.selected)("readonly", true)("disableRipple", true)("disableTransitions", ctx_r1.disableTransitions)("tabindex", -1);
  }
}
const _c55 = ["inputGroup"];
const _c56 = ["comboInput"];
const _c57 = ["searchInput"];
const _c58 = ["dropdownItemContainer"];
const _c59 = ["primitive"];
const _c60 = ["complex"];
function IgxComboDropDownComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c61 = [[["", "igxLabel", ""]], [["igx-prefix"]], [["igx-hint"], ["", "igxHint", ""]], [["igx-suffix"]]];
const _c62 = ["[igxLabel]", "igx-prefix", "igx-hint, [igxHint]", "igx-suffix"];
const _c63 = (a0, a1, a2, a3, a4, a5) => [a0, a1, a2, a3, a4, a5];
const _c64 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4];
const _c65 = (a0, a1, a2, a3, a4) => ({
  $implicit: a0,
  data: a1,
  valueKey: a2,
  groupKey: a3,
  displayKey: a4
});
const _c66 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  data: a1,
  valueKey: a2,
  displayKey: a3
});
function IgxComboComponent_Conditional_12_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxComboComponent_Conditional_12_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 22);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.clearIconTemplate);
  }
}
function IgxComboComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 27);
  }
}
function IgxComboComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 26);
    i0.ɵɵlistener("click", function IgxComboComponent_Conditional_12_Template_igx_suffix_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClearItems($event));
    });
    i0.ɵɵtemplate(1, IgxComboComponent_Conditional_12_Conditional_1_Template, 1, 1, "ng-container")(2, IgxComboComponent_Conditional_12_Conditional_2_Template, 1, 0, "igx-icon", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_combo_clearItems_placeholder);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.clearIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.clearIconTemplate ? 2 : -1);
  }
}
function IgxComboComponent_Conditional_14_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxComboComponent_Conditional_14_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.toggleIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r2.collapsed));
  }
}
function IgxComboComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 19);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r2.toggleIcon);
  }
}
function IgxComboComponent_Conditional_18_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 31);
    i0.ɵɵlistener("click", function IgxComboComponent_Conditional_18_Conditional_4_Template_igx_suffix_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.toggleCaseSensitive());
    });
    i0.ɵɵelementStart(1, "span", 32);
    i0.ɵɵelement(2, "igx-icon", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.filteringOptions.caseSensitive ? "igx-combo__case-icon--active" : "igx-combo__case-icon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("active", ctx_r2.filteringOptions.caseSensitive);
  }
}
function IgxComboComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "igx-input-group", 29)(2, "input", 30, 9);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxComboComponent_Conditional_18_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.searchValue, $event) || (ctx_r2.searchValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function IgxComboComponent_Conditional_18_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleInputChange($event));
    })("keyup", function IgxComboComponent_Conditional_18_Template_input_keyup_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyUp($event));
    })("keydown", function IgxComboComponent_Conditional_18_Template_input_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event));
    })("focus", function IgxComboComponent_Conditional_18_Template_input_focus_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dropdown.onBlur($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxComboComponent_Conditional_18_Conditional_4_Template, 3, 2, "igx-suffix");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.searchValue);
    i0.ɵɵattribute("placeholder", ctx_r2.getSearchPlaceholderText());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.showSearchCaseIcon ? 4 : -1);
  }
}
function IgxComboComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_igx_combo_item_22_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_igx_combo_item_22_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxComboComponent_igx_combo_item_22_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const headerItemBase_r7 = i0.ɵɵreference(36);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.headerItemTemplate ? ctx_r2.headerItemTemplate : headerItemBase_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c65, item_r6, ctx_r2.data, ctx_r2.valueKey, ctx_r2.groupKey, ctx_r2.displayKey));
  }
}
function IgxComboComponent_igx_combo_item_22_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 10);
  }
}
function IgxComboComponent_igx_combo_item_22_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxComboComponent_igx_combo_item_22_Conditional_2_ng_container_0_Template, 2, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.template)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c66, item_r6, ctx_r2.data, ctx_r2.valueKey, ctx_r2.displayKey));
  }
}
function IgxComboComponent_igx_combo_item_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-combo-item", 34);
    i0.ɵɵtemplate(1, IgxComboComponent_igx_combo_item_22_Conditional_1_Template, 1, 8, "ng-container")(2, IgxComboComponent_igx_combo_item_22_Conditional_2_Template, 1, 7, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const rowIndex_r8 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("itemHeight", ctx_r2.itemHeight)("value", item_r6)("isHeader", item_r6 == null ? null : item_r6.isHeader)("index", rowIndex_r8)("role", (item_r6 == null ? null : item_r6.isHeader) ? "group" : "option");
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r6 == null ? null : item_r6.isHeader) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r6 == null ? null : item_r6.isHeader) ? 2 : -1);
  }
}
function IgxComboComponent_Conditional_25_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_Conditional_25_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, IgxComboComponent_Conditional_25_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const empty_r9 = i0.ɵɵreference(32);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyTemplate ? ctx_r2.emptyTemplate : empty_r9);
  }
}
function IgxComboComponent_Conditional_25_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_Conditional_25_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-combo-add-item", 36);
    i0.ɵɵtemplate(1, IgxComboComponent_Conditional_25_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const addItemDefault_r10 = i0.ɵɵreference(34);
    i0.ɵɵproperty("itemHeight", ctx_r2.itemHeight)("tabindex", ctx_r2.dropdown.collapsed ? -1 : ctx_r2.customValueFlag ? 1 : -1)("index", ctx_r2.virtualScrollContainer.igxForOf.length);
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_combo_addCustomValues_placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.addItemTemplate ? ctx_r2.addItemTemplate : addItemDefault_r10);
  }
}
function IgxComboComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, IgxComboComponent_Conditional_25_Conditional_1_Template, 2, 1, "div", 35)(2, IgxComboComponent_Conditional_25_Conditional_2_Template, 2, 5, "igx-combo-add-item", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.filteredData.length === 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isAddButtonVisible() ? 2 : -1);
  }
}
function IgxComboComponent_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxComboComponent_ng_template_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const display_r11 = ctx.$implicit;
    const key_r12 = ctx.displayKey;
    i0.ɵɵtextInterpolate1(" ", display_r11[key_r12], "\n");
  }
}
function IgxComboComponent_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const display_r13 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", display_r13, "\n");
  }
}
function IgxComboComponent_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_combo_empty_message);
  }
}
function IgxComboComponent_ng_template_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_combo_addCustomValues_placeholder);
  }
}
function IgxComboComponent_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const key_r15 = ctx.valueKey;
    i0.ɵɵtextInterpolate1(" ", item_r14[key_r15], "\n");
  }
}
function IgxSimpleComboComponent_Conditional_12_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSimpleComboComponent_Conditional_12_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 21);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.clearIconTemplate);
  }
}
function IgxSimpleComboComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 26);
  }
}
function IgxSimpleComboComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 25);
    i0.ɵɵlistener("click", function IgxSimpleComboComponent_Conditional_12_Template_igx_suffix_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClear($event));
    });
    i0.ɵɵtemplate(1, IgxSimpleComboComponent_Conditional_12_Conditional_1_Template, 1, 1, "ng-container")(2, IgxSimpleComboComponent_Conditional_12_Conditional_2_Template, 1, 0, "igx-icon", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_combo_clearItems_placeholder);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.clearIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.clearIconTemplate ? 2 : -1);
  }
}
function IgxSimpleComboComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 27);
    i0.ɵɵlistener("click", function IgxSimpleComboComponent_Conditional_13_Template_igx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleCaseSensitive());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("active", ctx_r2.filteringOptions.caseSensitive);
  }
}
function IgxSimpleComboComponent_Conditional_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSimpleComboComponent_Conditional_15_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.toggleIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r2.collapsed));
  }
}
function IgxSimpleComboComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 19);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r2.toggleIcon);
  }
}
function IgxSimpleComboComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_igx_combo_item_22_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_igx_combo_item_22_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSimpleComboComponent_igx_combo_item_22_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const headerItemBase_r7 = i0.ɵɵreference(36);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.headerItemTemplate ? ctx_r2.headerItemTemplate : headerItemBase_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c65, item_r6, ctx_r2.data, ctx_r2.valueKey, ctx_r2.groupKey, ctx_r2.displayKey));
  }
}
function IgxSimpleComboComponent_igx_combo_item_22_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 9);
  }
}
function IgxSimpleComboComponent_igx_combo_item_22_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSimpleComboComponent_igx_combo_item_22_Conditional_2_ng_container_0_Template, 2, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.template)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c66, item_r6, ctx_r2.data, ctx_r2.valueKey, ctx_r2.displayKey));
  }
}
function IgxSimpleComboComponent_igx_combo_item_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-combo-item", 29);
    i0.ɵɵlistener("click", function IgxSimpleComboComponent_igx_combo_item_22_Template_igx_combo_item_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleItemClick());
    });
    i0.ɵɵtemplate(1, IgxSimpleComboComponent_igx_combo_item_22_Conditional_1_Template, 1, 8, "ng-container")(2, IgxSimpleComboComponent_igx_combo_item_22_Conditional_2_Template, 1, 7, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const rowIndex_r8 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("role", (item_r6 == null ? null : item_r6.isHeader) ? "group" : "option")("singleMode", true)("itemHeight", ctx_r2.itemHeight)("value", item_r6)("isHeader", item_r6 == null ? null : item_r6.isHeader)("index", rowIndex_r8);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r6 == null ? null : item_r6.isHeader) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r6 == null ? null : item_r6.isHeader) ? 2 : -1);
  }
}
function IgxSimpleComboComponent_Conditional_25_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_Conditional_25_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, IgxSimpleComboComponent_Conditional_25_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const empty_r9 = i0.ɵɵreference(32);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyTemplate ? ctx_r2.emptyTemplate : empty_r9);
  }
}
function IgxSimpleComboComponent_Conditional_25_Conditional_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_Conditional_25_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-combo-add-item", 31, 10);
    i0.ɵɵtemplate(2, IgxSimpleComboComponent_Conditional_25_Conditional_2_ng_container_2_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const addItemDefault_r10 = i0.ɵɵreference(34);
    i0.ɵɵproperty("itemHeight", ctx_r2.itemHeight)("tabindex", ctx_r2.dropdown.collapsed ? -1 : ctx_r2.customValueFlag ? 1 : -1)("index", ctx_r2.virtualScrollContainer.igxForOf.length);
    i0.ɵɵattribute("aria-label", ctx_r2.resourceStrings.igx_combo_addCustomValues_placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.addItemTemplate ? ctx_r2.addItemTemplate : addItemDefault_r10);
  }
}
function IgxSimpleComboComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, IgxSimpleComboComponent_Conditional_25_Conditional_1_Template, 2, 1, "div", 30)(2, IgxSimpleComboComponent_Conditional_25_Conditional_2_Template, 3, 5, "igx-combo-add-item", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.filteredData.length === 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isAddButtonVisible() ? 2 : -1);
  }
}
function IgxSimpleComboComponent_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSimpleComboComponent_ng_template_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const display_r11 = ctx.$implicit;
    const key_r12 = ctx.displayKey;
    i0.ɵɵtextInterpolate1(" ", display_r11[key_r12], "\n");
  }
}
function IgxSimpleComboComponent_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const display_r13 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", display_r13, "\n");
  }
}
function IgxSimpleComboComponent_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_combo_empty_message);
  }
}
function IgxSimpleComboComponent_ng_template_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_combo_addCustomValues_placeholder);
  }
}
function IgxSimpleComboComponent_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const key_r15 = ctx.valueKey;
    i0.ɵɵtextInterpolate1(" ", item_r14[key_r15], "\n");
  }
}
function IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6, 1);
    i0.ɵɵlistener("click", function IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.calendarClose.emit({
        owner: ctx_r1
      }));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.closeButtonLabel, " ");
  }
}
function IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6, 2);
    i0.ɵɵlistener("click", function IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.todaySelection.emit({
        owner: ctx_r1
      }));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.todayButtonLabel, " ");
  }
}
function IgxCalendarContainerComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_1_Template, 3, 1, "button", 5)(2, IgxCalendarContainerComponent_ng_template_0_Conditional_0_Conditional_2_Template, 3, 1, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.closeButtonLabel ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.todayButtonLabel ? 2 : -1);
  }
}
function IgxCalendarContainerComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxCalendarContainerComponent_ng_template_0_Conditional_0_Template, 3, 2, "div", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.closeButtonLabel || ctx_r1.todayButtonLabel ? 0 : -1);
  }
}
function IgxCalendarContainerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-divider");
  }
}
function IgxCalendarContainerComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCalendarContainerComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, IgxCalendarContainerComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultPickerActions_r4 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r1.pickerActions == null ? null : ctx_r1.pickerActions.template) || defaultPickerActions_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r1.calendar));
  }
}
const _c67 = [[["", "igxLabel", ""]], [["igx-prefix"], ["", "igxPrefix", ""]], [["igx-suffix"], ["", "igxSuffix", ""]], [["igx-hint"], ["", "igxHint", ""]]];
const _c68 = ["[igxLabel]", "igx-prefix,[igxPrefix]", "igx-suffix,[igxSuffix]", "igx-hint,[igxHint]"];
function IgxDatePickerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-prefix", 6);
    i0.ɵɵlistener("click", function IgxDatePickerComponent_Conditional_1_Template_igx_prefix_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggle());
    });
    i0.ɵɵelement(1, "igx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.value ? ctx_r1.pickerResourceStrings.igx_date_picker_change_date : ctx_r1.pickerResourceStrings.igx_date_picker_choose_date);
  }
}
function IgxDatePickerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 6);
    i0.ɵɵlistener("click", function IgxDatePickerComponent_Conditional_3_Template_igx_suffix_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵelement(1, "igx-icon", 8);
    i0.ɵɵelementEnd();
  }
}
const _c69 = [[["igx-dialog-title"], ["", "igxDialogTitle", ""]], "*", [["igx-dialog-actions"], ["", "igxDialogActions", ""]]];
const _c70 = ["igx-dialog-title,[igxDialogTitle]", "*", "igx-dialog-actions,[igxDialogActions]"];
function IgxDialogComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.titleId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function IgxDialogComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxDialogComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.message, " ");
  }
}
function IgxDialogComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxDialogComponent_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function IgxDialogComponent_Conditional_9_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onInternalLeftButtonSelect($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("igxRipple", ctx_r1.leftButtonRipple);
    i0.ɵɵproperty("igxFocus", ctx_r1.isOpen)("igxButton", ctx_r1.leftButtonType);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.leftButtonLabel, " ");
  }
}
function IgxDialogComponent_Conditional_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function IgxDialogComponent_Conditional_9_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onInternalRightButtonSelect($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("igxRipple", ctx_r1.rightButtonRipple);
    i0.ɵɵproperty("igxFocus", ctx_r1.isOpen)("igxButton", ctx_r1.rightButtonType);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rightButtonLabel, " ");
  }
}
function IgxDialogComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, IgxDialogComponent_Conditional_9_Conditional_1_Template, 2, 4, "button", 8)(2, IgxDialogComponent_Conditional_9_Conditional_2_Template, 2, 4, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.leftButtonLabel ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.rightButtonLabel ? 2 : -1);
  }
}
function IgxDialogComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxColumnActionsComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r0.titleID);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function IgxColumnActionsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 2)(1, "input", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxColumnActionsComponent_Conditional_2_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.filterCriteria, $event) || (ctx_r0.filterCriteria = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.filterCriteria);
    i0.ɵɵproperty("placeholder", ctx_r0.filterColumnsPrompt);
    i0.ɵɵattribute("aria-describedby", ctx_r0.titleID);
  }
}
function IgxColumnActionsComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-checkbox", 8);
    i0.ɵɵlistener("click", function IgxColumnActionsComponent_For_5_Template_igx_checkbox_click_0_listener() {
      const column_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleColumn(column_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("margin-left", column_r4.level * ctx_r0.indentation, "px");
    i0.ɵɵproperty("readonly", true)("checked", ctx_r0.actionsDirective.columnChecked(column_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r4.header || column_r4.field, " ");
  }
}
const _c71 = [[["igx-column"], ["igc-column"], ["igx-column-group"], ["igc-column-group"]]];
const _c72 = ["igx-column,igc-column,igx-column-group,igc-column-group"];
function IgxColumnGroupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1, 0);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
}
const _c73 = [[["igx-column"], ["igc-column"]]];
const _c74 = ["igx-column,igc-column"];
function IgxColumnLayoutComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1, 0);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
}
const _c75 = ["igx-prefix, [igxPrefix]", "*", "igx-suffix, [igxSuffix]"];
const _c76 = ["input"];
const _c77 = [[["", "igxLabel", ""]], [["igx-prefix"], ["", "igxPrefix", ""]], [["igx-suffix"], ["", "igxSuffix", ""]], [["igx-hint"], ["", "igxHint", ""]], [["igx-select-item"], ["igx-select-item-group"]], "*"];
const _c78 = ["[igxLabel]", "igx-prefix,[igxPrefix]", "igx-suffix,[igxSuffix]", "igx-hint, [igxHint]", "igx-select-item, igx-select-item-group", "*"];
function IgxSelectComponent_Conditional_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSelectComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSelectComponent_Conditional_11_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toggleIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r1.collapsed));
  }
}
function IgxSelectComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.toggleIcon);
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function IgxSelectComponent_Conditional_16_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 5, ["*ngTemplateOutlet", "headerTemplate"]);
  }
}
function IgxSelectComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, IgxSelectComponent_Conditional_16_ng_content_1_Template, 1, 0, "ng-content", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
  }
}
function IgxSelectComponent_Conditional_20_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSelectComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, IgxSelectComponent_Conditional_20_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
const _c79 = ["hourList"];
const _c80 = ["minuteList"];
const _c81 = ["secondsList"];
const _c82 = ["ampmList"];
const _c83 = (a0, a1) => ({
  "igx-time-picker--dropdown": a0,
  "igx-time-picker--vertical": a1
});
const _c84 = (a0, a1, a2, a3) => [a0, "hour", a1, a2, a3];
const _c85 = (a0, a1, a2, a3) => [a0, "minutes", a1, a2, a3];
const _c86 = (a0, a1, a2, a3) => [a0, "seconds", a1, a2, a3];
const _c87 = (a0, a1, a2, a3) => [a0, "ampm", a1, a2, a3];
const _forTrack2 = ($index, $item) => $item + $index;
function IgxTimePickerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-prefix", 20);
    i0.ɵɵlistener("click", function IgxTimePickerComponent_Conditional_3_Template_igx_prefix_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggle());
    });
    i0.ɵɵelement(1, "igx-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r2.value ? ctx_r2.resourceStrings.igx_time_picker_change_time : ctx_r2.resourceStrings.igx_time_picker_choose_time);
  }
}
function IgxTimePickerComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 20);
    i0.ɵɵlistener("click", function IgxTimePickerComponent_Conditional_8_Template_igx_suffix_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.clear();
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelement(1, "igx-icon", 22);
    i0.ɵɵelementEnd();
  }
}
function IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.cancelButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.cancelButtonLabel, " ");
  }
}
function IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.okButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.okButtonLabel, " ");
  }
}
function IgxTimePickerComponent_ng_template_13_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_1_Template, 2, 1, "button", 24)(2, IgxTimePickerComponent_ng_template_13_Conditional_0_Conditional_2_Template, 2, 1, "button", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.cancelButtonLabel ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.okButtonLabel ? 2 : -1);
  }
}
function IgxTimePickerComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTimePickerComponent_ng_template_13_Conditional_0_Template, 3, 2, "div", 23);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.cancelButtonLabel || ctx_r2.okButtonLabel ? 0 : -1);
  }
}
function IgxTimePickerComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "h2", 26)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "timeFormatPipe");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, ctx_r2.selectedDate));
  }
}
function IgxTimePickerComponent_Conditional_20_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27, 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r7 = ctx.$implicit;
    const timeItem_r8 = i0.ɵɵreference(1);
    i0.ɵɵproperty("igxTimeItem", hour_r7);
    i0.ɵɵattribute("role", timeItem_r8.isSelectedTime ? "spinbutton" : null)("aria-valuenow", timeItem_r8.isSelectedTime ? timeItem_r8.hourValue : null)("aria-valuemin", timeItem_r8.isSelectedTime ? timeItem_r8.minValue : null)("aria-valuemax", timeItem_r8.isSelectedTime ? timeItem_r8.maxValue : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(hour_r7);
  }
}
function IgxTimePickerComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 3);
    i0.ɵɵrepeaterCreate(2, IgxTimePickerComponent_Conditional_20_For_3_Template, 3, 6, "span", 27, _forTrack2);
    i0.ɵɵpipe(4, "timeItemPipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxItemList", "hourList");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBindV(4, 1, i0.ɵɵpureFunction4(7, _c84, ctx_r2.hourItems, ctx_r2.selectedDate, ctx_r2.minDropdownValue, ctx_r2.maxDropdownValue)));
  }
}
function IgxTimePickerComponent_Conditional_21_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28, 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const minute_r9 = ctx.$implicit;
    const timeItem_r10 = i0.ɵɵreference(1);
    i0.ɵɵproperty("igxTimeItem", minute_r9);
    i0.ɵɵattribute("role", timeItem_r10.isSelectedTime ? "spinbutton" : null)("aria-valuenow", timeItem_r10.isSelectedTime ? minute_r9 : null)("aria-valuemin", timeItem_r10.isSelectedTime ? timeItem_r10.minValue : null)("aria-valuemax", timeItem_r10.isSelectedTime ? timeItem_r10.maxValue : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(minute_r9);
  }
}
function IgxTimePickerComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 5);
    i0.ɵɵrepeaterCreate(2, IgxTimePickerComponent_Conditional_21_For_3_Template, 3, 6, "span", 28, _forTrack2);
    i0.ɵɵpipe(4, "timeItemPipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxItemList", "minuteList");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBindV(4, 1, i0.ɵɵpureFunction4(7, _c85, ctx_r2.minuteItems, ctx_r2.selectedDate, ctx_r2.minDropdownValue, ctx_r2.maxDropdownValue)));
  }
}
function IgxTimePickerComponent_Conditional_22_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29, 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const seconds_r11 = ctx.$implicit;
    const timeItem_r12 = i0.ɵɵreference(1);
    i0.ɵɵproperty("igxTimeItem", seconds_r11);
    i0.ɵɵattribute("role", timeItem_r12.isSelectedTime ? "spinbutton" : null)("aria-valuenow", timeItem_r12.isSelectedTime ? seconds_r11 : null)("aria-valuemin", timeItem_r12.isSelectedTime ? timeItem_r12.minValue : null)("aria-valuemax", timeItem_r12.isSelectedTime ? timeItem_r12.maxValue : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(seconds_r11);
  }
}
function IgxTimePickerComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 6);
    i0.ɵɵrepeaterCreate(2, IgxTimePickerComponent_Conditional_22_For_3_Template, 3, 6, "span", 29, _forTrack2);
    i0.ɵɵpipe(4, "timeItemPipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxItemList", "secondsList");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBindV(4, 1, i0.ɵɵpureFunction4(7, _c86, ctx_r2.secondsItems, ctx_r2.selectedDate, ctx_r2.minDropdownValue, ctx_r2.maxDropdownValue)));
  }
}
function IgxTimePickerComponent_Conditional_23_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30, 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ampm_r13 = ctx.$implicit;
    const timeItem_r14 = i0.ɵɵreference(1);
    i0.ɵɵproperty("igxTimeItem", ampm_r13);
    i0.ɵɵattribute("role", timeItem_r14.isSelectedTime ? "spinbutton" : null)("aria-valuenow", timeItem_r14.isSelectedTime ? ampm_r13 : null)("aria-valuemin", timeItem_r14.isSelectedTime ? timeItem_r14.minValue : null)("aria-valuemax", timeItem_r14.isSelectedTime ? timeItem_r14.maxValue : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ampm_r13);
  }
}
function IgxTimePickerComponent_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 7);
    i0.ɵɵrepeaterCreate(2, IgxTimePickerComponent_Conditional_23_For_3_Template, 3, 6, "span", 30, _forTrack2);
    i0.ɵɵpipe(4, "timeItemPipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxItemList", "ampmList");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBindV(4, 1, i0.ɵɵpureFunction4(7, _c87, ctx_r2.ampmItems, ctx_r2.selectedDate, ctx_r2.minDropdownValue, ctx_r2.maxDropdownValue)));
  }
}
function IgxTimePickerComponent_ng_container_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c88 = ["entitySelect"];
const _c89 = ["editingInputs"];
const _c90 = ["returnFieldsCombo"];
const _c91 = ["returnFieldSelect"];
const _c92 = ["fieldSelect"];
const _c93 = ["conditionSelect"];
const _c94 = ["searchValueInput"];
const _c95 = ["picker"];
const _c96 = ["addRootAndGroupButton"];
const _c97 = ["addConditionButton"];
const _c98 = ["entityChangeDialog"];
const _c99 = ["addOptionsDropDown"];
const _c100 = ["groupContextMenuDropDown"];
const _c101 = ["editingInputsContainer"];
const _c102 = ["currentGroupButtonsContainer"];
const _c103 = ["expressionsContainer"];
const _c104 = ["overlayOutlet"];
const _c105 = a0 => ({
  "igx-drop-down__item--selected": a0
});
const _c106 = a0 => ({
  "igx-filter-tree__expression-item": true,
  "igx-filter-tree__expression-item-keyboard-ghost": a0
});
const _c107 = (a0, a1) => ({
  "igx-filter-tree__line--and": a0,
  "igx-filter-tree__line--or": a1
});
const _c108 = (a0, a1) => ({
  "igx-filter-tree__button--and": a0,
  "igx-filter-tree__button--or": a1
});
const _forTrack3 = ($index, $item) => $item.name;
const _forTrack4 = ($index, $item) => $item.field;
function _forTrack5($index, $item) {
  return this.trackExpressionItem($item);
}
function IgxQueryBuilderTreeComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 38);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 39);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entity_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", entity_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", entity_r4.name, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_ng_template_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onSelectAllClicked());
    });
    i0.ɵɵelement(1, "igx-checkbox", 50);
    i0.ɵɵelementStart(2, "div", 51);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c105, ctx_r2.selectedEntity && ctx_r2.selectedReturnFields && ctx_r2.selectedEntity.fields.length === ctx_r2.selectedReturnFields.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.selectedEntity && ctx_r2.selectedReturnFields && ctx_r2.selectedEntity.fields.length === ctx_r2.selectedReturnFields.length)("indeterminate", ctx_r2.selectedEntity && ctx_r2.selectedReturnFields && ctx_r2.selectedReturnFields.length > 0 && ctx_r2.selectedReturnFields.length < (ctx_r2.selectedEntity.fields == null ? null : ctx_r2.selectedEntity.fields.length))("readonly", true)("disableRipple", true)("tabindex", -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.resourceStrings.igx_query_builder_select_all, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-combo", 47, 10);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_Template_igx_combo_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedReturnFields, $event) || (ctx_r2.selectedReturnFields = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_Template_igx_combo_selectionChanging_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onReturnFieldSelectChanging($event));
    })("opening", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_Template_igx_combo_opening_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.exitEditAddMode());
    });
    i0.ɵɵtemplate(2, IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_ng_template_2_Template, 4, 9, "ng-template", 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("display", ctx_r2.isInEditMode() ? "block" : "none");
    i0.ɵɵpropertyInterpolate("searchPlaceholder", ctx_r2.resourceStrings.igx_query_builder_search);
    i0.ɵɵproperty("itemsMaxHeight", 250)("data", ctx_r2.fields)("displayKey", "field")("valueKey", "field")("disabled", ctx_r2.disableReturnFieldsChange);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedReturnFields);
    i0.ɵɵproperty("overlaySettings", ctx_r2.returnFieldSelectOverlaySettings)("placeholder", ctx_r2.resourceStrings.igx_query_builder_select_return_fields);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", field_r8.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r8.field, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-select", 52, 11);
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_Template_igx_select_selectionChanging_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onReturnFieldSelectChanging($event));
    })("opening", function IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_Template_igx_select_opening_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.exitEditAddMode());
    });
    i0.ɵɵrepeaterCreate(2, IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_For_3_Template, 2, 2, "igx-select-item", 44, _forTrack4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("display", ctx_r2.isInEditMode() ? "block" : "none");
    i0.ɵɵproperty("overlaySettings", ctx_r2.returnFieldSelectOverlaySettings)("disabled", !ctx_r2.selectedEntity)("ngModel", ctx_r2.selectedReturnFields[0])("placeholder", ctx_r2.resourceStrings.igx_query_builder_select_return_field_single);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.fields);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40)(1, "div", 41)(2, "span", 42);
    i0.ɵɵtext(3, "From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "igx-select", 43, 9);
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_4_Template_igx_select_selectionChanging_4_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onEntitySelectChanging($event));
    })("opening", function IgxQueryBuilderTreeComponent_ng_template_4_Template_igx_select_opening_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.exitEditAddMode(true));
    });
    i0.ɵɵrepeaterCreate(6, IgxQueryBuilderTreeComponent_ng_template_4_For_7_Template, 2, 2, "igx-select-item", 44, _forTrack3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 41)(9, "span", 42);
    i0.ɵɵtext(10, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, IgxQueryBuilderTreeComponent_ng_template_4_Conditional_11_Template, 3, 11, "igx-combo", 45)(12, IgxQueryBuilderTreeComponent_ng_template_4_Conditional_12_Template, 4, 6, "igx-select", 46);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("display", ctx_r2.isInEditMode() && !ctx_r2.isAdvancedFiltering() ? "flex" : "none");
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("display", ctx_r2.isInEditMode() ? "block" : "none");
    i0.ɵɵproperty("overlaySettings", ctx_r2.entitySelectOverlaySettings)("ngModel", ctx_r2.selectedEntity)("placeholder", ctx_r2.resourceStrings.igx_query_builder_select_entity)("disabled", ctx_r2.disableEntityChange);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.entities);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(!ctx_r2.parentExpression ? 11 : 12);
  }
}
function IgxQueryBuilderTreeComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_9_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_9_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 55);
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_9_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r14 = i0.ɵɵnextContext();
      const expressionItem_r11 = ctx_r14.$implicit;
      const afterExpression_r12 = ctx_r14.afterExpression;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addReverseGroup(expressionItem_r11, afterExpression_r12));
    });
    i0.ɵɵtemplate(1, IgxQueryBuilderTreeComponent_ng_template_9_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const addIcon_r16 = i0.ɵɵreference(1);
    i0.ɵɵproperty("disabled", ctx_r2.hasEditedExpression);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", addIcon_r16);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_query_builder_add_group_root);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 53, 12);
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_9_Template_button_click_0_listener() {
      const ctx_r9 = i0.ɵɵrestoreView(_r9);
      const expressionItem_r11 = ctx_r9.$implicit;
      const afterExpression_r12 = ctx_r9.afterExpression;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addCondition(expressionItem_r11, afterExpression_r12, true));
    })("enter", function IgxQueryBuilderTreeComponent_ng_template_9_Template_button_enter_0_listener() {
      const expressionItem_r11 = i0.ɵɵrestoreView(_r9).$implicit;
      const addConditionButton_r13 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onAddConditionEnter(addConditionButton_r13, expressionItem_r11));
    })("leave", function IgxQueryBuilderTreeComponent_ng_template_9_Template_button_leave_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    });
    i0.ɵɵtemplate(2, IgxQueryBuilderTreeComponent_ng_template_9_ng_container_2_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, IgxQueryBuilderTreeComponent_ng_template_9_Conditional_5_Template, 4, 3, "button", 54);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const addIcon_r16 = i0.ɵɵreference(1);
    i0.ɵɵproperty("disabled", ctx_r2.hasEditedExpression);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", addIcon_r16);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_query_builder_add_condition_root);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.rootGroup ? 5 : -1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "igx-chip", 60);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", expressionItem_r17);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.resourceStrings.igx_query_builder_drop_ghost_text, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(expressionItem_r17.expression.searchTree.entity);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("\xA0/ ", ctx_r2.formatReturnFields(expressionItem_r17.expression.searchTree), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "fieldFormatter");
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(6).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, expressionItem_r17.expression.searchVal, ctx_r2.getFormatter(expressionItem_r17.expression.fieldName), undefined), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "date");
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(6).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(1, 1, expressionItem_r17.expression.searchVal, ctx_r2.getFormat(expressionItem_r17.expression.fieldName), undefined, ctx_r2.locale), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Conditional_0_Template, 2, 5)(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Conditional_1_Template, 2, 6);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.getFormatter(expressionItem_r17.expression.fieldName) ? 0 : 1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "fieldFormatter");
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(6).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, expressionItem_r17.expression.searchVal, ctx_r2.getFormatter(expressionItem_r17.expression.fieldName), expressionItem_r17.expression.conditionName || (expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.name)), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(6).$implicit;
    i0.ɵɵtextInterpolate1(" ", expressionItem_r17.expression.searchVal, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Conditional_0_Template, 2, 5)(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.getFormatter(expressionItem_r17.expression.fieldName) ? 0 : 1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_1_Template, 2, 1)(2, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Conditional_2_Template, 2, 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isDate(expressionItem_r17.expression.searchVal) ? 1 : 2);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_1_Template, 4, 2, "ng-container")(2, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Conditional_2_Template, 3, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(expressionItem_r17.expression.searchTree ? 1 : 2);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵtextInterpolate1(" ", expressionItem_r17.expression.searchTree.returnFields.join(", "), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getConditionFriendlyName(expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.name), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "fieldFormatter");
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, expressionItem_r17.expression.searchVal, ctx_r2.getFormatter(expressionItem_r17.expression.fieldName), expressionItem_r17.expression.conditionName || (expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.name)), " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵtextInterpolate1(" ", expressionItem_r17.expression.searchVal, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Conditional_0_Template, 2, 5)(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.getFormatter(expressionItem_r17.expression.fieldName) ? 0 : 1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67)(1, "button", 68, 17);
    i0.ɵɵlistener("keydown", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template_button_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.invokeClick($event));
    })("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r21);
      const addExpressionButton_r22 = i0.ɵɵreference(2);
      i0.ɵɵnextContext();
      const expressionChip_r20 = i0.ɵɵreference(3);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickExpressionAdd(addExpressionButton_r22, expressionChip_r20));
    })("blur", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template_button_blur_1_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.addExpressionBlur());
    });
    i0.ɵɵelement(3, "igx-icon", 69);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "igx-drop-down", 70, 18);
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template_igx_drop_down_selectionChanging_4_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const expressionItem_r17 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.enterExpressionAdd($event, expressionItem_r17));
    });
    i0.ɵɵelementStart(6, "igx-drop-down-item", 44)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "igx-drop-down-item", 44)(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const addOptionsDropDown_r23 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxDropDownItemNavigation", addOptionsDropDown_r23);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", "addCondition");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_query_builder_add_condition);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "addGroup");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.resourceStrings.igx_query_builder_add_group);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61, 14);
    i0.ɵɵlistener("enter", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_enter_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipEnter(dragRef_r19, expressionItem_r17));
    })("over", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_over_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onDivOver(dragRef_r19, expressionItem_r17));
    })("leave", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_leave_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    })("dropped", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_dropped_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onDivDropped(expressionItem_r17));
    })("mouseenter", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(expressionItem_r17.hovered = true);
    })("mouseleave", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(expressionItem_r17.hovered = false);
    })("focusin", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_focusin_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onExpressionFocus(expressionItem_r17));
    })("focusout", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_div_focusout_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onExpressionBlur($event, expressionItem_r17));
    });
    i0.ɵɵelementStart(2, "igx-chip", 62, 15);
    i0.ɵɵlistener("moveStart", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_moveStart_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onMoveStart(dragRef_r19, expressionItem_r17, false));
    })("moveEnd", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_moveEnd_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onMoveEnd());
    })("dragEnter", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_dragEnter_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipEnter(dragRef_r19, expressionItem_r17));
    })("dragOver", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_dragOver_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipOver(dragRef_r19));
    })("dragLeave", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_dragLeave_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    })("dragDrop", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_dragDrop_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipDropped());
    })("keydown", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.invokeClick($event));
    })("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_click_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionChip_r20 = i0.ɵɵreference(3);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipClick(expressionItem_r17, expressionChip_r20));
    })("remove", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_chip_remove_2_listener() {
      i0.ɵɵrestoreView(_r18);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipRemove(expressionItem_r17));
    });
    i0.ɵɵelementStart(5, "igx-icon", 63);
    i0.ɵɵlistener("focus", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_icon_focus_5_listener() {
      i0.ɵɵrestoreView(_r18);
      const dragRef_r19 = i0.ɵɵreference(1);
      const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipDragIndicatorFocus(dragRef_r19, expressionItem_r17));
    })("focusout", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template_igx_icon_focusout_5_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipDragIndicatorFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 64);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 65);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_10_Template, 3, 1, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 66, 16);
    i0.ɵɵtemplate(13, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_13_Template, 1, 1)(14, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_14_Template, 1, 1)(15, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_15_Template, 2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Conditional_16_Template, 12, 5, "div", 67);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tooltipRef_r24 = i0.ɵɵreference(12);
    const expressionItem_r17 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c106, expressionItem_r17 === ctx_r2.dragService.dropGhostExpression));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("draggable", true)("hideBaseOnDrag", false)("animateOnRelease", false)("igxTooltipTarget", tooltipRef_r24)("data", expressionItem_r17)("removable", ctx_r2.isInEditMode() ? "true" : "false");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", expressionItem_r17.fieldLabel || expressionItem_r17.expression.fieldName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getConditionFriendlyName(expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.name), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.isUnary) ? 10 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(expressionItem_r17.expression.searchTree ? 13 : (expressionItem_r17.expression.condition == null ? null : expressionItem_r17.expression.condition.isUnary) ? 14 : 15);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(expressionItem_r17.focused || expressionItem_r17.hovered ? 16 : -1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_0_Template, 3, 2, "div", 58)(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Conditional_1_Template, 17, 14, "div", 59);
  }
  if (rf & 2) {
    const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.dragService.dropGhostExpression && expressionItem_r17 === ctx_r2.dragService.dropGhostExpression && ctx_r2.dragService.isKeyboardDrag === false ? 0 : 1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r27 = ctx.$implicit;
    i0.ɵɵproperty("value", field_r27);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r27.label || field_r27.header || field_r27.field, " ");
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵelement(1, "igx-icon", 80);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const conditionSelect_r28 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r2.selectedField.filters.condition(conditionSelect_r28.value).iconName);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 74)(1, "div", 81);
    i0.ɵɵelement(2, "igx-icon", 80);
    i0.ɵɵelementStart(3, "span", 82);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const condition_r29 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", condition_r29)("text", ctx_r2.getConditionFriendlyName(condition_r29));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.selectedField.filters.condition(condition_r29).iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.getConditionFriendlyName(condition_r29));
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 83)(1, "input", 86, 23);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_0_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const ctx_r2 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r2.searchValue.value, $event) || (ctx_r2.searchValue.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.isSearchValueInputDisabled())("placeholder", ctx_r2.selectedCondition === "inQuery" || ctx_r2.selectedCondition === "notInQuery" ? ctx_r2.resourceStrings.igx_query_builder_query_value_placeholder : ctx_r2.resourceStrings.igx_query_builder_value_placeholder)("type", ctx_r2.selectedField && ctx_r2.selectedField.dataType === "number" ? "number" : "text");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.searchValue.value);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-date-picker", 87, 24);
    i0.ɵɵtwoWayListener("valueChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_1_Template_igx_date_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r2.searchValue.value, $event) || (ctx_r2.searchValue.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keydown", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_1_Template_igx_date_picker_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.openPicker($event));
    })("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_1_Template_igx_date_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r31);
      const picker_r32 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(picker_r32.open());
    });
    i0.ɵɵelement(2, "igx-picker-toggle")(3, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("value", ctx_r2.searchValue.value);
    i0.ɵɵproperty("readOnly", true)("disabled", ctx_r2.isSearchValueInputDisabled())("locale", ctx_r2.locale)("outlet", ctx_r2.pickerOutlet)("formatter", ctx_r2.selectedField.formatter)("displayFormat", ctx_r2.selectedField.pipeArgs.format)("weekStart", ctx_r2.selectedField.pipeArgs.weekStart)("placeholder", ctx_r2.resourceStrings.igx_query_builder_date_placeholder);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-time-picker", 88, 24);
    i0.ɵɵtwoWayListener("valueChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_2_Template_igx_time_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r33);
      const ctx_r2 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r2.searchValue.value, $event) || (ctx_r2.searchValue.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_2_Template_igx_time_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r33);
      const picker_r34 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(picker_r34.open());
    })("keydown", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_2_Template_igx_time_picker_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r33);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.openPicker($event));
    });
    i0.ɵɵelement(2, "igx-picker-toggle")(3, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("value", ctx_r2.searchValue.value);
    i0.ɵɵproperty("readOnly", true)("disabled", ctx_r2.isSearchValueInputDisabled())("locale", ctx_r2.locale)("outlet", ctx_r2.pickerOutlet)("formatter", ctx_r2.selectedField.formatter)("displayFormat", ctx_r2.selectedField.pipeArgs.format)("inputFormat", ctx_r2.selectedField.editorOptions == null ? null : ctx_r2.selectedField.editorOptions.dateTimeFormat)("placeholder", ctx_r2.resourceStrings.igx_query_builder_time_placeholder);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 83, 25)(2, "input", 89, 26);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_3_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r2 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r2.searchValue.value, $event) || (ctx_r2.searchValue.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", ctx_r2.resourceStrings.igx_query_builder_datetime_placeholder);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.searchValue.value);
    i0.ɵɵproperty("disabled", ctx_r2.isSearchValueInputDisabled())("locale", ctx_r2.locale)("igxDateTimeEditor", ctx_r2.selectedField.editorOptions == null ? null : ctx_r2.selectedField.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r2.selectedField.dataType)("displayFormat", ctx_r2.selectedField.pipeArgs.format);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_0_Template, 3, 4, "igx-input-group", 83)(1, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_1_Template, 4, 9, "igx-date-picker", 84)(2, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_2_Template, 4, 9, "igx-time-picker", 85)(3, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Conditional_3_Template, 4, 7, "igx-input-group", 83);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r2.selectedField || ctx_r2.selectedField.dataType !== "date" && ctx_r2.selectedField.dataType !== "time" && ctx_r2.selectedField.dataType !== "dateTime" ? 0 : ctx_r2.selectedField && ctx_r2.selectedField.dataType === "date" ? 1 : ctx_r2.selectedField && ctx_r2.selectedField.dataType === "time" ? 2 : ctx_r2.selectedField && ctx_r2.selectedField.dataType === "dateTime" ? 3 : -1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 71, 19);
    i0.ɵɵlistener("enter", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_div_enter_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
      const editingInputsContainer_r26 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipEnter(editingInputsContainer_r26, expressionItem_r17));
    })("over", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_div_over_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
      const editingInputsContainer_r26 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipEnter(editingInputsContainer_r26, expressionItem_r17));
    })("leave", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_div_leave_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    })("dropped", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_div_dropped_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onDivDropped(expressionItem_r17));
    });
    i0.ɵɵelementStart(2, "igx-select", 72, 20);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_igx_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedField, $event) || (ctx_r2.selectedField = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(4, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_For_5_Template, 2, 2, "igx-select-item", 44, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "igx-select", 73, 21);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_igx_select_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedCondition, $event) || (ctx_r2.selectedCondition = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_igx_select_selectionChanging_6_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onConditionSelectChanging($event));
    });
    i0.ɵɵtemplate(8, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Conditional_8_Template, 2, 1, "igx-prefix");
    i0.ɵɵrepeaterCreate(9, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_For_10_Template, 5, 4, "igx-select-item", 74, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_container_11_Template, 1, 0, "ng-container", 75)(12, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_template_12_Template, 4, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(14, "div", 76)(15, "button", 77);
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.commitExpression());
    });
    i0.ɵɵelement(16, "igx-icon", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 79);
    i0.ɵɵlistener("click", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r25);
      const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.discardExpression(expressionItem_r17));
    });
    i0.ɵɵtemplate(18, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_ng_container_18_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const conditionSelect_r28 = i0.ɵɵreference(7);
    const defaultSearchValueTemplate_r36 = i0.ɵɵreference(13);
    const ctx_r2 = i0.ɵɵnextContext(2);
    const closeIcon_r37 = i0.ɵɵreference(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("overlaySettings", ctx_r2.fieldSelectOverlaySettings);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedField);
    i0.ɵɵproperty("disabled", !ctx_r2.fields)("placeholder", ctx_r2.resourceStrings.igx_query_builder_column_placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.fields);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("overlaySettings", ctx_r2.conditionSelectOverlaySettings);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedCondition);
    i0.ɵɵproperty("disabled", !ctx_r2.selectedField)("placeholder", ctx_r2.resourceStrings.igx_query_builder_condition_placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.selectedField && conditionSelect_r28.value && ctx_r2.selectedField.filters.condition(conditionSelect_r28.value) ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.getConditionList());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.searchValueTemplate ? ctx_r2.searchValueTemplate : defaultSearchValueTemplate_r36)("ngTemplateOutletContext", ctx_r2.getSearchValueTemplateContext(defaultSearchValueTemplate_r36));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.operandCanBeCommitted());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", closeIcon_r37);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "igx-query-builder-tree", 90);
    i0.ɵɵlistener("inEditModeChange", function IgxQueryBuilderTreeComponent_ng_template_11_Conditional_4_Template_igx_query_builder_tree_inEditModeChange_1_listener($event) {
      i0.ɵɵrestoreView(_r38);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onInEditModeChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    const expressionItem_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", expressionItem_r17.inEditMode || expressionItem_r17.expanded ? "block" : "none");
    i0.ɵɵproperty("entities", ctx_r2.entities)("queryBuilder", ctx_r2.queryBuilder)("parentExpression", expressionItem_r17)("expressionTree", expressionItem_r17.inEditMode ? (tmp_17_0 = ctx_r2.innerQueryNewExpressionTree) !== null && tmp_17_0 !== undefined ? tmp_17_0 : ctx_r2.getExpressionTreeCopy(expressionItem_r17.expression.searchTree, true) : expressionItem_r17.expression.searchTree)("searchValueTemplate", ctx_r2.searchValueTemplate);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_0_Template, 2, 1);
    i0.ɵɵelementStart(1, "div", 56, 13);
    i0.ɵɵtemplate(3, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_3_Template, 19, 13, "div", 57)(4, IgxQueryBuilderTreeComponent_ng_template_11_Conditional_4_Template, 2, 7, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_14_0;
    const expressionItem_r17 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!expressionItem_r17.inEditMode ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(expressionItem_r17.inEditMode ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!expressionItem_r17.inEditMode && expressionItem_r17.expression.searchTree && (expressionItem_r17.expression.searchTree.filteringOperands == null ? null : expressionItem_r17.expression.searchTree.filteringOperands.length) > 0 || expressionItem_r17.inEditMode && (ctx_r2.selectedField == null ? null : ctx_r2.selectedField.filters == null ? null : (tmp_14_0 = ctx_r2.selectedField.filters.condition(ctx_r2.selectedCondition)) == null ? null : tmp_14_0.isNestedQuery) ? 4 : -1);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_13_For_18_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_13_For_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, IgxQueryBuilderTreeComponent_ng_template_13_For_18_ng_container_1_Template, 1, 0, "ng-container", 75);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const expr_r44 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const operandTemplate_r45 = i0.ɵɵreference(12);
    const expressionGroupTemplate_r46 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.isExpressionGroup(expr_r44) ? expressionGroupTemplate_r46 : operandTemplate_r45)("ngTemplateOutletContext", ctx_r2.context(expr_r44));
  }
}
function IgxQueryBuilderTreeComponent_ng_template_13_Conditional_19_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_ng_template_13_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 101, 30);
    i0.ɵɵtemplate(2, IgxQueryBuilderTreeComponent_ng_template_13_Conditional_19_ng_container_2_Template, 1, 0, "ng-container", 75);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expressionItem_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const addExpressionsTemplate_r47 = i0.ɵɵreference(10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", addExpressionsTemplate_r47)("ngTemplateOutletContext", ctx_r2.context(expressionItem_r40));
  }
}
function IgxQueryBuilderTreeComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵlistener("focusout", function IgxQueryBuilderTreeComponent_ng_template_13_Template_div_focusout_0_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.parentExpression ? null : ctx_r2.dragService.onDragFocusOut());
    });
    i0.ɵɵelement(1, "div", 92);
    i0.ɵɵelementStart(2, "div", 93)(3, "div", 94, 27);
    i0.ɵɵlistener("enter", function IgxQueryBuilderTreeComponent_ng_template_13_Template_div_enter_3_listener() {
      const expressionItem_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const groupRef_r41 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onGroupRootOver(groupRef_r41, expressionItem_r40));
    })("over", function IgxQueryBuilderTreeComponent_ng_template_13_Template_div_over_3_listener() {
      const expressionItem_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const groupRef_r41 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onGroupRootOver(groupRef_r41, expressionItem_r40));
    })("leave", function IgxQueryBuilderTreeComponent_ng_template_13_Template_div_leave_3_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    });
    i0.ɵɵelementStart(5, "button", 95, 28);
    i0.ɵɵlistener("keydown", function IgxQueryBuilderTreeComponent_ng_template_13_Template_button_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.invokeClick($event));
    })("click", function IgxQueryBuilderTreeComponent_ng_template_13_Template_button_click_5_listener() {
      const expressionItem_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const changeGroupButton_r42 = i0.ɵɵreference(6);
      const groupContextMenuDropDown_r43 = i0.ɵɵreference(11);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onGroupClick(groupContextMenuDropDown_r43, changeGroupButton_r42, expressionItem_r40));
    });
    i0.ɵɵelementStart(7, "span", 96);
    i0.ɵɵlistener("enter", function IgxQueryBuilderTreeComponent_ng_template_13_Template_span_enter_7_listener() {
      const expressionItem_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const groupRef_r41 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onGroupRootOver(groupRef_r41, expressionItem_r40));
    })("over", function IgxQueryBuilderTreeComponent_ng_template_13_Template_span_over_7_listener() {
      const expressionItem_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const groupRef_r41 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onGroupRootOver(groupRef_r41, expressionItem_r40));
    })("leave", function IgxQueryBuilderTreeComponent_ng_template_13_Template_span_leave_7_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragService.onChipLeave());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "igx-icon", 97);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "igx-drop-down", 98, 29);
    i0.ɵɵlistener("selectionChanging", function IgxQueryBuilderTreeComponent_ng_template_13_Template_igx_drop_down_selectionChanging_10_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onGroupContextMenuDropDownSelectionChanging($event));
    });
    i0.ɵɵelementStart(12, "igx-drop-down-item", 44);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "igx-drop-down-item", 99);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(16, "div", 100);
    i0.ɵɵrepeaterCreate(17, IgxQueryBuilderTreeComponent_ng_template_13_For_18_Template, 2, 2, "ng-container", null, _forTrack5, true);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, IgxQueryBuilderTreeComponent_ng_template_13_Conditional_19_Template, 3, 2, "div", 101);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const expressionItem_r40 = ctx.$implicit;
    const groupContextMenuDropDown_r43 = i0.ɵɵreference(11);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c107, ctx_r2.getOperator(expressionItem_r40) === 0, ctx_r2.getOperator(expressionItem_r40) === 1));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c108, ctx_r2.getOperator(expressionItem_r40) === 0, ctx_r2.getOperator(expressionItem_r40) === 1))("igxDropDownItemNavigation", groupContextMenuDropDown_r43);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getOperator(expressionItem_r40) === 0 ? ctx_r2.resourceStrings.igx_query_builder_and_label : ctx_r2.resourceStrings.igx_query_builder_or_label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", "fit-content");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", "switchCondition");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getSwitchGroupText(expressionItem_r40), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", "ungroup")("disabled", ctx_r2.rootGroup === ctx_r2.contextualGroup);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.resourceStrings.igx_query_builder_ungroup, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(expressionItem_r40 == null ? null : expressionItem_r40.children);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(expressionItem_r40 === ctx_r2.rootGroup && !ctx_r2.hasEditedExpression ? 19 : -1);
  }
}
function IgxQueryBuilderTreeComponent_Conditional_15_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵtext(1, "Where");
    i0.ɵɵelementEnd();
  }
}
function IgxQueryBuilderTreeComponent_Conditional_15_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxQueryBuilderTreeComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, IgxQueryBuilderTreeComponent_Conditional_15_Conditional_1_Template, 2, 0, "span", 42)(2, IgxQueryBuilderTreeComponent_Conditional_15_ng_container_2_Template, 1, 0, "ng-container", 75);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const expressionGroupTemplate_r46 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.isAdvancedFiltering() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", expressionGroupTemplate_r46)("ngTemplateOutletContext", ctx_r2.context(ctx_r2.rootGroup));
  }
}
const _c109 = [[["igx-query-builder-header"]]];
const _c110 = ["igx-query-builder-header"];
const _c111 = ["queryBuilder"];
const _c112 = a0 => ({
  "igx-advanced-filter": true,
  "igx-advanced-filter--inline": a0
});
function IgxAdvancedFilteringDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "article", 2);
    i0.ɵɵlistener("dragStart", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_article_dragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dragStart($event));
    })("dragMove", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_article_dragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragMove($event));
    })("keydown", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_article_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    });
    i0.ɵɵelementStart(1, "igx-query-builder", 3, 0);
    i0.ɵɵelement(3, "igx-query-builder-header", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "footer", 5)(5, "div", 6)(6, "button", 7);
    i0.ɵɵlistener("click", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_button_click_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClearButtonClick($event));
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 8)(9, "button", 9);
    i0.ɵɵlistener("click", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelChanges());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 10)(12, "button", 11);
    i0.ɵɵlistener("click", function IgxAdvancedFilteringDialogComponent_Conditional_0_Template_button_click_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onApplyButtonClick($event));
    });
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ghost", false)("dragTolerance", 0)("ngClass", i0.ɵɵpureFunction1(10, _c112, ctx_r1.inline));
    i0.ɵɵadvance();
    i0.ɵɵproperty("locale", ctx_r1.grid.locale)("entities", ctx_r1.generateEntity())("expressionTree", ctx_r1.grid.advancedFilteringExpressionsTree);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r1.grid.resourceStrings.igx_grid_advanced_filter_title);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_excel_custom_dialog_clear, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_excel_cancel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_excel_apply, " ");
  }
}
function IgxExcelStyleClearFiltersComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("keydown", function IgxExcelStyleClearFiltersComponent_Conditional_0_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClearFilterKeyDown($event));
    })("click", function IgxExcelStyleClearFiltersComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFilter());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "igx-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.clearFilterClass());
    i0.ɵɵattribute("aria-disabled", !ctx_r1.esf.column.filteringExpressionsTree);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_clear);
  }
}
const _c113 = ["dropdownConditions"];
const _c114 = ["logicOperatorButtonGroup"];
const _c115 = ["inputValues"];
function IgxExcelStyleDefaultExpressionComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.getIconName());
  }
}
function IgxExcelStyleDefaultExpressionComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
}
function IgxExcelStyleDefaultExpressionComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 10)(1, "div", 15);
    i0.ɵɵelement(2, "igx-icon", 8);
    i0.ɵɵelementStart(3, "span", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const condition_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", condition_r3)("text", ctx_r1.getConditionFriendlyName(condition_r3))("selected", ctx_r1.isConditionSelected(condition_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1.getCondition(condition_r3).iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.translateCondition(condition_r3));
  }
}
function IgxExcelStyleDefaultExpressionComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function IgxExcelStyleDefaultExpressionComponent_Conditional_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveButtonClick());
    });
    i0.ɵɵelement(1, "igx-icon", 18);
    i0.ɵɵelementEnd();
  }
}
function IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-buttongroup", null, 4)(2, "span", 19, 5);
    i0.ɵɵlistener("keydown", function IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template_span_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorKeyDown($event, 0));
    })("click", function IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template_span_click_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorButtonClicked($event, 0));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 19, 6);
    i0.ɵɵlistener("keydown", function IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template_span_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorKeyDown($event, 1));
    })("click", function IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template_span_click_5_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorButtonClicked($event, 1));
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", ctx_r1.expressionUI.afterOperator === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_filter_operator_and, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", ctx_r1.expressionUI.afterOperator === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_filter_operator_or, " ");
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.getIconName());
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 10);
  }
}
function IgxExcelStyleDateExpressionComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 11);
    i0.ɵɵelement(1, "igx-icon", 9);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const condition_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", condition_r3)("text", ctx_r1.getConditionFriendlyName(condition_r3))("selected", ctx_r1.isConditionSelected(condition_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.getCondition(condition_r3).iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.translateCondition(condition_r3));
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-date-picker", 17, 2);
    i0.ɵɵtwoWayListener("valueChange", function IgxExcelStyleDateExpressionComponent_Conditional_7_Template_igx_date_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchVal, $event) || (ctx_r1.searchVal = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("click", function IgxExcelStyleDateExpressionComponent_Conditional_7_Template_igx_date_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const picker_r5 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(picker_r5.open());
    });
    i0.ɵɵelement(2, "igx-picker-toggle")(3, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("weekStart", (tmp_4_0 = ctx_r1.column.pipeArgs.weekStart) !== null && tmp_4_0 !== undefined ? tmp_4_0 : ctx_r1.weekStart);
    i0.ɵɵtwoWayProperty("value", ctx_r1.searchVal);
    i0.ɵɵproperty("locale", ctx_r1.grid.locale)("outlet", ctx_r1.grid.outlet)("readOnly", true)("placeholder", ctx_r1.inputDatePlaceholder)("displayFormat", ctx_r1.column.pipeArgs.format)("formatter", ctx_r1.column.formatter)("disabled", ctx_r1.expressionUI.expression.condition && ctx_r1.expressionUI.expression.condition.isUnary);
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-time-picker", 18, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxExcelStyleDateExpressionComponent_Conditional_8_Template_igx_time_picker_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchVal, $event) || (ctx_r1.searchVal = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("click", function IgxExcelStyleDateExpressionComponent_Conditional_8_Template_igx_time_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const picker_r7 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(picker_r7.open());
    });
    i0.ɵɵelement(2, "igx-picker-toggle")(3, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchVal);
    i0.ɵɵproperty("locale", ctx_r1.grid.locale)("outlet", ctx_r1.grid.outlet)("readOnly", true)("placeholder", ctx_r1.inputTimePlaceholder)("displayFormat", ctx_r1.column.pipeArgs.format)("inputFormat", ctx_r1.column.editorOptions == null ? null : ctx_r1.column.editorOptions.dateTimeFormat)("formatter", ctx_r1.column.formatter)("disabled", ctx_r1.expressionUI.expression.condition && ctx_r1.expressionUI.expression.condition.isUnary);
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 14, 3)(3, "input", 19, 4);
    i0.ɵɵtwoWayListener("ngModelChange", function IgxExcelStyleDateExpressionComponent_Conditional_9_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchVal, $event) || (ctx_r1.searchVal = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("placeholder", ctx_r1.inputDatePlaceholder)("locale", ctx_r1.column.grid.locale)("igxDateTimeEditor", ctx_r1.column.editorOptions == null ? null : ctx_r1.column.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r1.column.dataType)("displayFormat", ctx_r1.column.pipeArgs.format);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchVal);
    i0.ɵɵproperty("disabled", ctx_r1.expressionUI.expression.condition && ctx_r1.expressionUI.expression.condition.isUnary);
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function IgxExcelStyleDateExpressionComponent_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveButtonClick());
    });
    i0.ɵɵelement(1, "igx-icon", 21);
    i0.ɵɵelementEnd();
  }
}
function IgxExcelStyleDateExpressionComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-buttongroup", null, 5)(2, "span", 22, 6);
    i0.ɵɵlistener("keydown", function IgxExcelStyleDateExpressionComponent_Conditional_11_Template_span_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorKeyDown($event, 0));
    })("click", function IgxExcelStyleDateExpressionComponent_Conditional_11_Template_span_click_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorButtonClicked($event, 0));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 22, 7);
    i0.ɵɵlistener("keydown", function IgxExcelStyleDateExpressionComponent_Conditional_11_Template_span_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorKeyDown($event, 1));
    })("click", function IgxExcelStyleDateExpressionComponent_Conditional_11_Template_span_click_5_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLogicOperatorButtonClicked($event, 1));
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", ctx_r1.expressionUI.afterOperator === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_filter_operator_and, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", ctx_r1.expressionUI.afterOperator === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.grid.resourceStrings.igx_grid_filter_operator_or, " ");
  }
}
const _c116 = ["toggle"];
const _c117 = ["defaultExpressionTemplate"];
const _c118 = ["dateExpressionTemplate"];
const _c119 = (a0, a1) => ({
  "igx-excel-filter__secondary--cosy": a0,
  "igx-excel-filter__secondary--compact": a1
});
const _forTrack6 = ($index, $item) => $item.expressionId;
function IgxExcelStyleCustomDialogComponent_Conditional_7_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-excel-style-date-expression", 15);
    i0.ɵɵlistener("expressionRemoved", function IgxExcelStyleCustomDialogComponent_Conditional_7_For_1_Template_igx_excel_style_date_expression_expressionRemoved_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onExpressionRemoved($event));
    })("logicOperatorChanged", function IgxExcelStyleCustomDialogComponent_Conditional_7_For_1_Template_igx_excel_style_date_expression_logicOperatorChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onLogicOperatorChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expression_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("expressionUI", expression_r4)("column", ctx_r2.column)("grid", ctx_r2.grid)("expressionsList", ctx_r2.expressionsList);
  }
}
function IgxExcelStyleCustomDialogComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxExcelStyleCustomDialogComponent_Conditional_7_For_1_Template, 1, 4, "igx-excel-style-date-expression", 14, _forTrack6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.expressionsList);
  }
}
function IgxExcelStyleCustomDialogComponent_Conditional_8_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-excel-style-default-expression", 15);
    i0.ɵɵlistener("expressionRemoved", function IgxExcelStyleCustomDialogComponent_Conditional_8_For_1_Template_igx_excel_style_default_expression_expressionRemoved_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onExpressionRemoved($event));
    })("logicOperatorChanged", function IgxExcelStyleCustomDialogComponent_Conditional_8_For_1_Template_igx_excel_style_default_expression_logicOperatorChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onLogicOperatorChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expression_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("expressionUI", expression_r6)("column", ctx_r2.column)("grid", ctx_r2.grid)("expressionsList", ctx_r2.expressionsList);
  }
}
function IgxExcelStyleCustomDialogComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxExcelStyleCustomDialogComponent_Conditional_8_For_1_Template, 1, 4, "igx-excel-style-default-expression", 14, _forTrack6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.expressionsList);
  }
}
const _c120 = ["customDialog"];
const _c121 = ["subMenu"];
function IgxExcelStyleConditionalFilterComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" (", ctx_r1.filterNumber, ") ");
  }
}
function IgxExcelStyleConditionalFilterComponent_Conditional_0_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 6)(1, "div", 9);
    i0.ɵɵelement(2, "igx-icon", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const condition_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selected", ctx_r1.getSelectedCondition(condition_r3))("value", condition_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1.getCondition(condition_r3).iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.translateCondition(condition_r3));
  }
}
function IgxExcelStyleConditionalFilterComponent_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 7)(1, "div", 9);
    i0.ɵɵelement(2, "igx-icon", 12);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selected", ctx_r1.getSelectedCondition("custom"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.esf.grid.resourceStrings.igx_grid_excel_custom_filter);
  }
}
function IgxExcelStyleConditionalFilterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("keydown", function IgxExcelStyleConditionalFilterComponent_Conditional_0_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTextFilterKeyDown($event));
    })("click", function IgxExcelStyleConditionalFilterComponent_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTextFilterClick($event));
    });
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, IgxExcelStyleConditionalFilterComponent_Conditional_0_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "igx-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "igx-drop-down", 5, 0);
    i0.ɵɵlistener("selectionChanging", function IgxExcelStyleConditionalFilterComponent_Conditional_0_Template_igx_drop_down_selectionChanging_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubMenuSelection($event));
    })("closed", function IgxExcelStyleConditionalFilterComponent_Conditional_0_Template_igx_drop_down_closed_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubMenuClosed());
    });
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵrepeaterCreate(8, IgxExcelStyleConditionalFilterComponent_Conditional_0_For_9_Template, 5, 4, "igx-drop-down-item", 6, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(10, IgxExcelStyleConditionalFilterComponent_Conditional_0_Conditional_10_Template, 5, 2, "igx-drop-down-item", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "igx-excel-style-custom-dialog", 8, 1);
  }
  if (rf & 2) {
    const subMenu_r4 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.filterNumber > 0 ? "igx-excel-filter__actions-filter--active" : "")("igxDropDownItemNavigation", subMenu_r4);
    i0.ɵɵattribute("aria-controls", ctx_r1.subMenu == null ? null : ctx_r1.subMenu.listId)("aria-activedescendant", !(ctx_r1.subMenu == null ? null : ctx_r1.subMenu.collapsed) ? ctx_r1.subMenu == null ? null : ctx_r1.subMenu.focusedItem == null ? null : ctx_r1.subMenu.focusedItem.id : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subMenuText, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.filterNumber > 0 ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("maxHeight", "397px");
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.conditions);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showCustomFilterItem() ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("column", ctx_r1.esf.column)("filteringService", ctx_r1.esf.grid.filteringService)("overlayComponentId", ctx_r1.esf.overlayComponentId);
  }
}
function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.esf.onSelect());
    });
    i0.ɵɵelement(1, "igx-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.esf.column.selected ? "igx-excel-filter__actions-selected" : "igx-excel-filter__actions-select");
    i0.ɵɵattribute("aria-label", ctx_r1.esf.column.selected ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_deselect : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_select);
  }
}
function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.esf.onPin());
    });
    i0.ɵɵelement(1, "igx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r1.esf.column.pinned ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_unpin : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_pin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.esf.column.pinned ? "unpin" : "pin");
  }
}
function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function IgxExcelStyleHeaderComponent_Conditional_0_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.esf.onHideToggle());
    });
    i0.ɵɵelement(1, "igx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r1.esf.column.hidden ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_show : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_hide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.esf.column.hidden ? "show" : "hide");
  }
}
function IgxExcelStyleHeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 0)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 1);
    i0.ɵɵtemplate(4, IgxExcelStyleHeaderComponent_Conditional_0_Conditional_4_Template, 2, 2, "button", 2)(5, IgxExcelStyleHeaderComponent_Conditional_0_Conditional_5_Template, 2, 2, "button", 3)(6, IgxExcelStyleHeaderComponent_Conditional_0_Conditional_6_Template, 2, 2, "button", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.esf.column.header || ctx_r1.esf.column.field);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showSelecting ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showPinning ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showHiding ? 6 : -1);
  }
}
function IgxExcelStyleHidingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function IgxExcelStyleHidingComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.esf.onHideToggle());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "igx-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.esf.column.hidden ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_show : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_hide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.esf.column.hidden ? "show" : "hide");
  }
}
function IgxExcelStyleMovingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-buttongroup")(3, "button", 0);
    i0.ɵɵlistener("click", function IgxExcelStyleMovingComponent_Conditional_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMoveButtonClicked(0));
    });
    i0.ɵɵelement(4, "igx-icon", 1);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 0);
    i0.ɵɵlistener("click", function IgxExcelStyleMovingComponent_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMoveButtonClicked(1));
    });
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "igx-icon", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_moving_header, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.canNotMoveLeft);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esfSize === "1" ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_moving_left_short : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_moving_left, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.canNotMoveRight);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esfSize === "1" ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_moving_right_short : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_moving_right, " ");
  }
}
function IgxExcelStylePinningComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function IgxExcelStylePinningComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.esf.onPin());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "igx-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.esf.column.pinned ? "igx-excel-filter__actions-unpin" : "igx-excel-filter__actions-pin");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.esf.column.pinned ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_unpin : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_pin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.esf.column.pinned ? "unpin" : "pin");
  }
}
const _c122 = (a0, a1, a2, a3, a4, a5) => ({
  "igx-linear-bar__value--start": a0,
  "igx-linear-bar__value--center": a1,
  "igx-linear-bar__value--end": a2,
  "igx-linear-bar__value--top": a3,
  "igx-linear-bar__value--hidden": a4,
  "igx-linear-bar__value--fraction": a5
});
const _c123 = ["circle"];
function IgxCircularProgressBarComponent__svg_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementContainer(0);
  }
}
function IgxCircularProgressBarComponent__svg_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "linearGradient", 9);
    i0.ɵɵelement(1, "stop", 10)(2, "stop", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.gradientId);
  }
}
function IgxCircularProgressBarComponent_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxCircularProgressBarComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, IgxCircularProgressBarComponent_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultTextTemplate_r2 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngClass", ctx_r0.hasFraction ? "igx-circular-bar__value--fraction" : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.textTemplate ? ctx_r0.textTemplate.template : defaultTextTemplate_r2)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxCircularProgressBarComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textContent, "\n");
  }
}
const _c124 = ["ghostTemplate"];
const _c125 = ["childrenContainer"];
const _c126 = [[["igx-tree-node"]], "*"];
const _c127 = ["igx-tree-node", "*"];
const _c128 = (a0, a1, a2, a3) => ({
  "igx-tree-node__wrapper--selected": a0,
  "igx-tree-node__wrapper--active": a1,
  "igx-tree-node__wrapper--focused": a2,
  "igx-tree-node__wrapper--disabled": a3
});
const _c129 = () => [];
const _c130 = a0 => ({
  "igx-tree-node__toggle-button--hidden": a0
});
function IgxTreeNodeComponent_ng_template_0_0_ng_template_0_Template(rf, ctx) {}
function IgxTreeNodeComponent_ng_template_0_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeNodeComponent_ng_template_0_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxTreeNodeComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeNodeComponent_ng_template_0_0_Template, 1, 0, null, 7);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const headerTemplate_r1 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", headerTemplate_r1);
  }
}
function IgxTreeNodeComponent_2_ng_template_0_Template(rf, ctx) {}
function IgxTreeNodeComponent_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeNodeComponent_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxTreeNodeComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8, 5);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
}
function IgxTreeNodeComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", !ctx_r1.expanded ? "tree_expand" : "tree_collapse");
    i0.ɵɵattribute("aria-label", ctx_r1.expanded ? ctx_r1.resourceStrings.igx_collapse : ctx_r1.resourceStrings.igx_expand);
  }
}
function IgxTreeNodeComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-checkbox", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r1.selected)("disabled", ctx_r1.disabled)("readonly", true)("indeterminate", ctx_r1.indeterminate)("tabindex", -1);
  }
}
function IgxTreeNodeComponent_ng_template_8_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
  }
}
function IgxTreeNodeComponent_ng_template_8_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeNodeComponent_ng_template_8_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵlistener("click", function IgxTreeNodeComponent_ng_template_8_Conditional_5_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.indicatorClick());
    });
    i0.ɵɵtemplate(1, IgxTreeNodeComponent_ng_template_8_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c130, !(ctx_r1._children == null ? null : ctx_r1._children.length)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.expandIndicatorTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c25, ctx_r1.expanded));
  }
}
function IgxTreeNodeComponent_ng_template_8_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵelement(1, "igx-circular-bar", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("animate", false)("indeterminate", true)("textVisibility", false);
  }
}
function IgxTreeNodeComponent_ng_template_8_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeNodeComponent_ng_template_8_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("pointerdown", function IgxTreeNodeComponent_ng_template_8_Conditional_7_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectorPointerDown($event));
    })("click", function IgxTreeNodeComponent_ng_template_8_Conditional_7_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectorClick($event));
    });
    i0.ɵɵtemplate(1, IgxTreeNodeComponent_ng_template_8_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const selectMarkerTemplate_r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", selectMarkerTemplate_r6);
  }
}
function IgxTreeNodeComponent_ng_template_8_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
  }
}
function IgxTreeNodeComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11, 6);
    i0.ɵɵlistener("pointerdown", function IgxTreeNodeComponent_ng_template_8_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPointerDown($event));
    })("focus", function IgxTreeNodeComponent_ng_template_8_Template_div_focus_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFocus());
    })("blur", function IgxTreeNodeComponent_ng_template_8_Template_div_blur_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFocus());
    });
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵrepeaterCreate(3, IgxTreeNodeComponent_ng_template_8_For_4_Template, 1, 0, "span", 13, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxTreeNodeComponent_ng_template_8_Conditional_5_Template, 2, 7, "span", 14)(6, IgxTreeNodeComponent_ng_template_8_Conditional_6_Template, 2, 3, "span", 15)(7, IgxTreeNodeComponent_ng_template_8_Conditional_7_Template, 2, 1, "div", 16);
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵprojection(9, 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 18);
    i0.ɵɵrepeaterCreate(11, IgxTreeNodeComponent_ng_template_8_For_12_Template, 1, 0, "span", 13, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelement(13, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabIndex", ctx_r1.tabIndex)("ngClass", i0.ɵɵpureFunction4(6, _c128, ctx_r1.selected, ctx_r1.active, ctx_r1.focused, ctx_r1.disabled));
    i0.ɵɵattribute("role", ctx_r1.role);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(11, _c129).constructor(ctx_r1.level));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.loading ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loading ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showSelectors ? 7 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(12, _c129).constructor(ctx_r1.level));
  }
}
function IgxTreeNodeComponent_ng_template_10_1_ng_template_0_Template(rf, ctx) {}
function IgxTreeNodeComponent_ng_template_10_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeNodeComponent_ng_template_10_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxTreeNodeComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, IgxTreeNodeComponent_ng_template_10_1_Template, 1, 0, null, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const headerTemplate_r1 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headerTemplate_r1);
  }
}
const _c131 = [[["igx-tree-node"]]];
const _c132 = ["igx-tree-node"];
const _c133 = ["leftPanningTmpl"];
const _c134 = ["rightPanningTmpl"];
const _c135 = ["*", [["", "igxListThumbnail", ""], ["igx-list__item-thumbnail"], ["igx-avatar"]], [["", "igxListLine", ""], ["", 8, "igx-list__item-lines"], ["", "igxListLineTitle", ""], ["", "igxListLineSubTitle", ""], ["", 8, "igx-list__item-line-title"], ["", 8, "igx-list__item-line-subtitle"]], [["", "igxListAction", ""], ["", 8, "igx-list__item-actions"]]];
const _c136 = ["*", "[igxListThumbnail], igx-list__item-thumbnail, igx-avatar", "[igxListLine], .igx-list__item-lines, [igxListLineTitle], [igxListLineSubTitle], .igx-list__item-line-title, .igx-list__item-line-subtitle", "[igxListAction], .igx-list__item-actions"];
function IgxListItemComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9, 4);
    i0.ɵɵtemplate(2, IgxListItemComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r0.offsetWidthInRem, "rem")("height", ctx_r0.offsetHeightInRem, "rem");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.list.listItemLeftPanningTemplate.template)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxListItemComponent_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11, 5);
    i0.ɵɵtemplate(2, IgxListItemComponent_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r0.offsetWidthInRem, "rem")("height", ctx_r0.offsetHeightInRem, "rem");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.list.listItemRightPanningTemplate.template)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxListItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxListItemComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function IgxListItemComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function IgxListItemComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
  }
}
function IgxListItemComponent_Conditional_10_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxListItemComponent_Conditional_10_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const itemsContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", itemsContent_r2);
  }
}
function IgxListItemComponent_Conditional_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_11_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_11_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_11_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListItemComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, IgxListItemComponent_Conditional_11_ng_container_1_Template, 1, 0, "ng-container", 15)(2, IgxListItemComponent_Conditional_11_ng_container_2_Template, 1, 0, "ng-container", 15)(3, IgxListItemComponent_Conditional_11_ng_container_3_Template, 1, 0, "ng-container", 15)(4, IgxListItemComponent_Conditional_11_ng_container_4_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const itemsContent_r2 = i0.ɵɵreference(3);
    const itemThumbnails_r3 = i0.ɵɵreference(5);
    const itemLines_r4 = i0.ɵɵreference(7);
    const itemActions_r5 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemThumbnails_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemLines_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemActions_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemsContent_r2);
  }
}
const _c137 = ["defaultEmptyList"];
const _c138 = ["defaultDataLoading"];
function IgxListComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.resourceStrings.igx_list_no_items, " ");
  }
}
function IgxListComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.resourceStrings.igx_list_loading, " ");
  }
}
function IgxListComponent_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxListComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxListComponent_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", ctx_r0.context);
  }
}
const _c139 = ["cancelButton"];
const _c140 = ["list"];
const _c141 = ["selectAllCheckbox"];
const _c142 = ["addToCurrentFilterCheckbox"];
const _c143 = ["tree"];
const _c144 = ["defaultExcelStyleLoadingValuesTemplate"];
const _forTrack7 = ($index, $item) => $item.value;
function IgxExcelStyleSearchComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 18);
    i0.ɵɵlistener("click", function IgxExcelStyleSearchComponent_Conditional_4_Template_igx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearInput());
    });
    i0.ɵɵelementEnd()();
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_igx_list_item_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-list-item", 25)(1, "igx-checkbox", 26);
    i0.ɵɵlistener("change", function IgxExcelStyleSearchComponent_Conditional_5_igx_list_item_3_Template_igx_checkbox_change_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCheckboxChange($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("igx-list__item-base--active", (ctx_r2.focusedItem == null ? null : ctx_r2.focusedItem.id) === ctx_r2.getItemId(i_r7));
    i0.ɵɵattribute("id", ctx_r2.getItemId(i_r7));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", item_r6)("tabindex", -1)("checked", item_r6 == null ? null : item_r6.isSelected)("disableRipple", true)("indeterminate", item_r6 == null ? null : item_r6.indeterminate)("disableTransitions", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r6.label, " ");
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, IgxExcelStyleSearchComponent_Conditional_5_ng_template_4_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.valuesLoadingTemplate);
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_ng_template_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxExcelStyleSearchComponent_Conditional_5_ng_template_5_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const emptySearch_r8 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", emptySearch_r8);
  }
}
function IgxExcelStyleSearchComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-list", 19, 4);
    i0.ɵɵlistener("keydown", function IgxExcelStyleSearchComponent_Conditional_5_Template_igx_list_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event));
    })("focus", function IgxExcelStyleSearchComponent_Conditional_5_Template_igx_list_focus_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onFocus());
    })("focusout", function IgxExcelStyleSearchComponent_Conditional_5_Template_igx_list_focusout_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onFocusOut());
    });
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵtemplate(3, IgxExcelStyleSearchComponent_Conditional_5_igx_list_item_3_Template, 3, 10, "igx-list-item", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxExcelStyleSearchComponent_Conditional_5_ng_template_4_Template, 2, 1, "ng-template", 22)(5, IgxExcelStyleSearchComponent_Conditional_5_ng_template_5_Template, 1, 1, "ng-template", 23);
    i0.ɵɵelementStart(6, "div", 24);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isLoading", ctx_r2.isLoading);
    i0.ɵɵattribute("aria-activedescendant", ctx_r2.activeDescendant);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("igxForOf", ctx_r2.displayedListData)("igxForScrollOrientation", "vertical")("igxForContainerSize", ctx_r2.containerSize)("igxForItemSize", ctx_r2.itemSize);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.esf.grid == null ? null : ctx_r2.esf.grid.resourceStrings.igx_grid_excel_matches_count.replace("{0}", ctx_r2.matchesCount), " ");
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "igx-checkbox", 34, 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.addToCurrentFilterItem)("checked", ctx_r2.addToCurrentFilterItem.isSelected)("disableRipple", true)("disableTransitions", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.addToCurrentFilterItem.label, " ");
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 32)(2, "igx-checkbox", 33, 6);
    i0.ɵɵlistener("change", function IgxExcelStyleSearchComponent_Conditional_6_Conditional_1_Template_igx_checkbox_change_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onSelectAllCheckboxChange($event));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, IgxExcelStyleSearchComponent_Conditional_6_Conditional_1_Conditional_5_Template, 4, 5, "div", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r2.selectAllItem)("checked", ctx_r2.selectAllItem == null ? null : ctx_r2.selectAllItem.isSelected)("disableRipple", true)("indeterminate", ctx_r2.selectAllItem == null ? null : ctx_r2.selectAllItem.indeterminate)("disableTransitions", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.selectAllItem.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.searchValue ? 5 : -1);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const childLevel9_r11 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel9_r11)("selected", childLevel9_r11.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel9_r11.label);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template, 3, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel8_r12 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel8_r12)("selected", childLevel8_r12.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel8_r12.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel8_r12.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel7_r13 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel7_r13)("selected", childLevel7_r13.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel7_r13.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel7_r13.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel6_r14 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel6_r14)("selected", childLevel6_r14.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel6_r14.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel6_r14.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel5_r15 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel5_r15)("selected", childLevel5_r15.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel5_r15.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel5_r15.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel4_r16 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel4_r16)("selected", childLevel4_r16.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel4_r16.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel4_r16.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel3_r17 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel3_r17)("selected", childLevel3_r17.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel3_r17.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel3_r17.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel2_r18 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel2_r18)("selected", childLevel2_r18.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel2_r18.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel2_r18.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childLevel1_r19 = ctx.$implicit;
    i0.ɵɵproperty("data", childLevel1_r19)("selected", childLevel1_r19.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(childLevel1_r19.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(childLevel1_r19.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-tree-node", 31)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, IgxExcelStyleSearchComponent_Conditional_6_For_5_For_4_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r20 = ctx.$implicit;
    i0.ɵɵproperty("data", item_r20)("selected", item_r20.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r20.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(item_r20.children);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_ng_template_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, IgxExcelStyleSearchComponent_Conditional_6_ng_template_6_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.valuesLoadingTemplate);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_Conditional_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxExcelStyleSearchComponent_Conditional_6_Conditional_7_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const emptySearch_r8 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", emptySearch_r8);
  }
}
function IgxExcelStyleSearchComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, IgxExcelStyleSearchComponent_Conditional_6_Conditional_1_Template, 6, 7, "div", 29);
    i0.ɵɵelementStart(2, "igx-tree", 30, 5);
    i0.ɵɵlistener("nodeSelection", function IgxExcelStyleSearchComponent_Conditional_6_Template_igx_tree_nodeSelection_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeSelectionChange($event));
    });
    i0.ɵɵrepeaterCreate(4, IgxExcelStyleSearchComponent_Conditional_6_For_5_Template, 5, 3, "igx-tree-node", 31, _forTrack7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, IgxExcelStyleSearchComponent_Conditional_6_ng_template_6_Template, 2, 1, "ng-template", 22)(7, IgxExcelStyleSearchComponent_Conditional_6_Conditional_7_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.isTreeEmpty() ? 1 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.displayedListData);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.isTreeEmpty() ? 7 : -1);
  }
}
function IgxExcelStyleSearchComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.esf.grid == null ? null : ctx_r2.esf.grid.resourceStrings.igx_grid_excel_no_matches, " ");
  }
}
function IgxExcelStyleSearchComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 36);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxExcelStyleSelectingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function IgxExcelStyleSelectingComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.esf.onSelect());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "igx-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.esf.column.selected ? "igx-excel-filter__actions-selected" : "igx-excel-filter__actions-select");
    i0.ɵɵattribute("aria-pressed", ctx_r1.esf.column.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.esf.grid.resourceStrings.igx_grid_excel_select);
  }
}
const _c145 = ["sortButtonGroup"];
function IgxExcelStyleSortingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-buttongroup", null, 0)(4, "button", 1);
    i0.ɵɵlistener("buttonSelected", function IgxExcelStyleSortingComponent_Conditional_0_Template_button_buttonSelected_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSortButtonClicked(1));
    });
    i0.ɵɵelement(5, "igx-icon", 2);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "button", 1);
    i0.ɵɵlistener("buttonSelected", function IgxExcelStyleSortingComponent_Conditional_0_Template_button_buttonSelected_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSortButtonClicked(2));
    });
    i0.ɵɵelement(9, "igx-icon", 3);
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_sorting_header, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("data-togglable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esfSize === "1" ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_sorting_asc_short : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_sorting_asc, " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-togglable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.esfSize === "1" ? ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_sorting_desc_short : ctx_r1.esf.grid.resourceStrings.igx_grid_excel_filter_sorting_desc, " ");
  }
}
const _c146 = ["mainDropdown"];
const _c147 = ["defaultExcelColumnOperations"];
const _c148 = ["defaultExcelFilterOperations"];
const _c149 = [[["igx-excel-style-column-operations"], ["", "igxExcelStyleColumnOperations", ""]], [["igx-excel-style-filter-operations"], ["", "igxExcelStyleFilterOperations", ""]]];
const _c150 = ["igx-excel-style-column-operations,[igxExcelStyleColumnOperations]", "igx-excel-style-filter-operations,[igxExcelStyleFilterOperations]"];
const _c151 = (a0, a1, a2) => ({
  "igx-excel-filter__sizing": a0,
  "igx-excel-filter__menu--cosy": a1,
  "igx-excel-filter__menu--compact": a2
});
function IgxGridExcelStyleFilteringComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-sorting");
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-moving");
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-pinning");
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-hiding");
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-selecting");
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-header", 2);
    i0.ɵɵtemplate(1, IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_1_Template, 1, 0, "igx-excel-style-sorting")(2, IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_2_Template, 1, 0, "igx-excel-style-moving")(3, IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_3_Template, 1, 0, "igx-excel-style-pinning")(4, IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_4_Template, 1, 0, "igx-excel-style-hiding")(5, IgxGridExcelStyleFilteringComponent_Conditional_3_Conditional_5_Template, 1, 0, "igx-excel-style-selecting");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showHiding", ctx_r1.size !== "3" && !(ctx_r1.column == null ? null : ctx_r1.column.disableHiding))("showPinning", ctx_r1.size !== "3" && !(ctx_r1.column == null ? null : ctx_r1.column.disablePinning))("showSelecting", ctx_r1.size !== "3" && ctx_r1.columnSelectable());
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.column == null ? null : ctx_r1.column.sortable) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.grid == null ? null : ctx_r1.grid.moving) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r1.column == null ? null : ctx_r1.column.disablePinning) && ctx_r1.size === "3" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r1.column == null ? null : ctx_r1.column.disableHiding) && ctx_r1.size === "3" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.columnSelectable() && ctx_r1.size === "3" ? 5 : -1);
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxGridExcelStyleFilteringComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-excel-style-clear-filters")(1, "igx-excel-style-conditional-filter")(2, "igx-excel-style-search");
  }
}
const _c152 = ["defaultESFHeaderIconTemplate"];
const _c153 = ["defaultSortHeaderIconTemplate"];
const _c154 = ["sortIconContainer"];
const _c155 = (a0, a1) => ({
  $implicit: a0,
  column: a1
});
function IgxGridHeaderComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.column.header || ctx_r0.column.field);
  }
}
function IgxGridHeaderComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 8);
  }
}
function IgxGridHeaderComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxGridHeaderComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderComponent_Conditional_8_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 3);
    i0.ɵɵpipe(2, "sortingIndex");
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderComponent_Conditional_8_Conditional_1_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onPointerDownIndicator($event));
    })("click", function IgxGridHeaderComponent_Conditional_8_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onSortingIconClick($event));
    });
    i0.ɵɵtemplate(3, IgxGridHeaderComponent_Conditional_8_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-sortIndex", ctx_r0.grid.sortingOptions.mode === "single" && ctx_r0.grid.sortingExpressions.length <= 1 ? null : i0.ɵɵpipeBind2(2, 3, ctx_r0.column.field, ctx_r0.grid.sortingExpressions));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sortIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx_r0));
  }
}
function IgxGridHeaderComponent_Conditional_8_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderComponent_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderComponent_Conditional_8_Conditional_2_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onPointerDownIndicator($event));
    })("click", function IgxGridHeaderComponent_Conditional_8_Conditional_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFilteringIconClick($event));
    });
    i0.ɵɵtemplate(1, IgxGridHeaderComponent_Conditional_8_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.filterIconClassName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.esfIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c25, ctx_r0));
  }
}
function IgxGridHeaderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, IgxGridHeaderComponent_Conditional_8_Conditional_1_Template, 4, 8, "div", 10)(2, IgxGridHeaderComponent_Conditional_8_Conditional_2_Template, 2, 5, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.sortable && !ctx_r0.disabled ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.allowFiltering && ctx_r0.column.filterable && ctx_r0.grid.filterMode === "excelStyleFilter" ? 2 : -1);
  }
}
const _c156 = ["emptyFilter"];
const _c157 = ["defaultFilter"];
const _c158 = ["complexFilter"];
const _c159 = ["chipsArea"];
const _c160 = ["moreIcon"];
const _c161 = ["ghostChip"];
const _c162 = ["complexChip"];
const _forTrack8 = ($index, $item) => $item.expression;
function IgxGridFilteringCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chips-area", 9)(1, "igx-chip", 10, 3);
    i0.ɵɵlistener("click", function IgxGridFilteringCellComponent_ng_template_0_Template_igx_chip_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChipClicked());
    });
    i0.ɵɵelement(3, "igx-icon", 11);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", ctx_r1.filteringElementsSize);
    i0.ɵɵproperty("tabIndex", -1);
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.filteringService.grid.resourceStrings.igx_grid_filter);
  }
}
function IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 17);
    i0.ɵɵlistener("click", function IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_0_Template_igx_chip_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChipClicked(item_r5.expression));
    })("remove", function IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_0_Template_igx_chip_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChipRemoved($event, item_r5));
    });
    i0.ɵɵelement(1, "igx-icon", 18);
    i0.ɵɵelementStart(2, "span", null, 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", ctx_r1.filteringElementsSize);
    i0.ɵɵproperty("removable", true)("tabIndex", -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", item_r5.expression.condition.iconName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.filteringService.getChipLabel(item_r5.expression), " ");
  }
}
function IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.filteringService.getOperatorAsString(item_r5.afterOperator));
  }
}
function IgxGridFilteringCellComponent_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_0_Template, 5, 6, "igx-chip", 15)(1, IgxGridFilteringCellComponent_ng_template_2_For_3_Conditional_1_Template, 2, 1, "span", 16);
  }
  if (rf & 2) {
    const ɵ$index_16_r6 = ctx.$index;
    const ɵ$count_16_r7 = ctx.$count;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.isChipVisible(ɵ$index_16_r6) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_16_r6 === ɵ$count_16_r7 - 1) && ctx_r1.isChipVisible(ɵ$index_16_r6 + 1) ? 1 : -1);
  }
}
function IgxGridFilteringCellComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chips-area", 9, 4);
    i0.ɵɵrepeaterCreate(2, IgxGridFilteringCellComponent_ng_template_2_For_3_Template, 2, 2, null, null, _forTrack8);
    i0.ɵɵelementStart(4, "div", 12, 5);
    i0.ɵɵlistener("click", function IgxGridFilteringCellComponent_ng_template_2_Template_div_click_4_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChipClicked());
    });
    i0.ɵɵelement(6, "igx-icon", 13)(7, "igx-badge", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.expressionsList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.filteringIndicatorClass());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r1.moreFiltersCount);
  }
}
function IgxGridFilteringCellComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 19, 7);
    i0.ɵɵlistener("remove", function IgxGridFilteringCellComponent_ng_template_4_Template_igx_chip_remove_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFiltering());
    });
    i0.ɵɵelement(2, "igx-icon", 11);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--ig-size", ctx_r1.filteringElementsSize);
    i0.ɵɵproperty("removable", true)("tabIndex", -1);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.filteringService.grid.resourceStrings.igx_grid_complex_filter);
  }
}
function IgxGridFilteringCellComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c163 = (a0, a1) => ({
  "igx-grid-th--pinned-last": a0,
  "igx-grid-th--pinned-first": a1
});
const _c164 = (a0, a1) => ({
  "grid-template-rows": a0,
  "grid-template-columns": a1
});
const _c165 = (a0, a1, a2, a3, a4, a5) => ({
  "igx-grid-th--pinned-last": a0,
  "igx-grid-th--pinned-first": a1,
  "igx-grid-th--collapsible": a2,
  "igx-grid-th--selectable": a3,
  "igx-grid-th--selected": a4,
  "igx-grid-th--active": a5
});
function IgxGridHeaderGroupComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
}
function IgxGridHeaderGroupComponent_Conditional_0_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 5);
    i0.ɵɵpipe(1, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const child_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", child_r1.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(1, 3, child_r1.headerGroupStyles, child_r1, ctx_r1.grid.pipeTrigger))("column", child_r1);
  }
}
function IgxGridHeaderGroupComponent_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_0_For_3_Conditional_0_Template, 2, 7, "igx-grid-header-group", 5);
  }
  if (rf & 2) {
    const child_r1 = ctx.$implicit;
    i0.ɵɵconditional(!child_r1.hidden ? 0 : -1);
  }
}
function IgxGridHeaderGroupComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
function IgxGridHeaderGroupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_0_Conditional_0_Template, 1, 0, "span", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵrepeaterCreate(2, IgxGridHeaderGroupComponent_Conditional_0_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxGridHeaderGroupComponent_Conditional_0_Conditional_4_Template, 1, 0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.grid.moving ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c163, ctx_r1.hasLastPinnedChildColumn, ctx_r1.hasFirstPinnedChildColumn))("ngStyle", i0.ɵɵpureFunction2(7, _c164, ctx_r1.column.getGridTemplate(true), ctx_r1.column.getGridTemplate(false)));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.column.children);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.grid.moving ? 4 : -1);
  }
}
function IgxGridHeaderGroupComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.column.header);
  }
}
function IgxGridHeaderGroupComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.column.expanded ? "tree_collapse" : "tree_expand");
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPointerDownIndicator($event));
    })("click", function IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleExpandState($event));
    });
    i0.ɵɵtemplate(1, IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultCollapseIndicator_r5 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.column.collapsibleIndicatorTemplate ? ctx_r1.column.collapsibleIndicatorTemplate : defaultCollapseIndicator_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c155, ctx_r1.column, ctx_r1.column));
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 5);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const child_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 7, child_r6.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.grid.hasColumnLayouts))("flex-basis", i0.ɵɵpipeBind3(2, 11, child_r6.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.grid.hasColumnLayouts));
    i0.ɵɵproperty("ngClass", child_r6.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 15, child_r6.headerGroupStyles, child_r6, ctx_r1.grid.pipeTrigger))("column", child_r6);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_For_2_Conditional_0_Template, 4, 19, "igx-grid-header-group", 13);
  }
  if (rf & 2) {
    const child_r6 = ctx.$implicit;
    i0.ɵɵconditional(!child_r6.hidden ? 0 : -1);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵrepeaterCreate(1, IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.column.children);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
function IgxGridHeaderGroupComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_5_Conditional_0_Template, 1, 0, "span", 2);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderGroupComponent_Conditional_5_Template_div_pointerdown_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pointerdown($event));
    })("click", function IgxGridHeaderGroupComponent_Conditional_5_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.groupClicked($event));
    })("pointerenter", function IgxGridHeaderGroupComponent_Conditional_5_Template_div_pointerenter_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPinterEnter());
    })("pointerleave", function IgxGridHeaderGroupComponent_Conditional_5_Template_div_pointerleave_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPointerLeave());
    });
    i0.ɵɵtemplate(2, IgxGridHeaderGroupComponent_Conditional_5_Conditional_2_Template, 2, 5, "div", 9)(3, IgxGridHeaderGroupComponent_Conditional_5_ng_container_3_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxGridHeaderGroupComponent_Conditional_5_Conditional_4_Template, 3, 0, "div", 11)(5, IgxGridHeaderGroupComponent_Conditional_5_Conditional_5_Template, 1, 0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultColumn_r7 = i0.ɵɵreference(2);
    i0.ɵɵconditional(ctx_r1.grid.moving ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(14, _c165, ctx_r1.hasLastPinnedChildColumn, ctx_r1.hasFirstPinnedChildColumn, ctx_r1.column.collapsible, ctx_r1.selectable, ctx_r1.selected, ctx_r1.activeGroup))("igxColumnMovingDrag", ctx_r1.column)("ghostHost", ctx_r1.grid.outlet.nativeElement)("igxColumnMovingDrop", ctx_r1.column);
    i0.ɵɵattribute("aria-label", ctx_r1.column.header || ctx_r1.column.field)("aria-expanded", ctx_r1.column.expanded)("aria-selected", ctx_r1.column.selected)("droppable", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.column.collapsible ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.column.headerTemplate ? ctx_r1.column.headerTemplate : defaultColumn_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction2(21, _c155, ctx_r1.column, ctx_r1.column));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.grid.type !== "pivot" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.grid.moving ? 5 : -1);
  }
}
function IgxGridHeaderGroupComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
}
function IgxGridHeaderGroupComponent_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-filtering-cell", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("column", ctx_r1.column);
    i0.ɵɵattribute("draggable", false);
  }
}
function IgxGridHeaderGroupComponent_Conditional_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("cursor", ctx_r1.colResizingService.resizeCursor);
    i0.ɵɵproperty("igxResizeHandle", ctx_r1.column);
    i0.ɵɵattribute("draggable", false);
  }
}
function IgxGridHeaderGroupComponent_Conditional_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
function IgxGridHeaderGroupComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_6_Conditional_0_Template, 1, 0, "span", 2);
    i0.ɵɵelementStart(1, "igx-grid-header", 14);
    i0.ɵɵpipe(2, "igxHeaderGroupStyle");
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderGroupComponent_Conditional_6_Template_igx_grid_header_pointerdown_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.activate());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxGridHeaderGroupComponent_Conditional_6_Conditional_3_Template, 1, 2, "igx-grid-filtering-cell", 15)(4, IgxGridHeaderGroupComponent_Conditional_6_Conditional_4_Template, 1, 4, "span", 16)(5, IgxGridHeaderGroupComponent_Conditional_6_Conditional_5_Template, 1, 0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.grid.moving ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.grid.id + "_" + ctx_r1.column.field)("ngClass", ctx_r1.column.headerClasses)("ngStyle", i0.ɵɵpipeBind3(2, 12, ctx_r1.column.headerStyles, ctx_r1.column, ctx_r1.grid.pipeTrigger))("igxColumnMovingDrag", ctx_r1.column)("ghostHost", ctx_r1.grid.outlet.nativeElement)("igxColumnMovingDrop", ctx_r1.column)("column", ctx_r1.column);
    i0.ɵɵattribute("droppable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.grid.allowFiltering && ctx_r1.grid.filterMode === "quickFilter" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.column.columnGroup && ctx_r1.column.resizable ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.grid.moving ? 5 : -1);
  }
}
const _c166 = ["defaultFilterUI"];
const _c167 = ["defaultDateUI"];
const _c168 = ["defaultTimeUI"];
const _c169 = ["defaultDateTimeUI"];
const _c170 = ["inputGroupConditions"];
const _c171 = ["inputGroupPrefix"];
const _c172 = ["operand"];
const _c173 = ["closeButton"];
const _c174 = ["operators"];
function IgxGridFilteringRowComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 16)(1, "div", 23);
    i0.ɵɵelement(2, "igx-icon", 24);
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const condition_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", condition_r2)("selected", ctx_r2.isConditionSelected(condition_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.getCondition(condition_r2).iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.translateCondition(condition_r2));
  }
}
function IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 29);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template_igx_icon_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template_igx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-icon", 30);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template_igx_icon_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template_igx_icon_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearClick());
    });
    i0.ɵɵelementEnd()();
  }
}
function IgxGridFilteringRowComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 26, 8);
    i0.ɵɵlistener("focusout", function IgxGridFilteringRowComponent_ng_template_4_Template_igx_input_group_focusout_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputGroupFocusout());
    });
    i0.ɵɵelementStart(2, "igx-prefix", 27, 9);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_ng_template_4_Template_igx_prefix_click_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputGroupPrefixClick($event));
    })("keydown", function IgxGridFilteringRowComponent_ng_template_4_Template_igx_prefix_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onPrefixKeyDown($event));
    });
    i0.ɵɵelement(4, "igx-icon", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 28, 10);
    i0.ɵɵlistener("input", function IgxGridFilteringRowComponent_ng_template_4_Template_input_input_5_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInput($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_4_Template_input_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputClick());
    })("compositionstart", function IgxGridFilteringRowComponent_ng_template_4_Template_input_compositionstart_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCompositionStart());
    })("compositionend", function IgxGridFilteringRowComponent_ng_template_4_Template_input_compositionend_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCompositionEnd());
    })("keydown", function IgxGridFilteringRowComponent_ng_template_4_Template_input_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyDown($event));
    })("keyup", function IgxGridFilteringRowComponent_ng_template_4_Template_input_keyup_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyUp());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, IgxGridFilteringRowComponent_ng_template_4_Conditional_7_Template, 3, 0, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const inputGroupConditions_r6 = i0.ɵɵreference(1);
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxDropDownItemNavigation", inputGroupConditions_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.getIconName());
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", ctx_r2.placeholder)("value", ctx_r2.value)("type", ctx_r2.type)("readonly", ctx_r2.isUnaryCondition);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.value || ctx_r2.value === 0 ? 7 : -1);
  }
}
function IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 29);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template_igx_icon_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template_igx_icon_click_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-icon", 30);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template_igx_icon_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template_igx_icon_click_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clearInput($event));
    });
    i0.ɵɵelementEnd()();
  }
}
function IgxGridFilteringRowComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-date-picker", 31, 11);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_date_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.value, $event) || (ctx_r2.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_date_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const picker_r8 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.expression.condition.isUnary ? null : picker_r8.open());
    })("keydown", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_date_picker_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyDown($event));
    })("focusout", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_date_picker_focusout_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputGroupFocusout());
    })("closed", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_date_picker_closed_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusEditElement());
    });
    i0.ɵɵelementStart(2, "igx-prefix", 27, 9);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_prefix_click_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputGroupPrefixClick($event));
    })("keydown", function IgxGridFilteringRowComponent_ng_template_6_Template_igx_prefix_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onPrefixKeyDown($event));
    });
    i0.ɵɵelement(4, "igx-icon", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxGridFilteringRowComponent_ng_template_6_Conditional_5_Template, 3, 0, "igx-suffix");
    i0.ɵɵelement(6, "igx-picker-toggle")(7, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const inputGroupConditions_r6 = i0.ɵɵreference(1);
    i0.ɵɵtwoWayProperty("value", ctx_r2.value);
    i0.ɵɵproperty("readOnly", true)("outlet", ctx_r2.filteringService.grid.outlet)("locale", ctx_r2.filteringService.grid.locale)("displayFormat", ctx_r2.column.pipeArgs.format)("formatter", ctx_r2.column.formatter)("placeholder", ctx_r2.placeholder)("weekStart", ctx_r2.column.pipeArgs.weekStart);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxDropDownItemNavigation", inputGroupConditions_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.expression.condition.iconName);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.value ? 5 : -1);
  }
}
function IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 29);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template_igx_icon_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template_igx_icon_click_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-icon", 30);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template_igx_icon_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template_igx_icon_click_2_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clearInput($event));
    });
    i0.ɵɵelementEnd()();
  }
}
function IgxGridFilteringRowComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-time-picker", 32, 11);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_time_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.value, $event) || (ctx_r2.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("closed", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_time_picker_closed_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusEditElement());
    })("focusout", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_time_picker_focusout_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputGroupFocusout());
    })("keydown", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_time_picker_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_time_picker_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const picker_r11 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.expression.condition.isUnary ? null : picker_r11.open());
    });
    i0.ɵɵelementStart(2, "igx-prefix", 27, 9);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_prefix_click_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputGroupPrefixClick($event));
    })("keydown", function IgxGridFilteringRowComponent_ng_template_8_Template_igx_prefix_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onPrefixKeyDown($event));
    });
    i0.ɵɵelement(4, "igx-icon", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxGridFilteringRowComponent_ng_template_8_Conditional_5_Template, 3, 0, "igx-suffix");
    i0.ɵɵelement(6, "igx-picker-toggle")(7, "igx-picker-clear");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const inputGroupConditions_r6 = i0.ɵɵreference(1);
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵtwoWayProperty("value", ctx_r2.value);
    i0.ɵɵproperty("inputFormat", ctx_r2.column.editorOptions == null ? null : ctx_r2.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r2.column.pipeArgs.format)("locale", ctx_r2.filteringService.grid.locale)("formatter", ctx_r2.column.formatter)("outlet", ctx_r2.filteringService.grid.outlet)("readOnly", true)("placeholder", ctx_r2.placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxDropDownItemNavigation", inputGroupConditions_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.expression.condition.iconName);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.value ? 5 : -1);
  }
}
function IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix")(1, "igx-icon", 29);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template_igx_icon_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template_igx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCommitClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "igx-icon", 30);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template_igx_icon_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template_igx_icon_click_2_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClearClick());
    });
    i0.ɵɵelementEnd()();
  }
}
function IgxGridFilteringRowComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 26, 8);
    i0.ɵɵlistener("focusout", function IgxGridFilteringRowComponent_ng_template_10_Template_igx_input_group_focusout_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputGroupFocusout());
    });
    i0.ɵɵelementStart(2, "igx-prefix", 27, 9);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_ng_template_10_Template_igx_prefix_click_2_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputGroupPrefixClick($event));
    })("keydown", function IgxGridFilteringRowComponent_ng_template_10_Template_igx_prefix_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onPrefixKeyDown($event));
    });
    i0.ɵɵelement(4, "igx-icon", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 33, 10);
    i0.ɵɵlistener("valueChange", function IgxGridFilteringRowComponent_ng_template_10_Template_input_valueChange_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInput($event));
    })("click", function IgxGridFilteringRowComponent_ng_template_10_Template_input_click_5_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputClick());
    })("keydown", function IgxGridFilteringRowComponent_ng_template_10_Template_input_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyDown($event));
    })("keyup", function IgxGridFilteringRowComponent_ng_template_10_Template_input_keyup_5_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyUp());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, IgxGridFilteringRowComponent_ng_template_10_Conditional_7_Template, 3, 0, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const inputGroupConditions_r6 = i0.ɵɵreference(1);
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxDropDownItemNavigation", inputGroupConditions_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r2.getIconName());
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", ctx_r2.placeholder)("locale", ctx_r2.filteringService.grid.locale)("displayFormat", ctx_r2.column.pipeArgs.format)("igxDateTimeEditor", ctx_r2.column.editorOptions == null ? null : ctx_r2.column.editorOptions.dateTimeFormat)("value", ctx_r2.value)("readonly", ctx_r2.isUnaryCondition);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.value || ctx_r2.value === 0 ? 7 : -1);
  }
}
function IgxGridFilteringRowComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridFilteringRowComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_Conditional_13_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onLeftArrowKeyDown($event));
    })("click", function IgxGridFilteringRowComponent_Conditional_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.scrollChipsOnArrowPress("left"));
    });
    i0.ɵɵelement(1, "igx-icon", 35);
    i0.ɵɵelementEnd();
  }
}
function IgxGridFilteringRowComponent_For_20_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 38)(1, "button", 39);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_For_20_Conditional_6_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ɵ$index_100_r20 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleOperatorsDropDown($event, ɵ$index_100_r20));
    });
    i0.ɵɵelement(2, "igx-icon", 40);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "igx-drop-down", 41, 13);
    i0.ɵɵlistener("selectionChanging", function IgxGridFilteringRowComponent_For_20_Conditional_6_Template_igx_drop_down_selectionChanging_5_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const item_r18 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onLogicOperatorChanged($event, item_r18));
    });
    i0.ɵɵelementStart(7, "igx-drop-down-item", 16);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "igx-drop-down-item", 16);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const operators_r21 = i0.ɵɵreference(6);
    const item_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵproperty("igxDropDownItemNavigation", operators_r21);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.getOperatorAsString(item_r18.afterOperator));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", 0)("selected", item_r18.afterOperator === 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.grid.resourceStrings.igx_grid_filter_operator_and);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", 1)("selected", item_r18.afterOperator === 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.grid.resourceStrings.igx_grid_filter_operator_or);
  }
}
function IgxGridFilteringRowComponent_For_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 20);
    i0.ɵɵelementStart(1, "igx-chip", 36, 12);
    i0.ɵɵlistener("pointerdown", function IgxGridFilteringRowComponent_For_20_Template_igx_chip_pointerdown_1_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const chip_r17 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipPointerdown($event, chip_r17));
    })("click", function IgxGridFilteringRowComponent_For_20_Template_igx_chip_click_1_listener($event) {
      const item_r18 = i0.ɵɵrestoreView(_r16).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipClick($event, item_r18));
    })("keydown", function IgxGridFilteringRowComponent_For_20_Template_igx_chip_keydown_1_listener($event) {
      const item_r18 = i0.ɵɵrestoreView(_r16).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipKeyDown($event, item_r18));
    })("remove", function IgxGridFilteringRowComponent_For_20_Template_igx_chip_remove_1_listener($event) {
      const item_r18 = i0.ɵɵrestoreView(_r16).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChipRemoved($event, item_r18));
    });
    i0.ɵɵelement(3, "igx-icon", 37);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, IgxGridFilteringRowComponent_For_20_Conditional_6_Template, 11, 10, "span", 38);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ɵ$index_100_r20 = ctx.$index;
    const ɵ$count_100_r22 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵproperty("selectable", false)("selected", item_r18.isSelected)("removable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", item_r18.expression.condition.iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.getChipLabel(item_r18.expression));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_100_r20 === ɵ$count_100_r22 - 1) ? 6 : -1);
  }
}
function IgxGridFilteringRowComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_Conditional_21_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.scrollChipsOnArrowPress("right"));
    });
    i0.ɵɵelement(1, "igx-icon", 43);
    i0.ɵɵelementEnd();
  }
}
function IgxGridFilteringRowComponent_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_Conditional_24_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearFiltering());
    });
    i0.ɵɵelement(1, "igx-icon", 45);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 46, 14);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_Conditional_24_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵelement(6, "igx-icon", 47);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵproperty("disabled", ctx_r2.disabled)("tabindex", ctx_r2.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.grid.resourceStrings.igx_grid_filter_row_reset);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.filteringService.grid.resourceStrings.igx_grid_filter_row_close);
  }
}
function IgxGridFilteringRowComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 48);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_Conditional_25_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearFiltering());
    });
    i0.ɵɵelement(1, "igx-icon", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 49, 14);
    i0.ɵɵlistener("click", function IgxGridFilteringRowComponent_Conditional_25_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵelement(4, "igx-icon", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
    i0.ɵɵproperty("disabled", ctx_r2.disabled)("tabindex", ctx_r2.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("--ig-size", ctx_r2.filteringElementsSize);
  }
}
const _c175 = ["headerVirtualContainer"];
const _c176 = ["headerDragContainer"];
const _c177 = ["headerSelectorContainer"];
const _c178 = ["headerGroupContainer"];
const _c179 = ["headSelectorBaseTemplate"];
const _c180 = ["headerHierarchyExpander"];
const _c181 = (a0, a1, a2) => ({
  "igx-grid__hierarchical-expander igx-grid__hierarchical-expander--header igx-grid__tr-action": a0,
  "igx-grid__hierarchical-expander--push": a1,
  "igx-grid__hierarchical-expander--no-border": a2
});
const _c182 = a0 => ({
  "visibility": a0
});
function _forTrack9($index, $item) {
  return this.trackPinnedColumn($item);
}
function IgxGridHeaderRowComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.grid.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
  }
}
function IgxGridHeaderRowComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.grid.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
  }
}
function IgxGridHeaderRowComponent_Conditional_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderRowComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24, 2);
    i0.ɵɵlistener("pointerdown", function IgxGridHeaderRowComponent_Conditional_4_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtemplate(3, IgxGridHeaderRowComponent_Conditional_4_ng_container_3_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("igx-grid__drag-indicator--header", !ctx_r1.grid.isRowSelectable);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.dragIndicatorIconTemplate || ctx_r1.grid.dragIndicatorIconBase);
  }
}
function IgxGridHeaderRowComponent_Conditional_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 4);
  }
}
function IgxGridHeaderRowComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27, 3);
    i0.ɵɵlistener("click", function IgxGridHeaderRowComponent_Conditional_5_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.headerRowSelection($event));
    })("pointerdown", function IgxGridHeaderRowComponent_Conditional_5_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(2, IgxGridHeaderRowComponent_Conditional_5_ng_container_2_Template, 2, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const headSelectorBaseTemplate_r5 = i0.ɵɵreference(17);
    i0.ɵɵclassProp("igx-grid__cbx-selection--push", ctx_r1.grid.filteringService.isFilterRowVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.headSelectorTemplate || headSelectorBaseTemplate_r5)("ngTemplateOutletContext", ctx_r1.rowSelectorsContext);
  }
}
function IgxGridHeaderRowComponent_Conditional_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderRowComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29, 5);
    i0.ɵɵlistener("click", function IgxGridHeaderRowComponent_Conditional_6_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.grid.toggleAll());
    })("pointerdown", function IgxGridHeaderRowComponent_Conditional_6_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(2, IgxGridHeaderRowComponent_Conditional_6_ng_container_2_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.grid.hasExpandableChildren || !ctx_r1.grid.hasVisibleColumns)("ngClass", i0.ɵɵpureFunction3(4, _c181, ctx_r1.grid.hasExpandableChildren, ctx_r1.grid.filteringService.isFilterRowVisible, ctx_r1.grid.isRowSelectable || ctx_r1.grid.rowDraggable));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c25, ctx_r1.grid));
  }
}
function IgxGridHeaderRowComponent_Conditional_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridHeaderRowComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30, 6);
    i0.ɵɵlistener("click", function IgxGridHeaderRowComponent_Conditional_7_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.grid.toggleAllGroupRows());
    })("pointerdown", function IgxGridHeaderRowComponent_Conditional_7_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(2, IgxGridHeaderRowComponent_Conditional_7_ng_container_2_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.indentationCSSClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c25, ctx_r1.grid));
  }
}
function IgxGridHeaderRowComponent_Conditional_8_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 32);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const column_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 7, column_r8.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 11, column_r8.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL));
    i0.ɵɵproperty("ngClass", column_r8.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 15, column_r8.headerGroupStyles, column_r8, ctx_r1.grid.pipeTrigger))("column", column_r8);
  }
}
function IgxGridHeaderRowComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxGridHeaderRowComponent_Conditional_8_For_1_Template, 4, 19, "igx-grid-header-group", 31, _forTrack9, true);
    i0.ɵɵpipe(2, "igxTopLevel");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumnCollection));
  }
}
function IgxGridHeaderRowComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 32);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const column_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 7, column_r9.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 11, column_r9.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL));
    i0.ɵɵproperty("ngClass", column_r9.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 15, column_r9.headerGroupStyles, column_r9, ctx_r1.grid.pipeTrigger))("column", column_r9);
  }
}
function IgxGridHeaderRowComponent_Conditional_12_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 32);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const column_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 9, column_r10.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 13, column_r10.resolvedWidth, ctx_r1.grid.defaultHeaderGroupMinWidth, ctx_r1.hasMRL))("left", column_r10.rightPinnedOffset);
    i0.ɵɵproperty("ngClass", column_r10.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 17, column_r10.headerGroupStyles, column_r10, ctx_r1.grid.pipeTrigger))("column", column_r10);
  }
}
function IgxGridHeaderRowComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxGridHeaderRowComponent_Conditional_12_For_1_Template, 4, 21, "igx-grid-header-group", 33, _forTrack9, true);
    i0.ɵɵpipe(2, "igxTopLevel");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumnCollection));
  }
}
function IgxGridHeaderRowComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-filtering-row", 34, 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r1.width, "px");
    i0.ɵɵproperty("column", ctx_r1.grid.filteringService.filteredColumn);
  }
}
function IgxGridHeaderRowComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
  }
}
function IgxGridHeaderRowComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelement(1, "igx-checkbox", 36, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const context_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("readonly", true)("checked", context_r11.selectedCount > 0 && ctx_r1.grid.selectionService.areAllRowSelected())("disableRipple", true)("ngStyle", i0.ɵɵpureFunction1(7, _c182, ctx_r1.grid.isMultiRowSelectionEnabled ? "visible" : "hidden"))("indeterminate", context_r11.selectedCount > 0 && ctx_r1.grid.selectionService.hasSomeRowSelected())("aria-label", ctx_r1.grid.headSelectorBaseAriaLabel);
  }
}
function _forTrack10($index, $item) {
  return this.trackSummaryResult($item);
}
function IgxSummaryCellComponent_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSummaryCellComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSummaryCellComponent_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultSummary_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate ? ctx_r0.summaryTemplate : defaultSummary_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r0.summaryResults));
  }
}
function IgxSummaryCellComponent_ng_template_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const summary_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r0.itemHeight, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", summary_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translateSummary(summary_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r0.formatSummaryResult(summary_r3));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formatSummaryResult(summary_r3), " ");
  }
}
function IgxSummaryCellComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxSummaryCellComponent_ng_template_1_For_1_Template, 5, 6, "div", 2, _forTrack10, true);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.summaryResults);
  }
}
function IgxSummaryRowComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("pointerdown", function IgxSummaryRowComponent_Conditional_0_Conditional_0_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", ctx_r1.grid.summariesMargin, "px")("flex-basis", ctx_r1.grid.summariesMargin, "px");
  }
}
function IgxSummaryRowComponent_Conditional_0_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSummaryRowComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSummaryRowComponent_Conditional_0_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const summaryCellTemplate_r3 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", summaryCellTemplate_r3)("ngTemplateOutletContext", ctx_r1.getContext(ctx_r1));
  }
}
function IgxSummaryRowComponent_Conditional_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-cell", 6);
  }
  if (rf & 2) {
    const col_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-height", ctx_r1.minHeight, "px")("min-height", ctx_r1.minHeight, "px")("min-width", col_r4.resolvedWidth)("max-width", col_r4.resolvedWidth)("flex-basis", col_r4.resolvedWidth);
    i0.ɵɵclassProp("igx-grid-summary--empty", !col_r4.hasSummary)("igx-grid-summary--pinned-last", col_r4.isLastPinned);
    i0.ɵɵproperty("column", col_r4)("rowIndex", ctx_r1.index)("firstCellIndentation", ctx_r1.firstCellIndentation)("summaryResults", ctx_r1.getColumnSummaries(col_r4.field))("summaryTemplate", col_r4.summaryTemplate)("hasSummary", col_r4.hasSummary)("summaryFormatter", col_r4.summaryFormatter)("active", ctx_r1.isCellActive(col_r4.visibleIndex));
  }
}
function IgxSummaryRowComponent_Conditional_0_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxSummaryRowComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSummaryRowComponent_Conditional_0_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const summaryCellTemplate_r3 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", summaryCellTemplate_r3)("ngTemplateOutletContext", ctx_r1.getContext(ctx_r1));
  }
}
function IgxSummaryRowComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSummaryRowComponent_Conditional_0_Conditional_0_Template, 1, 4, "div", 2)(1, IgxSummaryRowComponent_Conditional_0_Conditional_1_Template, 1, 2, "ng-container")(2, IgxSummaryRowComponent_Conditional_0_ng_template_2_Template, 1, 22, "ng-template", 3, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(4, "igxNotGrouped");
    i0.ɵɵtemplate(5, IgxSummaryRowComponent_Conditional_0_Conditional_5_Template, 1, 2, "ng-container");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.grid.summariesMargin ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && ctx_r1.grid.isPinningToStart ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(4, 9, ctx_r1.unpinnedColumns))("igxForScrollContainer", ctx_r1.grid.parentVirtDir)("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx_r1.grid.unpinnedWidth)("igxForTrackBy", ctx_r1.grid.trackColumnChanges)("igxForSizePropName", "calcPixelWidth");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && !ctx_r1.grid.isPinningToStart ? 5 : -1);
  }
}
function IgxSummaryRowComponent_ng_template_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-cell", 8);
  }
  if (rf & 2) {
    const col_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-height", ctx_r1.minHeight, "px")("min-height", ctx_r1.minHeight, "px")("min-width", col_r5.resolvedWidth)("max-width", col_r5.resolvedWidth)("flex-basis", col_r5.resolvedWidth)("left", col_r5.rightPinnedOffset);
    i0.ɵɵclassProp("igx-grid-summary--empty", !col_r5.hasSummary)("igx-grid-summary--pinned-first", col_r5.isFirstPinned)("igx-grid-summary--pinned-last", col_r5.isLastPinned);
    i0.ɵɵproperty("column", col_r5)("firstCellIndentation", ctx_r1.firstCellIndentation)("rowIndex", ctx_r1.index)("summaryResults", ctx_r1.getColumnSummaries(col_r5.field))("summaryTemplate", col_r5.summaryTemplate)("hasSummary", col_r5.hasSummary)("active", ctx_r1.isCellActive(col_r5.visibleIndex));
  }
}
function IgxSummaryRowComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxSummaryRowComponent_ng_template_1_For_1_Template, 1, 25, "igx-grid-summary-cell", 7, _forTrack9, true);
    i0.ɵɵpipe(2, "igxNotGrouped");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumns));
  }
}
const _c183 = ["*", [["", "igxButton", ""]]];
const _c184 = ["*", "[igxButton]"];
function IgxSnackbarComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function IgxSnackbarComponent_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerAction());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionText, " ");
  }
}
const _forTrack11 = ($index, $item) => $item.fieldName;
function IgxGridGroupByAreaComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 4);
    i0.ɵɵpipe(1, "igxGroupByMeta");
    i0.ɵɵpipe(2, "igxGroupByMeta");
    i0.ɵɵpipe(3, "igxGroupByMeta");
    i0.ɵɵpipe(4, "igxGroupByMeta");
    i0.ɵɵlistener("keyDown", function IgxGridGroupByAreaComponent_For_2_Template_igx_chip_keyDown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event.owner.id, $event.originalEvent));
    })("remove", function IgxGridGroupByAreaComponent_For_2_Template_igx_chip_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearGrouping($event.owner.id));
    })("chipClick", function IgxGridGroupByAreaComponent_For_2_Template_igx_chip_chipClick_0_listener() {
      const expression_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick(expression_r4.fieldName));
    });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "igxGroupByMeta");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "igx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 6);
    i0.ɵɵelement(10, "igx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expression_r4 = ctx.$implicit;
    const ɵ$index_3_r5 = ctx.$index;
    const ɵ$count_3_r6 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", expression_r4.fieldName)("title", i0.ɵɵpipeBind3(1, 8, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).title)("removable", i0.ɵɵpipeBind3(2, 12, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable)("draggable", i0.ɵɵpipeBind3(3, 16, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable)("disabled", !i0.ɵɵpipeBind3(4, 20, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 24, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", expression_r4.dir === 1 ? "sort_asc" : "sort_desc");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ɵ$index_3_r5 === ɵ$count_3_r6 - 1 && !ctx_r2.dropAreaVisible);
  }
}
function IgxGridGroupByAreaComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridGroupByAreaComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 8);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.dropAreaMessage);
  }
}
const _c185 = ["loadingOverlay"];
const _c186 = ["igxLoadingOverlayOutlet"];
const _c187 = ["emptyFilteredGrid"];
const _c188 = ["defaultEmptyGrid"];
const _c189 = ["defaultLoadingGrid"];
const _c190 = ["verticalScrollContainer"];
const _c191 = ["verticalScrollHolder"];
const _c192 = ["scr"];
const _c193 = ["footer"];
const _c194 = ["tbody"];
const _c195 = ["pinContainer"];
const _c196 = ["tfoot"];
const _c197 = ["igxRowEditingOverlayOutlet"];
const _c198 = ["dragIndicatorIconBase"];
const _c199 = ["rowEditingOverlay"];
const _c200 = ["igxFilteringOverlayOutlet"];
const _c201 = ["sink"];
const _c202 = ["defaultExpandedTemplate"];
const _c203 = ["defaultCollapsedTemplate"];
const _c204 = ["defaultESFHeaderIcon"];
const _c205 = ["defaultRowEditTemplate"];
const _c206 = ["summaryRow"];
const _c207 = ["row"];
const _c208 = ["pinnedRow"];
const _c209 = ["groupContent"];
const _c210 = ["defaultGroupByExpandedTemplate"];
const _c211 = ["defaultGroupByCollapsedTemplate"];
const _c212 = (a0, a1, a2) => ({
  selectedCount: a0,
  totalCount: a1,
  groupRow: a2
});
function IgxGridGroupByRowComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "igx-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("visibility", "hidden");
  }
}
function IgxGridGroupByRowComponent_Conditional_3_1_ng_template_0_Template(rf, ctx) {}
function IgxGridGroupByRowComponent_Conditional_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridGroupByRowComponent_Conditional_3_1_ng_template_0_Template, 0, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
  }
}
function IgxGridGroupByRowComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("pointerdown", function IgxGridGroupByRowComponent_Conditional_3_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      return i0.ɵɵresetView($event.preventDefault());
    })("click", function IgxGridGroupByRowComponent_Conditional_3_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onGroupSelectorClick($event));
    });
    i0.ɵɵtemplate(1, IgxGridGroupByRowComponent_Conditional_3_1_Template, 2, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const groupByRowSelectorBaseTemplate_r4 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.grid.groupByRowSelectorTemplate ? ctx_r2.grid.groupByRowSelectorTemplate : groupByRowSelectorBaseTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, i0.ɵɵpureFunction3(2, _c212, ctx_r2.selectedRowsInTheGroup.length, ctx_r2.groupRow.records.length, ctx_r2.groupRow)));
  }
}
function IgxGridGroupByRowComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridGroupByRowComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridGroupByRowComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 15);
  }
}
function IgxGridGroupByRowComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 16);
  }
}
function IgxGridGroupByRowComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "igx-icon", 18);
    i0.ɵɵelementStart(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 20);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "columnFormatter");
    i0.ɵɵpipe(7, "number");
    i0.ɵɵpipe(8, "date");
    i0.ɵɵpipe(9, "currency");
    i0.ɵɵpipe(10, "percent");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "igx-badge", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.groupRow.column && ctx_r2.groupRow.column.header ? ctx_r2.groupRow.column.header : ctx_r2.groupRow.expression ? ctx_r2.groupRow.expression.fieldName : "", ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.formatter ? i0.ɵɵpipeBind4(6, 3, ctx_r2.groupRow.value, ctx_r2.formatter, ctx_r2.groupRow.records[0], null) : ctx_r2.dataType === "number" ? i0.ɵɵpipeBind3(7, 8, ctx_r2.groupRow.value, ctx_r2.groupRow.column.pipeArgs.digitsInfo, ctx_r2.grid.locale) : ctx_r2.dataType === "date" || ctx_r2.dataType === "time" || ctx_r2.dataType === "dateTime" ? i0.ɵɵpipeBind4(8, 12, ctx_r2.groupRow.value, ctx_r2.groupRow.column.pipeArgs.format, ctx_r2.groupRow.column.pipeArgs.timezone, ctx_r2.grid.locale) : ctx_r2.dataType === "currency" ? i0.ɵɵpipeBindV(9, 17, i0.ɵɵpureFunction5(27, _c64, ctx_r2.groupRow.value, ctx_r2.currencyCode, ctx_r2.groupRow.column.pipeArgs.display, ctx_r2.groupRow.column.pipeArgs.digitsInfo, ctx_r2.grid.locale)) : ctx_r2.dataType === "percent" ? i0.ɵɵpipeBind3(10, 23, ctx_r2.groupRow.value, ctx_r2.groupRow.column.pipeArgs.digitsInfo, ctx_r2.grid.locale) : ctx_r2.groupRow.value);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r2.groupRow.records ? ctx_r2.groupRow.records.length : 0);
  }
}
function IgxGridGroupByRowComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "igx-checkbox", 23, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("readonly", true)("checked", ctx_r2.areAllRowsInTheGroupSelected)("disableRipple", true)("indeterminate", ctx_r2.groupByRowCheckboxIndeterminateState)("disabled", ctx_r2.grid.rowSelection === "single")("aria-label", ctx_r2.groupByRowSelectorBaseAriaLabel);
  }
}
const _c213 = ["errorIcon"];
const _c214 = ["defaultError"];
const _c215 = ["defaultCell"];
const _c216 = ["defaultPinnedIndicator"];
const _c217 = ["inlineEditor"];
const _c218 = ["addRowCell"];
const _c219 = ["error"];
const _c220 = (a0, a1) => ({
  "igx-icon--success": a0,
  "igx-icon--error": a1
});
function IgxGridCellComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-chip", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.grid.resourceStrings.igx_grid_pinned_row_indicator);
  }
}
function IgxGridCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_0_Conditional_0_Template, 2, 4, "igx-chip", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayPinnedChip ? 0 : -1);
  }
}
function IgxGridCellComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "columnFormatter");
    i0.ɵɵpipe(8, "number");
    i0.ɵɵpipe(9, "date");
    i0.ɵɵpipe(10, "currency");
    i0.ɵɵpipe(11, "percent");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind4(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData, ctx_r0.columnData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 14, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 18, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 23, i0.ɵɵpureFunction5(57, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 29, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.formatter ? i0.ɵɵpipeBind4(7, 33, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData, ctx_r0.columnData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(8, 38, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(9, 42, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(10, 47, i0.ɵɵpureFunction5(63, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(11, 53, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value);
  }
}
function IgxGridCellComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.value ? "confirm" : "close")("ngClass", i0.ɵɵpureFunction2(2, _c220, ctx_r0.value, !ctx_r0.value));
  }
}
function IgxGridCellComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
    i0.ɵɵpipe(1, "igxCellImageAlt");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.value, i0.ɵɵsanitizeUrl)("alt", i0.ɵɵpipeBind1(1, 2, ctx_r0.value));
  }
}
function IgxGridCellComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_2_Conditional_0_Template, 12, 69, "div", 10)(1, IgxGridCellComponent_ng_template_2_Conditional_1_Template, 1, 5, "igx-icon", 11)(2, IgxGridCellComponent_ng_template_2_Conditional_2_Template, 2, 4, "img", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" && ctx_r0.column.dataType !== "image" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" && !ctx_r0.formatter ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "image" ? 2 : -1);
  }
}
function IgxGridCellComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(32, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(!ctx_r0.isEmptyAddRowCell ? ctx_r0.value : ctx_r0.column.header || ctx_r0.column.field);
  }
}
function IgxGridCellComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_4_Conditional_0_Template, 7, 38, "div", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-input-group")(2, "input", 14);
    i0.ɵɵlistener("compositionstart", function IgxGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionstart_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = true);
    })("compositionend", function IgxGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionend_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = false);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelement(1, "igx-checkbox", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.editValue)("igxFocus", true)("disableRipple", true)("formControl", ctx_r0.formControl);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-date-picker", 17);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridCellComponent_ng_template_6_Conditional_3_Template_igx_date_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("weekStart", ctx_r0.column.pipeArgs.weekStart);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-time-picker", 18);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridCellComponent_ng_template_6_Conditional_4_Template_igx_time_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("locale", ctx_r0.grid.locale)("igxDateTimeEditor", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r0.column.dataType)("displayFormat", ctx_r0.column.pipeArgs.format)("igxFocus", true);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-suffix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵtemplate(1, IgxGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template, 2, 1, "igx-prefix");
    i0.ɵɵelement(2, "input", 15);
    i0.ɵɵtemplate(3, IgxGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template, 2, 1, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.currencyPositionLeft ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.grid.currencyPositionLeft ? 3 : -1);
  }
}
function IgxGridCellComponent_ng_template_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 15);
    i0.ɵɵelementStart(2, "igx-suffix");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "percent");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(4, 8, ctx_r0.editValue, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale), " ");
  }
}
function IgxGridCellComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_6_Conditional_0_Template, 3, 6, "ng-container", 13)(1, IgxGridCellComponent_ng_template_6_Conditional_1_Template, 2, 7, "igx-input-group", 13)(2, IgxGridCellComponent_ng_template_6_Conditional_2_Template, 2, 5, "ng-container", 13)(3, IgxGridCellComponent_ng_template_6_Conditional_3_Template, 2, 11, "ng-container", 13)(4, IgxGridCellComponent_ng_template_6_Conditional_4_Template, 2, 10, "ng-container", 13)(5, IgxGridCellComponent_ng_template_6_Conditional_5_Template, 2, 9, "igx-input-group", 13)(6, IgxGridCellComponent_ng_template_6_Conditional_6_Template, 4, 9, "igx-input-group", 13)(7, IgxGridCellComponent_ng_template_6_Conditional_7_Template, 5, 12, "igx-input-group", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType === "string" || ctx_r0.column.dataType === "image" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "number" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "date" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "time" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "dateTime" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "currency" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "percent" ? 7 : -1);
  }
}
function IgxGridCellComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridCellComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridCellComponent_Conditional_10_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridCellComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 20, 5);
    i0.ɵɵlistener("mouseover", function IgxGridCellComponent_Conditional_10_Template_igx_icon_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = true);
    })("mouseout", function IgxGridCellComponent_Conditional_10_Template_igx_icon_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = false);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 21, 6)(5, "div");
    i0.ɵɵtemplate(6, IgxGridCellComponent_Conditional_10_ng_container_6_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tooltipRef_r6 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultError_r7 = i0.ɵɵreference(12);
    i0.ɵɵproperty("igxTooltipTarget", tooltipRef_r6)("igxToggleOutlet", ctx_r0.grid.outlet);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.ariaErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", "max-content");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellValidationErrorTemplate || defaultError_r7)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_required_validation_error, " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.minlength.requiredLength), " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.maxlength.requiredLength), " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.min.min), " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.max.max), " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_email_validation_error, " ");
  }
}
function IgxGridCellComponent_ng_template_11_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_pattern_validation_error, " ");
  }
}
function IgxGridCellComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_11_Conditional_0_Template, 2, 1, "div")(1, IgxGridCellComponent_ng_template_11_Conditional_1_Template, 3, 5, "div")(2, IgxGridCellComponent_ng_template_11_Conditional_2_Template, 3, 5, "div")(3, IgxGridCellComponent_ng_template_11_Conditional_3_Template, 3, 5, "div")(4, IgxGridCellComponent_ng_template_11_Conditional_4_Template, 3, 5, "div")(5, IgxGridCellComponent_ng_template_11_Conditional_5_Template, 2, 1, "div")(6, IgxGridCellComponent_ng_template_11_Conditional_6_Template, 2, 1, "div");
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_12_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_6_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_6_0["required"]) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_7_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_7_0["minlength"]) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_8_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_8_0["maxlength"]) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_9_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_9_0["min"]) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_10_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_10_0["max"]) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_11_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_11_0["email"]) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_12_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_12_0["pattern"]) ? 6 : -1);
  }
}
const _c221 = ["indicator"];
const _c222 = ["indentationDiv"];
function IgxGridExpandableCellComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-chip", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.grid.resourceStrings.igx_grid_pinned_row_indicator);
  }
}
function IgxGridExpandableCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_0_Conditional_0_Template, 2, 4, "igx-chip", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayPinnedChip ? 0 : -1);
  }
}
function IgxGridExpandableCellComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "columnFormatter");
    i0.ɵɵpipe(8, "number");
    i0.ɵɵpipe(9, "date");
    i0.ɵɵpipe(10, "currency");
    i0.ɵɵpipe(11, "percent");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(55, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formatter ? i0.ɵɵpipeBind3(7, 32, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(8, 36, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(9, 40, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(10, 45, i0.ɵɵpureFunction5(61, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(11, 51, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value, "");
  }
}
function IgxGridExpandableCellComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 15);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.value ? "confirm" : "close")("ngClass", i0.ɵɵpureFunction2(2, _c220, ctx_r0.value, !ctx_r0.value));
  }
}
function IgxGridExpandableCellComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
    i0.ɵɵpipe(1, "igxCellImageAlt");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.value, i0.ɵɵsanitizeUrl)("alt", i0.ɵɵpipeBind1(1, 2, ctx_r0.value));
  }
}
function IgxGridExpandableCellComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_2_Conditional_0_Template, 12, 67, "div", 14)(1, IgxGridExpandableCellComponent_ng_template_2_Conditional_1_Template, 1, 5, "igx-icon", 15)(2, IgxGridExpandableCellComponent_ng_template_2_Conditional_2_Template, 2, 4, "img", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" && ctx_r0.column.dataType !== "image" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" && !ctx_r0.formatter ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "image" ? 2 : -1);
  }
}
function IgxGridExpandableCellComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(32, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value ? ctx_r0.value : ctx_r0.column.header || ctx_r0.column.field, " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_4_Conditional_0_Template, 7, 38, "div", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵelementStart(1, "igx-input-group")(2, "input", 19);
    i0.ɵɵlistener("compositionstart", function IgxGridExpandableCellComponent_ng_template_6_Conditional_0_Template_input_compositionstart_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = true);
    })("compositionend", function IgxGridExpandableCellComponent_ng_template_6_Conditional_0_Template_input_compositionend_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = false);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 17);
    i0.ɵɵelement(1, "input", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵelement(1, "igx-checkbox", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.editValue)("igxFocus", true)("disableRipple", true)("formControl", ctx_r0.formControl);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵelementStart(1, "igx-date-picker", 22);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridExpandableCellComponent_ng_template_6_Conditional_3_Template_igx_date_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("weekStart", ctx_r0.column.pipeArgs.weekStart);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵelementStart(1, "igx-time-picker", 23);
    i0.ɵɵtwoWayListener("valueChange", function IgxGridExpandableCellComponent_ng_template_6_Conditional_4_Template_igx_time_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 17);
    i0.ɵɵelement(1, "input", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("locale", ctx_r0.grid.locale)("igxDateTimeEditor", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r0.column.dataType)("displayFormat", ctx_r0.column.pipeArgs.format)("igxFocus", true);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-suffix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 17);
    i0.ɵɵtemplate(1, IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Conditional_1_Template, 2, 1, "igx-prefix");
    i0.ɵɵelement(2, "input", 20);
    i0.ɵɵtemplate(3, IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Conditional_3_Template, 2, 1, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.currencyPositionLeft ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.grid.currencyPositionLeft ? 3 : -1);
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 17);
    i0.ɵɵelement(1, "input", 20);
    i0.ɵɵelementStart(2, "igx-suffix");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "percent");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(4, 9, ctx_r0.editValue, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale), " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_6_Conditional_0_Template, 3, 7, "ng-container", 17)(1, IgxGridExpandableCellComponent_ng_template_6_Conditional_1_Template, 2, 8, "igx-input-group", 18)(2, IgxGridExpandableCellComponent_ng_template_6_Conditional_2_Template, 2, 5, "ng-container", 17)(3, IgxGridExpandableCellComponent_ng_template_6_Conditional_3_Template, 2, 11, "ng-container", 17)(4, IgxGridExpandableCellComponent_ng_template_6_Conditional_4_Template, 2, 10, "ng-container", 17)(5, IgxGridExpandableCellComponent_ng_template_6_Conditional_5_Template, 2, 9, "igx-input-group", 17)(6, IgxGridExpandableCellComponent_ng_template_6_Conditional_6_Template, 4, 10, "igx-input-group", 18)(7, IgxGridExpandableCellComponent_ng_template_6_Conditional_7_Template, 5, 13, "igx-input-group", 18);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType === "string" || ctx_r0.column.dataType === "image" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "number" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "date" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "time" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "dateTime" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "currency" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "percent" ? 7 : -1);
  }
}
function IgxGridExpandableCellComponent_Conditional_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridExpandableCellComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25, 7);
    i0.ɵɵlistener("click", function IgxGridExpandableCellComponent_Conditional_8_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggle($event));
    })("focus", function IgxGridExpandableCellComponent_Conditional_8_Template_div_focus_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onIndicatorFocus());
    });
    i0.ɵɵtemplate(2, IgxGridExpandableCellComponent_Conditional_8_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c25, ctx_r0.row));
  }
}
function IgxGridExpandableCellComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridExpandableCellComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridExpandableCellComponent_Conditional_11_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridExpandableCellComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 26, 8);
    i0.ɵɵlistener("mouseover", function IgxGridExpandableCellComponent_Conditional_11_Template_igx_icon_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = true);
    })("mouseout", function IgxGridExpandableCellComponent_Conditional_11_Template_igx_icon_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = false);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 27, 9)(5, "div");
    i0.ɵɵtemplate(6, IgxGridExpandableCellComponent_Conditional_11_ng_container_6_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tooltipRef_r7 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultError_r8 = i0.ɵɵreference(17);
    i0.ɵɵproperty("igxTooltipTarget", tooltipRef_r7)("igxToggleOutlet", ctx_r0.grid.outlet);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.ariaErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", "max-content");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellValidationErrorTemplate || defaultError_r8)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxGridExpandableCellComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 28);
  }
}
function IgxGridExpandableCellComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 29);
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_required_validation_error, " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.minlength.requiredLength), " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.maxlength.requiredLength), " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.min.min), " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.max.max), " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_email_validation_error, " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_pattern_validation_error, " ");
  }
}
function IgxGridExpandableCellComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_16_Conditional_0_Template, 2, 1, "div")(1, IgxGridExpandableCellComponent_ng_template_16_Conditional_1_Template, 3, 5, "div")(2, IgxGridExpandableCellComponent_ng_template_16_Conditional_2_Template, 3, 5, "div")(3, IgxGridExpandableCellComponent_ng_template_16_Conditional_3_Template, 3, 5, "div")(4, IgxGridExpandableCellComponent_ng_template_16_Conditional_4_Template, 3, 5, "div")(5, IgxGridExpandableCellComponent_ng_template_16_Conditional_5_Template, 2, 1, "div")(6, IgxGridExpandableCellComponent_ng_template_16_Conditional_6_Template, 2, 1, "div");
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_12_0;
    let tmp_13_0;
    let tmp_14_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_8_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_8_0["required"]) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_9_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_9_0["minlength"]) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_10_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_10_0["maxlength"]) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_11_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_11_0["min"]) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_12_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_12_0["max"]) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_13_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_13_0["email"]) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_14_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_14_0["pattern"]) ? 6 : -1);
  }
}
const _c223 = (a0, a1, a2, a3) => ({
  index: a0,
  rowID: a1,
  key: a2,
  selected: a3
});
const _c224 = (a0, a1, a2) => ({
  "grid-template-rows": a0,
  "grid-template-columns": a1,
  "z-index": a2
});
const _c225 = (a0, a1, a2, a3, a4, a5, a6) => [a0, a1, a2, a3, a4, a5, a6];
function IgxGridRowComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("animationend", function IgxGridRowComponent_ng_template_1_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.animationEndHandler());
    });
    i0.ɵɵtemplate(1, IgxGridRowComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultTemp_r3 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("igx-grid__tr--add-animate", ctx_r1.triggerAddAnimationClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultTemp_r3);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function IgxGridRowComponent_ng_template_3_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtemplate(1, IgxGridRowComponent_ng_template_3_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.resolveDragIndicatorClasses);
    i0.ɵɵproperty("igxRowDrag", ctx_r1)("ghostTemplate", ctx_r1.grid.getDragGhostCustomTemplate());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.dragIndicatorIconTemplate ? ctx_r1.grid.dragIndicatorIconTemplate : ctx_r1.grid.dragIndicatorIconBase);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function IgxGridRowComponent_ng_template_3_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("pointerdown", function IgxGridRowComponent_ng_template_3_Conditional_1_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.preventDefault());
    })("click", function IgxGridRowComponent_ng_template_3_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRowSelectorClick($event));
    });
    i0.ɵɵtemplate(1, IgxGridRowComponent_ng_template_3_Conditional_1_1_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const rowSelectorBaseTemplate_r6 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.rowSelectorTemplate ? ctx_r1.grid.rowSelectorTemplate : rowSelectorBaseTemplate_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c25, i0.ɵɵpureFunction4(2, _c223, ctx_r1.viewIndex, ctx_r1.key, ctx_r1.key, ctx_r1.selected)));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("pointerdown", function IgxGridRowComponent_ng_template_3_Conditional_2_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.preventDefault());
    })("click", function IgxGridRowComponent_ng_template_3_Conditional_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("igx-grid__row-indentation igx-grid__row-indentation--level-", ctx_r1.grid.groupingExpressions.length, "");
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_For_1_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const col_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const cellTemplate_r9 = i0.ɵɵreference(10);
    const expandableCellTemplate_r10 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", col_r8.visibleIndex === 0 && ctx_r1.grid.hasDetails ? expandableCellTemplate_r10 : cellTemplate_r9)("ngTemplateOutletContext", ctx_r1.getContext(col_r8, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_For_1_Template, 1, 2, "ng-container", null, _forTrack9, true);
    i0.ɵɵpipe(2, "igxNotGrouped");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumns));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_3_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const col_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const cellTemplate_r9 = i0.ɵɵreference(10);
    const expandableCellTemplate_r10 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", col_r11.visibleIndex === 0 && ctx_r1.grid.hasDetails ? expandableCellTemplate_r10 : cellTemplate_r9)("ngTemplateOutletContext", ctx_r1.getContext(col_r11, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_For_1_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const col_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const cellTemplate_r9 = i0.ɵɵreference(10);
    const expandableCellTemplate_r10 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", col_r12.visibleIndex === 0 && ctx_r1.grid.hasDetails ? expandableCellTemplate_r10 : cellTemplate_r9)("ngTemplateOutletContext", ctx_r1.getContext(col_r12, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_For_1_Template, 1, 2, "ng-container", null, _forTrack9, true);
    i0.ɵɵpipe(2, "igxNotGrouped");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumns));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_0_Template, 3, 2)(1, IgxGridRowComponent_ng_template_3_Conditional_3_ng_template_1_Template, 1, 2, "ng-template", 19, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(3, "igxNotGrouped");
    i0.ɵɵtemplate(4, IgxGridRowComponent_ng_template_3_Conditional_3_Conditional_4_Template, 3, 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && ctx_r1.grid.isPinningToStart ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(3, 8, ctx_r1.unpinnedColumns))("igxForScrollContainer", ctx_r1.grid.parentVirtDir)("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx_r1.grid.unpinnedWidth)("igxForSizePropName", "calcPixelWidth")("igxForTrackBy", ctx_r1.grid.trackColumnChanges);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && !ctx_r1.grid.isPinningToStart ? 4 : -1);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const mrlPinnedTemplate_r13 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", mrlPinnedTemplate_r13)("ngTemplateOutletContext", ctx_r1.getContextMRL(ctx_r1.pinnedColumns, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_For_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_For_2_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const col_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const mrlCellTemplate_r15 = i0.ɵɵreference(14);
    const mrlExpandableCellTemplate_r16 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", col_r14.visibleIndex === 0 && ctx_r1.grid.hasDetails ? mrlExpandableCellTemplate_r16 : mrlCellTemplate_r15)("ngTemplateOutletContext", ctx_r1.getContext(col_r14, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵrepeaterCreate(1, IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_For_2_Template, 1, 2, "ng-container", null, _forTrack9, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r17 = ctx.$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(1, _c164, col_r17.getGridTemplate(true), col_r17.getGridTemplate(false)));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(col_r17.children);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const mrlPinnedTemplate_r13 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", mrlPinnedTemplate_r13)("ngTemplateOutletContext", ctx_r1.getContextMRL(ctx_r1.pinnedColumns, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_0_Template, 1, 2, "ng-container")(1, IgxGridRowComponent_ng_template_3_Conditional_4_ng_template_1_Template, 3, 4, "ng-template", 19, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(3, "igxTopLevel");
    i0.ɵɵtemplate(4, IgxGridRowComponent_ng_template_3_Conditional_4_Conditional_4_Template, 1, 2, "ng-container");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && ctx_r1.grid.isPinningToStart ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(3, 8, ctx_r1.unpinnedColumns))("igxForScrollContainer", ctx_r1.grid.parentVirtDir)("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx_r1.grid.unpinnedWidth)("igxForSizePropName", "calcPixelWidth")("igxForTrackBy", ctx_r1.grid.trackColumnChanges);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && !ctx_r1.grid.isPinningToStart ? 4 : -1);
  }
}
function IgxGridRowComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_3_Conditional_0_Template, 2, 5, "div", 12)(1, IgxGridRowComponent_ng_template_3_Conditional_1_Template, 2, 9, "div", 13)(2, IgxGridRowComponent_ng_template_3_Conditional_2_Template, 1, 3, "div", 14)(3, IgxGridRowComponent_ng_template_3_Conditional_3_Template, 5, 10)(4, IgxGridRowComponent_ng_template_3_Conditional_4_Template, 5, 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.rowDraggable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showRowSelectors ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.grid.groupingExpressions.length > 0 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.grid.hasColumnLayouts ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.grid.hasColumnLayouts ? 4 : -1);
  }
}
function IgxGridRowComponent_ng_template_5_For_1_For_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridRowComponent_ng_template_5_For_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridRowComponent_ng_template_5_For_1_For_2_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const col_r18 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const mrlCellTemplate_r15 = i0.ɵɵreference(14);
    const mrlExpandableCellTemplate_r16 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", col_r18.visibleIndex === 0 && ctx_r1.grid.hasDetails ? mrlExpandableCellTemplate_r16 : mrlCellTemplate_r15)("ngTemplateOutletContext", ctx_r1.getContext(col_r18, ctx_r1));
  }
}
function IgxGridRowComponent_ng_template_5_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵrepeaterCreate(1, IgxGridRowComponent_ng_template_5_For_1_For_2_Template, 1, 2, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r19 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("left", ctx_r1.mrlRightPinnedOffset);
    i0.ɵɵclassProp("igx-grid__td--pinned-last", col_r19.hasLastPinnedChildColumn)("igx-grid__td--pinned-first", col_r19.hasFirstPinnedChildColumn);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(7, _c224, col_r19.getGridTemplate(true), col_r19.getGridTemplate(false), col_r19.pinned ? 1 : null));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(col_r19.children);
  }
}
function IgxGridRowComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxGridRowComponent_ng_template_5_For_1_Template, 3, 11, "div", 21, _forTrack9, true);
    i0.ɵɵpipe(2, "igxTopLevel");
  }
  if (rf & 2) {
    const pinnedColumns_r20 = ctx.$implicit;
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, pinnedColumns_r20));
  }
}
function IgxGridRowComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "igx-checkbox", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("checked", ctx_r1.selected)("readonly", true)("disabled", ctx_r1.deleted)("disableRipple", true)("disableTransitions", ctx_r1.grid.disableTransitions)("aria-label", ctx_r1.rowCheckboxAriaLabel);
  }
}
function IgxGridRowComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-cell", 24, 9);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r21 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", col_r21.resolvedWidth)("max-width", col_r21.resolvedWidth)("flex-basis", col_r21.resolvedWidth)("left", col_r21.rightPinnedOffset);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 36, i0.ɵɵpureFunction7(64, _c225, ctx_r1.key, col_r21.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--pinned", col_r21.pinned)("igx-grid__td--number", col_r21.dataType === "number" || col_r21.dataType === "percent" || col_r21.dataType === "currency")("igx-grid__td--bool", col_r21.dataType === "boolean")("igx-grid__td--image", col_r21.dataType === "image");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 44, i0.ɵɵpureFunction6(72, _c63, col_r21.cellClasses, ctx_r1.data[col_r21.field], ctx_r1.data, col_r21.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 51, i0.ɵɵpureFunction6(79, _c63, col_r21.cellStyles, ctx_r1.data[col_r21.field], ctx_r1.data, col_r21.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("editMode", col_r21.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r21.index))("column", col_r21)("formatter", col_r21.formatter)("intRow", ctx_r1)("lastPinned", col_r21.columnLayoutChild ? null : col_r21.isLastPinned)("firstPinned", col_r21.columnLayoutChild ? null : col_r21.isFirstPinned)("rowData", ctx_r1.data)("width", col_r21.getCellWidth())("visibleColumnIndex", col_r21.visibleIndex)("value", i0.ɵɵpipeBindV(5, 58, i0.ɵɵpureFunction5(86, _c64, ctx_r1.data, col_r21.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r21.field], col_r21.hasNestedPath)))("cellTemplate", col_r21.bodyTemplate)("cellValidationErrorTemplate", col_r21.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r21.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r21.visibleIndex));
  }
}
function IgxGridRowComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-expandable-grid-cell", 25, 9);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r22 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", col_r22.resolvedWidth)("max-width", col_r22.resolvedWidth)("flex-basis", col_r22.resolvedWidth);
    i0.ɵɵclassProp("igx-grid__td--pinned", col_r22.pinned)("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 30, i0.ɵɵpureFunction7(58, _c225, ctx_r1.key, col_r22.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", (col_r22.dataType === "number" || col_r22.dataType === "percent" || col_r22.dataType === "currency") && col_r22.visibleIndex !== 0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 38, i0.ɵɵpureFunction6(66, _c63, col_r22.cellClasses, ctx_r1.data[col_r22.field], ctx_r1.data, col_r22.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 45, i0.ɵɵpureFunction6(73, _c63, col_r22.cellStyles, ctx_r1.data[col_r22.field], ctx_r1.data, col_r22.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("expanded", ctx_r1.expanded)("editMode", col_r22.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r22.index))("column", col_r22)("formatter", col_r22.formatter)("intRow", ctx_r1)("lastPinned", col_r22.columnLayoutChild ? null : col_r22.isLastPinned)("rowData", ctx_r1.data)("width", col_r22.getCellWidth())("visibleColumnIndex", col_r22.visibleIndex)("value", i0.ɵɵpipeBindV(5, 52, i0.ɵɵpureFunction5(80, _c64, ctx_r1.data, col_r22.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r22.field], col_r22.hasNestedPath)))("cellTemplate", col_r22.bodyTemplate)("cellValidationErrorTemplate", col_r22.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r22.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r22.visibleIndex));
  }
}
function IgxGridRowComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-cell", 26, 9);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r23 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("grid-row-end", col_r23.rowEnd)("grid-column-end", col_r23.colEnd)("grid-row-start", col_r23.rowStart)("grid-column-start", col_r23.colStart);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 31, i0.ɵɵpureFunction7(59, _c225, ctx_r1.key, col_r23.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--pinned", col_r23.pinned)("igx-grid__td--number", col_r23.dataType === "number" || col_r23.dataType === "percent" || col_r23.dataType === "currency");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 39, i0.ɵɵpureFunction6(67, _c63, col_r23.cellClasses, ctx_r1.data[col_r23.field], ctx_r1.data, col_r23.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 46, i0.ɵɵpureFunction6(74, _c63, col_r23.cellStyles, ctx_r1.data[col_r23.field], ctx_r1.data, col_r23.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("editMode", col_r23.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r23.index))("column", col_r23)("lastPinned", col_r23.columnLayoutChild ? null : col_r23.isLastPinned)("firstPinned", col_r23.columnLayoutChild ? null : col_r23.isFirstPinned)("formatter", col_r23.formatter)("intRow", ctx_r1)("rowData", ctx_r1.data)("visibleColumnIndex", col_r23.visibleIndex)("value", i0.ɵɵpipeBindV(5, 53, i0.ɵɵpureFunction5(81, _c64, ctx_r1.data, col_r23.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r23.field], col_r23.hasNestedPath)))("cellTemplate", col_r23.bodyTemplate)("cellValidationErrorTemplate", col_r23.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r23.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r23.visibleIndex));
  }
}
function IgxGridRowComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-expandable-grid-cell", 27, 9);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r24 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("grid-row-end", col_r24.rowEnd)("grid-column-end", col_r24.colEnd)("grid-row-start", col_r24.rowStart)("grid-column-start", col_r24.colStart);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 31, i0.ɵɵpureFunction7(59, _c225, ctx_r1.key, col_r24.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--pinned", col_r24.pinned)("igx-grid__td--number", (col_r24.dataType === "number" || col_r24.dataType === "percent" || col_r24.dataType === "currency") && col_r24.visibleIndex !== 0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 39, i0.ɵɵpureFunction6(67, _c63, col_r24.cellClasses, ctx_r1.data[col_r24.field], ctx_r1.data, col_r24.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 46, i0.ɵɵpureFunction6(74, _c63, col_r24.cellStyles, ctx_r1.data[col_r24.field], ctx_r1.data, col_r24.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("expanded", ctx_r1.expanded)("editMode", col_r24.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r24.index))("column", col_r24)("lastPinned", col_r24.columnLayoutChild ? null : col_r24.isLastPinned)("formatter", col_r24.formatter)("intRow", ctx_r1)("rowData", ctx_r1.data)("visibleColumnIndex", col_r24.visibleIndex)("value", i0.ɵɵpipeBindV(5, 53, i0.ɵɵpureFunction5(81, _c64, ctx_r1.data, col_r24.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r24.field], col_r24.hasNestedPath)))("cellTemplate", col_r24.bodyTemplate)("cellValidationErrorTemplate", col_r24.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r24.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r24.visibleIndex));
  }
}
const _c226 = ["record_template"];
const _c227 = ["detail_template_container"];
const _c228 = ["group_template"];
const _c229 = ["summary_template"];
const _c230 = [[["igx-grid-toolbar"], ["igc-grid-toolbar"]], [["igx-grid-footer"], ["igc-grid-footer"]], [["igx-paginator"], ["igc-paginator"]], [["igx-grid-state"], ["igc-grid-state"]], [["igx-column"], ["igc-column"], ["igx-column-group"], ["igc-column-group"], ["igx-column-layout"], ["igc-column-layout"], ["igx-action-strip"], ["igc-action-strip"]]];
const _c231 = ["igx-grid-toolbar,igc-grid-toolbar", "igx-grid-footer,igc-grid-footer", "igx-paginator,igc-paginator", "igx-grid-state,igc-grid-state", "igx-column,igc-column,igx-column-group,igc-column-group,igx-column-layout,igc-column-layout,igx-action-strip,igc-action-strip"];
const _c232 = (a0, a1, a2, a3, a4, a5, a6, a7) => [a0, a1, a2, a3, a4, a5, a6, a7];
const _c233 = (a0, a1, a2, a3, a4, a5, a6) => [a0, a1, a2, a3, a4, a5, a6, true];
const _c234 = (a0, a1, a2, a3, a4, a5) => [a0, a1, a2, a3, a4, a5, true];
const _c235 = (a0, a1) => ({
  "igx-grid__tr--pinned-bottom": a0,
  "igx-grid__tr--pinned-top": a1
});
const _c236 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) => [a0, a1, a2, a3, a4, a5, a6, a7, a8, false, a9, a10];
const _c237 = a0 => ({
  "igx-grid__tr-container": true,
  "igx-grid__tr-container--active": a0
});
const _c238 = a0 => ({
  "igx-grid__group-expand-btn": true,
  "igx-grid__group-expand-btn--push": a0
});
const _c239 = (a0, a1) => ({
  rowChangesCount: a0,
  endEdit: a1
});
function IgxGridComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-group-by-area", 70, 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex-basis", ctx_r1.outerWidth, "px");
    i0.ɵɵproperty("grid", ctx_r1)("expressions", ctx_r1.groupingExpressions)("sortingExpressions", ctx_r1.sortingExpressions)("dropAreaTemplate", ctx_r1.dropAreaTemplate)("dropAreaMessage", ctx_r1.dropAreaMessage);
  }
}
function IgxGridComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 41);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxGridComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 71);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxGridComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_ng_container_0_Template, 1, 0, "ng-container", 45);
  }
  if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    const ɵ$index_33_r4 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const pinned_record_template_r5 = i0.ɵɵreference(27);
    i0.ɵɵproperty("ngTemplateOutlet", pinned_record_template_r5)("ngTemplateOutletContext", ctx_r1.getContext(rowData_r3, ɵ$index_33_r4, true));
  }
}
function IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73, 30);
    i0.ɵɵrepeaterCreate(2, IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_Template, 1, 2, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pinnedData_r6 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c235, !ctx_r1.isRowPinningToTop, ctx_r1.isRowPinningToTop));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(pinnedData_r6);
  }
}
function IgxGridComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridComponent_ng_template_9_Conditional_0_Conditional_0_Template, 4, 6, "div", 72);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length > 0 ? 0 : -1);
  }
}
function IgxGridComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxGridComponent_ng_template_9_Conditional_0_Template, 1, 1);
    i0.ɵɵpipe(1, "gridTransaction");
    i0.ɵɵpipe(2, "visibleColumns");
    i0.ɵɵpipe(3, "gridAddRow");
    i0.ɵɵpipe(4, "gridRowPinning");
    i0.ɵɵpipe(5, "gridFiltering");
    i0.ɵɵpipe(6, "gridSort");
  }
  if (rf & 2) {
    let tmp_30_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_30_0 = i0.ɵɵpipeBindV(6, 26, i0.ɵɵpureFunction6(42, _c234, i0.ɵɵpipeBindV(5, 17, i0.ɵɵpureFunction7(34, _c233, i0.ɵɵpipeBind4(4, 12, i0.ɵɵpipeBind3(3, 8, i0.ɵɵpipeBind2(2, 5, i0.ɵɵpipeBind3(1, 1, ctx_r1.data, ctx_r1.id, ctx_r1.pipeTrigger), ctx_r1.hasVisibleColumns), true, ctx_r1.pipeTrigger), ctx_r1.id, true, ctx_r1.pipeTrigger), ctx_r1.filteringExpressionsTree, ctx_r1.filterStrategy, ctx_r1.advancedFilteringExpressionsTree, ctx_r1.id, ctx_r1.pipeTrigger, ctx_r1.filteringPipeTrigger)), ctx_r1.sortingExpressions, ctx_r1.groupingExpressions, ctx_r1.sortStrategy, ctx_r1.id, ctx_r1.pipeTrigger))) ? 0 : -1, tmp_30_0);
  }
}
function IgxGridComponent_ng_template_11_ng_template_0_Template(rf, ctx) {}
function IgxGridComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxGridComponent_ng_template_11_ng_template_0_Template, 0, 0, "ng-template", 74);
    i0.ɵɵlistener("cachedViewLoaded", function IgxGridComponent_ng_template_11_Template_ng_template_cachedViewLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cachedViewLoaded($event));
    })("viewCreated", function IgxGridComponent_ng_template_11_Template_ng_template_viewCreated_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.viewCreatedHandler($event));
    })("viewMoved", function IgxGridComponent_ng_template_11_Template_ng_template_viewMoved_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.viewMovedHandler($event));
    });
  }
  if (rf & 2) {
    const rowData_r8 = ctx.$implicit;
    const rowIndex_r9 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxTemplateOutlet", ctx_r1.getRowTemplate(rowData_r8))("igxTemplateOutletContext", ctx_r1.getContext(rowData_r8, rowIndex_r9));
  }
}
function IgxGridComponent_ng_container_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-row", 75, 31);
    i0.ɵɵpipe(2, "igxGridRowClasses");
    i0.ɵɵpipe(3, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r10 = ctx.index;
    const rowData_r11 = ctx.$implicit;
    const disabledRow_r12 = ctx.disabled;
    const row_r13 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r10)("data", rowData_r11)("disabled", disabledRow_r12)("ngClass", i0.ɵɵpipeBindV(2, 6, i0.ɵɵpureFunctionV(24, _c236, [ctx_r1.rowClasses, row_r13, row_r13.inEditMode, row_r13.selected, row_r13.dirty, row_r13.deleted, row_r13.dragging, rowIndex_r10, ctx_r1.hasColumnLayouts, rowData_r11, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(3, 19, ctx_r1.rowStyles, rowData_r11, rowIndex_r10, ctx_r1.pipeTrigger));
  }
}
function IgxGridComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-row", 76, 32);
    i0.ɵɵpipe(3, "igxGridRowClasses");
    i0.ɵɵpipe(4, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r14 = ctx.index;
    const rowData_r15 = ctx.$implicit;
    const row_r16 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r14)("data", rowData_r15)("ngClass", i0.ɵɵpipeBindV(3, 5, i0.ɵɵpureFunctionV(23, _c236, [ctx_r1.rowClasses, row_r16, row_r16.inEditMode, row_r16.selected, row_r16.dirty, row_r16.deleted, row_r16.dragging, rowIndex_r14, ctx_r1.hasColumnLayouts, rowData_r15, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(4, 18, ctx_r1.rowStyles, rowData_r15, rowIndex_r14, ctx_r1.pipeTrigger));
  }
}
function IgxGridComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-groupby-row", 77, 31);
  }
  if (rf & 2) {
    const rowIndex_r17 = ctx.index;
    const rowData_r18 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r17)("groupRow", rowData_r18)("hideGroupRowSelectors", ctx_r1.hideRowSelectors)("rowDraggable", ctx_r1.rowDraggable);
  }
}
function IgxGridComponent_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-row", 78, 33);
  }
  if (rf & 2) {
    const rowIndex_r19 = ctx.index;
    const rowData_r20 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("summaries", rowData_r20.summaries)("index", rowIndex_r19);
  }
}
function IgxGridComponent_ng_template_32_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("igx-grid__row-indentation igx-grid__row-indentation--level-", ctx_r1.groupingExpressions.length, "");
  }
}
function IgxGridComponent_ng_template_32_ng_template_4_Template(rf, ctx) {}
function IgxGridComponent_ng_template_32_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 79, 34);
    i0.ɵɵlistener("pointerdown", function IgxGridComponent_ng_template_32_Template_div_pointerdown_0_listener() {
      const rowIndex_r22 = i0.ɵɵrestoreView(_r21).index;
      const detailsContainer_r23 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.detailsViewFocused(detailsContainer_r23, rowIndex_r22));
    });
    i0.ɵɵelementStart(2, "div", 80);
    i0.ɵɵtemplate(3, IgxGridComponent_ng_template_32_Conditional_3_Template, 1, 3, "div", 81)(4, IgxGridComponent_ng_template_32_ng_template_4_Template, 0, 0, "ng-template", 82);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rowIndex_r22 = ctx.index;
    const rowData_r24 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.id, "_", rowIndex_r22, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c237, ctx_r1.isDetailActive(rowIndex_r22)));
    i0.ɵɵattribute("data-rowindex", rowIndex_r22);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.groupingExpressions.length > 0 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.detailTemplate)("ngTemplateOutletContext", ctx_r1.getDetailsContext(rowData_r24, rowIndex_r22));
  }
}
function IgxGridComponent_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_Conditional_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 48);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxGridComponent_Conditional_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 49);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxGridComponent_ng_template_44_Template(rf, ctx) {}
function IgxGridComponent_Conditional_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-row", 83, 33);
    i0.ɵɵpipe(2, "igxGridSummaryDataPipe");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px")("height", ctx_r1.summaryRowHeight, "px");
    i0.ɵɵproperty("gridID", ctx_r1.id)("summaries", i0.ɵɵpipeBind2(2, 7, ctx_r1.id, ctx_r1.summaryService.retriggerRootPipe))("index", ctx_r1.dataView.length);
  }
}
function IgxGridComponent_ng_template_64_Template(rf, ctx) {}
function IgxGridComponent_ng_template_71_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_71_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxGridComponent_ng_template_71_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 43);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r25 = i0.ɵɵreference(76);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r25);
  }
}
function IgxGridComponent_ng_template_71_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 84)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxGridComponent_ng_template_71_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyFilteredGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxGridComponent_ng_template_73_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_73_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxGridComponent_ng_template_73_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 43);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r25 = i0.ɵɵreference(76);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r25);
  }
}
function IgxGridComponent_ng_template_73_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 84)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxGridComponent_ng_template_73_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxGridComponent_ng_template_75_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 85);
    i0.ɵɵlistener("click", function IgxGridComponent_ng_template_75_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.crudService.enterAddRowMode(null, false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.resourceStrings.igx_grid_add_row_label, " ");
  }
}
function IgxGridComponent_ng_template_77_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelement(1, "igx-circular-bar", 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxGridComponent_ng_template_79_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 87);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c238, ctx_r1.filteringService.isFilterRowVisible));
  }
}
function IgxGridComponent_ng_template_81_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 88);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c238, ctx_r1.filteringService.isFilterRowVisible));
  }
}
function IgxGridComponent_Conditional_83_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_Conditional_83_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47, 35)(2, "div", 89);
    i0.ɵɵtemplate(3, IgxGridComponent_Conditional_83_ng_container_3_Template, 1, 0, "ng-container", 45);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("className", ctx_r1.bannerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rowEditContainer)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c239, ctx_r1.rowChangesCount, ctx_r1.endEdit.bind(ctx_r1)));
  }
}
function IgxGridComponent_ng_template_84_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "igxStringReplace");
    i0.ɵɵpipe(2, "igxStringReplace");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 5, i0.ɵɵpipeBind3(1, 1, ctx_r1.resourceStrings.igx_grid_row_edit_text, "{0}", ctx_r1.rowChangesCount.toString()), "{1}", ctx_r1.hiddenColumnsCount.toString()), "\n");
  }
}
function IgxGridComponent_ng_template_86_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 90);
    i0.ɵɵlistener("click", function IgxGridComponent_ng_template_86_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 90);
    i0.ɵɵlistener("click", function IgxGridComponent_ng_template_86_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(true, $event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_cancel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_done);
  }
}
function IgxGridComponent_ng_template_88_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_88_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridComponent_ng_template_88_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91)(1, "span", 92);
    i0.ɵɵtemplate(2, IgxGridComponent_ng_template_88_ng_container_2_Template, 1, 0, "ng-container", 45);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 93)(4, "div", 94);
    i0.ɵɵtemplate(5, IgxGridComponent_ng_template_88_ng_container_5_Template, 1, 0, "ng-container", 45);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultRowEditText_r28 = i0.ɵɵreference(85);
    const defaultRowEditActions_r29 = i0.ɵɵreference(87);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) === "IgxAddRow" ? ctx_r1.rowAddTextTemplate : ctx_r1.rowEditTextTemplate ? ctx_r1.rowEditTextTemplate : defaultRowEditText_r28)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c25, (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) !== "IgxAddRow" ? ctx_r1.rowChangesCount : null));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rowEditActionsTemplate ? ctx_r1.rowEditActionsTemplate : defaultRowEditActions_r29)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx_r1.endEdit.bind(ctx_r1)));
  }
}
function IgxGridComponent_ng_template_90_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 95);
  }
}
function IgxGridComponent_Conditional_92_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-column-resizer");
  }
}
function IgxGridComponent_Conditional_95_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69, 36);
    i0.ɵɵprojection(2, 3);
    i0.ɵɵprojection(3, 4);
    i0.ɵɵelementEnd();
  }
}
function IgxPivotRowDimensionHeaderComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.column.header || ctx_r0.column.field);
  }
}
function IgxPivotRowDimensionHeaderComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 8);
  }
}
function IgxPivotRowDimensionHeaderComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxPivotRowDimensionHeaderComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 3);
    i0.ɵɵpipe(2, "sortingIndex");
    i0.ɵɵlistener("pointerdown", function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onPointerDownIndicator($event));
    })("click", function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onSortingIconClick($event));
    });
    i0.ɵɵtemplate(3, IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-sortIndex", ctx_r0.grid.sortingOptions.mode === "single" && ctx_r0.grid.sortingExpressions.length <= 1 ? null : i0.ɵɵpipeBind2(2, 3, ctx_r0.column.field, ctx_r0.grid.sortingExpressions));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sortIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx_r0));
  }
}
function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("pointerdown", function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onPointerDownIndicator($event));
    })("click", function IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFilteringIconClick($event));
    });
    i0.ɵɵtemplate(1, IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.filterIconClassName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.esfIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c25, ctx_r0));
  }
}
function IgxPivotRowDimensionHeaderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_1_Template, 4, 8, "div", 10)(2, IgxPivotRowDimensionHeaderComponent_Conditional_8_Conditional_2_Template, 2, 5, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.sortable && !ctx_r0.disabled ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.allowFiltering && ctx_r0.column.filterable && ctx_r0.grid.filterMode === "excelStyleFilter" ? 2 : -1);
  }
}
function IgxPivotRowHeaderGroupComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.column.header);
  }
}
function IgxPivotRowHeaderGroupComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.column.expanded ? "tree_collapse" : "tree_expand");
  }
}
function IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
function IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("cursor", ctx_r0.colResizingService.resizeCursor);
    i0.ɵɵproperty("igxPivotResizeHandle", ctx_r0.column)("igxPivotResizeHandleHeader", ctx_r0);
    i0.ɵɵattribute("draggable", false);
  }
}
function IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
}
function IgxPivotRowHeaderGroupComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_0_Template, 1, 0, "span", 4);
    i0.ɵɵelementStart(1, "igx-pivot-row-dimension-header", 5);
    i0.ɵɵpipe(2, "igxHeaderGroupStyle");
    i0.ɵɵlistener("pointerdown", function IgxPivotRowHeaderGroupComponent_Conditional_4_Template_igx_pivot_row_dimension_header_pointerdown_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.pointerdown($event));
    })("keydown", function IgxPivotRowHeaderGroupComponent_Conditional_4_Template_igx_pivot_row_dimension_header_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.grid.navigation.headerNavigation($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_3_Template, 1, 5, "span", 6)(4, IgxPivotRowHeaderGroupComponent_Conditional_4_Conditional_4_Template, 1, 0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.grid.hasMovableColumns ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.grid.id + "_" + ctx_r0.column.field)("ngClass", ctx_r0.column.headerClasses)("ngStyle", i0.ɵɵpipeBind3(2, 11, ctx_r0.column.headerStyles, ctx_r0.column, ctx_r0.grid.pipeTrigger))("igxColumnMovingDrag", ctx_r0.column)("ghostHost", ctx_r0.grid.outlet.nativeElement)("igxColumnMovingDrop", ctx_r0.column)("column", ctx_r0.column);
    i0.ɵɵattribute("droppable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.column.columnGroup && ctx_r0.column.resizable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.hasMovableColumns ? 4 : -1);
  }
}
const _c240 = ["esf"];
const _c241 = ["filterAreaHidden"];
const _c242 = ["filterIcon"];
const _c243 = ["dropdownChips"];
const _c244 = ["pivotFilterContainer"];
const _c245 = ["pivotRowContainer"];
const _c246 = ["notifyChip"];
const _c247 = ["rowDimensionHeaders"];
const _c248 = () => ({
  pivotArea: "filter"
});
const _c249 = () => ({
  pivotArea: "row"
});
const _c250 = () => ({
  pivotArea: "column"
});
const _c251 = () => ({
  pivotArea: "value"
});
const _forTrack12 = ($index, $item) => $item.key;
const _forTrack13 = ($index, $item) => $item.memberName;
const _forTrack14 = ($index, $item) => $item.member;
function IgxPivotHeaderRowComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_4_Conditional_4_Template_span_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      i0.ɵɵnextContext();
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, filterArea_r3, 2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.grid.resourceStrings.igx_grid_pivot_empty_filter_drop_area);
  }
}
function IgxPivotHeaderRowComponent_Conditional_4_For_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 48);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const filterArea_r3 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(filterArea_r3), "px");
  }
}
function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "span", 48);
    i0.ɵɵelementStart(1, "igx-chip", 49);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_remove_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.filterRemoved($event));
    })("dragOver", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_dragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragOver($event, 2));
    })("dragLeave", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_dragLeave_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragLeave($event));
    })("dragDrop", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_dragDrop_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      i0.ɵɵnextContext();
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, filterArea_r3, 2));
    })("moveStart", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_moveStart_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      i0.ɵɵnextContext();
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDragStart($event, filterArea_r3));
    })("moveEnd", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_chip_moveEnd_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragEnd());
    });
    i0.ɵɵelementStart(2, "igx-icon", 50);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_icon_pointerdown_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotHeaderRowComponent_Conditional_4_For_6_Template_igx_icon_click_2_listener($event) {
      const filter_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconClick($event, filter_r7));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_4_For_6_Conditional_4_Template, 1, 2, "span", 51);
  }
  if (rf & 2) {
    const filter_r7 = ctx.$implicit;
    const ɵ$index_18_r8 = ctx.$index;
    const ɵ$count_18_r9 = ctx.$count;
    i0.ɵɵnextContext();
    const filterArea_r3 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(filterArea_r3), "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", filter_r7.memberName)("draggable", true)("data", i0.ɵɵpureFunction0(8, _c248))("removable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r7.displayName || filter_r7.memberName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_18_r8 === ɵ$count_18_r9 - 1 ? 4 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_4_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46)(1, "igx-icon", 52, 8);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_4_Conditional_10_Template_igx_icon_pointerdown_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotHeaderRowComponent_Conditional_4_Conditional_10_Template_igx_icon_click_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFiltersAreaDropdownClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "igx-badge", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r3.filterDropdownDimensions.size);
  }
}
function IgxPivotHeaderRowComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43, 5);
    i0.ɵɵlistener("igxDragLeave", function IgxPivotHeaderRowComponent_Conditional_4_Template_div_igxDragLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onAreaDragLeave($event, filterArea_r3));
    })("dropped", function IgxPivotHeaderRowComponent_Conditional_4_Template_div_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, filterArea_r3, 2));
    })("pointerdown", function IgxPivotHeaderRowComponent_Conditional_4_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "igx-chips-area", 41, 6);
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_4_Conditional_4_Template, 2, 1, "span", 44);
    i0.ɵɵrepeaterCreate(5, IgxPivotHeaderRowComponent_Conditional_4_For_6_Template, 5, 9, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(7, "igx-chip", 45, 7);
    i0.ɵɵlistener("dragDrop", function IgxPivotHeaderRowComponent_Conditional_4_Template_igx_chip_dragDrop_7_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const filterArea_r3 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, filterArea_r3, 2));
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, IgxPivotHeaderRowComponent_Conditional_4_Conditional_10_Template, 4, 1, "div", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", ctx_r3.grid.pivotRowWidths - 1, "px")("max-width", ctx_r3.grid.pivotRowWidths - 1, "px");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r3.grid.filterDimensions.length === 0 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.filterAreaDimensions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_filter_drop_chip, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isFiltersButton && ctx_r3.grid.filterDimensions.length !== 0 ? 10 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_6_Conditional_4_Template_span_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      i0.ɵɵnextContext();
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r12, 0));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.grid.resourceStrings.igx_grid_pivot_empty_row_drop_area);
  }
}
function IgxPivotHeaderRowComponent_Conditional_6_For_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 57);
  }
  if (rf & 2) {
    const row_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", row_r15.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxPivotHeaderRowComponent_Conditional_6_For_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 48);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const rowArea_r12 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(rowArea_r12), "px");
  }
}
function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "span", 48);
    i0.ɵɵelementStart(1, "igx-chip", 55);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_remove_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.rowRemoved($event));
    })("dragLeave", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_dragLeave_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragLeave($event));
    })("dragDrop", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_dragDrop_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      i0.ɵɵnextContext();
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r12, 0));
    })("dragOver", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_dragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragOver($event, 0));
    })("moveStart", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_moveStart_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      i0.ɵɵnextContext();
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDragStart($event, rowArea_r12));
    })("moveEnd", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_moveEnd_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragEnd());
    })("click", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_chip_click_1_listener($event) {
      const row_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onChipSort($event, row_r15));
    });
    i0.ɵɵelement(2, "igx-icon", 56);
    i0.ɵɵelementStart(3, "igx-icon", 50);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_icon_pointerdown_3_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotHeaderRowComponent_Conditional_6_For_6_Template_igx_icon_click_3_listener($event) {
      const row_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconClick($event, row_r15));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, IgxPivotHeaderRowComponent_Conditional_6_For_6_Conditional_5_Template, 1, 1, "igx-icon", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, IgxPivotHeaderRowComponent_Conditional_6_For_6_Conditional_6_Template, 1, 2, "span", 51);
  }
  if (rf & 2) {
    const row_r15 = ctx.$implicit;
    const ɵ$index_50_r16 = ctx.$index;
    const ɵ$count_50_r17 = ctx.$count;
    i0.ɵɵnextContext();
    const rowArea_r12 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(rowArea_r12), "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("draggable", true)("id", row_r15.memberName)("data", i0.ɵɵpureFunction0(9, _c249))("removable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", row_r15.displayName || row_r15.memberName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(row_r15.sortDirection ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_50_r16 === ɵ$count_50_r17 - 1 ? 6 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54, 9);
    i0.ɵɵlistener("igxDragLeave", function IgxPivotHeaderRowComponent_Conditional_6_Template_div_igxDragLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onAreaDragLeave($event, rowArea_r12));
    })("dropped", function IgxPivotHeaderRowComponent_Conditional_6_Template_div_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r12, 0));
    });
    i0.ɵɵelementStart(2, "igx-chips-area", 41, 10);
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_6_Conditional_4_Template, 2, 1, "span", 44);
    i0.ɵɵrepeaterCreate(5, IgxPivotHeaderRowComponent_Conditional_6_For_6_Template, 7, 10, null, null, _forTrack13);
    i0.ɵɵelementStart(7, "igx-chip", 45, 7);
    i0.ɵɵlistener("dragDrop", function IgxPivotHeaderRowComponent_Conditional_6_Template_igx_chip_dragDrop_7_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const rowArea_r12 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r12, 0));
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r3.grid.pivotRowWidths - 1, "px");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r3.grid.rowDimensions.length === 0 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid.rowDimensions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_row_drop_chip, " ");
  }
}
function IgxPivotHeaderRowComponent_Conditional_8_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_8_Conditional_4_Template_span_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r20);
      i0.ɵɵnextContext();
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, colArea_r19, 1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_empty_column_drop_area, "");
  }
}
function IgxPivotHeaderRowComponent_Conditional_8_For_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 57);
  }
  if (rf & 2) {
    const col_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", col_r22.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxPivotHeaderRowComponent_Conditional_8_For_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 48);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const colArea_r19 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(colArea_r19), "px");
  }
}
function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "span", 48);
    i0.ɵɵelementStart(1, "igx-chip", 59);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_remove_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.columnRemoved($event));
    })("dragOver", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_dragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragOver($event, 1));
    })("dragLeave", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_dragLeave_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragLeave($event));
    })("dragDrop", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_dragDrop_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      i0.ɵɵnextContext();
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, colArea_r19, 1));
    })("moveStart", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_moveStart_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      i0.ɵɵnextContext();
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDragStart($event, colArea_r19));
    })("moveEnd", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_moveEnd_1_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragEnd());
    })("click", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_chip_click_1_listener($event) {
      const col_r22 = i0.ɵɵrestoreView(_r21).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onChipSort($event, col_r22));
    });
    i0.ɵɵelement(2, "igx-icon", 60);
    i0.ɵɵelementStart(3, "igx-icon", 50);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_icon_pointerdown_3_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotHeaderRowComponent_Conditional_8_For_6_Template_igx_icon_click_3_listener($event) {
      const col_r22 = i0.ɵɵrestoreView(_r21).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconClick($event, col_r22));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, IgxPivotHeaderRowComponent_Conditional_8_For_6_Conditional_5_Template, 1, 1, "igx-icon", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, IgxPivotHeaderRowComponent_Conditional_8_For_6_Conditional_6_Template, 1, 2, "span", 51);
  }
  if (rf & 2) {
    const col_r22 = ctx.$implicit;
    const ɵ$index_80_r23 = ctx.$index;
    const ɵ$count_80_r24 = ctx.$count;
    i0.ɵɵnextContext();
    const colArea_r19 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(colArea_r19), "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("draggable", true)("id", col_r22.memberName)("data", i0.ɵɵpureFunction0(9, _c250))("removable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", col_r22.displayName || col_r22.memberName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r22.sortDirection ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_80_r23 === ɵ$count_80_r24 - 1 ? 6 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58, 11);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_8_Template_div_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, colArea_r19, 1));
    })("igxDragLeave", function IgxPivotHeaderRowComponent_Conditional_8_Template_div_igxDragLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onAreaDragLeave($event, colArea_r19));
    });
    i0.ɵɵelementStart(2, "igx-chips-area", 41, 12);
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_8_Conditional_4_Template, 2, 1, "span", 44);
    i0.ɵɵrepeaterCreate(5, IgxPivotHeaderRowComponent_Conditional_8_For_6_Template, 7, 10, null, null, _forTrack13);
    i0.ɵɵelementStart(7, "igx-chip", 45, 7);
    i0.ɵɵlistener("dragDrop", function IgxPivotHeaderRowComponent_Conditional_8_Template_igx_chip_dragDrop_7_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const colArea_r19 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, colArea_r19, 1));
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r3.grid.columnDimensions.length === 0 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid.columnDimensions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_column_drop_chip, " ");
  }
}
function IgxPivotHeaderRowComponent_Conditional_9_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_9_Conditional_4_Template_span_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r27);
      i0.ɵɵnextContext();
      const valueArea_r26 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onValueDrop($event, valueArea_r26));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.grid.resourceStrings.igx_grid_pivot_empty_value_drop_area);
  }
}
function IgxPivotHeaderRowComponent_Conditional_9_For_6_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotHeaderRowComponent_Conditional_9_For_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 48);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const valueArea_r26 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(valueArea_r26), "px");
  }
}
function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "span", 48);
    i0.ɵɵelementStart(1, "igx-chip", 62, 16);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_igx_chip_remove_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.valueRemoved($event));
    })("dragLeave", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_igx_chip_dragLeave_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragLeave($event));
    })("dragOver", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_igx_chip_dragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDimDragOver($event));
    })("dragDrop", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_igx_chip_dragDrop_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      i0.ɵɵnextContext();
      const valueArea_r26 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onValueDrop($event, valueArea_r26));
    });
    i0.ɵɵelementStart(3, "div", 63);
    i0.ɵɵlistener("click", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_div_click_3_listener($event) {
      const value_r29 = i0.ɵɵrestoreView(_r28).$implicit;
      const currChip_r30 = i0.ɵɵreference(2);
      const ctx_r3 = i0.ɵɵnextContext(2);
      const dropdown_r31 = i0.ɵɵreference(21);
      return i0.ɵɵresetView(ctx_r3.onSummaryClick($event, value_r29, dropdown_r31, currChip_r30));
    })("pointerdown", function IgxPivotHeaderRowComponent_Conditional_9_For_6_Template_div_pointerdown_3_listener($event) {
      i0.ɵɵrestoreView(_r28);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelement(4, "igx-icon", 64)(5, "igx-icon", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, IgxPivotHeaderRowComponent_Conditional_9_For_6_ng_container_6_Template, 1, 0, "ng-container", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, IgxPivotHeaderRowComponent_Conditional_9_For_6_Conditional_7_Template, 1, 2, "span", 51);
  }
  if (rf & 2) {
    const value_r29 = ctx.$implicit;
    const ɵ$index_108_r32 = ctx.$index;
    const ɵ$count_108_r33 = ctx.$count;
    i0.ɵɵnextContext();
    const valueArea_r26 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    const dropdown_r31 = i0.ɵɵreference(21);
    const valueChipDefaultTemplate_r34 = i0.ɵɵreference(40);
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(valueArea_r26), "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("draggable", true)("id", value_r29.displayName || value_r29.member)("data", i0.ɵɵpureFunction0(10, _c251))("removable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxDropDownItemNavigation", dropdown_r31);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.grid.valueChipTemplate ? ctx_r3.grid.valueChipTemplate : valueChipDefaultTemplate_r34)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c25, value_r29));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_108_r32 === ɵ$count_108_r33 - 1 ? 7 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61, 13);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_9_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      return i0.ɵɵresetView($event.preventDefault());
    })("dropped", function IgxPivotHeaderRowComponent_Conditional_9_Template_div_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const valueArea_r26 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onValueDrop($event, valueArea_r26));
    })("igxDragLeave", function IgxPivotHeaderRowComponent_Conditional_9_Template_div_igxDragLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const valueArea_r26 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onAreaDragLeave($event, valueArea_r26));
    });
    i0.ɵɵelementStart(2, "igx-chips-area", 41, 14);
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_9_Conditional_4_Template, 2, 1, "span", 44);
    i0.ɵɵrepeaterCreate(5, IgxPivotHeaderRowComponent_Conditional_9_For_6_Template, 8, 13, null, null, _forTrack14);
    i0.ɵɵelementStart(7, "igx-chip", 45, 15);
    i0.ɵɵlistener("dragDrop", function IgxPivotHeaderRowComponent_Conditional_9_Template_igx_chip_dragDrop_7_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const valueArea_r26 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onValueDrop($event, valueArea_r26));
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r3.grid.values.length === 0 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid.values);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_value_drop_chip, " ");
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵlistener("dropped", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Conditional_0_Template_span_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r38);
      i0.ɵɵnextContext(2);
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r36, 0));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.grid.resourceStrings.igx_grid_pivot_empty_row_drop_area);
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 57);
  }
  if (rf & 2) {
    const row_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", row_r40.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 48);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const rowArea_r36 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(rowArea_r36), "px");
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "span", 48);
    i0.ɵɵelementStart(1, "igx-chip", 55);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_remove_1_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.rowRemoved($event));
    })("dragLeave", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_dragLeave_1_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onDimDragLeave($event));
    })("dragDrop", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_dragDrop_1_listener($event) {
      i0.ɵɵrestoreView(_r39);
      i0.ɵɵnextContext(2);
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r36, 0));
    })("dragOver", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_dragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onDimDragOver($event, 0));
    })("moveStart", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_moveStart_1_listener($event) {
      i0.ɵɵrestoreView(_r39);
      i0.ɵɵnextContext(2);
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDragStart($event, rowArea_r36));
    })("moveEnd", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_moveEnd_1_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onDimDragEnd());
    })("click", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_chip_click_1_listener($event) {
      const row_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onChipSort($event, row_r40));
    });
    i0.ɵɵelement(2, "igx-icon", 56);
    i0.ɵɵelementStart(3, "igx-icon", 50);
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_icon_pointerdown_3_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template_igx_icon_click_3_listener($event) {
      const row_r40 = i0.ɵɵrestoreView(_r39).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconClick($event, row_r40));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Conditional_5_Template, 1, 1, "igx-icon", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Conditional_6_Template, 1, 2, "span", 51);
  }
  if (rf & 2) {
    const row_r40 = ctx.$implicit;
    const ɵ$index_143_r41 = ctx.$index;
    const ɵ$count_143_r42 = ctx.$count;
    i0.ɵɵnextContext(2);
    const rowArea_r36 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.getAreaHeight(rowArea_r36), "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("draggable", true)("id", row_r40.memberName)("data", i0.ɵɵpureFunction0(9, _c249))("removable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", row_r40.displayName || row_r40.memberName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(row_r40.sortDirection ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_143_r41 === ɵ$count_143_r42 - 1 ? 6 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Conditional_0_Template, 2, 1, "span", 44);
    i0.ɵɵrepeaterCreate(1, IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_For_2_Template, 7, 10, null, null, _forTrack13);
    i0.ɵɵelementStart(3, "igx-chip", 45, 7);
    i0.ɵɵlistener("dragDrop", function IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Template_igx_chip_dragDrop_3_listener($event) {
      i0.ɵɵrestoreView(_r37);
      i0.ɵɵnextContext();
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r36, 0));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.grid.rowDimensions.length === 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid.rowDimensions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid.resourceStrings.igx_grid_pivot_row_drop_chip, " ");
  }
}
function IgxPivotHeaderRowComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67, 17);
    i0.ɵɵlistener("igxDragLeave", function IgxPivotHeaderRowComponent_Conditional_12_Template_div_igxDragLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onAreaDragLeave($event, rowArea_r36));
    })("dropped", function IgxPivotHeaderRowComponent_Conditional_12_Template_div_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const rowArea_r36 = i0.ɵɵreference(3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDimDrop($event, rowArea_r36, 0));
    })("pointerdown", function IgxPivotHeaderRowComponent_Conditional_12_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r35);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "igx-chips-area", 41, 10);
    i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_12_Conditional_4_Template, 6, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r3.grid.pivotRowWidths - 1, "px");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r3.grid.pivotUI.showConfiguration || ctx_r3.grid.rowDimensions.length === 0 ? 4 : -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_13_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-row-header-group", 70, 18);
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupWidth");
    i0.ɵɵpipe(4, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const dimCol_r43 = ctx;
    const ɵ$index_165_r44 = i0.ɵɵnextContext().$index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(2, 10, ctx_r3.grid.rowDimensionWidthToPixels(ctx_r3.grid.visibleRowDimensions[ɵ$index_165_r44]), ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL))("flex-basis", i0.ɵɵpipeBind3(3, 14, ctx_r3.grid.rowDimensionWidthToPixels(ctx_r3.grid.visibleRowDimensions[ɵ$index_165_r44]), ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL));
    i0.ɵɵproperty("ngClass", dimCol_r43.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(4, 18, dimCol_r43.headerGroupStyles, dimCol_r43, ctx_r3.grid.pipeTrigger))("column", dimCol_r43)("rootDimension", ctx_r3.grid.visibleRowDimensions[ɵ$index_165_r44])("dimWidth", ctx_r3.grid.rowDimensionWidthToPixels(ctx_r3.grid.visibleRowDimensions[ɵ$index_165_r44]))("rowIndex", -1);
  }
}
function IgxPivotHeaderRowComponent_Conditional_13_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxPivotHeaderRowComponent_Conditional_13_For_2_Conditional_0_Template, 5, 22, "igx-pivot-row-header-group", 69);
  }
  if (rf & 2) {
    let tmp_18_0;
    const dim_r45 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_18_0 = ctx_r3.getRowDimensionColumn(dim_r45)) ? 0 : -1, tmp_18_0);
  }
}
function IgxPivotHeaderRowComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵrepeaterCreate(1, IgxPivotHeaderRowComponent_Conditional_13_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r3.grid.pivotRowWidths - 1, "px");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid.visibleRowDimensions);
  }
}
function IgxPivotHeaderRowComponent_Conditional_14_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-header-group", 72);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_14_For_1_Template_igx_grid_header_group_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r46);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.grid.navigation.focusOutRowHeader($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r47 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 7, column_r47.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 11, column_r47.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL));
    i0.ɵɵproperty("ngClass", column_r47.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 15, column_r47.headerGroupStyles, column_r47, ctx_r3.grid.pipeTrigger))("column", column_r47);
  }
}
function IgxPivotHeaderRowComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxPivotHeaderRowComponent_Conditional_14_For_1_Template, 4, 19, "igx-grid-header-group", 71, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(2, "igxTopLevel");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r3.pinnedColumnCollection));
  }
}
function IgxPivotHeaderRowComponent_For_17_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-header-group", 75);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
  }
  if (rf & 2) {
    const column_r48 = ctx.$implicit;
    const ɵ$index_182_r49 = i0.ɵɵnextContext().$index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.totalDepth > 1 ? ctx_r3.calcHeight(column_r48, ɵ$index_182_r49) : undefined, "px")("min-width", i0.ɵɵpipeBind3(1, 13, column_r48.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 17, column_r48.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL));
    i0.ɵɵclassProp("igx-grid__tr-pivot--columnDimensionLeaf", ctx_r3.isDuplicateOfExistingParent(column_r48, ɵ$index_182_r49))("igx-grid__tr-pivot--columnMultiRowSpan", ctx_r3.isMultiRow(column_r48, ɵ$index_182_r49));
    i0.ɵɵproperty("ngClass", column_r48.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 21, column_r48.headerGroupStyles, column_r48, ctx_r3.grid.pipeTrigger))("column", column_r48);
  }
}
function IgxPivotHeaderRowComponent_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtemplate(1, IgxPivotHeaderRowComponent_For_17_ng_template_1_Template, 4, 25, "ng-template", 74, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dimLevelColumns_r50 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.totalDepth > 1 ? ctx_r3.grid.rowHeight : undefined, "px")("width", ctx_r3.grid.unpinnedWidth, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", dimLevelColumns_r50)("igxGridForOfUniqueSizeCache", true)("igxForScrollContainer", ctx_r3.grid.parentVirtDir)("igxForContainerSize", ctx_r3.grid.unpinnedWidth)("igxForTrackBy", ctx_r3.grid.trackColumnChanges)("igxForSizePropName", "calcPixelWidth")("igxForScrollOrientation", "horizontal");
  }
}
function IgxPivotHeaderRowComponent_Conditional_18_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-header-group", 72);
    i0.ɵɵpipe(1, "igxHeaderGroupWidth");
    i0.ɵɵpipe(2, "igxHeaderGroupWidth");
    i0.ɵɵpipe(3, "igxHeaderGroupStyle");
    i0.ɵɵlistener("pointerdown", function IgxPivotHeaderRowComponent_Conditional_18_For_1_Template_igx_grid_header_group_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.grid.navigation.focusOutRowHeader($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r52 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(1, 9, column_r52.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL))("flex-basis", i0.ɵɵpipeBind3(2, 13, column_r52.resolvedWidth, ctx_r3.grid.defaultHeaderGroupMinWidth, ctx_r3.hasMRL))("left", column_r52.rightPinnedOffset);
    i0.ɵɵproperty("ngClass", column_r52.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(3, 17, column_r52.headerGroupStyles, column_r52, ctx_r3.grid.pipeTrigger))("column", column_r52);
  }
}
function IgxPivotHeaderRowComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxPivotHeaderRowComponent_Conditional_18_For_1_Template, 4, 21, "igx-grid-header-group", 76, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(2, "igxTopLevel");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r3.pinnedColumnCollection));
  }
}
function IgxPivotHeaderRowComponent_For_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r53 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", ctx_r3.isSelected(item_r53))("value", item_r53);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r53.label, " ");
  }
}
function IgxPivotHeaderRowComponent_For_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 77);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_For_31_Template_igx_chip_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r54);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.filterRemoved($event));
    })("chipClick", function IgxPivotHeaderRowComponent_For_31_Template_igx_chip_chipClick_0_listener($event) {
      i0.ɵɵrestoreView(_r54);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onFiltersSelectionChanged($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r55 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", filter_r55.memberName)("removable", true)("selectable", true)("selected", filter_r55 === ctx_r3.filterDropdownDimensions.values().next().value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", filter_r55.displayName || filter_r55.memberName, " ");
  }
}
function IgxPivotHeaderRowComponent_For_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 78);
    i0.ɵɵlistener("remove", function IgxPivotHeaderRowComponent_For_38_Template_igx_chip_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r56);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.filterRemoved($event));
    });
    i0.ɵɵelement(1, "igx-icon", 79);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r57 = ctx.$implicit;
    i0.ɵɵproperty("id", filter_r57.memberName)("draggable", true)("removable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r57.displayName || filter_r57.memberName, " ");
  }
}
function IgxPivotHeaderRowComponent_ng_template_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r58 = ctx.$implicit;
    i0.ɵɵtextInterpolate2(" ", value_r58.aggregate.key, "(", value_r58.displayName || value_r58.member, ")\n");
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.column.header);
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.column.expanded ? "tree_collapse" : "tree_expand");
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("cursor", ctx_r0.colResizingService.resizeCursor);
    i0.ɵɵproperty("igxPivotResizeHandle", ctx_r0.column)("igxPivotResizeHandleHeader", ctx_r0);
    i0.ɵɵattribute("draggable", false);
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
}
function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_0_Template, 1, 0, "span", 4);
    i0.ɵɵelementStart(1, "igx-pivot-row-dimension-header", 5);
    i0.ɵɵpipe(2, "igxHeaderGroupStyle");
    i0.ɵɵlistener("pointerdown", function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Template_igx_pivot_row_dimension_header_pointerdown_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.pointerdown($event));
    })("keydown", function IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Template_igx_pivot_row_dimension_header_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.grid.navigation.headerNavigation($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_3_Template, 1, 5, "span", 6)(4, IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Conditional_4_Template, 1, 0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.grid.hasMovableColumns ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.grid.id + "_" + ctx_r0.column.field)("ngClass", ctx_r0.column.headerClasses)("ngStyle", i0.ɵɵpipeBind3(2, 11, ctx_r0.column.headerStyles, ctx_r0.column, ctx_r0.grid.pipeTrigger))("igxColumnMovingDrag", ctx_r0.column)("ghostHost", ctx_r0.grid.outlet.nativeElement)("igxColumnMovingDrop", ctx_r0.column)("column", ctx_r0.column);
    i0.ɵɵattribute("droppable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.column.columnGroup && ctx_r0.column.resizable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.hasMovableColumns ? 4 : -1);
  }
}
const _c252 = ["headerTemplate"];
const _c253 = ["headerDefaultTemplate"];
function IgxPivotRowDimensionContentComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "igx-icon", 5);
    i0.ɵɵlistener("click", function IgxPivotRowDimensionContentComponent_ng_template_7_Template_igx_icon_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleRowDimension($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("igx-grid__tr--header igx-grid__row-indentation--level-", ctx_r1.getLevel(), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.getExpandState() ? "tree_collapse" : "tree_expand");
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r3.header, " ");
  }
}
function IgxPivotRowDimensionContentComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "igx-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("igx-grid__tr--header igx-grid__row-indentation--level-", ctx_r1.getLevel(), "");
    i0.ɵɵadvance();
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r4.header, " ");
  }
}
function IgxPivotRowComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-grid-cell", 4, 2);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxPivotCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
    i0.ɵɵlistener("pointerdown", function IgxPivotRowComponent_ng_template_0_Template_igx_grid_cell_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.grid.navigation.focusOutRowHeader($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", col_r3.resolvedWidth)("max-width", col_r3.resolvedWidth)("flex-basis", col_r3.resolvedWidth);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 28, i0.ɵɵpureFunction7(56, _c225, ctx_r1.key, col_r3.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", col_r3.dataType === "number" || col_r3.dataType === "percent" || col_r3.dataType === "currency")("igx-grid__td--bool", col_r3.dataType === "boolean");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 36, i0.ɵɵpureFunction6(64, _c63, ctx_r1.getCellClass(col_r3), ctx_r1.data[col_r3.field], ctx_r1.data, ctx_r1.getColumnData(col_r3), ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 43, i0.ɵɵpureFunction6(71, _c63, col_r3.cellStyles, ctx_r1.pivotAggregationData[col_r3.field], ctx_r1.pivotAggregationData, col_r3.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("editMode", col_r3.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r3.index))("column", col_r3)("formatter", col_r3.formatter)("intRow", ctx_r1)("active", ctx_r1.isCellActive(col_r3.visibleIndex))("rowData", ctx_r1.data)("columnData", ctx_r1.getColumnData(col_r3))("width", col_r3.getCellWidth())("visibleColumnIndex", col_r3.visibleIndex)("value", i0.ɵɵpipeBindV(5, 50, i0.ɵɵpureFunction5(78, _c64, ctx_r1.pivotAggregationData[col_r3.field], col_r3.field, ctx_r1.grid.pipeTrigger, ctx_r1.pivotAggregationData[col_r3.field], col_r3.hasNestedPath)))("cellTemplate", col_r3.bodyTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r3.visibleIndex));
  }
}
function IgxPivotRowComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "igx-checkbox", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("readonly", true)("checked", ctx_r1.selected)("disableRipple", true)("disabled", ctx_r1.deleted)("disableTransitions", ctx_r1.grid.disableTransitions)("aria-label", ctx_r1.rowCheckboxAriaLabel);
  }
}
const _c254 = (a0, a1, a2, a3, a4) => ({
  rowStart: a0,
  rowEnd: a1,
  colStart: a2,
  colEnd: a3,
  columnVisibleIndex: a4
});
function _forTrack15($index, $item) {
  return this.getGroupKey($item);
}
function IgxPivotRowDimensionMrlRowComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-row-dimension-content", 0);
  }
  if (rf & 2) {
    const cell_r1 = ctx.$implicit;
    const ɵ$index_1_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("grid", ctx_r2.grid)("dimension", cell_r1.rootDimension)("rootDimension", cell_r1.rootDimension)("rowIndex", ctx_r2.rowIndex)("colIndex", ɵ$index_1_r2)("rowData", cell_r1.records[0])("width", ctx_r2.rowDimensionWidthCombined(cell_r1.dimensions))("layout", i0.ɵɵpureFunction5(8, _c254, cell_r1.rowStart, cell_r1.rowStart + cell_r1.rowSpan, cell_r1.colStart, cell_r1.colStart + cell_r1.colSpan, ɵ$index_1_r2));
  }
}
const _c255 = ["emptyPivotGridTemplate"];
const _c256 = ["rowDimensionContainer"];
const _c257 = ["verticalRowDimScrollContainer"];
const _c258 = [[["igx-grid-toolbar"], ["igc-grid-toolbar"]], [["igx-grid-footer"], ["igc-grid-footer"]], [["igx-grid-state"], ["igc-grid-state"]]];
const _c259 = ["igx-grid-toolbar,igc-grid-toolbar", "igx-grid-footer,igc-grid-footer", "igx-grid-state,igc-grid-state"];
function IgxPivotGridComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotGridComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxPivotGridComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 56);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxPivotGridComponent_ng_template_8_ng_template_0_Template(rf, ctx) {}
function IgxPivotGridComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxPivotGridComponent_ng_template_8_ng_template_0_Template, 0, 0, "ng-template", 57);
    i0.ɵɵlistener("cachedViewLoaded", function IgxPivotGridComponent_ng_template_8_Template_ng_template_cachedViewLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cachedViewLoaded($event));
    });
  }
  if (rf & 2) {
    const rowData_r4 = ctx.$implicit;
    const rowIndex_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxTemplateOutlet", ctx_r1.recordTemplate)("igxTemplateOutletContext", ctx_r1.getContext(rowData_r4, rowIndex_r5));
  }
}
function IgxPivotGridComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-row", 58, 21);
    i0.ɵɵpipe(2, "igxGridRowClasses");
    i0.ɵɵpipe(3, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r6 = ctx.index;
    const rowData_r7 = ctx.$implicit;
    const row_r8 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r6)("data", rowData_r7)("ngClass", i0.ɵɵpipeBindV(2, 5, i0.ɵɵpureFunctionV(23, _c236, [ctx_r1.rowClasses, row_r8, row_r8.inEditMode, row_r8.selected, row_r8.dirty, row_r8.deleted, row_r8.dragging, rowIndex_r6, ctx_r1.hasColumnLayouts, rowData_r7, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(3, 18, ctx_r1.rowStyles, rowData_r7, rowIndex_r6, ctx_r1.pipeTrigger));
  }
}
function IgxPivotGridComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxPivotGridComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 33);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxPivotGridComponent_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxPivotGridComponent_ng_template_27_Template(rf, ctx) {}
function IgxPivotGridComponent_ng_template_40_Template(rf, ctx) {}
function IgxPivotGridComponent_ng_template_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 59)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyFilteredGridMessage);
  }
}
function IgxPivotGridComponent_ng_template_50_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 59)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyGridMessage);
  }
}
function IgxPivotGridComponent_ng_template_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelement(1, "igx-circular-bar", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxPivotGridComponent_Conditional_54_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-grid-column-resizer", 49);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("restrictResizerTop", ctx_r1.calculateResizerTop());
  }
}
function IgxPivotGridComponent_ng_template_59_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "igx-icon", 62);
    i0.ɵɵlistener("click", function IgxPivotGridComponent_ng_template_59_Template_igx_icon_click_1_listener() {
      const column_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleColumn(column_r10));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.getColumnGroupExpandState(column_r10) ? "tree_expand" : "tree_collapse");
    i0.ɵɵattribute("draggable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r10.header, " ");
  }
}
function IgxPivotGridComponent_ng_template_61_For_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-row-dimension-content", 66);
  }
  if (rf & 2) {
    const rowData_r12 = ctx.$implicit;
    const rowIndex_r13 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext();
    const dim_r15 = ctx_r13.$implicit;
    const ɵ$index_115_r16 = ctx_r13.$index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r1.renderedRowHeight * (rowData_r12.rowSpan || 1), "px");
    i0.ɵɵproperty("grid", ctx_r1)("dimension", rowData_r12.dimensions[ɵ$index_115_r16])("rootDimension", dim_r15)("rowIndex", rowIndex_r13)("rowData", rowData_r12)("width", ctx_r1.rowDimensionWidthToPixels(dim_r15));
  }
}
function IgxPivotGridComponent_ng_template_61_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64, 22);
    i0.ɵɵlistener("focus", function IgxPivotGridComponent_ng_template_61_For_1_Template_div_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigation.focusTbody($event));
    })("keydown", function IgxPivotGridComponent_ng_template_61_For_1_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigation.handleNavigation($event));
    });
    i0.ɵɵtemplate(2, IgxPivotGridComponent_ng_template_61_For_1_ng_template_2_Template, 1, 8, "ng-template", 65, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(4, "pivotGridCellMerging");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dim_r15 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r1.totalHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind4(4, 8, ctx_r1.dataView, ctx_r1.pivotConfiguration, dim_r15, ctx_r1.pipeTrigger))("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx_r1.verticalScroll)("igxForContainerSize", ctx_r1.calcHeight)("igxForItemSize", ctx_r1.renderedRowHeight)("igxForSizePropName", "height");
  }
}
function IgxPivotGridComponent_ng_template_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxPivotGridComponent_ng_template_61_For_1_Template, 5, 13, "div", 63, _forTrack13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.rowDimensions);
  }
}
function IgxPivotGridComponent_ng_template_63_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-pivot-row-dimension-mrl-row", 69);
  }
  if (rf & 2) {
    const rowGroup_r18 = ctx.$implicit;
    const rowIndex_r19 = ctx.index;
    const groupedData_r20 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r1.renderedRowHeight * rowGroup_r18.length, "px");
    i0.ɵɵproperty("rowIndex", rowIndex_r19)("rowGroup", rowGroup_r18)("groupedData", groupedData_r20);
  }
}
function IgxPivotGridComponent_ng_template_63_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxPivotGridComponent_ng_template_63_Conditional_2_ng_template_0_Template, 1, 5, "ng-template", 68, 23, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("igxGridForOf", ctx)("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx_r1.verticalScroll)("igxForContainerSize", ctx_r1.calcHeight)("igxForItemSize", ctx_r1.renderedRowHeight)("igxForSizePropName", "height");
  }
}
function IgxPivotGridComponent_ng_template_63_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67, 22);
    i0.ɵɵlistener("focus", function IgxPivotGridComponent_ng_template_63_Template_div_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigation.focusTbody($event));
    })("keydown", function IgxPivotGridComponent_ng_template_63_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigation.handleNavigation($event));
    });
    i0.ɵɵtemplate(2, IgxPivotGridComponent_ng_template_63_Conditional_2_Template, 2, 6, null, 68);
    i0.ɵɵpipe(3, "pivotGridHorizontalRowGrouping");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_24_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r1.totalHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_24_0 = i0.ɵɵpipeBind4(3, 3, ctx_r1.dataView, ctx_r1.pivotConfiguration, ctx_r1.pipeTrigger, ctx_r1.regroupTrigger)) ? 2 : -1, tmp_24_0);
  }
}
function IgxPivotGridComponent_ng_template_65_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64, 22);
    i0.ɵɵlistener("focus", function IgxPivotGridComponent_ng_template_65_Conditional_0_Template_div_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigation.focusTbody($event));
    })("keydown", function IgxPivotGridComponent_ng_template_65_Conditional_0_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigation.handleNavigation($event));
    });
    i0.ɵɵelement(2, "igx-pivot-row-dimension-content", 66);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("grid", ctx_r1)("dimension", ctx_r1.emptyRowDimension)("rootDimension", ctx_r1.emptyRowDimension)("rowIndex", 0)("rowData", ctx_r1.dataView[0])("width", ctx_r1.rowDimensionWidthToPixels(ctx_r1.emptyRowDimension));
  }
}
function IgxPivotGridComponent_ng_template_65_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxPivotGridComponent_ng_template_65_Conditional_0_Template, 3, 6, "div", 70);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.columnDimensions.length > 0 || ctx_r1.values.length > 0 ? 0 : -1);
  }
}
function IgxPivotGridComponent_ng_template_67_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 59)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_pivot_empty_message);
  }
}
function IgxPivotGridComponent_Conditional_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55, 24);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵelementEnd();
  }
}
function IgxGridToolbarAdvancedFilteringComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.grid == null ? null : ctx_r1.grid.resourceStrings.igx_grid_toolbar_advanced_filtering_button_label);
  }
}
function IgxGridToolbarAdvancedFilteringComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r1.numberOfColumns, ") ");
  }
}
const _c260 = [[["", "igxGridToolbarTitle", ""], ["igx-grid-toolbar-title"], ["igc-grid-toolbar-title"]], "*", [["", "igxGridToolbarActions", ""], ["igx-grid-toolbar-actions"], ["igc-grid-toolbar-actions"]]];
const _c261 = ["[igxGridToolbarTitle],igx-grid-toolbar-title,igc-grid-toolbar-title", "*", "[igxGridToolbarActions],igx-grid-toolbar-actions,igc-grid-toolbar-actions"];
function IgxGridToolbarComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxGridToolbarComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-toolbar-advanced-filtering");
  }
}
function IgxGridToolbarComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-grid-toolbar-actions");
    i0.ɵɵtemplate(1, IgxGridToolbarComponent_Conditional_5_Conditional_1_Template, 1, 0, "igx-grid-toolbar-advanced-filtering");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.grid == null ? null : ctx_r0.grid.allowAdvancedFiltering) ? 1 : -1);
  }
}
function IgxGridToolbarComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxGridToolbarComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "igx-linear-bar", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("indeterminate", true);
  }
}
const _c262 = ["*", [["", "excelText", ""], ["excel-text"]], [["", "csvText", ""], ["csv-text"]]];
const _c263 = ["*", "[excelText],excel-text", "[csvText],csv-text"];
function IgxGridToolbarExporterComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid == null ? null : ctx_r3.grid.resourceStrings.igx_grid_toolbar_exporter_button_label, " ");
  }
}
function IgxGridToolbarExporterComponent_Conditional_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "excel-text");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid == null ? null : ctx_r3.grid.resourceStrings.igx_grid_toolbar_exporter_excel_entry_text, " ");
  }
}
function IgxGridToolbarExporterComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 14, 3);
    i0.ɵɵlistener("click", function IgxGridToolbarExporterComponent_Conditional_11_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      const toggleRef_r3 = i0.ɵɵreference(10);
      return i0.ɵɵresetView(ctx_r3.exportClicked("excel", toggleRef_r3));
    });
    i0.ɵɵelementStart(2, "span", null, 4);
    i0.ɵɵprojection(4, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxGridToolbarExporterComponent_Conditional_11_Conditional_5_Template, 2, 1, "excel-text");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const excel_r6 = i0.ɵɵreference(3);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(!excel_r6.childNodes.length ? 5 : -1);
  }
}
function IgxGridToolbarExporterComponent_Conditional_12_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "csv-text");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid == null ? null : ctx_r3.grid.resourceStrings.igx_grid_toolbar_exporter_csv_entry_text, " ");
  }
}
function IgxGridToolbarExporterComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15, 5);
    i0.ɵɵlistener("click", function IgxGridToolbarExporterComponent_Conditional_12_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext();
      const toggleRef_r3 = i0.ɵɵreference(10);
      return i0.ɵɵresetView(ctx_r3.exportClicked("csv", toggleRef_r3));
    });
    i0.ɵɵelementStart(2, "span", null, 6);
    i0.ɵɵprojection(4, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxGridToolbarExporterComponent_Conditional_12_Conditional_5_Template, 2, 1, "csv-text");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const csv_r8 = i0.ɵɵreference(3);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(!csv_r8.childNodes.length ? 5 : -1);
  }
}
function IgxGridToolbarHidingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 0);
    i0.ɵɵlistener("click", function IgxGridToolbarHidingComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const btn_r2 = i0.ɵɵreference(1);
      const actions_r3 = i0.ɵɵreference(8);
      const ref_r4 = i0.ɵɵreference(9);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.toggle(btn_r2, ref_r4, actions_r3));
    });
    i0.ɵɵelement(2, "igx-icon", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "igx-column-actions", 4, 1);
    i0.ɵɵlistener("opened", function IgxGridToolbarHidingComponent_Conditional_0_Template_igx_column_actions_opened_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ref_r4 = i0.ɵɵreference(9);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.focusSearch(ref_r4.element));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_hiding_button_tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", !ctx_r4.grid.hiddenColumnsCount ? "show" : "hide");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.grid.hiddenColumnsCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.buttonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("grid", ctx_r4.grid)("title", ctx_r4.title || (ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_hiding_title))("filterColumnsPrompt", ctx_r4.prompt || (ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_actions_filter_prompt))("hideFilter", ctx_r4.hideFilter)("filterCriteria", ctx_r4.filterCriteria)("columnDisplayOrder", ctx_r4.columnDisplayOrder)("columnsAreaMaxHeight", ctx_r4.columnsAreaMaxHeight)("uncheckAllText", ctx_r4.uncheckAllText)("checkAllText", ctx_r4.checkAllText)("indentation", ctx_r4.indentetion);
  }
}
function IgxGridToolbarPinningComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 0);
    i0.ɵɵlistener("click", function IgxGridToolbarPinningComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const btn_r2 = i0.ɵɵreference(1);
      const actions_r3 = i0.ɵɵreference(8);
      const ref_r4 = i0.ɵɵreference(9);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.toggle(btn_r2, ref_r4, actions_r3));
    });
    i0.ɵɵelement(2, "igx-icon", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "igx-column-actions", 4, 1);
    i0.ɵɵlistener("opened", function IgxGridToolbarPinningComponent_Conditional_0_Template_igx_column_actions_opened_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ref_r4 = i0.ɵɵreference(9);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.focusSearch(ref_r4.element));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_pinning_button_tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", !ctx_r4.grid.pinnedColumnsCount ? "unpin" : "pin");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.grid.pinnedColumnsCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.buttonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("grid", ctx_r4.grid)("title", ctx_r4.title || (ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_pinning_title))("filterColumnsPrompt", ctx_r4.prompt || (ctx_r4.grid == null ? null : ctx_r4.grid.resourceStrings.igx_grid_toolbar_actions_filter_prompt))("hideFilter", ctx_r4.hideFilter)("filterCriteria", ctx_r4.filterCriteria)("columnDisplayOrder", ctx_r4.columnDisplayOrder)("columnsAreaMaxHeight", ctx_r4.columnsAreaMaxHeight)("uncheckAllText", ctx_r4.uncheckAllText)("checkAllText", ctx_r4.checkAllText)("indentation", ctx_r4.indentetion);
  }
}
const _c264 = [[["", "igxPaginatorContent", ""], ["igx-paginator-content"]]];
const _c265 = ["[igxPaginatorContent],igx-paginator-content"];
function IgxPaginatorComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-page-size");
  }
}
function IgxPaginatorComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-page-nav");
  }
}
function IgxPageSizeSelectorComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-select-item", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const val_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", val_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", val_r1, " ");
  }
}
const _c266 = (a0, a1) => ({
  gridID: a0,
  selectorChannels: a1
});
const _forTrack16 = ($index, $item) => $item.memberName || $item.member;
function IgxPivotDataSelectorComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-list-item", 7)(1, "igx-checkbox", 11);
    i0.ɵɵlistener("click", function IgxPivotDataSelectorComponent_For_7_Template_igx_checkbox_click_1_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggleItem(item_r3));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵproperty("id", item_r3.memberName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("aria-labelledby", item_r3.memberName)("disableRipple", true)("checked", item_r3.enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r3.displayName || item_r3.memberName);
  }
}
function IgxPivotDataSelectorComponent_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-list-item", 7)(1, "igx-checkbox", 11);
    i0.ɵɵlistener("click", function IgxPivotDataSelectorComponent_For_10_Template_igx_checkbox_click_1_listener() {
      const item_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggleItem(item_r6));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵproperty("id", item_r6.member);
    i0.ɵɵadvance();
    i0.ɵɵproperty("aria-labelledby", item_r6.member)("disableRipple", true)("checked", item_r6.enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.displayName || item_r6.member);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r10.aggregate.key);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "(");
    i0.ɵɵelementEnd();
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ")");
    i0.ɵɵelementEnd();
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 25);
  }
  if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", item_r10.sortDirection < 2 ? "sort_asc" : "sort_desc");
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 30);
    i0.ɵɵlistener("pointerdown", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_11_Template_igx_icon_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconPointerDown($event));
    })("click", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_11_Template_igx_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const item_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onFilteringIconClick($event, item_r10));
    });
    i0.ɵɵelementEnd();
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 31);
    i0.ɵɵlistener("click", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_12_Template_igx_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const item_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      const dropdown_r13 = i0.ɵɵreference(16);
      return i0.ɵɵresetView(ctx_r3.onSummaryClick($event, item_r10, dropdown_r13));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const dropdown_r13 = i0.ɵɵreference(16);
    i0.ɵɵproperty("igxDropDownItemNavigation", dropdown_r13);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 29);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-list-item", 21);
    i0.ɵɵlistener("ghostCreate", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_ghostCreate_0_listener($event) {
      const item_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const panel_r8 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.ghostCreated($event, item_r10[panel_r8.itemKey]));
    })("over", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_over_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onItemDragOver($event));
    })("leave", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_leave_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onItemDragLeave($event));
    })("dragMove", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_dragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onItemDragMove($event));
    })("dragEnd", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_dragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onItemDragEnd($event));
    })("dropped", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_igx_list_item_dropped_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const panel_r8 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemDropped($event, panel_r8.type));
    });
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23);
    i0.ɵɵlistener("click", function IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template_div_click_2_listener($event) {
      const item_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const panel_r8 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemSort($event, item_r10, panel_r8.type));
    });
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtemplate(4, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_4_Template, 2, 1, "span")(5, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_5_Template, 2, 0, "span");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_8_Template, 2, 0, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_9_Template, 1, 1, "igx-icon", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 26);
    i0.ɵɵtemplate(11, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_11_Template, 1, 0, "igx-icon", 27)(12, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_12_Template, 1, 1, "igx-icon", 28)(13, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Conditional_13_Template, 1, 0, "igx-icon", 29);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const panel_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    const itemGhost_r14 = i0.ɵɵreference(20);
    i0.ɵɵproperty("igxDrag", i0.ɵɵpureFunction2(13, _c266, ctx_r3.grid.id, panel_r8.dragChannels))("ghostTemplate", itemGhost_r14)("id", item_r10[panel_r8.itemKey]);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("igx-pivot-data-selector__action-sort", panel_r8.sortable);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(panel_r8.type === null ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(panel_r8.type === null ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r10[panel_r8.displayKey] || item_r10[panel_r8.itemKey]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(panel_r8.type === null ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(panel_r8.sortable && item_r10.sortDirection ? 9 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(panel_r8.type !== null ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(panel_r8.type === null ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(panel_r8.dragChannels.length > 0 ? 13 : -1);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-list");
    i0.ɵɵrepeaterCreate(1, IgxPivotDataSelectorComponent_For_14_Conditional_10_For_2_Template, 14, 16, "igx-list-item", 20, _forTrack16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const panel_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.grid[panel_r8.dataKey]);
  }
}
function IgxPivotDataSelectorComponent_For_14_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid == null ? null : ctx_r3.grid.resourceStrings.igx_grid_pivot_selector_panel_empty, " ");
  }
}
function IgxPivotDataSelectorComponent_For_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-expansion-panel", 12);
    i0.ɵɵlistener("collapsedChange", function IgxPivotDataSelectorComponent_For_14_Template_igx_expansion_panel_collapsedChange_0_listener($event) {
      const panel_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCollapseChange($event, panel_r8.type));
    });
    i0.ɵɵelementStart(1, "igx-expansion-panel-header", 13);
    i0.ɵɵlistener("enter", function IgxPivotDataSelectorComponent_For_14_Template_igx_expansion_panel_header_enter_1_listener($event) {
      const panel_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onPanelEntry($event, panel_r8.name));
    })("dropped", function IgxPivotDataSelectorComponent_For_14_Template_igx_expansion_panel_header_dropped_1_listener($event) {
      const panel_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemDropped($event, panel_r8.type));
    });
    i0.ɵɵelementStart(2, "igx-expansion-panel-title", 14)(3, "h6", 15);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵelement(6, "igx-icon", 17);
    i0.ɵɵelementStart(7, "igx-chip");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "igx-expansion-panel-body", 18);
    i0.ɵɵlistener("enter", function IgxPivotDataSelectorComponent_For_14_Template_igx_expansion_panel_body_enter_9_listener($event) {
      const panel_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onPanelEntry($event, panel_r8.name));
    })("dropped", function IgxPivotDataSelectorComponent_For_14_Template_igx_expansion_panel_body_dropped_9_listener($event) {
      const panel_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemDropped($event, panel_r8.type));
    });
    i0.ɵɵtemplate(10, IgxPivotDataSelectorComponent_For_14_Conditional_10_Template, 3, 0, "igx-list")(11, IgxPivotDataSelectorComponent_For_14_Conditional_11_Template, 2, 1, "div", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r8 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("animationSettings", ctx_r3.animationSettings)("collapsed", ctx_r3.getPanelCollapsed(panel_r8.type));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", false);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.grid == null ? null : ctx_r3.grid.resourceStrings[panel_r8.i18n], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", panel_r8.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.grid ? ctx_r3.grid[panel_r8.dataKey].length : 0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.grid && ctx_r3.grid[panel_r8.dataKey].length > 0 ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.grid && ctx_r3.grid[panel_r8.dataKey].length === 0 ? 11 : -1);
  }
}
function IgxPivotDataSelectorComponent_For_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-drop-down-item", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", ctx_r3.isSelected(item_r15))("value", item_r15);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r15.label, " ");
  }
}
function IgxPivotDataSelectorComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 33);
    i0.ɵɵelement(2, "igx-icon", 34);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "igx-icon", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r3.ghostWidth, "px");
    i0.ɵɵclassProp("igx-pivot-data-selector__item-ghost--no-drop", !ctx_r3.dropAllowed);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.ghostText);
  }
}
function IgxTreeGridGroupByAreaComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-chip", 4);
    i0.ɵɵpipe(1, "igxGroupByMeta");
    i0.ɵɵpipe(2, "igxGroupByMeta");
    i0.ɵɵpipe(3, "igxGroupByMeta");
    i0.ɵɵpipe(4, "igxGroupByMeta");
    i0.ɵɵlistener("keyDown", function IgxTreeGridGroupByAreaComponent_For_2_Template_igx_chip_keyDown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleKeyDown($event.owner.id, $event.originalEvent));
    })("remove", function IgxTreeGridGroupByAreaComponent_For_2_Template_igx_chip_remove_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearGrouping($event.owner.id));
    })("chipClick", function IgxTreeGridGroupByAreaComponent_For_2_Template_igx_chip_chipClick_0_listener() {
      const expression_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick(expression_r4.fieldName));
    });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "igxGroupByMeta");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "igx-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 6);
    i0.ɵɵelement(10, "igx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const expression_r4 = ctx.$implicit;
    const ɵ$index_3_r5 = ctx.$index;
    const ɵ$count_3_r6 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", expression_r4.fieldName)("title", i0.ɵɵpipeBind3(1, 8, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).title)("removable", i0.ɵɵpipeBind3(2, 12, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable)("draggable", i0.ɵɵpipeBind3(3, 16, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable)("disabled", !i0.ɵɵpipeBind3(4, 20, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).groupable);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 24, expression_r4.fieldName, ctx_r2.grid, ctx_r2.grid.groupablePipeTrigger).title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", expression_r4.dir === 1 ? "sort_asc" : "sort_desc");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ɵ$index_3_r5 === ɵ$count_3_r6 - 1 && !ctx_r2.dropAreaVisible);
  }
}
function IgxTreeGridGroupByAreaComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridGroupByAreaComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 8);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.dropAreaMessage);
  }
}
const _c267 = a0 => ({
  "padding-inline-start": a0
});
const _c268 = a0 => ({
  visibility: a0
});
function IgxTreeGridCellComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-chip", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.grid.resourceStrings.igx_grid_pinned_row_indicator);
  }
}
function IgxTreeGridCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_0_Conditional_0_Template, 2, 4, "igx-chip", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayPinnedChip ? 0 : -1);
  }
}
function IgxTreeGridCellComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "columnFormatter");
    i0.ɵɵpipe(8, "number");
    i0.ɵɵpipe(9, "date");
    i0.ɵɵpipe(10, "currency");
    i0.ɵɵpipe(11, "percent");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(55, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.formatter ? i0.ɵɵpipeBind3(7, 32, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(8, 36, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(9, 40, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(10, 45, i0.ɵɵpureFunction5(61, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(11, 51, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value);
  }
}
function IgxTreeGridCellComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.value ? "confirm" : "close")("ngClass", i0.ɵɵpureFunction2(2, _c220, ctx_r0.value, !ctx_r0.value));
  }
}
function IgxTreeGridCellComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
    i0.ɵɵpipe(1, "igxCellImageAlt");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.value, i0.ɵɵsanitizeUrl)("alt", i0.ɵɵpipeBind1(1, 2, ctx_r0.value));
  }
}
function IgxTreeGridCellComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_2_Conditional_0_Template, 12, 67, "div", 15)(1, IgxTreeGridCellComponent_ng_template_2_Conditional_1_Template, 1, 5, "igx-icon", 16)(2, IgxTreeGridCellComponent_ng_template_2_Conditional_2_Template, 2, 4, "img", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" && ctx_r0.column.dataType !== "image" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" && !ctx_r0.formatter ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "image" ? 2 : -1);
  }
}
function IgxTreeGridCellComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(32, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(!ctx_r0.isEmptyAddRowCell ? ctx_r0.value : ctx_r0.column.header || ctx_r0.column.field);
  }
}
function IgxTreeGridCellComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_4_Conditional_0_Template, 7, 38, "div", 15);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 18);
    i0.ɵɵelementStart(1, "igx-input-group")(2, "input", 20);
    i0.ɵɵlistener("compositionstart", function IgxTreeGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionstart_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = true);
    })("compositionend", function IgxTreeGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionend_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = false);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 18);
    i0.ɵɵelement(1, "input", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 18);
    i0.ɵɵelement(1, "igx-checkbox", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.editValue)("igxFocus", true)("disableRipple", true)("formControl", ctx_r0.formControl);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 18);
    i0.ɵɵelementStart(1, "igx-date-picker", 23);
    i0.ɵɵtwoWayListener("valueChange", function IgxTreeGridCellComponent_ng_template_6_Conditional_3_Template_igx_date_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("weekStart", ctx_r0.column.pipeArgs.weekStart);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 18);
    i0.ɵɵelementStart(1, "igx-time-picker", 24);
    i0.ɵɵtwoWayListener("valueChange", function IgxTreeGridCellComponent_ng_template_6_Conditional_4_Template_igx_time_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 18);
    i0.ɵɵelement(1, "input", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("locale", ctx_r0.grid.locale)("igxDateTimeEditor", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r0.column.dataType)("displayFormat", ctx_r0.column.pipeArgs.format)("igxFocus", true);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-suffix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 18);
    i0.ɵɵtemplate(1, IgxTreeGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template, 2, 1, "igx-prefix");
    i0.ɵɵelement(2, "input", 21);
    i0.ɵɵtemplate(3, IgxTreeGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template, 2, 1, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.currencyPositionLeft ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.grid.currencyPositionLeft ? 3 : -1);
  }
}
function IgxTreeGridCellComponent_ng_template_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 18);
    i0.ɵɵelement(1, "input", 21);
    i0.ɵɵelementStart(2, "igx-suffix");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "percent");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("step", ctx_r0.step)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(4, 10, ctx_r0.editValue, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale), " ");
  }
}
function IgxTreeGridCellComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_6_Conditional_0_Template, 3, 8, "ng-container", 18)(1, IgxTreeGridCellComponent_ng_template_6_Conditional_1_Template, 2, 9, "igx-input-group", 19)(2, IgxTreeGridCellComponent_ng_template_6_Conditional_2_Template, 2, 5, "ng-container", 18)(3, IgxTreeGridCellComponent_ng_template_6_Conditional_3_Template, 2, 11, "ng-container", 18)(4, IgxTreeGridCellComponent_ng_template_6_Conditional_4_Template, 2, 10, "ng-container", 18)(5, IgxTreeGridCellComponent_ng_template_6_Conditional_5_Template, 2, 9, "igx-input-group", 18)(6, IgxTreeGridCellComponent_ng_template_6_Conditional_6_Template, 4, 11, "igx-input-group", 19)(7, IgxTreeGridCellComponent_ng_template_6_Conditional_7_Template, 5, 14, "igx-input-group", 19);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType === "string" || ctx_r0.column.dataType === "image" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "number" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "date" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "time" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "dateTime" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "currency" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "percent" ? 7 : -1);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 29, 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("igx-grid__tree-cell--padding-level-", ctx_r0.level, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c267, "calc(var(--igx-tree-indent-size) *" + ctx_r0.level + ")"));
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30, 9);
    i0.ɵɵlistener("click", function IgxTreeGridCellComponent_Conditional_8_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggle($event));
    })("focus", function IgxTreeGridCellComponent_Conditional_8_Conditional_1_Template_div_focus_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onIndicatorFocus());
    });
    i0.ɵɵtemplate(2, IgxTreeGridCellComponent_Conditional_8_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 12)(3, IgxTreeGridCellComponent_Conditional_8_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c268, ctx_r0.showIndicator ? "visible" : "hidden"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c25, ctx_r0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.pinnedIndicatorTemplate)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("dblclick", function IgxTreeGridCellComponent_Conditional_8_Conditional_2_Template_div_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onLoadingDblClick($event));
    });
    i0.ɵɵtemplate(1, IgxTreeGridCellComponent_Conditional_8_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const defaultLoadingIndicatorTemplate_r7 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.grid.rowLoadingIndicatorTemplate ? ctx_r0.grid.rowLoadingIndicatorTemplate : defaultLoadingIndicatorTemplate_r7);
  }
}
function IgxTreeGridCellComponent_Conditional_8_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 33);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxTreeGridCellComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_Conditional_8_Conditional_0_Template, 2, 6, "div", 26)(1, IgxTreeGridCellComponent_Conditional_8_Conditional_1_Template, 4, 9, "div", 27)(2, IgxTreeGridCellComponent_Conditional_8_Conditional_2_Template, 2, 1, "div", 28)(3, IgxTreeGridCellComponent_Conditional_8_ng_template_3_Template, 1, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.level > 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isLoading ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isLoading ? 2 : -1);
  }
}
function IgxTreeGridCellComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridCellComponent_Conditional_10_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridCellComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 34, 10);
    i0.ɵɵlistener("mouseover", function IgxTreeGridCellComponent_Conditional_10_Template_igx_icon_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = true);
    })("mouseout", function IgxTreeGridCellComponent_Conditional_10_Template_igx_icon_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = false);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 35, 11)(5, "div");
    i0.ɵɵtemplate(6, IgxTreeGridCellComponent_Conditional_10_ng_container_6_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tooltipRef_r9 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultError_r10 = i0.ɵɵreference(16);
    i0.ɵɵproperty("igxTooltipTarget", tooltipRef_r9)("igxToggleOutlet", ctx_r0.grid.outlet);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.ariaErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", "max-content");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellValidationErrorTemplate || defaultError_r10)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxTreeGridCellComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 36);
  }
}
function IgxTreeGridCellComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 37);
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_required_validation_error, " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.minlength.requiredLength), " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.maxlength.requiredLength), " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.min.min), " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.max.max), " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_email_validation_error, " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_pattern_validation_error, " ");
  }
}
function IgxTreeGridCellComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_15_Conditional_0_Template, 2, 1, "div")(1, IgxTreeGridCellComponent_ng_template_15_Conditional_1_Template, 3, 5, "div")(2, IgxTreeGridCellComponent_ng_template_15_Conditional_2_Template, 3, 5, "div")(3, IgxTreeGridCellComponent_ng_template_15_Conditional_3_Template, 3, 5, "div")(4, IgxTreeGridCellComponent_ng_template_15_Conditional_4_Template, 3, 5, "div")(5, IgxTreeGridCellComponent_ng_template_15_Conditional_5_Template, 2, 1, "div")(6, IgxTreeGridCellComponent_ng_template_15_Conditional_6_Template, 2, 1, "div");
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_12_0;
    let tmp_13_0;
    let tmp_14_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_8_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_8_0["required"]) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_9_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_9_0["minlength"]) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_10_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_10_0["maxlength"]) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_11_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_11_0["min"]) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_12_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_12_0["max"]) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_13_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_13_0["email"]) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_14_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_14_0["pattern"]) ? 6 : -1);
  }
}
const _c269 = ["treeCell"];
function IgxTreeGridRowComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("animationend", function IgxTreeGridRowComponent_ng_template_1_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.animationEndHandler());
    });
    i0.ɵɵtemplate(1, IgxTreeGridRowComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultTemp_r3 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("igx-grid__tr--add-animate", ctx_r1.triggerAddAnimationClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultTemp_r3);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function IgxTreeGridRowComponent_ng_template_3_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtemplate(1, IgxTreeGridRowComponent_ng_template_3_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.resolveDragIndicatorClasses);
    i0.ɵɵproperty("igxRowDrag", ctx_r1)("ghostTemplate", ctx_r1.grid.getDragGhostCustomTemplate());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.dragIndicatorIconTemplate ? ctx_r1.grid.dragIndicatorIconTemplate : ctx_r1.grid.dragIndicatorIconBase);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function IgxTreeGridRowComponent_ng_template_3_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_3_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function IgxTreeGridRowComponent_ng_template_3_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRowSelectorClick($event));
    })("pointerdown", function IgxTreeGridRowComponent_ng_template_3_Conditional_1_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(1, IgxTreeGridRowComponent_ng_template_3_Conditional_1_1_Template, 1, 0, null, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const rowSelectorBaseTemplate_r6 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.grid.rowSelectorTemplate ? ctx_r1.grid.rowSelectorTemplate : rowSelectorBaseTemplate_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c25, i0.ɵɵpureFunction4(2, _c223, ctx_r1.viewIndex, ctx_r1.key, ctx_r1.key, ctx_r1.selected)));
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_3_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const pinnedCellsTemplate_r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", pinnedCellsTemplate_r7)("ngTemplateOutletContext", ctx_r1);
  }
}
function IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-cell", 16, 7);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", col_r8.resolvedWidth)("max-width", col_r8.resolvedWidth)("flex-basis", col_r8.resolvedWidth);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 28, i0.ɵɵpureFunction7(56, _c225, ctx_r1.key, col_r8.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", col_r8.dataType === "number" || col_r8.dataType === "percent" || col_r8.dataType === "currency")("igx-grid__td--bool", col_r8.dataType === "boolean");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 36, i0.ɵɵpureFunction6(64, _c63, col_r8.cellClasses, ctx_r1.data[col_r8.field], ctx_r1.data, col_r8.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 43, i0.ɵɵpureFunction6(71, _c63, col_r8.cellStyles, ctx_r1.data[col_r8.field], ctx_r1.data, col_r8.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("editMode", col_r8.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r8.index))("column", col_r8)("formatter", col_r8.formatter)("intRow", ctx_r1)("rowData", ctx_r1.data)("width", col_r8.getCellWidth())("visibleColumnIndex", col_r8.visibleIndex)("value", i0.ɵɵpipeBindV(5, 50, i0.ɵɵpureFunction5(78, _c64, ctx_r1.data, col_r8.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r8.field], col_r8.hasNestedPath)))("cellTemplate", col_r8.bodyTemplate)("cellValidationErrorTemplate", col_r8.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r8.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r8.visibleIndex));
  }
}
function IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-tree-grid-cell", 17, 7);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", col_r8.resolvedWidth)("max-width", col_r8.resolvedWidth)("flex-basis", col_r8.resolvedWidth);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 30, i0.ɵɵpureFunction7(58, _c225, ctx_r1.key, col_r8.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", (col_r8.dataType === "number" || col_r8.dataType === "percent" || col_r8.dataType === "currency") && col_r8.visibleIndex !== 0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 38, i0.ɵɵpureFunction6(66, _c63, col_r8.cellClasses, ctx_r1.data[col_r8.field], ctx_r1.data, col_r8.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 45, i0.ɵɵpureFunction6(73, _c63, col_r8.cellStyles, ctx_r1.data[col_r8.field], ctx_r1.data, col_r8.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("level", ctx_r1.treeRow.level)("expanded", ctx_r1.expanded)("showIndicator", ctx_r1.showIndicator)("editMode", col_r8.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r8.index))("column", col_r8)("formatter", col_r8.formatter)("intRow", ctx_r1)("rowData", ctx_r1.data)("width", col_r8.getCellWidth())("visibleColumnIndex", col_r8.visibleIndex)("value", i0.ɵɵpipeBindV(5, 52, i0.ɵɵpureFunction5(80, _c64, ctx_r1.data, col_r8.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r8.field], col_r8.hasNestedPath)))("isLoading", ctx_r1.isLoading)("cellTemplate", col_r8.bodyTemplate)("cellValidationErrorTemplate", col_r8.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r8.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r8.visibleIndex));
  }
}
function IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_template_0_Template, 6, 84, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(2, IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_template_2_Template, 6, 86, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(4, IgxTreeGridRowComponent_ng_template_3_ng_template_3_ng_container_4_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const col_r8 = ctx.$implicit;
    const cellTemplate_r9 = i0.ɵɵreference(1);
    const treeCellTemplate_r10 = i0.ɵɵreference(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", col_r8.visibleIndex === 0 ? treeCellTemplate_r10 : cellTemplate_r9);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_3_Conditional_6_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const pinnedCellsTemplate_r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", pinnedCellsTemplate_r7)("ngTemplateOutletContext", ctx_r1);
  }
}
function IgxTreeGridRowComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_3_Conditional_0_Template, 2, 5, "div", 10)(1, IgxTreeGridRowComponent_ng_template_3_Conditional_1_Template, 2, 9, "div", 11)(2, IgxTreeGridRowComponent_ng_template_3_Conditional_2_Template, 1, 2, "ng-container")(3, IgxTreeGridRowComponent_ng_template_3_ng_template_3_Template, 5, 1, "ng-template", 12, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(5, "igxNotGrouped");
    i0.ɵɵtemplate(6, IgxTreeGridRowComponent_ng_template_3_Conditional_6_Template, 1, 2, "ng-container");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.rowDraggable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showRowSelectors ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && ctx_r1.grid.isPinningToStart ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(5, 10, ctx_r1.unpinnedColumns))("igxForScrollContainer", ctx_r1.grid.parentVirtDir)("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx_r1.grid.unpinnedWidth)("igxForSizePropName", "calcPixelWidth")("igxForTrackBy", ctx_r1.grid.trackColumnChanges);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.pinnedColumns.length > 0 && !ctx_r1.grid.isPinningToStart ? 6 : -1);
  }
}
function IgxTreeGridRowComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "igx-checkbox", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("readonly", true)("checked", ctx_r1.selected)("indeterminate", ctx_r1.indeterminate)("disabled", ctx_r1.deleted)("disableRipple", true)("disableTransitions", ctx_r1.grid.disableTransitions)("aria-label", ctx_r1.rowCheckboxAriaLabel);
  }
}
function IgxTreeGridRowComponent_ng_template_7_For_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-cell", 20, 7);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", col_r11.resolvedWidth)("max-width", col_r11.resolvedWidth)("flex-basis", col_r11.resolvedWidth)("left", col_r11.rightPinnedOffset);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 30, i0.ɵɵpureFunction7(58, _c225, ctx_r1.key, col_r11.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", col_r11.dataType === "number" || col_r11.dataType === "percent" || col_r11.dataType === "currency");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 38, i0.ɵɵpureFunction6(66, _c63, col_r11.cellClasses, ctx_r1.data[col_r11.field], ctx_r1.data, col_r11.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 45, i0.ɵɵpureFunction6(73, _c63, col_r11.cellStyles, ctx_r1.data[col_r11.field], ctx_r1.data, col_r11.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("editMode", col_r11.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r11.index))("column", col_r11)("formatter", col_r11.formatter)("intRow", ctx_r1)("firstPinned", col_r11.isFirstPinned)("lastPinned", col_r11.isLastPinned)("rowData", ctx_r1.data)("width", col_r11.getCellWidth())("visibleColumnIndex", col_r11.visibleIndex)("value", i0.ɵɵpipeBindV(5, 52, i0.ɵɵpureFunction5(80, _c64, ctx_r1.data, col_r11.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r11.field], col_r11.hasNestedPath)))("cellTemplate", col_r11.bodyTemplate)("cellValidationErrorTemplate", col_r11.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r11.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r11.visibleIndex));
  }
}
function IgxTreeGridRowComponent_ng_template_7_For_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-tree-grid-cell", 21, 7);
    i0.ɵɵpipe(2, "transactionState");
    i0.ɵɵpipe(3, "igxCellStyleClasses");
    i0.ɵɵpipe(4, "igxCellStyles");
    i0.ɵɵpipe(5, "dataMapper");
  }
  if (rf & 2) {
    const col_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", col_r11.resolvedWidth)("max-width", col_r11.resolvedWidth)("flex-basis", col_r11.resolvedWidth)("left", col_r11.rightPinnedOffset);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(2, 33, i0.ɵɵpureFunction7(61, _c225, ctx_r1.key, col_r11.field, ctx_r1.grid.rowEditable, ctx_r1.grid.transactions, ctx_r1.grid.pipeTrigger, ctx_r1.grid.gridAPI.crudService.cell, ctx_r1.grid.gridAPI.crudService.row)))("igx-grid__td--number", (col_r11.dataType === "number" || col_r11.dataType === "percent" || col_r11.dataType === "currency") && col_r11.visibleIndex !== 0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(3, 41, i0.ɵɵpureFunction6(69, _c63, col_r11.cellClasses, ctx_r1.data[col_r11.field], ctx_r1.data, col_r11.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(4, 48, i0.ɵɵpureFunction6(76, _c63, col_r11.cellStyles, ctx_r1.data[col_r11.field], ctx_r1.data, col_r11.field, ctx_r1.viewIndex, ctx_r1.grid.pipeTrigger)))("level", ctx_r1.treeRow.level)("expanded", ctx_r1.expanded)("showIndicator", ctx_r1.showIndicator)("editMode", col_r11.editable && ctx_r1.grid.crudService.targetInEdit(ctx_r1.index, col_r11.index))("column", col_r11)("formatter", col_r11.formatter)("intRow", ctx_r1)("lastPinned", col_r11.isLastPinned)("rowData", ctx_r1.data)("width", col_r11.getCellWidth())("visibleColumnIndex", col_r11.visibleIndex)("value", i0.ɵɵpipeBindV(5, 55, i0.ɵɵpureFunction5(83, _c64, ctx_r1.data, col_r11.field, ctx_r1.grid.pipeTrigger, ctx_r1.data[col_r11.field], col_r11.hasNestedPath)))("isLoading", ctx_r1.isLoading)("cellTemplate", col_r11.bodyTemplate)("cellValidationErrorTemplate", col_r11.errorTemplate)("lastSearchInfo", ctx_r1.grid.lastSearchInfo)("active", ctx_r1.isCellActive(col_r11.visibleIndex))("cellSelectionMode", ctx_r1.grid.cellSelection)("displayPinnedChip", ctx_r1.shouldDisplayPinnedChip(col_r11.visibleIndex));
  }
}
function IgxTreeGridRowComponent_ng_template_7_For_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridRowComponent_ng_template_7_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_template_7_For_1_ng_template_0_Template, 6, 86, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(2, IgxTreeGridRowComponent_ng_template_7_For_1_ng_template_2_Template, 6, 89, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(4, IgxTreeGridRowComponent_ng_template_7_For_1_ng_container_4_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const col_r11 = ctx.$implicit;
    const cellTemplate_r12 = i0.ɵɵreference(1);
    const treeCellTemplate_r13 = i0.ɵɵreference(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", col_r11.visibleIndex === 0 ? treeCellTemplate_r13 : cellTemplate_r12);
  }
}
function IgxTreeGridRowComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxTreeGridRowComponent_ng_template_7_For_1_Template, 5, 1, null, null, _forTrack9, true);
    i0.ɵɵpipe(2, "igxNotGrouped");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r1.pinnedColumns));
  }
}
const _c270 = [[["igx-grid-toolbar"], ["igc-grid-toolbar"]], [["igx-tree-grid-group-by-area"], ["igc-tree-grid-group-by-area"]], [["igx-grid-footer"], ["igc-grid-footer"]], [["igx-paginator"], ["igc-paginator"]], [["igx-grid-state"], ["igc-grid-state"]], [["igx-column"], ["igc-column"], ["igx-column-group"], ["igc-column-group"], ["igx-action-strip"], ["igc-action-strip"]]];
const _c271 = ["igx-grid-toolbar,igc-grid-toolbar", "igx-tree-grid-group-by-area,igc-tree-grid-group-by-area", "igx-grid-footer,igc-grid-footer", "igx-paginator,igc-paginator", "igx-grid-state,igc-grid-state", "igx-column,igc-column,igx-column-group,igc-column-group,igx-action-strip,igc-action-strip"];
const _c272 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4, true];
const _c273 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) => [a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11];
function _forTrack17($index, $item) {
  return this.trackPinnedRowData($item);
}
function IgxTreeGridComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxTreeGridComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 63);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_For_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_For_3_ng_container_0_Template, 1, 0, "ng-container", 38);
  }
  if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    const ɵ$index_28_r4 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const pinned_record_template_r5 = i0.ɵɵreference(27);
    i0.ɵɵproperty("ngTemplateOutlet", pinned_record_template_r5)("ngTemplateOutletContext", ctx_r1.getContext(rowData_r3, ɵ$index_28_r4, true));
  }
}
function IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65, 25);
    i0.ɵɵrepeaterCreate(2, IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_For_3_Template, 1, 2, "ng-container", null, _forTrack17, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pinnedData_r6 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c235, !ctx_r1.isRowPinningToTop, ctx_r1.isRowPinningToTop));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(pinnedData_r6);
  }
}
function IgxTreeGridComponent_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridComponent_ng_template_8_Conditional_0_Conditional_0_Template, 4, 6, "div", 64);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length > 0 ? 0 : -1);
  }
}
function IgxTreeGridComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTreeGridComponent_ng_template_8_Conditional_0_Template, 1, 1);
    i0.ɵɵpipe(1, "treeGridTransaction");
    i0.ɵɵpipe(2, "visibleColumns");
    i0.ɵɵpipe(3, "treeGridNormalizeRecord");
    i0.ɵɵpipe(4, "treeGridAddRow");
    i0.ɵɵpipe(5, "gridRowPinning");
    i0.ɵɵpipe(6, "treeGridFiltering");
    i0.ɵɵpipe(7, "treeGridSorting");
  }
  if (rf & 2) {
    let tmp_26_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_26_0 = i0.ɵɵpipeBindV(7, 27, i0.ɵɵpureFunction5(41, _c272, i0.ɵɵpipeBindV(6, 19, i0.ɵɵpureFunction6(34, _c234, i0.ɵɵpipeBind4(5, 14, i0.ɵɵpipeBind3(4, 10, i0.ɵɵpipeBind2(3, 7, i0.ɵɵpipeBind2(2, 4, i0.ɵɵpipeBind2(1, 1, ctx_r1.data, ctx_r1.pipeTrigger), ctx_r1.hasVisibleColumns), ctx_r1.pipeTrigger), true, ctx_r1.pipeTrigger), ctx_r1.id, true, ctx_r1.pipeTrigger), ctx_r1.filteringExpressionsTree, ctx_r1.filterStrategy, ctx_r1.advancedFilteringExpressionsTree, ctx_r1.pipeTrigger, ctx_r1.filteringPipeTrigger)), ctx_r1.sortingExpressions, ctx_r1.treeGroupArea == null ? null : ctx_r1.treeGroupArea.expressions, ctx_r1.sortStrategy, ctx_r1.pipeTrigger))) ? 0 : -1, tmp_26_0);
  }
}
function IgxTreeGridComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_11_ng_template_0_Template(rf, ctx) {}
function IgxTreeGridComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxTreeGridComponent_ng_template_11_ng_template_0_Template, 0, 0, "ng-template", 66);
    i0.ɵɵlistener("cachedViewLoaded", function IgxTreeGridComponent_ng_template_11_Template_ng_template_cachedViewLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cachedViewLoaded($event));
    });
  }
  if (rf & 2) {
    const rowData_r8 = ctx.$implicit;
    const rowIndex_r9 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    const record_template_r10 = i0.ɵɵreference(25);
    const summary_template_r11 = i0.ɵɵreference(29);
    i0.ɵɵproperty("igxTemplateOutlet", ctx_r1.isSummaryRow(rowData_r8) ? summary_template_r11 : record_template_r10)("igxTemplateOutletContext", ctx_r1.getContext(rowData_r8, rowIndex_r9, false));
  }
}
function IgxTreeGridComponent_ng_container_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-tree-grid-row", 67, 26);
    i0.ɵɵpipe(2, "igxGridRowClasses");
    i0.ɵɵpipe(3, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r12 = ctx.index;
    const disabledRow_r13 = ctx.disabled;
    const rowData_r14 = ctx.$implicit;
    const row_r15 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r12)("treeRow", rowData_r14)("disabled", disabledRow_r13)("ngClass", i0.ɵɵpipeBindV(2, 6, i0.ɵɵpureFunctionV(24, _c273, [ctx_r1.rowClasses, row_r15, row_r15.inEditMode, row_r15.selected, row_r15.dirty, row_r15.deleted, row_r15.dragging, rowIndex_r12, ctx_r1.hasColumnLayouts, row_r15.treeRow.isFilteredOutParent, rowData_r14, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(3, 19, ctx_r1.rowStyles, rowData_r14, rowIndex_r12, ctx_r1.pipeTrigger));
  }
}
function IgxTreeGridComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-tree-grid-row", 68, 27);
    i0.ɵɵpipe(3, "igxGridRowClasses");
    i0.ɵɵpipe(4, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r16 = ctx.index;
    const rowData_r17 = ctx.$implicit;
    const row_r18 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r16)("treeRow", rowData_r17)("ngClass", i0.ɵɵpipeBindV(3, 5, i0.ɵɵpureFunctionV(23, _c273, [ctx_r1.rowClasses, row_r18, row_r18.inEditMode, row_r18.selected, row_r18.dirty, row_r18.deleted, row_r18.dragging, rowIndex_r16, ctx_r1.hasColumnLayouts, row_r18.treeRow.isFilteredOutParent, rowData_r17, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(4, 18, ctx_r1.rowStyles, rowData_r17, rowIndex_r16, ctx_r1.pipeTrigger));
  }
}
function IgxTreeGridComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-row", 69, 28);
  }
  if (rf & 2) {
    const rowIndex_r19 = ctx.index;
    const rowData_r20 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("summaries", rowData_r20.summaries)("firstCellIndentation", rowData_r20.cellIndentation)("index", rowIndex_r19);
  }
}
function IgxTreeGridComponent_ng_container_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_Conditional_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 41);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxTreeGridComponent_Conditional_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 42);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxTreeGridComponent_ng_template_40_Template(rf, ctx) {}
function IgxTreeGridComponent_Conditional_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-row", 70, 28);
    i0.ɵɵpipe(2, "igxGridSummaryDataPipe");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px")("height", ctx_r1.summaryRowHeight, "px");
    i0.ɵɵproperty("gridID", ctx_r1.id)("summaries", i0.ɵɵpipeBind2(2, 7, ctx_r1.id, ctx_r1.summaryService.retriggerRootPipe))("index", ctx_r1.dataView.length);
  }
}
function IgxTreeGridComponent_ng_template_58_Template(rf, ctx) {}
function IgxTreeGridComponent_ng_template_65_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_65_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxTreeGridComponent_ng_template_65_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r21 = i0.ɵɵreference(70);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r21);
  }
}
function IgxTreeGridComponent_ng_template_65_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 71)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxTreeGridComponent_ng_template_65_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyFilteredGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxTreeGridComponent_ng_template_67_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_67_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxTreeGridComponent_ng_template_67_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r21 = i0.ɵɵreference(70);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r21);
  }
}
function IgxTreeGridComponent_ng_template_67_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 71)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxTreeGridComponent_ng_template_67_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxTreeGridComponent_ng_template_69_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 72);
    i0.ɵɵlistener("click", function IgxTreeGridComponent_ng_template_69_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r22);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.crudService.enterAddRowMode(null, false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.resourceStrings.igx_grid_add_row_label, " ");
  }
}
function IgxTreeGridComponent_ng_template_71_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelement(1, "igx-circular-bar", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxTreeGridComponent_Conditional_73_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_Conditional_73_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40, 29)(2, "div", 74);
    i0.ɵɵtemplate(3, IgxTreeGridComponent_Conditional_73_ng_container_3_Template, 1, 0, "ng-container", 38);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("className", ctx_r1.bannerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rowEditContainer)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c239, ctx_r1.rowChangesCount, ctx_r1.crudService.endEdit.bind(ctx_r1)));
  }
}
function IgxTreeGridComponent_ng_template_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "igxStringReplace");
    i0.ɵɵpipe(2, "igxStringReplace");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 5, i0.ɵɵpipeBind3(1, 1, ctx_r1.resourceStrings.igx_grid_row_edit_text, "{0}", ctx_r1.rowChangesCount.toString()), "{1}", ctx_r1.hiddenColumnsCount.toString()), "\n");
  }
}
function IgxTreeGridComponent_ng_template_76_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 75);
    i0.ɵɵlistener("click", function IgxTreeGridComponent_ng_template_76_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 75);
    i0.ɵɵlistener("click", function IgxTreeGridComponent_ng_template_76_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(true, $event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_cancel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_done);
  }
}
function IgxTreeGridComponent_ng_template_78_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_78_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTreeGridComponent_ng_template_78_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76)(1, "span", 77);
    i0.ɵɵtemplate(2, IgxTreeGridComponent_ng_template_78_ng_container_2_Template, 1, 0, "ng-container", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 78)(4, "div", 79);
    i0.ɵɵtemplate(5, IgxTreeGridComponent_ng_template_78_ng_container_5_Template, 1, 0, "ng-container", 38);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultRowEditText_r24 = i0.ɵɵreference(75);
    const defaultRowEditActions_r25 = i0.ɵɵreference(77);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) === "IgxAddRow" ? ctx_r1.rowAddTextTemplate : ctx_r1.rowEditTextTemplate ? ctx_r1.rowEditTextTemplate : defaultRowEditText_r24)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c25, (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) !== "IgxAddRow" ? ctx_r1.rowChangesCount : null));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rowEditActionsTemplate ? ctx_r1.rowEditActionsTemplate : defaultRowEditActions_r25)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx_r1.endEdit.bind(ctx_r1)));
  }
}
function IgxTreeGridComponent_ng_template_80_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 80);
  }
}
function IgxTreeGridComponent_Conditional_82_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-column-resizer");
  }
}
function IgxTreeGridComponent_Conditional_87_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62, 30);
    i0.ɵɵprojection(2, 4);
    i0.ɵɵprojection(3, 5);
    i0.ɵɵelementEnd();
  }
}
const _c274 = [[["igx-column"], ["igc-column"], ["igx-column-group"], ["igc-column-group"], ["igx-action-strip"], ["igc-action-strip"]], [["igx-row-island"], ["igc-row-island"]]];
const _c275 = ["igx-column,igc-column,igx-column-group,igc-column-group,igx-action-strip,igc-action-strip", "igx-row-island,igc-row-island"];
function IgxRowIslandComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1, 0);
    i0.ɵɵprojection(2);
    i0.ɵɵprojection(3, 1);
    i0.ɵɵelementEnd();
  }
}
function IgxHierarchicalGridCellComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-chip", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("--ig-size", 1);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.grid.resourceStrings.igx_grid_pinned_row_indicator);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_0_Conditional_0_Template, 2, 4, "igx-chip", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayPinnedChip ? 0 : -1);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "columnFormatter");
    i0.ɵɵpipe(8, "number");
    i0.ɵɵpipe(9, "date");
    i0.ɵɵpipe(10, "currency");
    i0.ɵɵpipe(11, "percent");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind4(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData, ctx_r0.columnData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 14, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 18, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 23, i0.ɵɵpureFunction5(57, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 29, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.formatter ? i0.ɵɵpipeBind4(7, 33, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData, ctx_r0.columnData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(8, 38, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(9, 42, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(10, 47, i0.ɵɵpureFunction5(63, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(11, 53, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.value ? "confirm" : "close")("ngClass", i0.ɵɵpureFunction2(2, _c220, ctx_r0.value, !ctx_r0.value));
  }
}
function IgxHierarchicalGridCellComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
    i0.ɵɵpipe(1, "igxCellImageAlt");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.value, i0.ɵɵsanitizeUrl)("alt", i0.ɵɵpipeBind1(1, 2, ctx_r0.value));
  }
}
function IgxHierarchicalGridCellComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_2_Conditional_0_Template, 12, 69, "div", 10)(1, IgxHierarchicalGridCellComponent_ng_template_2_Conditional_1_Template, 1, 5, "igx-icon", 11)(2, IgxHierarchicalGridCellComponent_ng_template_2_Conditional_2_Template, 2, 4, "img", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" && ctx_r0.column.dataType !== "image" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" && !ctx_r0.formatter ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "image" ? 2 : -1);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "columnFormatter");
    i0.ɵɵpipe(2, "number");
    i0.ɵɵpipe(3, "date");
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵpipe(5, "percent");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cssClass", ctx_r0.highlightClass)("activeCssClass", ctx_r0.activeHighlightClass)("groupName", ctx_r0.gridID)("value", ctx_r0.formatter ? i0.ɵɵpipeBind3(1, 9, ctx_r0.value, ctx_r0.formatter, ctx_r0.rowData) : ctx_r0.column.dataType === "number" ? i0.ɵɵpipeBind3(2, 13, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.column.dataType === "date" || ctx_r0.column.dataType === "time" || ctx_r0.column.dataType === "dateTime" ? i0.ɵɵpipeBind4(3, 17, ctx_r0.value, ctx_r0.column.pipeArgs.format, ctx_r0.column.pipeArgs.timezone, ctx_r0.grid.locale) : ctx_r0.column.dataType === "currency" ? i0.ɵɵpipeBindV(4, 22, i0.ɵɵpureFunction5(32, _c64, ctx_r0.value, ctx_r0.currencyCode, ctx_r0.column.pipeArgs.display, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale)) : ctx_r0.column.dataType === "percent" ? i0.ɵɵpipeBind3(5, 28, ctx_r0.value, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale) : ctx_r0.value)("row", ctx_r0.rowData)("column", ctx_r0.column.field)("containerClass", "igx-grid__td-text")("metadata", ctx_r0.searchMetadata);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(!ctx_r0.isEmptyAddRowCell ? ctx_r0.value : ctx_r0.column.header || ctx_r0.column.field);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_4_Conditional_0_Template, 7, 38, "div", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType !== "boolean" || ctx_r0.column.dataType === "boolean" && ctx_r0.formatter ? 0 : -1);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-input-group")(2, "input", 14);
    i0.ɵɵlistener("compositionstart", function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionstart_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = true);
    })("compositionend", function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_0_Template_input_compositionend_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.grid.crudService.isInCompositionMode = false);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelement(1, "igx-checkbox", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.editValue)("igxFocus", true)("disableRipple", true)("formControl", ctx_r0.formControl);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-date-picker", 17);
    i0.ɵɵtwoWayListener("valueChange", function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_3_Template_igx_date_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("weekStart", ctx_r0.column.pipeArgs.weekStart);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "igx-time-picker", 18);
    i0.ɵɵtwoWayListener("valueChange", function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_4_Template_igx_time_picker_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.editValue, $event) || (ctx_r0.editValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", 100, "%");
    i0.ɵɵproperty("outlet", ctx_r0.grid.outlet)("locale", ctx_r0.grid.locale)("inputFormat", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("displayFormat", ctx_r0.column.pipeArgs.format);
    i0.ɵɵtwoWayProperty("value", ctx_r0.editValue);
    i0.ɵɵproperty("igxFocus", true)("formControl", ctx_r0.formControl);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formControl)("locale", ctx_r0.grid.locale)("igxDateTimeEditor", ctx_r0.column.editorOptions == null ? null : ctx_r0.column.editorOptions.dateTimeFormat)("defaultFormatType", ctx_r0.column.dataType)("displayFormat", ctx_r0.column.pipeArgs.format)("igxFocus", true);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-suffix");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currencyCodeSymbol);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵtemplate(1, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Conditional_1_Template, 2, 1, "igx-prefix");
    i0.ɵɵelement(2, "input", 15);
    i0.ɵɵtemplate(3, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Conditional_3_Template, 2, 1, "igx-suffix");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.grid.currencyPositionLeft ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.grid.currencyPositionLeft ? 3 : -1);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-input-group", 13);
    i0.ɵɵelement(1, "input", 15);
    i0.ɵɵelementStart(2, "igx-suffix");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "percent");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxFocus", true)("igxTextSelection", true)("step", ctx_r0.step)("formControl", ctx_r0.formControl);
    i0.ɵɵattribute("aria-describedby", ctx_r0.ariaDescribeBy)("aria-invalid", ctx_r0.isInvalid);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(4, 8, ctx_r0.editValue, ctx_r0.column.pipeArgs.digitsInfo, ctx_r0.grid.locale), " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_0_Template, 3, 6, "ng-container", 13)(1, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_1_Template, 2, 7, "igx-input-group", 13)(2, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_2_Template, 2, 5, "ng-container", 13)(3, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_3_Template, 2, 11, "ng-container", 13)(4, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_4_Template, 2, 10, "ng-container", 13)(5, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_5_Template, 2, 9, "igx-input-group", 13)(6, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_6_Template, 4, 9, "igx-input-group", 13)(7, IgxHierarchicalGridCellComponent_ng_template_6_Conditional_7_Template, 5, 12, "igx-input-group", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.column.dataType === "string" || ctx_r0.column.dataType === "image" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "number" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "boolean" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "date" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "time" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "dateTime" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "currency" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.column.dataType === "percent" ? 7 : -1);
  }
}
function IgxHierarchicalGridCellComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridCellComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridCellComponent_Conditional_10_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridCellComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 20, 5);
    i0.ɵɵlistener("mouseover", function IgxHierarchicalGridCellComponent_Conditional_10_Template_igx_icon_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = true);
    })("mouseout", function IgxHierarchicalGridCellComponent_Conditional_10_Template_igx_icon_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.errorShowing = false);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 21, 6)(5, "div");
    i0.ɵɵtemplate(6, IgxHierarchicalGridCellComponent_Conditional_10_ng_container_6_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tooltipRef_r6 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultError_r7 = i0.ɵɵreference(12);
    i0.ɵɵproperty("igxTooltipTarget", tooltipRef_r6)("igxToggleOutlet", ctx_r0.grid.outlet);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.ariaErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", "max-content");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellValidationErrorTemplate || defaultError_r7)("ngTemplateOutletContext", ctx_r0.context);
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_required_validation_error, " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.minlength.requiredLength), " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_length_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.maxlength.requiredLength), " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_min_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.min.min), " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "igxStringReplace");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, ctx_r0.grid.resourceStrings.igx_grid_max_validation_error, "{0}", ctx_r0.formGroup.get(ctx_r0.column.field).errors.max.max), " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_email_validation_error, " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grid.resourceStrings.igx_grid_pattern_validation_error, " ");
  }
}
function IgxHierarchicalGridCellComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_0_Template, 2, 1, "div")(1, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_1_Template, 3, 5, "div")(2, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_2_Template, 3, 5, "div")(3, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_3_Template, 3, 5, "div")(4, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_4_Template, 3, 5, "div")(5, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_5_Template, 2, 1, "div")(6, IgxHierarchicalGridCellComponent_ng_template_11_Conditional_6_Template, 2, 1, "div");
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_12_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_6_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_6_0["required"]) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_7_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_7_0["minlength"]) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_8_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_8_0["maxlength"]) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_9_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_9_0["min"]) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_10_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_10_0["max"]) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_11_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_11_0["email"]) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.formGroup == null ? null : (tmp_12_0 = ctx_r0.formGroup.get(ctx_r0.column == null ? null : ctx_r0.column.field).errors) == null ? null : tmp_12_0["pattern"]) ? 6 : -1);
  }
}
const _c276 = ["expander"];
const _c277 = ["defaultEmptyTemplate"];
const _c278 = (a0, a1, a2, a3, a4, a5) => ({
  index: a0,
  rowID: a1,
  key: a2,
  selected: a3,
  select: a4,
  deselect: a5
});
function IgxHierarchicalRowComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalRowComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", !ctx_r0.added);
  }
}
function IgxHierarchicalRowComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", !ctx_r0.added);
  }
}
function IgxHierarchicalRowComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon");
  }
}
function IgxHierarchicalRowComponent_ng_template_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalRowComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("animationend", function IgxHierarchicalRowComponent_ng_template_7_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.animationEndHandler());
    });
    i0.ɵɵtemplate(1, IgxHierarchicalRowComponent_ng_template_7_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultTemp_r3 = i0.ɵɵreference(10);
    i0.ɵɵclassProp("igx-grid__tr--add-animate", ctx_r0.triggerAddAnimationClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultTemp_r3);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function IgxHierarchicalRowComponent_ng_template_9_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.stopPropagation());
    })("pointerdown", function IgxHierarchicalRowComponent_ng_template_9_Conditional_0_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(1, IgxHierarchicalRowComponent_ng_template_9_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.resolveDragIndicatorClasses);
    i0.ɵɵproperty("igxRowDrag", ctx_r0)("ghostTemplate", ctx_r0.grid.getDragGhostCustomTemplate());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.grid.dragIndicatorIconTemplate ? ctx_r0.grid.dragIndicatorIconTemplate : ctx_r0.grid.dragIndicatorIconBase);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function IgxHierarchicalRowComponent_ng_template_9_Conditional_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onRowSelectorClick($event));
    })("pointerdown", function IgxHierarchicalRowComponent_ng_template_9_Conditional_1_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(1, IgxHierarchicalRowComponent_ng_template_9_Conditional_1_1_Template, 1, 0, null, 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const rowSelectorBaseTemplate_r6 = i0.ɵɵreference(9);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.grid.rowSelectorTemplate ? ctx_r0.grid.rowSelectorTemplate : rowSelectorBaseTemplate_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c25, i0.ɵɵpureFunction6(2, _c278, ctx_r0.viewIndex, ctx_r0.key, ctx_r0.key, ctx_r0.selected, ctx_r0.select, ctx_r0.deselect)));
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20, 8);
    i0.ɵɵlistener("click", function IgxHierarchicalRowComponent_ng_template_9_Conditional_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.expanderClick($event));
    })("mousedown", function IgxHierarchicalRowComponent_ng_template_9_Conditional_2_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(2, IgxHierarchicalRowComponent_ng_template_9_Conditional_2_ng_container_2_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.expanderClassResolved);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c25, ctx_r0));
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_3_0_ng_template_0_Template(rf, ctx) {}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_3_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_3_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_3_0_Template, 1, 0, null, 19);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const pinnedCellsTemplate_r8 = i0.ɵɵreference(11);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", pinnedCellsTemplate_r8)("ngTemplateOutletContext", ctx_r0);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-hierarchical-grid-cell", 21);
    i0.ɵɵpipe(1, "transactionState");
    i0.ɵɵpipe(2, "igxCellStyleClasses");
    i0.ɵɵpipe(3, "igxCellStyles");
    i0.ɵɵpipe(4, "dataMapper");
  }
  if (rf & 2) {
    const col_r9 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", col_r9.resolvedWidth)("max-width", col_r9.resolvedWidth)("flex-basis", col_r9.resolvedWidth);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(1, 28, i0.ɵɵpureFunction7(56, _c225, ctx_r0.key, col_r9.field, ctx_r0.grid.rowEditable, ctx_r0.grid.transactions, ctx_r0.grid.pipeTrigger, ctx_r0.grid.gridAPI.crudService.cell, ctx_r0.grid.gridAPI.crudService.row)))("igx-grid__td--number", col_r9.dataType === "number" || col_r9.dataType === "percent" || col_r9.dataType === "currency")("igx-grid__td--bool", col_r9.dataType === "boolean");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(2, 36, i0.ɵɵpureFunction6(64, _c63, col_r9.cellClasses, ctx_r0.data[col_r9.field], ctx_r0.data, col_r9.field, ctx_r0.viewIndex, ctx_r0.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(3, 43, i0.ɵɵpureFunction6(71, _c63, col_r9.cellStyles, ctx_r0.data[col_r9.field], ctx_r0.data, col_r9.field, ctx_r0.viewIndex, ctx_r0.grid.pipeTrigger)))("editMode", col_r9.editable && ctx_r0.grid.crudService.targetInEdit(ctx_r0.index, col_r9.index))("column", col_r9)("formatter", col_r9.formatter)("intRow", ctx_r0)("active", ctx_r0.isCellActive(col_r9.visibleIndex))("rowData", ctx_r0.data)("width", col_r9.getCellWidth())("visibleColumnIndex", col_r9.visibleIndex)("value", i0.ɵɵpipeBindV(4, 50, i0.ɵɵpureFunction5(78, _c64, ctx_r0.data, col_r9.field, ctx_r0.grid.pipeTrigger, ctx_r0.data[col_r9.field], col_r9.hasNestedPath)))("cellTemplate", col_r9.bodyTemplate)("cellValidationErrorTemplate", col_r9.errorTemplate)("lastSearchInfo", ctx_r0.grid.lastSearchInfo)("cellSelectionMode", ctx_r0.grid.cellSelection)("displayPinnedChip", ctx_r0.shouldDisplayPinnedChip(col_r9.visibleIndex));
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_7_0_ng_template_0_Template(rf, ctx) {}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_7_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_7_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_7_0_Template, 1, 0, null, 19);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const pinnedCellsTemplate_r8 = i0.ɵɵreference(11);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", pinnedCellsTemplate_r8)("ngTemplateOutletContext", ctx_r0);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "igx-checkbox", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", -1)("readonly", true)("checked", ctx_r0.selected)("disableRipple", true)("disabled", ctx_r0.deleted)("disableTransitions", ctx_r0.grid.disableTransitions)("aria-label", ctx_r0.rowCheckboxAriaLabel);
  }
}
function IgxHierarchicalRowComponent_ng_template_9_ng_template_10_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-hierarchical-grid-cell", 25);
    i0.ɵɵpipe(1, "transactionState");
    i0.ɵɵpipe(2, "igxCellStyleClasses");
    i0.ɵɵpipe(3, "igxCellStyles");
    i0.ɵɵpipe(4, "dataMapper");
  }
  if (rf & 2) {
    const col_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("min-width", col_r10.resolvedWidth)("max-width", col_r10.resolvedWidth)("flex-basis", col_r10.resolvedWidth)("left", col_r10.rightPinnedOffset);
    i0.ɵɵclassProp("igx-grid__td--edited", i0.ɵɵpipeBindV(1, 30, i0.ɵɵpureFunction7(58, _c225, ctx_r0.key, col_r10.field, ctx_r0.grid.rowEditable, ctx_r0.grid.transactions, ctx_r0.grid.pipeTrigger, ctx_r0.grid.gridAPI.crudService.cell, ctx_r0.grid.gridAPI.crudService.row)))("igx-grid__td--number", col_r10.dataType === "number" || col_r10.dataType === "percent" || col_r10.dataType === "currency");
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBindV(2, 38, i0.ɵɵpureFunction6(66, _c63, col_r10.cellClasses, ctx_r0.data[col_r10.field], ctx_r0.data, col_r10.field, ctx_r0.viewIndex, ctx_r0.grid.pipeTrigger)))("ngStyle", i0.ɵɵpipeBindV(3, 45, i0.ɵɵpureFunction6(73, _c63, col_r10.cellStyles, ctx_r0.data[col_r10.field], ctx_r0.data, col_r10.field, ctx_r0.viewIndex, ctx_r0.grid.pipeTrigger)))("editMode", col_r10.editable && ctx_r0.grid.crudService.targetInEdit(ctx_r0.index, col_r10.index))("column", col_r10)("formatter", col_r10.formatter)("intRow", ctx_r0)("active", ctx_r0.isCellActive(col_r10.visibleIndex))("firstPinned", col_r10.isFirstPinned)("lastPinned", col_r10.isLastPinned)("rowData", ctx_r0.data)("width", col_r10.getCellWidth())("visibleColumnIndex", col_r10.visibleIndex)("value", i0.ɵɵpipeBindV(4, 52, i0.ɵɵpureFunction5(80, _c64, ctx_r0.data, col_r10.field, ctx_r0.grid.pipeTrigger, ctx_r0.data[col_r10.field], col_r10.hasNestedPath)))("cellTemplate", col_r10.bodyTemplate)("cellValidationErrorTemplate", col_r10.errorTemplate)("lastSearchInfo", ctx_r0.grid.lastSearchInfo)("cellSelectionMode", ctx_r0.grid.cellSelection)("displayPinnedChip", ctx_r0.shouldDisplayPinnedChip(col_r10.visibleIndex));
  }
}
function IgxHierarchicalRowComponent_ng_template_9_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, IgxHierarchicalRowComponent_ng_template_9_ng_template_10_For_1_Template, 5, 86, "igx-hierarchical-grid-cell", 24, _forTrack9, true);
    i0.ɵɵpipe(2, "igxNotGrouped");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx_r0.pinnedColumns));
  }
}
function IgxHierarchicalRowComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_template_9_Conditional_0_Template, 2, 5, "div", 13)(1, IgxHierarchicalRowComponent_ng_template_9_Conditional_1_Template, 2, 11, "div", 14)(2, IgxHierarchicalRowComponent_ng_template_9_Conditional_2_Template, 3, 5, "div", 15)(3, IgxHierarchicalRowComponent_ng_template_9_Conditional_3_Template, 1, 2)(4, IgxHierarchicalRowComponent_ng_template_9_ng_template_4_Template, 5, 84, "ng-template", 16, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(6, "igxNotGrouped");
    i0.ɵɵtemplate(7, IgxHierarchicalRowComponent_ng_template_9_Conditional_7_Template, 1, 2)(8, IgxHierarchicalRowComponent_ng_template_9_ng_template_8_Template, 2, 7, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(10, IgxHierarchicalRowComponent_ng_template_9_ng_template_10_Template, 3, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.rowDraggable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showRowSelectors ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasChildren ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.pinnedColumns.length > 0 && ctx_r0.grid.isPinningToStart ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(6, 11, ctx_r0.unpinnedColumns))("igxForScrollContainer", ctx_r0.grid.parentVirtDir)("igxForSizePropName", "calcPixelWidth")("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx_r0.grid.unpinnedWidth)("igxForTrackBy", ctx_r0.grid.trackColumnChanges);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.pinnedColumns.length > 0 && !ctx_r0.grid.isPinningToStart ? 7 : -1);
  }
}
const _c279 = a0 => ({
  "igx-grid__hierarchical-indent--scroll": a0
});
const _c280 = ["toolbarOutlet"];
const _c281 = ["paginatorOutlet"];
const _c282 = ["hierarchical_record_template"];
const _c283 = ["child_record_template"];
const _c284 = [[["igx-grid-toolbar"], ["igc-grid-toolbar"]], [["igx-grid-footer"], ["igc-grid-footer"]], [["igx-paginator"], ["igc-paginator"]], [["igx-grid-state"], ["igc-grid-state"]], [["igx-column"], ["igc-column"], ["igx-column-group"], ["igc-column-group"], ["igx-action-strip"], ["igc-action-strip"]], [["igx-row-island"], ["igc-row-island"]]];
const _c285 = ["igx-grid-toolbar,igc-grid-toolbar", "igx-grid-footer,igc-grid-footer", "igx-paginator,igc-paginator", "igx-grid-state,igc-grid-state", "igx-column,igc-column,igx-column-group,igc-column-group,igx-action-strip,igc-action-strip", "igx-row-island,igc-row-island"];
const _c286 = a0 => ({
  "igx-grid__tr-container": true,
  "igx-grid__tr--highlighted": a0
});
function IgxHierarchicalGridComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 38);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxHierarchicalGridComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 67);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", ctx_r1.pinnedWidth, "px");
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_ng_container_0_Template, 1, 0, "ng-container", 42);
  }
  if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    const ɵ$index_28_r4 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const pinned_hierarchical_record_template_r5 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", pinned_hierarchical_record_template_r5)("ngTemplateOutletContext", ctx_r1.getContext(rowData_r3, ɵ$index_28_r4, true));
  }
}
function IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69, 29);
    i0.ɵɵrepeaterCreate(2, IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_For_3_Template, 1, 2, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pinnedData_r6 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c235, !ctx_r1.isRowPinningToTop, ctx_r1.isRowPinningToTop));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(pinnedData_r6);
  }
}
function IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Conditional_0_Template, 4, 6, "div", 68);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length > 0 ? 0 : -1);
  }
}
function IgxHierarchicalGridComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxHierarchicalGridComponent_ng_template_9_Conditional_0_Template, 1, 1);
    i0.ɵɵpipe(1, "gridTransaction");
    i0.ɵɵpipe(2, "visibleColumns");
    i0.ɵɵpipe(3, "gridAddRow");
    i0.ɵɵpipe(4, "gridRowPinning");
    i0.ɵɵpipe(5, "gridFiltering");
    i0.ɵɵpipe(6, "gridSort");
  }
  if (rf & 2) {
    let tmp_30_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_30_0 = i0.ɵɵpipeBindV(6, 26, i0.ɵɵpureFunction6(43, _c234, i0.ɵɵpipeBindV(5, 17, i0.ɵɵpureFunction7(34, _c233, i0.ɵɵpipeBind4(4, 12, i0.ɵɵpipeBind3(3, 8, i0.ɵɵpipeBind2(2, 5, i0.ɵɵpipeBind3(1, 1, ctx_r1.data, ctx_r1.id, ctx_r1.pipeTrigger), ctx_r1.hasVisibleColumns), true, ctx_r1.pipeTrigger), ctx_r1.id, true, ctx_r1.pipeTrigger), ctx_r1.filteringExpressionsTree, ctx_r1.filterStrategy, ctx_r1.advancedFilteringExpressionsTree, ctx_r1.id, ctx_r1.pipeTrigger, ctx_r1.filteringPipeTrigger)), ctx_r1.sortingExpressions, i0.ɵɵpureFunction0(42, _c129), ctx_r1.sortStrategy, ctx_r1.id, ctx_r1.pipeTrigger))) ? 0 : -1, tmp_30_0);
  }
}
function IgxHierarchicalGridComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_12_ng_template_0_Template(rf, ctx) {}
function IgxHierarchicalGridComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, IgxHierarchicalGridComponent_ng_template_12_ng_template_0_Template, 0, 0, "ng-template", 70);
    i0.ɵɵlistener("viewCreated", function IgxHierarchicalGridComponent_ng_template_12_Template_ng_template_viewCreated_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.viewCreatedHandler($event));
    })("viewMoved", function IgxHierarchicalGridComponent_ng_template_12_Template_ng_template_viewMoved_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.viewMovedHandler($event));
    })("cachedViewLoaded", function IgxHierarchicalGridComponent_ng_template_12_Template_ng_template_cachedViewLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cachedViewLoaded($event));
    });
  }
  if (rf & 2) {
    const rowData_r8 = ctx.$implicit;
    const rowIndex_r9 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    const hierarchical_record_template_r10 = i0.ɵɵreference(23);
    const child_record_template_r11 = i0.ɵɵreference(27);
    i0.ɵɵproperty("igxTemplateOutlet", ctx_r1.isHierarchicalRecord(rowData_r8) ? hierarchical_record_template_r10 : ctx_r1.isChildGridRecord(rowData_r8) ? child_record_template_r11 : hierarchical_record_template_r10)("igxTemplateOutletContext", ctx_r1.getContext(rowData_r8, rowIndex_r9, false));
  }
}
function IgxHierarchicalGridComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-hierarchical-grid-row", 71, 30);
    i0.ɵɵpipe(2, "igxGridRowClasses");
    i0.ɵɵpipe(3, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r12 = ctx.index;
    const disabledRow_r13 = ctx.disabled;
    const rowData_r14 = ctx.$implicit;
    const row_r15 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r12)("disabled", disabledRow_r13)("data", rowData_r14)("ngClass", i0.ɵɵpipeBindV(2, 6, i0.ɵɵpureFunctionV(24, _c236, [ctx_r1.rowClasses, row_r15, row_r15.inEditMode, row_r15.selected, row_r15.dirty, row_r15.deleted, row_r15.dragging, rowIndex_r12, ctx_r1.hasColumnLayouts, rowData_r14, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(3, 19, ctx_r1.rowStyles, rowData_r14, rowIndex_r12, ctx_r1.pipeTrigger));
  }
}
function IgxHierarchicalGridComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-hierarchical-grid-row", 72, 31);
    i0.ɵɵpipe(3, "igxGridRowClasses");
    i0.ɵɵpipe(4, "igxGridRowStyles");
  }
  if (rf & 2) {
    const rowIndex_r16 = ctx.index;
    const rowData_r17 = ctx.$implicit;
    const row_r18 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridID", ctx_r1.id)("index", rowIndex_r16)("data", rowData_r17)("ngClass", i0.ɵɵpipeBindV(3, 5, i0.ɵɵpureFunctionV(23, _c236, [ctx_r1.rowClasses, row_r18, row_r18.inEditMode, row_r18.selected, row_r18.dirty, row_r18.deleted, row_r18.dragging, rowIndex_r16, ctx_r1.hasColumnLayouts, rowData_r17, ctx_r1.pipeTrigger])))("ngStyle", i0.ɵɵpipeBind4(4, 18, ctx_r1.rowStyles, rowData_r17, rowIndex_r16, ctx_r1.pipeTrigger));
  }
}
function IgxHierarchicalGridComponent_ng_template_26_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-child-grid-row", 74, 30);
  }
  if (rf & 2) {
    const layout_r20 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    const rowIndex_r22 = ctx_r20.index;
    const rowData_r23 = ctx_r20.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("parentGridID", ctx_r1.id)("index", rowIndex_r22)("data", rowData_r23)("layout", layout_r20);
  }
}
function IgxHierarchicalGridComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵlistener("scroll", function IgxHierarchicalGridComponent_ng_template_26_Template_div_scroll_0_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onContainerScroll());
    });
    i0.ɵɵrepeaterCreate(1, IgxHierarchicalGridComponent_ng_template_26_For_2_Template, 2, 4, "igx-child-grid-row", 74, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowIndex_r22 = ctx.index;
    const rowData_r23 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c286, ctx_r1.isRowHighlighted(rowData_r23)));
    i0.ɵɵattribute("data-rowindex", rowIndex_r22);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.childLayoutList);
  }
}
function IgxHierarchicalGridComponent_ng_container_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_container_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_Conditional_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 43);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxHierarchicalGridComponent_Conditional_33_Template(rf, ctx) {}
function IgxHierarchicalGridComponent_Conditional_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-circular-bar", 46);
  }
  if (rf & 2) {
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxHierarchicalGridComponent_Conditional_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 43);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("igxColumnMovingDrop", ctx_r1.headerContainer);
    i0.ɵɵattribute("droppable", true);
  }
}
function IgxHierarchicalGridComponent_ng_template_41_Template(rf, ctx) {}
function IgxHierarchicalGridComponent_Conditional_53_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-summary-row", 75, 32);
    i0.ɵɵpipe(2, "igxGridSummaryDataPipe");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r1.calcWidth, "px")("height", ctx_r1.summaryRowHeight, "px");
    i0.ɵɵproperty("gridID", ctx_r1.id)("summaries", i0.ɵɵpipeBind2(2, 7, ctx_r1.id, ctx_r1.summaryService.retriggerRootPipe))("index", ctx_r1.dataView.length);
  }
}
function IgxHierarchicalGridComponent_ng_template_59_Template(rf, ctx) {}
function IgxHierarchicalGridComponent_ng_template_68_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_68_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxHierarchicalGridComponent_ng_template_68_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r24 = i0.ɵɵreference(73);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r24);
  }
}
function IgxHierarchicalGridComponent_ng_template_68_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 76)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxHierarchicalGridComponent_ng_template_68_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyFilteredGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxHierarchicalGridComponent_ng_template_70_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_70_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, IgxHierarchicalGridComponent_ng_template_70_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const defaultAddRowEmptyTemplate_r24 = i0.ɵɵreference(73);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.addRowEmptyTemplate || defaultAddRowEmptyTemplate_r24);
  }
}
function IgxHierarchicalGridComponent_ng_template_70_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 76)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, IgxHierarchicalGridComponent_ng_template_70_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emptyGridMessage);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAddButton ? 3 : -1);
  }
}
function IgxHierarchicalGridComponent_ng_template_72_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 77);
    i0.ɵɵlistener("click", function IgxHierarchicalGridComponent_ng_template_72_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.crudService.enterAddRowMode(null, false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.resourceStrings.igx_grid_add_row_label, " ");
  }
}
function IgxHierarchicalGridComponent_ng_template_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵelement(1, "igx-circular-bar", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("indeterminate", true);
  }
}
function IgxHierarchicalGridComponent_ng_template_76_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 79);
  }
}
function IgxHierarchicalGridComponent_ng_template_78_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 80);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("active", ctx_r1.hasExpandedRecords() && ctx_r1.hasExpandableChildren);
  }
}
function IgxHierarchicalGridComponent_Conditional_80_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_Conditional_80_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45, 33)(2, "div", 81);
    i0.ɵɵtemplate(3, IgxHierarchicalGridComponent_Conditional_80_ng_container_3_Template, 1, 0, "ng-container", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("className", ctx_r1.bannerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.resolveRowEditContainer)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c239, ctx_r1.rowChangesCount, ctx_r1.crudService.endEdit.bind(ctx_r1)));
  }
}
function IgxHierarchicalGridComponent_ng_template_81_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "igxStringReplace");
    i0.ɵɵpipe(2, "igxStringReplace");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 5, i0.ɵɵpipeBind3(1, 1, ctx_r1.resourceStrings.igx_grid_row_edit_text, "{0}", ctx_r1.rowChangesCount.toString()), "{1}", ctx_r1.hiddenColumnsCount.toString()), "\n");
  }
}
function IgxHierarchicalGridComponent_ng_template_83_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 82);
    i0.ɵɵlistener("click", function IgxHierarchicalGridComponent_ng_template_83_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(false, $event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 82);
    i0.ɵɵlistener("click", function IgxHierarchicalGridComponent_ng_template_83_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.endRowEditTabStop(true, $event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_cancel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.resourceStrings.igx_grid_row_edit_btn_done);
  }
}
function IgxHierarchicalGridComponent_ng_template_85_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_85_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxHierarchicalGridComponent_ng_template_85_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 83)(1, "span", 84);
    i0.ɵɵtemplate(2, IgxHierarchicalGridComponent_ng_template_85_ng_container_2_Template, 1, 0, "ng-container", 42);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 85)(4, "div", 86);
    i0.ɵɵtemplate(5, IgxHierarchicalGridComponent_ng_template_85_ng_container_5_Template, 1, 0, "ng-container", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultRowEditText_r27 = i0.ɵɵreference(82);
    const defaultRowEditActions_r28 = i0.ɵɵreference(84);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) === "IgxAddRow" ? ctx_r1.rowAddTextTemplate : ctx_r1.resolveRowEditText || defaultRowEditText_r27)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c25, (ctx_r1.crudService.row == null ? null : ctx_r1.crudService.row.getClassName()) !== "IgxAddRow" ? ctx_r1.rowChangesCount : null));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.resolveRowEditActions || defaultRowEditActions_r28)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx_r1.endEdit.bind(ctx_r1)));
  }
}
function IgxHierarchicalGridComponent_ng_template_87_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 87);
  }
}
function IgxHierarchicalGridComponent_Conditional_89_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-grid-column-resizer");
  }
}
function IgxHierarchicalGridComponent_Conditional_94_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66, 34);
    i0.ɵɵprojection(2, 3);
    i0.ɵɵprojection(3, 4);
    i0.ɵɵprojection(4, 5);
    i0.ɵɵelementEnd();
  }
}
const _c287 = [[["igx-navbar-action"], ["", "igxNavbarAction", ""]], [["igx-navbar-title"], ["", "igxNavbarTitle", ""]], "*"];
const _c288 = ["igx-navbar-action, [igxNavbarAction]", "igx-navbar-title, [igxNavbarTitle]", "*"];
function IgxNavbarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-icon", 5);
    i0.ɵɵlistener("click", function IgxNavbarComponent_Conditional_2_Template_igx_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._triggerAction());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionButtonIcon, " ");
  }
}
function IgxNavbarComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.titleId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
const _c289 = ["aside"];
const _c290 = ["overlay"];
const _c291 = ["dummy"];
function IgxNavigationDrawerComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1, "Navigation Drawer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵtext(3, " Start by adding");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9)(5, "code");
    i0.ɵɵtext(6, "<ng-template igxDrawer>");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 9);
    i0.ɵɵtext(8, " And some items inside ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵtext(10, " Style with igxDrawerItem ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 9);
    i0.ɵɵtext(12, " and igxRipple directives");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 10);
    i0.ɵɵtext(14, "Disabled Item");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("isHeader", true);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("disabled", true);
  }
}
function IgxNavigationDrawerComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxThumbLabelComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxThumbLabelComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value, "\n");
  }
}
const _c292 = a0 => ({
  "igx-slider__ticks-group--tall": a0
});
const _c293 = a0 => ({
  "igx-slider__tick-label--hidden": a0
});
function IgxTicksComponent_For_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTicksComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
    i0.ɵɵtemplate(3, IgxTicksComponent_For_1_ng_container_3_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ɵ$index_1_r1 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    const tickLabelDefaultTemplate_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c292, ctx_r1.isPrimary(ɵ$index_1_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c293, !ctx_r1.hiddenTickLabels(ɵ$index_1_r1)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tickLabelTemplateRef ? ctx_r1.tickLabelTemplateRef : tickLabelDefaultTemplate_r3)("ngTemplateOutletContext", ctx_r1.context(ɵ$index_1_r1));
  }
}
function IgxTicksComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r4 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", value_r4, "\n");
  }
}
const _c294 = ["track"];
const _c295 = ["ticks"];
function IgxSliderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-ticks", 4);
    i0.ɵɵpipe(1, "spreadTickLabels");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("primaryTicks", ctx_r1.primaryTicks)("secondaryTicks", ctx_r1.secondaryTicks)("primaryTickLabels", ctx_r1.primaryTickLabels)("secondaryTickLabels", ctx_r1.secondaryTickLabels)("tickLabelsOrientation", ctx_r1.tickLabelsOrientation)("labelsViewEnabled", ctx_r1.labelsViewEnabled)("labels", i0.ɵɵpipeBind2(1, 10, ctx_r1.labels, ctx_r1.secondaryTicks))("tickLabelTemplateRef", ctx_r1.tickLabelTemplateRef)("minValue", ctx_r1.minValue)("maxValue", ctx_r1.maxValue);
  }
}
function IgxSliderComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-thumb-label", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.lowerLabel)("templateRef", ctx_r1.thumbFromTemplateRef)("continuous", ctx_r1.continuous)("context", ctx_r1.context)("deactiveState", ctx_r1.deactivateThumbLabel)("thumb", ctx_r1.thumbFrom);
  }
}
function IgxSliderComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-thumb", 17, 3);
    i0.ɵɵlistener("thumbChange", function IgxSliderComponent_Conditional_11_Template_igx_thumb_thumbChange_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onThumbChange());
    })("hoverChange", function IgxSliderComponent_Conditional_11_Template_igx_thumb_hoverChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onHoverChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.lowerLabel)("min", ctx_r1.minValue)("max", ctx_r1.maxValue)("disabled", ctx_r1.disabled)("continuous", ctx_r1.continuous)("onPan", ctx_r1.onPan)("stepDistance", ctx_r1.stepDistance)("step", ctx_r1.step)("templateRef", ctx_r1.thumbFromTemplateRef)("context", ctx_r1.context)("labels", ctx_r1.labels)("deactiveState", ctx_r1.deactivateThumbLabel)("thumbLabelVisibilityDuration", ctx_r1.thumbLabelVisibilityDuration);
  }
}
function IgxSliderComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-ticks", 16);
    i0.ɵɵpipe(1, "spreadTickLabels");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("primaryTicks", ctx_r1.primaryTicks)("secondaryTicks", ctx_r1.secondaryTicks)("primaryTickLabels", ctx_r1.primaryTickLabels)("secondaryTickLabels", ctx_r1.secondaryTickLabels)("tickLabelsOrientation", ctx_r1.tickLabelsOrientation)("labelsViewEnabled", ctx_r1.labelsViewEnabled)("labels", i0.ɵɵpipeBind2(1, 10, ctx_r1.labels, ctx_r1.secondaryTicks))("tickLabelTemplateRef", ctx_r1.tickLabelTemplateRef)("minValue", ctx_r1.minValue)("maxValue", ctx_r1.maxValue);
  }
}
const _c296 = ["panelTemplate"];
function IgxBottomNavContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c297 = [[["igx-bottom-nav-header"]], [["igx-bottom-nav-content"]]];
const _c298 = ["igx-bottom-nav-header", "igx-bottom-nav-content"];
function IgxBottomNavItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxBottomNavItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxBottomNavComponent_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxBottomNavComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxBottomNavComponent_For_1_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", tab_r1.panelTemplate);
  }
}
function IgxBottomNavComponent_For_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxBottomNavComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxBottomNavComponent_For_5_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", tab_r2.headerTemplate);
  }
}
function IgxTabContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c299 = ["headerContainer"];
const _c300 = ["viewPort"];
const _c301 = ["itemsWrapper"];
const _c302 = ["itemsContainer"];
const _c303 = ["selectedIndicator"];
const _c304 = ["scrollPrevButton"];
const _c305 = ["scrollNextButton"];
function IgxTabsComponent_For_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTabsComponent_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTabsComponent_For_12_ng_container_0_Template, 1, 0, "ng-container", 16);
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", tab_r2.headerTemplate);
  }
}
function IgxTabsComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13, 6);
  }
}
function IgxTabsComponent_For_19_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxTabsComponent_For_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxTabsComponent_For_19_ng_container_0_Template, 1, 0, "ng-container", 16);
  }
  if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", tab_r3.panelTemplate);
  }
}
const _c306 = [[["igx-tab-header"]], [["igx-tab-content"]]];
const _c307 = ["igx-tab-header", "igx-tab-content"];
function IgxTabItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxTabItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c308 = [[["igx-select-item"]]];
const _c309 = ["igx-select-item"];
const _c310 = [[["igx-splitter-pane"]]];
const _c311 = ["igx-splitter-pane"];
function IgxSplitterComponent_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-splitter-bar", 1);
    i0.ɵɵlistener("moveStart", function IgxSplitterComponent_For_2_Conditional_0_Template_igx_splitter_bar_moveStart_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMoveStart($event));
    })("moving", function IgxSplitterComponent_For_2_Conditional_0_Template_igx_splitter_bar_moving_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMoving($event));
    })("movingEnd", function IgxSplitterComponent_For_2_Conditional_0_Template_igx_splitter_bar_movingEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMoveEnd($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const pane_r4 = ctx_r2.$implicit;
    const ɵ$index_2_r5 = ctx_r2.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("order", pane_r4.order + 1)("type", ctx_r1.type)("pane", pane_r4)("siblings", ctx_r1.getPaneSiblingsByOrder(pane_r4.order + 1, ɵ$index_2_r5))("nonCollapsible", ctx_r1.nonCollapsible);
  }
}
function IgxSplitterComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxSplitterComponent_For_2_Conditional_0_Template, 1, 5, "igx-splitter-bar", 0);
  }
  if (rf & 2) {
    const ɵ$index_2_r5 = ctx.$index;
    const ɵ$count_2_r6 = ctx.$count;
    i0.ɵɵconditional(!(ɵ$index_2_r5 === ɵ$count_2_r6 - 1) ? 0 : -1);
  }
}
const _c312 = ["contentTemplate"];
const _c313 = ["customIndicator"];
const _c314 = ["contentContainer"];
const _c315 = [[["", "igxStepTitle", ""]], [["", "igxStepSubtitle", ""]], [["", "igxStepContent", ""]], [["", "igxStepIndicator", ""]]];
const _c316 = ["[igxStepTitle]", "[igxStepSubtitle]", "[igxStepContent]", "[igxStepIndicator]"];
function IgxStepComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxStepComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxStepComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxStepComponent_ng_template_0_Conditional_0_Template, 1, 0)(1, IgxStepComponent_ng_template_0_Conditional_1_Template, 1, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.isTitleVisible ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isTitleVisible ? 1 : -1);
  }
}
function IgxStepComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxStepComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 4);
    i0.ɵɵtemplate(2, IgxStepComponent_ng_template_2_Conditional_2_Template, 1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.contentClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.active || ctx_r1.collapsing ? 2 : -1);
  }
}
function IgxStepComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.index + 1);
  }
}
function IgxStepComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function IgxStepComponent_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxStepComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, IgxStepComponent_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultIndicator_r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.indicatorTemplate ? ctx_r1.indicatorTemplate : defaultIndicator_r3);
  }
}
function IgxStepComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxStepComponent_Conditional_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxStepComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, IgxStepComponent_Conditional_12_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTemplate_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", contentTemplate_r4);
  }
}
const _c317 = [[["igx-step"]]];
const _c318 = ["igx-step"];
function IgxStepperComponent_Conditional_0_1_ng_template_0_Template(rf, ctx) {}
function IgxStepperComponent_Conditional_0_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxStepperComponent_Conditional_0_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxStepperComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, IgxStepperComponent_Conditional_0_1_Template, 1, 0, null, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const stepTemplate_r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", stepTemplate_r1);
  }
}
function IgxStepperComponent_Conditional_1_For_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxStepperComponent_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxStepperComponent_Conditional_1_For_2_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const step_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", step_r2.contentTemplate);
  }
}
function IgxStepperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵrepeaterCreate(1, IgxStepperComponent_Conditional_1_For_2_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.steps);
  }
}
function IgxStepperComponent_Conditional_2_1_ng_template_0_Template(rf, ctx) {}
function IgxStepperComponent_Conditional_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxStepperComponent_Conditional_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function IgxStepperComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, IgxStepperComponent_Conditional_2_1_Template, 1, 0, null, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const stepTemplate_r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", stepTemplate_r1);
  }
}
function IgxStepperComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function IgxDateRangeStartComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, IgxDateRangeStartComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxDateRangeStartComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxDateRangeStartComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxDateRangeStartComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxDateRangeStartComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function IgxDateRangeStartComponent_ng_template_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-prefix", 14)(1, "button", 15);
    i0.ɵɵlistener("click", function IgxDateRangeStartComponent_ng_template_10_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.uploadButtonHandler());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r3.disabled)("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r3.isTypeLine));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.resourceStrings.igx_input_upload_button, " ");
  }
}
function IgxDateRangeStartComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_10_Conditional_0_Template, 3, 5, "igx-prefix", 14);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxDateRangeStartComponent_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r3.fileNames);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.fileNames);
  }
}
function IgxDateRangeStartComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_12_Conditional_0_Template, 3, 2, "div", 16);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxDateRangeStartComponent_ng_template_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 18);
    i0.ɵɵlistener("click", function IgxDateRangeStartComponent_ng_template_14_Conditional_0_Template_igx_suffix_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    })("keydown.Enter", function IgxDateRangeStartComponent_ng_template_14_Conditional_0_Template_igx_suffix_keydown_Enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    });
    i0.ɵɵelement(1, "igx-icon", 19);
    i0.ɵɵelementEnd();
  }
}
function IgxDateRangeStartComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_14_Conditional_0_Template, 2, 0, "igx-suffix", 17);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType && ctx_r3.isFilled ? 0 : -1);
  }
}
function IgxDateRangeStartComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 4);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_18_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxDateRangeStartComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, IgxDateRangeStartComponent_ng_template_18_ng_container_2_Template, 1, 0, "ng-container", 13)(3, IgxDateRangeStartComponent_ng_template_18_ng_container_3_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(4);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵtemplate(6, IgxDateRangeStartComponent_ng_template_18_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵtemplate(8, IgxDateRangeStartComponent_ng_template_18_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxDateRangeStartComponent_ng_template_18_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 24);
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵtemplate(12, IgxDateRangeStartComponent_ng_template_18_ng_container_12_Template, 1, 0, "ng-container", 13)(13, IgxDateRangeStartComponent_ng_template_18_ng_container_13_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, IgxDateRangeStartComponent_ng_template_18_Conditional_14_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 14 : -1);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_20_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxDateRangeStartComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_20_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxDateRangeStartComponent_ng_template_20_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxDateRangeStartComponent_ng_template_20_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 23);
    i0.ɵɵtemplate(6, IgxDateRangeStartComponent_ng_template_20_ng_container_6_Template, 1, 0, "ng-container", 13)(7, IgxDateRangeStartComponent_ng_template_20_ng_container_7_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 25);
    i0.ɵɵtemplate(9, IgxDateRangeStartComponent_ng_template_20_ng_container_9_Template, 1, 0, "ng-container", 13)(10, IgxDateRangeStartComponent_ng_template_20_ng_container_10_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, IgxDateRangeStartComponent_ng_template_20_Conditional_11_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 11 : -1);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_22_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxDateRangeStartComponent_ng_template_22_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxDateRangeStartComponent_ng_template_22_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxDateRangeStartComponent_ng_template_22_ng_container_5_Template, 1, 0, "ng-container", 13)(6, IgxDateRangeStartComponent_ng_template_22_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵtemplate(8, IgxDateRangeStartComponent_ng_template_22_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxDateRangeStartComponent_ng_template_22_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_24_Case_0_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const bootstrapBundle_r13 = i0.ɵɵreference(23);
    i0.ɵɵproperty("ngTemplateOutlet", bootstrapBundle_r13);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_24_Case_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_24_Case_2_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_24_Case_3_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const materialBundle_r15 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", materialBundle_r15);
  }
}
function IgxDateRangeStartComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeStartComponent_ng_template_24_Case_0_Template, 1, 1, "ng-container")(1, IgxDateRangeStartComponent_ng_template_24_Case_1_Template, 1, 1, "ng-container")(2, IgxDateRangeStartComponent_ng_template_24_Case_2_Template, 1, 1, "ng-container")(3, IgxDateRangeStartComponent_ng_template_24_Case_3_Template, 1, 1, "ng-container");
  }
  if (rf & 2) {
    let tmp_12_0;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_12_0 = ctx_r3.theme) === "bootstrap" ? 0 : tmp_12_0 === "fluent" ? 1 : tmp_12_0 === "indigo" ? 2 : 3);
  }
}
function IgxDateRangeEndComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, IgxDateRangeEndComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxDateRangeEndComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const bundle_r2 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", bundle_r2);
  }
}
function IgxDateRangeEndComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function IgxDateRangeEndComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function IgxDateRangeEndComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function IgxDateRangeEndComponent_ng_template_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-prefix", 14)(1, "button", 15);
    i0.ɵɵlistener("click", function IgxDateRangeEndComponent_ng_template_10_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.uploadButtonHandler());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r3.disabled)("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r3.isTypeLine));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.resourceStrings.igx_input_upload_button, " ");
  }
}
function IgxDateRangeEndComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_10_Conditional_0_Template, 3, 5, "igx-prefix", 14);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxDateRangeEndComponent_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r3.fileNames);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.fileNames);
  }
}
function IgxDateRangeEndComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_12_Conditional_0_Template, 3, 2, "div", 16);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType ? 0 : -1);
  }
}
function IgxDateRangeEndComponent_ng_template_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-suffix", 18);
    i0.ɵɵlistener("click", function IgxDateRangeEndComponent_ng_template_14_Conditional_0_Template_igx_suffix_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    })("keydown.Enter", function IgxDateRangeEndComponent_ng_template_14_Conditional_0_Template_igx_suffix_keydown_Enter_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearValueHandler());
    });
    i0.ɵɵelement(1, "igx-icon", 19);
    i0.ɵɵelementEnd();
  }
}
function IgxDateRangeEndComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_14_Conditional_0_Template, 2, 0, "igx-suffix", 17);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.isFileType && ctx_r3.isFilled ? 0 : -1);
  }
}
function IgxDateRangeEndComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 4);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_18_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxDateRangeEndComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, IgxDateRangeEndComponent_ng_template_18_ng_container_2_Template, 1, 0, "ng-container", 13)(3, IgxDateRangeEndComponent_ng_template_18_ng_container_3_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(4);
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵtemplate(6, IgxDateRangeEndComponent_ng_template_18_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵtemplate(8, IgxDateRangeEndComponent_ng_template_18_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxDateRangeEndComponent_ng_template_18_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 24);
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵtemplate(12, IgxDateRangeEndComponent_ng_template_18_ng_container_12_Template, 1, 0, "ng-container", 13)(13, IgxDateRangeEndComponent_ng_template_18_ng_container_13_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, IgxDateRangeEndComponent_ng_template_18_Conditional_14_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 14 : -1);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_20_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function IgxDateRangeEndComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_20_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxDateRangeEndComponent_ng_template_20_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxDateRangeEndComponent_ng_template_20_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 23);
    i0.ɵɵtemplate(6, IgxDateRangeEndComponent_ng_template_20_ng_container_6_Template, 1, 0, "ng-container", 13)(7, IgxDateRangeEndComponent_ng_template_20_ng_container_7_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 25);
    i0.ɵɵtemplate(9, IgxDateRangeEndComponent_ng_template_20_ng_container_9_Template, 1, 0, "ng-container", 13)(10, IgxDateRangeEndComponent_ng_template_20_ng_container_10_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, IgxDateRangeEndComponent_ng_template_20_Conditional_11_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.hasBorder ? 11 : -1);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_22_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, IgxDateRangeEndComponent_ng_template_22_ng_container_3_Template, 1, 0, "ng-container", 13)(4, IgxDateRangeEndComponent_ng_template_22_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, IgxDateRangeEndComponent_ng_template_22_ng_container_5_Template, 1, 0, "ng-container", 13)(6, IgxDateRangeEndComponent_ng_template_22_ng_container_6_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵtemplate(8, IgxDateRangeEndComponent_ng_template_22_ng_container_8_Template, 1, 0, "ng-container", 13)(9, IgxDateRangeEndComponent_ng_template_22_ng_container_9_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const label_r6 = i0.ɵɵreference(5);
    const input_r7 = i0.ɵɵreference(7);
    const prefix_r8 = i0.ɵɵreference(9);
    const uploadButton_r9 = i0.ɵɵreference(11);
    const files_r10 = i0.ɵɵreference(13);
    const clear_r11 = i0.ɵɵreference(15);
    const suffix_r12 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", label_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", prefix_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadButton_r9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", input_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", files_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", clear_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", suffix_r12);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_24_Case_0_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const bootstrapBundle_r13 = i0.ɵɵreference(23);
    i0.ɵɵproperty("ngTemplateOutlet", bootstrapBundle_r13);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_24_Case_1_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_24_Case_2_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const fluentBundle_r14 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", fluentBundle_r14);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_24_Case_3_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const materialBundle_r15 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", materialBundle_r15);
  }
}
function IgxDateRangeEndComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IgxDateRangeEndComponent_ng_template_24_Case_0_Template, 1, 1, "ng-container")(1, IgxDateRangeEndComponent_ng_template_24_Case_1_Template, 1, 1, "ng-container")(2, IgxDateRangeEndComponent_ng_template_24_Case_2_Template, 1, 1, "ng-container")(3, IgxDateRangeEndComponent_ng_template_24_Case_3_Template, 1, 1, "ng-container");
  }
  if (rf & 2) {
    let tmp_12_0;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_12_0 = ctx_r3.theme) === "bootstrap" ? 0 : tmp_12_0 === "fluent" ? 1 : tmp_12_0 === "indigo" ? 2 : 3);
  }
}
const _c319 = [[["igx-date-single"]], [["igx-date-range-start"]], [["igx-date-range-end"]], [["", "igxLabel", ""]], [["igx-prefix"], ["", "igxPrefix", ""]], [["igx-suffix"], ["", "igxSuffix", ""]], [["igx-hint"], ["", "igxHint", ""]]];
const _c320 = ["igx-date-single", "igx-date-range-start", "igx-date-range-end", "[igxLabel]", "igx-prefix,[igxPrefix]", "igx-suffix,[igxSuffix]", "igx-hint,[igxHint]"];
function IgxDateRangePickerComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangePickerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function IgxDateRangePickerComponent_ng_template_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.open());
    });
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function IgxDateRangePickerComponent_ng_template_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangePickerComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtemplate(2, IgxDateRangePickerComponent_ng_template_3_ng_container_2_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3, 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defDateSeparatorTemplate_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("className", ctx_r1.separatorClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dateSeparatorTemplate || defDateSeparatorTemplate_r3);
  }
}
function IgxDateRangePickerComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "igx-icon", 9);
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function IgxDateRangePickerComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r1.dateSeparator);
  }
}
function IgxDateRangePickerComponent_ng_template_9_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IgxDateRangePickerComponent_ng_template_9_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "igx-prefix");
    i0.ɵɵtemplate(1, IgxDateRangePickerComponent_ng_template_9_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const defIcon_r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defIcon_r5);
  }
}
function IgxDateRangePickerComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "igx-input-group", 10);
    i0.ɵɵlistener("click", function IgxDateRangePickerComponent_ng_template_9_Template_igx_input_group_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.open());
    });
    i0.ɵɵelement(1, "input", 11, 5);
    i0.ɵɵpipe(3, "dateRange");
    i0.ɵɵtemplate(4, IgxDateRangePickerComponent_ng_template_9_Conditional_4_Template, 2, 1, "igx-prefix");
    i0.ɵɵelementContainerStart(5, 12);
    i0.ɵɵprojection(6, 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 13);
    i0.ɵɵprojection(8, 4);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(9, 14);
    i0.ɵɵprojection(10, 5);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(11, 15);
    i0.ɵɵprojection(12, 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r1.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("placeholder", ctx_r1.value ? "" : ctx_r1.singleInputFormat)("value", i0.ɵɵpipeBind4(3, 7, ctx_r1.value, ctx_r1.appliedFormat, ctx_r1.locale, ctx_r1.formatter));
    i0.ɵɵattribute("aria-expanded", !ctx_r1.collapsed)("aria-labelledby", ctx_r1.label == null ? null : ctx_r1.label.id);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!ctx_r1.toggleComponents.length ? 4 : -1);
  }
}
let IgxNavigationService = /*#__PURE__*/(() => {
  class IgxNavigationService {
    constructor() {
      this.navs = {};
    }
    add(id, navItem) {
      this.navs[id] = navItem;
    }
    remove(id) {
      delete this.navs[id];
    }
    get(id) {
      if (id) {
        return this.navs[id];
      }
    }
    toggle(id, ...args) {
      if (this.navs[id]) {
        return this.navs[id].toggle(...args);
      }
    }
    open(id, ...args) {
      if (this.navs[id]) {
        return this.navs[id].open(...args);
      }
    }
    close(id, ...args) {
      if (this.navs[id]) {
        return this.navs[id].close(...args);
      }
    }
    static {
      this.ɵfac = function IgxNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavigationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxNavigationService,
        factory: IgxNavigationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Directive that can toggle targets through provided NavigationService.
 *
 * Usage:
 * ```
 * <button type="button" igxNavToggle="ID">Toggle</button>
 * ```
 * Where the `ID` matches the ID of compatible `IToggleView` component.
 */
let IgxNavigationToggleDirective = /*#__PURE__*/(() => {
  class IgxNavigationToggleDirective {
    constructor(nav) {
      this.state = nav;
    }
    toggleNavigationDrawer() {
      this.state.toggle(this.target, true);
    }
    static {
      this.ɵfac = function IgxNavigationToggleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavigationToggleDirective)(i0.ɵɵdirectiveInject(IgxNavigationService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavigationToggleDirective,
        selectors: [["", "igxNavToggle", ""]],
        hostBindings: function IgxNavigationToggleDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxNavigationToggleDirective_click_HostBindingHandler() {
              return ctx.toggleNavigationDrawer();
            });
          }
        },
        inputs: {
          target: [0, "igxNavToggle", "target"]
        }
      });
    }
  }
  return IgxNavigationToggleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Directive that can close targets through provided NavigationService.
 *
 * Usage:
 * ```
 * <button type="button" igxNavClose="ID">Close</button>
 * ```
 * Where the `ID` matches the ID of compatible `IToggleView` component.
 */
let IgxNavigationCloseDirective = /*#__PURE__*/(() => {
  class IgxNavigationCloseDirective {
    constructor(nav) {
      this.state = nav;
    }
    closeNavigationDrawer() {
      this.state.close(this.target, true);
    }
    static {
      this.ɵfac = function IgxNavigationCloseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavigationCloseDirective)(i0.ɵɵdirectiveInject(IgxNavigationService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavigationCloseDirective,
        selectors: [["", "igxNavClose", ""]],
        hostBindings: function IgxNavigationCloseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxNavigationCloseDirective_click_HostBindingHandler() {
              return ctx.closeNavigationDrawer();
            });
          }
        },
        inputs: {
          target: [0, "igxNavClose", "target"]
        }
      });
    }
  }
  return IgxNavigationCloseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTextHighlightService = /*#__PURE__*/(() => {
  class IgxTextHighlightService {
    constructor() {
      this.highlightGroupsMap = new Map();
      this.onActiveElementChanged = new EventEmitter();
    }
    /**
     * Activates the highlight at a given index.
     * (if such index exists)
     */
    setActiveHighlight(groupName, highlight) {
      this.highlightGroupsMap.set(groupName, highlight);
      this.onActiveElementChanged.emit(groupName);
    }
    /**
     * Clears any existing highlight.
     */
    clearActiveHighlight(groupName) {
      this.highlightGroupsMap.set(groupName, {
        index: -1
      });
      this.onActiveElementChanged.emit(groupName);
    }
    /**
     * Destroys a highlight group.
     */
    destroyGroup(groupName) {
      this.highlightGroupsMap.delete(groupName);
    }
    static {
      this.ɵfac = function IgxTextHighlightService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTextHighlightService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTextHighlightService,
        factory: IgxTextHighlightService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxTextHighlightService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Copyright (c) 2014-2020 Denis Pushkarev
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE
 */
// Note: Originally copied from core-js-pure package and modified. (https://github.com/zloirock/core-js)
const queue = {};
let counter = 0;
let eventListenerAdded = false;
const run = id => {
  if (queue.hasOwnProperty(id)) {
    const fn = queue[id];
    delete queue[id];
    fn();
  }
};
const listener = event => run(event.data);
// Use function instead of arrow function to workaround an issue in codesandbox
function setImmediate(cb, ...args) {
  if (window.setImmediate) {
    return window.setImmediate(cb);
  }
  if (!eventListenerAdded) {
    eventListenerAdded = true;
    window.addEventListener('message', listener, false);
  }
  queue[++counter] = () => {
    cb.apply(undefined, args);
  };
  const windowLocation = window.location;
  window.postMessage(counter + '', windowLocation.protocol + '//' + windowLocation.host);
  return counter;
}
function clearImmediate(id) {
  if (window.clearImmediate) {
    return window.clearImmediate(id);
  }
  delete queue[id];
}

/** @hidden @internal */
const ELEMENTS_TOKEN = /*@__PURE__*/new InjectionToken('elements environment');
/**
 * @hidden
 */
const showMessage = (message, isMessageShown) => {
  if (!isMessageShown && isDevMode()) {
    console.warn(message);
  }
  return true;
};
const mkenum = x => x;
/**
 *
 * @hidden @internal
 */
const getResizeObserver = () => globalThis.window?.ResizeObserver;
/**
 * @hidden
 */
const cloneArray = (array, deep) => {
  const arr = [];
  if (!array) {
    return arr;
  }
  let i = array.length;
  while (i--) {
    arr[i] = deep ? cloneValue(array[i]) : array[i];
  }
  return arr;
};
/**
 * Doesn't clone leaf items
 *
 * @hidden
 */
const cloneHierarchicalArray = (array, childDataKey) => {
  const result = [];
  if (!array) {
    return result;
  }
  for (const item of array) {
    const clonedItem = cloneValue(item);
    if (Array.isArray(item[childDataKey])) {
      clonedItem[childDataKey] = cloneHierarchicalArray(clonedItem[childDataKey], childDataKey);
    }
    result.push(clonedItem);
  }
  return result;
};
/**
 * Creates an object with prototype from provided source and copies
 * all properties descriptors from provided source
 * @param obj Source to copy prototype and descriptors from
 * @returns New object with cloned prototype and property descriptors
 */
const copyDescriptors = obj => {
  if (obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
  }
};
/**
 * Deep clones all first level keys of Obj2 and merges them to Obj1
 *
 * @param obj1 Object to merge into
 * @param obj2 Object to merge from
 * @returns Obj1 with merged cloned keys from Obj2
 * @hidden
 */
const mergeObjects = (obj1, obj2) => mergeWith(obj1, obj2, (objValue, srcValue) => {
  if (Array.isArray(srcValue)) {
    return objValue = srcValue;
  }
});
/**
 * Creates deep clone of provided value.
 * Supports primitive values, dates and objects.
 * If passed value is array returns shallow copy of the array.
 *
 * @param value value to clone
 * @returns Deep copy of provided value
 * @hidden
 */
const cloneValue = value => {
  if (isDate(value)) {
    return new Date(value.getTime());
  }
  if (Array.isArray(value)) {
    return [...value];
  }
  if (value instanceof Map || value instanceof Set) {
    return value;
  }
  if (isObject(value)) {
    const result = {};
    for (const key of Object.keys(value)) {
      if (key === "externalObject") {
        continue;
      }
      result[key] = cloneValue(value[key]);
    }
    return result;
  }
  return value;
};
/**
 * Creates deep clone of provided value.
 * Supports primitive values, dates and objects.
 * If passed value is array returns shallow copy of the array.
 * For Objects property values and references are cached and reused.
 * This allows for circular references to same objects.
 *
 * @param value value to clone
 * @param cache map of cached values already parsed
 * @returns Deep copy of provided value
 * @hidden
 */
const cloneValueCached = (value, cache) => {
  if (isDate(value)) {
    return new Date(value.getTime());
  }
  if (Array.isArray(value)) {
    return [...value];
  }
  if (value instanceof Map || value instanceof Set) {
    return value;
  }
  if (isObject(value)) {
    if (cache.has(value)) {
      return cache.get(value);
    }
    const result = {};
    cache.set(value, result);
    for (const key of Object.keys(value)) {
      result[key] = cloneValueCached(value[key], cache);
    }
    return result;
  }
  return value;
};
/**
 * Parse provided input to Date.
 *
 * @param value input to parse
 * @returns Date if parse succeed or null
 * @hidden
 */
const parseDate = value => {
  // if value is Invalid Date return null
  if (isDate(value)) {
    return !isNaN(value.getTime()) ? value : null;
  }
  return value ? new Date(value) : null;
};
/**
 * Returns an array with unique dates only.
 *
 * @param columnValues collection of date values (might be numbers or ISO 8601 strings)
 * @returns collection of unique dates.
 * @hidden
 */
const uniqueDates = columnValues => columnValues.reduce((a, c) => {
  if (!a.cache[c.label]) {
    a.result.push(c);
  }
  a.cache[c.label] = true;
  return a;
}, {
  result: [],
  cache: {}
}).result;
/**
 * Checks if provided variable is Object
 *
 * @param value Value to check
 * @returns true if provided variable is Object
 * @hidden
 */
const isObject = value => !!(value && value.toString() === '[object Object]');
/**
 * Checks if provided variable is Date
 *
 * @param value Value to check
 * @returns true if provided variable is Date
 * @hidden
 */
const isDate = value => {
  return Object.prototype.toString.call(value) === "[object Date]";
};
/**
 * Checks if the two passed arguments are equal
 * Currently supports date objects
 *
 * @param obj1
 * @param obj2
 * @returns: `boolean`
 * @hidden
 */
const isEqual = (obj1, obj2) => {
  if (isDate(obj1) && isDate(obj2)) {
    return obj1.getTime() === obj2.getTime();
  }
  return obj1 === obj2;
};
/**
 * Utility service taking care of various utility functions such as
 * detecting browser features, general cross browser DOM manipulation, etc.
 *
 * @hidden @internal
 */
let PlatformUtil = /*#__PURE__*/(() => {
  class PlatformUtil {
    constructor(platformId) {
      this.platformId = platformId;
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.isIOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
      this.isSafari = this.isBrowser && /Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent);
      this.isFirefox = this.isBrowser && /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent);
      this.isEdge = this.isBrowser && /Edge[\/\s](\d+\.\d+)/.test(navigator.userAgent);
      this.isChromium = this.isBrowser && (/Chrom|e?ium/g.test(navigator.userAgent) || /Google Inc/g.test(navigator.vendor)) && !/Edge/g.test(navigator.userAgent);
      this.browserVersion = this.isBrowser ? parseFloat(navigator.userAgent.match(/Version\/([\d.]+)/)?.at(1)) : 0;
      /** @hidden @internal */
      this.isElements = inject(ELEMENTS_TOKEN, {
        optional: true
      });
      this.KEYMAP = mkenum({
        ENTER: 'Enter',
        SPACE: ' ',
        ESCAPE: 'Escape',
        ARROW_DOWN: 'ArrowDown',
        ARROW_UP: 'ArrowUp',
        ARROW_LEFT: 'ArrowLeft',
        ARROW_RIGHT: 'ArrowRight',
        END: 'End',
        HOME: 'Home',
        PAGE_DOWN: 'PageDown',
        PAGE_UP: 'PageUp',
        F2: 'F2',
        TAB: 'Tab',
        SEMICOLON: ';',
        // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#editing_keys
        DELETE: 'Delete',
        BACKSPACE: 'Backspace',
        CONTROL: 'Control',
        X: 'x',
        Y: 'y',
        Z: 'z'
      });
    }
    /**
     * @hidden @internal
     * Returns the actual size of the node content, using Range
     * ```typescript
     * let range = document.createRange();
     * let column = this.grid.columnList.filter(c => c.field === 'ID')[0];
     *
     * let size = getNodeSizeViaRange(range, column.cells[0].nativeElement);
     *
     * @remarks
     * The last parameter is useful when the size of the element to measure is modified by a
     * parent element that has explicit size. In such cases the calculated size is never lower
     * and the function may instead remove the parent size while measuring to get the correct value.
     * ```
     */
    getNodeSizeViaRange(range, node, sizeHoldingNode) {
      let overflow = null;
      let nodeStyles;
      if (!this.isFirefox) {
        overflow = node.style.overflow;
        // we need that hack - otherwise content won't be measured correctly in IE/Edge
        node.style.overflow = 'visible';
      }
      if (sizeHoldingNode) {
        const style = sizeHoldingNode.style;
        nodeStyles = [style.width, style.minWidth, style.flexBasis];
        style.width = '';
        style.minWidth = '';
        style.flexBasis = '';
      }
      range.selectNodeContents(node);
      const scale = node.getBoundingClientRect().width / node.offsetWidth;
      const width = range.getBoundingClientRect().width / scale;
      if (!this.isFirefox) {
        // we need that hack - otherwise content won't be measured correctly in IE/Edge
        node.style.overflow = overflow;
      }
      if (sizeHoldingNode) {
        sizeHoldingNode.style.width = nodeStyles[0];
        sizeHoldingNode.style.minWidth = nodeStyles[1];
        sizeHoldingNode.style.flexBasis = nodeStyles[2];
      }
      return width;
    }
    /**
     * Returns true if the current keyboard event is an activation key (Enter/Space bar)
     *
     * @hidden
     * @internal
     *
     * @memberof PlatformUtil
     */
    isActivationKey(event) {
      return event.key === this.KEYMAP.ENTER || event.key === this.KEYMAP.SPACE;
    }
    /**
     * Returns true if the current keyboard event is a combination that closes the filtering UI of the grid. (Escape/Ctrl+Shift+L)
     *
     * @hidden
     * @internal
     * @param event
     * @memberof PlatformUtil
     */
    isFilteringKeyCombo(event) {
      return event.key === this.KEYMAP.ESCAPE || event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'l';
    }
    /**
     * @hidden @internal
     */
    isLeftClick(event) {
      return event.button === 0;
    }
    /**
     * @hidden @internal
     */
    isNavigationKey(key) {
      return [this.KEYMAP.HOME, this.KEYMAP.END, this.KEYMAP.SPACE, this.KEYMAP.ARROW_DOWN, this.KEYMAP.ARROW_LEFT, this.KEYMAP.ARROW_RIGHT, this.KEYMAP.ARROW_UP].includes(key);
    }
    static {
      this.ɵfac = function PlatformUtil_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlatformUtil)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PlatformUtil,
        factory: PlatformUtil.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PlatformUtil;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
const flatten$1 = arr => {
  let result = [];
  arr.forEach(el => {
    result.push(el);
    if (el.children) {
      const children = Array.isArray(el.children) ? el.children : el.children.toArray();
      result = result.concat(flatten$1(children));
    }
  });
  return result;
};
const HORIZONTAL_NAV_KEYS = new Set(['arrowleft', 'left', 'arrowright', 'right', 'home', 'end']);
const NAVIGATION_KEYS = new Set(['down', 'up', 'left', 'right', 'arrowdown', 'arrowup', 'arrowleft', 'arrowright', 'home', 'end', 'space', 'spacebar', ' ']);
const ACCORDION_NAVIGATION_KEYS = new Set('up down arrowup arrowdown home end'.split(' '));
const ROW_EXPAND_KEYS = new Set('right down arrowright arrowdown'.split(' '));
const ROW_COLLAPSE_KEYS = new Set('left up arrowleft arrowup'.split(' '));
const ROW_ADD_KEYS = new Set(['+', 'add', '≠', '±', '=']);
const SUPPORTED_KEYS = new Set([...Array.from(NAVIGATION_KEYS), ...Array.from(ROW_ADD_KEYS), 'enter', 'f2', 'escape', 'esc', 'pagedown', 'pageup']);
const HEADER_KEYS = new Set([...Array.from(NAVIGATION_KEYS), 'escape', 'esc', 'l', /** This symbol corresponds to the Alt + L combination under MAC. */
'¬']);
/**
 * @hidden
 * @internal
 *
 * Creates a new ResizeObserver on `target` and returns it as an Observable.
 * Run the resizeObservable outside angular zone, because it patches the MutationObserver which causes an infinite loop.
 * Related issue: https://github.com/angular/angular/issues/31712
 */
const resizeObservable = target => {
  const resizeObserver = getResizeObserver();
  // check whether we are on server env or client env
  if (resizeObserver) {
    return new Observable(observer => {
      const instance = new resizeObserver(entries => {
        observer.next(entries);
      });
      instance.observe(target);
      const unsubscribe = () => instance.disconnect();
      return unsubscribe;
    });
  } else {
    // if on a server env return a empty observable that does not complete immediately
    return NEVER;
  }
};
/**
 * @hidden
 * @internal
 *
 * Compares two maps.
 */
const compareMaps = (map1, map2) => {
  if (!map2) {
    return !map1 ? true : false;
  }
  if (map1.size !== map2.size) {
    return false;
  }
  let match = true;
  const keys = Array.from(map2.keys());
  for (const key of keys) {
    if (map1.has(key)) {
      match = map1.get(key) === map2.get(key);
    } else {
      match = false;
    }
    if (!match) {
      break;
    }
  }
  return match;
};
/**
 *
 * Given a property access path in the format `x.y.z` resolves and returns
 * the value of the `z` property in the passed object.
 *
 * @hidden
 * @internal
 */
const resolveNestedPath = (obj, path) => {
  const parts = path?.split('.') ?? [];
  let current = obj[parts.shift()];
  parts.forEach(prop => {
    if (current) {
      current = current[prop];
    }
  });
  return current;
};
/**
 *
 * Given a property access path in the format `x.y.z` and a value
 * this functions builds and returns an object following the access path.
 *
 * @example
 * ```typescript
 * console.log('x.y.z.', 42);
 * >> { x: { y: { z: 42 } } }
 * ```
 *
 * @hidden
 * @internal
 */
const reverseMapper = (path, value) => {
  const obj = {};
  const parts = path?.split('.') ?? [];
  let _prop = parts.shift();
  let mapping;
  // Initial binding for first level bindings
  obj[_prop] = value;
  mapping = obj;
  parts.forEach(prop => {
    // Start building the hierarchy
    mapping[_prop] = {};
    // Go down a level
    mapping = mapping[_prop];
    // Bind the value and move the key
    mapping[prop] = value;
    _prop = prop;
  });
  return obj;
};
const yieldingLoop = (count, chunkSize, callback, done) => {
  let i = 0;
  const chunk = () => {
    const end = Math.min(i + chunkSize, count);
    for (; i < end; ++i) {
      callback(i);
    }
    if (i < count) {
      setImmediate(chunk);
    } else {
      done();
    }
  };
  chunk();
};
const isConstructor = ref => typeof ref === 'function' && Boolean(ref.prototype) && Boolean(ref.prototype.constructor);
/**
 * Similar to Angular's formatDate. However it will not throw on `undefined | null | ''` instead
 * coalescing to an empty string.
 */
const formatDate = (value, format, locale, timezone) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return formatDate$1(value, format, locale, timezone);
};
const formatCurrency = new CurrencyPipe(undefined).transform;
/** Converts pixel values to their rem counterparts for a base value */
const rem = value => {
  const base = parseFloat(globalThis.window?.getComputedStyle(globalThis.document?.documentElement).getPropertyValue('--ig-base-font-size'));
  return Number(value) / base;
};
/** Get the size of the component as derived from the CSS size variable */
function getComponentSize(el) {
  return globalThis.window?.getComputedStyle(el).getPropertyValue('--component-size');
}
/** Get the first item in an array */
function first$1(arr) {
  return arr.at(0);
}
/** Get the last item in an array */
function last$1(arr) {
  return arr.at(-1);
}
/** Calculates the modulo of two numbers, ensuring a non-negative result. */
function modulo(n, d) {
  return (n % d + d) % d;
}
/**
 * Splits an array into chunks of length `size` and returns a generator
 * yielding each chunk.
 * The last chunk may contain less than `size` elements.
 *
 * @example
 * ```typescript
 * const arr = [0,1,2,3,4,5,6,7,8,9];
 *
 * Array.from(chunk(arr, 2)) // [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9]]
 * Array.from(chunk(arr, 3)) // [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9]]
 * Array.from(chunk([], 3)) // []
 * Array.from(chunk(arr, -3)) // Error
 * ```
 */
function* intoChunks(arr, size) {
  if (size < 1) {
    throw new Error('size must be an integer >= 1');
  }
  for (let i = 0; i < arr.length; i += size) {
    yield arr.slice(i, i + size);
  }
}
/**
 * @param size
 * @returns string that represents the --component-size default value
 */
function getComponentCssSizeVar(size) {
  switch (size) {
    case "1":
      return 'var(--ig-size, var(--ig-size-small))';
    case "2":
      return 'var(--ig-size, var(--ig-size-medium))';
    case "3":
    default:
      return 'var(--ig-size, var(--ig-size-large))';
  }
}
/**
 * @param path - The URI path to be normalized.
 * @returns string encoded using the encodeURI function.
 */
function normalizeURI(path) {
  return path?.split('/').map(encodeURI).join('/');
}
function getComponentTheme(el) {
  return globalThis.window?.getComputedStyle(el).getPropertyValue('--theme').trim();
}
/**
 * Collection re-created w/ the built in track by identity will always log
 * warning even for valid cases of recalculating all collection items.
 * See https://github.com/angular/angular/blob/55581b4181639568fb496e91055142a1b489e988/packages/core/src/render3/instructions/control_flow.ts#L393-L409
 * Current solution explicit track function doing the same as suggested in:
 * https://github.com/angular/angular/issues/56471#issuecomment-2180315803
 * This should be used with moderation and when necessary.
 * @internal
 */
function trackByIdentity(item) {
  return item;
}
var PagingError = /*#__PURE__*/function (PagingError) {
  PagingError[PagingError["None"] = 0] = "None";
  PagingError[PagingError["IncorrectPageIndex"] = 1] = "IncorrectPageIndex";
  PagingError[PagingError["IncorrectRecordsPerPage"] = 2] = "IncorrectRecordsPerPage";
  return PagingError;
}(PagingError || {});
var TransactionType = /*#__PURE__*/function (TransactionType) {
  TransactionType["ADD"] = "add";
  TransactionType["DELETE"] = "delete";
  TransactionType["UPDATE"] = "update";
  return TransactionType;
}(TransactionType || {});
var TransactionEventOrigin = /*#__PURE__*/function (TransactionEventOrigin) {
  TransactionEventOrigin["UNDO"] = "undo";
  TransactionEventOrigin["REDO"] = "redo";
  TransactionEventOrigin["CLEAR"] = "clear";
  TransactionEventOrigin["ADD"] = "add";
  TransactionEventOrigin["END"] = "endPending";
  return TransactionEventOrigin;
}(TransactionEventOrigin || {});
/* mustCoerceToInt */
var SortingDirection = /*#__PURE__*/function (SortingDirection) {
  SortingDirection[SortingDirection["None"] = 0] = "None";
  SortingDirection[SortingDirection["Asc"] = 1] = "Asc";
  SortingDirection[SortingDirection["Desc"] = 2] = "Desc";
  return SortingDirection;
}(SortingDirection || {});
let DefaultSortingStrategy = /*#__PURE__*/(() => {
  class DefaultSortingStrategy {
    static {
      this._instance = null;
    }
    constructor() {}
    static instance() {
      return this._instance || (this._instance = new this());
    }
    /* blazorSuppress */
    sort(data, fieldName, dir, ignoreCase, valueResolver, isDate, isTime) {
      const key = fieldName;
      const reverse = dir === SortingDirection.Desc ? -1 : 1;
      const cmpFunc = (obj1, obj2) => this.compareObjects(obj1, obj2, key, reverse, ignoreCase, valueResolver, isDate, isTime);
      return this.arraySort(data, cmpFunc);
    }
    compareValues(a, b) {
      const an = a === null || a === undefined;
      const bn = b === null || b === undefined;
      if (an) {
        if (bn) {
          return 0;
        }
        return -1;
      } else if (bn) {
        return 1;
      }
      return a > b ? 1 : a < b ? -1 : 0;
    }
    compareObjects(obj1, obj2, key, reverse, ignoreCase, valueResolver, isDate, isTime) {
      let a = valueResolver.call(this, obj1, key, isDate, isTime);
      let b = valueResolver.call(this, obj2, key, isDate, isTime);
      if (ignoreCase) {
        a = a && a.toLowerCase ? a.toLowerCase() : a;
        b = b && b.toLowerCase ? b.toLowerCase() : b;
      }
      return reverse * this.compareValues(a, b);
    }
    arraySort(data, compareFn) {
      return data.sort(compareFn);
    }
  }
  return DefaultSortingStrategy;
})();
let GroupMemberCountSortingStrategy = /*#__PURE__*/(() => {
  class GroupMemberCountSortingStrategy {
    static {
      this._instance = null;
    }
    constructor() {}
    static instance() {
      return this._instance || (this._instance = new this());
    }
    sort(data, fieldName, dir) {
      const groupedArray = this.groupBy(data, fieldName);
      const reverse = dir === SortingDirection.Desc ? -1 : 1;
      const cmpFunc = (a, b) => {
        return this.compareObjects(a, b, groupedArray, fieldName, reverse);
      };
      return data.sort((a, b) => a[fieldName].localeCompare(b[fieldName])).sort(cmpFunc);
    }
    groupBy(data, key) {
      return data.reduce((acc, curr) => {
        (acc[curr[key]] = acc[curr[key]] || []).push(curr);
        return acc;
      }, {});
    }
    compareObjects(obj1, obj2, data, fieldName, reverse) {
      const firstItemValuesLength = data[obj1[fieldName]].length;
      const secondItemValuesLength = data[obj2[fieldName]].length;
      return reverse * (firstItemValuesLength - secondItemValuesLength);
    }
  }
  return GroupMemberCountSortingStrategy;
})();
let FormattedValuesSortingStrategy = /*#__PURE__*/(() => {
  class FormattedValuesSortingStrategy extends DefaultSortingStrategy {
    static {
      this._instance = null;
    }
    constructor() {
      super();
    }
    static instance() {
      return this._instance || (this._instance = new this());
    }
    sort(data, fieldName, dir, ignoreCase, valueResolver, isDate, isTime, grid) {
      const key = fieldName;
      const reverse = dir === SortingDirection.Desc ? -1 : 1;
      const cmpFunc = (obj1, obj2) => this.compareObjects(obj1, obj2, key, reverse, ignoreCase, valueResolver, isDate, isTime, grid);
      return this.arraySort(data, cmpFunc);
    }
    compareObjects(obj1, obj2, key, reverse, ignoreCase, valueResolver, isDate, isTime, grid) {
      let a = valueResolver.call(this, obj1, key, isDate, isTime);
      let b = valueResolver.call(this, obj2, key, isDate, isTime);
      if (grid) {
        const col = grid.getColumnByName(key);
        if (col && col.formatter) {
          a = col.formatter(a);
          b = col.formatter(b);
        }
      }
      if (ignoreCase) {
        a = a && a.toLowerCase ? a.toLowerCase() : a;
        b = b && b.toLowerCase ? b.toLowerCase() : b;
      }
      return reverse * this.compareValues(a, b);
    }
  }
  return FormattedValuesSortingStrategy;
})();
const isHierarchyMatch = (h1, h2, expressions) => {
  if (h1.length !== h2.length) {
    return false;
  }
  return h1.every((level, index) => {
    const expr = expressions.find(e => e.fieldName === level.fieldName);
    const comparer = expr.groupingComparer || DefaultSortingStrategy.instance().compareValues;
    return level.fieldName === h2[index].fieldName && comparer(level.value, h2[index].value) === 0;
  });
};
const getHierarchy = gRow => {
  const hierarchy = [];
  if (gRow !== undefined && gRow.expression) {
    hierarchy.push({
      fieldName: gRow.expression.fieldName,
      value: gRow.value
    });
    while (gRow.groupParent) {
      gRow = gRow.groupParent;
      hierarchy.unshift({
        fieldName: gRow.expression.fieldName,
        value: gRow.value
      });
    }
  }
  return hierarchy;
};
const DATE_TYPE = 'date';
const TIME_TYPE = 'time';
const DATE_TIME_TYPE = 'dateTime';
const STRING_TYPE = 'string';
/**
 * Represents a class implementing the IGridSortingStrategy interface.
 * It provides sorting functionality for grid data based on sorting expressions.
 */
class IgxSorting {
  /* blazorSuppress */
  /**
  * Sorts the provided data based on the given sorting expressions.
  * `data`: The array of data to be sorted.
  * `expressions`: An array of sorting expressions that define the sorting rules. The expression contains information like file name, whether the letter case should be taken into account, etc.
  * `grid`: (Optional) The instance of the grid where the sorting is applied.
  * Returns a new array with the data sorted according to the sorting expressions.
  */
  sort(data, expressions, grid) {
    return this.sortDataRecursive(data, expressions, 0, grid);
  }
  /**
  * Recursively groups the provided data based on the given grouping state and returns the grouped result.
  * Returns an array containing the grouped result.
  * @internal
  */
  groupDataRecursive(data, state, level, parent, metadata, grid = null, groupsRecords = [], fullResult = {
    data: [],
    metadata: []
  }) {
    const expressions = state.expressions;
    const expansion = state.expansion;
    let i = 0;
    let result = [];
    while (i < data.length) {
      const column = grid ? grid.getColumnByName(expressions[level].fieldName) : null;
      const isDate = column?.dataType === DATE_TYPE || column?.dataType === DATE_TIME_TYPE;
      const isTime = column?.dataType === TIME_TYPE || column?.dataType === DATE_TIME_TYPE;
      const isString = column?.dataType === STRING_TYPE;
      const group = this.groupedRecordsByExpression(data, i, expressions[level], isDate, isTime, isString);
      const groupRow = {
        expression: expressions[level],
        level,
        records: cloneArray(group),
        value: this.getFieldValue(group[0], expressions[level].fieldName, isDate, isTime),
        groupParent: parent,
        groups: [],
        height: grid ? grid.renderedRowHeight : null,
        column
      };
      if (parent) {
        parent.groups.push(groupRow);
      } else {
        groupsRecords.push(groupRow);
      }
      const hierarchy = getHierarchy(groupRow);
      const expandState = expansion.find(s => isHierarchyMatch(s.hierarchy || [{
        fieldName: groupRow.expression.fieldName,
        value: groupRow.value
      }], hierarchy, expressions));
      const expanded = expandState ? expandState.expanded : state.defaultExpanded;
      let recursiveResult;
      result.push(groupRow);
      metadata.push(null);
      fullResult.data.push(groupRow);
      fullResult.metadata.push(null);
      if (level < expressions.length - 1) {
        recursiveResult = this.groupDataRecursive(group, state, level + 1, groupRow, expanded ? metadata : [], grid, groupsRecords, fullResult);
        if (expanded) {
          result = result.concat(recursiveResult);
        }
      } else {
        for (const groupItem of group) {
          fullResult.metadata.push(groupRow);
          fullResult.data.push(groupItem);
        }
        if (expanded) {
          metadata.push(...fullResult.metadata.slice(fullResult.metadata.length - group.length));
          result.push(...fullResult.data.slice(fullResult.data.length - group.length));
        }
      }
      i += group.length;
    }
    return result;
  }
  /**
  * Retrieves the value of the specified field from the given object, considering date and time data types.
  * `key`: The key of the field to retrieve.
  * `isDate`: (Optional) Indicates if the field is of type Date.
  * `isTime`: (Optional) Indicates if the field is of type Time.
  * Returns the value of the specified field in the data object.
  * @internal
  */
  getFieldValue(obj, key, isDate = false, isTime = false) {
    let resolvedValue = resolveNestedPath(obj, key);
    const date = parseDate(resolvedValue);
    if (date && isDate && isTime) {
      resolvedValue = date;
    } else if (date && isDate && !isTime) {
      resolvedValue = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    } else if (date && isTime && !isDate) {
      resolvedValue = new Date(new Date().setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    }
    return resolvedValue;
  }
  /**
  * Groups the records in the provided data array based on the given grouping expression.
  * `groupingComparer`: (Optional) A custom grouping comparator to determine the members of the group.
  * Returns an array containing the records that belong to the group.
  * @internal
  */
  groupedRecordsByExpression(data, index, expression, isDate = false, isTime = false, isString, groupingComparer) {
    const res = [];
    const key = expression.fieldName;
    const len = data.length;
    const groupRecord = data[index];
    let groupval = this.getFieldValue(groupRecord, key, isDate, isTime);
    res.push(groupRecord);
    index++;
    const comparer = expression.groupingComparer || groupingComparer || DefaultSortingStrategy.instance().compareValues;
    for (let i = index; i < len; i++) {
      const currRec = data[i];
      let fieldValue = this.getFieldValue(currRec, key, isDate, isTime);
      if (expression.ignoreCase && isString) {
        // when column's dataType is string but the value is number
        fieldValue = fieldValue?.toString().toLowerCase();
        groupval = groupval?.toString().toLowerCase();
      }
      if (comparer(fieldValue, groupval, currRec, groupRecord) === 0) {
        res.push(currRec);
      } else {
        break;
      }
    }
    return res;
  }
  /**
  * Sorts the provided data array based on the given sorting expressions.
  * The method can be used when multiple sorting is performed, going through each one
  * Returns a new array with the data sorted according to the sorting expressions.
  * @internal
  */
  sortDataRecursive(data, expressions, expressionIndex = 0, grid) {
    let i;
    let j;
    let gbData;
    let gbDataLen;
    const exprsLen = expressions.length;
    const dataLen = data.length;
    expressionIndex = expressionIndex || 0;
    if (expressionIndex >= exprsLen || dataLen <= 1) {
      return data;
    }
    const expr = expressions[expressionIndex];
    if (!expr.strategy) {
      expr.strategy = DefaultSortingStrategy.instance();
    }
    const column = grid?.getColumnByName(expr.fieldName);
    const isDate = column?.dataType === DATE_TYPE || column?.dataType === DATE_TIME_TYPE;
    const isTime = column?.dataType === TIME_TYPE || column?.dataType === DATE_TIME_TYPE;
    const isString = column?.dataType === STRING_TYPE;
    data = expr.strategy.sort(data, expr.fieldName, expr.dir, expr.ignoreCase, this.getFieldValue, isDate, isTime, grid);
    if (expressionIndex === exprsLen - 1) {
      return data;
    }
    // in case of multiple sorting
    for (i = 0; i < dataLen; i++) {
      gbData = this.groupedRecordsByExpression(data, i, expr, isDate, isTime, isString, column?.groupingComparer);
      gbDataLen = gbData.length;
      if (gbDataLen > 1) {
        gbData = this.sortDataRecursive(gbData, expressions, expressionIndex + 1, grid);
      }
      for (j = 0; j < gbDataLen; j++) {
        data[i + j] = gbData[j];
      }
      i += gbDataLen - 1;
    }
    return data;
  }
}
/**
 * Represents a class implementing the IGridGroupingStrategy interface and extending the IgxSorting class.
 * It provides a method to group data based on the given grouping state.
 */
class IgxGrouping extends IgxSorting {
  /* blazorSuppress */
  /**
   * Groups the provided data based on the given grouping state.
   * Returns an object containing the result of the grouping operation.
   */
  groupBy(data, state, grid, groupsRecords, fullResult = {
    data: [],
    metadata: []
  }) {
    const metadata = [];
    const grouping = this.groupDataRecursive(data, state, 0, null, metadata, grid, groupsRecords, fullResult);
    grid?.groupingPerformedSubject.next();
    return {
      data: grouping,
      metadata
    };
  }
}
/* csSuppress */
/**
 * Represents a class implementing the IGridSortingStrategy interface with a no-operation sorting strategy.
 * It performs no sorting and returns the data as it is.
 */
let NoopSortingStrategy = /*#__PURE__*/(() => {
  class NoopSortingStrategy {
    static {
      this._instance = null;
    }
    constructor() {}
    static instance() {
      return this._instance || (this._instance = new NoopSortingStrategy());
    }
    /* csSuppress */
    sort(data) {
      return data;
    }
  }
  return NoopSortingStrategy;
})();
/**
 * Represents a class extending the IgxSorting class
 * Provides custom data record sorting.
 */
class IgxDataRecordSorting extends IgxSorting {
  /**
  * Overrides the base method to retrieve the field value from the data object instead of the record object.
  * Returns the value of the specified field in the data object.
  */
  getFieldValue(obj, key, isDate = false, isTime = false) {
    return super.getFieldValue(obj.data, key, isDate, isTime);
  }
}

/**
 * Simplified data clone strategy that deep clones primitive values, dates and objects.
 * Does not support circular references in objects.
 */
class DefaultDataCloneStrategy {
  clone(data) {
    return cloneValue(data);
  }
}
/**
 * Data clone strategy that is uses cache to deep clone primitive values, dates and objects.
 * It allows using circular references inside object.
 */
class CachedDataCloneStrategy {
  clone(data) {
    return cloneValueCached(data, new Map());
  }
}

/**
 * @hidden
 */
const DataType = /*@__PURE__*/mkenum({
  String: 'string',
  Number: 'number',
  Boolean: 'boolean',
  Date: 'date',
  DateTime: 'dateTime',
  Time: 'time',
  Currency: 'currency',
  Percent: 'percent',
  Image: 'image'
});
/**
 * @hidden
 */
const GridColumnDataType = DataType;
/**
 * @hidden
 */
class DataUtil {
  static sort(data, expressions, sorting = new IgxSorting(), grid) {
    return sorting.sort(data, expressions, grid);
  }
  static treeGridSort(hierarchicalData, expressions, sorting = new IgxDataRecordSorting(), parent, grid) {
    let res = [];
    hierarchicalData.forEach(hr => {
      const rec = DataUtil.cloneTreeGridRecord(hr);
      rec.parent = parent;
      if (rec.children) {
        rec.children = DataUtil.treeGridSort(rec.children, expressions, sorting, rec, grid);
      }
      res.push(rec);
    });
    res = DataUtil.sort(res, expressions, sorting, grid);
    return res;
  }
  static cloneTreeGridRecord(hierarchicalRecord) {
    const rec = {
      key: hierarchicalRecord.key,
      data: hierarchicalRecord.data,
      children: hierarchicalRecord.children,
      isFilteredOutParent: hierarchicalRecord.isFilteredOutParent,
      level: hierarchicalRecord.level,
      expanded: hierarchicalRecord.expanded
    };
    return rec;
  }
  static group(data, state, grouping = new IgxGrouping(), grid = null, groupsRecords = [], fullResult = {
    data: [],
    metadata: []
  }) {
    groupsRecords.splice(0, groupsRecords.length);
    return grouping.groupBy(data, state, grid, groupsRecords, fullResult);
  }
  static page(data, state, dataLength) {
    if (!state) {
      return data;
    }
    const len = dataLength !== undefined ? dataLength : data.length;
    const index = state.index;
    const res = [];
    const recordsPerPage = dataLength !== undefined && state.recordsPerPage > dataLength ? dataLength : state.recordsPerPage;
    state.metadata = {
      countPages: 0,
      countRecords: len,
      error: PagingError.None
    };
    if (index < 0 || isNaN(index)) {
      state.metadata.error = PagingError.IncorrectPageIndex;
      return res;
    }
    if (recordsPerPage <= 0 || isNaN(recordsPerPage)) {
      state.metadata.error = PagingError.IncorrectRecordsPerPage;
      return res;
    }
    state.metadata.countPages = Math.ceil(len / recordsPerPage);
    if (!len) {
      return data;
    }
    if (index >= state.metadata.countPages) {
      state.metadata.error = PagingError.IncorrectPageIndex;
      return res;
    }
    return data.slice(index * recordsPerPage, (index + 1) * recordsPerPage);
  }
  static correctPagingState(state, length) {
    const maxPage = Math.ceil(length / state.recordsPerPage) - 1;
    if (!isNaN(maxPage) && state.index > maxPage) {
      state.index = maxPage;
    }
  }
  static getHierarchy(gRow) {
    return getHierarchy(gRow);
  }
  static isHierarchyMatch(h1, h2, expressions) {
    return isHierarchyMatch(h1, h2, expressions);
  }
  /**
   * Merges all changes from provided transactions into provided data collection
   *
   * @param data Collection to merge
   * @param transactions Transactions to merge into data
   * @param primaryKey Primary key of the collection, if any
   * @param deleteRows Should delete rows with DELETE transaction type from data
   * @returns Provided data collections updated with all provided transactions
   */
  static mergeTransactions(data, transactions, primaryKey, cloneStrategy = new DefaultDataCloneStrategy(), deleteRows = false) {
    data.forEach((item, index) => {
      const rowId = primaryKey ? item[primaryKey] : item;
      const transaction = transactions.find(t => t.id === rowId);
      if (transaction && transaction.type === TransactionType.UPDATE) {
        data[index] = mergeObjects(cloneStrategy.clone(data[index]), transaction.newValue);
      }
    });
    if (deleteRows) {
      transactions.filter(t => t.type === TransactionType.DELETE).forEach(t => {
        const index = primaryKey ? data.findIndex(d => d[primaryKey] === t.id) : data.findIndex(d => d === t.id);
        if (0 <= index && index < data.length) {
          data.splice(index, 1);
        }
      });
    }
    data.push(...transactions.filter(t => t.type === TransactionType.ADD).map(t => t.newValue));
    return data;
  }
  /**
   * Merges all changes from provided transactions into provided hierarchical data collection
   *
   * @param data Collection to merge
   * @param transactions Transactions to merge into data
   * @param childDataKey Data key of child collections
   * @param primaryKey Primary key of the collection, if any
   * @param deleteRows Should delete rows with DELETE transaction type from data
   * @returns Provided data collections updated with all provided transactions
   */
  static mergeHierarchicalTransactions(data, transactions, childDataKey, primaryKey, cloneStrategy = new DefaultDataCloneStrategy(), deleteRows = false) {
    for (const transaction of transactions) {
      if (transaction.path) {
        const parent = this.findParentFromPath(data, primaryKey, childDataKey, transaction.path);
        let collection = parent ? parent[childDataKey] : data;
        switch (transaction.type) {
          case TransactionType.ADD:
            //  if there is no parent this is ADD row at root level
            if (parent && !parent[childDataKey]) {
              parent[childDataKey] = collection = [];
            }
            collection.push(transaction.newValue);
            break;
          case TransactionType.UPDATE:
            const updateIndex = collection.findIndex(x => x[primaryKey] === transaction.id);
            if (updateIndex !== -1) {
              collection[updateIndex] = mergeObjects(cloneStrategy.clone(collection[updateIndex]), transaction.newValue);
            }
            break;
          case TransactionType.DELETE:
            if (deleteRows) {
              const deleteIndex = collection.findIndex(r => r[primaryKey] === transaction.id);
              if (deleteIndex !== -1) {
                collection.splice(deleteIndex, 1);
              }
            }
            break;
        }
      } else {
        //  if there is no path this is ADD row in root. Push the newValue to data
        data.push(transaction.newValue);
      }
    }
    return data;
  }
  static parseValue(dataType, value) {
    if (dataType === GridColumnDataType.Number || dataType === GridColumnDataType.Currency || dataType === GridColumnDataType.Percent) {
      value = parseFloat(value);
    }
    return value;
  }
  static findParentFromPath(data, primaryKey, childDataKey, path) {
    let collection = data;
    let result;
    for (const id of path) {
      result = collection && collection.find(x => x[primaryKey] === id);
      if (!result) {
        break;
      }
      collection = result[childDataKey];
    }
    return result;
  }
}

/**
 * @hidden
 */
class ExportUtilities {
  static getKeysFromData(data) {
    const length = data.length;
    if (length === 0) {
      return [];
    }
    const dataEntry = data[0];
    const dataEntryMiddle = data[Math.floor(length / 2)];
    const dataEntryLast = data[length - 1];
    const keys1 = Object.keys(dataEntry);
    const keys2 = Object.keys(dataEntryMiddle);
    const keys3 = Object.keys(dataEntryLast);
    const keys = new Set(keys1.concat(keys2).concat(keys3));
    return !ExportUtilities.isSpecialData(dataEntry) ? Array.from(keys) : ['Column 1'];
  }
  static saveBlobToFile(blob, fileName) {
    const doc = globalThis.document;
    const a = doc.createElement('a');
    const url = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.href = url;
    doc.body.appendChild(a);
    a.click();
    doc.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  static stringToArrayBuffer(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }
  static isSpecialData(data) {
    return typeof data === 'string' || typeof data === 'number' || data instanceof Date;
  }
  static hasValue(value) {
    return value !== undefined && value !== null;
  }
  static isNullOrWhitespaces(value) {
    return value === undefined || value === null || !value.trim();
  }
  static sanitizeValue(value) {
    if (!this.hasValue(value)) {
      return '';
    } else {
      const stringValue = String(value);
      return stringValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;')
      // Bug #14944 - Remove the not supported null character (\u0000, \x00)
      .replace(/\x00/g, '');
    }
  }
}

/**
 * Specify a particular date, time or AmPm part.
 */
var DatePart = /*#__PURE__*/function (DatePart) {
  DatePart["Date"] = "date";
  DatePart["Month"] = "month";
  DatePart["Year"] = "year";
  DatePart["Hours"] = "hours";
  DatePart["Minutes"] = "minutes";
  DatePart["Seconds"] = "seconds";
  DatePart["FractionalSeconds"] = "fractionalSeconds";
  DatePart["AmPm"] = "ampm";
  DatePart["Literal"] = "literal";
  return DatePart;
}(DatePart || {});
const TIME_CHARS = ['h', 'H', 'm', 's', 'S', 't', 'T', 'a'];
const DATE_CHARS = ['d', 'D', 'M', 'y', 'Y'];
/** Maps of the pre-defined date-time format options supported by the Angular DatePipe
 * - predefinedNumericFormats resolve to numeric parts only (and period) for the default 'en' culture
 * - predefinedNonNumericFormats usually contain non-numeric date/time parts, which cannot be
 *   handled for editing by the date/time editors
 *  Ref: https://angular.dev/api/common/DatePipe?tab=usage-notes
 * @hidden
 */
const predefinedNumericFormats = new Map([['short', ["month" /* DateParts.Month */, "day" /* DateParts.Day */, "year" /* DateParts.Year */, "hour" /* DateParts.Hour */, "minute" /* DateParts.Minute */]], ['shortDate', ["month" /* DateParts.Month */, "day" /* DateParts.Day */, "year" /* DateParts.Year */]], ['shortTime', ["hour" /* DateParts.Hour */, "minute" /* DateParts.Minute */]], ['mediumTime', ["hour" /* DateParts.Hour */, "minute" /* DateParts.Minute */, "second" /* DateParts.Second */]]]);
const predefinedNonNumericFormats = new Set(['medium', 'long', 'full', 'mediumDate', 'longDate', 'fullDate', 'longTime', 'fullTime']);
/** @hidden */
let DateTimeUtil = /*#__PURE__*/(() => {
  class DateTimeUtil {
    static {
      this.DEFAULT_INPUT_FORMAT = 'MM/dd/yyyy';
    }
    static {
      this.DEFAULT_TIME_INPUT_FORMAT = 'hh:mm tt';
    }
    static {
      this.SEPARATOR = 'literal';
    }
    static {
      this.DEFAULT_LOCALE = 'en';
    }
    /**
     * Parse a Date value from masked string input based on determined date parts
     *
     * @param inputData masked value to parse
     * @param dateTimeParts Date parts array for the mask
     */
    static parseValueFromMask(inputData, dateTimeParts, promptChar) {
      const parts = {};
      dateTimeParts.forEach(dp => {
        let value = parseInt(DateTimeUtil.getCleanVal(inputData, dp, promptChar), 10);
        if (!value) {
          value = dp.type === DatePart.Date || dp.type === DatePart.Month ? 1 : 0;
        }
        parts[dp.type] = value;
      });
      parts[DatePart.Month] -= 1;
      if (parts[DatePart.Month] < 0 || 11 < parts[DatePart.Month]) {
        return null;
      }
      // TODO: Century threshold
      if (parts[DatePart.Year] < 50) {
        parts[DatePart.Year] += 2000;
      }
      if (parts[DatePart.Date] > DateTimeUtil.daysInMonth(parts[DatePart.Year], parts[DatePart.Month])) {
        return null;
      }
      if (parts[DatePart.Hours] > 23 || parts[DatePart.Minutes] > 59 || parts[DatePart.Seconds] > 59 || parts[DatePart.FractionalSeconds] > 999) {
        return null;
      }
      const amPm = dateTimeParts.find(p => p.type === DatePart.AmPm);
      if (amPm) {
        parts[DatePart.Hours] %= 12;
      }
      if (amPm) {
        const cleanVal = DateTimeUtil.getCleanVal(inputData, amPm, promptChar);
        if (DateTimeUtil.isPm(cleanVal)) {
          parts[DatePart.Hours] += 12;
        }
      }
      return new Date(parts[DatePart.Year] || 2000, parts[DatePart.Month] || 0, parts[DatePart.Date] || 1, parts[DatePart.Hours] || 0, parts[DatePart.Minutes] || 0, parts[DatePart.Seconds] || 0, parts[DatePart.FractionalSeconds] || 0);
    }
    /** Parse the mask into date/time and literal parts */
    static parseDateTimeFormat(mask, locale) {
      const format = mask || DateTimeUtil.getDefaultInputFormat(locale);
      const dateTimeParts = [];
      const formatArray = Array.from(format);
      let currentPart = null;
      let position = 0;
      let lastPartAdded = false;
      for (let i = 0; i < formatArray.length; i++, position++) {
        const type = DateTimeUtil.determineDatePart(formatArray[i]);
        if (currentPart) {
          if (currentPart.type === type) {
            currentPart.format += formatArray[i];
            if (i < formatArray.length - 1) {
              continue;
            }
          }
          if (currentPart.type === DatePart.AmPm && currentPart.format.indexOf('a') !== -1) {
            currentPart = DateTimeUtil.simplifyAmPmFormat(currentPart);
          }
          DateTimeUtil.addCurrentPart(currentPart, dateTimeParts);
          lastPartAdded = true;
          position = currentPart.end;
          if (i === formatArray.length - 1 && currentPart.type !== type) {
            lastPartAdded = false;
          }
        }
        currentPart = {
          start: position,
          end: position + formatArray[i].length,
          type,
          format: formatArray[i]
        };
      }
      // make sure the last member of a format like H:m:s is not omitted
      if (!lastPartAdded) {
        if (currentPart.type === DatePart.AmPm) {
          currentPart = DateTimeUtil.simplifyAmPmFormat(currentPart);
        }
        DateTimeUtil.addCurrentPart(currentPart, dateTimeParts);
      }
      // formats like "y" or "yyy" are treated like "yyyy" while editing
      const yearPart = dateTimeParts.filter(p => p.type === DatePart.Year)[0];
      if (yearPart && yearPart.format !== 'yy') {
        yearPart.end += 4 - yearPart.format.length;
        yearPart.format = 'yyyy';
      }
      return dateTimeParts;
    }
    /** Simplifies the AmPm part to as many chars as will be displayed */
    static simplifyAmPmFormat(currentPart) {
      currentPart.format = currentPart.format.length === 5 ? 'a' : 'aa';
      currentPart.end = currentPart.start + currentPart.format.length;
      return {
        ...currentPart
      };
    }
    static getPartValue(value, datePartInfo, partLength) {
      let maskedValue;
      const datePart = datePartInfo.type;
      switch (datePart) {
        case DatePart.Date:
          maskedValue = value.getDate();
          break;
        case DatePart.Month:
          // months are zero based
          maskedValue = value.getMonth() + 1;
          break;
        case DatePart.Year:
          if (partLength === 2) {
            maskedValue = this.prependValue(parseInt(value.getFullYear().toString().slice(-2), 10), partLength, '0');
          } else {
            maskedValue = value.getFullYear();
          }
          break;
        case DatePart.Hours:
          if (datePartInfo.format.indexOf('h') !== -1) {
            maskedValue = this.prependValue(this.toTwelveHourFormat(value.getHours().toString()), partLength, '0');
          } else {
            maskedValue = value.getHours();
          }
          break;
        case DatePart.Minutes:
          maskedValue = value.getMinutes();
          break;
        case DatePart.Seconds:
          maskedValue = value.getSeconds();
          break;
        case DatePart.FractionalSeconds:
          maskedValue = value.getMilliseconds();
          break;
        case DatePart.AmPm:
          maskedValue = DateTimeUtil.getAmPmValue(partLength, value.getHours() < 12);
          break;
      }
      if (datePartInfo.type !== DatePart.AmPm && datePartInfo.type !== DatePart.Literal) {
        return this.prependValue(maskedValue, partLength, '0');
      }
      return maskedValue;
    }
    /** Returns the AmPm part value depending on the part length and a
     * conditional expression indicating whether the value is AM or PM.
     */
    static getAmPmValue(partLength, isAm) {
      if (isAm) {
        return partLength === 1 ? "a" /* AmPmValues.A */ : "AM" /* AmPmValues.AM */;
      } else {
        return partLength === 1 ? "p" /* AmPmValues.P */ : "PM" /* AmPmValues.PM */;
      }
    }
    /** Returns true if a string value indicates an AM period */
    static isAm(value) {
      value = value.toLowerCase();
      return value === "AM" /* AmPmValues.AM */.toLowerCase() || value === "a" /* AmPmValues.A */.toLowerCase();
    }
    /** Returns true if a string value indicates a PM period */
    static isPm(value) {
      value = value.toLowerCase();
      return value === "PM" /* AmPmValues.PM */.toLowerCase() || value === "p" /* AmPmValues.P */.toLowerCase();
    }
    /** Builds a date-time editor's default input format based on provided locale settings and data type. */
    static getDefaultInputFormat(locale, dataType = DataType.Date) {
      locale = locale || DateTimeUtil.DEFAULT_LOCALE;
      if (!Intl || !Intl.DateTimeFormat || !Intl.DateTimeFormat.prototype.formatToParts) {
        // TODO: fallback with Intl.format for IE?
        return DateTimeUtil.DEFAULT_INPUT_FORMAT;
      }
      const parts = DateTimeUtil.getDefaultLocaleMask(locale, dataType);
      parts.forEach(p => {
        if (p.type !== DatePart.Year && p.type !== DateTimeUtil.SEPARATOR && p.type !== DatePart.AmPm) {
          p.formatType = "2-digit" /* FormatDesc.TwoDigits */;
        }
      });
      return DateTimeUtil.getMask(parts);
    }
    /** Tries to format a date using Angular's DatePipe. Fallbacks to `Intl` if no locale settings have been loaded. */
    static formatDate(value, format, locale, timezone) {
      let formattedDate;
      try {
        formattedDate = formatDate$1(value, format, locale, timezone);
      } catch {
        DateTimeUtil.logMissingLocaleSettings(locale);
        const formatter = new Intl.DateTimeFormat(locale);
        formattedDate = formatter.format(value);
      }
      return formattedDate;
    }
    /**
     * Returns the date format based on a provided locale.
     * Supports Angular's DatePipe format options such as `shortDate`, `longDate`.
     */
    static getLocaleDateFormat(locale, displayFormat) {
      const formatKeys = Object.keys(FormatWidth);
      const targetKey = formatKeys.find(k => k.toLowerCase() === displayFormat?.toLowerCase().replace('date', ''));
      if (!targetKey) {
        // if displayFormat is not shortDate, longDate, etc.
        // or if it is not set by the user
        return displayFormat;
      }
      let format;
      try {
        format = getLocaleDateFormat(locale, FormatWidth[targetKey]);
      } catch {
        DateTimeUtil.logMissingLocaleSettings(locale);
        format = DateTimeUtil.getDefaultInputFormat(locale);
      }
      return format;
    }
    /** Determines if a given character is `d/M/y` or `h/m/s`. */
    static isDateOrTimeChar(char) {
      return DATE_CHARS.indexOf(char) !== -1 || TIME_CHARS.indexOf(char) !== -1;
    }
    /** Spins the date portion in a date-time editor. */
    static spinDate(delta, newDate, spinLoop) {
      const maxDate = DateTimeUtil.daysInMonth(newDate.getFullYear(), newDate.getMonth());
      let date = newDate.getDate() + delta;
      if (date > maxDate) {
        date = spinLoop ? date % maxDate : maxDate;
      } else if (date < 1) {
        date = spinLoop ? maxDate + date % maxDate : 1;
      }
      newDate.setDate(date);
    }
    /** Spins the month portion in a date-time editor. */
    static spinMonth(delta, newDate, spinLoop) {
      const maxDate = DateTimeUtil.daysInMonth(newDate.getFullYear(), newDate.getMonth() + delta);
      if (newDate.getDate() > maxDate) {
        newDate.setDate(maxDate);
      }
      const maxMonth = 11;
      const minMonth = 0;
      let month = newDate.getMonth() + delta;
      if (month > maxMonth) {
        month = spinLoop ? month % maxMonth - 1 : maxMonth;
      } else if (month < minMonth) {
        month = spinLoop ? maxMonth + month % maxMonth + 1 : minMonth;
      }
      newDate.setMonth(month);
    }
    /** Spins the year portion in a date-time editor. */
    static spinYear(delta, newDate) {
      const maxDate = DateTimeUtil.daysInMonth(newDate.getFullYear() + delta, newDate.getMonth());
      if (newDate.getDate() > maxDate) {
        // clip to max to avoid leap year change shifting the entire value
        newDate.setDate(maxDate);
      }
      newDate.setFullYear(newDate.getFullYear() + delta);
    }
    /** Spins the hours portion in a date-time editor. */
    static spinHours(delta, newDate, spinLoop) {
      const maxHour = 23;
      const minHour = 0;
      let hours = newDate.getHours() + delta;
      if (hours > maxHour) {
        hours = spinLoop ? hours % maxHour - 1 : maxHour;
      } else if (hours < minHour) {
        hours = spinLoop ? maxHour + hours % maxHour + 1 : minHour;
      }
      newDate.setHours(hours);
    }
    /** Spins the minutes portion in a date-time editor. */
    static spinMinutes(delta, newDate, spinLoop) {
      const maxMinutes = 59;
      const minMinutes = 0;
      let minutes = newDate.getMinutes() + delta;
      if (minutes > maxMinutes) {
        minutes = spinLoop ? minutes % maxMinutes - 1 : maxMinutes;
      } else if (minutes < minMinutes) {
        minutes = spinLoop ? maxMinutes + minutes % maxMinutes + 1 : minMinutes;
      }
      newDate.setMinutes(minutes);
    }
    /** Spins the seconds portion in a date-time editor. */
    static spinSeconds(delta, newDate, spinLoop) {
      const maxSeconds = 59;
      const minSeconds = 0;
      let seconds = newDate.getSeconds() + delta;
      if (seconds > maxSeconds) {
        seconds = spinLoop ? seconds % maxSeconds - 1 : maxSeconds;
      } else if (seconds < minSeconds) {
        seconds = spinLoop ? maxSeconds + seconds % maxSeconds + 1 : minSeconds;
      }
      newDate.setSeconds(seconds);
    }
    /** Spins the fractional seconds (milliseconds) portion in a date-time editor. */
    static spinFractionalSeconds(delta, newDate, spinLoop) {
      const maxMs = 999;
      const minMs = 0;
      let ms = newDate.getMilliseconds() + delta;
      if (ms > maxMs) {
        ms = spinLoop ? ms % maxMs - 1 : maxMs;
      } else if (ms < minMs) {
        ms = spinLoop ? maxMs + ms % maxMs + 1 : minMs;
      }
      newDate.setMilliseconds(ms);
    }
    /** Spins the AM/PM portion in a date-time editor. */
    static spinAmPm(newDate, currentDate, amPmFromMask) {
      if (DateTimeUtil.isAm(amPmFromMask)) {
        newDate = new Date(newDate.setHours(newDate.getHours() + 12));
      } else if (DateTimeUtil.isPm(amPmFromMask)) {
        newDate = new Date(newDate.setHours(newDate.getHours() - 12));
      }
      if (newDate.getDate() !== currentDate.getDate()) {
        return currentDate;
      }
      return newDate;
    }
    /**
     * Determines whether the provided value is greater than the provided max value.
     *
     * @param includeTime set to false if you want to exclude time portion of the two dates
     * @param includeDate set to false if you want to exclude the date portion of the two dates
     * @returns true if provided value is greater than provided maxValue
     */
    static greaterThanMaxValue(value, maxValue, includeTime = true, includeDate = true) {
      if (includeTime && includeDate) {
        return value.getTime() > maxValue.getTime();
      }
      const _value = new Date(value.getTime());
      const _maxValue = new Date(maxValue.getTime());
      if (!includeTime) {
        _value.setHours(0, 0, 0, 0);
        _maxValue.setHours(0, 0, 0, 0);
      }
      if (!includeDate) {
        _value.setFullYear(0, 0, 0);
        _maxValue.setFullYear(0, 0, 0);
      }
      return _value.getTime() > _maxValue.getTime();
    }
    /**
     * Determines whether the provided value is less than the provided min value.
     *
     * @param includeTime set to false if you want to exclude time portion of the two dates
     * @param includeDate set to false if you want to exclude the date portion of the two dates
     * @returns true if provided value is less than provided minValue
     */
    static lessThanMinValue(value, minValue, includeTime = true, includeDate = true) {
      if (includeTime && includeDate) {
        return value.getTime() < minValue.getTime();
      }
      const _value = new Date(value.getTime());
      const _minValue = new Date(minValue.getTime());
      if (!includeTime) {
        _value.setHours(0, 0, 0, 0);
        _minValue.setHours(0, 0, 0, 0);
      }
      if (!includeDate) {
        _value.setFullYear(0, 0, 0);
        _minValue.setFullYear(0, 0, 0);
      }
      return _value.getTime() < _minValue.getTime();
    }
    /**
     * Validates a value within a given min and max value range.
     *
     * @param value The value to validate
     * @param minValue The lowest possible value that `value` can take
     * @param maxValue The largest possible value that `value` can take
     */
    static validateMinMax(value, minValue, maxValue, includeTime = true, includeDate = true) {
      if (!value) {
        return null;
      }
      const errors = {};
      const min = DateTimeUtil.isValidDate(minValue) ? minValue : DateTimeUtil.parseIsoDate(minValue);
      const max = DateTimeUtil.isValidDate(maxValue) ? maxValue : DateTimeUtil.parseIsoDate(maxValue);
      if (min && value && DateTimeUtil.lessThanMinValue(value, min, includeTime, includeDate)) {
        Object.assign(errors, {
          minValue: true
        });
      }
      if (max && value && DateTimeUtil.greaterThanMaxValue(value, max, includeTime, includeDate)) {
        Object.assign(errors, {
          maxValue: true
        });
      }
      return errors;
    }
    /** Parse an ISO string to a Date */
    static parseIsoDate(value) {
      let regex = /^\d{4}/g;
      const timeLiteral = 'T';
      if (regex.test(value)) {
        return new Date(value + `${value.indexOf(timeLiteral) === -1 ? 'T00:00:00' : ''}`);
      }
      regex = /^\d{2}/g;
      if (regex.test(value)) {
        const dateNow = new Date().toISOString();
        // eslint-disable-next-line prefer-const
        let [datePart, _timePart] = dateNow.split(timeLiteral);
        return new Date(`${datePart}T${value}`);
      }
      return null;
    }
    /**
     * Returns whether the input is valid date
     *
     * @param value input to check
     * @returns true if provided input is a valid date
     */
    static isValidDate(value) {
      if (isDate(value)) {
        return !isNaN(value.getTime());
      }
      return false;
    }
    static isFormatNumeric(locale, inputFormat) {
      const dateParts = DateTimeUtil.parseDateTimeFormat(inputFormat);
      if (predefinedNonNumericFormats.has(inputFormat) || dateParts.every(p => p.type === DatePart.Literal)) {
        return false;
      }
      for (let i = 0; i < dateParts.length; i++) {
        if (dateParts[i].type === DatePart.AmPm || dateParts[i].type === DatePart.Literal) {
          continue;
        }
        const transformedValue = formatDate$1(new Date(), dateParts[i].format, locale);
        // check if the transformed date/time part contains any kind of letter from any language
        if (/\p{L}+/gu.test(transformedValue)) {
          return false;
        }
      }
      return true;
    }
    /**
     * Returns an input format that can be used by the date-time editors, as
     * - if the format is already numeric, return it as is
     * - if it is among the predefined numeric ones, return it as the equivalent locale-based format
     *   for the corresponding numeric date parts
     * - otherwise, return an empty string
     */
    static getNumericInputFormat(locale, format) {
      let resultFormat = '';
      if (!format) {
        return resultFormat;
      }
      if (predefinedNumericFormats.has(format)) {
        resultFormat = DateTimeUtil.getLocaleInputFormatFromParts(locale, predefinedNumericFormats.get(format));
      } else if (DateTimeUtil.isFormatNumeric(locale, format)) {
        resultFormat = format;
      }
      return resultFormat;
    }
    /** Gets the locale-based format from an array of date parts */
    static getLocaleInputFormatFromParts(locale, dateParts) {
      const options = {};
      dateParts.forEach(p => {
        if (p === "year" /* DateParts.Year */) {
          options[p] = "numeric" /* FormatDesc.Numeric */;
        } else if (p !== "dayPeriod" /* DateParts.AmPm */) {
          options[p] = "2-digit" /* FormatDesc.TwoDigits */;
        }
      });
      const formatter = new Intl.DateTimeFormat(locale, options);
      const dateStruct = DateTimeUtil.getDateStructFromParts(formatter.formatToParts(new Date()), formatter);
      DateTimeUtil.fillDatePartsPositions(dateStruct);
      return DateTimeUtil.getMask(dateStruct);
    }
    static addCurrentPart(currentPart, dateTimeParts) {
      DateTimeUtil.ensureLeadingZero(currentPart);
      currentPart.end = currentPart.start + currentPart.format.length;
      dateTimeParts.push(currentPart);
    }
    static daysInMonth(fullYear, month) {
      return new Date(fullYear, month + 1, 0).getDate();
    }
    static trimEmptyPlaceholders(value, promptChar) {
      const result = value.replace(new RegExp(promptChar || '_', 'g'), '');
      return result;
    }
    static getMask(dateStruct) {
      const mask = [];
      for (const part of dateStruct) {
        if (part.formatType === "numeric" /* FormatDesc.Numeric */) {
          switch (part.type) {
            case "day" /* DateParts.Day */:
              mask.push('d');
              break;
            case "month" /* DateParts.Month */:
              mask.push('M');
              break;
            case "year" /* DateParts.Year */:
              mask.push('yyyy');
              break;
            case "hour" /* DateParts.Hour */:
              mask.push(part.hour12 ? 'h' : 'H');
              break;
            case "minute" /* DateParts.Minute */:
              mask.push('m');
              break;
            case "second" /* DateParts.Second */:
              mask.push('s');
              break;
          }
        } else if (part.formatType === "2-digit" /* FormatDesc.TwoDigits */) {
          switch (part.type) {
            case "day" /* DateParts.Day */:
              mask.push('dd');
              break;
            case "month" /* DateParts.Month */:
              mask.push('MM');
              break;
            case "year" /* DateParts.Year */:
              mask.push('yy');
              break;
            case "hour" /* DateParts.Hour */:
              mask.push(part.hour12 ? 'hh' : 'HH');
              break;
            case "minute" /* DateParts.Minute */:
              mask.push('mm');
              break;
            case "second" /* DateParts.Second */:
              mask.push('ss');
              break;
          }
        }
        if (part.type === "dayPeriod" /* DateParts.AmPm */) {
          mask.push('tt');
        }
        if (part.type === DateTimeUtil.SEPARATOR) {
          mask.push(part.value);
        }
      }
      return mask.join('');
    }
    static logMissingLocaleSettings(locale) {
      console.warn(`Missing locale data for the locale ${locale}. Please refer to https://angular.io/guide/i18n#i18n-pipes`);
      console.warn('Using default browser locale settings.');
    }
    static prependValue(value, partLength, prependChar) {
      return (prependChar + value.toString()).slice(-partLength);
    }
    static toTwelveHourFormat(value, promptChar = '_') {
      let hour = parseInt(value.replace(new RegExp(promptChar, 'g'), '0'), 10);
      if (hour > 12) {
        hour -= 12;
      } else if (hour === 0) {
        hour = 12;
      }
      return hour;
    }
    static ensureLeadingZero(part) {
      switch (part.type) {
        case DatePart.Date:
        case DatePart.Month:
        case DatePart.Hours:
        case DatePart.Minutes:
        case DatePart.Seconds:
          if (part.format.length === 1) {
            part.format = part.format.repeat(2);
          }
          break;
        case DatePart.FractionalSeconds:
          part.format = part.format[0].repeat(3);
          break;
      }
    }
    static getCleanVal(inputData, datePart, promptChar) {
      return DateTimeUtil.trimEmptyPlaceholders(inputData.substring(datePart.start, datePart.end), promptChar);
    }
    static determineDatePart(char) {
      switch (char) {
        case 'd':
        case 'D':
          return DatePart.Date;
        case 'M':
          return DatePart.Month;
        case 'y':
        case 'Y':
          return DatePart.Year;
        case 'h':
        case 'H':
          return DatePart.Hours;
        case 'm':
          return DatePart.Minutes;
        case 's':
          return DatePart.Seconds;
        case 'S':
          return DatePart.FractionalSeconds;
        case 'a':
        case 't':
        case 'T':
          return DatePart.AmPm;
        default:
          return DatePart.Literal;
      }
    }
    static getFormatOptions(dataType) {
      const dateOptions = {
        day: "2-digit" /* FormatDesc.TwoDigits */,
        month: "2-digit" /* FormatDesc.TwoDigits */,
        year: "numeric" /* FormatDesc.Numeric */
      };
      const timeOptions = {
        hour: "2-digit" /* FormatDesc.TwoDigits */,
        minute: "2-digit" /* FormatDesc.TwoDigits */
      };
      switch (dataType) {
        case DataType.Date:
          return dateOptions;
        case DataType.Time:
          return timeOptions;
        case DataType.DateTime:
          return {
            ...dateOptions,
            ...timeOptions,
            second: "2-digit" /* FormatDesc.TwoDigits */
          };
        default:
          return {};
      }
    }
    static getDefaultLocaleMask(locale, dataType = DataType.Date) {
      const options = DateTimeUtil.getFormatOptions(dataType);
      const formatter = new Intl.DateTimeFormat(locale, options);
      const formatToParts = formatter.formatToParts(new Date());
      const dateStruct = DateTimeUtil.getDateStructFromParts(formatToParts, formatter);
      DateTimeUtil.fillDatePartsPositions(dateStruct);
      return dateStruct;
    }
    static getDateStructFromParts(parts, formatter) {
      const dateStruct = [];
      for (const part of parts) {
        if (part.type === DateTimeUtil.SEPARATOR) {
          dateStruct.push({
            type: DateTimeUtil.SEPARATOR,
            value: part.value
          });
        } else {
          dateStruct.push({
            type: part.type
          });
        }
      }
      const formatterOptions = formatter.resolvedOptions();
      for (const part of dateStruct) {
        switch (part.type) {
          case "day" /* DateParts.Day */:
            {
              part.formatType = formatterOptions.day;
              break;
            }
          case "month" /* DateParts.Month */:
            {
              part.formatType = formatterOptions.month;
              break;
            }
          case "year" /* DateParts.Year */:
            {
              part.formatType = formatterOptions.year;
              break;
            }
          case "hour" /* DateParts.Hour */:
            {
              part.formatType = formatterOptions.hour;
              if (formatterOptions.hour12) {
                part.hour12 = true;
              }
              break;
            }
          case "minute" /* DateParts.Minute */:
            {
              part.formatType = formatterOptions.minute;
              break;
            }
          case "second" /* DateParts.Second */:
            {
              part.formatType = formatterOptions.second;
              break;
            }
          case "dayPeriod" /* DateParts.AmPm */:
            {
              part.formatType = formatterOptions.dayPeriod;
              break;
            }
        }
      }
      return dateStruct;
    }
    static fillDatePartsPositions(dateArray) {
      let currentPos = 0;
      for (const part of dateArray) {
        // Day|Month|Hour|Minute|Second|AmPm part positions
        if (part.type === "day" /* DateParts.Day */ || part.type === "month" /* DateParts.Month */ || part.type === "hour" /* DateParts.Hour */ || part.type === "minute" /* DateParts.Minute */ || part.type === "second" /* DateParts.Second */ || part.type === "dayPeriod" /* DateParts.AmPm */) {
          // Offset 2 positions for number
          part.position = [currentPos, currentPos + 2];
          currentPos += 2;
        } else if (part.type === "year" /* DateParts.Year */) {
          // Year part positions
          switch (part.formatType) {
            case "numeric" /* FormatDesc.Numeric */:
              {
                // Offset 4 positions for full year
                part.position = [currentPos, currentPos + 4];
                currentPos += 4;
                break;
              }
            case "2-digit" /* FormatDesc.TwoDigits */:
              {
                // Offset 2 positions for short year
                part.position = [currentPos, currentPos + 2];
                currentPos += 2;
                break;
              }
          }
        } else if (part.type === DateTimeUtil.SEPARATOR) {
          // Separator positions
          part.position = [currentPos, currentPos + 1];
          currentPos++;
        }
      }
    }
  }
  return DateTimeUtil;
})();
/**
 * Provides base filtering operations
 * Implementations should be Singleton
 *
 * @export
 */
let IgxFilteringOperand = /*#__PURE__*/(() => {
  class IgxFilteringOperand {
    static {
      this._instance = null;
    }
    constructor() {
      this.operations = [{
        name: 'null',
        isUnary: true,
        iconName: 'filter_null',
        logic: target => target === null
      }, {
        name: 'notNull',
        isUnary: true,
        iconName: 'filter_not_null',
        logic: target => target !== null
      }, {
        name: 'in',
        isUnary: false,
        iconName: 'filter_in',
        hidden: true,
        logic: (target, searchVal) => this.findValueInSet(target, searchVal)
      }, {
        name: 'inQuery',
        isUnary: false,
        isNestedQuery: true,
        iconName: 'in',
        logic: (target, searchVal) => this.findValueInSet(target, searchVal)
      }, {
        name: 'notInQuery',
        isUnary: false,
        isNestedQuery: true,
        iconName: 'not-in',
        logic: (target, searchVal) => !this.findValueInSet(target, searchVal)
      }];
    }
    static instance() {
      return this._instance || (this._instance = new this());
    }
    /**
     * Returns an array of names of the conditions which are visible in the filtering UI
     */
    conditionList() {
      return this.operations.filter(f => !f.hidden && !f.isNestedQuery).map(element => element.name);
    }
    /**
     * Returns an array of names of the conditions which are visible in the UI, including "In" and "Not In", allowing the creation of sub-queries.
     * @hidden @internal
     */
    extendedConditionList() {
      return this.operations.filter(f => !f.hidden).map(element => element.name);
    }
    /**
     * Returns an instance of the condition with the specified name.
     *
     * @param name The name of the condition.
     */
    condition(name) {
      return this.operations.find(element => element.name === name);
    }
    /**
     * Adds a new condition to the filtering operations.
     *
     * @param operation The filtering operation.
     */
    append(operation) {
      this.operations.push(operation);
    }
    findValueInSet(target, searchVal) {
      return searchVal.has(target);
    }
  }
  return IgxFilteringOperand;
})();
/* blazorCSSuppress */
/**
 * Provides filtering operations for booleans
 *
 * @export
 */
class IgxBooleanFilteringOperand extends IgxFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'all',
      isUnary: true,
      iconName: 'filter_all',
      logic: _target => true
    }, {
      name: 'true',
      isUnary: true,
      iconName: 'filter_true',
      logic: target => !!(target && target !== null && target !== undefined)
    }, {
      name: 'false',
      isUnary: true,
      iconName: 'filter_false',
      logic: target => !target && target !== null && target !== undefined
    }, {
      name: 'empty',
      isUnary: true,
      iconName: 'filter_empty',
      logic: target => target === null || target === undefined
    }, {
      name: 'notEmpty',
      isUnary: true,
      iconName: 'filter_not_empty',
      logic: target => target !== null && target !== undefined
    }];
    this.operations = newOperations.concat(this.operations);
  }
}
/* blazorCSSuppress */
/**
 * @internal
 * @hidden
 */
class IgxBaseDateTimeFilteringOperand extends IgxFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'empty',
      isUnary: true,
      iconName: 'filter_empty',
      logic: target => target === null || target === undefined
    }, {
      name: 'notEmpty',
      isUnary: true,
      iconName: 'filter_not_empty',
      logic: target => target !== null && target !== undefined
    }];
    this.operations = newOperations.concat(this.operations);
  }
  /**
   * Splits a Date object into parts
   *
   * @memberof IgxDateFilteringOperand
   */
  static getDateParts(date, dateFormat) {
    const res = {
      day: null,
      hours: null,
      milliseconds: null,
      minutes: null,
      month: null,
      seconds: null,
      year: null
    };
    if (!date || !dateFormat) {
      return res;
    }
    if (dateFormat.indexOf('y') >= 0) {
      res.year = date.getFullYear();
    }
    if (dateFormat.indexOf('M') >= 0) {
      res.month = date.getMonth();
    }
    if (dateFormat.indexOf('d') >= 0) {
      res.day = date.getDate();
    }
    if (dateFormat.indexOf('h') >= 0) {
      res.hours = date.getHours();
    }
    if (dateFormat.indexOf('m') >= 0) {
      res.minutes = date.getMinutes();
    }
    if (dateFormat.indexOf('s') >= 0) {
      res.seconds = date.getSeconds();
    }
    if (dateFormat.indexOf('f') >= 0) {
      res.milliseconds = date.getMilliseconds();
    }
    return res;
  }
  findValueInSet(target, searchVal) {
    if (!target) {
      return false;
    }
    return searchVal.has(target instanceof Date ? target.toISOString() : target);
  }
  validateInputData(target) {
    if (!(target instanceof Date)) {
      throw new Error('Could not perform filtering on \'date\' column because the datasource object type is not \'Date\'.');
    }
  }
}
/* blazorCSSuppress */
/**
 * Provides filtering operations for Dates
 *
 * @export
 */
class IgxDateFilteringOperand extends IgxBaseDateTimeFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'equals',
      isUnary: false,
      iconName: 'filter_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetp = IgxDateFilteringOperand.getDateParts(target, 'yMd');
        const searchp = IgxDateFilteringOperand.getDateParts(searchVal, 'yMd');
        return targetp.year === searchp.year && targetp.month === searchp.month && targetp.day === searchp.day;
      }
    }, {
      name: 'doesNotEqual',
      isUnary: false,
      iconName: 'filter_not_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return true;
        }
        this.validateInputData(target);
        const targetp = IgxDateFilteringOperand.getDateParts(target, 'yMd');
        const searchp = IgxDateFilteringOperand.getDateParts(searchVal, 'yMd');
        return targetp.year !== searchp.year || targetp.month !== searchp.month || targetp.day !== searchp.day;
      }
    }, {
      name: 'before',
      isUnary: false,
      iconName: 'filter_before',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        return target < searchVal;
      }
    }, {
      name: 'after',
      isUnary: false,
      iconName: 'filter_after',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        return target > searchVal;
      }
    }, {
      name: 'today',
      isUnary: true,
      iconName: 'filter_today',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'yMd');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'yMd');
        return d.year === now.year && d.month === now.month && d.day === now.day;
      }
    }, {
      name: 'yesterday',
      isUnary: true,
      iconName: 'filter_yesterday',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const td = IgxDateFilteringOperand.getDateParts(target, 'yMd');
        const y = (d => new Date(d.setDate(d.getDate() - 1)))(new Date());
        const yesterday = IgxDateFilteringOperand.getDateParts(y, 'yMd');
        return td.year === yesterday.year && td.month === yesterday.month && td.day === yesterday.day;
      }
    }, {
      name: 'thisMonth',
      isUnary: true,
      iconName: 'filter_this_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'yM');
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'lastMonth',
      isUnary: true,
      iconName: 'filter_last_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'yM');
        if (!now.month) {
          now.month = 11;
          now.year -= 1;
        } else {
          now.month--;
        }
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'nextMonth',
      isUnary: true,
      iconName: 'filter_next_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'yM');
        if (now.month === 11) {
          now.month = 0;
          now.year += 1;
        } else {
          now.month++;
        }
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'thisYear',
      isUnary: true,
      iconName: 'filter_this_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year;
      }
    }, {
      name: 'lastYear',
      isUnary: true,
      iconName: 'filter_last_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year - 1;
      }
    }, {
      name: 'nextYear',
      isUnary: true,
      iconName: 'filter_next_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year + 1;
      }
    }];
    this.operations = newOperations.concat(this.operations);
  }
  findValueInSet(target, searchVal) {
    if (!target) {
      return false;
    }
    target = target.toDateString();
    return searchVal.has(target);
  }
}
/* blazorCSSuppress */
class IgxDateTimeFilteringOperand extends IgxBaseDateTimeFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'equals',
      isUnary: false,
      iconName: 'filter_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetp = IgxDateTimeFilteringOperand.getDateParts(target, 'yMdhms');
        const searchp = IgxDateTimeFilteringOperand.getDateParts(searchVal, 'yMdhms');
        return targetp.year === searchp.year && targetp.month === searchp.month && targetp.day === searchp.day && targetp.hours === searchp.hours && targetp.minutes === searchp.minutes && targetp.seconds === searchp.seconds;
      }
    }, {
      name: 'doesNotEqual',
      isUnary: false,
      iconName: 'filter_not_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return true;
        }
        this.validateInputData(target);
        const targetp = IgxDateTimeFilteringOperand.getDateParts(target, 'yMdhms');
        const searchp = IgxDateTimeFilteringOperand.getDateParts(searchVal, 'yMdhms');
        return targetp.year !== searchp.year || targetp.month !== searchp.month || targetp.day !== searchp.day || targetp.hours !== searchp.hours || targetp.minutes !== searchp.minutes || targetp.seconds !== searchp.seconds;
      }
    }, {
      name: 'before',
      isUnary: false,
      iconName: 'filter_before',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        return target < searchVal;
      }
    }, {
      name: 'after',
      isUnary: false,
      iconName: 'filter_after',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        return target > searchVal;
      }
    }, {
      name: 'today',
      isUnary: true,
      iconName: 'filter_today',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'yMd');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'yMd');
        return d.year === now.year && d.month === now.month && d.day === now.day;
      }
    }, {
      name: 'yesterday',
      isUnary: true,
      iconName: 'filter_yesterday',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const td = IgxDateTimeFilteringOperand.getDateParts(target, 'yMd');
        const y = (d => new Date(d.setDate(d.getDate() - 1)))(new Date());
        const yesterday = IgxDateTimeFilteringOperand.getDateParts(y, 'yMd');
        return td.year === yesterday.year && td.month === yesterday.month && td.day === yesterday.day;
      }
    }, {
      name: 'thisMonth',
      isUnary: true,
      iconName: 'filter_this_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'yM');
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'lastMonth',
      isUnary: true,
      iconName: 'filter_last_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'yM');
        if (!now.month) {
          now.month = 11;
          now.year -= 1;
        } else {
          now.month--;
        }
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'nextMonth',
      isUnary: true,
      iconName: 'filter_next_month',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'yM');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'yM');
        if (now.month === 11) {
          now.month = 0;
          now.year += 1;
        } else {
          now.month++;
        }
        return d.year === now.year && d.month === now.month;
      }
    }, {
      name: 'thisYear',
      isUnary: true,
      iconName: 'filter_this_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year;
      }
    }, {
      name: 'lastYear',
      isUnary: true,
      iconName: 'filter_last_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year - 1;
      }
    }, {
      name: 'nextYear',
      isUnary: true,
      iconName: 'filter_next_year',
      logic: target => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const d = IgxDateTimeFilteringOperand.getDateParts(target, 'y');
        const now = IgxDateTimeFilteringOperand.getDateParts(new Date(), 'y');
        return d.year === now.year + 1;
      }
    }];
    this.operations = newOperations.concat(this.operations);
  }
}
/* blazorCSSuppress */
class IgxTimeFilteringOperand extends IgxBaseDateTimeFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'at',
      isUnary: false,
      iconName: 'filter_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetp = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const searchp = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetp.hours === searchp.hours && targetp.minutes === searchp.minutes && targetp.seconds === searchp.seconds;
      }
    }, {
      name: 'not_at',
      isUnary: false,
      iconName: 'filter_not_equal',
      logic: (target, searchVal) => {
        if (!target) {
          return true;
        }
        this.validateInputData(target);
        const targetp = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const searchp = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetp.hours !== searchp.hours || targetp.minutes !== searchp.minutes || targetp.seconds !== searchp.seconds;
      }
    }, {
      name: 'before',
      isUnary: false,
      iconName: 'filter_before',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetn = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const search = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetn.hours < search.hours ? true : targetn.hours === search.hours && targetn.minutes < search.minutes ? true : targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds < search.seconds;
      }
    }, {
      name: 'after',
      isUnary: false,
      iconName: 'filter_after',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetn = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const search = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetn.hours > search.hours ? true : targetn.hours === search.hours && targetn.minutes > search.minutes ? true : targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds > search.seconds;
      }
    }, {
      name: 'at_before',
      isUnary: false,
      iconName: 'filter_before',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetn = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const search = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds === search.seconds || targetn.hours < search.hours ? true : targetn.hours === search.hours && targetn.minutes < search.minutes ? true : targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds < search.seconds;
      }
    }, {
      name: 'at_after',
      isUnary: false,
      iconName: 'filter_after',
      logic: (target, searchVal) => {
        if (!target) {
          return false;
        }
        this.validateInputData(target);
        const targetn = IgxTimeFilteringOperand.getDateParts(target, 'hms');
        const search = IgxTimeFilteringOperand.getDateParts(searchVal, 'hms');
        return targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds === search.seconds || targetn.hours > search.hours ? true : targetn.hours === search.hours && targetn.minutes > search.minutes ? true : targetn.hours === search.hours && targetn.minutes === search.minutes && targetn.seconds > search.seconds;
      }
    }];
    this.operations = newOperations.concat(this.operations);
  }
  findValueInSet(target, searchVal) {
    if (!target) {
      return false;
    }
    return searchVal.has(target.toLocaleTimeString());
  }
}
/* blazorCSSuppress */
/**
 * Provides filtering operations for numbers
 *
 * @export
 */
class IgxNumberFilteringOperand extends IgxFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'equals',
      isUnary: false,
      iconName: 'filter_equal',
      logic: (target, searchVal) => target === searchVal
    }, {
      name: 'doesNotEqual',
      isUnary: false,
      iconName: 'filter_not_equal',
      logic: (target, searchVal) => target !== searchVal
    }, {
      name: 'greaterThan',
      isUnary: false,
      iconName: 'filter_greater_than',
      logic: (target, searchVal) => target > searchVal
    }, {
      name: 'lessThan',
      isUnary: false,
      iconName: 'filter_less_than',
      logic: (target, searchVal) => target < searchVal
    }, {
      name: 'greaterThanOrEqualTo',
      isUnary: false,
      iconName: 'filter_greater_than_or_equal',
      logic: (target, searchVal) => target >= searchVal
    }, {
      name: 'lessThanOrEqualTo',
      isUnary: false,
      iconName: 'filter_less_than_or_equal',
      logic: (target, searchVal) => target <= searchVal
    }, {
      name: 'empty',
      isUnary: true,
      iconName: 'filter_empty',
      logic: target => target === null || target === undefined || isNaN(target)
    }, {
      name: 'notEmpty',
      isUnary: true,
      iconName: 'filter_not_empty',
      logic: target => target !== null && target !== undefined && !isNaN(target)
    }];
    this.operations = newOperations.concat(this.operations);
  }
}
/* blazorCSSuppress */
/**
 * Provides filtering operations for strings
 *
 * @export
 */
class IgxStringFilteringOperand extends IgxFilteringOperand {
  constructor() {
    super();
    const newOperations = [{
      name: 'contains',
      isUnary: false,
      iconName: 'filter_contains',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target.indexOf(search) !== -1;
      }
    }, {
      name: 'doesNotContain',
      isUnary: false,
      iconName: 'filter_does_not_contain',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target.indexOf(search) === -1;
      }
    }, {
      name: 'startsWith',
      isUnary: false,
      iconName: 'filter_starts_with',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target.startsWith(search);
      }
    }, {
      name: 'endsWith',
      isUnary: false,
      iconName: 'filter_ends_with',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target.endsWith(search);
      }
    }, {
      name: 'equals',
      isUnary: false,
      iconName: 'filter_equal',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target === search;
      }
    }, {
      name: 'doesNotEqual',
      isUnary: false,
      iconName: 'filter_not_equal',
      logic: (target, searchVal, ignoreCase) => {
        const search = IgxStringFilteringOperand.applyIgnoreCase(searchVal, ignoreCase);
        target = IgxStringFilteringOperand.applyIgnoreCase(target, ignoreCase);
        return target !== search;
      }
    }, {
      name: 'empty',
      isUnary: true,
      iconName: 'filter_empty',
      logic: target => target === null || target === undefined || target.length === 0
    }, {
      name: 'notEmpty',
      isUnary: true,
      iconName: 'filter_not_empty',
      logic: target => target !== null && target !== undefined && target.length > 0
    }];
    this.operations = newOperations.concat(this.operations);
  }
  /**
   * Applies case sensitivity on strings if provided
   *
   * @memberof IgxStringFilteringOperand
   */
  static applyIgnoreCase(a, ignoreCase) {
    a = a ?? '';
    // bulletproof
    return ignoreCase ? ('' + a).toLowerCase() : a;
  }
}
class ExpressionsTreeUtil {
  /**
   * Returns the filtering expression for a column with the provided tree and fieldName.
   * ```typescript
   * let filteringExpression = ExpressionsTreeUtil.find(gridExpressionTree, 'Column Field');
   * ```
   */
  static find(tree, fieldName) {
    const index = this.findIndex(tree, fieldName);
    if (index > -1) {
      return tree.filteringOperands[index];
    }
    return null;
  }
  /**
   * Returns the index of the filtering expression for a column with the provided tree and fieldName.
   * ```typescript
   * let filteringExpressionIndex = ExpressionsTreeUtil.findIndex(gridExpressionTree, 'Column Field');
   * ```
   */
  static findIndex(tree, fieldName) {
    for (let i = 0; i < tree.filteringOperands.length; i++) {
      const expr = tree.filteringOperands[i];
      if (expr.operator !== undefined) {
        if (this.isFilteringExpressionsTreeForColumn(expr, fieldName)) {
          return i;
        }
      } else if (expr.fieldName === fieldName) {
        return i;
      }
    }
    return -1;
  }
  static isFilteringExpressionsTreeForColumn(expressionsTree, fieldName) {
    if (expressionsTree.fieldName === fieldName) {
      return true;
    }
    for (const expr of expressionsTree.filteringOperands) {
      if (expr.operator !== undefined) {
        return this.isFilteringExpressionsTreeForColumn(expr, fieldName);
      } else if (expr.fieldName === fieldName) {
        return true;
      }
    }
    return false;
  }
}
/**
 * Recreates the search value for a given expression.
 * @param searchValue The search value to recreate.
 * @param dataType The data type of the field.
 * @returns The recreated search value.
 */
function recreateSearchValue(searchValue, dataType) {
  if (!dataType && !Array.isArray(searchValue)) {
    return searchValue;
  }
  // In ESF, values are stored as a Set.
  // Those values are converted to an array before returning string in the stringifyCallback
  // now we need to convert those back to Set
  if (Array.isArray(searchValue)) {
    return new Set(searchValue);
  } else if ((dataType.toLowerCase().includes('date') || dataType.toLowerCase().includes('time')) && !(searchValue instanceof Date)) {
    return DateTimeUtil.parseIsoDate(searchValue) ?? searchValue;
  }
  return searchValue;
}
/**
 * Returns the filtering logic function for a given dataType and condition (contains, greaterThan, etc.)
 * @param dataType The data type of the field.
 * @param name The name of the filtering condition.
 * @returns The filtering logic function.
 */
function getFilteringCondition(dataType, name) {
  let filters;
  switch (dataType) {
    case GridColumnDataType.Boolean:
      filters = IgxBooleanFilteringOperand.instance();
      break;
    case GridColumnDataType.Number:
    case GridColumnDataType.Currency:
    case GridColumnDataType.Percent:
      filters = IgxNumberFilteringOperand.instance();
      break;
    case GridColumnDataType.Date:
      filters = IgxDateFilteringOperand.instance();
      break;
    case GridColumnDataType.Time:
      filters = IgxTimeFilteringOperand.instance();
      break;
    case GridColumnDataType.DateTime:
      filters = IgxDateTimeFilteringOperand.instance();
      break;
    case GridColumnDataType.String:
    default:
      filters = IgxStringFilteringOperand.instance();
      break;
  }
  return filters.condition(name);
}
/**
 * Recreates the IFilteringOperation for a given expression.
 * If the `logic` is already populated - it will return the original IFilteringOperation
 * of the expression.
 * @param expression The expression for which to resolve the IFilteringOperation.
 * @param dataType The data type of the field.
 * @returns The IFilteringOperation for the given expression.
 */
function recreateOperatorFromDataType(expression, dataType) {
  if (!expression.condition?.logic) {
    return getFilteringCondition(dataType, expression.conditionName || expression.condition?.name);
  }
  return expression.condition;
}
/**
 * Recreates an expression from the given fields by applying the correct operands
 * and adjusting the search value to be the correct type.
 * @param expression The expression to recreate.
 * @param fields An array of fields to use for recreating the expression.
 * @returns The recreated expression.
 */
function recreateExpression(expression, fields) {
  const field = fields?.find(f => f.field === expression.fieldName);
  if (field && !expression.condition?.logic) {
    if (!field.filters) {
      expression.condition = recreateOperatorFromDataType(expression, field.dataType);
    } else {
      expression.condition = field.filters.condition(expression.conditionName || expression.condition?.name);
    }
  }
  if (!expression.condition && expression.conditionName) {
    throw Error('Wrong `conditionName`, `condition` or `field` provided! It is possible that there is a type mismatch between the condition type and field type.');
  }
  if (!expression.conditionName) {
    expression.conditionName = expression.condition?.name;
  }
  expression.searchVal = recreateSearchValue(expression.searchVal, field?.dataType);
  return expression;
}
/**
 * Checks if the given entry is an IExpressionTree.
 * @param entry The entry to check.
 * @returns True if the entry is an IExpressionTree, false otherwise.
 */
function isTree(entry) {
  return 'operator' in entry;
}
/**
 * Recreates the tree from a given array of entities by applying the correct operands
 * for each expression and adjusting the search values to be the correct type.
 * @param tree The expression tree to recreate.
 * @param entities An array of entities to use for recreating the tree.
 * @returns The recreated expression tree.
 */
function recreateTree(tree, entities) {
  const entity = entities.find(e => e.name === tree.entity);
  for (let i = 0; i < tree.filteringOperands.length; i++) {
    const operand = tree.filteringOperands[i];
    if (isTree(operand)) {
      tree.filteringOperands[i] = recreateTree(operand, entities);
    } else {
      if (operand.searchTree) {
        operand.searchTree = recreateTree(operand.searchTree, entities);
      }
      tree.filteringOperands[i] = recreateExpression(operand, entity?.fields);
    }
  }
  return tree;
}
/**
 * Recreates the tree from a given array of fields by applying the correct operands.
 * It is recommended to use `recreateTree` if there will be multiple entities in the tree
 * with potentially colliding field names.
 * @param tree The expression tree to recreate.
 * @param fields An array of fields to use for recreating the tree.
 */
function recreateTreeFromFields(tree, fields) {
  for (let i = 0; i < tree.filteringOperands.length; i++) {
    const operand = tree.filteringOperands[i];
    if (isTree(operand)) {
      tree.filteringOperands[i] = recreateTreeFromFields(operand, fields);
    } else {
      if (operand.searchTree) {
        operand.searchTree = recreateTreeFromFields(operand.searchTree, fields);
      }
      tree.filteringOperands[i] = recreateExpression(operand, fields);
    }
  }
  return tree;
}

/* mustCoerceToInt */
var FilteringExpressionsTreeType = /*#__PURE__*/function (FilteringExpressionsTreeType) {
  FilteringExpressionsTreeType[FilteringExpressionsTreeType["Regular"] = 0] = "Regular";
  FilteringExpressionsTreeType[FilteringExpressionsTreeType["Advanced"] = 1] = "Advanced";
  return FilteringExpressionsTreeType;
}(FilteringExpressionsTreeType || {});
/* marshalByValue */
/* jsonAPIPlainObject */
class FilteringExpressionsTree {
  constructor(operator, fieldName, entity, returnFields) {
    /**
     * Sets/gets the filtering operands.
     * ```typescript
     * const gridExpressionsTree = new FilteringExpressionsTree(FilteringLogic.And);
     * const expression = [
     * {
     *   condition: IgxStringFilteringOperand.instance().condition('contains'),
     *   fieldName: 'Column Field',
     *   searchVal: 'Value',
     *   ignoreCase: false
     * }];
     * gridExpressionsTree.filteringOperands.push(expression);
     * this.grid.filteringExpressionsTree = gridExpressionsTree;
     * ```
     * ```typescript
     * let filteringOperands = gridExpressionsTree.filteringOperands;
     * ```
     *
     * @memberof FilteringExpressionsTree
     */
    this.filteringOperands = [];
    this.operator = operator;
    this.entity = entity;
    this.returnFields = returnFields;
    this.fieldName = fieldName;
  }
  /**
   * Checks if filtering expressions tree is empty.
   *
   * @param expressionTree filtering expressions tree.
   */
  static empty(expressionTree) {
    return !expressionTree || !expressionTree.filteringOperands || !expressionTree.filteringOperands.length;
  }
  /* blazorSuppress */
  /**
   * Returns the filtering expression for a column with the provided fieldName.
   * ```typescript
   * let filteringExpression = gridExpressionTree.find('Column Field');
   * ```
   *
   * @memberof FilteringExpressionsTree
   * @deprecated in version 18.2.0. Use `ExpressionsTreeUtil.find` instead.
   */
  find(fieldName) {
    return ExpressionsTreeUtil.find(this, fieldName);
  }
  /* blazorSuppress */
  /**
   * Returns the index of the filtering expression for a column with the provided fieldName.
   * ```typescript
   * let filteringExpressionIndex = gridExpressionTree.findIndex('Column Field');
   * ```
   *
   * @memberof FilteringExpressionsTree
   * @deprecated in version 18.2.0. Use `ExpressionsTreeUtil.findIndex` instead.
   */
  findIndex(fieldName) {
    return ExpressionsTreeUtil.findIndex(this, fieldName);
  }
}

/* mustCoerceToInt */
var FilteringLogic = /*#__PURE__*/function (FilteringLogic) {
  FilteringLogic[FilteringLogic["And"] = 0] = "And";
  FilteringLogic[FilteringLogic["Or"] = 1] = "Or";
  return FilteringLogic;
}(FilteringLogic || {});
const DateType = 'date';
const DateTimeType = 'dateTime';
const TimeType = 'time';
class FilterUtil {
  static filter(data, state, grid) {
    if (!state.strategy) {
      state.strategy = new FilteringStrategy();
    }
    return state.strategy.filter(data, state.expressionsTree, state.advancedExpressionsTree, grid);
  }
}
/* csSuppress */
class BaseFilteringStrategy {
  // protected
  findMatchByExpression(rec, expr, isDate, isTime, grid) {
    const val = this.getFieldValue(rec, expr.fieldName, isDate, isTime, grid);
    if (expr.condition?.logic) {
      return expr.condition.logic(val, expr.searchVal, expr.ignoreCase);
    }
  }
  // protected
  matchRecord(rec, expressions, grid) {
    if (expressions) {
      if (isTree(expressions)) {
        const expressionsTree = expressions;
        const operator = expressionsTree.operator;
        let matchOperand;
        if (expressionsTree.filteringOperands && expressionsTree.filteringOperands.length) {
          for (const operand of expressionsTree.filteringOperands) {
            matchOperand = this.matchRecord(rec, operand, grid);
            // Return false if at least one operand does not match and the filtering logic is And
            if (!matchOperand && operator === FilteringLogic.And) {
              return false;
            }
            // Return true if at least one operand matches and the filtering logic is Or
            if (matchOperand && operator === FilteringLogic.Or) {
              return true;
            }
          }
          return matchOperand;
        }
        return true;
      } else {
        const expression = expressions;
        const column = grid && grid.getColumnByName(expression.fieldName);
        const isDate = column ? column.dataType === DateType || column.dataType === DateTimeType : false;
        const isTime = column ? column.dataType === TimeType : false;
        return this.findMatchByExpression(rec, expression, isDate, isTime, grid);
      }
    }
    return true;
  }
  getFilterItems(column, tree) {
    let data = column.grid.gridAPI.filterDataByExpressions(tree);
    data = column.grid.gridAPI.sortDataByExpressions(data, [{
      fieldName: column.field,
      dir: SortingDirection.Asc,
      ignoreCase: column.sortingIgnoreCase
    }]);
    const columnField = column.field;
    let filterItems = data.map(record => {
      let value = resolveNestedPath(record, columnField);
      const applyFormatter = column.formatter && this.shouldFormatFilterValues(column);
      value = applyFormatter ? column.formatter(value, record) : value;
      return {
        value,
        label: this.getFilterItemLabel(column, value, !applyFormatter, record)
      };
    });
    filterItems = this.getUniqueFilterItems(column, filterItems);
    return Promise.resolve(filterItems);
  }
  getFilterItemLabel(column, value, applyFormatter, data) {
    if (column.formatter) {
      if (applyFormatter) {
        return column.formatter(value, data);
      }
      return value;
    }
    const {
      display,
      format,
      digitsInfo,
      currencyCode,
      timezone
    } = column.pipeArgs;
    const locale = column.grid.locale;
    switch (column.dataType) {
      case GridColumnDataType.Date:
      case GridColumnDataType.DateTime:
      case GridColumnDataType.Time:
        return formatDate(value, format, locale, timezone);
      case GridColumnDataType.Currency:
        return formatCurrency(value, currencyCode || getLocaleCurrencyCode(locale), display, digitsInfo, locale);
      case GridColumnDataType.Number:
        return formatNumber(value, locale, digitsInfo);
      case GridColumnDataType.Percent:
        return formatPercent(value, locale, digitsInfo);
      default:
        return value;
    }
  }
  getUniqueFilterItems(column, filterItems) {
    const filteredUniqueValues = filterItems.reduce((map, item) => {
      let key = item.value;
      if (column.dataType === GridColumnDataType.String && column.filteringIgnoreCase) {
        key = key?.toString().toLowerCase();
      } else if (column.dataType === GridColumnDataType.DateTime) {
        key = item.value?.toString();
        item.value = key ? new Date(key) : key;
      } else if (column.dataType === GridColumnDataType.Time) {
        const date = key ? new Date(key) : key;
        key = date ? new Date().setHours(date.getHours(), date.getMinutes(), date.getSeconds()) : key;
        item.value = key ? new Date(key) : key;
      } else if (column.dataType === GridColumnDataType.Date) {
        const date = key ? new Date(key) : key;
        key = date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString() : key;
        item.value = date;
      }
      return map.has(key) ? map : map.set(key, item);
    }, new Map());
    const uniqueValues = Array.from(filteredUniqueValues.values());
    return uniqueValues;
  }
  shouldFormatFilterValues(_column) {
    return false;
  }
}
/* csSuppress */
let NoopFilteringStrategy = /*#__PURE__*/(() => {
  class NoopFilteringStrategy extends BaseFilteringStrategy {
    getFieldValue(rec, _fieldName) {
      return rec;
    }
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new NoopFilteringStrategy());
    }
    filter(data, _, __) {
      return data;
    }
  }
  return NoopFilteringStrategy;
})();
let FilteringStrategy = /*#__PURE__*/(() => {
  class FilteringStrategy extends BaseFilteringStrategy {
    static {
      this._instance = null;
    }
    constructor() {
      super();
    }
    static instance() {
      return this._instance || (this._instance = new this());
    }
    filter(data, expressionsTree, advancedExpressionsTree, grid) {
      let i;
      let rec;
      const len = data.length;
      const res = [];
      if (FilteringExpressionsTree.empty(expressionsTree) && FilteringExpressionsTree.empty(advancedExpressionsTree) || !len) {
        return data;
      }
      for (i = 0; i < len; i++) {
        rec = data[i];
        if (this.matchRecord(rec, expressionsTree, grid) && this.matchRecord(rec, advancedExpressionsTree, grid)) {
          res.push(rec);
        }
      }
      return res;
    }
    getFieldValue(rec, fieldName, isDate = false, isTime = false, grid) {
      const column = grid?.getColumnByName(fieldName);
      let value = resolveNestedPath(rec, fieldName);
      value = column?.formatter && this.shouldFormatFilterValues(column) ? column.formatter(value, rec) : value && (isDate || isTime) ? parseDate(value) : value;
      return value;
    }
  }
  return FilteringStrategy;
})();
class FormattedValuesFilteringStrategy extends FilteringStrategy {
  /**
   * Creates a new instance of FormattedValuesFilteringStrategy.
   *
   * @param fields An array of column field names that should be formatted.
   * If omitted the values of all columns which has formatter will be formatted.
   */
  constructor(fields) {
    super();
    this.fields = fields;
  }
  shouldFormatFilterValues(column) {
    return !this.fields || this.fields.length === 0 || this.fields.some(f => f === column.field);
  }
}
class TreeGridFilteringStrategy extends BaseFilteringStrategy {
  constructor(hierarchicalFilterFields) {
    super();
    this.hierarchicalFilterFields = hierarchicalFilterFields;
  }
  filter(data, expressionsTree, advancedExpressionsTree, grid) {
    return this.filterImpl(data, expressionsTree, advancedExpressionsTree, undefined, grid);
  }
  getFieldValue(rec, fieldName, isDate = false, isTime = false, grid) {
    const column = grid?.getColumnByName(fieldName);
    const hierarchicalRecord = rec;
    let value = this.isHierarchicalFilterField(fieldName) ? this.getHierarchicalFieldValue(hierarchicalRecord, fieldName) : resolveNestedPath(hierarchicalRecord.data, fieldName);
    value = column?.formatter && this.shouldFormatFilterValues(column) ? column.formatter(value, rec.data) : value && (isDate || isTime) ? parseDate(value) : value;
    return value;
  }
  getHierarchicalFieldValue(record, field) {
    const value = resolveNestedPath(record.data, field);
    return record.parent ? `${this.getHierarchicalFieldValue(record.parent, field)}${value ? `.[${value}]` : ''}` : `[${value}]`;
  }
  filterImpl(data, expressionsTree, advancedExpressionsTree, parent, grid) {
    let i;
    let rec;
    const len = data.length;
    const res = [];
    if (FilteringExpressionsTree.empty(expressionsTree) && FilteringExpressionsTree.empty(advancedExpressionsTree) || !len) {
      return data;
    }
    for (i = 0; i < len; i++) {
      rec = DataUtil.cloneTreeGridRecord(data[i]);
      rec.parent = parent;
      if (rec.children) {
        const filteredChildren = this.filterImpl(rec.children, expressionsTree, advancedExpressionsTree, rec, grid);
        rec.children = filteredChildren.length > 0 ? filteredChildren : null;
      }
      if (this.matchRecord(rec, expressionsTree, grid) && this.matchRecord(rec, advancedExpressionsTree, grid)) {
        res.push(rec);
      } else if (rec.children && rec.children.length > 0) {
        rec.isFilteredOutParent = true;
        res.push(rec);
      }
    }
    return res;
  }
  isHierarchicalFilterField(field) {
    return this.hierarchicalFilterFields && this.hierarchicalFilterFields.indexOf(field) !== -1;
  }
  getFilterItems(column, tree) {
    if (!this.isHierarchicalFilterField(column.field)) {
      return super.getFilterItems(column, tree);
    }
    let data = column.grid.gridAPI.filterTreeDataByExpressions(tree);
    data = DataUtil.treeGridSort(data, [{
      fieldName: column.field,
      dir: SortingDirection.Asc,
      ignoreCase: column.sortingIgnoreCase
    }], column.grid.sortStrategy, null, column.grid);
    const items = this.getHierarchicalFilterItems(data, column);
    return Promise.resolve(items);
  }
  getHierarchicalFilterItems(records, column, parent) {
    return records?.map(record => {
      let value = resolveNestedPath(record.data, column.field);
      const applyFormatter = column.formatter && this.shouldFormatFilterValues(column);
      value = applyFormatter ? column.formatter(value, record.data) : value;
      const hierarchicalValue = parent ? value || value === 0 ? `${parent.value}.[${value}]` : value : `[${value}]`;
      const filterItem = {
        value: hierarchicalValue
      };
      filterItem.label = this.getFilterItemLabel(column, value, !applyFormatter, record.data);
      filterItem.children = this.getHierarchicalFilterItems(record.children, column, filterItem);
      return filterItem;
    });
  }
}
class TreeGridFormattedValuesFilteringStrategy extends TreeGridFilteringStrategy {
  /**
   * Creates a new instance of FormattedValuesFilteringStrategy.
   *
   * @param fields An array of column field names that should be formatted.
   * If omitted the values of all columns which has formatter will be formatted.
   */
  constructor(fields) {
    super();
    this.fields = fields;
  }
  shouldFormatFilterValues(column) {
    return !this.fields || this.fields.length === 0 || this.fields.some(f => f === column.field);
  }
}
class TreeGridMatchingRecordsOnlyFilteringStrategy extends TreeGridFilteringStrategy {
  filter(data, expressionsTree, advancedExpressionsTree, grid) {
    return this.filterImplementation(data, expressionsTree, advancedExpressionsTree, undefined, grid);
  }
  filterImplementation(data, expressionsTree, advancedExpressionsTree, parent, grid) {
    let i;
    let rec;
    const len = data.length;
    const res = [];
    if (FilteringExpressionsTree.empty(expressionsTree) && FilteringExpressionsTree.empty(advancedExpressionsTree) || !len) {
      return data;
    }
    for (i = 0; i < len; i++) {
      rec = DataUtil.cloneTreeGridRecord(data[i]);
      rec.parent = parent;
      if (rec.children) {
        const filteredChildren = this.filterImplementation(rec.children, expressionsTree, advancedExpressionsTree, rec, grid);
        rec.children = filteredChildren.length > 0 ? filteredChildren : null;
      }
      if (this.matchRecord(rec, expressionsTree, grid) && this.matchRecord(rec, advancedExpressionsTree, grid)) {
        res.push(rec);
      } else if (rec.children && rec.children.length > 0) {
        rec = this.setCorrectLevelToFilteredRecords(rec);
        res.push(...rec.children);
      }
    }
    return res;
  }
  setCorrectLevelToFilteredRecords(rec) {
    if (rec.children && rec.children.length > 0) {
      rec.children.map(child => {
        child.level = child.level - 1;
        return this.setCorrectLevelToFilteredRecords(child);
      });
    }
    return rec;
  }
}

/**
 * Enumeration representing different filter modes for grid filtering.
 * - quickFilter: Default mode with a filter row UI between the column headers and the first row of records.
 * - excelStyleFilter: Filter mode where an Excel-style filter is used.
 */
const FilterMode = /*@__PURE__*/mkenum({
  quickFilter: 'quickFilter',
  excelStyleFilter: 'excelStyleFilter'
});
/**
 * Enumeration representing the position of grid summary rows.
 * - top: Default value; Summary rows are displayed at the top of the grid.
 * - bottom: Summary rows are displayed at the bottom of the grid.
 */
const GridSummaryPosition = /*@__PURE__*/mkenum({
  top: 'top',
  bottom: 'bottom'
});
/**
 * Enumeration representing different calculation modes for grid summaries.
 * - rootLevelOnly: Summaries are calculated only for the root level.
 * - childLevelsOnly: Summaries are calculated only for child levels.
 * - rootAndChildLevels: Default value; Summaries are calculated for both root and child levels.
 */
const GridSummaryCalculationMode = /*@__PURE__*/mkenum({
  rootLevelOnly: 'rootLevelOnly',
  childLevelsOnly: 'childLevelsOnly',
  rootAndChildLevels: 'rootAndChildLevels'
});
/**
 * Enumeration representing different selection modes for the grid elements if can be selected.
 * - 'none': No selection is allowed. Default row and column selection mode.
 * - 'single': Only one element can be selected at a time. Selecting a new one will deselect the previously selected one.
 * - 'multiple': Default cell selection mode. More than one element can be selected at a time.
 * - 'multipleCascade': Similar to multiple selection. It is used in hierarchical or tree grids. Allows selection not only to an individual item but also all its related or nested items in a single action
 */
const GridSelectionMode = /*@__PURE__*/mkenum({
  none: 'none',
  single: 'single',
  multiple: 'multiple',
  multipleCascade: 'multipleCascade'
});
/** Enumeration representing different column display order options. */
const ColumnDisplayOrder = /*@__PURE__*/mkenum({
  Alphabetical: 'Alphabetical',
  DisplayOrder: 'DisplayOrder'
});
/* mustCoerceToInt */
/**
 * Enumeration representing the possible positions for pinning columns.
 * - Start: Columns are pinned to the start of the grid.
 * - End: Columns are pinned to the end of the grid.
 */
var ColumnPinningPosition = /*#__PURE__*/function (ColumnPinningPosition) {
  ColumnPinningPosition[ColumnPinningPosition["Start"] = 0] = "Start";
  ColumnPinningPosition[ColumnPinningPosition["End"] = 1] = "End";
  return ColumnPinningPosition;
}(ColumnPinningPosition || {});
/* mustCoerceToInt */
/**
 * Enumeration representing the possible positions for pinning rows.
 * - Top: Rows are pinned to the top of the grid.
 * - Bottom: Rows are pinned to the bottom of the grid.
 */
var RowPinningPosition = /*#__PURE__*/function (RowPinningPosition) {
  RowPinningPosition[RowPinningPosition["Top"] = 0] = "Top";
  RowPinningPosition[RowPinningPosition["Bottom"] = 1] = "Bottom";
  return RowPinningPosition;
}(RowPinningPosition || {});
/* mustCoerceToInt */
/**
 * Enumeration representing different paging modes for the grid.
 * - Local: The grid will use local data to extract pages during paging.
 * - Remote: The grid will expect pages to be delivered from a remote location and will only raise events during paging interactions.
 */
var GridPagingMode = /*#__PURE__*/function (GridPagingMode) {
  GridPagingMode[GridPagingMode["Local"] = 0] = "Local";
  GridPagingMode[GridPagingMode["Remote"] = 1] = "Remote";
  return GridPagingMode;
}(GridPagingMode || {});
/**
 * @hidden @internal
 *
 * Enumeration representing the possible predefined size options of the grid.
 * - Small: This is the smallest size with 32px row height. Left and Right paddings are 12px. Minimal column width is 56px.
 * - Medium: This is the middle size with 40px row height. Left and Right paddings are 16px. Minimal column width is 64px.
 * - Large:  this is the default Grid size with the lowest intense and row height equal to 50px. Left and Right paddings are 24px. Minimal column width is 80px.
 */
const Size = /*@__PURE__*/mkenum({
  Small: '1',
  Medium: '2',
  Large: '3'
});
var ExportRecordType = /*#__PURE__*/function (ExportRecordType) {
  ExportRecordType["GroupedRecord"] = "GroupedRecord";
  ExportRecordType["TreeGridRecord"] = "TreeGridRecord";
  ExportRecordType["DataRecord"] = "DataRecord";
  ExportRecordType["HierarchicalGridRecord"] = "HierarchicalGridRecord";
  ExportRecordType["HeaderRecord"] = "HeaderRecord";
  ExportRecordType["SummaryRecord"] = "SummaryRecord";
  ExportRecordType["PivotGridRecord"] = "PivotGridRecord";
  return ExportRecordType;
}(ExportRecordType || {});
var ExportHeaderType = /*#__PURE__*/function (ExportHeaderType) {
  ExportHeaderType["RowHeader"] = "RowHeader";
  ExportHeaderType["ColumnHeader"] = "ColumnHeader";
  ExportHeaderType["MultiRowHeader"] = "MultiRowHeader";
  ExportHeaderType["MultiColumnHeader"] = "MultiColumnHeader";
  ExportHeaderType["PivotRowHeader"] = "PivotRowHeader";
  ExportHeaderType["PivotMergedHeader"] = "PivotMergedHeader";
  return ExportHeaderType;
}(ExportHeaderType || {});
/**hidden
 * A helper class used to identify whether the user has set a specific columnIndex
 * during columnExporting, so we can honor it at the exported file.
*/
class IgxColumnExportingEventArgs {
  get columnIndex() {
    return this._columnIndex;
  }
  set columnIndex(value) {
    this._columnIndex = value;
    this.userSetIndex = true;
  }
  constructor(original) {
    this.userSetIndex = false;
    this.header = original.header;
    this.field = original.field;
    this.cancel = original.cancel;
    this.skipFormatter = original.skipFormatter;
    this.grid = original.grid;
    this.owner = original.owner;
    this._columnIndex = original.columnIndex;
  }
}
const DEFAULT_OWNER = 'default';
const GRID_ROOT_SUMMARY = 'igxGridRootSummary';
const GRID_PARENT = 'grid-parent';
const GRID_LEVEL_COL = 'GRID_LEVEL_COL';
const DEFAULT_COLUMN_WIDTH = 8.43;
const GRID_CHILD = 'grid-child-';
class IgxBaseExporter {
  constructor() {
    this.exportEnded = new EventEmitter();
    /**
     * This event is emitted when a row is exported.
     * ```typescript
     * this.exporterService.rowExporting.subscribe((args: IRowExportingEventArgs) => {
     * // put event handler code here
     * });
     * ```
     *
     * @memberof IgxBaseExporter
     */
    this.rowExporting = new EventEmitter();
    /**
     * This event is emitted when a column is exported.
     * ```typescript
     * this.exporterService.columnExporting.subscribe((args: IColumnExportingEventArgs) => {
     * // put event handler code here
     * });
     * ```
     *
     * @memberof IgxBaseExporter
     */
    this.columnExporting = new EventEmitter();
    this._sort = null;
    this._ownersMap = new Map();
    this._setChildSummaries = false;
    this.summaries = new Map();
    this.rowIslandCounter = -1;
    this.flatRecords = [];
    this.pivotGridColumns = [];
    this.pivotGridKeyValueMap = new Map();
  }
  /* alternateName: exportGrid */
  /**
   * Method for exporting IgxGrid component's data.
   * ```typescript
   * this.exporterService.export(this.igxGridForExport, this.exportOptions);
   * ```
   *
   * @memberof IgxBaseExporter
   */
  export(grid, options) {
    if (options === undefined || options === null) {
      throw Error('No options provided!');
    }
    this.options = options;
    this.locale = grid.locale;
    this.ownerGrid = grid;
    let columns = grid.columns;
    if (this.options.ignoreMultiColumnHeaders) {
      columns = columns.filter(col => col.children === undefined);
    }
    const columnList = this.getColumns(columns);
    if (grid.type === 'hierarchical') {
      this._ownersMap.set(grid, columnList);
      const childLayoutList = grid.childLayoutList;
      for (const island of childLayoutList) {
        this.mapHierarchicalGridColumns(island, grid.data[0]);
      }
    } else if (grid.type === 'pivot') {
      this.pivotGridColumns = [];
      this.isPivotGridExport = true;
      this.pivotGridKeyValueMap = new Map();
      this.pivotGridRowDimensionsMap = new Map();
      grid.visibleRowDimensions.filter(r => r.enabled).forEach(rowDimension => {
        this.addToRowDimensionsMap(rowDimension, rowDimension.memberName);
      });
      this._ownersMap.set(DEFAULT_OWNER, columnList);
    } else {
      this._ownersMap.set(DEFAULT_OWNER, columnList);
    }
    this.summaries = this.prepareSummaries(grid);
    this._setChildSummaries = this.summaries.size > 1 && grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly;
    this.addLevelColumns();
    this.prepareData(grid);
    this.addLevelData();
    this.addPivotGridColumns(grid);
    this.addPivotRowHeaders(grid);
    this.exportGridRecordsData(this.flatRecords, grid);
  }
  /**
   * Method for exporting any kind of array data.
   * ```typescript
   * this.exporterService.exportData(this.arrayForExport, this.exportOptions);
   * ```
   *
   * @memberof IgxBaseExporter
   */
  exportData(data, options) {
    if (options === undefined || options === null) {
      throw Error('No options provided!');
    }
    this.options = options;
    const records = data.map(d => {
      const record = {
        data: d,
        type: ExportRecordType.DataRecord,
        level: 0
      };
      return record;
    });
    this.exportGridRecordsData(records);
  }
  addToRowDimensionsMap(rowDimension, rootParentName) {
    this.pivotGridRowDimensionsMap[rowDimension.memberName] = rootParentName;
    if (rowDimension.childLevel) {
      this.addToRowDimensionsMap(rowDimension.childLevel, rootParentName);
    }
  }
  exportGridRecordsData(records, grid) {
    if (this._ownersMap.size === 0) {
      const recordsData = records.filter(r => r.type !== ExportRecordType.SummaryRecord).map(r => r.data);
      const keys = ExportUtilities.getKeysFromData(recordsData);
      const columns = keys.map(k => ({
        header: k,
        field: k,
        skip: false,
        headerType: ExportHeaderType.ColumnHeader,
        level: 0,
        columnSpan: 1
      }));
      const columnWidths = new Array(keys.length).fill(DEFAULT_COLUMN_WIDTH);
      const mapRecord = {
        columns,
        columnWidths,
        indexOfLastPinnedColumn: -1,
        maxLevel: 0
      };
      this._ownersMap.set(DEFAULT_OWNER, mapRecord);
    }
    let shouldReorderColumns = false;
    for (const [key, mapRecord] of this._ownersMap) {
      let skippedPinnedColumnsCount = 0;
      let columnsWithoutHeaderCount = 1;
      let indexOfLastPinnedColumn = mapRecord.indexOfLastPinnedColumn;
      mapRecord.columns.forEach((column, index) => {
        if (!column.skip) {
          const columnExportArgs = {
            header: !ExportUtilities.isNullOrWhitespaces(column.header) ? column.header : 'Column' + columnsWithoutHeaderCount++,
            field: column.field,
            columnIndex: index,
            cancel: false,
            skipFormatter: false,
            grid: key === DEFAULT_OWNER ? grid : key
          };
          const newColumnExportArgs = new IgxColumnExportingEventArgs(columnExportArgs);
          this.columnExporting.emit(newColumnExportArgs);
          column.header = newColumnExportArgs.header;
          column.skip = newColumnExportArgs.cancel;
          column.skipFormatter = newColumnExportArgs.skipFormatter;
          if (newColumnExportArgs.userSetIndex) {
            column.exportIndex = newColumnExportArgs.columnIndex;
            shouldReorderColumns = true;
          }
          if (column.skip) {
            if (index <= indexOfLastPinnedColumn) {
              skippedPinnedColumnsCount++;
            }
            this.calculateColumnSpans(column, mapRecord, column.columnSpan);
            const nonSkippedColumns = mapRecord.columns.filter(c => !c.skip);
            if (nonSkippedColumns.length > 0) {
              this._ownersMap.get(key).maxLevel = nonSkippedColumns.sort((a, b) => b.level - a.level)[0].level;
            }
          }
          if (this._sort && this._sort.fieldName === column.field) {
            if (column.skip) {
              this._sort = null;
            } else {
              this._sort.fieldName = column.header;
            }
          }
        }
      });
      indexOfLastPinnedColumn -= skippedPinnedColumnsCount;
      // Reorder columns only if a column has been assigned a specific columnIndex during columnExporting event
      if (shouldReorderColumns) {
        mapRecord.columns = this.reorderColumns(mapRecord.columns);
      }
    }
    const dataToExport = new Array();
    const actualData = records[0]?.data;
    const isSpecialData = ExportUtilities.isSpecialData(actualData);
    yieldingLoop(records.length, 100, i => {
      const row = records[i];
      this.exportRow(dataToExport, row, i, isSpecialData);
    }, () => {
      this.exportDataImplementation(dataToExport, this.options, () => {
        this.resetDefaults();
      });
    });
  }
  calculateColumnSpans(column, mapRecord, span) {
    if (column.headerType === ExportHeaderType.MultiColumnHeader && column.skip) {
      const columnGroupChildren = mapRecord.columns.filter(c => c.columnGroupParent === column.columnGroup);
      columnGroupChildren.forEach(cgc => {
        if (cgc.headerType === ExportHeaderType.MultiColumnHeader) {
          cgc.columnSpan = 0;
          cgc.columnGroupParent = null;
          cgc.skip = true;
          this.calculateColumnSpans(cgc, mapRecord, cgc.columnSpan);
        } else {
          cgc.skip = true;
        }
      });
    }
    const targetCol = mapRecord.columns.filter(c => column.columnGroupParent !== null && column.columnGroupParent !== undefined && c.columnGroup === column.columnGroupParent)[0];
    if (targetCol !== undefined) {
      targetCol.columnSpan -= span;
      if (targetCol.columnGroupParent !== null) {
        this.calculateColumnSpans(targetCol, mapRecord, span);
      }
      if (targetCol.columnSpan === 0) {
        targetCol.skip = true;
      }
    }
  }
  exportRow(data, record, index, isSpecialData) {
    if (!isSpecialData) {
      const owner = record.owner === undefined ? DEFAULT_OWNER : record.owner;
      const ownerCols = this._ownersMap.get(owner).columns;
      if (record.type !== ExportRecordType.HeaderRecord) {
        const columns = ownerCols.filter(c => c.headerType === ExportHeaderType.ColumnHeader && !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex);
        record.data = columns.reduce((a, e) => {
          if (!e.skip) {
            let rawValue = resolveNestedPath(record.data, e.field);
            const shouldApplyFormatter = e.formatter && !e.skipFormatter && record.type !== ExportRecordType.GroupedRecord;
            const isOfDateType = e.dataType === 'date' || e.dataType === 'dateTime' || e.dataType === 'time';
            if (isOfDateType && record.type !== ExportRecordType.SummaryRecord && record.type !== ExportRecordType.GroupedRecord && !(rawValue instanceof Date) && !shouldApplyFormatter && rawValue !== undefined && rawValue !== null) {
              rawValue = new Date(rawValue);
            } else if (e.dataType === 'string' && rawValue instanceof Date) {
              rawValue = rawValue.toString();
            }
            let formattedValue = shouldApplyFormatter ? e.formatter(rawValue, record.data) : rawValue;
            if (this.isPivotGridExport && !isNaN(parseFloat(formattedValue))) {
              formattedValue = parseFloat(formattedValue);
            }
            a[e.field] = formattedValue;
          }
          return a;
        }, {});
      } else {
        record.data = record.data.filter((_, i) => !record.references[i].skip);
      }
    }
    const rowArgs = {
      rowData: record.data,
      rowIndex: index,
      cancel: false,
      owner: record.owner ?? this.ownerGrid
    };
    this.rowExporting.emit(rowArgs);
    if (!rowArgs.cancel) {
      data.push(record);
    }
  }
  reorderColumns(columns) {
    const filteredColumns = columns.filter(c => !c.skip);
    const length = filteredColumns.length;
    const specificIndicesColumns = filteredColumns.filter(col => !isNaN(col.exportIndex)).sort((a, b) => a.exportIndex - b.exportIndex);
    const indices = specificIndicesColumns.map(col => col.exportIndex);
    specificIndicesColumns.forEach(col => {
      filteredColumns.splice(filteredColumns.indexOf(col), 1);
    });
    const reorderedColumns = new Array(length);
    if (specificIndicesColumns.length > Math.max(...indices)) {
      return specificIndicesColumns.concat(filteredColumns);
    } else {
      indices.forEach((i, index) => {
        if (i < 0 || i >= length) {
          filteredColumns.push(specificIndicesColumns[index]);
        } else {
          let k = i;
          while (k < length && reorderedColumns[k] !== undefined) {
            ++k;
          }
          reorderedColumns[k] = specificIndicesColumns[index];
        }
      });
      for (let i = 0; i < length; i++) {
        if (reorderedColumns[i] === undefined) {
          reorderedColumns[i] = filteredColumns.splice(0, 1)[0];
        }
      }
    }
    return reorderedColumns;
  }
  prepareData(grid) {
    this.flatRecords = [];
    const hasFiltering = grid.filteringExpressionsTree && grid.filteringExpressionsTree.filteringOperands.length > 0 || grid.advancedFilteringExpressionsTree && grid.advancedFilteringExpressionsTree.filteringOperands.length > 0;
    const expressions = grid.groupingExpressions ? grid.groupingExpressions.concat(grid.sortingExpressions || []) : grid.sortingExpressions;
    const hasSorting = expressions && expressions.length > 0;
    let setSummaryOwner = false;
    switch (grid.type) {
      case 'pivot':
        {
          this.preparePivotGridData(grid);
          break;
        }
      case 'hierarchical':
        {
          this.prepareHierarchicalGridData(grid, hasFiltering, hasSorting);
          setSummaryOwner = true;
          break;
        }
      case 'tree':
        {
          this.prepareTreeGridData(grid, hasFiltering, hasSorting);
          break;
        }
      default:
        {
          this.prepareGridData(grid, hasFiltering, hasSorting);
          break;
        }
    }
    if (this.summaries.size > 0 && grid.summaryCalculationMode !== GridSummaryCalculationMode.childLevelsOnly) {
      setSummaryOwner ? this.setSummaries(GRID_ROOT_SUMMARY, 0, false, grid) : this.setSummaries(GRID_ROOT_SUMMARY);
    }
  }
  preparePivotGridData(grid) {
    for (const record of grid.filteredSortedData) {
      const recordData = Object.fromEntries(record.aggregationValues);
      record.dimensionValues.forEach((value, key) => {
        const actualKey = this.pivotGridRowDimensionsMap[key];
        recordData[actualKey] = value;
      });
      const pivotGridRecord = {
        data: recordData,
        level: record.level,
        type: ExportRecordType.PivotGridRecord
      };
      this.flatRecords.push(pivotGridRecord);
    }
  }
  prepareHierarchicalGridData(grid, hasFiltering, hasSorting) {
    const skipOperations = (!hasFiltering || !this.options.ignoreFiltering) && (!hasSorting || !this.options.ignoreSorting);
    if (skipOperations) {
      const data = grid.filteredSortedData;
      this.addHierarchicalGridData(grid, data);
    } else {
      let data = grid.data;
      if (hasFiltering && !this.options.ignoreFiltering) {
        const filteringState = {
          expressionsTree: grid.filteringExpressionsTree,
          advancedExpressionsTree: grid.advancedFilteringExpressionsTree,
          strategy: grid.filterStrategy
        };
        data = FilterUtil.filter(data, filteringState, grid);
      }
      if (hasSorting && !this.options.ignoreSorting) {
        this._sort = cloneValue(grid.sortingExpressions[0]);
        data = DataUtil.sort(data, grid.sortingExpressions, grid.sortStrategy, grid);
      }
      this.addHierarchicalGridData(grid, data);
    }
  }
  addHierarchicalGridData(grid, records) {
    const childLayoutList = grid.childLayoutList;
    const columnFields = this._ownersMap.get(grid).columns.map(col => col.field);
    for (const entry of records) {
      const expansionStateVal = grid.expansionStates.has(entry) ? grid.expansionStates.get(entry) : false;
      const dataWithoutChildren = Object.keys(entry).filter(k => columnFields.includes(k)).reduce((obj, key) => {
        obj[key] = entry[key];
        return obj;
      }, {});
      const hierarchicalGridRecord = {
        data: dataWithoutChildren,
        level: 0,
        type: ExportRecordType.HierarchicalGridRecord,
        owner: grid,
        hierarchicalOwner: GRID_PARENT
      };
      this.flatRecords.push(hierarchicalGridRecord);
      for (const island of childLayoutList) {
        const path = {
          rowID: island.primaryKey ? entry[island.primaryKey] : entry,
          rowKey: island.primaryKey ? entry[island.primaryKey] : entry,
          rowIslandKey: island.key
        };
        const islandGrid = grid?.gridAPI.getChildGrid([path]);
        const keyRecordData = this.prepareIslandData(island, islandGrid, entry[island.key]) || [];
        this.getAllChildColumnsAndData(island, keyRecordData, expansionStateVal, islandGrid);
      }
    }
  }
  prepareSummaries(grid) {
    let summaries = new Map();
    if (this.options.exportSummaries && grid.summaryService.summaryCacheMap.size > 0) {
      const summaryCacheMap = grid.summaryService.summaryCacheMap;
      switch (grid.summaryCalculationMode) {
        case GridSummaryCalculationMode.childLevelsOnly:
          summaryCacheMap.delete(GRID_ROOT_SUMMARY);
          break;
        case GridSummaryCalculationMode.rootLevelOnly:
          for (const k of summaryCacheMap.keys()) {
            if (k !== GRID_ROOT_SUMMARY) {
              summaryCacheMap.delete(k);
            }
          }
          break;
      }
      summaries = summaryCacheMap;
    }
    return summaries;
  }
  prepareIslandData(island, islandGrid, data) {
    if (islandGrid !== undefined) {
      const hasFiltering = islandGrid.filteringExpressionsTree && islandGrid.filteringExpressionsTree.filteringOperands.length > 0 || islandGrid.advancedFilteringExpressionsTree && islandGrid.advancedFilteringExpressionsTree.filteringOperands.length > 0;
      const hasSorting = islandGrid.sortingExpressions && islandGrid.sortingExpressions.length > 0;
      const skipOperations = (!hasFiltering || !this.options.ignoreFiltering) && (!hasSorting || !this.options.ignoreSorting);
      if (skipOperations) {
        data = islandGrid.filteredSortedData;
      } else {
        if (hasFiltering && !this.options.ignoreFiltering) {
          const filteringState = {
            expressionsTree: islandGrid.filteringExpressionsTree,
            advancedExpressionsTree: islandGrid.advancedFilteringExpressionsTree,
            strategy: islandGrid.filterStrategy
          };
          data = FilterUtil.filter(data, filteringState, islandGrid);
        }
        if (hasSorting && !this.options.ignoreSorting) {
          this._sort = cloneValue(islandGrid.sortingExpressions[0]);
          data = DataUtil.sort(data, islandGrid.sortingExpressions, islandGrid.sortStrategy, islandGrid);
        }
      }
    } else {
      const hasFiltering = island.filteringExpressionsTree && island.filteringExpressionsTree.filteringOperands.length > 0 || island.advancedFilteringExpressionsTree && island.advancedFilteringExpressionsTree.filteringOperands.length > 0;
      const hasSorting = island.sortingExpressions && island.sortingExpressions.length > 0;
      const skipOperations = (!hasFiltering || this.options.ignoreFiltering) && (!hasSorting || this.options.ignoreSorting);
      if (!skipOperations) {
        if (hasFiltering && !this.options.ignoreFiltering) {
          const filteringState = {
            expressionsTree: island.filteringExpressionsTree,
            advancedExpressionsTree: island.advancedFilteringExpressionsTree,
            strategy: island.filterStrategy
          };
          data = FilterUtil.filter(data, filteringState, island);
        }
        if (hasSorting && !this.options.ignoreSorting) {
          this._sort = cloneValue(island.sortingExpressions[0]);
          data = DataUtil.sort(data, island.sortingExpressions, island.sortStrategy, island);
        }
      }
    }
    return data;
  }
  getAllChildColumnsAndData(island, childData, expansionStateVal, grid) {
    const hierarchicalOwner = `${GRID_CHILD}${++this.rowIslandCounter}`;
    const columnList = this._ownersMap.get(island).columns;
    const columnHeaders = columnList.filter(col => col.headerType === ExportHeaderType.ColumnHeader);
    const columnHeader = columnHeaders.map(col => col.header ? col.header : col.field);
    const headerRecord = {
      data: columnHeader,
      level: island.level,
      type: ExportRecordType.HeaderRecord,
      owner: island,
      hidden: !expansionStateVal,
      references: columnHeaders,
      hierarchicalOwner
    };
    if (childData && childData.length > 0) {
      this.flatRecords.push(headerRecord);
      for (const rec of childData) {
        const exportRecord = {
          data: rec,
          level: island.level,
          type: ExportRecordType.HierarchicalGridRecord,
          owner: island,
          hidden: !expansionStateVal,
          hierarchicalOwner
        };
        exportRecord.summaryKey = island.key;
        this.flatRecords.push(exportRecord);
        if (island.children.length > 0) {
          const islandExpansionStateVal = grid === undefined ? false : grid.expansionStates.has(rec) ? grid.expansionStates.get(rec) : false;
          for (const childIsland of island.children) {
            const path = {
              rowID: childIsland.primaryKey ? rec[childIsland.primaryKey] : rec,
              rowKey: childIsland.primaryKey ? rec[childIsland.primaryKey] : rec,
              rowIslandKey: childIsland.key
            };
            // only defined when row is expanded in UI
            const childIslandGrid = grid?.gridAPI.getChildGrid([path]);
            const keyRecordData = this.prepareIslandData(island, childIslandGrid, rec[childIsland.key]) || [];
            this.getAllChildColumnsAndData(childIsland, keyRecordData, islandExpansionStateVal, childIslandGrid);
          }
        }
      }
      if (grid) {
        const summaries = this.prepareSummaries(grid);
        for (const k of summaries.keys()) {
          const summary = summaries.get(k);
          this.setSummaries(island.key, island.level, !expansionStateVal, island, summary, hierarchicalOwner);
        }
      }
    }
  }
  prepareGridData(grid, hasFiltering, hasSorting) {
    const groupedGridGroupingState = {
      expressions: grid.groupingExpressions,
      expansion: grid.groupingExpansionState,
      defaultExpanded: grid.groupsExpanded
    };
    const hasGrouping = grid.groupingExpressions && grid.groupingExpressions.length > 0;
    const skipOperations = (!hasFiltering || !this.options.ignoreFiltering) && (!hasSorting || !this.options.ignoreSorting) && (!hasGrouping || !this.options.ignoreGrouping);
    if (skipOperations) {
      if (hasGrouping) {
        this.addGroupedData(grid, grid.groupsRecords, groupedGridGroupingState, true);
      } else {
        this.addFlatData(grid.filteredSortedData);
      }
    } else {
      let gridData = grid.data;
      if (hasFiltering && !this.options.ignoreFiltering) {
        const filteringState = {
          expressionsTree: grid.filteringExpressionsTree,
          advancedExpressionsTree: grid.advancedFilteringExpressionsTree,
          strategy: grid.filterStrategy
        };
        gridData = FilterUtil.filter(gridData, filteringState, grid);
      }
      if (hasSorting && !this.options.ignoreSorting) {
        // TODO: We should drop support for this since in a grouped grid it doesn't make sense
        // this._sort = !isGroupedGrid ?
        //     cloneValue(grid.sortingExpressions[0]) :
        //     grid.sortingExpressions.length > 1 ?
        //         cloneValue(grid.sortingExpressions[1]) :
        //         cloneValue(grid.sortingExpressions[0]);
        const expressions = grid.groupingExpressions ? grid.groupingExpressions.concat(grid.sortingExpressions || []) : grid.sortingExpressions;
        gridData = DataUtil.sort(gridData, expressions, grid.sortStrategy, grid);
      }
      if (hasGrouping && !this.options.ignoreGrouping) {
        const groupsRecords = [];
        DataUtil.group(cloneArray(gridData), groupedGridGroupingState, grid.groupStrategy, grid, groupsRecords);
        gridData = groupsRecords;
      }
      if (hasGrouping && !this.options.ignoreGrouping) {
        this.addGroupedData(grid, gridData, groupedGridGroupingState, true);
      } else {
        this.addFlatData(gridData);
      }
    }
  }
  prepareTreeGridData(grid, hasFiltering, hasSorting) {
    const skipOperations = (!hasFiltering || !this.options.ignoreFiltering) && (!hasSorting || !this.options.ignoreSorting);
    if (skipOperations) {
      this.addTreeGridData(grid.processedRootRecords);
    } else {
      let gridData = grid.rootRecords;
      if (hasFiltering && !this.options.ignoreFiltering) {
        const filteringState = {
          expressionsTree: grid.filteringExpressionsTree,
          advancedExpressionsTree: grid.advancedFilteringExpressionsTree,
          strategy: grid.filterStrategy ? grid.filterStrategy : new TreeGridFilteringStrategy()
        };
        gridData = filteringState.strategy.filter(gridData, filteringState.expressionsTree, filteringState.advancedExpressionsTree);
      }
      if (hasSorting && !this.options.ignoreSorting) {
        this._sort = cloneValue(grid.sortingExpressions[0]);
        gridData = DataUtil.treeGridSort(gridData, grid.sortingExpressions, grid.sortStrategy);
      }
      this.addTreeGridData(gridData);
    }
  }
  addTreeGridData(records, parentExpanded = true, hierarchicalOwner) {
    if (!records) {
      return;
    }
    for (const record of records) {
      const treeGridRecord = {
        data: record.data,
        level: record.level,
        hidden: !parentExpanded,
        type: ExportRecordType.TreeGridRecord,
        summaryKey: record.key,
        hierarchicalOwner: record.level === 0 ? GRID_PARENT : hierarchicalOwner
      };
      this.flatRecords.push(treeGridRecord);
      if (record.children) {
        this.getTreeGridChildData(record.children, record.key, record.level, record.expanded && parentExpanded);
      }
    }
  }
  getTreeGridChildData(recordChildren, key, level, parentExpanded = true) {
    const hierarchicalOwner = `${GRID_CHILD}${++this.rowIslandCounter}`;
    let summaryLevel = level;
    let summaryHidden = !parentExpanded;
    for (const rc of recordChildren) {
      if (rc.children && rc.children.length > 0) {
        this.addTreeGridData([rc], parentExpanded, hierarchicalOwner);
        summaryLevel = rc.level;
      } else {
        const currentRecord = {
          data: rc.data,
          level: rc.level,
          hidden: !parentExpanded,
          type: ExportRecordType.DataRecord,
          hierarchicalOwner
        };
        if (this._setChildSummaries) {
          currentRecord.summaryKey = key;
        }
        this.flatRecords.push(currentRecord);
        summaryLevel = rc.level;
        summaryHidden = !parentExpanded;
      }
    }
    if (this._setChildSummaries) {
      this.setSummaries(key, summaryLevel, summaryHidden, null, null, hierarchicalOwner);
    }
  }
  addFlatData(records) {
    if (!records) {
      return;
    }
    for (const record of records) {
      const data = {
        data: record,
        type: ExportRecordType.DataRecord,
        level: 0
      };
      this.flatRecords.push(data);
    }
  }
  setSummaries(summaryKey, level = 0, hidden = false, owner, summary, hierarchicalOwner) {
    const rootSummary = summary ?? this.summaries.get(summaryKey);
    if (rootSummary) {
      const values = [...rootSummary.values()];
      const biggest = values.sort((a, b) => b.length - a.length)[0];
      for (let i = 0; i < biggest.length; i++) {
        const obj = {};
        for (const [key, value] of rootSummary) {
          const summaries = value.map(s => ({
            label: s.label,
            value: s.summaryResult
          }));
          obj[key] = summaries[i];
        }
        const summaryRecord = {
          data: obj,
          type: ExportRecordType.SummaryRecord,
          level,
          hidden,
          summaryKey,
          hierarchicalOwner
        };
        if (owner) {
          summaryRecord.owner = owner;
        }
        this.flatRecords.push(summaryRecord);
      }
    }
  }
  addGroupedData(grid, records, groupingState, setGridParent, parentExpanded = true, summaryKeysArr = []) {
    if (!records) {
      return;
    }
    let previousKey = '';
    const firstCol = this._ownersMap.get(DEFAULT_OWNER).columns.filter(c => c.headerType === ExportHeaderType.ColumnHeader && !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex)[0].field;
    for (const record of records) {
      let recordVal = record.value;
      const hierarchicalOwner = setGridParent ? GRID_PARENT : `${GRID_CHILD}${++this.rowIslandCounter}`;
      const hierarchy = getHierarchy(record);
      const expandState = groupingState.expansion.find(s => isHierarchyMatch(s.hierarchy || [{
        fieldName: record.expression.fieldName,
        value: recordVal
      }], hierarchy, grid.groupingExpressions));
      const expanded = expandState ? expandState.expanded : groupingState.defaultExpanded;
      const isDate = recordVal instanceof Date;
      if (isDate) {
        const timeZoneOffset = recordVal.getTimezoneOffset() * 60000;
        const isoString = new Date(recordVal - timeZoneOffset).toISOString();
        const pipe = new DatePipe(grid.locale);
        recordVal = pipe.transform(isoString);
      }
      const groupExpressionName = record.column && record.column.header ? record.column.header : record.expression.fieldName;
      recordVal = recordVal !== null ? recordVal : '';
      const groupExpression = {
        data: {
          [firstCol]: `${groupExpressionName}: ${recordVal ?? '(Blank)'} (${record.records.length})`
        },
        level: record.level,
        hidden: !parentExpanded,
        type: ExportRecordType.GroupedRecord,
        hierarchicalOwner
      };
      this.flatRecords.push(groupExpression);
      let currKey = '';
      let summaryKey = '';
      if (this._setChildSummaries) {
        currKey = `'${record.expression.fieldName}': '${recordVal}'`;
        summaryKeysArr = summaryKeysArr.filter(a => a !== previousKey);
        previousKey = currKey;
        summaryKeysArr.push(currKey);
        summaryKey = `{ ${summaryKeysArr.join(', ')} }`;
        groupExpression.summaryKey = summaryKey;
      }
      if (record.groups.length > 0) {
        this.addGroupedData(grid, record.groups, groupingState, false, expanded && parentExpanded, summaryKeysArr);
      } else {
        const rowRecords = record.records;
        for (const rowRecord of rowRecords) {
          const currentRecord = {
            data: rowRecord,
            level: record.level + 1,
            hidden: !(expanded && parentExpanded),
            type: ExportRecordType.DataRecord,
            hierarchicalOwner
          };
          if (summaryKey) {
            currentRecord.summaryKey = summaryKey;
          }
          this.flatRecords.push(currentRecord);
        }
      }
      if (this._setChildSummaries) {
        this.setSummaries(summaryKey, record.level + 1, !(expanded && parentExpanded), null, null, hierarchicalOwner);
        summaryKeysArr.pop();
      }
    }
  }
  getColumns(columns) {
    const colList = [];
    const colWidthList = [];
    const hiddenColumns = [];
    let indexOfLastPinnedColumn = -1;
    let lastVisibleColumnIndex = -1;
    let maxLevel = 0;
    columns.forEach(column => {
      const columnHeader = !ExportUtilities.isNullOrWhitespaces(column.header) ? column.header : column.field;
      const exportColumn = !column.hidden || this.options.ignoreColumnsVisibility;
      const index = this.options.ignoreColumnsOrder || this.options.ignoreColumnsVisibility ? column.index : column.visibleIndex;
      const columnWidth = Number(column.width?.slice(0, -2)) || DEFAULT_COLUMN_WIDTH;
      const columnLevel = !this.options.ignoreMultiColumnHeaders ? column.level : 0;
      const isMultiColHeader = column.columnGroup;
      const colSpan = isMultiColHeader ? column.allChildren.filter(ch => !ch.columnGroup && (!this.options.ignoreColumnsVisibility ? !ch.hidden : true)).length : 1;
      const columnInfo = {
        header: ExportUtilities.sanitizeValue(columnHeader),
        dataType: column.dataType,
        field: column.field,
        skip: !exportColumn,
        formatter: column.formatter,
        skipFormatter: false,
        headerType: isMultiColHeader ? ExportHeaderType.MultiColumnHeader : ExportHeaderType.ColumnHeader,
        columnSpan: colSpan,
        level: columnLevel,
        startIndex: index,
        pinnedIndex: !column.pinned ? Number.MAX_VALUE : !column.hidden ? column.grid.pinnedColumns.indexOf(column) : NaN,
        columnGroupParent: column.parent ? column.parent : null,
        columnGroup: isMultiColHeader ? column : null
      };
      if (column.dataType === 'currency') {
        columnInfo.currencyCode = column.pipeArgs.currencyCode ? column.pipeArgs.currencyCode : getLocaleCurrencyCode(this.locale);
        columnInfo.displayFormat = column.pipeArgs.display ? column.pipeArgs.display : 'symbol';
        columnInfo.digitsInfo = column.pipeArgs.digitsInfo ? column.pipeArgs.digitsInfo : '1.0-2';
      }
      if (column.dataType === 'date') {
        columnInfo.dateFormat = getLocaleDateFormat(this.locale, FormatWidth.Medium);
      }
      if (column.dataType === 'dateTime') {
        columnInfo.dateFormat = getLocaleDateTimeFormat(this.locale, FormatWidth.Medium);
      }
      if (this.options.ignoreColumnsOrder) {
        if (columnInfo.startIndex !== columnInfo.pinnedIndex) {
          columnInfo.pinnedIndex = Number.MAX_VALUE;
        }
      }
      if (column.level > maxLevel && !this.options.ignoreMultiColumnHeaders) {
        maxLevel = column.level;
      }
      if (index !== -1) {
        colList.push(columnInfo);
        colWidthList.push(columnWidth);
        lastVisibleColumnIndex = Math.max(lastVisibleColumnIndex, colList.indexOf(columnInfo));
      } else {
        hiddenColumns.push(columnInfo);
      }
      if (column.pinned && exportColumn && columnInfo.headerType === ExportHeaderType.ColumnHeader) {
        indexOfLastPinnedColumn++;
      }
    });
    //Append the hidden columns to the end of the list
    hiddenColumns.forEach(hiddenColumn => {
      colList[++lastVisibleColumnIndex] = hiddenColumn;
    });
    const result = {
      columns: colList,
      columnWidths: colWidthList,
      indexOfLastPinnedColumn,
      maxLevel
    };
    return result;
  }
  mapHierarchicalGridColumns(island, gridData) {
    let columnList;
    let keyData;
    if (island.autoGenerate) {
      keyData = gridData[island.key];
      const islandKeys = island.children.map(i => i.key);
      const islandData = keyData.map(i => {
        const newItem = {};
        Object.keys(i).map(k => {
          if (!islandKeys.includes(k)) {
            newItem[k] = i[k];
          }
        });
        return newItem;
      });
      columnList = this.getAutoGeneratedColumns(islandData);
    } else {
      const islandColumnList = island.columns;
      columnList = this.getColumns(islandColumnList);
    }
    this._ownersMap.set(island, columnList);
    if (island.children.length > 0) {
      for (const childIsland of island.children) {
        const islandKeyData = keyData !== undefined ? keyData[0] : {};
        this.mapHierarchicalGridColumns(childIsland, islandKeyData);
      }
    }
  }
  getAutoGeneratedColumns(data) {
    const colList = [];
    const colWidthList = [];
    const keys = Object.keys(data[0]);
    keys.forEach((colKey, i) => {
      const columnInfo = {
        header: colKey,
        field: colKey,
        dataType: 'string',
        skip: false,
        headerType: ExportHeaderType.ColumnHeader,
        columnSpan: 1,
        level: 0,
        startIndex: i,
        pinnedIndex: Number.MAX_VALUE
      };
      colList.push(columnInfo);
      colWidthList.push(DEFAULT_COLUMN_WIDTH);
    });
    const result = {
      columns: colList,
      columnWidths: colWidthList,
      indexOfLastPinnedColumn: -1,
      maxLevel: 0
    };
    return result;
  }
  addPivotRowHeaders(grid) {
    if (grid?.pivotUI?.showRowHeaders) {
      const headersList = this._ownersMap.get(DEFAULT_OWNER);
      const enabledRows = grid.visibleRowDimensions.filter(r => r.enabled).map((r, index) => ({
        name: r.displayName || r.memberName,
        level: index
      }));
      let startIndex = 0;
      enabledRows.forEach(x => {
        headersList.columns.unshift({
          rowSpan: headersList.maxLevel + 1,
          field: x.name,
          header: x.name,
          startIndex: startIndex,
          skip: false,
          pinnedIndex: 0,
          level: x.level,
          dataType: 'string',
          headerType: ExportHeaderType.PivotRowHeader
        });
        startIndex += 1;
      });
      headersList.columnWidths.unshift(...Array(enabledRows.length).fill(200));
    }
  }
  addPivotGridColumns(grid) {
    if (grid.type !== 'pivot') {
      return;
    }
    const enabledRows = grid.visibleRowDimensions.map((r, i) => ({
      name: r.memberName,
      level: i
    }));
    this.preparePivotGridColumns(enabledRows);
    this.pivotGridFilterFieldsCount = enabledRows.length;
    const columnList = this._ownersMap.get(DEFAULT_OWNER);
    columnList.columns.unshift(...this.pivotGridColumns);
    columnList.columnWidths.unshift(...Array(this.pivotGridColumns.length).fill(200));
    columnList.indexOfLastPinnedColumn = enabledRows.length - 1;
    columnList.maxRowLevel = enabledRows.length;
    this._ownersMap.set(DEFAULT_OWNER, columnList);
  }
  preparePivotGridColumns(keys, columnGroupParent) {
    if (keys.length === 0) {
      return;
    }
    let startIndex = 0;
    const key = keys[0];
    const records = this.flatRecords.map(r => r.data);
    const groupedRecords = {};
    records.forEach(obj => {
      const keyValue = obj[key.name];
      if (!groupedRecords[keyValue]) {
        groupedRecords[keyValue] = [];
      }
      groupedRecords[keyValue].push(obj);
    });
    if (columnGroupParent) {
      const mapKeys = [...this.pivotGridKeyValueMap.keys()];
      const mapValues = [...this.pivotGridKeyValueMap.values()];
      for (const k of Object.keys(groupedRecords)) {
        groupedRecords[k] = groupedRecords[k].filter(row => mapKeys.every(mk => Object.keys(row).includes(mk)) && mapValues.every(mv => Object.values(row).includes(mv)));
        if (groupedRecords[k].length === 0) {
          delete groupedRecords[k];
        }
      }
    }
    for (const k of Object.keys(groupedRecords)) {
      let groupKey = k;
      const rowSpan = groupedRecords[k].length;
      const rowDimensionColumn = {
        columnSpan: 1,
        rowSpan,
        field: groupKey,
        header: groupKey,
        startIndex,
        skip: false,
        pinnedIndex: 0,
        level: key.level,
        dataType: 'string',
        headerType: groupedRecords[groupKey].length > 1 ? ExportHeaderType.MultiRowHeader : ExportHeaderType.RowHeader
      };
      if (groupKey === 'undefined') {
        this.pivotGridColumns[this.pivotGridColumns.length - 1].columnSpan += 1;
        rowDimensionColumn.headerType = ExportHeaderType.PivotMergedHeader;
        groupKey = columnGroupParent;
      }
      if (columnGroupParent) {
        rowDimensionColumn.columnGroupParent = columnGroupParent;
      } else {
        rowDimensionColumn.columnGroup = groupKey;
      }
      this.pivotGridColumns.push(rowDimensionColumn);
      if (keys.length > 1) {
        if (groupKey !== columnGroupParent) {
          this.pivotGridKeyValueMap.set(key.name, groupKey);
        }
        const newKeys = keys.filter(kdd => kdd !== key);
        this.preparePivotGridColumns(newKeys, groupKey);
        this.pivotGridKeyValueMap.delete(key.name);
      }
      startIndex += rowSpan;
    }
  }
  addLevelColumns() {
    if (this.options.exportSummaries && this.summaries.size > 0) {
      this._ownersMap.forEach(om => {
        const levelCol = {
          header: GRID_LEVEL_COL,
          dataType: 'number',
          field: GRID_LEVEL_COL,
          skip: false,
          skipFormatter: false,
          headerType: ExportHeaderType.ColumnHeader,
          columnSpan: 1,
          level: 0
        };
        om.columns.push(levelCol);
        om.columnWidths.push(20);
      });
    }
  }
  addLevelData() {
    if (this.options.exportSummaries && this.summaries.size > 0) {
      for (const r of this.flatRecords) {
        if (r.type === ExportRecordType.DataRecord || r.type === ExportRecordType.TreeGridRecord || r.type === ExportRecordType.HierarchicalGridRecord) {
          r.data[GRID_LEVEL_COL] = r.level;
        }
      }
    }
  }
  resetDefaults() {
    this._sort = null;
    this.flatRecords = [];
    this.options = {};
    this._ownersMap.clear();
    this.rowIslandCounter = 0;
  }
}

/**
 * @hidden
 */
class CharSeparatedValueData {
  constructor(_data, valueDelimiter, columns = []) {
    this._data = _data;
    this.columns = columns;
    this._headerRecord = '';
    this._dataRecords = '';
    this._eor = '\r\n';
    this._escapeCharacters = ['\r', '\n', '\r\n'];
    this._delimiterLength = 1;
    this._isSpecialData = false;
    this.setDelimiter(valueDelimiter);
  }
  prepareData(key) {
    if (!this._data || this._data.length === 0) {
      return '';
    }
    let keys = [];
    if (key) {
      keys = key;
    } else {
      keys = ExportUtilities.getKeysFromData(this._data);
    }
    if (keys.length === 0) {
      return '';
    }
    this._isSpecialData = ExportUtilities.isSpecialData(this._data[0]);
    this._escapeCharacters.push(this._delimiter);
    this._headerRecord = this.processHeaderRecord(keys, this._data.length);
    this._dataRecords = this.processDataRecords(this._data, keys);
    return this._headerRecord + this._dataRecords;
  }
  prepareDataAsync(done) {
    const columns = this.columns?.filter(c => !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex);
    const keys = columns && columns.length ? columns.map(c => c.field) : ExportUtilities.getKeysFromData(this._data);
    this._isSpecialData = ExportUtilities.isSpecialData(this._data[0]);
    this._escapeCharacters.push(this._delimiter);
    const headers = columns && columns.length ? columns.map(c => c.header ?? c.field) : keys;
    this._headerRecord = this.processHeaderRecord(headers, this._data.length);
    if (keys.length === 0 || (!this._data || this._data.length === 0) && keys.length === 0) {
      done('');
    } else {
      this.processDataRecordsAsync(this._data, keys, dr => {
        done(this._headerRecord + dr);
      });
    }
  }
  processField(value, escapeChars) {
    let safeValue = ExportUtilities.hasValue(value) ? String(value) : '';
    if (escapeChars.some(v => safeValue.includes(v))) {
      safeValue = `"${safeValue}"`;
    }
    return safeValue + this._delimiter;
  }
  processHeaderRecord(keys, dataLength) {
    let recordData = '';
    for (const keyName of keys) {
      recordData += this.processField(keyName, this._escapeCharacters);
    }
    const result = recordData.slice(0, -this._delimiterLength);
    return dataLength > 0 ? result + this._eor : result;
  }
  processRecord(record, keys) {
    const recordData = new Array(keys.length);
    for (let index = 0; index < keys.length; index++) {
      const value = record[keys[index]] !== undefined ? record[keys[index]] : this._isSpecialData ? record : '';
      recordData[index] = this.processField(value, this._escapeCharacters);
    }
    return recordData.join('').slice(0, -this._delimiterLength) + this._eor;
  }
  processDataRecords(currentData, keys) {
    const dataRecords = new Array(currentData.length);
    for (let i = 0; i < currentData.length; i++) {
      const row = currentData[i];
      dataRecords[i] = this.processRecord(row, keys);
    }
    return dataRecords.join('');
  }
  processDataRecordsAsync(currentData, keys, done) {
    const dataRecords = new Array(currentData.length);
    yieldingLoop(currentData.length, 1000, i => {
      const row = currentData[i];
      dataRecords[i] = this.processRecord(row, keys);
    }, () => {
      done(dataRecords.join(''));
    });
  }
  setDelimiter(value) {
    this._delimiter = value;
    this._delimiterLength = value.length;
  }
}
class IgxExporterOptionsBase {
  constructor(fileName, _fileExtension) {
    this._fileExtension = _fileExtension;
    /**
     * Specifies whether hidden columns should be exported.
     * ```typescript
     * let ignoreColumnsVisibility = this.exportOptions.ignoreColumnsVisibility;
     * this.exportOptions.ignoreColumnsVisibility = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreColumnsVisibility = false;
    /**
     * Specifies whether filtered out rows should be exported.
     * ```typescript
     * let ignoreFiltering = this.exportOptions.ignoreFiltering;
     * this.exportOptions.ignoreFiltering = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreFiltering = false;
    /**
     * Specifies if the exporter should ignore the current column order in the IgxGrid.
     * ```typescript
     * let ignoreColumnsOrder = this.exportOptions.ignoreColumnsOrder;
     * this.exportOptions.ignoreColumnsOrder = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreColumnsOrder = false;
    /**
     * Specifies whether the exported data should be sorted as in the provided IgxGrid.
     * When you export grouped data, setting ignoreSorting to true will cause
     * the grouping to fail because it relies on the sorting of the records.
     * ```typescript
     * let ignoreSorting = this.exportOptions.ignoreSorting;
     * this.exportOptions.ignoreSorting = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreSorting = false;
    /**
     * Specifies whether the exported data should be grouped as in the provided IgxGrid.
     * ```typescript
     * let ignoreGrouping = this.exportOptions.ignoreGrouping;
     * this.exportOptions.ignoreGrouping = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreGrouping = false;
    /**
     * Specifies whether the exported data should include multi column headers as in the provided IgxGrid.
     * ```typescript
     * let ignoreMultiColumnHeaders = this.exportOptions.ignoreMultiColumnHeaders;
     * this.exportOptions.ignoreMultiColumnHeaders = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.ignoreMultiColumnHeaders = false;
    /**
     * Specifies whether the exported data should include column summaries.
     * ```typescript
     * let exportSummaries = this.exportOptions.exportSummaries;
     * this.exportOptions.exportSummaries = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.exportSummaries = true;
    /**
     * Specifies whether the exported data should have frozen headers.
     * ```typescript
     * let freezeHeaders = this.exportOptions.freezeHeaders;
     * this.exportOptions.freezeHeaders = true;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.freezeHeaders = false;
    /**
     * Specifies whether the headers should be exported if there is no data.
     * ```typescript
     * let alwaysExportHeaders = this.exportOptions.alwaysExportHeaders;
     * this.exportOptions.alwaysExportHeaders = false;
     * ```
     *
     * @memberof IgxExporterOptionsBase
     */
    this.alwaysExportHeaders = true;
    this.setFileName(fileName);
  }
  setFileName(fileName) {
    this._fileName = fileName + (fileName.endsWith(this._fileExtension) === false ? this._fileExtension : '');
  }
  /**
   * Gets the file name which will be used for the exporting operation.
   * ```typescript
   * let fileName = this.exportOptions.fileName;
   * ```
   *
   * @memberof IgxExporterOptionsBase
   */
  get fileName() {
    return this._fileName;
  }
  /**
   * Sets the file name which will be used for the exporting operation.
   * ```typescript
   * this.exportOptions.fileName = 'exportedData01';
   * ```
   *
   * @memberof IgxExporterOptionsBase
   */
  set fileName(value) {
    this.setFileName(value);
  }
}

/**
 * Objects of this class are used to configure the CSV exporting process.
 */
class IgxCsvExporterOptions extends IgxExporterOptionsBase {
  constructor(fileName, fileType) {
    super(fileName, IgxCsvExporterOptions.getExtensionFromFileType(fileType));
    this.setFileType(fileType);
    this.setDelimiter();
  }
  static getExtensionFromFileType(fType) {
    let extension = '';
    switch (fType) {
      case CsvFileTypes.CSV:
        extension = '.csv';
        break;
      case CsvFileTypes.TSV:
        extension = '.tsv';
        break;
      case CsvFileTypes.TAB:
        extension = '.tab';
        break;
      default:
        throw Error('Unsupported CSV file type!');
    }
    return extension;
  }
  /**
   * Gets the value delimiter which will be used for the exporting operation.
   * ```typescript
   * let delimiter = this.exportOptions.valueDelimiter;
   * ```
   *
   * @memberof IgxCsvExporterOptions
   */
  get valueDelimiter() {
    return this._valueDelimiter;
  }
  /**
   * Sets a value delimiter which will overwrite the default delimiter of the selected export format.
   * ```typescript
   * this.exportOptions.valueDelimiter = '|';
   * ```
   *
   * @memberof IgxCsvExporterOptions
   */
  set valueDelimiter(value) {
    this.setDelimiter(value);
  }
  /**
   * Gets the CSV export format.
   * ```typescript
   * let filetype = this.exportOptions.fileType;
   * ```
   *
   * @memberof IgxCsvExporterOptions
   */
  get fileType() {
    return this._fileType;
  }
  /**
   * Sets the CSV export format.
   * ```typescript
   * this.exportOptions.fileType = CsvFileTypes.TAB;
   * ```
   *
   * @memberof IgxCsvExporterOptions
   */
  set fileType(value) {
    this.setFileType(value);
  }
  setFileType(value) {
    if (value !== undefined && value !== null && value !== this._fileType) {
      this._fileType = value;
      const extension = IgxCsvExporterOptions.getExtensionFromFileType(value);
      if (!this.fileName.endsWith(extension)) {
        const oldExt = '.' + this.fileName.split('.').pop();
        const newName = this.fileName.replace(oldExt, extension);
        this._fileExtension = extension;
        this.fileName = newName;
      }
    }
  }
  setDelimiter(value) {
    if (value !== undefined && value !== '' && value !== null) {
      this._valueDelimiter = value;
    } else {
      switch (this.fileType) {
        case CsvFileTypes.CSV:
          this._valueDelimiter = ',';
          break;
        case CsvFileTypes.TSV:
        case CsvFileTypes.TAB:
          this._valueDelimiter = '\t';
          break;
      }
    }
  }
}
/**
 * This enumeration is used to configure the default value separator
 * as well as the default file extension used when performing CSV exporting.
 */
var CsvFileTypes = /*#__PURE__*/function (CsvFileTypes) {
  /**
   * Character Separated Values, default separator is "comma", default file extension is .csv
   */
  CsvFileTypes[CsvFileTypes["CSV"] = 0] = "CSV";
  /**
   * Tab Separated Values, default separator is tab, default file extension is .tsv
   */
  CsvFileTypes[CsvFileTypes["TSV"] = 1] = "TSV";
  /**
   * Tab Separated Values, default separator is tab, default file extension is .tab
   */
  CsvFileTypes[CsvFileTypes["TAB"] = 2] = "TAB";
  return CsvFileTypes;
}(CsvFileTypes || {});
/**
 * **Ignite UI for Angular CSV Exporter Service** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/exporter-csv)
 *
 * The Ignite UI for Angular CSV Exporter service can export data in a Character Separated Values format from
 * both raw data (array) or from an `IgxGrid`.
 *
 * Example:
 * ```typescript
 * public localData = [
 *   { Name: "Eric Ridley", Age: "26" },
 *   { Name: "Alanis Brook", Age: "22" },
 *   { Name: "Jonathan Morris", Age: "23" }
 * ];
 *
 * constructor(private csvExportService: IgxCsvExporterService) {
 * }
 *
 * const opt: IgxCsvExporterOptions = new IgxCsvExporterOptions("FileName", CsvFileTypes.CSV);
 * this.csvExportService.exportData(this.localData, opt);
 * ```
 */
let IgxCsvExporterService = /*#__PURE__*/(() => {
  class IgxCsvExporterService extends IgxBaseExporter {
    constructor() {
      super(...arguments);
      /**
       * This event is emitted when the export process finishes.
       * ```typescript
       * this.exporterService.exportEnded.subscribe((args: ICsvExportEndedEventArgs) => {
       * // put event handler code here
       * });
       * ```
       *
       * @memberof IgxCsvExporterService
       */
      this.exportEnded = new EventEmitter();
    }
    exportDataImplementation(data, options, done) {
      data = data.map(item => item.data);
      const columnList = this._ownersMap.get(DEFAULT_OWNER);
      const csvData = new CharSeparatedValueData(data, options.valueDelimiter, columnList?.columns);
      csvData.prepareDataAsync(r => {
        this._stringData = r;
        this.saveFile(options);
        this.exportEnded.emit({
          csvData: this._stringData
        });
        done();
      });
    }
    saveFile(options) {
      switch (options.fileType) {
        case CsvFileTypes.CSV:
          this.exportFile(this._stringData, options.fileName, 'text/csv;charset=utf-8;');
          break;
        case CsvFileTypes.TSV:
        case CsvFileTypes.TAB:
          this.exportFile(this._stringData, options.fileName, 'text/tab-separated-values;charset=utf-8;');
          break;
      }
    }
    exportFile(data, fileName, fileType) {
      const blob = new Blob([data ? '\ufeff' : '', data], {
        type: fileType
      });
      ExportUtilities.saveBlobToFile(blob, fileName);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxCsvExporterService_BaseFactory;
        return function IgxCsvExporterService_Factory(__ngFactoryType__) {
          return (ɵIgxCsvExporterService_BaseFactory || (ɵIgxCsvExporterService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxCsvExporterService)))(__ngFactoryType__ || IgxCsvExporterService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxCsvExporterService,
        factory: IgxCsvExporterService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxCsvExporterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
var ExcelFolderTypes = /*#__PURE__*/function (ExcelFolderTypes) {
  ExcelFolderTypes[ExcelFolderTypes["RootExcelFolder"] = 0] = "RootExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["RootRelsExcelFolder"] = 1] = "RootRelsExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["DocPropsExcelFolder"] = 2] = "DocPropsExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["XLExcelFolder"] = 3] = "XLExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["XLRelsExcelFolder"] = 4] = "XLRelsExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["ThemeExcelFolder"] = 5] = "ThemeExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["WorksheetsExcelFolder"] = 6] = "WorksheetsExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["WorksheetsRelsExcelFolder"] = 7] = "WorksheetsRelsExcelFolder";
  ExcelFolderTypes[ExcelFolderTypes["TablesExcelFolder"] = 8] = "TablesExcelFolder";
  return ExcelFolderTypes;
}(ExcelFolderTypes || {});
/**
 * @hidden
 */
var ExcelFileTypes = /*#__PURE__*/function (ExcelFileTypes) {
  ExcelFileTypes[ExcelFileTypes["RootRelsFile"] = 0] = "RootRelsFile";
  ExcelFileTypes[ExcelFileTypes["AppFile"] = 1] = "AppFile";
  ExcelFileTypes[ExcelFileTypes["CoreFile"] = 2] = "CoreFile";
  ExcelFileTypes[ExcelFileTypes["WorkbookRelsFile"] = 3] = "WorkbookRelsFile";
  ExcelFileTypes[ExcelFileTypes["ThemeFile"] = 4] = "ThemeFile";
  ExcelFileTypes[ExcelFileTypes["WorksheetFile"] = 5] = "WorksheetFile";
  ExcelFileTypes[ExcelFileTypes["StyleFile"] = 6] = "StyleFile";
  ExcelFileTypes[ExcelFileTypes["WorkbookFile"] = 7] = "WorkbookFile";
  ExcelFileTypes[ExcelFileTypes["ContentTypesFile"] = 8] = "ContentTypesFile";
  ExcelFileTypes[ExcelFileTypes["SharedStringsFile"] = 9] = "SharedStringsFile";
  ExcelFileTypes[ExcelFileTypes["WorksheetRelsFile"] = 10] = "WorksheetRelsFile";
  ExcelFileTypes[ExcelFileTypes["TablesFile"] = 11] = "TablesFile";
  return ExcelFileTypes;
}(ExcelFileTypes || {});
/** @hidden */
let ExcelStrings = /*#__PURE__*/(() => {
  class ExcelStrings {
    static {
      this.XML_STRING = '<?xml version="1.0" encoding="UTF-8"?>\r\n';
    }
    static {
      this.SHARED_STRING_RELATIONSHIP = '<Relationship Id="rId4" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />';
    }
    static getRels() {
      return ExcelStrings.XML_STRING + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>';
    }
    static getApp(worksheetName) {
      return ExcelStrings.XML_STRING + `<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>Microsoft Excel</Application><DocSecurity>0</DocSecurity><ScaleCrop>false</ScaleCrop><HeadingPairs><vt:vector size="2" baseType="variant"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>1</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector size="1" baseType="lpstr"><vt:lpstr>${worksheetName}</vt:lpstr></vt:vector></TitlesOfParts><Company></Company><LinksUpToDate>false</LinksUpToDate><SharedDoc>false</SharedDoc><HyperlinksChanged>false</HyperlinksChanged><AppVersion>16.0300</AppVersion></Properties>`;
    }
    static getCore() {
      return ExcelStrings.XML_STRING + '<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:creator></dc:creator><cp:lastModifiedBy></cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">2015-06-05T18:17:20Z</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">2015-06-05T18:17:26Z</dcterms:modified></cp:coreProperties>';
    }
    static getTheme() {
      return ExcelStrings.XML_STRING + '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="44546A"/></a:dk2><a:lt2><a:srgbClr val="E7E6E6"/></a:lt2><a:accent1><a:srgbClr val="5B9BD5"/></a:accent1><a:accent2><a:srgbClr val="ED7D31"/></a:accent2><a:accent3><a:srgbClr val="A5A5A5"/></a:accent3><a:accent4><a:srgbClr val="FFC000"/></a:accent4><a:accent5><a:srgbClr val="4472C4"/></a:accent5><a:accent6><a:srgbClr val="70AD47"/></a:accent6><a:hlink><a:srgbClr val="0563C1"/></a:hlink><a:folHlink><a:srgbClr val="954F72"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Calibri Light" panose="020F0302020204030204"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="游ゴシック Light"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="等线 Light"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:majorFont><a:minorFont><a:latin typeface="Calibri" panose="020F0502020204030204"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="游ゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="等线"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:lumMod val="110000"/><a:satMod val="105000"/><a:tint val="67000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:lumMod val="105000"/><a:satMod val="103000"/><a:tint val="73000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:lumMod val="105000"/><a:satMod val="109000"/><a:tint val="81000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:satMod val="103000"/><a:lumMod val="102000"/><a:tint val="94000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:satMod val="110000"/><a:lumMod val="100000"/><a:shade val="100000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:lumMod val="99000"/><a:satMod val="120000"/><a:shade val="78000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="6350" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln><a:ln w="12700" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln><a:ln w="19050" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="57150" dist="19050" dir="5400000" algn="ctr" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="63000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:solidFill><a:schemeClr val="phClr"><a:tint val="95000"/><a:satMod val="170000"/></a:schemeClr></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="93000"/><a:satMod val="150000"/><a:shade val="98000"/><a:lumMod val="102000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:tint val="98000"/><a:satMod val="130000"/><a:shade val="90000"/><a:lumMod val="103000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="63000"/><a:satMod val="120000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults/><a:extraClrSchemeLst/><a:extLst><a:ext uri="{05A4C25C-085E-4340-85A3-A5531E510DB2}"><thm15:themeFamily xmlns:thm15="http://schemas.microsoft.com/office/thememl/2012/main" name="Office Theme" id="{62F939B6-93AF-4DB8-9C6B-D6C7DFDC589F}" vid="{4A3C46E8-61CC-4603-A589-7422A47A8E4A}"/></a:ext></a:extLst></a:theme>';
    }
    static getStyles() {
      return ExcelStrings.XML_STRING + '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac x16r2" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:x16r2="http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"><numFmts count="5"><numFmt numFmtId="164" formatCode="&quot;$&quot;#,##0.00"/><numFmt numFmtId="165" formatCode="[$£-809]#,##0.00"/><numFmt numFmtId="166" formatCode="[$¥-804]#,##0.00"/><numFmt numFmtId="167" formatCode="#,##0.00\ [$€-1]"/><numFmt numFmtId="168" formatCode="[$¥-411]#,##0.00"/></numFmts><fonts count="2" x14ac:knownFonts="1"><font><sz val="11"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font><font><b/><sz val="11"/><color theme="0"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts><fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor theme="4"/><bgColor indexed="64"/></patternFill></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="13"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="14" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0"/><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyAlignment="1"><alignment horizontal="center" vertical="center"/></xf><xf numFmtId="164" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="165" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="166" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="167" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="168" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="21" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="22" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/><xf numFmtId="10" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles><dxfs count="0"/><tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleLight16"/><extLst><ext uri="{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"><x14:slicerStyles defaultSlicerStyle="SlicerStyleLight1"/></ext><ext uri="{9260A510-F301-46a8-8635-F512D64BE5F5}" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"><x15:timelineStyles defaultTimelineStyle="TimeSlicerStyleLight1"/></ext></extLst></styleSheet>';
    }
    static getWorkbook(worksheetName) {
      return ExcelStrings.XML_STRING + `<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x15" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"><fileVersion appName="xl" lastEdited="6" lowestEdited="6" rupBuild="14420"/><workbookPr filterPrivacy="1" defaultThemeVersion="164011"/><bookViews><workbookView xWindow="0" yWindow="0" windowWidth="22260" windowHeight="12645"/></bookViews><sheets><sheet name="${worksheetName}" sheetId="1" r:id="rId1"/></sheets><calcPr calcId="162913"/><extLst><ext uri="{140A7094-0E35-4892-8432-C4D2E57EDEB5}" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"><x15:workbookPr chartTrackingRefBase="1"/></ext></extLst></workbook>`;
    }
    static getWorksheetRels() {
      return ExcelStrings.XML_STRING + `<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/table" Target="../tables/table1.xml"/></Relationships>`;
    }
    static getWorkbookRels(hasSharedStrings) {
      let retVal = ExcelStrings.XML_STRING + `<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml"/><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>`;
      if (hasSharedStrings) {
        retVal += ExcelStrings.SHARED_STRING_RELATIONSHIP;
      }
      retVal += '</Relationships>';
      return retVal;
    }
    static getSheetXML(dimension, freezePane, cols, sheetData, hasTable, outlineLevel = 0, isHierarchical) {
      const hasOutline = outlineLevel > 0;
      const tableParts = hasTable ? '<tableParts count="1"><tablePart r:id="rId1"/></tableParts>' : '';
      const sheetOutlineProp = hasOutline ? '<sheetPr><outlinePr summaryBelow="0"/></sheetPr>' : '';
      const sOutlineLevel = hasOutline ? `outlineLevelRow="${outlineLevel}"` : '';
      const dimensions = isHierarchical ? '' : `<dimension ref="${dimension}"/>`;
      // return ExcelStrings.XML_STRING +
      //     '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"><dimension ref="' + dimension + '"/><sheetViews><sheetView tabSelected="1" workbookViewId="0">' + freezePane + '</sheetView></sheetViews><sheetFormatPr defaultRowHeight="15" x14ac:dyDescent="0.25"/>' + cols + sheetData + '<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>' + tableParts + '</worksheet>';
      return `${ExcelStrings.XML_STRING}
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">
${sheetOutlineProp}
${dimensions}
<sheetViews><sheetView tabSelected="1" workbookViewId="0">${freezePane}</sheetView></sheetViews>
<sheetFormatPr defaultRowHeight="15" ${sOutlineLevel} x14ac:dyDescent="0.25"/>
${cols}
${sheetData}
<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>
${tableParts}</worksheet>`;
    }
    static getSharedStringXML(count, uniqueCount, table) {
      return ExcelStrings.XML_STRING + '<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="' + count + '" uniqueCount="' + uniqueCount + '">' + table + '</sst>';
    }
    static getContentTypesXML(hasSharedStrings, hasTable) {
      let contentTypes = ExcelStrings.XML_STRING + `<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types\">
            <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
            <Default Extension="xml" ContentType="application/xml"/>
            <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
            <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
            <Override PartName="/xl/theme/theme1.xml" ContentType="application/vnd.openxmlformats-officedocument.theme+xml"/>
            <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
            <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/>
            <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/>`;
      contentTypes += hasSharedStrings ? `	<Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>` : '';
      contentTypes += hasTable ? `<Override PartName="/xl/tables/table1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"/>` : '';
      contentTypes += `</Types>`;
      return contentTypes;
    }
    static getTablesXML(autoFilterDimension, tableDimension, tableColumns, sort) {
      return `${ExcelStrings.XML_STRING}<table xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" id="1" name="Table1" displayName="Table1" ref="${tableDimension}" totalsRowShown="0">
    <autoFilter ref="${autoFilterDimension}"/>${sort}${tableColumns}<tableStyleInfo name="TableStyleMedium2" showFirstColumn="0" showLastColumn="0" showRowStripes="1" showColumnStripes="0"/>
</table>`;
    }
    static getExcelColumn(index) {
      // Returns the excel column name for given 0-based index
      // For example 27 should return "AB"
      let returnString = '';
      while (index >= 0) {
        const char = index % 26;
        returnString = String.fromCharCode(65 + char) + returnString;
        index = Math.floor(index / 26) - 1;
      }
      return returnString;
    }
  }
  return ExcelStrings;
})();
/**
 * @hidden
 */
class RootRelsFile {
  writeElement(folder) {
    folder['.rels'] = strToU8(ExcelStrings.getRels());
  }
}
/**
 * @hidden
 */
class AppFile {
  writeElement(folder, worksheetData) {
    folder['app.xml'] = strToU8(ExcelStrings.getApp(worksheetData.options.worksheetName));
  }
}
/**
 * @hidden
 */
class CoreFile {
  writeElement(folder) {
    folder['core.xml'] = strToU8(ExcelStrings.getCore());
  }
}
/**
 * @hidden
 */
class WorkbookRelsFile {
  writeElement(folder, worksheetData) {
    const hasSharedStrings = !worksheetData.isEmpty || worksheetData.options.alwaysExportHeaders;
    folder['workbook.xml.rels'] = strToU8(ExcelStrings.getWorkbookRels(hasSharedStrings));
  }
}
/**
 * @hidden
 */
class ThemeFile {
  writeElement(folder) {
    folder['theme1.xml'] = strToU8(ExcelStrings.getTheme());
  }
}
/**
 * @hidden
 */
let WorksheetFile = /*#__PURE__*/(() => {
  class WorksheetFile {
    constructor() {
      this.maxOutlineLevel = 0;
      this.sheetData = '';
      this.dimension = '';
      this.freezePane = '';
      this.rowHeight = '';
      this.mergeCellStr = '';
      this.mergeCellsCounter = 0;
      this.rowIndex = 0;
      this.pivotGridRowHeadersMap = new Map();
      this.dimensionMap = new Map();
      this.hierarchicalDimensionMap = new Map();
      this.currentSummaryOwner = '';
      this.currentHierarchicalOwner = '';
      this.firstColumn = Number.MAX_VALUE;
      this.firstDataRow = Number.MAX_VALUE;
      this.currencyStyleMap = new Map([['USD', {
        styleXf: 5,
        symbol: '$'
      }], ['GBP', {
        styleXf: 6,
        symbol: '£'
      }], ['CNY', {
        styleXf: 7,
        symbol: '¥'
      }], ['EUR', {
        styleXf: 8,
        symbol: '€'
      }], ['JPY', {
        styleXf: 9,
        symbol: '¥'
      }]]);
    }
    static {
      this.MIN_WIDTH = 8.43;
    }
    writeElement() {}
    async writeElementAsync(folder, worksheetData) {
      return new Promise(resolve => {
        this.prepareDataAsync(worksheetData, (cols, rows) => {
          const hasTable = (!worksheetData.isEmpty || worksheetData.options.alwaysExportHeaders) && worksheetData.options.exportAsTable;
          folder['sheet1.xml'] = strToU8(ExcelStrings.getSheetXML(this.dimension, this.freezePane, cols, rows, hasTable, this.maxOutlineLevel, worksheetData.isHierarchical));
          resolve();
        });
      });
    }
    prepareDataAsync(worksheetData, done) {
      this.sheetData = '';
      let cols = '';
      const dictionary = worksheetData.dataDictionary;
      this.rowIndex = 0;
      if (worksheetData.isEmpty && (!worksheetData.options.alwaysExportHeaders || worksheetData.owner.columns.length === 0)) {
        this.sheetData += '<sheetData/>';
        this.dimension = 'A1';
        done('', this.sheetData);
      } else {
        const owner = worksheetData.owner;
        const isHierarchicalGrid = worksheetData.isHierarchical;
        const hasMultiColumnHeader = worksheetData.hasMultiColumnHeader;
        const hasMultiRowHeader = worksheetData.hasMultiRowHeader;
        const hasUserSetIndex = owner.columns.some(col => col.exportIndex !== undefined);
        const height = worksheetData.options.rowHeight;
        this.isValidGrid = worksheetData.isHierarchical || worksheetData.isTreeGrid || worksheetData.isGroupedGrid;
        this.rowHeight = height ? ` ht="${height}" customHeight="1"` : '';
        this.sheetData += `<sheetData>`;
        let headersForLevel = [];
        for (let i = 0; i <= owner.maxRowLevel; i++) {
          headersForLevel = owner.columns.filter(c => c.level === i && c.rowSpan > 0 && !c.skip);
          this.printHeaders(worksheetData, headersForLevel, i, true);
          this.rowIndex++;
        }
        this.rowIndex = 0;
        for (let i = 0; i <= owner.maxLevel; i++) {
          this.rowIndex++;
          const pivotGridColumns = this.pivotGridRowHeadersMap.get(this.rowIndex) ?? "";
          this.sheetData += `<row r="${this.rowIndex}"${this.rowHeight}>${pivotGridColumns}`;
          const allowedColumns = owner.columns.filter(c => c.headerType !== ExportHeaderType.RowHeader && c.headerType !== ExportHeaderType.MultiRowHeader && c.headerType !== ExportHeaderType.PivotRowHeader && c.headerType !== ExportHeaderType.PivotMergedHeader);
          headersForLevel = hasMultiColumnHeader ? allowedColumns.filter(c => (c.level < i && c.headerType !== ExportHeaderType.MultiColumnHeader || c.level === i) && c.columnSpan > 0 && !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex) : hasUserSetIndex ? allowedColumns.filter(c => !c.skip) : allowedColumns.filter(c => !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex);
          this.printHeaders(worksheetData, headersForLevel, i, false);
          this.sheetData += `</row>`;
        }
        const multiColumnHeaderLevel = worksheetData.options.ignoreMultiColumnHeaders ? 0 : owner.maxLevel;
        const freezeHeaders = worksheetData.options.freezeHeaders ? 2 + multiColumnHeaderLevel : 1;
        if (!isHierarchicalGrid) {
          const col = worksheetData.hasSummaries ? worksheetData.columnCount + 1 : worksheetData.columnCount - 1;
          this.dimension = 'A1:' + ExcelStrings.getExcelColumn(col) + worksheetData.rowCount;
          cols += '<cols>';
          if (!hasMultiColumnHeader) {
            for (let j = 0; j < worksheetData.columnCount; j++) {
              const width = dictionary.columnWidths[j];
              // Use the width provided in the options if it exists
              let widthInTwips = worksheetData.options.columnWidth !== undefined ? worksheetData.options.columnWidth : Math.max(width / 96 * 14.4, WorksheetFile.MIN_WIDTH);
              if (!(widthInTwips > 0)) {
                widthInTwips = WorksheetFile.MIN_WIDTH;
              }
              cols += `<col min="${j + 1}" max="${j + 1}" width="${widthInTwips}" customWidth="1"/>`;
            }
          } else {
            cols += `<col min="1" max="${worksheetData.columnCount}" width="15" customWidth="1"/>`;
          }
          const indexOfLastPinnedColumn = worksheetData.indexOfLastPinnedColumn;
          const frozenColumnCount = indexOfLastPinnedColumn + 1;
          let firstCell = ExcelStrings.getExcelColumn(frozenColumnCount) + freezeHeaders;
          if (indexOfLastPinnedColumn !== undefined && indexOfLastPinnedColumn !== -1 && !worksheetData.options.ignorePinning && !worksheetData.options.ignoreColumnsOrder) {
            this.freezePane = `<pane xSplit="${frozenColumnCount}" ySplit="${freezeHeaders - 1}"
                         topLeftCell="${firstCell}" activePane="topRight" state="frozen"/>`;
          } else if (worksheetData.options.freezeHeaders) {
            firstCell = ExcelStrings.getExcelColumn(0) + freezeHeaders;
            this.freezePane = `<pane xSplit="0" ySplit="${freezeHeaders - 1}"
                         topLeftCell="${firstCell}" activePane="topRight" state="frozen"/>`;
          }
        } else {
          const columnWidth = worksheetData.options.columnWidth ? worksheetData.options.columnWidth : 20;
          cols += `<cols><col min="1" max="${worksheetData.columnCount}" width="${columnWidth}" customWidth="1"/>`;
          if (worksheetData.options.freezeHeaders) {
            const firstCell = ExcelStrings.getExcelColumn(0) + freezeHeaders;
            this.freezePane = `<pane xSplit="0" ySplit="${freezeHeaders - 1}"
                         topLeftCell="${firstCell}" activePane="topRight" state="frozen"/>`;
          }
        }
        if (worksheetData.hasSummaries) {
          cols += `<col min="${worksheetData.columnCount + 2}" max="${worksheetData.columnCount + 2}" hidden="1"/>`;
        }
        cols += '</cols>';
        this.processDataRecordsAsync(worksheetData, rows => {
          this.sheetData += rows;
          this.sheetData += '</sheetData>';
          if ((hasMultiColumnHeader || hasMultiRowHeader) && this.mergeCellsCounter > 0) {
            this.sheetData += `<mergeCells count="${this.mergeCellsCounter}">${this.mergeCellStr}</mergeCells>`;
          }
          done(cols, this.sheetData);
        });
      }
    }
    processDataRecordsAsync(worksheetData, done) {
      const rowDataArr = [];
      const height = worksheetData.options.rowHeight;
      this.rowHeight = height ? ' ht="' + height + '" customHeight="1"' : '';
      const isHierarchicalGrid = worksheetData.isHierarchical;
      const hasUserSetIndex = worksheetData.owner.columns.some(c => c.exportIndex !== undefined);
      let recordHeaders = [];
      yieldingLoop(worksheetData.rowCount - worksheetData.multiColumnHeaderRows - 1, 1000, i => {
        if (!worksheetData.isEmpty) {
          if (!isHierarchicalGrid) {
            if (hasUserSetIndex) {
              recordHeaders = worksheetData.rootKeys;
            } else {
              recordHeaders = worksheetData.owner.columns.filter(c => c.headerType === ExportHeaderType.ColumnHeader && !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex).map(c => c.field);
            }
          } else {
            const record = worksheetData.data[i];
            if (record.type === ExportRecordType.HeaderRecord) {
              const recordOwner = worksheetData.owners.get(record.owner);
              const hasMultiColumnHeaders = recordOwner.columns.some(c => !c.skip && c.headerType === ExportHeaderType.MultiColumnHeader);
              if (hasMultiColumnHeaders) {
                this.hGridPrintMultiColHeaders(worksheetData, rowDataArr, record, recordOwner);
              }
            }
            recordHeaders = Object.keys(worksheetData.data[i].data);
          }
          rowDataArr.push(this.processRow(worksheetData, i, recordHeaders, isHierarchicalGrid));
        }
      }, () => {
        done(rowDataArr.join(''));
      });
    }
    hGridPrintMultiColHeaders(worksheetData, rowDataArr, record, owner) {
      for (let j = 0; j < owner.maxLevel; j++) {
        const recordLevel = record.level;
        const outlineLevel = recordLevel > 0 ? ` outlineLevel="${recordLevel}"` : '';
        this.maxOutlineLevel = this.maxOutlineLevel < recordLevel ? recordLevel : this.maxOutlineLevel;
        const sHidden = record.hidden ? ` hidden="1"` : '';
        this.rowIndex++;
        let row = `<row r="${this.rowIndex}"${this.rowHeight}${outlineLevel}${sHidden}>`;
        const headersForLevel = owner.columns.filter(c => (c.level < j && c.headerType !== ExportHeaderType.MultiColumnHeader || c.level === j) && c.columnSpan > 0 && !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex);
        let startValue = 0 + record.level;
        for (const currentCol of headersForLevel) {
          if (currentCol.level === j) {
            let columnCoordinate;
            columnCoordinate = ExcelStrings.getExcelColumn(startValue) + this.rowIndex;
            const columnValue = worksheetData.dataDictionary.saveValue(currentCol.header, true);
            row += `<c r="${columnCoordinate}" s="3" t="s"><v>${columnValue}</v></c>`;
            if (j !== owner.maxLevel) {
              this.mergeCellsCounter++;
              this.mergeCellStr += ` <mergeCell ref="${columnCoordinate}:`;
              if (currentCol.headerType === ExportHeaderType.ColumnHeader) {
                columnCoordinate = ExcelStrings.getExcelColumn(startValue) + (this.rowIndex + owner.maxLevel - currentCol.level);
              } else {
                for (let k = 1; k < currentCol.columnSpan; k++) {
                  columnCoordinate = ExcelStrings.getExcelColumn(startValue + k) + this.rowIndex;
                  row += `<c r="${columnCoordinate}" s="3" />`;
                }
              }
              this.mergeCellStr += `${columnCoordinate}" />`;
            }
          }
          startValue += currentCol.columnSpan;
        }
        row += `</row>`;
        rowDataArr.push(row);
      }
    }
    processRow(worksheetData, i, headersForLevel, isHierarchicalGrid) {
      const record = worksheetData.data[i];
      const rowData = new Array(worksheetData.columnCount + 2);
      const rowLevel = record.level;
      const outlineLevel = rowLevel > 0 ? ` outlineLevel="${rowLevel}"` : '';
      this.maxOutlineLevel = this.maxOutlineLevel < rowLevel ? rowLevel : this.maxOutlineLevel;
      const sHidden = record.hidden ? ` hidden="1"` : '';
      this.rowIndex++;
      const pivotGridColumns = this.pivotGridRowHeadersMap.get(this.rowIndex) ?? "";
      rowData[0] = `<row r="${this.rowIndex}"${this.rowHeight}${outlineLevel}${sHidden}>${pivotGridColumns}`;
      const keys = worksheetData.isSpecialData ? [record.data] : headersForLevel;
      const isDataRecord = record.type === ExportRecordType.HierarchicalGridRecord || record.type === ExportRecordType.DataRecord || record.type === ExportRecordType.GroupedRecord || record.type === ExportRecordType.TreeGridRecord;
      const isValidRecordType = isDataRecord || record.type === ExportRecordType.SummaryRecord;
      if (isValidRecordType && worksheetData.hasSummaries) {
        this.resolveSummaryDimensions(record, isDataRecord, worksheetData.isGroupedGrid);
      }
      for (let j = 0; j < keys.length; j++) {
        const col = j + (isHierarchicalGrid ? rowLevel : worksheetData.isPivotGrid ? worksheetData.owner.maxRowLevel : 0);
        const cellData = this.getCellData(worksheetData, i, col, keys[j]);
        rowData[j + 1] = cellData;
      }
      rowData[keys.length + 1] = '</row>';
      return rowData.join('');
    }
    getCellData(worksheetData, row, column, key) {
      const dictionary = worksheetData.dataDictionary;
      let columnName = ExcelStrings.getExcelColumn(column) + this.rowIndex;
      const fullRow = worksheetData.data[row];
      const isHeaderRecord = fullRow.type === ExportRecordType.HeaderRecord;
      const isSummaryRecord = fullRow.type === ExportRecordType.SummaryRecord;
      const isValidRecordType = fullRow.type === ExportRecordType.GroupedRecord || fullRow.type === ExportRecordType.DataRecord || fullRow.type === ExportRecordType.HierarchicalGridRecord || fullRow.type === ExportRecordType.TreeGridRecord;
      this.firstDataRow = this.firstDataRow > this.rowIndex ? this.rowIndex : this.firstDataRow;
      const cellValue = worksheetData.isSpecialData ? fullRow.data : fullRow.data[key];
      if (cellValue === GRID_LEVEL_COL || key === GRID_LEVEL_COL) {
        columnName = ExcelStrings.getExcelColumn(worksheetData.columnCount + 1) + this.rowIndex;
      }
      if (worksheetData.hasSummaries && (isValidRecordType || worksheetData.isGroupedGrid && isSummaryRecord)) {
        this.setSummaryCoordinates(columnName, key, fullRow.hierarchicalOwner, worksheetData.isGroupedGrid && isSummaryRecord);
      }
      if (fullRow.summaryKey && fullRow.summaryKey === GRID_ROOT_SUMMARY && key !== GRID_LEVEL_COL && worksheetData.isGroupedGrid) {
        this.setRootSummaryStartCoordinate(column, key);
        if (this.firstColumn > column) {
          this.setRootSummaryStartCoordinate(worksheetData.columnCount + 1, GRID_LEVEL_COL);
          this.firstColumn = column;
        }
      }
      const targetColArr = Array.from(worksheetData.owners.values()).map(arr => arr.columns).find(product => product.some(item => item.field === key));
      const targetCol = targetColArr ? targetColArr.find(col => col.field === key) : undefined;
      if ((cellValue === undefined || cellValue === null) && !worksheetData.hasSummaries) {
        return `<c r="${columnName}" s="1"/>`;
      } else if (worksheetData.hasSummaries && (isValidRecordType || isHeaderRecord) || !worksheetData.hasSummaries) {
        const savedValue = dictionary.saveValue(cellValue, isHeaderRecord);
        const isSavedAsString = savedValue !== -1;
        const isSavedAsDate = !isSavedAsString && cellValue instanceof Date;
        let value = isSavedAsString ? savedValue : cellValue;
        if (isSavedAsDate) {
          const timeZoneOffset = value.getTimezoneOffset() * 60000;
          const isoString = new Date(value - timeZoneOffset).toISOString();
          value = isoString.substring(0, isoString.indexOf('.'));
        }
        const type = isSavedAsString ? ` t="s"` : isSavedAsDate ? ` t="d"` : '';
        const isTime = targetCol?.dataType === 'time';
        const isDateTime = targetCol?.dataType === 'dateTime';
        const isPercentage = targetCol?.dataType === 'percent';
        const isColumnCurrencyType = targetCol?.dataType === 'currency';
        const format = isPercentage ? ` s="12"` : isDateTime ? ` s="11"` : isTime ? ` s="10"` : isHeaderRecord ? ` s="3"` : isSavedAsString ? '' : isSavedAsDate ? ` s="2"` : isColumnCurrencyType ? ` s="${this.currencyStyleMap.get(targetCol.currencyCode)?.styleXf || 0}"` : ` s="1"`;
        return `<c r="${columnName}"${type}${format}><v>${value}</v></c>`;
      } else {
        let summaryFunc = `"${cellValue ?? ""}"`;
        if (isSummaryRecord && cellValue) {
          const dimensionMapKey = this.isValidGrid ? fullRow.hierarchicalOwner ?? GRID_PARENT : null;
          const level = worksheetData.isGroupedGrid ? worksheetData.maxLevel : fullRow.level;
          summaryFunc = this.getSummaryFunction(cellValue.label, key, dimensionMapKey, level, targetCol);
          if (!summaryFunc) {
            let summaryValue;
            const label = cellValue.label?.toString();
            const value = cellValue.value?.toString();
            if (label && value) {
              summaryValue = `${cellValue.label}: ${cellValue.value}`;
            } else if (label) {
              summaryValue = cellValue.label;
            } else if (value) {
              summaryValue = cellValue.value;
            }
            const savedValue = dictionary.saveValue(summaryValue, false);
            const isSavedAsString = savedValue !== -1;
            const isSavedAsDate = !isSavedAsString && summaryValue instanceof Date;
            if (isSavedAsDate) {
              const timeZoneOffset = summaryValue.getTimezoneOffset() * 60000;
              const isoString = new Date(summaryValue - timeZoneOffset).toISOString();
              summaryValue = isoString.substring(0, isoString.indexOf('.'));
            }
            const resolvedValue = isSavedAsString ? savedValue : summaryValue;
            const type = isSavedAsString ? `t="s"` : isSavedAsDate ? `t="d"` : '';
            const style = isSavedAsDate ? `s="2"` : `s="1"`;
            return `<c r="${columnName}" ${type} ${style}><v>${resolvedValue}</v></c>`;
          }
          return `<c r="${columnName}"><f t="array" ref="${columnName}">${summaryFunc}</f></c>`;
        }
        return `<c r="${columnName}" s="1"><f>${summaryFunc}</f></c>`;
      }
    }
    resolveSummaryDimensions(record, isDataRecord, isGroupedGrid) {
      if (this.isValidGrid && this.currentHierarchicalOwner !== '' && this.currentHierarchicalOwner !== record.owner && !this.hierarchicalDimensionMap.get(this.currentHierarchicalOwner)) {
        this.hierarchicalDimensionMap.set(this.currentHierarchicalOwner, new Map(this.dimensionMap));
      }
      if (isDataRecord) {
        if (this.currentSummaryOwner !== record.summaryKey || this.currentHierarchicalOwner !== record.hierarchicalOwner) {
          this.dimensionMap.clear();
        }
        this.currentSummaryOwner = record.summaryKey;
        // For grouped grid we need to reset the parent map
        // so we can change the startCoordinate for each record
        if (isGroupedGrid && this.currentHierarchicalOwner !== '' && record.hierarchicalOwner === GRID_PARENT) {
          this.hierarchicalDimensionMap.delete(GRID_PARENT);
        }
        this.currentHierarchicalOwner = record.hierarchicalOwner;
      }
    }
    setSummaryCoordinates(columnName, key, hierarchicalOwner, useLastValidEndCoordinate) {
      const targetDimensionMap = this.hierarchicalDimensionMap.get(hierarchicalOwner) ?? this.dimensionMap;
      if (!targetDimensionMap.get(key)) {
        const initialDimensions = {
          startCoordinate: columnName,
          endCoordinate: columnName
        };
        targetDimensionMap.set(key, initialDimensions);
      } else {
        if (useLastValidEndCoordinate) {
          this.setEndCoordinates(targetDimensionMap, true);
        } else {
          targetDimensionMap.get(key).endCoordinate = columnName;
          this.lastValidRow = targetDimensionMap.get(key).endCoordinate.match(/[a-z]+|[^a-z]+/gi)[1];
        }
      }
      if (this.isValidGrid && !useLastValidEndCoordinate && hierarchicalOwner !== GRID_PARENT) {
        const parentMap = this.hierarchicalDimensionMap.get(GRID_PARENT);
        this.setEndCoordinates(parentMap);
      }
    }
    setEndCoordinates(map, useLastValidEndCoordinate = false) {
      for (const a of map.values()) {
        const colName = a.endCoordinate.match(/[a-z]+|[^a-z]+/gi)[0];
        a.endCoordinate = `${colName}${useLastValidEndCoordinate ? this.lastValidRow : this.rowIndex}`;
      }
    }
    getSummaryFunction(type, key, dimensionMapKey, recordLevel, col) {
      const dimensionMap = dimensionMapKey ? this.hierarchicalDimensionMap.get(dimensionMapKey) : this.dimensionMap;
      const dimensions = dimensionMap.get(key);
      const levelDimensions = dimensionMap.get(GRID_LEVEL_COL);
      let func = '';
      let funcType = '';
      let result = '';
      const currencyInfo = this.currencyStyleMap.get(col.currencyCode);
      switch (type?.toString().toLowerCase()) {
        case "count":
          return `"Count: "&amp;_xlfn.COUNTIF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}, ${recordLevel})`;
        case "min":
          func = `_xlfn.MIN(_xlfn.IF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}=${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate}))`;
          funcType = `"Min: "&amp;`;
          result = funcType + (col.dataType === 'currency' && currencyInfo ? `_xlfn.TEXT(${func}, "${currencyInfo.symbol}#,##0.00")` : `${func}`);
          return result;
        case "max":
          func = `_xlfn.MAX(_xlfn.IF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}=${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate}))`;
          funcType = `"Max: "&amp;`;
          result = funcType + (col.dataType === 'currency' && currencyInfo ? `_xlfn.TEXT(${func}, "${currencyInfo.symbol}#,##0.00")` : `${func}`);
          return result;
        case "sum":
          func = `_xlfn.SUMIF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}, ${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate})`;
          funcType = `"Sum: "&amp;`;
          result = funcType + (col.dataType === 'currency' && currencyInfo ? `_xlfn.TEXT(${func}, "${currencyInfo.symbol}#,##0.00")` : `${func}`);
          return result;
        case "avg":
          func = `_xlfn.AVERAGEIF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}, ${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate})`;
          funcType = `"Avg: "&amp;`;
          result = funcType + (col.dataType === 'currency' && currencyInfo ? `_xlfn.TEXT(${func}, "${currencyInfo.symbol}#,##0.00")` : `${func}`);
          return result;
        case "earliest":
          // TODO: get date format from locale
          return `"Earliest: "&amp;_xlfn.TEXT(_xlfn.MIN(_xlfn.IF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}=${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate})), "m/d/yyyy")`;
        case "latest":
          // TODO: get date format from locale
          return `"Latest: "&amp;_xlfn.TEXT(_xlfn.MAX(_xlfn.IF(${levelDimensions.startCoordinate}:${levelDimensions.endCoordinate}=${recordLevel}, ${dimensions.startCoordinate}:${dimensions.endCoordinate})), "m/d/yyyy")`;
      }
    }
    setRootSummaryStartCoordinate(column, key) {
      const firstDataRecordColName = ExcelStrings.getExcelColumn(column) + this.firstDataRow;
      const targetMap = this.hierarchicalDimensionMap.get(GRID_PARENT);
      if (targetMap.get(key).startCoordinate !== firstDataRecordColName) {
        targetMap.get(key).startCoordinate = firstDataRecordColName;
      }
    }
    printHeaders(worksheetData, headersForLevel, i, isVertical) {
      let startValue = 0;
      let str = '';
      const isHierarchicalGrid = worksheetData.isHierarchical;
      let rowStyle = isHierarchicalGrid ? ' s="3"' : '';
      const dictionary = worksheetData.dataDictionary;
      const owner = worksheetData.owner;
      const maxLevel = isVertical ? owner.maxRowLevel : owner.maxLevel;
      for (const currentCol of headersForLevel) {
        const spanLength = isVertical ? currentCol.rowSpan : currentCol.columnSpan;
        if (currentCol.level === i && currentCol.headerType !== ExportHeaderType.PivotMergedHeader) {
          let columnCoordinate;
          const column = isVertical ? this.rowIndex : startValue + (owner.maxRowLevel ?? 0);
          let rowCoordinate = isVertical ? startValue + owner.maxLevel + 2 : this.rowIndex;
          if (currentCol.headerType === ExportHeaderType.PivotRowHeader) {
            rowCoordinate = startValue + 1;
          }
          const columnValue = dictionary.saveValue(currentCol.header, true, false);
          columnCoordinate = (currentCol.field === GRID_LEVEL_COL ? ExcelStrings.getExcelColumn(worksheetData.columnCount + 1) : ExcelStrings.getExcelColumn(column)) + rowCoordinate;
          rowStyle = isVertical && currentCol.rowSpan > 1 ? ' s="4"' : rowStyle;
          str = `<c r="${columnCoordinate}"${rowStyle} t="s"><v>${columnValue}</v></c>`;
          if (isVertical) {
            if (this.pivotGridRowHeadersMap.has(rowCoordinate)) {
              this.pivotGridRowHeadersMap.set(rowCoordinate, this.pivotGridRowHeadersMap.get(rowCoordinate) + str);
            } else {
              this.pivotGridRowHeadersMap.set(rowCoordinate, str);
            }
          } else {
            this.sheetData += str;
          }
          if (i !== maxLevel) {
            this.mergeCellsCounter++;
            this.mergeCellStr += ` <mergeCell ref="${columnCoordinate}:`;
            if (currentCol.headerType === ExportHeaderType.ColumnHeader) {
              const col = isVertical ? maxLevel : startValue + (owner.maxRowLevel ?? 0);
              const row = isVertical ? rowCoordinate : owner.maxLevel + 1;
              columnCoordinate = ExcelStrings.getExcelColumn(col) + row;
            } else {
              for (let k = 1; k < spanLength; k++) {
                const col = isVertical ? column : column + k;
                const row = isVertical ? rowCoordinate + k : this.rowIndex;
                columnCoordinate = ExcelStrings.getExcelColumn(col) + row;
                str = `<c r="${columnCoordinate}"${rowStyle} />`;
                isVertical ? this.pivotGridRowHeadersMap.set(row, str) : this.sheetData += str;
              }
            }
            if ((currentCol.headerType === ExportHeaderType.RowHeader || currentCol.headerType === ExportHeaderType.MultiRowHeader) && currentCol.columnSpan && currentCol.columnSpan > 1) {
              columnCoordinate = ExcelStrings.getExcelColumn(column + currentCol.columnSpan - 1) + (rowCoordinate + spanLength - 1);
            }
            this.mergeCellStr += `${columnCoordinate}" />`;
          }
        }
        if (currentCol.headerType !== ExportHeaderType.PivotRowHeader) {
          startValue += spanLength;
        }
      }
    }
  }
  return WorksheetFile;
})();
/**
 * @hidden
 */
class StyleFile {
  writeElement(folder) {
    folder['styles.xml'] = strToU8(ExcelStrings.getStyles());
  }
}
/**
 * @hidden
 */
class WorkbookFile {
  writeElement(folder, worksheetData) {
    folder['workbook.xml'] = strToU8(ExcelStrings.getWorkbook(worksheetData.options.worksheetName));
  }
}
/**
 * @hidden
 */
class ContentTypesFile {
  writeElement(folder, worksheetData) {
    const hasSharedStrings = !worksheetData.isEmpty || worksheetData.options.alwaysExportHeaders;
    folder['[Content_Types].xml'] = strToU8(ExcelStrings.getContentTypesXML(hasSharedStrings, worksheetData.options.exportAsTable));
  }
}
/**
 * @hidden
 */
class SharedStringsFile {
  writeElement(folder, worksheetData) {
    const dict = worksheetData.dataDictionary;
    const sortedValues = dict.getKeys();
    const sharedStrings = new Array(sortedValues.length);
    for (const value of sortedValues) {
      sharedStrings[dict.getSanitizedValue(value)] = '<si><t>' + value + '</t></si>';
    }
    folder['sharedStrings.xml'] = strToU8(ExcelStrings.getSharedStringXML(dict.stringsCount, sortedValues.length, sharedStrings.join('')));
  }
}
/**
 * @hidden
 */
class TablesFile {
  writeElement(folder, worksheetData) {
    const columnCount = worksheetData.columnCount;
    const lastColumn = ExcelStrings.getExcelColumn(columnCount - 1) + worksheetData.rowCount;
    const autoFilterDimension = 'A1:' + lastColumn;
    const tableDimension = worksheetData.isEmpty ? 'A1:' + ExcelStrings.getExcelColumn(columnCount - 1) + (worksheetData.rowCount + 1) : autoFilterDimension;
    const hasUserSetIndex = worksheetData.owner.columns.some(c => c.exportIndex !== undefined);
    const values = hasUserSetIndex ? worksheetData.rootKeys : worksheetData.owner.columns.filter(c => !c.skip).sort((a, b) => a.startIndex - b.startIndex).sort((a, b) => a.pinnedIndex - b.pinnedIndex).map(c => c.header);
    let sortString = '';
    let tableColumns = '<tableColumns count="' + columnCount + '">';
    for (let i = 0; i < columnCount; i++) {
      const value = values[i];
      tableColumns += '<tableColumn id="' + (i + 1) + '" name="' + value + '"/>';
    }
    tableColumns += '</tableColumns>';
    if (worksheetData.sort) {
      const sortingExpression = worksheetData.sort;
      const sc = ExcelStrings.getExcelColumn(values.indexOf(sortingExpression.fieldName));
      const dir = sortingExpression.dir - 1;
      sortString = `<sortState ref="A2:${lastColumn}"><sortCondition descending="${dir}" ref="${sc}1:${sc}15"/></sortState>`;
    }
    folder['table1.xml'] = strToU8(ExcelStrings.getTablesXML(autoFilterDimension, tableDimension, tableColumns, sortString));
  }
}
/**
 * @hidden
 */
class WorksheetRelsFile {
  writeElement(folder) {
    folder['sheet1.xml.rels'] = strToU8(ExcelStrings.getWorksheetRels());
  }
}

/** @hidden */
class RootExcelFolder {
  get folderName() {
    return '';
  }
  childFiles() {
    return [ExcelFileTypes.ContentTypesFile];
  }
  childFolders() {
    return [ExcelFolderTypes.RootRelsExcelFolder, ExcelFolderTypes.DocPropsExcelFolder, ExcelFolderTypes.XLExcelFolder];
  }
}
/** @hidden */
class RootRelsExcelFolder {
  get folderName() {
    return '_rels';
  }
  childFiles() {
    return [ExcelFileTypes.RootRelsFile];
  }
  childFolders() {
    return [];
  }
}
/** @hidden */
class DocPropsExcelFolder {
  get folderName() {
    return 'docProps';
  }
  childFiles() {
    return [ExcelFileTypes.AppFile, ExcelFileTypes.CoreFile];
  }
  childFolders() {
    return [];
  }
}
/** @hidden */
class XLExcelFolder {
  get folderName() {
    return 'xl';
  }
  childFiles(data) {
    const retVal = [ExcelFileTypes.StyleFile, ExcelFileTypes.WorkbookFile];
    if (!data.isEmpty || data.options.alwaysExportHeaders) {
      retVal.push(ExcelFileTypes.SharedStringsFile);
    }
    return retVal;
  }
  childFolders(data) {
    const retVal = [ExcelFolderTypes.XLRelsExcelFolder, ExcelFolderTypes.ThemeExcelFolder, ExcelFolderTypes.WorksheetsExcelFolder];
    if ((!data.isEmpty || data.options.alwaysExportHeaders) && data.options.exportAsTable) {
      retVal.push(ExcelFolderTypes.TablesExcelFolder);
    }
    return retVal;
  }
}
/** @hidden */
class XLRelsExcelFolder {
  get folderName() {
    return '_rels';
  }
  childFiles() {
    return [ExcelFileTypes.WorkbookRelsFile];
  }
  childFolders() {
    return [];
  }
}
/** @hidden */
class ThemeExcelFolder {
  get folderName() {
    return 'theme';
  }
  childFiles() {
    return [ExcelFileTypes.ThemeFile];
  }
  childFolders() {
    return [];
  }
}
/** @hidden */
class WorksheetsExcelFolder {
  get folderName() {
    return 'worksheets';
  }
  childFiles() {
    return [ExcelFileTypes.WorksheetFile];
  }
  childFolders(data) {
    return data.isEmpty && !data.options.alwaysExportHeaders || !data.options.exportAsTable ? [] : [ExcelFolderTypes.WorksheetsRelsExcelFolder];
  }
}
/** @hidden */
class TablesExcelFolder {
  get folderName() {
    return 'tables';
  }
  childFiles() {
    return [ExcelFileTypes.TablesFile];
  }
  childFolders() {
    return [];
  }
}
/** @hidden */
class WorksheetsRelsExcelFolder {
  get folderName() {
    return '_rels';
  }
  childFiles() {
    return [ExcelFileTypes.WorksheetRelsFile];
  }
  childFolders() {
    return [];
  }
}

/** @hidden */
class ExcelElementsFactory {
  static getExcelFolder(type) {
    switch (type) {
      case ExcelFolderTypes.RootExcelFolder:
        return new RootExcelFolder();
      case ExcelFolderTypes.RootRelsExcelFolder:
        return new RootRelsExcelFolder();
      case ExcelFolderTypes.DocPropsExcelFolder:
        return new DocPropsExcelFolder();
      case ExcelFolderTypes.XLExcelFolder:
        return new XLExcelFolder();
      case ExcelFolderTypes.XLRelsExcelFolder:
        return new XLRelsExcelFolder();
      case ExcelFolderTypes.ThemeExcelFolder:
        return new ThemeExcelFolder();
      case ExcelFolderTypes.WorksheetsExcelFolder:
        return new WorksheetsExcelFolder();
      case ExcelFolderTypes.WorksheetsRelsExcelFolder:
        return new WorksheetsRelsExcelFolder();
      case ExcelFolderTypes.TablesExcelFolder:
        return new TablesExcelFolder();
      default:
        throw new Error('Unknown excel folder type!');
    }
  }
  static getExcelFile(type) {
    switch (type) {
      case ExcelFileTypes.RootRelsFile:
        return new RootRelsFile();
      case ExcelFileTypes.AppFile:
        return new AppFile();
      case ExcelFileTypes.CoreFile:
        return new CoreFile();
      case ExcelFileTypes.WorkbookRelsFile:
        return new WorkbookRelsFile();
      case ExcelFileTypes.ThemeFile:
        return new ThemeFile();
      case ExcelFileTypes.WorksheetFile:
        return new WorksheetFile();
      case ExcelFileTypes.StyleFile:
        return new StyleFile();
      case ExcelFileTypes.WorkbookFile:
        return new WorkbookFile();
      case ExcelFileTypes.ContentTypesFile:
        return new ContentTypesFile();
      case ExcelFileTypes.SharedStringsFile:
        return new SharedStringsFile();
      case ExcelFileTypes.WorksheetRelsFile:
        return new WorksheetRelsFile();
      case ExcelFileTypes.TablesFile:
        return new TablesFile();
      default:
        throw Error('Unknown excel file type!');
    }
  }
}

/** @hidden */
let WorksheetDataDictionary = /*#__PURE__*/(() => {
  class WorksheetDataDictionary {
    static {
      this.DEFAULT_FONT = '11pt Calibri';
    }
    static {
      this.TEXT_PADDING = 5;
    }
    constructor(columnCount, columnWidth, columnWidthsList) {
      this.hasNumberValues = false;
      this.hasDateValues = false;
      this._dictionary = {};
      this._widthsDictionary = {};
      this._counter = 0;
      this.dirtyKeyCollections();
      this._columnWidths = new Array(columnCount);
      if (columnWidth) {
        this._columnWidths.fill(columnWidth);
      } else {
        this._columnWidths = columnWidthsList;
      }
      this.stringsCount = 0;
    }
    get columnWidths() {
      return this._columnWidths;
    }
    saveValue(value, isHeader, shouldSanitizeValue = true) {
      let sanitizedValue = '';
      const isDate = value instanceof Date;
      const isSavedAsString = isHeader || typeof value !== 'number' && value !== Number(value) && !Number.isFinite(value) && !isDate;
      if (isSavedAsString) {
        sanitizedValue = shouldSanitizeValue ? ExportUtilities.sanitizeValue(value) : value;
        if (this._dictionary[sanitizedValue] === undefined) {
          this._dictionary[sanitizedValue] = this._counter++;
          this.dirtyKeyCollections();
        }
        this.stringsCount++;
      } else if (isDate) {
        this.hasDateValues = true;
      } else {
        this.hasNumberValues = true;
      }
      return isSavedAsString ? this.getSanitizedValue(sanitizedValue) : -1;
    }
    getValue(value) {
      return this.getSanitizedValue(ExportUtilities.sanitizeValue(value));
    }
    getSanitizedValue(sanitizedValue) {
      return this._dictionary[sanitizedValue];
    }
    getKeys() {
      if (!this._keysAreValid) {
        this._keys = Object.keys(this._dictionary);
        this._keysAreValid = true;
      }
      return this._keys;
    }
    getTextWidth(value) {
      if (this._widthsDictionary[value] === undefined) {
        const context = this.getContext();
        const metrics = context.measureText(value);
        this._widthsDictionary[value] = metrics.width + WorksheetDataDictionary.TEXT_PADDING;
      }
      return this._widthsDictionary[value];
    }
    getContext() {
      if (!this._context) {
        const canvas = globalThis.document?.createElement('canvas');
        this._context = canvas.getContext('2d');
        this._context.font = WorksheetDataDictionary.DEFAULT_FONT;
      }
      return this._context;
    }
    dirtyKeyCollections() {
      this._keysAreValid = false;
    }
  }
  return WorksheetDataDictionary;
})();
/** @hidden */
class WorksheetData {
  constructor(_data, options, sort, columnCount, rootKeys, indexOfLastPinnedColumn, columnWidths, owner, owners) {
    this._data = _data;
    this.options = options;
    this.sort = sort;
    this.columnCount = columnCount;
    this.rootKeys = rootKeys;
    this.indexOfLastPinnedColumn = indexOfLastPinnedColumn;
    this.columnWidths = columnWidths;
    this.owner = owner;
    this.owners = owners;
    this.initializeData();
  }
  get data() {
    return this._data;
  }
  get rowCount() {
    return this._rowCount;
  }
  get isEmpty() {
    return !this.rowCount || this.rowCount === this.owner.maxLevel + 1 || !this.columnCount || this.owner.columns.every(c => c.skip);
  }
  get isSpecialData() {
    return this._isSpecialData;
  }
  get dataDictionary() {
    return this._dataDictionary;
  }
  get hasMultiColumnHeader() {
    return this._hasMultiColumnHeader;
  }
  get hasSummaries() {
    return this._hasSummaries;
  }
  get hasMultiRowHeader() {
    return this._hasMultiRowHeader;
  }
  get isHierarchical() {
    return this._isHierarchical;
  }
  get isTreeGrid() {
    return this._isTreeGrid;
  }
  get isPivotGrid() {
    return this._isPivotGrid;
  }
  get isGroupedGrid() {
    return this._data.some(d => d.type === ExportRecordType.GroupedRecord);
  }
  get maxLevel() {
    return [...new Set(this._data.map(item => item.level))].sort((a, b) => a > b ? -1 : 1)[0];
  }
  get multiColumnHeaderRows() {
    return !this.options.ignoreMultiColumnHeaders ? Array.from(this.owners.values()).map(c => c.maxLevel).reduce((a, b) => a + b) : 0;
  }
  initializeData() {
    this._dataDictionary = new WorksheetDataDictionary(this.columnCount, this.options.columnWidth, this.columnWidths);
    this._hasMultiColumnHeader = Array.from(this.owners.values()).some(o => o.columns.some(col => !col.skip && col.headerType === ExportHeaderType.MultiColumnHeader));
    this._hasMultiRowHeader = Array.from(this.owners.values()).some(o => o.columns.some(col => !col.skip && col.headerType === ExportHeaderType.MultiRowHeader));
    this._isHierarchical = this.data[0]?.type === ExportRecordType.HierarchicalGridRecord || !(typeof Array.from(this.owners.keys())[0] === 'string');
    this._hasSummaries = this._data.filter(d => d.type === ExportRecordType.SummaryRecord).length > 0;
    this._isTreeGrid = this._data.filter(d => d.type === ExportRecordType.TreeGridRecord).length > 0;
    this._isPivotGrid = this.data[0]?.type === ExportRecordType.PivotGridRecord;
    const exportMultiColumnHeaders = this._hasMultiColumnHeader && !this.options.ignoreMultiColumnHeaders;
    if (this._isHierarchical || exportMultiColumnHeaders || this._isPivotGrid) {
      this.options.exportAsTable = false;
    }
    if (!this._data || this._data.length === 0) {
      if (!this._isHierarchical) {
        this._rowCount = this.owner.maxLevel + 1;
      }
      return;
    }
    this._isSpecialData = ExportUtilities.isSpecialData(this._data[0].data);
    this._rowCount = this._data.length + this.multiColumnHeaderRows + 1;
  }
}
const EXCEL_MAX_ROWS = 1048576;
const EXCEL_MAX_COLS = 16384;
/**
 * **Ignite UI for Angular Excel Exporter Service** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/exporter_excel.html)
 *
 * The Ignite UI for Angular Excel Exporter service can export data in Microsoft® Excel® format from both raw data
 * (array) or from an `IgxGrid`.
 *
 * Example:
 * ```typescript
 * public localData = [
 *   { Name: "Eric Ridley", Age: "26" },
 *   { Name: "Alanis Brook", Age: "22" },
 *   { Name: "Jonathan Morris", Age: "23" }
 * ];
 *
 * constructor(private excelExportService: IgxExcelExporterService) {
 * }
 *
 * this.excelExportService.exportData(this.localData, new IgxExcelExporterOptions("FileName"));
 * ```
 */
let IgxExcelExporterService = /*#__PURE__*/(() => {
  class IgxExcelExporterService extends IgxBaseExporter {
    constructor() {
      super(...arguments);
      /**
       * This event is emitted when the export process finishes.
       * ```typescript
       * this.exporterService.exportEnded.subscribe((args: IExcelExportEndedEventArgs) => {
       * // put event handler code here
       * });
       * ```
       *
       * @memberof IgxExcelExporterService
       */
      this.exportEnded = new EventEmitter();
    }
    static async populateZipFileConfig(fileStructure, folder, worksheetData) {
      for (const childFolder of folder.childFolders(worksheetData)) {
        const folderInstance = ExcelElementsFactory.getExcelFolder(childFolder);
        const childStructure = fileStructure[folderInstance.folderName] = {};
        await IgxExcelExporterService.populateZipFileConfig(childStructure, folderInstance, worksheetData);
      }
      for (const childFile of folder.childFiles(worksheetData)) {
        const fileInstance = ExcelElementsFactory.getExcelFile(childFile);
        if (fileInstance instanceof WorksheetFile) {
          await fileInstance.writeElementAsync(fileStructure, worksheetData);
        } else {
          fileInstance.writeElement(fileStructure, worksheetData);
        }
      }
    }
    exportDataImplementation(data, options, done) {
      const firstDataElement = data[0];
      const isHierarchicalGrid = firstDataElement?.type === ExportRecordType.HierarchicalGridRecord;
      const isPivotGrid = firstDataElement?.type === ExportRecordType.PivotGridRecord;
      let rootKeys;
      let columnCount;
      let columnWidths;
      let indexOfLastPinnedColumn;
      let defaultOwner;
      const columnsExceedLimit = typeof firstDataElement !== 'undefined' ? isHierarchicalGrid ? data.some(d => Object.keys(d.data).length > EXCEL_MAX_COLS) : Object.keys(firstDataElement.data).length > EXCEL_MAX_COLS : false;
      if (data.length > EXCEL_MAX_ROWS || columnsExceedLimit) {
        throw Error('The Excel file can contain up to 1,048,576 rows and 16,384 columns.');
      }
      if (typeof firstDataElement !== 'undefined') {
        let maxLevel = 0;
        data.forEach(r => {
          maxLevel = Math.max(maxLevel, r.level);
        });
        if (maxLevel > 7) {
          throw Error('Can create an outline of up to eight levels!');
        }
        if (isHierarchicalGrid) {
          columnCount = data.map(a => this._ownersMap.get(a.owner).columns.filter(c => !c.skip).length + a.level).sort((a, b) => b - a)[0];
          rootKeys = this._ownersMap.get(firstDataElement.owner).columns.filter(c => !c.skip).map(c => c.field);
          defaultOwner = this._ownersMap.get(firstDataElement.owner);
        } else {
          defaultOwner = this._ownersMap.get(DEFAULT_OWNER);
          const columns = defaultOwner.columns.filter(col => col.field !== GRID_LEVEL_COL && !col.skip && col.headerType === ExportHeaderType.ColumnHeader);
          columnWidths = defaultOwner.columnWidths;
          indexOfLastPinnedColumn = defaultOwner.indexOfLastPinnedColumn;
          columnCount = isPivotGrid ? columns.length + this.pivotGridFilterFieldsCount : columns.length;
          rootKeys = columns.map(c => c.field);
        }
      } else {
        const ownersKeys = Array.from(this._ownersMap.keys());
        defaultOwner = this._ownersMap.get(ownersKeys[0]);
        columnWidths = defaultOwner.columnWidths;
        columnCount = defaultOwner.columns.filter(col => col.field !== GRID_LEVEL_COL && !col.skip && col.headerType === ExportHeaderType.ColumnHeader).length;
      }
      const worksheetData = new WorksheetData(data, options, this._sort, columnCount, rootKeys, indexOfLastPinnedColumn, columnWidths, defaultOwner, this._ownersMap);
      const rootFolder = ExcelElementsFactory.getExcelFolder(ExcelFolderTypes.RootExcelFolder);
      const fileData = {};
      IgxExcelExporterService.populateZipFileConfig(fileData, rootFolder, worksheetData).then(() => {
        zip(fileData, (_, result) => {
          this.saveFile(result, options.fileName);
          this.exportEnded.emit({
            xlsx: fileData
          });
          done();
        });
      });
    }
    saveFile(data, fileName) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      ExportUtilities.saveBlobToFile(blob, fileName);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxExcelExporterService_BaseFactory;
        return function IgxExcelExporterService_Factory(__ngFactoryType__) {
          return (ɵIgxExcelExporterService_BaseFactory || (ɵIgxExcelExporterService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxExcelExporterService)))(__ngFactoryType__ || IgxExcelExporterService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxExcelExporterService,
        factory: IgxExcelExporterService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxExcelExporterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Objects of this class are used to configure the Excel exporting process.
 */
class IgxExcelExporterOptions extends IgxExporterOptionsBase {
  constructor(fileName) {
    super(fileName, '.xlsx');
    /**
     * Specifies if column pinning should be ignored. If ignoreColumnsOrder is set to true,
     * this option will always be considered as set to true.
     * ```typescript
     * let ignorePinning = this.exportOptions.ignorePinning;
     * this.exportOptions.ignorePinning = true;
     * ```
     *
     * @memberof IgxExcelExporterOptions
     */
    this.ignorePinning = false;
    /**
     * Specifies whether the exported data should be formatted as Excel table. (True by default)
     * ```typescript
     * let exportAsTable = this.exportOptions.exportAsTable;
     * this.exportOptions.exportAsTable = false;
     * ```
     *
     * @memberof IgxExcelExporterOptions
     */
    this.exportAsTable = true;
  }
  /**
   * Gets the width of the columns in the exported excel file.
   * ```typescript
   * let width = this.exportOptions.columnWidth;
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  get columnWidth() {
    return this._columnWidth;
  }
  /**
   * Sets the width of the columns in the exported excel file. If left unspecified,
   * the width of the column or the default width of the excel columns will be used.
   * ```typescript
   * this.exportOptions.columnWidth = 55;
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  set columnWidth(value) {
    if (value < 0) {
      throw Error('Invalid value for column width!');
    }
    this._columnWidth = value;
  }
  /**
   * Gets the height of the rows in the exported excel file.
   * ```typescript
   * let height = this.exportOptions.rowHeight;
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  get rowHeight() {
    return this._rowHeight;
  }
  /**
   * Sets the height of the rows in the exported excel file. If left unspecified or 0,
   * the default height of the excel rows will be used.
   * ```typescript
   * this.exportOptions.rowHeight = 25;
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  set rowHeight(value) {
    if (value < 0) {
      throw Error('Invalid value for row height!');
    }
    this._rowHeight = value;
  }
  /**
   * Gets the name of the worksheet in the exported excel file.
   * ```typescript
   * let worksheetName = this.exportOptions.worksheetName;
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  get worksheetName() {
    if (this._worksheetName === undefined || this._worksheetName === null) {
      return 'Sheet1';
    }
    return this._worksheetName;
  }
  /**
   * Sets the name of the worksheet in the exported excel file.
   * ```typescript
   * this.exportOptions.worksheetName = "Worksheet";
   * ```
   *
   * @memberof IgxExcelExporterOptions
   */
  set worksheetName(value) {
    this._worksheetName = value;
  }
}
class IgxAngularAnimationPlayer {
  get position() {
    return this._innerPlayer.getPosition();
  }
  set position(value) {
    this.internalPlayer.setPosition(value);
  }
  constructor(internalPlayer) {
    this.internalPlayer = internalPlayer;
    this.animationStart = new EventEmitter();
    this.animationEnd = new EventEmitter();
    this.internalPlayer.onDone(() => this.onDone());
    const innerRenderer = this.internalPlayer._renderer;
    //  We need inner player as Angular.AnimationPlayer.getPosition returns always 0.
    // To workaround this we are getting the positions from the inner player.
    //  This is logged in Angular here - https://github.com/angular/angular/issues/18891
    //  As soon as this is resolved we can remove this hack
    const rendererEngine = innerRenderer.engine || innerRenderer.delegate.engine;
    // A workaround because of Angular SSR is using some delegation.
    this._innerPlayer = rendererEngine.players[rendererEngine.players.length - 1];
  }
  init() {
    this.internalPlayer.init();
  }
  play() {
    this.animationStart.emit({
      owner: this
    });
    this.internalPlayer.play();
  }
  finish() {
    this.internalPlayer.finish();
    // TODO: when animation finish angular deletes all onDone handlers. Add handlers again if needed
  }
  reset() {
    this.internalPlayer.reset();
    // calling reset does not change hasStarted to false. This is why we are doing it here via internal field
    this.internalPlayer._started = false;
  }
  destroy() {
    this.internalPlayer.destroy();
  }
  hasStarted() {
    return this.internalPlayer.hasStarted();
  }
  onDone() {
    this.animationEnd.emit({
      owner: this
    });
  }
}
let IgxAngularAnimationService = /*#__PURE__*/(() => {
  class IgxAngularAnimationService {
    constructor(builder) {
      this.builder = builder;
    }
    buildAnimation(animationMetaData, element) {
      if (!animationMetaData) {
        return null;
      }
      const animationBuilder = this.builder.build(animationMetaData);
      const player = new IgxAngularAnimationPlayer(animationBuilder.create(element));
      return player;
    }
    static {
      this.ɵfac = function IgxAngularAnimationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAngularAnimationService)(i0.ɵɵinject(i1.AnimationBuilder));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxAngularAnimationService,
        factory: IgxAngularAnimationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxAngularAnimationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorAlternateName: GridHorizontalAlignment */
var HorizontalAlignment = /*#__PURE__*/function (HorizontalAlignment) {
  HorizontalAlignment[HorizontalAlignment["Left"] = -1] = "Left";
  HorizontalAlignment[HorizontalAlignment["Center"] = -0.5] = "Center";
  HorizontalAlignment[HorizontalAlignment["Right"] = 0] = "Right";
  return HorizontalAlignment;
}(HorizontalAlignment || {});
/* blazorAlternateName: GridVerticalAlignment */
var VerticalAlignment = /*#__PURE__*/function (VerticalAlignment) {
  VerticalAlignment[VerticalAlignment["Top"] = -1] = "Top";
  VerticalAlignment[VerticalAlignment["Middle"] = -0.5] = "Middle";
  VerticalAlignment[VerticalAlignment["Bottom"] = 0] = "Bottom";
  return VerticalAlignment;
}(VerticalAlignment || {});
/**
 * Defines the possible values of the overlays' position strategy.
 */
var RelativePositionStrategy = /*#__PURE__*/function (RelativePositionStrategy) {
  RelativePositionStrategy["Connected"] = "connected";
  RelativePositionStrategy["Auto"] = "auto";
  RelativePositionStrategy["Elastic"] = "elastic";
  return RelativePositionStrategy;
}(RelativePositionStrategy || {});
/**
 * Defines the possible positions for the relative overlay settings presets.
 */
var RelativePosition = /*#__PURE__*/function (RelativePosition) {
  RelativePosition["Above"] = "above";
  RelativePosition["Below"] = "below";
  RelativePosition["Before"] = "before";
  RelativePosition["After"] = "after";
  RelativePosition["Default"] = "default";
  return RelativePosition;
}(RelativePosition || {});
/**
 * Defines the possible positions for the absolute overlay settings presets.
 */
var AbsolutePosition = /*#__PURE__*/function (AbsolutePosition) {
  AbsolutePosition["Bottom"] = "bottom";
  AbsolutePosition["Top"] = "top";
  AbsolutePosition["Center"] = "center";
  return AbsolutePosition;
}(AbsolutePosition || {});
/**
 * Determines whether to add or set the offset values.
 */
var OffsetMode = /*#__PURE__*/function (OffsetMode) {
  OffsetMode[OffsetMode["Add"] = 0] = "Add";
  OffsetMode[OffsetMode["Set"] = 1] = "Set";
  return OffsetMode;
}(OffsetMode || {});
// TODO: make this interface
class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}
/** @hidden @internal */
class Util {
  /**
   * Calculates the rectangle of target for provided overlay settings. Defaults to 0,0,0,0,0,0 rectangle
   * if no target is provided
   *
   * @param settings Overlay settings for which to calculate target rectangle
   */
  static getTargetRect(target) {
    let targetRect = {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0
    };
    if (target instanceof HTMLElement) {
      targetRect = target.getBoundingClientRect();
    } else if (target instanceof Point) {
      const targetPoint = target;
      targetRect = {
        bottom: targetPoint.y,
        height: 0,
        left: targetPoint.x,
        right: targetPoint.x,
        top: targetPoint.y,
        width: 0
      };
    }
    return targetRect;
  }
  static getViewportRect(document) {
    const width = document.documentElement.clientWidth;
    const height = document.documentElement.clientHeight;
    const scrollPosition = Util.getViewportScrollPosition(document);
    return {
      top: scrollPosition.y,
      left: scrollPosition.x,
      right: scrollPosition.x + width,
      bottom: scrollPosition.y + height,
      width,
      height
    };
  }
  static getViewportScrollPosition(document) {
    const documentElement = document.documentElement;
    const documentRect = documentElement.getBoundingClientRect();
    const horizontalScrollPosition = -documentRect.left || document.body.scrollLeft || window.scrollX || documentElement.scrollLeft || 0;
    const verticalScrollPosition = -documentRect.top || document.body.scrollTop || window.scrollY || documentElement.scrollTop || 0;
    return new Point(horizontalScrollPosition, verticalScrollPosition);
  }
  static cloneInstance(object) {
    const clonedObj = Object.assign(Object.create(Object.getPrototypeOf(object)), object);
    clonedObj.settings = cloneValue(clonedObj.settings);
    return clonedObj;
  }
}

/**
 * Positions the element based on the directions and start point passed in trough PositionSettings.
 * It is possible to either pass a start point or an HTMLElement as a positioning base.
 */
class ConnectedPositioningStrategy {
  constructor(settings) {
    this._defaultSettings = {
      horizontalDirection: HorizontalAlignment.Right,
      verticalDirection: VerticalAlignment.Bottom,
      horizontalStartPoint: HorizontalAlignment.Left,
      verticalStartPoint: VerticalAlignment.Bottom,
      openAnimation: scaleInVerTop,
      closeAnimation: scaleOutVerTop,
      minSize: {
        width: 0,
        height: 0
      }
    };
    this.settings = Object.assign({}, this._defaultSettings, settings);
  }
  /**
   * Position the element based on the PositionStrategy implementing this interface.
   *
   * @param contentElement The HTML element to be positioned
   * @param size Size of the element
   * @param document reference to the Document object
   * @param initialCall should be true if this is the initial call to the method
   * @param target attaching target for the component to show
   * ```typescript
   * settings.positionStrategy.position(content, size, document, true);
   * ```
   */
  position(contentElement, size, document, initialCall, target) {
    const rects = this.calculateElementRectangles(contentElement, target);
    this.setStyle(contentElement, rects.targetRect, rects.elementRect, {});
  }
  /**
   * Creates clone of this position strategy
   * @returns clone of this position strategy
   */
  clone() {
    return Util.cloneInstance(this);
  }
  /**
   * Obtains the DomRect objects for the required elements - target and element to position
   *
   * @returns target and element DomRect objects
   */
  calculateElementRectangles(contentElement, target) {
    return {
      targetRect: Util.getTargetRect(target),
      elementRect: contentElement.getBoundingClientRect()
    };
  }
  /**
   * Sets element's style which effectively positions provided element according
   * to provided position settings
   *
   * @param element Element to position
   * @param targetRect Bounding rectangle of strategy target
   * @param elementRect Bounding rectangle of the element
   */
  setStyle(element, targetRect, elementRect, connectedFit) {
    const horizontalOffset = connectedFit.horizontalOffset ? connectedFit.horizontalOffset : 0;
    const verticalOffset = connectedFit.verticalOffset ? connectedFit.verticalOffset : 0;
    const startPoint = {
      x: targetRect.right + targetRect.width * this.settings.horizontalStartPoint + horizontalOffset,
      y: targetRect.bottom + targetRect.height * this.settings.verticalStartPoint + verticalOffset
    };
    const wrapperRect = element.parentElement.getBoundingClientRect();
    //  clean up styles - if auto position strategy is chosen we may pass here several times
    element.style.right = '';
    element.style.left = '';
    element.style.bottom = '';
    element.style.top = '';
    switch (this.settings.horizontalDirection) {
      case HorizontalAlignment.Left:
        element.style.right = `${Math.round(wrapperRect.right - startPoint.x)}px`;
        break;
      case HorizontalAlignment.Center:
        element.style.left = `${Math.round(startPoint.x - wrapperRect.left - elementRect.width / 2)}px`;
        break;
      case HorizontalAlignment.Right:
        element.style.left = `${Math.round(startPoint.x - wrapperRect.left)}px`;
        break;
    }
    switch (this.settings.verticalDirection) {
      case VerticalAlignment.Top:
        element.style.bottom = `${Math.round(wrapperRect.bottom - startPoint.y)}px`;
        break;
      case VerticalAlignment.Middle:
        element.style.top = `${Math.round(startPoint.y - wrapperRect.top - elementRect.height / 2)}px`;
        break;
      case VerticalAlignment.Bottom:
        element.style.top = `${Math.round(startPoint.y - wrapperRect.top)}px`;
        break;
    }
  }
}
class BaseFitPositionStrategy extends ConnectedPositioningStrategy {
  /**
   * Position the element based on the PositionStrategy implementing this interface.
   *
   * @param contentElement The HTML element to be positioned
   * @param size Size of the element
   * @param document reference to the Document object
   * @param initialCall should be true if this is the initial call to the method
   * @param target attaching target for the component to show
   * ```typescript
   * settings.positionStrategy.position(content, size, document, true);
   * ```
   */
  position(contentElement, size, document, initialCall, target) {
    const rects = super.calculateElementRectangles(contentElement, target);
    const connectedFit = {};
    if (initialCall) {
      connectedFit.targetRect = rects.targetRect;
      connectedFit.contentElementRect = rects.elementRect;
      this._initialSettings = this._initialSettings || Object.assign({}, this.settings);
      this.settings = Object.assign({}, this._initialSettings);
      connectedFit.viewPortRect = Util.getViewportRect(document);
      this.updateViewPortFit(connectedFit);
      if (this.shouldFitInViewPort(connectedFit)) {
        this.fitInViewport(contentElement, connectedFit);
      }
    }
    this.setStyle(contentElement, rects.targetRect, rects.elementRect, connectedFit);
  }
  /**
   * Checks if element can fit in viewport and updates provided connectedFit
   * with the result
   *
   * @param connectedFit connectedFit to update
   */
  updateViewPortFit(connectedFit) {
    connectedFit.left = this.calculateLeft(connectedFit.targetRect, connectedFit.contentElementRect, this.settings.horizontalStartPoint, this.settings.horizontalDirection, connectedFit.horizontalOffset ? connectedFit.horizontalOffset : 0);
    connectedFit.right = connectedFit.left + connectedFit.contentElementRect.width;
    connectedFit.fitHorizontal = {
      back: Math.round(connectedFit.left),
      forward: Math.round(connectedFit.viewPortRect.width - connectedFit.right)
    };
    connectedFit.top = this.calculateTop(connectedFit.targetRect, connectedFit.contentElementRect, this.settings.verticalStartPoint, this.settings.verticalDirection, connectedFit.verticalOffset ? connectedFit.verticalOffset : 0);
    connectedFit.bottom = connectedFit.top + connectedFit.contentElementRect.height;
    connectedFit.fitVertical = {
      back: Math.round(connectedFit.top),
      forward: Math.round(connectedFit.viewPortRect.height - connectedFit.bottom)
    };
  }
  /**
   * Calculates the position of the left border of the element if it gets positioned
   * with provided start point and direction
   *
   * @param targetRect Rectangle of the target where element is attached
   * @param elementRect Rectangle of the element
   * @param startPoint Start point of the target
   * @param direction Direction in which to show the element
   */
  calculateLeft(targetRect, elementRect, startPoint, direction, offset) {
    return targetRect.right + targetRect.width * startPoint + elementRect.width * direction + offset;
  }
  /**
   * Calculates the position of the top border of the element if it gets positioned
   * with provided position settings related to the target
   *
   * @param targetRect Rectangle of the target where element is attached
   * @param elementRect Rectangle of the element
   * @param startPoint Start point of the target
   * @param direction Direction in which to show the element
   */
  calculateTop(targetRect, elementRect, startPoint, direction, offset) {
    return targetRect.bottom + targetRect.height * startPoint + elementRect.height * direction + offset;
  }
  /**
   * Returns whether the element should fit in viewport
   *
   * @param connectedFit connectedFit object containing all necessary parameters
   */
  shouldFitInViewPort(connectedFit) {
    return connectedFit.fitHorizontal.back < 0 || connectedFit.fitHorizontal.forward < 0 || connectedFit.fitVertical.back < 0 || connectedFit.fitVertical.forward < 0;
  }
}

/**
 * Positions the element as in **Connected** positioning strategy and re-positions the element in
 * the view port (calculating a different start point) in case the element is partially getting out of view
 */
class AutoPositionStrategy extends BaseFitPositionStrategy {
  /**
   * Fits the element into viewport according to the position settings
   *
   * @param element element to fit in viewport
   * @param connectedFit connectedFit object containing all necessary parameters
   */
  fitInViewport(element, connectedFit) {
    const transformString = [];
    if (connectedFit.fitHorizontal.back < 0 || connectedFit.fitHorizontal.forward < 0) {
      if (this.canFlipHorizontal(connectedFit)) {
        this.flipHorizontal();
        this.flipAnimation(FlipDirection.Horizontal);
      } else {
        const horizontalPush = this.horizontalPush(connectedFit);
        transformString.push(`translateX(${horizontalPush}px)`);
      }
    }
    if (connectedFit.fitVertical.back < 0 || connectedFit.fitVertical.forward < 0) {
      if (this.canFlipVertical(connectedFit)) {
        this.flipVertical();
        this.flipAnimation(FlipDirection.Vertical);
      } else {
        const verticalPush = this.verticalPush(connectedFit);
        transformString.push(`translateY(${verticalPush}px)`);
      }
    }
    element.style.transform = transformString.join(' ').trim();
  }
  /**
   * Checks if element can be flipped without get off the viewport
   *
   * @param connectedFit connectedFit object containing all necessary parameters
   * @returns true if element can be flipped and stain in viewport
   */
  canFlipHorizontal(connectedFit) {
    //  HorizontalAlignment can be Left = -1; Center = -0.5 or Right = 0.
    //  To virtually flip direction and start point (both are HorizontalAlignment) we can do this:
    //  flippedAlignment = (-1) * (HorizontalAlignment + 1)
    //  this way:
    //  (-1) * (Left + 1) = 0 = Right
    //  (-1) * (Center + 1) = -0.5 = Center
    //  (-1) * (Right + 1) = -1 = Left
    const flippedStartPoint = -1 * (this.settings.horizontalStartPoint + 1);
    const flippedDirection = -1 * (this.settings.horizontalDirection + 1);
    const leftBorder = this.calculateLeft(connectedFit.targetRect, connectedFit.contentElementRect, flippedStartPoint, flippedDirection, 0);
    const rightBorder = leftBorder + connectedFit.contentElementRect.width;
    return 0 < leftBorder && rightBorder < connectedFit.viewPortRect.width;
  }
  /**
   * Checks if element can be flipped without get off the viewport
   *
   * @param connectedFit connectedFit object containing all necessary parameters
   * @returns true if element can be flipped and stain in viewport
   */
  canFlipVertical(connectedFit) {
    const flippedStartPoint = -1 * (this.settings.verticalStartPoint + 1);
    const flippedDirection = -1 * (this.settings.verticalDirection + 1);
    const topBorder = this.calculateTop(connectedFit.targetRect, connectedFit.contentElementRect, flippedStartPoint, flippedDirection, 0);
    const bottomBorder = topBorder + connectedFit.contentElementRect.height;
    return 0 < topBorder && bottomBorder < connectedFit.viewPortRect.height;
  }
  /**
   * Flips direction and start point of the position settings
   */
  flipHorizontal() {
    switch (this.settings.horizontalDirection) {
      case HorizontalAlignment.Left:
        this.settings.horizontalDirection = HorizontalAlignment.Right;
        break;
      case HorizontalAlignment.Right:
        this.settings.horizontalDirection = HorizontalAlignment.Left;
        break;
    }
    switch (this.settings.horizontalStartPoint) {
      case HorizontalAlignment.Left:
        this.settings.horizontalStartPoint = HorizontalAlignment.Right;
        break;
      case HorizontalAlignment.Right:
        this.settings.horizontalStartPoint = HorizontalAlignment.Left;
        break;
    }
  }
  /**
   * Flips direction and start point of the position settings
   */
  flipVertical() {
    switch (this.settings.verticalDirection) {
      case VerticalAlignment.Top:
        this.settings.verticalDirection = VerticalAlignment.Bottom;
        break;
      case VerticalAlignment.Bottom:
        this.settings.verticalDirection = VerticalAlignment.Top;
        break;
    }
    switch (this.settings.verticalStartPoint) {
      case VerticalAlignment.Top:
        this.settings.verticalStartPoint = VerticalAlignment.Bottom;
        break;
      case VerticalAlignment.Bottom:
        this.settings.verticalStartPoint = VerticalAlignment.Top;
        break;
    }
  }
  /**
   * Calculates necessary horizontal push according to provided connectedFit
   *
   * @param connectedFit connectedFit object containing all necessary parameters
   * @returns amount of necessary translation which will push the element into viewport
   */
  horizontalPush(connectedFit) {
    const leftExtend = connectedFit.left;
    const rightExtend = connectedFit.right - connectedFit.viewPortRect.width;
    //  if leftExtend < 0 overlay goes beyond left end of the screen. We should push it back with exactly
    //  as much as it is beyond the screen.
    //  if rightExtend > 0 overlay goes beyond right end of the screen. We should push it back with the
    //  extend but with amount not bigger than what left between left border of screen and left border of
    //  overlay, e.g. leftExtend
    if (leftExtend < 0) {
      return Math.abs(leftExtend);
    } else if (rightExtend > 0) {
      return -Math.min(rightExtend, leftExtend);
    } else {
      return 0;
    }
  }
  /**
   * Calculates necessary vertical push according to provided connectedFit
   *
   * @param connectedFit connectedFit object containing all necessary parameters
   * @returns amount of necessary translation which will push the element into viewport
   */
  verticalPush(connectedFit) {
    const topExtend = connectedFit.top;
    const bottomExtend = connectedFit.bottom - connectedFit.viewPortRect.height;
    if (topExtend < 0) {
      return Math.abs(topExtend);
    } else if (bottomExtend > 0) {
      return -Math.min(bottomExtend, topExtend);
    } else {
      return 0;
    }
  }
  /**
   * Changes open and close animation with reverse animation if one exists
   *
   * @param flipDirection direction for which to change the animations
   */
  flipAnimation(flipDirection) {
    if (this.settings.openAnimation) {
      this.settings.openAnimation = this.updateAnimation(this.settings.openAnimation, flipDirection);
    }
    if (this.settings.closeAnimation) {
      this.settings.closeAnimation = this.updateAnimation(this.settings.closeAnimation, flipDirection);
    }
  }
  /**
   * Tries to find the reverse animation according to provided direction
   *
   * @param animation animation to update
   * @param direction required animation direction
   * @returns reverse animation in given direction if one exists
   */
  updateAnimation(animation, direction) {
    switch (direction) {
      case FlipDirection.Horizontal:
        if (AnimationUtil.instance().isHorizontalAnimation(animation)) {
          return AnimationUtil.instance().reverseAnimationResolver(animation);
        }
        break;
      case FlipDirection.Vertical:
        if (AnimationUtil.instance().isVerticalAnimation(animation)) {
          return AnimationUtil.instance().reverseAnimationResolver(animation);
        }
        break;
    }
    return animation;
  }
}
var FlipDirection = /*#__PURE__*/function (FlipDirection) {
  FlipDirection[FlipDirection["Horizontal"] = 0] = "Horizontal";
  FlipDirection[FlipDirection["Vertical"] = 1] = "Vertical";
  return FlipDirection;
}(FlipDirection || {});
/**
 * Positions the element based on the directions passed in trough PositionSettings.
 * These are Top/Middle/Bottom for verticalDirection and Left/Center/Right for horizontalDirection
 */
class GlobalPositionStrategy {
  constructor(settings) {
    this._defaultSettings = {
      horizontalDirection: HorizontalAlignment.Center,
      verticalDirection: VerticalAlignment.Middle,
      horizontalStartPoint: HorizontalAlignment.Center,
      verticalStartPoint: VerticalAlignment.Middle,
      openAnimation: fadeIn,
      closeAnimation: fadeOut,
      minSize: {
        width: 0,
        height: 0
      }
    };
    this.settings = Object.assign({}, this._defaultSettings, settings);
  }
  /**
   * Position the element based on the PositionStrategy implementing this interface.
   *
   * @param contentElement The HTML element to be positioned
   * @param size Size of the element
   * @param document reference to the Document object
   * @param initialCall should be true if this is the initial call to the method
   * @param target attaching target for the component to show
   * ```typescript
   * settings.positionStrategy.position(content, size, document, true);
   * ```
   */
  position(contentElement) {
    contentElement.classList.add('igx-overlay__content--relative');
    contentElement.parentElement.classList.add('igx-overlay__wrapper--flex');
    this.setPosition(contentElement);
  }
  /**
   * Clone the strategy instance.
   * ```typescript
   * settings.positionStrategy.clone();
   * ```
   */
  clone() {
    return Util.cloneInstance(this);
  }
  setPosition(contentElement) {
    switch (this.settings.horizontalDirection) {
      case HorizontalAlignment.Left:
        contentElement.parentElement.style.justifyContent = 'flex-start';
        break;
      case HorizontalAlignment.Center:
        contentElement.parentElement.style.justifyContent = 'center';
        break;
      case HorizontalAlignment.Right:
        contentElement.parentElement.style.justifyContent = 'flex-end';
        break;
      default:
        break;
    }
    switch (this.settings.verticalDirection) {
      case VerticalAlignment.Top:
        contentElement.parentElement.style.alignItems = 'flex-start';
        break;
      case VerticalAlignment.Middle:
        contentElement.parentElement.style.alignItems = 'center';
        break;
      case VerticalAlignment.Bottom:
        contentElement.parentElement.style.alignItems = 'flex-end';
        break;
      default:
        break;
    }
  }
}

/**
 * Positions the element inside the containing outlet based on the directions passed in trough PositionSettings.
 * These are Top/Middle/Bottom for verticalDirection and Left/Center/Right for horizontalDirection
 */
class ContainerPositionStrategy extends GlobalPositionStrategy {
  constructor(settings) {
    super(settings);
  }
  /**
   * Position the element based on the PositionStrategy implementing this interface.
   */
  position(contentElement) {
    contentElement.classList.add('igx-overlay__content--relative');
    contentElement.parentElement.classList.add('igx-overlay__wrapper--flex-container');
    this.setPosition(contentElement);
  }
}

/**
 * Positions the element as in **Connected** positioning strategy and resize the element
 * to fit in the view port in case the element is partially getting out of view
 */
class ElasticPositionStrategy extends BaseFitPositionStrategy {
  /**
   * Fits the element into viewport according to the position settings
   *
   * @param element element to fit in viewport
   * @param connectedFit connectedFit object containing all necessary parameters
   */
  fitInViewport(element, connectedFit) {
    element.classList.add('igx-overlay__content--elastic');
    const transformString = [];
    if (connectedFit.fitHorizontal.back < 0 || connectedFit.fitHorizontal.forward < 0) {
      const maxReduction = Math.max(0, connectedFit.contentElementRect.width - this.settings.minSize.width);
      const leftExtend = Math.max(0, -connectedFit.fitHorizontal.back);
      const rightExtend = Math.max(0, -connectedFit.fitHorizontal.forward);
      const reduction = Math.min(maxReduction, leftExtend + rightExtend);
      element.style.width = `${connectedFit.contentElementRect.width - reduction}px`;
      //  if direction is center and element goes off the screen in left direction we should push the
      //  element to the right. Prevents left still going out of view when normally positioned
      if (this.settings.horizontalDirection === HorizontalAlignment.Center) {
        //  the amount of translation depends on whether element goes off the screen to the left,
        //  to the right or in both directions, as well as how much it goes of the screen and finally
        //  on the minSize. The translation should be proportional between left and right extend
        //  taken from the reduction
        const translation = leftExtend * reduction / (leftExtend + rightExtend);
        if (translation > 0) {
          transformString.push(`translateX(${translation}px)`);
        }
      }
    }
    if (connectedFit.fitVertical.back < 0 || connectedFit.fitVertical.forward < 0) {
      const maxReduction = Math.max(0, connectedFit.contentElementRect.height - this.settings.minSize.height);
      const topExtend = Math.max(0, -connectedFit.fitVertical.back);
      const bottomExtend = Math.max(0, -connectedFit.fitVertical.forward);
      const reduction = Math.min(maxReduction, topExtend + bottomExtend);
      element.style.height = `${connectedFit.contentElementRect.height - reduction}px`;
      //  if direction is middle and element goes off the screen in top direction we should push the
      //  element to the bottom. Prevents top still going out of view when normally positioned
      if (this.settings.verticalDirection === VerticalAlignment.Middle) {
        //  the amount of translation depends on whether element goes off the screen to the top,
        //  to the bottom or in both directions, as well as how much it goes of the screen and finally
        //  on the minSize. The translation should be proportional between top and bottom extend
        //  taken from the reduction
        const translation = topExtend * reduction / (topExtend + bottomExtend);
        if (translation > 0) {
          transformString.push(`translateY(${translation}px)`);
        }
      }
    }
    element.style.transform = transformString.join(' ').trim();
  }
}
class ScrollStrategy {
  constructor() {}
}

/**
 * Empty scroll strategy. Does nothing.
 */
class NoOpScrollStrategy extends ScrollStrategy {
  constructor() {
    super();
  }
  /**
   * Initializes the strategy. Should be called once
   */
  initialize() {}
  /**
   * Detaches the strategy
   * ```typescript
   * settings.scrollStrategy.detach();
   * ```
   */
  attach() {}
  /**
   * Detaches the strategy
   * ```typescript
   * settings.scrollStrategy.detach();
   * ```
   */
  detach() {}
}

/**
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/overlay-main)
 * The overlay service allows users to show components on overlay div above all other elements in the page.
 */
let IgxOverlayService = /*#__PURE__*/(() => {
  class IgxOverlayService {
    constructor(_appRef, document, _zone, platformUtil, animationService) {
      this._appRef = _appRef;
      this.document = document;
      this._zone = _zone;
      this.platformUtil = platformUtil;
      this.animationService = animationService;
      /**
       * Emitted just before the overlay content starts to open.
       * ```typescript
       * opening(event: OverlayCancelableEventArgs){
       *     const opening = event;
       * }
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emitted after the overlay content is opened and all animations are finished.
       * ```typescript
       * opened(event: OverlayEventArgs){
       *     const opened = event;
       * }
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emitted just before the overlay content starts to close.
       * ```typescript
       * closing(event: OverlayCancelableEventArgs){
       *     const closing = event;
       * }
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emitted after the overlay content is closed and all animations are finished.
       * ```typescript
       * closed(event: OverlayEventArgs){
       *     const closed = event;
       * }
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * Emitted before the content is appended to the overlay.
       * ```typescript
       * contentAppending(event: OverlayEventArgs){
       *     const contentAppending = event;
       * }
       * ```
       */
      this.contentAppending = new EventEmitter();
      /**
       * Emitted after the content is appended to the overlay, and before animations are started.
       * ```typescript
       * contentAppended(event: OverlayEventArgs){
       *     const contentAppended = event;
       * }
       * ```
       */
      this.contentAppended = new EventEmitter();
      /**
       * Emitted just before the overlay animation start.
       * ```typescript
       * animationStarting(event: OverlayAnimationEventArgs){
       *     const animationStarting = event;
       * }
       * ```
       */
      this.animationStarting = new EventEmitter();
      this._componentId = 0;
      this._overlayInfos = [];
      this.destroy$ = new Subject();
      this._cursorStyleIsSet = false;
      this._defaultSettings = {
        excludeFromOutsideClick: [],
        positionStrategy: new GlobalPositionStrategy(),
        scrollStrategy: new NoOpScrollStrategy(),
        modal: true,
        closeOnOutsideClick: true,
        closeOnEscape: false
      };
      /** @hidden */
      this.repositionAll = () => {
        for (let i = this._overlayInfos.length; i--;) {
          this.reposition(this._overlayInfos[i].id);
        }
      };
      this.documentClicked = ev => {
        //  if we get to modal overlay just return - we should not close anything under it
        //  if we get to non-modal overlay do the next:
        //   1. Check it has close on outside click. If not go on to next overlay;
        //   2. If true check if click is on the element. If it is on the element we have closed
        //  already all previous non-modal with close on outside click elements, so we return. If
        //  not close the overlay and check next
        for (let i = this._overlayInfos.length; i--;) {
          const info = this._overlayInfos[i];
          if (info.settings.modal) {
            return;
          }
          if (info.settings.closeOnOutsideClick) {
            const target = ev.composed ? ev.composedPath()[0] : ev.target;
            const overlayElement = info.elementRef.nativeElement;
            // check if the click is on the overlay element or on an element from the exclusion list, and if so do not close the overlay
            const excludeElements = info.settings.excludeFromOutsideClick ? [...info.settings.excludeFromOutsideClick, overlayElement] : [overlayElement];
            const isInsideClick = excludeElements.some(e => e.contains(target));
            if (isInsideClick) {
              return;
              //  if the click is outside click, but close animation has started do nothing
            } else if (!info.closeAnimationPlayer?.hasStarted()) {
              this._hide(info.id, ev);
            }
          }
        }
      };
      this._document = this.document;
    }
    /**
     * Creates overlay settings with global or container position strategy and preset position settings
     *
     * @param position Preset position settings. Default position is 'center'
     * @param outlet The outlet container to attach the overlay to
     * @returns Non-modal overlay settings based on Global or Container position strategy and the provided position.
     */
    static createAbsoluteOverlaySettings(position, outlet) {
      const positionSettings = this.createAbsolutePositionSettings(position);
      const strategy = outlet ? new ContainerPositionStrategy(positionSettings) : new GlobalPositionStrategy(positionSettings);
      const overlaySettings = {
        positionStrategy: strategy,
        scrollStrategy: new NoOpScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true,
        outlet
      };
      return overlaySettings;
    }
    /**
     * Creates overlay settings with auto, connected or elastic position strategy and preset position settings
     *
     * @param target Attaching target for the component to show
     * @param strategy The relative position strategy to be applied to the overlay settings. Default is Auto positioning strategy.
     * @param position Preset position settings. By default the element is positioned below the target, left aligned.
     * @returns Non-modal overlay settings based on the provided target, strategy and position.
     */
    static createRelativeOverlaySettings(target, position, strategy) {
      const positionSettings = this.createRelativePositionSettings(position);
      const overlaySettings = {
        target,
        positionStrategy: this.createPositionStrategy(strategy, positionSettings),
        scrollStrategy: new NoOpScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      return overlaySettings;
    }
    static createAbsolutePositionSettings(position) {
      let positionSettings;
      switch (position) {
        case AbsolutePosition.Bottom:
          positionSettings = {
            horizontalDirection: HorizontalAlignment.Center,
            verticalDirection: VerticalAlignment.Bottom,
            openAnimation: slideInBottom,
            closeAnimation: slideOutBottom
          };
          break;
        case AbsolutePosition.Top:
          positionSettings = {
            horizontalDirection: HorizontalAlignment.Center,
            verticalDirection: VerticalAlignment.Top,
            openAnimation: slideInTop,
            closeAnimation: slideOutTop
          };
          break;
        case AbsolutePosition.Center:
        default:
          positionSettings = {
            horizontalDirection: HorizontalAlignment.Center,
            verticalDirection: VerticalAlignment.Middle,
            openAnimation: fadeIn,
            closeAnimation: fadeOut
          };
      }
      return positionSettings;
    }
    static createRelativePositionSettings(position) {
      let positionSettings;
      switch (position) {
        case RelativePosition.Above:
          positionSettings = {
            horizontalStartPoint: HorizontalAlignment.Center,
            verticalStartPoint: VerticalAlignment.Top,
            horizontalDirection: HorizontalAlignment.Center,
            verticalDirection: VerticalAlignment.Top,
            openAnimation: scaleInVerBottom,
            closeAnimation: scaleOutVerBottom
          };
          break;
        case RelativePosition.Below:
          positionSettings = {
            horizontalStartPoint: HorizontalAlignment.Center,
            verticalStartPoint: VerticalAlignment.Bottom,
            horizontalDirection: HorizontalAlignment.Center,
            verticalDirection: VerticalAlignment.Bottom,
            openAnimation: scaleInVerTop,
            closeAnimation: scaleOutVerTop
          };
          break;
        case RelativePosition.After:
          positionSettings = {
            horizontalStartPoint: HorizontalAlignment.Right,
            verticalStartPoint: VerticalAlignment.Middle,
            horizontalDirection: HorizontalAlignment.Right,
            verticalDirection: VerticalAlignment.Middle,
            openAnimation: scaleInHorLeft,
            closeAnimation: scaleOutHorLeft
          };
          break;
        case RelativePosition.Before:
          positionSettings = {
            horizontalStartPoint: HorizontalAlignment.Left,
            verticalStartPoint: VerticalAlignment.Middle,
            horizontalDirection: HorizontalAlignment.Left,
            verticalDirection: VerticalAlignment.Middle,
            openAnimation: scaleInHorRight,
            closeAnimation: scaleOutHorRight
          };
          break;
        case RelativePosition.Default:
        default:
          positionSettings = {
            horizontalStartPoint: HorizontalAlignment.Left,
            verticalStartPoint: VerticalAlignment.Bottom,
            horizontalDirection: HorizontalAlignment.Right,
            verticalDirection: VerticalAlignment.Bottom,
            openAnimation: scaleInVerTop,
            closeAnimation: scaleOutVerTop
          };
          break;
      }
      return positionSettings;
    }
    static createPositionStrategy(strategy, positionSettings) {
      switch (strategy) {
        case RelativePositionStrategy.Connected:
          return new ConnectedPositioningStrategy(positionSettings);
        case RelativePositionStrategy.Elastic:
          return new ElasticPositionStrategy(positionSettings);
        case RelativePositionStrategy.Auto:
        default:
          return new AutoPositionStrategy(positionSettings);
      }
    }
    attach(componentOrElement, viewContainerRefOrSettings, settings) {
      const info = this.getOverlayInfo(componentOrElement, viewContainerRefOrSettings, settings);
      if (!info) {
        console.warn('Overlay was not able to attach provided component!');
        return null;
      }
      info.id = (this._componentId++).toString();
      info.visible = false;
      // Emit the contentAppending event before appending the content
      const eventArgs = {
        id: info.id,
        elementRef: info.elementRef,
        componentRef: info.componentRef,
        settings: info.settings
      };
      this.contentAppending.emit(eventArgs);
      // Append the content to the overlay
      info.settings = eventArgs.settings;
      this._overlayInfos.push(info);
      info.hook = this.placeElementHook(info.elementRef.nativeElement);
      const elementRect = info.elementRef.nativeElement.getBoundingClientRect();
      info.initialSize = {
        width: elementRect.width,
        height: elementRect.height
      };
      // Get the size before moving the container into the overlay so that it does not forget about inherited styles.
      this.getComponentSize(info);
      this.moveElementToOverlay(info);
      // Update the container size after moving if there is size.
      if (info.size) {
        info.elementRef.nativeElement.parentElement.style.setProperty('--ig-size', info.size);
      }
      this.contentAppended.emit({
        id: info.id,
        componentRef: info.componentRef
      });
      info.settings.scrollStrategy.initialize(this._document, this, info.id);
      info.settings.scrollStrategy.attach();
      this.addOutsideClickListener(info);
      this.addResizeHandler();
      this.addCloseOnEscapeListener(info);
      this.buildAnimationPlayers(info);
      return info.id;
    }
    /**
     * Remove overlay with the provided id.
     *
     * @param id Id of the overlay to remove
     * ```typescript
     * this.overlay.detach(id);
     * ```
     */
    detach(id) {
      const info = this.getOverlayById(id);
      if (!info) {
        console.warn('igxOverlay.detach was called with wrong id: ', id);
        return;
      }
      info.detached = true;
      this.finishAnimations(info);
      info.settings.scrollStrategy.detach();
      this.removeOutsideClickListener(info);
      this.removeResizeHandler();
      this.cleanUp(info);
    }
    /**
     * Remove all the overlays.
     * ```typescript
     * this.overlay.detachAll();
     * ```
     */
    detachAll() {
      for (let i = this._overlayInfos.length; i--;) {
        this.detach(this._overlayInfos[i].id);
      }
    }
    /**
     * Shows the overlay for provided id.
     *
     * @param id Id to show overlay for
     * @param settings Display settings for the overlay, such as positioning and scroll/close behavior.
     */
    show(id, settings) {
      const info = this.getOverlayById(id);
      if (!info) {
        console.warn('igxOverlay.show was called with wrong id: ', id);
        return;
      }
      const eventArgs = {
        id,
        componentRef: info.componentRef,
        cancel: false
      };
      this.opening.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      if (settings) {
        settings.positionStrategy ??= info.settings.positionStrategy;
        settings.scrollStrategy ??= info.settings.scrollStrategy;
        info.settings = {
          ...info.settings,
          ...settings
        };
      }
      this.updateSize(info);
      info.settings.positionStrategy.position(info.elementRef.nativeElement.parentElement, {
        width: info.initialSize.width,
        height: info.initialSize.height
      }, this._document, true, info.settings.target);
      this.addModalClasses(info);
      if (info.settings.positionStrategy.settings.openAnimation) {
        // TODO: should we build players again. This was already done in attach!!!
        // this.buildAnimationPlayers(info);
        this.playOpenAnimation(info);
      } else {
        //  to eliminate flickering show the element just before opened fires
        info.wrapperElement.style.visibility = '';
        info.visible = true;
        this.opened.emit({
          id: info.id,
          componentRef: info.componentRef
        });
      }
    }
    /**
     * Hides the component with the ID provided as a parameter.
     * ```typescript
     * this.overlay.hide(id);
     * ```
     */
    hide(id, event) {
      this._hide(id, event);
    }
    /**
     * Hides all the components and the overlay.
     * ```typescript
     * this.overlay.hideAll();
     * ```
     */
    hideAll() {
      for (let i = this._overlayInfos.length; i--;) {
        this.hide(this._overlayInfos[i].id);
      }
    }
    /**
     * Repositions the component with ID provided as a parameter.
     *
     * @param id Id to reposition overlay for
     * ```typescript
     * this.overlay.reposition(id);
     * ```
     */
    reposition(id) {
      const overlayInfo = this.getOverlayById(id);
      if (!overlayInfo || !overlayInfo.settings) {
        console.warn('Wrong id provided in overlay.reposition method. Id: ', id);
        return;
      }
      if (!overlayInfo.visible) {
        return;
      }
      const contentElement = overlayInfo.elementRef.nativeElement.parentElement;
      const contentElementRect = contentElement.getBoundingClientRect();
      overlayInfo.settings.positionStrategy.position(contentElement, {
        width: contentElementRect.width,
        height: contentElementRect.height
      }, this._document, false, overlayInfo.settings.target);
    }
    /**
     * Offsets the content along the corresponding axis by the provided amount with optional offsetMode that determines whether to add (by default) or set the offset values
     *
     * @param id Id to offset overlay for
     * @param deltaX Amount of offset in horizontal direction
     * @param deltaY Amount of offset in vertical direction
     * @param offsetMode Determines whether to add (by default) or set the offset values with OffsetMode.Add and OffsetMode.Set
     * ```typescript
     * this.overlay.setOffset(id, deltaX, deltaY, offsetMode);
     * ```
     */
    setOffset(id, deltaX, deltaY, offsetMode) {
      const info = this.getOverlayById(id);
      if (!info) {
        return;
      }
      switch (offsetMode) {
        case OffsetMode.Set:
          info.transformX = deltaX;
          info.transformY = deltaY;
          break;
        case OffsetMode.Add:
        default:
          info.transformX += deltaX;
          info.transformY += deltaY;
          break;
      }
      const transformX = info.transformX;
      const transformY = info.transformY;
      const translate = `translate(${transformX}px, ${transformY}px)`;
      info.elementRef.nativeElement.parentElement.style.transform = translate;
    }
    /** @hidden */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /** @hidden @internal */
    getOverlayById(id) {
      if (!id) {
        return null;
      }
      const info = this._overlayInfos.find(e => e.id === id);
      return info;
    }
    _hide(id, event) {
      const info = this.getOverlayById(id);
      if (!info) {
        console.warn('igxOverlay.hide was called with wrong id: ', id);
        return;
      }
      const eventArgs = {
        id,
        componentRef: info.componentRef,
        cancel: false,
        event
      };
      this.closing.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.removeModalClasses(info);
      if (info.settings.positionStrategy.settings.closeAnimation) {
        this.playCloseAnimation(info, event);
      } else {
        this.closeDone(info);
      }
    }
    /**
     * Creates overlayInfo. Sets the info's `elementRef`, `componentRef`and `settings`. Also
     * initialize info's `ngZone`, `transformX` and `transformY`.
     * @param component ElementRef or Type. If type is provided dynamic component will be created
     * @param viewContainerRefOrSettings (optional): If ElementRef is provided for `component` this
     * parameter is OverlaySettings. Otherwise it could be ViewContainerRef or OverlayCreateSettings and will be
     * used when dynamic component is created.
     * @param settings (optional): OverlaySettings when `ViewContainerRef` is provided.
     * @returns OverlayInfo
     */
    getOverlayInfo(component, viewContainerRefOrSettings, settings) {
      const info = {
        ngZone: this._zone,
        transformX: 0,
        transformY: 0
      };
      let overlaySettings = settings;
      if (component instanceof ElementRef) {
        info.elementRef = component;
        overlaySettings = viewContainerRefOrSettings;
      } else {
        let dynamicComponent;
        if (viewContainerRefOrSettings instanceof ViewContainerRef) {
          const viewContainerRef = viewContainerRefOrSettings;
          dynamicComponent = viewContainerRef.createComponent(component);
        } else {
          const environmentInjector = this._appRef.injector;
          const createSettings = viewContainerRefOrSettings;
          let elementInjector;
          if (createSettings) {
            ({
              injector: elementInjector,
              ...overlaySettings
            } = createSettings);
          }
          dynamicComponent = createComponent(component, {
            environmentInjector,
            elementInjector
          });
          this._appRef.attachView(dynamicComponent.hostView);
        }
        if (dynamicComponent.onDestroy) {
          dynamicComponent.onDestroy(() => {
            if (!info.detached && this._overlayInfos.indexOf(info) !== -1) {
              this.detach(info.id);
            }
          });
        }
        // If the element is newly created from a Component, it is wrapped in 'ng-component' tag - we do not want that.
        const element = dynamicComponent.location.nativeElement;
        info.elementRef = {
          nativeElement: element
        };
        info.componentRef = dynamicComponent;
      }
      info.settings = Object.assign({}, this._defaultSettings, overlaySettings);
      return info;
    }
    placeElementHook(element) {
      if (!element.parentElement) {
        return null;
      }
      const hook = this._document.createElement('div');
      hook.style.display = 'none';
      element.parentElement.insertBefore(hook, element);
      return hook;
    }
    moveElementToOverlay(info) {
      info.wrapperElement = this.getWrapperElement();
      const contentElement = this.getContentElement(info.wrapperElement, info.settings.modal);
      this.getOverlayElement(info).appendChild(info.wrapperElement);
      contentElement.appendChild(info.elementRef.nativeElement);
    }
    getWrapperElement() {
      const wrapper = this._document.createElement('div');
      wrapper.classList.add('igx-overlay__wrapper');
      return wrapper;
    }
    getContentElement(wrapperElement, modal) {
      const content = this._document.createElement('div');
      if (modal) {
        content.classList.add('igx-overlay__content--modal');
        content.addEventListener('click', ev => {
          ev.stopPropagation();
        });
      } else {
        content.classList.add('igx-overlay__content');
      }
      content.addEventListener('scroll', ev => {
        ev.stopPropagation();
      });
      //  hide element to eliminate flickering. Show the element exactly before animation starts
      wrapperElement.style.visibility = 'hidden';
      wrapperElement.appendChild(content);
      return content;
    }
    getOverlayElement(info) {
      if (info.settings.outlet) {
        return info.settings.outlet.nativeElement || info.settings.outlet;
      }
      if (!this._overlayElement) {
        this._overlayElement = this._document.createElement('div');
        this._overlayElement.classList.add('igx-overlay');
        this._document.body.appendChild(this._overlayElement);
      }
      return this._overlayElement;
    }
    updateSize(info) {
      if (info.componentRef) {
        //  if we are positioning component this is first time it gets visible
        //  and we can finally get its size
        info.componentRef.changeDetectorRef.detectChanges();
        info.initialSize = info.elementRef.nativeElement.getBoundingClientRect();
      }
      // set content div width only if element to show has width
      if (info.initialSize.width !== 0) {
        info.elementRef.nativeElement.parentElement.style.width = info.initialSize.width + 'px';
      }
    }
    closeDone(info) {
      info.visible = false;
      if (info.wrapperElement) {
        // to eliminate flickering show the element just before animation start
        info.wrapperElement.style.visibility = 'hidden';
      }
      if (!info.closeAnimationDetaching) {
        this.closed.emit({
          id: info.id,
          componentRef: info.componentRef,
          event: info.event
        });
      }
      delete info.event;
    }
    cleanUp(info) {
      const child = info.elementRef.nativeElement;
      const outlet = this.getOverlayElement(info);
      // if same element is shown in other overlay outlet will not contain
      // the element and we should not remove it form outlet
      if (outlet.contains(child)) {
        outlet.removeChild(child.parentNode.parentNode);
      }
      if (info.componentRef) {
        this._appRef.detachView(info.componentRef.hostView);
        info.componentRef.destroy();
        delete info.componentRef;
      }
      if (info.hook) {
        info.hook.parentElement.insertBefore(info.elementRef.nativeElement, info.hook);
        info.hook.parentElement.removeChild(info.hook);
        delete info.hook;
      }
      const index = this._overlayInfos.indexOf(info);
      this._overlayInfos.splice(index, 1);
      // this._overlayElement.parentElement check just for tests that manually delete the element
      if (this._overlayInfos.length === 0) {
        if (this._overlayElement && this._overlayElement.parentElement) {
          this._overlayElement.parentElement.removeChild(this._overlayElement);
          this._overlayElement = null;
        }
        this.removeCloseOnEscapeListener();
      }
      // clean all the resources attached to info
      delete info.elementRef;
      delete info.settings;
      delete info.initialSize;
      info.openAnimationDetaching = true;
      info.openAnimationPlayer?.destroy();
      delete info.openAnimationPlayer;
      info.closeAnimationDetaching = true;
      info.closeAnimationPlayer?.destroy();
      delete info.closeAnimationPlayer;
      delete info.ngZone;
      delete info.wrapperElement;
      info = null;
    }
    playOpenAnimation(info) {
      //  if there is opening animation already started do nothing
      if (info.openAnimationPlayer?.hasStarted()) {
        return;
      }
      if (info.closeAnimationPlayer?.hasStarted()) {
        const position = info.closeAnimationPlayer.position;
        info.closeAnimationPlayer.reset();
        info.openAnimationPlayer.init();
        info.openAnimationPlayer.position = 1 - position;
      }
      this.animationStarting.emit({
        id: info.id,
        animationPlayer: info.openAnimationPlayer,
        animationType: 'open'
      });
      //  to eliminate flickering show the element just before animation start
      info.wrapperElement.style.visibility = '';
      info.visible = true;
      info.openAnimationPlayer.play();
    }
    playCloseAnimation(info, event) {
      //  if there is closing animation already started do nothing
      if (info.closeAnimationPlayer?.hasStarted()) {
        return;
      }
      if (info.openAnimationPlayer?.hasStarted()) {
        const position = info.openAnimationPlayer.position;
        info.openAnimationPlayer.reset();
        info.closeAnimationPlayer.init();
        info.closeAnimationPlayer.position = 1 - position;
      }
      this.animationStarting.emit({
        id: info.id,
        animationPlayer: info.closeAnimationPlayer,
        animationType: 'close'
      });
      info.event = event;
      info.closeAnimationPlayer.play();
    }
    //  TODO: check if applyAnimationParams will work with complex animations
    applyAnimationParams(wrapperElement, animationOptions) {
      if (!animationOptions) {
        wrapperElement.style.transitionDuration = '0ms';
        return;
      }
      if (!animationOptions.options || !animationOptions.options.params) {
        return;
      }
      const params = animationOptions.options.params;
      if (params.duration) {
        wrapperElement.style.transitionDuration = params.duration;
      }
      if (params.easing) {
        wrapperElement.style.transitionTimingFunction = params.easing;
      }
    }
    addOutsideClickListener(info) {
      if (info.settings.closeOnOutsideClick) {
        if (info.settings.modal) {
          fromEvent(info.elementRef.nativeElement.parentElement.parentElement, 'click').pipe(takeUntil(this.destroy$)).subscribe(e => this._hide(info.id, e));
        } else if (
        //  if all overlays minus closing overlays equals one add the handler
        this._overlayInfos.filter(x => x.settings.closeOnOutsideClick && !x.settings.modal).length - this._overlayInfos.filter(x => x.settings.closeOnOutsideClick && !x.settings.modal && x.closeAnimationPlayer?.hasStarted()).length === 1) {
          // click event is not fired on iOS. To make element "clickable" we are
          // setting the cursor to pointer
          if (this.platformUtil.isIOS && !this._cursorStyleIsSet) {
            this._cursorOriginalValue = this._document.body.style.cursor;
            this._document.body.style.cursor = 'pointer';
            this._cursorStyleIsSet = true;
          }
          this._document.addEventListener('click', this.documentClicked, true);
        }
      }
    }
    removeOutsideClickListener(info) {
      if (info.settings.modal === false) {
        let shouldRemoveClickEventListener = true;
        this._overlayInfos.forEach(o => {
          if (o.settings.modal === false && o.id !== info.id) {
            shouldRemoveClickEventListener = false;
          }
        });
        if (shouldRemoveClickEventListener) {
          if (this._cursorStyleIsSet) {
            this._document.body.style.cursor = this._cursorOriginalValue;
            this._cursorOriginalValue = '';
            this._cursorStyleIsSet = false;
          }
          this._document.removeEventListener('click', this.documentClicked, true);
        }
      }
    }
    addResizeHandler() {
      const closingOverlaysCount = this._overlayInfos.filter(o => o.closeAnimationPlayer?.hasStarted()).length;
      if (this._overlayInfos.length - closingOverlaysCount === 1) {
        this._document.defaultView.addEventListener('resize', this.repositionAll);
      }
    }
    removeResizeHandler() {
      const closingOverlaysCount = this._overlayInfos.filter(o => o.closeAnimationPlayer?.hasStarted()).length;
      if (this._overlayInfos.length - closingOverlaysCount === 1) {
        this._document.defaultView.removeEventListener('resize', this.repositionAll);
      }
    }
    addCloseOnEscapeListener(info) {
      if (info.settings.closeOnEscape && !this._keyPressEventListener) {
        this._keyPressEventListener = fromEvent(this._document, 'keydown').pipe(filter(ev => ev.key === 'Escape' || ev.key === 'Esc')).subscribe(ev => {
          const visibleOverlays = this._overlayInfos.filter(o => o.visible);
          if (visibleOverlays.length < 1) {
            return;
          }
          const targetOverlayInfo = visibleOverlays[visibleOverlays.length - 1];
          if (targetOverlayInfo.visible && targetOverlayInfo.settings.closeOnEscape) {
            this.hide(targetOverlayInfo.id, ev);
          }
        });
      }
    }
    removeCloseOnEscapeListener() {
      if (this._keyPressEventListener) {
        this._keyPressEventListener.unsubscribe();
        this._keyPressEventListener = null;
      }
    }
    addModalClasses(info) {
      if (info.settings.modal) {
        const wrapperElement = info.elementRef.nativeElement.parentElement.parentElement;
        wrapperElement.classList.remove('igx-overlay__wrapper');
        this.applyAnimationParams(wrapperElement, info.settings.positionStrategy.settings.openAnimation);
        requestAnimationFrame(() => {
          wrapperElement.classList.add('igx-overlay__wrapper--modal');
        });
      }
    }
    removeModalClasses(info) {
      if (info.settings.modal) {
        const wrapperElement = info.elementRef.nativeElement.parentElement.parentElement;
        this.applyAnimationParams(wrapperElement, info.settings.positionStrategy.settings.closeAnimation);
        wrapperElement.classList.remove('igx-overlay__wrapper--modal');
        wrapperElement.classList.add('igx-overlay__wrapper');
      }
    }
    buildAnimationPlayers(info) {
      if (info.settings.positionStrategy.settings.openAnimation) {
        info.openAnimationPlayer = this.animationService.buildAnimation(info.settings.positionStrategy.settings.openAnimation, info.elementRef.nativeElement);
        info.openAnimationPlayer.animationEnd.pipe(takeUntil(this.destroy$)).subscribe(() => this.openAnimationDone(info));
      }
      if (info.settings.positionStrategy.settings.closeAnimation) {
        info.closeAnimationPlayer = this.animationService.buildAnimation(info.settings.positionStrategy.settings.closeAnimation, info.elementRef.nativeElement);
        info.closeAnimationPlayer.animationEnd.pipe(takeUntil(this.destroy$)).subscribe(() => this.closeAnimationDone(info));
      }
    }
    openAnimationDone(info) {
      if (!info.openAnimationDetaching) {
        this.opened.emit({
          id: info.id,
          componentRef: info.componentRef
        });
      }
      if (info.openAnimationPlayer) {
        info.openAnimationPlayer.reset();
      }
      if (info.closeAnimationPlayer?.hasStarted()) {
        info.closeAnimationPlayer.reset();
      }
    }
    closeAnimationDone(info) {
      if (info.closeAnimationPlayer) {
        info.closeAnimationPlayer.reset();
      }
      if (info.openAnimationPlayer?.hasStarted()) {
        info.openAnimationPlayer.reset();
      }
      this.closeDone(info);
    }
    finishAnimations(info) {
      // // TODO: should we emit here opened or closed events
      if (info.openAnimationPlayer?.hasStarted()) {
        info.openAnimationPlayer.finish();
      }
      if (info.closeAnimationPlayer?.hasStarted()) {
        info.closeAnimationPlayer.finish();
      }
    }
    getComponentSize(info) {
      if (info.elementRef?.nativeElement instanceof Element) {
        const styles = this._document.defaultView.getComputedStyle(info.elementRef.nativeElement);
        const componentSize = styles.getPropertyValue('--component-size');
        const globalSize = styles.getPropertyValue('--ig-size');
        const size = componentSize || globalSize;
        info.size = size;
      }
    }
    static {
      this.ɵfac = function IgxOverlayService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxOverlayService)(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(PlatformUtil), i0.ɵɵinject(IgxAngularAnimationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxOverlayService,
        factory: IgxOverlayService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxOverlayService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Export position strategies

/**
 * On scroll reposition the overlay content.
 */
class AbsoluteScrollStrategy extends ScrollStrategy {
  constructor(scrollContainer) {
    super();
    this._initialized = false;
    this.onScroll = e => {
      const overlayInfo = this._overlayService.getOverlayById(this._id);
      if (!overlayInfo) {
        return;
      }
      if (!overlayInfo.elementRef.nativeElement.contains(e.target)) {
        this._overlayService.reposition(this._id);
      }
    };
    this._scrollContainer = scrollContainer;
  }
  /**
   * Initializes the strategy. Should be called once
   *
   * @param document reference to Document object.
   * @param overlayService IgxOverlay service to use in this strategy.
   * @param id Unique id for this strategy.
   * ```typescript
   * settings.scrollStrategy.initialize(document, overlay, id);
   * ```
   */
  initialize(document, overlayService, id) {
    if (this._initialized) {
      return;
    }
    this._overlayService = overlayService;
    this._id = id;
    this._document = document;
    this._zone = overlayService.getOverlayById(id).ngZone;
    this._initialized = true;
  }
  /**
   * Attaches the strategy
   * ```typescript
   * settings.scrollStrategy.attach();
   * ```
   */
  attach() {
    if (this._zone) {
      this._zone.runOutsideAngular(() => {
        this.addScrollEventListener();
      });
    } else {
      this.addScrollEventListener();
    }
  }
  /**
   * Detaches the strategy
   * ```typescript
   * settings.scrollStrategy.detach();
   * ```
   */
  detach() {
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.onScroll, true);
    } else {
      // Tired of this thing throwing every other time. Fix it ffs!
      this._document?.removeEventListener('scroll', this.onScroll, true);
    }
    this._initialized = false;
  }
  addScrollEventListener() {
    if (this._scrollContainer) {
      this._scrollContainer.addEventListener('scroll', this.onScroll, true);
    } else {
      this._document.addEventListener('scroll', this.onScroll, true);
    }
  }
}

/**
 * Prevents scrolling while the overlay content is shown.
 */
class BlockScrollStrategy extends ScrollStrategy {
  constructor() {
    super();
    this._initialized = false;
    this.onScroll = ev => {
      ev.preventDefault();
      if (!this._sourceElement || this._sourceElement !== ev.target) {
        this._sourceElement = ev.target;
        this._initialScrollTop = this._sourceElement.scrollTop;
        this._initialScrollLeft = this._sourceElement.scrollLeft;
      }
      this._sourceElement.scrollTop = this._initialScrollTop;
      this._sourceElement.scrollLeft = this._initialScrollLeft;
    };
  }
  /**
   * Initializes the strategy. Should be called once
   *
   */
  initialize(document) {
    if (this._initialized) {
      return;
    }
    this._document = document;
    this._initialized = true;
  }
  /**
   * Attaches the strategy
   * ```typescript
   * settings.scrollStrategy.attach();
   * ```
   */
  attach() {
    this._document.addEventListener('scroll', this.onScroll, true);
  }
  /**
   * Detaches the strategy
   * ```typescript
   * settings.scrollStrategy.detach();
   * ```
   */
  detach() {
    this._document.removeEventListener('scroll', this.onScroll, true);
    this._sourceElement = null;
    this._initialScrollTop = 0;
    this._initialScrollLeft = 0;
    this._initialized = false;
  }
}

/**
 * Uses a tolerance and closes the shown component upon scrolling if the tolerance is exceeded
 */
class CloseScrollStrategy extends ScrollStrategy {
  constructor(scrollContainer) {
    super();
    this._initialized = false;
    this.onScroll = ev => {
      if (!this._sourceElement) {
        this._sourceElement = ev.target;
        this.initialScrollTop = this._sourceElement.scrollTop;
        this.initialScrollLeft = this._sourceElement.scrollLeft;
      }
      if (this._overlayInfo.elementRef.nativeElement.contains(this._sourceElement)) {
        return;
      }
      if (Math.abs(this._sourceElement.scrollTop - this.initialScrollTop) > this._threshold || Math.abs(this._sourceElement.scrollLeft - this.initialScrollLeft) > this._threshold) {
        this._overlayService.hide(this._id);
      }
    };
    this._scrollContainer = scrollContainer;
    this._threshold = 10;
  }
  /**
   * Initializes the strategy. Should be called once
   *
   * @param document reference to Document object.
   * @param overlayService IgxOverlay service to use in this strategy.
   * @param id Unique id for this strategy.
   * ```typescript
   * settings.scrollStrategy.initialize(document, overlay, id);
   * ```
   */
  initialize(document, overlayService, id) {
    if (this._initialized) {
      return;
    }
    this._overlayService = overlayService;
    this._id = id;
    this._document = document;
    this._initialized = true;
    this._overlayInfo = overlayService.getOverlayById(id);
  }
  /**
   * Attaches the strategy
   * ```typescript
   * settings.scrollStrategy.attach();
   * ```
   */
  attach() {
    if (this._scrollContainer) {
      this._scrollContainer.addEventListener('scroll', this.onScroll);
      this._sourceElement = this._scrollContainer;
    } else {
      this._document.addEventListener('scroll', this.onScroll, true);
    }
  }
  /**
   * Detaches the strategy
   * ```typescript
   * settings.scrollStrategy.detach();
   * ```
   */
  detach() {
    // TODO: check why event listener removes only on first call and remains on each next!!!
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.onScroll);
    } else {
      this._document.removeEventListener('scroll', this.onScroll, true);
    }
    this._sourceElement = null;
    this._initialized = false;
  }
}

// Export scroll strategies

class IgxBaseTransactionService {
  constructor() {
    /**
     * Event fired when transaction state has changed - add transaction, commit all transactions, undo and redo
     */
    this.onStateUpdate = new EventEmitter();
    this._isPending = false;
    this._pendingTransactions = [];
    this._pendingStates = new Map();
    this._cloneStrategy = new DefaultDataCloneStrategy();
  }
  /**
   * Gets/Sets the data clone strategy used to clone data
   */
  get cloneStrategy() {
    return this._cloneStrategy;
  }
  set cloneStrategy(strategy) {
    if (strategy) {
      this._cloneStrategy = strategy;
    }
  }
  /**
   * @returns if there are any transactions in the Redo stack
   */
  get canRedo() {
    return false;
  }
  /**
   * @returns if there are any transactions in the Undo stack
   */
  get canUndo() {
    return false;
  }
  /**
   * Returns whether transaction is enabled for this service
   */
  get enabled() {
    return this._isPending;
  }
  /**
   * Adds provided  transaction with recordRef if any
   *
   * @param transaction Transaction to be added
   * @param recordRef Reference to the value of the record in the data source related to the changed item
   */
  add(transaction, recordRef) {
    if (this._isPending) {
      this.updateState(this._pendingStates, transaction, recordRef);
      this._pendingTransactions.push(transaction);
    }
  }
  /**
   * Returns all recorded transactions in chronological order
   *
   * @param id Optional record id to get transactions for
   * @returns All transaction in the service or for the specified record
   */
  getTransactionLog(_id) {
    return [];
  }
  /**
   * Remove the last transaction if any
   */
  undo() {}
  /**
   * Applies the last undone transaction if any
   */
  redo() {}
  /**
   * Returns aggregated changes from all transactions
   *
   * @param mergeChanges If set to true will merge each state's value over relate recordRef
   * and will record resulting value in the related transaction
   * @returns Collection of aggregated transactions for each changed record
   */
  getAggregatedChanges(mergeChanges) {
    const result = [];
    this._pendingStates.forEach((state, key) => {
      const value = mergeChanges ? this.getAggregatedValue(key, mergeChanges) : state.value;
      result.push({
        id: key,
        newValue: value,
        type: state.type
      });
    });
    return result;
  }
  /**
   * Returns the state of the record with provided id
   *
   * @param id The id of the record
   * @param pending Should get pending state
   * @returns State of the record if any
   */
  getState(id) {
    return this._pendingStates.get(id);
  }
  /**
   * Returns value of the required id including all uncommitted changes
   *
   * @param id The id of the record to return value for
   * @param mergeChanges If set to true will merge state's value over relate recordRef
   * and will return merged value
   * @returns Value with changes or **null**
   */
  getAggregatedValue(id, mergeChanges) {
    const state = this._pendingStates.get(id);
    if (!state) {
      return null;
    }
    if (mergeChanges && state.recordRef) {
      return this.updateValue(state);
    }
    return state.value;
  }
  /**
   * Applies all transactions over the provided data
   *
   * @param data Data source to update
   * @param id Optional record id to commit transactions for
   */
  commit(_data, _id) {}
  /**
   * Clears all transactions
   *
   * @param id Optional record id to clear transactions for
   */
  clear(_id) {
    this._pendingStates.clear();
    this._pendingTransactions = [];
  }
  /**
   * Starts pending transactions. All transactions passed after call to startPending
   * will not be added to transaction log
   */
  startPending() {
    this._isPending = true;
  }
  /**
   * Clears all pending transactions and aggregated pending state. If commit is set to true
   * commits pending states as single transaction
   *
   * @param commit Should commit the pending states
   */
  endPending(_commit) {
    this._isPending = false;
    this._pendingStates.clear();
    this._pendingTransactions = [];
  }
  /**
   * Updates the provided states collection according to passed transaction and recordRef
   *
   * @param states States collection to apply the update to
   * @param transaction Transaction to apply to the current state
   * @param recordRef Reference to the value of the record in data source, if any, where transaction should be applied
   */
  updateState(states, transaction, recordRef) {
    let state = states.get(transaction.id);
    if (state) {
      if (isObject(state.value)) {
        mergeObjects(state.value, transaction.newValue);
      } else {
        state.value = transaction.newValue;
      }
    } else {
      state = {
        value: this.cloneStrategy.clone(transaction.newValue),
        recordRef,
        type: transaction.type
      };
      states.set(transaction.id, state);
    }
    this.cleanState(transaction.id, states);
  }
  /**
   * Updates the recordRef of the provided state with all the changes in the state. Accepts primitive and object value types
   *
   * @param state State to update value for
   * @returns updated value including all the changes in provided state
   */
  updateValue(state) {
    return this.mergeValues(state.recordRef, state.value);
  }
  /**
   * Merges second values in first value and the result in empty object. If values are primitive type
   * returns second value if exists, or first value.
   *
   * @param first Value to merge into
   * @param second Value to merge
   */
  mergeValues(first, second) {
    if (isObject(first) || isObject(second)) {
      return mergeObjects(this.cloneStrategy.clone(first), second);
    } else {
      return second ? second : first;
    }
  }
  /**
   * Compares the state with recordRef and clears all duplicated values. If any state ends as
   * empty object removes it from states.
   *
   * @param state State to clean
   */
  cleanState(id, states) {
    const state = states.get(id);
    //  do nothing if
    //  there is no state, or
    //  there is no state value (e.g. DELETED transaction), or
    //  there is no recordRef (e.g. ADDED transaction)
    if (state && state.value && state.recordRef) {
      //  if state's value is object compare each key with the ones in recordRef
      //  if values in any key are the same delete it from state's value
      //  if state's value is not object, simply compare with recordRef and remove
      //  the state if they are equal
      if (isObject(state.recordRef)) {
        for (const key of Object.keys(state.value)) {
          if (JSON.stringify(state.recordRef[key]) === JSON.stringify(state.value[key])) {
            delete state.value[key];
          }
        }
        //  if state's value is empty remove the state from the states, only if state is not DELETE type
        if (state.type !== TransactionType.DELETE && Object.keys(state.value).length === 0) {
          states.delete(id);
        }
      } else {
        if (state.recordRef === state.value) {
          states.delete(id);
        }
      }
    }
  }
}
class IgxTransactionService extends IgxBaseTransactionService {
  constructor() {
    super(...arguments);
    this._transactions = [];
    this._redoStack = [];
    this._undoStack = [];
    this._states = new Map();
  }
  /**
   * @returns if there are any transactions in the Undo stack
   */
  get canUndo() {
    return this._undoStack.length > 0;
  }
  /**
   * @returns if there are any transactions in the Redo stack
   */
  get canRedo() {
    return this._redoStack.length > 0;
  }
  /**
   * Adds provided  transaction with recordRef if any
   *
   * @param transaction Transaction to be added
   * @param recordRef Reference to the value of the record in the data source related to the changed item
   */
  add(transaction, recordRef) {
    const states = this._isPending ? this._pendingStates : this._states;
    this.verifyAddedTransaction(states, transaction, recordRef);
    this.addTransaction(transaction, states, recordRef);
  }
  /**
   * Returns all recorded transactions in chronological order
   *
   * @param id Optional record id to get transactions for
   * @returns All transaction in the service or for the specified record
   */
  getTransactionLog(id) {
    if (id !== undefined) {
      return this._transactions.filter(t => t.id === id);
    }
    return [...this._transactions];
  }
  /**
   * Returns aggregated changes from all transactions
   *
   * @param mergeChanges If set to true will merge each state's value over relate recordRef
   * and will record resulting value in the related transaction
   * @returns Collection of aggregated transactions for each changed record
   */
  getAggregatedChanges(mergeChanges) {
    const result = [];
    this._states.forEach((state, key) => {
      const value = mergeChanges ? this.mergeValues(state.recordRef, state.value) : state.value;
      result.push({
        id: key,
        newValue: value,
        type: state.type
      });
    });
    return result;
  }
  /**
   * Returns the state of the record with provided id
   *
   * @param id The id of the record
   * @param pending Should get pending state
   * @returns State of the record if any
   */
  getState(id, pending = false) {
    return pending ? this._pendingStates.get(id) : this._states.get(id);
  }
  /**
   * Returns whether transaction is enabled for this service
   */
  get enabled() {
    return true;
  }
  /**
   * Returns value of the required id including all uncommitted changes
   *
   * @param id The id of the record to return value for
   * @param mergeChanges If set to true will merge state's value over relate recordRef
   * and will return merged value
   * @returns Value with changes or **null**
   */
  getAggregatedValue(id, mergeChanges) {
    const state = this._states.get(id);
    const pendingState = super.getState(id);
    //  if there is no state and there is no pending state return null
    if (!state && !pendingState) {
      return null;
    }
    const pendingChange = super.getAggregatedValue(id, false);
    const change = state && state.value;
    let aggregatedValue = this.mergeValues(change, pendingChange);
    if (mergeChanges) {
      const originalValue = state ? state.recordRef : pendingState.recordRef;
      aggregatedValue = this.mergeValues(originalValue, aggregatedValue);
    }
    return aggregatedValue;
  }
  /**
   * Clears all pending transactions and aggregated pending state. If commit is set to true
   * commits pending states as single transaction
   *
   * @param commit Should commit the pending states
   */
  endPending(commit) {
    this._isPending = false;
    if (commit) {
      const actions = [];
      // don't use addTransaction due to custom undo handling
      for (const transaction of this._pendingTransactions) {
        const pendingState = this._pendingStates.get(transaction.id);
        this._transactions.push(transaction);
        this.updateState(this._states, transaction, pendingState.recordRef);
        actions.push({
          transaction,
          recordRef: pendingState.recordRef
        });
      }
      this._undoStack.push(actions);
      this._redoStack = [];
      this.onStateUpdate.emit({
        origin: TransactionEventOrigin.END,
        actions
      });
    }
    super.endPending(commit);
  }
  /**
   * Applies all transactions over the provided data
   *
   * @param data Data source to update
   * @param id Optional record id to commit transactions for
   */
  commit(data, id) {
    if (id !== undefined) {
      const state = this.getState(id);
      if (state) {
        this.updateRecord(data, state);
      }
    } else {
      this._states.forEach(s => {
        this.updateRecord(data, s);
      });
    }
    this.clear(id);
  }
  /**
   * Clears all transactions
   *
   * @param id Optional record id to clear transactions for
   */
  clear(id) {
    if (id !== undefined) {
      this._transactions = this._transactions.filter(t => t.id !== id);
      this._states.delete(id);
      //  Undo stack is an array of actions. Each action is array of transaction like objects
      //  We are going trough all the actions. For each action we are filtering out transactions
      //  with provided id. Finally if any action ends up as empty array we are removing it from
      //  undo stack
      this._undoStack = this._undoStack.map(a => a.filter(t => t.transaction.id !== id)).filter(a => a.length > 0);
    } else {
      this._transactions = [];
      this._states.clear();
      this._undoStack = [];
    }
    this._redoStack = [];
    this.onStateUpdate.emit({
      origin: TransactionEventOrigin.CLEAR,
      actions: []
    });
  }
  /**
   * Remove the last transaction if any
   */
  undo() {
    if (this._undoStack.length <= 0) {
      return;
    }
    const lastActions = this._undoStack.pop();
    this._transactions.splice(this._transactions.length - lastActions.length);
    this._redoStack.push(lastActions);
    this._states.clear();
    for (const currentActions of this._undoStack) {
      for (const transaction of currentActions) {
        this.updateState(this._states, transaction.transaction, transaction.recordRef);
      }
    }
    this.onStateUpdate.emit({
      origin: TransactionEventOrigin.UNDO,
      actions: lastActions
    });
  }
  /**
   * Applies the last undone transaction if any
   */
  redo() {
    if (this._redoStack.length > 0) {
      const actions = this._redoStack.pop();
      for (const action of actions) {
        this.updateState(this._states, action.transaction, action.recordRef);
        this._transactions.push(action.transaction);
      }
      this._undoStack.push(actions);
      this.onStateUpdate.emit({
        origin: TransactionEventOrigin.REDO,
        actions
      });
    }
  }
  addTransaction(transaction, states, recordRef) {
    this.updateState(states, transaction, recordRef);
    const transactions = this._isPending ? this._pendingTransactions : this._transactions;
    transactions.push(transaction);
    if (!this._isPending) {
      const actions = [{
        transaction,
        recordRef
      }];
      this._undoStack.push(actions);
      this._redoStack = [];
      this.onStateUpdate.emit({
        origin: TransactionEventOrigin.ADD,
        actions
      });
    }
  }
  /**
   * Verifies if the passed transaction is correct. If not throws an exception.
   *
   * @param transaction Transaction to be verified
   */
  verifyAddedTransaction(states, transaction, recordRef) {
    const state = states.get(transaction.id);
    switch (transaction.type) {
      case TransactionType.ADD:
        if (state) {
          //  cannot add same item twice
          throw new Error(`Cannot add this transaction. Transaction with id: ${transaction.id} has been already added.`);
        }
        break;
      case TransactionType.DELETE:
      case TransactionType.UPDATE:
        if (state && state.type === TransactionType.DELETE) {
          //  cannot delete or update deleted items
          throw new Error(`Cannot add this transaction. Transaction with id: ${transaction.id} has been already deleted.`);
        }
        if (!state && !recordRef && !this._isPending) {
          //  cannot initially add transaction or delete item with no recordRef
          throw new Error(`Cannot add this transaction. This is first transaction of type ${transaction.type} ` + `for id ${transaction.id}. For first transaction of this type recordRef is mandatory.`);
        }
        break;
    }
  }
  /**
   * Updates the provided states collection according to passed transaction and recordRef
   *
   * @param states States collection to apply the update to
   * @param transaction Transaction to apply to the current state
   * @param recordRef Reference to the value of the record in data source, if any, where transaction should be applied
   */
  updateState(states, transaction, recordRef) {
    let state = states.get(transaction.id);
    //  if TransactionType is ADD simply add transaction to states;
    //  if TransactionType is DELETE:
    //    - if there is state with this id of type ADD remove it from the states;
    //    - if there is state with this id of type UPDATE change its type to DELETE;
    //    - if there is no state with this id add transaction to states;
    //  if TransactionType is UPDATE:
    //    - if there is state with this id of type ADD merge new value and state recordRef into state new value
    //    - if there is state with this id of type UPDATE merge new value into state new value
    //    - if there is state with this id and state type is DELETE change its type to UPDATE
    //    - if there is no state with this id add transaction to states;
    if (state) {
      switch (transaction.type) {
        case TransactionType.DELETE:
          if (state.type === TransactionType.ADD) {
            states.delete(transaction.id);
          } else if (state.type === TransactionType.UPDATE) {
            state.value = transaction.newValue;
            state.type = TransactionType.DELETE;
          }
          break;
        case TransactionType.UPDATE:
          if (isObject(state.value)) {
            if (state.type === TransactionType.ADD) {
              state.value = this.mergeValues(state.value, transaction.newValue);
            }
            if (state.type === TransactionType.UPDATE) {
              mergeObjects(state.value, transaction.newValue);
            }
          } else {
            state.value = transaction.newValue;
          }
      }
    } else {
      state = {
        value: this.cloneStrategy.clone(transaction.newValue),
        recordRef,
        type: transaction.type
      };
      states.set(transaction.id, state);
    }
    this.cleanState(transaction.id, states);
  }
  /**
   * Updates state related record in the provided data
   *
   * @param data Data source to update
   * @param state State to update data from
   */
  updateRecord(data, state) {
    const index = data.findIndex(i => JSON.stringify(i) === JSON.stringify(state.recordRef || {}));
    switch (state.type) {
      case TransactionType.ADD:
        data.push(state.value);
        break;
      case TransactionType.DELETE:
        if (0 <= index && index < data.length) {
          data.splice(index, 1);
        }
        break;
      case TransactionType.UPDATE:
        if (0 <= index && index < data.length) {
          data[index] = this.updateValue(state);
        }
        break;
    }
  }
}

/** @experimental @hidden */
class IgxHierarchicalTransactionService extends IgxTransactionService {
  getAggregatedChanges(mergeChanges) {
    const result = [];
    this._states.forEach((state, key) => {
      const value = mergeChanges ? this.mergeValues(state.recordRef, state.value) : this.cloneStrategy.clone(state.value);
      this.clearArraysFromObject(value);
      result.push({
        id: key,
        path: state.path,
        newValue: value,
        type: state.type
      });
    });
    return result;
  }
  commit(data, primaryKeyOrId, childDataKey, id) {
    if (childDataKey !== undefined) {
      let transactions = this.getAggregatedChanges(true);
      if (id !== undefined) {
        transactions = transactions.filter(t => t.id === id);
      }
      DataUtil.mergeHierarchicalTransactions(data, transactions, childDataKey, primaryKeyOrId, this.cloneStrategy, true);
      this.clear(id);
    } else {
      super.commit(data, primaryKeyOrId);
    }
  }
  updateState(states, transaction, recordRef) {
    super.updateState(states, transaction, recordRef);
    //  if transaction has no path, e.g. flat data source, get out
    if (!transaction.path) {
      return;
    }
    const currentState = states.get(transaction.id);
    if (currentState) {
      currentState.path = transaction.path;
    }
    //  if transaction has path, Hierarchical data source, and it is DELETE
    //  type transaction for all child rows remove ADD states and update
    //  transaction type and value of UPDATE states
    if (transaction.type === TransactionType.DELETE) {
      states.forEach((v, k) => {
        if (v.path && v.path.indexOf(transaction.id) !== -1) {
          switch (v.type) {
            case TransactionType.ADD:
              states.delete(k);
              break;
            case TransactionType.UPDATE:
              states.get(k).type = TransactionType.DELETE;
              states.get(k).value = null;
          }
        }
      });
    }
  }
  //  TODO: remove this method. Force cloning to strip child arrays when needed instead
  clearArraysFromObject(obj) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (Array.isArray(obj[prop])) {
          delete obj[prop];
        }
      }
    }
  }
}

/**
 * Factory service for instantiating TransactionServices
 */
let IgxFlatTransactionFactory = /*#__PURE__*/(() => {
  class IgxFlatTransactionFactory {
    /**
     * Creates a new Transaction service instance depending on the specified type.
     *
     * @param type The type of the transaction
     * @returns a new instance of TransactionService<Transaction, State>
     */
    create(type) {
      switch (type) {
        case "Base" /* TRANSACTION_TYPE.Base */:
          return new IgxTransactionService();
        default:
          return new IgxBaseTransactionService();
      }
    }
    static {
      this.ɵfac = function IgxFlatTransactionFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFlatTransactionFactory)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxFlatTransactionFactory,
        factory: IgxFlatTransactionFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxFlatTransactionFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Factory service for instantiating HierarchicalTransactionServices
 */
let IgxHierarchicalTransactionFactory = /*#__PURE__*/(() => {
  class IgxHierarchicalTransactionFactory extends IgxFlatTransactionFactory {
    /**
     * Creates a new HierarchialTransaction service instance depending on the specified type.
     *
     * @param type The type of the transaction
     * @returns a new instance of HierarchialTransaction<HierarchialTransaction, HierarchialState>
     */
    create(type) {
      switch (type) {
        case "Base" /* TRANSACTION_TYPE.Base */:
          return new IgxHierarchicalTransactionService();
        default:
          return new IgxBaseTransactionService();
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxHierarchicalTransactionFactory_BaseFactory;
        return function IgxHierarchicalTransactionFactory_Factory(__ngFactoryType__) {
          return (ɵIgxHierarchicalTransactionFactory_BaseFactory || (ɵIgxHierarchicalTransactionFactory_BaseFactory = i0.ɵɵgetInheritedFactory(IgxHierarchicalTransactionFactory)))(__ngFactoryType__ || IgxHierarchicalTransactionFactory);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxHierarchicalTransactionFactory,
        factory: IgxHierarchicalTransactionFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxHierarchicalTransactionFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ThemeToken {
  constructor(t) {
    this.t = t;
    this.document = inject(DOCUMENT);
    const globalTheme = globalThis.window?.getComputedStyle(this.document.body).getPropertyValue("--ig-theme").trim() || 'material';
    const _theme = t ?? globalTheme;
    this.subject = new BehaviorSubject(_theme);
  }
  onChange(callback) {
    return this.subject.subscribe(callback);
  }
  set(theme) {
    this.subject.next(theme);
  }
  get theme() {
    return this.subject.getValue();
  }
  get preferToken() {
    return !!this.t;
  }
}
const THEME_TOKEN = new InjectionToken('ThemeToken', {
  providedIn: 'root',
  factory: () => new ThemeToken()
});
const Theme = /*@__PURE__*/mkenum({
  Material: "material",
  Fluent: "fluent",
  Bootstrap: "bootstrap",
  IndigoDesign: "indigo"
});

// Export services

/** @hidden */
var Navigate = /*#__PURE__*/function (Navigate) {
  Navigate[Navigate["Up"] = -1] = "Up";
  Navigate[Navigate["Down"] = 1] = "Down";
  return Navigate;
}(Navigate || {});
/** Key actions that have designated handlers in IgxDropDownComponent */
const DropDownActionKey = /*@__PURE__*/mkenum({
  ESCAPE: 'escape',
  ENTER: 'enter',
  SPACE: 'space'
});
const IGX_DROPDOWN_BASE = /*@__PURE__*/new InjectionToken('IgxDropDownBaseToken');
let NEXT_ID$w = 0;
/**
 * An abstract class, defining a drop-down component, with:
 * Properties for display styles and classes
 * A collection items of type `IgxDropDownItemBaseDirective`
 * Properties and methods for navigating (highlighting/focusing) items from the collection
 * Properties and methods for selecting items from the collection
 */
let IgxDropDownBaseDirective = /*#__PURE__*/(() => {
  class IgxDropDownBaseDirective {
    /**
     * Gets/Sets the drop down's id
     *
     * ```typescript
     * // get
     * let myDropDownCurrentId = this.dropdown.id;
     * ```
     * ```html
     * <!--set-->
     * <igx-drop-down [id]='newDropDownId'></igx-drop-down>
     * ```
     */
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value;
    }
    /**
     * Get all non-header items
     *
     * ```typescript
     * let myDropDownItems = this.dropdown.items;
     * ```
     */
    get items() {
      const items = [];
      if (this.children !== undefined) {
        for (const child of this.children.toArray()) {
          if (!child.isHeader) {
            items.push(child);
          }
        }
      }
      return items;
    }
    /**
     * Get all header items
     *
     * ```typescript
     * let myDropDownHeaderItems = this.dropdown.headers;
     * ```
     */
    get headers() {
      const headers = [];
      if (this.children !== undefined) {
        for (const child of this.children.toArray()) {
          if (child.isHeader) {
            headers.push(child);
          }
        }
      }
      return headers;
    }
    /**
     * Get dropdown html element
     *
     * ```typescript
     * let myDropDownElement = this.dropdown.element;
     * ```
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * @hidden @internal
     * Get dropdown's html element of its scroll container
     */
    get scrollContainer() {
      return this.element;
    }
    constructor(elementRef, cdr, document) {
      this.elementRef = elementRef;
      this.cdr = cdr;
      this.document = document;
      /**
       * Emitted when item selection is changing, before the selection completes
       *
       * ```html
       * <igx-drop-down (selectionChanging)='handleSelection()'></igx-drop-down>
       * ```
       */
      this.selectionChanging = new EventEmitter();
      /**
       * Gets/Sets the drop down's container max height.
       *
       * ```typescript
       * // get
       * let maxHeight = this.dropdown.maxHeight;
       * ```
       * ```html
       * <!--set-->
       * <igx-drop-down [maxHeight]='200px'></igx-drop-down>
       * ```
       */
      this.maxHeight = null;
      /**
       * @hidden @internal
       */
      this.cssClass = true;
      this._focusedItem = null;
      this._id = `igx-drop-down-${NEXT_ID$w++}`;
    }
    ngOnInit() {
      this.computedStyles = this.document.defaultView.getComputedStyle(this.elementRef.nativeElement);
    }
    /** Keydown Handler */
    onItemActionKey(key, event) {
      switch (key) {
        case DropDownActionKey.ENTER:
        case DropDownActionKey.SPACE:
          this.selectItem(this.focusedItem, event);
          break;
        case DropDownActionKey.ESCAPE:
      }
    }
    /**
     * Emits selectionChanging with the target item & event
     *
     * @hidden @internal
     * @param newSelection the item selected
     * @param event the event that triggered the call
     */
    selectItem(newSelection, event, emit = true) {
      this.selectionChanging.emit({
        newSelection,
        oldSelection: null,
        cancel: false
      });
    }
    /**
     * @hidden @internal
     */
    get focusedItem() {
      return this._focusedItem;
    }
    /**
     * @hidden @internal
     */
    set focusedItem(item) {
      this._focusedItem = item;
    }
    /**
     * Navigates to the item on the specified index
     *
     * @param newIndex number - the index of the item in the `items` collection
     */
    navigateItem(newIndex) {
      if (newIndex !== -1) {
        const oldItem = this._focusedItem;
        const newItem = this.items[newIndex];
        if (oldItem) {
          oldItem.focused = false;
        }
        this.focusedItem = newItem;
        this.scrollToHiddenItem(newItem);
        this.focusedItem.focused = true;
      }
    }
    /**
     * @hidden @internal
     */
    navigateFirst() {
      this.navigate(Navigate.Down, -1);
    }
    /**
     * @hidden @internal
     */
    navigateLast() {
      this.navigate(Navigate.Up, this.items.length);
    }
    /**
     * @hidden @internal
     */
    navigateNext() {
      this.navigate(Navigate.Down);
    }
    /**
     * @hidden @internal
     */
    navigatePrev() {
      this.navigate(Navigate.Up);
    }
    scrollToHiddenItem(newItem) {
      const elementRect = newItem.element.nativeElement.getBoundingClientRect();
      const parentRect = this.scrollContainer.getBoundingClientRect();
      if (parentRect.top > elementRect.top) {
        this.scrollContainer.scrollTop -= parentRect.top - elementRect.top;
      }
      if (parentRect.bottom < elementRect.bottom) {
        this.scrollContainer.scrollTop += elementRect.bottom - parentRect.bottom;
      }
    }
    navigate(direction, currentIndex) {
      let index = -1;
      if (this._focusedItem) {
        index = currentIndex ? currentIndex : this.focusedItem.itemIndex;
      }
      const newIndex = this.getNearestSiblingFocusableItemIndex(index, direction);
      this.navigateItem(newIndex);
    }
    getNearestSiblingFocusableItemIndex(startIndex, direction) {
      let index = startIndex;
      const items = this.items;
      while (items[index + direction] && items[index + direction].disabled) {
        index += direction;
      }
      index += direction;
      if (index >= 0 && index < items.length) {
        return index;
      } else {
        return -1;
      }
    }
    static {
      this.ɵfac = function IgxDropDownBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDropDownBaseDirective,
        hostVars: 5,
        hostBindings: function IgxDropDownBaseDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("max-height", ctx.maxHeight);
            i0.ɵɵclassProp("igx-drop-down", ctx.cssClass);
          }
        },
        inputs: {
          width: "width",
          height: "height",
          id: "id",
          maxHeight: "maxHeight"
        },
        outputs: {
          selectionChanging: "selectionChanging"
        }
      });
    }
  }
  return IgxDropDownBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Navigation Directive that handles keyboard events on its host and controls a targeted IgxDropDownBaseDirective component
 */
let IgxDropDownItemNavigationDirective = /*#__PURE__*/(() => {
  class IgxDropDownItemNavigationDirective {
    constructor(dropdown) {
      this.dropdown = dropdown;
      this._target = null;
    }
    /**
     * Gets the target of the navigation directive;
     *
     * ```typescript
     * // Get
     * export class MyComponent {
     *  ...
     *  @ContentChild(IgxDropDownNavigationDirective)
     *  navDirective: IgxDropDownNavigationDirective = null
     *  ...
     *  const navTarget: IgxDropDownBaseDirective = navDirective.navTarget
     * }
     * ```
     */
    get target() {
      return this._target;
    }
    /**
     * Sets the target of the navigation directive;
     * If no valid target is passed, it falls back to the drop down context
     *
     * ```html
     * <!-- Set -->
     * <input [igxDropDownItemNavigation]="dropdown" />
     * ...
     * <igx-drop-down #dropdown>
     * ...
     * </igx-drop-down>
     * ```
     */
    set target(target) {
      this._target = target ? target : this.dropdown;
    }
    /**
     * Captures keydown events and calls the appropriate handlers on the target component
     */
    handleKeyDown(event) {
      if (event) {
        const key = event.key.toLowerCase();
        if (!this.target.collapsed) {
          // If dropdown is opened
          const navKeys = ['esc', 'escape', 'enter', 'space', 'spacebar', ' ', 'arrowup', 'up', 'arrowdown', 'down', 'home', 'end'];
          if (navKeys.indexOf(key) === -1) {
            // If key has appropriate function in DD
            return;
          }
          event.preventDefault();
          event.stopPropagation();
        } else {
          // If dropdown is closed, do nothing
          return;
        }
        switch (key) {
          case 'esc':
          case 'escape':
            this.target.onItemActionKey(DropDownActionKey.ESCAPE, event);
            break;
          case 'enter':
            this.target.onItemActionKey(DropDownActionKey.ENTER, event);
            break;
          case 'space':
          case 'spacebar':
          case ' ':
            this.target.onItemActionKey(DropDownActionKey.SPACE, event);
            break;
          case 'arrowup':
          case 'up':
            this.onArrowUpKeyDown();
            break;
          case 'arrowdown':
          case 'down':
            this.onArrowDownKeyDown();
            break;
          case 'home':
            this.onHomeKeyDown();
            break;
          case 'end':
            this.onEndKeyDown();
            break;
          default:
            return;
        }
      }
    }
    /**
     * Navigates to previous item
     */
    onArrowDownKeyDown() {
      this.target.navigateNext();
    }
    /**
     * Navigates to previous item
     */
    onArrowUpKeyDown() {
      this.target.navigatePrev();
    }
    /**
     * Navigates to target's last item
     */
    onEndKeyDown() {
      this.target.navigateLast();
    }
    /**
     * Navigates to target's first item
     */
    onHomeKeyDown() {
      this.target.navigateFirst();
    }
    static {
      this.ɵfac = function IgxDropDownItemNavigationDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownItemNavigationDirective)(i0.ɵɵdirectiveInject(IGX_DROPDOWN_BASE, 10));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDropDownItemNavigationDirective,
        selectors: [["", "igxDropDownItemNavigation", ""]],
        hostBindings: function IgxDropDownItemNavigationDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxDropDownItemNavigationDirective_keydown_HostBindingHandler($event) {
              return ctx.handleKeyDown($event);
            });
          }
        },
        inputs: {
          target: [0, "igxDropDownItemNavigation", "target"]
        }
      });
    }
  }
  return IgxDropDownItemNavigationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var IgxHintPosition = /*#__PURE__*/function (IgxHintPosition) {
  IgxHintPosition[IgxHintPosition["START"] = 0] = "START";
  IgxHintPosition[IgxHintPosition["END"] = 1] = "END";
  return IgxHintPosition;
}(IgxHintPosition || {});
let IgxHintDirective = /*#__PURE__*/(() => {
  class IgxHintDirective {
    constructor() {
      /**
       * Sets/gets whether the hint position is at the start.
       * Default value is `false`.
       * ```typescript
       * @ViewChild('hint', {read: IgxHintDirective})
       * public igxHint: IgxHintDirective;
       * this.igxHint.isPositionStart = true;
       * ```
       * ```typescript
       * let isHintPositionStart = this.igxHint.isPositionStart;
       * ```
       *
       * @memberof IgxHintDirective
       */
      this.isPositionStart = false;
      /**
       * Sets/gets whether the hint position is at the end.
       * Default value is `false`.
       * ```typescript
       * @ViewChild('hint', {read: IgxHintDirective})
       * public igxHint: IgxHintDirective;
       * this.igxHint.isPositionEnd = true;
       * ```
       * ```typescript
       * let isHintPositionEnd = this.igxHint.isPositionEnd;
       * ```
       *
       * @memberof IgxHintDirective
       */
      this.isPositionEnd = false;
      this._position = IgxHintPosition.START;
    }
    /**
     * Sets the position of the hint.
     * ```html
     * <igx-input-group>
     *  <input igxInput type="text"/>
     *  <igx-hint #hint [position]="'start'">IgxHint displayed at the start</igx-hint>
     * </igx-input-group>
     * ```
     *
     * @memberof IgxHintDirective
     */
    set position(value) {
      const position = IgxHintPosition[value.toUpperCase()];
      if (position !== undefined) {
        this._position = position;
        this._applyPosition(this._position);
      }
    }
    /**
     * Gets the position of the hint.
     * ```typescript
     * @ViewChild('hint', {read: IgxHintDirective})
     * public igxHint: IgxHintDirective;
     * let hintPosition =  this.igxHint.position;
     * ```
     *
     * @memberof IgxHintDirective
     */
    get position() {
      return this._position.toString();
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this._applyPosition(this._position);
    }
    _applyPosition(position) {
      this.isPositionStart = this.isPositionEnd = false;
      switch (position) {
        case IgxHintPosition.START:
          this.isPositionStart = true;
          break;
        case IgxHintPosition.END:
          this.isPositionEnd = true;
          break;
        default:
          break;
      }
    }
    static {
      this.ɵfac = function IgxHintDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHintDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxHintDirective,
        selectors: [["igx-hint"], ["", "igxHint", ""]],
        hostVars: 4,
        hostBindings: function IgxHintDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-input-group__hint-item--start", ctx.isPositionStart)("igx-input-group__hint-item--end", ctx.isPositionEnd);
          }
        },
        inputs: {
          position: "position"
        }
      });
    }
  }
  return IgxHintDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
class IgxInputGroupBase {}
const nativeValidationAttributes = ['required', 'pattern', 'minlength', 'maxlength', 'min', 'max', 'step'];
var IgxInputState = /*#__PURE__*/function (IgxInputState) {
  IgxInputState[IgxInputState["INITIAL"] = 0] = "INITIAL";
  IgxInputState[IgxInputState["VALID"] = 1] = "VALID";
  IgxInputState[IgxInputState["INVALID"] = 2] = "INVALID";
  return IgxInputState;
}(IgxInputState || {});
/**
 * The `igxInput` directive creates single- or multiline text elements, covering common scenarios when dealing with form inputs.
 *
 * @igxModule IgxInputGroupModule
 *
 * @igxParent Data Entry & Display
 *
 * @igxTheme igx-input-group-theme
 *
 * @igxKeywords input, input group, form, field, validation
 *
 * @igxGroup presentation
 *
 * @example
 * ```html
 * <input-group>
 *  <label for="address">Address</label>
 *  <input igxInput name="address" type="text" [(ngModel)]="customer.address">
 * </input-group>
 * ```
 */
let IgxInputDirective = /*#__PURE__*/(() => {
  class IgxInputDirective {
    constructor(inputGroup, ngModel, formControl, element, cdr, renderer) {
      this.inputGroup = inputGroup;
      this.ngModel = ngModel;
      this.formControl = formControl;
      this.element = element;
      this.cdr = cdr;
      this.renderer = renderer;
      /**
       * Sets/gets whether the `"igx-input-group__input"` class is added to the host element.
       * Default value is `false`.
       *
       * @example
       * ```typescript
       * this.igxInput.isInput = true;
       * ```
       *
       * @example
       * ```typescript
       * let isCLassAdded = this.igxInput.isInput;
       * ```
       */
      this.isInput = false;
      /**
       * Sets/gets whether the `"class.igx-input-group__textarea"` class is added to the host element.
       * Default value is `false`.
       *
       * @example
       * ```typescript
       * this.igxInput.isTextArea = true;
       * ```
       *
       * @example
       * ```typescript
       * let isCLassAdded = this.igxInput.isTextArea;
       * ```
       */
      this.isTextArea = false;
      this._valid = IgxInputState.INITIAL;
      this._disabled = false;
    }
    get ngControl() {
      return this.ngModel ? this.ngModel : this.formControl;
    }
    /**
     * Sets the `value` property.
     *
     * @example
     * ```html
     * <input-group>
     *  <input igxInput #igxInput [value]="'IgxInput Value'">
     * </input-group>
     * ```
     */
    set value(value) {
      this.nativeElement.value = value ?? '';
      this.updateValidityState();
    }
    /**
     * Gets the `value` property.
     *
     * @example
     * ```typescript
     * @ViewChild('igxInput', {read: IgxInputDirective})
     *  public igxInput: IgxInputDirective;
     * let inputValue = this.igxInput.value;
     * ```
     */
    get value() {
      return this.nativeElement.value;
    }
    /**
     * Sets the `disabled` property.
     *
     * @example
     * ```html
     * <input-group>
     *  <input igxInput #igxInput [disabled]="true">
     * </input-group>
     * ```
     */
    set disabled(value) {
      this._disabled = this.inputGroup.disabled = value;
      if (this.focused && this._disabled) {
        // Browser focus may not fire in good time and mess with change detection, adjust here in advance:
        this.inputGroup.isFocused = false;
      }
    }
    /**
     * Gets the `disabled` property
     *
     * @example
     * ```typescript
     * @ViewChild('igxInput', {read: IgxInputDirective})
     *  public igxInput: IgxInputDirective;
     * let isDisabled = this.igxInput.disabled;
     * ```
     */
    get disabled() {
      return this._disabled;
    }
    /**
     * Sets the `required` property.
     *
     * @example
     * ```html
     * <input-group>
     *  <input igxInput #igxInput required>
     * </input-group>
     * ```
     */
    set required(value) {
      this.nativeElement.required = this.inputGroup.isRequired = value;
    }
    /**
     * Gets whether the igxInput is required.
     *
     * @example
     * ```typescript
     * let isRequired = this.igxInput.required;
     * ```
     */
    get required() {
      let validation;
      if (this.ngControl && (this.ngControl.control.validator || this.ngControl.control.asyncValidator)) {
        validation = this.ngControl.control.validator({});
      }
      return validation && validation.required || this.nativeElement.hasAttribute('required');
    }
    /**
     * @hidden
     * @internal
     */
    onFocus() {
      this.inputGroup.isFocused = true;
    }
    /**
     * @param event The event to invoke the handler
     *
     * @hidden
     * @internal
     */
    onBlur() {
      this.inputGroup.isFocused = false;
      this.updateValidityState();
    }
    /** @hidden @internal */
    onInput() {
      this.checkNativeValidity();
    }
    /** @hidden @internal */
    change(event) {
      if (this.type === 'file') {
        const fileList = event.target.files;
        const fileArray = [];
        if (fileList) {
          for (const file of Array.from(fileList)) {
            fileArray.push(file);
          }
        }
        this._fileNames = (fileArray || []).map(f => f.name).join(', ');
        if (this.required && fileList?.length > 0) {
          this._valid = IgxInputState.INITIAL;
        }
      }
    }
    /** @hidden @internal */
    get fileNames() {
      return this._fileNames;
    }
    /** @hidden @internal */
    clear() {
      this.ngControl?.control?.setValue('');
      this.nativeElement.value = null;
      this._fileNames = '';
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.inputGroup.hasPlaceholder = this.nativeElement.hasAttribute('placeholder');
      if (this.ngControl && this.ngControl.disabled !== null) {
        this.disabled = this.ngControl.disabled;
      }
      this.inputGroup.disabled = this.inputGroup.disabled || this.nativeElement.hasAttribute('disabled');
      this.inputGroup.isRequired = this.nativeElement.hasAttribute('required');
      // Make sure we do not invalidate the input on init
      if (!this.ngControl) {
        this._valid = IgxInputState.INITIAL;
      }
      // Also check the control's validators for required
      if (this.required && !this.inputGroup.isRequired) {
        this.inputGroup.isRequired = this.required;
      }
      this.renderer.setAttribute(this.nativeElement, 'aria-required', this.required.toString());
      const elTag = this.nativeElement.tagName.toLowerCase();
      if (elTag === 'textarea') {
        this.isTextArea = true;
      } else {
        this.isInput = true;
      }
      if (this.ngControl) {
        this._statusChanges$ = this.ngControl.statusChanges.subscribe(this.onStatusChanged.bind(this));
        this._valueChanges$ = this.ngControl.valueChanges.subscribe(this.onValueChanged.bind(this));
      }
      this.cdr.detectChanges();
    }
    /** @hidden @internal */
    ngOnDestroy() {
      if (this._statusChanges$) {
        this._statusChanges$.unsubscribe();
      }
      if (this._valueChanges$) {
        this._valueChanges$.unsubscribe();
      }
    }
    /**
     * Sets a focus on the igxInput.
     *
     * @example
     * ```typescript
     * this.igxInput.focus();
     * ```
     */
    focus() {
      this.nativeElement.focus();
    }
    /**
     * Gets the `nativeElement` of the igxInput.
     *
     * @example
     * ```typescript
     * let igxInputNativeElement = this.igxInput.nativeElement;
     * ```
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /** @hidden @internal */
    onStatusChanged() {
      // Enable/Disable control based on ngControl #7086
      if (this.disabled !== this.ngControl.disabled) {
        this.disabled = this.ngControl.disabled;
      }
      this.updateValidityState();
    }
    /** @hidden @internal */
    onValueChanged() {
      if (this._fileNames && !this.value) {
        this._fileNames = '';
      }
    }
    /**
     * @hidden
     * @internal
     */
    updateValidityState() {
      if (this.ngControl) {
        if (!this.disabled && this.isTouchedOrDirty) {
          if (this.hasValidators) {
            // Run the validation with empty object to check if required is enabled.
            const error = this.ngControl.control.validator({});
            this.inputGroup.isRequired = error && error.required;
            if (this.focused) {
              this._valid = this.ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
            } else {
              this._valid = this.ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
            }
          } else {
            // If validator is dynamically cleared, reset label's required class(asterisk) and IgxInputState #10010
            this.inputGroup.isRequired = false;
            this._valid = this.ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
          }
        } else {
          this._valid = IgxInputState.INITIAL;
        }
        this.renderer.setAttribute(this.nativeElement, 'aria-required', this.required.toString());
        const ariaInvalid = this.valid === IgxInputState.INVALID;
        this.renderer.setAttribute(this.nativeElement, 'aria-invalid', ariaInvalid.toString());
      } else {
        this.checkNativeValidity();
      }
    }
    get isTouchedOrDirty() {
      return this.ngControl.control.touched || this.ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this.ngControl.control.validator || !!this.ngControl.control.asyncValidator;
    }
    /**
     * Gets whether the igxInput has a placeholder.
     *
     * @example
     * ```typescript
     * let hasPlaceholder = this.igxInput.hasPlaceholder;
     * ```
     */
    get hasPlaceholder() {
      return this.nativeElement.hasAttribute('placeholder');
    }
    /**
     * Gets the placeholder element of the igxInput.
     *
     * @example
     * ```typescript
     * let igxInputPlaceholder = this.igxInput.placeholder;
     * ```
     */
    get placeholder() {
      return this.nativeElement.placeholder;
    }
    /**
     * @returns An indicator of whether the input has validator attributes or not
     *
     * @hidden
     * @internal
     */
    _hasValidators() {
      for (const nativeValidationAttribute of nativeValidationAttributes) {
        if (this.nativeElement.hasAttribute(nativeValidationAttribute)) {
          return true;
        }
      }
      return false;
    }
    /**
     * Gets whether the igxInput is focused.
     *
     * @example
     * ```typescript
     * let isFocused = this.igxInput.focused;
     * ```
     */
    get focused() {
      return this.inputGroup.isFocused;
    }
    /**
     * Gets the state of the igxInput.
     *
     * @example
     * ```typescript
     * let igxInputState = this.igxInput.valid;
     * ```
     */
    get valid() {
      return this._valid;
    }
    /**
     * Sets the state of the igxInput.
     *
     * @example
     * ```typescript
     * this.igxInput.valid = IgxInputState.INVALID;
     * ```
     */
    set valid(value) {
      this._valid = value;
    }
    /**
     * Gets whether the igxInput is valid.
     *
     * @example
     * ```typescript
     * let valid = this.igxInput.isValid;
     * ```
     */
    get isValid() {
      return this.valid !== IgxInputState.INVALID;
    }
    /**
     * A function to assign a native validity property of an input.
     * This should be used when there's no ngControl
     *
     * @hidden
     * @internal
     */
    checkNativeValidity() {
      if (!this.disabled && this._hasValidators()) {
        this._valid = this.nativeElement.checkValidity() ? this.focused ? IgxInputState.VALID : IgxInputState.INITIAL : IgxInputState.INVALID;
      }
    }
    /**
     * Returns the input type.
     *
     * @hidden
     * @internal
     */
    get type() {
      return this.nativeElement.type;
    }
    static {
      this.ɵfac = function IgxInputDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxInputDirective)(i0.ɵɵdirectiveInject(IgxInputGroupBase), i0.ɵɵdirectiveInject(NgModel, 10), i0.ɵɵdirectiveInject(NgControl, 10), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxInputDirective,
        selectors: [["", "igxInput", ""]],
        hostVars: 5,
        hostBindings: function IgxInputDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function IgxInputDirective_focus_HostBindingHandler() {
              return ctx.onFocus();
            })("blur", function IgxInputDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("input", function IgxInputDirective_input_HostBindingHandler() {
              return ctx.onInput();
            })("change", function IgxInputDirective_change_HostBindingHandler($event) {
              return ctx.change($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵhostProperty("disabled", ctx.disabled);
            i0.ɵɵclassProp("igx-input-group__input", ctx.isInput)("igx-input-group__textarea", ctx.isTextArea);
          }
        },
        inputs: {
          value: "value",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          required: [2, "required", "required", booleanAttribute]
        },
        exportAs: ["igxInput"]
      });
    }
  }
  return IgxInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$v = 0;
let IgxLabelDirective = /*#__PURE__*/(() => {
  class IgxLabelDirective {
    constructor() {
      this.defaultClass = true;
      /**
       * @hidden
       */
      this.id = `igx-label-${NEXT_ID$v++}`;
    }
    static {
      this.ɵfac = function IgxLabelDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxLabelDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxLabelDirective,
        selectors: [["", "igxLabel", ""]],
        hostVars: 3,
        hostBindings: function IgxLabelDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-input-group__label", ctx.defaultClass);
          }
        },
        inputs: {
          id: "id"
        }
      });
    }
  }
  return IgxLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxPrefixDirective = /*#__PURE__*/(() => {
  class IgxPrefixDirective {
    static {
      this.ɵfac = function IgxPrefixDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPrefixDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPrefixDirective,
        selectors: [["igx-prefix"], ["", "igxPrefix", ""], ["", "igxStart", ""]]
      });
    }
  }
  return IgxPrefixDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxSuffixDirective = /*#__PURE__*/(() => {
  class IgxSuffixDirective {
    static {
      this.ɵfac = function IgxSuffixDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSuffixDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSuffixDirective,
        selectors: [["igx-suffix"], ["", "igxSuffix", ""], ["", "igxEnd", ""]]
      });
    }
  }
  return IgxSuffixDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const InputResourceStringsEN = {
  igx_input_upload_button: 'Upload File',
  igx_input_file_placeholder: 'No file chosen'
};
const IgxBaseButtonType = /*@__PURE__*/mkenum({
  Flat: 'flat',
  Contained: 'contained',
  Outlined: 'outlined'
});
let IgxButtonBaseDirective = /*#__PURE__*/(() => {
  class IgxButtonBaseDirective {
    /**
     * @hidden
     * @internal
     */
    onClick(ev) {
      this.buttonClick.emit(ev);
      this.focused = false;
    }
    /**
     * @hidden
     * @internal
     */
    onBlur() {
      this.focused = false;
    }
    /**
     * @hidden
     * @internal
     */
    get disabledAttribute() {
      return this.disabled || null;
    }
    constructor(element) {
      this.element = element;
      /**
       * Emitted when the button is clicked.
       */
      this.buttonClick = new EventEmitter();
      /**
       * Sets/gets the `role` attribute.
       *
       * @example
       * ```typescript
       * this.button.role = 'navbutton';
       * let buttonRole = this.button.role;
       * ```
       */
      this.role = 'button';
      /**
       * Sets/gets whether the button component is on focus.
       * Default value is `false`.
       * ```typescript
       * this.button.focus = true;
       * ```
       * ```typescript
       * let isFocused =  this.button.focused;
       * ```
       */
      this.focused = false;
      /**
        * Enables/disables the button.
        *
        * @example
        * ```html
        * <button igxButton="fab" disabled></button>
        * ```
        */
      this.disabled = false;
    }
    /**
     * @hidden
     * @internal
     */
    updateOnKeyUp(event) {
      if (event.key === "Tab") {
        this.focused = true;
      }
    }
    /**
     * Returns the underlying DOM element.
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    static {
      this.ɵfac = function IgxButtonBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxButtonBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxButtonBaseDirective,
        hostVars: 6,
        hostBindings: function IgxButtonBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxButtonBaseDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("blur", function IgxButtonBaseDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("keyup", function IgxButtonBaseDirective_keyup_HostBindingHandler($event) {
              return ctx.updateOnKeyUp($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("disabled", ctx.disabledAttribute);
            i0.ɵɵclassProp("igx-button--focused", ctx.focused)("igx-button--disabled", ctx.disabled);
          }
        },
        inputs: {
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        outputs: {
          buttonClick: "buttonClick"
        }
      });
    }
  }
  return IgxButtonBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxButtonType = /*@__PURE__*/mkenum({
  ...IgxBaseButtonType,
  FAB: 'fab'
});
/**
 * The Button directive provides the Ignite UI Button functionality to every component that's intended to be used as a button.
 *
 * @igxModule IgxButtonModule
 *
 * @igxParent Data Entry & Display
 *
 * @igxTheme igx-button-theme
 *
 * @igxKeywords button, span, div, click
 *
 * @remarks
 * The Ignite UI Button directive is intended to be used by any button, span or div and turn it into a fully functional button.
 *
 * @example
 * ```html
 * <button type="button" igxButton="outlined">A Button</button>
 * ```
 */
let IgxButtonDirective = /*#__PURE__*/(() => {
  class IgxButtonDirective extends IgxButtonBaseDirective {
    emitSelected() {
      this.buttonSelected.emit({
        button: this
      });
    }
    /**
     * Gets or sets whether the button is selected.
     * Mainly used in the IgxButtonGroup component and it will have no effect if set separately.
     *
     * @example
     * ```html
     * <button type="button" igxButton="flat" [selected]="button.selected"></button>
     * ```
     */
    set selected(value) {
      if (this._selected !== value) {
        this._selected = value;
        this._renderer.setAttribute(this.nativeElement, 'data-selected', value.toString());
      }
    }
    get selected() {
      return this._selected;
    }
    constructor(element, _renderer) {
      super(element);
      this.element = element;
      this._renderer = _renderer;
      /**
       * Called when the button is selected.
       */
      this.buttonSelected = new EventEmitter();
      /**
       * @hidden
       * @internal
       */
      this._cssClass = 'igx-button';
      /**
       * @hidden
       * @internal
       */
      this._selected = false;
    }
    ngAfterContentInit() {
      this.nativeElement.addEventListener('click', this.emitSelected.bind(this));
    }
    ngOnDestroy() {
      this.nativeElement.removeEventListener('click', this.emitSelected);
    }
    /**
     * Sets the type of the button.
     *
     * @example
     * ```html
     * <button type="button" igxButton="outlined"></button>
     * ```
     */
    set type(type) {
      const t = type ? type : IgxButtonType.Flat;
      if (this._type !== t) {
        this._type = t;
      }
    }
    /**
     * Sets the `aria-label` attribute.
     *
     * @example
     *  ```html
     * <button type="button" igxButton="flat" igxLabel="Label"></button>
     * ```
     */
    set label(value) {
      this._label = value || this._label;
      this._renderer.setAttribute(this.nativeElement, 'aria-label', this._label);
    }
    /**
     * @hidden
     * @internal
     */
    get flat() {
      return this._type === IgxButtonType.Flat;
    }
    /**
     * @hidden
     * @internal
     */
    get contained() {
      return this._type === IgxButtonType.Contained;
    }
    /**
     * @hidden
     * @internal
     */
    get outlined() {
      return this._type === IgxButtonType.Outlined;
    }
    /**
     * @hidden
     * @internal
     */
    get fab() {
      return this._type === IgxButtonType.FAB;
    }
    /**
     * @hidden
     * @internal
     */
    select() {
      this.selected = true;
    }
    /**
     * @hidden
     * @internal
     */
    deselect() {
      this.selected = false;
      this.focused = false;
    }
    static {
      this.ɵfac = function IgxButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxButtonDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxButtonDirective,
        selectors: [["", "igxButton", ""]],
        hostVars: 10,
        hostBindings: function IgxButtonDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-button", ctx._cssClass)("igx-button--flat", ctx.flat)("igx-button--contained", ctx.contained)("igx-button--outlined", ctx.outlined)("igx-button--fab", ctx.fab);
          }
        },
        inputs: {
          selected: [2, "selected", "selected", booleanAttribute],
          type: [0, "igxButton", "type"],
          label: [0, "igxLabel", "label"]
        },
        outputs: {
          buttonSelected: "buttonSelected"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxInputGroupEnum = /*@__PURE__*/mkenum({
  Line: 'line',
  Box: 'box',
  Border: 'border',
  Search: 'search'
});
/**
 * Defines the InputGroupType DI token.
 */
// Should this go trough Interface https://angular.io/api/core/InjectionToken
const IGX_INPUT_GROUP_TYPE = /*@__PURE__*/new InjectionToken('InputGroupType');
const makeIconRefs = icons => {
  return new Map(Object.entries(icons).map(icon => {
    return icon;
  }));
};
const addIcon = (name, target) => {
  const icon = {
    alias: {
      name,
      family: 'default'
    },
    target: makeIconRefs(target)
  };
  return icon;
};
const loadIconRefs = () => [addIcon('more_vert', {
  default: {
    name: 'more_vert',
    family: 'material'
  }
}), addIcon('arrow_prev', {
  default: {
    name: 'chevron_left',
    family: 'material'
  },
  fluent: {
    name: 'arrow_upward',
    family: 'material'
  },
  indigo: {
    name: 'chevron_left',
    family: 'internal_indigo'
  }
}), addIcon('arrow_next', {
  default: {
    name: 'chevron_right',
    family: 'material'
  },
  fluent: {
    name: 'arrow_downward',
    family: 'material'
  },
  indigo: {
    name: 'chevron_right',
    family: 'internal_indigo'
  }
}), addIcon('expand', {
  default: {
    name: 'expand_more',
    family: 'material'
  },
  indigo: {
    name: 'chevron_down',
    family: 'internal_indigo'
  }
}), addIcon('collapse', {
  default: {
    name: 'expand_less',
    family: 'material'
  },
  indigo: {
    name: 'chevron_up',
    family: 'internal_indigo'
  }
}), addIcon('carousel_prev', {
  default: {
    name: 'keyboard_arrow_left',
    family: 'material'
  },
  indigo: {
    name: 'chevron_left',
    family: 'internal_indigo'
  }
}), addIcon('carousel_next', {
  default: {
    name: 'keyboard_arrow_right',
    family: 'material'
  },
  indigo: {
    name: 'chevron_right',
    family: 'internal_indigo'
  }
}), addIcon('arrow_back', {
  default: {
    name: 'arrow_back',
    family: 'material'
  },
  indigo: {
    name: 'arrow_back',
    family: 'internal_indigo'
  }
}), addIcon('arrow_forward', {
  default: {
    name: 'arrow_forward',
    family: 'material'
  },
  indigo: {
    name: 'arrow_forward',
    family: 'internal_indigo'
  }
}), addIcon('selected', {
  default: {
    name: 'done',
    family: 'material'
  },
  indigo: {
    name: 'check',
    family: 'internal_indigo'
  }
}), addIcon('remove', {
  default: {
    name: 'cancel',
    family: 'material'
  },
  indigo: {
    name: 'cancel',
    family: 'internal_indigo'
  }
}), addIcon('input_clear', {
  default: {
    name: 'clear',
    family: 'material'
  },
  indigo: {
    name: 'clear',
    family: 'internal_indigo'
  }
}), addIcon('input_expand', {
  default: {
    name: 'expand_more',
    family: 'material'
  },
  indigo: {
    name: 'chevron_down',
    family: 'internal_indigo'
  }
}), addIcon('input_collapse', {
  default: {
    name: 'expand_less',
    family: 'material'
  },
  indigo: {
    name: 'chevron_up',
    family: 'internal_indigo'
  }
}), addIcon('arrow_drop_down', {
  default: {
    name: 'keyboard_arrow_down',
    family: 'material'
  },
  indigo: {
    name: 'chevron_down',
    family: 'internal_indigo'
  }
}), addIcon('case_sensitive', {
  default: {
    name: 'case-sensitive',
    family: 'imx-icons'
  }
}), addIcon('today', {
  default: {
    name: 'calendar_today',
    family: 'material'
  },
  indigo: {
    name: 'calendar_today',
    family: 'internal_indigo'
  }
}), addIcon('clock', {
  default: {
    name: 'access_time',
    family: 'material'
  },
  indigo: {
    name: 'access_time',
    family: 'internal_indigo'
  }
}), addIcon('date_range', {
  default: {
    name: 'date_range',
    family: 'material'
  },
  indigo: {
    name: 'calendar_today',
    family: 'internal_indigo'
  }
}), addIcon('prev', {
  default: {
    name: 'navigate_before',
    family: 'material'
  },
  indigo: {
    name: 'chevron_left',
    family: 'internal_indigo'
  }
}), addIcon('next', {
  default: {
    name: 'navigate_next',
    family: 'material'
  },
  indigo: {
    name: 'chevron_right',
    family: 'internal_indigo'
  }
}), addIcon('first_page', {
  default: {
    name: 'first_page',
    family: 'material'
  },
  indigo: {
    name: 'first_page',
    family: 'internal_indigo'
  }
}), addIcon('last_page', {
  default: {
    name: 'last_page',
    family: 'material'
  },
  indigo: {
    name: 'last_page',
    family: 'internal_indigo'
  }
}), addIcon('add', {
  default: {
    name: 'add',
    family: 'material'
  },
  indigo: {
    name: 'add',
    family: 'internal_indigo'
  }
}), addIcon('close', {
  default: {
    name: 'close',
    family: 'material'
  },
  indigo: {
    name: 'clear',
    family: 'internal_indigo'
  }
}), addIcon('error', {
  default: {
    name: 'error',
    family: 'material'
  },
  indigo: {
    name: 'error',
    family: 'internal_indigo'
  }
}), addIcon('confirm', {
  default: {
    name: 'check',
    family: 'material'
  },
  indigo: {
    name: 'check',
    family: 'internal_indigo'
  }
}), addIcon('cancel', {
  default: {
    name: 'close',
    family: 'material'
  },
  indigo: {
    name: 'clear',
    family: 'internal_indigo'
  }
}), addIcon('edit', {
  default: {
    name: 'edit',
    family: 'material'
  }
}), addIcon('delete', {
  default: {
    name: 'delete',
    family: 'material'
  }
}), addIcon('pin', {
  default: {
    name: 'pin-left',
    family: 'imx-icons'
  },
  indigo: {
    name: 'pin',
    family: 'internal_indigo'
  }
}), addIcon('unpin', {
  default: {
    name: 'unpin-left',
    family: 'imx-icons'
  },
  indigo: {
    name: 'unpin',
    family: 'internal_indigo'
  }
}), addIcon('show', {
  default: {
    name: 'visibility',
    family: 'material'
  }
}), addIcon('hide', {
  default: {
    name: 'visibility_off',
    family: 'material'
  }
}), addIcon('tree_expand', {
  default: {
    name: 'chevron_right',
    family: 'material'
  },
  indigo: {
    name: 'chevron_right',
    family: 'internal_indigo'
  }
}), addIcon('tree_collapse', {
  default: {
    name: 'expand_more',
    family: 'material'
  },
  indigo: {
    name: 'chevron_down',
    family: 'internal_indigo'
  }
}), addIcon('chevron_right', {
  default: {
    name: 'chevron_right',
    family: 'material'
  },
  indigo: {
    name: 'chevron_right',
    family: 'internal_indigo'
  }
}), addIcon('chevron_left', {
  default: {
    name: 'chevron_left',
    family: 'material'
  },
  indigo: {
    name: 'chevron_left',
    family: 'internal_indigo'
  }
}), addIcon('expand_more', {
  default: {
    name: 'expand_more',
    family: 'material'
  },
  indigo: {
    name: 'chevron_down',
    family: 'internal_indigo'
  }
}), addIcon('filter_list', {
  default: {
    name: 'filter_list',
    family: 'material'
  },
  indigo: {
    name: 'filter_list',
    family: 'internal_indigo'
  }
}), addIcon('import_export', {
  default: {
    name: 'import_export',
    family: 'material'
  }
}), addIcon('unfold_more', {
  default: {
    name: 'unfold_more',
    family: 'material'
  },
  indigo: {
    name: 'unfold_more',
    family: 'internal_indigo'
  }
}), addIcon('unfold_less', {
  default: {
    name: 'unfold_less',
    family: 'material'
  },
  indigo: {
    name: 'unfold_less',
    family: 'internal_indigo'
  }
}), addIcon('drag_indicator', {
  default: {
    name: 'drag_indicator',
    family: 'material'
  }
}), addIcon('group_work', {
  default: {
    name: 'group_work',
    family: 'material'
  }
}), addIcon('sort_asc', {
  default: {
    name: 'arrow_upward',
    family: 'material'
  },
  indigo: {
    name: 'arrow_upward',
    family: 'internal_indigo'
  }
}), addIcon('sort_desc', {
  default: {
    name: 'arrow_downward',
    family: 'material'
  },
  indigo: {
    name: 'arrow_downward',
    family: 'internal_indigo'
  }
}), addIcon('search', {
  default: {
    name: 'search',
    family: 'material'
  },
  indigo: {
    name: 'search',
    family: 'internal_indigo'
  }
}), addIcon('functions', {
  default: {
    name: 'functions',
    family: 'material'
  }
}), addIcon('table_rows', {
  default: {
    name: 'table_rows',
    family: 'material'
  }
}), addIcon('view_column', {
  default: {
    name: 'view_column',
    family: 'material'
  }
}), addIcon('refresh', {
  default: {
    name: 'refresh',
    family: 'material'
  },
  indigo: {
    name: 'refresh',
    family: 'internal_indigo'
  }
}), addIcon('add_row', {
  default: {
    name: 'add-row',
    family: 'imx-icons'
  }
}), addIcon('add_child', {
  default: {
    name: 'add-child',
    family: 'imx-icons'
  }
}), addIcon('jump_up', {
  default: {
    name: 'jump-up',
    family: 'imx-icons'
  }
}), addIcon('jump_down', {
  default: {
    name: 'jump-down',
    family: 'imx-icons'
  }
}), addIcon('filter_null', {
  default: {
    name: 'is-null',
    family: 'imx-icons'
  }
}), addIcon('filter_not_null', {
  default: {
    name: 'is-not-null',
    family: 'imx-icons'
  }
}), addIcon('filter_in', {
  default: {
    name: 'is-in',
    family: 'imx-icons'
  }
}), addIcon('filter_all', {
  default: {
    name: 'select-all',
    family: 'imx-icons'
  }
}), addIcon('filter_true', {
  default: {
    name: 'is-true',
    family: 'imx-icons'
  }
}), addIcon('filter_false', {
  default: {
    name: 'is-false',
    family: 'imx-icons'
  }
}), addIcon('filter_empty', {
  default: {
    name: 'is-empty',
    family: 'imx-icons'
  }
}), addIcon('filter_not_empty', {
  default: {
    name: 'not-empty',
    family: 'imx-icons'
  }
}), addIcon('filter_equal', {
  default: {
    name: 'equals',
    family: 'imx-icons'
  }
}), addIcon('filter_not_equal', {
  default: {
    name: 'not-equal',
    family: 'imx-icons'
  }
}), addIcon('filter_before', {
  default: {
    name: 'is-before',
    family: 'imx-icons'
  }
}), addIcon('filter_after', {
  default: {
    name: 'is-after',
    family: 'imx-icons'
  }
}), addIcon('filter_today', {
  default: {
    name: 'today',
    family: 'imx-icons'
  }
}), addIcon('filter_yesterday', {
  default: {
    name: 'yesterday',
    family: 'imx-icons'
  }
}), addIcon('filter_this_month', {
  default: {
    name: 'this-month',
    family: 'imx-icons'
  }
}), addIcon('filter_last_month', {
  default: {
    name: 'last-month',
    family: 'imx-icons'
  }
}), addIcon('filter_next_month', {
  default: {
    name: 'next-month',
    family: 'imx-icons'
  }
}), addIcon('filter_this_year', {
  default: {
    name: 'this-year',
    family: 'imx-icons'
  }
}), addIcon('filter_last_year', {
  default: {
    name: 'last-year',
    family: 'imx-icons'
  }
}), addIcon('filter_next_year', {
  default: {
    name: 'next-year',
    family: 'imx-icons'
  }
}), addIcon('filter_greater_than', {
  default: {
    name: 'greater-than',
    family: 'imx-icons'
  }
}), addIcon('filter_less_than', {
  default: {
    name: 'less-than',
    family: 'imx-icons'
  }
}), addIcon('filter_greater_than_or_equal', {
  default: {
    name: 'greater-than-or-equal',
    family: 'imx-icons'
  }
}), addIcon('filter_less_than_or_equal', {
  default: {
    name: 'less-than-or-equal',
    family: 'imx-icons'
  }
}), addIcon('filter_contains', {
  default: {
    name: 'contains',
    family: 'imx-icons'
  }
}), addIcon('filter_does_not_contain', {
  default: {
    name: 'does-not-contain',
    family: 'imx-icons'
  }
}), addIcon('filter_starts_with', {
  default: {
    name: 'starts-with',
    family: 'imx-icons'
  }
}), addIcon('filter_ends_with', {
  default: {
    name: 'ends-with',
    family: 'imx-icons'
  }
}), addIcon('ungroup', {
  default: {
    name: 'ungroup',
    family: 'imx-icons'
  }
}), addIcon('file_download', {
  default: {
    name: 'file_download',
    family: 'material'
  },
  indigo: {
    name: 'file_download',
    family: 'internal_indigo'
  }
}), addIcon('file_upload', {
  default: {
    name: 'file_upload',
    family: 'material'
  },
  indigo: {
    name: 'file_upload',
    family: 'internal_indigo'
  }
}), addIcon('horizontal_rule', {
  default: {
    name: 'horizontal_rule',
    family: 'material'
  },
  indigo: {
    name: 'horizontal_rule',
    family: 'internal_indigo'
  }
}), addIcon('menu', {
  default: {
    name: 'menu',
    family: 'material'
  },
  indigo: {
    name: 'menu',
    family: 'internal_indigo'
  }
})];
const iconReferences = /*@__PURE__*/loadIconRefs();
const clear$1 = {
  name: 'clear',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M14.8144 11.9896L18.4171 8.39087C18.7818 8.0135 18.9836 7.50809 18.9791 6.98347C18.9745 6.45885 18.764 5.95699 18.3927 5.58602C18.0215 5.21504 17.5192 5.00464 16.9942 5.00008C16.4692 4.99552 15.9635 5.19718 15.5858 5.56166L11.9896 9.15372L8.39335 5.56166C8.01571 5.19718 7.50992 4.99552 6.98492 5.00008C6.45992 5.00464 5.95769 5.21505 5.58645 5.58602C5.2152 5.95699 5.00464 6.45885 5.00008 6.98347C4.99551 7.50809 5.19733 8.0135 5.56207 8.39087L9.18561 12.0104L5.58291 15.6091C5.21817 15.9865 5.01635 16.4919 5.02091 17.0165C5.02548 17.5412 5.23604 18.043 5.60729 18.414C5.97853 18.785 6.48075 18.9954 7.00576 18.9999C7.53076 19.0045 8.03654 18.8028 8.41419 18.4383L12.0104 14.8463L15.6067 18.4383C15.9843 18.8028 16.4901 19.0045 17.0151 18.9999C17.5401 18.9954 18.0423 18.785 18.4136 18.414C18.7848 18.043 18.9954 17.5412 18.9999 17.0165C19.0045 16.4919 18.8027 15.9865 18.4379 15.6091L14.8144 11.9896Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const unfold_more = {
  name: 'unfold_more',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M13.2403 2.52848C12.9114 2.1902 12.4652 2.0001 12 2C11.5348 2.0001 11.0886 2.1902 10.7597 2.52848L6.49245 6.94326C6.17289 7.28344 5.99607 7.73906 6.00007 8.21198C6.00406 8.6849 6.18855 9.13731 6.51381 9.47173C6.83907 9.80615 7.27909 9.99582 7.73907 9.99993C8.19904 10.004 8.64218 9.82225 8.97305 9.49369L12 6.35412L15.0269 9.49369C15.3578 9.82225 15.801 10.004 16.2609 9.99993C16.7209 9.99582 17.1609 9.80615 17.4862 9.47173C17.8115 9.13731 17.9959 8.6849 17.9999 8.21198C18.0039 7.73906 17.8271 7.28344 17.5076 6.94326L13.2403 2.52848Z"/>
<path d="M10.7597 21.4715C11.0886 21.8098 11.5348 21.9999 12 22C12.4652 21.9999 12.9114 21.8098 13.2403 21.4715L17.5076 17.0567C17.8271 16.7166 18.0039 16.2609 17.9999 15.788C17.9959 15.3151 17.8115 14.8627 17.4862 14.5283C17.1609 14.1939 16.7209 14.0042 16.2609 14.0001C15.801 13.996 15.3578 14.1778 15.0269 14.5063L12 17.6459L8.97305 14.5063C8.64218 14.1778 8.19904 13.996 7.73907 14.0001C7.27909 14.0042 6.83907 14.1939 6.51381 14.5283C6.18855 14.8627 6.00406 15.3151 6.00007 15.788C5.99607 16.2609 6.17289 16.7166 6.49245 17.0567L10.7597 21.4715Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const unfold_less = {
  name: 'unfold_less',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M10.7597 9.47152C11.0886 9.8098 11.5348 9.9999 12 10C12.4652 9.9999 12.9114 9.8098 13.2403 9.47152L17.5076 5.05674C17.8271 4.71656 18.0039 4.26094 17.9999 3.78802C17.9959 3.3151 17.8115 2.86269 17.4862 2.52827C17.1609 2.19385 16.7209 2.00418 16.2609 2.00007C15.801 1.99596 15.3578 2.17775 15.0269 2.50631L12 5.64588L8.97305 2.50631C8.64218 2.17775 8.19904 1.99596 7.73907 2.00007C7.27909 2.00418 6.83907 2.19386 6.51381 2.52828C6.18855 2.8627 6.00406 3.3151 6.00007 3.78802C5.99607 4.26095 6.17289 4.71656 6.49245 5.05674L10.7597 9.47152Z"/>
<path d="M13.2403 14.5285C12.9114 14.1902 12.4652 14.0001 12 14C11.5348 14.0001 11.0886 14.1902 10.7597 14.5285L6.49245 18.9433C6.17289 19.2834 5.99607 19.7391 6.00007 20.212C6.00406 20.6849 6.18855 21.1373 6.51381 21.4717C6.83907 21.8061 7.27909 21.9958 7.73907 21.9999C8.19904 22.004 8.64218 21.8222 8.97305 21.4937L12 18.3541L15.0269 21.4937C15.3578 21.8222 15.801 22.004 16.2609 21.9999C16.7209 21.9958 17.1609 21.8061 17.4862 21.4717C17.8115 21.1373 17.9959 20.6849 17.9999 20.212C18.0039 19.7391 17.8271 19.2834 17.5076 18.9433L13.2403 14.5285Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const arrow_forward = {
  name: 'arrow_forward',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M4.00085 11.9436C3.99347 12.178 4.034 12.4115 4.12005 12.6303C4.20609 12.849 4.33589 13.0484 4.50174 13.2168C4.66758 13.3851 4.8661 13.519 5.0855 13.6103C5.30489 13.7017 5.54069 13.7487 5.7789 13.7486H14.136L11.6165 16.1733L11.5898 16.1996C11.2817 16.5108 11.1117 16.9297 11.117 17.3643C11.1224 17.7989 11.3026 18.2137 11.6183 18.5175C11.9413 18.8269 12.3741 19 12.8247 19C13.2753 19 13.7081 18.8269 14.0311 18.5175L19.5004 13.2234C19.6586 13.0703 19.7843 12.8878 19.8701 12.6864C19.9559 12.485 20 12.2688 20 12.0504V11.9576C20.0002 11.7387 19.9561 11.5219 19.8703 11.3199C19.7846 11.1179 19.6588 10.9348 19.5004 10.7811L14.0311 5.48876C13.8672 5.32979 13.6726 5.20469 13.4589 5.12081C13.2451 5.03693 13.0165 4.99596 12.7865 5.00031C12.3501 5.01251 11.9346 5.18704 11.6236 5.48876L11.5952 5.51677C11.2855 5.82747 11.1138 6.24653 11.1178 6.68184C11.1218 7.11714 11.3012 7.53307 11.6165 7.83821L14.12 10.2472L5.7789 10.2472C5.31673 10.247 4.87263 10.4239 4.54073 10.7406C4.20882 11.0573 4.01518 11.4888 4.00085 11.9436Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const arrow_back = {
  name: 'arrow_back',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M18.229 13.7483H9.87121L12.3839 16.1672L12.4106 16.1952C12.5638 16.3492 12.6846 16.5315 12.7662 16.7316C12.8478 16.9316 12.8885 17.1455 12.8861 17.361C12.8836 17.5766 12.8379 17.7895 12.7518 17.9877C12.6656 18.1859 12.5406 18.3654 12.3839 18.516C12.0608 18.8263 11.6272 19 11.1757 19C10.7242 19 10.2906 18.8263 9.9675 18.516L4.4996 13.2197C4.3412 13.0668 4.21543 12.8843 4.12963 12.683C4.04384 12.4816 3.99978 12.2654 4 12.0471L4 11.9543C3.9998 11.7354 4.04385 11.5187 4.12963 11.3168C4.21542 11.1148 4.34117 10.9317 4.4996 10.7782L9.9675 5.48717C10.2904 5.17494 10.7249 5 11.1775 5C11.6301 5 12.0646 5.17494 12.3874 5.48717L12.4106 5.51163C12.564 5.66543 12.6851 5.84754 12.767 6.04746C12.8489 6.24737 12.8899 6.46121 12.8878 6.67675C12.8857 6.8923 12.8404 7.10529 12.7545 7.30359C12.6687 7.50189 12.5439 7.68161 12.3874 7.83242L9.87832 10.2479L18.2219 10.2479C18.6935 10.2479 19.1458 10.4323 19.4792 10.7605C19.8127 11.0887 20 11.5339 20 11.9981C20 12.4623 19.8127 12.9074 19.4792 13.2356C19.1458 13.5638 18.6935 13.7483 18.2219 13.7483H18.229Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const arrow_downward = {
  name: 'arrow_downward',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M12.0564 4.00085C11.822 3.99347 11.5885 4.034 11.3697 4.12005C11.151 4.20609 10.9516 4.33589 10.7832 4.50174C10.6149 4.66758 10.481 4.8661 10.3897 5.0855C10.2983 5.30489 10.2513 5.54069 10.2514 5.7789V14.136L7.82669 11.6165L7.80043 11.5898C7.48918 11.2817 7.07026 11.1117 6.63567 11.117C6.20107 11.1224 5.78632 11.3026 5.48249 11.6183C5.17311 11.9413 5 12.3741 5 12.8247C5 13.2753 5.17311 13.7081 5.48249 14.0311L10.7766 19.5004C10.9297 19.6586 11.1122 19.7843 11.3136 19.8701C11.515 19.9559 11.7312 20 11.9496 20H12.0424C12.2613 20.0002 12.4781 19.9561 12.6801 19.8703C12.8821 19.7846 13.0652 19.6588 13.2189 19.5004L18.5112 14.0311C18.6702 13.8672 18.7953 13.6726 18.8792 13.4589C18.9631 13.2451 19.004 13.0165 18.9997 12.7865C18.9875 12.3501 18.813 11.9346 18.5112 11.6236L18.4832 11.5952C18.1725 11.2855 17.7535 11.1138 17.3182 11.1178C16.8829 11.1218 16.4669 11.3012 16.1618 11.6165L13.7528 14.12V5.7789C13.753 5.31673 13.5761 4.87263 13.2594 4.54073C12.9427 4.20882 12.5112 4.01518 12.0564 4.00085Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const arrow_upward = {
  name: 'arrow_upward',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M10.2517 18.229V9.87121L7.83279 12.3839L7.80481 12.4106C7.65078 12.5638 7.46849 12.6846 7.26845 12.7662C7.0684 12.8478 6.85454 12.8885 6.63899 12.8861C6.42344 12.8836 6.21049 12.8379 6.01231 12.7518C5.81414 12.6656 5.63459 12.5406 5.48402 12.3839C5.17367 12.0608 5 11.6272 5 11.1757C5 10.7242 5.17367 10.2906 5.48402 9.9675L10.7803 4.4996C10.9332 4.3412 11.1157 4.21543 11.317 4.12963C11.5184 4.04384 11.7346 3.99978 11.9529 4H12.0457C12.2646 3.9998 12.4813 4.04385 12.6832 4.12963C12.8852 4.21542 13.0683 4.34117 13.2218 4.4996L18.5128 9.9675C18.8251 10.2904 19 10.7249 19 11.1775C19 11.6301 18.8251 12.0646 18.5128 12.3874L18.4884 12.4106C18.3346 12.564 18.1525 12.6851 17.9525 12.767C17.7526 12.8489 17.5388 12.8899 17.3232 12.8878C17.1077 12.8857 16.8947 12.8404 16.6964 12.7545C16.4981 12.6687 16.3184 12.5439 16.1676 12.3874L13.7521 9.87832V18.2219C13.7521 18.6935 13.5677 19.1458 13.2395 19.4792C12.9113 19.8127 12.4661 20 12.0019 20C11.5377 20 11.0926 19.8127 10.7644 19.4792C10.4362 19.1458 10.2517 18.6935 10.2517 18.2219V18.229Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const chevron_down = {
  name: 'chevron_down',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M12 17C11.5348 16.9999 11.0886 16.8098 10.7597 16.4715L5.49245 11.0567C5.17289 10.7166 4.99607 10.2609 5.00007 9.78802C5.00406 9.3151 5.18855 8.86269 5.51381 8.52827C5.83907 8.19385 6.27909 8.00418 6.73907 8.00007C7.19904 7.99596 7.64218 8.17775 7.97305 8.50631L12 12.6459L16.027 8.50631C16.3578 8.17775 16.801 7.99596 17.2609 8.00007C17.7209 8.00418 18.1609 8.19386 18.4862 8.52827C18.8115 8.86269 18.9959 9.3151 18.9999 9.78802C19.0039 10.2609 18.8271 10.7166 18.5076 11.0567L13.2403 16.4715C12.9114 16.8098 12.4652 16.9999 12 17Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const chevron_up = {
  name: 'chevron_up',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M12 7.00001C12.4629 7.00011 12.9069 7.18943 13.2342 7.52633L18.467 12.9116C18.6338 13.0773 18.7668 13.2755 18.8583 13.4947C18.9498 13.7138 18.9979 13.9496 18.9999 14.1881C19.0019 14.4266 18.9578 14.6632 18.87 14.8839C18.7822 15.1047 18.6526 15.3052 18.4887 15.4739C18.3247 15.6425 18.1299 15.7759 17.9153 15.8662C17.7008 15.9565 17.4709 16.002 17.2391 15.9999C17.0073 15.9979 16.7783 15.9483 16.5653 15.8542C16.3523 15.76 16.1596 15.6232 15.9986 15.4516L12 11.3363L8.00135 15.4516C7.84032 15.6232 7.64771 15.76 7.43472 15.8542C7.22174 15.9483 6.99265 15.9979 6.76085 15.9999C6.52906 16.002 6.29918 15.9565 6.08463 15.8662C5.87009 15.7759 5.6752 15.6425 5.51129 15.4739C5.34738 15.3052 5.21778 15.1047 5.13 14.8839C5.04223 14.6632 4.99805 14.4266 5.00007 14.1881C5.00208 13.9496 5.05023 13.7138 5.14172 13.4947C5.23321 13.2755 5.36619 13.0773 5.53292 12.9116L10.7658 7.52633C10.9274 7.35895 11.1198 7.22625 11.3316 7.1359C11.5435 7.04556 11.7706 6.99937 12 7.00001Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const chevron_right = {
  name: 'chevron_right',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M17 12C16.9999 12.4652 16.8098 12.9114 16.4715 13.2403L11.0567 18.5076C10.7166 18.8271 10.2609 19.0039 9.78802 18.9999C9.3151 18.9959 8.86269 18.8115 8.52827 18.4862C8.19385 18.1609 8.00418 17.7209 8.00007 17.2609C7.99596 16.801 8.17775 16.3578 8.50631 16.027L12.6459 12L8.50631 7.97305C8.17775 7.64218 7.99596 7.19904 8.00007 6.73907C8.00418 6.27909 8.19385 5.83907 8.52827 5.51381C8.86269 5.18855 9.3151 5.00406 9.78802 5.00007C10.2609 4.99607 10.7166 5.17289 11.0567 5.49245L16.4715 10.7597C16.8098 11.0886 16.9999 11.5348 17 12Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const chevron_left = {
  name: 'chevron_left',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M7.00001 12C7.00011 11.5371 7.18943 11.0931 7.52633 10.7658L12.9116 5.53297C13.0773 5.36624 13.2755 5.23321 13.4947 5.14172C13.7138 5.05023 13.9496 5.00208 14.1881 5.00007C14.4266 4.99805 14.6632 5.04223 14.8839 5.13C15.1047 5.21778 15.3052 5.34743 15.4739 5.51134C15.6425 5.67525 15.7759 5.87015 15.8662 6.08469C15.9565 6.29923 16.002 6.52911 15.9999 6.7609C15.9979 6.9927 15.9483 7.22174 15.8542 7.43472C15.76 7.64771 15.6232 7.84037 15.4516 8.00141L11.3363 12L15.4516 15.9986C15.6232 16.1597 15.76 16.3523 15.8542 16.5653C15.9483 16.7783 15.9979 17.0074 15.9999 17.2391C16.002 17.4709 15.9565 17.7008 15.8662 17.9154C15.7759 18.1299 15.6425 18.3248 15.4739 18.4887C15.3052 18.6526 15.1047 18.7822 14.8839 18.87C14.6632 18.9578 14.4266 19.0019 14.1881 18.9999C13.9496 18.9979 13.7138 18.9498 13.4947 18.8583C13.2755 18.7668 13.0773 18.6338 12.9116 18.4671L7.52633 13.2342C7.35895 13.0726 7.22625 12.8802 7.1359 12.6684C7.04556 12.4565 6.99937 12.2294 7.00001 12Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const check = {
  name: 'check',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
<path d="M19.0329 5.00008C18.7694 4.99771 18.5081 5.04833 18.2646 5.14892C18.0211 5.2495 17.8003 5.39801 17.6153 5.5856L9.136 14.1629L6.38271 11.3931C6.19957 11.2083 5.98158 11.0615 5.74134 10.9613C5.5011 10.8612 5.24337 10.8096 4.98307 10.8096C4.72276 10.8096 4.46503 10.8612 4.22479 10.9613C3.98455 11.0615 3.76656 11.2083 3.58343 11.3931C3.2098 11.7677 3 12.2751 3 12.804C3 13.3329 3.2098 13.8402 3.58343 14.2148L7.73836 18.4113C7.92066 18.5977 8.13838 18.7458 8.37874 18.8468C8.61909 18.9479 8.87723 19 9.138 19C9.39876 19 9.6569 18.9479 9.89726 18.8468C10.1376 18.7458 10.3553 18.5977 10.5376 18.4113L20.4166 8.42125C20.7902 8.04667 21 7.53933 21 7.01042C21 6.48151 20.7902 5.97417 20.4166 5.59958C20.2368 5.41354 20.022 5.26481 19.7846 5.16193C19.5471 5.05905 19.2917 5.00405 19.0329 5.00008Z"/>
</svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const first_page = {
  name: 'first_page',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M4 17.222V6.778c0-.471.184-.924.513-1.257C4.84 5.187 5.286 5 5.75 5c.464 0 .91.187 1.238.52.328.334.512.787.512 1.258v10.444c0 .471-.184.924-.512 1.257-.328.334-.774.521-1.238.521-.464 0-.91-.187-1.237-.52A1.792 1.792 0 0 1 4 17.221ZM11.526 10.766A1.721 1.721 0 0 0 11 12c0 .23.046.457.136.668.09.212.223.405.39.566l5.386 5.233c.165.167.364.3.583.391a1.84 1.84 0 0 0 1.979-.37c.168-.163.302-.358.392-.573A1.703 1.703 0 0 0 19.452 16L15.336 12l4.116-3.999c.171-.16.308-.353.402-.566a1.703 1.703 0 0 0-.38-1.924 1.801 1.801 0 0 0-.59-.381 1.842 1.842 0 0 0-1.972.403l-5.386 5.233Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const last_page = {
  name: 'last_page',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path xmlns="http://www.w3.org/2000/svg" d="M17.013 18.48a1.793 1.793 0 0 1-.513-1.258V6.778c0-.471.184-.924.513-1.257.328-.334.773-.521 1.237-.521.464 0 .91.187 1.238.52.328.334.512.787.512 1.258v10.444c0 .471-.184.924-.512 1.257-.328.334-.774.521-1.238.521-.464 0-.91-.187-1.237-.52ZM12.472 13.24A1.73 1.73 0 0 0 13 12c0-.465-.19-.911-.528-1.24L7.057 5.492A1.831 1.831 0 0 0 5.788 5a1.83 1.83 0 0 0-1.26.514A1.73 1.73 0 0 0 4 6.739c-.004.46.178.903.506 1.234L8.646 12l-4.14 4.027c-.328.33-.51.774-.506 1.234.004.46.194.9.528 1.225.335.325.787.51 1.26.514.473.004.929-.173 1.269-.492l5.415-5.268Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const access_time = {
  name: 'access_time',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M10.5 8a1.5 1.5 0 0 1 3 0v2.5H16a1.5 1.5 0 1 1 0 3h-4a1.5 1.5 0 0 1-1.5-1.5V8Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12c0 5.523-4.476 10-10 10-5.522 0-10-4.477-10-10S6.479 2 12 2c5.524 0 10 4.477 10 10Zm-3 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const add = {
  name: 'add',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M10.2 13.8H5.8a1.8 1.8 0 0 1 0-3.6h4.4V5.8a1.8 1.8 0 1 1 3.6 0v4.4h4.4a1.8 1.8 0 0 1 0 3.6h-4.4v4.4a1.8 1.8 0 1 1-3.6 0v-4.4Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const attach_file = {
  name: 'attach_file',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="m16.496 10.809-7.63 7.365a.965.965 0 0 1-1.31 0 .844.844 0 0 1 0-1.24l6.59-6.382c.601-.601.59-1.55-.032-2.14a1.689 1.689 0 0 0-2.261-.03l-.033.03-6.558 6.351c-1.629 1.542-1.629 4.04 0 5.581 1.629 1.541 4.27 1.541 5.899 0l7.63-7.365c2.533-2.397 2.533-6.284 0-8.681-2.535-2.397-6.642-2.397-9.176 0L4.008 9.749l-.033.031a1.477 1.477 0 0 0 0 2.17 1.688 1.688 0 0 0 2.326-.03l5.608-5.452c1.267-1.198 3.32-1.198 4.587 0a2.954 2.954 0 0 1 0 4.34Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const block = {
  name: 'block',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M19.248 4.787c-.006-.007-.008-.014-.014-.02-.007-.007-.014-.009-.02-.015A10.232 10.232 0 0 0 4.751 19.213c.006.007.008.016.014.02.006.006.014.009.02.015A10.232 10.232 0 0 0 19.249 4.787ZM12 4.327c1.592 0 3.145.498 4.44 1.425L5.751 16.44A7.66 7.66 0 0 1 12 4.326Zm0 15.347a7.623 7.623 0 0 1-4.44-1.426L18.249 7.56A7.661 7.661 0 0 1 12 19.674Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const calendar_today = {
  name: 'calendar_today',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M18.299 4H17v-.5a1.5 1.5 0 1 0-3 0V4h-4v-.5a1.5 1.5 0 1 0-3 0V4H5.703A3.707 3.707 0 0 0 2 7.702v10.595A3.707 3.707 0 0 0 5.703 22h12.596A3.706 3.706 0 0 0 22 18.297V7.702A3.707 3.707 0 0 0 18.299 4ZM5.703 7H7v.5a1.5 1.5 0 0 0 3 0V7h4v.5a1.5 1.5 0 0 0 3 0V7h1.298a.704.704 0 0 1 .702.702v2.655H5V7.703A.703.703 0 0 1 5.703 7Zm12.596 12H5.703A.704.704 0 0 1 5 18.297v-4.94h14v4.94a.704.704 0 0 1-.702.703Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const cancel = {
  name: 'cancel',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.524 0 10-4.477 10-10 0-5.522-4.476-10-10-10C6.479 2 2 6.478 2 12c0 5.523 4.478 10 10 10ZM7.438 9.543a1.49 1.49 0 0 1 2.106-2.106l2.458 2.457 2.457-2.457a1.489 1.489 0 1 1 2.106 2.106L14.107 12l2.457 2.457a1.49 1.49 0 0 1-2.106 2.107l-2.457-2.458-2.458 2.458a1.489 1.489 0 1 1-2.106-2.107L9.894 12 7.437 9.543Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const check_circle = {
  name: 'check_circle',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.445 3.685a10 10 0 1 1 11.111 16.63A10 10 0 0 1 6.445 3.685Zm10.22 3.923a1.294 1.294 0 0 0-.523-.108 1.294 1.294 0 0 0-.947.424l-4.761 5.131-1.626-1.703a1.297 1.297 0 0 0-1.911 0c-.254.27-.396.632-.396 1.009 0 .376.142.738.396 1.008l2.59 2.712c.124.133.272.238.436.31a1.29 1.29 0 0 0 1.473-.31l3.547-3.815 2.162-2.33c.254-.27.396-.632.396-1.008 0-.377-.142-.738-.396-1.01a1.325 1.325 0 0 0-.44-.31Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const error = {
  name: 'error',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.685 17.556a10 10 0 1 1 16.63-11.112 10 10 0 0 1-16.63 11.112ZM10.5 11.5v-4a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 1 1-3 0Zm.253 5.833a1.5 1.5 0 1 1 2.495-1.667 1.5 1.5 0 0 1-2.495 1.667Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const file_download = {
  name: 'file_download',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M10.41 11.21V3.616c0-.43.167-.84.466-1.144A1.578 1.578 0 0 1 12 2c.422 0 .826.17 1.125.473.298.304.466.715.466 1.144v7.586l2.195-2.282a1.49 1.49 0 0 1 1.05-.455 1.47 1.47 0 0 1 1.06.434l.022.021c.284.294.443.689.443 1.1 0 .412-.16.807-.443 1.1l-4.81 4.972a1.496 1.496 0 0 1-1.069.454h-.084a1.47 1.47 0 0 1-1.066-.454L6.076 11.12a1.586 1.586 0 0 1-.44-1.098c0-.41.158-.805.44-1.098a1.49 1.49 0 0 1 1.05-.457 1.47 1.47 0 0 1 1.06.432l.025.025 2.199 2.284Z"/><path d="M20.41 14.729a1.59 1.59 0 0 0-1.592 1.591v1.613a.886.886 0 0 1-.884.884H6.07a.892.892 0 0 1-.89-.884V16.32a1.591 1.591 0 0 0-3.181 0v1.618A4.087 4.087 0 0 0 6.066 22h11.868A4.07 4.07 0 0 0 22 17.931V16.32a1.59 1.59 0 0 0-1.59-1.591Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const file_upload = {
  name: 'file_upload',
  categories: ['editor'],
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M13.59 14.927v-7.59L15.79 9.62l.026.024a1.489 1.489 0 0 0 1.06.432 1.473 1.473 0 0 0 1.05-.456c.281-.294.439-.688.439-1.098 0-.41-.158-.805-.44-1.099l-4.814-4.97A1.49 1.49 0 0 0 12.044 2h-.085a1.479 1.479 0 0 0-1.069.454l-4.81 4.97a1.582 1.582 0 0 0-.442 1.1c0 .412.16.806.443 1.1l.022.02a1.489 1.489 0 0 0 1.06.435 1.47 1.47 0 0 0 1.05-.455l2.195-2.28v7.583c0 .429.168.84.466 1.143.299.303.703.474 1.125.474.422 0 .827-.17 1.125-.474a1.63 1.63 0 0 0 .466-1.143Z"/><path d="M19.284 15.197A1.59 1.59 0 0 1 22 16.32v1.611A4.071 4.071 0 0 1 17.934 22H6.066A4.085 4.085 0 0 1 2 17.939V16.32a1.59 1.59 0 0 1 3.182 0v1.613a.892.892 0 0 0 .89.884h11.862a.886.886 0 0 0 .884-.884v-1.613c0-.422.168-.826.466-1.124Z"/></svg>`,
  fontSet: 'indigo'
};
const filter_list = {
  name: 'filter_list',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M4.616 7.682h14.768c.428 0 .84-.168 1.143-.466.303-.298.473-.703.473-1.125 0-.422-.17-.827-.473-1.125a1.63 1.63 0 0 0-1.143-.466H4.616c-.428 0-.84.168-1.143.466A1.579 1.579 0 0 0 3 6.091c0 .422.17.827.473 1.125a1.63 1.63 0 0 0 1.143.466ZM7.344 13.591h9.312c.429 0 .84-.168 1.143-.466.303-.299.474-.703.474-1.125 0-.422-.17-.827-.474-1.125a1.63 1.63 0 0 0-1.143-.466H7.344c-.429 0-.84.167-1.143.466A1.579 1.579 0 0 0 5.727 12c0 .422.17.827.474 1.125a1.63 1.63 0 0 0 1.143.466ZM13.929 19.5h-3.858a1.63 1.63 0 0 1-1.143-.466 1.578 1.578 0 0 1-.473-1.125c0-.422.17-.826.473-1.125a1.63 1.63 0 0 1 1.143-.466h3.858c.429 0 .84.167 1.143.466.303.298.474.703.474 1.125 0 .422-.17.827-.474 1.125a1.63 1.63 0 0 1-1.143.466Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const horizontal_rule = {
  name: 'horizontal_rule',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M5.778 13.5h12.444c.471 0 .924-.184 1.257-.512.334-.329.521-.774.521-1.238 0-.464-.187-.91-.52-1.237A1.793 1.793 0 0 0 18.221 10H5.778c-.471 0-.924.184-1.257.513-.334.328-.521.773-.521 1.237 0 .464.187.91.52 1.238.334.328.787.512 1.258.512Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const info = {
  name: 'info',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.686 6.944a10 10 0 1 0 16.63 11.112A10 10 0 0 0 3.685 6.944Zm6.815 5.556V17a1.5 1.5 0 0 0 3 0v-4.5a1.5 1.5 0 1 0-3 0Zm.253-5.333a1.5 1.5 0 1 0 2.494 1.666 1.5 1.5 0 0 0-2.494-1.666Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const menu = {
  name: 'menu',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M4.616 7.682h14.768c.428 0 .84-.168 1.143-.466.303-.299.473-.703.473-1.125 0-.422-.17-.827-.473-1.125a1.63 1.63 0 0 0-1.143-.466H4.616c-.428 0-.84.168-1.143.466A1.578 1.578 0 0 0 3 6.09c0 .422.17.826.473 1.125a1.63 1.63 0 0 0 1.143.466ZM4.616 13.59h14.768c.428 0 .84-.167 1.143-.465.303-.299.473-.703.473-1.125 0-.422-.17-.827-.473-1.125a1.63 1.63 0 0 0-1.143-.466H4.616c-.428 0-.84.167-1.143.466A1.578 1.578 0 0 0 3 12c0 .422.17.826.473 1.125a1.63 1.63 0 0 0 1.143.466ZM19.384 19.5H4.616a1.63 1.63 0 0 1-1.143-.466A1.578 1.578 0 0 1 3 17.909c0-.422.17-.826.473-1.125a1.63 1.63 0 0 1 1.143-.466h14.768c.428 0 .84.168 1.143.466.303.299.473.703.473 1.125 0 .422-.17.827-.473 1.125a1.63 1.63 0 0 1-1.143.466Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const pin = {
  name: 'pin',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.12 2.516A1.572 1.572 0 0 0 16.966 2H7.034c-.435 0-.85.187-1.154.516a1.814 1.814 0 0 0-.472 1.23c0 .46.168.902.472 1.23.304.33.72.516 1.154.516h.169v3.023a6.54 6.54 0 0 0-1.977 2.382c-.535 1.083-.782 2.444-.715 3.669.006.45.174.882.472 1.204.304.329.719.516 1.153.516h4.238v3.825c-.01.073-.015.147-.015.222 0 .92.735 1.667 1.641 1.667s1.64-.746 1.64-1.667c0-.075-.004-.15-.014-.222v-3.825h4.238c.434 0 .849-.187 1.153-.516.298-.322.466-.754.473-1.204.066-1.225-.181-2.586-.716-3.67a6.54 6.54 0 0 0-1.977-2.38V5.491h.17c.434 0 .849-.186 1.153-.515.304-.329.472-.772.472-1.23 0-.46-.168-.903-.472-1.231ZM8.005 12.114c-.114.169-.288.708-.288 1.076h8.566c0-.368-.174-.907-.289-1.076a2.738 2.738 0 0 0-1.051-.925 1.645 1.645 0 0 1-.764-.624 1.836 1.836 0 0 1-.304-1.016V5.095h-3.75V9.55c0 .364-.106.719-.304 1.016-.19.285-.456.503-.764.624-.417.205-.779.523-1.052.925Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const refresh = {
  name: 'refresh',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M14.068 3.247a9.05 9.05 0 0 0-8.98 2.925c-1.08 1.263-1.79 2.35-2.054 3.991a1.58 1.58 0 0 0-.034.315v.003A1.519 1.519 0 0 0 4.504 12a1.458 1.458 0 0 0 1.515-1.184l.002-.012.002-.012c.148-1.107.602-1.702 1.312-2.565a5.999 5.999 0 0 1 8.533-.75l-1.314 1.308a1.396 1.396 0 0 0-.314.445.761.761 0 0 0-.015.582.756.756 0 0 0 .418.406c.163.07.347.095.531.095H20.03A.985.985 0 0 0 21 9.348v-4.84c0-.323-.09-.772-.5-.94-.407-.17-.79.084-1.022.315l-1.45 1.444a9.05 9.05 0 0 0-3.96-2.08ZM3.977 13.687H3.97A.984.984 0 0 0 3 14.65v4.84c0 .324.09.773.499.942.408.17.79-.084 1.023-.315l1.45-1.444a9.049 9.049 0 0 0 12.94-.845c1.08-1.263 1.79-2.35 2.054-3.991.022-.104.033-.209.034-.315v-.003A1.518 1.518 0 0 0 19.496 12a1.458 1.458 0 0 0-1.513 1.184l-.002.012-.002.012c-.148 1.108-.602 1.702-1.312 2.565a6 6 0 0 1-8.535.75l1.314-1.308c.133-.132.246-.281.314-.445a.76.76 0 0 0 .015-.582.756.756 0 0 0-.418-.406 1.364 1.364 0 0 0-.531-.095h-4.85Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const search = {
  name: 'search',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path d="M10.393 3a7.393 7.393 0 1 0 4.068 13.567l3.996 3.997a1.49 1.49 0 1 0 2.107-2.107l-3.997-3.996A7.393 7.393 0 0 0 10.393 3ZM6 10.393a4.393 4.393 0 1 1 8.786 0 4.393 4.393 0 0 1-8.786 0Z"></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const send = {
  name: 'send',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.302 10.84S5.5 2.591 4.352 2.13C3.207 1.666 3 2.59 3 2.59v17.791c0 .277.077.549.223.79.146.242.356.444.611.589a1.871 1.871 0 0 0 1.708.064l14.5-8.216c.29-.136.533-.343.702-.6.17-.256.258-.551.256-.851a1.528 1.528 0 0 0-.267-.85 1.672 1.672 0 0 0-.431-.433v-.035ZM6.5 10.021V6.803l9.5 5.385-9.5 5.555v-3.146l3.583-.645.036-.01a1.76 1.76 0 0 0 .913-.572 1.54 1.54 0 0 0 .361-.964 1.535 1.535 0 0 0-.336-.972 1.753 1.753 0 0 0-.898-.593l-.034-.01-3.625-.81Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const unpin = {
  name: 'unpin',
  value: `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.474 19.223a1.633 1.633 0 0 0 0 2.3 1.614 1.614 0 0 0 2.29 0l5.11-5.105v3.693c-.01.073-.015.147-.015.222 0 .92.735 1.667 1.641 1.667s1.64-.746 1.64-1.667a1.77 1.77 0 0 0-.014-.222v-3.825h4.237c.435 0 .85-.187 1.154-.516.298-.322.466-.754.472-1.204.067-1.225-.18-2.586-.715-3.67A6.66 6.66 0 0 0 17.09 9.21l4.436-4.432a1.633 1.633 0 0 0 0-2.3 1.614 1.614 0 0 0-2.29 0L2.474 19.223Zm12.381-7.781-1.75 1.748h2.678c0-.368-.174-.907-.288-1.076a2.798 2.798 0 0 0-.64-.672Z"/><path d="M12.614 5.095h-2.99v2.986l-5.609 5.605c.061-.969.302-1.96.71-2.79a6.54 6.54 0 0 1 1.978-2.38V5.491h-.17c-.434 0-.849-.186-1.153-.515a1.814 1.814 0 0 1-.472-1.23c0-.46.168-.903.472-1.231A1.572 1.572 0 0 1 6.534 2h9.178l-3.098 3.095Z"/></svg>`,
  categories: ['editor'],
  fontSet: 'indigo'
};
const IndigoIcons = new Map(Object.entries({
  clear: clear$1,
  unfold_more,
  unfold_less,
  arrow_forward,
  arrow_back,
  arrow_downward,
  arrow_upward,
  chevron_down,
  chevron_up,
  chevron_right,
  chevron_left,
  check,
  first_page,
  last_page,
  access_time,
  add,
  attach_file,
  block,
  calendar_today,
  cancel,
  check_circle,
  error,
  file_download,
  file_upload,
  filter_list,
  horizontal_rule,
  info,
  menu,
  pin,
  refresh,
  search,
  send,
  unpin
}));

/**
 * **Ignite UI for Angular Icon Service** -
 *
 * The Ignite UI Icon Service makes it easy for developers to include custom SVG images and use them with IgxIconComponent.
 * In addition it could be used to associate a custom class to be applied on IgxIconComponent according to given font-family.
 *
 * Example:
 * ```typescript
 * this.iconService.setFamily('material', { className: 'material-icons', type: 'font' });
 * this.iconService.addSvgIcon('aruba', '/assets/svg/country_flags/aruba.svg', 'svg-flags');
 * ```
 */
let IgxIconService = /*#__PURE__*/(() => {
  class IgxIconService {
    constructor(_sanitizer, _httpClient, _platformUtil, _themeToken, _destroyRef, document) {
      this._sanitizer = _sanitizer;
      this._httpClient = _httpClient;
      this._platformUtil = _platformUtil;
      this._themeToken = _themeToken;
      this._destroyRef = _destroyRef;
      this.document = document;
      this._defaultFamily = {
        name: "material",
        meta: {
          className: "material-icons",
          type: "liga"
        }
      };
      this._iconRefs = new Map();
      this._families = new Map();
      this._cachedIcons = new Map();
      this._iconLoaded = new Subject();
      this.iconLoaded = this._iconLoaded.asObservable();
      this.setFamily(this._defaultFamily.name, this._defaultFamily.meta);
      const themeChange = this._themeToken?.onChange(theme => {
        this.setRefsByTheme(theme);
      });
      this._destroyRef.onDestroy(() => themeChange?.unsubscribe());
      if (this._platformUtil?.isBrowser) {
        this._domParser = new DOMParser();
        for (const [name, svg] of IndigoIcons) {
          this.addSvgIconFromText(name, svg.value, `internal_${svg.fontSet}`, true);
        }
      }
    }
    /**
     *  Returns the default font-family.
     * ```typescript
     *   const defaultFamily = this.iconService.defaultFamily;
     * ```
     */
    get defaultFamily() {
      return this._defaultFamily;
    }
    /**
     *  Sets the default font-family.
     * ```typescript
     *   this.iconService.defaultFamily = 'svg-flags';
     * ```
     */
    set defaultFamily(family) {
      this._defaultFamily = family;
      this.setFamily(this._defaultFamily.name, this._defaultFamily.meta);
    }
    /**
     *  Registers a custom class to be applied to IgxIconComponent for a given font-family.
     * ```typescript
     *   this.iconService.registerFamilyAlias('material', 'material-icons');
     * ```
     * @deprecated in version 18.1.0. Use `setFamily` instead.
     */
    registerFamilyAlias(alias, className = alias, type = "font") {
      this.setFamily(alias, {
        className,
        type
      });
      return this;
    }
    /**
     *  Returns the custom class, if any, associated to a given font-family.
     * ```typescript
     *   const familyClass = this.iconService.familyClassName('material');
     * ```
     */
    familyClassName(alias) {
      return this._families.get(alias)?.className || alias;
    }
    /** @hidden @internal */
    familyType(alias) {
      return this._families.get(alias)?.type;
    }
    /** @hidden @internal */
    setRefsByTheme(theme) {
      for (const {
        alias,
        target
      } of iconReferences) {
        const external = this._iconRefs.get(alias.family)?.get(alias.name)?.external;
        const _ref = this._iconRefs.get('default')?.get(alias.name) ?? {};
        const _target = target.get(theme) ?? target.get('default');
        const icon = target.get(theme) ?? target.get('default');
        const overwrite = !external && !(JSON.stringify(_ref) === JSON.stringify(_target));
        this._setIconRef(alias.name, alias.family, icon, overwrite);
      }
    }
    /**
     *  Creates a family to className relationship that is applied to the IgxIconComponent
     *   whenever that family name is used.
     * ```typescript
     *   this.iconService.setFamily('material', { className: 'material-icons', type: 'liga' });
     * ```
     */
    setFamily(name, meta) {
      this._families.set(name, meta);
    }
    /**
     *  Adds an icon reference meta for an icon in a meta family.
     *  Executes only if no icon reference is found.
     * ```typescript
     *   this.iconService.addIconRef('aruba', 'default', { name: 'aruba', family: 'svg-flags' });
     * ```
     */
    addIconRef(name, family, icon) {
      const iconRef = this._iconRefs.get(family)?.get(name);
      if (!iconRef) {
        this.setIconRef(name, family, icon);
      }
    }
    _setIconRef(name, family, icon, overwrite = false) {
      if (overwrite) {
        this.setIconRef(name, family, {
          ...icon,
          external: false
        });
      }
    }
    /**
     *  Similar to addIconRef, but always sets the icon reference meta for an icon in a meta family.
     * ```typescript
     *   this.iconService.setIconRef('aruba', 'default', { name: 'aruba', family: 'svg-flags' });
     * ```
     */
    setIconRef(name, family, icon) {
      let familyRef = this._iconRefs.get(family);
      if (!familyRef) {
        familyRef = new Map();
        this._iconRefs.set(family, familyRef);
      }
      const external = icon.external ?? true;
      const familyType = this.familyType(icon?.family);
      familyRef.set(name, {
        ...icon,
        type: icon.type ?? familyType,
        external
      });
      this._iconLoaded.next({
        name,
        family
      });
    }
    /**
     *  Returns the icon reference meta for an icon in a given family.
     * ```typescript
     *   const iconRef = this.iconService.getIconRef('aruba', 'default');
     * ```
     */
    getIconRef(name, family) {
      const icon = this._iconRefs.get(family)?.get(name);
      const iconFamily = icon?.family ?? family;
      const _name = icon?.name ?? name;
      const className = this.familyClassName(iconFamily);
      const prefix = this._families.get(iconFamily)?.prefix;
      // Handle name prefixes
      let iconName = _name;
      if (iconName && prefix) {
        iconName = _name.includes(prefix) ? _name : `${prefix}${_name}`;
      }
      const cached = this.isSvgIconCached(iconName, iconFamily);
      const type = cached ? "svg" : icon?.type ?? this.familyType(iconFamily);
      return {
        className,
        type,
        name: iconName,
        family: iconFamily
      };
    }
    getOrCreateSvgFamily(family) {
      if (!this._families.has(family)) {
        this._families.set(family, {
          className: family,
          type: "svg"
        });
      }
      return this._families.get(family);
    }
    /**
     *  Adds an SVG image to the cache. SVG source is an url.
     * ```typescript
     *   this.iconService.addSvgIcon('aruba', '/assets/svg/country_flags/aruba.svg', 'svg-flags');
     * ```
     */
    addSvgIcon(name, url, family = this._defaultFamily.name, stripMeta = false) {
      if (name && url) {
        const safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
        if (!safeUrl) {
          throw new Error(`The provided URL could not be processed as trusted resource URL by Angular's DomSanitizer: "${url}".`);
        }
        const sanitizedUrl = this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, safeUrl);
        if (!sanitizedUrl) {
          throw new Error(`The URL provided was not trusted as a resource URL: "${url}".`);
        }
        if (!this.isSvgIconCached(name, family)) {
          this.getOrCreateSvgFamily(family);
          this.fetchSvg(url).subscribe(res => {
            this.cacheSvgIcon(name, res, family, stripMeta);
          });
        }
      } else {
        throw new Error("You should provide at least `name` and `url` to register an svg icon.");
      }
    }
    /**
     *  Adds an SVG image to the cache. SVG source is its text.
     * ```typescript
     *   this.iconService.addSvgIconFromText('simple', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
     *   <path d="M74 74h54v54H74" /></svg>', 'svg-flags');
     * ```
     */
    addSvgIconFromText(name, iconText, family = this._defaultFamily.name, stripMeta = false) {
      if (name && iconText) {
        if (this.isSvgIconCached(name, family)) {
          return;
        }
        this.getOrCreateSvgFamily(family);
        this.cacheSvgIcon(name, iconText, family, stripMeta);
      } else {
        throw new Error("You should provide at least `name` and `iconText` to register an svg icon.");
      }
    }
    /**
     *  Returns whether a given SVG image is present in the cache.
     * ```typescript
     *   const isSvgCached = this.iconService.isSvgIconCached('aruba', 'svg-flags');
     * ```
     */
    isSvgIconCached(name, family) {
      if (this._cachedIcons.has(family)) {
        const familyRegistry = this._cachedIcons.get(family);
        return familyRegistry.has(name);
      }
      return false;
    }
    /**
     *  Returns the cached SVG image as string.
     * ```typescript
     *   const svgIcon = this.iconService.getSvgIcon('aruba', 'svg-flags');
     * ```
     */
    getSvgIcon(name, family) {
      return this._cachedIcons.get(family)?.get(name);
    }
    /**
     * @hidden
     */
    fetchSvg(url) {
      const req = this._httpClient.get(url, {
        responseType: "text"
      });
      return req;
    }
    /**
     * @hidden
     */
    cacheSvgIcon(name, value, family = this._defaultFamily.name, stripMeta) {
      if (this._platformUtil?.isBrowser && name && value) {
        const doc = this._domParser.parseFromString(value, "image/svg+xml");
        const svg = doc.querySelector("svg");
        if (!this._cachedIcons.has(family)) {
          this._cachedIcons.set(family, new Map());
        }
        if (svg) {
          svg.setAttribute("fit", "");
          svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
          if (stripMeta) {
            const title = svg.querySelector("title");
            const desc = svg.querySelector("desc");
            if (title) {
              svg.removeChild(title);
            }
            if (desc) {
              svg.removeChild(desc);
            }
          }
          const safeSvg = this._sanitizer.bypassSecurityTrustHtml(svg.outerHTML);
          this._cachedIcons.get(family).set(name, safeSvg);
          this._iconLoaded.next({
            name,
            value,
            family
          });
        }
      }
    }
    static {
      this.ɵfac = function IgxIconService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxIconService)(i0.ɵɵinject(i1$1.DomSanitizer, 8), i0.ɵɵinject(i2.HttpClient, 8), i0.ɵɵinject(PlatformUtil, 8), i0.ɵɵinject(THEME_TOKEN, 8), i0.ɵɵinject(DestroyRef, 8), i0.ɵɵinject(DOCUMENT, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxIconService,
        factory: IgxIconService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return IgxIconService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Icon provides a way to include material icons to markup
 *
 * @igxModule IgxIconModule
 *
 * @igxTheme igx-icon-theme
 *
 * @igxKeywords icon, picture
 *
 * @igxGroup Display
 *
 * @remarks
 *
 * The Ignite UI Icon makes it easy for developers to include material design icons directly in their markup. The icons
 * support different icon families and can be marked as active or disabled using the `active` property. This will change the appearance
 * of the icon.
 *
 * @example
 * ```html
 * <igx-icon family="filter-icons" active="true">home</igx-icon>
 * ```
 */
let IgxIconComponent = /*#__PURE__*/(() => {
  class IgxIconComponent {
    get elementClasses() {
      const icon = Array.from(this._iconClasses).join(" ");
      const user = Array.from(this._userClasses).join(" ");
      return `igx-icon ${icon} ${user}`.trim();
    }
    addIconClass(className) {
      this._iconClasses.add(className);
    }
    clearIconClasses() {
      this._iconClasses.clear();
    }
    /**
     *  An accessor that returns inactive property.
     *
     * @example
     * ```typescript
     * @ViewChild("MyIcon")
     * public icon: IgxIconComponent;
     * ngAfterViewInit() {
     *    let iconActive = this.icon.getInactive;
     * }
     * ```
     */
    get getInactive() {
      return !this.active;
    }
    constructor(el, iconService, ref) {
      this.el = el;
      this.iconService = iconService;
      this.ref = ref;
      this._destroy$ = new Subject();
      this._userClasses = new Set();
      this._iconClasses = new Set();
      /**
       * An @Input property that allows you to disable the `active` property. By default it's applied.
       *
       * @example
       * ```html
       * <igx-icon [active]="false">settings</igx-icon>
       * ```
       */
      this.active = true;
      this.family = this.iconService.defaultFamily.name;
      this.iconService.iconLoaded.pipe(filter(e => e.name === this.name && e.family === this.family), takeUntil(this._destroy$)).subscribe(() => {
        this.setIcon();
        this.ref.detectChanges();
      });
    }
    /**
     * @hidden
     * @internal
     */
    ngOnInit() {
      this.setIcon();
    }
    /**
     * @hidden
     * @internal
     */
    ngOnChanges() {
      this.setIcon();
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this._destroy$.next();
      this._destroy$.complete();
    }
    get iconRef() {
      return this._iconRef;
    }
    set iconRef(ref) {
      this._iconRef = ref;
    }
    /**
     *  An accessor that returns the value of the family property.
     *
     * @example
     * ```typescript
     *  @ViewChild("MyIcon")
     * public icon: IgxIconComponent;
     * ngAfterViewInit() {
     *    let iconFamily = this.icon.getFamily;
     * }
     * ```
     */
    get getFamily() {
      return this.iconRef.family;
    }
    /**
     *  An accessor that returns the value of the active property.
     *
     * @example
     * ```typescript
     * @ViewChild("MyIcon")
     * public icon: IgxIconComponent;
     * ngAfterViewInit() {
     *    let iconActive = this.icon.getActive;
     * }
     * ```
     */
    get getActive() {
      return this.active;
    }
    /**
     * An accessor that returns the value of the iconName property.
     *
     * @example
     * ```typescript
     * @ViewChild("MyIcon")
     * public icon: IgxIconComponent;
     * ngAfterViewInit() {
     *    let name = this.icon.getName;
     * }
     * ```
     */
    get getName() {
      return this.iconRef.name;
    }
    /**
     *  An accessor that returns the underlying SVG image as SafeHtml.
     *
     * @example
     * ```typescript
     * @ViewChild("MyIcon")
     * public icon: IgxIconComponent;
     * ngAfterViewInit() {
     *    let svg: SafeHtml = this.icon.getSvg;
     * }
     * ```
     */
    get getSvg() {
      const {
        name,
        family
      } = this.iconRef;
      if (this.iconService.isSvgIconCached(name, family)) {
        return this.iconService.getSvgIcon(name, family);
      }
      return null;
    }
    /**
     * @hidden
     * @internal
     */
    setIcon() {
      this.iconRef = this.iconService.getIconRef(this.name, this.family);
      this.clearIconClasses();
      const {
        name,
        type,
        className
      } = this.iconRef;
      if (name && type === "font") {
        this.addIconClass(name);
      }
      this.addIconClass(className);
    }
    static {
      this.ɵfac = function IgxIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxIconComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxIconService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxIconComponent,
        selectors: [["igx-icon"]],
        hostVars: 4,
        hostBindings: function IgxIconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.elementClasses);
            i0.ɵɵclassProp("igx-icon--inactive", ctx.getInactive);
          }
        },
        inputs: {
          family: "family",
          name: "name",
          active: [2, "active", "active", booleanAttribute]
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [[3, "innerHTML"]],
        template: function IgxIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxIconComponent_Conditional_0_Template, 1, 0)(1, IgxIconComponent_Case_1_Template, 1, 1)(2, IgxIconComponent_Case_2_Template, 1, 1, "div", 0);
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵconditional(!ctx.iconRef.name ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_1_0 = ctx.iconRef.type) === "liga" ? 1 : tmp_1_0 === "svg" ? 2 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class igxI18N {
  constructor() {
    this._currentResourceStrings = {};
  }
  static instance() {
    return this._instance || (this._instance = new this());
  }
  /**
   * Changes the resource strings for all components in the application
   * ```
   * @param resourceStrings to be applied
   */
  changei18n(resourceStrings) {
    for (const key of Object.keys(resourceStrings)) {
      this._currentResourceStrings[key] = resourceStrings[key];
    }
  }
  getCurrentResourceStrings(en) {
    for (const key of Object.keys(en)) {
      if (!this._currentResourceStrings[key]) {
        this._currentResourceStrings[key] = en[key];
      }
    }
    return this._currentResourceStrings;
  }
}
function getCurrentResourceStrings(en) {
  return igxI18N.instance().getCurrentResourceStrings(en);
}
function changei18n(resourceStrings) {
  igxI18N.instance().changei18n(resourceStrings);
}
let IgxInputGroupComponent = /*#__PURE__*/(() => {
  class IgxInputGroupComponent {
    /**
     * Sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * Returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /** @hidden */
    get validClass() {
      return this.input.valid === IgxInputState.VALID;
    }
    /** @hidden */
    get invalidClass() {
      return this.input.valid === IgxInputState.INVALID;
    }
    /** @hidden */
    get isFilled() {
      return this._filled || this.input && this.input.value;
    }
    /** @hidden */
    get textAreaClass() {
      return this.input.isTextArea;
    }
    /**
     * Sets how the input will be styled.
     * Allowed values of type IgxInputGroupType.
     * ```html
     * <igx-input-group [type]="'search'">
     * ```
     */
    set type(value) {
      this._type = value;
    }
    /**
     * Returns the type of the `IgxInputGroupComponent`. How the input is styled.
     * The default is `line`.
     * ```typescript
     * @ViewChild("MyInputGroup")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let inputType = this.inputGroup.type;
     * }
     * ```
     */
    get type() {
      return this._type || this._inputGroupType || 'line';
    }
    /**
     * Sets the theme of the input.
     * Allowed values of type IgxInputGroupTheme.
     * ```typescript
     * @ViewChild("MyInputGroup")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit() {
     *  let inputTheme = 'fluent';
     * }
     */
    set theme(value) {
      this._theme = value;
    }
    /**
     * Returns the theme of the input.
     * The returned value is of type IgxInputGroupType.
     * ```typescript
     * @ViewChild("MyInputGroup")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit() {
     *  let inputTheme = this.inputGroup.theme;
     * }
     */
    get theme() {
      return this._theme;
    }
    constructor(element, _inputGroupType, document, platform, cdr, themeToken) {
      this.element = element;
      this._inputGroupType = _inputGroupType;
      this.document = document;
      this.platform = platform;
      this.cdr = cdr;
      this.themeToken = themeToken;
      /**
       * Property that enables/disables the auto-generated class of the `IgxInputGroupComponent`.
       * By default applied the class is applied.
       * ```typescript
       *  @ViewChild("MyInputGroup")
       *  public inputGroup: IgxInputGroupComponent;
       *  ngAfterViewInit(){
       *  this.inputGroup.defaultClass = false;
       * ```
       * }
       */
      this.defaultClass = true;
      /** @hidden */
      this.hasPlaceholder = false;
      /** @hidden */
      this.isRequired = false;
      /** @hidden */
      this.isFocused = false;
      /**
       * @hidden @internal
       * When truthy, disables the `IgxInputGroupComponent`.
       * Controlled by the underlying `IgxInputDirective`.
       * ```html
       * <igx-input-group [disabled]="true"></igx-input-group>
       * ```
       */
      this.disabled = false;
      /**
       * Prevents automatically focusing the input when clicking on other elements in the input group (e.g. prefix or suffix).
       *
       * @remarks Automatic focus causes software keyboard to show on mobile devices.
       *
       * @example
       * ```html
       * <igx-input-group [suppressInputAutofocus]="true"></igx-input-group>
       * ```
       */
      this.suppressInputAutofocus = false;
      /** @hidden */
      this.hasWarning = false;
      this._destroyRef = inject(DestroyRef);
      this._type = null;
      this._filled = false;
      this._resourceStrings = getCurrentResourceStrings(InputResourceStringsEN);
      this._theme = this.themeToken.theme;
      const themeChange = this.themeToken.onChange(theme => {
        if (this._theme !== theme) {
          this._theme = theme;
          this.cdr.detectChanges();
        }
      });
      this._destroyRef.onDestroy(() => themeChange.unsubscribe());
    }
    /** @hidden */
    onClick(event) {
      if (!this.isFocused && event.target !== this.input.nativeElement && !this.suppressInputAutofocus) {
        this.input.focus();
      }
    }
    /** @hidden */
    onPointerDown(event) {
      if (this.isFocused && event.target !== this.input.nativeElement) {
        event.preventDefault();
      }
    }
    /** @hidden @internal */
    hintClickHandler(event) {
      event.stopPropagation();
    }
    /**
     * Returns whether the `IgxInputGroupComponent` has hints.
     * ```typescript
     * @ViewChild("MyInputGroup")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let inputHints = this.inputGroup.hasHints;
     * }
     * ```
     */
    get hasHints() {
      return this.hints.length > 0;
    }
    /** @hidden @internal */
    get hasPrefixes() {
      return this._prefixes.length > 0 || this.isFileType;
    }
    /** @hidden @internal */
    set prefixes(items) {
      this._prefixes = items;
    }
    /** @hidden @internal */
    get hasSuffixes() {
      return this._suffixes.length > 0 || this.isFileType && this.isFilled;
    }
    /** @hidden @internal */
    set suffixes(items) {
      this._suffixes = items;
    }
    /**
     * Returns whether the `IgxInputGroupComponent` has border.
     * ```typescript
     * @ViewChild("MyInputGroup")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let inputBorder = this.inputGroup.hasBorder;
     * }
     * ```
     */
    get hasBorder() {
      return (this.type === 'line' || this.type === 'box') && this._theme === 'material';
    }
    /**
     * Returns whether the `IgxInputGroupComponent` type is line.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeLine = this.inputGroup.isTypeLine;
     * }
     * ```
     */
    get isTypeLine() {
      return this.type === 'line' && this._theme === 'material';
    }
    /**
     * Returns whether the `IgxInputGroupComponent` type is box.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeBox = this.inputGroup.isTypeBox;
     * }
     * ```
     */
    get isTypeBox() {
      return this.type === 'box' && this._theme === 'material';
    }
    /** @hidden @internal */
    uploadButtonHandler() {
      this.input.nativeElement.click();
    }
    /** @hidden @internal */
    clearValueHandler() {
      this.input.clear();
    }
    /** @hidden @internal */
    get isFileType() {
      return this.input.type === 'file';
    }
    /** @hidden @internal */
    get fileNames() {
      return this.input.fileNames || this._resourceStrings.igx_input_file_placeholder;
    }
    /**
     * Returns whether the `IgxInputGroupComponent` type is border.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeBorder = this.inputGroup.isTypeBorder;
     * }
     * ```
     */
    get isTypeBorder() {
      return this.type === 'border' && this._theme === 'material';
    }
    /**
     * Returns true if the `IgxInputGroupComponent` theme is Fluent.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeFluent = this.inputGroup.isTypeFluent;
     * }
     * ```
     */
    get isTypeFluent() {
      return this._theme === 'fluent';
    }
    /**
     * Returns true if the `IgxInputGroupComponent` theme is Bootstrap.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeBootstrap = this.inputGroup.isTypeBootstrap;
     * }
     * ```
     */
    get isTypeBootstrap() {
      return this._theme === 'bootstrap';
    }
    /**
     * Returns true if the `IgxInputGroupComponent` theme is Indigo.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeIndigo = this.inputGroup.isTypeIndigo;
     * }
     * ```
     */
    get isTypeIndigo() {
      return this._theme === 'indigo';
    }
    /**
     * Returns whether the `IgxInputGroupComponent` type is search.
     * ```typescript
     * @ViewChild("MyInputGroup1")
     * public inputGroup: IgxInputGroupComponent;
     * ngAfterViewInit(){
     *    let isTypeSearch = this.inputGroup.isTypeSearch;
     * }
     * ```
     */
    get isTypeSearch() {
      if (!this.isFileType && !this.input.isTextArea) {
        return this.type === 'search';
      }
    }
    /** @hidden */
    get filled() {
      return this._filled;
    }
    /** @hidden */
    set filled(val) {
      this._filled = val;
    }
    setComponentTheme() {
      if (!this.themeToken.preferToken) {
        const theme = getComponentTheme(this.element.nativeElement);
        if (theme && theme !== this._theme) {
          this.theme = theme;
          this.cdr.markForCheck();
        }
      }
    }
    /** @hidden @internal */
    ngAfterContentChecked() {
      this.setComponentTheme();
    }
    static {
      this.ɵfac = function IgxInputGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxInputGroupComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(THEME_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxInputGroupComponent,
        selectors: [["igx-input-group"]],
        contentQueries: function IgxInputGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxInputDirective, 7, IgxInputDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxHintDirective, 4, IgxHintDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxPrefixDirective, 5, IgxPrefixDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxSuffixDirective, 5, IgxSuffixDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hints = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._prefixes = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._suffixes = _t);
          }
        },
        hostVars: 38,
        hostBindings: function IgxInputGroupComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxInputGroupComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("pointerdown", function IgxInputGroupComponent_pointerdown_HostBindingHandler($event) {
              return ctx.onPointerDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-input-group", ctx.defaultClass)("igx-input-group--placeholder", ctx.hasPlaceholder)("igx-input-group--required", ctx.isRequired)("igx-input-group--focused", ctx.isFocused)("igx-input-group--disabled", ctx.disabled)("igx-input-group--warning", ctx.hasWarning)("igx-input-group--valid", ctx.validClass)("igx-input-group--invalid", ctx.invalidClass)("igx-input-group--filled", ctx.isFilled)("igx-input-group--textarea-group", ctx.textAreaClass)("igx-input-group--prefixed", ctx.hasPrefixes)("igx-input-group--suffixed", ctx.hasSuffixes)("igx-input-group--box", ctx.isTypeBox)("igx-input-group--file", ctx.isFileType)("igx-input-group--border", ctx.isTypeBorder)("igx-input-group--fluent", ctx.isTypeFluent)("igx-input-group--bootstrap", ctx.isTypeBootstrap)("igx-input-group--indigo", ctx.isTypeIndigo)("igx-input-group--search", ctx.isTypeSearch);
          }
        },
        inputs: {
          resourceStrings: "resourceStrings",
          suppressInputAutofocus: [2, "suppressInputAutofocus", "suppressInputAutofocus", booleanAttribute],
          type: "type",
          theme: "theme"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxInputGroupBase,
          useExisting: IgxInputGroupComponent
        }])],
        ngContentSelectors: _c2,
        decls: 26,
        vars: 1,
        consts: [["label", ""], ["input", ""], ["prefix", ""], ["uploadButton", ""], ["files", ""], ["clear", ""], ["suffix", ""], ["materialBundle", ""], ["fluentBundle", ""], ["bootstrapBundle", ""], ["bundle", ""], [1, "igx-input-group__wrapper"], [1, "igx-input-group__hint", 3, "click"], [4, "ngTemplateOutlet"], [1, "igx-input-group__upload-button"], ["igxButton", "contained", "type", "button", 3, "click", "disabled", "ngClass"], [1, "igx-input-group__file-input", 3, "title"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon", 3, "click", "keydown.Enter"], ["family", "default", "name", "input_clear"], [1, "igx-input-group__bundle"], [1, "igx-input-group__bundle-start"], [1, "igx-input-group__notch"], [1, "igx-input-group__bundle-main"], [1, "igx-input-group__filler"], [1, "igx-input-group__bundle-end"], [1, "igx-input-group__line"]],
        template: function IgxInputGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, IgxInputGroupComponent_Conditional_0_Template, 2, 1, "div", 11)(1, IgxInputGroupComponent_Conditional_1_Template, 1, 1, "ng-container");
            i0.ɵɵelementStart(2, "div", 12);
            i0.ɵɵlistener("click", function IgxInputGroupComponent_Template_div_click_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hintClickHandler($event));
            });
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, IgxInputGroupComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, IgxInputGroupComponent_ng_template_6_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(8, IgxInputGroupComponent_ng_template_8_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(10, IgxInputGroupComponent_ng_template_10_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(12, IgxInputGroupComponent_ng_template_12_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(14, IgxInputGroupComponent_ng_template_14_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(16, IgxInputGroupComponent_ng_template_16_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(18, IgxInputGroupComponent_ng_template_18_Template, 15, 8, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(20, IgxInputGroupComponent_ng_template_20_Template, 12, 8, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(22, IgxInputGroupComponent_ng_template_22_Template, 10, 7, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(24, IgxInputGroupComponent_ng_template_24_Template, 4, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isTypeBox ? 0 : 1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxPrefixDirective, IgxButtonDirective, NgClass, IgxSuffixDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxInputGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Input group directives collection for ease-of-use import in standalone components scenario */
const IGX_INPUT_GROUP_DIRECTIVES = [IgxInputGroupComponent, IgxInputDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];

/**
 * **Ignite UI for Angular Autocomplete** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/autocomplete.html)
 *
 * The igxAutocomplete directive provides a way to enhance a text input
 * by showing a drop down of suggested options, provided by the developer.
 *
 * Example:
 * ```html
 * <input type="text" [igxAutocomplete]="townsPanel" #autocompleteRef="igxAutocomplete"/>
 * <igx-drop-down #townsPanel>
 *     <igx-drop-down-item *ngFor="let town of towns | startsWith:townSelected" [value]="town">
 *         {{town}}
 *     </igx-drop-down-item>
 * </igx-drop-down>
 * ```
 */
let IgxAutocompleteDirective = /*#__PURE__*/(() => {
  class IgxAutocompleteDirective extends IgxDropDownItemNavigationDirective {
    /**
     * Sets the target of the autocomplete directive
     *
     * ```html
     * <!-- Set -->
     * <input [igxAutocomplete]="dropdown" />
     * ...
     * <igx-drop-down #dropdown>
     * ...
     * </igx-drop-down>
     * ```
     */
    get target() {
      return this._target;
    }
    set target(v) {
      this._target = v;
    }
    /** @hidden @internal */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    /** @hidden @internal */
    get parentElement() {
      return this.group ? this.group.element.nativeElement : this.nativeElement;
    }
    get settings() {
      const settings = Object.assign({}, this.defaultSettings, this.autocompleteSettings);
      if (!settings.target) {
        const positionStrategyClone = settings.positionStrategy.clone();
        settings.target = this.parentElement;
        settings.positionStrategy = positionStrategyClone;
      }
      return settings;
    }
    /** @hidden  @internal */
    get ariaExpanded() {
      return !this.collapsed;
    }
    /** @hidden  @internal */
    get hasPopUp() {
      return 'listbox';
    }
    /** @hidden  @internal */
    get ariaOwns() {
      return this.target.listId;
    }
    /** @hidden  @internal */
    get ariaActiveDescendant() {
      return !this.target.collapsed && this.target.focusedItem ? this.target.focusedItem.id : null;
    }
    /** @hidden  @internal */
    get ariaAutocomplete() {
      return 'list';
    }
    get model() {
      return this.ngModel || this.formControl;
    }
    constructor(ngModel, formControl, group, elementRef, cdr) {
      super(null);
      this.ngModel = ngModel;
      this.formControl = formControl;
      this.group = group;
      this.elementRef = elementRef;
      this.cdr = cdr;
      /** @hidden @internal */
      this.autofill = 'off';
      /** @hidden  @internal */
      this.role = 'combobox';
      /**
       * Enables/disables autocomplete component
       *
       * ```typescript
       * // get
       * let disabled = this.autocomplete.disabled;
       * ```
       * ```html
       * <!--set-->
       * <input type="text" [igxAutocomplete]="townsPanel" [igxAutocompleteDisabled]="disabled"/>
       * ```
       * ```typescript
       * // set
       * public disabled = true;
       * ```
       */
      this.disabled = false;
      /**
       * Emitted after item from the drop down is selected
       *
       * ```html
       * <input igxInput [igxAutocomplete]="townsPanel" (selectionChanging)='selectionChanging($event)' />
       * ```
       */
      this.selectionChanging = new EventEmitter();
      this._shouldBeOpen = false;
      this.destroy$ = new Subject();
    }
    /** @hidden  @internal */
    onInput() {
      this.open();
    }
    /** @hidden @internal */
    onCompositionStart() {
      if (!this._composing) {
        this._composing = true;
      }
    }
    /** @hidden @internal */
    onCompositionEnd() {
      this._composing = false;
    }
    /** @hidden  @internal */
    onArrowDown(event) {
      event.preventDefault();
      this.open();
    }
    /** @hidden  @internal */
    onTab() {
      this.close();
    }
    /** @hidden  @internal */
    handleKeyDown(event) {
      if (!this.collapsed && !this._composing) {
        switch (event.key.toLowerCase()) {
          case 'space':
          case 'spacebar':
          case ' ':
          case 'home':
          case 'end':
            return;
          default:
            super.handleKeyDown(event);
        }
      }
    }
    /** @hidden  @internal */
    onArrowDownKeyDown() {
      super.onArrowDownKeyDown();
    }
    /** @hidden  @internal */
    onArrowUpKeyDown() {
      super.onArrowUpKeyDown();
    }
    /** @hidden  @internal */
    onEndKeyDown() {
      super.onEndKeyDown();
    }
    /** @hidden  @internal */
    onHomeKeyDown() {
      super.onHomeKeyDown();
    }
    /**
     * Closes autocomplete drop down
     */
    close() {
      this._shouldBeOpen = false;
      if (this.collapsed) {
        return;
      }
      this.target.close();
    }
    /**
     * Opens autocomplete drop down
     */
    open() {
      this._shouldBeOpen = true;
      if (this.disabled || !this.collapsed || this.target.children.length === 0) {
        return;
      }
      // if no drop-down width is set, the drop-down will be as wide as the autocomplete input;
      this.target.width = this.target.width || this.parentElement.clientWidth + 'px';
      this.target.open(this.settings);
      this.highlightFirstItem();
    }
    /** @hidden @internal */
    ngOnInit() {
      const targetElement = this.parentElement;
      this.defaultSettings = {
        target: targetElement,
        modal: false,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new AutoPositionStrategy(),
        excludeFromOutsideClick: [targetElement]
      };
    }
    /** @hidden */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    ngAfterViewInit() {
      this.target.children.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.target.children.length) {
          if (!this.collapsed) {
            this.highlightFirstItem();
          } else if (this._shouldBeOpen) {
            this.open();
          }
        } else {
          // _shouldBeOpen flag should remain unchanged since this state change doesn't come from outside of the component
          // (like in the case of public API or user interaction).
          this.target.close();
        }
      });
      this.target.selectionChanging.pipe(takeUntil(this.destroy$)).subscribe(this.select.bind(this));
    }
    get collapsed() {
      return this.target ? this.target.collapsed : true;
    }
    select(value) {
      if (!value.newSelection) {
        return;
      }
      value.cancel = true; // Disable selection in the drop down, because in autocomplete we do not save selection.
      const newValue = value.newSelection.value;
      const args = {
        value: newValue,
        cancel: false
      };
      this.selectionChanging.emit(args);
      if (args.cancel) {
        return;
      }
      this.close();
      // Update model after the input is re-focused, in order to have proper valid styling.
      // Otherwise when item is selected using mouse (and input is blurred), then valid style will be removed.
      if (this.model) {
        this.model.control.setValue(newValue);
      } else {
        this.nativeElement.value = newValue;
      }
    }
    highlightFirstItem() {
      if (this.target.focusedItem) {
        this.target.focusedItem.focused = false;
        this.target.focusedItem = null;
      }
      this.target.navigateFirst();
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function IgxAutocompleteDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAutocompleteDirective)(i0.ɵɵdirectiveInject(NgModel, 10), i0.ɵɵdirectiveInject(FormControlName, 10), i0.ɵɵdirectiveInject(IgxInputGroupComponent, 8), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxAutocompleteDirective,
        selectors: [["", "igxAutocomplete", ""]],
        hostVars: 7,
        hostBindings: function IgxAutocompleteDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function IgxAutocompleteDirective_input_HostBindingHandler() {
              return ctx.onInput();
            })("compositionstart", function IgxAutocompleteDirective_compositionstart_HostBindingHandler() {
              return ctx.onCompositionStart();
            })("compositionend", function IgxAutocompleteDirective_compositionend_HostBindingHandler() {
              return ctx.onCompositionEnd();
            })("keydown.ArrowDown", function IgxAutocompleteDirective_keydown_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Alt.ArrowDown", function IgxAutocompleteDirective_keydown_Alt_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.ArrowUp", function IgxAutocompleteDirective_keydown_ArrowUp_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Alt.ArrowUp", function IgxAutocompleteDirective_keydown_Alt_ArrowUp_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Tab", function IgxAutocompleteDirective_keydown_Tab_HostBindingHandler() {
              return ctx.onTab();
            })("keydown.Shift.Tab", function IgxAutocompleteDirective_keydown_Shift_Tab_HostBindingHandler() {
              return ctx.onTab();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("autocomplete", ctx.autofill)("role", ctx.role)("aria-expanded", ctx.ariaExpanded)("aria-haspopup", ctx.hasPopUp)("aria-owns", ctx.ariaOwns)("aria-activedescendant", ctx.ariaActiveDescendant)("aria-autocomplete", ctx.ariaAutocomplete);
          }
        },
        inputs: {
          target: [0, "igxAutocomplete", "target"],
          autocompleteSettings: [0, "igxAutocompleteSettings", "autocompleteSettings"],
          disabled: [2, "igxAutocompleteDisabled", "disabled", booleanAttribute]
        },
        outputs: {
          selectionChanging: "selectionChanging"
        },
        exportAs: ["igxAutocomplete"],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxAutocompleteDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxDividerType = /*@__PURE__*/mkenum({
  SOLID: 'solid',
  DASHED: 'dashed'
});
let NEXT_ID$u = 0;
let IgxDividerDirective = /*#__PURE__*/(() => {
  class IgxDividerDirective {
    constructor() {
      /**
       * Sets/gets the `id` of the divider.
       * If not set, `id` will have value `"igx-divider-0"`;
       * ```html
       * <igx-divider id="my-divider"></igx-divider>
       * ```
       * ```typescript
       * let dividerId =  this.divider.id;
       * ```
       */
      this.id = `igx-divider-${NEXT_ID$u++}`;
      /**
       * Sets the value of `role` attribute.
       * If not the default value of `separator` will be used.
       */
      this.role = 'separator';
      /**
       * Sets the type of the divider. The default value
       * is `default`. The divider can also be `dashed`;
       * ```html
       * <igx-divider type="dashed"></igx-divider>
       * ```
       */
      this.type = IgxDividerType.SOLID;
      /**
       * If set to `true` and an `inset` value has been provided,
       * the divider will start shrinking from both ends.
       * ```html
       * <igx-divider [middle]="true"></igx-divider>
       * ```
       */
      this.middle = false;
      /**
       * Sets the divider in vertical orientation.
       * ```html
       * <igx-divider [vertical]="true"></igx-divider>
       * ```
       */
      this.vertical = false;
      /**
       * Sets the value of the `inset` attribute.
       * If not provided it will be set to `'0'`.
       * ```html
       * <igx-divider inset="16px"></igx-divider>
       * ```
       */
      this._inset = '0';
    }
    get isDashed() {
      return this.type === IgxDividerType.DASHED;
    }
    /**
     * Sets the inset of the divider from the side(s).
     * If the divider attribute `middle` is set to `true`,
     * it will inset the divider on both sides.
     * ```typescript
     * this.divider.inset = '32px';
     * ```
     */
    set inset(value) {
      this._inset = value;
    }
    /**
     * Gets the current divider inset in terms of
     * inset-inline-start representation as applied to the divider.
     * ```typescript
     * const inset = this.divider.inset;
     * ```
     */
    get inset() {
      return this._inset;
    }
    /**
     * A getter that returns `true` if the type of the divider is `default`;
     * ```typescript
     * const isDefault = this.divider.isDefault;
     * ```
     */
    get isSolid() {
      return this.type === IgxDividerType.SOLID;
    }
    static {
      this.ɵfac = function IgxDividerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDividerDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDividerDirective,
        selectors: [["igx-divider"]],
        hostVars: 12,
        hostBindings: function IgxDividerDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role);
            i0.ɵɵstyleProp("--inset", ctx.inset);
            i0.ɵɵclassProp("igx-divider", ctx.type)("igx-divider--dashed", ctx.isDashed)("igx-divider--inset", ctx.middle)("igx-divider--vertical", ctx.vertical);
          }
        },
        inputs: {
          id: "id",
          role: "role",
          type: "type",
          middle: [2, "middle", "middle", booleanAttribute],
          vertical: [2, "vertical", "vertical", booleanAttribute],
          inset: "inset"
        }
      });
    }
  }
  return IgxDividerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
class IgxDefaultDropStrategy {
  dropAction(_drag, _drop, _atIndex) {}
}
// @dynamic
class IgxAppendDropStrategy {
  constructor(_renderer) {
    this._renderer = _renderer;
  }
  dropAction(drag, drop, _atIndex) {
    const dragElement = drag.element.nativeElement;
    const dropAreaElement = drop.element.nativeElement;
    this._renderer.removeChild(dragElement.parentNode, dragElement);
    this._renderer.appendChild(dropAreaElement, dragElement);
  }
}
// @dynamic
class IgxPrependDropStrategy {
  constructor(_renderer) {
    this._renderer = _renderer;
  }
  dropAction(drag, drop, _atIndex) {
    const dragElement = drag.element.nativeElement;
    const dropAreaElement = drop.element.nativeElement;
    this._renderer.removeChild(dragElement.parentNode, dragElement);
    if (dropAreaElement.children.length) {
      this._renderer.insertBefore(dropAreaElement, dragElement, dropAreaElement.children[0]);
    } else {
      this._renderer.appendChild(dropAreaElement, dragElement);
    }
  }
}
// @dynamic
class IgxInsertDropStrategy {
  constructor(_renderer) {
    this._renderer = _renderer;
  }
  dropAction(drag, drop, atIndex) {
    if (drag.element.nativeElement.parentElement === drop.element.nativeElement && atIndex === -1) {
      return;
    }
    const dragElement = drag.element.nativeElement;
    const dropAreaElement = drop.element.nativeElement;
    this._renderer.removeChild(dragElement.parentNode, dragElement);
    if (atIndex !== -1 && dropAreaElement.children.length > atIndex) {
      this._renderer.insertBefore(dropAreaElement, dragElement, dropAreaElement.children[atIndex]);
    } else {
      this._renderer.appendChild(dropAreaElement, dragElement);
    }
  }
}
var DragScrollDirection$1 = /*#__PURE__*/function (DragScrollDirection) {
  DragScrollDirection[DragScrollDirection["UP"] = 0] = "UP";
  DragScrollDirection[DragScrollDirection["DOWN"] = 1] = "DOWN";
  DragScrollDirection[DragScrollDirection["LEFT"] = 2] = "LEFT";
  DragScrollDirection[DragScrollDirection["RIGHT"] = 3] = "RIGHT";
  return DragScrollDirection;
}(DragScrollDirection$1 || {});
var DragDirection = /*#__PURE__*/function (DragDirection) {
  DragDirection[DragDirection["VERTICAL"] = 0] = "VERTICAL";
  DragDirection[DragDirection["HORIZONTAL"] = 1] = "HORIZONTAL";
  DragDirection[DragDirection["BOTH"] = 2] = "BOTH";
  return DragDirection;
}(DragDirection || {});
class IgxDragLocation {
  constructor(_pageX, _pageY) {
    this._pageX = _pageX;
    this._pageY = _pageY;
    this.pageX = parseFloat(_pageX);
    this.pageY = parseFloat(_pageY);
  }
}
let IgxDragHandleDirective = /*#__PURE__*/(() => {
  class IgxDragHandleDirective {
    constructor(element) {
      this.element = element;
      this.baseClass = true;
      /**
       * @hidden
       */
      this.parentDragElement = null;
    }
    static {
      this.ɵfac = function IgxDragHandleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDragHandleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDragHandleDirective,
        selectors: [["", "igxDragHandle", ""]],
        hostVars: 2,
        hostBindings: function IgxDragHandleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-drag__handle", ctx.baseClass);
          }
        }
      });
    }
  }
  return IgxDragHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxDragIgnoreDirective = /*#__PURE__*/(() => {
  class IgxDragIgnoreDirective {
    constructor(element) {
      this.element = element;
      this.baseClass = true;
    }
    static {
      this.ɵfac = function IgxDragIgnoreDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDragIgnoreDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDragIgnoreDirective,
        selectors: [["", "igxDragIgnore", ""]],
        hostVars: 2,
        hostBindings: function IgxDragIgnoreDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-drag__ignore", ctx.baseClass);
          }
        }
      });
    }
  }
  return IgxDragIgnoreDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxDragDirective = /*#__PURE__*/(() => {
  class IgxDragDirective {
    /**
     * - Save data inside the `igxDrag` directive. This can be set when instancing `igxDrag` on an element.
     * ```html
     * <div [igxDrag]="{ source: myElement }"></div>
     * ```
     *
     * @memberof IgxDragDirective
     */
    set data(value) {
      this._data = value;
    }
    get data() {
      return this._data;
    }
    /**
     * Gets the current location of the element relative to the page.
     */
    get location() {
      return new IgxDragLocation(this.pageX, this.pageY);
    }
    /**
     * Gets the original location of the element before dragging started.
     */
    get originLocation() {
      return new IgxDragLocation(this.baseOriginLeft, this.baseOriginTop);
    }
    /**
     * @hidden
     */
    get pointerEventsEnabled() {
      return typeof PointerEvent !== 'undefined';
    }
    /**
     * @hidden
     */
    get touchEventsEnabled() {
      return 'ontouchstart' in window;
    }
    /**
     * @hidden
     */
    get pageX() {
      if (this.ghost && this.ghostElement) {
        return this.ghostLeft;
      }
      return this.baseLeft + this.windowScrollLeft;
    }
    /**
     * @hidden
     */
    get pageY() {
      if (this.ghost && this.ghostElement) {
        return this.ghostTop;
      }
      return this.baseTop + this.windowScrollTop;
    }
    get baseLeft() {
      return this.element.nativeElement.getBoundingClientRect().left;
    }
    get baseTop() {
      return this.element.nativeElement.getBoundingClientRect().top;
    }
    get baseOriginLeft() {
      return this.baseLeft - this.getTransformX(this.element.nativeElement);
    }
    get baseOriginTop() {
      return this.baseTop - this.getTransformY(this.element.nativeElement);
    }
    set ghostLeft(pageX) {
      if (this.ghostElement) {
        // We need to take into account marginLeft, since top style does not include margin, but pageX includes the margin.
        const ghostMarginLeft = parseInt(this.document.defaultView.getComputedStyle(this.ghostElement)['margin-left'], 10);
        // If ghost host is defined it needs to be taken into account.
        this.ghostElement.style.left = pageX - ghostMarginLeft - this._ghostHostX + 'px';
      }
    }
    get ghostLeft() {
      if (this.ghostElement) {
        return parseInt(this.ghostElement.style.left, 10) + this._ghostHostX;
      }
    }
    set ghostTop(pageY) {
      if (this.ghostElement) {
        // We need to take into account marginTop, since top style does not include margin, but pageY includes the margin.
        const ghostMarginTop = parseInt(this.document.defaultView.getComputedStyle(this.ghostElement)['margin-top'], 10);
        // If ghost host is defined it needs to be taken into account.
        this.ghostElement.style.top = pageY - ghostMarginTop - this._ghostHostY + 'px';
      }
    }
    get ghostTop() {
      if (this.ghostElement) {
        return parseInt(this.ghostElement.style.top, 10) + this._ghostHostY;
      }
    }
    get windowScrollTop() {
      return this.document.documentElement.scrollTop || window.scrollY;
    }
    get windowScrollLeft() {
      return this.document.documentElement.scrollLeft || window.scrollX;
    }
    get windowScrollHeight() {
      return this.document.documentElement.scrollHeight;
    }
    get windowScrollWidth() {
      return this.document.documentElement.scrollWidth;
    }
    /**
     * Sets the offset of the dragged element relative to the mouse in pixels.
     * By default it's taking the relative position to the mouse when the drag started and keeps it the same.
     * ```html
     * <div #hostDiv></div>
     * <div igxDrag [ghostOffsetX]="0">
     *         <span>Drag Me!</span>
     * </div>
     * ```
     *
     * @memberof IgxDragDirective
     */
    set ghostOffsetX(value) {
      this._offsetX = parseInt(value, 10);
    }
    get ghostOffsetX() {
      return this._offsetX !== undefined ? this._offsetX : this._defaultOffsetX;
    }
    /**
     * Sets the offset of the dragged element relative to the mouse in pixels.
     * By default it's taking the relative position to the mouse when the drag started and keeps it the same.
     * ```html
     * <div #hostDiv></div>
     * <div igxDrag [ghostOffsetY]="0">
     *         <span>Drag Me!</span>
     * </div>
     * ```
     *
     * @memberof IgxDragDirective
     */
    set ghostOffsetY(value) {
      this._offsetY = parseInt(value, 10);
    }
    get ghostOffsetY() {
      return this._offsetY !== undefined ? this._offsetY : this._defaultOffsetY;
    }
    constructor(cdr, element, viewContainer, zone, renderer, platformUtil) {
      this.cdr = cdr;
      this.element = element;
      this.viewContainer = viewContainer;
      this.zone = zone;
      this.renderer = renderer;
      this.platformUtil = platformUtil;
      /**
       * Sets the tolerance in pixels before drag starts.
       * By default the drag starts after the draggable element is moved by 5px.
       * ```html
       * <div igxDrag [dragTolerance]="100">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragTolerance = 5;
      /**
       * Sets the directions that the element can be dragged.
       * By default it is set to both horizontal and vertical directions.
       * ```html
       * <div igxDrag [dragDirection]="dragDir">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public dragDir = DragDirection.HORIZONTAL;
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragDirection = DragDirection.BOTH;
      /**
       * Sets whether the base element should be moved, or a ghost element should be rendered that represents it instead.
       * By default it is set to `true`.
       * If it is set to `false` when dragging the base element is moved instead and no ghost elements are rendered.
       * ```html
       * <div igxDrag [ghost]="false">
       *      <span>Drag Me!</span>
       * </div>
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.ghost = true;
      /**
       * Sets a custom class that will be added to the `ghostElement` element.
       * ```html
       * <div igxDrag [ghostClass]="'ghostElement'">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.ghostClass = '';
      /**
       * Set styles that will be added to the `ghostElement` element.
       * ```html
       * <div igxDrag [ghostStyle]="{'--ig-size': 'var(--ig-size-small)'}">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.ghostStyle = {};
      /**
       * Overrides the scroll container of the dragged element. By default its the window.
       */
      this.scrollContainer = null;
      /**
       * Event triggered when the draggable element drag starts.
       * ```html
       * <div igxDrag (dragStart)="onDragStart()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public onDragStart(){
       *      alert("The drag has stared!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragStart = new EventEmitter();
      /**
       * Event triggered when the draggable element has been moved.
       * ```html
       * <div igxDrag  (dragMove)="onDragMove()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public onDragMove(){
       *      alert("The element has moved!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragMove = new EventEmitter();
      /**
       * Event triggered when the draggable element is released.
       * ```html
       * <div igxDrag (dragEnd)="onDragEnd()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public onDragEnd(){
       *      alert("The drag has ended!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragEnd = new EventEmitter();
      /**
       * Event triggered when the draggable element is clicked.
       * ```html
       * <div igxDrag (dragClick)="onDragClick()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public onDragClick(){
       *      alert("The element has been clicked!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.dragClick = new EventEmitter();
      /**
       * Event triggered when the drag ghost element is created.
       * ```html
       * <div igxDrag (ghostCreate)="ghostCreated()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public ghostCreated(){
       *      alert("The ghost has been created!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.ghostCreate = new EventEmitter();
      /**
       * Event triggered when the drag ghost element is created.
       * ```html
       * <div igxDrag (ghostDestroy)="ghostDestroyed()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public ghostDestroyed(){
       *      alert("The ghost has been destroyed!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.ghostDestroy = new EventEmitter();
      /**
       * Event triggered after the draggable element is released and after its animation has finished.
       * ```html
       * <div igxDrag (transitioned)="onMoveEnd()">
       *         <span>Drag Me!</span>
       * </div>
       * ```
       * ```typescript
       * public onMoveEnd(){
       *      alert("The move has ended!");
       * }
       * ```
       *
       * @memberof IgxDragDirective
       */
      this.transitioned = new EventEmitter();
      /**
       * @hidden
       */
      this.baseClass = true;
      /**
       * @hidden
       */
      this.selectDisabled = false;
      /**
       * @hidden
       */
      this.defaultReturnDuration = '0.5s';
      /**
       * @hidden
       */
      this.animInProgress = false;
      this.ghostContext = null;
      this._startX = 0;
      this._startY = 0;
      this._lastX = 0;
      this._lastY = 0;
      this._dragStarted = false;
      this._ghostHostX = 0;
      this._ghostHostY = 0;
      this._pointerDownId = null;
      this._clicked = false;
      this._lastDropArea = null;
      this._destroy = new Subject();
      this._removeOnDestroy = true;
      this._scrollContainer = null;
      this._originalScrollContainerWidth = 0;
      this._originalScrollContainerHeight = 0;
      this._scrollContainerStep = 5;
      this._scrollContainerStepMs = 10;
      this._scrollContainerThreshold = 25;
      this._containerScrollIntervalId = null;
      this.document = inject(DOCUMENT);
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      if (!this.dragHandles || !this.dragHandles.length) {
        // Set user select none to the whole draggable element if no drag handles are defined.
        this.selectDisabled = true;
      }
      // Bind events
      this.zone.runOutsideAngular(() => {
        if (!this.platformUtil.isBrowser) {
          return;
        }
        const targetElements = this.dragHandles && this.dragHandles.length ? this.dragHandles.filter(item => item.parentDragElement === null).map(item => {
          item.parentDragElement = this.element.nativeElement;
          return item.element.nativeElement;
        }) : [this.element.nativeElement];
        targetElements.forEach(element => {
          if (this.pointerEventsEnabled) {
            fromEvent(element, 'pointerdown').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerDown(res));
            fromEvent(element, 'pointermove').pipe(throttle(() => interval(0, animationFrameScheduler)), takeUntil(this._destroy)).subscribe(res => this.onPointerMove(res));
            fromEvent(element, 'pointerup').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerUp(res));
            if (!this.ghost) {
              // Do not bind `lostpointercapture` to the target, because we will bind it on the ghost later.
              fromEvent(element, 'lostpointercapture').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerLost(res));
            }
          } else if (this.touchEventsEnabled) {
            fromEvent(element, 'touchstart').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerDown(res));
          } else {
            // We don't have pointer events and touch events. Use then mouse events.
            fromEvent(element, 'mousedown').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerDown(res));
          }
        });
        // We should bind to document events only once when there are no pointer events.
        if (!this.pointerEventsEnabled && this.touchEventsEnabled) {
          fromEvent(this.document.defaultView, 'touchmove').pipe(throttle(() => interval(0, animationFrameScheduler)), takeUntil(this._destroy)).subscribe(res => this.onPointerMove(res));
          fromEvent(this.document.defaultView, 'touchend').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerUp(res));
        } else if (!this.pointerEventsEnabled) {
          fromEvent(this.document.defaultView, 'mousemove').pipe(throttle(() => interval(0, animationFrameScheduler)), takeUntil(this._destroy)).subscribe(res => this.onPointerMove(res));
          fromEvent(this.document.defaultView, 'mouseup').pipe(takeUntil(this._destroy)).subscribe(res => this.onPointerUp(res));
        }
        this.element.nativeElement.addEventListener('transitionend', this.onTransitionEnd.bind(this));
      });
      // Set transition duration to 0s. This also helps with setting `visibility: hidden` to the base to not lag.
      this.element.nativeElement.style.transitionDuration = '0.0s';
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._destroy.next(true);
      this._destroy.complete();
      if (this.ghost && this.ghostElement && this._removeOnDestroy) {
        this.ghostElement.parentNode.removeChild(this.ghostElement);
        this.ghostElement = null;
        if (this._dynamicGhostRef) {
          this._dynamicGhostRef.destroy();
          this._dynamicGhostRef = null;
        }
      }
      this.element.nativeElement.removeEventListener('transitionend', this.onTransitionEnd);
      if (this._containerScrollIntervalId) {
        clearInterval(this._containerScrollIntervalId);
        this._containerScrollIntervalId = null;
      }
    }
    /**
     * Sets desired location of the base element or ghost element if rended relative to the document.
     *
     * @param newLocation New location that should be applied. It is advised to get new location using getBoundingClientRects() + scroll.
     */
    setLocation(newLocation) {
      // We do not subtract marginLeft and marginTop here because here we calculate deltas.
      if (this.ghost && this.ghostElement) {
        this.ghostLeft = newLocation.pageX + this.windowScrollLeft;
        this.ghostTop = newLocation.pageY + this.windowScrollTop;
      } else if (!this.ghost) {
        const deltaX = newLocation.pageX - this.pageX;
        const deltaY = newLocation.pageY - this.pageY;
        const transformX = this.getTransformX(this.element.nativeElement);
        const transformY = this.getTransformY(this.element.nativeElement);
        this.setTransformXY(transformX + deltaX, transformY + deltaY);
      }
      this._startX = this.baseLeft;
      this._startY = this.baseTop;
    }
    /**
     * Animates the base or ghost element depending on the `ghost` input to its initial location.
     * If `ghost` is true but there is not ghost rendered, it will be created and animated.
     * If the base element has changed its DOM position its initial location will be changed accordingly.
     *
     * @param customAnimArgs Custom transition properties that will be applied when performing the transition.
     * @param startLocation Start location from where the transition should start.
     */
    transitionToOrigin(customAnimArgs, startLocation) {
      if (!!startLocation && startLocation.pageX === this.baseOriginLeft && startLocation.pageY === this.baseOriginLeft || !startLocation && this.ghost && !this.ghostElement) {
        return;
      }
      if (!!startLocation && startLocation.pageX !== this.pageX && startLocation.pageY !== this.pageY) {
        if (this.ghost && !this.ghostElement) {
          this._startX = startLocation.pageX;
          this._startY = startLocation.pageY;
          this._ghostStartX = this._startX;
          this._ghostStartY = this._startY;
          this.createGhost(this._startX, this._startY);
        }
        this.setLocation(startLocation);
      }
      this.animInProgress = true;
      // Use setTimeout because we need to be sure that the element is positioned first correctly if there is start location.
      setTimeout(() => {
        if (this.ghost) {
          this.ghostElement.style.transitionProperty = 'top, left';
          this.ghostElement.style.transitionDuration = customAnimArgs && customAnimArgs.duration ? customAnimArgs.duration + 's' : this.defaultReturnDuration;
          this.ghostElement.style.transitionTimingFunction = customAnimArgs && customAnimArgs.timingFunction ? customAnimArgs.timingFunction : '';
          this.ghostElement.style.transitionDelay = customAnimArgs && customAnimArgs.delay ? customAnimArgs.delay + 's' : '';
          this.setLocation(new IgxDragLocation(this.baseLeft, this.baseTop));
        } else if (!this.ghost) {
          this.element.nativeElement.style.transitionProperty = 'transform';
          this.element.nativeElement.style.transitionDuration = customAnimArgs && customAnimArgs.duration ? customAnimArgs.duration + 's' : this.defaultReturnDuration;
          this.element.nativeElement.style.transitionTimingFunction = customAnimArgs && customAnimArgs.timingFunction ? customAnimArgs.timingFunction : '';
          this.element.nativeElement.style.transitionDelay = customAnimArgs && customAnimArgs.delay ? customAnimArgs.delay + 's' : '';
          this._startX = this.baseLeft;
          this._startY = this.baseTop;
          this.setTransformXY(0, 0);
        }
      }, 0);
    }
    /**
     * Animates the base or ghost element to a specific target location or other element using transition.
     * If `ghost` is true but there is not ghost rendered, it will be created and animated.
     * It is recommended to use 'getBoundingClientRects() + pageScroll' when determining desired location.
     *
     * @param target Target that the base or ghost will transition to. It can be either location in the page or another HTML element.
     * @param customAnimArgs Custom transition properties that will be applied when performing the transition.
     * @param startLocation Start location from where the transition should start.
     */
    transitionTo(target, customAnimArgs, startLocation) {
      if (!!startLocation && this.ghost && !this.ghostElement) {
        this._startX = startLocation.pageX;
        this._startY = startLocation.pageY;
        this._ghostStartX = this._startX;
        this._ghostStartY = this._startY;
      } else if (!!startLocation && (!this.ghost || this.ghostElement)) {
        this.setLocation(startLocation);
      } else if (this.ghost && !this.ghostElement) {
        this._startX = this.baseLeft;
        this._startY = this.baseTop;
        this._ghostStartX = this._startX + this.windowScrollLeft;
        this._ghostStartY = this._startY + this.windowScrollTop;
      }
      if (this.ghost && !this.ghostElement) {
        this.createGhost(this._startX, this._startY);
      }
      this.animInProgress = true;
      // Use setTimeout because we need to be sure that the element is positioned first correctly if there is start location.
      setTimeout(() => {
        const movedElem = this.ghost ? this.ghostElement : this.element.nativeElement;
        movedElem.style.transitionProperty = this.ghost && this.ghostElement ? 'left, top' : 'transform';
        movedElem.style.transitionDuration = customAnimArgs && customAnimArgs.duration ? customAnimArgs.duration + 's' : this.defaultReturnDuration;
        movedElem.style.transitionTimingFunction = customAnimArgs && customAnimArgs.timingFunction ? customAnimArgs.timingFunction : '';
        movedElem.style.transitionDelay = customAnimArgs && customAnimArgs.delay ? customAnimArgs.delay + 's' : '';
        if (target instanceof IgxDragLocation) {
          this.setLocation(new IgxDragLocation(target.pageX, target.pageY));
        } else {
          const targetRects = target.nativeElement.getBoundingClientRect();
          this.setLocation(new IgxDragLocation(targetRects.left - this.windowScrollLeft, targetRects.top - this.windowScrollTop));
        }
      }, 0);
    }
    /**
     * @hidden
     * Method bound to the PointerDown event of the base element igxDrag is initialized.
     * @param event PointerDown event captured
     */
    onPointerDown(event) {
      const ignoredElement = this.dragIgnoredElems.find(elem => elem.element.nativeElement === event.target);
      if (ignoredElement) {
        return;
      }
      // Set pointer capture so we detect pointermove even if mouse is out of bounds until ghostElement is created.
      const handleFound = this.dragHandles.find(handle => handle.element.nativeElement === event.target);
      const targetElement = handleFound ? handleFound.element.nativeElement : event.target || this.element.nativeElement;
      if (this.pointerEventsEnabled && targetElement.isConnected) {
        this._pointerDownId = event.pointerId;
        targetElement.setPointerCapture(this._pointerDownId);
      } else if (targetElement.isConnected) {
        targetElement.focus();
        event.preventDefault();
      } else {
        return;
      }
      this._clicked = true;
      if (this.pointerEventsEnabled || !this.touchEventsEnabled) {
        // Check first for pointer events or non touch, because we can have pointer events and touch events at once.
        this._startX = event.pageX;
        this._startY = event.pageY;
      } else if (this.touchEventsEnabled) {
        this._startX = event.touches[0].pageX;
        this._startY = event.touches[0].pageY;
      }
      this._defaultOffsetX = this.baseLeft - this._startX + this.windowScrollLeft;
      this._defaultOffsetY = this.baseTop - this._startY + this.windowScrollTop;
      this._ghostStartX = this._startX + this.ghostOffsetX;
      this._ghostStartY = this._startY + this.ghostOffsetY;
      this._lastX = this._startX;
      this._lastY = this._startY;
    }
    /**
     * @hidden
     * Perform drag move logic when dragging and dispatching events if there is igxDrop under the pointer.
     * This method is bound at first at the base element.
     * If dragging starts and after the ghostElement is rendered the pointerId is reassigned it. Then this method is bound to it.
     * @param event PointerMove event captured
     */
    onPointerMove(event) {
      if (this._clicked) {
        let pageX;
        let pageY;
        if (this.pointerEventsEnabled || !this.touchEventsEnabled) {
          // Check first for pointer events or non touch, because we can have pointer events and touch events at once.
          pageX = event.pageX;
          pageY = event.pageY;
        } else if (this.touchEventsEnabled) {
          pageX = event.touches[0].pageX;
          pageY = event.touches[0].pageY;
          // Prevent scrolling on touch while dragging
          event.preventDefault();
        }
        const totalMovedX = pageX - this._startX;
        const totalMovedY = pageY - this._startY;
        if (!this._dragStarted && (Math.abs(totalMovedX) > this.dragTolerance || Math.abs(totalMovedY) > this.dragTolerance)) {
          const dragStartArgs = {
            originalEvent: event,
            owner: this,
            startX: pageX - totalMovedX,
            startY: pageY - totalMovedY,
            pageX,
            pageY,
            cancel: false
          };
          this.zone.run(() => {
            this.dragStart.emit(dragStartArgs);
          });
          if (!dragStartArgs.cancel) {
            this._dragStarted = true;
            if (this.ghost) {
              // We moved enough so ghostElement can be rendered and actual dragging to start.
              // When creating it will take into account any offset set by the user by default.
              this.createGhost(pageX, pageY);
            } else if (this._offsetX !== undefined || this._offsetY !== undefined) {
              // There is no need for ghost, but we will need to position initially the base element to reflect any offset.
              const transformX = (this._offsetX !== undefined ? this._offsetX - this._defaultOffsetX : 0) + this.getTransformX(this.element.nativeElement);
              const transformY = (this._offsetY !== undefined ? this._offsetY - this._defaultOffsetY : 0) + this.getTransformY(this.element.nativeElement);
              this.setTransformXY(transformX, transformY);
            }
          } else {
            return;
          }
        } else if (!this._dragStarted) {
          return;
        }
        const moveArgs = {
          originalEvent: event,
          owner: this,
          startX: this._startX,
          startY: this._startY,
          pageX: this._lastX,
          pageY: this._lastY,
          nextPageX: pageX,
          nextPageY: pageY,
          cancel: false
        };
        this.dragMove.emit(moveArgs);
        const setPageX = moveArgs.nextPageX;
        const setPageY = moveArgs.nextPageY;
        if (!moveArgs.cancel) {
          // Scroll root container if the user reaches its boundaries.
          this.onScrollContainer();
          // Move the actual element around
          if (this.ghost) {
            const updatedTotalMovedX = this.dragDirection === DragDirection.VERTICAL ? 0 : setPageX - this._startX;
            const updatedTotalMovedY = this.dragDirection === DragDirection.HORIZONTAL ? 0 : setPageY - this._startY;
            this.ghostLeft = this._ghostStartX + updatedTotalMovedX;
            this.ghostTop = this._ghostStartY + updatedTotalMovedY;
          } else {
            const lastMovedX = this.dragDirection === DragDirection.VERTICAL ? 0 : setPageX - this._lastX;
            const lastMovedY = this.dragDirection === DragDirection.HORIZONTAL ? 0 : setPageY - this._lastY;
            const translateX = this.getTransformX(this.element.nativeElement) + lastMovedX;
            const translateY = this.getTransformY(this.element.nativeElement) + lastMovedY;
            this.setTransformXY(translateX, translateY);
          }
          this.dispatchDragEvents(pageX, pageY, event);
        }
        this._lastX = setPageX;
        this._lastY = setPageY;
      }
    }
    /**
     * @hidden
     * Perform drag end logic when releasing the ghostElement and dispatching drop event if igxDrop is under the pointer.
     * This method is bound at first at the base element.
     * If dragging starts and after the ghostElement is rendered the pointerId is reassigned to it. Then this method is bound to it.
     * @param event PointerUp event captured
     */
    onPointerUp(event) {
      if (!this._clicked) {
        return;
      }
      let pageX;
      let pageY;
      if (this.pointerEventsEnabled || !this.touchEventsEnabled) {
        // Check first for pointer events or non touch, because we can have pointer events and touch events at once.
        pageX = event.pageX;
        pageY = event.pageY;
      } else if (this.touchEventsEnabled) {
        pageX = event.touches[0].pageX;
        pageY = event.touches[0].pageY;
        // Prevent scrolling on touch while dragging
        event.preventDefault();
      }
      const eventArgs = {
        originalEvent: event,
        owner: this,
        startX: this._startX,
        startY: this._startY,
        pageX,
        pageY
      };
      this._pointerDownId = null;
      this._clicked = false;
      if (this._dragStarted) {
        if (this._lastDropArea && this._lastDropArea !== this.element.nativeElement) {
          this.dispatchDropEvent(event.pageX, event.pageY, event);
        }
        this.zone.run(() => {
          this.dragEnd.emit(eventArgs);
        });
        if (!this.animInProgress) {
          this.onTransitionEnd(null);
        }
      } else {
        // Trigger our own click event because when there is no ghost, native click cannot be prevented when dragging.
        this.zone.run(() => {
          this.dragClick.emit(eventArgs);
        });
      }
      if (this._containerScrollIntervalId) {
        clearInterval(this._containerScrollIntervalId);
        this._containerScrollIntervalId = null;
      }
    }
    /**
     * @hidden
     * Execute this method whe the pointer capture has been lost.
     * This means that during dragging the user has performed other action like right clicking and then clicking somewhere else.
     * This method will ensure that the drag state is being reset in this case as if the user released the dragged element.
     * @param event Event captured
     */
    onPointerLost(event) {
      if (!this._clicked) {
        return;
      }
      // When the base element is moved to previous index, angular reattaches the ghost template as a sibling by default.
      // This is the defaut place for the EmbededViewRef when recreated.
      // That's why we need to move it to the proper place and set pointer capture again.
      if (this._pointerDownId && this.ghostElement && this._dynamicGhostRef && !this._dynamicGhostRef.destroyed) {
        let ghostReattached = false;
        if (this.ghostHost && !Array.from(this.ghostHost.children).includes(this.ghostElement)) {
          ghostReattached = true;
          this.ghostHost.appendChild(this.ghostElement);
        } else if (!this.ghostHost && !Array.from(this.document.body.children).includes(this.ghostElement)) {
          ghostReattached = true;
          this.document.body.appendChild(this.ghostElement);
        }
        if (ghostReattached) {
          this.ghostElement.setPointerCapture(this._pointerDownId);
          return;
        }
      }
      const eventArgs = {
        originalEvent: event,
        owner: this,
        startX: this._startX,
        startY: this._startY,
        pageX: event.pageX,
        pageY: event.pageY
      };
      this._pointerDownId = null;
      this._clicked = false;
      if (this._dragStarted) {
        this.zone.run(() => {
          this.dragEnd.emit(eventArgs);
        });
        if (!this.animInProgress) {
          this.onTransitionEnd(null);
        }
      }
    }
    /**
     * @hidden
     */
    onTransitionEnd(event) {
      if (!this._dragStarted && !this.animInProgress || this._clicked) {
        // Return if no dragging started and there is no animation in progress.
        return;
      }
      if (this.ghost && this.ghostElement) {
        this._ghostStartX = this.baseLeft + this.windowScrollLeft;
        this._ghostStartY = this.baseTop + this.windowScrollTop;
        const ghostDestroyArgs = {
          owner: this,
          ghostElement: this.ghostElement,
          cancel: false
        };
        this.ghostDestroy.emit(ghostDestroyArgs);
        if (ghostDestroyArgs.cancel) {
          return;
        }
        this.clearGhost();
      } else if (!this.ghost) {
        this.element.nativeElement.style.transitionProperty = '';
        this.element.nativeElement.style.transitionDuration = '0.0s';
        this.element.nativeElement.style.transitionTimingFunction = '';
        this.element.nativeElement.style.transitionDelay = '';
      }
      this.animInProgress = false;
      this._dragStarted = false;
      // Execute transitioned after everything is reset so if the user sets new location on the base now it would work as expected.
      this.zone.run(() => {
        this.transitioned.emit({
          originalEvent: event,
          owner: this,
          startX: this._startX,
          startY: this._startY,
          pageX: this._startX,
          pageY: this._startY
        });
      });
    }
    clearGhost() {
      this.ghostElement.removeEventListener('pointermove', this.onPointerMove);
      this.ghostElement.removeEventListener('pointerup', this.onPointerUp);
      this.ghostElement.removeEventListener('lostpointercapture', this.onPointerLost);
      this.ghostElement.removeEventListener('transitionend', this.onTransitionEnd);
      this.ghostElement.remove();
      this.ghostElement = null;
      if (this._dynamicGhostRef) {
        this._dynamicGhostRef.destroy();
        this._dynamicGhostRef = null;
      }
    }
    /**
     * @hidden
     * Create ghost element - if a Node object is provided it creates a clone of that node,
     * otherwise it clones the host element.
     * Bind all needed events.
     * @param pageX Latest pointer position on the X axis relative to the page.
     * @param pageY Latest pointer position on the Y axis relative to the page.
     * @param node The Node object to be cloned.
     */
    createGhost(pageX, pageY, node = null) {
      if (!this.ghost) {
        return;
      }
      if (this.ghostTemplate) {
        this.zone.run(() => {
          // Create template in zone, so it gets updated by it automatically.
          this._dynamicGhostRef = this.viewContainer.createEmbeddedView(this.ghostTemplate, this.ghostContext);
        });
        if (this._dynamicGhostRef.rootNodes[0].style.display === 'contents') {
          // Change the display to default since display contents does not position the element absolutely.
          this._dynamicGhostRef.rootNodes[0].style.display = 'block';
        }
        this.ghostElement = this._dynamicGhostRef.rootNodes[0];
      } else {
        this.ghostElement = node ? node.cloneNode(true) : this.element.nativeElement.cloneNode(true);
      }
      const totalMovedX = pageX - this._startX;
      const totalMovedY = pageY - this._startY;
      this._ghostHostX = this.getGhostHostBaseOffsetX();
      this._ghostHostY = this.getGhostHostBaseOffsetY();
      this.ghostElement.style.transitionDuration = '0.0s';
      this.ghostElement.style.position = 'absolute';
      if (this.ghostClass) {
        this.ghostElement.classList.add(this.ghostClass);
      }
      if (this.ghostStyle) {
        Object.entries(this.ghostStyle).map(([name, value]) => {
          this.renderer.setStyle(this.ghostElement, name, value, RendererStyleFlags2.DashCase);
        });
      }
      const createEventArgs = {
        owner: this,
        ghostElement: this.ghostElement,
        cancel: false
      };
      this.ghostCreate.emit(createEventArgs);
      if (createEventArgs.cancel) {
        this.ghostElement = null;
        if (this.ghostTemplate && this._dynamicGhostRef) {
          this._dynamicGhostRef.destroy();
        }
        return;
      }
      if (this.ghostHost) {
        this.ghostHost.appendChild(this.ghostElement);
      } else {
        this.document.body.appendChild(this.ghostElement);
      }
      const ghostMarginLeft = parseInt(this.document.defaultView.getComputedStyle(this.ghostElement)['margin-left'], 10);
      const ghostMarginTop = parseInt(this.document.defaultView.getComputedStyle(this.ghostElement)['margin-top'], 10);
      this.ghostElement.style.left = this._ghostStartX - ghostMarginLeft + totalMovedX - this._ghostHostX + 'px';
      this.ghostElement.style.top = this._ghostStartY - ghostMarginTop + totalMovedY - this._ghostHostY + 'px';
      if (this.pointerEventsEnabled) {
        // The ghostElement takes control for moving and dragging after it has been rendered.
        if (this._pointerDownId !== null) {
          this.ghostElement.setPointerCapture(this._pointerDownId);
        }
        this.ghostElement.addEventListener('pointermove', this.onPointerMove.bind(this));
        this.ghostElement.addEventListener('pointerup', this.onPointerUp.bind(this));
        this.ghostElement.addEventListener('lostpointercapture', this.onPointerLost.bind(this));
      }
      // Transition animation when the ghostElement is released and it returns to it's original position.
      this.ghostElement.addEventListener('transitionend', this.onTransitionEnd.bind(this));
      this.cdr.detectChanges();
    }
    /**
     * @hidden
     * Dispatch custom igxDragEnter/igxDragLeave events based on current pointer position and if drop area is under.
     */
    dispatchDragEvents(pageX, pageY, originalEvent) {
      let topDropArea;
      const customEventArgs = {
        startX: this._startX,
        startY: this._startY,
        pageX,
        pageY,
        owner: this,
        originalEvent
      };
      const elementsFromPoint = this.getElementsAtPoint(pageX, pageY);
      let targetElements = [];
      // Check for shadowRoot instance and use it if present
      for (const elFromPoint of elementsFromPoint) {
        if (elFromPoint?.shadowRoot) {
          targetElements = targetElements.concat(this.getFromShadowRoot(elFromPoint, pageX, pageY, elementsFromPoint));
        } else if (targetElements.indexOf(elFromPoint) === -1) {
          targetElements.push(elFromPoint);
        }
      }
      for (const element of targetElements) {
        if (element.getAttribute('droppable') === 'true' && element !== this.ghostElement && element !== this.element.nativeElement) {
          topDropArea = element;
          break;
        }
      }
      if (topDropArea && (!this._lastDropArea || this._lastDropArea && this._lastDropArea !== topDropArea)) {
        if (this._lastDropArea) {
          this.dispatchEvent(this._lastDropArea, 'igxDragLeave', customEventArgs);
        }
        this._lastDropArea = topDropArea;
        this.dispatchEvent(this._lastDropArea, 'igxDragEnter', customEventArgs);
      } else if (!topDropArea && this._lastDropArea) {
        this.dispatchEvent(this._lastDropArea, 'igxDragLeave', customEventArgs);
        this._lastDropArea = null;
        return;
      }
      if (topDropArea) {
        this.dispatchEvent(topDropArea, 'igxDragOver', customEventArgs);
      }
    }
    /**
     * @hidden
     * Traverse shadow dom in depth.
     */
    getFromShadowRoot(elem, pageX, pageY, parentDomElems) {
      const elementsFromPoint = elem.shadowRoot.elementsFromPoint(pageX, pageY);
      const shadowElements = elementsFromPoint.filter(cur => parentDomElems.indexOf(cur) === -1);
      let res = [];
      for (const elFromPoint of shadowElements) {
        if (!!elFromPoint?.shadowRoot && elFromPoint.shadowRoot !== elem.shadowRoot) {
          res = res.concat(this.getFromShadowRoot(elFromPoint, pageX, pageY, elementsFromPoint));
        }
        res.push(elFromPoint);
      }
      return res;
    }
    /**
     * @hidden
     * Dispatch custom igxDrop event based on current pointer position if there is last recorder drop area under the pointer.
     * Last recorder drop area is updated in @dispatchDragEvents method.
     */
    dispatchDropEvent(pageX, pageY, originalEvent) {
      const eventArgs = {
        startX: this._startX,
        startY: this._startY,
        pageX,
        pageY,
        owner: this,
        originalEvent
      };
      this.dispatchEvent(this._lastDropArea, 'igxDrop', eventArgs);
      this.dispatchEvent(this._lastDropArea, 'igxDragLeave', eventArgs);
      this._lastDropArea = null;
    }
    /**
     * @hidden
     */
    getElementsAtPoint(pageX, pageY) {
      // correct the coordinates with the current scroll position, because
      // document.elementsFromPoint consider position within the current viewport
      // window.pageXOffset == window.scrollX; // always true
      // using window.pageXOffset for IE9 compatibility
      const viewPortX = pageX - window.pageXOffset;
      const viewPortY = pageY - window.pageYOffset;
      if (this.document['msElementsFromPoint']) {
        // Edge and IE special snowflakes
        const elements = this.document['msElementsFromPoint'](viewPortX, viewPortY);
        return elements === null ? [] : elements;
      } else {
        // Other browsers like Chrome, Firefox, Opera
        return this.document.elementsFromPoint(viewPortX, viewPortY);
      }
    }
    /**
     * @hidden
     */
    dispatchEvent(target, eventName, eventArgs) {
      // This way is IE11 compatible.
      // const dragLeaveEvent = document.createEvent('CustomEvent');
      // dragLeaveEvent.initCustomEvent(eventName, false, false, eventArgs);
      // target.dispatchEvent(dragLeaveEvent);
      // Otherwise can be used `target.dispatchEvent(new CustomEvent(eventName, eventArgs));`
      target.dispatchEvent(new CustomEvent(eventName, {
        detail: eventArgs
      }));
    }
    getTransformX(elem) {
      let posX = 0;
      if (elem.style.transform) {
        const matrix = elem.style.transform;
        const values = matrix ? matrix.match(/-?[\d\.]+/g) : undefined;
        posX = values ? Number(values[1]) : 0;
      }
      return posX;
    }
    getTransformY(elem) {
      let posY = 0;
      if (elem.style.transform) {
        const matrix = elem.style.transform;
        const values = matrix ? matrix.match(/-?[\d\.]+/g) : undefined;
        posY = values ? Number(values[2]) : 0;
      }
      return posY;
    }
    /** Method setting transformation to the base draggable element. */
    setTransformXY(x, y) {
      if (x === 0 && y === 0) {
        this.element.nativeElement.style.transform = '';
        return;
      }
      this.element.nativeElement.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0px)';
    }
    /**
     * Since we are using absolute position to move the ghost, the ghost host might not have position: relative.
     * Combined with position static, this means that the absolute position in the browser is relative to the offsetParent.
     * The offsetParent is pretty much the closes parent that has position: relative, or if no such until it reaches the body.
     * That's why if this is the case, we need to know how much we should compensate for the ghostHost being offset from
     * its offsetParent.
     *
     * OffsetParent can be null in the case of position: fixed applied to the ghost host or display: none. In that case
     * just get the clientRects of the ghost host.
     */
    getGhostHostBaseOffsetX() {
      if (!this.ghostHost) return 0;
      const ghostPosition = this.document.defaultView.getComputedStyle(this.ghostHost).getPropertyValue('position');
      if (ghostPosition === 'static' && this.ghostHost.offsetParent && this.ghostHost.offsetParent === this.document.body) {
        return 0;
      } else if (ghostPosition === 'static' && this.ghostHost.offsetParent) {
        return this.ghostHost.offsetParent.getBoundingClientRect().left + this.windowScrollLeft;
      }
      return this.ghostHost.getBoundingClientRect().left + this.windowScrollLeft;
    }
    getGhostHostBaseOffsetY() {
      if (!this.ghostHost) return 0;
      const ghostPosition = this.document.defaultView.getComputedStyle(this.ghostHost).getPropertyValue('position');
      if (ghostPosition === 'static' && this.ghostHost.offsetParent && this.ghostHost.offsetParent === this.document.body) {
        return 0;
      } else if (ghostPosition === 'static' && this.ghostHost.offsetParent) {
        return this.ghostHost.offsetParent.getBoundingClientRect().top + this.windowScrollTop;
      }
      return this.ghostHost.getBoundingClientRect().top + this.windowScrollTop;
    }
    getContainerScrollDirection() {
      const containerBounds = this.scrollContainer ? this.scrollContainer.getBoundingClientRect() : null;
      const scrolledX = !this.scrollContainer ? this.windowScrollLeft > 0 : this.scrollContainer.scrollLeft > 0;
      const scrolledY = !this.scrollContainer ? this.windowScrollTop > 0 : this.scrollContainer.scrollTop > 0;
      // Take into account window scroll top because we do not use fixed positioning to the window.
      const topBorder = (!this.scrollContainer ? 0 : containerBounds.top) + this.windowScrollTop + this._scrollContainerThreshold;
      // Subtract the element height because we position it from top left corner.
      const elementHeight = this.ghost && this.ghostElement ? this.ghostElement.offsetHeight : this.element.nativeElement.offsetHeight;
      const bottomBorder = (!this.scrollContainer ? window.innerHeight : containerBounds.bottom) + this.windowScrollTop - this._scrollContainerThreshold - elementHeight;
      // Same for window scroll left
      const leftBorder = (!this.scrollContainer ? 0 : containerBounds.left) + this.windowScrollLeft + this._scrollContainerThreshold;
      // Subtract the element width again because we position it from top left corner.
      const elementWidth = this.ghost && this.ghostElement ? this.ghostElement.offsetWidth : this.element.nativeElement.offsetWidth;
      const rightBorder = (!this.scrollContainer ? window.innerWidth : containerBounds.right) + this.windowScrollLeft - this._scrollContainerThreshold - elementWidth;
      if (this.pageY <= topBorder && scrolledY) {
        return DragScrollDirection$1.UP;
      } else if (this.pageY > bottomBorder) {
        return DragScrollDirection$1.DOWN;
      } else if (this.pageX < leftBorder && scrolledX) {
        return DragScrollDirection$1.LEFT;
      } else if (this.pageX > rightBorder) {
        return DragScrollDirection$1.RIGHT;
      }
      return null;
    }
    onScrollContainerStep(scrollDir) {
      animationFrameScheduler.schedule(() => {
        let xDir = scrollDir == DragScrollDirection$1.LEFT ? -1 : scrollDir == DragScrollDirection$1.RIGHT ? 1 : 0;
        let yDir = scrollDir == DragScrollDirection$1.UP ? -1 : scrollDir == DragScrollDirection$1.DOWN ? 1 : 0;
        if (!this.scrollContainer) {
          // Cap scrolling so we don't scroll past the window max scroll position.
          const maxScrollX = this._originalScrollContainerWidth - this.document.documentElement.clientWidth;
          const maxScrollY = this._originalScrollContainerHeight - this.document.documentElement.clientHeight;
          xDir = this.windowScrollLeft <= 0 && xDir < 0 || this.windowScrollLeft >= maxScrollX && xDir > 0 ? 0 : xDir;
          yDir = this.windowScrollTop <= 0 && yDir < 0 || this.windowScrollTop >= maxScrollY && yDir > 0 ? 0 : yDir;
        } else {
          // Cap scrolling so we don't scroll past the container max scroll position.
          const maxScrollX = this._originalScrollContainerWidth - this.scrollContainer.clientWidth;
          const maxScrollY = this._originalScrollContainerHeight - this.scrollContainer.clientHeight;
          xDir = this.scrollContainer.scrollLeft <= 0 && xDir < 0 || this.scrollContainer.scrollLeft >= maxScrollX && xDir > 0 ? 0 : xDir;
          yDir = this.scrollContainer.scrollTop <= 0 && yDir < 0 || this.scrollContainer.scrollTop >= maxScrollY && yDir > 0 ? 0 : yDir;
        }
        const scrollByX = xDir * this._scrollContainerStep;
        const scrollByY = yDir * this._scrollContainerStep;
        // Scroll the corresponding window or container.
        if (!this.scrollContainer) {
          window.scrollBy(scrollByX, scrollByY);
        } else {
          this.scrollContainer.scrollLeft += scrollByX;
          this.scrollContainer.scrollTop += scrollByY;
        }
        if (this.ghost && !this.scrollContainer) {
          // Scroll the ghost only when there is no container specifies.
          // If it has container the ghost pretty much stays in the same position while the container is scrolled since e use top/left position.
          // Otherwise increase the position the same amount we have scrolled the window
          this.ghostLeft += scrollByX;
          this.ghostTop += scrollByY;
        } else if (!this.ghost) {
          // Move the base element the same amount we moved the window/container because we use transformations.
          const translateX = this.getTransformX(this.element.nativeElement) + scrollByX;
          const translateY = this.getTransformY(this.element.nativeElement) + scrollByY;
          this.setTransformXY(translateX, translateY);
          if (!this.scrollContainer) {
            this._lastX += scrollByX;
            this._lastY += scrollByY;
          }
        }
      });
    }
    onScrollContainer() {
      const scrollDir = this.getContainerScrollDirection();
      if (scrollDir !== null && scrollDir !== undefined && !this._containerScrollIntervalId) {
        // Save original container sizes to ensure that we don't increase scroll sizes infinitely when out of bounds.
        this._originalScrollContainerWidth = this.scrollContainer ? this.scrollContainer.scrollWidth : this.windowScrollWidth;
        this._originalScrollContainerHeight = this.scrollContainer ? this.scrollContainer.scrollHeight : this.windowScrollHeight;
        this._containerScrollIntervalId = setInterval(() => this.onScrollContainerStep(scrollDir), this._scrollContainerStepMs);
      } else if ((scrollDir === null || scrollDir === undefined) && this._containerScrollIntervalId) {
        // We moved out of end bounds and there is interval started
        clearInterval(this._containerScrollIntervalId);
        this._containerScrollIntervalId = null;
      }
    }
    static {
      this.ɵfac = function IgxDragDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDragDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDragDirective,
        selectors: [["", "igxDrag", ""]],
        contentQueries: function IgxDragDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxDragHandleDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxDragIgnoreDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragHandles = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragIgnoredElems = _t);
          }
        },
        hostVars: 4,
        hostBindings: function IgxDragDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-drag", ctx.baseClass)("igx-drag--select-disabled", ctx.selectDisabled);
          }
        },
        inputs: {
          data: [0, "igxDrag", "data"],
          dragTolerance: "dragTolerance",
          dragDirection: "dragDirection",
          dragChannel: "dragChannel",
          ghost: [2, "ghost", "ghost", booleanAttribute],
          ghostClass: "ghostClass",
          ghostStyle: "ghostStyle",
          ghostTemplate: "ghostTemplate",
          ghostHost: "ghostHost",
          scrollContainer: "scrollContainer",
          ghostOffsetX: "ghostOffsetX",
          ghostOffsetY: "ghostOffsetY"
        },
        outputs: {
          dragStart: "dragStart",
          dragMove: "dragMove",
          dragEnd: "dragEnd",
          dragClick: "dragClick",
          ghostCreate: "ghostCreate",
          ghostDestroy: "ghostDestroy",
          transitioned: "transitioned"
        },
        exportAs: ["drag"]
      });
    }
  }
  return IgxDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxDropDirective = /*#__PURE__*/(() => {
  class IgxDropDirective {
    /**
     * - Save data inside the `igxDrop` directive. This can be set when instancing `igxDrop` on an element.
     * ```html
     * <div [igxDrop]="{ source: myElement }"></div>
     * ```
     *
     * @memberof IgxDropDirective
     */
    set data(v) {
      this._data = v;
    }
    get data() {
      return this._data;
    }
    /**
     * Sets a drop strategy type that will be executed when an `IgxDrag` element is released inside
     *  the current drop area. The provided strategies are:
     *  - IgxDefaultDropStrategy - This is the default base strategy and it doesn't perform any actions.
     *  - IgxAppendDropStrategy - Appends the dropped element to last position as a direct child to the `igxDrop`.
     *  - IgxPrependDropStrategy - Prepends the dropped element to first position as a direct child to the `igxDrop`.
     *  - IgxInsertDropStrategy - If the dropped element is released above a child element of the `igxDrop`, it will be inserted
     *      at that position. Otherwise the dropped element will be appended if released outside any child of the `igxDrop`.
     * ```html
     * <div igxDrag>
     *      <span>DragMe</span>
     * </div>
     * <div igxDrop [dropStrategy]="myDropStrategy">
     *         <span>Numbers drop area!</span>
     * </div>
     * ```
     * ```typescript
     * import { IgxAppendDropStrategy } from 'igniteui-angular';
     *
     * export class App {
     *      public myDropStrategy = IgxAppendDropStrategy;
     * }
     * ```
     *
     * @memberof IgxDropDirective
     */
    set dropStrategy(classRef) {
      this._dropStrategy = new classRef(this._renderer);
    }
    get dropStrategy() {
      return this._dropStrategy;
    }
    constructor(element, _renderer, _zone) {
      this.element = element;
      this._renderer = _renderer;
      this._zone = _zone;
      /**
       * Event triggered when dragged element enters the area of the element.
       * ```html
       * <div class="cageArea" igxDrop (enter)="dragEnter()" (igxDragEnter)="onDragCageEnter()" (igxDragLeave)="onDragCageLeave()">
       * </div>
       * ```
       * ```typescript
       * public dragEnter(){
       *     alert("A draggable element has entered the chip area!");
       * }
       * ```
       *
       * @memberof IgxDropDirective
       */
      this.enter = new EventEmitter();
      /**
       * Event triggered when dragged element enters the area of the element.
       * ```html
       * <div class="cageArea" igxDrop (enter)="dragEnter()" (igxDragEnter)="onDragCageEnter()" (igxDragLeave)="onDragCageLeave()">
       * </div>
       * ```
       * ```typescript
       * public dragEnter(){
       *     alert("A draggable element has entered the chip area!");
       * }
       * ```
       *
       * @memberof IgxDropDirective
       */
      this.over = new EventEmitter();
      /**
       * Event triggered when dragged element leaves the area of the element.
       * ```html
       * <div class="cageArea" igxDrop (leave)="dragLeave()" (igxDragEnter)="onDragCageEnter()" (igxDragLeave)="onDragCageLeave()">
       * </div>
       * ```
       * ```typescript
       * public dragLeave(){
       *     alert("A draggable element has left the chip area!");
       * }
       * ```
       *
       * @memberof IgxDropDirective
       */
      this.leave = new EventEmitter();
      /**
       * Event triggered when dragged element is dropped in the area of the element.
       * Since the `igxDrop` has default logic that appends the dropped element as a child, it can be canceled here.
       * To cancel the default logic the `cancel` property of the event needs to be set to true.
       * ```html
       * <div class="cageArea" igxDrop (dropped)="dragDrop()" (igxDragEnter)="onDragCageEnter()" (igxDragLeave)="onDragCageLeave()">
       * </div>
       * ```
       * ```typescript
       * public dragDrop(){
       *     alert("A draggable element has been dropped in the chip area!");
       * }
       * ```
       *
       * @memberof IgxDropDirective
       */
      this.dropped = new EventEmitter();
      /**
       * @hidden
       */
      this.droppable = true;
      /**
       * @hidden
       */
      this.dragover = false;
      /**
       * @hidden
       */
      this._destroy = new Subject();
      this._dropStrategy = new IgxDefaultDropStrategy();
    }
    /**
     * @hidden
     */
    onDragDrop(event) {
      if (!this.isDragLinked(event.detail.owner)) {
        return;
      }
      const elementPosX = this.element.nativeElement.getBoundingClientRect().left + this.getWindowScrollLeft();
      const elementPosY = this.element.nativeElement.getBoundingClientRect().top + this.getWindowScrollTop();
      const offsetX = event.detail.pageX - elementPosX;
      const offsetY = event.detail.pageY - elementPosY;
      const args = {
        owner: this,
        originalEvent: event.detail.originalEvent,
        drag: event.detail.owner,
        dragData: event.detail.owner.data,
        startX: event.detail.startX,
        startY: event.detail.startY,
        pageX: event.detail.pageX,
        pageY: event.detail.pageY,
        offsetX,
        offsetY,
        cancel: false
      };
      this._zone.run(() => {
        this.dropped.emit(args);
      });
      if (this._dropStrategy && !args.cancel) {
        const elementsAtPoint = event.detail.owner.getElementsAtPoint(event.detail.pageX, event.detail.pageY);
        const insertIndex = this.getInsertIndexAt(event.detail.owner, elementsAtPoint);
        this._dropStrategy.dropAction(event.detail.owner, this, insertIndex);
      }
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this._zone.runOutsideAngular(() => {
        fromEvent(this.element.nativeElement, 'igxDragEnter').pipe(takeUntil(this._destroy)).subscribe(res => this.onDragEnter(res));
        fromEvent(this.element.nativeElement, 'igxDragLeave').pipe(takeUntil(this._destroy)).subscribe(res => this.onDragLeave(res));
        fromEvent(this.element.nativeElement, 'igxDragOver').pipe(takeUntil(this._destroy)).subscribe(res => this.onDragOver(res));
      });
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._destroy.next(true);
      this._destroy.complete();
    }
    /**
     * @hidden
     */
    onDragOver(event) {
      const elementPosX = this.element.nativeElement.getBoundingClientRect().left + this.getWindowScrollLeft();
      const elementPosY = this.element.nativeElement.getBoundingClientRect().top + this.getWindowScrollTop();
      const offsetX = event.detail.pageX - elementPosX;
      const offsetY = event.detail.pageY - elementPosY;
      const eventArgs = {
        originalEvent: event.detail.originalEvent,
        owner: this,
        drag: event.detail.owner,
        dragData: event.detail.owner.data,
        startX: event.detail.startX,
        startY: event.detail.startY,
        pageX: event.detail.pageX,
        pageY: event.detail.pageY,
        offsetX,
        offsetY
      };
      this.over.emit(eventArgs);
    }
    /**
     * @hidden
     */
    onDragEnter(event) {
      if (!this.isDragLinked(event.detail.owner)) {
        return;
      }
      this.dragover = true;
      const elementPosX = this.element.nativeElement.getBoundingClientRect().left + this.getWindowScrollLeft();
      const elementPosY = this.element.nativeElement.getBoundingClientRect().top + this.getWindowScrollTop();
      const offsetX = event.detail.pageX - elementPosX;
      const offsetY = event.detail.pageY - elementPosY;
      const eventArgs = {
        originalEvent: event.detail.originalEvent,
        owner: this,
        drag: event.detail.owner,
        dragData: event.detail.owner.data,
        startX: event.detail.startX,
        startY: event.detail.startY,
        pageX: event.detail.pageX,
        pageY: event.detail.pageY,
        offsetX,
        offsetY
      };
      this._zone.run(() => {
        this.enter.emit(eventArgs);
      });
    }
    /**
     * @hidden
     */
    onDragLeave(event) {
      if (!this.isDragLinked(event.detail.owner)) {
        return;
      }
      this.dragover = false;
      const elementPosX = this.element.nativeElement.getBoundingClientRect().left + this.getWindowScrollLeft();
      const elementPosY = this.element.nativeElement.getBoundingClientRect().top + this.getWindowScrollTop();
      const offsetX = event.detail.pageX - elementPosX;
      const offsetY = event.detail.pageY - elementPosY;
      const eventArgs = {
        originalEvent: event.detail.originalEvent,
        owner: this,
        drag: event.detail.owner,
        dragData: event.detail.owner.data,
        startX: event.detail.startX,
        startY: event.detail.startY,
        pageX: event.detail.pageX,
        pageY: event.detail.pageY,
        offsetX,
        offsetY
      };
      this._zone.run(() => {
        this.leave.emit(eventArgs);
      });
    }
    getWindowScrollTop() {
      return window.scrollY ? window.scrollY : window.pageYOffset ? window.pageYOffset : 0;
    }
    getWindowScrollLeft() {
      return window.scrollX ? window.scrollX : window.pageXOffset ? window.pageXOffset : 0;
    }
    isDragLinked(drag) {
      const dragLinkArray = drag.dragChannel instanceof Array;
      const dropLinkArray = this.dropChannel instanceof Array;
      if (!dragLinkArray && !dropLinkArray) {
        return this.dropChannel === drag.dragChannel;
      } else if (!dragLinkArray && dropLinkArray) {
        const dropLinks = this.dropChannel;
        for (const link of dropLinks) {
          if (link === drag.dragChannel) {
            return true;
          }
        }
      } else if (dragLinkArray && !dropLinkArray) {
        const dragLinks = drag.dragChannel;
        for (const link of dragLinks) {
          if (link === this.dropChannel) {
            return true;
          }
        }
      } else {
        const dragLinks = drag.dragChannel;
        const dropLinks = this.dropChannel;
        for (const draglink of dragLinks) {
          for (const droplink of dropLinks) {
            if (draglink === droplink) {
              return true;
            }
          }
        }
      }
      return false;
    }
    getInsertIndexAt(draggedDir, elementsAtPoint) {
      let insertIndex = -1;
      const dropChildren = Array.prototype.slice.call(this.element.nativeElement.children);
      if (!dropChildren.length) {
        return insertIndex;
      }
      let i = 0;
      let childUnder = null;
      while (!childUnder && i < elementsAtPoint.length) {
        if (elementsAtPoint[i].parentElement === this.element.nativeElement) {
          childUnder = elementsAtPoint[i];
        }
        i++;
      }
      const draggedElemIndex = dropChildren.indexOf(draggedDir.element.nativeElement);
      insertIndex = dropChildren.indexOf(childUnder);
      if (draggedElemIndex !== -1 && draggedElemIndex < insertIndex) {
        insertIndex++;
      }
      return insertIndex;
    }
    static {
      this.ɵfac = function IgxDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDropDirective,
        selectors: [["", "igxDrop", ""]],
        hostVars: 3,
        hostBindings: function IgxDropDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("igxDrop", function IgxDropDirective_igxDrop_HostBindingHandler($event) {
              return ctx.onDragDrop($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("droppable", ctx.droppable);
            i0.ɵɵclassProp("dragOver", ctx.dragover);
          }
        },
        inputs: {
          data: [0, "igxDrop", "data"],
          dropChannel: "dropChannel",
          dropStrategy: "dropStrategy"
        },
        outputs: {
          enter: "enter",
          over: "over",
          leave: "leave",
          dropped: "dropped"
        },
        exportAs: ["drop"]
      });
    }
  }
  return IgxDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Drag and drop directives collection for ease-of-use import in standalone components scenario */
const IGX_DRAG_DROP_DIRECTIVES = [IgxDragDirective, IgxDropDirective, IgxDragHandleDirective, IgxDragIgnoreDirective];
class IgxFilterOptions {
  constructor() {
    // Input text value that will be used as a filtering pattern (matching condition is based on it)
    this.inputValue = '';
  }
  // Function - get value to be tested from the item
  // item - single item of the list to be filtered
  // key - property name of item, which value should be tested
  // Default behavior - returns "key"- named property value of item if key is provided,
  // otherwise textContent of the item's html element
  get_value(item, key) {
    let result = '';
    if (key && item[key]) {
      result = item[key].toString();
    } else if (item.element) {
      if (item.element.nativeElement) {
        result = item.element.nativeElement.textContent.trim();
        // Check if element doesn't return the DOM element directly
      } else if (item.element.textContent) {
        result = item.element.textContent.trim();
      }
    }
    return result;
  }
  // Function - formats the original text before matching process
  // Default behavior - returns text to lower case
  formatter(valueToTest) {
    return valueToTest.toLowerCase();
  }
  // Function - determines whether the item met the condition
  // valueToTest - text value that should be tested
  // inputValue - text value from input that condition is based on
  // Default behavior - "contains"
  matchFn(valueToTest, inputValue) {
    return valueToTest.indexOf(inputValue && inputValue.toLowerCase() || '') > -1;
  }
  // Function - executed after matching test for every matched item
  // Default behavior - shows the item
  metConditionFn(item) {
    if (item.hasOwnProperty('hidden')) {
      item.hidden = false;
    }
  }
  // Function - executed for every NOT matched item after matching test
  // Default behavior - hides the item
  overdueConditionFn(item) {
    if (item.hasOwnProperty('hidden')) {
      item.hidden = true;
    }
  }
}
let IgxFilterDirective = /*#__PURE__*/(() => {
  class IgxFilterDirective {
    constructor() {
      this.filtering = new EventEmitter(false); // synchronous event emitter
      this.filtered = new EventEmitter();
    }
    ngOnChanges(changes) {
      // Detect only changes of input value
      if (changes.filterOptions && changes.filterOptions.currentValue && changes.filterOptions.currentValue.inputValue !== undefined && changes.filterOptions.previousValue && changes.filterOptions.currentValue.inputValue !== changes.filterOptions.previousValue.inputValue) {
        this.filter();
      }
    }
    filter() {
      if (!this.filterOptions.items) {
        return;
      }
      const args = {
        cancel: false,
        items: this.filterOptions.items
      };
      this.filtering.emit(args);
      if (args.cancel) {
        return;
      }
      const pipe = new IgxFilterPipe();
      const filtered = pipe.transform(this.filterOptions.items, this.filterOptions);
      this.filtered.emit({
        filteredItems: filtered
      });
    }
    static {
      this.ɵfac = function IgxFilterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxFilterDirective,
        selectors: [["", "igxFilter", ""]],
        inputs: {
          filterOptions: [0, "igxFilter", "filterOptions"]
        },
        outputs: {
          filtering: "filtering",
          filtered: "filtered"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxFilterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxFilterPipe = /*#__PURE__*/(() => {
  class IgxFilterPipe {
    findMatchByKey(item, options, key) {
      const match = options.matchFn(options.formatter(options.get_value(item, key)), options.inputValue);
      if (match) {
        if (options.metConditionFn) {
          options.metConditionFn(item);
        }
      } else {
        if (options.overdueConditionFn) {
          options.overdueConditionFn(item);
        }
      }
      return match;
    }
    transform(items,
    // options - initial settings of filter functionality
    options) {
      let result = [];
      if (!items || !items.length || !options) {
        return;
      }
      if (options.items) {
        items = options.items;
      }
      result = items.filter(item => {
        if (!Array.isArray(options.key)) {
          return this.findMatchByKey(item, options, options.key);
        } else {
          let isMatch = false;
          options.key.forEach(key => {
            if (this.findMatchByKey(item, options, key)) {
              isMatch = true;
            }
          });
          return isMatch;
        }
      });
      return result;
    }
    static {
      this.ɵfac = function IgxFilterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxFilter",
        type: IgxFilterPipe,
        pure: false
      });
    }
  }
  return IgxFilterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Injection token is used to inject the EditorProvider token into components
 *
 * @hidden @internal
 */
const EDITOR_PROVIDER = new InjectionToken('EditorProvider');
let IgxFocusDirective = /*#__PURE__*/(() => {
  class IgxFocusDirective {
    /**
     * Returns the state of the igxFocus.
     * ```typescript
     * @ViewChild('focusContainer', {read: IgxFocusDirective})
     * public igxFocus: IgxFocusDirective;
     * let isFocusOn = this.igxFocus.focused;
     * ```
     *
     * @memberof IgxFocusDirective
     */
    get focused() {
      return this.focusState;
    }
    /**
     * Sets the state of the igxFocus.
     * ```html
     * <igx-input-group >
     *  <input #focusContainer igxInput [igxFocus]="true"/>
     * </igx-input-group>
     * ```
     *
     * @memberof IgxFocusDirective
     */
    set focused(val) {
      this.focusState = val;
      this.trigger();
    }
    /**
     * Gets the native element of the igxFocus.
     * ```typescript
     * @ViewChild('focusContainer', {read: IgxFocusDirective})
     * public igxFocus: IgxFocusDirective;
     * let igxFocusNativeElement = this.igxFocus.nativeElement;
     * ```
     *
     * @memberof IgxFocusDirective
     */
    get nativeElement() {
      if (this.comp && this.comp[0] && this.comp[0].getEditElement) {
        return this.comp[0].getEditElement();
      }
      if (this.control && this.control[0] && this.control[0].getEditElement) {
        return this.control[0].getEditElement();
      }
      return this.element.nativeElement;
    }
    constructor(element, comp, control) {
      this.element = element;
      this.comp = comp;
      this.control = control;
      this.focusState = true;
    }
    /**
     * Triggers the igxFocus state.
     * ```typescript
     * @ViewChild('focusContainer', {read: IgxFocusDirective})
     * public igxFocus: IgxFocusDirective;
     * this.igxFocus.trigger();
     * ```
     *
     * @memberof IgxFocusDirective
     */
    trigger() {
      if (this.focusState) {
        requestAnimationFrame(() => this.nativeElement.focus({
          preventScroll: true
        }));
      }
    }
    static {
      this.ɵfac = function IgxFocusDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NG_VALUE_ACCESSOR, 10), i0.ɵɵdirectiveInject(EDITOR_PROVIDER, 10));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxFocusDirective,
        selectors: [["", "igxFocus", ""]],
        inputs: {
          focused: [2, "igxFocus", "focused", booleanAttribute]
        },
        exportAs: ["igxFocus"]
      });
    }
  }
  return IgxFocusDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxFocusTrapDirective = /*#__PURE__*/(() => {
  class IgxFocusTrapDirective {
    /** @hidden */
    get element() {
      return this.elementRef.nativeElement;
    }
    /** @hidden */
    constructor(elementRef, platformUtil) {
      this.elementRef = elementRef;
      this.platformUtil = platformUtil;
      this.destroy$ = new Subject();
      this._focusTrap = true;
    }
    /**
     * Sets whether the Tab key focus is trapped within the element.
     *
     * @example
     * ```html
     * <div igxFocusTrap="true"></div>
     * ```
     */
    set focusTrap(focusTrap) {
      this._focusTrap = focusTrap;
    }
    /** @hidden */
    get focusTrap() {
      return this._focusTrap;
    }
    /** @hidden */
    ngAfterViewInit() {
      fromEvent(this.element, 'keydown').pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (this._focusTrap && event.key === this.platformUtil.KEYMAP.TAB) {
          this.handleTab(event);
        }
      });
    }
    /** @hidden */
    ngOnDestroy() {
      this.destroy$.complete();
    }
    handleTab(event) {
      const elements = this.getFocusableElements(this.element);
      if (elements.length > 0) {
        const focusedElement = this.getFocusedElement();
        const focusedElementIndex = elements.findIndex(element => element === focusedElement);
        const direction = event.shiftKey ? -1 : 1;
        let nextFocusableElementIndex = focusedElementIndex + direction;
        if (nextFocusableElementIndex < 0) {
          nextFocusableElementIndex = elements.length - 1;
        }
        if (nextFocusableElementIndex >= elements.length) {
          nextFocusableElementIndex = 0;
        }
        elements[nextFocusableElementIndex].focus();
      } else {
        this.element.focus();
      }
      event.preventDefault();
    }
    getFocusableElements(element) {
      return Array.from(element.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')).filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
    }
    getFocusedElement() {
      let activeElement = typeof document !== 'undefined' && document ? document.activeElement : null;
      while (activeElement && activeElement.shadowRoot) {
        const newActiveElement = activeElement.shadowRoot.activeElement;
        if (newActiveElement === activeElement) {
          break;
        } else {
          activeElement = newActiveElement;
        }
      }
      return activeElement;
    }
    static {
      this.ɵfac = function IgxFocusTrapDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFocusTrapDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxFocusTrapDirective,
        selectors: [["", "igxFocusTrap", ""]],
        inputs: {
          focusTrap: [2, "igxFocusTrap", "focusTrap", booleanAttribute]
        }
      });
    }
  }
  return IgxFocusTrapDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxScrollInertiaDirective = /*#__PURE__*/(() => {
  class IgxScrollInertiaDirective {
    constructor(element, _zone) {
      this.element = element;
      this._zone = _zone;
      this.wheelStep = 50;
      this.inertiaStep = 1.5;
      this.smoothingStep = 1.5;
      this.smoothingDuration = 0.5;
      this.swipeToleranceX = 20;
      this.inertiaDeltaY = 3;
      this.inertiaDeltaX = 2;
      this.inertiaDuration = 0.5;
      this._savedSpeedsX = [];
      this.baseDeltaMultiplier = 1 / 120;
      this.firefoxDeltaMultiplier = 1 / 30;
    }
    ngOnInit() {
      this._zone.runOutsideAngular(() => {
        this.parentElement = this.element.nativeElement.parentElement || this.element.nativeElement.parentNode;
        if (!this.parentElement) {
          return;
        }
        const targetElem = this.parentElement;
        targetElem.addEventListener('wheel', this.onWheel.bind(this), {
          passive: false
        });
        targetElem.addEventListener('touchstart', this.onTouchStart.bind(this), {
          passive: false
        });
        targetElem.addEventListener('touchmove', this.onTouchMove.bind(this), {
          passive: false
        });
        targetElem.addEventListener('touchend', this.onTouchEnd.bind(this), {
          passive: false
        });
      });
    }
    ngOnDestroy() {
      this._zone.runOutsideAngular(() => {
        const targetElem = this.parentElement;
        if (!targetElem) {
          return;
        }
        targetElem.removeEventListener('wheel', this.onWheel);
        targetElem.removeEventListener('touchstart', this.onTouchStart);
        targetElem.removeEventListener('touchmove', this.onTouchMove);
        targetElem.removeEventListener('touchend', this.onTouchEnd);
      });
    }
    /**
     * @hidden
     * Function that is called when scrolling with the mouse wheel or using touchpad
     */
    onWheel(evt) {
      // if no scrollbar return
      if (!this.IgxScrollInertiaScrollContainer) {
        return;
      }
      // if ctrl key is pressed and the user want to zoom in/out the page
      if (evt.ctrlKey) {
        return;
      }
      let scrollDeltaX;
      let scrollDeltaY;
      const scrollStep = this.wheelStep;
      const minWheelStep = 1 / this.wheelStep;
      const smoothing = this.smoothingDuration !== 0;
      this._startX = this.IgxScrollInertiaScrollContainer.scrollLeft;
      this._startY = this.IgxScrollInertiaScrollContainer.scrollTop;
      if (evt.wheelDeltaX) {
        /* Option supported on Chrome, Safari, Opera.
        /* 120 is default for mousewheel on these browsers. Other values are for trackpads */
        scrollDeltaX = -evt.wheelDeltaX * this.baseDeltaMultiplier;
        if (-minWheelStep < scrollDeltaX && scrollDeltaX < minWheelStep) {
          scrollDeltaX = Math.sign(scrollDeltaX) * minWheelStep;
        }
      } else if (evt.deltaX) {
        /* For other browsers that don't provide wheelDelta, use the deltaY to determine direction and pass default values. */
        const deltaScaledX = evt.deltaX * (evt.deltaMode === 0 ? this.firefoxDeltaMultiplier : 1);
        scrollDeltaX = this.calcAxisCoords(deltaScaledX, -1, 1);
      }
      /** Get delta for the Y axis */
      if (evt.wheelDeltaY) {
        /* Option supported on Chrome, Safari, Opera.
        /* 120 is default for mousewheel on these browsers. Other values are for trackpads */
        scrollDeltaY = -evt.wheelDeltaY * this.baseDeltaMultiplier;
        if (-minWheelStep < scrollDeltaY && scrollDeltaY < minWheelStep) {
          scrollDeltaY = Math.sign(scrollDeltaY) * minWheelStep;
        }
      } else if (evt.deltaY) {
        /* For other browsers that don't provide wheelDelta, use the deltaY to determine direction and pass default values. */
        const deltaScaledY = evt.deltaY * (evt.deltaMode === 0 ? this.firefoxDeltaMultiplier : 1);
        scrollDeltaY = this.calcAxisCoords(deltaScaledY, -1, 1);
      }
      if (evt.composedPath && this.didChildScroll(evt, scrollDeltaX, scrollDeltaY)) {
        return;
      }
      if (scrollDeltaX && this.IgxScrollInertiaDirection === 'horizontal') {
        const nextLeft = this._startX + scrollDeltaX * scrollStep;
        if (!smoothing) {
          this._scrollToX(nextLeft);
        } else {
          this._smoothWheelScroll(scrollDeltaX);
        }
        const maxScrollLeft = parseInt(this.IgxScrollInertiaScrollContainer.children[0].style.width, 10);
        if (0 < nextLeft && nextLeft < maxScrollLeft) {
          // Prevent navigating through pages when scrolling on Mac
          evt.preventDefault();
        }
      } else if (evt.shiftKey && scrollDeltaY && this.IgxScrollInertiaDirection === 'horizontal') {
        if (!smoothing) {
          const step = this._startX + scrollDeltaY * scrollStep;
          this._scrollToX(step);
        } else {
          this._smoothWheelScroll(scrollDeltaY);
        }
      } else if (!evt.shiftKey && scrollDeltaY && this.IgxScrollInertiaDirection === 'vertical') {
        const nextTop = this._startY + scrollDeltaY * scrollStep;
        if (!smoothing) {
          this._scrollToY(nextTop);
        } else {
          this._smoothWheelScroll(scrollDeltaY);
        }
        this.preventParentScroll(evt, true, nextTop);
      }
    }
    /**
     * @hidden
     * When there is still room to scroll up/down prevent the parent elements from scrolling too.
     */
    preventParentScroll(evt, preventDefault, nextTop = 0) {
      const curScrollTop = nextTop === 0 ? this.IgxScrollInertiaScrollContainer.scrollTop : nextTop;
      const maxScrollTop = this.IgxScrollInertiaScrollContainer.children[0].scrollHeight - this.IgxScrollInertiaScrollContainer.offsetHeight;
      if (0 < curScrollTop && curScrollTop < maxScrollTop) {
        if (preventDefault) {
          evt.preventDefault();
        }
        if (evt.stopPropagation) {
          evt.stopPropagation();
        }
      }
    }
    /**
     * @hidden
     * Checks if the wheel event would have scrolled an element under the display container
     * in DOM tree so that it can correctly be ignored until that element can no longer be scrolled.
     */
    didChildScroll(evt, scrollDeltaX, scrollDeltaY) {
      const path = evt.composedPath();
      let i = 0;
      while (i < path.length && path[i].localName !== 'igx-display-container') {
        const e = path[i++];
        if (e.scrollHeight > e.clientHeight) {
          const overflowY = window.getComputedStyle(e)['overflow-y'];
          if (overflowY === 'auto' || overflowY === 'scroll') {
            if (scrollDeltaY > 0 && e.scrollHeight - Math.abs(Math.round(e.scrollTop)) !== e.clientHeight) {
              return true;
            }
            if (scrollDeltaY < 0 && e.scrollTop !== 0) {
              return true;
            }
          }
        }
        if (e.scrollWidth > e.clientWidth) {
          const overflowX = window.getComputedStyle(e)['overflow-x'];
          if (overflowX === 'auto' || overflowX === 'scroll') {
            if (scrollDeltaX > 0 && e.scrollWidth - Math.abs(Math.round(e.scrollLeft)) !== e.clientWidth) {
              return true;
            }
            if (scrollDeltaX < 0 && e.scrollLeft !== 0) {
              return true;
            }
          }
        }
      }
      return false;
    }
    /**
     * @hidden
     * Function that is called the first moment we start interacting with the content on a touch device
     */
    onTouchStart(event) {
      if (!this.IgxScrollInertiaScrollContainer) {
        return false;
      }
      // stops any current ongoing inertia
      cancelAnimationFrame(this._touchInertiaAnimID);
      const touch = event.touches[0];
      this._startX = this.IgxScrollInertiaScrollContainer.scrollLeft;
      this._startY = this.IgxScrollInertiaScrollContainer.scrollTop;
      this._touchStartX = touch.pageX;
      this._touchStartY = touch.pageY;
      this._lastTouchEnd = new Date().getTime();
      this._lastTouchX = touch.pageX;
      this._lastTouchY = touch.pageY;
      this._savedSpeedsX = [];
      this._savedSpeedsY = [];
      // Vars regarding swipe offset
      this._totalMovedX = 0;
      this._offsetRecorded = false;
      this._offsetDirection = 0;
      if (this.IgxScrollInertiaDirection === 'vertical') {
        this.preventParentScroll(event, false);
      }
    }
    /**
     * @hidden
     * Function that is called when we need to scroll the content based on touch interactions
     */
    onTouchMove(event) {
      if (!this.IgxScrollInertiaScrollContainer) {
        return;
      }
      const touch = event.touches[0];
      const destX = this._startX + (this._touchStartX - touch.pageX) * Math.sign(this.inertiaStep);
      const destY = this._startY + (this._touchStartY - touch.pageY) * Math.sign(this.inertiaStep);
      /* Handle complex touchmoves when swipe stops but the toch doesn't end and then a swipe is initiated again */
      /* **********************************************************/
      const timeFromLastTouch = new Date().getTime() - this._lastTouchEnd;
      if (timeFromLastTouch !== 0 && timeFromLastTouch < 100) {
        const speedX = (this._lastTouchX - touch.pageX) / timeFromLastTouch;
        const speedY = (this._lastTouchY - touch.pageY) / timeFromLastTouch;
        // Save the last 5 speeds between two touchmoves on X axis
        if (this._savedSpeedsX.length < 5) {
          this._savedSpeedsX.push(speedX);
        } else {
          this._savedSpeedsX.shift();
          this._savedSpeedsX.push(speedX);
        }
        // Save the last 5 speeds between two touchmoves on Y axis
        if (this._savedSpeedsY.length < 5) {
          this._savedSpeedsY.push(speedY);
        } else {
          this._savedSpeedsY.shift();
          this._savedSpeedsY.push(speedY);
        }
      }
      this._lastTouchEnd = new Date().getTime();
      this._lastMovedX = this._lastTouchX - touch.pageX;
      this._lastMovedY = this._lastTouchY - touch.pageY;
      this._lastTouchX = touch.pageX;
      this._lastTouchY = touch.pageY;
      this._totalMovedX += this._lastMovedX;
      /*	Do not scroll using touch untill out of the swipeToleranceX bounds */
      if (Math.abs(this._totalMovedX) < this.swipeToleranceX && !this._offsetRecorded) {
        this._scrollTo(this._startX, destY);
      } else {
        /*	Record the direction the first time we are out of the swipeToleranceX bounds.
        *	That way we know which direction we apply the offset so it doesn't hickup when moving out of the swipeToleranceX bounds */
        if (!this._offsetRecorded) {
          this._offsetDirection = Math.sign(destX - this._startX);
          this._offsetRecorded = true;
        }
        /*	Scroll with offset ammout of swipeToleranceX in the direction we have exited the bounds and
        don't change it after that ever until touchend and again touchstart */
        this._scrollTo(destX - this._offsetDirection * this.swipeToleranceX, destY);
      }
      // On Safari preventing the touchmove would prevent default page scroll behaviour even if there is the element doesn't have overflow
      if (this.IgxScrollInertiaDirection === 'vertical') {
        this.preventParentScroll(event, true);
      }
    }
    onTouchEnd(event) {
      let speedX = 0;
      let speedY = 0;
      // savedSpeedsX and savedSpeedsY have same length
      for (let i = 0; i < this._savedSpeedsX.length; i++) {
        speedX += this._savedSpeedsX[i];
        speedY += this._savedSpeedsY[i];
      }
      speedX = this._savedSpeedsX.length ? speedX / this._savedSpeedsX.length : 0;
      speedY = this._savedSpeedsX.length ? speedY / this._savedSpeedsY.length : 0;
      // Use the lastMovedX and lastMovedY to determine if the swipe stops without lifting the finger so we don't start inertia
      if ((Math.abs(speedX) > 0.1 || Math.abs(speedY) > 0.1) && (Math.abs(this._lastMovedX) > 2 || Math.abs(this._lastMovedY) > 2)) {
        this._inertiaInit(speedX, speedY);
      }
      if (this.IgxScrollInertiaDirection === 'vertical') {
        this.preventParentScroll(event, false);
      }
    }
    _smoothWheelScroll(delta) {
      this._nextY = this.IgxScrollInertiaScrollContainer.scrollTop;
      this._nextX = this.IgxScrollInertiaScrollContainer.scrollLeft;
      let x = -1;
      let wheelInertialAnimation = null;
      const inertiaWheelStep = () => {
        if (x > 1) {
          cancelAnimationFrame(wheelInertialAnimation);
          return;
        }
        const nextScroll = (-3 * x * x + 3) * delta * 2 * this.smoothingStep;
        if (this.IgxScrollInertiaDirection === 'vertical') {
          this._nextY += nextScroll;
          this._scrollToY(this._nextY);
        } else {
          this._nextX += nextScroll;
          this._scrollToX(this._nextX);
        }
        //continue the inertia
        x += 0.08 * (1 / this.smoothingDuration);
        wheelInertialAnimation = requestAnimationFrame(inertiaWheelStep);
      };
      wheelInertialAnimation = requestAnimationFrame(inertiaWheelStep);
    }
    _inertiaInit(speedX, speedY) {
      const stepModifer = this.inertiaStep;
      const inertiaDuration = this.inertiaDuration;
      let x = 0;
      this._nextX = this.IgxScrollInertiaScrollContainer.scrollLeft;
      this._nextY = this.IgxScrollInertiaScrollContainer.scrollTop;
      // Sets timeout until executing next movement iteration of the inertia
      const inertiaStep = () => {
        if (x > 6) {
          cancelAnimationFrame(this._touchInertiaAnimID);
          return;
        }
        if (Math.abs(speedX) > Math.abs(speedY)) {
          x += 0.05 / (1 * inertiaDuration);
        } else {
          x += 0.05 / (1 * inertiaDuration);
        }
        if (x <= 1) {
          // We use constant quation to determine the offset without speed falloff befor x reaches 1
          if (Math.abs(speedY) <= Math.abs(speedX) * this.inertiaDeltaY) {
            this._nextX += 1 * speedX * 15 * stepModifer;
          }
          if (Math.abs(speedY) >= Math.abs(speedX) * this.inertiaDeltaX) {
            this._nextY += 1 * speedY * 15 * stepModifer;
          }
        } else {
          // We use the quation "y = 2 / (x + 0.55) - 0.3" to determine the offset
          if (Math.abs(speedY) <= Math.abs(speedX) * this.inertiaDeltaY) {
            this._nextX += Math.abs(2 / (x + 0.55) - 0.3) * speedX * 15 * stepModifer;
          }
          if (Math.abs(speedY) >= Math.abs(speedX) * this.inertiaDeltaX) {
            this._nextY += Math.abs(2 / (x + 0.55) - 0.3) * speedY * 15 * stepModifer;
          }
        }
        // If we have mixed environment we use the default behaviour. i.e. touchscreen + mouse
        this._scrollTo(this._nextX, this._nextY);
        this._touchInertiaAnimID = requestAnimationFrame(inertiaStep);
      };
      // Start inertia and continue it recursively
      this._touchInertiaAnimID = requestAnimationFrame(inertiaStep);
    }
    calcAxisCoords(target, min, max) {
      if (target === undefined || target < min) {
        target = min;
      } else if (target > max) {
        target = max;
      }
      return target;
    }
    _scrollTo(destX, destY) {
      // TODO Trigger scrolling event?
      const scrolledX = this._scrollToX(destX);
      const scrolledY = this._scrollToY(destY);
      return {
        x: scrolledX,
        y: scrolledY
      };
    }
    _scrollToX(dest) {
      this.IgxScrollInertiaScrollContainer.scrollLeft = dest;
    }
    _scrollToY(dest) {
      this.IgxScrollInertiaScrollContainer.scrollTop = dest;
    }
    static {
      this.ɵfac = function IgxScrollInertiaDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxScrollInertiaDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxScrollInertiaDirective,
        selectors: [["", "igxScrollInertia", ""]],
        inputs: {
          IgxScrollInertiaDirection: "IgxScrollInertiaDirection",
          IgxScrollInertiaScrollContainer: "IgxScrollInertiaScrollContainer",
          wheelStep: "wheelStep",
          inertiaStep: "inertiaStep",
          smoothingStep: "smoothingStep",
          smoothingDuration: "smoothingDuration",
          swipeToleranceX: "swipeToleranceX",
          inertiaDeltaY: "inertiaDeltaY",
          inertiaDeltaX: "inertiaDeltaX",
          inertiaDuration: "inertiaDuration"
        }
      });
    }
  }
  return IgxScrollInertiaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DisplayContainerComponent = /*#__PURE__*/(() => {
  class DisplayContainerComponent {
    constructor(cdr, _viewContainer) {
      this.cdr = cdr;
      this._viewContainer = _viewContainer;
      this.cssClass = 'igx-display-container';
      this.notVirtual = true;
    }
    static {
      this.ɵfac = function DisplayContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DisplayContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DisplayContainerComponent,
        selectors: [["igx-display-container"]],
        viewQuery: function DisplayContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 7, ViewContainerRef);
            i0.ɵɵviewQuery(_c4, 7, IgxScrollInertiaDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._vcr = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._scrollInertia = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function DisplayContainerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.cssClass);
            i0.ɵɵclassProp("igx-display-container--inactive", ctx.notVirtual);
          }
        },
        decls: 2,
        vars: 2,
        consts: [["display_container", ""], ["igxScrollInertia", "", 3, "IgxScrollInertiaScrollContainer", "IgxScrollInertiaDirection"]],
        template: function DisplayContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DisplayContainerComponent_ng_template_0_Template, 0, 0, "ng-template", 1, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("IgxScrollInertiaScrollContainer", ctx.scrollContainer)("IgxScrollInertiaDirection", ctx.scrollDirection);
          }
        },
        dependencies: [IgxScrollInertiaDirective],
        encapsulation: 2
      });
    }
  }
  return DisplayContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VirtualHelperBaseDirective = /*#__PURE__*/(() => {
  class VirtualHelperBaseDirective {
    constructor(elementRef, cdr, _zone, document, platformUtil) {
      this.elementRef = elementRef;
      this.cdr = cdr;
      this._zone = _zone;
      this.document = document;
      this.platformUtil = platformUtil;
      this.scrollAmount = 0;
      this._size = 0;
      this.destroy$ = new Subject();
      this._afterViewInit = false;
      this._detached = false;
      this._scrollNativeSize = this.calculateScrollNativeSize();
    }
    onScroll(event) {
      this.scrollAmount = event.target.scrollTop || event.target.scrollLeft;
    }
    ngAfterViewInit() {
      this._afterViewInit = true;
      if (!this.platformUtil.isBrowser) {
        return;
      }
      const delayTime = 0;
      this._zone.runOutsideAngular(() => {
        resizeObservable(this.nativeElement).pipe(throttleTime(delayTime), takeUntil(this.destroy$)).subscribe(event => this.handleMutations(event));
      });
    }
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    ngOnDestroy() {
      this.destroyed = true;
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    calculateScrollNativeSize() {
      const div = this.document.createElement('div');
      const style = div.style;
      style.width = '100px';
      style.height = '100px';
      style.position = 'absolute';
      style.top = '-10000px';
      style.top = '-10000px';
      style.overflow = 'scroll';
      this.document.body.appendChild(div);
      const scrollWidth = div.offsetWidth - div.clientWidth;
      this.document.body.removeChild(div);
      return scrollWidth ? scrollWidth + 1 : 1;
    }
    set size(value) {
      if (this.destroyed) {
        return;
      }
      this._size = value;
      if (this._afterViewInit) {
        this.cdr.detectChanges();
      }
    }
    get size() {
      return this._size;
    }
    get scrollNativeSize() {
      return this._scrollNativeSize;
    }
    get isAttachedToDom() {
      return this.document.body.contains(this.nativeElement);
    }
    handleMutations(event) {
      const hasSize = !(event[0].contentRect.height === 0 && event[0].contentRect.width === 0);
      if (!hasSize && !this.isAttachedToDom) {
        // scroll bar detached from DOM
        this._detached = true;
      } else if (this._detached && hasSize && this.isAttachedToDom) {
        // attached back now.
        this.restoreScroll();
      }
    }
    restoreScroll() {}
    static {
      this.ɵfac = function VirtualHelperBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VirtualHelperBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VirtualHelperBaseDirective,
        selectors: [["", "igxVirtualHelperBase", ""]],
        hostBindings: function VirtualHelperBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function VirtualHelperBaseDirective_scroll_HostBindingHandler($event) {
              return ctx.onScroll($event);
            });
          }
        }
      });
    }
  }
  return VirtualHelperBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let HVirtualHelperComponent = /*#__PURE__*/(() => {
  class HVirtualHelperComponent extends VirtualHelperBaseDirective {
    constructor(elementRef, cdr, zone, document, platformUtil) {
      super(elementRef, cdr, zone, document, platformUtil);
      this.cssClasses = 'igx-vhelper--horizontal';
    }
    restoreScroll() {
      this.nativeElement.scrollLeft = this.scrollAmount;
    }
    static {
      this.ɵfac = function HVirtualHelperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HVirtualHelperComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HVirtualHelperComponent,
        selectors: [["igx-horizontal-virtual-helper"]],
        viewQuery: function HVirtualHelperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c5, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._vcr = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function HVirtualHelperComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.cssClasses);
          }
        },
        inputs: {
          width: "width"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 2,
        consts: [["horizontal_container", ""], [1, "igx-vhelper__placeholder-content"]],
        template: function HVirtualHelperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.size, "px");
          }
        },
        encapsulation: 2
      });
    }
  }
  return HVirtualHelperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VirtualHelperComponent = /*#__PURE__*/(() => {
  class VirtualHelperComponent extends VirtualHelperBaseDirective {
    constructor(elementRef, cdr, zone, document, platformUtil) {
      super(elementRef, cdr, zone, document, platformUtil);
      this.cssClasses = 'igx-vhelper--vertical';
    }
    ngOnInit() {
      this.scrollWidth = this.scrollNativeSize;
    }
    restoreScroll() {
      this.nativeElement.scrollTop = this.scrollAmount;
    }
    static {
      this.ɵfac = function VirtualHelperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VirtualHelperComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VirtualHelperComponent,
        selectors: [["igx-virtual-helper"]],
        viewQuery: function VirtualHelperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._vcr = _t.first);
          }
        },
        hostVars: 5,
        hostBindings: function VirtualHelperComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("scrollTop", ctx.scrollTop);
            i0.ɵɵclassMap(ctx.cssClasses);
            i0.ɵɵstyleProp("width", ctx.scrollWidth, "px");
          }
        },
        inputs: {
          itemsLength: "itemsLength"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 2,
        consts: [["container", ""], [1, "igx-vhelper__placeholder-content"]],
        template: function VirtualHelperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("height", ctx.size, "px");
          }
        },
        encapsulation: 2
      });
    }
  }
  return VirtualHelperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxForOfSyncService = /*#__PURE__*/(() => {
  class IgxForOfSyncService {
    constructor() {
      this._master = new Map();
    }
    /**
     * @hidden
     */
    isMaster(directive) {
      return this._master.get(directive.igxForScrollOrientation) === directive;
    }
    /**
     * @hidden
     */
    setMaster(directive, forced = false) {
      const orientation = directive.igxForScrollOrientation;
      // in case master is not in dom, set a new master
      const isMasterInDom = this._master.get(orientation)?.dc?.instance?._viewContainer.element.nativeElement.isConnected;
      if (!isMasterInDom) {
        forced = true;
      }
      if (orientation && (forced || !this._master.has(orientation))) {
        this._master.set(orientation, directive);
      }
    }
    /**
     * @hidden
     */
    resetMaster() {
      this._master.clear();
    }
    /**
     * @hidden
     */
    sizesCache(dir) {
      return this._master.get(dir).sizesCache;
    }
    /**
     * @hidden
     */
    chunkSize(dir) {
      return this._master.get(dir).state.chunkSize;
    }
    static {
      this.ɵfac = function IgxForOfSyncService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxForOfSyncService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxForOfSyncService,
        factory: IgxForOfSyncService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxForOfSyncService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxForOfScrollSyncService = /*#__PURE__*/(() => {
  class IgxForOfScrollSyncService {
    constructor() {
      this._masterScroll = new Map();
    }
    setScrollMaster(dir, scroll) {
      this._masterScroll.set(dir, scroll);
    }
    getScrollMaster(dir) {
      return this._masterScroll.get(dir);
    }
    static {
      this.ɵfac = function IgxForOfScrollSyncService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxForOfScrollSyncService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxForOfScrollSyncService,
        factory: IgxForOfScrollSyncService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxForOfScrollSyncService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAX_PERF_SCROLL_DIFF = 4;
/**
 *  @publicApi
 */
class IgxForOfContext {
  constructor($implicit, igxForOf, index, count) {
    this.$implicit = $implicit;
    this.igxForOf = igxForOf;
    this.index = index;
    this.count = count;
  }
  /**
   * A function that returns whether the element is the first or not
   */
  get first() {
    return this.index === 0;
  }
  /**
   * A function that returns whether the element is the last or not
   */
  get last() {
    return this.index === this.count - 1;
  }
  /**
   * A function that returns whether the element is even or not
   */
  get even() {
    return this.index % 2 === 0;
  }
  /**
   * A function that returns whether the element is odd or not
   */
  get odd() {
    return !this.even;
  }
}
/** @hidden @internal */
class IgxForOfToken {}
let IgxForOfDirective = /*#__PURE__*/(() => {
  class IgxForOfDirective extends IgxForOfToken {
    /**
     * The total count of the virtual data items, when using remote service.
     * Similar to the property totalItemCount, but this will allow setting the data count into the template.
     * ```html
     * <ng-template igxFor let-item [igxForOf]="data | async" [igxForTotalItemCount]="count | async"
     *  [igxForContainerSize]="'500px'" [igxForItemSize]="'50px'"></ng-template>
     * ```
     */
    get igxForTotalItemCount() {
      return this.totalItemCount;
    }
    set igxForTotalItemCount(value) {
      this.totalItemCount = value;
    }
    /**
     * The total count of the virtual data items, when using remote service.
     * ```typescript
     * this.parentVirtDir.totalItemCount = data.Count;
     * ```
     */
    get totalItemCount() {
      return this._totalItemCount;
    }
    set totalItemCount(val) {
      if (this._totalItemCount !== val) {
        this._totalItemCount = val;
        // update sizes in case total count changes.
        const newSize = this.initSizesCache(this.igxForOf);
        const sizeDiff = this.scrollComponent.size - newSize;
        this.scrollComponent.size = newSize;
        const lastChunkExceeded = this.state.startIndex + this.state.chunkSize > val;
        if (lastChunkExceeded) {
          this.state.startIndex = val - this.state.chunkSize;
        }
        this._adjustScrollPositionAfterSizeChange(sizeDiff);
      }
    }
    get displayContainer() {
      return this.dc?.instance?._viewContainer?.element?.nativeElement;
    }
    get virtualHelper() {
      return this.scrollComponent.nativeElement;
    }
    /**
     * @hidden
     */
    get isRemote() {
      return this.totalItemCount !== null;
    }
    /**
     *
     * Gets/Sets the scroll position.
     * ```typescript
     * const position = directive.scrollPosition;
     * directive.scrollPosition = value;
     * ```
     */
    get scrollPosition() {
      return this.scrollComponent.scrollAmount;
    }
    set scrollPosition(val) {
      if (val === this.scrollComponent.scrollAmount) {
        return;
      }
      if (this.igxForScrollOrientation === 'horizontal' && this.scrollComponent) {
        this.scrollComponent.nativeElement.scrollLeft = this.isRTL ? -val : val;
      } else if (this.scrollComponent) {
        this.scrollComponent.nativeElement.scrollTop = val;
      }
    }
    /**
     * @hidden
     */
    get isRTL() {
      const dir = window.getComputedStyle(this.dc.instance._viewContainer.element.nativeElement).getPropertyValue('direction');
      return dir === 'rtl';
    }
    get sizesCache() {
      return this._sizesCache;
    }
    set sizesCache(value) {
      this._sizesCache = value;
    }
    get _isScrolledToBottom() {
      if (!this.getScroll()) {
        return true;
      }
      const scrollHeight = this.getScroll().scrollHeight;
      // Use === and not >= because `scrollTop + container size` can't be bigger than `scrollHeight`, unless something isn't updated.
      // Also use Math.round because Chrome has some inconsistencies and `scrollTop + container` can be float when zooming the page.
      return Math.round(this.getScroll().scrollTop + this.igxForContainerSize) === scrollHeight;
    }
    get _isAtBottomIndex() {
      return this.igxForOf && this.state.startIndex + this.state.chunkSize > this.igxForOf.length;
    }
    constructor(_viewContainer, _template, _differs, cdr, _zone, syncScrollService, platformUtil, document) {
      super();
      this._viewContainer = _viewContainer;
      this._template = _template;
      this._differs = _differs;
      this.cdr = cdr;
      this._zone = _zone;
      this.syncScrollService = syncScrollService;
      this.platformUtil = platformUtil;
      this.document = document;
      /**
       * Specifies the scroll orientation.
       * Scroll orientation can be "vertical" or "horizontal".
       * ```html
       * <ng-template igxFor let-item [igxForOf]="data" [igxForScrollOrientation]="'horizontal'"></ng-template>
       * ```
       */
      this.igxForScrollOrientation = 'vertical';
      /**
       * An event that is emitted after a new chunk has been loaded.
       * ```html
       * <ng-template igxFor [igxForOf]="data" [igxForScrollOrientation]="'horizontal'" (chunkLoad)="loadChunk($event)"></ng-template>
       * ```
       * ```typescript
       * loadChunk(e){
       * alert("chunk loaded!");
       * }
       * ```
       */
      this.chunkLoad = new EventEmitter();
      /**
       * @hidden @internal
       * An event that is emitted when scrollbar visibility has changed.
       */
      this.scrollbarVisibilityChanged = new EventEmitter();
      /**
       * An event that is emitted after the rendered content size of the igxForOf has been changed.
       */
      this.contentSizeChange = new EventEmitter();
      /**
       * An event that is emitted after data has been changed.
       * ```html
       * <ng-template igxFor [igxForOf]="data" [igxForScrollOrientation]="'horizontal'" (dataChanged)="dataChanged($event)"></ng-template>
       * ```
       * ```typescript
       * dataChanged(e){
       * alert("data changed!");
       * }
       * ```
       */
      this.dataChanged = new EventEmitter();
      this.beforeViewDestroyed = new EventEmitter();
      /**
       * An event that is emitted on chunk loading to emit the current state information - startIndex, endIndex, totalCount.
       * Can be used for implementing remote load on demand for the igxFor data.
       * ```html
       * <ng-template igxFor [igxForOf]="data" [igxForScrollOrientation]="'horizontal'" (chunkPreload)="chunkPreload($event)"></ng-template>
       * ```
       * ```typescript
       * chunkPreload(e){
       * alert("chunk is loading!");
       * }
       * ```
       */
      this.chunkPreload = new EventEmitter();
      /**
       * The current state of the directive. It contains `startIndex` and `chunkSize`.
       * state.startIndex - The index of the item at which the current visible chunk begins.
       * state.chunkSize - The number of items the current visible chunk holds.
       * These options can be used when implementing remote virtualization as they provide the necessary state information.
       * ```typescript
       * const gridState = this.parentVirtDir.state;
       * ```
       */
      this.state = {
        startIndex: 0,
        chunkSize: 0
      };
      this._sizesCache = [];
      this._differ = null;
      this.individualSizeCache = [];
      /** Internal track for scroll top that is being virtualized */
      this._virtScrollPosition = 0;
      /** If the next onScroll event is triggered due to internal setting of scrollTop */
      this._bScrollInternal = false;
      // End properties related to virtual height handling
      this._embeddedViews = [];
      this.contentResizeNotify = new Subject();
      /** Size that is being virtualized. */
      this._virtSize = 0;
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
      this._totalItemCount = null;
      /**
       * Ratio for height that's being virtualizaed and the one visible
       * If _virtHeightRatio = 1, the visible height and the virtualized are the same, also _maxSize > _virtHeight.
       */
      this._virtRatio = 1;
    }
    verticalScrollHandler(event) {
      this.onScroll(event);
    }
    isScrollable() {
      return this.scrollComponent.size > parseInt(this.igxForContainerSize, 10);
    }
    /**
     * @hidden
     */
    ngOnInit() {
      const vc = this.igxForScrollContainer ? this.igxForScrollContainer._viewContainer : this._viewContainer;
      this.igxForSizePropName = this.igxForSizePropName || 'width';
      this.dc = this._viewContainer.createComponent(DisplayContainerComponent, {
        index: 0
      });
      this.dc.instance.scrollDirection = this.igxForScrollOrientation;
      if (this.igxForOf && this.igxForOf.length) {
        this.scrollComponent = this.syncScrollService.getScrollMaster(this.igxForScrollOrientation);
        this.state.chunkSize = this._calculateChunkSize();
        this.dc.instance.notVirtual = !(this.igxForContainerSize && this.state.chunkSize < this.igxForOf.length);
        if (this.scrollComponent && !this.scrollComponent.destroyed) {
          this.state.startIndex = Math.min(this.getIndexAt(this.scrollPosition, this.sizesCache), this.igxForOf.length - this.state.chunkSize);
        }
        for (let i = this.state.startIndex; i < this.state.startIndex + this.state.chunkSize && this.igxForOf[i] !== undefined; i++) {
          const input = this.igxForOf[i];
          const embeddedView = this.dc.instance._vcr.createEmbeddedView(this._template, new IgxForOfContext(input, this.igxForOf, this.getContextIndex(input), this.igxForOf.length));
          this._embeddedViews.push(embeddedView);
        }
      }
      this._maxSize = this._calcMaxBrowserSize();
      if (this.igxForScrollOrientation === 'vertical') {
        this.dc.instance._viewContainer.element.nativeElement.style.top = '0px';
        this.scrollComponent = this.syncScrollService.getScrollMaster(this.igxForScrollOrientation);
        if (!this.scrollComponent || this.scrollComponent.destroyed) {
          this.scrollComponent = vc.createComponent(VirtualHelperComponent).instance;
        }
        this.scrollComponent.size = this.igxForOf ? this._calcSize() : 0;
        this.syncScrollService.setScrollMaster(this.igxForScrollOrientation, this.scrollComponent);
        this._zone.runOutsideAngular(() => {
          this.verticalScrollHandler = this.verticalScrollHandler.bind(this);
          this.scrollComponent.nativeElement.addEventListener('scroll', this.verticalScrollHandler);
          this.dc.instance.scrollContainer = this.scrollComponent.nativeElement;
        });
        const destructor = takeUntil(this.destroy$);
        this.contentResizeNotify.pipe(filter(() => this.igxForContainerSize && this.igxForOf && this.igxForOf.length > 0), throttleTime(40, undefined, {
          leading: false,
          trailing: true
        }), destructor).subscribe(() => this._zone.runTask(() => this.updateSizes()));
      }
      if (this.igxForScrollOrientation === 'horizontal') {
        this.func = evt => this.onHScroll(evt);
        this.scrollComponent = this.syncScrollService.getScrollMaster(this.igxForScrollOrientation);
        if (!this.scrollComponent) {
          this.scrollComponent = vc.createComponent(HVirtualHelperComponent).instance;
          this.scrollComponent.size = this.igxForOf ? this._calcSize() : 0;
          this.syncScrollService.setScrollMaster(this.igxForScrollOrientation, this.scrollComponent);
          this._zone.runOutsideAngular(() => {
            this.scrollComponent.nativeElement.addEventListener('scroll', this.func);
            this.dc.instance.scrollContainer = this.scrollComponent.nativeElement;
          });
        } else {
          this._zone.runOutsideAngular(() => {
            this.scrollComponent.nativeElement.addEventListener('scroll', this.func);
            this.dc.instance.scrollContainer = this.scrollComponent.nativeElement;
          });
        }
        this._updateScrollOffset();
      }
    }
    ngAfterViewInit() {
      if (this.igxForScrollOrientation === 'vertical') {
        this._zone.runOutsideAngular(() => {
          if (this.platformUtil.isBrowser) {
            this.contentObserver = new (getResizeObserver())(() => this.contentResizeNotify.next());
            this.contentObserver.observe(this.dc.instance._viewContainer.element.nativeElement);
          }
        });
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.removeScrollEventListeners();
      this.destroy$.next(true);
      this.destroy$.complete();
      if (this.contentObserver) {
        this.contentObserver.disconnect();
      }
    }
    /**
     * @hidden @internal
     * Asserts the correct type of the context for the template that `igxForOf` will render.
     *
     * The presence of this method is a signal to the Ivy template type-check compiler that the
     * `IgxForOf` structural directive renders its template with a specific context type.
     */
    static ngTemplateContextGuard(dir, ctx) {
      return true;
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      const forOf = 'igxForOf';
      if (forOf in changes) {
        const value = changes[forOf].currentValue;
        if (!this._differ && value) {
          try {
            this._differ = this._differs.find(value).create(this.igxForTrackBy);
          } catch (e) {
            throw new Error(`Cannot find a differ supporting object "${value}" of type "${getTypeNameForDebugging(value)}".
                     NgFor only supports binding to Iterables such as Arrays.`);
          }
        }
      }
      const defaultItemSize = 'igxForItemSize';
      if (defaultItemSize in changes && !changes[defaultItemSize].firstChange && this.igxForOf) {
        // handle default item size changed.
        this.initSizesCache(this.igxForOf);
        this._applyChanges();
      }
      const containerSize = 'igxForContainerSize';
      if (containerSize in changes && !changes[containerSize].firstChange && this.igxForOf) {
        const prevSize = parseInt(changes[containerSize].previousValue, 10);
        const newSize = parseInt(changes[containerSize].currentValue, 10);
        this._recalcOnContainerChange({
          prevSize,
          newSize
        });
      }
    }
    /**
     * @hidden
     */
    ngDoCheck() {
      if (this._differ) {
        const changes = this._differ.diff(this.igxForOf);
        if (changes) {
          //  re-init cache.
          if (!this.igxForOf) {
            this.igxForOf = [];
          }
          this._updateSizeCache();
          this._zone.run(() => {
            this._applyChanges();
            this.cdr.markForCheck();
            this._updateScrollOffset();
            const args = {
              containerSize: this.igxForContainerSize,
              state: this.state
            };
            this.dataChanged.emit(args);
          });
        }
      }
    }
    /**
     * Shifts the scroll thumb position.
     * ```typescript
     * this.parentVirtDir.addScroll(5);
     * ```
     *
     * @param addTop negative value to scroll up and positive to scroll down;
     */
    addScrollTop(add) {
      return this.addScroll(add);
    }
    /**
     * Shifts the scroll thumb position.
     * ```typescript
     * this.parentVirtDir.addScroll(5);
     * ```
     *
     * @param add negative value to scroll previous and positive to scroll next;
     */
    addScroll(add) {
      if (add === 0) {
        return false;
      }
      const originalVirtScrollTop = this._virtScrollPosition;
      const containerSize = parseInt(this.igxForContainerSize, 10);
      const maxVirtScrollTop = this._virtSize - containerSize;
      this._bScrollInternal = true;
      this._virtScrollPosition += add;
      this._virtScrollPosition = this._virtScrollPosition > 0 ? this._virtScrollPosition < maxVirtScrollTop ? this._virtScrollPosition : maxVirtScrollTop : 0;
      this.scrollPosition += add / this._virtRatio;
      if (Math.abs(add / this._virtRatio) < 1) {
        // Actual scroll delta that was added is smaller than 1 and onScroll handler doesn't trigger when scrolling < 1px
        const scrollOffset = this.fixedUpdateAllElements(this._virtScrollPosition);
        // scrollOffset = scrollOffset !== parseInt(this.igxForItemSize, 10) ? scrollOffset : 0;
        this.dc.instance._viewContainer.element.nativeElement.style.top = -scrollOffset + 'px';
      }
      const maxRealScrollTop = this.scrollComponent.nativeElement.scrollHeight - containerSize;
      if (this._virtScrollPosition > 0 && this.scrollPosition === 0 || this._virtScrollPosition < maxVirtScrollTop && this.scrollPosition === maxRealScrollTop) {
        // Actual scroll position is at the top or bottom, but virtual one is not at the top or bottom (there's more to scroll)
        // Recalculate actual scroll position based on the virtual scroll.
        this.scrollPosition = this._virtScrollPosition / this._virtRatio;
      } else if (this._virtScrollPosition === 0 && this.scrollPosition > 0) {
        // Actual scroll position is not at the top, but virtual scroll is. Just update the actual scroll
        this.scrollPosition = 0;
      } else if (this._virtScrollPosition === maxVirtScrollTop && this.scrollPosition < maxRealScrollTop) {
        // Actual scroll position is not at the bottom, but virtual scroll is. Just update the acual scroll
        this.scrollPosition = maxRealScrollTop;
      }
      return this._virtScrollPosition !== originalVirtScrollTop;
    }
    /**
     * Scrolls to the specified index.
     * ```typescript
     * this.parentVirtDir.scrollTo(5);
     * ```
     *
     * @param index
     */
    scrollTo(index) {
      if (index < 0 || index > (this.isRemote ? this.totalItemCount : this.igxForOf.length) - 1) {
        return;
      }
      const containerSize = parseInt(this.igxForContainerSize, 10);
      const isPrevItem = index < this.state.startIndex || this.scrollPosition > this.sizesCache[index];
      let nextScroll = isPrevItem ? this.sizesCache[index] : this.sizesCache[index + 1] - containerSize;
      if (nextScroll < 0) {
        return;
      }
      const maxVirtScrollTop = this._virtSize - containerSize;
      if (nextScroll > maxVirtScrollTop) {
        nextScroll = maxVirtScrollTop;
      }
      this._bScrollInternal = true;
      this._virtScrollPosition = nextScroll;
      this.scrollPosition = this._virtScrollPosition / this._virtRatio;
      this._adjustToIndex = !isPrevItem ? index : null;
    }
    /**
     * Scrolls by one item into the appropriate next direction.
     * For "horizontal" orientation that will be the right column and for "vertical" that is the lower row.
     * ```typescript
     * this.parentVirtDir.scrollNext();
     * ```
     */
    scrollNext() {
      const scr = Math.abs(Math.ceil(this.scrollPosition));
      const endIndex = this.getIndexAt(scr + parseInt(this.igxForContainerSize, 10), this.sizesCache);
      this.scrollTo(endIndex);
    }
    /**
     * Scrolls by one item into the appropriate previous direction.
     * For "horizontal" orientation that will be the left column and for "vertical" that is the upper row.
     * ```typescript
     * this.parentVirtDir.scrollPrev();
     * ```
     */
    scrollPrev() {
      this.scrollTo(this.state.startIndex - 1);
    }
    /**
     * Scrolls by one page into the appropriate next direction.
     * For "horizontal" orientation that will be one view to the right and for "vertical" that is one view to the bottom.
     * ```typescript
     * this.parentVirtDir.scrollNextPage();
     * ```
     */
    scrollNextPage() {
      this.addScroll(parseInt(this.igxForContainerSize, 10));
    }
    /**
     * Scrolls by one page into the appropriate previous direction.
     * For "horizontal" orientation that will be one view to the left and for "vertical" that is one view to the top.
     * ```typescript
     * this.parentVirtDir.scrollPrevPage();
     * ```
     */
    scrollPrevPage() {
      const containerSize = parseInt(this.igxForContainerSize, 10);
      this.addScroll(-containerSize);
    }
    /**
     * @hidden
     */
    getColumnScrollLeft(colIndex) {
      return this.sizesCache[colIndex];
    }
    /**
     * Returns the total number of items that are fully visible.
     * ```typescript
     * this.parentVirtDir.getItemCountInView();
     * ```
     */
    getItemCountInView() {
      let startIndex = this.getIndexAt(this.scrollPosition, this.sizesCache);
      if (this.scrollPosition - this.sizesCache[startIndex] > 0) {
        // fisrt item is not fully in view
        startIndex++;
      }
      const endIndex = this.getIndexAt(this.scrollPosition + parseInt(this.igxForContainerSize, 10), this.sizesCache);
      return endIndex - startIndex;
    }
    /**
     * Returns a reference to the scrollbar DOM element.
     * This is either a vertical or horizontal scrollbar depending on the specified igxForScrollOrientation.
     * ```typescript
     * dir.getScroll();
     * ```
     */
    getScroll() {
      return this.scrollComponent?.nativeElement;
    }
    /**
     * Returns the size of the element at the specified index.
     * ```typescript
     * this.parentVirtDir.getSizeAt(1);
     * ```
     */
    getSizeAt(index) {
      return this.sizesCache[index + 1] - this.sizesCache[index];
    }
    /**
     * @hidden
     * Function that is called to get the native scrollbar size that the browsers renders.
     */
    getScrollNativeSize() {
      return this.scrollComponent ? this.scrollComponent.scrollNativeSize : 0;
    }
    /**
     * Returns the scroll offset of the element at the specified index.
     * ```typescript
     * this.parentVirtDir.getScrollForIndex(1);
     * ```
     */
    getScrollForIndex(index, bottom) {
      const containerSize = parseInt(this.igxForContainerSize, 10);
      const scroll = bottom ? Math.max(0, this.sizesCache[index + 1] - containerSize) : this.sizesCache[index];
      return scroll;
    }
    /**
     * Returns the index of the element at the specified offset.
     * ```typescript
     * this.parentVirtDir.getIndexAtScroll(100);
     * ```
     */
    getIndexAtScroll(scrollOffset) {
      return this.getIndexAt(scrollOffset, this.sizesCache);
    }
    /**
     * Returns whether the target index is outside the view.
     * ```typescript
     * this.parentVirtDir.isIndexOutsideView(10);
     * ```
     */
    isIndexOutsideView(index) {
      const targetNode = index >= this.state.startIndex && index <= this.state.startIndex + this.state.chunkSize ? this._embeddedViews.map(view => view.rootNodes.find(node => node.nodeType === Node.ELEMENT_NODE) || view.rootNodes[0].nextElementSibling)[index - this.state.startIndex] : null;
      const rowHeight = this.getSizeAt(index);
      const containerSize = parseInt(this.igxForContainerSize, 10);
      const containerOffset = -(this.scrollPosition - this.sizesCache[this.state.startIndex]);
      const endTopOffset = targetNode ? targetNode.offsetTop + rowHeight + containerOffset : containerSize + rowHeight;
      return !targetNode || targetNode.offsetTop < Math.abs(containerOffset) || containerSize && endTopOffset - containerSize > 5;
    }
    /**
     * @hidden
     * Function that recalculates and updates cache sizes.
     */
    recalcUpdateSizes() {
      const dimension = this.igxForScrollOrientation === 'horizontal' ? this.igxForSizePropName : 'height';
      const diffs = [];
      let totalDiff = 0;
      const l = this._embeddedViews.length;
      const rNodes = this._embeddedViews.map(view => view.rootNodes.find(node => node.nodeType === Node.ELEMENT_NODE) || view.rootNodes[0].nextElementSibling);
      for (let i = 0; i < l; i++) {
        const rNode = rNodes[i];
        if (rNode) {
          const height = window.getComputedStyle(rNode).getPropertyValue('height');
          const h = parseFloat(height) || parseInt(this.igxForItemSize, 10);
          const index = this.state.startIndex + i;
          if (!this.isRemote && !this.igxForOf[index]) {
            continue;
          }
          const margin = this.getMargin(rNode, dimension);
          const oldVal = this.individualSizeCache[index];
          const newVal = (dimension === 'height' ? h : rNode.clientWidth) + margin;
          this.individualSizeCache[index] = newVal;
          const currDiff = newVal - oldVal;
          diffs.push(currDiff);
          totalDiff += currDiff;
          this.sizesCache[index + 1] = (this.sizesCache[index] || 0) + newVal;
        }
      }
      // update cache
      if (Math.abs(totalDiff) > 0) {
        for (let j = this.state.startIndex + this.state.chunkSize + 1; j < this.sizesCache.length; j++) {
          this.sizesCache[j] = (this.sizesCache[j] || 0) + totalDiff;
        }
        // update scrBar heights/widths
        const reducer = (acc, val) => acc + val;
        const hSum = this.individualSizeCache.reduce(reducer);
        if (hSum > this._maxSize) {
          this._virtRatio = hSum / this._maxSize;
        }
        this.scrollComponent.size = Math.min(this.scrollComponent.size + totalDiff, this._maxSize);
        this._virtSize = hSum;
        if (!this.scrollComponent.destroyed) {
          this.scrollComponent.cdr.detectChanges();
        }
        const scrToBottom = this._isScrolledToBottom && !this.dc.instance.notVirtual;
        if (scrToBottom && !this._isAtBottomIndex) {
          const containerSize = parseInt(this.igxForContainerSize, 10);
          const maxVirtScrollTop = this._virtSize - containerSize;
          this._bScrollInternal = true;
          this._virtScrollPosition = maxVirtScrollTop;
          this.scrollPosition = maxVirtScrollTop;
          return;
        }
        if (this._adjustToIndex) {
          // in case scrolled to specific index where after scroll heights are changed
          // need to adjust the offsets so that item is last in view.
          const updatesToIndex = this._adjustToIndex - this.state.startIndex + 1;
          const sumDiffs = diffs.slice(0, updatesToIndex).reduce(reducer);
          if (sumDiffs !== 0) {
            this.addScroll(sumDiffs);
          }
          this._adjustToIndex = null;
        }
      }
    }
    /**
     * @hidden
     * Reset scroll position.
     * Needed in case scrollbar is hidden/detached but we still need to reset it.
     */
    resetScrollPosition() {
      this.scrollPosition = 0;
      this.scrollComponent.scrollAmount = 0;
    }
    /**
     * @hidden
     */
    removeScrollEventListeners() {
      if (this.igxForScrollOrientation === 'horizontal') {
        this._zone.runOutsideAngular(() => this.scrollComponent?.nativeElement?.removeEventListener('scroll', this.func));
      } else {
        this._zone.runOutsideAngular(() => this.scrollComponent?.nativeElement?.removeEventListener('scroll', this.verticalScrollHandler));
      }
    }
    /**
     * @hidden
     * Function that is called when scrolling vertically
     */
    onScroll(event) {
      /* in certain situations this may be called when no scrollbar is visible */
      if (!parseInt(this.scrollComponent.nativeElement.style.height, 10)) {
        return;
      }
      if (!this._bScrollInternal) {
        this._calcVirtualScrollPosition(event.target.scrollTop);
      } else {
        this._bScrollInternal = false;
      }
      const prevStartIndex = this.state.startIndex;
      const scrollOffset = this.fixedUpdateAllElements(this._virtScrollPosition);
      this.dc.instance._viewContainer.element.nativeElement.style.top = -scrollOffset + 'px';
      this._zone.onStable.pipe(first$2()).subscribe(this.recalcUpdateSizes.bind(this));
      this.dc.changeDetectorRef.detectChanges();
      if (prevStartIndex !== this.state.startIndex) {
        this.chunkLoad.emit(this.state);
      }
    }
    /**
     * @hidden
     * @internal
     */
    updateScroll() {
      if (this.igxForScrollOrientation === "horizontal") {
        const scrollAmount = this.scrollComponent.nativeElement["scrollLeft"];
        this.scrollComponent.scrollAmount = scrollAmount;
        this._updateScrollOffset();
      }
    }
    updateSizes() {
      if (!this.scrollComponent.nativeElement.isConnected) return;
      const scrollable = this.isScrollable();
      this.recalcUpdateSizes();
      this._applyChanges();
      this._updateScrollOffset();
      if (scrollable !== this.isScrollable()) {
        this.scrollbarVisibilityChanged.emit();
      } else {
        this.contentSizeChange.emit();
      }
    }
    /**
     * @hidden
     */
    fixedUpdateAllElements(inScrollTop) {
      const count = this.isRemote ? this.totalItemCount : this.igxForOf.length;
      let newStart = this.getIndexAt(inScrollTop, this.sizesCache);
      if (newStart + this.state.chunkSize > count) {
        newStart = count - this.state.chunkSize;
      }
      const prevStart = this.state.startIndex;
      const diff = newStart - this.state.startIndex;
      this.state.startIndex = newStart;
      if (diff) {
        this.chunkPreload.emit(this.state);
        if (!this.isRemote) {
          // recalculate and apply page size.
          if (diff && Math.abs(diff) <= MAX_PERF_SCROLL_DIFF) {
            if (diff > 0) {
              this.moveApplyScrollNext(prevStart);
            } else {
              this.moveApplyScrollPrev(prevStart);
            }
          } else {
            this.fixedApplyScroll();
          }
        }
      }
      return inScrollTop - this.sizesCache[this.state.startIndex];
    }
    /**
     * @hidden
     * The function applies an optimized state change for scrolling down/right employing context change with view rearrangement
     */
    moveApplyScrollNext(prevIndex) {
      const start = prevIndex + this.state.chunkSize;
      const end = start + this.state.startIndex - prevIndex;
      const container = this.dc.instance._vcr;
      for (let i = start; i < end && this.igxForOf[i] !== undefined; i++) {
        const embView = this._embeddedViews.shift();
        if (!embView.destroyed) {
          this.scrollFocus(embView.rootNodes.find(node => node.nodeType === Node.ELEMENT_NODE) || embView.rootNodes[0].nextElementSibling);
          const view = container.detach(0);
          this.updateTemplateContext(embView.context, i);
          container.insert(view);
          this._embeddedViews.push(embView);
        }
      }
    }
    /**
     * @hidden
     * The function applies an optimized state change for scrolling up/left employing context change with view rearrangement
     */
    moveApplyScrollPrev(prevIndex) {
      const container = this.dc.instance._vcr;
      for (let i = prevIndex - 1; i >= this.state.startIndex && this.igxForOf[i] !== undefined; i--) {
        const embView = this._embeddedViews.pop();
        if (!embView.destroyed) {
          this.scrollFocus(embView.rootNodes.find(node => node.nodeType === Node.ELEMENT_NODE) || embView.rootNodes[0].nextElementSibling);
          const view = container.detach(container.length - 1);
          this.updateTemplateContext(embView.context, i);
          container.insert(view, 0);
          this._embeddedViews.unshift(embView);
        }
      }
    }
    /**
     * @hidden
     */
    getContextIndex(input) {
      return this.isRemote ? this.state.startIndex + this.igxForOf.indexOf(input) : this.igxForOf.indexOf(input);
    }
    /**
     * @hidden
     * Function which updates the passed context of an embedded view with the provided index
     * from the view container.
     * Often, called while handling a scroll event.
     */
    updateTemplateContext(context, index = 0) {
      context.$implicit = this.igxForOf[index];
      context.index = this.getContextIndex(this.igxForOf[index]);
      context.count = this.igxForOf.length;
    }
    /**
     * @hidden
     * The function applies an optimized state change through context change for each view
     */
    fixedApplyScroll() {
      let j = 0;
      const endIndex = this.state.startIndex + this.state.chunkSize;
      for (let i = this.state.startIndex; i < endIndex && this.igxForOf[i] !== undefined; i++) {
        const embView = this._embeddedViews[j++];
        this.updateTemplateContext(embView.context, i);
      }
    }
    /**
     * @hidden
     * @internal
     *
     * Clears focus inside the virtualized container on small scroll swaps.
     */
    scrollFocus(node) {
      if (!node) {
        return;
      }
      const document = node.getRootNode();
      const activeElement = document.activeElement;
      // Remove focus in case the the active element is inside the view container.
      // Otherwise we hit an exception while doing the 'small' scrolls swapping.
      // For more information:
      //
      // https://developer.mozilla.org/en-US/docs/Web/API/Node/removeChild
      // https://bugs.chromium.org/p/chromium/issues/detail?id=432392
      if (node && node.contains(activeElement)) {
        activeElement.blur();
      }
    }
    /**
     * @hidden
     * Function that is called when scrolling horizontally
     */
    onHScroll(event) {
      /* in certain situations this may be called when no scrollbar is visible */
      const firstScrollChild = this.scrollComponent.nativeElement.children.item(0);
      if (!parseInt(firstScrollChild.style.width, 10)) {
        return;
      }
      if (!this._bScrollInternal) {
        this._calcVirtualScrollPosition(event.target.scrollLeft);
      } else {
        this._bScrollInternal = false;
      }
      const prevStartIndex = this.state.startIndex;
      const scrLeft = event.target.scrollLeft;
      // Updating horizontal chunks
      const scrollOffset = this.fixedUpdateAllElements(Math.abs(this._virtScrollPosition));
      if (scrLeft < 0) {
        // RTL
        this.dc.instance._viewContainer.element.nativeElement.style.left = scrollOffset + 'px';
      } else {
        this.dc.instance._viewContainer.element.nativeElement.style.left = -scrollOffset + 'px';
      }
      this._zone.onStable.pipe(first$2()).subscribe(this.recalcUpdateSizes.bind(this));
      this.dc.changeDetectorRef.detectChanges();
      if (prevStartIndex !== this.state.startIndex) {
        this.chunkLoad.emit(this.state);
      }
    }
    /**
     * Gets the function used to track changes in the items collection.
     * By default the object references are compared. However this can be optimized if you have unique identifier
     * value that can be used for the comparison instead of the object ref or if you have some other property values
     * in the item object that should be tracked for changes.
     * This option is similar to ngForTrackBy.
     * ```typescript
     * const trackFunc = this.parentVirtDir.igxForTrackBy;
     * ```
     */
    get igxForTrackBy() {
      return this._trackByFn;
    }
    /**
     * Sets the function used to track changes in the items collection.
     * This function can be set in scenarios where you want to optimize or
     * customize the tracking of changes for the items in the collection.
     * The igxForTrackBy function takes the index and the current item as arguments and needs to return the unique identifier for this item.
     * ```typescript
     * this.parentVirtDir.igxForTrackBy = (index, item) => {
     *      return item.id + item.width;
     * };
     * ```
     */
    set igxForTrackBy(fn) {
      this._trackByFn = fn;
    }
    /**
     * @hidden
     */
    _applyChanges() {
      const prevChunkSize = this.state.chunkSize;
      this.applyChunkSizeChange();
      this._recalcScrollBarSize();
      if (this.igxForOf && this.igxForOf.length && this.dc) {
        const embeddedViewCopy = Object.assign([], this._embeddedViews);
        let startIndex = this.state.startIndex;
        let endIndex = this.state.chunkSize + this.state.startIndex;
        if (this.isRemote) {
          startIndex = 0;
          endIndex = this.igxForOf.length;
        }
        for (let i = startIndex; i < endIndex && this.igxForOf[i] !== undefined; i++) {
          const embView = embeddedViewCopy.shift();
          this.updateTemplateContext(embView.context, i);
        }
        if (prevChunkSize !== this.state.chunkSize) {
          this.chunkLoad.emit(this.state);
        }
      }
    }
    /**
     * @hidden
     */
    _calcMaxBrowserSize() {
      if (!this.platformUtil.isBrowser) {
        return 0;
      }
      const div = this.document.createElement('div');
      const style = div.style;
      style.position = 'absolute';
      const dir = this.igxForScrollOrientation === 'horizontal' ? 'left' : 'top';
      style[dir] = '9999999999999999px';
      this.document.body.appendChild(div);
      const size = Math.abs(div.getBoundingClientRect()[dir]);
      this.document.body.removeChild(div);
      return size;
    }
    /**
     * @hidden
     * Recalculates the chunkSize based on current startIndex and returns the new size.
     * This should be called after this.state.startIndex is updated, not before.
     */
    _calculateChunkSize() {
      let chunkSize = 0;
      if (this.igxForContainerSize !== null && this.igxForContainerSize !== undefined) {
        if (!this.sizesCache || this.sizesCache.length === 0) {
          this.initSizesCache(this.igxForOf);
        }
        chunkSize = this._calcMaxChunkSize();
        if (this.igxForOf && chunkSize > this.igxForOf.length) {
          chunkSize = this.igxForOf.length;
        }
      } else {
        if (this.igxForOf) {
          chunkSize = Math.min(this.igxForInitialChunkSize || this.igxForOf.length, this.igxForOf.length);
        }
      }
      return chunkSize;
    }
    /**
     * @hidden
     */
    getElement(viewref, nodeName) {
      const elem = viewref.element.nativeElement.parentNode.getElementsByTagName(nodeName);
      return elem.length > 0 ? elem[0] : null;
    }
    /**
     * @hidden
     */
    initSizesCache(items) {
      let totalSize = 0;
      let size = 0;
      const dimension = this.igxForSizePropName || 'height';
      let i = 0;
      this.sizesCache = [];
      this.individualSizeCache = [];
      this.sizesCache.push(0);
      const count = this.isRemote ? this.totalItemCount : items.length;
      for (i; i < count; i++) {
        size = this._getItemSize(items[i], dimension);
        this.individualSizeCache.push(size);
        totalSize += size;
        this.sizesCache.push(totalSize);
      }
      return totalSize;
    }
    _updateSizeCache() {
      if (this.igxForScrollOrientation === 'horizontal') {
        this.initSizesCache(this.igxForOf);
        return;
      }
      const oldHeight = this.individualSizeCache.length > 0 ? this.individualSizeCache.reduce((acc, val) => acc + val) : 0;
      const newHeight = this.initSizesCache(this.igxForOf);
      const diff = oldHeight - newHeight;
      this._adjustScrollPositionAfterSizeChange(diff);
    }
    /**
     * @hidden
     */
    _calcMaxChunkSize() {
      let i = 0;
      let length = 0;
      let maxLength = 0;
      const arr = [];
      let sum = 0;
      const availableSize = parseInt(this.igxForContainerSize, 10);
      if (!availableSize) {
        return 0;
      }
      const dimension = this.igxForScrollOrientation === 'horizontal' ? this.igxForSizePropName : 'height';
      const reducer = (accumulator, currentItem) => accumulator + this._getItemSize(currentItem, dimension);
      for (i; i < this.igxForOf.length; i++) {
        let item = this.igxForOf[i];
        if (dimension === 'height') {
          item = {
            value: this.igxForOf[i],
            height: this.individualSizeCache[i]
          };
        }
        const size = dimension === 'height' ? this.individualSizeCache[i] : this._getItemSize(item, dimension);
        sum = arr.reduce(reducer, size);
        if (sum < availableSize) {
          arr.push(item);
          length = arr.length;
          if (i === this.igxForOf.length - 1) {
            // reached end without exceeding
            // include prev items until size is filled or first item is reached.
            let curItem = dimension === 'height' ? arr[0].value : arr[0];
            let prevIndex = this.igxForOf.indexOf(curItem) - 1;
            while (prevIndex >= 0 && sum <= availableSize) {
              curItem = dimension === 'height' ? arr[0].value : arr[0];
              prevIndex = this.igxForOf.indexOf(curItem) - 1;
              const prevItem = this.igxForOf[prevIndex];
              const prevSize = dimension === 'height' ? this.individualSizeCache[prevIndex] : parseInt(prevItem[dimension], 10);
              sum = arr.reduce(reducer, prevSize);
              arr.unshift(prevItem);
              length = arr.length;
            }
          }
        } else {
          arr.push(item);
          length = arr.length + 1;
          arr.shift();
        }
        if (length > maxLength) {
          maxLength = length;
        }
      }
      return maxLength;
    }
    /**
     * @hidden
     */
    getIndexAt(left, set) {
      let start = 0;
      let end = set.length - 1;
      if (left === 0) {
        return 0;
      }
      while (start <= end) {
        const midIdx = Math.floor((start + end) / 2);
        const midLeft = set[midIdx];
        const cmp = left - midLeft;
        if (cmp > 0) {
          start = midIdx + 1;
        } else if (cmp < 0) {
          end = midIdx - 1;
        } else {
          return midIdx;
        }
      }
      return end;
    }
    _recalcScrollBarSize(containerSizeInfo = null) {
      const count = this.isRemote ? this.totalItemCount : this.igxForOf ? this.igxForOf.length : 0;
      this.dc.instance.notVirtual = !(this.igxForContainerSize && this.dc && this.state.chunkSize < count);
      const scrollable = containerSizeInfo ? this.scrollComponent.size > containerSizeInfo.prevSize : this.isScrollable();
      if (this.igxForScrollOrientation === 'horizontal') {
        const totalWidth = parseInt(this.igxForContainerSize, 10) > 0 ? this._calcSize() : 0;
        if (totalWidth <= parseInt(this.igxForContainerSize, 10)) {
          this.resetScrollPosition();
        }
        this.scrollComponent.nativeElement.style.width = this.igxForContainerSize + 'px';
        this.scrollComponent.size = totalWidth;
      }
      if (this.igxForScrollOrientation === 'vertical') {
        const totalHeight = this._calcSize();
        if (totalHeight <= parseInt(this.igxForContainerSize, 10)) {
          this.resetScrollPosition();
        }
        this.scrollComponent.nativeElement.style.height = parseInt(this.igxForContainerSize, 10) + 'px';
        this.scrollComponent.size = totalHeight;
      }
      if (scrollable !== this.isScrollable()) {
        // scrollbar visibility has changed
        this.scrollbarVisibilityChanged.emit();
      }
    }
    _calcSize() {
      let size;
      if (this.individualSizeCache && this.individualSizeCache.length > 0) {
        size = this.individualSizeCache.reduce((acc, val) => acc + val, 0);
      } else {
        size = this.initSizesCache(this.igxForOf);
      }
      this._virtSize = size;
      if (size > this._maxSize) {
        this._virtRatio = size / this._maxSize;
        size = this._maxSize;
      }
      return size;
    }
    _recalcOnContainerChange(containerSizeInfo = null) {
      const prevChunkSize = this.state.chunkSize;
      this.applyChunkSizeChange();
      this._recalcScrollBarSize(containerSizeInfo);
      if (prevChunkSize !== this.state.chunkSize) {
        this.chunkLoad.emit(this.state);
      }
    }
    /**
     * @hidden
     * Removes an element from the embedded views and updates chunkSize.
     */
    removeLastElem() {
      const oldElem = this._embeddedViews.pop();
      this.beforeViewDestroyed.emit(oldElem);
      // also detach from ViewContainerRef to make absolutely sure this is removed from the view container.
      this.dc.instance._vcr.detach(this.dc.instance._vcr.length - 1);
      oldElem.destroy();
      this.state.chunkSize--;
    }
    /**
     * @hidden
     * If there exists an element that we can create embedded view for creates it, appends it and updates chunkSize
     */
    addLastElem() {
      let elemIndex = this.state.startIndex + this.state.chunkSize;
      if (!this.isRemote && !this.igxForOf) {
        return;
      }
      if (elemIndex >= this.igxForOf.length) {
        elemIndex = this.igxForOf.length - this.state.chunkSize;
      }
      const input = this.igxForOf[elemIndex];
      const embeddedView = this.dc.instance._vcr.createEmbeddedView(this._template, new IgxForOfContext(input, this.igxForOf, this.getContextIndex(input), this.igxForOf.length));
      this._embeddedViews.push(embeddedView);
      this.state.chunkSize++;
      this._zone.run(() => this.cdr.markForCheck());
    }
    /**
     * Recalculates chunkSize and adds/removes elements if need due to the change.
     * this.state.chunkSize is updated in @addLastElem() or @removeLastElem()
     */
    applyChunkSizeChange() {
      const chunkSize = this.isRemote ? this.igxForOf ? this.igxForOf.length : 0 : this._calculateChunkSize();
      if (chunkSize > this.state.chunkSize) {
        const diff = chunkSize - this.state.chunkSize;
        for (let i = 0; i < diff; i++) {
          this.addLastElem();
        }
      } else if (chunkSize < this.state.chunkSize) {
        const diff = this.state.chunkSize - chunkSize;
        for (let i = 0; i < diff; i++) {
          this.removeLastElem();
        }
      }
    }
    _calcVirtualScrollPosition(scrollPosition) {
      const containerSize = parseInt(this.igxForContainerSize, 10);
      const maxRealScrollPosition = this.scrollComponent.size - containerSize;
      const realPercentScrolled = maxRealScrollPosition !== 0 ? scrollPosition / maxRealScrollPosition : 0;
      const maxVirtScroll = this._virtSize - containerSize;
      this._virtScrollPosition = realPercentScrolled * maxVirtScroll;
    }
    _getItemSize(item, dimension) {
      const dim = item ? item[dimension] : null;
      return typeof dim === 'number' ? dim : parseInt(this.igxForItemSize, 10) || 0;
    }
    _updateScrollOffset() {
      let scrollOffset = 0;
      let currentScroll = this.scrollPosition;
      if (this._virtRatio !== 1) {
        this._calcVirtualScrollPosition(this.scrollPosition);
        currentScroll = this._virtScrollPosition;
      }
      const scroll = this.scrollComponent.nativeElement;
      scrollOffset = scroll && this.scrollComponent.size ? currentScroll - this.sizesCache[this.state.startIndex] : 0;
      const dir = this.igxForScrollOrientation === 'horizontal' ? 'left' : 'top';
      this.dc.instance._viewContainer.element.nativeElement.style[dir] = -scrollOffset + 'px';
    }
    _adjustScrollPositionAfterSizeChange(sizeDiff) {
      // if data has been changed while container is scrolled
      // should update scroll top/left according to change so that same startIndex is in view
      if (Math.abs(sizeDiff) > 0 && this.scrollPosition > 0) {
        this.recalcUpdateSizes();
        const offset = this.igxForScrollOrientation === 'horizontal' ? parseInt(this.dc.instance._viewContainer.element.nativeElement.style.left, 10) : parseInt(this.dc.instance._viewContainer.element.nativeElement.style.top, 10);
        const newSize = this.sizesCache[this.state.startIndex] - offset;
        this.scrollPosition = newSize;
        if (this.scrollPosition !== newSize) {
          this.scrollComponent.scrollAmount = newSize;
        }
      }
    }
    getMargin(node, dimension) {
      const styles = window.getComputedStyle(node);
      if (dimension === 'height') {
        return parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']) || 0;
      }
      return parseFloat(styles['marginLeft']) + parseFloat(styles['marginRight']) || 0;
    }
    static {
      this.ɵfac = function IgxForOfDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxForOfDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IgxForOfScrollSyncService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxForOfDirective,
        selectors: [["", "igxFor", "", "igxForOf", ""]],
        inputs: {
          igxForOf: "igxForOf",
          igxForSizePropName: "igxForSizePropName",
          igxForScrollOrientation: "igxForScrollOrientation",
          igxForScrollContainer: "igxForScrollContainer",
          igxForContainerSize: "igxForContainerSize",
          igxForInitialChunkSize: "igxForInitialChunkSize",
          igxForItemSize: "igxForItemSize",
          igxForTotalItemCount: "igxForTotalItemCount",
          igxForTrackBy: "igxForTrackBy"
        },
        outputs: {
          chunkLoad: "chunkLoad",
          scrollbarVisibilityChanged: "scrollbarVisibilityChanged",
          contentSizeChange: "contentSizeChange",
          dataChanged: "dataChanged",
          beforeViewDestroyed: "beforeViewDestroyed",
          chunkPreload: "chunkPreload"
        },
        features: [i0.ɵɵProvidersFeature([IgxForOfScrollSyncService, {
          provide: IgxForOfToken,
          useExisting: IgxForOfDirective
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxForOfDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getTypeNameForDebugging = type => type.name || typeof type;
class IgxGridForOfContext extends IgxForOfContext {
  constructor($implicit, igxGridForOf, index, count) {
    super($implicit, igxGridForOf, index, count);
    this.igxGridForOf = igxGridForOf;
  }
}
let IgxGridForOfDirective = /*#__PURE__*/(() => {
  class IgxGridForOfDirective extends IgxForOfDirective {
    set igxGridForOf(value) {
      this.igxForOf = value;
    }
    get igxGridForOf() {
      return this.igxForOf;
    }
    /**
     * @hidden
     * @internal
     */
    get sizesCache() {
      if (this.igxForScrollOrientation === 'horizontal') {
        if (this.igxGridForOfUniqueSizeCache || this.syncService.isMaster(this)) {
          return this._sizesCache;
        }
        return this.syncService.sizesCache(this.igxForScrollOrientation);
      } else {
        return this._sizesCache;
      }
    }
    /**
     * @hidden
     * @internal
     */
    set sizesCache(value) {
      this._sizesCache = value;
    }
    get itemsDimension() {
      return this.igxForSizePropName || 'height';
    }
    recalcUpdateSizes() {
      if (this.igxGridForOfVariableSizes && this.igxForScrollOrientation === 'vertical') {
        super.recalcUpdateSizes();
      }
    }
    constructor(_viewContainer, _template, _differs, cdr, _zone, _platformUtil, _document, syncScrollService, syncService) {
      super(_viewContainer, _template, _differs, cdr, _zone, syncScrollService, _platformUtil, _document);
      this.syncService = syncService;
      this.igxGridForOfUniqueSizeCache = false;
      this.igxGridForOfVariableSizes = true;
      /**
       * @hidden @internal
       * An event that is emitted after data has been changed but before the view is refreshed
       */
      this.dataChanging = new EventEmitter();
    }
    /**
     * @hidden @internal
     * Asserts the correct type of the context for the template that `IgxGridForOfDirective` will render.
     *
     * The presence of this method is a signal to the Ivy template type-check compiler that the
     * `IgxGridForOfDirective` structural directive renders its template with a specific context type.
     */
    static ngTemplateContextGuard(dir, ctx) {
      return true;
    }
    ngOnInit() {
      this.syncService.setMaster(this);
      super.ngOnInit();
      this.removeScrollEventListeners();
    }
    ngOnChanges(changes) {
      const forOf = 'igxGridForOf';
      this.syncService.setMaster(this);
      if (forOf in changes) {
        const value = changes[forOf].currentValue;
        if (!this._differ && value) {
          try {
            this._differ = this._differs.find(value).create(this.igxForTrackBy);
          } catch (e) {
            throw new Error(`Cannot find a differ supporting object "${value}" of type "${getTypeNameForDebugging(value)}".
                     NgFor only supports binding to Iterables such as Arrays.`);
          }
        }
        if (this.igxForScrollOrientation === 'horizontal') {
          // in case collection has changes, reset sync service
          this.syncService.setMaster(this, this.igxGridForOfUniqueSizeCache);
        }
      }
      const defaultItemSize = 'igxForItemSize';
      if (defaultItemSize in changes && !changes[defaultItemSize].firstChange && this.igxForScrollOrientation === 'vertical' && this.igxForOf) {
        // handle default item size changed.
        this.initSizesCache(this.igxForOf);
      }
      const containerSize = 'igxForContainerSize';
      if (containerSize in changes && !changes[containerSize].firstChange && this.igxForOf) {
        const prevSize = parseInt(changes[containerSize].previousValue, 10);
        const newSize = parseInt(changes[containerSize].currentValue, 10);
        this._recalcOnContainerChange({
          prevSize,
          newSize
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    assumeMaster() {
      this._sizesCache = this.syncService.sizesCache(this.igxForScrollOrientation);
      this.syncService.setMaster(this, true);
    }
    ngDoCheck() {
      if (this._differ) {
        const changes = this._differ.diff(this.igxForOf);
        if (changes) {
          const args = {
            containerSize: this.igxForContainerSize,
            state: this.state
          };
          this.dataChanging.emit(args);
          //  re-init cache.
          if (!this.igxForOf) {
            this.igxForOf = [];
          }
          /* we need to reset the master dir if all rows are removed
          (e.g. because of filtering); if all columns are hidden, rows are
          still rendered empty, so we should not reset master */
          if (!this.igxForOf.length && this.igxForScrollOrientation === 'vertical') {
            this.syncService.resetMaster();
          }
          this.syncService.setMaster(this);
          this.igxForContainerSize = args.containerSize;
          const sizeDiff = this._updateSizeCache(changes);
          this._applyChanges();
          if (sizeDiff) {
            this._adjustScrollPositionAfterSizeChange(sizeDiff);
          }
          this._updateScrollOffset();
          this.dataChanged.emit(args);
        }
      }
    }
    onScroll(event) {
      if (!parseInt(this.scrollComponent.nativeElement.style.height, 10)) {
        return;
      }
      if (!this._bScrollInternal) {
        this._calcVirtualScrollPosition(event.target.scrollTop);
      } else {
        this._bScrollInternal = false;
      }
      const scrollOffset = this.fixedUpdateAllElements(this._virtScrollPosition);
      this.dc.instance._viewContainer.element.nativeElement.style.top = -scrollOffset + 'px';
      this._zone.onStable.pipe(first$2()).subscribe(this.recalcUpdateSizes.bind(this));
      this.cdr.markForCheck();
    }
    onHScroll(scrollAmount) {
      /* in certain situations this may be called when no scrollbar is visible */
      const firstScrollChild = this.scrollComponent.nativeElement.children.item(0);
      if (!this.scrollComponent || !parseInt(firstScrollChild.style.width, 10)) {
        return;
      }
      // Updating horizontal chunks
      const scrollOffset = this.fixedUpdateAllElements(Math.abs(scrollAmount));
      if (scrollAmount < 0) {
        // RTL
        this.dc.instance._viewContainer.element.nativeElement.style.left = scrollOffset + 'px';
      } else {
        // LTR
        this.dc.instance._viewContainer.element.nativeElement.style.left = -scrollOffset + 'px';
      }
    }
    getItemSize(item) {
      let size = 0;
      const dimension = this.igxForSizePropName || 'height';
      if (this.igxForScrollOrientation === 'vertical') {
        size = this._getItemSize(item, dimension);
        if (item && item.summaries) {
          size = item.max;
        } else if (item && item.groups && item.height) {
          size = item.height;
        }
      } else {
        size = parseInt(item[dimension], 10) || 0;
      }
      return size;
    }
    initSizesCache(items) {
      if (!this.syncService.isMaster(this) && this.igxForScrollOrientation === 'horizontal') {
        const masterSizesCache = this.syncService.sizesCache(this.igxForScrollOrientation);
        return masterSizesCache[masterSizesCache.length - 1];
      }
      let totalSize = 0;
      let size = 0;
      let i = 0;
      this.sizesCache = [];
      this.individualSizeCache = [];
      this.sizesCache.push(0);
      const count = this.isRemote ? this.totalItemCount : items.length;
      for (i; i < count; i++) {
        size = this.getItemSize(items[i]);
        this.individualSizeCache.push(size);
        totalSize += size;
        this.sizesCache.push(totalSize);
      }
      return totalSize;
    }
    _updateSizeCache(changes = null) {
      const oldSize = this.individualSizeCache.length > 0 ? this.individualSizeCache.reduce((acc, val) => acc + val) : 0;
      let newSize = oldSize;
      if (changes && !this.isRemote) {
        newSize = this.handleCacheChanges(changes);
      } else {
        return;
      }
      const diff = oldSize - newSize;
      return diff;
    }
    handleCacheChanges(changes) {
      const identityChanges = [];
      const newHeightCache = [];
      const newSizesCache = [];
      newSizesCache.push(0);
      let newHeight = 0;
      // When there are more than one removed items the changes are not reliable so those with identity change should be default size.
      let numRemovedItems = 0;
      changes.forEachRemovedItem(() => numRemovedItems++);
      // Get the identity changes to determine later if those that have changed their indexes should be assigned default item size.
      changes.forEachIdentityChange(item => {
        if (item.currentIndex !== item.previousIndex) {
          // Filter out ones that have not changed their index.
          identityChanges[item.currentIndex] = item;
        }
      });
      // Processing each item that is passed to the igxForOf so far seem to be most reliable. We parse the updated list of items.
      changes.forEachItem(item => {
        if (item.previousIndex !== null && (numRemovedItems < 2 || !identityChanges.length || identityChanges[item.currentIndex]) && this.igxForScrollOrientation !== "horizontal") {
          // Reuse cache on those who have previousIndex.
          // When there are more than one removed items currently the changes are not readable so ones with identity change
          // should be racalculated.
          newHeightCache[item.currentIndex] = this.individualSizeCache[item.previousIndex];
        } else {
          // Assign default item size.
          newHeightCache[item.currentIndex] = this.getItemSize(item.item);
        }
        newSizesCache[item.currentIndex + 1] = newSizesCache[item.currentIndex] + newHeightCache[item.currentIndex];
        newHeight += newHeightCache[item.currentIndex];
      });
      this.individualSizeCache = newHeightCache;
      this.sizesCache = newSizesCache;
      return newHeight;
    }
    addLastElem() {
      let elemIndex = this.state.startIndex + this.state.chunkSize;
      if (!this.isRemote && !this.igxForOf) {
        return;
      }
      if (elemIndex >= this.igxForOf.length) {
        elemIndex = this.igxForOf.length - this.state.chunkSize;
      }
      const input = this.igxForOf[elemIndex];
      const embeddedView = this.dc.instance._vcr.createEmbeddedView(this._template, new IgxGridForOfContext(input, this.igxForOf, this.getContextIndex(input), this.igxForOf.length));
      this._embeddedViews.push(embeddedView);
      this.state.chunkSize++;
    }
    _updateViews(prevChunkSize) {
      if (this.igxForOf && this.igxForOf.length && this.dc) {
        const embeddedViewCopy = Object.assign([], this._embeddedViews);
        let startIndex;
        let endIndex;
        if (this.isRemote) {
          startIndex = 0;
          endIndex = this.igxForOf.length;
        } else {
          startIndex = this.getIndexAt(this.scrollPosition, this.sizesCache);
          if (startIndex + this.state.chunkSize > this.igxForOf.length) {
            startIndex = this.igxForOf.length - this.state.chunkSize;
          }
          this.state.startIndex = startIndex;
          endIndex = this.state.chunkSize + this.state.startIndex;
        }
        for (let i = startIndex; i < endIndex && this.igxForOf[i] !== undefined; i++) {
          const embView = embeddedViewCopy.shift();
          this.updateTemplateContext(embView.context, i);
        }
        if (prevChunkSize !== this.state.chunkSize) {
          this.chunkLoad.emit(this.state);
        }
      }
    }
    _applyChanges() {
      const prevChunkSize = this.state.chunkSize;
      this.applyChunkSizeChange();
      this._recalcScrollBarSize();
      this._updateViews(prevChunkSize);
    }
    /**
     * @hidden
     */
    _calcMaxChunkSize() {
      if (this.igxForScrollOrientation === 'horizontal') {
        if (this.syncService.isMaster(this)) {
          return super._calcMaxChunkSize();
        }
        return this.syncService.chunkSize(this.igxForScrollOrientation);
      } else {
        return super._calcMaxChunkSize();
      }
    }
    static {
      this.ɵfac = function IgxGridForOfDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridForOfDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IgxForOfScrollSyncService), i0.ɵɵdirectiveInject(IgxForOfSyncService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridForOfDirective,
        selectors: [["", "igxGridFor", "", "igxGridForOf", ""]],
        inputs: {
          igxGridForOf: "igxGridForOf",
          igxGridForOfUniqueSizeCache: [2, "igxGridForOfUniqueSizeCache", "igxGridForOfUniqueSizeCache", booleanAttribute],
          igxGridForOfVariableSizes: [2, "igxGridForOfVariableSizes", "igxGridForOfVariableSizes", booleanAttribute]
        },
        outputs: {
          dataChanging: "dataChanging"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxGridForOfDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The IgxIconButtonDirective provides a way to use an icon as a fully functional button.
 *
 * @example
 * ```html
 * <button type="button" igxIconButton="outlined">
 *      <igx-icon>home</igx-icon>
 * </button>
 * ```
 */
let IgxIconButtonDirective = /*#__PURE__*/(() => {
  class IgxIconButtonDirective extends IgxButtonBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * @hidden
       * @internal
       */
      this._cssClass = 'igx-icon-button';
    }
    /**
     * Sets the type of the icon button.
     *
     * @example
     * ```html
     * <button type="button" igxIconButton="flat"></button>
     * ```
     */
    set type(type) {
      const t = type ? type : IgxBaseButtonType.Contained;
      if (this._type !== t) {
        this._type = t;
      }
    }
    /**
     * @hidden
     * @internal
     */
    get flat() {
      return this._type === IgxBaseButtonType.Flat;
    }
    /**
     * @hidden
     * @internal
     */
    get contained() {
      return this._type === IgxBaseButtonType.Contained;
    }
    /**
     * @hidden
     * @internal
     */
    get outlined() {
      return this._type === IgxBaseButtonType.Outlined;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxIconButtonDirective_BaseFactory;
        return function IgxIconButtonDirective_Factory(__ngFactoryType__) {
          return (ɵIgxIconButtonDirective_BaseFactory || (ɵIgxIconButtonDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxIconButtonDirective)))(__ngFactoryType__ || IgxIconButtonDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxIconButtonDirective,
        selectors: [["", "igxIconButton", ""]],
        hostVars: 8,
        hostBindings: function IgxIconButtonDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-icon-button", ctx._cssClass)("igx-icon-button--flat", ctx.flat)("igx-icon-button--contained", ctx.contained)("igx-icon-button--outlined", ctx.outlined);
          }
        },
        inputs: {
          type: [0, "igxIconButton", "type"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxIconButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxLayoutDirective = /*#__PURE__*/(() => {
  class IgxLayoutDirective {
    constructor() {
      /**
       * Sets the default flow direction of the container's children.
       *
       * Defaults to `rows`.
       *
       * ```html
       *  <div
       *   igxLayout
       *   igxLayoutDir="row">
       *    <div igxFlex>1</div>
       *    <div igxFlex>2</div>
       *    <div igxFlex>3</div>
       *  </div>
       * ```
       */
      this.dir = 'row';
      /**
       * Defines the direction flex children are placed in the flex container.
       *
       * When set to `true`, the `rows` direction goes right to left and `columns` goes bottom to top.
       *
       * ```html
       * <div
       *   igxLayout
       *   igxLayoutReverse="true">
       *    <div igxFlex>1</div>
       *    <div igxFlex>2</div>
       *    <div igxFlex>3</div>
       * </div>
       * ```
       */
      this.reverse = false;
      /**
       * By default the immediate children will all try to fit onto one line.
       *
       * The default value `nowrap` sets this behavior.
       *
       * Other accepted values are `wrap` and `wrap-reverse`.
       *
       * ```html
       * <div
       *   igxLayout
       *   igxLayoutDir="row"
       *   igxLayoutWrap="wrap">
       *    <div igxFlex igxFlexGrow="0">1</div>
       *    <div igxFlex igxFlexGrow="0">2</div>
       *    <div igxFlex igxFlexGrow="0">3</div>
       * </div>
       * ```
       */
      this.wrap = 'nowrap';
      /**
       * Defines the alignment along the main axis.
       *
       * Defaults to `flex-start` which packs the children toward the start line.
       *
       * Other possible values are `flex-end`, `center`, `space-between`, `space-around`.
       *
       * ```html
       * <div
       *   igxLayout
       *   igxLayoutDir="column"
       *   igxLayoutJustify="space-between">
       *    <div>1</div>
       *    <div>2</div>
       *    <div>3</div>
       * </div>
       * ```
       */
      this.justify = 'flex-start';
      /**
       * Defines the default behavior for how children are laid out along the corss axis of the current line.
       *
       * Defaults to `flex-start`.
       *
       * Other possible values are `flex-end`, `center`, `baseline`, and `stretch`.
       *
       * ```html
       * <div
       *   igxLayout
       *   igxLayoutDir="column"
       *   igxLayoutItemAlign="start">
       *    <div igxFlex igxFlexGrow="0">1</div>
       *    <div igxFlex igxFlexGrow="0">2</div>
       *    <div igxFlex igxFlexGrow="0">3</div>
       * </div>
       * ```
       */
      this.itemAlign = 'stretch';
      /**
       * @hidden
       */
      this.display = 'flex';
    }
    /**
     * @hidden
     */
    get flexwrap() {
      return this.wrap;
    }
    /**
     * @hidden
     */
    get justifycontent() {
      return this.justify;
    }
    /**
     * @hidden
     */
    get align() {
      return this.itemAlign;
    }
    /**
     * @hidden
     */
    get direction() {
      if (this.reverse) {
        return this.dir === 'row' ? 'row-reverse' : 'column-reverse';
      }
      return this.dir === 'row' ? 'row' : 'column';
    }
    static {
      this.ɵfac = function IgxLayoutDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxLayoutDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxLayoutDirective,
        selectors: [["", "igxLayout", ""]],
        hostVars: 10,
        hostBindings: function IgxLayoutDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.display)("flex-wrap", ctx.flexwrap)("justify-content", ctx.justifycontent)("align-items", ctx.align)("flex-direction", ctx.direction);
          }
        },
        inputs: {
          dir: [0, "igxLayoutDir", "dir"],
          reverse: [2, "igxLayoutReverse", "reverse", booleanAttribute],
          wrap: [0, "igxLayoutWrap", "wrap"],
          justify: [0, "igxLayoutJustify", "justify"],
          itemAlign: [0, "igxLayoutItemAlign", "itemAlign"]
        }
      });
    }
  }
  return IgxLayoutDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxFlexDirective = /*#__PURE__*/(() => {
  class IgxFlexDirective {
    constructor() {
      /**
       * Applies the `grow` attribute to an element that uses the directive.
       *
       * Default value is `1`.
       *
       * ```html
       * <div>
       *    <div igxFlex igxFlexGrow="0">Content1</div>
       *    <div igxFlex igxFlexGrow="1">Content2</div>
       *    <div igxFlex igxFlexGrow="0">Content3</div>
       * </div>
       * ```
       */
      this.grow = 1;
      /**
       * Applies the `shrink` attribute to an element that uses the directive.
       *
       * Default value is `1`.
       *
       * ```html
       * <div>
       *    <div igxFlex igxFlexShrink="1">Content1</div>
       *    <div igxFlex igxFlexShrink="0">Content2</div>
       *    <div igxFlex igxFlexShrink="1">Content3</div>
       * </div>
       * ```
       */
      this.shrink = 1;
      /**
       * Applies the directive to an element.
       *
       * Possible values include `igxFlexGrow`, `igxFlexShrink`, `igxFlexOrder`, `igxFlexBasis`.
       *
       * ```html
       * <div igxFlex>Content</div>
       * ```
       */
      this.flex = '';
      /**
       * Applies the `order` attribute to an element that uses the directive.
       *
       * Default value is `0`.
       *
       * ```html
       * <div>
       *    <div igxFlex igxFlexOrder="1">Content1</div>
       *    <div igxFlex igxFlexOrder="0">Content2</div>
       *    <div igxFlex igxFlexOrder="2">Content3</div>
       * </div>
       * ```
       */
      this.order = 0;
      /**
       * Applies the `flex-basis` attribute to an element that uses the directive.
       *
       * Default value is `auto`.
       *
       * Other possible values include `content`, `max-content`, `min-content`, `fit-content`.
       *
       * ```html
       * <div igxFlex igxFlexBasis="fit-content">Content</div>
       * ```
       */
      this.basis = 'auto';
    }
    /**
     * @hidden
     */
    get style() {
      if (this.flex) {
        return `${this.flex}`;
      }
      return `${this.grow} ${this.shrink} ${this.basis}`;
    }
    /**
     * @hidden
     */
    get itemorder() {
      return this.order || 0;
    }
    static {
      this.ɵfac = function IgxFlexDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFlexDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxFlexDirective,
        selectors: [["", "igxFlex", ""]],
        hostVars: 4,
        hostBindings: function IgxFlexDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("flex", ctx.style)("order", ctx.itemorder);
          }
        },
        inputs: {
          grow: [0, "igxFlexGrow", "grow"],
          shrink: [0, "igxFlexShrink", "shrink"],
          flex: [0, "igxFlex", "flex"],
          order: [0, "igxFlexOrder", "order"],
          basis: [0, "igxFlexBasis", "basis"]
        }
      });
    }
  }
  return IgxFlexDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const FLAGS = new Set('aACL09#&?');
const REGEX = new Map([['C', /(?!^$)/u],
// Non-empty
['&', /[^\p{Separator}]/u],
// Non-whitespace
['a', /[\p{Letter}\d\p{Separator}]/u],
// Alphanumeric & whitespace
['A', /[\p{Letter}\d]/u],
// Alphanumeric
['?', /[\p{Letter}\p{Separator}]/u],
// Alpha & whitespace
['L', /\p{Letter}/u],
// Alpha
['0', /\d/],
// Numeric
['9', /[\d\p{Separator}]/u],
// Numeric & whitespace
['#', /[\d\-+]/] // Numeric and sign
]);
const replaceCharAt = (string, idx, char) => `${string.substring(0, idx)}${char}${string.substring(idx + 1)}`;
function parseMask(format) {
  const literals = new Map();
  let mask = format;
  for (let i = 0, j = 0; i < format.length; i++, j++) {
    const [current, next] = [format.charAt(i), format.charAt(i + 1)];
    if (current === '\\' && FLAGS.has(next)) {
      mask = replaceCharAt(mask, j, '');
      literals.set(j, next);
      i++;
    } else {
      if (!FLAGS.has(current)) {
        literals.set(j, current);
      }
    }
  }
  return {
    literals,
    mask
  };
}
/** @hidden */
let MaskParsingService = /*#__PURE__*/(() => {
  class MaskParsingService {
    applyMask(inputVal, maskOptions, pos = 0) {
      let outputVal = '';
      let value = '';
      const {
        literals,
        mask
      } = parseMask(maskOptions.format);
      const literalKeys = Array.from(literals.keys());
      const nonLiteralIndices = this.getNonLiteralIndices(mask, literalKeys);
      const literalValues = Array.from(literals.values());
      if (inputVal != null) {
        value = inputVal.toString();
      }
      for (const _maskSym of mask) {
        outputVal += maskOptions.promptChar;
      }
      literals.forEach((val, key) => {
        outputVal = replaceCharAt(outputVal, key, val);
      });
      if (!value) {
        return outputVal;
      }
      const nonLiteralValues = this.getNonLiteralValues(value, literalValues);
      for (let i = 0; i < nonLiteralValues.length; i++) {
        const char = nonLiteralValues[i];
        const isCharValid = this.validateCharOnPosition(char, nonLiteralIndices[i], mask);
        if (!isCharValid && char !== maskOptions.promptChar) {
          nonLiteralValues[i] = maskOptions.promptChar;
        }
      }
      if (nonLiteralValues.length > nonLiteralIndices.length) {
        nonLiteralValues.splice(nonLiteralIndices.length);
      }
      for (const nonLiteralValue of nonLiteralValues) {
        const char = nonLiteralValue;
        outputVal = replaceCharAt(outputVal, nonLiteralIndices[pos++], char);
      }
      return outputVal;
    }
    parseValueFromMask(maskedValue, maskOptions) {
      let outputVal = '';
      const literalValues = Array.from(parseMask(maskOptions.format).literals.values());
      for (const val of maskedValue) {
        if (literalValues.indexOf(val) === -1) {
          if (val !== maskOptions.promptChar) {
            outputVal += val;
          }
        }
      }
      return outputVal;
    }
    replaceInMask(maskedValue, value, maskOptions, start, end) {
      const {
        literals,
        mask
      } = parseMask(maskOptions.format);
      const literalsPositions = Array.from(literals.keys());
      value = this.replaceIMENumbers(value);
      const chars = Array.from(value);
      let cursor = start;
      end = Math.min(end, maskedValue.length);
      for (let i = start; i < end || chars.length && i < maskedValue.length; i++) {
        if (literalsPositions.indexOf(i) !== -1) {
          if (chars[0] === maskedValue[i] || value.length < 1) {
            cursor = i + 1;
            chars.shift();
          }
          continue;
        }
        if (chars[0] && !this.validateCharOnPosition(chars[0], i, mask) && chars[0] !== maskOptions.promptChar) {
          break;
        }
        let char = maskOptions.promptChar;
        if (chars.length) {
          cursor = i + 1;
          char = chars.shift();
        }
        if (value.length < 1) {
          // on `delete` the cursor should move forward
          cursor++;
        }
        maskedValue = replaceCharAt(maskedValue, i, char);
      }
      return {
        value: maskedValue,
        end: cursor
      };
    }
    /** Validates only non literal positions. */
    validateCharOnPosition(inputChar, position, mask) {
      const regex = REGEX.get(mask.charAt(position));
      return regex ? regex.test(inputChar) : false;
    }
    getNonLiteralIndices(mask, literalKeys) {
      const nonLiteralsIndices = [];
      for (let i = 0; i < mask.length; i++) {
        if (literalKeys.indexOf(i) === -1) {
          nonLiteralsIndices.push(i);
        }
      }
      return nonLiteralsIndices;
    }
    getNonLiteralValues(value, literalValues) {
      const nonLiteralValues = [];
      for (const val of value) {
        if (literalValues.indexOf(val) === -1) {
          nonLiteralValues.push(val);
        }
      }
      return nonLiteralValues;
    }
    replaceIMENumbers(value) {
      return value.replace(/[０１２３４５６７８９]/g, num => ({
        '１': '1',
        '２': '2',
        '３': '3',
        '４': '4',
        '５': '5',
        '６': '6',
        '７': '7',
        '８': '8',
        '９': '9',
        '０': '0'
      })[num]);
    }
    static {
      this.ɵfac = function MaskParsingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaskParsingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MaskParsingService,
        factory: MaskParsingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MaskParsingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxMaskDirective = /*#__PURE__*/(() => {
  class IgxMaskDirective {
    /**
     * Sets the input mask.
     * ```html
     * <input [igxMask] = "'00/00/0000'">
     * ```
     */
    get mask() {
      return this._mask || this.defaultMask;
    }
    set mask(val) {
      // B.P. 9th June 2021 #7490
      if (val !== this._mask) {
        const cleanInputValue = this.maskParser.parseValueFromMask(this.inputValue, this.maskOptions);
        this.setPlaceholder(val);
        this._mask = val;
        this.updateInputValue(cleanInputValue);
      }
    }
    /** @hidden */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    /** @hidden @internal; */
    get inputValue() {
      return this.nativeElement.value;
    }
    /** @hidden @internal */
    set inputValue(val) {
      this.nativeElement.value = val;
    }
    /** @hidden */
    get maskOptions() {
      const format = this.mask || this.defaultMask;
      const promptChar = this.promptChar && this.promptChar.substring(0, 1);
      return {
        format,
        promptChar
      };
    }
    /** @hidden */
    get selectionStart() {
      // Edge(classic) and FF don't select text on drop
      return this.nativeElement.selectionStart === this.nativeElement.selectionEnd && this._hasDropAction ? this.nativeElement.selectionEnd - this._droppedData.length : this.nativeElement.selectionStart;
    }
    /** @hidden */
    get selectionEnd() {
      return this.nativeElement.selectionEnd;
    }
    /** @hidden */
    get start() {
      return this._start;
    }
    /** @hidden */
    get end() {
      return this._end;
    }
    constructor(elementRef, maskParser, renderer, platform) {
      this.elementRef = elementRef;
      this.maskParser = maskParser;
      this.renderer = renderer;
      this.platform = platform;
      /**
       * Sets the character representing a fillable spot in the input mask.
       * Default value is "'_'".
       * ```html
       * <input [promptChar] = "'/'">
       * ```
       */
      this.promptChar = '_';
      /**
       * Emits an event each time the value changes.
       * Provides `rawValue: string` and `formattedValue: string` as event arguments.
       * ```html
       * <input (valueChanged) = "valueChanged(rawValue: string, formattedValue: string)">
       * ```
       */
      this.valueChanged = new EventEmitter();
      this._focused = false;
      this._end = 0;
      this._start = 0;
      this._oldText = '';
      this._dataValue = '';
      this.defaultMask = 'CCCCCCCCCC';
      this._onTouchedCallback = noop;
      this._onChangeCallback = noop;
    }
    /** @hidden */
    onKeyDown(event) {
      const key = event.key;
      if (!key) {
        return;
      }
      if (event.ctrlKey && (key === this.platform.KEYMAP.Z || key === this.platform.KEYMAP.Y)) {
        event.preventDefault();
      }
      this._key = key;
      this._start = this.selectionStart;
      this._end = this.selectionEnd;
    }
    /** @hidden @internal */
    onCompositionStart() {
      if (!this._composing) {
        this._compositionStartIndex = this._start;
        this._composing = true;
      }
    }
    /** @hidden @internal */
    onCompositionEnd() {
      this._start = this._compositionStartIndex;
      const end = this.selectionEnd;
      const valueToParse = this.inputValue.substring(this._start, end);
      this.updateInput(valueToParse);
      this._end = this.selectionEnd;
      this._compositionValue = this.inputValue;
    }
    /** @hidden @internal */
    onInputChanged(event) {
      /**
       * '!this._focused' is a fix for #8165
       * On page load IE triggers input events before focus events and
       * it does so for every single input on the page.
       * The mask needs to be prevented from doing anything while this is happening because
       * the end user will be unable to blur the input.
       * https://stackoverflow.com/questions/21406138/input-event-triggered-on-internet-explorer-when-placeholder-changed
       */
      if (this._composing) {
        if (this.inputValue.length < this._oldText.length) {
          // software keyboard input delete
          this._key = this.platform.KEYMAP.BACKSPACE;
        }
        return;
      }
      // After the compositionend event Chromium triggers input events of type 'deleteContentBackward' and
      // we need to adjust the start and end indexes to include mask literals
      if (event.inputType === 'deleteContentBackward' && this._key !== this.platform.KEYMAP.BACKSPACE) {
        const isInputComplete = this._compositionStartIndex === 0 && this._end === this.mask.length;
        let numberOfMaskLiterals = 0;
        const literalPos = parseMask(this.maskOptions.format).literals.keys();
        for (const index of literalPos) {
          if (index >= this._compositionStartIndex && index <= this._end) {
            numberOfMaskLiterals++;
          }
        }
        this.inputValue = isInputComplete ? this.inputValue.substring(0, this.selectionEnd - numberOfMaskLiterals) + this.inputValue.substring(this.selectionEnd) : this._compositionValue?.substring(0, this._compositionStartIndex) || this.inputValue;
        if (this._compositionValue) {
          this._start = this.selectionStart;
          this._end = this.selectionEnd;
          this.nativeElement.selectionStart = isInputComplete ? this._start - numberOfMaskLiterals : this._compositionStartIndex;
          this.nativeElement.selectionEnd = this._end - numberOfMaskLiterals;
          this.nativeElement.selectionEnd = this._end;
          this._start = this.selectionStart;
          this._end = this.selectionEnd;
        }
      }
      if (this._hasDropAction) {
        this._start = this.selectionStart;
      }
      let valueToParse = '';
      switch (this._key) {
        case this.platform.KEYMAP.DELETE:
          this._end = this._start === this._end ? ++this._end : this._end;
          break;
        case this.platform.KEYMAP.BACKSPACE:
          this._start = this.selectionStart;
          break;
        default:
          valueToParse = this.inputValue.substring(this._start, this.selectionEnd);
          break;
      }
      this.updateInput(valueToParse);
    }
    /** @hidden */
    onPaste() {
      this._oldText = this.inputValue;
      this._start = this.selectionStart;
    }
    /** @hidden */
    onFocus() {
      if (this.nativeElement.readOnly) {
        return;
      }
      this._focused = true;
      this.showMask(this.inputValue);
    }
    /** @hidden */
    onBlur(value) {
      this._focused = false;
      this.showDisplayValue(value);
      this._onTouchedCallback();
    }
    /** @hidden */
    onDragEnter() {
      if (!this._focused && !this._dataValue) {
        this.showMask(this._dataValue);
      }
    }
    /** @hidden */
    onDragLeave() {
      if (!this._focused) {
        this.showDisplayValue(this.inputValue);
      }
    }
    /** @hidden */
    onDrop(event) {
      this._hasDropAction = true;
      this._droppedData = event.dataTransfer.getData('text');
    }
    /** @hidden */
    ngOnInit() {
      this.setPlaceholder(this.maskOptions.format);
    }
    /**
     * TODO: Remove after date/time picker integration refactor
     *
     * @hidden
     */
    ngAfterViewChecked() {
      if (this._composing) {
        return;
      }
      this._oldText = this.inputValue;
    }
    /** @hidden */
    writeValue(value) {
      if (this.promptChar && this.promptChar.length > 1) {
        this.maskOptions.promptChar = this.promptChar.substring(0, 1);
      }
      this.inputValue = value ? this.maskParser.applyMask(value, this.maskOptions) : '';
      if (this.displayValuePipe) {
        this.inputValue = this.displayValuePipe.transform(this.inputValue);
      }
      this._dataValue = this.includeLiterals ? this.inputValue : value;
      this.valueChanged.emit({
        rawValue: value,
        formattedValue: this.inputValue
      });
    }
    /** @hidden */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden */
    showMask(value) {
      if (this.focusedValuePipe) {
        // TODO(D.P.): focusedValuePipe should be deprecated or force-checked to match mask format
        this.inputValue = this.focusedValuePipe.transform(value);
      } else {
        this.inputValue = this.maskParser.applyMask(value, this.maskOptions);
      }
      this._oldText = this.inputValue;
    }
    /** @hidden */
    setSelectionRange(start, end = start) {
      this.nativeElement.setSelectionRange(start, end);
    }
    /** @hidden */
    afterInput() {
      this._oldText = this.inputValue;
      this._hasDropAction = false;
      this._start = 0;
      this._end = 0;
      this._key = null;
      this._composing = false;
    }
    /** @hidden */
    setPlaceholder(value) {
      const placeholder = this.nativeElement.placeholder;
      if (!placeholder || placeholder === this.mask) {
        this.renderer.setAttribute(this.nativeElement, 'placeholder', parseMask(value ?? '').mask || this.defaultMask);
      }
    }
    updateInputValue(value) {
      if (this._focused) {
        this.showMask(value);
      } else if (!this.displayValuePipe) {
        this.inputValue = this.inputValue ? this.maskParser.applyMask(value, this.maskOptions) : '';
      }
    }
    updateInput(valueToParse) {
      const replacedData = this.maskParser.replaceInMask(this._oldText, valueToParse, this.maskOptions, this._start, this._end);
      this.inputValue = replacedData.value;
      if (this._key === this.platform.KEYMAP.BACKSPACE) {
        replacedData.end = this._start;
      }
      this.setSelectionRange(replacedData.end);
      const rawVal = this.maskParser.parseValueFromMask(this.inputValue, this.maskOptions);
      this._dataValue = this.includeLiterals ? this.inputValue : rawVal;
      this._onChangeCallback(this._dataValue);
      this.valueChanged.emit({
        rawValue: rawVal,
        formattedValue: this.inputValue
      });
      this.afterInput();
    }
    showDisplayValue(value) {
      if (this.displayValuePipe) {
        this.inputValue = this.displayValuePipe.transform(value);
      } else if (value === this.maskParser.applyMask(null, this.maskOptions)) {
        this.inputValue = '';
      }
    }
    static {
      this.ɵfac = function IgxMaskDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxMaskDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(MaskParsingService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxMaskDirective,
        selectors: [["", "igxMask", ""]],
        hostBindings: function IgxMaskDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxMaskDirective_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            })("compositionstart", function IgxMaskDirective_compositionstart_HostBindingHandler() {
              return ctx.onCompositionStart();
            })("compositionend", function IgxMaskDirective_compositionend_HostBindingHandler() {
              return ctx.onCompositionEnd();
            })("input", function IgxMaskDirective_input_HostBindingHandler($event) {
              return ctx.onInputChanged($event);
            })("paste", function IgxMaskDirective_paste_HostBindingHandler() {
              return ctx.onPaste();
            })("focus", function IgxMaskDirective_focus_HostBindingHandler() {
              return ctx.onFocus();
            })("blur", function IgxMaskDirective_blur_HostBindingHandler($event) {
              return ctx.onBlur($event.target.value);
            })("dragenter", function IgxMaskDirective_dragenter_HostBindingHandler() {
              return ctx.onDragEnter();
            })("dragleave", function IgxMaskDirective_dragleave_HostBindingHandler() {
              return ctx.onDragLeave();
            })("drop", function IgxMaskDirective_drop_HostBindingHandler($event) {
              return ctx.onDrop($event);
            });
          }
        },
        inputs: {
          mask: [0, "igxMask", "mask"],
          promptChar: "promptChar",
          includeLiterals: [2, "includeLiterals", "includeLiterals", booleanAttribute],
          displayValuePipe: "displayValuePipe",
          focusedValuePipe: "focusedValuePipe"
        },
        outputs: {
          valueChanged: "valueChanged"
        },
        exportAs: ["igxMask"],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxMaskDirective,
          multi: true
        }])]
      });
    }
  }
  return IgxMaskDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxRippleDirective = /*#__PURE__*/(() => {
  class IgxRippleDirective {
    /**
     * Enables/disables the ripple to be centered.
     * ```html
     * <button type="button" #rippleContainer igxButton igxRipple [igxRippleCentered]="true"></button>
     * ```
     *
     * @memberof IgxRippleDirective
     */
    set centered(value) {
      this._centered = value || this.centered;
    }
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    constructor(builder, elementRef, renderer, zone) {
      this.builder = builder;
      this.elementRef = elementRef;
      this.renderer = renderer;
      this.zone = zone;
      /**
       * Sets/gets the ripple target.
       * ```html
       * <div  #rippleContainer class="div-1" igxRipple [igxRippleTarget] = "'.div-1'"></div>
       * ```
       * ```typescript
       * @ViewChild('rippleContainer', {read: IgxRippleDirective})
       * public ripple: IgxRippleDirective;
       * let rippleTarget = this.ripple.rippleTarget;
       * ```
       * Can set the ripple to activate on a child element inside the parent where igxRipple is defined.
       * ```html
       * <div #rippleContainer [igxRippleTarget]="'#child"'>
       *   <button type="button" igxButton id="child">Click</button>
       * </div>
       * ```
       *
       * @memberof IgxRippleDirective
       */
      this.rippleTarget = '';
      /**
       * Sets/gets the ripple duration(in milliseconds).
       * Default value is `600`.
       * ```html
       * <button type="button" #rippleContainer igxButton igxRipple [igxRippleDuration]="800"></button>
       * ```
       * ```typescript
       * @ViewChild('rippleContainer', {read: IgxRippleDirective})
       * public ripple: IgxRippleDirective;
       * let rippleDuration = this.ripple.rippleDuration;
       * ```
       *
       * @memberof IgxRippleDirective
       */
      this.rippleDuration = 600;
      /**
       * Sets/gets whether the ripple is disabled.
       * Default value is `false`.
       * ```html
       * <button type="button" #rippleContainer igxRipple [igxRippleDisabled]="true"></button>
       * ```
       * ```typescript
       * @ViewChild('rippleContainer', {read: IgxRippleDirective})
       * public ripple: IgxRippleDirective;
       * let isRippleDisabled = this.ripple.rippleDisabled;
       * ```
       *
       * @memberof IgxRippleDirective
       */
      this.rippleDisabled = false;
      this.rippleElementClass = 'igx-ripple__inner';
      this.rippleHostClass = 'igx-ripple';
      this._centered = false;
      this.animationQueue = [];
    }
    /**
     * @hidden
     */
    onMouseDown(event) {
      this.zone.runOutsideAngular(() => this._ripple(event));
    }
    setStyles(rippleElement, styleParams) {
      this.renderer.addClass(rippleElement, this.rippleElementClass);
      this.renderer.setStyle(rippleElement, 'width', `${styleParams.radius}px`);
      this.renderer.setStyle(rippleElement, 'height', `${styleParams.radius}px`);
      this.renderer.setStyle(rippleElement, 'top', `${styleParams.top}px`);
      this.renderer.setStyle(rippleElement, 'left', `${styleParams.left}px`);
      if (this.rippleColor) {
        this.renderer.setStyle(rippleElement, 'background', this.rippleColor);
      }
    }
    _ripple(event) {
      if (this.rippleDisabled) {
        return;
      }
      const target = this.rippleTarget ? this.nativeElement.querySelector(this.rippleTarget) || this.nativeElement : this.nativeElement;
      const rectBounds = target.getBoundingClientRect();
      const radius = Math.max(rectBounds.width, rectBounds.height);
      let left = Math.round(event.clientX - rectBounds.left - radius / 2);
      let top = Math.round(event.clientY - rectBounds.top - radius / 2);
      if (this._centered) {
        left = top = 0;
      }
      const dimensions = {
        radius,
        top,
        left
      };
      const rippleElement = this.renderer.createElement('span');
      this.setStyles(rippleElement, dimensions);
      this.renderer.addClass(target, this.rippleHostClass);
      this.renderer.appendChild(target, rippleElement);
      const animation = this.builder.build([style({
        opacity: 0.5,
        transform: 'scale(.3)'
      }), animate(this.rippleDuration, style({
        opacity: 0,
        transform: 'scale(2)'
      }))]).create(rippleElement);
      this.animationQueue.push(animation);
      animation.onDone(() => {
        this.animationQueue.splice(this.animationQueue.indexOf(animation), 1);
        target.removeChild(rippleElement);
        if (this.animationQueue.length < 1) {
          this.renderer.removeClass(target, this.rippleHostClass);
        }
      });
      animation.play();
    }
    static {
      this.ɵfac = function IgxRippleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRippleDirective)(i0.ɵɵdirectiveInject(i1.AnimationBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRippleDirective,
        selectors: [["", "igxRipple", ""]],
        hostBindings: function IgxRippleDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function IgxRippleDirective_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
        },
        inputs: {
          rippleTarget: [0, "igxRippleTarget", "rippleTarget"],
          rippleColor: [0, "igxRipple", "rippleColor"],
          rippleDuration: [0, "igxRippleDuration", "rippleDuration"],
          centered: [2, "igxRippleCentered", "centered", booleanAttribute],
          rippleDisabled: [2, "igxRippleDisabled", "rippleDisabled", booleanAttribute]
        }
      });
    }
  }
  return IgxRippleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const LabelPosition = /*@__PURE__*/mkenum({
  BEFORE: 'before',
  AFTER: 'after'
});
let nextId$1 = 0;
let CheckboxBaseDirective = /*#__PURE__*/(() => {
  class CheckboxBaseDirective {
    get checked() {
      return this._checked;
    }
    set checked(value) {
      if (this._checked !== value) {
        this._checked = value;
        this._onChangeCallback(this._checked);
      }
    }
    /**
     * Returns reference to the `nativeElement` of the igx-checkbox/igx-switch.
     *
     * @example
     * ```typescript
     * let nativeElement = this.component.nativeElement;
     * ```
     */
    get nativeElement() {
      return this.nativeInput.nativeElement;
    }
    constructor(cdr, renderer, themeToken, ngControl) {
      this.cdr = cdr;
      this.renderer = renderer;
      this.themeToken = themeToken;
      this.ngControl = ngControl;
      /**
       * An event that is emitted after the checkbox state is changed.
       * Provides references to the `IgxCheckboxComponent` and the `checked` property as event arguments.
       */
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.change = new EventEmitter();
      /**
       * @hidden
       * @internal
       */
      this.destroy$ = new Subject();
      /**
       * Sets/gets the `id` of the checkbox component.
       * If not set, the `id` of the first checkbox component will be `"igx-checkbox-0"`.
       *
       * @example
       * ```html
       * <igx-checkbox id="my-first-checkbox"></igx-checkbox>
       * ```
       * ```typescript
       * let checkboxId =  this.checkbox.id;
       * ```
       */
      this.id = `igx-checkbox-${nextId$1++}`;
      /**
       * Sets/gets the id of the `label` element.
       * If not set, the id of the `label` in the first checkbox component will be `"igx-checkbox-0-label"`.
       *
       * @example
       * ```html
       * <igx-checkbox labelId="Label1"></igx-checkbox>
       * ```
       * ```typescript
       * let labelId =  this.component.labelId;
       * ```
       */
      this.labelId = `${this.id}-label`;
      /**
       * Sets/gets the value of the `tabindex` attribute.
       *
       * @example
       * ```html
       * <igx-checkbox [tabindex]="1"></igx-checkbox>
       * ```
       * ```typescript
       * let tabIndex =  this.checkbox.tabindex;
       * ```
       */
      this.tabindex = null;
      /**
       *  Sets/gets the position of the `label`.
       *  If not set, the `labelPosition` will have value `"after"`.
       *
       * @example
       * ```html
       * <igx-checkbox labelPosition="before"></igx-checkbox>
       * ```
       * ```typescript
       * let labelPosition =  this.checkbox.labelPosition;
       * ```
       */
      this.labelPosition = LabelPosition.AFTER;
      /**
       * Enables/Disables the ripple effect.
       * If not set, `disableRipple` will have value `false`.
       *
       * @example
       * ```html
       * <igx-checkbox [disableRipple]="true"></igx-checkbox>
       * ```
       * ```typescript
       * let isRippleDisabled = this.checkbox.desableRipple;
       * ```
       */
      this.disableRipple = false;
      /**
       * Sets/gets the `aria-labelledby` attribute.
       * If not set, the `aria-labelledby` will be equal to the value of `labelId` attribute.
       *
       * @example
       * ```html
       * <igx-checkbox aria-labelledby="Checkbox1"></igx-checkbox>
       * ```
       * ```typescript
       * let ariaLabelledBy = this.checkbox.ariaLabelledBy;
       * ```
       */
      this.ariaLabelledBy = this.labelId;
      /**
       * Sets/gets the value of the `aria-label` attribute.
       *
       * @example
       * ```html
       * <igx-checkbox aria-label="Checkbox1"></igx-checkbox>
       * ```
       * ```typescript
       * let ariaLabel = this.checkbox.ariaLabel;
       * ```
       */
      this.ariaLabel = null;
      /**
       * @hidden
       * @internal
       */
      this.inputId = `${this.id}-input`;
      /**
       * @hidden
       */
      this._onChangeCallback = noop;
      /**
       * @hidden
       */
      this._onTouchedCallback = noop;
      /**
       * @hidden
       * @internal
       */
      this._checked = false;
      /**
       * @hidden
       * @internal
       */
      this._required = false;
      this.elRef = inject(ElementRef);
      this.destroyRef = inject(DestroyRef);
      if (this.ngControl !== null) {
        this.ngControl.valueAccessor = this;
      }
      this.theme = this.themeToken.theme;
      const themeChange = this.themeToken.onChange(theme => {
        if (this.theme !== theme) {
          this.theme = theme;
          this.cdr.detectChanges();
        }
      });
      this.destroyRef.onDestroy(() => themeChange.unsubscribe());
    }
    /**
     * Sets/gets whether the checkbox is required.
     * If not set, `required` will have value `false`.
     *
     * @example
     * ```html
     * <igx-checkbox required></igx-checkbox>
     * ```
     * ```typescript
     * let isRequired = this.checkbox.required;
     * ```
     */
    // @Input({ transform: booleanAttribute })
    // public get required(): boolean {
    //     return this._required || this.nativeElement.hasAttribute('required');
    // }
    // public set required(value: boolean) {
    //     this._required = value;
    // }
    get required() {
      return this._required || this.nativeElement.hasAttribute('required');
    }
    set required(value) {
      this._required = value;
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterViewInit() {
      if (this.ngControl) {
        this.ngControl.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(this.updateValidityState.bind(this));
        if (this.ngControl.control.validator || this.ngControl.control.asyncValidator) {
          this._required = this.ngControl?.control?.hasValidator(Validators.required);
          this.cdr.detectChanges();
        }
      }
      this.setComponentTheme();
    }
    setComponentTheme() {
      if (!this.themeToken.preferToken) {
        const theme = getComponentTheme(this.elRef.nativeElement);
        if (theme && theme !== this.theme) {
          this.theme = theme;
          this.cdr.markForCheck();
        }
      }
    }
    /** @hidden @internal */
    onKeyUp(event) {
      event.stopPropagation();
      this.focused = true;
    }
    /** @hidden @internal */
    _onCheckboxClick(event) {
      // Since the original checkbox is hidden and the label
      // is used for styling and to change the checked state of the checkbox,
      // we need to prevent the checkbox click event from bubbling up
      // as it gets triggered on label click
      // NOTE: The above is no longer valid, as the native checkbox is not labeled
      // by the SVG anymore.
      if (this.disabled || this.readonly) {
        // readonly prevents the component from changing state (see toggle() method).
        // However, the native checkbox can still be activated through user interaction (focus + space, label click)
        // Prevent the native change so the input remains in sync
        event.preventDefault();
        return;
      }
      this.nativeElement.focus();
      this.indeterminate = false;
      this.checked = !this.checked;
      this.updateValidityState();
      // K.D. March 23, 2021 Emitting on click and not on the setter because otherwise every component
      // bound on change would have to perform self checks for weather the value has changed because
      // of the initial set on initialization
      this.change.emit({
        checked: this.checked,
        value: this.value,
        owner: this
      });
    }
    /**
     * @hidden
     * @internal
     */
    get ariaChecked() {
      if (this.indeterminate) {
        return 'mixed';
      } else {
        return this.checked;
      }
    }
    /** @hidden @internal */
    _onCheckboxChange(event) {
      // We have to stop the original checkbox change event
      // from bubbling up since we emit our own change event
      event.stopPropagation();
    }
    /** @hidden @internal */
    onBlur() {
      this.focused = false;
      this._onTouchedCallback();
      this.updateValidityState();
    }
    /** @hidden @internal */
    writeValue(value) {
      this._checked = value;
    }
    /** @hidden @internal */
    get labelClass() {
      switch (this.labelPosition) {
        case LabelPosition.BEFORE:
          return `${this.cssClass}__label--before`;
        case LabelPosition.AFTER:
        default:
          return `${this.cssClass}__label`;
      }
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    /** @hidden @internal */
    getEditElement() {
      return this.nativeInput.nativeElement;
    }
    /**
     * @hidden
     * @internal
     */
    updateValidityState() {
      if (this.ngControl) {
        if (!this.disabled && !this.readonly && (this.ngControl.control.touched || this.ngControl.control.dirty)) {
          // the control is not disabled and is touched or dirty
          this.invalid = this.ngControl.invalid;
        } else {
          //  if the control is untouched, pristine, or disabled, its state is initial. This is when the user did not interact
          //  with the checkbox or when the form/control is reset
          this.invalid = false;
        }
      } else {
        this.checkNativeValidity();
      }
    }
    /**
     * A function to assign a native validity property of a checkbox.
     * This should be used when there's no ngControl
     *
     * @hidden
     * @internal
     */
    checkNativeValidity() {
      if (!this.disabled && this._required && !this.checked && !this.readonly) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
    }
    static {
      this.ɵfac = function CheckboxBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxBaseDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(THEME_TOKEN), i0.ɵɵdirectiveInject(i4.NgControl, 10));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CheckboxBaseDirective,
        viewQuery: function CheckboxBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 7);
            i0.ɵɵviewQuery(_c8, 7);
            i0.ɵɵviewQuery(_c9, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeLabel = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.placeholderLabel = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function CheckboxBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keyup", function CheckboxBaseDirective_keyup_HostBindingHandler($event) {
              return ctx.onKeyUp($event);
            })("click", function CheckboxBaseDirective_click_HostBindingHandler($event) {
              return ctx._onCheckboxClick($event);
            })("blur", function CheckboxBaseDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
          }
        },
        inputs: {
          checked: [2, "checked", "checked", booleanAttribute],
          id: "id",
          labelId: "labelId",
          value: "value",
          name: "name",
          tabindex: "tabindex",
          labelPosition: "labelPosition",
          disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
          ariaLabelledBy: [0, "aria-labelledby", "ariaLabelledBy"],
          ariaLabel: [0, "aria-label", "ariaLabel"],
          required: [2, "required", "required", booleanAttribute]
        },
        outputs: {
          change: "change"
        }
      });
    }
  }
  return CheckboxBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * **Ignite UI for Angular Radio Button** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/radio_button.html)
 *
 * The Ignite UI Radio Button allows the user to select a single option from an available set of options that are listed side by side.
 *
 * Example:
 * ```html
 * <igx-radio>
 *   Simple radio button
 * </igx-radio>
 * ```
 */
let IgxRadioComponent = /*#__PURE__*/(() => {
  class IgxRadioComponent extends CheckboxBaseDirective {
    constructor() {
      super(...arguments);
      /** @hidden @internal */
      this.blurRadio = new EventEmitter();
      /**
       * Returns the class of the radio component.
       * ```typescript
       * let radioClass = this.radio.cssClass;
       * ```
       *
       * @memberof IgxRadioComponent
       */
      this.cssClass = 'igx-radio';
      /**
       * Sets/gets  the `disabled` attribute.
       * Default value is `false`.
       * ```html
       * <igx-radio disabled></igx-radio>
       * ```
       * ```typescript
       * let isDisabled =  this.radio.disabled;
       * ```
       *
       * @memberof IgxRadioComponent
       */
      this.disabled = false;
      /**
       * Sets/gets whether the radio button is invalid.
       * Default value is `false`.
       * ```html
       * <igx-radio invalid></igx-radio>
       * ```
       * ```typescript
       * let isInvalid =  this.radio.invalid;
       * ```
       *
       * @memberof IgxRadioComponent
       */
      this.invalid = false;
      /**
       * Sets/gets whether the radio component is on focus.
       * Default value is `false`.
       * ```typescript
       * this.radio.focus = true;
       * ```
       * ```typescript
       * let isFocused =  this.radio.focused;
       * ```
       *
       * @memberof IgxRadioComponent
       */
      this.focused = false;
    }
    /**
     * Sets/gets  the `checked` attribute.
     * Default value is `false`.
     * ```html
     * <igx-radio [checked]="true"></igx-radio>
     * ```
     * ```typescript
     * let isChecked =  this.radio.checked;
     * ```
     *
     * @memberof IgxRadioComponent
     */
    set checked(value) {
      this._checked = value;
    }
    get checked() {
      return this._checked;
    }
    /**
     * @hidden
     * @internal
     */
    _changed(event) {
      if (event instanceof Event) {
        event.preventDefault();
      }
    }
    /**
     * @hidden
     */
    _onCheckboxClick() {
      this.select();
    }
    /**
     * Selects the current radio button.
     * ```typescript
     * this.radio.select();
     * ```
     *
     * @memberof IgxRadioComponent
     */
    select() {
      if (!this.checked) {
        this.checked = true;
        this.change.emit({
          value: this.value,
          owner: this,
          checked: this.checked
        });
        this._onChangeCallback(this.value);
      }
    }
    /**
     * Deselects the current radio button.
     * ```typescript
     * this.radio.deselect();
     * ```
     *
     * @memberof IgxRadioComponent
     */
    deselect() {
      this.checked = false;
      this.focused = false;
      this.cdr.markForCheck();
    }
    /**
     * Checks whether the provided value is consistent to the current radio button.
     * If it is, the checked attribute will have value `true`;
     * ```typescript
     * this.radio.writeValue('radioButtonValue');
     * ```
     */
    writeValue(value) {
      this.value = this.value ?? value;
      if (value === this.value) {
        if (!this.checked) {
          this.checked = true;
        }
      } else {
        this.deselect();
      }
    }
    /**
     * @hidden
     */
    onBlur() {
      super.onBlur();
      this.blurRadio.emit();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxRadioComponent_BaseFactory;
        return function IgxRadioComponent_Factory(__ngFactoryType__) {
          return (ɵIgxRadioComponent_BaseFactory || (ɵIgxRadioComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxRadioComponent)))(__ngFactoryType__ || IgxRadioComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxRadioComponent,
        selectors: [["igx-radio"]],
        hostVars: 10,
        hostBindings: function IgxRadioComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function IgxRadioComponent_change_HostBindingHandler($event) {
              return ctx._changed($event);
            })("click", function IgxRadioComponent_click_HostBindingHandler() {
              return ctx._onCheckboxClick();
            })("blur", function IgxRadioComponent_blur_HostBindingHandler() {
              return ctx.onBlur();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-radio", ctx.cssClass)("igx-radio--checked", ctx.checked)("igx-radio--disabled", ctx.disabled)("igx-radio--invalid", ctx.invalid)("igx-radio--focused", ctx.focused);
          }
        },
        inputs: {
          checked: [2, "checked", "checked", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          invalid: [2, "invalid", "invalid", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: EDITOR_PROVIDER,
          useExisting: IgxRadioComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 8,
        vars: 18,
        consts: [["checkbox", ""], ["label", ""], ["placeholderLabel", ""], ["type", "radio", 1, "igx-radio__input", 3, "blur", "id", "name", "value", "tabindex", "disabled", "checked", "required"], ["igxRipple", "", "igxRippleTarget", ".igx-radio__ripple", 1, "igx-radio__composite", 3, "igxRippleDisabled", "igxRippleCentered", "igxRippleDuration"], [1, "igx-radio__ripple"], [3, "id"]],
        template: function IgxRadioComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "input", 3, 0);
            i0.ɵɵlistener("blur", function IgxRadioComponent_Template_input_blur_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span", 4, 1);
            i0.ɵɵelement(4, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "span", 6, 2);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.inputId)("name", ctx.name)("value", ctx.value)("tabindex", ctx.tabindex)("disabled", ctx.disabled)("checked", ctx.checked)("required", ctx.required);
            i0.ɵɵattribute("aria-required", ctx.required)("aria-invalid", ctx.invalid)("aria-checked", ctx.checked)("aria-labelledby", ctx.ariaLabel ? null : ctx.ariaLabelledBy)("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("igxRippleDisabled", ctx.disableRipple)("igxRippleCentered", true)("igxRippleDuration", 300);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.labelClass);
            i0.ɵɵproperty("id", ctx.labelId);
          }
        },
        dependencies: [IgxRippleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxRadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
function DIR_DOCUMENT_FACTORY() {
  return inject(DOCUMENT);
}
/**
 * Injection token is used to inject the document into Directionality
 * which factory could be faked for testing purposes.
 *
 * We can't provide and mock the DOCUMENT token from platform-browser because configureTestingModule
 * allows override of the default providers, directive, pipes, modules of the test injector
 * which causes errors.
 *
 * @hidden
 */
const DIR_DOCUMENT = /*@__PURE__*/new InjectionToken('dir-doc', {
  providedIn: 'root',
  factory: DIR_DOCUMENT_FACTORY
});
/**
 * @hidden
 *
 * Bidirectional service that extracts the value of the direction attribute on the body or html elements.
 *
 * The dir attribute over the body element takes precedence.
 */
let IgxDirectionality = /*#__PURE__*/(() => {
  class IgxDirectionality {
    get value() {
      return this._dir;
    }
    get document() {
      return this._document;
    }
    get rtl() {
      return this._dir === 'rtl';
    }
    constructor(document) {
      this._document = document;
      const bodyDir = this._document.body ? this._document.body.dir : null;
      const htmlDir = this._document.documentElement ? this._document.documentElement.dir : null;
      const extractedDir = bodyDir || htmlDir;
      this._dir = extractedDir === 'ltr' || extractedDir === 'rtl' ? extractedDir : 'ltr';
    }
    static {
      this.ɵfac = function IgxDirectionality_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDirectionality)(i0.ɵɵinject(DIR_DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxDirectionality,
        factory: IgxDirectionality.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxDirectionality;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Determines the Radio Group alignment
 */
const RadioGroupAlignment = mkenum({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
let nextId = 0;
/**
 * Radio group directive renders set of radio buttons.
 *
 * @igxModule IgxRadioModule
 *
 * @igxTheme igx-radio-theme
 *
 * @igxKeywords radiogroup, radio, button, input
 *
 * @igxGroup Data Entry & Display
 *
 * @remarks
 * The Ignite UI Radio Group allows the user to select a single option from an available set of options that are listed side by side.
 *
 * @example:
 * ```html
 * <igx-radio-group name="radioGroup">
 *   <igx-radio *ngFor="let item of ['Foo', 'Bar', 'Baz']" value="{{item}}">
 *      {{item}}
 *   </igx-radio>
 * </igx-radio-group>
 * ```
 */
let IgxRadioGroupDirective = /*#__PURE__*/(() => {
  class IgxRadioGroupDirective {
    /**
     * Sets/gets the `value` attribute.
     *
     * @example
     * ```html
     * <igx-radio-group [value] = "'radioButtonValue'"></igx-radio-group>
     * ```
     */
    get value() {
      return this._value;
    }
    set value(newValue) {
      if (this._value !== newValue) {
        this._value = newValue;
        this._selectRadioButton();
      }
    }
    /**
     * Sets/gets the `name` attribute of the radio group component. All child radio buttons inherits this name.
     *
     * @example
     * ```html
     * <igx-radio-group name = "Radio1"></igx-radio-group>
     *  ```
     */
    get name() {
      return this._name;
    }
    set name(newValue) {
      if (this._name !== newValue) {
        this._name = newValue;
        this._setRadioButtonNames();
      }
    }
    /**
     * Sets/gets whether the radio group is required.
     *
     * @remarks
     * If not set, `required` will have value `false`.
     *
     * @example
     * ```html
     * <igx-radio-group [required] = "true"></igx-radio-group>
     * ```
     */
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = value;
      this._setRadioButtonsRequired();
    }
    /**
     * Sets/gets the selected child radio button.
     *
     * @example
     * ```typescript
     * let selectedButton = this.radioGroup.selected;
     * this.radioGroup.selected = selectedButton;
     * ```
     */
    get selected() {
      return this._selected;
    }
    set selected(selected) {
      if (this._selected !== selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
      }
    }
    /**
     * Sets/gets whether the radio group is invalid.
     *
     * @remarks
     * If not set, `invalid` will have value `false`.
     *
     * @example
     * ```html
     * <igx-radio-group [invalid] = "true"></igx-radio-group>
     * ```
     */
    get invalid() {
      return this._invalid;
    }
    set invalid(value) {
      this._invalid = value;
      this._setRadioButtonsInvalid();
    }
    handleClick(event) {
      event.stopPropagation();
      if (this.selected) {
        this.selected.nativeElement.focus();
      }
    }
    handleKeyDown(event) {
      const {
        key
      } = event;
      const buttons = this.radioButtons.filter(radio => !radio.disabled);
      const checked = buttons.find(radio => radio.checked);
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key)) {
        let index = checked ? buttons.indexOf(checked) : -1;
        const ltr = this._directionality.value === 'ltr';
        switch (key) {
          case 'ArrowUp':
            index += -1;
            break;
          case 'ArrowLeft':
            index += ltr ? -1 : 1;
            break;
          case 'ArrowRight':
            index += ltr ? 1 : -1;
            break;
          default:
            index += 1;
        }
        if (index < 0) index = buttons.length - 1;
        if (index > buttons.length - 1) index = 0;
        buttons.forEach(radio => {
          radio.deselect();
          radio.nativeElement.blur();
        });
        buttons[index].focused = true;
        buttons[index].nativeElement.focus();
        buttons[index].select();
        event.preventDefault();
      }
      if (event.key === "Tab") {
        buttons.forEach(radio => {
          if (radio !== checked) {
            event.stopPropagation();
          }
        });
      }
    }
    /**
     * Returns the alignment of the `igx-radio-group`.
     * ```typescript
     * @ViewChild("MyRadioGroup")
     * public radioGroup: IgxRadioGroupDirective;
     * ngAfterViewInit(){
     *    let radioAlignment = this.radioGroup.alignment;
     * }
     * ```
     */
    get alignment() {
      return this.vertical ? RadioGroupAlignment.vertical : RadioGroupAlignment.horizontal;
    }
    /**
     * Allows you to set the radio group alignment.
     * Available options are `RadioGroupAlignment.horizontal` (default) and `RadioGroupAlignment.vertical`.
     * ```typescript
     * public alignment = RadioGroupAlignment.vertical;
     * //..
     * ```
     * ```html
     * <igx-radio-group [alignment]="alignment"></igx-radio-group>
     * ```
     */
    set alignment(value) {
      this.vertical = value === RadioGroupAlignment.vertical;
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterContentInit() {
      // The initial value can possibly be set by NgModel and it is possible that
      // the OnInit of the NgModel occurs after the OnInit of this class.
      this._isInitialized = true;
      this.radioButtons.changes.pipe(startWith(0), takeUntil(this.destroy$)).subscribe(() => {
        this.queryChange$.next();
        setTimeout(() => this._initRadioButtons());
      });
      if (this.ngControl) {
        this.radioButtons.forEach(button => {
          if (this.ngControl.disabled) {
            button.disabled = this.ngControl.disabled;
          }
        });
      }
    }
    /**
     * @hidden
     * @internal
    */
    ngAfterViewInit() {
      if (this.ngControl) {
        this.ngControl.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.invalid = false;
        });
        if (this.ngControl.control.validator || this.ngControl.control.asyncValidator) {
          this._required = this.ngControl?.control?.hasValidator(Validators.required);
        }
      }
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          button.blurRadio.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.updateValidityOnBlur();
          });
          fromEvent(button.nativeElement, 'keyup').pipe(takeUntil(this.destroy$)).subscribe(event => {
            this.updateOnKeyUp(event);
          });
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    updateValidityOnBlur() {
      this.radioButtons.forEach(button => {
        button.focused = false;
        if (button.invalid) {
          this.invalid = true;
        }
      });
    }
    /**
     * @hidden
     * @internal
     */
    updateOnKeyUp(event) {
      const checked = this.radioButtons.find(x => x.checked);
      if (event.key === "Tab") {
        this.radioButtons.forEach(radio => {
          if (radio === checked) {
            checked.focused = true;
          }
        });
      }
    }
    ngDoCheck() {
      this._updateTabIndex();
    }
    _updateTabIndex() {
      // Needed so that the keyboard navigation of a radio group
      // placed inside a dialog works properly
      if (this.radioButtons) {
        const checked = this.radioButtons.find(x => x.checked);
        if (checked) {
          this.radioButtons.forEach(button => {
            checked.nativeElement.tabIndex = 0;
            if (button !== checked) {
              button.nativeElement.tabIndex = -1;
              button.focused = false;
            }
          });
        }
      }
    }
    /**
     * Sets the "checked" property value on the radio input element.
     *
     * @remarks
     * Checks whether the provided value is consistent to the current radio button.
     * If it is, the checked attribute will have value `true` and selected property will contain the selected `IgxRadioComponent`.
     *
     * @example
     * ```typescript
     * this.radioGroup.writeValue('radioButtonValue');
     * ```
     */
    writeValue(value) {
      this.value = value;
    }
    /**
     * Registers a function called when the control value changes.
     *
     * @hidden
     * @internal
     */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /**
     * Registers a function called when the control is touched.
     *
     * @hidden
     * @internal
     */
    registerOnTouched(fn) {
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          button.registerOnTouched(fn);
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    constructor(ngControl, _directionality, cdr) {
      this.ngControl = ngControl;
      this._directionality = _directionality;
      this.cdr = cdr;
      /**
       * An event that is emitted after the radio group `value` is changed.
       *
       * @remarks
       * Provides references to the selected `IgxRadioComponent` and the `value` property as event arguments.
       *
       * @example
       * ```html
       * <igx-radio-group (change)="handler($event)"></igx-radio-group>
       * ```
       */
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.change = new EventEmitter();
      /**
       * The css class applied to the component.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-radio-group';
      /**
       * Sets vertical alignment to the radio group, if `alignment` is set to `vertical`.
       * By default the alignment is horizontal.
       *
       * @example
       * ```html
       * <igx-radio-group alignment="vertical"></igx-radio-group>
       * ```
       */
      this.vertical = false;
      /**
       * @hidden
       * @internal
       */
      this._onChangeCallback = noop;
      /**
       * @hidden
       * @internal
       */
      this._name = `igx-radio-group-${nextId++}`;
      /**
       * @hidden
       * @internal
       */
      this._value = null;
      /**
       * @hidden
       * @internal
       */
      this._selected = null;
      /**
       * @hidden
       * @internal
       */
      this._isInitialized = false;
      /**
       * @hidden
       * @internal
       */
      this._required = false;
      /**
       * @hidden
       * @internal
       */
      this._invalid = false;
      /**
       * @hidden
       * @internal
       */
      this.destroy$ = new Subject();
      /**
       * @hidden
       * @internal
       */
      this.queryChange$ = new Subject();
      if (this.ngControl !== null) {
        this.ngControl.valueAccessor = this;
      }
    }
    /**
     * @hidden
     * @internal
     */
    _initRadioButtons() {
      if (this.radioButtons) {
        const props = {
          name: this._name,
          required: this._required
        };
        this.radioButtons.forEach(button => {
          Object.assign(button, props);
          if (button.value === this._value) {
            button.checked = true;
            this._selected = button;
            this.cdr.markForCheck();
          }
          button.change.pipe(takeUntil(button.destroy$), takeUntil(this.destroy$), takeUntil(this.queryChange$)).subscribe(ev => this._selectedRadioButtonChanged(ev));
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    _selectedRadioButtonChanged(args) {
      this.radioButtons.forEach(button => {
        button.checked = button.id === args.owner.id;
        if (button.checked && button.ngControl) {
          this.invalid = button.ngControl.invalid;
        } else if (button.checked) {
          this.invalid = false;
        }
      });
      this._selected = args.owner;
      this._value = args.value;
      if (this._isInitialized) {
        this.change.emit(args);
        this._onChangeCallback(this.value);
      }
    }
    /**
     * @hidden
     * @internal
     */
    _setRadioButtonNames() {
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          button.name = this._name;
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    _selectRadioButton() {
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          if (this._value === null) {
            // no value - uncheck all radio buttons
            if (button.checked) {
              button.checked = false;
            }
          } else {
            if (this._value === button.value) {
              // selected button
              if (this._selected !== button) {
                this._selected = button;
              }
              if (!button.checked) {
                button.checked = true;
              }
            } else {
              // non-selected button
              if (button.checked) {
                button.checked = false;
              }
            }
          }
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    _setRadioButtonsRequired() {
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          button.required = this._required;
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    _setRadioButtonsInvalid() {
      if (this.radioButtons) {
        this.radioButtons.forEach(button => {
          button.invalid = this._invalid;
        });
      }
    }
    static {
      this.ɵfac = function IgxRadioGroupDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRadioGroupDirective)(i0.ɵɵdirectiveInject(i4.NgControl, 10), i0.ɵɵdirectiveInject(IgxDirectionality), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRadioGroupDirective,
        selectors: [["igx-radio-group"], ["", "igxRadioGroup", ""]],
        contentQueries: function IgxRadioGroupDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxRadioComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.radioButtons = _t);
          }
        },
        hostVars: 4,
        hostBindings: function IgxRadioGroupDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxRadioGroupDirective_click_HostBindingHandler($event) {
              return ctx.handleClick($event);
            })("keydown", function IgxRadioGroupDirective_keydown_HostBindingHandler($event) {
              return ctx.handleKeyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-radio-group", ctx.cssClass)("igx-radio-group--vertical", ctx.vertical);
          }
        },
        inputs: {
          value: "value",
          name: "name",
          required: [2, "required", "required", booleanAttribute],
          selected: "selected",
          invalid: [2, "invalid", "invalid", booleanAttribute],
          alignment: "alignment"
        },
        outputs: {
          change: "change"
        },
        exportAs: ["igxRadioGroup"]
      });
    }
  }
  return IgxRadioGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Radio Group directives collection for ease-of-use import in standalone components scenario */
const IGX_RADIO_GROUP_DIRECTIVES = [IgxRadioGroupDirective, IgxRadioComponent];
let IgSizeDirective = /*#__PURE__*/(() => {
  class IgSizeDirective {
    get igSize() {
      return this._size;
    }
    set igSize(value) {
      this._size = `var(--ig-size-${value})`;
    }
    static {
      this.ɵfac = function IgSizeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgSizeDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgSizeDirective,
        selectors: [["", "igSize", ""]],
        hostVars: 2,
        hostBindings: function IgSizeDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--ig-size", ctx.igSize);
          }
        },
        inputs: {
          igSize: "igSize"
        }
      });
    }
  }
  return IgSizeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTextHighlightDirective = /*#__PURE__*/(() => {
  class IgxTextHighlightDirective {
    /**
     * The underlying value of the element that will be highlighted.
     *
     * ```typescript
     * // get
     * const elementValue = this.textHighlight.value;
     * ```
     *
     * ```html
     * <!--set-->
     * <div
     *   igxTextHighlight
     *   [value]="newValue">
     * </div>
     * ```
     */
    get value() {
      return this._value;
    }
    set value(value) {
      if (value === undefined || value === null) {
        this._value = '';
      } else {
        this._value = value;
      }
    }
    /**
     * @hidden
     */
    get lastSearchInfo() {
      return this._lastSearchInfo;
    }
    constructor(element, service, renderer) {
      this.element = element;
      this.service = service;
      this.renderer = renderer;
      /**
       * Identifies the highlight within a unique group.
       * This allows it to have several different highlight groups,
       * with each of them having their own active highlight.
       *
       * ```html
       * <div
       *   igxTextHighlight
       *   [groupName]="myGroupName">
       * </div>
       * ```
       */
      this.groupName = '';
      this.destroy$ = new Subject();
      this._value = '';
      this._div = null;
      this._observer = null;
      this._nodeWasRemoved = false;
      this._forceEvaluation = false;
      this._activeElementIndex = -1;
      this._defaultCssClass = 'igx-highlight';
      this._defaultActiveCssClass = 'igx-highlight--active';
      this.service.onActiveElementChanged.pipe(takeUntil(this.destroy$)).subscribe(groupName => {
        if (this.groupName === groupName) {
          if (this._activeElementIndex !== -1) {
            this.deactivate();
          }
          this.activateIfNecessary();
        }
      });
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.clearHighlight();
      if (this._observer !== null) {
        this._observer.disconnect();
      }
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      if (changes.value && !changes.value.firstChange) {
        this._valueChanged = true;
      } else if (changes.row !== undefined && !changes.row.firstChange || changes.column !== undefined && !changes.column.firstChange || changes.page !== undefined && !changes.page.firstChange) {
        if (this._activeElementIndex !== -1) {
          this.deactivate();
        }
        this.activateIfNecessary();
      }
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this.parentElement = this.renderer.parentNode(this.element.nativeElement);
      if (this.service.highlightGroupsMap.has(this.groupName) === false) {
        this.service.highlightGroupsMap.set(this.groupName, {
          index: -1
        });
      }
      this._lastSearchInfo = {
        searchText: '',
        content: this.value,
        matchCount: 0,
        caseSensitive: false,
        exactMatch: false
      };
      this._container = this.parentElement.firstElementChild;
    }
    /**
     * @hidden
     */
    ngAfterViewChecked() {
      if (this._valueChanged) {
        this.highlight(this._lastSearchInfo.searchText, this._lastSearchInfo.caseSensitive, this._lastSearchInfo.exactMatch);
        this.activateIfNecessary();
        this._valueChanged = false;
      }
    }
    /**
     * Clears the existing highlight and highlights the searched text.
     * Returns how many times the element contains the searched text.
     */
    highlight(text, caseSensitive, exactMatch) {
      const caseSensitiveResolved = caseSensitive ? true : false;
      const exactMatchResolved = exactMatch ? true : false;
      if (this.searchNeedsEvaluation(text, caseSensitiveResolved, exactMatchResolved)) {
        this._lastSearchInfo.searchText = text;
        this._lastSearchInfo.caseSensitive = caseSensitiveResolved;
        this._lastSearchInfo.exactMatch = exactMatchResolved;
        this._lastSearchInfo.content = this.value;
        if (text === '' || text === undefined || text === null) {
          this.clearHighlight();
        } else {
          this.clearChildElements(true);
          this._lastSearchInfo.matchCount = this.getHighlightedText(text, caseSensitive, exactMatch);
        }
      } else if (this._nodeWasRemoved) {
        this._lastSearchInfo.searchText = text;
        this._lastSearchInfo.caseSensitive = caseSensitiveResolved;
        this._lastSearchInfo.exactMatch = exactMatchResolved;
      }
      return this._lastSearchInfo.matchCount;
    }
    /**
     * Clears any existing highlight.
     */
    clearHighlight() {
      this.clearChildElements(false);
      this._lastSearchInfo.searchText = '';
      this._lastSearchInfo.matchCount = 0;
    }
    /**
     * Activates the highlight if it is on the currently active row and column.
     */
    activateIfNecessary() {
      const group = this.service.highlightGroupsMap.get(this.groupName);
      if (group.index >= 0 && group.column === this.column && group.row === this.row && compareMaps(this.metadata, group.metadata)) {
        this.activate(group.index);
      }
    }
    /**
     * Attaches a MutationObserver to the parentElement and watches for when the container element is removed/readded to the DOM.
     * Should be used only when necessary as using many observers may lead to performance degradation.
     */
    observe() {
      if (this._observer === null) {
        const callback = mutationList => {
          mutationList.forEach(mutation => {
            const removedNodes = Array.from(mutation.removedNodes);
            removedNodes.forEach(n => {
              if (n === this._container) {
                this._nodeWasRemoved = true;
                this.clearChildElements(false);
              }
            });
            const addedNodes = Array.from(mutation.addedNodes);
            addedNodes.forEach(n => {
              if (n === this.parentElement.firstElementChild && this._nodeWasRemoved) {
                this._container = this.parentElement.firstElementChild;
                this._nodeWasRemoved = false;
                this._forceEvaluation = true;
                this.highlight(this._lastSearchInfo.searchText, this._lastSearchInfo.caseSensitive, this._lastSearchInfo.exactMatch);
                this._forceEvaluation = false;
                this.activateIfNecessary();
                this._observer.disconnect();
                this._observer = null;
              }
            });
          });
        };
        this._observer = new MutationObserver(callback);
        this._observer.observe(this.parentElement, {
          childList: true
        });
      }
    }
    activate(index) {
      this.deactivate();
      if (this._div !== null) {
        const spans = this._div.querySelectorAll('span');
        this._activeElementIndex = index;
        if (spans.length <= index) {
          return;
        }
        const elementToActivate = spans[index];
        this.renderer.addClass(elementToActivate, this._defaultActiveCssClass);
        this.renderer.addClass(elementToActivate, this.activeCssClass);
      }
    }
    deactivate() {
      if (this._activeElementIndex === -1) {
        return;
      }
      const spans = this._div.querySelectorAll('span');
      if (spans.length <= this._activeElementIndex) {
        this._activeElementIndex = -1;
        return;
      }
      const elementToDeactivate = spans[this._activeElementIndex];
      this.renderer.removeClass(elementToDeactivate, this._defaultActiveCssClass);
      this.renderer.removeClass(elementToDeactivate, this.activeCssClass);
      this._activeElementIndex = -1;
    }
    clearChildElements(originalContentHidden) {
      this.renderer.setProperty(this.element.nativeElement, 'hidden', originalContentHidden);
      if (this._div !== null) {
        this.renderer.removeChild(this.parentElement, this._div);
        this._div = null;
        this._activeElementIndex = -1;
      }
    }
    getHighlightedText(searchText, caseSensitive, exactMatch) {
      this.appendDiv();
      const stringValue = String(this.value);
      const contentStringResolved = !caseSensitive ? stringValue.toLowerCase() : stringValue;
      const searchTextResolved = !caseSensitive ? searchText.toLowerCase() : searchText;
      let matchCount = 0;
      if (exactMatch) {
        if (contentStringResolved === searchTextResolved) {
          this.appendSpan(`<span class="${this._defaultCssClass} ${this.cssClass ? this.cssClass : ''}">${stringValue}</span>`);
          matchCount++;
        } else {
          this.appendText(stringValue);
        }
      } else {
        let foundIndex = contentStringResolved.indexOf(searchTextResolved, 0);
        let previousMatchEnd = 0;
        while (foundIndex !== -1) {
          const start = foundIndex;
          const end = foundIndex + searchTextResolved.length;
          this.appendText(stringValue.substring(previousMatchEnd, start));
          this.appendSpan(`<span class="${this._defaultCssClass} ${this.cssClass ? this.cssClass : ''}">${stringValue.substring(start, end)}</span>`);
          previousMatchEnd = end;
          matchCount++;
          foundIndex = contentStringResolved.indexOf(searchTextResolved, end);
        }
        this.appendText(stringValue.substring(previousMatchEnd, stringValue.length));
      }
      return matchCount;
    }
    appendText(text) {
      const textElement = this.renderer.createText(text);
      this.renderer.appendChild(this._div, textElement);
    }
    appendSpan(outerHTML) {
      const span = this.renderer.createElement('span');
      this.renderer.appendChild(this._div, span);
      this.renderer.setProperty(span, 'outerHTML', outerHTML);
    }
    appendDiv() {
      this._div = this.renderer.createElement('div');
      if (this.containerClass) {
        this.renderer.addClass(this._div, this.containerClass);
      }
      this.renderer.appendChild(this.parentElement, this._div);
    }
    searchNeedsEvaluation(text, caseSensitive, exactMatch) {
      const searchedText = this._lastSearchInfo.searchText;
      return !this._nodeWasRemoved && (searchedText === null || searchedText !== text || this._lastSearchInfo.content !== this.value || this._lastSearchInfo.caseSensitive !== caseSensitive || this._lastSearchInfo.exactMatch !== exactMatch || this._forceEvaluation);
    }
    static {
      this.ɵfac = function IgxTextHighlightDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTextHighlightDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTextHighlightDirective,
        selectors: [["", "igxTextHighlight", ""]],
        inputs: {
          cssClass: "cssClass",
          activeCssClass: "activeCssClass",
          containerClass: "containerClass",
          groupName: "groupName",
          value: "value",
          row: "row",
          column: "column",
          metadata: "metadata"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxTextHighlightDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTextSelectionDirective = /*#__PURE__*/(() => {
  class IgxTextSelectionDirective {
    /**
     * Returns the nativeElement of the element where the directive was applied.
     *
     * ```html
     * <input
     *   type="text"
     *   id="firstName"
     *   igxTextSelection>
     * </input>
     * ```
     *
     * ```typescript
     * @ViewChild('firstName',
     *  {read: IgxTextSelectionDirective})
     * public inputElement: IgxTextSelectionDirective;
     *
     * public getNativeElement() {
     *  return this.inputElement.nativeElement;
     * }
     * ```
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(element) {
      this.element = element;
      /**
       *  Determines whether the input element could be selected through the directive.
       *
       * ```html
       * <!--set-->
       * <input
       *   type="text"
       *   id="firstName"
       *   [igxTextSelection]="true">
       * </input>
       *
       * <input
       *   type="text"
       *   id="lastName"
       *   igxTextSelection
       *   [selected]="true">
       * </input>
       * ```
       */
      this.selected = true;
    }
    /**
     * @hidden
     */
    onFocus() {
      this.trigger();
    }
    /**
     * Triggers the selection of the element if it is marked as selectable.
     *
     * ```html
     * <input
     *   type="text"
     *   id="firstName"
     *   igxTextSelection>
     * </input>
     * ```
     *
     * ```typescript
     * @ViewChild('firstName',
     *  {read: IgxTextSelectionDirective})
     * public inputElement: IgxTextSelectionDirective;
     *
     * public triggerElementSelection() {
     *  this.inputElement.trigger();
     * }
     * ```
     */
    trigger() {
      if (this.selected && this.nativeElement.value.length) {
        // delay the select call to avoid race conditions in case the directive is applied
        // to an element with its own focus handler
        requestAnimationFrame(() => this.nativeElement.select());
      }
    }
    static {
      this.ɵfac = function IgxTextSelectionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTextSelectionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTextSelectionDirective,
        selectors: [["", "igxTextSelection", ""]],
        hostBindings: function IgxTextSelectionDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function IgxTextSelectionDirective_focus_HostBindingHandler() {
              return ctx.onFocus();
            });
          }
        },
        inputs: {
          selected: [2, "igxTextSelection", "selected", booleanAttribute]
        },
        exportAs: ["igxTextSelection"]
      });
    }
  }
  return IgxTextSelectionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxTemplateOutletDirective = /*#__PURE__*/(() => {
  class IgxTemplateOutletDirective {
    constructor(_viewContainerRef, _zone, cdr) {
      this._viewContainerRef = _viewContainerRef;
      this._zone = _zone;
      this.cdr = cdr;
      this.viewCreated = new EventEmitter();
      this.viewMoved = new EventEmitter();
      this.cachedViewLoaded = new EventEmitter();
      this.beforeViewDetach = new EventEmitter();
      /**
       * The embedded views cache. Collection is key-value paired.
       * Key is the template type, value is another key-value paired collection
       * where the key is the template id and value is the embedded view for the related template.
       */
      this._embeddedViewsMap = new Map();
    }
    ngOnChanges(changes) {
      const actionType = this._getActionType(changes);
      switch (actionType) {
        case TemplateOutletAction.CreateView:
          this._recreateView();
          break;
        case TemplateOutletAction.MoveView:
          this._moveView();
          break;
        case TemplateOutletAction.UseCachedView:
          this._useCachedView();
          break;
        case TemplateOutletAction.UpdateViewContext:
          this._updateExistingContext(this.igxTemplateOutletContext);
          break;
      }
    }
    cleanCache() {
      this._embeddedViewsMap.forEach(collection => {
        collection.forEach(item => {
          if (!item.destroyed) {
            item.destroy();
          }
        });
        collection.clear();
      });
      this._embeddedViewsMap.clear();
    }
    cleanView(tmplID) {
      const embViewCollection = this._embeddedViewsMap.get(tmplID.type);
      const embView = embViewCollection?.get(tmplID.id);
      if (embView) {
        embView.destroy();
        this._embeddedViewsMap.get(tmplID.type).delete(tmplID.id);
      }
    }
    _recreateView() {
      const prevIndex = this._viewRef ? this._viewContainerRef.indexOf(this._viewRef) : -1;
      // detach old and create new
      if (prevIndex !== -1) {
        this.beforeViewDetach.emit({
          owner: this,
          view: this._viewRef,
          context: this.igxTemplateOutletContext
        });
        this._viewContainerRef.detach(prevIndex);
      }
      if (this.igxTemplateOutlet) {
        this._viewRef = this._viewContainerRef.createEmbeddedView(this.igxTemplateOutlet, this.igxTemplateOutletContext);
        this.viewCreated.emit({
          owner: this,
          view: this._viewRef,
          context: this.igxTemplateOutletContext
        });
        const tmplId = this.igxTemplateOutletContext['templateID'];
        if (tmplId) {
          // if context contains a template id, check if we have a view for that template already stored in the cache
          // if not create a copy and add it to the cache in detached state.
          // Note: Views in detached state do not appear in the DOM, however they remain stored in memory.
          const resCollection = this._embeddedViewsMap.get(this.igxTemplateOutletContext['templateID'].type);
          const res = resCollection?.get(this.igxTemplateOutletContext['templateID'].id);
          if (!res) {
            this._embeddedViewsMap.set(this.igxTemplateOutletContext['templateID'].type, new Map([[this.igxTemplateOutletContext['templateID'].id, this._viewRef]]));
          }
        }
      }
    }
    _moveView() {
      // using external view and inserting it in current view.
      const view = this.igxTemplateOutletContext['moveView'];
      const owner = this.igxTemplateOutletContext['owner'];
      if (view !== this._viewRef) {
        if (owner._viewContainerRef.indexOf(view) !== -1) {
          // detach in case view it is attached somewhere else at the moment.
          this.beforeViewDetach.emit({
            owner: this,
            view: this._viewRef,
            context: this.igxTemplateOutletContext
          });
          owner._viewContainerRef.detach(owner._viewContainerRef.indexOf(view));
        }
        if (this._viewRef && this._viewContainerRef.indexOf(this._viewRef) !== -1) {
          this.beforeViewDetach.emit({
            owner: this,
            view: this._viewRef,
            context: this.igxTemplateOutletContext
          });
          this._viewContainerRef.detach(this._viewContainerRef.indexOf(this._viewRef));
        }
        this._viewRef = view;
        this._viewContainerRef.insert(view, 0);
        this._updateExistingContext(this.igxTemplateOutletContext);
        this.viewMoved.emit({
          owner: this,
          view: this._viewRef,
          context: this.igxTemplateOutletContext
        });
      } else {
        this._updateExistingContext(this.igxTemplateOutletContext);
      }
    }
    _useCachedView() {
      // use view for specific template cached in the current template outlet
      const tmplID = this.igxTemplateOutletContext['templateID'];
      const cachedView = tmplID ? this._embeddedViewsMap.get(tmplID.type)?.get(tmplID.id) : null;
      // if view exists, but template has been changed and there is a view in the cache with the related template
      // then detach old view and insert the stored one with the matching template
      // after that update its context.
      if (this._viewContainerRef.length > 0) {
        this.beforeViewDetach.emit({
          owner: this,
          view: this._viewRef,
          context: this.igxTemplateOutletContext
        });
        this._viewContainerRef.detach(this._viewContainerRef.indexOf(this._viewRef));
      }
      this._viewRef = cachedView;
      const oldContext = this._cloneContext(cachedView.context);
      this._viewContainerRef.insert(this._viewRef, 0);
      this._updateExistingContext(this.igxTemplateOutletContext);
      this.cachedViewLoaded.emit({
        owner: this,
        view: this._viewRef,
        context: this.igxTemplateOutletContext,
        oldContext
      });
    }
    _shouldRecreateView(changes) {
      const ctxChange = changes['igxTemplateOutletContext'];
      return !!changes['igxTemplateOutlet'] || ctxChange && this._hasContextShapeChanged(ctxChange);
    }
    _hasContextShapeChanged(ctxChange) {
      const prevCtxKeys = Object.keys(ctxChange.previousValue || {});
      const currCtxKeys = Object.keys(ctxChange.currentValue || {});
      if (prevCtxKeys.length === currCtxKeys.length) {
        for (const propName of currCtxKeys) {
          if (prevCtxKeys.indexOf(propName) === -1) {
            return true;
          }
        }
        return false;
      } else {
        return true;
      }
    }
    _updateExistingContext(ctx) {
      for (const propName of Object.keys(ctx)) {
        this._viewRef.context[propName] = this.igxTemplateOutletContext[propName];
      }
    }
    _cloneContext(ctx) {
      const clone = {};
      for (const propName of Object.keys(ctx)) {
        clone[propName] = ctx[propName];
      }
      return clone;
    }
    _getActionType(changes) {
      const movedView = this.igxTemplateOutletContext['moveView'];
      const tmplID = this.igxTemplateOutletContext['templateID'];
      const cachedView = tmplID ? this._embeddedViewsMap.get(tmplID.type)?.get(tmplID.id) : null;
      const shouldRecreate = this._shouldRecreateView(changes);
      if (movedView) {
        // view is moved from external source
        return TemplateOutletAction.MoveView;
      } else if (shouldRecreate && cachedView) {
        // should recreate (template or context change) and there is a matching template in cache
        return TemplateOutletAction.UseCachedView;
      } else if (!this._viewRef || shouldRecreate) {
        // no view or should recreate
        return TemplateOutletAction.CreateView;
      } else if (this.igxTemplateOutletContext) {
        // has context, update context
        return TemplateOutletAction.UpdateViewContext;
      }
    }
    static {
      this.ɵfac = function IgxTemplateOutletDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTemplateOutletDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTemplateOutletDirective,
        selectors: [["", "igxTemplateOutlet", ""]],
        inputs: {
          igxTemplateOutletContext: "igxTemplateOutletContext",
          igxTemplateOutlet: "igxTemplateOutlet"
        },
        outputs: {
          viewCreated: "viewCreated",
          viewMoved: "viewMoved",
          cachedViewLoaded: "cachedViewLoaded",
          beforeViewDetach: "beforeViewDetach"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxTemplateOutletDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TemplateOutletAction = /*#__PURE__*/function (TemplateOutletAction) {
  TemplateOutletAction[TemplateOutletAction["CreateView"] = 0] = "CreateView";
  TemplateOutletAction[TemplateOutletAction["MoveView"] = 1] = "MoveView";
  TemplateOutletAction[TemplateOutletAction["UseCachedView"] = 2] = "UseCachedView";
  TemplateOutletAction[TemplateOutletAction["UpdateViewContext"] = 3] = "UpdateViewContext";
  return TemplateOutletAction;
}(TemplateOutletAction || {});
let IgxToggleDirective = /*#__PURE__*/(() => {
  class IgxToggleDirective {
    /**
     * @hidden
     */
    get collapsed() {
      return this._collapsed;
    }
    /**
     * @hidden
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * @hidden
     */
    get hiddenClass() {
      return this.collapsed;
    }
    get hiddenWebkitClass() {
      const isSafari = this.platform?.isSafari;
      const browserVersion = this.platform?.browserVersion;
      return this.collapsed && isSafari && !!browserVersion && browserVersion < 17.5;
    }
    /**
     * @hidden
     */
    get defaultClass() {
      return !this.collapsed;
    }
    /**
     * @hidden
     */
    constructor(elementRef, cdr, overlayService, navigationService, platform) {
      this.elementRef = elementRef;
      this.cdr = cdr;
      this.overlayService = overlayService;
      this.navigationService = navigationService;
      this.platform = platform;
      /**
       * Emits an event after the toggle container is opened.
       *
       * ```typescript
       * onToggleOpened(event) {
       *    alert("Toggle opened!");
       * }
       * ```
       *
       * ```html
       * <div
       *   igxToggle
       *   (opened)='onToggleOpened($event)'>
       * </div>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emits an event before the toggle container is opened.
       *
       * ```typescript
       * onToggleOpening(event) {
       *  alert("Toggle opening!");
       * }
       * ```
       *
       * ```html
       * <div
       *   igxToggle
       *   (opening)='onToggleOpening($event)'>
       * </div>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emits an event after the toggle container is closed.
       *
       * ```typescript
       * onToggleClosed(event) {
       *  alert("Toggle closed!");
       * }
       * ```
       *
       * ```html
       * <div
       *   igxToggle
       *   (closed)='onToggleClosed($event)'>
       * </div>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * Emits an event before the toggle container is closed.
       *
       * ```typescript
       * onToggleClosing(event) {
       *  alert("Toggle closing!");
       * }
       * ```
       *
       * ```html
       * <div
       *  igxToggle
       *  (closing)='onToggleClosing($event)'>
       * </div>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emits an event after the toggle element is appended to the overlay container.
       *
       * ```typescript
       * onAppended() {
       *  alert("Content appended!");
       * }
       * ```
       *
       * ```html
       * <div
       *   igxToggle
       *   (appended)='onToggleAppended()'>
       * </div>
       * ```
       */
      this.appended = new EventEmitter();
      this._collapsed = true;
      this.destroy$ = new Subject();
      this._overlaySubFilter = [filter(x => x.id === this._overlayId), takeUntil(this.destroy$)];
      this.overlayClosed = e => {
        this._collapsed = true;
        this.cdr.detectChanges();
        this.unsubscribe();
        this.overlayService.detach(this.overlayId);
        const args = {
          owner: this,
          id: this._overlayId,
          event: e.event
        };
        delete this._overlayId;
        this.closed.emit(args);
        this.cdr.markForCheck();
      };
    }
    /**
     * Opens the toggle.
     *
     * ```typescript
     * this.myToggle.open();
     * ```
     */
    open(overlaySettings) {
      //  if there is open animation do nothing
      //  if toggle is not collapsed and there is no close animation do nothing
      const info = this.overlayService.getOverlayById(this._overlayId);
      const openAnimationStarted = info?.openAnimationPlayer?.hasStarted() ?? false;
      const closeAnimationStarted = info?.closeAnimationPlayer?.hasStarted() ?? false;
      if (openAnimationStarted || !(this._collapsed || closeAnimationStarted)) {
        return;
      }
      this._collapsed = false;
      this.cdr.detectChanges();
      if (!info) {
        this.unsubscribe();
        this.subscribe();
        this._overlayId = this.overlayService.attach(this.elementRef, overlaySettings);
      }
      const args = {
        cancel: false,
        owner: this,
        id: this._overlayId
      };
      this.opening.emit(args);
      if (args.cancel) {
        this.unsubscribe();
        this.overlayService.detach(this._overlayId);
        this._collapsed = true;
        delete this._overlayId;
        this.cdr.detectChanges();
        return;
      }
      this.overlayService.show(this._overlayId, overlaySettings);
    }
    /**
     * Closes the toggle.
     *
     * ```typescript
     * this.myToggle.close();
     * ```
     */
    close(event) {
      //  if toggle is collapsed do nothing
      //  if there is close animation do nothing, toggle will close anyway
      const info = this.overlayService.getOverlayById(this._overlayId);
      const closeAnimationStarted = info?.closeAnimationPlayer?.hasStarted() || false;
      if (this._collapsed || closeAnimationStarted) {
        return;
      }
      this.overlayService.hide(this._overlayId, event);
    }
    /**
     * Opens or closes the toggle, depending on its current state.
     *
     * ```typescript
     * this.myToggle.toggle();
     * ```
     */
    toggle(overlaySettings) {
      //  if toggle is collapsed call open
      //  if there is running close animation call open
      if (this.collapsed || this.isClosing) {
        this.open(overlaySettings);
      } else {
        this.close();
      }
    }
    /** @hidden @internal */
    get isClosing() {
      const info = this.overlayService.getOverlayById(this._overlayId);
      return info ? info.closeAnimationPlayer?.hasStarted() : false;
    }
    /**
     * Returns the id of the overlay the content is rendered in.
     * ```typescript
     * this.myToggle.overlayId;
     * ```
     */
    get overlayId() {
      return this._overlayId;
    }
    /**
     * Repositions the toggle.
     * ```typescript
     * this.myToggle.reposition();
     * ```
     */
    reposition() {
      this.overlayService.reposition(this._overlayId);
    }
    /**
     * Offsets the content along the corresponding axis by the provided amount with optional
     * offsetMode that determines whether to add (by default) or set the offset values with OffsetMode.Add and OffsetMode.Set
     */
    setOffset(deltaX, deltaY, offsetMode) {
      this.overlayService.setOffset(this._overlayId, deltaX, deltaY, offsetMode);
    }
    /**
     * @hidden
     */
    ngOnInit() {
      if (this.navigationService && this.id) {
        this.navigationService.add(this.id, this);
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      if (this.navigationService && this.id) {
        this.navigationService.remove(this.id);
      }
      if (this._overlayId) {
        this.overlayService.detach(this._overlayId);
      }
      this.unsubscribe();
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    subscribe() {
      this._overlayContentAppendedSub = this.overlayService.contentAppended.pipe(first$2(), takeUntil(this.destroy$)).subscribe(() => {
        const args = {
          owner: this,
          id: this._overlayId
        };
        this.appended.emit(args);
      });
      this._overlayOpenedSub = this.overlayService.opened.pipe(...this._overlaySubFilter).subscribe(() => {
        const args = {
          owner: this,
          id: this._overlayId
        };
        this.opened.emit(args);
      });
      this._overlayClosingSub = this.overlayService.closing.pipe(...this._overlaySubFilter).subscribe(e => {
        const args = {
          cancel: false,
          event: e.event,
          owner: this,
          id: this._overlayId
        };
        this.closing.emit(args);
        e.cancel = args.cancel;
        //  in case event is not canceled this will close the toggle and we need to unsubscribe.
        //  Otherwise if for some reason, e.g. close on outside click, close() gets called before
        //  closed was fired we will end with calling closing more than once
        if (!e.cancel) {
          this.clearSubscription(this._overlayClosingSub);
        }
      });
      this._overlayClosedSub = this.overlayService.closed.pipe(...this._overlaySubFilter).subscribe(this.overlayClosed);
    }
    unsubscribe() {
      this.clearSubscription(this._overlayOpenedSub);
      this.clearSubscription(this._overlayClosingSub);
      this.clearSubscription(this._overlayClosedSub);
      this.clearSubscription(this._overlayContentAppendedSub);
    }
    clearSubscription(subscription) {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function IgxToggleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxToggleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxNavigationService, 8), i0.ɵɵdirectiveInject(PlatformUtil, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxToggleDirective,
        selectors: [["", "igxToggle", ""]],
        hostVars: 7,
        hostBindings: function IgxToggleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-hidden", ctx.hiddenClass);
            i0.ɵɵclassProp("igx-toggle--hidden", ctx.hiddenClass)("igx-toggle--hidden-webkit", ctx.hiddenWebkitClass)("igx-toggle", ctx.defaultClass);
          }
        },
        inputs: {
          id: "id"
        },
        outputs: {
          opened: "opened",
          opening: "opening",
          closed: "closed",
          closing: "closing",
          appended: "appended"
        },
        exportAs: ["toggle"]
      });
    }
  }
  return IgxToggleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxToggleActionDirective = /*#__PURE__*/(() => {
  class IgxToggleActionDirective {
    /**
     * @hidden
     */
    set target(target) {
      if (target !== null && target !== '') {
        this._target = target;
      }
    }
    /**
     * @hidden
     */
    get target() {
      if (typeof this._target === 'string') {
        return this.navigationService.get(this._target);
      }
      return this._target;
    }
    constructor(element, navigationService) {
      this.element = element;
      this.navigationService = navigationService;
    }
    /**
     * @hidden
     */
    onClick() {
      if (this.outlet) {
        this._overlayDefaults.outlet = this.outlet;
      }
      const clonedSettings = Object.assign({}, this._overlayDefaults, this.overlaySettings);
      this.updateOverlaySettings(clonedSettings);
      this.target.toggle(clonedSettings);
    }
    /**
     * @hidden
     */
    ngOnInit() {
      const targetElement = this.element.nativeElement;
      this._overlayDefaults = {
        target: targetElement,
        positionStrategy: new ConnectedPositioningStrategy(),
        scrollStrategy: new AbsoluteScrollStrategy(),
        closeOnOutsideClick: true,
        modal: false,
        excludeFromOutsideClick: [targetElement]
      };
    }
    /**
     * Updates provided overlay settings
     *
     * @param settings settings to update
     * @returns returns updated copy of provided overlay settings
     */
    updateOverlaySettings(settings) {
      if (settings && settings.positionStrategy) {
        const positionStrategyClone = settings.positionStrategy.clone();
        settings.target = this.element.nativeElement;
        settings.positionStrategy = positionStrategyClone;
      }
      return settings;
    }
    static {
      this.ɵfac = function IgxToggleActionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxToggleActionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxNavigationService, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxToggleActionDirective,
        selectors: [["", "igxToggleAction", ""]],
        hostBindings: function IgxToggleActionDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxToggleActionDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          overlaySettings: "overlaySettings",
          outlet: [0, "igxToggleOutlet", "outlet"],
          target: [0, "igxToggleAction", "target"]
        },
        exportAs: ["toggle-action"]
      });
    }
  }
  return IgxToggleActionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Mark an element as an igxOverlay outlet container.
 * Directive instance is exported as `overlay-outlet` to be assigned to templates variables:
 * ```html
 * <div igxOverlayOutlet #outlet="overlay-outlet"></div>
 * ```
 */
let IgxOverlayOutletDirective = /*#__PURE__*/(() => {
  class IgxOverlayOutletDirective {
    constructor(element) {
      this.element = element;
    }
    /** @hidden */
    get nativeElement() {
      return this.element.nativeElement;
    }
    static {
      this.ɵfac = function IgxOverlayOutletDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxOverlayOutletDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxOverlayOutletDirective,
        selectors: [["", "igxOverlayOutlet", ""]],
        exportAs: ["overlay-outlet"]
      });
    }
  }
  return IgxOverlayOutletDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$t = 0;
/**
 * **Ignite UI for Angular Tooltip** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/tooltip)
 *
 * The Ignite UI for Angular Tooltip directive is used to mark an HTML element in the markup as one that should behave as a tooltip.
 * The tooltip is used in combination with the Ignite UI for Angular Tooltip Target by assigning the exported tooltip reference to the
 * respective target's selector property.
 *
 * Example:
 * ```html
 * <button type="button" igxButton [igxTooltipTarget]="tooltipRef">Hover me</button>
 * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
 * ```
 */
let IgxTooltipDirective = /*#__PURE__*/(() => {
  class IgxTooltipDirective extends IgxToggleDirective {
    /**
     * @hidden
     */
    get hiddenClass() {
      return this.collapsed;
    }
    /**
     * @hidden
     */
    get defaultClass() {
      return !this.collapsed;
    }
    /**
     * Get the role attribute of the tooltip.
     *
     * ```typescript
     * let tooltipRole = this.tooltip.role;
     * ```
     */
    get role() {
      return 'tooltip';
    }
    /** @hidden */
    constructor(elementRef, cdr, overlayService, navigationService) {
      // D.P. constructor duplication due to es6 compilation, might be obsolete in the future
      super(elementRef, cdr, overlayService, navigationService);
      /**
       * Identifier for the tooltip.
       * If this is property is not explicitly set, it will be automatically generated.
       *
       * ```typescript
       * let tooltipId = this.tooltip.id;
       * ```
       */
      this.id = `igx-tooltip-${NEXT_ID$t++}`;
      /**
       * @hidden
       * Returns whether close time out has started
       */
      this.toBeHidden = false;
      /**
       * @hidden
       * Returns whether open time out has started
       */
      this.toBeShown = false;
    }
    /**
     * If there is open animation in progress this method will finish is.
     * If there is no open animation in progress this method will open the toggle with no animation.
     *
     * @param overlaySettings setting to use for opening the toggle
     */
    forceOpen(overlaySettings) {
      const info = this.overlayService.getOverlayById(this._overlayId);
      const hasOpenAnimation = info ? info.openAnimationPlayer : false;
      if (hasOpenAnimation) {
        info.openAnimationPlayer.finish();
        info.openAnimationPlayer.reset();
        info.openAnimationPlayer = null;
      } else if (this.collapsed) {
        const animation = overlaySettings.positionStrategy.settings.openAnimation;
        overlaySettings.positionStrategy.settings.openAnimation = null;
        this.open(overlaySettings);
        overlaySettings.positionStrategy.settings.openAnimation = animation;
      }
    }
    /**
     * If there is close animation in progress this method will finish is.
     * If there is no close animation in progress this method will close the toggle with no animation.
     *
     * @param overlaySettings settings to use for closing the toggle
     */
    forceClose(overlaySettings) {
      const info = this.overlayService.getOverlayById(this._overlayId);
      const hasCloseAnimation = info ? info.closeAnimationPlayer : false;
      if (hasCloseAnimation) {
        info.closeAnimationPlayer.finish();
        info.closeAnimationPlayer.reset();
        info.closeAnimationPlayer = null;
      } else if (!this.collapsed) {
        const animation = overlaySettings.positionStrategy.settings.closeAnimation;
        overlaySettings.positionStrategy.settings.closeAnimation = null;
        this.close();
        overlaySettings.positionStrategy.settings.closeAnimation = animation;
      }
    }
    static {
      this.ɵfac = function IgxTooltipDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxNavigationService, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTooltipDirective,
        selectors: [["", "igxTooltip", ""]],
        hostVars: 6,
        hostBindings: function IgxTooltipDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role);
            i0.ɵɵclassProp("igx-tooltip--hidden", ctx.hiddenClass)("igx-tooltip", ctx.defaultClass);
          }
        },
        inputs: {
          context: "context",
          id: "id"
        },
        exportAs: ["tooltip"],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxTooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTooltipComponent = /*#__PURE__*/(() => {
  class IgxTooltipComponent {
    static {
      this.ɵfac = function IgxTooltipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTooltipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTooltipComponent,
        selectors: [["igx-tooltip"]],
        viewQuery: function IgxTooltipComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxTooltipDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
          }
        },
        decls: 2,
        vars: 1,
        consts: [["igxTooltip", ""]],
        template: function IgxTooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.content);
          }
        },
        dependencies: [IgxTooltipDirective],
        encapsulation: 2
      });
    }
  }
  return IgxTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * **Ignite UI for Angular Tooltip Target** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/tooltip)
 *
 * The Ignite UI for Angular Tooltip Target directive is used to mark an HTML element in the markup as one that has a tooltip.
 * The tooltip target is used in combination with the Ignite UI for Angular Tooltip by assigning the exported tooltip reference to the
 * target's selector property.
 *
 * Example:
 * ```html
 * <button type="button" igxButton [igxTooltipTarget]="tooltipRef">Hover me</button>
 * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
 * ```
 */
let IgxTooltipTargetDirective = /*#__PURE__*/(() => {
  class IgxTooltipTargetDirective extends IgxToggleActionDirective {
    /**
     * @hidden
     */
    set target(target) {
      if (target instanceof IgxTooltipDirective) {
        this._target = target;
      }
    }
    /**
     * @hidden
     */
    get target() {
      if (typeof this._target === 'string') {
        return this._navigationService.get(this._target);
      }
      return this._target;
    }
    /**
    * @hidden
    */
    set tooltip(content) {
      if (!this.target && (typeof content === 'string' || content instanceof String)) {
        const tooltipComponent = this._viewContainerRef.createComponent(IgxTooltipComponent);
        tooltipComponent.instance.content = content;
        this._target = tooltipComponent.instance.tooltip;
      }
    }
    /**
     * Gets the respective native element of the directive.
     *
     * ```typescript
     * let tooltipTargetElement = this.tooltipTarget.nativeElement;
     * ```
     */
    get nativeElement() {
      return this._element.nativeElement;
    }
    /**
     * Indicates if the tooltip that is is associated with this target is currently hidden.
     *
     * ```typescript
     * let tooltipHiddenValue = this.tooltipTarget.tooltipHidden;
     * ```
     */
    get tooltipHidden() {
      return !this.target || this.target.collapsed;
    }
    constructor(_element, _navigationService, _viewContainerRef) {
      super(_element, _navigationService);
      this._element = _element;
      this._navigationService = _navigationService;
      this._viewContainerRef = _viewContainerRef;
      /**
       * Gets/sets the amount of milliseconds that should pass before showing the tooltip.
       *
       * ```typescript
       * // get
       * let tooltipShowDelay = this.tooltipTarget.showDelay;
       * ```
       *
       * ```html
       * <!--set-->
       * <button type="button" igxButton [igxTooltipTarget]="tooltipRef" [showDelay]="1500">Hover me</button>
       * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
       * ```
       */
      this.showDelay = 500;
      /**
       * Gets/sets the amount of milliseconds that should pass before hiding the tooltip.
       *
       * ```typescript
       * // get
       * let tooltipHideDelay = this.tooltipTarget.hideDelay;
       * ```
       *
       * ```html
       * <!--set-->
       * <button type="button" igxButton [igxTooltipTarget]="tooltipRef" [hideDelay]="1500">Hover me</button>
       * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
       * ```
       */
      this.hideDelay = 500;
      /**
       * Specifies if the tooltip should not show when hovering its target with the mouse. (defaults to false)
       * While setting this property to 'true' will disable the user interactions that shows/hides the tooltip,
       * the developer will still be able to show/hide the tooltip through the API.
       *
       * ```typescript
       * // get
       * let tooltipDisabledValue = this.tooltipTarget.tooltipDisabled;
       * ```
       *
       * ```html
       * <!--set-->
       * <button type="button" igxButton [igxTooltipTarget]="tooltipRef" [tooltipDisabled]="true">Hover me</button>
       * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
       * ```
       */
      this.tooltipDisabled = false;
      /**
       * Emits an event when the tooltip that is associated with this target starts showing.
       * This event is fired before the start of the countdown to showing the tooltip.
       *
       * ```typescript
       * tooltipShowing(args: ITooltipShowEventArgs) {
       *    alert("Tooltip started showing!");
       * }
       * ```
       *
       * ```html
       * <button type="button" igxButton [igxTooltipTarget]="tooltipRef" (tooltipShow)='tooltipShowing($event)'>Hover me</button>
       * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
       * ```
       */
      this.tooltipShow = new EventEmitter();
      /**
       * Emits an event when the tooltip that is associated with this target starts hiding.
       * This event is fired before the start of the countdown to hiding the tooltip.
       *
       * ```typescript
       * tooltipHiding(args: ITooltipHideEventArgs) {
       *    alert("Tooltip started hiding!");
       * }
       * ```
       *
       * ```html
       * <button type="button" igxButton [igxTooltipTarget]="tooltipRef" (tooltipHide)='tooltipHiding($event)'>Hover me</button>
       * <span #tooltipRef="tooltip" igxTooltip>Hello there, I am a tooltip!</span>
       * ```
       */
      this.tooltipHide = new EventEmitter();
      this.destroy$ = new Subject();
    }
    /**
     * @hidden
     */
    onClick() {
      if (!this.target.collapsed) {
        this.target.forceClose(this.mergedOverlaySettings);
      }
    }
    /**
     * @hidden
     */
    onMouseEnter() {
      if (this.tooltipDisabled) {
        return;
      }
      this.checkOutletAndOutsideClick();
      const shouldReturn = this.preMouseEnterCheck();
      if (shouldReturn) {
        return;
      }
      const showingArgs = {
        target: this,
        tooltip: this.target,
        cancel: false
      };
      this.tooltipShow.emit(showingArgs);
      if (showingArgs.cancel) {
        return;
      }
      this.target.toBeShown = true;
      this.target.timeoutId = setTimeout(() => {
        this.target.open(this.mergedOverlaySettings); // Call open() of IgxTooltipDirective
        this.target.toBeShown = false;
      }, this.showDelay);
    }
    /**
     * @hidden
     */
    onMouseLeave() {
      if (this.tooltipDisabled) {
        return;
      }
      this.checkOutletAndOutsideClick();
      const shouldReturn = this.preMouseLeaveCheck();
      if (shouldReturn || this.target.collapsed) {
        return;
      }
      this.target.toBeHidden = true;
      this.target.timeoutId = setTimeout(() => {
        this.target.close(); // Call close() of IgxTooltipDirective
        this.target.toBeHidden = false;
      }, this.hideDelay);
    }
    /**
     * @hidden
     */
    onTouchStart() {
      if (this.tooltipDisabled) {
        return;
      }
      this.showTooltip();
    }
    /**
     * @hidden
     */
    onDocumentTouchStart(event) {
      if (this.tooltipDisabled) {
        return;
      }
      if (this.nativeElement !== event.target && !this.nativeElement.contains(event.target)) {
        this.hideTooltip();
      }
    }
    /**
     * @hidden
     */
    ngOnInit() {
      super.ngOnInit();
      const positionSettings = {
        horizontalDirection: HorizontalAlignment.Center,
        horizontalStartPoint: HorizontalAlignment.Center,
        openAnimation: useAnimation(scaleInCenter, {
          params: {
            duration: '150ms'
          }
        }),
        closeAnimation: useAnimation(fadeOut, {
          params: {
            duration: '75ms'
          }
        })
      };
      this._overlayDefaults.positionStrategy = new AutoPositionStrategy(positionSettings);
      this._overlayDefaults.closeOnOutsideClick = false;
      this._overlayDefaults.closeOnEscape = true;
      this.target.closing.pipe(takeUntil(this.destroy$)).subscribe(event => {
        const hidingArgs = {
          target: this,
          tooltip: this.target,
          cancel: false
        };
        this.tooltipHide.emit(hidingArgs);
        if (hidingArgs.cancel) {
          event.cancel = true;
        }
      });
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Shows the tooltip by respecting the 'showDelay' property.
     *
     * ```typescript
     * this.tooltipTarget.showTooltip();
     * ```
     */
    showTooltip() {
      clearTimeout(this.target.timeoutId);
      if (!this.target.collapsed) {
        //  if close animation has started finish it, or close the tooltip with no animation
        this.target.forceClose(this.mergedOverlaySettings);
        this.target.toBeHidden = false;
      }
      const showingArgs = {
        target: this,
        tooltip: this.target,
        cancel: false
      };
      this.tooltipShow.emit(showingArgs);
      if (showingArgs.cancel) {
        return;
      }
      this.target.toBeShown = true;
      this.target.timeoutId = setTimeout(() => {
        this.target.open(this.mergedOverlaySettings); // Call open() of IgxTooltipDirective
        this.target.toBeShown = false;
      }, this.showDelay);
    }
    /**
     * Hides the tooltip by respecting the 'hideDelay' property.
     *
     * ```typescript
     * this.tooltipTarget.hideTooltip();
     * ```
     */
    hideTooltip() {
      if (this.target.collapsed && this.target.toBeShown) {
        clearTimeout(this.target.timeoutId);
      }
      if (this.target.collapsed || this.target.toBeHidden) {
        return;
      }
      this.target.toBeHidden = true;
      this.target.timeoutId = setTimeout(() => {
        this.target.close(); // Call close() of IgxTooltipDirective
        this.target.toBeHidden = false;
      }, this.hideDelay);
    }
    checkOutletAndOutsideClick() {
      if (this.outlet) {
        this._overlayDefaults.outlet = this.outlet;
      }
    }
    get mergedOverlaySettings() {
      return Object.assign({}, this._overlayDefaults, this.overlaySettings);
    }
    // Return true if the execution in onMouseEnter should be terminated after this method
    preMouseEnterCheck() {
      // If tooltip is about to be opened
      if (this.target.toBeShown) {
        clearTimeout(this.target.timeoutId);
        this.target.toBeShown = false;
      }
      // If Tooltip is opened or about to be hidden
      if (!this.target.collapsed || this.target.toBeHidden) {
        clearTimeout(this.target.timeoutId);
        //  if close animation has started finish it, or close the tooltip with no animation
        this.target.forceClose(this.mergedOverlaySettings);
        this.target.toBeHidden = false;
      }
      return false;
    }
    // Return true if the execution in onMouseLeave should be terminated after this method
    preMouseLeaveCheck() {
      clearTimeout(this.target.timeoutId);
      // If tooltip is about to be opened
      if (this.target.toBeShown) {
        this.target.toBeShown = false;
        this.target.toBeHidden = false;
        return true;
      }
      return false;
    }
    static {
      this.ɵfac = function IgxTooltipTargetDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTooltipTargetDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxNavigationService, 8), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTooltipTargetDirective,
        selectors: [["", "igxTooltipTarget", ""]],
        hostBindings: function IgxTooltipTargetDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxTooltipTargetDirective_click_HostBindingHandler() {
              return ctx.onClick();
            })("mouseenter", function IgxTooltipTargetDirective_mouseenter_HostBindingHandler() {
              return ctx.onMouseEnter();
            })("mouseleave", function IgxTooltipTargetDirective_mouseleave_HostBindingHandler() {
              return ctx.onMouseLeave();
            })("touchstart", function IgxTooltipTargetDirective_touchstart_HostBindingHandler() {
              return ctx.onTouchStart();
            })("touchstart", function IgxTooltipTargetDirective_touchstart_HostBindingHandler($event) {
              return ctx.onDocumentTouchStart($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          showDelay: "showDelay",
          hideDelay: "hideDelay",
          tooltipDisabled: [2, "tooltipDisabled", "tooltipDisabled", booleanAttribute],
          target: [0, "igxTooltipTarget", "target"],
          tooltip: "tooltip"
        },
        outputs: {
          tooltipShow: "tooltipShow",
          tooltipHide: "tooltipHide"
        },
        exportAs: ["tooltipTarget"],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxTooltipTargetDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Tooltip directives collection for ease-of-use import in standalone components scenario */
const IGX_TOOLTIP_DIRECTIVES = [IgxTooltipDirective, IgxTooltipTargetDirective];

/**
 * Date Time Editor provides a functionality to input, edit and format date and time.
 *
 * @igxModule IgxDateTimeEditorModule
 *
 * @igxParent IgxInputGroup
 *
 * @igxTheme igx-input-theme
 *
 * @igxKeywords date, time, editor
 *
 * @igxGroup Scheduling
 *
 * @remarks
 *
 * The Ignite UI Date Time Editor Directive makes it easy for developers to manipulate date/time user input.
 * It requires input in a specified or default input format which is visible in the input element as a placeholder.
 * It allows the input of only date (ex: 'dd/MM/yyyy'), only time (ex:'HH:mm tt') or both at once, if needed.
 * Supports display format that may differ from the input format.
 * Provides methods to increment and decrement any specific/targeted `DatePart`.
 *
 * @example
 * ```html
 * <igx-input-group>
 *   <input type="text" igxInput [igxDateTimeEditor]="'dd/MM/yyyy'" [displayFormat]="'shortDate'" [(ngModel)]="date"/>
 * </igx-input-group>
 * ```
 */
let IgxDateTimeEditorDirective = /*#__PURE__*/(() => {
  class IgxDateTimeEditorDirective extends IgxMaskDirective {
    /**
     * Minimum value required for the editor to remain valid.
     *
     * @remarks
     * If a `string` value is passed, it must be in the defined input format.
     *
     * @example
     * ```html
     * <input igxDateTimeEditor [minValue]="minDate">
     * ```
     */
    get minValue() {
      return this._minValue;
    }
    set minValue(value) {
      this._minValue = value;
      this._onValidatorChange();
    }
    /**
     * Maximum value required for the editor to remain valid.
     *
     * @remarks
     * If a `string` value is passed in, it must be in the defined input format.
     *
     * @example
     * ```html
     * <input igxDateTimeEditor [maxValue]="maxDate">
     * ```
     */
    get maxValue() {
      return this._maxValue;
    }
    set maxValue(value) {
      this._maxValue = value;
      this._onValidatorChange();
    }
    /**
     * Set both pre-defined format options such as `shortDate` and `longDate`,
     * as well as constructed format string using characters supported by `DatePipe`, e.g. `EE/MM/yyyy`.
     *
     * @example
     * ```html
     * <input igxDateTimeEditor [displayFormat]="'shortDate'">
     * ```
     */
    set displayFormat(value) {
      this._displayFormat = value;
      this.updateDefaultFormat();
    }
    get displayFormat() {
      return this._displayFormat || this.inputFormat;
    }
    /**
     * Expected user input format (and placeholder).
     *
     * @example
     * ```html
     * <input [igxDateTimeEditor]="'dd/MM/yyyy'">
     * ```
     */
    set inputFormat(value) {
      if (value) {
        this.setMask(value);
        this._inputFormat = value;
      }
    }
    get inputFormat() {
      return this._inputFormat || this._defaultInputFormat;
    }
    /**
     * Editor value.
     *
     * @example
     * ```html
     * <input igxDateTimeEditor [value]="date">
     * ```
     */
    set value(value) {
      this._value = value;
      this.setDateValue(value);
      this.onChangeCallback(value);
      this.updateMask();
    }
    get value() {
      return this._value;
    }
    get datePartDeltas() {
      return Object.assign({}, this._datePartDeltas, this.spinDelta);
    }
    get emptyMask() {
      return this.maskParser.applyMask(null, this.maskOptions);
    }
    get targetDatePart() {
      // V.K. May 16th, 2022 #11554 Get correct date part in shadow DOM
      if (this.document.activeElement === this.nativeElement || this.document.activeElement?.shadowRoot?.activeElement === this.nativeElement) {
        return this._inputDateParts.find(p => p.start <= this.selectionStart && this.selectionStart <= p.end && p.type !== DatePart.Literal)?.type;
      } else {
        if (this._inputDateParts.some(p => p.type === DatePart.Date)) {
          return DatePart.Date;
        } else if (this._inputDateParts.some(p => p.type === DatePart.Hours)) {
          return DatePart.Hours;
        }
      }
    }
    get hasDateParts() {
      return this._inputDateParts.some(p => p.type === DatePart.Date || p.type === DatePart.Month || p.type === DatePart.Year);
    }
    get hasTimeParts() {
      return this._inputDateParts.some(p => p.type === DatePart.Hours || p.type === DatePart.Minutes || p.type === DatePart.Seconds || p.type === DatePart.FractionalSeconds);
    }
    get dateValue() {
      return this._dateValue;
    }
    constructor(renderer, elementRef, maskParser, platform, _document, _locale) {
      super(elementRef, maskParser, renderer, platform);
      this._document = _document;
      this._locale = _locale;
      /**
       * Specify if the currently spun date segment should loop over.
       *
       * @example
       * ```html
       * <input igxDateTimeEditor [spinLoop]="false">
       * ```
       */
      this.spinLoop = true;
      /**
       * Specify the default input format type. Defaults to `date`, which includes
       * only date parts for editing. Other valid options are `time` and `dateTime`.
       *
       * @example
       * ```html
       * <input igxDateTimeEditor [defaultFormatType]="'dateTime'">
       * ```
       */
      this.defaultFormatType = 'date';
      /**
       * Emitted when the editor's value has changed.
       *
       * @example
       * ```html
       * <input igxDateTimeEditor (valueChange)="valueChange($event)"/>
       * ```
       */
      this.valueChange = new EventEmitter();
      /**
       * Emitted when the editor is not within a specified range or when the editor's value is in an invalid state.
       *
       * @example
       * ```html
       * <input igxDateTimeEditor [minValue]="minDate" [maxValue]="maxDate" (validationFailed)="onValidationFailed($event)"/>
       * ```
       */
      this.validationFailed = new EventEmitter();
      this._datePartDeltas = {
        date: 1,
        month: 1,
        year: 1,
        hours: 1,
        minutes: 1,
        seconds: 1,
        fractionalSeconds: 1
      };
      this.onChangeCallback = noop;
      this._onValidatorChange = noop;
      this.document = this._document;
      this.locale = this.locale || this._locale;
    }
    onWheel(event) {
      if (!this._focused) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (event.deltaY > 0) {
        this.decrement();
      } else {
        this.increment();
      }
    }
    ngOnInit() {
      this.updateDefaultFormat();
      this.setMask(this.inputFormat);
      this.updateMask();
    }
    /** @hidden @internal */
    ngOnChanges(changes) {
      if (changes['locale'] && !changes['locale'].firstChange || changes['defaultFormatType'] && !changes['defaultFormatType'].firstChange) {
        this.updateDefaultFormat();
        this.setMask(this.inputFormat);
        this.updateMask();
      }
      if (changes['inputFormat'] && !changes['inputFormat'].firstChange) {
        this.updateMask();
      }
    }
    /** Clear the input element value. */
    clear() {
      this._onClear = true;
      this.updateValue(null);
      this.setSelectionRange(0, this.inputValue.length);
      this._onClear = false;
    }
    /**
     * Increment specified DatePart.
     *
     * @param datePart The optional DatePart to increment. Defaults to Date or Hours (when Date is absent from the inputFormat - ex:'HH:mm').
     * @param delta The optional delta to increment by. Overrides `spinDelta`.
     */
    increment(datePart, delta) {
      const targetPart = datePart || this.targetDatePart;
      if (!targetPart) {
        return;
      }
      const newValue = this.trySpinValue(targetPart, delta);
      this.updateValue(newValue);
    }
    /**
     * Decrement specified DatePart.
     *
     * @param datePart The optional DatePart to decrement. Defaults to Date or Hours (when Date is absent from the inputFormat - ex:'HH:mm').
     * @param delta The optional delta to decrement by. Overrides `spinDelta`.
     */
    decrement(datePart, delta) {
      const targetPart = datePart || this.targetDatePart;
      if (!targetPart) {
        return;
      }
      const newValue = this.trySpinValue(targetPart, delta, true);
      this.updateValue(newValue);
    }
    /** @hidden @internal */
    writeValue(value) {
      this._value = value;
      this.setDateValue(value);
      this.updateMask();
    }
    /** @hidden @internal */
    validate(control) {
      if (!control.value) {
        return null;
      }
      // InvalidDate handling
      if (isDate(control.value) && !DateTimeUtil.isValidDate(control.value)) {
        return {
          value: true
        };
      }
      let errors = {};
      const value = DateTimeUtil.isValidDate(control.value) ? control.value : DateTimeUtil.parseIsoDate(control.value);
      const minValueDate = DateTimeUtil.isValidDate(this.minValue) ? this.minValue : this.parseDate(this.minValue);
      const maxValueDate = DateTimeUtil.isValidDate(this.maxValue) ? this.maxValue : this.parseDate(this.maxValue);
      if (minValueDate || maxValueDate) {
        errors = DateTimeUtil.validateMinMax(value, minValueDate, maxValueDate, this.hasTimeParts, this.hasDateParts);
      }
      return Object.keys(errors).length > 0 ? errors : null;
    }
    /** @hidden @internal */
    registerOnValidatorChange(fn) {
      this._onValidatorChange = fn;
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this.onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    setDisabledState(_isDisabled) {}
    /** @hidden @internal */
    onCompositionEnd() {
      super.onCompositionEnd();
      this.updateValue(this.parseDate(this.inputValue));
      this.updateMask();
    }
    /** @hidden @internal */
    onInputChanged(event) {
      super.onInputChanged(event);
      if (this._composing) {
        return;
      }
      if (this.inputIsComplete()) {
        const parsedDate = this.parseDate(this.inputValue);
        if (DateTimeUtil.isValidDate(parsedDate)) {
          this.updateValue(parsedDate);
        } else {
          const oldValue = this.value && new Date(this.dateValue.getTime());
          const args = {
            oldValue,
            newValue: parsedDate,
            userInput: this.inputValue
          };
          this.validationFailed.emit(args);
          if (DateTimeUtil.isValidDate(args.newValue)) {
            this.updateValue(args.newValue);
          } else {
            this.updateValue(null);
          }
        }
      } else {
        this.updateValue(null);
      }
    }
    /** @hidden @internal */
    onKeyDown(event) {
      if (this.nativeElement.readOnly) {
        return;
      }
      super.onKeyDown(event);
      const key = event.key;
      if (event.altKey) {
        return;
      }
      if (key === this.platform.KEYMAP.ARROW_DOWN || key === this.platform.KEYMAP.ARROW_UP) {
        this.spin(event);
        return;
      }
      if (event.ctrlKey && key === this.platform.KEYMAP.SEMICOLON) {
        this.updateValue(new Date());
      }
      this.moveCursor(event);
    }
    /** @hidden @internal */
    onFocus() {
      if (this.nativeElement.readOnly) {
        return;
      }
      this._focused = true;
      this._onTouchedCallback();
      this.updateMask();
      super.onFocus();
      this.nativeElement.select();
    }
    /** @hidden @internal */
    onBlur(value) {
      this._focused = false;
      if (!this.inputIsComplete() && this.inputValue !== this.emptyMask) {
        this.updateValue(this.parseDate(this.inputValue));
      } else {
        this.updateMask();
      }
      // TODO: think of a better way to set displayValuePipe in mask directive
      if (this.displayValuePipe) {
        return;
      }
      super.onBlur(value);
    }
    // the date editor sets its own inputFormat as its placeholder if none is provided
    /** @hidden */
    setPlaceholder(_value) {}
    updateDefaultFormat() {
      this._defaultInputFormat = DateTimeUtil.getNumericInputFormat(this.locale, this._displayFormat) || DateTimeUtil.getDefaultInputFormat(this.locale, this.defaultFormatType);
      this.setMask(this.inputFormat);
    }
    updateMask() {
      if (this._focused) {
        // store the cursor position as it will be moved during masking
        const cursor = this.selectionEnd;
        this.inputValue = this.getMaskedValue();
        this.setSelectionRange(cursor);
      } else {
        if (!this.dateValue || !DateTimeUtil.isValidDate(this.dateValue)) {
          this.inputValue = '';
          return;
        }
        if (this.displayValuePipe) {
          // TODO: remove when formatter func has been deleted
          this.inputValue = this.displayValuePipe.transform(this.value);
          return;
        }
        const format = this.displayFormat || this.inputFormat;
        if (format) {
          this.inputValue = DateTimeUtil.formatDate(this.dateValue, format.replace('tt', 'aa'), this.locale);
        } else {
          this.inputValue = this.dateValue.toLocaleString();
        }
      }
    }
    setMask(inputFormat) {
      const oldFormat = this._inputDateParts?.map(p => p.format).join('');
      this._inputDateParts = DateTimeUtil.parseDateTimeFormat(inputFormat);
      inputFormat = this._inputDateParts.map(p => p.format).join('');
      const mask = (inputFormat || this._defaultInputFormat).replace(new RegExp(/(?=[^at])[\w]/, 'g'), '0');
      this.mask = mask.replaceAll(/(a{1,2})|tt/g, match => 'L'.repeat(match.length === 1 ? 1 : 2));
      const placeholder = this.nativeElement.placeholder;
      if (!placeholder || oldFormat === placeholder) {
        this.renderer.setAttribute(this.nativeElement, 'placeholder', inputFormat);
      }
    }
    parseDate(val) {
      if (!val) {
        return null;
      }
      return DateTimeUtil.parseValueFromMask(val, this._inputDateParts, this.promptChar);
    }
    getMaskedValue() {
      let mask = this.emptyMask;
      if (DateTimeUtil.isValidDate(this.value) || DateTimeUtil.parseIsoDate(this.value)) {
        for (const part of this._inputDateParts) {
          if (part.type === DatePart.Literal) {
            continue;
          }
          const targetValue = this.getPartValue(part, part.format.length);
          mask = this.maskParser.replaceInMask(mask, targetValue, this.maskOptions, part.start, part.end).value;
        }
        return mask;
      }
      if (!this.inputIsComplete() || !this._onClear) {
        return this.inputValue;
      }
      return mask;
    }
    valueInRange(value) {
      if (!value) {
        return false;
      }
      let errors = {};
      const minValueDate = DateTimeUtil.isValidDate(this.minValue) ? this.minValue : this.parseDate(this.minValue);
      const maxValueDate = DateTimeUtil.isValidDate(this.maxValue) ? this.maxValue : this.parseDate(this.maxValue);
      if (minValueDate || maxValueDate) {
        errors = DateTimeUtil.validateMinMax(value, this.minValue, this.maxValue, this.hasTimeParts, this.hasDateParts);
      }
      return Object.keys(errors).length === 0;
    }
    spinValue(datePart, delta) {
      if (!this.dateValue || !DateTimeUtil.isValidDate(this.dateValue)) {
        return null;
      }
      const newDate = new Date(this.dateValue.getTime());
      switch (datePart) {
        case DatePart.Date:
          DateTimeUtil.spinDate(delta, newDate, this.spinLoop);
          break;
        case DatePart.Month:
          DateTimeUtil.spinMonth(delta, newDate, this.spinLoop);
          break;
        case DatePart.Year:
          DateTimeUtil.spinYear(delta, newDate);
          break;
        case DatePart.Hours:
          DateTimeUtil.spinHours(delta, newDate, this.spinLoop);
          break;
        case DatePart.Minutes:
          DateTimeUtil.spinMinutes(delta, newDate, this.spinLoop);
          break;
        case DatePart.Seconds:
          DateTimeUtil.spinSeconds(delta, newDate, this.spinLoop);
          break;
        case DatePart.FractionalSeconds:
          DateTimeUtil.spinFractionalSeconds(delta, newDate, this.spinLoop);
          break;
        case DatePart.AmPm:
          const formatPart = this._inputDateParts.find(dp => dp.type === DatePart.AmPm);
          const amPmFromMask = this.inputValue.substring(formatPart.start, formatPart.end);
          return DateTimeUtil.spinAmPm(newDate, this.dateValue, amPmFromMask);
      }
      return newDate;
    }
    trySpinValue(datePart, delta, negative = false) {
      if (!delta) {
        // default to 1 if a delta is set to 0 or any other falsy value
        delta = this.datePartDeltas[datePart] || 1;
      }
      const spinValue = negative ? -Math.abs(delta) : Math.abs(delta);
      return this.spinValue(datePart, spinValue) || new Date();
    }
    setDateValue(value) {
      this._dateValue = DateTimeUtil.isValidDate(value) ? value : DateTimeUtil.parseIsoDate(value);
    }
    updateValue(newDate) {
      this._oldValue = this.dateValue;
      this.value = newDate;
      // TODO: should we emit events here?
      if (this.inputIsComplete() || this.inputValue === this.emptyMask) {
        this.valueChange.emit(this.dateValue);
      }
      if (this.dateValue && !this.valueInRange(this.dateValue)) {
        this.validationFailed.emit({
          oldValue: this._oldValue,
          newValue: this.dateValue,
          userInput: this.inputValue
        });
      }
    }
    toTwelveHourFormat(value) {
      let hour = parseInt(value.replace(new RegExp(this.promptChar, 'g'), '0'), 10);
      if (hour > 12) {
        hour -= 12;
      } else if (hour === 0) {
        hour = 12;
      }
      return hour;
    }
    getPartValue(datePartInfo, partLength) {
      let maskedValue;
      const datePart = datePartInfo.type;
      switch (datePart) {
        case DatePart.Date:
          maskedValue = this.dateValue.getDate();
          break;
        case DatePart.Month:
          // months are zero based
          maskedValue = this.dateValue.getMonth() + 1;
          break;
        case DatePart.Year:
          if (partLength === 2) {
            maskedValue = this.prependValue(parseInt(this.dateValue.getFullYear().toString().slice(-2), 10), partLength, '0');
          } else {
            maskedValue = this.dateValue.getFullYear();
          }
          break;
        case DatePart.Hours:
          if (datePartInfo.format.indexOf('h') !== -1) {
            maskedValue = this.prependValue(this.toTwelveHourFormat(this.dateValue.getHours().toString()), partLength, '0');
          } else {
            maskedValue = this.dateValue.getHours();
          }
          break;
        case DatePart.Minutes:
          maskedValue = this.dateValue.getMinutes();
          break;
        case DatePart.Seconds:
          maskedValue = this.dateValue.getSeconds();
          break;
        case DatePart.FractionalSeconds:
          partLength = 3;
          maskedValue = this.prependValue(this.dateValue.getMilliseconds(), 3, '00');
          break;
        case DatePart.AmPm:
          maskedValue = DateTimeUtil.getAmPmValue(partLength, this.dateValue.getHours() < 12);
          break;
      }
      if (datePartInfo.type !== DatePart.AmPm) {
        return this.prependValue(maskedValue, partLength, '0');
      }
      return maskedValue;
    }
    prependValue(value, partLength, prependChar) {
      return (prependChar + value.toString()).slice(-partLength);
    }
    spin(event) {
      event.preventDefault();
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_UP:
          this.increment();
          break;
        case this.platform.KEYMAP.ARROW_DOWN:
          this.decrement();
          break;
      }
    }
    inputIsComplete() {
      return this.inputValue.indexOf(this.promptChar) === -1;
    }
    moveCursor(event) {
      const value = event.target.value;
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_LEFT:
          if (event.ctrlKey) {
            event.preventDefault();
            this.setSelectionRange(this.getNewPosition(value));
          }
          break;
        case this.platform.KEYMAP.ARROW_RIGHT:
          if (event.ctrlKey) {
            event.preventDefault();
            this.setSelectionRange(this.getNewPosition(value, 1));
          }
          break;
      }
    }
    /**
     * Move the cursor in a specific direction until it reaches a date/time separator.
     * Then return its index.
     *
     * @param value The string it operates on.
     * @param direction 0 is left, 1 is right. Default is 0.
     */
    getNewPosition(value, direction = 0) {
      const literals = this._inputDateParts.filter(p => p.type === DatePart.Literal);
      let cursorPos = this.selectionStart;
      if (!direction) {
        do {
          cursorPos = cursorPos > 0 ? --cursorPos : cursorPos;
        } while (!literals.some(l => l.end === cursorPos) && cursorPos > 0);
        return cursorPos;
      } else {
        do {
          cursorPos++;
        } while (!literals.some(l => l.start === cursorPos) && cursorPos < value.length);
        return cursorPos;
      }
    }
    static {
      this.ɵfac = function IgxDateTimeEditorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDateTimeEditorDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(MaskParsingService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(LOCALE_ID));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDateTimeEditorDirective,
        selectors: [["", "igxDateTimeEditor", ""]],
        hostBindings: function IgxDateTimeEditorDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("wheel", function IgxDateTimeEditorDirective_wheel_HostBindingHandler($event) {
              return ctx.onWheel($event);
            });
          }
        },
        inputs: {
          locale: "locale",
          minValue: "minValue",
          maxValue: "maxValue",
          spinLoop: [2, "spinLoop", "spinLoop", booleanAttribute],
          displayFormat: "displayFormat",
          inputFormat: [0, "igxDateTimeEditor", "inputFormat"],
          value: "value",
          defaultFormatType: "defaultFormatType",
          spinDelta: "spinDelta"
        },
        outputs: {
          valueChange: "valueChange",
          validationFailed: "validationFailed"
        },
        exportAs: ["igxDateTimeEditor"],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxDateTimeEditorDirective,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: IgxDateTimeEditorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return IgxDateTimeEditorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgcFormControlDirective = /*#__PURE__*/(() => {
  class IgcFormControlDirective {
    constructor(elementRef, renderer) {
      this.elementRef = elementRef;
      this.renderer = renderer;
      /** @hidden @internal */
      this.onChange = () => {};
      /** @hidden @internal */
      this.onTouched = () => {};
    }
    /** @hidden @internal */
    onBlur() {
      this.onTouched();
    }
    /** @hidden @internal */
    listenForValueChange(value) {
      this.onChange(value);
    }
    /** @hidden @internal */
    writeValue(value) {
      if (value) {
        this.elementRef.nativeElement.value = value;
      }
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this.onChange = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }
    static {
      this.ɵfac = function IgcFormControlDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgcFormControlDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgcFormControlDirective,
        selectors: [["igc-rating", "ngModel", ""], ["igc-rating", "formControlName", ""]],
        hostBindings: function IgcFormControlDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function IgcFormControlDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("igcChange", function IgcFormControlDirective_igcChange_HostBindingHandler($event) {
              return ctx.listenForValueChange($event.detail);
            });
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => IgcFormControlDirective),
          multi: true
        }])]
      });
    }
  }
  return IgcFormControlDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
class GroupedRecords extends Array {}

/** @hidden */
const IGX_EXPANSION_PANEL_COMPONENT = /*@__PURE__*/new InjectionToken('IgxExpansionPanelToken');
let HeaderContentBaseDirective = /*#__PURE__*/(() => {
  class HeaderContentBaseDirective {
    constructor(element) {
      this.element = element;
      /**
       * Returns the `textContent` of an element
       *
       * ```html
       * <igx-expansion-panel-title>
       *  Tooltip content
       * </igx-expansion-panel-title>
       * ```
       *
       *  or the `title` content
       *
       * ```html
       * <igx-expansion-panel-title [title]="'Tooltip content'">
       * </igx-expansion-panel-title>
       * ```
       *
       * If both are provided, returns the `title` content.
       *
       * @param element
       * @returns tooltip content for an element
       */
      this.getTooltipContent = element => {
        if (element.nativeElement.title) {
          return element.nativeElement.title;
        }
        if (element.nativeElement.textContent) {
          return element.nativeElement.textContent.trim();
        }
        return null;
      };
    }
    static {
      this.ɵfac = function HeaderContentBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderContentBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: HeaderContentBaseDirective
      });
    }
  }
  return HeaderContentBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxExpansionPanelBodyComponent = /*#__PURE__*/(() => {
  class IgxExpansionPanelBodyComponent {
    constructor(panel, element, cdr) {
      this.panel = panel;
      this.element = element;
      this.cdr = cdr;
      /**
       * @hidden
       */
      this.cssClass = `igx-expansion-panel__body`;
      /**
       * Gets/sets the `role` attribute of the panel body
       * Default is 'region';
       * Get
       * ```typescript
       *  const currentRole = this.panel.body.role;
       * ```
       * Set
       * ```typescript
       *  this.panel.body.role = 'content';
       * ```
       * ```html
       *  <igx-expansion-panel-body [role]="'custom'"></igx-expansion-panel-body>
       * ```
       */
      this.role = 'region';
      this._labelledBy = '';
      this._label = '';
    }
    /**
     * Gets the `aria-label` attribute of the panel body
     * Defaults to the panel id with '-region' in the end;
     * Get
     * ```typescript
     *  const currentLabel = this.panel.body.label;
     * ```
     */
    get label() {
      return this._label || this.panel.id + '-region';
    }
    /**
     * Sets the `aria-label` attribute of the panel body
     * ```typescript
     *  this.panel.body.label = 'my-custom-label';
     * ```
     * ```html
     *  <igx-expansion-panel-body [label]="'my-custom-label'"></igx-expansion-panel-body>
     * ```
     */
    set label(val) {
      this._label = val;
    }
    /**
     * Gets the `aria-labelledby` attribute of the panel body
     * Defaults to the panel header id;
     * Get
     * ```typescript
     *  const currentLabel = this.panel.body.labelledBy;
     * ```
     */
    get labelledBy() {
      return this._labelledBy;
    }
    /**
     * Sets the `aria-labelledby` attribute of the panel body
     * ```typescript
     *  this.panel.body.labelledBy = 'my-custom-id';
     * ```
     * ```html
     *  <igx-expansion-panel-body [labelledBy]="'my-custom-id'"></igx-expansion-panel-body>
     * ```
     */
    set labelledBy(val) {
      this._labelledBy = val;
    }
    static {
      this.ɵfac = function IgxExpansionPanelBodyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExpansionPanelBodyComponent)(i0.ɵɵdirectiveInject(IGX_EXPANSION_PANEL_COMPONENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExpansionPanelBodyComponent,
        selectors: [["igx-expansion-panel-body"]],
        hostVars: 5,
        hostBindings: function IgxExpansionPanelBodyComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("aria-label", ctx.label)("aria-labelledby", ctx.labelledBy);
            i0.ɵɵclassProp("igx-expansion-panel__body", ctx.cssClass);
          }
        },
        inputs: {
          role: "role",
          label: "label",
          labelledBy: "labelledBy"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxExpansionPanelBodyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxExpansionPanelBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let IgxExpansionPanelTitleDirective = /*#__PURE__*/(() => {
  class IgxExpansionPanelTitleDirective extends HeaderContentBaseDirective {
    constructor() {
      super(...arguments);
      this.cssClass = `igx-expansion-panel__header-title`;
    }
    get title() {
      return this.getTooltipContent(this.element);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxExpansionPanelTitleDirective_BaseFactory;
        return function IgxExpansionPanelTitleDirective_Factory(__ngFactoryType__) {
          return (ɵIgxExpansionPanelTitleDirective_BaseFactory || (ɵIgxExpansionPanelTitleDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxExpansionPanelTitleDirective)))(__ngFactoryType__ || IgxExpansionPanelTitleDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExpansionPanelTitleDirective,
        selectors: [["igx-expansion-panel-title"]],
        hostVars: 3,
        hostBindings: function IgxExpansionPanelTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("title", ctx.title);
            i0.ɵɵclassProp("igx-expansion-panel__header-title", ctx.cssClass);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxExpansionPanelTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxExpansionPanelDescriptionDirective = /*#__PURE__*/(() => {
  class IgxExpansionPanelDescriptionDirective extends HeaderContentBaseDirective {
    constructor() {
      super(...arguments);
      this.cssClass = `igx-expansion-panel__header-description`;
    }
    get title() {
      return this.getTooltipContent(this.element);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxExpansionPanelDescriptionDirective_BaseFactory;
        return function IgxExpansionPanelDescriptionDirective_Factory(__ngFactoryType__) {
          return (ɵIgxExpansionPanelDescriptionDirective_BaseFactory || (ɵIgxExpansionPanelDescriptionDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxExpansionPanelDescriptionDirective)))(__ngFactoryType__ || IgxExpansionPanelDescriptionDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExpansionPanelDescriptionDirective,
        selectors: [["igx-expansion-panel-description"]],
        hostVars: 3,
        hostBindings: function IgxExpansionPanelDescriptionDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("title", ctx.title);
            i0.ɵɵclassProp("igx-expansion-panel__header-description", ctx.cssClass);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxExpansionPanelDescriptionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxExpansionPanelIconDirective = /*#__PURE__*/(() => {
  class IgxExpansionPanelIconDirective {
    static {
      this.ɵfac = function IgxExpansionPanelIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExpansionPanelIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExpansionPanelIconDirective,
        selectors: [["igx-expansion-panel-icon"]]
      });
    }
  }
  return IgxExpansionPanelIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
const ExpansionPanelHeaderIconPosition = /*@__PURE__*/mkenum({
  LEFT: 'left',
  NONE: 'none',
  RIGHT: 'right'
});
let IgxExpansionPanelHeaderComponent = /*#__PURE__*/(() => {
  class IgxExpansionPanelHeaderComponent {
    /**
     * Returns a reference to the `igx-expansion-panel-icon` element;
     * If `iconPosition` is `NONE` - return null;
     */
    get iconRef() {
      const renderedTemplate = this.customIconRef ?? this.defaultIconRef;
      return this.iconPosition !== ExpansionPanelHeaderIconPosition.NONE ? renderedTemplate : null;
    }
    /**
     * @hidden
     */
    set iconTemplate(val) {
      this._iconTemplate = val;
    }
    /**
     * @hidden
     */
    get iconTemplate() {
      return this._iconTemplate;
    }
    /**
     * @hidden
     */
    get controls() {
      return this.panel.id;
    }
    /**
     * @hidden @internal
     */
    get innerElement() {
      return this.elementRef.nativeElement.children[0];
    }
    /**
     * @hidden
     */
    get isExpanded() {
      return !this.panel.collapsed;
    }
    /**
     * Gets/sets the whether the header is disabled
     * When disabled, the header will not handle user events and will stop their propagation
     *
     * ```typescript
     *  const isDisabled = this.panel.header.disabled;
     * ```
     * Set
     * ```typescript
     *  this.panel.header.disabled = true;
     * ```
     * ```html
     *  <igx-expansion-panel-header [disabled]="true">
     *     ...
     *  </igx-expansion-panel-header>
     * ```
     */
    get disabled() {
      return this._disabled;
    }
    set disabled(val) {
      this._disabled = val;
      if (val) {
        // V.S. June 11th, 2021: #9696 TabIndex should be removed when panel is disabled
        delete this.tabIndex;
      } else {
        this.tabIndex = 0;
      }
    }
    constructor(panel, cdr, elementRef) {
      this.panel = panel;
      this.cdr = cdr;
      this.elementRef = elementRef;
      /**
       * Gets/sets the `aria-level` attribute of the header
       * Get
       * ```typescript
       *  const currentAriaLevel = this.panel.header.lv;
       * ```
       * Set
       * ```typescript
       *  this.panel.header.lv = '5';
       * ```
       * ```html
       *  <igx-expansion-panel-header [lv]="myCustomLevel"></igx-expansion-panel-header>
       * ```
       */
      this.lv = '3';
      /**
       * Gets/sets the `role` attribute of the header
       * Get
       * ```typescript
       *  const currentRole = this.panel.header.role;
       * ```
       * Set
       * ```typescript
       *  this.panel.header.role = '5';
       * ```
       * ```html
       *  <igx-expansion-panel-header [role]="'custom'"></igx-expansion-panel-header>
       * ```
       */
      this.role = 'heading';
      /**
       * Gets/sets the position of the expansion-panel-header expand/collapse icon
       * Accepts `left`, `right` or `none`
       * ```typescript
       *  const currentIconPosition = this.panel.header.iconPosition;
       * ```
       * Set
       * ```typescript
       *  this.panel.header.iconPosition = 'left';
       * ```
       * ```html
       *  <igx-expansion-panel-header [iconPosition]="'right'"></igx-expansion-panel-header>
       * ```
       */
      this.iconPosition = ExpansionPanelHeaderIconPosition.LEFT;
      /**
       * Emitted whenever a user interacts with the header host
       * ```typescript
       *  handleInteraction(event: IExpansionPanelCancelableEventArgs) {
       *  ...
       * }
       * ```
       * ```html
       *  <igx-expansion-panel-header (interaction)="handleInteraction($event)">
       *      ...
       *  </igx-expansion-panel-header>
       * ```
       */
      this.interaction = new EventEmitter();
      /**
       * @hidden
       */
      this.cssClass = 'igx-expansion-panel__header';
      /**
       * Sets/gets the `id` of the expansion panel header.
       * ```typescript
       * let panelHeaderId =  this.panel.header.id;
       * ```
       *
       * @memberof IgxExpansionPanelComponent
       */
      this.id = '';
      /** @hidden @internal */
      this.tabIndex = 0;
      // properties section
      this._iconTemplate = false;
      this._disabled = false;
      this.id = `${this.panel.id}-header`;
    }
    /**
     * @hidden
     */
    onAction(evt) {
      if (this.disabled) {
        evt.stopPropagation();
        return;
      }
      const eventArgs = {
        event: evt,
        owner: this.panel,
        cancel: false
      };
      this.interaction.emit(eventArgs);
      if (eventArgs.cancel === true) {
        return;
      }
      this.panel.toggle(evt);
      evt.preventDefault();
    }
    /** @hidden @internal */
    openPanel(event) {
      if (event.altKey) {
        const eventArgs = {
          event,
          owner: this.panel,
          cancel: false
        };
        this.interaction.emit(eventArgs);
        if (eventArgs.cancel === true) {
          return;
        }
        this.panel.expand(event);
      }
    }
    /** @hidden @internal */
    closePanel(event) {
      if (event.altKey) {
        const eventArgs = {
          event,
          owner: this.panel,
          cancel: false
        };
        this.interaction.emit(eventArgs);
        if (eventArgs.cancel === true) {
          return;
        }
        this.panel.collapse(event);
      }
    }
    /**
     * @hidden
     */
    get iconPositionClass() {
      switch (this.iconPosition) {
        case ExpansionPanelHeaderIconPosition.LEFT:
          return `igx-expansion-panel__header-icon--start`;
        case ExpansionPanelHeaderIconPosition.RIGHT:
          return `igx-expansion-panel__header-icon--end`;
        case ExpansionPanelHeaderIconPosition.NONE:
          return `igx-expansion-panel__header-icon--none`;
        default:
          return '';
      }
    }
    static {
      this.ɵfac = function IgxExpansionPanelHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExpansionPanelHeaderComponent)(i0.ɵɵdirectiveInject(IGX_EXPANSION_PANEL_COMPONENT, 1), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExpansionPanelHeaderComponent,
        selectors: [["igx-expansion-panel-header"]],
        contentQueries: function IgxExpansionPanelHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxExpansionPanelIconDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxExpansionPanelIconDirective, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customIconRef = _t.first);
          }
        },
        viewQuery: function IgxExpansionPanelHeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxIconComponent, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultIconRef = _t.first);
          }
        },
        hostVars: 8,
        hostBindings: function IgxExpansionPanelHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.Enter", function IgxExpansionPanelHeaderComponent_keydown_Enter_HostBindingHandler($event) {
              return ctx.onAction($event);
            })("keydown.Space", function IgxExpansionPanelHeaderComponent_keydown_Space_HostBindingHandler($event) {
              return ctx.onAction($event);
            })("keydown.Spacebar", function IgxExpansionPanelHeaderComponent_keydown_Spacebar_HostBindingHandler($event) {
              return ctx.onAction($event);
            })("click", function IgxExpansionPanelHeaderComponent_click_HostBindingHandler($event) {
              return ctx.onAction($event);
            })("keydown.Alt.ArrowDown", function IgxExpansionPanelHeaderComponent_keydown_Alt_ArrowDown_HostBindingHandler($event) {
              return ctx.openPanel($event);
            })("keydown.Alt.ArrowUp", function IgxExpansionPanelHeaderComponent_keydown_Alt_ArrowUp_HostBindingHandler($event) {
              return ctx.closePanel($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-level", ctx.lv)("role", ctx.role);
            i0.ɵɵclassProp("igx-expansion-panel__header", ctx.cssClass)("igx-expansion-panel__header--expanded", ctx.isExpanded)("igx-expansion-panel--disabled", ctx.disabled);
          }
        },
        inputs: {
          lv: "lv",
          role: "role",
          iconPosition: "iconPosition",
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        outputs: {
          interaction: "interaction"
        },
        ngContentSelectors: _c11,
        decls: 8,
        vars: 9,
        consts: [["role", "button", 1, "igx-expansion-panel__header-inner"], [1, "igx-expansion-panel__title-wrapper"], ["family", "default", 3, "name"]],
        template: function IgxExpansionPanelHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c10);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4, 2);
            i0.ɵɵelementStart(5, "div");
            i0.ɵɵtemplate(6, IgxExpansionPanelHeaderComponent_Conditional_6_Template, 1, 0)(7, IgxExpansionPanelHeaderComponent_Conditional_7_Template, 1, 2, "igx-icon", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabIndex)("id", ctx.id)("aria-disabled", ctx.disabled)("aria-expanded", ctx.isExpanded)("aria-controls", ctx.controls);
            i0.ɵɵadvance(5);
            i0.ɵɵclassMap(ctx.iconPositionClass);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.iconTemplate ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.iconTemplate ? 7 : -1);
          }
        },
        dependencies: [IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExpansionPanelHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
var ANIMATION_TYPE = /*#__PURE__*/function (ANIMATION_TYPE) {
  ANIMATION_TYPE["OPEN"] = "open";
  ANIMATION_TYPE["CLOSE"] = "close";
  return ANIMATION_TYPE;
}(ANIMATION_TYPE || {});
/**@hidden @internal */
let ToggleAnimationPlayer = /*#__PURE__*/(() => {
  class ToggleAnimationPlayer {
    get animationSettings() {
      return this._animationSettings;
    }
    set animationSettings(value) {
      this._animationSettings = value;
    }
    constructor(animationService) {
      this.animationService = animationService;
      /** @hidden @internal */
      this.openAnimationDone = new EventEmitter();
      /** @hidden @internal */
      this.closeAnimationDone = new EventEmitter();
      /** @hidden @internal */
      this.openAnimationStart = new EventEmitter();
      /** @hidden @internal */
      this.closeAnimationStart = new EventEmitter();
      /** @hidden @internal */
      this.openAnimationPlayer = null;
      /** @hidden @internal */
      this.closeAnimationPlayer = null;
      this.destroy$ = new Subject();
      this.players = new Map();
      this._animationSettings = {
        openAnimation: growVerIn,
        closeAnimation: growVerOut
      };
      this.closeInterrupted = false;
      this.openInterrupted = false;
      this._defaultClosedCallback = noop;
      this._defaultOpenedCallback = noop;
      this.onClosedCallback = this._defaultClosedCallback;
      this.onOpenedCallback = this._defaultOpenedCallback;
    }
    /** @hidden @internal */
    playOpenAnimation(targetElement, onDone) {
      this.startPlayer(ANIMATION_TYPE.OPEN, targetElement, onDone || this._defaultOpenedCallback);
    }
    /** @hidden @internal */
    playCloseAnimation(targetElement, onDone) {
      this.startPlayer(ANIMATION_TYPE.CLOSE, targetElement, onDone || this._defaultClosedCallback);
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    startPlayer(type, targetElement, callback) {
      if (!targetElement) {
        // if no element is passed, there is nothing to animate
        return;
      }
      let target = this.getPlayer(type);
      if (!target) {
        target = this.initializePlayer(type, targetElement, callback);
      }
      // V.S. Jun 28th, 2021 #9783: player will NOT be initialized w/ null settings
      // events will already be emitted
      if (!target || target.hasStarted()) {
        return;
      }
      const targetEmitter = type === ANIMATION_TYPE.OPEN ? this.openAnimationStart : this.closeAnimationStart;
      targetEmitter.emit();
      if (target) {
        target.play();
      }
    }
    initializePlayer(type, targetElement, callback) {
      const oppositeType = type === ANIMATION_TYPE.OPEN ? ANIMATION_TYPE.CLOSE : ANIMATION_TYPE.OPEN;
      // V.S. Jun 28th, 2021 #9783: Treat falsy animation settings as disabled animations
      const targetAnimationSettings = this.animationSettings || {
        closeAnimation: null,
        openAnimation: null
      };
      const animationSettings = type === ANIMATION_TYPE.OPEN ? targetAnimationSettings.openAnimation : targetAnimationSettings.closeAnimation;
      // V.S. Jun 28th, 2021 #9783: When no animation in target direction, emit start and done events and return
      if (!animationSettings) {
        this.setCallback(type, callback);
        const targetEmitter = type === ANIMATION_TYPE.OPEN ? this.openAnimationStart : this.closeAnimationStart;
        targetEmitter.emit();
        this.onDoneHandler(type);
        return;
      }
      const opposite = this.getPlayer(oppositeType);
      let oppositePosition = 1;
      if (opposite) {
        oppositePosition = opposite.position;
        this.cleanUpPlayer(oppositeType);
      }
      if (type === ANIMATION_TYPE.OPEN) {
        this.openAnimationPlayer = this.animationService.buildAnimation(animationSettings, targetElement.nativeElement);
      } else if (type === ANIMATION_TYPE.CLOSE) {
        this.closeAnimationPlayer = this.animationService.buildAnimation(animationSettings, targetElement.nativeElement);
      }
      const target = this.getPlayer(type);
      target.init();
      this.getPlayer(type).position = 1 - oppositePosition;
      this.setCallback(type, callback);
      target.animationEnd.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.onDoneHandler(type);
      });
      return target;
    }
    onDoneHandler(type) {
      const targetEmitter = type === ANIMATION_TYPE.OPEN ? this.openAnimationDone : this.closeAnimationDone;
      const targetCallback = type === ANIMATION_TYPE.OPEN ? this.onOpenedCallback : this.onClosedCallback;
      targetCallback();
      if (!(type === ANIMATION_TYPE.OPEN ? this.openInterrupted : this.closeInterrupted)) {
        targetEmitter.emit();
      }
      this.cleanUpPlayer(type);
    }
    setCallback(type, callback) {
      if (type === ANIMATION_TYPE.OPEN) {
        this.onOpenedCallback = callback;
        this.openInterrupted = false;
      } else if (type === ANIMATION_TYPE.CLOSE) {
        this.onClosedCallback = callback;
        this.closeInterrupted = false;
      }
    }
    cleanUpPlayer(target) {
      switch (target) {
        case ANIMATION_TYPE.CLOSE:
          if (this.closeAnimationPlayer != null) {
            this.closeAnimationPlayer.reset();
            this.closeAnimationPlayer.destroy();
            this.closeAnimationPlayer = null;
          }
          this.closeInterrupted = true;
          this.onClosedCallback = this._defaultClosedCallback;
          break;
        case ANIMATION_TYPE.OPEN:
          if (this.openAnimationPlayer != null) {
            this.openAnimationPlayer.reset();
            this.openAnimationPlayer.destroy();
            this.openAnimationPlayer = null;
          }
          this.openInterrupted = true;
          this.onOpenedCallback = this._defaultOpenedCallback;
          break;
        default:
          break;
      }
    }
    getPlayer(type) {
      switch (type) {
        case ANIMATION_TYPE.OPEN:
          return this.openAnimationPlayer;
        case ANIMATION_TYPE.CLOSE:
          return this.closeAnimationPlayer;
        default:
          return null;
      }
    }
    static {
      this.ɵfac = function ToggleAnimationPlayer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ToggleAnimationPlayer)(i0.ɵɵdirectiveInject(IgxAngularAnimationService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ToggleAnimationPlayer
      });
    }
  }
  return ToggleAnimationPlayer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$s = 0;
let IgxExpansionPanelComponent = /*#__PURE__*/(() => {
  class IgxExpansionPanelComponent extends ToggleAnimationPlayer {
    /**
     * Sets/gets the animation settings of the expansion panel component
     * Open and Close animation should be passed
     *
     * Get
     * ```typescript
     *  const currentAnimations = this.panel.animationSettings;
     * ```
     * Set
     * ```typescript
     *  import { slideInLeft, slideOutRight } from 'igniteui-angular';
     *  ...
     *  this.panel.animationsSettings = {
     *      openAnimation: slideInLeft,
     *      closeAnimation: slideOutRight
     * };
     * ```
     * or via template
     * ```typescript
     *  import { slideInLeft, slideOutRight } from 'igniteui-angular';
     *  ...
     *  myCustomAnimationObject = {
     *      openAnimation: slideInLeft,
     *      closeAnimation: slideOutRight
     * };
     * ```html
     *  <igx-expansion-panel [animationSettings]='myCustomAnimationObject'>
     *  ...
     *  </igx-expansion-panel>
     * ```
     */
    get animationSettings() {
      return this._animationSettings;
    }
    set animationSettings(value) {
      this._animationSettings = value;
    }
    /**
     * @hidden @internal
     */
    get panelExpanded() {
      return !this.collapsed;
    }
    /**
     * @hidden
     */
    get headerId() {
      return this.header ? `${this.id}-header` : '';
    }
    /**
     * @hidden @internal
     */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    constructor(animationService, cdr, elementRef) {
      super(animationService);
      this.cdr = cdr;
      this.elementRef = elementRef;
      /**
       * Sets/gets the `id` of the expansion panel component.
       * If not set, `id` will have value `"igx-expansion-panel-0"`;
       * ```html
       * <igx-expansion-panel id = "my-first-expansion-panel"></igx-expansion-panel>
       * ```
       * ```typescript
       * let panelId =  this.panel.id;
       * ```
       *
       * @memberof IgxExpansionPanelComponent
       */
      this.id = `igx-expansion-panel-${NEXT_ID$s++}`;
      /**
       * @hidden
       */
      this.cssClass = 'igx-expansion-panel';
      /**
       * @hidden
       */
      this.opened = false;
      /**
       * Gets/sets whether the component is collapsed (its content is hidden)
       * Get
       * ```typescript
       *  const myPanelState: boolean = this.panel.collapsed;
       * ```
       * Set
       * ```html
       *  this.panel.collapsed = true;
       * ```
       *
       * Two-way data binding:
       * ```html
       * <igx-expansion-panel [(collapsed)]="model.isCollapsed"></igx-expansion-panel>
       * ```
       */
      this.collapsed = true;
      /**
       * @hidden
       */
      this.collapsedChange = new EventEmitter();
      /**
       * Emitted when the expansion panel starts collapsing
       * ```typescript
       *  handleCollapsing(event: IExpansionPanelCancelableEventArgs)
       * ```
       * ```html
       *  <igx-expansion-panel (contentCollapsing)="handleCollapsing($event)">
       *      ...
       *  </igx-expansion-panel>
       * ```
       */
      this.contentCollapsing = new EventEmitter();
      /**
       * Emitted when the expansion panel finishes collapsing
       * ```typescript
       *  handleCollapsed(event: IExpansionPanelEventArgs)
       * ```
       * ```html
       *  <igx-expansion-panel (contentCollapsed)="handleCollapsed($event)">
       *      ...
       *  </igx-expansion-panel>
       * ```
       */
      this.contentCollapsed = new EventEmitter();
      /**
       * Emitted when the expansion panel starts expanding
       * ```typescript
       *  handleExpanding(event: IExpansionPanelCancelableEventArgs)
       * ```
       * ```html
       *  <igx-expansion-panel (contentExpanding)="handleExpanding($event)">
       *      ...
       *  </igx-expansion-panel>
       * ```
       */
      this.contentExpanding = new EventEmitter();
      /**
       * Emitted when the expansion panel finishes expanding
       * ```typescript
       *  handleExpanded(event: IExpansionPanelEventArgs)
       * ```
       * ```html
       *  <igx-expansion-panel (contentExpanded)="handleExpanded($event)">
       *      ...
       *  </igx-expansion-panel>
       * ```
       */
      this.contentExpanded = new EventEmitter();
    }
    /** @hidden */
    ngAfterContentInit() {
      if (this.body && this.header) {
        // schedule at end of turn:
        Promise.resolve().then(() => {
          this.body.labelledBy = this.body.labelledBy || this.headerId;
          this.body.label = this.body.label || this.id + '-region';
        });
      }
    }
    /**
     * Collapses the panel
     *
     * ```html
     *  <igx-expansion-panel #myPanel>
     *      ...
     *  </igx-expansion-panel>
     *  <button type="button" igxButton (click)="myPanel.collapse($event)">Collpase Panel</button>
     * ```
     */
    collapse(evt) {
      // If expansion panel is already collapsed or is collapsing, do nothing
      if (this.collapsed || this.closeAnimationPlayer) {
        return;
      }
      const args = {
        event: evt,
        panel: this,
        owner: this,
        cancel: false
      };
      this.contentCollapsing.emit(args);
      if (args.cancel === true) {
        return;
      }
      this.opened = false;
      this.playCloseAnimation(this.body?.element, () => {
        this.contentCollapsed.emit({
          event: evt,
          owner: this
        });
        this.collapsed = true;
        this.collapsedChange.emit(true);
        this.cdr.markForCheck();
      });
    }
    /**
     * Expands the panel
     *
     * ```html
     *  <igx-expansion-panel #myPanel>
     *      ...
     *  </igx-expansion-panel>
     *  <button type="button" igxButton (click)="myPanel.expand($event)">Expand Panel</button>
     * ```
     */
    expand(evt) {
      if (!this.collapsed && !this.closeAnimationPlayer) {
        // Check if the panel is currently collapsing or already expanded
        return;
      }
      const args = {
        event: evt,
        panel: this,
        owner: this,
        cancel: false
      };
      this.contentExpanding.emit(args);
      if (args.cancel === true) {
        return;
      }
      this.collapsed = false;
      this.opened = true;
      this.collapsedChange.emit(false);
      this.cdr.detectChanges();
      this.playOpenAnimation(this.body?.element, () => {
        this.contentExpanded.emit({
          event: evt,
          owner: this
        });
      });
    }
    /**
     * Toggles the panel
     *
     * ```html
     *  <igx-expansion-panel #myPanel>
     *      ...
     *  </igx-expansion-panel>
     *  <button type="button" igxButton (click)="myPanel.toggle($event)">Expand Panel</button>
     * ```
     */
    toggle(evt) {
      if (this.collapsed) {
        this.open(evt);
      } else {
        this.close(evt);
      }
    }
    open(evt) {
      this.expand(evt);
    }
    close(evt) {
      this.collapse(evt);
    }
    static {
      this.ɵfac = function IgxExpansionPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExpansionPanelComponent)(i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExpansionPanelComponent,
        selectors: [["igx-expansion-panel"]],
        contentQueries: function IgxExpansionPanelComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxExpansionPanelBodyComponent, 5, IgxExpansionPanelBodyComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxExpansionPanelHeaderComponent, 5, IgxExpansionPanelHeaderComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.body = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function IgxExpansionPanelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("aria-expanded", ctx.panelExpanded);
            i0.ɵɵclassProp("igx-expansion-panel", ctx.cssClass)("igx-expansion-panel--expanded", ctx.opened);
          }
        },
        inputs: {
          animationSettings: "animationSettings",
          id: "id",
          collapsed: [2, "collapsed", "collapsed", booleanAttribute]
        },
        outputs: {
          collapsedChange: "collapsedChange",
          contentCollapsing: "contentCollapsing",
          contentCollapsed: "contentCollapsed",
          contentExpanding: "contentExpanding",
          contentExpanded: "contentExpanded"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_EXPANSION_PANEL_COMPONENT,
          useExisting: IgxExpansionPanelComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c13,
        decls: 2,
        vars: 1,
        template: function IgxExpansionPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c12);
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, IgxExpansionPanelComponent_Conditional_1_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.collapsed ? 1 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxExpansionPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$r = 0;
/**
 * IgxAccordion is a container-based component that contains that can house multiple expansion panels.
 *
 * @igxModule IgxAccordionModule
 *
 * @igxKeywords accordion
 *
 * @igxGroup Layouts
 *
 * @remarks
 * The Ignite UI for Angular Accordion component enables the user to navigate among multiple collapsing panels
 * displayed in a single container.
 * The accordion offers keyboard navigation and API to control the underlying panels' expansion state.
 *
 * @example
 * ```html
 * <igx-accordion>
 *   <igx-expansion-panel *ngFor="let panel of panels">
 *       ...
 *   </igx-expansion-panel>
 * </igx-accordion>
 * ```
 */
let IgxAccordionComponent = /*#__PURE__*/(() => {
  class IgxAccordionComponent {
    /**
     * Get/Set the animation settings that panels should use when expanding/collpasing.
     *
     * ```html
     * <igx-accordion [animationSettings]="customAnimationSettings"></igx-accordion>
     * ```
     *
     * ```typescript
     * const customAnimationSettings: ToggleAnimationSettings = {
     *      openAnimation: growVerIn,
     *      closeAnimation: growVerOut
     * };
     *
     * this.accordion.animationSettings = customAnimationSettings;
     * ```
     */
    get animationSettings() {
      return this._animationSettings;
    }
    set animationSettings(value) {
      this._animationSettings = value;
      this.updatePanelsAnimation();
    }
    /**
     * Get/Set how the accordion handles the expansion of the projected expansion panels.
     * If set to `true`, only a single panel can be expanded at a time, collapsing all others
     *
     * ```html
     * <igx-accordion [singleBranchExpand]="true">
     * ...
     * </igx-accordion>
     * ```
     *
     * ```typescript
     * this.accordion.singleBranchExpand = false;
     * ```
     */
    get singleBranchExpand() {
      return this._singleBranchExpand;
    }
    set singleBranchExpand(val) {
      this._singleBranchExpand = val;
      if (val) {
        this.collapseAllExceptLast();
      }
    }
    /**
     * Get all panels.
     *
     * ```typescript
     * const panels: IgxExpansionPanelComponent[] = this.accordion.panels;
     * ```
     */
    get panels() {
      return this._panels?.toArray();
    }
    constructor(cdr) {
      this.cdr = cdr;
      /**
       * Get/Set the `id` of the accordion component.
       * Default value is `"igx-accordion-0"`;
       * ```html
       * <igx-accordion id="my-first-accordion"></igx-accordion>
       * ```
       * ```typescript
       * const accordionId = this.accordion.id;
       * ```
       */
      this.id = `igx-accordion-${NEXT_ID$r++}`;
      /** @hidden @internal **/
      this.cssClass = 'igx-accordion';
      /** @hidden @internal **/
      this.displayStyle = 'block';
      /**
       * Emitted before a panel is expanded.
       *
       * @remarks
       * This event is cancelable.
       *
       * ```html
       * <igx-accordion (panelExpanding)="handlePanelExpanding($event)">
       * </igx-accordion>
       * ```
       *
       *```typescript
       * public handlePanelExpanding(event: IExpansionPanelCancelableEventArgs){
       *  const expandedPanel: IgxExpansionPanelComponent = event.panel;
       *  if (expandedPanel.disabled) {
       *      event.cancel = true;
       *  }
       * }
       *```
       */
      this.panelExpanding = new EventEmitter();
      /**
       * Emitted after a panel has been expanded.
       *
       * ```html
       * <igx-accordion (panelExpanded)="handlePanelExpanded($event)">
       * </igx-accordion>
       * ```
       *
       *```typescript
       * public handlePanelExpanded(event: IExpansionPanelCancelableEventArgs) {
       *  const expandedPanel: IgxExpansionPanelComponent = event.panel;
       *  console.log("Panel is expanded: ", expandedPanel.id);
       * }
       *```
       */
      this.panelExpanded = new EventEmitter();
      /**
       * Emitted before a panel is collapsed.
       *
       * @remarks
       * This event is cancelable.
       *
       * ```html
       * <igx-accordion (panelCollapsing)="handlePanelCollapsing($event)">
       * </igx-accordion>
       * ```
       */
      this.panelCollapsing = new EventEmitter();
      /**
       * Emitted after a panel has been collapsed.
       *
       * ```html
       * <igx-accordion (panelCollapsed)="handlePanelCollapsed($event)">
       * </igx-accordion>
       * ```
       */
      this.panelCollapsed = new EventEmitter();
      this._destroy$ = new Subject();
      this._unsubChildren$ = new Subject();
      this._singleBranchExpand = false;
    }
    /** @hidden @internal **/
    ngAfterContentInit() {
      this.updatePanelsAnimation();
      if (this.singleBranchExpand) {
        this.collapseAllExceptLast();
      }
    }
    /** @hidden @internal **/
    ngAfterViewInit() {
      this._expandedPanels = new Set(this._panels.filter(panel => !panel.collapsed));
      this._expandingPanels = new Set();
      this._panels.changes.pipe(takeUntil(this._destroy$)).subscribe(() => {
        this.subToChanges();
      });
      this.subToChanges();
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this._unsubChildren$.next();
      this._unsubChildren$.complete();
      this._destroy$.next();
      this._destroy$.complete();
    }
    /**
     * Expands all collapsed expansion panels.
     *
     * ```typescript
     * accordion.expandAll();
     * ```
     */
    expandAll() {
      if (this.singleBranchExpand) {
        for (let i = 0; i < this.panels.length - 1; i++) {
          this.panels[i].collapse();
        }
        this._panels.last.expand();
        return;
      }
      this.panels.forEach(panel => panel.expand());
    }
    /**
     * Collapses all expanded expansion panels.
     *
     * ```typescript
     * accordion.collapseAll();
     * ```
     */
    collapseAll() {
      this.panels.forEach(panel => panel.collapse());
    }
    collapseAllExceptLast() {
      const lastExpanded = this.panels?.filter(p => !p.collapsed && !p.header.disabled).pop();
      this.panels?.forEach(p => {
        if (p !== lastExpanded && !p.header.disabled) {
          p.collapsed = true;
        }
      });
      this.cdr.markForCheck();
    }
    handleKeydown(event, panel) {
      const key = event.key.toLowerCase();
      if (!ACCORDION_NAVIGATION_KEYS.has(key)) {
        return;
      }
      // TO DO: if we ever want to improve the performance of the accordion,
      // enabledPanels could be cached (by making a disabledChange emitter on the panel header)
      this._enabledPanels = this._panels.filter(p => !p.header.disabled);
      event.preventDefault();
      this.handleNavigation(event, panel);
    }
    handleNavigation(event, panel) {
      switch (event.key.toLowerCase()) {
        case 'home':
          this._enabledPanels[0].header.innerElement.focus();
          break;
        case 'end':
          this._enabledPanels[this._enabledPanels.length - 1].header.innerElement.focus();
          break;
        case 'arrowup':
        case 'up':
          this.handleUpDownArrow(true, event, panel);
          break;
        case 'arrowdown':
        case 'down':
          this.handleUpDownArrow(false, event, panel);
          break;
      }
    }
    handleUpDownArrow(isUp, event, panel) {
      if (!event.altKey) {
        const focusedPanel = panel;
        const next = this.getNextPanel(focusedPanel, isUp ? -1 : 1);
        if (next === focusedPanel) {
          return;
        }
        next.header.innerElement.focus();
      }
      if (event.altKey && event.shiftKey) {
        if (isUp) {
          this._enabledPanels.forEach(p => p.collapse());
        } else {
          if (this.singleBranchExpand) {
            for (let i = 0; i < this._enabledPanels.length - 1; i++) {
              this._enabledPanels[i].collapse();
            }
            this._enabledPanels[this._enabledPanels.length - 1].expand();
            return;
          }
          this._enabledPanels.forEach(p => p.expand());
        }
      }
    }
    getNextPanel(panel, dir = 1) {
      const panelIndex = this._enabledPanels.indexOf(panel);
      return this._enabledPanels[panelIndex + dir] || panel;
    }
    subToChanges() {
      this._unsubChildren$.next();
      this._panels.forEach(panel => {
        panel.contentExpanded.pipe(takeUntil(this._unsubChildren$)).subscribe(args => {
          this._expandedPanels.add(args.owner);
          this._expandingPanels.delete(args.owner);
          const evArgs = {
            ...args,
            owner: this,
            panel: args.owner
          };
          this.panelExpanded.emit(evArgs);
        });
        panel.contentExpanding.pipe(takeUntil(this._unsubChildren$)).subscribe(args => {
          if (args.cancel) {
            return;
          }
          const evArgs = {
            ...args,
            owner: this,
            panel: args.owner
          };
          this.panelExpanding.emit(evArgs);
          if (evArgs.cancel) {
            args.cancel = true;
            return;
          }
          if (this.singleBranchExpand) {
            this._expandedPanels.forEach(p => {
              if (!p.header.disabled) {
                p.collapse();
              }
            });
            this._expandingPanels.forEach(p => {
              if (!p.header.disabled) {
                if (!p.animationSettings.closeAnimation) {
                  p.openAnimationPlayer?.reset();
                }
                if (!p.animationSettings.openAnimation) {
                  p.closeAnimationPlayer?.reset();
                }
                p.collapse();
              }
            });
            this._expandingPanels.add(args.owner);
          }
        });
        panel.contentCollapsed.pipe(takeUntil(this._unsubChildren$)).subscribe(args => {
          this._expandedPanels.delete(args.owner);
          this._expandingPanels.delete(args.owner);
          const evArgs = {
            ...args,
            owner: this,
            panel: args.owner
          };
          this.panelCollapsed.emit(evArgs);
        });
        panel.contentCollapsing.pipe(takeUntil(this._unsubChildren$)).subscribe(args => {
          const evArgs = {
            ...args,
            owner: this,
            panel: args.owner
          };
          this.panelCollapsing.emit(evArgs);
          if (evArgs.cancel) {
            args.cancel = true;
          }
        });
        fromEvent(panel.header.innerElement, 'keydown').pipe(takeUntil(this._unsubChildren$)).subscribe(e => {
          this.handleKeydown(e, panel);
        });
      });
    }
    updatePanelsAnimation() {
      if (this.animationSettings !== undefined) {
        this.panels?.forEach(panel => panel.animationSettings = this.animationSettings);
      }
    }
    static {
      this.ɵfac = function IgxAccordionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAccordionComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxAccordionComponent,
        selectors: [["igx-accordion"]],
        contentQueries: function IgxAccordionComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxExpansionPanelComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._panels = _t);
          }
        },
        hostVars: 5,
        hostBindings: function IgxAccordionComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("display", ctx.displayStyle);
            i0.ɵɵclassProp("igx-accordion", ctx.cssClass);
          }
        },
        inputs: {
          id: "id",
          animationSettings: "animationSettings",
          singleBranchExpand: [2, "singleBranchExpand", "singleBranchExpand", booleanAttribute]
        },
        outputs: {
          panelExpanding: "panelExpanding",
          panelExpanded: "panelExpanded",
          panelCollapsing: "panelCollapsing",
          panelCollapsed: "panelCollapsed"
        },
        ngContentSelectors: _c15,
        decls: 1,
        vars: 0,
        template: function IgxAccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c14);
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxAccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Expansion panel directives collection for ease-of-use import in standalone components scenario */
const IGX_EXPANSION_PANEL_DIRECTIVES = [IgxExpansionPanelComponent, IgxExpansionPanelHeaderComponent, IgxExpansionPanelBodyComponent, IgxExpansionPanelDescriptionDirective, IgxExpansionPanelTitleDirective, IgxExpansionPanelIconDirective];

/* Accordion directives collection for ease-of-use import in standalone components scenario */
const IGX_ACCORDION_DIRECTIVES = [IgxAccordionComponent, IgxExpansionPanelComponent, IgxExpansionPanelHeaderComponent, IgxExpansionPanelBodyComponent, IgxExpansionPanelDescriptionDirective, IgxExpansionPanelTitleDirective, IgxExpansionPanelIconDirective];
const ActionStripResourceStringsEN = {
  igx_action_strip_button_more_title: 'More'
};

/** @hidden */
let IgxSelectionAPIService = /*#__PURE__*/(() => {
  class IgxSelectionAPIService {
    constructor() {
      /**
       * If primaryKey is defined, then multiple selection is based on the primaryKey, and it is array of numbers, strings, etc.
       * If the primaryKey is omitted, then selection is based on the item data
       */
      this.selection = new Map();
    }
    /**
     * Get current component selection.
     *
     * @param componentID ID of the component.
     */
    get(componentID) {
      return this.selection.get(componentID);
    }
    /**
     * Set new component selection.
     *
     * @param componentID ID of the component.
     * @param newSelection The new component selection to be set.
     */
    set(componentID, newSelection) {
      if (!componentID) {
        throw Error('Invalid value for component id!');
      }
      this.selection.set(componentID, newSelection);
    }
    /**
     * Clears selection for component.
     *
     * @param componentID ID of the component.
     */
    clear(componentID) {
      this.selection.set(componentID, this.get_empty());
    }
    /**
     * Removes selection for a component.
     * @param componentID
     */
    delete(componentID) {
      this.selection.delete(componentID);
    }
    /**
     * Get current component selection length.
     *
     * @param componentID ID of the component.
     */
    size(componentID) {
      const sel = this.get(componentID);
      return sel ? sel.size : 0;
    }
    /**
     * Creates new selection that consist of the new item added to the current component selection.
     * The returned collection is new Set,
     * therefore if you want to update component selection you need to call in addition the set_selection() method
     * or instead use the select_item() one.
     *
     * @param componentID ID of the component, which we add new item to.
     * @param itemID ID of the item to add to component selection.
     * @param sel Used internally only by the selection (add_items method) to accumulate selection for multiple items.
     *
     * @returns Selection after the new item is added.
     */
    add_item(componentID, itemID, sel) {
      if (!sel) {
        sel = new Set(this.get(componentID));
      }
      if (sel === undefined) {
        sel = this.get_empty();
      }
      sel.add(itemID);
      return sel;
    }
    /**
     * Creates new selection that consist of the new items added to the current component selection.
     * The returned collection is new Set,
     * therefore if you want to update component selection you need to call in addition the set_selection() method
     * or instead use the select_items() one.
     *
     * @param componentID ID of the component, which we add new items to.
     * @param itemIDs Array of IDs of the items to add to component selection.
     * @param clearSelection If true it will clear previous selection.
     *
     * @returns Selection after the new items are added.
     */
    add_items(componentID, itemIDs, clearSelection) {
      let selection;
      if (clearSelection) {
        selection = this.get_empty();
      } else if (itemIDs && itemIDs.length === 0) {
        selection = new Set(this.get(componentID));
      }
      itemIDs.forEach(item => selection = this.add_item(componentID, item, selection));
      return selection;
    }
    /**
     * Add item to the current component selection.
     *
     * @param componentID ID of the component, which we add new item to.
     * @param itemID ID of the item to add to component selection.
     * @param sel Used internally only by the selection (select_items method) to accumulate selection for multiple items.
     */
    select_item(componentID, itemID, sel) {
      this.set(componentID, this.add_item(componentID, itemID, sel));
    }
    /**
     * Add items to the current component selection.
     *
     * @param componentID ID of the component, which we add new items to.
     * @param itemIDs Array of IDs of the items to add to component selection.
     * @param clearSelection If true it will clear previous selection.
     */
    select_items(componentID, itemID, clearSelection) {
      this.set(componentID, this.add_items(componentID, itemID, clearSelection));
    }
    /**
     * Creates new selection that consist of the new items excluded from the current component selection.
     * The returned collection is new Set,
     * therefore if you want to update component selection you need to call in addition the set_selection() method
     * or instead use the deselect_item() one.
     *
     * @param componentID ID of the component, which we remove items from.
     * @param itemID ID of the item to remove from component selection.
     * @param sel Used internally only by the selection (delete_items method) to accumulate deselected items.
     *
     * @returns Selection after the item is removed.
     */
    delete_item(componentID, itemID, sel) {
      if (!sel) {
        sel = new Set(this.get(componentID));
      }
      if (sel === undefined) {
        return;
      }
      sel.delete(itemID);
      return sel;
    }
    /**
     * Creates new selection that consist of the new items removed to the current component selection.
     * The returned collection is new Set,
     * therefore if you want to update component selection you need to call in addition the set_selection() method
     * or instead use the deselect_items() one.
     *
     * @param componentID ID of the component, which we remove items from.
     * @param itemID ID of the items to remove from component selection.
     *
     * @returns Selection after the items are removed.
     */
    delete_items(componentID, itemIDs) {
      let selection;
      itemIDs.forEach(deselectedItem => selection = this.delete_item(componentID, deselectedItem, selection));
      return selection;
    }
    /**
     * Remove item from the current component selection.
     *
     * @param componentID ID of the component, which we remove item from.
     * @param itemID ID of the item to remove from component selection.
     * @param sel Used internally only by the selection (deselect_items method) to accumulate selection for multiple items.
     */
    deselect_item(componentID, itemID, sel) {
      this.set(componentID, this.delete_item(componentID, itemID, sel));
    }
    /**
     * Remove items to the current component selection.
     *
     * @param componentID ID of the component, which we add new items to.
     * @param itemIDs Array of IDs of the items to add to component selection.
     */
    deselect_items(componentID, itemID, _clearSelection) {
      this.set(componentID, this.delete_items(componentID, itemID));
    }
    /**
     * Check if the item is selected in the component selection.
     *
     * @param componentID ID of the component.
     * @param itemID ID of the item to search.
     *
     * @returns If item is selected.
     */
    is_item_selected(componentID, itemID) {
      const sel = this.get(componentID);
      if (!sel) {
        return false;
      }
      return sel.has(itemID);
    }
    /**
     * Get first element in the selection.
     * This is correct when we have only one item in the collection (for single selection purposes)
     * and the method returns that item.
     *
     * @param componentID ID of the component.
     *
     * @returns First element in the set.
     */
    first_item(componentID) {
      const sel = this.get(componentID);
      if (sel && sel.size > 0) {
        return sel.values().next().value;
      }
    }
    /**
     * Returns whether all items are selected.
     *
     * @param componentID ID of the component.
     * @param dataCount: number Number of items in the data.
     *
     * @returns If all items are selected.
     */
    are_all_selected(componentID, dataCount) {
      return dataCount > 0 && dataCount === this.size(componentID);
    }
    /**
     * Returns whether any of the items is selected.
     *
     * @param componentID ID of the component.
     * @param data Entire data array.
     *
     * @returns If there is any item selected.
     */
    are_none_selected(componentID) {
      return this.size(componentID) === 0;
    }
    /**
     * Get all primary key values from a data array. If there isn't a primary key defined that the entire data is returned instead.
     *
     * @param data Entire data array.
     * @param primaryKey Data primary key.
     *
     * @returns Array of identifiers, either primary key values or the entire data array.
     */
    get_all_ids(data, primaryKey) {
      // If primaryKey is 0, this should still map to the property
      return primaryKey !== undefined && primaryKey !== null ? data.map(x => x[primaryKey]) : data;
    }
    /**
     * Returns empty selection collection.
     *
     * @returns empty set.
     */
    get_empty() {
      return new Set();
    }
    static {
      this.ɵfac = function IgxSelectionAPIService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectionAPIService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxSelectionAPIService,
        factory: IgxSelectionAPIService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxSelectionAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$q = 0;
/**
 * The `<igx-drop-down-item>` is a container intended for row items in
 * a `<igx-drop-down>` container.
 */
let IgxDropDownGroupComponent = /*#__PURE__*/(() => {
  class IgxDropDownGroupComponent {
    constructor() {
      /**
       * @hidden @internal
       */
      this.role = 'group';
      /** @hidden @internal */
      this.groupClass = true;
      /**
       * Sets/gets if the item group is disabled
       *
       * ```typescript
       * const myDropDownGroup: IgxDropDownGroupComponent = this.dropdownGroup;
       * // get
       * ...
       * const groupState: boolean = myDropDownGroup.disabled;
       * ...
       * //set
       * ...
       * myDropDownGroup,disabled = false;
       * ...
       * ```
       *
       * ```html
       * <igx-drop-down-item-group [label]="'My Items'" [disabled]="true">
       *     <igx-drop-down-item *ngFor="let item of items[index]" [value]="item.value">
       *         {{ item.text }}
       *     </igx-drop-down-item>
       * </igx-drop-down-item-group>
       * ```
       *
       * **NOTE:** All items inside of a disabled drop down group will be treated as disabled
       */
      this.disabled = false;
      this._id = NEXT_ID$q++;
    }
    /**
     * @hidden @internal
     */
    get labelId() {
      return `igx-item-group-label-${this._id}`;
    }
    get labelledBy() {
      return this.labelId;
    }
    static {
      this.ɵfac = function IgxDropDownGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownGroupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDropDownGroupComponent,
        selectors: [["igx-drop-down-item-group"]],
        hostVars: 7,
        hostBindings: function IgxDropDownGroupComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-labelledby", ctx.labelledBy)("role", ctx.role)("aria-disabled", ctx.disabled);
            i0.ɵɵclassProp("igx-drop-down__group", ctx.groupClass)("igx-drop-down__group--disabled", ctx.disabled);
          }
        },
        inputs: {
          disabled: [2, "disabled", "disabled", booleanAttribute],
          label: "label"
        },
        ngContentSelectors: _c17,
        decls: 3,
        vars: 2,
        consts: [[3, "id"]],
        template: function IgxDropDownGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c16);
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(2);
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("id", ctx.labelId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxDropDownGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$p = 0;
/**
 * An abstract class defining a drop-down item:
 * With properties / styles for selection, highlight, height
 * Bindable property for passing data (`value: any`)
 * Parent component (has to be used under a parent with type `IDropDownBase`)
 * Method for handling click on Host()
 */
let IgxDropDownItemBaseDirective = /*#__PURE__*/(() => {
  class IgxDropDownItemBaseDirective {
    get ariaLabel() {
      return this._label ? this._label : this.value ? this.value : this.id;
    }
    set ariaLabel(value) {
      this._label = value;
    }
    /**
     * @hidden @internal
     */
    get itemID() {
      return this;
    }
    /**
     * The data index of the dropdown item.
     *
     * ```typescript
     * // get the data index of the selected dropdown item
     * let selectedItemIndex = this.dropdown.selectedItem.index
     * ```
     */
    get index() {
      if (this._index === null) {
        return this.itemIndex;
      }
      return this._index;
    }
    set index(value) {
      this._index = value;
    }
    /**
     * @hidden @internal
     */
    get itemStyle() {
      return !this.isHeader;
    }
    /**
     * Sets/Gets if the item is the currently selected one in the dropdown
     *
     * ```typescript
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let isMyItemSelected = mySelectedItem.selected; // true
     * ```
     *
     * Two-way data binding
     * ```html
     * <igx-drop-down-item [(selected)]='model.isSelected'></igx-drop-down-item>
     * ```
     */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (this.isHeader) {
        return;
      }
      this._selected = value;
      this.selectedChange.emit(this._selected);
    }
    /**
     * Sets/gets if the given item is focused
     * ```typescript
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let isMyItemFocused = mySelectedItem.focused;
     * ```
     */
    get focused() {
      return this.isSelectable && this._focused;
    }
    /**
     * ```html
     *  <igx-drop-down-item *ngFor="let item of items" focused={{!item.focused}}>
     *      <div>
     *          {{item.field}}
     *      </div>
     *  </igx-drop-down-item>
     * ```
     */
    set focused(value) {
      this._focused = value;
    }
    /**
     * Sets/gets if the given item is disabled
     *
     * ```typescript
     *  // get
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let myItemIsDisabled = mySelectedItem.disabled;
     * ```
     *
     * ```html
     *  <igx-drop-down-item *ngFor="let item of items" disabled={{!item.disabled}}>
     *      <div>
     *          {{item.field}}
     *      </div>
     *  </igx-drop-down-item>
     * ```
     * **NOTE:** Drop-down items inside of a disabled `IgxDropDownGroup` will always count as disabled
     */
    get disabled() {
      return this.group ? this.group.disabled || this._disabled : this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    /**
     * Gets item index
     *
     * @hidden @internal
     */
    get itemIndex() {
      return this.dropDown.items.indexOf(this);
    }
    /**
     * Gets item element height
     *
     * @hidden @internal
     */
    get elementHeight() {
      return this.elementRef.nativeElement.clientHeight;
    }
    /**
     * Get item html element
     *
     * @hidden @internal
     */
    get element() {
      return this.elementRef;
    }
    get hasIndex() {
      return this._index !== null && this._index !== undefined;
    }
    constructor(dropDown, elementRef, group, selection) {
      this.dropDown = dropDown;
      this.elementRef = elementRef;
      this.group = group;
      this.selection = selection;
      /**
       * Sets/gets the `id` of the item.
       * ```html
       * <igx-drop-down-item [id] = 'igx-drop-down-item-0'></igx-drop-down-item>
       * ```
       * ```typescript
       * let itemId =  this.item.id;
       * ```
       *
       * @memberof IgxSelectItemComponent
       */
      this.id = `igx-drop-down-item-${NEXT_ID$p++}`;
      /**
       * @hidden
       */
      this.selectedChange = new EventEmitter();
      /**
       * Gets/sets the `role` attribute of the item. Default is 'option'.
       *
       * ```html
       *  <igx-drop-down-item [role]="customRole"></igx-drop-down-item>
       * ```
       */
      this.role = 'option';
      /**
       * @hidden
       */
      this._focused = false;
      this._selected = false;
      this._index = null;
      this._disabled = false;
      this._label = null;
    }
    /**
     * @hidden
     * @internal
     */
    clicked(event) {}
    /**
     * @hidden
     * @internal
     */
    handleMousedown(event) {
      if (!this.dropDown.allowItemsFocus) {
        event.preventDefault();
      }
    }
    ngDoCheck() {
      if (this._selected) {
        const dropDownSelectedItem = this.dropDown.selectedItem;
        if (!dropDownSelectedItem) {
          this.dropDown.selectItem(this, undefined, false);
        } else if (this.hasIndex ? this._index !== dropDownSelectedItem.index || this.value !== dropDownSelectedItem.value : this !== dropDownSelectedItem) {
          this.dropDown.selectItem(this, undefined, false);
        }
      }
    }
    /** Returns true if the items is not a header or disabled  */
    get isSelectable() {
      return !(this.disabled || this.isHeader);
    }
    /** If `allowItemsFocus` is enabled, keep the browser focus on the active item */
    ensureItemFocus() {
      if (this.dropDown.allowItemsFocus) {
        const focusedItem = this.dropDown.items.find(item => item.focused);
        if (!focusedItem) {
          return;
        }
        focusedItem.element.nativeElement.focus({
          preventScroll: true
        });
      }
    }
    static {
      this.ɵfac = function IgxDropDownItemBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownItemBaseDirective)(i0.ɵɵdirectiveInject(IGX_DROPDOWN_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxDropDownGroupComponent, 8), i0.ɵɵdirectiveInject(IgxSelectionAPIService, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDropDownItemBaseDirective,
        selectors: [["", "igxDropDownItemBase", ""]],
        hostVars: 15,
        hostBindings: function IgxDropDownItemBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxDropDownItemBaseDirective_click_HostBindingHandler($event) {
              return ctx.clicked($event);
            })("mousedown", function IgxDropDownItemBaseDirective_mousedown_HostBindingHandler($event) {
              return ctx.handleMousedown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("aria-label", ctx.ariaLabel)("aria-selected", ctx.selected)("aria-disabled", ctx.disabled)("role", ctx.role);
            i0.ɵɵclassProp("igx-drop-down__item", ctx.itemStyle)("igx-drop-down__item--selected", ctx.selected)("igx-drop-down__item--focused", ctx.focused)("igx-drop-down__header", ctx.isHeader)("igx-drop-down__item--disabled", ctx.disabled);
          }
        },
        inputs: {
          id: "id",
          ariaLabel: "ariaLabel",
          index: "index",
          value: "value",
          selected: [2, "selected", "selected", booleanAttribute],
          isHeader: [2, "isHeader", "isHeader", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          role: "role"
        },
        outputs: {
          selectedChange: "selectedChange"
        }
      });
    }
  }
  return IgxDropDownItemBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The `<igx-drop-down-item>` is a container intended for row items in
 * a `<igx-drop-down>` container.
 */
let IgxDropDownItemComponent = /*#__PURE__*/(() => {
  class IgxDropDownItemComponent extends IgxDropDownItemBaseDirective {
    /**
     * Sets/gets if the given item is focused
     * ```typescript
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let isMyItemFocused = mySelectedItem.focused;
     * ```
     */
    get focused() {
      let focusedState = this._focused;
      if (this.hasIndex) {
        const focusedItem = this.selection.first_item(`${this.dropDown.id}-active`);
        const focusedIndex = focusedItem ? focusedItem.index : -1;
        focusedState = this._index === focusedIndex;
      }
      return this.isSelectable && focusedState;
    }
    /**
     * Sets/gets if the given item is focused
     * ```typescript
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let isMyItemFocused = mySelectedItem.focused;
     * ```
     */
    set focused(value) {
      this._focused = value;
    }
    /**
     * Sets/Gets if the item is the currently selected one in the dropdown
     *
     * ```typescript
     *  let mySelectedItem = this.dropdown.selectedItem;
     *  let isMyItemSelected = mySelectedItem.selected; // true
     * ```
     *
     * Two-way data binding
     * ```html
     * <igx-drop-down-item [(selected)]='model.isSelected'></igx-drop-down-item>
     * ```
     */
    get selected() {
      if (this.hasIndex) {
        const item = this.selection.first_item(`${this.dropDown.id}`);
        return item ? item.index === this._index && item.value === this.value : false;
      }
      return this._selected;
    }
    /**
     * Sets/Gets if the item is the currently selected one in the dropdown
     *
     */
    set selected(value) {
      if (this.isHeader) {
        return;
      }
      this._selected = value;
      this.selectedChange.emit(this._selected);
    }
    /**
     * @hidden @internal
     */
    get setTabIndex() {
      const shouldSetTabIndex = this.dropDown.allowItemsFocus && this.isSelectable;
      if (shouldSetTabIndex) {
        return 0;
      } else {
        return null;
      }
    }
    clicked(event) {
      if (!this.isSelectable) {
        this.ensureItemFocus();
        return;
      }
      if (this.selection) {
        this.dropDown.selectItem(this, event);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxDropDownItemComponent_BaseFactory;
        return function IgxDropDownItemComponent_Factory(__ngFactoryType__) {
          return (ɵIgxDropDownItemComponent_BaseFactory || (ɵIgxDropDownItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxDropDownItemComponent)))(__ngFactoryType__ || IgxDropDownItemComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDropDownItemComponent,
        selectors: [["igx-drop-down-item"]],
        hostVars: 1,
        hostBindings: function IgxDropDownItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.setTabIndex);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c19,
        decls: 6,
        vars: 0,
        consts: [[1, "igx-drop-down__content"], [1, "igx-drop-down__inner"]],
        template: function IgxDropDownItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c18);
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementStart(2, "span", 1);
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4, 2);
            i0.ɵɵprojection(5, 3);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxDropDownItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * **Ignite UI for Angular DropDown** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/drop-down)
 *
 * The Ignite UI for Angular Drop Down displays a scrollable list of items which may be visually grouped and
 * supports selection of a single item. Clicking or tapping an item selects it and closes the Drop Down
 *
 * Example:
 * ```html
 * <igx-drop-down>
 *   <igx-drop-down-item *ngFor="let item of items" disabled={{item.disabled}} isHeader={{item.header}}>
 *     {{ item.value }}
 *   </igx-drop-down-item>
 * </igx-drop-down>
 * ```
 */
let IgxDropDownComponent = /*#__PURE__*/(() => {
  class IgxDropDownComponent extends IgxDropDownBaseDirective {
    /**
     * @hidden @internal
     */
    get focusedItem() {
      if (this.virtDir) {
        return this._focusedItem && this._focusedItem.index !== -1 ? this.children.find(e => e.index === this._focusedItem.index) || null : null;
      }
      return this._focusedItem;
    }
    set focusedItem(value) {
      if (!value) {
        this.selection.clear(`${this.id}-active`);
        this._focusedItem = null;
        return;
      }
      this._focusedItem = value;
      if (this.virtDir) {
        this._focusedItem = {
          value: value.value,
          index: value.index
        };
      }
      this.selection.set(`${this.id}-active`, new Set([this._focusedItem]));
    }
    get id() {
      return this._id;
    }
    set id(value) {
      this.selection.set(value, this.selection.get(this.id));
      this.selection.clear(this.id);
      this.selection.set(value, this.selection.get(`${this.id}-active`));
      this.selection.clear(`${this.id}-active`);
      this._id = value;
    }
    /** Id of the internal listbox of the drop down */
    get listId() {
      return this.id + '-list';
    }
    /**
     * Get currently selected item
     *
     * ```typescript
     * let currentItem = this.dropdown.selectedItem;
     * ```
     */
    get selectedItem() {
      const selectedItem = this.selection.first_item(this.id);
      if (selectedItem) {
        return selectedItem;
      }
      return null;
    }
    /**
     * Gets if the dropdown is collapsed
     *
     * ```typescript
     * let isCollapsed = this.dropdown.collapsed;
     * ```
     */
    get collapsed() {
      return this.toggleDirective.collapsed;
    }
    /** @hidden @internal */
    get scrollContainer() {
      return this.scrollContainerRef.nativeElement;
    }
    get collectionLength() {
      if (this.virtDir) {
        return this.virtDir.totalItemCount || this.virtDir.igxForOf.length;
      }
    }
    constructor(elementRef, cdr, document, selection) {
      super(elementRef, cdr, document);
      this.selection = selection;
      /**
       * Emitted before the dropdown is opened
       *
       * ```html
       * <igx-drop-down (opening)='handleOpening($event)'></igx-drop-down>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emitted after the dropdown is opened
       *
       * ```html
       * <igx-drop-down (opened)='handleOpened($event)'></igx-drop-down>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emitted before the dropdown is closed
       *
       * ```html
       * <igx-drop-down (closing)='handleClosing($event)'></igx-drop-down>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emitted after the dropdown is closed
       *
       * ```html
       * <igx-drop-down (closed)='handleClosed($event)'></igx-drop-down>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * Gets/sets whether items take focus. Disabled by default.
       * When enabled, drop down items gain tab index and are focused when active -
       * this includes activating the selected item when opening the drop down and moving with keyboard navigation.
       *
       * Note: Keep that focus shift in mind when using the igxDropDownItemNavigation directive
       * and ensure it's placed either on each focusable item or a common ancestor to allow it to handle keyboard events.
       *
       * ```typescript
       * // get
       * let dropDownAllowsItemFocus = this.dropdown.allowItemsFocus;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-drop-down [allowItemsFocus]='true'></igx-drop-down>
       * ```
       */
      this.allowItemsFocus = false;
      this.destroy$ = new Subject();
    }
    /**
     * Opens the dropdown
     *
     * ```typescript
     * this.dropdown.open();
     * ```
     */
    open(overlaySettings) {
      const settings = {
        ...{},
        ...this.getDefaultOverlaySettings(),
        ...overlaySettings
      };
      this.toggleDirective.open(settings);
      this.updateScrollPosition();
    }
    /**
     * @hidden @internal
     */
    getDefaultOverlaySettings() {
      return {
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new ConnectedPositioningStrategy()
      };
    }
    /**
     * Closes the dropdown
     *
     * ```typescript
     * this.dropdown.close();
     * ```
     */
    close(event) {
      this.toggleDirective.close(event);
    }
    /**
     * Toggles the dropdown
     *
     * ```typescript
     * this.dropdown.toggle();
     * ```
     */
    toggle(overlaySettings) {
      if (this.collapsed || this.toggleDirective.isClosing) {
        this.open(overlaySettings);
      } else {
        this.close();
      }
    }
    /**
     * Select an item by index
     *
     * @param index of the item to select; If the drop down uses *igxFor, pass the index in data
     */
    setSelectedItem(index) {
      if (index < 0 || index >= this.items.length) {
        return;
      }
      let newSelection;
      if (this.virtDir) {
        newSelection = {
          value: this.virtDir.igxForOf[index],
          index
        };
      } else {
        newSelection = this.items[index];
      }
      this.selectItem(newSelection);
    }
    /**
     * Navigates to the item on the specified index
     * If the data in the drop-down is virtualized, pass the index of the item in the virtualized data.
     *
     * @param newIndex number
     */
    navigateItem(index) {
      if (this.virtDir) {
        if (index === -1 || index >= this.collectionLength) {
          return;
        }
        const direction = index > (this.focusedItem ? this.focusedItem.index : -1) ? Navigate.Down : Navigate.Up;
        const subRequired = this.isIndexOutOfBounds(index, direction);
        this.focusedItem = {
          value: this.virtDir.igxForOf[index],
          index
        };
        if (subRequired) {
          this.virtDir.scrollTo(index);
        }
        if (subRequired) {
          this.virtDir.chunkLoad.pipe(take(1)).subscribe(() => {
            this.skipHeader(direction);
          });
        } else {
          this.skipHeader(direction);
        }
      } else {
        super.navigateItem(index);
      }
      if (this.allowItemsFocus && this.focusedItem) {
        this.focusedItem.element.nativeElement.focus();
        this.cdr.markForCheck();
      }
    }
    /**
     * @hidden @internal
     */
    updateScrollPosition() {
      if (!this.virtDir) {
        return;
      }
      if (!this.selectedItem) {
        this.virtDir.scrollTo(0);
        return;
      }
      let targetScroll = this.virtDir.getScrollForIndex(this.selectedItem.index);
      // TODO: This logic _cannot_ be right, those are optional user-provided inputs that can be strings with units, refactor:
      const itemsInView = this.virtDir.igxForContainerSize / this.virtDir.igxForItemSize;
      targetScroll -= (itemsInView / 2 - 1) * this.virtDir.igxForItemSize;
      this.virtDir.getScroll().scrollTop = targetScroll;
    }
    /**
     * @hidden @internal
     */
    onToggleOpening(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: false
      };
      this.opening.emit(args);
      e.cancel = args.cancel;
      if (e.cancel) {
        return;
      }
      if (this.virtDir) {
        this.virtDir.scrollPosition = this._scrollPosition;
      }
    }
    /**
     * @hidden @internal
     */
    onToggleContentAppended(_event) {
      if (!this.virtDir && this.selectedItem) {
        this.scrollToItem(this.selectedItem);
      }
    }
    /**
     * @hidden @internal
     */
    onToggleOpened() {
      this.updateItemFocus();
      this.opened.emit({
        owner: this
      });
    }
    /**
     * @hidden @internal
     */
    onToggleClosing(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: false
      };
      this.closing.emit(args);
      e.cancel = args.cancel;
      if (e.cancel) {
        return;
      }
      if (this.virtDir) {
        this._scrollPosition = this.virtDir.scrollPosition;
      }
    }
    /**
     * @hidden @internal
     */
    onToggleClosed() {
      this.focusItem(false);
      this.closed.emit({
        owner: this
      });
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
      this.selection.delete(this.id);
      this.selection.delete(`${this.id}-active`);
    }
    /** @hidden @internal */
    calculateScrollPosition(item) {
      if (!item) {
        return 0;
      }
      const elementRect = item.element.nativeElement.getBoundingClientRect();
      const parentRect = this.scrollContainer.getBoundingClientRect();
      const scrollDelta = parentRect.top - elementRect.top;
      let scrollPosition = this.scrollContainer.scrollTop - scrollDelta;
      const dropDownHeight = this.scrollContainer.clientHeight;
      scrollPosition -= dropDownHeight / 2;
      scrollPosition += item.elementHeight / 2;
      return Math.floor(scrollPosition);
    }
    /**
     * @hidden @internal
     */
    ngOnChanges(changes) {
      if (changes.id) {
        // temp workaround until fix --> https://github.com/angular/angular/issues/34992
        this.toggleDirective.id = changes.id.currentValue;
      }
    }
    ngAfterViewInit() {
      if (this.virtDir) {
        this.virtDir.igxForItemSize = 28;
      }
    }
    /** Keydown Handler */
    onItemActionKey(key, event) {
      super.onItemActionKey(key, event);
      this.close(event);
    }
    /**
     * Virtual scroll implementation
     *
     * @hidden @internal
     */
    navigateFirst() {
      if (this.virtDir) {
        this.navigateItem(0);
      } else {
        super.navigateFirst();
      }
    }
    /**
     * @hidden @internal
     */
    navigateLast() {
      if (this.virtDir) {
        this.navigateItem(this.virtDir.totalItemCount ? this.virtDir.totalItemCount - 1 : this.virtDir.igxForOf.length - 1);
      } else {
        super.navigateLast();
      }
    }
    /**
     * @hidden @internal
     */
    navigateNext() {
      if (this.virtDir) {
        this.navigateItem(this._focusedItem ? this._focusedItem.index + 1 : 0);
      } else {
        super.navigateNext();
      }
    }
    /**
     * @hidden @internal
     */
    navigatePrev() {
      if (this.virtDir) {
        this.navigateItem(this._focusedItem ? this._focusedItem.index - 1 : 0);
      } else {
        super.navigatePrev();
      }
    }
    /**
     * Handles the `selectionChanging` emit and the drop down toggle when selection changes
     *
     * @hidden
     * @internal
     * @param newSelection
     * @param emit
     * @param event
     */
    selectItem(newSelection, event, emit = true) {
      const oldSelection = this.selectedItem;
      if (!newSelection) {
        newSelection = this.focusedItem;
      }
      if (newSelection === null) {
        return;
      }
      if (newSelection instanceof IgxDropDownItemBaseDirective && newSelection.isHeader) {
        return;
      }
      if (this.virtDir) {
        newSelection = {
          value: newSelection.value,
          index: newSelection.index
        };
      }
      const args = {
        oldSelection,
        newSelection,
        cancel: false,
        owner: this
      };
      if (emit) {
        this.selectionChanging.emit(args);
      }
      if (!args.cancel) {
        if (this.isSelectionValid(args.newSelection)) {
          this.selection.set(this.id, new Set([args.newSelection]));
          if (!this.virtDir) {
            if (oldSelection) {
              oldSelection.selected = false;
            }
            if (args.newSelection) {
              args.newSelection.selected = true;
            }
          }
          if (event) {
            this.toggleDirective.close(event);
          }
        } else {
          throw new Error('Please provide a valid drop-down item for the selection!');
        }
      }
    }
    /**
     * Clears the selection of the dropdown
     * ```typescript
     * this.dropdown.clearSelection();
     * ```
     */
    clearSelection() {
      const oldSelection = this.selectedItem;
      const newSelection = null;
      const args = {
        oldSelection,
        newSelection,
        cancel: false,
        owner: this
      };
      this.selectionChanging.emit(args);
      if (this.selectedItem && !args.cancel) {
        this.selectedItem.selected = false;
        this.selection.clear(this.id);
      }
    }
    /**
     * Checks whether the selection is valid
     * `null` - the selection should be emptied
     * Virtual? - the selection should at least have and `index` and `value` property
     * Non-virtual? - the selection should be a valid drop-down item and **not** be a header
     */
    isSelectionValid(selection) {
      return selection === null || this.virtDir && selection.hasOwnProperty('value') && selection.hasOwnProperty('index') || selection instanceof IgxDropDownItemComponent && !selection.isHeader;
    }
    scrollToItem(item) {
      this.scrollContainer.scrollTop = this.calculateScrollPosition(item);
    }
    focusItem(value) {
      if (value || this._focusedItem) {
        this._focusedItem.focused = value;
      }
    }
    updateItemFocus() {
      if (this.selectedItem) {
        this.focusedItem = this.selectedItem;
        this.focusItem(true);
      } else if (this.allowItemsFocus) {
        this.navigateFirst();
      }
    }
    skipHeader(direction) {
      if (!this.focusedItem) {
        return;
      }
      if (this.focusedItem.isHeader || this.focusedItem.disabled) {
        if (direction === Navigate.Up) {
          this.navigatePrev();
        } else {
          this.navigateNext();
        }
      }
    }
    isIndexOutOfBounds(index, direction) {
      const virtState = this.virtDir.state;
      const currentPosition = this.virtDir.getScroll().scrollTop;
      const itemPosition = this.virtDir.getScrollForIndex(index, direction === Navigate.Down);
      const indexOutOfChunk = index < virtState.startIndex || index > virtState.chunkSize + virtState.startIndex;
      const scrollNeeded = direction === Navigate.Down ? currentPosition < itemPosition : currentPosition > itemPosition;
      const subRequired = indexOutOfChunk || scrollNeeded;
      return subRequired;
    }
    static {
      this.ɵfac = function IgxDropDownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IgxSelectionAPIService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDropDownComponent,
        selectors: [["igx-drop-down"]],
        contentQueries: function IgxDropDownComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxForOfToken, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxDropDownItemComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtDir = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        viewQuery: function IgxDropDownComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxToggleDirective, 7);
            i0.ɵɵviewQuery(_c20, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollContainerRef = _t.first);
          }
        },
        inputs: {
          allowItemsFocus: [2, "allowItemsFocus", "allowItemsFocus", booleanAttribute],
          labelledBy: "labelledBy"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_DROPDOWN_BASE,
          useExisting: IgxDropDownComponent
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 9,
        consts: [["scrollContainer", ""], ["igxToggle", "", 1, "igx-drop-down__list", 3, "appended", "opening", "opened", "closing", "closed"], ["role", "listbox", 1, "igx-drop-down__list-scroll"]],
        template: function IgxDropDownComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("appended", function IgxDropDownComponent_Template_div_appended_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleContentAppended($event));
            })("opening", function IgxDropDownComponent_Template_div_opening_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleOpening($event));
            })("opened", function IgxDropDownComponent_Template_div_opened_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleOpened());
            })("closing", function IgxDropDownComponent_Template_div_closing_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleClosing($event));
            })("closed", function IgxDropDownComponent_Template_div_closed_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleClosed());
            });
            i0.ɵɵelementStart(1, "div", 2, 0);
            i0.ɵɵtemplate(3, IgxDropDownComponent_Conditional_3_Template, 1, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.height)("max-height", ctx.maxHeight);
            i0.ɵɵattribute("id", ctx.listId)("aria-labelledby", ctx.labelledBy);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.collapsed ? 3 : -1);
          }
        },
        dependencies: [IgxToggleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxDropDownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-action-button */
/* blazorIndirectRender */
let IgxGridActionButtonComponent = /*#__PURE__*/(() => {
  class IgxGridActionButtonComponent {
    constructor() {
      /* blazorSuppress */
      /**
       * Event emitted when action button is clicked.
       *
       * @example
       * ```html
       *  <igx-grid-action-button (actionClick)="startEdit($event)"></igx-grid-action-button>
       * ```
       */
      this.actionClick = new EventEmitter();
      /**
       * Whether button action is rendered in menu and should container text label.
       */
      this.asMenuItem = false;
    }
    /** @hidden @internal */
    get containerClass() {
      return 'igx-action-strip__menu-button ' + (this.classNames || '');
    }
    /**
     * @hidden
     * @internal
     */
    handleClick(event) {
      this.actionClick.emit(event);
    }
    /**
     * @hidden @internal
     */
    preventEvent(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
    static {
      this.ɵfac = function IgxGridActionButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridActionButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridActionButtonComponent,
        selectors: [["igx-grid-action-button"]],
        viewQuery: function IgxGridActionButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
            i0.ɵɵviewQuery(_c21, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          }
        },
        inputs: {
          asMenuItem: [2, "asMenuItem", "asMenuItem", booleanAttribute],
          iconName: "iconName",
          classNames: "classNames",
          iconSet: "iconSet",
          labelText: "labelText"
        },
        outputs: {
          actionClick: "actionClick"
        },
        decls: 3,
        vars: 1,
        consts: [["menuItemTemplate", ""], ["container", ""], ["type", "button", "igxIconButton", "flat", "igxRipple", "", 3, "title"], ["type", "button", "igxIconButton", "flat", "igxRipple", "", 3, "click", "mousedown", "title"], [3, "family", "name"], [3, "className"], ["igxLabel", ""]],
        template: function IgxGridActionButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridActionButtonComponent_Conditional_0_Template, 3, 3, "button", 2)(1, IgxGridActionButtonComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.asMenuItem ? 0 : -1);
          }
        },
        dependencies: [IgxRippleDirective, IgxIconComponent, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxGridActionButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Allows users to make a binary choice for a certain condition.
 *
 * @igxModule IgxCheckboxModule
 *
 * @igxTheme igx-checkbox-theme
 *
 * @igxKeywords checkbox, label
 *
 * @igxGroup Data entry and display
 *
 * @remarks
 * The Ignite UI Checkbox is a selection control that allows users to make a binary choice for a certain condition.It behaves similarly
 * to the native browser checkbox.
 *
 * @example
 * ```html
 * <igx-checkbox [checked]="true">
 *   simple checkbox
 * </igx-checkbox>
 * ```
 */
let IgxCheckboxComponent = /*#__PURE__*/(() => {
  class IgxCheckboxComponent extends CheckboxBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Returns the class of the checkbox component.
       *
       * @example
       * ```typescript
       * let class = this.checkbox.cssClass;
       * ```
       */
      this.cssClass = 'igx-checkbox';
      /**
       * Sets/gets whether the checkbox component is on focus.
       * Default value is `false`.
       *
       * @example
       * ```typescript
       * this.checkbox.focused =  true;
       * ```
       * ```typescript
       * let isFocused = this.checkbox.focused;
       * ```
       */
      this.focused = false;
      /**
       * Sets/gets the checkbox indeterminate visual state.
       * Default value is `false`;
       *
       * @example
       * ```html
       * <igx-checkbox [indeterminate]="true"></igx-checkbox>
       * ```
       * ```typescript
       * let isIndeterminate = this.checkbox.indeterminate;
       * ```
       */
      this.indeterminate = false;
      /**
       * Sets/gets whether the checkbox is disabled.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-checkbox disabled></igx-checkbox>
       * ```
       * ```typescript
       * let isDisabled = this.checkbox.disabled;
       * ```
       */
      this.disabled = false;
      /**
       * Sets/gets whether the checkbox is invalid.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-checkbox invalid></igx-checkbox>
       * ```
       * ```typescript
       * let isInvalid = this.checkbox.invalid;
       * ```
       */
      this.invalid = false;
      /**
       * Sets/gets whether the checkbox is readonly.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-checkbox [readonly]="true"></igx-checkbox>
       * ```
       * ```typescript
       * let readonly = this.checkbox.readonly;
       * ```
       */
      this.readonly = false;
      /**
       * Sets/gets whether the checkbox should disable all css transitions.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-checkbox [disableTransitions]="true"></igx-checkbox>
       * ```
       * ```typescript
       * let disableTransitions = this.checkbox.disableTransitions;
       * ```
       */
      this.disableTransitions = false;
    }
    /**
     * Returns if the component is of type `material`.
     *
     * @example
     * ```typescript
     * let checkbox = this.checkbox.material;
     * ```
     */
    get material() {
      return this.theme === 'material';
    }
    /**
     * Returns if the component is of type `indigo`.
     *
     * @example
     * ```typescript
     * let checkbox = this.checkbox.indigo;
     * ```
     */
    get indigo() {
      return this.theme === 'indigo';
    }
    /**
     * Returns if the component is of type `bootstrap`.
     *
     * @example
     * ```typescript
     * let checkbox = this.checkbox.bootstrap;
     * ```
     */
    get bootstrap() {
      return this.theme === 'bootstrap';
    }
    /**
     * Returns if the component is of type `fluent`.
     *
     * @example
     * ```typescript
     * let checkbox = this.checkbox.fluent;
     * ```
     */
    get fluent() {
      return this.theme === 'fluent';
    }
    /**
     * Sets/gets whether the checkbox is checked.
     * Default value is `false`.
     *
     * @example
     * ```html
     * <igx-checkbox [checked]="true"></igx-checkbox>
     * ```
     * ```typescript
     * let isChecked =  this.checkbox.checked;
     * ```
     */
    set checked(value) {
      super.checked = value;
    }
    get checked() {
      return super.checked;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxCheckboxComponent_BaseFactory;
        return function IgxCheckboxComponent_Factory(__ngFactoryType__) {
          return (ɵIgxCheckboxComponent_BaseFactory || (ɵIgxCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxCheckboxComponent)))(__ngFactoryType__ || IgxCheckboxComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCheckboxComponent,
        selectors: [["igx-checkbox"]],
        hostVars: 22,
        hostBindings: function IgxCheckboxComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-checkbox", ctx.cssClass)("igx-checkbox--material", ctx.material)("igx-checkbox--indigo", ctx.indigo)("igx-checkbox--bootstrap", ctx.bootstrap)("igx-checkbox--fluent", ctx.fluent)("igx-checkbox--focused", ctx.focused)("igx-checkbox--indeterminate", ctx.indeterminate)("igx-checkbox--checked", ctx.checked)("igx-checkbox--disabled", ctx.disabled)("igx-checkbox--invalid", ctx.invalid)("igx-checkbox--plain", ctx.disableTransitions);
          }
        },
        inputs: {
          indeterminate: [2, "indeterminate", "indeterminate", booleanAttribute],
          checked: [2, "checked", "checked", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          invalid: [2, "invalid", "invalid", booleanAttribute],
          readonly: [2, "readonly", "readonly", booleanAttribute],
          disableTransitions: [2, "disableTransitions", "disableTransitions", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: EDITOR_PROVIDER,
          useExisting: IgxCheckboxComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 11,
        vars: 20,
        consts: [["checkbox", ""], ["label", ""], ["placeholderLabel", ""], ["type", "checkbox", 1, "igx-checkbox__input", 3, "change", "blur", "id", "name", "value", "tabindex", "disabled", "indeterminate", "checked", "required"], ["igxRipple", "", "igxRippleTarget", ".igx-checkbox__ripple", 1, "igx-checkbox__composite-wrapper", 3, "igxRippleDisabled", "igxRippleCentered", "igxRippleDuration"], [1, "igx-checkbox__composite"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", 1, "igx-checkbox__composite-mark"], [1, "igx-checkbox__ripple"], [3, "id"], ["width", "18", "height", "4", "x", "2", "y", "9", "rx", "1.85"], ["d", "M19.033 5a1.966 1.966 0 0 0-1.418.586l-8.479 8.577-2.753-2.77a1.971 1.971 0 0 0-2.8 0 1.998 1.998 0 0 0 0 2.822l4.155 4.196a1.955 1.955 0 0 0 2.8 0l9.879-9.99a1.998 1.998 0 0 0 0-2.821 1.966 1.966 0 0 0-1.384-.6Z"], ["d", "M4.1,12.7 9,17.6 20.3,6.3"]],
        template: function IgxCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "input", 3, 0);
            i0.ɵɵlistener("change", function IgxCheckboxComponent_Template_input_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onCheckboxChange($event));
            })("blur", function IgxCheckboxComponent_Template_input_blur_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 4)(3, "span", 5, 1);
            i0.ɵɵtemplate(5, IgxCheckboxComponent_Conditional_5_Template, 3, 0, ":svg:svg", 6)(6, IgxCheckboxComponent_Conditional_6_Template, 2, 0, ":svg:svg", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 8, 2);
            i0.ɵɵprojection(10);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.inputId)("name", ctx.name)("value", ctx.value)("tabindex", ctx.tabindex)("disabled", ctx.disabled)("indeterminate", ctx.indeterminate)("checked", ctx.checked)("required", ctx.required);
            i0.ɵɵattribute("aria-required", ctx.required)("aria-invalid", ctx.invalid)("aria-checked", ctx.ariaChecked)("aria-labelledby", ctx.ariaLabel ? null : ctx.ariaLabelledBy)("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("igxRippleDisabled", ctx.disableRipple)("igxRippleCentered", true)("igxRippleDuration", 300);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.theme === "indigo" ? 5 : 6);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.labelClass);
            i0.ɵɵproperty("id", ctx.labelId);
          }
        },
        dependencies: [IgxRippleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IgxEditRow {
  constructor(id, index, data, grid) {
    this.id = id;
    this.index = index;
    this.data = data;
    this.grid = grid;
    this.rowFormGroup = new FormGroup({});
    this.rowFormGroup = this.grid.validation.create(id, data);
  }
  createRowEditEventArgs(includeNewValue = true, event) {
    const args = {
      primaryKey: this.id,
      rowID: this.id,
      rowKey: this.id,
      rowData: this.data,
      oldValue: this.data,
      cancel: false,
      owner: this.grid,
      isAddRow: false,
      valid: this.rowFormGroup.valid,
      event
    };
    if (includeNewValue) {
      args.newValue = this.newData ?? this.data;
    }
    return args;
  }
  createRowDataEventArgs(event) {
    const args = {
      rowID: this.id,
      primaryKey: this.id,
      rowKey: this.id,
      rowData: this.newData ?? this.data,
      data: this.newData ?? this.data,
      oldValue: this.data,
      cancel: false,
      owner: this.grid,
      isAddRow: true,
      valid: this.rowFormGroup.valid,
      event
    };
    return args;
  }
  createRowEditDoneEventArgs(cachedRowData, event) {
    const updatedData = this.grid.transactions.enabled ? this.grid.transactions.getAggregatedValue(this.id, true) : this.grid.gridAPI.getRowData(this.id);
    const rowData = updatedData ?? this.grid.gridAPI.getRowData(this.id);
    const args = {
      primaryKey: this.id,
      rowID: this.id,
      rowKey: this.id,
      rowData,
      oldValue: cachedRowData,
      newValue: updatedData,
      owner: this.grid,
      isAddRow: false,
      valid: true,
      event
    };
    return args;
  }
  getClassName() {
    return this.constructor.name;
  }
}
class IgxAddRow extends IgxEditRow {
  constructor(id, index, data, recordRef, grid) {
    super(id, index, data, grid);
    this.recordRef = recordRef;
    this.isAddRow = true;
  }
  createRowEditEventArgs(includeNewValue = true, event) {
    const args = super.createRowEditEventArgs(includeNewValue, event);
    args.oldValue = null;
    args.isAddRow = true;
    args.rowData = this.newData ?? this.data;
    return args;
  }
  createRowEditDoneEventArgs(cachedRowData, event) {
    const args = super.createRowEditDoneEventArgs(null, event);
    args.isAddRow = true;
    return args;
  }
}
class IgxCell {
  constructor(id, rowIndex, column, value, _editValue, rowData, grid) {
    this.id = id;
    this.rowIndex = rowIndex;
    this.column = column;
    this.value = value;
    this._editValue = _editValue;
    this.rowData = rowData;
    this.grid = grid;
    this.grid.validation.create(id.rowID, rowData);
  }
  get editValue() {
    const formControl = this.grid.validation.getFormControl(this.id.rowID, this.column.field);
    if (formControl) {
      return formControl.value;
    }
  }
  set editValue(value) {
    const formControl = this.grid.validation.getFormControl(this.id.rowID, this.column.field);
    if (this.grid.validationTrigger === 'change') {
      // in case trigger is change, mark as touched.
      formControl.setValue(value);
      formControl.markAsTouched();
    } else {
      this.pendingValue = value;
    }
  }
  castToNumber(value) {
    if (this.column.dataType === 'number' && !this.column.inlineEditorTemplate) {
      const v = parseFloat(value);
      return !isNaN(v) && isFinite(v) ? v : 0;
    }
    return value;
  }
  createCellEditEventArgs(includeNewValue = true, event) {
    const formControl = this.grid.validation.getFormControl(this.id.rowID, this.column.field);
    const args = {
      primaryKey: this.id.rowID,
      rowID: this.id.rowID,
      rowKey: this.id.rowID,
      cellID: this.id,
      rowData: this.rowData,
      oldValue: this.value,
      cancel: false,
      column: this.column,
      owner: this.grid,
      valid: formControl ? formControl.valid : true,
      event
    };
    if (includeNewValue) {
      args.newValue = this.castToNumber(this.editValue);
    }
    return args;
  }
  createCellEditDoneEventArgs(value, event) {
    const updatedData = this.grid.transactions.enabled ? this.grid.transactions.getAggregatedValue(this.id.rowID, true) : this.rowData;
    const rowData = updatedData === null ? this.grid.gridAPI.getRowData(this.id.rowID) : updatedData;
    const formControl = this.grid.validation.getFormControl(this.id.rowID, this.column.field);
    const args = {
      primaryKey: this.id.rowID,
      rowID: this.id.rowID,
      rowKey: this.id.rowID,
      cellID: this.id,
      // rowData - should be the updated/committed rowData - this effectively should be the newValue
      // the only case we use this.rowData directly, is when there is no rowEditing or transactions enabled
      rowData,
      oldValue: this.value,
      valid: formControl ? formControl.valid : true,
      newValue: value,
      column: this.column,
      owner: this.grid,
      event
    };
    return args;
  }
}
class IgxCellCrudState {
  constructor() {
    this.cell = null;
    this.row = null;
    this.isInCompositionMode = false;
  }
  createCell(cell) {
    return this.cell = new IgxCell(cell.cellID || cell.id, cell.row.index, cell.column, cell.value, cell.value, cell.row.data, cell.grid);
  }
  createRow(cell) {
    return this.row = new IgxEditRow(cell.id.rowID, cell.rowIndex, cell.rowData, cell.grid);
  }
  sameRow(rowID) {
    return this.row && this.row.id === rowID;
  }
  sameCell(cell) {
    return this.cell.id.rowID === cell.id.rowID && this.cell.id.columnID === cell.id.columnID;
  }
  get cellInEditMode() {
    return !!this.cell;
  }
  beginCellEdit(event) {
    const args = this.cell.createCellEditEventArgs(false, event);
    this.grid.cellEditEnter.emit(args);
    if (args.cancel) {
      this.endCellEdit();
    }
  }
  cellEdit(event) {
    const args = this.cell.createCellEditEventArgs(true, event);
    this.grid.cellEdit.emit(args);
    return args;
  }
  updateCell(exit, event) {
    if (!this.cell) {
      return;
    }
    // this is needed when we are not using ngModel to update the editValue
    // so that the change event of the inlineEditorTemplate is hit before
    // trying to update any cell
    const cellNode = this.grid.gridAPI.get_cell_by_index(this.cell.id.rowIndex, this.cell.column.field)?.nativeElement;
    let activeElement;
    if (cellNode) {
      const document = cellNode.getRootNode();
      if (cellNode.contains(document.activeElement)) {
        activeElement = document.activeElement;
        this.grid.tbody.nativeElement.focus();
      }
    }
    const formControl = this.grid.validation.getFormControl(this.cell.id.rowID, this.cell.column.field);
    if (this.grid.validationTrigger === 'blur' && this.cell.pendingValue !== undefined) {
      // in case trigger is blur, update value if there's a pending one and mark as touched.
      formControl.setValue(this.cell.pendingValue);
      formControl.markAsTouched();
    }
    if (this.grid.validationTrigger === 'blur') {
      this.grid.tbody.nativeElement.focus({
        preventScroll: true
      });
    }
    let doneArgs;
    if (this.cell.column.dataType === 'date' && !isDate(this.cell.value)) {
      if (isEqual(DateTimeUtil.parseIsoDate(this.cell.value), this.cell.editValue)) {
        doneArgs = this.exitCellEdit(event);
        return doneArgs;
      }
    }
    if (isEqual(this.cell.value, this.cell.editValue)) {
      doneArgs = this.exitCellEdit(event);
      return doneArgs;
    }
    const args = this.cellEdit(event);
    if (args.cancel) {
      // the focus is needed when we cancel the cellEdit so that the activeElement stays on the editor template
      activeElement?.focus();
      return args;
    }
    this.grid.gridAPI.update_cell(this.cell);
    doneArgs = this.cellEditDone(event, false);
    if (exit) {
      doneArgs = this.exitCellEdit(event);
    }
    return {
      ...args,
      ...doneArgs
    };
  }
  cellEditDone(event, addRow) {
    const newValue = this.cell.castToNumber(this.cell.editValue);
    const doneArgs = this.cell.createCellEditDoneEventArgs(newValue, event);
    this.grid.cellEditDone.emit(doneArgs);
    if (addRow) {
      doneArgs.rowData = this.row.data;
    }
    return doneArgs;
  }
  /** Exit cell edit mode */
  exitCellEdit(event) {
    if (!this.cell) {
      return;
    }
    const newValue = this.cell.castToNumber(this.cell.editValue);
    const args = this.cell?.createCellEditDoneEventArgs(newValue, event);
    this.cell.value = newValue;
    this.grid.cellEditExit.emit(args);
    this.endCellEdit();
    return args;
  }
  /** Clears cell editing state */
  endCellEdit() {
    this.cell = null;
  }
  /** Returns whether the targeted cell is in edit mode */
  targetInEdit(rowIndex, columnIndex) {
    if (!this.cell) {
      return false;
    }
    const res = this.cell.column.index === columnIndex && this.cell.rowIndex === rowIndex;
    return res;
  }
}
class IgxRowCrudState extends IgxCellCrudState {
  constructor() {
    super(...arguments);
    this.closeRowEditingOverlay = new Subject();
    this._rowEditingBlocked = false;
    this._rowEditingStarted = false;
  }
  get primaryKey() {
    return this.grid.primaryKey;
  }
  get rowInEditMode() {
    const editRowState = this.row;
    return editRowState !== null ? this.grid.rowList.find(e => e.key === editRowState.id) : null;
  }
  get rowEditing() {
    return this.grid.rowEditable;
  }
  get nonEditable() {
    return this.grid.rowEditable && (this.grid.primaryKey === undefined || this.grid.primaryKey === null);
  }
  get rowEditingBlocked() {
    return this._rowEditingBlocked;
  }
  set rowEditingBlocked(val) {
    this._rowEditingBlocked = val;
  }
  /** Enters row edit mode */
  beginRowEdit(event) {
    if (!this.row || !(this.row.getClassName() === IgxEditRow.name)) {
      if (!this.row) {
        this.createRow(this.cell);
      }
      if (!this._rowEditingStarted) {
        const rowArgs = this.row.createRowEditEventArgs(false, event);
        this.grid.rowEditEnter.emit(rowArgs);
        if (rowArgs.cancel) {
          this.endEditMode();
          return true;
        }
        this._rowEditingStarted = true;
      }
      this.row.transactionState = this.grid.transactions.getAggregatedValue(this.row.id, true);
      this.grid.transactions.startPending();
      this.grid.openRowOverlay(this.row.id);
    }
  }
  rowEdit(event) {
    const args = this.row.createRowEditEventArgs(true, event);
    this.grid.rowEdit.emit(args);
    return args;
  }
  updateRow(commit, event) {
    if (!this.grid.rowEditable || this.grid.rowEditingOverlay && this.grid.rowEditingOverlay.collapsed || !this.row) {
      return {};
    }
    let args;
    if (commit) {
      this.row.newData = this.grid.transactions.getAggregatedValue(this.row.id, true);
      this.updateRowEditData(this.row, this.row.newData);
      args = this.rowEdit(event);
      if (args.cancel) {
        return args;
      }
    }
    args = this.endRowTransaction(commit, event);
    return args;
  }
  /**
   * @hidden @internal
   */
  endRowTransaction(commit, event) {
    this.row.newData = this.grid.transactions.getAggregatedValue(this.row.id, true);
    let rowEditArgs = this.row.createRowEditEventArgs(true, event);
    let nonCancelableArgs;
    if (!commit) {
      this.grid.transactions.endPending(false);
      const isAddRow = this.row && this.row.getClassName() === IgxAddRow.name;
      const id = this.row ? this.row.id : this.cell.id.rowID;
      if (isAddRow) {
        this.grid.validation.clear(id);
      } else {
        this.grid.validation.update(id, rowEditArgs.oldValue);
      }
    } else if (this.row.getClassName() === IgxEditRow.name) {
      rowEditArgs = this.grid.gridAPI.update_row(this.row, this.row.newData, event);
      nonCancelableArgs = this.rowEditDone(rowEditArgs.oldValue, event);
    } else {
      const rowAddArgs = this.row.createRowDataEventArgs(event);
      this.grid.rowAdd.emit(rowAddArgs);
      if (rowAddArgs.cancel) {
        return rowAddArgs;
      }
      this.grid.transactions.endPending(false);
      const parentId = this.getParentRowId();
      this.grid.gridAPI.addRowToData(this.row.newData ?? this.row.data, parentId);
      this.grid.triggerPipes();
      nonCancelableArgs = this.rowEditDone(null, event);
    }
    nonCancelableArgs = this.exitRowEdit(rowEditArgs.oldValue, event);
    return {
      ...nonCancelableArgs,
      ...rowEditArgs
    };
  }
  rowEditDone(cachedRowData, event) {
    const doneArgs = this.row.createRowEditDoneEventArgs(cachedRowData, event);
    this.grid.rowEditDone.emit(doneArgs);
    return doneArgs;
  }
  /** Exit row edit mode */
  exitRowEdit(cachedRowData, event) {
    const nonCancelableArgs = this.row.createRowEditDoneEventArgs(cachedRowData, event);
    this.grid.rowEditExit.emit(nonCancelableArgs);
    this.grid.closeRowEditingOverlay();
    this.endRowEdit();
    return nonCancelableArgs;
  }
  /** Clears row editing state */
  endRowEdit() {
    this.row = null;
    this.rowEditingBlocked = false;
    this._rowEditingStarted = false;
  }
  /** Clears cell and row editing state and closes row editing template if it is open */
  endEditMode() {
    this.endCellEdit();
    if (this.grid.rowEditable) {
      this.endRowEdit();
      this.grid.closeRowEditingOverlay();
    }
  }
  updateRowEditData(row, value) {
    const grid = this.grid;
    const rowInEditMode = grid.gridAPI.crudService.row;
    row.newData = value ?? rowInEditMode.transactionState;
    if (rowInEditMode && row.id === rowInEditMode.id) {
      // do not use spread operator here as it will copy everything over an empty object with no descriptors
      row.data = Object.assign(copyDescriptors(row.data), row.data, rowInEditMode.transactionState);
      // TODO: Workaround for updating a row in edit mode through the API
    } else if (this.grid.transactions.enabled) {
      const state = grid.transactions.getState(row.id);
      row.data = state ? Object.assign({}, row.data, state.value) : row.data;
    }
  }
  getParentRowId() {
    return null;
  }
}
class IgxRowAddCrudState extends IgxRowCrudState {
  constructor() {
    super(...arguments);
    this.addRowParent = null;
  }
  /**
   * @hidden @internal
   */
  createAddRow(parentRow, asChild) {
    this.createAddRowParent(parentRow, asChild);
    const newRec = this.grid.getEmptyRecordObjectFor(parentRow);
    const addRowIndex = this.addRowParent.index + 1;
    return this.row = new IgxAddRow(newRec.rowID, addRowIndex, newRec.data, newRec.recordRef, this.grid);
  }
  /**
   * @hidden @internal
   */
  createAddRowParent(row, newRowAsChild) {
    const rowIndex = row ? row.index : -1;
    const rowId = row ? row.key : rowIndex >= 0 ? this.grid.rowList.last.key : null;
    const isInPinnedArea = this.grid.isRecordPinnedByViewIndex(rowIndex);
    const pinIndex = this.grid.pinnedRecords.findIndex(x => x[this.primaryKey] === rowId);
    const unpinIndex = this.grid.getUnpinnedIndexById(rowId);
    this.addRowParent = {
      rowID: rowId,
      rowKey: rowId,
      index: isInPinnedArea ? pinIndex : unpinIndex,
      asChild: newRowAsChild,
      isPinned: isInPinnedArea
    };
  }
  /**
   * @hidden @internal
   */
  endRowTransaction(commit, event) {
    const isAddRow = this.row && this.row.getClassName() === IgxAddRow.name;
    if (isAddRow) {
      this.grid.rowAdded.pipe(first$2()).subscribe(addRowArgs => {
        const rowData = addRowArgs.data;
        const pinnedIndex = this.grid.pinnedRecords.findIndex(x => x[this.primaryKey] === rowData[this.primaryKey]);
        // A check whether the row is in the current view
        const viewIndex = pinnedIndex !== -1 ? pinnedIndex : this._findRecordIndexInView(rowData);
        const dataIndex = this.grid.filteredSortedData.findIndex(data => data[this.primaryKey] === rowData[this.primaryKey]);
        const isInView = viewIndex !== -1 && !this.grid.navigation.shouldPerformVerticalScroll(viewIndex, 0);
        const showIndex = isInView ? -1 : dataIndex;
        this.grid.showSnackbarFor(showIndex);
      });
    }
    const args = super.endRowTransaction(commit, event);
    if (args.cancel) {
      return args;
    }
    if (isAddRow) {
      this.endAddRow();
      if (commit) {
        const rowAddedEventArgs = {
          data: args.rowData,
          rowData: args.rowData,
          owner: this.grid,
          primaryKey: args.rowData[this.grid.primaryKey],
          rowKey: args.rowData[this.grid.primaryKey]
        };
        this.grid.rowAddedNotifier.next(rowAddedEventArgs);
        this.grid.rowAdded.emit(rowAddedEventArgs);
      }
    }
    return args;
  }
  /**
   * @hidden @internal
   */
  endAddRow() {
    this.addRowParent = null;
    this.grid.triggerPipes();
  }
  /**
   * @hidden
   * @internal
   * TODO: consider changing modifier
   */
  _findRecordIndexInView(rec) {
    return this.grid.dataView.findIndex(data => data[this.primaryKey] === rec[this.primaryKey]);
  }
  getParentRowId() {
    if (this.addRowParent.asChild) {
      return this.addRowParent.asChild ? this.addRowParent.rowID : undefined;
    } else if (this.addRowParent.rowID !== null && this.addRowParent.rowID !== undefined) {
      const spawnedForRecord = this.grid.gridAPI.get_rec_by_id(this.addRowParent.rowID);
      return spawnedForRecord?.parent?.rowID;
    }
  }
}
let IgxGridCRUDService = /*#__PURE__*/(() => {
  class IgxGridCRUDService extends IgxRowAddCrudState {
    enterEditMode(cell, event) {
      if (this.isInCompositionMode) {
        return;
      }
      if (this.nonEditable) {
        console.warn('The grid must have a `primaryKey` specified when using `rowEditable`!');
        return;
      }
      if (this.cellInEditMode) {
        // TODO: case solely for f2/enter nav that uses enterEditMode as toggle. Refactor.
        const canceled = this.endEdit(true, event);
        if (!canceled || !this.cell) {
          this.grid.tbody.nativeElement.focus();
        }
      } else {
        if (this.rowEditing) {
          // TODO rowData
          if (this.row && !this.sameRow(cell?.cellID?.rowID)) {
            this.rowEditingBlocked = this.endEdit(true, event);
            if (this.rowEditingBlocked) {
              return true;
            }
            this.rowEditingBlocked = false;
            this.endRowEdit();
          }
          this.createCell(cell);
          const canceled = this.beginRowEdit(event);
          if (!canceled) {
            this.beginCellEdit(event);
          }
        } else {
          this.createCell(cell);
          this.beginCellEdit(event);
        }
      }
    }
    /**
     * Enters add row mode by creating temporary dummy so the user can fill in new row cells.
     *
     * @param parentRow Parent row after which the Add Row UI will be rendered.
     *                  If `null` will show it at the bottom after all rows (or top if there are not rows).
     * @param asChild Specifies if the new row should be added as a child to a tree row.
     * @param event Base event that triggered the add row mode.
     */
    enterAddRowMode(parentRow, asChild, event) {
      if (!this.rowEditing && (this.grid.primaryKey === undefined || this.grid.primaryKey === null)) {
        console.warn('The grid must use row edit mode to perform row adding! Please set rowEditable to true.');
        return;
      }
      this.endEdit(true, event);
      // work with copy of original row, since context may change on collapse.
      const parentRowCopy = parentRow ? Object.assign(copyDescriptors(parentRow), parentRow) : null;
      if (parentRowCopy != null && this.grid.expansionStates.get(parentRowCopy.key)) {
        this.grid.collapseRow(parentRowCopy.key);
      }
      this.createAddRow(parentRowCopy, asChild);
      this.grid.transactions.startPending();
      if (this.addRowParent.isPinned) {
        // If parent is pinned, add the new row to pinned records
        this.grid._pinnedRecordIDs.splice(this.row.index, 0, this.row.id);
      }
      this.grid.triggerPipes();
      this.grid.notifyChanges(true);
      this.grid.navigateTo(this.row.index, -1);
      // when selecting the dummy row we need to adjust for top pinned rows
      const indexAdjust = this.grid.isRowPinningToTop ? !this.addRowParent.isPinned ? this.grid.pinnedRows.length : 0 : !this.addRowParent.isPinned ? 0 : this.grid.unpinnedRecords.length;
      // TODO: Type this without shoving a bunch of internal properties in the row type
      const dummyRow = this.grid.gridAPI.get_row_by_index(this.row.index + indexAdjust);
      dummyRow.triggerAddAnimation();
      dummyRow.cdr.detectChanges();
      dummyRow.addAnimationEnd.pipe(first$2()).subscribe(() => {
        const cell = dummyRow.cells.find(c => c.editable);
        if (cell) {
          this.grid.gridAPI.update_cell(this.cell);
          this.enterEditMode(cell, event);
          cell.activate();
        }
      });
    }
    /**
     * Finishes the row transactions on the current row and returns whether the grid editing was canceled.
     *
     * @remarks
     * If `commit === true`, passes them from the pending state to the data (or transaction service)
     * @example
     * ```html
     * <button type="button" igxButton (click)="grid.endEdit(true)">Commit Row</button>
     * ```
     * @param commit
     */
    // TODO: Implement the same representation of the method without evt emission.
    endEdit(commit = true, event) {
      if (!this.row && !this.cell) {
        return;
      }
      let args;
      if (commit) {
        args = this.updateCell(true, event);
        if (args && args.cancel) {
          return args.cancel;
        }
      } else {
        // needede because this.cell is null after exitCellEdit
        // thus the next if is always false
        const cell = this.cell;
        this.exitCellEdit(event);
        if (!this.grid.rowEditable && cell) {
          const value = this.grid.transactions.getAggregatedValue(cell.id.rowID, true) || cell.rowData;
          this.grid.validation.update(cell.id.rowID, value);
        }
      }
      args = this.updateRow(commit, event);
      this.rowEditingBlocked = args.cancel;
      if (args.cancel) {
        return true;
      }
      const activeCell = this.grid.selectionService.activeElement;
      if (event && activeCell) {
        const rowIndex = activeCell.row;
        const visibleColIndex = activeCell.layout ? activeCell.layout.columnVisibleIndex : activeCell.column;
        this.grid.navigateTo(rowIndex, visibleColIndex);
      }
      return false;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridCRUDService_BaseFactory;
        return function IgxGridCRUDService_Factory(__ngFactoryType__) {
          return (ɵIgxGridCRUDService_BaseFactory || (ɵIgxGridCRUDService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridCRUDService)))(__ngFactoryType__ || IgxGridCRUDService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridCRUDService,
        factory: IgxGridCRUDService.ɵfac
      });
    }
  }
  return IgxGridCRUDService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IGX_GRID_BASE = /*@__PURE__*/new InjectionToken('IgxGridBaseToken');
const IGX_GRID_SERVICE_BASE = /*@__PURE__*/new InjectionToken('IgxGridServiceBaseToken');
const clear = el => el === 0 || Boolean(el);
const first = arr => arr[0];
const last = arr => arr[arr.length - 1];
/* blazorCSSuppress */
class IgxSummaryOperand {
  /**
   * Counts all the records in the data source.
   * If filtering is applied, counts only the filtered records.
   * ```typescript
   * IgxSummaryOperand.count(dataSource);
   * ```
   *
   * @memberof IgxSummaryOperand
   */
  static count(data) {
    return data.length;
  }
  /**
   * Executes the static `count` method and returns `IgxSummaryResult[]`.
   * ```typescript
   * interface IgxSummaryResult {
   *   key: string;
   *   label: string;
   *   summaryResult: any;
   * }
   * ```
   * Can be overridden in the inherited classes to provide customization for the `summary`.
   * ```typescript
   * class CustomSummary extends IgxSummaryOperand {
   *   constructor() {
   *     super();
   *   }
   *   public operate(data: any[], allData: any[], fieldName: string, groupRecord: IGroupByRecord): IgxSummaryResult[] {
   *     const result = [];
   *     result.push({
   *       key: "test",
   *       label: "Test",
   *       summaryResult: IgxSummaryOperand.count(data)
   *     });
   *     return result;
   *   }
   * }
   * this.grid.getColumnByName('ColumnName').summaries = CustomSummary;
   * ```
   *
   * @memberof IgxSummaryOperand
   */
  operate(data = [], _allData = [], _fieldName, _groupRecord) {
    return [{
      key: 'count',
      label: 'Count',
      defaultFormatting: false,
      summaryResult: IgxSummaryOperand.count(data)
    }];
  }
}
/* blazorCSSuppress */
// @dynamic
class IgxNumberSummaryOperand extends IgxSummaryOperand {
  /**
   * Returns the minimum numeric value in the provided data records.
   * If filtering is applied, returns the minimum value in the filtered data records.
   * ```typescript
   * IgxNumberSummaryOperand.min(data);
   * ```
   *
   * @memberof IgxNumberSummaryOperand
   */
  static min(data) {
    return data.length && data.filter(clear).length ? data.filter(clear).reduce((a, b) => Math.min(a, b)) : 0;
  }
  /**
   * Returns the maximum numeric value in the provided data records.
   * If filtering is applied, returns the maximum value in the filtered data records.
   * ```typescript
   * IgxNumberSummaryOperand.max(data);
   * ```
   *
   * @memberof IgxNumberSummaryOperand
   */
  static max(data) {
    return data.length && data.filter(clear).length ? data.filter(clear).reduce((a, b) => Math.max(a, b)) : 0;
  }
  /**
   * Returns the sum of the numeric values in the provided data records.
   * If filtering is applied, returns the sum of the numeric values in the data records.
   * ```typescript
   * IgxNumberSummaryOperand.sum(data);
   * ```
   *
   * @memberof IgxNumberSummaryOperand
   */
  static sum(data) {
    return data.length && data.filter(clear).length ? data.filter(clear).reduce((a, b) => +a + +b) : 0;
  }
  /**
   * Returns the average numeric value in the data provided data records.
   * If filtering is applied, returns the average numeric value in the filtered data records.
   * ```typescript
   * IgxSummaryOperand.average(data);
   * ```
   *
   * @memberof IgxNumberSummaryOperand
   */
  static average(data) {
    return data.length && data.filter(clear).length ? this.sum(data) / this.count(data) : 0;
  }
  /**
   * Executes the static methods and returns `IgxSummaryResult[]`.
   * ```typescript
   * interface IgxSummaryResult {
   *   key: string;
   *   label: string;
   *   summaryResult: any;
   * }
   * ```
   * Can be overridden in the inherited classes to provide customization for the `summary`.
   * ```typescript
   * class CustomNumberSummary extends IgxNumberSummaryOperand {
   *   constructor() {
   *     super();
   *   }
   *   public operate(data: any[], allData: any[], fieldName: string, groupRecord: IGroupByRecord): IgxSummaryResult[] {
   *     const result = super.operate(data, allData, fieldName, groupRecord);
   *     result.push({
   *       key: "avg",
   *       label: "Avg",
   *       summaryResult: IgxNumberSummaryOperand.average(data)
   *     });
   *     result.push({
   *       key: 'mdn',
   *       label: 'Median',
   *       summaryResult: this.findMedian(data)
   *     });
   *     return result;
   *   }
   * }
   * this.grid.getColumnByName('ColumnName').summaries = CustomNumberSummary;
   * ```
   *
   * @memberof IgxNumberSummaryOperand
   */
  operate(data = [], allData = [], fieldName, groupRecord) {
    const result = super.operate(data, allData, fieldName, groupRecord);
    result.push({
      key: 'min',
      label: 'Min',
      defaultFormatting: true,
      summaryResult: IgxNumberSummaryOperand.min(data)
    });
    result.push({
      key: 'max',
      label: 'Max',
      defaultFormatting: true,
      summaryResult: IgxNumberSummaryOperand.max(data)
    });
    result.push({
      key: 'sum',
      label: 'Sum',
      defaultFormatting: true,
      summaryResult: IgxNumberSummaryOperand.sum(data)
    });
    result.push({
      key: 'average',
      label: 'Avg',
      defaultFormatting: true,
      summaryResult: IgxNumberSummaryOperand.average(data)
    });
    return result;
  }
}
/* blazorCSSuppress */
// @dynamic
class IgxDateSummaryOperand extends IgxSummaryOperand {
  /**
   * Returns the latest date value in the data records.
   * If filtering is applied, returns the latest date value in the filtered data records.
   * ```typescript
   * IgxDateSummaryOperand.latest(data);
   * ```
   *
   * @memberof IgxDateSummaryOperand
   */
  static latest(data) {
    return data.length && data.filter(clear).length ? first(data.filter(clear).sort((a, b) => new Date(b).valueOf() - new Date(a).valueOf())) : undefined;
  }
  /**
   * Returns the earliest date value in the data records.
   * If filtering is applied, returns the latest date value in the filtered data records.
   * ```typescript
   * IgxDateSummaryOperand.earliest(data);
   * ```
   *
   * @memberof IgxDateSummaryOperand
   */
  static earliest(data) {
    return data.length && data.filter(clear).length ? last(data.filter(clear).sort((a, b) => new Date(b).valueOf() - new Date(a).valueOf())) : undefined;
  }
  /**
   * Executes the static methods and returns `IgxSummaryResult[]`.
   * ```typescript
   * interface IgxSummaryResult {
   *   key: string;
   *   label: string;
   *   summaryResult: any;
   * }
   * ```
   * Can be overridden in the inherited classes to provide customization for the `summary`.
   * ```typescript
   * class CustomDateSummary extends IgxDateSummaryOperand {
   *   constructor() {
   *     super();
   *   }
   *   public operate(data: any[], allData: any[], fieldName: string, groupRecord: IGroupByRecord): IgxSummaryResult[] {
   *     const result = super.operate(data, allData, fieldName, groupRecord);
   *     result.push({
   *       key: "deadline",
   *       label: "Deadline Date",
   *       summaryResult: this.calculateDeadline(data);
   *     });
   *     return result;
   *   }
   * }
   * this.grid.getColumnByName('ColumnName').summaries = CustomDateSummary;
   * ```
   *
   * @memberof IgxDateSummaryOperand
   */
  operate(data = [], allData = [], fieldName, groupRecord) {
    const result = super.operate(data, allData, fieldName, groupRecord);
    result.push({
      key: 'earliest',
      label: 'Earliest',
      defaultFormatting: true,
      summaryResult: IgxDateSummaryOperand.earliest(data)
    });
    result.push({
      key: 'latest',
      label: 'Latest',
      defaultFormatting: true,
      summaryResult: IgxDateSummaryOperand.latest(data)
    });
    return result;
  }
}
/* blazorCSSuppress */
// @dynamic
class IgxTimeSummaryOperand extends IgxSummaryOperand {
  /**
   * Returns the latest time value in the data records. Compare only the time part of the date.
   * If filtering is applied, returns the latest time value in the filtered data records.
   * ```typescript
   * IgxTimeSummaryOperand.latestTime(data);
   * ```
   *
   * @memberof IgxTimeSummaryOperand
   */
  static latestTime(data) {
    return data.length && data.filter(clear).length ? first(data.filter(clear).map(v => new Date(v)).sort((a, b) => new Date().setHours(b.getHours(), b.getMinutes(), b.getSeconds()) - new Date().setHours(a.getHours(), a.getMinutes(), a.getSeconds()))) : undefined;
  }
  /**
   * Returns the earliest time value in the data records. Compare only the time part of the date.
   * If filtering is applied, returns the earliest time value in the filtered data records.
   * ```typescript
   * IgxTimeSummaryOperand.earliestTime(data);
   * ```
   *
   * @memberof IgxTimeSummaryOperand
   */
  static earliestTime(data) {
    return data.length && data.filter(clear).length ? last(data.filter(clear).map(v => new Date(v)).sort((a, b) => new Date().setHours(b.getHours(), b.getMinutes(), b.getSeconds()) - new Date().setHours(a.getHours(), a.getMinutes(), a.getSeconds()))) : undefined;
  }
  /**
   * @memberof IgxTimeSummaryOperand
   */
  operate(data = [], allData = [], fieldName, groupRecord) {
    const result = super.operate(data, allData, fieldName, groupRecord);
    result.push({
      key: 'earliest',
      label: 'Earliest',
      defaultFormatting: true,
      summaryResult: IgxTimeSummaryOperand.earliestTime(data)
    });
    result.push({
      key: 'latest',
      label: 'Latest',
      defaultFormatting: true,
      summaryResult: IgxTimeSummaryOperand.latestTime(data)
    });
    return result;
  }
}
class IgxPivotAggregate {
  /**
   * Gets array with default aggregator function for base aggregation.
   * ```typescript
   * IgxPivotAggregate.aggregators();
   * ```
   *
   * @memberof IgxPivotAggregate
   */
  static aggregators() {
    return [{
      key: 'COUNT',
      label: 'Count',
      aggregator: IgxPivotAggregate.count
    }];
  }
  /**
   * Counts all the records in the data source.
   * If filtering is applied, counts only the filtered records.
   * ```typescript
   * IgxSummaryOperand.count(dataSource);
   * ```
   *
   * @memberof IgxPivotAggregate
   */
  static count(members) {
    return members.length;
  }
}
class IgxPivotNumericAggregate extends IgxPivotAggregate {
  /**
   * Gets array with default aggregator function for numeric aggregation.
   * ```typescript
   * IgxPivotAggregate.aggregators();
   * ```
   *
   * @memberof IgxPivotAggregate
   */
  static aggregators() {
    let result = [];
    result = result.concat(super.aggregators());
    result.push({
      key: 'MIN',
      label: 'Minimum',
      aggregator: IgxPivotNumericAggregate.min
    });
    result.push({
      key: 'MAX',
      label: 'Maximum',
      aggregator: IgxPivotNumericAggregate.max
    });
    result.push({
      key: 'SUM',
      label: 'Sum',
      aggregator: IgxPivotNumericAggregate.sum
    });
    result.push({
      key: 'AVG',
      label: 'Average',
      aggregator: IgxPivotNumericAggregate.average
    });
    return result;
  }
  /**
   * Returns the minimum numeric value in the provided data records.
   * If filtering is applied, returns the minimum value in the filtered data records.
   * ```typescript
   * IgxPivotNumericAggregate.min(members, data);
   * ```
   *
   * @memberof IgxPivotNumericAggregate
   */
  static min(members) {
    return IgxNumberSummaryOperand.min(members);
  }
  /**
   * Returns the maximum numeric value in the provided data records.
   * If filtering is applied, returns the maximum value in the filtered data records.
   * ```typescript
   * IgxPivotNumericAggregate.max(data);
   * ```
   *
   * @memberof IgxPivotNumericAggregate
   */
  static max(members) {
    return IgxNumberSummaryOperand.max(members);
  }
  /**
   * Returns the sum of the numeric values in the provided data records.
   * If filtering is applied, returns the sum of the numeric values in the data records.
   * ```typescript
   * IgxPivotNumericAggregate.sum(data);
   * ```
   *
   * @memberof IgxPivotNumericAggregate
   */
  static sum(members) {
    return IgxNumberSummaryOperand.sum(members);
  }
  /**
   * Returns the average numeric value in the data provided data records.
   * If filtering is applied, returns the average numeric value in the filtered data records.
   * ```typescript
   * IgxPivotNumericAggregate.average(data);
   * ```
   *
   * @memberof IgxPivotNumericAggregate
   */
  static average(members) {
    return IgxNumberSummaryOperand.average(members);
  }
}
class IgxPivotDateAggregate extends IgxPivotAggregate {
  /**
   * Gets array with default aggregator function for date aggregation.
   * ```typescript
   * IgxPivotDateAggregate.aggregators();
   * ```
   *
   * @memberof IgxPivotAggregate
   */
  static aggregators() {
    let result = [];
    result = result.concat(super.aggregators());
    result.push({
      key: 'LATEST',
      label: 'Latest Date',
      aggregator: IgxPivotDateAggregate.latest
    });
    result.push({
      key: 'EARLIEST',
      label: 'Earliest Date',
      aggregator: IgxPivotDateAggregate.earliest
    });
    return result;
  }
  /**
   * Returns the latest date value in the data records.
   * If filtering is applied, returns the latest date value in the filtered data records.
   * ```typescript
   * IgxPivotDateAggregate.latest(data);
   * ```
   *
   * @memberof IgxPivotDateAggregate
   */
  static latest(members) {
    return IgxDateSummaryOperand.latest(members);
  }
  /**
   * Returns the earliest date value in the data records.
   * If filtering is applied, returns the latest date value in the filtered data records.
   * ```typescript
   * IgxPivotDateAggregate.earliest(data);
   * ```
   *
   * @memberof IgxPivotDateAggregate
   */
  static earliest(members) {
    return IgxDateSummaryOperand.earliest(members);
  }
}
class IgxPivotTimeAggregate extends IgxPivotAggregate {
  /**
   * Gets array with default aggregator function for time aggregation.
   * ```typescript
   * IgxPivotTimeAggregate.aggregators();
   * ```
   *
   * @memberof IgxPivotAggregate
   */
  static aggregators() {
    let result = [];
    result = result.concat(super.aggregators());
    result.push({
      key: 'LATEST',
      label: 'Latest Time',
      aggregator: IgxPivotTimeAggregate.latestTime
    });
    result.push({
      key: 'EARLIEST',
      label: 'Earliest Time',
      aggregator: IgxPivotTimeAggregate.earliestTime
    });
    return result;
  }
  /**
   * Returns the latest time value in the data records. Compare only the time part of the date.
   * If filtering is applied, returns the latest time value in the filtered data records.
   * ```typescript
   * IgxPivotTimeAggregate.latestTime(data);
   * ```
   *
   * @memberof IgxPivotTimeAggregate
   */
  static latestTime(members) {
    return IgxTimeSummaryOperand.latestTime(members);
  }
  /**
   * Returns the earliest time value in the data records. Compare only the time part of the date.
   * If filtering is applied, returns the earliest time value in the filtered data records.
   * ```typescript
   * IgxPivotTimeAggregate.earliestTime(data);
   * ```
   *
   * @memberof IgxPivotTimeAggregate
   */
  static earliestTime(members) {
    return IgxTimeSummaryOperand.earliestTime(members);
  }
}

/**
* Default pivot keys used for data processing in the pivot pipes.
*/
const DEFAULT_PIVOT_KEYS = {
  aggregations: 'aggregations',
  records: 'records',
  children: 'children',
  level: 'level',
  rowDimensionSeparator: '_',
  columnDimensionSeparator: '-'
};
/* mustCoerceToInt */
/** The dimension types - Row, Column or Filter. */
var PivotDimensionType = /*#__PURE__*/function (PivotDimensionType) {
  PivotDimensionType[PivotDimensionType["Row"] = 0] = "Row";
  PivotDimensionType[PivotDimensionType["Column"] = 1] = "Column";
  PivotDimensionType[PivotDimensionType["Filter"] = 2] = "Filter";
  return PivotDimensionType;
}(PivotDimensionType || {});
var PivotRowLayoutType = /*#__PURE__*/function (PivotRowLayoutType) {
  PivotRowLayoutType["Vertical"] = "vertical";
  PivotRowLayoutType["Horizontal"] = "horizontal";
  return PivotRowLayoutType;
}(PivotRowLayoutType || {});
var PivotSummaryPosition = /*#__PURE__*/function (PivotSummaryPosition) {
  PivotSummaryPosition["Top"] = "top";
  PivotSummaryPosition["Bottom"] = "bottom";
  return PivotSummaryPosition;
}(PivotSummaryPosition || {});
class PivotUtil {
  // go through all children and apply new dimension groups as child
  static processGroups(recs, dimension, pivotKeys, cloneStrategy) {
    for (const rec of recs) {
      // process existing children
      if (rec.children && rec.children.size > 0) {
        // process hierarchy in dept
        rec.children.forEach(values => {
          this.processGroups(values, dimension, pivotKeys, cloneStrategy);
        });
      }
      // add children for current dimension
      const hierarchyFields = PivotUtil.getFieldsHierarchy(rec.records, [dimension], PivotDimensionType.Row, pivotKeys, cloneStrategy);
      const siblingData = PivotUtil.processHierarchy(hierarchyFields, pivotKeys, 0);
      rec.children.set(dimension.memberName, siblingData);
    }
  }
  static flattenGroups(data, dimension, expansionStates, defaultExpand, parent, parentRec) {
    for (let i = 0; i < data.length; i++) {
      const rec = data[i];
      const field = dimension.memberName;
      if (!field) {
        continue;
      }
      let recordsData = rec.children.get(field);
      if (!recordsData && parent) {
        // check parent
        recordsData = rec.children.get(parent.memberName);
        if (recordsData) {
          dimension = parent;
        }
      }
      if (parentRec) {
        parentRec.dimensionValues.forEach((value, key) => {
          if (parent.memberName !== key) {
            rec.dimensionValues.set(key, value);
            const dim = parentRec.dimensions.find(x => x.memberName === key);
            rec.dimensions.unshift(dim);
          }
        });
      }
      const expansionRowKey = PivotUtil.getRecordKey(rec, dimension);
      const isExpanded = expansionStates.get(expansionRowKey) === undefined ? defaultExpand : expansionStates.get(expansionRowKey);
      const shouldExpand = isExpanded || !dimension.childLevel || !rec.dimensionValues.get(dimension.memberName);
      if (shouldExpand && recordsData) {
        if (dimension.childLevel) {
          this.flattenGroups(recordsData, dimension.childLevel, expansionStates, defaultExpand, dimension, rec);
        } else {
          // copy parent values and dims in child
          recordsData.forEach(x => {
            rec.dimensionValues.forEach((value, key) => {
              if (dimension.memberName !== key) {
                x.dimensionValues.set(key, value);
                const dim = rec.dimensions.find(y => y.memberName === key);
                x.dimensions.unshift(dim);
              }
            });
          });
        }
        data.splice(i + 1, 0, ...recordsData);
        i += recordsData.length;
      }
    }
  }
  static flattenGroupsHorizontally(data, dimension, expansionStates, defaultExpand, visibleDimensions, summariesPosition, parent, parentRec) {
    for (let i = 0; i < data.length; i++) {
      const rec = data[i];
      const field = dimension.memberName;
      if (!field) {
        continue;
      }
      if (!visibleDimensions.find(recDim => recDim.memberName === rec.dimensions[0].memberName)) {
        visibleDimensions.push(rec.dimensions[0]);
      }
      let recordsData = rec.children.get(field);
      if (!recordsData && parent) {
        // check parent
        recordsData = rec.children.get(parent.memberName);
        if (recordsData) {
          dimension = parent;
        }
      }
      if (parentRec) {
        parentRec.dimensionValues.forEach((value, key) => {
          rec.dimensionValues.set(key, value);
          const dim = parentRec.dimensions.find(x => x.memberName === key);
          rec.dimensions.unshift(dim);
        });
      }
      const expansionRowKey = PivotUtil.getRecordKey(rec, dimension);
      const isExpanded = expansionStates.get(expansionRowKey) === undefined ? defaultExpand : expansionStates.get(expansionRowKey);
      const shouldExpand = isExpanded || !dimension.childLevel || !rec.dimensionValues.get(dimension.memberName);
      if (shouldExpand && recordsData && !rec.totalRecordDimensionName) {
        if (dimension.childLevel) {
          this.flattenGroupsHorizontally(recordsData, dimension.childLevel, expansionStates, defaultExpand, visibleDimensions, summariesPosition, dimension, rec);
        } else {
          // copy parent values and dims in child
          recordsData.forEach(x => {
            rec.dimensionValues.forEach((value, key) => {
              if (dimension.memberName !== key) {
                x.dimensionValues.set(key, value);
                const dim = rec.dimensions.find(y => y.memberName === key);
                x.dimensions.unshift(dim);
              }
            });
          });
        }
        recordsData.forEach(childRec => {
          if (childRec.dimensions.length === 1) {
            rec.dimensionValues.forEach((value, key) => {
              childRec.dimensionValues.set(key, value);
            });
          }
          childRec.dimensions.forEach(dim => {
            if (!visibleDimensions.find(recDim => recDim.memberName === dim.memberName)) {
              visibleDimensions.push(dim);
            }
          });
        });
        const curDimValue = rec.dimensionValues.get(dimension.memberName);
        if (dimension.horizontalSummary && curDimValue) {
          rec.totalRecordDimensionName = dimension.memberName;
          rec.dimensionValues.set(dimension.memberName, `${curDimValue} Total`);
          if (summariesPosition === PivotSummaryPosition.Top) {
            recordsData.unshift(rec);
          } else {
            recordsData.push(rec);
          }
        }
        data.splice(i, 1, ...recordsData);
        i += recordsData.length - 1;
      }
    }
  }
  static assignLevels(dims) {
    for (const dim of dims) {
      let currDim = dim;
      let lvl = 0;
      while (currDim.childLevel) {
        currDim.level = lvl;
        currDim = currDim.childLevel;
        lvl++;
      }
      currDim.level = lvl;
    }
  }
  static getFieldsHierarchy(data, dimensions, dimensionType, pivotKeys, cloneStrategy) {
    const hierarchy = new Map();
    for (const rec of data) {
      const vals = dimensionType === PivotDimensionType.Column ? this.extractValuesForColumn(dimensions, rec, pivotKeys) : this.extractValuesForRow(dimensions, rec, pivotKeys, cloneStrategy);
      for (const [_key, val] of vals) {
        // this should go in depth also vals.children
        if (hierarchy.get(val.value) != null) {
          this.applyHierarchyChildren(hierarchy, val, rec, pivotKeys);
        } else {
          hierarchy.set(val.value, cloneStrategy.clone(val));
          this.applyHierarchyChildren(hierarchy, val, rec, pivotKeys);
        }
      }
    }
    return hierarchy;
  }
  static sort(data, expressions, sorting = new IgxSorting()) {
    data.forEach(rec => {
      const children = rec.children;
      if (children) {
        children.forEach(x => {
          this.sort(x, expressions, sorting);
        });
      }
    });
    return DataUtil.sort(data, expressions, sorting);
  }
  static extractValueFromDimension(dim, recData) {
    return dim.memberFunction ? dim.memberFunction.call(null, recData) : recData[dim.memberName];
  }
  static getDimensionDepth(dim) {
    let lvl = 0;
    while (dim.childLevel) {
      lvl++;
      dim = dim.childLevel;
    }
    return lvl;
  }
  static extractValuesForRow(dims, recData, pivotKeys, cloneStrategy) {
    const values = new Map();
    for (const col of dims) {
      if (recData[pivotKeys.level] && recData[pivotKeys.level] > 0) {
        const childData = recData[pivotKeys.records];
        return this.getFieldsHierarchy(childData, [col], PivotDimensionType.Row, pivotKeys, cloneStrategy);
      }
      const value = this.extractValueFromDimension(col, recData);
      const objValue = {};
      objValue['value'] = value;
      objValue['dimension'] = col;
      if (col.childLevel) {
        const childValues = this.extractValuesForRow([col.childLevel], recData, pivotKeys, cloneStrategy);
        objValue[pivotKeys.children] = childValues;
      }
      values.set(value, objValue);
    }
    return values;
  }
  static extractValuesForColumn(dims, recData, pivotKeys, path = []) {
    const vals = new Map();
    let lvlCollection = vals;
    const flattenedDims = this.flatten(dims);
    for (const col of flattenedDims) {
      const value = this.extractValueFromDimension(col, recData);
      path.push(value);
      const newValue = path.join(pivotKeys.columnDimensionSeparator);
      const newObj = {
        value: newValue,
        expandable: col.expandable,
        children: null,
        dimension: col
      };
      if (!newObj.children) {
        newObj.children = new Map();
      }
      lvlCollection.set(newValue, newObj);
      lvlCollection = newObj.children;
    }
    return vals;
  }
  static flatten(arr, lvl = 0) {
    const newArr = arr.reduce((acc, item) => {
      if (item) {
        item.level = lvl;
        acc.push(item);
        if (item.childLevel) {
          item.expandable = true;
          acc = acc.concat(this.flatten([item.childLevel], lvl + 1));
        }
      }
      return acc;
    }, []);
    return newArr;
  }
  static applyAggregations(rec, hierarchies, values, pivotKeys) {
    if (hierarchies.size === 0) {
      // no column groups
      const aggregationResult = this.aggregate(rec.records, values);
      this.applyAggregationRecordData(aggregationResult, undefined, rec, pivotKeys);
      return;
    }
    hierarchies.forEach(hierarchy => {
      const children = hierarchy[pivotKeys.children];
      if (children && children.size > 0) {
        this.applyAggregations(rec, children, values, pivotKeys);
        const childRecords = this.collectRecords(children, pivotKeys);
        hierarchy[pivotKeys.aggregations] = this.aggregate(childRecords, values);
        this.applyAggregationRecordData(hierarchy[pivotKeys.aggregations], hierarchy.value, rec, pivotKeys);
      } else if (hierarchy[pivotKeys.records]) {
        hierarchy[pivotKeys.aggregations] = this.aggregate(hierarchy[pivotKeys.records], values);
        this.applyAggregationRecordData(hierarchy[pivotKeys.aggregations], hierarchy.value, rec, pivotKeys);
      }
    });
  }
  static applyAggregationRecordData(aggregationData, groupName, rec, pivotKeys) {
    const aggregationKeys = Object.keys(aggregationData);
    if (aggregationKeys.length > 1) {
      aggregationKeys.forEach(key => {
        const aggregationKey = groupName ? groupName + pivotKeys.columnDimensionSeparator + key : key;
        rec.aggregationValues.set(aggregationKey, aggregationData[key]);
      });
    } else if (aggregationKeys.length === 1) {
      const aggregationKey = aggregationKeys[0];
      rec.aggregationValues.set(groupName || aggregationKey, aggregationData[aggregationKey]);
    }
  }
  static aggregate(records, values) {
    const result = {};
    for (const pivotValue of values) {
      const aggregator = PivotUtil.getAggregatorForType(pivotValue.aggregate, pivotValue.dataType);
      if (!aggregator) {
        throw `No valid aggregator found for ${pivotValue.member}. Please set either a valid aggregatorName or aggregator`;
      }
      result[pivotValue.member] = aggregator(records.map(r => r[pivotValue.member]), records);
    }
    return result;
  }
  static getAggregatorForType(aggregate, dataType) {
    let aggregator = aggregate.aggregator;
    if (aggregate.aggregatorName) {
      let aggregators = IgxPivotNumericAggregate.aggregators();
      if (!dataType || dataType === 'date' || dataType === 'dateTime') {
        aggregators = aggregators.concat(IgxPivotDateAggregate.aggregators());
      } else if (dataType === 'time') {
        aggregators = aggregators.concat(IgxPivotTimeAggregate.aggregators());
      }
      aggregator = aggregators.find(x => x.key.toLocaleLowerCase() === aggregate.aggregatorName.toLocaleLowerCase())?.aggregator;
    }
    return aggregator;
  }
  static processHierarchy(hierarchies, pivotKeys, level = 0, rootData = false) {
    const flatData = [];
    hierarchies.forEach((h, key) => {
      const field = h.dimension.memberName;
      const rec = {
        dimensionValues: new Map(),
        aggregationValues: new Map(),
        children: new Map(),
        dimensions: [h.dimension]
      };
      rec.dimensionValues.set(field, key);
      if (h[pivotKeys.records]) {
        rec.records = this.getDirectLeafs(h[pivotKeys.records]);
      }
      rec.level = level;
      flatData.push(rec);
      if (h[pivotKeys.children] && h[pivotKeys.children].size > 0) {
        const nestedData = this.processHierarchy(h[pivotKeys.children], pivotKeys, level + 1, rootData);
        rec.records = this.getDirectLeafs(nestedData);
        rec.children.set(field, nestedData);
      }
    });
    return flatData;
  }
  static getDirectLeafs(records) {
    let leafs = [];
    for (const rec of records) {
      if (rec.records) {
        const data = rec.records.filter(x => !x.records && leafs.indexOf(x) === -1);
        leafs = leafs.concat(data);
      } else {
        leafs.push(rec);
      }
    }
    return leafs;
  }
  static getRecordKey(rec, currentDim) {
    const parentFields = [];
    const currentDimIndex = rec.dimensions.findIndex(x => x.memberName === currentDim.memberName) + 1;
    const prevDims = rec.dimensions.slice(0, currentDimIndex);
    for (const prev of prevDims) {
      const prevValue = rec.dimensionValues.get(prev.memberName);
      parentFields.push(prevValue);
    }
    return parentFields.join('-');
  }
  static buildExpressionTree(config) {
    const allDimensions = (config?.rows || []).concat(config?.columns || []).concat(config?.filters || []).filter(x => x !== null && x !== undefined);
    const enabledDimensions = allDimensions.filter(x => x && x.enabled);
    const expressionsTree = new FilteringExpressionsTree(FilteringLogic.And);
    // add expression trees from all filters
    PivotUtil.flatten(enabledDimensions).forEach(x => {
      if (x.filter && x.filter.filteringOperands) {
        expressionsTree.filteringOperands.push(...x.filter.filteringOperands);
      }
    });
    return expressionsTree;
  }
  static collectRecords(children, pivotKeys) {
    let result = [];
    children.forEach(value => result = result.concat(value[pivotKeys.records]));
    return result;
  }
  static applyHierarchyChildren(hierarchy, val, rec, pivotKeys) {
    const recordsKey = pivotKeys.records;
    const childKey = pivotKeys.children;
    const childCollection = val[childKey];
    const hierarchyValue = hierarchy.get(val.value);
    if (Array.isArray(hierarchyValue[childKey])) {
      hierarchyValue[childKey] = new Map();
    }
    if (!childCollection || childCollection.size === 0) {
      const dim = hierarchyValue.dimension;
      const isValid = this.extractValueFromDimension(dim, rec) === val.value;
      if (isValid) {
        if (hierarchyValue[recordsKey]) {
          hierarchyValue[recordsKey].push(rec);
        } else {
          hierarchyValue[recordsKey] = [rec];
        }
      }
    } else {
      const hierarchyChild = hierarchyValue[childKey];
      for (const [_key, child] of childCollection) {
        let hierarchyChildValue = hierarchyChild.get(child.value);
        if (!hierarchyChildValue) {
          hierarchyChild.set(child.value, child);
          hierarchyChildValue = child;
        }
        if (hierarchyChildValue[recordsKey]) {
          const copy = Object.assign({}, rec);
          if (rec[recordsKey]) {
            // not all nested children are valid
            const nestedValue = hierarchyChildValue.value;
            const dimension = hierarchyChildValue.dimension;
            const validRecs = rec[recordsKey].filter(x => this.extractValueFromDimension(dimension, x) === nestedValue);
            copy[recordsKey] = validRecs;
          }
          hierarchyChildValue[recordsKey].push(copy);
        } else {
          hierarchyChildValue[recordsKey] = [rec];
        }
        if (child[childKey] && child[childKey].size > 0) {
          this.applyHierarchyChildren(hierarchyChild, child, rec, pivotKeys);
        }
      }
    }
  }
  static getAggregateList(val, grid) {
    if (!val.aggregateList) {
      let defaultAggr = this.getAggregatorsForValue(val, grid);
      const isDefault = defaultAggr.find(x => x.key === val.aggregate.key);
      // resolve custom aggregations
      if (!isDefault && grid.data[0][val.member] !== undefined) {
        // if field exists, then we can apply default aggregations and add the custom one.
        defaultAggr.unshift(val.aggregate);
      } else if (!isDefault) {
        // otherwise this is a custom aggregation that is not compatible
        // with the defaults, since it operates on field that is not in the data
        // leave only the custom one.
        defaultAggr = [val.aggregate];
      }
      val.aggregateList = defaultAggr;
    }
    return val.aggregateList;
  }
  static getAggregatorsForValue(value, grid) {
    const dataType = value.dataType || grid.resolveDataTypes(grid.data[0][value.member]);
    switch (dataType) {
      case GridColumnDataType.Number:
      case GridColumnDataType.Currency:
        return IgxPivotNumericAggregate.aggregators();
      case GridColumnDataType.Date:
      case GridColumnDataType.DateTime:
        return IgxPivotDateAggregate.aggregators();
      case GridColumnDataType.Time:
        return IgxPivotTimeAggregate.aggregators();
      default:
        return IgxPivotAggregate.aggregators();
    }
  }
}
let IgxGridSelectionService = /*#__PURE__*/(() => {
  class IgxGridSelectionService {
    /**
     * Returns the current selected ranges in the grid from both
     * keyboard and pointer interactions
     */
    get ranges() {
      // The last action was keyboard + shift selection -> add it
      this.addKeyboardRange();
      const ranges = Array.from(this._ranges).map(range => JSON.parse(range));
      // No ranges but we have a focused cell -> add it
      if (!ranges.length && this.activeElement && this.grid.isCellSelectable) {
        ranges.push(this.generateRange(this.activeElement));
      }
      return ranges;
    }
    get primaryButton() {
      return this.pointerState.primaryButton;
    }
    set primaryButton(value) {
      this.pointerState.primaryButton = value;
    }
    constructor(zone, platform) {
      this.zone = zone;
      this.platform = platform;
      this.dragMode = false;
      this.keyboardState = {};
      this.pointerState = {};
      this.columnsState = {};
      this.selection = new Map();
      this.temp = new Map();
      this.rowSelection = new Set();
      this.indeterminateRows = new Set();
      this.columnSelection = new Set();
      /**
       * @hidden @internal
       */
      this.selectedRowsChange = new Subject();
      /**
       * Toggled when a pointerdown event is triggered inside the grid body (cells).
       * When `false` the drag select behavior is disabled.
       */
      this.pointerEventInGridBody = false;
      this._ranges = new Set();
      this.pointerOriginHandler = event => {
        this.pointerEventInGridBody = false;
        this.grid.document.body.removeEventListener('pointerup', this.pointerOriginHandler);
        const targetTagName = event.target.tagName.toLowerCase();
        if (targetTagName !== 'igx-grid-cell' && targetTagName !== 'igx-tree-grid-cell') {
          this.pointerUp(this._lastSelectedNode, this.grid.rangeSelected, true);
        }
      };
      this.initPointerState();
      this.initKeyboardState();
      this.initColumnsState();
    }
    /**
     * Resets the keyboard state
     */
    initKeyboardState() {
      this.keyboardState.node = null;
      this.keyboardState.shift = false;
      this.keyboardState.range = null;
      this.keyboardState.active = false;
    }
    /**
     * Resets the pointer state
     */
    initPointerState() {
      this.pointerState.node = null;
      this.pointerState.ctrl = false;
      this.pointerState.shift = false;
      this.pointerState.range = null;
      this.pointerState.primaryButton = true;
    }
    /**
     * Resets the columns state
     */
    initColumnsState() {
      this.columnsState.field = null;
      this.columnsState.range = [];
    }
    /**
     * Adds a single node.
     * Single clicks | Ctrl + single clicks on cells is the usual case.
     */
    add(node, addToRange = true) {
      if (this.selection.has(node.row)) {
        this.selection.get(node.row).add(node.column);
      } else {
        this.selection.set(node.row, new Set()).get(node.row).add(node.column);
      }
      if (addToRange) {
        this._ranges.add(JSON.stringify(this.generateRange(node)));
      }
    }
    /**
     * Adds the active keyboard range selection (if any) to the `ranges` meta.
     */
    addKeyboardRange() {
      if (this.keyboardState.range) {
        this._ranges.add(JSON.stringify(this.keyboardState.range));
      }
    }
    remove(node) {
      if (this.selection.has(node.row)) {
        this.selection.get(node.row).delete(node.column);
      }
      if (this.isActiveNode(node)) {
        this.activeElement = null;
      }
      this._ranges.delete(JSON.stringify(this.generateRange(node)));
    }
    isInMap(node) {
      return this.selection.has(node.row) && this.selection.get(node.row).has(node.column) || this.temp.has(node.row) && this.temp.get(node.row).has(node.column);
    }
    selected(node) {
      return this.isActiveNode(node) && this.grid.isCellSelectable || this.isInMap(node);
    }
    isActiveNode(node) {
      if (this.activeElement) {
        const isActive = this.activeElement.column === node.column && this.activeElement.row === node.row;
        if (this.grid.hasColumnLayouts) {
          const layout = this.activeElement.layout;
          return isActive && this.isActiveLayout(layout, node.layout);
        }
        return isActive;
      }
      return false;
    }
    isActiveLayout(current, target) {
      return current.columnVisibleIndex === target.columnVisibleIndex;
    }
    addRangeMeta(node, state) {
      this._ranges.add(JSON.stringify(this.generateRange(node, state)));
    }
    removeRangeMeta(node, state) {
      this._ranges.delete(JSON.stringify(this.generateRange(node, state)));
    }
    /**
     * Generates a new selection range from the given `node`.
     * If `state` is passed instead it will generate the range based on the passed `node`
     * and the start node of the `state`.
     */
    generateRange(node, state) {
      this._lastSelectedNode = node;
      if (!state) {
        return {
          rowStart: node.row,
          rowEnd: node.row,
          columnStart: node.column,
          columnEnd: node.column
        };
      }
      const {
        row,
        column
      } = state.node;
      const rowStart = Math.min(node.row, row);
      const rowEnd = Math.max(node.row, row);
      const columnStart = Math.min(node.column, column);
      const columnEnd = Math.max(node.column, column);
      return {
        rowStart,
        rowEnd,
        columnStart,
        columnEnd
      };
    }
    /**
     *
     */
    keyboardStateOnKeydown(node, shift, shiftTab) {
      this.keyboardState.active = true;
      this.initPointerState();
      this.keyboardState.shift = shift && !shiftTab;
      if (!this.grid.navigation.isDataRow(node.row)) {
        return;
      }
      // Kb navigation with shift and no previous node.
      // Clear the current selection init the start node.
      if (this.keyboardState.shift && !this.keyboardState.node) {
        this.clear();
        this.keyboardState.node = Object.assign({}, node);
      }
    }
    keyboardStateOnFocus(node, emitter, dom) {
      const kbState = this.keyboardState;
      // Focus triggered by keyboard navigation
      if (kbState.active) {
        if (this.platform.isChromium) {
          this._moveSelectionChrome(dom);
        }
        // Start generating a range if shift is hold
        if (kbState.shift) {
          this.dragSelect(node, kbState);
          kbState.range = this.generateRange(node, kbState);
          emitter.emit(this.generateRange(node, kbState));
          return;
        }
        this.initKeyboardState();
        this.clear();
        this.add(node);
      }
    }
    pointerDown(node, shift, ctrl) {
      this.addKeyboardRange();
      this.initKeyboardState();
      this.pointerState.ctrl = ctrl;
      this.pointerState.shift = shift;
      this.pointerEventInGridBody = true;
      this.grid.document.body.addEventListener('pointerup', this.pointerOriginHandler);
      // No ctrl key pressed - no multiple selection
      if (!ctrl) {
        this.clear();
      }
      if (shift) {
        // No previously 'clicked' node. Use the last active node.
        if (!this.pointerState.node) {
          this.pointerState.node = this.activeElement || node;
        }
        this.pointerDownShiftKey(node);
        this.clearTextSelection();
        return;
      }
      this.removeRangeMeta(node);
      this.pointerState.node = node;
    }
    pointerDownShiftKey(node) {
      this.clear();
      this.selectRange(node, this.pointerState);
    }
    mergeMap(target, source) {
      const iterator = source.entries();
      let pair = iterator.next();
      let key;
      let value;
      while (!pair.done) {
        [key, value] = pair.value;
        if (target.has(key)) {
          const newValue = target.get(key);
          value.forEach(record => newValue.add(record));
          target.set(key, newValue);
        } else {
          target.set(key, value);
        }
        pair = iterator.next();
      }
    }
    pointerEnter(node, event) {
      // https://www.w3.org/TR/pointerevents/#the-button-property
      this.dragMode = event.buttons === 1 && (event.button === -1 || event.button === 0) && this.pointerEventInGridBody;
      if (!this.dragMode) {
        return false;
      }
      this.clearTextSelection();
      // If the users triggers a drag-like event by first clicking outside the grid cells
      // and then enters in the grid body we may not have a initial pointer starting node.
      // Assume the first pointerenter node is where we start.
      if (!this.pointerState.node) {
        this.pointerState.node = node;
      }
      if (this.pointerState.ctrl) {
        this.selectRange(node, this.pointerState, this.temp);
      } else {
        this.dragSelect(node, this.pointerState);
      }
      return true;
    }
    pointerUp(node, emitter, firedOutsideGrid) {
      if (this.dragMode || firedOutsideGrid) {
        this.restoreTextSelection();
        this.addRangeMeta(node, this.pointerState);
        this.mergeMap(this.selection, this.temp);
        this.zone.runTask(() => emitter.emit(this.generateRange(node, this.pointerState)));
        this.temp.clear();
        this.dragMode = false;
        return true;
      }
      if (this.pointerState.shift) {
        this.clearTextSelection();
        this.restoreTextSelection();
        this.addRangeMeta(node, this.pointerState);
        emitter.emit(this.generateRange(node, this.pointerState));
        return true;
      }
      if (this.pointerEventInGridBody && this.isActiveNode(node)) {
        this.add(node);
      }
      return false;
    }
    selectRange(node, state, collection = this.selection) {
      if (collection === this.temp) {
        collection.clear();
      }
      const {
        rowStart,
        rowEnd,
        columnStart,
        columnEnd
      } = this.generateRange(node, state);
      for (let i = rowStart; i <= rowEnd; i++) {
        for (let j = columnStart; j <= columnEnd; j++) {
          if (collection.has(i)) {
            collection.get(i).add(j);
          } else {
            collection.set(i, new Set()).get(i).add(j);
          }
        }
      }
    }
    dragSelect(node, state) {
      if (!this.pointerState.ctrl) {
        this.selection.clear();
      }
      this.selectRange(node, state);
    }
    clear(clearAcriveEl = false) {
      if (clearAcriveEl) {
        this.activeElement = null;
      }
      this.selection.clear();
      this.temp.clear();
      this._ranges.clear();
    }
    clearTextSelection() {
      const selection = window.getSelection();
      if (selection.rangeCount) {
        this._selectionRange = selection.getRangeAt(0);
        this._selectionRange.collapse(true);
        selection.removeAllRanges();
      }
    }
    restoreTextSelection() {
      const selection = window.getSelection();
      if (!selection.rangeCount) {
        selection.addRange(this._selectionRange || this.grid.document.createRange());
      }
    }
    getSelectedRowsData() {
      if (this.grid.type === 'pivot') {
        return this.grid.dataView.filter(r => {
          const keys = r.dimensions.map(d => PivotUtil.getRecordKey(r, d));
          return keys.some(k => this.isPivotRowSelected(k));
        });
      }
      if (!this.grid.primaryKey) {
        return Array.from(this.rowSelection);
      }
      const selection = [];
      const gridDataMap = {};
      this.grid.gridAPI.get_all_data(true).forEach(row => gridDataMap[this.getRecordKey(row)] = row);
      this.rowSelection.forEach(rID => {
        const rData = gridDataMap[rID];
        const partialRowData = {};
        partialRowData[this.grid.primaryKey] = rID;
        selection.push(rData ? rData : partialRowData);
      });
      return selection;
    }
    /** Returns array of the selected row id's. */
    getSelectedRows() {
      return this.rowSelection.size ? Array.from(this.rowSelection.keys()) : [];
    }
    /** Returns array of the rows in indeterminate state. */
    getIndeterminateRows() {
      return this.indeterminateRows.size ? Array.from(this.indeterminateRows.keys()) : [];
    }
    /** Clears row selection, if filtering is applied clears only selected rows from filtered data. */
    clearRowSelection(event) {
      const selectedRows = this.getSelectedRowsData();
      const removedRec = this.isFilteringApplied() ? this.allData.filter(row => this.isRowSelected(this.getRecordKey(row))) : selectedRows;
      let newSelection;
      if (this.grid.primaryKey) {
        newSelection = this.isFilteringApplied() ? selectedRows.filter(x => {
          return !removedRec.some(item => item[this.grid.primaryKey] === x[this.grid.primaryKey]);
        }) : [];
      } else {
        newSelection = this.isFilteringApplied() ? selectedRows.filter(x => !removedRec.includes(x)) : [];
      }
      this.emitRowSelectionEvent(newSelection, [], removedRec, event, selectedRows);
    }
    /** Select all rows, if filtering is applied select only from filtered data. */
    selectAllRows(event) {
      const addedRows = this.allData.filter(row => !this.rowSelection.has(this.getRecordKey(row)));
      const selectedRows = this.getSelectedRowsData();
      const newSelection = this.rowSelection.size ? selectedRows.concat(addedRows) : addedRows;
      this.indeterminateRows.clear();
      this.emitRowSelectionEvent(newSelection, addedRows, [], event, selectedRows);
    }
    /** Select the specified row and emit event. */
    selectRowById(rowID, clearPrevSelection, event) {
      if (!(this.grid.isRowSelectable || this.grid.type === 'pivot') || this.isRowDeleted(rowID)) {
        return;
      }
      clearPrevSelection = !this.grid.isMultiRowSelectionEnabled || clearPrevSelection;
      if (this.grid.type === 'pivot') {
        this.selectPivotRowById(rowID, clearPrevSelection, event);
        return;
      }
      const selectedRows = this.getSelectedRowsData();
      const newSelection = clearPrevSelection ? [this.getRowDataById(rowID)] : this.rowSelection.has(rowID) ? selectedRows : [...selectedRows, this.getRowDataById(rowID)];
      const removed = clearPrevSelection ? selectedRows : [];
      this.emitRowSelectionEvent(newSelection, [this.getRowDataById(rowID)], removed, event, selectedRows);
    }
    selectPivotRowById(rowID, clearPrevSelection, event) {
      const selectedRows = this.getSelectedRows();
      const newSelection = clearPrevSelection ? [rowID] : this.rowSelection.has(rowID) ? selectedRows : [...selectedRows, rowID];
      const added = this.getPivotRowsByIds([rowID]);
      const removed = this.getPivotRowsByIds(clearPrevSelection ? selectedRows : []);
      this.emitRowSelectionEventPivotGrid(selectedRows, newSelection, added, removed, event);
    }
    /** Deselect the specified row and emit event. */
    deselectRow(rowID, event) {
      if (!this.isRowSelected(rowID)) {
        return;
      }
      if (this.grid.type === 'pivot') {
        this.deselectPivotRowByID(rowID, event);
        return;
      }
      const selectedRows = this.getSelectedRowsData();
      const newSelection = selectedRows.filter(r => this.getRecordKey(r) !== rowID);
      if (this.rowSelection.size && this.rowSelection.has(rowID)) {
        this.emitRowSelectionEvent(newSelection, [], [this.getRowDataById(rowID)], event, selectedRows);
      }
    }
    deselectPivotRowByID(rowID, event) {
      if (this.rowSelection.size && this.rowSelection.has(rowID)) {
        const currSelection = this.getSelectedRows();
        const newSelection = currSelection.filter(r => r !== rowID);
        const removed = this.getPivotRowsByIds([rowID]);
        this.emitRowSelectionEventPivotGrid(currSelection, newSelection, [], removed, event);
      }
    }
    emitRowSelectionEventPivotGrid(currSelection, newSelection, added, removed, event) {
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const currSelectedRows = this.getSelectedRowsData();
      const args = {
        owner: this.grid,
        oldSelection: currSelectedRows,
        newSelection: this.getPivotRowsByIds(newSelection),
        added,
        removed,
        event,
        cancel: false,
        allRowsSelected: this.areAllRowSelected(newSelection)
      };
      this.grid.rowSelectionChanging.emit(args);
      if (args.cancel) {
        this.clearHeaderCBState();
        return;
      }
      this.selectRowsWithNoEvent(newSelection, true);
    }
    /** Select the specified rows and emit event. */
    selectRows(keys, clearPrevSelection, event) {
      if (!this.grid.isMultiRowSelectionEnabled) {
        return;
      }
      let rowsToSelect = keys.filter(x => !this.isRowDeleted(x) && !this.rowSelection.has(x));
      if (!rowsToSelect.length && !clearPrevSelection) {
        // no valid/additional rows to select and no clear
        return;
      }
      const selectedRows = this.getSelectedRowsData();
      rowsToSelect = this.grid.primaryKey ? rowsToSelect.map(r => this.getRowDataById(r)) : rowsToSelect;
      const newSelection = clearPrevSelection ? rowsToSelect : [...selectedRows, ...rowsToSelect];
      const keysAsSet = new Set(rowsToSelect);
      const removed = clearPrevSelection ? selectedRows.filter(x => !keysAsSet.has(x)) : [];
      this.emitRowSelectionEvent(newSelection, rowsToSelect, removed, event, selectedRows);
    }
    deselectRows(keys, event) {
      if (!this.rowSelection.size) {
        return;
      }
      let rowsToDeselect = keys.filter(x => this.rowSelection.has(x));
      if (!rowsToDeselect.length) {
        return;
      }
      const selectedRows = this.getSelectedRowsData();
      rowsToDeselect = this.grid.primaryKey ? rowsToDeselect.map(r => this.getRowDataById(r)) : rowsToDeselect;
      const keysAsSet = new Set(rowsToDeselect);
      const newSelection = selectedRows.filter(r => !keysAsSet.has(r));
      this.emitRowSelectionEvent(newSelection, [], rowsToDeselect, event, selectedRows);
    }
    /** Select specified rows. No event is emitted. */
    selectRowsWithNoEvent(rowIDs, clearPrevSelection) {
      if (clearPrevSelection) {
        this.rowSelection.clear();
      }
      rowIDs.forEach(rowID => this.rowSelection.add(rowID));
      this.clearHeaderCBState();
      this.selectedRowsChange.next(rowIDs);
    }
    /** Deselect specified rows. No event is emitted. */
    deselectRowsWithNoEvent(rowIDs) {
      this.clearHeaderCBState();
      rowIDs.forEach(rowID => this.rowSelection.delete(rowID));
      this.selectedRowsChange.next(this.getSelectedRows());
    }
    isRowSelected(rowID) {
      return this.rowSelection.size > 0 && this.rowSelection.has(rowID);
    }
    isPivotRowSelected(rowID) {
      let contains = false;
      this.rowSelection.forEach(x => {
        const correctRowId = rowID.replace(x, '');
        if (rowID.includes(x) && (correctRowId === '' || correctRowId.startsWith('_'))) {
          contains = true;
          return;
        }
      });
      return this.rowSelection.size > 0 && contains;
    }
    isRowInIndeterminateState(rowID) {
      return this.indeterminateRows.size > 0 && this.indeterminateRows.has(rowID);
    }
    /** Select range from last selected row to the current specified row. */
    selectMultipleRows(rowID, rowData, event) {
      this.clearHeaderCBState();
      if (!this.rowSelection.size || this.isRowDeleted(rowID)) {
        this.selectRowById(rowID);
        return;
      }
      const gridData = this.allData;
      const lastRowID = this.getSelectedRows()[this.rowSelection.size - 1];
      const currIndex = gridData.indexOf(this.getRowDataById(lastRowID));
      const newIndex = gridData.indexOf(rowData);
      const rows = gridData.slice(Math.min(currIndex, newIndex), Math.max(currIndex, newIndex) + 1);
      const currSelection = this.getSelectedRowsData();
      const added = rows.filter(r => !this.isRowSelected(this.getRecordKey(r)));
      const newSelection = currSelection.concat(added);
      this.emitRowSelectionEvent(newSelection, added, [], event, currSelection);
    }
    areAllRowSelected(newSelection) {
      if (!this.grid.data && !newSelection) {
        return false;
      }
      if (this.allRowsSelected !== undefined && !newSelection) {
        return this.allRowsSelected;
      }
      const selectedData = new Set(this.getRowIDs(newSelection || this.rowSelection));
      return this.allRowsSelected = this.allData.length > 0 && this.allData.every(row => selectedData.has(this.getRecordKey(row)));
    }
    hasSomeRowSelected() {
      const filteredData = this.isFilteringApplied() ? this.getRowIDs(this.grid.filteredData).some(rID => this.isRowSelected(rID)) : true;
      return this.rowSelection.size > 0 && filteredData && !this.areAllRowSelected();
    }
    get filteredSelectedRowIds() {
      return this.isFilteringApplied() ? this.getRowIDs(this.allData).filter(rowID => this.isRowSelected(rowID)) : this.getSelectedRows().filter(rowID => !this.isRowDeleted(rowID));
    }
    emitRowSelectionEvent(newSelection, added, removed, event, currSelection) {
      currSelection = currSelection ?? this.getSelectedRowsData();
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const args = {
        owner: this.grid,
        oldSelection: currSelection,
        newSelection,
        added,
        removed,
        event,
        cancel: false,
        allRowsSelected: this.areAllRowSelected(newSelection)
      };
      this.grid.rowSelectionChanging.emit(args);
      if (args.cancel) {
        this.clearHeaderCBState();
        return;
      }
      this.selectRowsWithNoEvent(args.newSelection.map(r => this.getRecordKey(r)), true);
    }
    getPivotRowsByIds(ids) {
      return this.grid.dataView.filter(r => {
        const keys = r.dimensions.map(d => PivotUtil.getRecordKey(r, d));
        return new Set(ids.concat(keys)).size < ids.length + keys.length;
      });
    }
    getRowDataById(rowID) {
      if (!this.grid.primaryKey) {
        return rowID;
      }
      const rowIndex = this.getRowIDs(this.grid.gridAPI.get_all_data(true)).indexOf(rowID);
      return rowIndex < 0 ? rowID : this.grid.gridAPI.get_all_data(true)[rowIndex];
    }
    clearHeaderCBState() {
      this.allRowsSelected = undefined;
    }
    getRowIDs(data) {
      return this.grid.primaryKey && data.length ? data.map(rec => rec[this.grid.primaryKey]) : data;
    }
    getRecordKey(record) {
      return this.grid.primaryKey ? record[this.grid.primaryKey] : record;
    }
    /** Clear rowSelection and update checkbox state */
    clearAllSelectedRows() {
      this.rowSelection.clear();
      this.indeterminateRows.clear();
      this.clearHeaderCBState();
      this.selectedRowsChange.next([]);
    }
    /** Returns all data in the grid, with applied filtering and sorting and without deleted rows. */
    get allData() {
      let allData;
      // V.T. Jan 17th, 2024 #13757 Adding an additional conditional check to take account WITHIN range of groups
      if (this.isFilteringApplied() || this.grid.sortingExpressions.length || this.grid.groupingExpressions?.length) {
        allData = this.grid.pinnedRecordsCount ? this.grid._filteredSortedUnpinnedData : this.grid.filteredSortedData;
      } else {
        allData = this.grid.gridAPI.get_all_data(true);
      }
      return allData.filter(rData => !this.isRowDeleted(this.grid.gridAPI.get_row_id(rData)));
    }
    /** Returns array of the selected columns fields. */
    getSelectedColumns() {
      return this.columnSelection.size ? Array.from(this.columnSelection.keys()) : [];
    }
    isColumnSelected(field) {
      return this.columnSelection.size > 0 && this.columnSelection.has(field);
    }
    /** Select the specified column and emit event. */
    selectColumn(field, clearPrevSelection, selectColumnsRange, event) {
      const stateColumn = this.columnsState.field ? this.grid.getColumnByName(this.columnsState.field) : null;
      if (!event || !stateColumn || stateColumn.visibleIndex < 0 || !selectColumnsRange) {
        this.columnsState.field = field;
        this.columnsState.range = [];
        const newSelection = clearPrevSelection ? [field] : this.getSelectedColumns().indexOf(field) !== -1 ? this.getSelectedColumns() : [...this.getSelectedColumns(), field];
        const removed = clearPrevSelection ? this.getSelectedColumns().filter(colField => colField !== field) : [];
        const added = this.isColumnSelected(field) ? [] : [field];
        this.emitColumnSelectionEvent(newSelection, added, removed, event);
      } else if (selectColumnsRange) {
        this.selectColumnsRange(field, event);
      }
    }
    /** Select specified columns. And emit event. */
    selectColumns(fields, clearPrevSelection, selectColumnsRange, event) {
      const columns = fields.map(f => this.grid.getColumnByName(f)).sort((a, b) => a.visibleIndex - b.visibleIndex);
      const stateColumn = this.columnsState.field ? this.grid.getColumnByName(this.columnsState.field) : null;
      if (!stateColumn || stateColumn.visibleIndex < 0 || !selectColumnsRange) {
        this.columnsState.field = columns[0] ? columns[0].field : null;
        this.columnsState.range = [];
        const added = fields.filter(colField => !this.isColumnSelected(colField));
        const removed = clearPrevSelection ? this.getSelectedColumns().filter(colField => fields.indexOf(colField) === -1) : [];
        const newSelection = clearPrevSelection ? fields : this.getSelectedColumns().concat(added);
        this.emitColumnSelectionEvent(newSelection, added, removed, event);
      } else {
        const filedStart = stateColumn.visibleIndex > columns[columns.length - 1].visibleIndex ? columns[0].field : columns[columns.length - 1].field;
        this.selectColumnsRange(filedStart, event);
      }
    }
    /** Select range from last clicked column to the current specified column. */
    selectColumnsRange(field, event) {
      const currIndex = this.grid.getColumnByName(this.columnsState.field).visibleIndex;
      const newIndex = this.grid.columnToVisibleIndex(field);
      const columnsFields = this.grid.visibleColumns.filter(c => !c.columnGroup).sort((a, b) => a.visibleIndex - b.visibleIndex).slice(Math.min(currIndex, newIndex), Math.max(currIndex, newIndex) + 1).filter(col => col.selectable).map(col => col.field);
      const removed = [];
      const oldAdded = [];
      const added = columnsFields.filter(colField => !this.isColumnSelected(colField));
      this.columnsState.range.forEach(f => {
        if (columnsFields.indexOf(f) === -1) {
          removed.push(f);
        } else {
          oldAdded.push(f);
        }
      });
      this.columnsState.range = columnsFields.filter(colField => !this.isColumnSelected(colField) || oldAdded.indexOf(colField) > -1);
      const newSelection = this.getSelectedColumns().concat(added).filter(c => removed.indexOf(c) === -1);
      this.emitColumnSelectionEvent(newSelection, added, removed, event);
    }
    /** Select specified columns. No event is emitted. */
    selectColumnsWithNoEvent(fields, clearPrevSelection) {
      if (clearPrevSelection) {
        this.columnSelection.clear();
      }
      fields.forEach(field => {
        this.columnSelection.add(field);
      });
    }
    /** Deselect the specified column and emit event. */
    deselectColumn(field, event) {
      this.initColumnsState();
      const newSelection = this.getSelectedColumns().filter(c => c !== field);
      this.emitColumnSelectionEvent(newSelection, [], [field], event);
    }
    /** Deselect specified columns. No event is emitted. */
    deselectColumnsWithNoEvent(fields) {
      fields.forEach(field => this.columnSelection.delete(field));
    }
    /** Deselect specified columns. And emit event. */
    deselectColumns(fields, event) {
      const removed = this.getSelectedColumns().filter(colField => fields.indexOf(colField) > -1);
      const newSelection = this.getSelectedColumns().filter(colField => fields.indexOf(colField) === -1);
      this.emitColumnSelectionEvent(newSelection, [], removed, event);
    }
    emitColumnSelectionEvent(newSelection, added, removed, event) {
      const currSelection = this.getSelectedColumns();
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const args = {
        oldSelection: currSelection,
        newSelection,
        added,
        removed,
        event,
        cancel: false
      };
      this.grid.columnSelectionChanging.emit(args);
      if (args.cancel) {
        return;
      }
      this.selectColumnsWithNoEvent(args.newSelection, true);
    }
    /** Clear columnSelection */
    clearAllSelectedColumns() {
      this.columnSelection.clear();
    }
    areEqualCollections(first, second) {
      return first.length === second.length && new Set(first.concat(second)).size === first.length;
    }
    /**
     * (╯°□°）╯︵ ┻━┻
     * Chrome and Chromium don't care about the active
     * range after keyboard navigation, thus this.
     */
    _moveSelectionChrome(node) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      const range = new Range();
      range.selectNode(node);
      range.collapse(true);
      selection.addRange(range);
    }
    isFilteringApplied() {
      return !FilteringExpressionsTree.empty(this.grid.filteringExpressionsTree) || !FilteringExpressionsTree.empty(this.grid.advancedFilteringExpressionsTree);
    }
    isRowDeleted(rowID) {
      return this.grid.gridAPI.row_deleted_transaction(rowID);
    }
    static {
      this.ɵfac = function IgxGridSelectionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridSelectionService)(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(PlatformUtil));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridSelectionService,
        factory: IgxGridSelectionService.ɵfac
      });
    }
  }
  return IgxGridSelectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxRowDirective = /*#__PURE__*/(() => {
  class IgxRowDirective {
    /**
     *  The data passed to the row component.
     *
     * ```typescript
     * // get the row data for the first selected row
     * let selectedRowData = this.grid.selectedRows[0].data;
     * ```
     */
    get data() {
      if (this.inEditMode) {
        return mergeWith(this.grid.dataCloneStrategy.clone(this._data), this.grid.transactions.getAggregatedValue(this.key, false), (objValue, srcValue) => {
          if (Array.isArray(srcValue)) {
            return objValue = srcValue;
          }
        });
      }
      return this._data;
    }
    set data(v) {
      this._data = v;
    }
    /**
     * Sets whether the row is pinned.
     * Default value is `false`.
     * ```typescript
     * this.grid.selectedRows[0].pinned = true;
     * ```
     */
    set pinned(value) {
      if (value) {
        this.grid.pinRow(this.key);
      } else {
        this.grid.unpinRow(this.key);
      }
    }
    /**
     * Gets whether the row is pinned.
     * ```typescript
     * let isPinned = row.pinned;
     * ```
     */
    get pinned() {
      return this.grid.isRecordPinned(this.data);
    }
    /**
     * Gets the expanded state of the row.
     * ```typescript
     * let isExpanded = row.expanded;
     * ```
     */
    get expanded() {
      return this.grid.gridAPI.get_row_expansion_state(this.data);
    }
    /**
     * Expands/collapses the current row.
     *
     * ```typescript
     * this.grid.selectedRows[2].expanded = true;
     * ```
     */
    set expanded(val) {
      this.grid.gridAPI.set_row_expansion_state(this.key, val);
    }
    get addRowUI() {
      return !!this.grid.crudService.row && this.grid.crudService.row.getClassName() === IgxAddRow.name && this.grid.crudService.row.id === this.key;
    }
    get rowHeight() {
      let height = this.grid.rowHeight || 32;
      if (this.grid.hasColumnLayouts) {
        const maxRowSpan = this.grid.multiRowLayoutRowSize;
        height = height * maxRowSpan;
      }
      return this.addRowUI ? height : null;
    }
    /* blazorSuppress */
    get virtDirRow() {
      return this._virtDirRow ? this._virtDirRow.first : null;
    }
    /**
     * Gets the rendered cells in the row component.
     *
     * ```typescript
     * // get the cells of the third selected row
     * let selectedRowCells = this.grid.selectedRows[2].cells;
     * ```
     */
    get cells() {
      const res = new QueryList();
      if (!this._cells) {
        return res;
      }
      const cList = this._cells.filter(item => item.nativeElement.parentElement !== null).sort((item1, item2) => item1.column.visibleIndex - item2.column.visibleIndex);
      res.reset(cList);
      return res;
    }
    get dataRowIndex() {
      return this.index;
    }
    /**
     * @hidden
     */
    get selected() {
      return this.selectionService.isRowSelected(this.key);
    }
    set selected(value) {
      if (value) {
        this.selectionService.selectRowsWithNoEvent([this.key]);
      } else {
        this.selectionService.deselectRowsWithNoEvent([this.key]);
      }
      this.grid.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    get columns() {
      return this.grid.visibleColumns;
    }
    /**
     * @hidden
     * @internal
     */
    get viewIndex() {
      if (this.grid.groupingExpressions.length) {
        return this.grid.filteredSortedData.indexOf(this.data);
      }
      return this.index + this.grid.page * this.grid.perPage;
    }
    /**
     * @hidden
     */
    get pinnedColumns() {
      return this.grid.pinnedColumns;
    }
    /**
     * @hidden
     */
    get isRoot() {
      return true;
    }
    /**
     * @hidden
     */
    get hasChildren() {
      return false;
    }
    /**
     * @hidden
     */
    get unpinnedColumns() {
      return this.grid.unpinnedColumns;
    }
    /**
     * @hidden
     */
    get showRowSelectors() {
      return this.grid.showRowSelectors;
    }
    /** @hidden */
    get dirty() {
      const row = this.grid.transactions.getState(this.key);
      if (row) {
        return row.type === TransactionType.ADD || row.type === TransactionType.UPDATE;
      }
      return false;
    }
    /**
     * @hidden
     */
    get rowDraggable() {
      return this.grid.rowDraggable;
    }
    /** @hidden */
    get added() {
      const row = this.grid.transactions.getState(this.key);
      if (row) {
        return row.type === TransactionType.ADD;
      }
      return false;
    }
    /** @hidden */
    get deleted() {
      return this.grid.gridAPI.row_deleted_transaction(this.key);
    }
    /**
     * @hidden
     */
    get dragging() {
      return this.grid.dragRowID === this.key;
    }
    // TODO: Refactor
    get inEditMode() {
      if (this.grid.rowEditable) {
        const editRowState = this.grid.crudService.row;
        return editRowState && editRowState.id === this.key || false;
      } else {
        return false;
      }
    }
    /**
     * Gets the ID of the row.
     * A row in the grid is identified either by:
     * - primaryKey data value,
     * - the whole data, if the primaryKey is omitted.
     *
     * ```typescript
     * let rowID = this.grid.selectedRows[2].key;
     * ```
     */
    get key() {
      const primaryKey = this.grid.primaryKey;
      if (this._data) {
        return primaryKey ? this._data[primaryKey] : this._data;
      } else {
        return undefined;
      }
    }
    /**
     * The native DOM element representing the row. Could be null in certain environments.
     *
     * ```typescript
     * // get the nativeElement of the second selected row
     * let selectedRowNativeElement = this.grid.selectedRows[1].nativeElement;
     * ```
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(grid, selectionService, element, cdr) {
      this.grid = grid;
      this.selectionService = selectionService;
      this.element = element;
      this.cdr = cdr;
      /**
       * @hidden
       */
      this.addAnimationEnd = new EventEmitter();
      /**
       * @hidden
       */
      this.role = 'row';
      /**
       * Sets whether this specific row has disabled functionality for editing and row selection.
       * Default value is `false`.
       * ```typescript
       * this.grid.selectedRows[0].pinned = true;
       * ```
       */
      this.disabled = false;
      /**
       * @hidden
       */
      this.focused = false;
      /**
       * @hidden
       * @internal
       */
      this.defaultCssClass = 'igx-grid__tr';
      /**
       * @hidden
       */
      this.triggerAddAnimationClass = false;
      this.destroy$ = new Subject();
      /**
       * - state persistence switching all pinned columns resets collection
       * - MRL unpinnedColumns igxFor modes entire child loop on unpin
       */
      this.trackPinnedColumn = trackByIdentity;
    }
    /**
     * @hidden
     * @internal
     */
    onClick(event) {
      this.grid.rowClick.emit({
        row: this,
        event
      });
      if (this.grid.rowSelection === 'none' || this.deleted || !this.grid.selectRowOnClick) {
        return;
      }
      if (event.shiftKey && this.grid.isMultiRowSelectionEnabled) {
        this.selectionService.selectMultipleRows(this.key, this.data, event);
        return;
      }
      const clearSelection = !(+event.ctrlKey ^ +event.metaKey);
      if (this.selected && !clearSelection) {
        this.selectionService.deselectRow(this.key, event);
      } else {
        this.selectionService.selectRowById(this.key, clearSelection, event);
      }
    }
    /**
     * @hidden
     * @internal
     */
    onContextMenu(event) {
      const cell = event.target.closest('.igx-grid__td');
      this.grid.contextMenu.emit({
        row: this,
        cell: this.cells.find(c => c.nativeElement === cell),
        event
      });
    }
    /**
     * @hidden
     * @internal
     */
    showActionStrip() {
      if (this.grid.actionStrip) {
        this.grid.actionStrip.show(this);
      }
    }
    /**
     * @hidden
     * @internal
     */
    hideActionStrip() {
      if (this.grid.actionStrip && this.grid.actionStrip.hideOnRowLeave) {
        this.grid.actionStrip.hide();
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterViewInit() {
      // If the template of the row changes, the forOf in it is recreated and is not detected by the grid and rows can't be scrolled.
      this._virtDirRow.changes.pipe(takeUntil(this.destroy$)).subscribe(() => this.grid.resetHorizontalVirtualization());
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden
     */
    onRowSelectorClick(event) {
      event.stopPropagation();
      if (event.shiftKey && this.grid.isMultiRowSelectionEnabled) {
        this.selectionService.selectMultipleRows(this.key, this.data, event);
        return;
      }
      if (this.selected) {
        this.selectionService.deselectRow(this.key, event);
      } else {
        this.selectionService.selectRowById(this.key, false, event);
      }
    }
    /**
     * Updates the specified row object and the data source record with the passed value.
     *
     * ```typescript
     * // update the second selected row's value
     * let newValue = "Apple";
     * this.grid.selectedRows[1].update(newValue);
     * ```
     */
    update(value) {
      const crudService = this.grid.crudService;
      if (crudService.cellInEditMode && crudService.cell.id.key === this.key) {
        this.grid.transactions.endPending(false);
      }
      const row = new IgxEditRow(this.key, this.index, this.data, this.grid);
      this.grid.gridAPI.update_row(row, value);
      this.cdr.markForCheck();
    }
    /**
     * Removes the specified row from the grid's data source.
     * This method emits `rowDeleted` event.
     *
     * ```typescript
     * // delete the third selected row from the grid
     * this.grid.selectedRows[2].delete();
     * ```
     */
    delete() {
      this.grid.deleteRowById(this.key);
    }
    isCellActive(visibleColumnIndex) {
      const node = this.grid.navigation.activeNode;
      return node ? node.row === this.index && node.column === visibleColumnIndex : false;
    }
    /**
     * Pins the specified row.
     * This method emits `rowPinning`\`rowPinned` event.
     *
     * ```typescript
     * // pin the selected row from the grid
     * this.grid.selectedRows[0].pin();
     * ```
     */
    pin() {
      return this.grid.pinRow(this.key);
    }
    /**
     * Unpins the specified row.
     * This method emits `rowPinning`\`rowPinned` event.
     *
     * ```typescript
     * // unpin the selected row from the grid
     * this.grid.selectedRows[0].unpin();
     * ```
     */
    unpin() {
      return this.grid.unpinRow(this.key);
    }
    /**
     * @hidden
     */
    get rowCheckboxAriaLabel() {
      return this.grid.primaryKey ? this.selected ? 'Deselect row with key ' + this.key : 'Select row with key ' + this.key : this.selected ? 'Deselect row' : 'Select row';
    }
    /**
     * @hidden
     */
    ngDoCheck() {
      this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    shouldDisplayPinnedChip(visibleColumnIndex) {
      return this.pinned && this.disabled && visibleColumnIndex === 0;
    }
    /**
     * Spawns the add row UI for the specific row.
     *
     * @example
     * ```typescript
     * const row = this.grid1.getRowByIndex(1);
     * row.beginAddRow();
     * ```
     */
    beginAddRow() {
      this.grid.crudService.enterAddRowMode(this);
    }
    /**
     * @hidden
     */
    triggerAddAnimation() {
      this.triggerAddAnimationClass = true;
    }
    /**
     * @hidden
     */
    animationEndHandler() {
      this.triggerAddAnimationClass = false;
      this.addAnimationEnd.emit(this);
    }
    /**
     * @hidden
     */
    get resolveDragIndicatorClasses() {
      const defaultDragIndicatorCssClass = 'igx-grid__drag-indicator';
      const dragIndicatorOff = this.grid.rowDragging && !this.dragging ? 'igx-grid__drag-indicator--off' : '';
      return `${defaultDragIndicatorCssClass} ${dragIndicatorOff}`;
    }
    static {
      this.ɵfac = function IgxRowDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowDirective)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowDirective,
        selectors: [["", "igxRowBaseComponent", ""]],
        viewQuery: function IgxRowDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxCheckboxComponent, 5, IgxCheckboxComponent);
            i0.ɵɵviewQuery(_c22, 5, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c23, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._virtDirRow = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._cells = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxRowDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxRowDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("contextmenu", function IgxRowDirective_contextmenu_HostBindingHandler($event) {
              return ctx.onContextMenu($event);
            })("mouseenter", function IgxRowDirective_mouseenter_HostBindingHandler() {
              return ctx.showActionStrip();
            })("mouseleave", function IgxRowDirective_mouseleave_HostBindingHandler() {
              return ctx.hideActionStrip();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("aria-disabled", ctx.disabled)("data-rowIndex", ctx.dataRowIndex)("aria-selected", ctx.selected);
            i0.ɵɵstyleProp("min-height", ctx.rowHeight, "px");
            i0.ɵɵclassProp("igx-grid__tr--disabled", ctx.disabled);
          }
        },
        inputs: {
          data: "data",
          index: "index",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          gridID: "gridID",
          selected: "selected"
        },
        outputs: {
          addAnimationEnd: "addAnimationEnd"
        }
      });
    }
  }
  return IgxRowDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* contentParent: ActionStrip */
/* wcElementTag: igc-grid-action-base-directive */
/* jsonAPIManageCollectionInMarkup */
/* blazorIndirectRender */
let IgxGridActionsBaseDirective = /*#__PURE__*/(() => {
  class IgxGridActionsBaseDirective {
    /**
     * @hidden
     * @internal
     */
    get grid() {
      return this.strip.context.grid;
    }
    /**
     * Getter to be used in template
     *
     * @hidden
     * @internal
     */
    get isRowContext() {
      return this.isRow(this.strip?.context) && !this.strip.context.inEditMode;
    }
    constructor(iconService, differs) {
      this.iconService = iconService;
      this.differs = differs;
      /**
       * Gets/Sets if the action buttons will be rendered as menu items. When in menu, items will be rendered with text label.
       *
       * @example
       * ```html
       *  <igx-grid-pinning-actions [asMenuItems]='true'></igx-grid-pinning-actions>
       *  <igx-grid-editing-actions [asMenuItems]='true'></igx-grid-editing-actions>
       * ```
       */
      this.asMenuItems = false;
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterViewInit() {
      if (this.asMenuItems) {
        this.buttons.changes.subscribe(() => {
          this.strip.cdr.detectChanges();
        });
      }
    }
    /**
     * Check if the param is a row from a grid
     *
     * @hidden
     * @internal
     * @param context
     */
    isRow(context) {
      return context && context instanceof IgxRowDirective;
    }
    static {
      this.ɵfac = function IgxGridActionsBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridActionsBaseDirective)(i0.ɵɵdirectiveInject(IgxIconService), i0.ɵɵdirectiveInject(i0.IterableDiffers));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridActionsBaseDirective,
        selectors: [["", "igxGridActionsBase", ""]],
        viewQuery: function IgxGridActionsBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxGridActionButtonComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttons = _t);
          }
        },
        inputs: {
          asMenuItems: [2, "asMenuItems", "asMenuItems", booleanAttribute]
        }
      });
    }
  }
  return IgxGridActionsBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* csSuppress */
/** @hidden @internal */
class IgxActionStripToken {}
let IgxActionStripMenuItemDirective = /*#__PURE__*/(() => {
  class IgxActionStripMenuItemDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static {
      this.ɵfac = function IgxActionStripMenuItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxActionStripMenuItemDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxActionStripMenuItemDirective,
        selectors: [["", "igxActionStripMenuItem", ""]]
      });
    }
  }
  return IgxActionStripMenuItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorElement */
/* jsonAPIManageItemInMarkup */
/* jsonAPIManageCollectionInMarkup */
/* wcElementTag: igc-action-strip */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/* contentParent: GridBaseDirective */
/* contentParent: RowIsland */
/* contentParent: HierarchicalGrid */
/**
 * Action Strip provides templatable area for one or more actions.
 *
 * @igxModule IgxActionStripModule
 *
 * @igxTheme igx-action-strip-theme
 *
 * @igxKeywords action, strip, actionStrip, pinning, editing
 *
 * @igxGroup Data Entry & Display
 *
 * @igxParent IgxGridComponent, IgxTreeGridComponent, IgxHierarchicalGridComponent, IgxRowIslandComponent, *
 *
 * @remarks
 * The Ignite UI Action Strip is a container, overlaying its parent container,
 * and displaying action buttons with action applicable to the parent component the strip is instantiated or shown for.
 *
 * @example
 * ```html
 * <igx-action-strip #actionStrip>
 *     <igx-icon (click)="doSomeAction()"></igx-icon>
 * </igx-action-strip>
 */
let IgxActionStripComponent = /*#__PURE__*/(() => {
  class IgxActionStripComponent {
    /**
     * Gets/Sets the resource strings.
     *
     * @remarks
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Hide or not the Action Strip based on if it is a menu.
     *
     * @hidden
     * @internal
     */
    get hideOnRowLeave() {
      if (this.menu.items.length === 0) {
        return true;
      } else if (this.menu.items.length > 0) {
        if (this.menu.collapsed) {
          return true;
        } else {
          return false;
        }
      }
    }
    constructor(_viewContainer, renderer, el, /** @hidden @internal **/
    cdr) {
      this._viewContainer = _viewContainer;
      this.renderer = renderer;
      this.el = el;
      this.cdr = cdr;
      /**
       * Gets/Sets the visibility of the Action Strip.
       * Could be used to set if the Action Strip will be initially hidden.
       *
       * @example
       * ```html
       *  <igx-action-strip [hidden]="false">
       * ```
       */
      this.hidden = false;
      /**
       * Getter for menu overlay settings
       *
       * @hidden
       * @internal
       */
      this.menuOverlaySettings = {
        scrollStrategy: new CloseScrollStrategy()
      };
      this._hidden = false;
      this._resourceStrings = getCurrentResourceStrings(ActionStripResourceStringsEN);
      /**
       * Host `attr.class` binding.
       */
      this.hostClass = 'igx-action-strip';
      /** pin swapping w/ unpin resets the menuItems collection */
      this.trackMenuItem = trackByIdentity;
    }
    /**
     * Menu Items list.
     *
     * @hidden
     * @internal
     */
    get menuItems() {
      const actions = [];
      this.actionButtons.forEach(button => {
        if (button.asMenuItems) {
          const children = button.buttons;
          if (children) {
            children.toArray().forEach(x => actions.push(x));
          }
        }
      });
      return [...this._menuItems.toArray(), ...actions];
    }
    /**
     * Getter for the 'display' property of the current `IgxActionStrip`
     */
    get display() {
      return this.hidden ? 'none' : 'flex';
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterContentInit() {
      this.actionButtons.forEach(button => {
        button.strip = this;
      });
      this.actionButtons.changes.subscribe(() => {
        this.actionButtons.forEach(button => {
          button.strip = this;
        });
      });
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterViewInit() {
      this.menu.selectionChanging.subscribe($event => {
        const newSelection = $event.newSelection.elementRef.nativeElement;
        let allButtons = [];
        this.actionButtons.forEach(actionButtons => {
          if (actionButtons.asMenuItems) {
            allButtons = [...allButtons, ...actionButtons.buttons.toArray()];
          }
        });
        const button = allButtons.find(x => newSelection.contains(x.container.nativeElement));
        if (button) {
          button.actionClick.emit();
        }
      });
      this._originalParent = this._viewContainer.element.nativeElement?.parentElement;
    }
    /**
     * Showing the Action Strip and appending it the specified context element.
     *
     * @param context
     * @example
     * ```typescript
     * this.actionStrip.show(row);
     * ```
     */
    show(context) {
      this.hidden = false;
      if (!context) {
        return;
      }
      // when shown for different context make sure the menu won't stay opened
      if (this.context !== context) {
        this.closeMenu();
      }
      this.context = context;
      if (this.context && this.context.element) {
        this.renderer.appendChild(context.element.nativeElement, this._viewContainer.element.nativeElement);
      }
      this.cdr.detectChanges();
    }
    /**
     * Hiding the Action Strip and removing it from its current context element.
     *
     * @example
     * ```typescript
     * this.actionStrip.hide();
     * ```
     */
    hide() {
      this.hidden = true;
      this.closeMenu();
      if (this._originalParent) {
        // D.P. fix(elements) don't detach native DOM, instead move back. Might not matter for Angular, but Elements will destroy
        this.renderer.appendChild(this._originalParent, this._viewContainer.element.nativeElement);
      } else if (this.context && this.context.element) {
        this.renderer.removeChild(this.context.element.nativeElement, this._viewContainer.element.nativeElement);
      }
    }
    /**
     * Close the menu if opened
     *
     * @hidden
     * @internal
     */
    closeMenu() {
      if (this.menu && !this.menu.collapsed) {
        this.menu.close();
      }
    }
    static {
      this.ɵfac = function IgxActionStripComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxActionStripComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxActionStripComponent,
        selectors: [["igx-action-strip"]],
        contentQueries: function IgxActionStripComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxActionStripMenuItemDirective, 4);
            i0.ɵɵcontentQuery(dirIndex, IgxGridActionsBaseDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._menuItems = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionButtons = _t);
          }
        },
        viewQuery: function IgxActionStripComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c24, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function IgxActionStripComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.display);
            i0.ɵɵclassProp("igx-action-strip", ctx.hostClass);
          }
        },
        inputs: {
          context: "context",
          hidden: [2, "hidden", "hidden", booleanAttribute],
          resourceStrings: "resourceStrings"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxActionStripToken,
          useExisting: IgxActionStripComponent
        }])],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 1,
        consts: [["dropdown", ""], [1, "igx-action-strip__actions"], ["type", "button", "igxIconButton", "flat", "igxRipple", "", 3, "igxToggleAction", "overlaySettings", "title", "igxDropDownItemNavigation"], [1, "igx-action-strip__menu-item"], ["type", "button", "igxIconButton", "flat", "igxRipple", "", 3, "click", "igxToggleAction", "overlaySettings", "title", "igxDropDownItemNavigation"], ["family", "default", "name", "more_vert"], [1, "igx-drop-down__item-template"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function IgxActionStripComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵprojection(1, 0, ["#content", ""]);
            i0.ɵɵtemplate(2, IgxActionStripComponent_Conditional_2_Template, 2, 4, "button", 2);
            i0.ɵɵelementStart(3, "igx-drop-down", null, 0);
            i0.ɵɵrepeaterCreate(5, IgxActionStripComponent_For_6_Template, 3, 4, "igx-drop-down-item", 3, _forTrack0, true);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.menuItems.length > 0 ? 2 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.menuItems);
          }
        },
        dependencies: [NgTemplateOutlet, IgxIconButtonDirective, IgxRippleDirective, IgxToggleActionDirective, IgxDropDownItemNavigationDirective, IgxIconComponent, IgxDropDownComponent, IgxDropDownItemComponent],
        encapsulation: 2
      });
    }
  }
  return IgxActionStripComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-editing-actions */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/**
 * Grid Editing Actions for the Action Strip
 *
 * @igxParent IgxActionStripComponent
 */
let IgxGridEditingActionsComponent = /*#__PURE__*/(() => {
  class IgxGridEditingActionsComponent extends IgxGridActionsBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Host `class.igx-action-strip` binding.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-action-strip__editing-actions';
      /**
       * An input to enable/disable action strip row editing button
       */
      this.editRow = true;
      /**
      * An input to enable/disable action strip row deleting button
      */
      this.deleteRow = true;
      /**
       * An input to enable/disable action strip child row adding button
       */
      this.addChild = false;
      this.isMessageShown = false;
      this._addRow = false;
      this.iconsRendered = false;
    }
    /**
     * An input to enable/disable action strip row adding button
     */
    set addRow(value) {
      this._addRow = value;
    }
    get addRow() {
      if (!this.iconsRendered) {
        this.registerIcons();
        this.iconsRendered = true;
      }
      return this._addRow;
    }
    /**
     * Getter if the row is disabled
     *
     * @hidden
     * @internal
     */
    get disabled() {
      if (!this.isRow(this.strip.context)) {
        return;
      }
      return this.strip.context.disabled;
    }
    /**
     * Getter if the row is root.
     *
     * @hidden
     * @internal
     */
    get isRootRow() {
      if (!this.isRow(this.strip.context)) {
        return false;
      }
      return this.strip.context.isRoot;
    }
    get hasChildren() {
      if (!this.isRow(this.strip.context)) {
        return false;
      }
      return this.strip.context.hasChildren;
    }
    /**
     * Enter row or cell edit mode depending the grid rowEditable option
     *
     * @example
     * ```typescript
     * this.gridEditingActions.startEdit();
     * ```
     */
    startEdit(event) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const row = this.strip.context;
      const firstEditable = row.cells.filter(cell => cell.editable)[0];
      const grid = row.grid;
      if (!grid.hasEditableColumns) {
        this.isMessageShown = showMessage('The grid should be editable in order to use IgxGridEditingActionsComponent', this.isMessageShown);
        return;
      }
      // be sure row is in view
      if (grid.rowList.filter(r => r === row).length !== 0) {
        grid.gridAPI.crudService.enterEditMode(firstEditable, event);
        if (!grid.gridAPI.crudService.nonEditable) {
          firstEditable.activate(event);
        }
      }
      this.strip.hide();
    }
    /** @hidden @internal **/
    deleteRowHandler(event) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const context = this.strip.context;
      const grid = context.grid;
      grid.deleteRow(context.key);
      this.strip.hide();
    }
    /** @hidden @internal **/
    addRowHandler(event, asChild) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const context = this.strip.context;
      const grid = context.grid;
      if (!grid.rowEditable) {
        console.warn('The grid must use row edit mode to perform row adding! Please set rowEditable to true.');
        return;
      }
      grid.gridAPI.crudService.enterAddRowMode(context, asChild, event);
      this.strip.hide();
    }
    /**
     * @hidden
     * @internal
     */
    registerIcons() {
      this.iconService.addSvgIconFromText(addRow.name, addRow.value, 'imx-icons', true);
      this.iconService.addSvgIconFromText(addChild.name, addChild.value, 'imx-icons', true);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridEditingActionsComponent_BaseFactory;
        return function IgxGridEditingActionsComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridEditingActionsComponent_BaseFactory || (ɵIgxGridEditingActionsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridEditingActionsComponent)))(__ngFactoryType__ || IgxGridEditingActionsComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridEditingActionsComponent,
        selectors: [["igx-grid-editing-actions"]],
        hostVars: 2,
        hostBindings: function IgxGridEditingActionsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-action-strip__editing-actions", ctx.cssClass);
          }
        },
        inputs: {
          addRow: [2, "addRow", "addRow", booleanAttribute],
          editRow: [2, "editRow", "editRow", booleanAttribute],
          deleteRow: [2, "deleteRow", "deleteRow", booleanAttribute],
          addChild: [2, "addChild", "addChild", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxGridActionsBaseDirective,
          useExisting: IgxGridEditingActionsComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["iconName", "edit", 3, "asMenuItem", "labelText"], ["iconName", "add_row", "iconSet", "default", 3, "asMenuItem", "labelText"], ["iconName", "add_child", "iconSet", "default", 3, "asMenuItem", "labelText"], ["classNames", "igx-action-strip__menu-item--danger", "iconName", "delete", 1, "igx-action-strip__delete", 3, "asMenuItem", "labelText"], ["iconName", "edit", 3, "actionClick", "asMenuItem", "labelText"], ["iconName", "add_row", "iconSet", "default", 3, "actionClick", "asMenuItem", "labelText"], ["iconName", "add_child", "iconSet", "default", 3, "actionClick", "asMenuItem", "labelText"], ["classNames", "igx-action-strip__menu-item--danger", "iconName", "delete", 1, "igx-action-strip__delete", 3, "actionClick", "asMenuItem", "labelText"]],
        template: function IgxGridEditingActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridEditingActionsComponent_Conditional_0_Template, 4, 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isRowContext ? 0 : -1);
          }
        },
        dependencies: [IgxGridActionButtonComponent],
        encapsulation: 2
      });
    }
  }
  return IgxGridEditingActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-pinning-actions */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/**
 * Grid Pinning Actions for the Action Strip
 *
 * @igxParent IgxActionStripComponent
 */
let IgxGridPinningActionsComponent = /*#__PURE__*/(() => {
  class IgxGridPinningActionsComponent extends IgxGridActionsBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Host `class.igx-action-strip` binding.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-action-strip__pinning-actions';
      this.iconsRendered = false;
    }
    /**
     * Getter to know if the row is pinned
     *
     * @hidden
     * @internal
     */
    get pinned() {
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const context = this.strip.context;
      if (context && !this.iconsRendered) {
        this.registerSVGIcons();
        this.iconsRendered = true;
      }
      return context && context.pinned;
    }
    /**
     * Getter to know if the row is in pinned and ghost
     *
     * @hidden
     * @internal
     */
    get inPinnedArea() {
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const context = this.strip.context;
      return this.pinned && !context.disabled;
    }
    /**
     * Getter to know if the row pinning is set to top or bottom
     *
     * @hidden
     * @internal
     */
    get pinnedTop() {
      if (!this.isRow(this.strip.context)) {
        return;
      }
      return this.strip.context.grid.isRowPinningToTop;
    }
    /**
     * Pin the row according to the context.
     *
     * @example
     * ```typescript
     * this.gridPinningActions.pin();
     * ```
     */
    pin(event) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const row = this.strip.context;
      const grid = row.grid;
      grid.pinRow(row.key, grid.pinnedRecords.length);
      this.strip.hide();
    }
    /**
     * Unpin the row according to the context.
     *
     * @example
     * ```typescript
     * this.gridPinningActions.unpin();
     * ```
     */
    unpin(event) {
      if (event) {
        event.stopPropagation();
      }
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const row = this.strip.context;
      const grid = row.grid;
      grid.unpinRow(row.key);
      this.strip.hide();
    }
    scrollToRow(event) {
      if (event) {
        event.stopPropagation();
      }
      const context = this.strip.context;
      const grid = context.grid;
      grid.scrollTo(context.data, 0);
      this.strip.hide();
    }
    registerSVGIcons() {
      if (!this.isRow(this.strip.context)) {
        return;
      }
      const context = this.strip.context;
      const grid = context.grid;
      if (grid) {
        this.iconService.addSvgIconFromText(pinLeft.name, pinLeft.value, 'imx-icons', true);
        this.iconService.addSvgIconFromText(unpinLeft.name, unpinLeft.value, 'imx-icons', true);
        this.iconService.addSvgIconFromText(jumpDown.name, jumpDown.value, 'imx-icons', true);
        this.iconService.addSvgIconFromText(jumpUp.name, jumpUp.value, 'imx-icons', true);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridPinningActionsComponent_BaseFactory;
        return function IgxGridPinningActionsComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridPinningActionsComponent_BaseFactory || (ɵIgxGridPinningActionsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridPinningActionsComponent)))(__ngFactoryType__ || IgxGridPinningActionsComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridPinningActionsComponent,
        selectors: [["igx-grid-pinning-actions"]],
        hostVars: 2,
        hostBindings: function IgxGridPinningActionsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-action-strip__pinning-actions", ctx.cssClass);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxGridActionsBaseDirective,
          useExisting: IgxGridPinningActionsComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["iconSet", "default", "iconName", "jump_down", 3, "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "jump_up", 3, "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "pin", 3, "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "unpin", 3, "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "jump_down", 3, "actionClick", "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "jump_up", 3, "actionClick", "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "pin", 3, "actionClick", "asMenuItem", "labelText"], ["iconSet", "default", "iconName", "unpin", 3, "actionClick", "asMenuItem", "labelText"]],
        template: function IgxGridPinningActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridPinningActionsComponent_Conditional_0_Template, 4, 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isRowContext ? 0 : -1);
          }
        },
        dependencies: [IgxGridActionButtonComponent],
        encapsulation: 2
      });
    }
  }
  return IgxGridPinningActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Action-strip outside of grid directives collection for ease-of-use import in standalone components scenario */
const IGX_ACTION_STRIP_DIRECTIVES = [IgxActionStripComponent, IgxActionStripMenuItemDirective];
/* Action-strip in grid directives collection for ease-of-use import in standalone components scenario */
const IGX_GRID_ACTION_STRIP_DIRECTIVES = [IgxActionStripComponent, IgxActionStripMenuItemDirective, IgxGridPinningActionsComponent, IgxGridEditingActionsComponent, IgxGridActionsBaseDirective, IgxGridActionButtonComponent];
let NEXT_ID$o = 0;
const IgxAvatarSize = /*@__PURE__*/mkenum({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});
const IgxAvatarType = /*@__PURE__*/mkenum({
  INITIALS: 'initials',
  IMAGE: 'image',
  ICON: 'icon',
  CUSTOM: 'custom'
});
/**
 * Avatar provides a way to display an image, icon or initials to the user.
 *
 * @igxModule IgxAvatarModule
 *
 * @igxTheme igx-avatar-theme, igx-icon-theme
 *
 * @igxKeywords avatar, profile, picture, initials
 *
 * @igxGroup Layouts
 *
 * @remarks
 *
 * The Ignite UI Avatar provides an easy way to add an avatar icon to your application.  This icon can be an
 * image, someone's initials or a material icon from the Google Material icon set.
 *
 * @example
 * ```html
 * <igx-avatar initials="MS" shape="rounded" size="large">
 * </igx-avatar>
 * ```
 */
let IgxAvatarComponent = /*#__PURE__*/(() => {
  class IgxAvatarComponent {
    /** @hidden @internal */
    get isRounded() {
      return this.shape === 'rounded';
    }
    /** @hidden @internal */
    get isCircle() {
      return this.shape === 'circle';
    }
    /**
     * Sets the image source of the avatar.
     *
     * @example
     * ```html
     * <igx-avatar src="images/picture.jpg"></igx-avatar>
     * ```
     * @igxFriendlyName Image URL
     */
    set src(value) {
      this._src = normalizeURI(value);
    }
    get src() {
      return this._src;
    }
    /**
     * Returns the size of the avatar.
     *
     * @example
     * ```typescript
     * let avatarSize = this.avatar.size;
     * ```
     */
    get size() {
      return this._size || IgxAvatarSize.SMALL;
    }
    /**
     * Sets the size  of the avatar.
     * By default, the size is `"small"`. It can be set to `"medium"` or `"large"`.
     *
     * @example
     * ```html
     * <igx-avatar size="large"></igx-avatar>
     * ```
     */
    set size(value) {
      switch (value) {
        case 'small':
        case 'medium':
        case 'large':
          this._size = value;
          break;
        default:
          this._size = 'small';
      }
    }
    /**
     * Returns the type of the avatar.
     *
     * @example
     * ```typescript
     * let avatarType = this.avatar.type;
     * ```
     */
    get type() {
      if (this.src) {
        return IgxAvatarType.IMAGE;
      }
      if (this.icon) {
        return IgxAvatarType.ICON;
      }
      if (this.initials) {
        return IgxAvatarType.INITIALS;
      }
      return IgxAvatarType.CUSTOM;
    }
    /** @hidden @internal */
    get _isImageType() {
      return this.type === IgxAvatarType.IMAGE;
    }
    /** @hidden @internal */
    get _isIconType() {
      return this.type === IgxAvatarType.ICON;
    }
    /** @hidden @internal */
    get _isInitialsType() {
      return this.type === IgxAvatarType.INITIALS;
    }
    get componentSize() {
      if (this._size) {
        return `var(--ig-size-${this._size})`;
      }
    }
    /**
     * Returns the template of the avatar.
     *
     * @hidden
     * @internal
     */
    get template() {
      switch (this.type) {
        case IgxAvatarType.IMAGE:
          return this.imageTemplate;
        case IgxAvatarType.INITIALS:
          return this.initialsTemplate;
        case IgxAvatarType.ICON:
          return this.iconTemplate;
        default:
          return this.defaultTemplate;
      }
    }
    constructor(elementRef) {
      this.elementRef = elementRef;
      /**
       * Returns the `aria-label` attribute of the avatar.
       *
       * @example
       * ```typescript
       * let ariaLabel = this.avatar.ariaLabel;
       * ```
       *
       */
      this.ariaLabel = 'avatar';
      /**
       * Returns the `role` attribute of the avatar.
       *
       * @example
       * ```typescript
       * let avatarRole = this.avatar.role;
       * ```
       */
      this.role = 'img';
      /**
       * Host `class.igx-avatar` binding.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-avatar';
      /**
       * Sets the `id` of the avatar. If not set, the first avatar component will have `id` = `"igx-avatar-0"`.
       *
       * @example
       * ```html
       * <igx-avatar id="my-first-avatar"></igx-avatar>
       * ```
       */
      this.id = `igx-avatar-${NEXT_ID$o++}`;
      /**
       * Sets square, rounded or circular shape to the avatar.
       * By default the shape of the avatar is square.
       *
       * @example
       * ```html
       * <igx-avatar shape="rounded"></igx-avatar>
       * ```
       */
      this.shape = 'square';
    }
    /**
     * Returns the css url of the image.
     *
     * @hidden
     * @internal
     */
    getSrcUrl() {
      return `url("${this.src}")`;
    }
    /** @hidden @internal */
    ngOnInit() {
      this.roleDescription = this.getRole();
    }
    /** @hidden @internal */
    getRole() {
      switch (this.type) {
        case IgxAvatarType.IMAGE:
          return 'image avatar';
        case IgxAvatarType.ICON:
          return 'icon avatar';
        case IgxAvatarType.INITIALS:
          return 'initials avatar';
        default:
          return 'custom avatar';
      }
    }
    static {
      this.ɵfac = function IgxAvatarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAvatarComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxAvatarComponent,
        selectors: [["igx-avatar"]],
        viewQuery: function IgxAvatarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c26, 7, TemplateRef);
            i0.ɵɵviewQuery(_c27, 7, TemplateRef);
            i0.ɵɵviewQuery(_c28, 7, TemplateRef);
            i0.ɵɵviewQuery(_c29, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.imageTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.initialsTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iconTemplate = _t.first);
          }
        },
        hostVars: 22,
        hostBindings: function IgxAvatarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.ariaLabel)("role", ctx.role)("aria-roledescription", ctx.roleDescription)("id", ctx.id);
            i0.ɵɵstyleProp("color", ctx.color)("background", ctx.bgColor)("--component-size", ctx.componentSize);
            i0.ɵɵclassProp("igx-avatar", ctx.cssClass)("igx-avatar--rounded", ctx.isRounded)("igx-avatar--circle", ctx.isCircle)("igx-avatar--image", ctx._isImageType)("igx-avatar--icon", ctx._isIconType)("igx-avatar--initials", ctx._isInitialsType);
          }
        },
        inputs: {
          id: "id",
          shape: "shape",
          color: "color",
          bgColor: "bgColor",
          initials: "initials",
          icon: "icon",
          src: "src",
          size: "size"
        },
        ngContentSelectors: _c0,
        decls: 9,
        vars: 1,
        consts: [["defaultTemplate", ""], ["imageTemplate", ""], ["initialsTemplate", ""], ["iconTemplate", ""], ["image", ""], [4, "ngTemplateOutlet"], [1, "igx-avatar__image"]],
        template: function IgxAvatarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxAvatarComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxAvatarComponent_ng_template_2_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxAvatarComponent_ng_template_4_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxAvatarComponent_ng_template_6_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxAvatarComponent_ng_container_8_Template, 1, 0, "ng-container", 5);
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template);
          }
        },
        dependencies: [IgxIconComponent, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxAvatarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$n = 0;
/**
 * Determines the igxBadge type
 */
const IgxBadgeType = /*@__PURE__*/mkenum({
  PRIMARY: 'primary',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
});
/**
 * Badge provides visual notifications used to decorate avatars, menus, etc.
 *
 * @igxModule IgxBadgeModule
 *
 * @igxTheme igx-badge-theme
 *
 * @igxKeywords badge, icon, notification
 *
 * @igxGroup Data Entry & Display
 *
 * @remarks
 * The Ignite UI Badge is used to decorate avatars, navigation menus, or other components in the
 * application when visual notification is needed. They are usually designed as icons with a predefined
 * style to communicate information, success, warnings, or errors.
 *
 * @example
 * ```html
 * <igx-avatar>
 *   <igx-badge icon="check" type="success"></igx-badge>
 * </igx-avatar>
 */
let IgxBadgeComponent = /*#__PURE__*/(() => {
  class IgxBadgeComponent {
    constructor() {
      /**
       * Sets/gets the `id` of the badge.
       *
       * @remarks
       * If not set, the `id` will have value `"igx-badge-0"`.
       *
       * @example
       * ```html
       * <igx-badge id="igx-badge-2"></igx-badge>
       * ```
       */
      this.id = `igx-badge-${NEXT_ID$n++}`;
      /**
       * Sets/gets the type of the badge.
       *
       * @remarks
       * Allowed values are `primary`, `info`, `success`, `warning`, `error`.
       * Providing an invalid value won't display a badge.
       *
       * @example
       * ```html
       * <igx-badge type="success"></igx-badge>
       * ```
       */
      this.type = IgxBadgeType.PRIMARY;
      /**
       * Sets/gets the value to be displayed inside the badge.
       *
       * @remarks
       * If an `icon` property is already set the `icon` will be displayed.
       * If neither a `value` nor an `icon` is set the content of the badge will be empty.
       *
       * @example
       * ```html
       * <igx-badge value="11"></igx-badge>
       * ```
       */
      this.value = '';
      /**
       * Sets/gets the role attribute value.
       *
       * @example
       * ```typescript
       * @ViewChild("MyBadge", { read: IgxBadgeComponent })
       * public badge: IgxBadgeComponent;
       *
       * badge.role = 'status';
       * ```
       */
      this.role = 'status';
      /**
       * Sets/gets the css class to use on the badge.
       *
       * @example
       * ```typescript
       * @ViewChild("MyBadge", { read: IgxBadgeComponent })
       * public badge: IgxBadgeComponent;
       *
       * badge.cssClass = 'my-badge-class';
       * ```
       */
      this.cssClass = 'igx-badge';
      /**
       * Sets a square shape to the badge, if `shape` is set to `square`.
       * By default the shape of the badge is rounded.
       *
       * @example
       * ```html
       * <igx-badge shape="square"></igx-badge>
       * ```
       */
      this.shape = 'rounded';
      /**
       * Sets/gets the aria-label attribute value.
       *
       * @example
       * ```typescript
       * @ViewChild("MyBadge", { read: IgxBadgeComponent })
       * public badge: IgxBadgeComponent;
       *
       * badge.label = 'badge';
       * ```
       */
      this.label = 'badge';
      /**
       * Sets/gets whether the badge is outlined.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-badge outlined></igx-badge>
       * ```
       */
      this.outlined = false;
    }
    /** @hidden @internal */
    get _squareShape() {
      return this.shape === 'square';
    }
    /**
     * Defines a human-readable, accessor, author-localized description for
     * the `type` and the `icon` or `value` of the element.
     *
     * @hidden
     * @internal
     */
    get roleDescription() {
      if (this.icon) {
        return this.type + ' type badge with icon type ' + this.icon;
      } else if (this.value || this.value === 0) {
        return this.type + ' badge type with value ' + this.value;
      }
      return this.type + ' badge type without value';
    }
    get infoClass() {
      return this.type === IgxBadgeType.INFO;
    }
    get successClass() {
      return this.type === IgxBadgeType.SUCCESS;
    }
    get warningClass() {
      return this.type === IgxBadgeType.WARNING;
    }
    get errorClass() {
      return this.type === IgxBadgeType.ERROR;
    }
    static {
      this.ɵfac = function IgxBadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBadgeComponent,
        selectors: [["igx-badge"]],
        hostVars: 18,
        hostBindings: function IgxBadgeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role)("aria-label", ctx.label)("aria-roledescription", ctx.roleDescription);
            i0.ɵɵclassProp("igx-badge", ctx.cssClass)("igx-badge--square", ctx._squareShape)("igx-badge--outlined", ctx.outlined)("igx-badge--info", ctx.infoClass)("igx-badge--success", ctx.successClass)("igx-badge--warning", ctx.warningClass)("igx-badge--error", ctx.errorClass);
          }
        },
        inputs: {
          id: "id",
          type: "type",
          value: "value",
          icon: "icon",
          iconSet: "iconSet",
          shape: "shape",
          outlined: [2, "outlined", "outlined", booleanAttribute]
        },
        ngContentSelectors: _c0,
        decls: 4,
        vars: 3,
        consts: [[1, "igx-badge__value"], [3, "family", "name"]],
        template: function IgxBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxBadgeComponent_Conditional_0_Template, 2, 1, "span", 0)(1, IgxBadgeComponent_Conditional_1_Template, 2, 1, "igx-icon")(2, IgxBadgeComponent_Conditional_2_Template, 2, 3, "igx-icon", 1);
            i0.ɵɵprojection(3);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.value || ctx.value === 0 && !ctx.icon ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.icon && !ctx.iconSet ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.icon && ctx.iconSet ? 2 : -1);
          }
        },
        dependencies: [IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBannerActionsDirective = /*#__PURE__*/(() => {
  class IgxBannerActionsDirective {
    static {
      this.ɵfac = function IgxBannerActionsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBannerActionsDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxBannerActionsDirective,
        selectors: [["igx-banner-actions"]]
      });
    }
  }
  return IgxBannerActionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BannerResourceStringsEN = {
  igx_banner_button_dismiss: 'Dismiss'
};

/**
 * **Ignite UI for Angular Banner** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/banner.html)
 *
 * The Ignite UI Banner provides a highly template-able and easy to use banner that can be shown in your application.
 *
 * Usage:
 *
 * ```html
 * <igx-banner #banner>
 *   Our privacy settings have changed.
 *  <igx-banner-actions>
 *      <button type="button" igxButton="contained">Read More</button>
 *      <button type="button" igxButton="contained">Accept and Continue</button>
 *  </igx-banner-actions>
 * </igx-banner>
 * ```
 */
let IgxBannerComponent = /*#__PURE__*/(() => {
  class IgxBannerComponent {
    /** @hidden */
    get useDefaultTemplate() {
      return !this._bannerActionTemplate;
    }
    /**
     * Set the animation settings used by the banner open/close methods
     * ```typescript
     * import { slideInLeft, slideOutRight } from 'igniteui-angular';
     * ...
     * banner.animationSettings: ToggleAnimationSettings = { openAnimation: slideInLeft, closeAnimation: slideOutRight };
     * ```
     */
    set animationSettings(settings) {
      this._animationSettings = settings;
    }
    /**
     * Get the animation settings used by the banner open/close methods
     * ```typescript
     * let currentAnimations: ToggleAnimationSettings = banner.animationSettings
     * ```
     */
    get animationSettings() {
      return this._animationSettings ? this._animationSettings : this._expansionPanel.animationSettings;
    }
    /**
     * Gets/Sets the resource strings.
     *
     * @remarks
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Gets/Sets whether the banner is expanded (visible) or collapsed (hidden).
     * Defaults to `false`.
     * Setting to `true` opens the banner, while `false` closes it.
     *
     * @example
     * // Expand the banner
     * banner.expanded = true;
     *
     * @example
     * // Collapse the banner
     * banner.expanded = false;
     *
     * @example
     * // Check if the banner is expanded
     * const isExpanded = banner.expanded;
     */
    get expanded() {
      return this._expanded;
    }
    set expanded(value) {
      if (value === this._expanded) {
        return;
      }
      this._expanded = value;
      this._shouldFireEvent = true;
      if (value) {
        this._expansionPanel.open();
      } else {
        this._expansionPanel.close();
      }
    }
    /**
     * Gets whether the banner is collapsed.
     *
     * ```typescript
     * const isCollapsed: boolean = banner.collapsed;
     * ```
     */
    get collapsed() {
      return this._expansionPanel.collapsed;
    }
    /**
     * Returns the native element of the banner component
     * ```typescript
     *  const myBannerElement: HTMLElement = banner.element;
     * ```
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * @hidden
     */
    get displayStyle() {
      return this.collapsed ? '' : 'block';
    }
    constructor(elementRef) {
      this.elementRef = elementRef;
      /**
       * Fires after the banner shows up
       * ```typescript
       * public handleOpened(event) {
       *  ...
       * }
       * ```
       * ```html
       * <igx-banner (opened)="handleOpened($event)"></igx-banner>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Fires before the banner shows up
       * ```typescript
       * public handleOpening(event) {
       *  ...
       * }
       * ```
       * ```html
       * <igx-banner (opening)="handleOpening($event)"></igx-banner>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Fires after the banner hides
       * ```typescript
       * public handleClosed(event) {
       *  ...
       * }
       * ```
       * ```html
       * <igx-banner (closed)="handleClosed($event)"></igx-banner>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * Fires before the banner hides
       * ```typescript
       * public handleClosing(event) {
       *  ...
       * }
       * ```
       * ```html
       * <igx-banner (closing)="handleClosing($event)"></igx-banner>
       * ```
       */
      this.closing = new EventEmitter();
      this.cssClass = 'igx-banner-host';
      this._expanded = false;
      this._shouldFireEvent = false;
      this._resourceStrings = getCurrentResourceStrings(BannerResourceStringsEN);
    }
    /**
     * Opens the banner
     *
     * ```typescript
     *  myBanner.open();
     * ```
     *
     * ```html
     * <igx-banner #banner>
     * ...
     * </igx-banner>
     * <button type="button" (click)="banner.open()">Open Banner</button>
     * ```
     */
    open(event) {
      this._bannerEvent = {
        owner: this,
        event
      };
      const openingArgs = {
        owner: this,
        event,
        cancel: false
      };
      this.opening.emit(openingArgs);
      if (openingArgs.cancel) {
        return;
      }
      this._expansionPanel.open(event);
      this._expanded = true;
      this._shouldFireEvent = false;
    }
    /**
     * Closes the banner
     *
     * ```typescript
     *  myBanner.close();
     * ```
     *
     * ```html
     * <igx-banner #banner>
     * ...
     * </igx-banner>
     * <button type="button" (click)="banner.close()">Close Banner</button>
     * ```
     */
    close(event) {
      this._bannerEvent = {
        owner: this,
        event
      };
      const closingArgs = {
        owner: this,
        event,
        cancel: false
      };
      this.closing.emit(closingArgs);
      if (closingArgs.cancel) {
        return;
      }
      this._expansionPanel.close(event);
      this._expanded = false;
      this._shouldFireEvent = false;
    }
    /**
     * Toggles the banner
     *
     * ```typescript
     *  myBanner.toggle();
     * ```
     *
     * ```html
     * <igx-banner #banner>
     * ...
     * </igx-banner>
     * <button type="button" (click)="banner.toggle()">Toggle Banner</button>
     * ```
     */
    toggle(event) {
      if (this.collapsed) {
        this.open(event);
      } else {
        this.close(event);
      }
    }
    /** @hidden */
    onExpansionPanelOpen() {
      if (this._shouldFireEvent) {
        return;
      }
      this.opened.emit(this._bannerEvent);
    }
    /** @hidden */
    onExpansionPanelClose() {
      if (this._shouldFireEvent) {
        return;
      }
      this.closed.emit(this._bannerEvent);
    }
    static {
      this.ɵfac = function IgxBannerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBannerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBannerComponent,
        selectors: [["igx-banner"]],
        contentQueries: function IgxBannerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxIconComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxBannerActionsDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.bannerIcon = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._bannerActionTemplate = _t.first);
          }
        },
        viewQuery: function IgxBannerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c30, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._expansionPanel = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function IgxBannerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.cssClass);
            i0.ɵɵstyleProp("display", ctx.displayStyle);
          }
        },
        inputs: {
          animationSettings: "animationSettings",
          resourceStrings: "resourceStrings",
          expanded: "expanded"
        },
        outputs: {
          opened: "opened",
          opening: "opening",
          closed: "closed",
          closing: "closing"
        },
        ngContentSelectors: _c32,
        decls: 11,
        vars: 5,
        consts: [["expansionPanel", ""], ["role", "status", "aria-live", "polite", 3, "contentCollapsed", "contentExpanded", "animationSettings", "collapsed"], [1, "igx-banner"], [1, "igx-banner__message"], [1, "igx-banner__illustration"], [1, "igx-banner__text"], [1, "igx-banner__actions"], ["type", "button", "igxButton", "flat", "igxRipple", ""], ["type", "button", "igxButton", "flat", "igxRipple", "", 3, "click"]],
        template: function IgxBannerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c31);
            i0.ɵɵelementStart(0, "igx-expansion-panel", 1, 0);
            i0.ɵɵlistener("contentCollapsed", function IgxBannerComponent_Template_igx_expansion_panel_contentCollapsed_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onExpansionPanelClose());
            })("contentExpanded", function IgxBannerComponent_Template_igx_expansion_panel_contentExpanded_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onExpansionPanelOpen());
            });
            i0.ɵɵelementStart(2, "igx-expansion-panel-body")(3, "div", 2)(4, "div", 3);
            i0.ɵɵtemplate(5, IgxBannerComponent_Conditional_5_Template, 2, 0, "div", 4);
            i0.ɵɵelementStart(6, "span", 5);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵtemplate(9, IgxBannerComponent_Conditional_9_Template, 2, 1, "button", 7)(10, IgxBannerComponent_Conditional_10_Template, 1, 0);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("animationSettings", ctx.animationSettings)("collapsed", ctx.collapsed);
            i0.ɵɵattribute("aria-hidden", ctx.collapsed);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.bannerIcon ? 5 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.useDefaultTemplate ? 9 : 10);
          }
        },
        dependencies: [IgxExpansionPanelComponent, IgxExpansionPanelBodyComponent, IgxButtonDirective, IgxRippleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxBannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Banner directives collection for ease-of-use import in standalone components scenario */
const IGX_BANNER_DIRECTIVES = [IgxBannerComponent, IgxBannerActionsDirective];

/**
 * Determines the Button Group alignment
 */
const ButtonGroupAlignment = mkenum({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
let NEXT_ID$m = 0;
/**
 * **Ignite UI for Angular Button Group** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/buttongroup.html)
 *
 * The Ignite UI Button Group displays a group of buttons either vertically or horizontally. The group supports
 * single, multi and singleRequired selection.
 *
 * Example:
 * ```html
 * <igx-buttongroup selectionMode="multi" [values]="fontOptions">
 * </igx-buttongroup>
 * ```
 * The `fontOptions` value shown above is defined as:
 * ```typescript
 * this.fontOptions = [
 *   { icon: 'format_bold', selected: false },
 *   { icon: 'format_italic', selected: false },
 *   { icon: 'format_underlined', selected: false }];
 * ```
 */
let IgxButtonGroupComponent = /*#__PURE__*/(() => {
  class IgxButtonGroupComponent {
    /**
     * A collection containing all buttons inside the button group.
     */
    get buttons() {
      return [...this.viewButtons.toArray(), ...this.templateButtons.toArray()];
    }
    /**
     * Allows you to set a style using the `itemContentCssClass` input.
     * The value should be the CSS class name that will be applied to the button group.
     * ```typescript
     * public style1 = "styleClass";
     *  //..
     * ```
     *  ```html
     * <igx-buttongroup [itemContentCssClass]="style1" [selectionMode]="'multi'" [values]="alignOptions">
     * ```
     */
    set itemContentCssClass(value) {
      this._itemContentCssClass = value || this._itemContentCssClass;
    }
    /**
     * Returns the CSS class of the item content of the `IgxButtonGroup`.
     * ```typescript
     *  @ViewChild("MyChild")
     * public buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    let buttonSelect = this.buttonG.itemContentCssClass;
     * }
     * ```
     */
    get itemContentCssClass() {
      return this._itemContentCssClass;
    }
    /**
     * Enables selecting multiple buttons. By default, multi-selection is false.
     *
     * @deprecated in version 16.1.0. Use the `selectionMode` property instead.
     */
    get multiSelection() {
      if (this.selectionMode === 'multi') {
        return true;
      } else {
        return false;
      }
    }
    set multiSelection(selectionMode) {
      if (selectionMode) {
        this.selectionMode = 'multi';
      } else {
        this.selectionMode = 'single';
      }
    }
    /**
     * Gets/Sets the selection mode to 'single', 'singleRequired' or 'multi' of the buttons. By default, the selection mode is 'single'.
     * ```html
     * <igx-buttongroup [selectionMode]="'multi'" [alignment]="alignment"></igx-buttongroup>
     * ```
     */
    get selectionMode() {
      return this._selectionMode;
    }
    set selectionMode(selectionMode) {
      if (this.viewButtons && selectionMode !== this._selectionMode) {
        this.buttons.forEach((b, i) => {
          this.deselectButton(i);
        });
        this._selectionMode = selectionMode;
      } else {
        this._selectionMode = selectionMode;
      }
    }
    /**
     * Disables the `igx-buttongroup` component. By default it's false.
     * ```html
     * <igx-buttongroup [disabled]="true" [selectionMode]="'multi'" [values]="fontOptions"></igx-buttongroup>
     * ```
     */
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      if (this._disabled !== value) {
        this._disabled = value;
        if (this.viewButtons && this.templateButtons) {
          this.buttons.forEach(b => b.disabled = this._disabled);
        }
      }
    }
    /**
     * Allows you to set the button group alignment.
     * Available options are `ButtonGroupAlignment.horizontal` (default) and `ButtonGroupAlignment.vertical`.
     * ```typescript
     * public alignment = ButtonGroupAlignment.vertical;
     * //..
     * ```
     * ```html
     * <igx-buttongroup [selectionMode]="'single'" [values]="cities" [alignment]="alignment"></igx-buttongroup>
     * ```
     */
    set alignment(value) {
      this._isVertical = value === ButtonGroupAlignment.vertical;
    }
    /**
     * Returns the alignment of the `igx-buttongroup`.
     * ```typescript
     * @ViewChild("MyChild")
     * public buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    let buttonAlignment = this.buttonG.alignment;
     * }
     * ```
     */
    get alignment() {
      return this._isVertical ? ButtonGroupAlignment.vertical : ButtonGroupAlignment.horizontal;
    }
    /**
     * Returns true if the `igx-buttongroup` alignment is vertical.
     * Note that in order for the accessor to work correctly the property should be set explicitly.
     * ```html
     * <igx-buttongroup #MyChild [alignment]="alignment" [values]="alignOptions">
     * ```
     * ```typescript
     * //...
     * @ViewChild("MyChild")
     * private buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    let orientation = this.buttonG.isVertical;
     * }
     * ```
     */
    get isVertical() {
      return this._isVertical;
    }
    constructor(_cdr, _renderer, _el) {
      this._cdr = _cdr;
      this._renderer = _renderer;
      this._el = _el;
      /**
       * Gets/Sets the value of the `id` attribute. If not set it will be automatically generated.
       * ```html
       *  <igx-buttongroup [id]="'igx-dialog-56'" [selectionMode]="'multi'" [values]="alignOptions">
       * ```
       */
      this.id = `igx-buttongroup-${NEXT_ID$m++}`;
      /**
       * @hidden
       */
      this.zIndex = 0;
      /**
       * An @Ouput property that emits an event when a button is selected.
       * ```typescript
       * @ViewChild("toast")
       * private toast: IgxToastComponent;
       * public selectedHandler(buttongroup) {
       *     this.toast.open()
       * }
       *  //...
       * ```
       * ```html
       * <igx-buttongroup #MyChild [selectionMode]="'multi'" (selected)="selectedHandler($event)"></igx-buttongroup>
       * <igx-toast #toast>You have made a selection!</igx-toast>
       * ```
       */
      this.selected = new EventEmitter();
      /**
       * An @Ouput property that emits an event when a button is deselected.
       * ```typescript
       *  @ViewChild("toast")
       *  private toast: IgxToastComponent;
       *  public deselectedHandler(buttongroup){
       *     this.toast.open()
       * }
       *  //...
       * ```
       * ```html
       * <igx-buttongroup> #MyChild [selectionMode]="'multi'" (deselected)="deselectedHandler($event)"></igx-buttongroup>
       * <igx-toast #toast>You have deselected a button!</igx-toast>
       * ```
       */
      this.deselected = new EventEmitter();
      /**
       * @hidden
       */
      this.selectedIndexes = [];
      this.buttonClickNotifier$ = new Subject();
      this.queryListNotifier$ = new Subject();
      this._disabled = false;
      this._selectionMode = 'single';
      this.observerConfig = {
        attributeFilter: ["data-selected"],
        childList: true,
        subtree: true
      };
    }
    /**
     * Gets the selected button/buttons.
     * ```typescript
     * @ViewChild("MyChild")
     * private buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    let selectedButton = this.buttonG.selectedButtons;
     * }
     * ```
     */
    get selectedButtons() {
      return this.buttons.filter((_, i) => this.selectedIndexes.indexOf(i) !== -1);
    }
    /**
     * Selects a button by its index.
     * ```typescript
     * @ViewChild("MyChild")
     * private buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    this.buttonG.selectButton(2);
     *    this.cdr.detectChanges();
     * }
     * ```
     *
     * @memberOf {@link IgxButtonGroupComponent}
     */
    selectButton(index) {
      if (index >= this.buttons.length || index < 0) {
        return;
      }
      const button = this.buttons[index];
      button.select();
    }
    /**
     * @hidden
     * @internal
     */
    updateSelected(index) {
      const button = this.buttons[index];
      if (this.selectedIndexes.indexOf(index) === -1) {
        this.selectedIndexes.push(index);
      }
      this._renderer.setAttribute(button.nativeElement, 'aria-pressed', 'true');
      this._renderer.addClass(button.nativeElement, 'igx-button-group__item--selected');
      const indexInViewButtons = this.viewButtons.toArray().indexOf(button);
      if (indexInViewButtons !== -1) {
        this.values[indexInViewButtons].selected = true;
      }
      // deselect other buttons if selectionMode is not multi
      if (this.selectionMode !== 'multi' && this.selectedIndexes.length > 1) {
        this.buttons.forEach((_, i) => {
          if (i !== index && this.selectedIndexes.indexOf(i) !== -1) {
            this.deselectButton(i);
            this.updateDeselected(i);
          }
        });
      }
    }
    updateDeselected(index) {
      const button = this.buttons[index];
      if (this.selectedIndexes.indexOf(index) !== -1) {
        this.selectedIndexes.splice(this.selectedIndexes.indexOf(index), 1);
      }
      this._renderer.setAttribute(button.nativeElement, 'aria-pressed', 'false');
      this._renderer.removeClass(button.nativeElement, 'igx-button-group__item--selected');
      const indexInViewButtons = this.viewButtons.toArray().indexOf(button);
      if (indexInViewButtons !== -1) {
        this.values[indexInViewButtons].selected = false;
      }
    }
    /**
     * Deselects a button by its index.
     * ```typescript
     * @ViewChild("MyChild")
     * private buttonG: IgxButtonGroupComponent;
     * ngAfterViewInit(){
     *    this.buttonG.deselectButton(2);
     *    this.cdr.detectChanges();
     * }
     * ```
     *
     * @memberOf {@link IgxButtonGroupComponent}
     */
    deselectButton(index) {
      if (index >= this.buttons.length || index < 0) {
        return;
      }
      const button = this.buttons[index];
      button.deselect();
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      const initButtons = () => {
        // Cancel any existing buttonClick subscriptions
        this.buttonClickNotifier$.next();
        this.selectedIndexes.splice(0, this.selectedIndexes.length);
        // initial configuration
        this.buttons.forEach((button, index) => {
          const buttonElement = button.nativeElement;
          this._renderer.addClass(buttonElement, 'igx-button-group__item');
          if (this.disabled) {
            button.disabled = true;
          }
          if (button.selected) {
            this.updateSelected(index);
          }
          button.buttonClick.pipe(takeUntil(this.buttonClickNotifier$)).subscribe(_ => this._clickHandler(index));
        });
      };
      this.mutationObserver = this.setMutationsObserver();
      this.viewButtons.changes.pipe(takeUntil(this.queryListNotifier$)).subscribe(() => {
        this.mutationObserver.disconnect();
        initButtons();
        this.mutationObserver?.observe(this._el.nativeElement, this.observerConfig);
      });
      this.templateButtons.changes.pipe(takeUntil(this.queryListNotifier$)).subscribe(() => {
        this.mutationObserver.disconnect();
        initButtons();
        this.mutationObserver?.observe(this._el.nativeElement, this.observerConfig);
      });
      initButtons();
      this._cdr.detectChanges();
      this.mutationObserver?.observe(this._el.nativeElement, this.observerConfig);
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.buttonClickNotifier$.next();
      this.buttonClickNotifier$.complete();
      this.queryListNotifier$.next();
      this.queryListNotifier$.complete();
      this.mutationObserver?.disconnect();
    }
    /**
     * @hidden
     */
    _clickHandler(index) {
      const button = this.buttons[index];
      const args = {
        owner: this,
        button,
        index
      };
      if (this.selectionMode !== 'multi') {
        this.buttons.forEach((b, i) => {
          if (i !== index && this.selectedIndexes.indexOf(i) !== -1) {
            this.deselected.emit({
              owner: this,
              button: b,
              index: i
            });
          }
        });
      }
      if (this.selectedIndexes.indexOf(index) === -1) {
        this.selectButton(index);
        this.selected.emit(args);
      } else {
        if (this.selectionMode !== 'singleRequired') {
          this.deselectButton(index);
          this.deselected.emit(args);
        }
      }
    }
    setMutationsObserver() {
      if (typeof MutationObserver !== 'undefined') {
        return new MutationObserver((records, observer) => {
          // Stop observing while handling changes
          observer.disconnect();
          const updatedButtons = this.getUpdatedButtons(records);
          if (updatedButtons.length > 0) {
            updatedButtons.forEach(button => {
              const index = this.buttons.map(b => b.nativeElement).indexOf(button);
              this.updateButtonSelectionState(index);
            });
          }
          // Watch for changes again
          observer.observe(this._el.nativeElement, this.observerConfig);
        });
      }
    }
    getUpdatedButtons(records) {
      const updated = [];
      records.filter(x => x.type === 'attributes').reduce((prev, curr) => {
        prev.push(curr.target);
        return prev;
      }, updated);
      return updated;
    }
    updateButtonSelectionState(index) {
      if (this.buttons[index].selected) {
        this.updateSelected(index);
      } else {
        this.updateDeselected(index);
      }
    }
    static {
      this.ɵfac = function IgxButtonGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxButtonGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxButtonGroupComponent,
        selectors: [["igx-buttongroup"]],
        contentQueries: function IgxButtonGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxButtonDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateButtons = _t);
          }
        },
        viewQuery: function IgxButtonGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxButtonDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewButtons = _t);
          }
        },
        hostVars: 3,
        hostBindings: function IgxButtonGroupComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("z-index", ctx.zIndex);
          }
        },
        inputs: {
          id: "id",
          itemContentCssClass: "itemContentCssClass",
          multiSelection: "multiSelection",
          selectionMode: "selectionMode",
          values: "values",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          alignment: "alignment"
        },
        outputs: {
          selected: "selected",
          deselected: "deselected"
        },
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [["role", "group", 1, "igx-button-group"], ["type", "button", "igxButton", "flat", 3, "selected", "disabled", "igxLabel", "igxRipple"], [1, "igx-button-group__button-text"]],
        template: function IgxButtonGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, IgxButtonGroupComponent_For_2_Template, 4, 10, "button", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-button-group--vertical", ctx.isVertical);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.values);
          }
        },
        dependencies: [IgxButtonDirective, IgxRippleDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxButtonGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Button group directives collection for ease-of-use import in standalone components scenario */
const IGX_BUTTON_GROUP_DIRECTIVES = [IgxButtonGroupComponent, IgxButtonDirective];
const daysInWeek = 7;
const millisecondsInDay = 86400000;
function toCalendarDay(date) {
  return isDate(date) ? CalendarDay.from(date) : date;
}
function checkRollover(original, modified) {
  return original.date !== modified.date ? modified.set({
    date: 0
  }) : modified;
}
class CalendarDay {
  /** Constructs and returns the current day. */
  static get today() {
    return CalendarDay.from(new Date());
  }
  /** Constructs a new CalendarDay instance from a Date object. */
  static from(date) {
    return new CalendarDay({
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date.getDate()
    });
  }
  constructor(args) {
    this._date = new Date(args.year, args.month, args.date ?? 1);
  }
  /** Returns a copy of this instance. */
  clone() {
    return CalendarDay.from(this._date);
  }
  /**
   * Returns a new instance with values replaced.
   */
  set(args) {
    return new CalendarDay({
      year: args.year ?? this.year,
      month: args.month ?? this.month,
      date: args.date ?? this.date
    });
  }
  add(unit, value) {
    const result = this.clone();
    switch (unit) {
      case "year":
        result._date.setFullYear(result.year + value);
        return checkRollover(this, result);
      case "quarter":
        result._date.setMonth(result.month + 3 * value);
        return checkRollover(this, result);
      case "month":
        result._date.setMonth(result.month + value);
        return checkRollover(this, result);
      case "week":
        result._date.setDate(result.date + 7 * value);
        return result;
      case "day":
        result._date.setDate(result.date + value);
        return result;
      default:
        throw new Error("Invalid interval");
    }
  }
  /** Returns the day of the week (Sunday = 0). */
  get day() {
    return this._date.getDay();
  }
  /** Returns the full year. */
  get year() {
    return this._date.getFullYear();
  }
  /** Returns the month. */
  get month() {
    return this._date.getMonth();
  }
  /** Returns the date */
  get date() {
    return this._date.getDate();
  }
  /** Returns the timestamp since epoch in milliseconds. */
  get timestamp() {
    return this._date.getTime();
  }
  /** Returns the current week number. */
  get week() {
    const firstDay = new CalendarDay({
      year: this.year,
      month: 0
    }).timestamp;
    const currentDay = (this.timestamp - firstDay + millisecondsInDay) / millisecondsInDay;
    return Math.ceil(currentDay / daysInWeek);
  }
  /** Returns the underlying native date instance. */
  get native() {
    return new Date(this._date);
  }
  /**
   * Whether the current date is a weekend day.
   *
   * @remarks
   * This is naive, since it does not account for locale specifics.
   */
  get weekend() {
    return this.day < 1 || this.day > 5;
  }
  equalTo(value) {
    return this.timestamp === toCalendarDay(value).timestamp;
  }
  greaterThan(value) {
    return this.timestamp > toCalendarDay(value).timestamp;
  }
  lessThan(value) {
    return this.timestamp < toCalendarDay(value).timestamp;
  }
  toString() {
    return `${this.native}`;
  }
}

/**
 * This file contains all the directives used by the @link IgxCalendarComponent.
 * Except for the directives which are used for templating the calendar itself
 * you should generally not use them directly.
 *
 * @preferred
 */
const IGX_CALENDAR_VIEW_ITEM = new InjectionToken('IgxCalendarViewItem');
let IgxCalendarViewBaseDirective = /*#__PURE__*/(() => {
  class IgxCalendarViewBaseDirective {
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.showActive = false;
      this.itemSelection = new EventEmitter();
    }
    onMouseDown(event) {
      event.preventDefault();
      this.itemSelection.emit(this.value);
    }
    static {
      this.ɵfac = function IgxCalendarViewBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarViewBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarViewBaseDirective,
        hostBindings: function IgxCalendarViewBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function IgxCalendarViewBaseDirective_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
        },
        inputs: {
          value: "value",
          date: "date",
          showActive: "showActive"
        },
        outputs: {
          itemSelection: "itemSelection"
        }
      });
    }
  }
  return IgxCalendarViewBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCalendarYearDirective = /*#__PURE__*/(() => {
  class IgxCalendarYearDirective extends IgxCalendarViewBaseDirective {
    get isCurrent() {
      return CalendarDay.today.year === this.value.getFullYear();
    }
    get isSelected() {
      return this.value.getFullYear() === this.date.getFullYear();
    }
    get isActive() {
      return this.isSelected && this.showActive;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxCalendarYearDirective_BaseFactory;
        return function IgxCalendarYearDirective_Factory(__ngFactoryType__) {
          return (ɵIgxCalendarYearDirective_BaseFactory || (ɵIgxCalendarYearDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxCalendarYearDirective)))(__ngFactoryType__ || IgxCalendarYearDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarYearDirective,
        selectors: [["", "igxCalendarYear", ""]],
        hostVars: 6,
        hostBindings: function IgxCalendarYearDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-calendar-view__item--current", ctx.isCurrent)("igx-calendar-view__item--selected", ctx.isSelected)("igx-calendar-view__item--active", ctx.isActive);
          }
        },
        exportAs: ["igxCalendarYear"],
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_CALENDAR_VIEW_ITEM,
          useExisting: IgxCalendarYearDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxCalendarYearDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCalendarMonthDirective = /*#__PURE__*/(() => {
  class IgxCalendarMonthDirective extends IgxCalendarViewBaseDirective {
    get isCurrent() {
      const today = CalendarDay.today;
      const date = CalendarDay.from(this.value);
      return date.year === today.year && date.month === today.month;
    }
    get isSelected() {
      return this.value.getFullYear() === this.date.getFullYear() && this.value.getMonth() === this.date.getMonth();
    }
    get isActive() {
      return this.isSelected && this.showActive;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxCalendarMonthDirective_BaseFactory;
        return function IgxCalendarMonthDirective_Factory(__ngFactoryType__) {
          return (ɵIgxCalendarMonthDirective_BaseFactory || (ɵIgxCalendarMonthDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxCalendarMonthDirective)))(__ngFactoryType__ || IgxCalendarMonthDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarMonthDirective,
        selectors: [["", "igxCalendarMonth", ""]],
        hostVars: 6,
        hostBindings: function IgxCalendarMonthDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-calendar-view__item--current", ctx.isCurrent)("igx-calendar-view__item--selected", ctx.isSelected)("igx-calendar-view__item--active", ctx.isActive);
          }
        },
        exportAs: ["igxCalendarMonth"],
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_CALENDAR_VIEW_ITEM,
          useExisting: IgxCalendarMonthDirective
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxCalendarMonthDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCalendarHeaderTitleTemplateDirective = /*#__PURE__*/(() => {
  class IgxCalendarHeaderTitleTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxCalendarHeaderTitleTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarHeaderTitleTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarHeaderTitleTemplateDirective,
        selectors: [["", "igxCalendarHeaderTitle", ""]]
      });
    }
  }
  return IgxCalendarHeaderTitleTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCalendarHeaderTemplateDirective = /*#__PURE__*/(() => {
  class IgxCalendarHeaderTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxCalendarHeaderTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarHeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarHeaderTemplateDirective,
        selectors: [["", "igxCalendarHeader", ""]]
      });
    }
  }
  return IgxCalendarHeaderTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCalendarSubheaderTemplateDirective = /*#__PURE__*/(() => {
  class IgxCalendarSubheaderTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxCalendarSubheaderTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarSubheaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarSubheaderTemplateDirective,
        selectors: [["", "igxCalendarSubheader", ""]]
      });
    }
  }
  return IgxCalendarSubheaderTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCalendarScrollPageDirective = /*#__PURE__*/(() => {
  class IgxCalendarScrollPageDirective {
    constructor(element, zone, platform) {
      this.element = element;
      this.zone = zone;
      this.platform = platform;
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
    }
    /**
     * @hidden
     */
    onMouseDown(event) {
      event.preventDefault();
      this.startScroll();
    }
    /**
     * @hidden
     */
    onMouseUp(event) {
      this.stopScroll(event);
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      fromEvent(this.element.nativeElement, 'keyup').pipe(debounce(() => interval(100)), takeUntil(this.destroy$)).subscribe(event => {
        this.stopScroll(event);
      });
      this.zone.runOutsideAngular(() => {
        fromEvent(this.element.nativeElement, 'keydown').pipe(tap(event => {
          if (this.platform.isActivationKey(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }), debounce(() => interval(100)), takeUntil(this.destroy$)).subscribe(event => {
          if (this.platform.isActivationKey(event)) {
            this.zone.run(() => this.startScroll(true));
          }
        });
      });
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function IgxCalendarScrollPageDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarScrollPageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarScrollPageDirective,
        selectors: [["", "igxCalendarScrollPage", ""]],
        hostBindings: function IgxCalendarScrollPageDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function IgxCalendarScrollPageDirective_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            })("mouseup", function IgxCalendarScrollPageDirective_mouseup_HostBindingHandler($event) {
              return ctx.onMouseUp($event);
            });
          }
        },
        inputs: {
          startScroll: "startScroll",
          stopScroll: "stopScroll"
        }
      });
    }
  }
  return IgxCalendarScrollPageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets the selection type - single, multi or range.
 */
const CalendarSelection = /*@__PURE__*/mkenum({
  SINGLE: 'single',
  MULTI: 'multi',
  RANGE: 'range'
});
const IgxCalendarView = /*@__PURE__*/mkenum({
  Month: 'month',
  Year: 'year',
  Decade: 'decade'
});
const MDAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const FEBRUARY = 1;
const range = (start = 0, stop, step = 1) => {
  const res = [];
  const cur = stop === undefined ? 0 : start;
  const max = stop === undefined ? start : stop;
  for (let i = cur; step < 0 ? i > max : i < max; i += step) {
    res.push(i);
  }
  return res;
};
/**
 * Returns true for leap years, false for non-leap years.
 *
 * @export
 * @param year
 * @returns
 */
const isLeap = year => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
const weekDay = (year, month, day) => new Date(year, month, day).getDay();
/**
 * Return weekday and number of days for year, month.
 *
 * @export
 * @param year
 * @param month
 * @returns
 */
const monthRange = (year, month) => {
  if (month < 0 || month > 11) {
    throw new Error('Invalid month specified');
  }
  const day = weekDay(year, month, 1);
  let nDays = MDAYS[month];
  if (month === FEBRUARY && isLeap(year)) {
    nDays++;
  }
  return [day, nDays];
};
var WEEKDAYS = /*#__PURE__*/function (WEEKDAYS) {
  WEEKDAYS[WEEKDAYS["SUNDAY"] = 0] = "SUNDAY";
  WEEKDAYS[WEEKDAYS["MONDAY"] = 1] = "MONDAY";
  WEEKDAYS[WEEKDAYS["TUESDAY"] = 2] = "TUESDAY";
  WEEKDAYS[WEEKDAYS["WEDNESDAY"] = 3] = "WEDNESDAY";
  WEEKDAYS[WEEKDAYS["THURSDAY"] = 4] = "THURSDAY";
  WEEKDAYS[WEEKDAYS["FRIDAY"] = 5] = "FRIDAY";
  WEEKDAYS[WEEKDAYS["SATURDAY"] = 6] = "SATURDAY";
  return WEEKDAYS;
}(WEEKDAYS || {});
class Calendar {
  timedelta(date, interval, units) {
    const ret = new Date(date);
    const checkRollover = () => {
      if (ret.getDate() !== date.getDate()) {
        ret.setDate(0);
      }
    };
    switch (interval.toLowerCase()) {
      case 'year':
        ret.setFullYear(ret.getFullYear() + units);
        checkRollover();
        break;
      case 'quarter':
        ret.setMonth(ret.getMonth() + 3 * units);
        checkRollover();
        break;
      case 'month':
        ret.setMonth(ret.getMonth() + units);
        checkRollover();
        break;
      case 'week':
        ret.setDate(ret.getDate() + 7 * units);
        break;
      case 'day':
        ret.setDate(ret.getDate() + units);
        break;
      case 'hour':
        ret.setTime(ret.getTime() + units * 3600000);
        break;
      case 'minute':
        ret.setTime(ret.getTime() + units * 60000);
        break;
      case 'second':
        ret.setTime(ret.getTime() + units * 1000);
        break;
      default:
        throw new Error('Invalid interval specifier');
    }
    return ret;
  }
}
var DateRangeType$1 = /*#__PURE__*/function (DateRangeType) {
  DateRangeType[DateRangeType["After"] = 0] = "After";
  DateRangeType[DateRangeType["Before"] = 1] = "Before";
  DateRangeType[DateRangeType["Between"] = 2] = "Between";
  DateRangeType[DateRangeType["Specific"] = 3] = "Specific";
  DateRangeType[DateRangeType["Weekdays"] = 4] = "Weekdays";
  DateRangeType[DateRangeType["Weekends"] = 5] = "Weekends";
  return DateRangeType;
}(DateRangeType$1 || {});
function areSameMonth(firstMonth, secondMonth) {
  const [a, b] = [toCalendarDay(firstMonth), toCalendarDay(secondMonth)];
  return a.year === b.year && a.month === b.month;
}
function isNextMonth(target, origin) {
  const [a, b] = [toCalendarDay(target), toCalendarDay(origin)];
  return a.year === b.year ? a.month > b.month : a.year > b.year;
}
function isPreviousMonth(target, origin) {
  const [a, b] = [toCalendarDay(target), toCalendarDay(origin)];
  return a.year === b.year ? a.month < b.month : a.year < b.year;
}
/** Returns the next date starting from `start` that does not match the `disabled` descriptors */
function getNextActiveDate(start, disabled = []) {
  while (isDateInRanges(start, disabled)) {
    start = start.add("day", 1);
  }
  return start;
}
/** Returns the previous date starting from `start` that does not match the `disabled` descriptors */
function getPreviousActiveDate(start, disabled = []) {
  while (isDateInRanges(start, disabled)) {
    start = start.add("day", -1);
  }
  return start;
}
function getClosestActiveDate(start, delta, disabled = []) {
  // TODO: implement a more robust logic for max attempts,
  // i.e. the amount of days to jump between before giving up
  // currently it will try to find the closest date for a year
  const maxAttempts = 366;
  let date = start;
  let attempts = 0;
  while (attempts < maxAttempts) {
    date = start.add("day", delta * (attempts + 1));
    if (!isDateInRanges(date, disabled)) {
      return date;
    }
    attempts++;
  }
  return date;
}
/**
 * Returns a generator yielding day values between `start` and `end` (non-inclusive)
 * by a given `unit` as a step.
 *
 * @remarks
 * By default, `unit` is set to 'day'.
 */
function* calendarRange(options) {
  let low = toCalendarDay(options.start);
  const unit = options.unit ?? "day";
  const high = typeof options.end === "number" ? low.add(unit, options.end) : toCalendarDay(options.end);
  const reverse = high.lessThan(low);
  const step = reverse ? -1 : 1;
  while (!reverse ? low.lessThan(high) : low.greaterThan(high)) {
    yield low;
    low = low.add(unit, step);
  }
}
function* generateMonth(value, firstWeekDay) {
  const {
    year,
    month
  } = toCalendarDay(value);
  const start = new CalendarDay({
    year,
    month
  });
  const offset = modulo(start.day - firstWeekDay, daysInWeek);
  yield* calendarRange({
    start: start.add("day", -offset),
    end: 42
  });
}
function getYearRange(current, range) {
  const year = toCalendarDay(current).year;
  const start = Math.floor(year / range) * range;
  return {
    start,
    end: start + range - 1
  };
}
function isDateInRanges(date, ranges) {
  const value = toCalendarDay(date);
  return ranges.some(range => {
    const days = (range.dateRange ?? []).map(day => toCalendarDay(day));
    switch (range.type) {
      case DateRangeType$1.After:
        return value.greaterThan(first$1(days));
      case DateRangeType$1.Before:
        return value.lessThan(first$1(days));
      case DateRangeType$1.Between:
        {
          const min = Math.min(first$1(days).timestamp, last$1(days).timestamp);
          const max = Math.max(first$1(days).timestamp, last$1(days).timestamp);
          return value.timestamp >= min && value.timestamp <= max;
        }
      case DateRangeType$1.Specific:
        return days.some(day => day.equalTo(value));
      case DateRangeType$1.Weekdays:
        return !value.weekend;
      case DateRangeType$1.Weekends:
        return value.weekend;
      default:
        return false;
    }
  });
}
function formatToParts(date, locale, options, parts) {
  const formatter = new Intl.DateTimeFormat(locale, options);
  const result = {
    date,
    full: formatter.format(date)
  };
  const getFormattedPart = (formattedParts, partType) => {
    const part = formattedParts.find(({
      type
    }) => type === partType);
    const nextPart = formattedParts[formattedParts.indexOf(part) + 1];
    const value = part?.value || "";
    const literal = nextPart?.type === "literal" ? nextPart.value : "";
    return {
      value,
      literal,
      combined: value + literal
    };
  };
  if ("formatToParts" in formatter) {
    const formattedParts = formatter.formatToParts(date);
    parts.forEach(part => result[part] = getFormattedPart(formattedParts, part));
  } else {
    parts.forEach(part => result[part] = {
      value: "",
      literal: "",
      combined: ""
    });
  }
  return result;
}
var DateRangeType = /*#__PURE__*/function (DateRangeType) {
  DateRangeType[DateRangeType["After"] = 0] = "After";
  DateRangeType[DateRangeType["Before"] = 1] = "Before";
  DateRangeType[DateRangeType["Between"] = 2] = "Between";
  DateRangeType[DateRangeType["Specific"] = 3] = "Specific";
  DateRangeType[DateRangeType["Weekdays"] = 4] = "Weekdays";
  DateRangeType[DateRangeType["Weekends"] = 5] = "Weekends";
  return DateRangeType;
}(DateRangeType || {});
var Direction$1 = /*#__PURE__*/function (Direction) {
  Direction[Direction["NEXT"] = 1] = "NEXT";
  Direction[Direction["PREV"] = -1] = "PREV";
  return Direction;
}(Direction$1 || {});
const DAY_INTERVAL_TOKEN = new InjectionToken("DAY_INTERVAL");
let IgxCalendarViewDirective = /*#__PURE__*/(() => {
  class IgxCalendarViewDirective {
    get activeDescendant() {
      if (this.tabIndex === -1) return;
      return this.date.getTime();
    }
    /**
     * Gets/sets the selected date of the view.
     * By default it's the current date.
     * ```typescript
     * let date = this.view.date;
     * ```
     *
     * @memberof IgxYearsViewComponent
     */
    set date(value) {
      if (!isDate(value)) return;
      this._date = value;
    }
    get date() {
      return this._date;
    }
    /**
     * Gets the `locale` of the view.
     * Default value is `"en"`.
     * ```typescript
     * let locale = this.view.locale;
     * ```
     *
     * @memberof IgxCalendarViewDirective
     */
    get locale() {
      return this._locale;
    }
    /**
     * Sets the `locale` of the view.
     * Expects a valid BCP 47 language tag.
     * Default value is `"en"`.
     *
     * @memberof IgxCalendarViewDirective
     */
    set locale(value) {
      this._locale = value;
      this.initFormatter();
    }
    constructor(dayInterval) {
      this.dayInterval = dayInterval;
      this.role = 'grid';
      this.tabIndex = 0;
      /**
       * Applies styles to the active item on view focus.
       */
      this.showActive = false;
      /**
       * Emits an event when a selection is made in the view.
       * Provides reference the `date` property in the component.
       * @memberof IgxCalendarViewDirective
       */
      this.selected = new EventEmitter();
      /**
       * Emits an event when a page changes in the view.
       * Provides reference the `date` property in the component.
       * @memberof IgxCalendarViewDirective
       * @hidden @internal
       */
      this.pageChanged = new EventEmitter();
      /**
       * Emits an event when the active date has changed.
       * @memberof IgxCalendarViewDirective
       * @hidden @internal
       */
      this.activeDateChanged = new EventEmitter();
      /**
       * @hidden
       */
      this._locale = "en";
      /**
       * @hidden
       * @internal
       */
      this._date = new Date();
      /**
       * @hidden
       */
      this._onTouchedCallback = noop;
      /**
       * @hidden
       */
      this._onChangeCallback = noop;
      this.initFormatter();
    }
    /**
     * @hidden
     */
    onKeydownArrowDown(event) {
      this.navigateTo(event, Direction$1.NEXT, 3);
    }
    /**
     * @hidden
     */
    onKeydownArrowUp(event) {
      this.navigateTo(event, Direction$1.PREV, 3);
    }
    /**
     * @hidden
     */
    onKeydownArrowRight(event) {
      this.navigateTo(event, Direction$1.NEXT, 1);
    }
    /**
     * @hidden
     */
    onKeydownArrowLeft(event) {
      this.navigateTo(event, Direction$1.PREV, 1);
    }
    /**
     * @hidden
     */
    onKeydownHome(event) {
      event.preventDefault();
      event.stopPropagation();
      this.date = this.range.at(0);
      this.activeDateChanged.emit(this.date);
    }
    /**
     * @hidden
     */
    onKeydownEnd(event) {
      event.preventDefault();
      event.stopPropagation();
      this.date = this.range.at(-1);
      this.activeDateChanged.emit(this.date);
    }
    /**
     * @hidden
     */
    onKeydownEnter(event) {
      event.stopPropagation();
      this.selected.emit(this.date);
      this._onChangeCallback(this.date);
    }
    /**
     * @hidden
     */
    handleFocus() {
      this.showActive = true;
    }
    /**
     * @hidden
     */
    handleBlur() {
      this.showActive = false;
    }
    /**
     * @hidden
     */
    selectDate(value) {
      this.date = value;
      this.selected.emit(this.date);
      this._onChangeCallback(this.date);
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /**
     * @hidden
     */
    writeValue(value) {
      if (value) {
        this.date = value;
      }
    }
    /**
     * @hidden
     */
    navigateTo(event, direction, delta) {
      event.preventDefault();
      event.stopPropagation();
      const date = getNextActiveDate(CalendarDay.from(this.date).add(this.dayInterval, direction * delta), []);
      const outOfRange = !isDateInRanges(date, [{
        type: DateRangeType.Between,
        dateRange: [this.range.at(0), this.range.at(-1)]
      }]);
      if (outOfRange) {
        this.pageChanged.emit(date.native);
      }
      this.date = date.native;
      this.activeDateChanged.emit(this.date);
    }
    static {
      this.ɵfac = function IgxCalendarViewDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarViewDirective)(i0.ɵɵdirectiveInject(DAY_INTERVAL_TOKEN));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarViewDirective,
        viewQuery: function IgxCalendarViewDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IGX_CALENDAR_VIEW_ITEM, 5, IGX_CALENDAR_VIEW_ITEM);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewItems = _t);
          }
        },
        hostVars: 3,
        hostBindings: function IgxCalendarViewDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.arrowdown", function IgxCalendarViewDirective_keydown_arrowdown_HostBindingHandler($event) {
              return ctx.onKeydownArrowDown($event);
            })("keydown.arrowup", function IgxCalendarViewDirective_keydown_arrowup_HostBindingHandler($event) {
              return ctx.onKeydownArrowUp($event);
            })("keydown.arrowright", function IgxCalendarViewDirective_keydown_arrowright_HostBindingHandler($event) {
              return ctx.onKeydownArrowRight($event);
            })("keydown.arrowleft", function IgxCalendarViewDirective_keydown_arrowleft_HostBindingHandler($event) {
              return ctx.onKeydownArrowLeft($event);
            })("keydown.home", function IgxCalendarViewDirective_keydown_home_HostBindingHandler($event) {
              return ctx.onKeydownHome($event);
            })("keydown.end", function IgxCalendarViewDirective_keydown_end_HostBindingHandler($event) {
              return ctx.onKeydownEnd($event);
            })("keydown.enter", function IgxCalendarViewDirective_keydown_enter_HostBindingHandler($event) {
              return ctx.onKeydownEnter($event);
            })("focus", function IgxCalendarViewDirective_focus_HostBindingHandler() {
              return ctx.handleFocus();
            })("blur", function IgxCalendarViewDirective_blur_HostBindingHandler() {
              return ctx.handleBlur();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("tabIndex", ctx.tabIndex)("aria-activeDescendant", ctx.activeDescendant);
          }
        },
        inputs: {
          role: "role",
          tabIndex: "tabIndex",
          formatView: [2, "formatView", "formatView", booleanAttribute],
          showActive: [2, "showActive", "showActive", booleanAttribute],
          date: "date",
          locale: "locale"
        },
        outputs: {
          selected: "selected",
          pageChanged: "pageChanged",
          activeDateChanged: "activeDateChanged"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxCalendarViewDirective,
          multi: true
        }])]
      });
    }
  }
  return IgxCalendarViewDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$l = 0;
let IgxMonthsViewComponent = /*#__PURE__*/(() => {
  class IgxMonthsViewComponent extends IgxCalendarViewDirective {
    #standalone;
    /**
     * @hidden @internal
     */
    get standalone() {
      return this.#standalone;
    }
    set standalone(value) {
      this.#standalone = value;
    }
    /**
     * Gets the month format option of the months view.
     * ```typescript
     * let monthFormat = this.monthsView.monthFormat.
     * ```
     */
    get monthFormat() {
      return this._monthFormat;
    }
    /**
     * Sets the month format option of the months view.
     * ```html
     * <igx-months-view> [monthFormat]="short'"</igx-months-view>
     * ```
     *
     * @memberof IgxMonthsViewComponent
     */
    set monthFormat(value) {
      this._monthFormat = value;
      this.initFormatter();
    }
    /**
     * Returns an array of date objects which are then used to
     * properly render the month names.
     *
     * Used in the template of the component
     *
     * @hidden @internal
     */
    get range() {
      const start = CalendarDay.from(this.date).set({
        date: 1,
        month: 0
      });
      const end = start.add(this.dayInterval, 12);
      return Array.from(calendarRange({
        start,
        end,
        unit: this.dayInterval
      })).map(m => m.native);
    }
    constructor(el, dayInterval) {
      super(dayInterval);
      this.el = el;
      this.#standalone = true;
      /**
       * Sets/gets the `id` of the months view.
       * If not set, the `id` will have value `"igx-months-view-0"`.
       * ```html
       * <igx-months-view id="my-months-view"></igx-months-view>
       * ```
       * ```typescript
       * let monthsViewId =  this.monthsView.id;
       * ```
       *
       * @memberof IgxMonthsViewComponent
       */
      this.id = `igx-months-view-${NEXT_ID$l++}`;
      /**
       * The default css class applied to the component.
       *
       * @hidden
       */
      this.viewClass = true;
      /**
       * Gets/sets whether the view should be rendered
       * according to the locale and format, if any.
       */
      this.formatView = true;
      /**
       * @hidden
       */
      this._monthFormat = "short";
    }
    /**
     * @hidden
     */
    onMouseDown() {
      if (this.tabIndex !== -1) {
        this.el.nativeElement.focus();
      }
    }
    /**
     * Returns the locale representation of the month in the months view.
     *
     * @hidden
     */
    formattedMonth(value) {
      const rawFormatter = new Intl.DateTimeFormat(this.locale, {
        month: "long",
        year: "numeric"
      });
      if (this.formatView) {
        return {
          long: rawFormatter.format(value),
          formatted: this._formatter.format(value)
        };
      }
      return {
        long: rawFormatter.format(value),
        formatted: `${value.getMonth()}`
      };
    }
    /**
     * @hidden
     */
    monthTracker(_, item) {
      return `${item.getMonth()}}`;
    }
    /**
     * @hidden
     */
    initFormatter() {
      this._formatter = new Intl.DateTimeFormat(this._locale, {
        month: this.monthFormat
      });
    }
    static {
      this.ɵfac = function IgxMonthsViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxMonthsViewComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DAY_INTERVAL_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxMonthsViewComponent,
        selectors: [["igx-months-view"]],
        hostVars: 5,
        hostBindings: function IgxMonthsViewComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-calendar-view", ctx.viewClass)("igx-calendar-view--standalone", ctx.standalone);
          }
        },
        inputs: {
          id: "id",
          standalone: "standalone",
          monthFormat: "monthFormat",
          formatView: [2, "formatView", "formatView", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxMonthsViewComponent,
          multi: true
        }, {
          provide: DAY_INTERVAL_TOKEN,
          useValue: "month"
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 0,
        consts: [["item", "igxCalendarMonth"], ["role", "row", 1, "igx-calendar-view__items"], ["igxCalendarMonth", "", "role", "gridcell", 1, "igx-calendar-view__item", 3, "value", "date", "showActive"], ["igxCalendarMonth", "", "role", "gridcell", 1, "igx-calendar-view__item", 3, "itemSelection", "mousedown", "value", "date", "showActive"], ["aria-hidden", "true", 1, "igx-calendar-view__item-inner"]],
        template: function IgxMonthsViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵrepeaterCreate(1, IgxMonthsViewComponent_For_2_Template, 5, 9, "span", 2, ctx.monthTracker, true);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.range);
          }
        },
        dependencies: [IgxCalendarMonthDirective, TitleCasePipe],
        encapsulation: 2
      });
    }
  }
  return IgxMonthsViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxYearsViewComponent = /*#__PURE__*/(() => {
  class IgxYearsViewComponent extends IgxCalendarViewDirective {
    #standalone;
    /**
     * @hidden @internal
     */
    get standalone() {
      return this.#standalone;
    }
    set standalone(value) {
      this.#standalone = value;
    }
    /**
     * Gets the year format option of the years view.
     * ```typescript
     * let yearFormat = this.yearsView.yearFormat.
     * ```
     */
    get yearFormat() {
      return this._yearFormat;
    }
    /**
     * Sets the year format option of the years view.
     * ```html
     * <igx-years-view [yearFormat]="numeric"></igx-years-view>
     * ```
     *
     * @memberof IgxYearsViewComponent
     */
    set yearFormat(value) {
      this._yearFormat = value;
      this.initFormatter();
    }
    /**
     * Returns an array of date objects which are then used to properly
     * render the years.
     *
     * Used in the template of the component.
     *
     * @hidden @internal
     */
    get range() {
      const year = this.date.getFullYear();
      const start = new CalendarDay({
        year: Math.floor(year / this._yearsPerPage) * this._yearsPerPage,
        month: this.date.getMonth()
      });
      const end = start.add(this.dayInterval, this._yearsPerPage);
      return Array.from(calendarRange({
        start,
        end,
        unit: this.dayInterval
      })).map(m => m.native);
    }
    constructor(el, dayInterval) {
      super(dayInterval);
      this.el = el;
      this.#standalone = true;
      /**
       * The default css class applied to the component.
       *
       * @hidden
       */
      this.viewClass = true;
      /**
       * @hidden
       */
      this._yearFormat = "numeric";
      /**
       * @hidden
       */
      this._yearsPerPage = 15;
    }
    /**
     * Returns the locale representation of the year in the years view.
     *
     * @hidden
     */
    formattedYear(value) {
      const rawFormatter = new Intl.DateTimeFormat(this.locale, {
        year: 'numeric'
      });
      if (this.formatView) {
        return {
          long: rawFormatter.format(value),
          formatted: this._formatter.format(value)
        };
      }
      return {
        long: rawFormatter.format(value),
        formatted: `${value.getFullYear()}`
      };
    }
    /**
     * @hidden
     */
    yearTracker(_, item) {
      return `${item.getFullYear()}}`;
    }
    /**
     * @hidden
     */
    initFormatter() {
      this._formatter = new Intl.DateTimeFormat(this._locale, {
        year: this.yearFormat
      });
    }
    /**
     * @hidden
     */
    onMouseDown() {
      if (this.tabIndex !== -1) {
        this.el.nativeElement.focus();
      }
    }
    static {
      this.ɵfac = function IgxYearsViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxYearsViewComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DAY_INTERVAL_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxYearsViewComponent,
        selectors: [["igx-years-view"]],
        hostVars: 4,
        hostBindings: function IgxYearsViewComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-calendar-view", ctx.viewClass)("igx-calendar-view--standalone", ctx.standalone);
          }
        },
        inputs: {
          standalone: "standalone",
          yearFormat: "yearFormat"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxYearsViewComponent,
          multi: true
        }, {
          provide: DAY_INTERVAL_TOKEN,
          useValue: "year"
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 0,
        consts: [["item", "igxCalendarYear"], ["role", "row", 1, "igx-calendar-view__items"], ["igxCalendarYear", "", "role", "gridcell", 1, "igx-calendar-view__item", 3, "value", "date", "showActive"], ["igxCalendarYear", "", "role", "gridcell", 1, "igx-calendar-view__item", 3, "itemSelection", "mousedown", "value", "date", "showActive"], ["aria-hidden", "true", 1, "igx-calendar-view__item-inner"]],
        template: function IgxYearsViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵrepeaterCreate(1, IgxYearsViewComponent_For_2_Template, 4, 8, "span", 2, ctx.yearTracker, true);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.range);
          }
        },
        dependencies: [IgxCalendarYearDirective],
        encapsulation: 2
      });
    }
  }
  return IgxYearsViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxDayItemComponent = /*#__PURE__*/(() => {
  class IgxDayItemComponent {
    /**
     * Returns boolean indicating if the day is selected
     *
     */
    get selected() {
      return this._selected;
    }
    /**
     * Selects the day
     */
    set selected(value) {
      this._selected = value;
    }
    get hideLeading() {
      return this.hideLeadingDays && this.isPreviousMonth;
    }
    get hideTrailing() {
      return this.hideTrailingDays && this.isNextMonth;
    }
    get isCurrentMonth() {
      return areSameMonth(this.date, this.viewDate);
    }
    get isPreviousMonth() {
      return isPreviousMonth(this.date, this.viewDate);
    }
    get isNextMonth() {
      return isNextMonth(this.date, this.viewDate);
    }
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    get isSelectedCSS() {
      const selectable = !this.isInactive || this.isWithinPreviewRange || this.isWithinRange && this.selection === "range";
      return !this.isDisabled && selectable && this.selected;
    }
    get isInactive() {
      return !this.isCurrentMonth;
    }
    get isHidden() {
      return (this.hideLeading || this.hideTrailing) && this.isInactive;
    }
    get isToday() {
      return !this.isInactive && this.date.equalTo(CalendarDay.today);
    }
    get isWeekend() {
      return this.date.weekend;
    }
    get isDisabled() {
      if (!this.disabledDates) {
        return false;
      }
      return isDateInRanges(this.date, this.disabledDates);
    }
    get isFocusable() {
      return this.isCurrentMonth && !this.isHidden && !this.isDisabled;
    }
    onMouseEnter() {
      this.mouseEnter.emit();
    }
    onMouseLeave() {
      this.mouseLeave.emit();
    }
    onMouseDown(event) {
      event.preventDefault();
      this.mouseDown.emit();
    }
    get isWithinRangeCSS() {
      return !this.isSingleSelection && this.isWithinRange;
    }
    get isWithinPreviewRangeCSS() {
      return !this.isSingleSelection && this.isWithinPreviewRange;
    }
    get isSpecial() {
      if (!this.specialDates) {
        return false;
      }
      return !this.isInactive && isDateInRanges(this.date, this.specialDates);
    }
    get isDisabledCSS() {
      return this.isHidden || this.isDisabled;
    }
    get isSingleSelection() {
      return this.selection !== CalendarSelection.RANGE;
    }
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.hideOutsideDays = false;
      this.isLastInRange = false;
      this.isFirstInRange = false;
      this.isWithinRange = false;
      this.isWithinPreviewRange = false;
      this.hideLeadingDays = false;
      this.hideTrailingDays = false;
      this.dateSelection = new EventEmitter();
      this.mouseEnter = new EventEmitter();
      this.mouseLeave = new EventEmitter();
      this.mouseDown = new EventEmitter();
      this.isActive = false;
      this._selected = false;
    }
    static {
      this.ɵfac = function IgxDayItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDayItemComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDayItemComponent,
        selectors: [["igx-day-item"]],
        hostVars: 26,
        hostBindings: function IgxDayItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-days-view__date--last", ctx.isLastInRange)("igx-days-view__date--first", ctx.isFirstInRange)("igx-days-view__date--active", ctx.isActive)("igx-days-view__date--selected", ctx.isSelectedCSS)("igx-days-view__date--inactive", ctx.isInactive)("igx-days-view__date--hidden", ctx.isHidden)("igx-days-view__date--current", ctx.isToday)("igx-days-view__date--weekend", ctx.isWeekend)("igx-days-view__date--range", ctx.isWithinRangeCSS)("igx-days-view__date--range-preview", ctx.isWithinPreviewRangeCSS)("igx-days-view__date--special", ctx.isSpecial)("igx-days-view__date--disabled", ctx.isDisabledCSS)("igx-days-view__date--single", ctx.isSingleSelection);
          }
        },
        inputs: {
          date: "date",
          viewDate: "viewDate",
          selection: "selection",
          selected: "selected",
          disabledDates: "disabledDates",
          specialDates: "specialDates",
          hideOutsideDays: [2, "hideOutsideDays", "hideOutsideDays", booleanAttribute],
          isLastInRange: [2, "isLastInRange", "isLastInRange", booleanAttribute],
          isFirstInRange: [2, "isFirstInRange", "isFirstInRange", booleanAttribute],
          isWithinRange: [2, "isWithinRange", "isWithinRange", booleanAttribute],
          isWithinPreviewRange: [2, "isWithinPreviewRange", "isWithinPreviewRange", booleanAttribute],
          hideLeadingDays: [2, "hideLeadingDays", "hideLeadingDays", booleanAttribute],
          hideTrailingDays: [2, "hideTrailingDays", "hideTrailingDays", booleanAttribute],
          isActive: [2, "isActive", "isActive", booleanAttribute]
        },
        outputs: {
          dateSelection: "dateSelection",
          mouseEnter: "mouseEnter",
          mouseLeave: "mouseLeave",
          mouseDown: "mouseDown"
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 0,
        consts: [["aria-hidden", "true", 1, "igx-days-view__date-inner", 3, "mouseenter", "mouseleave", "mousedown"]],
        template: function IgxDayItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵlistener("mouseenter", function IgxDayItemComponent_Template_span_mouseenter_0_listener() {
              return ctx.onMouseEnter();
            })("mouseleave", function IgxDayItemComponent_Template_span_mouseleave_0_listener() {
              return ctx.onMouseLeave();
            })("mousedown", function IgxDayItemComponent_Template_span_mousedown_0_listener($event) {
              return ctx.onMouseDown($event);
            });
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxDayItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CalendarResourceStringsEN = {
  igx_calendar_previous_month: 'Previous Month',
  igx_calendar_next_month: 'Next Month',
  igx_calendar_previous_year: 'Previous Year',
  igx_calendar_next_year: 'Next Year',
  igx_calendar_previous_years: 'Previous {0} Years',
  igx_calendar_next_years: 'Next {0} Years',
  igx_calendar_select_date: 'Select Date',
  igx_calendar_select_month: 'Select Month',
  igx_calendar_select_year: 'Select Year',
  igx_calendar_range_start: 'Range start',
  igx_calendar_range_end: 'Range end',
  igx_calendar_range_label_start: 'Start',
  igx_calendar_range_label_end: 'End',
  igx_calendar_range_placeholder: 'Select Range',
  igx_calendar_selected_month_is: 'Selected month is ',
  igx_calendar_first_picker_of: 'First picker of {0} starts from',
  igx_calendar_multi_selection: 'Multi selection calendar with {0} date pickers',
  igx_calendar_range_selection: 'Range selection calendar with {0} date pickers',
  igx_calendar_single_selection: 'Calendar with {0} date pickers',
  igx_calendar_singular_multi_selection: 'Multi selection calendar',
  igx_calendar_singular_range_selection: 'Range selection calendar',
  igx_calendar_singular_single_selection: 'Calendar'
};
let KeyboardNavigationService = /*#__PURE__*/(() => {
  class KeyboardNavigationService {
    constructor(eventManager, ngZone) {
      this.eventManager = eventManager;
      this.ngZone = ngZone;
      this.keyHandlers = new Map();
      this.eventUnsubscribeFn = null;
    }
    attachKeyboardHandlers(elementRef, context) {
      this.detachKeyboardHandlers(); // Clean up any existing listeners
      this.ngZone.runOutsideAngular(() => {
        this.eventUnsubscribeFn = this.eventManager.addEventListener(elementRef.nativeElement, 'keydown', event => {
          const handler = this.keyHandlers.get(event.key);
          if (handler) {
            this.ngZone.run(handler.bind(context, event));
          }
        });
      });
      return this;
    }
    detachKeyboardHandlers() {
      if (this.eventUnsubscribeFn) {
        this.eventUnsubscribeFn();
        this.eventUnsubscribeFn = null;
      }
      this.keyHandlers.clear();
    }
    set(key, handler) {
      this.keyHandlers.set(key, handler);
      return this;
    }
    unset(key) {
      this.keyHandlers.delete(key);
      return this;
    }
    static {
      this.ɵfac = function KeyboardNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KeyboardNavigationService)(i0.ɵɵinject(i1$1.EventManager), i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: KeyboardNavigationService,
        factory: KeyboardNavigationService.ɵfac
      });
    }
  }
  return KeyboardNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let IgxCalendarBaseDirective = /*#__PURE__*/(() => {
  class IgxCalendarBaseDirective {
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Gets the start day of the week.
     * Can return a numeric or an enum representation of the week day.
     * If not set, defaults to the first day of the week for the application locale.
     */
    get weekStart() {
      return this._weekStart;
    }
    /**
     * Sets the start day of the week.
     * Can be assigned to a numeric value or to `WEEKDAYS` enum value.
     */
    set weekStart(value) {
      this._weekStart = value;
    }
    /**
     * Gets the `locale` of the calendar.
     * If not set, defaults to application's locale.
     */
    get locale() {
      return this._locale;
    }
    /**
     * Sets the `locale` of the calendar.
     * Expects a valid BCP 47 language tag.
     */
    set locale(value) {
      this._locale = value;
      // if value is not a valid BCP 47 tag, set it back to _localeId
      try {
        getLocaleFirstDayOfWeek(this._locale);
      } catch (e) {
        this._locale = this._localeId;
      }
      // changing locale runtime needs to update the `weekStart` too, if `weekStart` is not explicitly set
      if (!this.weekStart) {
        this.weekStart = getLocaleFirstDayOfWeek(this._locale);
      }
      this.initFormatters();
    }
    /**
     * Gets the date format options of the views.
     */
    get formatOptions() {
      return this._formatOptions;
    }
    /**
     * Sets the date format options of the views.
     * Default is { day: 'numeric', month: 'short', weekday: 'short', year: 'numeric' }
     */
    set formatOptions(formatOptions) {
      this._formatOptions = {
        ...this._formatOptions,
        ...formatOptions
      };
      this.initFormatters();
    }
    /**
     * Gets whether the `day`, `month` and `year` should be rendered
     * according to the locale and formatOptions, if any.
     */
    get formatViews() {
      return this._formatViews;
    }
    /**
     * Sets whether the `day`, `month` and `year` should be rendered
     * according to the locale and formatOptions, if any.
     */
    set formatViews(formatViews) {
      this._formatViews = Object.assign(this._formatViews, formatViews);
    }
    /**
     * Gets the current active view.
     * ```typescript
     * this.activeView = calendar.activeView;
     * ```
     */
    get activeView() {
      return this._activeView;
    }
    /**
     * Sets the current active view.
     * ```html
     * <igx-calendar [activeView]="year" #calendar></igx-calendar>
     * ```
     * ```typescript
     * calendar.activeView = IgxCalendarView.YEAR;
     * ```
     */
    set activeView(val) {
      this._activeView = val;
      this.activeViewSubject.next(val);
    }
    /**
     * @hidden
     */
    get isDefaultView() {
      return this._activeView === IgxCalendarView.Month;
    }
    /**
     * @hidden
     */
    get isDecadeView() {
      return this._activeView === IgxCalendarView.Decade;
    }
    /**
     * @hidden
     */
    activeViewDecade(activeViewIdx = 0) {
      this.activeView = IgxCalendarView.Decade;
      this.activeViewIdx = activeViewIdx;
    }
    /**
     * @hidden
     */
    activeViewDecadeKB(event, activeViewIdx = 0) {
      event.stopPropagation();
      if (this.platform.isActivationKey(event)) {
        event.preventDefault();
        this.activeViewDecade(activeViewIdx);
      }
    }
    /**
     * @hidden
     */
    changeYear(date) {
      this.previousViewDate = this.viewDate;
      this.viewDate = CalendarDay.from(date).add('month', -this.activeViewIdx).native;
      this.activeView = IgxCalendarView.Month;
    }
    /**
     * Returns the locale representation of the year in the year view if enabled,
     * otherwise returns the default `Date.getFullYear()` value.
     *
     * @hidden
     */
    formattedYear(value) {
      if (Array.isArray(value)) {
        return;
      }
      if (this.formatViews.year) {
        return this.formatterYear.format(value);
      }
      return `${value.getFullYear()}`;
    }
    formattedYears(value) {
      const dates = value;
      return dates.map(date => this.formattedYear(date)).join(' - ');
    }
    prevNavLabel(detail) {
      switch (this.activeView) {
        case 'month':
          return `${this.resourceStrings.igx_calendar_previous_month}, ${detail}`;
        case 'year':
          return this.resourceStrings.igx_calendar_previous_year.replace('{0}', '15');
        case 'decade':
          return this.resourceStrings.igx_calendar_previous_years.replace('{0}', '15');
      }
    }
    nextNavLabel(detail) {
      switch (this.activeView) {
        case 'month':
          return `${this.resourceStrings.igx_calendar_next_month}, ${detail}`;
        case 'year':
          return this.resourceStrings.igx_calendar_next_year.replace('{0}', '15');
        case 'decade':
          return this.resourceStrings.igx_calendar_next_years.replace('{0}', '15');
      }
    }
    getDecadeRange() {
      const range = getYearRange(this.viewDate, 15);
      const start = CalendarDay.from(this.viewDate).set({
        date: 1,
        year: range.start
      });
      const end = CalendarDay.from(this.viewDate).set({
        date: 1,
        year: range.end
      });
      return {
        start: this.formatterYear.format(start.native),
        end: this.formatterYear.format(end.native)
      };
    }
    /**
     *
     * Gets the selection type.
     * Default value is `"single"`.
     * Changing the type of selection resets the currently
     * selected values if any.
     */
    get selection() {
      return this._selection;
    }
    /**
     * Sets the selection.
     */
    set selection(value) {
      switch (value) {
        case CalendarSelection.SINGLE:
          this.selectedDates = null;
          break;
        case CalendarSelection.MULTI:
        case CalendarSelection.RANGE:
          this.selectedDates = [];
          break;
        default:
          throw new Error('Invalid selection value');
      }
      this._onChangeCallback(this.selectedDates);
      this.rangeStarted = false;
      this._selection = value;
    }
    /**
     * Gets the date that is presented. By default it is the current date.
     */
    get viewDate() {
      return this._viewDate;
    }
    /**
     * Sets the date that will be presented in the default view when the component renders.
     */
    set viewDate(value) {
      if (Array.isArray(value)) {
        return;
      }
      if (typeof value === 'string') {
        value = DateTimeUtil.parseIsoDate(value);
      }
      const validDate = this.validateDate(value);
      if (this._viewDate) {
        this.initialSelection = validDate;
      }
      const date = this.getDateOnly(validDate).setDate(1);
      this._viewDate = new Date(date);
    }
    /**
     * Gets the disabled dates descriptors.
     */
    get disabledDates() {
      return this._disabledDates;
    }
    /**
     * Sets the disabled dates' descriptors.
     * ```typescript
     * @ViewChild("MyCalendar")
     * public calendar: IgxCalendarComponent;
     * ngOnInit(){
     *    this.calendar.disabledDates = [
     *     {type: DateRangeType.Between, dateRange: [new Date("2020-1-1"), new Date("2020-1-15")]},
     *     {type: DateRangeType.Weekends}];
     * }
     * ```
     */
    set disabledDates(value) {
      this._disabledDates = value;
    }
    /**
     * Checks whether a date is disabled.
     *
     * @hidden
     */
    isDateDisabled(date) {
      if (!this.disabledDates) {
        return false;
      }
      if (typeof date === 'string') {
        date = DateTimeUtil.parseIsoDate(date);
      }
      return isDateInRanges(date, this.disabledDates);
    }
    /**
     * Gets the special dates descriptors.
     */
    get specialDates() {
      return this._specialDates;
    }
    /**
     * Sets the special dates' descriptors.
     * ```typescript
     * @ViewChild("MyCalendar")
     * public calendar: IgxCalendarComponent;
     * ngOnInit(){
     *    this.calendar.specialDates = [
     *     {type: DateRangeType.Between, dateRange: [new Date("2020-1-1"), new Date("2020-1-15")]},
     *     {type: DateRangeType.Weekends}];
     * }
     * ```
     */
    set specialDates(value) {
      this._specialDates = value;
    }
    /**
     * Gets the selected date(s).
     *
     * When selection is set to `single`, it returns
     * a single `Date` object.
     * Otherwise it is an array of `Date` objects.
     */
    get value() {
      if (this.selection === CalendarSelection.SINGLE) {
        return this.selectedDates?.at(0);
      }
      return this.selectedDates;
    }
    /**
     * Sets the selected date(s).
     *
     * When selection is set to `single`, it accepts
     * a single `Date` object.
     * Otherwise it is an array of `Date` objects.
     */
    set value(value) {
      // Validate the date if it is of type string and it is IsoDate
      if (typeof value === 'string') {
        value = DateTimeUtil.parseIsoDate(value);
      }
      // Check if value is set initially by the user,
      // if it's not set the initial selection to the current date
      if (!value || Array.isArray(value) && value.length === 0) {
        this.initialSelection = new Date();
        return;
      }
      // Value is provided, but there's no initial selection, set the initial selection to the passed value
      if (!this.initialSelection) {
        this.viewDate = Array.isArray(value) ? new Date(Math.min(...value)) : value;
      }
      // we then call selectDate with either a single date or an array of dates
      // we also set the initial selection to the provided value
      this.selectDate(value);
      this.initialSelection = value;
    }
    /**
     * @hidden
     */
    constructor(platform, _localeId, keyboardNavigation, cdr) {
      this.platform = platform;
      this._localeId = _localeId;
      this.keyboardNavigation = keyboardNavigation;
      this.cdr = cdr;
      /**
       * Holds month view index we are operating on.
       */
      this.activeViewIdx = 0;
      /**
       * @hidden
       */
      this._activeView = IgxCalendarView.Month;
      /**
       * @hidden
       */
      this.activeViewSubject = new Subject();
      /**
       * @hidden
       */
      this.activeView$ = this.activeViewSubject.asObservable();
      /**
       * Sets/gets whether the outside dates (dates that are out of the current month) will be hidden.
       * Default value is `false`.
       * ```html
       * <igx-calendar [hideOutsideDays]="true"></igx-calendar>
       * ```
       * ```typescript
       * let hideOutsideDays = this.calendar.hideOutsideDays;
       * ```
       */
      this.hideOutsideDays = false;
      /**
       * Emits an event when a date is selected.
       * Provides reference the `selectedDates` property.
       */
      this.selected = new EventEmitter();
      /**
       * Emits an event when the month in view is changed.
       * ```html
       * <igx-calendar (viewDateChanged)="viewDateChanged($event)"></igx-calendar>
       * ```
       * ```typescript
       * public viewDateChanged(event: IViewDateChangeEventArgs) {
       *  let viewDate = event.currentValue;
       * }
       * ```
       */
      this.viewDateChanged = new EventEmitter();
      /**
       * Emits an event when the active view is changed.
       * ```html
       * <igx-calendar (activeViewChanged)="activeViewChanged($event)"></igx-calendar>
       * ```
       * ```typescript
       * public activeViewChanged(event: CalendarView) {
       *  let activeView = event;
       * }
       * ```
       */
      this.activeViewChanged = new EventEmitter();
      /**
       * @hidden
       */
      this.rangeStarted = false;
      /**
       * @hidden
       */
      this.pageScrollDirection = "none" /* ScrollDirection.NONE */;
      /**
       * @hidden
       */
      this.scrollPage$ = new Subject();
      /**
       * @hidden
       */
      this.stopPageScroll$ = new Subject();
      /**
       * @hidden
       */
      this.startPageScroll$ = new Subject();
      /**
       * @hidden
       */
      this.shiftKey = false;
      /**
       * @hidden
       */
      this._onTouchedCallback = noop;
      /**
       * @hidden
       */
      this._onChangeCallback = noop;
      /**
       * @hidden
       */
      this._disabledDates = [];
      /**
       * @hidden
       */
      this._specialDates = [];
      /**
       * @hidden
       */
      this._selection = CalendarSelection.SINGLE;
      /** @hidden @internal */
      this._resourceStrings = getCurrentResourceStrings(CalendarResourceStringsEN);
      /**
       * @hidden
       */
      this._formatOptions = {
        day: 'numeric',
        month: 'long',
        weekday: 'narrow',
        year: 'numeric'
      };
      /**
       * @hidden
       */
      this._formatViews = {
        day: false,
        month: true,
        year: false
      };
      this.locale = _localeId;
      this.viewDate = this.viewDate ? this.viewDate : new Date();
      this.initFormatters();
    }
    /**
     * Multi/Range selection with shift key
     *
     * @hidden
     * @internal
     */
    onPointerdown(event) {
      this.shiftKey = event.button === 0 && event.shiftKey;
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /**
     * @hidden
     */
    writeValue(value) {
      this.value = value;
    }
    /**
     * Selects date(s) (based on the selection type).
     */
    selectDate(value) {
      if (typeof value === 'string') {
        value = DateTimeUtil.parseIsoDate(value);
      }
      if (value === null || value === undefined || Array.isArray(value) && value.length === 0) {
        return;
      }
      switch (this.selection) {
        case CalendarSelection.SINGLE:
          if (isDate(value) && !this.isDateDisabled(value)) {
            this.selectSingle(value);
          }
          break;
        case CalendarSelection.MULTI:
          this.selectMultiple(value);
          break;
        case CalendarSelection.RANGE:
          this.selectRange(value, true);
          break;
      }
    }
    /**
     * Deselects date(s) (based on the selection type).
     */
    deselectDate(value) {
      if (!this.selectedDates || this.selectedDates.length === 0) {
        return;
      }
      if (typeof value === 'string') {
        value = DateTimeUtil.parseIsoDate(value);
      }
      if (value === null || value === undefined) {
        this.selectedDates = this.selection === CalendarSelection.SINGLE ? null : [];
        this.rangeStarted = false;
        this._onChangeCallback(this.selectedDates);
        return;
      }
      switch (this.selection) {
        case CalendarSelection.SINGLE:
          this.deselectSingle(value);
          break;
        case CalendarSelection.MULTI:
          this.deselectMultiple(value);
          break;
        case CalendarSelection.RANGE:
          this.deselectRange(value);
          break;
      }
    }
    /**
     * Performs a single selection.
     *
     * @hidden
     */
    selectSingle(value) {
      if (!isEqual(this.selectedDates?.at(0), value)) {
        this.selectedDates = [this.getDateOnly(value)];
        this._onChangeCallback(this.selectedDates.at(0));
      }
    }
    /**
     * Performs a single deselection.
     *
     * @hidden
     */
    deselectSingle(value) {
      if (this.selectedDates !== null && this.getDateOnlyInMs(value) === this.getDateOnlyInMs(this.selectedDates.at(0))) {
        this.selectedDates = null;
        this._onChangeCallback(this.selectedDates);
      }
    }
    /**
     * Performs a multiple selection
     *
     * @hidden
     */
    selectMultiple(value) {
      if (Array.isArray(value)) {
        const newDates = value.map(v => this.getDateOnly(v).getTime());
        const selDates = this.selectedDates.map(v => this.getDateOnly(v).getTime());
        if (JSON.stringify(newDates) === JSON.stringify(selDates)) {
          return;
        }
        if (selDates.length === 0 || selDates.length > newDates.length) {
          // deselect the dates that are part of currently selectedDates and not part of updated new values
          this.selectedDates = newDates.map(v => new Date(v));
        } else {
          this.selectedDates = Array.from(new Set([...newDates, ...selDates])).map(v => new Date(v));
        }
      } else {
        let newSelection = [];
        if (this.shiftKey && this.lastSelectedDate) {
          [this._startDate, this._endDate] = this.lastSelectedDate.getTime() < value.getTime() ? [this.lastSelectedDate, value] : [value, this.lastSelectedDate];
          const unselectedDates = [this._startDate, ...this.generateDateRange(this._startDate, this._endDate)].filter(date => !this.isDateDisabled(date) && this.selectedDates.every(d => d.getTime() !== date.getTime()));
          // select all dates from last selected to shift clicked date
          if (this.selectedDates.some(date => date.getTime() === this.lastSelectedDate.getTime()) && unselectedDates.length) {
            newSelection = unselectedDates;
          } else {
            // delesect all dates from last clicked to shift clicked date (excluding)
            this.selectedDates = this.selectedDates.filter(date => date.getTime() < this._startDate.getTime() || date.getTime() > this._endDate.getTime());
            this.selectedDates.push(value);
            this._deselectDate = true;
          }
          this._startDate = this._endDate = undefined;
        } else if (this.selectedDates.every(date => date.getTime() !== value.getTime())) {
          newSelection.push(value);
        } else {
          this.selectedDates = this.selectedDates.filter(date => date.getTime() !== value.getTime());
          this._deselectDate = true;
        }
        if (newSelection.length > 0) {
          this.selectedDates = this.selectedDates.concat(newSelection);
          this._deselectDate = false;
        }
        this.lastSelectedDate = value;
      }
      this.selectedDates = this.selectedDates.filter(d => !this.isDateDisabled(d));
      this.selectedDates.sort((a, b) => a.valueOf() - b.valueOf());
      this._onChangeCallback(this.selectedDates);
    }
    /**
     * Performs a multiple deselection.
     *
     * @hidden
     */
    deselectMultiple(value) {
      value = value.filter(v => v !== null);
      const selectedDatesCount = this.selectedDates.length;
      const datesInMsToDeselect = new Set(value.map(v => this.getDateOnlyInMs(v)));
      for (let i = this.selectedDates.length - 1; i >= 0; i--) {
        if (datesInMsToDeselect.has(this.getDateOnlyInMs(this.selectedDates[i]))) {
          this.selectedDates.splice(i, 1);
        }
      }
      if (this.selectedDates.length !== selectedDatesCount) {
        this._onChangeCallback(this.selectedDates);
      }
    }
    /**
     * @hidden
     */
    selectRange(value, excludeDisabledDates = false) {
      if (Array.isArray(value)) {
        value.sort((a, b) => a.valueOf() - b.valueOf());
        this._startDate = this.getDateOnly(value[0]);
        this._endDate = this.getDateOnly(value[value.length - 1]);
      } else {
        if (this.shiftKey && this.lastSelectedDate) {
          if (this.lastSelectedDate.getTime() === value.getTime()) {
            this.selectedDates = this.selectedDates.length === 1 ? [] : [value];
            this.rangeStarted = !!this.selectedDates.length;
            this._onChangeCallback(this.selectedDates);
            return;
          }
          // shortens the range when selecting a date inside of it
          if (this.selectedDates.some(date => date.getTime() === value.getTime())) {
            this.lastSelectedDate.getTime() < value.getTime() ? this._startDate = value : this._endDate = value;
          } else {
            // extends the range when selecting a date outside of it
            // allows selection from last deselected to current selected date
            if (this.lastSelectedDate.getTime() < value.getTime()) {
              this._startDate = this._startDate ?? this.lastSelectedDate;
              this._endDate = value;
            } else {
              this._startDate = value;
              this._endDate = this._endDate ?? this.lastSelectedDate;
            }
          }
          this.rangeStarted = false;
        } else if (!this.rangeStarted) {
          this.rangeStarted = true;
          this.selectedDates = [value];
          this._startDate = this._endDate = undefined;
        } else {
          this.rangeStarted = false;
          if (this.selectedDates?.at(0)?.getTime() === value.getTime()) {
            this.selectedDates = [];
            this._onChangeCallback(this.selectedDates);
            return;
          }
          [this._startDate, this._endDate] = this.lastSelectedDate.getTime() < value.getTime() ? [this.lastSelectedDate, value] : [value, this.lastSelectedDate];
        }
        this.lastSelectedDate = value;
      }
      if (this._startDate && this._endDate) {
        this.selectedDates = [this._startDate, ...this.generateDateRange(this._startDate, this._endDate)];
      }
      if (excludeDisabledDates) {
        this.selectedDates = this.selectedDates.filter(d => !this.isDateDisabled(d));
      }
      this._onChangeCallback(this.selectedDates);
    }
    /**
     * Performs a range deselection.
     *
     * @hidden
     */
    deselectRange(value) {
      value = value.filter(v => v !== null);
      if (value.length < 1) {
        return;
      }
      value.sort((a, b) => a.valueOf() - b.valueOf());
      const valueStart = this.getDateOnlyInMs(value[0]);
      const valueEnd = this.getDateOnlyInMs(value[value.length - 1]);
      this.selectedDates.sort((a, b) => a.valueOf() - b.valueOf());
      const selectedDatesStart = this.getDateOnlyInMs(this.selectedDates[0]);
      const selectedDatesEnd = this.getDateOnlyInMs(this.selectedDates[this.selectedDates.length - 1]);
      if (!(valueEnd < selectedDatesStart) && !(valueStart > selectedDatesEnd)) {
        this.selectedDates = [];
        this.rangeStarted = false;
        this._onChangeCallback(this.selectedDates);
      }
    }
    /**
     * @hidden
     */
    initFormatters() {
      this.formatterDay = new Intl.DateTimeFormat(this._locale, {
        day: this._formatOptions.day
      });
      this.formatterWeekday = new Intl.DateTimeFormat(this._locale, {
        weekday: this._formatOptions.weekday
      });
      this.formatterMonth = new Intl.DateTimeFormat(this._locale, {
        month: this._formatOptions.month
      });
      this.formatterYear = new Intl.DateTimeFormat(this._locale, {
        year: this._formatOptions.year
      });
      this.formatterMonthday = new Intl.DateTimeFormat(this._locale, {
        month: this._formatOptions.month,
        day: this._formatOptions.day
      });
      this.formatterRangeday = new Intl.DateTimeFormat(this._locale, {
        day: this._formatOptions.day,
        month: 'short'
      });
    }
    /**
     * @hidden
     */
    getDateOnly(date) {
      const validDate = this.validateDate(date);
      return new Date(validDate.getFullYear(), validDate.getMonth(), validDate.getDate());
    }
    /**
     * @hidden
     */
    getDateOnlyInMs(date) {
      return this.getDateOnly(date).getTime();
    }
    /**
     * @hidden
     */
    generateDateRange(start, end) {
      const result = [];
      start = this.getDateOnly(start);
      end = this.getDateOnly(end);
      while (start.getTime() < end.getTime()) {
        start = CalendarDay.from(start).add('day', 1).native;
        result.push(start);
      }
      return result;
    }
    validateDate(value) {
      return DateTimeUtil.isValidDate(value) ? value : new Date();
    }
    static {
      this.ɵfac = function IgxCalendarBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarBaseDirective)(i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(KeyboardNavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCalendarBaseDirective,
        selectors: [["", "igxCalendarBase", ""]],
        viewQuery: function IgxCalendarBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c33, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.yearsBtns = _t);
          }
        },
        hostBindings: function IgxCalendarBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerdown", function IgxCalendarBaseDirective_pointerdown_HostBindingHandler($event) {
              return ctx.onPointerdown($event);
            });
          }
        },
        inputs: {
          hideOutsideDays: [2, "hideOutsideDays", "hideOutsideDays", booleanAttribute],
          resourceStrings: "resourceStrings",
          weekStart: "weekStart",
          locale: "locale",
          formatOptions: "formatOptions",
          formatViews: "formatViews",
          activeView: "activeView",
          selection: "selection",
          viewDate: "viewDate",
          disabledDates: "disabledDates",
          specialDates: "specialDates",
          value: "value"
        },
        outputs: {
          selected: "selected",
          viewDateChanged: "viewDateChanged",
          activeViewChanged: "activeViewChanged"
        },
        features: [i0.ɵɵProvidersFeature([KeyboardNavigationService])]
      });
    }
  }
  return IgxCalendarBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$k = 0;
let IgxDaysViewComponent = /*#__PURE__*/(() => {
  class IgxDaysViewComponent extends IgxCalendarBaseDirective {
    #standalone;
    get standalone() {
      return this.#standalone;
    }
    set standalone(value) {
      this.#standalone = value;
    }
    get activeDescendant() {
      if (this.tabIndex === -1) return;
      return this.activeDate.getTime();
    }
    /**
     * @hidden
     * @internal
     */
    set activeDate(value) {
      this._activeDate = value;
      this.changePreviewRange(value);
      this.activeDateChange.emit(this._activeDate);
    }
    get activeDate() {
      return this._activeDate ?? this.viewDate;
    }
    /**
     * @hidden
     * @internal
     */
    set previewRangeDate(value) {
      this._previewRangeDate = value;
      this.previewRangeDateChange.emit(value);
    }
    get previewRangeDate() {
      return this._previewRangeDate;
    }
    set hideLeadingDays(value) {
      this._hideLeadingDays = value;
      this.cdr.detectChanges();
    }
    get hideLeadingDays() {
      return this._hideLeadingDays ?? this.hideOutsideDays;
    }
    set hideTrailingDays(value) {
      this._hideTrailingDays = value;
      this.cdr.detectChanges();
    }
    get hideTrailingDays() {
      return this._hideTrailingDays ?? this.hideOutsideDays;
    }
    set showActiveDay(value) {
      this._showActiveDay = value;
    }
    get showActiveDay() {
      return this._showActiveDay;
    }
    /**
     * @hidden
     */
    constructor(platform, _localeId, el, cdr) {
      super(platform, _localeId, null, cdr);
      this.el = el;
      this.cdr = cdr;
      this.#standalone = true;
      /**
       * Sets/gets the `id` of the days view.
       * If not set, the `id` will have value `"igx-days-view-0"`.
       * ```html
       * <igx-days-view id="my-days-view"></igx-days-view>
       * ```
       * ```typescript
       * let daysViewId = this.daysView.id;
       * ```
       */
      this.id = `igx-days-view-${NEXT_ID$k++}`;
      this.tabIndex = 0;
      this.role = 'grid';
      this.viewClass = true;
      /**
       * @hidden
       */
      this.dateSelected = new EventEmitter();
      /**
       * @hidden
       */
      this.pageChanged = new EventEmitter();
      /**
       * @hidden
       */
      this.activeDateChange = new EventEmitter();
      /**
       * @hidden
       */
      this.previewRangeDateChange = new EventEmitter();
    }
    /**
     * @hidden
     */
    handleArrowKeydown(event, delta) {
      event.preventDefault();
      event.stopPropagation();
      const date = getClosestActiveDate(CalendarDay.from(this.activeDate), delta, this.disabledDates);
      if (!areSameMonth(this.activeDate, date.native)) {
        this.pageChanged.emit({
          monthAction: delta > 0 ? "next" /* ScrollDirection.NEXT */ : "prev" /* ScrollDirection.PREV */,
          key: event.key,
          nextDate: date.native
        });
      }
      this.activeDate = date.native;
      this.viewDate = date.native;
      this.clearPreviewRange();
      this.changePreviewRange(date.native);
      this.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    onArrowRight(event) {
      this.handleArrowKeydown(event, 1);
    }
    /**
     * @hidden
     */
    onArrowLeft(event) {
      this.handleArrowKeydown(event, -1);
    }
    /**
     * @hidden
     */
    onArrowUp(event) {
      this.handleArrowKeydown(event, -7);
    }
    /**
     * @hidden
     */
    onArrowDown(event) {
      this.handleArrowKeydown(event, 7);
    }
    /**
     * @hidden
     */
    onKeydownEnter(event) {
      event.stopPropagation();
      this.selectActiveDate();
    }
    /**
     * @hidden
     */
    onKeydownHome(event) {
      event.preventDefault();
      event.stopPropagation();
      const first = CalendarDay.from(this.activeDate);
      this.activeDate = getNextActiveDate(first.set({
        date: 1
      }), this.disabledDates).native;
    }
    /**
     * @hidden
     */
    onKeydownEnd(event) {
      event.preventDefault();
      event.stopPropagation();
      const last = CalendarDay.from(this.activeDate);
      this.activeDate = getPreviousActiveDate(last.set({
        month: last.month + 1,
        date: 0
      }), this.disabledDates).native;
    }
    /**
     * @hidden
     */
    handleFocus() {
      this._showActiveDay = true;
      this.changePreviewRange(this.activeDate);
    }
    /**
     * @hidden
     */
    handleBlur() {
      this._showActiveDay = false;
      this.clearPreviewRange();
    }
    /**
     * @hidden
     */
    handleDateClick(item) {
      const date = item.date.native;
      if (item.isPreviousMonth) {
        this.pageChanged.emit({
          monthAction: "prev" /* ScrollDirection.PREV */,
          key: '',
          nextDate: date
        });
      }
      if (item.isNextMonth) {
        this.pageChanged.emit({
          monthAction: "next" /* ScrollDirection.NEXT */,
          key: '',
          nextDate: date
        });
      }
      if (this.tabIndex !== -1) {
        this.el.nativeElement.focus();
      }
      this.activeDate = item.date.native;
      this.selectActiveDate();
    }
    selectActiveDate() {
      this.selectDate(this.activeDate);
      this.dateSelected.emit(this.activeDate);
      this.selected.emit(this.selectedDates);
      this.clearPreviewRange();
    }
    get calendarMonth() {
      return Array.from(generateMonth(this.viewDate, this.weekStart));
    }
    get monthWeeks() {
      return Array.from(intoChunks(this.calendarMonth, 7));
    }
    /**
     * Returns the week number by date
     *
     * @hidden
     */
    getWeekNumber(date) {
      return date.week;
    }
    /**
     * Returns the locale representation of the date in the days view.
     *
     * @hidden
     */
    formattedDate(value) {
      if (this.formatViews.day) {
        return this.formatterDay.format(value);
      }
      return `${value.getDate()}`;
    }
    /**
     * @hidden
     */
    get weekHeaderLabels() {
      const weekdays = [];
      const rawFormatter = new Intl.DateTimeFormat(this.locale, {
        weekday: 'long'
      });
      for (const day of this.monthWeeks.at(0)) {
        weekdays.push({
          long: rawFormatter.format(day.native),
          formatted: this.formatterWeekday.format(day.native)
        });
      }
      return weekdays;
    }
    get weekNumberHeader() {
      const weekOfYear = style => {
        const dn = new Intl.DisplayNames(this.locale, {
          type: 'dateTimeField',
          style
        });
        return dn.of('weekOfYear');
      };
      return {
        short: weekOfYear('narrow').substring(0, 1),
        long: weekOfYear('long')
      };
    }
    /**
     * @hidden
     */
    rowTracker(_, item) {
      return `${item[0].month}${item[0].date}`;
    }
    /**
     * @hidden
     */
    dateTracker(_, item) {
      return `${item.month}--${item.date}`;
    }
    /**
     * @hidden
     */
    isSelected(date) {
      const dates = this.value;
      const hasValue = this.value || Array.isArray(this.value) && this.value.length === 1;
      if (isDateInRanges(date, this.disabledDates)) {
        return false;
      }
      if (this.selection === CalendarSelection.SINGLE) {
        return !!this.value && date.equalTo(this.value);
      }
      if (!hasValue) {
        return false;
      }
      if (this.selection === CalendarSelection.MULTI && dates.length > 0) {
        return isDateInRanges(date, [{
          type: DateRangeType.Specific,
          dateRange: dates
        }]);
      }
      if (this.selection === CalendarSelection.RANGE && dates.length > 0) {
        return isDateInRanges(date, [{
          type: DateRangeType.Between,
          dateRange: [dates.at(0), dates.at(-1)]
        }]);
      }
    }
    /**
     * @hidden
     */
    isFirstInRange(date) {
      const dates = this.selectedDates;
      if (this.isSingleSelection || dates.length === 0) {
        return false;
      }
      let target = dates.at(0);
      if (this.previewRangeDate && this.previewRangeDate < target) {
        target = this.previewRangeDate;
      }
      return date.equalTo(target);
    }
    /**
     * @hidden
     */
    isLastInRange(date) {
      const dates = this.selectedDates;
      if (this.isSingleSelection || dates.length === 0) {
        return false;
      }
      let target = dates.at(-1);
      if (this.previewRangeDate && this.previewRangeDate > target) {
        target = this.previewRangeDate;
      }
      return date.equalTo(target);
    }
    /**
     * @hidden
     */
    isActiveDate(day) {
      return this._showActiveDay && day.equalTo(this.activeDate);
    }
    /**
     * @hidden
     */
    isWithinRange(date, checkForRange, min, max) {
      const dates = this.selectedDates;
      if (checkForRange && !(Array.isArray(dates) && dates.length > 1)) {
        return false;
      }
      min = min ? min : dates.at(0);
      max = max ? max : dates.at(-1);
      return isDateInRanges(date, [{
        type: DateRangeType.Between,
        dateRange: [min, max]
      }]);
    }
    isWithinPreviewRange(date) {
      if (this.selection !== 'range') return false;
      const dates = this.selectedDates;
      if (!(dates.length > 0 && this.previewRangeDate)) {
        return false;
      }
      return isDateInRanges(date, [{
        type: DateRangeType.Between,
        dateRange: [dates.at(0), this.previewRangeDate]
      }]);
    }
    /**
     * @hidden
     */
    get isSingleSelection() {
      return this.selection !== CalendarSelection.RANGE;
    }
    /**
     * @hidden @internal
     */
    changePreviewRange(date) {
      const dates = this.value;
      if (this.selection === 'range' && dates.length === 1) {
        const first = CalendarDay.from(dates.at(0));
        if (!first.equalTo(date)) {
          this.setPreviewRangeDate(date);
        }
      }
    }
    /**
     * @hidden @internal
     */
    clearPreviewRange() {
      if (this.previewRangeDate) {
        this.setPreviewRangeDate(undefined);
      }
    }
    setPreviewRangeDate(value) {
      this.previewRangeDate = value;
    }
    static {
      this.ɵfac = function IgxDaysViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDaysViewComponent)(i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDaysViewComponent,
        selectors: [["igx-days-view"]],
        viewQuery: function IgxDaysViewComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxDayItemComponent, 5, IgxDayItemComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dates = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxDaysViewComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.arrowright", function IgxDaysViewComponent_keydown_arrowright_HostBindingHandler($event) {
              return ctx.onArrowRight($event);
            })("keydown.arrowleft", function IgxDaysViewComponent_keydown_arrowleft_HostBindingHandler($event) {
              return ctx.onArrowLeft($event);
            })("keydown.arrowup", function IgxDaysViewComponent_keydown_arrowup_HostBindingHandler($event) {
              return ctx.onArrowUp($event);
            })("keydown.arrowdown", function IgxDaysViewComponent_keydown_arrowdown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Space", function IgxDaysViewComponent_keydown_Space_HostBindingHandler($event) {
              return ctx.onKeydownEnter($event);
            })("keydown.enter", function IgxDaysViewComponent_keydown_enter_HostBindingHandler($event) {
              return ctx.onKeydownEnter($event);
            })("keydown.home", function IgxDaysViewComponent_keydown_home_HostBindingHandler($event) {
              return ctx.onKeydownHome($event);
            })("keydown.end", function IgxDaysViewComponent_keydown_end_HostBindingHandler($event) {
              return ctx.onKeydownEnd($event);
            })("focus", function IgxDaysViewComponent_focus_HostBindingHandler() {
              return ctx.handleFocus();
            })("blur", function IgxDaysViewComponent_blur_HostBindingHandler() {
              return ctx.handleBlur();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("tabIndex", ctx.tabIndex)("role", ctx.role)("aria-activeDescendant", ctx.activeDescendant);
            i0.ɵɵclassProp("igx-days-view", ctx.viewClass)("igx-days-view--standalone", ctx.standalone);
          }
        },
        inputs: {
          id: "id",
          tabIndex: "tabIndex",
          role: "role",
          standalone: "standalone",
          showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute],
          activeDate: "activeDate",
          previewRangeDate: "previewRangeDate",
          hideLeadingDays: [2, "hideLeadingDays", "hideLeadingDays", booleanAttribute],
          hideTrailingDays: [2, "hideTrailingDays", "hideTrailingDays", booleanAttribute],
          showActiveDay: [2, "showActiveDay", "showActiveDay", booleanAttribute]
        },
        outputs: {
          dateSelected: "dateSelected",
          pageChanged: "pageChanged",
          activeDateChange: "activeDateChange",
          previewRangeDateChange: "previewRangeDateChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxDaysViewComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 4,
        consts: [["item", ""], ["role", "row", 1, "igx-days-view__row", 3, "title"], ["role", "columnheader", 1, "igx-days-view__label", "igx-days-view__label--week-number"], ["role", "columnheader", 1, "igx-days-view__label"], ["role", "row", 1, "igx-days-view__row"], [1, "igx-days-view__label-inner"], [1, "igx-days-view__date", "igx-days-view__date--week-number"], ["role", "gridcell", 1, "igx-days-view__date", 3, "date", "viewDate", "selection", "selected", "isActive", "isLastInRange", "isFirstInRange", "isWithinRange", "isWithinPreviewRange", "disabledDates", "specialDates", "hideLeadingDays", "hideTrailingDays"], ["role", "rowheader", 1, "igx-days-view__date-inner", "igx-days-view__date-inner--week-number"], ["role", "gridcell", 1, "igx-days-view__date", 3, "click", "mouseEnter", "mouseLeave", "date", "viewDate", "selection", "selected", "isActive", "isLastInRange", "isFirstInRange", "isWithinRange", "isWithinPreviewRange", "disabledDates", "specialDates", "hideLeadingDays", "hideTrailingDays"]],
        template: function IgxDaysViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵpipe(1, "titlecase");
            i0.ɵɵtemplate(2, IgxDaysViewComponent_Conditional_2_Template, 5, 3, "div", 2);
            i0.ɵɵrepeaterCreate(3, IgxDaysViewComponent_For_4_Template, 4, 4, "span", 3, _forTrack1);
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(5, IgxDaysViewComponent_For_6_Template, 4, 1, "div", 4, ctx.rowTracker, true);
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, ctx.weekNumberHeader.long));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showWeekNumbers ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.weekHeaderLabels);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.monthWeeks);
          }
        },
        dependencies: [IgxDayItemComponent, TitleCasePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxDaysViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxMonthViewSlotsCalendar = /*#__PURE__*/(() => {
  class IgxMonthViewSlotsCalendar {
    transform(monthViews) {
      return new Array(monthViews);
    }
    static {
      this.ɵfac = function IgxMonthViewSlotsCalendar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxMonthViewSlotsCalendar)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "IgxMonthViewSlots",
        type: IgxMonthViewSlotsCalendar,
        pure: true
      });
    }
  }
  return IgxMonthViewSlotsCalendar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGetViewDateCalendar = /*#__PURE__*/(() => {
  class IgxGetViewDateCalendar {
    constructor() {
      this.calendar = new Calendar();
    }
    transform(index, viewDate, wholeDate = true) {
      const date = this.calendar.timedelta(viewDate, 'month', index);
      return wholeDate ? date : date.getMonth();
    }
    static {
      this.ɵfac = function IgxGetViewDateCalendar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGetViewDateCalendar)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "IgxGetViewDate",
        type: IgxGetViewDateCalendar,
        pure: true
      });
    }
  }
  return IgxGetViewDateCalendar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$j = 0;
/**
 * Calendar provides a way to display date information.
 *
 * @igxModule IgxCalendarModule
 *
 * @igxTheme igx-calendar-theme, igx-icon-theme
 *
 * @igxKeywords calendar, datepicker, schedule, date
 *
 * @igxGroup Scheduling
 *
 * @remarks
 * The Ignite UI Calendar provides an easy way to display a calendar and allow users to select dates using single, multiple
 * or range selection.
 *
 * @example:
 * ```html
 * <igx-calendar selection="range"></igx-calendar>
 * ```
 */
let IgxCalendarComponent = /*#__PURE__*/(() => {
  class IgxCalendarComponent extends IgxCalendarBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Sets/gets the `id` of the calendar.
       *
       * @remarks
       * If not set, the `id` will have value `"igx-calendar-0"`.
       *
       * @example
       * ```html
       * <igx-calendar id="my-first-calendar"></igx-calendar>
       * ```
       * @memberof IgxCalendarComponent
       */
      this.id = `igx-calendar-${NEXT_ID$j++}`;
      /**
       * Sets/gets whether the calendar has header.
       * Default value is `true`.
       *
       * @example
       * ```html
       * <igx-calendar [hasHeader]="false"></igx-calendar>
       * ```
       */
      this.hasHeader = true;
      /**
       * Sets/gets whether the calendar header will be in vertical position.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-calendar [vertical]="true"></igx-calendar>
       * ```
       */
      this.vertical = false;
      this.orientation = 'horizontal';
      this.headerOrientation = 'horizontal';
      /**
       * Show/hide week numbers
       *
       * @example
       * ```html
       * <igx-calendar [showWeekNumbers]="true"></igx-calendar>
       * ``
       */
      this.showWeekNumbers = false;
      /**
       * The default css class applied to the component.
       *
       * @hidden
       * @internal
       */
      this.styleClass = true;
      /**
       * @hidden
       * @internal
       */
      this.activeDate = CalendarDay.today.native;
      /**
       * Denote if the calendar view was changed with the keyboard
       *
       * @hidden
       * @internal
       */
      this.isKeydownTrigger = false;
      /**
       * @hidden
       * @internal
       */
      this._monthsViewNumber = 1;
      /**
       * Continious navigation through the previous pages
       *
       * @hidden
       * @internal
       */
      this.startPrevPageScroll = (isKeydownTrigger = false) => {
        this.startPageScroll$.next();
        this.pageScrollDirection = "prev" /* ScrollDirection.PREV */;
        this.previousPage(isKeydownTrigger);
      };
      /**
       * Continious navigation through the next pages
       *
       * @hidden
       * @internal
       */
      this.startNextPageScroll = (isKeydownTrigger = false) => {
        this.startPageScroll$.next();
        this.pageScrollDirection = "next" /* ScrollDirection.NEXT */;
        this.nextPage(isKeydownTrigger);
      };
      /**
       * Stop continuous navigation
       *
       * @hidden
       * @internal
       */
      this.stopPageScroll = event => {
        event.stopPropagation();
        this.stopPageScroll$.next(true);
        this.stopPageScroll$.complete();
        if (this.platform.isActivationKey(event)) {
          this.resetActiveDate(this.viewDate);
        }
        this.pageScrollDirection = "none" /* ScrollDirection.NONE */;
      };
    }
    /**
     * Sets/gets the number of month views displayed.
     * Default value is `1`.
     *
     * @example
     * ```html
     * <igx-calendar [monthsViewNumber]="2"></igx-calendar>
     * ```
     */
    get monthsViewNumber() {
      return this._monthsViewNumber;
    }
    set monthsViewNumber(val) {
      if (val < 1) {
        return;
      }
      this._monthsViewNumber = val;
    }
    /**
     * The default css class applied to the component.
     *
     * @hidden
     * @internal
     */
    get styleVerticalClass() {
      return this.headerOrientation === 'vertical';
    }
    /**
     * Denote if the year view is active.
     *
     * @hidden
     * @internal
     */
    get isYearView() {
      return this.activeView === IgxCalendarView.Year;
    }
    /**
     * Gets the header template.
     *
     * @example
     * ```typescript
     * let headerTitleTemplate = this.calendar.headerTitleTeamplate;
     * ```
     * @memberof IgxCalendarComponent
     */
    get headerTitleTemplate() {
      if (this.headerTitleTemplateDirective) {
        return this.headerTitleTemplateDirective.template;
      }
      return null;
    }
    /**
     * Sets the header template.
     *
     * @example
     * ```html
     * <igx-calendar headerTitleTemplateDirective="igxCalendarHeaderTitle"></igx-calendar>
     * ```
     * @memberof IgxCalendarComponent
     */
    set headerTitleTemplate(directive) {
      this.headerTitleTemplateDirective = directive;
    }
    /**
     * Gets the header template.
     *
     * @example
     * ```typescript
     * let headerTemplate =  this.calendar.headerTeamplate;
     * ```
     * @memberof IgxCalendarComponent
     */
    get headerTemplate() {
      if (this.headerTemplateDirective) {
        return this.headerTemplateDirective.template;
      }
      return null;
    }
    /**
     * Sets the header template.
     *
     * @example
     * ```html
     * <igx-calendar headerTemplateDirective="igxCalendarHeader"></igx-calendar>
     * ```
     * @memberof IgxCalendarComponent
     */
    set headerTemplate(directive) {
      this.headerTemplateDirective = directive;
    }
    /**
     * Gets the subheader template.
     *
     * @example
     * ```typescript
     * let subheaderTemplate = this.calendar.subheaderTemplate;
     * ```
     */
    get subheaderTemplate() {
      if (this.subheaderTemplateDirective) {
        return this.subheaderTemplateDirective.template;
      }
      return null;
    }
    /**
     * Sets the subheader template.
     *
     * @example
     * ```html
     * <igx-calendar subheaderTemplate="igxCalendarSubheader"></igx-calendar>
     * ```
     * @memberof IgxCalendarComponent
     */
    set subheaderTemplate(directive) {
      this.subheaderTemplateDirective = directive;
    }
    /**
     * Gets the context for the template marked with the `igxCalendarHeader` directive.
     *
     * @example
     * ```typescript
     * let headerContext =  this.calendar.headerContext;
     * ```
     */
    get headerContext() {
      return this.generateContext(this.headerDate);
    }
    /**
     * Gets the context for the template marked with either `igxCalendarSubHeaderMonth`
     * or `igxCalendarSubHeaderYear` directive.
     *
     * @example
     * ```typescript
     * let context =  this.calendar.context;
     * ```
     */
    get context() {
      const date = this.viewDate;
      return this.generateContext(date);
    }
    /**
     * Date displayed in header
     *
     * @hidden
     * @internal
     */
    get headerDate() {
      return this.selectedDates?.at(0) ?? new Date();
    }
    onMouseDown(event) {
      event.stopPropagation();
      this.wrapper.nativeElement.focus();
    }
    /**
     * @hidden
     * @internal
     */
    set showActiveDay(value) {
      this._showActiveDay = value;
      this.cdr.detectChanges();
    }
    get showActiveDay() {
      return this._showActiveDay;
    }
    get activeDescendant() {
      if (this.activeView === 'month') {
        return this.activeDate.getTime();
      }
      return this._activeDescendant ?? this.viewDate.getTime();
    }
    set activeDescendant(date) {
      this._activeDescendant = date.getTime();
    }
    ngAfterViewInit() {
      this.keyboardNavigation.attachKeyboardHandlers(this.wrapper, this).set("ArrowUp", this.onArrowUp).set("ArrowDown", this.onArrowDown).set("ArrowLeft", this.onArrowLeft).set("ArrowRight", this.onArrowRight).set("Enter", this.onEnter).set(" ", this.onEnter).set("Home", this.onHome).set("End", this.onEnd).set("PageUp", this.handlePageUp).set("PageDown", this.handlePageDown);
      this.wrapper.nativeElement.addEventListener('focus', event => this.onWrapperFocus(event));
      this.wrapper.nativeElement.addEventListener('blur', event => this.onWrapperBlur(event));
      this.startPageScroll$.pipe(takeUntil(this.stopPageScroll$), switchMap(() => this.scrollPage$.pipe(skipLast(1), debounce(() => interval(300)), takeUntil(this.stopPageScroll$)))).subscribe(() => {
        switch (this.pageScrollDirection) {
          case "prev" /* ScrollDirection.PREV */:
            this.previousPage();
            break;
          case "next" /* ScrollDirection.NEXT */:
            this.nextPage();
            break;
          case "none" /* ScrollDirection.NONE */:
          default:
            break;
        }
      });
      this.activeView$.subscribe(view => {
        this.activeViewChanged.emit(view);
        this.viewDateChanged.emit({
          previousValue: this.previousViewDate,
          currentValue: this.viewDate
        });
      });
    }
    onWrapperFocus(_event) {
      this.showActiveDay = true;
      this.monthViews.forEach(view => view.changePreviewRange(this.activeDate));
    }
    onWrapperBlur(_event) {
      this.showActiveDay = false;
      this.monthViews.forEach(view => view.clearPreviewRange());
      this._onTouchedCallback();
    }
    handleArrowKeydown(event, delta) {
      event.preventDefault();
      const date = getClosestActiveDate(CalendarDay.from(this.activeDate), delta, this.disabledDates);
      this.activeDate = date.native;
      const dates = this.viewDates;
      const isDateInView = dates.some(d => d.date.equalTo(this.activeDate));
      this.monthViews.forEach(view => view.clearPreviewRange());
      if (!isDateInView) {
        delta > 0 ? this.nextPage(true) : this.previousPage(true);
      }
    }
    handlePageUpDown(event, delta) {
      event.preventDefault();
      const dir = delta > 0 ? "next" /* ScrollDirection.NEXT */ : "prev" /* ScrollDirection.PREV */;
      if (this.activeView === IgxCalendarView.Month && event.shiftKey) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', delta).native;
        this.resetActiveDate(this.viewDate);
        this.cdr.detectChanges();
      } else {
        this.changePage(false, dir);
      }
    }
    handlePageUp(event) {
      this.handlePageUpDown(event, -1);
    }
    handlePageDown(event) {
      this.handlePageUpDown(event, 1);
    }
    onArrowUp(event) {
      if (this.activeView === IgxCalendarView.Month) {
        this.handleArrowKeydown(event, -7);
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownArrowUp(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownArrowUp(event);
      }
    }
    onArrowDown(event) {
      if (this.activeView === IgxCalendarView.Month) {
        this.handleArrowKeydown(event, 7);
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownArrowDown(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownArrowDown(event);
      }
    }
    onArrowLeft(event) {
      if (this.activeView === IgxCalendarView.Month) {
        this.handleArrowKeydown(event, -1);
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownArrowLeft(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownArrowLeft(event);
      }
    }
    onArrowRight(event) {
      if (this.activeView === IgxCalendarView.Month) {
        this.handleArrowKeydown(event, 1);
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownArrowRight(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownArrowRight(event);
      }
    }
    onEnter(event) {
      if (this.activeView === IgxCalendarView.Month) {
        this.handleDateSelection(this.activeDate);
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownEnter(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownEnter(event);
      }
      this.monthViews.forEach(view => view.clearPreviewRange());
    }
    onHome(event) {
      if (this.activeView === IgxCalendarView.Month) {
        const dates = this.monthViews.toArray().flatMap(view => view.dates.toArray()).filter(d => d.isCurrentMonth && d.isFocusable);
        this.activeDate = dates.at(0).date.native;
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownHome(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownHome(event);
      }
    }
    onEnd(event) {
      if (this.activeView === IgxCalendarView.Month) {
        const dates = this.monthViews.toArray().flatMap(view => view.dates.toArray()).filter(d => d.isCurrentMonth && d.isFocusable);
        this.activeDate = dates.at(-1).date.native;
        this.cdr.detectChanges();
      }
      if (this.activeView === IgxCalendarView.Year) {
        this.monthsView.onKeydownEnd(event);
      }
      if (this.activeView === IgxCalendarView.Decade) {
        this.dacadeView.onKeydownEnd(event);
      }
    }
    /**
     * Returns the locale representation of the month in the month view if enabled,
     * otherwise returns the default `Date.getMonth()` value.
     *
     * @hidden
     * @internal
     */
    formattedMonth(value) {
      if (this.formatViews.month) {
        return this.formatterMonth.format(value);
      }
      return `${value.getMonth()}`;
    }
    /**
     * Change to previous page
     *
     * @hidden
     * @internal
     */
    previousPage(isKeydownTrigger = false) {
      if (isKeydownTrigger && this.pageScrollDirection === "next" /* ScrollDirection.NEXT */) {
        return;
      }
      this.changePage(isKeydownTrigger, "prev" /* ScrollDirection.PREV */);
    }
    /**
     * Change to next page
     *
     * @hidden
     * @internal
     */
    nextPage(isKeydownTrigger = false) {
      if (isKeydownTrigger && this.pageScrollDirection === "prev" /* ScrollDirection.PREV */) {
        return;
      }
      this.changePage(isKeydownTrigger, "next" /* ScrollDirection.NEXT */);
    }
    /**
     * Changes the current page
     *
     * @hidden
     * @internal
     */
    changePage(isKeydownTrigger = false, direction) {
      this.previousViewDate = this.viewDate;
      this.isKeydownTrigger = isKeydownTrigger;
      switch (this.activeView) {
        case "month":
          if (direction === "prev" /* ScrollDirection.PREV */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('month', -1).native;
          }
          if (direction === "next" /* ScrollDirection.NEXT */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('month', 1).native;
          }
          this.viewDateChanged.emit({
            previousValue: this.previousViewDate,
            currentValue: this.viewDate
          });
          break;
        case "year":
          if (direction === "prev" /* ScrollDirection.PREV */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('year', -1).native;
          }
          if (direction === "next" /* ScrollDirection.NEXT */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('year', 1).native;
          }
          break;
        case "decade":
          if (direction === "prev" /* ScrollDirection.PREV */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('year', -15).native;
          }
          if (direction === "next" /* ScrollDirection.NEXT */) {
            this.viewDate = CalendarDay.from(this.viewDate).add('year', 15).native;
          }
          break;
      }
      // XXX: Why only when it's not triggered by keyboard?
      if (!this.isKeydownTrigger) this.resetActiveDate(this.viewDate);
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewDecade(event, date, activeViewIdx) {
      event.preventDefault();
      super.activeViewDecade(activeViewIdx);
      this.viewDate = date;
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewDecadeKB(date, event, activeViewIdx) {
      super.activeViewDecadeKB(event, activeViewIdx);
      if (this.platform.isActivationKey(event)) {
        this.viewDate = date;
        this.wrapper.nativeElement.focus();
      }
    }
    /**
     * @hidden
     * @internal
     */
    onYearsViewClick(event) {
      const path = event.composed ? event.composedPath() : [event.target];
      const years = this.dacadeView.viewItems.toArray();
      const validTarget = years.some(year => path.includes(year.nativeElement));
      if (validTarget) {
        this.activeView = IgxCalendarView.Year;
      }
    }
    /**
     * @hidden
     * @internal
     */
    onYearsViewKeydown(event) {
      if (this.platform.isActivationKey(event)) {
        this.activeView = IgxCalendarView.Year;
      }
    }
    /**
     * @hidden
     * @internal
     */
    getFormattedDate() {
      const date = this.headerDate;
      const monthFormatter = new Intl.DateTimeFormat(this.locale, {
        month: 'short',
        day: 'numeric'
      });
      const dayFormatter = new Intl.DateTimeFormat(this.locale, {
        weekday: 'short'
      });
      return {
        monthday: monthFormatter.format(date),
        weekday: dayFormatter.format(date)
      };
    }
    /**
     * @hidden
     * @internal
     */
    getFormattedRange() {
      const dates = this.selectedDates;
      return {
        start: this.formatterRangeday.format(dates.at(0)),
        end: this.formatterRangeday.format(dates.at(-1))
      };
    }
    /**
     * @hidden
     * @internal
     */
    get viewDates() {
      return this.monthViews.toArray().flatMap(view => view.dates.toArray()).filter(d => d.isCurrentMonth);
    }
    /**
     * Handles invoked on date selection
     *
     * @hidden
     * @internal
     */
    handleDateSelection(date) {
      const outOfRange = !this.viewDates.some(d => {
        return d.date.equalTo(date);
      });
      if (outOfRange) {
        this.viewDate = date;
      }
      this.selectDate(date);
      // keep views in sync
      this.monthViews.forEach(m => {
        m.shiftKey = this.shiftKey;
        m.selectedDates = this.selectedDates;
        m.cdr.markForCheck();
      });
      if (this.selection !== 'single') {
        this.selected.emit(this.selectedDates);
      } else {
        this.selected.emit(this.selectedDates.at(0));
      }
    }
    /**
     * @hidden
     * @intenal
     */
    changeMonth(date) {
      this.previousViewDate = this.viewDate;
      this.viewDate = CalendarDay.from(date).add('month', -this.activeViewIdx).native;
      this.activeView = IgxCalendarView.Month;
      this.resetActiveDate(date);
    }
    /**
     * @hidden
     * @intenal
     */
    changeYear(date) {
      this.previousViewDate = this.viewDate;
      this.viewDate = CalendarDay.from(date).add('month', -this.activeViewIdx).native;
      this.activeView = IgxCalendarView.Year;
    }
    /**
     * @hidden
     * @intenal
     */
    updateYear(date) {
      this.previousViewDate = this.viewDate;
      this.viewDate = CalendarDay.from(date).add('year', -this.activeViewIdx).native;
    }
    updateActiveDescendant(date) {
      this.activeDescendant = date;
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewYear(event, date, activeViewIdx) {
      event.preventDefault();
      this.activeView = IgxCalendarView.Year;
      this.activeViewIdx = activeViewIdx;
      this.viewDate = date;
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewYearKB(date, event, activeViewIdx) {
      event.stopPropagation();
      if (this.platform.isActivationKey(event)) {
        event.preventDefault();
        this.activeView = IgxCalendarView.Year;
        this.activeViewIdx = activeViewIdx;
        this.viewDate = date;
        this.wrapper.nativeElement.focus();
      }
    }
    /**
     * Deselects date(s) (based on the selection type).
     *
     * @example
     * ```typescript
     *  this.calendar.deselectDate(new Date(`2018-06-12`));
     * ````
     */
    deselectDate(value) {
      super.deselectDate(value);
      this.monthViews.forEach(m => {
        m.selectedDates = this.selectedDates;
        m.rangeStarted = false;
        m.cdr.markForCheck();
      });
      this._onChangeCallback(this.selectedDates);
    }
    /**
     * Getter for the context object inside the calendar templates.
     *
     * @hidden
     * @internal
     */
    getContext(i) {
      const date = CalendarDay.from(this.viewDate).add('month', i).native;
      return this.generateContext(date, i);
    }
    /**
     * @hidden
     * @internal
     */
    // TODO: See if this can be incorporated in the DaysView directly
    resetActiveDate(date) {
      const target = CalendarDay.from(this.activeDate).set({
        month: date.getMonth(),
        year: date.getFullYear()
      });
      const outOfRange = !areSameMonth(date, target) || isDateInRanges(target, this.disabledDates);
      this.activeDate = outOfRange ? date : target.native;
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.keyboardNavigation.detachKeyboardHandlers();
      this.wrapper?.nativeElement.removeEventListener('focus', this.onWrapperFocus);
      this.wrapper?.nativeElement.removeEventListener('blur', this.onWrapperBlur);
    }
    /**
     * @hidden
     * @internal
     */
    getPrevMonth(date) {
      return CalendarDay.from(date).add('month', -1).native;
    }
    /**
     * @hidden
     * @internal
     */
    getNextMonth(date, viewIndex) {
      return CalendarDay.from(date).add('month', viewIndex).native;
    }
    /**
     * Helper method building and returning the context object inside the calendar templates.
     *
     * @hidden
     * @internal
     */
    generateContext(value, i) {
      const construct = (date, index) => ({
        index: index,
        date,
        ...formatToParts(date, this.locale, this.formatOptions, ["era", "year", "month", "day", "weekday"])
      });
      const formatObject = Array.isArray(value) ? value.map((date, index) => construct(date, index)) : construct(value, i);
      return {
        $implicit: formatObject
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxCalendarComponent_BaseFactory;
        return function IgxCalendarComponent_Factory(__ngFactoryType__) {
          return (ɵIgxCalendarComponent_BaseFactory || (ɵIgxCalendarComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxCalendarComponent)))(__ngFactoryType__ || IgxCalendarComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCalendarComponent,
        selectors: [["igx-calendar"]],
        contentQueries: function IgxCalendarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarHeaderTemplateDirective, 7, IgxCalendarHeaderTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarHeaderTitleTemplateDirective, 7, IgxCalendarHeaderTitleTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarSubheaderTemplateDirective, 7, IgxCalendarSubheaderTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTitleTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subheaderTemplateDirective = _t.first);
          }
        },
        viewQuery: function IgxCalendarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c34, 5);
            i0.ɵɵviewQuery(_c35, 5, IgxYearsViewComponent);
            i0.ɵɵviewQuery(_c36, 5, IgxMonthsViewComponent);
            i0.ɵɵviewQuery(_c37, 5, IgxDaysViewComponent);
            i0.ɵɵviewQuery(_c38, 5);
            i0.ɵɵviewQuery(_c39, 5);
            i0.ɵɵviewQuery(_c40, 5);
            i0.ɵɵviewQuery(_c37, 5, IgxDaysViewComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dacadeView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthsView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.daysView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevPageBtn = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextPageBtn = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthsBtns = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthViews = _t);
          }
        },
        hostVars: 5,
        hostBindings: function IgxCalendarComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function IgxCalendarComponent_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-calendar--vertical", ctx.styleVerticalClass)("igx-calendar", ctx.styleClass);
          }
        },
        inputs: {
          id: "id",
          hasHeader: [2, "hasHeader", "hasHeader", booleanAttribute],
          vertical: [2, "vertical", "vertical", booleanAttribute],
          orientation: "orientation",
          headerOrientation: "headerOrientation",
          monthsViewNumber: "monthsViewNumber",
          showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxCalendarComponent
        }, {
          multi: false,
          provide: KeyboardNavigationService
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 41,
        vars: 23,
        consts: [["defaultHeaderTitle", ""], ["defaultHeaderDate", ""], ["defaultMonth", ""], ["defaultYear", ""], ["defaultMonthYear", ""], ["defaultDecade", ""], ["prevArrow", ""], ["nextArrow", ""], ["prevPageButton", ""], ["nextPageButton", ""], ["calendarDaysPicker", ""], ["calendarYearPicker", ""], ["calendarDecadePicker", ""], ["wrapper", ""], ["monthsBtn", ""], ["yearsBtn", ""], ["prevPageBtn", ""], ["nextPageBtn", ""], ["days", ""], ["months", ""], ["decade", ""], ["aria-labelledby", "igx-aria-calendar-title-month igx-aria-calendar-title-year", 1, "igx-calendar__header"], ["aria-labelledby", "calendar-desc", "role", "grid", 1, "igx-calendar__wrapper", 3, "tabIndex"], ["id", "calendar-desc", "tabindex", "-1", 1, "igx-calendar__aria-off-screen"], [1, "igx-calendar__pickers"], ["role", "presentation", 1, "igx-calendar__body"], ["role", "rowgroup", 3, "tabIndex", "date", "locale", "formatView", "monthFormat", "showActive", "standalone"], ["role", "rowgroup", 3, "tabIndex", "date", "locale", "formatView", "yearFormat", "showActive", "standalone"], ["tabindex", "0", "role", "button", 1, "igx-calendar-picker__date", 3, "keydown", "mousedown"], ["aria-live", "polite", 1, "igx-calendar__aria-off-screen"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true", "family", "default", "name", "arrow_prev"], ["aria-hidden", "true", "family", "default", "name", "arrow_next"], ["tabindex", "0", "role", "button", "data-action", "prev", "igxCalendarScrollPage", "", 1, "igx-calendar-picker__prev", 3, "keydown", "startScroll", "stopScroll"], [4, "ngTemplateOutlet"], ["tabindex", "0", "role", "button", "data-action", "next", "igxCalendarScrollPage", "", 1, "igx-calendar-picker__next", 3, "keydown", "startScroll", "stopScroll"], [1, "igx-calendar-picker"], [1, "igx-calendar-picker__dates"], [1, "igx-calendar-picker__nav"], ["aria-live", "polite", 1, "igx-calendar-picker__dates"], ["id", "igx-aria-calendar-title-year", 1, "igx-calendar__header-year"], ["id", "igx-aria-calendar-title-month", 1, "igx-calendar__header-date"], ["role", "rowgroup", 3, "tabIndex", "selection", "locale", "value", "activeDate", "previewRangeDate", "viewDate", "weekStart", "formatOptions", "formatViews", "disabledDates", "specialDates", "--calendar-row-start", "hideLeadingDays", "hideTrailingDays", "showWeekNumbers", "showActiveDay", "standalone"], ["role", "rowgroup", 3, "activeDateChange", "previewRangeDateChange", "swiperight", "swipeleft", "dateSelected", "mousedown", "tabIndex", "selection", "locale", "value", "activeDate", "previewRangeDate", "viewDate", "weekStart", "formatOptions", "formatViews", "disabledDates", "specialDates", "hideLeadingDays", "hideTrailingDays", "showWeekNumbers", "showActiveDay", "standalone"], ["role", "rowgroup", 3, "swiperight", "swipeleft", "pageChanged", "activeDateChanged", "selected", "mousedown", "tabIndex", "date", "locale", "formatView", "monthFormat", "showActive", "standalone"], ["role", "rowgroup", 3, "swiperight", "swipeleft", "pageChanged", "activeDateChanged", "selected", "mousedown", "tabIndex", "date", "locale", "formatView", "yearFormat", "showActive", "standalone"]],
        template: function IgxCalendarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxCalendarComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxCalendarComponent_ng_template_2_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxCalendarComponent_ng_template_4_Template, 4, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxCalendarComponent_ng_template_6_Template, 5, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxCalendarComponent_ng_template_8_Template, 3, 9, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(10, IgxCalendarComponent_ng_template_10_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(12, IgxCalendarComponent_ng_template_12_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(14, IgxCalendarComponent_ng_template_14_Template, 1, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(16, IgxCalendarComponent_ng_template_16_Template, 4, 7, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(18, IgxCalendarComponent_ng_template_18_Template, 4, 7, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(20, IgxCalendarComponent_ng_template_20_Template, 5, 10, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor)(22, IgxCalendarComponent_ng_template_22_Template, 6, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor)(24, IgxCalendarComponent_ng_template_24_Template, 6, 3, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor)(26, IgxCalendarComponent_Conditional_26_Template, 5, 4, "header", 21);
            i0.ɵɵelementStart(27, "div", 22, 13)(29, "caption", 23);
            i0.ɵɵtemplate(30, IgxCalendarComponent_Conditional_30_Template, 1, 1)(31, IgxCalendarComponent_Conditional_31_Template, 1, 1)(32, IgxCalendarComponent_Conditional_32_Template, 1, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "section", 24);
            i0.ɵɵtemplate(34, IgxCalendarComponent_Conditional_34_Template, 3, 2)(35, IgxCalendarComponent_Conditional_35_Template, 1, 1, "ng-container")(36, IgxCalendarComponent_Conditional_36_Template, 1, 1, "ng-container");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "section", 25);
            i0.ɵɵtemplate(38, IgxCalendarComponent_Conditional_38_Template, 3, 2)(39, IgxCalendarComponent_Conditional_39_Template, 2, 7, "igx-months-view", 26)(40, IgxCalendarComponent_Conditional_40_Template, 2, 7, "igx-years-view", 27);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(26);
            i0.ɵɵconditional(ctx.selection === "single" && ctx.hasHeader || ctx.selection === "range" && ctx.hasHeader ? 26 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("--calendar-months", ctx.monthsViewNumber);
            i0.ɵɵclassProp("igx-calendar__wrapper--vertical", ctx.orientation === "vertical");
            i0.ɵɵproperty("tabIndex", 0);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant)("aria-multiselectable", ctx.selection !== "single");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.selection === "multi" ? 30 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selection === "range" ? 31 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selection === "single" ? 32 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("igx-calendar__pickers--days", ctx.isDefaultView)("igx-calendar__pickers--vertical", ctx.orientation === "vertical");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDefaultView ? 34 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isYearView ? 35 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDecadeView ? 36 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("igx-calendar__body--vertical", ctx.orientation === "vertical");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDefaultView ? 38 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isYearView ? 39 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDecadeView ? 40 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxCalendarScrollPageDirective, IgxIconComponent, IgxDaysViewComponent, IgxMonthsViewComponent, IgxYearsViewComponent, DatePipe, IgxMonthViewSlotsCalendar, IgxGetViewDateCalendar],
        encapsulation: 2
      });
    }
  }
  return IgxCalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$i = 0;
let IgxMonthPickerComponent = /*#__PURE__*/(() => {
  class IgxMonthPickerComponent extends IgxCalendarBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Sets/gets the `id` of the month picker.
       * If not set, the `id` will have value `"igx-month-picker-0"`.
       */
      this.id = `igx-month-picker-${NEXT_ID$i++}`;
      /**
       * The default css class applied to the component.
       *
       * @hidden
       */
      this.styleClass = true;
    }
    /**
     * @hidden
     */
    previousPage(event) {
      event?.preventDefault();
      this.previousViewDate = this.viewDate;
      if (this.isDefaultView) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', -1).native;
      }
      if (this.isDecadeView) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', -15).native;
      }
      this.viewDateChanged.emit({
        previousValue: this.previousViewDate,
        currentValue: this.viewDate
      });
    }
    /**
     * @hidden
     */
    nextPage(event) {
      event?.preventDefault();
      this.previousViewDate = this.viewDate;
      if (this.isDefaultView) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', 1).native;
      }
      if (this.isDecadeView) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', 15).native;
      }
      this.viewDateChanged.emit({
        previousValue: this.previousViewDate,
        currentValue: this.viewDate
      });
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewDecadeKB(date, event, activeViewIdx) {
      super.activeViewDecadeKB(event, activeViewIdx);
      if (this.platform.isActivationKey(event)) {
        this.viewDate = date;
        this.wrapper.nativeElement.focus();
      }
    }
    /**
     * @hidden
     * @internal
     */
    onActiveViewDecade(event, date, activeViewIdx) {
      event.preventDefault();
      super.activeViewDecade(activeViewIdx);
      this.viewDate = date;
    }
    /**
     * @hidden
     */
    activeViewDecadeKB(event) {
      super.activeViewDecadeKB(event);
      if (event.key === this.platform.KEYMAP.ARROW_RIGHT) {
        this.nextPage(event);
      }
      if (event.key === this.platform.KEYMAP.ARROW_LEFT) {
        this.previousPage(event);
      }
    }
    /**
     * @hidden
     */
    activeViewDecade() {
      super.activeViewDecade();
      requestAnimationFrame(() => {
        this.dacadeView.el.nativeElement.focus();
      });
    }
    /**
     * @hidden
     */
    changePageKB(event, next = true) {
      if (this.platform.isActivationKey(event)) {
        event.stopPropagation();
        if (next) {
          this.nextPage();
        } else {
          this.previousPage();
        }
      }
    }
    /**
     * @hidden
     */
    selectYear(event) {
      this.previousViewDate = this.viewDate;
      this.viewDate = new Date(event.getFullYear(), event.getMonth(), event.getDate());
      this.activeView = IgxCalendarView.Year;
      this.wrapper.nativeElement.focus();
    }
    /**
     * @hidden
     */
    selectMonth(event) {
      this.selectDate(event);
      this.selected.emit(this.selectedDates);
    }
    /**
     * Selects a date.
     * ```typescript
     *  this.monthPicker.selectDate(new Date(`2018-06-12`));
     * ```
     */
    selectDate(value) {
      if (!value) {
        return new Date();
      }
      super.selectDate(value);
      this.viewDate = value;
    }
    /**
     * @hidden
     */
    getNextYear() {
      return CalendarDay.from(this.viewDate).add('year', 1).year;
    }
    /**
     * @hidden
     */
    getPreviousYear() {
      return CalendarDay.from(this.viewDate).add('year', -1).year;
    }
    /**
     * @hidden
     */
    updateDate(date) {
      this.previousViewDate = this.viewDate;
      this.viewDate = CalendarDay.from(date).add('year', -this.activeViewIdx).native;
      if (this.isDefaultView) {
        this.viewDateChanged.emit({
          previousValue: this.previousViewDate,
          currentValue: this.viewDate
        });
      }
    }
    onMouseDown(event) {
      event.stopPropagation();
      this.wrapper.nativeElement.focus();
    }
    /**
     * @hidden
     * @internal
     */
    set showActiveDay(value) {
      this._showActiveDay = value;
      this.cdr.detectChanges();
    }
    get showActiveDay() {
      return this._showActiveDay;
    }
    get activeDescendant() {
      if (this.activeView === 'month') {
        return this.value?.getTime();
      }
      return this._activeDescendant ?? this.viewDate.getTime();
    }
    set activeDescendant(date) {
      this._activeDescendant = date.getTime();
    }
    get isDefaultView() {
      return this.activeView === IgxCalendarView.Year;
    }
    ngOnInit() {
      this.activeView = IgxCalendarView.Year;
    }
    ngAfterViewInit() {
      this.keyboardNavigation.attachKeyboardHandlers(this.wrapper, this).set("ArrowUp", this.onArrowUp).set("ArrowDown", this.onArrowDown).set("ArrowLeft", this.onArrowLeft).set("ArrowRight", this.onArrowRight).set("Enter", this.onEnter).set(" ", this.onEnter).set("Home", this.onHome).set("End", this.onEnd).set("PageUp", this.handlePageUp).set("PageDown", this.handlePageDown);
      this.wrapper.nativeElement.addEventListener('focus', event => this.onWrapperFocus(event));
      this.wrapper.nativeElement.addEventListener('blur', event => this.onWrapperBlur(event));
      this.activeView$.subscribe(view => {
        this.activeViewChanged.emit(view);
        this.viewDateChanged.emit({
          previousValue: this.previousViewDate,
          currentValue: this.viewDate
        });
      });
    }
    onWrapperFocus(event) {
      event.stopPropagation();
      this.showActiveDay = true;
    }
    onWrapperBlur(event) {
      event.stopPropagation();
      this.showActiveDay = false;
      this._onTouchedCallback();
    }
    handlePageUpDown(event, delta) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isDefaultView && event.shiftKey) {
        this.viewDate = CalendarDay.from(this.viewDate).add('year', delta).native;
        this.cdr.detectChanges();
      } else {
        delta > 0 ? this.nextPage() : this.previousPage();
      }
    }
    handlePageUp(event) {
      this.handlePageUpDown(event, -1);
    }
    handlePageDown(event) {
      this.handlePageUpDown(event, 1);
    }
    onArrowUp(event) {
      if (this.isDefaultView) {
        this.monthsView.onKeydownArrowUp(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownArrowUp(event);
      }
    }
    onArrowDown(event) {
      if (this.isDefaultView) {
        this.monthsView.onKeydownArrowDown(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownArrowDown(event);
      }
    }
    onArrowLeft(event) {
      if (this.isDefaultView) {
        this.monthsView.onKeydownArrowLeft(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownArrowLeft(event);
      }
    }
    onArrowRight(event) {
      if (this.isDefaultView) {
        this.monthsView.onKeydownArrowRight(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownArrowRight(event);
      }
    }
    onEnter(event) {
      event.stopPropagation();
      if (this.isDefaultView) {
        this.monthsView.onKeydownEnter(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownEnter(event);
      }
    }
    onHome(event) {
      event.stopPropagation();
      if (this.isDefaultView) {
        this.monthsView.onKeydownHome(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownHome(event);
      }
    }
    onEnd(event) {
      event.stopPropagation();
      if (this.isDefaultView) {
        this.monthsView.onKeydownEnd(event);
      }
      if (this.isDecadeView) {
        this.dacadeView.onKeydownEnd(event);
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.keyboardNavigation.detachKeyboardHandlers();
      this.wrapper?.nativeElement.removeEventListener('focus', this.onWrapperFocus);
      this.wrapper?.nativeElement.removeEventListener('blur', this.onWrapperBlur);
    }
    /**
     * @hidden
     * @internal
     */
    getPrevYearDate(date) {
      return CalendarDay.from(date).add('year', -1).native;
    }
    /**
     * @hidden
     * @internal
     */
    getNextYearDate(date) {
      return CalendarDay.from(date).add('year', 1).native;
    }
    /**
     * Getter for the context object inside the calendar templates.
     *
     * @hidden
     * @internal
     */
    getContext(i) {
      const date = CalendarDay.from(this.viewDate).add('month', i).native;
      return this.generateContext(date, i);
    }
    /**
     * Helper method building and returning the context object inside the calendar templates.
     *
     * @hidden
     * @internal
     */
    generateContext(value, i) {
      const construct = (date, index) => ({
        index: index,
        date,
        ...formatToParts(date, this.locale, this.formatOptions, ["era", "year", "month", "day", "weekday"])
      });
      const formatObject = Array.isArray(value) ? value.map((date, index) => construct(date, index)) : construct(value, i);
      return {
        $implicit: formatObject
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxMonthPickerComponent_BaseFactory;
        return function IgxMonthPickerComponent_Factory(__ngFactoryType__) {
          return (ɵIgxMonthPickerComponent_BaseFactory || (ɵIgxMonthPickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxMonthPickerComponent)))(__ngFactoryType__ || IgxMonthPickerComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxMonthPickerComponent,
        selectors: [["igx-month-picker"]],
        viewQuery: function IgxMonthPickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c34, 5);
            i0.ɵɵviewQuery(_c36, 5, IgxMonthsViewComponent);
            i0.ɵɵviewQuery(_c35, 5, IgxYearsViewComponent);
            i0.ɵɵviewQuery(_c37, 5, IgxDaysViewComponent);
            i0.ɵɵviewQuery(_c33, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthsView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dacadeView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.daysView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.yearsBtn = _t.first);
          }
        },
        hostVars: 3,
        hostBindings: function IgxMonthPickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.pageup", function IgxMonthPickerComponent_keydown_pageup_HostBindingHandler($event) {
              return ctx.previousPage($event);
            })("keydown.pagedown", function IgxMonthPickerComponent_keydown_pagedown_HostBindingHandler($event) {
              return ctx.nextPage($event);
            })("mousedown", function IgxMonthPickerComponent_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-month-picker", ctx.styleClass);
          }
        },
        inputs: {
          id: "id"
        },
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxMonthPickerComponent
        }, {
          multi: false,
          provide: KeyboardNavigationService
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 26,
        vars: 8,
        consts: [["prevArrow", ""], ["nextArrow", ""], ["prevPageButton", ""], ["nextPageButton", ""], ["defaultYear", ""], ["defaultDecade", ""], ["calendarYearPicker", ""], ["calendarDecadePicker", ""], ["wrapper", ""], ["prevPageBtn", ""], ["nextPageBtn", ""], ["yearsBtn", ""], ["months", ""], ["decade", ""], ["aria-labelledby", "calendar-desc", "role", "grid", 1, "igx-calendar__wrapper", 3, "tabIndex"], ["id", "calendar-desc", "tabindex", "-1", 1, "igx-calendar__aria-off-screen"], [1, "igx-calendar__pickers"], [1, "igx-calendar__body"], ["role", "rowgroup", 3, "tabIndex", "date", "locale", "formatView", "monthFormat", "showActive", "standalone"], ["role", "rowgroup", 3, "tabIndex", "date", "locale", "formatView", "yearFormat", "showActive", "standalone"], ["aria-hidden", "true", "family", "default", "name", "arrow_prev"], ["aria-hidden", "true", "family", "default", "name", "arrow_next"], ["tabindex", "0", "role", "button", "data-action", "prev", "igxCalendarScrollPage", "", 1, "igx-calendar-picker__prev", 3, "mousedown", "keydown"], [4, "ngTemplateOutlet"], ["tabindex", "0", "role", "button", "data-action", "next", "igxCalendarScrollPage", "", 1, "igx-calendar-picker__next", 3, "mousedown", "keydown"], ["aria-live", "polite", 1, "igx-calendar__aria-off-screen"], ["tabindex", "0", "role", "button", 1, "igx-calendar-picker__date", 3, "keydown", "mousedown"], [1, "igx-calendar-picker"], [1, "igx-calendar-picker__dates"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-calendar-picker__nav"], ["aria-live", "polite", 1, "igx-calendar-picker__dates"], ["role", "rowgroup", 3, "swiperight", "swipeleft", "selected", "pageChanged", "mousedown", "tabIndex", "date", "locale", "formatView", "monthFormat", "showActive", "standalone"], ["role", "rowgroup", 3, "swiperight", "swipeleft", "selected", "pageChanged", "mousedown", "tabIndex", "date", "locale", "formatView", "yearFormat", "showActive", "standalone"]],
        template: function IgxMonthPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxMonthPickerComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxMonthPickerComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxMonthPickerComponent_ng_template_4_Template, 4, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxMonthPickerComponent_ng_template_6_Template, 4, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxMonthPickerComponent_ng_template_8_Template, 5, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(10, IgxMonthPickerComponent_ng_template_10_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(12, IgxMonthPickerComponent_ng_template_12_Template, 6, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(14, IgxMonthPickerComponent_ng_template_14_Template, 6, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(16, "div", 14, 8)(18, "caption", 15);
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "section", 16);
            i0.ɵɵtemplate(21, IgxMonthPickerComponent_Conditional_21_Template, 1, 1, "ng-container")(22, IgxMonthPickerComponent_Conditional_22_Template, 1, 1, "ng-container");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "section", 17);
            i0.ɵɵtemplate(24, IgxMonthPickerComponent_Conditional_24_Template, 3, 7, "igx-months-view", 18)(25, IgxMonthPickerComponent_Conditional_25_Template, 2, 7, "igx-years-view", 19);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("tabIndex", 0);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant)("aria-multiselectable", ctx.selection !== "single");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.resourceStrings.igx_calendar_singular_single_selection, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isDefaultView ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDecadeView ? 22 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isDefaultView ? 24 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDecadeView ? 25 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, DatePipe, IgxIconComponent, IgxMonthsViewComponent, IgxYearsViewComponent],
        encapsulation: 2
      });
    }
  }
  return IgxMonthPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Calendar directives collection for ease-of-use import in standalone components scenario */
const IGX_CALENDAR_DIRECTIVES = [IgxCalendarComponent, IgxDaysViewComponent, IgxMonthsViewComponent, IgxYearsViewComponent, IgxMonthPickerComponent, IgxCalendarHeaderTemplateDirective, IgxCalendarHeaderTitleTemplateDirective, IgxCalendarMonthDirective, IgxCalendarYearDirective, IgxCalendarSubheaderTemplateDirective];
let NEXT_ID$h = 0;
/**
 * IgxCardMedia is container for the card media section.
 * Use it to wrap images and videos.
 */
let IgxCardMediaDirective = /*#__PURE__*/(() => {
  class IgxCardMediaDirective {
    constructor() {
      /** @hidden @internal */
      this.cssClass = 'igx-card__media';
      /**
       * Sets the `width` and `min-width` style property
       * of the media container. If not provided it will be set to `auto`.
       *
       * @example
       * ```html
       * <igx-card-media width="300px"></igx-card-media>
       * ```
       */
      this.width = 'auto';
      /**
       * Sets the `height` style property of the media container.
       * If not provided it will be set to `auto`.
       *
       * @example
       * ```html
       * <igx-card-media height="50%"></igx-card-media>
       * ```
       */
      this.height = 'auto';
      /**
       * Sets the `role` attribute of the media container.
       */
      this.role = 'img';
    }
    static {
      this.ɵfac = function IgxCardMediaDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardMediaDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardMediaDirective,
        selectors: [["igx-card-media"]],
        hostVars: 9,
        hostBindings: function IgxCardMediaDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
            i0.ɵɵstyleProp("width", ctx.width)("min-width", ctx.width)("height", ctx.height);
            i0.ɵɵclassProp("igx-card__media", ctx.cssClass);
          }
        },
        inputs: {
          width: "width",
          height: "height",
          role: "role"
        }
      });
    }
  }
  return IgxCardMediaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxCardHeader is container for the card header
 */
let IgxCardHeaderComponent = /*#__PURE__*/(() => {
  class IgxCardHeaderComponent {
    constructor() {
      /** @hidden @internal */
      this.cssClass = 'igx-card-header';
      /**
       * Sets the layout style of the header.
       * By default the header elements(thumbnail and title/subtitle) are aligned horizontally.
       *
       * @example
       * ```html
       * <igx-card-header [vertical]="true"></igx-card-header>
       * ```
       */
      this.vertical = false;
    }
    static {
      this.ɵfac = function IgxCardHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCardHeaderComponent,
        selectors: [["igx-card-header"]],
        hostVars: 4,
        hostBindings: function IgxCardHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-card-header", ctx.cssClass)("igx-card-header--vertical", ctx.vertical);
          }
        },
        inputs: {
          vertical: [2, "vertical", "vertical", booleanAttribute]
        },
        ngContentSelectors: _c42,
        decls: 5,
        vars: 0,
        consts: [[1, "igx-card-header__thumbnail"], [1, "igx-card-header__titles"]],
        template: function IgxCardHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c41);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4, 2);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxCardHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxCardThumbnail is container for the card thumbnail section.
 * Use it to wrap anything you want to be used as a thumbnail.
 */
let IgxCardThumbnailDirective = /*#__PURE__*/(() => {
  class IgxCardThumbnailDirective {
    static {
      this.ɵfac = function IgxCardThumbnailDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardThumbnailDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardThumbnailDirective,
        selectors: [["", "igxCardThumbnail", ""]]
      });
    }
  }
  return IgxCardThumbnailDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxCardHeaderTitle is used to denote the header title in a card.
 * Use it to tag text nodes.
 */
let IgxCardHeaderTitleDirective = /*#__PURE__*/(() => {
  class IgxCardHeaderTitleDirective {
    constructor() {
      /** @hidden @internal */
      this.cssClass = 'igx-card__header__title';
    }
    static {
      this.ɵfac = function IgxCardHeaderTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardHeaderTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardHeaderTitleDirective,
        selectors: [["", "igxCardHeaderTitle", ""]],
        hostVars: 2,
        hostBindings: function IgxCardHeaderTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-card-header__title", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxCardHeaderTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxCardHeaderSubtitle is used to denote the header subtitle in a card.
 * Use it to tag text nodes.
 */
let IgxCardHeaderSubtitleDirective = /*#__PURE__*/(() => {
  class IgxCardHeaderSubtitleDirective {
    constructor() {
      /** @hidden @internal */
      this.cssClass = 'igx-card-header__subtitle';
    }
    static {
      this.ɵfac = function IgxCardHeaderSubtitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardHeaderSubtitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardHeaderSubtitleDirective,
        selectors: [["", "igxCardHeaderSubtitle", ""]],
        hostVars: 2,
        hostBindings: function IgxCardHeaderSubtitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-card-header__subtitle", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxCardHeaderSubtitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxCardContent is container for the card content.
 */
let IgxCardContentDirective = /*#__PURE__*/(() => {
  class IgxCardContentDirective {
    constructor() {
      /** @hidden @internal */
      this.cssClass = 'igx-card-content';
    }
    static {
      this.ɵfac = function IgxCardContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardContentDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardContentDirective,
        selectors: [["igx-card-content"]],
        hostVars: 2,
        hostBindings: function IgxCardContentDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-card-content", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxCardContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxCardFooter is container for the card footer
 */
let IgxCardFooterDirective = /*#__PURE__*/(() => {
  class IgxCardFooterDirective {
    constructor() {
      /**
       * Sets the value of the `role` attribute of the card footer.
       * By default the value is set to `footer`.
       *
       * @example
       * ```html
       * <igx-card-footer role="footer"></igx-card-footer>
       * ```
       */
      this.role = 'footer';
    }
    static {
      this.ɵfac = function IgxCardFooterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardFooterDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCardFooterDirective,
        selectors: [["igx-card-footer"]],
        hostVars: 1,
        hostBindings: function IgxCardFooterDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
          }
        },
        inputs: {
          role: "role"
        }
      });
    }
  }
  return IgxCardFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Card provides a way to display organized content in appealing way.
 *
 * @igxModule IgxCardModule
 *
 * @igxTheme igx-card-theme, igx-icon-theme, igx-button-theme
 *
 * @igxKeywords card, button, avatar, icon
 *
 * @igxGroup Layouts
 *
 * @remarks
 * The Ignite UI Card serves as a container that allows custom content to be organized in an appealing way. There are
 * five sections in a card that you can use to organize your content. These are header, media, content, actions, and footer.
 *
 * @example
 * ```html
 * <igx-card>
 *   <igx-card-header>
 *     <h3 igxCardHeaderTitle>{{title}}</h3>
 *     <h5 igxCardHeaderSubtitle>{{subtitle}}</h5>
 *   </igx-card-header>
 *   <igx-card-actions>
 *       <button type="button" igxButton igxRipple>Share</button>
 *       <button type="button" igxButton igxRipple>Play Album</button>
 *   </igx-card-actions>
 * </igx-card>
 * ```
 */
let IgxCardComponent = /*#__PURE__*/(() => {
  class IgxCardComponent {
    constructor() {
      /**
       * Sets/gets the `id` of the card.
       * If not set, `id` will have value `"igx-card-0"`;
       *
       * @example
       * ```html
       * <igx-card id="my-first-card"></igx-card>
       * ```
       * ```typescript
       * let cardId =  this.card.id;
       * ```
       */
      this.id = `igx-card-${NEXT_ID$h++}`;
      /**
       * Sets the `igx-card` css class to the card component.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-card';
      /**
       * Sets the value of the `role` attribute of the card.
       * By default the value is set to `group`.
       *
       * @example
       * ```html
       * <igx-card role="group"></igx-card>
       * ```
       */
      this.role = 'group';
      /**
       * Sets/gets whether the card is elevated.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-card elevated></igx-card>
       * ```
       * ```typescript
       * let cardElevation = this.card.elevated;
       * ```
       */
      this.elevated = false;
      /**
       * Sets the value of the `horizontal` attribute of the card.
       * Setting this to `true` will make the different card sections align horizontally,
       * essentially flipping the card to the side.
       *
       * @example
       * ```html
       * <igx-card [horizontal]="true"></igx-card>
       * ```
       */
      this.horizontal = false;
    }
    static {
      this.ɵfac = function IgxCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCardComponent,
        selectors: [["igx-card"]],
        hostVars: 8,
        hostBindings: function IgxCardComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role);
            i0.ɵɵclassProp("igx-card", ctx.cssClass)("igx-card--elevated", ctx.elevated)("igx-card--horizontal", ctx.horizontal);
          }
        },
        inputs: {
          id: "id",
          role: "role",
          elevated: [2, "elevated", "elevated", booleanAttribute],
          horizontal: [2, "horizontal", "horizontal", booleanAttribute]
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxCardActionsLayout = /*@__PURE__*/mkenum({
  START: 'start',
  JUSTIFY: 'justify'
});
/**
 * IgxCardActions is container for the card actions.
 */
let IgxCardActionsComponent = /*#__PURE__*/(() => {
  class IgxCardActionsComponent {
    /**
     * A getter that returns `true` when the layout has been
     * set to `justify`.
     */
    get isJustifyLayout() {
      return this.layout === IgxCardActionsLayout.JUSTIFY;
    }
    constructor(card) {
      this.card = card;
      /**
       * Sets the layout style of the actions.
       * You can justify the elements slotted in the igx-card-action container
       * so that they are positioned equally from one another taking up all the
       * space available along the card actions axis.
       *
       * @example
       * ```html
       * <igx-card-actions layout="justify"></igx-card-actions>
       * ```
       */
      this.layout = IgxCardActionsLayout.START;
      /**
       * Sets the vertical attribute of the actions.
       * When set to `true` the actions will be layed out vertically.
       */
      this.vertical = false;
      this.isVerticalSet = false;
    }
    /**
     * @hidden
     * @internal
     */
    ngOnChanges(changes) {
      for (const prop in changes) {
        if (prop === 'vertical') {
          this.isVerticalSet = true;
        }
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngOnInit() {
      if (!this.isVerticalSet && this.card.horizontal) {
        this.vertical = true;
      }
    }
    static {
      this.ɵfac = function IgxCardActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardActionsComponent)(i0.ɵɵdirectiveInject(IgxCardComponent, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCardActionsComponent,
        selectors: [["igx-card-actions"]],
        hostVars: 6,
        hostBindings: function IgxCardActionsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-card-actions", ctx.layout)("igx-card-actions--vertical", ctx.vertical)("igx-card-actions--justify", ctx.isJustifyLayout);
          }
        },
        inputs: {
          layout: "layout",
          vertical: [2, "vertical", "vertical", booleanAttribute]
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c44,
        decls: 6,
        vars: 0,
        consts: [["buttons", ""], [1, "igx-card-actions__start"], [1, "igx-card-actions__end"]],
        template: function IgxCardActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c43);
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵprojection(5, 2);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxCardActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Card directives collection for ease-of-use import in standalone components scenario */
const IGX_CARD_DIRECTIVES = [IgxCardComponent, IgxCardHeaderComponent, IgxCardMediaDirective, IgxCardContentDirective, IgxCardActionsComponent, IgxCardFooterDirective, IgxCardHeaderTitleDirective, IgxCardHeaderSubtitleDirective, IgxCardThumbnailDirective];
const CarouselResourceStringsEN = {
  igx_carousel_of: 'of',
  igx_carousel_slide: 'slide',
  igx_carousel_previous_slide: 'previous slide',
  igx_carousel_next_slide: 'next slide'
};
const CarouselAnimationType = /*@__PURE__*/mkenum({
  none: 'none',
  slide: 'slide',
  fade: 'fade'
});
const CarouselIndicatorsOrientation = /*@__PURE__*/mkenum({
  /**
   * @deprecated in version 19.1.0. Use `end` instead.
   */
  bottom: 'bottom',
  /**
   * @deprecated in version 19.1.0. Use `start` instead.
   */
  top: 'top',
  start: 'start',
  end: 'end'
});
var Direction = /*#__PURE__*/function (Direction) {
  Direction[Direction["NONE"] = 0] = "NONE";
  Direction[Direction["NEXT"] = 1] = "NEXT";
  Direction[Direction["PREV"] = 2] = "PREV";
  return Direction;
}(Direction || {});
/** @hidden */
const IGX_CAROUSEL_COMPONENT = /*@__PURE__*/new InjectionToken('IgxCarouselToken');
/** @hidden */
let IgxCarouselComponentBase = /*#__PURE__*/(() => {
  let IgxCarouselComponentBase = class IgxCarouselComponentBase {
    constructor(animationService, cdr) {
      this.animationService = animationService;
      this.cdr = cdr;
      /** @hidden */
      this.animationType = CarouselAnimationType.slide;
      /** @hidden @internal */
      this.enterAnimationDone = new EventEmitter();
      /** @hidden @internal */
      this.leaveAnimationDone = new EventEmitter();
      /** @hidden */
      this.defaultAnimationDuration = 320;
      /** @hidden */
      this.animationPosition = 0;
      /** @hidden */
      this.newDuration = 0;
      /** @hidden */
      this.vertical = false;
    }
    /** @hidden */
    triggerAnimations() {
      if (this.animationType !== CarouselAnimationType.none) {
        if (this.animationStarted(this.leaveAnimationPlayer) || this.animationStarted(this.enterAnimationPlayer)) {
          requestAnimationFrame(() => {
            this.resetAnimations();
            this.playAnimations();
          });
        } else {
          this.playAnimations();
        }
      }
    }
    /** @hidden */
    animationStarted(animation) {
      return animation && animation.hasStarted();
    }
    /** @hidden */
    playAnimations() {
      this.playLeaveAnimation();
      this.playEnterAnimation();
    }
    resetAnimations() {
      if (this.animationStarted(this.leaveAnimationPlayer)) {
        this.leaveAnimationPlayer.reset();
        this.leaveAnimationDone.emit();
      }
      if (this.animationStarted(this.enterAnimationPlayer)) {
        this.enterAnimationPlayer.reset();
        this.enterAnimationDone.emit();
        this.cdr.markForCheck();
      }
    }
    getAnimation() {
      let duration;
      if (this.newDuration) {
        duration = this.animationPosition ? this.animationPosition * this.newDuration : this.newDuration;
      } else {
        duration = this.animationPosition ? this.animationPosition * this.defaultAnimationDuration : this.defaultAnimationDuration;
      }
      const trans = this.animationPosition ? this.animationPosition * 100 : 100;
      switch (this.animationType) {
        case CarouselAnimationType.slide:
          return {
            enterAnimation: useAnimation(slideInLeft, {
              params: {
                delay: '0s',
                duration: `${duration}ms`,
                endOpacity: 1,
                startOpacity: 1,
                fromPosition: `${this.vertical ? 'translateY' : 'translateX'}(${this.currentItem.direction === 1 ? trans : -trans}%)`,
                toPosition: `${this.vertical ? 'translateY(0%)' : 'translateX(0%)'}`
              }
            }),
            leaveAnimation: useAnimation(slideInLeft, {
              params: {
                delay: '0s',
                duration: `${duration}ms`,
                endOpacity: 1,
                startOpacity: 1,
                fromPosition: `${this.vertical ? 'translateY(0%)' : 'translateX(0%)'}`,
                toPosition: `${this.vertical ? 'translateY' : 'translateX'}(${this.currentItem.direction === 1 ? -trans : trans}%)`
              }
            })
          };
        case CarouselAnimationType.fade:
          return {
            enterAnimation: useAnimation(fadeIn, {
              params: {
                duration: `${duration}ms`,
                startOpacity: `${this.animationPosition}`
              }
            }),
            leaveAnimation: null
          };
      }
      return {
        enterAnimation: null,
        leaveAnimation: null
      };
    }
    playEnterAnimation() {
      const animation = this.getAnimation().enterAnimation;
      if (!animation) {
        return;
      }
      this.enterAnimationPlayer = this.animationService.buildAnimation(animation, this.getCurrentElement());
      this.enterAnimationPlayer.animationEnd.subscribe(() => {
        // TODO: animation may never end. Find better way to clean up the player
        if (this.enterAnimationPlayer) {
          this.enterAnimationPlayer.reset();
          this.enterAnimationPlayer = null;
        }
        this.animationPosition = 0;
        this.newDuration = 0;
        this.previousItem.previous = false;
        this.enterAnimationDone.emit();
        this.cdr.markForCheck();
      });
      this.previousItem.previous = true;
      this.enterAnimationPlayer.play();
    }
    playLeaveAnimation() {
      const animation = this.getAnimation().leaveAnimation;
      if (!animation) {
        return;
      }
      this.leaveAnimationPlayer = this.animationService.buildAnimation(animation, this.getPreviousElement());
      this.leaveAnimationPlayer.animationEnd.subscribe(() => {
        // TODO: animation may never end. Find better way to clean up the player
        if (this.leaveAnimationPlayer) {
          this.leaveAnimationPlayer.reset();
          this.leaveAnimationPlayer = null;
        }
        this.animationPosition = 0;
        this.newDuration = 0;
        this.leaveAnimationDone.emit();
      });
      this.leaveAnimationPlayer.play();
    }
  };
  IgxCarouselComponentBase = __decorate([__param(0, Inject(IgxAngularAnimationService))], IgxCarouselComponentBase);
  return IgxCarouselComponentBase;
})();
let IgxCarouselIndicatorDirective = /*#__PURE__*/(() => {
  class IgxCarouselIndicatorDirective {
    static {
      this.ɵfac = function IgxCarouselIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCarouselIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCarouselIndicatorDirective,
        selectors: [["", "igxCarouselIndicator", ""]]
      });
    }
  }
  return IgxCarouselIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCarouselNextButtonDirective = /*#__PURE__*/(() => {
  class IgxCarouselNextButtonDirective {
    static {
      this.ɵfac = function IgxCarouselNextButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCarouselNextButtonDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCarouselNextButtonDirective,
        selectors: [["", "igxCarouselNextButton", ""]]
      });
    }
  }
  return IgxCarouselNextButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCarouselPrevButtonDirective = /*#__PURE__*/(() => {
  class IgxCarouselPrevButtonDirective {
    static {
      this.ɵfac = function IgxCarouselPrevButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCarouselPrevButtonDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCarouselPrevButtonDirective,
        selectors: [["", "igxCarouselPrevButton", ""]]
      });
    }
  }
  return IgxCarouselPrevButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A slide component that usually holds an image and/or a caption text.
 * IgxSlideComponent is usually a child component of an IgxCarouselComponent.
 *
 * ```
 * <igx-slide [input bindings] >
 *    <ng-content></ng-content>
 * </igx-slide>
 * ```
 *
 * @export
 */
let IgxSlideComponent = /*#__PURE__*/(() => {
  class IgxSlideComponent {
    /**
     * Returns the `tabIndex` of the slide component.
     * ```typescript
     * let tabIndex =  this.carousel.tabIndex;
     * ```
     *
     * @memberof IgxSlideComponent
     */
    get tabIndex() {
      return this.active && this.carousel.keyboardSupport ? 0 : null;
    }
    /**
     * Gets/sets the `active` state of the slide.
     * ```html
     * <igx-carousel>
     *  <igx-slide [active] ="false"></igx-slide>
     * <igx-carousel>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <igx-carousel>
     *  <igx-slide [(active)] ="model.isActive"></igx-slide>
     * <igx-carousel>
     * ```
     *
     * @memberof IgxSlideComponent
     */
    get active() {
      return this._active;
    }
    set active(value) {
      this._active = value;
      this.activeChange.emit(this._active);
    }
    constructor(elementRef, carousel) {
      this.elementRef = elementRef;
      this.carousel = carousel;
      /**
       * Returns the `role` of the slide component.
       * By default is set to `tabpanel`
       *
       * @memberof IgxSlideComponent
       */
      this.tab = 'tabpanel';
      /**
       * Returns the class of the slide component.
       * ```typescript
       * let class =  this.slide.cssClass;
       * ```
       *
       * @memberof IgxSlideComponent
       */
      this.cssClass = 'igx-slide';
      this.previous = false;
      /**
       * @hidden
       */
      this.activeChange = new EventEmitter();
      this._active = false;
      this._destroy$ = new Subject();
    }
    /**
     * Returns a reference to the carousel element in the DOM.
     * ```typescript
     * let nativeElement =  this.slide.nativeElement;
     * ```
     *
     * @memberof IgxSlideComponent
     */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    /**
     * @hidden
     */
    get isDestroyed() {
      return this._destroy$;
    }
    ngAfterContentChecked() {
      this.id = `panel-${this.index}`;
      this.ariaLabelledBy = `tab-${this.index}-${this.total}`;
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._destroy$.next(true);
      this._destroy$.complete();
    }
    static {
      this.ɵfac = function IgxSlideComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSlideComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IGX_CAROUSEL_COMPONENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSlideComponent,
        selectors: [["igx-slide"]],
        hostVars: 10,
        hostBindings: function IgxSlideComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabIndex)("id", ctx.id)("role", ctx.tab)("aria-labelledby", ctx.ariaLabelledBy);
            i0.ɵɵclassProp("igx-slide", ctx.cssClass)("igx-slide--current", ctx.active)("igx-slide--previous", ctx.previous);
          }
        },
        inputs: {
          index: "index",
          direction: "direction",
          total: "total",
          active: [2, "active", "active", booleanAttribute],
          previous: [2, "previous", "previous", booleanAttribute]
        },
        outputs: {
          activeChange: "activeChange"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxSlideComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxSlideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const EVENT_SUFFIX = 'precise';
/**
 * Touch gestures manager based on Hammer.js
 * Use with caution, this will track references for single manager per element. Very TBD. Much TODO.
 *
 * @hidden
 */
class HammerGesturesManager {
  static {
    this.Hammer = typeof window !== 'undefined' ? window.Hammer : null;
  }
  constructor(_zone, doc, platformUtil) {
    this._zone = _zone;
    this.doc = doc;
    this.platformUtil = platformUtil;
    /**
     * Event option defaults for each recognizer, see http://hammerjs.github.io/api/ for API listing.
     */
    this.hammerOptions = {};
    this._hammerManagers = [];
    this.platformBrowser = this.platformUtil.isBrowser;
    if (this.platformBrowser && HammerGesturesManager.Hammer) {
      this.hammerOptions = {
        // D.P. #447 Force TouchInput due to PointerEventInput bug (https://github.com/hammerjs/hammer.js/issues/1065)
        // see https://github.com/IgniteUI/igniteui-angular/issues/447#issuecomment-324601803
        inputClass: HammerGesturesManager.Hammer.TouchInput,
        recognizers: [[HammerGesturesManager.Hammer.Pan, {
          threshold: 0
        }], [HammerGesturesManager.Hammer.Swipe, {
          direction: HammerGesturesManager.Hammer.DIRECTION_HORIZONTAL
        }], [HammerGesturesManager.Hammer.Tap], [HammerGesturesManager.Hammer.Tap, {
          event: 'doubletap',
          taps: 2
        }, ['tap']]]
      };
    }
  }
  supports(eventName) {
    return eventName.toLowerCase().endsWith('.' + EVENT_SUFFIX);
  }
  /**
   * Add listener extended with options for Hammer.js. Will use defaults if none are provided.
   * Modeling after other event plugins for easy future modifications.
   */
  addEventListener(element, eventName, eventHandler, options = null) {
    if (!this.platformBrowser) {
      return;
    }
    // Creating the manager bind events, must be done outside of angular
    return this._zone.runOutsideAngular(() => {
      if (!HammerGesturesManager.Hammer) {
        //no hammer
        return;
      }
      let mc = this.getManagerForElement(element);
      if (mc === null) {
        // new Hammer is a shortcut for Manager with defaults
        mc = new HammerGesturesManager.Hammer(element, Object.assign(this.hammerOptions, options));
        this.addManagerForElement(element, mc);
      }
      const handler = eventObj => this._zone.run(() => eventHandler(eventObj));
      mc.on(eventName, handler);
      return () => mc.off(eventName, handler);
    });
  }
  /**
   * Add listener extended with options for Hammer.js. Will use defaults if none are provided.
   * Modeling after other event plugins for easy future modifications.
   *
   * @param target Can be one of either window, body or document(fallback default).
   */
  addGlobalEventListener(target, eventName, eventHandler) {
    if (!this.platformBrowser || !HammerGesturesManager.Hammer) {
      return;
    }
    const element = this.getGlobalEventTarget(target);
    // Creating the manager bind events, must be done outside of angular
    return this.addEventListener(element, eventName, eventHandler);
  }
  /**
   * Exposes [Dom]Adapter.getGlobalEventTarget to get global event targets.
   * Supported: window, document, body. Defaults to document for invalid args.
   *
   * @param target Target name
   */
  getGlobalEventTarget(target) {
    return _getDOM().getGlobalEventTarget(this.doc, target);
  }
  /**
   * Set HammerManager options.
   *
   * @param element The DOM element used to create the manager on.
   *
   * ### Example
   *
   * ```ts
   * manager.setManagerOption(myElem, "pan", { pointers: 1 });
   * ```
   */
  setManagerOption(element, event, options) {
    const manager = this.getManagerForElement(element);
    manager.get(event).set(options);
  }
  /**
   * Add an element and manager map to the internal collection.
   *
   * @param element The DOM element used to create the manager on.
   */
  addManagerForElement(element, manager) {
    this._hammerManagers.push({
      element,
      manager
    });
  }
  /**
   * Get HammerManager for the element or null
   *
   * @param element The DOM element used to create the manager on.
   */
  getManagerForElement(element) {
    const result = this._hammerManagers.filter(value => value.element === element);
    return result.length ? result[0].manager : null;
  }
  /**
   * Destroys the HammerManager for the element, removing event listeners in the process.
   *
   * @param element The DOM element used to create the manager on.
   */
  removeManagerForElement(element) {
    let index = null;
    for (let i = 0; i < this._hammerManagers.length; i++) {
      if (element === this._hammerManagers[i].element) {
        index = i;
        break;
      }
    }
    if (index !== null) {
      const item = this._hammerManagers.splice(index, 1)[0];
      // destroy also
      item.manager.destroy();
    }
  }
  /** Destroys all internally tracked HammerManagers, removing event listeners in the process. */
  destroy() {
    for (const item of this._hammerManagers) {
      item.manager.destroy();
    }
    this._hammerManagers = [];
  }
  static {
    this.ɵfac = function HammerGesturesManager_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HammerGesturesManager)(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(PlatformUtil));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HammerGesturesManager,
      factory: HammerGesturesManager.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$g = 0;
let CarouselHammerConfig = /*#__PURE__*/(() => {
  class CarouselHammerConfig extends HammerGestureConfig {
    constructor() {
      super(...arguments);
      this.overrides = {
        pan: {
          direction: HammerGesturesManager.Hammer?.DIRECTION_HORIZONTAL
        }
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵCarouselHammerConfig_BaseFactory;
        return function CarouselHammerConfig_Factory(__ngFactoryType__) {
          return (ɵCarouselHammerConfig_BaseFactory || (ɵCarouselHammerConfig_BaseFactory = i0.ɵɵgetInheritedFactory(CarouselHammerConfig)))(__ngFactoryType__ || CarouselHammerConfig);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CarouselHammerConfig,
        factory: CarouselHammerConfig.ɵfac
      });
    }
  }
  return CarouselHammerConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * **Ignite UI for Angular Carousel** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/carousel.html)
 *
 * The Ignite UI Carousel is used to browse or navigate through a collection of slides. Slides can contain custom
 * content such as images or cards and be used for things such as on-boarding tutorials or page-based interfaces.
 * It can be used as a separate fullscreen element or inside another component.
 *
 * Example:
 * ```html
 * <igx-carousel>
 *   <igx-slide>
 *     <h3>First Slide Header</h3>
 *     <p>First slide Content</p>
 *   <igx-slide>
 *   <igx-slide>
 *     <h3>Second Slide Header</h3>
 *     <p>Second Slide Content</p>
 * </igx-carousel>
 * ```
 */
let IgxCarouselComponent = /*#__PURE__*/(() => {
  class IgxCarouselComponent extends IgxCarouselComponentBase {
    /** @hidden */
    get labelId() {
      return this.showIndicatorsLabel ? `${this.id}-label` : null;
    }
    /** @hidden */
    get isVertical() {
      return this.vertical;
    }
    /**
     * Gets the `touch-action` style of the `list item`.
     * ```typescript
     * let touchAction = this.listItem.touchAction;
     * ```
     */
    get touchAction() {
      return this.gesturesSupport ? 'pan-y' : 'auto';
    }
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /** @hidden */
    get getIndicatorTemplate() {
      if (this.indicatorTemplate) {
        return this.indicatorTemplate;
      }
      return this.defaultIndicator;
    }
    /** @hidden */
    get getNextButtonTemplate() {
      if (this.nextButtonTemplate) {
        return this.nextButtonTemplate;
      }
      return this.defaultNextButton;
    }
    /** @hidden */
    get getPrevButtonTemplate() {
      if (this.prevButtonTemplate) {
        return this.prevButtonTemplate;
      }
      return this.defaultPrevButton;
    }
    /** @hidden */
    get indicatorsClass() {
      return {
        ['igx-carousel-indicators--focused']: this._hasKeyboardFocusOnIndicators,
        [`igx-carousel-indicators--${this.getIndicatorsClass()}`]: true
      };
    }
    /** @hidden */
    get showIndicators() {
      return this.indicators && this.total <= this.maximumIndicatorsCount && this.total > 0;
    }
    /** @hidden */
    get showIndicatorsLabel() {
      return this.indicators && this.total > this.maximumIndicatorsCount;
    }
    /** @hidden */
    get getCarouselLabel() {
      return `${this.current + 1} ${this.resourceStrings.igx_carousel_of} ${this.total}`;
    }
    /**
     * Returns the total number of `slides` in the carousel.
     * ```typescript
     * let slideCount =  this.carousel.total;
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    get total() {
      return this.slides?.length;
    }
    /**
     * The index of the slide being currently shown.
     * ```typescript
     * let currentSlideNumber =  this.carousel.current;
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    get current() {
      return !this.currentItem ? 0 : this.currentItem.index;
    }
    /**
     * Returns a boolean indicating if the carousel is playing.
     * ```typescript
     * let isPlaying =  this.carousel.isPlaying;
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    get isPlaying() {
      return this.playing;
    }
    /**
     * Returns а boolean indicating if the carousel is destroyed.
     * ```typescript
     * let isDestroyed =  this.carousel.isDestroyed;
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    get isDestroyed() {
      return this.destroyed;
    }
    /**
     * Returns a reference to the carousel element in the DOM.
     * ```typescript
     * let nativeElement =  this.carousel.nativeElement;
     * ```
     *
     * @memberof IgxCarouselComponent
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /**
     * Returns the time `interval` in milliseconds before the slide changes.
     * ```typescript
     * let timeInterval = this.carousel.interval;
     * ```
     *
     * @memberof IgxCarouselComponent
     */
    get interval() {
      return this._interval;
    }
    /**
     * Sets the time `interval` in milliseconds before the slide changes.
     * If not set, the carousel will not change `slides` automatically.
     * ```html
     * <igx-carousel [interval]="1000"></igx-carousel>
     * ```
     *
     * @memberof IgxCarouselComponent
     */
    set interval(value) {
      this._interval = +value;
      this.restartInterval();
    }
    constructor(cdr, element, iterableDiffers, animationService, platformUtil, dir, document) {
      super(animationService, cdr);
      this.element = element;
      this.iterableDiffers = iterableDiffers;
      this.platformUtil = platformUtil;
      this.dir = dir;
      this.document = document;
      /**
       * Sets the `id` of the carousel.
       * If not set, the `id` of the first carousel component will be `"igx-carousel-0"`.
       * ```html
       * <igx-carousel id="my-first-carousel"></igx-carousel>
       * ```
       *
       * @memberof IgxCarouselComponent
       */
      this.id = `igx-carousel-${NEXT_ID$g++}`;
      /**
       * Returns the `role` attribute of the carousel.
       * ```typescript
       * let carouselRole =  this.carousel.role;
       * ```
       *
       * @memberof IgxCarouselComponent
       */
      this.role = 'region';
      /** @hidden */
      this.roleDescription = 'carousel';
      /**
       * Returns the class of the carousel component.
       * ```typescript
       * let class =  this.carousel.cssClass;
       * ```
       *
       * @memberof IgxCarouselComponent
       */
      this.cssClass = 'igx-carousel';
      /**
       * Sets whether the carousel should `loop` back to the first slide after reaching the last slide.
       * Default value is `true`.
       * ```html
       * <igx-carousel [loop]="false"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.loop = true;
      /**
       * Sets whether the carousel will `pause` the slide transitions on user interactions.
       * Default value is `true`.
       * ```html
       *  <igx-carousel [pause]="false"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.pause = true;
      /**
       * Controls whether the carousel should render the left/right `navigation` buttons.
       * Default value is `true`.
       * ```html
       * <igx-carousel [navigation]="false"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.navigation = true;
      /**
       * Controls whether the carousel should render the indicators.
       * Default value is `true`.
       * ```html
       * <igx-carousel [indicators]="false"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.indicators = true;
      /**
       * Controls whether the carousel has vertical alignment.
       * Default value is `false`.
       * ```html
       * <igx-carousel [vertical]="true"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.vertical = false;
      /**
       * Controls whether the carousel should support keyboard navigation.
       * Default value is `false`.
       * ```html
       * <igx-carousel [keyboardSupport]="true"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       * @deprecated in version 18.2.0.
       */
      this.keyboardSupport = false;
      /**
       * Controls whether the carousel should support gestures.
       * Default value is `true`.
       * ```html
       * <igx-carousel [gesturesSupport]="false"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.gesturesSupport = true;
      /**
       * Controls the maximum indexes that can be shown.
       * Default value is `10`.
       * ```html
       * <igx-carousel [maximumIndicatorsCount]="5"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.maximumIndicatorsCount = 10;
      /**
       * Gets/sets the display mode of carousel indicators. It can be `start` or `end`.
       * Default value is `end`.
       * ```html
       * <igx-carousel indicatorsOrientation="start">
       * <igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.indicatorsOrientation = CarouselIndicatorsOrientation.end;
      /**
       * Gets/sets the animation type of carousel.
       * Default value is `slide`.
       * ```html
       * <igx-carousel animationType="none">
       * <igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.animationType = CarouselAnimationType.slide;
      /**
       * The custom template, if any, that should be used when rendering carousel indicators
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.carousel.indicatorTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-carousel #carousel>
       *      ...
       *      <ng-template igxCarouselIndicator let-slide>
       *         <igx-icon *ngIf="slide.active">brightness_7</igx-icon>
       *         <igx-icon *ngIf="!slide.active">brightness_5</igx-icon>
       *      </ng-template>
       *  </igx-carousel>
       * ```
       */
      this.indicatorTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering carousel next button
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.carousel.nextButtonTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-carousel #carousel>
       *      ...
       *      <ng-template igxCarouselNextButton let-disabled>
       *          <button type="button" igxButton="fab" igxRipple="white" [disabled]="disabled">
       *              <igx-icon name="add"></igx-icon>
       *          </button>
       *      </ng-template>
       *  </igx-carousel>
       * ```
       */
      this.nextButtonTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering carousel previous button
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.carousel.prevButtonTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-carousel #carousel>
       *      ...
       *      <ng-template igxCarouselPrevButton let-disabled>
       *          <button type="button" igxButton="fab" igxRipple="white" [disabled]="disabled">
       *              <igx-icon name="remove"></igx-icon>
       *          </button>
       *      </ng-template>
       *  </igx-carousel>
       * ```
       */
      this.prevButtonTemplate = null;
      /**
       * An event that is emitted after a slide transition has happened.
       * Provides references to the `IgxCarouselComponent` and `IgxSlideComponent` as event arguments.
       * ```html
       * <igx-carousel (slideChanged)="slideChanged($event)"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.slideChanged = new EventEmitter();
      /**
       * An event that is emitted after a slide has been added to the carousel.
       * Provides references to the `IgxCarouselComponent` and `IgxSlideComponent` as event arguments.
       * ```html
       * <igx-carousel (slideAdded)="slideAdded($event)"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.slideAdded = new EventEmitter();
      /**
       * An event that is emitted after a slide has been removed from the carousel.
       * Provides references to the `IgxCarouselComponent` and `IgxSlideComponent` as event arguments.
       * ```html
       * <igx-carousel (slideRemoved)="slideRemoved($event)"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.slideRemoved = new EventEmitter();
      /**
       * An event that is emitted after the carousel has been paused.
       * Provides a reference to the `IgxCarouselComponent` as an event argument.
       * ```html
       * <igx-carousel (carouselPaused)="carouselPaused($event)"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.carouselPaused = new EventEmitter();
      /**
       * An event that is emitted after the carousel has resumed transitioning between `slides`.
       * Provides a reference to the `IgxCarouselComponent` as an event argument.
       * ```html
       * <igx-carousel (carouselPlaying)="carouselPlaying($event)"></igx-carousel>
       * ```
       *
       * @memberOf IgxCarouselComponent
       */
      this.carouselPlaying = new EventEmitter();
      this._resourceStrings = getCurrentResourceStrings(CarouselResourceStringsEN);
      this.destroy$ = new Subject();
      this.differ = null;
      this._hasKeyboardFocusOnIndicators = false;
      this.differ = this.iterableDiffers.find([]).create(null);
    }
    /** @hidden */
    onKeydownArrowRight(event) {
      if (this.keyboardSupport) {
        event.preventDefault();
        this.next();
        this.focusElement();
      }
    }
    /** @hidden */
    onKeydownArrowLeft(event) {
      if (this.keyboardSupport) {
        event.preventDefault();
        this.prev();
        this.focusElement();
      }
    }
    /** @hidden */
    onTap(event) {
      // play pause only when tap on slide
      if (event.target && event.target.classList.contains('igx-slide')) {
        if (this.isPlaying) {
          if (this.pause) {
            this.stoppedByInteraction = true;
          }
          this.stop();
        } else if (this.stoppedByInteraction) {
          this.play();
        }
      }
    }
    /** @hidden */
    onKeydownHome(event) {
      if (this.keyboardSupport && this.slides.length > 0) {
        event.preventDefault();
        this.slides.first.active = true;
        this.focusElement();
      }
    }
    /** @hidden */
    onKeydownEnd(event) {
      if (this.keyboardSupport && this.slides.length > 0) {
        event.preventDefault();
        this.slides.last.active = true;
        this.focusElement();
      }
    }
    /** @hidden */
    onMouseEnter() {
      if (this.pause && this.isPlaying) {
        this.stoppedByInteraction = true;
      }
      this.stop();
    }
    /** @hidden */
    onMouseLeave() {
      if (this.stoppedByInteraction) {
        this.play();
      }
    }
    /** @hidden */
    onPanLeft(event) {
      if (!this.vertical) {
        this.pan(event);
      }
    }
    /** @hidden */
    onPanRight(event) {
      if (!this.vertical) {
        this.pan(event);
      }
    }
    /** @hidden */
    onPanUp(event) {
      if (this.vertical) {
        this.pan(event);
      }
    }
    /** @hidden */
    onPanDown(event) {
      if (this.vertical) {
        this.pan(event);
      }
    }
    /**
     * @hidden
     */
    onPanEnd(event) {
      if (!this.gesturesSupport) {
        return;
      }
      event.preventDefault();
      const slideSize = this.vertical ? this.currentItem.nativeElement.offsetHeight : this.currentItem.nativeElement.offsetWidth;
      const panOffset = slideSize / 1000;
      const eventDelta = this.vertical ? event.deltaY : event.deltaX;
      const delta = Math.abs(eventDelta) + panOffset < slideSize ? Math.abs(eventDelta) : slideSize - panOffset;
      const velocity = Math.abs(event.velocity);
      this.resetSlideStyles(this.currentItem);
      if (this.incomingSlide) {
        this.resetSlideStyles(this.incomingSlide);
        if (slideSize / 2 < delta || velocity > 1) {
          this.incomingSlide.direction = eventDelta < 0 ? Direction.NEXT : Direction.PREV;
          this.incomingSlide.previous = false;
          this.animationPosition = this.animationType === CarouselAnimationType.fade ? delta / slideSize : (slideSize - delta) / slideSize;
          if (velocity > 1) {
            this.newDuration = this.defaultAnimationDuration / velocity;
          }
          this.incomingSlide.active = true;
        } else {
          this.currentItem.direction = eventDelta > 0 ? Direction.NEXT : Direction.PREV;
          this.previousItem = this.incomingSlide;
          this.previousItem.previous = true;
          this.animationPosition = this.animationType === CarouselAnimationType.fade ? Math.abs((slideSize - delta) / slideSize) : delta / slideSize;
          this.playAnimations();
        }
      }
      if (this.stoppedByInteraction) {
        this.play();
      }
    }
    /** @hidden */
    ngAfterContentInit() {
      this.slides.changes.pipe(takeUntil(this.destroy$)).subscribe(change => this.initSlides(change));
      this.initSlides(this.slides);
    }
    /** @hidden */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
      this.destroyed = true;
      if (this.lastInterval) {
        clearInterval(this.lastInterval);
      }
    }
    /** @hidden */
    handleKeydownPrev(event) {
      if (this.platformUtil.isActivationKey(event)) {
        event.preventDefault();
        this.prev();
      }
    }
    /** @hidden */
    handleKeydownNext(event) {
      if (this.platformUtil.isActivationKey(event)) {
        event.preventDefault();
        this.next();
      }
    }
    /** @hidden */
    handleKeyUp(event) {
      if (event.key === this.platformUtil.KEYMAP.TAB) {
        this._hasKeyboardFocusOnIndicators = true;
      }
    }
    /** @hidden */
    handleFocusOut(event) {
      const target = event.relatedTarget;
      if (!target || !target.classList.contains('igx-carousel-indicators__indicator')) {
        this._hasKeyboardFocusOnIndicators = false;
      }
    }
    /** @hidden */
    handleClick() {
      this._hasKeyboardFocusOnIndicators = false;
    }
    /** @hidden */
    handleKeydown(event) {
      if (this.keyboardSupport) {
        return;
      }
      const {
        key
      } = event;
      const slides = this.slides.toArray();
      switch (key) {
        case this.platformUtil.KEYMAP.ARROW_LEFT:
          this.dir.rtl ? this.next() : this.prev();
          break;
        case this.platformUtil.KEYMAP.ARROW_RIGHT:
          this.dir.rtl ? this.prev() : this.next();
          break;
        case this.platformUtil.KEYMAP.HOME:
          event.preventDefault();
          this.select(this.dir.rtl ? last$1(slides) : first$1(slides));
          break;
        case this.platformUtil.KEYMAP.END:
          event.preventDefault();
          this.select(this.dir.rtl ? first$1(slides) : last$1(slides));
          break;
      }
      this.indicatorsElements[this.current].nativeElement.focus();
    }
    /**
     * Returns the slide corresponding to the provided `index` or null.
     * ```typescript
     * let slide1 =  this.carousel.get(1);
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    get(index) {
      return this.slides.find(slide => slide.index === index);
    }
    /**
     * Adds a new slide to the carousel.
     * ```typescript
     * this.carousel.add(newSlide);
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    add(slide) {
      const newSlides = this.slides.toArray();
      newSlides.push(slide);
      this.slides.reset(newSlides);
      this.slides.notifyOnChanges();
    }
    /**
     * Removes a slide from the carousel.
     * ```typescript
     * this.carousel.remove(slide);
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    remove(slide) {
      if (slide && slide === this.get(slide.index)) {
        // check if the requested slide for delete is present in the carousel
        const newSlides = this.slides.toArray();
        newSlides.splice(slide.index, 1);
        this.slides.reset(newSlides);
        this.slides.notifyOnChanges();
      }
    }
    /**
     * Kicks in a transition for a given slide with a given `direction`.
     * ```typescript
     * this.carousel.select(this.carousel.get(2), Direction.NEXT);
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    select(slide, direction = Direction.NONE) {
      if (slide && slide !== this.currentItem) {
        slide.direction = direction;
        slide.active = true;
      }
    }
    /**
     * Transitions to the next slide in the carousel.
     * ```typescript
     * this.carousel.next();
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    next() {
      const index = this.getNextIndex();
      if (index === 0 && !this.loop) {
        this.stop();
        return;
      }
      return this.select(this.get(index), Direction.NEXT);
    }
    /**
     * Transitions to the previous slide in the carousel.
     * ```typescript
     * this.carousel.prev();
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    prev() {
      const index = this.getPrevIndex();
      if (!this.loop && index === this.total - 1) {
        this.stop();
        return;
      }
      return this.select(this.get(index), Direction.PREV);
    }
    /**
     * Resumes playing of the carousel if in paused state.
     * No operation otherwise.
     * ```typescript
     * this.carousel.play();
     * }
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    play() {
      if (!this.playing) {
        this.playing = true;
        this.carouselPlaying.emit(this);
        this.restartInterval();
        this.stoppedByInteraction = false;
      }
    }
    /**
     * Stops slide transitions if the `pause` option is set to `true`.
     * No operation otherwise.
     * ```typescript
     *  this.carousel.stop();
     * }
     * ```
     *
     * @memberOf IgxCarouselComponent
     */
    stop() {
      if (this.pause) {
        this.playing = false;
        this.carouselPaused.emit(this);
        this.resetInterval();
      }
    }
    getPreviousElement() {
      return this.previousItem.nativeElement;
    }
    getCurrentElement() {
      return this.currentItem.nativeElement;
    }
    resetInterval() {
      if (this.lastInterval) {
        clearInterval(this.lastInterval);
        this.lastInterval = null;
      }
    }
    restartInterval() {
      this.resetInterval();
      if (!isNaN(this.interval) && this.interval > 0 && this.platformUtil.isBrowser) {
        this.lastInterval = setInterval(() => {
          const tick = +this.interval;
          if (this.playing && this.total && !isNaN(tick) && tick > 0) {
            this.next();
          } else {
            this.stop();
          }
        }, this.interval);
      }
    }
    /** @hidden */
    get nextButtonDisabled() {
      return !this.loop && this.current === this.total - 1;
    }
    /** @hidden */
    get prevButtonDisabled() {
      return !this.loop && this.current === 0;
    }
    get indicatorsElements() {
      return this._indicators.toArray();
    }
    focusElement() {
      const focusedElement = this.document.activeElement;
      if (focusedElement.classList.contains('igx-carousel-indicators__indicator')) {
        this.indicatorsElements[this.current].nativeElement.focus();
      } else {
        this.focusSlideElement();
      }
    }
    getIndicatorsClass() {
      switch (this.indicatorsOrientation) {
        case CarouselIndicatorsOrientation.top:
          return CarouselIndicatorsOrientation.start;
        case CarouselIndicatorsOrientation.bottom:
          return CarouselIndicatorsOrientation.end;
        default:
          return this.indicatorsOrientation;
      }
    }
    getNextIndex() {
      return (this.current + 1) % this.total;
    }
    getPrevIndex() {
      return this.current - 1 < 0 ? this.total - 1 : this.current - 1;
    }
    resetSlideStyles(slide) {
      slide.nativeElement.style.transform = '';
      slide.nativeElement.style.opacity = '';
    }
    pan(event) {
      const slideSize = this.vertical ? this.currentItem.nativeElement.offsetHeight : this.currentItem.nativeElement.offsetWidth;
      const panOffset = slideSize / 1000;
      const delta = this.vertical ? event.deltaY : event.deltaX;
      const index = delta < 0 ? this.getNextIndex() : this.getPrevIndex();
      const offset = delta < 0 ? slideSize + delta : -slideSize + delta;
      if (!this.gesturesSupport || event.isFinal || Math.abs(delta) + panOffset >= slideSize) {
        return;
      }
      if (!this.loop && (this.current === 0 && delta > 0 || this.current === this.total - 1 && delta < 0)) {
        this.incomingSlide = null;
        return;
      }
      event.preventDefault();
      if (this.isPlaying) {
        this.stoppedByInteraction = true;
        this.stop();
      }
      if (this.previousItem && this.previousItem.previous) {
        this.previousItem.previous = false;
      }
      this.finishAnimations();
      if (this.incomingSlide) {
        if (index !== this.incomingSlide.index) {
          this.resetSlideStyles(this.incomingSlide);
          this.incomingSlide.previous = false;
          this.incomingSlide = this.get(index);
        }
      } else {
        this.incomingSlide = this.get(index);
      }
      this.incomingSlide.previous = true;
      if (this.animationType === CarouselAnimationType.fade) {
        this.currentItem.nativeElement.style.opacity = `${Math.abs(offset) / slideSize}`;
      } else {
        this.currentItem.nativeElement.style.transform = this.vertical ? `translateY(${delta}px)` : `translateX(${delta}px)`;
        this.incomingSlide.nativeElement.style.transform = this.vertical ? `translateY(${offset}px)` : `translateX(${offset}px)`;
      }
    }
    unsubscriber(slide) {
      return merge(this.destroy$, slide.isDestroyed);
    }
    onSlideActivated(slide) {
      if (slide.active && slide !== this.currentItem) {
        if (slide.direction === Direction.NONE) {
          const newIndex = slide.index;
          slide.direction = newIndex > this.current ? Direction.NEXT : Direction.PREV;
        }
        if (this.currentItem) {
          if (this.previousItem && this.previousItem.previous) {
            this.previousItem.previous = false;
          }
          this.currentItem.direction = slide.direction;
          this.currentItem.active = false;
          this.previousItem = this.currentItem;
          this.currentItem = slide;
          this.triggerAnimations();
        } else {
          this.currentItem = slide;
        }
        this.slideChanged.emit({
          carousel: this,
          slide
        });
        this.restartInterval();
        this.cdr.markForCheck();
      }
    }
    finishAnimations() {
      if (this.animationStarted(this.leaveAnimationPlayer)) {
        this.leaveAnimationPlayer.finish();
      }
      if (this.animationStarted(this.enterAnimationPlayer)) {
        this.enterAnimationPlayer.finish();
      }
    }
    initSlides(change) {
      const diff = this.differ.diff(change.toArray());
      if (diff) {
        this.slides.reduce((any, c, ind) => c.index = ind, 0); // reset slides indexes
        diff.forEachAddedItem(record => {
          const slide = record.item;
          slide.total = this.total;
          this.slideAdded.emit({
            carousel: this,
            slide
          });
          if (slide.active) {
            this.currentItem = slide;
          }
          slide.activeChange.pipe(takeUntil(this.unsubscriber(slide))).subscribe(() => this.onSlideActivated(slide));
        });
        diff.forEachRemovedItem(record => {
          const slide = record.item;
          this.slideRemoved.emit({
            carousel: this,
            slide
          });
          if (slide.active) {
            slide.active = false;
            this.currentItem = this.get(slide.index < this.total ? slide.index : this.total - 1);
          }
        });
        this.updateSlidesSelection();
      }
    }
    updateSlidesSelection() {
      if (this.platformUtil.isBrowser) {
        requestAnimationFrame(() => {
          if (this.currentItem) {
            this.currentItem.active = true;
            const activeSlides = this.slides.filter(slide => slide.active && slide.index !== this.currentItem.index);
            activeSlides.forEach(slide => slide.active = false);
          } else if (this.total) {
            this.slides.first.active = true;
          }
          this.play();
        });
      }
    }
    focusSlideElement() {
      if (this.leaveAnimationPlayer) {
        this.leaveAnimationPlayer.animationEnd.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.slides.find(s => s.active).nativeElement.focus();
        });
      } else {
        requestAnimationFrame(() => this.slides.find(s => s.active).nativeElement.focus());
      }
    }
    static {
      this.ɵfac = function IgxCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCarouselComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxDirectionality), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCarouselComponent,
        selectors: [["igx-carousel"]],
        contentQueries: function IgxCarouselComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxCarouselIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxCarouselNextButtonDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxCarouselPrevButtonDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSlideComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextButtonTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevButtonTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slides = _t);
          }
        },
        viewQuery: function IgxCarouselComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c45, 7, TemplateRef);
            i0.ɵɵviewQuery(_c46, 7, TemplateRef);
            i0.ɵɵviewQuery(_c47, 7, TemplateRef);
            i0.ɵɵviewQuery(_c48, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultIndicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultNextButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultPrevButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._indicators = _t);
          }
        },
        hostVars: 10,
        hostBindings: function IgxCarouselComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.arrowright", function IgxCarouselComponent_keydown_arrowright_HostBindingHandler($event) {
              return ctx.onKeydownArrowRight($event);
            })("keydown.arrowleft", function IgxCarouselComponent_keydown_arrowleft_HostBindingHandler($event) {
              return ctx.onKeydownArrowLeft($event);
            })("tap", function IgxCarouselComponent_tap_HostBindingHandler($event) {
              return ctx.onTap($event);
            })("keydown.home", function IgxCarouselComponent_keydown_home_HostBindingHandler($event) {
              return ctx.onKeydownHome($event);
            })("keydown.end", function IgxCarouselComponent_keydown_end_HostBindingHandler($event) {
              return ctx.onKeydownEnd($event);
            })("mouseenter", function IgxCarouselComponent_mouseenter_HostBindingHandler() {
              return ctx.onMouseEnter();
            })("mouseleave", function IgxCarouselComponent_mouseleave_HostBindingHandler() {
              return ctx.onMouseLeave();
            })("panleft", function IgxCarouselComponent_panleft_HostBindingHandler($event) {
              return ctx.onPanLeft($event);
            })("panright", function IgxCarouselComponent_panright_HostBindingHandler($event) {
              return ctx.onPanRight($event);
            })("panup", function IgxCarouselComponent_panup_HostBindingHandler($event) {
              return ctx.onPanUp($event);
            })("pandown", function IgxCarouselComponent_pandown_HostBindingHandler($event) {
              return ctx.onPanDown($event);
            })("panend", function IgxCarouselComponent_panend_HostBindingHandler($event) {
              return ctx.onPanEnd($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role)("aria-roledescription", ctx.roleDescription)("aria-labelledby", ctx.labelId);
            i0.ɵɵstyleProp("touch-action", ctx.touchAction);
            i0.ɵɵclassProp("igx-carousel--vertical", ctx.isVertical)("igx-carousel", ctx.cssClass);
          }
        },
        inputs: {
          id: "id",
          loop: [2, "loop", "loop", booleanAttribute],
          pause: [2, "pause", "pause", booleanAttribute],
          navigation: [2, "navigation", "navigation", booleanAttribute],
          indicators: [2, "indicators", "indicators", booleanAttribute],
          vertical: [2, "vertical", "vertical", booleanAttribute],
          keyboardSupport: [2, "keyboardSupport", "keyboardSupport", booleanAttribute],
          gesturesSupport: [2, "gesturesSupport", "gesturesSupport", booleanAttribute],
          maximumIndicatorsCount: "maximumIndicatorsCount",
          indicatorsOrientation: "indicatorsOrientation",
          animationType: "animationType",
          resourceStrings: "resourceStrings",
          interval: "interval"
        },
        outputs: {
          slideChanged: "slideChanged",
          slideAdded: "slideAdded",
          slideRemoved: "slideRemoved",
          carouselPaused: "carouselPaused",
          carouselPlaying: "carouselPlaying"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: HAMMER_GESTURE_CONFIG,
          useClass: CarouselHammerConfig
        }, {
          provide: IGX_CAROUSEL_COMPONENT,
          useExisting: IgxCarouselComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 12,
        vars: 5,
        consts: [["defaultIndicator", ""], ["defaultNextButton", ""], ["defaultPrevButton", ""], ["indicators", ""], ["igxButton", "", 1, "igx-carousel__arrow--prev", 3, "disabled"], ["igxButton", "", 1, "igx-carousel__arrow--next", 3, "disabled"], [3, "ngClass"], [1, "igx-carousel-label-indicator", 3, "ngClass"], [1, "igx-carousel__inner"], [1, "igx-nav-dot"], ["aria-hidden", "true", "family", "default", "name", "carousel_next", 1, "igx-nav-arrow"], ["aria-hidden", "true", "family", "default", "name", "carousel_prev", 1, "igx-nav-arrow"], ["igxButton", "", 1, "igx-carousel__arrow--prev", 3, "click", "keydown", "disabled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["igxButton", "", 1, "igx-carousel__arrow--next", 3, "click", "keydown", "disabled"], [3, "keyup", "focusout", "click", "keydown", "ngClass"], [1, "igx-carousel-indicators__indicator", 3, "id"], [1, "igx-carousel-indicators__indicator", 3, "click", "id"], [1, "igx-carousel__label", 3, "id"]],
        template: function IgxCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxCarouselComponent_ng_template_0_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxCarouselComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxCarouselComponent_ng_template_4_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxCarouselComponent_Conditional_6_Template, 2, 6, "button", 4)(7, IgxCarouselComponent_Conditional_7_Template, 2, 6, "button", 5)(8, IgxCarouselComponent_Conditional_8_Template, 3, 2, "div", 6)(9, IgxCarouselComponent_Conditional_9_Template, 3, 3, "div", 7);
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵprojection(11);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵconditional(ctx.navigation && ctx.slides.length ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.navigation && ctx.slides.length ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showIndicators ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showIndicatorsLabel ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-live", !ctx.interval || ctx.stoppedByInteraction ? "polite" : "off");
          }
        },
        dependencies: [IgxButtonDirective, IgxIconComponent, NgClass, NgTemplateOutlet],
        styles: ["[_nghost-%COMP%]{display:block;outline-style:none}"]
      });
    }
  }
  return IgxCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Carousel directives collection for ease-of-use import in standalone components scenario */
const IGX_CAROUSEL_DIRECTIVES = [IgxCarouselComponent, IgxSlideComponent, IgxCarouselIndicatorDirective, IgxCarouselNextButtonDirective, IgxCarouselPrevButtonDirective];
const ChipResourceStringsEN = {
  igx_chip_remove: 'remove chip',
  igx_chip_select: 'select chip'
};
const IgxChipTypeVariant = /*@__PURE__*/mkenum({
  PRIMARY: 'primary',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
});
let CHIP_ID = 0;
/**
 * Chip is compact visual component that displays information in an obround.
 *
 * @igxModule IgxChipsModule
 *
 * @igxTheme igx-chip-theme
 *
 * @igxKeywords chip
 *
 * @igxGroup display
 *
 * @remarks
 * The Ignite UI Chip can be templated, deleted, and selected.
 * Multiple chips can be reordered and visually connected to each other.
 * Chips reside in a container called chips area which is responsible for managing the interactions between the chips.
 *
 * @example
 * ```html
 * <igx-chip class="chipStyle" [id]="901" [draggable]="true" [removable]="true" (remove)="chipRemoved($event)">
 *    <igx-avatar class="chip-avatar-resized" igxPrefix></igx-avatar>
 * </igx-chip>
 * ```
 */
let IgxChipComponent = /*#__PURE__*/(() => {
  class IgxChipComponent {
    /**
     * Sets the value of `tabindex` attribute. If not provided it will use the element's tabindex if set.
     *
     * @example
     * ```html
     * <igx-chip [id]="'igx-chip-1'" [tabIndex]="1"></igx-chip>
     * ```
     */
    set tabIndex(value) {
      this._tabIndex = value;
    }
    get tabIndex() {
      if (this._tabIndex !== null) {
        return this._tabIndex;
      }
      return !this.disabled ? 0 : null;
    }
    /**
     * Sets the `IgxChipComponent` selected state.
     *
     * @example
     * ```html
     * <igx-chip #myChip [id]="'igx-chip-1'" [selectable]="true" [selected]="true">
     * ```
     *
     * Two-way data binding:
     * ```html
     * <igx-chip #myChip [id]="'igx-chip-1'" [selectable]="true" [(selected)]="model.isSelected">
     * ```
     */
    set selected(newValue) {
      this.changeSelection(newValue);
    }
    /**
     * Returns if the `IgxChipComponent` is selected.
     *
     * @example
     * ```typescript
     * @ViewChild('myChip')
     * public chip: IgxChipComponent;
     * selectedChip(){
     *     let selectedChip = this.chip.selected;
     * }
     * ```
     */
    get selected() {
      return this._selected;
    }
    /**
     * Sets the `IgxChipComponent` background color.
     * The `color` property supports string, rgb, hex.
     *
     * @example
     * ```html
     * <igx-chip #myChip [id]="'igx-chip-1'" [color]="'#ff0000'"></igx-chip>
     * ```
     */
    set color(newColor) {
      this.chipArea.nativeElement.style.backgroundColor = newColor;
    }
    /**
     * Returns the background color of the `IgxChipComponent`.
     *
     * @example
     * ```typescript
     * @ViewChild('myChip')
     * public chip: IgxChipComponent;
     * ngAfterViewInit(){
     *     let chipColor = this.chip.color;
     * }
     * ```
     */
    get color() {
      return this.chipArea.nativeElement.style.backgroundColor;
    }
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    get isPrimary() {
      return this.variant === IgxChipTypeVariant.PRIMARY;
    }
    get isInfo() {
      return this.variant === IgxChipTypeVariant.INFO;
    }
    get isSuccess() {
      return this.variant === IgxChipTypeVariant.SUCCESS;
    }
    get isWarning() {
      return this.variant === IgxChipTypeVariant.WARNING;
    }
    get isDanger() {
      return this.variant === IgxChipTypeVariant.DANGER;
    }
    /**
     * @hidden
     * @internal
     */
    get removeButtonTemplate() {
      if (!this.disabled) {
        return this.removeIcon || this.defaultRemoveIcon;
      }
    }
    /**
     * @hidden
     * @internal
     */
    get selectIconTemplate() {
      return this.selectIcon || this.defaultSelectIcon;
    }
    /**
     * @hidden
     * @internal
     */
    get ghostStyles() {
      return {
        '--ig-size': `${this.chipSize}`
      };
    }
    /** @hidden @internal */
    get nativeElement() {
      return this.ref.nativeElement;
    }
    get chipSize() {
      return this.computedStyles?.getPropertyValue('--ig-size') || Size.Medium;
    }
    constructor(cdr, ref, renderer, document) {
      this.cdr = cdr;
      this.ref = ref;
      this.renderer = renderer;
      this.document = document;
      /**
       * Sets the value of `id` attribute. If not provided it will be automatically generated.
       *
       * @example
       * ```html
       * <igx-chip [id]="'igx-chip-1'"></igx-chip>
       * ```
       */
      this.id = `igx-chip-${CHIP_ID++}`;
      /**
       * Returns the `role` attribute of the chip.
       *
       * @example
       * ```typescript
       * let chipRole = this.chip.role;
       * ```
       */
      this.role = 'option';
      /**
       * Defines if the `IgxChipComponent` can be dragged in order to change it's position.
       * By default it is set to false.
       *
       * @example
       * ```html
       * <igx-chip [id]="'igx-chip-1'" [draggable]="true"></igx-chip>
       * ```
       */
      this.draggable = false;
      /**
       * Enables/disables the draggable element animation when the element is released.
       * By default it's set to true.
       *
       * @example
       * ```html
       * <igx-chip [id]="'igx-chip-1'" [draggable]="true" [animateOnRelease]="false"></igx-chip>
       * ```
       */
      this.animateOnRelease = true;
      /**
       * Enables/disables the hiding of the base element that has been dragged.
       * By default it's set to true.
       *
       * @example
       * ```html
       * <igx-chip [id]="'igx-chip-1'" [draggable]="true" [hideBaseOnDrag]="false"></igx-chip>
       * ```
       */
      this.hideBaseOnDrag = true;
      /**
       * Defines if the `IgxChipComponent` should render remove button and throw remove events.
       * By default it is set to false.
       *
       * @example
       * ```html
       * <igx-chip [id]="'igx-chip-1'" [draggable]="true" [removable]="true"></igx-chip>
       * ```
       */
      this.removable = false;
      /**
       * Defines if the `IgxChipComponent` can be selected on click or through navigation,
       * By default it is set to false.
       *
       * @example
       * ```html
       * <igx-chip [id]="chip.id" [draggable]="true" [removable]="true" [selectable]="true"></igx-chip>
       * ```
       */
      this.selectable = false;
      /**
       * @hidden
       * @internal
       */
      this.class = '';
      /**
       * Disables the `IgxChipComponent`. When disabled it restricts user interactions
       * like focusing on click or tab, selection on click or Space, dragging.
       * By default it is set to false.
       *
       * @example
       * ```html
       * <igx-chip [id]="chip.id" [disabled]="true"></igx-chip>
       * ```
       */
      this.disabled = false;
      /**
       * @hidden
       * @internal
       */
      this.selectedChange = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` moving starts.
       * Returns the moving `IgxChipComponent`.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (moveStart)="moveStarted($event)">
       * ```
       */
      this.moveStart = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` moving ends.
       * Returns the moved `IgxChipComponent`.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (moveEnd)="moveEnded($event)">
       * ```
       */
      this.moveEnd = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` is removed.
       * Returns the removed `IgxChipComponent`.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (remove)="remove($event)">
       * ```
       */
      this.remove = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` is clicked.
       * Returns the clicked `IgxChipComponent`, whether the event should be canceled.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (click)="chipClick($event)">
       * ```
       */
      this.chipClick = new EventEmitter();
      /**
       * Emits event when the `IgxChipComponent` is selected/deselected.
       * Returns the selected chip reference, whether the event should be canceled, what is the next selection state and
       * when the event is triggered by interaction `originalEvent` is provided, otherwise `originalEvent` is `null`.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [selectable]="true" (selectedChanging)="chipSelect($event)">
       * ```
       */
      this.selectedChanging = new EventEmitter();
      /**
       * Emits event when the `IgxChipComponent` is selected/deselected and any related animations and transitions also end.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [selectable]="true" (selectedChanged)="chipSelectEnd($event)">
       * ```
       */
      this.selectedChanged = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` keyboard navigation is being used.
       * Returns the focused/selected `IgxChipComponent`, whether the event should be canceled,
       * if the `alt`, `shift` or `control` key is pressed and the pressed key name.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (keyDown)="chipKeyDown($event)">
       * ```
       */
      this.keyDown = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` has entered the `IgxChipsAreaComponent`.
       * Returns the target `IgxChipComponent`, the drag `IgxChipComponent`, as  well as
       * the original drop event arguments.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (dragEnter)="chipEnter($event)">
       * ```
       */
      this.dragEnter = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` has left the `IgxChipsAreaComponent`.
       * Returns the target `IgxChipComponent`, the drag `IgxChipComponent`, as  well as
       * the original drop event arguments.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (dragLeave)="chipLeave($event)">
       * ```
       */
      this.dragLeave = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` is over the `IgxChipsAreaComponent`.
       * Returns the target `IgxChipComponent`, the drag `IgxChipComponent`, as  well as
       * the original drop event arguments.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (dragOver)="chipOver($event)">
       * ```
       */
      this.dragOver = new EventEmitter();
      /**
       * Emits an event when the `IgxChipComponent` has been dropped in the `IgxChipsAreaComponent`.
       * Returns the target `IgxChipComponent`, the drag `IgxChipComponent`, as  well as
       * the original drop event arguments.
       *
       * @example
       * ```html
       * <igx-chip #myChip [id]="'igx-chip-1'" [draggable]="true" (dragDrop)="chipLeave($event)">
       * ```
       */
      this.dragDrop = new EventEmitter();
      this.defaultClass = 'igx-chip';
      /**
       * @hidden
       * @internal
       */
      this.hideBaseElement = false;
      /**
       * @hidden
       * @internal
       */
      this.destroy$ = new Subject();
      this._tabIndex = null;
      this._selected = false;
      this._selectedItemClass = 'igx-chip__item--selected';
      this._movedWhileRemoving = false;
      this._resourceStrings = getCurrentResourceStrings(ChipResourceStringsEN);
    }
    /**
     * @hidden
     * @internal
     */
    keyEvent(event) {
      this.onChipKeyDown(event);
    }
    /**
     * @hidden
     * @internal
     */
    selectClass(condition) {
      const SELECT_CLASS = 'igx-chip__select';
      return {
        [SELECT_CLASS]: condition,
        [`${SELECT_CLASS}--hidden`]: !condition
      };
    }
    onSelectTransitionDone(event) {
      if (event.target.tagName) {
        // Trigger onSelectionDone on when `width` property is changed and the target is valid element(not comment).
        this.selectedChanged.emit({
          owner: this,
          originalEvent: event
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    onChipKeyDown(event) {
      const keyDownArgs = {
        originalEvent: event,
        owner: this,
        cancel: false
      };
      this.keyDown.emit(keyDownArgs);
      if (keyDownArgs.cancel) {
        return;
      }
      if ((event.key === 'Delete' || event.key === 'Del') && this.removable) {
        this.remove.emit({
          originalEvent: event,
          owner: this
        });
      }
      if ((event.key === ' ' || event.key === 'Spacebar') && this.selectable && !this.disabled) {
        this.changeSelection(!this.selected, event);
      }
      if (event.key !== 'Tab') {
        event.preventDefault();
      }
    }
    /**
     * @hidden
     * @internal
     */
    onRemoveBtnKeyDown(event) {
      if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
        this.remove.emit({
          originalEvent: event,
          owner: this
        });
        event.preventDefault();
        event.stopPropagation();
      }
    }
    onRemoveMouseDown(event) {
      event.stopPropagation();
    }
    /**
     * @hidden
     * @internal
     */
    onRemoveClick(event) {
      this.remove.emit({
        originalEvent: event,
        owner: this
      });
    }
    /**
     * @hidden
     * @internal
     */
    onRemoveTouchMove() {
      // We don't remove chip if user starting touch interacting on the remove button moves the chip
      this._movedWhileRemoving = true;
    }
    /**
     * @hidden
     * @internal
     */
    onRemoveTouchEnd(event) {
      if (!this._movedWhileRemoving) {
        this.onRemoveClick(event);
      }
      this._movedWhileRemoving = false;
    }
    /**
     * @hidden
     * @internal
     */
    // -----------------------------
    // Start chip igxDrag behavior
    onChipDragStart(event) {
      this.moveStart.emit({
        originalEvent: event,
        owner: this
      });
      event.cancel = !this.draggable || this.disabled;
    }
    /**
     * @hidden
     * @internal
     */
    onChipDragEnd() {
      if (this.animateOnRelease) {
        this.dragDirective.transitionToOrigin();
      }
    }
    /**
     * @hidden
     * @internal
     */
    onChipMoveEnd(event) {
      // moveEnd is triggered after return animation has finished. This happen when we drag and release the chip.
      this.moveEnd.emit({
        originalEvent: event,
        owner: this
      });
      if (this.selected) {
        this.chipArea.nativeElement.focus();
      }
    }
    /**
     * @hidden
     * @internal
     */
    onChipGhostCreate() {
      this.hideBaseElement = this.hideBaseOnDrag;
    }
    /**
     * @hidden
     * @internal
     */
    onChipGhostDestroy() {
      this.hideBaseElement = false;
    }
    /**
     * @hidden
     * @internal
     */
    onChipDragClicked(event) {
      const clickEventArgs = {
        originalEvent: event,
        owner: this,
        cancel: false
      };
      this.chipClick.emit(clickEventArgs);
      if (!clickEventArgs.cancel && this.selectable && !this.disabled) {
        this.changeSelection(!this.selected, event);
      }
    }
    // End chip igxDrag behavior
    /**
     * @hidden
     * @internal
     */
    // -----------------------------
    // Start chip igxDrop behavior
    onChipDragEnterHandler(event) {
      if (this.dragDirective === event.drag) {
        return;
      }
      const eventArgs = {
        owner: this,
        dragChip: event.drag.data?.chip,
        originalEvent: event
      };
      this.dragEnter.emit(eventArgs);
    }
    /**
     * @hidden
     * @internal
     */
    onChipDragLeaveHandler(event) {
      if (this.dragDirective === event.drag) {
        return;
      }
      const eventArgs = {
        owner: this,
        dragChip: event.drag.data?.chip,
        originalEvent: event
      };
      this.dragLeave.emit(eventArgs);
    }
    /**
     * @hidden
     * @internal
     */
    onChipDrop(event) {
      // Cancel the default drop logic
      event.cancel = true;
      if (this.dragDirective === event.drag) {
        return;
      }
      const eventArgs = {
        owner: this,
        dragChip: event.drag.data?.chip,
        originalEvent: event
      };
      this.dragDrop.emit(eventArgs);
    }
    /**
     * @hidden
     * @internal
     */
    onChipOverHandler(event) {
      if (this.dragDirective === event.drag) {
        return;
      }
      const eventArgs = {
        owner: this,
        dragChip: event.drag.data?.chip,
        originalEvent: event
      };
      this.dragOver.emit(eventArgs);
    }
    // End chip igxDrop behavior
    changeSelection(newValue, srcEvent = null) {
      const onSelectArgs = {
        originalEvent: srcEvent,
        owner: this,
        selected: false,
        cancel: false
      };
      if (newValue && !this._selected) {
        onSelectArgs.selected = true;
        this.selectedChanging.emit(onSelectArgs);
        if (!onSelectArgs.cancel) {
          this.renderer.addClass(this.chipArea.nativeElement, this._selectedItemClass);
          this._selected = newValue;
          this.selectedChange.emit(this._selected);
          this.selectedChanged.emit({
            owner: this,
            originalEvent: srcEvent
          });
        }
      } else if (!newValue && this._selected) {
        this.selectedChanging.emit(onSelectArgs);
        if (!onSelectArgs.cancel) {
          this.renderer.removeClass(this.chipArea.nativeElement, this._selectedItemClass);
          this._selected = newValue;
          this.selectedChange.emit(this._selected);
          this.selectedChanged.emit({
            owner: this,
            originalEvent: srcEvent
          });
        }
      }
    }
    ngOnInit() {
      this.computedStyles = this.document.defaultView.getComputedStyle(this.nativeElement);
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function IgxChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxChipComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxChipComponent,
        selectors: [["igx-chip"]],
        viewQuery: function IgxChipComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c49, 7, IgxDragDirective);
            i0.ɵɵviewQuery(_c49, 7, ElementRef);
            i0.ɵɵviewQuery(_c50, 7, TemplateRef);
            i0.ɵɵviewQuery(_c51, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultRemoveIcon = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultSelectIcon = _t.first);
          }
        },
        hostVars: 18,
        hostBindings: function IgxChipComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxChipComponent_keydown_HostBindingHandler($event) {
              return ctx.keyEvent($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role)("tabIndex", ctx.tabIndex)("aria-selected", ctx.selected);
            i0.ɵɵclassProp("igx-chip--disabled", ctx.disabled)("igx-chip", ctx.defaultClass)("igx-chip--primary", ctx.isPrimary)("igx-chip--info", ctx.isInfo)("igx-chip--success", ctx.isSuccess)("igx-chip--warning", ctx.isWarning)("igx-chip--danger", ctx.isDanger);
          }
        },
        inputs: {
          variant: "variant",
          id: "id",
          tabIndex: "tabIndex",
          data: "data",
          draggable: [2, "draggable", "draggable", booleanAttribute],
          animateOnRelease: [2, "animateOnRelease", "animateOnRelease", booleanAttribute],
          hideBaseOnDrag: [2, "hideBaseOnDrag", "hideBaseOnDrag", booleanAttribute],
          removable: [2, "removable", "removable", booleanAttribute],
          removeIcon: "removeIcon",
          selectable: [2, "selectable", "selectable", booleanAttribute],
          selectIcon: "selectIcon",
          class: "class",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          selected: [2, "selected", "selected", booleanAttribute],
          color: "color",
          resourceStrings: "resourceStrings"
        },
        outputs: {
          selectedChange: "selectedChange",
          moveStart: "moveStart",
          moveEnd: "moveEnd",
          remove: "remove",
          chipClick: "chipClick",
          selectedChanging: "selectedChanging",
          selectedChanged: "selectedChanged",
          keyDown: "keyDown",
          dragEnter: "dragEnter",
          dragLeave: "dragLeave",
          dragOver: "dragOver",
          dragDrop: "dragDrop"
        },
        ngContentSelectors: _c53,
        decls: 15,
        vars: 8,
        consts: [["chipArea", ""], ["selectContainer", ""], ["defaultSelectIcon", ""], ["defaultRemoveIcon", ""], ["ghostClass", "igx-chip__ghost", "igxDrop", "", 1, "igx-chip__item", 3, "dragStart", "ghostCreate", "ghostDestroy", "dragEnd", "transitioned", "dragClick", "enter", "leave", "over", "dropped", "igxDrag", "ghostStyle"], [1, "igx-chip__start"], [3, "ngClass"], [1, "igx-chip__content"], [1, "igx-chip__end"], [1, "igx-chip__remove"], [4, "ngTemplateOutlet"], [1, "igx-chip__remove", 3, "keydown", "pointerdown", "mousedown", "click", "touchmove", "touchend"], ["family", "default", "name", "selected"], ["family", "default", "name", "remove"]],
        template: function IgxChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c52);
            i0.ɵɵelementStart(0, "div", 4, 0);
            i0.ɵɵlistener("dragStart", function IgxChipComponent_Template_div_dragStart_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDragStart($event));
            })("ghostCreate", function IgxChipComponent_Template_div_ghostCreate_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipGhostCreate());
            })("ghostDestroy", function IgxChipComponent_Template_div_ghostDestroy_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipGhostDestroy());
            })("dragEnd", function IgxChipComponent_Template_div_dragEnd_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDragEnd());
            })("transitioned", function IgxChipComponent_Template_div_transitioned_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipMoveEnd($event));
            })("dragClick", function IgxChipComponent_Template_div_dragClick_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDragClicked($event));
            })("enter", function IgxChipComponent_Template_div_enter_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDragEnterHandler($event));
            })("leave", function IgxChipComponent_Template_div_leave_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDragLeaveHandler($event));
            })("over", function IgxChipComponent_Template_div_over_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipOverHandler($event));
            })("dropped", function IgxChipComponent_Template_div_dropped_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChipDrop($event));
            });
            i0.ɵɵelementStart(2, "div", 5, 1);
            i0.ɵɵtemplate(4, IgxChipComponent_Conditional_4_Template, 2, 2, "div", 6);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 7);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 8);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵtemplate(10, IgxChipComponent_Conditional_10_Template, 2, 2, "div", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, IgxChipComponent_ng_template_11_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, IgxChipComponent_ng_template_13_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("visibility", ctx.hideBaseElement ? "hidden" : "visible");
            i0.ɵɵproperty("igxDrag", i0.ɵɵpureFunction1(6, _c54, ctx))("ghostStyle", ctx.ghostStyles);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.selected ? 4 : -1);
            i0.ɵɵadvance(6);
            i0.ɵɵconditional(ctx.removable ? 10 : -1);
          }
        },
        dependencies: [IgxDropDirective, IgxDragDirective, NgClass, NgTemplateOutlet, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The chip area allows you to perform more complex scenarios with chips that require interaction,
 * like dragging, selection, navigation, etc.
 *
 * @igxModule IgxChipsModule
 *
 * @igxTheme igx-chip-theme
 *
 * @igxKeywords chip area, chip
 *
 * @igxGroup display
 *
 * @example
 * ```html
 * <igx-chips-area>
 *    <igx-chip *ngFor="let chip of chipList" [id]="chip.id">
 *        <span>{{chip.text}}</span>
 *    </igx-chip>
 * </igx-chips-area>
 * ```
 */
let IgxChipsAreaComponent = /*#__PURE__*/(() => {
  class IgxChipsAreaComponent {
    /** @hidden @internal */
    get _widthToRem() {
      return rem(this.width);
    }
    /** @hidden @internal */
    get _heightToRem() {
      return rem(this.height);
    }
    constructor(cdr, element, _iterableDiffers) {
      this.cdr = cdr;
      this.element = element;
      this._iterableDiffers = _iterableDiffers;
      /**
       * Returns the `role` attribute of the chips area.
       *
       * @example
       * ```typescript
       * let chipsAreaRole = this.chipsArea.role;
       * ```
       */
      this.role = 'listbox';
      /**
       * Returns the `aria-label` attribute of the chips area.
       *
       * @example
       * ```typescript
       * let ariaLabel = this.chipsArea.ariaLabel;
       * ```
       *
       */
      this.ariaLabel = 'chip area';
      /**
       * Emits an event when `IgxChipComponent`s in the `IgxChipsAreaComponent` should be reordered.
       * Returns an array of `IgxChipComponent`s.
       *
       * @example
       * ```html
       * <igx-chips-area #chipsArea [width]="'300'" [height]="'10'" (onReorder)="changedOrder($event)"></igx-chips-area>
       * ```
       */
      this.reorder = new EventEmitter();
      /**
       * Emits an event when an `IgxChipComponent` in the `IgxChipsAreaComponent` is selected/deselected.
       * Fired after the chips area is initialized if there are initially selected chips as well.
       * Returns an array of selected `IgxChipComponent`s and the `IgxChipAreaComponent`.
       *
       * @example
       * ```html
       * <igx-chips-area #chipsArea [width]="'300'" [height]="'10'" (selectionChange)="selection($event)"></igx-chips-area>
       * ```
       */
      this.selectionChange = new EventEmitter();
      /**
       * Emits an event when an `IgxChipComponent` in the `IgxChipsAreaComponent` is moved.
       *
       * @example
       * ```html
       * <igx-chips-area #chipsArea [width]="'300'" [height]="'10'" (moveStart)="moveStart($event)"></igx-chips-area>
       * ```
       */
      this.moveStart = new EventEmitter();
      /**
       * Emits an event after an `IgxChipComponent` in the `IgxChipsAreaComponent` is moved.
       *
       * @example
       * ```html
       * <igx-chips-area #chipsArea [width]="'300'" [height]="'10'" (moveEnd)="moveEnd($event)"></igx-chips-area>
       * ```
       */
      this.moveEnd = new EventEmitter();
      this.destroy$ = new Subject();
      this.hostClass = 'igx-chip-area';
      this._differ = null;
      this._differ = this._iterableDiffers.find([]).create(null);
    }
    /**
     * @hidden
     * @internal
     */
    ngAfterViewInit() {
      // If we have initially selected chips through their inputs, we need to get them, because we cannot listen to their events yet.
      if (this.chipsList.length) {
        const selectedChips = this.chipsList.filter(item => item.selected);
        if (selectedChips.length) {
          this.selectionChange.emit({
            originalEvent: null,
            newSelection: selectedChips,
            owner: this
          });
        }
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngDoCheck() {
      if (this.chipsList) {
        const changes = this._differ.diff(this.chipsList.toArray());
        if (changes) {
          changes.forEachAddedItem(addedChip => {
            addedChip.item.moveStart.pipe(takeUntil(addedChip.item.destroy$)).subscribe(args => {
              this.onChipMoveStart(args);
            });
            addedChip.item.moveEnd.pipe(takeUntil(addedChip.item.destroy$)).subscribe(args => {
              this.onChipMoveEnd(args);
            });
            addedChip.item.dragEnter.pipe(takeUntil(addedChip.item.destroy$)).subscribe(args => {
              this.onChipDragEnter(args);
            });
            addedChip.item.keyDown.pipe(takeUntil(addedChip.item.destroy$)).subscribe(args => {
              this.onChipKeyDown(args);
            });
            if (addedChip.item.selectable) {
              addedChip.item.selectedChanging.pipe(takeUntil(addedChip.item.destroy$)).subscribe(args => {
                this.onChipSelectionChange(args);
              });
            }
          });
          this.modifiedChipsArray = this.chipsList.toArray();
        }
      }
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden
     * @internal
     */
    onChipKeyDown(event) {
      let orderChanged = false;
      const chipsArray = this.chipsList.toArray();
      const dragChipIndex = chipsArray.findIndex(el => el === event.owner);
      if (event.originalEvent.shiftKey === true) {
        if (event.originalEvent.key === 'ArrowLeft' || event.originalEvent.key === 'Left') {
          orderChanged = this.positionChipAtIndex(dragChipIndex, dragChipIndex - 1, false, event.originalEvent);
          if (orderChanged) {
            setTimeout(() => {
              this.chipsList.get(dragChipIndex - 1).nativeElement.focus();
            });
          }
        } else if (event.originalEvent.key === 'ArrowRight' || event.originalEvent.key === 'Right') {
          orderChanged = this.positionChipAtIndex(dragChipIndex, dragChipIndex + 1, true, event.originalEvent);
        }
      } else {
        if ((event.originalEvent.key === 'ArrowLeft' || event.originalEvent.key === 'Left') && dragChipIndex > 0) {
          chipsArray[dragChipIndex - 1].nativeElement.focus();
        } else if ((event.originalEvent.key === 'ArrowRight' || event.originalEvent.key === 'Right') && dragChipIndex < chipsArray.length - 1) {
          chipsArray[dragChipIndex + 1].nativeElement.focus();
        }
      }
    }
    /**
     * @hidden
     * @internal
     */
    onChipMoveStart(event) {
      this.moveStart.emit({
        originalEvent: event.originalEvent,
        owner: this
      });
    }
    /**
     * @hidden
     * @internal
     */
    onChipMoveEnd(event) {
      this.moveEnd.emit({
        originalEvent: event.originalEvent,
        owner: this
      });
    }
    /**
     * @hidden
     * @internal
     */
    onChipDragEnter(event) {
      const dropChipIndex = this.chipsList.toArray().findIndex(el => el === event.owner);
      const dragChipIndex = this.chipsList.toArray().findIndex(el => el === event.dragChip);
      if (dragChipIndex < dropChipIndex) {
        // from the left to right
        this.positionChipAtIndex(dragChipIndex, dropChipIndex, true, event.originalEvent);
      } else {
        // from the right to left
        this.positionChipAtIndex(dragChipIndex, dropChipIndex, false, event.originalEvent);
      }
    }
    /**
     * @hidden
     * @internal
     */
    positionChipAtIndex(chipIndex, targetIndex, shiftRestLeft, originalEvent) {
      if (chipIndex < 0 || this.chipsList.length <= chipIndex || targetIndex < 0 || this.chipsList.length <= targetIndex) {
        return false;
      }
      const chipsArray = this.chipsList.toArray();
      const result = [];
      for (let i = 0; i < chipsArray.length; i++) {
        if (shiftRestLeft) {
          if (chipIndex <= i && i < targetIndex) {
            result.push(chipsArray[i + 1]);
          } else if (i === targetIndex) {
            result.push(chipsArray[chipIndex]);
          } else {
            result.push(chipsArray[i]);
          }
        } else {
          if (targetIndex < i && i <= chipIndex) {
            result.push(chipsArray[i - 1]);
          } else if (i === targetIndex) {
            result.push(chipsArray[chipIndex]);
          } else {
            result.push(chipsArray[i]);
          }
        }
      }
      this.modifiedChipsArray = result;
      const eventData = {
        chipsArray: this.modifiedChipsArray,
        originalEvent,
        owner: this
      };
      this.reorder.emit(eventData);
      return true;
    }
    /**
     * @hidden
     * @internal
     */
    onChipSelectionChange(event) {
      let selectedChips = this.chipsList.filter(chip => chip.selected);
      if (event.selected && !selectedChips.includes(event.owner)) {
        selectedChips.push(event.owner);
      } else if (!event.selected && selectedChips.includes(event.owner)) {
        selectedChips = selectedChips.filter(chip => chip.id !== event.owner.id);
      }
      this.selectionChange.emit({
        originalEvent: event.originalEvent,
        newSelection: selectedChips,
        owner: this
      });
    }
    static {
      this.ɵfac = function IgxChipsAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxChipsAreaComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.IterableDiffers));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxChipsAreaComponent,
        selectors: [["igx-chips-area"]],
        contentQueries: function IgxChipsAreaComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxChipComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipsList = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxChipsAreaComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("aria-label", ctx.ariaLabel);
            i0.ɵɵclassMap(ctx.hostClass);
            i0.ɵɵstyleProp("width", ctx._widthToRem, "rem")("height", ctx._heightToRem, "rem");
          }
        },
        inputs: {
          width: "width",
          height: "height"
        },
        outputs: {
          reorder: "reorder",
          selectionChange: "selectionChange",
          moveStart: "moveStart",
          moveEnd: "moveEnd"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxChipsAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxChipsAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Chips directives collection for ease-of-use import in standalone components scenario */
const IGX_CHIPS_DIRECTIVES = [IgxChipsAreaComponent, IgxChipComponent, IgxPrefixDirective, IgxSuffixDirective];

/**
 * @hidden
 */
let IgxComboAPIService = /*#__PURE__*/(() => {
  class IgxComboAPIService {
    constructor() {
      this.disableTransitions = false;
    }
    get valueKey() {
      return this.combo.valueKey !== null && this.combo.valueKey !== undefined ? this.combo.valueKey : null;
    }
    get item_focusable() {
      return false;
    }
    get isRemote() {
      return this.combo.isRemote;
    }
    get comboID() {
      return this.combo.id;
    }
    register(combo) {
      this.combo = combo;
    }
    clear() {
      this.combo = null;
    }
    add_custom_item() {
      if (!this.combo) {
        return;
      }
      this.combo.addItemToCollection();
    }
    set_selected_item(itemID, event) {
      const selected = this.combo.isItemSelected(itemID);
      if (itemID === undefined) {
        return;
      }
      if (!selected) {
        this.combo.select([itemID], false, event);
      } else {
        this.combo.deselect([itemID], event);
      }
    }
    is_item_selected(itemID) {
      return this.combo.isItemSelected(itemID);
    }
    static {
      this.ɵfac = function IgxComboAPIService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboAPIService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxComboAPIService,
        factory: IgxComboAPIService.ɵfac
      });
    }
  }
  return IgxComboAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxComboItemComponent = /*#__PURE__*/(() => {
  class IgxComboItemComponent extends IgxDropDownItemComponent {
    /** @hidden @internal */
    get _itemHeightToRem() {
      if (this.itemHeight) {
        return rem(this.itemHeight);
      }
    }
    get ariaLabel() {
      const valueKey = this.comboAPI.valueKey;
      return valueKey !== null && this.value != null ? this.value[valueKey] : this.value;
    }
    /**
     * @hidden
     */
    get itemID() {
      const valueKey = this.comboAPI.valueKey;
      return valueKey !== null ? this.value[valueKey] : this.value;
    }
    /**
     * @hidden
     */
    get comboID() {
      return this.comboAPI.comboID;
    }
    /**
     * @hidden
     * @internal
     */
    get disableTransitions() {
      return this.comboAPI.disableTransitions;
    }
    constructor(comboAPI, dropDown, elementRef, selection) {
      super(dropDown, elementRef, null, selection);
      this.comboAPI = comboAPI;
      /**
       * Gets the height of a list item
       *
       * @hidden
       */
      this.itemHeight = '';
    }
    /**
     * @hidden
     */
    get selected() {
      return this.comboAPI.is_item_selected(this.itemID);
    }
    set selected(value) {
      if (this.isHeader) {
        return;
      }
      this._selected = value;
    }
    /**
     * @hidden
     */
    isVisible(direction) {
      const rect = this.element.nativeElement.getBoundingClientRect();
      const parentDiv = this.element.nativeElement.parentElement.parentElement.getBoundingClientRect();
      if (direction === Navigate.Down) {
        return rect.y + rect.height <= parentDiv.y + parentDiv.height;
      }
      return rect.y >= parentDiv.y;
    }
    clicked(event) {
      this.comboAPI.disableTransitions = false;
      if (!this.isSelectable) {
        return;
      }
      this.dropDown.navigateItem(this.index);
      this.comboAPI.set_selected_item(this.itemID, event);
    }
    /**
     * @hidden
     * @internal
     * The event that is prevented is the click on the checkbox label element.
     * That is the only visible element that a user can interact with.
     * The click propagates to the host and the preventDefault is to stop it from
     * switching focus to the input it's base on.
     * The toggle happens in an internal handler in the drop-down on the next task queue cycle.
     */
    disableCheck(event) {
      event.preventDefault();
    }
    static {
      this.ɵfac = function IgxComboItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboItemComponent)(i0.ɵɵdirectiveInject(IgxComboAPIService), i0.ɵɵdirectiveInject(IGX_DROPDOWN_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxSelectionAPIService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxComboItemComponent,
        selectors: [["igx-combo-item"]],
        hostVars: 3,
        hostBindings: function IgxComboItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵstyleProp("height", ctx._itemHeightToRem, "rem");
          }
        },
        inputs: {
          itemHeight: "itemHeight",
          ariaLabel: "ariaLabel",
          singleMode: [2, "singleMode", "singleMode", booleanAttribute]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 1,
        consts: [[1, "igx-combo__checkbox", 3, "checked", "readonly", "disableRipple", "disableTransitions", "tabindex"], [1, "igx-drop-down__inner"], [1, "igx-combo__checkbox", 3, "click", "checked", "readonly", "disableRipple", "disableTransitions", "tabindex"]],
        template: function IgxComboItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxComboItemComponent_Conditional_0_Template, 1, 5, "igx-checkbox", 0);
            i0.ɵɵelementStart(1, "span", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isHeader && !ctx.singleMode ? 0 : -1);
          }
        },
        dependencies: [IgxCheckboxComponent],
        encapsulation: 2
      });
    }
  }
  return IgxComboItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Allows a custom element to be added at the beginning of the combo list.
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 * <igx-combo>
 *   <ng-template igxComboHeader>
 *      <div class="header-class">Custom header</div>
 *      <img src=""/>
 *   </ng-template>
 * </igx-combo>
 */
let IgxComboHeaderDirective = /*#__PURE__*/(() => {
  class IgxComboHeaderDirective {
    static {
      this.ɵfac = function IgxComboHeaderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboHeaderDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboHeaderDirective,
        selectors: [["", "igxComboHeader", ""]]
      });
    }
  }
  return IgxComboHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added at the end of the combo list.
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 * <igx-combo>
 *   <ng-template igxComboFooter>
 *      <div class="footer-class">Custom footer</div>
 *      <img src=""/>
 *   </ng-template>
 * </igx-combo>
 */
let IgxComboFooterDirective = /*#__PURE__*/(() => {
  class IgxComboFooterDirective {
    static {
      this.ɵfac = function IgxComboFooterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboFooterDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboFooterDirective,
        selectors: [["", "igxComboFooter", ""]]
      });
    }
  }
  return IgxComboFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows the combo's items to be modified with a custom template
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 * <igx-combo>
 *	<ng-template igxComboItem let-display let-key="valueKey">
 *		<div class="item">
 *			<span class="state">State: {{ display[key] }}</span>
 *	 		<span class="region">Region: {{ display.region }}</span>
 *	 	</div>
 *	 </ng-template>
  * </igx-combo>
 */
let IgxComboItemDirective = /*#__PURE__*/(() => {
  class IgxComboItemDirective {
    static {
      this.ɵfac = function IgxComboItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboItemDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboItemDirective,
        selectors: [["", "igxComboItem", ""]]
      });
    }
  }
  return IgxComboItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the custom template that will be displayed when the combo's list is empty
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 *  <igx-combo>
 *      <ng-template igxComboEmpty>
 *          <div class="combo--empty">
 *              There are no items to display
 *          </div>
 *      </ng-template>
 *  </igx-combo>
 */
let IgxComboEmptyDirective = /*#__PURE__*/(() => {
  class IgxComboEmptyDirective {
    static {
      this.ɵfac = function IgxComboEmptyDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboEmptyDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboEmptyDirective,
        selectors: [["", "igxComboEmpty", ""]]
      });
    }
  }
  return IgxComboEmptyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the custom template that will be used when rendering header items for groups in the combo's list
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 *  <igx-combo>
 *      <ng-template igxComboHeaderItem let-item let-key="groupKey">
 *          <div class="custom-item--group">Group header for {{ item[key] }}</div>
 *      </ng-template>
 *  </igx-combo>
 */
let IgxComboHeaderItemDirective = /*#__PURE__*/(() => {
  class IgxComboHeaderItemDirective {
    static {
      this.ɵfac = function IgxComboHeaderItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboHeaderItemDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboHeaderItemDirective,
        selectors: [["", "igxComboHeaderItem", ""]]
      });
    }
  }
  return IgxComboHeaderItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the custom template that will be used to display the `ADD` button
 *
 * @remarks To show the `ADD` button, the `allowCustomValues` option must be enabled
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 * <igx-combo #combo>
 *      <ng-template igxComboAddItem>
 *          <button type="button" class="combo__add-button">
 *              Click to add item
 *          </button>
 *      </ng-template>
 *  </igx-combo>
 */
let IgxComboAddItemDirective = /*#__PURE__*/(() => {
  class IgxComboAddItemDirective {
    static {
      this.ɵfac = function IgxComboAddItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboAddItemDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboAddItemDirective,
        selectors: [["", "igxComboAddItem", ""]]
      });
    }
  }
  return IgxComboAddItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * The custom template that will be used when rendering the combo's toggle button
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 *  <igx-combo #combo>
 *      <ng-template igxComboToggleIcon let-collapsed>
 *          <igx-icon>{{ collapsed ? 'remove_circle' : 'remove_circle_outline'}}</igx-icon>
 *      </ng-template>
 *  </igx-combo>
 */
let IgxComboToggleIconDirective = /*#__PURE__*/(() => {
  class IgxComboToggleIconDirective {
    static {
      this.ɵfac = function IgxComboToggleIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboToggleIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboToggleIconDirective,
        selectors: [["", "igxComboToggleIcon", ""]]
      });
    }
  }
  return IgxComboToggleIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the custom template that will be used when rendering the combo's clear icon
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @example
 *  <igx-combo #combo>
 *      <ng-template igxComboClearIcon>
 *          <igx-icon>clear</igx-icon>
 *      </ng-template>
 *  </igx-combo>
 */
let IgxComboClearIconDirective = /*#__PURE__*/(() => {
  class IgxComboClearIconDirective {
    static {
      this.ɵfac = function IgxComboClearIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboClearIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboClearIconDirective,
        selectors: [["", "igxComboClearIcon", ""]]
      });
    }
  }
  return IgxComboClearIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ComboResourceStringsEN = {
  igx_combo_empty_message: 'The list is empty',
  igx_combo_filter_search_placeholder: 'Enter a Search Term',
  igx_combo_addCustomValues_placeholder: 'Add Item',
  igx_combo_clearItems_placeholder: 'Clear Selection'
};
const IGX_COMBO_COMPONENT = /*@__PURE__*/new InjectionToken('IgxComboComponentToken');
let NEXT_ID$f = 0;
let IgxComboBaseDirective = /*#__PURE__*/(() => {
  class IgxComboBaseDirective {
    /**
     * Gets/gets combo id.
     *
     * ```typescript
     * // get
     * let id = this.combo.id;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-combo [id]='combo1'></igx-combo>
     * ```
     */
    get id() {
      return this._id;
    }
    set id(value) {
      if (!value) {
        return;
      }
      const selection = this.selectionService.get(this._id);
      this.selectionService.clear(this._id);
      this._id = value;
      if (selection) {
        this.selectionService.set(this._id, selection);
      }
    }
    /**
     * Configures the drop down list height
     *
     * ```typescript
     * // get
     * let myComboItemsMaxHeight = this.combo.itemsMaxHeight;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-combo [itemsMaxHeight]='320'></igx-combo>
     * ```
     */
    get itemsMaxHeight() {
      if (this.itemHeight && !this._itemsMaxHeight) {
        return this.itemHeight * this.itemsInContainer;
      }
      return this._itemsMaxHeight;
    }
    set itemsMaxHeight(val) {
      this._itemsMaxHeight = val;
    }
    /** @hidden */
    get itemsMaxHeightInRem() {
      if (this.itemsMaxHeight) {
        return rem(this.itemsMaxHeight);
      }
    }
    /**
     * Configures the drop down list item height
     *
     * ```typescript
     * // get
     * let myComboItemHeight = this.combo.itemHeight;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-combo [itemHeight]='32'></igx-combo>
     * ```
     */
    get itemHeight() {
      return this._itemHeight;
    }
    set itemHeight(val) {
      this._itemHeight = val;
    }
    /**
     * Combo data source.
     *
     * ```html
     * <!--set-->
     * <igx-combo [data]='items'></igx-combo>
     * ```
     */
    get data() {
      return this._data;
    }
    set data(val) {
      // igxFor directive ignores undefined values
      // if the combo uses simple data and filtering is applied
      // an error will occur due to the mismatch of the length of the data
      // this can occur during filtering for the igx-combo and
      // during filtering & selection for the igx-simple-combo
      // since the simple combo's input is both a container for the selection and a filter
      this._data = val ? val.filter(x => x !== undefined) : [];
    }
    set displayKey(val) {
      this._displayKey = val;
    }
    /**
     * Determines which column in the data source is used to determine the display value.
     *
     * ```typescript
     * // get
     * let myComboDisplayKey = this.combo.displayKey;
     *
     * // set
     * this.combo.displayKey = 'val';
     *
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-combo [displayKey]='myDisplayKey'></igx-combo>
     * ```
     */
    get displayKey() {
      return this._displayKey ? this._displayKey : this.valueKey;
    }
    /**
     * The item property by which items should be grouped inside the items list. Not usable if data is not of type Object[].
     *
     * ```html
     * <!--set-->
     * <igx-combo [groupKey]='newGroupKey'></igx-combo>
     * ```
     */
    set groupKey(val) {
      this._groupKey = val;
    }
    /**
     * The item property by which items should be grouped inside the items list. Not usable if data is not of type Object[].
     *
     * ```typescript
     * // get
     * let currentGroupKey = this.combo.groupKey;
     * ```
     */
    get groupKey() {
      return this._groupKey;
    }
    /**
     * Sets groups sorting order.
     *
     * @example
     * ```html
     * <igx-combo [groupSortingDirection]="groupSortingDirection"></igx-combo>
     * ```
     * ```typescript
     * public groupSortingDirection = SortingDirection.Asc;
     * ```
     */
    get groupSortingDirection() {
      return this._groupSortingDirection;
    }
    set groupSortingDirection(val) {
      this._groupSortingDirection = val;
    }
    /**
     * Sets the visual combo type.
     * The allowed values are `line`, `box`, `border` and `search`. The default is `box`.
     * ```html
     * <igx-combo [type]="'line'">
     * ```
     */
    get type() {
      return this._type || this._inputGroupType || 'box';
    }
    set type(val) {
      this._type = val;
    }
    /**
     * Gets/Sets the resource strings.
     *
     * @remarks
     * By default it uses EN resources.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /** @hidden @internal */
    get searchValue() {
      return this._searchValue;
    }
    set searchValue(val) {
      this.filterValue = val;
      this._searchValue = val;
    }
    /** @hidden @internal */
    get isRemote() {
      return this.totalItemCount > 0 && this.valueKey && this.dataType === "complex" /* DataTypes.COMPLEX */;
    }
    /** @hidden @internal */
    get dataType() {
      if (this.displayKey) {
        return "complex" /* DataTypes.COMPLEX */;
      }
      return "primitive" /* DataTypes.PRIMITIVE */;
    }
    /**
     * Gets if control is valid, when used in a form
     *
     * ```typescript
     * // get
     * let valid = this.combo.valid;
     * ```
     */
    get valid() {
      return this._valid;
    }
    /**
     * Sets if control is valid, when used in a form
     *
     * ```typescript
     * // set
     * this.combo.valid = IgxInputState.INVALID;
     * ```
     */
    set valid(valid) {
      this._valid = valid;
      this.comboInput.valid = valid;
    }
    /**
     * The value of the combo
     *
     * ```typescript
     * // get
     * let comboValue = this.combo.value;
     * ```
     */
    get value() {
      return this._value;
    }
    /**
     * The text displayed in the combo input
     *
     * ```typescript
     * // get
     * let comboDisplayValue = this.combo.displayValue;
     * ```
     */
    get displayValue() {
      return this._displayValue;
    }
    /**
     * Defines the current state of the virtualized data. It contains `startIndex` and `chunkSize`
     *
     * ```typescript
     * // get
     * let state = this.combo.virtualizationState;
     * ```
     */
    get virtualizationState() {
      return this.virtDir.state;
    }
    /**
     * Sets the current state of the virtualized data.
     *
     * ```typescript
     * // set
     * this.combo.virtualizationState(state);
     * ```
     */
    set virtualizationState(state) {
      this.virtDir.state = state;
    }
    /**
     * Gets drop down state.
     *
     * ```typescript
     * let state = this.combo.collapsed;
     * ```
     */
    get collapsed() {
      return this.dropdown.collapsed;
    }
    /**
     * Gets total count of the virtual data items, when using remote service.
     *
     * ```typescript
     * // get
     * let count = this.combo.totalItemCount;
     * ```
     */
    get totalItemCount() {
      return this.virtDir.totalItemCount;
    }
    /**
     * Sets total count of the virtual data items, when using remote service.
     *
     * ```typescript
     * // set
     * this.combo.totalItemCount(remoteService.count);
     * ```
     */
    set totalItemCount(count) {
      this.virtDir.totalItemCount = count;
    }
    /** @hidden @internal */
    get template() {
      this._dataType = this.dataType;
      if (this.itemTemplate) {
        return this.itemTemplate;
      }
      if (this._dataType === "complex" /* DataTypes.COMPLEX */) {
        return this.complexTemplate;
      }
      return this.primitiveTemplate;
    }
    /**
     * Configures the way combo items will be filtered.
     *
     * ```typescript
     * // get
     * let myFilteringOptions = this.combo.filteringOptions;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-combo [filteringOptions]='myFilteringOptions'></igx-combo>
     * ```
     */
    get filteringOptions() {
      return this._filteringOptions || this._defaultFilteringOptions;
    }
    set filteringOptions(value) {
      this._filteringOptions = value;
    }
    constructor(elementRef, cdr, selectionService, comboAPI, document, _inputGroupType, _injector, _iconService) {
      this.elementRef = elementRef;
      this.cdr = cdr;
      this.selectionService = selectionService;
      this.comboAPI = comboAPI;
      this.document = document;
      this._inputGroupType = _inputGroupType;
      this._injector = _injector;
      this._iconService = _iconService;
      /**
       * Defines whether the caseSensitive icon should be shown in the search input
       *
       * ```typescript
       * // get
       * let myComboShowSearchCaseIcon = this.combo.showSearchCaseIcon;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-combo [showSearchCaseIcon]='true'></igx-combo>
       * ```
       */
      this.showSearchCaseIcon = false;
      /**
       * Set custom overlay settings that control how the combo's list of items is displayed.
       * Set:
       * ```html
       * <igx-combo [overlaySettings]="customOverlaySettings"></igx-combo>
       * ```
       *
       * ```typescript
       *  const customSettings = { positionStrategy: { settings: { target: myTarget } } };
       *  combo.overlaySettings = customSettings;
       * ```
       * Get any custom overlay settings used by the combo:
       * ```typescript
       *  const comboOverlaySettings: OverlaySettings = myCombo.overlaySettings;
       * ```
       */
      this.overlaySettings = null;
      /**
       * Controls whether custom values can be added to the collection
       *
       * ```typescript
       * // get
       * let comboAllowsCustomValues = this.combo.allowCustomValues;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-combo [allowCustomValues]='true'></igx-combo>
       * ```
       */
      this.allowCustomValues = false;
      /**
       * Determines which column in the data source is used to determine the value.
       *
       * ```typescript
       * // get
       * let myComboValueKey = this.combo.valueKey;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-combo [valueKey]='myKey'></igx-combo>
       * ```
       */
      this.valueKey = null;
      /** @hidden @internal */
      this.cssClass = 'igx-combo'; // Independent of display density for the time being
      /**
       * Disables the combo. The default is `false`.
       * ```html
       * <igx-combo [disabled]="'true'">
       * ```
       */
      this.disabled = false;
      /**
       * Emitted before the dropdown is opened
       *
       * ```html
       * <igx-combo opening='handleOpening($event)'></igx-combo>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emitted after the dropdown is opened
       *
       * ```html
       * <igx-combo (opened)='handleOpened($event)'></igx-combo>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emitted before the dropdown is closed
       *
       * ```html
       * <igx-combo (closing)='handleClosing($event)'></igx-combo>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emitted after the dropdown is closed
       *
       * ```html
       * <igx-combo (closed)='handleClosed($event)'></igx-combo>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * Emitted when an item is being added to the data collection
       *
       * ```html
       * <igx-combo (addition)='handleAdditionEvent($event)'></igx-combo>
       * ```
       */
      this.addition = new EventEmitter();
      /**
       * Emitted when the value of the search input changes (e.g. typing, pasting, clear, etc.)
       *
       * ```html
       * <igx-combo (searchInputUpdate)='handleSearchInputEvent($event)'></igx-combo>
       * ```
       */
      this.searchInputUpdate = new EventEmitter();
      /**
       * Emitted when new chunk of data is loaded from the virtualization
       *
       * ```html
       * <igx-combo (dataPreLoad)='handleDataPreloadEvent($event)'></igx-combo>
       * ```
       */
      this.dataPreLoad = new EventEmitter();
      /**
       * The custom template, if any, that should be used when rendering ITEMS in the combo list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.itemTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboItem let-item let-key="valueKey">
       *          <div class="custom-item">
       *              <div class="custom-item__name">{{ item[key] }}</div>
       *              <div class="custom-item__cost">{{ item.cost }}</div>
       *          </div>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.itemTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the HEADER for the combo items list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.headerTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboHeader>
       *          <div class="combo__header">
       *              This is a custom header
       *          </div>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.headerTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the FOOTER for the combo items list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.footerTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboFooter>
       *          <div class="combo__footer">
       *              This is a custom footer
       *          </div>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.footerTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering HEADER ITEMS for groups in the combo list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.headerItemTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboHeaderItem let-item let-key="groupKey">
       *          <div class="custom-item--group">Group header for {{ item[key] }}</div>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.headerItemTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the ADD BUTTON in the combo drop down
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.addItemTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboAddItem>
       *          <button type="button" igxButton="contained" class="combo__add-button">
       *              Click to add item
       *          </button>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.addItemTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the ADD BUTTON in the combo drop down
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.emptyTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboEmpty>
       *          <div class="combo--empty">
       *              There are no items to display
       *          </div>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.emptyTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the combo TOGGLE(open/close) button
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.toggleIconTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboToggleIcon let-collapsed>
       *          <igx-icon>{{ collapsed ? 'remove_circle' : 'remove_circle_outline'}}</igx-icon>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.toggleIconTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the combo CLEAR button
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.combo.clearIconTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-combo #combo>
       *      ...
       *      <ng-template igxComboClearIcon>
       *          <igx-icon>clear</igx-icon>
       *      </ng-template>
       *  </igx-combo>
       * ```
       */
      this.clearIconTemplate = null;
      /** @hidden @internal */
      this.searchInput = null;
      this.dropdownContainer = null;
      /** @hidden @internal */
      this.customValueFlag = true;
      /** @hidden @internal */
      this.filterValue = '';
      /** @hidden @internal */
      this.defaultFallbackGroup = 'Other';
      /** @hidden @internal */
      this.activeDescendant = '';
      this.containerSize = undefined;
      this.itemSize = undefined;
      this._data = [];
      this._value = [];
      this._displayValue = '';
      this._groupKey = '';
      this._searchValue = '';
      this._filteredData = [];
      this._remoteSelection = {};
      this._resourceStrings = getCurrentResourceStrings(ComboResourceStringsEN);
      this._valid = IgxInputState.INITIAL;
      this.ngControl = null;
      this.destroy$ = new Subject();
      this._onTouchedCallback = noop;
      this._onChangeCallback = noop;
      this.compareCollator = new Intl.Collator();
      this._id = `igx-combo-${NEXT_ID$f++}`;
      this._type = null;
      this._dataType = '';
      this._itemHeight = undefined;
      this._itemsMaxHeight = null;
      this._groupSortingDirection = SortingDirection.Asc;
      this._defaultFilteringOptions = {
        caseSensitive: false
      };
      this.itemsInContainer = 10;
      this.onStatusChanged = () => {
        if (this.ngControl && this.isTouchedOrDirty && !this.disabled) {
          if (this.hasValidators && (!this.collapsed || this.inputGroup.isFocused)) {
            this.valid = this.ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
          } else {
            this.valid = this.ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
          }
        } else {
          // B.P. 18 May 2021: IgxDatePicker does not reset its state upon resetForm #9526
          this.valid = IgxInputState.INITIAL;
        }
        this.manageRequiredAsterisk();
      };
      this.findMatch = element => {
        const value = this.displayKey ? element[this.displayKey] : element;
        const searchValue = this.searchValue || this.comboInput?.value;
        return value?.toString().trim().toLowerCase() === searchValue.trim().toLowerCase();
      };
    }
    ngAfterViewChecked() {
      const targetElement = this.inputGroup.element.nativeElement.querySelector('.igx-input-group__bundle');
      this._overlaySettings = {
        target: targetElement,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new AutoPositionStrategy(),
        modal: false,
        closeOnOutsideClick: true,
        excludeFromOutsideClick: [targetElement]
      };
    }
    /** @hidden @internal */
    ngAfterContentChecked() {
      if (this.inputGroup && this.prefixes?.length > 0) {
        this.inputGroup.prefixes = this.prefixes;
      }
      if (this.inputGroup && this.suffixes?.length > 0) {
        this.inputGroup.suffixes = this.suffixes;
      }
    }
    /** @hidden @internal */
    ngOnInit() {
      this.ngControl = this._injector.get(NgControl, null);
      this.selectionService.set(this.id, new Set());
      this._iconService?.addSvgIconFromText(caseSensitive.name, caseSensitive.value, 'imx-icons');
      this.computedStyles = this.document.defaultView.getComputedStyle(this.elementRef.nativeElement);
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.filteredData = [...this.data];
      if (this.ngControl) {
        this.ngControl.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(this.onStatusChanged);
        this.manageRequiredAsterisk();
        this.cdr.detectChanges();
      }
      this.virtDir.chunkPreload.pipe(takeUntil(this.destroy$)).subscribe(e => {
        const eventArgs = Object.assign({}, e, {
          owner: this
        });
        this.dataPreLoad.emit(eventArgs);
      });
      this.dropdown?.opening.subscribe(_args => {
        // calculate the container size and item size based on the sizes from the DOM
        const dropdownContainerHeight = this.dropdownContainer.nativeElement.getBoundingClientRect().height;
        if (dropdownContainerHeight) {
          this.containerSize = parseFloat(dropdownContainerHeight);
        }
        if (this.dropdown.children?.first) {
          this.itemSize = this.dropdown.children.first.element.nativeElement.getBoundingClientRect().height;
        }
      });
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
      this.comboAPI.clear();
      this.selectionService.delete(this.id);
    }
    /**
     * A method that opens/closes the combo.
     *
     * ```html
     * <button type="button" (click)="combo.toggle()">Toggle Combo</button>
     * <igx-combo #combo></igx-combo>
     * ```
     */
    toggle() {
      if (this.collapsed && this._displayValue.length !== 0) {
        this.filterValue = '';
        this.cdr.detectChanges();
      }
      const overlaySettings = Object.assign({}, this._overlaySettings, this.overlaySettings);
      this.dropdown.toggle(overlaySettings);
      if (!this.collapsed) {
        this.setActiveDescendant();
      }
    }
    /**
     * A method that opens the combo.
     *
     * ```html
     * <button type="button" (click)="combo.open()">Open Combo</button>
     * <igx-combo #combo></igx-combo>
     * ```
     */
    open() {
      if (this.collapsed && this._displayValue.length !== 0) {
        this.filterValue = '';
        this.cdr.detectChanges();
      }
      const overlaySettings = Object.assign({}, this._overlaySettings, this.overlaySettings);
      this.dropdown.open(overlaySettings);
      this.setActiveDescendant();
    }
    /**
     * A method that closes the combo.
     *
     * ```html
     * <button type="button" (click)="combo.close()">Close Combo</button>
     * <igx-combo #combo></igx-combo>
     * ```
     */
    close() {
      this.dropdown.close();
    }
    /**
     * Triggers change detection on the combo view
     */
    triggerCheck() {
      this.cdr.detectChanges();
    }
    /**
     * Get current selection state
     *
     * @returns Array of selected items
     * ```typescript
     * let mySelection = this.combo.selection;
     * ```
     */
    get selection() {
      const items = Array.from(this.selectionService.get(this.id));
      return this.convertKeysToItems(items);
    }
    /**
     * Returns if the specified itemID is selected
     *
     * @hidden
     * @internal
     */
    isItemSelected(item) {
      return this.selectionService.is_item_selected(this.id, item);
    }
    /** @hidden @internal */
    get toggleIcon() {
      return this.dropdown.collapsed ? 'input_expand' : 'input_collapse';
    }
    /** @hidden @internal */
    addItemToCollection() {
      if (!this.searchValue) {
        return;
      }
      const addedItem = this.displayKey ? {
        [this.valueKey]: this.searchValue,
        [this.displayKey]: this.searchValue
      } : this.searchValue;
      if (this.groupKey) {
        Object.assign(addedItem, {
          [this.groupKey]: this.defaultFallbackGroup
        });
      }
      // expose shallow copy instead of this.data in event args so this.data can't be mutated
      const oldCollection = [...this.data];
      const newCollection = [...this.data, addedItem];
      const args = {
        oldCollection,
        addedItem,
        newCollection,
        owner: this,
        cancel: false
      };
      this.addition.emit(args);
      if (args.cancel) {
        return;
      }
      this.data.push(args.addedItem);
      // trigger re-render
      this.data = cloneArray(this.data);
      this.select(this.valueKey !== null && this.valueKey !== undefined ? [args.addedItem[this.valueKey]] : [args.addedItem], false);
      this.customValueFlag = false;
      this.searchInput?.nativeElement.focus();
      this.dropdown.focusedItem = null;
      this.virtDir.scrollTo(0);
    }
    /** @hidden @internal */
    isAddButtonVisible() {
      // This should always return a boolean value. If this.searchValue was '', it returns '' instead of false;
      return this.searchValue !== '' && this.customValueFlag;
    }
    /** @hidden @internal */
    handleInputChange(event) {
      if (event !== undefined) {
        const args = {
          searchText: typeof event === 'string' ? event : event.target.value,
          owner: this,
          cancel: false
        };
        this.searchInputUpdate.emit(args);
        if (args.cancel) {
          this.filterValue = null;
        }
      }
      this.checkMatch();
    }
    /**
     * Event handlers
     *
     * @hidden
     * @internal
     */
    handleOpening(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: e.cancel
      };
      this.opening.emit(args);
      e.cancel = args.cancel;
    }
    /** @hidden @internal */
    handleClosing(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: e.cancel
      };
      this.closing.emit(args);
      e.cancel = args.cancel;
      if (e.cancel) {
        return;
      }
      this.searchValue = '';
      if (!e.event) {
        this.comboInput?.nativeElement.focus();
      } else {
        this._onTouchedCallback();
        this.updateValidity();
      }
    }
    /** @hidden @internal */
    handleClosed() {
      this.closed.emit({
        owner: this
      });
    }
    /** @hidden @internal */
    handleKeyDown(event) {
      if (event.key === 'ArrowUp' || event.key === 'Up') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    /** @hidden @internal */
    onClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (!this.disabled) {
        this.toggle();
      }
    }
    /** @hidden @internal */
    onBlur() {
      if (this.collapsed) {
        this._onTouchedCallback();
        this.updateValidity();
      }
    }
    /** @hidden @internal */
    setActiveDescendant() {
      this.activeDescendant = this.dropdown.focusedItem?.id || '';
    }
    /** @hidden @internal */
    toggleCaseSensitive() {
      this.filteringOptions = Object.assign({}, this.filteringOptions, {
        caseSensitive: !this.filteringOptions.caseSensitive
      });
    }
    updateValidity() {
      if (this.ngControl && this.ngControl.invalid) {
        this.valid = IgxInputState.INVALID;
      } else {
        this.valid = IgxInputState.INITIAL;
      }
    }
    get isTouchedOrDirty() {
      return this.ngControl.control.touched || this.ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this.ngControl.control.validator || !!this.ngControl.control.asyncValidator;
    }
    /** if there is a valueKey - map the keys to data items, else - just return the keys */
    convertKeysToItems(keys) {
      if (this.valueKey === null || this.valueKey === undefined) {
        return keys;
      }
      return keys.map(key => {
        const item = this.data.find(entry => isEqual$1(entry[this.valueKey], key));
        return item !== undefined ? item : {
          [this.valueKey]: key
        };
      });
    }
    checkMatch() {
      const itemMatch = this.filteredData.some(this.findMatch);
      this.customValueFlag = this.allowCustomValues && !itemMatch;
    }
    manageRequiredAsterisk() {
      if (this.ngControl) {
        this.inputGroup.isRequired = this.required;
      }
    }
    /** Contains key-value pairs of the selected valueKeys and their resp. displayKeys */
    registerRemoteEntries(ids, add = true) {
      if (add) {
        const selection = this.getValueDisplayPairs(ids);
        for (const entry of selection) {
          this._remoteSelection[entry[this.valueKey]] = entry[this.displayKey];
        }
      } else {
        for (const entry of ids) {
          delete this._remoteSelection[entry];
        }
      }
    }
    /**
     * For `id: any[]` returns a mapped `{ [combo.valueKey]: any, [combo.displayKey]: any }[]`
     */
    getValueDisplayPairs(ids) {
      return this.data.filter(entry => ids.indexOf(entry[this.valueKey]) > -1).map(e => ({
        [this.valueKey]: e[this.valueKey],
        [this.displayKey]: e[this.displayKey]
      }));
    }
    getRemoteSelection(newSelection, oldSelection) {
      if (!newSelection.length) {
        // If new selection is empty, clear all items
        this.registerRemoteEntries(oldSelection, false);
        return '';
      }
      const removedItems = oldSelection.filter(e => newSelection.indexOf(e) < 0);
      const addedItems = newSelection.filter(e => oldSelection.indexOf(e) < 0);
      this.registerRemoteEntries(addedItems);
      this.registerRemoteEntries(removedItems, false);
      return Object.keys(this._remoteSelection).map(e => this._remoteSelection[e]).join(', ');
    }
    get required() {
      if (this.ngControl && this.ngControl.control && this.ngControl.control.validator) {
        // Run the validation with empty object to check if required is enabled.
        const error = this.ngControl.control.validator({});
        return error && error.required;
      }
      return false;
    }
    static {
      this.ɵfac = function IgxComboBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxSelectionAPIService), i0.ɵɵdirectiveInject(IgxComboAPIService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(i0.Injector, 8), i0.ɵɵdirectiveInject(IgxIconService, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxComboBaseDirective,
        contentQueries: function IgxComboBaseDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxComboItemDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboHeaderDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboFooterDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboHeaderItemDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboAddItemDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboEmptyDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboToggleIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxComboClearIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxLabelDirective, 7);
            i0.ɵɵcontentQuery(dirIndex, IgxPrefixDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxSuffixDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerItemTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addItemTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixes = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixes = _t);
          }
        },
        viewQuery: function IgxComboBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c55, 7, IgxInputGroupComponent);
            i0.ɵɵviewQuery(_c56, 7, IgxInputDirective);
            i0.ɵɵviewQuery(_c57, 5);
            i0.ɵɵviewQuery(IgxForOfDirective, 7);
            i0.ɵɵviewQuery(IgxForOfDirective, 7, IgxForOfDirective);
            i0.ɵɵviewQuery(_c58, 7);
            i0.ɵɵviewQuery(_c59, 7, TemplateRef);
            i0.ɵɵviewQuery(_c60, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.comboInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtualScrollContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtDir = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primitiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.complexTemplate = _t.first);
          }
        },
        hostVars: 5,
        hostBindings: function IgxComboBaseDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("width", ctx.width);
            i0.ɵɵclassProp("igx-combo", ctx.cssClass);
          }
        },
        inputs: {
          showSearchCaseIcon: [2, "showSearchCaseIcon", "showSearchCaseIcon", booleanAttribute],
          overlaySettings: "overlaySettings",
          id: "id",
          width: "width",
          allowCustomValues: [2, "allowCustomValues", "allowCustomValues", booleanAttribute],
          itemsMaxHeight: "itemsMaxHeight",
          itemHeight: "itemHeight",
          itemsWidth: "itemsWidth",
          placeholder: "placeholder",
          data: "data",
          valueKey: "valueKey",
          displayKey: "displayKey",
          groupKey: "groupKey",
          groupSortingDirection: "groupSortingDirection",
          filterFunction: "filterFunction",
          ariaLabelledBy: "ariaLabelledBy",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          type: "type",
          resourceStrings: "resourceStrings",
          filteringOptions: "filteringOptions"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed",
          addition: "addition",
          searchInputUpdate: "searchInputUpdate",
          dataPreLoad: "dataPreLoad"
        }
      });
    }
  }
  return IgxComboBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxComboAddItemComponent = /*#__PURE__*/(() => {
  class IgxComboAddItemComponent extends IgxComboItemComponent {
    get isDropDownItem() {
      return false;
    }
    get selected() {
      return false;
    }
    set selected(value) {}
    clicked(event) {
      this.comboAPI.disableTransitions = false;
      this.comboAPI.add_custom_item();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxComboAddItemComponent_BaseFactory;
        return function IgxComboAddItemComponent_Factory(__ngFactoryType__) {
          return (ɵIgxComboAddItemComponent_BaseFactory || (ɵIgxComboAddItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxComboAddItemComponent)))(__ngFactoryType__ || IgxComboAddItemComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxComboAddItemComponent,
        selectors: [["igx-combo-add-item"]],
        hostVars: 2,
        hostBindings: function IgxComboAddItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-drop-down__item", ctx.isDropDownItem);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxComboItemComponent,
          useExisting: IgxComboAddItemComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxComboAddItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxComboAddItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxComboDropDownComponent = /*#__PURE__*/(() => {
  class IgxComboDropDownComponent extends IgxDropDownComponent {
    /** @hidden @internal */
    get scrollContainer() {
      // TODO: Update, use public API if possible:
      return this.virtDir.dc.location.nativeElement;
    }
    get isScrolledToLast() {
      const scrollTop = this.virtDir.scrollPosition;
      const scrollHeight = this.virtDir.getScroll().scrollHeight;
      return Math.floor(scrollTop + this.virtDir.igxForContainerSize) === scrollHeight;
    }
    get lastVisibleIndex() {
      return this.combo.totalItemCount ? Math.floor(this.combo.itemsMaxHeight / this.combo.itemHeight) : this.items.length - 1;
    }
    get sortedChildren() {
      if (this.children !== undefined) {
        return this.children.toArray().sort((a, b) => a.index - b.index);
      }
      return null;
    }
    /**
     * Get all non-header items
     *
     * ```typescript
     * let myDropDownItems = this.dropdown.items;
     * ```
     */
    get items() {
      const items = [];
      if (this.children !== undefined) {
        const sortedChildren = this.sortedChildren;
        for (const child of sortedChildren) {
          if (!child.isHeader) {
            items.push(child);
          }
        }
      }
      return items;
    }
    constructor(elementRef, cdr, document, selection, combo, comboAPI) {
      super(elementRef, cdr, document, selection);
      this.combo = combo;
      this.comboAPI = comboAPI;
      /** @hidden @internal */
      this.singleMode = false;
      /**
       * @hidden
       * @internal
       */
      this.children = null;
      this.scrollHandler = () => {
        this.comboAPI.disableTransitions = true;
      };
    }
    /**
     * @hidden @internal
     */
    onFocus() {
      this.focusedItem = this._focusedItem || this.items[0];
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden @internal
     */
    onBlur(_evt) {
      this.focusedItem = null;
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden @internal
     */
    onToggleOpened() {
      this.opened.emit();
    }
    /**
     * @hidden
     */
    navigateFirst() {
      this.navigateItem(this.virtDir.igxForOf.findIndex(e => !e?.isHeader));
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden
     */
    navigatePrev() {
      if (this._focusedItem && this._focusedItem.index === 0 && this.virtDir.state.startIndex === 0) {
        this.combo.focusSearchInput(false);
        this.focusedItem = null;
      } else {
        super.navigatePrev();
      }
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden
     */
    navigateNext() {
      const lastIndex = this.combo.totalItemCount ? this.combo.totalItemCount - 1 : this.virtDir.igxForOf.length - 1;
      if (this._focusedItem && this._focusedItem.index === lastIndex) {
        this.focusAddItemButton();
      } else {
        super.navigateNext();
      }
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden @internal
     */
    selectItem(item) {
      if (item === null || item === undefined) {
        return;
      }
      this.comboAPI.set_selected_item(item.itemID);
      this._focusedItem = item;
      this.combo.setActiveDescendant();
    }
    /**
     * @hidden @internal
     */
    updateScrollPosition() {
      this.virtDir.getScroll().scrollTop = this._scrollPosition;
    }
    /**
     * @hidden @internal
     */
    onItemActionKey(key) {
      switch (key) {
        case DropDownActionKey.ENTER:
          this.handleEnter();
          break;
        case DropDownActionKey.SPACE:
          this.handleSpace();
          break;
        case DropDownActionKey.ESCAPE:
          this.close();
      }
    }
    ngAfterViewInit() {
      this.virtDir.getScroll().addEventListener('scroll', this.scrollHandler);
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.virtDir.getScroll().removeEventListener('scroll', this.scrollHandler);
      super.ngOnDestroy();
    }
    scrollToHiddenItem(_newItem) {}
    handleEnter() {
      if (this.isAddItemFocused()) {
        this.combo.addItemToCollection();
        return;
      }
      if (this.singleMode && this.focusedItem) {
        this.combo.select(this.focusedItem.itemID);
      }
      this.close();
    }
    handleSpace() {
      if (this.isAddItemFocused()) {
        return;
      } else {
        this.selectItem(this.focusedItem);
      }
    }
    isAddItemFocused() {
      return this.focusedItem instanceof IgxComboAddItemComponent;
    }
    focusAddItemButton() {
      if (this.combo.isAddButtonVisible()) {
        this.focusedItem = this.items[this.items.length - 1];
      }
    }
    static {
      this.ɵfac = function IgxComboDropDownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboDropDownComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IgxSelectionAPIService), i0.ɵɵdirectiveInject(IGX_COMBO_COMPONENT), i0.ɵɵdirectiveInject(IgxComboAPIService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxComboDropDownComponent,
        selectors: [["igx-combo-drop-down"]],
        contentQueries: function IgxComboDropDownComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxComboItemComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        inputs: {
          singleMode: [2, "singleMode", "singleMode", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_DROPDOWN_BASE,
          useExisting: IgxComboDropDownComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 9,
        consts: [["scrollContainer", ""], ["igxToggle", "", 1, "igx-drop-down__list", 3, "appended", "opening", "opened", "closing", "closed"], ["role", "listbox", 1, "igx-drop-down__list-scroll"]],
        template: function IgxComboDropDownComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("appended", function IgxComboDropDownComponent_Template_div_appended_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleContentAppended($event));
            })("opening", function IgxComboDropDownComponent_Template_div_opening_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleOpening($event));
            })("opened", function IgxComboDropDownComponent_Template_div_opened_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleOpened());
            })("closing", function IgxComboDropDownComponent_Template_div_closing_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleClosing($event));
            })("closed", function IgxComboDropDownComponent_Template_div_closed_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleClosed());
            });
            i0.ɵɵelementStart(1, "div", 2, 0);
            i0.ɵɵtemplate(3, IgxComboDropDownComponent_Conditional_3_Template, 1, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.height)("max-height", ctx.maxHeight);
            i0.ɵɵattribute("id", ctx.listId)("aria-labelledby", ctx.labelledBy);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.collapsed ? 3 : -1);
          }
        },
        dependencies: [IgxToggleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxComboDropDownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxComboFilteringPipe = /*#__PURE__*/(() => {
  class IgxComboFilteringPipe {
    transform(collection, searchValue, displayKey, filteringOptions, filterFunction = defaultFilterFunction, disableFiltering = false) {
      if (!collection) {
        return [];
      }
      if (disableFiltering) {
        return collection;
      }
      filteringOptions.filteringKey = filteringOptions.filteringKey ?? displayKey;
      return filterFunction(collection, searchValue, filteringOptions);
    }
    static {
      this.ɵfac = function IgxComboFilteringPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboFilteringPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "comboFiltering",
        type: IgxComboFilteringPipe,
        pure: true
      });
    }
  }
  return IgxComboFilteringPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden */
let IgxComboGroupingPipe = /*#__PURE__*/(() => {
  class IgxComboGroupingPipe {
    constructor(combo) {
      this.combo = combo;
    }
    transform(collection, groupKey, valueKey, sortingDirection, compareCollator) {
      // TODO: should filteredData be changed here?
      this.combo.filteredData = collection;
      if (!groupKey && groupKey !== 0 || !collection.length) {
        return collection;
      }
      const groups = Object.entries(groupBy(collection, item => item[groupKey] ?? 'Other'));
      if (sortingDirection !== SortingDirection.None) {
        const reverse = sortingDirection === SortingDirection.Desc ? -1 : 1;
        groups.sort((a, b) => {
          return compareCollator.compare(a[0], b[0]) * reverse;
        });
      }
      const result = groups.flatMap(([_, items]) => {
        items.unshift({
          isHeader: true,
          [valueKey]: items[0][groupKey],
          [groupKey]: items[0][groupKey]
        });
        return items;
      });
      return result;
    }
    static {
      this.ɵfac = function IgxComboGroupingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboGroupingPipe)(i0.ɵɵdirectiveInject(IGX_COMBO_COMPONENT, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "comboGrouping",
        type: IgxComboGroupingPipe,
        pure: true
      });
    }
  }
  return IgxComboGroupingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function defaultFilterFunction(collection, searchValue, filteringOptions) {
  if (!searchValue) {
    return collection;
  }
  const {
    caseSensitive,
    filteringKey
  } = filteringOptions;
  const term = caseSensitive ? searchValue : searchValue.toLowerCase();
  return collection.filter(item => {
    const str = filteringKey ? `${item[filteringKey]}` : `${item}`;
    return (caseSensitive ? str : str.toLowerCase()).includes(term);
  });
}
function normalizeString(str, caseSensitive = false) {
  return (caseSensitive ? str : str.toLocaleLowerCase()).normalize('NFKD').replace(/\p{M}/gu, '');
}
function groupBy(data, key) {
  const result = {};
  const _get = typeof key === 'function' ? key : item => item[key];
  for (const item of data) {
    const category = _get(item);
    const group = result[category];
    Array.isArray(group) ? group.push(item) : result[category] = [item];
  }
  return result;
}
/**
 * Combo filter function which does not distinguish between accented letters and their base letters.
 * For example, when filtering for "resume", this function will match both "resume" and "résumé".
 *
 * @example
 * ```html
 * <igx-combo [filterFunction]="comboIgnoreDiacriticFilterFunction"></igx-combo>
 * ```
 */
function comboIgnoreDiacriticsFilter(collection, searchValue, filteringOptions) {
  if (!searchValue) {
    return collection;
  }
  const {
    caseSensitive,
    filteringKey
  } = filteringOptions;
  const term = normalizeString(searchValue, caseSensitive);
  return collection.filter(item => {
    const str = filteringKey ? `${item[filteringKey]}` : `${item}`;
    return normalizeString(str, caseSensitive).includes(term);
  });
}

/**
 * When called with sets A & B, returns A - B (as array);
 *
 * @hidden
 */
const diffInSets = (set1, set2) => {
  const results = [];
  set1.forEach(entry => {
    if (!set2.has(entry)) {
      results.push(entry);
    }
  });
  return results;
};
/**
 *  Represents a drop-down list that provides editable functionalities, allowing users to choose an option from a predefined list.
 *
 * @igxModule IgxComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, combo selection
 * @igxGroup Grids & Lists
 *
 * @remarks
 * It provides the ability to filter items as well as perform selection with the provided data.
 * Additionally, it exposes keyboard navigation and custom styling capabilities.
 * @example
 * ```html
 * <igx-combo [itemsMaxHeight]="250" [data]="locationData"
 *  [displayKey]="'field'" [valueKey]="'field'"
 *  placeholder="Location(s)" searchPlaceholder="Search...">
 * </igx-combo>
 * ```
 */
let IgxComboComponent = /*#__PURE__*/(() => {
  class IgxComboComponent extends IgxComboBaseDirective {
    /**
     * Enables/disables filtering in the list. The default is `false`.
     */
    get disableFiltering() {
      return this._disableFiltering || this.filteringOptions.filterable === false;
    }
    set disableFiltering(value) {
      this._disableFiltering = value;
    }
    /** @hidden @internal */
    get filteredData() {
      return this.disableFiltering ? this.data : this._filteredData;
    }
    /** @hidden @internal */
    set filteredData(val) {
      this._filteredData = this.groupKey ? (val || []).filter(e => e.isHeader !== true) : val;
      this.checkMatch();
    }
    constructor(elementRef, cdr, selectionService, comboAPI, document, _inputGroupType, _injector, _iconService) {
      super(elementRef, cdr, selectionService, comboAPI, document, _inputGroupType, _injector, _iconService);
      /**
       * Whether the combo's search box should be focused after the dropdown is opened.
       * When `false`, the combo's list item container will be focused instead
       */
      this.autoFocusSearch = true;
      /**
       * Emitted when item selection is changing, before the selection completes
       *
       * ```html
       * <igx-combo (selectionChanging)='handleSelection()'></igx-combo>
       * ```
       */
      this.selectionChanging = new EventEmitter();
      this._prevInputValue = '';
      this._disableFiltering = false;
      this.comboAPI.register(this);
    }
    onArrowDown(event) {
      event.preventDefault();
      event.stopPropagation();
      this.open();
    }
    /** @hidden @internal */
    get displaySearchInput() {
      return !this.disableFiltering || this.allowCustomValues;
    }
    /**
     * @hidden @internal
     */
    handleKeyUp(event) {
      // TODO: use PlatformUtil for keyboard navigation
      if (event.key === 'ArrowDown' || event.key === 'Down') {
        this.dropdown.focusedItem = this.dropdown.items[0];
        this.dropdownContainer.nativeElement.focus();
      } else if (event.key === 'Escape' || event.key === 'Esc') {
        this.toggle();
      }
    }
    /**
     * @hidden @internal
     */
    handleSelectAll(evt) {
      if (evt.checked) {
        this.selectAllItems();
      } else {
        this.deselectAllItems();
      }
    }
    /**
     * @hidden @internal
     */
    writeValue(value) {
      const selection = Array.isArray(value) ? value.filter(x => x !== undefined) : [];
      const oldSelection = this.selection;
      this.selectionService.select_items(this.id, selection, true);
      this.cdr.markForCheck();
      this._displayValue = this.createDisplayText(this.selection, oldSelection);
      this._value = this.valueKey ? this.selection.map(item => item[this.valueKey]) : this.selection;
    }
    /** @hidden @internal */
    ngDoCheck() {
      if (this.data?.length && this.selection.length) {
        this._displayValue = this._displayText || this.createDisplayText(this.selection, []);
        this._value = this.valueKey ? this.selection.map(item => item[this.valueKey]) : this.selection;
      }
    }
    /**
     * @hidden
     */
    getEditElement() {
      return this.comboInput.nativeElement;
    }
    /**
     * @hidden @internal
     */
    get context() {
      return {
        $implicit: this
      };
    }
    /**
     * @hidden @internal
     */
    handleClearItems(event) {
      if (this.disabled) {
        return;
      }
      this.deselectAllItems(true, event);
      if (this.collapsed) {
        this.getEditElement().focus();
      } else {
        this.focusSearchInput(true);
      }
      event.stopPropagation();
    }
    /**
     * Select defined items
     *
     * @param newItems new items to be selected
     * @param clearCurrentSelection if true clear previous selected items
     * ```typescript
     * this.combo.select(["New York", "New Jersey"]);
     * ```
     */
    select(newItems, clearCurrentSelection, event) {
      if (newItems) {
        const newSelection = this.selectionService.add_items(this.id, newItems, clearCurrentSelection);
        this.setSelection(newSelection, event);
      }
    }
    /**
     * Deselect defined items
     *
     * @param items items to deselected
     * ```typescript
     * this.combo.deselect(["New York", "New Jersey"]);
     * ```
     */
    deselect(items, event) {
      if (items) {
        const newSelection = this.selectionService.delete_items(this.id, items);
        this.setSelection(newSelection, event);
      }
    }
    /**
     * Select all (filtered) items
     *
     * @param ignoreFilter if set to true, selects all items, otherwise selects only the filtered ones.
     * ```typescript
     * this.combo.selectAllItems();
     * ```
     */
    selectAllItems(ignoreFilter, event) {
      const allVisible = this.selectionService.get_all_ids(ignoreFilter ? this.data : this.filteredData, this.valueKey);
      const newSelection = this.selectionService.add_items(this.id, allVisible);
      this.setSelection(newSelection, event);
    }
    /**
     * Deselect all (filtered) items
     *
     * @param ignoreFilter if set to true, deselects all items, otherwise deselects only the filtered ones.
     * ```typescript
     * this.combo.deselectAllItems();
     * ```
     */
    deselectAllItems(ignoreFilter, event) {
      let newSelection = this.selectionService.get_empty();
      if (this.filteredData.length !== this.data.length && !ignoreFilter) {
        newSelection = this.selectionService.delete_items(this.id, this.selectionService.get_all_ids(this.filteredData, this.valueKey));
      }
      this.setSelection(newSelection, event);
    }
    /**
     * Selects/Deselects a single item
     *
     * @param itemID the itemID of the specific item
     * @param select If the item should be selected (true) or deselected (false)
     *
     * Without specified valueKey;
     * ```typescript
     * this.combo.valueKey = null;
     * const items: { field: string, region: string}[] = data;
     * this.combo.setSelectedItem(items[0], true);
     * ```
     * With specified valueKey;
     * ```typescript
     * this.combo.valueKey = 'field';
     * const items: { field: string, region: string}[] = data;
     * this.combo.setSelectedItem('Connecticut', true);
     * ```
     */
    setSelectedItem(itemID, select = true, event) {
      if (itemID === undefined) {
        return;
      }
      if (select) {
        this.select([itemID], false, event);
      } else {
        this.deselect([itemID], event);
      }
    }
    /** @hidden @internal */
    handleOpened() {
      this.triggerCheck();
      // Disabling focus of the search input should happen only when drop down opens.
      // During keyboard navigation input should receive focus, even the autoFocusSearch is disabled.
      // That is why in such cases focusing of the dropdownContainer happens outside focusSearchInput method.
      if (this.autoFocusSearch) {
        this.focusSearchInput(true);
      } else {
        this.dropdownContainer.nativeElement.focus();
      }
      this.opened.emit({
        owner: this
      });
    }
    /** @hidden @internal */
    focusSearchInput(opening) {
      if (this.displaySearchInput && this.searchInput) {
        this.searchInput.nativeElement.focus();
      } else {
        if (opening) {
          this.dropdownContainer.nativeElement.focus();
        } else {
          this.comboInput.nativeElement.focus();
          this.toggle();
        }
      }
    }
    setSelection(selection, event) {
      const currentSelection = this.selectionService.get(this.id);
      const removed = this.convertKeysToItems(diffInSets(currentSelection, selection));
      const added = this.convertKeysToItems(diffInSets(selection, currentSelection));
      const newValue = Array.from(selection);
      const oldValue = Array.from(currentSelection || []);
      const newSelection = this.convertKeysToItems(newValue);
      const oldSelection = this.convertKeysToItems(oldValue);
      const displayText = this.createDisplayText(this.convertKeysToItems(newValue), oldValue);
      const args = {
        newValue,
        oldValue,
        newSelection,
        oldSelection,
        added,
        removed,
        event,
        owner: this,
        displayText,
        cancel: false
      };
      this.selectionChanging.emit(args);
      if (!args.cancel) {
        this.selectionService.select_items(this.id, args.newValue, true);
        this._value = args.newValue;
        if (displayText !== args.displayText) {
          this._displayValue = this._displayText = args.displayText;
        } else {
          this._displayValue = this.createDisplayText(this.selection, args.oldSelection);
        }
        this._onChangeCallback(args.newValue);
      } else if (this.isRemote) {
        this.registerRemoteEntries(diffInSets(selection, currentSelection), false);
      }
    }
    createDisplayText(newSelection, oldSelection) {
      const selection = this.valueKey ? newSelection.map(item => item[this.valueKey]) : newSelection;
      return this.isRemote ? this.getRemoteSelection(selection, oldSelection) : this.concatDisplayText(newSelection);
    }
    getSearchPlaceholderText() {
      return this.searchPlaceholder || (this.disableFiltering ? this.resourceStrings.igx_combo_addCustomValues_placeholder : this.resourceStrings.igx_combo_filter_search_placeholder);
    }
    /** Returns a string that should be populated in the combo's text box */
    concatDisplayText(selection) {
      const value = this.displayKey !== null && this.displayKey !== undefined ? selection.map(entry => entry[this.displayKey]).join(', ') : selection.join(', ');
      return value;
    }
    static {
      this.ɵfac = function IgxComboComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxSelectionAPIService), i0.ɵɵdirectiveInject(IgxComboAPIService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(i0.Injector, 8), i0.ɵɵdirectiveInject(IgxIconService, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxComboComponent,
        selectors: [["igx-combo"]],
        viewQuery: function IgxComboComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxComboDropDownComponent, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
          }
        },
        hostBindings: function IgxComboComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.ArrowDown", function IgxComboComponent_keydown_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Alt.ArrowDown", function IgxComboComponent_keydown_Alt_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            });
          }
        },
        inputs: {
          autoFocusSearch: [2, "autoFocusSearch", "autoFocusSearch", booleanAttribute],
          disableFiltering: [2, "disableFiltering", "disableFiltering", booleanAttribute],
          searchPlaceholder: "searchPlaceholder"
        },
        outputs: {
          selectionChanging: "selectionChanging"
        },
        features: [i0.ɵɵProvidersFeature([IgxComboAPIService, {
          provide: IGX_COMBO_COMPONENT,
          useExisting: IgxComboComponent
        }, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxComboComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c62,
        decls: 37,
        vars: 55,
        consts: [["inputGroup", ""], ["comboInput", ""], ["igxComboDropDown", ""], ["dropdownItemContainer", ""], ["complex", ""], ["primitive", ""], ["empty", ""], ["addItemDefault", ""], ["headerItemBase", ""], ["searchInput", ""], ["listItem", ""], [3, "click", "type"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["ngProjectAs", "igx-hint, [igxHint]", 5, ["igx-hint"]], ["igxInput", "", "name", "comboInput", "type", "text", "readonly", "", "role", "combobox", "aria-haspopup", "listbox", 3, "blur", "value", "disabled"], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], [1, "igx-combo__clear-button"], [1, "igx-combo__toggle-button"], ["family", "default", 3, "name"], [1, "igx-combo__drop-down", 3, "opening", "closing", "opened", "closed", "labelledBy", "width"], [1, "igx-combo__search"], [4, "ngTemplateOutlet"], ["aria-multiselectable", "true", 1, "igx-combo__content", 3, "focus", "igxDropDownItemNavigation", "tabindex"], [3, "itemHeight", "value", "isHeader", "index", "role", 4, "igxFor", "igxForOf", "igxForInitialChunkSize", "igxForContainerSize", "igxForItemSize", "igxForScrollOrientation"], [1, "igx-combo__add"], [1, "igx-combo__clear-button", 3, "click"], ["family", "default", "name", "input_clear"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "line"], ["igxInput", "", "name", "searchInput", "autocomplete", "off", "type", "text", "aria-autocomplete", "list", "role", "searchbox", "aria-label", "search", 3, "ngModelChange", "keyup", "keydown", "focus", "ngModel"], [3, "click"], [3, "ngClass"], ["family", "default", "name", "case_sensitive", 3, "active"], [3, "itemHeight", "value", "isHeader", "index", "role"], [1, "igx-combo__empty"], ["role", "button", 1, "igx-combo__add-item", 3, "itemHeight", "tabindex", "index"], ["type", "button", "igxButton", "flat", "igxRipple", ""]],
        template: function IgxComboComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c61);
            i0.ɵɵelementStart(0, "igx-input-group", 11, 0);
            i0.ɵɵlistener("click", function IgxComboComponent_Template_igx_input_group_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵelementContainerStart(2, 12);
            i0.ɵɵprojection(3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(4, 13);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(6, 14);
            i0.ɵɵprojection(7, 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementStart(8, "input", 15, 1);
            i0.ɵɵlistener("blur", function IgxComboComponent_Template_input_blur_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(10, 16);
            i0.ɵɵprojection(11, 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(12, IgxComboComponent_Conditional_12_Template, 3, 3, "igx-suffix", 17);
            i0.ɵɵelementStart(13, "igx-suffix", 18);
            i0.ɵɵtemplate(14, IgxComboComponent_Conditional_14_Template, 1, 4, "ng-container")(15, IgxComboComponent_Conditional_15_Template, 1, 1, "igx-icon", 19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "igx-combo-drop-down", 20, 2);
            i0.ɵɵlistener("opening", function IgxComboComponent_Template_igx_combo_drop_down_opening_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpening($event));
            })("closing", function IgxComboComponent_Template_igx_combo_drop_down_closing_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosing($event));
            })("opened", function IgxComboComponent_Template_igx_combo_drop_down_opened_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpened());
            })("closed", function IgxComboComponent_Template_igx_combo_drop_down_closed_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosed());
            });
            i0.ɵɵtemplate(18, IgxComboComponent_Conditional_18_Template, 5, 3, "div", 21)(19, IgxComboComponent_ng_container_19_Template, 1, 0, "ng-container", 22);
            i0.ɵɵelementStart(20, "div", 23, 3);
            i0.ɵɵlistener("focus", function IgxComboComponent_Template_div_focus_20_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dropdown.onFocus());
            });
            i0.ɵɵtemplate(22, IgxComboComponent_igx_combo_item_22_Template, 3, 7, "igx-combo-item", 24);
            i0.ɵɵpipe(23, "comboFiltering");
            i0.ɵɵpipe(24, "comboGrouping");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(25, IgxComboComponent_Conditional_25_Template, 3, 2, "div", 25)(26, IgxComboComponent_ng_container_26_Template, 1, 0, "ng-container", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, IgxComboComponent_ng_template_27_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(29, IgxComboComponent_ng_template_29_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(31, IgxComboComponent_ng_template_31_Template, 2, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(33, IgxComboComponent_ng_template_33_Template, 2, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(35, IgxComboComponent_ng_template_35_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type === "search" ? "box" : ctx.type);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("value", ctx.displayValue)("disabled", ctx.disabled);
            i0.ɵɵattribute("placeholder", ctx.placeholder)("aria-expanded", !ctx.dropdown.collapsed)("aria-controls", ctx.dropdown.listId)("aria-labelledby", ctx.ariaLabelledBy || (ctx.label == null ? null : ctx.label.id) || ctx.placeholder);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.displayValue ? 12 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.toggleIconTemplate ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggleIconTemplate ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("labelledBy", ctx.ariaLabelledBy || (ctx.label == null ? null : ctx.label.id) || ctx.placeholder || "")("width", ctx.itemsWidth || "100%");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.displaySearchInput ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("overflow", "hidden")("max-height", ctx.itemsMaxHeightInRem, "rem");
            i0.ɵɵproperty("igxDropDownItemNavigation", ctx.dropdown)("tabindex", ctx.dropdown.collapsed ? -1 : 0);
            i0.ɵɵattribute("id", ctx.dropdown.id)("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("igxForOf", i0.ɵɵpipeBindV(24, 36, i0.ɵɵpureFunction5(49, _c64, i0.ɵɵpipeBindV(23, 29, i0.ɵɵpureFunction6(42, _c63, ctx.data, ctx.filterValue, ctx.displayKey, ctx.filteringOptions, ctx.filterFunction, ctx.disableFiltering)), ctx.groupKey, ctx.valueKey, ctx.groupSortingDirection, ctx.compareCollator)))("igxForInitialChunkSize", 10)("igxForContainerSize", ctx.itemsMaxHeight || ctx.containerSize)("igxForItemSize", ctx.itemHeight || ctx.itemSize)("igxForScrollOrientation", "vertical");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.filteredData.length === 0 || ctx.isAddButtonVisible() ? 25 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.footerTemplate);
          }
        },
        dependencies: [NgTemplateOutlet, NgClass, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IgxInputGroupComponent, IgxInputDirective, IgxSuffixDirective, IgxIconComponent, IgxComboDropDownComponent, IgxDropDownItemNavigationDirective, IgxForOfDirective, IgxComboItemComponent, IgxComboAddItemComponent, IgxButtonDirective, IgxRippleDirective, IgxComboFilteringPipe, IgxComboGroupingPipe],
        encapsulation: 2
      });
    }
  }
  return IgxComboComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Combo directives collection for ease-of-use import in standalone components scenario */
const IGX_COMBO_DIRECTIVES = [IgxComboComponent, IgxComboAddItemDirective, IgxComboClearIconDirective, IgxComboEmptyDirective, IgxComboFooterDirective, IgxComboHeaderDirective, IgxComboHeaderItemDirective, IgxComboItemDirective, IgxComboToggleIconDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];

/**
 * Represents a drop-down list that provides filtering functionality, allowing users to choose a single option from a predefined list.
 *
 * @igxModule IgxSimpleComboModule
 * @igxTheme igx-combo-theme
 * @igxKeywords combobox, single combo selection
 * @igxGroup Grids & Lists
 *
 * @remarks
 * It provides the ability to filter items as well as perform single selection on the provided data.
 * Additionally, it exposes keyboard navigation and custom styling capabilities.
 * @example
 * ```html
 * <igx-simple-combo [itemsMaxHeight]="250" [data]="locationData"
 *  [displayKey]="'field'" [valueKey]="'field'"
 *  placeholder="Location" searchPlaceholder="Search...">
 * </igx-simple-combo>
 * ```
 */
let IgxSimpleComboComponent = /*#__PURE__*/(() => {
  class IgxSimpleComboComponent extends IgxComboBaseDirective {
    get value() {
      return this._value[0];
    }
    /**
     * Get current selection state
     *
     * @returns The selected item, if any
     * ```typescript
     * let mySelection = this.combo.selection;
     * ```
     */
    get selection() {
      return super.selection[0];
    }
    /** @hidden @internal */
    get filteredData() {
      return this._filteredData;
    }
    /** @hidden @internal */
    set filteredData(val) {
      this._filteredData = this.groupKey ? (val || []).filter(e => e.isHeader !== true) : val;
      this.checkMatch();
    }
    /** @hidden @internal */
    get searchValue() {
      return this._searchValue;
    }
    set searchValue(val) {
      this._searchValue = val;
    }
    get selectedItem() {
      return this.selectionService.get(this.id).values().next().value;
    }
    get hasSelectedItem() {
      return !!this.selectionService.get(this.id).size;
    }
    constructor(elementRef, cdr, selectionService, comboAPI, platformUtil, document, _inputGroupType, _injector, _iconService, formGroupDirective) {
      super(elementRef, cdr, selectionService, comboAPI, document, _inputGroupType, _injector, _iconService);
      this.platformUtil = platformUtil;
      this.formGroupDirective = formGroupDirective;
      /**
       * Emitted when item selection is changing, before the selection completes
       *
       * ```html
       * <igx-simple-combo (selectionChanging)='handleSelection()'></igx-simple-combo>
       * ```
       */
      this.selectionChanging = new EventEmitter();
      /** @hidden @internal */
      this.composing = false;
      this._updateInput = true;
      this._collapsing = false;
      this.findAllMatches = element => {
        const value = this.displayKey ? element[this.displayKey] : element;
        if (value === null || value === undefined || value === '') {
          // we can accept null, undefined and empty strings as empty display values
          return true;
        }
        const searchValue = this.searchValue || this.comboInput.value;
        return !!searchValue && value.toString().toLowerCase().includes(searchValue.toLowerCase());
      };
      this.comboAPI.register(this);
    }
    /** @hidden @internal */
    onArrowDown(event) {
      if (this.collapsed) {
        event.preventDefault();
        event.stopPropagation();
        this.open();
      } else {
        if (this.virtDir.igxForOf.length > 0 && !this.hasSelectedItem) {
          this.dropdown.navigateNext();
          this.dropdownContainer.nativeElement.focus();
        } else if (this.allowCustomValues) {
          this.addItem?.element.nativeElement.focus();
        }
      }
    }
    /**
     * Select a defined item
     *
     * @param item the item to be selected
     * ```typescript
     * this.combo.select("New York");
     * ```
     */
    select(item) {
      if (item !== undefined) {
        const newSelection = this.selectionService.add_items(this.id, item instanceof Array ? item : [item], true);
        this.setSelection(newSelection);
      }
    }
    /**
     * Deselect the currently selected item
     *
     * @param item the items to be deselected
     * ```typescript
     * this.combo.deselect("New York");
     * ```
     */
    deselect() {
      this.clearSelection();
    }
    /** @hidden @internal */
    writeValue(value) {
      const oldSelection = super.selection;
      this.selectionService.select_items(this.id, this.isValid(value) ? [value] : [], true);
      this.cdr.markForCheck();
      this._displayValue = this.createDisplayText(super.selection, oldSelection);
      this._value = this.valueKey ? super.selection.map(item => item[this.valueKey]) : super.selection;
      this.filterValue = this._displayValue?.toString() || '';
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.virtDir.contentSizeChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (super.selection.length > 0) {
          const index = this.virtDir.igxForOf.findIndex(e => {
            let current = e ? e[this.valueKey] : undefined;
            if (this.valueKey === null || this.valueKey === undefined) {
              current = e;
            }
            return current === super.selection[0];
          });
          if (!this.isRemote) {
            // navigate to item only if we have local data
            // as with remote data this will fiddle with igxFor's scroll handler
            // and will trigger another chunk load which will break the visualization
            this.dropdown.navigateItem(index);
          }
        }
      });
      this.dropdown.opening.pipe(takeUntil(this.destroy$)).subscribe(args => {
        if (args.cancel) {
          return;
        }
        this._collapsing = false;
        const filtered = this.filteredData.find(this.findAllMatches);
        if (filtered === undefined || filtered === null) {
          this.filterValue = this.searchValue = this.comboInput.value;
          return;
        }
      });
      this.dropdown.opened.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.composing) {
          this.comboInput.focus();
        }
      });
      this.dropdown.closing.pipe(takeUntil(this.destroy$)).subscribe(args => {
        if (args.cancel) {
          return;
        }
        if (this.getEditElement() && !args.event) {
          this._collapsing = true;
        } else {
          this.clearOnBlur();
          this._onTouchedCallback();
        }
        this.comboInput.focus();
      });
      // in reactive form the control is not present initially
      // and sets the selection to an invalid value in writeValue method
      if (!this.isValid(this.selectedItem)) {
        this.selectionService.clear(this.id);
        this._displayValue = '';
      }
      super.ngAfterViewInit();
    }
    /** @hidden @internal */
    ngDoCheck() {
      if (this.data?.length && super.selection.length && !this._displayValue) {
        this._displayValue = this.createDisplayText(super.selection, []);
        this._value = this.valueKey ? super.selection.map(item => item[this.valueKey]) : super.selection;
      }
    }
    /** @hidden @internal */
    handleInputChange(event) {
      if (this.collapsed && this.comboInput.focused) {
        this.open();
      }
      if (event !== undefined) {
        this.filterValue = this.searchValue = typeof event === 'string' ? event : event.target.value;
      }
      if (!this.comboInput.value.trim() && super.selection.length) {
        // handle clearing of input by space
        this.clearSelection();
        this._onChangeCallback(null);
        this.filterValue = '';
      }
      if (super.selection.length) {
        const args = {
          newValue: undefined,
          oldValue: this.selectedItem,
          newSelection: undefined,
          oldSelection: this.selection,
          displayText: typeof event === 'string' ? event : event?.target?.value,
          owner: this,
          cancel: false
        };
        this.selectionChanging.emit(args);
        if (!args.cancel) {
          this.selectionService.select_items(this.id, [], true);
        }
      }
      // when filtering the focused item should be the first item or the currently selected item
      if (!this.dropdown.focusedItem || this.dropdown.focusedItem.id !== this.dropdown.items[0].id) {
        this.dropdown.navigateFirst();
      }
      super.handleInputChange(event);
      this.composing = true;
    }
    /** @hidden @internal */
    handleInputClick() {
      if (this.collapsed) {
        this.open();
        this.comboInput.focus();
      }
    }
    /** @hidden @internal */
    handleKeyDown(event) {
      if (event.key === this.platformUtil.KEYMAP.ENTER) {
        const filtered = this.filteredData.find(this.findAllMatches);
        if (filtered === null || filtered === undefined) {
          return;
        }
        if (!this.dropdown.collapsed) {
          const focusedItem = this.dropdown.focusedItem;
          if (focusedItem && !focusedItem.isHeader) {
            this.select(focusedItem.itemID);
            event.preventDefault();
            event.stopPropagation();
            this.close();
          } else {
            event.preventDefault();
            event.stopPropagation();
            this.comboInput.focus();
          }
        }
        // manually trigger text selection as it will not be triggered during editing
        this.textSelection.trigger();
        return;
      }
      if (event.key === this.platformUtil.KEYMAP.BACKSPACE || event.key === this.platformUtil.KEYMAP.DELETE) {
        this._updateInput = false;
        this.clearSelection(true);
      }
      if (!this.collapsed && event.key === this.platformUtil.KEYMAP.TAB) {
        const filtered = this.filteredData.find(this.findAllMatches);
        if (filtered === null || filtered === undefined) {
          this.clearOnBlur();
          this.close();
          return;
        }
        const focusedItem = this.dropdown.focusedItem;
        if (focusedItem && !focusedItem.isHeader) {
          this.select(focusedItem.itemID);
          this.close();
          this.textSelection.trigger();
        } else {
          this.clearOnBlur();
          this.close();
        }
      }
      this.composing = false;
      super.handleKeyDown(event);
    }
    /** @hidden @internal */
    handleKeyUp(event) {
      if (event.key === this.platformUtil.KEYMAP.ARROW_DOWN) {
        this.dropdown.focusedItem = this.hasSelectedItem && this.filteredData.length > 0 ? this.dropdown.items.find(i => i.itemID === this.selectedItem) : this.dropdown.items[0];
        this.dropdownContainer.nativeElement.focus();
      }
    }
    /** @hidden @internal */
    handleItemKeyDown(event) {
      if (event.key === this.platformUtil.KEYMAP.ARROW_UP && event.altKey) {
        this.close();
        this.comboInput.focus();
        return;
      }
      if (event.key === this.platformUtil.KEYMAP.ENTER) {
        this.comboInput.focus();
      }
    }
    /** @hidden @internal */
    handleItemClick() {
      this.close();
      this.comboInput.focus();
    }
    /** @hidden @internal */
    onBlur() {
      // when clicking the toggle button to close the combo and immediately clicking outside of it
      // the collapsed state is not modified as the dropdown is still not closed
      if (this.collapsed || this._collapsing) {
        this.clearOnBlur();
      }
      super.onBlur();
    }
    /** @hidden @internal */
    getEditElement() {
      return this.comboInput.nativeElement;
    }
    /** @hidden @internal */
    handleClear(event) {
      if (this.disabled) {
        return;
      }
      const oldSelection = this.selection;
      this.clearSelection(true);
      if (!this.collapsed) {
        this.focusSearchInput(true);
      }
      event.stopPropagation();
      if (this.selection !== oldSelection) {
        this.comboInput.value = this.filterValue = this.searchValue = '';
      }
      this.dropdown.focusedItem = null;
      this.composing = false;
      this.comboInput.focus();
    }
    /** @hidden @internal */
    handleOpened() {
      this.triggerCheck();
      if (!this.comboInput.focused) {
        this.dropdownContainer.nativeElement.focus();
      }
      this.opened.emit({
        owner: this
      });
    }
    /** @hidden @internal */
    handleClosing(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: e.cancel
      };
      this.closing.emit(args);
      e.cancel = args.cancel;
      if (e.cancel) {
        return;
      }
      this.composing = false;
      // explicitly update selection so that we don't have to force CD
      this.textSelection.selected = true;
    }
    /** @hidden @internal */
    focusSearchInput(opening) {
      if (opening) {
        this.dropdownContainer.nativeElement.focus();
      } else {
        this.comboInput.nativeElement.focus();
      }
    }
    /** @hidden @internal */
    onClick(event) {
      super.onClick(event);
      if (this.comboInput.value.length === 0) {
        this.virtDir.scrollTo(0);
      }
    }
    setSelection(newSelection) {
      const newValueAsArray = newSelection ? Array.from(newSelection) : [];
      const oldValueAsArray = Array.from(this.selectionService.get(this.id) || []);
      const newItems = this.convertKeysToItems(newValueAsArray);
      const oldItems = this.convertKeysToItems(oldValueAsArray);
      const displayText = this.createDisplayText(this.convertKeysToItems(newValueAsArray), oldValueAsArray);
      const args = {
        newValue: newValueAsArray[0],
        oldValue: oldValueAsArray[0],
        newSelection: newItems[0],
        oldSelection: oldItems[0],
        displayText,
        owner: this,
        cancel: false
      };
      if (args.newSelection !== args.oldSelection) {
        this.selectionChanging.emit(args);
      }
      // TODO: refactor below code as it sets the selection and the display text
      if (!args.cancel) {
        let argsSelection = this.isValid(args.newValue) ? args.newValue : [];
        argsSelection = Array.isArray(argsSelection) ? argsSelection : [argsSelection];
        this.selectionService.select_items(this.id, argsSelection, true);
        this._value = argsSelection;
        if (this._updateInput) {
          this.comboInput.value = this._displayValue = this.searchValue = displayText !== args.displayText ? args.displayText : this.createDisplayText(super.selection, [args.oldValue]);
        }
        this._onChangeCallback(args.newValue);
        this._updateInput = true;
      } else if (this.isRemote) {
        this.registerRemoteEntries(newValueAsArray, false);
      } else {
        args.displayText = this.createDisplayText(oldItems, []);
        const oldSelectionArray = args.oldSelection ? [args.oldSelection] : [];
        this.comboInput.value = this._displayValue = this.searchValue = this.createDisplayText(oldSelectionArray, []);
        if (this.isRemote) {
          this.registerRemoteEntries(newValueAsArray, false);
        }
      }
    }
    createDisplayText(newSelection, oldSelection) {
      if (this.isRemote) {
        const selection = this.valueKey ? newSelection.map(item => item[this.valueKey]) : newSelection;
        return this.getRemoteSelection(selection, oldSelection);
      }
      if (this.displayKey !== null && this.displayKey !== undefined && newSelection.length > 0) {
        return newSelection.filter(e => e).map(e => e[this.displayKey])[0]?.toString() || '';
      }
      return newSelection[0]?.toString() || '';
    }
    getRemoteSelection(newSelection, oldSelection) {
      if (!newSelection.length) {
        this.registerRemoteEntries(oldSelection, false);
        return '';
      }
      this.registerRemoteEntries(oldSelection, false);
      this.registerRemoteEntries(newSelection);
      return Object.keys(this._remoteSelection).map(e => this._remoteSelection[e])[0] || '';
    }
    /** Contains key-value pairs of the selected valueKeys and their resp. displayKeys */
    registerRemoteEntries(ids, add = true) {
      const selection = this.getValueDisplayPairs(ids)[0];
      if (add && selection) {
        this._remoteSelection[selection[this.valueKey]] = selection[this.displayKey].toString();
      } else {
        this._remoteSelection = {};
      }
    }
    clearSelection(ignoreFilter) {
      let newSelection = this.selectionService.get_empty();
      if (this.filteredData.length !== this.data.length && !ignoreFilter) {
        newSelection = this.selectionService.delete_items(this.id, this.selectionService.get_all_ids(this.filteredData, this.valueKey));
      }
      if (this.selectionService.get(this.id).size > 0 || this.comboInput.value.trim()) {
        this.setSelection(newSelection);
      }
    }
    clearOnBlur() {
      if (this.isRemote) {
        const searchValue = this.searchValue || this.comboInput.value;
        const remoteValue = Object.keys(this._remoteSelection).map(e => this._remoteSelection[e])[0] || '';
        if (searchValue !== remoteValue) {
          this.clear();
        }
        return;
      }
      const filtered = this.filteredData.find(this.findMatch);
      // selecting null in primitive data returns undefined as the search text is '', but the item is null
      if (filtered === undefined && this.selectedItem !== null || !super.selection.length) {
        this.clear();
      }
    }
    getElementVal(element) {
      const elementVal = this.displayKey ? element[this.displayKey] : element;
      return String(elementVal);
    }
    clear() {
      this.clearSelection(true);
      const oldSelection = this.selection;
      if (this.selection !== oldSelection) {
        this.comboInput.value = this._displayValue = this.searchValue = '';
      }
    }
    isValid(value) {
      if (this.formGroupDirective && value === null) {
        return false;
      }
      if (this.required) {
        return value !== null && value !== '' && value !== undefined;
      }
      return value !== undefined;
    }
    static {
      this.ɵfac = function IgxSimpleComboComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSimpleComboComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxSelectionAPIService), i0.ɵɵdirectiveInject(IgxComboAPIService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(i0.Injector, 8), i0.ɵɵdirectiveInject(IgxIconService, 8), i0.ɵɵdirectiveInject(i4.FormGroupDirective, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSimpleComboComponent,
        selectors: [["igx-simple-combo"]],
        viewQuery: function IgxSimpleComboComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxComboDropDownComponent, 7);
            i0.ɵɵviewQuery(IgxComboAddItemComponent, 5);
            i0.ɵɵviewQuery(IgxTextSelectionDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addItem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textSelection = _t.first);
          }
        },
        hostBindings: function IgxSimpleComboComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.ArrowDown", function IgxSimpleComboComponent_keydown_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            })("keydown.Alt.ArrowDown", function IgxSimpleComboComponent_keydown_Alt_ArrowDown_HostBindingHandler($event) {
              return ctx.onArrowDown($event);
            });
          }
        },
        outputs: {
          selectionChanging: "selectionChanging"
        },
        features: [i0.ɵɵProvidersFeature([IgxComboAPIService, {
          provide: IGX_COMBO_COMPONENT,
          useExisting: IgxSimpleComboComponent
        }, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxSimpleComboComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c62,
        decls: 37,
        vars: 55,
        consts: [["inputGroup", ""], ["comboInput", ""], ["igxComboDropDown", ""], ["dropdownItemContainer", ""], ["complex", ""], ["primitive", ""], ["empty", ""], ["addItemDefault", ""], ["headerItemBase", ""], ["listItem", ""], ["addItem", ""], [3, "type"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["ngProjectAs", "igx-hint, [igxHint]", 5, ["igx-hint"]], ["igxInput", "", "role", "combobox", "aria-haspopup", "listbox", "aria-autocomplete", "list", "aria-readonly", "false", 3, "input", "click", "keyup", "keydown", "blur", "paste", "value", "disabled", "igxTextSelection"], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], [1, "igx-combo__clear-button"], [1, "igx-combo__toggle-button", 3, "click"], ["family", "default", 3, "name"], [1, "igx-combo__drop-down", 3, "opening", "closing", "opened", "closed", "labelledBy", "width", "singleMode"], [4, "ngTemplateOutlet"], [1, "igx-combo__content", 3, "focus", "keydown", "igxDropDownItemNavigation", "tabindex"], [3, "role", "singleMode", "itemHeight", "value", "isHeader", "index", "click", 4, "igxFor", "igxForOf", "igxForInitialChunkSize", "igxForContainerSize", "igxForItemSize", "igxForScrollOrientation"], [1, "igx-combo__add"], [1, "igx-combo__clear-button", 3, "click"], ["family", "default", "name", "input_clear"], ["family", "default", "name", "case_sensitive", 3, "click", "active"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "click", "role", "singleMode", "itemHeight", "value", "isHeader", "index"], [1, "igx-combo__empty"], ["role", "button", 1, "igx-combo__add-item", 3, "itemHeight", "tabindex", "index"], ["type", "button", "igxButton", "flat", "igxRipple", ""]],
        template: function IgxSimpleComboComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c61);
            i0.ɵɵelementStart(0, "igx-input-group", 11, 0);
            i0.ɵɵelementContainerStart(2, 12);
            i0.ɵɵprojection(3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(4, 13);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(6, 14);
            i0.ɵɵprojection(7, 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementStart(8, "input", 15, 1);
            i0.ɵɵlistener("input", function IgxSimpleComboComponent_Template_input_input_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleInputChange($event));
            })("click", function IgxSimpleComboComponent_Template_input_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleInputClick());
            })("keyup", function IgxSimpleComboComponent_Template_input_keyup_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleKeyUp($event));
            })("keydown", function IgxSimpleComboComponent_Template_input_keydown_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleKeyDown($event));
            })("blur", function IgxSimpleComboComponent_Template_input_blur_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            })("paste", function IgxSimpleComboComponent_Template_input_paste_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleInputChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(10, 16);
            i0.ɵɵprojection(11, 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(12, IgxSimpleComboComponent_Conditional_12_Template, 3, 3, "igx-suffix", 17)(13, IgxSimpleComboComponent_Conditional_13_Template, 2, 1, "igx-suffix");
            i0.ɵɵelementStart(14, "igx-suffix", 18);
            i0.ɵɵlistener("click", function IgxSimpleComboComponent_Template_igx_suffix_click_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵtemplate(15, IgxSimpleComboComponent_Conditional_15_Template, 1, 4, "ng-container")(16, IgxSimpleComboComponent_Conditional_16_Template, 1, 1, "igx-icon", 19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "igx-combo-drop-down", 20, 2);
            i0.ɵɵlistener("opening", function IgxSimpleComboComponent_Template_igx_combo_drop_down_opening_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpening($event));
            })("closing", function IgxSimpleComboComponent_Template_igx_combo_drop_down_closing_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosing($event));
            })("opened", function IgxSimpleComboComponent_Template_igx_combo_drop_down_opened_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpened());
            })("closed", function IgxSimpleComboComponent_Template_igx_combo_drop_down_closed_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosed());
            });
            i0.ɵɵtemplate(19, IgxSimpleComboComponent_ng_container_19_Template, 1, 0, "ng-container", 21);
            i0.ɵɵelementStart(20, "div", 22, 3);
            i0.ɵɵlistener("focus", function IgxSimpleComboComponent_Template_div_focus_20_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dropdown.onFocus());
            })("keydown", function IgxSimpleComboComponent_Template_div_keydown_20_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleItemKeyDown($event));
            });
            i0.ɵɵtemplate(22, IgxSimpleComboComponent_igx_combo_item_22_Template, 3, 8, "igx-combo-item", 23);
            i0.ɵɵpipe(23, "comboFiltering");
            i0.ɵɵpipe(24, "comboGrouping");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(25, IgxSimpleComboComponent_Conditional_25_Template, 3, 2, "div", 24)(26, IgxSimpleComboComponent_ng_container_26_Template, 1, 0, "ng-container", 21);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, IgxSimpleComboComponent_ng_template_27_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(29, IgxSimpleComboComponent_ng_template_29_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(31, IgxSimpleComboComponent_ng_template_31_Template, 2, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(33, IgxSimpleComboComponent_ng_template_33_Template, 2, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(35, IgxSimpleComboComponent_ng_template_35_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("value", ctx.displayValue)("disabled", ctx.disabled)("igxTextSelection", !ctx.composing);
            i0.ɵɵattribute("aria-expanded", !ctx.dropdown.collapsed)("aria-controls", ctx.dropdown.listId)("aria-labelledby", ctx.ariaLabelledBy || (ctx.label == null ? null : ctx.label.id) || ctx.placeholder)("placeholder", ctx.placeholder);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.hasSelectedItem ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSearchCaseIcon ? 13 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.toggleIconTemplate ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggleIconTemplate ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("labelledBy", ctx.ariaLabelledBy || (ctx.label == null ? null : ctx.label.id) || ctx.placeholder || "")("width", ctx.itemsWidth || "100%")("singleMode", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("overflow", "hidden")("max-height", ctx.itemsMaxHeightInRem, "rem");
            i0.ɵɵproperty("igxDropDownItemNavigation", ctx.dropdown)("tabindex", ctx.dropdown.collapsed ? -1 : 0);
            i0.ɵɵattribute("id", ctx.dropdown.id)("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("igxForOf", i0.ɵɵpipeBindV(24, 37, i0.ɵɵpureFunction5(49, _c64, i0.ɵɵpipeBindV(23, 31, i0.ɵɵpureFunction5(43, _c64, ctx.data, ctx.filterValue, ctx.displayKey, ctx.filteringOptions, ctx.filterFunction)), ctx.groupKey, ctx.valueKey, ctx.groupSortingDirection, ctx.compareCollator)))("igxForInitialChunkSize", 10)("igxForContainerSize", ctx.itemsMaxHeight || ctx.containerSize)("igxForItemSize", ctx.itemHeight || ctx.itemSize)("igxForScrollOrientation", "vertical");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.filteredData.length === 0 || ctx.isAddButtonVisible() ? 25 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.footerTemplate);
          }
        },
        dependencies: [IgxInputGroupComponent, IgxInputDirective, IgxTextSelectionDirective, IgxSuffixDirective, NgTemplateOutlet, IgxIconComponent, IgxComboDropDownComponent, IgxDropDownItemNavigationDirective, IgxForOfDirective, IgxComboItemComponent, IgxComboAddItemComponent, IgxButtonDirective, IgxRippleDirective, IgxComboFilteringPipe, IgxComboGroupingPipe],
        encapsulation: 2
      });
    }
  }
  return IgxSimpleComboComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Simple combo directives collection for ease-of-use import in standalone components scenario */
const IGX_SIMPLE_COMBO_DIRECTIVES = [IgxSimpleComboComponent, IgxComboAddItemDirective, IgxComboClearIconDirective, IgxComboEmptyDirective, IgxComboFooterDirective, IgxComboHeaderDirective, IgxComboHeaderItemDirective, IgxComboItemDirective, IgxComboToggleIconDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];

/**
 * Templates the default toggle icon in the picker.
 *
 * @remarks Can be applied to IgxDatePickerComponent, IgxTimePickerComponent, IgxDateRangePickerComponent
 *
 * @example
 * ```html
 * <igx-date-range-picker>
 *   <igx-picker-toggle igxSuffix>
 *      <igx-icon>calendar_view_day</igx-icon>
 *   </igx-picker-toggle>
 * </igx-date-range-picker>
 * ```
 */
let IgxPickerToggleComponent = /*#__PURE__*/(() => {
  class IgxPickerToggleComponent {
    constructor() {
      this.clicked = new EventEmitter();
    }
    onClick(event) {
      // do not focus input on click
      event.stopPropagation();
      this.clicked.emit();
    }
    static {
      this.ɵfac = function IgxPickerToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPickerToggleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPickerToggleComponent,
        selectors: [["igx-picker-toggle"]],
        hostBindings: function IgxPickerToggleComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxPickerToggleComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        outputs: {
          clicked: "clicked"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxPickerToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxPickerToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Templates the default clear icon in the picker.
 *
 * @remarks Can be applied to IgxDatePickerComponent, IgxTimePickerComponent, IgxDateRangePickerComponent
 *
 * @example
 * ```html
 * <igx-date-picker>
 *   <igx-picker-clear igxSuffix>
 *      <igx-icon>delete</igx-icon>
 *   </igx-picker-clear>
 * </igx-date-picker>
 * ```
 */
let IgxPickerClearComponent = /*#__PURE__*/(() => {
  class IgxPickerClearComponent extends IgxPickerToggleComponent {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxPickerClearComponent_BaseFactory;
        return function IgxPickerClearComponent_Factory(__ngFactoryType__) {
          return (ɵIgxPickerClearComponent_BaseFactory || (ɵIgxPickerClearComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxPickerClearComponent)))(__ngFactoryType__ || IgxPickerClearComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPickerClearComponent,
        selectors: [["igx-picker-clear"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxPickerClearComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxPickerClearComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxPickerActionsDirective can be used to re-template the dropdown/dialog action buttons.
 *
 * @remarks Can be applied to IgxDatePickerComponent, IgxTimePickerComponent, IgxDateRangePickerComponent
 *
 */
let IgxPickerActionsDirective = /*#__PURE__*/(() => {
  class IgxPickerActionsDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxPickerActionsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPickerActionsDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPickerActionsDirective,
        selectors: [["", "igxPickerActions", ""]]
      });
    }
  }
  return IgxPickerActionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DatePickerResourceStringsEN = {
  igx_date_picker_change_date: 'Change Date',
  igx_date_picker_choose_date: 'Choose Date'
};

/** Header orientation in `dialog` mode. */
const PickerHeaderOrientation = /*@__PURE__*/mkenum({
  Horizontal: 'horizontal',
  Vertical: 'vertical'
});
/**
 * This enumeration is used to configure whether the date/time picker has an editable input with drop down
 * or is readonly - the date/time is selected only through a dialog.
 */
const PickerInteractionMode = /*@__PURE__*/mkenum({
  DropDown: 'dropdown',
  Dialog: 'dialog'
});

/** @hidden */
let IgxCalendarContainerComponent = /*#__PURE__*/(() => {
  class IgxCalendarContainerComponent {
    constructor() {
      this.calendarClose = new EventEmitter();
      this.todaySelection = new EventEmitter();
      this.styleClass = 'igx-date-picker';
      this.vertical = false;
      this.mode = PickerInteractionMode.DropDown;
    }
    get dropdownCSS() {
      return this.mode === PickerInteractionMode.DropDown;
    }
    onEscape(event) {
      event.preventDefault();
      this.calendarClose.emit();
    }
    get isReadonly() {
      return this.mode === PickerInteractionMode.Dialog;
    }
    static {
      this.ɵfac = function IgxCalendarContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCalendarContainerComponent,
        selectors: [["igx-calendar-container"]],
        viewQuery: function IgxCalendarContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxCalendarComponent, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendar = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function IgxCalendarContainerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.alt.arrowup", function IgxCalendarContainerComponent_keydown_alt_arrowup_HostBindingHandler($event) {
              return ctx.onEscape($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-date-picker", ctx.styleClass)("igx-date-picker--dropdown", ctx.dropdownCSS);
          }
        },
        outputs: {
          calendarClose: "calendarClose",
          todaySelection: "todaySelection"
        },
        decls: 5,
        vars: 2,
        consts: [["defaultPickerActions", ""], ["closeButton", ""], ["todayButton", ""], [1, "igx-date-picker__actions"], [1, "igx-date-picker__buttons"], ["type", "button", "igxButton", "flat", "igxRipple", ""], ["type", "button", "igxButton", "flat", "igxRipple", "", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function IgxCalendarContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxCalendarContainerComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelement(2, "igx-calendar");
            i0.ɵɵtemplate(3, IgxCalendarContainerComponent_Conditional_3_Template, 1, 0, "igx-divider")(4, IgxCalendarContainerComponent_Conditional_4_Template, 2, 4, "div", 3);
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((ctx.pickerActions == null ? null : ctx.pickerActions.template) || ctx.closeButtonLabel || ctx.todayButtonLabel ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.pickerActions == null ? null : ctx.pickerActions.template) || ctx.closeButtonLabel || ctx.todayButtonLabel ? 4 : -1);
          }
        },
        dependencies: [IgxButtonDirective, IgxRippleDirective, IgxCalendarComponent, NgTemplateOutlet, IgxDividerDirective],
        styles: ["[_nghost-%COMP%]{display:block}"]
      });
    }
  }
  return IgxCalendarContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PickerBaseDirective = /*#__PURE__*/(() => {
  class PickerBaseDirective {
    /**
     * @example
     * ```html
     * <igx-date-picker locale="jp"></igx-date-picker>
     * ```
     */
    /**
     * Gets the `locale` of the date-picker.
     * If not set, defaults to applciation's locale..
     */
    get locale() {
      return this._locale;
    }
    /**
     * Sets the `locale` of the date-picker.
     * Expects a valid BCP 47 language tag.
     */
    set locale(value) {
      this._locale = value;
      // if value is invalid, set it back to _localeId
      try {
        getLocaleFirstDayOfWeek(this._locale);
      } catch (e) {
        this._locale = this._localeId;
      }
    }
    /**
     * Gets the start day of the week.
     * Can return a numeric or an enum representation of the week day.
     * If not set, defaults to the first day of the week for the application locale.
     */
    get weekStart() {
      return this._weekStart ?? getLocaleFirstDayOfWeek(this._locale);
    }
    /**
     * Sets the start day of the week.
     * Can be assigned to a numeric value or to `WEEKDAYS` enum value.
     */
    set weekStart(value) {
      this._weekStart = value;
    }
    /**
     * Determines how the picker's input will be styled.
     *
     * @remarks
     * Default is `box`.
     *
     * @example
     * ```html
     * <igx-date-picker [type]="'line'"></igx-date-picker>
     * ```
     */
    set type(val) {
      this._type = val;
    }
    get type() {
      return this._type || this._inputGroupType;
    }
    /**
     * Gets the picker's pop-up state.
     *
     * @example
     * ```typescript
     * const state = this.picker.collapsed;
     * ```
     */
    get collapsed() {
      return this._collapsed;
    }
    /** @hidden @internal */
    get isDropdown() {
      return this.mode === PickerInteractionMode.DropDown;
    }
    /**
     * Returns if there's focus within the picker's element OR popup container
     * @hidden @internal
     */
    get isFocused() {
      const document = this.element.nativeElement?.getRootNode();
      if (!document?.activeElement) return false;
      return this.element.nativeElement.contains(document.activeElement) || !this.collapsed && this.toggleContainer.contains(document.activeElement);
    }
    constructor(element, _localeId, _inputGroupType) {
      this.element = element;
      this._localeId = _localeId;
      this._inputGroupType = _inputGroupType;
      /**
       * Sets the `placeholder` of the picker's input.
       *
       * @example
       * ```html
       * <igx-date-picker [placeholder]="'Choose your date'"></igx-date-picker>
       * ```
       */
      this.placeholder = '';
      /**
       * Can be `dropdown` with editable input field or `dialog` with readonly input field.
       *
       * @remarks
       * Default mode is `dropdown`
       *
       * @example
       * ```html
       * <igx-date-picker mode="dialog"></igx-date-picker>
       * ```
       */
      this.mode = PickerInteractionMode.DropDown;
      /**
       * Enables or disables the picker.
       *
       * @example
       * ```html
       * <igx-date-picker [disabled]="'true'"></igx-date-picker>
       * ```
       */
      this.disabled = false;
      /**
       * Emitted when the calendar has started opening, cancelable.
       *
       * @example
       * ```html
       * <igx-date-picker (opening)="handleOpening($event)"></igx-date-picker>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emitted after the calendar has opened.
       *
       * @example
       * ```html
       * <igx-date-picker (opened)="handleOpened($event)"></igx-date-picker>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emitted when the calendar has started closing, cancelable.
       *
       * @example
       * ```html
       * <igx-date-picker (closing)="handleClosing($event)"></igx-date-picker>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emitted after the calendar has closed.
       *
       * @example
       * ```html
       * <igx-date-picker (closed)="handleClosed($event)"></igx-date-picker>
       * ```
       */
      this.closed = new EventEmitter();
      this._collapsed = true;
      this._destroy$ = new Subject();
      this.locale = this.locale || this._localeId;
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.subToIconsClicked(this.toggleComponents, () => this.open());
      this.toggleComponents.changes.pipe(takeUntil(this._destroy$)).subscribe(() => this.subToIconsClicked(this.toggleComponents, () => this.open()));
    }
    /** @hidden @internal */
    ngAfterContentChecked() {
      if (this.inputGroup && this.prefixes?.length > 0) {
        this.inputGroup.prefixes = this.prefixes;
      }
      if (this.inputGroup && this.suffixes?.length > 0) {
        this.inputGroup.suffixes = this.suffixes;
      }
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this._destroy$.next();
      this._destroy$.complete();
    }
    /** Subscribes to the click events of toggle/clear icons in a query */
    subToIconsClicked(components, next) {
      components.forEach(toggle => {
        toggle.clicked.pipe(takeUntil(merge(components.changes, this._destroy$))).subscribe(next);
      });
    }
    static {
      this.ɵfac = function PickerBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PickerBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: PickerBaseDirective,
        contentQueries: function PickerBaseDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxPickerToggleComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPrefixDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxSuffixDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixes = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixes = _t);
          }
        },
        viewQuery: function PickerBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxInputGroupComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputGroup = _t.first);
          }
        },
        inputs: {
          inputFormat: "inputFormat",
          displayFormat: "displayFormat",
          placeholder: "placeholder",
          mode: "mode",
          overlaySettings: "overlaySettings",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          locale: "locale",
          weekStart: "weekStart",
          outlet: "outlet",
          type: "type",
          tabIndex: "tabIndex"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed"
        }
      });
    }
  }
  return PickerBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$e = 0;
/**
 * Date Picker displays a popup calendar that lets users select a single date.
 *
 * @igxModule IgxDatePickerModule
 * @igxTheme igx-calendar-theme, igx-icon-theme
 * @igxGroup Scheduling
 * @igxKeywords datepicker, calendar, schedule, date
 * @example
 * ```html
 * <igx-date-picker [(ngModel)]="selectedDate"></igx-date-picker>
 * ```
 */
let IgxDatePickerComponent = /*#__PURE__*/(() => {
  class IgxDatePickerComponent extends PickerBaseDirective {
    /**
     * Gets/Sets the disabled dates descriptors.
     *
     * @example
     * ```typescript
     * let disabledDates = this.datepicker.disabledDates;
     * this.datePicker.disabledDates = [ {type: DateRangeType.Weekends}, ...];
     * ```
     */
    get disabledDates() {
      return this._disabledDates;
    }
    set disabledDates(value) {
      this._disabledDates = value;
      this._onValidatorChange();
    }
    /**
     * Gets/Sets the special dates descriptors.
     *
     * @example
     * ```typescript
     * let specialDates = this.datepicker.specialDates;
     * this.datePicker.specialDates = [ {type: DateRangeType.Weekends}, ... ];
     * ```
     */
    get specialDates() {
      return this._specialDates;
    }
    set specialDates(value) {
      this._specialDates = value;
    }
    //#endregion
    /**
     * Gets/Sets the selected date.
     *
     *  @example
     * ```html
     * <igx-date-picker [value]="date"></igx-date-picker>
     * ```
     */
    get value() {
      return this._value;
    }
    set value(date) {
      this._value = date;
      this.setDateValue(date);
      if (this.dateTimeEditor.value !== date) {
        this.dateTimeEditor.value = this._dateValue;
      }
      this.valueChange.emit(this.dateValue);
      this._onChangeCallback(this.dateValue);
    }
    /**
     * The minimum value the picker will accept.
     *
     * @example
     * <igx-date-picker [minValue]="minDate"></igx-date-picker>
     */
    set minValue(value) {
      this._minValue = value;
      this._onValidatorChange();
    }
    get minValue() {
      return this._minValue;
    }
    /**
     * The maximum value the picker will accept.
     *
     * @example
     * <igx-date-picker [maxValue]="maxDate"></igx-date-picker>
     */
    set maxValue(value) {
      this._maxValue = value;
      this._onValidatorChange();
    }
    get maxValue() {
      return this._maxValue;
    }
    get dialogOverlaySettings() {
      return Object.assign({}, this._dialogOverlaySettings, this.overlaySettings);
    }
    get dropDownOverlaySettings() {
      return Object.assign({}, this._dropDownOverlaySettings, this.overlaySettings);
    }
    get inputGroupElement() {
      return this.inputGroup?.element.nativeElement;
    }
    get dateValue() {
      return this._dateValue;
    }
    get pickerFormatViews() {
      return Object.assign({}, this._defFormatViews, this.formatViews);
    }
    get pickerCalendarFormat() {
      return Object.assign({}, this._calendarFormat, this.calendarFormat);
    }
    constructor(element, _localeId, _overlayService, _injector, _renderer, platform, cdr, _inputGroupType) {
      super(element, _localeId, _inputGroupType);
      this._overlayService = _overlayService;
      this._injector = _injector;
      this._renderer = _renderer;
      this.platform = platform;
      this.cdr = cdr;
      /**
       * Gets/Sets the number of month views displayed.
       *
       * @remarks
       * Default value is `1`.
       *
       * @example
       * ```html
       * <igx-date-picker [displayMonthsCount]="2"></igx-date-picker>
       * ```
       * @example
       * ```typescript
       * let monthViewsDisplayed = this.datePicker.displayMonthsCount;
       * ```
       */
      this.displayMonthsCount = 1;
      /**
       * Gets/Sets the orientation of the `IgxDatePickerComponent` header.
       *
       *  @example
       * ```html
       * <igx-date-picker headerOrientation="vertical"></igx-date-picker>
       * ```
       */
      this.headerOrientation = PickerHeaderOrientation.Horizontal;
      /**
       * Specify if the currently spun date segment should loop over.
       *
       *  @example
       * ```html
       * <igx-date-picker [spinLoop]="false"></igx-date-picker>
       * ```
       */
      this.spinLoop = true;
      /**
       * Gets/Sets the value of `id` attribute.
       *
       * @remarks If not provided it will be automatically generated.
       * @example
       * ```html
       * <igx-date-picker [id]="'igx-date-picker-3'" cancelButtonLabel="cancel" todayButtonLabel="today"></igx-date-picker>
       * ```
       */
      this.id = `igx-date-picker-${NEXT_ID$e++}`;
      /** @hidden @internal */
      this.readOnly = false;
      /**
       * Emitted when the picker's value changes.
       *
       * @remarks
       * Used for `two-way` bindings.
       *
       * @example
       * ```html
       * <igx-date-picker [(value)]="date"></igx-date-picker>
       * ```
       */
      this.valueChange = new EventEmitter();
      /**
       * Emitted when the user types/spins invalid date in the date-picker editor.
       *
       *  @example
       * ```html
       * <igx-date-picker (validationFailed)="onValidationFailed($event)"></igx-date-picker>
       * ```
       */
      this.validationFailed = new EventEmitter();
      /** @hidden @internal */
      this.displayValue = {
        transform: date => this.formatter(date)
      };
      this._resourceStrings = getCurrentResourceStrings(DatePickerResourceStringsEN);
      this._ngControl = null;
      this._specialDates = null;
      this._disabledDates = null;
      this._overlaySubFilter = [filter(x => x.id === this._overlayId), takeUntil(this._destroy$)];
      this._dropDownOverlaySettings = {
        target: this.inputGroupElement,
        closeOnOutsideClick: true,
        modal: false,
        closeOnEscape: true,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new AutoPositionStrategy({
          openAnimation: fadeIn,
          closeAnimation: fadeOut
        })
      };
      this._dialogOverlaySettings = {
        closeOnOutsideClick: true,
        modal: true,
        closeOnEscape: true
      };
      this._calendarFormat = {
        day: 'numeric',
        month: 'short',
        weekday: 'short',
        year: 'numeric'
      };
      this._defFormatViews = {
        day: false,
        month: true,
        year: false
      };
      this._onChangeCallback = noop;
      this._onTouchedCallback = noop;
      this._onValidatorChange = noop;
      this.onStatusChanged = () => {
        this.disabled = this._ngControl.disabled;
        this.updateValidity();
        this.inputGroup.isRequired = this.required;
      };
      this.locale = this.locale || this._localeId;
    }
    /** @hidden @internal */
    get required() {
      if (this._ngControl && this._ngControl.control && this._ngControl.control.validator) {
        // Run the validation with empty object to check if required is enabled.
        const error = this._ngControl.control.validator({});
        return error && error.required;
      }
      return false;
    }
    /** @hidden @internal */
    get pickerResourceStrings() {
      return Object.assign({}, this._resourceStrings, this.resourceStrings);
    }
    get toggleContainer() {
      return this._calendarContainer;
    }
    /** @hidden @internal */
    onKeyDown(event) {
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_UP:
          if (event.altKey) {
            this.close();
          }
          break;
        case this.platform.KEYMAP.ARROW_DOWN:
          if (event.altKey) {
            this.open();
          }
          break;
        case this.platform.KEYMAP.SPACE:
          event.preventDefault();
          this.open();
          break;
      }
    }
    /**
     * Opens the picker's dropdown or dialog.
     *
     * @example
     * ```html
     * <igx-date-picker #picker></igx-date-picker>
     *
     * <button type="button" igxButton (click)="picker.open()">Open Dialog</button>
     * ```
     */
    open(settings) {
      if (!this.collapsed || this.disabled) {
        return;
      }
      const overlaySettings = Object.assign({}, this.isDropdown ? this.dropDownOverlaySettings : this.dialogOverlaySettings, settings);
      if (this.isDropdown && this.inputGroupElement) {
        overlaySettings.target = this.inputGroupElement;
      }
      if (this.outlet) {
        overlaySettings.outlet = this.outlet;
      }
      this._overlayId = this._overlayService.attach(IgxCalendarContainerComponent, this.viewContainerRef, overlaySettings);
      this._overlayService.show(this._overlayId);
    }
    /**
     * Toggles the picker's dropdown or dialog
     *
     * @example
     * ```html
     * <igx-date-picker #picker></igx-date-picker>
     *
     * <button type="button" igxButton (click)="picker.toggle()">Toggle Dialog</button>
     * ```
     */
    toggle(settings) {
      if (this.collapsed) {
        this.open(settings);
      } else {
        this.close();
      }
    }
    /**
     * Closes the picker's dropdown or dialog.
     *
     * @example
     * ```html
     * <igx-date-picker #picker></igx-date-picker>
     *
     * <button type="button" igxButton (click)="picker.close()">Close Dialog</button>
     * ```
     */
    close() {
      if (!this.collapsed) {
        this._overlayService.hide(this._overlayId);
      }
    }
    /**
     * Selects a date.
     *
     * @remarks Updates the value in the input field.
     *
     * @example
     * ```typescript
     * this.datePicker.select(date);
     * ```
     * @param date passed date that has to be set to the calendar.
     */
    select(value) {
      this.value = value;
    }
    /**
     * Selects today's date and closes the picker.
     *
     * @example
     * ```html
     * <igx-date-picker #picker></igx-date-picker>
     *
     * <button type="button" igxButton (click)="picker.selectToday()">Select Today</button>
     * ```
     * */
    selectToday() {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      this.select(today);
      this.close();
    }
    /**
     * Clears the input field and the picker's value.
     *
     * @example
     * ```typescript
     * this.datePicker.clear();
     * ```
     */
    clear() {
      if (!this.disabled) {
        this._calendar?.deselectDate();
        this.dateTimeEditor.clear();
      }
    }
    /**
     * Increment a specified `DatePart`.
     *
     * @param datePart The optional DatePart to increment. Defaults to Date.
     * @param delta The optional delta to increment by. Overrides `spinDelta`.
     * @example
     * ```typescript
     * this.datePicker.increment(DatePart.Date);
     * ```
     */
    increment(datePart, delta) {
      this.dateTimeEditor.increment(datePart, delta);
    }
    /**
     * Decrement a specified `DatePart`
     *
     * @param datePart The optional DatePart to decrement. Defaults to Date.
     * @param delta The optional delta to decrement by. Overrides `spinDelta`.
     * @example
     * ```typescript
     * this.datePicker.decrement(DatePart.Date);
     * ```
     */
    decrement(datePart, delta) {
      this.dateTimeEditor.decrement(datePart, delta);
    }
    //#region Control Value Accessor
    /** @hidden @internal */
    writeValue(value) {
      this._value = value;
      this.setDateValue(value);
      if (this.dateTimeEditor.value !== value) {
        this.dateTimeEditor.value = this._dateValue;
      }
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    //#endregion
    //#region Validator
    /** @hidden @internal */
    registerOnValidatorChange(fn) {
      this._onValidatorChange = fn;
    }
    /** @hidden @internal */
    validate(control) {
      if (!control.value) {
        return null;
      }
      // InvalidDate handling
      if (isDate(control.value) && !DateTimeUtil.isValidDate(control.value)) {
        return {
          value: true
        };
      }
      const errors = {};
      const value = DateTimeUtil.isValidDate(control.value) ? control.value : DateTimeUtil.parseIsoDate(control.value);
      if (value && this.disabledDates && isDateInRanges(value, this.disabledDates)) {
        Object.assign(errors, {
          dateIsDisabled: true
        });
      }
      Object.assign(errors, DateTimeUtil.validateMinMax(value, this.minValue, this.maxValue, false));
      return Object.keys(errors).length > 0 ? errors : null;
    }
    //#endregion
    /** @hidden @internal */
    ngOnInit() {
      this._ngControl = this._injector.get(NgControl, null);
      this.locale = this.locale || this._localeId;
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.subscribeToClick();
      this.subscribeToOverlayEvents();
      this.subscribeToDateEditorEvents();
      this.subToIconsClicked(this.clearComponents, () => this.clear());
      this.clearComponents.changes.pipe(takeUntil(this._destroy$)).subscribe(() => this.subToIconsClicked(this.clearComponents, () => this.clear()));
      this._dropDownOverlaySettings.excludeFromOutsideClick = [this.inputGroup.element.nativeElement];
      fromEvent(this.inputDirective.nativeElement, 'blur').pipe(takeUntil(this._destroy$)).subscribe(() => {
        if (this.collapsed) {
          this._onTouchedCallback();
          this.updateValidity();
        }
      });
      if (this._ngControl) {
        this._statusChanges$ = this._ngControl.statusChanges.subscribe(this.onStatusChanged.bind(this));
        if (this._ngControl.control.validator) {
          this.inputGroup.isRequired = this.required;
          this.cdr.detectChanges();
        }
      }
    }
    /** @hidden @internal */
    ngAfterViewChecked() {
      if (this.labelDirective) {
        this._renderer.setAttribute(this.inputDirective.nativeElement, 'aria-labelledby', this.labelDirective.id);
      }
    }
    /** @hidden @internal */
    ngOnDestroy() {
      super.ngOnDestroy();
      if (this._statusChanges$) {
        this._statusChanges$.unsubscribe();
      }
      if (this._overlayId) {
        this._overlayService.detach(this._overlayId);
        delete this._overlayId;
      }
    }
    /** @hidden @internal */
    getEditElement() {
      return this.inputDirective.nativeElement;
    }
    subscribeToClick() {
      fromEvent(this.getEditElement(), 'click').pipe(takeUntil(this._destroy$)).subscribe(() => {
        if (!this.isDropdown) {
          this.toggle();
        }
      });
    }
    setDateValue(value) {
      if (isDate(value) && isNaN(value.getTime())) {
        this._dateValue = value;
        return;
      }
      this._dateValue = DateTimeUtil.isValidDate(value) ? value : DateTimeUtil.parseIsoDate(value);
    }
    updateValidity() {
      // B.P. 18 May 2021: IgxDatePicker does not reset its state upon resetForm #9526
      if (this._ngControl && !this.disabled && this.isTouchedOrDirty) {
        if (this.hasValidators && this.inputGroup.isFocused) {
          this.inputDirective.valid = this._ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
        } else {
          this.inputDirective.valid = this._ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
        }
      } else {
        this.inputDirective.valid = IgxInputState.INITIAL;
      }
    }
    get isTouchedOrDirty() {
      return this._ngControl.control.touched || this._ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this._ngControl.control.validator || !!this._ngControl.control.asyncValidator;
    }
    handleSelection(date) {
      if (this.dateValue && DateTimeUtil.isValidDate(this.dateValue)) {
        date.setHours(this.dateValue.getHours());
        date.setMinutes(this.dateValue.getMinutes());
        date.setSeconds(this.dateValue.getSeconds());
        date.setMilliseconds(this.dateValue.getMilliseconds());
      }
      this.value = date;
      this._calendar.viewDate = date;
      this.close();
    }
    subscribeToDateEditorEvents() {
      this.dateTimeEditor.valueChange.pipe(takeUntil(this._destroy$)).subscribe(val => {
        this.value = val;
      });
      this.dateTimeEditor.validationFailed.pipe(takeUntil(this._destroy$)).subscribe(event => {
        this.validationFailed.emit({
          owner: this,
          prevValue: event.oldValue,
          currentValue: this.value
        });
      });
    }
    subscribeToOverlayEvents() {
      this._overlayService.opening.pipe(...this._overlaySubFilter).subscribe(e => {
        const args = {
          owner: this,
          event: e.event,
          cancel: e.cancel
        };
        this.opening.emit(args);
        e.cancel = args.cancel;
        if (args.cancel) {
          this._overlayService.detach(this._overlayId);
          return;
        }
        this._initializeCalendarContainer(e.componentRef.instance);
        this._calendarContainer = e.componentRef.location.nativeElement;
        this._collapsed = false;
      });
      this._overlayService.opened.pipe(...this._overlaySubFilter).subscribe(() => {
        this.opened.emit({
          owner: this
        });
        this._calendar.wrapper?.nativeElement?.focus();
        if (this._targetViewDate) {
          this._targetViewDate.setHours(0, 0, 0, 0);
          // INFO: We need to set the active date to the target view date so there's something to
          // navigate when the calendar is opened.
          this._calendar.activeDate = this._targetViewDate;
        }
      });
      this._overlayService.closing.pipe(...this._overlaySubFilter).subscribe(e => {
        const args = {
          owner: this,
          event: e.event,
          cancel: e.cancel
        };
        this.closing.emit(args);
        e.cancel = args.cancel;
        if (args.cancel) {
          return;
        }
        // do not focus the input if clicking outside in dropdown mode
        const outsideEvent = args.event && args.event.key !== this.platform.KEYMAP.ESCAPE;
        if (this.getEditElement() && !(outsideEvent && this.isDropdown)) {
          this.inputDirective.focus();
        } else {
          this._onTouchedCallback();
          this.updateValidity();
        }
      });
      this._overlayService.closed.pipe(...this._overlaySubFilter).subscribe(() => {
        this.closed.emit({
          owner: this
        });
        this._overlayService.detach(this._overlayId);
        this._collapsed = true;
        this._overlayId = null;
        this._calendar = null;
        this._calendarContainer = undefined;
      });
    }
    getMinMaxDates() {
      const minValue = DateTimeUtil.isValidDate(this.minValue) ? this.minValue : DateTimeUtil.parseIsoDate(this.minValue);
      const maxValue = DateTimeUtil.isValidDate(this.maxValue) ? this.maxValue : DateTimeUtil.parseIsoDate(this.maxValue);
      return {
        minValue,
        maxValue
      };
    }
    setDisabledDates() {
      this._calendar.disabledDates = this.disabledDates ? [...this.disabledDates] : [];
      const {
        minValue,
        maxValue
      } = this.getMinMaxDates();
      if (minValue) {
        this._calendar.disabledDates.push({
          type: DateRangeType.Before,
          dateRange: [minValue]
        });
      }
      if (maxValue) {
        this._calendar.disabledDates.push({
          type: DateRangeType.After,
          dateRange: [maxValue]
        });
      }
    }
    _initializeCalendarContainer(componentInstance) {
      this._calendar = componentInstance.calendar;
      this._calendar.hasHeader = !this.isDropdown;
      this._calendar.formatOptions = this.pickerCalendarFormat;
      this._calendar.formatViews = this.pickerFormatViews;
      this._calendar.locale = this.locale;
      this._calendar.weekStart = this.weekStart;
      this._calendar.specialDates = this.specialDates;
      this._calendar.headerTitleTemplate = this.headerTitleTemplate;
      this._calendar.headerTemplate = this.headerTemplate;
      this._calendar.subheaderTemplate = this.subheaderTemplate;
      this._calendar.headerOrientation = this.headerOrientation;
      this._calendar.hideOutsideDays = this.hideOutsideDays;
      this._calendar.monthsViewNumber = this.displayMonthsCount;
      this._calendar.showWeekNumbers = this.showWeekNumbers;
      this._calendar.selected.pipe(takeUntil(this._destroy$)).subscribe(ev => this.handleSelection(ev));
      this.setDisabledDates();
      if (DateTimeUtil.isValidDate(this.dateValue)) {
        // calendar will throw if the picker's value is InvalidDate #9208
        this._calendar.value = this.dateValue;
      }
      this.setCalendarViewDate();
      componentInstance.mode = this.mode;
      // componentInstance.headerOrientation = this.headerOrientation;
      componentInstance.closeButtonLabel = this.cancelButtonLabel;
      componentInstance.todayButtonLabel = this.todayButtonLabel;
      componentInstance.pickerActions = this.pickerActions;
      componentInstance.calendarClose.pipe(takeUntil(this._destroy$)).subscribe(() => this.close());
      componentInstance.todaySelection.pipe(takeUntil(this._destroy$)).subscribe(() => this.selectToday());
    }
    setCalendarViewDate() {
      const {
        minValue,
        maxValue
      } = this.getMinMaxDates();
      const dateValue = DateTimeUtil.isValidDate(this.dateValue) ? this.dateValue : new Date();
      if (minValue && DateTimeUtil.lessThanMinValue(dateValue, minValue)) {
        this._calendar.viewDate = this._targetViewDate = minValue;
        return;
      }
      if (maxValue && DateTimeUtil.greaterThanMaxValue(dateValue, maxValue)) {
        this._calendar.viewDate = this._targetViewDate = maxValue;
        return;
      }
      this._calendar.viewDate = this._targetViewDate = dateValue;
    }
    static {
      this.ɵfac = function IgxDatePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDatePickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDatePickerComponent,
        selectors: [["igx-date-picker"]],
        contentQueries: function IgxDatePickerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxLabelDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarHeaderTitleTemplateDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarHeaderTemplateDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxCalendarSubheaderTemplateDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPickerActionsDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPickerClearComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTitleTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subheaderTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pickerActions = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearComponents = _t);
          }
        },
        viewQuery: function IgxDatePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxDateTimeEditorDirective, 7);
            i0.ɵɵviewQuery(IgxInputGroupComponent, 5, ViewContainerRef);
            i0.ɵɵviewQuery(IgxLabelDirective, 5);
            i0.ɵɵviewQuery(IgxInputDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateTimeEditor = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputDirective = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function IgxDatePickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxDatePickerComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
          }
        },
        inputs: {
          hideOutsideDays: [2, "hideOutsideDays", "hideOutsideDays", booleanAttribute],
          displayMonthsCount: "displayMonthsCount",
          showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute],
          formatter: "formatter",
          headerOrientation: "headerOrientation",
          todayButtonLabel: "todayButtonLabel",
          cancelButtonLabel: "cancelButtonLabel",
          spinLoop: [2, "spinLoop", "spinLoop", booleanAttribute],
          spinDelta: "spinDelta",
          outlet: "outlet",
          id: "id",
          formatViews: "formatViews",
          disabledDates: "disabledDates",
          specialDates: "specialDates",
          calendarFormat: "calendarFormat",
          value: "value",
          minValue: "minValue",
          maxValue: "maxValue",
          resourceStrings: "resourceStrings",
          readOnly: [2, "readOnly", "readOnly", booleanAttribute]
        },
        outputs: {
          valueChange: "valueChange",
          validationFailed: "validationFailed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxDatePickerComponent,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: IgxDatePickerComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c68,
        decls: 12,
        vars: 17,
        consts: [[3, "type"], ["igxInput", "", "aria-haspopup", "dialog", "aria-autocomplete", "none", "role", "combobox", 1, "igx-date-picker__input-date", 3, "displayValuePipe", "igxDateTimeEditor", "displayFormat", "minValue", "maxValue", "spinDelta", "spinLoop", "disabled", "placeholder", "readonly", "igxTextSelection", "locale"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], ["ngProjectAs", "igx-hint", 5, ["igx-hint"]], [3, "click"], ["family", "default", "name", "today", 3, "title"], ["family", "default", "name", "input_clear"]],
        template: function IgxDatePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c67);
            i0.ɵɵelementStart(0, "igx-input-group", 0);
            i0.ɵɵtemplate(1, IgxDatePickerComponent_Conditional_1_Template, 2, 1, "igx-prefix");
            i0.ɵɵelement(2, "input", 1);
            i0.ɵɵtemplate(3, IgxDatePickerComponent_Conditional_3_Template, 2, 0, "igx-suffix");
            i0.ɵɵelementContainerStart(4, 2);
            i0.ɵɵprojection(5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(6, 3);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(8, 4);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(10, 5);
            i0.ɵɵprojection(11, 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggleComponents.length ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayValuePipe", ctx.formatter ? ctx.displayValue : null)("igxDateTimeEditor", ctx.inputFormat)("displayFormat", ctx.displayFormat)("minValue", ctx.minValue)("maxValue", ctx.maxValue)("spinDelta", ctx.spinDelta)("spinLoop", ctx.spinLoop)("disabled", ctx.disabled)("placeholder", ctx.placeholder)("readonly", !ctx.isDropdown || ctx.readOnly)("igxTextSelection", ctx.isDropdown && !ctx.readOnly)("locale", ctx.locale);
            i0.ɵɵattribute("aria-expanded", !ctx.collapsed)("aria-labelledby", ctx.label == null ? null : ctx.label.id);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.clearComponents.length && ctx.value ? 3 : -1);
          }
        },
        dependencies: [IgxInputGroupComponent, IgxPrefixDirective, IgxIconComponent, IgxInputDirective, IgxDateTimeEditorDirective, IgxTextSelectionDirective, IgxSuffixDirective],
        styles: ["[_nghost-%COMP%]{display:block}"]
      });
    }
  }
  return IgxDatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Date picker directives collection for ease-of-use import in standalone components scenario */
const IGX_DATE_PICKER_DIRECTIVES = [IgxDatePickerComponent, IgxPickerToggleComponent, IgxPickerClearComponent, IgxPickerActionsDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];
let DIALOG_ID = 0;
/**
 * **Ignite UI for Angular Dialog Window** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/dialog.html)
 *
 * The Ignite UI Dialog Window presents a dialog window to the user which can simply display messages or display
 * more complicated visuals such as a user sign-in form.  It also provides a right and left button
 * which can be used for custom actions.
 *
 * Example:
 * ```html
 * <button type="button" igxButton (click)="form.open()">Show Dialog</button>
 * <igx-dialog #form title="Sign In" rightButtonLabel="OK">
 *   <div>
 *     <igx-input-group>
 *       <input type="text" igxInput/>
 *       <label igxLabel>Username</label>
 *     </igx-input-group>
 *   </div>
 *   <div>
 *     <igx-input-group>
 *       <input type="password" igxInput/>
 *       <label igxLabel>Password</label>
 *     </igx-input-group>
 *   </div>
 * </igx-dialog>
 * ```
 */
let IgxDialogComponent = /*#__PURE__*/(() => {
  class IgxDialogComponent {
    static {
      this.NEXT_ID = 1;
    }
    static {
      this.DIALOG_CLASS = 'igx-dialog';
    }
    /**
     * Controls whether the dialog should be shown as modal. Defaults to `true`
     * ```html
     * <igx-dialog [isModal]="false" ></igx-dialog>
     * ```
     */
    get isModal() {
      return this._isModal;
    }
    set isModal(val) {
      this._overlayDefaultSettings.modal = val;
      this._isModal = val;
    }
    /**
     * Controls whether the dialog should close when `Esc` key is pressed. Defaults to `true`
     * ```html
     * <igx-dialog [closeOnEscape]="false" ></igx-dialog>
     * ```
     */
    get closeOnEscape() {
      return this._closeOnEscape;
    }
    set closeOnEscape(val) {
      this._overlayDefaultSettings.closeOnEscape = val;
      this._closeOnEscape = val;
    }
    /**
     * Gets/Sets whether the dialog should close on click outside the component. By default it's false.
     * ```html
     * <igx-dialog closeOnOutsideSelect="true" leftButtonLabel="Cancel" (leftButtonSelect)="dialog.close()"
     * rightButtonLabel="OK" rightButtonRipple="#4CAF50" (rightButtonSelect)="onDialogOKSelected($event)">
     * </igx-dialog>
     * ```
     */
    get closeOnOutsideSelect() {
      return this._closeOnOutsideSelect;
    }
    set closeOnOutsideSelect(val) {
      this._overlayDefaultSettings.closeOnOutsideClick = val;
      this._closeOnOutsideSelect = val;
    }
    /**
     * Get the position and animation settings used by the dialog.
     * ```typescript
     * @ViewChild('alert', { static: true }) public alert: IgxDialogComponent;
     * let currentPosition: PositionSettings = this.alert.positionSettings
     * ```
     */
    get positionSettings() {
      return this._positionSettings;
    }
    /**
     * Set the position and animation settings used by the dialog.
     * ```typescript
     * import { slideInLeft, slideOutRight } from 'igniteui-angular';
     * ...
     * @ViewChild('alert', { static: true }) public alert: IgxDialogComponent;
     *  public newPositionSettings: PositionSettings = {
     *      openAnimation: useAnimation(slideInTop, { params: { duration: '2000ms' } }),
     *      closeAnimation: useAnimation(slideOutBottom, { params: { duration: '2000ms'} }),
     *      horizontalDirection: HorizontalAlignment.Left,
     *      verticalDirection: VerticalAlignment.Middle,
     *      horizontalStartPoint: HorizontalAlignment.Left,
     *      verticalStartPoint: VerticalAlignment.Middle,
     *      minSize: { height: 100, width: 100 }
     *  };
     * this.alert.positionSettings = this.newPositionSettings;
     * ```
     */
    set positionSettings(settings) {
      this._positionSettings = settings;
      this._overlayDefaultSettings.positionStrategy = new GlobalPositionStrategy(this._positionSettings);
    }
    /**
     * @hidden
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * Returns the value of state. Possible state values are "open" or "close".
     * ```typescript
     * @ViewChild("MyDialog")
     * public dialog: IgxDialogComponent;
     * ngAfterViewInit() {
     *     let dialogState = this.dialog.state;
     * }
     * ```
     */
    get state() {
      return this.isOpen ? 'open' : 'close';
    }
    /**
     * State of the dialog.
     *
     * ```typescript
     * // get
     * let dialogIsOpen = this.dialog.isOpen;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-dialog [isOpen]='false'></igx-dialog>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <!--set-->
     * <igx-dialog [(isOpen)]='model.isOpen'></igx-dialog>
     * ```
     */
    get isOpen() {
      return this.toggleRef ? !this.toggleRef.collapsed : false;
    }
    set isOpen(value) {
      if (value !== this.isOpen) {
        this.isOpenChange.emit(value);
        if (value) {
          requestAnimationFrame(() => {
            this.open();
          });
        } else {
          this.close();
        }
      }
    }
    get isCollapsed() {
      return this.toggleRef.collapsed;
    }
    /**
     * Returns the value of the role of the dialog. The valid values are `dialog`, `alertdialog`, `alert`.
     * ```typescript
     * @ViewChild("MyDialog")
     * public dialog: IgxDialogComponent;
     * ngAfterViewInit() {
     *     let dialogRole = this.dialog.role;
     * }
     *  ```
     */
    get role() {
      if (this.leftButtonLabel !== '' && this.rightButtonLabel !== '') {
        return 'dialog';
      } else if (this.leftButtonLabel !== '' || this.rightButtonLabel !== '') {
        return 'alertdialog';
      } else {
        return 'alert';
      }
    }
    /**
     * Returns the value of the title id.
     * ```typescript
     *  @ViewChild("MyDialog")
     * public dialog: IgxDialogComponent;
     * ngAfterViewInit() {
     *     let dialogTitle = this.dialog.titleId;
     * }
     * ```
     */
    get titleId() {
      return this._titleId;
    }
    constructor(elementRef, navService) {
      this.elementRef = elementRef;
      this.navService = navService;
      /**
       * Sets the value of the `id` attribute. If not provided it will be automatically generated.
       * ```html
       * <igx-dialog [id]="'igx-dialog-56'" #alert title="Notification"
       *  leftButtonLabel="OK" (leftButtonSelect)="alert.close()">
       * </igx-dialog>
       * ```
       */
      this.id = `igx-dialog-${DIALOG_ID++}`;
      /**
       * Set whether the Tab key focus is trapped within the dialog when opened.
       * Defaults to `true`.
       * ```html
       * <igx-dialog focusTrap="false""></igx-dialog>
       * ```
       */
      this.focusTrap = true;
      /**
       * Sets the title of the dialog.
       * ```html
       * <igx-dialog title="Notification" #alert leftButtonLabel="OK" (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.title = '';
      /**
       *  Sets the message text of the dialog.
       * ```html
       * <igx-dialog message="Your email was sent!" #alert leftButtonLabel="OK" (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.message = '';
      /**
       * Sets the `label` of the left button of the dialog.
       * ```html
       * <igx-dialog leftButtonLabel="OKAY" #alert title="Notification"  (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.leftButtonLabel = '';
      /**
       * Sets the left button `type`. The types are `flat`, `contained` and `fab`.
       * The `flat` type button is a rectangle and doesn't have a shadow. <br>
       * The `contained` type button is also a rectangle but has a shadow. <br>
       * The `fab` type button is a circle with a shadow. <br>
       * The default value is `flat`.
       * ```html
       * <igx-dialog leftButtonType="contained" leftButtonLabel="OKAY" #alert (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.leftButtonType = 'flat';
      /**
       * Sets the left button `ripple`. The `ripple` animates a click/tap to a component as a series of fading waves.
       * The property accepts all valid CSS color property values.
       * ```html
       * <igx-dialog leftButtonRipple="green" leftButtonLabel="OKAY" #alert (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.leftButtonRipple = '';
      /**
       * Sets the `label` of the right button of the dialog.
       * ```html
       * <igx-dialog rightButtonLabel="OKAY" #alert title="Notification"  (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.rightButtonLabel = '';
      /**
       * Sets the right button `type`. The types are `flat`, `contained` and `fab`.
       * The `flat` type button is a rectangle and doesn't have a shadow. <br>
       * The `contained` type button is also a rectangle but has a shadow. <br>
       * The `fab` type button is a circle with a shadow. <br>
       * The default value is `flat`.
       * ```html
       * <igx-dialog rightButtonType="fab" rightButtonLabel="OKAY" #alert (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.rightButtonType = 'flat';
      /**
       * Sets the right button `ripple`.
       * ```html
       * <igx-dialog rightButtonRipple="green" rightButtonLabel="OKAY" #alert (leftButtonSelect)="alert.close()"></igx-dialog>
       * ```
       */
      this.rightButtonRipple = '';
      /**
       * The default `tabindex` attribute for the component
       *
       * @hidden
       */
      this.tabindex = -1;
      /**
       * An event that is emitted before the dialog is opened.
       * ```html
       * <igx-dialog (opening)="onDialogOpenHandler($event)" (leftButtonSelect)="dialog.close()" rightButtonLabel="OK">
       * </igx-dialog>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * An event that is emitted after the dialog is opened.
       * ```html
       * <igx-dialog (opened)="onDialogOpenedHandler($event)" (leftButtonSelect)="dialog.close()" rightButtonLabel="OK">
       * </igx-dialog>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * An event that is emitted before the dialog is closed.
       * ```html
       * <igx-dialog (closing)="onDialogCloseHandler($event)" title="Confirmation" leftButtonLabel="Cancel" rightButtonLabel="OK">
       * </igx-dialog>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * An event that is emitted after the dialog is closed.
       * ```html
       * <igx-dialog (closed)="onDialogClosedHandler($event)" title="Confirmation" leftButtonLabel="Cancel" rightButtonLabel="OK">
       * </igx-dialog>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * An event that is emitted when the left button is clicked.
       * ```html
       * <igx-dialog (leftButtonSelect)="onDialogOKSelected($event)" #dialog leftButtonLabel="OK" rightButtonLabel="Cancel">
       * </igx-dialog>
       * ```
       */
      this.leftButtonSelect = new EventEmitter();
      /**
       * An event that is emitted when the right button is clicked.
       * ```html
       * <igx-dialog (rightButtonSelect)="onDialogOKSelected($event)"
       * #dialog title="Confirmation" (leftButtonSelect)="dialog.close()" rightButtonLabel="OK"
       * rightButtonRipple="#4CAF50" closeOnOutsideSelect="true">
       * </igx-dialog>
       * ```
       */
      this.rightButtonSelect = new EventEmitter();
      /**
       * @hidden
       */
      this.isOpenChange = new EventEmitter();
      this.destroy$ = new Subject();
      this._positionSettings = {
        openAnimation: fadeIn,
        closeAnimation: fadeOut
      };
      this._closeOnOutsideSelect = false;
      this._closeOnEscape = true;
      this._isModal = true;
      this._titleId = IgxDialogComponent.NEXT_ID++ + '_title';
      this._overlayDefaultSettings = {
        positionStrategy: new GlobalPositionStrategy(this._positionSettings),
        scrollStrategy: new NoOpScrollStrategy(),
        modal: this.isModal,
        closeOnEscape: this._closeOnEscape,
        closeOnOutsideClick: this.closeOnOutsideSelect
      };
    }
    ngAfterContentInit() {
      this.toggleRef.closing.pipe(takeUntil(this.destroy$)).subscribe(eventArgs => this.emitCloseFromDialog(eventArgs));
      this.toggleRef.closed.pipe(takeUntil(this.destroy$)).subscribe(eventArgs => this.emitClosedFromDialog(eventArgs));
      this.toggleRef.opened.pipe(takeUntil(this.destroy$)).subscribe(eventArgs => this.emitOpenedFromDialog(eventArgs));
    }
    /**
     * A method that opens the dialog.
     *
     * @memberOf {@link IgxDialogComponent}
     * ```html
     * <button type="button" (click)="dialog.open() igxButton="contained">Trigger Dialog</button>
     * <igx-dialog #dialog></igx-dialog>
     * ```
     */
    open(overlaySettings = this._overlayDefaultSettings) {
      const eventArgs = {
        dialog: this,
        event: null,
        cancel: false
      };
      this.opening.emit(eventArgs);
      if (!eventArgs.cancel) {
        overlaySettings = {
          ...{},
          ...this._overlayDefaultSettings,
          ...overlaySettings
        };
        this.toggleRef.open(overlaySettings);
        this.isOpenChange.emit(true);
        if (!this.leftButtonLabel && !this.rightButtonLabel) {
          this.toggleRef.element.focus();
        }
      }
    }
    /**
     * A method that that closes the dialog.
     *
     *  @memberOf {@link IgxDialogComponent}
     * ```html
     * <button type="button" (click)="dialog.close() igxButton="contained">Trigger Dialog</button>
     * <igx-dialog #dialog></igx-dialog>
     * ```
     */
    close() {
      // `closing` will emit from `toggleRef.closing` subscription
      this.toggleRef?.close();
    }
    /**
     * A method that opens/closes the dialog.
     *
     * @memberOf {@link IgxDialogComponent}
     * ```html
     * <button type="button" (click)="dialog.toggle() igxButton="contained">Trigger Dialog</button>
     * <igx-dialog #dialog></igx-dialog>
     * ```
     */
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
    /**
     * @hidden
     */
    onDialogSelected(event) {
      event.stopPropagation();
      if (this.isOpen && this.closeOnOutsideSelect && event.target.classList.contains(IgxDialogComponent.DIALOG_CLASS)) {
        this.close();
      }
    }
    /**
     * @hidden
     */
    onInternalLeftButtonSelect(event) {
      this.leftButtonSelect.emit({
        dialog: this,
        event
      });
    }
    /**
     * @hidden
     */
    onInternalRightButtonSelect(event) {
      this.rightButtonSelect.emit({
        dialog: this,
        event
      });
    }
    /**
     * @hidden
     */
    ngOnInit() {
      if (this.navService && this.id) {
        this.navService.add(this.id, this);
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      if (this.navService && this.id) {
        this.navService.remove(this.id);
      }
    }
    emitCloseFromDialog(eventArgs) {
      const dialogEventsArgs = {
        dialog: this,
        event: eventArgs.event,
        cancel: eventArgs.cancel
      };
      this.closing.emit(dialogEventsArgs);
      eventArgs.cancel = dialogEventsArgs.cancel;
      if (!eventArgs.cancel) {
        this.isOpenChange.emit(false);
      }
    }
    emitClosedFromDialog(eventArgs) {
      this.closed.emit({
        dialog: this,
        event: eventArgs.event
      });
    }
    emitOpenedFromDialog(eventArgs) {
      this.opened.emit({
        dialog: this,
        event: eventArgs.event
      });
    }
    static {
      this.ɵfac = function IgxDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDialogComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxNavigationService, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDialogComponent,
        selectors: [["igx-dialog"]],
        viewQuery: function IgxDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxToggleDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleRef = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function IgxDialogComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("tabindex", ctx.tabindex);
            i0.ɵɵclassProp("igx-dialog--hidden", ctx.isCollapsed);
          }
        },
        inputs: {
          id: "id",
          isModal: [2, "isModal", "isModal", booleanAttribute],
          closeOnEscape: [2, "closeOnEscape", "closeOnEscape", booleanAttribute],
          focusTrap: [2, "focusTrap", "focusTrap", booleanAttribute],
          title: "title",
          message: "message",
          leftButtonLabel: "leftButtonLabel",
          leftButtonType: "leftButtonType",
          leftButtonRipple: "leftButtonRipple",
          rightButtonLabel: "rightButtonLabel",
          rightButtonType: "rightButtonType",
          rightButtonRipple: "rightButtonRipple",
          closeOnOutsideSelect: [2, "closeOnOutsideSelect", "closeOnOutsideSelect", booleanAttribute],
          positionSettings: "positionSettings",
          isOpen: [2, "isOpen", "isOpen", booleanAttribute],
          role: "role",
          titleId: "titleId"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed",
          leftButtonSelect: "leftButtonSelect",
          rightButtonSelect: "rightButtonSelect",
          isOpenChange: "isOpenChange"
        },
        ngContentSelectors: _c70,
        decls: 11,
        vars: 9,
        consts: [["dialog", ""], ["dialogWindow", ""], ["tabindex", "0", "igxToggle", "", 1, "igx-dialog", 3, "click", "igxFocusTrap"], [1, "igx-dialog__window"], [1, "igx-dialog__window-title"], [1, "igx-dialog__window-content"], [1, "igx-dialog__window-message"], [1, "igx-dialog__window-actions"], ["type", "button", 3, "igxFocus", "igxButton", "igxRipple"], ["type", "button", 3, "click", "igxFocus", "igxButton", "igxRipple"]],
        template: function IgxDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c69);
            i0.ɵɵelementStart(0, "div", 2, 0);
            i0.ɵɵlistener("click", function IgxDialogComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDialogSelected($event));
            });
            i0.ɵɵelementStart(2, "div", 3, 1);
            i0.ɵɵtemplate(4, IgxDialogComponent_Conditional_4_Template, 2, 2, "div", 4)(5, IgxDialogComponent_Conditional_5_Template, 1, 0);
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵtemplate(7, IgxDialogComponent_Conditional_7_Template, 2, 1, "span", 6)(8, IgxDialogComponent_Conditional_8_Template, 1, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, IgxDialogComponent_Conditional_9_Template, 3, 2, "div", 7)(10, IgxDialogComponent_Conditional_10_Template, 1, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("igxFocusTrap", ctx.focusTrap);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("role", ctx.role)("aria-labelledby", ctx.titleId);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.title ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.title ? 5 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.message ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.message ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.leftButtonLabel || ctx.rightButtonLabel ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.leftButtonLabel && !ctx.rightButtonLabel ? 10 : -1);
          }
        },
        dependencies: [IgxToggleDirective, IgxFocusTrapDirective, IgxFocusDirective, IgxButtonDirective, IgxRippleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxDialogTitleDirective = /*#__PURE__*/(() => {
  class IgxDialogTitleDirective {
    constructor() {
      this.defaultStyle = true;
    }
    static {
      this.ɵfac = function IgxDialogTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDialogTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDialogTitleDirective,
        selectors: [["igx-dialog-title"], ["", "igxDialogTitle", ""]],
        hostVars: 2,
        hostBindings: function IgxDialogTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-dialog__window-title", ctx.defaultStyle);
          }
        }
      });
    }
  }
  return IgxDialogTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxDialogActionsDirective = /*#__PURE__*/(() => {
  class IgxDialogActionsDirective {
    constructor() {
      this.defaultClass = true;
    }
    static {
      this.ɵfac = function IgxDialogActionsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDialogActionsDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDialogActionsDirective,
        selectors: [["igx-dialog-actions"], ["", "igxDialogActions", ""]],
        hostVars: 2,
        hostBindings: function IgxDialogActionsDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-dialog__window-actions", ctx.defaultClass);
          }
        }
      });
    }
  }
  return IgxDialogActionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Dialog directives collection for ease-of-use import in standalone components scenario */
const IGX_DIALOG_DIRECTIVES = [IgxDialogComponent, IgxDialogTitleDirective, IgxDialogActionsDirective];

/* NOTE: Drop down directives collection for ease-of-use import in standalone components scenario */
const IGX_DROP_DOWN_DIRECTIVES = [IgxDropDownComponent, IgxDropDownItemComponent, IgxDropDownGroupComponent, IgxDropDownItemNavigationDirective];
let NEXT_ID$d = 0;
/**
 * Providing reference to `IgxColumnActionsComponent`:
 * ```typescript
 *  @ViewChild('columnActions', { read: IgxColumnActionsComponent })
 *  public columnActions: IgxColumnActionsComponent;
 */
let IgxColumnActionsComponent = /*#__PURE__*/(() => {
  class IgxColumnActionsComponent {
    constructor(differs) {
      this.differs = differs;
      /**
       * Gets/sets the indentation of columns in the column list based on their hierarchy level.
       *
       * @example
       * ```
       * <igx-column-actions [indentation]="15"></igx-column-actions>
       * ```
       */
      this.indentation = 30;
      /**
       * Sets/Gets the css class selector.
       * By default the value of the `class` attribute is `"igx-column-actions"`.
       * ```typescript
       * let cssCLass =  this.columnHidingUI.cssClass;
       * ```
       * ```typescript
       * this.columnHidingUI.cssClass = 'column-chooser';
       * ```
       */
      this.cssClass = 'igx-column-actions';
      /**
       * Gets/sets the max height of the columns area.
       *
       * @remarks
       * The default max height is 100%.
       * @example
       * ```html
       * <igx-column-actions [columnsAreaMaxHeight]="200px"></igx-column-actions>
       * ```
       */
      this.columnsAreaMaxHeight = '100%';
      /**
       * Shows/hides the columns filtering input from the UI.
       *
       * @example
       * ```html
       *  <igx-column-actions [hideFilter]="true"></igx-column-actions>
       * ```
       */
      this.hideFilter = false;
      /**
       * Gets/sets the title of the column actions component.
       *
       * @example
       * ```html
       * <igx-column-actions [title]="'Pin Columns'"></igx-column-actions>
       * ```
       */
      this.title = '';
      /**
       * An event that is emitted after a column's checked state is changed.
       * Provides references to the `column` and the `checked` properties as event arguments.
       * ```html
       *  <igx-column-actions (columnToggled)="columnToggled($event)"></igx-column-actions>
       * ```
       */
      this.columnToggled = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.actionableColumns = [];
      /**
       * @hidden @internal
       */
      this.filteredColumns = [];
      /**
       * @hidden @internal
       */
      this.pipeTrigger = 0;
      this._differ = null;
      /**
       * @hidden @internal
       */
      this._filterColumnsPrompt = '';
      /**
       * @hidden @internal
       */
      this._filterCriteria = '';
      /**
       * @hidden @internal
       */
      this._columnDisplayOrder = ColumnDisplayOrder.DisplayOrder;
      /**
       * @hidden @internal
       */
      this._id = `igx-column-actions-${NEXT_ID$d++}`;
      /**
       * @hidden @internal
       */
      this.trackChanges = (index, col) => col.field + '_' + this.actionsDirective.actionEnabledColumnsFilter(col, index, []);
      this._differ = this.differs.find([]).create(this.trackChanges);
    }
    /**
     * Gets the prompt that is displayed in the filter input.
     *
     * @example
     * ```typescript
     * let filterColumnsPrompt = this.columnActions.filterColumnsPrompt;
     * ```
     */
    get filterColumnsPrompt() {
      return this._filterColumnsPrompt;
    }
    /**
     * Sets the prompt that is displayed in the filter input.
     *
     * @example
     * ```html
     * <igx-column-actions [filterColumnsPrompt]="'Type here to search'"></igx-column-actions>
     * ```
     */
    set filterColumnsPrompt(value) {
      this._filterColumnsPrompt = value || '';
    }
    /**
     * Gets the value which filters the columns list.
     *
     * @example
     * ```typescript
     * let filterCriteria =  this.columnActions.filterCriteria;
     * ```
     */
    get filterCriteria() {
      return this._filterCriteria;
    }
    /**
     * Sets the value which filters the columns list.
     *
     * @example
     * ```html
     *  <igx-column-actions [filterCriteria]="'ID'"></igx-column-actions>
     * ```
     */
    set filterCriteria(value) {
      value = value || '';
      if (value !== this._filterCriteria) {
        this._filterCriteria = value;
        this.pipeTrigger++;
      }
    }
    /**
     * Gets the display order of the columns.
     *
     * @example
     * ```typescript
     * let columnDisplayOrder = this.columnActions.columnDisplayOrder;
     * ```
     */
    get columnDisplayOrder() {
      return this._columnDisplayOrder;
    }
    /**
     * Sets the display order of the columns.
     *
     * @example
     * ```typescript
     * this.columnActions.columnDisplayOrder = ColumnDisplayOrder.Alphabetical;
     * ```
     */
    set columnDisplayOrder(value) {
      if (value && value !== this._columnDisplayOrder) {
        this._columnDisplayOrder = value;
        this.pipeTrigger++;
      }
    }
    /**
     * Gets the text of the button that unchecks all columns.
     *
     * @remarks
     * If unset it is obtained from the IgxColumnActionsBased derived directive applied.
     * @example
     * ```typescript
     * let uncheckAllText = this.columnActions.uncheckAllText;
     * ```
     */
    get uncheckAllText() {
      return this._uncheckAllText || this.actionsDirective.uncheckAllLabel;
    }
    /**
     * Sets the text of the button that unchecks all columns.
     *
     * @example
     * ```html
     * <igx-column-actions [uncheckAllText]="'Show All'"></igx-column-actions>
     * ```
     */
    set uncheckAllText(value) {
      this._uncheckAllText = value;
    }
    /**
     * Gets the text of the button that checks all columns.
     *
     * @remarks
     * If unset it is obtained from the IgxColumnActionsBased derived directive applied.
     * @example
     * ```typescript
     * let uncheckAllText = this.columnActions.uncheckAllText;
     * ```
     */
    get checkAllText() {
      return this._checkAllText || this.actionsDirective.checkAllLabel;
    }
    /**
     * Sets the text of the button that checks all columns.
     *
     * @remarks
     * If unset it is obtained from the IgxColumnActionsBased derived directive applied.
     * @example
     * ```html
     * <igx-column-actions [checkAllText]="'Hide All'"></igx-column-actions>
     * ```
     */
    set checkAllText(value) {
      this._checkAllText = value;
    }
    /**
     * @hidden @internal
     */
    get checkAllDisabled() {
      return this.actionsDirective.allUnchecked;
    }
    /**
     * @hidden @internal
     */
    get uncheckAllDisabled() {
      return this.actionsDirective.allChecked;
    }
    /**
     * Gets/Sets the value of the `id` attribute.
     *
     * @remarks
     * If not provided it will be automatically generated.
     * @example
     * ```html
     * <igx-column-actions [id]="'igx-actions-1'"></igx-column-actions>
     * ```
     */
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value;
    }
    /**
     * @hidden @internal
     */
    get titleID() {
      return this.id + '_title';
    }
    /**
     * @hidden @internal
     */
    ngDoCheck() {
      if (this._differ) {
        const changes = this._differ.diff(this.grid?.columnList);
        if (changes) {
          this.pipeTrigger++;
        }
      }
    }
    /**
     * Unchecks all columns and performs the appropriate action.
     *
     * @example
     * ```typescript
     * this.columnActions.uncheckAllColumns();
     * ```
     */
    uncheckAllColumns() {
      this.actionsDirective.uncheckAll();
    }
    /**
     * Checks all columns and performs the appropriate action.
     *
     * @example
     * ```typescript
     * this.columnActions.checkAllColumns();
     * ```
     */
    checkAllColumns() {
      this.actionsDirective.checkAll();
    }
    /**
     * @hidden @internal
     */
    toggleColumn(column) {
      this.actionsDirective.toggleColumn(column);
      this.columnToggled.emit({
        column: column,
        checked: this.actionsDirective.columnChecked(column)
      });
    }
    static {
      this.ɵfac = function IgxColumnActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnActionsComponent)(i0.ɵɵdirectiveInject(i0.IterableDiffers));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxColumnActionsComponent,
        selectors: [["igx-column-actions"]],
        viewQuery: function IgxColumnActionsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxCheckboxComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnItems = _t);
          }
        },
        hostVars: 3,
        hostBindings: function IgxColumnActionsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassMap(ctx.cssClass);
          }
        },
        inputs: {
          grid: "grid",
          indentation: "indentation",
          columnsAreaMaxHeight: "columnsAreaMaxHeight",
          hideFilter: [2, "hideFilter", "hideFilter", booleanAttribute],
          title: "title",
          filterColumnsPrompt: "filterColumnsPrompt",
          filterCriteria: "filterCriteria",
          columnDisplayOrder: "columnDisplayOrder",
          uncheckAllText: "uncheckAllText",
          checkAllText: "checkAllText",
          id: "id"
        },
        outputs: {
          columnToggled: "columnToggled"
        },
        decls: 14,
        vars: 20,
        consts: [[1, "igx-column-actions__header"], [1, "igx-column-actions__header-title"], [1, "igx-column-actions__header-input"], ["tabindex", "0", 1, "igx-column-actions__columns"], [1, "igx-column-actions__columns-item", 3, "readonly", "checked", "margin-left"], [1, "igx-column-actions__buttons"], ["type", "button", "igxButton", "", "igxRipple", "", 3, "click", "disabled"], ["igxInput", "", "type", "text", "autocomplete", "off", 3, "ngModelChange", "ngModel", "placeholder"], [1, "igx-column-actions__columns-item", 3, "click", "readonly", "checked"]],
        template: function IgxColumnActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, IgxColumnActionsComponent_Conditional_1_Template, 2, 2, "h4", 1)(2, IgxColumnActionsComponent_Conditional_2_Template, 2, 3, "igx-input-group", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵrepeaterCreate(4, IgxColumnActionsComponent_For_5_Template, 2, 5, "igx-checkbox", 4, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵpipe(6, "columnActionEnabled");
            i0.ɵɵpipe(7, "filterActionColumns");
            i0.ɵɵpipe(8, "sortActionColumns");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 5)(10, "button", 6);
            i0.ɵɵlistener("click", function IgxColumnActionsComponent_Template_button_click_10_listener() {
              return ctx.uncheckAllColumns();
            });
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "button", 6);
            i0.ɵɵlistener("click", function IgxColumnActionsComponent_Template_button_click_12_listener() {
              return ctx.checkAllColumns();
            });
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.title ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hideFilter ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("max-height", ctx.columnsAreaMaxHeight);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(i0.ɵɵpipeBind3(8, 16, i0.ɵɵpipeBind3(7, 12, i0.ɵɵpipeBind3(6, 8, ctx.grid == null ? null : ctx.grid._columns, ctx.actionsDirective.actionEnabledColumnsFilter, ctx.pipeTrigger), ctx.filterCriteria, ctx.pipeTrigger), ctx.columnDisplayOrder, ctx.pipeTrigger));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("disabled", ctx.uncheckAllDisabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.uncheckAllText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.checkAllDisabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.checkAllText);
          }
        },
        dependencies: () => [IgxInputGroupComponent, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IgxInputDirective, IgxCheckboxComponent, IgxButtonDirective, IgxRippleDirective, IgxColumnActionEnabledPipe, IgxFilterActionColumnsPipe, IgxSortActionColumnsPipe],
        encapsulation: 2
      });
    }
  }
  return IgxColumnActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnActionEnabledPipe = /*#__PURE__*/(() => {
  class IgxColumnActionEnabledPipe {
    constructor(columnActions) {
      this.columnActions = columnActions;
    }
    transform(collection, actionFilter, _pipeTrigger) {
      if (!collection) {
        return collection;
      }
      let copy = collection.slice(0);
      if (copy.length && copy[0].grid.hasColumnLayouts) {
        copy = copy.filter(c => c.columnLayout);
      }
      if (actionFilter) {
        copy = copy.filter(actionFilter);
      }
      // Preserve the actionable collection for use in the component
      this.columnActions.actionableColumns = copy;
      return copy;
    }
    static {
      this.ɵfac = function IgxColumnActionEnabledPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnActionEnabledPipe)(i0.ɵɵdirectiveInject(IgxColumnActionsComponent, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "columnActionEnabled",
        type: IgxColumnActionEnabledPipe,
        pure: true
      });
    }
  }
  return IgxColumnActionEnabledPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxFilterActionColumnsPipe = /*#__PURE__*/(() => {
  class IgxFilterActionColumnsPipe {
    constructor(columnActions) {
      this.columnActions = columnActions;
    }
    transform(collection, filterCriteria, _pipeTrigger) {
      if (!collection) {
        return collection;
      }
      let copy = collection.slice(0);
      if (filterCriteria && filterCriteria.length > 0) {
        const filterFunc = c => {
          const filterText = c.header || c.field;
          if (!filterText) {
            return false;
          }
          return filterText.toLocaleLowerCase().indexOf(filterCriteria.toLocaleLowerCase()) >= 0 || (c.children?.some(filterFunc) ?? false);
        };
        copy = collection.filter(filterFunc);
      }
      // Preserve the filtered collection for use in the component
      this.columnActions.filteredColumns = copy;
      return copy;
    }
    static {
      this.ɵfac = function IgxFilterActionColumnsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterActionColumnsPipe)(i0.ɵɵdirectiveInject(IgxColumnActionsComponent, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterActionColumns",
        type: IgxFilterActionColumnsPipe,
        pure: true
      });
    }
  }
  return IgxFilterActionColumnsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSortActionColumnsPipe = /*#__PURE__*/(() => {
  class IgxSortActionColumnsPipe {
    transform(collection, displayOrder, _pipeTrigger) {
      if (displayOrder === ColumnDisplayOrder.Alphabetical) {
        return collection.sort((a, b) => (a.header || a.field).localeCompare(b.header || b.field));
      }
      return collection;
    }
    static {
      this.ɵfac = function IgxSortActionColumnsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSortActionColumnsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "sortActionColumns",
        type: IgxSortActionColumnsPipe,
        pure: true
      });
    }
  }
  return IgxSortActionColumnsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnActionsBaseDirective = /*#__PURE__*/(() => {
  class IgxColumnActionsBaseDirective {
    static {
      this.ɵfac = function IgxColumnActionsBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnActionsBaseDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnActionsBaseDirective
      });
    }
  }
  return IgxColumnActionsBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnHidingDirective = /*#__PURE__*/(() => {
  class IgxColumnHidingDirective extends IgxColumnActionsBaseDirective {
    constructor(columnActions) {
      super();
      this.columnActions = columnActions;
      /**
       * @hidden @internal
       */
      this.actionEnabledColumnsFilter = c => !c.disableHiding;
      columnActions.actionsDirective = this;
    }
    /**
     * @hidden @internal
     */
    get checkAllLabel() {
      return this.columnActions.grid?.resourceStrings.igx_grid_hiding_check_all_label ?? 'Show All';
    }
    /**
     * @hidden @internal
     */
    get uncheckAllLabel() {
      return this.columnActions.grid?.resourceStrings.igx_grid_hiding_uncheck_all_label ?? 'Hide All';
    }
    /**
     * @hidden @internal
     */
    checkAll() {
      this.columnActions.filteredColumns.forEach(c => c.toggleVisibility(false));
    }
    /**
     * @hidden @internal
     */
    uncheckAll() {
      this.columnActions.filteredColumns.forEach(c => c.toggleVisibility(true));
    }
    /**
     * @hidden @internal
     */
    columnChecked(column) {
      return !column.hidden;
    }
    /**
     * @hidden @internal
     */
    toggleColumn(column) {
      column.toggleVisibility();
    }
    get allChecked() {
      return this.columnActions.filteredColumns.every(col => !this.columnChecked(col));
    }
    get allUnchecked() {
      return this.columnActions.filteredColumns.every(col => this.columnChecked(col));
    }
    static {
      this.ɵfac = function IgxColumnHidingDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnHidingDirective)(i0.ɵɵdirectiveInject(IgxColumnActionsComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnHidingDirective,
        selectors: [["", "igxColumnHiding", ""]],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnHidingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnPinningDirective = /*#__PURE__*/(() => {
  class IgxColumnPinningDirective extends IgxColumnActionsBaseDirective {
    constructor(columnActions) {
      super();
      this.columnActions = columnActions;
      /**
       * @hidden @internal
       */
      this.actionEnabledColumnsFilter = c => !c.disablePinning && !c.level;
      columnActions.actionsDirective = this;
    }
    /**
     * @hidden @internal
     */
    get checkAllLabel() {
      return this.columnActions.grid?.resourceStrings.igx_grid_pinning_check_all_label ?? 'Pin All';
    }
    /**
     * @hidden @internal
     */
    get uncheckAllLabel() {
      return this.columnActions.grid?.resourceStrings.igx_grid_pinning_uncheck_all_label ?? 'Unpin All';
    }
    /**
     * @hidden @internal
     */
    checkAll() {
      this.columnActions.filteredColumns.forEach(c => c.pinned = true);
    }
    /**
     * @hidden @internal
     */
    uncheckAll() {
      this.columnActions.filteredColumns.forEach(c => c.pinned = false);
    }
    /**
     * @hidden @internal
     */
    columnChecked(column) {
      return column.pinned;
    }
    /**
     * @hidden @internal
     */
    toggleColumn(column) {
      column.pinned = !column.pinned;
    }
    get allUnchecked() {
      return !this.columnActions.filteredColumns.some(col => !this.columnChecked(col));
    }
    get allChecked() {
      return !this.columnActions.filteredColumns.some(col => this.columnChecked(col));
    }
    static {
      this.ɵfac = function IgxColumnPinningDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnPinningDirective)(i0.ɵɵdirectiveInject(IgxColumnActionsComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnPinningDirective,
        selectors: [["", "igxColumnPinning", ""]],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnPinningDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxColumnActionsComponent } from './column-actions.component';
// import { IgxColumnHidingDirective } from './column-hiding.directive';
// import { IgxColumnPinningDirective } from './column-pinning.directive';
/* NOTE: Grid column actions directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_COLUMN_ACTIONS_DIRECTIVES = [
//     IgxColumnActionsComponent,
//     IgxColumnHidingDirective,
//     IgxColumnPinningDirective
// ] as const;
let IgxColumnRequiredValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnRequiredValidatorDirective extends RequiredValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnRequiredValidatorDirective_BaseFactory;
        return function IgxColumnRequiredValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnRequiredValidatorDirective_BaseFactory || (ɵIgxColumnRequiredValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnRequiredValidatorDirective)))(__ngFactoryType__ || IgxColumnRequiredValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnRequiredValidatorDirective,
        selectors: [["igx-column", "required", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnRequiredValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnRequiredValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnMinValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnMinValidatorDirective extends MinValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnMinValidatorDirective_BaseFactory;
        return function IgxColumnMinValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnMinValidatorDirective_BaseFactory || (ɵIgxColumnMinValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnMinValidatorDirective)))(__ngFactoryType__ || IgxColumnMinValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMinValidatorDirective,
        selectors: [["igx-column", "min", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnMinValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMinValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnMaxValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnMaxValidatorDirective extends MaxValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnMaxValidatorDirective_BaseFactory;
        return function IgxColumnMaxValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnMaxValidatorDirective_BaseFactory || (ɵIgxColumnMaxValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnMaxValidatorDirective)))(__ngFactoryType__ || IgxColumnMaxValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMaxValidatorDirective,
        selectors: [["igx-column", "max", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnMaxValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMaxValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnEmailValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnEmailValidatorDirective extends EmailValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnEmailValidatorDirective_BaseFactory;
        return function IgxColumnEmailValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnEmailValidatorDirective_BaseFactory || (ɵIgxColumnEmailValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnEmailValidatorDirective)))(__ngFactoryType__ || IgxColumnEmailValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnEmailValidatorDirective,
        selectors: [["igx-column", "email", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnEmailValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnEmailValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnMinLengthValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnMinLengthValidatorDirective extends MinLengthValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnMinLengthValidatorDirective_BaseFactory;
        return function IgxColumnMinLengthValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnMinLengthValidatorDirective_BaseFactory || (ɵIgxColumnMinLengthValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnMinLengthValidatorDirective)))(__ngFactoryType__ || IgxColumnMinLengthValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMinLengthValidatorDirective,
        selectors: [["igx-column", "minlength", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnMinLengthValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMinLengthValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnMaxLengthValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumnMaxLengthValidatorDirective extends MaxLengthValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnMaxLengthValidatorDirective_BaseFactory;
        return function IgxColumnMaxLengthValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumnMaxLengthValidatorDirective_BaseFactory || (ɵIgxColumnMaxLengthValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnMaxLengthValidatorDirective)))(__ngFactoryType__ || IgxColumnMaxLengthValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMaxLengthValidatorDirective,
        selectors: [["igx-column", "maxlength", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumnMaxLengthValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMaxLengthValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumPatternValidatorDirective = /*#__PURE__*/(() => {
  class IgxColumPatternValidatorDirective extends PatternValidator {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumPatternValidatorDirective_BaseFactory;
        return function IgxColumPatternValidatorDirective_Factory(__ngFactoryType__) {
          return (ɵIgxColumPatternValidatorDirective_BaseFactory || (ɵIgxColumPatternValidatorDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumPatternValidatorDirective)))(__ngFactoryType__ || IgxColumPatternValidatorDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumPatternValidatorDirective,
        selectors: [["igx-column", "pattern", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: IgxColumPatternValidatorDirective,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumPatternValidatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
function WatchChanges() {
  return (target, key, propDesc) => {
    const privateKey = '_' + key.toString();
    propDesc = propDesc || {
      configurable: true,
      enumerable: true
    };
    propDesc.get = propDesc.get || function () {
      return this[privateKey];
    };
    const originalSetter = propDesc.set || function (val) {
      this[privateKey] = val;
    };
    propDesc.set = function (val) {
      const init = this._init;
      const oldValue = this[key];
      if (val !== oldValue || typeof val === 'object' && val === oldValue) {
        originalSetter.call(this, val);
        if (this.ngOnChanges && !init) {
          // in case wacthed prop changes trigger ngOnChanges manually
          const changes = {
            [key]: new SimpleChange(oldValue, val, false)
          };
          this.ngOnChanges(changes);
        }
      }
    };
    return propDesc;
  };
}
function WatchColumnChanges() {
  return (target, key, propDesc) => {
    const privateKey = '_' + key.toString();
    propDesc = propDesc || {
      configurable: true,
      enumerable: true
    };
    propDesc.get = propDesc.get || function () {
      return this[privateKey];
    };
    const originalSetter = propDesc.set || function (val) {
      this[privateKey] = val;
    };
    propDesc.set = function (val) {
      const oldValue = this[key];
      originalSetter.call(this, val);
      if (val !== oldValue || typeof val === 'object' && val === oldValue) {
        if (this.columnChange) {
          this.columnChange.emit();
        }
      }
    };
    return propDesc;
  };
}
function notifyChanges(repaint = false) {
  return (_, key, propDesc) => {
    const privateKey = `__${key}`;
    propDesc = propDesc || {
      enumerable: true,
      configurable: true
    };
    const originalSetter = propDesc ? propDesc.set : null;
    propDesc.get = propDesc.get || function () {
      return this[privateKey];
    };
    propDesc.set = function (newValue) {
      if (originalSetter) {
        originalSetter.call(this, newValue);
        if (this.grid) {
          this.grid.notifyChanges(repaint && this.type !== 'pivot');
        }
      } else {
        if (newValue === this[key]) {
          return;
        }
        this[privateKey] = newValue;
        if (this.grid) {
          this.grid.notifyChanges(repaint && this.type !== 'pivot');
        }
      }
    };
    return propDesc;
  };
}
let IgxFilterCellTemplateDirective = /*#__PURE__*/(() => {
  class IgxFilterCellTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxFilterCellTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterCellTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxFilterCellTemplateDirective,
        selectors: [["", "igxFilterCellTemplate", ""]]
      });
    }
  }
  return IgxFilterCellTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCellTemplateDirective = /*#__PURE__*/(() => {
  class IgxCellTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxCellTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCellTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCellTemplateDirective,
        selectors: [["", "igxCell", ""]]
      });
    }
  }
  return IgxCellTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCellValidationErrorDirective = /*#__PURE__*/(() => {
  class IgxCellValidationErrorDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxCellValidationErrorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCellValidationErrorDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCellValidationErrorDirective,
        selectors: [["", "igxCellValidationError", ""]]
      });
    }
  }
  return IgxCellValidationErrorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCellHeaderTemplateDirective = /*#__PURE__*/(() => {
  class IgxCellHeaderTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxCellHeaderTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCellHeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCellHeaderTemplateDirective,
        selectors: [["", "igxHeader", ""]]
      });
    }
  }
  return IgxCellHeaderTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxCellFooterTemplateDirective = /*#__PURE__*/(() => {
  class IgxCellFooterTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxCellFooterTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCellFooterTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCellFooterTemplateDirective,
        selectors: [["", "igxFooter", ""]]
      });
    }
  }
  return IgxCellFooterTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCellEditorTemplateDirective = /*#__PURE__*/(() => {
  class IgxCellEditorTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxCellEditorTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCellEditorTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCellEditorTemplateDirective,
        selectors: [["", "igxCellEditor", ""]]
      });
    }
  }
  return IgxCellEditorTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCollapsibleIndicatorTemplateDirective = /*#__PURE__*/(() => {
  class IgxCollapsibleIndicatorTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxCollapsibleIndicatorTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCollapsibleIndicatorTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCollapsibleIndicatorTemplateDirective,
        selectors: [["", "igxCollapsibleIndicator", ""]]
      });
    }
  }
  return IgxCollapsibleIndicatorTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSummaryTemplateDirective = /*#__PURE__*/(() => {
  class IgxSummaryTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxSummaryTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSummaryTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSummaryTemplateDirective,
        selectors: [["", "igxSummary", ""]]
      });
    }
  }
  return IgxSummaryTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* mustCoerceToInt */
/**
 * This enumeration is used to configure whether the drop position is set before or after
 * the target.
 */
var DropPosition = /*#__PURE__*/function (DropPosition) {
  DropPosition[DropPosition["BeforeDropTarget"] = 0] = "BeforeDropTarget";
  DropPosition[DropPosition["AfterDropTarget"] = 1] = "AfterDropTarget";
  return DropPosition;
}(DropPosition || {});
/**
 * @hidden
 * @internal
 */
let IgxColumnMovingService = /*#__PURE__*/(() => {
  class IgxColumnMovingService {
    static {
      this.ɵfac = function IgxColumnMovingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnMovingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxColumnMovingService,
        factory: IgxColumnMovingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IgxColumnMovingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IgxGridCell {
  /**
   * @hidden
   */
  constructor(grid, row, column) {
    this.grid = grid;
    if (typeof row === 'number') {
      this._rowIndex = row;
    } else {
      this._row = row;
      this._rowIndex = row.index;
    }
    this._column = column;
  }
  /**
   * Returns the row containing the cell.
   * ```typescript
   * let row = this.cell.row;
   * ```
   *
   * @memberof IgxGridCell
   */
  get row() {
    return this._row || this.grid.createRow(this._rowIndex);
  }
  /**
   * Returns the column of the cell.
   * ```typescript
   * let column = this.cell.column;
   * ```
   *
   * @memberof IgxGridCell
   */
  get column() {
    return this._column;
  }
  /**
   * Gets the current edit value while a cell is in edit mode.
   * ```typescript
   * let editValue = this.cell.editValue;
   * ```
   *
   * @memberof IgxGridCell
   */
  get editValue() {
    if (this.isCellInEditMode()) {
      return this.grid.crudService.cell.editValue;
    }
  }
  /**
   * Sets the current edit value while a cell is in edit mode.
   * Only for cell editing mode.
   * ```typescript
   * this.cell.editValue = value;
   * ```
   *
   * @memberof IgxGridCell
   */
  set editValue(value) {
    if (this.isCellInEditMode()) {
      this.grid.crudService.cell.editValue = value;
    }
  }
  /**
   * Gets the validation status and errors, if any.
   * ```typescript
   * let validation = this.cell.validation;
   * let errors = validation.errors;
   * ```
   */
  get validation() {
    const form = this.grid.validation.getFormControl(this.row.key, this.column.field);
    return {
      status: form?.status || 'VALID',
      errors: form?.errors
    };
  }
  /**
   * Returns whether the cell is editable..
   *
   * @memberof IgxGridCell
   */
  get editable() {
    return this.column.editable && !this.row?.disabled;
  }
  /**
   * Gets the width of the cell.
   * ```typescript
   * let cellWidth = this.cell.width;
   * ```
   *
   * @memberof IgxGridCell
   */
  get width() {
    return this.column.width;
  }
  /**
   * Returns the cell value.
   *
   * @memberof IgxGridCell
   */
  get value() {
    // will return undefined for a column layout, because getCellByColumnVisibleIndex may return the column layout at that index.
    // getCellByColumnVisibleIndex is deprecated and will be removed in future version
    return this.column.field ? this.column.hasNestedPath ? resolveNestedPath(this.row?.data, this.column.field) : this.row?.data[this.column.field] : undefined;
  }
  /**
   * Updates the cell value.
   *
   * @memberof IgxGridCell
   */
  set value(val) {
    this.update(val);
  }
  /**
   * Gets the cell id.
   * A cell in the grid is identified by:
   * - rowID - primaryKey data value or the whole rowData, if the primaryKey is omitted.
   * - rowIndex - the row index
   * - columnID - column index
   *
   * ```typescript
   * let cellID = cell.id;
   * ```
   *
   * @memberof IgxGridCell
   */
  get id() {
    const primaryKey = this.grid.primaryKey;
    const rowID = primaryKey ? this.row?.data[primaryKey] : this.row?.data;
    return {
      rowID,
      columnID: this.column.index,
      rowIndex: this._rowIndex || this.row?.index
    };
  }
  /**
   * Returns if the row is currently in edit mode.
   *
   * @memberof IgxGridCell
   */
  get editMode() {
    return this.isCellInEditMode();
  }
  /**
   * Starts/ends edit mode for the cell.
   *
   * ```typescript
   * cell.editMode  = !cell.editMode;
   * ```
   *
   * @memberof IgxGridCell
   */
  set editMode(value) {
    const isInEditMode = this.isCellInEditMode();
    if (!this.row || this.row?.deleted || isInEditMode === value) {
      return;
    }
    if (this.editable && value) {
      this.endEdit();
      // TODO possibly define similar method in gridAPI, which does not emit event
      this.grid.crudService.enterEditMode(this);
    } else {
      this.grid.crudService.endCellEdit();
    }
    this.grid.notifyChanges();
  }
  /**
   * Gets whether the cell is selected.
   * ```typescript
   * let isSelected = this.cell.selected;
   * ```
   *
   *
   * @memberof IgxGridCell
   */
  get selected() {
    return this.grid.selectionService.selected(this.selectionNode);
  }
  /**
   * Selects/deselects the cell.
   * ```typescript
   * this.cell.selected = true.
   * ```
   *
   *
   * @memberof IgxGridCell
   */
  set selected(val) {
    const node = this.selectionNode;
    if (val) {
      this.grid.selectionService.add(node);
    } else {
      this.grid.selectionService.remove(node);
    }
    this.grid.notifyChanges();
  }
  get active() {
    const node = this.grid.navigation.activeNode;
    return node ? node.row === this.row?.index && node.column === this.column.visibleIndex : false;
  }
  /**
   * Updates the cell value.
   *
   * ```typescript
   * cell.update(newValue);
   * ```
   *
   * @memberof IgxGridCell
   */
  update(val) {
    if (this.row?.deleted) {
      return;
    }
    this.endEdit();
    const cell = this.isCellInEditMode() ? this.grid.crudService.cell : this.grid.crudService.createCell(this);
    cell.editValue = val;
    this.grid.gridAPI.update_cell(cell);
    this.grid.crudService.endCellEdit();
    this.grid.notifyChanges();
  }
  get selectionNode() {
    return {
      row: this.row?.index,
      column: this.column.columnLayoutChild ? this.column.parent.visibleIndex : this.column.visibleIndex,
      layout: this.column.columnLayoutChild ? {
        rowStart: this.column.rowStart,
        colStart: this.column.colStart,
        rowEnd: this.column.rowEnd,
        colEnd: this.column.colEnd,
        columnVisibleIndex: this.column.visibleIndex
      } : null
    };
  }
  isCellInEditMode() {
    if (this.grid.crudService.cellInEditMode) {
      const cellInEditMode = this.grid.crudService.cell.id;
      const isCurrentCell = cellInEditMode.rowID === this.id.rowID && cellInEditMode.rowIndex === this.id.rowIndex && cellInEditMode.columnID === this.id.columnID;
      return isCurrentCell;
    }
    return false;
  }
  endEdit() {
    if (!this.isCellInEditMode()) {
      this.grid.gridAPI.update_cell(this.grid.crudService.cell);
      this.grid.crudService.endCellEdit();
    }
  }
}
const DEFAULT_DATE_FORMAT = 'mediumDate';
const DEFAULT_TIME_FORMAT = 'mediumTime';
const DEFAULT_DATE_TIME_FORMAT = 'medium';
const DEFAULT_DIGITS_INFO = '1.0-3';
/* blazorElement */
/* contentParent: ColumnGroup */
/* wcElementTag: igc-column */
/* additionalIdentifier: Field */
/* blazorIndirectRender */
/**
 * **Ignite UI for Angular Column** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/grid/grid#columns-configuration)
 *
 * The Ignite UI Column is used within an `igx-grid` element to define what data the column will show. Features such as sorting,
 * filtering & editing are enabled at the column level.  You can also provide a template containing custom content inside
 * the column using `ng-template` which will be used for all cells within the column.
 *
 * @igxParent IgxGridComponent, IgxTreeGridComponent, IgxHierarchicalGridComponent, IgxPivotGridComponent, IgxRowIslandComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent
 */
let IgxColumnComponent = /*#__PURE__*/(() => {
  class IgxColumnComponent {
    /**
     * Sets/gets the `field` value.
     * ```typescript
     * let columnField = this.column.field;
     * ```
     * ```html
     * <igx-column [field] = "'ID'"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set field(value) {
      this._field = value;
      this.hasNestedPath = value?.includes('.');
    }
    get field() {
      return this._field;
    }
    /**
     * Returns if the column is selectable.
     * ```typescript
     * let columnSelectable = this.column.selectable;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get selectable() {
      return this._selectable;
    }
    /**
     * Sets if the column is selectable.
     * Default value is `true`.
     * ```html
     * <igx-column [selectable] = "false"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set selectable(value) {
      this._selectable = value;
    }
    /**
     * Sets/gets whether the column is groupable.
     * Default value is `false`.
     * ```typescript
     * let isGroupable = this.column.groupable;
     * ```
     * ```html
     * <igx-column [groupable] = "true"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get groupable() {
      return this._groupable;
    }
    set groupable(value) {
      this._groupable = value;
      this.grid.groupablePipeTrigger++;
    }
    /**
     * Gets whether the column is editable.
     * Default value is `false`.
     * ```typescript
     * let isEditable = this.column.editable;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get editable() {
      // Updating the primary key when grid has transactions (incl. row edit)
      // should not be allowed, as that can corrupt transaction state.
      const rowEditable = this.grid && this.grid.rowEditable;
      const hasTransactions = this.grid && this.grid.transactions.enabled;
      if (this.isPrimaryColumn && (rowEditable || hasTransactions)) {
        return false;
      }
      if (this._editable !== undefined) {
        return this._editable;
      } else {
        return rowEditable;
      }
    }
    /**
     * Sets whether the column is editable.
     * ```typescript
     * this.column.editable = true;
     * ```
     * ```html
     * <igx-column [editable] = "true"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set editable(editable) {
      this._editable = editable;
    }
    /**
     * Gets a value indicating whether the summary for the column is enabled.
     * ```typescript
     * let hasSummary = this.column.hasSummary;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get hasSummary() {
      return this._hasSummary;
    }
    /**
     * Sets a value indicating whether the summary for the column is enabled.
     * Default value is `false`.
     * ```html
     * <igx-column [hasSummary] = "true"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set hasSummary(value) {
      this._hasSummary = value;
      if (this.grid) {
        this.grid.summaryService.resetSummaryHeight();
      }
    }
    /**
     * Gets whether the column is hidden.
     * ```typescript
     * let isHidden = this.column.hidden;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get hidden() {
      return this._hidden;
    }
    /**
     * Sets the column hidden property.
     * Default value is `false`.
     * ```html
     * <igx-column [hidden] = "true"></igx-column>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <igx-column [(hidden)] = "model.isHidden"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set hidden(value) {
      if (this._hidden !== value) {
        this._hidden = value;
        this.hiddenChange.emit(this._hidden);
        if (this.columnLayoutChild && this.parent.hidden !== value) {
          this.parent.hidden = value;
          return;
        }
        if (this.grid) {
          this.grid.crudService.endEdit(false);
          this.grid.summaryService.resetSummaryHeight();
          this.grid.filteringService.refreshExpressions();
          this.grid.filteringService.hideFilteringRowOnColumnVisibilityChange(this);
          this.grid.notifyChanges();
        }
      }
    }
    /**
     * Returns if the column is selected.
     * ```typescript
     * let isSelected = this.column.selected;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get selected() {
      return this.grid.selectionService.isColumnSelected(this.field);
    }
    /**
     * Select/deselect a column.
     * Default value is `false`.
     * ```typescript
     * this.column.selected = true;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set selected(value) {
      if (this.selectable && value !== this.selected) {
        if (value) {
          this.grid.selectionService.selectColumnsWithNoEvent([this.field]);
        } else {
          this.grid.selectionService.deselectColumnsWithNoEvent([this.field]);
        }
        this.grid.notifyChanges();
      }
    }
    /**
     * Gets the `width` of the column.
     * ```typescript
     * let columnWidth = this.column.width;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get width() {
      const isAutoWidth = this._width && typeof this._width === 'string' && this._width === 'auto';
      if (isAutoWidth) {
        if (!this.autoSize) {
          return 'fit-content';
        } else {
          return this.autoSize + 'px';
        }
      }
      return this.widthSetByUser ? this._width : this.defaultWidth;
    }
    /**
     * Sets the `width` of the column.
     * ```html
     * <igx-column [width] = "'25%'"></igx-column>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <igx-column [(width)]="model.columns[0].width"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set width(value) {
      if (value) {
        this._calcWidth = null;
        this.calcPixelWidth = NaN;
        this.widthSetByUser = true;
        // width could be passed as number from the template
        // host bindings are not px affixed so we need to ensure we affix simple number strings
        if (typeof value === 'number' || value.match(/^[0-9]*$/)) {
          value = value + 'px';
        }
        if (value === 'fit-content') {
          value = 'auto';
        }
        this._width = value;
        if (this.grid) {
          this.cacheCalcWidth();
        }
        this.widthChange.emit(this._width);
      }
    }
    /**
     * @hidden
     */
    get calcWidth() {
      return this.getCalcWidth();
    }
    /**
     * @hidden
     */
    get maxWidthPx() {
      const gridAvailableSize = this.grid.calcWidth;
      const isPercentageWidth = this.maxWidth && typeof this.maxWidth === 'string' && this.maxWidth.indexOf('%') !== -1;
      return isPercentageWidth ? parseFloat(this.maxWidth) / 100 * gridAvailableSize : parseFloat(this.maxWidth);
    }
    /**
     * @hidden
     */
    get maxWidthPercent() {
      const gridAvailableSize = this.grid.calcWidth;
      const isPercentageWidth = this.maxWidth && typeof this.maxWidth === 'string' && this.maxWidth.indexOf('%') !== -1;
      return isPercentageWidth ? parseFloat(this.maxWidth) : parseFloat(this.maxWidth) / gridAvailableSize * 100;
    }
    /**
     * @hidden
     */
    get minWidthPx() {
      const gridAvailableSize = this.grid.calcWidth;
      const isPercentageWidth = this.minWidth && typeof this.minWidth === 'string' && this.minWidth.indexOf('%') !== -1;
      return isPercentageWidth ? parseFloat(this.minWidth) / 100 * gridAvailableSize : parseFloat(this.minWidth);
    }
    /**
     * @hidden
     */
    get minWidthPercent() {
      const gridAvailableSize = this.grid.calcWidth;
      const isPercentageWidth = this.minWidth && typeof this.minWidth === 'string' && this.minWidth.indexOf('%') !== -1;
      return isPercentageWidth ? parseFloat(this.minWidth) : parseFloat(this.minWidth) / gridAvailableSize * 100;
    }
    /**
     * Sets/gets the minimum `width` of the column.
     * Default value is `88`;
     * ```typescript
     * let columnMinWidth = this.column.minWidth;
     * ```
     * ```html
     * <igx-column [minWidth] = "'100px'"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set minWidth(value) {
      const minVal = parseFloat(value);
      if (Number.isNaN(minVal)) {
        return;
      }
      this._defaultMinWidth = value;
    }
    get minWidth() {
      return !this._defaultMinWidth ? this.defaultMinWidth : this._defaultMinWidth;
    }
    /** @hidden @internal **/
    get resolvedWidth() {
      if (this.columnLayoutChild) {
        return '';
      }
      const isAutoWidth = this._width && typeof this._width === 'string' && this._width === 'auto';
      return isAutoWidth ? this.width : this.calcPixelWidth + 'px';
    }
    /**
     * Gets the column index.
     * ```typescript
     * let columnIndex = this.column.index;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get index() {
      return this.grid._columns.indexOf(this);
    }
    /**
     * Gets whether the column is `pinned`.
     * ```typescript
     * let isPinned = this.column.pinned;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get pinned() {
      return this._pinned;
    }
    /**
     * Sets whether the column is pinned.
     * Default value is `false`.
     * ```html
     * <igx-column [pinned] = "true"></igx-column>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <igx-column [(pinned)] = "model.columns[0].isPinned"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set pinned(value) {
      if (this._pinned !== value) {
        const isAutoWidth = this.width && typeof this.width === 'string' && this.width === 'fit-content';
        if (this.grid && this.width && (isAutoWidth || !isNaN(parseInt(this.width, 10)))) {
          if (value) {
            this.pin();
          } else {
            this.unpin();
          }
          return;
        }
        /* No grid/width available at initialization. `initPinning` in the grid
           will re-init the group (if present)
        */
        this._pinned = value;
        this.pinnedChange.emit(this._pinned);
      }
    }
    /* treatAsRef */
    /**
     * Gets the column `summaries`.
     * ```typescript
     * let columnSummaries = this.column.summaries;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get summaries() {
      return this._summaries;
    }
    /* treatAsRef */
    /**
     * Sets the column `summaries`.
     * ```typescript
     * this.column.summaries = IgxNumberSummaryOperand;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set summaries(classRef) {
      if (isConstructor(classRef)) {
        this._summaries = new classRef();
      }
      if (this.grid) {
        this.grid.summaryService.removeSummariesCachePerColumn(this.field);
        this.grid.summaryPipeTrigger++;
        this.grid.summaryService.resetSummaryHeight();
      }
    }
    /**
     * Sets/gets the summary operands to exclude from display.
     * Accepts an array of string keys representing the summary types to disable, such as 'Min', 'Max', 'Count' etc.
     * ```typescript
     * let disabledSummaries = this.column.disabledSummaries;
     * ```
     * ```html
     * <igx-column [disabledSummaries]="['min', 'max', 'average']"></igx-column>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get disabledSummaries() {
      return this._disabledSummaries;
    }
    set disabledSummaries(value) {
      if (isEqual$1(this._disabledSummaries, value)) {
        return;
      }
      this._disabledSummaries = value;
      if (this.grid) {
        this.grid.summaryService.removeSummariesCachePerColumn(this.field);
        this.grid.summaryPipeTrigger++;
        this.grid.summaryService.resetSummaryHeight();
      }
    }
    /**
     * Gets the column `filters`.
     * ```typescript
     * let columnFilters = this.column.filters'
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get filters() {
      return this._filters;
    }
    /**
     * Sets the column `filters`.
     * ```typescript
     * this.column.filters = IgxBooleanFilteringOperand.instance().
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set filters(instance) {
      this._filters = instance;
    }
    /**
     * Gets the column `sortStrategy`.
     * ```typescript
     * let sortStrategy = this.column.sortStrategy
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get sortStrategy() {
      return this._sortStrategy;
    }
    /**
     * Sets the column `sortStrategy`.
     * ```typescript
     * this.column.sortStrategy = new CustomSortingStrategy().
     * class CustomSortingStrategy extends SortingStrategy {...}
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set sortStrategy(classRef) {
      this._sortStrategy = classRef;
    }
    /* blazorSuppress */
    /**
     * Gets the function that compares values for grouping.
     * ```typescript
     * let groupingComparer = this.column.groupingComparer'
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get groupingComparer() {
      return this._groupingComparer;
    }
    /* blazorSuppress */
    /**
     * Sets a custom function to compare values for grouping.
     * Subsequent values in the sorted data that the function returns 0 for are grouped.
     * ```typescript
     * this.column.groupingComparer = (a: any, b: any, currRec?: any, groupRec?: any) => { return a === b ? 0 : -1; }
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set groupingComparer(funcRef) {
      this._groupingComparer = funcRef;
    }
    /**
     * @hidden @internal
     */
    get defaultMinWidth() {
      if (!this.grid) {
        return '80';
      }
      switch (this.grid.gridSize) {
        case Size.Medium:
          return '64';
        case Size.Small:
          return '56';
        default:
          return '80';
      }
    }
    /**
     * Returns a reference to the `summaryTemplate`.
     * ```typescript
     * let summaryTemplate = this.column.summaryTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get summaryTemplate() {
      return this._summaryTemplate;
    }
    /**
     * Sets the summary template.
     * ```html
     * <ng-template #summaryTemplate igxSummary let-summaryResults>
     *    <p>{{ summaryResults[0].label }}: {{ summaryResults[0].summaryResult }}</p>
     *    <p>{{ summaryResults[1].label }}: {{ summaryResults[1].summaryResult }}</p>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'summaryTemplate'", {read: TemplateRef })
     * public summaryTemplate: TemplateRef<any>;
     * this.column.summaryTemplate = this.summaryTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set summaryTemplate(template) {
      this._summaryTemplate = template;
    }
    /**
     * Returns a reference to the `bodyTemplate`.
     * ```typescript
     * let bodyTemplate = this.column.bodyTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get bodyTemplate() {
      return this._bodyTemplate;
    }
    /**
     * Sets the body template.
     * ```html
     * <ng-template #bodyTemplate igxCell let-val>
     *    <div style = "background-color: yellowgreen" (click) = "changeColor(val)">
     *       <span> {{val}} </span>
     *    </div>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'bodyTemplate'", {read: TemplateRef })
     * public bodyTemplate: TemplateRef<any>;
     * this.column.bodyTemplate = this.bodyTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set bodyTemplate(template) {
      this._bodyTemplate = template;
    }
    /**
     * Returns a reference to the header template.
     * ```typescript
     * let headerTemplate = this.column.headerTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get headerTemplate() {
      return this._headerTemplate;
    }
    /**
     * Sets the header template.
     * Note that the column header height is fixed and any content bigger than it will be cut off.
     * ```html
     * <ng-template #headerTemplate>
     *   <div style = "background-color:black" (click) = "changeColor(val)">
     *       <span style="color:red" >{{column.field}}</span>
     *   </div>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'headerTemplate'", {read: TemplateRef })
     * public headerTemplate: TemplateRef<any>;
     * this.column.headerTemplate = this.headerTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set headerTemplate(template) {
      this._headerTemplate = template;
    }
    /**
     * Returns a reference to the inline editor template.
     * ```typescript
     * let inlineEditorTemplate = this.column.inlineEditorTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get inlineEditorTemplate() {
      return this._inlineEditorTemplate;
    }
    /**
     * Sets the inline editor template.
     * ```html
     * <ng-template #inlineEditorTemplate igxCellEditor let-cell="cell">
     *     <input type="string" [(ngModel)]="cell.value"/>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'inlineEditorTemplate'", {read: TemplateRef })
     * public inlineEditorTemplate: TemplateRef<any>;
     * this.column.inlineEditorTemplate = this.inlineEditorTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set inlineEditorTemplate(template) {
      this._inlineEditorTemplate = template;
    }
    /**
     * Returns a reference to the validation error template.
     * ```typescript
     * let errorTemplate = this.column.errorTemplate;
     * ```
     */
    get errorTemplate() {
      return this._errorTemplate;
    }
    /**
     * Sets the error template.
     * ```html
     * <ng-template igxCellValidationError let-cell="cell" #errorTemplate >
     *     <div *ngIf="cell.validation.errors?.['forbiddenName']">
     *      This name is forbidden.
     *     </div>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'errorTemplate'", {read: TemplateRef })
     * public errorTemplate: TemplateRef<any>;
     * this.column.errorTemplate = this.errorTemplate;
     * ```
     */
    set errorTemplate(template) {
      this._errorTemplate = template;
    }
    /**
     * Returns a reference to the `filterCellTemplate`.
     * ```typescript
     * let filterCellTemplate = this.column.filterCellTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get filterCellTemplate() {
      return this._filterCellTemplate;
    }
    /**
     * Sets the quick filter template.
     * ```html
     * <ng-template #filterCellTemplate IgxFilterCellTemplate let-column="column">
     *    <input (input)="onInput()">
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'filterCellTemplate'", {read: TemplateRef })
     * public filterCellTemplate: TemplateRef<any>;
     * this.column.filterCellTemplate = this.filterCellTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set filterCellTemplate(template) {
      this._filterCellTemplate = template;
    }
    /**
     * @hidden @internal
     */
    get cells() {
      return this.grid.dataView.map((rec, index) => {
        if (!this.grid.isGroupByRecord(rec) && !this.grid.isSummaryRow(rec)) {
          this.grid.pagingMode === 1 && this.grid.page !== 0 ? index = index + this.grid.perPage * this.grid.page : index = this.grid.dataRowList.first.index + index;
          const cell = new IgxGridCell(this.grid, index, this);
          return cell;
        }
      }).filter(cell => cell);
    }
    /**
     * @hidden @internal
     */
    get _cells() {
      return this.grid.rowList.filter(row => row instanceof IgxRowDirective).map(row => {
        if (row._cells) {
          return row._cells.filter(cell => cell.columnIndex === this.index);
        }
      }).reduce((a, b) => a.concat(b), []);
    }
    /**
     * Gets the column visible index.
     * If the column is not visible, returns `-1`.
     * ```typescript
     * let visibleColumnIndex =  this.column.visibleIndex;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get visibleIndex() {
      if (!isNaN(this._vIndex)) {
        return this._vIndex;
      }
      const unpinnedColumns = this.grid.unpinnedColumns.filter(c => !c.columnGroup);
      const pinnedColumns = this.grid.pinnedColumns.filter(c => !c.columnGroup);
      let col = this;
      let vIndex = -1;
      if (this.columnGroup) {
        col = this.allChildren.filter(c => !c.columnGroup && !c.hidden)[0];
      }
      if (this.columnLayoutChild) {
        return this.parent.childrenVisibleIndexes.find(x => x.column === this).index;
      }
      if (!this.pinned) {
        const indexInCollection = unpinnedColumns.indexOf(col);
        vIndex = indexInCollection === -1 ? -1 : this.grid.isPinningToStart ? pinnedColumns.length + indexInCollection : indexInCollection;
      } else {
        const indexInCollection = pinnedColumns.indexOf(col);
        vIndex = this.grid.isPinningToStart ? indexInCollection : unpinnedColumns.length + indexInCollection;
      }
      this._vIndex = vIndex;
      return vIndex;
    }
    /* blazorCSSuppress - Blazor doesn't carry over the ColumnType interface + should translate as static bool value */
    /**
     * Returns a boolean indicating if the column is a `ColumnGroup`.
     * ```typescript
     * let columnGroup =  this.column.columnGroup;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get columnGroup() {
      return false;
    }
    /* blazorCSSuppress - Blazor doesn't carry over the ColumnType interface + should translate as static bool value */
    /**
     * Returns a boolean indicating if the column is a `ColumnLayout` for multi-row layout.
     * ```typescript
     * let columnGroup =  this.column.columnGroup;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get columnLayout() {
      return false;
    }
    /**
     * Returns a boolean indicating if the column is a child of a `ColumnLayout` for multi-row layout.
     * ```typescript
     * let columnLayoutChild =  this.column.columnLayoutChild;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get columnLayoutChild() {
      return this.parent && this.parent.columnLayout;
    }
    /**
     * A list containing all the child columns under this column (if any).
     * Empty without children or if this column is not Group or Layout.
     */
    get childColumns() {
      return [];
    }
    /** @hidden @internal **/
    get allChildren() {
      return [];
    }
    /**
     * Returns the level of the column in a column group.
     * Returns `0` if the column doesn't have a `parent`.
     * ```typescript
     * let columnLevel =  this.column.level;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get level() {
      let ptr = this.parent;
      let lvl = 0;
      while (ptr) {
        lvl++;
        ptr = ptr.parent;
      }
      return lvl;
    }
    /** @hidden @internal **/
    get isLastPinned() {
      return this.grid.isPinningToStart && this.grid.pinnedColumns[this.grid.pinnedColumns.length - 1] === this;
    }
    /** @hidden @internal **/
    get isFirstPinned() {
      const pinnedCols = this.grid.pinnedColumns.filter(x => !x.columnGroup);
      return !this.grid.isPinningToStart && pinnedCols[0] === this;
    }
    /** @hidden @internal **/
    get rightPinnedOffset() {
      return this.pinned && !this.grid.isPinningToStart ? -this.grid.pinnedWidth - this.grid.headerFeaturesWidth + 'px' : null;
    }
    /** @hidden @internal **/
    get gridRowSpan() {
      return this.rowEnd && this.rowStart ? this.rowEnd - this.rowStart : 1;
    }
    /** @hidden @internal **/
    get gridColumnSpan() {
      return this.colEnd && this.colStart ? this.colEnd - this.colStart : 1;
    }
    /**
     * Indicates whether the column will be visible when its parent is collapsed.
     * ```html
     * <igx-column-group>
     *   <igx-column [visibleWhenCollapsed]="true"></igx-column>
     * </igx-column-group>
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set visibleWhenCollapsed(value) {
      this._visibleWhenCollapsed = value;
      this.visibleWhenCollapsedChange.emit(this._visibleWhenCollapsed);
      if (this.parent) {
        this.parent?.setExpandCollapseState?.();
      }
    }
    get visibleWhenCollapsed() {
      return this._visibleWhenCollapsed;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /**
     * @remarks
     * Pass optional parameters for DatePipe and/or DecimalPipe to format the display value for date and numeric columns.
     * Accepts an `IColumnPipeArgs` object with any of the `format`, `timezone` and `digitsInfo` properties.
     * For more details see https://angular.io/api/common/DatePipe and https://angular.io/api/common/DecimalPipe
     * @example
     * ```typescript
     * const pipeArgs: IColumnPipeArgs = {
     *      format: 'longDate',
     *      timezone: 'UTC',
     *      digitsInfo: '1.1-2'
     * }
     * ```
     * ```html
     * <igx-column dataType="date" [pipeArgs]="pipeArgs"></igx-column>
     * <igx-column dataType="number" [pipeArgs]="pipeArgs"></igx-column>
     * ```
     * @memberof IgxColumnComponent
     */
    set pipeArgs(value) {
      this._columnPipeArgs = Object.assign(this._columnPipeArgs, value);
      this.grid.summaryService.clearSummaryCache();
      this.grid.pipeTrigger++;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor */
    get pipeArgs() {
      return this._columnPipeArgs;
    }
    /**
     * Pass optional properties for the default column editors.
     * @remarks
     * Options may be applicable only to specific column type editors.
     * @example
     * ```typescript
     * const editorOptions: IColumnEditorOptions = {
     *      dateTimeFormat: 'MM/dd/YYYY',
     * }
     * ```
     * ```html
     * <igx-column dataType="date" [editorOptions]="editorOptions"></igx-column>
     * ```
     * @memberof IgxColumnComponent
     */
    set editorOptions(value) {
      this._editorOptions = value;
    }
    get editorOptions() {
      return this._editorOptions;
    }
    /**
     * @hidden
     * @internal
     */
    get collapsible() {
      return false;
    }
    set collapsible(_value) {}
    /**
     * @hidden
     * @internal
     */
    get expanded() {
      return true;
    }
    set expanded(_value) {}
    /**
     * Returns the filteringExpressionsTree of the column.
     * ```typescript
     * let tree =  this.column.filteringExpressionsTree;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get filteringExpressionsTree() {
      return ExpressionsTreeUtil.find(this.grid.filteringExpressionsTree, this.field);
    }
    /**
     * @hidden
     */
    get isPrimaryColumn() {
      return this.field !== undefined && this.grid !== undefined && this.field === this.grid.primaryKey;
    }
    constructor(grid, _validators, /** @hidden @internal **/
    cdr, platform) {
      this.grid = grid;
      this._validators = _validators;
      this.cdr = cdr;
      this.platform = platform;
      /**
       * @hidden @internal
       */
      this.validators = [];
      /**
       * Sets/gets the `header` value.
       * ```typescript
       * let columnHeader = this.column.header;
       * ```
       * ```html
       * <igx-column [header] = "'ID'"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.header = '';
      /**
       * Sets/gets the `title` value.
       * ```typescript
       * let title = this.column.title;
       * ```
       * ```html
       * <igx-column [title] = "'Some column tooltip'"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.title = '';
      /**
       * Sets/gets whether the column is sortable.
       * Default value is `false`.
       * ```typescript
       * let isSortable = this.column.sortable;
       * ```
       * ```html
       * <igx-column [sortable] = "true"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.sortable = false;
      /**
       * Sets/gets whether the column is filterable.
       * Default value is `true`.
       * ```typescript
       * let isFilterable = this.column.filterable;
       * ```
       * ```html
       * <igx-column [filterable] = "false"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.filterable = true;
      /**
       * Sets/gets whether the column is resizable.
       * Default value is `false`.
       * ```typescript
       * let isResizable = this.column.resizable;
       * ```
       * ```html
       * <igx-column [resizable] = "true"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.resizable = false;
      /**
       * Sets/gets whether the column header is included in autosize logic.
       * Useful when template for a column header is sized based on parent, for example a default `div`.
       * Default value is `false`.
       * ```typescript
       * let isResizable = this.column.resizable;
       * ```
       * ```html
       * <igx-column [resizable] = "true"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.autosizeHeader = true;
      /**
       * @hidden
       */
      this.hiddenChange = new EventEmitter();
      /** @hidden */
      this.expandedChange = new EventEmitter();
      /** @hidden */
      this.collapsibleChange = new EventEmitter();
      /** @hidden */
      this.visibleWhenCollapsedChange = new EventEmitter();
      /** @hidden */
      this.columnChange = new EventEmitter();
      /**
       * Gets whether the hiding is disabled.
       * ```typescript
       * let isHidingDisabled =  this.column.disableHiding;
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.disableHiding = false;
      /**
       * Gets whether the pinning is disabled.
       * ```typescript
       * let isPinningDisabled =  this.column.disablePinning;
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.disablePinning = false;
      /**
       * Sets/gets the class selector of the column header.
       * ```typescript
       * let columnHeaderClass = this.column.headerClasses;
       * ```
       * ```html
       * <igx-column [headerClasses] = "'column-header'"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.headerClasses = '';
      /**
       * Sets conditional style properties on the column header.
       * Similar to `ngStyle` it accepts an object literal where the keys are
       * the style properties and the value is the expression to be evaluated.
       * ```typescript
       * styles = {
       *  background: 'royalblue',
       *  color: (column) => column.pinned ? 'red': 'inherit'
       * }
       * ```
       * ```html
       * <igx-column [headerStyles]="styles"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.headerStyles = null;
      /**
       * Sets/gets the class selector of the column group header.
       * ```typescript
       * let columnHeaderClass = this.column.headerGroupClasses;
       * ```
       * ```html
       * <igx-column [headerGroupClasses] = "'column-group-header'"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.headerGroupClasses = '';
      /**
       * Sets conditional style properties on the column header group wrapper.
       * Similar to `ngStyle` it accepts an object literal where the keys are
       * the style properties and the value is the expression to be evaluated.
       * ```typescript
       * styles = {
       *  background: 'royalblue',
       *  color: (column) => column.pinned ? 'red': 'inherit'
       * }
       * ```
       * ```html
       * <igx-column [headerGroupStyles]="styles"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.headerGroupStyles = null;
      /* treatAsRef */
      /**
       * Sets conditional style properties on the column cells.
       * Similar to `ngStyle` it accepts an object literal where the keys are
       * the style properties and the value is the expression to be evaluated.
       * As with `cellClasses` it accepts a callback function.
       * ```typescript
       * styles = {
       *  background: 'royalblue',
       *  color: (rowData, columnKey, cellValue, rowIndex) => value.startsWith('Important') ? 'red': 'inherit'
       * }
       * ```
       * ```html
       * <igx-column [cellStyles]="styles"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.cellStyles = null;
      /**
       * Sets/gets whether the column filtering should be case sensitive.
       * Default value is `true`.
       * ```typescript
       * let filteringIgnoreCase = this.column.filteringIgnoreCase;
       * ```
       * ```html
       * <igx-column [filteringIgnoreCase] = "false"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.filteringIgnoreCase = true;
      /**
       * Sets/gets whether the column sorting should be case sensitive.
       * Default value is `true`.
       * ```typescript
       * let sortingIgnoreCase = this.column.sortingIgnoreCase;
       * ```
       * ```html
       * <igx-column [sortingIgnoreCase] = "false"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.sortingIgnoreCase = true;
      /**
       * Sets/gets whether the column is `searchable`.
       * Default value is `true`.
       * ```typescript
       * let isSearchable =  this.column.searchable';
       * ```
       * ```html
       *  <igx-column [searchable] = "false"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.searchable = true;
      /**
       * Sets/gets the data type of the column values.
       * Default value is `string`.
       * ```typescript
       * let columnDataType = this.column.dataType;
       * ```
       * ```html
       * <igx-column [dataType] = "'number'"></igx-column>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.dataType = GridColumnDataType.String;
      /**
       * @hidden
       */
      this.widthChange = new EventEmitter();
      /**
       * @hidden
       */
      this.pinnedChange = new EventEmitter();
      /**
       * @hidden
       * @internal
       */
      this.defaultTimeFormat = 'hh:mm:ss a';
      /**
       * @hidden
       * @internal
       */
      this.defaultDateTimeFormat = 'dd/MM/yyyy HH:mm:ss a';
      /* alternateName: parentColumn */
      /**
       * Sets/gets the parent column.
       * ```typescript
       * let parentColumn = this.column.parent;
       * ```
       * ```typescript
       * this.column.parent = higherLevelColumn;
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.parent = null;
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
      /**
       * @hidden
       */
      this._applySelectableClass = false;
      this._vIndex = NaN;
      /**
       * @hidden
       */
      this._pinned = false;
      /**
       * @hidden
       */
      this._summaries = null;
      /**
       * @hidden
       */
      this._disabledSummaries = [];
      /**
       * @hidden
       */
      this._filters = null;
      /**
       * @hidden
       */
      this._sortStrategy = DefaultSortingStrategy.instance();
      /**
       * @hidden
       */
      this._hidden = false;
      /**
       * @hidden
       */
      this._disablePinning = false;
      /**
       * @hidden
       */
      this._defaultMinWidth = '';
      /**
       * @hidden
       */
      this._hasSummary = false;
      /**
       * @hidden
       */
      this._groupable = false;
      /**
       * @hidden
       */
      this._collapsible = false;
      /**
       * @hidden
       */
      this._expanded = true;
      /**
       * @hidden
       */
      this._selectable = true;
      this._calcWidth = null;
      this._columnPipeArgs = {
        digitsInfo: DEFAULT_DIGITS_INFO
      };
      this._editorOptions = {};
      this.validators = _validators;
    }
    /**
     * @hidden
     * @internal
     */
    resetCaches() {
      this._vIndex = NaN;
      if (this.grid) {
        this.cacheCalcWidth();
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      if (this.summaryTemplateDirective) {
        this._summaryTemplate = this.summaryTemplateDirective.template;
      }
      if (this.cellTemplate) {
        this._bodyTemplate = this.cellTemplate.template;
      }
      if (this.cellValidationErrorTemplate) {
        this._errorTemplate = this.cellValidationErrorTemplate.template;
      }
      if (this.headTemplate && this.headTemplate.length) {
        this._headerTemplate = this.headTemplate.toArray()[0].template;
      }
      if (this.editorTemplate) {
        this._inlineEditorTemplate = this.editorTemplate.template;
      }
      if (this.filterCellTemplateDirective) {
        this._filterCellTemplate = this.filterCellTemplateDirective.template;
      }
      if (!this._columnPipeArgs.format) {
        this._columnPipeArgs.format = this.dataType === GridColumnDataType.Time ? DEFAULT_TIME_FORMAT : this.dataType === GridColumnDataType.DateTime ? DEFAULT_DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT;
      }
      if (!this.summaries) {
        switch (this.dataType) {
          case GridColumnDataType.Number:
          case GridColumnDataType.Currency:
          case GridColumnDataType.Percent:
            this.summaries = IgxNumberSummaryOperand;
            break;
          case GridColumnDataType.Date:
          case GridColumnDataType.DateTime:
            this.summaries = IgxDateSummaryOperand;
            break;
          case GridColumnDataType.Time:
            this.summaries = IgxTimeSummaryOperand;
            break;
          case GridColumnDataType.String:
          case GridColumnDataType.Boolean:
          default:
            this.summaries = IgxSummaryOperand;
            break;
        }
      }
      if (!this.filters) {
        switch (this.dataType) {
          case GridColumnDataType.Boolean:
            this.filters = IgxBooleanFilteringOperand.instance();
            break;
          case GridColumnDataType.Number:
          case GridColumnDataType.Currency:
          case GridColumnDataType.Percent:
            this.filters = IgxNumberFilteringOperand.instance();
            break;
          case GridColumnDataType.Date:
            this.filters = IgxDateFilteringOperand.instance();
            break;
          case GridColumnDataType.Time:
            this.filters = IgxTimeFilteringOperand.instance();
            break;
          case GridColumnDataType.DateTime:
            this.filters = IgxDateTimeFilteringOperand.instance();
            break;
          case GridColumnDataType.Image:
            this.filterable = false;
            break;
          case GridColumnDataType.String:
          default:
            this.filters = IgxStringFilteringOperand.instance();
            break;
        }
      }
    }
    /**
     * @hidden
     */
    getGridTemplate(isRow) {
      if (isRow) {
        const rowsCount = this.grid.type !== 'pivot' ? this.grid.multiRowLayoutRowSize : this.children.length - 1;
        return `repeat(${rowsCount},1fr)`;
      } else {
        return this.getColumnSizesString(this.children);
      }
    }
    /** @hidden @internal **/
    getInitialChildColumnSizes(children) {
      const columnSizes = [];
      // find the smallest col spans
      children.forEach(col => {
        if (!col.colStart) {
          return;
        }
        const newWidthSet = col.widthSetByUser && columnSizes[col.colStart - 1] && !columnSizes[col.colStart - 1].widthSetByUser;
        const newSpanSmaller = columnSizes[col.colStart - 1] && columnSizes[col.colStart - 1].colSpan > col.gridColumnSpan;
        const bothWidthsSet = col.widthSetByUser && columnSizes[col.colStart - 1] && columnSizes[col.colStart - 1].widthSetByUser;
        const bothWidthsNotSet = !col.widthSetByUser && columnSizes[col.colStart - 1] && !columnSizes[col.colStart - 1].widthSetByUser;
        if (columnSizes[col.colStart - 1] === undefined) {
          // If nothing is defined yet take any column at first
          // We use colEnd to know where the column actually ends, because not always it starts where we have it set in columnSizes.
          columnSizes[col.colStart - 1] = {
            ref: col,
            width: col.width === 'fit-content' ? col.autoSize : col.widthSetByUser || this.grid.columnWidthSetByUser ? parseFloat(col.calcWidth) : null,
            colSpan: col.gridColumnSpan,
            colEnd: col.colStart + col.gridColumnSpan,
            widthSetByUser: col.widthSetByUser
          };
        } else if (newWidthSet || newSpanSmaller && (bothWidthsSet || bothWidthsNotSet)) {
          // If a column is set already it should either not have width defined or have width with bigger span than the new one.
          /**
           *  If replaced column has bigger span, we want to fill the remaining columns
           *  that the replacing column does not fill with the old one.
           */
          if (bothWidthsSet && newSpanSmaller) {
            // Start from where the new column set would end and apply the old column to the rest depending on how much it spans.
            // We have not yet replaced it so we can use it directly from the columnSizes collection.
            // This is where colEnd is used because the colStart of the old column is not actually i + 1.
            for (let i = col.colStart - 1 + col.gridColumnSpan; i < columnSizes[col.colStart - 1].colEnd - 1; i++) {
              if (!columnSizes[i] || !columnSizes[i].widthSetByUser) {
                columnSizes[i] = columnSizes[col.colStart - 1];
              } else {
                break;
              }
            }
          }
          // Replace the old column with the new one.
          columnSizes[col.colStart - 1] = {
            ref: col,
            width: col.width === 'fit-content' ? col.autoSize : col.widthSetByUser || this.grid.columnWidthSetByUser ? parseFloat(col.calcWidth) : null,
            colSpan: col.gridColumnSpan,
            colEnd: col.colStart + col.gridColumnSpan,
            widthSetByUser: col.widthSetByUser
          };
        } else if (bothWidthsSet && columnSizes[col.colStart - 1].colSpan < col.gridColumnSpan) {
          // If the column already in the columnSizes has smaller span, we still need to fill any empty places with the current col.
          // Start from where the smaller column set would end and apply the bigger column to the rest depending on how much it spans.
          // Since here we do not have it in columnSizes we set it as a new column keeping the same colSpan.
          for (let i = col.colStart - 1 + columnSizes[col.colStart - 1].colSpan; i < col.colStart - 1 + col.gridColumnSpan; i++) {
            if (!columnSizes[i] || !columnSizes[i].widthSetByUser) {
              columnSizes[i] = {
                ref: col,
                width: col.width === 'fit-content' ? col.autoSize : col.widthSetByUser || this.grid.columnWidthSetByUser ? parseFloat(col.calcWidth) : null,
                colSpan: col.gridColumnSpan,
                colEnd: col.colStart + col.gridColumnSpan,
                widthSetByUser: col.widthSetByUser
              };
            } else {
              break;
            }
          }
        }
      });
      // Flatten columnSizes so there are not columns with colSpan > 1
      for (let i = 0; i < columnSizes.length; i++) {
        if (columnSizes[i] && columnSizes[i].colSpan > 1) {
          let j = 1;
          // Replace all empty places depending on how much the current column spans starting from next col.
          for (; j < columnSizes[i].colSpan && i + j + 1 < columnSizes[i].colEnd; j++) {
            if (columnSizes[i + j] && (!columnSizes[i].width && columnSizes[i + j].width || !columnSizes[i].width && !columnSizes[i + j].width && columnSizes[i + j].colSpan <= columnSizes[i].colSpan || !!columnSizes[i + j].width && columnSizes[i + j].colSpan <= columnSizes[i].colSpan)) {
              // If we reach an already defined column that has width and the current doesn't have or
              // if the reached column has bigger colSpan we stop.
              break;
            } else {
              const width = columnSizes[i].widthSetByUser ? columnSizes[i].width / columnSizes[i].colSpan : columnSizes[i].width;
              columnSizes[i + j] = {
                ref: columnSizes[i].ref,
                width,
                colSpan: 1,
                colEnd: columnSizes[i].colEnd,
                widthSetByUser: columnSizes[i].widthSetByUser
              };
            }
          }
          // Update the current column width so it is divided between all columns it spans and set it to 1.
          columnSizes[i].width = columnSizes[i].widthSetByUser ? columnSizes[i].width / columnSizes[i].colSpan : columnSizes[i].width;
          columnSizes[i].colSpan = 1;
          // Update the index based on how much we have replaced. Subtract 1 because we started from 1.
          i += j - 1;
        }
      }
      return columnSizes;
    }
    /** @hidden @internal **/
    getFilledChildColumnSizes(children) {
      const columnSizes = this.getInitialChildColumnSizes(children);
      // fill the gaps if there are any
      const result = [];
      for (const size of columnSizes) {
        if (size && !!size.width) {
          result.push(size.width + 'px');
        } else {
          result.push(parseFloat(this.grid.getPossibleColumnWidth()) + 'px');
        }
      }
      return result;
    }
    /** @hidden @internal **/
    getResizableColUnderEnd() {
      if (this.columnLayout || !this.columnLayoutChild || this.columnGroup) {
        return [{
          target: this,
          spanUsed: 1
        }];
      }
      const columnSized = this.getInitialChildColumnSizes(this.parent.children);
      const targets = [];
      const colEnd = this.colEnd ? this.colEnd : this.colStart + 1;
      for (let i = 0; i < columnSized.length; i++) {
        if (this.colStart <= i + 1 && i + 1 < colEnd) {
          targets.push({
            target: columnSized[i].ref,
            spanUsed: 1
          });
        }
      }
      const targetsSquashed = [];
      for (const target of targets) {
        if (targetsSquashed.length && targetsSquashed[targetsSquashed.length - 1].target.field === target.target.field) {
          targetsSquashed[targetsSquashed.length - 1].spanUsed++;
        } else {
          targetsSquashed.push(target);
        }
      }
      return targetsSquashed;
    }
    /**
     * Pins the column at the provided index in the pinned area.
     * Defaults to index `0` if not provided, or to the initial index in the pinned area.
     * Returns `true` if the column is successfully pinned. Returns `false` if the column cannot be pinned.
     * Column cannot be pinned if:
     * - Is already pinned
     * - index argument is out of range
     * - The pinned area exceeds 80% of the grid width
     * ```typescript
     * let success = this.column.pin();
     * ```
     *
     * @memberof IgxColumnComponent
     */
    pin(index) {
      // TODO: Probably should the return type of the old functions
      // should be moved as a event parameter.
      const grid = this.grid;
      if (this._pinned) {
        return false;
      }
      if (this.parent && !this.parent.pinned) {
        return this.topLevelParent.pin(index);
      }
      const hasIndex = index !== undefined;
      if (hasIndex && (index < 0 || index > grid.pinnedColumns.length)) {
        return false;
      }
      if (!this.parent && !this.pinnable) {
        return false;
      }
      const rootPinnedCols = grid._pinnedColumns.filter(c => c.level === 0);
      index = hasIndex ? index : rootPinnedCols.length;
      const args = {
        column: this,
        insertAtIndex: index,
        isPinned: false,
        cancel: false
      };
      this.grid.columnPin.emit(args);
      if (args.cancel) {
        return;
      }
      this.grid.crudService.endEdit(false);
      this._pinned = true;
      this.pinnedChange.emit(this._pinned);
      // it is possible that index is the last position, so will need to find target column by [index-1]
      const targetColumn = args.insertAtIndex === grid._pinnedColumns.length ? grid._pinnedColumns[args.insertAtIndex - 1] : grid._pinnedColumns[args.insertAtIndex];
      if (grid._pinnedColumns.indexOf(this) === -1) {
        if (!grid.hasColumnGroups) {
          grid._pinnedColumns.splice(args.insertAtIndex, 0, this);
        } else {
          // insert based only on root collection
          if (this.level === 0) {
            rootPinnedCols.splice(args.insertAtIndex, 0, this);
          }
          let allPinned = [];
          // FIX: this is duplicated on every step in the hierarchy....
          // re-create hierarchy
          rootPinnedCols.forEach(group => {
            allPinned.push(group);
            allPinned = allPinned.concat(group.allChildren);
          });
          grid._pinnedColumns = allPinned;
        }
        if (grid._unpinnedColumns.indexOf(this) !== -1) {
          const childrenCount = this.allChildren.length;
          grid._unpinnedColumns.splice(grid._unpinnedColumns.indexOf(this), 1 + childrenCount);
        }
      }
      if (hasIndex) {
        index === grid._pinnedColumns.length - 1 ? grid._moveColumns(this, targetColumn, DropPosition.AfterDropTarget) : grid._moveColumns(this, targetColumn, DropPosition.BeforeDropTarget);
      }
      if (this.columnGroup) {
        this.allChildren.forEach(child => child.pin());
        grid.reinitPinStates();
      }
      grid.resetCaches();
      grid.notifyChanges();
      if (this.columnLayoutChild) {
        this.grid.columns.filter(x => x.columnLayout).forEach(x => x.populateVisibleIndexes());
      }
      this.grid.filteringService.refreshExpressions();
      const eventArgs = {
        column: this,
        insertAtIndex: index,
        isPinned: true
      };
      this.grid.columnPinned.emit(eventArgs);
      return true;
    }
    /**
     * Unpins the column and place it at the provided index in the unpinned area.
     * Defaults to index `0` if not provided, or to the initial index in the unpinned area.
     * Returns `true` if the column is successfully unpinned. Returns `false` if the column cannot be unpinned.
     * Column cannot be unpinned if:
     * - Is already unpinned
     * - index argument is out of range
     * ```typescript
     * let success = this.column.unpin();
     * ```
     *
     * @memberof IgxColumnComponent
     */
    unpin(index) {
      const grid = this.grid;
      if (!this._pinned) {
        return false;
      }
      if (this.parent && this.parent.pinned) {
        return this.topLevelParent.unpin(index);
      }
      const hasIndex = index !== undefined;
      if (hasIndex && (index < 0 || index > grid._unpinnedColumns.length)) {
        return false;
      }
      // estimate the exact index at which column will be inserted
      // takes into account initial unpinned index of the column
      if (!hasIndex) {
        const indices = grid.unpinnedColumns.map(col => col.index);
        indices.push(this.index);
        indices.sort((a, b) => a - b);
        index = indices.indexOf(this.index);
      }
      const args = {
        column: this,
        insertAtIndex: index,
        isPinned: true,
        cancel: false
      };
      this.grid.columnPin.emit(args);
      if (args.cancel) {
        return;
      }
      this.grid.crudService.endEdit(false);
      this._pinned = false;
      this.pinnedChange.emit(this._pinned);
      // it is possible that index is the last position, so will need to find target column by [index-1]
      const targetColumn = args.insertAtIndex === grid._unpinnedColumns.length ? grid._unpinnedColumns[args.insertAtIndex - 1] : grid._unpinnedColumns[args.insertAtIndex];
      if (!hasIndex) {
        grid._unpinnedColumns.splice(index, 0, this);
        if (grid._pinnedColumns.indexOf(this) !== -1) {
          grid._pinnedColumns.splice(grid._pinnedColumns.indexOf(this), 1);
        }
      }
      if (hasIndex) {
        grid.moveColumn(this, targetColumn);
      }
      if (this.columnGroup) {
        this.allChildren.forEach(child => child.unpin());
      }
      grid.reinitPinStates();
      grid.resetCaches();
      grid.notifyChanges();
      if (this.columnLayoutChild) {
        this.grid.columns.filter(x => x.columnLayout).forEach(x => x.populateVisibleIndexes());
      }
      this.grid.filteringService.refreshExpressions();
      this.grid.columnPinned.emit({
        column: this,
        insertAtIndex: index,
        isPinned: false
      });
      return true;
    }
    /**
     * Moves a column to the specified visible index.
     * If passed index is invalid, or if column would receive a different visible index after moving, moving is not performed.
     * If passed index would move the column to a different column group. moving is not performed.
     *
     * @example
     * ```typescript
     * column.move(index);
     * ```
     * @memberof IgxColumnComponent
     */
    move(index) {
      let target;
      let columns = this.grid.columns.filter(c => c.visibleIndex > -1);
      // grid last visible index
      const li = columns.map(c => c.visibleIndex).reduce((a, b) => Math.max(a, b));
      const parent = this.parent;
      const isPreceding = this.visibleIndex < index;
      if (index === this.visibleIndex || index < 0 || index > li) {
        return;
      }
      if (parent) {
        columns = columns.filter(c => c.level >= this.level && c !== this && c.parent !== this && c.topLevelParent === this.topLevelParent);
      }
      // If isPreceding, find a target such that when the current column is placed after it, current colummn will receive a visibleIndex === index. This takes into account visible children of the columns.
      // If !isPreceding, finds a column of the same level and visible index that equals the passed index agument (c.visibleIndex === index). No need to consider the children here.
      if (isPreceding) {
        columns = columns.filter(c => c.visibleIndex > this.visibleIndex);
        target = columns.find(c => c.level === this.level && c.visibleIndex + c.calcChildren() - this.calcChildren() === index);
      } else {
        columns = columns.filter(c => c.visibleIndex < this.visibleIndex);
        target = columns.find(c => c.level === this.level && c.visibleIndex === index);
      }
      if (!target || target.pinned && this.disablePinning) {
        return;
      }
      const pos = isPreceding ? DropPosition.AfterDropTarget : DropPosition.BeforeDropTarget;
      this.grid.moveColumn(this, target, pos);
    }
    /**
     * No children for the column, so will returns 1 or 0, if the column is hidden.
     *
     * @hidden
     */
    calcChildren() {
      const children = this.hidden ? 0 : 1;
      return children;
    }
    /**
     * Toggles column vibisility and emits the respective event.
     *
     * @hidden
     */
    toggleVisibility(value) {
      const newValue = value ?? !this.hidden;
      const eventArgs = {
        column: this,
        newValue,
        cancel: false
      };
      this.grid.columnVisibilityChanging.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.hidden = newValue;
      this.grid.columnVisibilityChanged.emit({
        column: this,
        newValue
      });
    }
    /**
     * Returns a reference to the top level parent column.
     * ```typescript
     * let topLevelParent =  this.column.topLevelParent;
     * ```
     */
    get topLevelParent() {
      let parent = this.parent;
      while (parent && parent.parent) {
        parent = parent.parent;
      }
      return parent ?? undefined;
    }
    /**
     * @hidden @internal
     */
    get headerCell() {
      return this.grid.headerCellList.find(header => header.column === this);
    }
    /**
     * @hidden @internal
     */
    get filterCell() {
      return this.grid.filterCellList.find(filterCell => filterCell.column === this);
    }
    /**
     * @hidden @internal
     */
    get headerGroup() {
      return this.grid.headerGroupsList.find(group => group.column === this);
    }
    /**
     * Autosize the column to the longest currently visible cell value, including the header cell.
     * ```typescript
     * @ViewChild('grid') grid: IgxGridComponent;
     * let column = this.grid.columnList.filter(c => c.field === 'ID')[0];
     * column.autosize();
     * ```
     *
     * @memberof IgxColumnComponent
     * @param byHeaderOnly Set if column should be autosized based only on the header content.
     */
    autosize(byHeaderOnly = false) {
      if (!this.columnGroup) {
        this.width = this.getAutoSize(byHeaderOnly);
        this.grid.reflow();
      }
    }
    /**
     * @hidden
     */
    getAutoSize(byHeader = false) {
      const size = !byHeader ? this.getLargestCellWidth() : Object.values(this.getHeaderCellWidths()).reduce((a, b) => a + b) + 'px';
      const isPercentageWidth = this.width && typeof this.width === 'string' && this.width.indexOf('%') !== -1;
      let newWidth;
      if (isPercentageWidth) {
        const gridAvailableSize = this.grid.calcWidth;
        const percentageSize = parseFloat(size) / gridAvailableSize * 100;
        newWidth = percentageSize + '%';
      } else {
        newWidth = size;
      }
      const maxWidth = isPercentageWidth ? this.maxWidthPercent : this.maxWidthPx;
      const minWidth = isPercentageWidth ? this.minWidthPercent : this.minWidthPx;
      if (this.maxWidth && parseFloat(newWidth) > maxWidth) {
        newWidth = isPercentageWidth ? maxWidth + '%' : maxWidth + 'px';
      } else if (parseFloat(newWidth) < minWidth) {
        newWidth = isPercentageWidth ? minWidth + '%' : minWidth + 'px';
      }
      return newWidth;
    }
    /**
     * @hidden
     */
    getCalcWidth() {
      if (this._calcWidth && !isNaN(this.calcPixelWidth)) {
        return this._calcWidth;
      }
      this.cacheCalcWidth();
      return this._calcWidth;
    }
    /**
     * @hidden
     * Returns the width and padding of a header cell.
     */
    getHeaderCellWidths() {
      return this.grid.getHeaderCellWidth(this.headerCell.nativeElement);
    }
    /**
     * @hidden
     * Returns the size (in pixels) of the longest currently visible cell, including the header cell.
     * ```typescript
     * @ViewChild('grid') grid: IgxGridComponent;
     *
     * let column = this.grid.columnList.filter(c => c.field === 'ID')[0];
     * let size = column.getLargestCellWidth();
     * ```
     * @memberof IgxColumnComponent
     */
    getLargestCellWidth() {
      const range = this.grid.document.createRange();
      const largest = new Map();
      if (this._cells.length > 0) {
        const cellsContentWidths = [];
        this._cells.forEach(cell => cellsContentWidths.push(cell.calculateSizeToFit(range)));
        const index = cellsContentWidths.indexOf(Math.max(...cellsContentWidths));
        const cellStyle = this.grid.document.defaultView.getComputedStyle(this._cells[index].nativeElement);
        const cellPadding = parseFloat(cellStyle.paddingLeft) + parseFloat(cellStyle.paddingRight) + parseFloat(cellStyle.borderLeftWidth) + parseFloat(cellStyle.borderRightWidth);
        largest.set(Math.max(...cellsContentWidths), cellPadding);
      }
      if (this.headerCell && this.autosizeHeader) {
        const headerCellWidths = this.getHeaderCellWidths();
        largest.set(headerCellWidths.width, headerCellWidths.padding);
      }
      const largestCell = Math.max(...Array.from(largest.keys()));
      const width = Math.ceil(largestCell + largest.get(largestCell));
      if (Number.isNaN(width)) {
        return this.width;
      } else {
        return width + 'px';
      }
    }
    /**
     * @hidden
     */
    getCellWidth() {
      const colWidth = this.width;
      const isPercentageWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1;
      if (this.columnLayoutChild) {
        return '';
      }
      if (colWidth && !isPercentageWidth) {
        let cellWidth = colWidth;
        if (typeof cellWidth !== 'string' || cellWidth.endsWith('px') === false) {
          cellWidth += 'px';
        }
        return cellWidth;
      } else {
        return colWidth;
      }
    }
    /**
     * @hidden
     */
    populateVisibleIndexes() {}
    getColumnSizesString(children) {
      const res = this.getFilledChildColumnSizes(children);
      return res.join(' ');
    }
    /**
     * @hidden
     * @internal
     */
    cacheCalcWidth() {
      const colWidth = this.width;
      const isPercentageWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1;
      const isAutoWidth = colWidth && typeof colWidth === 'string' && colWidth === 'fit-content';
      if (isPercentageWidth && this.grid.isColumnWidthSum) {
        this._calcWidth = this.grid.minColumnWidth;
      } else if (isPercentageWidth) {
        this._calcWidth = parseFloat(colWidth) / 100 * this.grid.calcWidth;
      } else if (!colWidth || isAutoWidth && !this.autoSize) {
        // no width
        this._calcWidth = this.defaultWidth || this.grid.getPossibleColumnWidth();
      } else {
        this._calcWidth = this.width;
      }
      this.calcPixelWidth = parseFloat(this._calcWidth);
    }
    /**
     * @hidden
     * @internal
     */
    setExpandCollapseState() {
      this.children.filter(col => col.visibleWhenCollapsed !== undefined).forEach(c => {
        if (!this.collapsible) {
          c.hidden = this.hidden;
          return;
        }
        c.hidden = this._expanded ? c.visibleWhenCollapsed : !c.visibleWhenCollapsed;
      });
    }
    /**
     * @hidden
     * @internal
     */
    checkCollapsibleState() {
      if (!this.children) {
        return false;
      }
      const cols = this.children.map(child => child.visibleWhenCollapsed);
      return cols.some(c => c === true) && cols.some(c => c === false);
    }
    /**
     * @hidden
     */
    get pinnable() {
      return this.grid._init || !this.pinned;
    }
    /**
     * @hidden
     */
    get applySelectableClass() {
      return this._applySelectableClass;
    }
    /**
     * @hidden
     */
    set applySelectableClass(value) {
      if (this.selectable) {
        this._applySelectableClass = value;
      }
    }
    static {
      this.ɵfac = function IgxColumnComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(NG_VALIDATORS, 10), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxColumnComponent,
        selectors: [["igx-column"]],
        contentQueries: function IgxColumnComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxFilterCellTemplateDirective, 5, IgxFilterCellTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxSummaryTemplateDirective, 5, IgxSummaryTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCellTemplateDirective, 5, IgxCellTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCellValidationErrorDirective, 5, IgxCellValidationErrorDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCellEditorTemplateDirective, 5, IgxCellEditorTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCollapsibleIndicatorTemplateDirective, 5, IgxCollapsibleIndicatorTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxCellHeaderTemplateDirective, 4, IgxCellHeaderTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterCellTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.summaryTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellValidationErrorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headTemplate = _t);
          }
        },
        inputs: {
          field: "field",
          header: "header",
          title: "title",
          sortable: [2, "sortable", "sortable", booleanAttribute],
          selectable: "selectable",
          groupable: [2, "groupable", "groupable", booleanAttribute],
          editable: [2, "editable", "editable", booleanAttribute],
          filterable: [2, "filterable", "filterable", booleanAttribute],
          resizable: [2, "resizable", "resizable", booleanAttribute],
          autosizeHeader: [2, "autosizeHeader", "autosizeHeader", booleanAttribute],
          hasSummary: [2, "hasSummary", "hasSummary", booleanAttribute],
          hidden: [2, "hidden", "hidden", booleanAttribute],
          disableHiding: [2, "disableHiding", "disableHiding", booleanAttribute],
          disablePinning: [2, "disablePinning", "disablePinning", booleanAttribute],
          width: "width",
          maxWidth: "maxWidth",
          headerClasses: "headerClasses",
          headerStyles: "headerStyles",
          headerGroupClasses: "headerGroupClasses",
          headerGroupStyles: "headerGroupStyles",
          cellClasses: "cellClasses",
          cellStyles: "cellStyles",
          formatter: "formatter",
          summaryFormatter: "summaryFormatter",
          filteringIgnoreCase: [2, "filteringIgnoreCase", "filteringIgnoreCase", booleanAttribute],
          sortingIgnoreCase: [2, "sortingIgnoreCase", "sortingIgnoreCase", booleanAttribute],
          searchable: [2, "searchable", "searchable", booleanAttribute],
          dataType: "dataType",
          collapsibleIndicatorTemplate: "collapsibleIndicatorTemplate",
          rowEnd: "rowEnd",
          colEnd: "colEnd",
          rowStart: "rowStart",
          colStart: "colStart",
          additionalTemplateContext: "additionalTemplateContext",
          minWidth: "minWidth",
          pinned: [2, "pinned", "pinned", booleanAttribute],
          summaries: "summaries",
          disabledSummaries: "disabledSummaries",
          filters: "filters",
          sortStrategy: "sortStrategy",
          groupingComparer: "groupingComparer",
          summaryTemplate: "summaryTemplate",
          bodyTemplate: [0, "cellTemplate", "bodyTemplate"],
          headerTemplate: "headerTemplate",
          inlineEditorTemplate: [0, "cellEditorTemplate", "inlineEditorTemplate"],
          errorTemplate: "errorTemplate",
          filterCellTemplate: "filterCellTemplate",
          visibleWhenCollapsed: [2, "visibleWhenCollapsed", "visibleWhenCollapsed", booleanAttribute],
          pipeArgs: "pipeArgs",
          editorOptions: "editorOptions"
        },
        outputs: {
          hiddenChange: "hiddenChange",
          expandedChange: "expandedChange",
          collapsibleChange: "collapsibleChange",
          visibleWhenCollapsedChange: "visibleWhenCollapsedChange",
          columnChange: "columnChange",
          widthChange: "widthChange",
          pinnedChange: "pinnedChange"
        },
        decls: 0,
        vars: 0,
        template: function IgxColumnComponent_Template(rf, ctx) {},
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "header", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "title", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "sortable", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "selectable", null);
  __decorate([notifyChanges(true), WatchColumnChanges()], IgxColumnComponent.prototype, "groupable", null);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "editable", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "filterable", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "resizable", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "autosizeHeader", void 0);
  __decorate([notifyChanges(true), WatchColumnChanges()], IgxColumnComponent.prototype, "hasSummary", null);
  __decorate([notifyChanges(true), WatchColumnChanges()], IgxColumnComponent.prototype, "hidden", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "disableHiding", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "disablePinning", void 0);
  __decorate([notifyChanges(true), WatchColumnChanges()], IgxColumnComponent.prototype, "width", null);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "maxWidth", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "headerClasses", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "headerStyles", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "headerGroupClasses", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "headerGroupStyles", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "cellClasses", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "cellStyles", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "formatter", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "summaryFormatter", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "filteringIgnoreCase", void 0);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "sortingIgnoreCase", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "searchable", void 0);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "minWidth", null);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "pinned", null);
  __decorate([notifyChanges(true), WatchColumnChanges()], IgxColumnComponent.prototype, "summaries", null);
  __decorate([WatchColumnChanges()], IgxColumnComponent.prototype, "disabledSummaries", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "summaryTemplate", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "bodyTemplate", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "headerTemplate", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "inlineEditorTemplate", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "errorTemplate", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "filterCellTemplate", null);
  __decorate([notifyChanges(true)], IgxColumnComponent.prototype, "visibleWhenCollapsed", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "pipeArgs", null);
  __decorate([notifyChanges(), WatchColumnChanges()], IgxColumnComponent.prototype, "editorOptions", null);
  return IgxColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* omitModule */
/* wcElementTag: igc-column-group */
/* additionalIdentifier: Children.Field */
/* jsonAPIManageCollectionInMarkup */
/* blazorIndirectRender */
/**
 * **Ignite UI for Angular Column Group**
 *
 * @igxParent IgxGridComponent, IgxTreeGridComponent, IgxHierarchicalGridComponent, IgxColumnGroupComponent, IgxRowIslandComponent
 */
let IgxColumnGroupComponent = /*#__PURE__*/(() => {
  class IgxColumnGroupComponent extends IgxColumnComponent {
    constructor() {
      super(...arguments);
      /* blazorInclude */
      /* contentChildren */
      /* blazorTreatAsCollection */
      /* blazorCollectionName: ColumnCollection */
      /* blazorCollectionItemName: Column */
      /* alternateType: HTMLCollection */
      /**
       * @deprecated in version 18.1.0. Use the `childColumns` property instead.
       */
      this.children = new QueryList();
      /* blazorSuppress */
      /**
       * Sets/gets whether the column group is `searchable`.
       * Default value is `true`.
       * ```typescript
       * let isSearchable =  this.columnGroup.searchable;
       * ```
       * ```html
       *  <igx-column-group [searchable] = "false"></igx-column-group>
       * ```
       *
       * @memberof IgxColumnGroupComponent
       */
      this.searchable = true;
    }
    /**
     * Set if the column group is collapsible.
     * Default value is `false`
     * ```html
     *  <igx-column-group [collapsible] = "true"></igx-column-group>
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set collapsible(value) {
      this._collapsible = value;
      this.collapsibleChange.emit(this._collapsible);
      if (this.children && !this.hidden) {
        if (this._collapsible) {
          this.setExpandCollapseState();
        } else {
          this.children.forEach(child => child.hidden = false);
        }
      }
    }
    get collapsible() {
      return this._collapsible && this.checkCollapsibleState();
    }
    /**
     * Set whether the group is expanded or collapsed initially.
     * Applied only if the collapsible property is set to `true`
     * Default value is `true`
     * ```html
     *  const state = false
     *  <igx-column-group [(expand)] = "state"></igx-column-group>
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set expanded(value) {
      this._expanded = value;
      this.expandedChange.emit(this._expanded);
      if (!this.collapsible) {
        return;
      }
      if (!this.hidden && this.children) {
        this.setExpandCollapseState();
      }
    }
    get expanded() {
      return this._expanded;
    }
    /**
     * Gets the column group `summaries`.
     * ```typescript
     * let columnGroupSummaries = this.columnGroup.summaries;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get summaries() {
      return this._summaries;
    }
    /* blazorSuppress */
    /**
     * Sets the column group `summaries`.
     * ```typescript
     * this.columnGroup.summaries = IgxNumberSummaryOperand;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set summaries(classRef) {}
    /**
     * Gets the column group `filters`.
     * ```typescript
     * let columnGroupFilters = this.columnGroup.filters;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get filters() {
      return this._filters;
    }
    /* blazorSuppress */
    /**
     * Sets the column group `filters`.
     * ```typescript
     * this.columnGroup.filters = IgxStringFilteringOperand;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set filters(classRef) {}
    /**
     * Returns if the column group is selectable
     * ```typescript
     * let columnGroupSelectable = this.columnGroup.selectable;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get selectable() {
      return this.children && this.children.some(child => child.selectable);
    }
    /**
     * @hidden
     */
    set selectable(value) {}
    /**
     * @hidden
     */
    get bodyTemplate() {
      return this._bodyTemplate;
    }
    /**
     * @hidden
     */
    set bodyTemplate(template) {}
    /**
     * @hidden
     */
    get inlineEditorTemplate() {
      return this._inlineEditorTemplate;
    }
    /**
     * @hidden
     */
    set inlineEditorTemplate(template) {}
    /**
     * @hidden @internal
     */
    get cells() {
      return [];
    }
    /**
     * Gets whether the column group is hidden.
     * ```typescript
     * let isHidden = this.columnGroup.hidden;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get hidden() {
      return this.allChildren.every(c => c.hidden);
    }
    /* blazorSuppress */
    /**
     * Sets the column group hidden property.
     * ```html
     * <igx-column [hidden] = "true"></igx-column>
     * ```
     *
     * Two-way data binding
     * ```html
     * <igx-column [(hidden)] = "model.columns[0].isHidden"></igx-column>
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set hidden(value) {
      this._hidden = value;
      this.hiddenChange.emit(this._hidden);
      if (this._hidden || !this.collapsible) {
        this.children.forEach(child => child.hidden = this._hidden);
      } else {
        this.children.forEach(c => {
          if (c.visibleWhenCollapsed === undefined) {
            c.hidden = false;
            return;
          }
          c.hidden = this.expanded ? c.visibleWhenCollapsed : !c.visibleWhenCollapsed;
        });
      }
    }
    /**
     * Returns if the column group is selected.
     * ```typescript
     * let isSelected = this.columnGroup.selected;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get selected() {
      const selectableChildren = this.allChildren.filter(c => !c.columnGroup && c.selectable && !c.hidden);
      return selectableChildren.length > 0 && selectableChildren.every(c => c.selected);
    }
    /* blazorSuppress */
    /**
     * Select/deselect the column group.
     * ```typescript
     * this.columnGroup.selected = true;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set selected(value) {
      if (this.selectable) {
        this.children.forEach(c => {
          c.selected = value;
        });
      }
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      /*
          @ContentChildren with descendants still returns the `parent`
          component in the query list.
      */
      if (this.headTemplate && this.headTemplate.length) {
        this._headerTemplate = this.headTemplate.toArray()[0].template;
      }
      if (this.collapseIndicatorTemplate) {
        this.collapsibleIndicatorTemplate = this.collapseIndicatorTemplate.template;
      }
      // currently only ivy fixes the issue, we have to slice only if the first child is group
      if (this.children.first === this) {
        this.children.reset(this.children.toArray().slice(1));
      }
      this.children.forEach(child => {
        child.parent = this;
        if (this.pinned) {
          child.pinned = this.pinned;
        }
        if (this._hidden) {
          child.hidden = this._hidden;
        }
      });
      if (this.collapsible) {
        this.setExpandCollapseState();
      }
      this.children.changes.pipe(takeUntil(this.destroy$)).subscribe(change => {
        let shouldReinitPinning = false;
        change.forEach(x => {
          x.parent = this;
          if (this.pinned && x.pinned !== this.pinned) {
            shouldReinitPinning = true;
            x.pinned = this.pinned;
          }
        });
        if (this.collapsible) {
          this.setExpandCollapseState();
        }
        if (shouldReinitPinning) {
          this.grid.initPinning();
        }
      });
    }
    /**
     * A list containing all the child columns under this column (if any).
     * Empty without children or if this column is not Group or Layout.
     */
    get childColumns() {
      return this.children.toArray();
    }
    /** @hidden @internal **/
    get allChildren() {
      return flatten$1(this.children.toArray());
    }
    /**
     * Returns a boolean indicating if the column is a `ColumnGroup`.
     * ```typescript
     * let isColumnGroup =  this.columnGroup.columnGroup
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get columnGroup() {
      return true;
    }
    /**
     * Returns a boolean indicating if the column is a `ColumnLayout` for multi-row layout.
     * ```typescript
     * let columnGroup =  this.column.columnGroup;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get columnLayout() {
      return false;
    }
    /**
     * Gets the width of the column group.
     * ```typescript
     * let columnGroupWidth = this.columnGroup.width;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get width() {
      const width = `${this.children.reduce((acc, val) => {
        if (val.hidden) {
          return acc;
        }
        return acc + parseFloat(val.calcWidth);
      }, 0)}`;
      return width + 'px';
    }
    /* blazorSuppress */
    set width(val) {}
    /** @hidden @internal **/
    get resolvedWidth() {
      return this.width;
    }
    /**
     * @hidden
     */
    get applySelectableClass() {
      return this._applySelectableClass;
    }
    /**
     * @hidden
     */
    set applySelectableClass(value) {
      if (this.selectable) {
        this._applySelectableClass = value;
        this.children.forEach(c => {
          c.applySelectableClass = value;
        });
      }
    }
    /**
     * @hidden
     * Calculates the number of visible columns, based on indexes of first and last visible columns.
     */
    calcChildren() {
      const visibleChildren = this.allChildren.filter(c => c.visibleIndex > -1);
      const fi = visibleChildren[0].visibleIndex;
      const li = visibleChildren[visibleChildren.length - 1].visibleIndex;
      return li - fi + 1;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnGroupComponent_BaseFactory;
        return function IgxColumnGroupComponent_Factory(__ngFactoryType__) {
          return (ɵIgxColumnGroupComponent_BaseFactory || (ɵIgxColumnGroupComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnGroupComponent)))(__ngFactoryType__ || IgxColumnGroupComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxColumnGroupComponent,
        selectors: [["igx-column-group"]],
        contentQueries: function IgxColumnGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxColumnComponent, 4, IgxColumnComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        inputs: {
          collapsible: [2, "collapsible", "collapsible", booleanAttribute],
          expanded: [2, "expanded", "expanded", booleanAttribute],
          summaries: "summaries",
          searchable: [2, "searchable", "searchable", booleanAttribute],
          filters: "filters",
          collapsibleIndicatorTemplate: "collapsibleIndicatorTemplate",
          hidden: [2, "hidden", "hidden", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxColumnComponent,
          useExisting: forwardRef(() => IgxColumnGroupComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c72,
        decls: 1,
        vars: 1,
        consts: [["sink", ""], [2, "display", "none"]],
        template: function IgxColumnGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c71);
            i0.ɵɵtemplate(0, IgxColumnGroupComponent_Conditional_0_Template, 3, 0, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.platform.isElements ? 0 : -1);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxColumnGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorIndirectRender */
/* blazorElement */
/* omitModule */
/* wcElementTag: igc-column-layout */
/* additionalIdentifier: Children.Field */
/* jsonAPIManageCollectionInMarkup */
/**
 * Column layout for declaration of Multi-row Layout
 *
 * @igxParent IgxGridComponent
 */
let IgxColumnLayoutComponent = /*#__PURE__*/(() => {
  class IgxColumnLayoutComponent extends IgxColumnGroupComponent {
    constructor() {
      super(...arguments);
      /** @hidden @internal **/
      this.childrenVisibleIndexes = [];
    }
    /**
     * Gets the width of the column layout.
     * ```typescript
     * let columnGroupWidth = this.columnGroup.width;
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    get width() {
      const width = this.getFilledChildColumnSizes(this.children).reduce((acc, val) => acc + parseFloat(val), 0);
      return width;
    }
    /* blazorSuppress */
    set width(val) {}
    get columnLayout() {
      return true;
    }
    /**
     * @hidden
     */
    getCalcWidth() {
      let borderWidth = 0;
      if (this.headerGroup && this.headerGroup.hasLastPinnedChildColumn) {
        const headerStyles = this.grid.document.defaultView.getComputedStyle(this.headerGroup.nativeElement.children[0]);
        borderWidth = parseFloat(headerStyles.borderRightWidth);
      }
      return super.getCalcWidth() + borderWidth;
    }
    /**
     * Gets the column visible index.
     * If the column is not visible, returns `-1`.
     * ```typescript
     * let visibleColumnIndex =  this.column.visibleIndex;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get visibleIndex() {
      if (!isNaN(this._vIndex)) {
        return this._vIndex;
      }
      const unpinnedColumns = this.grid.unpinnedColumns.filter(c => c.columnLayout && !c.hidden);
      const pinnedColumns = this.grid.pinnedColumns.filter(c => c.columnLayout && !c.hidden);
      let vIndex = -1;
      if (!this.pinned) {
        const indexInCollection = unpinnedColumns.indexOf(this);
        vIndex = indexInCollection === -1 ? -1 : pinnedColumns.length + indexInCollection;
      } else {
        vIndex = pinnedColumns.indexOf(this);
      }
      this._vIndex = vIndex;
      return vIndex;
    }
    /*
     * Gets whether the column layout is hidden.
     * ```typescript
     * let isHidden = this.columnGroup.hidden;
     * ```
     * @memberof IgxColumnGroupComponent
     */
    get hidden() {
      return this._hidden;
    }
    /* blazorSuppress */
    /**
     * Sets the column layout hidden property.
     * ```typescript
     * <igx-column-layout [hidden] = "true"></igx-column->
     * ```
     *
     * @memberof IgxColumnGroupComponent
     */
    set hidden(value) {
      this._hidden = value;
      this.children.forEach(child => child.hidden = value);
      if (this.grid && this.grid.columns && this.grid.columns.length > 0) {
        // reset indexes in case columns are hidden/shown runtime
        const columns = this.grid && this.grid.pinnedColumns && this.grid.unpinnedColumns ? this.grid.pinnedColumns.concat(this.grid.unpinnedColumns) : [];
        if (!this._hidden && !columns.find(c => c.field === this.field)) {
          this.grid.resetColumnCollections();
        }
        this.grid.columns.filter(x => x.columnLayout).forEach(x => x.populateVisibleIndexes());
      }
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      super.ngAfterContentInit();
      if (!this.hidden) {
        this.hidden = this.allChildren.some(x => x.hidden);
      } else {
        this.children.forEach(child => child.hidden = this.hidden);
      }
    }
    /** @hidden @internal **/
    get hasLastPinnedChildColumn() {
      return this.children.some(child => child.isLastPinned);
    }
    /** @hidden @internal **/
    get hasFirstPinnedChildColumn() {
      return this.children.some(child => child.isFirstPinned);
    }
    /**
     * @hidden
     */
    populateVisibleIndexes() {
      this.childrenVisibleIndexes = [];
      const columns = this.grid?.pinnedColumns && this.grid?.unpinnedColumns ? this.grid.pinnedColumns.concat(this.grid.unpinnedColumns) : [];
      const orderedCols = columns.filter(x => !x.columnGroup && !x.hidden).sort((a, b) => a.rowStart - b.rowStart || columns.indexOf(a.parent) - columns.indexOf(b.parent) || a.colStart - b.colStart);
      this.children.forEach(child => {
        const rs = child.rowStart || 1;
        let vIndex = 0;
        // filter out all cols with larger rowStart
        const cols = orderedCols.filter(c => !c.columnGroup && (c.rowStart || 1) <= rs);
        vIndex = cols.indexOf(child);
        this.childrenVisibleIndexes.push({
          column: child,
          index: vIndex
        });
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxColumnLayoutComponent_BaseFactory;
        return function IgxColumnLayoutComponent_Factory(__ngFactoryType__) {
          return (ɵIgxColumnLayoutComponent_BaseFactory || (ɵIgxColumnLayoutComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxColumnLayoutComponent)))(__ngFactoryType__ || IgxColumnLayoutComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxColumnLayoutComponent,
        selectors: [["igx-column-layout"]],
        inputs: {
          hidden: [2, "hidden", "hidden", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxColumnComponent,
          useExisting: forwardRef(() => IgxColumnLayoutComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c74,
        decls: 1,
        vars: 1,
        consts: [["sink", ""], [2, "display", "none"]],
        template: function IgxColumnLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c73);
            i0.ɵɵtemplate(0, IgxColumnLayoutComponent_Conditional_0_Template, 3, 0, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.platform.isElements ? 0 : -1);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxColumnLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxColumnGroupComponent } from './column-group.component';
// import { IgxColumnLayoutComponent } from './column-layout.component';
// import { IgxColumnComponent } from './column.component';
// import {
//     IgxCellEditorTemplateDirective,
//     IgxCellFooterTemplateDirective,
//     IgxCellHeaderTemplateDirective,
//     IgxCellTemplateDirective,
//     IgxCellValidationErrorDirective,
//     IgxCollapsibleIndicatorTemplateDirective,
//     IgxFilterCellTemplateDirective,
//     IgxSummaryTemplateDirective
// } from './templates.directive';
/* NOTE: Grid column validation directives collection for ease-of-use import in standalone components scenario */
const IGX_GRID_VALIDATION_DIRECTIVES = [IgxColumnRequiredValidatorDirective, IgxColumnMinValidatorDirective, IgxColumnMaxValidatorDirective, IgxColumnEmailValidatorDirective, IgxColumnMinLengthValidatorDirective, IgxColumnMaxLengthValidatorDirective, IgxColumPatternValidatorDirective];
/* NOTE: Grid column validation directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_COLUMN_DIRECTIVES = [
//     IgxFilterCellTemplateDirective,
//     IgxSummaryTemplateDirective,
//     IgxCellTemplateDirective,
//     IgxCellValidationErrorDirective,
//     IgxCellHeaderTemplateDirective,
//     IgxCellFooterTemplateDirective,
//     IgxCellEditorTemplateDirective,
//     IgxCollapsibleIndicatorTemplateDirective,
//     IgxColumnComponent,
//     IgxColumnGroupComponent,
//     IgxColumnLayoutComponent
// ] as const;

const QueryBuilderResourceStringsEN = {
  igx_query_builder_date_placeholder: 'Select date',
  igx_query_builder_time_placeholder: 'Select time',
  igx_query_builder_datetime_placeholder: 'Select date & time',
  igx_query_builder_filter_operator_and: 'And',
  igx_query_builder_filter_operator_or: 'Or',
  igx_query_builder_filter_contains: 'Contains',
  igx_query_builder_filter_doesNotContain: 'Does Not Contain',
  igx_query_builder_filter_startsWith: 'Starts With',
  igx_query_builder_filter_endsWith: 'Ends With',
  igx_query_builder_filter_equals: 'Equals',
  igx_query_builder_filter_doesNotEqual: 'Does Not Equal',
  igx_query_builder_filter_empty: 'Empty',
  igx_query_builder_filter_notEmpty: 'Not Empty',
  igx_query_builder_filter_null: 'Null',
  igx_query_builder_filter_notNull: 'Not Null',
  igx_query_builder_filter_in: 'In',
  igx_query_builder_filter_notIn: 'Not In',
  igx_query_builder_filter_before: 'Before',
  igx_query_builder_filter_after: 'After',
  igx_query_builder_filter_at: 'At',
  igx_query_builder_filter_not_at: 'Not At',
  igx_query_builder_filter_at_before: 'At or Before',
  igx_query_builder_filter_at_after: 'At or After',
  igx_query_builder_filter_today: 'Today',
  igx_query_builder_filter_yesterday: 'Yesterday',
  igx_query_builder_filter_thisMonth: 'This Month',
  igx_query_builder_filter_lastMonth: 'Last Month',
  igx_query_builder_filter_nextMonth: 'Next Month',
  igx_query_builder_filter_thisYear: 'This Year',
  igx_query_builder_filter_lastYear: 'Last Year',
  igx_query_builder_filter_nextYear: 'Next Year',
  igx_query_builder_filter_greaterThan: 'Greater Than',
  igx_query_builder_filter_lessThan: 'Less Than',
  igx_query_builder_filter_greaterThanOrEqualTo: 'Greater Than Or Equal To',
  igx_query_builder_filter_lessThanOrEqualTo: 'Less Than Or Equal To',
  igx_query_builder_filter_true: 'True',
  igx_query_builder_filter_false: 'False',
  igx_query_builder_filter_all: 'All',
  igx_query_builder_from_label: 'From',
  igx_query_builder_select_label: 'Select',
  igx_query_builder_where_label: 'Where',
  igx_query_builder_and_group: '"And" Group',
  igx_query_builder_or_group: '"Or" Group',
  igx_query_builder_end_group: 'End Group',
  igx_query_builder_and_label: 'and',
  igx_query_builder_or_label: 'or',
  igx_query_builder_switch_group: 'Switch to {0}',
  igx_query_builder_add_condition: 'Add condition',
  igx_query_builder_add_group: 'Add group',
  igx_query_builder_add_condition_root: 'Condition',
  igx_query_builder_add_group_root: 'Group',
  igx_query_builder_ungroup: 'Ungroup',
  igx_query_builder_delete: 'Delete',
  igx_query_builder_delete_filters: 'Delete filters',
  igx_query_builder_initial_text: 'Start with creating a group of conditions linked with "And" or "Or"',
  igx_query_builder_column_placeholder: 'Select column',
  igx_query_builder_condition_placeholder: 'Select filter',
  igx_query_builder_value_placeholder: 'Value',
  igx_query_builder_query_value_placeholder: 'Sub-query results',
  igx_query_builder_all_fields: 'All fields',
  igx_query_builder_details: 'Details',
  igx_query_builder_search: 'Search',
  igx_query_builder_select_all: 'Select All',
  igx_query_builder_select_entity: 'Select entity',
  igx_query_builder_select_return_field_single: 'Select return field',
  igx_query_builder_select_return_fields: 'Select return fields',
  igx_query_builder_dialog_title: 'Confirmation',
  igx_query_builder_dialog_message: 'By changing the entity, you will lose your current settings. Are you sure you want to do that?',
  igx_query_builder_dialog_checkbox_text: 'Do not show this dialog again',
  igx_query_builder_dialog_cancel: 'Cancel',
  igx_query_builder_dialog_confirm: 'Confirm',
  igx_query_builder_drop_ghost_text: 'Drop here to insert'
};
let IgxSelectItemComponent = /*#__PURE__*/(() => {
  class IgxSelectItemComponent extends IgxDropDownItemComponent {
    /**
     * Gets/Sets the item's text to be displayed in the select component's input when the item is selected.
     *
     * ```typescript
     *  //get
     *  let mySelectedItem = this.dropDown.selectedItem;
     *  let selectedItemText = mySelectedItem.text;
     * ```
     *
     * ```html
     * // set
     * <igx-select-item [text]="'London'"></igx-select-item>
     * ```
     */
    get text() {
      return this._text;
    }
    set text(text) {
      this._text = text;
    }
    /** @hidden @internal */
    get itemText() {
      if (this._text !== undefined) {
        return this._text;
      }
      // If text @Input is undefined, try extract a meaningful item text out of the item template
      return this.elementRef.nativeElement.textContent.trim();
    }
    /**
     * Sets/Gets if the item is the currently selected one in the select
     *
     * ```typescript
     *  let mySelectedItem = this.select.selectedItem;
     *  let isMyItemSelected = mySelectedItem.selected; // true
     * ```
     */
    get selected() {
      return !this.isHeader && !this.disabled && this.selection.is_item_selected(this.dropDown.id, this);
    }
    set selected(value) {
      if (value && !this.isHeader && !this.disabled) {
        this.dropDown.selectItem(this);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxSelectItemComponent_BaseFactory;
        return function IgxSelectItemComponent_Factory(__ngFactoryType__) {
          return (ɵIgxSelectItemComponent_BaseFactory || (ɵIgxSelectItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxSelectItemComponent)))(__ngFactoryType__ || IgxSelectItemComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSelectItemComponent,
        selectors: [["igx-select-item"]],
        inputs: {
          text: "text"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c75,
        decls: 5,
        vars: 0,
        consts: [[1, "igx-drop-down__content"], [1, "igx-drop-down__inner"]],
        template: function IgxSelectItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c52);
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementStart(2, "span", 1);
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4, 2);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxSelectItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let SelectPositioningStrategy = /*#__PURE__*/(() => {
  let SelectPositioningStrategy = class SelectPositioningStrategy extends BaseFitPositionStrategy {
    constructor(select, settings, platform) {
      super();
      this.select = select;
      this.platform = platform;
      this._selectDefaultSettings = {
        horizontalDirection: HorizontalAlignment.Right,
        verticalDirection: VerticalAlignment.Bottom,
        horizontalStartPoint: HorizontalAlignment.Left,
        verticalStartPoint: VerticalAlignment.Top,
        openAnimation: fadeIn,
        closeAnimation: fadeOut
      };
      // Global variables required for cases of !initialCall (page scroll/overlay repositionAll)
      this.global_yOffset = 0;
      this.global_xOffset = 0;
      this.global_styles = {};
      this.settings = Object.assign({}, this._selectDefaultSettings, settings);
    }
    /**
     * Position the element based on the PositionStrategy implementing this interface.
     *
     * @param contentElement The HTML element to be positioned
     * @param size Size of the element
     * @param document reference to the Document object
     * @param initialCall should be true if this is the initial call to the method
     * @param target attaching target for the component to show
     * ```typescript
     * settings.positionStrategy.position(content, size, document, true);
     * ```
     */
    position(contentElement, size, document, initialCall, target) {
      const targetElement = target;
      const rects = super.calculateElementRectangles(contentElement, targetElement);
      // selectFit obj, to be used for both cases of initialCall and !initialCall(page scroll/overlay repositionAll)
      const selectFit = {
        verticalOffset: this.global_yOffset,
        horizontalOffset: this.global_xOffset,
        targetRect: rects.targetRect,
        contentElementRect: rects.elementRect,
        styles: this.global_styles,
        scrollContainer: this.select.scrollContainer,
        scrollContainerRect: this.select.scrollContainer.getBoundingClientRect()
      };
      if (initialCall) {
        this.select.scrollContainer.scrollTop = 0;
        // Fill in the required selectFit object properties.
        selectFit.viewPortRect = Util.getViewportRect(document);
        selectFit.itemElement = this.getInteractionItemElement();
        selectFit.itemRect = selectFit.itemElement.getBoundingClientRect();
        // Calculate input and selected item elements style related variables
        selectFit.styles = this.calculateStyles(selectFit, targetElement);
        selectFit.scrollAmount = this.calculateScrollAmount(selectFit);
        // Calculate how much to offset the overlay container.
        this.calculateYoffset(selectFit);
        this.calculateXoffset(selectFit);
        super.updateViewPortFit(selectFit);
        // container does not fit in viewPort and is out on Top or Bottom
        if (selectFit.fitVertical.back < 0 || selectFit.fitVertical.forward < 0) {
          this.fitInViewport(contentElement, selectFit);
        }
        // Calculate scrollTop independently of the dropdown, as we cover all `igsSelect` specific positioning and
        // scrolling to selected item scenarios here.
        this.select.scrollContainer.scrollTop = selectFit.scrollAmount;
      }
      this.setStyles(contentElement, selectFit);
    }
    /**
     * Obtain the selected item if there is such one or otherwise use the first one
     */
    getInteractionItemElement() {
      let itemElement;
      if (this.select.selectedItem) {
        itemElement = this.select.selectedItem.element.nativeElement;
      } else {
        itemElement = this.select.getFirstItemElement();
      }
      return itemElement;
    }
    /**
     * Position the items outer container so selected item text is positioned over input text and if header
     * And/OR footer - both header/footer are visible
     *
     * @param selectFit selectFit to use for computation.
     */
    fitInViewport(contentElement, selectFit) {
      const footer = selectFit.scrollContainerRect.bottom - selectFit.contentElementRect.bottom;
      const header = selectFit.scrollContainerRect.top - selectFit.contentElementRect.top;
      const lastItemFitSize = selectFit.targetRect.bottom + selectFit.styles.itemTextToInputTextDiff - footer;
      const firstItemFitSize = selectFit.targetRect.top - selectFit.styles.itemTextToInputTextDiff - header;
      // out of viewPort on Top
      if (selectFit.fitVertical.back < 0) {
        const possibleScrollAmount = selectFit.scrollContainer.scrollHeight - selectFit.scrollContainerRect.height - selectFit.scrollAmount;
        if (possibleScrollAmount + selectFit.fitVertical.back > 0 && firstItemFitSize > selectFit.viewPortRect.top) {
          selectFit.scrollAmount -= selectFit.fitVertical.back;
          selectFit.verticalOffset -= selectFit.fitVertical.back;
          this.global_yOffset = selectFit.verticalOffset;
        } else {
          selectFit.verticalOffset = 0;
          this.global_yOffset = 0;
        }
        // out of viewPort on Bottom
      } else if (selectFit.fitVertical.forward < 0) {
        if (selectFit.scrollAmount + selectFit.fitVertical.forward > 0 && lastItemFitSize < selectFit.viewPortRect.bottom) {
          selectFit.scrollAmount += selectFit.fitVertical.forward;
          selectFit.verticalOffset += selectFit.fitVertical.forward;
          this.global_yOffset = selectFit.verticalOffset;
        } else {
          selectFit.verticalOffset = -selectFit.contentElementRect.height + selectFit.targetRect.height;
          this.global_yOffset = selectFit.verticalOffset;
        }
      }
    }
    /**
     * Sets element's style which effectively positions the provided element
     *
     * @param element Element to position
     * @param selectFit selectFit to use for computation.
     * @param initialCall should be true if this is the initial call to the position method calling setStyles
     */
    setStyles(contentElement, selectFit) {
      super.setStyle(contentElement, selectFit.targetRect, selectFit.contentElementRect, selectFit);
      contentElement.style.width = `${selectFit.styles.contentElementNewWidth}px`; // manage container based on paddings?
      this.global_styles.contentElementNewWidth = selectFit.styles.contentElementNewWidth;
    }
    /**
     * Calculate selected item scroll position.
     */
    calculateScrollAmount(selectFit) {
      const itemElementRect = selectFit.itemRect;
      const scrollContainer = selectFit.scrollContainer;
      const scrollContainerRect = selectFit.scrollContainerRect;
      const scrollDelta = scrollContainerRect.top - itemElementRect.top;
      let scrollPosition = scrollContainer.scrollTop - scrollDelta;
      const dropDownHeight = scrollContainer.clientHeight;
      scrollPosition -= dropDownHeight / 2;
      scrollPosition += itemElementRect.height / 2;
      return Math.round(Math.min(Math.max(0, scrollPosition), scrollContainer.scrollHeight - scrollContainerRect.height));
    }
    /**
     * Calculate the necessary input and selected item styles to be used for positioning item text over input text.
     * Calculate & Set default items container width.
     *
     * @param selectFit selectFit to use for computation.
     */
    calculateStyles(selectFit, target) {
      const styles = {};
      const inputElementStyles = window.getComputedStyle(target);
      const itemElementStyles = window.getComputedStyle(selectFit.itemElement);
      const numericInputFontSize = parseFloat(inputElementStyles.fontSize);
      const numericInputPaddingTop = parseFloat(inputElementStyles.paddingTop);
      const numericInputPaddingBottom = parseFloat(inputElementStyles.paddingBottom);
      const numericItemFontSize = parseFloat(itemElementStyles.fontSize);
      const inputTextToInputTop = (selectFit.targetRect.bottom - numericInputPaddingBottom - (selectFit.targetRect.top + numericInputPaddingTop) - numericInputFontSize) / 2;
      const itemTextToItemTop = (selectFit.itemRect.height - numericItemFontSize) / 2;
      styles.itemTextToInputTextDiff = Math.round(itemTextToItemTop - inputTextToInputTop - numericInputPaddingTop);
      const numericLeftPadding = parseFloat(itemElementStyles.paddingLeft);
      const numericTextIndent = parseFloat(itemElementStyles.textIndent);
      styles.itemTextPadding = numericLeftPadding;
      styles.itemTextIndent = numericTextIndent;
      // 24 is the input's toggle ddl icon width
      styles.contentElementNewWidth = selectFit.targetRect.width + 24 + numericLeftPadding * 2;
      return styles;
    }
    /**
     * Calculate how much to offset the overlay container for Y-axis.
     */
    calculateYoffset(selectFit) {
      selectFit.verticalOffset = -(selectFit.itemRect.top - selectFit.contentElementRect.top + selectFit.styles.itemTextToInputTextDiff - selectFit.scrollAmount);
      this.global_yOffset = selectFit.verticalOffset;
    }
    /**
     * Calculate how much to offset the overlay container for X-axis.
     */
    calculateXoffset(selectFit) {
      selectFit.horizontalOffset = selectFit.styles.itemTextIndent - selectFit.styles.itemTextPadding;
      this.global_xOffset = selectFit.horizontalOffset;
    }
  };
  SelectPositioningStrategy = __decorate([__param(2, Optional())], SelectPositioningStrategy);

  /** @hidden @internal */
  return SelectPositioningStrategy;
})();
let IgxSelectItemNavigationDirective = /*#__PURE__*/(() => {
  class IgxSelectItemNavigationDirective extends IgxDropDownItemNavigationDirective {
    get target() {
      return this._target;
    }
    set target(target) {
      this._target = target ? target : this.dropdown;
    }
    constructor() {
      super(null);
      this._target = null;
      this.inputStream = '';
      this.clearStream$ = Subscription.EMPTY;
    }
    /** Captures keydown events and calls the appropriate handlers on the target component */
    handleKeyDown(event) {
      if (!event) {
        return;
      }
      const key = event.key.toLowerCase();
      if (event.altKey && (key === 'arrowdown' || key === 'arrowup' || key === 'down' || key === 'up')) {
        this.target.toggle();
        return;
      }
      if (this.target.collapsed) {
        switch (key) {
          case 'space':
          case 'spacebar':
          case ' ':
          case 'enter':
            event.preventDefault();
            this.target.open();
            return;
          case 'arrowdown':
          case 'down':
            this.target.navigateNext();
            this.target.selectItem(this.target.focusedItem);
            event.preventDefault();
            return;
          case 'arrowup':
          case 'up':
            this.target.navigatePrev();
            this.target.selectItem(this.target.focusedItem);
            event.preventDefault();
            return;
          default:
            break;
        }
      } else if (key === 'tab' || event.shiftKey && key === 'tab') {
        this.target.close();
      }
      super.handleKeyDown(event);
      this.captureKey(event);
    }
    captureKey(event) {
      // relying only on key, available on all major browsers:
      // https://caniuse.com/#feat=keyboardevent-key (IE/Edge quirk doesn't affect letter typing)
      if (!event || !event.key || event.key.length > 1 || event.key === ' ' || event.key === 'spacebar') {
        // ignore longer keys ('Alt', 'ArrowDown', etc) AND spacebar (used of open/close)
        return;
      }
      this.clearStream$.unsubscribe();
      this.clearStream$ = timer(500).subscribe(() => {
        this.inputStream = '';
      });
      this.inputStream += event.key;
      const focusedItem = this.target.focusedItem;
      // select the item
      if (focusedItem && this.inputStream.length > 1 && focusedItem.itemText.toLowerCase().startsWith(this.inputStream.toLowerCase())) {
        return;
      }
      this.activateItemByText(this.inputStream);
    }
    activateItemByText(text) {
      const items = this.target.items;
      // ^ this is focused OR selected if the dd is closed
      let nextItem = this.findNextItem(items, text);
      // If there is no such an item starting with the current text input stream AND the last Char in the input stream
      // is the same as the first one, find next item starting with the same first Char.
      // Covers cases of holding down the same key Ex: "pppppp" that iterates trough list items starting with "p".
      if (!nextItem && text.charAt(0) === text.charAt(text.length - 1)) {
        text = text.slice(0, 1);
        nextItem = this.findNextItem(items, text);
      }
      // If there is no other item to be found, do not change the active item.
      if (!nextItem) {
        return;
      }
      if (this.target.collapsed) {
        this.target.selectItem(nextItem);
      }
      this.target.navigateItem(items.indexOf(nextItem));
    }
    ngOnDestroy() {
      this.clearStream$.unsubscribe();
    }
    findNextItem(items, text) {
      const activeItemIndex = items.indexOf(this.target.focusedItem) || 0;
      // Match next item in ddl items and wrap around if needed
      return items.slice(activeItemIndex + 1).find(x => !x.disabled && x.itemText.toLowerCase().startsWith(text.toLowerCase())) || items.slice(0, activeItemIndex).find(x => !x.disabled && x.itemText.toLowerCase().startsWith(text.toLowerCase()));
    }
    static {
      this.ɵfac = function IgxSelectItemNavigationDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectItemNavigationDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSelectItemNavigationDirective,
        selectors: [["", "igxSelectItemNavigation", ""]],
        inputs: {
          target: [0, "igxSelectItemNavigation", "target"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxSelectItemNavigationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let IgxSelectToggleIconDirective = /*#__PURE__*/(() => {
  class IgxSelectToggleIconDirective {
    static {
      this.ɵfac = function IgxSelectToggleIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectToggleIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSelectToggleIconDirective,
        selectors: [["", "igxSelectToggleIcon", ""]]
      });
    }
  }
  return IgxSelectToggleIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxSelectHeaderDirective = /*#__PURE__*/(() => {
  class IgxSelectHeaderDirective {
    static {
      this.ɵfac = function IgxSelectHeaderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectHeaderDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSelectHeaderDirective,
        selectors: [["", "igxSelectHeader", ""]]
      });
    }
  }
  return IgxSelectHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxSelectFooterDirective = /*#__PURE__*/(() => {
  class IgxSelectFooterDirective {
    static {
      this.ɵfac = function IgxSelectFooterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectFooterDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSelectFooterDirective,
        selectors: [["", "igxSelectFooter", ""]]
      });
    }
  }
  return IgxSelectFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * **Ignite UI for Angular Select** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/select)
 *
 * The `igxSelect` provides an input with dropdown list allowing selection of a single item.
 *
 * Example:
 * ```html
 * <igx-select #select1 [placeholder]="'Pick One'">
 *   <label igxLabel>Select Label</label>
 *   <igx-select-item *ngFor="let item of items" [value]="item.field">
 *     {{ item.field }}
 *   </igx-select-item>
 * </igx-select>
 * ```
 */
let IgxSelectComponent = /*#__PURE__*/(() => {
  class IgxSelectComponent extends IgxDropDownComponent {
    /**
     * Gets/Sets the component value.
     *
     * ```typescript
     * // get
     * let selectValue = this.select.value;
     * ```
     *
     * ```typescript
     * // set
     * this.select.value = 'London';
     * ```
     * ```html
     * <igx-select [value]="value"></igx-select>
     * ```
     */
    get value() {
      return this._value;
    }
    set value(v) {
      if (this._value === v) {
        return;
      }
      this._value = v;
      this.setSelection(this.items.find(x => x.value === this.value));
    }
    /**
     * Sets how the select will be styled.
     * The allowed values are `line`, `box` and `border`. The input-group default is `line`.
     * ```html
     * <igx-select [type]="'box'"></igx-select>
     * ```
     */
    get type() {
      return this._type || this._inputGroupType || 'line';
    }
    set type(val) {
      this._type = val;
    }
    /** @hidden @internal */
    get selectionValue() {
      const selectedItem = this.selectedItem;
      return selectedItem ? selectedItem.itemText : '';
    }
    /** @hidden @internal */
    get selectedItem() {
      return this.selection.first_item(this.id);
    }
    constructor(elementRef, cdr, document, selection, overlayService, _inputGroupType, _injector) {
      super(elementRef, cdr, document, selection);
      this.overlayService = overlayService;
      this._inputGroupType = _inputGroupType;
      this._injector = _injector;
      /**
       * Disables the component.
       * ```html
       * <igx-select [disabled]="'true'"></igx-select>
       * ```
       */
      this.disabled = false;
      /** @hidden @internal */
      this.maxHeight = '256px';
      /**
       * Emitted before the dropdown is opened
       *
       * ```html
       * <igx-select opening='handleOpening($event)'></igx-select>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Emitted after the dropdown is opened
       *
       * ```html
       * <igx-select (opened)='handleOpened($event)'></igx-select>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Emitted before the dropdown is closed
       *
       * ```html
       * <igx-select (closing)='handleClosing($event)'></igx-select>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Emitted after the dropdown is closed
       *
       * ```html
       * <igx-select (closed)='handleClosed($event)'></igx-select>
       * ```
       */
      this.closed = new EventEmitter();
      /**
       * The custom template, if any, that should be used when rendering the select TOGGLE(open/close) button
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.select.toggleIconTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-select #select>
       *      ...
       *      <ng-template igxSelectToggleIcon let-collapsed>
       *          <igx-icon>{{ collapsed ? 'remove_circle' : 'remove_circle_outline'}}</igx-icon>
       *      </ng-template>
       *  </igx-select>
       * ```
       */
      this.toggleIconTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the HEADER for the select items list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.select.headerTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-select #select>
       *      ...
       *      <ng-template igxSelectHeader>
       *          <div class="select__header">
       *              This is a custom header
       *          </div>
       *      </ng-template>
       *  </igx-select>
       * ```
       */
      this.headerTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering the FOOTER for the select items list
       *
       * ```typescript
       * // Set in typescript
       * const myCustomTemplate: TemplateRef<any> = myComponent.customTemplate;
       * myComponent.select.footerTemplate = myCustomTemplate;
       * ```
       * ```html
       * <!-- Set in markup -->
       *  <igx-select #select>
       *      ...
       *      <ng-template igxSelectFooter>
       *          <div class="select__footer">
       *              This is a custom footer
       *          </div>
       *      </ng-template>
       *  </igx-select>
       * ```
       */
      this.footerTemplate = null;
      /** @hidden @internal do not use the drop-down container class */
      this.cssClass = false;
      /** @hidden @internal */
      this.allowItemsFocus = false;
      this.ngControl = null;
      this._type = null;
      this._onChangeCallback = noop;
      this._onTouchedCallback = noop;
      //#region ControlValueAccessor
      /** @hidden @internal */
      this.writeValue = value => {
        this.value = value;
      };
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    //#endregion
    /** @hidden @internal */
    getEditElement() {
      return this.input.nativeElement;
    }
    /** @hidden @internal */
    selectItem(newSelection, event) {
      const oldSelection = this.selectedItem ?? {};
      if (newSelection === null || newSelection.disabled || newSelection.isHeader) {
        return;
      }
      if (newSelection === oldSelection) {
        this.toggleDirective.close();
        return;
      }
      const args = {
        oldSelection,
        newSelection,
        cancel: false,
        owner: this
      };
      this.selectionChanging.emit(args);
      if (args.cancel) {
        return;
      }
      this.setSelection(newSelection);
      this._value = newSelection.value;
      if (event) {
        this.toggleDirective.close();
      }
      this.cdr.detectChanges();
      this._onChangeCallback(this.value);
    }
    /** @hidden @internal */
    getFirstItemElement() {
      return this.children.first.element.nativeElement;
    }
    /**
     * Opens the select
     *
     * ```typescript
     * this.select.open();
     * ```
     */
    open(overlaySettings) {
      if (this.disabled || this.items.length === 0) {
        return;
      }
      if (!this.selectedItem) {
        this.navigateFirst();
      }
      super.open(Object.assign({}, this._overlayDefaults, this.overlaySettings, overlaySettings));
    }
    inputGroupClick(event, overlaySettings) {
      const targetElement = event.target;
      if (this.hintElement && targetElement.contains(this.hintElement.nativeElement)) {
        return;
      }
      this.toggle(Object.assign({}, this._overlayDefaults, this.overlaySettings, overlaySettings));
    }
    /** @hidden @internal */
    ngAfterContentInit() {
      this._overlayDefaults = {
        target: this.getEditElement(),
        modal: false,
        positionStrategy: new SelectPositioningStrategy(this),
        scrollStrategy: new AbsoluteScrollStrategy(),
        excludeFromOutsideClick: [this.inputGroup.element.nativeElement]
      };
      const changes$ = this.children.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setSelection(this.items.find(x => x.value === this.value));
        this.cdr.detectChanges();
      });
      Promise.resolve().then(() => {
        if (!changes$.closed) {
          this.children.notifyOnChanges();
        }
      });
    }
    /**
     * Event handlers
     *
     * @hidden @internal
     */
    handleOpening(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: e.cancel
      };
      this.opening.emit(args);
      e.cancel = args.cancel;
      if (args.cancel) {
        return;
      }
    }
    /** @hidden @internal */
    onToggleContentAppended(event) {
      const info = this.overlayService.getOverlayById(event.id);
      if (info?.settings?.positionStrategy instanceof SelectPositioningStrategy) {
        return;
      }
      super.onToggleContentAppended(event);
    }
    /** @hidden @internal */
    handleOpened() {
      this.updateItemFocus();
      this.opened.emit({
        owner: this
      });
    }
    /** @hidden @internal */
    handleClosing(e) {
      const args = {
        owner: this,
        event: e.event,
        cancel: e.cancel
      };
      this.closing.emit(args);
      e.cancel = args.cancel;
    }
    /** @hidden @internal */
    handleClosed() {
      this.focusItem(false);
      this.closed.emit({
        owner: this
      });
    }
    /** @hidden @internal */
    onBlur() {
      this._onTouchedCallback();
      if (this.ngControl && this.ngControl.invalid) {
        this.input.valid = IgxInputState.INVALID;
      } else {
        this.input.valid = IgxInputState.INITIAL;
      }
    }
    /** @hidden @internal */
    onFocus() {
      this._onTouchedCallback();
    }
    /**
     * @hidden @internal
     */
    ngOnInit() {
      this.ngControl = this._injector.get(NgControl, null);
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      if (this.ngControl) {
        this.ngControl.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(this.onStatusChanged.bind(this));
        this.manageRequiredAsterisk();
      }
      this.cdr.detectChanges();
    }
    /** @hidden @internal */
    ngAfterContentChecked() {
      if (this.inputGroup && this.prefixes?.length > 0) {
        this.inputGroup.prefixes = this.prefixes;
      }
      if (this.inputGroup && this.suffixes?.length > 0) {
        this.inputGroup.suffixes = this.suffixes;
      }
    }
    /** @hidden @internal */
    get toggleIcon() {
      return this.collapsed ? 'input_expand' : 'input_collapse';
    }
    /**
     * @hidden @internal
     * Prevent input blur - closing the items container on Header/Footer Template click.
     */
    mousedownHandler(event) {
      event.preventDefault();
    }
    onStatusChanged() {
      this.manageRequiredAsterisk();
      if (this.ngControl && !this.disabled && this.isTouchedOrDirty) {
        if (this.hasValidators && this.inputGroup.isFocused) {
          this.input.valid = this.ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
        } else {
          // B.P. 18 May 2021: IgxDatePicker does not reset its state upon resetForm #9526
          this.input.valid = this.ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
        }
      } else {
        this.input.valid = IgxInputState.INITIAL;
      }
    }
    get isTouchedOrDirty() {
      return this.ngControl.control.touched || this.ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this.ngControl.control.validator || !!this.ngControl.control.asyncValidator;
    }
    navigate(direction, currentIndex) {
      if (this.collapsed && this.selectedItem) {
        this.navigateItem(this.selectedItem.itemIndex);
      }
      super.navigate(direction, currentIndex);
    }
    manageRequiredAsterisk() {
      const hasRequiredHTMLAttribute = this.elementRef.nativeElement.hasAttribute('required');
      if (this.ngControl && this.ngControl.control.validator) {
        // Run the validation with empty object to check if required is enabled.
        const error = this.ngControl.control.validator({});
        this.inputGroup.isRequired = error && error.required;
        this.cdr.markForCheck();
        // If validator is dynamically cleared and no required HTML attribute is set,
        // reset label's required class(asterisk) and IgxInputState #6896
      } else if (this.inputGroup.isRequired && this.ngControl && !this.ngControl.control.validator && !hasRequiredHTMLAttribute) {
        this.input.valid = IgxInputState.INITIAL;
        this.inputGroup.isRequired = false;
        this.cdr.markForCheck();
      }
    }
    setSelection(item) {
      if (item && item.value !== undefined && item.value !== null) {
        this.selection.set(this.id, new Set([item]));
      } else {
        this.selection.clear(this.id);
      }
    }
    static {
      this.ɵfac = function IgxSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IgxSelectionAPIService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSelectComponent,
        selectors: [["igx-select"]],
        contentQueries: function IgxSelectComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxLabelDirective, 7);
            i0.ɵɵcontentQuery(dirIndex, IgxSelectToggleIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSelectHeaderDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSelectFooterDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxHintDirective, 5, ElementRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSelectItemComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPrefixDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxSuffixDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hintElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixes = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixes = _t);
          }
        },
        viewQuery: function IgxSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c55, 7, IgxInputGroupComponent);
            i0.ɵɵviewQuery(_c76, 7, IgxInputDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxSelectComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("max-height", ctx.maxHeight);
          }
        },
        inputs: {
          placeholder: "placeholder",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          overlaySettings: "overlaySettings",
          value: "value",
          type: "type"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxSelectComponent,
          multi: true
        }, {
          provide: IGX_DROPDOWN_BASE,
          useExisting: IgxSelectComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c78,
        decls: 21,
        vars: 17,
        consts: [["inputGroup", ""], ["input", ""], ["scrollContainer", ""], [1, "input-group", 3, "click", "type"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["type", "text", "igxInput", "", "readonly", "true", "role", "combobox", "aria-haspopup", "listbox", 1, "input", 3, "blur", "focus", "igxSelectItemNavigation", "disabled", "value"], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], [1, "igx-select__toggle-button"], ["family", "default", 3, "name"], ["ngProjectAs", "igx-hint, [igxHint]", 5, ["igx-hint"]], ["igxToggle", "", 1, "igx-drop-down__list", 3, "mousedown", "appended", "opening", "opened", "closing", "closed"], [1, "igx-drop-down__select-header"], ["unselectable", "on", "role", "listbox", 1, "igx-drop-down__list-scroll"], [1, "igx-drop-down__select-footer"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"]],
        template: function IgxSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c77);
            i0.ɵɵelementStart(0, "igx-input-group", 3, 0);
            i0.ɵɵlistener("click", function IgxSelectComponent_Template_igx_input_group_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputGroupClick($event));
            });
            i0.ɵɵelementContainerStart(2, 4);
            i0.ɵɵprojection(3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(4, 5);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementStart(6, "input", 6, 1);
            i0.ɵɵlistener("blur", function IgxSelectComponent_Template_input_blur_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            })("focus", function IgxSelectComponent_Template_input_focus_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(8, 7);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementStart(10, "igx-suffix", 8);
            i0.ɵɵtemplate(11, IgxSelectComponent_Conditional_11_Template, 1, 4, "ng-container")(12, IgxSelectComponent_Conditional_12_Template, 1, 2, "igx-icon", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(13, 10);
            i0.ɵɵprojection(14, 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "div", 11);
            i0.ɵɵlistener("mousedown", function IgxSelectComponent_Template_div_mousedown_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mousedownHandler($event));
            })("appended", function IgxSelectComponent_Template_div_appended_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggleContentAppended($event));
            })("opening", function IgxSelectComponent_Template_div_opening_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpening($event));
            })("opened", function IgxSelectComponent_Template_div_opened_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpened());
            })("closing", function IgxSelectComponent_Template_div_closing_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosing($event));
            })("closed", function IgxSelectComponent_Template_div_closed_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleClosed());
            });
            i0.ɵɵtemplate(16, IgxSelectComponent_Conditional_16_Template, 2, 1, "div", 12);
            i0.ɵɵelementStart(17, "div", 13, 2);
            i0.ɵɵprojection(19, 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, IgxSelectComponent_Conditional_20_Template, 2, 1, "div", 14);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type === "search" ? "line" : ctx.type);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("igxSelectItemNavigation", ctx)("disabled", ctx.disabled)("value", ctx.selectionValue);
            i0.ɵɵattribute("placeholder", ctx.placeholder)("aria-labelledby", ctx.label == null ? null : ctx.label.id)("aria-expanded", !ctx.collapsed)("aria-owns", ctx.listId)("aria-activedescendant", !ctx.collapsed ? ctx.focusedItem == null ? null : ctx.focusedItem.id : null);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.toggleIconTemplate ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggleIconTemplate ? 12 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.headerTemplate ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("max-height", ctx.maxHeight);
            i0.ɵɵattribute("id", ctx.listId)("aria-labelledby", ctx.label == null ? null : ctx.label.id);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.footerTemplate ? 20 : -1);
          }
        },
        dependencies: [IgxInputGroupComponent, IgxInputDirective, IgxSelectItemNavigationDirective, IgxSuffixDirective, NgTemplateOutlet, IgxIconComponent, IgxToggleDirective],
        styles: ["[_nghost-%COMP%]{display:block}"]
      });
    }
  }
  return IgxSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
const IGX_TIME_PICKER_COMPONENT = 'IgxTimePickerComponentToken';

/**
 * This file contains all the directives used by the @link IgxTimePickerComponent.
 * You should generally not use them directly.
 *
 * @preferred
 */
/** @hidden */
let IgxItemListDirective = /*#__PURE__*/(() => {
  class IgxItemListDirective {
    constructor(timePicker, elementRef, touchManager) {
      this.timePicker = timePicker;
      this.elementRef = elementRef;
      this.touchManager = touchManager;
      this.tabindex = 0;
      this.onPanMove = event => {
        const delta = event.deltaY < 0 ? -1 : event.deltaY > 0 ? 1 : 0;
        if (delta !== 0) {
          this.nextItem(delta);
        }
      };
    }
    get defaultCSS() {
      return true;
    }
    get hourCSS() {
      return this.type === 'hourList';
    }
    get minuteCSS() {
      return this.type === 'minuteList';
    }
    get secondsCSS() {
      return this.type === 'secondsList';
    }
    get ampmCSS() {
      return this.type === 'ampmList';
    }
    onFocus() {
      this.isActive = true;
    }
    onBlur() {
      this.isActive = false;
    }
    /**
     * @hidden
     */
    onKeydownArrowDown(event) {
      event.preventDefault();
      this.nextItem(1);
    }
    /**
     * @hidden
     */
    onKeydownArrowUp(event) {
      event.preventDefault();
      this.nextItem(-1);
    }
    /**
     * @hidden
     */
    onKeydownArrowRight(event) {
      event.preventDefault();
      const listName = event.target.className;
      if (listName.indexOf('hourList') !== -1 && this.timePicker.minuteList) {
        this.timePicker.minuteList.nativeElement.focus();
      } else if ((listName.indexOf('hourList') !== -1 || listName.indexOf('minuteList') !== -1) && this.timePicker.secondsList) {
        this.timePicker.secondsList.nativeElement.focus();
      } else if ((listName.indexOf('hourList') !== -1 || listName.indexOf('minuteList') !== -1 || listName.indexOf('secondsList') !== -1) && this.timePicker.ampmList) {
        this.timePicker.ampmList.nativeElement.focus();
      }
    }
    /**
     * @hidden
     */
    onKeydownArrowLeft(event) {
      event.preventDefault();
      const listName = event.target.className;
      if (listName.indexOf('ampmList') !== -1 && this.timePicker.secondsList) {
        this.timePicker.secondsList.nativeElement.focus();
      } else if (listName.indexOf('secondsList') !== -1 && this.timePicker.secondsList && listName.indexOf('minutesList') && this.timePicker.minuteList) {
        this.timePicker.minuteList.nativeElement.focus();
      } else if (listName.indexOf('ampmList') !== -1 && this.timePicker.minuteList) {
        this.timePicker.minuteList.nativeElement.focus();
      } else if ((listName.indexOf('ampmList') !== -1 || listName.indexOf('secondsList') !== -1 || listName.indexOf('minuteList') !== -1) && this.timePicker.hourList) {
        this.timePicker.hourList.nativeElement.focus();
      }
    }
    /**
     * @hidden
     */
    onKeydownEnter(event) {
      event.preventDefault();
      this.timePicker.okButtonClick();
    }
    /**
     * @hidden
     */
    onKeydownEscape(event) {
      event.preventDefault();
      this.timePicker.cancelButtonClick();
    }
    /**
     * @hidden
     */
    onHover() {
      this.elementRef.nativeElement.focus();
    }
    /**
     * @hidden
     */
    onScroll(event) {
      event.preventDefault();
      event.stopPropagation();
      const delta = event.deltaY;
      if (delta !== 0) {
        this.nextItem(delta);
      }
    }
    /**
     * @hidden @internal
     */
    ngOnInit() {
      const hammerOptions = {
        recognizers: [[HammerGesturesManager.Hammer?.Pan, {
          direction: HammerGesturesManager.Hammer?.DIRECTION_VERTICAL,
          threshold: 10
        }]]
      };
      this.touchManager.addEventListener(this.elementRef.nativeElement, 'pan', this.onPanMove, hammerOptions);
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.touchManager.destroy();
    }
    nextItem(delta) {
      switch (this.type) {
        case 'hourList':
          {
            this.timePicker.nextHour(delta);
            break;
          }
        case 'minuteList':
          {
            this.timePicker.nextMinute(delta);
            break;
          }
        case 'secondsList':
          {
            this.timePicker.nextSeconds(delta);
            break;
          }
        case 'ampmList':
          {
            this.timePicker.nextAmPm(delta);
            break;
          }
      }
    }
    static {
      this.ɵfac = function IgxItemListDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxItemListDirective)(i0.ɵɵdirectiveInject(IGX_TIME_PICKER_COMPONENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(HammerGesturesManager));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxItemListDirective,
        selectors: [["", "igxItemList", ""]],
        hostVars: 11,
        hostBindings: function IgxItemListDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function IgxItemListDirective_focus_HostBindingHandler() {
              return ctx.onFocus();
            })("blur", function IgxItemListDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("keydown.arrowdown", function IgxItemListDirective_keydown_arrowdown_HostBindingHandler($event) {
              return ctx.onKeydownArrowDown($event);
            })("keydown.arrowup", function IgxItemListDirective_keydown_arrowup_HostBindingHandler($event) {
              return ctx.onKeydownArrowUp($event);
            })("keydown.arrowright", function IgxItemListDirective_keydown_arrowright_HostBindingHandler($event) {
              return ctx.onKeydownArrowRight($event);
            })("keydown.arrowleft", function IgxItemListDirective_keydown_arrowleft_HostBindingHandler($event) {
              return ctx.onKeydownArrowLeft($event);
            })("keydown.enter", function IgxItemListDirective_keydown_enter_HostBindingHandler($event) {
              return ctx.onKeydownEnter($event);
            })("keydown.escape", function IgxItemListDirective_keydown_escape_HostBindingHandler($event) {
              return ctx.onKeydownEscape($event);
            })("mouseover", function IgxItemListDirective_mouseover_HostBindingHandler() {
              return ctx.onHover();
            })("wheel", function IgxItemListDirective_wheel_HostBindingHandler($event) {
              return ctx.onScroll($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabindex);
            i0.ɵɵclassProp("igx-time-picker__column", ctx.defaultCSS)("igx-time-picker__hourList", ctx.hourCSS)("igx-time-picker__minuteList", ctx.minuteCSS)("igx-time-picker__secondsList", ctx.secondsCSS)("igx-time-picker__ampmList", ctx.ampmCSS);
          }
        },
        inputs: {
          type: [0, "igxItemList", "type"]
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager])]
      });
    }
  }
  return IgxItemListDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxTimeItemDirective = /*#__PURE__*/(() => {
  class IgxTimeItemDirective {
    get defaultCSS() {
      return true;
    }
    get selectedCSS() {
      return this.isSelectedTime;
    }
    get activeCSS() {
      return this.isSelectedTime && this.itemList.isActive;
    }
    get isSelectedTime() {
      const currentValue = this.value.length < 2 ? `0${this.value}` : this.value;
      const dateType = this.itemList.type;
      const inputDateParts = DateTimeUtil.parseDateTimeFormat(this.timePicker.appliedFormat);
      switch (dateType) {
        case 'hourList':
          const hourPart = inputDateParts.find(element => element.type === 'hours');
          return DateTimeUtil.getPartValue(this.timePicker.selectedDate, hourPart, hourPart.format.length) === currentValue;
        case 'minuteList':
          const minutePart = inputDateParts.find(element => element.type === 'minutes');
          return DateTimeUtil.getPartValue(this.timePicker.selectedDate, minutePart, minutePart.format.length) === currentValue;
        case 'secondsList':
          const secondsPart = inputDateParts.find(element => element.type === 'seconds');
          return DateTimeUtil.getPartValue(this.timePicker.selectedDate, secondsPart, secondsPart.format.length) === currentValue;
        case 'ampmList':
          const ampmPart = inputDateParts.find(element => element.format.indexOf('a') !== -1 || element.format === 'tt');
          return DateTimeUtil.getPartValue(this.timePicker.selectedDate, ampmPart, ampmPart.format.length) === this.value;
      }
    }
    get minValue() {
      const dateType = this.itemList.type;
      const inputDateParts = DateTimeUtil.parseDateTimeFormat(this.timePicker.appliedFormat);
      switch (dateType) {
        case 'hourList':
          return this.getHourPart(this.timePicker.minDropdownValue);
        case 'minuteList':
          if (this.timePicker.selectedDate.getHours() === this.timePicker.minDropdownValue.getHours()) {
            const minutePart = inputDateParts.find(element => element.type === 'minutes');
            return DateTimeUtil.getPartValue(this.timePicker.minDropdownValue, minutePart, minutePart.format.length);
          }
          return '00';
        case 'secondsList':
          const date = new Date(this.timePicker.selectedDate);
          const min = new Date(this.timePicker.minDropdownValue);
          date.setSeconds(0);
          min.setSeconds(0);
          if (date.getTime() === min.getTime()) {
            const secondsPart = inputDateParts.find(element => element.type === 'seconds');
            return DateTimeUtil.getPartValue(this.timePicker.minDropdownValue, secondsPart, secondsPart.format.length);
          }
          return '00';
        case 'ampmList':
          const ampmPart = inputDateParts.find(element => element.format.indexOf('a') !== -1 || element.format === 'tt');
          return DateTimeUtil.getPartValue(this.timePicker.minDropdownValue, ampmPart, ampmPart.format.length);
      }
    }
    get maxValue() {
      const dateType = this.itemList.type;
      const inputDateParts = DateTimeUtil.parseDateTimeFormat(this.timePicker.appliedFormat);
      switch (dateType) {
        case 'hourList':
          return this.getHourPart(this.timePicker.maxDropdownValue);
        case 'minuteList':
          if (this.timePicker.selectedDate.getHours() === this.timePicker.maxDropdownValue.getHours()) {
            const minutePart = inputDateParts.find(element => element.type === 'minutes');
            return DateTimeUtil.getPartValue(this.timePicker.maxDropdownValue, minutePart, minutePart.format.length);
          } else {
            const currentTime = new Date(this.timePicker.selectedDate);
            const minDelta = this.timePicker.itemsDelta.minutes;
            const remainder = 60 % minDelta;
            const delta = remainder === 0 ? 60 - minDelta : 60 - remainder;
            currentTime.setMinutes(delta);
            const minutePart = inputDateParts.find(element => element.type === 'minutes');
            return DateTimeUtil.getPartValue(currentTime, minutePart, minutePart.format.length);
          }
        case 'secondsList':
          const date = new Date(this.timePicker.selectedDate);
          const max = new Date(this.timePicker.maxDropdownValue);
          date.setSeconds(0);
          max.setSeconds(0);
          if (date.getTime() === max.getTime()) {
            const secondsPart = inputDateParts.find(element => element.type === 'seconds');
            return DateTimeUtil.getPartValue(this.timePicker.maxDropdownValue, secondsPart, secondsPart.format.length);
          } else {
            const secDelta = this.timePicker.itemsDelta.seconds;
            const remainder = 60 % secDelta;
            const delta = remainder === 0 ? 60 - secDelta : 60 - remainder;
            date.setSeconds(delta);
            const secondsPart = inputDateParts.find(element => element.type === 'seconds');
            return DateTimeUtil.getPartValue(date, secondsPart, secondsPart.format.length);
          }
        case 'ampmList':
          const ampmPart = inputDateParts.find(element => element.format.indexOf('a') !== -1 || element.format === 'tt');
          return DateTimeUtil.getPartValue(this.timePicker.maxDropdownValue, ampmPart, ampmPart.format.length);
      }
    }
    get hourValue() {
      return this.getHourPart(this.timePicker.selectedDate);
    }
    constructor(timePicker, itemList) {
      this.timePicker = timePicker;
      this.itemList = itemList;
    }
    onClick(item) {
      if (item !== '') {
        const dateType = this.itemList.type;
        this.timePicker.onItemClick(item, dateType);
      }
    }
    getHourPart(date) {
      const inputDateParts = DateTimeUtil.parseDateTimeFormat(this.timePicker.appliedFormat);
      const hourPart = inputDateParts.find(element => element.type === 'hours');
      const ampmPart = inputDateParts.find(element => element.format.indexOf('a') !== -1 || element.format === 'tt');
      const hour = DateTimeUtil.getPartValue(date, hourPart, hourPart.format.length);
      if (ampmPart) {
        const ampm = DateTimeUtil.getPartValue(date, ampmPart, ampmPart.format.length);
        return `${hour} ${ampm}`;
      }
      return hour;
    }
    static {
      this.ɵfac = function IgxTimeItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTimeItemDirective)(i0.ɵɵdirectiveInject(IGX_TIME_PICKER_COMPONENT), i0.ɵɵdirectiveInject(IgxItemListDirective));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTimeItemDirective,
        selectors: [["", "igxTimeItem", ""]],
        hostVars: 6,
        hostBindings: function IgxTimeItemDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxTimeItemDirective_click_HostBindingHandler() {
              return ctx.onClick(ctx.value);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-time-picker__item", ctx.defaultCSS)("igx-time-picker__item--selected", ctx.selectedCSS)("igx-time-picker__item--active", ctx.activeCSS);
          }
        },
        inputs: {
          value: [0, "igxTimeItem", "value"]
        },
        exportAs: ["timeItem"]
      });
    }
  }
  return IgxTimeItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TimePickerResourceStringsEN = {
  igx_time_picker_ok: 'OK',
  igx_time_picker_cancel: 'Cancel',
  igx_time_picker_change_time: 'Change Time',
  igx_time_picker_choose_time: 'Choose Time'
};
const ITEMS_COUNT = 7;
let TimeFormatPipe = /*#__PURE__*/(() => {
  class TimeFormatPipe {
    constructor(timePicker) {
      this.timePicker = timePicker;
    }
    transform(value) {
      const format = this.timePicker.appliedFormat.replace('tt', 'aa');
      const datePipe = new DatePipe(this.timePicker.locale);
      return datePipe.transform(value, format);
    }
    static {
      this.ɵfac = function TimeFormatPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TimeFormatPipe)(i0.ɵɵdirectiveInject(IGX_TIME_PICKER_COMPONENT, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "timeFormatPipe",
        type: TimeFormatPipe,
        pure: true
      });
    }
  }
  return TimeFormatPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TimeItemPipe = /*#__PURE__*/(() => {
  class TimeItemPipe {
    constructor(timePicker) {
      this.timePicker = timePicker;
    }
    transform(_collection, timePart, selectedDate, min, max) {
      let list;
      let part;
      switch (timePart) {
        case 'hour':
          list = this.generateHours(min, max);
          const hours = this.timePicker.isTwelveHourFormat ? this.toTwelveHourFormat(selectedDate.getHours()) : selectedDate.getHours();
          list = this.scrollListItem(hours, list);
          part = DatePart.Hours;
          break;
        case 'minutes':
          list = this.generateMinutes(selectedDate, min, max);
          list = this.scrollListItem(selectedDate.getMinutes(), list);
          part = DatePart.Minutes;
          break;
        case 'seconds':
          list = this.generateSeconds(selectedDate, min, max);
          list = this.scrollListItem(selectedDate.getSeconds(), list);
          part = DatePart.Seconds;
          break;
        case 'ampm':
          const selectedAmPm = this.timePicker.getPartValue(selectedDate, 'ampm');
          list = this.generateAmPm(min, max, selectedAmPm);
          list = this.scrollListItem(selectedAmPm, list);
          part = DatePart.AmPm;
          break;
      }
      return this.getListView(list, part);
    }
    getListView(view, dateType) {
      for (let i = 0; i < view.length; i++) {
        view[i] = this.getItemView(view[i], dateType);
      }
      return view;
    }
    getItemView(item, dateType) {
      if (item === null) {
        item = '';
      } else if (dateType && typeof item !== 'string') {
        const leadZeroHour = item < 10 && (this.timePicker.appliedFormat?.indexOf('hh') !== -1 || this.timePicker.appliedFormat?.indexOf('HH') !== -1);
        const leadZeroMinute = item < 10 && this.timePicker.appliedFormat?.indexOf('mm') !== -1;
        const leadZeroSeconds = item < 10 && this.timePicker.appliedFormat?.indexOf('ss') !== -1;
        const leadZero = {
          hours: leadZeroHour,
          minutes: leadZeroMinute,
          seconds: leadZeroSeconds
        }[dateType];
        item = leadZero ? '0' + item : `${item}`;
      }
      return item;
    }
    scrollListItem(item, items) {
      const itemsCount = items.length;
      let view;
      if (items) {
        const index = items.indexOf(item);
        if (index < 3) {
          view = items.slice(itemsCount - (3 - index), itemsCount);
          view = view.concat(items.slice(0, index + 4));
        } else if (index + 4 > itemsCount) {
          view = items.slice(index - 3, itemsCount);
          view = view.concat(items.slice(0, index + 4 - itemsCount));
        } else {
          view = items.slice(index - 3, index + 4);
        }
      }
      return view;
    }
    generateHours(min, max) {
      const hourItems = [];
      let hoursCount = this.timePicker.isTwelveHourFormat ? 13 : 24;
      hoursCount /= this.timePicker.itemsDelta.hours;
      const minHours = min.getHours();
      const maxHours = max.getHours();
      if (hoursCount > 1) {
        for (let hourIndex = 0; hourIndex < 24; hourIndex++) {
          let hours = hourIndex * this.timePicker.itemsDelta.hours;
          if (hours >= minHours && hours <= maxHours) {
            hours = this.timePicker.isTwelveHourFormat ? this.toTwelveHourFormat(hours) : hours;
            if (!hourItems.find(element => element === hours)) {
              hourItems.push(hours);
            }
          }
        }
      } else {
        hourItems.push(0);
      }
      if (hourItems.length < ITEMS_COUNT || hoursCount < ITEMS_COUNT || !this.timePicker.spinLoop) {
        const index = !this.timePicker.spinLoop || hourItems.length < ITEMS_COUNT && hoursCount < ITEMS_COUNT ? 6 : 3;
        for (let i = 0; i < index; i++) {
          hourItems.push(null);
        }
      }
      return hourItems;
    }
    generateMinutes(time, min, max) {
      const minuteItems = [];
      const minuteItemsCount = 60 / this.timePicker.itemsDelta.minutes;
      time = new Date(time);
      for (let i = 0; i < minuteItemsCount; i++) {
        const minutes = i * this.timePicker.itemsDelta.minutes;
        time.setMinutes(minutes);
        if (time >= min && time <= max) {
          minuteItems.push(i * this.timePicker.itemsDelta.minutes);
        }
      }
      if (minuteItems.length < ITEMS_COUNT || minuteItemsCount < ITEMS_COUNT || !this.timePicker.spinLoop) {
        const index = !this.timePicker.spinLoop || minuteItems.length < ITEMS_COUNT && minuteItemsCount < ITEMS_COUNT ? 6 : 3;
        for (let i = 0; i < index; i++) {
          minuteItems.push(null);
        }
      }
      return minuteItems;
    }
    generateSeconds(time, min, max) {
      const secondsItems = [];
      const secondsItemsCount = 60 / this.timePicker.itemsDelta.seconds;
      time = new Date(time);
      for (let i = 0; i < secondsItemsCount; i++) {
        const seconds = i * this.timePicker.itemsDelta.seconds;
        time.setSeconds(seconds);
        if (time.getTime() >= min.getTime() && time.getTime() <= max.getTime()) {
          secondsItems.push(i * this.timePicker.itemsDelta.seconds);
        }
      }
      if (secondsItems.length < ITEMS_COUNT || secondsItemsCount < ITEMS_COUNT || !this.timePicker.spinLoop) {
        const index = !this.timePicker.spinLoop || secondsItems.length < ITEMS_COUNT && secondsItemsCount < ITEMS_COUNT ? 6 : 3;
        for (let i = 0; i < index; i++) {
          secondsItems.push(null);
        }
      }
      return secondsItems;
    }
    generateAmPm(min, max, selectedAmPm) {
      const ampmItems = [];
      const minHour = min.getHours();
      const maxHour = max.getHours();
      if (minHour < 12) {
        ampmItems.push(DateTimeUtil.getAmPmValue(selectedAmPm.length, true));
      }
      if (minHour >= 12 || maxHour >= 12) {
        ampmItems.push(DateTimeUtil.getAmPmValue(selectedAmPm.length, false));
      }
      for (let i = 0; i < 5; i++) {
        ampmItems.push(null);
      }
      return ampmItems;
    }
    toTwelveHourFormat(hour) {
      if (hour > 12) {
        hour -= 12;
      } else if (hour === 0) {
        hour = 12;
      }
      return hour;
    }
    static {
      this.ɵfac = function TimeItemPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TimeItemPipe)(i0.ɵɵdirectiveInject(IGX_TIME_PICKER_COMPONENT, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "timeItemPipe",
        type: TimeItemPipe,
        pure: true
      });
    }
  }
  return TimeItemPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$c = 0;
let IgxTimePickerComponent = /*#__PURE__*/(() => {
  class IgxTimePickerComponent extends PickerBaseDirective {
    /**
     * The minimum value the picker will accept.
     *
     * @remarks
     * If a `string` value is passed in, it must be in ISO format.
     *
     * @example
     * ```html
     * <igx-time-picker [minValue]="18:00:00"></igx-time-picker>
     * ```
     */
    set minValue(value) {
      this._minValue = value;
      const date = this.parseToDate(value);
      if (date) {
        this._dateMinValue = new Date();
        this._dateMinValue.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        this.minDropdownValue = this.setMinMaxDropdownValue('min', this._dateMinValue);
      }
      this.setSelectedValue(this._selectedDate);
      this._onValidatorChange();
    }
    get minValue() {
      return this._minValue;
    }
    /**
     * Gets if the dropdown/dialog is collapsed
     *
     * ```typescript
     * let isCollapsed = this.timePicker.collapsed;
     * ```
     */
    get collapsed() {
      return this.toggleRef?.collapsed;
    }
    /**
     * The maximum value the picker will accept.
     *
     * @remarks
     * If a `string` value is passed in, it must be in ISO format.
     *
     * @example
     * ```html
     * <igx-time-picker [maxValue]="20:30:00"></igx-time-picker>
     * ```
     */
    set maxValue(value) {
      this._maxValue = value;
      const date = this.parseToDate(value);
      if (date) {
        this._dateMaxValue = new Date();
        this._dateMaxValue.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        this.maxDropdownValue = this.setMinMaxDropdownValue('max', this._dateMaxValue);
      }
      this.setSelectedValue(this._selectedDate);
      this._onValidatorChange();
    }
    get maxValue() {
      return this._maxValue;
    }
    /** @hidden */
    get showClearButton() {
      if (this.clearComponents.length) {
        return false;
      }
      if (DateTimeUtil.isValidDate(this.value)) {
        // TODO: Update w/ clear behavior
        return this.value.getHours() !== 0 || this.value.getMinutes() !== 0 || this.value.getSeconds() !== 0 || this.value.getMilliseconds() !== 0;
      }
      return !!this.dateTimeEditor.value;
    }
    /** @hidden */
    get showHoursList() {
      return this.appliedFormat?.indexOf('h') !== -1 || this.appliedFormat?.indexOf('H') !== -1;
    }
    /** @hidden */
    get showMinutesList() {
      return this.appliedFormat?.indexOf('m') !== -1;
    }
    /** @hidden */
    get showSecondsList() {
      return this.appliedFormat?.indexOf('s') !== -1;
    }
    /** @hidden */
    get showAmPmList() {
      return this.appliedFormat?.indexOf('t') !== -1 || this.appliedFormat?.indexOf('a') !== -1;
    }
    /** @hidden */
    get isTwelveHourFormat() {
      return this.appliedFormat?.indexOf('h') !== -1;
    }
    /** @hidden @internal */
    get isVertical() {
      return this.headerOrientation === PickerHeaderOrientation.Vertical;
    }
    /** @hidden @internal */
    get selectedDate() {
      return this._selectedDate;
    }
    /** @hidden @internal */
    get minDateValue() {
      if (!this._dateMinValue) {
        const minDate = new Date();
        minDate.setHours(0, 0, 0, 0);
        return minDate;
      }
      return this._dateMinValue;
    }
    /** @hidden @internal */
    get maxDateValue() {
      if (!this._dateMaxValue) {
        const maxDate = new Date();
        maxDate.setHours(23, 59, 59, 999);
        return maxDate;
      }
      return this._dateMaxValue;
    }
    /** @hidden @internal */
    get appliedFormat() {
      return this.inputFormat || this.dateTimeEditor?.inputFormat;
    }
    get toggleContainer() {
      return this.toggleRef?.element;
    }
    get required() {
      if (this._ngControl && this._ngControl.control && this._ngControl.control.validator) {
        // Run the validation with empty object to check if required is enabled.
        const error = this._ngControl.control.validator({});
        return !!(error && error.required);
      }
      return false;
    }
    get dialogOverlaySettings() {
      return Object.assign({}, this._defaultDialogOverlaySettings, this.overlaySettings);
    }
    get dropDownOverlaySettings() {
      return Object.assign({}, this._defaultDropDownOverlaySettings, this.overlaySettings);
    }
    /**
     * The currently selected value / time from the drop-down/dialog
     *
     * @remarks
     * The current value is of type `Date`
     *
     * @example
     * ```typescript
     * const newValue: Date = new Date(2000, 2, 2, 10, 15, 15);
     * this.timePicker.value = newValue;
     * ```
     */
    get value() {
      return this._value;
    }
    /**
     * An accessor that allows you to set a time using the `value` input.
     * ```html
     * public date: Date = new Date(Date.now());
     *  //...
     * <igx-time-picker [value]="date" format="h:mm tt"></igx-time-picker>
     * ```
     */
    set value(value) {
      const oldValue = this._value;
      this._value = value;
      const date = this.parseToDate(value);
      if (date) {
        this._dateValue = new Date();
        this._dateValue.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        this.setSelectedValue(this._dateValue);
      } else {
        this._dateValue = null;
        this.setSelectedValue(null);
      }
      if (this.dateTimeEditor) {
        this.dateTimeEditor.value = date;
      }
      this.emitValueChange(oldValue, this._value);
      this._onChangeCallback(this._value);
    }
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Overrides the default text of the **OK** button.
     *
     * @remarks
     * Defaults to the value from resource strings, `"OK"` for the built-in EN.
     *
     * ```html
     * <igx-time-picker okButtonLabel='SET' [value]="date" format="h:mm tt"></igx-time-picker>
     * ```
     */
    set okButtonLabel(value) {
      this._okButtonLabel = value;
    }
    /**
     * An accessor that returns the label of ok button.
     */
    get okButtonLabel() {
      if (this._okButtonLabel === null) {
        return this.resourceStrings.igx_time_picker_ok;
      }
      return this._okButtonLabel;
    }
    /**
     * Overrides the default text of the **Cancel** button.
     * @remarks
     * Defaults to the value from resource strings, `"Cancel"` for the built-in EN.
     * ```html
     * <igx-time-picker cancelButtonLabel='Exit' [value]="date" format="h:mm tt"></igx-time-picker>
     * ```
     */
    set cancelButtonLabel(value) {
      this._cancelButtonLabel = value;
    }
    /**
     * An accessor that returns the label of cancel button.
     */
    get cancelButtonLabel() {
      if (this._cancelButtonLabel === null) {
        return this.resourceStrings.igx_time_picker_cancel;
      }
      return this._cancelButtonLabel;
    }
    /**
     * Delta values used to increment or decrement each editor date part on spin actions and
     * to display time portions in the dropdown/dialog.
     * By default `itemsDelta` is set to `{hour: 1, minute: 1, second: 1}`
     * ```html
     * <igx-time-picker [itemsDelta]="{hour:3, minute:5, second:10}" id="time-picker"></igx-time-picker>
     * ```
     */
    set itemsDelta(value) {
      Object.assign(this._itemsDelta, value);
    }
    get itemsDelta() {
      return this._itemsDelta;
    }
    constructor(element, _localeId, _inputGroupType, _injector, platform, cdr) {
      super(element, _localeId, _inputGroupType);
      this._injector = _injector;
      this.platform = platform;
      this.cdr = cdr;
      /**
       * Sets the value of the `id` attribute.
       * ```html
       * <igx-time-picker [id]="'igx-time-picker-5'" [displayFormat]="h:mm tt" ></igx-time-picker>
       * ```
       */
      this.id = `igx-time-picker-${NEXT_ID$c++}`;
      /**
       * Gets/Sets the interaction mode - dialog or drop down.
       *
       * @example
       * ```html
       * <igx-time-picker mode="dialog"></igx-time-picker>
       * ```
       */
      this.mode = PickerInteractionMode.DropDown;
      /**
       * Sets whether the seconds, minutes and hour spinning will loop back around when end value is reached.
       * By default it's set to true.
       * ```html
       * <igx-time-picker [spinLoop]="false"></igx-time-picker>
       * ```
       */
      this.spinLoop = true;
      /**
       * Sets the orientation of the picker's header.
       *
       * @remarks
       * Available in dialog mode only. Default value is `horizontal`.
       *
       * ```html
       * <igx-time-picker [headerOrientation]="'vertical'"></igx-time-picker>
       * ```
       */
      this.headerOrientation = PickerHeaderOrientation.Horizontal;
      /** @hidden @internal */
      this.readOnly = false;
      /**
       * Emitted after a selection has been done.
       *
       * @example
       * ```html
       * <igx-time-picker (selected)="onSelection($event)"></igx-time-picker>
       * ```
       */
      this.selected = new EventEmitter();
      /**
       * Emitted when the picker's value changes.
       *
       * @remarks
       * Used for `two-way` bindings.
       *
       * @example
       * ```html
       * <igx-time-picker [(value)]="date"></igx-time-picker>
       * ```
       */
      this.valueChange = new EventEmitter();
      /**
       * Emitted when the user types/spins invalid time in the time-picker editor.
       *
       *  @example
       * ```html
       * <igx-time-picker (validationFailed)="onValidationFailed($event)"></igx-time-picker>
       * ```
       */
      this.validationFailed = new EventEmitter();
      /** @hidden */
      this.cleared = false;
      /** @hidden */
      this.isNotEmpty = false;
      /** @hidden @internal */
      this.displayValue = {
        transform: date => this.formatter(date)
      };
      /** @hidden @internal */
      this.hourItems = [];
      /** @hidden @internal */
      this.minuteItems = [];
      /** @hidden @internal */
      this.secondsItems = [];
      /** @hidden @internal */
      this.ampmItems = [];
      this._resourceStrings = getCurrentResourceStrings(TimePickerResourceStringsEN);
      this._okButtonLabel = null;
      this._cancelButtonLabel = null;
      this._itemsDelta = {
        hours: 1,
        minutes: 1,
        seconds: 1,
        fractionalSeconds: 1
      };
      this._ngControl = null;
      this._onChangeCallback = noop;
      this._onTouchedCallback = noop;
      this._onValidatorChange = noop;
      this._defaultDialogOverlaySettings = {
        closeOnOutsideClick: true,
        modal: true,
        closeOnEscape: true,
        outlet: this.outlet
      };
      this._defaultDropDownOverlaySettings = {
        target: this.element.nativeElement,
        modal: false,
        closeOnOutsideClick: true,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new AutoPositionStrategy(),
        outlet: this.outlet
      };
      this.locale = this.locale || this._localeId;
    }
    /** @hidden @internal */
    onKeyDown(event) {
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_UP:
          if (event.altKey && this.isDropdown) {
            this.close();
          }
          break;
        case this.platform.KEYMAP.ARROW_DOWN:
          if (event.altKey && this.isDropdown) {
            this.open();
          }
          break;
        case this.platform.KEYMAP.ESCAPE:
          this.cancelButtonClick();
          break;
        case this.platform.KEYMAP.SPACE:
          this.open();
          event.preventDefault();
          break;
      }
    }
    /** @hidden @internal */
    getPartValue(value, type) {
      const inputDateParts = DateTimeUtil.parseDateTimeFormat(this.appliedFormat);
      const part = inputDateParts.find(element => element.type === type);
      return DateTimeUtil.getPartValue(value, part, part.format?.length);
    }
    /** @hidden @internal */
    toISOString(value) {
      return value.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3
      });
    }
    // #region ControlValueAccessor
    /** @hidden @internal */
    writeValue(value) {
      this._value = value;
      const date = this.parseToDate(value);
      if (date) {
        this._dateValue = new Date();
        this._dateValue.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        this.setSelectedValue(this._dateValue);
      } else {
        this.setSelectedValue(null);
      }
      if (this.dateTimeEditor) {
        this.dateTimeEditor.value = date;
      }
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden @internal */
    registerOnValidatorChange(fn) {
      this._onValidatorChange = fn;
    }
    /** @hidden @internal */
    validate(control) {
      if (!control.value) {
        return null;
      }
      // InvalidDate handling
      if (isDate(control.value) && !DateTimeUtil.isValidDate(control.value)) {
        return {
          value: true
        };
      }
      const errors = {};
      const value = DateTimeUtil.isValidDate(control.value) ? control.value : DateTimeUtil.parseIsoDate(control.value);
      Object.assign(errors, DateTimeUtil.validateMinMax(value, this.minValue, this.maxValue, true, false));
      return Object.keys(errors).length > 0 ? errors : null;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    //#endregion
    /** @hidden */
    ngOnInit() {
      this._ngControl = this._injector.get(NgControl, null);
      this.minDropdownValue = this.setMinMaxDropdownValue('min', this.minDateValue);
      this.maxDropdownValue = this.setMinMaxDropdownValue('max', this.maxDateValue);
      this.setSelectedValue(this._dateValue);
    }
    /** @hidden */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.subscribeToDateEditorEvents();
      this.subscribeToToggleDirectiveEvents();
      this._defaultDropDownOverlaySettings.excludeFromOutsideClick = [this._inputGroup.element.nativeElement];
      fromEvent(this.inputDirective.nativeElement, 'blur').pipe(takeUntil(this._destroy$)).subscribe(() => {
        if (this.collapsed) {
          this.updateValidityOnBlur();
        }
      });
      this.subToIconsClicked(this.clearComponents, () => this.clear());
      this.clearComponents.changes.pipe(takeUntil(this._destroy$)).subscribe(() => this.subToIconsClicked(this.clearComponents, () => this.clear()));
      if (this._ngControl) {
        this._statusChanges$ = this._ngControl.statusChanges.subscribe(this.onStatusChanged.bind(this));
        this._inputGroup.isRequired = this.required;
        this.cdr.detectChanges();
      }
    }
    /** @hidden */
    ngOnDestroy() {
      super.ngOnDestroy();
      if (this._statusChanges$) {
        this._statusChanges$.unsubscribe();
      }
    }
    /** @hidden */
    getEditElement() {
      return this.dateTimeEditor.nativeElement;
    }
    /**
     * Opens the picker's dialog UI.
     *
     * @param settings OverlaySettings - the overlay settings to use for positioning the drop down or dialog container according to
     * ```html
     * <igx-time-picker #picker [value]="date"></igx-time-picker>
     * <button type="button" igxButton (click)="picker.open()">Open Dialog</button>
     * ```
     */
    open(settings) {
      if (this.disabled || !this.toggleRef.collapsed) {
        return;
      }
      this.setSelectedValue(this._dateValue);
      const overlaySettings = Object.assign({}, this.isDropdown ? this.dropDownOverlaySettings : this.dialogOverlaySettings, settings);
      this.toggleRef.open(overlaySettings);
    }
    /**
     * Closes the dropdown/dialog.
     * ```html
     * <igx-time-picker #timePicker></igx-time-picker>
     * ```
     * ```typescript
     * @ViewChild('timePicker', { read: IgxTimePickerComponent }) picker: IgxTimePickerComponent;
     * picker.close();
     * ```
     */
    close() {
      this.toggleRef.close();
    }
    toggle(settings) {
      if (this.toggleRef.collapsed) {
        this.open(settings);
      } else {
        this.close();
      }
    }
    /**
     * Clears the time picker value if it is a `string` or resets the time to `00:00:00` if the value is a Date object.
     *
     * @example
     * ```typescript
     * this.timePicker.clear();
     * ```
     */
    clear() {
      if (this.disabled) {
        return;
      }
      if (!this.toggleRef.collapsed) {
        this.close();
      }
      if (DateTimeUtil.isValidDate(this.value)) {
        const oldValue = new Date(this.value);
        this.value.setHours(0, 0, 0, 0);
        if (this.value.getTime() !== oldValue.getTime()) {
          this.emitValueChange(oldValue, this.value);
          this._dateValue.setHours(0, 0, 0, 0);
          this.dateTimeEditor.value = new Date(this.value);
          this.setSelectedValue(this._dateValue);
        }
      } else {
        this.value = null;
      }
    }
    /**
     * Selects time from the igxTimePicker.
     *
     * @example
     * ```typescript
     * this.timePicker.select(date);
     *
     * @param date Date object containing the time to be selected.
     */
    select(date) {
      this.value = date;
    }
    /**
     * Increment a specified `DatePart`.
     *
     * @param datePart The optional DatePart to increment. Defaults to Hour.
     * @param delta The optional delta to increment by. Overrides `itemsDelta`.
     * @example
     * ```typescript
     * this.timePicker.increment(DatePart.Hours);
     * ```
     */
    increment(datePart, delta) {
      this.dateTimeEditor.increment(datePart, delta);
    }
    /**
     * Decrement a specified `DatePart`
     *
     * @param datePart The optional DatePart to decrement. Defaults to Hour.
     * @param delta The optional delta to decrement by. Overrides `itemsDelta`.
     * @example
     * ```typescript
     * this.timePicker.decrement(DatePart.Seconds);
     * ```
     */
    decrement(datePart, delta) {
      this.dateTimeEditor.decrement(datePart, delta);
    }
    /** @hidden @internal */
    cancelButtonClick() {
      this.setSelectedValue(this._dateValue);
      this.dateTimeEditor.value = this.parseToDate(this.value);
      this.close();
    }
    /** @hidden @internal */
    okButtonClick() {
      this.updateValue(this._selectedDate);
      this.close();
    }
    /** @hidden @internal */
    onItemClick(item, dateType) {
      let date = new Date(this._selectedDate);
      switch (dateType) {
        case 'hourList':
          {
            let ampm;
            const selectedHour = parseInt(item, 10);
            let hours = selectedHour;
            if (this.showAmPmList) {
              ampm = this.getPartValue(date, 'ampm');
              hours = this.toTwentyFourHourFormat(hours, ampm);
              const minHours = this.minDropdownValue?.getHours() || 0;
              const maxHours = this.maxDropdownValue?.getHours() || 24;
              if (hours < minHours || hours > maxHours) {
                hours = hours < 12 ? hours + 12 : hours - 12;
              }
            }
            date.setHours(hours);
            date = this.validateDropdownValue(date);
            if (this.valueInRange(date, this.minDropdownValue, this.maxDropdownValue)) {
              this.setSelectedValue(date);
            }
            break;
          }
        case 'minuteList':
          {
            const minutes = parseInt(item, 10);
            date.setMinutes(minutes);
            date = this.validateDropdownValue(date);
            this.setSelectedValue(date);
            break;
          }
        case 'secondsList':
          {
            const seconds = parseInt(item, 10);
            date.setSeconds(seconds);
            if (this.valueInRange(date, this.minDropdownValue, this.maxDropdownValue)) {
              this.setSelectedValue(date);
            }
            break;
          }
        case 'ampmList':
          {
            let hour = this._selectedDate.getHours();
            hour = DateTimeUtil.isAm(item) ? hour % 12 : hour % 12 + 12;
            date.setHours(hour);
            date = this.validateDropdownValue(date, true);
            this.setSelectedValue(date);
            break;
          }
      }
      this.updateEditorValue();
    }
    /** @hidden @internal */
    nextHour(delta) {
      delta = delta > 0 ? 1 : -1;
      const previousDate = new Date(this._selectedDate);
      const minHours = this.minDropdownValue?.getHours();
      const maxHours = this.maxDropdownValue?.getHours();
      const previousHours = previousDate.getHours();
      let hours = previousHours + delta * this.itemsDelta.hours;
      if (previousHours === maxHours && delta > 0 || previousHours === minHours && delta < 0) {
        hours = !this.spinLoop ? previousHours : delta > 0 ? minHours : maxHours;
      }
      this._selectedDate.setHours(hours);
      this._selectedDate = this.validateDropdownValue(this._selectedDate);
      this._selectedDate = new Date(this._selectedDate);
      this.updateEditorValue();
    }
    /** @hidden @internal */
    nextMinute(delta) {
      delta = delta > 0 ? 1 : -1;
      const minHours = this.minDropdownValue.getHours();
      const maxHours = this.maxDropdownValue.getHours();
      const hours = this._selectedDate.getHours();
      let minutes = this._selectedDate.getMinutes();
      const minMinutes = hours === minHours ? this.minDropdownValue.getMinutes() : 0;
      const maxMinutes = hours === maxHours ? this.maxDropdownValue.getMinutes() : 60 % this.itemsDelta.minutes > 0 ? 60 - 60 % this.itemsDelta.minutes : 60 - this.itemsDelta.minutes;
      if (delta < 0 && minutes === minMinutes || delta > 0 && minutes === maxMinutes) {
        minutes = this.spinLoop && minutes === minMinutes ? maxMinutes : this.spinLoop && minutes === maxMinutes ? minMinutes : minutes;
      } else {
        minutes = minutes + delta * this.itemsDelta.minutes;
      }
      this._selectedDate.setMinutes(minutes);
      this._selectedDate = this.validateDropdownValue(this._selectedDate);
      this._selectedDate = new Date(this._selectedDate);
      this.updateEditorValue();
    }
    /** @hidden @internal */
    nextSeconds(delta) {
      delta = delta > 0 ? 1 : -1;
      const minHours = this.minDropdownValue.getHours();
      const maxHours = this.maxDropdownValue.getHours();
      const hours = this._selectedDate.getHours();
      const minutes = this._selectedDate.getMinutes();
      const minMinutes = this.minDropdownValue.getMinutes();
      const maxMinutes = this.maxDropdownValue.getMinutes();
      let seconds = this._selectedDate.getSeconds();
      const minSeconds = hours === minHours && minutes === minMinutes ? this.minDropdownValue.getSeconds() : 0;
      const maxSeconds = hours === maxHours && minutes === maxMinutes ? this.maxDropdownValue.getSeconds() : 60 % this.itemsDelta.seconds > 0 ? 60 - 60 % this.itemsDelta.seconds : 60 - this.itemsDelta.seconds;
      if (delta < 0 && seconds === minSeconds || delta > 0 && seconds === maxSeconds) {
        seconds = this.spinLoop && seconds === minSeconds ? maxSeconds : this.spinLoop && seconds === maxSeconds ? minSeconds : seconds;
      } else {
        seconds = seconds + delta * this.itemsDelta.seconds;
      }
      this._selectedDate.setSeconds(seconds);
      this._selectedDate = this.validateDropdownValue(this._selectedDate);
      this._selectedDate = new Date(this._selectedDate);
      this.updateEditorValue();
    }
    /** @hidden @internal */
    nextAmPm(delta) {
      const ampm = this.getPartValue(this._selectedDate, 'ampm');
      if (!delta || DateTimeUtil.isAm(ampm) && delta > 0 || DateTimeUtil.isPm(ampm) && delta < 0) {
        let hours = this._selectedDate.getHours();
        const sign = hours < 12 ? 1 : -1;
        hours = hours + sign * 12;
        this._selectedDate.setHours(hours);
        this._selectedDate = this.validateDropdownValue(this._selectedDate, true);
        this._selectedDate = new Date(this._selectedDate);
        this.updateEditorValue();
      }
    }
    /** @hidden @internal */
    setSelectedValue(value) {
      this._selectedDate = value ? new Date(value) : null;
      if (!DateTimeUtil.isValidDate(this._selectedDate)) {
        this._selectedDate = new Date(this.minDropdownValue);
        return;
      }
      if (this.minValue && DateTimeUtil.lessThanMinValue(this._selectedDate, this.minDropdownValue, true, false)) {
        this._selectedDate = new Date(this.minDropdownValue);
        return;
      }
      if (this.maxValue && DateTimeUtil.greaterThanMaxValue(this._selectedDate, this.maxDropdownValue, true, false)) {
        this._selectedDate = new Date(this.maxDropdownValue);
        return;
      }
      if (this._selectedDate.getHours() % this.itemsDelta.hours > 0) {
        this._selectedDate.setHours(this._selectedDate.getHours() + this.itemsDelta.hours - this._selectedDate.getHours() % this.itemsDelta.hours, 0, 0);
      }
      if (this._selectedDate.getMinutes() % this.itemsDelta.minutes > 0) {
        this._selectedDate.setHours(this._selectedDate.getHours(), this._selectedDate.getMinutes() + this.itemsDelta.minutes - this._selectedDate.getMinutes() % this.itemsDelta.minutes, 0);
      }
      if (this._selectedDate.getSeconds() % this.itemsDelta.seconds > 0) {
        this._selectedDate.setSeconds(this._selectedDate.getSeconds() + this.itemsDelta.seconds - this._selectedDate.getSeconds() % this.itemsDelta.seconds);
      }
    }
    onStatusChanged() {
      if (this._ngControl && !this._ngControl.disabled && this.isTouchedOrDirty) {
        if (this.hasValidators && this._inputGroup.isFocused) {
          this.inputDirective.valid = this._ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
        } else {
          this.inputDirective.valid = this._ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
        }
      } else {
        // B.P. 18 May 2021: IgxDatePicker does not reset its state upon resetForm #9526
        this.inputDirective.valid = IgxInputState.INITIAL;
      }
      if (this._inputGroup && this._inputGroup.isRequired !== this.required) {
        this._inputGroup.isRequired = this.required;
      }
    }
    get isTouchedOrDirty() {
      return this._ngControl.control.touched || this._ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this._ngControl.control.validator || !!this._ngControl.control.asyncValidator;
    }
    setMinMaxDropdownValue(type, time) {
      let delta;
      const sign = type === 'min' ? 1 : -1;
      const hours = time.getHours();
      let minutes = time.getMinutes();
      let seconds = time.getSeconds();
      if (this.showHoursList && hours % this.itemsDelta.hours > 0) {
        delta = type === 'min' ? this.itemsDelta.hours - hours % this.itemsDelta.hours : hours % this.itemsDelta.hours;
        minutes = type === 'min' ? 0 : 60 % this.itemsDelta.minutes > 0 ? 60 - 60 % this.itemsDelta.minutes : 60 - this.itemsDelta.minutes;
        seconds = type === 'min' ? 0 : 60 % this.itemsDelta.seconds > 0 ? 60 - 60 % this.itemsDelta.seconds : 60 - this.itemsDelta.seconds;
        time.setHours(hours + sign * delta, minutes, seconds);
      } else if (this.showMinutesList && minutes % this.itemsDelta.minutes > 0) {
        delta = type === 'min' ? this.itemsDelta.minutes - minutes % this.itemsDelta.minutes : minutes % this.itemsDelta.minutes;
        seconds = type === 'min' ? 0 : 60 % this.itemsDelta.seconds > 0 ? 60 - 60 % this.itemsDelta.seconds : 60 - this.itemsDelta.seconds;
        time.setHours(hours, minutes + sign * delta, seconds);
      } else if (this.showSecondsList && seconds % this.itemsDelta.seconds > 0) {
        delta = type === 'min' ? this.itemsDelta.seconds - seconds % this.itemsDelta.seconds : seconds % this.itemsDelta.seconds;
        time.setHours(hours, minutes, seconds + sign * delta);
      }
      return time;
    }
    initializeContainer() {
      requestAnimationFrame(() => {
        if (this.hourList) {
          this.hourList.nativeElement.focus();
        } else if (this.minuteList) {
          this.minuteList.nativeElement.focus();
        } else if (this.secondsList) {
          this.secondsList.nativeElement.focus();
        }
      });
    }
    validateDropdownValue(date, isAmPm = false) {
      if (date > this.maxDropdownValue) {
        if (isAmPm && date.getHours() !== this.maxDropdownValue.getHours()) {
          date.setHours(12);
        } else {
          date = new Date(this.maxDropdownValue);
        }
      }
      if (date < this.minDropdownValue) {
        date = new Date(this.minDropdownValue);
      }
      return date;
    }
    emitValueChange(oldValue, newValue) {
      if (!isEqual(oldValue, newValue)) {
        this.valueChange.emit(newValue);
      }
    }
    emitValidationFailedEvent(previousValue) {
      const args = {
        owner: this,
        previousValue,
        currentValue: this.value
      };
      this.validationFailed.emit(args);
    }
    updateValidityOnBlur() {
      this._onTouchedCallback();
      if (this._ngControl) {
        if (!this._ngControl.valid) {
          this.inputDirective.valid = IgxInputState.INVALID;
        } else {
          this.inputDirective.valid = IgxInputState.INITIAL;
        }
      }
    }
    valueInRange(value, minValue, maxValue) {
      if (minValue && DateTimeUtil.lessThanMinValue(value, minValue, true, false)) {
        return false;
      }
      if (maxValue && DateTimeUtil.greaterThanMaxValue(value, maxValue, true, false)) {
        return false;
      }
      return true;
    }
    parseToDate(value) {
      return DateTimeUtil.isValidDate(value) ? value : DateTimeUtil.parseIsoDate(value);
    }
    toTwentyFourHourFormat(hour, ampm) {
      if (DateTimeUtil.isPm(ampm) && hour < 12) {
        hour += 12;
      } else if (DateTimeUtil.isAm(ampm) && hour === 12) {
        hour = 0;
      }
      return hour;
    }
    updateValue(newValue) {
      if (!this.value) {
        this.value = newValue ? new Date(newValue) : newValue;
      } else if (isDate(this.value)) {
        const date = new Date(this.value);
        date.setHours(newValue?.getHours() || 0, newValue?.getMinutes() || 0, newValue?.getSeconds() || 0, newValue?.getMilliseconds() || 0);
        this.value = date;
      } else {
        this.value = newValue ? this.toISOString(newValue) : newValue;
      }
    }
    updateEditorValue() {
      const date = this.dateTimeEditor.value ? new Date(this.dateTimeEditor.value) : new Date();
      date.setHours(this._selectedDate.getHours(), this._selectedDate.getMinutes(), this._selectedDate.getSeconds(), this._selectedDate.getMilliseconds());
      this.dateTimeEditor.value = date;
    }
    subscribeToDateEditorEvents() {
      this.dateTimeEditor.valueChange.pipe(
      // internal date editor directive is only used w/ Date object values:
      takeUntil(this._destroy$)).subscribe(date => {
        this.updateValue(date);
      });
      this.dateTimeEditor.validationFailed.pipe(takeUntil(this._destroy$)).subscribe(event => {
        this.emitValidationFailedEvent(event.oldValue);
      });
    }
    subscribeToToggleDirectiveEvents() {
      if (this.toggleRef) {
        if (this._inputGroup && this.platform.isBrowser) {
          this.toggleRef.element.style.width = this._inputGroup.element.nativeElement.getBoundingClientRect().width + 'px';
        }
        this.toggleRef.opening.pipe(takeUntil(this._destroy$)).subscribe(e => {
          const args = {
            owner: this,
            event: e.event,
            cancel: false
          };
          this.opening.emit(args);
          e.cancel = args.cancel;
          if (args.cancel) {
            return;
          }
          this.initializeContainer();
        });
        this.toggleRef.opened.pipe(takeUntil(this._destroy$)).subscribe(() => {
          this.opened.emit({
            owner: this
          });
        });
        this.toggleRef.closed.pipe(takeUntil(this._destroy$)).subscribe(() => {
          this.closed.emit({
            owner: this
          });
        });
        this.toggleRef.closing.pipe(takeUntil(this._destroy$)).subscribe(e => {
          const args = {
            owner: this,
            event: e.event,
            cancel: false
          };
          this.closing.emit(args);
          e.cancel = args.cancel;
          if (args.cancel) {
            return;
          }
          const value = this.parseToDate(this.value);
          if (this.dateTimeEditor.value?.getTime() !== value?.getTime()) {
            this.updateValue(this._selectedDate);
          }
          // Do not focus the input if clicking outside in dropdown mode
          const input = this.getEditElement();
          if (input && !(e.event && this.isDropdown)) {
            input.focus();
          } else {
            this.updateValidityOnBlur();
          }
        });
      }
    }
    static {
      this.ɵfac = function IgxTimePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTimePickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTimePickerComponent,
        selectors: [["igx-time-picker"]],
        contentQueries: function IgxTimePickerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxLabelDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPickerActionsDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPickerClearComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timePickerActionsDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearComponents = _t);
          }
        },
        viewQuery: function IgxTimePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c79, 5);
            i0.ɵɵviewQuery(_c80, 5);
            i0.ɵɵviewQuery(_c81, 5);
            i0.ɵɵviewQuery(_c82, 5);
            i0.ɵɵviewQuery(IgxInputDirective, 5, IgxInputDirective);
            i0.ɵɵviewQuery(_c55, 7, IgxInputGroupComponent);
            i0.ɵɵviewQuery(IgxDateTimeEditorDirective, 7);
            i0.ɵɵviewQuery(IgxToggleDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hourList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.minuteList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.secondsList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ampmList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateTimeEditor = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleRef = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function IgxTimePickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxTimePickerComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
          }
        },
        inputs: {
          id: "id",
          displayFormat: "displayFormat",
          inputFormat: "inputFormat",
          mode: "mode",
          minValue: "minValue",
          maxValue: "maxValue",
          spinLoop: [2, "spinLoop", "spinLoop", booleanAttribute],
          formatter: "formatter",
          headerOrientation: "headerOrientation",
          readOnly: [2, "readOnly", "readOnly", booleanAttribute],
          value: "value",
          resourceStrings: "resourceStrings",
          okButtonLabel: "okButtonLabel",
          cancelButtonLabel: "cancelButtonLabel",
          itemsDelta: "itemsDelta"
        },
        outputs: {
          selected: "selected",
          valueChange: "valueChange",
          validationFailed: "validationFailed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxTimePickerComponent,
          multi: true
        }, {
          provide: IGX_TIME_PICKER_COMPONENT,
          useExisting: IgxTimePickerComponent
        }, {
          provide: NG_VALIDATORS,
          useExisting: IgxTimePickerComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c68,
        decls: 26,
        vars: 27,
        consts: [["inputGroup", ""], ["defaultTimePickerActions", ""], ["toggleDirective", "toggle"], ["hourList", ""], ["timeItem", "timeItem"], ["minuteList", ""], ["secondsList", ""], ["ampmList", ""], [3, "type"], ["igxInput", "", "type", "text", "defaultFormatType", "time", "role", "combobox", "aria-haspopup", "dialog", 3, "click", "displayValuePipe", "igxDateTimeEditor", "readonly", "minValue", "maxValue", "locale", "spinDelta", "spinLoop", "placeholder", "disabled", "displayFormat", "igxTextSelection"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], ["ngProjectAs", "igx-hint", 5, ["igx-hint"]], ["igxToggle", "", "role", "dialog", 1, "igx-time-picker", 3, "ngClass"], [1, "igx-time-picker__main"], [1, "igx-time-picker__header"], [1, "igx-time-picker__body"], [3, "igxItemList"], [4, "ngTemplateOutlet"], [3, "click"], ["family", "default", "name", "clock", 3, "title"], ["family", "default", "name", "input_clear"], [1, "igx-time-picker__buttons"], ["type", "button", "igxButton", "flat"], ["type", "button", "igxButton", "flat", 3, "click"], [1, "igx-time-picker__header-hour"], ["aria-label", "hour", 3, "igxTimeItem"], ["aria-label", "minutes", 3, "igxTimeItem"], ["aria-label", "seconds", 3, "igxTimeItem"], ["aria-label", "ampm", 3, "igxTimeItem"]],
        template: function IgxTimePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c67);
            i0.ɵɵelementStart(0, "igx-input-group", 8, 0)(2, "input", 9);
            i0.ɵɵlistener("click", function IgxTimePickerComponent_Template_input_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(!ctx.isDropdown && ctx.toggle());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, IgxTimePickerComponent_Conditional_3_Template, 2, 1, "igx-prefix");
            i0.ɵɵelementContainerStart(4, 10);
            i0.ɵɵprojection(5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(6, 11);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(8, IgxTimePickerComponent_Conditional_8_Template, 2, 0, "igx-suffix");
            i0.ɵɵelementContainerStart(9, 12);
            i0.ɵɵprojection(10, 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(11, 13);
            i0.ɵɵprojection(12, 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, IgxTimePickerComponent_ng_template_13_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(15, "div", 14, 2)(17, "div", 15);
            i0.ɵɵtemplate(18, IgxTimePickerComponent_Conditional_18_Template, 5, 3, "div", 16);
            i0.ɵɵelementStart(19, "div", 17);
            i0.ɵɵtemplate(20, IgxTimePickerComponent_Conditional_20_Template, 5, 12, "div", 18)(21, IgxTimePickerComponent_Conditional_21_Template, 5, 12, "div", 18)(22, IgxTimePickerComponent_Conditional_22_Template, 5, 12, "div", 18)(23, IgxTimePickerComponent_Conditional_23_Template, 5, 12, "div", 18);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(24, "igx-divider");
            i0.ɵɵtemplate(25, IgxTimePickerComponent_ng_container_25_Template, 1, 0, "ng-container", 19);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const defaultTimePickerActions_r15 = i0.ɵɵreference(14);
            const toggleDirective_r16 = i0.ɵɵreference(16);
            i0.ɵɵproperty("type", ctx.type);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("displayValuePipe", ctx.formatter ? ctx.displayValue : null)("igxDateTimeEditor", ctx.inputFormat)("readonly", !ctx.isDropdown || ctx.readOnly)("minValue", ctx.minValue)("maxValue", ctx.maxValue)("locale", ctx.locale)("spinDelta", ctx.itemsDelta)("spinLoop", ctx.spinLoop)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("displayFormat", ctx.displayFormat)("igxTextSelection", ctx.isDropdown && !ctx.readOnly);
            i0.ɵɵattribute("aria-expanded", !toggleDirective_r16.collapsed)("aria-labelledby", ctx.label == null ? null : ctx.label.id);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggleComponents.length ? 3 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.showClearButton ? 8 : -1);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c83, ctx.isDropdown, ctx.isVertical && !ctx.isDropdown));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.isDropdown ? 18 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showHoursList ? 20 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showMinutesList ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSecondsList ? 22 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showAmPmList ? 23 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.timePickerActionsDirective ? ctx.timePickerActionsDirective.template : defaultTimePickerActions_r15);
          }
        },
        dependencies: [IgxInputGroupComponent, IgxInputDirective, IgxDateTimeEditorDirective, IgxTextSelectionDirective, IgxPrefixDirective, IgxIconComponent, IgxSuffixDirective, IgxButtonDirective, IgxToggleDirective, NgClass, IgxItemListDirective, IgxTimeItemDirective, NgTemplateOutlet, TimeFormatPipe, TimeItemPipe, IgxDividerDirective],
        styles: ["[_nghost-%COMP%]{display:block}"]
      });
    }
  }
  return IgxTimePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxFieldFormatterPipe = /*#__PURE__*/(() => {
  class IgxFieldFormatterPipe {
    transform(value, formatter, rowData, fieldData) {
      return formatter(value, rowData, fieldData);
    }
    static {
      this.ɵfac = function IgxFieldFormatterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFieldFormatterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "fieldFormatter",
        type: IgxFieldFormatterPipe,
        pure: true
      });
    }
  }
  return IgxFieldFormatterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden @internal
 */
class ExpressionItem {
  constructor(parent) {
    this.parent = parent;
  }
}
/**
 * @hidden @internal
 */
class ExpressionGroupItem extends ExpressionItem {
  constructor(operator, parent) {
    super(parent);
    this.operator = operator;
    this.children = [];
  }
}
/**
 * @hidden @internal
 */
class ExpressionOperandItem extends ExpressionItem {
  constructor(expression, parent) {
    super(parent);
    this.expression = expression;
  }
}
const IGX_QUERY_BUILDER = 'igx-query-builder';
const IGX_FILTER_TREE = 'igx-filter-tree';
/**
 * @hidden @internal
 */
const QueryBuilderSelectors = {
  DRAG_INDICATOR: 'igx-drag-indicator',
  CHIP_GHOST: 'igx-chip__ghost',
  DROP_DOWN_LIST_SCROLL: 'igx-drop-down__list-scroll',
  DROP_DOWN_ITEM_DISABLED: 'igx-drop-down__item--disabled',
  FILTER_TREE: IGX_FILTER_TREE,
  FILTER_TREE_EXPRESSION_CONTEXT_MENU: IGX_FILTER_TREE + '__expression-context-menu',
  FILTER_TREE_EXPRESSION_ITEM: IGX_FILTER_TREE + '__expression-item',
  FILTER_TREE_EXPRESSION_ITEM_DROP_GHOST: IGX_FILTER_TREE + '__expression-item-drop-ghost',
  FILTER_TREE_EXPRESSION_ITEM_KEYBOARD_GHOST: IGX_FILTER_TREE + '__expression-item-keyboard-ghost',
  FILTER_TREE_EXPRESSION_ITEM_GHOST: IGX_FILTER_TREE + '__expression-item-ghost',
  FILTER_TREE_EXPRESSION_SECTION: IGX_FILTER_TREE + '__expression-section',
  FILTER_TREE_LINE_AND: IGX_FILTER_TREE + '__line--and',
  FILTER_TREE_LINE_OR: IGX_FILTER_TREE + '__line--or',
  FILTER_TREE_SUBQUERY: IGX_FILTER_TREE + '__subquery',
  QUERY_BUILDER: IGX_QUERY_BUILDER,
  QUERY_BUILDER_BODY: IGX_QUERY_BUILDER + '__main',
  QUERY_BUILDER_HEADER: IGX_QUERY_BUILDER + '__header',
  QUERY_BUILDER_TREE: IGX_QUERY_BUILDER + '-tree'
};
const DEFAULT_SET_Z_INDEX_DELAY = 10;
const Z_INDEX_TO_SET = 10010; //overlay z-index is 10005
/** @hidden @internal */
let IgxQueryBuilderDragService = /*#__PURE__*/(() => {
  class IgxQueryBuilderDragService {
    constructor() {
      this._keyDragCurrentIndex = 0;
      this._keyDragInitialIndex = 0;
      this._isKeyDragsFirstMove = true;
    }
    /** Get the dragged ghost as a HTMLElement*/
    get getDragGhostElement() {
      return document.querySelector(`.${QueryBuilderSelectors.CHIP_GHOST}[ghostclass="${QueryBuilderSelectors.CHIP_GHOST}"]`);
    }
    /** Get the drop ghost chip component */
    get getDropGhostElement() {
      return this._queryBuilderTreeComponent.expressionsChips.find(x => x.data === this.dropGhostExpression);
    }
    get getMainExpressionTree() {
      return this._queryBuilderTreeComponentElRef.nativeElement.querySelector(`.${QueryBuilderSelectors.FILTER_TREE}`);
    }
    register(tree, el) {
      this._queryBuilderTreeComponent = tree;
      this._queryBuilderTreeComponentElRef = el;
    }
    /** When chip is picked up for dragging
     *
     * @param sourceDragElement The HTML element of the chip that's been dragged
     * @param sourceExpressionItem The expressionItem of the chip that's been dragged
     * @param isKeyboardDrag If it's a mouse drag or keyboard reorder
     *
    */
    onMoveStart(sourceDragElement, sourceExpressionItem, isKeyboardDrag) {
      this.resetDragAndDrop(true);
      this._queryBuilderTreeComponent._expressionTreeCopy = this._queryBuilderTreeComponent._expressionTree;
      this.isKeyboardDrag = isKeyboardDrag;
      this._sourceExpressionItem = sourceExpressionItem;
      this._sourceElement = sourceDragElement;
      this.listenToKeyboard();
      if (!this.isKeyboardDrag) {
        this._sourceElement.style.display = 'none';
        this.setDragGhostZIndex();
      }
    }
    /** When dragged chip is let go outside a proper drop zone */
    onMoveEnd() {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      if (this.dropGhostExpression) {
        //If there is a ghost chip presented to the user, execute drop
        this.onChipDropped();
      } else {
        this.resetDragAndDrop(true);
      }
      this._ghostChipMousemoveSubscription$?.unsubscribe();
      this._keyboardSubscription$?.unsubscribe();
    }
    /** When mouse drag enters a chip's area
     * @param targetDragElement The HTML element of the drop area chip that's been dragged to
     * @param targetExpressionItem The expressionItem of the drop area chip that's been dragged to
    */
    onChipEnter(targetDragElement, targetExpressionItem) {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      //If entering the one that's been picked up don't do any thing
      if (targetExpressionItem === this.dropGhostExpression) {
        return;
      }
      //Simulate leaving the last entered chip in case of no Leave event triggered due to the artificial drop zone of a north positioned ghost chip
      if (this._targetExpressionItem) {
        this.resetDragAndDrop(false);
      }
      this._targetExpressionItem = targetExpressionItem;
      //Determine the middle point of the chip.
      const appendUnder = this.ghostInLowerPart(targetDragElement);
      this.renderDropGhostChip(appendUnder);
    }
    /** When mouse drag moves in a div's drop area
     * @param targetDragElement The HTML element of the drop area chip that's been dragged to
     * @param targetExpressionItem The expressionItem of the drop area chip that's been dragged to
    */
    onDivOver(targetDragElement, targetExpressionItem) {
      if (this._targetExpressionItem === targetExpressionItem) {
        this.onChipOver(targetDragElement);
      } else {
        this.onChipEnter(targetDragElement, targetExpressionItem);
      }
    }
    /** When mouse drag moves in a chip's drop area
     * @param targetDragElement The HTML element of the drop area chip that's been dragged to
    */
    onChipOver(targetDragElement) {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      //Determine the middle point of the chip.
      const appendUnder = this.ghostInLowerPart(targetDragElement);
      this.renderDropGhostChip(appendUnder);
    }
    /** When mouse drag leaves a chip's drop area */
    onChipLeave() {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      //if the drag ghost is on the drop ghost row don't trigger leave
      if (this.dragGhostIsOnDropGhostRow()) {
        return;
      }
      if (this._targetExpressionItem) {
        this.resetDragAndDrop(false);
      }
    }
    /** When dragged chip is let go in div's drop area
     * @param targetExpressionItem The expressionItem of the drop area chip that's been dragged to
    */
    onDivDropped(targetExpressionItem) {
      if (targetExpressionItem !== this._sourceExpressionItem) {
        this.onChipDropped();
      }
    }
    /** When dragged chip is let go in chip's drop area */
    onChipDropped() {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      //Determine which chip to be focused after drop completes
      const [dropLocationIndex, _] = this.countChipsBeforeDropLocation(this._queryBuilderTreeComponent.rootGroup);
      //Delete from old place
      this._queryBuilderTreeComponent.deleteItem(this._sourceExpressionItem);
      this.dropGhostExpression = null;
      this._queryBuilderTreeComponent.focusChipAfterDrag(dropLocationIndex);
      this.resetDragAndDrop(true);
      this._queryBuilderTreeComponent.exitEditAddMode();
    }
    /** When mouse drag moves in a AND/OR drop area
     * @param targetDragElement The HTML element of the drop area chip that's been dragged to
     * @param targetExpressionItem The expressionItem of the drop area chip that's been dragged to
    */
    onGroupRootOver(targetDragElement, targetExpressionItem) {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      let newTargetExpressionItem;
      if (this.ghostInLowerPart(targetDragElement) || !targetExpressionItem.parent) {
        //if ghost is in lower part of the AND/OR (or it's the main group) => drop as first child of that group    
        //accounting for the fact that the drop ghost might already be there as first child        
        if (targetExpressionItem.children[0] !== this.dropGhostExpression) {
          newTargetExpressionItem = targetExpressionItem.children[0];
        } else {
          newTargetExpressionItem = targetExpressionItem.children[1];
        }
      } else {
        //if ghost is in upper part => drop before the group starts             
        newTargetExpressionItem = targetExpressionItem;
      }
      if (this._targetExpressionItem !== newTargetExpressionItem) {
        this.resetDragAndDrop(false);
        this._targetExpressionItem = newTargetExpressionItem;
        this.renderDropGhostChip(false);
      }
    }
    /** When mouse drag moves in 'Add condition' button's drop area
     * @param addConditionElement The Add condition button HTML Element
     * @param rootGroup The root group of the query tree
    */
    onAddConditionEnter(addConditionElement, rootGroup) {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      const lastElement = addConditionElement.parentElement.previousElementSibling.lastElementChild;
      //simulate entering in the lower part of the last chip/group
      this.onChipEnter(lastElement, rootGroup.children[rootGroup.children.length - 1]);
    }
    /** When chip's drag indicator is focused
     *
     * @param sourceDragElement The HTML element of the chip that's been dragged
     * @param sourceExpressionItem The expressionItem of the chip that's been dragged
     *
    */
    onChipDragIndicatorFocus(sourceDragElement, sourceExpressionItem) {
      //if drag is not underway, already
      if (!this.getDropGhostElement) {
        this.onMoveStart(sourceDragElement, sourceExpressionItem, true);
      }
    }
    /** When chip's drag indicator looses focus*/
    onChipDragIndicatorFocusOut() {
      if (this._sourceElement?.style?.display !== 'none') {
        this.resetDragAndDrop(true);
        this._keyboardSubscription$?.unsubscribe();
      }
    }
    /** Upon blurring the tree, if Keyboard drag is underway and the next active item is not the drop ghost's drag indicator icon, cancel the drag&drop procedure*/
    onDragFocusOut() {
      if (this.isKeyboardDrag && this.getDropGhostElement) {
        //have to wait a tick because upon blur, the next activeElement is always body, right before the next element gains focus
        setTimeout(() => {
          if (document.activeElement.className.indexOf(QueryBuilderSelectors.DRAG_INDICATOR) === -1) {
            this.resetDragAndDrop(true);
            this._keyboardSubscription$?.unsubscribe();
          }
        }, 0);
      }
    }
    /** Checks if the dragged ghost is horizontally on the same line with the drop ghost*/
    dragGhostIsOnDropGhostRow() {
      const dragGhostBounds = this.getDragGhostElement.getBoundingClientRect();
      const dropGhostBounds = this.getDropGhostElement?.nativeElement?.parentElement.getBoundingClientRect();
      if (!dragGhostBounds || !dropGhostBounds) {
        return false;
      }
      const tolerance = dragGhostBounds.bottom - dragGhostBounds.top;
      return !(dragGhostBounds.bottom < dropGhostBounds.top - tolerance || dragGhostBounds.top > dropGhostBounds.bottom + tolerance);
    }
    /** Checks if the dragged ghost is north or south of a target element's center*/
    ghostInLowerPart(ofElement) {
      const ghostBounds = this.getDragGhostElement.getBoundingClientRect();
      const targetBounds = ofElement.getBoundingClientRect();
      return (ghostBounds.top + ghostBounds.bottom) / 2 >= (targetBounds.top + targetBounds.bottom) / 2;
    }
    /** Make a copy of the _sourceExpressionItem's chip and paste it in the tree north or south of the _targetExpressionItem's chip */
    renderDropGhostChip(appendUnder) {
      if (appendUnder !== this._dropUnder || this.isKeyboardDrag) {
        this.clearDropGhost();
        //Copy dragged chip
        const dragCopy = {
          ...this._sourceExpressionItem
        };
        dragCopy.parent = this._targetExpressionItem.parent;
        this.dropGhostExpression = dragCopy;
        //Paste chip
        this._dropUnder = appendUnder;
        const pasteIndex = this._targetExpressionItem.parent.children.indexOf(this._targetExpressionItem);
        this._targetExpressionItem.parent.children.splice(pasteIndex + (this._dropUnder ? 1 : 0), 0, dragCopy);
      }
      //Put focus on the drag icon of the ghost while performing keyboard drag
      if (this.isKeyboardDrag) {
        setTimeout(() => {
          const dropGhostDragIndicator = this.getDropGhostElement?.nativeElement?.querySelector(`.${QueryBuilderSelectors.DRAG_INDICATOR}`);
          if (dropGhostDragIndicator) {
            dropGhostDragIndicator.focus();
          }
        }, 0);
      }
      //Attach a mousemove event listener (if not already in place) to the dragged ghost (if present)
      if (!this.isKeyboardDrag && this.getDragGhostElement && (!this._ghostChipMousemoveSubscription$ || this._ghostChipMousemoveSubscription$?.closed === true)) {
        const mouseMoves = fromEvent(this.getDragGhostElement, 'mousemove');
        //When mouse moves and there is a drop ghost => trigger onChipLeave to check if the drop ghost has to be removed 
        //effectively solving the case when mouse leaves the QB and a drop ghost is still in place
        this._ghostChipMousemoveSubscription$ = mouseMoves.pipe(sampleTime(100)).subscribe(() => {
          if (this.getDropGhostElement) {
            this.onChipLeave();
          }
        });
      }
      this.setDragCursor('grab');
    }
    /** Set the cursor when dragging a ghost*/
    setDragCursor(cursor) {
      if (this.getDragGhostElement) {
        this.getDragGhostElement.style.cursor = cursor;
      }
    }
    /** Removes the drop ghost expression from the tree and it's chip effectively  */
    clearDropGhost() {
      if (this.dropGhostExpression) {
        const children = this.dropGhostExpression.parent.children;
        const delIndex = children.indexOf(this.dropGhostExpression);
        children.splice(delIndex, 1);
        this.dropGhostExpression = null;
      }
    }
    /** Reset Drag&Drop vars. Optionally the drag source vars too*/
    resetDragAndDrop(clearDragged) {
      this._targetExpressionItem = null;
      this._dropUnder = null;
      this.clearDropGhost();
      this._keyDragInitialIndex = 0;
      this._keyDragCurrentIndex = 0;
      this._possibleDropLocations = null;
      this._isKeyDragsFirstMove = true;
      this.setDragCursor('no-drop');
      if (this._queryBuilderTreeComponent._expressionTreeCopy) {
        this._queryBuilderTreeComponent._expressionTree = this._queryBuilderTreeComponent._expressionTreeCopy;
      }
      if ((clearDragged || this.isKeyboardDrag) && this._sourceElement) {
        this._sourceElement.style.display = '';
      }
      if (clearDragged) {
        this._queryBuilderTreeComponent._expressionTreeCopy = null;
        this._sourceExpressionItem = null;
        this._sourceElement = null;
      }
    }
    /** Start listening for drag and drop specific keys */
    listenToKeyboard() {
      this._keyboardSubscription$?.unsubscribe();
      this._keyboardSubscription$ = fromEvent(this.getMainExpressionTree, 'keydown').pipe(filter$1(e => ['ArrowUp', 'ArrowDown', 'Enter', 'Space', 'Escape', 'Tab'].includes(e.key)))
      // .pipe(tap(e => {
      //     //Inhibit Tabs if keyboard drag is underway (don't allow to loose focus of the drop ghost's drag indicator)
      //     if (e.key === 'Tab' && this.getDropGhostElement) {
      //         e.preventDefault();
      //     }
      // }))
      .pipe(filter$1(event => !event.repeat)).subscribe(e => {
        if (e.key === 'Escape') {
          //TODO cancel mouse drag once it's implemented in igx-chip draggable
          this.resetDragAndDrop(false);
          //Regain focus on the drag icon after keyboard drag cancel
          if (this.isKeyboardDrag) {
            this._sourceElement.firstElementChild.firstElementChild.firstElementChild.firstElementChild.focus();
          }
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          this.arrowDrag(e.key);
        } else if (e.key === 'Enter' || e.key === 'Space') {
          //this.platform.isActivationKey(eventArgs) Maybe use this rather that Enter/Space?
          this.onChipDropped();
          this._keyboardSubscription$.unsubscribe();
        }
      });
    }
    /** Perform up/down movement of drop ghost along the expression tree*/
    arrowDrag(key) {
      if (!this._sourceElement || !this._sourceExpressionItem) {
        return;
      }
      const rootGroup = this._queryBuilderTreeComponent.rootGroup;
      if (this._isKeyDragsFirstMove) {
        this._possibleDropLocations = this.getPossibleDropLocations(rootGroup, true);
        this._keyDragInitialIndex = this._possibleDropLocations.findIndex(e => e[0] === this._sourceExpressionItem && e[1] === true);
        this._keyDragCurrentIndex = this._keyDragInitialIndex;
        if (this._keyDragInitialIndex === -1) {
          console.error("Dragged expression not found");
        }
        this._sourceElement.style.display = 'none';
      }
      let newKeyIndexOffset = this._keyDragCurrentIndex;
      if (key === 'ArrowUp') {
        //decrease index capped at top of tree
        newKeyIndexOffset && newKeyIndexOffset--;
      } else if (key === 'ArrowDown') {
        //increase index capped at bottom of tree
        newKeyIndexOffset < this._possibleDropLocations.length - 1 && newKeyIndexOffset++;
      } else {
        console.error('wrong key');
        return;
      }
      //if drop location has no change
      if (newKeyIndexOffset !== this._keyDragCurrentIndex || this._isKeyDragsFirstMove) {
        this._keyDragCurrentIndex = newKeyIndexOffset;
        const newDropTarget = this._possibleDropLocations[this._keyDragCurrentIndex];
        this._targetExpressionItem = newDropTarget[0];
        this.renderDropGhostChip(newDropTarget[1]);
        //Situations when drop ghost hasn't really moved, run one more time
        if (this._keyDragCurrentIndex === this._keyDragInitialIndex || this._isKeyDragsFirstMove && this._keyDragCurrentIndex === this._keyDragInitialIndex - 1) {
          this._isKeyDragsFirstMove = false;
          this.arrowDrag(key);
        }
        this._isKeyDragsFirstMove = false;
      }
      return;
    }
    /** Produces a flat ordered list of possible drop locations as Tuple <[targetExpression, dropUnder]>, while performing the keyboard drag&drop */
    getPossibleDropLocations(group, isRoot) {
      const result = new Array();
      //Add dropZone under AND/OR (as first child of group)
      result.push([group.children[0], false]);
      for (let i = 0; i < group.children.length; i++) {
        if (group.children[i] instanceof ExpressionGroupItem) {
          result.push(...this.getPossibleDropLocations(group.children[i], false));
        } else {
          result.push([group.children[i], true]);
        }
      }
      //Add dropZone under the whole group
      if (!isRoot) {
        result.push([group, true]);
      }
      return result;
    }
    /** Counts how many chips will be in the tree (from top to bottom) before the dropped one */
    countChipsBeforeDropLocation(group) {
      let count = 0,
        totalCount = 0,
        targetReached = false;
      for (let i = 0; i < group.children.length; i++) {
        const child = group.children[i];
        if (targetReached) {
          break;
        }
        if (child instanceof ExpressionGroupItem) {
          if (child === this._targetExpressionItem) {
            if (this._dropUnder) {
              [count] = this.countChipsBeforeDropLocation(child);
              totalCount += count;
            }
            targetReached = true;
          } else {
            [count, targetReached] = this.countChipsBeforeDropLocation(child);
            totalCount += count;
          }
        } else {
          if (child !== this._sourceExpressionItem &&
          //not the hidden source chip
          child !== this.dropGhostExpression &&
          //not the drop ghost
          !(child.inEditMode && this._queryBuilderTreeComponent.operandCanBeCommitted() !== true) //not a chip in edit mode that will be discarded
          ) {
            totalCount++;
          }
          if (child === this._targetExpressionItem) {
            targetReached = true;
            if (!this._dropUnder && !(child.inEditMode && this._queryBuilderTreeComponent.operandCanBeCommitted() !== true)) {
              totalCount--;
            }
          }
        }
      }
      totalCount === -1 && totalCount++;
      return [totalCount, targetReached];
    }
    /** Sets the z-index of the drag ghost with a little delay, since we don't have access to ghostCreated() but we know it's executed right after moveStart() */
    setDragGhostZIndex() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
      this._timeoutId = setTimeout(() => {
        if (this.getDragGhostElement?.style) {
          this.getDragGhostElement.style.zIndex = `${Z_INDEX_TO_SET}`;
        }
      }, DEFAULT_SET_Z_INDEX_DELAY);
    }
    static {
      this.ɵfac = function IgxQueryBuilderDragService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderDragService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxQueryBuilderDragService,
        factory: IgxQueryBuilderDragService.ɵfac
      });
    }
  }
  return IgxQueryBuilderDragService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_PIPE_DATE_FORMAT = 'mediumDate';
const DEFAULT_PIPE_TIME_FORMAT = 'mediumTime';
const DEFAULT_PIPE_DATE_TIME_FORMAT = 'medium';
const DEFAULT_PIPE_DIGITS_INFO = '1.0-3';
const DEFAULT_CHIP_FOCUS_DELAY = 50;
/** @hidden */
let IgxQueryBuilderTreeComponent = /*#__PURE__*/(() => {
  class IgxQueryBuilderTreeComponent {
    /**
     * @hidden @internal
     */
    get getClass() {
      return `igx-query-builder-tree--level-${this.level}`;
    }
    /**
    * Returns the parent expression operand.
    */
    get parentExpression() {
      return this._parentExpression;
    }
    /**
     * Sets the parent expression operand.
     */
    set parentExpression(value) {
      this._parentExpression = value;
    }
    /**
    * Returns the fields.
    */
    get fields() {
      if (!this._fields && this.isAdvancedFiltering()) {
        this._fields = this.entities[0].fields;
      }
      return this._fields;
    }
    /**
     * Sets the fields.
     */
    set fields(fields) {
      this._fields = fields;
      if (!this._fields && this.isAdvancedFiltering()) {
        this._fields = this.entities[0].fields;
      }
      if (this._fields) {
        this._fields.forEach(field => {
          this.setFilters(field);
          this.setFormat(field);
        });
      }
    }
    /**
    * Returns the expression tree.
    */
    get expressionTree() {
      return this._expressionTree;
    }
    /**
     * Sets the expression tree.
     */
    set expressionTree(expressionTree) {
      this._expressionTree = expressionTree;
      if (!expressionTree) {
        this._selectedEntity = null;
        this._selectedReturnFields = [];
      }
      if (!this._preventInit) {
        this.init();
      }
    }
    /**
     * Gets the `locale` of the query builder.
     * If not set, defaults to application's locale.
     */
    get locale() {
      return this._locale;
    }
    /**
     * Sets the `locale` of the query builder.
     * Expects a valid BCP 47 language tag.
     */
    set locale(value) {
      this._locale = value;
      // if value is invalid, set it back to _localeId
      try {
        getLocaleFirstDayOfWeek(this._locale);
      } catch {
        this._locale = this._localeId;
      }
    }
    /**
     * Sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * Returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    set editingInputsContainer(value) {
      if (value && !this._editingInputsContainer || value && this._editingInputsContainer && this._editingInputsContainer.nativeElement !== value.nativeElement) {
        requestAnimationFrame(() => {
          this.scrollElementIntoView(value.nativeElement);
        });
      }
      this._editingInputsContainer = value;
    }
    /** @hidden */
    get editingInputsContainer() {
      return this._editingInputsContainer;
    }
    set currentGroupButtonsContainer(value) {
      if (value && !this._currentGroupButtonsContainer || value && this._currentGroupButtonsContainer && this._currentGroupButtonsContainer.nativeElement !== value.nativeElement) {
        requestAnimationFrame(() => {
          this.scrollElementIntoView(value.nativeElement);
        });
      }
      this._currentGroupButtonsContainer = value;
    }
    /** @hidden */
    get currentGroupButtonsContainer() {
      return this._currentGroupButtonsContainer;
    }
    /**
     * Returns if the select entity dropdown at the root level is disabled after the initial selection.
     */
    get disableEntityChange() {
      return !this.parentExpression && this.selectedEntity ? this.queryBuilder.disableEntityChange : false;
    }
    /**
     * Returns if the fields combo at the root level is disabled.
     */
    get disableReturnFieldsChange() {
      return !this.selectedEntity || this.queryBuilder.disableReturnFieldsChange;
    }
    /**
     * Returns the current level.
     */
    get level() {
      let parent = this.elRef.nativeElement.parentElement;
      let _level = 0;
      while (parent) {
        if (parent.localName === 'igx-query-builder-tree') {
          _level++;
        }
        parent = parent.parentElement;
      }
      return _level;
    }
    /** @hidden */
    isAdvancedFiltering() {
      return this.entities?.length === 1 && !this.entities[0]?.name;
    }
    /** @hidden */
    isSearchValueInputDisabled() {
      return !this.selectedField || !this.selectedCondition || this.selectedField && (this.selectedField.filters.condition(this.selectedCondition).isUnary || this.selectedField.filters.condition(this.selectedCondition).isNestedQuery);
    }
    constructor(cdr, dragService, platform, elRef, _localeId) {
      this.cdr = cdr;
      this.dragService = dragService;
      this.platform = platform;
      this.elRef = elRef;
      this._localeId = _localeId;
      /**
       * Sets/gets the search value template.
       */
      this.searchValueTemplate = null;
      /**
       * Event fired as the expression tree is changed.
       */
      this.expressionTreeChange = new EventEmitter();
      /**
       * Event fired if a nested query builder tree is being edited.
       */
      this.inEditModeChange = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.selectedExpressions = [];
      /**
       * @hidden @internal
       */
      this.searchValue = {
        value: null
      };
      /**
       * @hidden @internal
       */
      this.initialOperator = 0;
      /**
       * @hidden @internal
       */
      this.returnFieldSelectOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      /**
       * @hidden @internal
       */
      this.entitySelectOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      /**
       * @hidden @internal
       */
      this.fieldSelectOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      /**
       * @hidden @internal
       */
      this.conditionSelectOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      /**
       * @hidden @internal
       */
      this.addExpressionDropDownOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      /**
       * @hidden @internal
       */
      this.groupContextMenuDropDownOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
      this.destroy$ = new Subject();
      this._focusDelay = DEFAULT_CHIP_FOCUS_DELAY;
      this._preventInit = false;
      this._expandedExpressions = [];
      this._resourceStrings = getCurrentResourceStrings(QueryBuilderResourceStringsEN);
      this._positionSettings = {
        horizontalStartPoint: HorizontalAlignment.Right,
        verticalStartPoint: VerticalAlignment.Top
      };
      this._overlaySettings = {
        closeOnOutsideClick: false,
        modal: false,
        positionStrategy: new ConnectedPositioningStrategy(this._positionSettings),
        scrollStrategy: new CloseScrollStrategy()
      };
      /**
       * @hidden @internal
       */
      this.deleteItem = (expressionItem, skipEmit = false) => {
        if (!expressionItem.parent) {
          this.rootGroup = null;
          this.currentGroup = null;
          //this._expressionTree = null;
          return;
        }
        if (expressionItem === this.currentGroup) {
          this.currentGroup = this.currentGroup.parent;
        }
        const children = expressionItem.parent.children;
        const index = children.indexOf(expressionItem);
        children.splice(index, 1);
        const entity = this.expressionTree ? this.expressionTree.entity : null;
        const returnFields = this.expressionTree ? this.expressionTree.returnFields : null;
        this._expressionTree = this.createExpressionTreeFromGroupItem(this.rootGroup, entity, returnFields); // TODO: don't recreate if not necessary
        if (!children.length) {
          this.deleteItem(expressionItem.parent, true);
        }
        if (!this.parentExpression && !skipEmit) {
          this.expressionTreeChange.emit(this._expressionTree);
        }
      };
      /**
       * @hidden @internal
       */
      this.focusChipAfterDrag = index => {
        this._lastFocusedChipIndex = index;
        this.focusEditedExpressionChip();
      };
      /** rootGroup is recreated after clicking Apply, which sets new expressionTree and calls init()*/
      this.trackExpressionItem = trackByIdentity;
      this.locale = this.locale || this._localeId;
      this.dragService.register(this, elRef);
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      this._overlaySettings.outlet = this.overlayOutlet;
      this.entitySelectOverlaySettings.outlet = this.overlayOutlet;
      this.fieldSelectOverlaySettings.outlet = this.overlayOutlet;
      this.conditionSelectOverlaySettings.outlet = this.overlayOutlet;
      this.returnFieldSelectOverlaySettings.outlet = this.overlayOutlet;
      this.addExpressionDropDownOverlaySettings.outlet = this.overlayOutlet;
      this.groupContextMenuDropDownOverlaySettings.outlet = this.overlayOutlet;
      // Trigger additional change detection cycle
      this.cdr.detectChanges();
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden @internal
     */
    set selectedEntity(value) {
      this._selectedEntity = this.entities?.find(el => el.name === value);
    }
    /**
     * @hidden @internal
     */
    get selectedEntity() {
      return this._selectedEntity;
    }
    /**
     * @hidden @internal
     */
    onEntitySelectChanging(event) {
      event.cancel = true;
      this._entityNewValue = event.newSelection.value;
      if (event.oldSelection.value && this.queryBuilder.showEntityChangeDialog) {
        this.entityChangeDialog.open();
      } else {
        this.onEntityChangeConfirm();
      }
    }
    /**
     * @hidden
     */
    onShowEntityChangeDialogChange(eventArgs) {
      this.queryBuilder.showEntityChangeDialog = !eventArgs.checked;
    }
    /**
     * @hidden
     */
    onEntityChangeCancel() {
      this.entityChangeDialog.close();
      this.entitySelect.close();
      this._entityNewValue = null;
    }
    /**
     * @hidden
     */
    onEntityChangeConfirm() {
      if (this._parentExpression) {
        this._expressionTree = this.createExpressionTreeFromGroupItem(this.createExpressionGroupItem(this._expressionTree));
      }
      this._selectedEntity = this._entityNewValue;
      if (!this._selectedEntity.fields) {
        this._selectedEntity.fields = [];
      }
      this.fields = this._entityNewValue ? this._entityNewValue.fields : [];
      this._selectedReturnFields = this.parentExpression ? [] : this._entityNewValue.fields?.map(f => f.field);
      if (this._expressionTree) {
        this._expressionTree.entity = this._entityNewValue.name;
        this._expressionTree.returnFields = [];
        this._expressionTree.filteringOperands = [];
        this._editedExpression = null;
        if (!this.parentExpression) {
          this.expressionTreeChange.emit(this._expressionTree);
        }
        this.rootGroup = null;
        this.currentGroup = this.rootGroup;
      }
      this._selectedField = null;
      this.selectedCondition = null;
      this.searchValue.value = null;
      this.entityChangeDialog.close();
      this.entitySelect.close();
      this._entityNewValue = null;
      this.innerQueryNewExpressionTree = null;
      this.initExpressionTree(this._selectedEntity.name, this.selectedReturnFields);
    }
    /**
     * @hidden @internal
     */
    set selectedReturnFields(value) {
      if (this._selectedReturnFields !== value) {
        this._selectedReturnFields = value;
        if (this._expressionTree && !this.parentExpression) {
          this._expressionTree.returnFields = value;
          this.expressionTreeChange.emit(this._expressionTree);
        }
      }
    }
    /**
     * @hidden @internal
     */
    get selectedReturnFields() {
      if (typeof this._selectedReturnFields == 'string') {
        return [this._selectedReturnFields];
      }
      return this._selectedReturnFields;
    }
    /**
     * @hidden @internal
     */
    set selectedField(value) {
      const oldValue = this._selectedField;
      if (this._selectedField !== value) {
        this._selectedField = value;
        this.selectDefaultCondition();
        if (oldValue && this._selectedField && this._selectedField.dataType !== oldValue.dataType) {
          this.searchValue.value = null;
          this.cdr.detectChanges();
        }
      }
    }
    /**
     * @hidden @internal
     */
    get selectedField() {
      return this._selectedField;
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    setPickerOutlet(outlet) {
      this.pickerOutlet = outlet;
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    get isContextMenuVisible() {
      return !this.groupContextMenuDropDown.collapsed;
    }
    /**
     * @hidden @internal
     */
    get hasEditedExpression() {
      return this._editedExpression !== undefined && this._editedExpression !== null;
    }
    /**
     * @hidden @internal
     */
    addCondition(parent, afterExpression, isUIInteraction) {
      this.cancelOperandAdd();
      const operandItem = new ExpressionOperandItem({
        fieldName: null,
        condition: null,
        conditionName: null,
        ignoreCase: true,
        searchVal: null
      }, parent);
      const groupItem = new ExpressionGroupItem(this.getOperator(null) ?? FilteringLogic.And, parent);
      this.contextualGroup = groupItem;
      this.initialOperator = null;
      this._lastFocusedChipIndex = this._lastFocusedChipIndex === undefined ? -1 : this._lastFocusedChipIndex;
      if (parent) {
        if (afterExpression) {
          const index = parent.children.indexOf(afterExpression);
          parent.children.splice(index + 1, 0, operandItem);
        } else {
          parent.children.push(operandItem);
        }
        this._lastFocusedChipIndex++;
      } else {
        this.rootGroup = groupItem;
        operandItem.parent = groupItem;
        this.rootGroup.children.push(operandItem);
        this._lastFocusedChipIndex = 0;
      }
      this._focusDelay = 250;
      if (isUIInteraction && !afterExpression) {
        this._lastFocusedChipIndex = this.expressionsChips.length;
        this._focusDelay = DEFAULT_CHIP_FOCUS_DELAY;
      }
      this.enterExpressionEdit(operandItem);
    }
    /**
     * @hidden @internal
     */
    addReverseGroup(parent, afterExpression) {
      parent = parent ?? this.rootGroup;
      if (parent.operator === FilteringLogic.And) {
        this.addGroup(FilteringLogic.Or, parent, afterExpression);
      } else {
        this.addGroup(FilteringLogic.And, parent, afterExpression);
      }
    }
    /**
     * @hidden @internal
     */
    endGroup(groupItem) {
      this.currentGroup = groupItem.parent;
    }
    /**
     * @hidden @internal
     */
    commitExpression() {
      this.commitOperandEdit();
      this.focusEditedExpressionChip();
    }
    /**
     * @hidden @internal
     */
    discardExpression(expressionItem) {
      this.cancelOperandEdit();
      if (expressionItem && expressionItem.expression.fieldName) {
        this.focusEditedExpressionChip();
      }
    }
    /**
     * @hidden @internal
     */
    commitOperandEdit() {
      const actualSearchValue = this.searchValue.value;
      if (this._editedExpression) {
        this._editedExpression.expression.fieldName = this.selectedField.field;
        this._editedExpression.expression.condition = this.selectedField.filters.condition(this.selectedCondition);
        this._editedExpression.expression.conditionName = this.selectedCondition;
        this._editedExpression.expression.searchVal = DataUtil.parseValue(this.selectedField.dataType, actualSearchValue) || actualSearchValue;
        this._editedExpression.fieldLabel = this.selectedField.label ? this.selectedField.label : this.selectedField.header ? this.selectedField.header : this.selectedField.field;
        const innerQuery = this.innerQueries.filter(q => q.isInEditMode())[0];
        if (innerQuery && this.selectedField?.filters?.condition(this.selectedCondition)?.isNestedQuery) {
          innerQuery.exitEditAddMode();
          this._editedExpression.expression.searchTree = this.getExpressionTreeCopy(innerQuery.expressionTree);
          this._editedExpression.expression.searchTree.returnFields = innerQuery.selectedReturnFields;
        } else {
          this._editedExpression.expression.searchTree = null;
        }
        this.innerQueryNewExpressionTree = null;
        if (this.selectedField.filters.condition(this.selectedCondition)?.isUnary || this.selectedField.filters.condition(this.selectedCondition)?.isNestedQuery) {
          this._editedExpression.expression.searchVal = null;
        }
        this._editedExpression.inEditMode = false;
        this._editedExpression = null;
      }
      this._expressionTree = this.createExpressionTreeFromGroupItem(this.rootGroup, this.selectedEntity?.name, this.selectedReturnFields);
      if (!this.parentExpression) {
        this.expressionTreeChange.emit(this._expressionTree);
      }
    }
    /**
     * @hidden @internal
     */
    cancelOperandAdd() {
      if (this._addModeExpression) {
        this._addModeExpression.inAddMode = false;
        this._addModeExpression = null;
      }
    }
    /**
     * @hidden @internal
     */
    cancelOperandEdit() {
      if (this.innerQueries) {
        const innerQuery = this.innerQueries.filter(q => q.isInEditMode())[0];
        if (innerQuery) {
          if (innerQuery._editedExpression) {
            innerQuery.cancelOperandEdit();
          }
          innerQuery.expressionTree = this.getExpressionTreeCopy(this._editedExpression.expression.searchTree);
          this.innerQueryNewExpressionTree = null;
        }
      }
      if (this._editedExpression) {
        this._editedExpression.inEditMode = false;
        if (!this._editedExpression.expression.fieldName) {
          this.deleteItem(this._editedExpression);
        }
        this._editedExpression = null;
      }
      if (!this.expressionTree && this.contextualGroup) {
        this.initialOperator = this.contextualGroup.operator;
      }
    }
    /**
     * @hidden @internal
     */
    operandCanBeCommitted() {
      const innerQuery = this.innerQueries.filter(q => q.isInEditMode())[0];
      return this.selectedField && this.selectedCondition && ((!Array.isArray(this.searchValue.value) && !!this.searchValue.value || Array.isArray(this.searchValue.value) && this.searchValue.value.length !== 0) && !this.selectedField?.filters?.condition(this.selectedCondition)?.isNestedQuery || this.selectedField?.filters?.condition(this.selectedCondition)?.isNestedQuery && innerQuery && !!innerQuery.expressionTree && innerQuery.selectedReturnFields?.length > 0 || this.selectedField.filters.condition(this.selectedCondition)?.isUnary);
    }
    /**
     * @hidden @internal
     */
    canCommitCurrentState() {
      const innerQuery = this.innerQueries.filter(q => q.isInEditMode())[0];
      if (innerQuery) {
        return this.selectedReturnFields?.length > 0 && innerQuery.canCommitCurrentState();
      } else {
        return this.selectedReturnFields?.length > 0 && (!this._editedExpression ||
        // no edited expr
        this._editedExpression && !this.selectedField ||
        // empty edited expr
        this._editedExpression && this.operandCanBeCommitted() === true // valid edited expr
        );
      }
    }
    /**
     * @hidden @internal
     */
    commitCurrentState() {
      const innerQuery = this.innerQueries.filter(q => q.isInEditMode())[0];
      if (innerQuery) {
        innerQuery.commitCurrentState();
      }
      if (this._editedExpression) {
        if (this.selectedField) {
          this.commitOperandEdit();
        } else {
          this.deleteItem(this._editedExpression);
          this._editedExpression = null;
        }
      }
    }
    /**
     * @hidden @internal
     */
    exitEditAddMode(shouldPreventInit = false) {
      if (!this._editedExpression) {
        return;
      }
      this.exitOperandEdit();
      this.cancelOperandAdd();
      if (shouldPreventInit) {
        this._preventInit = true;
      }
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    exitOperandEdit() {
      if (!this._editedExpression) {
        return;
      }
      if (this.operandCanBeCommitted()) {
        this.commitOperandEdit();
      } else {
        this.cancelOperandEdit();
      }
    }
    /**
     * @hidden @internal
     */
    isExpressionGroup(expression) {
      return expression instanceof ExpressionGroupItem;
    }
    /**
     * @hidden @internal
     */
    onExpressionFocus(expressionItem) {
      if (this.prevFocusedExpression) {
        this.prevFocusedExpression.focused = false;
      }
      expressionItem.focused = true;
      this.prevFocusedExpression = expressionItem;
    }
    /**
     * @hidden @internal
     */
    onExpressionBlur(event, expressionItem) {
      if (this._prevFocusedContainer && this._prevFocusedContainer !== event.target.closest('.igx-filter-tree__expression-item')) {
        expressionItem.focused = false;
      }
      this._prevFocusedContainer = event.target.closest('.igx-filter-tree__expression-item');
    }
    /**
     * @hidden @internal
     */
    onChipRemove(expressionItem) {
      this.exitEditAddMode();
      this.deleteItem(expressionItem);
    }
    /**
     * @hidden @internal
     */
    addExpressionBlur() {
      if (this.prevFocusedExpression) {
        this.prevFocusedExpression.focused = false;
      }
      if (this.addExpressionItemDropDown && !this.addExpressionItemDropDown.collapsed) {
        this.addExpressionItemDropDown.close();
      }
    }
    /**
     * @hidden @internal
     */
    onChipClick(expressionItem, chip) {
      this.enterExpressionEdit(expressionItem, chip);
    }
    /**
     * @hidden @internal
     */
    enterExpressionEdit(expressionItem, chip) {
      this.exitEditAddMode(true);
      this.cdr.detectChanges();
      this._lastFocusedChipIndex = chip ? this.expressionsChips.toArray().findIndex(expr => expr === chip) : this._lastFocusedChipIndex;
      this.enterEditMode(expressionItem);
    }
    /**
     * @hidden @internal
     */
    clickExpressionAdd(targetButton, chip) {
      this.exitEditAddMode(true);
      this.cdr.detectChanges();
      this._lastFocusedChipIndex = this.expressionsChips.toArray().findIndex(expr => expr === chip);
      this.openExpressionAddDialog(targetButton);
    }
    /**
     * @hidden @internal
     */
    openExpressionAddDialog(targetButton) {
      this.addExpressionDropDownOverlaySettings.target = targetButton;
      this.addExpressionDropDownOverlaySettings.positionStrategy = new ConnectedPositioningStrategy({
        horizontalDirection: HorizontalAlignment.Right,
        horizontalStartPoint: HorizontalAlignment.Left,
        verticalStartPoint: VerticalAlignment.Bottom
      });
      this.addExpressionItemDropDown.open(this.addExpressionDropDownOverlaySettings);
    }
    /**
     * @hidden @internal
     */
    enterExpressionAdd(event, expressionItem) {
      if (this._addModeExpression) {
        this._addModeExpression.inAddMode = false;
      }
      if (this.parentExpression) {
        this.inEditModeChange.emit(this.parentExpression);
      }
      const parent = expressionItem.parent ?? this.rootGroup;
      requestAnimationFrame(() => {
        if (event.newSelection.value === 'addCondition') {
          this.addCondition(parent, expressionItem);
        } else if (event.newSelection.value === 'addGroup') {
          this.addReverseGroup(parent, expressionItem);
        }
        expressionItem.inAddMode = true;
        this._addModeExpression = expressionItem;
      });
    }
    /**
     * @hidden @internal
     */
    enterEditMode(expressionItem) {
      if (this._editedExpression) {
        this._editedExpression.inEditMode = false;
      }
      if (this.parentExpression) {
        this.inEditModeChange.emit(this.parentExpression);
      }
      expressionItem.hovered = false;
      this.fields = this.selectedEntity ? this.selectedEntity.fields : null;
      this.selectedField = expressionItem.expression.fieldName ? this.fields?.find(field => field.field === expressionItem.expression.fieldName) : null;
      this.selectedCondition = expressionItem.expression.condition ? expressionItem.expression.condition.name : null;
      this.searchValue.value = expressionItem.expression.searchVal instanceof Set ? Array.from(expressionItem.expression.searchVal) : expressionItem.expression.searchVal;
      expressionItem.inEditMode = true;
      this._editedExpression = expressionItem;
      this.cdr.detectChanges();
      this.entitySelectOverlaySettings.target = this.entitySelect.element;
      this.entitySelectOverlaySettings.excludeFromOutsideClick = [this.entitySelect.element];
      this.entitySelectOverlaySettings.positionStrategy = new AutoPositionStrategy();
      if (this.returnFieldSelect) {
        this.returnFieldSelectOverlaySettings.target = this.returnFieldSelect.element;
        this.returnFieldSelectOverlaySettings.excludeFromOutsideClick = [this.returnFieldSelect.element];
        this.returnFieldSelectOverlaySettings.positionStrategy = new AutoPositionStrategy();
      }
      if (this.fieldSelect) {
        this.fieldSelectOverlaySettings.target = this.fieldSelect.element;
        this.fieldSelectOverlaySettings.excludeFromOutsideClick = [this.fieldSelect.element];
        this.fieldSelectOverlaySettings.positionStrategy = new AutoPositionStrategy();
      }
      if (this.conditionSelect) {
        this.conditionSelectOverlaySettings.target = this.conditionSelect.element;
        this.conditionSelectOverlaySettings.excludeFromOutsideClick = [this.conditionSelect.element];
        this.conditionSelectOverlaySettings.positionStrategy = new AutoPositionStrategy();
      }
      if (!this.selectedField) {
        this.fieldSelect.input.nativeElement.focus();
      } else if (this.selectedField.filters.condition(this.selectedCondition)?.isUnary) {
        this.conditionSelect.input.nativeElement.focus();
      } else {
        const input = this.searchValueInput?.nativeElement || this.picker?.getEditElement();
        input?.focus();
      }
      this.editingInputs?.nativeElement.parentElement?.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    }
    /**
     * @hidden @internal
     */
    onConditionSelectChanging(event) {
      event.cancel = true;
      this.selectedCondition = event.newSelection.value;
      this.conditionSelect.close();
      this.cdr.detectChanges();
    }
    /**
     * @hidden @internal
     */
    onKeyDown(eventArgs) {
      eventArgs.stopPropagation();
    }
    /**
     * @hidden @internal
     */
    onGroupClick(groupContextMenuDropDown, targetButton, groupItem) {
      this.exitEditAddMode();
      this.cdr.detectChanges();
      this.groupContextMenuDropDown = groupContextMenuDropDown;
      this.groupContextMenuDropDownOverlaySettings.target = targetButton;
      this.groupContextMenuDropDownOverlaySettings.positionStrategy = new ConnectedPositioningStrategy({
        horizontalDirection: HorizontalAlignment.Right,
        horizontalStartPoint: HorizontalAlignment.Left,
        verticalStartPoint: VerticalAlignment.Bottom
      });
      if (groupContextMenuDropDown.collapsed) {
        this.contextualGroup = groupItem;
        groupContextMenuDropDown.open(this.groupContextMenuDropDownOverlaySettings);
      } else {
        groupContextMenuDropDown.close();
      }
    }
    /**
     * @hidden @internal
     */
    getOperator(expressionItem) {
      // if (!expressionItem && !this.expressionTree && !this.initialOperator) {
      //     this.initialOperator = 0;
      // }
      const operator = expressionItem ? expressionItem.operator : this.expressionTree ? this.expressionTree.operator : this.initialOperator;
      return operator;
    }
    /**
     * @hidden @internal
     */
    getSwitchGroupText(expressionItem) {
      const operator = this.getOperator(expressionItem);
      const condition = operator === FilteringLogic.Or ? this.resourceStrings.igx_query_builder_and_label : this.resourceStrings.igx_query_builder_or_label;
      return this.resourceStrings.igx_query_builder_switch_group.replace('{0}', condition.toUpperCase());
    }
    /**
     * @hidden @internal
     */
    onGroupContextMenuDropDownSelectionChanging(event) {
      event.cancel = true;
      if (event.newSelection.value === 'switchCondition') {
        const newOperator = (!this.expressionTree ? this.initialOperator : (this.contextualGroup ?? this._expressionTree).operator) === 0 ? 1 : 0;
        this.selectFilteringLogic(newOperator);
      } else if (event.newSelection.value === 'ungroup') {
        this.ungroup();
      }
      this.groupContextMenuDropDown.close();
    }
    /**
     * @hidden @internal
     */
    ungroup() {
      const selectedGroup = this.contextualGroup;
      const parent = selectedGroup.parent;
      if (parent) {
        const index = parent.children.indexOf(selectedGroup);
        parent.children.splice(index, 1, ...selectedGroup.children);
        for (const expr of selectedGroup.children) {
          expr.parent = parent;
        }
      }
      this.commitOperandEdit();
    }
    /**
     * @hidden @internal
     */
    selectFilteringLogic(index) {
      if (!this.expressionTree) {
        this.initialOperator = index;
        return;
      }
      if (this.contextualGroup) {
        this.contextualGroup.operator = index;
        this.commitOperandEdit();
      } else if (this.expressionTree) {
        this._expressionTree.operator = index;
      }
      this.initialOperator = null;
    }
    /**
     * @hidden @internal
     */
    getConditionFriendlyName(name) {
      // As we have an 'In' condition already used in ESF to search in a Set, we add the 'Query' suffix to the newly introduced nested query condition names.
      // So instead of in/notIn we end up with 'inQuery'/'notInQuery', hence removing the suffix from the friendly name.
      return this.resourceStrings[`igx_query_builder_filter_${name?.replace('Query', '')}`] || name;
    }
    /**
     * @hidden @internal
     */
    isDate(value) {
      return value instanceof Date;
    }
    /**
     * @hidden @internal
     */
    invokeClick(eventArgs) {
      if (!this.dragService.dropGhostExpression && this.platform.isActivationKey(eventArgs)) {
        eventArgs.preventDefault();
        eventArgs.currentTarget.click();
      }
    }
    /**
     * @hidden @internal
     */
    openPicker(args) {
      if (this.platform.isActivationKey(args)) {
        args.preventDefault();
        this.picker.open();
      }
    }
    /**
     * @hidden @internal
     */
    onOutletPointerDown(event) {
      // This prevents closing the select's dropdown when clicking the scroll
      event.preventDefault();
    }
    /**
     * @hidden @internal
     */
    getConditionList() {
      if (!this.selectedField) return [];
      if (this.entities?.length === 1 && !this.entities[0].name) {
        return this.selectedField.filters.conditionList();
      }
      return this.selectedField.filters.extendedConditionList();
    }
    /**
     * @hidden @internal
     */
    getFormatter(field) {
      return this.fields?.find(el => el.field === field)?.formatter;
    }
    /**
     * @hidden @internal
     */
    getFormat(field) {
      return this.fields?.find(el => el.field === field).pipeArgs.format;
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    setAddButtonFocus() {
      if (this.addRootAndGroupButton) {
        this.addRootAndGroupButton.nativeElement.focus();
      } else if (this.addConditionButton) {
        this.addConditionButton.nativeElement.focus();
      }
    }
    /**
     * @hidden @internal
     */
    context(expression, afterExpression) {
      return {
        $implicit: expression,
        afterExpression
      };
    }
    formatReturnFields(innerTree) {
      const returnFields = innerTree.returnFields;
      let text = returnFields.join(', ');
      const innerTreeEntity = this.entities?.find(el => el.name === innerTree.entity);
      if (returnFields.length === innerTreeEntity?.fields.length) {
        text = this.resourceStrings.igx_query_builder_all_fields;
      } else {
        text = returnFields.join(', ');
        text = text.length > 25 ? text.substring(0, 25) + ' ...' : text;
      }
      return text;
    }
    isInEditMode() {
      return !this.parentExpression || this.parentExpression && this.parentExpression.inEditMode;
    }
    onInEditModeChanged(expressionItem) {
      if (!expressionItem.inEditMode) {
        this.enterExpressionEdit(expressionItem);
      }
    }
    getExpressionTreeCopy(expressionTree, shouldAssignInnerQueryExprTree) {
      if (!expressionTree) {
        return null;
      }
      const exprTreeCopy = new FilteringExpressionsTree(expressionTree.operator, expressionTree.fieldName, expressionTree.entity, expressionTree.returnFields);
      exprTreeCopy.filteringOperands = [];
      expressionTree.filteringOperands.forEach(o => isTree(o) ? exprTreeCopy.filteringOperands.push(this.getExpressionTreeCopy(o)) : exprTreeCopy.filteringOperands.push(o));
      if (!this.innerQueryNewExpressionTree && shouldAssignInnerQueryExprTree) {
        this.innerQueryNewExpressionTree = exprTreeCopy;
      }
      return exprTreeCopy;
    }
    onSelectAllClicked() {
      if (this._selectedReturnFields.length > 0 && this._selectedReturnFields.length < this._selectedEntity.fields.length || this._selectedReturnFields.length == this._selectedEntity.fields.length) {
        this.returnFieldsCombo.deselectAllItems();
      } else {
        this.returnFieldsCombo.selectAllItems();
      }
    }
    onReturnFieldSelectChanging(event) {
      let newSelection = [];
      if (Array.isArray(event.newSelection)) {
        newSelection = event.newSelection.map(item => item.field);
      } else {
        newSelection.push(event.newSelection.value);
        this._selectedReturnFields = newSelection;
      }
      this.initExpressionTree(this.selectedEntity.name, newSelection);
    }
    initExpressionTree(selectedEntityName, selectedReturnFields) {
      if (!this._expressionTree) {
        this._expressionTree = this.createExpressionTreeFromGroupItem(new ExpressionGroupItem(FilteringLogic.And, this.rootGroup), selectedEntityName, selectedReturnFields);
      }
      if (!this.parentExpression) {
        this.expressionTreeChange.emit(this._expressionTree);
      }
    }
    getSearchValueTemplateContext(defaultSearchValueTemplate) {
      const ctx = {
        $implicit: this.searchValue,
        selectedField: this.selectedField,
        selectedCondition: this.selectedCondition,
        defaultSearchValueTemplate: defaultSearchValueTemplate
      };
      return ctx;
    }
    setFormat(field) {
      if (!field.pipeArgs) {
        field.pipeArgs = {
          digitsInfo: DEFAULT_PIPE_DIGITS_INFO
        };
      }
      if (!field.pipeArgs.format) {
        field.pipeArgs.format = field.dataType === DataType.Time ? DEFAULT_PIPE_TIME_FORMAT : field.dataType === DataType.DateTime ? DEFAULT_PIPE_DATE_TIME_FORMAT : DEFAULT_PIPE_DATE_FORMAT;
      }
    }
    selectDefaultCondition() {
      if (this.selectedField && this.selectedField.filters) {
        this.selectedCondition = this.selectedField.filters.conditionList().indexOf('equals') >= 0 ? 'equals' : this.selectedField.filters.conditionList()[0];
      }
    }
    setFilters(field) {
      if (!field.filters) {
        switch (field.dataType) {
          case DataType.Boolean:
            field.filters = IgxBooleanFilteringOperand.instance();
            break;
          case DataType.Number:
          case DataType.Currency:
          case DataType.Percent:
            field.filters = IgxNumberFilteringOperand.instance();
            break;
          case DataType.Date:
            field.filters = IgxDateFilteringOperand.instance();
            break;
          case DataType.Time:
            field.filters = IgxTimeFilteringOperand.instance();
            break;
          case DataType.DateTime:
            field.filters = IgxDateTimeFilteringOperand.instance();
            break;
          case DataType.String:
          default:
            field.filters = IgxStringFilteringOperand.instance();
            break;
        }
      }
    }
    addGroup(operator, parent, afterExpression) {
      this.cancelOperandAdd();
      const groupItem = new ExpressionGroupItem(operator, parent);
      if (parent) {
        if (afterExpression) {
          const index = parent.children.indexOf(afterExpression);
          parent.children.splice(index + 1, 0, groupItem);
        } else {
          parent.children.push(groupItem);
        }
      } else {
        this.rootGroup = groupItem;
      }
      this.addCondition(groupItem);
      this.currentGroup = groupItem;
    }
    createExpressionGroupItem(expressionTree, parent, entityName) {
      let groupItem;
      if (expressionTree) {
        groupItem = new ExpressionGroupItem(expressionTree.operator, parent);
        if (!expressionTree.filteringOperands) {
          return groupItem;
        }
        for (let i = 0; i < expressionTree.filteringOperands.length; i++) {
          const expr = expressionTree.filteringOperands[i];
          if (isTree(expr)) {
            groupItem.children.push(this.createExpressionGroupItem(expr, groupItem, expressionTree.entity));
          } else {
            const filteringExpr = expr;
            const exprCopy = {
              fieldName: filteringExpr.fieldName,
              condition: filteringExpr.condition,
              conditionName: filteringExpr.condition?.name || filteringExpr.conditionName,
              searchVal: filteringExpr.searchVal,
              searchTree: filteringExpr.searchTree,
              ignoreCase: filteringExpr.ignoreCase
            };
            const operandItem = new ExpressionOperandItem(exprCopy, groupItem);
            const field = this.fields?.find(el => el.field === filteringExpr.fieldName);
            operandItem.fieldLabel = field?.label || field?.header || field?.field;
            if (this._expandedExpressions.filter(e => e.searchTree == operandItem.expression.searchTree).length > 0) {
              operandItem.expanded = true;
            }
            groupItem.children.push(operandItem);
          }
        }
        if (expressionTree.entity) {
          entityName = expressionTree.entity;
        }
        const entity = this.entities?.find(el => el.name === entityName);
        if (entity) {
          this.fields = entity.fields;
        }
        this._selectedEntity = this.entities?.find(el => el.name === entityName);
        this._selectedReturnFields = !expressionTree.returnFields || expressionTree.returnFields.includes('*') || expressionTree.returnFields.includes('All') || expressionTree.returnFields.length === 0 ? this.fields?.map(f => f.field) : this.fields?.filter(f => expressionTree.returnFields.indexOf(f.field) >= 0).map(f => f.field);
      }
      return groupItem;
    }
    createExpressionTreeFromGroupItem(groupItem, entity, returnFields) {
      if (!groupItem) {
        return null;
      }
      const expressionTree = new FilteringExpressionsTree(groupItem.operator, undefined, entity, returnFields);
      for (let i = 0; i < groupItem.children.length; i++) {
        const item = groupItem.children[i];
        if (item instanceof ExpressionGroupItem) {
          const subTree = this.createExpressionTreeFromGroupItem(item, entity, returnFields);
          expressionTree.filteringOperands.push(subTree);
        } else {
          expressionTree.filteringOperands.push(item.expression);
        }
      }
      return expressionTree;
    }
    scrollElementIntoView(target) {
      const container = this.expressionsContainer.nativeElement;
      const targetOffset = target.offsetTop - container.offsetTop;
      const delta = 10;
      if (container.scrollTop + delta > targetOffset) {
        container.scrollTop = targetOffset - delta;
      } else if (container.scrollTop + container.clientHeight < targetOffset + target.offsetHeight + delta) {
        container.scrollTop = targetOffset + target.offsetHeight + delta - container.clientHeight;
      }
    }
    focusEditedExpressionChip() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
      this._timeoutId = setTimeout(() => {
        if (this._lastFocusedChipIndex != -1) {
          //Sort the expression chip list.
          //If there was a recent drag&drop and the tree hasn't rerendered(child query), they will be unordered
          const sortedChips = this.expressionsChips.toArray().sort(function (a, b) {
            if (a === b) return 0;
            if (a.chipArea.nativeElement.compareDocumentPosition(b.chipArea.nativeElement) & 2) {
              // b comes before a
              return 1;
            }
            return -1;
          });
          const chipElement = sortedChips[this._lastFocusedChipIndex]?.nativeElement;
          if (chipElement) {
            chipElement.focus();
          }
          this._lastFocusedChipIndex = -1;
          this._focusDelay = DEFAULT_CHIP_FOCUS_DELAY;
        }
      }, this._focusDelay);
    }
    init() {
      this.cancelOperandAdd();
      this.cancelOperandEdit();
      // Ignore values of certain properties for the comparison
      const propsToIgnore = ['parent', 'hovered', 'ignoreCase', 'inEditMode', 'inAddMode'];
      const propsReplacer = function replacer(key, value) {
        if (propsToIgnore.indexOf(key) >= 0) {
          return undefined;
        } else {
          return value;
        }
      };
      // Skip root being recreated if the same
      const newRootGroup = this.createExpressionGroupItem(this.expressionTree);
      if (JSON.stringify(this.rootGroup, propsReplacer) !== JSON.stringify(newRootGroup, propsReplacer)) {
        this.rootGroup = this.createExpressionGroupItem(this.expressionTree);
        this.currentGroup = this.rootGroup;
      }
      if (this.rootGroup?.children?.length == 0) {
        this.rootGroup = null;
        this.currentGroup = null;
      }
    }
    static {
      this.ɵfac = function IgxQueryBuilderTreeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderTreeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxQueryBuilderDragService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LOCALE_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxQueryBuilderTreeComponent,
        selectors: [["igx-query-builder-tree"]],
        viewQuery: function IgxQueryBuilderTreeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c88, 5, IgxSelectComponent);
            i0.ɵɵviewQuery(_c89, 5, ElementRef);
            i0.ɵɵviewQuery(_c90, 5, IgxComboComponent);
            i0.ɵɵviewQuery(_c91, 5, IgxSelectComponent);
            i0.ɵɵviewQuery(_c92, 5, IgxSelectComponent);
            i0.ɵɵviewQuery(_c93, 5, IgxSelectComponent);
            i0.ɵɵviewQuery(_c94, 5, ElementRef);
            i0.ɵɵviewQuery(_c95, 5);
            i0.ɵɵviewQuery(_c96, 5, ElementRef);
            i0.ɵɵviewQuery(_c97, 5, ElementRef);
            i0.ɵɵviewQuery(_c98, 5, IgxDialogComponent);
            i0.ɵɵviewQuery(_c99, 5, IgxDropDownComponent);
            i0.ɵɵviewQuery(_c100, 5, IgxDropDownComponent);
            i0.ɵɵviewQuery(_c101, 5, ElementRef);
            i0.ɵɵviewQuery(_c102, 5, ElementRef);
            i0.ɵɵviewQuery(_c103, 5);
            i0.ɵɵviewQuery(_c104, 7, IgxOverlayOutletDirective);
            i0.ɵɵviewQuery(IgxChipComponent, 5, IgxChipComponent);
            i0.ɵɵviewQuery(IgxQueryBuilderTreeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entitySelect = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editingInputs = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.returnFieldsCombo = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.returnFieldSelect = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldSelect = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.conditionSelect = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchValueInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addRootAndGroupButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addConditionButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.entityChangeDialog = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addExpressionItemDropDown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupContextMenuDropDown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editingInputsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.currentGroupButtonsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expressionsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayOutlet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expressionsChips = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.innerQueries = _t);
          }
        },
        hostAttrs: [1, "igx-query-builder-tree"],
        hostVars: 2,
        hostBindings: function IgxQueryBuilderTreeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.getClass);
          }
        },
        inputs: {
          entities: "entities",
          queryBuilder: "queryBuilder",
          searchValueTemplate: "searchValueTemplate",
          parentExpression: "parentExpression",
          fields: "fields",
          expressionTree: "expressionTree",
          locale: "locale",
          resourceStrings: "resourceStrings"
        },
        outputs: {
          expressionTreeChange: "expressionTreeChange",
          inEditModeChange: "inEditModeChange"
        },
        features: [i0.ɵɵProvidersFeature([IgxQueryBuilderDragService])],
        decls: 25,
        vars: 9,
        consts: [["addIcon", ""], ["closeIcon", ""], ["selectFromTemplate", ""], ["expressionsContainer", ""], ["addExpressionsTemplate", ""], ["operandTemplate", ""], ["expressionGroupTemplate", ""], ["overlayOutlet", ""], ["entityChangeDialog", ""], ["entitySelect", ""], ["returnFieldsCombo", ""], ["returnFieldSelect", ""], ["addConditionButton", ""], ["editingInputsContainer", ""], ["dragRef", ""], ["expressionChip", "", "target", "tooltipTarget"], ["tooltipRef", "tooltip"], ["addExpressionButton", ""], ["addOptionsDropDown", ""], ["editingInputs", ""], ["fieldSelect", ""], ["conditionSelect", ""], ["defaultSearchValueTemplate", ""], ["searchValueInput", ""], ["picker", ""], ["inputGroup", ""], ["input", ""], ["groupRef", ""], ["changeGroupButton", ""], ["groupContextMenuDropDown", ""], ["currentGroupButtonsContainer", ""], [1, "igx-query-builder__main"], [4, "ngTemplateOutlet"], [1, "igx-filter-tree__section"], ["igxOverlayOutlet", "", 1, "igx-query-builder__outlet", 3, "pointerdown"], [3, "leftButtonSelect", "rightButtonSelect", "title", "leftButtonLabel", "rightButtonLabel"], [1, "igx-query-builder-dialog"], [3, "change", "disableRipple", "tabindex"], ["family", "default", "name", "add"], ["family", "default", "name", "close"], [1, "igx-filter-tree__inputs"], [1, "igx-filter-tree__inputs-field"], [1, "igx-query-builder__label"], ["type", "box", 3, "selectionChanging", "opening", "overlaySettings", "ngModel", "placeholder", "disabled"], [3, "value"], [3, "itemsMaxHeight", "data", "displayKey", "valueKey", "disabled", "ngModel", "overlaySettings", "placeholder", "searchPlaceholder", "display"], ["type", "box", 3, "overlaySettings", "disabled", "ngModel", "placeholder", "display"], [3, "ngModelChange", "selectionChanging", "opening", "itemsMaxHeight", "data", "displayKey", "valueKey", "disabled", "ngModel", "overlaySettings", "placeholder", "searchPlaceholder"], ["igxComboHeader", ""], [1, "igx-drop-down__item", "igx-drop-down__item--query-builder", 3, "click", "ngClass"], [1, "igx-combo__checkbox", 3, "checked", "indeterminate", "readonly", "disableRipple", "tabindex"], [1, "igx-drop-down__inner"], ["type", "box", 3, "selectionChanging", "opening", "overlaySettings", "disabled", "ngModel", "placeholder"], ["type", "button", "igxButton", "flat", "igxDrop", "", 3, "click", "enter", "leave", "disabled"], ["type", "button", "igxButton", "flat", 3, "disabled"], ["type", "button", "igxButton", "flat", 3, "click", "disabled"], [1, "igx-filter-tree__subquery"], ["igxDrop", "", 1, "igx-filter-tree__inputs"], [1, "igx-filter-tree__expression-item", "igx-filter-tree__expression-item-drop-ghost"], ["igxDrop", "", 3, "ngClass"], [3, "data"], ["igxDrop", "", 3, "enter", "over", "leave", "dropped", "mouseenter", "mouseleave", "focusin", "focusout", "ngClass"], [3, "moveStart", "moveEnd", "dragEnter", "dragOver", "dragLeave", "dragDrop", "keydown", "click", "remove", "draggable", "hideBaseOnDrag", "animateOnRelease", "igxTooltipTarget", "data", "removable"], ["igxPrefix", "", "tabindex", "0", "family", "default", "name", "drag_indicator", 1, "igx-drag-indicator", 3, "focus", "focusout"], ["igxPrefix", "", 1, "igx-filter-tree__expression-column"], ["igxPrefix", "", 1, "igx-filter-tree__expression-condition"], ["igxTooltip", ""], ["igxDragIgnore", "", 1, "igx-filter-tree__expression-actions"], ["igxDragIgnore", "", "igxIconButton", "outlined", "aria-labelledby", "add-expression", 3, "keydown", "click", "blur", "igxDropDownItemNavigation"], ["id", "add-expression", "family", "default", "name", "add"], [3, "selectionChanging"], ["igxDrop", "", 1, "igx-filter-tree__inputs", 3, "enter", "over", "leave", "dropped"], ["type", "box", 3, "ngModelChange", "overlaySettings", "ngModel", "disabled", "placeholder"], ["type", "box", 3, "ngModelChange", "selectionChanging", "overlaySettings", "ngModel", "disabled", "placeholder"], [3, "value", "text"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-filter-tree__inputs-actions"], ["type", "button", "igxIconButton", "outlined", 3, "click", "disabled"], ["family", "default", "name", "confirm"], ["type", "button", "igxIconButton", "outlined", 3, "click"], ["family", "default", 3, "name"], [1, "igx-grid__filtering-dropdown-items"], [1, "igx-grid__filtering-dropdown-text"], ["type", "box"], ["type", "box", 3, "value", "readOnly", "disabled", "locale", "outlet", "formatter", "displayFormat", "weekStart", "placeholder"], ["type", "box", 3, "value", "readOnly", "disabled", "locale", "outlet", "formatter", "displayFormat", "inputFormat", "placeholder"], ["igxInput", "", 3, "ngModelChange", "disabled", "placeholder", "type", "ngModel"], ["type", "box", 3, "valueChange", "keydown", "click", "value", "readOnly", "disabled", "locale", "outlet", "formatter", "displayFormat", "weekStart", "placeholder"], ["type", "box", 3, "valueChange", "click", "keydown", "value", "readOnly", "disabled", "locale", "outlet", "formatter", "displayFormat", "inputFormat", "placeholder"], ["igxInput", "", "tabindex", "0", 3, "ngModelChange", "placeholder", "ngModel", "disabled", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat"], [3, "inEditModeChange", "entities", "queryBuilder", "parentExpression", "expressionTree", "searchValueTemplate"], [1, "igx-filter-tree", 3, "focusout"], [1, "igx-filter-tree__line", 3, "ngClass"], [1, "igx-filter-tree__expressions"], ["igxDrop", "", 1, "igx-filter-tree__expression-context-menu", 3, "enter", "over", "leave"], ["igxDragIgnore", "", "igxButton", "flat", "aria-labelledby", "change-group", 3, "keydown", "click", "ngClass", "igxDropDownItemNavigation"], ["igxDrop", "", 3, "enter", "over", "leave"], ["family", "default", "name", "arrow_drop_down", "role", "button"], [3, "selectionChanging", "width"], [3, "value", "disabled"], [1, "igx-filter-tree__expression-section"], [1, "igx-filter-tree__buttons"]],
        template: function IgxQueryBuilderTreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, IgxQueryBuilderTreeComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxQueryBuilderTreeComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxQueryBuilderTreeComponent_ng_template_4_Template, 13, 9, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "div", 31, 3);
            i0.ɵɵtemplate(8, IgxQueryBuilderTreeComponent_ng_container_8_Template, 1, 0, "ng-container", 32)(9, IgxQueryBuilderTreeComponent_ng_template_9_Template, 6, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(11, IgxQueryBuilderTreeComponent_ng_template_11_Template, 5, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(13, IgxQueryBuilderTreeComponent_ng_template_13_Template, 20, 17, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(15, IgxQueryBuilderTreeComponent_Conditional_15_Template, 3, 3, "div", 33);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 34, 7);
            i0.ɵɵlistener("pointerdown", function IgxQueryBuilderTreeComponent_Template_div_pointerdown_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOutletPointerDown($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "igx-dialog", 35, 8);
            i0.ɵɵlistener("leftButtonSelect", function IgxQueryBuilderTreeComponent_Template_igx_dialog_leftButtonSelect_18_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onEntityChangeCancel());
            })("rightButtonSelect", function IgxQueryBuilderTreeComponent_Template_igx_dialog_rightButtonSelect_18_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onEntityChangeConfirm());
            });
            i0.ɵɵelementStart(20, "section", 36)(21, "p");
            i0.ɵɵtext(22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "igx-checkbox", 37);
            i0.ɵɵlistener("change", function IgxQueryBuilderTreeComponent_Template_igx_checkbox_change_23_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onShowEntityChangeDialogChange($event));
            });
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const selectFromTemplate_r48 = i0.ɵɵreference(5);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngTemplateOutlet", selectFromTemplate_r48);
            i0.ɵɵadvance(7);
            i0.ɵɵconditional(ctx.rootGroup || !ctx.rootGroup && (ctx.selectedEntity || (ctx.entities == null ? null : ctx.entities.length) === 1 && !(ctx.entities[0] == null ? null : ctx.entities[0].name)) ? 15 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("title", ctx.resourceStrings.igx_query_builder_dialog_title);
            i0.ɵɵpropertyInterpolate("leftButtonLabel", ctx.resourceStrings.igx_query_builder_dialog_cancel);
            i0.ɵɵpropertyInterpolate("rightButtonLabel", ctx.resourceStrings.igx_query_builder_dialog_confirm);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.resourceStrings.igx_query_builder_dialog_message);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disableRipple", true)("tabindex", -1);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.resourceStrings.igx_query_builder_dialog_checkbox_text, " ");
          }
        },
        dependencies: [IgxQueryBuilderTreeComponent, DatePipe, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IgxButtonDirective, IgxCheckboxComponent, IgxChipComponent, IgxComboComponent, IgxComboHeaderDirective, IgxDatePickerComponent, IgxDateTimeEditorDirective, IgxDialogComponent, IgxDragIgnoreDirective, IgxDropDirective, IgxDropDownComponent, IgxDropDownItemComponent, IgxDropDownItemNavigationDirective, IgxFieldFormatterPipe, IgxIconButtonDirective, IgxIconComponent, IgxInputDirective, IgxInputGroupComponent, IgxOverlayOutletDirective, IgxPickerClearComponent, IgxPickerToggleComponent, IgxPrefixDirective, IgxSelectComponent, IgxSelectItemComponent, IgxTimePickerComponent, IgxTooltipDirective, IgxTooltipTargetDirective, NgClass, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxQueryBuilderTreeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Defines the custom template that will be used for the search value input of condition in edit mode
 *
 * @igxModule IgxQueryBuilderModule
 * @igxKeywords query builder, query builder search value
 * @igxGroup Data entry and display
 *
 * @example
 * <igx-query-builder>
 *      <ng-template igxQueryBuilderSearchValue let-expression="expression">
 *          <input type="text" required [(ngModel)]="expression.searchVal"/>
 *      </ng-template>
 *  </igx-query-builder>
 */
let IgxQueryBuilderSearchValueTemplateDirective = /*#__PURE__*/(() => {
  class IgxQueryBuilderSearchValueTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxQueryBuilderSearchValueTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderSearchValueTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxQueryBuilderSearchValueTemplateDirective,
        selectors: [["", "igxQueryBuilderSearchValue", ""]]
      });
    }
  }
  return IgxQueryBuilderSearchValueTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for operating with complex filters by creating or editing conditions
 * and grouping them using AND/OR logic.
 * It is used internally in the Advanced Filtering of the Grid.
 *
 * @example
 * ```html
 * <igx-query-builder [entities]="this.entities">
 * </igx-query-builder>
 * ```
 */
let IgxQueryBuilderComponent = /*#__PURE__*/(() => {
  class IgxQueryBuilderComponent {
    /**
     * Returns the entities.
     * @hidden
     */
    get entities() {
      return this._entities;
    }
    /**
     * Sets the entities.
     * @hidden
     */
    set entities(entities) {
      if (entities !== this._entities) {
        if (entities && this.expressionTree) {
          this._expressionTree = recreateTree(this._expressionTree, entities);
        }
      }
      this._entities = entities;
    }
    /**
     * Returns the fields.
     * @hidden
     * @deprecated in version 19.1.0. Use the `entities` property instead.
     */
    get fields() {
      return this._fields;
    }
    /**
     * Sets the fields.
     * @hidden
     * @deprecated in version 19.1.0. Use the `entities` property instead.
     */
    set fields(fields) {
      if (fields) {
        this._fields = fields;
        this.entities = [{
          name: null,
          fields: fields
        }];
      }
    }
    /**
    * Returns the expression tree.
    */
    get expressionTree() {
      return this._expressionTree;
    }
    /**
     * Sets the expression tree.
     */
    set expressionTree(expressionTree) {
      if (expressionTree !== this._expressionTree) {
        if (this.entities && expressionTree) {
          this._expressionTree = recreateTree(expressionTree, this.entities);
        } else {
          this._expressionTree = expressionTree;
        }
      }
    }
    /**
     * Sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * Returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    constructor(iconService) {
      this.iconService = iconService;
      /**
       * @hidden @internal
       */
      this.cssClass = 'igx-query-builder';
      /**
       * @hidden @internal
       */
      this.display = 'block';
      /**
       * Gets/sets whether the confirmation dialog should be shown when changing entity.
       * Default value is `true`.
       */
      this.showEntityChangeDialog = true;
      /**
       * Disables subsequent entity changes at the root level after the initial selection.
       */
      this.disableEntityChange = false;
      /**
       * Disables return fields changes at the root level.
       */
      this.disableReturnFieldsChange = false;
      /**
       * Event fired as the expression tree is changed.
       *
       * ```html
       *  <igx-query-builder (expressionTreeChange)='onExpressionTreeChange()'></igx-query-builder>
       * ```
       */
      this.expressionTreeChange = new EventEmitter();
      this.destroy$ = new Subject();
      this._resourceStrings = getCurrentResourceStrings(QueryBuilderResourceStringsEN);
      this._shouldEmitTreeChange = true;
      this.registerSVGIcons();
    }
    /**
     * Returns whether the expression tree can be committed in the current state.
     */
    canCommit() {
      return this.queryTree?.canCommitCurrentState() === true;
    }
    /**
     * Commits the expression tree in the current state if it is valid. If not throws an exception.
     */
    commit() {
      if (this.canCommit()) {
        this._shouldEmitTreeChange = false;
        this.queryTree.commitCurrentState();
        this._shouldEmitTreeChange = true;
      } else {
        throw new Error('Expression tree can\'t be committed in the current state. Use `canCommit` method to check if the current state is valid.');
      }
    }
    /**
     * Discards all unsaved changes to the expression tree.
     */
    discard() {
      this.queryTree.cancelOperandEdit();
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    setPickerOutlet(outlet) {
      this.queryTree.setPickerOutlet(outlet);
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    get isContextMenuVisible() {
      return this.queryTree.isContextMenuVisible;
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    exitOperandEdit() {
      this.queryTree.exitOperandEdit();
    }
    /**
     * @hidden @internal
     *
     * used by the grid
     */
    setAddButtonFocus() {
      this.queryTree.setAddButtonFocus();
    }
    onExpressionTreeChange(tree) {
      if (tree && this.entities && tree !== this._expressionTree) {
        this._expressionTree = recreateTree(tree, this.entities);
      } else {
        this._expressionTree = tree;
      }
      if (this._shouldEmitTreeChange) {
        this.expressionTreeChange.emit(tree);
      }
    }
    registerSVGIcons() {
      const editorIcons = editor;
      editorIcons.forEach(icon => {
        this.iconService.addSvgIconFromText(icon.name, icon.value, 'imx-icons');
        this.iconService.addIconRef(icon.name, 'default', {
          name: icon.name,
          family: 'imx-icons'
        });
      });
      const inIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M560-280H120v-400h720v120h-80v-40H200v240h360v80Zm-360-80v-240 240Zm560 200v-120H640v-80h120v-120h80v120h120v80H840v120h-80Z"/></svg>';
      this.iconService.addSvgIconFromText('in', inIcon, 'imx-icons');
      this.iconService.addIconRef('in', 'default', {
        name: 'in',
        family: 'imx-icons'
      });
      const notInIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M560-280H120v-400h720v120h-80v-40H200v240h360v80Zm-360-80v-240 240Zm440 104 84-84-84-84 56-56 84 84 84-84 56 56-83 84 83 84-56 56-84-83-84 83-56-56Z"/></svg>';
      this.iconService.addSvgIconFromText('not-in', notInIcon, 'imx-icons');
      this.iconService.addIconRef('not-in', 'default', {
        name: 'not-in',
        family: 'imx-icons'
      });
      this.iconService.addIconRef('add', 'default', {
        name: 'add',
        family: 'material'
      });
      this.iconService.addIconRef('close', 'default', {
        name: 'close',
        family: 'material'
      });
      this.iconService.addIconRef('check', 'default', {
        name: 'check',
        family: 'material'
      });
      this.iconService.addIconRef('delete', 'default', {
        name: 'delete',
        family: 'material'
      });
      this.iconService.addIconRef('edit', 'default', {
        name: 'edit',
        family: 'material'
      });
    }
    static {
      this.ɵfac = function IgxQueryBuilderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderComponent)(i0.ɵɵdirectiveInject(IgxIconService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxQueryBuilderComponent,
        selectors: [["igx-query-builder"]],
        contentQueries: function IgxQueryBuilderComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxQueryBuilderSearchValueTemplateDirective, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchValueTemplate = _t.first);
          }
        },
        viewQuery: function IgxQueryBuilderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxQueryBuilderTreeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.queryTree = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function IgxQueryBuilderComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.display);
            i0.ɵɵclassProp("igx-query-builder", ctx.cssClass);
          }
        },
        inputs: {
          showEntityChangeDialog: [2, "showEntityChangeDialog", "showEntityChangeDialog", booleanAttribute],
          entities: "entities",
          fields: "fields",
          expressionTree: "expressionTree",
          locale: "locale",
          resourceStrings: "resourceStrings",
          disableEntityChange: "disableEntityChange",
          disableReturnFieldsChange: "disableReturnFieldsChange"
        },
        outputs: {
          expressionTreeChange: "expressionTreeChange"
        },
        ngContentSelectors: _c110,
        decls: 2,
        vars: 6,
        consts: [[3, "expressionTreeChange", "entities", "expressionTree", "locale", "resourceStrings", "queryBuilder", "searchValueTemplate"]],
        template: function IgxQueryBuilderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c109);
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "igx-query-builder-tree", 0);
            i0.ɵɵlistener("expressionTreeChange", function IgxQueryBuilderComponent_Template_igx_query_builder_tree_expressionTreeChange_1_listener($event) {
              return ctx.onExpressionTreeChange($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("entities", ctx.entities)("expressionTree", ctx.expressionTree)("locale", ctx.locale)("resourceStrings", ctx.resourceStrings)("queryBuilder", ctx)("searchValueTemplate", ctx.searchValueTemplate);
          }
        },
        dependencies: [IgxQueryBuilderTreeComponent],
        encapsulation: 2
      });
    }
  }
  return IgxQueryBuilderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const GridResourceStringsEN = {
  igx_grid_groupByArea_message: 'Drag a column header and drop it here to group by that column.',
  igx_grid_groupByArea_select_message: 'Select all rows in the group with field name {0} and value {1}.',
  igx_grid_groupByArea_deselect_message: 'Deselect all rows in the group with field name {0} and value {1}.',
  igx_grid_emptyFilteredGrid_message: 'No records found.',
  igx_grid_emptyGrid_message: 'Grid has no data.',
  igx_grid_filter: 'Filter',
  igx_grid_filter_row_close: 'Close',
  igx_grid_filter_row_reset: 'Reset',
  igx_grid_filter_row_placeholder: 'Add filter value',
  igx_grid_filter_row_boolean_placeholder: 'All',
  igx_grid_filter_row_date_placeholder: 'Pick up date',
  igx_grid_filter_row_time_placeholder: 'Pick up time',
  igx_grid_filter_operator_and: 'And',
  igx_grid_filter_operator_or: 'Or',
  igx_grid_complex_filter: 'Complex Filter',
  igx_grid_filter_contains: 'Contains',
  igx_grid_filter_doesNotContain: 'Does Not Contain',
  igx_grid_filter_startsWith: 'Starts With',
  igx_grid_filter_endsWith: 'Ends With',
  igx_grid_filter_equals: 'Equals',
  igx_grid_filter_doesNotEqual: 'Does Not Equal',
  igx_grid_filter_empty: 'Empty',
  igx_grid_filter_notEmpty: 'Not Empty',
  igx_grid_filter_null: 'Null',
  igx_grid_filter_notNull: 'Not Null',
  igx_grid_filter_before: 'Before',
  igx_grid_filter_after: 'After',
  igx_grid_filter_at: 'At',
  igx_grid_filter_not_at: 'Not At',
  igx_grid_filter_at_before: 'At or Before',
  igx_grid_filter_at_after: 'At or After',
  igx_grid_filter_today: 'Today',
  igx_grid_filter_yesterday: 'Yesterday',
  igx_grid_filter_thisMonth: 'This Month',
  igx_grid_filter_lastMonth: 'Last Month',
  igx_grid_filter_nextMonth: 'Next Month',
  igx_grid_filter_thisYear: 'This Year',
  igx_grid_filter_lastYear: 'Last Year',
  igx_grid_filter_nextYear: 'Next Year',
  igx_grid_filter_greaterThan: 'Greater Than',
  igx_grid_filter_lessThan: 'Less Than',
  igx_grid_filter_greaterThanOrEqualTo: 'Greater Than Or Equal To',
  igx_grid_filter_lessThanOrEqualTo: 'Less Than Or Equal To',
  igx_grid_filter_true: 'True',
  igx_grid_filter_false: 'False',
  igx_grid_filter_all: 'All',
  igx_grid_filter_condition_placeholder: 'Select filter',
  igx_grid_summary_count: 'Count',
  igx_grid_summary_min: 'Min',
  igx_grid_summary_max: 'Max',
  igx_grid_summary_sum: 'Sum',
  igx_grid_summary_average: 'Avg',
  igx_grid_summary_earliest: 'Earliest',
  igx_grid_summary_latest: 'Latest',
  igx_grid_excel_filter_moving_left: 'move left',
  igx_grid_excel_filter_moving_left_short: 'left',
  igx_grid_excel_filter_moving_right: 'move right',
  igx_grid_excel_filter_moving_right_short: 'right',
  igx_grid_excel_filter_moving_header: 'move',
  igx_grid_excel_filter_sorting_asc: 'ascending',
  igx_grid_excel_filter_sorting_asc_short: 'asc',
  igx_grid_excel_filter_sorting_desc: 'descending',
  igx_grid_excel_filter_sorting_desc_short: 'desc',
  igx_grid_excel_filter_sorting_header: 'sort',
  igx_grid_excel_filter_clear: 'Clear column filters',
  igx_grid_excel_custom_dialog_add: 'add filter',
  igx_grid_excel_custom_dialog_clear: 'Clear filter',
  igx_grid_excel_custom_dialog_header: 'Custom auto-filter on column: ',
  igx_grid_excel_cancel: 'Cancel',
  igx_grid_excel_apply: 'Apply',
  igx_grid_excel_search_placeholder: 'Search',
  igx_grid_excel_select_all: 'Select All',
  igx_grid_excel_select_all_search_results: 'Select all search results',
  igx_grid_excel_add_to_filter: 'Add current selection to filter',
  igx_grid_excel_blanks: '(Blanks)',
  igx_grid_excel_hide: 'Hide column',
  igx_grid_excel_show: 'Show column',
  igx_grid_excel_pin: 'Pin column',
  igx_grid_excel_unpin: 'Unpin column',
  igx_grid_excel_select: 'Select column',
  igx_grid_excel_deselect: 'Deselect column',
  igx_grid_excel_text_filter: 'Text filter',
  igx_grid_excel_number_filter: 'Number filter',
  igx_grid_excel_date_filter: 'Date filter',
  igx_grid_excel_boolean_filter: 'Boolean filter',
  igx_grid_excel_currency_filter: 'Currency filter',
  igx_grid_excel_custom_filter: 'Custom filter...',
  igx_grid_excel_no_matches: 'No matches',
  igx_grid_excel_matches_count: '{0} matches.',
  igx_grid_advanced_filter_title: 'Advanced Filtering',
  igx_grid_advanced_filter_and_group: '"And" Group',
  igx_grid_advanced_filter_or_group: '"Or" Group',
  igx_grid_advanced_filter_end_group: 'End Group',
  igx_grid_advanced_filter_create_and_group: 'Create "And" Group',
  igx_grid_advanced_filter_create_or_group: 'Create "Or" Group',
  igx_grid_advanced_filter_and_label: 'and',
  igx_grid_advanced_filter_or_label: 'or',
  igx_grid_advanced_filter_add_condition: 'Condition',
  igx_grid_advanced_filter_ungroup: 'Ungroup',
  igx_grid_advanced_filter_delete: 'Delete',
  igx_grid_advanced_filter_delete_filters: 'Delete filters',
  igx_grid_advanced_filter_initial_text: 'Start with creating a group of conditions linked with "And" or "Or"',
  igx_grid_advanced_filter_column_placeholder: 'Select column',
  igx_grid_advanced_filter_value_placeholder: 'Value',
  igx_grid_pinned_row_indicator: 'Pinned',
  igx_grid_hiding_check_all_label: 'Show All',
  igx_grid_hiding_uncheck_all_label: 'Hide All',
  igx_grid_pinning_check_all_label: 'Pin All',
  igx_grid_pinning_uncheck_all_label: 'Unpin All',
  igx_grid_row_edit_btn_done: 'Done',
  igx_grid_row_edit_btn_cancel: 'Cancel',
  igx_grid_row_edit_text: 'You have {0} changes in this row and {1} hidden columns',
  igx_grid_toolbar_actions_filter_prompt: 'Filter columns list ...',
  igx_grid_toolbar_pinning_button_tooltip: 'Open column pinning dropdown',
  igx_grid_toolbar_hiding_button_tooltip: 'Open column hiding dropdown',
  igx_grid_toolbar_pinning_title: 'Pinned columns',
  igx_grid_toolbar_hiding_title: 'Visible columns',
  igx_grid_toolbar_advanced_filtering_button_tooltip: 'Open advanced filtering dialog',
  igx_grid_toolbar_advanced_filtering_button_label: 'Advanced filtering',
  igx_grid_toolbar_exporter_button_tooltip: 'Open exporter dropdown',
  igx_grid_toolbar_exporter_button_label: 'Export',
  igx_grid_toolbar_exporter_excel_entry_text: 'Export to Excel',
  igx_grid_toolbar_exporter_csv_entry_text: 'Export to CSV',
  igx_grid_snackbar_addrow_label: 'Row added',
  igx_grid_snackbar_addrow_actiontext: 'SHOW',
  igx_grid_actions_edit_label: 'Edit',
  igx_grid_actions_add_label: 'Add',
  igx_grid_add_row_label: 'ADD ROW',
  igx_grid_actions_add_child_label: 'Add Child',
  igx_grid_actions_delete_label: 'Delete',
  igx_grid_actions_pin_label: 'Pin',
  igx_grid_actions_unpin_label: 'Unpin',
  igx_grid_actions_jumpUp_label: 'Jump up',
  igx_grid_actions_jumpDown_label: 'Jump down',
  igx_grid_pivot_date_dimension_total: 'All Periods',
  igx_grid_pivot_aggregate_count: 'Count',
  igx_grid_pivot_aggregate_min: 'Minimum',
  igx_grid_pivot_aggregate_max: 'Maximum',
  igx_grid_pivot_aggregate_sum: 'Sum',
  igx_grid_pivot_aggregate_avg: 'Average',
  igx_grid_pivot_aggregate_date_latest: 'Latest Date',
  igx_grid_pivot_aggregate_date_earliest: 'Earliest Date',
  igx_grid_pivot_aggregate_time_latest: 'Latest Time',
  igx_grid_pivot_aggregate_time_earliest: 'Earliest Time',
  igx_grid_pivot_empty_row_drop_area: 'Drop Row Fields here.',
  igx_grid_pivot_empty_column_drop_area: 'Drop Column Fields here.',
  igx_grid_pivot_empty_filter_drop_area: 'Drop Filter Fields here.',
  igx_grid_pivot_empty_value_drop_area: 'Drop Value Fields here.',
  igx_grid_pivot_row_drop_chip: 'Drop here to use as row',
  igx_grid_pivot_column_drop_chip: 'Drop here to use as column',
  igx_grid_pivot_filter_drop_chip: 'Drop here to use as filter',
  igx_grid_pivot_value_drop_chip: 'Drop here to use as value',
  igx_grid_pivot_empty_message: 'Pivot grid has no dimensions and values.',
  igx_grid_pivot_selector_filters: 'Filters',
  igx_grid_pivot_selector_rows: 'Rows',
  igx_grid_pivot_selector_columns: 'Columns',
  igx_grid_pivot_selector_values: 'Values',
  igx_grid_pivot_selector_panel_empty: 'Drop Items Here',
  igx_grid_required_validation_error: 'This field is required',
  igx_grid_min_validation_error: 'A value of at least {0} should be entered',
  igx_grid_max_validation_error: 'A value no more than {0} should be entered',
  igx_grid_min_length_validation_error: 'Entry should be at least {0} character(s) long',
  igx_grid_max_length_validation_error: 'Entry should be no more than {0} character(s) long',
  igx_grid_email_validation_error: 'A valid email address should be entered',
  igx_grid_pattern_validation_error: 'Entry does not match the required pattern'
};
let IgxQueryBuilderHeaderComponent = /*#__PURE__*/(() => {
  class IgxQueryBuilderHeaderComponent {
    constructor() {
      this._resourceStrings = getCurrentResourceStrings(QueryBuilderResourceStringsEN);
      /**
       * Show/hide the legend.
       *
       * @example
       * ```html
       * <igx-query-builder-header [showLegend]="false"></igx-query-builder-header>
       * ```
       * @deprecated in version 19.1.0.
       */
      this.showLegend = true;
    }
    /**
     * @hidden @internal
     */
    get getClass() {
      return 'igx-query-builder__header';
    }
    /**
     * Sets the resource strings.
     * By default it uses EN resources.
     *
     * @deprecated in version 19.1.0.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * Returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    static {
      this.ɵfac = function IgxQueryBuilderHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxQueryBuilderHeaderComponent,
        selectors: [["igx-query-builder-header"]],
        hostVars: 2,
        hostBindings: function IgxQueryBuilderHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.getClass);
          }
        },
        inputs: {
          title: "title",
          showLegend: "showLegend",
          resourceStrings: "resourceStrings"
        },
        ngContentSelectors: _c0,
        decls: 3,
        vars: 1,
        consts: [[1, "igx-query-builder__title"]],
        template: function IgxQueryBuilderHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(2);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxQueryBuilderHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting advanced filtering UI for a Grid.
 * It is used internally in the Grid, but could also be hosted in a container outside of it.
 *
 * Example:
 * ```html
 * <igx-advanced-filtering-dialog
 *     [grid]="grid1">
 * </igx-advanced-filtering-dialog>
 * ```
 */
let IgxAdvancedFilteringDialogComponent = /*#__PURE__*/(() => {
  class IgxAdvancedFilteringDialogComponent {
    constructor(cdr, platform) {
      this.cdr = cdr;
      this.platform = platform;
      /**
       * @hidden @internal
       */
      this.display = 'block';
      /**
       * @hidden @internal
       */
      this.inline = true;
      /**
       * @hidden @internal
       */
      this.lastActiveNode = {};
      this.destroy$ = new Subject();
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      this.queryBuilder.setPickerOutlet(this.grid.outlet);
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * Assigns the grid instance corresponding to the advanced filtering dialog instance.
     */
    set grid(grid) {
      this._grid = grid;
      if (this._grid) {
        this._grid.filteringService.registerSVGIcons();
      }
      this.assignResourceStrings();
    }
    /**
     * Returns the grid.
     */
    get grid() {
      return this._grid;
    }
    /**
     * @hidden @internal
     */
    get filterableFields() {
      return this.grid.columns.filter(column => !column.columnGroup && column.filterable);
    }
    /**
     * @hidden @internal
     */
    dragStart(dragArgs) {
      if (!this._overlayComponentId) {
        dragArgs.cancel = true;
        return;
      }
    }
    /**
     * @hidden @internal
     */
    onDragMove(e) {
      const deltaX = e.nextPageX - e.pageX;
      const deltaY = e.nextPageY - e.pageY;
      e.cancel = true;
      this._overlayService.setOffset(this._overlayComponentId, deltaX, deltaY);
    }
    /**
     * @hidden @internal
     */
    onKeyDown(eventArgs) {
      eventArgs.stopPropagation();
      const key = eventArgs.key;
      if (key === this.platform.KEYMAP.ESCAPE) {
        this.closeDialog();
      }
    }
    /**
     * @hidden @internal
     */
    initialize(grid, overlayService, overlayComponentId) {
      this.inline = false;
      this.grid = grid;
      this._overlayService = overlayService;
      this._overlayComponentId = overlayComponentId;
    }
    /**
     * @hidden @internal
     */
    onClearButtonClick(event) {
      this.grid.crudService.endEdit(false, event);
      this.queryBuilder.expressionTree = this.grid.advancedFilteringExpressionsTree = null;
    }
    /**
     * @hidden @internal
     */
    closeDialog() {
      if (this._overlayComponentId) {
        this._overlayService.hide(this._overlayComponentId);
      }
      this.grid.navigation.activeNode = this.lastActiveNode;
      if (this.grid.navigation.activeNode && this.grid.navigation.activeNode.row === -1) {
        this.grid.theadRow.nativeElement.focus();
      }
    }
    /**
     * @hidden @internal
     */
    applyChanges(event) {
      this.grid.crudService.endEdit(false, event);
      this.queryBuilder.exitOperandEdit();
      this.grid.advancedFilteringExpressionsTree = this.queryBuilder.expressionTree;
    }
    /**
     * @hidden @internal
     */
    cancelChanges() {
      this.closeDialog();
    }
    /**
     * @hidden @internal
     */
    onApplyButtonClick(event) {
      this.applyChanges(event);
      this.closeDialog();
    }
    /**
     * @hidden @internal
     */
    generateEntity() {
      const entities = [{
        name: null,
        fields: this.filterableFields
      }];
      return entities;
    }
    assignResourceStrings() {
      // If grid has custom resource strings set for the advanced filtering,
      // they are passed to the query builder resource strings.
      const gridRS = this.grid.resourceStrings;
      if (gridRS !== GridResourceStringsEN) {
        const queryBuilderRS = getCurrentResourceStrings(QueryBuilderResourceStringsEN);
        Object.keys(gridRS).forEach(prop => {
          const reg = /^igx_grid_(advanced_)?filter_(row_)?/;
          if (!reg.test(prop)) {
            return;
          }
          const affix = prop.replace(reg, '');
          const filterProp = `igx_query_builder_filter_${affix}`;
          const generalProp = `igx_query_builder_${affix}`;
          if (queryBuilderRS[filterProp] !== undefined) {
            queryBuilderRS[filterProp] = gridRS[prop];
          } else if (queryBuilderRS[generalProp] !== undefined) {
            queryBuilderRS[generalProp] = gridRS[prop];
          }
        });
      }
    }
    static {
      this.ɵfac = function IgxAdvancedFilteringDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAdvancedFilteringDialogComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxAdvancedFilteringDialogComponent,
        selectors: [["igx-advanced-filtering-dialog"]],
        viewQuery: function IgxAdvancedFilteringDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c111, 5, IgxQueryBuilderComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.queryBuilder = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxAdvancedFilteringDialogComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.display);
          }
        },
        inputs: {
          grid: "grid"
        },
        decls: 1,
        vars: 1,
        consts: [["queryBuilder", ""], ["igxDrag", "", 1, "igx-advanced-filter", 3, "ghost", "dragTolerance", "ngClass"], ["igxDrag", "", 1, "igx-advanced-filter", 3, "dragStart", "dragMove", "keydown", "ghost", "dragTolerance", "ngClass"], [3, "locale", "entities", "expressionTree"], ["igxDragHandle", "", 3, "title"], [1, "igx-excel-filter__secondary-footer"], [1, "igx-excel-filter__clear"], ["igxButton", "flat", "type", "button", 3, "click"], [1, "igx-excel-filter__cancel"], ["igxButton", "outlined", "type", "button", 3, "click"], [1, "igx-excel-filter__apply"], ["igxButton", "contained", "type", "button", 3, "click"]],
        template: function IgxAdvancedFilteringDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxAdvancedFilteringDialogComponent_Conditional_0_Template, 14, 12, "article", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.grid ? 0 : -1);
          }
        },
        dependencies: [IgxDragDirective, NgClass, IgxQueryBuilderComponent, IgxQueryBuilderHeaderComponent, IgxDragHandleDirective, IgxButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxAdvancedFilteringDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseFilteringComponent = /*#__PURE__*/(() => {
  class BaseFilteringComponent {
    constructor(cdr, element, platform) {
      this.cdr = cdr;
      this.element = element;
      this.platform = platform;
    }
    static {
      this.ɵfac = function BaseFilteringComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseFilteringComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseFilteringComponent
      });
    }
  }
  return BaseFilteringComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style clear filters UI.
 */
let IgxExcelStyleClearFiltersComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleClearFiltersComponent {
    constructor(esf, platform) {
      this.esf = esf;
      this.platform = platform;
    }
    /**
     * @hidden @internal
     */
    clearFilterClass() {
      if (this.esf.column.filteringExpressionsTree) {
        return 'igx-excel-filter__actions-clear';
      }
      return 'igx-excel-filter__actions-clear--disabled';
    }
    /**
     * @hidden @internal
     */
    clearFilter() {
      this.esf.grid.filteringService.clearFilter(this.esf.column.field);
      this.selectAllFilterItems();
    }
    /**
     * @hidden @internal
     */
    onClearFilterKeyDown(eventArgs) {
      if (eventArgs.key === this.platform.KEYMAP.ENTER) {
        this.clearFilter();
      }
    }
    selectAllFilterItems() {
      this.esf.listData.forEach(filterListItem => {
        filterListItem.isSelected = true;
        filterListItem.indeterminate = false;
      });
      this.esf.detectChanges();
    }
    static {
      this.ɵfac = function IgxExcelStyleClearFiltersComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleClearFiltersComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleClearFiltersComponent,
        selectors: [["igx-excel-style-clear-filters"]],
        decls: 1,
        vars: 1,
        consts: [["tabindex", "0", "role", "menuitem", 3, "ngClass"], ["tabindex", "0", "role", "menuitem", 3, "keydown", "click", "ngClass"], ["family", "default", "name", "cancel"]],
        template: function IgxExcelStyleClearFiltersComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleClearFiltersComponent_Conditional_0_Template, 4, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [NgClass, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleClearFiltersComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxExcelStyleDefaultExpressionComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleDefaultExpressionComponent {
    get isLast() {
      return this.expressionsList[this.expressionsList.length - 1] === this.expressionUI;
    }
    get isSingle() {
      return this.expressionsList.length === 1;
    }
    get conditionsPlaceholder() {
      return this.grid.resourceStrings['igx_grid_filter_condition_placeholder'];
    }
    get inputValuePlaceholder() {
      return this.grid.resourceStrings['igx_grid_filter_row_placeholder'];
    }
    get type() {
      switch (this.column.dataType) {
        case GridColumnDataType.Number:
        case GridColumnDataType.Currency:
        case GridColumnDataType.Percent:
          return 'number';
        default:
          return 'text';
      }
    }
    constructor(cdr, platform) {
      this.cdr = cdr;
      this.platform = platform;
      this.expressionRemoved = new EventEmitter();
      this.logicOperatorChanged = new EventEmitter();
      this.dropDownOverlaySettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: true
      };
    }
    get conditions() {
      return this.column.filters.conditionList();
    }
    get inputValuesElement() {
      return this.inputValuesDirective.nativeElement;
    }
    ngAfterViewInit() {
      this.dropDownOverlaySettings.outlet = this.overlayOutlet;
      this.dropDownOverlaySettings.target = this.dropdownConditions.inputGroup.element.nativeElement;
      this.dropDownOverlaySettings.excludeFromOutsideClick = [this.dropdownConditions.inputGroup.element.nativeElement];
      this.dropDownOverlaySettings.positionStrategy = new ConnectedPositioningStrategy();
    }
    focus() {
      // use requestAnimationFrame to focus the values input because when initializing the component
      // datepicker's input group is not yet fully initialized
      requestAnimationFrame(() => this.inputValuesElement.focus());
    }
    translateCondition(value) {
      return this.grid.resourceStrings[`igx_grid_filter_${this.getCondition(value).name}`] || value;
    }
    getIconName() {
      if (this.column.dataType === GridColumnDataType.Boolean && this.expressionUI.expression.condition === null) {
        return this.getCondition(this.conditions[0]).iconName;
      } else if (!this.expressionUI.expression.condition) {
        return 'filter_list';
      } else {
        return this.expressionUI.expression.condition.iconName;
      }
    }
    isConditionSelected(conditionName) {
      return this.expressionUI.expression.condition && this.expressionUI.expression.condition.name === conditionName;
    }
    onConditionsChanged(eventArgs) {
      const value = eventArgs.newSelection.value;
      this.expressionUI.expression.condition = this.getCondition(value);
      this.focus();
    }
    getCondition(value) {
      return this.column.filters.condition(value);
    }
    getConditionFriendlyName(name) {
      return this.grid.resourceStrings[`igx_grid_filter_${name}`] || name;
    }
    onValuesInput(eventArgs) {
      this.expressionUI.expression.searchVal = DataUtil.parseValue(this.column.dataType, eventArgs.target.value);
    }
    onLogicOperatorButtonClicked(eventArgs, buttonIndex) {
      if (this.logicOperatorButtonGroup.selectedButtons.length === 0) {
        eventArgs.stopPropagation();
        this.logicOperatorButtonGroup.selectButton(buttonIndex);
      } else {
        this.logicOperatorChanged.emit({
          target: this.expressionUI,
          newValue: buttonIndex
        });
      }
    }
    onLogicOperatorKeyDown(eventArgs, buttonIndex) {
      if (eventArgs.key === this.platform.KEYMAP.ENTER) {
        this.logicOperatorButtonGroup.selectButton(buttonIndex);
        this.logicOperatorChanged.emit({
          target: this.expressionUI,
          newValue: buttonIndex
        });
      }
    }
    onRemoveButtonClick() {
      this.expressionRemoved.emit(this.expressionUI);
    }
    onOutletPointerDown(event) {
      event.preventDefault();
    }
    static {
      this.ɵfac = function IgxExcelStyleDefaultExpressionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleDefaultExpressionComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleDefaultExpressionComponent,
        selectors: [["igx-excel-style-default-expression"]],
        viewQuery: function IgxExcelStyleDefaultExpressionComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c104, 7, IgxOverlayOutletDirective);
            i0.ɵɵviewQuery(_c113, 7, IgxSelectComponent);
            i0.ɵɵviewQuery(_c114, 5, IgxButtonGroupComponent);
            i0.ɵɵviewQuery(_c115, 7, IgxInputDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayOutlet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownConditions = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logicOperatorButtonGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputValuesDirective = _t.first);
          }
        },
        inputs: {
          column: "column",
          expressionUI: "expressionUI",
          expressionsList: "expressionsList",
          grid: "grid"
        },
        outputs: {
          expressionRemoved: "expressionRemoved",
          logicOperatorChanged: "logicOperatorChanged"
        },
        decls: 15,
        vars: 10,
        consts: [["dropdownConditions", ""], ["inputGroupValues", ""], ["inputValues", ""], ["overlayOutlet", ""], ["logicOperatorButtonGroup", ""], ["andButton", ""], ["orButton", ""], ["type", "box", 3, "selectionChanging", "placeholder", "overlaySettings"], ["family", "default", 3, "name"], ["family", "default", "name", "filter_list"], [3, "value", "text", "selected"], ["type", "box"], ["igxInput", "", "tabindex", "0", "autocomplete", "off", 3, "input", "type", "placeholder", "disabled", "value"], ["type", "button", "igxIconButton", "flat"], ["igxOverlayOutlet", "", 3, "pointerdown"], [1, "igx-grid__filtering-dropdown-items"], [1, "igx-grid__filtering-dropdown-text"], ["type", "button", "igxIconButton", "flat", 3, "click"], ["family", "default", "name", "remove"], ["igxButton", "", "tabindex", "0", "type", "button", 3, "keydown", "click", "selected"]],
        template: function IgxExcelStyleDefaultExpressionComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-select", 7, 0);
            i0.ɵɵlistener("selectionChanging", function IgxExcelStyleDefaultExpressionComponent_Template_igx_select_selectionChanging_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConditionsChanged($event));
            });
            i0.ɵɵelementStart(2, "igx-prefix");
            i0.ɵɵtemplate(3, IgxExcelStyleDefaultExpressionComponent_Conditional_3_Template, 1, 1, "igx-icon", 8)(4, IgxExcelStyleDefaultExpressionComponent_Conditional_4_Template, 1, 0, "igx-icon", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(5, IgxExcelStyleDefaultExpressionComponent_For_6_Template, 5, 5, "igx-select-item", 10, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "igx-input-group", 11, 1)(9, "input", 12, 2);
            i0.ɵɵlistener("input", function IgxExcelStyleDefaultExpressionComponent_Template_input_input_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onValuesInput($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, IgxExcelStyleDefaultExpressionComponent_Conditional_11_Template, 2, 0, "button", 13)(12, IgxExcelStyleDefaultExpressionComponent_Conditional_12_Template, 8, 4, "igx-buttongroup");
            i0.ɵɵelementStart(13, "div", 14, 3);
            i0.ɵɵlistener("pointerdown", function IgxExcelStyleDefaultExpressionComponent_Template_div_pointerdown_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOutletPointerDown($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("placeholder", ctx.conditionsPlaceholder)("overlaySettings", ctx.dropDownOverlaySettings);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.expressionUI.expression.condition ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.expressionUI.expression.condition ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.conditions);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("type", ctx.type)("placeholder", ctx.inputValuePlaceholder)("disabled", ctx.expressionUI.expression.condition && ctx.expressionUI.expression.condition.isUnary)("value", ctx.expressionUI.expression.searchVal);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.isSingle ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isLast ? 12 : -1);
          }
        },
        dependencies: [IgxSelectComponent, IgxPrefixDirective, IgxIconComponent, IgxSelectItemComponent, IgxInputGroupComponent, IgxInputDirective, IgxButtonDirective, IgxButtonGroupComponent, IgxOverlayOutletDirective, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleDefaultExpressionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxExcelStyleDateExpressionComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleDateExpressionComponent extends IgxExcelStyleDefaultExpressionComponent {
    get searchVal() {
      return this.expressionUI.expression.searchVal;
    }
    set searchVal(value) {
      this.expressionUI.expression.searchVal = value ? new Date(Date.parse(value.toString())) : null;
    }
    get inputValuesElement() {
      return this.picker?.getEditElement() || this.input?.nativeElement;
    }
    get inputDatePlaceholder() {
      return this.grid.resourceStrings['igx_grid_filter_row_date_placeholder'];
    }
    get inputTimePlaceholder() {
      return this.grid.resourceStrings['igx_grid_filter_row_time_placeholder'];
    }
    get weekStart() {
      return getLocaleFirstDayOfWeek(this.grid.locale);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxExcelStyleDateExpressionComponent_BaseFactory;
        return function IgxExcelStyleDateExpressionComponent_Factory(__ngFactoryType__) {
          return (ɵIgxExcelStyleDateExpressionComponent_BaseFactory || (ɵIgxExcelStyleDateExpressionComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxExcelStyleDateExpressionComponent)))(__ngFactoryType__ || IgxExcelStyleDateExpressionComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleDateExpressionComponent,
        selectors: [["igx-excel-style-date-expression"]],
        viewQuery: function IgxExcelStyleDateExpressionComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c76, 5, IgxInputDirective);
            i0.ɵɵviewQuery(_c95, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
          }
        },
        inputs: {
          searchVal: "searchVal"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 9,
        consts: [["dropdownConditions", ""], ["overlayOutlet", ""], ["picker", ""], ["dropDownTarget", "", "inputGroup", ""], ["input", ""], ["logicOperatorButtonGroup", ""], ["andButton", ""], ["orButton", ""], ["type", "box", 3, "selectionChanging", "placeholder", "overlaySettings"], ["family", "default", 3, "name"], ["family", "default", "name", "filter_list"], [3, "value", "text", "selected"], ["type", "box", 3, "weekStart", "value", "locale", "outlet", "readOnly", "placeholder", "displayFormat", "formatter", "disabled"], ["type", "box", 3, "ngModel", "locale", "outlet", "readOnly", "placeholder", "displayFormat", "inputFormat", "formatter", "disabled"], ["type", "box"], ["type", "button", "igxIconButton", "flat"], ["igxOverlayOutlet", "", 3, "pointerdown"], ["type", "box", 3, "valueChange", "click", "weekStart", "value", "locale", "outlet", "readOnly", "placeholder", "displayFormat", "formatter", "disabled"], ["type", "box", 3, "ngModelChange", "click", "ngModel", "locale", "outlet", "readOnly", "placeholder", "displayFormat", "inputFormat", "formatter", "disabled"], ["igxInput", "", "tabindex", "0", 3, "ngModelChange", "placeholder", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat", "ngModel", "disabled"], ["type", "button", "igxIconButton", "flat", 3, "click"], ["family", "default", "name", "remove"], ["igxButton", "", "tabindex", "0", "type", "button", 3, "keydown", "click", "selected"]],
        template: function IgxExcelStyleDateExpressionComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-select", 8, 0);
            i0.ɵɵlistener("selectionChanging", function IgxExcelStyleDateExpressionComponent_Template_igx_select_selectionChanging_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConditionsChanged($event));
            });
            i0.ɵɵelementStart(2, "igx-prefix");
            i0.ɵɵtemplate(3, IgxExcelStyleDateExpressionComponent_Conditional_3_Template, 1, 1, "igx-icon", 9)(4, IgxExcelStyleDateExpressionComponent_Conditional_4_Template, 1, 0, "igx-icon", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(5, IgxExcelStyleDateExpressionComponent_For_6_Template, 4, 5, "igx-select-item", 11, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, IgxExcelStyleDateExpressionComponent_Conditional_7_Template, 4, 9, "igx-date-picker", 12)(8, IgxExcelStyleDateExpressionComponent_Conditional_8_Template, 4, 9, "igx-time-picker", 13)(9, IgxExcelStyleDateExpressionComponent_Conditional_9_Template, 5, 7, "igx-input-group", 14)(10, IgxExcelStyleDateExpressionComponent_Conditional_10_Template, 2, 0, "button", 15)(11, IgxExcelStyleDateExpressionComponent_Conditional_11_Template, 8, 4, "igx-buttongroup");
            i0.ɵɵelementStart(12, "div", 16, 1);
            i0.ɵɵlistener("pointerdown", function IgxExcelStyleDateExpressionComponent_Template_div_pointerdown_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOutletPointerDown($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("placeholder", ctx.conditionsPlaceholder)("overlaySettings", ctx.dropDownOverlaySettings);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.expressionUI.expression.condition ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.expressionUI.expression.condition ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.conditions);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.column.dataType === "date" ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.column.dataType === "time" ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.column.dataType === "dateTime" ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isSingle ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isLast ? 11 : -1);
          }
        },
        dependencies: [IgxSelectComponent, IgxPrefixDirective, IgxIconComponent, IgxSelectItemComponent, IgxDatePickerComponent, IgxPickerToggleComponent, IgxPickerClearComponent, IgxTimePickerComponent, IgxInputGroupComponent, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IgxInputDirective, IgxDateTimeEditorDirective, IgxButtonDirective, IgxButtonGroupComponent, IgxOverlayOutletDirective, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleDateExpressionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden @internal
 */
class FilterListItem {
  constructor() {
    this.isSpecial = false;
    this.isBlanks = false;
  }
}
/**
 * @hidden
 */
class ExpressionUI {
  constructor() {
    this.isSelected = false;
    this.isVisible = true;
    // Use IDs to identify expressions clearly and use to track them in template @for cycles.
    this.expressionId = crypto.randomUUID();
  }
}
/**
 * @hidden @internal
 */
class ActiveElement {}
function generateExpressionsList(expressions, operator, expressionsUIs) {
  generateExpressionsListRecursive(expressions, operator, expressionsUIs);
  // The beforeOperator of the first expression and the afterOperator of the last expression should be null
  if (expressionsUIs.length) {
    expressionsUIs[expressionsUIs.length - 1].afterOperator = null;
  }
}
function generateExpressionsListRecursive(expressions, operator, expressionsUIs) {
  if (!expressions) {
    return;
  }
  if (isTree(expressions)) {
    for (const operand of expressions.filteringOperands) {
      generateExpressionsListRecursive(operand, expressions.operator, expressionsUIs);
    }
    if (expressionsUIs.length) {
      expressionsUIs[expressionsUIs.length - 1].afterOperator = operator;
    }
  } else {
    const exprUI = new ExpressionUI();
    exprUI.expression = expressions;
    exprUI.afterOperator = operator;
    const prevExprUI = expressionsUIs[expressionsUIs.length - 1];
    if (prevExprUI) {
      exprUI.beforeOperator = prevExprUI.afterOperator;
    }
    expressionsUIs.push(exprUI);
  }
}

/**
 * @hidden
 */
let IgxExcelStyleCustomDialogComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleCustomDialogComponent {
    constructor(overlayService, cdr, platform, esf) {
      this.overlayService = overlayService;
      this.cdr = cdr;
      this.platform = platform;
      this.esf = esf;
      this.expressionsList = new Array();
      this._customDialogPositionSettings = {
        verticalDirection: VerticalAlignment.Middle,
        horizontalDirection: HorizontalAlignment.Center,
        horizontalStartPoint: HorizontalAlignment.Center,
        verticalStartPoint: VerticalAlignment.Middle
      };
      this._customDialogOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new AutoPositionStrategy(this._customDialogPositionSettings),
        scrollStrategy: new AbsoluteScrollStrategy()
      };
    }
    ngAfterViewInit() {
      this._customDialogOverlaySettings.outlet = this.grid.outlet;
    }
    get template() {
      if (this.column.dataType === GridColumnDataType.Date) {
        return this.dateExpressionTemplate;
      }
      return this.defaultExpressionTemplate;
    }
    get grid() {
      return this.filteringService.grid;
    }
    onCustomDialogOpening() {
      if (this.selectedOperator) {
        this.createInitialExpressionUIElement();
      }
    }
    onCustomDialogOpened() {
      if (this.expressionComponents.first) {
        this.expressionComponents.first.focus();
      }
    }
    open(esf) {
      this._customDialogOverlaySettings.target = this.overlayComponentId ? this.grid.rootGrid ? this.grid.rootGrid.nativeElement : this.grid.nativeElement : esf;
      this.toggle.open(this._customDialogOverlaySettings);
      this.overlayComponentId = this.toggle.overlayId;
    }
    onClearButtonClick() {
      this.filteringService.clearFilter(this.column.field);
      this.selectedOperator = null;
      this.createInitialExpressionUIElement();
      this.cdr.detectChanges();
    }
    closeDialog() {
      if (this.overlayComponentId) {
        this.overlayService.hide(this.overlayComponentId);
        this.overlayComponentId = null;
      } else {
        this.toggle.close();
      }
    }
    cancelDialog() {
      this.esf.cancel();
      this.closeDialog();
    }
    onApplyButtonClick() {
      this.expressionsList = this.expressionsList.filter(element => element.expression.condition && (element.expression.searchVal || element.expression.searchVal === 0 || element.expression.condition.isUnary));
      if (this.expressionsList.length > 0) {
        this.expressionsList[0].beforeOperator = null;
        this.expressionsList[this.expressionsList.length - 1].afterOperator = null;
      }
      this.filteringService.filterInternal(this.column.field, this.expressionsList);
      this.closeDialog();
    }
    onAddButtonClick() {
      const exprUI = new ExpressionUI();
      exprUI.expression = {
        condition: null,
        conditionName: null,
        fieldName: this.column.field,
        ignoreCase: this.column.filteringIgnoreCase,
        searchVal: null
      };
      this.expressionsList[this.expressionsList.length - 1].afterOperator = FilteringLogic.And;
      exprUI.beforeOperator = this.expressionsList[this.expressionsList.length - 1].afterOperator;
      this.expressionsList.push(exprUI);
      this.markChildrenForCheck();
      this.scrollToBottom();
    }
    onExpressionRemoved(event) {
      const indexToRemove = this.expressionsList.indexOf(event);
      if (indexToRemove === 0 && this.expressionsList.length > 1) {
        this.expressionsList[1].beforeOperator = null;
      } else if (indexToRemove === this.expressionsList.length - 1) {
        this.expressionsList[indexToRemove - 1].afterOperator = null;
      } else {
        this.expressionsList[indexToRemove - 1].afterOperator = this.expressionsList[indexToRemove + 1].beforeOperator;
        this.expressionsList[0].beforeOperator = null;
        this.expressionsList[this.expressionsList.length - 1].afterOperator = null;
      }
      this.expressionsList.splice(indexToRemove, 1);
      this.cdr.detectChanges();
      this.markChildrenForCheck();
    }
    onLogicOperatorChanged(event) {
      const index = this.expressionsList.indexOf(event.target);
      event.target.afterOperator = event.newValue;
      if (index + 1 < this.expressionsList.length) {
        this.expressionsList[index + 1].beforeOperator = event.newValue;
      }
    }
    onKeyDown(eventArgs) {
      eventArgs.stopPropagation();
    }
    onApplyButtonKeyDown(eventArgs) {
      if (eventArgs.key === this.platform.KEYMAP.TAB && !eventArgs.shiftKey) {
        eventArgs.stopPropagation();
        eventArgs.preventDefault();
      }
    }
    createCondition(conditionName) {
      switch (this.column.dataType) {
        case GridColumnDataType.Boolean:
          return IgxBooleanFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Number:
        case GridColumnDataType.Currency:
        case GridColumnDataType.Percent:
          return IgxNumberFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Date:
          return IgxDateFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Time:
          return IgxTimeFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.DateTime:
          return IgxDateTimeFilteringOperand.instance().condition(conditionName);
        default:
          return IgxStringFilteringOperand.instance().condition(conditionName);
      }
    }
    markChildrenForCheck() {
      this.expressionComponents.forEach(x => x.cdr.markForCheck());
      this.expressionDateComponents.forEach(x => x.cdr.markForCheck());
    }
    createInitialExpressionUIElement() {
      let firstExprUI = new ExpressionUI();
      if (this.expressionsList.length == 1 && this.expressionsList[0].expression.condition?.name === this.selectedOperator) {
        firstExprUI = this.expressionsList.pop();
      } else {
        this.expressionsList = [];
        const cond = this.createCondition(this.selectedOperator);
        firstExprUI.expression = {
          condition: cond,
          conditionName: cond?.name,
          fieldName: this.column.field,
          ignoreCase: this.column.filteringIgnoreCase,
          searchVal: null
        };
      }
      firstExprUI.afterOperator = FilteringLogic.And;
      this.expressionsList.push(firstExprUI);
      const secondExprUI = new ExpressionUI();
      secondExprUI.expression = {
        condition: null,
        conditionName: null,
        fieldName: this.column.field,
        ignoreCase: this.column.filteringIgnoreCase,
        searchVal: null
      };
      secondExprUI.beforeOperator = FilteringLogic.And;
      this.expressionsList.push(secondExprUI);
    }
    scrollToBottom() {
      requestAnimationFrame(() => {
        this.expressionsContainer.nativeElement.scrollTop = this.expressionsContainer.nativeElement.scrollHeight;
      });
    }
    static {
      this.ɵfac = function IgxExcelStyleCustomDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleCustomDialogComponent)(i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleCustomDialogComponent,
        selectors: [["igx-excel-style-custom-dialog"]],
        viewQuery: function IgxExcelStyleCustomDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c116, 7, IgxToggleDirective);
            i0.ɵɵviewQuery(_c117, 5, TemplateRef);
            i0.ɵɵviewQuery(_c118, 5, TemplateRef);
            i0.ɵɵviewQuery(_c103, 7);
            i0.ɵɵviewQuery(IgxExcelStyleDefaultExpressionComponent, 5);
            i0.ɵɵviewQuery(IgxExcelStyleDateExpressionComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggle = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExpressionTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateExpressionTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expressionsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expressionComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expressionDateComponents = _t);
          }
        },
        inputs: {
          expressionsList: "expressionsList",
          column: "column",
          selectedOperator: "selectedOperator",
          filteringService: "filteringService",
          overlayComponentId: "overlayComponentId"
        },
        decls: 23,
        vars: 12,
        consts: [["toggle", ""], ["expressionsContainer", ""], ["igxToggle", "", 1, "igx-excel-filter__secondary", 3, "keydown", "opening", "opened", "ngClass"], [1, "igx-excel-filter__secondary-header"], [1, "ig-typography__h6"], [1, "igx-excel-filter__secondary-main"], ["type", "button", "igxButton", "", 1, "igx-excel-filter__add-filter", 3, "click"], ["family", "default", "name", "add"], [1, "igx-excel-filter__secondary-footer"], [1, "igx-excel-filter__clear"], ["type", "button", "igxButton", "flat", 3, "click"], [1, "igx-excel-filter__cancel"], [1, "igx-excel-filter__apply"], ["type", "button", "igxButton", "contained", 3, "click", "keydown"], [1, "igx-excel-filter__condition", 3, "expressionUI", "column", "grid", "expressionsList"], [1, "igx-excel-filter__condition", 3, "expressionRemoved", "logicOperatorChanged", "expressionUI", "column", "grid", "expressionsList"]],
        template: function IgxExcelStyleCustomDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "article", 2, 0);
            i0.ɵɵlistener("keydown", function IgxExcelStyleCustomDialogComponent_Template_article_keydown_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyDown($event));
            })("opening", function IgxExcelStyleCustomDialogComponent_Template_article_opening_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCustomDialogOpening());
            })("opened", function IgxExcelStyleCustomDialogComponent_Template_article_opened_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCustomDialogOpened());
            });
            i0.ɵɵelementStart(2, "header", 3)(3, "h4", 4);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "article", 5, 1);
            i0.ɵɵtemplate(7, IgxExcelStyleCustomDialogComponent_Conditional_7_Template, 2, 0)(8, IgxExcelStyleCustomDialogComponent_Conditional_8_Template, 2, 0);
            i0.ɵɵelementStart(9, "button", 6);
            i0.ɵɵlistener("click", function IgxExcelStyleCustomDialogComponent_Template_button_click_9_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onAddButtonClick());
            });
            i0.ɵɵelement(10, "igx-icon", 7);
            i0.ɵɵelementStart(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(13, "footer", 8)(14, "div", 9)(15, "button", 10);
            i0.ɵɵlistener("click", function IgxExcelStyleCustomDialogComponent_Template_button_click_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClearButtonClick());
            });
            i0.ɵɵtext(16);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 11)(18, "button", 10);
            i0.ɵɵlistener("click", function IgxExcelStyleCustomDialogComponent_Template_button_click_18_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.cancelDialog());
            });
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 12)(21, "button", 13);
            i0.ɵɵlistener("click", function IgxExcelStyleCustomDialogComponent_Template_button_click_21_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onApplyButtonClick());
            })("keydown", function IgxExcelStyleCustomDialogComponent_Template_button_keydown_21_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onApplyButtonKeyDown($event));
            });
            i0.ɵɵtext(22);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c119, ctx.grid.gridSize === "2", ctx.grid.gridSize === "1"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2(" ", ctx.grid.resourceStrings.igx_grid_excel_custom_dialog_header, "", ctx.column.header || ctx.column.field, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.column.dataType === "date" || ctx.column.dataType === "dateTime" || ctx.column.dataType === "time" ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.column.dataType !== "date" && ctx.column.dataType !== "dateTime" && ctx.column.dataType !== "time" ? 8 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.grid.resourceStrings.igx_grid_excel_custom_dialog_add);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.grid.resourceStrings.igx_grid_excel_custom_dialog_clear, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.grid.resourceStrings.igx_grid_excel_cancel, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.grid.resourceStrings.igx_grid_excel_apply, " ");
          }
        },
        dependencies: [IgxToggleDirective, NgClass, IgxExcelStyleDateExpressionComponent, IgxExcelStyleDefaultExpressionComponent, IgxButtonDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleCustomDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style conditional filter UI.
 */
let IgxExcelStyleConditionalFilterComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleConditionalFilterComponent {
    get filterNumber() {
      return this.esf.expressionsList.filter(e => e.expression.condition).length;
    }
    constructor(esf, platform) {
      this.esf = esf;
      this.platform = platform;
      this.shouldOpenSubMenu = true;
      this.destroy$ = new Subject();
      this._subMenuPositionSettings = {
        verticalStartPoint: VerticalAlignment.Top
      };
      this._subMenuOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new AutoPositionStrategy(this._subMenuPositionSettings),
        scrollStrategy: new AbsoluteScrollStrategy()
      };
      this.esf.columnChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.esf.grid) {
          this.shouldOpenSubMenu = true;
          this._subMenuOverlaySettings.outlet = this.esf.grid.outlet;
        }
      });
      if (this.esf.grid) {
        this._subMenuOverlaySettings.outlet = this.esf.grid.outlet;
      }
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden @internal
     */
    onTextFilterKeyDown(eventArgs) {
      if (eventArgs.key === this.platform.KEYMAP.ENTER) {
        this.onTextFilterClick(eventArgs);
      } else if (eventArgs.key === this.platform.KEYMAP.TAB) {
        this.subMenu.close();
      }
    }
    /**
     * @hidden @internal
     */
    onTextFilterClick(eventArgs) {
      if (this.shouldOpenSubMenu) {
        this._subMenuOverlaySettings.target = eventArgs.currentTarget;
        const gridRect = this.esf.grid.nativeElement.getBoundingClientRect();
        const dropdownRect = this.esf.mainDropdown.nativeElement.getBoundingClientRect();
        let x = dropdownRect.left + dropdownRect.width;
        let x1 = gridRect.left + gridRect.width;
        x += window.pageXOffset;
        x1 += window.pageXOffset;
        if (Math.abs(x - x1) < 200) {
          this._subMenuOverlaySettings.positionStrategy.settings.horizontalDirection = HorizontalAlignment.Left;
          this._subMenuOverlaySettings.positionStrategy.settings.horizontalStartPoint = HorizontalAlignment.Left;
        } else {
          this._subMenuOverlaySettings.positionStrategy.settings.horizontalDirection = HorizontalAlignment.Right;
          this._subMenuOverlaySettings.positionStrategy.settings.horizontalStartPoint = HorizontalAlignment.Right;
        }
        this.subMenu.open(this._subMenuOverlaySettings);
        this.shouldOpenSubMenu = false;
      }
    }
    /**
     * @hidden @internal
     */
    getCondition(value) {
      return this.esf.column.filters.condition(value);
    }
    getSelectedCondition(condition) {
      const expressions = this.esf.expressionsList;
      if (expressions.length < 1) {
        return false;
      }
      return expressions.length === 1 ? expressions[0].expression.condition.name === condition : condition === 'custom';
    }
    /**
     * @hidden @internal
     */
    translateCondition(value) {
      return this.esf.grid.resourceStrings[`igx_grid_filter_${this.getCondition(value).name}`] || value;
    }
    /**
     * @hidden @internal
     */
    onSubMenuSelection(eventArgs) {
      if (this.esf.expressionsList && this.esf.expressionsList.length && this.esf.expressionsList[0].expression.condition.name !== 'in') {
        this.customDialog.expressionsList = this.esf.expressionsList;
      } else {
        this.customDialog.expressionsList = this.customDialog.expressionsList.filter(e => e.expression.fieldName === this.esf.column.field && e.expression.condition);
      }
      this.customDialog.selectedOperator = eventArgs.newSelection.value;
      eventArgs.cancel = true;
      if (this.esf.overlayComponentId) {
        this.esf.hide();
      }
      this.subMenu.close();
      this.customDialog.open(this.esf.mainDropdown.nativeElement);
    }
    /**
     * @hidden @internal
     */
    onSubMenuClosed() {
      requestAnimationFrame(() => {
        this.shouldOpenSubMenu = true;
      });
    }
    /**
     * @hidden @internal
     */
    showCustomFilterItem() {
      const exprTree = this.esf.column.filteringExpressionsTree;
      return exprTree && exprTree.filteringOperands && exprTree.filteringOperands.length && !(exprTree.filteringOperands[0].condition && exprTree.filteringOperands[0].condition.name === 'in');
    }
    /**
     * @hidden @internal
     */
    get subMenuText() {
      switch (this.esf.column.dataType) {
        case GridColumnDataType.Boolean:
          return this.esf.grid.resourceStrings.igx_grid_excel_boolean_filter;
        case GridColumnDataType.Number:
        case GridColumnDataType.Percent:
          return this.esf.grid.resourceStrings.igx_grid_excel_number_filter;
        case GridColumnDataType.Date:
        case GridColumnDataType.DateTime:
        case GridColumnDataType.Time:
          return this.esf.grid.resourceStrings.igx_grid_excel_date_filter;
        case GridColumnDataType.Currency:
          return this.esf.grid.resourceStrings.igx_grid_excel_currency_filter;
        default:
          return this.esf.grid.resourceStrings.igx_grid_excel_text_filter;
      }
    }
    /**
     * @hidden @internal
     */
    get conditions() {
      return this.esf.column.filters.conditionList();
    }
    static {
      this.ɵfac = function IgxExcelStyleConditionalFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleConditionalFilterComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleConditionalFilterComponent,
        selectors: [["igx-excel-style-conditional-filter"]],
        viewQuery: function IgxExcelStyleConditionalFilterComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c120, 5, IgxExcelStyleCustomDialogComponent);
            i0.ɵɵviewQuery(_c121, 5, IgxDropDownComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customDialog = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subMenu = _t.first);
          }
        },
        decls: 1,
        vars: 1,
        consts: [["subMenu", ""], ["customDialog", ""], ["tabindex", "0", "role", "menuitem", "aria-haspopup", "true", 1, "igx-excel-filter__actions-filter", 3, "keydown", "click", "ngClass", "igxDropDownItemNavigation"], [1, "igx-excel-filter__filter-number"], ["name", "chevron_right", "family", "default"], [3, "selectionChanging", "closed", "maxHeight"], [3, "selected", "value"], [3, "selected"], [3, "column", "filteringService", "overlayComponentId"], [1, "igx-grid__filtering-dropdown-items"], ["family", "default", 3, "name"], [1, "igx-grid__filtering-dropdown-text"], ["name", "filter_list", "family", "default"]],
        template: function IgxExcelStyleConditionalFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleConditionalFilterComponent_Conditional_0_Template, 13, 11);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [NgClass, IgxDropDownItemNavigationDirective, IgxIconComponent, IgxDropDownComponent, IgxDropDownItemComponent, IgxExcelStyleCustomDialogComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleConditionalFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style header UI.
 */
let IgxExcelStyleHeaderComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleHeaderComponent {
    constructor(esf) {
      this.esf = esf;
    }
    static {
      this.ɵfac = function IgxExcelStyleHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleHeaderComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleHeaderComponent,
        selectors: [["igx-excel-style-header"]],
        inputs: {
          showPinning: [2, "showPinning", "showPinning", booleanAttribute],
          showSelecting: [2, "showSelecting", "showSelecting", booleanAttribute],
          showHiding: [2, "showHiding", "showHiding", booleanAttribute]
        },
        decls: 1,
        vars: 1,
        consts: [[1, "igx-excel-filter__menu-header"], [1, "igx-excel-filter__menu-header-actions"], ["type", "button", "igxIconButton", "flat", 3, "ngClass"], ["type", "button", "igxIconButton", "flat"], ["type", "button", "igxIconButton", "flat", 3, "click", "ngClass"], ["family", "default", "name", "selected"], ["type", "button", "igxIconButton", "flat", 3, "click"], ["family", "default", 3, "name"]],
        template: function IgxExcelStyleHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleHeaderComponent_Conditional_0_Template, 7, 4, "header", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [NgClass, IgxIconComponent, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style column hiding UI.
 */
let IgxExcelStyleHidingComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleHidingComponent {
    constructor(esf) {
      this.esf = esf;
    }
    static {
      this.ɵfac = function IgxExcelStyleHidingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleHidingComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleHidingComponent,
        selectors: [["igx-excel-style-hiding"]],
        decls: 1,
        vars: 1,
        consts: [["tabindex", "0", "role", "menuitem", 1, "igx-excel-filter__actions-hide"], ["tabindex", "0", "role", "menuitem", 1, "igx-excel-filter__actions-hide", 3, "click"], ["family", "default", 3, "name"]],
        template: function IgxExcelStyleHidingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleHidingComponent_Conditional_0_Template, 4, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleHidingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style column moving UI.
 */
let IgxExcelStyleMovingComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleMovingComponent {
    constructor(esf) {
      this.esf = esf;
      /**
       * @hidden @internal
       */
      this.defaultClass = true;
    }
    get visibleColumns() {
      return this.esf.grid.visibleColumns.filter(col => !col.columnGroup);
    }
    /**
     * @hidden @internal
     */
    get canNotMoveLeft() {
      return this.esf.column.visibleIndex === 0 || this.esf.grid.unpinnedColumns.indexOf(this.esf.column) === 0 && this.esf.column.disablePinning || this.esf.column.level !== 0 && !this.findColumn(0, this.visibleColumns);
    }
    /**
     * @hidden @internal
     */
    get canNotMoveRight() {
      return this.esf.column.visibleIndex === this.visibleColumns.length - 1 || this.esf.column.level !== 0 && !this.findColumn(1, this.visibleColumns);
    }
    /**
     * @hidden @internal
     */
    onMoveButtonClicked(moveDirection) {
      let targetColumn;
      if (this.esf.column.pinned) {
        if (this.esf.column.isLastPinned && moveDirection === 1 && this.esf.grid.isPinningToStart) {
          targetColumn = this.esf.grid.unpinnedColumns[0];
          moveDirection = 0;
        } else if (this.esf.column.isFirstPinned && moveDirection === 0 && !this.esf.grid.isPinningToStart) {
          targetColumn = this.esf.grid.unpinnedColumns[this.esf.grid.unpinnedColumns.length - 1];
          moveDirection = 1;
        } else {
          targetColumn = this.findColumn(moveDirection, this.esf.grid.pinnedColumns);
        }
      } else if (this.esf.grid.unpinnedColumns.indexOf(this.esf.column) === 0 && moveDirection === 0 && this.esf.grid.isPinningToStart) {
        targetColumn = this.esf.grid.pinnedColumns[this.esf.grid.pinnedColumns.length - 1];
        if (targetColumn.parent) {
          targetColumn = targetColumn.topLevelParent;
        }
        moveDirection = 1;
      } else if (this.esf.grid.unpinnedColumns.indexOf(this.esf.column) === this.esf.grid.unpinnedColumns.length - 1 && moveDirection === 1 && !this.esf.grid.isPinningToStart) {
        targetColumn = this.esf.grid.pinnedColumns[0];
        moveDirection = 0;
      } else {
        targetColumn = this.findColumn(moveDirection, this.esf.grid.unpinnedColumns);
      }
      this.esf.grid.moveColumn(this.esf.column, targetColumn, moveDirection);
    }
    get esfSize() {
      const esf = this.esf;
      return esf.size;
    }
    findColumn(moveDirection, columns) {
      let index = columns.indexOf(this.esf.column);
      if (moveDirection === 0) {
        while (index > 0) {
          index--;
          if (columns[index].level === this.esf.column.level && columns[index].parent === this.esf.column.parent) {
            return columns[index];
          }
        }
        return columns[0];
      } else {
        while (index < columns.length - 1) {
          index++;
          if (columns[index].level === this.esf.column.level && columns[index].parent === this.esf.column.parent) {
            return columns[index];
          }
        }
      }
    }
    static {
      this.ɵfac = function IgxExcelStyleMovingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleMovingComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleMovingComponent,
        selectors: [["igx-excel-style-moving"]],
        hostVars: 2,
        hostBindings: function IgxExcelStyleMovingComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-excel-filter__move", ctx.defaultClass);
          }
        },
        decls: 1,
        vars: 1,
        consts: [["type", "button", "igxButton", "", 3, "click", "disabled"], ["family", "default", "name", "arrow_back"], ["family", "default", "name", "arrow_forward"]],
        template: function IgxExcelStyleMovingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleMovingComponent_Conditional_0_Template, 11, 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [IgxButtonGroupComponent, IgxButtonDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleMovingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style column pinning UI.
 */
let IgxExcelStylePinningComponent = /*#__PURE__*/(() => {
  class IgxExcelStylePinningComponent {
    constructor(esf) {
      this.esf = esf;
    }
    static {
      this.ɵfac = function IgxExcelStylePinningComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStylePinningComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStylePinningComponent,
        selectors: [["igx-excel-style-pinning"]],
        decls: 1,
        vars: 1,
        consts: [["tabindex", "0", "role", "menuitem", 3, "ngClass"], ["tabindex", "0", "role", "menuitem", 3, "click", "ngClass"], ["family", "default", 3, "name"]],
        template: function IgxExcelStylePinningComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStylePinningComponent_Conditional_0_Template, 4, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [NgClass, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStylePinningComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxProgressBarTextTemplateDirective = /*#__PURE__*/(() => {
  class IgxProgressBarTextTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxProgressBarTextTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxProgressBarTextTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxProgressBarTextTemplateDirective,
        selectors: [["", "igxProgressBarText", ""]]
      });
    }
  }
  return IgxProgressBarTextTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxProgressBarGradientDirective = /*#__PURE__*/(() => {
  class IgxProgressBarGradientDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxProgressBarGradientDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxProgressBarGradientDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxProgressBarGradientDirective,
        selectors: [["", "igxProgressBarGradient", ""]]
      });
    }
  }
  return IgxProgressBarGradientDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ONE_PERCENT = 0.01;
const MIN_VALUE = 0;
const IgxTextAlign = /*@__PURE__*/mkenum({
  START: 'start',
  CENTER: 'center',
  END: 'end'
});
const IgxProgressType = /*@__PURE__*/mkenum({
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success'
});
const valueInRange = (value, max, min = 0) => Math.max(Math.min(value, max), min);
/**
 * @hidden
 */
let BaseProgressDirective = /*#__PURE__*/(() => {
  class BaseProgressDirective {
    constructor() {
      /**
       * An event, which is triggered after progress is changed.
       * ```typescript
       * public progressChange(event) {
       *     alert("Progress made!");
       * }
       *  //...
       * ```
       * ```html
       * <igx-circular-bar (progressChanged)="progressChange($event)"></igx-circular-bar>
       * <igx-linear-bar (progressChanged)="progressChange($event)"></igx-linear-bar>
       * ```
       */
      this.progressChanged = new EventEmitter();
      /**
       * Sets/Gets progressbar animation duration. By default, it is 2000ms.
       * ```html
       * <igx-linear-bar [animationDuration]="3000"></igx-linear-bar>
       * <igx-circular-bar [animationDuration]="3000"></igx-linear-bar>
       * ```
       */
      this.animationDuration = 2000;
      this._contentInit = false;
      this._indeterminate = false;
      this._max = 100;
      this._value = MIN_VALUE;
      this._animate = true;
      this._fraction = 0;
      this._integer = 0;
      this._cdr = inject(ChangeDetectorRef);
      this._zone = inject(NgZone);
    }
    /**
     * Sets progressbar in indeterminate. By default, it is set to false.
     * ```html
     * <igx-linear-bar [indeterminate]="true"></igx-linear-bar>
     * <igx-circular-bar [indeterminate]="true"></igx-circular-bar>
     * ```
     */
    set indeterminate(isIndeterminate) {
      this._indeterminate = isIndeterminate;
      this._resetCounterValues(this._indeterminate); // Use the helper for indeterminate condition
    }
    /**
     * Gets the current state of the progress bar:
     * - `true` if in the indeterminate state (no progress value displayed),
     * - `false` if the progress bar shows the actual progress.
     *
     * ```typescript
     * const isIndeterminate = progressBar.indeterminate;
     * ```
    */
    get indeterminate() {
      return this._indeterminate;
    }
    /**
     * Returns the value which update the progress indicator of the `progress bar`.
     * ```typescript
     * @ViewChild("MyProgressBar")
     * public progressBar: IgxLinearProgressBarComponent | IgxCircularBarComponent;
     * public stepValue(event) {
     *     let step = this.progressBar.step;
     *     alert(step);
     * }
     * ```
     */
    get step() {
      if (this._step) {
        return this._step;
      }
      return this._max * ONE_PERCENT;
    }
    /**
     * Sets the value by which progress indicator is updated. By default, it is 1.
     * ```html
     * <igx-linear-bar [step]="1"></igx-linear-bar>
     * <igx-circular-bar [step]="1"></igx-circular-bar>
     * ```
     */
    set step(val) {
      const step = Number(val);
      if (step > this.max) {
        return;
      }
      this._step = step;
    }
    /**
     * Set a custom text. This will hide the counter value.
     * ```html
     * <igx-circular-bar text="my text"></igx-circular-bar>
     * ```
     */
    set text(value) {
      this._text = value;
      this._resetCounterValues(!!this._text); // Use the helper for text condition
    }
    /**
     * Gets a custom text.
     * ```typescript
     * let text = this.circularBar.text;
     * ```
     */
    get text() {
      return this._text;
    }
    /**
     * Animating the progress. By default, it is set to true.
     * ```html
     * <igx-linear-bar [animate]="false"></igx-linear-bar>
     * <igx-circular-bar [animate]="false"></igx-circular-bar>
     * ```
     */
    set animate(animate) {
      this._animate = animate;
    }
    /**
     * Returns whether the `progress bar` has animation true/false.
     * ```typescript
     * @ViewChild("MyProgressBar")
     * public progressBar: IgxLinearProgressBarComponent | IgxCircularBarComponent;
     * public animationStatus(event) {
     *     let animationStatus = this.progressBar.animate;
     *     alert(animationStatus);
     * }
     * ```
     */
    get animate() {
      return this._animate;
    }
    /**
     * Set maximum value that can be passed. By default it is set to 100.
     * ```html
     * <igx-linear-bar [max]="200"></igx-linear-bar>
     * <igx-circular-bar [max]="200"></igx-circular-bar>
     * ```
     */
    set max(maxNum) {
      // Ignore invalid or unchanged max
      if (maxNum < MIN_VALUE || this._max === maxNum) {
        return;
      }
      this._max = maxNum;
      // Revalidate current value
      this._value = valueInRange(this._value, this._max);
      // Refresh CSS variables
      this._updateProgressValues();
    }
    /**
     * Returns the maximum progress value of the `progress bar`.
     * ```typescript
     * @ViewChild("MyProgressBar")
     * public progressBar: IgxLinearProgressBarComponent | IgxCircularBarComponent;
     * public maxValue(event) {
     *     let max = this.progressBar.max;
     *     alert(max);
     * }
     * ```
     */
    get max() {
      return this._max;
    }
    get progressInteger() {
      return this._integer.toString();
    }
    get progressFraction() {
      return this._fraction.toString();
    }
    get progressWhole() {
      return this.valueInPercent.toFixed(2);
    }
    get transitionDuration() {
      return `${this.animationDuration}ms`;
    }
    /**
     * @hidden
     */
    get hasFraction() {
      const percentage = this.valueInPercent;
      const integerPart = Math.floor(percentage);
      const fractionalPart = percentage - integerPart;
      return fractionalPart > 0;
    }
    /**
     * Returns the `IgxLinearProgressBarComponent`/`IgxCircularProgressBarComponent` value in percentage.
     * ```typescript
     * @ViewChild("MyProgressBar")
     * public progressBar: IgxLinearProgressBarComponent / IgxCircularProgressBarComponent
     * public valuePercent(event){
     *     let percentValue = this.progressBar.valueInPercent;
     *     alert(percentValue);
     * }
     * ```
     */
    get valueInPercent() {
      const result = this.max > 0 ? this._value / this.max * 100 : 0;
      return Math.round(result * 100) / 100; // Round to two decimal places
    }
    /**
     * Returns value that indicates the current `IgxLinearProgressBarComponent`/`IgxCircularProgressBarComponent` position.
     * ```typescript
     * @ViewChild("MyProgressBar")
     * public progressBar: IgxLinearProgressBarComponent / IgxCircularProgressBarComponent;
     * public getValue(event) {
     *     let value = this.progressBar.value;
     *     alert(value);
     * }
     * ```
     */
    get value() {
      return this._value;
    }
    /**
     * @hidden
     */
    _updateProgressValues() {
      const percentage = this.valueInPercent;
      const integerPart = Math.floor(percentage);
      const fractionalPart = Math.round(percentage % 1 * 100);
      this._integer = integerPart;
      this._fraction = fractionalPart;
    }
    _resetCounterValues(condition) {
      if (condition) {
        this._integer = 0;
        this._fraction = 0;
      } else {
        this._zone.runOutsideAngular(() => {
          setTimeout(() => {
            this._updateProgressValues();
            this._cdr.markForCheck();
          });
        });
      }
    }
    /**
     * Set value that indicates the current `IgxLinearProgressBarComponent / IgxCircularProgressBarComponent` position.
     * ```html
     * <igx-linear-bar [value]="50"></igx-linear-bar>
     * <igx-circular-bar [value]="50"></igx-circular-bar>
     * ```
     */
    set value(val) {
      const valInRange = valueInRange(val, this.max); // Ensure value is in range
      // Avoid redundant updates
      if (isNaN(valInRange) || this._value === valInRange) {
        return;
      }
      const previousValue = this._value;
      // Update internal value
      this._value = valInRange;
      this._zone.runOutsideAngular(() => {
        setTimeout(() => {
          this._updateProgressValues();
          this._cdr.markForCheck();
        });
      });
      // Emit the progressChanged event
      this.progressChanged.emit({
        previousValue,
        currentValue: this._value
      });
    }
    static {
      this.ɵfac = function BaseProgressDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseProgressDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseProgressDirective,
        hostVars: 10,
        hostBindings: function BaseProgressDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-valuemax", ctx.max)("aria-valuenow", ctx.value);
            i0.ɵɵstyleProp("--_progress-integer", ctx.progressInteger)("--_progress-fraction", ctx.progressFraction)("--_progress-whole", ctx.progressWhole)("--_transition-duration", ctx.transitionDuration);
          }
        },
        inputs: {
          animationDuration: "animationDuration",
          indeterminate: [2, "indeterminate", "indeterminate", booleanAttribute],
          step: "step",
          text: "text",
          animate: [2, "animate", "animate", booleanAttribute],
          max: "max",
          value: "value"
        },
        outputs: {
          progressChanged: "progressChanged"
        }
      });
    }
  }
  return BaseProgressDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_LINEAR_ID = 0;
let NEXT_CIRCULAR_ID = 0;
let NEXT_GRADIENT_ID = 0;
let IgxLinearProgressBarComponent = /*#__PURE__*/(() => {
  class IgxLinearProgressBarComponent extends BaseProgressDirective {
    constructor() {
      super(...arguments);
      this.valueMin = 0;
      this.cssClass = 'igx-linear-bar';
      /**
       * Set `IgxLinearProgressBarComponent` to have striped style. By default it is set to false.
       * ```html
       * <igx-linear-bar [striped]="true" [max]="200" [value]="50"></igx-linear-bar>
       * ```
       */
      this.striped = false;
      /**
       * Sets the value of the `role` attribute. If not provided it will be automatically set to `progressbar`.
       * ```html
       * <igx-linear-bar role="progressbar"></igx-linear-bar>
       * ```
       */
      this.role = 'progressbar';
      /**
       * Sets the value of `id` attribute. If not provided it will be automatically generated.
       * ```html
       * <igx-linear-bar [id]="'igx-linear-bar-55'" [striped]="true" [max]="200" [value]="50"></igx-linear-bar>
       * ```
       */
      this.id = `igx-linear-bar-${NEXT_LINEAR_ID++}`;
      /**
       * Set the position that defines where the text is aligned.
       * Possible options - `IgxTextAlign.START` (default), `IgxTextAlign.CENTER`, `IgxTextAlign.END`.
       * ```typescript
       * public positionCenter: IgxTextAlign;
       * public ngOnInit() {
       *     this.positionCenter = IgxTextAlign.CENTER;
       * }
       *  //...
       * ```
       *  ```html
       * <igx-linear-bar [textAlign]="positionCenter"></igx-linear-bar>
       * ```
       */
      this.textAlign = IgxTextAlign.START;
      /**
       * Set the text to be visible. By default, it is set to true.
       * ```html
       *  <igx-linear-bar [textVisibility]="false"></igx-linear-bar>
       * ```
       */
      this.textVisibility = true;
      /**
       * Set the position that defines if the text should be aligned above the progress line. By default, is set to false.
       * ```html
       *  <igx-linear-bar [textTop]="true"></igx-linear-bar>
       * ```
       */
      this.textTop = false;
      /**
       * Set type of the `IgxLinearProgressBarComponent`. Possible options - `default`, `success`, `info`, `warning`, and `error`.
       * ```html
       * <igx-linear-bar [type]="'error'"></igx-linear-bar>
       * ```
       */
      this.type = 'default';
    }
    /**
     * @hidden
     * ```
     */
    get isIndeterminate() {
      return this.indeterminate;
    }
    /**
     * @hidden
     */
    get disableAnimationClass() {
      return !this._animate;
    }
    /**
     * @hidden
     */
    get hasText() {
      return !!this.text;
    }
    /**
     * @hidden
     */
    get error() {
      return this.type === IgxProgressType.ERROR;
    }
    /**
     * @hidden
     */
    get info() {
      return this.type === IgxProgressType.INFO;
    }
    /**
     * @hidden
     */
    get warning() {
      return this.type === IgxProgressType.WARNING;
    }
    /**
     * @hidden
     */
    get success() {
      return this.type === IgxProgressType.SUCCESS;
    }
    ngAfterContentInit() {
      this._contentInit = true;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxLinearProgressBarComponent_BaseFactory;
        return function IgxLinearProgressBarComponent_Factory(__ngFactoryType__) {
          return (ɵIgxLinearProgressBarComponent_BaseFactory || (ɵIgxLinearProgressBarComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxLinearProgressBarComponent)))(__ngFactoryType__ || IgxLinearProgressBarComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxLinearProgressBarComponent,
        selectors: [["igx-linear-bar"]],
        hostVars: 21,
        hostBindings: function IgxLinearProgressBarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-valuemin", ctx.valueMin)("role", ctx.role)("id", ctx.id);
            i0.ɵɵclassProp("igx-linear-bar", ctx.cssClass)("igx-linear-bar--striped", ctx.striped)("igx-linear-bar--indeterminate", ctx.isIndeterminate)("igx-linear-bar--animation-none", ctx.disableAnimationClass)("igx-linear-bar--hide-counter", ctx.hasText)("igx-linear-bar--danger", ctx.error)("igx-linear-bar--info", ctx.info)("igx-linear-bar--warning", ctx.warning)("igx-linear-bar--success", ctx.success);
          }
        },
        inputs: {
          striped: [2, "striped", "striped", booleanAttribute],
          role: "role",
          id: "id",
          textAlign: "textAlign",
          textVisibility: [2, "textVisibility", "textVisibility", booleanAttribute],
          textTop: [2, "textTop", "textTop", booleanAttribute],
          type: "type"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 9,
        consts: [[1, "igx-linear-bar__base"], [1, "igx-linear-bar__indicator"], [1, "igx-linear-bar__indicator-secondary"], [1, "igx-linear-bar__value", 3, "ngClass"]],
        template: function IgxLinearProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1)(2, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(2, _c122, ctx.textAlign === "start", ctx.textAlign === "center", ctx.textAlign === "end", ctx.textTop, !ctx.textVisibility, ctx.hasFraction));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.text, " ");
          }
        },
        dependencies: [NgClass],
        encapsulation: 2
      });
    }
  }
  return IgxLinearProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCircularProgressBarComponent = /*#__PURE__*/(() => {
  class IgxCircularProgressBarComponent extends BaseProgressDirective {
    /**
     * @hidden
     */
    get isIndeterminate() {
      return this.indeterminate;
    }
    /**
     * @hidden
     */
    get disableAnimationClass() {
      return !this._animate;
    }
    /**
     * @hidden
     */
    get hasText() {
      return !!this.text;
    }
    /**
     * @hidden
     */
    get context() {
      return {
        $implicit: {
          value: this.value,
          valueInPercent: this.valueInPercent,
          max: this.max
        }
      };
    }
    /**
     * @hidden
     */
    get textContent() {
      return this.text;
    }
    constructor(renderer) {
      super();
      this.renderer = renderer;
      /**
       * @hidden
       */
      this.cssClass = 'igx-circular-bar';
      /**
       * Sets the value of `id` attribute. If not provided it will be automatically generated.
       * ```html
       * <igx-circular-bar [id]="'igx-circular-bar-55'"></igx-circular-bar>
       * ```
       */
      this.id = `igx-circular-bar-${NEXT_CIRCULAR_ID++}`;
      /**
       * Sets the text visibility. By default, it is set to true.
       * ```html
       * <igx-circular-bar [textVisibility]="false"></igx-circular-bar>
       * ```
       */
      this.textVisibility = true;
      /**
       * @hidden
       */
      this.gradientId = `igx-circular-gradient-${NEXT_GRADIENT_ID++}`;
      /**
       * Set type of the `IgxCircularProgressBarComponent`. Possible options - `default`, `success`, `info`, `warning`, and `error`.
       * ```html
       * <igx-circular-bar [type]="'error'"></igx-circular-bar>
       * ```
       */
      this.type = 'default';
    }
    /**
     * @hidden
     */
    get error() {
      return this.type === IgxProgressType.ERROR;
    }
    /**
     * @hidden
     */
    get info() {
      return this.type === IgxProgressType.INFO;
    }
    /**
     * @hidden
     */
    get warning() {
      return this.type === IgxProgressType.WARNING;
    }
    /**
     * @hidden
     */
    get success() {
      return this.type === IgxProgressType.SUCCESS;
    }
    /**
     * @hidden
     */
    get strokeStyle() {
      return this.type === 'default' ? `url(#${this.gradientId})` : 'none';
    }
    ngAfterContentInit() {
      this._contentInit = true;
    }
    static {
      this.ɵfac = function IgxCircularProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCircularProgressBarComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxCircularProgressBarComponent,
        selectors: [["igx-circular-bar"]],
        contentQueries: function IgxCircularProgressBarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxProgressBarTextTemplateDirective, 5, IgxProgressBarTextTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxProgressBarGradientDirective, 5, IgxProgressBarGradientDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gradientTemplate = _t.first);
          }
        },
        viewQuery: function IgxCircularProgressBarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c123, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._svgCircle = _t.first);
          }
        },
        hostVars: 19,
        hostBindings: function IgxCircularProgressBarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("stroke", ctx.strokeStyle);
            i0.ɵɵclassProp("igx-circular-bar", ctx.cssClass)("igx-circular-bar--indeterminate", ctx.isIndeterminate)("igx-circular-bar--animation-none", ctx.disableAnimationClass)("igx-circular-bar--hide-counter", ctx.hasText)("igx-circular-bar--danger", ctx.error)("igx-circular-bar--info", ctx.info)("igx-circular-bar--warning", ctx.warning)("igx-circular-bar--success", ctx.success);
          }
        },
        inputs: {
          id: "id",
          textVisibility: [2, "textVisibility", "textVisibility", booleanAttribute],
          type: "type"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 12,
        vars: 7,
        consts: [["svg", ""], ["circle", ""], ["defaultGradientTemplate", ""], ["defaultTextTemplate", ""], ["role", "progressbar", "aria-valuemin", "0"], [1, "igx-circular-bar__inner"], [1, "igx-circular-bar__outer"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-circular-bar__text", 3, "ngClass"], ["gradientTransform", "rotate(90)", 3, "id"], ["offset", "0%", 1, "igx-circular-bar__gradient-start"], ["offset", "100%", 1, "igx-circular-bar__gradient-end"]],
        template: function IgxCircularProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 4, 0);
            i0.ɵɵelement(2, "circle", 5)(3, "circle", 6, 1);
            i0.ɵɵelementStart(5, "defs");
            i0.ɵɵtemplate(6, IgxCircularProgressBarComponent__svg_ng_container_6_Template, 1, 0, "ng-container", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, IgxCircularProgressBarComponent__svg_ng_template_7_Template, 3, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, IgxCircularProgressBarComponent_Conditional_9_Template, 2, 3, "span", 8)(10, IgxCircularProgressBarComponent_ng_template_10_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const defaultGradientTemplate_r3 = i0.ɵɵreference(8);
            i0.ɵɵattribute("aria-valuemax", ctx.max)("aria-valuenow", ctx.value);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.gradientTemplate ? ctx.gradientTemplate.template : defaultGradientTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c25, ctx.gradientId));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.textVisibility ? 9 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, NgClass],
        encapsulation: 2
      });
    }
  }
  return IgxCircularProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TreeResourceStringsEN = {
  igx_expand: 'Expand',
  igx_collapse: 'Collapse'
};

// Enums
const IgxTreeSelectionType = /*@__PURE__*/mkenum({
  None: 'None',
  BiState: 'BiState',
  Cascading: 'Cascading'
});
// Token
const IGX_TREE_COMPONENT = /*@__PURE__*/new InjectionToken('IgxTreeToken');
const IGX_TREE_NODE_COMPONENT = /*@__PURE__*/new InjectionToken('IgxTreeNodeToken');

/** @hidden @internal */
let IgxTreeService = /*#__PURE__*/(() => {
  class IgxTreeService {
    constructor() {
      this.expandedNodes = new Set();
      this.collapsingNodes = new Set();
      this.siblingComparer = (data, node) => node !== data && node.level === data.level;
    }
    /**
     * Adds the node to the `expandedNodes` set and fires the nodes change event
     *
     * @param node target node
     * @param uiTrigger is the event triggered by a ui interraction (so we know if we should animate)
     * @returns void
     */
    expand(node, uiTrigger) {
      this.collapsingNodes.delete(node);
      if (!this.expandedNodes.has(node)) {
        node.expandedChange.emit(true);
      } else {
        return;
      }
      this.expandedNodes.add(node);
      if (this.tree.singleBranchExpand) {
        this.tree.findNodes(node, this.siblingComparer)?.forEach(e => {
          if (uiTrigger) {
            e.collapse();
          } else {
            e.expanded = false;
          }
        });
      }
    }
    /**
     * Adds a node to the `collapsing` collection
     *
     * @param node target node
     */
    collapsing(node) {
      this.collapsingNodes.add(node);
    }
    /**
     * Removes the node from the 'expandedNodes' set and emits the node's change event
     *
     * @param node target node
     * @returns void
     */
    collapse(node) {
      if (this.expandedNodes.has(node)) {
        node.expandedChange.emit(false);
      }
      this.collapsingNodes.delete(node);
      this.expandedNodes.delete(node);
    }
    isExpanded(node) {
      return this.expandedNodes.has(node);
    }
    register(tree) {
      this.tree = tree;
    }
    static {
      this.ɵfac = function IgxTreeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTreeService,
        factory: IgxTreeService.ɵfac
      });
    }
  }
  return IgxTreeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let IgxTreeSelectionService = /*#__PURE__*/(() => {
  class IgxTreeSelectionService {
    constructor() {
      this.nodeSelection = new Set();
      this.indeterminateNodes = new Set();
    }
    register(tree) {
      this.tree = tree;
    }
    /** Select range from last selected node to the current specified node. */
    selectMultipleNodes(node, event) {
      if (!this.nodeSelection.size) {
        this.selectNode(node);
        return;
      }
      const lastSelectedNodeIndex = this.tree.nodes.toArray().indexOf(this.getSelectedNodes()[this.nodeSelection.size - 1]);
      const currentNodeIndex = this.tree.nodes.toArray().indexOf(node);
      const nodes = this.tree.nodes.toArray().slice(Math.min(currentNodeIndex, lastSelectedNodeIndex), Math.max(currentNodeIndex, lastSelectedNodeIndex) + 1);
      const added = nodes.filter(_node => !this.isNodeSelected(_node));
      const newSelection = this.getSelectedNodes().concat(added);
      this.emitNodeSelectionEvent(newSelection, added, [], event);
    }
    /** Select the specified node and emit event. */
    selectNode(node, event) {
      if (this.tree.selection === IgxTreeSelectionType.None) {
        return;
      }
      this.emitNodeSelectionEvent([...this.getSelectedNodes(), node], [node], [], event);
    }
    /** Deselect the specified node and emit event. */
    deselectNode(node, event) {
      const newSelection = this.getSelectedNodes().filter(r => r !== node);
      this.emitNodeSelectionEvent(newSelection, [], [node], event);
    }
    /** Clears node selection */
    clearNodesSelection() {
      this.nodeSelection.clear();
      this.indeterminateNodes.clear();
    }
    isNodeSelected(node) {
      return this.nodeSelection.has(node);
    }
    isNodeIndeterminate(node) {
      return this.indeterminateNodes.has(node);
    }
    /** Select specified nodes. No event is emitted. */
    selectNodesWithNoEvent(nodes, clearPrevSelection = false, shouldEmit = true) {
      if (this.tree && this.tree.selection === IgxTreeSelectionType.Cascading) {
        this.cascadeSelectNodesWithNoEvent(nodes, clearPrevSelection);
        return;
      }
      const oldSelection = this.getSelectedNodes();
      if (clearPrevSelection) {
        this.nodeSelection.clear();
      }
      nodes.forEach(node => this.nodeSelection.add(node));
      if (shouldEmit) {
        this.emitSelectedChangeEvent(oldSelection);
      }
    }
    /** Deselect specified nodes. No event is emitted. */
    deselectNodesWithNoEvent(nodes, shouldEmit = true) {
      const oldSelection = this.getSelectedNodes();
      if (!nodes) {
        this.nodeSelection.clear();
      } else if (this.tree && this.tree.selection === IgxTreeSelectionType.Cascading) {
        this.cascadeDeselectNodesWithNoEvent(nodes);
      } else {
        nodes.forEach(node => this.nodeSelection.delete(node));
      }
      if (shouldEmit) {
        this.emitSelectedChangeEvent(oldSelection);
      }
    }
    /** Called on `node.ngOnDestroy` to ensure state is correct after node is removed */
    ensureStateOnNodeDelete(node) {
      if (this.tree?.selection !== IgxTreeSelectionType.Cascading) {
        return;
      }
      requestAnimationFrame(() => {
        if (this.isNodeSelected(node)) {
          // node is destroyed, do not emit event
          this.deselectNodesWithNoEvent([node], false);
        } else {
          if (!node.parentNode) {
            return;
          }
          const assitantLeafNode = node.parentNode?.allChildren.find(e => !e._children?.length);
          if (!assitantLeafNode) {
            return;
          }
          this.retriggerNodeState(assitantLeafNode);
        }
      });
    }
    /** Retriggers a node's selection state */
    retriggerNodeState(node) {
      if (node.selected) {
        this.nodeSelection.delete(node);
        this.selectNodesWithNoEvent([node], false, false);
      } else {
        this.nodeSelection.add(node);
        this.deselectNodesWithNoEvent([node], false);
      }
    }
    /** Returns array of the selected nodes. */
    getSelectedNodes() {
      return this.nodeSelection.size ? Array.from(this.nodeSelection) : [];
    }
    /** Returns array of the nodes in indeterminate state. */
    getIndeterminateNodes() {
      return this.indeterminateNodes.size ? Array.from(this.indeterminateNodes) : [];
    }
    emitNodeSelectionEvent(newSelection, added, removed, event) {
      if (this.tree.selection === IgxTreeSelectionType.Cascading) {
        this.emitCascadeNodeSelectionEvent(newSelection, added, removed, event);
        return;
      }
      const currSelection = this.getSelectedNodes();
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const args = {
        oldSelection: currSelection,
        newSelection,
        added,
        removed,
        event,
        cancel: false,
        owner: this.tree
      };
      this.tree.nodeSelection.emit(args);
      if (args.cancel) {
        return;
      }
      this.selectNodesWithNoEvent(args.newSelection, true);
    }
    areEqualCollections(first, second) {
      return first.length === second.length && new Set(first.concat(second)).size === first.length;
    }
    cascadeSelectNodesWithNoEvent(nodes, clearPrevSelection = false) {
      const oldSelection = this.getSelectedNodes();
      if (clearPrevSelection) {
        this.indeterminateNodes.clear();
        this.nodeSelection.clear();
        this.calculateNodesNewSelectionState({
          added: nodes,
          removed: []
        });
      } else {
        const newSelection = [...oldSelection, ...nodes];
        const args = {
          oldSelection,
          newSelection
        };
        // retrieve only the rows without their parents/children which has to be added to the selection
        this.populateAddRemoveArgs(args);
        this.calculateNodesNewSelectionState(args);
      }
      this.nodeSelection = new Set(this.nodesToBeSelected);
      this.indeterminateNodes = new Set(this.nodesToBeIndeterminate);
      this.emitSelectedChangeEvent(oldSelection);
    }
    cascadeDeselectNodesWithNoEvent(nodes) {
      const args = {
        added: [],
        removed: nodes
      };
      this.calculateNodesNewSelectionState(args);
      this.nodeSelection = new Set(this.nodesToBeSelected);
      this.indeterminateNodes = new Set(this.nodesToBeIndeterminate);
    }
    /**
     * populates the nodesToBeSelected and nodesToBeIndeterminate sets
     * with the nodes which will be eventually in selected/indeterminate state
     */
    calculateNodesNewSelectionState(args) {
      this.nodesToBeSelected = new Set(args.oldSelection ? args.oldSelection : this.getSelectedNodes());
      this.nodesToBeIndeterminate = new Set(this.getIndeterminateNodes());
      this.cascadeSelectionState(args.removed, false);
      this.cascadeSelectionState(args.added, true);
    }
    /** Ensures proper selection state for all predescessors and descendants during a selection event */
    cascadeSelectionState(nodes, selected) {
      if (!nodes || nodes.length === 0) {
        return;
      }
      if (nodes && nodes.length > 0) {
        const nodeCollection = this.getCascadingNodeCollection(nodes);
        nodeCollection.nodes.forEach(node => {
          if (selected) {
            this.nodesToBeSelected.add(node);
          } else {
            this.nodesToBeSelected.delete(node);
          }
          this.nodesToBeIndeterminate.delete(node);
        });
        Array.from(nodeCollection.parents).forEach(parent => {
          this.handleParentSelectionState(parent);
        });
      }
    }
    emitCascadeNodeSelectionEvent(newSelection, added, removed, event) {
      const currSelection = this.getSelectedNodes();
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const args = {
        oldSelection: currSelection,
        newSelection,
        added,
        removed,
        event,
        cancel: false,
        owner: this.tree
      };
      this.calculateNodesNewSelectionState(args);
      args.newSelection = Array.from(this.nodesToBeSelected);
      // retrieve nodes/parents/children which has been added/removed from the selection
      this.populateAddRemoveArgs(args);
      this.tree.nodeSelection.emit(args);
      if (args.cancel) {
        return;
      }
      // if args.newSelection hasn't been modified
      if (this.areEqualCollections(Array.from(this.nodesToBeSelected), args.newSelection)) {
        this.nodeSelection = new Set(this.nodesToBeSelected);
        this.indeterminateNodes = new Set(this.nodesToBeIndeterminate);
        this.emitSelectedChangeEvent(currSelection);
      } else {
        // select the nodes within the modified args.newSelection with no event
        this.cascadeSelectNodesWithNoEvent(args.newSelection, true);
      }
    }
    /**
     * recursively handle the selection state of the direct and indirect parents
     */
    handleParentSelectionState(node) {
      if (!node) {
        return;
      }
      this.handleNodeSelectionState(node);
      if (node.parentNode) {
        this.handleParentSelectionState(node.parentNode);
      }
    }
    /**
     * Handle the selection state of a given node based the selection states of its direct children
     */
    handleNodeSelectionState(node) {
      const nodesArray = node && node._children ? node._children.toArray() : [];
      if (nodesArray.length) {
        if (nodesArray.every(n => this.nodesToBeSelected.has(n))) {
          this.nodesToBeSelected.add(node);
          this.nodesToBeIndeterminate.delete(node);
        } else if (nodesArray.some(n => this.nodesToBeSelected.has(n) || this.nodesToBeIndeterminate.has(n))) {
          this.nodesToBeIndeterminate.add(node);
          this.nodesToBeSelected.delete(node);
        } else {
          this.nodesToBeIndeterminate.delete(node);
          this.nodesToBeSelected.delete(node);
        }
      } else {
        // if the children of the node has been deleted and the node was selected do not change its state
        if (this.isNodeSelected(node)) {
          this.nodesToBeSelected.add(node);
        } else {
          this.nodesToBeSelected.delete(node);
        }
        this.nodesToBeIndeterminate.delete(node);
      }
    }
    /**
     * Get a collection of all nodes affected by the change event
     *
     * @param nodesToBeProcessed set of the nodes to be selected/deselected
     * @returns a collection of all affected nodes and all their parents
     */
    getCascadingNodeCollection(nodes) {
      const collection = {
        parents: new Set(),
        nodes: new Set(nodes)
      };
      Array.from(collection.nodes).forEach(node => {
        const nodeAndAllChildren = node.allChildren?.toArray() || [];
        nodeAndAllChildren.forEach(n => {
          collection.nodes.add(n);
        });
        if (node && node.parentNode) {
          collection.parents.add(node.parentNode);
        }
      });
      return collection;
    }
    /**
     * retrieve the nodes which should be added/removed to/from the old selection
     */
    populateAddRemoveArgs(args) {
      args.removed = args.oldSelection.filter(x => args.newSelection.indexOf(x) < 0);
      args.added = args.newSelection.filter(x => args.oldSelection.indexOf(x) < 0);
    }
    /** Emits the `selectedChange` event for each node affected by the selection */
    emitSelectedChangeEvent(oldSelection) {
      this.getSelectedNodes().forEach(n => {
        if (oldSelection.indexOf(n) < 0) {
          n.selectedChange.emit(true);
        }
      });
      oldSelection.forEach(n => {
        if (!this.nodeSelection.has(n)) {
          n.selectedChange.emit(false);
        }
      });
    }
    static {
      this.ɵfac = function IgxTreeSelectionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeSelectionService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTreeSelectionService,
        factory: IgxTreeSelectionService.ɵfac
      });
    }
  }
  return IgxTreeSelectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
let IgxTreeNavigationService = /*#__PURE__*/(() => {
  class IgxTreeNavigationService {
    constructor(treeService, selectionService) {
      this.treeService = treeService;
      this.selectionService = selectionService;
      this._focusedNode = null;
      this._lastFocusedNode = null;
      this._activeNode = null;
      this._visibleChildren = [];
      this._invisibleChildren = new Set();
      this._disabledChildren = new Set();
      this._cacheChange = new Subject();
      this._cacheChange.subscribe(() => {
        this._visibleChildren = this.tree?.nodes ? this.tree.nodes.filter(e => !(this._invisibleChildren.has(e) || this._disabledChildren.has(e))) : [];
      });
    }
    register(tree) {
      this.tree = tree;
    }
    get focusedNode() {
      return this._focusedNode;
    }
    set focusedNode(value) {
      if (this._focusedNode === value) {
        return;
      }
      this._lastFocusedNode = this._focusedNode;
      if (this._lastFocusedNode) {
        this._lastFocusedNode.tabIndex = -1;
      }
      this._focusedNode = value;
      if (this._focusedNode !== null) {
        this._focusedNode.tabIndex = 0;
        this._focusedNode.header.nativeElement.focus();
      }
    }
    get activeNode() {
      return this._activeNode;
    }
    set activeNode(value) {
      if (this._activeNode === value) {
        return;
      }
      this._activeNode = value;
      this.tree.activeNodeChanged.emit(this._activeNode);
    }
    get visibleChildren() {
      return this._visibleChildren;
    }
    update_disabled_cache(node) {
      if (node.disabled) {
        this._disabledChildren.add(node);
      } else {
        this._disabledChildren.delete(node);
      }
      this._cacheChange.next();
    }
    init_invisible_cache() {
      this.tree.nodes.filter(e => e.level === 0).forEach(node => {
        this.update_visible_cache(node, node.expanded, false);
      });
      this._cacheChange.next();
    }
    update_visible_cache(node, expanded, shouldEmit = true) {
      if (expanded) {
        node._children.forEach(child => {
          this._invisibleChildren.delete(child);
          this.update_visible_cache(child, child.expanded, false);
        });
      } else {
        node.allChildren.forEach(c => this._invisibleChildren.add(c));
      }
      if (shouldEmit) {
        this._cacheChange.next();
      }
    }
    /**
     * Sets the node as focused (and active)
     *
     * @param node target node
     * @param isActive if true, sets the node as active
     */
    setFocusedAndActiveNode(node, isActive = true) {
      if (isActive) {
        this.activeNode = node;
      }
      this.focusedNode = node;
    }
    /** Handler for keydown events. Used in tree.component.ts */
    handleKeydown(event) {
      const key = event.key.toLowerCase();
      if (!this.focusedNode) {
        return;
      }
      if (!(NAVIGATION_KEYS.has(key) || key === '*')) {
        if (key === 'enter') {
          this.activeNode = this.focusedNode;
        }
        return;
      }
      event.preventDefault();
      if (event.repeat) {
        setTimeout(() => this.handleNavigation(event), 1);
      } else {
        this.handleNavigation(event);
      }
    }
    ngOnDestroy() {
      this._cacheChange.next();
      this._cacheChange.complete();
    }
    handleNavigation(event) {
      switch (event.key.toLowerCase()) {
        case 'home':
          this.setFocusedAndActiveNode(this.visibleChildren[0]);
          break;
        case 'end':
          this.setFocusedAndActiveNode(this.visibleChildren[this.visibleChildren.length - 1]);
          break;
        case 'arrowleft':
        case 'left':
          this.handleArrowLeft();
          break;
        case 'arrowright':
        case 'right':
          this.handleArrowRight();
          break;
        case 'arrowup':
        case 'up':
          this.handleUpDownArrow(true, event);
          break;
        case 'arrowdown':
        case 'down':
          this.handleUpDownArrow(false, event);
          break;
        case '*':
          this.handleAsterisk();
          break;
        case ' ':
        case 'spacebar':
        case 'space':
          this.handleSpace(event.shiftKey);
          break;
        default:
          return;
      }
    }
    handleArrowLeft() {
      if (this.focusedNode.expanded && !this.treeService.collapsingNodes.has(this.focusedNode) && this.focusedNode._children?.length) {
        this.activeNode = this.focusedNode;
        this.focusedNode.collapse();
      } else {
        const parentNode = this.focusedNode.parentNode;
        if (parentNode && !parentNode.disabled) {
          this.setFocusedAndActiveNode(parentNode);
        }
      }
    }
    handleArrowRight() {
      if (this.focusedNode._children.length > 0) {
        if (!this.focusedNode.expanded) {
          this.activeNode = this.focusedNode;
          this.focusedNode.expand();
        } else {
          if (this.treeService.collapsingNodes.has(this.focusedNode)) {
            this.focusedNode.expand();
            return;
          }
          const firstChild = this.focusedNode._children.find(node => !node.disabled);
          if (firstChild) {
            this.setFocusedAndActiveNode(firstChild);
          }
        }
      }
    }
    handleUpDownArrow(isUp, event) {
      const next = this.getVisibleNode(this.focusedNode, isUp ? -1 : 1);
      if (next === this.focusedNode) {
        return;
      }
      if (event.ctrlKey) {
        this.setFocusedAndActiveNode(next, false);
      } else {
        this.setFocusedAndActiveNode(next);
      }
    }
    handleAsterisk() {
      const nodes = this.focusedNode.parentNode ? this.focusedNode.parentNode._children : this.tree.rootNodes;
      nodes?.forEach(node => {
        if (!node.disabled && (!node.expanded || this.treeService.collapsingNodes.has(node))) {
          node.expand();
        }
      });
    }
    handleSpace(shiftKey = false) {
      if (this.tree.selection === IgxTreeSelectionType.None) {
        return;
      }
      this.activeNode = this.focusedNode;
      if (shiftKey) {
        this.selectionService.selectMultipleNodes(this.focusedNode);
        return;
      }
      if (this.focusedNode.selected) {
        this.selectionService.deselectNode(this.focusedNode);
      } else {
        this.selectionService.selectNode(this.focusedNode);
      }
    }
    /** Gets the next visible node in the given direction - 1 -> next, -1 -> previous */
    getVisibleNode(node, dir = 1) {
      const nodeIndex = this.visibleChildren.indexOf(node);
      return this.visibleChildren[nodeIndex + dir] || node;
    }
    static {
      this.ɵfac = function IgxTreeNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeNavigationService)(i0.ɵɵinject(IgxTreeService), i0.ɵɵinject(IgxTreeSelectionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTreeNavigationService,
        factory: IgxTreeNavigationService.ɵfac
      });
    }
  }
  return IgxTreeNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: Implement aria functionality
/**
 * @hidden @internal
 * Used for links (`a` tags) in the body of an `igx-tree-node`. Handles aria and event dispatch.
 */
let IgxTreeNodeLinkDirective = /*#__PURE__*/(() => {
  class IgxTreeNodeLinkDirective {
    /**
     * The node's parent. Should be used only when the link is defined
     * in `<ng-template>` tag outside of its parent, as Angular DI will not properly provide a reference
     *
     * ```html
     * <igx-tree>
     *     <igx-tree-node #myNode *ngFor="let node of data" [data]="node">
     *         <ng-template *ngTemplateOutlet="nodeTemplate; context: { $implicit: data, parentNode: myNode }">
     *         </ng-template>
     *     </igx-tree-node>
     *     ...
     *     <!-- node template is defined under tree to access related services -->
     *     <ng-template #nodeTemplate let-data let-node="parentNode">
     *         <a [igxTreeNodeLink]="node">{{ data.label }}</a>
     *     </ng-template>
     * </igx-tree>
     * ```
     */
    set parentNode(val) {
      if (val) {
        this._parentNode = val;
        this._parentNode.addLinkChild(this);
      }
    }
    get parentNode() {
      return this._parentNode;
    }
    /** A pointer to the parent node */
    get target() {
      return this.node || this.parentNode;
    }
    constructor(node, navService, elementRef) {
      this.node = node;
      this.navService = navService;
      this.elementRef = elementRef;
      this.role = 'treeitem';
      this._parentNode = null;
    }
    /** @hidden @internal */
    get tabIndex() {
      return this.navService.focusedNode === this.target ? this.target?.disabled ? -1 : 0 : -1;
    }
    /**
     * @hidden @internal
     * Clear the node's focused state
     */
    handleBlur() {
      this.target.isFocused = false;
    }
    /**
     * @hidden @internal
     * Set the node as focused
     */
    handleFocus() {
      if (this.target && !this.target.disabled) {
        if (this.navService.focusedNode !== this.target) {
          this.navService.focusedNode = this.target;
        }
        this.target.isFocused = true;
      }
    }
    ngOnDestroy() {
      this.target.removeLinkChild(this);
    }
    static {
      this.ɵfac = function IgxTreeNodeLinkDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeNodeLinkDirective)(i0.ɵɵdirectiveInject(IGX_TREE_NODE_COMPONENT, 8), i0.ɵɵdirectiveInject(IgxTreeNavigationService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTreeNodeLinkDirective,
        selectors: [["", "igxTreeNodeLink", ""]],
        hostVars: 2,
        hostBindings: function IgxTreeNodeLinkDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function IgxTreeNodeLinkDirective_blur_HostBindingHandler() {
              return ctx.handleBlur();
            })("focus", function IgxTreeNodeLinkDirective_focus_HostBindingHandler() {
              return ctx.handleFocus();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("tabindex", ctx.tabIndex);
          }
        },
        inputs: {
          parentNode: [0, "igxTreeNodeLink", "parentNode"]
        }
      });
    }
  }
  return IgxTreeNodeLinkDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * The tree node component represents a child node of the tree component or another tree node.
 * Usage:
 *
 * ```html
 *  <igx-tree>
 *  ...
 *    <igx-tree-node [data]="data" [selected]="service.isNodeSelected(data.Key)" [expanded]="service.isNodeExpanded(data.Key)">
 *      {{ data.FirstName }} {{ data.LastName }}
 *    </igx-tree-node>
 *  ...
 *  </igx-tree>
 * ```
 */
let IgxTreeNodeComponent = /*#__PURE__*/(() => {
  class IgxTreeNodeComponent extends ToggleAnimationPlayer {
    // TO DO: return different tab index depending on anchor child
    /** @hidden @internal */
    set tabIndex(val) {
      this._tabIndex = val;
    }
    /** @hidden @internal */
    get tabIndex() {
      if (this.disabled) {
        return -1;
      }
      if (this._tabIndex === null) {
        if (this.navService.focusedNode === null) {
          return this.hasLinkChildren ? -1 : 0;
        }
        return -1;
      }
      return this.hasLinkChildren ? -1 : this._tabIndex;
    }
    /** @hidden @internal */
    get animationSettings() {
      return this.tree.animationSettings;
    }
    /**
     * Gets/Sets the resource strings.
     *
     * @remarks
     * Uses EN resources by default.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Gets/Sets the active state of the node
     *
     * @param value: boolean
     */
    set active(value) {
      if (value) {
        this.navService.activeNode = this;
        this.tree.activeNodeBindingChange.emit(this);
      }
    }
    get active() {
      return this.navService.activeNode === this;
    }
    /** @hidden @internal */
    get focused() {
      return this.isFocused && this.navService.focusedNode === this;
    }
    /**
     * Retrieves the full path to the node incuding itself
     *
     * ```typescript
     * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * const path: IgxTreeNode<any>[] = node.path;
     * ```
     */
    get path() {
      return this.parentNode?.path ? [...this.parentNode.path, this] : [this];
    }
    // TODO: bind to disabled state when node is dragged
    /**
     * Gets/Sets the disabled state of the node
     *
     * @param value: boolean
     */
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      if (value !== this._disabled) {
        this._disabled = value;
        this.tree.disabledChange.emit(this);
      }
    }
    /** @hidden @internal */
    get role() {
      return this.hasLinkChildren ? 'none' : 'treeitem';
    }
    /**
     * Return the child nodes of the node (if any)
     *
     * @remarks
     * Returns `null` if node does not have children
     *
     * @example
     * ```typescript
     * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * const children: IgxTreeNode<any>[] = node.children;
     * ```
     */
    get children() {
      return this._children?.length ? this._children.toArray() : null;
    }
    get hasLinkChildren() {
      return this.linkChildren?.length > 0 || this.registeredChildren?.length > 0;
    }
    constructor(tree, selectionService, treeService, navService, cdr, animationService, element, parentNode) {
      super(animationService);
      this.tree = tree;
      this.selectionService = selectionService;
      this.treeService = treeService;
      this.navService = navService;
      this.cdr = cdr;
      this.element = element;
      this.parentNode = parentNode;
      /**
       * To be used for load-on-demand scenarios in order to specify whether the node is loading data.
       *
       * @remarks
       * Loading nodes do not render children.
       */
      this.loading = false;
      /**
       * Emitted when the node's `selected` property changes.
       *
       * ```html
       * <igx-tree>
       *      <igx-tree-node *ngFor="let node of data" [data]="node" [(selected)]="node.selected">
       *      </igx-tree-node>
       * </igx-tree>
       * ```
       *
       * ```typescript
       * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
       * node.selectedChange.pipe(takeUntil(this.destroy$)).subscribe((e: boolean) => console.log("Node selection changed to ", e))
       * ```
       */
      this.selectedChange = new EventEmitter();
      /**
       * Emitted when the node's `expanded` property changes.
       *
       * ```html
       * <igx-tree>
       *      <igx-tree-node *ngFor="let node of data" [data]="node" [(expanded)]="node.expanded">
       *      </igx-tree-node>
       * </igx-tree>
       * ```
       *
       * ```typescript
       * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
       * node.expandedChange.pipe(takeUntil(this.destroy$)).subscribe((e: boolean) => console.log("Node expansion state changed to ", e))
       * ```
       */
      this.expandedChange = new EventEmitter();
      /** @hidden @internal */
      this.cssClass = 'igx-tree-node';
      /** @hidden @internal */
      this.registeredChildren = [];
      /** @hidden @internal */
      this._resourceStrings = getCurrentResourceStrings(TreeResourceStringsEN);
      this._tabIndex = null;
      this._disabled = false;
    }
    /**
     * @hidden @internal
     */
    get showSelectors() {
      return this.tree.selection !== IgxTreeSelectionType.None;
    }
    /**
     * @hidden @internal
     */
    get indeterminate() {
      return this.selectionService.isNodeIndeterminate(this);
    }
    /** The depth of the node, relative to the root
     *
     * ```html
     * <igx-tree>
     *  ...
     *  <igx-tree-node #node>
     *      My level is {{ node.level }}
     *  </igx-tree-node>
     * </igx-tree>
     * ```
     *
     * ```typescript
     * const node: IgxTreeNode<any> = this.tree.findNodes(data[12])[0];
     * const level: number = node.level;
     * ```
     */
    get level() {
      return this.parentNode ? this.parentNode.level + 1 : 0;
    }
    /** Get/set whether the node is selected. Supporst two-way binding.
     *
     * ```html
     * <igx-tree>
     *  ...
     *  <igx-tree-node *ngFor="let node of data" [(selected)]="node.selected">
     *      {{ node.label }}
     *  </igx-tree-node>
     * </igx-tree>
     * ```
     *
     * ```typescript
     * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * const selected = node.selected;
     * node.selected = true;
     * ```
     */
    get selected() {
      return this.selectionService.isNodeSelected(this);
    }
    set selected(val) {
      if (!(this.tree?.nodes && this.tree.nodes.find(e => e === this)) && val) {
        this.tree.forceSelect.push(this);
        return;
      }
      if (val && !this.selectionService.isNodeSelected(this)) {
        this.selectionService.selectNodesWithNoEvent([this]);
      }
      if (!val && this.selectionService.isNodeSelected(this)) {
        this.selectionService.deselectNodesWithNoEvent([this]);
      }
    }
    /** Get/set whether the node is expanded
     *
     * ```html
     * <igx-tree>
     *  ...
     *  <igx-tree-node *ngFor="let node of data" [expanded]="node.name === this.expandedNode">
     *      {{ node.label }}
     *  </igx-tree-node>
     * </igx-tree>
     * ```
     *
     * ```typescript
     * const node: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * const expanded = node.expanded;
     * node.expanded = true;
     * ```
     */
    get expanded() {
      return this.treeService.isExpanded(this);
    }
    set expanded(val) {
      if (val) {
        this.treeService.expand(this, false);
      } else {
        this.treeService.collapse(this);
      }
    }
    /** @hidden @internal */
    get expandIndicatorTemplate() {
      return this.tree?.expandIndicator || this._defaultExpandIndicatorTemplate;
    }
    /**
     * The native DOM element representing the node. Could be null in certain environments.
     *
     * ```typescript
     * // get the nativeElement of the second node
     * const node: IgxTreeNode = this.tree.nodes.first();
     * const nodeElement: HTMLElement = node.nativeElement;
     * ```
     */
    /** @hidden @internal */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /** @hidden @internal */
    ngOnInit() {
      this.openAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.tree.nodeExpanded.emit({
          owner: this.tree,
          node: this
        });
      });
      this.closeAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.tree.nodeCollapsed.emit({
          owner: this.tree,
          node: this
        });
        this.treeService.collapse(this);
        this.cdr.markForCheck();
      });
    }
    /**
     * @hidden @internal
     * Sets the focus to the node's <a> child, if present
     * Sets the node as the tree service's focusedNode
     * Marks the node as the current active element
     */
    handleFocus() {
      if (this.disabled) {
        return;
      }
      if (this.navService.focusedNode !== this) {
        this.navService.focusedNode = this;
      }
      this.isFocused = true;
      if (this.linkChildren?.length) {
        this.linkChildren.first.nativeElement.focus();
        return;
      }
      if (this.registeredChildren.length) {
        this.registeredChildren[0].elementRef.nativeElement.focus();
        return;
      }
    }
    /**
     * @hidden @internal
     * Clear the node's focused status
     */
    clearFocus() {
      this.isFocused = false;
    }
    /**
     * @hidden @internal
     */
    onSelectorPointerDown(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    /**
     * @hidden @internal
     */
    onSelectorClick(event) {
      // event.stopPropagation();
      event.preventDefault();
      // this.navService.handleFocusedAndActiveNode(this);
      if (event.shiftKey) {
        this.selectionService.selectMultipleNodes(this, event);
        return;
      }
      if (this.selected) {
        this.selectionService.deselectNode(this, event);
      } else {
        this.selectionService.selectNode(this, event);
      }
    }
    /**
     * Toggles the node expansion state, triggering animation
     *
     * ```html
     * <igx-tree>
     *      <igx-tree-node #node>My Node</igx-tree-node>
     * </igx-tree>
     * <button type="button" igxButton (click)="node.toggle()">Toggle Node</button>
     * ```
     *
     * ```typescript
     * const myNode: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * myNode.toggle();
     * ```
     */
    toggle() {
      if (this.expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }
    /** @hidden @internal */
    indicatorClick() {
      if (!this.tree.toggleNodeOnClick) {
        this.toggle();
        this.navService.setFocusedAndActiveNode(this);
      }
    }
    /**
     * @hidden @internal
     */
    onPointerDown(event) {
      event.stopPropagation();
      //Toggle the node only on left mouse click - https://w3c.github.io/pointerevents/#button-states
      if (this.tree.toggleNodeOnClick && event.button === 0) {
        this.toggle();
      }
      this.navService.setFocusedAndActiveNode(this);
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.selectionService.ensureStateOnNodeDelete(this);
    }
    /**
     * Expands the node, triggering animation
     *
     * ```html
     * <igx-tree>
     *      <igx-tree-node #node>My Node</igx-tree-node>
     * </igx-tree>
     * <button type="button" igxButton (click)="node.expand()">Expand Node</button>
     * ```
     *
     * ```typescript
     * const myNode: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * myNode.expand();
     * ```
     */
    expand() {
      if (this.expanded && !this.treeService.collapsingNodes.has(this)) {
        return;
      }
      const args = {
        owner: this.tree,
        node: this,
        cancel: false
      };
      this.tree.nodeExpanding.emit(args);
      if (!args.cancel) {
        this.treeService.expand(this, true);
        this.cdr.detectChanges();
        this.playOpenAnimation(this.childrenContainer);
      }
    }
    /**
     * Collapses the node, triggering animation
     *
     * ```html
     * <igx-tree>
     *      <igx-tree-node #node>My Node</igx-tree-node>
     * </igx-tree>
     * <button type="button" igxButton (click)="node.collapse()">Collapse Node</button>
     * ```
     *
     * ```typescript
     * const myNode: IgxTreeNode<any> = this.tree.findNodes(data[0])[0];
     * myNode.collapse();
     * ```
     */
    collapse() {
      if (!this.expanded || this.treeService.collapsingNodes.has(this)) {
        return;
      }
      const args = {
        owner: this.tree,
        node: this,
        cancel: false
      };
      this.tree.nodeCollapsing.emit(args);
      if (!args.cancel) {
        this.treeService.collapsing(this);
        this.playCloseAnimation(this.childrenContainer);
      }
    }
    /** @hidden @internal */
    addLinkChild(link) {
      this._tabIndex = -1;
      this.registeredChildren.push(link);
    }
    /** @hidden @internal */
    removeLinkChild(link) {
      const index = this.registeredChildren.indexOf(link);
      if (index !== -1) {
        this.registeredChildren.splice(index, 1);
      }
    }
    static {
      this.ɵfac = function IgxTreeNodeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeNodeComponent)(i0.ɵɵdirectiveInject(IGX_TREE_COMPONENT), i0.ɵɵdirectiveInject(IgxTreeSelectionService), i0.ɵɵdirectiveInject(IgxTreeService), i0.ɵɵdirectiveInject(IgxTreeNavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IGX_TREE_NODE_COMPONENT, 12));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeNodeComponent,
        selectors: [["igx-tree-node"]],
        contentQueries: function IgxTreeNodeComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxTreeNodeLinkDirective, 4, ElementRef);
            i0.ɵɵcontentQuery(dirIndex, IGX_TREE_NODE_COMPONENT, 4, IGX_TREE_NODE_COMPONENT);
            i0.ɵɵcontentQuery(dirIndex, IGX_TREE_NODE_COMPONENT, 5, IGX_TREE_NODE_COMPONENT);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.linkChildren = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._children = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.allChildren = _t);
          }
        },
        viewQuery: function IgxTreeNodeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c124, 5, ElementRef);
            i0.ɵɵviewQuery(_c45, 7, TemplateRef);
            i0.ɵɵviewQuery(_c125, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._defaultExpandIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenContainer = _t.first);
          }
        },
        hostVars: 5,
        hostBindings: function IgxTreeNodeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
            i0.ɵɵclassProp("igx-tree-node--disabled", ctx.disabled)("igx-tree-node", ctx.cssClass);
          }
        },
        inputs: {
          data: "data",
          loading: [2, "loading", "loading", booleanAttribute],
          resourceStrings: "resourceStrings",
          active: [2, "active", "active", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          selected: [2, "selected", "selected", booleanAttribute],
          expanded: [2, "expanded", "expanded", booleanAttribute]
        },
        outputs: {
          selectedChange: "selectedChange",
          expandedChange: "expandedChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_TREE_NODE_COMPONENT,
          useExisting: IgxTreeNodeComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c127,
        decls: 12,
        vars: 2,
        consts: [["noDragTemplate", ""], ["defaultIndicator", ""], ["selectMarkerTemplate", ""], ["headerTemplate", ""], ["dragTemplate", ""], ["childrenContainer", ""], ["ghostTemplate", ""], [4, "ngTemplateOutlet"], ["role", "group", 1, "igx-tree-node__group"], ["family", "default", 3, "name"], [3, "checked", "disabled", "readonly", "indeterminate", "tabindex"], [1, "igx-tree-node__wrapper", 3, "pointerdown", "focus", "blur", "tabIndex", "ngClass"], ["aria-hidden", "true"], ["aria-hidden", "true", 1, "igx-tree-node__spacer"], [1, "igx-tree-node__toggle-button", 3, "ngClass"], [1, "igx-tree-node__toggle-button"], [1, "igx-tree-node__select"], [1, "igx-tree-node__content"], [1, "igx-tree-node__drop-indicator"], [1, "igx-tree-node__toggle-button", 3, "click", "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "animate", "indeterminate", "textVisibility"], [1, "igx-tree-node__select", 3, "pointerdown", "click"], [1, "igx-tree-node__drag-wrapper"]],
        template: function IgxTreeNodeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c126);
            i0.ɵɵtemplate(0, IgxTreeNodeComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxTreeNodeComponent_2_Template, 1, 0, null, 7)(3, IgxTreeNodeComponent_Conditional_3_Template, 3, 0, "div", 8)(4, IgxTreeNodeComponent_ng_template_4_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, IgxTreeNodeComponent_ng_template_6_Template, 1, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, IgxTreeNodeComponent_ng_template_8_Template, 14, 13, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, IgxTreeNodeComponent_ng_template_10_Template, 2, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const noDragTemplate_r7 = i0.ɵɵreference(1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", noDragTemplate_r7);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.expanded && !ctx.loading ? 3 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxIconComponent, IgxCheckboxComponent, NgClass, IgxCircularProgressBarComponent],
        encapsulation: 2
      });
    }
  }
  return IgxTreeNodeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden @internal
 * Used for templating the select marker of the tree
 */
let IgxTreeSelectMarkerDirective = /*#__PURE__*/(() => {
  class IgxTreeSelectMarkerDirective {
    static {
      this.ɵfac = function IgxTreeSelectMarkerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeSelectMarkerDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTreeSelectMarkerDirective,
        selectors: [["", "igxTreeSelectMarker", ""]]
      });
    }
  }
  return IgxTreeSelectMarkerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden @internal
 * Used for templating the expand indicator of the tree
 */
let IgxTreeExpandIndicatorDirective = /*#__PURE__*/(() => {
  class IgxTreeExpandIndicatorDirective {
    static {
      this.ɵfac = function IgxTreeExpandIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeExpandIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTreeExpandIndicatorDirective,
        selectors: [["", "igxTreeExpandIndicator", ""]]
      });
    }
  }
  return IgxTreeExpandIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * IgxTreeComponent allows a developer to show a set of nodes in a hierarchical fashion.
 *
 * @igxModule IgxTreeModule
 * @igxKeywords tree
 * @igxTheme igx-tree-theme
 * @igxGroup Grids & Lists
 *
 * @remark
 * The Angular Tree Component allows users to represent hierarchical data in a tree-view structure,
 * maintaining parent-child relationships, as well as to define static tree-view structure without a corresponding data model.
 * Its primary purpose is to allow end-users to visualize and navigate within hierarchical data structures.
 * The Ignite UI for Angular Tree Component also provides load on demand capabilities, item activation,
 * bi-state and cascading selection of items through built-in checkboxes, built-in keyboard navigation and more.
 *
 * @example
 * ```html
 * <igx-tree>
 *   <igx-tree-node>
 *      I am a parent node 1
 *      <igx-tree-node>
 *          I am a child node 1
 *      </igx-tree-node>
 *      ...
 *   </igx-tree-node>
 *	 ...
 * </igx-tree>
 * ```
 */
let IgxTreeComponent = /*#__PURE__*/(() => {
  class IgxTreeComponent {
    /**
     * Gets/Sets tree selection mode
     *
     * @remarks
     * By default the tree selection mode is 'None'
     * @param selectionMode: IgxTreeSelectionType
     */
    get selection() {
      return this._selection;
    }
    set selection(selectionMode) {
      this._selection = selectionMode;
      this.selectionService.clearNodesSelection();
    }
    /**
     * Returns all **root level** nodes
     *
     * ```typescript
     * const tree: IgxTree = this.tree;
     * const rootNodes: IgxTreeNodeComponent<any>[] = tree.rootNodes;
     * ```
     */
    get rootNodes() {
      return this.nodes?.filter(node => node.level === 0);
    }
    constructor(navService, selectionService, treeService, element) {
      this.navService = navService;
      this.selectionService = selectionService;
      this.treeService = treeService;
      this.element = element;
      this.cssClass = 'igx-tree';
      /** Get/Set how the tree should handle branch expansion.
       * If set to `true`, only a single branch can be expanded at a time, collapsing all others
       *
       * ```html
       * <igx-tree [singleBranchExpand]="true">
       * ...
       * </igx-tree>
       * ```
       *
       * ```typescript
       * const tree: IgxTree = this.tree;
       * this.tree.singleBranchExpand = false;
       * ```
       */
      this.singleBranchExpand = false;
      /** Get/Set if nodes should be expanded/collapsed when clicking over them.
       *
       * ```html
       * <igx-tree [toggleNodeOnClick]="true">
       * ...
       * </igx-tree>
       * ```
       *
       * ```typescript
       * const tree: IgxTree = this.tree;
       * this.tree.toggleNodeOnClick = false;
       * ```
       */
      this.toggleNodeOnClick = false;
      /** Get/Set the animation settings that branches should use when expanding/collpasing.
       *
       * ```html
       * <igx-tree [animationSettings]="customAnimationSettings">
       * </igx-tree>
       * ```
       *
       * ```typescript
       * const animationSettings: ToggleAnimationSettings = {
       *      openAnimation: growVerIn,
       *      closeAnimation: growVerOut
       * };
       *
       * this.tree.animationSettings = animationSettings;
       * ```
       */
      this.animationSettings = {
        openAnimation: growVerIn,
        closeAnimation: growVerOut
      };
      /** Emitted when the node selection is changed through interaction
       *
       * ```html
       * <igx-tree (nodeSelection)="handleNodeSelection($event)">
       * </igx-tree>
       * ```
       *
       *```typescript
       * public handleNodeSelection(event: ITreeNodeSelectionEvent) {
       *  const newSelection: IgxTreeNode<any>[] = event.newSelection;
       *  const added: IgxTreeNode<any>[] = event.added;
       *  console.log("New selection will be: ", newSelection);
       *  console.log("Added nodes: ", event.added);
       * }
       *```
       */
      this.nodeSelection = new EventEmitter();
      /** Emitted when a node is expanding, before it finishes
       *
       * ```html
       * <igx-tree (nodeExpanding)="handleNodeExpanding($event)">
       * </igx-tree>
       * ```
       *
       *```typescript
       * public handleNodeExpanding(event: ITreeNodeTogglingEventArgs) {
       *  const expandedNode: IgxTreeNode<any> = event.node;
       *  if (expandedNode.disabled) {
       *      event.cancel = true;
       *  }
       * }
       *```
       */
      this.nodeExpanding = new EventEmitter();
      /** Emitted when a node is expanded, after it finishes
       *
       * ```html
       * <igx-tree (nodeExpanded)="handleNodeExpanded($event)">
       * </igx-tree>
       * ```
       *
       *```typescript
       * public handleNodeExpanded(event: ITreeNodeToggledEventArgs) {
       *  const expandedNode: IgxTreeNode<any> = event.node;
       *  console.log("Node is expanded: ", expandedNode.data);
       * }
       *```
       */
      this.nodeExpanded = new EventEmitter();
      /** Emitted when a node is collapsing, before it finishes
       *
       * ```html
       * <igx-tree (nodeCollapsing)="handleNodeCollapsing($event)">
       * </igx-tree>
       * ```
       *
       *```typescript
       * public handleNodeCollapsing(event: ITreeNodeTogglingEventArgs) {
       *  const collapsedNode: IgxTreeNode<any> = event.node;
       *  if (collapsedNode.alwaysOpen) {
       *      event.cancel = true;
       *  }
       * }
       *```
       */
      this.nodeCollapsing = new EventEmitter();
      /** Emitted when a node is collapsed, after it finishes
       *
       * @example
       * ```html
       * <igx-tree (nodeCollapsed)="handleNodeCollapsed($event)">
       * </igx-tree>
       * ```
       * ```typescript
       * public handleNodeCollapsed(event: ITreeNodeToggledEventArgs) {
       *  const collapsedNode: IgxTreeNode<any> = event.node;
       *  console.log("Node is collapsed: ", collapsedNode.data);
       * }
       * ```
       */
      this.nodeCollapsed = new EventEmitter();
      /**
       * Emitted when the active node is changed.
       *
       * @example
       * ```
       * <igx-tree (activeNodeChanged)="activeNodeChanged($event)"></igx-tree>
       * ```
       */
      this.activeNodeChanged = new EventEmitter();
      /** @hidden @internal */
      this.disabledChange = new EventEmitter();
      /**
       * Emitted when the active node is set through API
       *
       * @hidden @internal
       */
      this.activeNodeBindingChange = new EventEmitter();
      /** @hidden @internal */
      this.forceSelect = [];
      /** @hidden @internal */
      this.resizeNotify = new Subject();
      this._selection = IgxTreeSelectionType.None;
      this.destroy$ = new Subject();
      this.unsubChildren$ = new Subject();
      this._comparer = (data, node) => node.data === data;
      this.selectionService.register(this);
      this.treeService.register(this);
      this.navService.register(this);
    }
    /** @hidden @internal */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /**
     * Expands all of the passed nodes.
     * If no nodes are passed, expands ALL nodes
     *
     * @param nodes nodes to be expanded
     *
     * ```typescript
     * const targetNodes: IgxTreeNode<any> = this.tree.findNodes(true, (_data: any, node: IgxTreeNode<any>) => node.data.expandable);
     * tree.expandAll(nodes);
     * ```
     */
    expandAll(nodes) {
      nodes = nodes || this.nodes.toArray();
      nodes.forEach(e => e.expanded = true);
    }
    /**
     * Collapses all of the passed nodes.
     * If no nodes are passed, collapses ALL nodes
     *
     * @param nodes nodes to be collapsed
     *
     * ```typescript
     * const targetNodes: IgxTreeNode<any> = this.tree.findNodes(true, (_data: any, node: IgxTreeNode<any>) => node.data.collapsible);
     * tree.collapseAll(nodes);
     * ```
     */
    collapseAll(nodes) {
      nodes = nodes || this.nodes.toArray();
      nodes.forEach(e => e.expanded = false);
    }
    /**
     * Deselect all nodes if the nodes collection is empty. Otherwise, deselect the nodes in the nodes collection.
     *
     * @example
     * ```typescript
     *  const arr = [
     *      this.tree.nodes.toArray()[0],
     *      this.tree.nodes.toArray()[1]
     *  ];
     *  this.tree.deselectAll(arr);
     * ```
     * @param nodes: IgxTreeNodeComponent<any>[]
     */
    deselectAll(nodes) {
      this.selectionService.deselectNodesWithNoEvent(nodes);
    }
    /**
     * Returns all of the nodes that match the passed searchTerm.
     * Accepts a custom comparer function for evaluating the search term against the nodes.
     *
     * @remarks
     * Default search compares the passed `searchTerm` against the node's `data` Input.
     * When using `findNodes` w/o a `comparer`, make sure all nodes have `data` passed.
     *
     * @param searchTerm The data of the searched node
     * @param comparer A custom comparer function that evaluates the passed `searchTerm` against all nodes.
     * @returns Array of nodes that match the search. `null` if no nodes are found.
     *
     * ```html
     * <igx-tree>
     *     <igx-tree-node *ngFor="let node of data" [data]="node">
     *          {{ node.label }}
     *     </igx-tree-node>
     * </igx-tree>
     * ```
     *
     * ```typescript
     * public data: DataEntry[] = FETCHED_DATA;
     * ...
     * const matchedNodes: IgxTreeNode<DataEntry>[] = this.tree.findNodes<DataEntry>(searchTerm: data[5]);
     * ```
     *
     * Using a custom comparer
     * ```typescript
     * public data: DataEntry[] = FETCHED_DATA;
     * ...
     * const comparer: IgxTreeSearchResolver = (data: any, node: IgxTreeNode<DataEntry>) {
     *      return node.data.index % 2 === 0;
     * }
     * const evenIndexNodes: IgxTreeNode<DataEntry>[] = this.tree.findNodes<DataEntry>(null, comparer);
     * ```
     */
    findNodes(searchTerm, comparer) {
      const compareFunc = comparer || this._comparer;
      const results = this.nodes.filter(node => compareFunc(searchTerm, node));
      return results?.length === 0 ? null : results;
    }
    /** @hidden @internal */
    handleKeydown(event) {
      this.navService.handleKeydown(event);
    }
    /** @hidden @internal */
    ngOnInit() {
      this.disabledChange.pipe(takeUntil(this.destroy$)).subscribe(e => {
        this.navService.update_disabled_cache(e);
      });
      this.activeNodeBindingChange.pipe(takeUntil(this.destroy$)).subscribe(node => {
        this.expandToNode(this.navService.activeNode);
        this.scrollNodeIntoView(node?.header?.nativeElement);
      });
      this.subToCollapsing();
      this.resizeNotify.pipe(throttleTime(40, null, {
        trailing: true
      }), takeUntil(this.destroy$)).subscribe(() => {
        requestAnimationFrame(() => {
          this.scrollNodeIntoView(this.navService.activeNode?.header.nativeElement);
        });
      });
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.nodes.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.subToChanges();
      });
      this.scrollNodeIntoView(this.navService.activeNode?.header?.nativeElement);
      this.subToChanges();
      resizeObservable(this.nativeElement).pipe(takeUntil(this.destroy$)).subscribe(() => this.resizeNotify.next());
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.unsubChildren$.next();
      this.unsubChildren$.complete();
      this.destroy$.next();
      this.destroy$.complete();
    }
    expandToNode(node) {
      if (node && node.parentNode) {
        node.path.forEach(n => {
          if (n !== node && !n.expanded) {
            n.expanded = true;
          }
        });
      }
    }
    subToCollapsing() {
      this.nodeCollapsing.pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (event.cancel) {
          return;
        }
        this.navService.update_visible_cache(event.node, false);
      });
      this.nodeExpanding.pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (event.cancel) {
          return;
        }
        this.navService.update_visible_cache(event.node, true);
      });
    }
    subToChanges() {
      this.unsubChildren$.next();
      const toBeSelected = [...this.forceSelect];
      requestAnimationFrame(() => {
        this.selectionService.selectNodesWithNoEvent(toBeSelected);
      });
      this.forceSelect = [];
      this.nodes.forEach(node => {
        node.expandedChange.pipe(takeUntil(this.unsubChildren$)).subscribe(nodeState => {
          this.navService.update_visible_cache(node, nodeState);
        });
        node.closeAnimationDone.pipe(takeUntil(this.unsubChildren$)).subscribe(() => {
          const targetElement = this.navService.focusedNode?.header.nativeElement;
          this.scrollNodeIntoView(targetElement);
        });
        node.openAnimationDone.pipe(takeUntil(this.unsubChildren$)).subscribe(() => {
          const targetElement = this.navService.focusedNode?.header.nativeElement;
          this.scrollNodeIntoView(targetElement);
        });
      });
      this.navService.init_invisible_cache();
    }
    scrollNodeIntoView(el) {
      if (!el) {
        return;
      }
      const nodeRect = el.getBoundingClientRect();
      const treeRect = this.nativeElement.getBoundingClientRect();
      const topOffset = treeRect.top > nodeRect.top ? nodeRect.top - treeRect.top : 0;
      const bottomOffset = treeRect.bottom < nodeRect.bottom ? nodeRect.bottom - treeRect.bottom : 0;
      const shouldScroll = !!topOffset || !!bottomOffset;
      if (shouldScroll && this.nativeElement.scrollHeight > this.nativeElement.clientHeight) {
        // this.nativeElement.scrollTop = nodeRect.y - treeRect.y - nodeRect.height;
        this.nativeElement.scrollTop = this.nativeElement.scrollTop + bottomOffset + topOffset + (topOffset ? -1 : +1) * nodeRect.height;
      }
    }
    static {
      this.ɵfac = function IgxTreeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeComponent)(i0.ɵɵdirectiveInject(IgxTreeNavigationService), i0.ɵɵdirectiveInject(IgxTreeSelectionService), i0.ɵɵdirectiveInject(IgxTreeService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeComponent,
        selectors: [["igx-tree"]],
        contentQueries: function IgxTreeComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxTreeExpandIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxTreeNodeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandIndicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodes = _t);
          }
        },
        hostVars: 2,
        hostBindings: function IgxTreeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-tree", ctx.cssClass);
          }
        },
        inputs: {
          selection: "selection",
          singleBranchExpand: [2, "singleBranchExpand", "singleBranchExpand", booleanAttribute],
          toggleNodeOnClick: [2, "toggleNodeOnClick", "toggleNodeOnClick", booleanAttribute],
          animationSettings: "animationSettings"
        },
        outputs: {
          nodeSelection: "nodeSelection",
          nodeExpanding: "nodeExpanding",
          nodeExpanded: "nodeExpanded",
          nodeCollapsing: "nodeCollapsing",
          nodeCollapsed: "nodeCollapsed",
          activeNodeChanged: "activeNodeChanged"
        },
        features: [i0.ɵɵProvidersFeature([IgxTreeService, IgxTreeSelectionService, IgxTreeNavigationService, {
          provide: IGX_TREE_COMPONENT,
          useExisting: IgxTreeComponent
        }])],
        ngContentSelectors: _c132,
        decls: 2,
        vars: 0,
        consts: [["role", "tree", 1, "igx-tree__root", 3, "keydown"]],
        template: function IgxTreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c131);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("keydown", function IgxTreeComponent_Template_div_keydown_0_listener($event) {
              return ctx.handleKeydown($event);
            });
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxTreeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxListBaseDirective = /*#__PURE__*/(() => {
  class IgxListBaseDirective {
    constructor(el) {
      this.el = el;
    }
    static {
      this.ɵfac = function IgxListBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListBaseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListBaseDirective,
        selectors: [["", "igxListBase", ""]]
      });
    }
  }
  return IgxListBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var IgxListPanState = /*#__PURE__*/function (IgxListPanState) {
  IgxListPanState[IgxListPanState["NONE"] = 0] = "NONE";
  IgxListPanState[IgxListPanState["LEFT"] = 1] = "LEFT";
  IgxListPanState[IgxListPanState["RIGHT"] = 2] = "RIGHT";
  return IgxListPanState;
}(IgxListPanState || {});
let IgxEmptyListTemplateDirective = /*#__PURE__*/(() => {
  class IgxEmptyListTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxEmptyListTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxEmptyListTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxEmptyListTemplateDirective,
        selectors: [["", "igxEmptyList", ""]]
      });
    }
  }
  return IgxEmptyListTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxDataLoadingTemplateDirective = /*#__PURE__*/(() => {
  class IgxDataLoadingTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxDataLoadingTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDataLoadingTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDataLoadingTemplateDirective,
        selectors: [["", "igxDataLoading", ""]]
      });
    }
  }
  return IgxDataLoadingTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxListItemLeftPanningTemplateDirective = /*#__PURE__*/(() => {
  class IgxListItemLeftPanningTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxListItemLeftPanningTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListItemLeftPanningTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListItemLeftPanningTemplateDirective,
        selectors: [["", "igxListItemLeftPanning", ""]]
      });
    }
  }
  return IgxListItemLeftPanningTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxListItemRightPanningTemplateDirective = /*#__PURE__*/(() => {
  class IgxListItemRightPanningTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxListItemRightPanningTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListItemRightPanningTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListItemRightPanningTemplateDirective,
        selectors: [["", "igxListItemRightPanning", ""]]
      });
    }
  }
  return IgxListItemRightPanningTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Ignite UI List Item component is a container intended for row items in the Ignite UI for Angular List component.
 *
 * Example:
 * ```html
 * <igx-list>
 *   <igx-list-item isHeader="true">Contacts</igx-list-item>
 *   <igx-list-item *ngFor="let contact of contacts">
 *     <span class="name">{{ contact.name }}</span>
 *     <span class="phone">{{ contact.phone }}</span>
 *   </igx-list-item>
 * </igx-list>
 * ```
 */
let IgxListItemComponent = /*#__PURE__*/(() => {
  class IgxListItemComponent {
    /**
     * Gets the `panState` of a `list item`.
     * ```typescript
     * let itemPanState =  this.listItem.panState;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get panState() {
      return this._panState;
    }
    /**
     * Gets the `index` of a `list item`.
     * ```typescript
     * let itemIndex =  this.listItem.index;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get index() {
      return this._index !== null ? this._index : this.list.children.toArray().indexOf(this);
    }
    /**
     * Sets the `index` of the `list item`.
     * ```typescript
     * this.listItem.index = index;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    set index(value) {
      this._index = value;
    }
    /**
     * Returns an element reference to the list item.
     * ```typescript
     * let listItemElement =  this.listItem.element.
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * Returns a reference container which contains the list item's content.
     * ```typescript
     * let listItemContainer =  this.listItem.contentElement.
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get contentElement() {
      const candidates = this.element.getElementsByClassName('igx-list__item-content');
      return candidates && candidates.length > 0 ? candidates[0] : null;
    }
    /**
     * Returns the `context` object which represents the `template context` binding into the `list item container`
     * by providing the `$implicit` declaration which is the `IgxListItemComponent` itself.
     * ```typescript
     * let listItemComponent = this.listItem.context;
     * ```
     */
    get context() {
      return {
        $implicit: this
      };
    }
    /**
     * Gets the width of a `list item`.
     * ```typescript
     * let itemWidth = this.listItem.width;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get width() {
      if (this.element) {
        return this.element.offsetWidth;
      }
    }
    /**
     * Gets the maximum left position of the `list item`.
     * ```typescript
     * let maxLeft = this.listItem.maxLeft;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get maxLeft() {
      return -this.width;
    }
    /**
     * Gets the maximum right position of the `list item`.
     * ```typescript
     * let maxRight = this.listItem.maxRight;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get maxRight() {
      return this.width;
    }
    /** @hidden @internal */
    get offsetWidthInRem() {
      return rem(this.element.offsetWidth);
    }
    /** @hidden @internal */
    get offsetHeightInRem() {
      return rem(this.element.offsetHeight);
    }
    constructor(list, elementRef, _renderer) {
      this.list = list;
      this.elementRef = elementRef;
      this._renderer = _renderer;
      /**
       * Sets/gets whether the `list item` is hidden.
       * By default the `hidden` value is `false`.
       * ```html
       * <igx-list-item [hidden] = "true">Hidden Item</igx-list-item>
       * ```
       * ```typescript
       * let isHidden =  this.listItem.hidden;
       * ```
       *
       * @memberof IgxListItemComponent
       */
      this.hidden = false;
      /**
       * Gets the `touch-action` style of the `list item`.
       * ```typescript
       * let touchAction = this.listItem.touchAction;
       * ```
       */
      this.touchAction = 'pan-y';
      /**
       * @hidden
       */
      this._panState = IgxListPanState.NONE;
      /**
       * @hidden
       */
      this.panOffset = 0;
      /**
       * @hidden
       */
      this._index = null;
      /**
       * @hidden
       */
      this.lastPanDir = IgxListPanState.NONE;
      this._role = '';
      this._selected = false;
    }
    /**
     * Gets/Sets the `role` attribute of the `list item`.
     * ```typescript
     * let itemRole =  this.listItem.role;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get role() {
      return this._role ? this._role : this.isHeader ? 'separator' : 'listitem';
    }
    set role(val) {
      this._role = val;
    }
    /**
     * Sets/gets whether the `list item` is selected.
     * Selection is only applied to non-header items.
     * When selected, the CSS class 'igx-list__item-base--selected' is added to the item.
     * ```html
     * <igx-list-item [selected]="true">Selected Item</igx-list-item>
     * ```
     * ```typescript
     * let isSelected = this.listItem.selected;
     * this.listItem.selected = true;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get selected() {
      return this._selected && !this.isHeader;
    }
    set selected(value) {
      this._selected = value;
    }
    /**
     * Indicates whether `list item` should have header style.
     * ```typescript
     * let headerStyle =  this.listItem.headerStyle;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get headerStyle() {
      return this.isHeader;
    }
    /**
     * Applies the inner style of the `list item` if the item is not counted as header.
     * ```typescript
     * let innerStyle =  this.listItem.innerStyle;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get innerStyle() {
      return !this.isHeader;
    }
    /**
     * Returns string value which describes the display mode of the `list item`.
     * ```typescript
     * let isHidden = this.listItem.display;
     * ```
     *
     * @memberof IgxListItemComponent
     */
    get display() {
      return this.hidden ? 'none' : '';
    }
    /**
     * @hidden
     */
    clicked(evt) {
      this.list.itemClicked.emit({
        item: this,
        event: evt,
        direction: this.lastPanDir
      });
      this.lastPanDir = IgxListPanState.NONE;
    }
    /**
     * @hidden
     */
    panStart() {
      if (this.isTrue(this.isHeader)) {
        return;
      }
      if (!this.isTrue(this.list.allowLeftPanning) && !this.isTrue(this.list.allowRightPanning)) {
        return;
      }
      this.list.startPan.emit({
        item: this,
        direction: this.lastPanDir,
        keepitem: false
      });
    }
    /**
     * @hidden
     */
    panCancel() {
      this.resetPanPosition();
      this.list.endPan.emit({
        item: this,
        direction: this.lastPanDir,
        keepItem: false
      });
    }
    /**
     * @hidden
     */
    panMove(ev) {
      if (this.isTrue(this.isHeader)) {
        return;
      }
      if (!this.isTrue(this.list.allowLeftPanning) && !this.isTrue(this.list.allowRightPanning)) {
        return;
      }
      const isPanningToLeft = ev.deltaX < 0;
      if (isPanningToLeft && this.isTrue(this.list.allowLeftPanning)) {
        this.showLeftPanTemplate();
        this.setContentElementLeft(Math.max(this.maxLeft, ev.deltaX));
      } else if (!isPanningToLeft && this.isTrue(this.list.allowRightPanning)) {
        this.showRightPanTemplate();
        this.setContentElementLeft(Math.min(this.maxRight, ev.deltaX));
      }
    }
    /**
     * @hidden
     */
    panEnd() {
      if (this.isTrue(this.isHeader)) {
        return;
      }
      if (!this.isTrue(this.list.allowLeftPanning) && !this.isTrue(this.list.allowRightPanning)) {
        return;
      }
      // the translation offset of the current list item content
      const relativeOffset = this.panOffset;
      const widthTriggeringGrip = this.width * this.list.panEndTriggeringThreshold;
      if (relativeOffset === 0) {
        return; // no panning has occured
      }
      const dir = relativeOffset > 0 ? IgxListPanState.RIGHT : IgxListPanState.LEFT;
      this.lastPanDir = dir;
      const args = {
        item: this,
        direction: dir,
        keepItem: false
      };
      this.list.endPan.emit(args);
      const oldPanState = this._panState;
      if (Math.abs(relativeOffset) < widthTriggeringGrip) {
        this.resetPanPosition();
        this.list.resetPan.emit(this);
        return;
      }
      if (dir === IgxListPanState.LEFT) {
        this.list.leftPan.emit(args);
      } else {
        this.list.rightPan.emit(args);
      }
      if (args.keepItem === true) {
        this.setContentElementLeft(0);
        this._panState = IgxListPanState.NONE;
      } else {
        if (dir === IgxListPanState.LEFT) {
          this.setContentElementLeft(this.maxLeft);
          this._panState = IgxListPanState.LEFT;
        } else {
          this.setContentElementLeft(this.maxRight);
          this._panState = IgxListPanState.RIGHT;
        }
      }
      if (oldPanState !== this._panState) {
        const args2 = {
          oldState: oldPanState,
          newState: this._panState,
          item: this
        };
        this.list.panStateChange.emit(args2);
      }
      this.hideLeftAndRightPanTemplates();
    }
    /**
     * @hidden
     */
    showLeftPanTemplate() {
      this.setLeftAndRightTemplatesVisibility('visible', 'hidden');
    }
    /**
     * @hidden
     */
    showRightPanTemplate() {
      this.setLeftAndRightTemplatesVisibility('hidden', 'visible');
    }
    /**
     * @hidden
     */
    hideLeftAndRightPanTemplates() {
      setTimeout(() => {
        this.setLeftAndRightTemplatesVisibility('hidden', 'hidden');
      }, 500);
    }
    /**
     * @hidden
     */
    setLeftAndRightTemplatesVisibility(leftVisibility, rightVisibility) {
      if (this.leftPanningTemplateElement && this.leftPanningTemplateElement.nativeElement) {
        this.leftPanningTemplateElement.nativeElement.style.visibility = leftVisibility;
      }
      if (this.rightPanningTemplateElement && this.rightPanningTemplateElement.nativeElement) {
        this.rightPanningTemplateElement.nativeElement.style.visibility = rightVisibility;
      }
    }
    /**
     * @hidden
     */
    setContentElementLeft(value) {
      this.panOffset = value;
      this.contentElement.style.transform = 'translateX(' + value + 'px)';
    }
    /**
     * @hidden
     */
    isTrue(value) {
      if (typeof value === 'boolean') {
        return value;
      } else {
        return value === 'true';
      }
    }
    /**
     * @hidden
     */
    resetPanPosition() {
      this.setContentElementLeft(0);
      this._panState = IgxListPanState.NONE;
      this.hideLeftAndRightPanTemplates();
    }
    static {
      this.ɵfac = function IgxListItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListItemComponent)(i0.ɵɵdirectiveInject(IgxListBaseDirective), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxListItemComponent,
        selectors: [["igx-list-item"]],
        viewQuery: function IgxListItemComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c133, 5);
            i0.ɵɵviewQuery(_c134, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leftPanningTemplateElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightPanningTemplateElement = _t.first);
          }
        },
        hostVars: 12,
        hostBindings: function IgxListItemComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxListItemComponent_click_HostBindingHandler($event) {
              return ctx.clicked($event);
            })("panstart", function IgxListItemComponent_panstart_HostBindingHandler() {
              return ctx.panStart();
            })("pancancel", function IgxListItemComponent_pancancel_HostBindingHandler() {
              return ctx.panCancel();
            })("panmove", function IgxListItemComponent_panmove_HostBindingHandler($event) {
              return ctx.panMove($event);
            })("panend", function IgxListItemComponent_panend_HostBindingHandler() {
              return ctx.panEnd();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.ariaLabel)("role", ctx.role);
            i0.ɵɵstyleProp("touch-action", ctx.touchAction)("display", ctx.display);
            i0.ɵɵclassProp("igx-list__item-base--selected", ctx.selected)("igx-list__header", ctx.headerStyle)("igx-list__item-base", ctx.innerStyle);
          }
        },
        inputs: {
          isHeader: [2, "isHeader", "isHeader", booleanAttribute],
          hidden: [2, "hidden", "hidden", booleanAttribute],
          index: "index",
          role: "role",
          selected: [2, "selected", "selected", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager])],
        ngContentSelectors: _c136,
        decls: 12,
        vars: 4,
        consts: [["itemsContent", ""], ["itemThumbnails", ""], ["itemLines", ""], ["itemActions", ""], ["leftPanningTmpl", ""], ["rightPanningTmpl", ""], [1, "igx-list__item-right", 3, "width", "height"], [1, "igx-list__item-left", 3, "width", "height"], [1, "igx-list__item-content"], [1, "igx-list__item-right"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-list__item-left"], [1, "igx-list__item-thumbnail"], [1, "igx-list__item-lines"], [1, "igx-list__item-actions"], [4, "ngTemplateOutlet"]],
        template: function IgxListItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c135);
            i0.ɵɵtemplate(0, IgxListItemComponent_Conditional_0_Template, 3, 6, "div", 6)(1, IgxListItemComponent_Conditional_1_Template, 3, 6, "div", 7)(2, IgxListItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, IgxListItemComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, IgxListItemComponent_ng_template_6_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, IgxListItemComponent_ng_template_8_Template, 2, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, IgxListItemComponent_Conditional_10_Template, 1, 1, "ng-container")(11, IgxListItemComponent_Conditional_11_Template, 5, 4, "div", 8);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isHeader && ctx.list.listItemLeftPanningTemplate ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isHeader && ctx.list.listItemRightPanningTemplate ? 1 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵconditional(ctx.isHeader ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isHeader ? 11 : -1);
          }
        },
        dependencies: [NgTemplateOutlet],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxListItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ListResourceStringsEN = {
  igx_list_no_items: 'There are no items in the list.',
  igx_list_loading: 'Loading data from the server...'
};
let NEXT_ID$b = 0;
/**
 * igxListThumbnail is container for the List media
 * Use it to wrap anything you want to be used as a thumbnail.
 */
let IgxListThumbnailDirective = /*#__PURE__*/(() => {
  class IgxListThumbnailDirective {
    static {
      this.ɵfac = function IgxListThumbnailDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListThumbnailDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListThumbnailDirective,
        selectors: [["", "igxListThumbnail", ""]]
      });
    }
  }
  return IgxListThumbnailDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxListAction is container for the List action
 * Use it to wrap anything you want to be used as a list action: icon, checkbox...
 */
let IgxListActionDirective = /*#__PURE__*/(() => {
  class IgxListActionDirective {
    static {
      this.ɵfac = function IgxListActionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListActionDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListActionDirective,
        selectors: [["", "igxListAction", ""]]
      });
    }
  }
  return IgxListActionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxListLine is container for the List text content
 * Use it to wrap anything you want to be used as a plane text.
 */
let IgxListLineDirective = /*#__PURE__*/(() => {
  class IgxListLineDirective {
    static {
      this.ɵfac = function IgxListLineDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListLineDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListLineDirective,
        selectors: [["", "igxListLine", ""]]
      });
    }
  }
  return IgxListLineDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxListLineTitle is a directive that add class to the target element
 * Use it to make anything to look like list Title.
 */
let IgxListLineTitleDirective = /*#__PURE__*/(() => {
  class IgxListLineTitleDirective {
    constructor() {
      this.cssClass = 'igx-list__item-line-title';
    }
    static {
      this.ɵfac = function IgxListLineTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListLineTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListLineTitleDirective,
        selectors: [["", "igxListLineTitle", ""]],
        hostVars: 2,
        hostBindings: function IgxListLineTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-list__item-line-title", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxListLineTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * igxListLineSubTitle is a directive that add class to the target element
 * Use it to make anything to look like list Subtitle.
 */
let IgxListLineSubTitleDirective = /*#__PURE__*/(() => {
  class IgxListLineSubTitleDirective {
    constructor() {
      this.cssClass = 'igx-list__item-line-subtitle';
    }
    static {
      this.ɵfac = function IgxListLineSubTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListLineSubTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxListLineSubTitleDirective,
        selectors: [["", "igxListLineSubTitle", ""]],
        hostVars: 2,
        hostBindings: function IgxListLineSubTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-list__item-line-subtitle", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxListLineSubTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Displays a collection of data items in a templatable list format
 *
 * @igxModule IgxListModule
 *
 * @igxTheme igx-list-theme
 *
 * @igxKeywords list, data
 *
 * @igxGroup Grids & Lists
 *
 * @remarks
 * The Ignite UI List displays rows of items and supports one or more header items as well as search and filtering
 * of list items. Each list item is completely templatable and will support any valid HTML or Angular component.
 *
 * @example
 * ```html
 * <igx-list>
 *   <igx-list-item isHeader="true">Contacts</igx-list-item>
 *   <igx-list-item *ngFor="let contact of contacts">
 *     <span class="name">{{ contact.name }}</span>
 *     <span class="phone">{{ contact.phone }}</span>
 *   </igx-list-item>
 * </igx-list>
 * ```
 */
let IgxListComponent = /*#__PURE__*/(() => {
  class IgxListComponent extends IgxListBaseDirective {
    /**
     * Sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * Returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    constructor(element) {
      super(element);
      this.element = element;
      /**
       * Provides a threshold after which the item's panning will be completed automatically.
       *
       * @remarks
       * By default this property is set to 0.5 which is 50% of the list item's width.
       *
       * @example
       * ```html
       * <igx-list [panEndTriggeringThreshold]="0.8"></igx-list>
       * ```
       */
      this.panEndTriggeringThreshold = 0.5;
      /**
       * Sets/gets the `id` of the list.
       *
       * @remarks
       * If not set, the `id` of the first list component will be `"igx-list-0"`.
       *
       * @example
       * ```html
       * <igx-list id="my-first-list"></igx-list>
       * ```
       * ```typescript
       * let listId = this.list.id;
       * ```
       */
      this.id = `igx-list-${NEXT_ID$b++}`;
      /**
       * Sets/gets whether the left panning of an item is allowed.
       *
       * @remarks
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-list [allowLeftPanning]="true"></igx-list>
       * ```
       * ```typescript
       * let isLeftPanningAllowed = this.list.allowLeftPanning;
       * ```
       */
      this.allowLeftPanning = false;
      /**
       * Sets/gets whether the right panning of an item is allowed.
       *
       * @remarks
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-list [allowRightPanning]="true"></igx-list>
       * ```
       * ```typescript
       * let isRightPanningAllowed = this.list.allowRightPanning;
       * ```
       */
      this.allowRightPanning = false;
      /**
       * Sets/gets whether the list is currently loading data.
       *
       * @remarks
       * Set it to display the dataLoadingTemplate while data is being retrieved.
       * Default value is `false`.
       *
       * @example
       * ```html
       *  <igx-list [isLoading]="true"></igx-list>
       * ```
       * ```typescript
       * let isLoading = this.list.isLoading;
       * ```
       */
      this.isLoading = false;
      /**
       * Event emitted when a left pan gesture is executed on a list item.
       *
       * @remarks
       * Provides a reference to an object of type `IListItemPanningEventArgs` as an event argument.
       *
       * @example
       * ```html
       * <igx-list [allowLeftPanning]="true" (leftPan)="leftPan($event)"></igx-list>
       * ```
       */
      this.leftPan = new EventEmitter();
      /**
       * Event emitted when a right pan gesture is executed on a list item.
       *
       * @remarks
       * Provides a reference to an object of type `IListItemPanningEventArgs` as an event argument.
       *
       * @example
       * ```html
       * <igx-list [allowRightPanning]="true" (rightPan)="rightPan($event)"></igx-list>
       * ```
       */
      this.rightPan = new EventEmitter();
      /**
       * Event emitted when a pan gesture is started.
       *
       * @remarks
       * Provides a reference to an object of type `IListItemPanningEventArgs` as an event argument.
       *
       * @example
       * ```html
       * <igx-list (startPan)="startPan($event)"></igx-list>
       * ```
       */
      this.startPan = new EventEmitter();
      /**
       * Event emitted when a pan gesture is completed or canceled.
       *
       * @remarks
       * Provides a reference to an object of type `IListItemPanningEventArgs` as an event argument.
       *
       * @example
       * ```html
       * <igx-list (endPan)="endPan($event)"></igx-list>
       * ```
       */
      this.endPan = new EventEmitter();
      /**
       * Event emitted when a pan item is returned to its original position.
       *
       * @remarks
       * Provides a reference to an object of type `IgxListComponent` as an event argument.
       *
       * @example
       * ```html
       * <igx-list (resetPan)="resetPan($event)"></igx-list>
       * ```
       */
      this.resetPan = new EventEmitter();
      /**
       *
       * Event emitted when a pan gesture is executed on a list item.
       *
       * @remarks
       * Provides references to the `IgxListItemComponent` and `IgxListPanState` as event arguments.
       *
       * @example
       * ```html
       * <igx-list (panStateChange)="panStateChange($event)"></igx-list>
       * ```
       */
      this.panStateChange = new EventEmitter();
      /**
       * Event emitted when a list item is clicked.
       *
       * @remarks
       * Provides references to the `IgxListItemComponent` and `Event` as event arguments.
       *
       * @example
       * ```html
       * <igx-list (itemClicked)="onItemClicked($event)"></igx-list>
       * ```
       */
      this.itemClicked = new EventEmitter();
      this._resourceStrings = getCurrentResourceStrings(ListResourceStringsEN);
      this._role = 'list';
    }
    /**
     * @hidden
     * @internal
     */
    get sortedChildren() {
      if (this.children !== undefined) {
        return this.children.toArray().sort((a, b) => a.index - b.index);
      }
      return null;
    }
    /**
     * Gets/Sets the `role` attribute value.
     *
     * @example
     * ```typescript
     * let listRole =  this.list.role;
     * ```
     */
    get role() {
      return this._role;
    }
    set role(val) {
      this._role = val;
    }
    /**
     * Gets a boolean indicating if the list is empty.
     *
     * @example
     * ```typescript
     * let isEmpty =  this.list.isListEmpty;
     * ```
     */
    get isListEmpty() {
      return !this.children || this.children.length === 0;
    }
    /**
     * @hidden
     * @internal
     */
    get cssClass() {
      return !this.isListEmpty;
    }
    /**
     * Gets the list `items` excluding the header ones.
     *
     * @example
     * ```typescript
     * let listItems: IgxListItemComponent[] = this.list.items;
     * ```
     */
    get items() {
      const items = [];
      if (this.children !== undefined) {
        for (const child of this.sortedChildren) {
          if (!child.isHeader) {
            items.push(child);
          }
        }
      }
      return items;
    }
    /**
     * Gets the header list `items`.
     *
     * @example
     * ```typescript
     * let listHeaders: IgxListItemComponent[] =  this.list.headers;
     * ```
     */
    get headers() {
      const headers = [];
      if (this.children !== undefined) {
        for (const child of this.children.toArray()) {
          if (child.isHeader) {
            headers.push(child);
          }
        }
      }
      return headers;
    }
    /**
     * Gets the `context` object of the template binding.
     *
     * @remarks
     * Gets the `context` object which represents the `template context` binding into the `list container`
     * by providing the `$implicit` declaration which is the `IgxListComponent` itself.
     *
     * @example
     * ```typescript
     * let listComponent =  this.list.context;
     * ```
     */
    get context() {
      return {
        $implicit: this
      };
    }
    /**
     * Gets a `TemplateRef` to the currently used template.
     *
     * @example
     * ```typescript
     * let listTemplate = this.list.template;
     * ```
     */
    get template() {
      if (this.isLoading) {
        return this.dataLoadingTemplate ? this.dataLoadingTemplate.template : this.defaultDataLoadingTemplate;
      } else {
        return this.emptyListTemplate ? this.emptyListTemplate.template : this.defaultEmptyListTemplate;
      }
    }
    static {
      this.ɵfac = function IgxListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxListComponent,
        selectors: [["igx-list"]],
        contentQueries: function IgxListComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxEmptyListTemplateDirective, 5, IgxEmptyListTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxDataLoadingTemplateDirective, 5, IgxDataLoadingTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxListItemLeftPanningTemplateDirective, 5, IgxListItemLeftPanningTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxListItemRightPanningTemplateDirective, 5, IgxListItemRightPanningTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxListItemComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyListTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataLoadingTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listItemLeftPanningTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listItemRightPanningTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        viewQuery: function IgxListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c137, 7, TemplateRef);
            i0.ɵɵviewQuery(_c138, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultEmptyListTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultDataLoadingTemplate = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function IgxListComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role);
            i0.ɵɵclassProp("igx-list--empty", ctx.isListEmpty)("igx-list", ctx.cssClass);
          }
        },
        inputs: {
          panEndTriggeringThreshold: "panEndTriggeringThreshold",
          id: "id",
          allowLeftPanning: [2, "allowLeftPanning", "allowLeftPanning", booleanAttribute],
          allowRightPanning: [2, "allowRightPanning", "allowRightPanning", booleanAttribute],
          isLoading: [2, "isLoading", "isLoading", booleanAttribute],
          resourceStrings: "resourceStrings",
          role: "role"
        },
        outputs: {
          leftPan: "leftPan",
          rightPan: "rightPan",
          startPan: "startPan",
          endPan: "endPan",
          resetPan: "resetPan",
          panStateChange: "panStateChange",
          itemClicked: "itemClicked"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxListBaseDirective,
          useExisting: IgxListComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 6,
        vars: 1,
        consts: [["defaultEmptyList", ""], ["defaultDataLoading", ""], [1, "igx-list__message"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function IgxListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, IgxListComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxListComponent_ng_template_3_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxListComponent_Conditional_5_Template, 1, 2, "ng-container");
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ctx.children || ctx.children.length === 0 || ctx.isLoading ? 5 : -1);
          }
        },
        dependencies: [NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxExcelStyleLoadingValuesTemplateDirective = /*#__PURE__*/(() => {
  class IgxExcelStyleLoadingValuesTemplateDirective {
    static ngTemplateContextGuard(_dir, ctx) {
      return true;
    }
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxExcelStyleLoadingValuesTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleLoadingValuesTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExcelStyleLoadingValuesTemplateDirective,
        selectors: [["", "igxExcelStyleLoading", ""]]
      });
    }
  }
  return IgxExcelStyleLoadingValuesTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$a = 0;
/**
 * A component used for presenting Excel style search UI.
 */
let IgxExcelStyleSearchComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleSearchComponent {
    static {
      this.filterOptimizationThreshold = 2;
    }
    /**
     * @hidden @internal
     */
    get selectAllItem() {
      if (!this._selectAllItem) {
        const selectAllItem = {
          isSelected: false,
          isFiltered: false,
          indeterminate: false,
          isSpecial: true,
          isBlanks: false,
          value: this.esf.grid.resourceStrings.igx_grid_excel_select_all,
          label: this.esf.grid.resourceStrings.igx_grid_excel_select_all
        };
        this._selectAllItem = selectAllItem;
      }
      return this._selectAllItem;
    }
    /**
     * @hidden @internal
     */
    get addToCurrentFilterItem() {
      if (!this._addToCurrentFilterItem) {
        const addToCurrentFilterItem = {
          isSelected: false,
          isFiltered: false,
          indeterminate: false,
          isSpecial: true,
          isBlanks: false,
          value: this.esf.grid.resourceStrings.igx_grid_excel_add_to_filter,
          label: this.esf.grid.resourceStrings.igx_grid_excel_add_to_filter
        };
        this._addToCurrentFilterItem = addToCurrentFilterItem;
      }
      return this._addToCurrentFilterItem;
    }
    /**
     * @hidden @internal
     */
    get isLoading() {
      return this._isLoading;
    }
    /**
     * @hidden @internal
     */
    set isLoading(value) {
      this._isLoading = value;
      if (!this.cdr.destroyed) {
        this.cdr.detectChanges();
      }
    }
    /**
     * @hidden @internal
     */
    get valuesLoadingTemplate() {
      if (this.esf.grid?.excelStyleLoadingValuesTemplateDirective) {
        return this.esf.grid.excelStyleLoadingValuesTemplateDirective.template;
      } else {
        return this.defaultExcelStyleLoadingValuesTemplate;
      }
    }
    constructor(cdr, esf, platform) {
      this.cdr = cdr;
      this.esf = esf;
      this.platform = platform;
      /**
       * @hidden @internal
       */
      this.defaultClass = true;
      /**
       * @hidden @internal
       */
      this.displayedListData = [];
      this.activeDescendant = '';
      this._id = `igx-excel-style-search-${NEXT_ID$a++}`;
      this._focusedItem = null;
      this.destroy$ = new Subject();
      /**
       * @hidden @internal
       */
      this.refreshSize = () => {
        if (this.virtDir) {
          this.virtDir.igxForContainerSize = this.containerSize;
          this.virtDir.igxForItemSize = this.itemSize;
          this.virtDir.recalcUpdateSizes();
          this.cdr.detectChanges();
        }
      };
      esf.loadingStart.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.displayedListData = [];
        this.isLoading = true;
      });
      esf.loadingEnd.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.refreshSize();
        this.isLoading = false;
      });
      esf.initialized.pipe(takeUntil(this.destroy$)).subscribe(() => {
        requestAnimationFrame(() => {
          this.refreshSize();
          this.searchInput.nativeElement.focus();
        });
      });
      esf.columnChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.virtDir?.resetScrollPosition();
        if (this.virtDir) {
          this.virtDir.state.startIndex = 0;
        }
      });
      esf.listDataLoaded.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this._selectAllItem = this.esf.listData[0];
        if (this.isHierarchical() && this.esf.listData[0].isSpecial) {
          this.esf.listData.splice(0, 1);
        }
        if (this.searchValue) {
          this.clearInput();
        } else {
          this.filterListData();
        }
        this.cdr.detectChanges();
        requestAnimationFrame(() => {
          this.refreshSize();
          this.searchInput.nativeElement.focus();
        });
      });
    }
    ngAfterViewInit() {
      requestAnimationFrame(this.refreshSize);
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden @internal
     */
    clearInput() {
      this.searchValue = null;
      this.filterListData();
    }
    /**
     * @hidden @internal
     */
    onCheckboxChange(eventArgs) {
      const selectedIndex = this.displayedListData.indexOf(eventArgs.owner.value);
      const selectAllBtn = this.displayedListData[0];
      if (selectedIndex === 0) {
        this.displayedListData.forEach(element => {
          if (element === this.addToCurrentFilterItem) {
            return;
          }
          element.isSelected = eventArgs.checked;
        });
        selectAllBtn.indeterminate = false;
      } else {
        eventArgs.owner.value.isSelected = eventArgs.checked;
        const indexToStartSlicing = this.displayedListData.indexOf(this.addToCurrentFilterItem) > -1 ? 2 : 1;
        const slicedArray = this.displayedListData.slice(indexToStartSlicing, this.displayedListData.length);
        if (!slicedArray.find(el => el.isSelected === false)) {
          selectAllBtn.indeterminate = false;
          selectAllBtn.isSelected = true;
        } else if (!slicedArray.find(el => el.isSelected === true)) {
          selectAllBtn.indeterminate = false;
          selectAllBtn.isSelected = false;
        } else {
          selectAllBtn.indeterminate = true;
        }
      }
    }
    /**
     * @hidden @internal
     */
    onSelectAllCheckboxChange(eventArgs) {
      this._selectAllItem.isSelected = eventArgs.checked;
      this._selectAllItem.indeterminate = false;
      const treeNodes = this.tree.nodes;
      treeNodes.forEach(node => node.data.isSelected = eventArgs.checked);
    }
    /**
     * @hidden @internal
     */
    onNodeSelectionChange(eventArgs) {
      eventArgs.added.forEach(node => {
        node.data.isSelected = true;
      });
      eventArgs.removed.forEach(node => {
        node.data.isSelected = false;
      });
      this._hierarchicalSelectedItems = eventArgs.newSelection.map(item => item.data);
      const selectAllBtn = this.selectAllItem;
      if (this._hierarchicalSelectedItems.length === 0) {
        selectAllBtn.indeterminate = false;
        selectAllBtn.isSelected = false;
      } else if (this._hierarchicalSelectedItems.length === this.tree.nodes.length) {
        selectAllBtn.indeterminate = false;
        selectAllBtn.isSelected = true;
      } else {
        selectAllBtn.indeterminate = true;
        selectAllBtn.isSelected = false;
      }
    }
    /**
     * @hidden @internal
     */
    get itemSize() {
      let itemSize = '40px';
      const esf = this.esf;
      switch (esf.size) {
        case Size.Medium:
          itemSize = '32px';
          break;
        case Size.Small:
          itemSize = '24px';
          break;
        default:
          break;
      }
      return itemSize;
    }
    /**
     * @hidden @internal
     */
    get containerSize() {
      if (this.esf.listData.length) {
        return this.list?.element.nativeElement.offsetHeight;
      }
      // GE Nov 1st, 2021 #10355 Return a numeric value, so the chunk size is calculated properly.
      // If we skip this branch, on applying the filter the _calculateChunkSize() method off the ForOfDirective receives
      // an igxForContainerSize = undefined, thus assigns the chunkSize to the igxForOf.length which leads to performance issues.
      return 0;
    }
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value;
    }
    getItemId(index) {
      return `${this.id}-item-${index}`;
    }
    setActiveDescendant() {
      this.activeDescendant = this.focusedItem?.id || '';
    }
    get focusedItem() {
      return this._focusedItem;
    }
    set focusedItem(val) {
      this._focusedItem = val;
    }
    /**
     * @hidden @internal
     */
    get applyButtonDisabled() {
      return this._selectAllItem && !this._selectAllItem.isSelected && !this._selectAllItem.indeterminate || this.displayedListData && this.displayedListData.length === 0;
    }
    /**
     * @hidden @internal
     */
    onInputKeyDown(event) {
      switch (event.key) {
        case this.platform.KEYMAP.ENTER:
          event.preventDefault();
          this.applyFilter();
          return;
        case this.platform.KEYMAP.ESCAPE:
          if (this.searchValue) {
            event.stopPropagation();
            this.clearInput();
          }
          return;
      }
    }
    /**
     * @hidden @internal
     */
    filterListData() {
      if (this.esf.column?.dataType === GridColumnDataType.Number || this.esf.column?.dataType === GridColumnDataType.Currency || this.esf.column?.dataType === GridColumnDataType.Percent) {
        this.rejectNonNumericalEntries();
      }
      if (!this.esf.listData || !this.esf.listData.length) {
        this.displayedListData = [];
        return;
      }
      let selectAllBtn;
      if (this._selectAllItem) {
        selectAllBtn = this._selectAllItem;
      } else {
        selectAllBtn = this.esf.listData[0];
      }
      if (!this.searchValue) {
        let anyFiltered = this.esf.listData.some(i => i.isFiltered);
        let anyUnfiltered = this.esf.listData.some(i => !i.isFiltered);
        selectAllBtn.indeterminate = anyFiltered && anyUnfiltered;
        if (this.isHierarchical() && this.tree) {
          this._hierarchicalSelectedItems = this.tree.nodes.map(n => n.data).filter(item => item.isFiltered);
          this.tree.collapseAll();
        }
        this.esf.listData.forEach(i => i.isSelected = i.isFiltered);
        if (this.displayedListData !== this.esf.listData) {
          this.displayedListData = this.esf.listData;
          if (this.isHierarchical()) {
            this.cdr.detectChanges();
            this.tree.nodes.forEach(n => {
              const item = n.data;
              n.selected = item.isSelected || item.isFiltered;
              anyFiltered = anyFiltered || n.selected;
              anyUnfiltered = anyUnfiltered || !n.selected;
            });
            selectAllBtn.indeterminate = anyFiltered && anyUnfiltered;
          }
        }
        selectAllBtn.label = this.esf.grid.resourceStrings.igx_grid_excel_select_all;
        this.matchesCount = this.displayedListData.length - 1;
        this.cdr.detectChanges();
        return;
      }
      const searchVal = this.searchValue.toLowerCase();
      if (this.isHierarchical()) {
        this._hierarchicalSelectedItems = [];
        this.esf.listData.forEach(i => i.isSelected = false);
        const matchedData = cloneHierarchicalArray(this.esf.listData, 'children');
        this.displayedListData = this.hierarchicalSelectMatches(matchedData, searchVal);
        this.cdr.detectChanges();
        this.tree.nodes.forEach(n => {
          n.selected = true;
          if (n.data.label.toString().toLowerCase().indexOf(searchVal) > -1) {
            this.expandAllParentNodes(n);
          }
        });
      } else {
        this.displayedListData = this.esf.listData.filter((it, i) => i === 0 && it.isSpecial || it.label !== null && it.label !== undefined && !it.isBlanks && it.label.toString().toLowerCase().indexOf(searchVal) > -1);
        this.esf.listData.forEach(i => i.isSelected = false);
        this.displayedListData.forEach(i => i.isSelected = true);
        this.displayedListData.splice(1, 0, this.addToCurrentFilterItem);
        if (this.displayedListData.length === 2) {
          this.displayedListData = [];
        }
      }
      if (this.displayedListData.length > 2) {
        this.matchesCount = this.displayedListData.length - 2;
      } else {
        this.matchesCount = 0;
      }
      selectAllBtn.indeterminate = false;
      selectAllBtn.isSelected = true;
      selectAllBtn.label = this.esf.grid.resourceStrings.igx_grid_excel_select_all_search_results;
      this.cdr.detectChanges();
    }
    /**
     * @hidden @internal
     */
    applyFilter() {
      const filterTree = new FilteringExpressionsTree(FilteringLogic.Or, this.esf.column.field);
      let selectedItems = [];
      if (this.isHierarchical()) {
        if (this.addToCurrentFilterCheckbox && this.addToCurrentFilterCheckbox.checked) {
          this.addFilteredToSelectedItems(this.esf.listData);
        }
        selectedItems = this._hierarchicalSelectedItems;
      } else {
        const item = this.displayedListData[1];
        const addToCurrentFilterOptionVisible = item === this.addToCurrentFilterItem;
        selectedItems = addToCurrentFilterOptionVisible && item.isSelected ? this.esf.listData.slice(1, this.esf.listData.length).filter(el => el.isSelected || el.isFiltered) : this.esf.listData.slice(1, this.esf.listData.length).filter(el => el.isSelected);
      }
      let unselectedItem;
      if (this.isHierarchical()) {
        unselectedItem = this.esf.listData.find(el => el.isSelected === false);
      } else {
        unselectedItem = this.esf.listData.slice(1, this.esf.listData.length).find(el => el.isSelected === false);
      }
      if (unselectedItem) {
        if (selectedItems.length <= IgxExcelStyleSearchComponent.filterOptimizationThreshold) {
          selectedItems.forEach(element => {
            let condition = null;
            if (element.value !== null && element.value !== undefined) {
              if (this.esf.column.dataType === GridColumnDataType.Boolean) {
                condition = this.createCondition(element.value.toString());
              } else {
                const filterCondition = this.esf.column.dataType === GridColumnDataType.Time ? 'at' : 'equals';
                condition = this.createCondition(filterCondition);
              }
            } else {
              condition = this.createCondition('empty');
            }
            filterTree.filteringOperands.push({
              condition,
              conditionName: condition.name,
              fieldName: this.esf.column.field,
              ignoreCase: this.esf.column.filteringIgnoreCase,
              searchVal: element.value
            });
          });
        } else {
          const blanksItemIndex = selectedItems.findIndex(e => e.value === null || e.value === undefined);
          let blanksItem;
          if (blanksItemIndex >= 0) {
            blanksItem = selectedItems[blanksItemIndex];
            selectedItems.splice(blanksItemIndex, 1);
          }
          filterTree.filteringOperands.push({
            condition: this.createCondition('in'),
            conditionName: 'in',
            fieldName: this.esf.column.field,
            ignoreCase: this.esf.column.filteringIgnoreCase,
            searchVal: new Set(this.esf.column.dataType === GridColumnDataType.Date ? selectedItems.map(d => d.value.toDateString()) : this.esf.column.dataType === GridColumnDataType.DateTime ? selectedItems.map(d => d.value.toISOString()) : this.esf.column.dataType === GridColumnDataType.Time ? selectedItems.map(e => e.value.toLocaleTimeString()) : selectedItems.map(e => e.value))
          });
          if (blanksItem) {
            filterTree.filteringOperands.push({
              condition: this.createCondition('empty'),
              conditionName: 'empty',
              fieldName: this.esf.column.field,
              ignoreCase: this.esf.column.filteringIgnoreCase,
              searchVal: blanksItem.value
            });
          }
        }
        const grid = this.esf.grid;
        const col = this.esf.column;
        grid.filteringService.filterInternal(col.field, filterTree);
        this.esf.expressionsList = new Array();
        grid.filteringService.generateExpressionsList(col.filteringExpressionsTree, grid.filteringLogic, this.esf.expressionsList);
      } else {
        this.esf.grid.filteringService.clearFilter(this.esf.column.field);
      }
      this.esf.closeDropdown();
    }
    handleKeyDown(event) {
      if (event) {
        const key = event.key.toLowerCase();
        const navKeys = ['space', 'spacebar', ' ', 'arrowup', 'up', 'arrowdown', 'down', 'home', 'end'];
        if (navKeys.indexOf(key) === -1) {
          // If key has appropriate function in DD
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        switch (key) {
          case 'arrowup':
          case 'up':
            this.onArrowUpKeyDown();
            break;
          case 'arrowdown':
          case 'down':
            this.onArrowDownKeyDown();
            break;
          case 'home':
            this.onHomeKeyDown();
            break;
          case 'end':
            this.onEndKeyDown();
            break;
          case 'space':
          case 'spacebar':
          case ' ':
            this.onActionKeyDown();
            break;
          default:
            return;
        }
      }
    }
    onFocus() {
      const firstIndexInView = this.virtDir.state.startIndex;
      if (this.virtDir.igxForOf.length > 0) {
        this.focusedItem = {
          id: this.getItemId(firstIndexInView),
          index: firstIndexInView,
          checked: this.virtDir.igxForOf[firstIndexInView].isSelected
        };
      }
      this.setActiveDescendant();
    }
    onFocusOut() {
      this.focusedItem = null;
      this.setActiveDescendant();
    }
    /**
     * @hidden @internal
     */
    isHierarchical() {
      return this.esf.isHierarchical;
    }
    /**
     * @hidden @internal
     */
    isTreeEmpty() {
      return this.esf.isHierarchical && this.displayedListData.length === 0;
    }
    hierarchicalSelectMatches(data, searchVal) {
      data.forEach(element => {
        element.indeterminate = false;
        element.isSelected = false;
        const node = this.tree.nodes.filter(n => n.data.label === element.label)[0];
        if (node) {
          node.expanded = false;
        }
        if (element.label.toString().toLowerCase().indexOf(searchVal) > -1) {
          element.isSelected = true;
          this.hierarchicalSelectAllChildren(element);
          this._hierarchicalSelectedItems.push(element);
        } else if (element.children.length > 0) {
          element.children = this.hierarchicalSelectMatches(element.children, searchVal);
          if (element.children.length > 0) {
            element.isSelected = true;
            if (node) {
              node.expanded = true;
            }
          }
        }
      });
      return data.filter(element => element.isSelected === true);
    }
    hierarchicalSelectAllChildren(element) {
      element.children.forEach(child => {
        child.indeterminate = false;
        child.isSelected = true;
        this._hierarchicalSelectedItems.push(child);
        if (child.children) {
          this.hierarchicalSelectAllChildren(child);
        }
      });
    }
    expandAllParentNodes(node) {
      if (node.parentNode) {
        node.parentNode.expanded = true;
        this.expandAllParentNodes(node.parentNode);
      }
    }
    addFilteredToSelectedItems(records) {
      records.forEach(record => {
        if (record.children) {
          this.addFilteredToSelectedItems(record.children);
        }
        if (record.isFiltered && this._hierarchicalSelectedItems.indexOf(record) < 0) {
          this._hierarchicalSelectedItems.push(record);
        }
      });
    }
    createCondition(conditionName) {
      switch (this.esf.column.dataType) {
        case GridColumnDataType.Boolean:
          return IgxBooleanFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Number:
        case GridColumnDataType.Currency:
        case GridColumnDataType.Percent:
          return IgxNumberFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Date:
          return IgxDateFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.Time:
          return IgxTimeFilteringOperand.instance().condition(conditionName);
        case GridColumnDataType.DateTime:
          return IgxDateTimeFilteringOperand.instance().condition(conditionName);
        default:
          return IgxStringFilteringOperand.instance().condition(conditionName);
      }
    }
    /**
     * @hidden @internal
     */
    rejectNonNumericalEntries() {
      const regExp = /[^0-9\.,eE\-]/g;
      if (this.searchValue && regExp.test(this.searchValue)) {
        this.searchInput.value = this.searchValue.replace(regExp, '');
        this.searchValue = this.searchInput.value;
      }
    }
    onArrowUpKeyDown() {
      if (this.focusedItem && this.focusedItem.index === 0 && this.virtDir.state.startIndex === 0) {
        // on ArrowUp the focus stays on the same element if it is the first focused
        return;
      } else {
        this.navigateItem(this.focusedItem ? this.focusedItem.index - 1 : 0);
      }
      this.setActiveDescendant();
    }
    onArrowDownKeyDown() {
      const lastIndex = this.virtDir.igxForOf.length - 1;
      if (this.focusedItem && this.focusedItem.index === lastIndex) {
        // on ArrowDown the focus stays on the same element if it is the last focused
        return;
      } else {
        this.navigateItem(this.focusedItem ? this.focusedItem.index + 1 : 0);
      }
      this.setActiveDescendant();
    }
    onHomeKeyDown() {
      this.navigateItem(0);
      this.setActiveDescendant();
    }
    onEndKeyDown() {
      this.navigateItem(this.virtDir.igxForOf.length - 1);
      this.setActiveDescendant();
    }
    onActionKeyDown() {
      const dataItem = this.displayedListData[this.focusedItem.index];
      const args = {
        checked: !dataItem.isSelected,
        owner: {
          value: dataItem
        }
      };
      this.onCheckboxChange(args);
    }
    navigateItem(index) {
      if (index === -1 || index >= this.virtDir.igxForOf.length) {
        return;
      }
      const direction = index > (this.focusedItem ? this.focusedItem.index : -1) ? Navigate.Down : Navigate.Up;
      const scrollRequired = this.isIndexOutOfBounds(index, direction);
      this.focusedItem = {
        id: this.getItemId(index),
        index: index,
        checked: this.virtDir.igxForOf[index].isSelected
      };
      if (scrollRequired) {
        this.virtDir.scrollTo(index);
      }
    }
    isIndexOutOfBounds(index, direction) {
      const virtState = this.virtDir.state;
      const currentPosition = this.virtDir.getScroll().scrollTop;
      const itemPosition = this.virtDir.getScrollForIndex(index, direction === Navigate.Down);
      const indexOutOfChunk = index < virtState.startIndex || index > virtState.chunkSize + virtState.startIndex;
      const scrollNeeded = direction === Navigate.Down ? currentPosition < itemPosition : currentPosition > itemPosition;
      const subRequired = indexOutOfChunk || scrollNeeded;
      return subRequired;
    }
    static {
      this.ɵfac = function IgxExcelStyleSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(BaseFilteringComponent), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleSearchComponent,
        selectors: [["igx-excel-style-search"]],
        viewQuery: function IgxExcelStyleSearchComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c76, 7, IgxInputDirective);
            i0.ɵɵviewQuery(_c139, 7, IgxButtonDirective);
            i0.ɵɵviewQuery(_c140, 5, IgxListComponent);
            i0.ɵɵviewQuery(_c141, 5, IgxCheckboxComponent);
            i0.ɵɵviewQuery(_c142, 5, IgxCheckboxComponent);
            i0.ɵɵviewQuery(_c143, 5, IgxTreeComponent);
            i0.ɵɵviewQuery(IgxForOfDirective, 5);
            i0.ɵɵviewQuery(_c144, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cancelButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.list = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectAllCheckbox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addToCurrentFilterCheckbox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tree = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtDir = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExcelStyleLoadingValuesTemplate = _t.first);
          }
        },
        hostVars: 3,
        hostBindings: function IgxExcelStyleSearchComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-excel-filter__menu-main", ctx.defaultClass);
          }
        },
        inputs: {
          id: "id"
        },
        decls: 19,
        vars: 8,
        consts: [["input", ""], ["emptySearch", ""], ["defaultExcelStyleLoadingValuesTemplate", ""], ["cancelButton", ""], ["list", ""], ["tree", ""], ["selectAllCheckbox", ""], ["addToCurrentFilterCheckbox", ""], ["type", "box"], ["igxPrefix", "", "family", "default", "name", "search"], ["igxInput", "", "tabindex", "0", "autocomplete", "off", 3, "ngModelChange", "keydown", "ngModel", "placeholder"], ["role", "listbox", "tabindex", "0", 3, "isLoading"], [1, "igx-excel-filter__tree"], [1, "igx-excel-filter__menu-footer"], [1, "igx-excel-filter__cancel"], ["type", "button", "igxButton", "flat", 3, "click"], [1, "igx-excel-filter__apply"], ["type", "button", "igxButton", "contained", 3, "click", "disabled"], ["family", "default", "name", "input_clear", "tabindex", "0", 3, "click"], ["role", "listbox", "tabindex", "0", 3, "keydown", "focus", "focusout", "isLoading"], [2, "overflow", "hidden", "position", "relative"], ["role", "option", 3, "igx-list__item-base--active", 4, "igxFor", "igxForOf", "igxForScrollOrientation", "igxForContainerSize", "igxForItemSize"], ["igxDataLoading", ""], ["igxEmptyList", ""], ["aria-live", "polite", "aria-atomic", "true", 1, "igx-excel-filter__filter-results"], ["role", "option"], [3, "change", "value", "tabindex", "checked", "disableRipple", "indeterminate", "disableTransitions"], [1, "igx-excel-filter__loading"], [4, "ngTemplateOutlet"], [1, "igx-excel-filter__tree-alike"], ["selection", "Cascading", 3, "nodeSelection"], [3, "data", "selected"], [1, "igx-excel-filter__tree-alike-item"], [3, "change", "value", "checked", "disableRipple", "indeterminate", "disableTransitions"], [3, "value", "checked", "disableRipple", "disableTransitions"], [1, "igx-excel-filter__empty"], [3, "indeterminate"]],
        template: function IgxExcelStyleSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-input-group", 8);
            i0.ɵɵelement(1, "igx-icon", 9);
            i0.ɵɵelementStart(2, "input", 10, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function IgxExcelStyleSearchComponent_Template_input_ngModelChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.searchValue, $event) || (ctx.searchValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function IgxExcelStyleSearchComponent_Template_input_ngModelChange_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterListData());
            })("keydown", function IgxExcelStyleSearchComponent_Template_input_keydown_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputKeyDown($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, IgxExcelStyleSearchComponent_Conditional_4_Template, 2, 0, "igx-suffix");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, IgxExcelStyleSearchComponent_Conditional_5_Template, 8, 7, "igx-list", 11)(6, IgxExcelStyleSearchComponent_Conditional_6_Template, 8, 2, "div", 12)(7, IgxExcelStyleSearchComponent_ng_template_7_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(9, IgxExcelStyleSearchComponent_ng_template_9_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(11, "footer", 13)(12, "div", 14)(13, "button", 15, 3);
            i0.ɵɵlistener("click", function IgxExcelStyleSearchComponent_Template_button_click_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.esf.cancel());
            });
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 16)(17, "button", 17);
            i0.ɵɵlistener("click", function IgxExcelStyleSearchComponent_Template_button_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.applyFilter());
            });
            i0.ɵɵtext(18);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.searchValue);
            i0.ɵɵproperty("placeholder", ctx.esf.column == null ? null : ctx.esf.column.grid.resourceStrings.igx_grid_excel_search_placeholder);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.searchValue || ctx.searchValue === 0 ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isHierarchical() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isHierarchical() ? 6 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵtextInterpolate1(" ", ctx.esf.grid == null ? null : ctx.esf.grid.resourceStrings.igx_grid_excel_cancel, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.applyButtonDisabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.esf.grid == null ? null : ctx.esf.grid.resourceStrings.igx_grid_excel_apply, " ");
          }
        },
        dependencies: [IgxInputGroupComponent, IgxIconComponent, IgxPrefixDirective, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IgxInputDirective, IgxSuffixDirective, IgxListComponent, IgxForOfDirective, IgxListItemComponent, IgxCheckboxComponent, IgxDataLoadingTemplateDirective, NgTemplateOutlet, IgxEmptyListTemplateDirective, IgxTreeComponent, IgxTreeNodeComponent, IgxCircularProgressBarComponent, IgxButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style conditional filter UI.
 */
let IgxExcelStyleSelectingComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleSelectingComponent {
    constructor(esf) {
      this.esf = esf;
    }
    static {
      this.ɵfac = function IgxExcelStyleSelectingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleSelectingComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleSelectingComponent,
        selectors: [["igx-excel-style-selecting"]],
        decls: 1,
        vars: 1,
        consts: [["tabindex", "0", "role", "button", 3, "ngClass"], ["tabindex", "0", "role", "button", 3, "click", "ngClass"], ["family", "default", "name", "selected"]],
        template: function IgxExcelStyleSelectingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleSelectingComponent_Conditional_0_Template, 4, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [NgClass, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleSelectingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A component used for presenting Excel style column sorting UI.
 */
let IgxExcelStyleSortingComponent = /*#__PURE__*/(() => {
  class IgxExcelStyleSortingComponent {
    constructor(esf, cdr) {
      this.esf = esf;
      this.cdr = cdr;
      /**
       * @hidden @internal
       */
      this.defaultClass = true;
      this.destroy$ = new Subject();
      this.esf.sortingChanged.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateSelectedButtons(this.esf.column.field);
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden @internal
     */
    onSortButtonClicked(sortDirection) {
      if (this.sortButtonGroup.buttons.filter(b => b.selected).length === 0) {
        if (this.esf.grid.isColumnGrouped(this.esf.column.field)) {
          this.sortButtonGroup.selectButton(sortDirection - 1);
        } else {
          this.esf.grid.clearSort(this.esf.column.field);
        }
      } else {
        this.esf.grid.sort({
          fieldName: this.esf.column.field,
          dir: sortDirection,
          ignoreCase: true
        });
      }
    }
    get esfSize() {
      const esf = this.esf;
      return esf.size;
    }
    updateSelectedButtons(fieldName) {
      const sortIndex = this.esf.grid.sortingExpressions.findIndex(s => s.fieldName === fieldName);
      this.cdr.detectChanges();
      this.sortButtonGroup.buttons.forEach((b, i) => {
        this.sortButtonGroup.deselectButton(i);
      });
      if (sortIndex !== -1) {
        const sortDirection = this.esf.grid.sortingExpressions[sortIndex].dir;
        this.sortButtonGroup.selectButton(sortDirection - 1);
      }
    }
    static {
      this.ɵfac = function IgxExcelStyleSortingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleSortingComponent)(i0.ɵɵdirectiveInject(BaseFilteringComponent), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxExcelStyleSortingComponent,
        selectors: [["igx-excel-style-sorting"]],
        viewQuery: function IgxExcelStyleSortingComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c145, 5, IgxButtonGroupComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortButtonGroup = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxExcelStyleSortingComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-excel-filter__sort", ctx.defaultClass);
          }
        },
        decls: 1,
        vars: 1,
        consts: [["sortButtonGroup", ""], ["type", "button", "igxButton", "", 3, "buttonSelected"], ["family", "default", "name", "sort_asc"], ["family", "default", "name", "sort_desc"]],
        template: function IgxExcelStyleSortingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxExcelStyleSortingComponent_Conditional_0_Template, 12, 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.esf.column ? 0 : -1);
          }
        },
        dependencies: [IgxButtonGroupComponent, IgxButtonDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxExcelStyleSortingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxExcelStyleColumnOperationsTemplateDirective = /*#__PURE__*/(() => {
  class IgxExcelStyleColumnOperationsTemplateDirective {
    static {
      this.ɵfac = function IgxExcelStyleColumnOperationsTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleColumnOperationsTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExcelStyleColumnOperationsTemplateDirective,
        selectors: [["igx-excel-style-column-operations"], ["", "igxExcelStyleColumnOperations", ""]]
      });
    }
  }
  return IgxExcelStyleColumnOperationsTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxExcelStyleFilterOperationsTemplateDirective = /*#__PURE__*/(() => {
  class IgxExcelStyleFilterOperationsTemplateDirective {
    static {
      this.ɵfac = function IgxExcelStyleFilterOperationsTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleFilterOperationsTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExcelStyleFilterOperationsTemplateDirective,
        selectors: [["igx-excel-style-filter-operations"], ["", "igxExcelStyleFilterOperations", ""]]
      });
    }
  }
  return IgxExcelStyleFilterOperationsTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * A component used for presenting Excel style filtering UI for a specific column.
 * It is used internally in the Grid, but could also be hosted in a container outside of it.
 *
 * Example:
 * ```html
 * <igx-grid-excel-style-filtering
 *     [column]="grid1.columns[0]">
 * </igx-grid-excel-style-filtering>
 * ```
 */
let IgxGridExcelStyleFilteringComponent = /*#__PURE__*/(() => {
  class IgxGridExcelStyleFilteringComponent extends BaseFilteringComponent {
    get shouldApplySizes() {
      return !(this._minHeight || this._maxHeight);
    }
    /**
     * Sets the column.
     */
    set column(value) {
      this._column = value;
      this.listData = new Array();
      this.columnChange.emit(this._column);
      this.subscriptions?.unsubscribe();
      if (this._column) {
        this.grid.filteringService.registerSVGIcons();
        this.init();
        this.sortingChanged.emit();
        this.subscriptions = this.grid.columnPin.subscribe(() => {
          requestAnimationFrame(() => {
            if (!this.cdr.destroyed) {
              this.cdr.detectChanges();
            }
          });
        });
        this.subscriptions.add(this.grid.columnVisibilityChanged.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.grid.sortingExpressionsChange.subscribe(() => this.sortingChanged.emit()));
        this.subscriptions.add(this.grid.filteringExpressionsTreeChange.subscribe(() => this.init()));
        this.subscriptions.add(this.grid.columnMovingEnd.subscribe(() => this.cdr.markForCheck()));
      }
    }
    /**
     * Returns the current column.
     */
    get column() {
      return this._column;
    }
    /**
     * Gets the minimum height.
     *
     * Setting value in template:
     * ```ts
     * [minHeight]="'<number><unit (px|rem|etc..)>'"
     * ```
     *
     * Example for setting a value:
     * ```ts
     * [minHeight]="'700px'"
     * ```
     */
    get minHeight() {
      if (this._minHeight || this._minHeight === 0) {
        return this._minHeight;
      }
    }
    /**
     * Sets the minimum height.
     */
    set minHeight(value) {
      this._minHeight = value;
    }
    /**
     * Gets the maximum height.
     *
     * Setting value in template:
     * ```ts
     * [maxHeight]="'<number><unit (px|rem|etc..)>'"
     * ```
     *
     * Example for setting a value:
     * ```ts
     * [maxHeight]="'700px'"
     * ```
     */
    get maxHeight() {
      if (this._maxHeight) {
        return this._maxHeight;
      }
    }
    /**
     * Sets the maximum height.
     */
    set maxHeight(value) {
      this._maxHeight = value;
    }
    /**
     * @hidden @internal
     */
    get grid() {
      return this.column?.grid ?? this.gridAPI;
    }
    constructor(cdr, element, platform, document, gridAPI) {
      super(cdr, element, platform);
      this.document = document;
      this.gridAPI = gridAPI;
      /**
       * @hidden @internal
       */
      this.defaultClass = true;
      /**
       * @hidden @internal
       */
      this.inline = true;
      /**
       * @hidden @internal
       */
      this.loadingStart = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.loadingEnd = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.initialized = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.sortingChanged = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnChange = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.listDataLoaded = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.expressionsList = new Array();
      /**
       * @hidden @internal
       */
      this.listData = new Array();
      /**
       * @hidden @internal
       */
      this.uniqueValues = [];
      /**
       * @hidden @internal
       */
      this.isHierarchical = false;
      this.containsNullOrEmpty = false;
      this.selectAllSelected = true;
      this.selectAllIndeterminate = false;
      this.filterValues = new Set();
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.subscriptions?.unsubscribe();
      delete this.overlayComponentId;
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      this.computedStyles = this.document.defaultView.getComputedStyle(this.element.nativeElement);
    }
    /**
     * @hidden @internal
     */
    initialize(column, overlayService) {
      this.inline = false;
      this.column = column;
      this.overlayService = overlayService;
      if (this._originalDisplay) {
        this.element.nativeElement.style.display = this._originalDisplay;
      }
      this.initialized.emit();
      this.subscriptions.add(this.grid.columnMoving.subscribe(() => this.closeDropdown()));
    }
    /**
     * @hidden @internal
     */
    onPin() {
      this.closeDropdown();
      this.column.pinned = !this.column.pinned;
    }
    /**
     * @hidden @internal
     */
    onSelect() {
      if (!this.column.selected) {
        this.grid.selectionService.selectColumn(this.column.field, this.grid.columnSelection === GridSelectionMode.single);
      } else {
        this.grid.selectionService.deselectColumn(this.column.field);
      }
      this.grid.notifyChanges();
    }
    /**
     * @hidden @internal
     */
    columnSelectable() {
      return this.grid?.columnSelection !== GridSelectionMode.none && this.column?.selectable;
    }
    /**
     * @hidden @internal
     */
    onHideToggle() {
      this.column.toggleVisibility();
      this.closeDropdown();
    }
    /**
     * @hidden @internal
     */
    cancel() {
      if (!this.overlayComponentId) {
        this.init();
      }
      this.closeDropdown();
    }
    /**
     * @hidden @internal
     */
    closeDropdown() {
      if (this.overlayComponentId) {
        this.overlayService.hide(this.overlayComponentId);
        this.overlayComponentId = null;
      }
    }
    /**
     * @hidden @internal
     */
    onKeyDown(eventArgs) {
      if (this.platform.isFilteringKeyCombo(eventArgs)) {
        eventArgs.preventDefault();
        this.closeDropdown();
      }
      eventArgs.stopPropagation();
    }
    /**
     * @hidden @internal
     */
    hide() {
      this._originalDisplay = this.computedStyles.display;
      this.element.nativeElement.style.display = 'none';
    }
    /**
     * @hidden @internal
     */
    detectChanges() {
      this.cdr.detectChanges();
    }
    get size() {
      return this.computedStyles?.getPropertyValue('--component-size');
    }
    init() {
      this.expressionsList = new Array();
      generateExpressionsList(this.column.filteringExpressionsTree, this.grid.filteringLogic, this.expressionsList);
      this.populateColumnData();
    }
    areExpressionsSelectable() {
      if (this.expressionsList.length === 1 && (this.expressionsList[0].expression.condition.name === 'equals' || this.expressionsList[0].expression.condition.name === 'at' || this.expressionsList[0].expression.condition.name === 'true' || this.expressionsList[0].expression.condition.name === 'false' || this.expressionsList[0].expression.condition.name === 'empty' || this.expressionsList[0].expression.condition.name === 'in')) {
        return true;
      }
      const selectableExpressionsCount = this.expressionsList.filter(exp => (exp.beforeOperator === 1 || exp.afterOperator === 1) && (exp.expression.condition.name === 'equals' || exp.expression.condition.name === 'at' || exp.expression.condition.name === 'true' || exp.expression.condition.name === 'false' || exp.expression.condition.name === 'empty' || exp.expression.condition.name === 'in')).length;
      return selectableExpressionsCount === this.expressionsList.length;
    }
    populateColumnData() {
      this.cdr.detectChanges();
      if (this.grid.uniqueColumnValuesStrategy) {
        this.renderColumnValuesRemotely();
      } else {
        this.renderColumnValuesFromData();
      }
    }
    renderColumnValuesRemotely() {
      this.loadingStart.emit();
      const expressionsTree = this.getColumnFilterExpressionsTree();
      const prevColumn = this.column;
      this.grid.uniqueColumnValuesStrategy(this.column, expressionsTree, values => {
        if (!this.column || this.column !== prevColumn) {
          return;
        }
        const items = values.map(v => ({
          value: v
        }));
        this.uniqueValues = this.column.sortStrategy.sort(items, 'value', SortingDirection.Asc, this.column.sortingIgnoreCase, (obj, key) => {
          let resolvedValue = obj[key];
          if (this.column.dataType === GridColumnDataType.Time) {
            resolvedValue = new Date().setHours(resolvedValue.getHours(), resolvedValue.getMinutes(), resolvedValue.getSeconds(), resolvedValue.getMilliseconds());
          }
          return resolvedValue;
        });
        this.renderValues();
        this.loadingEnd.emit();
      });
    }
    renderColumnValuesFromData() {
      this.loadingStart.emit();
      const expressionsTree = this.getColumnFilterExpressionsTree();
      const promise = this.grid.filterStrategy.getFilterItems(this.column, expressionsTree);
      promise.then(items => {
        this.isHierarchical = items.length > 0 && items.some(i => i.children && i.children.length > 0);
        this.uniqueValues = items;
        this.renderValues();
        this.loadingEnd.emit();
        this.sortingChanged.emit();
      });
    }
    renderValues() {
      this.filterValues = this.generateFilterValues();
      this.generateListData();
      this.expressionsList.forEach(expr => {
        if (this.column.dataType === GridColumnDataType.String && this.column.filteringIgnoreCase && expr.expression.searchVal && expr.expression.searchVal instanceof Set) {
          this.modifyExpression(expr);
        }
      });
    }
    generateFilterValues() {
      const formatValue = value => {
        if (!value) return value;
        switch (this.column.dataType) {
          case GridColumnDataType.Date:
            return new Date(value).toDateString();
          case GridColumnDataType.DateTime:
            return new Date(value).toISOString();
          case GridColumnDataType.Time:
            return typeof value === 'string' ? value : new Date(value).toLocaleTimeString();
          default:
            return value;
        }
      };
      const processExpression = (arr, e) => {
        if (e.expression.condition.name === 'in') {
          return [...arr, ...Array.from(e.expression.searchVal.values()).map(v => formatValue(v))];
        }
        return [...arr, formatValue(e.expression.searchVal)];
      };
      const filterValues = new Set(this.expressionsList.reduce(processExpression, []));
      return filterValues;
    }
    modifyExpression(expr) {
      const lowerCaseFilterValues = new Set(Array.from(expr.expression.searchVal).map(value => value.toLowerCase()));
      this.grid.data.forEach(item => {
        if (typeof item[this.column.field] === "string" && lowerCaseFilterValues.has(item[this.column.field]?.toLowerCase())) {
          expr.expression.searchVal.add(item[this.column.field]);
        }
      });
    }
    generateListData() {
      this.listData = new Array();
      const shouldUpdateSelection = this.areExpressionsSelectable();
      if (this.column.dataType === GridColumnDataType.Boolean) {
        this.addBooleanItems();
      } else {
        this.addItems(shouldUpdateSelection);
      }
      if (!this.isHierarchical && this.containsNullOrEmpty) {
        const blanksItem = this.generateBlanksItem(shouldUpdateSelection);
        this.listData.unshift(blanksItem);
      }
      if (this.listData.length > 0) {
        this.addSelectAllItem();
      }
      if (!this.cdr.destroyed) {
        this.cdr.detectChanges();
      }
      this.listDataLoaded.emit();
    }
    getColumnFilterExpressionsTree() {
      const gridExpressionsTree = this.grid.filteringExpressionsTree;
      const expressionsTree = new FilteringExpressionsTree(gridExpressionsTree.operator, gridExpressionsTree.fieldName);
      for (const operand of gridExpressionsTree.filteringOperands) {
        if (isTree(operand)) {
          const columnExprTree = operand;
          if (columnExprTree.fieldName === this.column.field) {
            continue;
          }
        }
        expressionsTree.filteringOperands.push(operand);
      }
      return expressionsTree;
    }
    addBooleanItems() {
      this.selectAllSelected = true;
      this.selectAllIndeterminate = false;
      this.uniqueValues.forEach(element => {
        const value = element.value;
        const filterListItem = new FilterListItem();
        if (value !== undefined && value !== null && value !== '') {
          if (this.column.filteringExpressionsTree) {
            if (value === true && this.expressionsList.find(exp => exp.expression.condition.name === 'true')) {
              filterListItem.isSelected = true;
              filterListItem.isFiltered = true;
              this.selectAllIndeterminate = true;
            } else if (value === false && this.expressionsList.find(exp => exp.expression.condition.name === 'false')) {
              filterListItem.isSelected = true;
              filterListItem.isFiltered = true;
              this.selectAllIndeterminate = true;
            } else {
              filterListItem.isSelected = false;
              filterListItem.isFiltered = false;
            }
          } else {
            filterListItem.isSelected = true;
            filterListItem.isFiltered = true;
          }
          filterListItem.value = value;
          filterListItem.label = value ? this.grid.resourceStrings.igx_grid_filter_true : this.grid.resourceStrings.igx_grid_filter_false;
          filterListItem.indeterminate = false;
          this.listData.push(filterListItem);
        } else {
          this.containsNullOrEmpty = true;
        }
      });
    }
    addItems(shouldUpdateSelection) {
      this.selectAllSelected = true;
      this.selectAllIndeterminate = false;
      this.containsNullOrEmpty = false;
      this.listData = this.generateFilterListItems(this.uniqueValues, shouldUpdateSelection);
      this.containsNullOrEmpty = this.uniqueValues.length > this.listData.length;
    }
    generateFilterListItems(values, shouldUpdateSelection, parent) {
      const filterListItems = [];
      values?.forEach(element => {
        const value = element.value;
        const hasValue = value !== undefined && value !== null && value !== '';
        if (hasValue) {
          const filterListItem = new FilterListItem();
          filterListItem.parent = parent;
          filterListItem.value = value;
          filterListItem.label = element.label !== undefined ? element.label : this.getFilterItemLabel(value);
          filterListItem.indeterminate = false;
          filterListItem.isSelected = true;
          filterListItem.isFiltered = true;
          if (this.column.filteringExpressionsTree) {
            filterListItem.isSelected = false;
            filterListItem.isFiltered = false;
            if (shouldUpdateSelection) {
              const exprValue = this.getExpressionValue(value);
              if (this.filterValues.has(exprValue)) {
                filterListItem.isSelected = true;
                filterListItem.isFiltered = true;
              }
              this.selectAllIndeterminate = true;
            } else {
              this.selectAllSelected = false;
            }
          }
          filterListItem.children = this.generateFilterListItems(element.children ?? element.value?.children, shouldUpdateSelection, filterListItem);
          filterListItems.push(filterListItem);
        }
      });
      return filterListItems;
    }
    addSelectAllItem() {
      const selectAll = new FilterListItem();
      selectAll.isSelected = this.selectAllSelected;
      selectAll.value = this.grid.resourceStrings.igx_grid_excel_select_all;
      selectAll.label = this.grid.resourceStrings.igx_grid_excel_select_all;
      selectAll.indeterminate = this.selectAllIndeterminate;
      selectAll.isSpecial = true;
      selectAll.isFiltered = this.selectAllSelected;
      this.listData.unshift(selectAll);
    }
    generateBlanksItem(shouldUpdateSelection) {
      const blanks = new FilterListItem();
      if (this.column.filteringExpressionsTree) {
        if (shouldUpdateSelection) {
          if (this.filterValues.has(null)) {
            blanks.isSelected = true;
            blanks.isFiltered = true;
          } else {
            blanks.isSelected = false;
            blanks.isFiltered = false;
          }
        }
      } else {
        blanks.isSelected = true;
        blanks.isFiltered = true;
      }
      blanks.value = null;
      blanks.label = this.grid.resourceStrings.igx_grid_excel_blanks;
      blanks.indeterminate = false;
      blanks.isSpecial = true;
      blanks.isBlanks = true;
      return blanks;
    }
    getFilterItemLabel(value, applyFormatter = true, data) {
      if (this.column.formatter) {
        if (applyFormatter) {
          return this.column.formatter(value, data);
        }
        return value;
      }
      const {
        display,
        format,
        digitsInfo,
        currencyCode,
        timezone
      } = this.column.pipeArgs;
      const locale = this.grid.locale;
      switch (this.column.dataType) {
        case GridColumnDataType.Date:
        case GridColumnDataType.DateTime:
        case GridColumnDataType.Time:
          return formatDate(value, format, locale, timezone);
        case GridColumnDataType.Currency:
          return formatCurrency(value, currencyCode || getLocaleCurrencyCode(locale), display, digitsInfo, locale);
        case GridColumnDataType.Number:
          return formatNumber(value, locale, digitsInfo);
        case GridColumnDataType.Percent:
          return formatPercent(value, locale, digitsInfo);
        default:
          return value;
      }
    }
    getExpressionValue(value) {
      if (this.column.dataType === GridColumnDataType.Date) {
        value = value ? new Date(value).toDateString() : value;
      } else if (this.column.dataType === GridColumnDataType.DateTime) {
        value = value ? new Date(value).toISOString() : value;
      } else if (this.column.dataType === GridColumnDataType.Time) {
        value = value ? new Date(value).toLocaleTimeString() : value;
      }
      return value;
    }
    static {
      this.ɵfac = function IgxGridExcelStyleFilteringComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridExcelStyleFilteringComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IGX_GRID_BASE, 9));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridExcelStyleFilteringComponent,
        selectors: [["igx-grid-excel-style-filtering"]],
        contentQueries: function IgxGridExcelStyleFilteringComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxExcelStyleColumnOperationsTemplateDirective, 5, IgxExcelStyleColumnOperationsTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxExcelStyleFilterOperationsTemplateDirective, 5, IgxExcelStyleFilterOperationsTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelColumnOperationsDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelFilterOperationsDirective = _t.first);
          }
        },
        viewQuery: function IgxGridExcelStyleFilteringComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c146, 5, ElementRef);
            i0.ɵɵviewQuery(_c147, 7, TemplateRef);
            i0.ɵɵviewQuery(_c148, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mainDropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExcelColumnOperations = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExcelFilterOperations = _t.first);
          }
        },
        hostVars: 8,
        hostBindings: function IgxGridExcelStyleFilteringComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("max-height", ctx.maxHeight);
            i0.ɵɵclassProp("igx-excel-filter", ctx.defaultClass)("igx-excel-filter__sizing", ctx.shouldApplySizes)("igx-excel-filter--inline", ctx.inline);
          }
        },
        inputs: {
          column: "column",
          minHeight: "minHeight",
          maxHeight: "maxHeight"
        },
        outputs: {
          loadingStart: "loadingStart",
          loadingEnd: "loadingEnd",
          initialized: "initialized",
          sortingChanged: "sortingChanged",
          columnChange: "columnChange",
          listDataLoaded: "listDataLoaded"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: BaseFilteringComponent,
          useExisting: forwardRef(() => IgxGridExcelStyleFilteringComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c150,
        decls: 6,
        vars: 12,
        consts: [["mainDropdown", ""], ["role", "menu", 1, "igx-excel-filter__menu", 3, "keydown", "ngClass", "id"], [3, "showHiding", "showPinning", "showSelecting"]],
        template: function IgxGridExcelStyleFilteringComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c149);
            i0.ɵɵelementStart(0, "article", 1, 0);
            i0.ɵɵlistener("keydown", function IgxGridExcelStyleFilteringComponent_Template_article_keydown_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyDown($event));
            });
            i0.ɵɵtemplate(2, IgxGridExcelStyleFilteringComponent_Conditional_2_Template, 1, 0)(3, IgxGridExcelStyleFilteringComponent_Conditional_3_Template, 6, 8)(4, IgxGridExcelStyleFilteringComponent_Conditional_4_Template, 1, 0)(5, IgxGridExcelStyleFilteringComponent_Conditional_5_Template, 3, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("min-height", ctx.minHeight)("max-height", ctx.maxHeight);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(8, _c151, ctx.shouldApplySizes, ctx.size === "2", ctx.size === "1"))("id", ctx.overlayComponentId);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.excelColumnOperationsDirective ? 2 : 3);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.excelFilterOperationsDirective ? 4 : 5);
          }
        },
        dependencies: [IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStyleMovingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleSearchComponent, NgClass],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridExcelStyleFilteringComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxExcelStyleClearFiltersComponent } from './excel-style-clear-filters.component';
// import { IgxExcelStyleConditionalFilterComponent } from './excel-style-conditional-filter.component';
// import { IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxGridExcelStyleFilteringComponent } from './excel-style-filtering.component';
// import { IgxExcelStyleHeaderComponent } from './excel-style-header.component';
// import { IgxExcelStyleHidingComponent } from './excel-style-hiding.component';
// import { IgxExcelStyleMovingComponent } from './excel-style-moving.component';
// import { IgxExcelStylePinningComponent } from './excel-style-pinning.component';
// import { IgxExcelStyleLoadingValuesTemplateDirective, IgxExcelStyleSearchComponent } from './excel-style-search.component';
// import { IgxExcelStyleSelectingComponent } from './excel-style-selecting.component';
// import { IgxExcelStyleSortingComponent } from './excel-style-sorting.component';
/* NOTE: Grid excel-style filtering directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES = [
//     IgxGridExcelStyleFilteringComponent,
//     IgxExcelStyleHeaderComponent,
//     IgxExcelStyleSortingComponent,
//     IgxExcelStylePinningComponent,
//     IgxExcelStyleHidingComponent,
//     IgxExcelStyleSelectingComponent,
//     IgxExcelStyleClearFiltersComponent,
//     IgxExcelStyleConditionalFilterComponent,
//     IgxExcelStyleMovingComponent,
//     IgxExcelStyleSearchComponent,
//     IgxExcelStyleColumnOperationsTemplateDirective,
//     IgxExcelStyleFilterOperationsTemplateDirective,
//     IgxExcelStyleLoadingValuesTemplateDirective
// ] as const;
let IgxGridFooterComponent = /*#__PURE__*/(() => {
  class IgxGridFooterComponent {
    static {
      this.ɵfac = function IgxGridFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridFooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridFooterComponent,
        selectors: [["igx-grid-footer"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxGridFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxGridFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxColumnMovingDragDirective = /*#__PURE__*/(() => {
  class IgxColumnMovingDragDirective extends IgxDragDirective {
    get draggable() {
      return this.column && (this.column.grid.moving || this.column.groupable && !this.column.columnGroup);
    }
    get icon() {
      return this.cms.icon;
    }
    constructor(element, viewContainer, zone, renderer, cdr, cms, _platformUtil) {
      super(cdr, element, viewContainer, zone, renderer, _platformUtil);
      this.cms = cms;
      this._ghostClass = 'igx-grid__drag-ghost-image';
      this.ghostImgIconClass = 'igx-grid__drag-ghost-image-icon';
      this.ghostImgIconGroupClass = 'igx-grid__drag-ghost-image-icon-group';
      this.columnSelectedClass = 'igx-grid-th--selected';
      this.ghostClass = this._ghostClass;
    }
    ngOnDestroy() {
      this._unsubscribe();
      super.ngOnDestroy();
    }
    onEscape(event) {
      this.cms.cancelDrop = true;
      this.onPointerUp(event);
    }
    onPointerDown(event) {
      if (!this.draggable || event.target.getAttribute('draggable') === 'false') {
        return;
      }
      super.onPointerDown(event);
    }
    onPointerMove(event) {
      if (this._clicked && !this._dragStarted) {
        this._removeOnDestroy = false;
        this.cms.column = this.column;
        this.column.grid.cdr.detectChanges();
        const movingStartArgs = {
          source: this.column
        };
        this.column.grid.columnMovingStart.emit(movingStartArgs);
        this.subscription$ = fromEvent(this.column.grid.document.defaultView, 'keydown').pipe(takeUntil(this._destroy)).subscribe(ev => {
          if (ev.key === this.platformUtil.KEYMAP.ESCAPE) {
            this.onEscape(ev);
          }
        });
      }
      super.onPointerMove(event);
      if (this._dragStarted && this.ghostElement && !this.cms.column) {
        this.cms.column = this.column;
        this.column.grid.cdr.detectChanges();
      }
      if (this.cms.column) {
        const args = {
          source: this.column,
          cancel: false
        };
        this.column.grid.columnMoving.emit(args);
        if (args.cancel) {
          this.onEscape(event);
        }
      }
    }
    onPointerUp(event) {
      // Run it explicitly inside the zone because sometimes onPointerUp executes after the code below.
      this.zone.run(() => {
        super.onPointerUp(event);
        this.cms.column = null;
        this.column.grid.cdr.detectChanges();
      });
      this._unsubscribe();
    }
    createGhost(pageX, pageY) {
      super.createGhost(pageX, pageY);
      this.ghostElement.style.height = null;
      this.ghostElement.style.minWidth = null;
      this.ghostElement.style.flexBasis = null;
      this.ghostElement.style.position = null;
      this.ghostElement.classList.remove(this.columnSelectedClass);
      const icon = this.column?.grid.document.createElement('i');
      const text = this.column?.grid.document.createTextNode('block');
      icon.appendChild(text);
      icon.classList.add('material-icons');
      this.cms.icon = icon;
      if (!this.column.columnGroup) {
        icon.classList.add(this.ghostImgIconClass);
        this.ghostElement.insertBefore(icon, this.ghostElement.firstElementChild);
        this.ghostLeft = this._ghostStartX = pageX - this.ghostElement.getBoundingClientRect().width / 3 * 2;
        this.ghostTop = this._ghostStartY = pageY - this.ghostElement.getBoundingClientRect().height / 3 * 2;
      } else {
        this.ghostElement.insertBefore(icon, this.ghostElement.childNodes[0]);
        icon.classList.add(this.ghostImgIconGroupClass);
        this.ghostElement.children[0].style.paddingLeft = '0px';
        this.ghostLeft = this._ghostStartX = pageX - this.ghostElement.getBoundingClientRect().width / 3 * 2;
        this.ghostTop = this._ghostStartY = pageY - this.ghostElement.getBoundingClientRect().height / 3 * 2;
      }
    }
    _unsubscribe() {
      if (this.subscription$) {
        this.subscription$.unsubscribe();
        this.subscription$ = null;
      }
    }
    static {
      this.ɵfac = function IgxColumnMovingDragDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnMovingDragDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxColumnMovingService), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMovingDragDirective,
        selectors: [["", "igxColumnMovingDrag", ""]],
        inputs: {
          column: [0, "igxColumnMovingDrag", "column"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMovingDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * An internal component representing a base group-by drop area.
 *
 * @hidden @internal
 */
let IgxGroupByAreaDirective = /*#__PURE__*/(() => {
  class IgxGroupByAreaDirective {
    /**
     * The group-by expressions provided by the parent grid.
     */
    get expressions() {
      return this._expressions;
    }
    set expressions(value) {
      this._expressions = value;
      this.chipExpressions = this._expressions;
      this.expressionsChanged();
      this.expressionsChange.emit(this._expressions);
    }
    /**
     * The default message for the default drop area template.
     * Obviously, if another template is provided, this is ignored.
     */
    get dropAreaMessage() {
      return this._dropAreaMessage ?? this.grid.resourceStrings.igx_grid_groupByArea_message;
    }
    set dropAreaMessage(value) {
      this._dropAreaMessage = value;
    }
    /** The native DOM element. Used in sizing calculations. */
    get nativeElement() {
      return this.ref.nativeElement;
    }
    constructor(ref, platform) {
      this.ref = ref;
      this.platform = platform;
      this.defaultClass = true;
      this.expressionsChange = new EventEmitter();
      this._expressions = [];
    }
    get dropAreaVisible() {
      return this.grid.columnInDrag && this.grid.columnInDrag.groupable || !this.expressions.length;
    }
    handleKeyDown(id, event) {
      if (this.platform.isActivationKey(event)) {
        this.updateGroupSorting(id);
      }
    }
    handleClick(id) {
      if (!this.grid.getColumnByName(id).groupable) {
        return;
      }
      this.updateGroupSorting(id);
    }
    onDragDrop(event) {
      const drag = event.detail.owner;
      if (drag instanceof IgxColumnMovingDragDirective) {
        const column = drag.column;
        if (!this.grid.columns.find(c => c === column)) {
          return;
        }
        const isGrouped = this.expressions.findIndex(item => item.fieldName === column.field) !== -1;
        if (column.groupable && !isGrouped && !column.columnGroup && !!column.field) {
          const groupingExpression = {
            fieldName: column.field,
            dir: this.grid.sortingExpressions.find(expr => expr.fieldName === column.field)?.dir || SortingDirection.Asc,
            ignoreCase: column.sortingIgnoreCase,
            strategy: column.sortStrategy,
            groupingComparer: column.groupingComparer
          };
          this.groupBy(groupingExpression);
        }
      }
    }
    getReorderedExpressions(chipsArray) {
      const newExpressions = [];
      chipsArray.forEach(chip => {
        const expr = this.expressions.find(item => item.fieldName === chip.id);
        // disallow changing order if there are columns with groupable: false
        if (!this.grid.getColumnByName(expr.fieldName)?.groupable) {
          return;
        }
        newExpressions.push(expr);
      });
      return newExpressions;
    }
    updateGroupSorting(id) {
      const expr = this.expressions.find(e => e.fieldName === id);
      expr.dir = 3 - expr.dir;
      const expressionsChangeEvent = this.grid.groupingExpressionsChange || this.expressionsChange;
      expressionsChangeEvent.emit(this.expressions);
      this.grid.pipeTrigger++;
      this.grid.notifyChanges();
    }
    expressionsChanged() {}
    static {
      this.ɵfac = function IgxGroupByAreaDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGroupByAreaDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGroupByAreaDirective,
        viewQuery: function IgxGroupByAreaDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxChipComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chips = _t);
          }
        },
        hostVars: 2,
        hostBindings: function IgxGroupByAreaDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid-grouparea", ctx.defaultClass);
          }
        },
        inputs: {
          dropAreaTemplate: "dropAreaTemplate",
          grid: "grid",
          expressions: "expressions",
          dropAreaMessage: "dropAreaMessage"
        },
        outputs: {
          expressionsChange: "expressionsChange"
        }
      });
    }
  }
  return IgxGroupByAreaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * A pipe to circumvent the use of getters/methods just to get some additional
 * information from the grouping expression and pass it to the chip representing
 * that expression.
 *
 * @hidden @internal
 */
let IgxGroupByMetaPipe = /*#__PURE__*/(() => {
  class IgxGroupByMetaPipe {
    transform(key, grid, _pipeTrigger) {
      const column = grid.getColumnByName(key);
      return {
        groupable: !!column?.groupable,
        title: column?.header || key
      };
    }
    static {
      this.ɵfac = function IgxGroupByMetaPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGroupByMetaPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxGroupByMeta",
        type: IgxGroupByMetaPipe,
        pure: true
      });
    }
  }
  return IgxGroupByMetaPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGroupByRowTemplateDirective = /*#__PURE__*/(() => {
  class IgxGroupByRowTemplateDirective {
    static ngTemplateContextGuard(_dir, ctx) {
      return true;
    }
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxGroupByRowTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGroupByRowTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGroupByRowTemplateDirective,
        selectors: [["", "igxGroupByRow", ""]]
      });
    }
  }
  return IgxGroupByRowTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGridDetailTemplateDirective = /*#__PURE__*/(() => {
  class IgxGridDetailTemplateDirective {
    static ngTemplateContextGuard(_dir, ctx) {
      return true;
    }
    static {
      this.ɵfac = function IgxGridDetailTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridDetailTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridDetailTemplateDirective,
        selectors: [["", "igxGridDetail", ""]]
      });
    }
  }
  return IgxGridDetailTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxRowExpandedIndicatorDirective = /*#__PURE__*/(() => {
  class IgxRowExpandedIndicatorDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowExpandedIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowExpandedIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowExpandedIndicatorDirective,
        selectors: [["", "igxRowExpandedIndicator", ""]]
      });
    }
  }
  return IgxRowExpandedIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxRowCollapsedIndicatorDirective = /*#__PURE__*/(() => {
  class IgxRowCollapsedIndicatorDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowCollapsedIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowCollapsedIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowCollapsedIndicatorDirective,
        selectors: [["", "igxRowCollapsedIndicator", ""]]
      });
    }
  }
  return IgxRowCollapsedIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxHeaderExpandedIndicatorDirective = /*#__PURE__*/(() => {
  class IgxHeaderExpandedIndicatorDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxHeaderExpandedIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHeaderExpandedIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxHeaderExpandedIndicatorDirective,
        selectors: [["", "igxHeaderExpandedIndicator", ""]]
      });
    }
  }
  return IgxHeaderExpandedIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxHeaderCollapsedIndicatorDirective = /*#__PURE__*/(() => {
  class IgxHeaderCollapsedIndicatorDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxHeaderCollapsedIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHeaderCollapsedIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxHeaderCollapsedIndicatorDirective,
        selectors: [["", "igxHeaderCollapsedIndicator", ""]]
      });
    }
  }
  return IgxHeaderCollapsedIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxExcelStyleHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxExcelStyleHeaderIconDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxExcelStyleHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelStyleHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExcelStyleHeaderIconDirective,
        selectors: [["", "igxExcelStyleHeaderIcon", ""]]
      });
    }
  }
  return IgxExcelStyleHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxSortHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxSortHeaderIconDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxSortHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSortHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSortHeaderIconDirective,
        selectors: [["", "igxSortHeaderIcon", ""]]
      });
    }
  }
  return IgxSortHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxSortAscendingHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxSortAscendingHeaderIconDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxSortAscendingHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSortAscendingHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSortAscendingHeaderIconDirective,
        selectors: [["", "igxSortAscendingHeaderIcon", ""]]
      });
    }
  }
  return IgxSortAscendingHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxSortDescendingHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxSortDescendingHeaderIconDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxSortDescendingHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSortDescendingHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxSortDescendingHeaderIconDirective,
        selectors: [["", "igxSortDescendingHeaderIcon", ""]]
      });
    }
  }
  return IgxSortDescendingHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGroupAreaDropDirective = /*#__PURE__*/(() => {
  class IgxGroupAreaDropDirective extends IgxDropDirective {
    constructor(groupArea, elementRef, renderer, zone) {
      super(elementRef, renderer, zone);
      this.groupArea = groupArea;
      this.elementRef = elementRef;
      this.hovered = false;
    }
    onDragEnter(event) {
      const drag = event.detail.owner;
      const column = drag.column;
      if (!this.columnBelongsToGrid(column)) {
        return;
      }
      const isGrouped = this.groupArea.expressions ? this.groupArea.expressions.findIndex(item => item.fieldName === column.field) !== -1 : false;
      if (column.groupable && !isGrouped && !column.columnGroup && !!column.field) {
        drag.icon.innerText = 'group_work';
        this.hovered = true;
      } else {
        drag.icon.innerText = 'block';
        this.hovered = false;
      }
    }
    onDragLeave(event) {
      const drag = event.detail.owner;
      const column = drag.column;
      if (!this.columnBelongsToGrid(column)) {
        return;
      }
      event.detail.owner.icon.innerText = 'block';
      this.hovered = false;
    }
    closestParentByAttr(elem, attr) {
      return elem.hasAttribute(attr) ? elem : this.closestParentByAttr(elem.parentElement, attr);
    }
    columnBelongsToGrid(column) {
      const elem = this.elementRef.nativeElement;
      const closestGridID = this.closestParentByAttr(elem, 'igxGroupAreaDrop').getAttribute('gridId');
      if (!column) {
        return false;
      } else {
        const grid = column.grid;
        if (!grid || grid.id !== closestGridID) {
          return false;
        }
        return true;
      }
    }
    static {
      this.ɵfac = function IgxGroupAreaDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGroupAreaDropDirective)(i0.ɵɵdirectiveInject(IgxGroupByAreaDirective), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGroupAreaDropDirective,
        selectors: [["", "igxGroupAreaDrop", ""]],
        hostVars: 2,
        hostBindings: function IgxGroupAreaDropDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-drop-area--hover", ctx.hovered);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxGroupAreaDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SortingIndexPipe = /*#__PURE__*/(() => {
  class SortingIndexPipe {
    transform(columnField, sortingExpressions) {
      let sortIndex = sortingExpressions.findIndex(expression => expression.fieldName === columnField);
      return sortIndex !== -1 ? ++sortIndex : null;
    }
    static {
      this.ɵfac = function SortingIndexPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SortingIndexPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "sortingIndex",
        type: SortingIndexPipe,
        pure: true
      });
    }
  }
  return SortingIndexPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxHeaderGroupWidthPipe = /*#__PURE__*/(() => {
  class IgxHeaderGroupWidthPipe {
    transform(width, minWidth, hasLayout) {
      const isFitContent = width === 'fit-content';
      return hasLayout ? '' : isFitContent ? width : `${Math.max(parseFloat(width), minWidth)}px`;
    }
    static {
      this.ɵfac = function IgxHeaderGroupWidthPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHeaderGroupWidthPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxHeaderGroupWidth",
        type: IgxHeaderGroupWidthPipe,
        pure: true
      });
    }
  }
  return IgxHeaderGroupWidthPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxHeaderGroupStylePipe = /*#__PURE__*/(() => {
  class IgxHeaderGroupStylePipe {
    transform(styles, column, _) {
      const css = {};
      if (!styles) {
        return css;
      }
      for (const prop of Object.keys(styles)) {
        const res = styles[prop];
        css[prop] = typeof res === 'function' ? res(column) : res;
      }
      return css;
    }
    static {
      this.ɵfac = function IgxHeaderGroupStylePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHeaderGroupStylePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxHeaderGroupStyle",
        type: IgxHeaderGroupStylePipe,
        pure: true
      });
    }
  }
  return IgxHeaderGroupStylePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxColumnResizingService = /*#__PURE__*/(() => {
  class IgxColumnResizingService {
    constructor(zone) {
      this.zone = zone;
      /**
       * @hidden
       */
      this.resizeCursor = 'col-resize';
      /**
       * @hidden
       */
      this.showResizer = false;
    }
    /**
     * @hidden
     */
    getColumnHeaderRenderedWidth() {
      return parseFloat(window.getComputedStyle(this.column.headerCell.nativeElement).width);
    }
    /**
     * @hidden
     */
    get resizerHeight() {
      let height = this.column.grid.getVisibleContentHeight();
      // Column height multiplier in case there are Column Layouts. The resizer height need to take into account rowStart.
      let columnHeightMultiplier = 1;
      if (this.column.columnLayoutChild) {
        columnHeightMultiplier = this.column.grid.multiRowLayoutRowSize - this.column.rowStart + 1;
      }
      if (this.column.level !== 0) {
        height -= this.column.topLevelParent.headerGroup.height - this.column.headerGroup.height * columnHeightMultiplier;
      }
      return height;
    }
    /**
     * Returns the minimal possible width to which the column can be resized.
     */
    get restrictResizeMin() {
      const actualWidth = this.getColumnHeaderRenderedWidth();
      const minWidth = this.column.minWidthPx < actualWidth ? this.column.minWidthPx : actualWidth;
      return actualWidth - minWidth;
    }
    /**
     * Returns the maximal possible width to which the column can be resized.
     */
    get restrictResizeMax() {
      const actualWidth = this.getColumnHeaderRenderedWidth();
      const maxWidth = this.column.maxWidthPx;
      if (this.column.maxWidth) {
        return maxWidth - actualWidth;
      } else {
        return Number.MAX_SAFE_INTEGER;
      }
    }
    /**
     * Autosizes the column to the longest currently visible cell value, including the header cell.
     * If the column has a predifined maxWidth and the autosized column width will become bigger than it,
     * then the column is sized to its maxWidth.
     */
    autosizeColumnOnDblClick() {
      const currentColWidth = this.getColumnHeaderRenderedWidth();
      this.column.width = this.column.getAutoSize();
      this.zone.run(() => {});
      this.column.grid.columnResized.emit({
        column: this.column,
        prevWidth: currentColWidth.toString(),
        newWidth: this.column.width
      });
    }
    /**
     * Resizes the column regaridng to the column minWidth and maxWidth.
     */
    resizeColumn(event, ratio = 1) {
      this.showResizer = false;
      const diff = (event.clientX - this.startResizePos) / ratio;
      const colWidth = this.column.width;
      const isPercentageWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1;
      let currentColWidth = parseFloat(colWidth);
      const actualWidth = this.getColumnHeaderRenderedWidth();
      currentColWidth = Number.isNaN(currentColWidth) ? parseFloat(actualWidth) : currentColWidth;
      if (this.column.grid.hasColumnLayouts) {
        this.resizeColumnLayoutFor(this.column, diff);
      } else if (isPercentageWidth) {
        this._handlePercentageResize(diff, this.column);
      } else {
        this._handlePixelResize(diff, this.column);
      }
      this.zone.run(() => {});
      if (currentColWidth !== parseFloat(this.column.width)) {
        this.column.grid.columnResized.emit({
          column: this.column,
          prevWidth: isPercentageWidth ? currentColWidth + '%' : currentColWidth + 'px',
          newWidth: this.column.width
        });
      }
      this.isColumnResizing = false;
    }
    _handlePixelResize(diff, column) {
      const currentColWidth = parseFloat(column.width);
      const colMinWidth = column.minWidthPx;
      const colMaxWidth = column.maxWidthPx;
      if (currentColWidth + diff < colMinWidth) {
        column.width = colMinWidth + 'px';
      } else if (colMaxWidth && currentColWidth + diff > colMaxWidth) {
        column.width = colMaxWidth + 'px';
      } else {
        column.width = currentColWidth + diff + 'px';
      }
    }
    _handlePercentageResize(diff, column) {
      const currentPercentWidth = parseFloat(column.width);
      const gridAvailableSize = column.grid.calcWidth;
      const diffPercentage = diff / gridAvailableSize * 100;
      const colMinWidth = column.minWidthPercent;
      const colMaxWidth = column.maxWidthPercent;
      if (currentPercentWidth + diffPercentage < colMinWidth) {
        column.width = colMinWidth + '%';
      } else if (colMaxWidth && currentPercentWidth + diffPercentage > colMaxWidth) {
        column.width = colMaxWidth + '%';
      } else {
        column.width = currentPercentWidth + diffPercentage + '%';
      }
    }
    getColMinWidth(column) {
      let currentColWidth = parseFloat(column.width);
      const actualWidth = column.headerCell.nativeElement.getBoundingClientRect().width;
      currentColWidth = Number.isNaN(currentColWidth) || currentColWidth < actualWidth ? actualWidth : currentColWidth;
      const actualMinWidth = parseFloat(column.minWidth);
      return actualMinWidth < currentColWidth ? actualMinWidth : currentColWidth;
    }
    resizeColumnLayoutFor(column, diff) {
      const relativeColumns = column.getResizableColUnderEnd();
      const combinedSpan = relativeColumns.reduce((acc, col) => acc + col.spanUsed, 0);
      // Resize first those who might reach min/max width
      let columnsToResize = [...relativeColumns];
      let updatedDiff = diff;
      let updatedCombinedSpan = combinedSpan;
      let setMinMaxCols = false;
      do {
        // Cycle them until there are not ones that reach min/max size, because the diff accumulates after each cycle.
        // This is because we can have at first 2 cols reaching min width and then after
        // recalculating the diff there might be 1 more that reaches min width.
        setMinMaxCols = false;
        let newCombinedSpan = updatedCombinedSpan;
        const newColsToResize = [];
        columnsToResize.forEach(col => {
          const currentResizeWidth = parseFloat(col.target.calcWidth);
          const resizeScaled = diff / updatedCombinedSpan * col.target.gridColumnSpan;
          const colWidth = col.target.width;
          const isPercentageWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1;
          const minWidth = col.target.minWidthPx;
          const maxWidth = col.target.maxWidthPx;
          if (currentResizeWidth + resizeScaled < minWidth) {
            col.target.width = isPercentageWidth ? col.target.minWidthPercent + '%' : minWidth + 'px';
            updatedDiff += currentResizeWidth - minWidth;
            newCombinedSpan -= col.spanUsed;
            setMinMaxCols = true;
          } else if (maxWidth && currentResizeWidth + resizeScaled > maxWidth) {
            col.target.width = isPercentageWidth ? col.target.maxWidthPercent + '%' : col.target.maxWidthPx + 'px';
            updatedDiff -= maxWidth - currentResizeWidth;
            newCombinedSpan -= col.spanUsed;
            setMinMaxCols = true;
          } else {
            // Save new ones that can be resized
            newColsToResize.push(col);
          }
        });
        updatedCombinedSpan = newCombinedSpan;
        columnsToResize = newColsToResize;
      } while (setMinMaxCols);
      // Those left that don't reach min/max size resize them normally.
      columnsToResize.forEach(col => {
        const resizeScaled = updatedDiff / updatedCombinedSpan * col.target.gridColumnSpan;
        const colWidth = col.target.width;
        const isPercentageWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1;
        if (isPercentageWidth) {
          this._handlePercentageResize(resizeScaled, col.target);
        } else {
          this._handlePixelResize(resizeScaled, col.target);
        }
      });
    }
    static {
      this.ɵfac = function IgxColumnResizingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnResizingService)(i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxColumnResizingService,
        factory: IgxColumnResizingService.ɵfac
      });
    }
  }
  return IgxColumnResizingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGridHeaderComponent = /*#__PURE__*/(() => {
  class IgxGridHeaderComponent {
    /**
     * Returns the `aria-selected` of the header.
     */
    get ariaSelected() {
      return this.column.selected;
    }
    get columnGroupStyle() {
      return !this.column.columnGroup;
    }
    get sortAscendingStyle() {
      return this.sortDirection === SortingDirection.Asc;
    }
    get sortDescendingStyle() {
      return this.sortDirection === SortingDirection.Desc;
    }
    get numberStyle() {
      return this.column.dataType === GridColumnDataType.Number;
    }
    get sortableStyle() {
      return this.column.sortable;
    }
    get selectableStyle() {
      return this.selectable;
    }
    get filterableStyle() {
      return this.column.filterable && this.grid.filteringService.isFilterRowVisible;
    }
    get sortedStyle() {
      return this.sorted;
    }
    get selectedStyle() {
      return this.selected;
    }
    /**
     * @hidden
     */
    get esfIconTemplate() {
      return this.grid.excelStyleHeaderIconTemplate || this.defaultESFHeaderIconTemplate;
    }
    /**
     * @hidden
     */
    get sortIconTemplate() {
      if (this.sortDirection === SortingDirection.None && this.grid.sortHeaderIconTemplate) {
        return this.grid.sortHeaderIconTemplate;
      } else if (this.sortDirection === SortingDirection.Asc && this.grid.sortAscendingHeaderIconTemplate) {
        return this.grid.sortAscendingHeaderIconTemplate;
      } else if (this.sortDirection === SortingDirection.Desc && this.grid.sortDescendingHeaderIconTemplate) {
        return this.grid.sortDescendingHeaderIconTemplate;
      } else {
        return this.defaultSortHeaderIconTemplate;
      }
    }
    /**
     * @hidden
     */
    get disabled() {
      const groupArea = this.grid.groupArea || this.grid.treeGroupArea;
      if (groupArea?.expressions && groupArea.expressions.length && groupArea.expressions.map(g => g.fieldName).includes(this.column.field)) {
        return true;
      }
      return false;
    }
    get sorted() {
      return this.sortDirection !== SortingDirection.None;
    }
    get filterIconClassName() {
      return this.column.filteringExpressionsTree || this.isAdvancedFilterApplied() ? 'igx-excel-filter__icon--filtered' : 'igx-excel-filter__icon';
    }
    get selectable() {
      return this.grid.columnSelection !== GridSelectionMode.none && this.column.applySelectableClass && !this.column.selected && !this.grid.filteringService.isFilterRowVisible;
    }
    get selected() {
      return this.column.selected && (!this.grid.filteringService.isFilterRowVisible || this.grid.filteringService.filteredColumn !== this.column);
    }
    get title() {
      return this.column.title || this.column.header || this.column.field;
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    constructor(grid, colResizingService, cdr, ref) {
      this.grid = grid;
      this.colResizingService = colResizingService;
      this.cdr = cdr;
      this.ref = ref;
      this.sortDirection = SortingDirection.None;
      this._destroy$ = new Subject();
    }
    onClick(event) {
      if (!this.colResizingService.isColumnResizing) {
        if (this.grid.filteringService.isFilterRowVisible) {
          if (this.column.filterCellTemplate) {
            this.grid.filteringRow.close();
            return;
          }
          if (this.column.filterable && !this.column.columnGroup && !this.grid.filteringService.isFilterComplex(this.column.field)) {
            this.grid.filteringService.filteredColumn = this.column;
          }
        } else if (this.grid.columnSelection !== GridSelectionMode.none && this.column.selectable) {
          const clearSelection = this.grid.columnSelection === GridSelectionMode.single || !event.ctrlKey;
          const rangeSelection = this.grid.columnSelection === GridSelectionMode.multiple && event.shiftKey;
          if (!this.column.selected || this.grid.selectionService.getSelectedColumns().length > 1 && clearSelection) {
            this.grid.selectionService.selectColumn(this.column.field, clearSelection, rangeSelection, event);
          } else {
            this.grid.selectionService.deselectColumn(this.column.field, event);
          }
        }
      }
      this.grid.theadRow.nativeElement.focus();
    }
    /**
     * @hidden
     */
    onPinterEnter() {
      this.column.applySelectableClass = true;
    }
    /**
     * @hidden
     */
    onPointerLeave() {
      this.column.applySelectableClass = false;
    }
    /**
     * @hidden @internal
     */
    ngDoCheck() {
      this.getSortDirection();
      this.cdr.markForCheck();
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this._destroy$.next(true);
      this._destroy$.complete();
    }
    /**
     * @hidden @internal
     */
    onPointerDownIndicator(event) {
      // Stop propagation of pointer events to now allow column dragging using the header indicators.
      event.stopPropagation();
    }
    /**
     * @hidden @internal
     */
    onFilteringIconClick(event) {
      event.stopPropagation();
      this.grid.filteringService.toggleFilterDropdown(this.nativeElement, this.column);
    }
    /**
     * @hidden @internal
     */
    onSortingIconClick(event) {
      event.stopPropagation();
      this.triggerSort();
    }
    getSortDirection() {
      const expr = this.grid.sortingExpressions.find(x => x.fieldName === this.column.field);
      this.sortDirection = expr ? expr.dir : SortingDirection.None;
    }
    isAdvancedFilterApplied() {
      if (!this.grid.advancedFilteringExpressionsTree) {
        return false;
      }
      return !!ExpressionsTreeUtil.find(this.grid.advancedFilteringExpressionsTree, this.column.field);
    }
    triggerSort() {
      const groupingExpr = this.grid.groupingExpressions ? this.grid.groupingExpressions.find(expr => expr.fieldName === this.column.field) : this.grid.groupArea?.expressions ? this.grid.groupArea?.expressions.find(expr => expr.fieldName === this.column.field) : null;
      const sortDir = groupingExpr ? this.sortDirection + 1 > SortingDirection.Desc ? SortingDirection.Asc : SortingDirection.Desc : this.sortDirection + 1 > SortingDirection.Desc ? SortingDirection.None : this.sortDirection + 1;
      this.sortDirection = sortDir;
      this.grid.sort({
        fieldName: this.column.field,
        dir: this.sortDirection,
        ignoreCase: this.column.sortingIgnoreCase,
        strategy: this.column.sortStrategy
      });
    }
    static {
      this.ɵfac = function IgxGridHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridHeaderComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridHeaderComponent,
        selectors: [["igx-grid-header"]],
        viewQuery: function IgxGridHeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c152, 7, TemplateRef);
            i0.ɵɵviewQuery(_c153, 7, TemplateRef);
            i0.ɵɵviewQuery(_c154, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultESFHeaderIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultSortHeaderIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortIconContainer = _t.first);
          }
        },
        hostVars: 19,
        hostBindings: function IgxGridHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxGridHeaderComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("pointerenter", function IgxGridHeaderComponent_pointerenter_HostBindingHandler() {
              return ctx.onPinterEnter();
            })("pointerleave", function IgxGridHeaderComponent_pointerleave_HostBindingHandler() {
              return ctx.onPointerLeave();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-selected", ctx.ariaSelected);
            i0.ɵɵclassProp("igx-grid-th", ctx.columnGroupStyle)("asc", ctx.sortAscendingStyle)("desc", ctx.sortDescendingStyle)("igx-grid-th--number", ctx.numberStyle)("igx-grid-th--sortable", ctx.sortableStyle)("igx-grid-th--selectable", ctx.selectableStyle)("igx-grid-th--filtrable", ctx.filterableStyle)("igx-grid-th--sorted", ctx.sortedStyle)("igx-grid-th--selected", ctx.selectedStyle);
          }
        },
        inputs: {
          column: "column"
        },
        decls: 9,
        vars: 6,
        consts: [["defaultColumn", ""], ["defaultESFHeaderIconTemplate", ""], ["defaultSortHeaderIconTemplate", ""], ["sortIconContainer", ""], [1, "igx-grid-th__title"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid-th__icons"], [3, "title"], ["family", "default", "name", "more_vert"], ["family", "default", 3, "name"], [1, "sort-icon"], [3, "ngClass"], [1, "sort-icon", 3, "pointerdown", "click"], [3, "pointerdown", "click", "ngClass"]],
        template: function IgxGridHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridHeaderComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxGridHeaderComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxGridHeaderComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "span", 4);
            i0.ɵɵtemplate(7, IgxGridHeaderComponent_ng_container_7_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, IgxGridHeaderComponent_Conditional_8_Template, 3, 2, "div", 6);
          }
          if (rf & 2) {
            const defaultColumn_r4 = i0.ɵɵreference(1);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.column.headerTemplate ? ctx.column.headerTemplate : defaultColumn_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c155, ctx.column, ctx.column));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.column.columnGroup ? 8 : -1);
          }
        },
        dependencies: [IgxIconComponent, NgTemplateOutlet, NgClass, SortingIndexPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
class ExcelStylePositionStrategy extends AutoPositionStrategy {
  shouldFitInViewPort() {
    return true;
  }
  fitInViewport(element, connectedFit) {
    const heightOverflow = connectedFit.contentElementRect.height - connectedFit.viewPortRect.height;
    if (heightOverflow > 0) {
      element.style.width = 'auto';
      element.style.height = `${connectedFit.viewPortRect.height}px`;
    } else {
      element.style.height = `${Math.max(connectedFit.viewPortRect.height - connectedFit.targetRect.bottom - 1, connectedFit.contentElementRect.height)}px`;
    }
    super.fitInViewport(element, connectedFit);
  }
}

/**
 * @hidden
 */
let IgxFilteringService = /*#__PURE__*/(() => {
  class IgxFilteringService {
    constructor(iconService, _overlayService) {
      this.iconService = iconService;
      this._overlayService = _overlayService;
      this.isFilterRowVisible = false;
      this.filteredColumn = null;
      this.selectedExpression = null;
      this.columnToMoreIconHidden = new Map();
      this.activeFilterCell = 0;
      this.columnsWithComplexFilter = new Set();
      this.areEventsSubscribed = false;
      this.destroy$ = new Subject();
      this.isFiltering = false;
      this.columnToExpressionsMap = new Map();
      this.columnStartIndex = -1;
      this._filterMenuOverlaySettings = {
        closeOnEscape: true,
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new ExcelStylePositionStrategy({
          verticalStartPoint: VerticalAlignment.Bottom,
          openAnimation: useAnimation(fadeIn, {
            params: {
              duration: '250ms'
            }
          }),
          closeAnimation: null
        }),
        scrollStrategy: new AbsoluteScrollStrategy()
      };
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    toggleFilterDropdown(element, column) {
      const filterIcon = column.filteringExpressionsTree ? 'igx-excel-filter__icon--filtered' : 'igx-excel-filter__icon';
      const filterIconTarget = element.querySelector(`.${filterIcon}`) || element;
      const id = this.grid.createFilterDropdown(column, {
        ...this._filterMenuOverlaySettings,
        ...{
          target: filterIconTarget
        }
      });
      this._overlayService.opening.pipe(first$2(overlay => overlay.id === id), takeUntil(this.destroy$)).subscribe(event => {
        if (event.componentRef) {
          event.componentRef.instance.initialize(column, this._overlayService);
          event.componentRef.instance.overlayComponentId = id;
        }
        this.lastActiveNode = this.grid.navigation.activeNode;
      });
      this._overlayService.closed.pipe(first$2(overlay => overlay.id === id), takeUntil(this.destroy$)).subscribe(() => {
        this._overlayService.detach(id);
        this.grid.navigation.activeNode = this.lastActiveNode;
        this.grid.theadRow.nativeElement.focus();
      });
      this._overlayService.show(id);
    }
    /**
     * Subscribe to grid's events.
     */
    subscribeToEvents() {
      if (!this.areEventsSubscribed) {
        this.areEventsSubscribed = true;
        this.grid.columnResized.pipe(takeUntil(this.destroy$)).subscribe(eventArgs => {
          this.updateFilteringCell(eventArgs.column);
        });
        this.grid.parentVirtDir.chunkLoad.pipe(takeUntil(this.destroy$)).subscribe(eventArgs => {
          if (eventArgs.startIndex !== this.columnStartIndex) {
            this.columnStartIndex = eventArgs.startIndex;
            this.grid.filterCellList.forEach(filterCell => {
              filterCell.updateFilterCellArea();
            });
          }
        });
        this.grid.columnMovingEnd.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.grid.filterCellList.forEach(filterCell => {
            filterCell.updateFilterCellArea();
          });
        });
      }
    }
    /**
     * Close filtering row if a column is hidden.
     */
    hideFilteringRowOnColumnVisibilityChange(col) {
      const filteringRow = this.grid?.filteringRow;
      if (filteringRow && filteringRow.column && filteringRow.column === col) {
        filteringRow.close();
      }
    }
    /**
     * Internal method to create expressionsTree and filter grid used in both filter modes.
     */
    filterInternal(field, expressions = null) {
      this.isFiltering = true;
      let expressionsTree;
      if (expressions && 'operator' in expressions) {
        expressionsTree = expressions;
      } else {
        expressionsTree = this.createSimpleFilteringTree(field, expressions);
      }
      if (expressionsTree.filteringOperands.length === 0) {
        this.clearFilter(field);
      } else {
        this.filter(field, null, expressionsTree);
      }
      this.isFiltering = false;
    }
    /**
     * Execute filtering on the grid.
     */
    filter(field, value, conditionOrExpressionTree, ignoreCase) {
      const grid = this.grid;
      const col = grid.getColumnByName(field);
      const filteringIgnoreCase = ignoreCase || (col ? col.filteringIgnoreCase : false);
      const filteringTree = grid.filteringExpressionsTree;
      const columnFilteringExpressionsTree = ExpressionsTreeUtil.find(filteringTree, field);
      conditionOrExpressionTree = conditionOrExpressionTree ?? columnFilteringExpressionsTree;
      const fieldFilterIndex = ExpressionsTreeUtil.findIndex(filteringTree, field);
      const newFilteringTree = this.prepare_filtering_expression(filteringTree, field, value, conditionOrExpressionTree, filteringIgnoreCase, fieldFilterIndex, true);
      const eventArgs = {
        owner: grid,
        filteringExpressions: ExpressionsTreeUtil.find(newFilteringTree, field),
        cancel: false
      };
      this.grid.filtering.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      if (conditionOrExpressionTree) {
        this.filter_internal(field, value, conditionOrExpressionTree, filteringIgnoreCase);
      } else {
        const expressionsTreeForColumn = ExpressionsTreeUtil.find(this.grid.filteringExpressionsTree, field);
        if (!expressionsTreeForColumn) {
          throw new Error('Invalid condition or Expression Tree!');
        } else if (isTree(expressionsTreeForColumn)) {
          this.filter_internal(field, value, expressionsTreeForColumn, filteringIgnoreCase);
        } else {
          this.filter_internal(field, value, expressionsTreeForColumn.condition, filteringIgnoreCase);
        }
      }
      const doneEventArgs = ExpressionsTreeUtil.find(this.grid.filteringExpressionsTree, field);
      // Wait for the change detection to update filtered data through the pipes and then emit the event.
      requestAnimationFrame(() => this.grid.filteringDone.emit(doneEventArgs));
    }
    filter_global(term, condition, ignoreCase) {
      if (!condition) {
        return;
      }
      const filteringTree = this.grid.filteringExpressionsTree;
      this.grid.crudService.endEdit(false);
      this.grid.page = 0;
      filteringTree.filteringOperands = [];
      for (const column of this.grid.columns) {
        this.prepare_filtering_expression(filteringTree, column.field, term, condition, ignoreCase || column.filteringIgnoreCase);
      }
      this.grid.filteringExpressionsTree = filteringTree;
    }
    /**
     * Clears the filter of a given column if name is provided. Otherwise clears the filters of all columns.
     */
    clearFilter(field) {
      if (field) {
        const column = this.grid.getColumnByName(field);
        if (!column) {
          return;
        }
      }
      const emptyFilter = new FilteringExpressionsTree(null, field);
      const onFilteringEventArgs = {
        owner: this.grid,
        filteringExpressions: emptyFilter,
        cancel: false
      };
      this.grid.filtering.emit(onFilteringEventArgs);
      if (onFilteringEventArgs.cancel) {
        return;
      }
      this.isFiltering = true;
      this.clear_filter(field);
      // Wait for the change detection to update filtered data through the pipes and then emit the event.
      requestAnimationFrame(() => this.grid.filteringDone.emit(emptyFilter));
      if (field) {
        const expressions = this.getExpressions(field);
        expressions.length = 0;
      } else {
        this.grid.columns.forEach(c => {
          const expressions = this.getExpressions(c.field);
          expressions.length = 0;
        });
      }
      this.isFiltering = false;
    }
    clear_filter(fieldName) {
      const grid = this.grid;
      grid.crudService.endEdit(false);
      const filteringState = grid.filteringExpressionsTree;
      const index = ExpressionsTreeUtil.findIndex(filteringState, fieldName);
      if (index > -1) {
        filteringState.filteringOperands.splice(index, 1);
      } else if (!fieldName) {
        filteringState.filteringOperands = [];
      }
      grid.filteringExpressionsTree = filteringState;
    }
    /**
     * Filters all the `IgxColumnComponent` in the `IgxGridComponent` with the same condition.
     * @deprecated in version 19.0.0.
     */
    filterGlobal(value, condition, ignoreCase) {
      if (!condition) {
        return;
      }
      const filteringTree = this.grid.filteringExpressionsTree;
      const newFilteringTree = new FilteringExpressionsTree(filteringTree.operator, filteringTree.fieldName);
      for (const column of this.grid.columns) {
        this.prepare_filtering_expression(newFilteringTree, column.field, value, condition, ignoreCase || column.filteringIgnoreCase);
      }
      const eventArgs = {
        owner: this.grid,
        filteringExpressions: newFilteringTree,
        cancel: false
      };
      this.grid.filtering.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.grid.crudService.endEdit(false);
      this.grid.page = 0;
      this.grid.filteringExpressionsTree = newFilteringTree;
      // Wait for the change detection to update filtered data through the pipes and then emit the event.
      requestAnimationFrame(() => this.grid.filteringDone.emit(this.grid.filteringExpressionsTree));
    }
    /**
     * Register filtering SVG icons in the icon service.
     */
    registerSVGIcons() {
      const editorIcons = editor;
      editorIcons.forEach(icon => {
        this.iconService.addSvgIconFromText(icon.name, icon.value, 'imx-icons');
      });
      this.iconService.addSvgIconFromText(pinLeft.name, pinLeft.value, 'imx-icons');
      this.iconService.addSvgIconFromText(unpinLeft.name, unpinLeft.value, 'imx-icons');
    }
    /**
     * Returns the ExpressionUI array for a given column.
     */
    getExpressions(columnId) {
      if (!this.columnToExpressionsMap.has(columnId)) {
        const column = this.grid.columns.find(col => col.field === columnId);
        const expressionUIs = new Array();
        if (column) {
          this.generateExpressionsList(column.filteringExpressionsTree, this.grid.filteringExpressionsTree.operator, expressionUIs);
          this.columnToExpressionsMap.set(columnId, expressionUIs);
        }
        return expressionUIs;
      }
      return this.columnToExpressionsMap.get(columnId);
    }
    /**
     * Recreates all ExpressionUIs for all columns. Executed after filtering to refresh the cache.
     */
    refreshExpressions() {
      if (!this.isFiltering) {
        this.columnsWithComplexFilter.clear();
        this.columnToExpressionsMap.forEach((value, key) => {
          const column = this.grid.columns.find(col => col.field === key);
          if (column) {
            value.length = 0;
            this.generateExpressionsList(column.filteringExpressionsTree, this.grid.filteringExpressionsTree.operator, value);
            const isComplex = this.isFilteringTreeComplex(column.filteringExpressionsTree);
            if (isComplex) {
              this.columnsWithComplexFilter.add(key);
            }
            this.updateFilteringCell(column);
          } else {
            this.columnToExpressionsMap.delete(key);
          }
        });
      }
    }
    /**
     * Remove an ExpressionUI for a given column.
     */
    removeExpression(columnId, indexToRemove) {
      const expressionsList = this.getExpressions(columnId);
      if (indexToRemove === 0 && expressionsList.length > 1) {
        expressionsList[1].beforeOperator = null;
      } else if (indexToRemove === expressionsList.length - 1) {
        expressionsList[indexToRemove - 1].afterOperator = null;
      } else {
        expressionsList[indexToRemove - 1].afterOperator = expressionsList[indexToRemove + 1].beforeOperator;
        expressionsList[0].beforeOperator = null;
        expressionsList[expressionsList.length - 1].afterOperator = null;
      }
      expressionsList.splice(indexToRemove, 1);
    }
    /**
     * Generate filtering tree for a given column from existing ExpressionUIs.
     */
    createSimpleFilteringTree(columnId, expressionUIList = null) {
      const expressionsList = expressionUIList ? expressionUIList : this.getExpressions(columnId);
      const expressionsTree = new FilteringExpressionsTree(FilteringLogic.Or, columnId);
      let currAndBranch;
      for (const currExpressionUI of expressionsList) {
        if (!currExpressionUI.expression.condition.isUnary && currExpressionUI.expression.searchVal === null) {
          if (currExpressionUI.afterOperator === FilteringLogic.And && !currAndBranch) {
            currAndBranch = new FilteringExpressionsTree(FilteringLogic.And, columnId);
            expressionsTree.filteringOperands.push(currAndBranch);
          }
          continue;
        }
        if ((currExpressionUI.beforeOperator === undefined || currExpressionUI.beforeOperator === null || currExpressionUI.beforeOperator === FilteringLogic.Or) && currExpressionUI.afterOperator === FilteringLogic.And) {
          currAndBranch = new FilteringExpressionsTree(FilteringLogic.And, columnId);
          expressionsTree.filteringOperands.push(currAndBranch);
          currAndBranch.filteringOperands.push(currExpressionUI.expression);
        } else if (currExpressionUI.beforeOperator === FilteringLogic.And) {
          currAndBranch.filteringOperands.push(currExpressionUI.expression);
        } else {
          expressionsTree.filteringOperands.push(currExpressionUI.expression);
          currAndBranch = null;
        }
      }
      return expressionsTree;
    }
    /**
     * Returns whether a complex filter is applied to a given column.
     */
    isFilterComplex(columnId) {
      if (this.columnsWithComplexFilter.has(columnId)) {
        return true;
      }
      const column = this.grid.columns.find(col => col.field === columnId);
      const isComplex = column && this.isFilteringTreeComplex(column.filteringExpressionsTree);
      if (isComplex) {
        this.columnsWithComplexFilter.add(columnId);
      }
      return isComplex;
    }
    /**
     * Returns the string representation of the FilteringLogic operator.
     */
    getOperatorAsString(operator) {
      if (operator === 0) {
        return this.grid.resourceStrings.igx_grid_filter_operator_and;
      } else {
        return this.grid.resourceStrings.igx_grid_filter_operator_or;
      }
    }
    /**
     * Generate the label of a chip from a given filtering expression.
     */
    getChipLabel(expression) {
      if (expression.condition.isUnary) {
        return this.grid.resourceStrings[`igx_grid_filter_${expression.condition.name}`] || expression.condition.name;
      } else if (expression.searchVal instanceof Date) {
        const column = this.grid.getColumnByName(expression.fieldName);
        const formatter = column.formatter;
        if (formatter) {
          return formatter(expression.searchVal, undefined);
        }
        const pipeArgs = column.pipeArgs;
        return formatDate(expression.searchVal, pipeArgs.format, this.grid.locale);
      } else {
        return expression.searchVal;
      }
    }
    /**
     * Updates the content of a filterCell.
     */
    updateFilteringCell(column) {
      const filterCell = column.filterCell;
      if (filterCell) {
        filterCell.updateFilterCellArea();
      }
    }
    generateExpressionsList(expressions, operator, expressionsUIs) {
      generateExpressionsList(expressions, operator, expressionsUIs);
    }
    isFilteringExpressionsTreeEmpty(expressionTree) {
      if (FilteringExpressionsTree.empty(expressionTree)) {
        return true;
      }
      for (const expr of expressionTree.filteringOperands) {
        if (isTree(expr)) {
          if (expr.filteringOperands && expr.filteringOperands.length) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    }
    filter_internal(fieldName, term, conditionOrExpressionsTree, ignoreCase) {
      const filteringTree = this.grid.filteringExpressionsTree;
      this.grid.crudService.endEdit(false);
      this.grid.page = 0;
      const fieldFilterIndex = ExpressionsTreeUtil.findIndex(filteringTree, fieldName);
      this.prepare_filtering_expression(filteringTree, fieldName, term, conditionOrExpressionsTree, ignoreCase, fieldFilterIndex);
      this.grid.filteringExpressionsTree = filteringTree;
    }
    /** Modifies the filteringState object to contain the newly added filtering conditions/expressions.
     * If createNewTree is true, filteringState will not be modified (because it directly affects the grid.filteringExpressionsTree),
     * but a new object is created and returned.
     */
    prepare_filtering_expression(filteringState, fieldName, searchVal, conditionOrExpressionsTree, ignoreCase, insertAtIndex = -1, createNewTree = false) {
      let expressionsTree = conditionOrExpressionsTree && 'operator' in conditionOrExpressionsTree ? conditionOrExpressionsTree : null;
      const condition = conditionOrExpressionsTree && 'operator' in conditionOrExpressionsTree ? null : conditionOrExpressionsTree;
      let newExpressionsTree = filteringState;
      if (createNewTree) {
        newExpressionsTree = new FilteringExpressionsTree(filteringState.operator, filteringState.fieldName);
        newExpressionsTree.filteringOperands = [...filteringState.filteringOperands];
      }
      if (condition) {
        const newExpression = {
          fieldName: fieldName,
          searchVal,
          condition,
          conditionName: condition.name,
          ignoreCase
        };
        expressionsTree = new FilteringExpressionsTree(filteringState.operator, fieldName);
        expressionsTree.filteringOperands.push(newExpression);
      }
      if (expressionsTree) {
        if (insertAtIndex > -1) {
          newExpressionsTree.filteringOperands[insertAtIndex] = expressionsTree;
        } else {
          newExpressionsTree.filteringOperands.push(expressionsTree);
        }
      }
      return newExpressionsTree;
    }
    isFilteringTreeComplex(expressions) {
      if (!expressions) {
        return false;
      }
      if (isTree(expressions)) {
        if (expressions.operator === FilteringLogic.Or) {
          const andOperatorsCount = this.getChildAndOperatorsCount(expressions);
          // having more than one 'And' operator in the sub-tree means that the filter could not be represented without parentheses.
          return andOperatorsCount > 1;
        }
        let isComplex = false;
        for (const operand of expressions.filteringOperands) {
          isComplex = isComplex || this.isFilteringTreeComplex(operand);
        }
        return isComplex;
      }
      return false;
    }
    getChildAndOperatorsCount(expressions) {
      let count = 0;
      let operand;
      for (let i = 0; i < expressions.filteringOperands.length; i++) {
        operand = expressions[i];
        if (operand && isTree(operand)) {
          if (operand.operator === FilteringLogic.And) {
            count++;
          }
          count = count + this.getChildAndOperatorsCount(operand);
        }
      }
      return count;
    }
    static {
      this.ɵfac = function IgxFilteringService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilteringService)(i0.ɵɵinject(IgxIconService), i0.ɵɵinject(IgxOverlayService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxFilteringService,
        factory: IgxFilteringService.ɵfac
      });
    }
  }
  return IgxFilteringService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGridFilteringCellComponent = /*#__PURE__*/(() => {
  class IgxGridFilteringCellComponent {
    get styleClasses() {
      return this.column && this.column.selected ? 'igx-grid__filtering-cell--selected' : 'igx-grid__filtering-cell';
    }
    constructor(cdr, filteringService) {
      this.cdr = cdr;
      this.filteringService = filteringService;
      this.moreFiltersCount = 0;
      this.baseClass = 'igx-grid__filtering-cell-indicator';
      this.filteringService.subscribeToEvents();
    }
    ngOnInit() {
      this.filteringService.columnToMoreIconHidden.set(this.column.field, true);
    }
    ngAfterViewInit() {
      this.updateFilterCellArea();
    }
    ngDoCheck() {
      this.updateFilterCellArea();
    }
    /**
     * Returns whether a chip with a given index is visible or not.
     */
    isChipVisible(index) {
      const expression = this.expressionsList[index];
      return !!(expression && expression.isVisible);
    }
    /**
     * Updates the filtering cell area.
     */
    updateFilterCellArea() {
      this.expressionsList = this.filteringService.getExpressions(this.column.field);
      this.updateVisibleFilters();
    }
    get template() {
      if (!this.column.filterable) {
        return null;
      }
      if (this.column.filterCellTemplate) {
        return this.column.filterCellTemplate;
      }
      const expressionTree = this.column.filteringExpressionsTree;
      if (!expressionTree || expressionTree.filteringOperands.length === 0) {
        return this.emptyFilter;
      }
      if (this.filteringService.isFilterComplex(this.column.field)) {
        return this.complexFilter;
      }
      return this.defaultFilter;
    }
    /**
     * Gets the context passed to the filter template.
     *
     * @memberof IgxGridFilteringCellComponent
     */
    get context() {
      return {
        $implicit: this.column,
        column: this.column
      };
    }
    /**
     * Chip clicked event handler.
     */
    onChipClicked(expression) {
      if (expression) {
        this.expressionsList.forEach(item => {
          item.isSelected = item.expression === expression;
        });
      } else if (this.expressionsList.length > 0) {
        this.expressionsList.forEach(item => {
          item.isSelected = false;
        });
        this.expressionsList[0].isSelected = true;
      }
      this.filteringService.grid.navigation.performHorizontalScrollToCell(this.column.visibleIndex);
      this.filteringService.filteredColumn = this.column;
      this.filteringService.isFilterRowVisible = true;
      this.filteringService.selectedExpression = expression;
    }
    /**
     * Chip removed event handler.
     */
    onChipRemoved(eventArgs, item) {
      const indexToRemove = this.expressionsList.indexOf(item);
      this.removeExpression(indexToRemove);
      this.filteringService.grid.theadRow.nativeElement.focus();
    }
    /**
     * Clears the filtering.
     */
    clearFiltering() {
      this.filteringService.clearFilter(this.column.field);
      this.cdr.detectChanges();
    }
    /**
     * Returns the filtering indicator class.
     */
    filteringIndicatorClass() {
      return {
        [this.baseClass]: !this.isMoreIconHidden(),
        [`${this.baseClass}--hidden`]: this.isMoreIconHidden()
      };
    }
    get filteringElementsSize() {
      return this.column.grid.gridSize === Size.Large ? Size.Medium : this.column.grid.gridSize;
    }
    removeExpression(indexToRemove) {
      if (indexToRemove === 0 && this.expressionsList.length === 1) {
        this.clearFiltering();
        return;
      }
      this.filteringService.removeExpression(this.column.field, indexToRemove);
      this.updateVisibleFilters();
      this.filteringService.filterInternal(this.column.field);
    }
    isMoreIconHidden() {
      return this.filteringService.columnToMoreIconHidden.get(this.column.field);
    }
    updateVisibleFilters() {
      this.expressionsList.forEach(ex => ex.isVisible = true);
      if (this.moreIcon) {
        this.filteringService.columnToMoreIconHidden.set(this.column.field, true);
      }
      this.cdr.detectChanges();
      if (this.chipsArea && this.expressionsList.length > 1) {
        const areaWidth = this.chipsArea.element.nativeElement.offsetWidth;
        let viewWidth = 0;
        const chipsAreaElements = this.chipsArea.element.nativeElement.children;
        let visibleChipsCount = 0;
        const moreIconWidth = this.moreIcon.nativeElement.offsetWidth - parseInt(this.column?.grid.document.defaultView.getComputedStyle(this.moreIcon.nativeElement)['margin-left'], 10);
        for (let index = 0; index < chipsAreaElements.length - 1; index++) {
          if (viewWidth + chipsAreaElements[index].offsetWidth < areaWidth) {
            viewWidth += chipsAreaElements[index].offsetWidth;
            if (index % 2 === 0) {
              visibleChipsCount++;
            } else {
              viewWidth += parseInt(this.column?.grid.document.defaultView.getComputedStyle(chipsAreaElements[index])['margin-left'], 10);
              viewWidth += parseInt(this.column?.grid.document.defaultView.getComputedStyle(chipsAreaElements[index])['margin-right'], 10);
            }
          } else {
            if (index % 2 !== 0 && viewWidth + moreIconWidth > areaWidth) {
              visibleChipsCount--;
            } else if (visibleChipsCount > 0 && viewWidth - chipsAreaElements[index - 1].offsetWidth + moreIconWidth > areaWidth) {
              visibleChipsCount--;
            }
            this.moreFiltersCount = this.expressionsList.length - visibleChipsCount;
            this.filteringService.columnToMoreIconHidden.set(this.column.field, false);
            break;
          }
        }
        for (let i = visibleChipsCount; i < this.expressionsList.length; i++) {
          this.expressionsList[i].isVisible = false;
        }
        this.cdr.detectChanges();
      }
    }
    static {
      this.ɵfac = function IgxGridFilteringCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridFilteringCellComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxFilteringService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridFilteringCellComponent,
        selectors: [["igx-grid-filtering-cell"]],
        viewQuery: function IgxGridFilteringCellComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c156, 7, TemplateRef);
            i0.ɵɵviewQuery(_c157, 7, TemplateRef);
            i0.ɵɵviewQuery(_c158, 7, TemplateRef);
            i0.ɵɵviewQuery(_c159, 5, IgxChipsAreaComponent);
            i0.ɵɵviewQuery(_c160, 5, ElementRef);
            i0.ɵɵviewQuery(_c161, 5, IgxChipComponent);
            i0.ɵɵviewQuery(_c162, 5, IgxChipComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.complexFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipsArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreIcon = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ghostChip = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.complexChip = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxGridFilteringCellComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClasses);
          }
        },
        inputs: {
          column: "column"
        },
        decls: 7,
        vars: 2,
        consts: [["emptyFilter", ""], ["defaultFilter", ""], ["complexFilter", ""], ["ghostChip", ""], ["chipsArea", ""], ["moreIcon", ""], ["label", ""], ["complexChip", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-filtering-chips"], [3, "click", "tabIndex"], ["igxPrefix", "", "family", "default", "name", "filter_list"], [3, "click", "ngClass"], ["family", "default", "name", "filter_list"], [3, "value"], [3, "removable", "tabIndex", "--ig-size"], [1, "igx-filtering-chips__connector"], [3, "click", "remove", "removable", "tabIndex"], ["igxPrefix", "", "family", "default", 3, "name"], [3, "remove", "removable", "tabIndex"]],
        template: function IgxGridFilteringCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridFilteringCellComponent_ng_template_0_Template, 6, 8, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxGridFilteringCellComponent_ng_template_2_Template, 8, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxGridFilteringCellComponent_ng_template_4_Template, 5, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxGridFilteringCellComponent_ng_container_6_Template, 1, 0, "ng-container", 8);
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.context);
          }
        },
        dependencies: [IgxChipsAreaComponent, IgxChipComponent, IgxIconComponent, IgxPrefixDirective, NgClass, IgxBadgeComponent, NgTemplateOutlet],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridFilteringCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxResizeHandleDirective = /*#__PURE__*/(() => {
  class IgxResizeHandleDirective {
    constructor(zone, element, colResizingService) {
      this.zone = zone;
      this.element = element;
      this.colResizingService = colResizingService;
      /**
       * @hidden
       */
      this._dblClick = false;
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
      this.DEBOUNCE_TIME = 200;
    }
    /**
     * @hidden
     */
    onDoubleClick() {
      this._dblClick = true;
      this.initResizeService();
      this.colResizingService.autosizeColumnOnDblClick();
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      if (!this.column.columnGroup && this.column.resizable) {
        this.zone.runOutsideAngular(() => {
          fromEvent(this.element.nativeElement, 'mousedown').pipe(debounceTime(this.DEBOUNCE_TIME), takeUntil(this.destroy$)).subscribe(event => {
            if (this._dblClick) {
              this._dblClick = false;
              return;
            }
            if (event.button === 0) {
              this._onResizeAreaMouseDown(event);
              this.column.grid.resizeLine.resizer.onMousedown(event);
            }
          });
        });
        fromEvent(this.element.nativeElement, 'mouseup').pipe(debounceTime(this.DEBOUNCE_TIME), takeUntil(this.destroy$)).subscribe(() => {
          this.colResizingService.isColumnResizing = false;
          this.colResizingService.showResizer = false;
          this.column.grid.cdr.detectChanges();
        });
      }
    }
    /**
     * @hidden
     */
    _onResizeAreaMouseDown(event) {
      this.initResizeService(event);
      this.colResizingService.showResizer = true;
      this.column.grid.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    initResizeService(event = null) {
      this.colResizingService.column = this.column;
      if (event) {
        this.colResizingService.isColumnResizing = true;
        this.colResizingService.startResizePos = event.clientX;
      }
    }
    static {
      this.ɵfac = function IgxResizeHandleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxResizeHandleDirective)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxColumnResizingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxResizeHandleDirective,
        selectors: [["", "igxResizeHandle", ""]],
        hostBindings: function IgxResizeHandleDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dblclick", function IgxResizeHandleDirective_dblclick_HostBindingHandler() {
              return ctx.onDoubleClick();
            });
          }
        },
        inputs: {
          column: [0, "igxResizeHandle", "column"]
        }
      });
    }
  }
  return IgxResizeHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxGridHeaderGroupComponent } from '../headers/grid-header-group.component';
let IgxColumnMovingDropDirective = /*#__PURE__*/(() => {
  class IgxColumnMovingDropDirective extends IgxDropDirective {
    set data(val) {
      if (val instanceof IgxGridForOfDirective) {
        this._displayContainer = val;
      } else {
        this._column = val;
      }
    }
    get column() {
      return this._column;
    }
    get isDropTarget() {
      return this.column && this.column.grid.moving && (!this.column.pinned && this.cms.column?.disablePinning || !this.cms.column?.disablePinning);
    }
    get horizontalScroll() {
      if (this._displayContainer) {
        return this._displayContainer;
      }
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    constructor(ref, renderer, _, cms) {
      super(ref, renderer, _);
      this.ref = ref;
      this.renderer = renderer;
      this._ = _;
      this.cms = cms;
      this._dropIndicator = null;
      this._lastDropIndicator = null;
      this._dragLeave = new Subject();
      this._dropIndicatorClass = 'igx-grid-th__drop-indicator--active';
    }
    ngOnDestroy() {
      this._dragLeave.next(true);
      this._dragLeave.complete();
      super.ngOnDestroy();
    }
    onDragOver(event) {
      const drag = event.detail.owner;
      if (!(drag instanceof IgxColumnMovingDragDirective)) {
        return;
      }
      if (this.isDropTarget && this.cms.column !== this.column && this.cms.column.level === this.column.level && this.cms.column.parent === this.column.parent) {
        if (this._lastDropIndicator) {
          this.renderer.removeClass(this._dropIndicator, this._dropIndicatorClass);
        }
        const clientRect = this.nativeElement.getBoundingClientRect();
        const pos = clientRect.left + clientRect.width / 2;
        const parent = this.nativeElement.parentElement;
        if (event.detail.pageX < pos) {
          this._dropPos = DropPosition.BeforeDropTarget;
          this._lastDropIndicator = this._dropIndicator = parent.firstElementChild;
        } else {
          this._dropPos = DropPosition.AfterDropTarget;
          this._lastDropIndicator = this._dropIndicator = parent.lastElementChild;
        }
        if (this.cms.icon.innerText !== 'block') {
          this.renderer.addClass(this._dropIndicator, this._dropIndicatorClass);
        }
      }
    }
    onDragEnter(event) {
      const drag = event.detail.owner;
      if (!(drag instanceof IgxColumnMovingDragDirective)) {
        return;
      }
      if (this.column && this.cms.column.grid.id !== this.column.grid.id) {
        this.cms.icon.innerText = 'block';
        return;
      }
      if (this.isDropTarget && this.cms.column !== this.column && this.cms.column.level === this.column.level && this.cms.column.parent === this.column.parent) {
        if (!this.column.pinned || this.column.pinned && this.cms.column.pinned) {
          this.cms.icon.innerText = 'swap_horiz';
        }
        this.cms.icon.innerText = 'save_alt';
      } else {
        this.cms.icon.innerText = 'block';
      }
      if (this.horizontalScroll) {
        this.cms.icon.innerText = event.target.id === 'right' ? 'arrow_forward' : 'arrow_back';
        interval(0, animationFrameScheduler).pipe(takeUntil(this._dragLeave)).subscribe(() => {
          if (event.target.id === 'right') {
            this.horizontalScroll.scrollPosition += 10;
          } else {
            this.horizontalScroll.scrollPosition -= 10;
          }
        });
      }
    }
    onDragLeave(event) {
      const drag = event.detail.owner;
      if (!(drag instanceof IgxColumnMovingDragDirective)) {
        return;
      }
      this.cms.icon.innerText = 'block';
      if (this._dropIndicator) {
        this.renderer.removeClass(this._dropIndicator, this._dropIndicatorClass);
      }
      if (this.horizontalScroll) {
        this._dragLeave.next(true);
      }
    }
    onDragDrop(event) {
      event.preventDefault();
      const drag = event.detail.owner;
      if (this.cms.cancelDrop || !(drag instanceof IgxColumnMovingDragDirective)) {
        this.cms.cancelDrop = false;
        return;
      }
      if (this.column && this.cms.column.grid.id !== this.column.grid.id) {
        return;
      }
      if (this.horizontalScroll) {
        this._dragLeave.next(true);
      }
      if (this.isDropTarget) {
        this.column.grid.moveColumn(this.cms.column, this.column, this._dropPos);
        this.cms.column = null;
        this.column.grid.cdr.detectChanges();
      }
    }
    static {
      this.ɵfac = function IgxColumnMovingDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnMovingDropDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IgxColumnMovingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnMovingDropDirective,
        selectors: [["", "igxColumnMovingDrop", ""]],
        inputs: {
          data: [0, "igxColumnMovingDrop", "data"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxColumnMovingDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const Z_INDEX = 9999;
/**
 * @hidden
 */
let IgxGridHeaderGroupComponent = /*#__PURE__*/(() => {
  class IgxGridHeaderGroupComponent {
    get rowEnd() {
      return this.column.rowEnd;
    }
    get colEnd() {
      return this.column.colEnd;
    }
    get rowStart() {
      return this.column.rowStart;
    }
    get colStart() {
      return this.column.colStart;
    }
    get headerID() {
      return `${this.grid.id}_-1_${this.column.level}_${this.column.visibleIndex}`;
    }
    get active() {
      const node = this.grid.navigation.activeNode;
      return node && !this.column.columnGroup ? node.row === -1 && node.column === this.column.visibleIndex && node.level === this.column.level : false;
    }
    get activeGroup() {
      const node = this.grid.navigation.activeNode;
      return node ? node.row === -1 && node.column === this.column.visibleIndex && node.level === this.column.level : false;
    }
    /**
     * Gets the width of the header group.
     *
     * @memberof IgxGridHeaderGroupComponent
     */
    get width() {
      return this.grid.getHeaderGroupWidth(this.column);
    }
    constructor(cdr, grid, ref, colResizingService, filteringService, platform) {
      this.cdr = cdr;
      this.grid = grid;
      this.ref = ref;
      this.colResizingService = colResizingService;
      this.filteringService = filteringService;
      this.platform = platform;
      this.defaultCss = true;
    }
    get pinnedCss() {
      return this.isPinned;
    }
    get pinnedLastCss() {
      return this.isLastPinned;
    }
    get pinnedFirstCSS() {
      return this.isFirstPinned;
    }
    get headerDragCss() {
      return this.isHeaderDragged;
    }
    get filteringCss() {
      return this.isFiltered;
    }
    /**
     * @hidden
     */
    get zIndex() {
      if (!this.column.pinned) {
        return null;
      }
      return Z_INDEX - this.grid.pinnedColumns.indexOf(this.column);
    }
    /**
     * Gets whether the header group belongs to a column that is filtered.
     *
     * @memberof IgxGridHeaderGroupComponent
     */
    get isFiltered() {
      return this.filteringService.filteredColumn === this.column;
    }
    /**
     * Gets whether the header group is stored in the last column in the pinned area.
     *
     * @memberof IgxGridHeaderGroupComponent
     */
    get isLastPinned() {
      return !this.grid.hasColumnLayouts ? this.column.isLastPinned : false;
    }
    /**
     * Gets whether the header group is stored in the first column of the right pinned area.
     */
    get isFirstPinned() {
      return !this.grid.hasColumnLayouts ? this.column.isFirstPinned : false;
    }
    get groupDisplayStyle() {
      return this.grid.hasColumnLayouts && this.column.children ? 'flex' : '';
    }
    /**
     * Gets whether the header group is stored in a pinned column.
     *
     * @memberof IgxGridHeaderGroupComponent
     */
    get isPinned() {
      return this.column.pinned;
    }
    /**
     * Gets whether the header group belongs to a column that is moved.
     *
     * @memberof IgxGridHeaderGroupComponent
     */
    get isHeaderDragged() {
      return this.grid.columnInDrag === this.column;
    }
    /**
     * @hidden
     */
    get hasLastPinnedChildColumn() {
      return this.column.allChildren.some(child => child.isLastPinned);
    }
    /**
     * @hidden
     */
    get hasFirstPinnedChildColumn() {
      return this.column.allChildren.some(child => child.isFirstPinned);
    }
    /**
     * @hidden
     */
    get selectable() {
      const selectableChildren = this.column.allChildren.filter(c => !c.hidden && c.selectable && !c.columnGroup);
      return this.grid.columnSelection !== GridSelectionMode.none && this.column.applySelectableClass && !this.selected && selectableChildren.length > 0 && !this.grid.filteringService.isFilterRowVisible;
    }
    /**
     * @hidden
     */
    get selected() {
      return this.column.selected;
    }
    /**
     * @hidden
     */
    get height() {
      return this.nativeElement.getBoundingClientRect().height;
    }
    /**
     * @hidden
     */
    get title() {
      return this.column.title || this.column.header;
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    /**
     * @hidden
     */
    onMouseDown(event) {
      if (!this.grid.allowFiltering || event.composedPath().findIndex(el => el.tagName?.toLowerCase() === 'igx-grid-filtering-cell') < 1) {
        // Hack for preventing text selection in IE and Edge while dragging the resize element
        event.preventDefault();
      }
    }
    /**
     * @hidden
     */
    groupClicked(event) {
      const columnsToSelect = this.column.allChildren.filter(c => !c.hidden && c.selectable && !c.columnGroup).map(c => c.field);
      if (this.grid.columnSelection !== GridSelectionMode.none && columnsToSelect.length > 0 && !this.grid.filteringService.isFilterRowVisible) {
        const clearSelection = this.grid.columnSelection === GridSelectionMode.single || !event.ctrlKey;
        const rangeSelection = this.grid.columnSelection === GridSelectionMode.multiple && event.shiftKey;
        if (!this.selected) {
          this.grid.selectionService.selectColumns(columnsToSelect, clearSelection, rangeSelection, event);
        } else {
          const selectedFields = this.grid.selectionService.getSelectedColumns();
          if (selectedFields.length === columnsToSelect.length && selectedFields.every(el => columnsToSelect.includes(el)) || !clearSelection) {
            this.grid.selectionService.deselectColumns(columnsToSelect, event);
          } else {
            this.grid.selectionService.selectColumns(columnsToSelect, clearSelection, rangeSelection, event);
          }
        }
      }
    }
    /**
     * @hidden @internal
     */
    onPointerDownIndicator(event) {
      // Stop propagation of pointer events to now allow column dragging using the header indicators.
      event.stopPropagation();
    }
    /**
     * @hidden @internal
     */
    toggleExpandState(event) {
      event.stopPropagation();
      this.column.expanded = !this.column.expanded;
    }
    /**
     * @hidden @internal
     */
    pointerdown(event) {
      event.stopPropagation();
      this.activate();
      this.grid.theadRow.nativeElement.focus();
    }
    /*
     * This method is necessary due to some specifics related with implementation of column moving
     * @hidden
     */
    activate() {
      this.grid.navigation.setActiveNode(this.activeNode);
      this.grid.theadRow.nativeElement.focus();
    }
    ngDoCheck() {
      this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    onPinterEnter() {
      this.column.applySelectableClass = true;
    }
    /**
     * @hidden
     */
    onPointerLeave() {
      this.column.applySelectableClass = false;
    }
    get activeNode() {
      return {
        row: -1,
        column: this.column.visibleIndex,
        level: this.column.level,
        mchCache: {
          level: this.column.level,
          visibleIndex: this.column.visibleIndex
        },
        layout: this.column.columnLayoutChild ? {
          rowStart: this.column.rowStart,
          colStart: this.column.colStart,
          rowEnd: this.column.rowEnd,
          colEnd: this.column.colEnd,
          columnVisibleIndex: this.column.visibleIndex
        } : null
      };
    }
    static {
      this.ɵfac = function IgxGridHeaderGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridHeaderGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridHeaderGroupComponent,
        selectors: [["igx-grid-header-group"]],
        viewQuery: function IgxGridHeaderGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxGridHeaderComponent, 5);
            i0.ɵɵviewQuery(IgxGridFilteringCellComponent, 5);
            i0.ɵɵviewQuery(IgxGridHeaderGroupComponent, 5, IgxGridHeaderGroupComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        hostVars: 27,
        hostBindings: function IgxGridHeaderGroupComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function IgxGridHeaderGroupComponent_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.headerID);
            i0.ɵɵstyleProp("grid-row-end", ctx.rowEnd)("grid-column-end", ctx.colEnd)("grid-row-start", ctx.rowStart)("grid-column-start", ctx.colStart)("z-index", ctx.zIndex)("display", ctx.groupDisplayStyle);
            i0.ɵɵclassProp("igx-grid-th--active", ctx.active)("igx-grid-thead__item", ctx.defaultCss)("igx-grid-th--pinned", ctx.pinnedCss)("igx-grid-th--pinned-last", ctx.pinnedLastCss)("igx-grid-th--pinned-first", ctx.pinnedFirstCSS)("igx-grid__drag-col-header", ctx.headerDragCss)("igx-grid-th--filtering", ctx.filteringCss);
          }
        },
        inputs: {
          column: "column"
        },
        decls: 7,
        vars: 3,
        consts: [["defaultColumn", ""], ["defaultCollapseIndicator", ""], [1, "igx-grid-th__drop-indicator-left"], [1, "igx-grid-thead__group", "igx-grid__mrl-block", 3, "ngClass", "ngStyle"], [1, "igx-grid-th__drop-indicator-right"], [1, "igx-grid-thead__subgroup", 3, "ngClass", "ngStyle", "column"], [1, "igx-grid-th__group-title", 3, "title"], ["family", "default", 3, "name"], ["role", "columnheader", 1, "igx-grid-thead__title", 3, "pointerdown", "click", "pointerenter", "pointerleave", "ngClass", "igxColumnMovingDrag", "ghostHost", "igxColumnMovingDrop"], [1, "igx-grid-th__expander"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid-thead__group"], [1, "igx-grid-th__expander", 3, "pointerdown", "click"], [1, "igx-grid-thead__subgroup", 3, "ngClass", "ngStyle", "column", "min-width", "flex-basis"], ["role", "columnheader", 1, "igx-grid-th--fw", 3, "pointerdown", "id", "ngClass", "ngStyle", "igxColumnMovingDrag", "ghostHost", "igxColumnMovingDrop", "column"], [3, "column"], [1, "igx-grid-th__resize-handle", 3, "igxResizeHandle", "cursor"], [1, "igx-grid-th__resize-handle", 3, "igxResizeHandle"]],
        template: function IgxGridHeaderGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridHeaderGroupComponent_Conditional_0_Template, 5, 10)(1, IgxGridHeaderGroupComponent_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxGridHeaderGroupComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxGridHeaderGroupComponent_Conditional_5_Template, 6, 24)(6, IgxGridHeaderGroupComponent_Conditional_6_Template, 6, 16);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.grid.hasColumnLayouts && ctx.column.columnGroup ? 0 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ctx.grid.hasColumnLayouts && ctx.column.columnGroup ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.column.columnGroup ? 6 : -1);
          }
        },
        dependencies: [IgxGridHeaderGroupComponent, NgClass, NgStyle, IgxColumnMovingDragDirective, IgxColumnMovingDropDirective, IgxIconComponent, NgTemplateOutlet, IgxGridHeaderComponent, IgxGridFilteringCellComponent, IgxResizeHandleDirective, IgxHeaderGroupWidthPipe, IgxHeaderGroupStylePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridHeaderGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGridFilteringRowComponent = /*#__PURE__*/(() => {
  class IgxGridFilteringRowComponent {
    get column() {
      return this._column;
    }
    set column(val) {
      if (this._column) {
        this.expressionsList.forEach(exp => exp.isSelected = false);
      }
      if (val) {
        this._column = val;
        this.expressionsList = this.filteringService.getExpressions(this._column.field);
        this.resetExpression();
        this.chipAreaScrollOffset = 0;
        this.transform(this.chipAreaScrollOffset);
      }
    }
    get value() {
      return this._value;
    }
    set value(val) {
      if (!val && val !== 0 && (this.expression.searchVal || this.expression.searchVal === 0)) {
        this.expression.searchVal = null;
        this._value = null;
        const index = this.expressionsList.findIndex(item => item.expression === this.expression);
        if (index === 0 && this.expressionsList.length === 1 && !this.expression.condition.isUnary) {
          this.filteringService.clearFilter(this.column.field);
        }
      } else {
        if (val === '') {
          return;
        }
        const oldValue = this.expression.searchVal;
        if (isEqual(oldValue, val)) {
          return;
        }
        this._value = val;
        this.expression.searchVal = DataUtil.parseValue(this.column.dataType, val);
        if (this.expressionsList.find(item => item.expression === this.expression) === undefined) {
          this.addExpression(true);
        }
        this.filter();
      }
    }
    get filteringElementsSize() {
      // needed because we want the size of the chips to be either Medium or Small
      return this.column.grid.gridSize === Size.Large ? Size.Medium : this.column.grid.gridSize;
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    constructor(filteringService, ref, cdr, platform) {
      this.filteringService = filteringService;
      this.ref = ref;
      this.cdr = cdr;
      this.platform = platform;
      this.defaultCSSClass = true;
      this._positionSettings = {
        horizontalStartPoint: HorizontalAlignment.Left,
        verticalStartPoint: VerticalAlignment.Bottom
      };
      this._conditionsOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new ConnectedPositioningStrategy(this._positionSettings)
      };
      this._operatorsOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        scrollStrategy: new AbsoluteScrollStrategy(),
        positionStrategy: new ConnectedPositioningStrategy(this._positionSettings)
      };
      this.chipAreaScrollOffset = 0;
      this._column = null;
      this.isKeyPressed = false;
      this.isComposing = false;
      this._cancelChipClick = false;
      this._value = null;
      /** switch to icon buttons when width is below 432px */
      this.NARROW_WIDTH_THRESHOLD = 432;
      this.$destroyer = new Subject();
    }
    onKeydownHandler(evt) {
      if (this.platform.isFilteringKeyCombo(evt)) {
        evt.preventDefault();
        evt.stopPropagation();
        this.close();
      }
    }
    ngAfterViewInit() {
      this._conditionsOverlaySettings.outlet = this.column.grid.outlet;
      this._operatorsOverlaySettings.outlet = this.column.grid.outlet;
      const selectedItem = this.expressionsList.find(expr => expr.isSelected === true);
      if (selectedItem) {
        this.expression = selectedItem.expression;
        this._value = this.expression.searchVal;
      }
      this.filteringService.grid.localeChange.pipe(takeUntil(this.$destroyer)).subscribe(() => {
        this.cdr.markForCheck();
      });
      requestAnimationFrame(() => this.focusEditElement());
    }
    get disabled() {
      return !(this.column.filteringExpressionsTree && this.column.filteringExpressionsTree.filteringOperands.length > 0);
    }
    get template() {
      if (this.column.dataType === GridColumnDataType.Date) {
        return this.defaultDateUI;
      }
      if (this.column.dataType === GridColumnDataType.Time) {
        return this.defaultTimeUI;
      }
      if (this.column.dataType === GridColumnDataType.DateTime) {
        return this.defaultDateTimeUI;
      }
      return this.defaultFilterUI;
    }
    get type() {
      switch (this.column.dataType) {
        case GridColumnDataType.String:
        case GridColumnDataType.Boolean:
          return 'text';
        case GridColumnDataType.Number:
        case GridColumnDataType.Currency:
          return 'number';
      }
    }
    get conditions() {
      return this.column.filters.conditionList();
    }
    get isUnaryCondition() {
      if (this.expression.condition) {
        return this.expression.condition.isUnary;
      } else {
        return true;
      }
    }
    get placeholder() {
      if (this.expression.condition && this.expression.condition.isUnary) {
        return this.filteringService.getChipLabel(this.expression);
      } else if (this.column.dataType === GridColumnDataType.Date) {
        return this.filteringService.grid.resourceStrings.igx_grid_filter_row_date_placeholder;
      } else if (this.column.dataType === GridColumnDataType.Boolean) {
        return this.filteringService.grid.resourceStrings.igx_grid_filter_row_boolean_placeholder;
      } else {
        return this.filteringService.grid.resourceStrings.igx_grid_filter_row_placeholder;
      }
    }
    /**
     * Event handler for keydown on the input group's prefix.
     */
    onPrefixKeyDown(event) {
      if (this.platform.isActivationKey(event) && this.dropDownConditions.collapsed) {
        this.toggleConditionsDropDown(this.inputGroupPrefix.nativeElement);
        event.stopImmediatePropagation();
      } else if (event.key === this.platform.KEYMAP.TAB && !this.dropDownConditions.collapsed) {
        this.toggleConditionsDropDown(this.inputGroupPrefix.nativeElement);
      }
    }
    /**
     * Event handler for keydown on the input.
     */
    onInputKeyDown(event) {
      this.isKeyPressed = true;
      event.stopPropagation();
      if (this.column.dataType === GridColumnDataType.Boolean) {
        if (this.platform.isActivationKey(event)) {
          this.inputGroupPrefix.nativeElement.focus();
          this.toggleConditionsDropDown(this.inputGroupPrefix.nativeElement);
          return;
        }
      }
      if (event.key === this.platform.KEYMAP.ENTER) {
        if (this.isComposing) {
          return;
        }
        this.commitInput();
      } else if (event.altKey && event.key === this.platform.KEYMAP.ARROW_DOWN) {
        this.inputGroupPrefix.nativeElement.focus();
        this.toggleConditionsDropDown(this.inputGroupPrefix.nativeElement);
      } else if (this.platform.isFilteringKeyCombo(event)) {
        event.preventDefault();
        this.close();
      }
    }
    /**
     * Event handler for keyup on the input.
     */
    onInputKeyUp() {
      this.isKeyPressed = false;
    }
    /**
     * Event handler for input on the input.
     */
    onInput(eventArgs) {
      if (!eventArgs) {
        return;
      }
      // The 'iskeyPressed' flag is needed for a case in IE, because the input event is fired on focus and for some reason,
      // when you have a japanese character as a placeholder, on init the value here is empty string .
      const target = eventArgs.target;
      if (this.column.dataType === GridColumnDataType.DateTime) {
        this.value = eventArgs;
        return;
      }
      if (this.platform.isEdge && target.type !== 'number' || this.isKeyPressed || target.value || target.checkValidity()) {
        this.value = target.value;
      }
    }
    /**
     * Event handler for compositionstart on the input.
     */
    onCompositionStart() {
      this.isComposing = true;
    }
    /**
     * Event handler for compositionend on the input.
     */
    onCompositionEnd() {
      this.isComposing = false;
    }
    /**
     * Event handler for input click event.
     */
    onInputClick() {
      if (this.column.dataType === GridColumnDataType.Boolean && this.dropDownConditions.collapsed) {
        this.inputGroupPrefix.nativeElement.focus();
        this.toggleConditionsDropDown(this.inputGroupPrefix.nativeElement);
      }
    }
    /**
     * Returns the filtering operation condition for a given value.
     */
    getCondition(value) {
      return this.column.filters.condition(value);
    }
    /**
     * Returns the translated condition name for a given value.
     */
    translateCondition(value) {
      return this.filteringService.grid.resourceStrings[`igx_grid_filter_${this.getCondition(value).name}`] || value;
    }
    /**
     * Returns the icon name of the current condition.
     */
    getIconName() {
      if (this.column.dataType === GridColumnDataType.Boolean && this.expression.condition === null) {
        return this.getCondition(this.conditions[0]).iconName;
      } else {
        return this.expression.condition.iconName;
      }
    }
    /**
     * Returns whether a given condition is selected in dropdown.
     */
    isConditionSelected(conditionName) {
      if (this.expression.condition) {
        return this.expression.condition.name === conditionName;
      } else {
        return false;
      }
    }
    /**
     * Clears the current filtering.
     */
    clearFiltering() {
      this.filteringService.clearFilter(this.column.field);
      this.resetExpression();
      if (this.input) {
        this.input.nativeElement.focus();
      }
      this.cdr.detectChanges();
      this.chipAreaScrollOffset = 0;
      this.transform(this.chipAreaScrollOffset);
    }
    /**
     * Commits the value of the input.
     */
    commitInput() {
      const selectedItem = this.expressionsList.filter(ex => ex.isSelected === true);
      selectedItem.forEach(e => e.isSelected = false);
      let indexToDeselect = -1;
      for (let index = 0; index < this.expressionsList.length; index++) {
        const expression = this.expressionsList[index].expression;
        if (expression.searchVal === null && !expression.condition.isUnary) {
          indexToDeselect = index;
        }
      }
      if (indexToDeselect !== -1) {
        this.removeExpression(indexToDeselect, this.expression);
      }
      this.resetExpression();
      this._value = this.expression.searchVal;
      this.scrollChipsWhenAddingExpression();
    }
    /**
     * Clears the value of the input.
     */
    clearInput(event) {
      event?.stopPropagation();
      this.value = null;
    }
    /**
     * Event handler for keydown on clear button.
     */
    onClearKeyDown(eventArgs) {
      if (this.platform.isActivationKey(eventArgs)) {
        eventArgs.preventDefault();
        this.clearInput();
        this.focusEditElement();
      }
    }
    /**
     * Event handler for click on clear button.
     */
    onClearClick() {
      this.clearInput();
      this.focusEditElement();
    }
    /**
     * Event handler for keydown on commit button.
     */
    onCommitKeyDown(eventArgs) {
      if (this.platform.isActivationKey(eventArgs)) {
        eventArgs.preventDefault();
        this.commitInput();
        this.focusEditElement();
      }
    }
    /**
     * Event handler for click on commit button.
     */
    onCommitClick(event) {
      event?.stopPropagation();
      this.commitInput();
      this.focusEditElement();
    }
    /**
     * Event handler for focusout on the input group.
     */
    onInputGroupFocusout() {
      if (!this.value && this.value !== 0 && this.expression.condition && !this.expression.condition.isUnary) {
        return;
      }
      requestAnimationFrame(() => {
        const focusedElement = this.column?.grid.document.activeElement;
        if (focusedElement.classList.contains('igx-chip__remove')) {
          return;
        }
        if (!(focusedElement && this.editorFocused(focusedElement)) && this.dropDownConditions.collapsed) {
          this.commitInput();
        }
      });
    }
    /**
     * Closes the filtering edit row.
     */
    close() {
      if (this.expressionsList.length === 1 && this.expressionsList[0].expression.searchVal === null && this.expressionsList[0].expression.condition.isUnary === false) {
        this.filteringService.getExpressions(this.column.field).pop();
        this.filter();
      } else {
        const condToRemove = this.expressionsList.filter(ex => ex.expression.searchVal === null && !ex.expression.condition.isUnary);
        if (condToRemove && condToRemove.length > 0) {
          condToRemove.forEach(c => this.filteringService.removeExpression(this.column.field, this.expressionsList.indexOf(c)));
          this.filter();
        }
      }
      this.filteringService.isFilterRowVisible = false;
      this.filteringService.updateFilteringCell(this.column);
      this.filteringService.filteredColumn = null;
      this.filteringService.selectedExpression = null;
      this.filteringService.grid.theadRow.nativeElement.focus();
      this.chipAreaScrollOffset = 0;
      this.transform(this.chipAreaScrollOffset);
    }
    /**
     *  Event handler for date picker's selection.
     */
    onDateSelected(value) {
      this.value = value;
    }
    /** @hidden @internal */
    inputGroupPrefixClick(event) {
      event.stopPropagation();
      event.currentTarget.focus();
      this.toggleConditionsDropDown(event.currentTarget);
    }
    /**
     * Opens the conditions dropdown.
     */
    toggleConditionsDropDown(target) {
      this._conditionsOverlaySettings.target = target;
      this._conditionsOverlaySettings.excludeFromOutsideClick = [target];
      this.dropDownConditions.toggle(this._conditionsOverlaySettings);
    }
    /**
     * Opens the logic operators dropdown.
     */
    toggleOperatorsDropDown(eventArgs, index) {
      this._operatorsOverlaySettings.target = eventArgs.target.parentElement;
      this._operatorsOverlaySettings.excludeFromOutsideClick = [eventArgs.target.parentElement];
      this.dropDownOperators.toArray()[index].toggle(this._operatorsOverlaySettings);
    }
    /**
     * Event handler for change event in conditions dropdown.
     */
    onConditionsChanged(eventArgs) {
      const value = eventArgs.newSelection.value;
      this.expression.condition = this.getCondition(value);
      if (this.expression.condition.isUnary) {
        // update grid's filtering on the next cycle to ensure the drop-down is closed
        // if the drop-down is not closed this event handler will be invoked multiple times
        requestAnimationFrame(() => this.unaryConditionChangedCallback());
      } else {
        requestAnimationFrame(() => this.conditionChangedCallback());
      }
      // Add requestAnimationFrame because of an issue in IE, where you are still able to write in the input,
      // if it has been focused and then set to readonly.
      requestAnimationFrame(() => this.focusEditElement());
    }
    onChipPointerdown(args, chip) {
      const activeElement = this.column?.grid.document.activeElement;
      this._cancelChipClick = chip.selected && activeElement && this.editorFocused(activeElement);
    }
    onChipClick(args, item) {
      if (this._cancelChipClick) {
        this._cancelChipClick = false;
        return;
      }
      this.expressionsList.forEach(ex => ex.isSelected = false);
      this.toggleChip(item);
    }
    toggleChip(item) {
      item.isSelected = !item.isSelected;
      if (item.isSelected) {
        this.expression = item.expression;
        this._value = this.expression.searchVal;
        this.focusEditElement();
      }
    }
    /**
     * Event handler for chip keydown event.
     */
    onChipKeyDown(eventArgs, item) {
      if (eventArgs.key === this.platform.KEYMAP.ENTER) {
        eventArgs.preventDefault();
        this.toggleChip(item);
      }
    }
    /**
     * Scrolls the first chip into view if the tab key is pressed on the left arrow.
     */
    onLeftArrowKeyDown(event) {
      if (event.key === this.platform.KEYMAP.TAB) {
        this.chipAreaScrollOffset = 0;
        this.transform(this.chipAreaScrollOffset);
      }
    }
    /**
     * Event handler for chip removed event.
     */
    onChipRemoved(eventArgs, item) {
      const indexToRemove = this.expressionsList.indexOf(item);
      this.removeExpression(indexToRemove, item.expression);
      this.scrollChipsOnRemove();
    }
    /**
     * Event handler for logic operator changed event.
     */
    onLogicOperatorChanged(eventArgs, expression) {
      if (eventArgs.oldSelection) {
        expression.afterOperator = eventArgs.newSelection.value;
        this.expressionsList[this.expressionsList.indexOf(expression) + 1].beforeOperator = expression.afterOperator;
        // update grid's filtering on the next cycle to ensure the drop-down is closed
        // if the drop-down is not closed this event handler will be invoked multiple times
        requestAnimationFrame(() => this.filter());
      }
    }
    /**
     * Scrolls the chips into the chip area when left or right arrows are pressed.
     */
    scrollChipsOnArrowPress(arrowPosition) {
      let count = 0;
      const chipAraeChildren = this.chipsArea.element.nativeElement.children;
      const containerRect = this.container.nativeElement.getBoundingClientRect();
      if (arrowPosition === 'right') {
        for (const chip of chipAraeChildren) {
          if (Math.ceil(chip.getBoundingClientRect().right) < Math.ceil(containerRect.right)) {
            count++;
          }
        }
        if (count < chipAraeChildren.length) {
          this.chipAreaScrollOffset -= Math.ceil(chipAraeChildren[count].getBoundingClientRect().right) - Math.ceil(containerRect.right) + 1;
          this.transform(this.chipAreaScrollOffset);
        }
      }
      if (arrowPosition === 'left') {
        for (const chip of chipAraeChildren) {
          if (Math.ceil(chip.getBoundingClientRect().left) < Math.ceil(containerRect.left)) {
            count++;
          }
        }
        if (count > 0) {
          this.chipAreaScrollOffset += Math.ceil(containerRect.left) - Math.ceil(chipAraeChildren[count - 1].getBoundingClientRect().left) + 1;
          this.transform(this.chipAreaScrollOffset);
        }
      }
    }
    /**
     * @hidden
     * Resets the chips area
     * @memberof IgxGridFilteringRowComponent
     */
    resetChipsArea() {
      this.chipAreaScrollOffset = 0;
      this.transform(this.chipAreaScrollOffset);
      this.showHideArrowButtons();
    }
    /** @hidden @internal */
    focusEditElement() {
      if (this.input) {
        this.input.nativeElement.focus();
      } else if (this.picker) {
        this.picker.getEditElement().focus();
      }
    }
    ngOnDestroy() {
      this.$destroyer.next();
    }
    showHideArrowButtons() {
      requestAnimationFrame(() => {
        if (this.filteringService.isFilterRowVisible) {
          const containerWidth = this.container.nativeElement.getBoundingClientRect().width;
          this.chipsAreaWidth = this.chipsArea.element.nativeElement.getBoundingClientRect().width;
          this.showArrows = this.chipsAreaWidth >= containerWidth && this.isColumnFiltered;
          // TODO: revise the cdr.detectChanges() usage here
          if (!this.cdr.destroyed) {
            this.cdr.detectChanges();
          }
        }
      });
    }
    addExpression(isSelected) {
      const exprUI = new ExpressionUI();
      exprUI.expression = this.expression;
      exprUI.beforeOperator = this.expressionsList.length > 0 ? FilteringLogic.And : null;
      exprUI.isSelected = isSelected;
      this.expressionsList.push(exprUI);
      const length = this.expressionsList.length;
      if (this.expressionsList[length - 2]) {
        this.expressionsList[length - 2].afterOperator = this.expressionsList[length - 1].beforeOperator;
      }
      this.showHideArrowButtons();
    }
    removeExpression(indexToRemove, expression) {
      if (indexToRemove === 0 && this.expressionsList.length === 1) {
        this.clearFiltering();
        return;
      }
      this.filteringService.removeExpression(this.column.field, indexToRemove);
      this.filter();
      if (this.expression === expression) {
        this.resetExpression();
      }
      this.showHideArrowButtons();
    }
    resetExpression(condition) {
      this.expression = {
        fieldName: this.column.field,
        condition: null,
        conditionName: null,
        searchVal: null,
        ignoreCase: this.column.filteringIgnoreCase
      };
      if (this.column.dataType !== GridColumnDataType.Boolean) {
        this.expression.condition = this.getCondition(condition ?? this.conditions[0]);
      }
      if (this.column.dataType === GridColumnDataType.Date && this.input) {
        this.input.nativeElement.value = null;
      }
      this.showHideArrowButtons();
    }
    scrollChipsWhenAddingExpression() {
      const chipAraeChildren = this.chipsArea.element.nativeElement.children;
      if (!chipAraeChildren || chipAraeChildren.length === 0) {
        return;
      }
      const chipsContainerWidth = this.container.nativeElement.offsetWidth;
      const chipsAreaWidth = this.chipsArea.element.nativeElement.offsetWidth;
      if (chipsAreaWidth > chipsContainerWidth) {
        this.chipAreaScrollOffset = chipsContainerWidth - chipsAreaWidth;
        this.transform(this.chipAreaScrollOffset);
      }
    }
    transform(offset) {
      requestAnimationFrame(() => {
        this.chipsArea.element.nativeElement.style.transform = `translate(${offset}px)`;
      });
    }
    scrollChipsOnRemove() {
      let count = 0;
      const chipAraeChildren = this.chipsArea.element.nativeElement.children;
      const containerRect = this.container.nativeElement.getBoundingClientRect();
      for (const chip of chipAraeChildren) {
        if (Math.ceil(chip.getBoundingClientRect().right) < Math.ceil(containerRect.left)) {
          count++;
        }
      }
      if (count <= 2) {
        this.chipAreaScrollOffset = 0;
      } else {
        const dif = chipAraeChildren[count].id === 'chip' ? count - 2 : count - 1;
        this.chipAreaScrollOffset += Math.ceil(containerRect.left) - Math.ceil(chipAraeChildren[dif].getBoundingClientRect().left) + 1;
      }
      this.transform(this.chipAreaScrollOffset);
    }
    conditionChangedCallback() {
      if (!!this.expression.searchVal || this.expression.searchVal === 0) {
        this.filter();
      } else if (this.value) {
        this.value = null;
      }
    }
    unaryConditionChangedCallback() {
      if (this.value) {
        this.value = null;
      }
      if (this.expressionsList.find(item => item.expression === this.expression) === undefined) {
        this.addExpression(true);
      }
      this.filter();
    }
    filter() {
      this.filteringService.filterInternal(this.column.field);
    }
    editorFocused(activeElement) {
      // if the first check is false and the second is undefined this will return undefined
      // make sure it always returns boolean
      return !!(this.inputGroup && this.inputGroup.nativeElement.contains(activeElement) || this.picker && this.picker.isFocused);
    }
    get isColumnFiltered() {
      return this.column.filteringExpressionsTree && this.column.filteringExpressionsTree.filteringOperands.length > 0;
    }
    get isNarrowWidth() {
      return this.nativeElement.offsetWidth < this.NARROW_WIDTH_THRESHOLD;
    }
    static {
      this.ɵfac = function IgxGridFilteringRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridFilteringRowComponent)(i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridFilteringRowComponent,
        selectors: [["igx-grid-filtering-row"]],
        viewQuery: function IgxGridFilteringRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c166, 7, TemplateRef);
            i0.ɵɵviewQuery(_c167, 7, TemplateRef);
            i0.ɵɵviewQuery(_c168, 7, TemplateRef);
            i0.ɵɵviewQuery(_c169, 7, TemplateRef);
            i0.ɵɵviewQuery(_c76, 5, ElementRef);
            i0.ɵɵviewQuery(_c170, 7, IgxDropDownComponent);
            i0.ɵɵviewQuery(_c159, 7, IgxChipsAreaComponent);
            i0.ɵɵviewQuery(_c55, 5, ElementRef);
            i0.ɵɵviewQuery(_c95, 5);
            i0.ɵɵviewQuery(_c171, 5, ElementRef);
            i0.ɵɵviewQuery(_c6, 7);
            i0.ɵɵviewQuery(_c172, 5);
            i0.ɵɵviewQuery(_c173, 7);
            i0.ɵɵviewQuery(_c174, 5, IgxDropDownComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultFilterUI = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultDateUI = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTimeUI = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultDateTimeUI = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownConditions = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipsArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputGroupPrefix = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.operand = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownOperators = _t);
          }
        },
        hostVars: 2,
        hostBindings: function IgxGridFilteringRowComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxGridFilteringRowComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeydownHandler($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid__filtering-row", ctx.defaultCSSClass);
          }
        },
        inputs: {
          column: "column",
          value: "value"
        },
        decls: 26,
        vars: 12,
        consts: [["inputGroupConditions", ""], ["defaultFilterUI", ""], ["defaultDateUI", ""], ["defaultTimeUI", ""], ["defaultDateTimeUI", ""], ["container", ""], ["chipsArea", ""], ["buttonsContainer", ""], ["inputGroup", ""], ["inputGroupPrefix", ""], ["input", ""], ["picker", ""], ["chip", ""], ["operators", ""], ["closeButton", ""], [3, "selectionChanging", "height"], [3, "value", "selected"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["igxIconButton", "flat", "type", "button", 1, "igx-grid__filtering-row-scroll-start"], [1, "igx-grid__filtering-row-main"], ["tabindex", "0"], ["igxIconButton", "flat", "type", "button", 1, "igx-grid__filtering-row-scroll-end"], [3, "ngClass"], [1, "igx-grid__filtering-dropdown-items"], ["family", "default", 3, "name"], [1, "igx-grid__filtering-dropdown-text"], ["type", "box", 3, "focusout"], ["tabindex", "0", 3, "click", "keydown", "igxDropDownItemNavigation"], ["igxInput", "", "tabindex", "0", "autocomplete", "off", 3, "input", "click", "compositionstart", "compositionend", "keydown", "keyup", "placeholder", "value", "type", "readonly"], ["tabindex", "0", "family", "default", "name", "confirm", 3, "keydown", "click"], ["tabindex", "0", "family", "default", "name", "input_clear", 3, "keydown", "click"], ["type", "box", 3, "valueChange", "click", "keydown", "focusout", "closed", "value", "readOnly", "outlet", "locale", "displayFormat", "formatter", "placeholder", "weekStart"], ["type", "box", 3, "valueChange", "closed", "focusout", "keydown", "click", "value", "inputFormat", "displayFormat", "locale", "formatter", "outlet", "readOnly", "placeholder"], ["igxInput", "", "tabindex", "0", "defaultFormatType", "dateTime", 3, "valueChange", "click", "keydown", "keyup", "placeholder", "locale", "displayFormat", "igxDateTimeEditor", "value", "readonly"], ["igxIconButton", "flat", "type", "button", 1, "igx-grid__filtering-row-scroll-start", 3, "keydown", "click"], ["family", "default", "name", "prev"], ["id", "chip", 3, "pointerdown", "click", "keydown", "remove", "selectable", "selected", "removable"], ["igxPrefix", "", "family", "default", 3, "name"], ["id", "operand"], ["igxButton", "", "type", "button", 3, "click", "igxDropDownItemNavigation"], ["family", "default", "name", "expand_more"], [3, "selectionChanging"], ["igxIconButton", "flat", "type", "button", 1, "igx-grid__filtering-row-scroll-end", 3, "click"], ["family", "default", "name", "next"], ["igxButton", "flat", "type", "button", "igxRipple", "", 3, "click", "disabled", "tabindex"], ["family", "default", "name", "refresh"], ["igxButton", "flat", "type", "button", "igxRipple", "", 3, "click"], ["family", "default", "name", "close"], ["igxIconButton", "flat", "type", "button", "igxRipple", "", 3, "click", "disabled", "tabindex"], ["igxIconButton", "flat", "type", "button", "igxRipple", "", 3, "click"]],
        template: function IgxGridFilteringRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-drop-down", 15, 0);
            i0.ɵɵlistener("selectionChanging", function IgxGridFilteringRowComponent_Template_igx_drop_down_selectionChanging_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConditionsChanged($event));
            });
            i0.ɵɵrepeaterCreate(2, IgxGridFilteringRowComponent_For_3_Template, 5, 4, "igx-drop-down-item", 16, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, IgxGridFilteringRowComponent_ng_template_4_Template, 8, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, IgxGridFilteringRowComponent_ng_template_6_Template, 8, 11, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, IgxGridFilteringRowComponent_ng_template_8_Template, 8, 13, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, IgxGridFilteringRowComponent_ng_template_10_Template, 8, 11, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(12, IgxGridFilteringRowComponent_ng_container_12_Template, 1, 0, "ng-container", 17)(13, IgxGridFilteringRowComponent_Conditional_13_Template, 2, 0, "button", 18);
            i0.ɵɵelementStart(14, "div", 19, 5)(16, "div")(17, "igx-chips-area", null, 6);
            i0.ɵɵrepeaterCreate(19, IgxGridFilteringRowComponent_For_20_Template, 7, 8, "ng-container", 20, _forTrack8);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(21, IgxGridFilteringRowComponent_Conditional_21_Template, 2, 0, "button", 21);
            i0.ɵɵelementStart(22, "div", 22, 7);
            i0.ɵɵtemplate(24, IgxGridFilteringRowComponent_Conditional_24_Template, 9, 8)(25, IgxGridFilteringRowComponent_Conditional_25_Template, 5, 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("--ig-size", ctx.filteringElementsSize);
            i0.ɵɵproperty("height", "200px");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.conditions);
            i0.ɵɵadvance(10);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c25, ctx));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showArrows ? 13 : -1);
            i0.ɵɵadvance(6);
            i0.ɵɵrepeater(ctx.expressionsList);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showArrows ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.isNarrowWidth ? "igx-grid__filtering-row-editing-buttons--small" : "igx-grid__filtering-row-editing-buttons");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.isNarrowWidth ? 24 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isNarrowWidth ? 25 : -1);
          }
        },
        dependencies: [IgxDropDownComponent, IgxDropDownItemComponent, IgxChipsAreaComponent, IgxChipComponent, IgxIconComponent, IgxInputGroupComponent, IgxPrefixDirective, IgxDropDownItemNavigationDirective, IgxInputDirective, IgxSuffixDirective, IgxDatePickerComponent, IgxPickerToggleComponent, IgxPickerClearComponent, IgxTimePickerComponent, IgxDateTimeEditorDirective, NgTemplateOutlet, IgxButtonDirective, NgClass, IgxRippleDirective, IgxIconButtonDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridFilteringRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BaseRow {
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    return this.index + this.grid.page * this.grid.perPage;
  }
  /**
   * Gets the row key.
   * A row in the grid is identified either by:
   * - primaryKey data value,
   * - the whole rowData, if the primaryKey is omitted.
   *
   * ```typescript
   * let rowKey = row.key;
   * ```
   */
  get key() {
    const data = this._data ?? this.grid.dataView[this.index];
    const primaryKey = this.grid.primaryKey;
    return primaryKey ? data[primaryKey] : data;
  }
  /**
   * Gets if this represents add row UI
   *
   * ```typescript
   * let isAddRow = row.addRowUI;
   * ```
   */
  get addRowUI() {
    return !!this.grid.crudService.row && this.grid.crudService.row.getClassName() === IgxAddRow.name && this.grid.crudService.row.id === this.key;
  }
  /** Gets the validation status and errors, if any.
  * ```typescript
  * let validation = row.validation;
  * let errors = validation.errors;
  * ```
  */
  get validation() {
    const formGroup = this.grid.validation.getFormGroup(this.key);
    return {
      status: formGroup?.status || 'VALID',
      errors: formGroup?.errors
    };
  }
  /**
   * The data record that populates the row.
   *
   * ```typescript
   * let rowData = row.data;
   * ```
   */
  get data() {
    if (this.inEditMode) {
      return mergeWith(this.grid.dataCloneStrategy.clone(this._data ?? this.grid.dataView[this.index]), this.grid.transactions.getAggregatedValue(this.key, false), (objValue, srcValue) => {
        if (Array.isArray(srcValue)) {
          return objValue = srcValue;
        }
      });
    }
    return this._data ?? this.grid.dataView[this.index];
  }
  /**
   * Returns if the row is currently in edit mode.
   */
  get inEditMode() {
    if (this.grid.rowEditable) {
      const editRowState = this.grid.crudService.row;
      return editRowState && editRowState.id === this.key || false;
    } else {
      return false;
    }
  }
  /**
   * Gets whether the row is pinned.
   * Default value is `false`.
   * ```typescript
   * const isPinned = row.pinned;
   * ```
   */
  get pinned() {
    return this.grid.isRecordPinned(this.data);
  }
  /**
   * Sets whether the row is pinned.
   * Default value is `false`.
   * ```typescript
   * row.pinned = !row.pinned;
   * ```
   */
  set pinned(val) {
    if (val) {
      this.pin();
    } else {
      this.unpin();
    }
  }
  /**
   * Gets the row expanded/collapsed state.
   *
   * ```typescript
   * const isExpanded = row.expanded;
   * ```
   */
  get expanded() {
    return this.grid.gridAPI.get_row_expansion_state(this.data);
  }
  /**
   * Expands/collapses the row.
   *
   * ```typescript
   * row.expanded = true;
   * ```
   */
  set expanded(val) {
    this.grid.gridAPI.set_row_expansion_state(this.key, val);
  }
  /**
   * Gets whether the row is selected.
   * Default value is `false`.
   * ```typescript
   * row.selected = true;
   * ```
   */
  get selected() {
    return this.grid.selectionService.isRowSelected(this.key);
  }
  /**
   * Sets whether the row is selected.
   * Default value is `false`.
   * ```typescript
   * row.selected = !row.selected;
   * ```
   */
  set selected(val) {
    if (val) {
      this.grid.selectionService.selectRowsWithNoEvent([this.key]);
    } else {
      this.grid.selectionService.deselectRowsWithNoEvent([this.key]);
    }
    this.grid.cdr.markForCheck();
  }
  /**
   * Returns if the row is in delete state.
   */
  get deleted() {
    return this.grid.gridAPI.row_deleted_transaction(this.key);
  }
  /**
   * Returns if the row has child rows. Always return false for IgxGridRow.
   */
  get hasChildren() {
    return false;
  }
  get disabled() {
    return this.grid.isGhostRecord(this.data);
  }
  /**
   * Gets the rendered cells in the row component.
   */
  get cells() {
    const res = [];
    this.grid.columns.forEach(col => {
      const cell = new IgxGridCell(this.grid, this.index, col);
      res.push(cell);
    });
    return res;
  }
  /**
   * Pins the specified row.
   * This method emits `onRowPinning` event.
   *
   * ```typescript
   * // pin the selected row from the grid
   * this.grid.selectedRows[0].pin();
   * ```
   */
  pin() {
    return this.grid.pinRow(this.key, this.index);
  }
  /**
   * Unpins the specified row.
   * This method emits `onRowPinning` event.
   *
   * ```typescript
   * // unpin the selected row from the grid
   * this.grid.selectedRows[0].unpin();
   * ```
   */
  unpin() {
    return this.grid.unpinRow(this.key);
  }
  /**
   * Updates the specified row object and the data source record with the passed value.
   *
   * ```typescript
   * // update the second selected row's value
   * let newValue = "Apple";
   * this.grid.selectedRows[1].update(newValue);
   * ```
   */
  update(value) {
    const crudService = this.grid.crudService;
    if (crudService.cellInEditMode && crudService.cell.id.rowID === this.key) {
      this.grid.transactions.endPending(false);
    }
    const row = new IgxEditRow(this.key, this.index, this.data, this.grid);
    this.grid.gridAPI.update_row(row, value);
    this.grid.notifyChanges();
  }
  /**
   * Removes the specified row from the grid's data source.
   * This method emits `onRowDeleted` event.
   *
   * ```typescript
   * // delete the third selected row from the grid
   * this.grid.selectedRows[2].delete();
   * ```
   */
  delete() {
    this.grid.deleteRowById(this.key);
  }
}
class IgxGridRow extends BaseRow {
  /**
   * @hidden
   */
  constructor(grid, index, data) {
    super();
    this.grid = grid;
    this.index = index;
    this._data = data && data.addRow && data.recordRef ? data.recordRef : data;
  }
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    if (this.grid.paginator) {
      const precedingDetailRows = [];
      const precedingGroupRows = [];
      const firstRow = this.grid.dataView[0];
      const hasDetailRows = this.grid.expansionStates.size;
      const hasGroupedRows = this.grid.groupingExpressions.length;
      let precedingSummaryRows = 0;
      const firstRowInd = this.grid.groupingFlatResult.indexOf(firstRow);
      // from groupingFlatResult, resolve two other collections:
      // precedingGroupedRows -> use it to resolve summaryRow for each group in previous pages
      // precedingDetailRows -> ise it to resolve the detail row for each expanded grid row in previous pages
      if (hasDetailRows || hasGroupedRows) {
        this.grid.groupingFlatResult.forEach((r, ind) => {
          const rowID = this.grid.primaryKey ? r[this.grid.primaryKey] : r;
          if (hasGroupedRows && ind < firstRowInd && this.grid.isGroupByRecord(r)) {
            precedingGroupRows.push(r);
          }
          if (this.grid.expansionStates.get(rowID) && ind < firstRowInd && !this.grid.isGroupByRecord(r)) {
            precedingDetailRows.push(r);
          }
        });
      }
      if (this.grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly) {
        // if firstRow is a child of the last item in precedingGroupRows,
        // then summaryRow for this given groupedRecord is rendered after firstRow,
        // i.e. need to decrease firstRowInd to account for the above.
        precedingSummaryRows = precedingGroupRows.filter(gr => this.grid.isExpandedGroup(gr)).length;
        if (this.grid.summaryPosition === GridSummaryPosition.bottom && precedingGroupRows.length && precedingGroupRows[precedingGroupRows.length - 1].records.indexOf(firstRow) > -1) {
          precedingSummaryRows += -1;
        }
      }
      return precedingDetailRows.length + precedingSummaryRows + firstRowInd + this.index;
    } else {
      return this.index;
    }
  }
  /**
   * Returns the parent row, if grid is grouped.
   */
  get parent() {
    let parent;
    if (!this.grid.groupingExpressions.length) {
      return undefined;
    }
    let i = this.index - 1;
    while (i >= 0 && !parent) {
      const rec = this.grid.dataView[i];
      if (this.grid.isGroupByRecord(rec)) {
        parent = new IgxGroupByRow(this.grid, i, rec);
      }
      i--;
    }
    return parent;
  }
}
class IgxTreeGridRow extends BaseRow {
  /**
   * @hidden
   */
  constructor(grid, index, data, _treeRow) {
    super();
    this.grid = grid;
    this.index = index;
    this._treeRow = _treeRow;
    this._data = data && data.addRow && data.recordRef ? data.recordRef : data;
  }
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    if (this.grid.hasSummarizedColumns && this.grid.page > 0) {
      if (this.grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly) {
        const firstRowIndex = this.grid.processedExpandedFlatData.indexOf(this.grid.dataView[0].data);
        // firstRowIndex is based on data result after all pipes triggered, excluding summary pipe
        const precedingSummaryRows = this.grid.summaryPosition === GridSummaryPosition.bottom ? this.grid.rootRecords.indexOf(this.getRootParent(this.grid.dataView[0])) : this.grid.rootRecords.indexOf(this.getRootParent(this.grid.dataView[0])) + 1;
        // there is a summary row for each root record, so we calculate how many root records are rendered before the current row
        return firstRowIndex + precedingSummaryRows + this.index;
      }
    }
    return this.index + this.grid.page * this.grid.perPage;
  }
  /**
   *  The data passed to the row component.
   *
   * ```typescript
   * let selectedRowData = this.grid.selectedRows[0].data;
   * ```
   */
  get data() {
    if (this.inEditMode) {
      return mergeWith(this.grid.dataCloneStrategy.clone(this._data ?? this.grid.dataView[this.index]), this.grid.transactions.getAggregatedValue(this.key, false), (objValue, srcValue) => {
        if (Array.isArray(srcValue)) {
          return objValue = srcValue;
        }
      });
    }
    const rec = this.grid.dataView[this.index];
    return this._data ? this._data : this.grid.isTreeRow(rec) ? rec.data : rec;
  }
  /**
   * Returns the child rows.
   */
  get children() {
    const children = [];
    if (this.treeRow.expanded) {
      this.treeRow.children.forEach((rec, i) => {
        const row = new IgxTreeGridRow(this.grid, this.index + 1 + i, rec.data);
        children.push(row);
      });
    }
    return children;
  }
  /**
   * Returns the parent row.
   */
  get parent() {
    const row = this.grid.getRowByKey(this.treeRow.parent?.key);
    return row;
  }
  /**
   * Returns true if child rows exist. Always return false for IgxGridRow.
   */
  get hasChildren() {
    if (this.treeRow.children) {
      return this.treeRow.children.length > 0;
    } else {
      return false;
    }
  }
  /**
   * The `ITreeGridRecord` with metadata about the row in the context of the tree grid.
   *
   * ```typescript
   * const rowParent = this.treeGrid.getRowByKey(1).treeRow.parent;
   * ```
   */
  get treeRow() {
    return this._treeRow ?? this.grid.records.get(this.key);
  }
  /**
   * Gets whether the row is pinned.
   *
   * ```typescript
   * let isPinned = row.pinned;
   * ```
   */
  get pinned() {
    return this.grid.isRecordPinned(this);
  }
  /**
   * Sets whether the row is pinned.
   * Default value is `false`.
   * ```typescript
   * row.pinned = !row.pinned;
   * ```
   */
  set pinned(val) {
    if (val) {
      this.pin();
    } else {
      this.unpin();
    }
  }
  /**
   * Gets whether the row is expanded.
   *
   * ```typescript
   * let esExpanded = row.expanded;
   * ```
   */
  get expanded() {
    return this.grid.gridAPI.get_row_expansion_state(this.treeRow);
  }
  /**
   * Expands/collapses the row.
   *
   * ```typescript
   * row.expanded = true;
   * ```
   */
  set expanded(val) {
    this.grid.gridAPI.set_row_expansion_state(this.key, val);
  }
  get disabled() {
    // TODO cell
    return this.grid.isGhostRecord(this.data) ? this.treeRow.isFilteredOutParent === undefined : false;
  }
  getRootParent(row) {
    while (row.parent) {
      row = row.parent;
    }
    return row;
  }
}
class IgxHierarchicalGridRow extends BaseRow {
  /**
   * @hidden
   */
  constructor(grid, index, data) {
    super();
    this.grid = grid;
    this.index = index;
    this._data = data && data.addRow && data.recordRef ? data.recordRef : data;
  }
  /**
   * Returns true if row islands exist.
   */
  get hasChildren() {
    return !!this.grid.childLayoutKeys.length;
  }
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    const firstRowInd = this.grid.filteredSortedData.indexOf(this.grid.dataView[0]);
    const expandedRows = this.grid.filteredSortedData.filter((rec, ind) => {
      const rowID = this.grid.primaryKey ? rec[this.grid.primaryKey] : rec;
      return this.grid.expansionStates.get(rowID) && ind < firstRowInd;
    });
    return firstRowInd + expandedRows.length + this.index;
  }
  /**
   * Gets the rendered cells in the row component.
   */
  get cells() {
    const res = [];
    this.grid.columns.forEach(col => {
      const cell = new IgxGridCell(this.grid, this.index, col);
      res.push(cell);
    });
    return res;
  }
}
class IgxGroupByRow {
  /**
   * The IGroupByRecord object, representing the group record, if the row is a GroupByRow.
   */
  get groupRow() {
    return this._groupRow ? this._groupRow : this.grid.dataView[this.index];
  }
  /**
   * Returns the child rows.
   */
  get children() {
    const children = [];
    this.groupRow.records.forEach((rec, i) => {
      const row = new IgxGridRow(this.grid, this.index + 1 + i, rec);
      children.push(row);
    });
    return children;
  }
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    if (this.grid.page) {
      const precedingDetailRows = [];
      const precedingGroupRows = [];
      const firstRow = this.grid.dataView[0];
      const hasDetailRows = this.grid.expansionStates.size;
      const hasGroupedRows = this.grid.groupingExpressions.length;
      let precedingSummaryRows = 0;
      const firstRowInd = this.grid.groupingFlatResult.indexOf(firstRow);
      // from groupingFlatResult, resolve two other collections:
      // precedingGroupedRows -> use it to resolve summaryRow for each group in previous pages
      // precedingDetailRows -> ise it to resolve the detail row for each expanded grid row in previous pages
      if (hasDetailRows || hasGroupedRows) {
        this.grid.groupingFlatResult.forEach((r, ind) => {
          const rowID = this.grid.primaryKey ? r[this.grid.primaryKey] : r;
          if (hasGroupedRows && ind < firstRowInd && this.grid.isGroupByRecord(r)) {
            precedingGroupRows.push(r);
          }
          if (this.grid.expansionStates.get(rowID) && ind < firstRowInd && !this.grid.isGroupByRecord(r)) {
            precedingDetailRows.push(r);
          }
        });
      }
      if (this.grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly) {
        // if firstRow is a child of the last item in precedingGroupRows,
        // then summaryRow for this given groupedRecord is rendered after firstRow,
        // i.e. need to decrease firstRowInd to account for the above.
        precedingSummaryRows = precedingGroupRows.filter(gr => this.grid.isExpandedGroup(gr)).length;
        if (this.grid.summaryPosition === GridSummaryPosition.bottom && precedingGroupRows.length && precedingGroupRows[precedingGroupRows.length - 1].records.indexOf(firstRow) > -1) {
          precedingSummaryRows += -1;
        }
      }
      return precedingDetailRows.length + precedingSummaryRows + firstRowInd + this.index;
    } else {
      return this.index;
    }
  }
  /**
   * @hidden
   */
  constructor(grid, index, _groupRow) {
    this._groupRow = _groupRow;
    this.grid = grid;
    this.index = index;
    this.isGroupByRow = true;
  }
  /**
   * Gets whether the row is selected.
   * Default value is `false`.
   * ```typescript
   * row.selected = true;
   * ```
   */
  get selected() {
    return this.children.every(row => row.selected);
  }
  /**
   * Sets whether the row is selected.
   * Default value is `false`.
   * ```typescript
   * row.selected = !row.selected;
   * ```
   */
  set selected(val) {
    if (val) {
      this.children.forEach(row => {
        this.grid.selectionService.selectRowsWithNoEvent([row.key]);
      });
    } else {
      this.children.forEach(row => {
        this.grid.selectionService.deselectRowsWithNoEvent([row.key]);
      });
    }
    this.grid.cdr.markForCheck();
  }
  /**
   * Gets/sets whether the group row is expanded.
   * ```typescript
   * const groupRowExpanded = groupRow.expanded;
   * ```
   */
  get expanded() {
    return this.grid.isExpandedGroup(this.groupRow);
  }
  set expanded(value) {
    this.gridAPI.set_grouprow_expansion_state(this.groupRow, value);
  }
  isActive() {
    return this.grid.navigation.activeNode ? this.grid.navigation.activeNode.row === this.index : false;
  }
  /**
   * Toggles the group row expanded/collapsed state.
   * ```typescript
   * groupRow.toggle()
   * ```
   */
  toggle() {
    this.grid.toggleGroup(this.groupRow);
  }
  get gridAPI() {
    return this.grid.gridAPI;
  }
}
class IgxSummaryRow {
  /**
   * The IGroupByRecord object, representing the group record, if the row is a GroupByRow.
   */
  get summaries() {
    return this._summaries ? this._summaries : this.grid.dataView[this.index].summaries;
  }
  /**
   * Returns the view index calculated per the grid page.
   */
  get viewIndex() {
    if (this.grid.hasSummarizedColumns && this.grid.page > 0) {
      if (this.grid.type === 'flat') {
        if (this.grid.page) {
          const precedingDetailRows = [];
          const precedingGroupRows = [];
          const firstRow = this.grid.dataView[0];
          const hasDetailRows = this.grid.expansionStates.size;
          const hasGroupedRows = this.grid.groupingExpressions.length;
          let precedingSummaryRows = 0;
          const firstRowInd = this.grid.groupingFlatResult.indexOf(firstRow);
          // from groupingFlatResult, resolve two other collections:
          // precedingGroupedRows -> use it to resolve summaryRow for each group in previous pages
          // precedingDetailRows -> ise it to resolve the detail row for each expanded grid row in previous pages
          if (hasDetailRows || hasGroupedRows) {
            this.grid.groupingFlatResult.forEach((r, ind) => {
              const rowID = this.grid.primaryKey ? r[this.grid.primaryKey] : r;
              if (hasGroupedRows && ind < firstRowInd && this.grid.isGroupByRecord(r)) {
                precedingGroupRows.push(r);
              }
              if (this.grid.expansionStates.get(rowID) && ind < firstRowInd && !this.grid.isGroupByRecord(r)) {
                precedingDetailRows.push(r);
              }
            });
          }
          if (this.grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly) {
            // if firstRow is a child of the last item in precedingGroupRows,
            // then summaryRow for this given groupedRecord is rendered after firstRow,
            // i.e. need to decrease firstRowInd to account for the above.
            precedingSummaryRows = precedingGroupRows.filter(gr => this.grid.isExpandedGroup(gr)).length;
            if (this.grid.summaryPosition === GridSummaryPosition.bottom && precedingGroupRows.length && precedingGroupRows[precedingGroupRows.length - 1].records.indexOf(firstRow) > -1) {
              precedingSummaryRows += -1;
            }
          }
          return precedingDetailRows.length + precedingSummaryRows + firstRowInd + this.index;
        } else {
          return this.index;
        }
      } else if (this.grid.type === 'tree') {
        if (this.grid.summaryCalculationMode !== GridSummaryCalculationMode.rootLevelOnly) {
          const firstRowIndex = this.grid.processedExpandedFlatData.indexOf(this.grid.dataView[0].data);
          const precedingSummaryRows = this.grid.summaryPosition === GridSummaryPosition.bottom ? this.grid.rootRecords.indexOf(this.getRootParent(this.grid.dataView[0])) : this.grid.rootRecords.indexOf(this.getRootParent(this.grid.dataView[0])) + 1;
          return firstRowIndex + precedingSummaryRows + this.index;
        }
      }
    }
    return this.index + this.grid.page * this.grid.perPage;
  }
  /**
   * @hidden
   */
  constructor(grid, index, _summaries) {
    this._summaries = _summaries;
    this.grid = grid;
    this.index = index;
    this.isSummaryRow = true;
  }
  getRootParent(row) {
    while (row.parent) {
      row = row.parent;
    }
    return row;
  }
}

/**
 * @hidden
 * @internal
 */
let IgxGridCellStyleClassesPipe = /*#__PURE__*/(() => {
  class IgxGridCellStyleClassesPipe {
    transform(cssClasses, _, data, field, index, __) {
      if (!cssClasses) {
        return '';
      }
      const result = [];
      for (const cssClass of Object.keys(cssClasses)) {
        const callbackOrValue = cssClasses[cssClass];
        const apply = typeof callbackOrValue === 'function' ? callbackOrValue(data, field, resolveNestedPath(data, field), index) : callbackOrValue;
        if (apply) {
          result.push(cssClass);
        }
      }
      return result.join(' ');
    }
    static {
      this.ɵfac = function IgxGridCellStyleClassesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridCellStyleClassesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxCellStyleClasses",
        type: IgxGridCellStyleClassesPipe,
        pure: true
      });
    }
  }
  return IgxGridCellStyleClassesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridCellStylesPipe = /*#__PURE__*/(() => {
  class IgxGridCellStylesPipe {
    transform(styles, _, data, field, index, __) {
      const css = {};
      if (!styles) {
        return css;
      }
      for (const prop of Object.keys(styles)) {
        const res = styles[prop];
        css[prop] = typeof res === 'function' ? res(data, field, resolveNestedPath(data, field), index) : res;
      }
      return css;
    }
    static {
      this.ɵfac = function IgxGridCellStylesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridCellStylesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxCellStyles",
        type: IgxGridCellStylesPipe,
        pure: true
      });
    }
  }
  return IgxGridCellStylesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridCellImageAltPipe = /*#__PURE__*/(() => {
  class IgxGridCellImageAltPipe {
    transform(value) {
      if (value) {
        const val = value.split('/');
        const imagename = val[val.length - 1].split('.');
        return imagename.length ? imagename[0] : '';
      }
      return value;
    }
    static {
      this.ɵfac = function IgxGridCellImageAltPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridCellImageAltPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxCellImageAlt",
        type: IgxGridCellImageAltPipe,
        pure: true
      });
    }
  }
  return IgxGridCellImageAltPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridRowClassesPipe = /*#__PURE__*/(() => {
  class IgxGridRowClassesPipe {
    constructor(grid) {
      this.grid = grid;
      this.row = new IgxGridRow(this.grid, -1, {});
    }
    transform(cssClasses, row, editMode, selected, dirty, deleted, dragging, index, mrl, filteredOut, _rowData, _) {
      const result = new Set(['igx-grid__tr', index % 2 ? 'igx-grid__tr--even' : 'igx-grid__tr--odd']);
      const mapping = [[selected, 'igx-grid__tr--selected'], [editMode, 'igx-grid__tr--edit'], [dirty, 'igx-grid__tr--edited'], [deleted, 'igx-grid__tr--deleted'], [dragging, 'igx-grid__tr--drag'], [mrl, 'igx-grid__tr--mrl'],
      // Tree grid only
      [filteredOut, 'igx-grid__tr--filtered']];
      for (const [state, _class] of mapping) {
        if (state) {
          result.add(_class);
        }
      }
      for (const cssClass of Object.keys(cssClasses ?? {})) {
        const callbackOrValue = cssClasses[cssClass];
        this.row.index = index;
        this.row._data = row.data;
        const apply = typeof callbackOrValue === 'function' ? callbackOrValue(this.row) : callbackOrValue;
        if (apply) {
          result.add(cssClass);
        }
      }
      return result;
    }
    static {
      this.ɵfac = function IgxGridRowClassesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridRowClassesPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxGridRowClasses",
        type: IgxGridRowClassesPipe,
        pure: true
      });
    }
  }
  return IgxGridRowClassesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridRowStylesPipe = /*#__PURE__*/(() => {
  class IgxGridRowStylesPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(styles, rowData, index, __) {
      const css = {};
      if (!styles) {
        return css;
      }
      for (const prop of Object.keys(styles)) {
        const cb = styles[prop];
        const data = this.grid.isTreeRow && this.grid.isTreeRow(rowData) ? rowData.data : rowData;
        const row = new IgxGridRow(this.grid, index, data);
        css[prop] = typeof cb === 'function' ? cb(row) : cb;
      }
      return css;
    }
    static {
      this.ɵfac = function IgxGridRowStylesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridRowStylesPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxGridRowStyles",
        type: IgxGridRowStylesPipe,
        pure: true
      });
    }
  }
  return IgxGridRowStylesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridNotGroupedPipe = /*#__PURE__*/(() => {
  class IgxGridNotGroupedPipe {
    transform(value) {
      return value.filter(item => !item.columnGroup);
    }
    static {
      this.ɵfac = function IgxGridNotGroupedPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridNotGroupedPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxNotGrouped",
        type: IgxGridNotGroupedPipe,
        pure: true
      });
    }
  }
  return IgxGridNotGroupedPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridTopLevelColumns = /*#__PURE__*/(() => {
  class IgxGridTopLevelColumns {
    transform(value) {
      return value.filter(item => item.level === 0);
    }
    static {
      this.ɵfac = function IgxGridTopLevelColumns_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridTopLevelColumns)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxTopLevel",
        type: IgxGridTopLevelColumns,
        pure: true
      });
    }
  }
  return IgxGridTopLevelColumns;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridFilterConditionPipe = /*#__PURE__*/(() => {
  class IgxGridFilterConditionPipe {
    transform(value) {
      return value.split(/(?=[A-Z])/).join(' ');
    }
    static {
      this.ɵfac = function IgxGridFilterConditionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridFilterConditionPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterCondition",
        type: IgxGridFilterConditionPipe,
        pure: true
      });
    }
  }
  return IgxGridFilterConditionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridTransactionPipe = /*#__PURE__*/(() => {
  class IgxGridTransactionPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, _id, _pipeTrigger) {
      if (this.grid.transactions.enabled) {
        const result = DataUtil.mergeTransactions(cloneArray(collection), this.grid.transactions.getAggregatedChanges(true), this.grid.primaryKey, this.grid.dataCloneStrategy);
        return result;
      }
      return collection;
    }
    static {
      this.ɵfac = function IgxGridTransactionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridTransactionPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridTransaction",
        type: IgxGridTransactionPipe,
        pure: true
      });
    }
  }
  return IgxGridTransactionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGridPaginatorOptionsPipe = /*#__PURE__*/(() => {
  class IgxGridPaginatorOptionsPipe {
    transform(values) {
      return Array.from(new Set([...values])).sort((a, b) => a - b);
    }
    static {
      this.ɵfac = function IgxGridPaginatorOptionsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridPaginatorOptionsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "paginatorOptions",
        type: IgxGridPaginatorOptionsPipe,
        pure: true
      });
    }
  }
  return IgxGridPaginatorOptionsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxHasVisibleColumnsPipe = /*#__PURE__*/(() => {
  class IgxHasVisibleColumnsPipe {
    transform(values, hasVisibleColumns) {
      if (!(values && values.length)) {
        return values;
      }
      return hasVisibleColumns ? values : [];
    }
    static {
      this.ɵfac = function IgxHasVisibleColumnsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHasVisibleColumnsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "visibleColumns",
        type: IgxHasVisibleColumnsPipe,
        pure: true
      });
    }
  }
  return IgxHasVisibleColumnsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
function buildDataView() {
  return function (_target, _propertyKey, descriptor) {
    const original = descriptor.value;
    descriptor.value = function (...args) {
      const result = original.apply(this, args);
      this.grid.buildDataView();
      return result;
    };
    return descriptor;
  };
}
/**
 * @hidden
 */
let IgxGridRowPinningPipe = /*#__PURE__*/(() => {
  class IgxGridRowPinningPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, id, isPinned = false, _pipeTrigger) {
      if (this.grid.hasPinnedRecords && isPinned) {
        const result = collection.filter(rec => !this.grid.isSummaryRow(rec) && this.grid.isRecordPinned(rec));
        result.sort((rec1, rec2) => this.grid.getInitialPinnedIndex(rec1) - this.grid.getInitialPinnedIndex(rec2));
        return result;
      }
      this.grid.unpinnedRecords = collection;
      if (!this.grid.hasPinnedRecords) {
        this.grid.pinnedRecords = [];
        return isPinned ? [] : collection;
      }
      return collection.map(rec => !this.grid.isSummaryRow(rec) && this.grid.isRecordPinned(rec) ? {
        recordRef: rec,
        ghostRecord: true
      } : rec);
    }
    static {
      this.ɵfac = function IgxGridRowPinningPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridRowPinningPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridRowPinning",
        type: IgxGridRowPinningPipe,
        pure: true
      });
    }
  }
  __decorate([buildDataView()], IgxGridRowPinningPipe.prototype, "transform", null);
  return IgxGridRowPinningPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridDataMapperPipe = /*#__PURE__*/(() => {
  class IgxGridDataMapperPipe {
    transform(data, field, _, val, isNestedPath) {
      return isNestedPath ? resolveNestedPath(data, field) : val;
    }
    static {
      this.ɵfac = function IgxGridDataMapperPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridDataMapperPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dataMapper",
        type: IgxGridDataMapperPipe,
        pure: true
      });
    }
  }
  return IgxGridDataMapperPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxStringReplacePipe = /*#__PURE__*/(() => {
  class IgxStringReplacePipe {
    transform(value, search, replacement) {
      return value.replace(search, replacement);
    }
    static {
      this.ɵfac = function IgxStringReplacePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStringReplacePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxStringReplace",
        type: IgxStringReplacePipe,
        pure: true
      });
    }
  }
  return IgxStringReplacePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridTransactionStatePipe = /*#__PURE__*/(() => {
  class IgxGridTransactionStatePipe {
    transform(row_id, field, rowEditable, transactions, _, __, ___) {
      if (rowEditable) {
        const rowCurrentState = transactions.getAggregatedValue(row_id, false);
        if (rowCurrentState) {
          const value = resolveNestedPath(rowCurrentState, field);
          return value !== undefined && value !== null;
        }
      } else {
        const transaction = transactions.getState(row_id);
        const value = resolveNestedPath(transaction?.value ?? {}, field);
        return transaction && transaction.value && (value || value === 0 || value === false);
      }
    }
    static {
      this.ɵfac = function IgxGridTransactionStatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridTransactionStatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "transactionState",
        type: IgxGridTransactionStatePipe,
        pure: true
      });
    }
  }
  return IgxGridTransactionStatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxColumnFormatterPipe = /*#__PURE__*/(() => {
  class IgxColumnFormatterPipe {
    transform(value, formatter, rowData, columnData) {
      return formatter(value, rowData, columnData);
    }
    static {
      this.ɵfac = function IgxColumnFormatterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnFormatterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "columnFormatter",
        type: IgxColumnFormatterPipe,
        pure: true
      });
    }
  }
  return IgxColumnFormatterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSummaryFormatterPipe = /*#__PURE__*/(() => {
  class IgxSummaryFormatterPipe {
    transform(summaryResult, summaryOperand, summaryFormatter) {
      return summaryFormatter(summaryResult, summaryOperand);
    }
    static {
      this.ɵfac = function IgxSummaryFormatterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSummaryFormatterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "summaryFormatter",
        type: IgxSummaryFormatterPipe,
        pure: true
      });
    }
  }
  return IgxSummaryFormatterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridAddRowPipe = /*#__PURE__*/(() => {
  class IgxGridAddRowPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, isPinned = false, _pipeTrigger) {
      if (!this.grid.rowEditable || !this.grid.crudService.row || this.grid.crudService.row.getClassName() !== IgxAddRow.name || !this.grid.crudService.addRowParent || isPinned !== this.grid.crudService.addRowParent.isPinned) {
        return collection;
      }
      const copy = collection.slice(0);
      const rec = this.grid.crudService.row.recordRef;
      copy.splice(this.grid.crudService.row.index, 0, rec);
      return copy;
    }
    static {
      this.ɵfac = function IgxGridAddRowPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridAddRowPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridAddRow",
        type: IgxGridAddRowPipe,
        pure: true
      });
    }
  }
  return IgxGridAddRowPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 *
 * For all intents & purposes treat this component as what a <thead> usually is in the default <table> element.
 *
 * This container holds the grid header elements and their behavior/interactions.
 *
 * @hidden @internal
 */
let IgxGridHeaderRowComponent = /*#__PURE__*/(() => {
  class IgxGridHeaderRowComponent {
    /**
     * The flattened header groups collection.
     *
     * @hidden @internal
     */
    get groups() {
      return flatten$1(this._groups?.toArray() ?? []);
    }
    /** Header components in the header row. */
    get headers() {
      return this.groups.map(group => group.header);
    }
    /** Filtering cell components in the header row. */
    get filters() {
      return this.groups.map(group => group.filter);
    }
    get headerForOf() {
      return this.headerContainer;
    }
    get navigation() {
      return this.grid.navigation;
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    /**
     * Returns whether the current grid instance is a hierarchical grid.
     * as only hierarchical grids have the `isHierarchicalRecord` method.
     *
     * @hidden @internal
     */
    get isHierarchicalGrid() {
      return !!this.grid.isHierarchicalRecord;
    }
    get indentationCSSClasses() {
      return `igx-grid__header-indentation igx-grid__row-indentation--level-${this.grid.groupingExpressions.length}`;
    }
    get rowSelectorsContext() {
      const ctx = {
        $implicit: {
          selectedCount: this.grid.selectionService.filteredSelectedRowIds.length,
          totalCount: this.grid.totalRowsCountAfterFilter
        }
      };
      if (this.isHierarchicalGrid) {
        ctx.$implicit.selectAll = () => this.grid.selectAllRows();
        ctx.$implicit.deselectAll = () => this.grid.deselectAllRows();
      }
      return ctx;
    }
    constructor(ref, cdr) {
      this.ref = ref;
      this.cdr = cdr;
      /** Pinned columns of the grid. */
      this.pinnedColumnCollection = [];
      /** Unpinned columns of the grid. */
      this.unpinnedColumnCollection = [];
      /** state persistence switching all pinned columns resets collection */
      this.trackPinnedColumn = trackByIdentity;
    }
    /**
     * This hook exists as a workaround for the unfortunate fact
     * that when we have pinned columns in the grid, the unpinned columns headers
     * are affected by a delayed change detection cycle after a horizontal scroll :(
     * Thus, we tell the parent grid change detector to check us at each cycle.
     *
     * @hidden @internal
     */
    ngDoCheck() {
      this.cdr.markForCheck();
    }
    /**
     * @hidden @internal
     */
    scroll(event) {
      this.grid.preventHeaderScroll(event);
    }
    headerRowSelection(event) {
      if (!this.grid.isMultiRowSelectionEnabled) {
        return;
      }
      if (this.grid.selectionService.areAllRowSelected()) {
        this.grid.selectionService.clearRowSelection(event);
      } else {
        this.grid.selectionService.selectAllRows(event);
      }
    }
    static {
      this.ɵfac = function IgxGridHeaderRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridHeaderRowComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridHeaderRowComponent,
        selectors: [["igx-grid-header-row"]],
        viewQuery: function IgxGridHeaderRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c175, 7, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c176, 5);
            i0.ɵɵviewQuery(_c177, 5);
            i0.ɵɵviewQuery(_c178, 5);
            i0.ɵɵviewQuery(_c179, 5);
            i0.ɵɵviewQuery(IgxGridFilteringRowComponent, 5);
            i0.ɵɵviewQuery(_c180, 5);
            i0.ɵɵviewQuery(IgxGridHeaderGroupComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerDragContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerSelectorContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerGroupContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headSelectorBaseTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterRow = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerHierarchyExpander = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groups = _t);
          }
        },
        inputs: {
          grid: "grid",
          pinnedColumnCollection: "pinnedColumnCollection",
          unpinnedColumnCollection: "unpinnedColumnCollection",
          activeDescendant: "activeDescendant",
          hasMRL: [2, "hasMRL", "hasMRL", booleanAttribute],
          width: "width"
        },
        decls: 18,
        vars: 27,
        consts: [["headerVirtualContainer", ""], ["headSelectorBaseTemplate", ""], ["headerDragContainer", ""], ["headerSelectorContainer", ""], ["headSelector", ""], ["headerHierarchyExpander", ""], ["headerGroupContainer", ""], ["filteringRow", ""], ["headerCheckbox", ""], ["role", "rowgroup", 1, "igx-grid-thead__wrapper", 3, "scroll"], ["role", "row", 1, "igx-grid__tr"], ["id", "left", "droppable", "true", 1, "igx-grid__scroll-on-drag-left", 3, "left", "igxColumnMovingDrop"], ["id", "left", "droppable", "true", 1, "igx-grid__scroll-on-drag-pinned", 3, "left", "igxColumnMovingDrop"], [1, "igx-grid__drag-indicator", "igx-grid__tr-action", 3, "igx-grid__drag-indicator--header"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "igx-grid__cbx-selection--push"], [3, "hidden", "ngClass"], [3, "class"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForContainerSize", "igxForTrackBy", "igxForSizePropName", "igxForScrollOrientation"], [3, "column", "width"], ["id", "right", "droppable", "true", 1, "igx-grid__scroll-on-drag-right", 3, "igxColumnMovingDrop"], [1, "igx-grid-thead__thumb", 3, "hidden"], ["igxHeadSelector", ""], ["id", "left", "droppable", "true", 1, "igx-grid__scroll-on-drag-left", 3, "igxColumnMovingDrop"], ["id", "left", "droppable", "true", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop"], [1, "igx-grid__drag-indicator", "igx-grid__tr-action", 3, "pointerdown"], [2, "visibility", "hidden"], [4, "ngTemplateOutlet"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "click", "pointerdown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "click", "pointerdown", "hidden", "ngClass"], [3, "click", "pointerdown"], [3, "ngClass", "ngStyle", "column", "min-width", "flex-basis"], [3, "ngClass", "ngStyle", "column"], [3, "ngClass", "ngStyle", "column", "min-width", "flex-basis", "left"], [3, "column"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "readonly", "checked", "disableRipple", "ngStyle", "indeterminate", "aria-label"]],
        template: function IgxGridHeaderRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 9);
            i0.ɵɵlistener("scroll", function IgxGridHeaderRowComponent_Template_div_scroll_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.scroll($event));
            });
            i0.ɵɵelementStart(1, "div", 10);
            i0.ɵɵtemplate(2, IgxGridHeaderRowComponent_Conditional_2_Template, 1, 3, "span", 11)(3, IgxGridHeaderRowComponent_Conditional_3_Template, 1, 3, "span", 12)(4, IgxGridHeaderRowComponent_Conditional_4_Template, 4, 3, "div", 13)(5, IgxGridHeaderRowComponent_Conditional_5_Template, 3, 4, "div", 14)(6, IgxGridHeaderRowComponent_Conditional_6_Template, 3, 10, "div", 15)(7, IgxGridHeaderRowComponent_Conditional_7_Template, 3, 7, "div", 16)(8, IgxGridHeaderRowComponent_Conditional_8_Template, 3, 2)(9, IgxGridHeaderRowComponent_ng_template_9_Template, 4, 19, "ng-template", 17, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(11, "igxTopLevel");
            i0.ɵɵtemplate(12, IgxGridHeaderRowComponent_Conditional_12_Template, 3, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, IgxGridHeaderRowComponent_Conditional_13_Template, 2, 3, "igx-grid-filtering-row", 18)(14, IgxGridHeaderRowComponent_Conditional_14_Template, 1, 1, "span", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "div", 20);
            i0.ɵɵtemplate(16, IgxGridHeaderRowComponent_ng_template_16_Template, 3, 9, "ng-template", 21, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵclassProp("igx-grid__tr--mrl", ctx.hasMRL);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.moving && ctx.grid.columnInDrag && ctx.pinnedColumnCollection.length <= 0 ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.moving && ctx.grid.columnInDrag && ctx.pinnedColumnCollection.length > 0 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.rowDraggable ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.showRowSelectors ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isHierarchicalGrid ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.grid == null ? null : ctx.grid.groupingExpressions == null ? null : ctx.grid.groupingExpressions.length) ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.pinnedColumnCollection.length && ctx.grid.isPinningToStart ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(11, 25, ctx.unpinnedColumnCollection))("igxForScrollContainer", ctx.grid.parentVirtDir)("igxForContainerSize", ctx.grid.unpinnedWidth)("igxForTrackBy", ctx.grid.trackColumnChanges)("igxForSizePropName", "calcPixelWidth")("igxForScrollOrientation", "horizontal");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.pinnedColumnCollection.length && !ctx.grid.isPinningToStart ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.filteringService.isFilterRowVisible ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.moving && ctx.grid.columnInDrag ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.grid.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.grid.hasVerticalScroll());
          }
        },
        dependencies: [IgxColumnMovingDropDirective, NgTemplateOutlet, NgClass, IgxGridHeaderGroupComponent, NgStyle, IgxGridForOfDirective, IgxGridFilteringRowComponent, IgxCheckboxComponent, IgxGridTopLevelColumns, IgxHeaderGroupWidthPipe, IgxHeaderGroupStylePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridHeaderRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxGridHeaderGroupComponent } from './grid-header-group.component';
// import { IgxGridHeaderRowComponent } from './grid-header-row.component';
// import { IgxGridHeaderComponent } from './grid-header.component';
/* NOTE: Grid headers directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_HEADERS_DIRECTIVES = [
//     IgxGridHeaderComponent,
//     IgxGridHeaderGroupComponent,
//     IgxGridHeaderRowComponent
// ] as const;

const ghostBackgroundClass = 'igx-grid__tr--ghost';
const gridCellClass = 'igx-grid__td';
const rowSelectedClass = 'igx-grid__tr--selected';
const cellSelectedClass = 'igx-grid__td--selected';
const cellActiveClass = 'igx-grid__td--active';
/**
 * @hidden
 */
let IgxRowDragDirective = /*#__PURE__*/(() => {
  class IgxRowDragDirective extends IgxDragDirective {
    constructor() {
      super(...arguments);
      this._rowDragStarted = false;
      this.transitionEndEvent = () => {
        if (this.ghostElement) {
          this.ghostElement.removeEventListener('transitionend', this.transitionEndEvent, false);
        }
        this.endDragging();
      };
    }
    set data(value) {
      this._data = value;
    }
    get data() {
      return this._data.grid.createRow(this._data.index, this._data.data);
    }
    get row() {
      return this._data;
    }
    onPointerDown(event) {
      event.preventDefault();
      this._rowDragStarted = false;
      this._removeOnDestroy = false;
      super.onPointerDown(event);
    }
    onPointerMove(event) {
      super.onPointerMove(event);
      if (this._dragStarted && !this._rowDragStarted) {
        this._rowDragStarted = true;
        const args = {
          dragDirective: this,
          dragData: this.data,
          dragElement: this.row.nativeElement,
          cancel: false,
          owner: this.row.grid
        };
        this.row.grid.rowDragStart.emit(args);
        if (args.cancel) {
          this.ghostElement.parentNode.removeChild(this.ghostElement);
          this.ghostElement = null;
          this._dragStarted = false;
          this._clicked = false;
          return;
        }
        this.row.grid.dragRowID = this.row.key;
        this.row.grid.rowDragging = true;
        this.row.grid.cdr.detectChanges();
        this.subscription$ = fromEvent(this.row.grid.document.defaultView, 'keydown').subscribe(ev => {
          if (ev.key === this.platformUtil.KEYMAP.ESCAPE) {
            this._lastDropArea = false;
            this.onPointerUp(event);
          }
        });
      }
    }
    onPointerUp(event) {
      if (!this._clicked) {
        return;
      }
      const args = {
        dragDirective: this,
        dragData: this.data,
        dragElement: this.row.nativeElement,
        animation: false,
        owner: this.row.grid
      };
      this.zone.run(() => {
        this.row.grid.rowDragEnd.emit(args);
      });
      const dropArea = this._lastDropArea;
      super.onPointerUp(event);
      if (!dropArea && this.ghostElement) {
        this.ghostElement.addEventListener('transitionend', this.transitionEndEvent, false);
      } else {
        this.endDragging();
      }
    }
    createGhost(pageX, pageY) {
      this.row.grid.gridAPI.crudService.endEdit(false);
      this.row.grid.cdr.detectChanges();
      this.ghostContext = {
        $implicit: this.row.data,
        data: this.row.data,
        grid: this.row.grid
      };
      super.createGhost(pageX, pageY, this.row.nativeElement);
      // check if there is an expander icon and create the ghost at the corresponding position
      if (this.isHierarchicalGrid) {
        const row = this.row;
        if (row.expander) {
          const expanderWidth = row.expander.nativeElement.getBoundingClientRect().width;
          this._ghostHostX += expanderWidth;
        }
      }
      const ghost = this.ghostElement;
      const gridRect = this.row.grid.nativeElement.getBoundingClientRect();
      const rowRect = this.row.nativeElement.getBoundingClientRect();
      ghost.style.overflow = 'hidden';
      ghost.style.width = gridRect.width + 'px';
      ghost.style.height = rowRect.height + 'px';
      ghost.classList.add(ghostBackgroundClass);
      ghost.classList.remove(rowSelectedClass);
      const ghostCells = ghost.getElementsByClassName(gridCellClass);
      for (const cell of ghostCells) {
        cell.classList.remove(cellSelectedClass);
        cell.classList.remove(cellActiveClass);
      }
    }
    _unsubscribe() {
      if (this.subscription$ && !this.subscription$.closed) {
        this.subscription$.unsubscribe();
      }
    }
    endDragging() {
      this.onTransitionEnd(null);
      this.row.grid.dragRowID = null;
      this.row.grid.rowDragging = false;
      this.row.grid.cdr.detectChanges();
      this._unsubscribe();
    }
    get isHierarchicalGrid() {
      return this.row.grid.type === 'hierarchical';
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxRowDragDirective_BaseFactory;
        return function IgxRowDragDirective_Factory(__ngFactoryType__) {
          return (ɵIgxRowDragDirective_BaseFactory || (ɵIgxRowDragDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxRowDragDirective)))(__ngFactoryType__ || IgxRowDragDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowDragDirective,
        selectors: [["", "igxRowDrag", ""]],
        inputs: {
          data: [0, "igxRowDrag", "data"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxRowDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxDragIndicatorIconDirective = /*#__PURE__*/(() => {
  class IgxDragIndicatorIconDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxDragIndicatorIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDragIndicatorIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDragIndicatorIconDirective,
        selectors: [["", "igxDragIndicatorIcon", ""]]
      });
    }
  }
  return IgxDragIndicatorIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxRowDragGhostDirective = /*#__PURE__*/(() => {
  class IgxRowDragGhostDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowDragGhostDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowDragGhostDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowDragGhostDirective,
        selectors: [["", "igxRowDragGhost", ""]]
      });
    }
  }
  return IgxRowDragGhostDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxRowSelectorDirective = /*#__PURE__*/(() => {
  class IgxRowSelectorDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowSelectorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowSelectorDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowSelectorDirective,
        selectors: [["", "igxRowSelector", ""]]
      });
    }
  }
  return IgxRowSelectorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxGroupByRowSelectorDirective = /*#__PURE__*/(() => {
  class IgxGroupByRowSelectorDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxGroupByRowSelectorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGroupByRowSelectorDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGroupByRowSelectorDirective,
        selectors: [["", "igxGroupByRowSelector", ""]]
      });
    }
  }
  return IgxGroupByRowSelectorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * @internal
 */
let IgxHeadSelectorDirective = /*#__PURE__*/(() => {
  class IgxHeadSelectorDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxHeadSelectorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHeadSelectorDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxHeadSelectorDirective,
        selectors: [["", "igxHeadSelector", ""]]
      });
    }
  }
  return IgxHeadSelectorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective, IgxRowSelectorDirective } from './row-selectors';
/* NOTE: Grid selection directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_SELECTION_DIRECTIVES = [
//     IgxRowSelectorDirective,
//     IgxGroupByRowSelectorDirective,
//     IgxHeadSelectorDirective
// ] as const;
let IgxGridBodyDirective = /*#__PURE__*/(() => {
  class IgxGridBodyDirective {
    static {
      this.ɵfac = function IgxGridBodyDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridBodyDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridBodyDirective,
        selectors: [["", "igxGridBody", ""]],
        features: [i0.ɵɵProvidersFeature([IgxForOfSyncService])]
      });
    }
  }
  return IgxGridBodyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
class RowEditPositionStrategy extends ConnectedPositioningStrategy {
  constructor() {
    super(...arguments);
    this.isTop = false;
    this.isTopInitialPosition = null;
  }
  position(contentElement, size, document, initialCall, target) {
    const container = this.settings.container; // grid.tbody
    const targetElement = target; // current grid.row
    // Position of the overlay depends on the available space in the grid.
    // If the bottom space is not enough then the the row overlay will show at the top of the row.
    // Once shown, either top or bottom, then this position stays until the overlay is closed (isTopInitialPosition property),
    // which means that when scrolling then overlay may hide, while the row is still visible (UX requirement).
    this.isTop = this.isTopInitialPosition !== null ? this.isTopInitialPosition : container.getBoundingClientRect().bottom < targetElement.getBoundingClientRect().bottom + contentElement.getBoundingClientRect().height;
    // Set width of the row editing overlay to equal row width, otherwise it fits 100% of the grid.
    contentElement.style.width = targetElement.clientWidth + 'px';
    this.settings.verticalStartPoint = this.settings.verticalDirection = this.isTop ? VerticalAlignment.Top : VerticalAlignment.Bottom;
    this.settings.openAnimation = this.isTop ? scaleInVerBottom : scaleInVerTop;
    super.position(contentElement, {
      width: targetElement.clientWidth,
      height: targetElement.clientHeight
    }, document, initialCall, targetElement);
  }
}

/** @hidden @internal */
class IgxToolbarToken {}

/** @hidden @internal */
let IgxRowEditTemplateDirective = /*#__PURE__*/(() => {
  class IgxRowEditTemplateDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowEditTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowEditTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowEditTemplateDirective,
        selectors: [["", "igxRowEdit", ""]]
      });
    }
  }
  return IgxRowEditTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxRowEditTextDirective = /*#__PURE__*/(() => {
  class IgxRowEditTextDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowEditTextDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowEditTextDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowEditTextDirective,
        selectors: [["", "igxRowEditText", ""]]
      });
    }
  }
  return IgxRowEditTextDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxRowAddTextDirective = /*#__PURE__*/(() => {
  class IgxRowAddTextDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowAddTextDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowAddTextDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowAddTextDirective,
        selectors: [["", "igxRowAddText", ""]]
      });
    }
  }
  return IgxRowAddTextDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxRowEditActionsDirective = /*#__PURE__*/(() => {
  class IgxRowEditActionsDirective {
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxRowEditActionsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowEditActionsDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowEditActionsDirective,
        selectors: [["", "igxRowEditActions", ""]]
      });
    }
  }
  return IgxRowEditActionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// TODO: Refactor circular ref, deps and logic
/** @hidden @internal */
let IgxRowEditTabStopDirective = /*#__PURE__*/(() => {
  class IgxRowEditTabStopDirective {
    constructor(grid, element) {
      this.grid = grid;
      this.element = element;
    }
    handleTab(event) {
      event.stopPropagation();
      if (this.grid.rowEditTabs.last === this && !event.shiftKey || this.grid.rowEditTabs.first === this && event.shiftKey) {
        this.move(event);
      }
    }
    handleEscape(event) {
      this.grid.crudService.endEdit(false, event);
      this.grid.tbody.nativeElement.focus();
    }
    handleEnter(event) {
      event.stopPropagation();
    }
    /**
     * Moves focus to first/last editable cell in the editable row and put the cell in edit mode.
     * If cell is out of view first scrolls to the cell
     *
     * @param event keyboard event containing information about whether SHIFT key was pressed
     */
    move(event) {
      event.preventDefault();
      this.currentCellIndex = event.shiftKey ? this.grid.lastEditableColumnIndex : this.grid.firstEditableColumnIndex;
      this.grid.navigation.activeNode.row = this.grid.crudService.rowInEditMode.index;
      this.grid.navigation.activeNode.column = this.currentCellIndex;
      this.grid.navigateTo(this.grid.crudService.rowInEditMode.index, this.currentCellIndex, obj => {
        obj.target.activate(event);
        this.grid.cdr.detectChanges();
      });
    }
    static {
      this.ɵfac = function IgxRowEditTabStopDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowEditTabStopDirective)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowEditTabStopDirective,
        selectors: [["", "igxRowEditTabStop", ""]],
        hostBindings: function IgxRowEditTabStopDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.Tab", function IgxRowEditTabStopDirective_keydown_Tab_HostBindingHandler($event) {
              return ctx.handleTab($event);
            })("keydown.Shift.Tab", function IgxRowEditTabStopDirective_keydown_Shift_Tab_HostBindingHandler($event) {
              return ctx.handleTab($event);
            })("keydown.Escape", function IgxRowEditTabStopDirective_keydown_Escape_HostBindingHandler($event) {
              return ctx.handleEscape($event);
            })("keydown.Enter", function IgxRowEditTabStopDirective_keydown_Enter_HostBindingHandler($event) {
              return ctx.handleEnter($event);
            });
          }
        }
      });
    }
  }
  return IgxRowEditTabStopDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSummaryCellComponent = /*#__PURE__*/(() => {
  class IgxSummaryCellComponent {
    constructor(element) {
      this.element = element;
      this.firstCellIndentation = 0;
      this.hasSummary = false;
      /** cached single summary res after filter resets collection */
      this.trackSummaryResult = trackByIdentity;
    }
    get visibleColumnIndex() {
      return this.column.visibleIndex;
    }
    get attrCellID() {
      return `${this.grid.id}_${this.rowIndex}_${this.visibleColumnIndex}`;
    }
    activate() {
      const currNode = this.grid.navigation.activeNode;
      if (currNode && this.rowIndex === currNode.row && this.visibleColumnIndex === currNode.column) {
        return;
      }
      this.grid.navigation.setActiveNode({
        row: this.rowIndex,
        column: this.visibleColumnIndex
      }, 'summaryCell');
      this.grid.cdr.detectChanges();
    }
    get selectionNode() {
      return {
        row: this.rowIndex,
        column: this.column.columnLayoutChild ? this.column.parent.visibleIndex : this.visibleColumnIndex,
        isSummaryRow: true
      };
    }
    get width() {
      return this.column.getCellWidth();
    }
    get nativeElement() {
      return this.element.nativeElement;
    }
    get columnDatatype() {
      return this.column.dataType;
    }
    get itemHeight() {
      return this.column.grid.defaultSummaryHeight;
    }
    /**
     * @hidden
     */
    get grid() {
      return this.column.grid;
    }
    /**
     * @hidden @internal
     */
    get currencyCode() {
      return this.column.pipeArgs.currencyCode ? this.column.pipeArgs.currencyCode : getLocaleCurrencyCode(this.grid.locale);
    }
    /**
     * @hidden @internal
     */
    get currencySymbol() {
      return this.column.pipeArgs.display ? this.column.pipeArgs.display : getLocaleCurrencySymbol(this.grid.locale);
    }
    translateSummary(summary) {
      return this.grid.resourceStrings[`igx_grid_summary_${summary.key}`] || summary.label;
    }
    /**
     * @hidden @internal
     */
    formatSummaryResult(summary) {
      if (summary.summaryResult === undefined || summary.summaryResult === null || summary.summaryResult === '') {
        return '';
      }
      if (this.summaryFormatter) {
        return this.summaryFormatter(summary, this.column.summaries);
      }
      const args = this.column.pipeArgs;
      const locale = this.grid.locale;
      if (summary.key === 'count') {
        return formatNumber(summary.summaryResult, locale);
      }
      if (summary.defaultFormatting) {
        switch (this.column.dataType) {
          case GridColumnDataType.Number:
            return formatNumber(summary.summaryResult, locale, args.digitsInfo);
          case GridColumnDataType.Date:
          case GridColumnDataType.DateTime:
          case GridColumnDataType.Time:
            return formatDate$1(summary.summaryResult, args.format, locale, args.timezone);
          case GridColumnDataType.Currency:
            return formatCurrency$1(summary.summaryResult, locale, this.currencySymbol, this.currencyCode, args.digitsInfo);
          case GridColumnDataType.Percent:
            return formatPercent(summary.summaryResult, locale, args.digitsInfo);
        }
      }
      return summary.summaryResult;
    }
    static {
      this.ɵfac = function IgxSummaryCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSummaryCellComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSummaryCellComponent,
        selectors: [["igx-grid-summary-cell"]],
        hostVars: 5,
        hostBindings: function IgxSummaryCellComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerdown", function IgxSummaryCellComponent_pointerdown_HostBindingHandler() {
              return ctx.activate();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-rowIndex", ctx.rowIndex)("data-visibleIndex", ctx.visibleColumnIndex)("id", ctx.attrCellID);
            i0.ɵɵclassProp("igx-grid-summary--active", ctx.active);
          }
        },
        inputs: {
          summaryResults: "summaryResults",
          column: "column",
          firstCellIndentation: "firstCellIndentation",
          hasSummary: [2, "hasSummary", "hasSummary", booleanAttribute],
          summaryFormatter: "summaryFormatter",
          summaryTemplate: "summaryTemplate",
          active: "active",
          rowIndex: "rowIndex"
        },
        decls: 3,
        vars: 1,
        consts: [["defaultSummary", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid-summary__item", 3, "height"], [1, "igx-grid-summary__item"], [1, "igx-grid-summary__label", 3, "title"], [1, "igx-grid-summary__result", 3, "title"]],
        template: function IgxSummaryCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxSummaryCellComponent_Conditional_0_Template, 1, 4, "ng-container")(1, IgxSummaryCellComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.hasSummary ? 0 : -1);
          }
        },
        dependencies: [NgTemplateOutlet],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxSummaryCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSummaryRowComponent = /*#__PURE__*/(() => {
  class IgxSummaryRowComponent {
    get dataRowIndex() {
      return this.index;
    }
    get minHeight() {
      return this.grid.summaryRowHeight - 1;
    }
    get summaryCells() {
      const res = new QueryList();
      if (!this._summaryCells) {
        return res;
      }
      const cList = this._summaryCells.filter(c => c.nativeElement.isConnected);
      res.reset(cList);
      return res;
    }
    set summaryCells(cells) {}
    constructor(grid, element, cdr) {
      this.grid = grid;
      this.element = element;
      this.cdr = cdr;
      this.firstCellIndentation = -1;
      /** state persistence switching all pinned columns resets collection */
      this.trackPinnedColumn = trackByIdentity;
    }
    ngDoCheck() {
      this.cdr.markForCheck();
    }
    get nativeElement() {
      return this.element.nativeElement;
    }
    getColumnSummaries(columnName) {
      if (!this.summaries.get(columnName)) {
        return [];
      }
      return this.summaries.get(columnName);
    }
    /**
     * @hidden
     * @internal
     */
    isCellActive(visibleColumnIndex) {
      const node = this.grid.navigation.activeNode;
      return node ? node.row === this.index && node.column === visibleColumnIndex : false;
    }
    /**
     * @hidden
     */
    get pinnedColumns() {
      return this.grid.pinnedColumns;
    }
    /**
     * @hidden
     */
    get unpinnedColumns() {
      return this.grid.unpinnedColumns;
    }
    getContext(row) {
      return {
        $implicit: row
      };
    }
    static {
      this.ɵfac = function IgxSummaryRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSummaryRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSummaryRowComponent,
        selectors: [["igx-grid-summary-row"]],
        viewQuery: function IgxSummaryRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c22, 5, IgxGridForOfDirective);
            i0.ɵɵviewQuery(IgxSummaryCellComponent, 5, IgxSummaryCellComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtDirRow = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._summaryCells = _t);
          }
        },
        hostVars: 1,
        hostBindings: function IgxSummaryRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-rowIndex", ctx.dataRowIndex);
          }
        },
        inputs: {
          summaries: "summaries",
          gridID: "gridID",
          index: "index",
          firstCellIndentation: "firstCellIndentation"
        },
        features: [i0.ɵɵProvidersFeature([IgxForOfSyncService])],
        decls: 3,
        vars: 1,
        consts: [["summaryCellTemplate", ""], ["igxDirRef", ""], [1, "igx-grid__summaries-patch", 3, "min-width", "flex-basis"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForScrollOrientation", "igxForContainerSize", "igxForTrackBy", "igxForSizePropName"], [1, "igx-grid__summaries-patch", 3, "pointerdown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "cell", 1, "igx-grid-summary", "igx-grid-summary--fw", 3, "column", "rowIndex", "firstCellIndentation", "summaryResults", "summaryTemplate", "hasSummary", "summaryFormatter", "active"], ["role", "cell", 1, "igx-grid-summary", "igx-grid-summary--fw", "igx-grid-summary--pinned", 3, "igx-grid-summary--empty", "igx-grid-summary--pinned-first", "igx-grid-summary--pinned-last", "column", "firstCellIndentation", "rowIndex", "summaryResults", "summaryTemplate", "hasSummary", "active", "max-height", "min-height", "min-width", "max-width", "flex-basis", "left"], ["role", "cell", 1, "igx-grid-summary", "igx-grid-summary--fw", "igx-grid-summary--pinned", 3, "column", "firstCellIndentation", "rowIndex", "summaryResults", "summaryTemplate", "hasSummary", "active"]],
        template: function IgxSummaryRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxSummaryRowComponent_Conditional_0_Template, 6, 11)(1, IgxSummaryRowComponent_ng_template_1_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.summaries.size ? 0 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxGridForOfDirective, IgxSummaryCellComponent, IgxGridNotGroupedPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxSummaryRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxColumnResizerDirective = /*#__PURE__*/(() => {
  class IgxColumnResizerDirective {
    get ratio() {
      return this._ratio;
    }
    constructor(element, document, zone) {
      this.element = element;
      this.document = document;
      this.zone = zone;
      this.restrictHResizeMin = Number.MIN_SAFE_INTEGER;
      this.restrictHResizeMax = Number.MAX_SAFE_INTEGER;
      this.resizeEnd = new Subject();
      this.resizeStart = new Subject();
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.resize = new Subject();
      this._ratio = 1;
      this._destroy = new Subject();
      this.resizeStart.pipe(takeUntil(this._destroy), map(event => event.clientX), switchMap(offset => this.resize.pipe(takeUntil(this._destroy), takeUntil(this.resizeEnd), map(event => (event.clientX - offset) / this._ratio)))).subscribe(pos => {
        const left = this._left + pos;
        const min = this._left - this.restrictHResizeMin;
        const max = this._left + this.restrictHResizeMax;
        this.left = left < min ? min : left;
        if (left > max) {
          this.left = max;
        }
      });
    }
    ngOnInit() {
      this.zone.runOutsideAngular(() => {
        fromEvent(this.document.defaultView, 'mousemove').pipe(takeUntil(this._destroy), throttle(() => interval(0, animationFrameScheduler))).subscribe(res => this.onMousemove(res));
        fromEvent(this.document.defaultView, 'mouseup').pipe(takeUntil(this._destroy)).subscribe(res => this.onMouseup(res));
      });
    }
    ngOnDestroy() {
      this._destroy.next(true);
      this._destroy.complete();
    }
    set left(val) {
      requestAnimationFrame(() => this.element.nativeElement.style.left = val + 'px');
    }
    set top(val) {
      if (this.restrictResizerTop != undefined) {
        requestAnimationFrame(() => this.element.nativeElement.style.top = this.restrictResizerTop + 'px');
      } else {
        requestAnimationFrame(() => this.element.nativeElement.style.top = val + 'px');
      }
    }
    onMouseup(event) {
      this.resizeEnd.next(event);
      this.resizeEnd.complete();
    }
    onMousedown(event) {
      event.preventDefault();
      const parent = this.element.nativeElement.parentElement.parentElement;
      const parentRectWidth = parent.getBoundingClientRect().width;
      const parentComputedWidth = parseFloat(window.getComputedStyle(parent).width);
      if (Math.abs(parentRectWidth - parentComputedWidth) > 1) {
        this._ratio = parentRectWidth / parentComputedWidth;
      }
      this.left = this._left = (event.clientX - parent.getBoundingClientRect().left) / this._ratio;
      this.top = event.target.getBoundingClientRect().top - parent.getBoundingClientRect().top;
      this.resizeStart.next(event);
    }
    onMousemove(event) {
      event.preventDefault();
      this.resize.next(event);
    }
    static {
      this.ɵfac = function IgxColumnResizerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxColumnResizerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxColumnResizerDirective,
        selectors: [["", "igxResizer", ""]],
        inputs: {
          restrictHResizeMin: "restrictHResizeMin",
          restrictHResizeMax: "restrictHResizeMax",
          restrictResizerTop: "restrictResizerTop"
        },
        outputs: {
          resizeEnd: "resizeEnd",
          resizeStart: "resizeStart",
          resize: "resize"
        }
      });
    }
  }
  return IgxColumnResizerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridColumnResizerComponent = /*#__PURE__*/(() => {
  class IgxGridColumnResizerComponent {
    constructor(colResizingService) {
      this.colResizingService = colResizingService;
    }
    static {
      this.ɵfac = function IgxGridColumnResizerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridColumnResizerComponent)(i0.ɵɵdirectiveInject(IgxColumnResizingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridColumnResizerComponent,
        selectors: [["igx-grid-column-resizer"]],
        viewQuery: function IgxGridColumnResizerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxColumnResizerDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizer = _t.first);
          }
        },
        inputs: {
          restrictResizerTop: "restrictResizerTop"
        },
        decls: 1,
        vars: 7,
        consts: [["igxResizer", "", 1, "igx-grid-th__resize-line", 3, "resizeEnd", "restrictHResizeMax", "restrictHResizeMin", "restrictResizerTop"]],
        template: function IgxGridColumnResizerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("resizeEnd", function IgxGridColumnResizerComponent_Template_div_resizeEnd_0_listener($event) {
              return ctx.colResizingService.resizeColumn($event, ctx.resizer.ratio);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("left", -99999, "px")("height", ctx.colResizingService.resizerHeight, "px");
            i0.ɵɵproperty("restrictHResizeMax", ctx.colResizingService.restrictResizeMax)("restrictHResizeMin", ctx.colResizingService.restrictResizeMin)("restrictResizerTop", ctx.restrictResizerTop);
          }
        },
        dependencies: [IgxColumnResizerDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridColumnResizerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxNotificationsDirective = /*#__PURE__*/(() => {
  class IgxNotificationsDirective extends IgxToggleDirective {
    constructor() {
      super(...arguments);
      /**
       * Sets/gets the `aria-live` attribute.
       * If not set, `aria-live` will have value `"polite"`.
       */
      this.ariaLive = 'polite';
      /**
       * Sets/gets whether the element will be hidden after the `displayTime` is over.
       * Default value is `true`.
       */
      this.autoHide = true;
      /**
       * Sets/gets the duration of time span (in milliseconds) which the element will be visible
       * after it is being shown.
       * Default value is `4000`.
       */
      this.displayTime = 4000;
      /**
       * @hidden
       * @internal
       */
      this.textMessage = '';
    }
    /**
     * Enables/Disables the visibility of the element.
     * If not set, the `isVisible` attribute will have value `false`.
     */
    get isVisible() {
      return !this.collapsed;
    }
    set isVisible(value) {
      if (value !== this.isVisible) {
        if (value) {
          requestAnimationFrame(() => {
            this.open();
          });
        } else {
          this.close();
        }
      }
    }
    /**
     * @hidden
     */
    open() {
      clearInterval(this.timeoutId);
      const overlaySettings = {
        positionStrategy: this.strategy,
        closeOnEscape: false,
        closeOnOutsideClick: false,
        modal: false,
        outlet: this.outlet
      };
      super.open(overlaySettings);
      if (this.autoHide) {
        this.timeoutId = window.setTimeout(() => {
          this.close();
        }, this.displayTime);
      }
    }
    /**
     * Hides the element.
     */
    close() {
      clearTimeout(this.timeoutId);
      super.close();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxNotificationsDirective_BaseFactory;
        return function IgxNotificationsDirective_Factory(__ngFactoryType__) {
          return (ɵIgxNotificationsDirective_BaseFactory || (ɵIgxNotificationsDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxNotificationsDirective)))(__ngFactoryType__ || IgxNotificationsDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNotificationsDirective,
        hostVars: 1,
        hostBindings: function IgxNotificationsDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-live", ctx.ariaLive);
          }
        },
        inputs: {
          ariaLive: "ariaLive",
          autoHide: [2, "autoHide", "autoHide", booleanAttribute],
          displayTime: "displayTime",
          outlet: "outlet",
          isVisible: [2, "isVisible", "isVisible", booleanAttribute]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxNotificationsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$9 = 0;
/**
 * **Ignite UI for Angular Snackbar** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/snackbar.html)
 *
 * The Ignite UI Snack Bar provides feedback about an operation with a single-line message, which can
 * include a link to an action such as Undo.
 *
 * Example:
 * ```html
 * <button type="button" igxButton (click)="snackbar.show()">Send message</button>
 * <div>
 *   <igx-snackbar #snackbar>
 *      Message sent
 *   </igx-snackbar>
 * </div>
 * ```
 */
let IgxSnackbarComponent = /*#__PURE__*/(() => {
  class IgxSnackbarComponent extends IgxNotificationsDirective {
    constructor() {
      super(...arguments);
      /**
       * Sets/gets the `id` of the snackbar.
       * If not set, the `id` of the first snackbar component  will be `"igx-snackbar-0"`;
       * ```html
       * <igx-snackbar id = "Snackbar1"></igx-snackbar>
       * ```
       * ```typescript
       * let snackbarId = this.snackbar.id;
       * ```
       *
       * @memberof IgxSnackbarComponent
       */
      this.id = `igx-snackbar-${NEXT_ID$9++}`;
      /**
       * The default css class applied to the component.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-snackbar';
      /**
       * An event that will be emitted when the action button is clicked.
       * Provides reference to the `IgxSnackbarComponent` as an argument.
       * ```html
       * <igx-snackbar (clicked)="clickedHandler($event)"></igx-snackbar>
       * ```
       */
      this.clicked = new EventEmitter();
      /**
       * An event that will be emitted when the snackbar animation starts.
       * Provides reference to the `ToggleViewEventArgs` interface as an argument.
       * ```html
       * <igx-snackbar (animationStarted) = "animationStarted($event)"></igx-snackbar>
       * ```
       */
      this.animationStarted = new EventEmitter();
      /**
       * An event that will be emitted when the snackbar animation ends.
       * Provides reference to the `ToggleViewEventArgs` interface as an argument.
       * ```html
       * <igx-snackbar (animationDone) = "animationDone($event)"></igx-snackbar>
       * ```
       */
      this.animationDone = new EventEmitter();
      this._positionSettings = {
        horizontalDirection: HorizontalAlignment.Center,
        verticalDirection: VerticalAlignment.Bottom,
        openAnimation: useAnimation(fadeIn, {
          params: {
            duration: '.35s',
            easing: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
            fromPosition: 'translateY(100%)',
            toPosition: 'translateY(0)'
          }
        }),
        closeAnimation: useAnimation(fadeOut, {
          params: {
            duration: '.2s',
            easing: 'cubic-bezier(0.4, 0.0, 1, 1)',
            fromPosition: 'translateY(0)',
            toPosition: 'translateY(100%)'
          }
        })
      };
    }
    /**
     * Get the position and animation settings used by the snackbar.
     * ```typescript
     * @ViewChild('snackbar', { static: true }) public snackbar: IgxSnackbarComponent;
     * let currentPosition: PositionSettings = this.snackbar.positionSettings
     * ```
     */
    get positionSettings() {
      return this._positionSettings;
    }
    /**
     * Set the position and animation settings used by the snackbar.
     * ```html
     * <igx-snackbar [positionSettings]="newPositionSettings"></igx-snackbar>
     * ```
     * ```typescript
     * import { slideInTop, slideOutBottom } from 'igniteui-angular';
     * ...
     * @ViewChild('snackbar', { static: true }) public snackbar: IgxSnackbarComponent;
     *  public newPositionSettings: PositionSettings = {
     *      openAnimation: useAnimation(slideInTop, { params: { duration: '1000ms', fromPosition: 'translateY(100%)'}}),
     *      closeAnimation: useAnimation(slideOutBottom, { params: { duration: '1000ms', fromPosition: 'translateY(0)'}}),
     *      horizontalDirection: HorizontalAlignment.Left,
     *      verticalDirection: VerticalAlignment.Middle,
     *      horizontalStartPoint: HorizontalAlignment.Left,
     *      verticalStartPoint: VerticalAlignment.Middle,
     *      minSize: { height: 100, width: 100 }
     *  };
     * this.snackbar.positionSettings = this.newPositionSettings;
     * ```
     */
    set positionSettings(settings) {
      this._positionSettings = settings;
    }
    /**
     * Shows the snackbar and hides it after the `displayTime` is over if `autoHide` is set to `true`.
     * ```typescript
     * this.snackbar.open();
     * ```
     */
    open(message) {
      if (message !== undefined) {
        this.textMessage = message;
      }
      this.strategy = this.outlet ? new ContainerPositionStrategy(this.positionSettings) : new GlobalPositionStrategy(this.positionSettings);
      super.open();
    }
    /**
     * Opens or closes the snackbar, depending on its current state.
     *
     * ```typescript
     * this.snackbar.toggle();
     * ```
     */
    toggle() {
      if (this.collapsed || this.isClosing) {
        this.open();
      } else {
        this.close();
      }
    }
    /**
     * @hidden
     */
    triggerAction() {
      this.clicked.emit(this);
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this.opened.pipe(takeUntil(this.destroy$)).subscribe(() => {
        const openedEventArgs = {
          owner: this,
          id: this._overlayId
        };
        this.animationStarted.emit(openedEventArgs);
      });
      this.closed.pipe(takeUntil(this.destroy$)).subscribe(() => {
        const closedEventArgs = {
          owner: this,
          id: this._overlayId
        };
        this.animationDone.emit(closedEventArgs);
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxSnackbarComponent_BaseFactory;
        return function IgxSnackbarComponent_Factory(__ngFactoryType__) {
          return (ɵIgxSnackbarComponent_BaseFactory || (ɵIgxSnackbarComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxSnackbarComponent)))(__ngFactoryType__ || IgxSnackbarComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSnackbarComponent,
        selectors: [["igx-snackbar"]],
        hostVars: 3,
        hostBindings: function IgxSnackbarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-snackbar", ctx.cssClass);
          }
        },
        inputs: {
          id: "id",
          actionText: "actionText",
          positionSettings: "positionSettings"
        },
        outputs: {
          clicked: "clicked",
          animationStarted: "animationStarted",
          animationDone: "animationDone"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c184,
        decls: 7,
        vars: 2,
        consts: [["customButton", ""], [1, "igx-snackbar__message"], [1, "igx-snackbar__button"], ["igxButton", ""], ["igxButton", "", 3, "click"]],
        template: function IgxSnackbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c183);
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtext(1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2, 0);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, IgxSnackbarComponent_Conditional_6_Template, 2, 1, "button", 3);
          }
          if (rf & 2) {
            const customButton_r3 = i0.ɵɵreference(4);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.textMessage, " ");
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!customButton_r3.children.length && ctx.actionText ? 6 : -1);
          }
        },
        dependencies: [IgxButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxSnackbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden @internal */
class IgxPaginatorToken {}

/**
 * An internal component representing the group-by drop area for the igx-grid component.
 *
 * @hidden @internal
 */
let IgxGridGroupByAreaComponent = /*#__PURE__*/(() => {
  class IgxGridGroupByAreaComponent extends IgxGroupByAreaDirective {
    constructor(ref, platform) {
      super(ref, platform);
      this.sortingExpressions = [];
    }
    handleReorder(event) {
      const {
        chipsArray,
        originalEvent
      } = event;
      const newExpressions = this.getReorderedExpressions(chipsArray);
      this.grid.groupingExpansionState = [];
      this.expressions = newExpressions;
      // When reordered using keyboard navigation, we don't have `onMoveEnd` event.
      if (originalEvent instanceof KeyboardEvent) {
        this.grid.groupingExpressions = newExpressions;
      }
    }
    handleMoveEnd() {
      this.grid.groupingExpressions = this.expressions;
    }
    groupBy(expression) {
      this.grid.groupBy(expression);
    }
    clearGrouping(name) {
      this.grid.clearGrouping(name);
    }
    static {
      this.ɵfac = function IgxGridGroupByAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridGroupByAreaComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridGroupByAreaComponent,
        selectors: [["igx-grid-group-by-area"]],
        inputs: {
          sortingExpressions: "sortingExpressions",
          grid: "grid"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxGroupByAreaDirective,
          useExisting: IgxGridGroupByAreaComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 3,
        consts: [["default", ""], [3, "reorder", "moveEnd"], ["igxGroupAreaDrop", "", 1, "igx-drop-area", 3, "igxDrop", "hidden"], [4, "ngTemplateOutlet"], [3, "keyDown", "remove", "chipClick", "id", "title", "removable", "draggable", "disabled"], ["family", "default", "igxSuffix", "", 3, "name"], [1, "igx-grid-grouparea__connector"], ["family", "default", "name", "arrow_forward", 3, "hidden"], ["family", "default", "name", "group_work", 1, "igx-drop-area__icon"], [1, "igx-drop-area__text"]],
        template: function IgxGridGroupByAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-chips-area", 1);
            i0.ɵɵlistener("reorder", function IgxGridGroupByAreaComponent_Template_igx_chips_area_reorder_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleReorder($event));
            })("moveEnd", function IgxGridGroupByAreaComponent_Template_igx_chips_area_moveEnd_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleMoveEnd());
            });
            i0.ɵɵrepeaterCreate(1, IgxGridGroupByAreaComponent_For_2_Template, 11, 28, null, null, _forTrack11);
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵlistener("igxDrop", function IgxGridGroupByAreaComponent_Template_div_igxDrop_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDragDrop($event));
            });
            i0.ɵɵtemplate(4, IgxGridGroupByAreaComponent_ng_container_4_Template, 1, 0, "ng-container", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, IgxGridGroupByAreaComponent_ng_template_5_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const default_r7 = i0.ɵɵreference(6);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.chipExpressions);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.dropAreaVisible);
            i0.ɵɵattribute("gridId", ctx.grid.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.dropAreaTemplate || default_r7);
          }
        },
        dependencies: [IgxChipsAreaComponent, IgxChipComponent, IgxIconComponent, IgxSuffixDirective, IgxGroupAreaDropDirective, IgxDropDirective, NgTemplateOutlet, IgxGroupByMetaPipe],
        encapsulation: 2
      });
    }
  }
  return IgxGridGroupByAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Injection token for accessing the grid transaction object.
 * This allows injecting the grid transaction object into components or services.
 */
const IgxGridTransaction = /*@__PURE__*/new InjectionToken('IgxGridTransaction');
let IgxGridValidationService = /*#__PURE__*/(() => {
  class IgxGridValidationService {
    constructor() {
      this._validityStates = new Map();
      this._valid = true;
    }
    /** Gets whether state is valid.
    */
    get valid() {
      return this._valid;
    }
    /**
     * @hidden
     * @internal
     */
    create(rowId, data) {
      let formGroup = this.getFormGroup(rowId);
      if (!formGroup) {
        formGroup = new FormGroup({});
        for (const col of this.grid.columns) {
          this.addFormControl(formGroup, data, col);
        }
        const args = {
          formGroup,
          owner: this.grid
        };
        this.grid.formGroupCreated.emit(args);
        this.add(rowId, formGroup);
      } else {
        // reset to pristine.
        for (const col of this.grid.columns) {
          const formControl = formGroup.get(col.field);
          if (formControl) {
            formControl.markAsPristine();
          } else {
            this.addFormControl(formGroup, data, col);
          }
        }
      }
      return formGroup;
    }
    /**
    * @hidden
    * @internal
    */
    addFormControl(formGroup, data, column) {
      const value = resolveNestedPath(data || {}, column.field);
      const field = this.getFieldKey(column.field);
      const control = new FormControl(value, {
        updateOn: this.grid.validationTrigger
      });
      control.addValidators(column.validators);
      formGroup.addControl(field, control);
      control.setValue(value);
    }
    /**
     * @hidden
     * @internal
     */
    getFieldKey(path) {
      const parts = path?.split('.') ?? [];
      return parts.join('_');
    }
    /**
     * @hidden
     * @internal
     */
    getFormGroup(id) {
      return this._validityStates.get(id);
    }
    /**
     * @hidden
     * @internal
     */
    getFormControl(rowId, columnKey) {
      const formControl = this.getFormGroup(rowId);
      const field = this.getFieldKey(columnKey);
      return formControl?.get(field);
    }
    /**
     * @hidden
     * @internal
     */
    add(rowId, form) {
      this._validityStates.set(rowId, form);
    }
    /**
     * @hidden
     * @internal
     */
    getValidity() {
      const states = [];
      this._validityStates.forEach((formGroup, key) => {
        const state = [];
        for (const col of this.grid.columns) {
          const colKey = this.getFieldKey(col.field);
          const control = formGroup.get(colKey);
          if (control) {
            state.push({
              field: colKey,
              status: control.status,
              errors: control.errors
            });
          }
        }
        states.push({
          key: key,
          status: formGroup.status,
          fields: state,
          errors: formGroup.errors
        });
      });
      return states;
    }
    /**
     * Returns all invalid record states.
     */
    getInvalid() {
      const validity = this.getValidity();
      return validity.filter(x => x.status === 'INVALID');
    }
    /**
     * @hidden
     * @internal
     */
    update(rowId, rowData) {
      if (!rowData) return;
      const keys = Object.keys(rowData);
      const rowGroup = this.getFormGroup(rowId);
      for (const key of keys) {
        const colKey = this.getFieldKey(key);
        const control = rowGroup?.get(colKey);
        if (control && control.value !== rowData[key]) {
          control.setValue(rowData[key], {
            emitEvent: false
          });
        }
      }
      this.updateStatus();
    }
    /**
     * @hidden
     * @internal
     * Update validity based on new data.
     */
    updateAll(newData) {
      if (!newData || this._validityStates.size === 0) return;
      for (const rec of newData) {
        const rowId = rec[this.grid.primaryKey] || rec;
        if (this.getFormGroup(rowId)) {
          const recAggregatedData = this.grid.transactions.getAggregatedValue(rowId, true) || rec;
          this.update(rowId, recAggregatedData);
        }
      }
    }
    /** Marks the associated record or field as touched.
     * @param key The id of the record that will be marked as touched.
     * @param field Optional. The field from the record that will be marked as touched. If not provided all fields will be touched.
    */
    markAsTouched(key, field) {
      const rowGroup = this.getFormGroup(key);
      if (!rowGroup) return;
      rowGroup.markAsTouched();
      const fields = field ? [field] : this.grid.columns.map(x => x.field);
      for (const currField of fields) {
        const colKey = this.getFieldKey(currField);
        rowGroup?.get(colKey)?.markAsTouched();
      }
    }
    /**
     * @hidden
     * @internal
     */
    updateStatus() {
      const currentValid = this.valid;
      this._valid = this.getInvalid().length === 0;
      if (this.valid !== currentValid) {
        this.grid.validationStatusChange.emit({
          status: this.valid ? 'VALID' : 'INVALID',
          owner: this.grid
        });
      }
    }
    /** Clears validation state by key or all states if none is provided.
     * @param key Optional. The key of the record for which to clear state.
    */
    clear(key) {
      if (key !== undefined) {
        this._validityStates.delete(key);
      } else {
        this._validityStates.clear();
      }
      this.updateStatus();
    }
    static {
      this.ɵfac = function IgxGridValidationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridValidationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridValidationService,
        factory: IgxGridValidationService.ɵfac
      });
    }
  }
  return IgxGridValidationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxGridNavigationService = /*#__PURE__*/(() => {
  class IgxGridNavigationService {
    get activeNode() {
      return this._activeNode;
    }
    set activeNode(value) {
      this._activeNode = value;
    }
    constructor(platform) {
      this.platform = platform;
      this._activeNode = {};
      this.lastActiveNode = {};
      this.pendingNavigation = false;
    }
    handleNavigation(event) {
      const key = event.key.toLowerCase();
      if (NAVIGATION_KEYS.has(key)) {
        event.stopPropagation();
      }
      if (this.grid.crudService.cell && NAVIGATION_KEYS.has(key)) {
        return;
      }
      if (event.repeat && SUPPORTED_KEYS.has(key) || key === 'tab' && this.grid.crudService.cell) {
        event.preventDefault();
      }
      if (event.repeat) {
        setTimeout(() => this.dispatchEvent(event), 1);
      } else {
        this.dispatchEvent(event);
      }
    }
    dispatchEvent(event) {
      const key = event.key.toLowerCase();
      const cellOrRowInEdit = this.grid.crudService.cell || this.grid.crudService.row;
      if (!this.activeNode || !(SUPPORTED_KEYS.has(key) || key === 'tab' && cellOrRowInEdit)) {
        return;
      }
      const shift = event.shiftKey;
      const ctrl = event.ctrlKey;
      if (NAVIGATION_KEYS.has(key) && this.pendingNavigation) {
        event.preventDefault();
        return;
      }
      const type = this.isDataRow(this.activeNode.row) ? 'dataCell' : this.isDataRow(this.activeNode.row, true) ? 'summaryCell' : 'groupRow';
      if (this.emitKeyDown(type, this.activeNode.row, event)) {
        return;
      }
      if (event.altKey) {
        this.handleAlt(key, event);
        return;
      }
      if ([' ', 'spacebar', 'space'].indexOf(key) === -1) {
        this.grid.selectionService.keyboardStateOnKeydown(this.activeNode, shift, shift && key === 'tab');
      }
      const position = this.getNextPosition(this.activeNode.row, this.activeNode.column, key, shift, ctrl, event);
      if (NAVIGATION_KEYS.has(key)) {
        event.preventDefault();
        this.navigateInBody(position.rowIndex, position.colIndex, obj => {
          obj.target.activate(event);
          this.grid.cdr.detectChanges();
        });
      }
      this.grid.cdr.detectChanges();
    }
    summaryNav(event) {
      if (this.grid.hasSummarizedColumns) {
        this.horizontalNav(event, event.key.toLowerCase(), this.grid.dataView.length, 'summaryCell');
      }
    }
    headerNavigation(event) {
      const key = event.key.toLowerCase();
      if (!HEADER_KEYS.has(key) || this.activeNode?.row !== -1) {
        return;
      }
      event.preventDefault();
      const ctrl = event.ctrlKey;
      const shift = event.shiftKey;
      const alt = event.altKey;
      this.performHeaderKeyCombination(this.currentActiveColumn, key, shift, ctrl, alt, event);
      if (shift || alt || ctrl && (key.includes('down') || key.includes('down'))) {
        return;
      }
      if (this.grid.hasColumnGroups) {
        this.handleMCHeaderNav(key, ctrl);
      } else {
        this.horizontalNav(event, key, -1, 'headerCell');
      }
    }
    focusTbody(event) {
      const gridRows = this.grid.verticalScrollContainer.totalItemCount ?? this.grid.dataView.length;
      if (gridRows < 1) {
        this.activeNode = null;
        return;
      }
      if (!this.activeNode || !Object.keys(this.activeNode).length || this.activeNode.row < 0 || this.activeNode.row > gridRows - 1) {
        const hasLastActiveNode = Object.keys(this.lastActiveNode).length;
        const shouldClearSelection = hasLastActiveNode && (this.lastActiveNode.row < 0 || this.lastActiveNode.row > gridRows - 1);
        this.setActiveNode(this.lastActiveNode.row >= 0 && this.lastActiveNode.row < gridRows ? this.firstVisibleNode(this.lastActiveNode.row) : this.firstVisibleNode());
        if (shouldClearSelection || this.grid.cellSelection !== GridSelectionMode.multiple) {
          this.grid.clearCellSelection();
          this.grid.navigateTo(this.activeNode.row, this.activeNode.column, obj => {
            obj.target?.activate(event);
            this.grid.cdr.detectChanges();
          });
        } else {
          if (hasLastActiveNode && !this.grid.selectionService.selected(this.lastActiveNode)) {
            return;
          }
          const range = {
            rowStart: this.activeNode.row,
            rowEnd: this.activeNode.row,
            columnStart: this.activeNode.column,
            columnEnd: this.activeNode.column
          };
          this.grid.selectRange(range);
          this.grid.notifyChanges();
        }
      }
    }
    focusFirstCell(header = true) {
      if ((header || this.grid.dataView.length) && this.activeNode && (this.activeNode.row === -1 || this.activeNode.row === this.grid.dataView.length || !header && !this.grid.hasSummarizedColumns)) {
        return;
      }
      const shouldScrollIntoView = this.lastActiveNode && header && this.lastActiveNode.row !== -1 || !header && this.lastActiveNode.row !== this.grid.dataView.length;
      this.setActiveNode(this.firstVisibleNode(header ? -1 : this.grid.dataView.length));
      if (shouldScrollIntoView) {
        this.performHorizontalScrollToCell(this.activeNode.column);
      }
    }
    isColumnFullyVisible(columnIndex) {
      if (columnIndex < 0 || this.isColumnPinned(columnIndex, this.forOfDir())) {
        return true;
      }
      const index = this.getColumnUnpinnedIndex(columnIndex);
      const width = this.forOfDir().getColumnScrollLeft(index + 1) - this.forOfDir().getColumnScrollLeft(index);
      if (this.displayContainerWidth < width && this.displayContainerScrollLeft === this.forOfDir().getColumnScrollLeft(index)) {
        return true;
      }
      return this.displayContainerWidth >= this.forOfDir().getColumnScrollLeft(index + 1) - this.displayContainerScrollLeft && this.displayContainerScrollLeft <= this.forOfDir().getColumnScrollLeft(index);
    }
    shouldPerformHorizontalScroll(visibleColIndex, rowIndex = -1) {
      if (visibleColIndex < 0 || visibleColIndex > this.grid.visibleColumns.length - 1) {
        return false;
      }
      if (rowIndex < 0 || rowIndex > this.grid.dataView.length - 1) {
        return !this.isColumnFullyVisible(visibleColIndex);
      }
      const row = this.grid.dataView[rowIndex];
      return row.expression || row.detailsData ? false : !this.isColumnFullyVisible(visibleColIndex);
    }
    shouldPerformVerticalScroll(targetRowIndex, _visibleColIndex) {
      if (this.grid.isRecordPinnedByViewIndex(targetRowIndex)) {
        return false;
      }
      const scrollRowIndex = this.grid.hasPinnedRecords && this.grid.isRowPinningToTop ? targetRowIndex - this.grid.pinnedDataView.length : targetRowIndex;
      const targetRow = this.getRowElementByIndex(targetRowIndex);
      const rowHeight = this.grid.verticalScrollContainer.getSizeAt(scrollRowIndex);
      const containerHeight = this.grid.calcHeight ? Math.ceil(this.grid.calcHeight) : 0;
      const endTopOffset = targetRow ? targetRow.offsetTop + rowHeight + this.containerTopOffset : containerHeight + rowHeight;
      // this is workaround: endTopOffset - containerHeight > 5 and should be replaced with: containerHeight < endTopOffset
      // when the page is zoomed the grid does not scroll the row completely in the view
      return !targetRow || targetRow.offsetTop < Math.abs(this.containerTopOffset) || containerHeight && endTopOffset - containerHeight > 5;
    }
    performVerticalScrollToCell(rowIndex, visibleColIndex = -1, cb) {
      if (!this.shouldPerformVerticalScroll(rowIndex, visibleColIndex)) {
        if (cb) {
          cb();
        }
        return;
      }
      this.pendingNavigation = true;
      // Only for top pinning we need to subtract pinned count because virtualization indexing doesn't count pinned rows.
      const scrollRowIndex = this.grid.hasPinnedRecords && this.grid.isRowPinningToTop ? rowIndex - this.grid.pinnedDataView.length : rowIndex;
      this.grid.verticalScrollContainer.scrollTo(scrollRowIndex);
      this.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
        this.pendingNavigation = false;
        if (cb) {
          cb();
        }
      });
    }
    performHorizontalScrollToCell(visibleColumnIndex, cb) {
      if (this.grid.rowList < 1 && this.grid.summariesRowList.length < 1 && this.grid.hasColumnGroups) {
        let column = this.grid.getColumnByVisibleIndex(visibleColumnIndex);
        while (column.parent) {
          column = column.parent;
        }
        visibleColumnIndex = this.forOfDir().igxForOf.indexOf(column);
      }
      if (!this.shouldPerformHorizontalScroll(visibleColumnIndex)) {
        return;
      }
      this.pendingNavigation = true;
      this.grid.parentVirtDir.chunkLoad.pipe(first$2()).subscribe(() => {
        this.pendingNavigation = false;
        if (cb) {
          cb();
        }
      });
      this.forOfDir().scrollTo(this.getColumnUnpinnedIndex(visibleColumnIndex));
    }
    isDataRow(rowIndex, includeSummary = false) {
      let curRow;
      if (rowIndex < 0 || rowIndex > this.grid.dataView.length - 1) {
        curRow = this.grid.dataView[rowIndex - this.grid.virtualizationState.startIndex];
        if (!curRow) {
          // if data is remote, record might not be in the view yet.
          return this.grid.verticalScrollContainer.isRemote && rowIndex >= 0 && rowIndex <= this.grid.totalItemCount - 1;
        }
      } else {
        curRow = this.grid.dataView[rowIndex];
      }
      return curRow && !this.grid.isGroupByRecord(curRow) && !this.grid.isDetailRecord(curRow) && !curRow.childGridsData && (includeSummary || !curRow.summaries);
    }
    isGroupRow(rowIndex) {
      if (rowIndex < 0 || rowIndex > this.grid.dataView.length - 1) {
        return false;
      }
      const curRow = this.grid.dataView[rowIndex];
      return curRow && this.grid.isGroupByRecord(curRow);
    }
    setActiveNode(activeNode) {
      if (!this.isActiveNodeChanged(activeNode)) {
        return;
      }
      if (!this.activeNode) {
        this.activeNode = activeNode;
      }
      Object.assign(this.activeNode, activeNode);
      const currRow = this.grid.dataView[activeNode.row];
      const type = activeNode.row < 0 ? 'headerCell' : this.isDataRow(activeNode.row) ? 'dataCell' : currRow && this.grid.isGroupByRecord(currRow) ? 'groupRow' : currRow && this.grid.isDetailRecord(currRow) ? 'masterDetailRow' : 'summaryCell';
      const args = {
        row: this.activeNode.row,
        column: this.activeNode.column,
        level: this.activeNode.level,
        tag: type
      };
      this.grid.activeNodeChange.emit(args);
    }
    isActiveNodeChanged(activeNode) {
      let isChanged = false;
      const checkInnerProp = (aciveNode, prop) => {
        if (!aciveNode) {
          isChanged = true;
          return;
        }
        props = Object.getOwnPropertyNames(aciveNode);
        for (const propName of props) {
          if (this.activeNode[prop][propName] !== aciveNode[propName]) {
            isChanged = true;
          }
        }
      };
      if (!this.activeNode) {
        return isChanged = true;
      }
      let props = Object.getOwnPropertyNames(activeNode);
      for (const propName of props) {
        if (!!this.activeNode[propName] && typeof this.activeNode[propName] === 'object') {
          checkInnerProp(activeNode[propName], propName);
        } else if (this.activeNode[propName] !== activeNode[propName]) {
          isChanged = true;
        }
      }
      return isChanged;
    }
    /** Focus the Grid section (header, body, footer) depending on the current activeNode */
    restoreActiveNodeFocus() {
      if (!this.activeNode || !Object.keys(this.activeNode).length) {
        return;
      }
      if (this.activeNode.row >= 0 && this.activeNode.row < this.grid.dataView.length) {
        this.grid.tbody.nativeElement.focus();
      }
      if (this.activeNode.row === -1) {
        this.grid.theadRow.nativeElement.focus();
      }
      if (this.activeNode.row === this.grid.dataView.length) {
        this.grid.tfoot.nativeElement.focus();
      }
    }
    getNextPosition(rowIndex, colIndex, key, shift, ctrl, event) {
      if (!this.isDataRow(rowIndex, true) && (key.indexOf('down') < 0 || key.indexOf('up') < 0) && ctrl) {
        return {
          rowIndex,
          colIndex
        };
      }
      switch (key) {
        case 'pagedown':
        case 'pageup':
          event.preventDefault();
          if (key === 'pagedown') {
            this.grid.verticalScrollContainer.scrollNextPage();
          } else {
            this.grid.verticalScrollContainer.scrollPrevPage();
          }
          const editCell = this.grid.crudService.cell;
          this.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
            if (editCell && this.grid.rowList.map(r => r.index).indexOf(editCell.rowIndex) < 0) {
              this.grid.tbody.nativeElement.focus({
                preventScroll: true
              });
            }
          });
          break;
        case 'tab':
          this.handleEditing(shift, event);
          break;
        case 'end':
          rowIndex = ctrl ? this.findLastDataRowIndex() : this.activeNode.row;
          colIndex = this.lastColumnIndex;
          break;
        case 'home':
          rowIndex = ctrl ? this.findFirstDataRowIndex() : this.activeNode.row;
          colIndex = 0;
          break;
        case 'arrowleft':
        case 'left':
          colIndex = ctrl ? 0 : this.activeNode.column - 1;
          break;
        case 'arrowright':
        case 'right':
          colIndex = ctrl ? this.lastColumnIndex : this.activeNode.column + 1;
          break;
        case 'arrowup':
        case 'up':
          if (ctrl && !this.isDataRow(rowIndex) || this.grid.rowEditable && this.grid.crudService.rowEditingBlocked) {
            break;
          }
          colIndex = this.activeNode.column !== undefined ? this.activeNode.column : 0;
          rowIndex = ctrl ? this.findFirstDataRowIndex() : this.activeNode.row - 1;
          break;
        case 'arrowdown':
        case 'down':
          if (ctrl && !this.isDataRow(rowIndex) || this.grid.rowEditable && this.grid.crudService.rowEditingBlocked) {
            break;
          }
          colIndex = this.activeNode.column !== undefined ? this.activeNode.column : 0;
          rowIndex = ctrl ? this.findLastDataRowIndex() : this.activeNode.row + 1;
          break;
        case 'enter':
        case 'f2':
          const cell = this.grid.gridAPI.get_cell_by_visible_index(this.activeNode.row, this.activeNode.column);
          if (!this.isDataRow(rowIndex) || !cell.editable) {
            break;
          }
          this.grid.crudService.enterEditMode(cell, event);
          break;
        case 'escape':
        case 'esc':
          if (!this.isDataRow(rowIndex)) {
            break;
          }
          if (this.grid.crudService.isInCompositionMode) {
            return;
          }
          if (this.grid.crudService.cellInEditMode || this.grid.crudService.rowInEditMode) {
            this.grid.crudService.endEdit(false, event);
            if (this.platform.isEdge) {
              this.grid.cdr.detectChanges();
            }
            this.grid.tbody.nativeElement.focus();
          }
          break;
        case ' ':
        case 'spacebar':
        case 'space':
          const rowObj = this.grid.gridAPI.get_row_by_index(this.activeNode.row);
          if (this.grid.isRowSelectable && rowObj) {
            if (this.isDataRow(rowIndex)) {
              if (rowObj.selected) {
                this.grid.selectionService.deselectRow(rowObj.key, event);
              } else {
                this.grid.selectionService.selectRowById(rowObj.key, false, event);
              }
            }
            if (this.isGroupRow(rowIndex)) {
              rowObj.onGroupSelectorClick(event);
            }
          }
          break;
        default:
          return;
      }
      return {
        rowIndex,
        colIndex
      };
    }
    horizontalNav(event, key, rowIndex, tag) {
      const ctrl = event.ctrlKey;
      if (!HORIZONTAL_NAV_KEYS.has(event.key.toLowerCase())) {
        return;
      }
      event.preventDefault();
      this.activeNode.row = rowIndex;
      if (rowIndex > 0) {
        if (this.emitKeyDown('summaryCell', this.activeNode.row, event)) {
          return;
        }
      }
      const newActiveNode = {
        column: this.activeNode.column,
        mchCache: {
          level: this.activeNode.level,
          visibleIndex: this.activeNode.column
        }
      };
      if ((key.includes('left') || key === 'home') && this.activeNode.column > 0) {
        newActiveNode.column = ctrl || key === 'home' ? 0 : this.activeNode.column - 1;
      }
      if ((key.includes('right') || key === 'end') && this.activeNode.column < this.lastColumnIndex) {
        newActiveNode.column = ctrl || key === 'end' ? this.lastColumnIndex : this.activeNode.column + 1;
      }
      if (tag === 'headerCell') {
        const column = this.grid.getColumnByVisibleIndex(newActiveNode.column);
        newActiveNode.mchCache.level = column.level;
        newActiveNode.mchCache.visibleIndex = column.visibleIndex;
      }
      this.setActiveNode({
        row: this.activeNode.row,
        column: newActiveNode.column,
        mchCache: newActiveNode.mchCache
      });
      this.performHorizontalScrollToCell(this.activeNode.column);
    }
    get lastColumnIndex() {
      return Math.max(...this.grid.visibleColumns.map(col => col.visibleIndex));
    }
    get displayContainerWidth() {
      return Math.round(this.grid.parentVirtDir.dc.instance._viewContainer.element.nativeElement.offsetWidth);
    }
    get displayContainerScrollLeft() {
      return Math.ceil(this.grid.headerContainer.scrollPosition);
    }
    get containerTopOffset() {
      return parseInt(this.grid.verticalScrollContainer.dc.instance._viewContainer.element.nativeElement.style.top, 10);
    }
    getColumnUnpinnedIndex(visibleColumnIndex) {
      const column = this.grid.unpinnedColumns.find(col => !col.columnGroup && col.visibleIndex === visibleColumnIndex);
      return this.grid.pinnedColumns.length ? this.grid.unpinnedColumns.filter(c => !c.columnGroup).indexOf(column) : visibleColumnIndex;
    }
    forOfDir() {
      const forOfDir = this.grid.dataRowList.length > 0 ? this.grid.dataRowList.first.virtDirRow : this.grid.summariesRowList.length ? this.grid.summariesRowList.first.virtDirRow : this.grid.headerContainer;
      return forOfDir;
    }
    handleAlt(key, event) {
      event.preventDefault();
      // todo TODO ROW
      const row = this.grid.gridAPI.get_row_by_index(this.activeNode.row);
      if (!(this.isToggleKey(key) || this.isAddKey(key)) || !row) {
        return;
      }
      if (this.isAddKey(key)) {
        if (!this.grid.rowEditable) {
          console.warn('The grid must be in row edit mode to perform row adding!');
          return;
        }
        if (event.shiftKey && row.treeRow !== undefined) {
          this.grid.crudService.enterAddRowMode(row, true, event);
        } else if (!event.shiftKey) {
          this.grid.crudService.enterAddRowMode(row, false, event);
        }
      } else if (!row.expanded && ROW_EXPAND_KEYS.has(key)) {
        if (row.key === undefined) {
          // TODO use expanded row.expanded = !row.expanded;
          row.toggle();
        } else {
          this.grid.gridAPI.set_row_expansion_state(row.key, true, event);
        }
      } else if (row.expanded && ROW_COLLAPSE_KEYS.has(key)) {
        if (row.key === undefined) {
          // TODO use expanded row.expanded = !row.expanded;
          row.toggle();
        } else {
          this.grid.gridAPI.set_row_expansion_state(row.key, false, event);
        }
      }
      this.grid.notifyChanges();
    }
    handleEditing(shift, event) {
      const next = shift ? this.grid.getPreviousCell(this.activeNode.row, this.activeNode.column, col => col.editable) : this.grid.getNextCell(this.activeNode.row, this.activeNode.column, col => col.editable);
      if (!this.grid.crudService.rowInEditMode && this.isActiveNode(next.rowIndex, next.visibleColumnIndex)) {
        this.grid.crudService.endEdit(true, event);
        this.grid.tbody.nativeElement.focus();
        return;
      }
      event.preventDefault();
      if (this.grid.crudService.rowInEditMode && this.grid.rowEditTabs.length && (this.activeNode.row !== next.rowIndex || this.isActiveNode(next.rowIndex, next.visibleColumnIndex))) {
        const args = this.grid.crudService.updateCell(true, event);
        if (args.cancel) {
          return;
        } else if (shift) {
          this.grid.rowEditTabs.last.element.nativeElement.focus();
        } else {
          this.grid.rowEditTabs.first.element.nativeElement.focus();
        }
        return;
      }
      if (this.grid.crudService.rowInEditMode && !this.grid.rowEditTabs.length) {
        if (shift && next.rowIndex === this.activeNode.row && next.visibleColumnIndex === this.activeNode.column) {
          next.visibleColumnIndex = this.grid.lastEditableColumnIndex;
        } else if (!shift && next.rowIndex === this.activeNode.row && next.visibleColumnIndex === this.activeNode.column) {
          next.visibleColumnIndex = this.grid.firstEditableColumnIndex;
        } else {
          next.rowIndex = this.activeNode.row;
        }
      }
      this.navigateInBody(next.rowIndex, next.visibleColumnIndex, obj => {
        obj.target.activate(event);
        this.grid.cdr.detectChanges();
      });
    }
    navigateInBody(rowIndex, visibleColIndex, cb = null) {
      if (!this.isValidPosition(rowIndex, visibleColIndex) || this.isActiveNode(rowIndex, visibleColIndex)) {
        return;
      }
      this.grid.navigateTo(rowIndex, visibleColIndex, cb);
    }
    emitKeyDown(type, rowIndex, event) {
      const row = this.grid.summariesRowList.toArray().concat(this.grid.rowList.toArray()).find(r => r.index === rowIndex);
      if (!row) {
        return;
      }
      const target = type === 'groupRow' ? row : type === 'dataCell' ? row.cells?.find(c => c.visibleColumnIndex === this.activeNode.column) : row.summaryCells?.find(c => c.visibleColumnIndex === this.activeNode.column);
      const keydownArgs = {
        targetType: type,
        event,
        cancel: false,
        target
      };
      this.grid.gridKeydown.emit(keydownArgs);
      if (keydownArgs.cancel && type === 'dataCell') {
        this.grid.selectionService.clear();
        this.grid.selectionService.keyboardState.active = true;
        return keydownArgs.cancel;
      }
    }
    isColumnPinned(columnIndex, forOfDir) {
      const horizontalScroll = forOfDir.getScroll();
      return !horizontalScroll.clientWidth || this.grid.getColumnByVisibleIndex(columnIndex)?.pinned;
    }
    findFirstDataRowIndex() {
      return this.grid.dataView.findIndex(rec => !this.grid.isGroupByRecord(rec) && !this.grid.isDetailRecord(rec) && !rec.summaries);
    }
    findLastDataRowIndex() {
      if (this.grid.totalItemCount) {
        return this.grid.totalItemCount - 1;
      }
      let i = this.grid.dataView.length;
      while (i--) {
        if (this.isDataRow(i)) {
          return i;
        }
      }
    }
    getRowElementByIndex(index) {
      if (this.grid.hasDetails) {
        const detail = this.grid.nativeElement.querySelector(`[detail="true"][data-rowindex="${index}"]`);
        if (detail) {
          return detail;
        }
      }
      return this.grid.rowList.toArray().concat(this.grid.summariesRowList.toArray()).find(r => r.index === index)?.nativeElement;
    }
    isValidPosition(rowIndex, colIndex) {
      const length = this.grid.totalItemCount ?? this.grid.dataView.length;
      if (rowIndex < 0 || colIndex < 0 || length - 1 < rowIndex || this.lastColumnIndex < colIndex) {
        return false;
      }
      return this.activeNode.column !== colIndex && !this.isDataRow(rowIndex, true) ? false : true;
    }
    performHeaderKeyCombination(column, key, shift, ctrl, alt, event) {
      let direction = this.grid.sortingExpressions.find(expr => expr.fieldName === column.field)?.dir;
      if (ctrl && key.includes('up') && column.sortable && !column.columnGroup) {
        direction = direction === SortingDirection.Asc ? SortingDirection.None : SortingDirection.Asc;
        this.grid.sort({
          fieldName: column.field,
          dir: direction,
          ignoreCase: false
        });
        return;
      }
      if (ctrl && key.includes('down') && column.sortable && !column.columnGroup) {
        direction = direction === SortingDirection.Desc ? SortingDirection.None : SortingDirection.Desc;
        this.grid.sort({
          fieldName: column.field,
          dir: direction,
          ignoreCase: false
        });
        return;
      }
      if (shift && alt && this.isToggleKey(key) && !column.columnGroup && column.groupable) {
        direction = direction || SortingDirection.Asc;
        if (key.includes('right')) {
          this.grid.groupBy({
            fieldName: column.field,
            dir: direction,
            ignoreCase: column.sortingIgnoreCase,
            strategy: column.sortStrategy,
            groupingComparer: column.groupingComparer
          });
        } else {
          this.grid.clearGrouping(column.field);
        }
        this.activeNode.column = key.includes('right') && this.grid.hideGroupedColumns && column.visibleIndex === this.lastColumnIndex ? this.lastColumnIndex - 1 : this.activeNode.column;
        return;
      }
      if (alt && (ROW_EXPAND_KEYS.has(key) || ROW_COLLAPSE_KEYS.has(key))) {
        this.handleMCHExpandCollapse(key, column);
        return;
      }
      if ([' ', 'spacebar', 'space'].indexOf(key) !== -1) {
        this.handleColumnSelection(column, event);
      }
      if (alt && (key === 'l' || key === '¬') && this.grid.allowAdvancedFiltering) {
        this.grid.openAdvancedFilteringDialog();
      }
      if (ctrl && shift && key === 'l' && this.grid.allowFiltering && !column.columnGroup && column.filterable) {
        if (this.grid.filterMode === FilterMode.excelStyleFilter) {
          const headerEl = this.grid.headerGroups.find(g => g.active).nativeElement;
          this.grid.filteringService.toggleFilterDropdown(headerEl, column);
        } else {
          this.performHorizontalScrollToCell(column.visibleIndex);
          this.grid.filteringService.filteredColumn = column;
          this.grid.filteringService.isFilterRowVisible = true;
        }
      }
    }
    firstVisibleNode(rowIndex) {
      const colIndex = this.lastActiveNode.column !== undefined ? this.lastActiveNode.column : this.grid.visibleColumns.sort((c1, c2) => c1.visibleIndex - c2.visibleIndex).find(c => this.isColumnFullyVisible(c.visibleIndex))?.visibleIndex;
      const column = this.grid.visibleColumns.find(col => !col.columnLayout && col.visibleIndex === colIndex);
      const rowInd = rowIndex ? rowIndex : this.grid.rowList.find(r => !this.shouldPerformVerticalScroll(r.index, colIndex))?.index;
      const node = {
        row: rowInd ?? 0,
        column: column?.visibleIndex ?? 0,
        level: column?.level ?? 0,
        mchCache: column ? {
          level: column.level,
          visibleIndex: column.visibleIndex
        } : {},
        layout: column && column.columnLayoutChild ? {
          rowStart: column.rowStart,
          colStart: column.colStart,
          rowEnd: column.rowEnd,
          colEnd: column.colEnd,
          columnVisibleIndex: column.visibleIndex
        } : null
      };
      return node;
    }
    handleMCHeaderNav(key, ctrl) {
      const newHeaderNode = {
        visibleIndex: this.activeNode.mchCache.visibleIndex,
        level: this.activeNode.mchCache.level
      };
      const activeCol = this.currentActiveColumn;
      const lastGroupIndex = Math.max(...this.grid.visibleColumns.filter(c => c.level <= this.activeNode.level).map(col => col.visibleIndex));
      let nextCol = activeCol;
      if ((key.includes('left') || key === 'home') && this.activeNode.column > 0) {
        const index = ctrl || key === 'home' ? 0 : this.activeNode.column - 1;
        nextCol = this.getNextColumnMCH(index);
        newHeaderNode.visibleIndex = nextCol.visibleIndex;
      }
      if ((key.includes('right') || key === 'end') && activeCol.visibleIndex < lastGroupIndex) {
        const nextVIndex = activeCol.children ? Math.max(...activeCol.allChildren.map(c => c.visibleIndex)) + 1 : activeCol.visibleIndex + 1;
        nextCol = ctrl || key === 'end' ? this.getNextColumnMCH(this.lastColumnIndex) : this.getNextColumnMCH(nextVIndex);
        newHeaderNode.visibleIndex = nextCol.visibleIndex;
      }
      if (!ctrl && key.includes('up') && this.activeNode.level > 0) {
        nextCol = activeCol.parent;
        newHeaderNode.level = nextCol.level;
      }
      if (!ctrl && key.includes('down') && activeCol.children) {
        nextCol = activeCol.children.find(c => c.visibleIndex === newHeaderNode.visibleIndex) || activeCol.children.toArray().sort((a, b) => b.visibleIndex - a.visibleIndex).filter(col => col.visibleIndex < newHeaderNode.visibleIndex)[0];
        newHeaderNode.level = nextCol.level;
      }
      this.setActiveNode({
        row: this.activeNode.row,
        column: nextCol.visibleIndex,
        level: nextCol.level,
        mchCache: newHeaderNode
      });
      this.performHorizontalScrollToCell(nextCol.visibleIndex);
    }
    handleMCHExpandCollapse(key, column) {
      if (!column.children || !column.collapsible) {
        return;
      }
      if (!column.expanded && ROW_EXPAND_KEYS.has(key)) {
        column.expanded = true;
      } else if (column.expanded && ROW_COLLAPSE_KEYS.has(key)) {
        column.expanded = false;
      }
    }
    handleColumnSelection(column, event) {
      if (!column.selectable || this.grid.columnSelection === GridSelectionMode.none) {
        return;
      }
      const clearSelection = this.grid.columnSelection === GridSelectionMode.single;
      const columnsToSelect = !column.children ? [column.field] : column.allChildren.filter(c => !c.hidden && c.selectable && !c.columnGroup).map(c => c.field);
      if (column.selected) {
        this.grid.selectionService.deselectColumns(columnsToSelect, event);
      } else {
        this.grid.selectionService.selectColumns(columnsToSelect, clearSelection, false, event);
      }
    }
    getNextColumnMCH(visibleIndex) {
      let col = this.grid.getColumnByVisibleIndex(visibleIndex);
      let parent = col.parent;
      while (parent && col.level > this.activeNode.mchCache.level) {
        col = col.parent;
        parent = col.parent;
      }
      return col;
    }
    get currentActiveColumn() {
      return this.grid.visibleColumns.find(c => c.visibleIndex === this.activeNode.column && c.level === this.activeNode.level);
    }
    isActiveNode(rIndex, cIndex) {
      return this.activeNode ? this.activeNode.row === rIndex && this.activeNode.column === cIndex : false;
    }
    isToggleKey(key) {
      return ROW_COLLAPSE_KEYS.has(key) || ROW_EXPAND_KEYS.has(key);
    }
    isAddKey(key) {
      return ROW_ADD_KEYS.has(key);
    }
    static {
      this.ɵfac = function IgxGridNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridNavigationService)(i0.ɵɵinject(PlatformUtil));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridNavigationService,
        factory: IgxGridNavigationService.ɵfac
      });
    }
  }
  return IgxGridNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxGridSummaryService = /*#__PURE__*/(() => {
  class IgxGridSummaryService {
    constructor() {
      this.rootSummaryID = 'igxGridRootSummary';
      this.summaryHeight = 0;
      this.maxSummariesLength = 0;
      this.groupingExpressions = [];
      this.retriggerRootPipe = 0;
      this.deleteOperation = false;
      this.summaryCacheMap = new Map();
    }
    recalculateSummaries() {
      this.resetSummaryHeight();
      this.grid.notifyChanges(true);
    }
    clearSummaryCache(args) {
      if (!this.summaryCacheMap.size) {
        return;
      }
      if (!args) {
        this.summaryCacheMap.clear();
        if (this.grid && this.grid.rootSummariesEnabled) {
          this.retriggerRootPipe++;
        }
        return;
      }
      if (args.data) {
        const rowID = this.grid.primaryKey ? args.data[this.grid.primaryKey] : args.data;
        this.removeSummaries(rowID);
      }
      if (args.rowID !== undefined && args.rowID !== null) {
        let columnName = args.cellID ? this.grid.columns.find(col => col.index === args.cellID.columnID).field : undefined;
        if (columnName && this.grid.rowEditable) {
          return;
        }
        const isGroupedColumn = this.grid.groupingExpressions && this.grid.groupingExpressions.map(expr => expr.fieldName).indexOf(columnName) !== -1;
        if (columnName && isGroupedColumn) {
          columnName = undefined;
        }
        this.removeSummaries(args.rowID, columnName);
      }
    }
    removeSummaries(rowID, columnName) {
      this.deleteSummaryCache(this.rootSummaryID, columnName);
      if (this.summaryCacheMap.size === 1 && this.summaryCacheMap.has(this.rootSummaryID)) {
        return;
      }
      if (this.grid.type === 'tree') {
        if (this.grid.transactions.enabled && this.deleteOperation) {
          this.deleteOperation = false;
          // TODO: this.removeChildRowSummaries(rowID, columnName);
          this.summaryCacheMap.clear();
          return;
        }
        this.removeAllTreeGridSummaries(rowID, columnName);
      } else if (this.grid.type === 'hierarchical') {
        if (this.grid.transactions.enabled && this.deleteOperation) {
          this.deleteOperation = false;
          this.summaryCacheMap.clear();
        }
      } else {
        const summaryIds = this.getSummaryID(rowID, this.grid.groupingExpressions);
        summaryIds.forEach(id => {
          this.deleteSummaryCache(id, columnName);
        });
      }
    }
    removeSummariesCachePerColumn(columnName) {
      this.summaryCacheMap.forEach(cache => {
        if (cache.get(columnName)) {
          cache.delete(columnName);
        }
      });
      if (this.grid.rootSummariesEnabled) {
        this.retriggerRootPipe++;
      }
    }
    calcMaxSummaryHeight() {
      if (this.summaryHeight) {
        return this.summaryHeight;
      }
      if (!this.grid.data) {
        return this.summaryHeight = 0;
      }
      let maxSummaryLength = 0;
      this.grid.columns.filter(col => col.hasSummary && !col.hidden).forEach(column => {
        const getCurrentSummary = column.summaries.operate([], [], column.field);
        const getCurrentSummaryColumn = column.disabledSummaries.length > 0 ? getCurrentSummary.filter(s => !column.disabledSummaries.includes(s.key)).length : getCurrentSummary.length;
        if (maxSummaryLength < getCurrentSummaryColumn) {
          maxSummaryLength = getCurrentSummaryColumn;
        }
      });
      this.maxSummariesLength = maxSummaryLength;
      this.summaryHeight = maxSummaryLength * this.grid.defaultSummaryHeight;
      return this.summaryHeight;
    }
    calculateSummaries(rowID, data, groupRecord) {
      let rowSummaries = this.summaryCacheMap.get(rowID);
      if (!rowSummaries) {
        rowSummaries = new Map();
        this.summaryCacheMap.set(rowID, rowSummaries);
      }
      if (!this.hasSummarizedColumns || !data) {
        return rowSummaries;
      }
      this.grid.columns.filter(col => col.hasSummary).forEach(column => {
        if (!rowSummaries.get(column.field)) {
          let summaryResult = column.summaries.operate(data.map(r => resolveNestedPath(r, column.field)), data, column.field, groupRecord, this.grid.locale, column.pipeArgs);
          summaryResult = column.disabledSummaries.length > 0 ? summaryResult.filter(s => !column.disabledSummaries.includes(s.key)) : summaryResult;
          rowSummaries.set(column.field, summaryResult);
        }
      });
      return rowSummaries;
    }
    resetSummaryHeight() {
      this.summaryHeight = 0;
      if (this.grid) {
        this.grid.summaryPipeTrigger++;
        if (this.grid.rootSummariesEnabled) {
          this.retriggerRootPipe++;
          Promise.resolve().then(() => this.grid.notifyChanges(true));
        }
      }
    }
    updateSummaryCache(groupingArgs) {
      if (this.summaryCacheMap.size === 0 || !this.hasSummarizedColumns) {
        return;
      }
      if (this.groupingExpressions.length === 0) {
        this.groupingExpressions = groupingArgs.expressions.map(record => record.fieldName);
        return;
      }
      if (groupingArgs.length === 0) {
        this.groupingExpressions = [];
        this.clearSummaryCache();
        return;
      }
      this.compareGroupingExpressions(this.groupingExpressions, groupingArgs);
      this.groupingExpressions = groupingArgs.expressions.map(record => record.fieldName);
    }
    get hasSummarizedColumns() {
      const summarizedColumns = this.grid.columns.filter(col => col.hasSummary && !col.hidden);
      return summarizedColumns.length > 0;
    }
    deleteSummaryCache(id, columnName) {
      if (this.summaryCacheMap.get(id)) {
        const filteringApplied = columnName && this.grid.filteringExpressionsTree && this.grid.filteringExpressionsTree.filteringOperands.map(expr => expr.fieldName).indexOf(columnName) !== -1;
        if (columnName && this.summaryCacheMap.get(id).get(columnName) && !filteringApplied) {
          this.summaryCacheMap.get(id).delete(columnName);
        } else {
          this.summaryCacheMap.delete(id);
        }
        if (id === this.rootSummaryID && this.grid.rootSummariesEnabled) {
          this.retriggerRootPipe++;
        }
      }
    }
    getSummaryID(rowID, groupingExpressions) {
      if (groupingExpressions.length === 0) {
        return [];
      }
      const summaryIDs = [];
      let data = this.grid.data;
      if (this.grid.transactions.enabled) {
        data = DataUtil.mergeTransactions(cloneArray(this.grid.data), this.grid.transactions.getAggregatedChanges(true), this.grid.primaryKey, this.grid.dataCloneStrategy);
      }
      const rowData = this.grid.primaryKey ? data.find(rec => rec[this.grid.primaryKey] === rowID) : rowID;
      if (!rowData) {
        return summaryIDs;
      }
      let id = '{ ';
      groupingExpressions.forEach(expr => {
        id += `'${expr.fieldName}': '${rowData[expr.fieldName]}'`;
        summaryIDs.push(id.concat(' }'));
        id += ', ';
      });
      return summaryIDs;
    }
    removeAllTreeGridSummaries(rowID, columnName) {
      let row = this.grid.records.get(rowID);
      if (!row) {
        return;
      }
      row = row.children ? row : row.parent;
      while (row) {
        rowID = row.key;
        this.deleteSummaryCache(rowID, columnName);
        row = row.parent;
      }
    }
    // TODO: remove only deleted rows
    // private removeChildRowSummaries(rowID, columnName?) {
    // }
    compareGroupingExpressions(current, groupingArgs) {
      const newExpressions = groupingArgs.expressions.map(record => record.fieldName);
      const removedCols = groupingArgs.ungroupedColumns;
      if (current.length <= newExpressions.length) {
        const newExpr = newExpressions.slice(0, current.length).toString();
        if (current.toString() !== newExpr) {
          this.clearSummaryCache();
        }
      } else {
        const currExpr = current.slice(0, newExpressions.length).toString();
        if (currExpr !== newExpressions.toString()) {
          this.clearSummaryCache();
          return;
        }
        removedCols.map(col => col.field).forEach(colName => {
          this.summaryCacheMap.forEach((cache, id) => {
            if (id.indexOf(colName) !== -1) {
              this.summaryCacheMap.delete(id);
            }
          });
        });
      }
    }
    static {
      this.ɵfac = function IgxGridSummaryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridSummaryService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridSummaryService,
        factory: IgxGridSummaryService.ɵfac
      });
    }
  }
  return IgxGridSummaryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FAKE_ROW_ID = -1;
const DEFAULT_ITEMS_PER_PAGE = 15;
const MINIMUM_COLUMN_WIDTH$1 = 136;
// By default row editing overlay outlet is inside grid body so that overlay is hidden below grid header when scrolling.
// In cases when grid has 1-2 rows there isn't enough space in grid body and row editing overlay should be shown above header.
// Default row editing overlay height is higher then row height that is why the case is valid also for row with 2 rows.
// More accurate calculation is not possible, cause row editing overlay is still not shown and we don't know its height,
// but in the same time we need to set row editing overlay outlet before opening the overlay itself.
const MIN_ROW_EDITING_COUNT_THRESHOLD = 2;
/* blazorIndirectRender
   blazorComponent
   omitModule
   wcSkipComponentSuffix */
let IgxGridBaseDirective = /*#__PURE__*/(() => {
  class IgxGridBaseDirective {
    /**
     * Get/Set IgxSummaryRow height
     */
    set summaryRowHeight(value) {
      this._summaryRowHeight = value | 0;
      this.summaryService.summaryHeight = value;
      if (!this._init) {
        this.reflow();
      }
    }
    get summaryRowHeight() {
      if (this.hasSummarizedColumns && this.rootSummariesEnabled) {
        return this._summaryRowHeight || this.summaryService.calcMaxSummaryHeight();
      }
      return 0;
    }
    /** @hidden @internal */
    get hasColumnsToAutosize() {
      return this._columns.some(x => x.width === 'fit-content');
    }
    /**
     * Gets/Sets the data clone strategy of the grid when in edit mode.
     *
     * @example
     * ```html
     *  <igx-grid #grid [data]="localData" [dataCloneStrategy]="customCloneStrategy"></igx-grid>
     * ```
     */
    get dataCloneStrategy() {
      return this._dataCloneStrategy;
    }
    set dataCloneStrategy(strategy) {
      if (strategy) {
        this._dataCloneStrategy = strategy;
        this._transactions.cloneStrategy = strategy;
      }
    }
    /**
     * Gets/Sets the primary key.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [primaryKey]="'ProductID'" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get primaryKey() {
      return this._primaryKey;
    }
    set primaryKey(value) {
      this._primaryKey = value;
      this.checkPrimaryKeyField();
    }
    /** @hidden @internal */
    get excelStyleFilteringComponent() {
      return this.excelStyleFilteringComponents?.first;
    }
    /** @hidden @internal */
    get headerGroups() {
      return this.theadRow.groups;
    }
    /** @hidden @internal */
    get actionStrip() {
      return this.actionStripComponents?.first;
    }
    /**
     * Gets the custom template, if any, used for row drag ghost.
     */
    get dragGhostCustomTemplate() {
      return this._dragGhostCustomTemplate || this.dragGhostCustomTemplates?.first;
    }
    /**
     * Sets a custom template for the row drag ghost.
     *```html
     * <ng-template #template igxRowDragGhost>
     *    <igx-icon>menu</igx-icon>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.dragGhostCustomTemplate = this.template;
     * ```
     */
    set dragGhostCustomTemplate(template) {
      this._dragGhostCustomTemplate = template;
    }
    /** @hidden @internal */
    get headerContainer() {
      return this.theadRow?.headerForOf;
    }
    /** @hidden @internal */
    get headerSelectorContainer() {
      return this.theadRow?.headerSelectorContainer;
    }
    /** @hidden @internal */
    get headerDragContainer() {
      return this.theadRow?.headerDragContainer;
    }
    /** @hidden @internal */
    get headerGroupContainer() {
      return this.theadRow?.headerGroupContainer;
    }
    /** @hidden @internal */
    get filteringRow() {
      return this.theadRow?.filterRow;
    }
    /**
     * Gets the row edit text template.
     */
    get rowEditTextTemplate() {
      return this._rowEditTextTemplate || this.rowEditTextDirectives?.first;
    }
    /**
     * Sets the row edit text template.
     *```html
     * <ng-template #template igxRowEditText let-rowChangesCount>
     * Changes: {{rowChangesCount}}
     * </ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.rowEditTextTemplate = this.template;
     * ```
     */
    set rowEditTextTemplate(template) {
      this._rowEditTextTemplate = template;
    }
    /**
     * Gets the row add text template.
     */
    get rowAddTextTemplate() {
      return this._rowAddTextTemplate || this.rowAddText;
    }
    /**
     * Sets the row add text template.
     *```html
     * <ng-template #template igxRowAddText>
     * Adding Row
     * </ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.rowAddTextTemplate = this.template;
     * ```
     */
    set rowAddTextTemplate(template) {
      this._rowAddTextTemplate = template;
    }
    /**
     * Gets the row edit actions template.
     */
    get rowEditActionsTemplate() {
      return this._rowEditActionsTemplate || this.rowEditActionsDirectives?.first;
    }
    /**
     * Sets the row edit actions template.
     *```html
     * <ng-template #template igxRowEditActions let-endRowEdit>
     *     <button type="button" igxButton igxRowEditTabStop (click)="endRowEdit(false)">Cancel</button>
     *     <button type="button" igxButton igxRowEditTabStop (click)="endRowEdit(true)">Apply</button>
     * </ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.rowEditActionsTemplate = this.template;
     * ```
     */
    set rowEditActionsTemplate(template) {
      this._rowEditActionsTemplate = template;
    }
    /**
     * Gets the row expand indicator template.
    */
    get rowExpandedIndicatorTemplate() {
      return this._rowExpandedIndicatorTemplate || this.rowExpandedIndicatorDirectiveTemplate;
    }
    /**
     * Sets the row expand indicator template.
     *```html
     *<ng-template igxRowExpandedIndicator>
     *  <igx-icon role="button">remove</igx-icon>
     *</ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.rowExpandedIndicatorTemplate = this.template;
     * ```
    */
    set rowExpandedIndicatorTemplate(template) {
      this._rowExpandedIndicatorTemplate = template;
    }
    /**
     * Gets the row collapse indicator template.
    */
    get rowCollapsedIndicatorTemplate() {
      return this._rowCollapsedIndicatorTemplate || this.rowCollapsedIndicatorDirectiveTemplate;
    }
    /**
     * Sets the row collapse indicator template.
     *```html
     *<ng-template igxRowCollapsedIndicator>
     *  <igx-icon role="button">add</igx-icon>
     *</ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.rowCollapsedIndicatorTemplate = this.template;
     * ```
    */
    set rowCollapsedIndicatorTemplate(template) {
      this._rowCollapsedIndicatorTemplate = template;
    }
    /**
     * Gets the header expand indicator template.
    */
    get headerExpandedIndicatorTemplate() {
      return this._headerExpandIndicatorTemplate || this.headerExpandedIndicatorDirectiveTemplate;
    }
    /**
     * Sets the header expand indicator template.
     *```html
     *<ng-template igxHeaderExpandedIndicator>
     *  <igx-icon role="button">remove</igx-icon>
     *</ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.headerExpandedIndicatorTemplate = this.template;
     * ```
    */
    set headerExpandedIndicatorTemplate(template) {
      this._headerExpandIndicatorTemplate = template;
    }
    /**
     * Gets the row collapse indicator template.
    */
    get headerCollapsedIndicatorTemplate() {
      return this._headerCollapseIndicatorTemplate || this.headerCollapsedIndicatorDirectiveTemplate;
    }
    /**
     * Sets the row collapse indicator template.
     *```html
     *<ng-template igxHeaderCollapsedIndicator>
     *  <igx-icon role="button">add</igx-icon>
     *</ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.headerCollapsedIndicatorTemplate = this.template;
     * ```
    */
    set headerCollapsedIndicatorTemplate(template) {
      this._headerCollapseIndicatorTemplate = template;
    }
    /**
     * Gets the excel style header icon.
    */
    get excelStyleHeaderIconTemplate() {
      return this._excelStyleHeaderIconTemplate || this.excelStyleHeaderIconDirectiveTemplate;
    }
    /**
     * Sets the excel style header icon.
     *```html
     *<ng-template #template igxExcelStyleHeaderIcon>
     * <igx-icon>filter_alt</igx-icon>
     *</ng-template>
     * ```
     *```typescript
     * @ViewChild('template', {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.excelStyleHeaderIconTemplate = this.template;
     * ```
    */
    set excelStyleHeaderIconTemplate(template) {
      this._excelStyleHeaderIconTemplate = template;
    }
    /**
     * The custom template, if any, that should be used when rendering a header sorting indicator when columns are sorted in asc order.
     */
    get sortAscendingHeaderIconTemplate() {
      return this._sortAscendingHeaderIconTemplate;
    }
    /**
     * Sets a custom template that should be used when rendering a header sorting indicator when columns are sorted in asc order.
     *```html
     * <ng-template #template igxSortAscendingHeaderIcon>
     *    <igx-icon>expand_less</igx-icon>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.sortAscendingHeaderIconTemplate = this.template;
     * ```
     */
    set sortAscendingHeaderIconTemplate(template) {
      this._sortAscendingHeaderIconTemplate = template;
    }
    /**
     * The custom template, if any, that should be used when rendering a header sorting indicator when columns are sorted in desc order.
     */
    get sortDescendingHeaderIconTemplate() {
      return this._sortDescendingHeaderIconTemplate;
    }
    /**
     * Sets a custom template that should be used when rendering a header sorting indicator when columns are sorted in desc order.
     *```html
     * <ng-template #template igxSortDescendingHeaderIcon>
     *    <igx-icon>expand_more</igx-icon>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.sortDescendingHeaderIconTemplate = this.template;
     * ```
     */
    set sortDescendingHeaderIconTemplate(template) {
      this._sortDescendingHeaderIconTemplate = template;
    }
    /**
     * Gets custom template, if any, that should be used when rendering a header sorting indicator when columns are not sorted.
     */
    get sortHeaderIconTemplate() {
      return this._sortHeaderIconTemplate;
    }
    /**
     * Sets a custom template that should be used when rendering a header sorting indicator when columns are not sorted.
     *```html
     * <ng-template #template igxSortHeaderIcon>
     *    <igx-icon>unfold_more</igx-icon>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.sortHeaderIconTemplate = this.template;
     * ```
     */
    set sortHeaderIconTemplate(template) {
      this._sortHeaderIconTemplate = template;
    }
    /**
     * Gets/Sets the resource strings.
     *
     * @remarks
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    get resourceStrings() {
      return this._resourceStrings;
    }
    /**
     * Gets/Sets the filtering logic of the `IgxGridComponent`.
     *
     * @remarks
     * The default is AND.
     * @example
     * ```html
     * <igx-grid [data]="Data" [autoGenerate]="true" [filteringLogic]="filtering"></igx-grid>
     * ```
     */
    get filteringLogic() {
      return this._filteringExpressionsTree.operator;
    }
    set filteringLogic(value) {
      this._filteringExpressionsTree.operator = value;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor */
    /**
     * Gets/Sets the filtering state.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [autoGenerate]="true" [(filteringExpressionsTree)]="model.filteringExpressions"></igx-grid>
     * ```
     * @remarks
     * Supports two-way binding.
     */
    get filteringExpressionsTree() {
      return this._filteringExpressionsTree;
    }
    set filteringExpressionsTree(value) {
      if (value && isTree(value)) {
        for (let index = 0; index < value.filteringOperands.length; index++) {
          if (!isTree(value.filteringOperands[index])) {
            const newExpressionsTree = new FilteringExpressionsTree(FilteringLogic.And, value.filteringOperands[index].fieldName);
            newExpressionsTree.filteringOperands.push(value.filteringOperands[index]);
            value.filteringOperands[index] = newExpressionsTree;
          }
        }
        value.type = FilteringExpressionsTreeType.Regular;
        if (value && this._columns?.length > 0) {
          this._filteringExpressionsTree = recreateTreeFromFields(value, this._columns);
        } else {
          this._filteringExpressionsTree = value;
        }
        this.filteringPipeTrigger++;
        this.filteringExpressionsTreeChange.emit(this._filteringExpressionsTree);
        if (this.filteringService.isFilteringExpressionsTreeEmpty(this._filteringExpressionsTree) && this.filteringService.isFilteringExpressionsTreeEmpty(this._advancedFilteringExpressionsTree)) {
          this._filteredData = null;
        }
        this.filteringService.refreshExpressions();
        this.selectionService.clearHeaderCBState();
        this.summaryService.clearSummaryCache();
        this.notifyChanges();
      }
    }
    /**
     * Gets/Sets the advanced filtering state.
     *
     * @example
     * ```typescript
     * let advancedFilteringExpressionsTree = this.grid.advancedFilteringExpressionsTree;
     * this.grid.advancedFilteringExpressionsTree = logic;
     * ```
     */
    get advancedFilteringExpressionsTree() {
      return this._advancedFilteringExpressionsTree;
    }
    set advancedFilteringExpressionsTree(value) {
      const filteringEventArgs = {
        owner: this,
        filteringExpressions: value,
        cancel: false
      };
      this.filtering.emit(filteringEventArgs);
      if (filteringEventArgs.cancel) {
        return;
      }
      if (value && isTree(value)) {
        value.type = FilteringExpressionsTreeType.Advanced;
        if (this._columns && this._columns.length > 0) {
          this._advancedFilteringExpressionsTree = recreateTreeFromFields(value, this._columns);
        } else {
          this._advancedFilteringExpressionsTree = value;
        }
        this.filteringPipeTrigger++;
      } else {
        this._advancedFilteringExpressionsTree = null;
      }
      this.advancedFilteringExpressionsTreeChange.emit(this._advancedFilteringExpressionsTree);
      if (this.filteringService.isFilteringExpressionsTreeEmpty(this._filteringExpressionsTree) && this.filteringService.isFilteringExpressionsTreeEmpty(this._advancedFilteringExpressionsTree)) {
        this._filteredData = null;
      }
      this.selectionService.clearHeaderCBState();
      this.summaryService.clearSummaryCache();
      this.notifyChanges();
      // Wait for the change detection to update filtered data through the pipes and then emit the event.
      requestAnimationFrame(() => this.filteringDone.emit(this._advancedFilteringExpressionsTree));
    }
    /**
     * Gets/Sets the locale.
     *
     * @remarks
     * If not set, returns browser's language.
     */
    get locale() {
      return this._locale;
    }
    set locale(value) {
      if (value !== this._locale) {
        this._locale = value;
        this._currencyPositionLeft = undefined;
        this.summaryService.clearSummaryCache();
        this.pipeTrigger++;
        this.notifyChanges();
        this.localeChange.emit();
      }
    }
    get pagingMode() {
      return this._pagingMode;
    }
    set pagingMode(val) {
      this._pagingMode = val;
      this.pipeTrigger++;
      this.notifyChanges(true);
    }
    /** @hidden @internal */
    get page() {
      return this.paginator?.page || 0;
    }
    set page(val) {
      if (this.paginator) {
        this.paginator.page = val;
      }
    }
    /** @hidden @internal */
    get perPage() {
      return this.paginator?.perPage || DEFAULT_ITEMS_PER_PAGE;
    }
    set perPage(val) {
      if (this.paginator) {
        this.paginator.perPage = val;
      }
    }
    /**
     * Gets/Sets if the row selectors are hidden.
     *
     * @remarks
     *  By default row selectors are shown
     */
    get hideRowSelectors() {
      return this._hideRowSelectors;
    }
    set hideRowSelectors(value) {
      this._hideRowSelectors = value;
      this.notifyChanges(true);
    }
    /**
     * Gets/Sets whether rows can be moved.
     *
     * @example
     * ```html
     * <igx-grid #grid [rowDraggable]="true"></igx-grid>
     * ```
     */
    get rowDraggable() {
      return this._rowDrag && this.hasVisibleColumns;
    }
    set rowDraggable(val) {
      this._rowDrag = val;
      this.notifyChanges(true);
    }
    /**
     * Gets/Sets whether the rows are editable.
     *
     * @remarks
     * By default it is set to false.
     * @example
     * ```html
     * <igx-grid #grid [rowEditable]="true" [primaryKey]="'ProductID'" ></igx-grid>
     * ```
     */
    get rowEditable() {
      return this._rowEditable;
    }
    set rowEditable(val) {
      if (!this._init) {
        this.refreshGridState();
      }
      this._rowEditable = val;
      this.notifyChanges();
    }
    /**
     * Gets/Sets the height.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [height]="'305px'" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get height() {
      return this._height;
    }
    set height(value) {
      if (this._height !== value) {
        this._height = value;
        this.nativeElement.style.height = value;
        this.notifyChanges(true);
      }
    }
    /**
     * @hidden @internal
     */
    get hostWidth() {
      return this._width || this._hostWidth;
    }
    /**
     * Gets/Sets the width of the grid.
     *
     * @example
     * ```typescript
     * let gridWidth = this.grid.width;
     * ```
     */
    get width() {
      return this._width;
    }
    set width(value) {
      if (this._width !== value) {
        this._width = value;
        this.nativeElement.style.width = value;
        this.notifyChanges(true);
      }
    }
    /** @hidden @internal */
    get headerWidth() {
      return parseInt(this.width, 10) - 17;
    }
    /**
     * Gets/Sets the row height.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [rowHeight]="100" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get rowHeight() {
      return this._rowHeight ? this._rowHeight : this.defaultRowHeight;
    }
    set rowHeight(value) {
      if (typeof value !== 'number') {
        value = parseInt(value, 10);
      }
      this._rowHeight = value;
    }
    /**
     * Gets/Sets the default width of the columns.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [columnWidth]="100" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get columnWidth() {
      return this._columnWidth;
    }
    set columnWidth(value) {
      this._columnWidth = value;
      this.columnWidthSetByUser = true;
      this.notifyChanges(true);
    }
    /**
     * Get/Sets the message displayed when there are no records.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [emptyGridMessage]="'The grid is empty'" [autoGenerate]="true"></igx-grid>
     * ```
     */
    set emptyGridMessage(value) {
      this._emptyGridMessage = value;
    }
    get emptyGridMessage() {
      return this._emptyGridMessage || this.resourceStrings.igx_grid_emptyGrid_message;
    }
    /**
     * Gets/Sets whether the grid is going to show a loading indicator.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [isLoading]="true" [autoGenerate]="true"></igx-grid>
     * ```
     */
    set isLoading(value) {
      if (this._isLoading !== value) {
        this._isLoading = value;
        if (this.data) {
          this.evaluateLoadingState();
        }
      }
      Promise.resolve().then(() => {
        // wait for the current detection cycle to end before triggering a new one.
        this.notifyChanges();
      });
    }
    get isLoading() {
      return this._isLoading;
    }
    /**
     * Gets/Sets whether the columns should be auto-generated once again after the initialization of the grid
     *
     * @remarks
     * This will allow to bind the grid to remote data and having auto-generated columns at the same time.
     * Note that after generating the columns, this property would be disabled to avoid re-creating
     * columns each time a new data is assigned.
     * @example
     * ```typescript
     *  this.grid.shouldGenerate = true;
     * ```
     * @deprecated in version 18.2.0. Column re-creation now relies on `autoGenerate` instead.
     */
    get shouldGenerate() {
      return this.autoGenerate;
    }
    set shouldGenerate(value) {
      this.autoGenerate = value;
    }
    /**
     * Gets/Sets the message displayed when there are no records and the grid is filtered.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [emptyGridMessage]="'The grid is empty'" [autoGenerate]="true"></igx-grid>
     * ```
     */
    set emptyFilteredGridMessage(value) {
      this._emptyFilteredGridMessage = value;
    }
    get emptyFilteredGridMessage() {
      return this._emptyFilteredGridMessage || this.resourceStrings.igx_grid_emptyFilteredGrid_message;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /**
     * Gets/Sets the initial pinning configuration.
     *
     * @remarks
     * Allows to apply pinning the columns to the start or the end.
     * Note that pinning to both sides at a time is not allowed.
     * @example
     * ```html
     * <igx-grid [pinning]="pinningConfig"></igx-grid>
     * ```
     */
    get pinning() {
      return this._pinning;
    }
    set pinning(value) {
      if (value !== this._pinning) {
        this.resetCaches();
      }
      this._pinning = value;
    }
    /**
     * Gets/Sets if the filtering is enabled.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [allowFiltering]="true" [height]="'305px'" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get allowFiltering() {
      return this._allowFiltering;
    }
    set allowFiltering(value) {
      if (this._allowFiltering !== value) {
        this._allowFiltering = value;
        this.filteringService.registerSVGIcons();
        this.filteringService.isFilterRowVisible = false;
        this.filteringService.filteredColumn = null;
        this.notifyChanges(true);
      }
    }
    /**
     * Gets/Sets a value indicating whether the advanced filtering is enabled.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [allowAdvancedFiltering]="true" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get allowAdvancedFiltering() {
      return this._allowAdvancedFiltering;
    }
    set allowAdvancedFiltering(value) {
      if (this._allowAdvancedFiltering !== value) {
        this._allowAdvancedFiltering = value;
        this.filteringService.registerSVGIcons();
        if (!this._init) {
          this.notifyChanges(true);
        }
      }
    }
    /**
     * Gets/Sets the filter mode.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [filterMode]="'quickFilter'" [height]="'305px'" [autoGenerate]="true"></igx-grid>
     * ```
     * @remarks
     * By default it's set to FilterMode.quickFilter.
     */
    get filterMode() {
      return this._filterMode;
    }
    set filterMode(value) {
      switch (value) {
        case FilterMode.excelStyleFilter:
        case FilterMode.quickFilter:
          this._filterMode = value;
          break;
        default:
          break;
      }
      if (this.filteringService.isFilterRowVisible) {
        this.filteringRow.close();
      }
      this.notifyChanges(true);
    }
    /**
     * Gets/Sets the summary position.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" summaryPosition="top" [autoGenerate]="true"></igx-grid>
     * ```
     * @remarks
     * By default it is bottom.
     */
    get summaryPosition() {
      return this._summaryPosition;
    }
    set summaryPosition(value) {
      this._summaryPosition = value;
      this.notifyChanges();
    }
    /**
     * Gets/Sets the summary calculation mode.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" summaryCalculationMode="rootLevelOnly" [autoGenerate]="true"></igx-grid>
     * ```
     * @remarks
     * By default it is rootAndChildLevels which means the summaries are calculated for the root level and each child level.
     */
    get summaryCalculationMode() {
      return this._summaryCalculationMode;
    }
    set summaryCalculationMode(value) {
      this._summaryCalculationMode = value;
      if (!this._init) {
        this.crudService.endEdit(false);
        this.summaryService.resetSummaryHeight();
        this.notifyChanges(true);
      }
    }
    /**
     * Controls whether the summary row is visible when groupBy/parent row is collapsed.
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [showSummaryOnCollapse]="true" [autoGenerate]="true"></igx-grid>
     * ```
     * @remarks
     * By default showSummaryOnCollapse is set to 'false' which means that the summary row is not visible
     * when the groupBy/parent row is collapsed.
     */
    get showSummaryOnCollapse() {
      return this._showSummaryOnCollapse;
    }
    set showSummaryOnCollapse(value) {
      this._showSummaryOnCollapse = value;
      this.notifyChanges();
    }
    /**
     * Gets/Sets the filtering strategy of the grid.
     *
     * @example
     * ```html
     *  <igx-grid #grid [data]="localData" [filterStrategy]="filterStrategy"></igx-grid>
     * ```
     */
    get filterStrategy() {
      return this._filterStrategy;
    }
    set filterStrategy(classRef) {
      this._filterStrategy = classRef;
    }
    /**
     * Gets/Sets the sorting strategy of the grid.
     *
     * @example
     * ```html
     *  <igx-grid #grid [data]="localData" [sortStrategy]="sortStrategy"></igx-grid>
     * ```
     */
    get sortStrategy() {
      return this._sortingStrategy;
    }
    set sortStrategy(value) {
      this._sortingStrategy = value;
    }
    /**
     * Gets/Sets the sorting options - single or multiple sorting.
     * Accepts an `ISortingOptions` object with any of the `mode` properties.
     *
     * @example
     * ```typescript
     * const _sortingOptions: ISortingOptions = {
     *      mode: 'single'
     * }
     * ```html
     * <igx-grid [sortingOptions]="sortingOptions"><igx-grid>
     * ```
     */
    set sortingOptions(value) {
      if (!this._init) {
        // clear sort only if option is changed runtime. No need to clear on initial load.
        this.clearSort();
      }
      this._sortingOptions = Object.assign(this._sortingOptions, value);
    }
    get sortingOptions() {
      return this._sortingOptions;
    }
    /* blazorByValueArray */
    /* blazorAlwaysWriteback */
    /* @tsTwoWayProperty (true, "SelectedRowsChange", "Detail", false) */
    /* blazorPrimitiveValue */
    /**
     * Gets/Sets the current selection state.
     *
     * @remarks
     * Represents the selected rows' IDs (primary key or rowData)
     * @example
     * ```html
     * <igx-grid [data]="localData" primaryKey="ID" rowSelection="multiple" [selectedRows]="[0, 1, 2]"><igx-grid>
     * ```
     */
    set selectedRows(rowIDs) {
      this.selectRows(rowIDs || [], true);
    }
    get selectedRows() {
      return this.selectionService.getSelectedRows();
    }
    /** @hidden @internal */
    get headerGroupsList() {
      return this.theadRow.groups;
    }
    /** @hidden @internal */
    get headerCellList() {
      return this.headerGroupsList.map(headerGroup => headerGroup.header).filter(header => header);
    }
    /** @hidden @internal */
    get filterCellList() {
      return this.headerGroupsList.map(group => group.filter).filter(cell => cell);
    }
    /**
     * @hidden @internal
     */
    get summariesRowList() {
      const res = new QueryList();
      if (!this._summaryRowList) {
        return res;
      }
      const sumList = this._summaryRowList.filter(item => item.element.nativeElement.parentElement !== null);
      res.reset(sumList);
      return res;
    }
    /* csSuppress */
    /**
     * A list of `IgxGridRowComponent`.
     *
     * @example
     * ```typescript
     * const rowList = this.grid.rowList;
     * ```
     */
    get rowList() {
      const res = new QueryList();
      if (!this._rowList) {
        return res;
      }
      const rList = this._rowList.filter(item => item.element.nativeElement.parentElement !== null).sort((a, b) => a.index - b.index);
      res.reset(rList);
      return res;
    }
    /* csSuppress */
    /**
     * A list of currently rendered `IgxGridRowComponent`'s.
     *
     * @example
     * ```typescript
     * const dataList = this.grid.dataRowList;
     * ```
     */
    get dataRowList() {
      const res = new QueryList();
      if (!this._dataRowList) {
        return res;
      }
      const rList = this._dataRowList.filter(item => item.element.nativeElement.parentElement !== null).sort((a, b) => a.index - b.index);
      res.reset(rList);
      return res;
    }
    /**
     * Gets the header row selector template.
     */
    get headSelectorTemplate() {
      return this._headSelectorTemplate || this.headSelectorsTemplates?.first;
    }
    /**
     * Sets the header row selector template.
     * ```html
     * <ng-template #template igxHeadSelector let-headContext>
     * {{ headContext.selectedCount }} / {{ headContext.totalCount  }}
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.headSelectorTemplate = this.template;
     * ```
     */
    set headSelectorTemplate(template) {
      this._headSelectorTemplate = template;
    }
    /**
     * @hidden
     * @internal
     */
    get isPinningToStart() {
      return this.pinning.columns !== ColumnPinningPosition.End;
    }
    /**
     * @hidden
     * @internal
     */
    get isRowPinningToTop() {
      return this.pinning.rows !== RowPinningPosition.Bottom;
    }
    /**
     * Gets the row selector template.
     */
    get rowSelectorTemplate() {
      return this._rowSelectorTemplate || this.rowSelectorsTemplates?.first;
    }
    /**
         * Sets a custom template for the row selectors.
         * ```html
         * <ng-template #template igxRowSelector let-rowContext>
         *    <igx-checkbox [checked]="rowContext.selected"></igx-checkbox>
         * </ng-template>
         * ```
         * ```typescript
         * @ViewChild("'template'", {read: TemplateRef })
         * public template: TemplateRef<any>;
         * this.grid.rowSelectorTemplate = this.template;
         * ```
         */
    set rowSelectorTemplate(template) {
      this._rowSelectorTemplate = template;
    }
    /**
     * @hidden @internal
     */
    get rowOutletDirective() {
      return this.rowEditingOutletDirective;
    }
    /**
     * @hidden @internal
     */
    get parentRowOutletDirective() {
      return this.outlet;
    }
    /**
     * @hidden @internal
     */
    get rowEditCustom() {
      if (this.rowEditCustomDirectives && this.rowEditCustomDirectives.first) {
        return this.rowEditCustomDirectives.first;
      }
      return null;
    }
    /**
     /**
     * @hidden @internal
     */
    get rowEditContainer() {
      return this.rowEditCustom ? this.rowEditCustom : this.defaultRowEditTemplate;
    }
    /**
     * The custom template, if any, that should be used when rendering the row drag indicator icon
     */
    get dragIndicatorIconTemplate() {
      return this._customDragIndicatorIconTemplate || this.dragIndicatorIconTemplates?.first;
    }
    /**
     * Sets a custom template that should be used when rendering the row drag indicator icon.
     *```html
     * <ng-template #template igxDragIndicatorIcon>
     *    <igx-icon>expand_less</igx-icon>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.dragIndicatorIconTemplate = this.template;
     * ```
     */
    set dragIndicatorIconTemplate(val) {
      this._customDragIndicatorIconTemplate = val;
    }
    /**
     * @hidden @internal
     */
    get firstEditableColumnIndex() {
      const index = this.visibleColumns.filter(col => col.editable).map(c => c.visibleIndex).sort((a, b) => a - b);
      return index.length ? index[0] : null;
    }
    /**
     * @hidden @internal
     */
    get lastEditableColumnIndex() {
      const index = this.visibleColumns.filter(col => col.editable).map(c => c.visibleIndex).sort((a, b) => a > b ? -1 : 1);
      return index.length ? index[0] : null;
    }
    /**
     * @hidden @internal
     * TODO: Nav service logic doesn't handle 0 results from this querylist
     */
    get rowEditTabs() {
      return this.rowEditTabsCUSTOM.length ? this.rowEditTabsCUSTOM : this.rowEditTabsDEFAULT;
    }
    /** @hidden @internal */
    get activeDescendant() {
      const activeElem = this.navigation.activeNode;
      if (!activeElem || !Object.keys(activeElem).length) {
        return this.id;
      }
      return activeElem.row < 0 ? `${this.id}_${activeElem.row}_${activeElem.mchCache.level}_${activeElem.column}` : `${this.id}_${activeElem.row}_${activeElem.column}`;
    }
    /** @hidden @internal */
    get bannerClass() {
      const position = this.rowEditPositioningStrategy.isTop ? 'igx-banner__border-top' : 'igx-banner__border-bottom';
      return `igx-banner ${position}`;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /**
     * Gets/Sets the sorting state.
     *
     * @remarks
     * Supports two-way data binding.
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [autoGenerate]="true" [(sortingExpressions)]="model.sortingExpressions"></igx-grid>
     * ```
     */
    get sortingExpressions() {
      return this._sortingExpressions;
    }
    set sortingExpressions(value) {
      this._sortingExpressions = cloneArray(value);
      this.sortingExpressionsChange.emit(this._sortingExpressions);
      this.notifyChanges();
    }
    /**
     * @hidden @internal
     */
    get maxLevelHeaderDepth() {
      if (this._maxLevelHeaderDepth === null) {
        this._maxLevelHeaderDepth = this.hasColumnLayouts ? this._columns.reduce((acc, col) => Math.max(acc, col.rowStart), 0) : this._columns.reduce((acc, col) => Math.max(acc, col.level), 0);
      }
      return this._maxLevelHeaderDepth;
    }
    /**
     * Gets the number of hidden columns.
     *
     * @example
     * ```typescript
     * const hiddenCol = this.grid.hiddenColumnsCount;
     * ``
     */
    get hiddenColumnsCount() {
      return this._columns.filter(col => col.columnGroup === false && col.hidden === true).length;
    }
    /**
     * Gets the number of pinned columns.
     */
    get pinnedColumnsCount() {
      return this.pinnedColumns.filter(col => !col.columnLayout).length;
    }
    /**
     * Gets/Sets whether the grid has batch editing enabled.
     * When batch editing is enabled, changes are not made directly to the underlying data.
     * Instead, they are stored as transactions, which can later be committed w/ the `commit` method.
     *
     * @example
     * ```html
     * <igx-grid [batchEditing]="true" [data]="someData">
     * </igx-grid>
     * ```
     */
    get batchEditing() {
      return this._batchEditing;
    }
    set batchEditing(val) {
      if (val !== this._batchEditing) {
        delete this._transactions;
        this._batchEditing = val;
        this.switchTransactionService(val);
        this.subscribeToTransactions();
      }
    }
    /* blazorSuppress */
    /**
     * Get transactions service for the grid.
     */
    get transactions() {
      if (this._diTransactions && !this.batchEditing) {
        return this._diTransactions;
      }
      return this._transactions;
    }
    /**
     * @hidden @internal
     */
    get currentRowState() {
      return this._currentRowState;
    }
    /**
     * @hidden @internal
     */
    get currencyPositionLeft() {
      if (this._currencyPositionLeft !== undefined) {
        return this._currencyPositionLeft;
      }
      const format = getLocaleNumberFormat(this.locale, NumberFormatStyle.Currency);
      const formatParts = format.split(',');
      const i = formatParts.indexOf(formatParts.find(c => c.includes('¤')));
      return this._currencyPositionLeft = i < 1;
    }
    /**
     * Gets/Sets cell selection mode.
     *
     * @remarks
     * By default the cell selection mode is multiple
     * @param selectionMode: GridSelectionMode
     */
    get cellSelection() {
      return this._cellSelectionMode;
    }
    set cellSelection(selectionMode) {
      this._cellSelectionMode = selectionMode;
      // if (this.gridAPI.grid) {
      this.selectionService.clear(true);
      this.notifyChanges();
      // }
    }
    /**
     * Gets/Sets row selection mode
     *
     * @remarks
     * By default the row selection mode is 'none'
     * Note that in IgxGrid and IgxHierarchicalGrid 'multipleCascade' behaves like 'multiple'
     */
    get rowSelection() {
      return this._rowSelectionMode;
    }
    set rowSelection(selectionMode) {
      this._rowSelectionMode = selectionMode;
      if (!this._init) {
        this.selectionService.clearAllSelectedRows();
        this.notifyChanges(true);
      }
    }
    /**
     * Gets/Sets column selection mode
     *
     * @remarks
     * By default the row selection mode is none
     * @param selectionMode: GridSelectionMode
     */
    get columnSelection() {
      return this._columnSelectionMode;
    }
    set columnSelection(selectionMode) {
      this._columnSelectionMode = selectionMode;
      // if (this.gridAPI.grid) {
      this.selectionService.clearAllSelectedColumns();
      this.notifyChanges(true);
      // }
    }
    /**
     * @hidden @internal
     */
    set pagingState(value) {
      this._pagingState = value;
      if (this.paginator && !this._init) {
        this.paginator.totalRecords = value.metadata.countRecords;
      }
    }
    get pagingState() {
      return this._pagingState;
    }
    /**
     * Represents the last search information.
     */
    get lastSearchInfo() {
      return this._lastSearchInfo;
    }
    /** @hidden @internal */
    get type() {
      return 'flat';
    }
    /** @hidden @internal */
    get paginator() {
      return this.paginationComponents?.first;
    }
    /**
     * @hidden @internal
     */
    get scrollSize() {
      return this.verticalScrollContainer.getScrollNativeSize();
    }
    /**
     * @hidden @internal
     */
    get minColumnWidth() {
      return MINIMUM_COLUMN_WIDTH$1;
    }
    get isCustomSetRowHeight() {
      return !isNaN(this._rowHeight);
    }
    /**
     * Returns an array of objects containing the filtered data.
     *
     * @example
     * ```typescript
     * let filteredData = this.grid.filteredData;
     * ```
     */
    get filteredData() {
      return this._filteredData;
    }
    /**
     * Returns an array containing the filtered sorted data.
     *
     * @example
     * ```typescript
     * const filteredSortedData = this.grid1.filteredSortedData;
     * ```
     */
    get filteredSortedData() {
      return this._filteredSortedData;
    }
    /**
     * @hidden @internal
     */
    get rowChangesCount() {
      if (!this.crudService.row) {
        return 0;
      }
      const f = obj => {
        let changes = 0;
        Object.keys(obj).forEach(key => isObject(obj[key]) ? changes += f(obj[key]) : changes++);
        return changes;
      };
      if (this.transactions.getState(this.crudService.row.id)?.type === TransactionType.ADD) {
        return this._columns.filter(c => c.field).length;
      }
      const rowChanges = this.transactions.getAggregatedValue(this.crudService.row.id, false);
      return rowChanges ? f(rowChanges) : 0;
    }
    /**
     * @hidden @internal
     */
    get dataWithAddedInTransactionRows() {
      const result = cloneArray(this.gridAPI.get_all_data());
      if (this.transactions.enabled) {
        result.push(...this.transactions.getAggregatedChanges(true).filter(t => t.type === TransactionType.ADD).map(t => t.newValue));
      }
      if (this.crudService.row && this.crudService.row.getClassName() === IgxAddRow.name) {
        result.splice(this.crudService.row.index, 0, this.crudService.row.data);
      }
      return result;
    }
    /**
     * @hidden @internal
     */
    get dataLength() {
      return this.transactions.enabled ? this.dataWithAddedInTransactionRows.length : this.gridAPI.get_all_data().length;
    }
    /**
     * @hidden @internal
     */
    get template() {
      if (this.isLoading && (this.hasZeroResultFilter || this.hasNoData)) {
        return this.loadingGridTemplate ? this.loadingGridTemplate : this.loadingGridDefaultTemplate;
      }
      if (this.hasZeroResultFilter) {
        return this.emptyGridTemplate ? this.emptyGridTemplate : this.emptyFilteredGridTemplate;
      }
      if (this.hasNoData) {
        return this.emptyGridTemplate ? this.emptyGridTemplate : this.emptyGridDefaultTemplate;
      }
    }
    /**
     * @hidden @internal
     */
    get hasZeroResultFilter() {
      return this.filteredData && this.filteredData.length === 0;
    }
    /**
     * @hidden @internal
     */
    get hasNoData() {
      return !this.data || this.dataLength === 0;
    }
    /**
     * @hidden @internal
     */
    get shouldOverlayLoading() {
      return this.isLoading && !this.hasNoData && !this.hasZeroResultFilter;
    }
    /**
     * @hidden @internal
     */
    get isMultiRowSelectionEnabled() {
      return this.rowSelection === GridSelectionMode.multiple || this.rowSelection === GridSelectionMode.multipleCascade;
    }
    /**
     * @hidden @internal
     */
    get isRowSelectable() {
      return this.rowSelection !== GridSelectionMode.none;
    }
    /**
     * @hidden @internal
     */
    get isCellSelectable() {
      return this.cellSelection !== GridSelectionMode.none;
    }
    /**
     * @hidden @internal
     */
    get columnInDrag() {
      return this.gridAPI.cms.column;
    }
    constructor(validation, /** @hidden @internal */
    selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, /** @hidden @internal */
    document, cdr, differs, viewRef, injector, envInjector, navigation, /** @hidden @internal */
    filteringService, textHighlightService, overlayService, /** @hidden @internal */
    summaryService, localeId, platform, _diTransactions) {
      this.validation = validation;
      this.selectionService = selectionService;
      this.colResizingService = colResizingService;
      this.gridAPI = gridAPI;
      this.transactionFactory = transactionFactory;
      this.elementRef = elementRef;
      this.zone = zone;
      this.document = document;
      this.cdr = cdr;
      this.differs = differs;
      this.viewRef = viewRef;
      this.injector = injector;
      this.envInjector = envInjector;
      this.navigation = navigation;
      this.filteringService = filteringService;
      this.textHighlightService = textHighlightService;
      this.overlayService = overlayService;
      this.summaryService = summaryService;
      this.localeId = localeId;
      this.platform = platform;
      this._diTransactions = _diTransactions;
      /**
       * Gets/Sets the display time for the row adding snackbar notification.
       *
       * @remarks
       * By default it is 6000ms.
       */
      this.snackbarDisplayTime = 6000;
      /**
       * Gets/Sets whether to auto-generate the columns.
       *
       * @remarks
       * The default value is false. When set to true, it will override all columns declared through code or in markup.
       * @example
       * ```html
       * <igx-grid [data]="Data" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.autoGenerate = false;
      /**
       * Gets/Sets a list of property keys to be excluded from the generated column collection
       * @remarks
       * The collection is only used during initialization and changing it will not cause any changes in the generated columns at runtime
       * unless the grid is destroyed and recreated. To modify the columns visible in the UI at runtime, please use their
       * [hidden](https://www.infragistics.com/products/ignite-ui-angular/docs/typescript/latest/classes/IgxColumnComponent.html#hidden) property.
       * @example
       * ```html
       * <igx-grid data=[Data] [autoGenerate]="true" [autoGenerateExclude]="['ProductName', 'Count']"></igx-grid>
       * ```
       * ```typescript
       * const Data = [{ 'Id': '1', 'ProductName': 'name1', 'Description': 'description1', 'Count': 5 }]
       * ```
       */
      this.autoGenerateExclude = [];
      /**
       * Controls whether columns moving is enabled in the grid.
       *
       */
      this.moving = false;
      /**
       * Controls the copy behavior of the grid.
       */
      this.clipboardOptions = {
        /**
         * Enables/disables the copy behavior
         */
        enabled: true,
        /**
         * Include the columns headers in the clipboard output.
         */
        copyHeaders: true,
        /**
         * Apply the columns formatters (if any) on the data in the clipboard output.
         */
        copyFormatters: true,
        /**
         * The separator used for formatting the copy output. Defaults to `\t`.
         */
        separator: '\t'
      };
      /**
       * Emitted after filtering is performed.
       *
       * @remarks
       * Returns the filtering expressions tree of the column for which filtering was performed.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [height]="'305px'" [autoGenerate]="true"
       *              (filteringExpressionsTreeChange)="filteringExprTreeChange($event)"></igx-grid>
       * ```
       */
      this.filteringExpressionsTreeChange = new EventEmitter();
      /**
       * Emitted after advanced filtering is performed.
       *
       * @remarks
       * Returns the advanced filtering expressions tree.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [height]="'305px'" [autoGenerate]="true"
       *           (advancedFilteringExpressionsTreeChange)="advancedFilteringExprTreeChange($event)"></igx-grid>
       * ```
       */
      this.advancedFilteringExpressionsTreeChange = new EventEmitter();
      /**
       * Emitted when grid is scrolled horizontally/vertically.
       *
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [height]="'305px'" [autoGenerate]="true"
       *              (gridScroll)="onScroll($event)"></igx-grid>
       * ```
       */
      this.gridScroll = new EventEmitter();
      /* treatAsRef */
      /**
       * Sets conditional style properties on the grid row element.
       * It accepts an object literal where the keys are
       * the style properties and the value is an expression to be evaluated.
       * ```typescript
       * styles = {
       *  background: 'yellow',
       *  color: (row: RowType) => row.selected : 'red': 'white'
       * }
       * ```
       * ```html
       * <igx-grid #grid [data]="Data" [rowStyles]="styles" [autoGenerate]="true"></igx-grid>
       * ```
       *
       * @memberof IgxColumnComponent
       */
      this.rowStyles = null;
      /**
       * Emitted when a cell is clicked.
       *
       * @remarks
       * Returns the `IgxGridCell`.
       * @example
       * ```html
       * <igx-grid #grid (cellClick)="cellClick($event)" [data]="localData" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.cellClick = new EventEmitter();
      /**
       * Emitted when a row is clicked.
       *
       * @remarks
       * Returns the `IgxGridRow`.
       * @example
       * ```html
       * <igx-grid #grid (rowClick)="rowClick($event)" [data]="localData" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowClick = new EventEmitter();
      /**
       * Emitted when formGroup is created on edit of row/cell.
       *
       * @example
       * ```html
       * <igx-grid #grid (formGroupCreated)="formGroupCreated($event)" [data]="localData" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.formGroupCreated = new EventEmitter();
      /**
       * Emitted when grid's validation status changes.
       *
       * @example
       * ```html
       * <igx-grid #grid (validationStatusChange)="validationStatusChange($event)" [data]="localData" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.validationStatusChange = new EventEmitter();
      /**
       * Emitted when a cell is selected.
       *
       * @remarks
       *  Returns the `IgxGridCell`.
       * @example
       * ```html
       * <igx-grid #grid (selected)="onCellSelect($event)" [data]="localData" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.selected = new EventEmitter();
      /**
       *  Emitted when `IgxGridRowComponent` is selected.
       *
       * @example
       * ```html
       * <igx-grid #grid (rowSelectionChanging)="rowSelectionChanging($event)" [data]="localData" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowSelectionChanging = new EventEmitter();
      /**
       *  Emitted when `IgxColumnComponent` is selected.
       *
       * @example
       * ```html
       * <igx-grid #grid (columnSelectionChanging)="columnSelectionChanging($event)" [data]="localData" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.columnSelectionChanging = new EventEmitter();
      /**
       * Emitted before `IgxColumnComponent` is pinned.
       *
       * @remarks
       * The index at which to insert the column may be changed through the `insertAtIndex` property.
       * @example
       * ```typescript
       * public columnPinning(event) {
       *     if (event.column.field === "Name") {
       *       event.insertAtIndex = 0;
       *     }
       * }
       * ```
       */
      this.columnPin = new EventEmitter();
      /**
       * Emitted after `IgxColumnComponent` is pinned.
       *
       * @remarks
       * The index that the column is inserted at may be changed through the `insertAtIndex` property.
       * @example
       * ```typescript
       * public columnPinning(event) {
       *     if (event.column.field === "Name") {
       *       event.insertAtIndex = 0;
       *     }
       * }
       * ```
       */
      this.columnPinned = new EventEmitter();
      /**
       * Emitted when cell enters edit mode.
       *
       * @remarks
       * This event is cancelable.
       * @example
       * ```html
       * <igx-grid #grid3 (cellEditEnter)="editStart($event)" [data]="data" [primaryKey]="'ProductID'">
       * </igx-grid>
       * ```
       */
      this.cellEditEnter = new EventEmitter();
      /**
       * Emitted when cell exits edit mode.
       *
       * @example
       * ```html
       * <igx-grid #grid3 (cellEditExit)="editExit($event)" [data]="data" [primaryKey]="'ProductID'">
       * </igx-grid>
       * ```
       */
      this.cellEditExit = new EventEmitter();
      /**
       * Emitted when cell has been edited.
       *
       * @remarks
       * Event is fired after editing is completed, when the cell is exiting edit mode.
       * This event is cancelable.
       * @example
       * ```html
       * <igx-grid #grid3 (cellEdit)="editDone($event)" [data]="data" [primaryKey]="'ProductID'">
       * </igx-grid>
       * ```
       */
      this.cellEdit = new EventEmitter();
      /* blazorCSSuppress */
      /**
       * Emitted after cell has been edited and editing has been committed.
       *
       * @example
       * ```html
       * <igx-grid #grid3 (cellEditDone)="editDone($event)" [data]="data" [primaryKey]="'ProductID'">
       * </igx-grid>
       * ```
       */
      this.cellEditDone = new EventEmitter();
      /**
       * Emitted when a row enters edit mode.
       *
       * @remarks
       * Emitted when [rowEditable]="true".
       * This event is cancelable.
       * @example
       * ```html
       * <igx-grid #grid3 (rowEditEnter)="editStart($event)" [primaryKey]="'ProductID'" [rowEditable]="true">
       * </igx-grid>
       * ```
       */
      this.rowEditEnter = new EventEmitter();
      /**
       * Emitted when exiting edit mode for a row.
       *
       * @remarks
       * Emitted when [rowEditable]="true" & `endEdit(true)` is called.
       * Emitted when changing rows during edit mode, selecting an un-editable cell in the edited row,
       * performing paging operation, column resizing, pinning, moving or hitting `Done`
       * button inside of the rowEditingOverlay, or hitting the `Enter` key while editing a cell.
       * This event is cancelable.
       * @example
       * ```html
       * <igx-grid #grid3 (rowEdit)="editDone($event)" [data]="data" [primaryKey]="'ProductID'" [rowEditable]="true">
       * </igx-grid>
       * ```
       */
      this.rowEdit = new EventEmitter();
      /**
       * Emitted after exiting edit mode for a row and editing has been committed.
       *
       * @remarks
       * Emitted when [rowEditable]="true" & `endEdit(true)` is called.
       * Emitted when changing rows during edit mode, selecting an un-editable cell in the edited row,
       * performing paging operation, column resizing, pinning, moving or hitting `Done`
       * button inside of the rowEditingOverlay, or hitting the `Enter` key while editing a cell.
       * @example
       * ```html
       * <igx-grid #grid3 (rowEditDone)="editDone($event)" [data]="data" [primaryKey]="'ProductID'" [rowEditable]="true">
       * </igx-grid>
       * ```
       */
      this.rowEditDone = new EventEmitter();
      /**
       * Emitted when row editing is canceled.
       *
       * @remarks
       * Emits when [rowEditable]="true" & `endEdit(false)` is called.
       * Emitted when changing hitting `Esc` key during cell editing and when click on the `Cancel` button
       * in the row editing overlay.
       * @example
       * ```html
       * <igx-grid #grid3 (rowEditExit)="editExit($event)" [data]="data" [primaryKey]="'ProductID'" [rowEditable]="true">
       * </igx-grid>
       * ```
       */
      this.rowEditExit = new EventEmitter();
      /**
       * Emitted when a column is initialized.
       *
       * @remarks
       * Returns the column object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (columnInit)="initColumns($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.columnInit = new EventEmitter();
      /* blazorInclude */
      /**
       * @hidden @internal
       */
      this.columnsAutogenerated = new EventEmitter();
      /**
       * Emitted before sorting expressions are applied.
       *
       * @remarks
       * Returns an `ISortingEventArgs` object. `sortingExpressions` key holds the sorting expressions.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [autoGenerate]="true" (sorting)="sorting($event)"></igx-grid>
       * ```
       */
      this.sorting = new EventEmitter();
      /**
       * Emitted after sorting is completed.
       *
       * @remarks
       * Returns the sorting expression.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [autoGenerate]="true" (sortingDone)="sortingDone($event)"></igx-grid>
       * ```
       */
      this.sortingDone = new EventEmitter();
      /**
       * Emitted before filtering expressions are applied.
       *
       * @remarks
       * Returns an `IFilteringEventArgs` object. `filteringExpressions` key holds the filtering expressions for the column.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [height]="'305px'" [autoGenerate]="true" (filtering)="filtering($event)"></igx-grid>
       * ```
       */
      this.filtering = new EventEmitter();
      /**
       * Emitted after filtering is performed through the UI.
       *
       * @remarks
       * Returns the filtering expressions tree of the column for which filtering was performed.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [height]="'305px'" [autoGenerate]="true" (filteringDone)="filteringDone($event)"></igx-grid>
       * ```
       */
      this.filteringDone = new EventEmitter();
      /* blazorCSSuppress */
      /**
       * Emitted when a row is added.
       *
       * @remarks
       * Returns the data for the new `IgxGridRowComponent` object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (rowAdded)="rowAdded($event)" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowAdded = new EventEmitter();
      /* blazorCSSuppress */
      /**
       * Emitted when a row is deleted.
       *
       * @remarks
       * Returns an `IRowDataEventArgs` object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (rowDeleted)="rowDeleted($event)" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowDeleted = new EventEmitter();
      /**
       * Emmited when deleting a row.
       *
       * @remarks
       * This event is cancelable.
       * Returns an IRowDataCancellableEventArgs` object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (rowDelete)="rowDelete($event)" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowDelete = new EventEmitter();
      /**
       * Emmited just before the newly added row is commited.
       *
       * @remarks
       * This event is cancelable.
       * Returns an IRowDataCancellableEventArgs` object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (rowAdd)="rowAdd($event)" [height]="'305px'" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowAdd = new EventEmitter();
      /**
       * Emitted after column is resized.
       *
       * @remarks
       * Returns the `IgxColumnComponent` object's old and new width.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (columnResized)="resizing($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.columnResized = new EventEmitter();
      /**
       * Emitted when a cell or row is right clicked.
       *
       * @remarks
       * Returns the `IgxGridCell` object if the immediate context menu target is a cell or an `IgxGridRow` otherwise.
       * ```html
       * <igx-grid #grid [data]="localData" (contextMenu)="contextMenu($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.contextMenu = new EventEmitter();
      /**
       * Emitted when a cell is double clicked.
       *
       * @remarks
       * Returns the `IgxGridCell` object.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (doubleClick)="dblClick($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.doubleClick = new EventEmitter();
      /**
       * Emitted before column visibility is changed.
       *
       * @remarks
       * Args: { column: any, newValue: boolean }
       * @example
       * ```html
       * <igx-grid (columnVisibilityChanging)="visibilityChanging($event)"></igx-grid>
       * ```
       */
      this.columnVisibilityChanging = new EventEmitter();
      /**
       * Emitted after column visibility is changed.
       *
       * @remarks
       * Args: { column: IgxColumnComponent, newValue: boolean }
       * @example
       * ```html
       * <igx-grid (columnVisibilityChanged)="visibilityChanged($event)"></igx-grid>
       * ```
       */
      this.columnVisibilityChanged = new EventEmitter();
      /**
       * Emitted when column moving starts.
       *
       * @remarks
       * Returns the moved `IgxColumnComponent` object.
       * @example
       * ```html
       * <igx-grid (columnMovingStart)="movingStart($event)"></igx-grid>
       * ```
       */
      this.columnMovingStart = new EventEmitter();
      /**
       * Emitted during the column moving operation.
       *
       * @remarks
       * Returns the source and target `IgxColumnComponent` objects. This event is cancelable.
       * @example
       * ```html
       * <igx-grid (columnMoving)="moving($event)"></igx-grid>
       * ```
       */
      this.columnMoving = new EventEmitter();
      /**
       * Emitted when column moving ends.
       *
       * @remarks
       * Returns the source and target `IgxColumnComponent` objects.
       * @example
       * ```html
       * <igx-grid (columnMovingEnd)="movingEnds($event)"></igx-grid>
       * ```
       */
      this.columnMovingEnd = new EventEmitter();
      /**
       * Emitted when keydown is triggered over element inside grid's body.
       *
       * @remarks
       * This event is fired only if the key combination is supported in the grid.
       * Return the target type, target object and the original event. This event is cancelable.
       * @example
       * ```html
       *  <igx-grid (gridKeydown)="customKeydown($event)"></igx-grid>
       * ```
       */
      this.gridKeydown = new EventEmitter();
      /**
       * Emitted when start dragging a row.
       *
       * @remarks
       * Return the dragged row.
       */
      this.rowDragStart = new EventEmitter();
      /**
       * Emitted when dropping a row.
       *
       * @remarks
       * Return the dropped row.
       */
      this.rowDragEnd = new EventEmitter();
      /**
       * Emitted when a copy operation is executed.
       *
       * @remarks
       * Fired only if copy behavior is enabled through the [`clipboardOptions`]{@link IgxGridBaseDirective#clipboardOptions}.
       */
      this.gridCopy = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.expansionStatesChange = new EventEmitter();
      /* blazorInclude */
      /** @hidden @internal */
      this.selectedRowsChange = new EventEmitter();
      /**
       * Emitted when the expanded state of a row gets changed.
       *
       * @example
       * ```html
       * <igx-grid [data]="employeeData" (rowToggle)="rowToggle($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowToggle = new EventEmitter();
      /**
       * Emitted when the pinned state of a row is changed.
       *
       * @example
       * ```html
       * <igx-grid [data]="employeeData" (rowPinning)="rowPin($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowPinning = new EventEmitter();
      /**
       * Emitted when the pinned state of a row is changed.
       *
       * @example
       * ```html
       * <igx-grid [data]="employeeData" (rowPinned)="rowPin($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.rowPinned = new EventEmitter();
      /**
       * Emmited when the active node is changed.
       *
       * @example
       * ```
       * <igx-grid [data]="data" [autoGenerate]="true" (activeNodeChange)="activeNodeChange($event)"></igx-grid>
       * ```
       */
      this.activeNodeChange = new EventEmitter();
      /**
       * Emitted before sorting is performed.
       *
       * @remarks
       * Returns the sorting expressions.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" [autoGenerate]="true" (sortingExpressionsChange)="sortingExprChange($event)"></igx-grid>
       * ```
       */
      this.sortingExpressionsChange = new EventEmitter();
      /**
       * Emitted when an export process is initiated by the user.
       *
       * @example
       * ```typescript
       * toolbarExporting(event: IGridToolbarExportEventArgs){
       *     const toolbarExporting = event;
       * }
       * ```
       */
      this.toolbarExporting = new EventEmitter();
      /* End of toolbar related definitions */
      /**
       * Emitted when making a range selection.
       *
       * @remarks
       * Range selection can be made either through drag selection or through keyboard selection.
       */
      this.rangeSelected = new EventEmitter();
      /** Emitted after the ngAfterViewInit hook. At this point the grid exists in the DOM */
      this.rendered = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.localeChange = new EventEmitter();
      /**
       * Emitted before the grid's data view is changed because of a data operation, rebinding, etc.
       *
       * @example
       * ```typescript
       *  <igx-grid #grid [data]="localData" [autoGenerate]="true" (dataChanging)='handleDataChangingEvent()'></igx-grid>
       * ```
       */
      this.dataChanging = new EventEmitter();
      /**
       * Emitted after the grid's data view is changed because of a data operation, rebinding, etc.
       *
       * @example
       * ```typescript
       *  <igx-grid #grid [data]="localData" [autoGenerate]="true" (dataChanged)='handleDataChangedEvent()'></igx-grid>
       * ```
       */
      this.dataChanged = new EventEmitter();
      /* reactContentChildren */
      /* blazorInclude */
      /* blazorTreatAsCollection */
      /* blazorCollectionName: ColumnCollection */
      /* ngQueryListName: columnList */
      /**
       * @hidden @internal
       */
      this.columnList = new QueryList();
      /**
       * @hidden @internal
       */
      this.tmpOutlets = new QueryList();
      /**
       * The custom template, if any, that should be used when rendering a row expand indicator.
       */
      this.rowExpandedIndicatorDirectiveTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering a row collapse indicator.
       */
      this.rowCollapsedIndicatorDirectiveTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering a header expand indicator.
       */
      this.headerExpandedIndicatorDirectiveTemplate = null;
      /**
       * The custom template, if any, that should be used when rendering a header collapse indicator.
       */
      this.headerCollapsedIndicatorDirectiveTemplate = null;
      /** @hidden @internal */
      this.excelStyleHeaderIconDirectiveTemplate = null;
      /**
       * @hidden
       * @internal
       */
      this.sortAscendingHeaderIconDirectiveTemplate = null;
      /** @hidden @internal */
      this.sortDescendingHeaderIconDirectiveTemplate = null;
      /**
       * @hidden
       * @internal
       */
      this.sortHeaderIconDirectiveTemplate = null;
      /**
       * @hidden @internal
       */
      this.tabindex = 0;
      /**
       * @hidden @internal
       */
      this.hostRole = 'grid';
      this.baseClass = 'igx-grid';
      /**
       * Gets/Sets the trigger for validators used when editing the grid.
       *
       * @example
       * ```html
       * <igx-grid #grid validationTrigger='blur'></igx-grid>
       * ```
       */
      this.validationTrigger = 'change';
      /**
       * @hidden
       * @internal
       */
      this.rowDragging = false;
      /** @hidden @internal */
      this.dragRowID = null;
      /**
       * @hidden @internal
       */
      this.calcHeight = 0;
      /**
       * @hidden @internal
       */
      this.disableTransitions = false;
      /**
       * @hidden @internal
       */
      this.columnWidthSetByUser = false;
      /**
       * @hidden @internal
       */
      this.rendered$ = this.rendered.asObservable().pipe(shareReplay({
        bufferSize: 1,
        refCount: true
      }));
      /** @hidden @internal */
      this.resizeNotify = new Subject();
      /** @hidden @internal */
      this.rowAddedNotifier = new Subject();
      /** @hidden @internal */
      this.rowDeletedNotifier = new Subject();
      /** @hidden @internal */
      this.pipeTriggerNotifier = new Subject();
      /**
       * @hidden @internal
       */
      this._destroyed = false;
      /**
       * @hidden @internal
       */
      this._totalRecords = -1;
      /**
       * @hidden @internal
       */
      this.columnsWithNoSetWidths = null;
      /**
       * @hidden @internal
       */
      this.pipeTrigger = 0;
      /**
       * @hidden @internal
       */
      this.filteringPipeTrigger = 0;
      /**
       * @hidden @internal
       */
      this.isColumnWidthSum = false;
      /**
       * @hidden @internal
       */
      this.summaryPipeTrigger = 0;
      /**
       * @hidden @internal
       */
      this.groupablePipeTrigger = 0;
      /**
      * @hidden @internal
      */
      this.EMPTY_DATA = [];
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
      /**
       * @hidden
       */
      this._pagingMode = GridPagingMode.Local;
      /**
       * @hidden
       */
      this._hideRowSelectors = false;
      /**
       * @hidden
       */
      this._rowDrag = false;
      /**
       * @hidden
       */
      this._columns = [];
      /**
       * @hidden
       */
      this._pinnedColumns = [];
      /**
       * @hidden
       */
      this._unpinnedColumns = [];
      /**
       * @hidden
       */
      this._filteringExpressionsTree = new FilteringExpressionsTree(FilteringLogic.And);
      /**
       * @hidden
       */
      this._sortingExpressions = [];
      /**
       * @hidden
       */
      this._maxLevelHeaderDepth = null;
      /**
       * @hidden
       */
      this._columnHiding = false;
      /**
       * @hidden
       */
      this._columnPinning = false;
      this._pinnedRecordIDs = [];
      this._allowFiltering = false;
      this._allowAdvancedFiltering = false;
      this._filterMode = FilterMode.quickFilter;
      this._defaultTargetRecordNumber = 10;
      this._expansionStates = new Map();
      this._defaultExpandState = false;
      this._headerFeaturesWidth = NaN;
      this._init = true;
      this._firstAutoResize = true;
      this._autoSizeColumnsNotify = new Subject();
      this._cdrRequestRepaint = false;
      this._batchEditing = false;
      this._sortingOptions = {
        mode: 'multiple'
      };
      this._filterStrategy = new FilteringStrategy();
      this._autoGeneratedCols = [];
      this._dataView = [];
      this._lastSearchInfo = {
        searchText: '',
        caseSensitive: false,
        exactMatch: false,
        activeMatchIndex: 0,
        matchInfoCache: [],
        matchCount: 0,
        content: ''
      };
      this._rowEditable = false;
      this._filteredSortedData = null;
      this._filteredData = null;
      this._cdrRequests = false;
      this._resourceStrings = getCurrentResourceStrings(GridResourceStringsEN);
      this._emptyGridMessage = null;
      this._emptyFilteredGridMessage = null;
      this._isLoading = false;
      this.overlayIDs = [];
      this._pinning = {
        columns: ColumnPinningPosition.Start
      };
      this._shouldRecalcRowHeight = false;
      this._advancedFilteringPositionSettings = {
        verticalDirection: VerticalAlignment.Middle,
        horizontalDirection: HorizontalAlignment.Center,
        horizontalStartPoint: HorizontalAlignment.Center,
        verticalStartPoint: VerticalAlignment.Middle
      };
      this._advancedFilteringOverlaySettings = {
        closeOnOutsideClick: false,
        modal: false,
        positionStrategy: new ConnectedPositioningStrategy(this._advancedFilteringPositionSettings)
      };
      this._height = '100%';
      this._width = '100%';
      this._horizontalForOfs = [];
      this._multiRowLayoutRowSize = 1;
      // Caches
      this._totalWidth = NaN;
      this._pinnedVisible = [];
      this._unpinnedVisible = [];
      this._pinnedWidth = NaN;
      this._unpinnedWidth = NaN;
      this._visibleColumns = [];
      this._columnGroups = false;
      this._summaryPosition = GridSummaryPosition.bottom;
      this._summaryCalculationMode = GridSummaryCalculationMode.rootAndChildLevels;
      this._showSummaryOnCollapse = false;
      this._summaryRowHeight = 0;
      this._cellSelectionMode = GridSelectionMode.multiple;
      this._rowSelectionMode = GridSelectionMode.none;
      this._selectRowOnClick = true;
      this._columnSelectionMode = GridSelectionMode.none;
      this.rowEditPositioningStrategy = new RowEditPositionStrategy({
        horizontalDirection: HorizontalAlignment.Right,
        verticalDirection: VerticalAlignment.Bottom,
        horizontalStartPoint: HorizontalAlignment.Left,
        verticalStartPoint: VerticalAlignment.Bottom,
        closeAnimation: null
      });
      this.rowEditSettings = {
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnOutsideClick: false,
        outlet: this.rowOutletDirective,
        positionStrategy: this.rowEditPositioningStrategy
      };
      this.transactionChange$ = new Subject();
      this._rendered = false;
      this.DRAG_SCROLL_DELTA = 10;
      this._dataCloneStrategy = new DefaultDataCloneStrategy();
      this._autoSize = false;
      this._sortHeaderIconTemplate = null;
      this._sortAscendingHeaderIconTemplate = null;
      this._sortDescendingHeaderIconTemplate = null;
      this._gridSize = Size.Large;
      this._defaultRowHeight = 50;
      /**
       * @hidden @internal
       */
      this.isHorizontalScrollHidden = false;
      /**
       * @hidden @internal
       */
      this.preventContainerScroll = evt => {
        if (evt.target.scrollTop !== 0) {
          this.verticalScrollContainer.addScroll(evt.target.scrollTop);
          evt.target.scrollTop = 0;
        }
        if (evt.target.scrollLeft !== 0) {
          this.headerContainer.scrollPosition += evt.target.scrollLeft;
          evt.target.scrollLeft = 0;
        }
      };
      this.locale = this.locale || this.localeId;
      this._transactions = this.transactionFactory.create("None" /* TRANSACTION_TYPE.None */);
      this._transactions.cloneStrategy = this.dataCloneStrategy;
      this.cdr.detach();
      this.selectionService.selectedRowsChange.pipe(takeUntil(this.destroy$)).subscribe(args => {
        this.selectedRowsChange.emit(args);
      });
    }
    /**
     * @hidden
     * @internal
     */
    hideActionStrip() {
      this.actionStrip?.hide();
    }
    /**
     * @hidden
     * @internal
     */
    get headerFeaturesWidth() {
      return this._headerFeaturesWidth;
    }
    /**
     * @hidden
     * @internal
     */
    isDetailRecord(_rec) {
      return false;
    }
    /**
     * @hidden
     * @internal
     */
    isGroupByRecord(_rec) {
      return false;
    }
    /**
     * @hidden @internal
     */
    isGhostRecord(record) {
      return record.ghostRecord !== undefined;
    }
    /**
     * @hidden @internal
     */
    isAddRowRecord(record) {
      return record.addRow !== undefined;
    }
    /**
     * @hidden
     * Returns the row index of a row that takes into account the full view data like pinning.
     */
    getDataViewIndex(rowIndex, pinned) {
      if (pinned && !this.isRowPinningToTop) {
        rowIndex = rowIndex + this.unpinnedDataView.length;
      } else if (!pinned && this.isRowPinningToTop) {
        rowIndex = rowIndex + this.pinnedDataView.length;
      }
      return rowIndex;
    }
    /**
     * @hidden
     * @internal
     */
    get hasDetails() {
      return false;
    }
    /**
     * Returns the state of the grid virtualization.
     *
     * @remarks
     * Includes the start index and how many records are rendered.
     * @example
     * ```typescript
     * const gridVirtState = this.grid1.virtualizationState;
     * ```
     */
    get virtualizationState() {
      return this.verticalScrollContainer.state;
    }
    /**
     * @hidden
     * @internal
     */
    hideOverlays() {
      this.overlayIDs.forEach(overlayID => {
        const overlay = this.overlayService.getOverlayById(overlayID);
        if (overlay?.visible && !overlay.closeAnimationPlayer?.hasStarted()) {
          this.overlayService.hide(overlayID);
          this.nativeElement.focus();
        }
      });
    }
    /**
     * Returns whether the record is pinned or not.
     *
     * @param rowIndex Index of the record in the `dataView` collection.
     *
     * @hidden
     * @internal
     */
    isRecordPinnedByViewIndex(rowIndex) {
      return this.hasPinnedRecords && this.isRowPinningToTop && rowIndex < this.pinnedDataView.length || !this.isRowPinningToTop && rowIndex >= this.unpinnedDataView.length;
    }
    /**
     * Returns whether the record is pinned or not.
     *
     * @param rowIndex Index of the record in the `filteredSortedData` collection.
     */
    isRecordPinnedByIndex(rowIndex) {
      return this.hasPinnedRecords && this.isRowPinningToTop && rowIndex < this._filteredSortedPinnedData.length || !this.isRowPinningToTop && rowIndex >= this._filteredSortedUnpinnedData.length;
    }
    /**
     * @hidden
     * @internal
     */
    isRecordPinned(rec) {
      return this.getInitialPinnedIndex(rec) !== -1;
    }
    /**
     * @hidden
     * @internal
     * Returns the record index in order of pinning by the user. Does not consider sorting/filtering.
     */
    getInitialPinnedIndex(rec) {
      const id = this.gridAPI.get_row_id(rec);
      return this._pinnedRecordIDs.indexOf(id);
    }
    /**
     * @hidden
     * @internal
     */
    get hasPinnedRecords() {
      return this._pinnedRecordIDs.length > 0;
    }
    /**
     * @hidden
     * @internal
     */
    get pinnedRecordsCount() {
      return this._pinnedRecordIDs.length;
    }
    /**
     * @hidden
     * @internal
     */
    get crudService() {
      return this.gridAPI.crudService;
    }
    /**
     * @hidden
     * @internal
     */
    _setupServices() {
      this.gridAPI.grid = this;
      this.crudService.grid = this;
      this.selectionService.grid = this;
      this.validation.grid = this;
      this.navigation.grid = this;
      this.filteringService.grid = this;
      this.summaryService.grid = this;
    }
    /**
     * @hidden
     * @internal
     */
    _setupListeners() {
      const destructor = takeUntil(this.destroy$);
      fromEvent(this.nativeElement, 'focusout').pipe(filter(() => !!this.navigation.activeNode), destructor).subscribe(event => {
        const activeNode = this.navigation.activeNode;
        if (!this.crudService.cell && !!activeNode && (event.target === this.tbody.nativeElement && activeNode.row >= 0 && activeNode.row < this.dataView.length || event.target === this.theadRow.nativeElement && activeNode.row === -1 || event.target === this.tfoot.nativeElement && activeNode.row === this.dataView.length) && !(this.rowEditable && this.crudService.rowEditingBlocked && this.crudService.rowInEditMode)) {
          this.clearActiveNode();
        }
      });
      this.rowAddedNotifier.pipe(destructor).subscribe(args => this.refreshGridState(args));
      this.rowDeletedNotifier.pipe(destructor).subscribe(args => {
        this.summaryService.deleteOperation = true;
        this.summaryService.clearSummaryCache(args);
      });
      this.subscribeToTransactions();
      this.resizeNotify.pipe(filter(() => !this._init), throttleTime(40, animationFrameScheduler, {
        leading: true,
        trailing: true
      }), destructor).subscribe(() => {
        this.zone.run(() => {
          // do not trigger reflow if element is detached.
          if (this.nativeElement.isConnected) {
            if (this.shouldResize) {
              // resizing occurs due to the change of --ig-size css var
              this._gridSize = this.gridSize;
              this.updateDefaultRowHeight();
              this._autoSize = this.isPercentHeight && this.calcHeight !== this.getDataBasedBodyHeight();
              this.crudService.endEdit(false);
              if (this._summaryRowHeight === 0) {
                this.summaryService.summaryHeight = 0;
              }
            }
            this.notifyChanges(true);
          }
        });
      });
      this.pipeTriggerNotifier.pipe(takeUntil(this.destroy$)).subscribe(() => this.pipeTrigger++);
      this.columnMovingEnd.pipe(destructor).subscribe(() => this.crudService.endEdit(false));
      this.overlayService.opening.pipe(destructor).subscribe(event => {
        if (this._advancedFilteringOverlayId === event.id) {
          const instance = event.componentRef.instance;
          if (instance) {
            instance.initialize(this, this.overlayService, event.id);
          }
        }
      });
      this.overlayService.opened.pipe(destructor).subscribe(event => {
        const overlaySettings = this.overlayService.getOverlayById(event.id)?.settings;
        // do not hide the advanced filtering overlay on scroll
        if (this._advancedFilteringOverlayId === event.id) {
          const instance = event.componentRef.instance;
          if (instance) {
            instance.lastActiveNode = this.navigation.activeNode;
            instance.queryBuilder.setAddButtonFocus();
          }
          return;
        }
        // do not hide the overlay if it's attached to a row
        if (this.rowEditingOverlay?.overlayId === event.id) {
          return;
        }
        if (overlaySettings?.outlet === this.outlet && this.overlayIDs.indexOf(event.id) === -1) {
          this.overlayIDs.push(event.id);
        }
      });
      this.overlayService.closed.pipe(filter(() => !this._init), destructor).subscribe(event => {
        if (this._advancedFilteringOverlayId === event.id) {
          this.overlayService.detach(this._advancedFilteringOverlayId);
          this._advancedFilteringOverlayId = null;
          return;
        }
        const ind = this.overlayIDs.indexOf(event.id);
        if (ind !== -1) {
          this.overlayIDs.splice(ind, 1);
        }
      });
      this.verticalScrollContainer.dataChanging.pipe(filter(() => !this._init), destructor).subscribe($event => {
        const shouldRecalcSize = this.isPercentHeight && (!this.calcHeight || this.calcHeight === this.getDataBasedBodyHeight() || this.calcHeight === this.renderedRowHeight * this._defaultTargetRecordNumber);
        if (shouldRecalcSize) {
          this.calculateGridHeight();
          $event.containerSize = this.calcHeight;
        }
        this.evaluateLoadingState();
      });
      this.verticalScrollContainer.scrollbarVisibilityChanged.pipe(filter(() => !this._init), destructor).subscribe(() => {
        // called to recalc all widths that may have changes as a result of
        // the vert. scrollbar showing/hiding
        this.notifyChanges(true);
        this.cdr.detectChanges();
        Promise.resolve().then(() => this.headerContainer.updateScroll());
      });
      this.headerContainer?.scrollbarVisibilityChanged.pipe(filter(() => !this._init), destructor).subscribe(() => {
        // the horizontal scrollbar showing/hiding
        // update scrollbar visibility and recalc heights
        this.notifyChanges(true);
        this.cdr.detectChanges();
      });
      this.verticalScrollContainer.contentSizeChange.pipe(filter(() => !this._init), throttleTime(30), destructor).subscribe(() => {
        this.notifyChanges(true);
      });
      // notifier for column autosize requests
      this._autoSizeColumnsNotify.pipe(throttleTime(0, animationFrameScheduler, {
        leading: false,
        trailing: true
      }), destructor).subscribe(() => {
        this.autoSizeColumnsInView();
        this._firstAutoResize = false;
      });
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this._setupServices();
      this._setupListeners();
      this.rowListDiffer = this.differs.find([]).create(null);
      // compare based on field, not on object ref.
      this.columnListDiffer = this.differs.find([]).create((index, col) => col.field);
      this.calcWidth = this.width && this.width.indexOf('%') === -1 ? parseInt(this.width, 10) : 0;
      this.gridComputedStyles = this.document.defaultView.getComputedStyle(this.nativeElement);
    }
    /**
     * @hidden
     * @internal
     */
    resetColumnsCaches() {
      this._columns.forEach(column => column.resetCaches());
    }
    /**
     * @hidden @internal
     */
    generateRowID() {
      const primaryColumn = this._columns.find(col => col.field === this.primaryKey);
      const idType = this.data.length ? this.resolveDataTypes(this.data[0][this.primaryKey]) : primaryColumn ? primaryColumn.dataType : 'string';
      return idType === 'string' ? crypto.randomUUID() : FAKE_ROW_ID--;
    }
    /**
     * @hidden
     * @internal
     */
    resetForOfCache() {
      const firstVirtRow = this.dataRowList.first;
      if (firstVirtRow) {
        if (this._cdrRequests) {
          firstVirtRow.virtDirRow.cdr.detectChanges();
        }
        firstVirtRow.virtDirRow.assumeMaster();
      }
    }
    /**
     * @hidden
     * @internal
     */
    setFilteredData(data, pinned) {
      if (this.hasPinnedRecords && pinned) {
        this._filteredPinnedData = data || [];
        const filteredUnpinned = this._filteredUnpinnedData || [];
        const filteredData = [...this._filteredPinnedData, ...filteredUnpinned];
        this._filteredData = filteredData.length > 0 ? filteredData : this._filteredUnpinnedData;
      } else if (this.hasPinnedRecords && !pinned) {
        this._filteredUnpinnedData = data;
      } else {
        this._filteredData = data;
      }
    }
    /**
     * @hidden
     * @internal
     */
    resetColumnCollections() {
      if (this.hasColumnLayouts) {
        this._columns.filter(x => x.columnLayout).forEach(x => x.populateVisibleIndexes());
      }
      this._visibleColumns.length = 0;
      this._pinnedVisible.length = 0;
      this._unpinnedVisible.length = 0;
    }
    /**
     * @hidden
     * @internal
     */
    resetCachedWidths() {
      this._unpinnedWidth = NaN;
      this._pinnedWidth = NaN;
      this._totalWidth = NaN;
    }
    /**
     * @hidden
     * @internal
     */
    resetCaches(recalcFeatureWidth = true) {
      if (recalcFeatureWidth) {
        this._headerFeaturesWidth = NaN;
        this.summaryService.summaryHeight = 0;
      }
      this.resetColumnsCaches();
      this.resetColumnCollections();
      this.resetForOfCache();
      this.resetCachedWidths();
      this.hasVisibleColumns = undefined;
      this._columnGroups = this._columns.some(col => col.columnGroup);
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      if (this.sortHeaderIconDirectiveTemplate) {
        this.sortHeaderIconTemplate = this.sortHeaderIconDirectiveTemplate;
      }
      if (this.sortAscendingHeaderIconDirectiveTemplate) {
        this.sortAscendingHeaderIconTemplate = this.sortAscendingHeaderIconDirectiveTemplate;
      }
      if (this.sortDescendingHeaderIconDirectiveTemplate) {
        this.sortDescendingHeaderIconTemplate = this.sortDescendingHeaderIconDirectiveTemplate;
      }
      this.setupColumns();
      this.toolbar.changes.pipe(filter(() => !this._init), takeUntil(this.destroy$)).subscribe(() => this.notifyChanges(true));
      this.setUpPaginator();
      this.paginationComponents.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setUpPaginator();
      });
      if (this.actionStrip) {
        this.actionStrip.menuOverlaySettings.outlet = this.outlet;
      }
    }
    /**
     * @hidden @internal
     */
    dataRebinding(event) {
      if (event.state.chunkSize == 0) {
        this._shouldRecalcRowHeight = true;
      }
      this.dataChanging.emit(event);
    }
    /**
     * @hidden @internal
     */
    dataRebound(event) {
      this.selectionService.clearHeaderCBState();
      if (this._shouldRecalcRowHeight) {
        this._shouldRecalcRowHeight = false;
        this.updateDefaultRowHeight();
      }
      this.dataChanged.emit(event);
    }
    /** @hidden @internal */
    createFilterDropdown(column, options) {
      options.outlet = this.outlet;
      if (this.excelStyleFilteringComponent) {
        this.excelStyleFilteringComponent.initialize(column, this.overlayService);
        const id = this.overlayService.attach(this.excelStyleFilteringComponent.element, options);
        this.excelStyleFilteringComponent.overlayComponentId = id;
        return id;
      }
      const id = this.overlayService.attach(IgxGridExcelStyleFilteringComponent, this.viewRef, options);
      return id;
    }
    /** @hidden @internal */
    setUpPaginator() {
      if (this.paginator) {
        this.paginator.pageChange.pipe(takeWhile(() => !!this.paginator), filter(() => !this._init)).subscribe(() => {
          this.selectionService.clear(true);
          this.crudService.endEdit(false);
          this.pipeTrigger++;
          this.navigateTo(0);
          this.notifyChanges();
        });
        this.paginator.perPageChange.pipe(takeWhile(() => !!this.paginator), filter(() => !this._init)).subscribe(() => {
          this.selectionService.clear(true);
          this.page = 0;
          this.crudService.endEdit(false);
          this.notifyChanges();
        });
      } else {
        this.markForCheck();
      }
    }
    /**
     * @hidden
     * @internal
     */
    setFilteredSortedData(data, pinned) {
      data = data || [];
      if (this.pinnedRecordsCount > 0) {
        if (pinned) {
          this._filteredSortedPinnedData = data;
          this.pinnedRecords = data;
          this._filteredSortedData = this.isRowPinningToTop ? [...this._filteredSortedPinnedData, ...this._filteredSortedUnpinnedData] : [...this._filteredSortedUnpinnedData, ...this._filteredSortedPinnedData];
          this.refreshSearch(true, false);
        } else {
          this._filteredSortedUnpinnedData = data;
        }
      } else {
        this._filteredSortedData = data;
        this.refreshSearch(true, false);
      }
      this.buildDataView(data);
    }
    /**
     * @hidden @internal
     */
    resetHorizontalVirtualization() {
      const elementFilter = item => this.isDefined(item.nativeElement.parentElement);
      this._horizontalForOfs = [...this._dataRowList.filter(elementFilter).map(item => item.virtDirRow), ...this._summaryRowList.filter(elementFilter).map(item => item.virtDirRow)];
    }
    /**
     * @hidden @internal
     */
    _setupRowObservers() {
      const elementFilter = item => this.isDefined(item.nativeElement.parentElement);
      const extractForOfs = pipe(map(collection => collection.filter(elementFilter).map(item => item.virtDirRow)));
      const rowListObserver = extractForOfs(this._dataRowList.changes);
      const summaryRowObserver = extractForOfs(this._summaryRowList.changes);
      rowListObserver.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.resetHorizontalVirtualization();
      });
      summaryRowObserver.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.resetHorizontalVirtualization();
      });
      this.resetHorizontalVirtualization();
    }
    /**
     * @hidden @internal
     */
    _zoneBegoneListeners() {
      this.zone.runOutsideAngular(() => {
        this.verticalScrollContainer.getScroll().addEventListener('scroll', this.verticalScrollHandler.bind(this));
        this.headerContainer?.getScroll().addEventListener('scroll', this.horizontalScrollHandler.bind(this));
        if (this.hasColumnsToAutosize) {
          this.headerContainer?.dataChanged.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.cdr.detectChanges();
            this.zone.onStable.pipe(first$2()).subscribe(() => {
              this.autoSizeColumnsInView();
            });
          });
        }
        // Window resize observer not needed because when you resize the window element the tbody container always resize so
        // it would always notify resizing, thus a change detection and recalculation of sizes will occur
        resizeObservable(this.nativeElement).pipe(first$2(), takeUntil(this.destroy$)).subscribe(() => this.resizeNotify.next());
        resizeObservable(this.tbodyContainer.nativeElement).pipe(takeUntil(this.destroy$)).subscribe(() => this.resizeNotify.next());
      });
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this.initPinning();
      this.calculateGridSizes();
      this._init = false;
      this.cdr.reattach();
      this._setupRowObservers();
      this._zoneBegoneListeners();
      const vertScrDC = this.verticalScrollContainer.displayContainer;
      vertScrDC.addEventListener('scroll', this.preventContainerScroll.bind(this));
      this._pinnedRowList.changes.pipe(takeUntil(this.destroy$)).subscribe(change => {
        this.onPinnedRowsChanged(change);
      });
      this.addRowSnackbar?.clicked.pipe(takeUntil(this.destroy$)).subscribe(() => {
        const rec = this.filteredSortedData[this.lastAddedRowIndex];
        this.scrollTo(rec, 0);
        this.addRowSnackbar.close();
      });
      // Keep the stream open for future subscribers
      this.rendered$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.paginator) {
          this.paginator.totalRecords = this.totalRecords ? this.totalRecords : this.paginator.totalRecords;
          this.paginator.overlaySettings = {
            outlet: this.outlet
          };
        }
        if (this.hasColumnsToAutosize) {
          this.autoSizeColumnsInView();
        }
        this._rendered = true;
      });
      Promise.resolve().then(() => this.rendered.next(true));
    }
    /**
     * @hidden @internal
     */
    notifyChanges(repaint = false) {
      this._cdrRequests = true;
      this._cdrRequestRepaint = repaint;
      this.cdr.markForCheck();
    }
    /**
     * @hidden @internal
     */
    ngDoCheck() {
      if (this._init) {
        return;
      }
      if (this._cdrRequestRepaint) {
        this.resetNotifyChanges();
        this.calculateGridSizes();
        this.refreshSearch(true);
        return;
      }
      if (this._cdrRequests) {
        this.resetNotifyChanges();
        this.cdr.detectChanges();
      }
    }
    /**
     * @hidden
     * @internal
     */
    getDragGhostCustomTemplate() {
      return this.dragGhostCustomTemplate;
    }
    /**
     * @hidden @internal
     */
    ngOnDestroy() {
      this.tmpOutlets.forEach(tmplOutlet => {
        tmplOutlet.cleanCache();
      });
      this.destroy$.next(true);
      this.destroy$.complete();
      this.transactionChange$.next();
      this.transactionChange$.complete();
      this._destroyed = true;
      this.textHighlightService.destroyGroup(this.id);
      if (this._advancedFilteringOverlayId) {
        this.overlayService.detach(this._advancedFilteringOverlayId);
        delete this._advancedFilteringOverlayId;
      }
      this.overlayIDs.forEach(overlayID => {
        const overlay = this.overlayService.getOverlayById(overlayID);
        if (overlay && !overlay.detached) {
          this.overlayService.detach(overlayID);
        }
      });
      this.zone.runOutsideAngular(() => {
        this.verticalScrollContainer?.getScroll()?.removeEventListener('scroll', this.verticalScrollHandler);
        this.headerContainer?.getScroll()?.removeEventListener('scroll', this.horizontalScrollHandler);
        const vertScrDC = this.verticalScrollContainer?.displayContainer;
        vertScrDC?.removeEventListener('scroll', this.preventContainerScroll);
      });
    }
    /**
     * Toggles the specified column's visibility.
     *
     * @example
     * ```typescript
     * this.grid1.toggleColumnVisibility({
     *       column: this.grid1.columns[0],
     *       newValue: true
     * });
     * ```
     */
    toggleColumnVisibility(args) {
      const col = args.column ? this._columns.find(c => c === args.column) : undefined;
      if (!col) {
        return;
      }
      col.toggleVisibility(args.newValue);
    }
    /* blazorSuppress */
    /**
     * Gets/Sets a list of key-value pairs [row ID, expansion state].
     *
     * @remarks
     * Includes only states that differ from the default one.
     * Supports two-way binding.
     * @example
     * ```html
     * <igx-grid #grid [data]="data" [(expansionStates)]="model.expansionStates">
     * </igx-grid>
     * ```
     */
    get expansionStates() {
      return this._expansionStates;
    }
    /* blazorSuppress */
    set expansionStates(value) {
      this._expansionStates = new Map(value);
      this.expansionStatesChange.emit(this._expansionStates);
      this.notifyChanges(true);
      if (this.gridAPI.grid) {
        this.cdr.detectChanges();
      }
    }
    /**
     * Expands all rows.
     *
     * @example
     * ```typescript
     * this.grid.expandAll();
     * ```
     */
    expandAll() {
      this._defaultExpandState = true;
      this.expansionStates = new Map();
    }
    /**
     * Collapses all rows.
     *
     * @example
     * ```typescript
     * this.grid.collapseAll();
     * ```
     */
    collapseAll() {
      this._defaultExpandState = false;
      this.expansionStates = new Map();
    }
    /**
     * Expands the row by its id.
     *
     * @remarks
     * ID is either the primaryKey value or the data record instance.
     * @example
     * ```typescript
     * this.grid.expandRow(rowID);
     * ```
     * @param rowID The row id - primaryKey value or the data record instance.
     */
    expandRow(rowID) {
      this.gridAPI.set_row_expansion_state(rowID, true);
    }
    /**
     * Collapses the row by its id.
     *
     * @remarks
     * ID is either the primaryKey value or the data record instance.
     * @example
     * ```typescript
     * this.grid.collapseRow(rowID);
     * ```
     * @param rowID The row id - primaryKey value or the data record instance.
     */
    collapseRow(rowID) {
      this.gridAPI.set_row_expansion_state(rowID, false);
    }
    /**
     * Toggles the row by its id.
     *
     * @remarks
     * ID is either the primaryKey value or the data record instance.
     * @example
     * ```typescript
     * this.grid.toggleRow(rowID);
     * ```
     * @param rowID The row id - primaryKey value or the data record instance.
     */
    toggleRow(rowID) {
      const rec = this.gridAPI.get_rec_by_id(rowID);
      const state = this.gridAPI.get_row_expansion_state(rec);
      this.gridAPI.set_row_expansion_state(rowID, !state);
    }
    /**
     * @hidden
     * @internal
     */
    getDefaultExpandState(_rec) {
      return this._defaultExpandState;
    }
    /**
     * Gets the native element.
     *
     * @example
     * ```typescript
     * const nativeEl = this.grid.nativeElement.
     * ```
     */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    /**
     * Gets/Sets the outlet used to attach the grid's overlays to.
     *
     * @remarks
     * If set, returns the outlet defined outside the grid. Otherwise returns the grid's internal outlet directive.
     */
    get outlet() {
      return this.resolveOutlet();
    }
    set outlet(val) {
      this._userOutletDirective = val;
    }
    /**
     * Gets the default row height.
     *
     * @example
     * ```typescript
     * const rowHeigh = this.grid.defaultRowHeight;
     * ```
     */
    get defaultRowHeight() {
      return this._defaultRowHeight;
    }
    /**
     * @hidden @internal
     */
    get defaultSummaryHeight() {
      switch (this.gridSize) {
        case Size.Medium:
          return 30;
        case Size.Small:
          return 24;
        default:
          return 36;
      }
    }
    /**
     * Returns the `IgxGridHeaderGroupComponent`'s minimum allowed width.
     *
     * @remarks
     * Used internally for restricting header group component width.
     * The values below depend on the header cell default right/left padding values.
     */
    get defaultHeaderGroupMinWidth() {
      switch (this.gridSize) {
        case Size.Medium:
          return 32;
        case Size.Small:
          return 24;
        default:
          return 48;
      }
    }
    /** @hidden @internal */
    get pinnedWidth() {
      if (!isNaN(this._pinnedWidth)) {
        return this._pinnedWidth;
      }
      this._pinnedWidth = this.getPinnedWidth();
      return this._pinnedWidth;
    }
    /** @hidden @internal */
    get unpinnedWidth() {
      if (!isNaN(this._unpinnedWidth)) {
        return this._unpinnedWidth;
      }
      this._unpinnedWidth = this.getUnpinnedWidth();
      return this._unpinnedWidth;
    }
    /**
     * @hidden @internal
     * Gets the header cell inner width for auto-sizing.
     */
    getHeaderCellWidth(element) {
      const range = this.document.createRange();
      const headerWidth = this.platform.getNodeSizeViaRange(range, element, element.parentElement);
      const headerStyle = this.document.defaultView.getComputedStyle(element);
      const headerPadding = parseFloat(headerStyle.paddingLeft) + parseFloat(headerStyle.paddingRight) + parseFloat(headerStyle.borderRightWidth);
      // Take into consideration the header group element, since column pinning applies borders to it if its not a columnGroup.
      const headerGroupStyle = this.document.defaultView.getComputedStyle(element.parentElement);
      const borderSize = parseFloat(headerGroupStyle.borderRightWidth) + parseFloat(headerGroupStyle.borderLeftWidth);
      return {
        width: Math.ceil(headerWidth),
        padding: Math.ceil(headerPadding + borderSize)
      };
    }
    /**
     * @hidden @internal
     * Gets the combined width of the columns that are specific to the enabled grid features. They are fixed.
     */
    featureColumnsWidth(expander) {
      if (Number.isNaN(this._headerFeaturesWidth)) {
        // TODO: platformUtil.isBrowser check
        const rowSelectArea = this.headerSelectorContainer?.nativeElement?.getBoundingClientRect ? this.headerSelectorContainer.nativeElement.getBoundingClientRect().width : 0;
        const rowDragArea = this.rowDraggable && this.headerDragContainer?.nativeElement?.getBoundingClientRect ? this.headerDragContainer.nativeElement.getBoundingClientRect().width : 0;
        const groupableArea = this.headerGroupContainer?.nativeElement?.getBoundingClientRect ? this.headerGroupContainer.nativeElement.getBoundingClientRect().width : 0;
        const expanderWidth = expander?.nativeElement?.getBoundingClientRect ? expander.nativeElement.getBoundingClientRect().width : 0;
        this._headerFeaturesWidth = rowSelectArea + rowDragArea + groupableArea + expanderWidth;
      }
      return this._headerFeaturesWidth;
    }
    /**
     * @hidden @internal
     */
    get summariesMargin() {
      return this.featureColumnsWidth();
    }
    /**
     * Gets an array of `IgxColumnComponent`s.
     *
     * @example
     * ```typescript
     * const colums = this.grid.columns.
     * ```
     */
    get columns() {
      return this._columns || [];
    }
    /**
     * Gets an array of the pinned `IgxColumnComponent`s.
     *
     * @example
     * ```typescript
     * const pinnedColumns = this.grid.pinnedColumns.
     * ```
     */
    get pinnedColumns() {
      if (this._pinnedVisible.length) {
        return this._pinnedVisible;
      }
      this._pinnedVisible = this._pinnedColumns.filter(col => !col.hidden);
      return this._pinnedVisible;
    }
    /* csSuppress */
    /**
     * Gets an array of the pinned `IgxRowComponent`s.
     *
     * @example
     * ```typescript
     * const pinnedRow = this.grid.pinnedRows;
     * ```
     */
    get pinnedRows() {
      return this._pinnedRowList.toArray().sort((a, b) => a.index - b.index);
    }
    /**
     * Gets an array of unpinned `IgxColumnComponent`s.
     *
     * @example
     * ```typescript
     * const unpinnedColumns = this.grid.unpinnedColumns.
     * ```
     */
    get unpinnedColumns() {
      if (this._unpinnedVisible.length) {
        return this._unpinnedVisible;
      }
      this._unpinnedVisible = this._unpinnedColumns.filter(col => !col.hidden);
      return this._unpinnedVisible;
    }
    /**
     * Gets the `width` to be set on `IgxGridHeaderGroupComponent`.
     */
    getHeaderGroupWidth(column) {
      return this.hasColumnLayouts ? '' : `${Math.max(parseFloat(column.calcWidth), this.defaultHeaderGroupMinWidth)}px`;
    }
    /**
     * Returns the `IgxColumnComponent` by field name.
     *
     * @example
     * ```typescript
     * const myCol = this.grid1.getColumnByName("ID");
     * ```
     * @param name
     */
    getColumnByName(name) {
      return this._columns.find(col => col.field === name);
    }
    getColumnByVisibleIndex(index) {
      return this.visibleColumns.find(col => !col.columnGroup && !col.columnLayout && col.visibleIndex === index);
    }
    /**
     * Recalculates all widths of columns that have size set to `auto`.
     *
     * @example
     * ```typescript
     * this.grid1.recalculateAutoSizes();
     * ```
     */
    recalculateAutoSizes() {
      // reset auto-size and calculate it again.
      this._columns.forEach(x => x.autoSize = undefined);
      this.resetCaches();
      this.zone.onStable.pipe(first$2()).subscribe(() => {
        this.cdr.detectChanges();
        this.autoSizeColumnsInView();
      });
    }
    /**
     * Returns an array of visible `IgxColumnComponent`s.
     *
     * @example
     * ```typescript
     * const visibleColumns = this.grid.visibleColumns.
     * ```
     */
    get visibleColumns() {
      if (this._visibleColumns.length) {
        return this._visibleColumns;
      }
      this._visibleColumns = this._columns.filter(c => !c.hidden);
      return this._visibleColumns;
    }
    /**
     * Returns the total number of records.
     *
     * @remarks
     * Only functions when paging is enabled.
     * @example
     * ```typescript
     * const totalRecords = this.grid.totalRecords;
     * ```
     */
    get totalRecords() {
      return this._totalRecords >= 0 ? this._totalRecords : this.pagingState?.metadata.countRecords;
    }
    set totalRecords(total) {
      if (total >= 0) {
        if (this.paginator) {
          this.paginator.totalRecords = total;
        }
        this._totalRecords = total;
        this.pipeTrigger++;
        this.notifyChanges();
      }
    }
    /** @hidden @internal */
    get totalWidth() {
      if (!isNaN(this._totalWidth)) {
        return this._totalWidth;
      }
      // Take only top level columns
      const cols = this.visibleColumns.filter(col => col.level === 0 && !col.pinned);
      let totalWidth = 0;
      let i = 0;
      for (i; i < cols.length; i++) {
        totalWidth += parseFloat(cols[i].calcWidth) || 0;
      }
      this._totalWidth = totalWidth;
      return totalWidth;
    }
    /**
     * @hidden
     * @internal
     */
    get showRowSelectors() {
      return this.isRowSelectable && this.hasVisibleColumns && !this.hideRowSelectors;
    }
    /**
     * @hidden
     * @internal
     */
    get showAddButton() {
      return this.rowEditable && this.dataView.length === 0 && this._columns.length > 0;
    }
    /**
     * @hidden
     * @internal
     */
    get showDragIcons() {
      return this.rowDraggable && this._columns.length > this.hiddenColumnsCount;
    }
    /**
     * @hidden
     * @internal
     */
    _getDataViewIndex(index) {
      let newIndex = index;
      if ((index < 0 || index >= this.dataView.length) && this.pagingMode === 1 && this.page !== 0) {
        newIndex = index - this.perPage * this.page;
      } else if (this.gridAPI.grid.verticalScrollContainer.isRemote) {
        newIndex = index - this.gridAPI.grid.virtualizationState.startIndex;
      }
      return newIndex;
    }
    /**
     * @hidden
     * @internal
     */
    getDataIndex(dataViewIndex) {
      let newIndex = dataViewIndex;
      if (this.gridAPI.grid.verticalScrollContainer.isRemote) {
        newIndex = dataViewIndex + this.gridAPI.grid.virtualizationState.startIndex;
      }
      return newIndex;
    }
    /**
     * Places a column before or after the specified target column.
     *
     * @example
     * ```typescript
     * grid.moveColumn(column, target);
     * ```
     */
    moveColumn(column, target, pos = DropPosition.AfterDropTarget) {
      // M.A. May 11th, 2021 #9508 Make the event cancelable
      const eventArgs = {
        source: column,
        target,
        cancel: false
      };
      this.columnMovingEnd.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      if (column === target || column.level !== target.level || column.topLevelParent !== target.topLevelParent) {
        return;
      }
      if (column.level) {
        this._moveChildColumns(column.parent, column, target, pos);
      }
      // let columnPinStateChanged;
      // pinning and unpinning will work correctly even without passing index
      // but is easier to calclulate the index here, and later use it in the pinning event args
      if (target.pinned && !column.pinned) {
        const pinnedIndex = this._pinnedColumns.indexOf(target);
        const index = pos === DropPosition.AfterDropTarget ? pinnedIndex + 1 : pinnedIndex;
        column.pin(index);
      }
      if (!target.pinned && column.pinned) {
        const unpinnedIndex = this._unpinnedColumns.indexOf(target);
        const index = pos === DropPosition.AfterDropTarget ? unpinnedIndex + 1 : unpinnedIndex;
        column.unpin(index);
      }
      // if (target.pinned && column.pinned && !columnPinStateChanged) {
      //     this._reorderColumns(column, target, pos, this._pinnedColumns);
      // }
      // if (!target.pinned && !column.pinned && !columnPinStateChanged) {
      //     this._reorderColumns(column, target, pos, this._unpinnedColumns);
      // }
      this._moveColumns(column, target, pos);
      this._columnsReordered(column);
    }
    /**
     * Triggers change detection for the `IgxGridComponent`.
     * Calling markForCheck also triggers the grid pipes explicitly, resulting in all updates being processed.
     * May degrade performance if used when not needed, or if misused:
     * ```typescript
     * // DON'Ts:
     * // don't call markForCheck from inside a loop
     * // don't call markForCheck when a primitive has changed
     * grid.data.forEach(rec => {
     *  rec = newValue;
     *  grid.markForCheck();
     * });
     *
     * // DOs
     * // call markForCheck after updating a nested property
     * grid.data.forEach(rec => {
     *  rec.nestedProp1.nestedProp2 = newValue;
     * });
     * grid.markForCheck();
     * ```
     *
     * @example
     * ```typescript
     * grid.markForCheck();
     * ```
     */
    markForCheck() {
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    /* csSuppress */
    /**
     * Creates a new `IgxGridRowComponent` and adds the data record to the end of the data source.
     *
     * @example
     * ```typescript
     * this.grid1.addRow(record);
     * ```
     * @param data
     */
    addRow(data) {
      // commit pending states prior to adding a row
      this.crudService.endEdit(true);
      this.gridAPI.addRowToData(data);
      this.pipeTrigger++;
      this.rowAddedNotifier.next({
        data: data,
        rowData: data,
        owner: this,
        primaryKey: data[this.primaryKey],
        rowKey: data[this.primaryKey]
      });
      this.notifyChanges();
    }
    /* blazorCSSuppress */
    /**
     * Removes the `IgxGridRowComponent` and the corresponding data record by primary key.
     *
     * @remarks
     * Requires that the `primaryKey` property is set.
     * The method accept rowSelector as a parameter, which is the rowID.
     * @example
     * ```typescript
     * this.grid1.deleteRow(0);
     * ```
     * @param rowSelector
     */
    deleteRow(rowSelector) {
      if (this.primaryKey !== undefined && this.primaryKey !== null) {
        return this.deleteRowById(rowSelector);
      }
    }
    /** @hidden */
    deleteRowById(rowId) {
      const args = {
        rowID: rowId,
        primaryKey: rowId,
        rowKey: rowId,
        rowData: this.getRowData(rowId),
        data: this.getRowData(rowId),
        oldValue: this.getRowData(rowId),
        owner: this,
        isAddRow: false,
        cancel: false
      };
      this.rowDelete.emit(args);
      if (args.cancel) {
        return;
      }
      const record = this.gridAPI.deleteRowById(rowId);
      if (record !== null && record !== undefined) {
        const rowDeletedEventArgs = {
          data: record,
          rowData: record,
          owner: this,
          primaryKey: record[this.primaryKey],
          rowKey: record[this.primaryKey]
        };
        this.rowDeleted.emit(rowDeletedEventArgs);
      }
      return record;
    }
    /* blazorCSSuppress */
    /**
     * Updates the `IgxGridRowComponent` and the corresponding data record by primary key.
     *
     * @remarks
     * Requires that the `primaryKey` property is set.
     * @example
     * ```typescript
     * this.gridWithPK.updateCell('Updated', 1, 'ProductName');
     * ```
     * @param value the new value which is to be set.
     * @param rowSelector corresponds to rowID.
     * @param column corresponds to column field.
     */
    updateCell(value, rowSelector, column) {
      if (this.isDefined(this.primaryKey)) {
        const col = this._columns.find(c => c.field === column);
        if (col) {
          // Simplify
          const rowData = this.gridAPI.getRowData(rowSelector);
          const index = this.gridAPI.get_row_index_in_data(rowSelector);
          // If row passed is invalid
          if (index < 0) {
            return;
          }
          const id = {
            rowID: rowSelector,
            columnID: col.index,
            rowIndex: index
          };
          const cell = new IgxCell(id, index, col, rowData[col.field], value, rowData, this);
          const formControl = this.validation.getFormControl(cell.id.rowID, cell.column.field);
          formControl.setValue(value);
          this.gridAPI.update_cell(cell);
          this.cdr.detectChanges();
        }
      }
    }
    /* blazorCSSuppress */
    /**
     * Updates the `IgxGridRowComponent`
     *
     * @remarks
     * The row is specified by
     * rowSelector parameter and the data source record with the passed value.
     * This method will apply requested update only if primary key is specified in the grid.
     * @example
     * ```typescript
     * grid.updateRow({
     *       ProductID: 1, ProductName: 'Spearmint', InStock: true, UnitsInStock: 1, OrderDate: new Date('2005-03-21')
     *   }, 1);
     * ```
     * @param value–
     * @param rowSelector correspond to rowID
     */
    // TODO: prevent event invocation
    updateRow(value, rowSelector) {
      if (this.isDefined(this.primaryKey)) {
        const editableCell = this.crudService.cell;
        if (editableCell && editableCell.id.rowID === rowSelector) {
          this.crudService.endCellEdit();
        }
        const row = new IgxEditRow(rowSelector, -1, this.gridAPI.getRowData(rowSelector), this);
        this.gridAPI.update_row(row, value);
        // TODO: fix for #5934 and probably break for #5763
        // consider adding of third optional boolean parameter in updateRow.
        // If developer set this parameter to true we should call notifyChanges(true), and
        // vise-versa if developer set it to false we should call notifyChanges(false).
        // The parameter should default to false
        this.notifyChanges();
      }
    }
    /**
     * Returns the data that is contained in the row component.
     *
     * @remarks
     * If the primary key is not specified the row selector match the row data.
     * @example
     * ```typescript
     * const data = grid.getRowData(94741);
     * ```
     * @param rowSelector correspond to rowID
     */
    getRowData(rowSelector) {
      if (!this.primaryKey) {
        return rowSelector;
      }
      const data = this.gridAPI.get_all_data(this.transactions.enabled);
      const index = this.gridAPI.get_row_index_in_data(rowSelector);
      return index < 0 ? {} : data[index];
    }
    /**
     * Sort a single `IgxColumnComponent`.
     *
     * @remarks
     * Sort the `IgxGridComponent`'s `IgxColumnComponent` based on the provided array of sorting expressions.
     * @example
     * ```typescript
     * this.grid.sort({ fieldName: name, dir: SortingDirection.Asc, ignoreCase: false });
     * ```
     */
    sort(expression) {
      const sortingState = cloneArray(this.sortingExpressions);
      if (expression instanceof Array) {
        for (const each of expression) {
          this.gridAPI.prepare_sorting_expression([sortingState], each);
        }
      } else {
        if (this._sortingOptions.mode === 'single') {
          this._columns.forEach(col => {
            if (!(col.field === expression.fieldName)) {
              this.clearSort(col.field);
            }
          });
        }
        this.gridAPI.prepare_sorting_expression([sortingState], expression);
      }
      const eventArgs = {
        owner: this,
        sortingExpressions: sortingState,
        cancel: false
      };
      this.sorting.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.crudService.endEdit(false);
      if (expression instanceof Array) {
        this.gridAPI.sort_multiple(expression);
      } else {
        this.gridAPI.sort(expression);
      }
      requestAnimationFrame(() => this.sortingDone.emit(expression));
    }
    /**
     * Filters a single `IgxColumnComponent`.
     *
     * @example
     * ```typescript
     * public filter(term) {
     *      this.grid.filter("ProductName", term, IgxStringFilteringOperand.instance().condition("contains"));
     * }
     * ```
     * @param name
     * @param value
     * @param conditionOrExpressionTree
     * @param ignoreCase
     */
    filter(name, value, conditionOrExpressionTree, ignoreCase) {
      this.filteringService.filter(name, value, conditionOrExpressionTree, ignoreCase);
    }
    /**
     * Filters all the `IgxColumnComponent` in the `IgxGridComponent` with the same condition.
     *
     * @example
     * ```typescript
     * grid.filterGlobal('some', IgxStringFilteringOperand.instance().condition('contains'));
     * ```
     * @param value
     * @param condition
     * @param ignoreCase
     * @deprecated in version 19.0.0.
     */
    filterGlobal(value, condition, ignoreCase) {
      this.filteringService.filterGlobal(value, condition, ignoreCase);
    }
    /**
     * Enables summaries for the specified column and applies your customSummary.
     *
     * @remarks
     * If you do not provide the customSummary, then the default summary for the column data type will be applied.
     * @example
     * ```typescript
     * grid.enableSummaries([{ fieldName: 'ProductName' }, { fieldName: 'ID' }]);
     * ```
     * Enable summaries for the listed columns.
     * @example
     * ```typescript
     * grid.enableSummaries('ProductName');
     * ```
     * @param rest
     */
    enableSummaries(...rest) {
      if (rest.length === 1 && Array.isArray(rest[0])) {
        this._multipleSummaries(rest[0], true);
      } else {
        this._summaries(rest[0], true, rest[1]);
      }
    }
    /**
     * Disable summaries for the specified column.
     *
     * @example
     * ```typescript
     * grid.disableSummaries('ProductName');
     * ```
     * @remarks
     * Disable summaries for the listed columns.
     * @example
     * ```typescript
     * grid.disableSummaries([{ fieldName: 'ProductName' }]);
     * ```
     */
    disableSummaries(...rest) {
      if (rest.length === 1 && Array.isArray(rest[0])) {
        this._disableMultipleSummaries(rest[0]);
      } else {
        this._summaries(rest[0], false);
      }
    }
    /**
     * If name is provided, clears the filtering state of the corresponding `IgxColumnComponent`.
     *
     * @remarks
     * Otherwise clears the filtering state of all `IgxColumnComponent`s.
     * @example
     * ```typescript
     * this.grid.clearFilter();
     * ```
     * @param name
     */
    clearFilter(name) {
      this.filteringService.clearFilter(name);
    }
    /**
     * If name is provided, clears the sorting state of the corresponding `IgxColumnComponent`.
     *
     * @remarks
     * otherwise clears the sorting state of all `IgxColumnComponent`.
     * @example
     * ```typescript
     * this.grid.clearSort();
     * ```
     * @param name
     */
    clearSort(name) {
      if (!name) {
        this.sortingExpressions = [];
        return;
      }
      if (!this.gridAPI.get_column_by_name(name)) {
        return;
      }
      this.gridAPI.clear_sort(name);
    }
    /**
     * @hidden @internal
     */
    refreshGridState(_args) {
      this.crudService.endEdit(true);
      this.selectionService.clearHeaderCBState();
      this.summaryService.clearSummaryCache();
      this.summaryPipeTrigger++;
      this.cdr.detectChanges();
    }
    // TODO: We have return values here. Move them to event args ??
    /**
     * Pins a column by field name.
     *
     * @remarks
     * Returns whether the operation is successful.
     * @example
     * ```typescript
     * this.grid.pinColumn("ID");
     * ```
     * @param columnName
     * @param index
     */
    pinColumn(columnName, index) {
      const col = columnName instanceof IgxColumnComponent ? columnName : this.getColumnByName(columnName);
      return col.pin(index);
    }
    /**
     * Unpins a column by field name. Returns whether the operation is successful.
     *
     * @example
     * ```typescript
     * this.grid.pinColumn("ID");
     * ```
     * @param columnName
     * @param index
     */
    unpinColumn(columnName, index) {
      const col = columnName instanceof IgxColumnComponent ? columnName : this.getColumnByName(columnName);
      return col.unpin(index);
    }
    /* csSuppress */
    /**
     * Pin the row by its id.
     *
     * @remarks
     * ID is either the primaryKey value or the data record instance.
     * @example
     * ```typescript
     * this.grid.pinRow(rowID);
     * ```
     * @param rowID The row id - primaryKey value or the data record instance.
     * @param index The index at which to insert the row in the pinned collection.
     */
    pinRow(rowID, index, row) {
      if (this._pinnedRecordIDs.indexOf(rowID) !== -1) {
        return false;
      }
      const eventArgs = this.gridAPI.get_pin_row_event_args(rowID, index, row, true);
      this.rowPinning.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.crudService.endEdit(false);
      const insertIndex = typeof eventArgs.insertAtIndex === 'number' ? eventArgs.insertAtIndex : this._pinnedRecordIDs.length;
      this._pinnedRecordIDs.splice(insertIndex, 0, rowID);
      this.pipeTrigger++;
      if (this.gridAPI.grid) {
        this.cdr.detectChanges();
        this.rowPinned.emit(eventArgs);
      }
      return true;
    }
    /* csSuppress */
    /**
     * Unpin the row by its id.
     *
     * @remarks
     * ID is either the primaryKey value or the data record instance.
     * @example
     * ```typescript
     * this.grid.unpinRow(rowID);
     * ```
     * @param rowID The row id - primaryKey value or the data record instance.
     */
    unpinRow(rowID, row) {
      const index = this._pinnedRecordIDs.indexOf(rowID);
      if (index === -1) {
        return false;
      }
      const eventArgs = this.gridAPI.get_pin_row_event_args(rowID, null, row, false);
      this.rowPinning.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      this.crudService.endEdit(false);
      this._pinnedRecordIDs.splice(index, 1);
      this.pipeTrigger++;
      if (this.gridAPI.grid) {
        this.cdr.detectChanges();
        this.rowPinned.emit(eventArgs);
      }
      return true;
    }
    /** @hidden @internal */
    get pinnedRowHeight() {
      const containerHeight = this.pinContainer ? this.pinContainer.nativeElement.offsetHeight : 0;
      return this.hasPinnedRecords ? containerHeight : 0;
    }
    /** @hidden @internal */
    get totalHeight() {
      return this.calcHeight ? this.calcHeight + this.pinnedRowHeight : this.calcHeight;
    }
    /**
     * Recalculates grid width/height dimensions.
     *
     * @remarks
     * Should be run when changing DOM elements dimentions manually that affect the grid's size.
     * @example
     * ```typescript
     * this.grid.reflow();
     * ```
     */
    reflow() {
      this.calculateGridSizes();
    }
    /**
     * Finds the next occurrence of a given string in the grid and scrolls to the cell if it isn't visible.
     *
     * @remarks
     * Returns how many times the grid contains the string.
     * @example
     * ```typescript
     * this.grid.findNext("financial");
     * ```
     * @param text the string to search.
     * @param caseSensitive optionally, if the search should be case sensitive (defaults to false).
     * @param exactMatch optionally, if the text should match the entire value  (defaults to false).
     */
    findNext(text, caseSensitive, exactMatch) {
      return this.find(text, 1, caseSensitive, exactMatch);
    }
    /**
     * Finds the previous occurrence of a given string in the grid and scrolls to the cell if it isn't visible.
     *
     * @remarks
     * Returns how many times the grid contains the string.
     * @example
     * ```typescript
     * this.grid.findPrev("financial");
     * ```
     * @param text the string to search.
     * @param caseSensitive optionally, if the search should be case sensitive (defaults to false).
     * @param exactMatch optionally, if the text should match the entire value (defaults to false).
     */
    findPrev(text, caseSensitive, exactMatch) {
      return this.find(text, -1, caseSensitive, exactMatch);
    }
    /**
     * Reapplies the existing search.
     *
     * @remarks
     * Returns how many times the grid contains the last search.
     * @example
     * ```typescript
     * this.grid.refreshSearch();
     * ```
     * @param updateActiveInfo
     */
    refreshSearch(updateActiveInfo, endEdit = true) {
      if (this._lastSearchInfo.searchText) {
        this.rebuildMatchCache();
        if (updateActiveInfo) {
          const activeInfo = this.textHighlightService.highlightGroupsMap.get(this.id);
          this._lastSearchInfo.matchInfoCache.forEach((match, i) => {
            if (match.column === activeInfo.column && match.row === activeInfo.row && match.index === activeInfo.index && compareMaps(match.metadata, activeInfo.metadata)) {
              this._lastSearchInfo.activeMatchIndex = i;
            }
          });
        }
        return this.find(this._lastSearchInfo.searchText, 0, this._lastSearchInfo.caseSensitive, this._lastSearchInfo.exactMatch, false, endEdit);
      } else {
        return 0;
      }
    }
    /**
     * Removes all the highlights in the cell.
     *
     * @example
     * ```typescript
     * this.grid.clearSearch();
     * ```
     */
    clearSearch() {
      this._lastSearchInfo = {
        searchText: '',
        caseSensitive: false,
        exactMatch: false,
        activeMatchIndex: 0,
        matchInfoCache: [],
        matchCount: 0,
        content: ''
      };
      this.rowList.forEach(row => {
        if (row.cells) {
          row.cells.forEach(c => {
            c.clearHighlight();
          });
        }
      });
    }
    /** @hidden @internal */
    get hasEditableColumns() {
      return this._columns.some(col => col.editable);
    }
    /** @hidden @internal */
    get hasSummarizedColumns() {
      const summarizedColumns = this._columns.filter(col => col.hasSummary && !col.hidden);
      return summarizedColumns.length > 0;
    }
    /**
     * @hidden @internal
     */
    get rootSummariesEnabled() {
      return this.summaryCalculationMode !== GridSummaryCalculationMode.childLevelsOnly;
    }
    /**
     * @hidden @internal
     */
    get hasVisibleColumns() {
      if (this._hasVisibleColumns === undefined) {
        return this._columns ? this._columns.some(c => !c.hidden) : false;
      }
      return this._hasVisibleColumns;
    }
    set hasVisibleColumns(value) {
      this._hasVisibleColumns = value;
    }
    /** @hidden @internal */
    get hasMovableColumns() {
      return this.moving;
    }
    /** @hidden @internal */
    get hasColumnGroups() {
      return this._columnGroups;
    }
    /** @hidden @internal */
    get hasColumnLayouts() {
      return !!this._columns.some(col => col.columnLayout);
    }
    /**
     * @hidden @internal
     */
    get multiRowLayoutRowSize() {
      return this._multiRowLayoutRowSize;
    }
    /**
     * @hidden
     */
    get rowBasedHeight() {
      return this.dataLength * this.rowHeight;
    }
    /**
     * @hidden
     */
    get isPercentWidth() {
      return this.width && this.width.indexOf('%') !== -1;
    }
    get shouldResize() {
      return this._gridSize !== this.gridSize;
    }
    /**
     * @hidden @internal
     */
    get isPercentHeight() {
      return this._height && this._height.indexOf('%') !== -1;
    }
    /**
     * @hidden
     */
    get defaultTargetBodyHeight() {
      const allItems = this.dataLength;
      return this.renderedActualRowHeight * Math.min(this._defaultTargetRecordNumber, this.paginator ? Math.min(allItems, this.paginator.perPage) : allItems);
    }
    /**
     * @hidden @internal
     * The rowHeight input is bound to min-height css prop of rows that adds a 1px border in all cases
     */
    get renderedRowHeight() {
      return this.rowHeight + 1;
    }
    /**
     * @hidden @internal
     */
    get outerWidth() {
      return this.hasVerticalScroll() ? this.calcWidth + this.scrollSize : this.calcWidth;
    }
    /**
     * @hidden @internal
     * Gets the size of the grid
     */
    get gridSize() {
      return this.gridComputedStyles?.getPropertyValue('--component-size') || Size.Large;
    }
    /**
     * @hidden @internal
     * Gets the visible content height that includes header + tbody + footer.
     */
    getVisibleContentHeight() {
      let height = this.theadRow.nativeElement.clientHeight + this.tbody.nativeElement.clientHeight;
      if (this.hasSummarizedColumns) {
        height += this.tfoot.nativeElement.clientHeight;
      }
      return height;
    }
    /**
     * @hidden @internal
     */
    getPossibleColumnWidth(baseWidth = null) {
      let computedWidth;
      if (baseWidth !== null) {
        computedWidth = baseWidth;
      } else {
        computedWidth = this.calcWidth || parseFloat(this.document.defaultView.getComputedStyle(this.nativeElement).getPropertyValue('width'));
      }
      const visibleChildColumns = this.visibleColumns.filter(c => !c.columnGroup);
      // Column layouts related
      let visibleCols = [];
      const columnBlocks = this.visibleColumns.filter(c => c.columnGroup);
      const colsPerBlock = columnBlocks.map(block => block.getInitialChildColumnSizes(block.children));
      const combinedBlocksSize = colsPerBlock.reduce((acc, item) => acc + item.length, 0);
      colsPerBlock.forEach(blockCols => visibleCols = visibleCols.concat(blockCols));
      //
      const columnsWithSetWidths = this.hasColumnLayouts ? visibleCols.filter(c => c.widthSetByUser) : visibleChildColumns.filter(c => c.widthSetByUser && c.width !== 'fit-content');
      const columnsToSize = this.hasColumnLayouts ? combinedBlocksSize - columnsWithSetWidths.length : visibleChildColumns.length - columnsWithSetWidths.length;
      const sumExistingWidths = columnsWithSetWidths.reduce((prev, curr) => {
        const colWidth = curr.width;
        let widthValue = parseFloat(colWidth);
        if (isNaN(widthValue)) {
          widthValue = MINIMUM_COLUMN_WIDTH$1;
        }
        const currWidth = colWidth && typeof colWidth === 'string' && colWidth.indexOf('%') !== -1 ? widthValue / 100 * computedWidth : widthValue;
        return prev + currWidth;
      }, 0);
      // When all columns are hidden, return 0px width
      if (!sumExistingWidths && !columnsToSize) {
        return '0px';
      }
      computedWidth -= this.featureColumnsWidth();
      const columnWidth = !Number.isFinite(sumExistingWidths) ? Math.max(computedWidth / columnsToSize, this.minColumnWidth) : Math.max((computedWidth - sumExistingWidths) / columnsToSize, this.minColumnWidth);
      return columnWidth + 'px';
    }
    /**
     * @hidden @internal
     */
    hasVerticalScroll() {
      if (this._init) {
        return false;
      }
      const isScrollable = this.verticalScrollContainer ? this.verticalScrollContainer.isScrollable() : false;
      return !!(this.calcWidth && this.dataView && this.dataView.length > 0 && isScrollable);
    }
    /**
     * Gets calculated width of the pinned area.
     *
     * @example
     * ```typescript
     * const pinnedWidth = this.grid.getPinnedWidth();
     * ```
     * @param takeHidden If we should take into account the hidden columns in the pinned area.
     */
    getPinnedWidth(takeHidden = false) {
      const fc = takeHidden ? this._pinnedColumns : this.pinnedColumns;
      let sum = 0;
      for (const col of fc) {
        if (col.level === 0) {
          sum += parseInt(col.calcWidth, 10);
        }
      }
      if (this.isPinningToStart) {
        sum += this.featureColumnsWidth();
      }
      return sum;
    }
    /**
     * @hidden @internal
     */
    isColumnGrouped(_fieldName) {
      return false;
    }
    /**
     * @hidden @internal
     * TODO: REMOVE
     */
    onHeaderSelectorClick(event) {
      if (!this.isMultiRowSelectionEnabled) {
        return;
      }
      if (this.selectionService.areAllRowSelected()) {
        this.selectionService.clearRowSelection(event);
      } else {
        this.selectionService.selectAllRows(event);
      }
    }
    /**
     * @hidden @internal
     */
    get headSelectorBaseAriaLabel() {
      if (this._filteringExpressionsTree.filteringOperands.length > 0) {
        return this.selectionService.areAllRowSelected() ? 'Deselect all filtered' : 'Select all filtered';
      }
      return this.selectionService.areAllRowSelected() ? 'Deselect all' : 'Select all';
    }
    /**
     * @hidden
     * @internal
     */
    get totalRowsCountAfterFilter() {
      if (this.data) {
        return this.selectionService.allData.length;
      }
      return 0;
    }
    /** @hidden @internal */
    get pinnedDataView() {
      return this.pinnedRecords ? this.pinnedRecords : [];
    }
    /** @hidden @internal */
    get unpinnedDataView() {
      return this.unpinnedRecords ? this.unpinnedRecords : this.verticalScrollContainer?.igxForOf || [];
    }
    /**
     * Returns the currently transformed paged/filtered/sorted/grouped/pinned/unpinned row data, displayed in the grid.
     *
     * @example
     * ```typescript
     *      const dataView = this.grid.dataView;
     * ```
     */
    get dataView() {
      return this._dataView;
    }
    /**
     * Gets/Sets whether clicking over a row should select/deselect it
     *
     * @remarks
     * By default it is set to true
     * @param enabled: boolean
     */
    get selectRowOnClick() {
      return this._selectRowOnClick;
    }
    set selectRowOnClick(enabled) {
      this._selectRowOnClick = enabled;
    }
    /**
     * Select specified rows by ID.
     *
     * @example
     * ```typescript
     * this.grid.selectRows([1,2,5], true);
     * ```
     * @param rowIDs
     * @param clearCurrentSelection if true clears the current selection
     */
    selectRows(rowIDs, clearCurrentSelection) {
      this.selectionService.selectRowsWithNoEvent(rowIDs, clearCurrentSelection);
      this.notifyChanges();
    }
    /**
     * Deselect specified rows by ID.
     *
     * @example
     * ```typescript
     * this.grid.deselectRows([1,2,5]);
     * ```
     * @param rowIDs
     */
    deselectRows(rowIDs) {
      this.selectionService.deselectRowsWithNoEvent(rowIDs);
      this.notifyChanges();
    }
    /**
     * Selects all rows
     *
     * @remarks
     * By default if filtering is in place, selectAllRows() and deselectAllRows() select/deselect all filtered rows.
     * If you set the parameter onlyFilterData to false that will select all rows in the grid exept deleted rows.
     * @example
     * ```typescript
     * this.grid.selectAllRows();
     * this.grid.selectAllRows(false);
     * ```
     * @param onlyFilterData
     */
    selectAllRows(onlyFilterData = true) {
      const data = onlyFilterData && this.filteredData ? this.filteredData : this.gridAPI.get_all_data(true);
      const rowIDs = this.selectionService.getRowIDs(data).filter(rID => !this.gridAPI.row_deleted_transaction(rID));
      this.selectRows(rowIDs);
    }
    /**
     * Deselects all rows
     *
     * @remarks
     * By default if filtering is in place, selectAllRows() and deselectAllRows() select/deselect all filtered rows.
     * If you set the parameter onlyFilterData to false that will deselect all rows in the grid exept deleted rows.
     * @example
     * ```typescript
     * this.grid.deselectAllRows();
     * ```
     * @param onlyFilterData
     */
    deselectAllRows(onlyFilterData = true) {
      if (onlyFilterData && this.filteredData && this.filteredData.length > 0) {
        this.deselectRows(this.selectionService.getRowIDs(this.filteredData));
      } else {
        this.selectionService.clearAllSelectedRows();
        this.notifyChanges();
      }
    }
    /**
     * Deselect selected cells.
     * @example
     * ```typescript
     * this.grid.clearCellSelection();
     * ```
     */
    clearCellSelection() {
      this.selectionService.clear(true);
      this.notifyChanges();
    }
    /**
     * @hidden @internal
     */
    dragScroll(delta) {
      const horizontal = this.headerContainer.getScroll();
      const vertical = this.verticalScrollContainer.getScroll();
      const {
        left,
        top
      } = delta;
      horizontal.scrollLeft += left * this.DRAG_SCROLL_DELTA;
      vertical.scrollTop += top * this.DRAG_SCROLL_DELTA;
    }
    /**
     * @hidden @internal
     */
    isDefined(arg) {
      return arg !== undefined && arg !== null;
    }
    /**
     * Select range(s) of cells between certain rows and columns of the grid.
     */
    selectRange(arg) {
      if (!this.isDefined(arg)) {
        this.clearCellSelection();
        return;
      }
      if (arg instanceof Array) {
        arg.forEach(range => this.setSelection(range));
      } else {
        this.setSelection(arg);
      }
      this.notifyChanges();
    }
    /**
     * @hidden @internal
     */
    columnToVisibleIndex(field) {
      const visibleColumns = this.visibleColumns;
      if (typeof field === 'number') {
        return field;
      }
      return visibleColumns.find(column => column.field === field).visibleIndex;
    }
    /**
     * @hidden @internal
     */
    setSelection(range) {
      const startNode = {
        row: range.rowStart,
        column: this.columnToVisibleIndex(range.columnStart)
      };
      const endNode = {
        row: range.rowEnd,
        column: this.columnToVisibleIndex(range.columnEnd)
      };
      this.selectionService.pointerState.node = startNode;
      this.selectionService.selectRange(endNode, this.selectionService.pointerState);
      this.selectionService.addRangeMeta(endNode, this.selectionService.pointerState);
      this.selectionService.initPointerState();
    }
    /**
     * Get the currently selected ranges in the grid.
     */
    getSelectedRanges() {
      return this.selectionService.ranges;
    }
    /**
     *
     * Returns an array of the current cell selection in the form of `[{ column.field: cell.value }, ...]`.
     *
     * @remarks
     * If `formatters` is enabled, the cell value will be formatted by its respective column formatter (if any).
     * If `headers` is enabled, it will use the column header (if any) instead of the column field.
     */
    getSelectedData(formatters = false, headers = false) {
      const source = this.filteredSortedData;
      return this.extractDataFromSelection(source, formatters, headers);
    }
    /**
     * Get current selected columns.
     *
     * @example
     * Returns an array with selected columns
     * ```typescript
     * const selectedColumns = this.grid.selectedColumns();
     * ```
     */
    selectedColumns() {
      const fields = this.selectionService.getSelectedColumns();
      return fields.map(field => this.getColumnByName(field)).filter(field => field);
    }
    /**
     * Select specified columns.
     *
     * @example
     * ```typescript
     * this.grid.selectColumns(['ID','Name'], true);
     * ```
     * @param columns
     * @param clearCurrentSelection if true clears the current selection
     */
    selectColumns(columns, clearCurrentSelection) {
      let fieldToSelect = [];
      if (columns.length === 0 || typeof columns[0] === 'string') {
        fieldToSelect = columns;
      } else {
        columns.forEach(col => {
          if (col.columnGroup) {
            const children = col.allChildren.filter(c => !c.columnGroup).map(c => c.field);
            fieldToSelect = [...fieldToSelect, ...children];
          } else {
            fieldToSelect.push(col.field);
          }
        });
      }
      this.selectionService.selectColumnsWithNoEvent(fieldToSelect, clearCurrentSelection);
      this.notifyChanges();
    }
    /**
     * Deselect specified columns by field.
     *
     * @example
     * ```typescript
     * this.grid.deselectColumns(['ID','Name']);
     * ```
     * @param columns
     */
    deselectColumns(columns) {
      let fieldToDeselect = [];
      if (columns.length === 0 || typeof columns[0] === 'string') {
        fieldToDeselect = columns;
      } else {
        columns.forEach(col => {
          if (col.columnGroup) {
            const children = col.allChildren.filter(c => !c.columnGroup).map(c => c.field);
            fieldToDeselect = [...fieldToDeselect, ...children];
          } else {
            fieldToDeselect.push(col.field);
          }
        });
      }
      this.selectionService.deselectColumnsWithNoEvent(fieldToDeselect);
      this.notifyChanges();
    }
    /**
     * Deselects all columns
     *
     * @example
     * ```typescript
     * this.grid.deselectAllColumns();
     * ```
     */
    deselectAllColumns() {
      this.selectionService.clearAllSelectedColumns();
      this.notifyChanges();
    }
    /**
     * Selects all columns
     *
     * @example
     * ```typescript
     * this.grid.deselectAllColumns();
     * ```
     */
    selectAllColumns() {
      this.selectColumns(this._columns.filter(c => !c.columnGroup));
    }
    /**
     *
     * Returns an array of the current columns selection in the form of `[{ column.field: cell.value }, ...]`.
     *
     * @remarks
     * If `formatters` is enabled, the cell value will be formatted by its respective column formatter (if any).
     * If `headers` is enabled, it will use the column header (if any) instead of the column field.
     */
    getSelectedColumnsData(formatters = false, headers = false) {
      const source = this.filteredSortedData ? this.filteredSortedData : this.data;
      return this.extractDataFromColumnsSelection(source, formatters, headers);
    }
    /** @hidden @internal **/
    combineSelectedCellAndColumnData(columnData, formatters = false, headers = false) {
      const source = this.filteredSortedData;
      return this.extractDataFromSelection(source, formatters, headers, columnData);
    }
    /**
     * @hidden
     * @internal
     */
    copyHandler(event) {
      const eventPathElements = event.composedPath().map(el => el.tagName?.toLowerCase());
      if (eventPathElements.includes('igx-grid-filtering-row') || eventPathElements.includes('igx-grid-filtering-cell')) {
        return;
      }
      const selectedColumns = this.gridAPI.grid.selectedColumns();
      const columnData = this.getSelectedColumnsData(this.clipboardOptions.copyFormatters, this.clipboardOptions.copyHeaders);
      let selectedData;
      if (event.type === 'copy') {
        selectedData = this.getSelectedData(this.clipboardOptions.copyFormatters, this.clipboardOptions.copyHeaders);
      }
      let data = [];
      let result;
      if (event.code === 'KeyC' && (event.ctrlKey || event.metaKey) && event.currentTarget.className === 'igx-grid-thead__wrapper') {
        if (selectedData.length) {
          if (columnData.length === 0) {
            result = this.prepareCopyData(event, selectedData);
          } else {
            data = this.combineSelectedCellAndColumnData(columnData, this.clipboardOptions.copyFormatters, this.clipboardOptions.copyHeaders);
            result = this.prepareCopyData(event, data[0], data[1]);
          }
        } else {
          data = columnData;
          result = this.prepareCopyData(event, data);
        }
        navigator.clipboard.writeText(result).then().catch(e => console.error(e));
      } else if (!this.clipboardOptions.enabled || this.crudService.cellInEditMode || event.type === 'keydown') {
        return;
      } else {
        if (selectedColumns.length) {
          data = this.combineSelectedCellAndColumnData(columnData, this.clipboardOptions.copyFormatters, this.clipboardOptions.copyHeaders);
          result = this.prepareCopyData(event, data[0], data[1]);
        } else {
          data = selectedData;
          result = this.prepareCopyData(event, data);
        }
        event.clipboardData.setData('text/plain', result);
      }
    }
    /**
     * @hidden @internal
     */
    prepareCopyData(event, data, keys) {
      const ev = {
        data,
        cancel: false
      };
      this.gridCopy.emit(ev);
      if (ev.cancel) {
        return;
      }
      const transformer = new CharSeparatedValueData(ev.data, this.clipboardOptions.separator);
      let result = keys ? transformer.prepareData(keys) : transformer.prepareData();
      if (!this.clipboardOptions.copyHeaders) {
        result = result.substring(result.indexOf('\n') + 1);
      }
      if (data && data.length > 0 && Object.values(data[0]).length === 1) {
        result = result.slice(0, -2);
      }
      event.preventDefault();
      /* Necessary for the hiearachical case but will probably have to
         change how getSelectedData is propagated in the hiearachical grid
      */
      event.stopPropagation();
      return result;
    }
    /**
     * @hidden @internal
     */
    showSnackbarFor(index) {
      this.addRowSnackbar.actionText = index === -1 ? '' : this.resourceStrings.igx_grid_snackbar_addrow_actiontext;
      this.lastAddedRowIndex = index;
      this.addRowSnackbar.open();
    }
    /* blazorCsSuppress */
    /**
     * Navigates to a position in the grid based on provided `rowindex` and `visibleColumnIndex`.
     *
     * @remarks
     * Also can execute a custom logic over the target element,
     * through a callback function that accepts { targetType: GridKeydownTargetType, target: Object }
     * @example
     * ```typescript
     *  this.grid.navigateTo(10, 3, (args) => { args.target.nativeElement.focus(); });
     * ```
     */
    navigateTo(rowIndex, visibleColIndex = -1, cb = null) {
      const totalItems = this.totalItemCount ?? this.dataView.length - 1;
      if (rowIndex < 0 || rowIndex > totalItems || visibleColIndex !== -1 && this._columns.map(col => col.visibleIndex).indexOf(visibleColIndex) === -1) {
        return;
      }
      if (this.dataView.slice(rowIndex, rowIndex + 1).find(rec => rec.expression || rec.childGridsData)) {
        visibleColIndex = -1;
      }
      // If the target row is pinned no need to scroll as well.
      const shouldScrollVertically = this.navigation.shouldPerformVerticalScroll(rowIndex, visibleColIndex);
      const shouldScrollHorizontally = this.navigation.shouldPerformHorizontalScroll(visibleColIndex, rowIndex);
      if (shouldScrollVertically) {
        this.navigation.performVerticalScrollToCell(rowIndex, visibleColIndex, () => {
          if (shouldScrollHorizontally) {
            this.navigation.performHorizontalScrollToCell(visibleColIndex, () => this.executeCallback(rowIndex, visibleColIndex, cb));
          } else {
            this.executeCallback(rowIndex, visibleColIndex, cb);
          }
        });
      } else if (shouldScrollHorizontally) {
        this.navigation.performHorizontalScrollToCell(visibleColIndex, () => {
          if (shouldScrollVertically) {
            this.navigation.performVerticalScrollToCell(rowIndex, visibleColIndex, () => this.executeCallback(rowIndex, visibleColIndex, cb));
          } else {
            this.executeCallback(rowIndex, visibleColIndex, cb);
          }
        });
      } else {
        this.executeCallback(rowIndex, visibleColIndex, cb);
      }
    }
    /* blazorCsSuppress */
    /**
     * Returns `ICellPosition` which defines the next cell,
     * according to the current position, that match specific criteria.
     *
     * @remarks
     * You can pass callback function as a third parameter of `getPreviousCell` method.
     * The callback function accepts IgxColumnComponent as a param
     * @example
     * ```typescript
     *  const nextEditableCellPosition = this.grid.getNextCell(0, 3, (column) => column.editable);
     * ```
     */
    getNextCell(currRowIndex, curVisibleColIndex, callback = null) {
      const columns = this._columns.filter(col => !col.columnGroup && col.visibleIndex >= 0);
      const dataViewIndex = this._getDataViewIndex(currRowIndex);
      if (!this.isValidPosition(dataViewIndex, curVisibleColIndex)) {
        return {
          rowIndex: currRowIndex,
          visibleColumnIndex: curVisibleColIndex
        };
      }
      const colIndexes = callback ? columns.filter(col => callback(col)).map(editCol => editCol.visibleIndex).sort((a, b) => a - b) : columns.map(editCol => editCol.visibleIndex).sort((a, b) => a - b);
      const nextCellIndex = colIndexes.find(index => index > curVisibleColIndex);
      if (this.dataView.slice(dataViewIndex, dataViewIndex + 1).find(rec => !rec.expression && !rec.summaries && !rec.childGridsData && !rec.detailsData) && nextCellIndex !== undefined) {
        return {
          rowIndex: currRowIndex,
          visibleColumnIndex: nextCellIndex
        };
      } else {
        const nextIndex = this.getNextDataRowIndex(currRowIndex);
        if (colIndexes.length === 0 || nextIndex === currRowIndex) {
          return {
            rowIndex: currRowIndex,
            visibleColumnIndex: curVisibleColIndex
          };
        } else {
          return {
            rowIndex: nextIndex,
            visibleColumnIndex: colIndexes[0]
          };
        }
      }
    }
    /* blazorCsSuppress */
    /**
     * Returns `ICellPosition` which defines the previous cell,
     * according to the current position, that match specific criteria.
     *
     * @remarks
     * You can pass callback function as a third parameter of `getPreviousCell` method.
     * The callback function accepts IgxColumnComponent as a param
     * @example
     * ```typescript
     *  const previousEditableCellPosition = this.grid.getPreviousCell(0, 3, (column) => column.editable);
     * ```
     */
    getPreviousCell(currRowIndex, curVisibleColIndex, callback = null) {
      const columns = this._columns.filter(col => !col.columnGroup && col.visibleIndex >= 0);
      const dataViewIndex = this._getDataViewIndex(currRowIndex);
      if (!this.isValidPosition(dataViewIndex, curVisibleColIndex)) {
        return {
          rowIndex: currRowIndex,
          visibleColumnIndex: curVisibleColIndex
        };
      }
      const colIndexes = callback ? columns.filter(col => callback(col)).map(editCol => editCol.visibleIndex).sort((a, b) => b - a) : columns.map(editCol => editCol.visibleIndex).sort((a, b) => b - a);
      const prevCellIndex = colIndexes.find(index => index < curVisibleColIndex);
      if (this.dataView.slice(dataViewIndex, dataViewIndex + 1).find(rec => !rec.expression && !rec.summaries && !rec.childGridsData && !rec.detailsData) && prevCellIndex !== undefined) {
        return {
          rowIndex: currRowIndex,
          visibleColumnIndex: prevCellIndex
        };
      } else {
        const prevIndex = this.getNextDataRowIndex(currRowIndex, true);
        if (colIndexes.length === 0 || prevIndex === currRowIndex) {
          return {
            rowIndex: currRowIndex,
            visibleColumnIndex: curVisibleColIndex
          };
        } else {
          return {
            rowIndex: prevIndex,
            visibleColumnIndex: colIndexes[0]
          };
        }
      }
    }
    /**
     * @hidden
     * @internal
     */
    endRowEditTabStop(commit = true, event) {
      const canceled = this.crudService.endEdit(commit, event);
      if (canceled) {
        return true;
      }
      this.navigation.restoreActiveNodeFocus();
    }
    /**
     * @hidden @internal
     */
    trackColumnChanges(index, col) {
      return col.field + col._calcWidth;
    }
    /**
     * @hidden
     */
    isExpandedGroup(_group) {
      return undefined;
    }
    /**
     * @hidden @internal
     * TODO: MOVE to CRUD
     */
    openRowOverlay(id) {
      this.configureRowEditingOverlay(id, this.rowList.length <= MIN_ROW_EDITING_COUNT_THRESHOLD);
      this.rowEditingOverlay.open(this.rowEditSettings);
      this.rowEditingOverlay.element.addEventListener('wheel', this.rowEditingWheelHandler.bind(this));
    }
    /**
     * @hidden @internal
     */
    closeRowEditingOverlay() {
      this.rowEditingOverlay.element.removeEventListener('wheel', this.rowEditingWheelHandler);
      this.rowEditPositioningStrategy.isTopInitialPosition = null;
      this.rowEditingOverlay.close();
      this.rowEditingOverlay.element.parentElement.style.display = '';
    }
    /**
     * @hidden @internal
     */
    toggleRowEditingOverlay(show) {
      const rowStyle = this.rowEditingOverlay.element.style;
      if (show) {
        rowStyle.display = 'block';
      } else {
        rowStyle.display = 'none';
      }
    }
    /**
     * @hidden @internal
     */
    repositionRowEditingOverlay(row) {
      if (row && !this.rowEditingOverlay.collapsed) {
        const rowStyle = this.rowEditingOverlay.element.parentElement.style;
        if (row) {
          rowStyle.display = '';
          this.configureRowEditingOverlay(row.key);
          this.rowEditingOverlay.reposition();
        } else {
          rowStyle.display = 'none';
        }
      }
    }
    /**
     * @hidden @internal
     */
    cachedViewLoaded(args) {
      if (this.hasHorizontalScroll()) {
        const tmplId = args.context.templateID.type;
        const index = args.context.index;
        args.view.detectChanges();
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          const row = tmplId === 'dataRow' ? this.gridAPI.get_row_by_index(index) : null;
          const summaryRow = tmplId === 'summaryRow' ? this.summariesRowList.find(sr => sr.dataRowIndex === index) : null;
          if (row && row instanceof IgxRowDirective) {
            this._restoreVirtState(row);
          } else if (summaryRow) {
            this._restoreVirtState(summaryRow);
          }
        });
      }
    }
    /**
     * Opens the advanced filtering dialog.
     */
    openAdvancedFilteringDialog(overlaySettings) {
      const settings = overlaySettings ? overlaySettings : this._advancedFilteringOverlaySettings;
      if (!this._advancedFilteringOverlayId) {
        this._advancedFilteringOverlaySettings.target = this.rootGrid ? this.rootGrid.nativeElement : this.nativeElement;
        this._advancedFilteringOverlaySettings.outlet = this.outlet;
        this._advancedFilteringOverlayId = this.overlayService.attach(IgxAdvancedFilteringDialogComponent, this.viewRef, settings);
        this.overlayService.show(this._advancedFilteringOverlayId);
      }
    }
    /**
     * Closes the advanced filtering dialog.
     *
     * @param applyChanges indicates whether the changes should be applied
     */
    closeAdvancedFilteringDialog(applyChanges) {
      if (this._advancedFilteringOverlayId) {
        const advancedFilteringOverlay = this.overlayService.getOverlayById(this._advancedFilteringOverlayId);
        const advancedFilteringDialog = advancedFilteringOverlay.componentRef.instance;
        if (applyChanges) {
          advancedFilteringDialog.applyChanges();
        }
        advancedFilteringDialog.closeDialog();
      }
    }
    /**
     * @hidden @internal
     */
    getEmptyRecordObjectFor(inRow) {
      const row = {
        ...inRow?.data
      };
      Object.keys(row).forEach(key => row[key] = undefined);
      const id = this.generateRowID();
      row[this.primaryKey] = id;
      return {
        rowID: id,
        data: row,
        recordRef: row
      };
    }
    /**
     * @hidden @internal
     */
    hasHorizontalScroll() {
      return this.totalWidth - this.unpinnedWidth > 0 && this.width !== null;
    }
    /**
     * @hidden @internal
     */
    isSummaryRow(rowData) {
      return rowData && rowData.summaries && rowData.summaries instanceof Map;
    }
    /**
     * @hidden @internal
     */
    triggerPipes() {
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    rowEditingWheelHandler(event) {
      if (event.deltaY > 0) {
        this.verticalScrollContainer.scrollNext();
      } else {
        this.verticalScrollContainer.scrollPrev();
      }
    }
    /**
     * @hidden
     */
    getUnpinnedIndexById(id) {
      return this.unpinnedRecords.findIndex(x => x[this.primaryKey] === id);
    }
    /**
     * Finishes the row transactions on the current row and returns whether the grid editing was canceled.
     *
     * @remarks
     * If `commit === true`, passes them from the pending state to the data (or transaction service)
     * @example
     * ```html
     * <button type="button" igxButton (click)="grid.endEdit(true)">Commit Row</button>
     * ```
     * @param commit
     */
    // TODO: Facade for crud service refactoring. To be removed
    // TODO: do not remove this, as it is used in rowEditTemplate, but mark is as internal and hidden
    /* blazorCSSuppress */
    endEdit(commit = true, event) {
      const document = this.nativeElement?.getRootNode();
      const focusWithin = this.nativeElement?.contains(document.activeElement);
      const success = this.crudService.endEdit(commit, event);
      if (focusWithin) {
        // restore focus for navigation
        this.navigation.restoreActiveNodeFocus();
      } else if (this.navigation.activeNode) {
        // grid already lost focus, clear active node
        this.clearActiveNode();
      }
      return success;
    }
    /**
     * Enters add mode by spawning the UI under the specified row by rowID.
     *
     * @remarks
     * If null is passed as rowID, the row adding UI is spawned as the first record in the data view
     * @remarks
     * Spawning the UI to add a child for a record only works if you provide a rowID
     * @example
     * ```typescript
     * this.grid.beginAddRowById('ALFKI');
     * this.grid.beginAddRowById('ALFKI', true);
     * this.grid.beginAddRowById(null);
     * ```
     * @param rowID - The rowID to spawn the add row UI for, or null to spawn it as the first record in the data view
     * @param asChild - Whether the record should be added as a child. Only applicable to igxTreeGrid.
     */
    beginAddRowById(rowID, asChild) {
      let index = rowID;
      if (rowID == null) {
        if (asChild) {
          console.warn('The record cannot be added as a child to an unspecified record.');
          return;
        }
        index = null;
      } else {
        // find the index of the record with that PK
        index = this.gridAPI.get_rec_index_by_id(rowID, this.dataView);
        if (index === -1) {
          console.warn('No row with the specified ID was found.');
          return;
        }
      }
      this._addRowForIndex(index, asChild);
    }
    _addRowForIndex(index, asChild) {
      if (!this.dataView.length) {
        this.beginAddRowForIndex(index, asChild);
        return;
      }
      // check if the index is valid - won't support anything outside the data view
      if (index >= 0 && index < this.dataView.length) {
        // check if the index is in the view port
        if ((index < this.virtualizationState.startIndex || index >= this.virtualizationState.startIndex + this.virtualizationState.chunkSize) && !this.isRecordPinnedByViewIndex(index)) {
          this.verticalScrollContainer.chunkLoad.pipe(first$2(), takeUntil(this.destroy$)).subscribe(() => {
            this.beginAddRowForIndex(index, asChild);
          });
          this.navigateTo(index);
          this.notifyChanges(true);
          return;
        }
        this.beginAddRowForIndex(index, asChild);
      } else {
        console.warn('The row with the specified PK or index is outside of the current data view.');
      }
    }
    /* csSuppress */
    /**
     * Enters add mode by spawning the UI at the specified index.
     *
     * @remarks
     * Accepted values for index are integers from 0 to this.grid.dataView.length
     * @example
     * ```typescript
     * this.grid.beginAddRowByIndex(0);
     * ```
     * @param index - The index to spawn the UI at. Accepts integers from 0 to this.grid.dataView.length
     */
    beginAddRowByIndex(index) {
      if (index === 0) {
        return this.beginAddRowById(null);
      }
      return this._addRowForIndex(index - 1);
    }
    /**
     * @hidden
     */
    preventHeaderScroll(args) {
      if (args.target.scrollLeft !== 0) {
        this.navigation.forOfDir().getScroll().scrollLeft = args.target.scrollLeft;
        args.target.scrollLeft = 0;
      }
    }
    beginAddRowForIndex(index, asChild = false) {
      // TODO is row from rowList suitable for enterAddRowMode
      const row = index == null ? null : this.rowList.find(r => r.index === index);
      if (row !== undefined) {
        this.crudService.enterAddRowMode(row, asChild);
      } else {
        console.warn('No row with the specified PK or index was found.');
      }
    }
    switchTransactionService(val) {
      if (val) {
        this._transactions = this.transactionFactory.create("Base" /* TRANSACTION_TYPE.Base */);
      } else {
        this._transactions = this.transactionFactory.create("None" /* TRANSACTION_TYPE.None */);
      }
      if (this.dataCloneStrategy) {
        this._transactions.cloneStrategy = this.dataCloneStrategy;
      }
    }
    subscribeToTransactions() {
      this.transactionChange$.next();
      this.transactions.onStateUpdate.pipe(takeUntil(merge(this.destroy$, this.transactionChange$))).subscribe(this.transactionStatusUpdate.bind(this));
    }
    transactionStatusUpdate(event) {
      let actions = [];
      if (event.origin === TransactionEventOrigin.REDO) {
        actions = event.actions ? event.actions.filter(x => x.transaction.type === TransactionType.DELETE) : [];
      } else if (event.origin === TransactionEventOrigin.UNDO) {
        actions = event.actions ? event.actions.filter(x => x.transaction.type === TransactionType.ADD) : [];
      }
      if (actions.length > 0) {
        for (const action of actions) {
          if (this.selectionService.isRowSelected(action.transaction.id)) {
            this.selectionService.deselectRow(action.transaction.id);
          }
        }
      }
      if (event.origin === TransactionEventOrigin.REDO || event.origin === TransactionEventOrigin.UNDO) {
        event.actions.forEach(x => {
          if (x.transaction.type === TransactionType.UPDATE) {
            const value = this.transactions.getAggregatedValue(x.transaction.id, true);
            this.validation.update(x.transaction.id, value ?? x.recordRef);
          } else if (x.transaction.type === TransactionType.DELETE || x.transaction.type === TransactionType.ADD) {
            const value = this.transactions.getAggregatedValue(x.transaction.id, true);
            if (value) {
              this.validation.create(x.transaction.id, value ?? x.recordRef);
              this.validation.update(x.transaction.id, value ?? x.recordRef);
              this.validation.markAsTouched(x.transaction.id);
            } else {
              this.validation.clear(x.transaction.id);
            }
          }
        });
      }
      this.selectionService.clearHeaderCBState();
      this.summaryService.clearSummaryCache();
      this.pipeTrigger++;
      this.notifyChanges();
    }
    writeToData(rowIndex, value) {
      mergeObjects(this.gridAPI.get_all_data()[rowIndex], value);
    }
    _restoreVirtState(row) {
      // check virtualization state of data record added from cache
      // in case state is no longer valid - update it.
      const rowForOf = row.virtDirRow;
      const gridScrLeft = rowForOf.getScroll().scrollLeft;
      rowForOf.onHScroll(gridScrLeft);
      rowForOf.cdr.detectChanges();
    }
    changeRowEditingOverlayStateOnScroll(row) {
      if (!this.rowEditable || !this.rowEditingOverlay || this.rowEditingOverlay.collapsed) {
        return;
      }
      if (!row) {
        this.toggleRowEditingOverlay(false);
      } else {
        this.repositionRowEditingOverlay(row);
      }
    }
    /**
     * Should be called when data and/or isLoading input changes so that the overlay can be
     * hidden/shown based on the current value of shouldOverlayLoading
     */
    evaluateLoadingState() {
      if (this.shouldOverlayLoading) {
        // a new overlay should be shown
        const overlaySettings = {
          outlet: this.loadingOutlet,
          closeOnOutsideClick: false,
          positionStrategy: new ContainerPositionStrategy()
        };
        this.loadingOverlay.open(overlaySettings);
      } else {
        this.loadingOverlay.close();
      }
    }
    /**
     * @hidden
     * Sets grid width i.e. this.calcWidth
     */
    calculateGridWidth() {
      let width;
      if (this.isPercentWidth) {
        /* width in %*/
        const computed = this.document.defaultView.getComputedStyle(this.nativeElement).getPropertyValue('width');
        width = computed.indexOf('%') === -1 ? parseFloat(computed) : null;
      } else {
        width = parseInt(this.width, 10);
      }
      if (!width && this.nativeElement) {
        width = this.nativeElement.offsetWidth;
      }
      if (this.width === null || !width) {
        this.isColumnWidthSum = true;
        width = this.getColumnWidthSum();
      } else {
        this.isColumnWidthSum = false;
      }
      if (this.hasVerticalScroll() && this.width !== null) {
        width -= this.scrollSize;
      }
      if ((Number.isFinite(width) || width === null) && width !== this.calcWidth) {
        this.calcWidth = width;
      }
      this._derivePossibleWidth();
    }
    /**
     * @hidden
     * Sets columns defaultWidth property
     */
    _derivePossibleWidth() {
      if (!this.columnWidthSetByUser) {
        this._columnWidth = this.width !== null ? this.getPossibleColumnWidth() : this.minColumnWidth + 'px';
      }
      this._columns.forEach(column => {
        if (this.hasColumnLayouts && parseFloat(this._columnWidth)) {
          const columnWidthCombined = parseFloat(this._columnWidth) * (column.colEnd ? column.colEnd - column.colStart : 1);
          column.defaultWidth = columnWidthCombined + 'px';
        } else {
          // D.K. March 29th, 2021 #9145 Consider min/max width when setting defaultWidth property
          column.defaultWidth = this.getExtremumBasedColWidth(column);
          column.resetCaches();
        }
      });
      this.resetCachedWidths();
    }
    /**
     * @hidden
     * @internal
     */
    getExtremumBasedColWidth(column) {
      let width = this._columnWidth;
      if (width && typeof width !== 'string') {
        width = String(width);
      }
      const minWidth = width.indexOf('%') === -1 ? column.minWidthPx : column.minWidthPercent;
      const maxWidth = width.indexOf('%') === -1 ? column.maxWidthPx : column.maxWidthPercent;
      if (column.hidden) {
        return width;
      }
      if (minWidth > parseFloat(width)) {
        width = String(column.minWidth);
      } else if (maxWidth < parseFloat(width)) {
        width = String(column.maxWidth);
      }
      // if no px or % are defined in maxWidth/minWidth consider it px
      if (width.indexOf('%') === -1 && width.indexOf('px') === -1) {
        width += 'px';
      }
      return width;
    }
    resetNotifyChanges() {
      this._cdrRequestRepaint = false;
      this._cdrRequests = false;
    }
    /** @hidden @internal */
    resolveOutlet() {
      return this._userOutletDirective ? this._userOutletDirective : this._outletDirective;
    }
    /**
     * Reorder columns in the main columnList and _columns collections.
     *
     * @hidden
     */
    _moveColumns(from, to, pos) {
      const orderedList = this._pinnedColumns.concat(this._unpinnedColumns);
      const list = orderedList;
      this._reorderColumns(from, to, pos, list);
      const newList = this._resetColumnList(list);
      this.updateColumns(newList);
    }
    /**
     * Update internal column's collection.
     * @hidden
     */
    updateColumns(newColumns) {
      // update internal collections to retain order.
      this._pinnedColumns = newColumns.filter(c => c.pinned);
      this._unpinnedColumns = newColumns.filter(c => !c.pinned);
      this._columns = newColumns;
      if (this._columns && this._columns.length && this._filteringExpressionsTree) {
        this._filteringExpressionsTree = recreateTreeFromFields(this._filteringExpressionsTree, this.columns);
      }
      if (this._columns && this._columns.length && this._advancedFilteringExpressionsTree) {
        this._advancedFilteringExpressionsTree = recreateTreeFromFields(this._advancedFilteringExpressionsTree, this.columns);
      }
      this.resetCaches();
    }
    /**
     * @hidden
     */
    _resetColumnList(list) {
      if (!list) {
        list = this._columns;
      }
      let newList = [];
      list.filter(c => c.level === 0).forEach(p => {
        newList.push(p);
        if (p.columnGroup) {
          newList = newList.concat(p.allChildren);
        }
      });
      return newList;
    }
    /**
     * Reorders columns inside the passed column collection.
     * When reordering column group collection, the collection is not flattened.
     * In all other cases, the columns collection is flattened, this is why adittional calculations on the dropIndex are done.
     *
     * @hidden
     */
    _reorderColumns(from, to, position, columnCollection, inGroup = false) {
      const fromIndex = columnCollection.indexOf(from);
      const childColumnsCount = inGroup ? 1 : from.allChildren.length + 1;
      columnCollection.splice(fromIndex, childColumnsCount);
      let dropIndex = columnCollection.indexOf(to);
      if (position === DropPosition.AfterDropTarget) {
        dropIndex++;
        if (!inGroup && to.columnGroup) {
          dropIndex += to.allChildren.length;
        }
      }
      columnCollection.splice(dropIndex, 0, from);
    }
    /**
     * Reorder column group collection.
     *
     * @hidden
     */
    _moveChildColumns(parent, from, to, pos) {
      const buffer = parent.children.toArray();
      this._reorderColumns(from, to, pos, buffer, true);
      parent.children.reset(buffer);
    }
    /**
     * @hidden @internal
     */
    setupColumns() {
      if (this.autoGenerate) {
        this.autogenerateColumns();
      } else {
        this._columns = this.getColumnList();
      }
      if (this._columns && this._columns.length && this._filteringExpressionsTree) {
        this._filteringExpressionsTree = recreateTreeFromFields(this._filteringExpressionsTree, this._columns);
      }
      if (this._columns && this._columns.length && this._advancedFilteringExpressionsTree) {
        this._advancedFilteringExpressionsTree = recreateTreeFromFields(this._advancedFilteringExpressionsTree, this._columns);
      }
      this.initColumns(this._columns, col => this.columnInit.emit(col));
      this.columnListDiffer.diff(this.columnList);
      this.columnList.changes.pipe(takeUntil(this.destroy$)).subscribe(change => {
        this.onColumnsChanged(change);
      });
    }
    getColumnList() {
      return this.columnList.toArray();
    }
    /**
     * @hidden
     */
    deleteRowFromData(rowID, index) {
      //  if there is a row (index !== 0) delete it
      //  if there is a row in ADD or UPDATE state change it's state to DELETE
      if (index !== -1) {
        if (this.transactions.enabled) {
          const transaction = {
            id: rowID,
            type: TransactionType.DELETE,
            newValue: null
          };
          this.transactions.add(transaction, this.data[index]);
        } else {
          this.data.splice(index, 1);
        }
      } else {
        const state = this.transactions.getState(rowID);
        this.transactions.add({
          id: rowID,
          type: TransactionType.DELETE,
          newValue: null
        }, state && state.recordRef);
      }
    }
    /**
     * @hidden @internal
     */
    getDataBasedBodyHeight() {
      return !this.data || this.data.length < this._defaultTargetRecordNumber ? 0 : this.defaultTargetBodyHeight;
    }
    /**
     * @hidden @internal
     */
    onPinnedRowsChanged(change) {
      const diff = this.rowListDiffer.diff(change);
      if (diff) {
        this.notifyChanges(true);
      }
    }
    /**
     * @hidden
     */
    onColumnsChanged(change) {
      const diff = this.columnListDiffer.diff(change);
      if (this.autoGenerate && this._columns.length === 0 && this._autoGeneratedCols.length > 0) {
        // In Ivy if there are nested conditional templates the content children are re-evaluated
        // hence autogenerated columns are cleared and need to be reset.
        this.updateColumns(this._autoGeneratedCols);
        return;
      }
      if (diff) {
        let added = false;
        let removed = false;
        let pinning = false;
        diff.forEachAddedItem(record => {
          added = true;
          if (record.item.pinned) {
            this._pinnedColumns.push(record.item);
            pinning = true;
          } else {
            this._unpinnedColumns.push(record.item);
          }
        });
        this.initColumns(this.columnList.toArray(), col => this.columnInit.emit(col));
        if (pinning) {
          this.initPinning();
        }
        diff.forEachRemovedItem(record => {
          const isColumnGroup = record.item instanceof IgxColumnGroupComponent;
          if (!isColumnGroup) {
            // Clear Grouping
            this.gridAPI.clear_groupby(record.item.field);
            // Clear Filtering
            this.filteringService.clear_filter(record.item.field);
            // Close filter row
            if (this.filteringService.isFilterRowVisible && this.filteringService.filteredColumn && this.filteringService.filteredColumn.field === record.item.field) {
              this.filteringRow.close();
            }
            // Clear Sorting
            this.gridAPI.clear_sort(record.item.field);
            // Remove column selection
            this.selectionService.deselectColumnsWithNoEvent([record.item.field]);
          }
          removed = true;
        });
        this.resetCaches();
        if (added || removed) {
          this.onColumnsAddedOrRemoved();
        }
      }
    }
    checkPrimaryKeyField() {
      if (this.primaryKey && this.data?.length && !(this.primaryKey in this.data[0])) {
        console.warn(`Field "${this.primaryKey}" is not defined in the data. Set \`primaryKey\` to a valid field.`);
      }
    }
    /**
     * @hidden @internal
     */
    onColumnsAddedOrRemoved() {
      this.summaryService.clearSummaryCache();
      Promise.resolve().then(() => {
        // `onColumnsChanged` can be executed midway a current detectChange cycle and markForCheck will be ignored then.
        // This ensures that we will wait for the current cycle to end so we can trigger a new one and ngDoCheck to fire.
        this.notifyChanges(true);
      });
    }
    /**
     * @hidden
     */
    calculateGridSizes(recalcFeatureWidth = true) {
      /*
          TODO: (R.K.) This layered lasagne should be refactored
          ASAP. The reason I have to reset the caches so many times is because
          after teach `detectChanges` call they are filled with invalid
          state. Of course all of this happens midway through the grid
          sizing process which of course, uses values from the caches, thus resulting
          in a broken layout.
      */
      this.cdr.detectChanges();
      this.resetCaches(recalcFeatureWidth);
      const hasScroll = this.hasVerticalScroll();
      const hasHScroll = !this.isHorizontalScrollHidden;
      this.calculateGridWidth();
      this.resetCaches(recalcFeatureWidth);
      this.cdr.detectChanges();
      this.calculateGridHeight();
      if (this.rowEditable) {
        this.repositionRowEditingOverlay(this.crudService.rowInEditMode);
      }
      if (this.filteringService.isFilterRowVisible) {
        this.filteringRow.resetChipsArea();
      }
      this.cdr.detectChanges();
      // in case scrollbar has appeared recalc to size correctly.
      if (hasScroll !== this.hasVerticalScroll()) {
        this.calculateGridWidth();
        this.cdr.detectChanges();
      }
      // in case horizontal scrollbar has appeared recalc to size correctly.
      if (hasHScroll !== this.hasHorizontalScroll()) {
        this.isHorizontalScrollHidden = !this.hasHorizontalScroll();
        this.cdr.detectChanges();
        this.calculateGridHeight();
        this.cdr.detectChanges();
      }
      if (this.zone.isStable) {
        this.zone.run(() => {
          this._applyWidthHostBinding();
          this.cdr.detectChanges();
        });
      } else {
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          this.zone.run(() => {
            this._applyWidthHostBinding();
          });
        });
      }
      this.resetCaches(recalcFeatureWidth);
      if (this.hasColumnsToAutosize) {
        this.cdr.detectChanges();
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          this._autoSizeColumnsNotify.next();
        });
      }
    }
    /**
     * @hidden
     * Sets TBODY height i.e. this.calcHeight
     */
    calculateGridHeight() {
      this.calcHeight = this._calculateGridBodyHeight();
      if (this.pinnedRowHeight && this.calcHeight) {
        this.calcHeight -= this.pinnedRowHeight;
      }
    }
    /**
     * @hidden
     */
    getGroupAreaHeight() {
      return 0;
    }
    /**
     * @hidden
     */
    getComputedHeight(elem) {
      return elem.offsetHeight ? parseFloat(this.document.defaultView.getComputedStyle(elem).getPropertyValue('height')) : 0;
    }
    /**
     * @hidden
     */
    getFooterHeight() {
      return this.summaryRowHeight || this.getComputedHeight(this.tfoot.nativeElement);
    }
    /**
     * @hidden
     */
    getTheadRowHeight() {
      // D.P.: Before CSS loads,theadRow computed height will be 'auto'->NaN, so use 0 fallback
      const height = this.getComputedHeight(this.theadRow.nativeElement) || 0;
      return !this.allowFiltering || this.allowFiltering && this.filterMode !== FilterMode.quickFilter ? height - this.getFilterCellHeight() : height;
    }
    /**
     * @hidden
     */
    getToolbarHeight() {
      let toolbarHeight = 0;
      if (this.toolbar.first) {
        toolbarHeight = this.getComputedHeight(this.toolbar.first.nativeElement);
      }
      return toolbarHeight;
    }
    /**
     * @hidden
     */
    getPagingFooterHeight() {
      let pagingHeight = 0;
      if (this.footer) {
        const height = this.getComputedHeight(this.footer.nativeElement);
        pagingHeight = this.footer.nativeElement.firstElementChild ? height : 0;
      }
      return pagingHeight;
    }
    /**
     * @hidden
     */
    getFilterCellHeight() {
      const headerGroupNativeEl = this.headerGroupsList.length !== 0 ? this.headerGroupsList[0].nativeElement : null;
      const filterCellNativeEl = headerGroupNativeEl ? headerGroupNativeEl.querySelector('igx-grid-filtering-cell') : null;
      return filterCellNativeEl ? filterCellNativeEl.offsetHeight : 0;
    }
    /**
     * @hidden
     */
    _calculateGridBodyHeight() {
      if (!this._height) {
        return null;
      }
      const actualTheadRow = this.getTheadRowHeight();
      const footerHeight = this.getFooterHeight();
      const toolbarHeight = this.getToolbarHeight();
      const pagingHeight = this.getPagingFooterHeight();
      const groupAreaHeight = this.getGroupAreaHeight();
      const scrHeight = this.getComputedHeight(this.scr.nativeElement);
      const renderedHeight = toolbarHeight + actualTheadRow + footerHeight + pagingHeight + groupAreaHeight + scrHeight;
      let gridHeight = 0;
      if (this.isPercentHeight) {
        const computed = this.document.defaultView.getComputedStyle(this.nativeElement).getPropertyValue('height');
        const autoSize = this._shouldAutoSize(renderedHeight);
        if (autoSize || computed.indexOf('%') !== -1) {
          const bodyHeight = this.getDataBasedBodyHeight();
          return bodyHeight > 0 ? bodyHeight : null;
        }
        gridHeight = parseFloat(computed);
      } else {
        gridHeight = parseInt(this._height, 10);
      }
      const height = Math.abs(gridHeight - renderedHeight);
      if (Math.round(height) === 0 || isNaN(gridHeight)) {
        const bodyHeight = this.defaultTargetBodyHeight;
        return bodyHeight > 0 ? bodyHeight : null;
      }
      return height;
    }
    checkContainerSizeChange() {
      const parentElement = this.nativeElement.parentElement || this.nativeElement.getRootNode().host;
      const origHeight = parentElement.offsetHeight;
      this.nativeElement.style.display = 'none';
      const height = parentElement.offsetHeight;
      this.nativeElement.style.display = '';
      return origHeight !== height;
    }
    _shouldAutoSize(renderedHeight) {
      this.tbody.nativeElement.style.display = 'none';
      const parentElement = this.nativeElement.parentElement || this.nativeElement.getRootNode().host;
      let res = !parentElement || parentElement.clientHeight === 0 || parentElement.clientHeight === renderedHeight;
      if (parentElement && (res || this._autoSize)) {
        // If grid causes the parent container to extend (for example when container is flex)
        // we should always auto-size since the actual size of the container will continuously change as the grid renders elements.
        this._autoSize = false;
        res = this.checkContainerSizeChange();
      }
      this.tbody.nativeElement.style.display = '';
      return res;
    }
    /**
     * @hidden
     * Gets calculated width of the unpinned area
     * @param takeHidden If we should take into account the hidden columns in the pinned area.
     */
    getUnpinnedWidth(takeHidden = false) {
      let width = this.isPercentWidth ? this.calcWidth : parseInt(this.width, 10) || parseInt(this.hostWidth, 10) || this.calcWidth;
      if (this.hasVerticalScroll() && !this.isPercentWidth) {
        width -= this.scrollSize;
      }
      if (!this.isPinningToStart) {
        width -= this.featureColumnsWidth();
      }
      return width - this.getPinnedWidth(takeHidden);
    }
    /**
     * @hidden
     */
    _summaries(fieldName, hasSummary, summaryOperand) {
      const column = this.gridAPI.get_column_by_name(fieldName);
      if (column) {
        column.hasSummary = hasSummary;
        if (summaryOperand) {
          if (this.rootSummariesEnabled) {
            this.summaryService.retriggerRootPipe++;
          }
          column.summaries = summaryOperand;
        }
      }
    }
    /**
     * @hidden
     */
    _multipleSummaries(expressions, hasSummary) {
      expressions.forEach(element => {
        this._summaries(element.fieldName, hasSummary, element.customSummary);
      });
    }
    /**
     * @hidden
     */
    _disableMultipleSummaries(expressions) {
      expressions.forEach(column => {
        const columnName = column && column.fieldName ? column.fieldName : column;
        this._summaries(columnName, false);
      });
    }
    /**
     * @hidden
     */
    resolveDataTypes(rec) {
      if (typeof rec === 'number') {
        return GridColumnDataType.Number;
      } else if (typeof rec === 'boolean') {
        return GridColumnDataType.Boolean;
      } else if (typeof rec === 'object' && rec instanceof Date) {
        return GridColumnDataType.Date;
      } else if (typeof rec === 'string' && /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(rec)) {
        return GridColumnDataType.Image;
      }
      return GridColumnDataType.String;
    }
    /**
     * @hidden
     */
    autogenerateColumns() {
      const data = this.gridAPI.get_data();
      const fields = this.generateDataFields(data);
      const columns = [];
      fields.forEach(field => {
        const ref = createComponent(IgxColumnComponent, {
          environmentInjector: this.envInjector,
          elementInjector: this.injector
        });
        ref.instance.field = field;
        ref.instance.dataType = this.resolveDataTypes(data[0][field]);
        ref.changeDetectorRef.detectChanges();
        columns.push(ref.instance);
      });
      this._autoGeneratedCols = columns;
      this.updateColumns(columns);
      this.columnsAutogenerated.emit({
        columns: this._autoGeneratedCols
      });
    }
    generateDataFields(data) {
      return Object.keys(data && data.length !== 0 ? data[0] : []).filter(key => !this.autoGenerateExclude.includes(key));
    }
    /**
     * @hidden
     */
    initColumns(collection, cb = null) {
      this._columnGroups = collection.some(col => col.columnGroup);
      if (this.hasColumnLayouts) {
        // Set overall row layout size
        collection.forEach(col => {
          if (col.columnLayout) {
            const layoutSize = col.children ? col.children.reduce((acc, val) => Math.max(val.rowStart + val.gridRowSpan - 1, acc), 1) : 1;
            this._multiRowLayoutRowSize = Math.max(layoutSize, this._multiRowLayoutRowSize);
          }
        });
      }
      if (this.hasColumnLayouts && this.hasColumnGroups) {
        // invalid configuration - multi-row and column groups
        // remove column groups
        const columnLayoutColumns = collection.filter(col => col.columnLayout || col.columnLayoutChild);
        collection = columnLayoutColumns;
      }
      this._maxLevelHeaderDepth = null;
      collection.forEach(column => {
        column.defaultWidth = this.columnWidthSetByUser ? this._columnWidth : column.defaultWidth ? column.defaultWidth : '';
        if (cb) {
          cb(column);
        }
      });
      this.updateColumns(collection);
      if (this.hasColumnLayouts) {
        collection.forEach(column => {
          column.populateVisibleIndexes();
        });
      }
    }
    /**
     * @hidden
     */
    reinitPinStates() {
      this._pinnedColumns = this._columns.filter(c => c.pinned).sort((a, b) => this._pinnedColumns.indexOf(a) - this._pinnedColumns.indexOf(b));
      this._unpinnedColumns = this.hasColumnGroups ? this._columns.filter(c => !c.pinned) : this._columns.filter(c => !c.pinned).sort((a, b) => this._unpinnedColumns.indexOf(a) - this._unpinnedColumns.indexOf(b));
    }
    extractDataFromSelection(source, formatters = false, headers = false, columnData) {
      let columnsArray;
      let record = {};
      let selectedData = [];
      let keys = [];
      const selectionCollection = new Map();
      const keysAndData = [];
      const activeEl = this.selectionService.activeElement;
      if (this.type === 'hierarchical') {
        const expansionRowIndexes = [];
        for (const [key, value] of this.expansionStates.entries()) {
          if (value) {
            const rowIndex = this.gridAPI.get_rec_index_by_id(key, this.dataView);
            expansionRowIndexes.push(rowIndex);
          }
        }
        if (this.selectionService.selection.size > 0) {
          if (expansionRowIndexes.length > 0) {
            for (const [key, value] of this.selectionService.selection.entries()) {
              const updatedKey = key;
              let subtract = 0;
              expansionRowIndexes.forEach(row => {
                if (updatedKey > Number(row)) {
                  subtract++;
                }
              });
              selectionCollection.set(updatedKey - subtract, value);
            }
          }
        } else if (activeEl) {
          let subtract = 0;
          if (expansionRowIndexes.length > 0) {
            expansionRowIndexes.forEach(row => {
              if (activeEl.row > Number(row)) {
                subtract++;
              }
            });
            activeEl.row -= subtract;
          }
        }
      }
      const totalItems = this.totalItemCount ?? 0;
      const isRemote = totalItems && totalItems > this.dataView.length;
      let selectionMap;
      if (this.type === 'hierarchical' && selectionCollection.size > 0) {
        selectionMap = isRemote ? Array.from(selectionCollection) : Array.from(selectionCollection).filter(tuple => tuple[0] < source.length);
      } else {
        selectionMap = isRemote ? Array.from(this.selectionService.selection) : Array.from(this.selectionService.selection).filter(tuple => tuple[0] < source.length);
      }
      if (this.cellSelection === GridSelectionMode.single && activeEl) {
        selectionMap.push([activeEl.row, new Set().add(activeEl.column)]);
      }
      if (this.cellSelection === GridSelectionMode.none && activeEl) {
        selectionMap.push([activeEl.row, new Set().add(activeEl.column)]);
      }
      if (columnData) {
        selectedData = columnData;
      }
      // eslint-disable-next-line prefer-const
      for (let [row, set] of selectionMap) {
        row = this.paginator && this.pagingMode === GridPagingMode.Local && source === this.filteredSortedData ? row + this.perPage * this.page : row;
        row = isRemote ? row - this.virtualizationState.startIndex : row;
        if (!source[row] || source[row].detailsData !== undefined) {
          continue;
        }
        const temp = Array.from(set);
        for (const each of temp) {
          columnsArray = this.getSelectableColumnsAt(each);
          columnsArray.forEach(col => {
            if (col) {
              const key = this.type !== 'pivot' && headers ? col.header || col.field : col.field;
              const rowData = source[row].ghostRecord ? source[row].recordRef : source[row];
              const value = this.type === 'pivot' ? rowData.aggregationValues.get(col.field) : resolveNestedPath(rowData, col.field);
              record[key] = formatters && col.formatter ? col.formatter(value, rowData) : value;
              if (columnData) {
                if (!record[key]) {
                  record[key] = '';
                }
                record[key] = record[key].toString().concat('recordRow-' + row);
              }
            }
          });
        }
        if (Object.keys(record).length) {
          if (columnData) {
            if (!keys.length) {
              keys = Object.keys(columnData[0]);
            }
            for (const [key, value] of Object.entries(record)) {
              if (!keys.includes(key)) {
                keys.push(key);
              }
              let c = value;
              const rowNumber = +c.split('recordRow-')[1];
              c = c.split('recordRow-')[0];
              record[key] = c;
              const mergedObj = Object.assign(selectedData[rowNumber], record);
              selectedData[rowNumber] = mergedObj;
            }
          } else {
            selectedData.push(record);
          }
        }
        record = {};
      }
      if (keys.length) {
        keysAndData.push(selectedData);
        keysAndData.push(keys);
        return keysAndData;
      } else {
        return selectedData;
      }
    }
    getSelectableColumnsAt(index) {
      if (this.hasColumnLayouts) {
        const visibleLayoutColumns = this.visibleColumns.filter(col => col.columnLayout).sort((a, b) => a.visibleIndex - b.visibleIndex);
        const colLayout = visibleLayoutColumns[index];
        return colLayout ? colLayout.children.toArray() : [];
      } else {
        const visibleColumns = this.visibleColumns.filter(col => !col.columnGroup).sort((a, b) => a.visibleIndex - b.visibleIndex);
        return [visibleColumns[index]];
      }
    }
    autoSizeColumnsInView() {
      if (!this.hasColumnsToAutosize) return;
      const vState = this.headerContainer.state;
      let colResized = false;
      const unpinnedInView = this.headerContainer.igxGridForOf.slice(vState.startIndex, vState.startIndex + vState.chunkSize).flatMap(x => x.columnGroup ? x.allChildren : x);
      const columnsInView = this.pinnedColumns.concat(unpinnedInView);
      for (const col of columnsInView) {
        if (!col.autoSize && col.headerCell) {
          const cellsContentWidths = [];
          if (col._cells.length !== this.rowList.length) {
            this.rowList.forEach(x => x.cdr.detectChanges());
          }
          const cells = this._dataRowList.map(x => x.cells.find(c => c.column === col));
          cells.forEach(cell => cellsContentWidths.push(cell?.nativeElement?.offsetWidth || 0));
          let maxForCells = Math.max(...cellsContentWidths);
          const header = this.headerCellList.find(x => x.column === col);
          cellsContentWidths.push(header.nativeElement.offsetWidth);
          const max = Math.max(...cellsContentWidths);
          // in cases with template contains something, like a webcomponent,
          // that renders fully only after it is already injected in the DOM,
          // and initially renders as empty, skip measuring it.
          let emptyCellWithPaddingOnly = 0;
          if (cells.length > 0 && !!col.bodyTemplate) {
            const cellStyle = this.document.defaultView.getComputedStyle(cells[0].nativeElement);
            emptyCellWithPaddingOnly = parseFloat(cellStyle.paddingLeft) + parseFloat(cellStyle.paddingRight);
          } else {
            maxForCells = max;
          }
          if (max === 0 || maxForCells <= emptyCellWithPaddingOnly && this._firstAutoResize) {
            // cells not in DOM yet or content not fully initialized.
            continue;
          }
          let maxSize = Math.ceil(Math.max(...cellsContentWidths)) + 1;
          if (col.maxWidth && maxSize > col.maxWidthPx) {
            maxSize = col.maxWidthPx;
          } else if (maxSize < col.minWidthPx) {
            maxSize = col.minWidthPx;
          }
          col.autoSize = maxSize;
          col.resetCaches();
          colResized = true;
        }
      }
      if (colResized) {
        this.resetCachedWidths();
        this.cdr.detectChanges();
      }
      if (this.isColumnWidthSum) {
        this.calcWidth = this.getColumnWidthSum();
      }
    }
    extractDataFromColumnsSelection(source, formatters = false, headers = false) {
      let record = {};
      const selectedData = [];
      const selectedColumns = this.selectedColumns();
      if (selectedColumns.length === 0) {
        return [];
      }
      for (const data of source) {
        selectedColumns.forEach(col => {
          const key = headers ? col.header || col.field : col.field;
          record[key] = formatters && col.formatter ? col.formatter(data[col.field], data) : data[col.field];
        });
        if (Object.keys(record).length) {
          selectedData.push(record);
        }
        record = {};
      }
      return selectedData;
    }
    /**
     * @hidden
     */
    initPinning() {
      this.calculateGridWidth();
      this.resetCaches();
      this.handleColumnPinningForGroups();
      this.notifyChanges();
    }
    /**
     * @hidden
     */
    scrollTo(row, column, inCollection = this._filteredSortedUnpinnedData) {
      let delayScrolling = false;
      if (this.paginator && typeof row !== 'number') {
        const rowIndex = inCollection.indexOf(row);
        const page = Math.floor(rowIndex / this.perPage);
        if (this.page !== page) {
          delayScrolling = true;
          this.page = page;
        }
      }
      if (delayScrolling) {
        this.verticalScrollContainer.dataChanged.pipe(first$2()).subscribe(() => {
          this.scrollDirective(this.verticalScrollContainer, typeof row === 'number' ? row : this.unpinnedDataView.indexOf(row));
        });
      } else {
        this.scrollDirective(this.verticalScrollContainer, typeof row === 'number' ? row : this.unpinnedDataView.indexOf(row));
      }
      this.scrollToHorizontally(column);
    }
    /**
     * @hidden
     */
    scrollToHorizontally(column) {
      let columnIndex = typeof column === 'number' ? column : this.getColumnByName(column).visibleIndex;
      const scrollRow = this.rowList.find(r => !!r.virtDirRow);
      const virtDir = scrollRow ? scrollRow.virtDirRow : null;
      if (this.isPinningToStart && this.pinnedColumns.length) {
        if (columnIndex >= this.pinnedColumns.length) {
          columnIndex -= this.pinnedColumns.length;
          this.scrollDirective(virtDir, columnIndex);
        }
      } else {
        this.scrollDirective(virtDir, columnIndex);
      }
    }
    /**
     * @hidden
     */
    scrollDirective(directive, goal) {
      if (!directive) {
        return;
      }
      directive.scrollTo(goal);
    }
    /**
     * @hidden
     */
    getColumnWidthSum() {
      let colSum = 0;
      const cols = this.hasColumnLayouts ? this.visibleColumns.filter(x => x.columnLayout) : this.visibleColumns.filter(x => !x.columnGroup);
      cols.forEach(item => {
        colSum += parseInt(item.calcWidth || item.defaultWidth, 10) || this.minColumnWidth;
      });
      if (!colSum) {
        return null;
      }
      this.cdr.detectChanges();
      colSum += this.featureColumnsWidth();
      return colSum;
    }
    /**
     * Notify changes, reset cache and populateVisibleIndexes.
     *
     * @hidden
     */
    _columnsReordered(column) {
      this.notifyChanges();
      // after reordering is done reset cached column collections.
      this.resetColumnCollections();
      column.resetCaches();
    }
    buildDataView(_data) {
      this._dataView = this.isRowPinningToTop ? [...this.pinnedDataView, ...this.unpinnedDataView] : [...this.unpinnedDataView, ...this.pinnedDataView];
    }
    _applyWidthHostBinding() {
      let width = this._width;
      if (width === null) {
        let currentWidth = this.calcWidth;
        if (this.hasVerticalScroll()) {
          currentWidth += this.scrollSize;
        }
        width = currentWidth + 'px';
        this.resetCaches();
      }
      this._hostWidth = width;
      this.cdr.markForCheck();
    }
    verticalScrollHandler(event) {
      this.verticalScrollContainer.onScroll(event);
      this.disableTransitions = true;
      this.zone.run(() => {
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          this.verticalScrollContainer.chunkLoad.emit(this.verticalScrollContainer.state);
          if (this.rowEditable) {
            this.changeRowEditingOverlayStateOnScroll(this.crudService.rowInEditMode);
          }
        });
      });
      this.disableTransitions = false;
      this.hideOverlays();
      this.actionStrip?.hide();
      if (this.actionStrip) {
        this.actionStrip.context = null;
      }
      const args = {
        direction: 'vertical',
        event,
        scrollPosition: this.verticalScrollContainer.scrollPosition
      };
      this.gridScroll.emit(args);
    }
    horizontalScrollHandler(event) {
      const scrollLeft = event.target.scrollLeft;
      this.headerContainer.onHScroll(scrollLeft);
      this._horizontalForOfs.forEach(vfor => vfor.onHScroll(scrollLeft));
      this.cdr.markForCheck();
      this.zone.run(() => {
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          this.parentVirtDir.chunkLoad.emit(this.headerContainer.state);
          requestAnimationFrame(() => {
            this.autoSizeColumnsInView();
          });
        });
      });
      if (!this.navigation.isColumnFullyVisible(this.navigation.lastColumnIndex)) {
        this.hideOverlays();
      }
      const args = {
        direction: 'horizontal',
        event,
        scrollPosition: this.headerContainer.scrollPosition
      };
      this.gridScroll.emit(args);
    }
    get renderedActualRowHeight() {
      let border = 1;
      if (this.rowList.toArray().length > 0) {
        const rowStyles = this.document.defaultView.getComputedStyle(this.rowList.first.nativeElement);
        border = rowStyles.borderBottomWidth ? Math.ceil(parseFloat(rowStyles.borderBottomWidth)) : border;
      }
      return this.rowHeight + border;
    }
    executeCallback(rowIndex, visibleColIndex = -1, cb = null) {
      if (!cb) {
        return;
      }
      let row = this.summariesRowList.filter(s => s.index !== 0).concat(this.rowList.toArray()).find(r => r.index === rowIndex);
      if (!row) {
        if (this.totalItemCount) {
          this.verticalScrollContainer.dataChanged.pipe(first$2()).subscribe(() => {
            this.cdr.detectChanges();
            row = this.summariesRowList.filter(s => s.index !== 0).concat(this.rowList.toArray()).find(r => r.index === rowIndex);
            const cbArgs = this.getNavigationArguments(row, visibleColIndex);
            cb(cbArgs);
          });
        }
        const dataViewIndex = this._getDataViewIndex(rowIndex);
        if (this.dataView[dataViewIndex].detailsData) {
          this.navigation.setActiveNode({
            row: rowIndex
          });
          this.cdr.detectChanges();
        }
        return;
      }
      const args = this.getNavigationArguments(row, visibleColIndex);
      cb(args);
    }
    getNavigationArguments(row, visibleColIndex) {
      let targetType;
      let target;
      switch (row.nativeElement.tagName.toLowerCase()) {
        case 'igx-grid-groupby-row':
          targetType = 'groupRow';
          target = row;
          break;
        case 'igx-grid-summary-row':
          targetType = 'summaryCell';
          target = visibleColIndex !== -1 ? row.summaryCells.find(c => c.visibleColumnIndex === visibleColIndex) : row.summaryCells.first;
          break;
        case 'igx-child-grid-row':
          targetType = 'hierarchicalRow';
          target = row;
          break;
        default:
          targetType = 'dataCell';
          target = visibleColIndex !== -1 ? row.cells.find(c => c.visibleColumnIndex === visibleColIndex) : row.cells.first;
          break;
      }
      return {
        targetType,
        target
      };
    }
    getNextDataRowIndex(currentRowIndex, previous = false) {
      const resolvedIndex = this._getDataViewIndex(currentRowIndex);
      if (currentRowIndex < 0 || currentRowIndex === 0 && previous || resolvedIndex >= this.dataView.length - 1 && !previous) {
        return currentRowIndex;
      }
      // find next/prev record that is editable.
      const nextRowIndex = previous ? this.findPrevEditableDataRowIndex(currentRowIndex) : this.dataView.findIndex((rec, index) => index > resolvedIndex && this.isEditableDataRecordAtIndex(index));
      const nextDataIndex = this.getDataIndex(nextRowIndex);
      return nextDataIndex !== -1 ? nextDataIndex : currentRowIndex;
    }
    /**
     * Returns the previous editable row index or -1 if no such row is found.
     *
     * @param currentIndex The index of the current editable record.
     */
    findPrevEditableDataRowIndex(currentIndex) {
      let i = this.dataView.length;
      const resolvedIndex = this._getDataViewIndex(currentIndex);
      while (i--) {
        if (i < resolvedIndex && this.isEditableDataRecordAtIndex(i)) {
          return i;
        }
      }
      return -1;
    }
    /**
     * Returns if the record at the specified data view index is a an editable data record.
     * If record is group rec, summary rec, child rec, ghost rec. etc. it is not editable.
     *
     * @param dataViewIndex The index of that record in the data view.
     *
     */
    // TODO: Consider moving it into CRUD
    isEditableDataRecordAtIndex(dataViewIndex) {
      const rec = this.dataView[dataViewIndex];
      return !rec.expression && !rec.summaries && !rec.childGridsData && !rec.detailsData && !this.isGhostRecordAtIndex(dataViewIndex);
    }
    /**
     * Returns if the record at the specified data view index is a ghost.
     * If record is pinned but is not in pinned area then it is a ghost record.
     *
     * @param dataViewIndex The index of that record in the data view.
     */
    isGhostRecordAtIndex(dataViewIndex) {
      const isPinned = this.isRecordPinned(this.dataView[dataViewIndex]);
      const isInPinnedArea = this.isRecordPinnedByViewIndex(dataViewIndex);
      return isPinned && !isInPinnedArea;
    }
    isValidPosition(rowIndex, colIndex) {
      const rows = this.summariesRowList.filter(s => s.index !== 0).concat(this.rowList.toArray()).length;
      const cols = this._columns.filter(col => !col.columnGroup && col.visibleIndex >= 0 && !col.hidden).length;
      if (rows < 1 || cols < 1) {
        return false;
      }
      if (rowIndex > -1 && rowIndex < this.dataView.length && colIndex > -1 && colIndex <= Math.max(...this.visibleColumns.map(c => c.visibleIndex))) {
        return true;
      }
      return false;
    }
    find(text, increment, caseSensitive, exactMatch, scroll, endEdit = true) {
      if (!this.rowList) {
        return 0;
      }
      if (endEdit) {
        this.crudService.endEdit(false);
      }
      if (!text) {
        this.clearSearch();
        return 0;
      }
      const caseSensitiveResolved = caseSensitive ? true : false;
      const exactMatchResolved = exactMatch ? true : false;
      let rebuildCache = false;
      if (this._lastSearchInfo.searchText !== text || this._lastSearchInfo.caseSensitive !== caseSensitiveResolved || this._lastSearchInfo.exactMatch !== exactMatchResolved) {
        this._lastSearchInfo = {
          searchText: text,
          activeMatchIndex: 0,
          caseSensitive: caseSensitiveResolved,
          exactMatch: exactMatchResolved,
          matchInfoCache: [],
          matchCount: 0,
          content: ''
        };
        rebuildCache = true;
      } else {
        this._lastSearchInfo.activeMatchIndex += increment;
      }
      if (rebuildCache) {
        this.rowList.forEach(row => {
          if (row.cells) {
            row.cells.forEach(c => {
              c.highlightText(text, caseSensitiveResolved, exactMatchResolved);
            });
          }
        });
        this.rebuildMatchCache();
      }
      if (this._lastSearchInfo.activeMatchIndex >= this._lastSearchInfo.matchCount) {
        this._lastSearchInfo.activeMatchIndex = 0;
      } else if (this._lastSearchInfo.activeMatchIndex < 0) {
        this._lastSearchInfo.activeMatchIndex = this._lastSearchInfo.matchCount - 1;
      }
      if (this._lastSearchInfo.matchCount > 0) {
        const matchInfo = this._lastSearchInfo.matchInfoCache[this._lastSearchInfo.activeMatchIndex];
        this._lastSearchInfo = {
          ...this._lastSearchInfo
        };
        if (scroll !== false) {
          this.scrollTo(matchInfo.row, matchInfo.column);
        }
        this.textHighlightService.setActiveHighlight(this.id, {
          column: matchInfo.column,
          row: matchInfo.row,
          index: matchInfo.index,
          metadata: matchInfo.metadata
        });
      } else {
        this.textHighlightService.clearActiveHighlight(this.id);
      }
      return this._lastSearchInfo.matchCount;
    }
    rebuildMatchCache() {
      this._lastSearchInfo.matchInfoCache = [];
      const caseSensitive = this._lastSearchInfo.caseSensitive;
      const exactMatch = this._lastSearchInfo.exactMatch;
      const searchText = caseSensitive ? this._lastSearchInfo.searchText : this._lastSearchInfo.searchText.toLowerCase();
      const data = this.filteredSortedData;
      const columnItems = this.visibleColumns.filter(c => !c.columnGroup).sort((c1, c2) => c1.visibleIndex - c2.visibleIndex);
      data.forEach((dataRow, rowIndex) => {
        columnItems.forEach(c => {
          const pipeArgs = this.getColumnByName(c.field).pipeArgs;
          const value = c.formatter ? c.formatter(resolveNestedPath(dataRow, c.field), dataRow) : c.dataType === 'number' ? formatNumber(resolveNestedPath(dataRow, c.field), this.locale, pipeArgs.digitsInfo) : c.dataType === 'date' ? formatDate(resolveNestedPath(dataRow, c.field), pipeArgs.format, this.locale, pipeArgs.timezone) : resolveNestedPath(dataRow, c.field);
          if (value !== undefined && value !== null && c.searchable) {
            let searchValue = caseSensitive ? String(value) : String(value).toLowerCase();
            if (exactMatch) {
              if (searchValue === searchText) {
                const mic = {
                  row: dataRow,
                  column: c.field,
                  index: 0,
                  metadata: new Map([['pinned', this.isRecordPinnedByIndex(rowIndex)]])
                };
                this._lastSearchInfo.matchInfoCache.push(mic);
              }
            } else {
              let occurrenceIndex = 0;
              let searchIndex = searchValue.indexOf(searchText);
              while (searchIndex !== -1) {
                const mic = {
                  row: dataRow,
                  column: c.field,
                  index: occurrenceIndex++,
                  metadata: new Map([['pinned', this.isRecordPinnedByIndex(rowIndex)]])
                };
                this._lastSearchInfo.matchInfoCache.push(mic);
                searchValue = searchValue.substring(searchIndex + searchText.length);
                searchIndex = searchValue.indexOf(searchText);
              }
            }
          }
        });
      });
      this._lastSearchInfo.matchCount = this._lastSearchInfo.matchInfoCache.length;
    }
    updateDefaultRowHeight() {
      if (this.dataRowList.length > 0 && this.dataRowList.first.cells && this.dataRowList.first.cells.length > 0) {
        const height = parseFloat(this.document.defaultView.getComputedStyle(this.dataRowList.first.cells.first.nativeElement)?.getPropertyValue('height'));
        if (height) {
          this._defaultRowHeight = height;
        } else {
          this._shouldRecalcRowHeight = true;
        }
      }
    }
    // TODO: About to Move to CRUD
    configureRowEditingOverlay(rowID, useOuter = false) {
      let settings = this.rowEditSettings;
      const overlay = this.overlayService.getOverlayById(this.rowEditingOverlay.overlayId);
      if (overlay) {
        settings = overlay.settings;
      }
      settings.outlet = useOuter ? this.parentRowOutletDirective : this.rowOutletDirective;
      this.rowEditPositioningStrategy.settings.container = this.tbody.nativeElement;
      const pinned = this._pinnedRecordIDs.indexOf(rowID) !== -1;
      const targetRow = !pinned ? this.gridAPI.get_row_by_key(rowID) : this.pinnedRows.find(x => x.key === rowID);
      if (!targetRow) {
        return;
      }
      settings.target = targetRow.element.nativeElement;
      this.toggleRowEditingOverlay(true);
    }
    handleColumnPinningForGroups() {
      // When a column is a group or is inside a group, pin all related.
      const pinnedColumns = [];
      const unpinnedColumns = [];
      this._pinnedColumns.forEach(col => {
        if (col.parent) {
          col.parent.pinned = true;
        }
        if (col.columnGroup) {
          col.children.forEach(child => child.pinned = true);
        }
      });
      // Make sure we don't exceed unpinned area min width and get pinned and unpinned col collections.
      // We take into account top level columns (top level groups and non groups).
      // If top level is unpinned the pinning handles all children to be unpinned as well.
      for (const column of this._columns) {
        if (column.pinned && !column.parent) {
          pinnedColumns.push(column);
        } else if (column.pinned && column.parent) {
          if (column.topLevelParent.pinned) {
            pinnedColumns.push(column);
          } else {
            column.pinned = false;
            unpinnedColumns.push(column);
          }
        } else {
          unpinnedColumns.push(column);
        }
      }
      // Assign the applicable collections.
      this._pinnedColumns = pinnedColumns;
      this._unpinnedColumns = unpinnedColumns;
    }
    shouldRecreateColumns(oldData, newData) {
      if (!oldData || !oldData.length) return true;
      if (!newData || !newData.length) return false;
      return Object.keys(oldData[0]).join() !== Object.keys(newData[0]).join();
    }
    /**
     * Clears the current navigation service active node
     */
    clearActiveNode() {
      this.navigation.lastActiveNode = this.navigation.activeNode;
      this.navigation.activeNode = {};
      this.notifyChanges();
    }
    static {
      this.ɵfac = function IgxGridBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridBaseDirective)(i0.ɵɵdirectiveInject(IgxGridValidationService), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(IgxFlatTransactionFactory), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(IgxGridNavigationService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxGridSummaryService), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxGridTransaction, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridBaseDirective,
        contentQueries: function IgxGridBaseDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxExcelStyleLoadingValuesTemplateDirective, 7, IgxExcelStyleLoadingValuesTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxRowAddTextDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowExpandedIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowCollapsedIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxHeaderExpandedIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxHeaderCollapsedIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxExcelStyleHeaderIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSortAscendingHeaderIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSortDescendingHeaderIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxSortHeaderIconDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxGridExcelStyleFilteringComponent, 4, IgxGridExcelStyleFilteringComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxColumnComponent, 5, IgxColumnComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxActionStripToken, 4);
            i0.ɵɵcontentQuery(dirIndex, IgxHeadSelectorDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowSelectorDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowDragGhostDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowEditTemplateDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowEditTextDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowEditActionsDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxDragIndicatorIconDirective, 4, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowEditTabStopDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxToolbarToken, 4);
            i0.ɵɵcontentQuery(dirIndex, IgxPaginatorToken, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelStyleLoadingValuesTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowAddText = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowExpandedIndicatorDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowCollapsedIndicatorDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerExpandedIndicatorDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerCollapsedIndicatorDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelStyleHeaderIconDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortAscendingHeaderIconDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortDescendingHeaderIconDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortHeaderIconDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelStyleFilteringComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionStripComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headSelectorsTemplates = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowSelectorsTemplates = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragGhostCustomTemplates = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditCustomDirectives = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditTextDirectives = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditActionsDirectives = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragIndicatorIconTemplates = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditTabsCUSTOM = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbar = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationComponents = _t);
          }
        },
        viewQuery: function IgxGridBaseDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxSnackbarComponent, 5);
            i0.ɵɵviewQuery(IgxGridColumnResizerComponent, 5);
            i0.ɵɵviewQuery(_c185, 7, IgxToggleDirective);
            i0.ɵɵviewQuery(_c186, 7, IgxOverlayOutletDirective);
            i0.ɵɵviewQuery(_c187, 7, TemplateRef);
            i0.ɵɵviewQuery(_c188, 7, TemplateRef);
            i0.ɵɵviewQuery(_c189, 7, TemplateRef);
            i0.ɵɵviewQuery(_c20, 7, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c190, 7, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c191, 7, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c192, 7, ElementRef);
            i0.ɵɵviewQuery(_c179, 7, TemplateRef);
            i0.ɵɵviewQuery(_c193, 5, ElementRef);
            i0.ɵɵviewQuery(IgxGridHeaderRowComponent, 7);
            i0.ɵɵviewQuery(IgxGridGroupByAreaComponent, 5);
            i0.ɵɵviewQuery(_c194, 7);
            i0.ɵɵviewQuery(IgxGridBodyDirective, 7, ElementRef);
            i0.ɵɵviewQuery(_c195, 5, ElementRef);
            i0.ɵɵviewQuery(_c196, 7);
            i0.ɵɵviewQuery(_c197, 7, IgxOverlayOutletDirective);
            i0.ɵɵviewQuery(_c198, 7, TemplateRef);
            i0.ɵɵviewQuery(_c199, 5, IgxToggleDirective);
            i0.ɵɵviewQuery(_c200, 7, IgxOverlayOutletDirective);
            i0.ɵɵviewQuery(_c201, 7, ViewContainerRef);
            i0.ɵɵviewQuery(_c202, 7, TemplateRef);
            i0.ɵɵviewQuery(_c203, 7, TemplateRef);
            i0.ɵɵviewQuery(_c204, 7, TemplateRef);
            i0.ɵɵviewQuery(_c205, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxTemplateOutletDirective, 5, IgxTemplateOutletDirective);
            i0.ɵɵviewQuery(IgxRowEditTabStopDirective, 5);
            i0.ɵɵviewQuery(_c206, 5, IgxSummaryRowComponent);
            i0.ɵɵviewQuery(_c207, 5);
            i0.ɵɵviewQuery(_c208, 5);
            i0.ɵɵviewQuery(IgxRowDirective, 5, IgxRowDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addRowSnackbar = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizeLine = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingOverlay = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingOutlet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyFilteredGridTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyGridDefaultTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingGridDefaultTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.parentVirtDir = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.verticalScrollContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.verticalScroll = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scr = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerSelectorBaseTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.theadRow = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tbody = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tbodyContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pinContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tfoot = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditingOutletDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragIndicatorIconBase = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditingOverlay = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._outletDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.anchor = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExpandedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultCollapsedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultESFHeaderIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultRowEditTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tmpOutlets = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowEditTabsDEFAULT = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._summaryRowList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._rowList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._pinnedRowList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._dataRowList = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxGridBaseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseleave", function IgxGridBaseDirective_mouseleave_HostBindingHandler() {
              return ctx.hideActionStrip();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabindex)("role", ctx.hostRole);
            i0.ɵɵstyleProp("height", ctx.height)("width", ctx.hostWidth);
            i0.ɵɵclassProp("igx-grid", ctx.baseClass);
          }
        },
        inputs: {
          snackbarDisplayTime: "snackbarDisplayTime",
          autoGenerate: [2, "autoGenerate", "autoGenerate", booleanAttribute],
          autoGenerateExclude: "autoGenerateExclude",
          moving: [2, "moving", "moving", booleanAttribute],
          emptyGridTemplate: "emptyGridTemplate",
          addRowEmptyTemplate: "addRowEmptyTemplate",
          loadingGridTemplate: "loadingGridTemplate",
          summaryRowHeight: "summaryRowHeight",
          dataCloneStrategy: "dataCloneStrategy",
          clipboardOptions: "clipboardOptions",
          rowClasses: "rowClasses",
          rowStyles: "rowStyles",
          primaryKey: "primaryKey",
          uniqueColumnValuesStrategy: "uniqueColumnValuesStrategy",
          dragGhostCustomTemplate: "dragGhostCustomTemplate",
          rowEditTextTemplate: "rowEditTextTemplate",
          rowAddTextTemplate: "rowAddTextTemplate",
          rowEditActionsTemplate: "rowEditActionsTemplate",
          rowExpandedIndicatorTemplate: "rowExpandedIndicatorTemplate",
          rowCollapsedIndicatorTemplate: "rowCollapsedIndicatorTemplate",
          headerExpandedIndicatorTemplate: "headerExpandedIndicatorTemplate",
          headerCollapsedIndicatorTemplate: "headerCollapsedIndicatorTemplate",
          excelStyleHeaderIconTemplate: "excelStyleHeaderIconTemplate",
          sortAscendingHeaderIconTemplate: "sortAscendingHeaderIconTemplate",
          sortDescendingHeaderIconTemplate: "sortDescendingHeaderIconTemplate",
          sortHeaderIconTemplate: "sortHeaderIconTemplate",
          resourceStrings: "resourceStrings",
          filteringLogic: "filteringLogic",
          filteringExpressionsTree: "filteringExpressionsTree",
          advancedFilteringExpressionsTree: "advancedFilteringExpressionsTree",
          locale: "locale",
          pagingMode: "pagingMode",
          hideRowSelectors: [2, "hideRowSelectors", "hideRowSelectors", booleanAttribute],
          rowDraggable: [2, "rowDraggable", "rowDraggable", booleanAttribute],
          validationTrigger: "validationTrigger",
          rowEditable: [2, "rowEditable", "rowEditable", booleanAttribute],
          height: "height",
          width: "width",
          rowHeight: "rowHeight",
          columnWidth: "columnWidth",
          emptyGridMessage: "emptyGridMessage",
          isLoading: [2, "isLoading", "isLoading", booleanAttribute],
          emptyFilteredGridMessage: "emptyFilteredGridMessage",
          pinning: "pinning",
          allowFiltering: [2, "allowFiltering", "allowFiltering", booleanAttribute],
          allowAdvancedFiltering: [2, "allowAdvancedFiltering", "allowAdvancedFiltering", booleanAttribute],
          filterMode: "filterMode",
          summaryPosition: "summaryPosition",
          summaryCalculationMode: "summaryCalculationMode",
          showSummaryOnCollapse: [2, "showSummaryOnCollapse", "showSummaryOnCollapse", booleanAttribute],
          filterStrategy: "filterStrategy",
          sortStrategy: "sortStrategy",
          sortingOptions: "sortingOptions",
          selectedRows: "selectedRows",
          headSelectorTemplate: "headSelectorTemplate",
          rowSelectorTemplate: "rowSelectorTemplate",
          dragIndicatorIconTemplate: "dragIndicatorIconTemplate",
          sortingExpressions: "sortingExpressions",
          batchEditing: [2, "batchEditing", "batchEditing", booleanAttribute],
          cellSelection: "cellSelection",
          rowSelection: "rowSelection",
          columnSelection: "columnSelection",
          expansionStates: "expansionStates",
          outlet: "outlet",
          totalRecords: "totalRecords",
          selectRowOnClick: [2, "selectRowOnClick", "selectRowOnClick", booleanAttribute]
        },
        outputs: {
          filteringExpressionsTreeChange: "filteringExpressionsTreeChange",
          advancedFilteringExpressionsTreeChange: "advancedFilteringExpressionsTreeChange",
          gridScroll: "gridScroll",
          cellClick: "cellClick",
          rowClick: "rowClick",
          formGroupCreated: "formGroupCreated",
          validationStatusChange: "validationStatusChange",
          selected: "selected",
          rowSelectionChanging: "rowSelectionChanging",
          columnSelectionChanging: "columnSelectionChanging",
          columnPin: "columnPin",
          columnPinned: "columnPinned",
          cellEditEnter: "cellEditEnter",
          cellEditExit: "cellEditExit",
          cellEdit: "cellEdit",
          cellEditDone: "cellEditDone",
          rowEditEnter: "rowEditEnter",
          rowEdit: "rowEdit",
          rowEditDone: "rowEditDone",
          rowEditExit: "rowEditExit",
          columnInit: "columnInit",
          columnsAutogenerated: "columnsAutogenerated",
          sorting: "sorting",
          sortingDone: "sortingDone",
          filtering: "filtering",
          filteringDone: "filteringDone",
          rowAdded: "rowAdded",
          rowDeleted: "rowDeleted",
          rowDelete: "rowDelete",
          rowAdd: "rowAdd",
          columnResized: "columnResized",
          contextMenu: "contextMenu",
          doubleClick: "doubleClick",
          columnVisibilityChanging: "columnVisibilityChanging",
          columnVisibilityChanged: "columnVisibilityChanged",
          columnMovingStart: "columnMovingStart",
          columnMoving: "columnMoving",
          columnMovingEnd: "columnMovingEnd",
          gridKeydown: "gridKeydown",
          rowDragStart: "rowDragStart",
          rowDragEnd: "rowDragEnd",
          gridCopy: "gridCopy",
          expansionStatesChange: "expansionStatesChange",
          selectedRowsChange: "selectedRowsChange",
          rowToggle: "rowToggle",
          rowPinning: "rowPinning",
          rowPinned: "rowPinned",
          activeNodeChange: "activeNodeChange",
          sortingExpressionsChange: "sortingExpressionsChange",
          toolbarExporting: "toolbarExporting",
          rangeSelected: "rangeSelected",
          rendered: "rendered",
          localeChange: "localeChange",
          dataChanging: "dataChanging",
          dataChanged: "dataChanged"
        }
      });
    }
  }
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "primaryKey", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "filteringLogic", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "filteringExpressionsTree", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "advancedFilteringExpressionsTree", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "hideRowSelectors", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "rowEditable", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "height", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "width", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "rowHeight", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "columnWidth", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "isLoading", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "sortingExpressions", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "cellSelection", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "rowSelection", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "columnSelection", null);
  __decorate([WatchChanges()], IgxGridBaseDirective.prototype, "selectRowOnClick", null);
  return IgxGridBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GridBaseAPIService = /*#__PURE__*/(() => {
  class GridBaseAPIService {
    constructor(crudService, cms) {
      this.crudService = crudService;
      this.cms = cms;
      this.destroyMap = new Map();
    }
    get_column_by_name(name) {
      return this.grid.columns.find(col => col.field === name);
    }
    get_summary_data() {
      const grid = this.grid;
      let data = grid.filteredData;
      if (data && grid.hasPinnedRecords) {
        data = grid._filteredUnpinnedData;
      }
      if (!data) {
        if (grid.transactions.enabled) {
          data = DataUtil.mergeTransactions(cloneArray(grid.data), grid.transactions.getAggregatedChanges(true), grid.primaryKey, grid.dataCloneStrategy);
          const deletedRows = grid.transactions.getTransactionLog().filter(t => t.type === TransactionType.DELETE).map(t => t.id);
          deletedRows.forEach(rowID => {
            const tempData = grid.primaryKey ? data.map(rec => rec[grid.primaryKey]) : data;
            const index = tempData.indexOf(rowID);
            if (index !== -1) {
              data.splice(index, 1);
            }
          });
        } else {
          data = grid.data;
        }
      }
      return data;
    }
    /**
     * @hidden
     * @internal
     */
    getRowData(rowID) {
      const data = this.get_all_data(this.grid.transactions.enabled);
      const index = this.get_row_index_in_data(rowID, data);
      return data[index];
    }
    get_row_index_in_data(rowID, dataCollection) {
      const grid = this.grid;
      if (!grid) {
        return -1;
      }
      const data = dataCollection ?? this.get_all_data(grid.transactions.enabled);
      return grid.primaryKey ? data.findIndex(record => record.recordRef ? record.recordRef[grid.primaryKey] === rowID : record[grid.primaryKey] === rowID) : data.indexOf(rowID);
    }
    get_row_by_key(rowSelector) {
      if (!this.grid) {
        return null;
      }
      const primaryKey = this.grid.primaryKey;
      if (primaryKey !== undefined && primaryKey !== null) {
        return this.grid.dataRowList.find(row => row.data[primaryKey] === rowSelector);
      } else {
        return this.grid.dataRowList.find(row => row.data === rowSelector);
      }
    }
    get_row_by_index(rowIndex) {
      return this.grid.rowList.find(row => row.index === rowIndex);
    }
    /**
     * Gets the rowID of the record at the specified data view index
     *
     * @param index
     * @param dataCollection
     */
    get_rec_id_by_index(index, dataCollection) {
      dataCollection = dataCollection || this.grid.data;
      if (index >= 0 && index < dataCollection.length) {
        const rec = dataCollection[index];
        return this.grid.primaryKey ? rec[this.grid.primaryKey] : rec;
      }
      return null;
    }
    get_cell_by_key(rowSelector, field) {
      const row = this.get_row_by_key(rowSelector);
      if (row && row.cells) {
        return row.cells.find(cell => cell.column.field === field);
      }
    }
    get_cell_by_index(rowIndex, columnID) {
      const row = this.get_row_by_index(rowIndex);
      const hasCells = row && row.cells;
      if (hasCells && typeof columnID === 'number') {
        return row.cells.find(cell => cell.column.index === columnID);
      }
      if (hasCells && typeof columnID === 'string') {
        return row.cells.find(cell => cell.column.field === columnID);
      }
    }
    get_cell_by_visible_index(rowIndex, columnIndex) {
      const row = this.get_row_by_index(rowIndex);
      if (row && row.cells) {
        return row.cells.find(cell => cell.visibleColumnIndex === columnIndex);
      }
    }
    update_cell(cell) {
      if (!cell) {
        return;
      }
      const args = cell.createCellEditEventArgs(true);
      if (!this.grid.crudService.row) {
        // should not recalculate summaries when there is row in edit mode
        this.grid.summaryService.clearSummaryCache(args);
      }
      const data = this.getRowData(cell.id.rowID);
      const newRowData = reverseMapper(cell.column.field, args.newValue);
      this.updateData(this.grid, cell.id.rowID, data, cell.rowData, newRowData);
      if (!this.grid.crudService.row) {
        this.grid.validation.update(cell.id.rowID, newRowData);
      }
      if (this.grid.primaryKey === cell.column.field) {
        if (this.grid.pinnedRecords.length > 0) {
          const rowIndex = this.grid.pinnedRecords.indexOf(cell.rowData);
          if (rowIndex !== -1) {
            const previousRowId = cell.value;
            const rowType = this.grid.getRowByIndex(cell.rowIndex);
            this.unpin_row(previousRowId, rowType);
            this.pin_row(args.newValue, rowIndex, rowType);
          }
        }
        if (this.grid.selectionService.isRowSelected(cell.id.rowID)) {
          this.grid.selectionService.deselectRow(cell.id.rowID);
          this.grid.selectionService.selectRowById(args.newValue);
        }
        if (this.grid.hasSummarizedColumns) {
          this.grid.summaryService.removeSummaries(cell.id.rowID);
        }
      }
      if (!this.grid.rowEditable || !this.crudService.row || this.crudService.row.id !== cell.id.rowID || !this.grid.transactions.enabled) {
        this.grid.summaryService.clearSummaryCache(args);
        this.grid.pipeTrigger++;
      }
      return args;
    }
    // TODO: CRUD refactor to not emit editing evts.
    update_row(row, value, event) {
      const grid = this.grid;
      const selected = grid.selectionService.isRowSelected(row.id);
      const rowInEditMode = this.crudService.row;
      const data = this.get_all_data(grid.transactions.enabled);
      const index = this.get_row_index_in_data(row.id, data);
      const hasSummarized = grid.hasSummarizedColumns;
      this.crudService.updateRowEditData(row, value);
      const args = row.createRowEditEventArgs(true, event);
      // If no valid row is found
      if (index === -1) {
        return args;
      }
      if (rowInEditMode) {
        const hasChanges = grid.transactions.getState(args.rowID, true);
        grid.transactions.endPending(false);
        if (!hasChanges) {
          return args;
        }
      }
      if (!args.newValue) {
        return args;
      }
      if (hasSummarized) {
        grid.summaryService.removeSummaries(args.rowID);
      }
      this.updateData(grid, row.id, data[index], args.oldValue, args.newValue);
      this.grid.validation.update(row.id, args.newValue);
      const newId = grid.primaryKey ? args.newValue[grid.primaryKey] : args.newValue;
      if (selected) {
        grid.selectionService.deselectRow(row.id);
        grid.selectionService.selectRowById(newId);
      }
      // make sure selection is handled prior to updating the row.id
      row.id = newId;
      if (hasSummarized) {
        grid.summaryService.removeSummaries(newId);
      }
      grid.pipeTrigger++;
      return args;
    }
    sort(expression) {
      if (expression.dir === SortingDirection.None) {
        this.remove_grouping_expression(expression.fieldName);
      }
      const sortingState = cloneArray(this.grid.sortingExpressions);
      this.prepare_sorting_expression([sortingState], expression);
      this.grid.sortingExpressions = sortingState;
    }
    sort_decoupled(expression) {
      if (expression.dir === SortingDirection.None) {
        this.remove_grouping_expression(expression.fieldName);
      }
      const groupingState = cloneArray(this.grid.groupingExpressions);
      this.prepare_grouping_expression([groupingState], expression);
      this.grid.groupingExpressions = groupingState;
    }
    sort_multiple(expressions) {
      const sortingState = cloneArray(this.grid.sortingExpressions);
      for (const each of expressions) {
        if (each.dir === SortingDirection.None) {
          this.remove_grouping_expression(each.fieldName);
        }
        this.prepare_sorting_expression([sortingState], each);
      }
      this.grid.sortingExpressions = sortingState;
    }
    sort_groupBy_multiple(expressions) {
      const groupingState = cloneArray(this.grid.groupingExpressions);
      for (const each of expressions) {
        if (each.dir === SortingDirection.None) {
          this.remove_grouping_expression(each.fieldName);
        }
        this.prepare_grouping_expression([groupingState], each);
      }
    }
    clear_sort(fieldName) {
      const sortingState = this.grid.sortingExpressions;
      const index = sortingState.findIndex(expr => expr.fieldName === fieldName);
      if (index > -1) {
        sortingState.splice(index, 1);
        this.grid.sortingExpressions = sortingState;
      }
    }
    clear_groupby(_name) {}
    should_apply_number_style(column) {
      return column.dataType === GridColumnDataType.Number;
    }
    get_data() {
      const grid = this.grid;
      const data = grid.data ? grid.data : [];
      return data;
    }
    get_all_data(includeTransactions = false) {
      const grid = this.grid;
      let data = grid && grid.data ? grid.data : [];
      data = includeTransactions ? grid.dataWithAddedInTransactionRows : data;
      return data;
    }
    get_filtered_data() {
      return this.grid.filteredData;
    }
    addRowToData(rowData, _parentID) {
      // Add row goes to transactions and if rowEditable is properly implemented, added rows will go to pending transactions
      // If there is a row in edit - > commit and close
      const grid = this.grid;
      const rowId = grid.primaryKey ? rowData[grid.primaryKey] : rowData;
      if (grid.transactions.enabled) {
        const transaction = {
          id: rowId,
          type: TransactionType.ADD,
          newValue: rowData
        };
        grid.transactions.add(transaction);
      } else {
        grid.data.push(rowData);
      }
      grid.validation.markAsTouched(rowId);
      grid.validation.update(rowId, rowData);
    }
    deleteRowFromData(rowID, index) {
      //  if there is a row (index !== 0) delete it
      //  if there is a row in ADD or UPDATE state change it's state to DELETE
      const grid = this.grid;
      if (index !== -1) {
        if (grid.transactions.enabled) {
          const transaction = {
            id: rowID,
            type: TransactionType.DELETE,
            newValue: null
          };
          grid.transactions.add(transaction, grid.data[index]);
        } else {
          grid.data.splice(index, 1);
        }
      } else {
        const state = grid.transactions.getState(rowID);
        grid.transactions.add({
          id: rowID,
          type: TransactionType.DELETE,
          newValue: null
        }, state && state.recordRef);
      }
      grid.validation.clear(rowID);
    }
    deleteRowById(rowId) {
      let index;
      const grid = this.grid;
      const data = this.get_all_data(grid.transactions.enabled);
      if (grid.primaryKey) {
        index = data.map(record => record[grid.primaryKey]).indexOf(rowId);
      } else {
        index = data.indexOf(rowId);
      }
      const state = grid.transactions.getState(rowId);
      const hasRowInNonDeletedState = state && state.type !== TransactionType.DELETE;
      //  if there is a row (index !== -1) and the we have cell in edit mode on same row exit edit mode
      //  if there is no row (index === -1), but there is a row in ADD or UPDATE state do as above
      //  Otherwise just exit - there is nothing to delete
      if (index !== -1 || hasRowInNonDeletedState) {
        // Always exit edit when row is deleted
        this.crudService.endEdit(true);
      } else {
        return;
      }
      const record = data[index];
      const key = record ? record[grid.primaryKey] : undefined;
      grid.rowDeletedNotifier.next({
        data: record,
        rowData: record,
        owner: grid,
        primaryKey: key,
        rowKey: key
      });
      this.deleteRowFromData(rowId, index);
      if (grid.selectionService.isRowSelected(rowId)) {
        grid.selectionService.deselectRowsWithNoEvent([rowId]);
      } else {
        grid.selectionService.clearHeaderCBState();
      }
      grid.pipeTrigger++;
      grid.notifyChanges();
      // Data needs to be recalculated if transactions are in place
      // If no transactions, `data` will be a reference to the grid getter, otherwise it will be stale
      const dataAfterDelete = grid.transactions.enabled ? grid.dataWithAddedInTransactionRows : data;
      grid.refreshSearch();
      if (dataAfterDelete.length % grid.perPage === 0 && dataAfterDelete.length / grid.perPage - 1 < grid.page && grid.page !== 0) {
        grid.page--;
      }
      return record;
    }
    get_row_id(rowData) {
      return this.grid.primaryKey ? rowData[this.grid.primaryKey] : rowData;
    }
    row_deleted_transaction(rowID) {
      const grid = this.grid;
      if (!grid) {
        return false;
      }
      if (!grid.transactions.enabled) {
        return false;
      }
      const state = grid.transactions.getState(rowID);
      if (state) {
        return state.type === TransactionType.DELETE;
      }
      return false;
    }
    get_row_expansion_state(record) {
      const grid = this.grid;
      const states = grid.expansionStates;
      const rowID = grid.primaryKey ? record[grid.primaryKey] : record;
      const expanded = states.get(rowID);
      if (expanded !== undefined) {
        return expanded;
      } else {
        return grid.getDefaultExpandState(record);
      }
    }
    set_row_expansion_state(rowID, expanded, event) {
      const grid = this.grid;
      const expandedStates = grid.expansionStates;
      if (!this.allow_expansion_state_change(rowID, expanded)) {
        return;
      }
      const args = {
        rowKey: rowID,
        rowID,
        expanded,
        event,
        cancel: false
      };
      grid.rowToggle.emit(args);
      if (args.cancel) {
        return;
      }
      expandedStates.set(rowID, expanded);
      grid.expansionStates = expandedStates;
      // K.D. 28 Feb, 2022 #10634 Don't trigger endEdit/commit upon row expansion state change
      // this.crudService.endEdit(false);
    }
    get_rec_by_id(rowID) {
      return this.grid.primaryKey ? this.getRowData(rowID) : rowID;
    }
    /**
     * Returns the index of the record in the data view by pk or -1 if not found or primaryKey is not set.
     *
     * @param pk
     * @param dataCollection
     */
    get_rec_index_by_id(pk, dataCollection) {
      dataCollection = dataCollection || this.grid.data;
      return this.grid.primaryKey ? dataCollection.findIndex(rec => rec[this.grid.primaryKey] === pk) : -1;
    }
    allow_expansion_state_change(rowID, expanded) {
      return this.grid.expansionStates.get(rowID) !== expanded;
    }
    prepare_sorting_expression(stateCollections, expression) {
      if (expression.dir === SortingDirection.None) {
        stateCollections.forEach(state => {
          state.splice(state.findIndex(expr => expr.fieldName === expression.fieldName), 1);
        });
        return;
      }
      /**
       * We need to make sure the states in each collection with same fields point to the same object reference.
       * If the different state collections provided have different sizes we need to get the largest one.
       * That way we can get the state reference from the largest one that has the same fieldName as the expression to prepare.
       */
      let maxCollection = stateCollections[0];
      for (let i = 1; i < stateCollections.length; i++) {
        if (maxCollection.length < stateCollections[i].length) {
          maxCollection = stateCollections[i];
        }
      }
      const maxExpr = maxCollection.find(expr => expr.fieldName === expression.fieldName);
      stateCollections.forEach(collection => {
        const myExpr = collection.find(expr => expr.fieldName === expression.fieldName);
        if (!myExpr && !maxExpr) {
          // Expression with this fieldName is missing from the current and the max collection.
          collection.push(expression);
        } else if (!myExpr && maxExpr) {
          // Expression with this fieldName is missing from the current and but the max collection has.
          collection.push(maxExpr);
          Object.assign(maxExpr, expression);
        } else {
          // The current collection has the expression so just update it.
          Object.assign(myExpr, expression);
        }
      });
    }
    prepare_grouping_expression(stateCollections, expression) {
      if (expression.dir === SortingDirection.None) {
        stateCollections.forEach(state => {
          state.splice(state.findIndex(expr => expr.fieldName === expression.fieldName), 1);
        });
        return;
      }
      /**
       * We need to make sure the states in each collection with same fields point to the same object reference.
       * If the different state collections provided have different sizes we need to get the largest one.
       * That way we can get the state reference from the largest one that has the same fieldName as the expression to prepare.
       */
      let maxCollection = stateCollections[0];
      for (let i = 1; i < stateCollections.length; i++) {
        if (maxCollection.length < stateCollections[i].length) {
          maxCollection = stateCollections[i];
        }
      }
      const maxExpr = maxCollection.find(expr => expr.fieldName === expression.fieldName);
      stateCollections.forEach(collection => {
        const myExpr = collection.find(expr => expr.fieldName === expression.fieldName);
        if (!myExpr && !maxExpr) {
          // Expression with this fieldName is missing from the current and the max collection.
          collection.push(expression);
        } else if (!myExpr && maxExpr) {
          // Expression with this fieldName is missing from the current and but the max collection has.
          collection.push(maxExpr);
          Object.assign(maxExpr, expression);
        } else {
          // The current collection has the expression so just update it.
          Object.assign(myExpr, expression);
        }
      });
    }
    remove_grouping_expression(_fieldName) {}
    filterDataByExpressions(expressionsTree) {
      let data = this.get_all_data();
      if (expressionsTree.filteringOperands.length) {
        const state = {
          expressionsTree,
          strategy: this.grid.filterStrategy
        };
        data = FilterUtil.filter(cloneArray(data), state, this.grid);
      }
      return data;
    }
    sortDataByExpressions(data, expressions) {
      return DataUtil.sort(cloneArray(data), expressions, this.grid.sortStrategy, this.grid);
    }
    pin_row(rowID, index, row) {
      const grid = this.grid;
      if (grid._pinnedRecordIDs.indexOf(rowID) !== -1) {
        return;
      }
      const eventArgs = this.get_pin_row_event_args(rowID, index, row, true);
      grid.rowPinning.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      const insertIndex = typeof eventArgs.insertAtIndex === 'number' ? eventArgs.insertAtIndex : grid._pinnedRecordIDs.length;
      grid._pinnedRecordIDs.splice(insertIndex, 0, rowID);
    }
    unpin_row(rowID, row) {
      const grid = this.grid;
      const index = grid._pinnedRecordIDs.indexOf(rowID);
      if (index === -1) {
        return;
      }
      const eventArgs = this.get_pin_row_event_args(rowID, null, row, false);
      grid.rowPinning.emit(eventArgs);
      if (eventArgs.cancel) {
        return;
      }
      grid._pinnedRecordIDs.splice(index, 1);
    }
    get_pin_row_event_args(rowID, index, row, pinned) {
      const eventArgs = {
        isPinned: pinned ? true : false,
        rowKey: rowID,
        rowID,
        row,
        cancel: false
      };
      if (typeof index === 'number') {
        eventArgs.insertAtIndex = index <= this.grid.pinnedRecords.length ? index : this.grid.pinnedRecords.length;
      }
      return eventArgs;
    }
    /**
     * Updates related row of provided grid's data source with provided new row value
     *
     * @param grid Grid to update data for
     * @param rowID ID of the row to update
     * @param rowValueInDataSource Initial value of the row as it is in data source
     * @param rowCurrentValue Current value of the row as it is with applied previous transactions
     * @param rowNewValue New value of the row
     */
    updateData(grid, rowID, rowValueInDataSource, rowCurrentValue, rowNewValue) {
      if (grid.transactions.enabled) {
        const transaction = {
          id: rowID,
          type: TransactionType.UPDATE,
          newValue: rowNewValue
        };
        grid.transactions.add(transaction, rowCurrentValue);
      } else {
        mergeObjects(rowValueInDataSource, rowNewValue);
      }
    }
    update_row_in_array(value, rowID, index) {
      const grid = this.grid;
      grid.data[index] = value;
    }
    getSortStrategyPerColumn(fieldName) {
      return this.get_column_by_name(fieldName) ? this.get_column_by_name(fieldName).sortStrategy : undefined;
    }
    static {
      this.ɵfac = function GridBaseAPIService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GridBaseAPIService)(i0.ɵɵinject(IgxGridCRUDService), i0.ɵɵinject(IgxColumnMovingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GridBaseAPIService,
        factory: GridBaseAPIService.ɵfac
      });
    }
  }
  return GridBaseAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridAPIService = /*#__PURE__*/(() => {
  class IgxGridAPIService extends GridBaseAPIService {
    groupBy(expression) {
      const groupingState = cloneArray(this.grid.groupingExpressions);
      this.prepare_grouping_expression([groupingState], expression);
      this.grid.groupingExpressions = groupingState;
      this.arrange_sorting_expressions();
    }
    groupBy_multiple(expressions) {
      const groupingState = cloneArray(this.grid.groupingExpressions);
      for (const each of expressions) {
        this.prepare_grouping_expression([groupingState], each);
      }
      this.grid.groupingExpressions = groupingState;
      this.arrange_sorting_expressions();
    }
    clear_groupby(name) {
      const groupingState = cloneArray(this.grid.groupingExpressions);
      if (name) {
        const names = typeof name === 'string' ? [name] : name;
        const groupedCols = groupingState.filter(state => names.indexOf(state.fieldName) < 0);
        this.grid.groupingExpressions = groupedCols;
        names.forEach(colName => {
          const grExprIndex = groupingState.findIndex(exp => exp.fieldName === colName);
          const grpExpandState = this.grid.groupingExpansionState;
          /* remove expansion states related to the cleared group
             and all with deeper hierarchy than the cleared group */
          const newExpandState = grpExpandState.filter(val => val.hierarchy && val.hierarchy.length <= grExprIndex);
          /* Do not set the new instance produced by filter
              when there are no differences between expansion states */
          if (newExpandState.length !== grpExpandState.length) {
            this.grid.groupingExpansionState = newExpandState;
          }
        });
      } else {
        // clear all
        this.grid.groupingExpressions = [];
        this.grid.groupingExpansionState = [];
      }
    }
    groupBy_get_expanded_for_group(groupRow) {
      const grState = this.grid.groupingExpansionState;
      const hierarchy = DataUtil.getHierarchy(groupRow);
      return grState.find(state => DataUtil.isHierarchyMatch(state.hierarchy || [{
        fieldName: groupRow.expression.fieldName,
        value: groupRow.value
      }], hierarchy, this.grid.groupingExpressions));
    }
    groupBy_is_row_in_group(groupRow, rowID) {
      const grid = this.grid;
      let rowInGroup = false;
      groupRow.records.forEach(row => {
        if (grid.primaryKey ? row[grid.primaryKey] === rowID : row === rowID) {
          rowInGroup = true;
        }
      });
      return rowInGroup;
    }
    groupBy_toggle_group(groupRow) {
      const grid = this.grid;
      if (grid.gridAPI.crudService.cellInEditMode) {
        this.crudService.endEdit(false);
      }
      const expansionState = grid.groupingExpansionState;
      const state = this.groupBy_get_expanded_for_group(groupRow);
      if (state) {
        state.expanded = !state.expanded;
      } else {
        expansionState.push({
          expanded: !grid.groupsExpanded,
          hierarchy: DataUtil.getHierarchy(groupRow)
        });
      }
      this.grid.groupingExpansionState = [...expansionState];
      if (grid.rowEditable) {
        grid.repositionRowEditingOverlay(grid.gridAPI.crudService.rowInEditMode);
      }
    }
    set_grouprow_expansion_state(groupRow, value) {
      if (this.grid.isExpandedGroup(groupRow) !== value) {
        this.groupBy_toggle_group(groupRow);
      }
    }
    groupBy_fully_expand_group(groupRow) {
      const state = this.groupBy_get_expanded_for_group(groupRow);
      const expanded = state ? state.expanded : this.grid.groupsExpanded;
      if (!expanded) {
        this.groupBy_toggle_group(groupRow);
      }
      if (groupRow.groupParent) {
        this.groupBy_fully_expand_group(groupRow.groupParent);
      }
    }
    groupBy_select_all_rows_in_group(groupRow, clearPrevSelection) {
      this.grid.selectionService.selectRowsWithNoEvent(this.grid.primaryKey ? groupRow.records.map(x => x[this.grid.primaryKey]) : groupRow.records, clearPrevSelection);
    }
    groupBy_deselect_all_rows_in_group(groupRow) {
      this.grid.selectionService.deselectRowsWithNoEvent(this.grid.primaryKey ? groupRow.records.map(x => x[this.grid.primaryKey]) : groupRow.records);
    }
    arrange_sorting_expressions() {
      const groupingState = this.grid.groupingExpressions;
      const sortingState = cloneArray(this.grid.sortingExpressions);
      for (const grExpr of groupingState) {
        const sortExprIndex = sortingState.findIndex(exp => exp.fieldName === grExpr.fieldName);
        if (sortExprIndex > -1) {
          sortingState.splice(sortExprIndex, 1);
        }
      }
      this.grid.sortingExpressions = sortingState;
    }
    get_groupBy_record_id(gRow) {
      let recordId = '{ ';
      const hierrarchy = DataUtil.getHierarchy(gRow);
      for (let i = 0; i < hierrarchy.length; i++) {
        const groupByKey = hierrarchy[i];
        recordId += `'${groupByKey.fieldName}': '${groupByKey.value}'`;
        if (i < hierrarchy.length - 1) {
          recordId += ', ';
        }
      }
      recordId += ' }';
      return recordId;
    }
    remove_grouping_expression(fieldName) {
      const groupingExpressions = this.grid.groupingExpressions;
      const index = groupingExpressions.findIndex(expr => expr.fieldName === fieldName);
      if (index !== -1) {
        groupingExpressions.splice(index, 1);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridAPIService_BaseFactory;
        return function IgxGridAPIService_Factory(__ngFactoryType__) {
          return (ɵIgxGridAPIService_BaseFactory || (ɵIgxGridAPIService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridAPIService)))(__ngFactoryType__ || IgxGridAPIService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridAPIService,
        factory: IgxGridAPIService.ɵfac
      });
    }
  }
  return IgxGridAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridGroupByRowComponent = /*#__PURE__*/(() => {
  class IgxGridGroupByRowComponent {
    /**
     * Returns whether the row is focused.
     * ```
     * let gridRowFocused = this.grid1.rowList.first.focused;
     * ```
     */
    get focused() {
      return this.isActive();
    }
    /** @hidden @internal */
    get currencyCode() {
      return this.groupRow.column.pipeArgs.currencyCode ? this.groupRow.column.pipeArgs.currencyCode : getLocaleCurrencyCode(this.grid.locale);
    }
    constructor(grid, gridSelection, element, cdr, filteringService) {
      this.grid = grid;
      this.gridSelection = gridSelection;
      this.element = element;
      this.cdr = cdr;
      this.filteringService = filteringService;
      /**
       * @hidden
       */
      this.isFocused = false;
      /**
       * @hidden
       */
      this.destroy$ = new Subject();
      /**
       * @hidden
       */
      this.defaultCssClass = 'igx-grid__group-row';
      /**
       * @hidden
       */
      this.paddingIndentationCssClass = 'igx-grid__group-row--padding-level';
      this.gridSelection.selectedRowsChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.cdr.markForCheck();
      });
    }
    activate() {
      this.grid.navigation.setActiveNode({
        row: this.index
      });
    }
    onClick(event) {
      this.grid.rowClick.emit({
        row: this.grid.createRow(this.index),
        event
      });
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Returns whether the group row is expanded.
     * ```typescript
     * const groupRowExpanded = this.grid1.rowList.first.expanded;
     * ```
     */
    get expanded() {
      return this.grid.isExpandedGroup(this.groupRow);
    }
    /**
     * @hidden
     */
    get describedBy() {
      const grRowExpr = this.groupRow.expression !== undefined ? this.groupRow.expression.fieldName : '';
      return this.gridID + '_' + grRowExpr;
    }
    get dataRowIndex() {
      return this.index;
    }
    /**
     * Returns a reference to the underlying HTML element.
     * ```typescript
     * const groupRowElement = this.nativeElement;
     * ```
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    get attrCellID() {
      return `${this.gridID}_${this.index}`;
    }
    /**
     * Returns the style classes applied to the group rows.
     * ```typescript
     * const groupCssStyles = this.grid1.rowList.first.styleClasses;
     * ```
     */
    get styleClasses() {
      return `${this.defaultCssClass} ` + `${this.paddingIndentationCssClass}-` + this.groupRow.level + (this.isActive() ? ` ${this.defaultCssClass}--active` : '');
    }
    isActive() {
      return this.grid.navigation.activeNode ? this.grid.navigation.activeNode.row === this.index : false;
    }
    /**
     * @hidden @internal
     */
    getRowID(rowData) {
      return this.grid.primaryKey ? rowData[this.grid.primaryKey] : rowData;
    }
    /**
     * @hidden @internal
     */
    onGroupSelectorClick(event) {
      if (!this.grid.isMultiRowSelectionEnabled) {
        return;
      }
      event.stopPropagation();
      if (this.areAllRowsInTheGroupSelected) {
        this.gridSelection.deselectRows(this.groupRow.records.map(x => this.getRowID(x)));
      } else {
        this.gridSelection.selectRows(this.groupRow.records.map(x => this.getRowID(x)));
      }
    }
    /**
     * Toggles the group row.
     * ```typescript
     * this.grid1.rowList.first.toggle()
     * ```
     */
    toggle() {
      this.grid.toggleGroup(this.groupRow);
    }
    get iconTemplate() {
      if (this.expanded) {
        return this.grid.rowExpandedIndicatorTemplate || this.defaultGroupByExpandedTemplate;
      } else {
        return this.grid.rowCollapsedIndicatorTemplate || this.defaultGroupByCollapsedTemplate;
      }
    }
    get selectionNode() {
      return {
        row: this.index,
        column: this.gridSelection.activeElement ? this.gridSelection.activeElement.column : 0
      };
    }
    /**
     * @hidden @internal
    */
    get dataType() {
      const column = this.groupRow.column;
      return column && column.dataType || GridColumnDataType.String;
    }
    /**
     * @hidden @internal
     */
    get formatter() {
      const column = this.groupRow.column;
      return column && column.formatter || null;
    }
    /**
     * @hidden @internal
     */
    get areAllRowsInTheGroupSelected() {
      return this.groupRow.records.every(x => this.gridSelection.isRowSelected(this.getRowID(x)));
    }
    /**
     * @hidden @internal
     */
    get selectedRowsInTheGroup() {
      const selectedIds = new Set(this.gridSelection.filteredSelectedRowIds);
      return this.groupRow.records.filter(rowID => selectedIds.has(this.getRowID(rowID)));
    }
    /**
     * @hidden @internal
     */
    get groupByRowCheckboxIndeterminateState() {
      if (this.selectedRowsInTheGroup.length > 0) {
        return !this.areAllRowsInTheGroupSelected;
      }
      return false;
    }
    /**
     * @hidden @internal
     */
    get groupByRowSelectorBaseAriaLabel() {
      const ariaLabel = this.areAllRowsInTheGroupSelected ? this.grid.resourceStrings.igx_grid_groupByArea_deselect_message : this.grid.resourceStrings.igx_grid_groupByArea_select_message;
      return ariaLabel.replace('{0}', this.groupRow.expression.fieldName).replace('{1}', this.groupRow.value);
    }
    /**
     * @hidden @internal
     */
    get showRowSelectors() {
      return this.grid.rowSelection !== GridSelectionMode.none && !this.hideGroupRowSelectors;
    }
    static {
      this.ɵfac = function IgxGridGroupByRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridGroupByRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxFilteringService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridGroupByRowComponent,
        selectors: [["igx-grid-groupby-row"]],
        viewQuery: function IgxGridGroupByRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c209, 7);
            i0.ɵɵviewQuery(_c210, 7, TemplateRef);
            i0.ɵɵviewQuery(_c211, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultGroupByExpandedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultGroupByCollapsedTemplate = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function IgxGridGroupByRowComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerdown", function IgxGridGroupByRowComponent_pointerdown_HostBindingHandler() {
              return ctx.activate();
            })("click", function IgxGridGroupByRowComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-expanded", ctx.expanded)("aria-describedby", ctx.describedBy)("data-rowIndex", ctx.dataRowIndex)("id", ctx.attrCellID);
            i0.ɵɵclassMap(ctx.styleClasses);
          }
        },
        inputs: {
          hideGroupRowSelectors: "hideGroupRowSelectors",
          rowDraggable: "rowDraggable",
          index: "index",
          gridID: "gridID",
          groupRow: "groupRow",
          isFocused: "isFocused"
        },
        decls: 17,
        vars: 10,
        consts: [["defaultGroupRow", ""], ["groupContent", ""], ["defaultGroupByExpandedTemplate", ""], ["defaultGroupByCollapsedTemplate", ""], ["defaultGroupByTemplate", ""], ["groupByRowSelectorBaseTemplate", ""], ["groupByRowSelector", ""], ["groupByRowCheckbox", ""], [1, "igx-grid__drag-indicator", "igx-grid__tr-action"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action"], [1, "igx-grid__grouping-indicator", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__group-content"], ["family", "default", "name", "drag_indicator"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "pointerdown", "click"], ["family", "default", "name", "tree_collapse"], ["family", "default", "name", "tree_expand"], [1, "igx-group-label"], ["family", "default", "name", "group_work", 1, "igx-group-label__icon"], [1, "igx-group-label__column-name"], [1, "igx-group-label__text"], [1, "igx-group-label__count-badge", 3, "value"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "readonly", "checked", "disableRipple", "indeterminate", "disabled", "aria-label"]],
        template: function IgxGridGroupByRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementContainerStart(0, null, 0);
            i0.ɵɵtemplate(2, IgxGridGroupByRowComponent_Conditional_2_Template, 2, 2, "div", 8)(3, IgxGridGroupByRowComponent_Conditional_3_Template, 2, 8, "div", 9);
            i0.ɵɵelementStart(4, "div", 10);
            i0.ɵɵlistener("click", function IgxGridGroupByRowComponent_Template_div_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggle());
            });
            i0.ɵɵtemplate(5, IgxGridGroupByRowComponent_ng_container_5_Template, 1, 0, "ng-container", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 12, 1);
            i0.ɵɵtemplate(8, IgxGridGroupByRowComponent_ng_container_8_Template, 1, 0, "ng-container", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, IgxGridGroupByRowComponent_ng_template_9_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(11, IgxGridGroupByRowComponent_ng_template_11_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(13, IgxGridGroupByRowComponent_ng_template_13_Template, 12, 33, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(15, IgxGridGroupByRowComponent_ng_template_15_Template, 3, 7, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            const defaultGroupByTemplate_r5 = i0.ɵɵreference(14);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.rowDraggable ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showRowSelectors ? 3 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c25, ctx));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.grid.groupRowTemplate ? ctx.grid.groupRowTemplate : defaultGroupByTemplate_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c25, ctx.groupRow));
          }
        },
        dependencies: [NgTemplateOutlet, DecimalPipe, DatePipe, PercentPipe, CurrencyPipe, IgxIconComponent, IgxBadgeComponent, IgxCheckboxComponent, IgxColumnFormatterPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridGroupByRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxGridMRLNavigationService = /*#__PURE__*/(() => {
  class IgxGridMRLNavigationService extends IgxGridNavigationService {
    isValidPosition(rowIndex, colIndex) {
      if (rowIndex < 0 || colIndex < 0 || this.grid.dataView.length - 1 < rowIndex || Math.max(...this.grid.visibleColumns.map(col => col.visibleIndex)) < colIndex || this.activeNode.column !== colIndex && !this.isDataRow(rowIndex, true)) {
        return false;
      }
      return true;
    }
    shouldPerformVerticalScroll(targetRowIndex, visibleColIndex) {
      if (!super.shouldPerformVerticalScroll(targetRowIndex, visibleColIndex)) {
        return false;
      }
      if (!this.isDataRow(targetRowIndex) || visibleColIndex < 0) {
        return super.shouldPerformVerticalScroll(targetRowIndex, visibleColIndex);
      }
      const targetRow = super.getRowElementByIndex(targetRowIndex);
      const containerHeight = this.grid.calcHeight ? Math.ceil(this.grid.calcHeight) : 0;
      const scrollPos = this.getVerticalScrollPositions(targetRowIndex, visibleColIndex);
      return !targetRow || targetRow.offsetTop + scrollPos.topOffset < Math.abs(this.containerTopOffset) || containerHeight && containerHeight < scrollPos.rowBottom - Math.ceil(this.scrollTop);
    }
    isColumnFullyVisible(visibleColIndex) {
      const targetCol = this.grid.getColumnByVisibleIndex(visibleColIndex);
      if (this.isParentColumnFullyVisible(targetCol?.parent) || super.isColumnPinned(visibleColIndex, this.forOfDir())) {
        return true;
      }
      const scrollPos = this.getChildColumnScrollPositions(visibleColIndex);
      const colWidth = scrollPos.rightScroll - scrollPos.leftScroll;
      if (this.displayContainerWidth < colWidth && this.displayContainerScrollLeft === scrollPos.leftScroll) {
        return true;
      }
      return this.displayContainerWidth >= scrollPos.rightScroll - this.displayContainerScrollLeft && this.displayContainerScrollLeft <= scrollPos.leftScroll;
    }
    getVerticalScrollPositions(rowIndex, visibleIndex) {
      const targetCol = this.grid.getColumnByVisibleIndex(visibleIndex);
      const rowSpan = targetCol.rowEnd && targetCol.rowEnd - targetCol.rowStart ? targetCol.rowEnd - targetCol.rowStart : 1;
      const topOffset = this.grid.defaultRowHeight * (targetCol.rowStart - 1);
      const rowTop = this.grid.verticalScrollContainer.sizesCache[rowIndex] + topOffset;
      return {
        topOffset,
        rowTop,
        rowBottom: rowTop + this.grid.defaultRowHeight * rowSpan
      };
    }
    performHorizontalScrollToCell(visibleColumnIndex, cb) {
      if (!this.shouldPerformHorizontalScroll(visibleColumnIndex)) {
        return;
      }
      const scrollPos = this.getChildColumnScrollPositions(visibleColumnIndex);
      const startScroll = scrollPos.rightScroll - this.displayContainerScrollLeft;
      const nextScroll = !(this.displayContainerScrollLeft <= scrollPos.leftScroll) && this.displayContainerWidth >= startScroll ? scrollPos.leftScroll : scrollPos.rightScroll - this.displayContainerWidth;
      this.forOfDir().getScroll().scrollLeft = nextScroll;
      this.grid.parentVirtDir.chunkLoad.pipe(first$2()).subscribe(() => {
        if (cb) {
          cb();
        }
      });
    }
    performVerticalScrollToCell(rowIndex, visibleColIndex, cb) {
      const children = this.parentByChildIndex(visibleColIndex || 0)?.children;
      if (!super.isDataRow(rowIndex) || children && children.length < 2 || visibleColIndex < 0) {
        return super.performVerticalScrollToCell(rowIndex, visibleColIndex, cb);
      }
      const containerHeight = this.grid.calcHeight ? Math.ceil(this.grid.calcHeight) : 0;
      const pos = this.getVerticalScrollPositions(rowIndex, visibleColIndex);
      const row = super.getRowElementByIndex(rowIndex);
      if (this.scrollTop > pos.rowTop && (!row || row.offsetTop + pos.topOffset < Math.abs(this.containerTopOffset))) {
        if (pos.topOffset === 0) {
          this.grid.verticalScrollContainer.scrollTo(rowIndex);
        } else {
          this.grid.verticalScrollContainer.scrollPosition = pos.rowTop;
        }
      } else {
        this.grid.verticalScrollContainer.addScrollTop(Math.abs(pos.rowBottom - this.scrollTop - containerHeight));
      }
      this.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
        if (cb) {
          cb();
        }
      });
    }
    getNextHorizontalCellPosition(previous = false) {
      const parent = this.parentByChildIndex(this.activeNode.column);
      if (!this.hasNextHorizontalPosition(previous, parent)) {
        return {
          row: this.activeNode.row,
          column: this.activeNode.column
        };
      }
      const columns = previous ? parent.children.filter(c => c.rowStart <= this.activeNode.layout.rowStart).sort((a, b) => b.visibleIndex - a.visibleIndex) : parent.children.filter(c => c.rowStart <= this.activeNode.layout.rowStart);
      let column = columns.find(col => previous ? col.visibleIndex < this.activeNode.column && this.rowEnd(col) > this.activeNode.layout.rowStart : col.visibleIndex > this.activeNode.column && col.colStart > this.activeNode.layout.colStart);
      if (!column || previous && this.activeNode.layout.colStart === 1) {
        const index = previous ? parent.visibleIndex - 1 : parent.visibleIndex + 1;
        const children = this.grid.columns.find(cols => cols.columnLayout && cols.visibleIndex === index).children;
        column = previous ? children.toArray().reverse().find(child => child.rowStart <= this.activeNode.layout.rowStart) : children.find(child => this.rowEnd(child) > this.activeNode.layout.rowStart && child.colStart === 1);
      }
      return {
        row: this.activeNode.row,
        column: column.visibleIndex
      };
    }
    getNextVerticalPosition(previous = false) {
      this.activeNode.column = this.activeNode.column || 0;
      if (!this.hasNextVerticalPosition(previous)) {
        return {
          row: this.activeNode.row,
          column: this.activeNode.column
        };
      }
      const currentRowStart = this.grid.getColumnByVisibleIndex(this.activeNode.column).rowStart;
      const nextBlock = !this.isDataRow(this.activeNode.row) || (previous ? currentRowStart === 1 : currentRowStart === this.lastRowStartPerBlock());
      const nextRI = previous ? this.activeNode.row - 1 : this.activeNode.row + 1;
      if (nextBlock && !this.isDataRow(nextRI)) {
        return {
          row: nextRI,
          column: this.activeNode.column
        };
      }
      const children = this.parentByChildIndex(this.activeNode.column).children;
      const col = previous ? this.getPreviousRowIndex(children, nextBlock) : this.getNextRowIndex(children, nextBlock);
      return {
        row: nextBlock ? nextRI : this.activeNode.row,
        column: col.visibleIndex
      };
    }
    headerNavigation(event) {
      const key = event.key.toLowerCase();
      if (!HEADER_KEYS.has(key)) {
        return;
      }
      event.preventDefault();
      if (!this.activeNode.layout) {
        this.activeNode.layout = this.layout(this.activeNode.column || 0);
      }
      const alt = event.altKey;
      const ctrl = event.ctrlKey;
      this.performHeaderKeyCombination(this.grid.getColumnByVisibleIndex(this.activeNode.column), key, event.shiftKey, ctrl, alt, event);
      if (!ctrl && !alt && (key.includes('down') || key.includes('up'))) {
        const children = this.parentByChildIndex(this.activeNode.column).children;
        const col = key.includes('down') ? this.getNextRowIndex(children, false) : this.getPreviousRowIndex(children, false);
        if (!col) {
          return;
        }
        this.activeNode.column = col.visibleIndex;
        const layout = this.layout(this.activeNode.column);
        const nextLayout = {
          ...this.activeNode.layout,
          rowStart: layout.rowStart,
          rowEnd: layout.rowEnd
        };
        this.setActiveNode({
          row: this.activeNode.row,
          layout: nextLayout
        });
        return;
      }
      this.horizontalNav(event, key, -1, 'headerCell');
    }
    /**
     * @hidden
     * @internal
     */
    layout(visibleIndex) {
      const column = this.grid.getColumnByVisibleIndex(visibleIndex);
      return {
        colStart: column.colStart,
        rowStart: column.rowStart,
        colEnd: column.colEnd,
        rowEnd: column.rowEnd,
        columnVisibleIndex: column.visibleIndex
      };
    }
    getNextPosition(rowIndex, colIndex, key, shift, ctrl, event) {
      if (!this.activeNode.layout) {
        this.activeNode.layout = this.layout(this.activeNode.column || 0);
      }
      switch (key) {
        case 'tab':
        case ' ':
        case 'spacebar':
        case 'space':
        case 'escape':
        case 'esc':
        case 'enter':
        case 'f2':
          super.getNextPosition(rowIndex, colIndex, key, shift, ctrl, event);
          break;
        case 'end':
          rowIndex = ctrl ? this.findLastDataRowIndex() : this.activeNode.row;
          colIndex = ctrl ? this.lastColIndexPerMRLBlock(this.lastIndexPerRow) : this.lastIndexPerRow;
          break;
        case 'home':
          rowIndex = ctrl ? this.findFirstDataRowIndex() : this.activeNode.row;
          colIndex = ctrl ? 0 : this.firstIndexPerRow;
          break;
        case 'arrowleft':
        case 'left':
          colIndex = ctrl ? this.firstIndexPerRow : this.getNextHorizontalCellPosition(true).column;
          break;
        case 'arrowright':
        case 'right':
          colIndex = ctrl ? this.lastIndexPerRow : this.getNextHorizontalCellPosition().column;
          break;
        case 'arrowup':
        case 'up':
          const prevPos = this.getNextVerticalPosition(true);
          colIndex = ctrl ? this.activeNode.column : prevPos.column;
          rowIndex = ctrl ? this.findFirstDataRowIndex() : prevPos.row;
          break;
        case 'arrowdown':
        case 'down':
          const nextPos = this.getNextVerticalPosition();
          colIndex = ctrl ? this.activeNode.column : nextPos.column;
          rowIndex = ctrl ? this.findLastDataRowIndex() : nextPos.row;
          break;
        default:
          return;
      }
      const nextLayout = this.layout(colIndex);
      const newLayout = key.includes('up') || key.includes('down') ? {
        rowStart: nextLayout.rowStart
      } : {
        colStart: nextLayout.colStart
      };
      Object.assign(this.activeNode.layout, newLayout, {
        rowEnd: nextLayout.rowEnd
      });
      if (ctrl && (key === 'home' || key === 'end')) {
        this.activeNode.layout = nextLayout;
      }
      return {
        rowIndex,
        colIndex
      };
    }
    horizontalNav(event, key, rowIndex, tag) {
      const ctrl = event.ctrlKey;
      if (!HORIZONTAL_NAV_KEYS.has(key) || event.altKey) {
        return;
      }
      this.activeNode.row = rowIndex;
      const newActiveNode = {
        column: this.activeNode.column,
        mchCache: {
          level: this.activeNode.level,
          visibleIndex: this.activeNode.column
        }
      };
      if ((key.includes('left') || key === 'home') && this.activeNode.column > 0) {
        newActiveNode.column = ctrl || key === 'home' ? this.firstIndexPerRow : this.getNextHorizontalCellPosition(true).column;
      }
      if ((key.includes('right') || key === 'end') && this.activeNode.column !== this.lastIndexPerRow) {
        newActiveNode.column = ctrl || key === 'end' ? this.lastIndexPerRow : this.getNextHorizontalCellPosition().column;
      }
      if (tag === 'headerCell') {
        const column = this.grid.getColumnByVisibleIndex(newActiveNode.column);
        newActiveNode.mchCache.level = column.level;
        newActiveNode.mchCache.visibleIndex = column.visibleIndex;
      }
      const layout = this.layout(newActiveNode.column);
      const newLayout = {
        ...this.activeNode.layout,
        colStart: layout.colStart,
        rowEnd: layout.rowEnd
      };
      this.setActiveNode({
        row: this.activeNode.row,
        column: newActiveNode.column,
        layout: newLayout,
        mchCache: newActiveNode.mchCache
      });
      this.performHorizontalScrollToCell(newActiveNode.column);
    }
    isParentColumnFullyVisible(parent) {
      if (!this.forOfDir().getScroll().clientWidth || parent?.pinned) {
        return true;
      }
      const index = this.forOfDir().igxForOf.indexOf(parent);
      return this.displayContainerWidth >= this.forOfDir().getColumnScrollLeft(index + 1) - this.displayContainerScrollLeft && this.displayContainerScrollLeft <= this.forOfDir().getColumnScrollLeft(index);
    }
    getChildColumnScrollPositions(visibleColIndex) {
      const targetCol = this.grid.getColumnByVisibleIndex(visibleColIndex);
      const parentVIndex = this.forOfDir().igxForOf.indexOf(targetCol.parent);
      let leftScroll = this.forOfDir().getColumnScrollLeft(parentVIndex);
      let rightScroll = this.forOfDir().getColumnScrollLeft(parentVIndex + 1);
      targetCol.parent.children.forEach(c => {
        if (c.rowStart >= targetCol.rowStart && c.visibleIndex < targetCol.visibleIndex) {
          leftScroll += parseInt(c.width, 10);
        }
        if (c.rowStart <= targetCol.rowStart && c.visibleIndex > targetCol.visibleIndex) {
          rightScroll -= parseInt(c.width, 10);
        }
      });
      return {
        leftScroll,
        rightScroll
      };
    }
    getNextRowIndex(children, next) {
      const rowStart = next ? 1 : this.rowEnd(this.grid.getColumnByVisibleIndex(this.activeNode.column));
      const col = children.filter(c => c.rowStart === rowStart);
      return col.find(co => co.colStart === this.activeNode.layout.colStart) || col.sort((a, b) => b.visibleIndex - a.visibleIndex).find(co => co.colStart <= this.activeNode.layout.colStart);
    }
    getPreviousRowIndex(children, prev) {
      const end = prev ? Math.max(...children.map(c => this.rowEnd(c))) : this.grid.getColumnByVisibleIndex(this.activeNode.column).rowStart;
      const col = children.filter(c => this.rowEnd(c) === end);
      return col.find(co => co.colStart === this.activeNode.layout.colStart) || col.sort((a, b) => b.visibleIndex - a.visibleIndex).find(co => co.colStart <= this.activeNode.layout.colStart);
    }
    get lastIndexPerRow() {
      const children = this.grid.visibleColumns.find(c => c.visibleIndex === this.lastLayoutIndex && c.columnLayout).children.toArray().reverse();
      const column = children.find(co => co.rowStart === this.activeNode.layout.rowStart) || children.find(co => co.rowStart <= this.activeNode.layout.rowStart);
      return column.visibleIndex;
    }
    get firstIndexPerRow() {
      const children = this.grid.visibleColumns.find(c => c.visibleIndex === 0 && c.columnLayout).children;
      const column = children.find(co => co.rowStart === this.activeNode.layout.rowStart) || children.find(co => co.rowStart <= this.activeNode.layout.rowStart);
      return column.visibleIndex;
    }
    get lastLayoutIndex() {
      return Math.max(...this.grid.visibleColumns.filter(c => c.columnLayout).map(col => col.visibleIndex));
    }
    get scrollTop() {
      return Math.abs(this.grid.verticalScrollContainer.getScroll().scrollTop);
    }
    lastColIndexPerMRLBlock(visibleIndex = this.activeNode.column) {
      return this.parentByChildIndex(visibleIndex).children.last.visibleIndex;
    }
    lastRowStartPerBlock(visibleIndex = this.activeNode.column) {
      return Math.max(...this.parentByChildIndex(visibleIndex).children.map(c => c.rowStart));
    }
    rowEnd(column) {
      return column.rowEnd && column.rowEnd - column.rowStart ? column.rowStart + column.rowEnd - column.rowStart : column.rowStart + 1;
    }
    parentByChildIndex(visibleIndex) {
      return this.grid.getColumnByVisibleIndex(visibleIndex)?.parent;
    }
    hasNextHorizontalPosition(previous = false, parent) {
      if (previous && parent.visibleIndex === 0 && this.activeNode.layout.colStart === 1 || !previous && parent.visibleIndex === this.lastLayoutIndex && this.activeNode.column === this.lastIndexPerRow) {
        return false;
      }
      return true;
    }
    hasNextVerticalPosition(prev = false) {
      if (prev && this.activeNode.row === 0 && (!this.isDataRow(this.activeNode.row) || this.activeNode.layout.rowStart === 1) || !prev && this.activeNode.row >= this.grid.dataView.length - 1 && this.activeNode.column === this.lastColIndexPerMRLBlock()) {
        return false;
      }
      return true;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridMRLNavigationService_BaseFactory;
        return function IgxGridMRLNavigationService_Factory(__ngFactoryType__) {
          return (ɵIgxGridMRLNavigationService_BaseFactory || (ɵIgxGridMRLNavigationService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridMRLNavigationService)))(__ngFactoryType__ || IgxGridMRLNavigationService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxGridMRLNavigationService,
        factory: IgxGridMRLNavigationService.ɵfac
      });
    }
  }
  return IgxGridMRLNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxGridDetailsPipe = /*#__PURE__*/(() => {
  class IgxGridDetailsPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, hasDetails, expansionStates, _pipeTrigger) {
      if (!hasDetails) {
        return collection;
      }
      const res = this.addDetailRows(collection, expansionStates);
      return res;
    }
    addDetailRows(collection, _expansionStates) {
      const result = [];
      collection.forEach(v => {
        result.push(v);
        if (!this.grid.isGroupByRecord(v) && !this.grid.isSummaryRow(v) && this.grid.gridAPI.get_row_expansion_state(v)) {
          const detailsObj = {
            detailsData: v
          };
          result.push(detailsObj);
        }
      });
      return result;
    }
    static {
      this.ɵfac = function IgxGridDetailsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridDetailsPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridDetails",
        type: IgxGridDetailsPipe,
        pure: true
      });
    }
  }
  return IgxGridDetailsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxGridSummaryPipe = /*#__PURE__*/(() => {
  class IgxGridSummaryPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, hasSummary, summaryCalculationMode, summaryPosition, id, showSummary, _, __) {
      if (!collection.data || !hasSummary || summaryCalculationMode === GridSummaryCalculationMode.rootLevelOnly) {
        return collection.data;
      }
      return this.addSummaryRows(id, collection, summaryPosition, showSummary);
    }
    addSummaryRows(gridId, collection, summaryPosition, showSummary) {
      const recordsWithSummary = [];
      const lastChildMap = new Map();
      const maxSummaryHeight = this.grid.summaryService.calcMaxSummaryHeight();
      if (collection.metadata.length && !this.grid.isGroupByRecord(collection.data[0]) && this.grid.isGroupByRecord(collection.metadata[0]) && summaryPosition === GridSummaryPosition.bottom) {
        const groups = [];
        groups.push(collection.metadata[0]);
        while (groups[groups.length - 1].groupParent) {
          groups.push(groups[groups.length - 1].groupParent);
        }
        groups.reverse();
        groups.forEach(g => g.skip = true);
        collection.data.splice(0, 0, ...groups);
      }
      for (const record of collection.data) {
        let skipAdd = false;
        let recordId;
        let groupByRecord = null;
        if (this.grid.isGroupByRecord(record)) {
          skipAdd = !!record.skip;
          record.skip = null;
          groupByRecord = record;
          recordId = this.grid.gridAPI.get_groupBy_record_id(groupByRecord);
        } else {
          recordId = this.grid.gridAPI.get_row_id(record);
        }
        if (!skipAdd) {
          recordsWithSummary.push(record);
        }
        if (summaryPosition === GridSummaryPosition.bottom && showSummary && groupByRecord && !this.grid.isExpandedGroup(groupByRecord)) {
          const records = this.removeDeletedRecord(this.grid, groupByRecord.records.slice());
          const summaries = this.grid.summaryService.calculateSummaries(recordId, records);
          const summaryRecord = {
            summaries,
            max: maxSummaryHeight
          };
          recordsWithSummary.push(summaryRecord);
        }
        if (summaryPosition === GridSummaryPosition.bottom && lastChildMap.has(recordId)) {
          const groupRecords = lastChildMap.get(recordId);
          for (const groupRecord of groupRecords) {
            const groupRecordId = this.grid.gridAPI.get_groupBy_record_id(groupRecord);
            const records = this.removeDeletedRecord(this.grid, groupRecord.records.slice());
            const summaries = this.grid.summaryService.calculateSummaries(groupRecordId, records, groupRecord);
            const summaryRecord = {
              summaries,
              max: maxSummaryHeight
            };
            recordsWithSummary.push(summaryRecord);
          }
        }
        const showSummaries = showSummary ? false : groupByRecord && !this.grid.isExpandedGroup(groupByRecord);
        if (groupByRecord === null || showSummaries) {
          continue;
        }
        if (summaryPosition === GridSummaryPosition.top) {
          const records = this.removeDeletedRecord(this.grid, groupByRecord.records.slice());
          const summaries = this.grid.summaryService.calculateSummaries(recordId, records, groupByRecord);
          const summaryRecord = {
            summaries,
            max: maxSummaryHeight
          };
          recordsWithSummary.push(summaryRecord);
        } else if (summaryPosition === GridSummaryPosition.bottom) {
          let lastChild = groupByRecord;
          while (lastChild.groups && lastChild.groups.length > 0 && this.grid.isExpandedGroup(lastChild)) {
            lastChild = lastChild.groups[lastChild.groups.length - 1];
          }
          let lastChildId;
          if (this.grid.isExpandedGroup(lastChild)) {
            lastChildId = this.grid.gridAPI.get_row_id(lastChild.records[lastChild.records.length - 1]);
          } else {
            lastChildId = this.grid.gridAPI.get_groupBy_record_id(lastChild);
          }
          let groupRecords = lastChildMap.get(lastChildId);
          if (!groupRecords) {
            groupRecords = [];
            lastChildMap.set(lastChildId, groupRecords);
          }
          groupRecords.unshift(groupByRecord);
        }
      }
      return recordsWithSummary;
    }
    removeDeletedRecord(grid, data) {
      if (!grid.transactions.enabled) {
        return data;
      }
      const deletedRows = grid.transactions.getTransactionLog().filter(t => t.type === 'delete').map(t => t.id);
      deletedRows.forEach(rowID => {
        const tempData = grid.primaryKey ? data.map(rec => rec[grid.primaryKey]) : data;
        const index = tempData.indexOf(rowID);
        if (index !== -1) {
          data.splice(index, 1);
        }
      });
      return data;
    }
    static {
      this.ɵfac = function IgxGridSummaryPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridSummaryPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridSummary",
        type: IgxGridSummaryPipe,
        pure: true
      });
    }
  }
  return IgxGridSummaryPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGridSortingPipe = /*#__PURE__*/(() => {
  class IgxGridSortingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, sortExpressions, groupExpressions, sorting, id, pipeTrigger, pinned) {
      let result;
      const expressions = groupExpressions.concat(sortExpressions);
      if (!expressions.length) {
        result = collection;
      } else {
        result = DataUtil.sort(cloneArray(collection), expressions, sorting, this.grid);
      }
      this.grid.setFilteredSortedData(result, pinned);
      return result;
    }
    static {
      this.ɵfac = function IgxGridSortingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridSortingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridSort",
        type: IgxGridSortingPipe,
        pure: true
      });
    }
  }
  return IgxGridSortingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGridGroupingPipe = /*#__PURE__*/(() => {
  class IgxGridGroupingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, expression, expansion, groupingStrategy, defaultExpanded, id, groupsRecords, _pipeTrigger) {
      const state = {
        expressions: [],
        expansion: [],
        defaultExpanded
      };
      state.expressions = this.grid.groupingExpressions;
      let result;
      const fullResult = {
        data: [],
        metadata: []
      };
      if (!state.expressions.length) {
        // empty the array without changing reference
        groupsRecords.splice(0, groupsRecords.length);
        result = {
          data: collection,
          metadata: collection
        };
      } else {
        state.expansion = this.grid.groupingExpansionState;
        state.defaultExpanded = this.grid.groupsExpanded;
        result = DataUtil.group(cloneArray(collection), state, groupingStrategy, this.grid, groupsRecords, fullResult);
      }
      this.grid.groupingFlatResult = result.data;
      this.grid.groupingResult = fullResult.data;
      this.grid.groupingMetadata = fullResult.metadata;
      return result;
    }
    static {
      this.ɵfac = function IgxGridGroupingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridGroupingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridGroupBy",
        type: IgxGridGroupingPipe,
        pure: true
      });
    }
  }
  return IgxGridGroupingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGridPagingPipe = /*#__PURE__*/(() => {
  class IgxGridPagingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, enabled, page = 0, perPage = 15, _) {
      if (!enabled || this.grid.pagingMode !== GridPagingMode.Local) {
        return collection;
      }
      const state = {
        index: page,
        recordsPerPage: perPage
      };
      const total = this.grid._totalRecords >= 0 ? this.grid._totalRecords : collection.data?.length;
      DataUtil.correctPagingState(state, total);
      const result = {
        data: DataUtil.page(cloneArray(collection.data), state, total),
        metadata: DataUtil.page(cloneArray(collection.metadata), state, total)
      };
      if (this.grid.page !== state.index) {
        this.grid.page = state.index;
      }
      this.grid.pagingState = state;
      return result;
    }
    static {
      this.ɵfac = function IgxGridPagingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridPagingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridPaging",
        type: IgxGridPagingPipe,
        pure: true
      });
    }
  }
  return IgxGridPagingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGridFilteringPipe = /*#__PURE__*/(() => {
  class IgxGridFilteringPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, expressionsTree, filterStrategy, advancedExpressionsTree, id, pipeTrigger, filteringPipeTrigger, pinned) {
      const state = {
        expressionsTree,
        strategy: filterStrategy,
        advancedExpressionsTree
      };
      if (FilteringExpressionsTree.empty(state.expressionsTree) && FilteringExpressionsTree.empty(state.advancedExpressionsTree)) {
        return collection;
      }
      const result = FilterUtil.filter(cloneArray(collection), state, this.grid);
      this.grid.setFilteredData(result, pinned);
      return result;
    }
    static {
      this.ɵfac = function IgxGridFilteringPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridFilteringPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridFiltering",
        type: IgxGridFilteringPipe,
        pure: true
      });
    }
  }
  return IgxGridFilteringPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxSummaryDataPipe = /*#__PURE__*/(() => {
  class IgxSummaryDataPipe {
    constructor(grid) {
      this.grid = grid;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(id, trigger = 0) {
      const summaryService = this.grid.summaryService;
      return summaryService.calculateSummaries(summaryService.rootSummaryID, this.grid.gridAPI.get_summary_data());
    }
    static {
      this.ɵfac = function IgxSummaryDataPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSummaryDataPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxGridSummaryDataPipe",
        type: IgxSummaryDataPipe,
        pure: true
      });
    }
  }
  return IgxSummaryDataPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Providing reference to `IgxGridCellComponent`:
 * ```typescript
 * @ViewChild('grid', { read: IgxGridComponent })
 *  public grid: IgxGridComponent;
 * ```
 * ```typescript
 *  let column = this.grid.columnList.first;
 * ```
 * ```typescript
 *  let cell = column.cells[0];
 * ```
 */
let IgxGridCellComponent = /*#__PURE__*/(() => {
  class IgxGridCellComponent {
    /**
     * @hidden
     * @internal
     */
    get isEmptyAddRowCell() {
      return this.intRow.addRowUI && (this.value === undefined || this.value === null);
    }
    /**
     * @hidden
     * @internal
     */
    get formGroup() {
      return this.grid.validation.getFormGroup(this.intRow.key);
    }
    /**
     * Gets the row of the cell.
     * ```typescript
     * let cellRow = this.cell.row;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get row() {
      return this.grid.createRow(this.intRow.index);
    }
    /**
     * Gets the cell template context object.
     * ```typescript
     *  let context = this.cell.context();
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get context() {
      const getCellType = () => this.getCellType(true);
      const ctx = {
        $implicit: this.value,
        additionalTemplateContext: this.column.additionalTemplateContext,
        get cell() {
          /* Turns the `cell` property from the template context object into lazy-evaluated one.
           * Otherwise on each detection cycle the cell template is recreating N cell instances where
           * N = number of visible cells in the grid, leading to massive performance degradation in large grids.
           */
          return getCellType();
        }
      };
      if (this.editMode) {
        ctx.formControl = this.formControl;
      }
      if (this.isInvalid) {
        ctx.defaultErrorTemplate = this.defaultErrorTemplate;
      }
      return ctx;
    }
    /**
     * Gets the cell template.
     * ```typescript
     * let template = this.cell.template;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get template() {
      if (this.editMode && this.formGroup) {
        const inlineEditorTemplate = this.column.inlineEditorTemplate;
        return inlineEditorTemplate ? inlineEditorTemplate : this.inlineEditorTemplate;
      }
      if (this.cellTemplate) {
        return this.cellTemplate;
      }
      if (this.grid.rowEditable && this.intRow.addRowUI) {
        return this.addRowCellTemplate;
      }
      return this.defaultCellTemplate;
    }
    /**
     * Gets the pinned indicator template.
     * ```typescript
     * let template = this.cell.pinnedIndicatorTemplate;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get pinnedIndicatorTemplate() {
      if (this.pinnedIndicator) {
        return this.pinnedIndicator;
      }
      return this.defaultPinnedIndicator;
    }
    /**
     * Gets the `id` of the grid in which the cell is stored.
     * ```typescript
     * let gridId = this.cell.gridID;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get gridID() {
      return this.intRow.gridID;
    }
    /**
     * Gets the `index` of the row where the cell is stored.
     * ```typescript
     * let rowIndex = this.cell.rowIndex;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get rowIndex() {
      return this.intRow.index;
    }
    /**
     * Gets the `index` of the cell column.
     * ```typescript
     * let columnIndex = this.cell.columnIndex;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get columnIndex() {
      return this.column.index;
    }
    /**
     * Returns the column visible index.
     * ```typescript
     * let visibleColumnIndex = this.cell.visibleColumnIndex;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get visibleColumnIndex() {
      return this.column.columnLayoutChild ? this.column.visibleIndex : this._vIndex;
    }
    set visibleColumnIndex(val) {
      this._vIndex = val;
    }
    /**
     * Gets the ID of the cell.
     * ```typescript
     * let cellID = this.cell.cellID;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get cellID() {
      const primaryKey = this.grid.primaryKey;
      const rowID = primaryKey ? this.rowData[primaryKey] : this.rowData;
      return {
        rowID,
        columnID: this.columnIndex,
        rowIndex: this.rowIndex
      };
    }
    get attrCellID() {
      return `${this.intRow.gridID}_${this.rowIndex}_${this.visibleColumnIndex}`;
    }
    get title() {
      if (this.editMode || this.cellTemplate || this.errorShowing) {
        return '';
      }
      if (this.formatter) {
        return this.formatter(this.value, this.rowData, this.columnData);
      }
      const args = this.column.pipeArgs;
      const locale = this.grid.locale;
      switch (this.column.dataType) {
        case GridColumnDataType.Percent:
          return formatPercent(this.value, locale, args.digitsInfo);
        case GridColumnDataType.Currency:
          return formatCurrency(this.value, this.currencyCode, args.display, args.digitsInfo, locale);
        case GridColumnDataType.Date:
        case GridColumnDataType.DateTime:
        case GridColumnDataType.Time:
          return formatDate(this.value, args.format, locale, args.timezone);
      }
      return this.value;
    }
    get booleanClass() {
      return this.column.dataType === 'boolean' && this.value;
    }
    /**
     * Returns a reference to the nativeElement of the cell.
     * ```typescript
     * let cellNativeElement = this.cell.nativeElement;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /**
     * @hidden
     * @internal
     */
    get cellSelectionMode() {
      return this._cellSelection;
    }
    set cellSelectionMode(value) {
      if (this._cellSelection === value) {
        return;
      }
      this.zone.runOutsideAngular(() => {
        if (value === GridSelectionMode.multiple) {
          this.addPointerListeners(value);
        } else {
          this.removePointerListeners(this._cellSelection);
        }
      });
      this._cellSelection = value;
    }
    /**
     * @hidden
     * @internal
     */
    set lastSearchInfo(value) {
      this._lastSearchInfo = value;
      this.highlightText(this._lastSearchInfo.searchText, this._lastSearchInfo.caseSensitive, this._lastSearchInfo.exactMatch);
    }
    /**
     * Gets whether the cell is editable.
     * ```typescript
     * let isCellReadonly = this.cell.readonly;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get readonly() {
      return !this.editable;
    }
    /** @hidden @internal */
    get ariaDescribeBy() {
      let describeBy = (this.gridID + '_' + this.column.field).replace('.', '_');
      if (this.isInvalid) {
        describeBy += ' ' + this.ariaErrorMessage;
      }
      return describeBy;
    }
    /** @hidden @internal */
    get ariaErrorMessage() {
      return this.grid.id + '_' + this.column.field + '_' + this.intRow.index + '_error';
    }
    /**
     * @hidden
     * @internal
     */
    get isInvalid() {
      const isInvalid = this.formGroup?.get(this.column?.field)?.invalid && this.formGroup?.get(this.column?.field)?.touched;
      return !this.intRow.deleted && isInvalid;
    }
    /**
     * @hidden
     * @internal
     */
    get isValidAfterEdit() {
      const formControl = this.formGroup?.get(this.column?.field);
      return this.editMode && formControl && !formControl.invalid && formControl.dirty;
    }
    /**
     * Gets the formControl responsible for value changes and validation for this cell.
     */
    get formControl() {
      return this.grid.validation.getFormControl(this.intRow.key, this.column.field);
    }
    get gridRowSpan() {
      return this.column.gridRowSpan;
    }
    get gridColumnSpan() {
      return this.column.gridColumnSpan;
    }
    get rowEnd() {
      return this.column.rowEnd;
    }
    get colEnd() {
      return this.column.colEnd;
    }
    get rowStart() {
      return this.column.rowStart;
    }
    get colStart() {
      return this.column.colStart;
    }
    get ariaSelected() {
      return this.selected || this.column.selected || this.intRow.selected;
    }
    /**
     * Gets whether the cell is selected.
     * ```typescript
     * let isSelected = this.cell.selected;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get selected() {
      return this.selectionService.selected(this.selectionNode);
    }
    /**
     * Selects/deselects the cell.
     * ```typescript
     * this.cell.selected = true.
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    set selected(val) {
      const node = this.selectionNode;
      if (val) {
        this.selectionService.add(node);
      } else {
        this.selectionService.remove(node);
      }
      this.grid.notifyChanges();
    }
    /**
     * Gets whether the cell column is selected.
     * ```typescript
     * let isCellColumnSelected = this.cell.columnSelected;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get columnSelected() {
      return this.selectionService.isColumnSelected(this.column.field);
    }
    /**
     * Sets the current edit value while a cell is in edit mode.
     * Only for cell editing mode.
     * ```typescript
     * this.cell.editValue = value;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    set editValue(value) {
      if (this.grid.crudService.cellInEditMode) {
        this.grid.crudService.cell.editValue = value;
      }
    }
    /**
     * Gets the current edit value while a cell is in edit mode.
     * Only for cell editing mode.
     * ```typescript
     * let editValue = this.cell.editValue;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get editValue() {
      if (this.grid.crudService.cellInEditMode) {
        return this.grid.crudService.cell.editValue;
      }
    }
    /**
     * Returns whether the cell is editable.
     */
    get editable() {
      return this.column.editable && !this.intRow.disabled;
    }
    get minHeight() {
      if (this.grid.isCustomSetRowHeight) {
        return this.grid.renderedRowHeight;
      }
    }
    set highlight(value) {
      this._highlight = value;
      if (this._highlight && this.grid.lastSearchInfo.searchText) {
        this._highlight.highlight(this.grid.lastSearchInfo.searchText, this.grid.lastSearchInfo.caseSensitive, this.grid.lastSearchInfo.exactMatch);
        this._highlight.activateIfNecessary();
      }
    }
    get highlight() {
      return this._highlight;
    }
    get selectionNode() {
      return {
        row: this.rowIndex,
        column: this.column.columnLayoutChild ? this.column.parent.visibleIndex : this.visibleColumnIndex,
        layout: this.column.columnLayoutChild ? {
          rowStart: this.column.rowStart,
          colStart: this.column.colStart,
          rowEnd: this.column.rowEnd,
          colEnd: this.column.colEnd,
          columnVisibleIndex: this.visibleColumnIndex
        } : null
      };
    }
    /** @hidden @internal */
    get step() {
      const digitsInfo = this.column.pipeArgs.digitsInfo;
      if (!digitsInfo) {
        return 1;
      }
      const step = +digitsInfo.substr(digitsInfo.indexOf('.') + 1, 1);
      return 1 / Math.pow(10, step);
    }
    /** @hidden @internal */
    get currencyCode() {
      return this.column.pipeArgs.currencyCode ? this.column.pipeArgs.currencyCode : getLocaleCurrencyCode(this.grid.locale);
    }
    /** @hidden @internal */
    get currencyCodeSymbol() {
      return getCurrencySymbol(this.currencyCode, 'wide', this.grid.locale);
    }
    constructor(selectionService, grid, overlayService, cdr, element, zone, touchManager, platformUtil) {
      this.selectionService = selectionService;
      this.grid = grid;
      this.overlayService = overlayService;
      this.cdr = cdr;
      this.element = element;
      this.zone = zone;
      this.touchManager = touchManager;
      this.platformUtil = platformUtil;
      this._destroy$ = new Subject();
      /**
       * @hidden
       * @internal
       */
      this.lastPinned = false;
      /**
       * @hidden
       * @internal
       */
      this.firstPinned = false;
      /**
       * Returns whether the cell is in edit mode.
       */
      this.editMode = false;
      /**
       * Sets/get the `role` property of the cell.
       * Default value is `"gridcell"`.
       * ```typescript
       * this.cell.role = 'grid-cell';
       * ```
       * ```typescript
       * let cellRole = this.cell.role;
       * ```
       *
       * @memberof IgxGridCellComponent
       */
      this.role = 'gridcell';
      /**
       * Gets the width of the cell.
       * ```typescript
       * let cellWidth = this.cell.width;
       * ```
       *
       * @memberof IgxGridCellComponent
       */
      this.width = '';
      /**
       * @hidden
       */
      this.active = false;
      /**
       * @hidden
       */
      this.displayPinnedChip = false;
      /**
       * Sets/gets the highlight class of the cell.
       * Default value is `"igx-highlight"`.
       * ```typescript
       * let highlightClass = this.cell.highlightClass;
       * ```
       * ```typescript
       * this.cell.highlightClass = 'igx-cell-highlight';
       * ```
       *
       * @memberof IgxGridCellComponent
       */
      this.highlightClass = 'igx-highlight';
      /**
       * Sets/gets the active highlight class class of the cell.
       * Default value is `"igx-highlight__active"`.
       * ```typescript
       * let activeHighlightClass = this.cell.activeHighlightClass;
       * ```
       * ```typescript
       * this.cell.activeHighlightClass = 'igx-cell-highlight_active';
       * ```
       *
       * @memberof IgxGridCellComponent
       */
      this.activeHighlightClass = 'igx-highlight__active';
      this._cellSelection = GridSelectionMode.multiple;
      this._vIndex = -1;
      /**
       * @hidden
       * @internal
       */
      this.onDoubleClick = event => {
        if (event.type === 'doubletap') {
          // prevent double-tap to zoom on iOS
          event.preventDefault();
        }
        if (this.editable && !this.editMode && !this.intRow.deleted && !this.grid.crudService.rowEditingBlocked) {
          this.grid.crudService.enterEditMode(this, event);
        }
        this.grid.doubleClick.emit({
          cell: this.getCellType(),
          event
        });
      };
      /**
       * @hidden
       * @internal
       */
      this.errorShowing = false;
      /**
       *
       * @hidden
       * @internal
       */
      this.pointerdown = event => {
        if (this.cellSelectionMode !== GridSelectionMode.multiple) {
          this.activate(event);
          return;
        }
        if (!this.platformUtil.isLeftClick(event)) {
          event.preventDefault();
          this.grid.navigation.setActiveNode({
            rowIndex: this.rowIndex,
            colIndex: this.visibleColumnIndex
          });
          this.selectionService.addKeyboardRange();
          this.selectionService.initKeyboardState();
          this.selectionService.primaryButton = false;
          // Ensure RMB Click on edited cell does not end cell editing
          if (!this.selected) {
            this.grid.crudService.updateCell(true, event);
          }
          return;
        } else {
          this.selectionService.primaryButton = true;
        }
        this.selectionService.pointerDown(this.selectionNode, event.shiftKey, event.ctrlKey);
        this.activate(event);
      };
      /**
       *
       * @hidden
       * @internal
       */
      this.pointerenter = event => {
        const isHierarchicalGrid = this.grid.type === 'hierarchical';
        if (isHierarchicalGrid && (!this.grid.navigation?.activeNode?.gridID || this.grid.navigation.activeNode.gridID !== this.gridID)) {
          return;
        }
        const dragMode = this.selectionService.pointerEnter(this.selectionNode, event);
        if (dragMode) {
          this.grid.cdr.detectChanges();
        }
      };
      /**
       * @hidden
       * @internal
       */
      this.focusout = () => {
        this.closeErrorTooltip();
      };
      /**
       * @hidden
       * @internal
       */
      this.pointerup = event => {
        const isHierarchicalGrid = this.grid.type === 'hierarchical';
        if (!this.platformUtil.isLeftClick(event) || isHierarchicalGrid && (!this.grid.navigation?.activeNode?.gridID || this.grid.navigation.activeNode.gridID !== this.gridID)) {
          return;
        }
        if (this.selectionService.pointerUp(this.selectionNode, this.grid.rangeSelected)) {
          this.grid.cdr.detectChanges();
        }
      };
    }
    /**
     * @hidden
     * @internal
     */
    onClick(event) {
      this.grid.cellClick.emit({
        cell: this.getCellType(),
        event
      });
    }
    /**
     * @hidden
     * @internal
     */
    ngOnInit() {
      this.zone.runOutsideAngular(() => {
        this.nativeElement.addEventListener('pointerdown', this.pointerdown);
        this.addPointerListeners(this.cellSelectionMode);
      });
      if (this.platformUtil.isIOS) {
        this.touchManager.addEventListener(this.nativeElement, 'doubletap', this.onDoubleClick, {
          cssProps: {} /* don't disable user-select, etc */
        });
      }
    }
    ngAfterViewInit() {
      this.errorTooltip.changes.pipe(takeUntil(this._destroy$)).subscribe(() => {
        if (this.errorTooltip.length > 0 && this.active) {
          // error ocurred
          this.cdr.detectChanges();
          this.openErrorTooltip();
        }
      });
    }
    openErrorTooltip() {
      const tooltip = this.errorTooltip.first;
      tooltip.open({
        target: this.errorIcon.el.nativeElement,
        closeOnOutsideClick: true,
        excludeFromOutsideClick: [this.nativeElement],
        closeOnEscape: false,
        outlet: this.grid.outlet,
        modal: false,
        positionStrategy: new AutoPositionStrategy({
          horizontalStartPoint: HorizontalAlignment.Center,
          horizontalDirection: HorizontalAlignment.Center
        })
      });
    }
    /**
     * @hidden
     * @internal
     */
    ngOnDestroy() {
      this.zone.runOutsideAngular(() => {
        this.nativeElement.removeEventListener('pointerdown', this.pointerdown);
        this.removePointerListeners(this.cellSelectionMode);
      });
      this.touchManager.destroy();
      this._destroy$.next();
      this._destroy$.complete();
    }
    /**
     * @hidden
     * @internal
     */
    ngOnChanges(changes) {
      if (changes.editMode && changes.editMode.currentValue && this.formControl) {
        // ensure when values change, form control is forced to be marked as touche.
        this.formControl.valueChanges.pipe(takeWhile(() => this.editMode)).subscribe(() => this.formControl.markAsTouched());
        // while in edit mode subscribe to value changes on the current form control and set to editValue
        this.formControl.statusChanges.pipe(takeWhile(() => this.editMode)).subscribe(status => {
          if (status === 'INVALID' && this.errorTooltip.length > 0) {
            this.cdr.detectChanges();
            const tooltip = this.errorTooltip.first;
            this.resizeAndRepositionOverlayById(tooltip.overlayId, this.errorTooltip.first.element.offsetWidth);
          }
        });
      }
      if (changes.value && !changes.value.firstChange) {
        if (this.highlight) {
          this.highlight.lastSearchInfo.searchText = this.grid.lastSearchInfo.searchText;
          this.highlight.lastSearchInfo.caseSensitive = this.grid.lastSearchInfo.caseSensitive;
          this.highlight.lastSearchInfo.exactMatch = this.grid.lastSearchInfo.exactMatch;
        }
      }
    }
    /**
     * @hidden @internal
     */
    resizeAndRepositionOverlayById(overlayId, newSize) {
      const overlay = this.overlayService.getOverlayById(overlayId);
      if (!overlay) return;
      overlay.initialSize.width = newSize;
      overlay.elementRef.nativeElement.parentElement.style.width = newSize + 'px';
      this.overlayService.reposition(overlayId);
    }
    /**
     * Starts/ends edit mode for the cell.
     *
     * ```typescript
     * cell.setEditMode(true);
     * ```
     */
    setEditMode(value) {
      if (this.intRow.deleted) {
        return;
      }
      if (this.editable && value) {
        if (this.grid.crudService.cellInEditMode) {
          this.grid.gridAPI.update_cell(this.grid.crudService.cell);
          this.grid.crudService.endCellEdit();
        }
        this.grid.crudService.enterEditMode(this);
      } else {
        this.grid.crudService.endCellEdit();
      }
      this.grid.notifyChanges();
    }
    /**
     * Sets new value to the cell.
     * ```typescript
     * this.cell.update('New Value');
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    // TODO: Refactor
    update(val) {
      if (this.intRow.deleted) {
        return;
      }
      let cell = this.grid.crudService.cell;
      if (!cell) {
        cell = this.grid.crudService.createCell(this);
      }
      cell.editValue = val;
      this.grid.gridAPI.update_cell(cell);
      this.grid.crudService.endCellEdit();
      this.cdr.markForCheck();
    }
    closeErrorTooltip() {
      const tooltip = this.errorTooltip.first;
      if (tooltip) {
        tooltip.close();
      }
    }
    /**
     * @hidden
     * @internal
     */
    activate(event) {
      const node = this.selectionNode;
      let shouldEmitSelection = !this.selectionService.isActiveNode(node);
      if (this.selectionService.primaryButton) {
        const currentActive = this.selectionService.activeElement;
        if (this.cellSelectionMode === GridSelectionMode.single && event?.ctrlKey && this.selected) {
          this.selectionService.activeElement = null;
          shouldEmitSelection = true;
        } else {
          this.selectionService.activeElement = node;
        }
        const cancel = this._updateCRUDStatus(event);
        if (cancel) {
          this.selectionService.activeElement = currentActive;
          return;
        }
        const activeElement = this.selectionService.activeElement;
        const row = activeElement ? this.grid.gridAPI.get_row_by_index(activeElement.row) : null;
        if (this.grid.crudService.rowEditingBlocked && row && this.intRow.key !== row.key) {
          return;
        }
      } else {
        this.selectionService.activeElement = null;
        if (this.grid.crudService.cellInEditMode && !this.editMode) {
          this.grid.crudService.updateCell(true, event);
        }
      }
      this.grid.navigation.setActiveNode({
        row: this.rowIndex,
        column: this.visibleColumnIndex
      });
      const isTargetErrorIcon = event && event.target && event.target === this.errorIcon?.el.nativeElement;
      if (this.isInvalid && !isTargetErrorIcon) {
        this.cdr.detectChanges();
        this.openErrorTooltip();
        this.grid.activeNodeChange.pipe(first$2()).subscribe(() => {
          this.closeErrorTooltip();
        });
      }
      this.selectionService.primaryButton = true;
      if (this.cellSelectionMode === GridSelectionMode.multiple && this.selectionService.activeElement) {
        if (this.selectionService.isInMap(this.selectionService.activeElement) && event?.ctrlKey && !event?.shiftKey) {
          this.selectionService.remove(this.selectionService.activeElement);
          shouldEmitSelection = true;
        } else {
          this.selectionService.add(this.selectionService.activeElement, false); // pointer events handle range generation
          this.selectionService.keyboardStateOnFocus(node, this.grid.rangeSelected, this.nativeElement);
        }
      }
      if (this.grid.isCellSelectable && shouldEmitSelection) {
        this.zone.run(() => this.grid.selected.emit({
          cell: this.getCellType(),
          event
        }));
      }
    }
    /**
     * If the provided string matches the text in the cell, the text gets highlighted.
     * ```typescript
     * this.cell.highlightText('Cell Value', true);
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    highlightText(text, caseSensitive, exactMatch) {
      return this.highlight && this.column.searchable ? this.highlight.highlight(text, caseSensitive, exactMatch) : 0;
    }
    /**
     * Clears the highlight of the text in the cell.
     * ```typescript
     * this.cell.clearHighLight();
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    clearHighlight() {
      if (this.highlight && this.column.searchable) {
        this.highlight.clearHighlight();
      }
    }
    /**
     * @hidden
     * @internal
     */
    calculateSizeToFit(range) {
      return this.platformUtil.getNodeSizeViaRange(range, this.nativeElement);
    }
    /**
     * @hidden
     * @internal
     */
    get searchMetadata() {
      const meta = new Map();
      meta.set('pinned', this.grid.isRecordPinnedByViewIndex(this.intRow.index));
      return meta;
    }
    /**
     * @hidden
     * @internal
     */
    _updateCRUDStatus(event) {
      if (this.editMode) {
        return;
      }
      let editableArgs;
      const crud = this.grid.crudService;
      const editableCell = this.grid.crudService.cell;
      const editMode = !!(crud.row || crud.cell);
      if (this.editable && editMode && !this.intRow.deleted) {
        if (editableCell) {
          editableArgs = this.grid.crudService.updateCell(false, event);
          /* This check is related with the following issue #6517:
           * when edit cell that belongs to a column which is sorted and press tab,
           * the next cell in edit mode is with wrong value /its context is not updated/;
           * So we reapply sorting before the next cell enters edit mode.
           * Also we need to keep the notifyChanges below, because of the current
           * change detection cycle when we have editing with enabled transactions
           */
          if (this.grid.sortingExpressions.length && this.grid.sortingExpressions.indexOf(editableCell.column.field)) {
            this.grid.cdr.detectChanges();
          }
          if (editableArgs && editableArgs.cancel) {
            return true;
          }
          crud.exitCellEdit(event);
        }
        this.grid.tbody.nativeElement.focus({
          preventScroll: true
        });
        this.grid.notifyChanges();
        crud.enterEditMode(this, event);
        return false;
      }
      if (editableCell && crud.sameRow(this.cellID.rowID)) {
        this.grid.crudService.updateCell(true, event);
      } else if (editMode && !crud.sameRow(this.cellID.rowID)) {
        this.grid.crudService.endEdit(true, event);
      }
    }
    addPointerListeners(selection) {
      if (selection !== GridSelectionMode.multiple) {
        return;
      }
      this.nativeElement.addEventListener('pointerenter', this.pointerenter);
      this.nativeElement.addEventListener('pointerup', this.pointerup);
      this.nativeElement.addEventListener('focusout', this.focusout);
    }
    removePointerListeners(selection) {
      if (selection !== GridSelectionMode.multiple) {
        return;
      }
      this.nativeElement.removeEventListener('pointerenter', this.pointerenter);
      this.nativeElement.removeEventListener('pointerup', this.pointerup);
      this.nativeElement.removeEventListener('focusout', this.focusout);
    }
    getCellType(useRow) {
      const rowID = useRow ? this.grid.createRow(this.intRow.index, this.intRow.data) : this.intRow.index;
      return new IgxGridCell(this.grid, rowID, this.column);
    }
    static {
      this.ɵfac = function IgxGridCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridCellComponent)(i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(HammerGesturesManager), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridCellComponent,
        selectors: [["igx-grid-cell"]],
        viewQuery: function IgxGridCellComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c213, 5, IgxIconComponent);
            i0.ɵɵviewQuery(_c214, 7, TemplateRef);
            i0.ɵɵviewQuery(_c215, 7, TemplateRef);
            i0.ɵɵviewQuery(_c216, 7, TemplateRef);
            i0.ɵɵviewQuery(_c217, 7, TemplateRef);
            i0.ɵɵviewQuery(_c218, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxTextHighlightDirective, 5, IgxTextHighlightDirective);
            i0.ɵɵviewQuery(_c219, 5, IgxTooltipDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorIcon = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultErrorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultCellTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultPinnedIndicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inlineEditorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addRowCellTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.highlight = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorTooltip = _t);
          }
        },
        hostVars: 33,
        hostBindings: function IgxGridCellComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dblclick", function IgxGridCellComponent_dblclick_HostBindingHandler($event) {
              return ctx.onDoubleClick($event);
            })("click", function IgxGridCellComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-rowIndex", ctx.rowIndex)("data-visibleIndex", ctx.visibleColumnIndex)("id", ctx.attrCellID)("title", ctx.title)("role", ctx.role)("aria-readonly", ctx.readonly)("aria-describedby", ctx.ariaDescribeBy)("aria-invalid", ctx.isInvalid)("aria-selected", ctx.ariaSelected);
            i0.ɵɵstyleProp("min-height", ctx.minHeight, "px");
            i0.ɵɵclassProp("igx-grid__td--new", ctx.isEmptyAddRowCell)("igx-grid__td--bool-true", ctx.booleanClass)("igx-grid__td--pinned-last", ctx.lastPinned)("igx-grid__td--pinned-first", ctx.firstPinned)("igx-grid__td--editing", ctx.editMode)("igx-grid__td--invalid", ctx.isInvalid)("igx-grid__td--valid", ctx.isValidAfterEdit)("igx-grid__td--active", ctx.active)("igx-grid__td--selected", ctx.selected)("igx-grid__td--column-selected", ctx.columnSelected)("igx-grid__td--row-pinned-first", ctx.displayPinnedChip);
          }
        },
        inputs: {
          column: "column",
          intRow: "intRow",
          row: "row",
          rowData: "rowData",
          columnData: "columnData",
          cellTemplate: "cellTemplate",
          cellValidationErrorTemplate: "cellValidationErrorTemplate",
          pinnedIndicator: "pinnedIndicator",
          value: "value",
          formatter: "formatter",
          visibleColumnIndex: "visibleColumnIndex",
          cellSelectionMode: "cellSelectionMode",
          lastSearchInfo: "lastSearchInfo",
          lastPinned: "lastPinned",
          firstPinned: "firstPinned",
          editMode: [2, "editMode", "editMode", booleanAttribute],
          width: "width",
          active: "active",
          displayPinnedChip: "displayPinnedChip"
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager]), i0.ɵɵNgOnChangesFeature],
        decls: 13,
        vars: 5,
        consts: [["defaultPinnedIndicator", ""], ["defaultCell", ""], ["addRowCell", ""], ["inlineEditor", ""], ["defaultError", ""], ["errorIcon", ""], ["error", "", "tooltipRef", "tooltip"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__td--pinned-chip", 3, "disabled", "--ig-size"], [1, "igx-grid__td--pinned-chip", 3, "disabled"], ["igxTextHighlight", "", 1, "igx-grid__td-text", 3, "cssClass", "activeCssClass", "groupName", "value", "row", "column", "containerClass", "metadata"], ["family", "default", 3, "name", "ngClass"], [3, "src", "alt"], [3, "formGroup"], ["igxInput", "", 3, "compositionstart", "compositionend", "igxFocus", "igxTextSelection", "formControl"], ["igxInput", "", "type", "number", 3, "igxFocus", "igxTextSelection", "step", "formControl"], [3, "checked", "igxFocus", "disableRipple", "formControl"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "weekStart", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "inputFormat", "displayFormat", "value", "igxFocus", "formControl"], ["type", "text", "igxInput", "", 3, "formControl", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat", "igxFocus"], ["family", "default", "name", "error", 3, "mouseover", "mouseout", "igxTooltipTarget", "igxToggleOutlet"], ["igxTooltip", "", 3, "id"]],
        template: function IgxGridCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridCellComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxGridCellComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxGridCellComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxGridCellComponent_ng_template_6_Template, 8, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxGridCellComponent_ng_container_8_Template, 1, 0, "ng-container", 7)(9, IgxGridCellComponent_ng_container_9_Template, 1, 0, "ng-container", 7)(10, IgxGridCellComponent_Conditional_10_Template, 7, 7)(11, IgxGridCellComponent_ng_template_11_Template, 7, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.pinnedIndicatorTemplate)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isInvalid ? 10 : -1);
          }
        },
        dependencies: [NgClass, NgTemplateOutlet, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe, ReactiveFormsModule, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormControlDirective, i4.FormGroupDirective, IgxChipComponent, IgxTextHighlightDirective, IgxIconComponent, IgxInputGroupComponent, IgxInputDirective, IgxFocusDirective, IgxTextSelectionDirective, IgxCheckboxComponent, IgxDatePickerComponent, IgxTimePickerComponent, IgxDateTimeEditorDirective, IgxPrefixDirective, IgxSuffixDirective, IgxTooltipTargetDirective, IgxTooltipDirective, IgxGridCellImageAltPipe, IgxStringReplacePipe, IgxColumnFormatterPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridExpandableCellComponent = /*#__PURE__*/(() => {
  class IgxGridExpandableCellComponent extends IgxGridCellComponent {
    constructor(selectionService, grid, overlayService, cdr, element, zone, touchManager, document, platformUtil) {
      super(selectionService, grid, overlayService, cdr, element, zone, touchManager, platformUtil);
      this.document = document;
      /**
       * @hidden
       */
      this.expanded = false;
    }
    /**
     * @hidden
     */
    toggle(event) {
      event.stopPropagation();
      const expansionState = this.grid.gridAPI.get_row_expansion_state(this.intRow.data);
      this.grid.gridAPI.set_row_expansion_state(this.intRow.key, !expansionState, event);
    }
    /**
     * @hidden
     */
    onIndicatorFocus() {
      this.grid.gridAPI.update_cell(this.grid.crudService.cell);
    }
    /**
     * @hidden
     */
    calculateSizeToFit(range) {
      let leftPadding = 0;
      if (this.indentationDiv) {
        const indentationStyle = this.document.defaultView.getComputedStyle(this.indentationDiv.nativeElement);
        leftPadding = parseFloat(indentationStyle.paddingLeft);
      }
      const contentWidth = this.platformUtil.getNodeSizeViaRange(range, this.nativeElement);
      return contentWidth + leftPadding;
    }
    /**
     * @hidden
     */
    get iconTemplate() {
      if (this.expanded) {
        return this.grid.rowExpandedIndicatorTemplate || this.defaultExpandedTemplate;
      } else {
        return this.grid.rowCollapsedIndicatorTemplate || this.defaultCollapsedTemplate;
      }
    }
    /**
     * @hidden
     */
    get showExpanderIndicator() {
      const isGhost = this.intRow.pinned && this.intRow.disabled;
      return !this.editMode && (!this.intRow.pinned || isGhost);
    }
    static {
      this.ɵfac = function IgxGridExpandableCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridExpandableCellComponent)(i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(HammerGesturesManager), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridExpandableCellComponent,
        selectors: [["igx-expandable-grid-cell"]],
        viewQuery: function IgxGridExpandableCellComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c221, 5, ElementRef);
            i0.ɵɵviewQuery(_c222, 5, ElementRef);
            i0.ɵɵviewQuery(_c202, 7, TemplateRef);
            i0.ɵɵviewQuery(_c203, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indentationDiv = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExpandedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultCollapsedTemplate = _t.first);
          }
        },
        inputs: {
          expanded: "expanded"
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager]), i0.ɵɵInheritDefinitionFeature],
        decls: 18,
        vars: 6,
        consts: [["defaultPinnedIndicator", ""], ["defaultCell", ""], ["addRowCell", ""], ["inlineEditor", ""], ["defaultExpandedTemplate", ""], ["defaultCollapsedTemplate", ""], ["defaultError", ""], ["indicator", ""], ["errorIcon", ""], ["error", "", "tooltipRef", "tooltip"], [1, "igx-grid__tree-grouping-indicator"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__td--pinned-chip", 3, "disabled", "--ig-size"], [1, "igx-grid__td--pinned-chip", 3, "disabled"], ["igxTextHighlight", "", 1, "igx-grid__td-text", 3, "cssClass", "activeCssClass", "groupName", "value", "row", "column", "containerClass", "metadata"], ["family", "default", 3, "name", "ngClass"], [3, "src", "alt"], [3, "formGroup"], [3, "--ig-size", "formGroup"], ["igxInput", "", 3, "compositionstart", "compositionend", "igxFocus", "formControl"], ["igxInput", "", "type", "number", 3, "igxFocus", "step", "formControl"], [3, "checked", "igxFocus", "disableRipple", "formControl"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "weekStart", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["type", "text", "igxInput", "", 3, "formControl", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat", "igxFocus"], [1, "igx-grid__tree-grouping-indicator", 3, "click", "focus"], ["family", "default", "name", "error", 3, "mouseover", "mouseout", "igxTooltipTarget", "igxToggleOutlet"], ["igxTooltip", "", 3, "id"], ["family", "default", "name", "tree_collapse"], ["family", "default", "name", "tree_expand"]],
        template: function IgxGridExpandableCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridExpandableCellComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxGridExpandableCellComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxGridExpandableCellComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxGridExpandableCellComponent_ng_template_6_Template, 8, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxGridExpandableCellComponent_Conditional_8_Template, 3, 4, "div", 10)(9, IgxGridExpandableCellComponent_ng_container_9_Template, 1, 0, "ng-container", 11)(10, IgxGridExpandableCellComponent_ng_container_10_Template, 1, 0, "ng-container", 11)(11, IgxGridExpandableCellComponent_Conditional_11_Template, 7, 7)(12, IgxGridExpandableCellComponent_ng_template_12_Template, 1, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(14, IgxGridExpandableCellComponent_ng_template_14_Template, 1, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(16, IgxGridExpandableCellComponent_ng_template_16_Template, 7, 7, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵconditional(ctx.showExpanderIndicator ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.pinnedIndicatorTemplate)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isInvalid ? 11 : -1);
          }
        },
        dependencies: [IgxChipComponent, IgxTextHighlightDirective, IgxIconComponent, NgClass, FormsModule, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, ReactiveFormsModule, i4.FormControlDirective, i4.FormGroupDirective, IgxInputGroupComponent, IgxInputDirective, IgxFocusDirective, IgxCheckboxComponent, IgxDatePickerComponent, IgxTimePickerComponent, IgxDateTimeEditorDirective, IgxPrefixDirective, IgxSuffixDirective, NgTemplateOutlet, IgxTooltipTargetDirective, IgxTooltipDirective, IgxGridCellImageAltPipe, IgxStringReplacePipe, IgxColumnFormatterPipe, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridExpandableCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorIndirectRender */
/* blazorElement */
let IgxGridRowComponent = /*#__PURE__*/(() => {
  class IgxGridRowComponent extends IgxRowDirective {
    getContext(col, row) {
      return {
        $implicit: col,
        row
      };
    }
    get mrlRightPinnedOffset() {
      return !this.grid.isPinningToStart ? -this.grid.pinnedWidth - this.grid.headerFeaturesWidth + 'px' : null;
    }
    getContextMRL(pinnedCols, row) {
      return {
        $implicit: pinnedCols,
        row
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridRowComponent_BaseFactory;
        return function IgxGridRowComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridRowComponent_BaseFactory || (ɵIgxGridRowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridRowComponent)))(__ngFactoryType__ || IgxGridRowComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridRowComponent,
        selectors: [["igx-grid-row"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxRowDirective,
          useExisting: forwardRef(() => IgxGridRowComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 17,
        vars: 1,
        consts: [["addTemp", ""], ["defaultTemp", ""], ["mrlPinnedTemplate", ""], ["rowSelectorBaseTemplate", ""], ["cellTemplate", ""], ["expandableCellTemplate", ""], ["mrlCellTemplate", ""], ["mrlExpandableCellTemplate", ""], ["igxDirRef", ""], ["cell", ""], [4, "ngTemplateOutlet"], [1, "igx-grid__tr--inner", 3, "animationend"], [3, "class", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action"], [3, "class"], [3, "click", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "pointerdown", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "pointerdown", "click"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForScrollOrientation", "igxForContainerSize", "igxForSizePropName", "igxForTrackBy"], [1, "igx-grid__mrl-block", 3, "ngStyle"], [1, "igx-grid__mrl-block", 3, "igx-grid__td--pinned-last", "igx-grid__td--pinned-first", "left", "ngStyle"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "checked", "readonly", "disabled", "disableRipple", "disableTransitions", "aria-label"], [1, "igx-grid__td", "igx-grid__td--fw", 3, "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "lastPinned", "firstPinned", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--tree-cell", 3, "ngClass", "ngStyle", "expanded", "editMode", "column", "formatter", "intRow", "lastPinned", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", 3, "ngClass", "ngStyle", "editMode", "column", "lastPinned", "firstPinned", "formatter", "intRow", "rowData", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--tree-cell", 3, "ngClass", "ngStyle", "expanded", "editMode", "column", "lastPinned", "formatter", "intRow", "rowData", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"]],
        template: function IgxGridRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridRowComponent_ng_container_0_Template, 1, 0, "ng-container", 10)(1, IgxGridRowComponent_ng_template_1_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxGridRowComponent_ng_template_3_Template, 5, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxGridRowComponent_ng_template_5_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, IgxGridRowComponent_ng_template_7_Template, 2, 7, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(9, IgxGridRowComponent_ng_template_9_Template, 6, 92, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(11, IgxGridRowComponent_ng_template_11_Template, 6, 86, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(13, IgxGridRowComponent_ng_template_13_Template, 6, 87, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(15, IgxGridRowComponent_ng_template_15_Template, 6, 87, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const addTemp_r25 = i0.ɵɵreference(2);
            const defaultTemp_r3 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.addRowUI ? addTemp_r25 : defaultTemp_r3);
          }
        },
        dependencies: [NgTemplateOutlet, IgxRowDragDirective, IgxGridForOfDirective, NgStyle, IgxCheckboxComponent, IgxGridCellComponent, NgClass, IgxGridExpandableCellComponent, IgxGridNotGroupedPipe, IgxGridTopLevelColumns, IgxGridCellStylesPipe, IgxGridCellStyleClassesPipe, IgxGridDataMapperPipe, IgxGridTransactionStatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DragScrollDirection = /*#__PURE__*/function (DragScrollDirection) {
  DragScrollDirection[DragScrollDirection["NONE"] = 0] = "NONE";
  DragScrollDirection[DragScrollDirection["LEFT"] = 1] = "LEFT";
  DragScrollDirection[DragScrollDirection["TOP"] = 2] = "TOP";
  DragScrollDirection[DragScrollDirection["RIGHT"] = 3] = "RIGHT";
  DragScrollDirection[DragScrollDirection["BOTTOM"] = 4] = "BOTTOM";
  DragScrollDirection[DragScrollDirection["TOPLEFT"] = 5] = "TOPLEFT";
  DragScrollDirection[DragScrollDirection["TOPRIGHT"] = 6] = "TOPRIGHT";
  DragScrollDirection[DragScrollDirection["BOTTOMLEFT"] = 7] = "BOTTOMLEFT";
  DragScrollDirection[DragScrollDirection["BOTTOMRIGHT"] = 8] = "BOTTOMRIGHT";
  return DragScrollDirection;
}(DragScrollDirection || {});
/**
 * An internal directive encapsulating the drag scroll behavior in the grid.
 *
 * @hidden @internal
 */
let IgxGridDragSelectDirective = /*#__PURE__*/(() => {
  class IgxGridDragSelectDirective {
    get activeDrag() {
      return this._activeDrag;
    }
    set activeDrag(val) {
      if (val !== this._activeDrag) {
        this.unsubscribe();
        this._activeDrag = val;
      }
    }
    get nativeElement() {
      return this.ref.nativeElement;
    }
    constructor(ref, zone) {
      this.ref = ref;
      this.zone = zone;
      this.dragStop = new EventEmitter();
      this.dragScroll = new EventEmitter();
      this.end$ = new Subject();
      this.lastDirection = DragScrollDirection.NONE;
      this.startDragSelection = ev => {
        if (!this.activeDrag) {
          return;
        }
        const x = ev.clientX;
        const y = ev.clientY;
        const {
          direction,
          delta
        } = this._measureDimensions(x, y);
        if (direction === this.lastDirection) {
          return;
        }
        this.unsubscribe();
        this._sub = this._interval$.subscribe(() => this.dragScroll.emit(delta));
        this.lastDirection = direction;
      };
      this.stopDragSelection = () => {
        if (!this.activeDrag) {
          return;
        }
        this.dragStop.emit(false);
        this.unsubscribe();
        this.lastDirection = DragScrollDirection.NONE;
      };
      this._interval$ = interval(0, animationFrameScheduler).pipe(takeUntil(this.end$), filter(() => this.activeDrag));
    }
    ngOnInit() {
      this.zone.runOutsideAngular(() => {
        this.nativeElement.addEventListener('pointerover', this.startDragSelection);
        this.nativeElement.addEventListener('pointerleave', this.stopDragSelection);
      });
    }
    ngOnDestroy() {
      this.zone.runOutsideAngular(() => {
        this.nativeElement.removeEventListener('pointerover', this.startDragSelection);
        this.nativeElement.removeEventListener('pointerleave', this.stopDragSelection);
      });
      this.unsubscribe();
      this.end$.complete();
    }
    _measureDimensions(x, y) {
      let direction;
      let delta = {
        left: 0,
        top: 0
      };
      const {
        left,
        top,
        width,
        height
      } = this.nativeElement.getBoundingClientRect();
      const RATIO = 0.15;
      const offsetX = Math.trunc(x - left);
      const offsetY = Math.trunc(y - top);
      const leftDirection = offsetX <= width * RATIO;
      const rightDirection = offsetX >= width * (1 - RATIO);
      const topDirection = offsetY <= height * RATIO;
      const bottomDirection = offsetY >= height * (1 - RATIO);
      if (topDirection && leftDirection) {
        direction = DragScrollDirection.TOPLEFT;
        delta = {
          left: -1,
          top: -1
        };
      } else if (topDirection && rightDirection) {
        direction = DragScrollDirection.TOPRIGHT;
        delta = {
          left: 1,
          top: -1
        };
      } else if (bottomDirection && leftDirection) {
        direction = DragScrollDirection.BOTTOMLEFT;
        delta = {
          left: -1,
          top: 1
        };
      } else if (bottomDirection && rightDirection) {
        direction = DragScrollDirection.BOTTOMRIGHT;
        delta = {
          top: 1,
          left: 1
        };
      } else if (topDirection) {
        direction = DragScrollDirection.TOP;
        delta.top = -1;
      } else if (bottomDirection) {
        direction = DragScrollDirection.BOTTOM;
        delta.top = 1;
      } else if (leftDirection) {
        direction = DragScrollDirection.LEFT;
        delta.left = -1;
      } else if (rightDirection) {
        direction = DragScrollDirection.RIGHT;
        delta.left = 1;
      } else {
        direction = DragScrollDirection.NONE;
      }
      return {
        direction,
        delta
      };
    }
    unsubscribe() {
      if (this._sub) {
        this._sub.unsubscribe();
      }
    }
    static {
      this.ɵfac = function IgxGridDragSelectDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridDragSelectDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridDragSelectDirective,
        selectors: [["", "igxGridDragSelect", ""]],
        inputs: {
          activeDrag: [2, "igxGridDragSelect", "activeDrag", booleanAttribute]
        },
        outputs: {
          dragStop: "dragStop",
          dragScroll: "dragScroll"
        }
      });
    }
  }
  return IgxGridDragSelectDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$8 = 0;
/* blazorAdditionalDependency: Column */
/* blazorAdditionalDependency: ColumnGroup */
/* blazorAdditionalDependency: ColumnLayout */
/* blazorAdditionalDependency: GridToolbar */
/* blazorAdditionalDependency: GridToolbarActions */
/* blazorAdditionalDependency: GridToolbarTitle */
/* blazorAdditionalDependency: GridToolbarAdvancedFiltering */
/* blazorAdditionalDependency: GridToolbarExporter */
/* blazorAdditionalDependency: GridToolbarHiding */
/* blazorAdditionalDependency: GridToolbarPinning */
/* blazorAdditionalDependency: ActionStrip */
/* blazorAdditionalDependency: GridActionsBaseDirective */
/* blazorAdditionalDependency: GridEditingActions */
/* blazorAdditionalDependency: GridPinningActions */
/* blazorIndirectRender */
/**
 * Grid provides a way to present and manipulate tabular data.
 *
 * @igxModule IgxGridModule
 * @igxGroup Grids & Lists
 * @igxKeywords grid, table
 * @igxTheme igx-grid-theme
 * @remarks
 * The Ignite UI Grid is used for presenting and manipulating tabular data in the simplest way possible.  Once data
 * has been bound, it can be manipulated through filtering, sorting & editing operations.
 * @example
 * ```html
 * <igx-grid [data]="employeeData" [autoGenerate]="false">
 *   <igx-column field="first" header="First Name"></igx-column>
 *   <igx-column field="last" header="Last Name"></igx-column>
 *   <igx-column field="role" header="Role"></igx-column>
 * </igx-grid>
 * ```
 */
let IgxGridComponent = /*#__PURE__*/(() => {
  class IgxGridComponent extends IgxGridBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Emitted when a new chunk of data is loaded from virtualization.
       *
       * @example
       * ```typescript
       *  <igx-grid #grid [data]="localData" [autoGenerate]="true" (dataPreLoad)='handleDataPreloadEvent()'></igx-grid>
       * ```
       */
      this.dataPreLoad = new EventEmitter();
      /**
       * @hidden
       */
      this.groupingExpressionsChange = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.groupingExpansionStateChange = new EventEmitter();
      /**
       * Emitted when columns are grouped/ungrouped.
       *
       * @remarks
       * The `groupingDone` event would be raised only once if several columns get grouped at once by calling
       * the `groupBy()` or `clearGrouping()` API methods and passing an array as an argument.
       * The event arguments provide the `expressions`, `groupedColumns` and `ungroupedColumns` properties, which contain
       * the `ISortingExpression` and the `IgxColumnComponent` related to the grouping/ungrouping operation.
       * Please note that `groupedColumns` and `ungroupedColumns` show only the **newly** changed columns (affected by the **last**
       * grouping/ungrouping operation), not all columns which are currently grouped/ungrouped.
       * columns.
       * @example
       * ```html
       * <igx-grid #grid [data]="localData" (groupingDone)="groupingDone($event)" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.groupingDone = new EventEmitter();
      /**
       * Gets/Sets whether created groups are rendered expanded or collapsed.
       *
       * @remarks
       * The default rendered state is expanded.
       * @example
       * ```html
       * <igx-grid #grid [data]="Data" [groupsExpanded]="false" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.groupsExpanded = true;
      /**
       * @hidden @internal
       */
      this.role = 'grid';
      /**
       * Gets/Sets the value of the `id` attribute.
       *
       * @remarks
       * If not provided it will be automatically generated.
       * @example
       * ```html
       * <igx-grid [id]="'igx-grid-1'" [data]="Data" [autoGenerate]="true"></igx-grid>
       * ```
       */
      this.id = `igx-grid-${NEXT_ID$8++}`;
      this._groupsRecords = [];
      /**
       * @hidden
       */
      this._groupingExpressions = [];
      /**
       * @hidden
       */
      this._groupingExpandState = [];
      this._hideGroupedColumns = false;
      this._dropAreaMessage = null;
      this._showGroupArea = true;
      this.childDetailTemplates = new Map();
      /**
       * @hidden @internal
       */
      this.groupingPerformedSubject = new Subject();
      /**
       * @hidden @internal
       */
      this.groupingPerformed$ = this.groupingPerformedSubject.asObservable();
    }
    /**
     * Returns a reference to the master-detail template.
     * ```typescript
     * let detailTemplate = this.grid.detailTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    get detailTemplate() {
      return this._detailTemplate;
    }
    /**
     * Sets the master-detail template.
     * ```html
     * <ng-template #detailTemplate igxGridDetail let-dataItem>
     *    <div>
     *       <div><span class='categoryStyle'>City:</span> {{dataItem.City}}</div>
     *       <div><span class='categoryStyle'>Address:</span> {{dataItem.Address}}</div>
     *    </div>
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'detailTemplate'", {read: TemplateRef })
     * public detailTemplate: TemplateRef<any>;
     * this.grid.detailTemplate = this.detailTemplate;
     * ```
     *
     * @memberof IgxColumnComponent
     */
    set detailTemplate(template) {
      this._detailTemplate = template;
    }
    /**
     * Gets the hierarchical representation of the group by records.
     *
     * @example
     * ```typescript
     * let groupRecords = this.grid.groupsRecords;
     * ```
     */
    get groupsRecords() {
      return this._groupsRecords;
    }
    /**
     * Gets/Sets the array of data that populates the component.
     *
     * @example
     * ```html
     * <igx-grid [data]="Data" [autoGenerate]="true"></igx-grid>
     * ```
     */
    /* treatAsRef */
    get data() {
      return this._data;
    }
    set data(value) {
      const dataLoaded = (!this._data || this._data.length === 0) && value && value.length > 0;
      const oldData = this._data;
      this._data = value || [];
      this.summaryService.clearSummaryCache();
      if (!this._init) {
        this.validation.updateAll(this._data);
      }
      if (this.autoGenerate && this._data.length > 0 && this.shouldRecreateColumns(oldData, this._data)) {
        this.setupColumns();
      }
      this.cdr.markForCheck();
      if (this.isPercentHeight) {
        this.notifyChanges(true);
      }
      // check if any columns have width auto and if so recalculate their auto-size on data loaded.
      if (dataLoaded && this._columns.some(x => x._width === 'auto')) {
        this.recalculateAutoSizes();
      }
      this.checkPrimaryKeyField();
    }
    /**
     * Gets/Sets the total number of records in the data source.
     *
     * @remarks
     * This property is required for remote grid virtualization to function when it is bound to remote data.
     * @example
     * ```typescript
     * const itemCount = this.grid1.totalItemCount;
     * this.grid1.totalItemCount = 55;
     * ```
     */
    set totalItemCount(count) {
      this.verticalScrollContainer.totalItemCount = count;
    }
    get totalItemCount() {
      return this.verticalScrollContainer.totalItemCount;
    }
    get _gridAPI() {
      return this.gridAPI;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /**
     * Gets/Sets the group by state.
     *
     * @example
     * ```typescript
     * let groupByState = this.grid.groupingExpressions;
     * this.grid.groupingExpressions = [...];
     * ```
     * @remarks
     * Supports two-way data binding.
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [autoGenerate]="true" [(groupingExpressions)]="model.groupingExpressions"></igx-grid>
     * ```
     */
    get groupingExpressions() {
      return this._groupingExpressions;
    }
    set groupingExpressions(value) {
      if (this.groupingExpressions === value) {
        return;
      }
      if (value && value.length > 10) {
        throw Error('Maximum amount of grouped columns is 10.');
      }
      const oldExpressions = this.groupingExpressions;
      const newExpressions = value;
      this._groupingExpressions = cloneArray(value);
      this.groupingExpressionsChange.emit(this._groupingExpressions);
      if (this._gridAPI.grid) {
        /* grouping and sorting are working separate from each other */
        this._applyGrouping();
        this.notifyChanges();
      }
      if (!this._init && JSON.stringify(oldExpressions, this.stringifyCallback) !== JSON.stringify(newExpressions, this.stringifyCallback) && this._columns) {
        const groupedCols = [];
        const ungroupedCols = [];
        const groupedColsArr = newExpressions.filter(obj => !oldExpressions.some(obj2 => obj.fieldName === obj2.fieldName));
        groupedColsArr.forEach(elem => {
          groupedCols.push(this.getColumnByName(elem.fieldName));
        }, this);
        const ungroupedColsArr = oldExpressions.filter(obj => !newExpressions.some(obj2 => obj.fieldName === obj2.fieldName));
        ungroupedColsArr.forEach(elem => {
          ungroupedCols.push(this.getColumnByName(elem.fieldName));
        }, this);
        this.notifyChanges();
        const groupingDoneArgs = {
          expressions: newExpressions,
          groupedColumns: groupedCols,
          ungroupedColumns: ungroupedCols
        };
        this.groupingPerformed$.pipe(take(1)).subscribe(() => {
          this.groupingDone.emit(groupingDoneArgs);
        });
      }
    }
    /**
     * Gets/Sets a list of expansion states for group rows.
     *
     * @remarks
     * Includes only states that differ from the default one (controlled through groupsExpanded and states that the user has changed.
     * Contains the expansion state (expanded: boolean) and the unique identifier for the group row (Array).
     * Supports two-way data binding.
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [autoGenerate]="true" [(groupingExpansionState)]="model.groupingExpansionState"></igx-grid>
     * ```
     */
    get groupingExpansionState() {
      return this._groupingExpandState;
    }
    set groupingExpansionState(value) {
      if (value !== this._groupingExpandState) {
        this.groupingExpansionStateChange.emit(value);
      }
      this._groupingExpandState = value;
      if (this.gridAPI.grid) {
        this.cdr.detectChanges();
      }
    }
    /**
     * Gets/Sets whether the grouped columns should be hidden.
     *
     * @remarks
     * The default value is "false"
     * @example
     * ```html
     * <igx-grid #grid [data]="localData" [hideGroupedColumns]="true" [autoGenerate]="true"></igx-grid>
     * ```
     */
    get hideGroupedColumns() {
      return this._hideGroupedColumns;
    }
    set hideGroupedColumns(value) {
      if (value) {
        this.groupingDiffer = this.differs.find(this.groupingExpressions).create();
      } else {
        this.groupingDiffer = null;
      }
      if (this._columns && this.groupingExpressions) {
        this._setGroupColsVisibility(value);
      }
      this._hideGroupedColumns = value;
    }
    /**
     * Gets/Sets the grouping strategy of the grid.
     *
     * @remarks The default IgxGrouping extends from IgxSorting and a custom one can be used as a `sortStrategy` as well.
     *
     * @example
     * ```html
     *  <igx-grid #grid [data]="localData" [groupStrategy]="groupStrategy"></igx-grid>
     * ```
     */
    get groupStrategy() {
      return this._groupStrategy;
    }
    set groupStrategy(value) {
      this._groupStrategy = value;
    }
    /**
     * Gets/Sets the message displayed inside the GroupBy drop area where columns can be dragged on.
     *
     * @remarks
     * The grid needs to have at least one groupable column in order the GroupBy area to be displayed.
     * @example
     * ```html
     * <igx-grid dropAreaMessage="Drop here to group!">
     *      <igx-column [groupable]="true" field="ID"></igx-column>
     * </igx-grid>
     * ```
     */
    set dropAreaMessage(value) {
      this._dropAreaMessage = value;
      this.notifyChanges();
    }
    get dropAreaMessage() {
      return this._dropAreaMessage || this.resourceStrings.igx_grid_groupByArea_message;
    }
    /**
     * @hidden @internal
     */
    get groupsRowList() {
      const res = new QueryList();
      if (!this._groupsRowList) {
        return res;
      }
      const rList = this._groupsRowList.filter(item => item.element.nativeElement.parentElement !== null).sort((item1, item2) => item1.index - item2.index);
      res.reset(rList);
      return res;
    }
    /**
     * Gets the group by row selector template.
     */
    get groupByRowSelectorTemplate() {
      return this._groupByRowSelectorTemplate || this.groupByRowSelectorsTemplates?.first;
    }
    /**
     * Sets the group by row selector template.
     * ```html
     * <ng-template #template igxGroupByRowSelector let-groupByRowContext>
     * {{ groupByRowContext.selectedCount }} / {{ groupByRowContext.totalCount  }}
     * </ng-template>
     * ```
     * ```typescript
     * @ViewChild("'template'", {read: TemplateRef })
     * public template: TemplateRef<any>;
     * this.grid.groupByRowSelectorTemplate = this.template;
     * ```
     */
    set groupByRowSelectorTemplate(template) {
      this._groupByRowSelectorTemplate = template;
    }
    /**
     * @hidden @internal
     */
    getDetailsContext(rowData, index) {
      return {
        $implicit: rowData,
        index
      };
    }
    /**
     * @hidden @internal
     */
    detailsViewFocused(container, rowIndex) {
      this.navigation.setActiveNode({
        row: rowIndex
      });
    }
    /**
     * @hidden @internal
     */
    get hasDetails() {
      return !!this.detailTemplate;
    }
    /**
     * @hidden @internal
     */
    getRowTemplate(rowData) {
      if (this.isGroupByRecord(rowData)) {
        return this.defaultGroupTemplate;
      } else if (this.isSummaryRow(rowData)) {
        return this.summaryTemplate;
      } else if (this.hasDetails && this.isDetailRecord(rowData)) {
        return this.detailTemplateContainer;
      } else {
        return this.recordTemplate;
      }
    }
    /**
     * @hidden @internal
     */
    isDetailRecord(record) {
      return record && record.detailsData !== undefined;
    }
    /**
     * @hidden @internal
     */
    isDetailActive(rowIndex) {
      return this.navigation.activeNode ? this.navigation.activeNode.row === rowIndex : false;
    }
    /**
     * Gets/Sets the template reference for the group row.
     *
     * @example
     * ```
     * const groupRowTemplate = this.grid.groupRowTemplate;
     * this.grid.groupRowTemplate = myRowTemplate;
     * ```
     */
    get groupRowTemplate() {
      return this._groupRowTemplate;
    }
    set groupRowTemplate(template) {
      this._groupRowTemplate = template;
      this.notifyChanges();
    }
    /**
     * Groups by a new `IgxColumnComponent` based on the provided expression, or modifies an existing one.
     *
     * @remarks
     * Also allows for multiple columns to be grouped at once if an array of `ISortingExpression` is passed.
     * The `groupingDone` event would get raised only **once** if this method gets called multiple times with the same arguments.
     * @example
     * ```typescript
     * this.grid.groupBy({ fieldName: name, dir: SortingDirection.Asc, ignoreCase: false });
     * this.grid.groupBy([
     *     { fieldName: name1, dir: SortingDirection.Asc, ignoreCase: false },
     *     { fieldName: name2, dir: SortingDirection.Desc, ignoreCase: true },
     *     { fieldName: name3, dir: SortingDirection.Desc, ignoreCase: false }
     * ]);
     * ```
     */
    groupBy(expression) {
      if (this.checkIfNoColumnField(expression)) {
        return;
      }
      this.crudService.endEdit(false);
      if (expression instanceof Array) {
        this._gridAPI.groupBy_multiple(expression);
      } else {
        this._gridAPI.groupBy(expression);
      }
      this.notifyChanges(true);
    }
    /**
     * Clears grouping for particular column, array of columns or all columns.
     *
     * @remarks
     * Clears all grouping in the grid, if no parameter is passed.
     * If a parameter is provided, clears grouping for a particular column or an array of columns.
     * @example
     * ```typescript
     * this.grid.clearGrouping(); //clears all grouping
     * this.grid.clearGrouping("ID"); //ungroups a single column
     * this.grid.clearGrouping(["ID", "Column1", "Column2"]); //ungroups multiple columns
     * ```
     * @param name Name of column or array of column names to be ungrouped.
     */
    clearGrouping(name) {
      this._gridAPI.clear_groupby(name);
      this.calculateGridSizes();
      this.notifyChanges(true);
      this.groupingPerformedSubject.next();
    }
    /**
     * Returns if a group is expanded or not.
     *
     * @param group The group record.
     * @example
     * ```typescript
     * public groupRow: IGroupByRecord;
     * const expandedGroup = this.grid.isExpandedGroup(this.groupRow);
     * ```
     */
    isExpandedGroup(group) {
      const state = this._getStateForGroupRow(group);
      return state ? state.expanded : this.groupsExpanded;
    }
    /**
     * Toggles the expansion state of a group.
     *
     * @param groupRow The group record to toggle.
     * @example
     * ```typescript
     * public groupRow: IGroupByRecord;
     * const toggleExpGroup = this.grid.toggleGroup(this.groupRow);
     * ```
     */
    toggleGroup(groupRow) {
      this._toggleGroup(groupRow);
      this.notifyChanges();
    }
    /**
     * Select all rows within a group.
     *
     * @param groupRow: The group record which rows would be selected.
     * @param clearCurrentSelection if true clears the current selection
     * @example
     * ```typescript
     * this.grid.selectRowsInGroup(this.groupRow, true);
     * ```
     */
    selectRowsInGroup(groupRow, clearPrevSelection) {
      this._gridAPI.groupBy_select_all_rows_in_group(groupRow, clearPrevSelection);
      this.notifyChanges();
    }
    /**
     * Deselect all rows within a group.
     *
     * @param groupRow The group record which rows would be deselected.
     * @example
     * ```typescript
     * public groupRow: IGroupByRecord;
     * this.grid.deselectRowsInGroup(this.groupRow);
     * ```
     */
    deselectRowsInGroup(groupRow) {
      this._gridAPI.groupBy_deselect_all_rows_in_group(groupRow);
      this.notifyChanges();
    }
    /**
     * Expands the specified group and all of its parent groups.
     *
     * @param groupRow The group record to fully expand.
     * @example
     * ```typescript
     * public groupRow: IGroupByRecord;
     * this.grid.fullyExpandGroup(this.groupRow);
     * ```
     */
    fullyExpandGroup(groupRow) {
      this._fullyExpandGroup(groupRow);
      this.notifyChanges();
    }
    /**
     * @hidden @internal
     */
    isGroupByRecord(record) {
      // return record.records instance of GroupedRecords fails under Webpack
      return record && record?.records && record.records?.length && record.expression && record.expression?.fieldName;
    }
    /**
     * Toggles the expansion state of all group rows recursively.
     *
     * @example
     * ```typescript
     * this.grid.toggleAllGroupRows;
     * ```
     */
    toggleAllGroupRows() {
      this.groupingExpansionState = [];
      this.groupsExpanded = !this.groupsExpanded;
      this.notifyChanges();
    }
    /** @hidden @internal */
    get hasGroupableColumns() {
      return this._columns.some(col => col.groupable && !col.columnGroup);
    }
    /**
     * Returns whether the `IgxGridComponent` has group area.
     *
     * @example
     * ```typescript
     * let isGroupAreaVisible = this.grid.showGroupArea;
     * ```
     *
     * @example
     * ```html
     * <igx-grid #grid [data]="Data" [showGroupArea]="false"></igx-grid>
     * ```
     */
    get showGroupArea() {
      return this._showGroupArea;
    }
    set showGroupArea(value) {
      this._showGroupArea = value;
      this.notifyChanges(true);
    }
    /**
     * @hidden @internal
     */
    isColumnGrouped(fieldName) {
      return this.groupingExpressions.find(exp => exp.fieldName === fieldName) ? true : false;
    }
    /**
     * @hidden @internal
     */
    getContext(rowData, rowIndex, pinned) {
      if (this.isDetailRecord(rowData)) {
        const cachedData = this.childDetailTemplates.get(rowData.detailsData);
        const rowID = this.primaryKey ? rowData.detailsData[this.primaryKey] : rowData.detailsData;
        if (cachedData) {
          const view = cachedData.view;
          const tmlpOutlet = cachedData.owner;
          return {
            $implicit: rowData.detailsData,
            moveView: view,
            owner: tmlpOutlet,
            index: this.dataView.indexOf(rowData),
            templateID: {
              type: 'detailRow',
              id: rowID
            }
          };
        } else {
          // child rows contain unique grids, hence should have unique templates
          return {
            $implicit: rowData.detailsData,
            templateID: {
              type: 'detailRow',
              id: rowID
            },
            index: this.dataView.indexOf(rowData)
          };
        }
      }
      return {
        $implicit: this.isGhostRecord(rowData) ? rowData.recordRef : rowData,
        index: this.getDataViewIndex(rowIndex, pinned),
        templateID: {
          type: this.isGroupByRecord(rowData) ? 'groupRow' : this.isSummaryRow(rowData) ? 'summaryRow' : 'dataRow',
          id: null
        },
        disabled: this.isGhostRecord(rowData)
      };
    }
    /**
     * @hidden @internal
     */
    viewCreatedHandler(args) {
      if (args.context.templateID.type === 'detailRow') {
        this.childDetailTemplates.set(args.context.$implicit, args);
      }
    }
    /**
     * @hidden @internal
     */
    viewMovedHandler(args) {
      if (args.context.templateID.type === 'detailRow') {
        // view was moved, update owner in cache
        const key = args.context.$implicit;
        const cachedData = this.childDetailTemplates.get(key);
        cachedData.owner = args.owner;
      }
    }
    /**
     * @hidden @internal
     */
    get iconTemplate() {
      if (this.groupsExpanded) {
        return this.headerExpandedIndicatorTemplate || this.defaultExpandedTemplate;
      } else {
        return this.headerCollapsedIndicatorTemplate || this.defaultCollapsedTemplate;
      }
    }
    /**
     * @hidden @internal
     */
    ngAfterContentInit() {
      super.ngAfterContentInit();
      if (this.allowFiltering && this.hasColumnLayouts) {
        this.filterMode = FilterMode.excelStyleFilter;
      }
      if (this.groupTemplate) {
        this._groupRowTemplate = this.groupTemplate.template;
      }
      if (this.detailTemplateDirective) {
        this._detailTemplate = this.detailTemplateDirective;
      }
      if (this.hideGroupedColumns && this._columns && this.groupingExpressions) {
        this._setGroupColsVisibility(this.hideGroupedColumns);
      }
      this._setupNavigationService();
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.verticalScrollContainer.beforeViewDestroyed.pipe(takeUntil(this.destroy$)).subscribe(view => {
        const rowData = view.context.$implicit;
        if (this.isDetailRecord(rowData)) {
          const cachedData = this.childDetailTemplates.get(rowData.detailsData);
          if (cachedData) {
            const tmlpOutlet = cachedData.owner;
            tmlpOutlet._viewContainerRef.detach(0);
          }
        }
      });
      this.sortingExpressionsChange.pipe(takeUntil(this.destroy$)).subscribe(sortingExpressions => {
        if (!this.groupingExpressions || !this.groupingExpressions.length) {
          return;
        }
        sortingExpressions.forEach(sortExpr => {
          const fieldName = sortExpr.fieldName;
          const groupingExpr = this.groupingExpressions.find(ex => ex.fieldName === fieldName);
          if (groupingExpr) {
            groupingExpr.dir = sortExpr.dir;
          }
        });
      });
    }
    /**
     * @hidden @internal
     */
    ngOnInit() {
      super.ngOnInit();
      this.trackChanges = (_, rec) => rec?.detailsData !== undefined ? rec.detailsData : rec;
      this.groupingDone.pipe(takeUntil(this.destroy$)).subscribe(args => {
        this.crudService.endEdit(false);
        this.summaryService.updateSummaryCache(args);
        this._headerFeaturesWidth = NaN;
      });
    }
    /**
     * @hidden @internal
     */
    ngDoCheck() {
      if (this.groupingDiffer && this._columns && !this.hasColumnLayouts) {
        const changes = this.groupingDiffer.diff(this.groupingExpressions);
        if (changes && this._columns.length > 0) {
          changes.forEachAddedItem(rec => {
            const col = this.getColumnByName(rec.item.fieldName);
            if (col) {
              col.hidden = true;
            }
          });
          changes.forEachRemovedItem(rec => {
            const col = this.getColumnByName(rec.item.fieldName);
            col.hidden = false;
          });
        }
      }
      super.ngDoCheck();
    }
    /**
     * @hidden @internal
     */
    dataLoading(event) {
      this.dataPreLoad.emit(event);
    }
    /**
     *
     * Returns an array of the current cell selection in the form of `[{ column.field: cell.value }, ...]`.
     *
     * @remarks
     * If `formatters` is enabled, the cell value will be formatted by its respective column formatter (if any).
     * If `headers` is enabled, it will use the column header (if any) instead of the column field.
     */
    getSelectedData(formatters = false, headers = false) {
      if (this.groupingExpressions.length || this.hasDetails) {
        const source = [];
        const process = record => {
          if (record.expression || record.summaries || this.isDetailRecord(record)) {
            source.push(null);
            return;
          }
          source.push(record);
        };
        this.dataView.forEach(process);
        return this.extractDataFromSelection(source, formatters, headers);
      } else {
        return super.getSelectedData(formatters, headers);
      }
    }
    /**
     * Returns the `IgxGridRow` by index.
     *
     * @example
     * ```typescript
     * const myRow = grid.getRowByIndex(1);
     * ```
     * @param index
     */
    getRowByIndex(index) {
      let row;
      if (index < 0) {
        return undefined;
      }
      if (this.dataView.length >= this.virtualizationState.startIndex + this.virtualizationState.chunkSize) {
        row = this.createRow(index);
      } else {
        if (!(index < this.virtualizationState.startIndex) && !(index > this.virtualizationState.startIndex + this.virtualizationState.chunkSize)) {
          row = this.createRow(index);
        }
      }
      if (this.pagingMode === 1 && this.page !== 0) {
        row.index = index + this.perPage * this.page;
      }
      return row;
    }
    /**
     * Returns `IgxGridRow` object by the specified primary key.
     *
     * @remarks
     * Requires that the `primaryKey` property is set.
     * @example
     * ```typescript
     * const myRow = this.grid1.getRowByKey("cell5");
     * ```
     * @param keyValue
     */
    getRowByKey(key) {
      const rec = this.filteredSortedData ? this.primaryKey ? this.filteredSortedData.find(record => record[this.primaryKey] === key) : this.filteredSortedData.find(record => record === key) : undefined;
      const index = this.dataView.indexOf(rec);
      if (index < 0 || index > this.dataView.length) {
        return undefined;
      }
      return new IgxGridRow(this, index, rec);
    }
    /**
     * @hidden @internal
     */
    allRows() {
      return this.dataView.map((rec, index) => {
        this.pagingMode === 1 && this.page !== 0 ? index = index + this.perPage * this.page : index = this.dataRowList.first.index + index;
        return this.createRow(index);
      });
    }
    /**
     * Returns the collection of `IgxGridRow`s for current page.
     *
     * @hidden @internal
     */
    dataRows() {
      return this.allRows().filter(row => row instanceof IgxGridRow);
    }
    /**
     * Returns an array of the selected `IgxGridCell`s.
     *
     * @example
     * ```typescript
     * const selectedCells = this.grid.selectedCells;
     * ```
     */
    get selectedCells() {
      return this.dataRows().map(row => row.cells.filter(cell => cell.selected)).reduce((a, b) => a.concat(b), []);
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @example
     * ```typescript
     * const myCell = this.grid1.getCellByColumn(2, "UnitPrice");
     * ```
     * @param rowIndex
     * @param columnField
     */
    getCellByColumn(rowIndex, columnField) {
      const row = this.getRowByIndex(rowIndex);
      const column = this._columns.find(col => col.field === columnField);
      if (row && row instanceof IgxGridRow && !row.data?.detailsData && column) {
        if (this.pagingMode === 1 && this.page !== 0) {
          row.index = rowIndex + this.perPage * this.page;
        }
        return new IgxGridCell(this, row.index, column);
      }
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @remarks
     * Requires that the primaryKey property is set.
     * @example
     * ```typescript
     * grid.getCellByKey(1, 'index');
     * ```
     * @param rowSelector match any rowID
     * @param columnField
     */
    getCellByKey(rowSelector, columnField) {
      const row = this.getRowByKey(rowSelector);
      const column = this._columns.find(col => col.field === columnField);
      if (row && column) {
        return new IgxGridCell(this, row.index, column);
      }
    }
    pinRow(rowID, index) {
      const row = this.getRowByKey(rowID);
      return super.pinRow(rowID, index, row);
    }
    unpinRow(rowID) {
      const row = this.getRowByKey(rowID);
      return super.unpinRow(rowID, row);
    }
    /**
     * @hidden @internal
     */
    createRow(index, data) {
      let row;
      const dataIndex = this._getDataViewIndex(index);
      const rec = data ?? this.dataView[dataIndex];
      if (rec && this.isGroupByRecord(rec)) {
        row = new IgxGroupByRow(this, index, rec);
      }
      if (rec && this.isSummaryRow(rec)) {
        row = new IgxSummaryRow(this, index, rec.summaries);
      }
      // if found record is a no a groupby or summary row, return IgxGridRow instance
      if (!row && rec) {
        row = new IgxGridRow(this, index, rec);
      }
      return row;
    }
    /**
     * @hidden @internal
     */
    get defaultTargetBodyHeight() {
      const allItems = this.totalItemCount || this.dataLength;
      return this.renderedActualRowHeight * Math.min(this._defaultTargetRecordNumber, this.paginator ? Math.min(allItems, this.perPage) : allItems);
    }
    /**
     * @hidden @internal
     */
    getGroupAreaHeight() {
      return this.groupArea ? this.getComputedHeight(this.groupArea.nativeElement) : 0;
    }
    /**
     * @hidden @internal
     */
    onColumnsAddedOrRemoved() {
      // update grouping states
      this.groupablePipeTrigger++;
      if (this.groupingExpressions && this.hideGroupedColumns) {
        this._setGroupColsVisibility(this.hideGroupedColumns);
      }
      super.onColumnsAddedOrRemoved();
    }
    /**
     * @hidden @internal
     */
    scrollTo(row, column) {
      if (this.groupingExpressions && this.groupingExpressions.length && typeof row !== 'number') {
        const rowIndex = this.groupingResult.indexOf(row);
        const groupByRecord = this.groupingMetadata[rowIndex];
        if (groupByRecord) {
          this._fullyExpandGroup(groupByRecord);
        }
      }
      super.scrollTo(row, column, this.groupingFlatResult);
    }
    /**
     * @hidden @internal
     */
    _getStateForGroupRow(groupRow) {
      return this._gridAPI.groupBy_get_expanded_for_group(groupRow);
    }
    /**
     * @hidden
     */
    _toggleGroup(groupRow) {
      this._gridAPI.groupBy_toggle_group(groupRow);
    }
    /**
     * @hidden @internal
     */
    _fullyExpandGroup(groupRow) {
      this._gridAPI.groupBy_fully_expand_group(groupRow);
    }
    /**
     * @hidden @internal
     */
    _applyGrouping() {
      this._gridAPI.sort_groupBy_multiple(this._groupingExpressions);
    }
    _setupNavigationService() {
      if (this.hasColumnLayouts) {
        this.navigation = new IgxGridMRLNavigationService(this.platform);
        this.navigation.grid = this;
      }
    }
    checkIfNoColumnField(expression) {
      if (expression instanceof Array) {
        for (const singleExpression of expression) {
          if (!singleExpression.fieldName) {
            return true;
          }
        }
        return false;
      }
      return !expression.fieldName;
    }
    _setGroupColsVisibility(value) {
      if (this._columns.length > 0 && !this.hasColumnLayouts) {
        this.groupingExpressions.forEach(expr => {
          const col = this.getColumnByName(expr.fieldName);
          col.hidden = value;
        });
      }
    }
    stringifyCallback(key, val) {
      // Workaround for Blazor, since its wrappers inject this externalObject that cannot serialize.
      if (key === 'externalObject') {
        return undefined;
      }
      return val;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridComponent_BaseFactory;
        return function IgxGridComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridComponent_BaseFactory || (ɵIgxGridComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridComponent)))(__ngFactoryType__ || IgxGridComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridComponent,
        selectors: [["igx-grid"]],
        contentQueries: function IgxGridComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxGridDetailTemplateDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxGroupByRowTemplateDirective, 5, IgxGroupByRowTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxGroupByRowSelectorDirective, 4, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupByRowSelectorsTemplates = _t);
          }
        },
        viewQuery: function IgxGridComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c226, 7, TemplateRef);
            i0.ɵɵviewQuery(_c227, 7, TemplateRef);
            i0.ɵɵviewQuery(_c228, 7, TemplateRef);
            i0.ɵɵviewQuery(_c229, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxGridGroupByRowComponent, 5, IgxGridGroupByRowComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.recordTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailTemplateContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultGroupTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.summaryTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsRowList = _t);
          }
        },
        hostVars: 2,
        hostBindings: function IgxGridComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("id", ctx.id);
          }
        },
        inputs: {
          groupsExpanded: [2, "groupsExpanded", "groupsExpanded", booleanAttribute],
          dropAreaTemplate: "dropAreaTemplate",
          detailTemplate: "detailTemplate",
          id: "id",
          data: "data",
          totalItemCount: "totalItemCount",
          groupingExpressions: "groupingExpressions",
          groupingExpansionState: "groupingExpansionState",
          hideGroupedColumns: [2, "hideGroupedColumns", "hideGroupedColumns", booleanAttribute],
          groupStrategy: "groupStrategy",
          dropAreaMessage: "dropAreaMessage",
          groupByRowSelectorTemplate: "groupByRowSelectorTemplate",
          groupRowTemplate: "groupRowTemplate",
          showGroupArea: [2, "showGroupArea", "showGroupArea", booleanAttribute]
        },
        outputs: {
          dataPreLoad: "dataPreLoad",
          groupingExpressionsChange: "groupingExpressionsChange",
          groupingExpansionStateChange: "groupingExpansionStateChange",
          groupingDone: "groupingDone"
        },
        features: [i0.ɵɵProvidersFeature([IgxGridCRUDService, IgxGridNavigationService, IgxGridSummaryService, IgxGridSelectionService, IgxGridValidationService, {
          provide: IGX_GRID_SERVICE_BASE,
          useClass: IgxGridAPIService
        }, {
          provide: IGX_GRID_BASE,
          useExisting: IgxGridComponent
        }, IgxFilteringService, IgxColumnResizingService, IgxForOfSyncService, IgxForOfScrollSyncService]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c231,
        decls: 96,
        vars: 173,
        consts: [["tbody", ""], ["pinnedRecordsTemplate", ""], ["verticalScrollContainer", ""], ["record_template", ""], ["pinned_record_template", ""], ["group_template", ""], ["summary_template", ""], ["detail_template_container", ""], ["igxRowEditingOverlayOutlet", ""], ["loadingOverlay", ""], ["verticalScrollHolder", ""], ["addRowSnackbar", ""], ["igxBodyOverlayOutlet", "overlay-outlet"], ["igxLoadingOverlayOutlet", ""], ["tfoot", ""], ["scr", ""], ["scrollContainer", ""], ["footer", ""], ["emptyFilteredGrid", ""], ["defaultEmptyGrid", ""], ["defaultAddRowEmptyTemplate", ""], ["defaultLoadingGrid", ""], ["defaultExpandedTemplate", ""], ["defaultCollapsedTemplate", ""], ["defaultRowEditText", ""], ["defaultRowEditActions", ""], ["defaultRowEditTemplate", ""], ["dragIndicatorIconBase", ""], ["igxFilteringOverlayOutlet", ""], ["groupArea", ""], ["pinContainer", ""], ["row", ""], ["row", "", "pinnedRow", ""], ["summaryRow", ""], ["detailsContainer", ""], ["rowEditingOverlay", ""], ["sink", ""], [3, "flex-basis", "grid", "expressions", "sortingExpressions", "dropAreaTemplate", "dropAreaMessage"], ["tabindex", "0", 1, "igx-grid-thead", 3, "keydown.meta.c", "keydown.control.c", "copy", "keydown", "scroll", "focus", "grid", "hasMRL", "activeDescendant", "width", "pinnedColumnCollection", "unpinnedColumnCollection"], ["igxGridBody", "", "role", "rowgroup", 1, "igx-grid__tbody", 3, "keydown.control.c", "copy"], ["tabindex", "0", 1, "igx-grid__tbody-content", 3, "keydown", "focus", "dragStop", "scroll", "dragScroll", "igxGridDragSelect"], ["id", "left", 1, "igx-grid__scroll-on-drag-left", 3, "igxColumnMovingDrop"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop", "left"], [4, "ngTemplateOutlet"], ["igxGridFor", "", 3, "chunkPreload", "dataChanging", "dataChanged", "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize", "igxForTrackBy"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["igxOverlayOutlet", "", 1, "igx-grid__row-editing-outlet"], ["igxToggle", ""], [3, "indeterminate"], ["id", "right", 1, "igx-grid__scroll-on-drag-right", 3, "igxColumnMovingDrop"], [1, "igx-grid__tbody-scrollbar", 3, "pointerdown", "hidden"], [1, "igx-grid__tbody-scrollbar-start"], [1, "igx-grid__tbody-scrollbar-main"], ["igxGridFor", "", 3, "igxGridForOf"], [1, "igx-grid__tbody-scrollbar-end"], [1, "igx-grid__addrow-snackbar"], [3, "outlet", "actionText", "displayTime"], ["igxOverlayOutlet", ""], ["igxOverlayOutlet", "", 1, "igx-grid__loading-outlet"], ["role", "rowgroup", 1, "igx-grid__tfoot"], ["tabindex", "0", 3, "focus", "keydown"], ["role", "row", 1, "igx-grid__summaries", 3, "width", "height", "gridID", "summaries", "index"], [1, "igx-grid__tfoot-thumb", 3, "hidden"], [1, "igx-grid__scroll", 3, "pointerdown", "hidden"], [1, "igx-grid__scroll-start"], [1, "igx-grid__scroll-main"], [1, "igx-grid__scroll-end", 3, "hidden"], [1, "igx-grid__footer"], ["igxOverlayOutlet", "", 1, "igx-grid__outlet"], [2, "display", "none"], [3, "grid", "expressions", "sortingExpressions", "dropAreaTemplate", "dropAreaMessage"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop"], [1, "igx-grid__tr--pinned", 3, "ngClass", "width"], [1, "igx-grid__tr--pinned", 3, "ngClass"], [3, "cachedViewLoaded", "viewCreated", "viewMoved", "igxTemplateOutlet", "igxTemplateOutletContext"], [3, "gridID", "index", "data", "disabled", "ngClass", "ngStyle"], [3, "gridID", "index", "data", "ngClass", "ngStyle"], [3, "gridID", "index", "groupRow", "hideGroupRowSelectors", "rowDraggable"], ["role", "row", 1, "igx-grid__summaries--body", 3, "gridID", "summaries", "index"], ["detail", "true", 3, "pointerdown", "id", "ngClass"], [1, "igx-grid__hierarchical-indent"], [3, "class"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "row", 1, "igx-grid__summaries", 3, "gridID", "summaries", "index"], ["role", "cell", 1, "igx-grid__tbody-message"], ["type", "button", "igxButton", "contained", "igxRipple", "", 3, "click"], [1, "igx-grid__loading"], ["family", "default", "name", "unfold_less", "role", "button", 3, "ngClass"], ["family", "default", "name", "unfold_more", "role", "button", 3, "ngClass"], [3, "className"], ["igxButton", "", "igxRowEditTabStop", "", "type", "button", 3, "click"], [1, "igx-banner__message"], [1, "igx-banner__text"], [1, "igx-banner__actions"], [1, "igx-banner__row"], ["family", "default", "name", "drag_indicator"]],
        template: function IgxGridComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c230);
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, IgxGridComponent_Conditional_1_Template, 2, 7, "igx-grid-group-by-area", 37);
            i0.ɵɵelementStart(2, "igx-grid-header-row", 38);
            i0.ɵɵlistener("keydown.meta.c", function IgxGridComponent_Template_igx_grid_header_row_keydown_meta_c_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown.control.c", function IgxGridComponent_Template_igx_grid_header_row_keydown_control_c_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxGridComponent_Template_igx_grid_header_row_copy_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown", function IgxGridComponent_Template_igx_grid_header_row_keydown_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.headerNavigation($event));
            })("scroll", function IgxGridComponent_Template_igx_grid_header_row_scroll_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventHeaderScroll($event));
            })("focus", function IgxGridComponent_Template_igx_grid_header_row_focus_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 39);
            i0.ɵɵlistener("keydown.control.c", function IgxGridComponent_Template_div_keydown_control_c_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxGridComponent_Template_div_copy_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            });
            i0.ɵɵelementStart(4, "div", 40, 0);
            i0.ɵɵlistener("keydown", function IgxGridComponent_Template_div_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.handleNavigation($event));
            })("focus", function IgxGridComponent_Template_div_focus_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusTbody($event));
            })("dragStop", function IgxGridComponent_Template_div_dragStop_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectionService.dragMode = $event);
            })("scroll", function IgxGridComponent_Template_div_scroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventContainerScroll($event));
            })("dragScroll", function IgxGridComponent_Template_div_dragScroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragScroll($event));
            });
            i0.ɵɵtemplate(6, IgxGridComponent_Conditional_6_Template, 1, 2, "span", 41)(7, IgxGridComponent_Conditional_7_Template, 1, 4, "span", 42)(8, IgxGridComponent_ng_container_8_Template, 1, 0, "ng-container", 43)(9, IgxGridComponent_ng_template_9_Template, 7, 49, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, IgxGridComponent_ng_template_11_Template, 1, 2, "ng-template", 44, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(13, "gridTransaction");
            i0.ɵɵpipe(14, "visibleColumns");
            i0.ɵɵpipe(15, "gridFiltering");
            i0.ɵɵpipe(16, "gridSort");
            i0.ɵɵpipe(17, "gridGroupBy");
            i0.ɵɵpipe(18, "gridPaging");
            i0.ɵɵpipe(19, "gridSummary");
            i0.ɵɵpipe(20, "gridDetails");
            i0.ɵɵpipe(21, "gridAddRow");
            i0.ɵɵpipe(22, "gridRowPinning");
            i0.ɵɵlistener("chunkPreload", function IgxGridComponent_Template_ng_template_chunkPreload_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataLoading($event));
            })("dataChanging", function IgxGridComponent_Template_ng_template_dataChanging_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebinding($event));
            })("dataChanged", function IgxGridComponent_Template_ng_template_dataChanged_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebound($event));
            });
            i0.ɵɵtemplate(23, IgxGridComponent_ng_container_23_Template, 1, 0, "ng-container", 43)(24, IgxGridComponent_ng_template_24_Template, 4, 36, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(26, IgxGridComponent_ng_template_26_Template, 5, 35, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(28, IgxGridComponent_ng_template_28_Template, 2, 5, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(30, IgxGridComponent_ng_template_30_Template, 2, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(32, IgxGridComponent_ng_template_32_Template, 5, 10, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(34, IgxGridComponent_ng_container_34_Template, 1, 0, "ng-container", 45);
            i0.ɵɵelement(35, "div", 46, 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "div", 47, 9);
            i0.ɵɵtemplate(39, IgxGridComponent_Conditional_39_Template, 1, 1, "igx-circular-bar", 48);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(40, IgxGridComponent_Conditional_40_Template, 1, 2, "span", 49);
            i0.ɵɵelementStart(41, "div", 50);
            i0.ɵɵlistener("pointerdown", function IgxGridComponent_Template_div_pointerdown_41_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(42, "div", 51);
            i0.ɵɵelementStart(43, "div", 52);
            i0.ɵɵtemplate(44, IgxGridComponent_ng_template_44_Template, 0, 0, "ng-template", 53, 10, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(46, "div", 54);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(47, "div", 55)(48, "igx-snackbar", 56, 11);
            i0.ɵɵtext(50);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(51, "div", 57, 12)(53, "div", 58, 13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(55, "div", 59, 14)(57, "div", 60);
            i0.ɵɵlistener("focus", function IgxGridComponent_Template_div_focus_57_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell(false));
            })("keydown", function IgxGridComponent_Template_div_keydown_57_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.summaryNav($event));
            });
            i0.ɵɵtemplate(58, IgxGridComponent_Conditional_58_Template, 3, 10, "igx-grid-summary-row", 61);
            i0.ɵɵelement(59, "div", 62);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(60, "div", 63, 15);
            i0.ɵɵlistener("pointerdown", function IgxGridComponent_Template_div_pointerdown_60_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(62, "div", 64);
            i0.ɵɵelementStart(63, "div", 65);
            i0.ɵɵtemplate(64, IgxGridComponent_ng_template_64_Template, 0, 0, "ng-template", 53, 16, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(66, "div", 66);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "div", 67, 17);
            i0.ɵɵprojection(69, 1);
            i0.ɵɵprojection(70, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(71, IgxGridComponent_ng_template_71_Template, 4, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor)(73, IgxGridComponent_ng_template_73_Template, 4, 2, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor)(75, IgxGridComponent_ng_template_75_Template, 2, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor)(77, IgxGridComponent_ng_template_77_Template, 2, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor)(79, IgxGridComponent_ng_template_79_Template, 1, 3, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor)(81, IgxGridComponent_ng_template_81_Template, 1, 3, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor)(83, IgxGridComponent_Conditional_83_Template, 4, 6, "div", 47)(84, IgxGridComponent_ng_template_84_Template, 3, 9, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor)(86, IgxGridComponent_ng_template_86_Template, 4, 2, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor)(88, IgxGridComponent_ng_template_88_Template, 6, 8, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor)(90, IgxGridComponent_ng_template_90_Template, 1, 0, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor)(92, IgxGridComponent_Conditional_92_Template, 1, 0, "igx-grid-column-resizer");
            i0.ɵɵelement(93, "div", 68, 28);
            i0.ɵɵtemplate(95, IgxGridComponent_Conditional_95_Template, 4, 0, "div", 69);
          }
          if (rf & 2) {
            const pinnedRecordsTemplate_r30 = i0.ɵɵreference(10);
            const igxBodyOverlayOutlet_r31 = i0.ɵɵreference(52);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showGroupArea && (ctx.groupingExpressions.length > 0 || ctx.hasGroupableColumns) ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("grid", ctx)("hasMRL", ctx.hasColumnLayouts)("activeDescendant", ctx.activeDescendant)("width", ctx.calcWidth)("pinnedColumnCollection", ctx.pinnedColumns)("unpinnedColumnCollection", ctx.unpinnedColumns);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", ctx.totalHeight, "px")("width", ctx.calcWidth || null, "px");
            i0.ɵɵproperty("igxGridDragSelect", ctx.selectionService.dragMode);
            i0.ɵɵattribute("role", ctx.dataView.length ? null : "row")("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length <= 0 ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length > 0 ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && ctx.isRowPinningToTop ? pinnedRecordsTemplate_r30 : null);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind4(22, 126, i0.ɵɵpipeBind3(21, 122, i0.ɵɵpipeBind4(20, 117, i0.ɵɵpipeBindV(19, 108, i0.ɵɵpureFunction8(161, _c232, i0.ɵɵpipeBindV(18, 102, i0.ɵɵpureFunction5(155, _c64, i0.ɵɵpipeBindV(17, 93, i0.ɵɵpureFunction8(146, _c232, i0.ɵɵpipeBindV(16, 86, i0.ɵɵpureFunction6(139, _c63, i0.ɵɵpipeBindV(15, 78, i0.ɵɵpureFunction7(131, _c225, i0.ɵɵpipeBind2(14, 75, i0.ɵɵpipeBind3(13, 71, ctx.data, ctx.id, ctx.pipeTrigger), ctx.hasVisibleColumns), ctx.filteringExpressionsTree, ctx.filterStrategy, ctx.advancedFilteringExpressionsTree, ctx.id, ctx.pipeTrigger, ctx.filteringPipeTrigger)), ctx.sortingExpressions, ctx.groupingExpressions, ctx.sortStrategy, ctx.id, ctx.pipeTrigger)), ctx.groupingExpressions, ctx.groupingExpansionState, ctx.groupStrategy, ctx.groupsExpanded, ctx.id, ctx.groupsRecords, ctx.pipeTrigger)), !!ctx.paginator, ctx.page, ctx.perPage, ctx.pipeTrigger)), ctx.hasSummarizedColumns, ctx.summaryCalculationMode, ctx.summaryPosition, ctx.id, ctx.showSummaryOnCollapse, ctx.pipeTrigger, ctx.summaryPipeTrigger)), ctx.hasDetails, ctx.expansionStates, ctx.pipeTrigger), false, ctx.pipeTrigger), ctx.id, false, ctx.pipeTrigger))("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx.verticalScroll)("igxForContainerSize", ctx.calcHeight)("igxForItemSize", ctx.hasColumnLayouts ? ctx.rowHeight * ctx.multiRowLayoutRowSize + 1 : ctx.renderedRowHeight)("igxForTrackBy", ctx.trackChanges);
            i0.ɵɵadvance(12);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && !ctx.isRowPinningToTop ? pinnedRecordsTemplate_r30 : null);
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(170, _c25, ctx));
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.shouldOverlayLoading ? 39 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag ? 40 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.calcHeight, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(172, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", !ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("outlet", igxBodyOverlayOutlet_r31)("actionText", ctx.resourceStrings.igx_grid_snackbar_addrow_actiontext)("displayTime", ctx.snackbarDisplayTime);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.resourceStrings.igx_grid_snackbar_addrow_label);
            i0.ɵɵadvance(5);
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasSummarizedColumns && ctx.rootSummariesEnabled ? 58 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px")("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", ctx.isHorizontalScrollHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px")("min-width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.unpinnedWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", ctx.EMPTY_DATA);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("float", "right")("width", ctx.pinnedWidth, "px")("min-width", ctx.pinnedWidth, "px");
            i0.ɵɵproperty("hidden", ctx.pinnedWidth === 0 || ctx.isPinningToStart);
            i0.ɵɵadvance(17);
            i0.ɵɵconditional(ctx.rowEditable ? 83 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵconditional(ctx.colResizingService.showResizer ? 92 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.platform.isElements ? 95 : -1);
          }
        },
        dependencies: [NgClass, NgStyle, NgTemplateOutlet, IgxGridGroupByAreaComponent, IgxGridHeaderRowComponent, IgxGridBodyDirective, IgxGridDragSelectDirective, IgxColumnMovingDropDirective, IgxGridForOfDirective, IgxTemplateOutletDirective, IgxGridRowComponent, IgxGridGroupByRowComponent, IgxSummaryRowComponent, IgxOverlayOutletDirective, IgxToggleDirective, IgxCircularProgressBarComponent, IgxSnackbarComponent, IgxButtonDirective, IgxRippleDirective, IgxIconComponent, IgxRowEditTabStopDirective, IgxGridColumnResizerComponent, IgxGridTransactionPipe, IgxHasVisibleColumnsPipe, IgxGridRowPinningPipe, IgxGridAddRowPipe, IgxGridRowClassesPipe, IgxGridRowStylesPipe, IgxSummaryDataPipe, IgxGridGroupingPipe, IgxGridPagingPipe, IgxGridSortingPipe, IgxGridFilteringPipe, IgxGridSummaryPipe, IgxGridDetailsPipe, IgxStringReplacePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxPivotColumnResizingService = /*#__PURE__*/(() => {
  class IgxPivotColumnResizingService extends IgxColumnResizingService {
    /**
     * @hidden
     */
    getColumnHeaderRenderedWidth() {
      return this.rowHeaderGroup.header.nativeElement.getBoundingClientRect().width;
    }
    _handlePixelResize(diff, column) {
      const rowDim = this.rowHeaderGroup.parent.rootDimension;
      if (!rowDim) return;
      const currentColWidth = parseFloat(column.width);
      const colMinWidth = column.minWidthPx;
      const colMaxWidth = column.maxWidthPx;
      let newWidth = currentColWidth;
      if (currentColWidth + diff < colMinWidth) {
        newWidth = colMinWidth;
      } else if (colMaxWidth && currentColWidth + diff > colMaxWidth) {
        newWidth = colMaxWidth;
      } else {
        newWidth = currentColWidth + diff;
      }
      this.rowHeaderGroup.grid.resizeRowDimensionPixels(rowDim, newWidth);
    }
    _handlePercentageResize() {}
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxPivotColumnResizingService_BaseFactory;
        return function IgxPivotColumnResizingService_Factory(__ngFactoryType__) {
          return (ɵIgxPivotColumnResizingService_BaseFactory || (ɵIgxPivotColumnResizingService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxPivotColumnResizingService)))(__ngFactoryType__ || IgxPivotColumnResizingService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxPivotColumnResizingService,
        factory: IgxPivotColumnResizingService.ɵfac
      });
    }
  }
  return IgxPivotColumnResizingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxPivotRowDimensionHeaderComponent = /*#__PURE__*/(() => {
  class IgxPivotRowDimensionHeaderComponent extends IgxGridHeaderComponent {
    constructor(grid, colResizingService, cdr, refInstance) {
      super(grid, colResizingService, cdr, refInstance);
      this.colResizingService = colResizingService;
      this.refInstance = refInstance;
      this.pivotGrid = this.grid;
      this.pivotGrid.dimensionsSortingExpressionsChange.pipe(takeUntil(this._destroy$)).subscribe(_ => this.setSortIndex());
    }
    ngAfterViewInit() {
      this.setSortIndex();
    }
    onClick(event) {
      event.preventDefault();
    }
    /**
     * @hidden @internal
     */
    get selectable() {
      return false;
    }
    /**
     * @hidden @internal
     */
    onSortingIconClick(event) {
      event.stopPropagation();
      const dim = this.pivotGrid.getRowDimensionByName(this.column.field);
      const startDirection = dim.sortDirection || SortingDirection.None;
      const direction = startDirection + 1 > SortingDirection.Desc ? SortingDirection.None : startDirection + 1;
      this.pivotGrid.sortDimension(dim, direction);
    }
    getSortDirection() {
      const dim = this.pivotGrid.getRowDimensionByName(this.column.field);
      this.sortDirection = dim?.sortDirection || SortingDirection.None;
    }
    setSortIndex() {
      if (this.column.sortable && this.sortIconContainer) {
        const visibleRows = this.pivotGrid.pivotUI.rowLayout === PivotRowLayoutType.Vertical ? this.pivotGrid.pivotConfiguration.rows : PivotUtil.flatten(this.pivotGrid.pivotConfiguration.rows);
        const dimIndex = visibleRows.findIndex(target => target.memberName === this.column.field);
        const dim = visibleRows[dimIndex];
        let newSortIndex = -1;
        if (dim.sortDirection) {
          let priorSortedDims = 0;
          for (let i = 0; i < dimIndex; i++) {
            if (visibleRows[i].sortDirection) {
              priorSortedDims++;
            }
          }
          // Sort index starts from 1.
          newSortIndex = priorSortedDims + 1;
        }
        this.sortIconContainer.nativeElement.setAttribute("data-sortIndex", newSortIndex >= 0 ? newSortIndex : "");
      }
    }
    static {
      this.ɵfac = function IgxPivotRowDimensionHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowDimensionHeaderComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxPivotColumnResizingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowDimensionHeaderComponent,
        selectors: [["igx-pivot-row-dimension-header"]],
        hostBindings: function IgxPivotRowDimensionHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxPivotRowDimensionHeaderComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 6,
        consts: [["defaultColumn", ""], ["defaultESFHeaderIconTemplate", ""], ["defaultSortHeaderIconTemplate", ""], ["sortIconContainer", ""], [1, "igx-grid-th__title"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid-th__icons"], [3, "title"], ["family", "default", "name", "more_vert"], ["family", "default", 3, "name"], [1, "sort-icon"], [3, "ngClass"], [1, "sort-icon", 3, "pointerdown", "click"], [3, "pointerdown", "click", "ngClass"]],
        template: function IgxPivotRowDimensionHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxPivotRowDimensionHeaderComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxPivotRowDimensionHeaderComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxPivotRowDimensionHeaderComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "span", 4);
            i0.ɵɵtemplate(7, IgxPivotRowDimensionHeaderComponent_ng_container_7_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, IgxPivotRowDimensionHeaderComponent_Conditional_8_Template, 3, 2, "div", 6);
          }
          if (rf & 2) {
            const defaultColumn_r4 = i0.ɵɵreference(1);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.column.headerTemplate ? ctx.column.headerTemplate : defaultColumn_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c155, ctx.column, ctx.column));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.column.columnGroup ? 8 : -1);
          }
        },
        dependencies: [IgxIconComponent, NgTemplateOutlet, NgClass, SortingIndexPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowDimensionHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * @internal
 */
let IgxPivotResizeHandleDirective = /*#__PURE__*/(() => {
  class IgxPivotResizeHandleDirective extends IgxResizeHandleDirective {
    /**
     * @hidden
     */
    set pivotColumn(value) {
      this.column = value;
    }
    get pivotColumn() {
      return this.column;
    }
    constructor(zone, element, colResizingService) {
      super(zone, element, colResizingService);
      this.colResizingService = colResizingService;
    }
    /**
     * @hidden
     */
    onDoubleClick() {
      this._dblClick = true;
      this.initResizeService();
      this.rowHeaderGroup.grid.autoSizeRowDimension(this.rowHeaderGroup.parent.rootDimension);
    }
    /**
     * @hidden
     */
    initResizeService(event = null) {
      super.initResizeService(event);
      this.colResizingService.rowHeaderGroup = this.rowHeaderGroup;
    }
    static {
      this.ɵfac = function IgxPivotResizeHandleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotResizeHandleDirective)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxPivotColumnResizingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPivotResizeHandleDirective,
        selectors: [["", "igxPivotResizeHandle", ""]],
        inputs: {
          pivotColumn: [0, "igxPivotResizeHandle", "pivotColumn"],
          rowHeaderGroup: [0, "igxPivotResizeHandleHeader", "rowHeaderGroup"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxPivotResizeHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxPivotRowHeaderGroupComponent = /*#__PURE__*/(() => {
  class IgxPivotRowHeaderGroupComponent extends IgxGridHeaderGroupComponent {
    constructor(cdRef, grid, elementRef, colResizingService, filteringService, platform, zone) {
      super(cdRef, grid, elementRef, colResizingService, filteringService, platform);
      this.cdRef = cdRef;
      this.grid = grid;
      this.elementRef = elementRef;
      this.colResizingService = colResizingService;
      this.zone = zone;
      /**
       * @hidden
       */
      this.userSelect = 'none';
    }
    set dimWidth(value) {
      this.column.width = value + 'px';
    }
    get dimWidth() {
      return parseFloat(this.column.width);
    }
    get parent() {
      return this;
    }
    get headerID() {
      return `${this.grid.id}_-2_${this.rootDimension.memberName}_${this.visibleIndex}`;
    }
    get title() {
      return this.rootDimension.displayName;
    }
    /**
     * @hidden
     * @internal
     */
    get visibleIndex() {
      const rows = this.grid.visibleRowDimensions;
      return rows.indexOf(this.rootDimension);
    }
    get active() {
      const nav = this.grid.navigation;
      const node = nav.activeNode;
      return node && !this.column.columnGroup ? nav.isRowDimensionHeaderActive && node.row === this.rowIndex && node.column === this.visibleIndex : false;
    }
    get sortAscendingStyle() {
      return this.rootDimension.sortDirection === SortingDirection.Asc;
    }
    get sortDescendingStyle() {
      return this.rootDimension.sortDirection === SortingDirection.Desc;
    }
    get sortableStyle() {
      return true;
    }
    get sortedStyle() {
      return this.rootDimension.sortDirection !== undefined && this.rootDimension.sortDirection !== SortingDirection.None;
    }
    get activeNode() {
      this.grid.navigation.isRowDimensionHeaderActive = true;
      this.grid.navigation.isRowHeaderActive = false;
      return {
        row: this.rowIndex,
        column: this.visibleIndex,
        level: null,
        mchCache: {
          level: 0,
          visibleIndex: this.visibleIndex
        },
        layout: null
      };
    }
    activate() {
      this.grid.navigation.setActiveNode(this.activeNode);
    }
    /**
     * @hidden @internal
     */
    pointerdown(_event) {
      this.activate();
    }
    /**
     * @hidden @internal
     */
    onMouseDown(_event) {
      this.activate();
    }
    get selectable() {
      return false;
    }
    static {
      this.ɵfac = function IgxPivotRowHeaderGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowHeaderGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxPivotColumnResizingService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowHeaderGroupComponent,
        selectors: [["igx-pivot-row-header-group"]],
        viewQuery: function IgxPivotRowHeaderGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxPivotRowDimensionHeaderComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
          }
        },
        hostVars: 14,
        hostBindings: function IgxPivotRowHeaderGroupComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.headerID)("title", ctx.title);
            i0.ɵɵstyleProp("user-select", ctx.userSelect);
            i0.ɵɵclassProp("igx-grid-th--active", ctx.active)("asc", ctx.sortAscendingStyle)("desc", ctx.sortDescendingStyle)("igx-grid-th--sortable", ctx.sortableStyle)("igx-grid-th--sorted", ctx.sortedStyle);
          }
        },
        inputs: {
          rowIndex: "rowIndex",
          dimWidth: "dimWidth",
          rootDimension: "rootDimension"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 1,
        consts: [["defaultColumn", ""], ["defaultCollapseIndicator", ""], [1, "igx-grid-th__group-title", 3, "title"], ["family", "default", 3, "name"], [1, "igx-grid-th__drop-indicator-left"], ["role", "columnheader", 1, "igx-grid-th--fw", 3, "pointerdown", "keydown", "id", "ngClass", "ngStyle", "igxColumnMovingDrag", "ghostHost", "igxColumnMovingDrop", "column"], [1, "igx-grid-th__resize-handle", 3, "igxPivotResizeHandle", "igxPivotResizeHandleHeader", "cursor"], [1, "igx-grid-th__drop-indicator-right"], [1, "igx-grid-th__resize-handle", 3, "igxPivotResizeHandle", "igxPivotResizeHandleHeader"]],
        template: function IgxPivotRowHeaderGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxPivotRowHeaderGroupComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxPivotRowHeaderGroupComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxPivotRowHeaderGroupComponent_Conditional_4_Template, 5, 15);
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(!ctx.column.columnGroup ? 4 : -1);
          }
        },
        dependencies: [IgxIconComponent, IgxPivotRowDimensionHeaderComponent, NgClass, NgStyle, IgxColumnMovingDragDirective, IgxColumnMovingDropDirective, IgxPivotResizeHandleDirective, IgxHeaderGroupStylePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowHeaderGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 *
 * For all intents & purposes treat this component as what a <thead> usually is in the default <table> element.
 *
 * This container holds the pivot grid header elements and their behavior/interactions.
 *
 * @hidden @internal
 */
let IgxPivotHeaderRowComponent = /*#__PURE__*/(() => {
  class IgxPivotHeaderRowComponent extends IgxGridHeaderRowComponent {
    get headerForOf() {
      return this.headerContainers?.last;
    }
    constructor(grid, ref, cdr, renderer) {
      super(ref, cdr);
      this.grid = grid;
      this.renderer = renderer;
      this.aggregateList = [];
      this.filterDropdownDimensions = new Set();
      this.filterAreaDimensions = new Set();
      this._dropPos = DropPosition.AfterDropTarget;
      this._subMenuPositionSettings = {
        verticalStartPoint: VerticalAlignment.Bottom,
        closeAnimation: undefined
      };
      this._subMenuOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new AutoPositionStrategy(this._subMenuPositionSettings),
        scrollStrategy: new AbsoluteScrollStrategy()
      };
      /**
      * @hidden
      * @internal
      * Default is a single empty level since default depth is 1
      */
      this.columnDimensionsByLevel = [[]];
    }
    /**
    * @hidden @internal
    */
    get isFiltersButton() {
      let chipsWidth = 0;
      this.filterDropdownDimensions.clear();
      this.filterAreaDimensions.clear();
      if (this.filterArea?.chipsList && this.filterArea.chipsList.length !== 0) {
        const styles = getComputedStyle(this.pivotFilterContainer.nativeElement);
        const containerPaddings = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
        chipsWidth += containerPaddings + (this.filtersButton && this.filterArea?.chipsList.length > 1 ? this.filtersButton.el.nativeElement.getBoundingClientRect().width : 0);
        this.filterArea.chipsList.forEach(chip => {
          const dim = this.grid.filterDimensions.find(x => x.memberName === chip.id);
          if (dim) {
            // 8 px margin between chips
            const currentChipWidth = chip.nativeElement.getBoundingClientRect().width + 8;
            if (chipsWidth + currentChipWidth < this.grid.pivotRowWidths) {
              this.filterAreaDimensions.add(dim);
            } else {
              this.filterDropdownDimensions.add(dim);
            }
            chipsWidth += currentChipWidth;
          }
        });
        return this.filterDropdownDimensions.size > 0;
      }
      return false;
    }
    /**
    * @hidden
    * @internal
    */
    get totalDepth() {
      const columnDimensions = this.grid.columnDimensions;
      if (columnDimensions.length === 0) {
        return 1;
      }
      let totalDepth = columnDimensions.map(x => PivotUtil.getDimensionDepth(x) + 1).reduce((acc, val) => acc + val);
      if (this.grid.hasMultipleValues) {
        totalDepth += 1;
      }
      return totalDepth;
    }
    /**
    * @hidden
    * @internal
    */
    get maxContainerHeight() {
      return this.totalDepth * this.grid.renderedRowHeight;
    }
    /**
    * @hidden
    * @internal
    */
    calcHeight(col, index) {
      return !col.columnGroup && col.level < this.totalDepth && col.level === index ? (this.totalDepth - col.level) * this.grid.rowHeight : this.grid.rowHeight;
    }
    /**
    * @hidden
    * @internal
    */
    isDuplicateOfExistingParent(col, lvl) {
      const parentCollection = lvl > 0 ? this.columnDimensionsByLevel[lvl - 1] : [];
      const duplicate = parentCollection.indexOf(col) !== -1;
      return duplicate;
    }
    /**
    * @hidden
    * @internal
    */
    isMultiRow(col, lvl) {
      const isLeaf = !col.columnGroup;
      return isLeaf && lvl !== this.totalDepth - 1;
    }
    /**
    * @hidden
    * @internal
    */
    populateColumnDimensionsByLevel() {
      const res = [];
      for (let i = 0; i < this.totalDepth; i++) {
        res[i] = [];
      }
      const cols = this.unpinnedColumnCollection;
      // populate column dimension matrix recursively
      this.populateDimensionRecursively(cols.filter(x => x.level === 0), 0, res);
      this.columnDimensionsByLevel = res;
    }
    populateDimensionRecursively(currentLevelColumns, level = 0, res) {
      currentLevelColumns.forEach(col => {
        if (res[level]) {
          res[level].push(col);
          if (col.columnGroup && col.children.length > 0) {
            const visibleColumns = col.children.toArray().filter(x => !x.hidden);
            this.populateDimensionRecursively(visibleColumns, level + 1, res);
          } else if (level < this.totalDepth - 1) {
            for (let i = level + 1; i <= this.totalDepth - 1; i++) {
              res[i].push(col);
            }
          }
        }
      });
    }
    /**
    * @hidden
    * @internal
    */
    ngOnChanges(changes) {
      if (changes.unpinnedColumnCollection) {
        this.populateColumnDimensionsByLevel();
      }
    }
    /**
    * @hidden
    * @internal
    */
    onDimDragStart(event, area) {
      this.cdr.detectChanges();
      for (const chip of this.notificationChips) {
        const parent = chip.nativeElement.parentElement;
        if (area.chipsList.toArray().indexOf(chip) === -1 && parent.children.length > 0 && parent.children.item(0).id !== 'empty') {
          chip.nativeElement.hidden = false;
          parent.parentElement.scrollTo({
            left: chip.nativeElement.offsetLeft
          });
        }
      }
    }
    /**
    * @hidden
    * @internal
    */
    onDimDragEnd() {
      for (const chip of this.notificationChips) {
        chip.nativeElement.hidden = true;
      }
    }
    /**
    * @hidden
    * @internal
    */
    getAreaHeight(area) {
      const chips = area.chipsList;
      return chips && chips.length > 0 ? chips.first.nativeElement.offsetHeight : 0;
    }
    /**
    * @hidden
    * @internal
    */
    rowRemoved(event) {
      const row = this.grid.pivotConfiguration.rows.find(x => x.memberName === event.owner.id);
      this.grid.toggleDimension(row);
    }
    /**
    * @hidden
    * @internal
    */
    columnRemoved(event) {
      const col = this.grid.pivotConfiguration.columns.find(x => x.memberName === event.owner.id);
      this.grid.toggleDimension(col);
    }
    /**
    * @hidden
    * @internal
    */
    valueRemoved(event) {
      const value = this.grid.pivotConfiguration.values.find(x => x.member === event.owner.id || x.displayName === event.owner.id);
      this.grid.toggleValue(value);
    }
    /**
    * @hidden
    * @internal
    */
    filterRemoved(event) {
      const filter = this.grid.pivotConfiguration.filters.find(x => x.memberName === event.owner.id);
      this.grid.toggleDimension(filter);
      if (this.filterDropdownDimensions.size > 0) {
        this.onFiltersAreaDropdownClick({
          target: this.filtersButton.el.nativeElement
        }, undefined, false);
      } else {
        this.grid.filteringService.hideESF();
      }
    }
    onFiltersSelectionChanged(event) {
      this.dropdownChips.chipsList.forEach(chip => {
        if (chip.id !== event.owner.id) {
          chip.selected = false;
        }
      });
      this.onFiltersAreaDropdownClick({
        target: this.filtersButton.el.nativeElement
      }, this.grid.filterDimensions.find(dim => dim.memberName === event.owner.id), false);
    }
    /**
    * @hidden
    * @internal
    */
    onFilteringIconPointerDown(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    /**
    * @hidden
    * @internal
    */
    onFilteringIconClick(event, dimension) {
      event.stopPropagation();
      event.preventDefault();
      const dim = dimension;
      const col = this.grid.dimensionDataColumns.find(x => x.field === dim.memberName || x.field === dim.member);
      this.grid.filteringService.toggleFilterDropdown(event.target, col);
    }
    /**
    * @hidden
    * @internal
    */
    onSummaryClick(eventArgs, value, dropdown, chip) {
      this._subMenuOverlaySettings.target = eventArgs.currentTarget;
      this.updateDropDown(value, dropdown, chip);
    }
    /**
     * @hidden @internal
     */
    onFiltersAreaDropdownClick(event, dimension, shouldReattach = true) {
      const dim = dimension || this.filterDropdownDimensions.values().next().value;
      const col = this.grid.dimensionDataColumns.find(x => x.field === dim.memberName || x.field === dim.member);
      if (shouldReattach) {
        this.dropdownChips.chipsList.forEach(chip => {
          chip.selected = false;
        });
        this.dropdownChips.chipsList.first.selected = true;
      }
      this.grid.filteringService.toggleFiltersESF(this.esf, event.target, col, shouldReattach);
    }
    /**
    * @hidden
    * @internal
    */
    onAggregationChange(event) {
      if (!this.isSelected(event.newSelection.value)) {
        this.value.aggregate = event.newSelection.value;
        this.grid.pipeTrigger++;
      }
    }
    /**
    * @hidden
    * @internal
    */
    isSelected(val) {
      return this.value.aggregate.key === val.key;
    }
    /**
    * @hidden
    * @internal
    */
    onChipSort(_event, dimension) {
      if (dimension.sortable === undefined || dimension.sortable) {
        const startDirection = dimension.sortDirection || SortingDirection.None;
        const direction = startDirection + 1 > SortingDirection.Desc ? SortingDirection.None : startDirection + 1;
        this.grid.sortDimension(dimension, direction);
      }
    }
    /**
    * @hidden
    * @internal
    */
    onDimDragOver(event, dimension) {
      if (!event.dragChip || !event.dragChip.data?.pivotArea) return;
      const typeMismatch = dimension !== undefined ? this.grid.pivotConfiguration.values.find(x => x.member === event.dragChip.id || x.displayName === event.dragChip.id) : !this.grid.pivotConfiguration.values.find(x => x.member === event.dragChip.id || x.displayName === event.dragChip.id);
      if (typeMismatch) {
        // cannot drag between dimensions and value
        return;
      }
      // if we are in the left half of the chip, drop on the left
      // else drop on the right of the chip
      const clientRect = event.owner.nativeElement.getBoundingClientRect();
      const pos = clientRect.width / 2;
      this._dropPos = event.originalEvent.offsetX > pos ? DropPosition.AfterDropTarget : DropPosition.BeforeDropTarget;
      if (this._dropPos === DropPosition.AfterDropTarget) {
        event.owner.nativeElement.previousElementSibling.style.visibility = 'hidden';
        event.owner.nativeElement.nextElementSibling.style.visibility = '';
      } else {
        event.owner.nativeElement.nextElementSibling.style.visibility = 'hidden';
        event.owner.nativeElement.previousElementSibling.style.visibility = '';
      }
    }
    /**
    * @hidden
    * @internal
    */
    onDimDragLeave(event) {
      event.owner.nativeElement.previousElementSibling.style.visibility = 'hidden';
      event.owner.nativeElement.nextElementSibling.style.visibility = 'hidden';
      this._dropPos = DropPosition.AfterDropTarget;
    }
    /**
    * @hidden
    * @internal
    */
    onAreaDragLeave(event, area) {
      const dataChips = area.chipsList.toArray().filter(x => this.notificationChips.toArray().indexOf(x) === -1);
      dataChips.forEach(element => {
        if (element.nativeElement.previousElementSibling) {
          element.nativeElement.previousElementSibling.style.visibility = 'hidden';
        }
        if (element.nativeElement.nextElementSibling) {
          element.nativeElement.nextElementSibling.style.visibility = 'hidden';
        }
      });
    }
    /**
    * @hidden
    * @internal
    */
    onValueDrop(event, area) {
      if (!(event.dragChip && event.dragChip.data?.pivotArea) && !(event.dragData?.chip && !!event.dragData.chip.data.pivotArea)) return;
      //values can only be reordered
      const values = this.grid.pivotConfiguration.values;
      const dragId = event.dragChip?.id || event.dragData?.chip.id;
      const chipsArray = area.chipsList.toArray();
      let chipIndex = chipsArray.indexOf(event.owner) !== -1 ? chipsArray.indexOf(event.owner) : chipsArray.length;
      chipIndex = this._dropPos === DropPosition.AfterDropTarget ? chipIndex + 1 : chipIndex;
      const value = values.find(x => x.member === dragId || x.displayName === dragId);
      if (value) {
        const dragChipIndex = chipsArray.indexOf(event.dragChip || event.dragData.chip);
        this.grid.moveValue(value, dragChipIndex >= chipIndex ? chipIndex : chipIndex - 1);
      }
    }
    /**
    * @hidden
    * @internal
    */
    onDimDrop(event, area, dimensionType) {
      if (!(event.dragChip && event.dragChip.data?.pivotArea) && !(event.dragData?.chip && !!event.dragData.chip.data.pivotArea)) return;
      const dragId = event.dragChip?.id || event.dragData?.chip.id;
      const currentDim = this.grid.getDimensionsByType(dimensionType);
      const chipsArray = area.chipsList.toArray();
      const chip = chipsArray.find(x => x.id === dragId);
      const isNewChip = chip === undefined;
      const isReorder = event.owner.id !== undefined;
      //const chipIndex = chipsArray.indexOf(event.owner) !== -1 ? chipsArray.indexOf(event.owner) : chipsArray.length;
      const chipIndex = currentDim.findIndex(x => x.memberName === event.owner.id) !== -1 ? currentDim.findIndex(x => x.memberName === event.owner.id) : currentDim.length;
      const targetIndex = this._dropPos === DropPosition.AfterDropTarget ? chipIndex + 1 : chipIndex;
      if (isNewChip) {
        // chip moved from an external collection
        const dim = this.grid.allDimensions.find(x => x && x.memberName === dragId);
        if (!dim) {
          // you have dragged something that is not a dimension
          return;
        }
        this.grid.moveDimension(dim, dimensionType, targetIndex);
      } else if (isReorder) {
        // chip from same collection, reordered.
        const newDim = currentDim.find(x => x.memberName === dragId);
        const dragChipIndex = currentDim.findIndex(x => x.memberName === dragId);
        this.grid.moveDimension(newDim, dimensionType, dragChipIndex > chipIndex ? targetIndex : targetIndex - 1);
      }
      this.grid.pipeTrigger++;
      this.grid.dimensionsChange.emit({
        dimensions: currentDim,
        dimensionCollectionType: dimensionType
      });
      // clean states
      this.onDimDragEnd();
      this.onAreaDragLeave(event, area);
    }
    updateDropDown(value, dropdown, chip) {
      this.value = value;
      dropdown.width = chip.nativeElement.clientWidth + 'px';
      this.aggregateList = PivotUtil.getAggregateList(value, this.grid);
      this.cdr.detectChanges();
      dropdown.open(this._subMenuOverlaySettings);
    }
    getRowDimensionColumn(dim) {
      return this.grid.dimensionDataColumns ? this.grid.dimensionDataColumns.find(col => col.field === dim.memberName) : null;
    }
    static {
      this.ɵfac = function IgxPivotHeaderRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotHeaderRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotHeaderRowComponent,
        selectors: [["igx-pivot-header-row"]],
        viewQuery: function IgxPivotHeaderRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c240, 5);
            i0.ɵɵviewQuery(_c241, 5);
            i0.ɵɵviewQuery(_c242, 5);
            i0.ɵɵviewQuery(_c243, 5);
            i0.ɵɵviewQuery(_c244, 5);
            i0.ɵɵviewQuery(_c245, 5);
            i0.ɵɵviewQuery(_c246, 5);
            i0.ɵɵviewQuery(_c175, 5, IgxGridForOfDirective);
            i0.ɵɵviewQuery(_c247, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.esf = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filtersButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownChips = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pivotFilterContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pivotRowContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notificationChips = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContainers = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDimensionHeaders = _t);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 41,
        vars: 27,
        consts: [["dropdown", ""], ["esf", ""], ["dropdownChips", ""], ["filterAreaHidden", ""], ["valueChipDefaultTemplate", ""], ["pivotFilterContainer", ""], ["filterArea", ""], ["notifyChip", ""], ["filterIcon", ""], ["pivotRowContainer", ""], ["rowArea", ""], ["pivotColumnContainer", ""], ["colArea", ""], ["pivotValueContainer", ""], ["valueArea", ""], ["notifyValueChip", ""], ["currChip", ""], ["pivotContainer", ""], ["rowDimensionHeaders", ""], ["headerVirtualContainer", ""], ["role", "row", 1, "igx-grid-thead__wrapper", "igx-grid-thead__wrapper--pivot"], ["role", "row", 1, "igx-grid__tr"], [1, "igx-grid__tr-pivot--filter-container"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--filter", 3, "min-width", "max-width"], [1, "igx-grid__tr-pivot--drop-row-area"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--small-row-area", 3, "width"], [1, "igx-grid__tr-pivot-group"], ["igxDrop", "", 1, "igx-grid__tr-pivot"], ["role", "rowgroup", 1, "igx-grid-thead__wrapper"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--row-area", 3, "width"], ["role", "row", 1, "igx-grid__tr", "igx-grid__tr-header-row", 3, "width"], [1, "igx-grid-thead--virtualizationWrapper", 3, "click"], [1, "igx-grid-thead__group", "igx-grid-thead--virtualizationContainer", 3, "height", "width"], [1, "igx-grid-thead__thumb", 3, "hidden"], [3, "selectionChanging"], [3, "selected", "value"], [3, "hidden"], [3, "maxHeight", "minHeight"], ["igxExcelStyleColumnOperations", ""], [3, "id", "removable", "selectable", "selected"], [2, "visibility", "hidden", "position", "absolute", "top", "-10000px"], ["droppable", "true"], [3, "id", "draggable", "removable"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--filter", 3, "igxDragLeave", "dropped", "pointerdown"], ["id", "empty", "igxDrop", "", 1, "igx-grid__pivot-empty-chip-area"], ["igxDrop", "", 3, "dragDrop", "hidden"], [1, "igx-grid__pivot-filter-toggle"], ["id", "empty", "igxDrop", "", 1, "igx-grid__pivot-empty-chip-area", 3, "dropped"], [1, "igx-grid__tr-pivot--chip_drop_indicator"], [3, "remove", "dragOver", "dragLeave", "dragDrop", "moveStart", "moveEnd", "id", "draggable", "data", "removable"], ["family", "default", "name", "filter_list", "igxPrefix", "", 3, "pointerdown", "click"], [1, "igx-grid__tr-pivot--chip_drop_indicator", 3, "height"], ["family", "default", "name", "filter_list", 3, "pointerdown", "click"], [3, "value"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--small-row-area", 3, "igxDragLeave", "dropped"], [3, "remove", "dragLeave", "dragDrop", "dragOver", "moveStart", "moveEnd", "click", "draggable", "id", "data", "removable"], ["igxPrefix", "", "family", "default", "name", "table_rows"], ["family", "default", "igxSuffix", "", 3, "name"], ["igxDrop", "", 1, "igx-grid__tr-pivot", 3, "dropped", "igxDragLeave"], [3, "remove", "dragOver", "dragLeave", "dragDrop", "moveStart", "moveEnd", "click", "draggable", "id", "data", "removable"], ["family", "default", "name", "view_column", "igxPrefix", ""], ["igxDrop", "", 1, "igx-grid__tr-pivot", 3, "pointerdown", "dropped", "igxDragLeave"], [3, "remove", "dragLeave", "dragOver", "dragDrop", "draggable", "id", "data", "removable"], ["igxPrefix", "", 1, "igx-grid__tr-pivot-toggle-icons", 3, "click", "pointerdown", "igxDropDownItemNavigation"], ["family", "default", "name", "functions"], ["family", "default", "name", "arrow_drop_down"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["igxDrop", "", 1, "igx-grid__tr-pivot", "igx-grid__tr-pivot--row-area", 3, "igxDragLeave", "dropped", "pointerdown"], ["role", "row", 1, "igx-grid__tr", "igx-grid__tr-header-row"], [3, "ngClass", "ngStyle", "min-width", "flex-basis", "column", "rootDimension", "dimWidth", "rowIndex"], [3, "ngClass", "ngStyle", "column", "rootDimension", "dimWidth", "rowIndex"], [3, "ngClass", "ngStyle", "column", "min-width", "flex-basis"], [3, "pointerdown", "ngClass", "ngStyle", "column"], [1, "igx-grid-thead__group", "igx-grid-thead--virtualizationContainer"], ["igxGridFor", "", 3, "igxGridForOf", "igxGridForOfUniqueSizeCache", "igxForScrollContainer", "igxForContainerSize", "igxForTrackBy", "igxForSizePropName", "igxForScrollOrientation"], [3, "ngClass", "ngStyle", "column"], [3, "ngClass", "ngStyle", "column", "min-width", "flex-basis", "left"], [3, "remove", "chipClick", "id", "removable", "selectable", "selected"], [3, "remove", "id", "draggable", "removable"], ["family", "default", "name", "filter_list", "igxPrefix", ""]],
        template: function IgxPivotHeaderRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div")(1, "div", 20)(2, "div", 21)(3, "div", 22);
            i0.ɵɵtemplate(4, IgxPivotHeaderRowComponent_Conditional_4_Template, 11, 8, "div", 23);
            i0.ɵɵelementStart(5, "div", 24);
            i0.ɵɵtemplate(6, IgxPivotHeaderRowComponent_Conditional_6_Template, 10, 5, "div", 25);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 26);
            i0.ɵɵtemplate(8, IgxPivotHeaderRowComponent_Conditional_8_Template, 10, 3, "div", 27)(9, IgxPivotHeaderRowComponent_Conditional_9_Template, 10, 3, "div", 27);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 28)(11, "div", 21);
            i0.ɵɵtemplate(12, IgxPivotHeaderRowComponent_Conditional_12_Template, 5, 3, "div", 29)(13, IgxPivotHeaderRowComponent_Conditional_13_Template, 3, 2, "div", 30)(14, IgxPivotHeaderRowComponent_Conditional_14_Template, 3, 2);
            i0.ɵɵelementStart(15, "div", 31);
            i0.ɵɵlistener("click", function IgxPivotHeaderRowComponent_Template_div_click_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.grid.navigation.focusOutRowHeader($event));
            });
            i0.ɵɵrepeaterCreate(16, IgxPivotHeaderRowComponent_For_17_Template, 3, 11, "div", 32, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(18, IgxPivotHeaderRowComponent_Conditional_18_Template, 3, 2);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(19, "div", 33);
            i0.ɵɵelementStart(20, "igx-drop-down", 34, 0);
            i0.ɵɵlistener("selectionChanging", function IgxPivotHeaderRowComponent_Template_igx_drop_down_selectionChanging_20_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onAggregationChange($event));
            });
            i0.ɵɵrepeaterCreate(22, IgxPivotHeaderRowComponent_For_23_Template, 2, 3, "igx-drop-down-item", 35, _forTrack12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "div", 36)(25, "igx-grid-excel-style-filtering", 37, 1)(27, "div", 38)(28, "igx-chips-area", null, 2);
            i0.ɵɵrepeaterCreate(30, IgxPivotHeaderRowComponent_For_31_Template, 2, 5, "igx-chip", 39, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "igx-excel-style-filter-operations");
            i0.ɵɵelement(33, "igx-excel-style-search");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(34, "div", 40)(35, "igx-chips-area", 41, 3);
            i0.ɵɵrepeaterCreate(37, IgxPivotHeaderRowComponent_For_38_Template, 3, 4, "igx-chip", 42, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(39, IgxPivotHeaderRowComponent_ng_template_39_Template, 1, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.grid.pivotUI.showConfiguration ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.grid.pivotUI.showConfiguration && ctx.grid.pivotUI.showRowHeaders ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.grid.pivotUI.showConfiguration ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.pivotUI.showConfiguration ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵclassProp("igx-grid__tr--mrl", ctx.hasMRL);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.grid.pivotUI.showRowHeaders || ctx.grid.rowDimensions.length === 0 ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.grid.pivotUI.showRowHeaders && ctx.grid.visibleRowDimensions.length > 0 ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.pinnedColumnCollection.length && ctx.grid.isPinningToStart ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("max-height", ctx.maxContainerHeight, "px");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.columnDimensionsByLevel);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.pinnedColumnCollection.length && !ctx.grid.isPinningToStart ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.grid.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.grid.hasVerticalScroll());
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.aggregateList);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("maxHeight", ctx.grid.excelStyleFilterMaxHeight)("minHeight", ctx.grid.excelStyleFilterMinHeight);
            i0.ɵɵadvance(5);
            i0.ɵɵrepeater(ctx.filterDropdownDimensions);
            i0.ɵɵadvance(7);
            i0.ɵɵrepeater(ctx.grid.filterDimensions);
          }
        },
        dependencies: [IgxDropDirective, IgxChipsAreaComponent, IgxChipComponent, IgxIconComponent, IgxPrefixDirective, IgxBadgeComponent, IgxSuffixDirective, IgxDropDownItemNavigationDirective, NgTemplateOutlet, IgxGridHeaderGroupComponent, NgClass, NgStyle, IgxGridForOfDirective, IgxDropDownComponent, IgxDropDownItemComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleSearchComponent, IgxHeaderGroupWidthPipe, IgxHeaderGroupStylePipe, IgxGridTopLevelColumns, IgxPivotRowHeaderGroupComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotHeaderRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* csSuppress */
let NoopPivotDimensionsStrategy = /*#__PURE__*/(() => {
  class NoopPivotDimensionsStrategy {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new NoopPivotDimensionsStrategy());
    }
    process(collection, _, __) {
      return collection;
    }
  }
  return NoopPivotDimensionsStrategy;
})();
let PivotRowDimensionsStrategy = /*#__PURE__*/(() => {
  class PivotRowDimensionsStrategy {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new PivotRowDimensionsStrategy());
    }
    process(collection, rows, values, cloneStrategy, pivotKeys = DEFAULT_PIVOT_KEYS) {
      let hierarchies;
      let data;
      const prevRowDims = [];
      const currRows = cloneArray(rows, true);
      PivotUtil.assignLevels(currRows);
      if (currRows.length === 0) {
        hierarchies = PivotUtil.getFieldsHierarchy(collection, [{
          memberName: '',
          enabled: true
        }], PivotDimensionType.Row, pivotKeys, cloneStrategy);
        // generate flat data from the hierarchies
        data = PivotUtil.processHierarchy(hierarchies, pivotKeys, 0, true);
        return data;
      }
      for (const row of currRows) {
        if (!data) {
          // build hierarchies - groups and subgroups
          hierarchies = PivotUtil.getFieldsHierarchy(collection, [row], PivotDimensionType.Row, pivotKeys, cloneStrategy);
          // generate flat data from the hierarchies
          data = PivotUtil.processHierarchy(hierarchies, pivotKeys, 0, true);
          prevRowDims.push(row);
        } else {
          PivotUtil.processGroups(data, row, pivotKeys, cloneStrategy);
        }
      }
      return data;
    }
  }
  return PivotRowDimensionsStrategy;
})();
let PivotColumnDimensionsStrategy = /*#__PURE__*/(() => {
  class PivotColumnDimensionsStrategy {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new PivotColumnDimensionsStrategy());
    }
    process(collection, columns, values, cloneStrategy, pivotKeys = DEFAULT_PIVOT_KEYS) {
      const res = this.processHierarchy(collection, columns, values, pivotKeys, cloneStrategy);
      return res;
    }
    processHierarchy(collection, columns, values, pivotKeys, cloneStrategy) {
      const result = [];
      collection.forEach(rec => {
        // apply aggregations based on the created groups and generate column fields based on the hierarchies
        this.groupColumns(rec, columns, values, pivotKeys, cloneStrategy);
        result.push(rec);
      });
      return result;
    }
    groupColumns(rec, columns, values, pivotKeys, cloneStrategy) {
      const children = rec.children;
      if (children && children.size > 0) {
        children.forEach(childRecs => {
          if (childRecs) {
            childRecs.forEach(child => {
              this.groupColumns(child, columns, values, pivotKeys, cloneStrategy);
            });
          }
        });
      }
      this.applyAggregates(rec, columns, values, pivotKeys, cloneStrategy);
    }
    applyAggregates(rec, columns, values, pivotKeys, cloneStrategy) {
      const leafRecords = this.getLeafs(rec.records, pivotKeys);
      const hierarchy = PivotUtil.getFieldsHierarchy(leafRecords, columns, PivotDimensionType.Column, pivotKeys, cloneStrategy);
      PivotUtil.applyAggregations(rec, hierarchy, values, pivotKeys);
    }
    getLeafs(records, pivotKeys) {
      let leafs = [];
      for (const rec of records) {
        if (rec[pivotKeys.records]) {
          leafs = leafs.concat(this.getLeafs(rec[pivotKeys.records], pivotKeys));
        } else {
          leafs.push(rec);
        }
      }
      return leafs;
    }
  }
  return PivotColumnDimensionsStrategy;
})();
class DimensionValuesFilteringStrategy extends FilteringStrategy {
  /**
   * Creates a new instance of FormattedValuesFilteringStrategy.
   *
   * @param fields An array of column field names that should be formatted.
   * If omitted the values of all columns which has formatter will be formatted.
   */
  constructor(fields) {
    super();
    this.fields = fields;
  }
  getFieldValue(rec, fieldName, _isDate = false, _isTime = false, grid) {
    const allDimensions = grid.allDimensions;
    const enabledDimensions = allDimensions.filter(x => x && x.enabled);
    const dim = PivotUtil.flatten(enabledDimensions).find(x => x.memberName === fieldName);
    const value = dim.childLevel ? this._getDimensionValueHierarchy(dim, rec).map(x => `[` + x + `]`).join('.') : PivotUtil.extractValueFromDimension(dim, rec);
    return value;
  }
  getFilterItems(column, tree) {
    const grid = column.grid;
    const enabledDimensions = grid.allDimensions.filter(x => x && x.enabled);
    const data = column.grid.gridAPI.filterDataByExpressions(tree);
    const dim = enabledDimensions.find(x => x.memberName === column.field);
    const allValuesHierarchy = PivotUtil.getFieldsHierarchy(data, [dim], PivotDimensionType.Column, grid.pivotKeys, grid.pivotValueCloneStrategy);
    const isNoop = grid.pivotConfiguration.columnStrategy instanceof NoopPivotDimensionsStrategy || grid.pivotConfiguration.rowStrategy instanceof NoopPivotDimensionsStrategy;
    const items = !isNoop ? this._getFilterItems(allValuesHierarchy, grid.pivotKeys) : [{
      value: ''
    }];
    return Promise.resolve(items);
  }
  _getFilterItems(hierarchy, pivotKeys) {
    const items = [];
    hierarchy.forEach(value => {
      const val = value.value;
      const path = val.split(pivotKeys.columnDimensionSeparator);
      const hierarchicalValue = path.length > 1 ? path.map(x => `[` + x + `]`).join('.') : val;
      const text = path[path.length - 1];
      items.push({
        value: hierarchicalValue,
        label: text,
        children: this._getFilterItems(value.children, pivotKeys)
      });
    });
    return items;
  }
  _getDimensionValueHierarchy(dim, rec) {
    let path = [];
    const value = PivotUtil.extractValueFromDimension(dim, rec);
    path.push(value);
    if (dim.childLevel) {
      const childVals = this._getDimensionValueHierarchy(dim.childLevel, rec);
      path = path.concat(childVals);
    }
    return path;
  }
}
let IgxPivotGridNavigationService = /*#__PURE__*/(() => {
  class IgxPivotGridNavigationService extends IgxGridNavigationService {
    constructor() {
      super(...arguments);
      this.isRowHeaderActive = false;
      this.isRowDimensionHeaderActive = false;
    }
    get lastRowDimensionsIndex() {
      return this.grid.visibleRowDimensions.length - 1;
    }
    get lastRowDimensionMRLRowIndex() {
      return this.grid.verticalRowDimScrollContainers.first.igxGridForOf.length - 1;
    }
    focusOutRowHeader() {
      this.isRowHeaderActive = false;
      this.isRowDimensionHeaderActive = false;
    }
    async handleNavigation(event) {
      if (this.isRowHeaderActive) {
        const key = event.key.toLowerCase();
        const ctrl = event.ctrlKey;
        if (!HEADER_KEYS.has(key)) {
          return;
        }
        event.preventDefault();
        const newActiveNode = {
          row: this.activeNode.row,
          column: this.activeNode.column,
          level: null,
          mchCache: null,
          layout: this.activeNode.layout
        };
        if (event.altKey) {
          this.handleAlt(key, event);
          return;
        }
        let verticalContainer;
        if (this.grid.hasHorizontalLayout) {
          let newPosition = {
            row: this.activeNode.row,
            column: this.activeNode.column,
            layout: this.activeNode.layout
          };
          verticalContainer = this.grid.verticalRowDimScrollContainers.first;
          if (key.includes('left')) {
            newPosition = await this.getNextHorizontalPosition(true, ctrl);
          }
          if (key.includes('right')) {
            newPosition = await this.getNextHorizontalPosition(false, ctrl);
          }
          if (key.includes('up') || key === 'home') {
            newPosition = await this.getNextVerticalPosition(true, ctrl || key === 'home', key === 'home');
          }
          if (key.includes('down') || key === 'end') {
            newPosition = await this.getNextVerticalPosition(false, ctrl || key === 'end', key === 'end');
          }
          newActiveNode.row = newPosition.row;
          newActiveNode.column = newPosition.column;
          newActiveNode.layout = newPosition.layout;
        } else {
          if ((key.includes('left') || key === 'home') && this.activeNode.column > 0) {
            newActiveNode.column = ctrl || key === 'home' ? 0 : this.activeNode.column - 1;
          }
          if ((key.includes('right') || key === 'end') && this.activeNode.column < this.lastRowDimensionsIndex) {
            newActiveNode.column = ctrl || key === 'end' ? this.lastRowDimensionsIndex : this.activeNode.column + 1;
          }
          verticalContainer = this.grid.verticalRowDimScrollContainers.toArray()[newActiveNode.column];
          if (key.includes('up')) {
            if (ctrl) {
              newActiveNode.row = 0;
            } else if (this.activeNode.row > 0) {
              newActiveNode.row = this.activeNode.row - 1;
            } else {
              newActiveNode.row = -1;
              newActiveNode.column = newActiveNode.layout ? newActiveNode.layout.colStart - 1 : 0;
              newActiveNode.layout = null;
              this.isRowDimensionHeaderActive = true;
              this.isRowHeaderActive = false;
              this.grid.theadRow.nativeElement.focus();
            }
          }
          if (key.includes('down') && this.activeNode.row < this.findLastDataRowIndex()) {
            newActiveNode.row = ctrl ? verticalContainer.igxForOf.length - 1 : Math.min(this.activeNode.row + 1, verticalContainer.igxForOf.length - 1);
          }
          if (key.includes('left') || key.includes('right')) {
            const prevRIndex = this.activeNode.row;
            const prevScrContainer = this.grid.verticalRowDimScrollContainers.toArray()[this.activeNode.column];
            const src = prevScrContainer.getScrollForIndex(prevRIndex);
            newActiveNode.row = this.activeNode.mchCache && this.activeNode.mchCache.level === newActiveNode.column ? this.activeNode.mchCache.visibleIndex : verticalContainer.getIndexAtScroll(src);
            newActiveNode.mchCache = {
              visibleIndex: this.activeNode.row,
              level: this.activeNode.column
            };
          }
        }
        this.setActiveNode(newActiveNode);
        if (!this.grid.hasHorizontalLayout && verticalContainer.isIndexOutsideView(newActiveNode.row)) {
          verticalContainer.scrollTo(newActiveNode.row);
        }
      } else {
        super.handleNavigation(event);
      }
    }
    handleAlt(key, event) {
      event.preventDefault();
      let rowData, dimIndex;
      if (!this.grid.hasHorizontalLayout) {
        dimIndex = this.activeNode.column;
        const scrContainer = this.grid.verticalRowDimScrollContainers.toArray()[dimIndex];
        rowData = scrContainer.igxGridForOf[this.activeNode.row];
      } else {
        const mrlRow = this.grid.rowDimensionMrlRowsCollection.find(mrl => mrl.rowIndex === this.activeNode.row);
        rowData = mrlRow.rowGroup[this.activeNode.layout.rowStart - 1];
        dimIndex = this.activeNode.layout.colStart - 1;
      }
      const dimension = this.grid.visibleRowDimensions[dimIndex];
      const expansionRowKey = PivotUtil.getRecordKey(rowData, dimension);
      const isExpanded = this.grid.expansionStates.get(expansionRowKey) ?? true;
      let prevCellLayout;
      if (this.grid.hasHorizontalLayout) {
        const parentRow = this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === this.activeNode.row);
        prevCellLayout = this.getNextVerticalColumnIndex(parentRow, Math.min(parentRow.rowGroup.length, this.activeNode.layout.rowStart), this.activeNode.layout.colStart);
      }
      if (ROW_EXPAND_KEYS.has(key) && !isExpanded) {
        this.grid.gridAPI.set_row_expansion_state(expansionRowKey, true, event);
      } else if (ROW_COLLAPSE_KEYS.has(key) && isExpanded) {
        this.grid.gridAPI.set_row_expansion_state(expansionRowKey, false, event);
      }
      if (ROW_EXPAND_KEYS.has(key) && !isExpanded || ROW_COLLAPSE_KEYS.has(key) && isExpanded) {
        this.onRowToggle(!isExpanded, dimension, rowData, prevCellLayout);
      }
      this.updateActiveNodeLayout();
      this.grid.notifyChanges();
    }
    updateActiveNodeLayout() {
      if (this.grid.hasHorizontalLayout) {
        const mrlRow = this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === this.activeNode.row);
        const activeCell = mrlRow.contentCells.toArray()[this.activeNode.column];
        this.activeNode.layout = activeCell.layout;
      }
    }
    /** Update active cell when toggling row expand when horizontal summaries have position set to top */
    onRowToggle(newExpandState, dimension, rowData, prevCellLayout) {
      if (this.grid.hasHorizontalLayout && rowData.totalRecordDimensionName !== dimension.memberName && dimension.horizontalSummary && this.grid.pivotUI.horizontalSummariesPosition === PivotSummaryPosition.Top) {
        const maxActiveRow = Math.min(this.lastRowDimensionMRLRowIndex, this.activeNode.row);
        const parentRowUpdated = this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === maxActiveRow);
        const maxRowEnd = parentRowUpdated.rowGroup.length + 1;
        const nextRowStart = Math.max(1, this.activeNode.layout.rowStart + (!newExpandState ? -1 : 1));
        const curValidRowStart = Math.min(parentRowUpdated.rowGroup.length, nextRowStart);
        // Get current cell layout, because the actineNode the rowStart might be different, based on where we come from(might be smaller cell).
        const curCellLayout = this.getNextVerticalColumnIndex(parentRowUpdated, curValidRowStart, this.activeNode.layout.colStart);
        const nextBlock = !newExpandState && prevCellLayout.rowStart === 1 || newExpandState && prevCellLayout.rowEnd >= maxRowEnd;
        this.activeNode.row += nextBlock ? !newExpandState ? -1 : 1 : 0;
        this.activeNode.column = curCellLayout.columnVisibleIndex;
        this.activeNode.layout = curCellLayout;
      }
    }
    async headerNavigation(event) {
      const key = event.key.toLowerCase();
      const ctrl = event.ctrlKey;
      if (!HEADER_KEYS.has(key)) {
        return;
      }
      if (this.isRowDimensionHeaderActive) {
        event.preventDefault();
        const newActiveNode = {
          row: this.activeNode.row,
          column: this.activeNode.column,
          level: null,
          mchCache: this.activeNode.mchCache,
          layout: null
        };
        if (ctrl) {
          const dimIndex = this.activeNode.column;
          const dim = this.grid.visibleRowDimensions[dimIndex];
          if (this.activeNode.row === -1) {
            if (key.includes('down') || key.includes('up')) {
              let newSortDirection = SortingDirection.None;
              if (key.includes('down')) {
                newSortDirection = dim.sortDirection === SortingDirection.Desc ? SortingDirection.None : SortingDirection.Desc;
              } else if (key.includes('up')) {
                newSortDirection = dim.sortDirection === SortingDirection.Asc ? SortingDirection.None : SortingDirection.Asc;
              }
              this.grid.sortDimension(dim, newSortDirection);
              return;
            }
          }
        }
        if ((key.includes('left') || key === 'home') && this.activeNode.column > 0) {
          newActiveNode.column = ctrl || key === 'home' ? 0 : this.activeNode.column - 1;
        }
        if ((key.includes('right') || key === 'end') && this.activeNode.column < this.lastRowDimensionsIndex) {
          newActiveNode.column = ctrl || key === 'end' ? this.lastRowDimensionsIndex : this.activeNode.column + 1;
        } else if (key.includes('right')) {
          this.isRowDimensionHeaderActive = false;
          newActiveNode.column = 0;
          newActiveNode.level = this.activeNode.mchCache?.level || 0;
          newActiveNode.mchCache = this.activeNode.mchCache || {
            level: 0,
            visibleIndex: 0
          };
        }
        if (key.includes('down')) {
          if (this.grid.hasHorizontalLayout) {
            this.activeNode.row = 0;
            this.activeNode.layout = {
              rowStart: 1,
              rowEnd: 2,
              colStart: newActiveNode.column + 1,
              colEnd: newActiveNode.column + 2,
              columnVisibleIndex: newActiveNode.column
            };
            const newPosition = await this.getNextVerticalPosition(true, ctrl || key === 'home', key === 'home');
            newActiveNode.row = 0;
            newActiveNode.column = newPosition.column;
            newActiveNode.layout = newPosition.layout;
          } else {
            const verticalContainer = this.grid.verticalRowDimScrollContainers.toArray()[newActiveNode.column];
            newActiveNode.row = ctrl ? verticalContainer.igxForOf.length - 1 : 0;
          }
          this.isRowDimensionHeaderActive = false;
          this.isRowHeaderActive = true;
          this.grid.rowDimensionContainer.toArray()[this.grid.hasHorizontalLayout ? 0 : newActiveNode.column].nativeElement.focus();
        }
        this.setActiveNode(newActiveNode);
      } else if (key.includes('left') && this.activeNode.column === 0 && this.grid.pivotUI.showRowHeaders) {
        this.isRowDimensionHeaderActive = true;
        const newActiveNode = {
          row: this.activeNode.row,
          column: this.lastRowDimensionsIndex,
          level: null,
          mchCache: this.activeNode.mchCache,
          layout: null
        };
        this.setActiveNode(newActiveNode);
      } else {
        super.headerNavigation(event);
      }
    }
    focusTbody(event) {
      if (!this.activeNode || this.activeNode.row === null || this.activeNode.row === undefined) {
        this.activeNode = this.lastActiveNode;
      } else {
        super.focusTbody(event);
      }
    }
    async getNextVerticalPosition(previous, ctrl, homeEnd) {
      const parentRow = this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === this.activeNode.row);
      const maxRowEnd = parentRow.rowGroup.length + 1;
      const curValidRowStart = Math.min(parentRow.rowGroup.length, this.activeNode.layout.rowStart);
      // Get current cell layout, because the actineNode the rowStart might be different, based on where we come from(might be smaller cell).
      const curCellLayout = this.getNextVerticalColumnIndex(parentRow, curValidRowStart, this.activeNode.layout.colStart);
      const nextBlock = previous && curCellLayout.rowStart === 1 || !previous && curCellLayout.rowEnd === maxRowEnd;
      if (nextBlock && (previous && this.activeNode.row === 0 || !previous && this.activeNode.row === this.lastRowDimensionMRLRowIndex)) {
        if (previous && this.grid.pivotUI.showRowHeaders) {
          this.isRowDimensionHeaderActive = true;
          this.isRowHeaderActive = false;
          this.grid.theadRow.nativeElement.focus();
          return {
            row: -1,
            column: this.activeNode.layout.colStart - 1,
            layout: this.activeNode.layout
          };
        }
        return {
          row: this.activeNode.row,
          column: this.activeNode.column,
          layout: this.activeNode.layout
        };
      }
      const nextMRLRowIndex = previous ? ctrl ? 0 : this.activeNode.row - 1 : ctrl ? this.lastRowDimensionMRLRowIndex : this.activeNode.row + 1;
      let nextRow = nextBlock || ctrl ? this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === nextMRLRowIndex) : parentRow;
      if (!nextRow) {
        const nextDataViewIndex = previous ? ctrl ? 0 : parentRow.rowGroup[curCellLayout.rowStart - 1].dataIndex - 1 : ctrl ? this.grid.dataView.length - 1 : parentRow.rowGroup[curCellLayout.rowEnd - 2].dataIndex + 1;
        await this.scrollToNextHorizontalDimRow(nextDataViewIndex);
        nextRow = nextBlock || ctrl ? this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === nextMRLRowIndex) : parentRow;
      }
      const nextRowStart = nextBlock ? previous ? nextRow.rowGroup.length : 1 : previous ? curCellLayout.rowStart - 1 : curCellLayout.rowEnd;
      const maxColEnd = Math.max(...nextRow.contentCells.map(cell => cell.layout.colEnd));
      const nextColumnLayout = this.getNextVerticalColumnIndex(nextRow, ctrl ? previous ? 1 : nextRow.rowGroup.length : nextRowStart, homeEnd ? previous ? 1 : maxColEnd - 1 : this.activeNode.layout.colStart);
      const nextDataViewIndex = previous ? nextRow.rowGroup[nextColumnLayout.rowStart - 1].dataIndex : nextRow.rowGroup[nextColumnLayout.rowEnd - 2].dataIndex;
      await this.scrollToNextHorizontalDimRow(nextDataViewIndex);
      return {
        row: nextBlock || ctrl ? nextMRLRowIndex : this.activeNode.row,
        column: nextColumnLayout.columnVisibleIndex,
        layout: {
          rowStart: nextColumnLayout.rowStart,
          rowEnd: nextColumnLayout.rowEnd,
          colStart: homeEnd ? nextColumnLayout.colStart : this.activeNode.layout.colStart,
          colEnd: nextColumnLayout.colEnd,
          columnVisibleIndex: nextColumnLayout.columnVisibleIndex
        }
      };
    }
    async getNextHorizontalPosition(previous, ctrl) {
      const parentRow = this.grid.rowDimensionMrlRowsCollection.find(row => row.rowIndex === this.activeNode.row);
      const maxColEnd = Math.max(...parentRow.contentCells.map(cell => cell.layout.colEnd));
      // Get current cell layout, because the actineNode the rowStart might be different, based on where we come from(might be smaller cell).
      const curCellLayout = this.getNextVerticalColumnIndex(parentRow, this.activeNode.layout.rowStart, this.activeNode.layout.colStart);
      if (previous && curCellLayout.colStart === 1 || !previous && curCellLayout.colEnd === maxColEnd) {
        return {
          row: this.activeNode.row,
          column: this.activeNode.column,
          layout: this.activeNode.layout
        };
      }
      const nextColStartNormal = curCellLayout.colStart + (previous ? -1 : curCellLayout.colEnd - curCellLayout.colStart);
      const nextColumnLayout = this.getNextVerticalColumnIndex(parentRow, this.activeNode.layout.rowStart, ctrl ? previous ? 1 : maxColEnd - 1 : nextColStartNormal);
      const nextDataViewIndex = parentRow.rowGroup[nextColumnLayout.rowStart - 1].dataIndex;
      await this.scrollToNextHorizontalDimRow(nextDataViewIndex);
      return {
        row: this.activeNode.row,
        column: nextColumnLayout.columnVisibleIndex,
        layout: {
          rowStart: this.activeNode.layout.rowStart,
          rowEnd: nextColumnLayout.rowEnd,
          colStart: nextColumnLayout.colStart,
          colEnd: nextColumnLayout.colEnd,
          columnVisibleIndex: nextColumnLayout.columnVisibleIndex
        }
      };
    }
    async scrollToNextHorizontalDimRow(nextDataViewIndex) {
      const verticalContainer = this.grid.verticalScrollContainer;
      if (verticalContainer.isIndexOutsideView(nextDataViewIndex)) {
        verticalContainer.scrollTo(nextDataViewIndex);
        await new Promise(resolve => {
          this.grid.gridScroll.pipe(take(1), timeout({
            first: 10000
          })).subscribe({
            next: value => resolve(value),
            error: err => resolve(err)
          });
        });
      }
    }
    getNextVerticalColumnIndex(nextRow, newRowStart, newColStart) {
      const nextCell = nextRow.contentCells.find(cell => {
        return cell.layout.rowStart <= newRowStart && newRowStart < cell.layout.rowEnd && cell.layout.colStart <= newColStart && newColStart < cell.layout.colEnd;
      });
      return nextCell.layout;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxPivotGridNavigationService_BaseFactory;
        return function IgxPivotGridNavigationService_Factory(__ngFactoryType__) {
          return (ɵIgxPivotGridNavigationService_BaseFactory || (ɵIgxPivotGridNavigationService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxPivotGridNavigationService)))(__ngFactoryType__ || IgxPivotGridNavigationService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxPivotGridNavigationService,
        factory: IgxPivotGridNavigationService.ɵfac
      });
    }
  }
  return IgxPivotGridNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPivotFilteringService = /*#__PURE__*/(() => {
  class IgxPivotFilteringService extends IgxFilteringService {
    clearFilter(field) {
      this.clear_filter(field);
    }
    clear_filter(fieldName) {
      super.clear_filter(fieldName);
      const grid = this.grid;
      const allDimensions = grid.allDimensions;
      const allDimensionsFlat = PivotUtil.flatten(allDimensions);
      const dim = allDimensionsFlat.find(x => x.memberName === fieldName);
      dim.filter = undefined;
      grid.filteringPipeTrigger++;
      if (allDimensions.indexOf(dim) !== -1) {
        // update columns
        grid.setupColumns();
      }
    }
    filter_internal(fieldName, term, conditionOrExpressionsTree, ignoreCase) {
      super.filter_internal(fieldName, term, conditionOrExpressionsTree, ignoreCase);
      const grid = this.grid;
      const config = grid.pivotConfiguration;
      const allDimensions = PivotUtil.flatten(config.rows.concat(config.columns).concat(config.filters).filter(x => x !== null && x !== undefined));
      const enabledDimensions = allDimensions.filter(x => x && x.enabled);
      const dim = enabledDimensions.find(x => x.memberName === fieldName || x.member === fieldName);
      const filteringTree = dim.filter || new FilteringExpressionsTree(FilteringLogic.And);
      const fieldFilterIndex = filteringTree.findIndex(fieldName);
      if (fieldFilterIndex > -1) {
        filteringTree.filteringOperands.splice(fieldFilterIndex, 1);
      }
      this.prepare_filtering_expression(filteringTree, fieldName, term, conditionOrExpressionsTree, ignoreCase, fieldFilterIndex);
      dim.filter = filteringTree;
      grid.filteringPipeTrigger++;
      grid.filterStrategy = grid.filterStrategy ?? new DimensionValuesFilteringStrategy();
      if (allDimensions.indexOf(dim) !== -1) {
        // update columns
        grid.setupColumns();
      }
    }
    toggleFiltersESF(dropdown, element, column, shouldReattach) {
      const filterIcon = column.filteringExpressionsTree ? 'igx-excel-filter__icon--filtered' : 'igx-excel-filter__icon';
      const filterIconTarget = element.querySelector(`.${filterIcon}`) || element;
      const {
        id,
        ref
      } = this.grid.createFilterESF(dropdown, column, {
        ...this._filterMenuOverlaySettings,
        ...{
          target: filterIconTarget
        }
      }, shouldReattach);
      this.filtersESFId = id;
      if (shouldReattach) {
        this._overlayService.opening.pipe(first$2(overlay => overlay.id === id), takeUntil(this.destroy$)).subscribe(() => this.lastActiveNode = this.grid.navigation.activeNode);
        this._overlayService.closed.pipe(first$2(overlay => overlay.id === id), takeUntil(this.destroy$)).subscribe(() => {
          this._overlayService.detach(id);
          ref?.destroy();
          this.grid.navigation.activeNode = this.lastActiveNode;
          this.grid.theadRow.nativeElement.focus();
        });
        this.grid.columnPinned.pipe(first$2()).subscribe(() => ref?.destroy());
        this._overlayService.show(id);
      }
    }
    hideESF() {
      this._overlayService.hide(this.filtersESFId);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxPivotFilteringService_BaseFactory;
        return function IgxPivotFilteringService_Factory(__ngFactoryType__) {
          return (ɵIgxPivotFilteringService_BaseFactory || (ɵIgxPivotFilteringService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxPivotFilteringService)))(__ngFactoryType__ || IgxPivotFilteringService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxPivotFilteringService,
        factory: IgxPivotFilteringService.ɵfac
      });
    }
  }
  return IgxPivotFilteringService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxPivotRowDimensionHeaderGroupComponent = /*#__PURE__*/(() => {
  class IgxPivotRowDimensionHeaderGroupComponent extends IgxGridHeaderGroupComponent {
    constructor(cdRef, grid, elementRef, colResizingService, filteringService, platform, zone) {
      super(cdRef, grid, elementRef, colResizingService, filteringService, platform);
      this.cdRef = cdRef;
      this.grid = grid;
      this.elementRef = elementRef;
      this.colResizingService = colResizingService;
      this.zone = zone;
      /**
       * @hidden
       */
      this.userSelect = 'none';
    }
    get headerID() {
      return `${this.grid.id}_-2_${this.rowIndex}_${this.visibleIndex}`;
    }
    get title() {
      return this.column.header;
    }
    /**
     * @hidden @internal
     */
    onClick(event) {
      if (this.grid.rowSelection === 'none') {
        return;
      }
      event?.stopPropagation();
      const key = this.parent.getRowDimensionKey(this.column);
      if (this.grid.selectionService.isRowSelected(key)) {
        this.grid.selectionService.deselectRow(key, event);
      } else {
        this.grid.selectionService.selectRowById(key, true, event);
      }
      this.zone.run(() => {});
    }
    /**
     * @hidden
     * @internal
     */
    get visibleIndex() {
      if (this.grid.hasHorizontalLayout) {
        return this.colIndex;
      }
      const field = this.column.field;
      const rows = this.grid.rowDimensions;
      const rootDimension = this.findRootDimension(field);
      return rows.indexOf(rootDimension);
    }
    get active() {
      const nav = this.grid.navigation;
      const node = nav.activeNode;
      return node && !this.column.columnGroup ? nav.isRowHeaderActive && node.row === this.rowIndex && node.column === this.visibleIndex : false;
    }
    get activeNode() {
      this.grid.navigation.isRowHeaderActive = true;
      this.grid.navigation.isRowDimensionHeaderActive = false;
      return {
        row: this.rowIndex,
        column: this.visibleIndex,
        level: null,
        mchCache: null,
        layout: this.layout || null
      };
    }
    findRootDimension(field) {
      const rows = this.grid.rowDimensions;
      let tempRow;
      let result = null;
      rows.forEach(row => {
        tempRow = row;
        do {
          if (tempRow.memberName === field) {
            result = row;
          }
          tempRow = tempRow.childLevel;
        } while (tempRow);
      });
      return result;
    }
    activate() {
      this.grid.navigation.isRowHeader = true;
      this.grid.navigation.setActiveNode(this.activeNode);
    }
    /**
     * @hidden @internal
     */
    pointerdown(_event) {
      this.activate();
    }
    /**
     * @hidden @internal
     */
    onMouseDown(_event) {
      this.activate();
    }
    get selectable() {
      return false;
    }
    static {
      this.ɵfac = function IgxPivotRowDimensionHeaderGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowDimensionHeaderGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxPivotColumnResizingService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowDimensionHeaderGroupComponent,
        selectors: [["igx-pivot-row-dimension-header-group"]],
        viewQuery: function IgxPivotRowDimensionHeaderGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxPivotRowDimensionHeaderComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function IgxPivotRowDimensionHeaderGroupComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxPivotRowDimensionHeaderGroupComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.headerID)("title", ctx.title);
            i0.ɵɵstyleProp("user-select", ctx.userSelect);
            i0.ɵɵclassProp("igx-grid-th--active", ctx.active);
          }
        },
        inputs: {
          rowIndex: "rowIndex",
          colIndex: "colIndex",
          layout: "layout",
          parent: "parent"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 1,
        consts: [["defaultColumn", ""], ["defaultCollapseIndicator", ""], [1, "igx-grid-th__group-title", 3, "title"], ["family", "default", 3, "name"], [1, "igx-grid-th__drop-indicator-left"], ["role", "columnheader", 1, "igx-grid-th--fw", 3, "pointerdown", "keydown", "id", "ngClass", "ngStyle", "igxColumnMovingDrag", "ghostHost", "igxColumnMovingDrop", "column"], [1, "igx-grid-th__resize-handle", 3, "igxPivotResizeHandle", "igxPivotResizeHandleHeader", "cursor"], [1, "igx-grid-th__drop-indicator-right"], [1, "igx-grid-th__resize-handle", 3, "igxPivotResizeHandle", "igxPivotResizeHandleHeader"]],
        template: function IgxPivotRowDimensionHeaderGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxPivotRowDimensionHeaderGroupComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxPivotRowDimensionHeaderGroupComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxPivotRowDimensionHeaderGroupComponent_Conditional_4_Template, 5, 15);
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(!ctx.column.columnGroup ? 4 : -1);
          }
        },
        dependencies: [IgxIconComponent, IgxPivotRowDimensionHeaderComponent, NgClass, NgStyle, IgxColumnMovingDragDirective, IgxColumnMovingDropDirective, IgxPivotResizeHandleDirective, IgxHeaderGroupStylePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowDimensionHeaderGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 *
 * For all intents & purposes treat this component as what a <thead> usually is in the default <table> element.
 *
 * This container holds the pivot grid header elements and their behavior/interactions.
 *
 * @hidden @internal
 */
let IgxPivotRowDimensionContentComponent = /*#__PURE__*/(() => {
  class IgxPivotRowDimensionContentComponent extends IgxGridHeaderRowComponent {
    get rowStart() {
      return this.layout ? `${this.layout.rowStart}` : "";
    }
    get rowsEnd() {
      return this.layout ? `${this.layout.rowEnd}` : "";
    }
    get colStart() {
      return this.layout ? `${this.layout.colStart}` : "";
    }
    get colEnd() {
      return this.layout ? `${this.layout.colEnd}` : "";
    }
    constructor(grid, ref, injector, envInjector, cdr, viewRef) {
      super(ref, cdr);
      this.grid = grid;
      this.injector = injector;
      this.envInjector = envInjector;
      this.viewRef = viewRef;
    }
    get rowDimensionColumn() {
      return this.rowDimensionData?.column;
    }
    /**
    * @hidden
    * @internal
    */
    ngOnChanges(changes) {
      if (changes.rowData) {
        // generate new rowDimension on row data change
        this.rowDimensionData = null;
        this.viewRef.clear();
        this.extractFromDimensions();
        this.viewRef.clear();
      }
      if (changes.width && this.rowDimensionData) {
        const data = this.rowDimensionData;
        data.column.width = this.grid.rowDimensionWidthToPixels(this.rootDimension) + 'px';
      }
    }
    /**
    * @hidden
    * @internal
    */
    toggleRowDimension(event) {
      this.grid.toggleRow(this.getRowDimensionKey());
      this.grid.navigation.onRowToggle(this.getExpandState(), this.dimension, this.rowData, this.layout);
      event?.stopPropagation();
    }
    /**
     * @hidden
     * @internal
     */
    getRowDimensionKey() {
      const dimData = this.rowDimensionData;
      const key = PivotUtil.getRecordKey(this.rowData, dimData.dimension);
      return key;
    }
    getExpandState() {
      return this.grid.gridAPI.get_row_expansion_state(this.getRowDimensionKey());
    }
    getLevel() {
      return this.grid.hasHorizontalLayout ? 0 : this.dimension.level;
    }
    getHeaderWidthFromDimension() {
      if (this.grid.hasHorizontalLayout) {
        return this.width === -1 ? 'fit-content' : this.width;
      }
      return this.grid.rowDimensionWidth(this.rootDimension);
    }
    extractFromDimensions() {
      if (this.dimension && this.rowData) {
        const col = this.extractFromDimension(this.dimension, this.rowData);
        const prevDims = [];
        this.rowDimensionData = {
          column: col,
          dimension: this.dimension,
          prevDimensions: prevDims
        };
      }
    }
    extractFromDimension(dim, rowData) {
      const field = dim.memberName;
      const header = rowData?.dimensionValues.get(field);
      const col = this._createColComponent(field, header, dim);
      return col;
    }
    _createColComponent(field, header, dim) {
      const ref = createComponent(IgxColumnComponent, {
        environmentInjector: this.envInjector,
        elementInjector: this.injector
      });
      ref.instance.field = field;
      ref.instance.header = header;
      ref.instance.width = this.grid.rowDimensionWidthToPixels(this.rootDimension) + 'px';
      ref.instance.resizable = this.grid.rowDimensionResizing;
      ref.instance._vIndex = this.grid.columns.length + this.rowIndex + this.rowIndex * this.grid.pivotConfiguration.rows.length;
      if (header && dim.childLevel && (!this.rowData.totalRecordDimensionName || this.rowData.totalRecordDimensionName !== dim.memberName)) {
        ref.instance.headerTemplate = this.headerTemplate;
      } else {
        ref.instance.headerTemplate = this.headerTemplateDefault;
      }
      return ref.instance;
    }
    static {
      this.ɵfac = function IgxPivotRowDimensionContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowDimensionContentComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowDimensionContentComponent,
        selectors: [["igx-pivot-row-dimension-content"]],
        viewQuery: function IgxPivotRowDimensionContentComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c252, 7, TemplateRef);
            i0.ɵɵviewQuery(_c253, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxPivotRowDimensionHeaderGroupComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplateDefault = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerGroups = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxPivotRowDimensionContentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("grid-row-start", ctx.rowStart)("grid-row-end", ctx.rowsEnd)("grid-column-start", ctx.colStart)("grid-column-end", ctx.colEnd);
          }
        },
        inputs: {
          rowIndex: "rowIndex",
          colIndex: "colIndex",
          layout: "layout",
          dimension: "dimension",
          rootDimension: "rootDimension",
          rowData: "rowData"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 11,
        vars: 35,
        consts: [["headerTemplate", ""], ["headerDefaultTemplate", ""], ["role", "rowgroup", 1, "igx-grid-thead__wrapper"], ["role", "row", 1, "igx-grid__tr", "igx-grid__tr-header-row"], [3, "ngClass", "ngStyle", "column", "rowIndex", "colIndex", "layout", "parent"], ["family", "default", 3, "click", "name"], [2, "--component-size", "3"], [2, "flex-shrink", "0"]],
        template: function IgxPivotRowDimensionContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
            i0.ɵɵelement(2, "igx-pivot-row-dimension-header-group", 4);
            i0.ɵɵpipe(3, "igxHeaderGroupWidth");
            i0.ɵɵpipe(4, "igxHeaderGroupWidth");
            i0.ɵɵpipe(5, "igxHeaderGroupWidth");
            i0.ɵɵpipe(6, "igxHeaderGroupStyle");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, IgxPivotRowDimensionContentComponent_ng_template_7_Template, 3, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, IgxPivotRowDimensionContentComponent_ng_template_9_Template, 3, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵclassProp("igx-grid__tr--mrl", ctx.hasMRL);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind3(3, 19, ctx.getHeaderWidthFromDimension(), ctx.grid.defaultHeaderGroupMinWidth, ctx.hasMRL))("width", i0.ɵɵpipeBind3(4, 23, ctx.getHeaderWidthFromDimension(), ctx.grid.defaultHeaderGroupMinWidth, ctx.hasMRL))("flex-basis", i0.ɵɵpipeBind3(5, 27, ctx.getHeaderWidthFromDimension(), ctx.grid.defaultHeaderGroupMinWidth, ctx.hasMRL));
            i0.ɵɵproperty("ngClass", ctx.rowDimensionColumn.headerGroupClasses)("ngStyle", i0.ɵɵpipeBind3(6, 31, ctx.rowDimensionColumn.headerGroupStyles, ctx.rowDimensionColumn, ctx.grid.pipeTrigger))("column", ctx.rowDimensionColumn)("rowIndex", ctx.rowIndex)("colIndex", ctx.colIndex)("layout", ctx.layout)("parent", ctx);
          }
        },
        dependencies: [IgxPivotRowDimensionHeaderGroupComponent, NgClass, NgStyle, IgxIconComponent, IgxHeaderGroupWidthPipe, IgxHeaderGroupStylePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowDimensionContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPivotGridColumnResizerComponent = /*#__PURE__*/(() => {
  class IgxPivotGridColumnResizerComponent extends IgxGridColumnResizerComponent {
    constructor(colResizingService) {
      super(colResizingService);
      this.colResizingService = colResizingService;
    }
    static {
      this.ɵfac = function IgxPivotGridColumnResizerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridColumnResizerComponent)(i0.ɵɵdirectiveInject(IgxPivotColumnResizingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotGridColumnResizerComponent,
        selectors: [["igx-pivot-grid-column-resizer"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 7,
        consts: [["igxResizer", "", 1, "igx-grid-th__resize-line", 3, "resizeEnd", "restrictHResizeMax", "restrictHResizeMin", "restrictResizerTop"]],
        template: function IgxPivotGridColumnResizerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("resizeEnd", function IgxPivotGridColumnResizerComponent_Template_div_resizeEnd_0_listener($event) {
              return ctx.colResizingService.resizeColumn($event, ctx.resizer.ratio);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("left", -99999, "px")("height", ctx.colResizingService.resizerHeight, "px");
            i0.ɵɵproperty("restrictHResizeMax", ctx.colResizingService.restrictResizeMax)("restrictHResizeMin", ctx.colResizingService.restrictResizeMin)("restrictResizerTop", ctx.restrictResizerTop);
          }
        },
        dependencies: [IgxColumnResizerDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotGridColumnResizerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DefaultPivotGridRecordSortingStrategy = /*#__PURE__*/(() => {
  class DefaultPivotGridRecordSortingStrategy extends DefaultSortingStrategy {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new this());
    }
    sort(data, fieldName, dir, ignoreCase, valueResolver, isDate, isTime, _grid) {
      const reverse = dir === SortingDirection.Desc ? -1 : 1;
      const cmpFunc = (obj1, obj2) => this.compareObjects(obj1, obj2, fieldName, reverse, ignoreCase, this.getFieldValue, isDate, isTime);
      return this.arraySort(data, cmpFunc);
    }
    getFieldValue(obj, key, _isDate = false, _isTime = false) {
      return obj.aggregationValues.get(key);
    }
  }
  return DefaultPivotGridRecordSortingStrategy;
})();
let DefaultPivotSortingStrategy = /*#__PURE__*/(() => {
  class DefaultPivotSortingStrategy extends DefaultSortingStrategy {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new this());
    }
    sort(data, fieldName, dir, ignoreCase, valueResolver, isDate, isTime, grid) {
      const key = fieldName;
      const allDimensions = grid.allDimensions;
      const enabledDimensions = allDimensions.filter(x => x && x.enabled);
      this.dimension = PivotUtil.flatten(enabledDimensions).find(x => x.memberName === key);
      const reverse = dir === SortingDirection.Desc ? -1 : 1;
      const cmpFunc = (obj1, obj2) => this.compareObjects(obj1, obj2, key, reverse, ignoreCase, this.getFieldValue, isDate, isTime);
      return this.arraySort(data, cmpFunc);
    }
    getFieldValue(obj, key, _isDate = false, isTime = false) {
      let resolvedValue = PivotUtil.extractValueFromDimension(this.dimension, obj) || obj[0];
      const formatAsDate = this.dimension.dataType === GridColumnDataType.Date || this.dimension.dataType === GridColumnDataType.DateTime;
      if (formatAsDate) {
        const date = parseDate(resolvedValue);
        resolvedValue = isTime && date ? new Date().setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()) : date;
      }
      return resolvedValue;
    }
  }
  return DefaultPivotSortingStrategy;
})();
class PivotSortUtil {
  static generateDimensionSortingExpressions(dimensions) {
    const expressions = [];
    PivotUtil.flatten(dimensions).forEach(x => {
      if (x.sortDirection) {
        expressions.push({
          dir: x.sortDirection,
          fieldName: x.memberName,
          strategy: DefaultPivotSortingStrategy.instance()
        });
      } else {
        expressions.push({
          dir: SortingDirection.None,
          fieldName: x.memberName,
          strategy: DefaultPivotSortingStrategy.instance()
        });
      }
    });
    return expressions;
  }
}

/**
 * @hidden
 */
let IgxPivotValueChipTemplateDirective = /*#__PURE__*/(() => {
  class IgxPivotValueChipTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxPivotValueChipTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotValueChipTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPivotValueChipTemplateDirective,
        selectors: [["", "igxPivotValueChip", ""]]
      });
    }
  }
  return IgxPivotValueChipTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotRowDimensionHeaderTemplateDirective = /*#__PURE__*/(() => {
  class IgxPivotRowDimensionHeaderTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_directive, context) {
      return true;
    }
    static {
      this.ɵfac = function IgxPivotRowDimensionHeaderTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowDimensionHeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPivotRowDimensionHeaderTemplateDirective,
        selectors: [["", "igxPivotRowDimensionHeader", ""]]
      });
    }
  }
  return IgxPivotRowDimensionHeaderTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxPivotRowPipe = /*#__PURE__*/(() => {
  class IgxPivotRowPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, config, cloneStrategy, _, _pipeTrigger, __) {
      const pivotKeys = config.pivotKeys || DEFAULT_PIVOT_KEYS;
      const enabledRows = config.rows?.filter(x => x.enabled) || [];
      const enabledColumns = config.columns?.filter(x => x.enabled) || [];
      const enabledValues = config.values?.filter(x => x.enabled) || [];
      if (enabledRows.length === 0 && enabledColumns.length === 0 && enabledValues.length === 0) {
        // nothing to group and aggregate by ...
        return [];
      }
      const rowStrategy = config.rowStrategy || PivotRowDimensionsStrategy.instance();
      const data = cloneArray(collection, true);
      return rowStrategy.process(data, enabledRows, config.values, cloneStrategy, pivotKeys);
    }
    static {
      this.ɵfac = function IgxPivotRowPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridRow",
        type: IgxPivotRowPipe,
        pure: true
      });
    }
  }
  return IgxPivotRowPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 * Transforms generic array data into IPivotGridRecord[]
 */
let IgxPivotAutoTransform = /*#__PURE__*/(() => {
  class IgxPivotAutoTransform {
    transform(collection, config, _pipeTrigger, __) {
      let needsTransformation = false;
      if (collection.length > 0) {
        needsTransformation = !this.isPivotRecord(collection[0]);
      }
      if (!needsTransformation) return collection;
      const res = this.processCollectionToPivotRecord(config, collection);
      return res;
    }
    isPivotRecord(arg) {
      return !!arg.aggregationValues;
    }
    processCollectionToPivotRecord(config, collection) {
      const pivotKeys = config.pivotKeys || DEFAULT_PIVOT_KEYS;
      const enabledRows = config.rows.filter(x => x.enabled);
      const allFlat = PivotUtil.flatten(enabledRows);
      const result = [];
      for (const rec of collection) {
        const pivotRec = {
          dimensionValues: new Map(),
          aggregationValues: new Map(),
          children: new Map(),
          dimensions: []
        };
        const keys = Object.keys(rec);
        for (const key of keys) {
          const dim = allFlat.find(x => x.memberName === key);
          if (dim) {
            //field has matching dimension
            pivotRec.dimensions.push(dim);
            pivotRec.dimensionValues.set(key, rec[key]);
          } else if (key.indexOf(pivotKeys.rowDimensionSeparator + pivotKeys.records) !== -1) {
            // field that contains child collection
            const dimKey = key.slice(0, key.indexOf(pivotKeys.rowDimensionSeparator + pivotKeys.records));
            const childData = rec[key];
            const childPivotData = this.processCollectionToPivotRecord(config, childData);
            pivotRec.children.set(dimKey, childPivotData);
          } else {
            // an aggregation
            pivotRec.aggregationValues.set(key, rec[key]);
          }
        }
        const flattened = PivotUtil.flatten(config.rows);
        pivotRec.dimensions.sort((x, y) => flattened.indexOf(x) - flattened.indexOf(y));
        result.push(pivotRec);
      }
      return result;
    }
    static {
      this.ɵfac = function IgxPivotAutoTransform_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotAutoTransform)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridAutoTransform",
        type: IgxPivotAutoTransform,
        pure: true
      });
    }
  }
  return IgxPivotAutoTransform;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotRowExpansionPipe = /*#__PURE__*/(() => {
  class IgxPivotRowExpansionPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, config, expansionStates, defaultExpand, _pipeTrigger, __) {
      const enabledRows = config.rows?.filter(x => x.enabled) || [];
      const data = collection ? cloneArray(collection, true) : [];
      const horizontalRowDimensions = [];
      for (const row of enabledRows) {
        if (this.grid?.hasHorizontalLayout) {
          PivotUtil.flattenGroupsHorizontally(data, row, expansionStates, defaultExpand, horizontalRowDimensions, this.grid.pivotUI.horizontalSummariesPosition);
        } else {
          PivotUtil.flattenGroups(data, row, expansionStates, defaultExpand);
        }
      }
      let finalData = data;
      if (this.grid?.hasHorizontalLayout) {
        const allRowDims = PivotUtil.flatten(this.grid.rowDimensions);
        this.grid.visibleRowDimensions = allRowDims.filter(rowDim => horizontalRowDimensions.some(targetDim => targetDim.memberName === rowDim.memberName));
      } else {
        if (this.grid) {
          this.grid.visibleRowDimensions = enabledRows;
        }
        finalData = enabledRows.length > 0 ? finalData.filter(x => x.dimensions.length === enabledRows.length) : finalData;
      }
      if (this.grid) {
        this.grid.setFilteredSortedData(finalData, false);
      }
      return finalData;
    }
    static {
      this.ɵfac = function IgxPivotRowExpansionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowExpansionPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridRowExpansion",
        type: IgxPivotRowExpansionPipe,
        pure: true
      });
    }
  }
  return IgxPivotRowExpansionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotCellMergingPipe = /*#__PURE__*/(() => {
  class IgxPivotCellMergingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, config, dim, _pipeTrigger) {
      if (collection.length === 0 || config.rows.length === 0) return collection;
      const data = collection ? cloneArray(collection, true) : [];
      const res = [];
      let groupData = [];
      let prevId;
      const enabledRows = this.grid.hasHorizontalLayout ? this.grid.visibleRowDimensions : config.rows?.filter(x => x.enabled);
      const dimIndex = enabledRows.indexOf(dim);
      for (const rec of data) {
        let currentDim;
        if (this.grid.hasHorizontalLayout) {
          currentDim = dim;
          rec.dimensions = enabledRows;
        } else {
          currentDim = rec.dimensions[dimIndex];
        }
        const id = PivotUtil.getRecordKey(rec, currentDim);
        if (groupData.length > 0 && prevId !== id) {
          const h = groupData.length > 1 ? groupData.length * this.grid.renderedRowHeight : undefined;
          groupData[0].height = h;
          groupData[0].rowSpan = groupData.length;
          res.push(groupData[0]);
          groupData = [];
        }
        groupData.push(rec);
        prevId = id;
      }
      if (groupData.length > 0) {
        const h = groupData.length > 1 ? groupData.length * this.grid.rowHeight + (groupData.length - 1) + 1 : undefined;
        groupData[0].height = h;
        groupData[0].rowSpan = groupData.length;
        res.push(groupData[0]);
      }
      return res;
    }
    static {
      this.ɵfac = function IgxPivotCellMergingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotCellMergingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridCellMerging",
        type: IgxPivotCellMergingPipe,
        pure: true
      });
    }
  }
  return IgxPivotCellMergingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotGridHorizontalRowGrouping = /*#__PURE__*/(() => {
  class IgxPivotGridHorizontalRowGrouping {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, config, _pipeTrigger, _regroupTrigger) {
      if (collection.length === 0 || config.rows.length === 0) return null;
      const data = collection ? cloneArray(collection, true) : [];
      const res = [];
      const groupDim = config.rows.filter(dim => dim.enabled)[0];
      let curGroup = [];
      let curGroupValue = data[0].dimensionValues.get(groupDim.memberName);
      for (const [index, curRec] of data.entries()) {
        curRec.dataIndex = index;
        const curRecValue = curRec.dimensionValues.get(groupDim.memberName);
        if (curGroup.length === 0 || curRecValue === curGroupValue) {
          curGroup.push(curRec);
        } else {
          curGroup["height"] = this.grid.renderedRowHeight * curGroup.length;
          res.push(curGroup);
          curGroup = [curRec];
          curGroupValue = curRecValue;
        }
      }
      res.push(curGroup);
      return res;
    }
    static {
      this.ɵfac = function IgxPivotGridHorizontalRowGrouping_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridHorizontalRowGrouping)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridHorizontalRowGrouping",
        type: IgxPivotGridHorizontalRowGrouping,
        pure: true
      });
    }
  }
  return IgxPivotGridHorizontalRowGrouping;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotGridHorizontalRowCellMerging = /*#__PURE__*/(() => {
  class IgxPivotGridHorizontalRowCellMerging {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, config, _pipeTrigger) {
      if (collection.length === 0 || config.rows.length === 0) return [{
        colStart: 1,
        colSpan: 1,
        rowStart: 1,
        rowSpan: 1,
        records: collection
      }];
      const data = collection ? cloneArray(collection, true) : [];
      const res = [];
      // Merge vertically for each row dimension.
      const verticalMergeGroups = [...data.map(_ => [])];
      for (let dimIndex = 0; dimIndex < this.grid.visibleRowDimensions.length; dimIndex++) {
        const curDim = this.grid.visibleRowDimensions[dimIndex];
        let curGroup = {
          colStart: dimIndex + 1,
          colSpan: 1,
          rowStart: 1,
          rowSpan: 1,
          value: data[0].dimensionValues.get(curDim.memberName),
          rootDimension: curDim,
          dimensions: [curDim],
          records: [data[0]]
        };
        for (let i = 1; i < data.length; i++) {
          const curRec = data[i];
          const curRecValue = curRec.dimensionValues.get(curDim.memberName);
          const previousRowCell = verticalMergeGroups[i][verticalMergeGroups[i].length - 1];
          if (curRecValue === curGroup.value && !previousRowCell) {
            // If previousRowCell is non existing, its merged so we can push in this vertigal group as well.
            curGroup.rowSpan++;
            curGroup.records.push(curRec);
          } else {
            verticalMergeGroups[curGroup.rowStart - 1].push(curGroup);
            curGroup = {
              colStart: dimIndex + 1,
              colSpan: 1,
              rowStart: curGroup.rowStart + curGroup.rowSpan,
              rowSpan: 1,
              value: curRec.dimensionValues.get(curDim.memberName),
              rootDimension: curDim,
              dimensions: [curDim],
              records: [curRec]
            };
          }
        }
        verticalMergeGroups[curGroup.rowStart - 1].push(curGroup);
      }
      // Merge rows in a single array
      const sortedGroups = verticalMergeGroups.reduce((prev, cur) => prev.concat(...cur), []);
      // Horizontally merge any groups that can be merged or have been
      res.push(sortedGroups[0]);
      let prevGroup = sortedGroups[0];
      for (let i = 1; i < sortedGroups.length; i++) {
        const curGroup = sortedGroups[i];
        if (curGroup.value && prevGroup.value !== curGroup.value) {
          prevGroup = curGroup;
          res.push(curGroup);
        } else {
          prevGroup.dimensions.push(curGroup.rootDimension);
          prevGroup.colSpan++;
        }
      }
      return res;
    }
    static {
      this.ɵfac = function IgxPivotGridHorizontalRowCellMerging_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridHorizontalRowCellMerging)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridHorizontalRowCellMerging",
        type: IgxPivotGridHorizontalRowCellMerging,
        pure: true
      });
    }
  }
  return IgxPivotGridHorizontalRowCellMerging;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotColumnPipe = /*#__PURE__*/(() => {
  class IgxPivotColumnPipe {
    transform(collection, config, cloneStrategy, _, _pipeTrigger, __) {
      const pivotKeys = config.pivotKeys || DEFAULT_PIVOT_KEYS;
      const enabledColumns = config.columns?.filter(x => x.enabled) || [];
      const enabledValues = config.values?.filter(x => x.enabled) || [];
      const colStrategy = config.columnStrategy || PivotColumnDimensionsStrategy.instance();
      const data = cloneArray(collection, true);
      return colStrategy.process(data, enabledColumns, enabledValues, cloneStrategy, pivotKeys);
    }
    static {
      this.ɵfac = function IgxPivotColumnPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotColumnPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridColumn",
        type: IgxPivotColumnPipe,
        pure: true
      });
    }
  }
  return IgxPivotColumnPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotGridFilterPipe = /*#__PURE__*/(() => {
  class IgxPivotGridFilterPipe {
    constructor(gridAPI) {
      this.gridAPI = gridAPI;
    }
    transform(collection, config, filterStrategy, advancedExpressionsTree, _filterPipeTrigger, _pipeTrigger) {
      const expressionsTree = PivotUtil.buildExpressionTree(config);
      const state = {
        expressionsTree,
        strategy: filterStrategy || new DimensionValuesFilteringStrategy(),
        advancedExpressionsTree
      };
      if (FilteringExpressionsTree.empty(state.expressionsTree) && FilteringExpressionsTree.empty(state.advancedExpressionsTree)) {
        return collection;
      }
      const result = FilterUtil.filter(cloneArray(collection, true), state, this.gridAPI.grid);
      return result;
    }
    static {
      this.ɵfac = function IgxPivotGridFilterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridFilterPipe)(i0.ɵɵdirectiveInject(GridBaseAPIService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridFilter",
        type: IgxPivotGridFilterPipe,
        pure: true
      });
    }
  }
  return IgxPivotGridFilterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotGridColumnSortingPipe = /*#__PURE__*/(() => {
  class IgxPivotGridColumnSortingPipe {
    transform(collection, expressions, sorting, _pipeTrigger) {
      let result;
      if (!expressions.length) {
        result = collection;
      } else {
        for (const expr of expressions) {
          expr.strategy = DefaultPivotGridRecordSortingStrategy.instance();
        }
        result = PivotUtil.sort(cloneArray(collection, true), expressions, sorting);
      }
      return result;
    }
    static {
      this.ɵfac = function IgxPivotGridColumnSortingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridColumnSortingPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridColumnSort",
        type: IgxPivotGridColumnSortingPipe,
        pure: true
      });
    }
  }
  return IgxPivotGridColumnSortingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxPivotGridSortingPipe = /*#__PURE__*/(() => {
  class IgxPivotGridSortingPipe {
    constructor(gridAPI) {
      this.gridAPI = gridAPI;
    }
    transform(collection, config, sorting, _pipeTrigger) {
      let result;
      const allDimensions = config.rows || [];
      const enabledDimensions = allDimensions.filter(x => x && x.enabled);
      const expressions = PivotSortUtil.generateDimensionSortingExpressions(enabledDimensions);
      if (!expressions.length) {
        result = collection;
      } else {
        result = DataUtil.sort(cloneArray(collection, true), expressions, sorting, this.gridAPI.grid);
      }
      return result;
    }
    static {
      this.ɵfac = function IgxPivotGridSortingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridSortingPipe)(i0.ɵɵdirectiveInject(GridBaseAPIService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pivotGridSort",
        type: IgxPivotGridSortingPipe,
        pure: true
      });
    }
  }
  return IgxPivotGridSortingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxFilterPivotItemsPipe = /*#__PURE__*/(() => {
  class IgxFilterPivotItemsPipe {
    transform(collection, filterCriteria, _pipeTrigger) {
      if (!collection) {
        return collection;
      }
      let copy = collection.slice(0);
      if (filterCriteria && filterCriteria.length > 0) {
        const filterFunc = c => {
          const filterText = c.member || c.memberName;
          if (!filterText) {
            return false;
          }
          return filterText.toLocaleLowerCase().indexOf(filterCriteria.toLocaleLowerCase()) >= 0 || (c.children?.some(filterFunc) ?? false);
        };
        copy = collection.filter(filterFunc);
      }
      return copy;
    }
    static {
      this.ɵfac = function IgxFilterPivotItemsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterPivotItemsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterPivotItems",
        type: IgxFilterPivotItemsPipe,
        pure: true
      });
    }
  }
  return IgxFilterPivotItemsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPivotGridCellStyleClassesPipe = /*#__PURE__*/(() => {
  class IgxPivotGridCellStyleClassesPipe {
    transform(cssClasses, _, rowData, columnData, index, __) {
      if (!cssClasses) {
        return '';
      }
      const result = [];
      for (const cssClass of Object.keys(cssClasses)) {
        const callbackOrValue = cssClasses[cssClass];
        const apply = typeof callbackOrValue === 'function' ? callbackOrValue(rowData, columnData, resolveNestedPath(rowData, columnData.field), index) : callbackOrValue;
        if (apply) {
          result.push(cssClass);
        }
      }
      return result.join(' ');
    }
    static {
      this.ɵfac = function IgxPivotGridCellStyleClassesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridCellStyleClassesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "igxPivotCellStyleClasses",
        type: IgxPivotGridCellStyleClassesPipe,
        pure: true
      });
    }
  }
  return IgxPivotGridCellStyleClassesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPivotRowComponent = /*#__PURE__*/(() => {
  class IgxPivotRowComponent extends IgxRowDirective {
    /**
     * @hidden
     */
    get selected() {
      let isSelected = false;
      for (const rowDim of this.data.dimensions) {
        const key = PivotUtil.getRecordKey(this.data, rowDim);
        if (this.selectionService.isPivotRowSelected(key)) {
          isSelected = true;
        }
      }
      return isSelected;
    }
    constructor(grid, selectionService, element, cdr, viewRef) {
      super(grid, selectionService, element, cdr);
      this.grid = grid;
      this.viewRef = viewRef;
      /**
       * @hidden
       * @internal
       */
      this.disabled = false;
    }
    /**
     * @hidden
     * @internal
     */
    get viewIndex() {
      return this.index;
    }
    /**
     * @hidden
     * @internal
     */
    get addRowUI() {
      return false;
    }
    /**
     * @hidden
     * @internal
     */
    get inEditMode() {
      return false;
    }
    /**
     * @hidden
     * @internal
     */
    set pinned(_value) {}
    get pinned() {
      return false;
    }
    /**
     * @hidden
     * @internal
     */
    delete() {}
    /**
     * @hidden
     * @internal
     */
    beginAddRow() {}
    /**
     * @hidden
     * @internal
     */
    update(_value) {}
    /**
     * @hidden
     * @internal
     */
    pin() {
      return false;
    }
    /**
    * @hidden
    * @internal
    */
    unpin() {
      return false;
    }
    /**
    *  The pivot record data passed to the row component.
    *
    * ```typescript
    * // get the pivot row data for the first selected row
    * let selectedRowData = this.grid.selectedRows[0].data;
    * ```
    */
    get data() {
      return this._data;
    }
    set data(v) {
      this._data = v;
    }
    /**
     * @hidden
     * @internal
     */
    get pivotAggregationData() {
      const aggregations = this.data.aggregationValues;
      const obj = {};
      aggregations.forEach((value, key) => {
        obj[key] = value;
      });
      return obj;
    }
    getCellClass(col) {
      const values = this.grid.values;
      if (values.length === 1) {
        return values[0].styles;
      }
      const colName = col.field.split(this.grid.pivotKeys.columnDimensionSeparator);
      const measureName = colName[colName.length - 1];
      return values.find(v => v.member === measureName)?.styles;
    }
    isCellActive(visibleColumnIndex) {
      const nav = this.grid.navigation;
      const node = nav.activeNode;
      return node && Object.keys(node).length !== 0 ? !nav.isRowHeaderActive && !nav.isRowDimensionHeaderActive && super.isCellActive(visibleColumnIndex) : false;
    }
    getColumnData(col) {
      const path = col.field.split(this.grid.pivotKeys.columnDimensionSeparator);
      const keyValueMap = new Map();
      const colDimensions = PivotUtil.flatten(this.grid.columnDimensions);
      for (const dim of colDimensions) {
        keyValueMap.set(dim.memberName, path.shift());
      }
      let pivotValue;
      if (this.grid.hasMultipleValues) {
        pivotValue = this.grid.values.find(x => x.member === path.shift());
      } else {
        pivotValue = this.grid.values ? this.grid.values[0] : undefined;
      }
      return {
        field: col.field,
        dimensions: this.grid.columnDimensions,
        dimensionValues: keyValueMap,
        value: pivotValue
      };
    }
    static {
      this.ɵfac = function IgxPivotRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowComponent,
        selectors: [["igx-pivot-row"]],
        hostVars: 1,
        hostBindings: function IgxPivotRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-selected", ctx.selected);
          }
        },
        inputs: {
          selected: "selected",
          data: "data"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxRowDirective,
          useExisting: forwardRef(() => IgxPivotRowComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 8,
        consts: [["igxDirRef", ""], ["rowSelectorBaseTemplate", ""], ["cell", ""], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForSizePropName", "igxForScrollOrientation", "igxForContainerSize", "igxForTrackBy"], [1, "igx-grid__td", "igx-grid__td--fw", 3, "pointerdown", "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "active", "rowData", "columnData", "width", "visibleColumnIndex", "value", "cellTemplate", "lastSearchInfo", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "readonly", "checked", "disableRipple", "disabled", "disableTransitions", "aria-label"]],
        template: function IgxPivotRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxPivotRowComponent_ng_template_0_Template, 6, 84, "ng-template", 3, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(2, "igxNotGrouped");
            i0.ɵɵtemplate(3, IgxPivotRowComponent_ng_template_3_Template, 2, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind1(2, 6, ctx.unpinnedColumns))("igxForScrollContainer", ctx.grid.parentVirtDir)("igxForSizePropName", "calcPixelWidth")("igxForScrollOrientation", "horizontal")("igxForContainerSize", ctx.grid.unpinnedWidth)("igxForTrackBy", ctx.grid.trackColumnChanges);
          }
        },
        dependencies: [IgxGridForOfDirective, IgxGridCellComponent, NgClass, NgStyle, IgxCheckboxComponent, IgxGridNotGroupedPipe, IgxGridCellStylesPipe, IgxGridDataMapperPipe, IgxGridTransactionStatePipe, IgxPivotGridCellStyleClassesPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorAlternateBaseType: PivotDimension */
/* alternateBaseType: PivotDimension */
// Equals to pretty much this configuration:
// {
//     member: () => 'All Periods',
//     enabled: true,
//     fieldName: 'AllPeriods',
//     childLevel: {
//         fieldName: 'Years',
//         member: (rec) => {
//             const recordValue = rec['Date'];
//             return recordValue ? (new Date(recordValue)).getFullYear().toString() : rec['Years'];
//         },
//         enabled: true,
//         childLevel: {
//                 member: (rec) => {
//                     const recordValue = rec['Date'];
//                     return recordValue ? new Date(recordValue).toLocaleString('default', { month: 'long' }) : rec['Months'];
//                 },
//                 enabled: true,
//                 fieldName: 'Months',
//                 childLevel: {
//                         member: 'Date',
//                         fieldName:'Date',
//                         enabled: true
//                     }
//             }
//     }
// },
class IgxPivotDateDimension {
  /**
   * Gets/Sets the resource strings.
   *
   * @remarks
   * By default it uses EN resources.
   */
  set resourceStrings(value) {
    this._resourceStrings = Object.assign({}, this._resourceStrings, value);
  }
  get resourceStrings() {
    return this._resourceStrings;
  }
  /**
   * Gets/Sets the base dimension that is used by this class to determine the other dimensions and their values.
   * Having base dimension set is required in order for the Date Dimensions to show.
   */
  get baseDimension() {
    return this._baseDimension;
  }
  set baseDimension(value) {
    this._baseDimension = value;
    this.initialize(this.baseDimension, this.options);
  }
  /**
   * Gets/Sets the options for the predefined date dimensions whether to show quarter, years and etc.
   */
  get options() {
    return this._options;
  }
  set options(value) {
    this._options = value;
    if (this.baseDimension) {
      this.initialize(this.baseDimension, this.options);
    }
  }
  /**
   * Creates additional pivot date dimensions based on a provided dimension describing date data:
   *
   * @param inDateDimension Base dimension that is used by this class to determine the other dimensions and their values.
   * @param inOptions Options for the predefined date dimensions whether to show quarter, years and etc.
   * @example
   * ```typescript
   * // Displays only years as parent dimension to the base dimension provided.
   * new IgxPivotDateDimension({ memberName: 'Date', enabled: true }, { total: false, months: false });
   * ```
   */
  constructor(inBaseDimension = null, inOptions = {}) {
    /** Enables/Disables a particular dimension from pivot structure. */
    this.enabled = true;
    /* blazorSuppress */
    /** Default options. */
    this.defaultOptions = {
      total: true,
      years: true,
      months: true,
      fullDate: true
    };
    /** @hidden @internal */
    this.memberName = 'AllPeriods';
    this._resourceStrings = getCurrentResourceStrings(GridResourceStringsEN);
    this._options = {};
    this._monthIntl = new Intl.DateTimeFormat('default', {
      month: 'long'
    });
    /** @hidden @internal */
    this.memberFunction = _data => this.resourceStrings.igx_grid_pivot_date_dimension_total;
    this._baseDimension = inBaseDimension;
    this._options = inOptions;
    if (this.baseDimension && this.options) {
      this.initialize(this.baseDimension, this.options);
    }
  }
  initialize(inBaseDimension, inOptions) {
    const options = {
      ...this.defaultOptions,
      ...inOptions
    };
    this.dataType = GridColumnDataType.Date;
    inBaseDimension.dataType = GridColumnDataType.Date;
    this.enabled = inBaseDimension.enabled;
    this.displayName = inBaseDimension.displayName || this.resourceStrings.igx_grid_pivot_date_dimension_total;
    const baseDimension = options.fullDate ? inBaseDimension : null;
    const monthDimensionDef = {
      memberName: 'Months',
      memberFunction: rec => {
        const recordValue = PivotUtil.extractValueFromDimension(inBaseDimension, rec);
        return recordValue ? this._monthIntl.format(new Date(recordValue)) : rec['Months'];
      },
      enabled: true,
      childLevel: baseDimension
    };
    const monthDimension = options.months ? monthDimensionDef : baseDimension;
    const quarterDimensionDef = {
      memberName: 'Quarters',
      memberFunction: rec => {
        const recordValue = PivotUtil.extractValueFromDimension(inBaseDimension, rec);
        return recordValue ? `Q` + Math.ceil((new Date(recordValue).getMonth() + 1) / 3) : rec['Quarters'];
      },
      enabled: true,
      childLevel: monthDimension
    };
    const quarterDimension = options.quarters ? quarterDimensionDef : monthDimension;
    const yearsDimensionDef = {
      memberName: 'Years',
      memberFunction: rec => {
        const recordValue = PivotUtil.extractValueFromDimension(inBaseDimension, rec);
        return recordValue ? new Date(recordValue).getFullYear().toString() : rec['Years'];
      },
      enabled: true,
      childLevel: quarterDimension
    };
    const yearsDimension = options.years ? yearsDimensionDef : quarterDimension;
    this.childLevel = yearsDimension;
    if (!options.total) {
      this.memberName = yearsDimension.memberName;
      this.memberFunction = yearsDimension.memberFunction;
      this.childLevel = yearsDimension.childLevel;
      this.displayName = yearsDimension.displayName;
    }
  }
}

/**
 *
 * For all intents & purposes treat this component as what a <thead> usually is in the default <table> element.
 *
 * This container holds the pivot grid header elements and their behavior/interactions.
 *
 * @hidden @internal
 */
let IgxPivotRowDimensionMrlRowComponent = /*#__PURE__*/(() => {
  class IgxPivotRowDimensionMrlRowComponent extends IgxGridHeaderRowComponent {
    get rowsTemplate() {
      return this.getRowMRLTemplate(true, this.rowGroup);
    }
    get colsTemplate() {
      return this.getRowMRLTemplate(false, this.rowGroup);
    }
    constructor(grid, ref, injector, envInjector, cdr, viewRef) {
      super(ref, cdr);
      this.grid = grid;
      this.injector = injector;
      this.envInjector = envInjector;
      this.viewRef = viewRef;
      this.pivotDim = true;
      this.mrlBlock = true;
    }
    getRowMRLTemplate(forRows, rows) {
      if (forRows) {
        return `repeat(${rows.length},1fr)`;
      } else if (this.grid.visibleRowDimensions && this.grid.dimensionDataColumns) {
        const res = [];
        this.grid.visibleRowDimensions.forEach(dim => {
          res.push(this.grid.rowDimensionWidth(dim));
        });
        return res.join(' ');
      }
    }
    rowDimensionWidthCombined(dims) {
      let resWidth = 0;
      for (const dim of dims || []) {
        const rowDimWidth = this.grid.rowDimensionWidth(dim);
        if (rowDimWidth === 'fit-content') {
          return -1;
        } else {
          resWidth += parseFloat(rowDimWidth);
        }
      }
      return resWidth;
    }
    getGroupKey(group) {
      const rec = group.records[0];
      const key = PivotUtil.getRecordKey(rec, group.rootDimension);
      return key;
    }
    static {
      this.ɵfac = function IgxPivotRowDimensionMrlRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotRowDimensionMrlRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotRowDimensionMrlRowComponent,
        selectors: [["igx-pivot-row-dimension-mrl-row"]],
        viewQuery: function IgxPivotRowDimensionMrlRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxPivotRowDimensionContentComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentCells = _t);
          }
        },
        hostVars: 8,
        hostBindings: function IgxPivotRowDimensionMrlRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("grid-template-rows", ctx.rowsTemplate)("grid-template-columns", ctx.colsTemplate);
            i0.ɵɵclassProp("igx-grid__tbody-pivot-dimension", ctx.pivotDim)("igx-grid__mrl-block", ctx.mrlBlock);
          }
        },
        inputs: {
          rowIndex: "rowIndex",
          rowGroup: "rowGroup",
          groupedData: "groupedData"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 4,
        consts: [["role", "row", 1, "igx-grid-thead", 3, "grid", "dimension", "rootDimension", "rowIndex", "colIndex", "rowData", "width", "layout"]],
        template: function IgxPivotRowDimensionMrlRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, IgxPivotRowDimensionMrlRowComponent_For_1_Template, 1, 14, "igx-pivot-row-dimension-content", 0, _forTrack15, true);
            i0.ɵɵpipe(2, "pivotGridHorizontalRowCellMerging");
          }
          if (rf & 2) {
            i0.ɵɵrepeater(i0.ɵɵpipeBind3(2, 0, ctx.rowGroup, ctx.grid.pivotConfiguration, ctx.grid.pipeTrigger));
          }
        },
        dependencies: [IgxPivotRowDimensionContentComponent, IgxPivotGridHorizontalRowCellMerging],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxPivotRowDimensionMrlRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$7 = 0;
const MINIMUM_COLUMN_WIDTH = 200;
const MINIMUM_COLUMN_WIDTH_SUPER_COMPACT = 104;
/* blazorAdditionalDependency: Column */
/* blazorAdditionalDependency: ColumnGroup */
/* blazorAdditionalDependency: ColumnLayout */
/* blazorAdditionalDependency: GridToolbar */
/* blazorAdditionalDependency: GridToolbarActions */
/* blazorAdditionalDependency: GridToolbarTitle */
/* blazorAdditionalDependency: GridToolbarAdvancedFiltering */
/* blazorAdditionalDependency: GridToolbarExporter */
/* blazorAdditionalDependency: GridToolbarHiding */
/* blazorAdditionalDependency: GridToolbarPinning */
/* blazorAdditionalDependency: ActionStrip */
/* blazorAdditionalDependency: GridActionsBaseDirective */
/* blazorAdditionalDependency: GridEditingActions */
/* blazorAdditionalDependency: GridPinningActions */
/* blazorAdditionalDependency: PivotDateDimension */
/* blazorIndirectRender */
/**
 * Pivot Grid provides a way to present and manipulate data in a pivot table view.
 *
 * @igxModule IgxPivotGridModule
 * @igxGroup Grids & Lists
 * @igxKeywords pivot, grid, table
 * @igxTheme igx-grid-theme
 * @remarks
 * The Ignite UI Pivot Grid is used for grouping and aggregating simple flat data into a pivot table.  Once data
 * has been bound and the dimensions and values configured it can be manipulated via sorting and filtering.
 * @example
 * ```html
 * <igx-pivot-grid [data]="data" [pivotConfiguration]="configuration">
 * </igx-pivot-grid>
 * ```
 */
let IgxPivotGridComponent = /*#__PURE__*/(() => {
  class IgxPivotGridComponent extends IgxGridBaseDirective {
    /**
     * Gets the sorting expressions generated for the dimensions.
     *
     * @example
     * ```typescript
     * const expressions = this.grid.dimensionsSortingExpressions;
     * ```
     */
    get dimensionsSortingExpressions() {
      const allEnabledDimensions = this.rowDimensions.concat(this.columnDimensions);
      const dimensionsSortingExpressions = PivotSortUtil.generateDimensionSortingExpressions(allEnabledDimensions);
      return dimensionsSortingExpressions;
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /* @tsTwoWayProperty (true, "PivotConfigurationChange", "Detail.PivotConfiguration", false) */
    /**
     * Gets/Sets the pivot configuration with all related dimensions and values.
     *
     * @example
     * ```html
     * <igx-pivot-grid [pivotConfiguration]="config"></igx-pivot-grid>
     * ```
     */
    set pivotConfiguration(value) {
      this._pivotConfiguration = value;
      this.emitInitEvents(this._pivotConfiguration);
      this.filteringExpressionsTree = PivotUtil.buildExpressionTree(value);
      if (!this._init) {
        this.setupColumns();
      }
      this.notifyChanges(true);
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor */
    get pivotConfiguration() {
      return this._pivotConfiguration || {
        rows: null,
        columns: null,
        values: null,
        filters: null
      };
    }
    set pivotUI(value) {
      this._pivotUI = Object.assign(this._pivotUI, value || {});
      this.pipeTrigger++;
      this.notifyChanges(true);
    }
    get pivotUI() {
      return this._pivotUI;
    }
    /**
     * Enables a super compact theme for the component.
     * @remarks
     * Overrides the grid size option if one is set.
     * @example
     * ```html
     * <igx-pivot-grid [superCompactMode]="true"></igx-pivot-grid>
     * ```
     */
    get superCompactMode() {
      return this._superCompactMode;
    }
    set superCompactMode(value) {
      this._superCompactMode = value;
    }
    /** @hidden @internal */
    get gridSize() {
      if (this.superCompactMode) {
        return Size.Small;
      }
      return super.gridSize;
    }
    /**
     * Gets/Sets the values clone strategy of the pivot grid when assigning them to different dimensions.
     *
     * @example
     * ```html
     *  <igx-pivot-grid #grid [data]="localData" [pivotValueCloneStrategy]="customCloneStrategy"></igx-pivot-grid>
     * ```
     * @hidden @internal
     */
    get pivotValueCloneStrategy() {
      return this._pivotValueCloneStrategy;
    }
    set pivotValueCloneStrategy(strategy) {
      if (strategy) {
        this._pivotValueCloneStrategy = strategy;
      }
    }
    /**
     * @hidden @internal
     */
    get minColumnWidth() {
      if (this.superCompactMode) {
        return MINIMUM_COLUMN_WIDTH_SUPER_COMPACT;
      } else {
        return MINIMUM_COLUMN_WIDTH;
      }
    }
    /** @hidden @internal */
    get pivotKeys() {
      return this.pivotConfiguration.pivotKeys || DEFAULT_PIVOT_KEYS;
    }
    /** @hidden @internal */
    get type() {
      return 'pivot';
    }
    /**
    * @hidden @internal
    */
    get rootSummariesEnabled() {
      return false;
    }
    /**
     * @hidden @internal
     */
    get emptyRowDimension() {
      return this._emptyRowDimension;
    }
    /**
    * Gets/Sets the default expand state for all rows.
    */
    get defaultExpandState() {
      return this._defaultExpandState;
    }
    set defaultExpandState(val) {
      this._defaultExpandState = val;
    }
    /**
     * @hidden @internal
     */
    get pagingMode() {
      return;
    }
    set pagingMode(_val) {}
    /**
     * @hidden @internal
     */
    get hideRowSelectors() {
      return;
    }
    set hideRowSelectors(_value) {}
    /**
     * @hidden @internal
     */
    get actionStrip() {
      return undefined;
    }
    /**
     * @hidden @internal
     * @deprecated in version 18.2.0. This property is no longer supported.
     */
    get shouldGenerate() {
      return false;
    }
    set shouldGenerate(value) {}
    /**
     * @hidden @internal
     */
    get rowDraggable() {
      return;
    }
    set rowDraggable(_val) {}
    /**
     * @hidden @internal
     */
    get allowAdvancedFiltering() {
      return false;
    }
    set allowAdvancedFiltering(_value) {}
    /**
     * @hidden @internal
     */
    get filterMode() {
      return FilterMode.quickFilter;
    }
    set filterMode(_value) {}
    /**
     * @hidden @internal
     */
    get allowFiltering() {
      return false;
    }
    set allowFiltering(_value) {}
    /**
     * @hidden @internal
     */
    get page() {
      return 0;
    }
    set page(_val) {}
    /**
     * @hidden @internal
     */
    get perPage() {
      return;
    }
    set perPage(_val) {}
    /**
     * @hidden @internal
     */
    get pinnedColumns() {
      return [];
    }
    /**
    * @hidden @internal
    */
    get unpinnedColumns() {
      return super.unpinnedColumns;
    }
    /**
    * @hidden @internal
    */
    get unpinnedDataView() {
      return super.unpinnedDataView;
    }
    /**
    * @hidden @internal
    */
    get unpinnedWidth() {
      return super.unpinnedWidth;
    }
    /**
     * @hidden @internal
     */
    get pinnedWidth() {
      return super.pinnedWidth;
    }
    /**
     * @hidden @internal
     */
    set summaryRowHeight(_value) {}
    get summaryRowHeight() {
      return 0;
    }
    /**
     * @hidden @internal
     */
    get transactions() {
      return this._transactions;
    }
    /**
     * @hidden @internal
     */
    get dragIndicatorIconTemplate() {
      return;
    }
    set dragIndicatorIconTemplate(_val) {}
    /**
     * @hidden @internal
     */
    get rowEditable() {
      return;
    }
    set rowEditable(_val) {}
    /**
     * @hidden @internal
     */
    get pinning() {
      return {};
    }
    set pinning(_value) {}
    /**
     * @hidden @internal
     */
    get summaryPosition() {
      return;
    }
    set summaryPosition(_value) {}
    /**
     * @hidden @interal
     */
    get summaryCalculationMode() {
      return;
    }
    set summaryCalculationMode(_value) {}
    /**
     * @hidden @interal
     */
    get showSummaryOnCollapse() {
      return;
    }
    set showSummaryOnCollapse(_value) {}
    /**
     * @hidden @internal
     */
    get hiddenColumnsCount() {
      return null;
    }
    /**
     * @hidden @internal
     */
    get pinnedColumnsCount() {
      return null;
    }
    /**
     * @hidden @internal
     */
    get batchEditing() {
      return;
    }
    set batchEditing(_val) {}
    /* csSuppress */
    get selectedRows() {
      if (this.selectionService.getSelectedRows().length === 0) {
        return [];
      }
      const selectedRowIds = [];
      this.dataView.forEach(record => {
        const prev = [];
        for (const dim of this.rowDimensions) {
          let currDim = dim;
          let shouldBreak = false;
          do {
            const key = PivotUtil.getRecordKey(record, currDim);
            if (this.selectionService.isPivotRowSelected(key) && !selectedRowIds.find(x => x === record)) {
              selectedRowIds.push(record);
              shouldBreak = true;
              break;
            }
            currDim = currDim.childLevel;
          } while (currDim);
          prev.push(dim);
          if (shouldBreak) {
            break;
          }
        }
      });
      return selectedRowIds;
    }
    constructor(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions) {
      super(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions);
      this.navigation = navigation;
      /**
       * Emitted when the dimension collection is changed via the grid chip area.
       *
       * @remarks
       * Returns the new dimension collection and its type:
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (dimensionsChange)="dimensionsChange($event)"></igx-grid>
       * ```
       */
      this.dimensionsChange = new EventEmitter();
      /**
       * Emitted when any of the pivotConfiguration properties is changed via the grid chip area.
       *
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (pivotConfigurationChanged)="configurationChanged($event)"></igx-grid>
       * ```
       */
      this.pivotConfigurationChange = new EventEmitter();
      /**
       * Emitted when the dimension is initialized.
       * @remarks
       * Emits the dimension that is about to be initialized.
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (dimensionInit)="dimensionInit($event)"></igx-pivot-grid>
       * ```
       */
      this.dimensionInit = new EventEmitter();
      /**
       * Emitted when the value is initialized.
       * @remarks
       * Emits the value that is about to be initialized.
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (valueInit)="valueInit($event)"></igx-pivot-grid>
       * ```
       */
      this.valueInit = new EventEmitter();
      /**
       * Emitted when a dimension is sorted.
       *
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (dimensionsSortingExpressionsChange)="dimensionsSortingExpressionsChange($event)"></igx-pivot-grid>
       * ```
       */
      this.dimensionsSortingExpressionsChange = new EventEmitter();
      /**
       * Emitted when the values collection is changed via the grid chip area.
       *
       * @remarks
       * Returns the new dimension
       * @example
       * ```html
       * <igx-pivot-grid #grid [data]="localData" [height]="'305px'"
       *              (valuesChange)="valuesChange($event)"></igx-grid>
       * ```
      */
      this.valuesChange = new EventEmitter();
      /**
       * Gets/Sets whether to auto-generate the pivot configuration based on the provided data.
       *
       * @remarks
       * The default value is false. When set to true, it will override all dimensions and values in the pivotConfiguration.
       * @example
       * ```html
       * <igx-pivot-grid [data]="Data" [autoGenerateConfig]="true"></igx-pivot-grid>
       * ```
       */
      this.autoGenerateConfig = false;
      /**
       * @hidden @internal
       */
      this.role = 'grid';
      /**
       * @hidden @internal
       */
      this.autoGenerateExclude = [];
      /**
       * @hidden @internal
       */
      this.snackbarDisplayTime = 6000;
      /**
       * @hidden @internal
       */
      this.cellEdit = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.cellEditDone = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.cellEditEnter = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.cellEditExit = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnMovingStart = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnMoving = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnMovingEnd = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnPin = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.columnPinned = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowAdd = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowAdded = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowDeleted = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowDelete = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowDragStart = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowDragEnd = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowEditEnter = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowEdit = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowEditDone = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowEditExit = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowPinning = new EventEmitter();
      /**
       * @hidden @internal
       */
      this.rowPinned = new EventEmitter();
      /** @hidden @internal */
      this.columnGroupStates = new Map();
      /**
       * @hidden @internal
       */
      this.dragRowID = null;
      /**
       * @hidden @internal
       */
      this.rowDimensionResizing = true;
      this._emptyRowDimension = {
        memberName: '',
        enabled: true,
        level: 0
      };
      this._pivotValueCloneStrategy = new DefaultDataCloneStrategy();
      this._defaultExpandState = false;
      this._filterStrategy = new DimensionValuesFilteringStrategy();
      this.regroupTrigger = 0;
      this._pivotConfiguration = {
        rows: null,
        columns: null,
        values: null,
        filters: null
      };
      this.p_id = `igx-pivot-grid-${NEXT_ID$7++}`;
      this._superCompactMode = false;
      this._pivotUI = {
        showConfiguration: true,
        showRowHeaders: false,
        rowLayout: PivotRowLayoutType.Vertical,
        horizontalSummariesPosition: PivotSummaryPosition.Bottom
      };
      this._sortableColumns = true;
      this._visibleRowDimensions = [];
      this._shouldUpdateSizes = false;
      /**
       * @hidden @internal
       */
      this.autoGenerate = true;
      /**
       * @hidden @internal
       */
      this.moving = false;
      /**
       * @hidden @internal
       */
      this.toolbarExporting = new EventEmitter();
    }
    /**
     * @hidden
     */
    ngOnInit() {
      // pivot grid always generates columns automatically.
      this.autoGenerate = true;
      super.ngOnInit();
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      // ignore any user defined columns and auto-generate based on pivot config.
      this.updateColumns([]);
      Promise.resolve().then(() => {
        if (this.autoGenerateConfig) {
          this.generateConfig();
        }
        this.setupColumns();
      });
      if (this.valueChipTemplateDirective) {
        this.valueChipTemplate = this.valueChipTemplateDirective.template;
      }
      if (this.rowDimensionHeaderDirective) {
        this.rowDimensionHeaderTemplate = this.rowDimensionHeaderDirective.template;
      }
    }
    /**
     * @hidden @internal
     */
    ngAfterViewInit() {
      Promise.resolve().then(() => {
        super.ngAfterViewInit();
      });
    }
    /**
     * @hidden @internal
     */
    ngOnChanges(changes) {
      if (changes.superCompactMode && !changes.superCompactMode.isFirstChange()) {
        this._shouldUpdateSizes = true;
        resizeObservable(this.verticalScrollContainer.displayContainer).pipe(take(1), takeUntil(this.destroy$)).subscribe(() => this.resizeNotify.next());
      }
    }
    /**
     * Notifies for dimension change.
     */
    notifyDimensionChange(regenerateColumns = false) {
      if (regenerateColumns) {
        this.setupColumns();
      }
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    /**
     * Gets the full list of dimensions.
     *
     * @example
     * ```typescript
     * const dimensions = this.grid.allDimensions;
     * ```
     */
    get allDimensions() {
      const config = this._pivotConfiguration;
      if (!config) return [];
      return (config.rows || []).concat(config.columns || []).concat(config.filters || []).filter(x => x !== null && x !== undefined);
    }
    get allVisibleDimensions() {
      const config = this._pivotConfiguration;
      if (!config) return [];
      const uniqueVisibleRowDims = this.visibleRowDimensions.filter(dim => !config.rows.find(configRow => configRow.memberName === dim.memberName));
      const rows = (config.rows || []).concat(...uniqueVisibleRowDims);
      return rows.concat(config.columns || []).concat(config.filters || []).filter(x => x !== null && x !== undefined);
    }
    get shouldResize() {
      if (!this.dataRowList.first?.cells || this.dataRowList.first.cells.length === 0) {
        return false;
      }
      const isSizePropChanged = super.shouldResize;
      if (isSizePropChanged || this._shouldUpdateSizes) {
        this._shouldUpdateSizes = false;
        return true;
      }
      return false;
    }
    /** @hidden @internal */
    createFilterESF(dropdown, column, options, shouldReatach) {
      options.outlet = this.outlet;
      if (dropdown) {
        dropdown.initialize(column, this.overlayService);
        if (shouldReatach) {
          const id = this.overlayService.attach(dropdown.element, options);
          dropdown.overlayComponentId = id;
          return {
            id,
            ref: undefined
          };
        }
        return {
          id: dropdown.overlayComponentId,
          ref: undefined
        };
      }
    }
    /** @hidden */
    featureColumnsWidth() {
      return this.pivotRowWidths || 0;
    }
    /* blazorSuppress */
    /**
     * Gets/Sets the value of the `id` attribute.
     *
     * @remarks
     * If not provided it will be automatically generated.
     * @example
     * ```html
     * <igx-pivot-grid [id]="'igx-pivot-1'" [data]="Data"></igx-pivot-grid>
     * ```
     */
    get id() {
      return this.p_id;
    }
    /* blazorSuppress */
    set id(value) {
      this.p_id = value;
    }
    /* treatAsRef */
    /* blazorAlternateType: object */
    /**
     * Gets/Sets the array of data that populates the component.
     * ```html
     * <igx-pivot-grid [data]="Data"></igx-pivot-grid>
     * ```
     */
    set data(value) {
      this._data = value || [];
      if (!this._init) {
        if (this.autoGenerateConfig) {
          this.generateConfig();
        }
        this.setupColumns();
        this.reflow();
      }
      this.cdr.markForCheck();
      if (this.height === null || this.height.indexOf('%') !== -1) {
        // If the height will change based on how much data there is, recalculate sizes in igxForOf.
        this.notifyChanges(true);
      }
    }
    /* treatAsRef */
    /* blazorAlternateType: object */
    /**
     * Returns an array of data set to the component.
     * ```typescript
     * let data = this.grid.data;
     * ```
     */
    get data() {
      return this._data;
    }
    /**
     * @hidden
     */
    getContext(rowData, rowIndex) {
      return {
        $implicit: rowData,
        templateID: {
          type: 'dataRow',
          id: null
        },
        index: this.getDataViewIndex(rowIndex, false)
      };
    }
    /**
     * @hidden @internal
     */
    get pivotRowWidths() {
      return this.visibleRowDimensions.length ? this.visibleRowDimensions.reduce((accumulator, dim) => accumulator + this.rowDimensionWidthToPixels(dim), 0) : this.rowDimensionWidthToPixels(this.emptyRowDimension);
    }
    /**
     * @hidden @internal
     */
    rowDimensionWidth(dim) {
      const isAuto = dim.width && dim.width.indexOf('auto') !== -1;
      if (isAuto) {
        return dim.autoWidth ? dim.autoWidth + 'px' : 'fit-content';
      } else {
        return this.rowDimensionWidthToPixels(dim) + 'px';
      }
    }
    /**
     * @hidden @internal
     */
    rowDimensionWidthToPixels(dim) {
      if (!dim?.width) {
        return MINIMUM_COLUMN_WIDTH;
      }
      const isPercent = dim.width && dim.width.indexOf('%') !== -1;
      const isAuto = dim.width && dim.width.indexOf('auto') !== -1;
      if (isPercent) {
        return Math.round(parseFloat(dim.width) / 100 * this.calcWidth);
      } else if (isAuto) {
        return dim.autoWidth;
      } else {
        return parseInt(dim.width, 10);
      }
    }
    /**
     * @hidden @internal
     */
    reverseDimensionWidthToPercent(width) {
      return width * 100 / this.calcWidth;
    }
    /** @hidden @internal */
    get pivotContentCalcWidth() {
      const totalDimWidth = this.rowDimensions.length > 0 ? this.rowDimensions.map(dim => this.rowDimensionWidthToPixels(dim)).reduce((prev, cur) => prev + cur) : 0;
      return this.calcWidth - totalDimWidth;
    }
    /** @hidden @internal */
    get pivotPinnedWidth() {
      return !this._init ? this.isPinningToStart ? this.pinnedWidth : this.headerFeaturesWidth : 0;
    }
    /** @hidden @internal */
    get pivotUnpinnedWidth() {
      return this.unpinnedWidth || 0;
    }
    /** @hidden @internal */
    get rowDimensions() {
      return this.pivotConfiguration.rows?.filter(x => x.enabled) || [];
    }
    /** @hidden @internal */
    set visibleRowDimensions(value) {
      this._visibleRowDimensions = value;
    }
    get visibleRowDimensions() {
      return this._visibleRowDimensions || this.rowDimensions;
    }
    /** @hidden @internal */
    get columnDimensions() {
      return this.pivotConfiguration.columns?.filter(x => x.enabled) || [];
    }
    /** @hidden @internal */
    get filterDimensions() {
      return this.pivotConfiguration.filters?.filter(x => x.enabled) || [];
    }
    /** @hidden @internal */
    get values() {
      return this.pivotConfiguration.values?.filter(x => x.enabled) || [];
    }
    toggleColumn(col) {
      const state = this.columnGroupStates.get(col.field);
      const newState = !state;
      this.columnGroupStates.set(col.field, newState);
      this.toggleRowGroup(col, newState);
      this.reflow();
    }
    /**
     * @hidden @internal
     */
    isRecordPinnedByIndex(_rowIndex) {
      return null;
    }
    /**
     * @hidden @internal
     */
    toggleColumnVisibility(_args) {
      return;
    }
    /**
     * @hidden @internal
     */
    expandAll() {}
    /**
     * @hidden @internal
     */
    collapseAll() {}
    /**
     * @hidden @internal
     */
    expandRow(_rowID) {}
    /**
     * @hidden @internal
     */
    collapseRow(_rowID) {}
    /**
     * @hidden @internal
     */
    get pinnedRows() {
      return;
    }
    /**
     * @hidden @internal
     */
    get totalRecords() {
      return;
    }
    set totalRecords(_total) {}
    /**
     * @hidden @internal
     */
    moveColumn(_column, _target, _pos = DropPosition.AfterDropTarget) {}
    /**
     * @hidden @internal
     */
    addRow(_data) {}
    /**
     * @hidden @internal
     */
    deleteRow(_rowSelector) {}
    /**
     * @hidden @internal
     */
    updateCell(_value, _rowSelector, _column) {}
    /**
     * @hidden @internal
     */
    updateRow(_value, _rowSelector) {}
    /**
     * @hidden @internal
     */
    enableSummaries(..._rest) {}
    /**
     * @hidden @internal
     */
    disableSummaries(..._rest) {}
    /**
     * @hidden @internal
     */
    pinColumn(_columnName, _index) {
      return;
    }
    /**
     * @hidden @internal
     */
    unpinColumn(_columnName, _index) {
      return;
    }
    /**
     * @hidden @internal
     */
    pinRow(_rowID, _index, _row) {
      return;
    }
    /**
     * @hidden @internal
     */
    unpinRow(_rowID, _row) {
      return;
    }
    /**
     * @hidden @internal
     */
    get pinnedRowHeight() {
      return;
    }
    /**
     * @hidden @internal
     */
    get hasEditableColumns() {
      return;
    }
    /**
     * @hidden @internal
     */
    get hasSummarizedColumns() {
      return;
    }
    /**
     * @hidden @internal
     */
    get hasMovableColumns() {
      return;
    }
    /**
     * @hidden @internal
     */
    get pinnedDataView() {
      return [];
    }
    /**
     * @hidden @internal
     */
    openAdvancedFilteringDialog(_overlaySettings) {}
    /**
     * @hidden @internal
     */
    closeAdvancedFilteringDialog(_applyChanges) {}
    /**
     * @hidden @internal
     */
    endEdit(_commit = true, _event) {
      return;
    }
    /**
     * @hidden @internal
     */
    beginAddRowById(_rowID, _asChild) {}
    /**
     * @hidden @internal
     */
    beginAddRowByIndex(_index) {}
    /**
     * @hidden @internal
     */
    clearSearch() {}
    /**
    * @hidden @internal
    */
    refreshSearch(_updateActiveInfo, _endEdit = true) {
      return 0;
    }
    /**
    * @hidden @internal
    */
    findNext(_text, _caseSensitive, _exactMatch) {
      return 0;
    }
    /**
    * @hidden @internal
    */
    findPrev(_text, _caseSensitive, _exactMatch) {
      return 0;
    }
    /**
    * @hidden @internal
    */
    getNextCell(currRowIndex, curVisibleColIndex, callback = null) {
      return super.getNextCell(currRowIndex, curVisibleColIndex, callback);
    }
    /**
    * @hidden @internal
    */
    getPreviousCell(currRowIndex, curVisibleColIndex, callback = null) {
      return super.getPreviousCell(currRowIndex, curVisibleColIndex, callback);
    }
    /**
    * @hidden @internal
    */
    getPinnedWidth(takeHidden = false) {
      return super.getPinnedWidth(takeHidden);
    }
    /**
     * @hidden @internal
     */
    get totalHeight() {
      return this.calcHeight;
    }
    getColumnGroupExpandState(col) {
      const state = this.columnGroupStates.get(col.field);
      // columns are expanded by default?
      return state !== undefined && state !== null ? state : false;
    }
    toggleRowGroup(col, newState) {
      if (!col) return;
      if (this.hasMultipleValues) {
        const parentCols = col.parent ? col.parent.children.toArray() : this._autoGeneratedCols.filter(x => x.level === 0);
        const siblingCol = parentCols.filter(x => x.header === col.header && x !== col)[0];
        const currIndex = parentCols.indexOf(col);
        const siblingIndex = parentCols.indexOf(siblingCol);
        if (currIndex < siblingIndex) {
          // clicked on the full hierarchy header
          this.resolveToggle(col, newState);
          siblingCol.headerTemplate = this.headerTemplate;
        } else {
          // clicked on summary parent column that contains just the measures
          col.headerTemplate = undefined;
          this.resolveToggle(siblingCol, newState);
        }
      } else {
        const parentCols = col.parent ? col.parent.children : this._autoGeneratedCols.filter(x => x.level === 0);
        const fieldColumn = parentCols.filter(x => x.header === col.header && !x.columnGroup)[0];
        const groupColumn = parentCols.filter(x => x.header === col.header && x.columnGroup)[0];
        this.resolveToggle(groupColumn, newState);
        if (newState) {
          fieldColumn.headerTemplate = this.headerTemplate;
        } else {
          fieldColumn.headerTemplate = undefined;
        }
      }
    }
    /**
    * @hidden @internal
    */
    setupColumns() {
      super.setupColumns();
    }
    /**
    * @hidden @internal
    */
    dataRebinding(event) {
      if (this.hasHorizontalLayout) {
        this.dimensionDataColumns = this.generateDimensionColumns();
      }
      super.dataRebinding(event);
    }
    /**
     * Auto-sizes row dimension cells.
     *
     * @remarks
     * Only sizes based on the dimension cells in view.
     * @example
     * ```typescript
     * this.grid.autoSizeRowDimension(dimension);
     * ```
     * @param dimension The row dimension to size.
     */
    autoSizeRowDimension(dimension) {
      if (this.getDimensionType(dimension) === PivotDimensionType.Row) {
        const relatedDims = PivotUtil.flatten([dimension]).map(x => x.memberName);
        const contentCollection = this.getContentCollection(dimension);
        const content = contentCollection.filter(x => relatedDims.indexOf(x.dimension.memberName) !== -1);
        const headers = content.map(x => x.headerGroups.toArray()).flat().map(x => x.header && x.header.refInstance);
        if (this.pivotUI.showRowHeaders) {
          const dimensionHeader = this.theadRow.rowDimensionHeaders.find(x => x.column.field === dimension.memberName);
          headers.push(dimensionHeader);
        }
        const autoWidth = this.getLargesContentWidth(headers);
        if (dimension.width === "auto") {
          dimension.autoWidth = parseFloat(autoWidth);
        } else {
          dimension.width = autoWidth;
        }
        this.pipeTrigger++;
        this.cdr.detectChanges();
      }
    }
    /**
     * Inserts dimension in target collection by type at specified index or at the collection's end.
     *
     * @example
     * ```typescript
     * this.grid.insertDimensionAt(dimension, PivotDimensionType.Row, 1);
     * ```
     * @param dimension The dimension that will be added.
     * @param targetCollectionType The target collection type to add to. Can be Row, Column or Filter.
     * @param index The index in the collection at which to add.
     * This parameter is optional. If not set it will add it to the end of the collection.
     */
    insertDimensionAt(dimension, targetCollectionType, index) {
      const targetCollection = this.getDimensionsByType(targetCollectionType);
      if (index !== undefined) {
        targetCollection.splice(index, 0, dimension);
      } else {
        targetCollection.push(dimension);
      }
      if (targetCollectionType === PivotDimensionType.Column) {
        this.setupColumns();
      }
      this.pipeTrigger++;
      this.dimensionsChange.emit({
        dimensions: targetCollection,
        dimensionCollectionType: targetCollectionType
      });
      if (targetCollectionType === PivotDimensionType.Filter) {
        this.dimensionDataColumns = this.generateDimensionColumns();
        this.reflow();
      }
      this.pivotConfigurationChange.emit({
        pivotConfiguration: this.pivotConfiguration
      });
    }
    /**
     * Move dimension from its currently collection to the specified target collection by type at specified index or at the collection's end.
     *
     * @example
     * ```typescript
     * this.grid.moveDimension(dimension, PivotDimensionType.Row, 1);
     * ```
     * @param dimension The dimension that will be moved.
     * @param targetCollectionType The target collection type to move it to. Can be Row, Column or Filter.
     * @param index The index in the collection at which to add.
     * This parameter is optional. If not set it will add it to the end of the collection.
     */
    moveDimension(dimension, targetCollectionType, index) {
      const prevCollectionType = this.getDimensionType(dimension);
      if (prevCollectionType === null) return;
      // remove from old collection
      this._removeDimensionInternal(dimension);
      // add to target
      this.insertDimensionAt(dimension, targetCollectionType, index);
      if (prevCollectionType === PivotDimensionType.Column) {
        this.setupColumns();
      }
    }
    /**
     * Removes dimension from its currently collection.
     * @remarks
     * This is different than toggleDimension that enabled/disables the dimension.
     * This completely removes the specified dimension from the collection.
     * @example
     * ```typescript
     * this.grid.removeDimension(dimension);
     * ```
     * @param dimension The dimension to be removed.
     */
    removeDimension(dimension) {
      const prevCollectionType = this.getDimensionType(dimension);
      this._removeDimensionInternal(dimension);
      if (prevCollectionType === PivotDimensionType.Column) {
        this.setupColumns();
      }
      if (prevCollectionType === PivotDimensionType.Filter) {
        this.reflow();
      }
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    /**
     * Toggles the dimension's enabled state on or off.
     * @remarks
     * The dimension remains in its current collection. This just changes its enabled state.
     * @example
     * ```typescript
     * this.grid.toggleDimension(dimension);
     * ```
     * @param dimension The dimension to be toggled.
     */
    toggleDimension(dimension) {
      const dimType = this.getDimensionType(dimension);
      if (dimType === null) return;
      const collection = this.getDimensionsByType(dimType);
      dimension.enabled = !dimension.enabled;
      if (dimType === PivotDimensionType.Column) {
        this.setupColumns();
      }
      if (!dimension.enabled && dimension.filter) {
        this.filteringService.clearFilter(dimension.memberName);
      }
      this.pipeTrigger++;
      this.dimensionsChange.emit({
        dimensions: collection,
        dimensionCollectionType: dimType
      });
      this.cdr.detectChanges();
      if (dimType === PivotDimensionType.Filter) {
        this.reflow();
      }
      this.pivotConfigurationChange.emit({
        pivotConfiguration: this.pivotConfiguration
      });
    }
    /**
     * Inserts value at specified index or at the end.
     *
     * @example
     * ```typescript
     * this.grid.insertValueAt(value, 1);
     * ```
     * @param value The value definition that will be added.
     * @param index The index in the collection at which to add.
     * This parameter is optional. If not set it will add it to the end of the collection.
     */
    insertValueAt(value, index) {
      if (!this.pivotConfiguration.values) {
        this.pivotConfiguration.values = [];
      }
      const values = this.pivotConfiguration.values;
      if (index !== undefined) {
        values.splice(index, 0, value);
      } else {
        values.push(value);
      }
      this.setupColumns();
      this.pipeTrigger++;
      this.cdr.detectChanges();
      this.valuesChange.emit({
        values
      });
      this.pivotConfigurationChange.emit({
        pivotConfiguration: this.pivotConfiguration
      });
    }
    /**
     * Move value from its currently at specified index or at the end.
     *
     * @example
     * ```typescript
     * this.grid.moveValue(value, 1);
     * ```
     * @param value The value that will be moved.
     * @param index The index in the collection at which to add.
     * This parameter is optional. If not set it will add it to the end of the collection.
     */
    moveValue(value, index) {
      if (this.pivotConfiguration.values.indexOf(value) === -1) return;
      // remove from old index
      this.removeValue(value);
      // add to new
      this.insertValueAt(value, index);
    }
    /**
     * Removes value from collection.
     * @remarks
     * This is different than toggleValue that enabled/disables the value.
     * This completely removes the specified value from the collection.
     * @example
     * ```typescript
     * this.grid.removeValue(dimension);
     * ```
     * @param value The value to be removed.
     */
    removeValue(value) {
      const values = this.pivotConfiguration.values;
      const currentIndex = values.indexOf(value);
      if (currentIndex !== -1) {
        values.splice(currentIndex, 1);
        this.setupColumns();
        this.pipeTrigger++;
        this.valuesChange.emit({
          values
        });
        this.pivotConfigurationChange.emit({
          pivotConfiguration: this.pivotConfiguration
        });
      }
    }
    /**
     * Toggles the value's enabled state on or off.
     * @remarks
     * The value remains in its current collection. This just changes its enabled state.
     * @example
     * ```typescript
     * this.grid.toggleValue(value);
     * ```
     * @param value The value to be toggled.
     */
    toggleValue(value) {
      if (this.pivotConfiguration.values.indexOf(value) === -1) return;
      value.enabled = !value.enabled;
      this.setupColumns();
      this.pipeTrigger++;
      this.valuesChange.emit({
        values: this.pivotConfiguration.values
      });
      this.reflow();
      this.pivotConfigurationChange.emit({
        pivotConfiguration: this.pivotConfiguration
      });
    }
    /**
     * Sort the dimension and its children in the provided direction.
     * @example
     * ```typescript
     * this.grid.sortDimension(dimension, SortingDirection.Asc);
     * ```
     * @param value The value to be toggled.
     */
    sortDimension(dimension, sortDirection) {
      const dimensionType = this.getDimensionType(dimension);
      dimension.sortDirection = sortDirection;
      // apply same sort direction to children.
      let dim = dimension;
      if (this.pivotUI.rowLayout === PivotRowLayoutType.Vertical) {
        while (dim.childLevel) {
          dim.childLevel.sortDirection = dimension.sortDirection;
          dim = dim.childLevel;
        }
      }
      this.pipeTrigger++;
      this.dimensionsSortingExpressionsChange.emit(this.dimensionsSortingExpressions);
      if (dimensionType === PivotDimensionType.Column) {
        this.setupColumns();
      }
      this.cdr.detectChanges();
      this.pivotConfigurationChange.emit({
        pivotConfiguration: this.pivotConfiguration
      });
    }
    /**
     * Filters a single `IPivotDimension`.
     *
     * @example
     * ```typescript
     * public filter() {
     *      const set = new Set();
     *      set.add('Value 1');
     *      set.add('Value 2');
     *      this.grid1.filterDimension(this.pivotConfigHierarchy.rows[0], set, IgxStringFilteringOperand.instance().condition('in'));
     * }
     * ```
     */
    filterDimension(dimension, value, conditionOrExpressionTree) {
      this.filteringService.filter(dimension.memberName, value, conditionOrExpressionTree);
      const dimensionType = this.getDimensionType(dimension);
      if (dimensionType === PivotDimensionType.Column) {
        this.setupColumns();
      }
      this.cdr.detectChanges();
    }
    /**
     * @hidden @internal
     */
    getRowDimensionByName(memberName) {
      const visibleRows = this.pivotUI.rowLayout === PivotRowLayoutType.Vertical ? this.pivotConfiguration.rows : PivotUtil.flatten(this.pivotConfiguration.rows);
      const dimIndex = visibleRows.findIndex(target => target.memberName === memberName);
      const dim = visibleRows[dimIndex];
      return dim;
    }
    /**
     * @hidden @internal
     */
    getDimensionsByType(dimension) {
      switch (dimension) {
        case PivotDimensionType.Row:
          if (!this.pivotConfiguration.rows) {
            this.pivotConfiguration.rows = [];
          }
          return this.pivotConfiguration.rows;
        case PivotDimensionType.Column:
          if (!this.pivotConfiguration.columns) {
            this.pivotConfiguration.columns = [];
          }
          return this.pivotConfiguration.columns;
        case PivotDimensionType.Filter:
          if (!this.pivotConfiguration.filters) {
            this.pivotConfiguration.filters = [];
          }
          return this.pivotConfiguration.filters;
        default:
          return null;
      }
    }
    /**
     * @hidden @internal
     */
    resizeRowDimensionPixels(dimension, newWidth) {
      const isPercentageWidth = dimension.width && typeof dimension.width === 'string' && dimension.width.indexOf('%') !== -1;
      if (isPercentageWidth) {
        dimension.width = this.reverseDimensionWidthToPercent(newWidth).toFixed(2) + '%';
      } else {
        dimension.width = newWidth + 'px';
      }
      // Notify the grid to reflow, to update if horizontal scrollbar needs to be rendered/removed.
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    /*
    * @hidden
    * @internal
    */
    _removeDimensionInternal(dimension) {
      const prevCollectionType = this.getDimensionType(dimension);
      if (prevCollectionType === null) return;
      const prevCollection = this.getDimensionsByType(prevCollectionType);
      const currentIndex = prevCollection.indexOf(dimension);
      prevCollection.splice(currentIndex, 1);
      this.pipeTrigger++;
      this.cdr.detectChanges();
    }
    getDimensionType(dimension) {
      return PivotUtil.flatten(this.pivotConfiguration.rows).indexOf(dimension) !== -1 ? PivotDimensionType.Row : PivotUtil.flatten(this.pivotConfiguration.columns).indexOf(dimension) !== -1 ? PivotDimensionType.Column : !!this.pivotConfiguration.filters && PivotUtil.flatten(this.pivotConfiguration.filters).indexOf(dimension) !== -1 ? PivotDimensionType.Filter : null;
    }
    getPivotRowHeaderContentWidth(headerGroup) {
      const headerSizes = this.getHeaderCellWidth(headerGroup.header.refInstance.nativeElement);
      return headerSizes.width + headerSizes.padding;
    }
    getLargesContentWidth(contents) {
      const largest = new Map();
      if (contents.length > 0) {
        const cellsContentWidths = [];
        contents.forEach(elem => {
          elem instanceof IgxPivotRowHeaderGroupComponent ? cellsContentWidths.push(this.getPivotRowHeaderContentWidth(elem)) : cellsContentWidths.push(this.getHeaderCellWidth(elem.nativeElement).width);
        });
        const index = cellsContentWidths.indexOf(Math.max(...cellsContentWidths));
        const cellStyle = this.document.defaultView.getComputedStyle(contents[index].nativeElement);
        const cellPadding = parseFloat(cellStyle.paddingLeft) + parseFloat(cellStyle.paddingRight) + parseFloat(cellStyle.borderLeftWidth) + parseFloat(cellStyle.borderRightWidth);
        largest.set(Math.max(...cellsContentWidths), cellPadding);
      }
      const largestCell = Math.max(...Array.from(largest.keys()));
      const width = Math.ceil(largestCell + largest.get(largestCell));
      if (Number.isNaN(width)) {
        return null;
      } else {
        return width + 'px';
      }
    }
    /** @hidden @internal */
    get hasHorizontalLayout() {
      return this.pivotUI.rowLayout === PivotRowLayoutType.Horizontal;
    }
    /**
    * @hidden
    */
    get hasMultipleValues() {
      return this.values.length > 1;
    }
    /**
    * @hidden
    */
    get excelStyleFilterMaxHeight() {
      // max 10 rows, row size depends on grid size
      const maxHeight = this.renderedRowHeight * 10;
      return `${maxHeight}px`;
    }
    /**
    * @hidden
    */
    get excelStyleFilterMinHeight() {
      // min 5 rows, row size depends on grid size
      const minHeight = this.renderedRowHeight * 5;
      return `${minHeight}px`;
    }
    /** @hidden @internal */
    get activeDescendant() {
      const activeElem = this.navigation.activeNode;
      if (this.navigation.isRowHeaderActive || this.navigation.isRowDimensionHeaderActive) {
        if (!activeElem || !Object.keys(activeElem).length) {
          return this.id;
        }
        return `${this.id}_${activeElem.row}_${activeElem.column}`;
      }
      return super.activeDescendant;
    }
    resolveToggle(groupColumn, state) {
      if (!groupColumn) return;
      groupColumn.hidden = state;
      this.columnGroupStates.set(groupColumn.field, state);
      const childrenTotal = this.hasMultipleValues ? groupColumn.children.filter(x => x.columnGroup && x.children.filter(y => !y.columnGroup).length === this.values.length) : groupColumn.children.filter(x => !x.columnGroup);
      const childrenSubgroups = this.hasMultipleValues ? groupColumn.children.filter(x => x.columnGroup && x.children.filter(y => !y.columnGroup).length === 0) : groupColumn.children.filter(x => x.columnGroup);
      childrenTotal.forEach(group => {
        const newState = this.columnGroupStates.get(group.field) || state;
        if (newState) {
          group.headerTemplate = this.headerTemplate;
        } else {
          group.headerTemplate = undefined;
        }
      });
      if (!groupColumn.hidden && childrenSubgroups.length > 0) {
        childrenSubgroups.forEach(group => {
          const newState = this.columnGroupStates.get(group.field) || state;
          this.resolveToggle(group, newState);
        });
      }
    }
    buildDataView(data) {
      this._dataView = data;
    }
    /**
     * @hidden @internal
     */
    getDataBasedBodyHeight() {
      const dvl = this.dataView?.length || 0;
      return dvl < this._defaultTargetRecordNumber ? 0 : this.defaultTargetBodyHeight;
    }
    horizontalScrollHandler(event) {
      const scrollLeft = event.target.scrollLeft;
      this.theadRow.headerContainers.forEach(headerForOf => {
        headerForOf.onHScroll(scrollLeft);
      });
      super.horizontalScrollHandler(event);
    }
    verticalScrollHandler(event) {
      this.verticalRowDimScrollContainers.forEach(x => {
        x.onScroll(event);
      });
      super.verticalScrollHandler(event);
    }
    /**
     * @hidden
     */
    autogenerateColumns() {
      let columns = [];
      const data = this.gridAPI.filterDataByExpressions(this.filteringExpressionsTree);
      this.dimensionDataColumns = this.generateDimensionColumns();
      const flattenedColumnsWithSorting = PivotUtil.flatten(this.columnDimensions).filter(dim => dim.sortDirection);
      const expressions = flattenedColumnsWithSorting.length > 0 ? PivotSortUtil.generateDimensionSortingExpressions(flattenedColumnsWithSorting) : [];
      let sortedData = data;
      if (expressions.length > 0) {
        sortedData = DataUtil.sort(cloneArray(data), expressions, this.sortStrategy, this);
      }
      let fieldsMap;
      if (this.pivotConfiguration.columnStrategy && this.pivotConfiguration.columnStrategy instanceof NoopPivotDimensionsStrategy) {
        const fields = this.generateDataFields(sortedData);
        if (fields.length === 0) return;
        const rowFields = PivotUtil.flatten(this.pivotConfiguration.rows).map(x => x.memberName);
        const keyFields = Object.values(this.pivotKeys);
        const filteredFields = fields.filter(x => rowFields.indexOf(x) === -1 && keyFields.indexOf(x) === -1 && x.indexOf(this.pivotKeys.rowDimensionSeparator + this.pivotKeys.level) === -1 && x.indexOf(this.pivotKeys.rowDimensionSeparator + this.pivotKeys.records) === -1);
        fieldsMap = this.generateFromData(filteredFields);
      } else {
        fieldsMap = PivotUtil.getFieldsHierarchy(sortedData, this.columnDimensions, PivotDimensionType.Column, this.pivotKeys, this.pivotValueCloneStrategy);
      }
      columns = this.generateColumnHierarchy(fieldsMap, sortedData);
      this._autoGeneratedCols = columns;
      // reset expansion states if any are stored.
      this.columnGroupStates.forEach((value, key) => {
        if (value) {
          const primaryColumn = columns.find(x => x.field === key && x.headerTemplate === this.headerTemplate);
          const groupSummaryColumn = columns.find(x => x.field === key && x.headerTemplate !== this.headerTemplate);
          this.toggleRowGroup(primaryColumn, value);
          if (groupSummaryColumn) {
            groupSummaryColumn.headerTemplate = this.headerTemplate;
          }
        }
      });
      this.updateColumns(columns);
      this.pipeTrigger++;
      this.reflow();
    }
    generateDimensionColumns() {
      const columns = [];
      this.allVisibleDimensions.forEach(dim => {
        const ref = createComponent(IgxColumnComponent, {
          environmentInjector: this.envInjector,
          elementInjector: this.injector
        });
        ref.instance.field = dim.memberName;
        ref.instance.header = dim.displayName || dim.memberName;
        ref.instance.headerTemplate = this.rowDimensionHeaderTemplate;
        ref.instance.resizable = this.rowDimensionResizing;
        ref.instance.sortable = dim.sortable === undefined ? true : dim.sortable;
        ref.instance.width = this.rowDimensionWidth(dim);
        ref.changeDetectorRef.detectChanges();
        columns.push(ref.instance);
      });
      return columns;
    }
    calculateGridSizes(recalcFeatureWidth = true) {
      super.calculateGridSizes(recalcFeatureWidth);
      if (this.hasDimensionsToAutosize) {
        this.cdr.detectChanges();
        this.zone.onStable.pipe(first$2()).subscribe(() => {
          requestAnimationFrame(() => {
            this.autoSizeDimensionsInView();
          });
        });
      }
    }
    getContentCollection(dimenstion) {
      let contentCollection;
      if (this.hasHorizontalLayout) {
        const allMrlContents = this.rowDimensionMrlRowsCollection.map(mrlRow => mrlRow.contentCells.toArray()).flat();
        contentCollection = allMrlContents.filter(cell => cell.rootDimension === dimenstion);
      } else {
        contentCollection = this.rowDimensionContentCollection.toArray();
      }
      return contentCollection;
    }
    autoSizeDimensionsInView() {
      if (!this.hasDimensionsToAutosize) return;
      for (const dim of this.visibleRowDimensions) {
        if (dim.width === 'auto') {
          const contentWidths = [];
          const relatedDims = PivotUtil.flatten([dim]).map(x => x.memberName);
          const contentCollection = this.getContentCollection(dim);
          const content = contentCollection.filter(x => relatedDims.indexOf(x.dimension.memberName) !== -1);
          const headers = content.map(x => x.headerGroups.toArray()).flat().map(x => x.header && x.header.refInstance);
          headers.forEach(header => contentWidths.push(header?.nativeElement?.offsetWidth || 0));
          if (this.pivotUI.showRowHeaders) {
            const dimensionHeader = this.theadRow.rowDimensionHeaders.find(x => x.column.field === dim.memberName);
            contentWidths.push(parseFloat(this.getLargesContentWidth([dimensionHeader])));
          }
          const max = Math.max(...contentWidths);
          if (max === 0) {
            // cells not in DOM yet...
            continue;
          }
          const maxSize = Math.ceil(Math.max(...contentWidths));
          dim.autoWidth = maxSize;
        }
      }
      if (this.isColumnWidthSum) {
        this.calcWidth = this.getColumnWidthSum();
      }
    }
    /** @hidden @internal */
    get hasDimensionsToAutosize() {
      return this.rowDimensions.some(x => x.width === 'auto' && !x.autoWidth);
    }
    generateFromData(fields) {
      const separator = this.pivotKeys.columnDimensionSeparator;
      const dataArr = fields.map(x => x.split(separator)).sort(x => x.length);
      const hierarchy = new Map();
      const columnDimensions = PivotUtil.flatten(this.columnDimensions);
      dataArr.forEach(arr => {
        let currentHierarchy = hierarchy;
        const path = [];
        let index = 0;
        for (const val of arr) {
          path.push(val);
          const newPath = path.join(separator);
          let targetHierarchy = currentHierarchy.get(newPath);
          if (!targetHierarchy) {
            const currentColumnDimension = columnDimensions[index];
            currentHierarchy.set(newPath, {
              value: newPath,
              expandable: !!currentColumnDimension.childLevel,
              children: new Map(),
              dimension: currentColumnDimension
            });
            targetHierarchy = currentHierarchy.get(newPath);
          }
          currentHierarchy = targetHierarchy.children;
          index++;
        }
      });
      return hierarchy;
    }
    generateColumnHierarchy(fields, data, parent = null) {
      let columns = [];
      if (fields.size === 0) {
        this.values.forEach(value => {
          const ref = createComponent(IgxColumnComponent, {
            environmentInjector: this.envInjector,
            elementInjector: this.injector
          });
          ref.instance.header = value.displayName;
          ref.instance.field = value.member;
          ref.instance.parent = parent;
          ref.instance.sortable = true;
          ref.instance.dataType = value.dataType || this.resolveDataTypes(data.length ? data[0][value.member] : null);
          ref.instance.formatter = value.formatter;
          columns.push(ref.instance);
        });
        return columns;
      }
      const currentFields = fields;
      currentFields.forEach(value => {
        let shouldGenerate = true;
        if (data.length === 0) {
          shouldGenerate = false;
        }
        if (shouldGenerate && (value.children == null || value.children.length === 0 || value.children.size === 0)) {
          const col = this.createColumnForDimension(value, data, parent, this.hasMultipleValues);
          columns.push(col);
          if (this.hasMultipleValues) {
            const measureChildren = this.getMeasureChildren(data, col, false, value.dimension.width);
            col.children.reset(measureChildren);
            columns = columns.concat(measureChildren);
          }
        } else if (shouldGenerate) {
          const col = this.createColumnForDimension(value, data, parent, true);
          if (value.expandable) {
            col.headerTemplate = this.headerTemplate;
          }
          const children = this.generateColumnHierarchy(value.children, data, col);
          const filteredChildren = children.filter(x => x.level === col.level + 1);
          columns.push(col);
          if (this.hasMultipleValues) {
            let measureChildren = this.getMeasureChildren(data, col, true, value.dimension.width);
            const nestedChildren = filteredChildren;
            //const allChildren = children.concat(measureChildren);
            col.children.reset(nestedChildren);
            columns = columns.concat(children);
            if (value.dimension.childLevel) {
              const sibling = this.createColumnForDimension(value, data, parent, true);
              columns.push(sibling);
              measureChildren = this.getMeasureChildren(data, sibling, false, value.dimension?.width);
              sibling.children.reset(measureChildren);
              columns = columns.concat(measureChildren);
            }
          } else {
            col.children.reset(filteredChildren);
            columns = columns.concat(children);
            if (value.dimension.childLevel) {
              const sibling = this.createColumnForDimension(value, data, parent, false);
              columns.push(sibling);
            }
          }
        }
      });
      return columns;
    }
    generateConfig() {
      if (!this.data) return;
      const data = this.data;
      const fields = this.generateDataFields(data);
      const columnDimensions = [];
      const rowDimensions = [];
      const values = [];
      let isFirstDate = true;
      fields.forEach(field => {
        const dataType = this.resolveDataTypes(data[0][field]);
        switch (dataType) {
          case "number":
            {
              const value = {
                member: field,
                displayName: field,
                dataType: dataType,
                aggregate: {
                  key: 'sum',
                  label: 'Sum',
                  aggregatorName: "SUM"
                },
                enabled: true
              };
              values.push(value);
              break;
            }
          case "date":
            {
              const dimension = new IgxPivotDateDimension({
                memberName: field,
                enabled: isFirstDate,
                dataType: dataType
              });
              rowDimensions.push(dimension);
              isFirstDate = false;
              break;
            }
          default:
            {
              const dimension = {
                memberName: field,
                enabled: false,
                dataType: dataType
              };
              columnDimensions.push(dimension);
              break;
            }
        }
      });
      const config = {
        columns: columnDimensions,
        rows: rowDimensions,
        values: values
      };
      this.pivotConfiguration = config;
    }
    createColumnForDimension(value, data, parent, isGroup) {
      const key = value.value;
      const ref = isGroup ? createComponent(IgxColumnGroupComponent, {
        environmentInjector: this.envInjector,
        elementInjector: this.injector
      }) : createComponent(IgxColumnComponent, {
        environmentInjector: this.envInjector,
        elementInjector: this.injector
      });
      ref.instance.header = parent != null ? key.split(parent.header + this.pivotKeys.columnDimensionSeparator)[1] : key;
      ref.instance.field = key;
      ref.instance.parent = parent;
      if (value.dimension.width) {
        ref.instance.width = value.dimension.width;
      }
      const valueDefinition = this.values[0];
      ref.instance.dataType = valueDefinition?.dataType || this.resolveDataTypes(data[0][valueDefinition?.member]);
      ref.instance.formatter = valueDefinition?.formatter;
      ref.instance.sortable = true;
      ref.changeDetectorRef.detectChanges();
      return ref.instance;
    }
    resolveColumnDimensionWidth(dim) {
      if (dim.width) {
        return dim.width;
      }
      return this.minColumnWidth + 'px';
    }
    getMeasureChildren(data, parent, hidden, parentWidth) {
      const cols = [];
      const count = this.values.length;
      const childWidth = parseInt(parentWidth, 10) / count;
      const isPercent = parentWidth && parentWidth.indexOf('%') !== -1;
      const isAuto = parentWidth && parentWidth.indexOf('auto') !== -1;
      this.values.forEach(val => {
        const ref = createComponent(IgxColumnComponent, {
          environmentInjector: this.envInjector,
          elementInjector: this.injector
        });
        ref.instance.header = val.displayName || val.member;
        ref.instance.field = parent.field + this.pivotKeys.columnDimensionSeparator + val.member;
        ref.instance.parent = parent;
        if (parentWidth) {
          ref.instance.width = isAuto ? 'auto' : isPercent ? childWidth + '%' : childWidth + 'px';
        }
        ref.instance.hidden = hidden;
        ref.instance.sortable = this._sortableColumns;
        ref.instance.dataType = val.dataType || this.resolveDataTypes(data[0][val.member]);
        ref.instance.formatter = val.formatter;
        ref.changeDetectorRef.detectChanges();
        cols.push(ref.instance);
      });
      return cols;
    }
    /**
    * @hidden @internal
    */
    get template() {
      const allEnabledDimensions = this.rowDimensions.concat(this.columnDimensions);
      if (allEnabledDimensions.length === 0 && this.values.length === 0) {
        // no enabled values and dimensions
        return this.emptyPivotGridTemplate || this.defaultEmptyPivotGridTemplate;
      }
      return super.template;
    }
    emitInitEvents(pivotConfig) {
      const dimensions = PivotUtil.flatten(this.allDimensions);
      dimensions.forEach(dim => {
        this.dimensionInit.emit(dim);
      });
      const values = pivotConfig?.values;
      values?.forEach(val => {
        this.valueInit.emit(val);
      });
    }
    rowDimensionByName(memberName) {
      return this.visibleRowDimensions.find(rowDim => rowDim.memberName === memberName);
    }
    calculateResizerTop() {
      return this.pivotUI.showRowHeaders ? (this.theadRow.pivotFilterContainer?.nativeElement.offsetHeight || 0) + (this.theadRow.pivotRowContainer?.nativeElement.offsetHeight || 0) : this.theadRow.nativeElement.offsetHeight;
    }
    updateDefaultRowHeight() {
      super.updateDefaultRowHeight();
      if (this.hasHorizontalLayout) {
        // Trigger pipes to recalc heights for the horizontal layout mrl rows.
        this.regroupTrigger++;
      }
    }
    static {
      this.ɵfac = function IgxPivotGridComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridComponent)(i0.ɵɵdirectiveInject(IgxGridValidationService), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IgxPivotColumnResizingService), i0.ɵɵdirectiveInject(GridBaseAPIService), i0.ɵɵdirectiveInject(IgxFlatTransactionFactory), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(IgxPivotGridNavigationService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxGridSummaryService), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxGridTransaction, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotGridComponent,
        selectors: [["igx-pivot-grid"]],
        contentQueries: function IgxPivotGridComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxPivotValueChipTemplateDirective, 5, IgxPivotValueChipTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxPivotRowDimensionHeaderTemplateDirective, 5, IgxPivotRowDimensionHeaderTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueChipTemplateDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDimensionHeaderDirective = _t.first);
          }
        },
        viewQuery: function IgxPivotGridComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxPivotHeaderRowComponent, 7);
            i0.ɵɵviewQuery(_c226, 7, TemplateRef);
            i0.ɵɵviewQuery(_c252, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxPivotGridColumnResizerComponent, 5);
            i0.ɵɵviewQuery(_c255, 7, TemplateRef);
            i0.ɵɵviewQuery(_c256, 5, ElementRef);
            i0.ɵɵviewQuery(IgxGridExcelStyleFilteringComponent, 5, IgxGridExcelStyleFilteringComponent);
            i0.ɵɵviewQuery(IgxPivotRowDimensionContentComponent, 5);
            i0.ɵɵviewQuery(_c257, 5, IgxGridForOfDirective);
            i0.ɵɵviewQuery(IgxPivotRowDimensionMrlRowComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.theadRow = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.recordTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizeLine = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultEmptyPivotGridTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDimensionContainer = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.excelStyleFilteringComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDimensionContentCollection = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.verticalRowDimScrollContainers = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDimensionMrlRowsCollection = _t);
          }
        },
        hostVars: 4,
        hostBindings: function IgxPivotGridComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("id", ctx.id);
            i0.ɵɵclassProp("igx-grid__pivot--super-compact", ctx.superCompactMode);
          }
        },
        inputs: {
          valueChipTemplate: "valueChipTemplate",
          rowDimensionHeaderTemplate: "rowDimensionHeaderTemplate",
          pivotConfiguration: "pivotConfiguration",
          autoGenerateConfig: [2, "autoGenerateConfig", "autoGenerateConfig", booleanAttribute],
          pivotUI: "pivotUI",
          superCompactMode: "superCompactMode",
          pivotValueCloneStrategy: "pivotValueCloneStrategy",
          addRowEmptyTemplate: "addRowEmptyTemplate",
          autoGenerateExclude: "autoGenerateExclude",
          snackbarDisplayTime: "snackbarDisplayTime",
          defaultExpandState: [2, "defaultExpandState", "defaultExpandState", booleanAttribute],
          pagingMode: "pagingMode",
          hideRowSelectors: [2, "hideRowSelectors", "hideRowSelectors", booleanAttribute],
          rowDraggable: [2, "rowDraggable", "rowDraggable", booleanAttribute],
          allowAdvancedFiltering: [2, "allowAdvancedFiltering", "allowAdvancedFiltering", booleanAttribute],
          filterMode: "filterMode",
          allowFiltering: [2, "allowFiltering", "allowFiltering", booleanAttribute],
          page: "page",
          perPage: "perPage",
          summaryRowHeight: "summaryRowHeight",
          rowEditable: [2, "rowEditable", "rowEditable", booleanAttribute],
          pinning: "pinning",
          summaryPosition: "summaryPosition",
          summaryCalculationMode: "summaryCalculationMode",
          showSummaryOnCollapse: [2, "showSummaryOnCollapse", "showSummaryOnCollapse", booleanAttribute],
          batchEditing: [2, "batchEditing", "batchEditing", booleanAttribute],
          id: "id",
          data: "data",
          totalRecords: "totalRecords",
          emptyPivotGridTemplate: "emptyPivotGridTemplate"
        },
        outputs: {
          dimensionsChange: "dimensionsChange",
          pivotConfigurationChange: "pivotConfigurationChange",
          dimensionInit: "dimensionInit",
          valueInit: "valueInit",
          dimensionsSortingExpressionsChange: "dimensionsSortingExpressionsChange",
          valuesChange: "valuesChange",
          cellEdit: "cellEdit",
          cellEditDone: "cellEditDone",
          cellEditEnter: "cellEditEnter",
          cellEditExit: "cellEditExit",
          columnMovingStart: "columnMovingStart",
          columnMoving: "columnMoving",
          columnMovingEnd: "columnMovingEnd",
          columnPin: "columnPin",
          columnPinned: "columnPinned",
          rowAdd: "rowAdd",
          rowAdded: "rowAdded",
          rowDeleted: "rowDeleted",
          rowDelete: "rowDelete",
          rowDragStart: "rowDragStart",
          rowDragEnd: "rowDragEnd",
          rowEditEnter: "rowEditEnter",
          rowEdit: "rowEdit",
          rowEditDone: "rowEditDone",
          rowEditExit: "rowEditExit",
          rowPinning: "rowPinning",
          rowPinned: "rowPinned"
        },
        features: [i0.ɵɵProvidersFeature([IgxGridCRUDService, IgxGridValidationService, IgxGridSummaryService, IgxGridSelectionService, IgxColumnResizingService, GridBaseAPIService, {
          provide: IGX_GRID_BASE,
          useExisting: IgxPivotGridComponent
        }, {
          provide: IgxFilteringService,
          useClass: IgxPivotFilteringService
        }, IgxPivotGridNavigationService, IgxPivotColumnResizingService, IgxForOfSyncService, IgxForOfScrollSyncService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c259,
        decls: 75,
        vars: 133,
        consts: [["tbody", ""], ["verticalScrollContainer", ""], ["record_template", ""], ["loadingOverlay", ""], ["verticalScrollHolder", ""], ["addRowSnackbar", ""], ["igxBodyOverlayOutlet", "overlay-outlet"], ["scr", ""], ["scrollContainer", ""], ["tfoot", ""], ["footer", ""], ["emptyFilteredGrid", ""], ["defaultEmptyGrid", ""], ["defaultLoadingGrid", ""], ["igxLoadingOverlayOutlet", ""], ["igxFilteringOverlayOutlet", ""], ["headerTemplate", ""], ["defaultRowDimensionsTemplate", ""], ["horizontalRowDimensionsTemplate", ""], ["emptyRowDimensionsTemplate", ""], ["emptyPivotGridTemplate", ""], ["row", ""], ["rowDimensionContainer", ""], ["verticalRowDimScrollContainer", ""], ["sink", ""], ["tabindex", "0", 1, "igx-grid-thead", "igx-grid-thead--pivot", 3, "keydown.meta.c", "keydown.control.c", "copy", "keydown", "scroll", "grid", "hasMRL", "activeDescendant", "width", "pinnedColumnCollection", "unpinnedColumnCollection"], ["igxGridBody", "", "role", "rowgroup", 1, "igx-grid__tbody", 3, "keydown.control.c", "copy"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "0", 1, "igx-grid__tbody-content", 3, "keydown", "focus", "dragStop", "scroll", "dragScroll", "igxGridDragSelect"], ["id", "left", 1, "igx-grid__scroll-on-drag-left", 3, "igxColumnMovingDrop"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop", "left"], ["igxGridFor", "", 3, "dataChanging", "dataChanged", "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize", "igxGridForOfVariableSizes"], ["igxToggle", ""], [3, "indeterminate"], ["id", "right", 1, "igx-grid__scroll-on-drag-right", 3, "igxColumnMovingDrop"], [1, "igx-grid__tbody-scrollbar", 3, "pointerdown", "hidden"], [1, "igx-grid__tbody-scrollbar-start"], [1, "igx-grid__tbody-scrollbar-main"], ["igxGridFor", "", 3, "igxGridForOf"], [1, "igx-grid__tbody-scrollbar-end"], [1, "igx-grid__addrow-snackbar"], [3, "outlet", "actionText", "displayTime"], ["igxOverlayOutlet", ""], [1, "igx-grid__scroll", 3, "pointerdown", "hidden"], [1, "igx-grid__scroll-start"], [1, "igx-grid__scroll-main"], [1, "igx-grid__scroll-end", 3, "hidden"], ["role", "rowgroup", 1, "igx-grid__tfoot"], [1, "igx-grid__footer"], [3, "restrictResizerTop"], ["igxOverlayOutlet", "", 1, "igx-grid__loading-outlet"], ["igxOverlayOutlet", "", 1, "igx-grid__outlet"], [3, "hidden"], [3, "maxHeight", "minHeight"], ["igxExcelStyleColumnOperations", "", 3, "hidden"], [2, "display", "none"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop"], [3, "cachedViewLoaded", "igxTemplateOutlet", "igxTemplateOutletContext"], [3, "gridID", "index", "data", "ngClass", "ngStyle"], ["role", "cell", 1, "igx-grid__tbody-message"], [1, "igx-grid__loading"], [1, "igx-grid__tr--header"], ["family", "default", 3, "click", "name"], ["tabindex", "0", "role", "rowgroup", 1, "igx-grid__tbody-pivot-dimension", 3, "height"], ["tabindex", "0", "role", "rowgroup", 1, "igx-grid__tbody-pivot-dimension", 3, "focus", "keydown"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize", "igxForSizePropName"], ["role", "row", 1, "igx-grid-thead", 3, "grid", "dimension", "rootDimension", "rowIndex", "rowData", "width"], ["tabindex", "0", 1, "igx-grid__tbody-pivot-mrl-dimension", 3, "focus", "keydown"], ["role", "rowgroup", "igxGridFor", "", 3, "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize", "igxForSizePropName"], [3, "rowIndex", "rowGroup", "groupedData"], ["tabindex", "0", "role", "rowgroup", 1, "igx-grid__tbody-pivot-dimension"]],
        template: function IgxPivotGridComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c258);
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "igx-pivot-header-row", 25);
            i0.ɵɵlistener("keydown.meta.c", function IgxPivotGridComponent_Template_igx_pivot_header_row_keydown_meta_c_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown.control.c", function IgxPivotGridComponent_Template_igx_pivot_header_row_keydown_control_c_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxPivotGridComponent_Template_igx_pivot_header_row_copy_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown", function IgxPivotGridComponent_Template_igx_pivot_header_row_keydown_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.headerNavigation($event));
            })("scroll", function IgxPivotGridComponent_Template_igx_pivot_header_row_scroll_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventHeaderScroll($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 26);
            i0.ɵɵlistener("keydown.control.c", function IgxPivotGridComponent_Template_div_keydown_control_c_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxPivotGridComponent_Template_div_copy_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            });
            i0.ɵɵtemplate(3, IgxPivotGridComponent_ng_container_3_Template, 1, 0, "ng-container", 27);
            i0.ɵɵelementStart(4, "div", 28, 0);
            i0.ɵɵlistener("keydown", function IgxPivotGridComponent_Template_div_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.handleNavigation($event));
            })("focus", function IgxPivotGridComponent_Template_div_focus_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusTbody($event));
            })("dragStop", function IgxPivotGridComponent_Template_div_dragStop_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectionService.dragMode = $event);
            })("scroll", function IgxPivotGridComponent_Template_div_scroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventContainerScroll($event));
            })("dragScroll", function IgxPivotGridComponent_Template_div_dragScroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragScroll($event));
            });
            i0.ɵɵtemplate(6, IgxPivotGridComponent_Conditional_6_Template, 1, 2, "span", 29)(7, IgxPivotGridComponent_Conditional_7_Template, 1, 4, "span", 30)(8, IgxPivotGridComponent_ng_template_8_Template, 1, 2, "ng-template", 31, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(10, "pivotGridFilter");
            i0.ɵɵpipe(11, "pivotGridSort");
            i0.ɵɵpipe(12, "pivotGridRow");
            i0.ɵɵpipe(13, "pivotGridColumn");
            i0.ɵɵpipe(14, "pivotGridAutoTransform");
            i0.ɵɵpipe(15, "pivotGridColumnSort");
            i0.ɵɵpipe(16, "pivotGridRowExpansion");
            i0.ɵɵlistener("dataChanging", function IgxPivotGridComponent_Template_ng_template_dataChanging_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebinding($event));
            })("dataChanged", function IgxPivotGridComponent_Template_ng_template_dataChanged_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebound($event));
            });
            i0.ɵɵtemplate(17, IgxPivotGridComponent_ng_template_17_Template, 4, 35, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(19, IgxPivotGridComponent_ng_container_19_Template, 1, 0, "ng-container", 27);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "div", 32, 3);
            i0.ɵɵtemplate(22, IgxPivotGridComponent_Conditional_22_Template, 1, 1, "igx-circular-bar", 33);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(23, IgxPivotGridComponent_Conditional_23_Template, 1, 2, "span", 34);
            i0.ɵɵelementStart(24, "div", 35);
            i0.ɵɵlistener("pointerdown", function IgxPivotGridComponent_Template_div_pointerdown_24_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(25, "div", 36);
            i0.ɵɵelementStart(26, "div", 37);
            i0.ɵɵtemplate(27, IgxPivotGridComponent_ng_template_27_Template, 0, 0, "ng-template", 38, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(29, "div", 39);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "div", 40)(31, "igx-snackbar", 41, 5);
            i0.ɵɵtext(33);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(34, "div", 42, 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "div", 43, 7);
            i0.ɵɵlistener("pointerdown", function IgxPivotGridComponent_Template_div_pointerdown_36_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(38, "div", 44);
            i0.ɵɵelementStart(39, "div", 45);
            i0.ɵɵtemplate(40, IgxPivotGridComponent_ng_template_40_Template, 0, 0, "ng-template", 38, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "div", 46);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(43, "div", 47, 9);
            i0.ɵɵelementStart(45, "div", 48, 10);
            i0.ɵɵprojection(47, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(48, IgxPivotGridComponent_ng_template_48_Template, 3, 1, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor)(50, IgxPivotGridComponent_ng_template_50_Template, 3, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor)(52, IgxPivotGridComponent_ng_template_52_Template, 2, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor)(54, IgxPivotGridComponent_Conditional_54_Template, 1, 1, "igx-pivot-grid-column-resizer", 49);
            i0.ɵɵelement(55, "div", 50, 14)(57, "div", 51, 15);
            i0.ɵɵtemplate(59, IgxPivotGridComponent_ng_template_59_Template, 3, 3, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor)(61, IgxPivotGridComponent_ng_template_61_Template, 2, 0, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor)(63, IgxPivotGridComponent_ng_template_63_Template, 4, 8, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor)(65, IgxPivotGridComponent_ng_template_65_Template, 1, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor)(67, IgxPivotGridComponent_ng_template_67_Template, 3, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(69, "div", 52)(70, "igx-grid-excel-style-filtering", 53);
            i0.ɵɵelement(71, "div", 54);
            i0.ɵɵelementStart(72, "igx-excel-style-filter-operations");
            i0.ɵɵelement(73, "igx-excel-style-search");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(74, IgxPivotGridComponent_Conditional_74_Template, 3, 0, "div", 55);
          }
          if (rf & 2) {
            const igxBodyOverlayOutlet_r22 = i0.ɵɵreference(35);
            const defaultRowDimensionsTemplate_r23 = i0.ɵɵreference(62);
            const horizontalRowDimensionsTemplate_r24 = i0.ɵɵreference(64);
            const emptyRowDimensionsTemplate_r25 = i0.ɵɵreference(66);
            i0.ɵɵadvance();
            i0.ɵɵproperty("grid", ctx)("hasMRL", ctx.hasColumnLayouts)("activeDescendant", ctx.activeDescendant)("width", ctx.calcWidth)("pinnedColumnCollection", ctx.pinnedColumns)("unpinnedColumnCollection", ctx.unpinnedColumns);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.rowDimensions.length ? ctx.hasHorizontalLayout ? horizontalRowDimensionsTemplate_r24 : defaultRowDimensionsTemplate_r23 : emptyRowDimensionsTemplate_r25)("ngTemplateOutletContext", ctx);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.totalHeight, "px")("width", ctx.pivotContentCalcWidth || null, "px");
            i0.ɵɵproperty("igxGridDragSelect", ctx.selectionService.dragMode);
            i0.ɵɵattribute("role", ctx.dataView.length ? null : "row")("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.hasMovableColumns && ctx.columnInDrag && ctx.pinnedColumns.length <= 0 ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasMovableColumns && ctx.columnInDrag && ctx.pinnedColumns.length > 0 ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBindV(16, 97, i0.ɵɵpureFunction5(124, _c64, i0.ɵɵpipeBind4(15, 92, i0.ɵɵpipeBind3(14, 88, i0.ɵɵpipeBindV(13, 81, i0.ɵɵpureFunction6(117, _c63, i0.ɵɵpipeBindV(12, 74, i0.ɵɵpureFunction6(110, _c63, i0.ɵɵpipeBind4(11, 69, i0.ɵɵpipeBindV(10, 62, i0.ɵɵpureFunction6(103, _c63, ctx.data, ctx.pivotConfiguration, ctx.filterStrategy, ctx.advancedFilteringExpressionsTree, ctx.filteringPipeTrigger, ctx.pipeTrigger)), ctx.pivotConfiguration, ctx.sortStrategy, ctx.pipeTrigger), ctx.pivotConfiguration, ctx.pivotValueCloneStrategy, ctx.expansionStates, ctx.pipeTrigger, ctx.sortingExpressions)), ctx.pivotConfiguration, ctx.pivotValueCloneStrategy, ctx.expansionStates, ctx.pipeTrigger, ctx.sortingExpressions)), ctx.pivotConfiguration, ctx.pipeTrigger), ctx.sortingExpressions, ctx.sortStrategy, ctx.pipeTrigger), ctx.pivotConfiguration, ctx.expansionStates, ctx.defaultExpandState, ctx.pipeTrigger)))("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx.verticalScroll)("igxForContainerSize", ctx.calcHeight)("igxForItemSize", ctx.hasColumnLayouts ? ctx.rowHeight * ctx.multiRowLayoutRowSize + 1 : ctx.renderedRowHeight)("igxGridForOfVariableSizes", false);
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(130, _c25, ctx));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.shouldOverlayLoading ? 22 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasMovableColumns && ctx.columnInDrag ? 23 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.calcHeight, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(132, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", !ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("outlet", igxBodyOverlayOutlet_r22)("actionText", ctx.resourceStrings.igx_grid_snackbar_addrow_actiontext)("displayTime", ctx.snackbarDisplayTime);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.resourceStrings.igx_grid_snackbar_addrow_label);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("height", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", ctx.isHorizontalScrollHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.pivotPinnedWidth, "px")("min-width", ctx.pivotPinnedWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.pivotUnpinnedWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", ctx.EMPTY_DATA);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.pivotPinnedWidth, "px")("min-width", ctx.pivotPinnedWidth, "px");
            i0.ɵɵproperty("hidden", ctx.pivotPinnedWidth === 0 || ctx.isPinningToStart);
            i0.ɵɵadvance(12);
            i0.ɵɵconditional(ctx.colResizingService.showResizer ? 54 : -1);
            i0.ɵɵadvance(15);
            i0.ɵɵproperty("hidden", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("maxHeight", ctx.excelStyleFilterMaxHeight)("minHeight", ctx.excelStyleFilterMinHeight);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", true);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.platform.isElements ? 74 : -1);
          }
        },
        dependencies: [NgClass, NgStyle, NgTemplateOutlet, IgxPivotHeaderRowComponent, IgxGridBodyDirective, IgxGridDragSelectDirective, IgxColumnMovingDropDirective, IgxGridForOfDirective, IgxTemplateOutletDirective, IgxPivotRowComponent, IgxToggleDirective, IgxCircularProgressBarComponent, IgxSnackbarComponent, IgxOverlayOutletDirective, IgxPivotGridColumnResizerComponent, IgxIconComponent, IgxPivotRowDimensionContentComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleSearchComponent, IgxGridRowClassesPipe, IgxGridRowStylesPipe, IgxPivotRowPipe, IgxPivotRowExpansionPipe, IgxPivotAutoTransform, IgxPivotColumnPipe, IgxPivotGridFilterPipe, IgxPivotGridSortingPipe, IgxPivotGridColumnSortingPipe, IgxPivotCellMergingPipe, IgxPivotGridHorizontalRowGrouping, IgxPivotRowDimensionMrlRowComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([WatchChanges()], IgxPivotGridComponent.prototype, "hideRowSelectors", null);
  __decorate([WatchChanges()], IgxPivotGridComponent.prototype, "rowEditable", null);
  return IgxPivotGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-state-base-directive */
/* blazorIndirectRender */
let IgxGridStateBaseDirective = /*#__PURE__*/(() => {
  class IgxGridStateBaseDirective {
    /**
     *  An object with options determining if a certain feature state should be saved.
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * public options = {selection: false, advancedFiltering: false};
     * ```
     */
    get options() {
      return this._options;
    }
    set options(value) {
      Object.assign(this._options, value);
      if (!(this.grid instanceof IgxGridComponent)) {
        delete this._options.groupBy;
      } else {
        delete this._options.rowIslands;
      }
    }
    /**
     * @hidden
     */
    constructor(grid, viewRef, envInjector, injector) {
      this.grid = grid;
      this.viewRef = viewRef;
      this.envInjector = envInjector;
      this.injector = injector;
      this.featureKeys = [];
      this._options = {
        columns: true,
        filtering: true,
        advancedFiltering: true,
        sorting: true,
        groupBy: true,
        paging: true,
        cellSelection: true,
        rowSelection: true,
        columnSelection: true,
        rowPinning: true,
        expansion: true,
        moving: true,
        rowIslands: true,
        pivotConfiguration: true
      };
      this.FEATURES = {
        sorting: {
          getFeatureState: context => {
            const sortingState = context.currGrid.sortingExpressions;
            sortingState.forEach(s => {
              delete s.strategy;
              delete s.owner;
            });
            return {
              sorting: sortingState
            };
          },
          restoreFeatureState: (context, state) => {
            context.currGrid.sortingExpressions = state;
          }
        },
        filtering: {
          getFeatureState: context => {
            const filteringState = context.currGrid.filteringExpressionsTree;
            if (filteringState) {
              delete filteringState.owner;
              for (const item of filteringState.filteringOperands) {
                delete item.owner;
              }
            }
            return {
              filtering: filteringState
            };
          },
          restoreFeatureState: (context, state) => {
            const filterTree = context.createExpressionsTreeFromObject(state);
            context.currGrid.filteringExpressionsTree = filterTree;
          }
        },
        advancedFiltering: {
          getFeatureState: context => {
            const filteringState = context.currGrid.advancedFilteringExpressionsTree;
            let advancedFiltering;
            if (filteringState) {
              delete filteringState.owner;
              for (const item of filteringState.filteringOperands) {
                delete item.owner;
              }
              advancedFiltering = filteringState;
            } else {
              advancedFiltering = {};
            }
            return {
              advancedFiltering
            };
          },
          restoreFeatureState: (context, state) => {
            const filterTree = context.createExpressionsTreeFromObject(state);
            context.currGrid.advancedFilteringExpressionsTree = filterTree;
          }
        },
        columns: {
          getFeatureState: context => {
            const gridColumns = context.currGrid.columns.map(c => ({
              pinned: c.pinned,
              sortable: c.sortable,
              filterable: c.filterable,
              editable: c.editable,
              sortingIgnoreCase: c.sortingIgnoreCase,
              filteringIgnoreCase: c.filteringIgnoreCase,
              headerClasses: c.headerClasses,
              headerGroupClasses: c.headerGroupClasses,
              maxWidth: c.maxWidth,
              groupable: c.groupable,
              hidden: c.hidden,
              dataType: c.dataType,
              hasSummary: c.hasSummary,
              field: c.field,
              width: c.width,
              header: c.header,
              resizable: c.resizable,
              searchable: c.searchable,
              selectable: c.selectable,
              key: c.columnGroup ? this.getColumnGroupKey(c) : c.field,
              parentKey: c.parent ? this.getColumnGroupKey(c.parent) : undefined,
              columnGroup: c.columnGroup,
              columnLayout: c.columnLayout || undefined,
              rowStart: c.parent?.columnLayout ? c.rowStart : undefined,
              rowEnd: c.parent?.columnLayout ? c.rowEnd : undefined,
              colStart: c.parent?.columnLayout ? c.colStart : undefined,
              colEnd: c.parent?.columnLayout ? c.colEnd : undefined,
              disableHiding: c.disableHiding,
              disablePinning: c.disablePinning,
              collapsible: c.columnGroup ? c.collapsible : undefined,
              expanded: c.columnGroup ? c.expanded : undefined,
              visibleWhenCollapsed: c.parent?.columnGroup ? c.visibleWhenCollapsed : undefined
            }));
            return {
              columns: gridColumns
            };
          },
          restoreFeatureState: (context, state) => {
            const newColumns = [];
            state.forEach(colState => {
              const hasColumnGroup = colState.columnGroup;
              const hasColumnLayouts = colState.columnLayout;
              delete colState.columnGroup;
              delete colState.columnLayout;
              if (hasColumnGroup) {
                let ref1 = context.currGrid.columns.find(x => x.columnGroup && (colState.key ? this.getColumnGroupKey(x) === colState.key : x.header === colState.header));
                if (!ref1) {
                  const component = hasColumnLayouts ? createComponent(IgxColumnLayoutComponent, {
                    environmentInjector: this.envInjector,
                    elementInjector: this.injector
                  }) : createComponent(IgxColumnGroupComponent, {
                    environmentInjector: this.envInjector,
                    elementInjector: this.injector
                  });
                  ref1 = component.instance;
                  component.changeDetectorRef.detectChanges();
                } else {
                  ref1.children.reset([]);
                }
                Object.assign(ref1, colState);
                ref1.grid = context.currGrid;
                if (colState.parent || colState.parentKey) {
                  const columnGroup = newColumns.find(e => e.columnGroup && (e.key ? e.key === colState.parentKey : e.header === ref1.parent));
                  columnGroup.children.reset([...columnGroup.children.toArray(), ref1]);
                  ref1.parent = columnGroup;
                }
                ref1.cdr.detectChanges();
                newColumns.push(ref1);
              } else {
                let ref = context.currGrid.columns.find(x => !x.columnGroup && x.field === colState.field);
                if (!ref) {
                  const component = createComponent(IgxColumnComponent, {
                    environmentInjector: this.envInjector,
                    elementInjector: this.injector
                  });
                  ref = component.instance;
                  component.changeDetectorRef.detectChanges();
                }
                Object.assign(ref, colState);
                ref.grid = context.currGrid;
                if (colState.parent || colState.parentKey) {
                  const columnGroup = newColumns.find(e => e.columnGroup && (e.key ? e.key === colState.parentKey : e.header === ref.parent));
                  if (columnGroup) {
                    ref.parent = columnGroup;
                    columnGroup.children.reset([...columnGroup.children.toArray(), ref]);
                  }
                }
                ref.cdr.detectChanges();
                newColumns.push(ref);
              }
            });
            context.currGrid.updateColumns(newColumns);
            newColumns.forEach(col => {
              context.currGrid.columnInit.emit(col);
            });
          }
        },
        groupBy: {
          getFeatureState: context => {
            const grid = context.currGrid;
            const groupingExpressions = grid.groupingExpressions;
            groupingExpressions.forEach(expr => {
              delete expr.strategy;
            });
            const expansionState = grid.groupingExpansionState;
            const groupsExpanded = grid.groupsExpanded;
            return {
              groupBy: {
                expressions: groupingExpressions,
                expansion: expansionState,
                defaultExpanded: groupsExpanded
              }
            };
          },
          restoreFeatureState: (context, state) => {
            const grid = context.currGrid;
            grid.groupingExpressions = state.expressions;
            state.expansion.forEach(exp => {
              exp.hierarchy.forEach(h => {
                const dataType = grid.columns.find(c => c.field === h.fieldName).dataType;
                if (dataType.includes(GridColumnDataType.Date) || dataType.includes(GridColumnDataType.Time)) {
                  h.value = h.value ? new Date(Date.parse(h.value)) : h.value;
                }
              });
            });
            if (grid.groupsExpanded !== state.defaultExpanded) {
              grid.toggleAllGroupRows();
            }
            grid.groupingExpansionState = state.expansion;
          }
        },
        paging: {
          getFeatureState: context => {
            const pagingState = context.currGrid.pagingState;
            return {
              paging: pagingState
            };
          },
          restoreFeatureState: (context, state) => {
            if (!context.currGrid.paginator) {
              return;
            }
            if (context.currGrid.perPage !== state.recordsPerPage) {
              context.currGrid.perPage = state.recordsPerPage;
              context.currGrid.cdr.detectChanges();
            }
            context.currGrid.page = state.index;
          }
        },
        moving: {
          getFeatureState: context => {
            return {
              moving: context.currGrid.moving
            };
          },
          restoreFeatureState: (context, state) => {
            context.currGrid.moving = state;
          }
        },
        rowSelection: {
          getFeatureState: context => {
            const selection = context.currGrid.selectionService.getSelectedRows();
            return {
              rowSelection: selection
            };
          },
          restoreFeatureState: (context, state) => {
            context.currGrid.selectRows(state, true);
          }
        },
        cellSelection: {
          getFeatureState: context => {
            const selection = context.currGrid.getSelectedRanges().map(range => ({
              rowStart: range.rowStart,
              rowEnd: range.rowEnd,
              columnStart: range.columnStart,
              columnEnd: range.columnEnd
            }));
            return {
              cellSelection: selection
            };
          },
          restoreFeatureState: (context, state) => {
            state.forEach(r => {
              const range = {
                rowStart: r.rowStart,
                rowEnd: r.rowEnd,
                columnStart: r.columnStart,
                columnEnd: r.columnEnd
              };
              context.currGrid.selectRange(range);
            });
          }
        },
        columnSelection: {
          getFeatureState: context => {
            const selection = context.currGrid.selectedColumns().map(c => c.field);
            return {
              columnSelection: selection
            };
          },
          restoreFeatureState: (context, state) => {
            context.currGrid.deselectAllColumns();
            context.currGrid.selectColumns(state);
          }
        },
        rowPinning: {
          getFeatureState: context => {
            const pinned = context.currGrid.pinnedRows?.map(x => x.key);
            return {
              rowPinning: pinned
            };
          },
          restoreFeatureState: (context, state) => {
            // clear current state.
            context.currGrid.pinnedRows.forEach(row => row.unpin());
            state.forEach(rowID => context.currGrid.pinRow(rowID));
          }
        },
        pinningConfig: {
          getFeatureState: context => ({
            pinningConfig: context.currGrid.pinning
          }),
          restoreFeatureState: (context, state) => {
            context.currGrid.pinning = state;
          }
        },
        expansion: {
          getFeatureState: context => {
            const expansionStates = Array.from(context.currGrid.expansionStates);
            return {
              expansion: expansionStates
            };
          },
          restoreFeatureState: (context, state) => {
            const expansionStates = new Map(state);
            context.currGrid.expansionStates = expansionStates;
          }
        },
        rowIslands: {
          getFeatureState(context) {
            const childGridStates = [];
            const rowIslands = context.currGrid.allLayoutList;
            if (rowIslands) {
              rowIslands.forEach(rowIsland => {
                const childGrids = rowIsland.rowIslandAPI.getChildGrids();
                childGrids.forEach(chGrid => {
                  const parentRowID = this.getParentRowID(chGrid);
                  context.currGrid = chGrid;
                  if (context.currGrid) {
                    const childGridState = context.buildState(context.featureKeys);
                    childGridStates.push({
                      id: `${rowIsland.id}`,
                      parentRowID,
                      state: childGridState
                    });
                  }
                });
              });
            }
            context.currGrid = context.grid;
            return {
              rowIslands: childGridStates
            };
          },
          restoreFeatureState(context, state) {
            const rowIslands = context.currGrid.allLayoutList;
            if (rowIslands) {
              rowIslands.forEach(rowIsland => {
                const childGrids = rowIsland.rowIslandAPI.getChildGrids();
                childGrids.forEach(chGrid => {
                  const parentRowID = this.getParentRowID(chGrid);
                  context.currGrid = chGrid;
                  const childGridState = state.find(st => st.id === rowIsland.id && st.parentRowID === parentRowID);
                  if (childGridState && context.currGrid) {
                    context.restoreGridState(childGridState.state, context.featureKeys);
                  }
                });
              });
            }
            context.currGrid = context.grid;
          },
          /**
           * Traverses the hierarchy up to the root grid to return the ID of the expanded row.
           */
          getParentRowID: grid => {
            let childGrid;
            while (grid.parent) {
              childGrid = grid;
              grid = grid.parent;
            }
            return grid.gridAPI.getParentRowId(childGrid);
          }
        },
        pivotConfiguration: {
          getFeatureState(context) {
            const config = context.currGrid.pivotConfiguration;
            if (!config || !(context.currGrid instanceof IgxPivotGridComponent)) {
              return {
                pivotConfiguration: undefined
              };
            }
            const configCopy = cloneValue(config);
            configCopy.rows = cloneArray(config.rows, true);
            configCopy.columns = cloneArray(config.columns, true);
            configCopy.filters = cloneArray(config.filters, true);
            const dims = [...(configCopy.rows || []), ...(configCopy.columns || []), ...(configCopy.filters || [])];
            const dateDimensions = dims.filter(x => context.isDateDimension(x));
            dateDimensions?.forEach(dim => {
              // do not serialize the grid resource strings. This would pollute the object with unnecessary data.
              dim.resourceStrings = {};
            });
            return {
              pivotConfiguration: configCopy
            };
          },
          restoreFeatureState(context, state) {
            const config = state;
            if (!config || !(context.currGrid instanceof IgxPivotGridComponent)) {
              return;
            }
            context.restoreValues(config, context.currGrid);
            context.restoreDimensions(config);
            context.currGrid.pivotConfiguration = config;
          }
        }
      };
    }
    /**
     * Gets the state of a feature or states of all grid features, unless a certain feature is disabled through the `options` property.
     *
     * @param `serialize` determines whether the returned object will be serialized to JSON string. Default value is true.
     * @param `feature` string or array of strings determining the features to be added in the state. If skipped, all features are added.
     * @returns Returns the serialized to JSON string IGridState object, or the non-serialized IGridState object.
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * @ViewChild(IgxGridStateDirective, { static: true }) public state;
     * let state = this.state.getState(); // returns string
     * let state = this.state(false) // returns `IGridState` object
     * ```
     */
    getStateInternal(serialize = true, features) {
      let state;
      this.currGrid = this.grid;
      this.state = state = this.buildState(features);
      if (serialize) {
        state = JSON.stringify(state, this.stringifyCallback);
      }
      return state;
    }
    /* blazorSuppress */
    /**
     * Restores grid features' state based on the IGridState object passed as an argument.
     *
     * @param IGridState object to restore state from.
     * @returns
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * @ViewChild(IgxGridStateDirective, { static: true }) public state;
     * this.state.setState(gridState);
     * ```
     */
    setStateInternal(state, features) {
      this.state = state;
      this.currGrid = this.grid;
      this.restoreGridState(state, features);
      this.grid.cdr.detectChanges(); // TODO
    }
    /**
     * Builds an IGridState object.
     */
    buildState(keys) {
      this.applyFeatures(keys);
      let gridState = {};
      this.featureKeys.forEach(f => {
        if (this.options[f]) {
          if (!(this.grid instanceof IgxGridComponent) && f === 'groupBy') {
            return;
          }
          const feature = this.getFeature(f);
          const featureState = feature?.getFeatureState(this);
          gridState = Object.assign(gridState, featureState);
        }
      });
      return gridState;
    }
    /**
     * The method that calls corresponding methods to restore features from the passed IGridState object.
     */
    restoreGridState(state, features) {
      this.applyFeatures(features);
      this.restoreFeatures(state);
    }
    restoreFeatures(state) {
      this.featureKeys.forEach(f => {
        if (this.options[f]) {
          const featureState = state[f];
          if (f === 'moving' || featureState) {
            const feature = this.getFeature(f);
            feature.restoreFeatureState(this, featureState);
          }
        }
      });
    }
    /**
     * Returns a collection of all grid features.
     */
    applyFeatures(keys) {
      this.featureKeys = [];
      if (!keys) {
        for (const key of Object.keys(this.options)) {
          this.featureKeys.push(key);
        }
      } else if (Array.isArray(keys)) {
        this.featureKeys = [...keys];
      } else {
        this.featureKeys.push(keys);
      }
    }
    /**
     * This method restores complex objects in the pivot dimensions
     * Like the IgxPivotDateDimension and filters.
     */
    restoreDimensions(config) {
      const collections = [config.rows, config.columns, config.filters];
      for (const collection of collections) {
        for (let index = 0; index < collection?.length; index++) {
          const dim = collection[index];
          if (this.isDateDimension(dim)) {
            this.restoreDateDimension(dim);
          }
          // restore complex filters
          if (dim.filter) {
            dim.filter = this.createExpressionsTreeFromObject(dim.filter);
          }
        }
      }
    }
    /**
     * This method restores the IgxPivotDateDimension with its default functions and resource strings.
     */
    restoreDateDimension(dim) {
      const dateDim = new IgxPivotDateDimension(dim._baseDimension, dim._options);
      // restore functions and resource strings
      dim.resourceStrings = dateDim.resourceStrings;
      dim.memberFunction = dateDim.memberFunction;
      let currDim = dim;
      let originDim = dateDim;
      while (currDim.childLevel) {
        currDim = currDim.childLevel;
        originDim = originDim.childLevel;
        currDim.memberFunction = originDim.memberFunction;
      }
    }
    /**
     * Returns if this is a IgxPivotDateDimension.
     */
    isDateDimension(dim) {
      return dim._baseDimension;
    }
    /**
     * This method restores complex objects in the pivot values.
     * Like the default aggregator methods.
     */
    restoreValues(config, grid) {
      // restore aggregator func if it matches the default aggregators key and label
      const values = config.values;
      for (const value of values) {
        const aggregateList = value.aggregateList;
        const aggregators = PivotUtil.getAggregatorsForValue(value, grid);
        value.aggregate.aggregator = aggregators.find(x => x.key === value.aggregate.key && x.label === value.aggregate.label)?.aggregator;
        if (aggregateList) {
          for (const ag of aggregateList) {
            ag.aggregator = aggregators.find(x => x.key === ag.key && x.label === ag.label)?.aggregator;
          }
        }
      }
    }
    /**
     * This method builds a rehydrated IExpressionTree from a provided object.
     */
    createExpressionsTreeFromObject(exprTreeObject) {
      if (!exprTreeObject || !exprTreeObject.filteringOperands) {
        return null;
      }
      if (this.currGrid instanceof IgxPivotGridComponent) {
        return recreateTreeFromFields(exprTreeObject, this.currGrid.allDimensions.map(d => ({
          dataType: d.dataType,
          field: d.memberName
        })));
      }
      return recreateTreeFromFields(exprTreeObject, this.currGrid.columns);
    }
    stringifyCallback(key, val) {
      if (key === 'searchVal' && val instanceof Set) {
        return Array.from(val);
      }
      return val;
    }
    getColumnGroupKey(columnGroup) {
      return columnGroup.childColumns.map(x => x.columnGroup ? x.level + "_" + this.getColumnGroupKey(x) : x.field).sort().join("_");
    }
    getFeature(key) {
      const feature = this.FEATURES[key];
      return feature;
    }
    static {
      this.ɵfac = function IgxGridStateBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridStateBaseDirective)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 9), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridStateBaseDirective,
        inputs: {
          options: "options"
        }
      });
    }
  }
  return IgxGridStateBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridStateDirective = /*#__PURE__*/(() => {
  class IgxGridStateDirective extends IgxGridStateBaseDirective {
    constructor() {
      super(...arguments);
      /**
       *  Event emitted when set state is called with a string.
       * Returns the parsed state object so that it can be further modified before applying to the grid.
       * ```typescript
       * this.state.stateParsed.subscribe(parsedState => parsedState.sorting.forEach(x => x.strategy = NoopSortingStrategy.instance()});
       * ```
       */
      this.stateParsed = new EventEmitter();
    }
    /**
     *  An object with options determining if a certain feature state should be saved.
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * public options = {selection: false, advancedFiltering: false};
     * ```
     */
    get options() {
      return super.options;
    }
    set options(value) {
      super.options = value;
    }
    /**
     * Gets the state of a feature or states of all grid features, unless a certain feature is disabled through the `options` property.
     *
     * @param `serialize` determines whether the returned object will be serialized to JSON string. Default value is true.
     * @param `feature` string or array of strings determining the features to be added in the state. If skipped, all features are added.
     * @returns Returns the serialized to JSON string IGridState object, or the non-serialized IGridState object.
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * @ViewChild(IgxGridStateDirective, { static: true }) public state;
     * let state = this.state.getState(); // returns string
     * let state = this.state(false) // returns `IGridState` object
     * ```
     */
    getState(serialize = true, features) {
      return super.getStateInternal(serialize, features);
    }
    /* blazorSuppress */
    /**
     * Restores grid features' state based on the IGridState object passed as an argument.
     *
     * @param IGridState object to restore state from.
     * @returns
     * ```html
     * <igx-grid [igxGridState]="options"></igx-grid>
     * ```
     * ```typescript
     * @ViewChild(IgxGridStateDirective, { static: true }) public state;
     * this.state.setState(gridState);
     * ```
     */
    setState(state, features) {
      if (typeof state === 'string') {
        state = JSON.parse(state);
        this.stateParsed.emit(state);
      }
      return super.setStateInternal(state, features);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridStateDirective_BaseFactory;
        return function IgxGridStateDirective_Factory(__ngFactoryType__) {
          return (ɵIgxGridStateDirective_BaseFactory || (ɵIgxGridStateDirective_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridStateDirective)))(__ngFactoryType__ || IgxGridStateDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridStateDirective,
        selectors: [["", "igxGridState", ""]],
        inputs: {
          options: [0, "igxGridState", "options"]
        },
        outputs: {
          stateParsed: "stateParsed"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxGridStateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxExcelTextDirective = /*#__PURE__*/(() => {
  class IgxExcelTextDirective {
    static {
      this.ɵfac = function IgxExcelTextDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExcelTextDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxExcelTextDirective,
        selectors: [["", "excelText", ""], ["excel-text"]]
      });
    }
  }
  return IgxExcelTextDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxCSVTextDirective = /*#__PURE__*/(() => {
  class IgxCSVTextDirective {
    static {
      this.ɵfac = function IgxCSVTextDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCSVTextDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxCSVTextDirective,
        selectors: [["", "csvText", ""], ["csv-text"]]
      });
    }
  }
  return IgxCSVTextDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorElement */
/* wcElementTag: igc-grid-toolbar-title */
/* blazorAlternateBaseType: GridToolbarContent */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/**
 * Provides a way to template the title portion of the toolbar in the grid.
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 * @example
 * ```html
 * <igx-grid-toolbar-title>My custom title</igx-grid-toolbar-title>
 * ```
 */
let IgxGridToolbarTitleComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarTitleComponent {
    constructor() {
      /**
       * Host `class.igx-grid-toolbar__title` binding.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-grid-toolbar__title';
    }
    static {
      this.ɵfac = function IgxGridToolbarTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarTitleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarTitleComponent,
        selectors: [["igx-grid-toolbar-title"]],
        hostVars: 2,
        hostBindings: function IgxGridToolbarTitleComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid-toolbar__title", ctx.cssClass);
          }
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxGridToolbarTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorElement */
/* blazorIndirectRender */
/* blazorAlternateBaseType: GridToolbarContent */
/* wcElementTag: igc-grid-toolbar-actions */
/* singleInstanceIdentifier */
/**
 * Provides a way to template the action portion of the toolbar in the grid.
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 * @example
 * ```html
 * <igx-grid-toolbar-actions>
 *  <some-toolbar-action-here />
 * </igx-grid-toolbar-actions>
 * ```
 */
let IgxGridToolbarActionsComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarActionsComponent {
    constructor() {
      /**
       * Host `class.igx-grid-toolbar__actions` binding.
       *
       * @hidden
       * @internal
       */
      this.cssClass = 'igx-grid-toolbar__actions';
    }
    static {
      this.ɵfac = function IgxGridToolbarActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarActionsComponent,
        selectors: [["igx-grid-toolbar-actions"]],
        hostVars: 2,
        hostBindings: function IgxGridToolbarActionsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid-toolbar__actions", ctx.cssClass);
          }
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxGridToolbarActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxGridToolbarDirective = /*#__PURE__*/(() => {
  class IgxGridToolbarDirective {
    constructor(template) {
      this.template = template;
    }
    static ngTemplateContextGuard(_dir, ctx) {
      return true;
    }
    static {
      this.ɵfac = function IgxGridToolbarDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxGridToolbarDirective,
        selectors: [["", "igxGridToolbar", ""]]
      });
    }
  }
  return IgxGridToolbarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-toolbar-advanced-filtering */
/* blazorIndirectRender */
/* blazorAlternateBaseType: GridToolbarBaseAction */
/* jsonAPIManageItemInMarkup */
/* singleInstanceIdentifier */
/**
 * Provides a pre-configured button to open the advanced filtering dialog of the grid.
 *
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 * @example
 * ```html
 * <igx-grid-toolbar-advanced-filtering></igx-grid-toolbar-advanced-filtering>
 * <igx-grid-toolbar-advanced-filtering>Custom text</igx-grid-toolbar-advanced-filtering>
 * ```
 */
let IgxGridToolbarAdvancedFilteringComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarAdvancedFilteringComponent {
    /**
     * Returns the grid containing this component.
     * @hidden @internal
     */
    get grid() {
      return this.toolbar.grid;
    }
    constructor(toolbar) {
      this.toolbar = toolbar;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      // Initial value
      this.numberOfColumns = this.grid?.advancedFilteringExpressionsTree ? this.extractUniqueFieldNamesFromFilterTree(this.grid?.advancedFilteringExpressionsTree).length : 0;
      // Subscribing for future updates
      this.grid?.advancedFilteringExpressionsTreeChange.subscribe(filteringTree => {
        this.numberOfColumns = this.extractUniqueFieldNamesFromFilterTree(filteringTree).length;
      });
    }
    extractUniqueFieldNamesFromFilterTree(filteringTree) {
      const columnNames = [];
      if (!filteringTree) return columnNames;
      filteringTree.filteringOperands.forEach(expr => {
        if (isTree(expr)) {
          columnNames.push(...this.extractUniqueFieldNamesFromFilterTree(expr));
        } else {
          columnNames.push(expr.fieldName);
        }
      });
      return [...new Set(columnNames)];
    }
    static {
      this.ɵfac = function IgxGridToolbarAdvancedFilteringComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarAdvancedFilteringComponent)(i0.ɵɵdirectiveInject(IgxToolbarToken));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarAdvancedFilteringComponent,
        selectors: [["igx-grid-toolbar-advanced-filtering"]],
        inputs: {
          overlaySettings: "overlaySettings"
        },
        ngContentSelectors: _c0,
        decls: 7,
        vars: 3,
        consts: [["ref", ""], ["igxButton", "outlined", "type", "button", "name", "btnAdvancedFiltering", "igxRipple", "", 1, "igx-grid-toolbar__adv-filter", 3, "click", "title"], ["family", "default", "name", "filter_list"], [1, "igx-adv-filter--column-number"]],
        template: function IgxGridToolbarAdvancedFilteringComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 1);
            i0.ɵɵlistener("click", function IgxGridToolbarAdvancedFilteringComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.grid.openAdvancedFilteringDialog(ctx.overlaySettings));
            });
            i0.ɵɵelement(1, "igx-icon", 2);
            i0.ɵɵelementStart(2, "span", null, 0);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, IgxGridToolbarAdvancedFilteringComponent_Conditional_5_Template, 2, 1, "span")(6, IgxGridToolbarAdvancedFilteringComponent_Conditional_6_Template, 2, 1, "span", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const ref_r3 = i0.ɵɵreference(3);
            i0.ɵɵproperty("title", ctx.grid == null ? null : ctx.grid.resourceStrings.igx_grid_toolbar_advanced_filtering_button_tooltip);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ref_r3.textContent.trim() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.grid == null ? null : ctx.grid.advancedFilteringExpressionsTree) ? 6 : -1);
          }
        },
        dependencies: [IgxButtonDirective, IgxRippleDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarAdvancedFilteringComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* mustUseNGParentAnchor */
/* wcElementTag: igc-grid-toolbar */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/* contentParent: GridBaseDirective */
/* contentParent: RowIsland */
/* contentParent: HierarchicalGrid */
/* jsonAPIManageItemInMarkup */
/**
 * Provides a context-aware container component for UI operations for the grid components.
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridComponent, IgxTreeGridComponent, IgxHierarchicalGridComponent, IgxPivotGridComponent
 *
 */
let IgxGridToolbarComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarComponent {
    /**
     * Gets/sets the grid component for the toolbar component.
     *
     * @deprecated since version 17.1.0. No longer required to be set for the Hierarchical Grid child grid template
     *
     * @remarks
     * Usually you should not set this property in the context of the default grid/tree grid.
     * The only grids that demands this to be set are the hierarchical child grids. For additional
     * information check the toolbar topic.
     */
    get grid() {
      if (this._grid) {
        return this._grid;
      }
      return this.api.grid;
    }
    set grid(value) {
      this._grid = value;
    }
    /** Returns the native DOM element of the toolbar component */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(api, iconService, element) {
      this.api = api;
      this.iconService = iconService;
      this.element = element;
      /**
       * When enabled, shows the indeterminate progress bar.
       *
       * @remarks
       * By default this will be toggled, when the default exporter component is present
       * and an exporting is in progress.
       */
      this.showProgress = false;
      /**
       * @hidden
       * @internal
       */
      this.defaultStyle = true;
      this.iconService.addSvgIconFromText(pinLeft.name, pinLeft.value, 'imx-icons');
      this.iconService.addSvgIconFromText(unpinLeft.name, unpinLeft.value, 'imx-icons');
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.sub?.unsubscribe();
    }
    static {
      this.ɵfac = function IgxGridToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarComponent)(i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(IgxIconService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarComponent,
        selectors: [["igx-grid-toolbar"]],
        contentQueries: function IgxGridToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxGridToolbarActionsComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hasActions = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxGridToolbarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid-toolbar", ctx.defaultStyle);
          }
        },
        inputs: {
          showProgress: [2, "showProgress", "showProgress", booleanAttribute],
          grid: "grid"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxToolbarToken,
          useExisting: IgxGridToolbarComponent
        }])],
        ngContentSelectors: _c261,
        decls: 8,
        vars: 3,
        consts: [["actions", ""], [1, "igx-grid-toolbar__custom-content"], [4, "ngTemplateOutlet"], [1, "igx-grid-toolbar__progress-bar"], [3, "indeterminate"]],
        template: function IgxGridToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c260);
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, IgxGridToolbarComponent_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, IgxGridToolbarComponent_Conditional_5_Template, 2, 1, "igx-grid-toolbar-actions")(6, IgxGridToolbarComponent_ng_container_6_Template, 1, 0, "ng-container", 2)(7, IgxGridToolbarComponent_Conditional_7_Template, 2, 1, "div", 3);
          }
          if (rf & 2) {
            const actions_r2 = i0.ɵɵreference(4);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ctx.hasActions ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", actions_r2);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showProgress ? 7 : -1);
          }
        },
        dependencies: [IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, NgTemplateOutlet, IgxLinearProgressBarComponent],
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorInclude */
/* blazorElement */
/* blazorIndirectRender */
/* blazorAlternateBaseType: GridToolbarBaseAction */
/**
 * Base class for the pinning/hiding column and exporter actions.
 *
 * @hidden @internal
 */
let BaseToolbarDirective = /*#__PURE__*/(() => {
  class BaseToolbarDirective {
    /**
     * Sets overlay settings
     */
    set overlaySettings(overlaySettings) {
      this._overlaySettings = overlaySettings;
    }
    /**
     * Returns overlay settings
     */
    get overlaySettings() {
      return this._overlaySettings;
    }
    /**
     * Returns the grid containing this component.
     * @hidden @internal
     */
    get grid() {
      return this.toolbar.grid;
    }
    constructor(toolbar) {
      this.toolbar = toolbar;
      /**
       * Emits an event before the toggle container is opened.
       */
      this.opening = new EventEmitter();
      /**
       * Emits an event after the toggle container is opened.
       */
      this.opened = new EventEmitter();
      /**
       * Emits an event before the toggle container is closed.
       */
      this.closing = new EventEmitter();
      /**
       * Emits an event after the toggle container is closed.
       */
      this.closed = new EventEmitter();
      /**
       * Emits when after a column's checked state is changed
       */
      this.columnToggle = new EventEmitter();
      this.$destroy = new Subject();
      this._overlaySettings = {
        positionStrategy: new ConnectedPositioningStrategy({
          horizontalDirection: HorizontalAlignment.Left,
          horizontalStartPoint: HorizontalAlignment.Right,
          verticalDirection: VerticalAlignment.Bottom,
          verticalStartPoint: VerticalAlignment.Bottom
        }),
        scrollStrategy: new AbsoluteScrollStrategy(),
        modal: false,
        closeOnEscape: true,
        closeOnOutsideClick: true
      };
    }
    /** @hidden @internal **/
    ngOnDestroy() {
      this.$destroy.next();
      this.$destroy.complete();
    }
    /** @hidden @internal */
    toggle(anchorElement, toggleRef, actions) {
      if (actions) {
        this._setupListeners(toggleRef, actions);
        const setHeight = () => actions.columnsAreaMaxHeight = actions.columnsAreaMaxHeight !== '100%' ? actions.columnsAreaMaxHeight : this.columnListHeight ?? `${Math.max(this.grid.calcHeight * 0.5, 200)}px`;
        toggleRef.opening.pipe(first$2()).subscribe(setHeight);
      }
      toggleRef.toggle({
        ...this.overlaySettings,
        ...{
          target: anchorElement,
          outlet: this.grid.outlet,
          excludeFromOutsideClick: [anchorElement]
        }
      });
    }
    /** @hidden @internal */
    focusSearch(columnActions) {
      columnActions.querySelector('input')?.focus();
    }
    _setupListeners(toggleRef, actions) {
      if (actions) {
        if (!this.$sub || this.$sub.closed) {
          this.$sub = actions.columnToggled.pipe(takeUntil(this.$destroy)).subscribe(event => this.columnToggle.emit(event));
        }
      }
      /** The if statement prevents emitting open and close events twice  */
      if (toggleRef.collapsed) {
        toggleRef.opening.pipe(first$2(), takeUntil(this.$destroy)).subscribe(event => this.opening.emit(event));
        toggleRef.opened.pipe(first$2(), takeUntil(this.$destroy)).subscribe(event => this.opened.emit(event));
      } else {
        toggleRef.closing.pipe(first$2(), takeUntil(this.$destroy)).subscribe(event => this.closing.emit(event));
        toggleRef.closed.pipe(first$2(), takeUntil(this.$destroy)).subscribe(event => this.closed.emit(event));
      }
    }
    static {
      this.ɵfac = function BaseToolbarDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseToolbarDirective)(i0.ɵɵdirectiveInject(IgxToolbarToken));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseToolbarDirective,
        inputs: {
          columnListHeight: "columnListHeight",
          title: "title",
          prompt: "prompt",
          overlaySettings: "overlaySettings"
        },
        outputs: {
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed",
          columnToggle: "columnToggle"
        }
      });
    }
  }
  return BaseToolbarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorElement */
/* blazorIndirectRender */
/**
 * @hidden @internal
 * Base class for pinning/hiding column actions
 */
let BaseToolbarColumnActionsDirective = /*#__PURE__*/(() => {
  class BaseToolbarColumnActionsDirective extends BaseToolbarDirective {
    constructor() {
      super(...arguments);
      this.hideFilter = false;
      this.filterCriteria = '';
      this.columnDisplayOrder = ColumnDisplayOrder.DisplayOrder;
      this.columnsAreaMaxHeight = '100%';
      this.indentetion = 30;
    }
    checkAll() {
      this.columnActionsUI.checkAllColumns();
    }
    uncheckAll() {
      this.columnActionsUI.uncheckAllColumns();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵBaseToolbarColumnActionsDirective_BaseFactory;
        return function BaseToolbarColumnActionsDirective_Factory(__ngFactoryType__) {
          return (ɵBaseToolbarColumnActionsDirective_BaseFactory || (ɵBaseToolbarColumnActionsDirective_BaseFactory = i0.ɵɵgetInheritedFactory(BaseToolbarColumnActionsDirective)))(__ngFactoryType__ || BaseToolbarColumnActionsDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseToolbarColumnActionsDirective,
        inputs: {
          hideFilter: [2, "hideFilter", "hideFilter", booleanAttribute],
          filterCriteria: "filterCriteria",
          columnDisplayOrder: "columnDisplayOrder",
          columnsAreaMaxHeight: "columnsAreaMaxHeight",
          uncheckAllText: "uncheckAllText",
          checkAllText: "checkAllText",
          indentetion: "indentetion",
          buttonText: "buttonText"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return BaseToolbarColumnActionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-toolbar-exporter */
/* blazorIndirectRender */
/* jsonAPIManageItemInMarkup */
/* singleInstanceIdentifier */
/**
 * Provides a pre-configured exporter component for the grid.
 *
 * @remarks
 * This component still needs the actual exporter service(s) provided in the DI chain
 * in order to export something.
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 */
let IgxGridToolbarExporterComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarExporterComponent extends BaseToolbarDirective {
    constructor(toolbar, excelExporter, csvExporter) {
      super(toolbar);
      this.excelExporter = excelExporter;
      this.csvExporter = csvExporter;
      /**
       * Show entry for CSV export.
       */
      this.exportCSV = true;
      /**
       * Show entry for Excel export.
       */
      this.exportExcel = true;
      /**
       * The name for the exported file.
       */
      this.filename = 'ExportedData';
      /**
       * Emitted when starting an export operation. Re-emitted additionally
       * by the grid itself.
       */
      this.exportStarted = new EventEmitter();
      /**
       * Emitted on successful ending of an export operation.
       */
      this.exportEnded = new EventEmitter();
      /**
       * Indicates whether there is an export in progress.
       */
      this.isExporting = false;
    }
    exportClicked(type, toggleRef) {
      toggleRef?.close();
      this.export(type);
    }
    /* alternateName: exportGrid */
    /**
     * Export the grid's data
     * @param type File type to export
     */
    export(type) {
      let options;
      let exporter;
      switch (type) {
        case 'csv':
          options = new IgxCsvExporterOptions(this.filename, CsvFileTypes.CSV);
          exporter = this.csvExporter;
          break;
        case 'excel':
          options = new IgxExcelExporterOptions(this.filename);
          exporter = this.excelExporter;
      }
      const args = {
        exporter,
        options,
        grid: this.grid,
        cancel: false
      };
      this.exportStarted.emit(args);
      this.grid.toolbarExporting.emit(args);
      this.isExporting = true;
      this.toolbar.showProgress = true;
      if (args.cancel) {
        return;
      }
      exporter.exportEnded.pipe(first$2()).subscribe(() => {
        this.exportEnded.emit();
        this.isExporting = false;
        this.toolbar.showProgress = false;
      });
      exporter.export(this.grid, options);
    }
    static {
      this.ɵfac = function IgxGridToolbarExporterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridToolbarExporterComponent)(i0.ɵɵdirectiveInject(IgxToolbarToken), i0.ɵɵdirectiveInject(IgxExcelExporterService), i0.ɵɵdirectiveInject(IgxCsvExporterService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarExporterComponent,
        selectors: [["igx-grid-toolbar-exporter"]],
        inputs: {
          exportCSV: [2, "exportCSV", "exportCSV", booleanAttribute],
          exportExcel: [2, "exportExcel", "exportExcel", booleanAttribute],
          filename: "filename"
        },
        outputs: {
          exportStarted: "exportStarted",
          exportEnded: "exportEnded"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c263,
        decls: 13,
        vars: 5,
        consts: [["btn", ""], ["ref", ""], ["toggleRef", "toggle"], ["btnExportExcel", ""], ["excel", ""], ["btnExportCsv", ""], ["csv", ""], ["igxButton", "outlined", "type", "button", "igxRipple", "", 3, "click", "title", "disabled"], ["family", "default", "name", "file_download"], ["family", "default", "name", "arrow_drop_down"], ["id", "btnExport", 1, "igx-grid-toolbar__dropdown"], ["igxToggle", "", 1, "igx-grid-toolbar__dd-list"], ["id", "btnExportExcel", "igxRipple", "", 1, "igx-grid-toolbar__dd-list-items"], ["id", "btnExportCsv", "igxRipple", "", 1, "igx-grid-toolbar__dd-list-items"], ["id", "btnExportExcel", "igxRipple", "", 1, "igx-grid-toolbar__dd-list-items", 3, "click"], ["id", "btnExportCsv", "igxRipple", "", 1, "igx-grid-toolbar__dd-list-items", 3, "click"]],
        template: function IgxGridToolbarExporterComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c262);
            i0.ɵɵelementStart(0, "button", 7, 0);
            i0.ɵɵlistener("click", function IgxGridToolbarExporterComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              const btn_r2 = i0.ɵɵreference(1);
              const toggleRef_r3 = i0.ɵɵreference(10);
              return i0.ɵɵresetView(ctx.toggle(btn_r2, toggleRef_r3));
            });
            i0.ɵɵelement(2, "igx-icon", 8);
            i0.ɵɵelementStart(3, "span", null, 1);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, IgxGridToolbarExporterComponent_Conditional_6_Template, 2, 1, "span");
            i0.ɵɵelement(7, "igx-icon", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 10)(9, "ul", 11, 2);
            i0.ɵɵtemplate(11, IgxGridToolbarExporterComponent_Conditional_11_Template, 6, 1, "li", 12)(12, IgxGridToolbarExporterComponent_Conditional_12_Template, 6, 1, "li", 13);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const ref_r9 = i0.ɵɵreference(4);
            i0.ɵɵproperty("title", ctx.grid == null ? null : ctx.grid.resourceStrings.igx_grid_toolbar_exporter_button_tooltip)("disabled", ctx.isExporting);
            i0.ɵɵadvance(6);
            i0.ɵɵconditional(!ref_r9.textContent.trim() ? 6 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.exportExcel ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.exportCSV ? 12 : -1);
          }
        },
        dependencies: [IgxButtonDirective, IgxRippleDirective, IgxIconComponent, IgxToggleDirective, IgxExcelTextDirective, IgxCSVTextDirective],
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarExporterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-toolbar-hiding */
/* blazorIndirectRender */
/* jsonAPIManageItemInMarkup */
/* singleInstanceIdentifier */
/**
 * Provides a pre-configured column hiding component for the grid.
 *
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 * @example
 * ```html
 *  <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
 * ```
 */
let IgxGridToolbarHidingComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarHidingComponent extends BaseToolbarColumnActionsDirective {
    set content(content) {
      this.columnActionsUI = content;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridToolbarHidingComponent_BaseFactory;
        return function IgxGridToolbarHidingComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridToolbarHidingComponent_BaseFactory || (ɵIgxGridToolbarHidingComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridToolbarHidingComponent)))(__ngFactoryType__ || IgxGridToolbarHidingComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarHidingComponent,
        selectors: [["igx-grid-toolbar-hiding"]],
        viewQuery: function IgxGridToolbarHidingComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxColumnHidingDirective, 5, IgxColumnActionsComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [["btn", ""], ["actions", "", "ref", "toggle"], ["igxButton", "outlined", "type", "button", "name", "btnColumnHiding", 3, "click", "title"], ["family", "default", 3, "name"], ["igxColumnHiding", "", "igxToggle", "", 3, "opened", "grid", "title", "filterColumnsPrompt", "hideFilter", "filterCriteria", "columnDisplayOrder", "columnsAreaMaxHeight", "uncheckAllText", "checkAllText", "indentation"]],
        template: function IgxGridToolbarHidingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridToolbarHidingComponent_Conditional_0_Template, 10, 14);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.grid.rendered$) ? 0 : -1);
          }
        },
        dependencies: [IgxButtonDirective, IgxIconComponent, IgxColumnActionsComponent, IgxColumnHidingDirective, IgxToggleDirective, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarHidingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorElement */
/* wcElementTag: igc-grid-toolbar-pinning */
/* singleInstanceIdentifier */
/* blazorIndirectRender */
/* jsonAPIManageItemInMarkup */
/**
 * Provides a pre-configured column pinning component for the grid.
 *
 *
 * @igxModule IgxGridToolbarModule
 * @igxParent IgxGridToolbarComponent
 *
 * @example
 * ```html
 *  <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
 * ```
 */
let IgxGridToolbarPinningComponent = /*#__PURE__*/(() => {
  class IgxGridToolbarPinningComponent extends BaseToolbarColumnActionsDirective {
    set content(content) {
      this.columnActionsUI = content;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxGridToolbarPinningComponent_BaseFactory;
        return function IgxGridToolbarPinningComponent_Factory(__ngFactoryType__) {
          return (ɵIgxGridToolbarPinningComponent_BaseFactory || (ɵIgxGridToolbarPinningComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxGridToolbarPinningComponent)))(__ngFactoryType__ || IgxGridToolbarPinningComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxGridToolbarPinningComponent,
        selectors: [["igx-grid-toolbar-pinning"]],
        viewQuery: function IgxGridToolbarPinningComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxColumnPinningDirective, 5, IgxColumnActionsComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [["btn", ""], ["actions", "", "ref", "toggle"], ["igxButton", "outlined", "type", "button", "name", "btnColumnPinning", 3, "click", "title"], ["family", "default", 3, "name"], ["igxColumnPinning", "", "igxToggle", "", 3, "opened", "grid", "title", "filterColumnsPrompt", "hideFilter", "filterCriteria", "columnDisplayOrder", "columnsAreaMaxHeight", "uncheckAllText", "checkAllText", "indentation"]],
        template: function IgxGridToolbarPinningComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxGridToolbarPinningComponent_Conditional_0_Template, 10, 14);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.grid.rendered$) ? 0 : -1);
          }
        },
        dependencies: [IgxButtonDirective, IgxIconComponent, IgxColumnActionsComponent, IgxColumnPinningDirective, IgxToggleDirective, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return IgxGridToolbarPinningComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// import { IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarDirective, IgxGridToolbarTitleComponent } from './common';
// import { IgxGridToolbarAdvancedFilteringComponent } from './grid-toolbar-advanced-filtering.component';
// import { IgxGridToolbarExporterComponent } from './grid-toolbar-exporter.component';
// import { IgxGridToolbarHidingComponent } from './grid-toolbar-hiding.component';
// import { IgxGridToolbarPinningComponent } from './grid-toolbar-pinning.component';
// import { IgxGridToolbarComponent } from './grid-toolbar.component';
/* NOTE: Grid toolbar directives collection for ease-of-use import in standalone components scenario */
// export const IGX_GRID_TOOLBAR_DIRECTIVES = [
//     IgxCSVTextDirective,
//     IgxExcelTextDirective,
//     IgxGridToolbarActionsComponent,
//     IgxGridToolbarAdvancedFilteringComponent,
//     IgxGridToolbarComponent,
//     IgxGridToolbarExporterComponent,
//     IgxGridToolbarHidingComponent,
//     IgxGridToolbarPinningComponent,
//     IgxGridToolbarTitleComponent,
//     IgxGridToolbarDirective
// ] as const;

/*
export * from './api.service';

// export * from './common/shared.module';
export * from './columns/interfaces';
// export * from './headers/headers.module';
// export * from './filtering/base/filtering.module';
export * from './grid-base.directive';
export * from './grid.common';
// export * from './grid-common.module';
//
// export * from './toolbar/toolbar.module';
export * from './grid/grid-validation.service';

export { IgxGridCellComponent } from './cell.component';

export * from './resizing/resize.module';
// export * from './summaries/summary.module';
export * from './grouping/tree-grid-group-by-area.component';
export * from './grouping/grid-group-by-area.component';
export * from './grouping/group-by-area.directive';
export { DropPosition } from './moving/moving.service';
*/
/* NOTE: Common grid directives collection for reuse
    Import `IGX_GRID_DIRECTIVES` or `IGX_TREE_GRID_DIRECTIVES` or `IGX_HIERARCHICAL_GRID_DIRECTIVES` instead of `IGX_GRID_COMMON_DIRECTIVES`
*/
const IGX_GRID_COMMON_DIRECTIVES = [IgxRowDirective, IgxGridFooterComponent, IgxAdvancedFilteringDialogComponent, IgxRowExpandedIndicatorDirective, IgxRowCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHeaderCollapsedIndicatorDirective, IgxExcelStyleHeaderIconDirective, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxDragIndicatorIconDirective, IgxRowDragGhostDirective, IgxGridStateDirective,
// IGX_GRID_HEADERS_DIRECTIVES:
IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent,
// IGX_GRID_COLUMN_DIRECTIVES:
IgxFilterCellTemplateDirective, IgxSummaryTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCellHeaderTemplateDirective, IgxCellFooterTemplateDirective, IgxCellEditorTemplateDirective, IgxCollapsibleIndicatorTemplateDirective, IgxColumnComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent,
// IGX_GRID_COLUMN_ACTIONS_DIRECTIVES:
IgxColumnActionsComponent, IgxColumnHidingDirective, IgxColumnPinningDirective,
// IGX_GRID_SELECTION_DIRECTIVES:
IgxRowSelectorDirective, IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective,
// IGX_GRID_TOOLBAR_DIRECTIVES:
IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridToolbarDirective,
// IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES:
IgxGridExcelStyleFilteringComponent, IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleMovingComponent, IgxExcelStyleSearchComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleLoadingValuesTemplateDirective];
let IgxPaginatorDirective = /*#__PURE__*/(() => {
  class IgxPaginatorDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxPaginatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPaginatorDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPaginatorDirective,
        selectors: [["", "igxPaginator", ""]]
      });
    }
  }
  return IgxPaginatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const PaginatorResourceStringsEN = {
  igx_paginator_label: 'Items per page',
  igx_paginator_pager_text: 'of',
  igx_paginator_first_page_button_text: 'Go to first page',
  igx_paginator_previous_page_button_text: 'Previous page',
  igx_paginator_last_page_button_text: 'Go to last page',
  igx_paginator_next_page_button_text: 'Next page'
};
let IgxPaginatorContentDirective = /*#__PURE__*/(() => {
  class IgxPaginatorContentDirective {
    constructor() {
      /**
       * @internal
       * @hidden
       */
      this.cssClass = 'igx-paginator-content';
    }
    static {
      this.ɵfac = function IgxPaginatorContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPaginatorContentDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxPaginatorContentDirective,
        selectors: [["", "igxPaginatorContent", ""], ["igx-paginator-content"]],
        hostVars: 2,
        hostBindings: function IgxPaginatorContentDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-paginator-content", ctx.cssClass);
          }
        }
      });
    }
  }
  return IgxPaginatorContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorElement */
/* mustUseNGParentAnchor */
/* wcElementTag: igc-paginator */
/* blazorIndirectRender */
/* singleInstanceIdentifier */
/* contentParent: GridBaseDirective */
/* contentParent: RowIsland */
/* contentParent: HierarchicalGrid */
/* jsonAPIManageCollectionInMarkup */
/**
 * Paginator component description
 * @igxParent IgxGridComponent, IgxTreeGridComponent, IgxHierarchicalGridComponent, IgxPivotGridComponent, *
 */
// switch IgxPaginatorToken to extends once density is dropped
let IgxPaginatorComponent = /*#__PURE__*/(() => {
  class IgxPaginatorComponent {
    /**
     * Gets/Sets the current page of the paginator.
     * The default is 0.
     * ```typescript
     * let page = this.paginator.page;
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    get page() {
      return this._page;
    }
    set page(value) {
      if (this._page === value || value < 0 || value > this.totalPages) {
        return;
      }
      const cancelEventArgs = {
        current: this._page,
        next: value,
        cancel: false
      };
      const eventArgs = {
        previous: this._page,
        current: value
      };
      this.paging.emit(cancelEventArgs);
      if (cancelEventArgs.cancel) {
        return;
      }
      this._page = value;
      this.pageChange.emit(this._page);
      this.pagingDone.emit(eventArgs);
    }
    /**
     * Gets/Sets the number of visible items per page in the paginator.
     * The default is 15.
     * ```typescript
     * let itemsPerPage = this.paginator.perPage;
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    get perPage() {
      return this._perPage;
    }
    set perPage(value) {
      if (value < 0 || this.perPage === value) {
        return;
      }
      this._perPage = Number(value);
      this.perPageChange.emit(this._perPage);
      this._selectOptions = this.sortUniqueOptions(this.defaultSelectValues, this._perPage);
      this.totalPages = Math.ceil(this.totalRecords / this._perPage);
      if (this.totalPages !== 0 && this.page >= this.totalPages) {
        this.page = this.totalPages - 1;
      }
    }
    /**
     * Sets the total records.
     * ```typescript
     * let totalRecords = this.paginator.totalRecords;
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    get totalRecords() {
      return this._totalRecords;
    }
    set totalRecords(value) {
      this._totalRecords = value;
      this.totalPages = Math.ceil(this.totalRecords / this.perPage);
      if (this.page > this.totalPages) {
        this.page = 0;
      }
      this.cdr.detectChanges();
    }
    /**
     * Sets custom options in the select of the paginator
     * ```typescript
     * let options = this.paginator.selectOptions;
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    get selectOptions() {
      return this._selectOptions;
    }
    set selectOptions(value) {
      this._selectOptions = this.sortUniqueOptions(value, this._perPage);
      this.defaultSelectValues = [...value];
    }
    /**
     * Sets custom OverlaySettings.
     * ```html
     * <igx-paginator [overlaySettings] = "customOverlaySettings"></igx-paginator>
     * ```
     */
    get overlaySettings() {
      return this._overlaySettings;
    }
    set overlaySettings(value) {
      this._overlaySettings = Object.assign({}, this._overlaySettings, value);
    }
    /* mustSetInCodePlatforms: WebComponents;Blazor;React */
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    constructor(elementRef, cdr) {
      this.elementRef = elementRef;
      this.cdr = cdr;
      /**
       * Emitted when `perPage` property value of the paginator is changed.
       *
       * @example
       * ```html
       * <igx-paginator (perPageChange)="onPerPageChange($event)"></igx-paginator>
       * ```
       * ```typescript
       * public onPerPageChange(perPage: number) {
       *   this.perPage = perPage;
       * }
       * ```
       */
      this.perPageChange = new EventEmitter();
      /**
       * Emitted after the current page is changed.
       *
       * @example
       * ```html
       * <igx-paginator (pageChange)="onPageChange($event)"></igx-paginator>
       * ```
       * ```typescript
       * public onPageChange(page: number) {
       *   this.currentPage = page;
       * }
       * ```
       */
      this.pageChange = new EventEmitter();
      /**
       * Emitted before paging is performed.
       *
       * @remarks
       * Returns an object consisting of the current and next pages.
       * @example
       * ```html
       * <igx-paginator (paging)="pagingHandler($event)"></igx-paginator>
       * ```
       */
      this.paging = new EventEmitter();
      /**
       * Emitted after paging is performed.
       *
       * @remarks
       * Returns an object consisting of the previous and current pages.
       * @example
       * ```html
       * <igx-paginator (pagingDone)="pagingDone($event)"></igx-paginator>
       * ```
       */
      this.pagingDone = new EventEmitter();
      this._page = 0;
      this._selectOptions = [5, 10, 15, 25, 50, 100, 500];
      this._perPage = 15;
      this._resourceStrings = getCurrentResourceStrings(PaginatorResourceStringsEN);
      this._overlaySettings = {};
      this.defaultSelectValues = [5, 10, 15, 25, 50, 100, 500];
      /** @hidden @internal */
      this.cssClass = 'igx-paginator';
    }
    /**
     * Returns if the current page is the last page.
     * ```typescript
     * const lastPage = this.paginator.isLastPage;
     * ```
     */
    get isLastPage() {
      return this.page + 1 >= this.totalPages;
    }
    /**
     * Returns if the current page is the first page.
     * ```typescript
     * const lastPage = this.paginator.isFirstPage;
     * ```
     */
    get isFirstPage() {
      return this.page === 0;
    }
    /**
     * Returns if the first pager buttons should be disabled
     * @hidden
     * @deprecated in version 18.1.0. Use the `isFirstPage` property instead.
     */
    get isFirstPageDisabled() {
      return this.isFirstPage;
    }
    /**
     * Returns if the last pager buttons should be disabled
     * @hidden
     * @deprecated in version 18.1.0. Use the `isLastPage` property instead.
     */
    get isLastPageDisabled() {
      return this.isLastPage;
    }
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    /**
     * Goes to the next page of the `IgxPaginatorComponent`, if the paginator is not already at the last page.
     * ```typescript
     * this.paginator.nextPage();
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    nextPage() {
      if (!this.isLastPage) {
        this.page += 1;
      }
    }
    /**
     * Goes to the previous page of the `IgxPaginatorComponent`, if the paginator is not already at the first page.
     * ```typescript
     * this.paginator.previousPage();
     * ```
     *
     * @memberof IgxPaginatorComponent
     */
    previousPage() {
      if (!this.isFirstPage) {
        this.page -= 1;
      }
    }
    /**
     * Goes to the desired page index.
     * ```typescript
     * this.paginator.paginate(1);
     * ```
     *
     * @param val
     * @memberof IgxPaginatorComponent
     */
    paginate(val) {
      if (val < 0 || val > this.totalPages - 1) {
        return;
      }
      this.page = val;
    }
    sortUniqueOptions(values, newOption) {
      return Array.from(new Set([...values, newOption])).sort((a, b) => a - b);
    }
    static {
      this.ɵfac = function IgxPaginatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPaginatorComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPaginatorComponent,
        selectors: [["igx-paginator"]],
        contentQueries: function IgxPaginatorComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxPaginatorContentDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customContent = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxPaginatorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-paginator", ctx.cssClass);
          }
        },
        inputs: {
          page: "page",
          perPage: "perPage",
          totalRecords: "totalRecords",
          selectOptions: "selectOptions",
          overlaySettings: "overlaySettings",
          resourceStrings: "resourceStrings"
        },
        outputs: {
          perPageChange: "perPageChange",
          pageChange: "pageChange",
          paging: "paging",
          pagingDone: "pagingDone"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxPaginatorToken,
          useExisting: IgxPaginatorComponent
        }])],
        ngContentSelectors: _c265,
        decls: 3,
        vars: 2,
        template: function IgxPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c264);
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, IgxPaginatorComponent_Conditional_1_Template, 1, 0, "igx-page-size")(2, IgxPaginatorComponent_Conditional_2_Template, 1, 0, "igx-page-nav");
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.customContent ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.customContent ? 2 : -1);
          }
        },
        dependencies: () => [IgxPageSizeSelectorComponent, IgxPageNavigationComponent],
        encapsulation: 2
      });
    }
  }
  return IgxPaginatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPageSizeSelectorComponent = /*#__PURE__*/(() => {
  class IgxPageSizeSelectorComponent {
    constructor(paginator) {
      this.paginator = paginator;
      /**
       * @internal
       * @hidden
       */
      this.cssClass = 'igx-page-size';
    }
    static {
      this.ɵfac = function IgxPageSizeSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPageSizeSelectorComponent)(i0.ɵɵdirectiveInject(IgxPaginatorComponent, 1));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPageSizeSelectorComponent,
        selectors: [["igx-page-size"]],
        hostVars: 2,
        hostBindings: function IgxPageSizeSelectorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-page-size", ctx.cssClass);
          }
        },
        decls: 6,
        vars: 3,
        consts: [[1, "igx-page-size__label"], [1, "igx-page-size__select"], ["type", "border", 3, "ngModelChange", "overlaySettings", "ngModel"], [3, "value"]],
        template: function IgxPageSizeSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "igx-select", 2);
            i0.ɵɵtwoWayListener("ngModelChange", function IgxPageSizeSelectorComponent_Template_igx_select_ngModelChange_3_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.paginator.perPage, $event) || (ctx.paginator.perPage = $event);
              return $event;
            });
            i0.ɵɵrepeaterCreate(4, IgxPageSizeSelectorComponent_For_5_Template, 2, 2, "igx-select-item", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.paginator.resourceStrings.igx_paginator_label);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("overlaySettings", ctx.paginator.overlaySettings);
            i0.ɵɵtwoWayProperty("ngModel", ctx.paginator.perPage);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.paginator.selectOptions);
          }
        },
        dependencies: [IgxSelectComponent, FormsModule, i4.NgControlStatus, i4.NgModel, IgxSelectItemComponent],
        encapsulation: 2
      });
    }
  }
  return IgxPageSizeSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxPageNavigationComponent = /*#__PURE__*/(() => {
  class IgxPageNavigationComponent {
    constructor(paginator) {
      this.paginator = paginator;
      /**
       * @internal
       * @hidden
       */
      this.cssClass = 'igx-page-nav';
      /**
       * Sets the `role` attribute of the element.
       */
      this.role = 'navigation';
    }
    static {
      this.ɵfac = function IgxPageNavigationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPageNavigationComponent)(i0.ɵɵdirectiveInject(IgxPaginatorComponent, 1));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPageNavigationComponent,
        selectors: [["igx-page-nav"]],
        hostVars: 3,
        hostBindings: function IgxPageNavigationComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
            i0.ɵɵclassProp("igx-page-nav", ctx.cssClass);
          }
        },
        inputs: {
          role: "role"
        },
        decls: 15,
        vars: 19,
        consts: [["igxIconButton", "flat", "igxRipple", "", "type", "button", 3, "click", "title", "disabled", "igxRippleCentered"], ["family", "default", "name", "first_page"], ["family", "default", "name", "prev"], ["aria-current", "page", 1, "igx-page-nav__text"], ["igxRipple", "", "igxIconButton", "flat", "type", "button", 3, "click", "title", "disabled", "igxRippleCentered"], ["family", "default", "name", "next"], ["family", "default", "name", "last_page"]],
        template: function IgxPageNavigationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function IgxPageNavigationComponent_Template_button_click_0_listener() {
              return ctx.paginator.paginate(0);
            });
            i0.ɵɵelement(1, "igx-icon", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "button", 0);
            i0.ɵɵlistener("click", function IgxPageNavigationComponent_Template_button_click_2_listener() {
              return ctx.paginator.previousPage();
            });
            i0.ɵɵelement(3, "igx-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "span");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "button", 4);
            i0.ɵɵlistener("click", function IgxPageNavigationComponent_Template_button_click_11_listener() {
              return ctx.paginator.nextPage();
            });
            i0.ɵɵelement(12, "igx-icon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "button", 0);
            i0.ɵɵlistener("click", function IgxPageNavigationComponent_Template_button_click_13_listener() {
              return ctx.paginator.paginate(ctx.paginator.totalPages - 1);
            });
            i0.ɵɵelement(14, "igx-icon", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", ctx.paginator.resourceStrings.igx_paginator_first_page_button_text)("disabled", ctx.paginator.isFirstPage)("igxRippleCentered", true);
            i0.ɵɵattribute("aria-disabled", ctx.paginator.isFirstPage);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", ctx.paginator.resourceStrings.igx_paginator_previous_page_button_text)("disabled", ctx.paginator.isFirstPage)("igxRippleCentered", true);
            i0.ɵɵattribute("aria-disabled", ctx.paginator.isFirstPage);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.paginator.page + 1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("\xA0", ctx.paginator.resourceStrings.igx_paginator_pager_text, "\xA0");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.paginator.totalPages || 1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("title", ctx.paginator.resourceStrings.igx_paginator_next_page_button_text)("disabled", ctx.paginator.isLastPage)("igxRippleCentered", true);
            i0.ɵɵattribute("aria-disabled", ctx.paginator.isLastPage);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", ctx.paginator.resourceStrings.igx_paginator_last_page_button_text)("disabled", ctx.paginator.isLastPage)("igxRippleCentered", true);
            i0.ɵɵattribute("aria-disabled", ctx.paginator.isLastPage);
          }
        },
        dependencies: [IgxRippleDirective, IgxIconComponent, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxPageNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Paginator directives collection for ease-of-use import in standalone components scenario */
const IGX_PAGINATOR_DIRECTIVES = [IgxPaginatorComponent, IgxPageNavigationComponent, IgxPageSizeSelectorComponent, IgxPaginatorContentDirective, IgxPaginatorDirective];

/* NOTE: Grid directives collection for ease-of-use import in standalone components scenario */
const IGX_GRID_DIRECTIVES = [IgxGridComponent, IgxGroupByRowTemplateDirective, IgxGridDetailTemplateDirective, IgxRowAddTextDirective, IgxRowEditActionsDirective, IgxRowEditTextDirective, IgxRowEditTabStopDirective,
// IGX_GRID_COMMON_DIRECTIVES:
IgxRowDirective, IgxGridFooterComponent, IgxAdvancedFilteringDialogComponent, IgxRowExpandedIndicatorDirective, IgxRowCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHeaderCollapsedIndicatorDirective, IgxExcelStyleHeaderIconDirective, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxDragIndicatorIconDirective, IgxRowDragGhostDirective, IgxGridStateDirective,
// IGX_GRID_HEADERS_DIRECTIVES:
IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent,
// IGX_GRID_COLUMN_DIRECTIVES:
IgxFilterCellTemplateDirective, IgxSummaryTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCellHeaderTemplateDirective, IgxCellFooterTemplateDirective, IgxCellEditorTemplateDirective, IgxCollapsibleIndicatorTemplateDirective, IgxColumnComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent,
// IGX_GRID_COLUMN_ACTIONS_DIRECTIVES:
IgxColumnActionsComponent, IgxColumnHidingDirective, IgxColumnPinningDirective,
// IGX_GRID_SELECTION_DIRECTIVES:
IgxRowSelectorDirective, IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective,
// IGX_GRID_TOOLBAR_DIRECTIVES:
IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridToolbarDirective,
// IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES:
IgxGridExcelStyleFilteringComponent, IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleMovingComponent, IgxExcelStyleSearchComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleLoadingValuesTemplateDirective,
// IGX_GRID_VALIDATION_DIRECTIVES:
IgxColumnRequiredValidatorDirective, IgxColumnMinValidatorDirective, IgxColumnMaxValidatorDirective, IgxColumnEmailValidatorDirective, IgxColumnMinLengthValidatorDirective, IgxColumnMaxLengthValidatorDirective, IgxColumPatternValidatorDirective,
// IGX_PAGINATOR_DIRECTIVES:
IgxPaginatorComponent, IgxPageNavigationComponent, IgxPageSizeSelectorComponent, IgxPaginatorContentDirective, IgxPaginatorDirective];

/* blazorIndirectRender
   blazorComponent */
/* wcElementTag: igc-pivot-data-selector */
/**
 * Pivot Data Selector provides means to configure the pivot state of the Pivot Grid via a vertical panel UI
 *
 * @igxModule IgxPivotGridModule
 * @igxGroup Grids & Lists
 * @igxKeywords data selector, pivot, grid
 * @igxTheme pivot-data-selector-theme
 * @remarks
 * The Ignite UI Data Selector has a searchable list with the grid data columns,
 * there are also four expandable areas underneath for filters, rows, columns, and values
 * is used for grouping and aggregating simple flat data into a pivot table.
 * @example
 * ```html
 * <igx-pivot-grid #grid1 [data]="data" [pivotConfiguration]="configuration">
 * </igx-pivot-grid>
 * <igx-pivot-data-selector [grid]="grid1"></igx-pivot-data-selector>
 * ```
 */
let IgxPivotDataSelectorComponent = /*#__PURE__*/(() => {
  class IgxPivotDataSelectorComponent {
    get size() {
      return this.grid?.gridSize;
    }
    /** @hidden @internal */
    get dims() {
      return this._grid?.allDimensions || [];
    }
    /** @hidden @internal */
    get values() {
      return this._grid?.pivotConfiguration.values || [];
    }
    constructor(renderer, cdr) {
      this.renderer = renderer;
      this.cdr = cdr;
      /**
       * Gets/sets whether the columns panel is expanded
       * Get
       * ```typescript
       *  const columnsPanelState: boolean = this.dataSelector.columnsExpanded;
       * ```
       * Set
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [columnsExpanded]="columnsPanelState"></igx-pivot-data-selector>
       * ```
       *
       * Two-way data binding:
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [(columnsExpanded)]="columnsPanelState"></igx-pivot-data-selector>
       * ```
       */
      this.columnsExpanded = true;
      /**
       * @hidden
       */
      this.columnsExpandedChange = new EventEmitter();
      /**
       * Gets/sets whether the rows panel is expanded
       * Get
       * ```typescript
       *  const rowsPanelState: boolean = this.dataSelector.rowsExpanded;
       * ```
       * Set
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [rowsExpanded]="rowsPanelState"></igx-pivot-data-selector>
       * ```
       *
       * Two-way data binding:
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [(rowsExpanded)]="rowsPanelState"></igx-pivot-data-selector>
       * ```
       */
      this.rowsExpanded = true;
      /**
       * @hidden
       */
      this.rowsExpandedChange = new EventEmitter();
      /**
       * Gets/sets whether the filters panel is expanded
       * Get
       * ```typescript
       *  const filtersPanelState: boolean = this.dataSelector.filtersExpanded;
       * ```
       * Set
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [filtersExpanded]="filtersPanelState"></igx-pivot-data-selector>
       * ```
       *
       * Two-way data binding:
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [(filtersExpanded)]="filtersPanelState"></igx-pivot-data-selector>
       * ```
       */
      this.filtersExpanded = true;
      /**
       * @hidden
       */
      this.filtersExpandedChange = new EventEmitter();
      /**
       * Gets/sets whether the values panel is expanded
       * Get
       * ```typescript
       *  const valuesPanelState: boolean = this.dataSelector.valuesExpanded;
       * ```
       * Set
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [valuesExpanded]="valuesPanelState"></igx-pivot-data-selector>
       * ```
       *
       * Two-way data binding:
       * ```html
       * <igx-pivot-data-selector [grid]="grid1" [(valuesExpanded)]="valuesPanelState"></igx-pivot-data-selector>
       * ```
       */
      this.valuesExpanded = true;
      /**
       * @hidden
       */
      this.valuesExpandedChange = new EventEmitter();
      this._dropDelta = 0;
      /** @hidden @internal **/
      this.cssClass = "igx-pivot-data-selector";
      this._subMenuPositionSettings = {
        verticalStartPoint: VerticalAlignment.Bottom,
        closeAnimation: undefined
      };
      this._subMenuOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        positionStrategy: new AutoPositionStrategy(this._subMenuPositionSettings),
        scrollStrategy: new AbsoluteScrollStrategy()
      };
      /* blazorSuppress */
      this.animationSettings = {
        closeAnimation: useAnimation(fadeOut, {
          params: {
            duration: "0ms"
          }
        }),
        openAnimation: useAnimation(fadeIn, {
          params: {
            duration: "0ms"
          }
        })
      };
      /** @hidden @internal */
      this.aggregateList = [];
      /**
       * @hidden @internal
       */
      this._panels = [{
        name: "Filters",
        i18n: 'igx_grid_pivot_selector_filters',
        type: PivotDimensionType.Filter,
        dataKey: "filterDimensions",
        icon: "filter_list",
        itemKey: "memberName",
        displayKey: 'displayName',
        sortable: false,
        dragChannels: ["Filters", "Columns", "Rows"]
      }, {
        name: "Columns",
        i18n: 'igx_grid_pivot_selector_columns',
        type: PivotDimensionType.Column,
        dataKey: "columnDimensions",
        icon: "view_column",
        itemKey: "memberName",
        displayKey: 'displayName',
        sortable: true,
        dragChannels: ["Filters", "Columns", "Rows"]
      }, {
        name: "Rows",
        i18n: 'igx_grid_pivot_selector_rows',
        type: PivotDimensionType.Row,
        dataKey: "rowDimensions",
        icon: "table_rows",
        itemKey: "memberName",
        displayKey: 'displayName',
        sortable: true,
        dragChannels: ["Filters", "Columns", "Rows"]
      }, {
        name: "Values",
        i18n: 'igx_grid_pivot_selector_values',
        type: null,
        dataKey: "values",
        icon: "functions",
        itemKey: "member",
        displayKey: 'displayName',
        sortable: false,
        dragChannels: ["Values"]
      }];
    }
    /* treatAsRef */
    /**
     * Sets the grid.
     */
    set grid(value) {
      this._grid = value;
    }
    /* treatAsRef */
    /**
     * Returns the grid.
     */
    get grid() {
      return this._grid;
    }
    /**
     * @hidden
     * @internal
     */
    onItemSort(_, dimension, dimensionType) {
      if (!this._panels.find(panel => panel.type === dimensionType).sortable) return;
      const startDirection = dimension.sortDirection || SortingDirection.None;
      const direction = startDirection + 1 > SortingDirection.Desc ? SortingDirection.None : startDirection + 1;
      this.grid.sortDimension(dimension, direction);
    }
    /**
     * @hidden
     * @internal
     */
    onFilteringIconPointerDown(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    /**
     * @hidden
     * @internal
     */
    onFilteringIconClick(event, dimension) {
      event.stopPropagation();
      event.preventDefault();
      let dim = dimension;
      let col;
      while (dim) {
        col = this.grid.dimensionDataColumns.find(x => x.field === dim.memberName);
        if (col) {
          break;
        } else {
          dim = dim.childLevel;
        }
      }
      this.grid.filteringService.toggleFilterDropdown(event.target, col);
    }
    /**
     * @hidden
     * @internal
     */
    getDimensionState(dimensionType) {
      switch (dimensionType) {
        case PivotDimensionType.Row:
          return this.grid.rowDimensions;
        case PivotDimensionType.Column:
          return this.grid.columnDimensions;
        case PivotDimensionType.Filter:
          return this.grid.filterDimensions;
        default:
          return null;
      }
    }
    /**
     * @hidden
     * @internal
     */
    moveValueItem(itemId) {
      const aggregation = this.grid.pivotConfiguration.values;
      const valueIndex = aggregation.findIndex(x => x.member === itemId) !== -1 ? aggregation?.findIndex(x => x.member === itemId) : aggregation.length;
      const newValueIndex = valueIndex + this._dropDelta < 0 ? 0 : valueIndex + this._dropDelta;
      const aggregationItem = aggregation.find(x => x.member === itemId || x.displayName === itemId);
      if (aggregationItem) {
        this.grid.moveValue(aggregationItem, newValueIndex);
        this.grid.valuesChange.emit({
          values: this.grid.pivotConfiguration.values
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    onItemDropped(event, dimensionType) {
      if (!this.dropAllowed) {
        return;
      }
      const dimension = this.grid.getDimensionsByType(dimensionType);
      const dimensionState = this.getDimensionState(dimensionType);
      const itemId = event.drag.element.nativeElement.id;
      const targetId = event.owner.element.nativeElement.id;
      const dimensionItem = dimension?.find(x => x.memberName === itemId);
      const itemIndex = dimension?.findIndex(x => x?.memberName === itemId) !== -1 ? dimension?.findIndex(x => x.memberName === itemId) : dimension?.length;
      const dimensions = this.grid.allDimensions.filter(x => x && x.memberName === itemId);
      const reorder = dimensionState?.findIndex(item => item.memberName === itemId) !== -1;
      let targetIndex = targetId !== "" ? dimension?.findIndex(x => x.memberName === targetId) : dimension?.length;
      if (!dimension) {
        this.moveValueItem(itemId);
      }
      if (reorder) {
        targetIndex = itemIndex + this._dropDelta < 0 ? 0 : itemIndex + this._dropDelta;
      }
      if (dimensionItem) {
        this.grid.moveDimension(dimensionItem, dimensionType, targetIndex);
      } else {
        const newDim = dimensions.find(x => x.memberName === itemId);
        this.grid.moveDimension(newDim, dimensionType, targetIndex);
      }
      this.grid.dimensionsChange.emit({
        dimensions: dimension,
        dimensionCollectionType: dimensionType
      });
    }
    /**
     * @hidden
     * @internal
     */
    updateDropDown(value, dropdown) {
      this.value = value;
      dropdown.width = "200px";
      this.aggregateList = PivotUtil.getAggregateList(value, this.grid);
      this.cdr.detectChanges();
      dropdown.open(this._subMenuOverlaySettings);
    }
    /**
     * @hidden
     * @internal
     */
    onSummaryClick(event, value, dropdown) {
      this._subMenuOverlaySettings.target = event.currentTarget;
      if (dropdown.collapsed) {
        this.updateDropDown(value, dropdown);
      } else {
        // close for previous chip
        dropdown.close();
        dropdown.closed.pipe(first$2()).subscribe(() => {
          this.updateDropDown(value, dropdown);
        });
      }
    }
    /**
     * @hidden
     * @internal
     */
    onAggregationChange(event) {
      if (!this.isSelected(event.newSelection.value)) {
        this.value.aggregate = event.newSelection.value;
        this.grid.pipeTrigger++;
        this.grid.cdr.markForCheck();
      }
    }
    /**
     * @hidden
     * @internal
     */
    isSelected(val) {
      return this.value.aggregate.key === val.key;
    }
    /**
     * @hidden
     * @internal
     */
    ghostCreated(event, value) {
      const {
        width: itemWidth
      } = event.owner.element.nativeElement.getBoundingClientRect();
      this.ghostWidth = itemWidth;
      this.ghostText = value;
      this.renderer.setStyle(event.owner.element.nativeElement, "position", "absolute");
      this.renderer.setStyle(event.owner.element.nativeElement, "visibility", "hidden");
    }
    /**
     * @hidden
     * @internal
     */
    toggleItem(item) {
      if (item) {
        this.grid.toggleValue(item);
      }
      if (item) {
        this.grid.toggleDimension(item);
      }
    }
    /**
     * @hidden
     * @internal
     */
    onPanelEntry(event, panel) {
      this.dropAllowed = event.dragData.gridID === this.grid.id && event.dragData.selectorChannels?.some(channel => channel === panel);
    }
    /**
     * @hidden
     * @internal
     */
    onItemDragMove(event) {
      const clientRect = event.owner.element.nativeElement.getBoundingClientRect();
      this._dropDelta = Math.round((event.nextPageY - event.startY) / clientRect.height);
    }
    /**
     * @hidden
     * @internal
     */
    onItemDragEnd(event) {
      this.renderer.setStyle(event.owner.element.nativeElement, "position", "static");
      this.renderer.setStyle(event.owner.element.nativeElement, "visibility", "visible");
    }
    /**
     * @hidden
     * @internal
     */
    onItemDragOver(event) {
      if (this.dropAllowed) {
        this.renderer.addClass(event.owner.element.nativeElement, "igx-drag--push");
      }
    }
    /**
     * @hidden
     * @internal
     */
    onItemDragLeave(event) {
      if (this.dropAllowed) {
        this.renderer.removeClass(event.owner.element.nativeElement, "igx-drag--push");
      }
    }
    /**
     * @hidden
     * @internal
     */
    getPanelCollapsed(panelType) {
      switch (panelType) {
        case PivotDimensionType.Column:
          return !this.columnsExpanded;
        case PivotDimensionType.Filter:
          return !this.filtersExpanded;
        case PivotDimensionType.Row:
          return !this.rowsExpanded;
        default:
          return !this.valuesExpanded;
      }
    }
    /**
     * @hidden
     * @internal
     */
    onCollapseChange(value, panelType) {
      switch (panelType) {
        case PivotDimensionType.Column:
          this.columnsExpanded = !value;
          this.columnsExpandedChange.emit(this.columnsExpanded);
          break;
        case PivotDimensionType.Filter:
          this.filtersExpanded = !value;
          this.filtersExpandedChange.emit(this.filtersExpanded);
          break;
        case PivotDimensionType.Row:
          this.rowsExpanded = !value;
          this.rowsExpandedChange.emit(this.rowsExpanded);
          break;
        default:
          this.valuesExpanded = !value;
          this.valuesExpandedChange.emit(this.valuesExpanded);
      }
    }
    static {
      this.ɵfac = function IgxPivotDataSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotDataSelectorComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxPivotDataSelectorComponent,
        selectors: [["igx-pivot-data-selector"]],
        hostVars: 4,
        hostBindings: function IgxPivotDataSelectorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--ig-size", ctx.size);
            i0.ɵɵclassProp("igx-pivot-data-selector", ctx.cssClass);
          }
        },
        inputs: {
          columnsExpanded: [2, "columnsExpanded", "columnsExpanded", booleanAttribute],
          rowsExpanded: [2, "rowsExpanded", "rowsExpanded", booleanAttribute],
          filtersExpanded: [2, "filtersExpanded", "filtersExpanded", booleanAttribute],
          valuesExpanded: [2, "valuesExpanded", "valuesExpanded", booleanAttribute],
          grid: "grid"
        },
        outputs: {
          columnsExpandedChange: "columnsExpandedChange",
          rowsExpandedChange: "rowsExpandedChange",
          filtersExpandedChange: "filtersExpandedChange",
          valuesExpandedChange: "valuesExpandedChange"
        },
        decls: 21,
        vars: 8,
        consts: [["input", ""], ["dropdown", ""], ["itemGhost", ""], [1, "igx-pivot-data-selector__filter"], ["type", "box"], ["family", "default", "name", "search", "igxPrefix", ""], ["igxInput", "", "tabindex", "0", "placeholder", "Search", "autocomplete", "off"], [3, "id"], [3, "animationSettings", "collapsed"], [3, "selectionChanging"], [3, "selected", "value"], [3, "click", "aria-labelledby", "disableRipple", "checked"], [3, "collapsedChange", "animationSettings", "collapsed"], ["iconPosition", "left", "igxDrop", "", 3, "enter", "dropped", "disabled"], [1, "igx-pivot-data-selector__header"], [1, "igx-pivot-data-selector__header-title"], [1, "igx-pivot-data-selector__header-extra"], ["family", "default", 3, "name"], ["igxDrop", "", 3, "enter", "dropped"], [1, "igx-pivot-data-selector__empty"], ["igxDrop", "", 3, "igxDrag", "ghostTemplate", "id"], ["igxDrop", "", 3, "ghostCreate", "over", "leave", "dragMove", "dragEnd", "dropped", "igxDrag", "ghostTemplate", "id"], [1, "igx-pivot-data-selector__item"], [1, "igx-pivot-data-selector__item-start", 3, "click"], [1, "igx-pivot-data-selector__item-text"], ["family", "default", 1, "igx-pivot-data-selector__action-sort", 3, "name"], [1, "igx-pivot-data-selector__item-end"], ["family", "default", "name", "filter_list", 1, "igx-pivot-data-selector__action-filter"], ["family", "default", "name", "functions", 1, "igx-pivot-data-selector__action-summary", 3, "igxDropDownItemNavigation"], ["family", "default", "name", "drag_indicator", "igxDragHandle", "", 1, "igx-pivot-data-selector__action-move"], ["family", "default", "name", "filter_list", 1, "igx-pivot-data-selector__action-filter", 3, "pointerdown", "click"], ["family", "default", "name", "functions", 1, "igx-pivot-data-selector__action-summary", 3, "click", "igxDropDownItemNavigation"], [1, "igx-pivot-data-selector__item-ghost"], [1, "igx-pivot-data-selector__item-ghost-text"], ["family", "default", "name", "import_export"], ["family", "default", "name", "drag_indicator"]],
        template: function IgxPivotDataSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3)(1, "igx-input-group", 4);
            i0.ɵɵelement(2, "igx-icon", 5)(3, "input", 6, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "igx-list");
            i0.ɵɵrepeaterCreate(6, IgxPivotDataSelectorComponent_For_7_Template, 4, 5, "igx-list-item", 7, _forTrack13);
            i0.ɵɵpipe(8, "filterPivotItems");
            i0.ɵɵrepeaterCreate(9, IgxPivotDataSelectorComponent_For_10_Template, 4, 5, "igx-list-item", 7, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵpipe(11, "filterPivotItems");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "igx-accordion");
            i0.ɵɵrepeaterCreate(13, IgxPivotDataSelectorComponent_For_14_Template, 12, 8, "igx-expansion-panel", 8, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "igx-drop-down", 9, 1);
            i0.ɵɵlistener("selectionChanging", function IgxPivotDataSelectorComponent_Template_igx_drop_down_selectionChanging_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onAggregationChange($event));
            });
            i0.ɵɵrepeaterCreate(17, IgxPivotDataSelectorComponent_For_18_Template, 2, 3, "igx-drop-down-item", 10, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(19, IgxPivotDataSelectorComponent_ng_template_19_Template, 6, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const input_r16 = i0.ɵɵreference(4);
            i0.ɵɵadvance(6);
            i0.ɵɵrepeater(i0.ɵɵpipeBind3(8, 0, ctx.dims, input_r16.value, ctx.grid == null ? null : ctx.grid.pipeTrigger));
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(i0.ɵɵpipeBind3(11, 4, ctx.values, input_r16.value, ctx.grid == null ? null : ctx.grid.pipeTrigger));
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx._panels);
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.aggregateList);
          }
        },
        dependencies: [IgxInputGroupComponent, IgxIconComponent, IgxPrefixDirective, IgxInputDirective, IgxListComponent, IgxListItemComponent, IgxCheckboxComponent, IgxAccordionComponent, IgxExpansionPanelComponent, IgxExpansionPanelHeaderComponent, IgxDropDirective, IgxExpansionPanelTitleDirective, IgxChipComponent, IgxExpansionPanelBodyComponent, IgxDragDirective, IgxDropDownItemNavigationDirective, IgxDragHandleDirective, IgxDropDownComponent, IgxDropDownItemComponent, IgxFilterPivotItemsPipe],
        encapsulation: 2
      });
    }
  }
  return IgxPivotDataSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Pivot grid directives collection for ease-of-use import in standalone components scenario */
const IGX_PIVOT_GRID_DIRECTIVES = [IgxPivotGridComponent, IgxPivotDataSelectorComponent, IgxPivotValueChipTemplateDirective,
// IGX_GRID_COMMON_DIRECTIVES:
IgxRowDirective, IgxGridFooterComponent, IgxAdvancedFilteringDialogComponent, IgxRowExpandedIndicatorDirective, IgxRowCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHeaderCollapsedIndicatorDirective, IgxExcelStyleHeaderIconDirective, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxDragIndicatorIconDirective, IgxRowDragGhostDirective, IgxGridStateDirective,
// IGX_GRID_HEADERS_DIRECTIVES:
IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent,
// IGX_GRID_COLUMN_DIRECTIVES:
IgxFilterCellTemplateDirective, IgxSummaryTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCellHeaderTemplateDirective, IgxCellFooterTemplateDirective, IgxCellEditorTemplateDirective, IgxCollapsibleIndicatorTemplateDirective, IgxColumnComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent,
// IGX_GRID_COLUMN_ACTIONS_DIRECTIVES:
IgxColumnActionsComponent, IgxColumnHidingDirective, IgxColumnPinningDirective,
// IGX_GRID_SELECTION_DIRECTIVES:
IgxRowSelectorDirective, IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective,
// IGX_GRID_TOOLBAR_DIRECTIVES:
IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridToolbarDirective,
// IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES:
IgxGridExcelStyleFilteringComponent, IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleMovingComponent, IgxExcelStyleSearchComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleLoadingValuesTemplateDirective];
let IgxTreeGridAPIService = /*#__PURE__*/(() => {
  class IgxTreeGridAPIService extends GridBaseAPIService {
    get_all_data(transactions) {
      const grid = this.grid;
      let data = grid && grid.flatData ? grid.flatData : [];
      data = transactions ? grid.dataWithAddedInTransactionRows : data;
      return data;
    }
    get_summary_data() {
      const grid = this.grid;
      const data = grid.processedRootRecords?.filter(row => row.isFilteredOutParent === undefined || row.isFilteredOutParent === false).map(rec => rec.data);
      if (data && grid.transactions.enabled) {
        const deletedRows = grid.transactions.getTransactionLog().filter(t => t.type === TransactionType.DELETE).map(t => t.id);
        deletedRows.forEach(rowID => {
          const tempData = grid.primaryKey ? data.map(rec => rec[grid.primaryKey]) : data;
          const index = tempData.indexOf(rowID);
          if (index !== -1) {
            data.splice(index, 1);
          }
        });
      }
      return data;
    }
    allow_expansion_state_change(rowID, expanded) {
      const grid = this.grid;
      const row = grid.records.get(rowID);
      if (row.expanded === expanded || (!row.children || !row.children.length) && (!grid.loadChildrenOnDemand || grid.hasChildrenKey && !row.data[grid.hasChildrenKey])) {
        return false;
      }
      return true;
    }
    expand_path_to_record(record) {
      const grid = this.grid;
      const expandedStates = grid.expansionStates;
      while (record.parent) {
        record = record.parent;
        const expanded = this.get_row_expansion_state(record);
        if (!expanded) {
          expandedStates.set(record.key, true);
        }
      }
      grid.expansionStates = expandedStates;
      if (grid.rowEditable) {
        grid.gridAPI.crudService.endEdit(false);
      }
    }
    get_row_expansion_state(record) {
      const grid = this.grid;
      const states = grid.expansionStates;
      const expanded = states.get(record.key);
      if (expanded !== undefined) {
        return expanded;
      } else {
        return record.children && record.children.length && record.level < grid.expansionDepth;
      }
    }
    should_apply_number_style(column) {
      return column.dataType === GridColumnDataType.Number && column.visibleIndex !== 0;
    }
    deleteRowById(rowID) {
      const treeGrid = this.grid;
      const flatDataWithCascadeOnDeleteAndTransactions = treeGrid.primaryKey && treeGrid.foreignKey && treeGrid.cascadeOnDelete && treeGrid.transactions.enabled;
      if (flatDataWithCascadeOnDeleteAndTransactions) {
        treeGrid.transactions.startPending();
      }
      const record = super.deleteRowById(rowID);
      if (flatDataWithCascadeOnDeleteAndTransactions) {
        treeGrid.transactions.endPending(true);
      }
      return record;
    }
    deleteRowFromData(rowID, index) {
      const treeGrid = this.grid;
      const record = treeGrid.records.get(rowID);
      if (treeGrid.primaryKey && treeGrid.foreignKey) {
        index = treeGrid.primaryKey ? treeGrid.data.map(c => c[treeGrid.primaryKey]).indexOf(rowID) : treeGrid.data.indexOf(rowID);
        super.deleteRowFromData(rowID, index);
        if (treeGrid.cascadeOnDelete) {
          if (record && record.children) {
            for (const child of record.children) {
              super.deleteRowById(child.key);
            }
          }
        }
      } else {
        const collection = record.parent ? record.parent.data[treeGrid.childDataKey] : treeGrid.data;
        index = treeGrid.primaryKey ? collection.map(c => c[treeGrid.primaryKey]).indexOf(rowID) : collection.indexOf(rowID);
        const selectedChildren = [];
        this.get_selected_children(record, selectedChildren);
        if (selectedChildren.length > 0) {
          treeGrid.deselectRows(selectedChildren);
        }
        if (treeGrid.transactions.enabled) {
          const path = treeGrid.generateRowPath(rowID);
          treeGrid.transactions.add({
            id: rowID,
            type: TransactionType.DELETE,
            newValue: null,
            path
          }, collection[index]);
        } else {
          collection.splice(index, 1);
        }
        this.grid.validation.clear(rowID);
      }
    }
    get_selected_children(record, selectedRowIDs) {
      const grid = this.grid;
      if (!record.children || record.children.length === 0) {
        return;
      }
      for (const child of record.children) {
        if (grid.selectionService.isRowSelected(child.key)) {
          selectedRowIDs.push(child.key);
        }
        this.get_selected_children(child, selectedRowIDs);
      }
    }
    row_deleted_transaction(rowID) {
      return this.row_deleted_parent(rowID) || super.row_deleted_transaction(rowID);
    }
    get_rec_by_id(rowID) {
      return this.grid.records.get(rowID);
    }
    /**
     * Returns the index of the record in the data view by pk or -1 if not found or primaryKey is not set.
     *
     * @param pk
     * @param dataCollection
     */
    get_rec_index_by_id(pk, dataCollection) {
      dataCollection = dataCollection || this.grid.data;
      return this.grid.primaryKey ? dataCollection.findIndex(rec => rec.data[this.grid.primaryKey] === pk) : -1;
    }
    addRowToData(data, parentRowID) {
      if (parentRowID !== undefined && parentRowID !== null) {
        const state = this.grid.transactions.getState(parentRowID);
        // we should not allow adding of rows as child of deleted row
        if (state && state.type === TransactionType.DELETE) {
          throw Error(`Cannot add child row to deleted parent row`);
        }
        const parentRecord = this.grid.records.get(parentRowID);
        if (!parentRecord) {
          throw Error('Invalid parent row ID!');
        }
        this.grid.summaryService.clearSummaryCache({
          rowID: parentRecord.key
        });
        if (this.grid.primaryKey && this.grid.foreignKey) {
          data[this.grid.foreignKey] = parentRowID;
          super.addRowToData(data);
        } else {
          const parentData = parentRecord.data;
          const childKey = this.grid.childDataKey;
          if (this.grid.transactions.enabled) {
            const rowId = this.grid.primaryKey ? data[this.grid.primaryKey] : data;
            const path = [];
            path.push(...this.grid.generateRowPath(parentRowID));
            path.push(parentRowID);
            this.grid.transactions.add({
              id: rowId,
              path,
              newValue: data,
              type: TransactionType.ADD
            }, null);
          } else {
            if (!parentData[childKey]) {
              parentData[childKey] = [];
            }
            parentData[childKey].push(data);
          }
        }
      } else {
        super.addRowToData(data);
      }
    }
    filterDataByExpressions(expressionsTree) {
      const records = this.filterTreeDataByExpressions(expressionsTree);
      const data = [];
      this.getFlatDataFromFilteredRecords(records, data);
      return data;
    }
    sortDataByExpressions(data, expressions) {
      const records = DataUtil.sort(cloneArray(data), expressions, this.grid.sortStrategy ?? new IgxDataRecordSorting(), this.grid);
      return records.map(r => r.data);
    }
    filterTreeDataByExpressions(expressionsTree) {
      let records = this.grid.rootRecords;
      if (expressionsTree.filteringOperands.length) {
        const state = {
          expressionsTree,
          strategy: this.grid.filterStrategy ?? new TreeGridFilteringStrategy()
        };
        records = FilterUtil.filter(cloneArray(records), state, this.grid);
      }
      return records;
    }
    update_row_in_array(value, rowID, index) {
      const grid = this.grid;
      if (grid.primaryKey && grid.foreignKey) {
        super.update_row_in_array(value, rowID, index);
      } else {
        const record = grid.records.get(rowID);
        const childData = record.parent ? record.parent.data[grid.childDataKey] : grid.data;
        index = grid.primaryKey ? childData.map(c => c[grid.primaryKey]).indexOf(rowID) : childData.indexOf(rowID);
        childData[index] = value;
      }
    }
    /**
     * Updates related row of provided grid's data source with provided new row value
     *
     * @param grid Grid to update data for
     * @param rowID ID of the row to update
     * @param rowValueInDataSource Initial value of the row as it is in data source
     * @param rowCurrentValue Current value of the row as it is with applied previous transactions
     * @param rowNewValue New value of the row
     */
    updateData(grid, rowID, rowValueInDataSource, rowCurrentValue, rowNewValue) {
      if (grid.transactions.enabled) {
        const path = grid.generateRowPath(rowID);
        const transaction = {
          id: rowID,
          type: TransactionType.UPDATE,
          newValue: rowNewValue,
          path
        };
        grid.transactions.add(transaction, rowCurrentValue);
      } else {
        mergeObjects(rowValueInDataSource, rowNewValue);
      }
    }
    row_deleted_parent(rowID) {
      const grid = this.grid;
      if (!grid) {
        return false;
      }
      if (grid.cascadeOnDelete && grid.foreignKey || grid.childDataKey) {
        let node = grid.records.get(rowID);
        while (node) {
          const state = grid.transactions.getState(node.key);
          if (state && state.type === TransactionType.DELETE) {
            return true;
          }
          node = node.parent;
        }
      }
      return false;
    }
    getFlatDataFromFilteredRecords(records, data) {
      if (!records || records.length === 0) {
        return;
      }
      for (const record of records) {
        if (!record.isFilteredOutParent) {
          data.push(record);
        }
        this.getFlatDataFromFilteredRecords(record.children, data);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTreeGridAPIService_BaseFactory;
        return function IgxTreeGridAPIService_Factory(__ngFactoryType__) {
          return (ɵIgxTreeGridAPIService_BaseFactory || (ɵIgxTreeGridAPIService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTreeGridAPIService)))(__ngFactoryType__ || IgxTreeGridAPIService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTreeGridAPIService,
        factory: IgxTreeGridAPIService.ɵfac
      });
    }
  }
  return IgxTreeGridAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxRowLoadingIndicatorTemplateDirective = /*#__PURE__*/(() => {
  class IgxRowLoadingIndicatorTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxRowLoadingIndicatorTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowLoadingIndicatorTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxRowLoadingIndicatorTemplateDirective,
        selectors: [["", "igxRowLoadingIndicator", ""]]
      });
    }
  }
  return IgxRowLoadingIndicatorTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTreeGridSelectionService = /*#__PURE__*/(() => {
  class IgxTreeGridSelectionService extends IgxGridSelectionService {
    /** Select specified rows. No event is emitted. */
    selectRowsWithNoEvent(rowIDs, clearPrevSelection) {
      if (this.grid && this.grid.rowSelection === GridSelectionMode.multipleCascade) {
        this.cascadeSelectRowsWithNoEvent(rowIDs, clearPrevSelection);
        return;
      }
      super.selectRowsWithNoEvent(rowIDs, clearPrevSelection);
    }
    /** Deselect specified rows. No event is emitted. */
    deselectRowsWithNoEvent(rowIDs) {
      if (this.grid.rowSelection === GridSelectionMode.multipleCascade) {
        this.cascadeDeselectRowsWithNoEvent(rowIDs);
        return;
      }
      super.deselectRowsWithNoEvent(rowIDs);
    }
    emitRowSelectionEvent(newSelection, added, removed, event) {
      if (this.grid.rowSelection === GridSelectionMode.multipleCascade) {
        this.emitCascadeRowSelectionEvent(newSelection, added, removed, event);
        return;
      }
      super.emitRowSelectionEvent(newSelection, added, removed, event);
    }
    updateCascadeSelectionOnFilterAndCRUD(parents, crudRowID, visibleRowIDs = null) {
      if (visibleRowIDs === null) {
        // if the tree grid has flat structure
        // do not explicitly handle the selection state of the rows
        if (!parents.size) {
          return;
        }
        visibleRowIDs = new Set(this.getRowIDs(this.allData));
        this.rowsToBeSelected = new Set(this.rowSelection);
        this.rowsToBeIndeterminate = new Set(this.indeterminateRows);
        if (crudRowID) {
          this.rowSelection.delete(crudRowID);
        }
      }
      if (!parents.size) {
        this.rowSelection = new Set(this.rowsToBeSelected);
        this.indeterminateRows = new Set(this.rowsToBeIndeterminate);
        // TODO: emit selectionChangeD event, calculate its args through the handleAddedAndRemovedArgs method
        this.clearHeaderCBState();
        this.selectedRowsChange.next(this.getSelectedRows());
        return;
      }
      const newParents = new Set();
      parents.forEach(parent => {
        this.handleRowSelectionState(parent, visibleRowIDs);
        if (parent && parent.parent) {
          newParents.add(parent.parent);
        }
      });
      this.updateCascadeSelectionOnFilterAndCRUD(newParents, null, visibleRowIDs);
    }
    cascadeSelectRowsWithNoEvent(rowIDs, clearPrevSelection) {
      if (clearPrevSelection) {
        this.indeterminateRows.clear();
        this.rowSelection.clear();
        this.calculateRowsNewSelectionState({
          added: rowIDs,
          removed: []
        });
      } else {
        const oldSelection = this.getSelectedRows();
        const newSelection = [...oldSelection, ...rowIDs];
        const args = {
          oldSelection,
          newSelection
        };
        // retrieve only the rows without their parents/children which has to be added to the selection
        this.handleAddedAndRemovedArgs(args);
        this.calculateRowsNewSelectionState(args);
      }
      this.rowSelection = new Set(this.rowsToBeSelected);
      this.indeterminateRows = new Set(this.rowsToBeIndeterminate);
      this.clearHeaderCBState();
      this.selectedRowsChange.next(this.getSelectedRows());
    }
    cascadeDeselectRowsWithNoEvent(rowIDs) {
      const args = {
        added: [],
        removed: rowIDs
      };
      this.calculateRowsNewSelectionState(args);
      this.rowSelection = new Set(this.rowsToBeSelected);
      this.indeterminateRows = new Set(this.rowsToBeIndeterminate);
      this.clearHeaderCBState();
      this.selectedRowsChange.next(this.getSelectedRows());
    }
    get selectionService() {
      return this.grid.selectionService;
    }
    emitCascadeRowSelectionEvent(newSelection, added, removed, event) {
      const currSelection = this.getSelectedRows();
      if (this.areEqualCollections(currSelection, newSelection)) {
        return;
      }
      const args = {
        owner: this.grid,
        oldSelection: this.getSelectedRowsData(),
        newSelection,
        added,
        removed,
        event,
        cancel: false
      };
      this.calculateRowsNewSelectionState(args, !!this.grid.primaryKey);
      args.newSelection = Array.from(this.grid.gridAPI.get_all_data().filter(r => this.rowsToBeSelected.has(this.grid.primaryKey ? r[this.grid.primaryKey] : r)));
      // retrieve rows/parents/children which has been added/removed from the selection
      this.handleAddedAndRemovedArgs(args);
      this.grid.rowSelectionChanging.emit(args);
      if (args.cancel) {
        return;
      }
      const newSelectionIDs = args.newSelection.map(r => this.grid.primaryKey ? r[this.grid.primaryKey] : r);
      // if args.newSelection hasn't been modified
      if (this.areEqualCollections(Array.from(this.rowsToBeSelected), newSelectionIDs)) {
        this.rowSelection = new Set(this.rowsToBeSelected);
        this.indeterminateRows = new Set(this.rowsToBeIndeterminate);
        this.clearHeaderCBState();
        this.selectedRowsChange.next(this.getSelectedRows());
      } else {
        // select the rows within the modified args.newSelection with no event
        this.cascadeSelectRowsWithNoEvent(newSelectionIDs, true);
      }
    }
    /**
     * retrieve the rows which should be added/removed to/from the old selection
     */
    handleAddedAndRemovedArgs(args) {
      const newSelectionSet = new Set(args.newSelection);
      const oldSelectionSet = new Set(args.oldSelection);
      args.removed = args.oldSelection.filter(x => !newSelectionSet.has(x));
      args.added = args.newSelection.filter(x => !oldSelectionSet.has(x));
    }
    /**
     * adds to rowsToBeProcessed set all visible children of the rows which was initially within the rowsToBeProcessed set
     *
     * @param rowsToBeProcessed set of the rows (without their parents/children) to be selected/deselected
     * @param visibleRowIDs list of all visible rowIds
     * @returns a new set with all direct parents of the rows within rowsToBeProcessed set
     */
    collectRowsChildrenAndDirectParents(rowsToBeProcessed, visibleRowIDs, adding, shouldConvert) {
      const processedRowsParents = new Set();
      Array.from(rowsToBeProcessed).forEach(row => {
        const rowID = shouldConvert ? row[this.grid.primaryKey] : row;
        this.selectDeselectRow(rowID, adding);
        const rowTreeRecord = this.grid.gridAPI.get_rec_by_id(rowID);
        const rowAndAllChildren = this.get_all_children(rowTreeRecord);
        rowAndAllChildren.forEach(r => {
          if (visibleRowIDs.has(r.key)) {
            this.selectDeselectRow(r.key, adding);
          }
        });
        if (rowTreeRecord && rowTreeRecord.parent) {
          processedRowsParents.add(rowTreeRecord.parent);
        }
      });
      return processedRowsParents;
    }
    /**
     * populates the rowsToBeSelected and rowsToBeIndeterminate sets
     * with the rows which will be eventually in selected/indeterminate state
     */
    calculateRowsNewSelectionState(args, shouldConvert = false) {
      this.rowsToBeSelected = new Set(args.oldSelection ? shouldConvert ? args.oldSelection.map(r => r[this.grid.primaryKey]) : args.oldSelection : this.getSelectedRows());
      this.rowsToBeIndeterminate = new Set(this.getIndeterminateRows());
      const visibleRowIDs = new Set(this.getRowIDs(this.allData));
      const removed = new Set(args.removed);
      const added = new Set(args.added);
      if (removed && removed.size) {
        let removedRowsParents = new Set();
        removedRowsParents = this.collectRowsChildrenAndDirectParents(removed, visibleRowIDs, false, shouldConvert);
        Array.from(removedRowsParents).forEach(parent => {
          this.handleParentSelectionState(parent, visibleRowIDs);
        });
      }
      if (added && added.size) {
        let addedRowsParents = new Set();
        addedRowsParents = this.collectRowsChildrenAndDirectParents(added, visibleRowIDs, true, shouldConvert);
        Array.from(addedRowsParents).forEach(parent => {
          this.handleParentSelectionState(parent, visibleRowIDs);
        });
      }
    }
    /**
     * recursively handle the selection state of the direct and indirect parents
     */
    handleParentSelectionState(treeRow, visibleRowIDs) {
      if (!treeRow) {
        return;
      }
      this.handleRowSelectionState(treeRow, visibleRowIDs);
      if (treeRow.parent) {
        this.handleParentSelectionState(treeRow.parent, visibleRowIDs);
      }
    }
    /**
     * Handle the selection state of a given row based the selection states of its direct children
     */
    handleRowSelectionState(treeRow, visibleRowIDs) {
      let visibleChildren = [];
      if (treeRow && treeRow.children) {
        visibleChildren = treeRow.children.filter(child => visibleRowIDs.has(child.key));
      }
      if (visibleChildren.length) {
        if (visibleChildren.every(row => this.rowsToBeSelected.has(row.key))) {
          this.selectDeselectRow(treeRow.key, true);
        } else if (visibleChildren.some(row => this.rowsToBeSelected.has(row.key) || this.rowsToBeIndeterminate.has(row.key))) {
          this.rowsToBeIndeterminate.add(treeRow.key);
          this.rowsToBeSelected.delete(treeRow.key);
        } else {
          this.selectDeselectRow(treeRow.key, false);
        }
      } else {
        // if the children of the row has been deleted and the row was selected do not change its state
        if (this.isRowSelected(treeRow.key)) {
          this.selectDeselectRow(treeRow.key, true);
        } else {
          this.selectDeselectRow(treeRow.key, false);
        }
      }
    }
    get_all_children(record) {
      const children = [];
      if (record && record.children && record.children.length) {
        for (const child of record.children) {
          children.push(...this.get_all_children(child));
          children.push(child);
        }
      }
      return children;
    }
    selectDeselectRow(rowID, select) {
      if (select) {
        this.rowsToBeSelected.add(rowID);
        this.rowsToBeIndeterminate.delete(rowID);
      } else {
        this.rowsToBeSelected.delete(rowID);
        this.rowsToBeIndeterminate.delete(rowID);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTreeGridSelectionService_BaseFactory;
        return function IgxTreeGridSelectionService_Factory(__ngFactoryType__) {
          return (ɵIgxTreeGridSelectionService_BaseFactory || (ɵIgxTreeGridSelectionService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTreeGridSelectionService)))(__ngFactoryType__ || IgxTreeGridSelectionService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxTreeGridSelectionService,
        factory: IgxTreeGridSelectionService.ɵfac
      });
    }
  }
  return IgxTreeGridSelectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * An internal component representing the group-by drop area for the igx-grid component.
 *
 * @hidden @internal
 */
let IgxTreeGridGroupByAreaComponent = /*#__PURE__*/(() => {
  class IgxTreeGridGroupByAreaComponent extends IgxGroupByAreaDirective {
    get hideGroupedColumns() {
      return this._hideGroupedColumns;
    }
    set hideGroupedColumns(value) {
      if (this.grid?.columns && this.expressions) {
        this.setColumnsVisibility(value);
      }
      this._hideGroupedColumns = value;
    }
    constructor(differs, ref, platform) {
      super(ref, platform);
      this.differs = differs;
      this._hideGroupedColumns = false;
      this.destroy$ = new Subject();
    }
    ngAfterContentInit() {
      if (this.grid.columns && this.expressions) {
        this.groupingDiffer = this.differs.find(this.expressions).create();
        this.updateColumnsVisibility();
      }
      this.grid.sortingExpressionsChange.pipe(takeUntil(this.destroy$)).subscribe(sortingExpressions => {
        if (!this.expressions || !this.expressions.length) {
          return;
        }
        let changed = false;
        sortingExpressions.forEach(sortExpr => {
          const fieldName = sortExpr.fieldName;
          const groupingExpr = this.expressions.find(ex => ex.fieldName === fieldName);
          if (groupingExpr && groupingExpr.dir !== sortExpr.dir) {
            groupingExpr.dir = sortExpr.dir;
            changed = true;
          }
        });
        if (changed) {
          this.expressions = [...this.expressions];
        }
      });
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    handleReorder(event) {
      const {
        chipsArray,
        originalEvent
      } = event;
      const newExpressions = this.getReorderedExpressions(chipsArray);
      this.chipExpressions = newExpressions;
      // When reordered using keyboard navigation, we don't have `onMoveEnd` event.
      if (originalEvent instanceof KeyboardEvent) {
        this.expressions = newExpressions;
      }
    }
    handleMoveEnd() {
      this.expressions = this.chipExpressions;
    }
    groupBy(expression) {
      this.expressions.push(expression);
      this.expressions = [...this.expressions];
    }
    clearGrouping(name) {
      this.expressions = this.expressions.filter(item => item.fieldName !== name);
      this.grid.sortingExpressions = this.grid.sortingExpressions.filter(item => item.fieldName !== name);
      this.grid.notifyChanges(true);
    }
    expressionsChanged() {
      this.updateColumnsVisibility();
    }
    updateColumnsVisibility() {
      if (this.groupingDiffer && this.grid.columns && !this.grid.hasColumnLayouts) {
        const changes = this.groupingDiffer.diff(this.expressions);
        if (changes && this.grid.columns.length > 0) {
          changes.forEachAddedItem(rec => {
            const col = this.grid.getColumnByName(rec.item.fieldName);
            col.hidden = this.hideGroupedColumns;
          });
          changes.forEachRemovedItem(rec => {
            const col = this.grid.getColumnByName(rec.item.fieldName);
            col.hidden = false;
          });
        }
      }
    }
    setColumnsVisibility(value) {
      if (this.grid.columns.length > 0 && !this.grid.hasColumnLayouts) {
        this.expressions.forEach(expr => {
          const col = this.grid.getColumnByName(expr.fieldName);
          col.hidden = value;
        });
      }
    }
    static {
      this.ɵfac = function IgxTreeGridGroupByAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridGroupByAreaComponent)(i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeGridGroupByAreaComponent,
        selectors: [["igx-tree-grid-group-by-area"]],
        inputs: {
          hideGroupedColumns: [2, "hideGroupedColumns", "hideGroupedColumns", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxGroupByAreaDirective,
          useExisting: IgxTreeGridGroupByAreaComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 3,
        consts: [["default", ""], [3, "reorder", "moveEnd"], ["igxGroupAreaDrop", "", 1, "igx-drop-area", 3, "igxDrop", "hidden"], [4, "ngTemplateOutlet"], [3, "keyDown", "remove", "chipClick", "id", "title", "removable", "draggable", "disabled"], ["family", "default", "igxSuffix", "", 3, "name"], [1, "igx-grid-grouparea__connector"], ["family", "default", "name", "arrow_forward", 3, "hidden"], ["family", "default", "name", "group_work", 1, "igx-drop-area__icon"], [1, "igx-drop-area__text"]],
        template: function IgxTreeGridGroupByAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "igx-chips-area", 1);
            i0.ɵɵlistener("reorder", function IgxTreeGridGroupByAreaComponent_Template_igx_chips_area_reorder_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleReorder($event));
            })("moveEnd", function IgxTreeGridGroupByAreaComponent_Template_igx_chips_area_moveEnd_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleMoveEnd());
            });
            i0.ɵɵrepeaterCreate(1, IgxTreeGridGroupByAreaComponent_For_2_Template, 11, 28, null, null, _forTrack11);
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵlistener("igxDrop", function IgxTreeGridGroupByAreaComponent_Template_div_igxDrop_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDragDrop($event));
            });
            i0.ɵɵtemplate(4, IgxTreeGridGroupByAreaComponent_ng_container_4_Template, 1, 0, "ng-container", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, IgxTreeGridGroupByAreaComponent_ng_template_5_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const default_r7 = i0.ɵɵreference(6);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.chipExpressions);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.dropAreaVisible);
            i0.ɵɵattribute("gridId", ctx.grid.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.dropAreaTemplate || default_r7);
          }
        },
        dependencies: [IgxChipsAreaComponent, IgxChipComponent, IgxIconComponent, IgxSuffixDirective, IgxGroupAreaDropDirective, IgxDropDirective, NgTemplateOutlet, IgxGroupByMetaPipe],
        encapsulation: 2
      });
    }
  }
  return IgxTreeGridGroupByAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxTreeGridSummaryPipe = /*#__PURE__*/(() => {
  class IgxTreeGridSummaryPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(flatData, hasSummary, summaryCalculationMode, summaryPosition, showSummaryOnCollapse, _, __) {
      if (!flatData || !hasSummary || summaryCalculationMode === GridSummaryCalculationMode.rootLevelOnly) {
        return flatData;
      }
      return this.addSummaryRows(this.grid, flatData, summaryPosition, showSummaryOnCollapse);
    }
    addSummaryRows(grid, collection, summaryPosition, showSummaryOnCollapse) {
      const recordsWithSummary = [];
      const maxSummaryHeight = grid.summaryService.calcMaxSummaryHeight();
      for (const record of collection) {
        recordsWithSummary.push(record);
        const isCollapsed = !record.expanded && record.children && record.children.length > 0 && showSummaryOnCollapse;
        if (isCollapsed) {
          let childData = record.children.filter(r => !r.isFilteredOutParent).map(r => r.data);
          childData = this.removeDeletedRecord(grid, record.key, childData);
          const summaries = grid.summaryService.calculateSummaries(record.key, childData);
          const summaryRecord = {
            summaries,
            max: maxSummaryHeight,
            cellIndentation: record.level + 1
          };
          recordsWithSummary.push(summaryRecord);
        }
        const isExpanded = record.children && record.children.length > 0 && record.expanded;
        if (summaryPosition === GridSummaryPosition.bottom && !isExpanded) {
          let childRecord = record;
          let parent = record.parent;
          while (parent) {
            const children = parent.children;
            if (children[children.length - 1] === childRecord) {
              let childData = children.filter(r => !r.isFilteredOutParent).map(r => r.data);
              childData = this.removeDeletedRecord(grid, parent.key, childData);
              const summaries = grid.summaryService.calculateSummaries(parent.key, childData);
              const summaryRecord = {
                summaries,
                max: maxSummaryHeight,
                cellIndentation: parent.level + 1
              };
              recordsWithSummary.push(summaryRecord);
              childRecord = parent;
              parent = childRecord.parent;
            } else {
              break;
            }
          }
        } else if (summaryPosition === GridSummaryPosition.top && isExpanded) {
          let childData = record.children.filter(r => !r.isFilteredOutParent).map(r => r.data);
          childData = this.removeDeletedRecord(grid, record.key, childData);
          const summaries = grid.summaryService.calculateSummaries(record.key, childData);
          const summaryRecord = {
            summaries,
            max: maxSummaryHeight,
            cellIndentation: record.level + 1
          };
          recordsWithSummary.push(summaryRecord);
        }
      }
      return recordsWithSummary;
    }
    removeDeletedRecord(grid, rowId, data) {
      if (!grid.transactions.enabled || !grid.cascadeOnDelete) {
        return data;
      }
      const deletedRows = grid.transactions.getTransactionLog().filter(t => t.type === 'delete').map(t => t.id);
      let row = grid.records.get(rowId);
      if (!row && deletedRows.lenght === 0) {
        return [];
      }
      row = row.children ? row : row.parent;
      while (row) {
        rowId = row.key;
        if (deletedRows.indexOf(rowId) !== -1) {
          return [];
        }
        row = row.parent;
      }
      deletedRows.forEach(rowID => {
        const tempData = grid.primaryKey ? data.map(rec => rec[grid.primaryKey]) : data;
        const index = tempData.indexOf(rowID);
        if (index !== -1) {
          data.splice(index, 1);
        }
      });
      return data;
    }
    static {
      this.ɵfac = function IgxTreeGridSummaryPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridSummaryPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridSummary",
        type: IgxTreeGridSummaryPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridSummaryPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let IgxTreeGridFilteringPipe = /*#__PURE__*/(() => {
  class IgxTreeGridFilteringPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(hierarchyData, expressionsTree, filterStrategy, advancedFilteringExpressionsTree, _, __, pinned) {
      const state = {
        expressionsTree,
        advancedExpressionsTree: advancedFilteringExpressionsTree,
        strategy: new TreeGridFilteringStrategy()
      };
      if (filterStrategy) {
        state.strategy = filterStrategy;
      }
      if (FilteringExpressionsTree.empty(state.expressionsTree) && FilteringExpressionsTree.empty(state.advancedExpressionsTree)) {
        this.grid.setFilteredData(null, pinned);
        return hierarchyData;
      }
      const result = this.filter(hierarchyData, state, this.grid);
      const filteredData = [];
      this.expandAllRecursive(this.grid, result, this.grid.expansionStates, filteredData);
      this.grid.setFilteredData(filteredData, pinned);
      return result;
    }
    expandAllRecursive(grid, data, expandedStates, filteredData) {
      for (const rec of data) {
        filteredData.push(rec.data);
        if (rec.children && rec.children.length > 0) {
          expandedStates.set(rec.key, true);
          this.expandAllRecursive(grid, rec.children, expandedStates, filteredData);
        }
      }
    }
    filter(data, state, grid) {
      return state.strategy.filter(data, state.expressionsTree, state.advancedExpressionsTree, grid);
    }
    static {
      this.ɵfac = function IgxTreeGridFilteringPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridFilteringPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridFiltering",
        type: IgxTreeGridFilteringPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridFilteringPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxTreeGridHierarchizingPipe = /*#__PURE__*/(() => {
  class IgxTreeGridHierarchizingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, primaryKey, foreignKey, childDataKey, _) {
      let hierarchicalRecords = [];
      const treeGridRecordsMap = new Map();
      const flatData = [];
      if (!collection || !collection.length) {
        this.grid.flatData = collection;
        this.grid.records = treeGridRecordsMap;
        this.grid.rootRecords = collection;
        return collection;
      }
      if (childDataKey) {
        hierarchicalRecords = this.hierarchizeRecursive(collection, primaryKey, childDataKey, undefined, flatData, 0, treeGridRecordsMap);
      } else if (primaryKey) {
        hierarchicalRecords = this.hierarchizeFlatData(collection, primaryKey, foreignKey, treeGridRecordsMap, flatData);
      }
      this.grid.flatData = this.grid.transactions.enabled ? flatData.filter(rec => {
        const state = this.grid.transactions.getState(this.getRowID(primaryKey, rec));
        return !state || state.type !== TransactionType.ADD;
      }) : flatData;
      this.grid.records = treeGridRecordsMap;
      this.grid.rootRecords = hierarchicalRecords;
      return hierarchicalRecords;
    }
    getRowID(primaryKey, rowData) {
      return primaryKey ? rowData[primaryKey] : rowData;
    }
    hierarchizeFlatData(collection, primaryKey, foreignKey, map, flatData) {
      const result = [];
      const missingParentRecords = [];
      collection.forEach(row => {
        const record = {
          key: this.getRowID(primaryKey, row),
          data: row,
          children: []
        };
        const parent = map.get(row[foreignKey]);
        if (parent) {
          record.parent = parent;
          parent.children.push(record);
        } else {
          missingParentRecords.push(record);
        }
        map.set(row[primaryKey], record);
      });
      missingParentRecords.forEach(record => {
        const parent = map.get(record.data[foreignKey]);
        if (parent) {
          record.parent = parent;
          parent.children.push(record);
        } else {
          result.push(record);
        }
      });
      this.setIndentationLevels(result, 0, flatData);
      return result;
    }
    setIndentationLevels(collection, indentationLevel, flatData) {
      for (const record of collection) {
        record.level = indentationLevel;
        record.expanded = this.grid.gridAPI.get_row_expansion_state(record);
        flatData.push(record.data);
        if (record.children && record.children.length > 0) {
          this.setIndentationLevels(record.children, indentationLevel + 1, flatData);
        }
      }
    }
    hierarchizeRecursive(collection, primaryKey, childDataKey, parent, flatData, indentationLevel, map) {
      const result = [];
      for (const item of collection) {
        const record = {
          key: this.getRowID(primaryKey, item),
          data: item,
          parent,
          level: indentationLevel
        };
        record.expanded = this.grid.gridAPI.get_row_expansion_state(record);
        flatData.push(item);
        map.set(record.key, record);
        record.children = item[childDataKey] ? this.hierarchizeRecursive(item[childDataKey], primaryKey, childDataKey, record, flatData, indentationLevel + 1, map) : undefined;
        result.push(record);
      }
      return result;
    }
    static {
      this.ɵfac = function IgxTreeGridHierarchizingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridHierarchizingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridHierarchizing",
        type: IgxTreeGridHierarchizingPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridHierarchizingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxTreeGridFlatteningPipe = /*#__PURE__*/(() => {
  class IgxTreeGridFlatteningPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, expandedLevels, expandedStates, _) {
      const data = [];
      this.grid.processedRootRecords = collection;
      this.grid.processedRecords = new Map();
      this.getFlatDataRecursive(collection, data, expandedLevels, expandedStates, true);
      this.grid.processedExpandedFlatData = data.map(r => r.data);
      return data;
    }
    getFlatDataRecursive(collection, data, expandedLevels, expandedStates, parentExpanded) {
      if (!collection || !collection.length) {
        return;
      }
      for (const hierarchicalRecord of collection) {
        if (parentExpanded) {
          data.push(hierarchicalRecord);
        }
        hierarchicalRecord.expanded = this.grid.gridAPI.get_row_expansion_state(hierarchicalRecord);
        this.updateNonProcessedRecordExpansion(this.grid, hierarchicalRecord);
        this.grid.processedRecords.set(hierarchicalRecord.key, hierarchicalRecord);
        this.getFlatDataRecursive(hierarchicalRecord.children, data, expandedLevels, expandedStates, parentExpanded && hierarchicalRecord.expanded);
      }
    }
    updateNonProcessedRecordExpansion(grid, record) {
      const rec = grid.records.get(record.key);
      rec.expanded = record.expanded;
    }
    static {
      this.ɵfac = function IgxTreeGridFlatteningPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridFlatteningPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridFlattening",
        type: IgxTreeGridFlatteningPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridFlatteningPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden */
let IgxTreeGridSortingPipe = /*#__PURE__*/(() => {
  class IgxTreeGridSortingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(hierarchicalData, sortExpressions, groupExpressions, sorting, _, pinned) {
      const expressions = groupExpressions ? groupExpressions.concat(sortExpressions) : sortExpressions;
      let result;
      if (!expressions.length) {
        result = hierarchicalData;
      } else {
        result = DataUtil.treeGridSort(hierarchicalData, expressions, sorting, null, this.grid);
      }
      const filteredSortedData = [];
      this.flattenTreeGridRecords(result, filteredSortedData);
      this.grid.setFilteredSortedData(filteredSortedData, pinned);
      return result;
    }
    flattenTreeGridRecords(records, flatData) {
      if (records && records.length) {
        for (const record of records) {
          flatData.push(record.data);
          this.flattenTreeGridRecords(record.children, flatData);
        }
      }
    }
    static {
      this.ɵfac = function IgxTreeGridSortingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridSortingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridSorting",
        type: IgxTreeGridSortingPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridSortingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden */
let IgxTreeGridPagingPipe = /*#__PURE__*/(() => {
  class IgxTreeGridPagingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, enabled, page = 0, perPage = 15, _) {
      if (!enabled || this.grid.pagingMode !== GridPagingMode.Local) {
        return collection;
      }
      const len = this.grid._totalRecords >= 0 ? this.grid._totalRecords : collection.length;
      const totalPages = Math.ceil(len / perPage);
      const state = {
        index: totalPages > 0 && page >= totalPages ? totalPages - 1 : page,
        recordsPerPage: perPage
      };
      const result = DataUtil.page(cloneArray(collection), state, len);
      this.grid.pagingState = state;
      this.grid.page = state.index;
      return result;
    }
    static {
      this.ɵfac = function IgxTreeGridPagingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridPagingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridPaging",
        type: IgxTreeGridPagingPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridPagingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden */
let IgxTreeGridTransactionPipe = /*#__PURE__*/(() => {
  class IgxTreeGridTransactionPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, _) {
      if (this.grid.transactions.enabled) {
        const aggregatedChanges = this.grid.transactions.getAggregatedChanges(true);
        if (aggregatedChanges.length > 0) {
          const primaryKey = this.grid.primaryKey;
          if (!primaryKey) {
            return collection;
          }
          const childDataKey = this.grid.childDataKey;
          if (childDataKey) {
            const hierarchicalDataClone = cloneHierarchicalArray(collection, childDataKey);
            return DataUtil.mergeHierarchicalTransactions(hierarchicalDataClone, aggregatedChanges, childDataKey, this.grid.primaryKey, this.grid.dataCloneStrategy);
          } else {
            const flatDataClone = cloneArray(collection);
            return DataUtil.mergeTransactions(flatDataClone, aggregatedChanges, this.grid.primaryKey, this.grid.dataCloneStrategy);
          }
        }
      }
      return collection;
    }
    static {
      this.ɵfac = function IgxTreeGridTransactionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridTransactionPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridTransaction",
        type: IgxTreeGridTransactionPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridTransactionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * This pipe maps the original record to ITreeGridRecord format used in TreeGrid.
 */
let IgxTreeGridNormalizeRecordsPipe = /*#__PURE__*/(() => {
  class IgxTreeGridNormalizeRecordsPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(_, __) {
      const primaryKey = this.grid.primaryKey;
      // using flattened data because origin data may be hierarchical.
      const flatData = this.grid.flatData;
      const res = flatData ? flatData.map(rec => ({
        rowID: this.grid.primaryKey ? rec[primaryKey] : rec,
        data: rec,
        level: 0,
        children: []
      })) : [];
      return res;
    }
    static {
      this.ɵfac = function IgxTreeGridNormalizeRecordsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridNormalizeRecordsPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridNormalizeRecord",
        type: IgxTreeGridNormalizeRecordsPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridNormalizeRecordsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTreeGridAddRowPipe = /*#__PURE__*/(() => {
  class IgxTreeGridAddRowPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, isPinned = false, _pipeTrigger) {
      if (!this.grid.rowEditable || !this.grid.crudService.row || this.grid.crudService.row.getClassName() !== IgxAddRow.name || !this.grid.gridAPI.crudService.addRowParent || isPinned !== this.grid.gridAPI.crudService.addRowParent.isPinned) {
        return collection;
      }
      const copy = collection.slice(0);
      const rec = this.grid.crudService.row.recordRef;
      if (this.grid.crudService.addRowParent.isPinned) {
        const parentRowIndex = copy.findIndex(record => record.rowID === this.grid.crudService.addRowParent.rowID);
        copy.splice(parentRowIndex + 1, 0, rec);
      } else {
        copy.splice(this.grid.crudService.row.index, 0, rec);
      }
      this.grid.records.set(rec.key, rec);
      return copy;
    }
    static {
      this.ɵfac = function IgxTreeGridAddRowPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridAddRowPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridAddRow",
        type: IgxTreeGridAddRowPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridAddRowPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTreeGridCellComponent = /*#__PURE__*/(() => {
  class IgxTreeGridCellComponent extends IgxGridExpandableCellComponent {
    constructor() {
      super(...arguments);
      /**
       * @hidden
       */
      this.level = 0;
      /**
       * @hidden
       */
      this.showIndicator = false;
    }
    /**
     * Gets the row of the cell.
     * ```typescript
     * let cellRow = this.cell.row;
     * ```
     *
     * @memberof IgxGridCellComponent
     */
    get row() {
      // TODO: Fix types
      return new IgxTreeGridRow(this.grid, this.intRow.index, this.intRow.data);
    }
    /**
     * @hidden
     */
    toggle(event) {
      event.stopPropagation();
      this.grid.gridAPI.set_row_expansion_state(this.intRow.key, !this.intRow.expanded, event);
    }
    /**
     * @hidden
     */
    onLoadingDblClick(event) {
      event.stopPropagation();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTreeGridCellComponent_BaseFactory;
        return function IgxTreeGridCellComponent_Factory(__ngFactoryType__) {
          return (ɵIgxTreeGridCellComponent_BaseFactory || (ɵIgxTreeGridCellComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTreeGridCellComponent)))(__ngFactoryType__ || IgxTreeGridCellComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeGridCellComponent,
        selectors: [["igx-tree-grid-cell"]],
        inputs: {
          level: "level",
          showIndicator: "showIndicator",
          isLoading: "isLoading",
          row: "row"
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager]), i0.ɵɵInheritDefinitionFeature],
        decls: 17,
        vars: 4,
        consts: [["defaultPinnedIndicator", ""], ["defaultCell", ""], ["addRowCell", ""], ["inlineEditor", ""], ["defaultExpandedTemplate", ""], ["defaultCollapsedTemplate", ""], ["defaultError", ""], ["defaultLoadingIndicatorTemplate", ""], ["indentationDiv", ""], ["indicator", ""], ["errorIcon", ""], ["error", "", "tooltipRef", "tooltip"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__td--pinned-chip", 3, "disabled", "--ig-size"], [1, "igx-grid__td--pinned-chip", 3, "disabled"], ["igxTextHighlight", "", 1, "igx-grid__td-text", 3, "cssClass", "activeCssClass", "groupName", "value", "row", "column", "containerClass", "metadata"], ["family", "default", 3, "name", "ngClass"], [3, "src", "alt"], [3, "formGroup"], [3, "--ig-size", "formGroup"], ["igxInput", "", 3, "compositionstart", "compositionend", "igxFocus", "igxTextSelection", "formControl"], ["igxInput", "", "type", "number", 3, "igxFocus", "step", "igxTextSelection", "formControl"], [3, "checked", "igxFocus", "disableRipple", "formControl"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "weekStart", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["type", "text", "igxInput", "", 3, "formControl", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat", "igxFocus"], [3, "class", "ngStyle"], [1, "igx-grid__tree-grouping-indicator", 3, "ngStyle"], [1, "igx-grid__tree-loading-indicator"], [3, "ngStyle"], [1, "igx-grid__tree-grouping-indicator", 3, "click", "focus", "ngStyle"], [1, "igx-grid__tree-loading-indicator", 3, "dblclick"], [4, "ngTemplateOutlet"], [3, "indeterminate"], ["family", "default", "name", "error", 3, "mouseover", "mouseout", "igxTooltipTarget", "igxToggleOutlet"], ["igxTooltip", "", 3, "id"], ["family", "default", "name", "tree_collapse"], ["family", "default", "name", "tree_expand"]],
        template: function IgxTreeGridCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxTreeGridCellComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxTreeGridCellComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxTreeGridCellComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxTreeGridCellComponent_ng_template_6_Template, 8, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxTreeGridCellComponent_Conditional_8_Template, 5, 3)(9, IgxTreeGridCellComponent_ng_container_9_Template, 1, 0, "ng-container", 12)(10, IgxTreeGridCellComponent_Conditional_10_Template, 7, 7)(11, IgxTreeGridCellComponent_ng_template_11_Template, 1, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(13, IgxTreeGridCellComponent_ng_template_13_Template, 1, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(15, IgxTreeGridCellComponent_ng_template_15_Template, 7, 7, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵconditional(!ctx.editMode ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isInvalid ? 10 : -1);
          }
        },
        dependencies: [NgClass, NgStyle, NgTemplateOutlet, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe, IgxChipComponent, IgxTextHighlightDirective, IgxIconComponent, ReactiveFormsModule, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormControlDirective, i4.FormGroupDirective, IgxInputGroupComponent, IgxInputDirective, IgxFocusDirective, IgxCheckboxComponent, IgxDatePickerComponent, IgxTimePickerComponent, IgxDateTimeEditorDirective, IgxPrefixDirective, IgxSuffixDirective, IgxCircularProgressBarComponent, IgxTooltipTargetDirective, IgxTooltipDirective, IgxGridCellImageAltPipe, IgxStringReplacePipe, IgxColumnFormatterPipe, IgxTextSelectionDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxTreeGridCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTreeGridRowComponent = /*#__PURE__*/(() => {
  class IgxTreeGridRowComponent extends IgxRowDirective {
    /**
     * The `ITreeGridRecord` passed to the row component.
     *
     * ```typescript
     * const row = this.grid.getRowByKey(1) as IgxTreeGridRowComponent;
     * const treeRow = row.treeRow;
     * ```
     */
    get treeRow() {
      return this._treeRow;
    }
    set treeRow(value) {
      if (this._treeRow !== value) {
        this._treeRow = value;
        this.data = this._treeRow.data;
      }
    }
    /**
     * Sets whether the row is pinned.
     * Default value is `false`.
     * ```typescript
     * this.grid.selectedRows[0].pinned = true;
     * ```
     */
    set pinned(value) {
      if (value) {
        this.grid.pinRow(this.key);
      } else {
        this.grid.unpinRow(this.key);
      }
    }
    /**
     * Gets whether the row is pinned.
     * ```typescript
     * let isPinned = row.pinned;
     * ```
     */
    get pinned() {
      return this.grid.isRecordPinned(this._treeRow);
    }
    /**
     * @hidden
     */
    get isRoot() {
      let treeRec = this.treeRow;
      const isPinnedArea = this.pinned && !this.disabled;
      if (isPinnedArea) {
        treeRec = this.grid.unpinnedRecords.find(x => x.data === this.data);
      }
      return treeRec?.level === 0;
    }
    /**
     * @hidden
     */
    get hasChildren() {
      return true;
    }
    /**
     * Returns a value indicating whether the row component is expanded.
     *
     * ```typescript
     * const row = this.grid.getRowByKey(1) as IgxTreeGridRowComponent;
     * const expanded = row.expanded;
     * ```
     */
    get expanded() {
      return this._treeRow.expanded;
    }
    /**
     * Sets a value indicating whether the row component is expanded.
     *
     * ```typescript
     * const row = this.grid.getRowByKey(1) as IgxTreeGridRowComponent;
     * row.expanded = true;
     * ```
     */
    set expanded(value) {
      this.grid.gridAPI.set_row_expansion_state(this._treeRow.key, value);
    }
    /**
     * @hidden
     * @internal
     */
    get viewIndex() {
      return this.index + this.grid.page * this.grid.perPage;
    }
    /**
     * @hidden
     */
    get showIndicator() {
      return this.grid.loadChildrenOnDemand ? this.grid.expansionStates.has(this.key) ? this.treeRow.children && this.treeRow.children.length : this.grid.hasChildrenKey ? this.data[this.grid.hasChildrenKey] : true : this.treeRow.children && this.treeRow.children.length;
    }
    /**
     * @hidden
     */
    get indeterminate() {
      return this.selectionService.isRowInIndeterminateState(this.key);
    }
    /**
     * @hidden
     */
    ngDoCheck() {
      this.isLoading = this.grid.loadChildrenOnDemand ? this.grid.loadingRows.has(this.key) : false;
      super.ngDoCheck();
    }
    /**
     * Spawns the add child row UI for the specific row.
     *
     * @example
     * ```typescript
     * const row = this.grid.getRowByKey(1) as IgxTreeGridRowComponent;
     * row.beginAddChild();
     * ```
     * @param rowID
     */
    beginAddChild() {
      this.grid.crudService.enterAddRowMode(this, true);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTreeGridRowComponent_BaseFactory;
        return function IgxTreeGridRowComponent_Factory(__ngFactoryType__) {
          return (ɵIgxTreeGridRowComponent_BaseFactory || (ɵIgxTreeGridRowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTreeGridRowComponent)))(__ngFactoryType__ || IgxTreeGridRowComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeGridRowComponent,
        selectors: [["igx-tree-grid-row"]],
        viewQuery: function IgxTreeGridRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c269, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._cells = _t);
          }
        },
        hostVars: 1,
        hostBindings: function IgxTreeGridRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-expanded", ctx.expanded);
          }
        },
        inputs: {
          treeRow: "treeRow"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxRowDirective,
          useExisting: forwardRef(() => IgxTreeGridRowComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 1,
        consts: [["addTemp", ""], ["defaultTemp", ""], ["rowSelectorBaseTemplate", ""], ["pinnedCellsTemplate", ""], ["igxDirRef", ""], ["cellTemplate", ""], ["treeCellTemplate", ""], ["treeCell", ""], [4, "ngTemplateOutlet"], [1, "igx-grid__tr--inner", 3, "animationend"], [3, "class", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForScrollOrientation", "igxForContainerSize", "igxForSizePropName", "igxForTrackBy"], [3, "click", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "click", "pointerdown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__td", "igx-grid__td--fw", 3, "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--tree-cell", 3, "ngClass", "ngStyle", "level", "expanded", "showIndicator", "editMode", "column", "formatter", "intRow", "rowData", "width", "visibleColumnIndex", "value", "isLoading", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "readonly", "checked", "indeterminate", "disabled", "disableRipple", "disableTransitions", "aria-label"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--pinned", 3, "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "firstPinned", "lastPinned", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--tree-cell", "igx-grid__td--pinned", 3, "ngClass", "ngStyle", "level", "expanded", "showIndicator", "editMode", "column", "formatter", "intRow", "lastPinned", "rowData", "width", "visibleColumnIndex", "value", "isLoading", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "active", "cellSelectionMode", "displayPinnedChip"]],
        template: function IgxTreeGridRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxTreeGridRowComponent_ng_container_0_Template, 1, 0, "ng-container", 8)(1, IgxTreeGridRowComponent_ng_template_1_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxTreeGridRowComponent_ng_template_3_Template, 7, 12, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxTreeGridRowComponent_ng_template_5_Template, 2, 8, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, IgxTreeGridRowComponent_ng_template_7_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const addTemp_r14 = i0.ɵɵreference(2);
            const defaultTemp_r3 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.addRowUI ? addTemp_r14 : defaultTemp_r3);
          }
        },
        dependencies: [NgTemplateOutlet, IgxRowDragDirective, IgxGridForOfDirective, IgxGridCellComponent, NgClass, NgStyle, IgxTreeGridCellComponent, IgxCheckboxComponent, IgxGridNotGroupedPipe, IgxGridCellStylesPipe, IgxGridCellStyleClassesPipe, IgxGridDataMapperPipe, IgxGridTransactionStatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxTreeGridRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$6 = 0;
/* blazorAdditionalDependency: Column */
/* blazorAdditionalDependency: ColumnGroup */
/* blazorAdditionalDependency: ColumnLayout */
/* blazorAdditionalDependency: GridToolbar */
/* blazorAdditionalDependency: GridToolbarActions */
/* blazorAdditionalDependency: GridToolbarTitle */
/* blazorAdditionalDependency: GridToolbarAdvancedFiltering */
/* blazorAdditionalDependency: GridToolbarExporter */
/* blazorAdditionalDependency: GridToolbarHiding */
/* blazorAdditionalDependency: GridToolbarPinning */
/* blazorAdditionalDependency: ActionStrip */
/* blazorAdditionalDependency: GridActionsBaseDirective */
/* blazorAdditionalDependency: GridEditingActions */
/* blazorAdditionalDependency: GridPinningActions */
/* blazorIndirectRender */
/**
 * **Ignite UI for Angular Tree Grid** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/grid/grid)
 *
 * The Ignite UI Tree Grid displays and manipulates hierarchical data with consistent schema formatted as a table and
 * provides features such as sorting, filtering, editing, column pinning, paging, column moving and hiding.
 *
 * Example:
 * ```html
 * <igx-tree-grid [data]="employeeData" primaryKey="employeeID" foreignKey="PID" [autoGenerate]="false">
 *   <igx-column field="first" header="First Name"></igx-column>
 *   <igx-column field="last" header="Last Name"></igx-column>
 *   <igx-column field="role" header="Role"></igx-column>
 * </igx-tree-grid>
 * ```
 */
let IgxTreeGridComponent = /*#__PURE__*/(() => {
  class IgxTreeGridComponent extends IgxGridBaseDirective {
    /* treatAsRef */
    /**
     * Gets/Sets the array of data that populates the component.
     * ```html
     * <igx-tree-grid [data]="Data" [autoGenerate]="true"></igx-tree-grid>
     * ```
     *
     * @memberof IgxTreeGridComponent
     */
    get data() {
      return this._data;
    }
    /* treatAsRef */
    set data(value) {
      const oldData = this._data;
      this._data = value || [];
      this.summaryService.clearSummaryCache();
      if (!this._init) {
        this.validation.updateAll(this._data);
      }
      if (this.autoGenerate && this._data.length > 0 && this.shouldRecreateColumns(oldData, this._data)) {
        this.setupColumns();
      }
      this.checkPrimaryKeyField();
      this.cdr.markForCheck();
    }
    /** @hidden @internal */
    get type() {
      return 'tree';
    }
    /**
     * Get transactions service for the grid.
     *
     * @experimental @hidden
     */
    get transactions() {
      if (this._diTransactions && !this.batchEditing) {
        return this._diTransactions;
      }
      return this._transactions;
    }
    /**
     * Sets the count of levels to be expanded in the `IgxTreeGridComponent`. By default it is
     * set to `Infinity` which means all levels would be expanded.
     * ```html
     * <igx-tree-grid #grid [data]="employeeData" [childDataKey]="'employees'" expansionDepth="1" [autoGenerate]="true"></igx-tree-grid>
     * ```
     *
     * @memberof IgxTreeGridComponent
     */
    get expansionDepth() {
      return this._expansionDepth;
    }
    set expansionDepth(value) {
      this._expansionDepth = value;
      this.notifyChanges();
    }
    /**
     * Template for the row loading indicator when load on demand is enabled.
     * ```html
     * <ng-template #rowLoadingTemplate>
     *     <igx-icon>loop</igx-icon>
     * </ng-template>
     *
     * <igx-tree-grid #grid [data]="employeeData" [primaryKey]="'ID'" [foreignKey]="'parentID'"
     *                [loadChildrenOnDemand]="loadChildren"
     *                [rowLoadingIndicatorTemplate]="rowLoadingTemplate">
     * </igx-tree-grid>
     * ```
     *
     * @memberof IgxTreeGridComponent
     */
    get rowLoadingIndicatorTemplate() {
      return this._rowLoadingIndicatorTemplate;
    }
    set rowLoadingIndicatorTemplate(value) {
      this._rowLoadingIndicatorTemplate = value;
      this.notifyChanges();
    }
    // Kind of stupid
    // private get _gridAPI(): IgxTreeGridAPIService {
    //     return this.gridAPI as IgxTreeGridAPIService;
    // }
    constructor(validationService, selectionService, colResizingService, gridAPI,
    // public gridAPI: GridBaseAPIService<IgxGridBaseDirective & GridType>,
    transactionFactory, _elementRef, _zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions) {
      super(validationService, selectionService, colResizingService, gridAPI, transactionFactory, _elementRef, _zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions);
      this._diTransactions = _diTransactions;
      /**
       * Sets whether child records should be deleted when their parent gets deleted.
       * By default it is set to true and deletes all children along with the parent.
       * ```html
       * <igx-tree-grid [data]="employeeData" [primaryKey]="'employeeID'" [foreignKey]="'parentID'" cascadeOnDelete="false">
       * </igx-tree-grid>
       * ```
       *
       * @memberof IgxTreeGridComponent
       */
      this.cascadeOnDelete = true;
      /**
       * @hidden @internal
       */
      this.role = 'treegrid';
      /**
       * Sets the value of the `id` attribute. If not provided it will be automatically generated.
       * ```html
       * <igx-tree-grid [id]="'igx-tree-grid-1'"></igx-tree-grid>
       * ```
       *
       * @memberof IgxTreeGridComponent
       */
      this.id = `igx-tree-grid-${NEXT_ID$6++}`;
      /* blazorSuppress */
      /**
       * Returns a map of all `ITreeGridRecord`s.
       * ```typescript
       * // gets the record with primaryKey=2
       * const states = this.grid.records.get(2);
       * ```
       *
       * @memberof IgxTreeGridComponent
       */
      this.records = new Map();
      /* blazorSuppress */
      /**
       * Returns a map of all processed (filtered and sorted) `ITreeGridRecord`s.
       * ```typescript
       * // gets the processed record with primaryKey=2
       * const states = this.grid.processedRecords.get(2);
       * ```
       *
       * @memberof IgxTreeGridComponent
       */
      this.processedRecords = new Map();
      /**
       * @hidden
       */
      this.loadingRows = new Set();
      this._filterStrategy = new TreeGridFilteringStrategy();
      this._expansionDepth = Infinity;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      super.ngOnInit();
      this.rowToggle.pipe(takeUntil(this.destroy$)).subscribe(args => {
        this.loadChildrenOnRowExpansion(args);
      });
      // TODO: cascade selection logic should be refactor to be handled in the already existing subs
      this.rowAddedNotifier.pipe(takeUntil(this.destroy$)).subscribe(args => {
        if (this.rowSelection === GridSelectionMode.multipleCascade) {
          let rec = this.gridAPI.get_rec_by_id(this.primaryKey ? args.data[this.primaryKey] : args.data);
          if (rec && rec.parent) {
            this.gridAPI.grid.selectionService.updateCascadeSelectionOnFilterAndCRUD(new Set([rec.parent]), rec.parent.key);
          } else {
            // The record is still not available
            // Wait for the change detection to update records through pipes
            requestAnimationFrame(() => {
              rec = this.gridAPI.get_rec_by_id(this.primaryKey ? args.data[this.primaryKey] : args.data);
              if (rec && rec.parent) {
                this.gridAPI.grid.selectionService.updateCascadeSelectionOnFilterAndCRUD(new Set([rec.parent]), rec.parent.key);
              }
              this.notifyChanges();
            });
          }
        }
      });
      this.rowDeletedNotifier.pipe(takeUntil(this.destroy$)).subscribe(args => {
        if (this.rowSelection === GridSelectionMode.multipleCascade) {
          if (args.data) {
            const rec = this.gridAPI.get_rec_by_id(this.primaryKey ? args.data[this.primaryKey] : args.data);
            this.handleCascadeSelection(args, rec);
          } else {
            // if a row has been added and before commiting the transaction deleted
            const leafRowsDirectParents = new Set();
            this.records.forEach(record => {
              if (record && (!record.children || record.children.length === 0) && record.parent) {
                leafRowsDirectParents.add(record.parent);
              }
            });
            // Wait for the change detection to update records through pipes
            requestAnimationFrame(() => {
              this.gridAPI.grid.selectionService.updateCascadeSelectionOnFilterAndCRUD(leafRowsDirectParents);
              this.notifyChanges();
            });
          }
        }
      });
      this.filteringDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.rowSelection === GridSelectionMode.multipleCascade) {
          const leafRowsDirectParents = new Set();
          this.records.forEach(record => {
            if (record && (!record.children || record.children.length === 0) && record.parent) {
              leafRowsDirectParents.add(record.parent);
            }
          });
          this.gridAPI.grid.selectionService.updateCascadeSelectionOnFilterAndCRUD(leafRowsDirectParents);
          this.notifyChanges();
        }
      });
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      // TODO: pipesExectured event
      // run after change detection in super triggers pipes for records structure
      if (this.rowSelection === GridSelectionMode.multipleCascade && this.selectedRows.length) {
        const selRows = this.selectedRows;
        this.selectionService.clearRowSelection();
        this.selectRows(selRows, true);
        this.cdr.detectChanges();
      }
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      if (this.rowLoadingTemplate) {
        this._rowLoadingIndicatorTemplate = this.rowLoadingTemplate.template;
      }
      super.ngAfterContentInit();
    }
    getDefaultExpandState(record) {
      return record.children && record.children.length && record.level < this.expansionDepth;
    }
    /**
     * Expands all rows.
     * ```typescript
     * this.grid.expandAll();
     * ```
     *
     * @memberof IgxTreeGridComponent
     */
    expandAll() {
      this._expansionDepth = Infinity;
      this.expansionStates = new Map();
    }
    /**
     * Collapses all rows.
     *
     * ```typescript
     * this.grid.collapseAll();
     *  ```
     *
     * @memberof IgxTreeGridComponent
     */
    collapseAll() {
      this._expansionDepth = 0;
      this.expansionStates = new Map();
    }
    /**
     * @hidden
     */
    refreshGridState(args) {
      super.refreshGridState();
      if (this.primaryKey && this.foreignKey && args) {
        const rowID = args.data[this.foreignKey];
        this.summaryService.clearSummaryCache({
          rowID
        });
        this.pipeTrigger++;
        this.cdr.detectChanges();
      }
    }
    /* blazorCSSuppress */
    /**
     * Creates a new `IgxTreeGridRowComponent` with the given data. If a parentRowID is not specified, the newly created
     * row would be added at the root level. Otherwise, it would be added as a child of the row whose primaryKey matches
     * the specified parentRowID. If the parentRowID does not exist, an error would be thrown.
     * ```typescript
     * const record = {
     *     ID: this.grid.data[this.grid1.data.length - 1].ID + 1,
     *     Name: this.newRecord
     * };
     * this.grid.addRow(record, 1); // Adds a new child row to the row with ID=1.
     * ```
     *
     * @param data
     * @param parentRowID
     * @memberof IgxTreeGridComponent
     */
    // TODO: remove evt emission
    addRow(data, parentRowID) {
      this.crudService.endEdit(true);
      this.gridAPI.addRowToData(data, parentRowID);
      this.rowAddedNotifier.next({
        data: data,
        rowData: data,
        owner: this,
        primaryKey: data[this.primaryKey],
        rowKey: data[this.primaryKey]
      });
      this.pipeTrigger++;
      this.notifyChanges();
    }
    /**
     * Enters add mode by spawning the UI with the context of the specified row by index.
     *
     * @remarks
     * Accepted values for index are integers from 0 to this.grid.dataView.length
     * @remarks
     * When adding the row as a child, the parent row is the specified row.
     * @remarks
     * To spawn the UI on top, call the function with index = null or a negative number.
     * In this case trying to add this row as a child will result in error.
     * @example
     * ```typescript
     * this.grid.beginAddRowByIndex(10);
     * this.grid.beginAddRowByIndex(10, true);
     * this.grid.beginAddRowByIndex(null);
     * ```
     * @param index - The index to spawn the UI at. Accepts integers from 0 to this.grid.dataView.length
     * @param asChild - Whether the record should be added as a child. Only applicable to igxTreeGrid.
     */
    beginAddRowByIndex(index, asChild) {
      if (index === null || index < 0) {
        return this.beginAddRowById(null, asChild);
      }
      return this._addRowForIndex(index - 1, asChild);
    }
    /**
     * @hidden
     */
    getContext(rowData, rowIndex, pinned) {
      return {
        $implicit: this.isGhostRecord(rowData) ? rowData.recordRef : rowData,
        index: this.getDataViewIndex(rowIndex, pinned),
        templateID: {
          type: this.isSummaryRow(rowData) ? 'summaryRow' : 'dataRow',
          id: null
        },
        disabled: this.isGhostRecord(rowData) ? rowData.recordRef.isFilteredOutParent === undefined : false
      };
    }
    /**
     * @hidden
     * @internal
     */
    getInitialPinnedIndex(rec) {
      const id = this.gridAPI.get_row_id(rec);
      return this._pinnedRecordIDs.indexOf(id);
    }
    /**
     * @hidden
     * @internal
     */
    isRecordPinned(rec) {
      return this.getInitialPinnedIndex(rec.data) !== -1;
    }
    /**
     *
     * Returns an array of the current cell selection in the form of `[{ column.field: cell.value }, ...]`.
     *
     * @remarks
     * If `formatters` is enabled, the cell value will be formatted by its respective column formatter (if any).
     * If `headers` is enabled, it will use the column header (if any) instead of the column field.
     */
    getSelectedData(formatters = false, headers = false) {
      let source = [];
      const process = record => {
        if (record.summaries) {
          source.push(null);
          return;
        }
        source.push(record.data);
      };
      this.unpinnedDataView.forEach(process);
      source = this.isRowPinningToTop ? [...this.pinnedDataView, ...source] : [...source, ...this.pinnedDataView];
      return this.extractDataFromSelection(source, formatters, headers);
    }
    /**
     * @hidden @internal
     */
    getEmptyRecordObjectFor(inTreeRow) {
      const treeRowRec = inTreeRow?.treeRow || null;
      const row = {
        ...treeRowRec
      };
      const data = treeRowRec?.data || {};
      row.data = {
        ...data
      };
      Object.keys(row.data).forEach(key => {
        // persist foreign key if one is set.
        if (this.foreignKey && key === this.foreignKey) {
          row.data[key] = treeRowRec.data[this.crudService.addRowParent?.asChild ? this.primaryKey : key];
        } else {
          row.data[key] = undefined;
        }
      });
      let id = this.generateRowID();
      const rootRecPK = this.foreignKey && this.rootRecords && this.rootRecords.length > 0 ? this.rootRecords[0].data[this.foreignKey] : null;
      if (id === rootRecPK) {
        // safeguard in case generated id matches the root foreign key.
        id = this.generateRowID();
      }
      row.key = id;
      row.data[this.primaryKey] = id;
      return {
        rowID: id,
        data: row.data,
        recordRef: row
      };
    }
    /** @hidden */
    deleteRowById(rowId) {
      //  if this is flat self-referencing data, and CascadeOnDelete is set to true
      //  and if we have transactions we should start pending transaction. This allows
      //  us in case of delete action to delete all child rows as single undo action
      const args = {
        rowID: rowId,
        primaryKey: rowId,
        rowKey: rowId,
        cancel: false,
        rowData: this.getRowData(rowId),
        data: this.getRowData(rowId),
        oldValue: null,
        owner: this
      };
      this.rowDelete.emit(args);
      if (args.cancel) {
        return;
      }
      const record = this.gridAPI.deleteRowById(rowId);
      const key = record[this.primaryKey];
      if (record !== null && record !== undefined) {
        const rowDeletedEventArgs = {
          data: record,
          rowData: record,
          owner: this,
          primaryKey: key,
          rowKey: key
        };
        this.rowDeleted.emit(rowDeletedEventArgs);
      }
      return record;
    }
    /**
     * Returns the `IgxTreeGridRow` by index.
     *
     * @example
     * ```typescript
     * const myRow = treeGrid.getRowByIndex(1);
     * ```
     * @param index
     */
    getRowByIndex(index) {
      if (index < 0 || index >= this.dataView.length) {
        return undefined;
      }
      return this.createRow(index);
    }
    /**
     * Returns the `RowType` object by the specified primary key.
     *
     * @example
     * ```typescript
     * const myRow = this.treeGrid.getRowByIndex(1);
     * ```
     * @param index
     */
    getRowByKey(key) {
      const rec = this.filteredSortedData ? this.primaryKey ? this.filteredSortedData.find(r => r[this.primaryKey] === key) : this.filteredSortedData.find(r => r === key) : undefined;
      const index = this.dataView.findIndex(r => r.data && r.data === rec);
      if (index < 0 || index >= this.filteredSortedData.length) {
        return undefined;
      }
      return new IgxTreeGridRow(this, index, rec);
    }
    /**
     * Returns the collection of all RowType for current page.
     *
     * @hidden @internal
     */
    allRows() {
      return this.dataView.map((rec, index) => this.createRow(index));
    }
    /**
     * Returns the collection of `IgxTreeGridRow`s for current page.
     *
     * @hidden @internal
     */
    dataRows() {
      return this.allRows().filter(row => row instanceof IgxTreeGridRow);
    }
    /**
     * Returns an array of the selected `IgxGridCell`s.
     *
     * @example
     * ```typescript
     * const selectedCells = this.grid.selectedCells;
     * ```
     */
    get selectedCells() {
      return this.dataRows().map(row => row.cells.filter(cell => cell.selected)).reduce((a, b) => a.concat(b), []);
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @example
     * ```typescript
     * const myCell = this.grid1.getCellByColumn(2, "UnitPrice");
     * ```
     * @param rowIndex
     * @param columnField
     */
    getCellByColumn(rowIndex, columnField) {
      const row = this.getRowByIndex(rowIndex);
      const column = this.columns.find(col => col.field === columnField);
      if (row && row instanceof IgxTreeGridRow && column) {
        return new IgxGridCell(this, rowIndex, column);
      }
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @remarks
     * Requires that the primaryKey property is set.
     * @example
     * ```typescript
     * grid.getCellByKey(1, 'index');
     * ```
     * @param rowSelector match any rowID
     * @param columnField
     */
    getCellByKey(rowSelector, columnField) {
      const row = this.getRowByKey(rowSelector);
      const column = this.columns.find(col => col.field === columnField);
      if (row && column) {
        return new IgxGridCell(this, row.index, column);
      }
    }
    pinRow(rowID, index) {
      const row = this.getRowByKey(rowID);
      return super.pinRow(rowID, index, row);
    }
    unpinRow(rowID) {
      const row = this.getRowByKey(rowID);
      return super.unpinRow(rowID, row);
    }
    /** @hidden */
    generateRowPath(rowId) {
      const path = [];
      let record = this.records.get(rowId);
      while (record.parent) {
        path.push(record.parent.key);
        record = record.parent;
      }
      return path.reverse();
    }
    /** @hidden */
    isTreeRow(record) {
      return record.key !== undefined && record.data;
    }
    /** @hidden */
    getUnpinnedIndexById(id) {
      return this.unpinnedRecords.findIndex(x => x.data[this.primaryKey] === id);
    }
    /**
     * @hidden
     */
    createRow(index, data) {
      let row;
      const dataIndex = this._getDataViewIndex(index);
      const rec = data ?? this.dataView[dataIndex];
      if (this.isSummaryRow(rec)) {
        row = new IgxSummaryRow(this, index, rec.summaries);
      }
      if (!row && rec) {
        const isTreeRow = this.isTreeRow(rec);
        const dataRec = isTreeRow ? rec.data : rec;
        const treeRow = isTreeRow ? rec : undefined;
        row = new IgxTreeGridRow(this, index, dataRec, treeRow);
      }
      return row;
    }
    generateDataFields(data) {
      return super.generateDataFields(data).filter(field => field !== this.childDataKey);
    }
    transactionStatusUpdate(event) {
      let actions = [];
      if (event.origin === TransactionEventOrigin.REDO) {
        actions = event.actions ? event.actions.filter(x => x.transaction.type === TransactionType.DELETE) : [];
        if (this.rowSelection === GridSelectionMode.multipleCascade) {
          this.handleCascadeSelection(event);
        }
      } else if (event.origin === TransactionEventOrigin.UNDO) {
        actions = event.actions ? event.actions.filter(x => x.transaction.type === TransactionType.ADD) : [];
        if (this.rowSelection === GridSelectionMode.multipleCascade) {
          if (event.actions[0].transaction.type === 'add') {
            const rec = this.gridAPI.get_rec_by_id(event.actions[0].transaction.id);
            this.handleCascadeSelection(event, rec);
          } else {
            this.handleCascadeSelection(event);
          }
        }
      }
      if (actions.length) {
        for (const action of actions) {
          this.deselectChildren(action.transaction.id);
        }
      }
      super.transactionStatusUpdate(event);
    }
    findRecordIndexInView(rec) {
      return this.dataView.findIndex(x => x.data[this.primaryKey] === rec[this.primaryKey]);
    }
    /**
     * @hidden @internal
     */
    getDataBasedBodyHeight() {
      return !this.flatData || this.flatData.length < this._defaultTargetRecordNumber ? 0 : this.defaultTargetBodyHeight;
    }
    /**
     * @hidden
     */
    scrollTo(row, column) {
      let delayScrolling = false;
      let record;
      if (typeof row !== 'number') {
        const rowData = row;
        const rowID = this.gridAPI.get_row_id(rowData);
        record = this.processedRecords.get(rowID);
        this.gridAPI.expand_path_to_record(record);
        if (this.paginator) {
          const rowIndex = this.processedExpandedFlatData.indexOf(rowData);
          const page = Math.floor(rowIndex / this.perPage);
          if (this.page !== page) {
            delayScrolling = true;
            this.page = page;
          }
        }
      }
      if (delayScrolling) {
        this.verticalScrollContainer.dataChanged.pipe(first$2()).subscribe(() => {
          this.scrollDirective(this.verticalScrollContainer, typeof row === 'number' ? row : this.unpinnedDataView.indexOf(record));
        });
      } else {
        this.scrollDirective(this.verticalScrollContainer, typeof row === 'number' ? row : this.unpinnedDataView.indexOf(record));
      }
      this.scrollToHorizontally(column);
    }
    writeToData(rowIndex, value) {
      mergeObjects(this.flatData[rowIndex], value);
    }
    /**
     * @hidden
     */
    initColumns(collection, cb = null) {
      if (this.hasColumnLayouts) {
        // invalid configuration - tree grid should not allow column layouts
        // remove column layouts
        const nonColumnLayoutColumns = this.columns.filter(col => !col.columnLayout && !col.columnLayoutChild);
        this.updateColumns(nonColumnLayoutColumns);
      }
      super.initColumns(collection, cb);
    }
    /**
     * @hidden @internal
     */
    getGroupAreaHeight() {
      return this.treeGroupArea ? this.getComputedHeight(this.treeGroupArea.nativeElement) : 0;
    }
    /** {@link triggerPipes} will re-create pinnedData on CRUD operations */
    trackPinnedRowData(record) {
      // TODO FIX: pipeline data doesn't match end interface (¬_¬ )
      // return record.key || (record as any).rowID;
      return record;
    }
    /**
     * @description A recursive way to deselect all selected children of a given record
     * @param recordID ID of the record whose children to deselect
     * @hidden
     * @internal
     */
    deselectChildren(recordID) {
      const selectedChildren = [];
      // G.E. Apr 28, 2021 #9465 Records which are not in view can also be selected so we need to
      // deselect them as well, hence using 'records' map instead of getRowByKey() method which will
      // return only row components (i.e. records in view).
      const rowToDeselect = this.records.get(recordID);
      this.selectionService.deselectRowsWithNoEvent([recordID]);
      this.gridAPI.get_selected_children(rowToDeselect, selectedChildren);
      if (selectedChildren.length > 0) {
        selectedChildren.forEach(x => this.deselectChildren(x));
      }
    }
    addChildRows(children, parentID) {
      if (this.primaryKey && this.foreignKey) {
        for (const child of children) {
          child[this.foreignKey] = parentID;
        }
        this.data.push(...children);
      } else if (this.childDataKey) {
        let parent = this.records.get(parentID);
        let parentData = parent.data;
        if (this.transactions.enabled && this.transactions.getAggregatedChanges(true).length) {
          const path = [];
          while (parent) {
            path.push(parent.key);
            parent = parent.parent;
          }
          let collection = this.data;
          let record;
          for (let i = path.length - 1; i >= 0; i--) {
            const pid = path[i];
            record = collection.find(r => r[this.primaryKey] === pid);
            if (!record) {
              break;
            }
            collection = record[this.childDataKey];
          }
          if (record) {
            parentData = record;
          }
        }
        parentData[this.childDataKey] = children;
      }
      this.selectionService.clearHeaderCBState();
      this.pipeTrigger++;
      if (this.rowSelection === GridSelectionMode.multipleCascade) {
        // Force pipe triggering for building the data structure
        this.cdr.detectChanges();
        if (this.selectionService.isRowSelected(parentID)) {
          this.selectionService.rowSelection.delete(parentID);
          this.selectionService.selectRowsWithNoEvent([parentID]);
        }
      }
    }
    loadChildrenOnRowExpansion(args) {
      if (this.loadChildrenOnDemand) {
        const parentID = args.rowID;
        if (args.expanded && !this._expansionStates.has(parentID)) {
          this.loadingRows.add(parentID);
          this.loadChildrenOnDemand(parentID, children => {
            this.loadingRows.delete(parentID);
            this.addChildRows(children, parentID);
            this.notifyChanges();
          });
        }
      }
    }
    handleCascadeSelection(event, rec = null) {
      // Wait for the change detection to update records through the pipes
      requestAnimationFrame(() => {
        if (rec === null) {
          rec = this.gridAPI.get_rec_by_id(event.actions[0].transaction.id);
        }
        if (rec && rec.parent) {
          this.gridAPI.grid.selectionService.updateCascadeSelectionOnFilterAndCRUD(new Set([rec.parent]), rec.parent.key);
          this.notifyChanges();
        }
      });
    }
    static {
      this.ɵfac = function IgxTreeGridComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridComponent)(i0.ɵɵdirectiveInject(IgxGridValidationService), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(IgxHierarchicalTransactionFactory), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(IgxGridNavigationService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxGridSummaryService), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxGridTransaction, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTreeGridComponent,
        selectors: [["igx-tree-grid"]],
        contentQueries: function IgxTreeGridComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxTreeGridGroupByAreaComponent, 5, IgxTreeGridGroupByAreaComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxRowLoadingIndicatorTemplateDirective, 5, IgxRowLoadingIndicatorTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeGroupArea = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowLoadingTemplate = _t.first);
          }
        },
        viewQuery: function IgxTreeGridComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c226, 7, TemplateRef);
            i0.ɵɵviewQuery(_c229, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.recordTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.summaryTemplate = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxTreeGridComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("id", ctx.id);
          }
        },
        inputs: {
          childDataKey: "childDataKey",
          foreignKey: "foreignKey",
          hasChildrenKey: "hasChildrenKey",
          cascadeOnDelete: [2, "cascadeOnDelete", "cascadeOnDelete", booleanAttribute],
          loadChildrenOnDemand: "loadChildrenOnDemand",
          id: "id",
          data: "data",
          expansionDepth: "expansionDepth",
          rowLoadingIndicatorTemplate: "rowLoadingIndicatorTemplate"
        },
        features: [i0.ɵɵProvidersFeature([IgxGridCRUDService, IgxGridValidationService, IgxGridSummaryService, IgxGridNavigationService, {
          provide: IgxGridSelectionService,
          useClass: IgxTreeGridSelectionService
        }, {
          provide: IGX_GRID_SERVICE_BASE,
          useClass: IgxTreeGridAPIService
        }, {
          provide: IGX_GRID_BASE,
          useExisting: IgxTreeGridComponent
        }, IgxFilteringService, IgxColumnResizingService, IgxForOfSyncService, IgxForOfScrollSyncService]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c271,
        decls: 88,
        vars: 159,
        consts: [["tbody", ""], ["pinnedRecordsTemplate", ""], ["verticalScrollContainer", ""], ["record_template", ""], ["pinned_record_template", ""], ["summary_template", ""], ["igxRowEditingOverlayOutlet", ""], ["loadingOverlay", ""], ["verticalScrollHolder", ""], ["addRowSnackbar", ""], ["igxBodyOverlayOutlet", "overlay-outlet"], ["tfoot", ""], ["scr", ""], ["scrollContainer", ""], ["footer", ""], ["emptyFilteredGrid", ""], ["defaultEmptyGrid", ""], ["defaultAddRowEmptyTemplate", ""], ["defaultLoadingGrid", ""], ["defaultRowEditText", ""], ["defaultRowEditActions", ""], ["defaultRowEditTemplate", ""], ["dragIndicatorIconBase", ""], ["igxLoadingOverlayOutlet", ""], ["igxFilteringOverlayOutlet", ""], ["pinContainer", ""], ["row", ""], ["row", "", "pinnedRow", ""], ["summaryRow", ""], ["rowEditingOverlay", ""], ["sink", ""], ["tabindex", "0", 1, "igx-grid-thead", 3, "keydown.meta.c", "keydown.control.c", "copy", "keydown", "focus", "grid", "hasMRL", "activeDescendant", "width", "pinnedColumnCollection", "unpinnedColumnCollection"], ["igxGridBody", "", "role", "rowgroup", 1, "igx-grid__tbody", 3, "keydown.control.c", "copy"], ["tabindex", "0", 1, "igx-grid__tbody-content", 3, "focus", "keydown", "dragStop", "dragScroll", "scroll", "igxGridDragSelect"], ["id", "left", 1, "igx-grid__scroll-on-drag-left", 3, "igxColumnMovingDrop"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop", "left"], [4, "ngTemplateOutlet"], ["igxGridFor", "", 3, "dataChanging", "dataChanged", "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["igxOverlayOutlet", "", 1, "igx-grid__row-editing-outlet"], ["igxToggle", ""], [3, "indeterminate"], ["id", "right", 1, "igx-grid__scroll-on-drag-right", 3, "igxColumnMovingDrop"], [1, "igx-grid__tbody-scrollbar", 3, "pointerdown", "hidden"], [1, "igx-grid__tbody-scrollbar-start"], [1, "igx-grid__tbody-scrollbar-main"], ["igxGridFor", "", 3, "igxGridForOf"], [1, "igx-grid__tbody-scrollbar-end"], [1, "igx-grid__addrow-snackbar"], [3, "outlet", "actionText", "displayTime"], ["igxOverlayOutlet", ""], ["role", "rowgroup", 1, "igx-grid__tfoot"], ["tabindex", "0", 3, "focus", "keydown"], ["role", "row", 1, "igx-grid__summaries", 3, "width", "height", "gridID", "summaries", "index"], [1, "igx-grid__tfoot-thumb", 3, "hidden"], [1, "igx-grid__scroll", 3, "pointerdown", "hidden"], [1, "igx-grid__scroll-start"], [1, "igx-grid__scroll-main"], [1, "igx-grid__scroll-end", 3, "hidden"], [1, "igx-grid__footer"], ["igxOverlayOutlet", "", 1, "igx-grid__loading-outlet"], ["igxOverlayOutlet", "", 1, "igx-grid__outlet"], [2, "display", "none"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop"], [1, "igx-grid__tr--pinned", 3, "ngClass", "width"], [1, "igx-grid__tr--pinned", 3, "ngClass"], [3, "cachedViewLoaded", "igxTemplateOutlet", "igxTemplateOutletContext"], [3, "gridID", "index", "treeRow", "disabled", "ngClass", "ngStyle"], [3, "gridID", "index", "treeRow", "ngClass", "ngStyle"], ["role", "row", 1, "igx-grid__summaries--body", 3, "gridID", "summaries", "firstCellIndentation", "index"], ["role", "row", 1, "igx-grid__summaries", 3, "gridID", "summaries", "index"], ["role", "cell", 1, "igx-grid__tbody-message"], ["type", "button", "igxButton", "contained", "igxRipple", "", 3, "click"], [1, "igx-grid__loading"], [3, "className"], ["type", "button", "igxButton", "", "igxRowEditTabStop", "", 3, "click"], [1, "igx-banner__message"], [1, "igx-banner__text"], [1, "igx-banner__actions"], [1, "igx-banner__row"], ["family", "default", "name", "drag_indicator"]],
        template: function IgxTreeGridComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c270);
            i0.ɵɵprojection(0);
            i0.ɵɵprojection(1, 1);
            i0.ɵɵelementStart(2, "igx-grid-header-row", 31);
            i0.ɵɵlistener("keydown.meta.c", function IgxTreeGridComponent_Template_igx_grid_header_row_keydown_meta_c_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown.control.c", function IgxTreeGridComponent_Template_igx_grid_header_row_keydown_control_c_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxTreeGridComponent_Template_igx_grid_header_row_copy_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown", function IgxTreeGridComponent_Template_igx_grid_header_row_keydown_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.headerNavigation($event));
            })("focus", function IgxTreeGridComponent_Template_igx_grid_header_row_focus_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 32);
            i0.ɵɵlistener("keydown.control.c", function IgxTreeGridComponent_Template_div_keydown_control_c_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxTreeGridComponent_Template_div_copy_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            });
            i0.ɵɵelementStart(4, "div", 33, 0);
            i0.ɵɵlistener("focus", function IgxTreeGridComponent_Template_div_focus_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusTbody($event));
            })("keydown", function IgxTreeGridComponent_Template_div_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.handleNavigation($event));
            })("dragStop", function IgxTreeGridComponent_Template_div_dragStop_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectionService.dragMode = $event);
            })("dragScroll", function IgxTreeGridComponent_Template_div_dragScroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragScroll($event));
            })("scroll", function IgxTreeGridComponent_Template_div_scroll_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventContainerScroll($event));
            });
            i0.ɵɵtemplate(6, IgxTreeGridComponent_Conditional_6_Template, 1, 2, "span", 34)(7, IgxTreeGridComponent_Conditional_7_Template, 1, 4, "span", 35)(8, IgxTreeGridComponent_ng_template_8_Template, 8, 47, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(10, IgxTreeGridComponent_ng_container_10_Template, 1, 0, "ng-container", 36)(11, IgxTreeGridComponent_ng_template_11_Template, 1, 2, "ng-template", 37, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(13, "treeGridTransaction");
            i0.ɵɵpipe(14, "visibleColumns");
            i0.ɵɵpipe(15, "treeGridHierarchizing");
            i0.ɵɵpipe(16, "treeGridFiltering");
            i0.ɵɵpipe(17, "treeGridSorting");
            i0.ɵɵpipe(18, "treeGridFlattening");
            i0.ɵɵpipe(19, "treeGridPaging");
            i0.ɵɵpipe(20, "treeGridSummary");
            i0.ɵɵpipe(21, "treeGridAddRow");
            i0.ɵɵpipe(22, "gridRowPinning");
            i0.ɵɵlistener("dataChanging", function IgxTreeGridComponent_Template_ng_template_dataChanging_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebinding($event));
            })("dataChanged", function IgxTreeGridComponent_Template_ng_template_dataChanged_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebound($event));
            });
            i0.ɵɵtemplate(23, IgxTreeGridComponent_ng_container_23_Template, 1, 0, "ng-container", 36)(24, IgxTreeGridComponent_ng_template_24_Template, 4, 37, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(26, IgxTreeGridComponent_ng_template_26_Template, 5, 36, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(28, IgxTreeGridComponent_ng_template_28_Template, 2, 4, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(30, IgxTreeGridComponent_ng_container_30_Template, 1, 0, "ng-container", 38);
            i0.ɵɵelement(31, "div", 39, 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "div", 40, 7);
            i0.ɵɵtemplate(35, IgxTreeGridComponent_Conditional_35_Template, 1, 1, "igx-circular-bar", 41);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(36, IgxTreeGridComponent_Conditional_36_Template, 1, 2, "span", 42);
            i0.ɵɵelementStart(37, "div", 43);
            i0.ɵɵlistener("pointerdown", function IgxTreeGridComponent_Template_div_pointerdown_37_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(38, "div", 44);
            i0.ɵɵelementStart(39, "div", 45);
            i0.ɵɵtemplate(40, IgxTreeGridComponent_ng_template_40_Template, 0, 0, "ng-template", 46, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "div", 47);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "div", 48)(44, "igx-snackbar", 49, 9);
            i0.ɵɵtext(46);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(47, "div", 50, 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(49, "div", 51, 11)(51, "div", 52);
            i0.ɵɵlistener("focus", function IgxTreeGridComponent_Template_div_focus_51_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell(false));
            })("keydown", function IgxTreeGridComponent_Template_div_keydown_51_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.summaryNav($event));
            });
            i0.ɵɵtemplate(52, IgxTreeGridComponent_Conditional_52_Template, 3, 10, "igx-grid-summary-row", 53);
            i0.ɵɵelement(53, "div", 54);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(54, "div", 55, 12);
            i0.ɵɵlistener("pointerdown", function IgxTreeGridComponent_Template_div_pointerdown_54_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(56, "div", 56);
            i0.ɵɵelementStart(57, "div", 57);
            i0.ɵɵtemplate(58, IgxTreeGridComponent_ng_template_58_Template, 0, 0, "ng-template", 46, 13, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(60, "div", 58);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(61, "div", 59, 14);
            i0.ɵɵprojection(63, 2);
            i0.ɵɵprojection(64, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(65, IgxTreeGridComponent_ng_template_65_Template, 4, 2, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor)(67, IgxTreeGridComponent_ng_template_67_Template, 4, 2, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor)(69, IgxTreeGridComponent_ng_template_69_Template, 2, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor)(71, IgxTreeGridComponent_ng_template_71_Template, 2, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor)(73, IgxTreeGridComponent_Conditional_73_Template, 4, 6, "div", 40)(74, IgxTreeGridComponent_ng_template_74_Template, 3, 9, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor)(76, IgxTreeGridComponent_ng_template_76_Template, 4, 2, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor)(78, IgxTreeGridComponent_ng_template_78_Template, 6, 8, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor)(80, IgxTreeGridComponent_ng_template_80_Template, 1, 0, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor)(82, IgxTreeGridComponent_Conditional_82_Template, 1, 0, "igx-grid-column-resizer");
            i0.ɵɵelement(83, "div", 60, 23)(85, "div", 61, 24);
            i0.ɵɵtemplate(87, IgxTreeGridComponent_Conditional_87_Template, 4, 0, "div", 62);
          }
          if (rf & 2) {
            const pinnedRecordsTemplate_r26 = i0.ɵɵreference(9);
            const igxBodyOverlayOutlet_r27 = i0.ɵɵreference(48);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("grid", ctx)("hasMRL", ctx.hasColumnLayouts)("activeDescendant", ctx.activeDescendant)("width", ctx.calcWidth)("pinnedColumnCollection", ctx.pinnedColumns)("unpinnedColumnCollection", ctx.unpinnedColumns);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", ctx.totalHeight, "px")("width", ctx.calcWidth, "px");
            i0.ɵɵproperty("igxGridDragSelect", ctx.selectionService.dragMode);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant)("role", ctx.dataView.length ? null : "row");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length <= 0 ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length > 0 ? 7 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && ctx.isRowPinningToTop ? pinnedRecordsTemplate_r26 : null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind4(22, 117, i0.ɵɵpipeBind3(21, 113, i0.ɵɵpipeBindV(20, 105, i0.ɵɵpureFunction7(147, _c225, i0.ɵɵpipeBindV(19, 99, i0.ɵɵpureFunction5(141, _c64, i0.ɵɵpipeBind4(18, 94, i0.ɵɵpipeBindV(17, 88, i0.ɵɵpureFunction5(135, _c64, i0.ɵɵpipeBindV(16, 81, i0.ɵɵpureFunction6(128, _c63, i0.ɵɵpipeBindV(15, 75, i0.ɵɵpureFunction5(122, _c64, i0.ɵɵpipeBind2(14, 72, i0.ɵɵpipeBind2(13, 69, ctx.data, ctx.pipeTrigger), ctx.hasVisibleColumns), ctx.primaryKey, ctx.foreignKey, ctx.childDataKey, ctx.pipeTrigger)), ctx.filteringExpressionsTree, ctx.filterStrategy, ctx.advancedFilteringExpressionsTree, ctx.pipeTrigger, ctx.filteringPipeTrigger)), ctx.sortingExpressions, ctx.treeGroupArea == null ? null : ctx.treeGroupArea.expressions, ctx.sortStrategy, ctx.pipeTrigger)), ctx.expansionDepth, ctx.expansionStates, ctx.pipeTrigger), !!ctx.paginator, ctx.page, ctx.perPage, ctx.pipeTrigger)), ctx.hasSummarizedColumns, ctx.summaryCalculationMode, ctx.summaryPosition, ctx.showSummaryOnCollapse, ctx.pipeTrigger, ctx.summaryPipeTrigger)), false, ctx.pipeTrigger), ctx.id, false, ctx.pipeTrigger))("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx.verticalScroll)("igxForContainerSize", ctx.calcHeight)("igxForItemSize", ctx.renderedRowHeight);
            i0.ɵɵadvance(12);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && !ctx.isRowPinningToTop ? pinnedRecordsTemplate_r26 : null);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(155, _c25, ctx));
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.shouldOverlayLoading ? 35 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag ? 36 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.scrollSize, "px")("height", ctx.calcHeight, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.calcHeight, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(157, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", !ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("outlet", igxBodyOverlayOutlet_r27)("actionText", ctx.resourceStrings.igx_grid_snackbar_addrow_actiontext)("displayTime", ctx.snackbarDisplayTime);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.resourceStrings.igx_grid_snackbar_addrow_label);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasSummarizedColumns && ctx.rootSummariesEnabled ? 52 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px")("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", ctx.isHorizontalScrollHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px")("min-width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.unpinnedWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(158, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.pinnedWidth, "px")("min-width", ctx.pinnedWidth, "px");
            i0.ɵɵproperty("hidden", ctx.pinnedWidth === 0 || ctx.isPinningToStart);
            i0.ɵɵadvance(13);
            i0.ɵɵconditional(ctx.rowEditable ? 73 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵconditional(ctx.colResizingService.showResizer ? 82 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.platform.isElements ? 87 : -1);
          }
        },
        dependencies: [NgClass, NgStyle, NgTemplateOutlet, IgxGridHeaderRowComponent, IgxGridBodyDirective, IgxGridDragSelectDirective, IgxColumnMovingDropDirective, IgxGridForOfDirective, IgxTemplateOutletDirective, IgxTreeGridRowComponent, IgxSummaryRowComponent, IgxOverlayOutletDirective, IgxToggleDirective, IgxCircularProgressBarComponent, IgxSnackbarComponent, IgxButtonDirective, IgxRippleDirective, IgxRowEditTabStopDirective, IgxIconComponent, IgxGridColumnResizerComponent, IgxHasVisibleColumnsPipe, IgxGridRowPinningPipe, IgxGridRowClassesPipe, IgxGridRowStylesPipe, IgxSummaryDataPipe, IgxTreeGridHierarchizingPipe, IgxTreeGridFlatteningPipe, IgxTreeGridSortingPipe, IgxTreeGridFilteringPipe, IgxTreeGridPagingPipe, IgxTreeGridTransactionPipe, IgxTreeGridSummaryPipe, IgxTreeGridNormalizeRecordsPipe, IgxTreeGridAddRowPipe, IgxStringReplacePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxTreeGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const HIDDEN_FIELD_NAME = '_Igx_Hidden_Data_';
/**
 * @hidden
 * @internal
 */
class GroupByRecord {}
class ITreeGridAggregation {}
let IgxGroupedTreeGridSorting = /*#__PURE__*/(() => {
  class IgxGroupedTreeGridSorting extends IgxSorting {
    static {
      this._instance = null;
    }
    static instance() {
      return this._instance || (this._instance = new IgxGroupedTreeGridSorting());
    }
    getFieldValue(obj, key, isDate = false, isTime = false) {
      const data = obj.data[HIDDEN_FIELD_NAME] ? obj.data.hasOwnProperty(key) ? obj.data : obj.data[HIDDEN_FIELD_NAME] : obj.data;
      return super.getFieldValue(data, key, isDate, isTime);
    }
  }
  return IgxGroupedTreeGridSorting;
})();
/** @hidden */
let IgxTreeGridGroupingPipe = /*#__PURE__*/(() => {
  class IgxTreeGridGroupingPipe {
    transform(collection, groupingExpressions, groupKey, childDataKey, grid, aggregations) {
      if (groupingExpressions.length === 0) {
        return collection;
      }
      if (groupKey?.toLowerCase() === childDataKey?.toLowerCase()) {
        throw new Error('Group key and child data key cannot be the same.');
      }
      this.grid = grid;
      const result = [];
      const groupedRecords = this.groupByMultiple(collection, groupingExpressions);
      this.flattenGrouping(groupedRecords, groupKey, childDataKey, result, aggregations);
      return result;
    }
    flattenGrouping(groupRecords, groupKey, childDataKey, data, aggregations = []) {
      for (const groupRecord of groupRecords) {
        const parent = {};
        const children = groupRecord.records;
        parent[childDataKey] = [];
        for (const aggregation of aggregations) {
          parent[aggregation.field] = aggregation.aggregate(parent, children);
        }
        parent[groupKey] = groupRecord.value + ` (${groupRecord.records.length})`;
        parent[HIDDEN_FIELD_NAME] = {
          [groupRecord.key]: groupRecord.value
        };
        data.push(parent);
        if (groupRecord.groups) {
          this.flattenGrouping(groupRecord.groups, groupKey, childDataKey, parent[childDataKey], aggregations);
        } else {
          parent[childDataKey] = children;
        }
      }
    }
    groupByMultiple(array, groupingExpressions, index = 0) {
      const res = this.groupBy(array, groupingExpressions[index]);
      if (index + 1 < groupingExpressions.length) {
        for (const groupByRecord of res) {
          groupByRecord.groups = this.groupByMultiple(groupByRecord.records, groupingExpressions, index + 1);
        }
      }
      return res;
    }
    groupBy(array, groupingExpression) {
      const key = groupingExpression.fieldName;
      const column = this.grid?.getColumnByName(key);
      const isDateTime = column?.dataType === GridColumnDataType.Date || column?.dataType === GridColumnDataType.DateTime || column?.dataType === GridColumnDataType.Time;
      const map = new Map();
      for (const record of array) {
        const value = isDateTime ? formatDate(record[key], column.pipeArgs.format, this.grid.locale) : record[key];
        let valueCase = value;
        let groupByRecord;
        if (groupingExpression.ignoreCase) {
          valueCase = value?.toString().toLowerCase();
        }
        if (map.has(valueCase)) {
          groupByRecord = map.get(valueCase);
        } else {
          groupByRecord = new GroupByRecord();
          groupByRecord.key = key;
          groupByRecord.value = value;
          groupByRecord.records = [];
          map.set(valueCase, groupByRecord);
        }
        groupByRecord.records.push(record);
      }
      return Array.from(map.values());
    }
    static {
      this.ɵfac = function IgxTreeGridGroupingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridGroupingPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "treeGridGrouping",
        type: IgxTreeGridGroupingPipe,
        pure: true
      });
    }
  }
  return IgxTreeGridGroupingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Tree grid directives collection for ease-of-use import in standalone components scenario */
const IGX_TREE_GRID_DIRECTIVES = [IgxTreeGridComponent, IgxTreeGridGroupByAreaComponent, IgxTreeGridGroupingPipe, IgxRowAddTextDirective, IgxRowEditActionsDirective, IgxRowEditTextDirective, IgxRowEditTabStopDirective,
// IGX_GRID_COMMON_DIRECTIVES:
IgxRowDirective, IgxGridFooterComponent, IgxAdvancedFilteringDialogComponent, IgxRowExpandedIndicatorDirective, IgxRowCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHeaderCollapsedIndicatorDirective, IgxExcelStyleHeaderIconDirective, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxDragIndicatorIconDirective, IgxRowDragGhostDirective, IgxGridStateDirective,
// IGX_GRID_HEADERS_DIRECTIVES:
IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent,
// IGX_GRID_COLUMN_DIRECTIVES:
IgxFilterCellTemplateDirective, IgxSummaryTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCellHeaderTemplateDirective, IgxCellFooterTemplateDirective, IgxCellEditorTemplateDirective, IgxCollapsibleIndicatorTemplateDirective, IgxColumnComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent,
// IGX_GRID_COLUMN_ACTIONS_DIRECTIVES:
IgxColumnActionsComponent, IgxColumnHidingDirective, IgxColumnPinningDirective,
// IGX_GRID_SELECTION_DIRECTIVES:
IgxRowSelectorDirective, IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective,
// IGX_GRID_TOOLBAR_DIRECTIVES:
IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridToolbarDirective,
// IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES:
IgxGridExcelStyleFilteringComponent, IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleMovingComponent, IgxExcelStyleSearchComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleLoadingValuesTemplateDirective,
// IGX_PAGINATOR_DIRECTIVES:
IgxColumnRequiredValidatorDirective, IgxColumnMinValidatorDirective, IgxColumnMaxValidatorDirective, IgxColumnEmailValidatorDirective, IgxColumnMinLengthValidatorDirective, IgxColumnMaxLengthValidatorDirective, IgxColumPatternValidatorDirective,
// IGX_PAGINATOR_DIRECTIVES:
IgxPaginatorComponent, IgxPageNavigationComponent, IgxPageSizeSelectorComponent, IgxPaginatorContentDirective, IgxPaginatorDirective];
let IgxHierarchicalGridAPIService = /*#__PURE__*/(() => {
  class IgxHierarchicalGridAPIService extends GridBaseAPIService {
    constructor() {
      super(...arguments);
      this.childRowIslands = new Map();
      this.childGrids = new Map();
    }
    registerChildRowIsland(rowIsland) {
      this.childRowIslands.set(rowIsland.key, rowIsland);
      this.destroyMap.set(rowIsland.key, new Subject());
    }
    unsetChildRowIsland(rowIsland) {
      this.childGrids.delete(rowIsland.key);
      this.childRowIslands.delete(rowIsland.key);
      this.destroyMap.delete(rowIsland.key);
    }
    getChildRowIsland(key) {
      return this.childRowIslands.get(key);
    }
    getChildGrid(path) {
      const currPath = path;
      let grid;
      const pathElem = currPath.shift();
      const childrenForLayout = this.childGrids.get(pathElem.rowIslandKey);
      if (childrenForLayout) {
        const childGrid = childrenForLayout.get(pathElem.rowKey);
        if (currPath.length === 0) {
          grid = childGrid;
        } else {
          grid = childGrid.gridAPI.getChildGrid(currPath);
        }
      }
      return grid;
    }
    getChildGrids(inDepth) {
      let allChildren = [];
      this.childGrids.forEach(layoutMap => {
        layoutMap.forEach(grid => {
          allChildren.push(grid);
          if (inDepth) {
            const children = grid.gridAPI.getChildGrids(inDepth);
            allChildren = allChildren.concat(children);
          }
        });
      });
      return allChildren;
    }
    getParentRowId(childGrid) {
      let rowID;
      this.childGrids.forEach(layoutMap => {
        layoutMap.forEach((grid, key) => {
          if (grid === childGrid) {
            rowID = key;
            return;
          }
        });
      });
      return rowID;
    }
    registerChildGrid(parentRowID, rowIslandKey, grid) {
      let childrenForLayout = this.childGrids.get(rowIslandKey);
      if (!childrenForLayout) {
        this.childGrids.set(rowIslandKey, new Map());
        childrenForLayout = this.childGrids.get(rowIslandKey);
      }
      childrenForLayout.set(parentRowID, grid);
    }
    getChildGridsForRowIsland(rowIslandKey) {
      const childrenForLayout = this.childGrids.get(rowIslandKey);
      const children = [];
      if (childrenForLayout) {
        childrenForLayout.forEach(child => {
          children.push(child);
        });
      }
      return children;
    }
    getChildGridByID(rowIslandKey, rowID) {
      const childrenForLayout = this.childGrids.get(rowIslandKey);
      return childrenForLayout.get(rowID);
    }
    get_row_expansion_state(record) {
      let inState;
      if (record.childGridsData !== undefined) {
        const ri = record.key;
        const states = this.grid.expansionStates;
        const expanded = states.get(ri);
        if (expanded !== undefined) {
          return expanded;
        } else {
          return this.grid.getDefaultExpandState(record);
        }
      } else {
        inState = !!super.get_row_expansion_state(record);
      }
      return inState && this.grid.childLayoutList.length !== 0;
    }
    allow_expansion_state_change(rowID, expanded) {
      const rec = this.get_rec_by_id(rowID);
      const grid = this.grid;
      if (grid.hasChildrenKey && !rec[grid.hasChildrenKey]) {
        return false;
      }
      return !!rec && this.grid.expansionStates.get(rowID) !== expanded;
    }
    get_rec_by_id(rowID) {
      const data = this.get_all_data(false);
      const index = this.get_row_index_in_data(rowID, data);
      return data[index];
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxHierarchicalGridAPIService_BaseFactory;
        return function IgxHierarchicalGridAPIService_Factory(__ngFactoryType__) {
          return (ɵIgxHierarchicalGridAPIService_BaseFactory || (ɵIgxHierarchicalGridAPIService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxHierarchicalGridAPIService)))(__ngFactoryType__ || IgxHierarchicalGridAPIService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxHierarchicalGridAPIService,
        factory: IgxHierarchicalGridAPIService.ɵfac
      });
    }
  }
  return IgxHierarchicalGridAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxHierarchicalGridNavigationService = /*#__PURE__*/(() => {
  class IgxHierarchicalGridNavigationService extends IgxGridNavigationService {
    constructor() {
      super(...arguments);
      this._pendingNavigation = false;
    }
    dispatchEvent(event) {
      const key = event.key.toLowerCase();
      const cellOrRowInEdit = this.grid.crudService.cell || this.grid.crudService.row;
      if (!this.activeNode || !(SUPPORTED_KEYS.has(key) || key === 'tab' && cellOrRowInEdit)) {
        return;
      }
      const targetGrid = this.getClosestElemByTag(event.target, 'igx-hierarchical-grid') || this.getClosestElemByTag(event.target, 'igc-hierarchical-grid');
      if (targetGrid !== this.grid.nativeElement) {
        return;
      }
      if (this._pendingNavigation && NAVIGATION_KEYS.has(key)) {
        // In case focus needs to be moved from one grid to another, however there is a pending scroll operation
        // which is an async operation, any additional navigation keys should be ignored
        // untill operation complete.
        event.preventDefault();
        return;
      }
      super.dispatchEvent(event);
    }
    navigateInBody(rowIndex, visibleColIndex, cb = null) {
      const rec = this.grid.dataView[rowIndex];
      if (rec && this.grid.isChildGridRecord(rec)) {
        // target is child grid
        const virtState = this.grid.verticalScrollContainer.state;
        const inView = rowIndex >= virtState.startIndex && rowIndex <= virtState.startIndex + virtState.chunkSize;
        const isNext = this.activeNode.row < rowIndex;
        const targetLayoutIndex = isNext ? null : this.grid.childLayoutKeys.length - 1;
        if (inView) {
          this._moveToChild(rowIndex, visibleColIndex, isNext, targetLayoutIndex, cb);
        } else {
          let scrollAmount = this.grid.verticalScrollContainer.getScrollForIndex(rowIndex, !isNext);
          scrollAmount += isNext ? 1 : -1;
          this.grid.verticalScrollContainer.getScroll().scrollTop = scrollAmount;
          this._pendingNavigation = true;
          this.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
            this._moveToChild(rowIndex, visibleColIndex, isNext, targetLayoutIndex, cb);
            this._pendingNavigation = false;
          });
        }
        return;
      }
      const isLast = rowIndex === this.grid.dataView.length;
      if ((rowIndex === -1 || isLast) && this.grid.parent !== null) {
        // reached end of child grid
        const nextSiblingIndex = this.nextSiblingIndex(isLast);
        if (nextSiblingIndex !== null) {
          this.grid.parent.navigation._moveToChild(this.grid.childRow.index, visibleColIndex, isLast, nextSiblingIndex, cb);
        } else {
          this._moveToParent(isLast, visibleColIndex, cb);
        }
        return;
      }
      if (this.grid.parent) {
        const isNext = this.activeNode && typeof this.activeNode.row === 'number' ? rowIndex > this.activeNode.row : false;
        const cbHandler = args => {
          this._handleScrollInChild(rowIndex, isNext);
          cb(args);
        };
        if (!this.activeNode) {
          this.activeNode = {
            row: null,
            column: null
          };
        }
        super.navigateInBody(rowIndex, visibleColIndex, cbHandler);
        return;
      }
      if (!this.activeNode) {
        this.activeNode = {
          row: null,
          column: null
        };
      }
      super.navigateInBody(rowIndex, visibleColIndex, cb);
    }
    shouldPerformVerticalScroll(index, visibleColumnIndex = -1, isNext) {
      const targetRec = this.grid.dataView[index];
      if (this.grid.isChildGridRecord(targetRec)) {
        const scrollAmount = this.grid.verticalScrollContainer.getScrollForIndex(index, !isNext);
        const currScroll = this.grid.verticalScrollContainer.getScroll().scrollTop;
        const shouldScroll = !isNext ? scrollAmount > currScroll : currScroll < scrollAmount;
        return shouldScroll;
      } else {
        return super.shouldPerformVerticalScroll(index, visibleColumnIndex);
      }
    }
    focusTbody(event) {
      if (!this.activeNode || this.activeNode.row === null) {
        this.activeNode = {
          row: 0,
          column: 0
        };
        this.grid.navigateTo(0, 0, obj => {
          this.grid.clearCellSelection();
          obj.target.activate(event);
        });
      } else {
        super.focusTbody(event);
      }
    }
    nextSiblingIndex(isNext) {
      const layoutKey = this.grid.childRow.layout.key;
      const layoutIndex = this.grid.parent.childLayoutKeys.indexOf(layoutKey);
      const nextIndex = isNext ? layoutIndex + 1 : layoutIndex - 1;
      if (nextIndex <= this.grid.parent.childLayoutKeys.length - 1 && nextIndex > -1) {
        return nextIndex;
      } else {
        return null;
      }
    }
    /**
     * Handles scrolling in child grid and ensures target child row is in main grid view port.
     *
     * @param rowIndex The row index which should be in view.
     * @param isNext  Optional. Whether we are navigating to next. Used to determine scroll direction.
     * @param cb  Optional.Callback function called when operation is complete.
     */
    _handleScrollInChild(rowIndex, isNext, cb) {
      const shouldScroll = this.shouldPerformVerticalScroll(rowIndex, -1, isNext);
      if (shouldScroll) {
        this.grid.navigation.performVerticalScrollToCell(rowIndex, -1, () => {
          this.positionInParent(rowIndex, isNext, cb);
        });
      } else {
        this.positionInParent(rowIndex, isNext, cb);
      }
    }
    /**
     *
     * @param rowIndex Row index that should come in view.
     * @param isNext  Whether we are navigating to next. Used to determine scroll direction.
     * @param cb  Optional.Callback function called when operation is complete.
     */
    positionInParent(rowIndex, isNext, cb) {
      const row = this.grid.gridAPI.get_row_by_index(rowIndex);
      if (!row) {
        if (cb) {
          cb();
        }
        return;
      }
      const positionInfo = this.getPositionInfo(row, isNext);
      if (!positionInfo.inView) {
        // stop event from triggering multiple times before scrolling is complete.
        this._pendingNavigation = true;
        const scrollableGrid = isNext ? this.getNextScrollableDown(this.grid) : this.getNextScrollableUp(this.grid);
        scrollableGrid.grid.verticalScrollContainer.recalcUpdateSizes();
        scrollableGrid.grid.verticalScrollContainer.addScrollTop(positionInfo.offset);
        scrollableGrid.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
          this._pendingNavigation = false;
          if (cb) {
            cb();
          }
        });
      } else {
        if (cb) {
          cb();
        }
      }
    }
    /**
     * Navigates to the specific child grid based on the array of paths leading to it
     *
     * @param pathToChildGrid Array of IPathSegments that describe the path to the child grid
     * each segment is described by the rowKey of the parent row and the rowIslandKey.
     */
    navigateToChildGrid(pathToChildGrid, cb) {
      if (pathToChildGrid.length == 0) {
        if (cb) {
          cb();
        }
        return;
      }
      const pathElem = pathToChildGrid.shift();
      const rowKey = pathElem.rowKey;
      const rowIndex = this.grid.gridAPI.get_row_index_in_data(rowKey);
      if (rowIndex === -1) {
        if (cb) {
          cb();
        }
        return;
      }
      // scroll to row, since it can be out of view
      this.performVerticalScrollToCell(rowIndex, -1, () => {
        this.grid.cdr.detectChanges();
        // next, expand row, if it is collapsed
        const row = this.grid.getRowByIndex(rowIndex);
        if (!row.expanded) {
          row.expanded = true;
          // update sizes after expand
          this.grid.verticalScrollContainer.recalcUpdateSizes();
          this.grid.cdr.detectChanges();
        }
        const childGrid = this.grid.gridAPI.getChildGrid([pathElem]);
        if (!childGrid) {
          if (cb) {
            cb();
          }
          return;
        }
        const positionInfo = this.getElementPosition(childGrid.nativeElement, false);
        this.grid.verticalScrollContainer.addScrollTop(positionInfo.offset);
        this.grid.verticalScrollContainer.chunkLoad.pipe(first$2()).subscribe(() => {
          childGrid.navigation.navigateToChildGrid(pathToChildGrid, cb);
        });
      });
    }
    /**
     * Moves navigation to child grid.
     *
     * @param parentRowIndex The parent row index, at which the child grid is rendered.
     * @param childLayoutIndex Optional. The index of the child row island to which the child grid belongs to. Uses first if not set.
     */
    _moveToChild(parentRowIndex, visibleColIndex, isNext, childLayoutIndex, cb) {
      const ri = typeof childLayoutIndex !== 'number' ? this.grid.childLayoutList.first : this.grid.childLayoutList.toArray()[childLayoutIndex];
      const rowId = this.grid.dataView[parentRowIndex].rowID;
      const pathSegment = {
        rowID: rowId,
        rowKey: rowId,
        rowIslandKey: ri.key
      };
      const childGrid = this.grid.gridAPI.getChildGrid([pathSegment]);
      const targetIndex = isNext ? 0 : childGrid.dataView.length - 1;
      const targetRec = childGrid.dataView[targetIndex];
      if (!targetRec) {
        // if no target rec, then move on in next sibling or parent
        childGrid.navigation.navigateInBody(targetIndex, visibleColIndex, cb);
        return;
      }
      if (childGrid.isChildGridRecord(targetRec)) {
        // if target is a child grid record should move into it.
        this.grid.navigation.activeNode.row = null;
        childGrid.navigation.activeNode = {
          row: targetIndex,
          column: this.activeNode.column
        };
        childGrid.navigation._handleScrollInChild(targetIndex, isNext, () => {
          const targetLayoutIndex = isNext ? 0 : childGrid.childLayoutList.toArray().length - 1;
          childGrid.navigation._moveToChild(targetIndex, visibleColIndex, isNext, targetLayoutIndex, cb);
        });
        return;
      }
      const childGridNav = childGrid.navigation;
      this.clearActivation();
      const lastVisibleIndex = childGridNav.lastColumnIndex;
      const columnIndex = visibleColIndex <= lastVisibleIndex ? visibleColIndex : lastVisibleIndex;
      childGridNav.activeNode = {
        row: targetIndex,
        column: columnIndex
      };
      childGrid.tbody.nativeElement.focus({
        preventScroll: true
      });
      this._pendingNavigation = false;
      childGrid.navigation._handleScrollInChild(targetIndex, isNext, () => {
        childGrid.navigateTo(targetIndex, columnIndex, cb);
      });
    }
    /**
     * Moves navigation back to parent grid.
     *
     * @param rowIndex
     */
    _moveToParent(isNext, columnIndex, cb) {
      const indexInParent = this.grid.childRow.index;
      const hasNextTarget = this.hasNextTarget(this.grid.parent, indexInParent, isNext);
      if (!hasNextTarget) {
        return;
      }
      this.clearActivation();
      const targetRowIndex = isNext ? indexInParent + 1 : indexInParent - 1;
      const lastVisibleIndex = this.grid.parent.navigation.lastColumnIndex;
      const nextColumnIndex = columnIndex <= lastVisibleIndex ? columnIndex : lastVisibleIndex;
      this._pendingNavigation = true;
      const cbFunc = args => {
        this._pendingNavigation = false;
        cb(args);
        args.target.grid.tbody.nativeElement.focus();
      };
      this.grid.parent.navigation.navigateInBody(targetRowIndex, nextColumnIndex, cbFunc);
    }
    /**
     * Gets information on the row position relative to the root grid view port.
     * Returns whether the row is in view and its offset.
     *
     * @param rowObj
     * @param isNext
     */
    getPositionInfo(row, isNext) {
      // XXX: Fix type
      let rowElem = row.nativeElement;
      if (row.layout) {
        const childLayoutKeys = this.grid.childLayoutKeys;
        const riKey = isNext ? childLayoutKeys[0] : childLayoutKeys[childLayoutKeys.length - 1];
        const pathSegment = {
          rowID: row.data.rowID,
          rowKey: row.data.rowID,
          rowIslandKey: riKey
        };
        const childGrid = this.grid.gridAPI.getChildGrid([pathSegment]);
        rowElem = childGrid.tfoot.nativeElement;
      }
      return this.getElementPosition(rowElem, isNext);
    }
    getElementPosition(element, isNext) {
      // Special handling for scenarios where there is css transformations applied that affects scale.
      // getBoundingClientRect().height returns size after transformations
      // element.offsetHeight returns size without any transformations
      // get the ratio to figure out if anything has applied transformations
      const scaling = element.getBoundingClientRect().height / element.offsetHeight;
      const gridBottom = this._getMinBottom(this.grid);
      const diffBottom = element.getBoundingClientRect().bottom - gridBottom;
      const gridTop = this._getMaxTop(this.grid);
      const diffTop = element.getBoundingClientRect().bottom - element.getBoundingClientRect().height - gridTop;
      // Adding Math.Round because Chrome has some inconsistencies when the page is zoomed
      const isInView = isNext ? Math.round(diffBottom) <= 0 : Math.round(diffTop) >= 0;
      const calcOffset = isNext ? diffBottom : diffTop;
      return {
        inView: isInView,
        offset: calcOffset / scaling
      };
    }
    /**
     * Gets closest element by its tag name.
     *
     * @param sourceElem The element from which to start the search.
     * @param targetTag The target element tag name, for which to search.
     */
    getClosestElemByTag(sourceElem, targetTag) {
      let result = sourceElem;
      while (result !== null && result.nodeType === 1) {
        if (result.tagName.toLowerCase() === targetTag.toLowerCase()) {
          return result;
        }
        result = result.parentNode;
      }
      return null;
    }
    clearActivation() {
      // clear if previous activation exists.
      if (this.activeNode && Object.keys(this.activeNode).length) {
        this.activeNode = Object.assign({});
      }
    }
    hasNextTarget(grid, index, isNext) {
      const targetRowIndex = isNext ? index + 1 : index - 1;
      const hasTargetRecord = !!grid.dataView[targetRowIndex];
      if (hasTargetRecord) {
        return true;
      } else {
        let hasTargetRecordInParent = false;
        if (grid.parent) {
          const indexInParent = grid.childRow.index;
          hasTargetRecordInParent = this.hasNextTarget(grid.parent, indexInParent, isNext);
        }
        return hasTargetRecordInParent;
      }
    }
    /**
     * Gets the max top view in the current grid hierarchy.
     *
     * @param grid
     */
    _getMaxTop(grid) {
      let currGrid = grid;
      let top = currGrid.tbody.nativeElement.getBoundingClientRect().top;
      while (currGrid.parent) {
        currGrid = currGrid.parent;
        const pinnedRowsHeight = currGrid.hasPinnedRecords && currGrid.isRowPinningToTop ? currGrid.pinnedRowHeight : 0;
        top = Math.max(top, currGrid.tbody.nativeElement.getBoundingClientRect().top + pinnedRowsHeight);
      }
      return top;
    }
    /**
     * Gets the min bottom view in the current grid hierarchy.
     *
     * @param grid
     */
    _getMinBottom(grid) {
      let currGrid = grid;
      let bottom = currGrid.tbody.nativeElement.getBoundingClientRect().bottom;
      while (currGrid.parent) {
        currGrid = currGrid.parent;
        const pinnedRowsHeight = currGrid.hasPinnedRecords && !currGrid.isRowPinningToTop ? currGrid.pinnedRowHeight : 0;
        bottom = Math.min(bottom, currGrid.tbody.nativeElement.getBoundingClientRect().bottom - pinnedRowsHeight);
      }
      return bottom;
    }
    /**
     * Finds the next grid that allows scrolling down.
     *
     * @param grid The grid from which to begin the search.
     */
    getNextScrollableDown(grid) {
      let currGrid = grid.parent;
      if (!currGrid) {
        return {
          grid,
          prev: null
        };
      }
      let scrollTop = currGrid.verticalScrollContainer.scrollPosition;
      let scrollHeight = currGrid.verticalScrollContainer.getScroll().scrollHeight;
      let nonScrollable = scrollHeight === 0 || Math.round(scrollTop + currGrid.verticalScrollContainer.igxForContainerSize) === scrollHeight;
      let prev = grid;
      while (nonScrollable && currGrid.parent !== null) {
        prev = currGrid;
        currGrid = currGrid.parent;
        scrollTop = currGrid.verticalScrollContainer.scrollPosition;
        scrollHeight = currGrid.verticalScrollContainer.getScroll().scrollHeight;
        nonScrollable = scrollHeight === 0 || Math.round(scrollTop + currGrid.verticalScrollContainer.igxForContainerSize) === scrollHeight;
      }
      return {
        grid: currGrid,
        prev
      };
    }
    /**
     * Finds the next grid that allows scrolling up.
     *
     * @param grid The grid from which to begin the search.
     */
    getNextScrollableUp(grid) {
      let currGrid = grid.parent;
      if (!currGrid) {
        return {
          grid,
          prev: null
        };
      }
      let nonScrollable = currGrid.verticalScrollContainer.scrollPosition === 0;
      let prev = grid;
      while (nonScrollable && currGrid.parent !== null) {
        prev = currGrid;
        currGrid = currGrid.parent;
        nonScrollable = currGrid.verticalScrollContainer.scrollPosition === 0;
      }
      return {
        grid: currGrid,
        prev
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxHierarchicalGridNavigationService_BaseFactory;
        return function IgxHierarchicalGridNavigationService_Factory(__ngFactoryType__) {
          return (ɵIgxHierarchicalGridNavigationService_BaseFactory || (ɵIgxHierarchicalGridNavigationService_BaseFactory = i0.ɵɵgetInheritedFactory(IgxHierarchicalGridNavigationService)))(__ngFactoryType__ || IgxHierarchicalGridNavigationService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxHierarchicalGridNavigationService,
        factory: IgxHierarchicalGridNavigationService.ɵfac
      });
    }
  }
  return IgxHierarchicalGridNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const hierarchicalTransactionServiceFactory = () => new IgxTransactionService();
const IgxHierarchicalTransactionServiceFactory = {
  provide: IgxGridTransaction,
  useFactory: hierarchicalTransactionServiceFactory
};
/* blazorIndirectRender
   blazorComponent
   omitModule
   wcSkipComponentSuffix */
let IgxHierarchicalGridBaseDirective = /*#__PURE__*/(() => {
  class IgxHierarchicalGridBaseDirective extends IgxGridBaseDirective {
    /** @hidden @internal */
    get type() {
      return 'hierarchical';
    }
    /**
     * @hidden
     */
    get maxLevelHeaderDepth() {
      if (this._maxLevelHeaderDepth === null) {
        this._maxLevelHeaderDepth = this.columns.reduce((acc, col) => Math.max(acc, col.level), 0);
      }
      return this._maxLevelHeaderDepth;
    }
    /* blazorSuppress */
    /**
     * Gets the outlet used to attach the grid's overlays to.
     *
     * @remarks
     * If set, returns the outlet defined outside the grid. Otherwise returns the grid's internal outlet directive.
     */
    get outlet() {
      return this.rootGrid ? this.rootGrid.resolveOutlet() : this.resolveOutlet();
    }
    /* blazorSuppress */
    /**
     * Sets the outlet used to attach the grid's overlays to.
     */
    set outlet(val) {
      this._userOutletDirective = val;
    }
    get batchEditing() {
      return this._batchEditing;
    }
    set batchEditing(val) {
      if (val !== this._batchEditing) {
        delete this._transactions;
        this.switchTransactionService(val);
        this.subscribeToTransactions();
        this.batchEditingChange.emit(val);
        this._batchEditing = val;
      }
    }
    constructor(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions) {
      super(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform, _diTransactions);
      this.gridAPI = gridAPI;
      this.navigation = navigation;
      /**
       * Gets/Sets whether the expand/collapse all button in the header should be rendered.
       *
       * @remarks
       * The default value is false.
       * @example
       * ```html
       * <igx-hierarchical-grid #grid [data]="localData" [showExpandAll]="true">
       * </igx-hierarchical-grid>
       * ```
       */
      this.showExpandAll = false;
      /**
       * Emitted when a new chunk of data is loaded from virtualization.
       *
       * @example
       * ```typescript
       *  <igx-hierarchical-grid [id]="'igx-grid-1'" [data]="Data" [autoGenerate]="true" (dataPreLoad)="handleEvent()">
       *  </igx-hierarchical-grid>
       * ```
       */
      this.dataPreLoad = new EventEmitter();
      /** @hidden @internal */
      this.batchEditingChange = new EventEmitter();
    }
    /**
     * @hidden
     */
    createColumnsList(cols) {
      const columns = [];
      const topLevelCols = cols.filter(c => c.level === 0);
      topLevelCols.forEach(col => {
        col.grid = this;
        const ref = this._createColumn(col);
        ref.changeDetectorRef.detectChanges();
        columns.push(ref.instance);
      });
      const result = flatten(columns);
      this.updateColumns(result);
      this.initPinning();
      result.forEach(col => {
        this.columnInit.emit(col);
      });
      const mirror = reflectComponentType(IgxColumnComponent);
      const outputs = mirror.outputs.filter(o => o.propName !== 'columnChange');
      outputs.forEach(output => {
        this.columns.forEach(column => {
          if (column[output.propName]) {
            column[output.propName].pipe(takeUntil(column.destroy$)).subscribe(args => {
              const rowIslandColumn = this.parentIsland.columnList.find(col => col.field ? col.field === column.field : col.header === column.header);
              rowIslandColumn[output.propName].emit({
                args,
                owner: this
              });
            });
          }
        });
      });
    }
    _createColumn(col) {
      let ref;
      if (col instanceof IgxColumnGroupComponent) {
        ref = this._createColGroupComponent(col);
      } else {
        ref = this._createColComponent(col);
      }
      return ref;
    }
    _createColGroupComponent(col) {
      const ref = createComponent(IgxColumnGroupComponent, {
        environmentInjector: this.envInjector,
        elementInjector: this.injector
      });
      ref.changeDetectorRef.detectChanges();
      const mirror = reflectComponentType(IgxColumnGroupComponent);
      mirror.inputs.forEach(input => {
        const propName = input.propName;
        ref.instance[propName] = col[propName];
      });
      if (col.children.length > 0) {
        const newChildren = [];
        col.children.forEach(child => {
          const newCol = this._createColumn(child).instance;
          newCol.parent = ref.instance;
          newChildren.push(newCol);
        });
        ref.instance.children.reset(newChildren);
        ref.instance.children.notifyOnChanges();
      }
      return ref;
    }
    _createColComponent(col) {
      const ref = createComponent(IgxColumnComponent, {
        environmentInjector: this.envInjector,
        elementInjector: this.injector
      });
      const mirror = reflectComponentType(IgxColumnComponent);
      mirror.inputs.forEach(input => {
        const propName = input.propName;
        if (!(col[propName] instanceof IgxSummaryOperand)) {
          ref.instance[propName] = col[propName];
        } else {
          ref.instance[propName] = col[propName].constructor;
        }
      });
      ref.instance.validators = col.validators;
      return ref;
    }
    getGridsForIsland(rowIslandID) {
      return this.gridAPI.getChildGridsForRowIsland(rowIslandID);
    }
    getChildGrid(path) {
      if (!path) {
        return;
      }
      return this.gridAPI.getChildGrid(path);
    }
    static {
      this.ɵfac = function IgxHierarchicalGridBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHierarchicalGridBaseDirective)(i0.ɵɵdirectiveInject(IgxGridValidationService), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(IgxFlatTransactionFactory), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(IgxHierarchicalGridNavigationService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxGridSummaryService), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxGridTransaction, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxHierarchicalGridBaseDirective,
        inputs: {
          hasChildrenKey: "hasChildrenKey",
          showExpandAll: [2, "showExpandAll", "showExpandAll", booleanAttribute]
        },
        outputs: {
          dataPreLoad: "dataPreLoad"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxHierarchicalGridBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const flatten = arr => {
  let result = [];
  arr.forEach(el => {
    result.push(el);
    if (el.children) {
      result = result.concat(flatten(el.children.toArray()));
    }
  });
  return result;
};
let IgxRowIslandAPIService = /*#__PURE__*/(() => {
  class IgxRowIslandAPIService {
    constructor() {
      this.change = new Subject();
      this.state = new Map();
      this.destroyMap = new Map();
      this.childRowIslands = new Map();
      this.childGrids = new Map();
    }
    register(rowIsland) {
      this.state.set(rowIsland.id, rowIsland);
      this.destroyMap.set(rowIsland.id, new Subject());
    }
    unsubscribe(rowIsland) {
      this.state.delete(rowIsland.id);
    }
    get(id) {
      return this.state.get(id);
    }
    unset(id) {
      this.state.delete(id);
      this.destroyMap.delete(id);
    }
    reset(oldId, newId) {
      const destroy = this.destroyMap.get(oldId);
      const rowIsland = this.get(oldId);
      this.unset(oldId);
      if (rowIsland) {
        this.state.set(newId, rowIsland);
      }
      if (destroy) {
        this.destroyMap.set(newId, destroy);
      }
    }
    registerChildRowIsland(rowIsland) {
      this.childRowIslands.set(rowIsland.key, rowIsland);
      this.destroyMap.set(rowIsland.key, new Subject());
    }
    unsetChildRowIsland(rowIsland) {
      this.childRowIslands.delete(rowIsland.key);
      this.destroyMap.delete(rowIsland.key);
    }
    getChildRowIsland(rowIslandKey) {
      return this.childRowIslands.get(rowIslandKey);
    }
    registerChildGrid(parentRowID, grid) {
      this.childGrids.set(parentRowID, grid);
    }
    getChildGrids(inDepth) {
      let allChildren = [];
      this.childGrids.forEach(grid => {
        allChildren.push(grid);
      });
      if (inDepth) {
        this.childRowIslands.forEach(layout => {
          allChildren = allChildren.concat(layout.rowIslandAPI.getChildGrids(inDepth));
        });
      }
      return allChildren;
    }
    getChildGridByID(rowID) {
      return this.childGrids.get(rowID);
    }
    static {
      this.ɵfac = function IgxRowIslandAPIService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowIslandAPIService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxRowIslandAPIService,
        factory: IgxRowIslandAPIService.ɵfac
      });
    }
  }
  return IgxRowIslandAPIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* blazorCopyInheritedMembers */
/* blazorElement */
/* wcElementTag: igc-row-island */
/* blazorIndirectRender */
/* jsonAPIManageCollectionInMarkup */
/* jsonAPIManageItemInMarkup */
/* mustUseNGParentAnchor */
/* additionalIdentifier: ChildDataKey */
/* contentParent: RowIsland */
/* contentParent: HierarchicalGrid */
/**
 * Row island
 *
 * @igxModule IgxHierarchicalGridModule
 * @igxParent IgxHierarchicalGridComponent, IgxRowIslandComponent
 *
 */
let IgxRowIslandComponent = /*#__PURE__*/(() => {
  class IgxRowIslandComponent extends IgxHierarchicalGridBaseDirective {
    /* blazorInclude,wcInclude TODO: Move to Elements-only component */
    /**
     * Sets the key of the row island by which child data would be taken from the row data if such is provided.
     * @hidden @internal
     */
    get childDataKey() {
      return this.key;
    }
    /* blazorInclude,wcInclude */
    set childDataKey(value) {
      this.key = value;
    }
    /* csSuppress */
    /**
     * Sets/Gets the toolbar template for each child grid created from this row island.
    */
    get toolbarTemplate() {
      return this._toolbarTemplate || this.toolbarDirectiveTemplate;
    }
    set toolbarTemplate(template) {
      this._toolbarTemplate = template;
    }
    /* csSuppress */
    /**
     * Sets/Gets the paginator template for each child grid created from this row island.
    */
    get paginatorTemplate() {
      return this._paginatorTemplate || this.paginatorDirectiveTemplate;
    }
    set paginatorTemplate(template) {
      this._paginatorTemplate = template;
    }
    /** @hidden */
    get hiddenColumnsCount() {
      return 0;
    }
    /** @hidden */
    get pinnedColumnsCount() {
      return 0;
    }
    /** @hidden */
    get lastSearchInfo() {
      return null;
    }
    /** @hidden */
    get filteredData() {
      return [];
    }
    /** @hidden */
    get filteredSortedData() {
      return [];
    }
    /** @hidden */
    get virtualizationState() {
      return null;
    }
    /** @hidden */
    get pinnedColumns() {
      return [];
    }
    /** @hidden */
    get unpinnedColumns() {
      return [];
    }
    /** @hidden */
    get visibleColumns() {
      return [];
    }
    /** @hidden */
    get dataView() {
      return [];
    }
    /**
     * Sets if all immediate children of the grids for this `IgxRowIslandComponent` should be expanded/collapsed.
     * ```html
     * <igx-hierarchical-grid [data]="Data" [autoGenerate]="true">
     *      <igx-row-island [key]="'childData'" [expandChildren]="true" #rowIsland>
     *          <!-- ... -->
     *      </igx-row-island>
     * </igx-hierarchical-grid>
     * ```
     *
     * @memberof IgxRowIslandComponent
     */
    set expandChildren(value) {
      this._defaultExpandState = value;
      this.rowIslandAPI.getChildGrids().forEach(grid => {
        if (this.document.body.contains(grid.nativeElement)) {
          // Detect changes right away if the grid is visible
          grid.expandChildren = value;
          grid.cdr.detectChanges();
        } else {
          // Else defer the detection on changes when the grid gets into view for performance.
          grid.updateOnRender = true;
        }
      });
    }
    /**
     * Gets if all immediate children of the grids for this `IgxRowIslandComponent` have been set to be expanded/collapsed.
     * ```typescript
     * const expanded = this.rowIsland.expandChildren;
     * ```
     *
     * @memberof IgxRowIslandComponent
     */
    get expandChildren() {
      return this._defaultExpandState;
    }
    /**
     * @hidden
     */
    get id() {
      const pId = this.parentId ? this.parentId.substring(this.parentId.indexOf(this.layout_id) + this.layout_id.length) + '-' : '';
      return this.layout_id + pId + this.key;
    }
    /**
     * @hidden
     */
    get parentId() {
      return this.parentIsland ? this.parentIsland.id : null;
    }
    /**
     * @hidden
     */
    get level() {
      let ptr = this.parentIsland;
      let lvl = 0;
      while (ptr) {
        lvl++;
        ptr = ptr.parentIsland;
      }
      return lvl + 1;
    }
    constructor(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, rowIslandAPI, localeId, platform) {
      super(validationService, selectionService, colResizingService, gridAPI, transactionFactory, elementRef, zone, document, cdr, differs, viewRef, injector, envInjector, navigation, filteringService, textHighlightService, overlayService, summaryService, localeId, platform);
      this.rowIslandAPI = rowIslandAPI;
      /**
       * @hidden
       */
      this.children = new QueryList();
      /* contentChildren */
      /* blazorInclude */
      /* blazorTreatAsCollection */
      /* blazorCollectionName: RowIslandCollection */
      /**
       * @hidden @internal
       */
      this.childLayoutList = new QueryList();
      /**
       * @hidden
       */
      this.childColumns = new QueryList();
      /**
       * @hidden
       */
      this.layoutChange = new EventEmitter();
      /**
       * Event emitted when a grid is being created based on this row island.
       * ```html
       * <igx-hierarchical-grid [data]="Data" [autoGenerate]="true">
       *      <igx-row-island [key]="'childData'" (gridCreated)="gridCreated($event)" #rowIsland>
       *          <!-- ... -->
       *      </igx-row-island>
       * </igx-hierarchical-grid>
       * ```
       *
       * @memberof IgxRowIslandComponent
       */
      this.gridCreated = new EventEmitter();
      /**
       * Emitted after a grid is being initialized for this row island.
       * The emitting is done in `ngAfterViewInit`.
       * ```html
       * <igx-hierarchical-grid [data]="Data" [autoGenerate]="true">
       *      <igx-row-island [key]="'childData'" (gridInitialized)="gridInitialized($event)" #rowIsland>
       *          <!-- ... -->
       *      </igx-row-island>
       * </igx-hierarchical-grid>
       * ```
       *
       * @memberof IgxRowIslandComponent
       */
      this.gridInitialized = new EventEmitter();
      /**
       * @hidden
       */
      this.initialChanges = [];
      /**
       * @hidden
       */
      this.rootGrid = null;
      this.layout_id = `igx-row-island-`;
      this.isInit = false;
      this._childColumns = [];
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this.filteringService.grid = this;
      this.rootGrid = this.gridAPI.grid;
      this.rowIslandAPI.rowIsland = this;
      this.ri_columnListDiffer = this.differs.find([]).create(null);
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      this.updateChildren();
      this.children.notifyOnChanges();
      this.children.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateChildren();
        // update existing grids since their child ri have been changed.
        this.getGridsForIsland(this.key).forEach(grid => {
          grid.onRowIslandChange(this.children);
        });
      });
      const nestedColumns = this.children.map(layout => layout.columnList.toArray());
      const colsArray = [].concat.apply([], nestedColumns);
      const topCols = this.columnList.filter(item => colsArray.indexOf(item) === -1);
      this._childColumns = topCols;
      this.updateColumns(this._childColumns);
      this.columnList.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        Promise.resolve().then(() => {
          this.updateColumnList();
        });
      });
      // handle column changes so that they are passed to child grid instances when columnChange is emitted.
      this.ri_columnListDiffer.diff(this.childColumns);
      this._childColumns.forEach(x => x.columnChange.pipe(takeUntil(x.destroy$)).subscribe(() => this.updateColumnList()));
      this.childColumns.changes.pipe(takeUntil(this.destroy$)).subscribe(change => {
        const diff = this.ri_columnListDiffer.diff(change);
        if (diff) {
          diff.forEachAddedItem(record => {
            record.item.columnChange.pipe(takeUntil(record.item.destroy$)).subscribe(() => this.updateColumnList());
          });
        }
      });
      if (this.actionStrip) {
        this.actionStrip.menuOverlaySettings.outlet = this.outlet;
      }
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this.rowIslandAPI.register(this);
      if (this.parentIsland) {
        this.parentIsland.rowIslandAPI.registerChildRowIsland(this);
      } else {
        this.rootGrid.gridAPI.registerChildRowIsland(this);
      }
      this._init = false;
      // Create the child toolbar if the parent island has a toolbar definition
      this.gridCreated.pipe(pluck('grid'), takeUntil(this.destroy$)).subscribe(grid => {
        grid.rendered$.pipe(first$2(), filter(() => !!this.toolbarTemplate)).subscribe(() => grid.toolbarOutlet.createEmbeddedView(this.toolbarTemplate, {
          $implicit: grid
        }, {
          injector: grid.toolbarOutlet.injector
        }));
        grid.rendered$.pipe(first$2(), filter(() => !!this.paginatorTemplate)).subscribe(() => {
          this.rootGrid.paginatorList.changes.pipe(takeUntil(this.destroy$)).subscribe(changes => {
            changes.forEach(p => {
              if (p.nativeElement.offsetParent?.id === grid.id) {
                // Optimize update only for those grids that have related changed paginator.
                grid.setUpPaginator();
              }
            });
          });
          grid.paginatorOutlet.createEmbeddedView(this.paginatorTemplate, {
            $implicit: grid
          });
        });
      });
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      this.layoutChange.emit(changes);
      if (!this.isInit) {
        this.initialChanges.push(changes);
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      // Override the base destroy because we have not rendered anything to use removeEventListener on
      this.destroy$.next(true);
      this.destroy$.complete();
      this._destroyed = true;
      this.rowIslandAPI.unset(this.id);
      if (this.parentIsland) {
        this.getGridsForIsland(this.key).forEach(grid => {
          this.cleanGridState(grid);
          grid.gridAPI.unsetChildRowIsland(this);
        });
        this.parentIsland.rowIslandAPI.unsetChildRowIsland(this);
      } else {
        this.rootGrid.gridAPI.unsetChildRowIsland(this);
        this.cleanGridState(this.rootGrid);
      }
    }
    /**
     * @hidden
     */
    reflow() {}
    /**
     * @hidden
     */
    calculateGridHeight() {}
    /**
     * @hidden
     */
    calculateGridWidth() {}
    updateColumnList() {
      const nestedColumns = this.children.map(layout => layout.columnList.toArray());
      const colsArray = [].concat.apply([], nestedColumns);
      const topCols = this.columnList.filter(item => {
        if (colsArray.indexOf(item) === -1) {
          /* Reset the default width of the columns that come into this row island,
          because the root catches them first during the detectChanges() and sets their defaultWidth. */
          item.defaultWidth = undefined;
          return true;
        }
        return false;
      });
      this._childColumns = topCols;
      this.updateColumns(this._childColumns);
      this.rowIslandAPI.getChildGrids().forEach(grid => {
        grid.createColumnsList(this._childColumns);
        if (!this.document.body.contains(grid.nativeElement)) {
          grid.updateOnRender = true;
        }
      });
    }
    updateChildren() {
      if (this.children.first === this) {
        this.children.reset(this.children.toArray().slice(1));
      }
      this.children.forEach(child => {
        child.parentIsland = this;
      });
    }
    cleanGridState(grid) {
      grid.childGridTemplates.forEach(tmpl => {
        tmpl.owner.cleanView(tmpl.context.templateID);
      });
      grid.childGridTemplates.clear();
      grid.onRowIslandChange();
    }
    static {
      this.ɵfac = function IgxRowIslandComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRowIslandComponent)(i0.ɵɵdirectiveInject(IgxGridValidationService), i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IgxColumnResizingService), i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(IgxFlatTransactionFactory), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(IgxHierarchicalGridNavigationService), i0.ɵɵdirectiveInject(IgxFilteringService), i0.ɵɵdirectiveInject(IgxTextHighlightService), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IgxGridSummaryService), i0.ɵɵdirectiveInject(IgxRowIslandAPIService), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxRowIslandComponent,
        selectors: [["igx-row-island"]],
        contentQueries: function IgxRowIslandComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxGridToolbarDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxPaginatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxRowIslandComponent, 4, IgxRowIslandComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxRowIslandComponent, 4, IgxRowIslandComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxColumnComponent, 4, IgxColumnComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxActionStripToken, 4, IgxActionStripToken);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbarDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginatorDirectiveTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childLayoutList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childColumns = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionStripComponents = _t);
          }
        },
        inputs: {
          key: "key",
          childDataKey: "childDataKey",
          toolbarTemplate: "toolbarTemplate",
          paginatorTemplate: "paginatorTemplate",
          expandChildren: [2, "expandChildren", "expandChildren", booleanAttribute]
        },
        outputs: {
          layoutChange: "layoutChange",
          gridCreated: "gridCreated",
          gridInitialized: "gridInitialized"
        },
        features: [i0.ɵɵProvidersFeature([IgxRowIslandAPIService, IgxFilteringService, IgxGridSelectionService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c275,
        decls: 1,
        vars: 1,
        consts: [["sink", ""], [2, "display", "none"]],
        template: function IgxRowIslandComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c274);
            i0.ɵɵtemplate(0, IgxRowIslandComponent_Conditional_0_Template, 4, 0, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.platform.isElements ? 0 : -1);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxRowIslandComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxGridHierarchicalPipe = /*#__PURE__*/(() => {
  class IgxGridHierarchicalPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, state = new Map(), id, primaryKey, childKeys, _pipeTrigger) {
      if (childKeys.length === 0) {
        return collection;
      }
      if (this.grid.verticalScrollContainer.isRemote) {
        return collection;
      }
      const result = this.addHierarchy(this.grid, cloneArray(collection), state, primaryKey, childKeys);
      return result;
    }
    addHierarchy(grid, data, state, primaryKey, childKeys) {
      const result = [];
      data.forEach(v => {
        result.push(v);
        const childGridsData = {};
        childKeys.forEach(childKey => {
          if (!v[childKey]) {
            v[childKey] = [];
          }
          const hasNestedPath = childKey?.includes('.');
          const childData = !hasNestedPath ? v[childKey] : resolveNestedPath(v, childKey);
          childGridsData[childKey] = childData;
        });
        if (grid.gridAPI.get_row_expansion_state(v)) {
          result.push({
            rowID: primaryKey ? v[primaryKey] : v,
            childGridsData
          });
        }
      });
      return result;
    }
    static {
      this.ɵfac = function IgxGridHierarchicalPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridHierarchicalPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridHierarchical",
        type: IgxGridHierarchicalPipe,
        pure: true
      });
    }
  }
  return IgxGridHierarchicalPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden
 */
let IgxGridHierarchicalPagingPipe = /*#__PURE__*/(() => {
  class IgxGridHierarchicalPagingPipe {
    constructor(grid) {
      this.grid = grid;
    }
    transform(collection, enabled, page = 0, perPage = 15, _id, _pipeTrigger) {
      if (!enabled || this.grid.pagingMode !== GridPagingMode.Local) {
        return collection;
      }
      const state = {
        index: page,
        recordsPerPage: perPage
      };
      const total = this.grid._totalRecords >= 0 ? this.grid._totalRecords : collection.length;
      const result = DataUtil.page(cloneArray(collection), state, total);
      this.grid.pagingState = state;
      return result;
    }
    static {
      this.ɵfac = function IgxGridHierarchicalPagingPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridHierarchicalPagingPipe)(i0.ɵɵdirectiveInject(IGX_GRID_BASE, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "gridHierarchicalPaging",
        type: IgxGridHierarchicalPagingPipe,
        pure: true
      });
    }
  }
  return IgxGridHierarchicalPagingPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxHierarchicalGridCellComponent = /*#__PURE__*/(() => {
  class IgxHierarchicalGridCellComponent extends IgxGridCellComponent {
    constructor(selectionService, grid, overlayService, cdr, helement, zone, touchManager, platformUtil) {
      super(selectionService, grid, overlayService, cdr, helement, zone, touchManager, platformUtil);
    }
    ngOnInit() {
      super.ngOnInit();
      this._rootGrid = this._getRootGrid();
    }
    /**
     * @hidden
     * @internal
     */
    activate(event) {
      this._clearAllHighlights();
      const currentElement = this.grid.nativeElement;
      let parentGrid = this.grid;
      let childGrid;
      // add highligh to the current grid
      if (this._rootGrid.id !== currentElement.id) {
        currentElement.classList.add('igx-grid__tr--highlighted');
      }
      // add highligh to the current grid
      while (this._rootGrid.id !== parentGrid.id) {
        childGrid = parentGrid;
        parentGrid = parentGrid.parent;
        const parentRowID = parentGrid.gridAPI.getParentRowId(childGrid);
        parentGrid.highlightedRowID = parentRowID;
      }
      this.grid.navigation.activeNode.gridID = this.gridID;
      super.activate(event);
    }
    _getRootGrid() {
      let currGrid = this.grid;
      while (currGrid.parent) {
        currGrid = currGrid.parent;
      }
      return currGrid;
    }
    // TODO: Extend the new selection service to avoid complete traversal
    _clearAllHighlights() {
      [this._rootGrid, ...this._rootGrid.getChildGrids(true)].forEach(grid => {
        if (grid !== this.grid && grid.navigation.activeNode) {
          grid.navigation.clearActivation();
          grid.selectionService.initKeyboardState();
          grid.selectionService.clear();
        }
        grid.selectionService.activeElement = null;
        grid.nativeElement.classList.remove('igx-grid__tr--highlighted');
        grid.highlightedRowID = null;
        grid.cdr.markForCheck();
      });
    }
    static {
      this.ɵfac = function IgxHierarchicalGridCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHierarchicalGridCellComponent)(i0.ɵɵdirectiveInject(IgxGridSelectionService), i0.ɵɵdirectiveInject(IGX_GRID_BASE), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(HammerGesturesManager), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxHierarchicalGridCellComponent,
        selectors: [["igx-hierarchical-grid-cell"]],
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager]), i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 5,
        consts: [["defaultPinnedIndicator", ""], ["defaultCell", ""], ["addRowCell", ""], ["inlineEditor", ""], ["defaultError", ""], ["errorIcon", ""], ["error", "", "tooltipRef", "tooltip"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "igx-grid__td--pinned-chip", 3, "disabled", "--ig-size"], [1, "igx-grid__td--pinned-chip", 3, "disabled"], ["igxTextHighlight", "", 1, "igx-grid__td-text", 3, "cssClass", "activeCssClass", "groupName", "value", "row", "column", "containerClass", "metadata"], ["family", "default", 3, "name", "ngClass"], [3, "src", "alt"], [3, "formGroup"], ["igxInput", "", 3, "compositionstart", "compositionend", "igxFocus", "igxTextSelection", "formControl"], ["igxInput", "", "type", "number", 3, "igxFocus", "igxTextSelection", "step", "formControl"], [3, "checked", "igxFocus", "disableRipple", "formControl"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "weekStart", "value", "igxFocus", "formControl", "inputFormat", "displayFormat"], ["mode", "dropdown", 3, "valueChange", "outlet", "locale", "inputFormat", "displayFormat", "value", "igxFocus", "formControl"], ["type", "text", "igxInput", "", 3, "formControl", "locale", "igxDateTimeEditor", "defaultFormatType", "displayFormat", "igxFocus"], ["family", "default", "name", "error", 3, "mouseover", "mouseout", "igxTooltipTarget", "igxToggleOutlet"], ["igxTooltip", "", 3, "id"]],
        template: function IgxHierarchicalGridCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxHierarchicalGridCellComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxHierarchicalGridCellComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxHierarchicalGridCellComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxHierarchicalGridCellComponent_ng_template_6_Template, 8, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, IgxHierarchicalGridCellComponent_ng_container_8_Template, 1, 0, "ng-container", 7)(9, IgxHierarchicalGridCellComponent_ng_container_9_Template, 1, 0, "ng-container", 7)(10, IgxHierarchicalGridCellComponent_Conditional_10_Template, 7, 7)(11, IgxHierarchicalGridCellComponent_ng_template_11_Template, 7, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.pinnedIndicatorTemplate)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ctx.context);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isInvalid ? 10 : -1);
          }
        },
        dependencies: [IgxChipComponent, IgxTextHighlightDirective, IgxIconComponent, NgClass, FormsModule, i4.DefaultValueAccessor, i4.NumberValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, ReactiveFormsModule, i4.FormControlDirective, i4.FormGroupDirective, IgxInputGroupComponent, IgxInputDirective, IgxFocusDirective, IgxTextSelectionDirective, IgxCheckboxComponent, IgxDatePickerComponent, IgxTimePickerComponent, IgxDateTimeEditorDirective, IgxPrefixDirective, IgxSuffixDirective, NgTemplateOutlet, IgxTooltipTargetDirective, IgxTooltipDirective, IgxGridCellImageAltPipe, IgxStringReplacePipe, IgxColumnFormatterPipe, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxHierarchicalGridCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxHierarchicalRowComponent = /*#__PURE__*/(() => {
  class IgxHierarchicalRowComponent extends IgxRowDirective {
    constructor() {
      super(...arguments);
      this.expanderClass = 'igx-grid__hierarchical-expander';
      this.rolActionClass = 'igx-grid__tr-action';
      /**
       * @hidden
       * @internal
       */
      this.select = () => {
        this.grid.selectRows([this.key]);
      };
      /**
       * @hidden
       * @internal
       */
      this.deselect = () => {
        this.grid.deselectRows([this.key]);
      };
    }
    /**
     * @hidden
     */
    get expanderClassResolved() {
      return {
        [`${this.expanderClass} ${this.rolActionClass}`]: !this.pinned || this.disabled,
        [`${this.expanderClass}--empty`]: this.pinned && !this.disabled
      };
    }
    get viewIndex() {
      return this.index + this.grid.page * this.grid.perPage;
    }
    /**
     * Returns whether the row is expanded.
     * ```typescript
     * const RowExpanded = this.grid1.rowList.first.expanded;
     * ```
     */
    get expanded() {
      return this.grid.gridAPI.get_row_expansion_state(this.data);
    }
    /**
     * @hidden
     */
    get expandedClass() {
      return this.expanded && !this.pinned;
    }
    get hasChildren() {
      return !!this.grid.childLayoutKeys.length;
    }
    /**
     * @hidden
     */
    get highlighted() {
      return this.grid && this.grid.highlightedRowID === this.key;
    }
    /**
     * @hidden
     */
    expanderClick(event) {
      event.stopPropagation();
      this.toggle();
    }
    /**
     * Toggles the hierarchical row.
     * ```typescript
     * this.grid1.rowList.first.toggle()
     * ```
     */
    toggle() {
      if (this.added) {
        return;
      }
      // K.D. 28 Feb, 2022 #10634 Don't trigger endEdit/commit upon row expansion state change
      // this.endEdit(this.grid.rootGrid);
      this.grid.gridAPI.set_row_expansion_state(this.key, !this.expanded);
      this.grid.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    get iconTemplate() {
      let expandable = true;
      if (this.grid.hasChildrenKey) {
        expandable = this.data[this.grid.hasChildrenKey];
      }
      if (!expandable || this.pinned && !this.disabled) {
        return this.defaultEmptyTemplate;
      }
      if (this.expanded) {
        return this.grid.rowExpandedIndicatorTemplate || this.defaultExpandedTemplate;
      } else {
        return this.grid.rowCollapsedIndicatorTemplate || this.defaultCollapsedTemplate;
      }
    }
    // TODO: consider moving into CRUD
    endEdit(grid) {
      if (grid.gridAPI.crudService.cellInEditMode) {
        grid.gridAPI.crudService.endEdit();
      }
      grid.gridAPI.getChildGrids(true).forEach(g => {
        if (g.gridAPI.crudService.cellInEditMode) {
          g.gridAPI.crudService.endEdit();
        }
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxHierarchicalRowComponent_BaseFactory;
        return function IgxHierarchicalRowComponent_Factory(__ngFactoryType__) {
          return (ɵIgxHierarchicalRowComponent_BaseFactory || (ɵIgxHierarchicalRowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxHierarchicalRowComponent)))(__ngFactoryType__ || IgxHierarchicalRowComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxHierarchicalRowComponent,
        selectors: [["igx-hierarchical-grid-row"]],
        viewQuery: function IgxHierarchicalRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c276, 5, ElementRef);
            i0.ɵɵviewQuery(_c202, 7, TemplateRef);
            i0.ɵɵviewQuery(_c277, 7, TemplateRef);
            i0.ɵɵviewQuery(_c203, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxHierarchicalGridCellComponent, 5, IgxHierarchicalGridCellComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expander = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultExpandedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultEmptyTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultCollapsedTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._cells = _t);
          }
        },
        hostVars: 4,
        hostBindings: function IgxHierarchicalRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-grid__tr--expanded", ctx.expandedClass)("igx-grid__tr--highlighted", ctx.highlighted);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxRowDirective,
          useExisting: forwardRef(() => IgxHierarchicalRowComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 1,
        consts: [["defaultExpandedTemplate", ""], ["defaultCollapsedTemplate", ""], ["defaultEmptyTemplate", ""], ["addTemp", ""], ["defaultTemp", ""], ["igxDirRef", ""], ["rowSelectorBaseTemplate", ""], ["pinnedCellsTemplate", ""], ["expander", ""], [4, "ngTemplateOutlet"], ["family", "default", "name", "tree_collapse", 3, "active"], ["family", "default", "name", "tree_expand", 3, "active"], [1, "igx-grid__tr--inner", 3, "animationend"], [3, "class", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action"], [3, "ngClass"], ["igxGridFor", "", 3, "igxGridForOf", "igxForScrollContainer", "igxForSizePropName", "igxForScrollOrientation", "igxForContainerSize", "igxForTrackBy"], [3, "click", "pointerdown", "igxRowDrag", "ghostTemplate"], [1, "igx-grid__cbx-selection", "igx-grid__tr-action", 3, "click", "pointerdown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "click", "mousedown", "ngClass"], [1, "igx-grid__td", "igx-grid__td--fw", 3, "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "active", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__cbx-padding"], [3, "tabindex", "readonly", "checked", "disableRipple", "disabled", "disableTransitions", "aria-label"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--pinned", 3, "igx-grid__td--edited", "igx-grid__td--number", "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "active", "firstPinned", "lastPinned", "rowData", "min-width", "max-width", "flex-basis", "left", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "cellSelectionMode", "displayPinnedChip"], [1, "igx-grid__td", "igx-grid__td--fw", "igx-grid__td--pinned", 3, "ngClass", "ngStyle", "editMode", "column", "formatter", "intRow", "active", "firstPinned", "lastPinned", "rowData", "width", "visibleColumnIndex", "value", "cellTemplate", "cellValidationErrorTemplate", "lastSearchInfo", "cellSelectionMode", "displayPinnedChip"]],
        template: function IgxHierarchicalRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IgxHierarchicalRowComponent_ng_container_0_Template, 1, 0, "ng-container", 9)(1, IgxHierarchicalRowComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxHierarchicalRowComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxHierarchicalRowComponent_ng_template_5_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, IgxHierarchicalRowComponent_ng_template_7_Template, 2, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(9, IgxHierarchicalRowComponent_ng_template_9_Template, 12, 13, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const addTemp_r11 = i0.ɵɵreference(8);
            const defaultTemp_r3 = i0.ɵɵreference(10);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.addRowUI ? addTemp_r11 : defaultTemp_r3);
          }
        },
        dependencies: [NgTemplateOutlet, IgxIconComponent, IgxRowDragDirective, NgClass, IgxGridForOfDirective, IgxHierarchicalGridCellComponent, NgStyle, IgxCheckboxComponent, IgxGridNotGroupedPipe, IgxGridCellStylesPipe, IgxGridCellStyleClassesPipe, IgxGridDataMapperPipe, IgxGridTransactionStatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxHierarchicalRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$5 = 0;
/**
 * @hidden @internal
 */
let IgxChildGridRowComponent = /*#__PURE__*/(() => {
  class IgxChildGridRowComponent {
    /**
     * @hidden
     */
    get parentHasScroll() {
      return !this.parentGrid.verticalScrollContainer.dc.instance.notVirtual;
    }
    /**
     *  The data passed to the row component.
     *
     * ```typescript
     * // get the row data for the first selected row
     * let selectedRowData = this.grid.selectedRows[0].data;
     * ```
     */
    get data() {
      return this._data || [];
    }
    set data(value) {
      this._data = value;
      if (this.hGrid && !this.hGrid.dataSetByUser) {
        this.hGrid.setDataInternal(this._data.childGridsData[this.layout.key]);
      }
    }
    /* blazorSuppress */
    /**
     * Get a reference to the grid that contains the selected row.
     *
     * ```typescript
     * handleRowSelection(event) {
     *  // the grid on which the rowSelected event was triggered
     *  const grid = event.row.grid;
     * }
     * ```
     *
     * ```html
     *  <igx-grid
     *    [data]="data"
     *    (rowSelected)="handleRowSelection($event)">
     *  </igx-grid>
     * ```
     */
    // TODO: Refactor
    get parentGrid() {
      return this.gridAPI.grid;
    }
    get level() {
      return this.layout.level;
    }
    /**
     * The native DOM element representing the row. Could be null in certain environments.
     *
     * ```typescript
     * // get the nativeElement of the second selected row
     * let selectedRowNativeElement = this.grid.selectedRows[1].nativeElement;
     * ```
     */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(gridAPI, element, cdr) {
      this.gridAPI = gridAPI;
      this.element = element;
      this.cdr = cdr;
      /**
       * Returns whether the row is expanded.
       * ```typescript
       * const RowExpanded = this.grid1.rowList.first.expanded;
       * ```
       */
      this.expanded = false;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      const ref = this.container.createComponent(IgxHierarchicalGridComponent, {
        injector: this.container.injector
      });
      this.hGrid = ref.instance;
      this.hGrid.setDataInternal(this.data.childGridsData[this.layout.key]);
      this.hGrid.nativeElement["__componentRef"] = ref;
      this.layout.layoutChange.subscribe(ch => {
        this._handleLayoutChanges(ch);
      });
      const changes = this.layout.initialChanges;
      changes.forEach(change => {
        this._handleLayoutChanges(change);
      });
      this.hGrid.parent = this.parentGrid;
      this.hGrid.parentIsland = this.layout;
      this.hGrid.childRow = this;
      // handler logic that re-emits hgrid events on the row island
      this.setupEventEmitters();
      this.layout.gridCreated.emit({
        owner: this.layout,
        parentID: this.data.rowID,
        grid: this.hGrid
      });
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this.hGrid.childLayoutList = this.layout.children;
      const layouts = this.hGrid.childLayoutList.toArray();
      layouts.forEach(l => this.hGrid.gridAPI.registerChildRowIsland(l));
      this.parentGrid.gridAPI.registerChildGrid(this.data.rowID, this.layout.key, this.hGrid);
      this.layout.rowIslandAPI.registerChildGrid(this.data.rowID, this.hGrid);
      this.layout.gridInitialized.emit({
        owner: this.layout,
        parentID: this.data.rowID,
        grid: this.hGrid
      });
      this.hGrid.cdr.detectChanges();
    }
    setupEventEmitters() {
      const destructor = takeUntil(this.hGrid.destroy$);
      const mirror = reflectComponentType(IgxGridComponent);
      // exclude outputs related to two-way binding functionality
      const inputNames = mirror.inputs.map(input => input.propName);
      const outputs = mirror.outputs.filter(o => {
        const matchingInputPropName = o.propName.slice(0, o.propName.indexOf('Change'));
        return inputNames.indexOf(matchingInputPropName) === -1;
      });
      // TODO: Skip the `rendered` output. Rendered should be called once per grid.
      outputs.filter(o => o.propName !== 'rendered').forEach(output => {
        if (this.hGrid[output.propName]) {
          this.hGrid[output.propName].pipe(destructor).subscribe(args => {
            if (!args) {
              args = {};
            }
            args.owner = this.hGrid;
            this.layout[output.propName].emit(args);
          });
        }
      });
    }
    _handleLayoutChanges(changes) {
      for (const change in changes) {
        if (changes.hasOwnProperty(change)) {
          this.hGrid[change] = changes[change].currentValue;
        }
      }
    }
    static {
      this.ɵfac = function IgxChildGridRowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxChildGridRowComponent)(i0.ɵɵdirectiveInject(IGX_GRID_SERVICE_BASE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxChildGridRowComponent,
        selectors: [["igx-child-grid-row"]],
        viewQuery: function IgxChildGridRowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function IgxChildGridRowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-level", ctx.level);
          }
        },
        inputs: {
          layout: "layout",
          parentGridID: "parentGridID",
          data: "data",
          index: "index"
        },
        decls: 3,
        vars: 3,
        consts: [["container", ""], [1, "igx-grid__hierarchical-indent", 3, "ngClass"]],
        template: function IgxChildGridRowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelementContainer(1, null, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c279, ctx.parentHasScroll));
          }
        },
        dependencies: [NgClass],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxChildGridRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* blazorAdditionalDependency: Column */
/* blazorAdditionalDependency: ColumnGroup */
/* blazorAdditionalDependency: ColumnLayout */
/* blazorAdditionalDependency: GridToolbar */
/* blazorAdditionalDependency: GridToolbarActions */
/* blazorAdditionalDependency: GridToolbarTitle */
/* blazorAdditionalDependency: GridToolbarAdvancedFiltering */
/* blazorAdditionalDependency: GridToolbarExporter */
/* blazorAdditionalDependency: GridToolbarHiding */
/* blazorAdditionalDependency: GridToolbarPinning */
/* blazorAdditionalDependency: ActionStrip */
/* blazorAdditionalDependency: GridActionsBaseDirective */
/* blazorAdditionalDependency: GridEditingActions */
/* blazorAdditionalDependency: GridPinningActions */
/* blazorAdditionalDependency: RowIsland */
/* blazorIndirectRender */
/**
 * Hierarchical grid
 *
 * @igxModule IgxHierarchicalGridModule
 *
 */
let IgxHierarchicalGridComponent = /*#__PURE__*/(() => {
  class IgxHierarchicalGridComponent extends IgxHierarchicalGridBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * @hidden @internal
       */
      this.role = 'grid';
      /**
       * @hidden
       */
      this.childLayoutKeys = [];
      /** @hidden @internal */
      this.dataSetByUser = false;
      /**
       * @hidden
       */
      this.highlightedRowID = null;
      /**
       * @hidden
       */
      this.updateOnRender = false;
      /**
       * @hidden
       */
      this.parent = null;
      this.h_id = `igx-hierarchical-grid-${NEXT_ID$5++}`;
      this.childGridTemplates = new Map();
    }
    // @ViewChild('headerHierarchyExpander', { read: ElementRef, static: true })
    get headerHierarchyExpander() {
      return this.theadRow?.headerHierarchyExpander;
    }
    /** @hidden @internal */
    get actionStrip() {
      return this.parentIsland ? this.parentIsland.actionStrip : super.actionStrip;
    }
    /**
     * Gets/Sets the value of the `id` attribute.
     *
     * @remarks
     * If not provided it will be automatically generated.
     * @example
     * ```html
     * <igx-hierarchical-grid [id]="'igx-hgrid-1'" [data]="Data" [autoGenerate]="true"></igx-hierarchical-grid>
     * ```
     */
    get id() {
      return this.h_id;
    }
    set id(value) {
      this.h_id = value;
    }
    /* treatAsRef */
    /**
     * Gets/Sets the array of data that populates the component.
     * ```html
     * <igx-hierarchical-grid [data]="Data" [autoGenerate]="true"></igx-hierarchical-grid>
     * ```
     *
     * @memberof IgxHierarchicalGridComponent
     */
    set data(value) {
      this.setDataInternal(value);
      this.dataSetByUser = true;
      this.checkPrimaryKeyField();
    }
    /**
     * Returns an array of data set to the `IgxHierarchicalGridComponent`.
     * ```typescript
     * let filteredData = this.grid.filteredData;
     * ```
     *
     * @memberof IgxHierarchicalGridComponent
     */
    get data() {
      return this._data;
    }
    /** @hidden @internal */
    get paginator() {
      const id = this.id;
      return !this.parentIsland && this.paginationComponents?.first || this.rootGrid.paginatorList?.find(pg => pg.nativeElement.offsetParent?.id === id);
    }
    /** @hidden @internal */
    get excelStyleFilteringComponent() {
      return this.parentIsland ? this.parentIsland.excelStyleFilteringComponents.first : super.excelStyleFilteringComponent;
    }
    /**
     * Gets/Sets the total number of records in the data source.
     *
     * @remarks
     * This property is required for remote grid virtualization to function when it is bound to remote data.
     * @example
     * ```typescript
     * const itemCount = this.grid1.totalItemCount;
     * this.grid1.totalItemCount = 55;
     * ```
     */
    set totalItemCount(count) {
      this.verticalScrollContainer.totalItemCount = count;
    }
    get totalItemCount() {
      return this.verticalScrollContainer.totalItemCount;
    }
    /**
     * Sets if all immediate children of the `IgxHierarchicalGridComponent` should be expanded/collapsed.
     * Default value is false.
     * ```html
     * <igx-hierarchical-grid [id]="'igx-grid-1'" [data]="Data" [autoGenerate]="true" [expandChildren]="true"></igx-hierarchical-grid>
     * ```
     *
     * @memberof IgxHierarchicalGridComponent
     */
    set expandChildren(value) {
      this._defaultExpandState = value;
      this.expansionStates = new Map();
    }
    /**
     * Gets if all immediate children of the `IgxHierarchicalGridComponent` previously have been set to be expanded/collapsed.
     * If previously set and some rows have been manually expanded/collapsed it will still return the last set value.
     * ```typescript
     * const expanded = this.grid.expandChildren;
     * ```
     *
     * @memberof IgxHierarchicalGridComponent
     */
    get expandChildren() {
      return this._defaultExpandState;
    }
    /**
     * Gets the unique identifier of the parent row. It may be a `string` or `number` if `primaryKey` of the
     * parent grid is set or an object reference of the parent record otherwise.
     * ```typescript
     * const foreignKey = this.grid.foreignKey;
     * ```
     *
     * @memberof IgxHierarchicalGridComponent
     */
    get foreignKey() {
      if (!this.parent) {
        return null;
      }
      return this.parent.gridAPI.getParentRowId(this);
    }
    /**
     * @hidden
     */
    get hasExpandableChildren() {
      return !!this.childLayoutKeys.length;
    }
    /**
     * @hidden
     */
    get resolveRowEditContainer() {
      if (this.parentIsland && this.parentIsland.rowEditCustom) {
        return this.parentIsland.rowEditContainer;
      }
      return this.rowEditContainer;
    }
    /**
     * @hidden
     */
    get resolveRowEditActions() {
      return this.parentIsland ? this.parentIsland.rowEditActionsTemplate : this.rowEditActionsTemplate;
    }
    /**
     * @hidden
     */
    get resolveRowEditText() {
      return this.parentIsland ? this.parentIsland.rowEditTextTemplate : this.rowEditTextTemplate;
    }
    /** @hidden */
    hideActionStrip() {
      if (!this.parent) {
        // hide child layout actions strips when
        // moving outside root grid.
        super.hideActionStrip();
        this.allLayoutList.forEach(ri => {
          ri.actionStrip?.hide();
        });
      }
    }
    /**
     * @hidden
     */
    get parentRowOutletDirective() {
      // Targeting parent outlet in order to prevent hiding when outlet
      // is present at a child grid and is attached to a row.
      return this.parent ? this.parent.rowOutletDirective : this.outlet;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      // this.expansionStatesChange.pipe(takeUntil(this.destroy$)).subscribe((value: Map<any, boolean>) => {
      //     const res = Array.from(value.entries()).filter(({1: v}) => v === true).map(([k]) => k);
      // });
      this.batchEditing = !!this.rootGrid.batchEditing;
      if (this.rootGrid !== this) {
        this.rootGrid.batchEditingChange.pipe(takeUntil(this.destroy$)).subscribe(val => {
          this.batchEditing = val;
        });
      }
      super.ngOnInit();
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.verticalScrollContainer.beforeViewDestroyed.pipe(takeUntil(this.destroy$)).subscribe(view => {
        const rowData = view.context.$implicit;
        if (this.isChildGridRecord(rowData)) {
          const cachedData = this.childGridTemplates.get(rowData.rowID);
          if (cachedData) {
            const tmlpOutlet = cachedData.owner;
            tmlpOutlet._viewContainerRef.detach(0);
          }
        }
      });
      if (this.parent) {
        this.childLayoutKeys = this.parentIsland.children.map(item => item.key);
      }
      this.headSelectorsTemplates = this.parentIsland ? this.parentIsland.headSelectorsTemplates : this.headSelectorsTemplates;
      this.rowSelectorsTemplates = this.parentIsland ? this.parentIsland.rowSelectorsTemplates : this.rowSelectorsTemplates;
      this.dragIndicatorIconTemplate = this.parentIsland ? this.parentIsland.dragIndicatorIconTemplate : this.dragIndicatorIconTemplate;
      this.rowExpandedIndicatorTemplate = this.rootGrid.rowExpandedIndicatorTemplate;
      this.rowCollapsedIndicatorTemplate = this.rootGrid.rowCollapsedIndicatorTemplate;
      this.headerCollapsedIndicatorTemplate = this.rootGrid.headerCollapsedIndicatorTemplate;
      this.headerExpandedIndicatorTemplate = this.rootGrid.headerExpandedIndicatorTemplate;
      this.excelStyleHeaderIconTemplate = this.rootGrid.excelStyleHeaderIconTemplate;
      this.sortAscendingHeaderIconTemplate = this.rootGrid.sortAscendingHeaderIconTemplate;
      this.sortDescendingHeaderIconTemplate = this.rootGrid.sortDescendingHeaderIconTemplate;
      this.sortHeaderIconTemplate = this.rootGrid.sortHeaderIconTemplate;
      this.hasChildrenKey = this.parentIsland ? this.parentIsland.hasChildrenKey || this.rootGrid.hasChildrenKey : this.rootGrid.hasChildrenKey;
      this.showExpandAll = this.parentIsland ? this.parentIsland.showExpandAll : this.rootGrid.showExpandAll;
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      this.updateColumnList(false);
      this.childLayoutKeys = this.parent ? this.parentIsland.children.map(item => item.key) : this.childLayoutKeys = this.childLayoutList.map(item => item.key);
      this.childLayoutList.notifyOnChanges();
      this.childLayoutList.changes.pipe(takeUntil(this.destroy$)).subscribe(() => this.onRowIslandChange());
      super.ngAfterContentInit();
    }
    /**
     * Returns the `RowType` by index.
     *
     * @example
     * ```typescript
     * const myRow = this.grid1.getRowByIndex(1);
     * ```
     * @param index
     */
    getRowByIndex(index) {
      if (index < 0 || index >= this.dataView.length) {
        return undefined;
      }
      return this.createRow(index);
    }
    /**
     * Returns the `RowType` by key.
     *
     * @example
     * ```typescript
     * const myRow = this.grid1.getRowByKey(1);
     * ```
     * @param key
     */
    getRowByKey(key) {
      const data = this.dataView;
      const rec = this.primaryKey ? data.find(record => record[this.primaryKey] === key) : data.find(record => record === key);
      const index = data.indexOf(rec);
      if (index < 0 || index > data.length) {
        return undefined;
      }
      return new IgxHierarchicalGridRow(this, index, rec);
    }
    /**
     * @hidden @internal
     */
    allRows() {
      return this.dataView.map((rec, index) => this.createRow(index));
    }
    /**
     * Returns the collection of `IgxHierarchicalGridRow`s for current page.
     *
     * @hidden @internal
     */
    dataRows() {
      return this.allRows().filter(row => row instanceof IgxHierarchicalGridRow);
    }
    /**
     * Returns an array of the selected `IgxGridCell`s.
     *
     * @example
     * ```typescript
     * const selectedCells = this.grid.selectedCells;
     * ```
     */
    get selectedCells() {
      return this.dataRows().map(row => row.cells.filter(cell => cell.selected)).reduce((a, b) => a.concat(b), []);
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @example
     * ```typescript
     * const myCell = this.grid1.getCellByColumn(2, "UnitPrice");
     * ```
     * @param rowIndex
     * @param columnField
     */
    getCellByColumn(rowIndex, columnField) {
      const row = this.getRowByIndex(rowIndex);
      const column = this.columns.find(col => col.field === columnField);
      if (row && row instanceof IgxHierarchicalGridRow && column) {
        return new IgxGridCell(this, rowIndex, column);
      }
    }
    /**
     * Returns a `CellType` object that matches the conditions.
     *
     * @remarks
     * Requires that the primaryKey property is set.
     * @example
     * ```typescript
     * grid.getCellByKey(1, 'index');
     * ```
     * @param rowSelector match any rowID
     * @param columnField
     */
    getCellByKey(rowSelector, columnField) {
      const row = this.getRowByKey(rowSelector);
      const column = this.columns.find(col => col.field === columnField);
      if (row && column) {
        return new IgxGridCell(this, row.index, column);
      }
    }
    pinRow(rowID, index) {
      const row = this.getRowByKey(rowID);
      return super.pinRow(rowID, index, row);
    }
    /** @hidden @internal */
    setDataInternal(value) {
      const oldData = this._data;
      this._data = value || [];
      this.summaryService.clearSummaryCache();
      if (!this._init) {
        this.validation.updateAll(this._data);
      }
      if (this.autoGenerate && this._data.length > 0 && this.shouldRecreateColumns(oldData, this._data)) {
        this.setupColumns();
        this.reflow();
      }
      this.cdr.markForCheck();
      if (this.parent && (this.height === null || this.height.indexOf('%') !== -1)) {
        // If the height will change based on how much data there is, recalculate sizes in igxForOf.
        this.notifyChanges(true);
      }
    }
    unpinRow(rowID) {
      const row = this.getRowByKey(rowID);
      return super.unpinRow(rowID, row);
    }
    /**
     * @hidden @internal
     */
    dataLoading(event) {
      this.dataPreLoad.emit(event);
    }
    /** @hidden */
    featureColumnsWidth() {
      return super.featureColumnsWidth(this.headerHierarchyExpander);
    }
    /**
     * @hidden
     */
    onRowIslandChange() {
      if (this.parent) {
        this.childLayoutKeys = this.parentIsland.children.filter(item => !item._destroyed).map(item => item.key);
      } else {
        this.childLayoutKeys = this.childLayoutList.filter(item => !item._destroyed).map(item => item.key);
      }
      if (!this.cdr.destroyed) {
        this.cdr.detectChanges();
      }
    }
    /** @hidden @internal **/
    ngOnDestroy() {
      if (!this.parent) {
        this.gridAPI.getChildGrids(true).forEach(grid => {
          if (!grid.childRow.cdr.destroyed) {
            grid.childRow.cdr.destroy();
          }
        });
      }
      if (this.parent && this.selectionService.activeElement) {
        // in case selection is in destroyed child grid, selection should be cleared.
        this._clearSeletionHighlights();
      }
      super.ngOnDestroy();
    }
    /**
     * @hidden
     */
    isRowHighlighted(rowData) {
      return this.highlightedRowID === rowData.rowID;
    }
    /**
     * @hidden
     */
    isHierarchicalRecord(record) {
      if (this.isGhostRecord(record)) {
        record = record.recordRef;
      }
      return this.childLayoutList.length !== 0 && record[this.childLayoutList.first.key];
    }
    /**
     * @hidden
     */
    isChildGridRecord(record) {
      // Can be null when there is defined layout but no child data was found
      return record?.childGridsData !== undefined;
    }
    /**
     * @hidden
     */
    trackChanges(index, rec) {
      if (rec.childGridsData !== undefined) {
        // if is child rec
        return rec.rowID;
      }
      return rec;
    }
    /**
     * @hidden
     */
    getContext(rowData, rowIndex, pinned) {
      if (this.isChildGridRecord(rowData)) {
        const cachedData = this.childGridTemplates.get(rowData.rowID);
        if (cachedData) {
          const view = cachedData.view;
          const tmlpOutlet = cachedData.owner;
          return {
            $implicit: rowData,
            moveView: view,
            owner: tmlpOutlet,
            index: this.dataView.indexOf(rowData)
          };
        } else {
          // child rows contain unique grids, hence should have unique templates
          return {
            $implicit: rowData,
            templateID: {
              type: 'childRow',
              id: rowData.rowID
            },
            index: this.dataView.indexOf(rowData)
          };
        }
      } else {
        return {
          $implicit: this.isGhostRecord(rowData) ? rowData.recordRef : rowData,
          templateID: {
            type: 'dataRow',
            id: null
          },
          index: this.getDataViewIndex(rowIndex, pinned),
          disabled: this.isGhostRecord(rowData)
        };
      }
    }
    /**
     * @hidden
     */
    get rootGrid() {
      let currGrid = this;
      while (currGrid.parent) {
        currGrid = currGrid.parent;
      }
      return currGrid;
    }
    /**
     * @hidden
     */
    get iconTemplate() {
      const expanded = this.hasExpandedRecords() && this.hasExpandableChildren;
      if (!expanded && this.showExpandAll) {
        return this.headerCollapsedIndicatorTemplate || this.defaultCollapsedTemplate;
      } else {
        return this.headerExpandedIndicatorTemplate || this.defaultExpandedTemplate;
      }
    }
    /**
     * @hidden
     * @internal
     */
    getDragGhostCustomTemplate() {
      if (this.parentIsland) {
        return this.parentIsland.getDragGhostCustomTemplate();
      }
      return super.getDragGhostCustomTemplate();
    }
    /**
     * @hidden
     * Gets the visible content height that includes header + tbody + footer.
     * For hierarchical child grid it may be scrolled and not fully visible.
     */
    getVisibleContentHeight() {
      let height = super.getVisibleContentHeight();
      if (this.parent) {
        const rootHeight = this.rootGrid.getVisibleContentHeight();
        const topDiff = this.nativeElement.getBoundingClientRect().top - this.rootGrid.nativeElement.getBoundingClientRect().top;
        height = rootHeight - topDiff > height ? height : rootHeight - topDiff;
      }
      return height;
    }
    /**
     * @hidden
     */
    toggleAll() {
      const expanded = this.hasExpandedRecords() && this.hasExpandableChildren;
      if (!expanded && this.showExpandAll) {
        this.expandAll();
      } else {
        this.collapseAll();
      }
    }
    /**
     * @hidden
     * @internal
     */
    hasExpandedRecords() {
      if (this.expandChildren) {
        return true;
      }
      let hasExpandedEntry = false;
      this.expansionStates.forEach(value => {
        if (value) {
          hasExpandedEntry = value;
        }
      });
      return hasExpandedEntry;
    }
    getDefaultExpandState(record) {
      if (this.hasChildrenKey && !record[this.hasChildrenKey]) {
        return false;
      }
      return this.expandChildren;
    }
    /**
     * @hidden
     */
    isExpanded(record) {
      return this.gridAPI.get_row_expansion_state(record);
    }
    /**
     * @hidden
     */
    viewCreatedHandler(args) {
      if (this.isChildGridRecord(args.context.$implicit)) {
        const key = args.context.$implicit.rowID;
        this.childGridTemplates.set(key, args);
      }
    }
    /**
     * @hidden
     */
    viewMovedHandler(args) {
      if (this.isChildGridRecord(args.context.$implicit)) {
        // view was moved, update owner in cache
        const key = args.context.$implicit.rowID;
        const cachedData = this.childGridTemplates.get(key);
        cachedData.owner = args.owner;
        this.childLayoutList.forEach(layout => {
          const relatedGrid = this.gridAPI.getChildGridByID(layout.key, args.context.$implicit.rowID);
          if (relatedGrid && relatedGrid.updateOnRender) {
            // Detect changes if `expandChildren` has changed when the grid wasn't visible. This is for performance reasons.
            relatedGrid.notifyChanges(true);
            relatedGrid.updateOnRender = false;
          }
        });
      }
    }
    /** @hidden @internal **/
    onContainerScroll() {
      this.hideOverlays();
    }
    /**
     * @hidden
     */
    createRow(index, data) {
      let row;
      const dataIndex = this._getDataViewIndex(index);
      const rec = data ?? this.dataView[dataIndex];
      if (!row && rec && !rec.childGridsData) {
        row = new IgxHierarchicalGridRow(this, index, rec);
      }
      return row;
    }
    /** @hidden @internal */
    getChildGrids(inDeph) {
      return this.gridAPI.getChildGrids(inDeph);
    }
    generateDataFields(data) {
      return super.generateDataFields(data).filter(field => {
        const layoutsList = this.parentIsland ? this.parentIsland.children : this.childLayoutList;
        const keys = layoutsList.map(item => item.key);
        return keys.indexOf(field) === -1;
      });
    }
    resizeNotifyHandler() {
      // do not trigger reflow if element is detached or if it is child grid.
      if (this.nativeElement?.isConnected && !this.parent) {
        this.notifyChanges(true);
      }
    }
    /**
     * @hidden
     */
    initColumns(collection, cb = null) {
      if (this.hasColumnLayouts) {
        // invalid configuration - hierarchical grid should not allow column layouts
        // remove column layouts
        const nonColumnLayoutColumns = this.columns.filter(col => !col.columnLayout && !col.columnLayoutChild);
        this.updateColumns(nonColumnLayoutColumns);
      }
      super.initColumns(collection, cb);
    }
    setupColumns() {
      if (this.parentIsland && this.parentIsland.childColumns.length > 0 && !this.autoGenerate) {
        this.createColumnsList(this.parentIsland.childColumns.toArray());
      } else {
        super.setupColumns();
      }
    }
    getColumnList() {
      const childLayouts = this.parent ? this.childLayoutList : this.allLayoutList;
      const nestedColumns = childLayouts.map(layout => layout.columnList.toArray());
      const colsArray = [].concat.apply([], nestedColumns);
      if (colsArray.length > 0) {
        const topCols = this.columnList.filter(item => colsArray.indexOf(item) === -1);
        return topCols;
      } else {
        return this.columnList.toArray();
      }
    }
    onColumnsChanged() {
      Promise.resolve().then(() => {
        this.updateColumnList();
      });
    }
    _shouldAutoSize(renderedHeight) {
      if (this.isPercentHeight && this.parent) {
        return true;
      }
      return super._shouldAutoSize(renderedHeight);
    }
    updateColumnList(recalcColSizes = true) {
      const childLayouts = this.parent ? this.childLayoutList : this.allLayoutList;
      const nestedColumns = childLayouts.map(layout => layout.columnList.toArray());
      const colsArray = [].concat.apply([], nestedColumns);
      const colLength = this.columns.length;
      const topCols = this.columnList.filter(item => colsArray.indexOf(item) === -1);
      if (topCols.length > 0) {
        this.initColumns(topCols, col => this.columnInit.emit(col));
        if (recalcColSizes && this.columns.length !== colLength) {
          this.calculateGridSizes(false);
        }
      }
    }
    _clearSeletionHighlights() {
      [this.rootGrid, ...this.rootGrid.getChildGrids(true)].forEach(grid => {
        grid.selectionService.clear();
        grid.selectionService.activeElement = null;
        grid.nativeElement.classList.remove('igx-grid__tr--highlighted');
        grid.highlightedRowID = null;
        grid.cdr.markForCheck();
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxHierarchicalGridComponent_BaseFactory;
        return function IgxHierarchicalGridComponent_Factory(__ngFactoryType__) {
          return (ɵIgxHierarchicalGridComponent_BaseFactory || (ɵIgxHierarchicalGridComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxHierarchicalGridComponent)))(__ngFactoryType__ || IgxHierarchicalGridComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxHierarchicalGridComponent,
        selectors: [["igx-hierarchical-grid"]],
        contentQueries: function IgxHierarchicalGridComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxRowIslandComponent, 4, IgxRowIslandComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxRowIslandComponent, 5, IgxRowIslandComponent);
            i0.ɵɵcontentQuery(dirIndex, IgxPaginatorToken, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxActionStripToken, 4, IgxActionStripToken);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childLayoutList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.allLayoutList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginatorList = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionStripComponents = _t);
          }
        },
        viewQuery: function IgxHierarchicalGridComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c280, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c281, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c282, 7, TemplateRef);
            i0.ɵɵviewQuery(_c283, 7, TemplateRef);
            i0.ɵɵviewQuery(IgxTemplateOutletDirective, 5, IgxTemplateOutletDirective);
            i0.ɵɵviewQuery(IgxChildGridRowComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbarOutlet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginatorOutlet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hierarchicalRecordTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateOutlets = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hierarchicalRows = _t);
          }
        },
        hostVars: 2,
        hostBindings: function IgxHierarchicalGridComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("id", ctx.id);
          }
        },
        inputs: {
          id: "id",
          data: "data",
          totalItemCount: "totalItemCount",
          expandChildren: [2, "expandChildren", "expandChildren", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([IgxGridCRUDService, IgxGridValidationService, IgxGridSelectionService, {
          provide: IGX_GRID_SERVICE_BASE,
          useClass: IgxHierarchicalGridAPIService
        }, {
          provide: IGX_GRID_BASE,
          useExisting: IgxHierarchicalGridComponent
        }, IgxGridSummaryService, IgxFilteringService, IgxHierarchicalGridNavigationService, IgxColumnResizingService, IgxForOfSyncService, IgxForOfScrollSyncService, IgxRowIslandAPIService]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c285,
        decls: 95,
        vars: 149,
        consts: [["toolbarOutlet", ""], ["tbody", ""], ["pinnedRecordsTemplate", ""], ["verticalScrollContainer", ""], ["hierarchical_record_template", ""], ["pinned_hierarchical_record_template", ""], ["child_record_template", ""], ["igxRowEditingOverlayOutlet", ""], ["loadingOverlay", ""], ["verticalScrollHolder", ""], ["addRowSnackbar", ""], ["igxBodyOverlayOutlet", "overlay-outlet"], ["tfoot", ""], ["scr", ""], ["scrollContainer", ""], ["footer", ""], ["paginatorOutlet", ""], ["emptyFilteredGrid", ""], ["defaultEmptyGrid", ""], ["defaultAddRowEmptyTemplate", ""], ["defaultLoadingGrid", ""], ["defaultCollapsedTemplate", ""], ["defaultExpandedTemplate", ""], ["defaultRowEditText", ""], ["defaultRowEditActions", ""], ["defaultRowEditTemplate", ""], ["dragIndicatorIconBase", ""], ["igxLoadingOverlayOutlet", ""], ["igxFilteringOverlayOutlet", ""], ["pinContainer", ""], ["row", ""], ["row", "", "pinnedRow", ""], ["summaryRow", ""], ["rowEditingOverlay", ""], ["sink", ""], ["tabindex", "0", 1, "igx-grid-thead", 3, "keydown.meta.c", "keydown.control.c", "copy", "keydown", "focus", "grid", "hasMRL", "activeDescendant", "width", "pinnedColumnCollection", "unpinnedColumnCollection"], ["igxGridBody", "", "role", "rowgroup", 1, "igx-grid__tbody", 3, "keydown.control.c", "copy"], ["tabindex", "0", 1, "igx-grid__tbody-content", 3, "focus", "keydown", "dragStop", "dragScroll", "scroll", "igxGridDragSelect"], ["id", "left", 1, "igx-grid__scroll-on-drag-left", 3, "igxColumnMovingDrop"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop", "left"], [4, "ngTemplateOutlet"], ["igxGridFor", "", 3, "chunkPreload", "dataChanging", "dataChanged", "igxGridForOf", "igxForScrollOrientation", "igxForScrollContainer", "igxForContainerSize", "igxForItemSize", "igxForTrackBy"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["id", "right", 1, "igx-grid__scroll-on-drag-right", 3, "igxColumnMovingDrop"], ["igxOverlayOutlet", "", 1, "igx-grid__row-editing-outlet"], ["igxToggle", ""], [3, "indeterminate"], [1, "igx-grid__tbody-scrollbar", 3, "pointerdown", "hidden"], [1, "igx-grid__tbody-scrollbar-start"], [1, "igx-grid__tbody-scrollbar-main"], ["igxGridFor", "", 3, "igxGridForOf"], [1, "igx-grid__tbody-scrollbar-end"], [1, "igx-grid__addrow-snackbar"], [3, "outlet", "actionText", "displayTime"], ["igxOverlayOutlet", ""], ["role", "rowgroup", 1, "igx-grid__tfoot"], ["tabindex", "0", 3, "focus", "keydown"], ["role", "row", 1, "igx-grid__summaries", 3, "width", "height", "gridID", "summaries", "index"], [1, "igx-grid__tfoot-thumb", 3, "hidden"], [1, "igx-grid__scroll", 3, "pointerdown", "hidden"], [1, "igx-grid__scroll-start"], [1, "igx-grid__scroll-main"], [1, "igx-grid__scroll-end", 3, "hidden"], [1, "igx-grid__footer"], ["igxOverlayOutlet", "", 1, "igx-grid__loading-outlet"], ["igxOverlayOutlet", "", 1, "igx-grid__outlet"], [2, "display", "none"], ["id", "left", 1, "igx-grid__scroll-on-drag-pinned", 3, "igxColumnMovingDrop"], [1, "igx-grid__tr--pinned", 3, "ngClass", "width"], [1, "igx-grid__tr--pinned", 3, "ngClass"], [3, "viewCreated", "viewMoved", "cachedViewLoaded", "igxTemplateOutlet", "igxTemplateOutletContext"], [3, "gridID", "index", "disabled", "data", "ngClass", "ngStyle"], [3, "gridID", "index", "data", "ngClass", "ngStyle"], [3, "scroll", "ngClass"], [3, "parentGridID", "index", "data", "layout"], ["role", "row", 1, "igx-grid__summaries", 3, "gridID", "summaries", "index"], ["role", "cell", 1, "igx-grid__tbody-message"], ["type", "button", "igxButton", "contained", "igxRipple", "", 3, "click"], [1, "igx-grid__loading"], ["family", "default", "name", "unfold_more", "role", "button"], ["family", "default", "name", "unfold_less", "role", "button", 3, "active"], [3, "className"], ["type", "button", "igxButton", "", "igxRowEditTabStop", "", 3, "click"], [1, "igx-banner__message"], [1, "igx-banner__text"], [1, "igx-banner__actions"], [1, "igx-banner__row"], ["family", "default", "name", "drag_indicator"]],
        template: function IgxHierarchicalGridComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c284);
            i0.ɵɵprojection(0);
            i0.ɵɵelementContainer(1, null, 0);
            i0.ɵɵelementStart(3, "igx-grid-header-row", 35);
            i0.ɵɵlistener("keydown.meta.c", function IgxHierarchicalGridComponent_Template_igx_grid_header_row_keydown_meta_c_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown.control.c", function IgxHierarchicalGridComponent_Template_igx_grid_header_row_keydown_control_c_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxHierarchicalGridComponent_Template_igx_grid_header_row_copy_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("keydown", function IgxHierarchicalGridComponent_Template_igx_grid_header_row_keydown_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.headerNavigation($event));
            })("focus", function IgxHierarchicalGridComponent_Template_igx_grid_header_row_focus_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 36);
            i0.ɵɵlistener("keydown.control.c", function IgxHierarchicalGridComponent_Template_div_keydown_control_c_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            })("copy", function IgxHierarchicalGridComponent_Template_div_copy_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.copyHandler($event));
            });
            i0.ɵɵelementStart(5, "div", 37, 1);
            i0.ɵɵlistener("focus", function IgxHierarchicalGridComponent_Template_div_focus_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusTbody($event));
            })("keydown", function IgxHierarchicalGridComponent_Template_div_keydown_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.handleNavigation($event));
            })("dragStop", function IgxHierarchicalGridComponent_Template_div_dragStop_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectionService.dragMode = $event);
            })("dragScroll", function IgxHierarchicalGridComponent_Template_div_dragScroll_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragScroll($event));
            })("scroll", function IgxHierarchicalGridComponent_Template_div_scroll_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.preventContainerScroll($event));
            });
            i0.ɵɵtemplate(7, IgxHierarchicalGridComponent_Conditional_7_Template, 1, 2, "span", 38)(8, IgxHierarchicalGridComponent_Conditional_8_Template, 1, 4, "span", 39)(9, IgxHierarchicalGridComponent_ng_template_9_Template, 7, 50, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(11, IgxHierarchicalGridComponent_ng_container_11_Template, 1, 0, "ng-container", 40)(12, IgxHierarchicalGridComponent_ng_template_12_Template, 1, 2, "ng-template", 41, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵpipe(14, "gridTransaction");
            i0.ɵɵpipe(15, "visibleColumns");
            i0.ɵɵpipe(16, "gridFiltering");
            i0.ɵɵpipe(17, "gridSort");
            i0.ɵɵpipe(18, "gridHierarchicalPaging");
            i0.ɵɵpipe(19, "gridHierarchical");
            i0.ɵɵpipe(20, "gridAddRow");
            i0.ɵɵpipe(21, "gridRowPinning");
            i0.ɵɵlistener("chunkPreload", function IgxHierarchicalGridComponent_Template_ng_template_chunkPreload_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataLoading($event));
            })("dataChanging", function IgxHierarchicalGridComponent_Template_ng_template_dataChanging_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebinding($event));
            })("dataChanged", function IgxHierarchicalGridComponent_Template_ng_template_dataChanged_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dataRebound($event));
            });
            i0.ɵɵtemplate(22, IgxHierarchicalGridComponent_ng_template_22_Template, 4, 36, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(24, IgxHierarchicalGridComponent_ng_template_24_Template, 5, 35, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(26, IgxHierarchicalGridComponent_ng_template_26_Template, 3, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(28, IgxHierarchicalGridComponent_ng_container_28_Template, 1, 0, "ng-container", 40)(29, IgxHierarchicalGridComponent_ng_container_29_Template, 1, 0, "ng-container", 42)(30, IgxHierarchicalGridComponent_Conditional_30_Template, 1, 2, "span", 43);
            i0.ɵɵelement(31, "div", 44, 7);
            i0.ɵɵtemplate(33, IgxHierarchicalGridComponent_Conditional_33_Template, 0, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "div", 45, 8);
            i0.ɵɵtemplate(36, IgxHierarchicalGridComponent_Conditional_36_Template, 1, 1, "igx-circular-bar", 46);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(37, IgxHierarchicalGridComponent_Conditional_37_Template, 1, 2, "span", 43);
            i0.ɵɵelementStart(38, "div", 47);
            i0.ɵɵlistener("pointerdown", function IgxHierarchicalGridComponent_Template_div_pointerdown_38_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(39, "div", 48);
            i0.ɵɵelementStart(40, "div", 49);
            i0.ɵɵtemplate(41, IgxHierarchicalGridComponent_ng_template_41_Template, 0, 0, "ng-template", 50, 9, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(43, "div", 51);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(44, "div", 52)(45, "igx-snackbar", 53, 10);
            i0.ɵɵtext(47);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(48, "div", 54, 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "div", 55, 12)(52, "div", 56);
            i0.ɵɵlistener("focus", function IgxHierarchicalGridComponent_Template_div_focus_52_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.focusFirstCell(false));
            })("keydown", function IgxHierarchicalGridComponent_Template_div_keydown_52_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigation.summaryNav($event));
            });
            i0.ɵɵtemplate(53, IgxHierarchicalGridComponent_Conditional_53_Template, 3, 10, "igx-grid-summary-row", 57);
            i0.ɵɵelement(54, "div", 58);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(55, "div", 59, 13);
            i0.ɵɵlistener("pointerdown", function IgxHierarchicalGridComponent_Template_div_pointerdown_55_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelement(57, "div", 60);
            i0.ɵɵelementStart(58, "div", 61);
            i0.ɵɵtemplate(59, IgxHierarchicalGridComponent_ng_template_59_Template, 0, 0, "ng-template", 50, 14, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(61, "div", 62);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(62, "div", 63, 15);
            i0.ɵɵprojection(64, 1);
            i0.ɵɵprojection(65, 2);
            i0.ɵɵelementContainer(66, null, 16);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(68, IgxHierarchicalGridComponent_ng_template_68_Template, 4, 2, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor)(70, IgxHierarchicalGridComponent_ng_template_70_Template, 4, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor)(72, IgxHierarchicalGridComponent_ng_template_72_Template, 2, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor)(74, IgxHierarchicalGridComponent_ng_template_74_Template, 2, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor)(76, IgxHierarchicalGridComponent_ng_template_76_Template, 1, 0, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor)(78, IgxHierarchicalGridComponent_ng_template_78_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor)(80, IgxHierarchicalGridComponent_Conditional_80_Template, 4, 6, "div", 45)(81, IgxHierarchicalGridComponent_ng_template_81_Template, 3, 9, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor)(83, IgxHierarchicalGridComponent_ng_template_83_Template, 4, 2, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor)(85, IgxHierarchicalGridComponent_ng_template_85_Template, 6, 8, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor)(87, IgxHierarchicalGridComponent_ng_template_87_Template, 1, 0, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor)(89, IgxHierarchicalGridComponent_Conditional_89_Template, 1, 0, "igx-grid-column-resizer");
            i0.ɵɵelement(90, "div", 64, 27)(92, "div", 65, 28);
            i0.ɵɵtemplate(94, IgxHierarchicalGridComponent_Conditional_94_Template, 5, 0, "div", 66);
          }
          if (rf & 2) {
            const pinnedRecordsTemplate_r29 = i0.ɵɵreference(10);
            const igxBodyOverlayOutlet_r30 = i0.ɵɵreference(49);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("grid", ctx)("hasMRL", ctx.hasColumnLayouts)("activeDescendant", ctx.activeDescendant)("width", ctx.calcWidth)("pinnedColumnCollection", ctx.pinnedColumns)("unpinnedColumnCollection", ctx.unpinnedColumns);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", ctx.totalHeight, "px")("width", ctx.calcWidth, "px");
            i0.ɵɵproperty("igxGridDragSelect", ctx.selectionService.dragMode);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant)("role", ctx.dataView.length ? null : "row");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length <= 0 ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag && ctx.pinnedColumns.length > 0 ? 8 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && ctx.isRowPinningToTop ? pinnedRecordsTemplate_r29 : null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpipeBind4(21, 110, i0.ɵɵpipeBind3(20, 106, i0.ɵɵpipeBindV(19, 99, i0.ɵɵpureFunction6(138, _c63, i0.ɵɵpipeBindV(18, 92, i0.ɵɵpureFunction6(131, _c63, i0.ɵɵpipeBindV(17, 85, i0.ɵɵpureFunction6(124, _c63, i0.ɵɵpipeBindV(16, 77, i0.ɵɵpureFunction7(115, _c225, i0.ɵɵpipeBind2(15, 74, i0.ɵɵpipeBind3(14, 70, ctx.data, ctx.id, ctx.pipeTrigger), ctx.hasVisibleColumns), ctx.filteringExpressionsTree, ctx.filterStrategy, ctx.advancedFilteringExpressionsTree, ctx.id, ctx.pipeTrigger, ctx.filteringPipeTrigger)), ctx.sortingExpressions, i0.ɵɵpureFunction0(123, _c129), ctx.sortStrategy, ctx.id, ctx.pipeTrigger)), !!ctx.paginator, ctx.page, ctx.perPage, ctx.id, ctx.pipeTrigger)), ctx.expansionStates, ctx.id, ctx.primaryKey, ctx.childLayoutKeys, ctx.pipeTrigger)), false, ctx.pipeTrigger), ctx.id, false, ctx.pipeTrigger))("igxForScrollOrientation", "vertical")("igxForScrollContainer", ctx.verticalScroll)("igxForContainerSize", ctx.calcHeight)("igxForItemSize", ctx.renderedRowHeight)("igxForTrackBy", ctx.trackChanges);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasPinnedRecords && !ctx.isRowPinningToTop ? pinnedRecordsTemplate_r29 : null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(145, _c25, ctx));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag ? 30 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.parent ? 33 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.shouldOverlayLoading ? 36 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.moving && ctx.columnInDrag ? 37 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.calcHeight, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(147, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", !ctx.isRowPinningToTop ? ctx.pinnedRowHeight : 0, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("outlet", igxBodyOverlayOutlet_r30)("actionText", ctx.resourceStrings.igx_grid_snackbar_addrow_actiontext)("displayTime", ctx.snackbarDisplayTime);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.resourceStrings.igx_grid_snackbar_addrow_label);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-activedescendant", ctx.activeDescendant);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasSummarizedColumns && ctx.rootSummariesEnabled ? 53 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.summaryRowHeight, "px")("width", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", !ctx.hasVerticalScroll());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.scrollSize, "px");
            i0.ɵɵproperty("hidden", ctx.isHorizontalScrollHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px")("min-width", ctx.isPinningToStart ? ctx.pinnedWidth : ctx.headerFeaturesWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.unpinnedWidth, "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("igxGridForOf", i0.ɵɵpureFunction0(148, _c129));
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", ctx.pinnedWidth, "px")("min-width", ctx.pinnedWidth, "px");
            i0.ɵɵproperty("hidden", ctx.pinnedWidth === 0 || ctx.isPinningToStart);
            i0.ɵɵadvance(19);
            i0.ɵɵconditional(ctx.rowEditable ? 80 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵconditional(ctx.colResizingService.showResizer ? 89 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.platform.isElements ? 94 : -1);
          }
        },
        dependencies: [NgClass, NgTemplateOutlet, NgStyle, IgxGridHeaderRowComponent, IgxGridBodyDirective, IgxGridDragSelectDirective, IgxColumnMovingDropDirective, IgxGridForOfDirective, IgxTemplateOutletDirective, IgxHierarchicalRowComponent, IgxOverlayOutletDirective, IgxToggleDirective, IgxCircularProgressBarComponent, IgxSnackbarComponent, IgxSummaryRowComponent, IgxButtonDirective, IgxRippleDirective, IgxIconComponent, IgxRowEditTabStopDirective, IgxGridColumnResizerComponent, IgxChildGridRowComponent, IgxGridSortingPipe, IgxGridFilteringPipe, IgxGridTransactionPipe, IgxHasVisibleColumnsPipe, IgxGridRowPinningPipe, IgxGridAddRowPipe, IgxGridRowClassesPipe, IgxGridRowStylesPipe, IgxSummaryDataPipe, IgxGridHierarchicalPipe, IgxGridHierarchicalPagingPipe, IgxStringReplacePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return IgxHierarchicalGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Hierarchical grid directives collection for ease-of-use import in standalone components scenario */
const IGX_HIERARCHICAL_GRID_DIRECTIVES = [IgxHierarchicalGridComponent, IgxRowIslandComponent, IgxRowAddTextDirective, IgxRowEditActionsDirective, IgxRowEditTextDirective, IgxRowEditTabStopDirective,
// IGX_GRID_COMMON_DIRECTIVES:
IgxRowDirective, IgxGridFooterComponent, IgxAdvancedFilteringDialogComponent, IgxRowExpandedIndicatorDirective, IgxRowCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHeaderCollapsedIndicatorDirective, IgxExcelStyleHeaderIconDirective, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxDragIndicatorIconDirective, IgxRowDragGhostDirective, IgxGridStateDirective,
// IGX_GRID_HEADERS_DIRECTIVES:
IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent,
// IGX_GRID_COLUMN_DIRECTIVES:
IgxFilterCellTemplateDirective, IgxSummaryTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCellHeaderTemplateDirective, IgxCellFooterTemplateDirective, IgxCellEditorTemplateDirective, IgxCollapsibleIndicatorTemplateDirective, IgxColumnComponent, IgxColumnGroupComponent, IgxColumnLayoutComponent,
// IGX_GRID_COLUMN_ACTIONS_DIRECTIVES:
IgxColumnActionsComponent, IgxColumnHidingDirective, IgxColumnPinningDirective,
// IGX_GRID_SELECTION_DIRECTIVES:
IgxRowSelectorDirective, IgxGroupByRowSelectorDirective, IgxHeadSelectorDirective,
// IGX_GRID_TOOLBAR_DIRECTIVES:
IgxCSVTextDirective, IgxExcelTextDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridToolbarDirective,
// IGX_GRID_EXCEL_STYLE_FILTER_DIRECTIVES:
IgxGridExcelStyleFilteringComponent, IgxExcelStyleHeaderComponent, IgxExcelStyleSortingComponent, IgxExcelStylePinningComponent, IgxExcelStyleHidingComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleClearFiltersComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleMovingComponent, IgxExcelStyleSearchComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleLoadingValuesTemplateDirective,
// IGX_GRID_VALIDATION_DIRECTIVES:
IgxColumnRequiredValidatorDirective, IgxColumnMinValidatorDirective, IgxColumnMaxValidatorDirective, IgxColumnEmailValidatorDirective, IgxColumnMinLengthValidatorDirective, IgxColumnMaxLengthValidatorDirective, IgxColumPatternValidatorDirective,
// IGX_PAGINATOR_DIRECTIVES:
IgxPaginatorComponent, IgxPageNavigationComponent, IgxPageSizeSelectorComponent, IgxPaginatorContentDirective, IgxPaginatorDirective];

/* NOTE: List directives collection for ease-of-use import in standalone components scenario */
const IGX_LIST_DIRECTIVES = [IgxListComponent, IgxListItemComponent, IgxListThumbnailDirective, IgxListActionDirective, IgxListLineDirective, IgxListLineTitleDirective, IgxListLineSubTitleDirective, IgxDataLoadingTemplateDirective, IgxEmptyListTemplateDirective, IgxListItemLeftPanningTemplateDirective, IgxListItemRightPanningTemplateDirective];

/**
 * IgxActionIcon is a container for the action nav icon of the IgxNavbar.
 */
let IgxNavbarActionDirective = /*#__PURE__*/(() => {
  class IgxNavbarActionDirective {
    static {
      this.ɵfac = function IgxNavbarActionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavbarActionDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavbarActionDirective,
        selectors: [["igx-navbar-action"], ["", "igxNavbarAction", ""]]
      });
    }
  }
  return IgxNavbarActionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxNavbarTitleDirective = /*#__PURE__*/(() => {
  class IgxNavbarTitleDirective {
    static {
      this.ɵfac = function IgxNavbarTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavbarTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavbarTitleDirective,
        selectors: [["igx-navbar-title"], ["", "igxNavbarTitle", ""]]
      });
    }
  }
  return IgxNavbarTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$4 = 0;
/**
 * **Ignite UI for Angular Navbar** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/navbar.html)
 *
 * The Ignite UI Navbar is most commonly used to provide an app header with a hamburger menu and navigation
 * state such as a "Go Back" button. It also supports other actions represented by icons.
 *
 * Example:
 * ```html
 * <igx-navbar title="Sample App" actionButtonIcon="menu">
 *   <igx-icon>search</igx-icon>
 *   <igx-icon>favorite</igx-icon>
 *   <igx-icon>more_vert</igx-icon>
 * </igx-navbar>
 * ```
 */
let IgxNavbarComponent = /*#__PURE__*/(() => {
  class IgxNavbarComponent {
    constructor() {
      /**
       * Sets the value of the `id` attribute. If not provided it will be automatically generated.
       * ```html
       * <igx-navbar [id]="'igx-navbar-12'" title="Sample App" actionButtonIcon="menu">
       * ```
       */
      this.id = `igx-navbar-${NEXT_ID$4++}`;
      /**
       * The event that will be thrown when the action is executed,
       * provides reference to the `IgxNavbar` component as argument
       * ```typescript
       * public actionExc(event){
       *     alert("Action Execute!");
       * }
       *  //..
       * ```
       * ```html
       * <igx-navbar (action)="actionExc($event)" title="Sample App" actionButtonIcon="menu">
       * ```
       */
      this.action = new EventEmitter();
      /**
       * Sets the titleId of the `IgxNavbarComponent`. If not set it will be automatically generated.
       * ```html
       * <igx-navbar [titleId]="'igx-navbar-7'" title="Sample App" actionButtonIcon="menu">
       * ```
       */
      this.titleId = `igx-navbar-title-${NEXT_ID$4++}`;
      this.isVisible = true;
    }
    /**
     * Sets whether the action button of the `IgxNavbarComponent` is visible.
     * ```html
     * <igx-navbar [title]="currentView" [isActionButtonVisible]="'false'"></igx-navbar>
     * ```
     */
    set isActionButtonVisible(value) {
      this.isVisible = value;
    }
    /**
     * Returns whether the `IgxNavbarComponent` action button is visible, true/false.
     * ```typescript
     *  @ViewChild("MyChild")
     * public navBar: IgxNavbarComponent;
     * ngAfterViewInit(){
     *     let actionButtonVisibile = this.navBar.isActionButtonVisible;
     * }
     * ```
     */
    get isActionButtonVisible() {
      if (this.actionIconTemplate || !this.actionButtonIcon) {
        return false;
      }
      return this.isVisible;
    }
    get isTitleContentVisible() {
      return this.titleContent ? true : false;
    }
    /**
     * @hidden
     */
    _triggerAction() {
      this.action.emit(this);
    }
    static {
      this.ɵfac = function IgxNavbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxNavbarComponent,
        selectors: [["igx-navbar"]],
        contentQueries: function IgxNavbarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxNavbarActionDirective, 5, IgxNavbarActionDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxNavbarTitleDirective, 5, IgxNavbarTitleDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionIconTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.titleContent = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function IgxNavbarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
          }
        },
        inputs: {
          id: "id",
          actionButtonIcon: "actionButtonIcon",
          title: "title",
          titleId: "titleId",
          isActionButtonVisible: [2, "isActionButtonVisible", "isActionButtonVisible", booleanAttribute]
        },
        outputs: {
          action: "action"
        },
        ngContentSelectors: _c288,
        decls: 9,
        vars: 3,
        consts: [["role", "navigation", 1, "igx-navbar"], [1, "igx-navbar__left"], [1, "igx-navbar__middle"], [1, "igx-navbar__title"], [1, "igx-navbar__right"], [3, "click"]],
        template: function IgxNavbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c287);
            i0.ɵɵelementStart(0, "nav", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, IgxNavbarComponent_Conditional_2_Template, 2, 1, "igx-icon");
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵtemplate(5, IgxNavbarComponent_Conditional_5_Template, 2, 2, "h1", 3);
            i0.ɵɵprojection(6, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 4);
            i0.ɵɵprojection(8, 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-labelledby", ctx.titleId);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isActionButtonVisible ? 2 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.isTitleContentVisible ? 5 : -1);
          }
        },
        dependencies: [IgxIconComponent],
        styles: ["[_nghost-%COMP%]{display:block;width:100%}"]
      });
    }
  }
  return IgxNavbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Navbar directives collection for ease-of-use import in standalone components scenario */
const IGX_NAVBAR_DIRECTIVES = [IgxNavbarComponent, IgxNavbarActionDirective, IgxNavbarTitleDirective];
let IgxNavDrawerItemDirective = /*#__PURE__*/(() => {
  class IgxNavDrawerItemDirective {
    constructor() {
      /**
       * Styles a navigation drawer item as selected.
       * If not set, `active` will have default value `false`.
       *
       * @example
       * ```html
       * <span igxDrawerItem [active]="true">Active Item</span>
       * ```
       */
      this.active = false;
      /**
       * Disables a navigation drawer item.
       * If not set, `disabled` will have default value `false`.
       *
       * @example
       * ```html
       * <span igxDrawerItem [disabled]="true">Disabled Item</span>
       * ```
       */
      this.disabled = false;
      /**
       * Styles a navigation drawer item as a group header.
       * If not set, `isHeader` will have default value `false`.
       *
       * @example
       * ```html
       * <span igxDrawerItem [isHeader]="true">Header</span>
       * ```
       */
      this.isHeader = false;
      /**
       * @hidden
       */
      this.activeClass = 'igx-nav-drawer__item--active';
      /**
      * @hidden
      */
      this.disabledClass = 'igx-nav-drawer__item--disabled';
    }
    /**
     * @hidden
     */
    get defaultCSS() {
      return !this.active && !this.isHeader;
    }
    /**
     * @hidden
     */
    get currentCSS() {
      return this.active && !this.isHeader && !this.disabled;
    }
    /**
     * @hidden
     */
    get headerCSS() {
      return this.isHeader;
    }
    /**
     * @hidden
     */
    get disabledCSS() {
      return this.disabled;
    }
    static {
      this.ɵfac = function IgxNavDrawerItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavDrawerItemDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavDrawerItemDirective,
        selectors: [["", "igxDrawerItem", ""]],
        hostVars: 8,
        hostBindings: function IgxNavDrawerItemDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-nav-drawer__item", ctx.defaultCSS)("igx-nav-drawer__item--active", ctx.currentCSS)("igx-nav-drawer__item--header", ctx.headerCSS)("igx-nav-drawer__item--disabled", ctx.disabledCSS);
          }
        },
        inputs: {
          active: [2, "active", "active", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          isHeader: [2, "isHeader", "isHeader", booleanAttribute]
        },
        exportAs: ["igxDrawerItem"]
      });
    }
  }
  return IgxNavDrawerItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxNavDrawerTemplateDirective = /*#__PURE__*/(() => {
  class IgxNavDrawerTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxNavDrawerTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavDrawerTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavDrawerTemplateDirective,
        selectors: [["", "igxDrawer", ""]]
      });
    }
  }
  return IgxNavDrawerTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxNavDrawerMiniTemplateDirective = /*#__PURE__*/(() => {
  class IgxNavDrawerMiniTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function IgxNavDrawerMiniTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavDrawerMiniTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxNavDrawerMiniTemplateDirective,
        selectors: [["", "igxDrawerMini", ""]]
      });
    }
  }
  return IgxNavDrawerMiniTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$3 = 0;
/**
 * **Ignite UI for Angular Navigation Drawer** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/navdrawer)
 *
 * The Ignite UI Navigation Drawer is a collapsible side navigation container commonly used in combination with the Navbar.
 *
 * Example:
 * ```html
 * <igx-nav-drawer id="navigation" [isOpen]="true">
 *   <ng-template igxDrawer>
 *     <nav>
 *       <span igxDrawerItem [isHeader]="true">Email</span>
 *       <span igxDrawerItem igxRipple>Inbox</span>
 *       <span igxDrawerItem igxRipple>Deleted</span>
 *       <span igxDrawerItem igxRipple>Sent</span>
 *     </nav>
 *   </ng-template>
 * </igx-nav-drawer>
 * ```
 */
let IgxNavigationDrawerComponent = /*#__PURE__*/(() => {
  class IgxNavigationDrawerComponent {
    get width() {
      return this._width;
    }
    set width(value) {
      this._width = value;
    }
    /**
     * State of the drawer.
     *
     * ```typescript
     * // get
     * let navDrawerIsOpen = this.navdrawer.isOpen;
     * ```
     *
     * ```html
     * <!--set-->
     * <igx-nav-drawer [isOpen]='false'></igx-nav-drawer>
     * ```
     *
     * Two-way data binding.
     * ```html
     * <!--set-->
     * <igx-nav-drawer [(isOpen)]='model.isOpen'></igx-nav-drawer>
     * ```
     */
    get isOpen() {
      return this._isOpen;
    }
    set isOpen(value) {
      this._isOpen = value;
      this.isOpenChange.emit(this._isOpen);
    }
    /**
     * Returns nativeElement of the component.
     *
     * @hidden
     */
    get element() {
      return this.elementRef.nativeElement;
    }
    /**
     * @hidden
     */
    get template() {
      if (this.miniTemplate && !this.isOpen) {
        return this.miniTemplate.template;
      } else if (this.contentTemplate) {
        return this.contentTemplate.template;
      }
    }
    /**
     * @hidden
     */
    get miniTemplate() {
      return this._miniTemplate;
    }
    /**
     * @hidden
     */
    set miniTemplate(v) {
      this._miniTemplate = v;
    }
    /** @hidden @internal */
    get isMini() {
      return !!this._miniTemplate && !this.isOpen;
    }
    /** @hidden @internal */
    get pinned() {
      return !!this.pin;
    }
    /**
     * @hidden
     */
    get normalSize() {
      if (!this.isOpen) {
        return '0px';
      }
      return this.width;
    }
    /**
     * @hidden
     */
    get miniSize() {
      if (this.miniTemplate && this.miniWidth) {
        return this.miniWidth;
      }
    }
    /** @hidden */
    get isPinnedRight() {
      return this.pin && this.position === 'right' ? '1' : '0';
    }
    /**
     * @hidden
     */
    get drawer() {
      return this._drawer.nativeElement;
    }
    /**
     * @hidden
     */
    get overlay() {
      return this._overlay.nativeElement;
    }
    /**
     * @hidden
     */
    get styleDummy() {
      return this._styleDummy.nativeElement;
    }
    /**
     * Property to decide whether to change width or translate the drawer from pan gesture.
     *
     * @hidden
     */
    get hasAnimateWidth() {
      return this.pin || !!this.miniTemplate;
    }
    /**
     * Used for touch gestures (swipe and pan).
     * Defaults to 50 (in px) and is extended to at least 110% of the mini template width if available.
     *
     * @hidden
     */
    get maxEdgeZone() {
      return this._maxEdgeZone;
    }
    /**
     * Gets the Drawer width for specific state.
     * Will attempt to evaluate requested state and cache.
     *
     *
     * @hidden
     */
    get expectedWidth() {
      return this.getExpectedWidth(false);
    }
    /**
     * Get the Drawer mini width for specific state.
     * Will attempt to evaluate requested state and cache.
     *
     * @hidden
     */
    get expectedMiniWidth() {
      return this.getExpectedWidth(true);
    }
    /**
     * @hidden
     */
    get touchManager() {
      return this._touchManager;
    }
    /**
     * Exposes optional navigation service
     *
     * @hidden
     */
    get state() {
      return this._state;
    }
    constructor(elementRef, _state, renderer, _touchManager, platformUtil) {
      this.elementRef = elementRef;
      this._state = _state;
      this.renderer = renderer;
      this._touchManager = _touchManager;
      this.platformUtil = platformUtil;
      /** @hidden @internal */
      this.cssClass = true;
      /**
       * ID of the component
       *
       * ```typescript
       * // get
       * let myNavDrawerId = this.navdrawer.id;
       * ```
       *
       * ```html
       * <!--set-->
       *  <igx-nav-drawer id='navdrawer'></igx-nav-drawer>
       * ```
       */
      this.id = `igx-nav-drawer-${NEXT_ID$3++}`;
      /**
       * Position of the Navigation Drawer. Can be "left"(default) or "right".
       *
       * ```typescript
       * // get
       * let myNavDrawerPosition = this.navdrawer.position;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-nav-drawer [position]="'left'"></igx-nav-drawer>
       * ```
       */
      this.position = 'left';
      /**
       * Enables the use of touch gestures to manipulate the drawer:
       * - swipe/pan from edge to open, swipe-toggle and pan-drag.
       *
       * ```typescript
       * // get
       * let gesturesEnabled = this.navdrawer.enableGestures;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-nav-drawer [enableGestures]='true'></igx-nav-drawer>
       * ```
       */
      this.enableGestures = true;
      /**
       * @hidden
       */
      this.isOpenChange = new EventEmitter();
      /**
       * Minimum device width required for automatic pin to be toggled.
       * Default is 1024, can be set to a falsy value to disable this behavior.
       *
       * ```typescript
       * // get
       * let navDrawerPinThreshold = this.navdrawer.pinThreshold;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-nav-drawer [pinThreshold]='1024'></igx-nav-drawer>
       * ```
       */
      this.pinThreshold = 1024;
      /**
       * When pinned the drawer is relatively positioned instead of sitting above content.
       * May require additional layout styling.
       *
       * ```typescript
       * // get
       * let navDrawerIsPinned = this.navdrawer.pin;
       * ```
       *
       * ```html
       * <!--set-->
       * <igx-nav-drawer [pin]='false'></igx-nav-drawer>
       * ```
       */
      this.pin = false;
      /**
       * Enables/disables the animation, when toggling the drawer. Set to `false` by default.
       * ````html
       * <igx-nav-drawer [disableAnimation]="true"></igx-nav-drawer>
       * ````
       */
      this.disableAnimation = false;
      /**
       * Pinned state change output for two-way binding.
       *
       * ```html
       * <igx-nav-drawer [(pin)]='isPinned'></igx-nav-drawer>
       * ```
       */
      this.pinChange = new EventEmitter(true);
      /**
       * Event fired as the Navigation Drawer is about to open.
       *
       * ```html
       *  <igx-nav-drawer (opening)='onOpening()'></igx-nav-drawer>
       * ```
       */
      this.opening = new EventEmitter();
      /**
       * Event fired when the Navigation Drawer has opened.
       *
       * ```html
       * <igx-nav-drawer (opened)='onOpened()'></igx-nav-drawer>
       * ```
       */
      this.opened = new EventEmitter();
      /**
       * Event fired as the Navigation Drawer is about to close.
       *
       * ```html
       * <igx-nav-drawer (closing)='onClosing()'></igx-nav-drawer>
       * ```
       */
      this.closing = new EventEmitter();
      /**
       * Event fired when the Navigation Drawer has closed.
       *
       * ```html
       * <igx-nav-drawer (closed)='onClosed()'></igx-nav-drawer>
       * ```
       */
      this.closed = new EventEmitter();
      this._isOpen = false;
      this._gesturesAttached = false;
      this._widthCache = {
        width: null,
        miniWidth: null,
        windowWidth: null
      };
      this.css = {
        drawer: 'igx-nav-drawer__aside',
        mini: 'igx-nav-drawer__aside--mini',
        overlay: 'igx-nav-drawer__overlay',
        styleDummy: 'igx-nav-drawer__style-dummy'
      };
      /** Pan animation properties */
      this._panning = false;
      this._maxEdgeZone = 50;
      this.checkPinThreshold = evt => {
        if (!this.platformUtil.isBrowser) {
          return;
        }
        let windowWidth;
        if (this.pinThreshold) {
          windowWidth = this.getWindowWidth();
          if (evt && this._widthCache.windowWidth === windowWidth) {
            return;
          }
          this._widthCache.windowWidth = windowWidth;
          if (!this.pin && windowWidth >= this.pinThreshold) {
            this.pin = true;
            this.pinChange.emit(true);
          } else if (this.pin && windowWidth < this.pinThreshold) {
            this.pin = false;
            this.pinChange.emit(false);
          }
        }
      };
      this.swipe = evt => {
        // TODO: Could also force input type: http://stackoverflow.com/a/27108052
        if (!this.enableGestures || evt.pointerType !== 'touch') {
          return;
        }
        // HammerJS swipe is horizontal-only by default, don't check deltaY
        let deltaX;
        let startPosition;
        if (this.position === 'right') {
          // when on the right use inverse of deltaX
          deltaX = -evt.deltaX;
          startPosition = this.getWindowWidth() - (evt.center.x + evt.distance);
        } else {
          deltaX = evt.deltaX;
          startPosition = evt.center.x - evt.distance;
        }
        // only accept closing swipe (ignoring minEdgeZone) when the drawer is expanded:
        if (this.isOpen && deltaX < 0 ||
        // positive deltaX from the edge:
        deltaX > 0 && startPosition < this.maxEdgeZone) {
          this.toggle();
        }
      };
      this.panstart = evt => {
        if (!this.enableGestures || this.pin || evt.pointerType !== 'touch') {
          return;
        }
        const startPosition = this.position === 'right' ? this.getWindowWidth() - (evt.center.x + evt.distance) : evt.center.x - evt.distance;
        // cache width during animation, flag to allow further handling
        if (this.isOpen || startPosition < this.maxEdgeZone) {
          this._panning = true;
          this._panStartWidth = this.getExpectedWidth(!this.isOpen);
          this._panLimit = this.getExpectedWidth(this.isOpen);
          this.renderer.addClass(this.overlay, 'panning');
          this.renderer.addClass(this.drawer, 'panning');
        }
      };
      this.pan = evt => {
        // TODO: input.deltaX = prevDelta.x + (center.x - offset.x);
        // get actual delta (not total session one) from event?
        // pan WILL also fire after a full swipe, only resize on flag
        if (!this._panning) {
          return;
        }
        const right = this.position === 'right';
        // when on the right use inverse of deltaX
        const deltaX = right ? -evt.deltaX : evt.deltaX;
        let newX;
        let percent;
        const visibleWidth = this._panStartWidth + deltaX;
        if (this.isOpen && deltaX < 0) {
          // when visibleWidth hits limit - stop animating
          if (visibleWidth <= this._panLimit) {
            return;
          }
          if (this.hasAnimateWidth) {
            percent = (visibleWidth - this._panLimit) / (this._panStartWidth - this._panLimit);
            newX = visibleWidth;
          } else {
            percent = visibleWidth / this._panStartWidth;
            newX = evt.deltaX;
          }
          this.setXSize(newX, percent.toPrecision(2));
        } else if (!this.isOpen && deltaX > 0) {
          // when visibleWidth hits limit - stop animating
          if (visibleWidth >= this._panLimit) {
            return;
          }
          if (this.hasAnimateWidth) {
            percent = (visibleWidth - this._panStartWidth) / (this._panLimit - this._panStartWidth);
            newX = visibleWidth;
          } else {
            percent = visibleWidth / this._panLimit;
            newX = (this._panLimit - visibleWidth) * (right ? 1 : -1);
          }
          this.setXSize(newX, percent.toPrecision(2));
        }
      };
      this.panEnd = evt => {
        if (this._panning) {
          const deltaX = this.position === 'right' ? -evt.deltaX : evt.deltaX;
          const visibleWidth = this._panStartWidth + deltaX;
          this.resetPan();
          // check if pan brought the drawer to 50%
          if (this.isOpen && visibleWidth <= this._panStartWidth / 2) {
            this.close();
          } else if (!this.isOpen && visibleWidth >= this._panLimit / 2) {
            this.open();
          }
          this._panStartWidth = null;
        }
      };
      this.toggleOpenedEvent = () => {
        this.elementRef.nativeElement.removeEventListener('transitionend', this.toggleOpenedEvent, false);
        this.opened.emit();
      };
      this.toggleClosedEvent = () => {
        this.elementRef.nativeElement.removeEventListener('transitionend', this.toggleClosedEvent, false);
        this.closed.emit();
      };
    }
    /**
     * @hidden
     */
    ngOnInit() {
      // DOM and @Input()-s initialized
      if (this._state) {
        this._state.add(this.id, this);
      }
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
      // wait for template and ng-content to be ready
      this.updateEdgeZone();
      this.checkPinThreshold();
      this.ensureEvents();
      // TODO: apply platform-safe Ruler from http://plnkr.co/edit/81nWDyreYMzkunihfRgX?p=preview
      // (https://github.com/angular/angular/issues/6515), blocked by https://github.com/angular/angular/issues/6904
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._touchManager.destroy();
      if (this._state) {
        this._state.remove(this.id);
      }
      if (this._resizeObserver) {
        this._resizeObserver.unsubscribe();
      }
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      // simple settings can come from attribute set (rather than binding), make sure boolean props are converted
      if (changes.enableGestures && changes.enableGestures.currentValue !== undefined) {
        this.enableGestures = !!(this.enableGestures && this.enableGestures.toString() === 'true');
        this.ensureEvents();
      }
      if (changes.pin && changes.pin.currentValue !== undefined) {
        this.pin = !!(this.pin && this.pin.toString() === 'true');
        if (this.pin) {
          this._touchManager.destroy();
          this._gesturesAttached = false;
        } else {
          this.ensureEvents();
        }
      }
      if (changes.pinThreshold) {
        if (this.pinThreshold) {
          this.ensureEvents();
          this.checkPinThreshold();
        }
      }
      if (changes.miniWidth) {
        this.updateEdgeZone();
      }
    }
    /**
     * Toggle the open state of the Navigation Drawer.
     *
     * ```typescript
     * this.navdrawer.toggle();
     * ```
     */
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
    /**
     * Open the Navigation Drawer. Has no effect if already opened.
     *
     * ```typescript
     * this.navdrawer.open();
     * ```
     */
    open() {
      if (this._panning) {
        this.resetPan();
      }
      if (this.isOpen) {
        return;
      }
      this.opening.emit();
      this.isOpen = true;
      // TODO: Switch to animate API when available
      // var animationCss = this.animate.css();
      //     animationCss
      //         .setStyles({'width':'50px'}, {'width':'400px'})
      //         .start(this.elementRef.nativeElement)
      //         .onComplete(() => animationCss.setToStyles({'width':'auto'}).start(this.elementRef.nativeElement));
      this.elementRef.nativeElement.addEventListener('transitionend', this.toggleOpenedEvent, false);
      requestAnimationFrame(() => {});
    }
    /**
     * Close the Navigation Drawer. Has no effect if already closed.
     *
     * ```typescript
     * this.navdrawer.close();
     * ```
     */
    close() {
      if (this._panning) {
        this.resetPan();
      }
      if (!this.isOpen) {
        return;
      }
      this.closing.emit();
      this.isOpen = false;
      this.elementRef.nativeElement.addEventListener('transitionend', this.toggleClosedEvent, false);
    }
    /**
     * @hidden
     */
    set_maxEdgeZone(value) {
      this._maxEdgeZone = value;
    }
    /**
     * Get the Drawer width for specific state. Will attempt to evaluate requested state and cache.
     *
     * @hidden
     * @param [mini] - Request mini width instead
     */
    getExpectedWidth(mini) {
      if (mini) {
        if (!this.miniTemplate) {
          return 0;
        }
        if (this.miniWidth) {
          return parseFloat(this.miniWidth);
        } else {
          // if (!this.isOpen) { // This WON'T work due to transition timings...
          //     return this.elementRef.nativeElement.children[1].offsetWidth;
          // } else {
          if (this._widthCache.miniWidth === null) {
            // force class for width calc. TODO?
            // force class for width calc. TODO?
            this.renderer.addClass(this.styleDummy, this.css.drawer);
            this.renderer.addClass(this.styleDummy, this.css.mini);
            this._widthCache.miniWidth = this.styleDummy.offsetWidth;
            this.renderer.removeClass(this.styleDummy, this.css.drawer);
            this.renderer.removeClass(this.styleDummy, this.css.mini);
          }
          return this._widthCache.miniWidth;
        }
      } else {
        if (this.width) {
          return parseFloat(this.width);
        } else {
          if (this._widthCache.width === null) {
            // force class for width calc. TODO?
            // force class for width calc. TODO?
            this.renderer.addClass(this.styleDummy, this.css.drawer);
            this._widthCache.width = this.styleDummy.offsetWidth;
            this.renderer.removeClass(this.styleDummy, this.css.drawer);
          }
          return this._widthCache.width;
        }
      }
    }
    getWindowWidth() {
      return window.innerWidth > 0 ? window.innerWidth : screen.width;
    }
    /**
     * Get current Drawer width.
     */
    getDrawerWidth() {
      return this.drawer.offsetWidth;
    }
    ensureEvents() {
      // set listeners for swipe/pan only if needed, but just once
      if (this.enableGestures && !this.pin && !this._gesturesAttached) {
        // Built-in manager handler(L20887) causes endless loop and max stack exception.
        // https://github.com/angular/angular/issues/6993
        // Use ours for now (until beta.10):
        // this.renderer.listen(document, "swipe", this.swipe);
        this._touchManager.addGlobalEventListener('document', 'swipe', this.swipe);
        this._gesturesAttached = true;
        // this.renderer.listen(document, "panstart", this.panstart);
        // this.renderer.listen(document, "pan", this.pan);
        this._touchManager.addGlobalEventListener('document', 'panstart', this.panstart);
        this._touchManager.addGlobalEventListener('document', 'panmove', this.pan);
        this._touchManager.addGlobalEventListener('document', 'panend', this.panEnd);
      }
      if (!this._resizeObserver && this.platformUtil.isBrowser) {
        this._resizeObserver = fromEvent(window, 'resize').pipe(debounce(() => interval(150))).subscribe(value => {
          this.checkPinThreshold(value);
        });
      }
    }
    updateEdgeZone() {
      let maxValue;
      if (this.miniTemplate) {
        maxValue = Math.max(this._maxEdgeZone, this.getExpectedWidth(true) * 1.1);
        this.set_maxEdgeZone(maxValue);
      }
    }
    resetPan() {
      this._panning = false;
      /* styles fail to apply when set on parent due to extra attributes, prob ng bug */
      /* styles fail to apply when set on parent due to extra attributes, prob ng bug */
      this.renderer.removeClass(this.overlay, 'panning');
      this.renderer.removeClass(this.drawer, 'panning');
      this.setXSize(0, '');
    }
    /**
     * Sets the absolute position or width in case the drawer doesn't change position.
     *
     * @param x the number pixels to translate on the X axis or the width to set. 0 width will clear the style instead.
     * @param opacity optional value to apply to the overlay
     */
    setXSize(x, opacity) {
      // Angular polyfills patches window.requestAnimationFrame, but switch to DomAdapter API (TODO)
      window.requestAnimationFrame(() => {
        if (this.hasAnimateWidth) {
          this.renderer.setStyle(this.drawer, 'width', x ? Math.abs(x) + 'px' : '');
        } else {
          this.renderer.setStyle(this.drawer, 'transform', x ? 'translate3d(' + x + 'px,0,0)' : '');
          this.renderer.setStyle(this.drawer, '-webkit-transform', x ? 'translate3d(' + x + 'px,0,0)' : '');
        }
        if (opacity !== undefined) {
          this.renderer.setStyle(this.overlay, 'opacity', opacity);
        }
      });
    }
    static {
      this.ɵfac = function IgxNavigationDrawerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavigationDrawerComponent)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(IgxNavigationService, 8), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(HammerGesturesManager), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxNavigationDrawerComponent,
        selectors: [["igx-nav-drawer"]],
        contentQueries: function IgxNavigationDrawerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxNavDrawerTemplateDirective, 5, IgxNavDrawerTemplateDirective);
            i0.ɵɵcontentQuery(dirIndex, IgxNavDrawerMiniTemplateDirective, 5, IgxNavDrawerMiniTemplateDirective);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.miniTemplate = _t.first);
          }
        },
        viewQuery: function IgxNavigationDrawerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c289, 7);
            i0.ɵɵviewQuery(_c290, 7);
            i0.ɵɵviewQuery(_c291, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._drawer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._overlay = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._styleDummy = _t.first);
          }
        },
        hostVars: 15,
        hostBindings: function IgxNavigationDrawerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵstyleProp("--igx-nav-drawer-size", ctx.normalSize)("--igx-nav-drawer-size--mini", ctx.miniSize)("order", ctx.isPinnedRight);
            i0.ɵɵclassProp("igx-nav-drawer", ctx.cssClass)("igx-nav-drawer--disable-animation", ctx.disableAnimation)("igx-nav-drawer--mini", ctx.isMini)("igx-nav-drawer--pinned", ctx.pinned);
          }
        },
        inputs: {
          id: "id",
          position: "position",
          enableGestures: [2, "enableGestures", "enableGestures", booleanAttribute],
          pinThreshold: "pinThreshold",
          pin: [2, "pin", "pin", booleanAttribute],
          width: "width",
          disableAnimation: [2, "disableAnimation", "disableAnimation", booleanAttribute],
          miniWidth: "miniWidth",
          isOpen: [2, "isOpen", "isOpen", booleanAttribute]
        },
        outputs: {
          isOpenChange: "isOpenChange",
          pinChange: "pinChange",
          opening: "opening",
          opened: "opened",
          closing: "closing",
          closed: "closed"
        },
        features: [i0.ɵɵProvidersFeature([HammerGesturesManager]), i0.ɵɵNgOnChangesFeature],
        decls: 9,
        vars: 18,
        consts: [["defaultItemsTemplate", ""], ["overlay", ""], ["aside", ""], ["dummy", ""], [1, "igx-nav-drawer__overlay", 3, "click", "hidden"], [1, "igx-nav-drawer__aside"], [4, "ngTemplateOutlet"], [1, "igx-nav-drawer__style-dummy"], ["igxDrawerItem", "", 3, "isHeader"], ["igxDrawerItem", ""], ["igxDrawerItem", "", 3, "disabled"]],
        template: function IgxNavigationDrawerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, IgxNavigationDrawerComponent_ng_template_0_Template, 15, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(2, "div", 4, 1);
            i0.ɵɵlistener("click", function IgxNavigationDrawerComponent_Template_div_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.close());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "nav", 5, 2);
            i0.ɵɵtemplate(6, IgxNavigationDrawerComponent_ng_container_6_Template, 1, 0, "ng-container", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "div", 7, 3);
          }
          if (rf & 2) {
            const defaultItemsTemplate_r2 = i0.ɵɵreference(1);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("igx-nav-drawer__overlay--hidden", !ctx.isOpen)("igx-nav-drawer--disable-animation", ctx.disableAnimation);
            i0.ɵɵproperty("hidden", ctx.pin);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("igx-nav-drawer__aside--collapsed", !ctx.miniTemplate && !ctx.isOpen)("igx-nav-drawer__aside--mini", ctx.miniTemplate && !ctx.isOpen)("igx-nav-drawer__aside--normal", !ctx.miniTemplate || ctx.isOpen)("igx-nav-drawer__aside--pinned", ctx.pin)("igx-nav-drawer__aside--right", ctx.position === "right")("igx-nav-drawer--disable-animation", ctx.disableAnimation);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template || defaultItemsTemplate_r2);
          }
        },
        dependencies: [IgxNavDrawerItemDirective, NgTemplateOutlet],
        styles: ["[_nghost-%COMP%]{display:block;height:100%}"]
      });
    }
  }
  return IgxNavigationDrawerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Navigation drawer directives collection for ease-of-use import in standalone components scenario */
const IGX_NAVIGATION_DRAWER_DIRECTIVES = [IgxNavigationDrawerComponent, IgxNavDrawerItemDirective, IgxNavDrawerMiniTemplateDirective, IgxNavDrawerTemplateDirective];

/* NOTE: Progress bar (linear and circular) directives collection for ease-of-use import in standalone components scenario */
const IGX_PROGRESS_BAR_DIRECTIVES = [IgxLinearProgressBarComponent, IgxCircularProgressBarComponent, IgxProgressBarTextTemplateDirective, IgxProgressBarGradientDirective];
/* NOTE: Linear progress bar directives collection for ease-of-use import in standalone components scenario */
const IGX_LINEAR_PROGRESS_BAR_DIRECTIVES = [IgxLinearProgressBarComponent, IgxProgressBarGradientDirective];
/* NOTE: Circular progress bar directives collection for ease-of-use import in standalone components scenario */
const IGX_CIRCULAR_PROGRESS_BAR_DIRECTIVES = [IgxCircularProgressBarComponent, IgxProgressBarTextTemplateDirective, IgxProgressBarGradientDirective];

/**
 * Template directive that allows you to set a custom template representing the lower label value of the {@link IgxSliderComponent}
 *
 * ```html
 * <igx-slider>
 *  <ng-template igxSliderThumbFrom let-value let-labels>{{value}}</ng-template>
 * </igx-slider>
 * ```
 *
 * @context {@link IgxSliderComponent.context}
 */
let IgxThumbFromTemplateDirective = /*#__PURE__*/(() => {
  class IgxThumbFromTemplateDirective {
    static {
      this.ɵfac = function IgxThumbFromTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxThumbFromTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxThumbFromTemplateDirective,
        selectors: [["", "igxSliderThumbFrom", ""]]
      });
    }
  }
  return IgxThumbFromTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Template directive that allows you to set a custom template representing the upper label value of the {@link IgxSliderComponent}
 *
 * ```html
 * <igx-slider>
 *  <ng-template igxSliderThumbTo let-value let-labels>{{value}}</ng-template>
 * </igx-slider>
 * ```
 *
 * @context {@link IgxSliderComponent.context}
 */
let IgxThumbToTemplateDirective = /*#__PURE__*/(() => {
  class IgxThumbToTemplateDirective {
    static {
      this.ɵfac = function IgxThumbToTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxThumbToTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxThumbToTemplateDirective,
        selectors: [["", "igxSliderThumbTo", ""]]
      });
    }
  }
  return IgxThumbToTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Template directive that allows you to set a custom template, represeting primary/secondary tick labels of the {@link IgxSliderComponent}
 *
 * @context {@link IgxTicksComponent.context}
 */
let IgxTickLabelTemplateDirective = /*#__PURE__*/(() => {
  class IgxTickLabelTemplateDirective {
    static {
      this.ɵfac = function IgxTickLabelTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTickLabelTemplateDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTickLabelTemplateDirective,
        selectors: [["", "igxSliderTickLabel", ""]]
      });
    }
  }
  return IgxTickLabelTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxSliderType = /*@__PURE__*/mkenum({
  /**
   * Slider with single thumb.
   */
  SLIDER: 'slider',
  /**
   *  Range slider with multiple thumbs, that can mark the range.
   */
  RANGE: 'range'
});
const SliderHandle = /*@__PURE__*/mkenum({
  FROM: 'from',
  TO: 'to'
});
/**
 * Slider Tick labels Orientation
 */
const TickLabelsOrientation = /*@__PURE__*/mkenum({
  Horizontal: 'horizontal',
  TopToBottom: 'toptobottom',
  BottomToTop: 'bottomtotop'
});
/**
 * Slider Ticks orientation
 */
const TicksOrientation = /*@__PURE__*/mkenum({
  Top: 'top',
  Bottom: 'bottom',
  Mirror: 'mirror'
});

/**
 * @hidden
 */
let IgxThumbLabelComponent = /*#__PURE__*/(() => {
  class IgxThumbLabelComponent {
    get thumbFromClass() {
      return this.type === SliderHandle.FROM;
    }
    get thumbToClass() {
      return this.type === SliderHandle.TO;
    }
    get thumbFromActiveClass() {
      return this.type === SliderHandle.FROM && this.active;
    }
    get thumbToActiveClass() {
      return this.type === SliderHandle.TO && this.active;
    }
    get labelFromPressedClass() {
      return this.thumb?.thumbFromPressedClass;
    }
    get labelToPressedClass() {
      return this.thumb?.thumbToPressedClass;
    }
    get getLabelClass() {
      return {
        'igx-slider-thumb-label-from__container': this.type === SliderHandle.FROM,
        'igx-slider-thumb-label-to__container': this.type === SliderHandle.TO
      };
    }
    constructor(_elementRef) {
      this._elementRef = _elementRef;
    }
    get nativeElement() {
      return this._elementRef.nativeElement;
    }
    get active() {
      return this._active;
    }
    set active(val) {
      if (this.continuous || this.deactiveState) {
        this._active = false;
      } else {
        this._active = val;
      }
    }
    static {
      this.ɵfac = function IgxThumbLabelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxThumbLabelComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxThumbLabelComponent,
        selectors: [["igx-thumb-label"]],
        hostVars: 12,
        hostBindings: function IgxThumbLabelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-slider-thumb-label-from", ctx.thumbFromClass)("igx-slider-thumb-label-to", ctx.thumbToClass)("igx-slider-thumb-label-from--active", ctx.thumbFromActiveClass)("igx-slider-thumb-label-to--active", ctx.thumbToActiveClass)("igx-slider-thumb-label-from--pressed", ctx.labelFromPressedClass)("igx-slider-thumb-label-to--pressed", ctx.labelToPressedClass);
          }
        },
        inputs: {
          value: "value",
          templateRef: "templateRef",
          context: "context",
          type: "type",
          continuous: [2, "continuous", "continuous", booleanAttribute],
          deactiveState: [2, "deactiveState", "deactiveState", booleanAttribute],
          thumb: "thumb"
        },
        decls: 4,
        vars: 3,
        consts: [["thumbFromDefaultTemplate", ""], [3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function IgxThumbLabelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, IgxThumbLabelComponent_ng_container_1_Template, 1, 0, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, IgxThumbLabelComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const thumbFromDefaultTemplate_r2 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngClass", ctx.getLabelClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef ? ctx.templateRef : thumbFromDefaultTemplate_r2)("ngTemplateOutletContext", ctx.context);
          }
        },
        dependencies: [NgClass, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxThumbLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxSliderThumbComponent = /*#__PURE__*/(() => {
  class IgxSliderThumbComponent {
    get ariaValueNow() {
      return this.value;
    }
    get ariaValueMin() {
      return this.min;
    }
    get ariaValueMax() {
      return this.max;
    }
    get ariaValueText() {
      if (this.labels && this.labels[this.value] !== undefined) {
        return this.labels[this.value];
      }
      return this.value;
    }
    get ariaLabelAttr() {
      return `Slider thumb ${this.type}`;
    }
    get ariaDisabled() {
      return this.disabled;
    }
    get thumbFromClass() {
      return this.type === SliderHandle.FROM;
    }
    get thumbToClass() {
      return this.type === SliderHandle.TO;
    }
    get thumbFromActiveClass() {
      return this.type === SliderHandle.FROM && this._isActive;
    }
    get thumbToActiveClass() {
      return this.type === SliderHandle.TO && this._isActive;
    }
    get thumbFromDisabledClass() {
      return this.type === SliderHandle.FROM && this.disabled;
    }
    get thumbToDisabledClass() {
      return this.type === SliderHandle.TO && this.disabled;
    }
    get thumbFromPressedClass() {
      return this.type === SliderHandle.FROM && this.isActive && this._isPressed;
    }
    get thumbToPressedClass() {
      return this.type === SliderHandle.TO && this.isActive && this._isPressed;
    }
    get getDotClass() {
      return {
        'igx-slider-thumb-from__dot': this.type === SliderHandle.FROM,
        'igx-slider-thumb-to__dot': this.type === SliderHandle.TO
      };
    }
    get nativeElement() {
      return this._elementRef.nativeElement;
    }
    get destroy() {
      return this._destroy$;
    }
    get thumbPositionX() {
      const thumbBounderies = this.nativeElement.getBoundingClientRect();
      const thumbCenter = (thumbBounderies.right - thumbBounderies.left) / 2;
      return thumbBounderies.left + thumbCenter;
    }
    constructor(_elementRef, _dir) {
      this._elementRef = _elementRef;
      this._dir = _dir;
      this.thumbValueChange = new EventEmitter();
      this.thumbChange = new EventEmitter();
      this.thumbBlur = new EventEmitter();
      this.hoverChange = new EventEmitter();
      this.tabindex = 0;
      this.role = 'slider';
      this.ariaOrientation = 'horizontal';
      this.zIndex = 0;
      this.focused = false;
      this.isActive = false;
      this._isActive = false;
      this._isPressed = false;
      this._destroy$ = new Subject();
    }
    onPointerEnter() {
      this.focused = false;
      this.hoverChange.emit(true);
    }
    onPointerLeave() {
      this.hoverChange.emit(false);
    }
    onKeyUp(event) {
      event.stopPropagation();
      this.focused = true;
    }
    onKeyDown(event) {
      if (this.disabled) {
        return;
      }
      let increment = 0;
      const stepWithDir = rtl => rtl ? this.step * -1 : this.step;
      if (event.key.endsWith('Left')) {
        increment = stepWithDir(!this._dir.rtl);
      } else if (event.key.endsWith('Right')) {
        increment = stepWithDir(this._dir.rtl);
      } else {
        return;
      }
      this.thumbChange.emit();
      this.thumbValueChange.emit(increment);
    }
    onBlur() {
      this.isActive = false;
      this.zIndex = 0;
      this.focused = false;
      this.thumbBlur.emit();
    }
    onFocusListener() {
      this.isActive = true;
      this.zIndex = 1;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this.onPan.pipe(takeUntil(this._destroy$)).subscribe(mouseX => this.updateThumbValue(mouseX));
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._destroy$.next(true);
      this._destroy$.complete();
    }
    /**
     * Show thumb label and ripple.
     */
    showThumbIndicators() {
      this.toggleThumbIndicators(true);
    }
    /**
     * Hide thumb label and ripple.
     */
    hideThumbIndicators() {
      this.toggleThumbIndicators(false);
    }
    updateThumbValue(mouseX) {
      const updateValue = this.calculateTrackUpdate(mouseX);
      if (this.isActive && updateValue !== 0) {
        this.thumbValueChange.emit(updateValue);
      }
    }
    calculateTrackUpdate(mouseX) {
      const scaleX = this._dir.rtl ? this.thumbPositionX - mouseX : mouseX - this.thumbPositionX;
      const stepDistanceCenter = this.stepDistance / 2;
      // If the thumb scale range (slider update) is less thàn a half step,
      // the position stays the same.
      const scaleXPositive = Math.abs(scaleX);
      if (scaleXPositive < stepDistanceCenter) {
        return 0;
      }
      return this.stepToProceed(scaleX, this.stepDistance);
    }
    stepToProceed(scaleX, stepDist) {
      return Math.round(scaleX / stepDist) * this.step;
    }
    toggleThumbIndicators(visible) {
      this._isPressed = visible;
      if (this.continuous || this.deactiveState) {
        this._isActive = false;
      } else {
        this._isActive = visible;
      }
    }
    static {
      this.ɵfac = function IgxSliderThumbComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSliderThumbComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxDirectionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSliderThumbComponent,
        selectors: [["igx-thumb"]],
        hostVars: 28,
        hostBindings: function IgxSliderThumbComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerenter", function IgxSliderThumbComponent_pointerenter_HostBindingHandler() {
              return ctx.onPointerEnter();
            })("pointerleave", function IgxSliderThumbComponent_pointerleave_HostBindingHandler() {
              return ctx.onPointerLeave();
            })("keyup", function IgxSliderThumbComponent_keyup_HostBindingHandler($event) {
              return ctx.onKeyUp($event);
            })("keydown", function IgxSliderThumbComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            })("blur", function IgxSliderThumbComponent_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("focus", function IgxSliderThumbComponent_focus_HostBindingHandler() {
              return ctx.onFocusListener();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabindex)("role", ctx.role)("aria-valuenow", ctx.ariaValueNow)("aria-valuemin", ctx.ariaValueMin)("aria-valuemax", ctx.ariaValueMax)("aria-valuetext", ctx.ariaValueText)("aria-label", ctx.ariaLabelAttr)("aria-orientation", ctx.ariaOrientation)("aria-disabled", ctx.ariaDisabled)("z-index", ctx.zIndex);
            i0.ɵɵclassProp("igx-slider-thumb-to--focused", ctx.focused)("igx-slider-thumb-from", ctx.thumbFromClass)("igx-slider-thumb-to", ctx.thumbToClass)("igx-slider-thumb-from--active", ctx.thumbFromActiveClass)("igx-slider-thumb-to--active", ctx.thumbToActiveClass)("igx-slider-thumb-from--disabled", ctx.thumbFromDisabledClass)("igx-slider-thumb-to--disabled", ctx.thumbToDisabledClass)("igx-slider-thumb-from--pressed", ctx.thumbFromPressedClass)("igx-slider-thumb-to--pressed", ctx.thumbToPressedClass);
          }
        },
        inputs: {
          value: "value",
          continuous: [2, "continuous", "continuous", booleanAttribute],
          thumbLabelVisibilityDuration: "thumbLabelVisibilityDuration",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          onPan: "onPan",
          stepDistance: "stepDistance",
          step: "step",
          templateRef: "templateRef",
          context: "context",
          type: "type",
          deactiveState: [2, "deactiveState", "deactiveState", booleanAttribute],
          min: "min",
          max: "max",
          labels: "labels"
        },
        outputs: {
          thumbValueChange: "thumbValueChange",
          thumbChange: "thumbChange",
          thumbBlur: "thumbBlur",
          hoverChange: "hoverChange"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "ngClass"]],
        template: function IgxSliderThumbComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.getDotClass);
          }
        },
        dependencies: [NgClass],
        encapsulation: 2
      });
    }
  }
  return IgxSliderThumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxTickLabelsPipe = /*#__PURE__*/(() => {
  class IgxTickLabelsPipe {
    transform(labels, secondaryTicks) {
      if (!labels) {
        return;
      }
      const result = [];
      labels.forEach(item => {
        result.push(item);
        for (let i = 0; i < secondaryTicks; i++) {
          result.push('');
        }
      });
      return result;
    }
    static {
      this.ɵfac = function IgxTickLabelsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTickLabelsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "spreadTickLabels",
        type: IgxTickLabelsPipe,
        pure: true
      });
    }
  }
  return IgxTickLabelsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxTicksComponent = /*#__PURE__*/(() => {
  class IgxTicksComponent {
    constructor() {
      /**
       * @hidden
       */
      this.ticksClass = true;
    }
    /**
     * @hidden
     */
    get ticksTopClass() {
      return this.ticksOrientation === TicksOrientation.Top;
    }
    /**
     * @hidden
     */
    get hasPrimaryClass() {
      return this.primaryTicks > 0;
    }
    /**
     * @hidden
     */
    get labelsTopToBottomClass() {
      return this.tickLabelsOrientation === TickLabelsOrientation.TopToBottom;
    }
    /**
     * @hidden
     */
    get labelsBottomToTopClass() {
      return this.tickLabelsOrientation === TickLabelsOrientation.BottomToTop;
    }
    /**
     * Returns the template context corresponding to
     * {@link IgxTickLabelTemplateDirective}
     *
     * ```typescript
     * return {
     *  $implicit //returns the value per each tick label.
     *  isPrimery //returns if the tick is primary.
     *  labels // returns the {@link labels} collection.
     *  index // returns the index per each tick of the whole sequence.
     * }
     * ```
     *
     * @param idx the index per each tick label.
     */
    context(idx) {
      return {
        $implicit: this.tickLabel(idx),
        isPrimary: this.isPrimary(idx),
        labels: this.labels,
        index: idx
      };
    }
    /**
     * @hidden
     */
    get ticksLength() {
      return this.primaryTicks > 0 ? (this.primaryTicks - 1) * this.secondaryTicks + this.primaryTicks : this.secondaryTicks > 0 ? this.secondaryTicks : 0;
    }
    hiddenTickLabels(idx) {
      return this.isPrimary(idx) ? this.primaryTickLabels : this.secondaryTickLabels;
    }
    /**
     * @hidden
     */
    isPrimary(idx) {
      return this.primaryTicks <= 0 ? false : idx % (this.secondaryTicks + 1) === 0;
    }
    /**
     * @hidden
     */
    tickLabel(idx) {
      if (this.labelsViewEnabled) {
        return this.labels[idx];
      }
      const labelStep = (Math.max(this.minValue, this.maxValue) - Math.min(this.minValue, this.maxValue)) / (this.ticksLength - 1);
      const labelVal = labelStep * idx;
      return (this.minValue + labelVal).toFixed(2);
    }
    static {
      this.ɵfac = function IgxTicksComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTicksComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTicksComponent,
        selectors: [["igx-ticks"]],
        hostVars: 10,
        hostBindings: function IgxTicksComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-slider__ticks", ctx.ticksClass)("igx-slider__ticks--top", ctx.ticksTopClass)("igx-slider__ticks--tall", ctx.hasPrimaryClass)("igx-slider__tick-labels--top-bottom", ctx.labelsTopToBottomClass)("igx-slider__tick-labels--bottom-top", ctx.labelsBottomToTopClass);
          }
        },
        inputs: {
          primaryTicks: "primaryTicks",
          secondaryTicks: "secondaryTicks",
          primaryTickLabels: [2, "primaryTickLabels", "primaryTickLabels", booleanAttribute],
          secondaryTickLabels: [2, "secondaryTickLabels", "secondaryTickLabels", booleanAttribute],
          ticksOrientation: "ticksOrientation",
          tickLabelsOrientation: "tickLabelsOrientation",
          maxValue: "maxValue",
          minValue: "minValue",
          labelsViewEnabled: [2, "labelsViewEnabled", "labelsViewEnabled", booleanAttribute],
          labels: "labels",
          tickLabelTemplateRef: "tickLabelTemplateRef"
        },
        decls: 4,
        vars: 1,
        consts: [["tickLabelDefaultTemplate", ""], [1, "igx-slider__ticks-group", 3, "ngClass"], [1, "igx-slider__ticks-tick"], [1, "igx-slider__ticks-label", 3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function IgxTicksComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, IgxTicksComponent_For_1_Template, 4, 8, "div", 1, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵtemplate(2, IgxTicksComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(i0.ɵɵpureFunction0(0, _c129).constructor(ctx.ticksLength));
          }
        },
        dependencies: [NgClass, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxTicksComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID$2 = 0;
/**
 * **Ignite UI for Angular Slider** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/slider/slider)
 *
 * The Ignite UI Slider allows selection in a given range by moving the thumb along the track. The track
 * can be defined as continuous or stepped, and you can choose between single and range slider types.
 *
 * Example:
 * ```html
 * <igx-slider id="slider"
 *            [minValue]="0" [maxValue]="100"
 *            [continuous]=true [(ngModel)]="volume">
 * </igx-slider>
 * ```
 */
let IgxSliderComponent = /*#__PURE__*/(() => {
  class IgxSliderComponent {
    /**
     * @hidden
     */
    get thumbFrom() {
      return this.thumbs.find(thumb => thumb.type === SliderHandle.FROM);
    }
    /**
     * @hidden
     */
    get thumbTo() {
      return this.thumbs.find(thumb => thumb.type === SliderHandle.TO);
    }
    get labelFrom() {
      return this.labelRefs.find(label => label.type === SliderHandle.FROM);
    }
    get labelTo() {
      return this.labelRefs.find(label => label.type === SliderHandle.TO);
    }
    /**
     * @hidden
     */
    get disabledClass() {
      return this.disabled;
    }
    /**
     * Gets the type of the `IgxSliderComponent`.
     * The slider can be IgxSliderType.SLIDER(default) or IgxSliderType.RANGE.
     * ```typescript
     * @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let type = this.slider.type;
     * }
     */
    get type() {
      return this._type;
    }
    /**
     * Sets the type of the `IgxSliderComponent`.
     * The slider can be IgxSliderType.SLIDER(default) or IgxSliderType.RANGE.
     * ```typescript
     * sliderType: IgxSliderType = IgxSliderType.RANGE;
     * ```
     * ```html
     * <igx-slider #slider2 [type]="sliderType" [(ngModel)]="rangeValue" [minValue]="0" [maxValue]="100">
     * ```
     */
    set type(type) {
      this._type = type;
      if (type === IgxSliderType.SLIDER) {
        this.lowerValue = 0;
      }
      if (this._hasViewInit) {
        this.updateTrack();
      }
    }
    /**
     * Enables `labelView`, by accepting a collection of primitive values with more than one element.
     * Each element will be equally spread over the slider and it will serve as a thumb label.
     * Once the property is set, it will precendence over {@link maxValue}, {@link minValue}, {@link step}.
     * This means that the manipulation for those properties won't be allowed.
     */
    get labels() {
      return this._labels;
    }
    set labels(labels) {
      this._labels = labels;
      this._pMax = this.valueToFraction(this.upperBound, 0, 1);
      this._pMin = this.valueToFraction(this.lowerBound, 0, 1);
      this.positionHandlersAndUpdateTrack();
      if (this._hasViewInit) {
        this.stepDistance = this.calculateStepDistance();
        this.setTickInterval();
      }
    }
    /**
     * Returns the template context corresponding
     * to {@link IgxThumbFromTemplateDirective} and {@link IgxThumbToTemplateDirective} templates.
     *
     * ```typescript
     * return {
     *  $implicit // returns the value of the label,
     *  labels // returns the labels collection the user has passed.
     * }
     * ```
     */
    get context() {
      return {
        $implicit: this.value,
        labels: this.labels
      };
    }
    /**
     * Sets the incremental/decremental step of the value when dragging the thumb.
     * The default step is 1, and step should not be less or equal than 0.
     * ```html
     * <igx-slider #slider [(ngModel)]="task.percentCompleted" [step]="5">
     * ```
     */
    set step(step) {
      this._step = step;
      if (this._hasViewInit) {
        this.stepDistance = this.calculateStepDistance();
        this.normalizeByStep(this._value);
        this.setValue(this._value, true);
        this.positionHandlersAndUpdateTrack();
        this.setTickInterval();
      }
    }
    /**
     * Returns the incremental/decremental dragging step of the {@link IgxSliderComponent}.
     * ```typescript
     * @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let step = this.slider.step;
     * }
     * ```
     */
    get step() {
      return this.labelsViewEnabled ? 1 : this._step;
    }
    /**
     * Returns if the {@link IgxSliderComponent} is disabled.
     * ```typescript
     * @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let isDisabled = this.slider.disabled;
     * }
     * ```
     */
    get disabled() {
      return this._disabled;
    }
    /**
     * Disables the component.
     * ```html
     * <igx-slider #slider [disabled]="true" [(ngModel)]="task.percentCompleted" [step]="5" [lowerBound]="20">
     * ```
     */
    set disabled(disable) {
      this._disabled = disable;
      if (this._hasViewInit) {
        this.changeThumbFocusableState(disable);
      }
    }
    /**
     * Returns if the {@link IgxSliderComponent} is set as continuous.
     * ```typescript
     * @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let continuous = this.slider.continuous;
     * }
     * ```
     */
    get continuous() {
      return this._continuous;
    }
    /**
     * Sets the {@link IgxSliderComponent} as continuous.
     * By default is considered that the {@link IgxSliderComponent} is discrete.
     * Discrete {@link IgxSliderComponent} slider has step indicators over the track and visible thumb labels during interaction.
     * Continuous {@link IgxSliderComponent} does not have ticks and does not show bubble labels for values.
     * ```html
     * <igx-slider #slider [continuous]="'true'" [(ngModel)]="task.percentCompleted" [step]="5" [lowerBound]="20">
     * ```
     */
    set continuous(continuous) {
      this._continuous = continuous;
      if (this._hasViewInit) {
        this.setTickInterval();
      }
    }
    /**
     * Returns the minimal displayed track value of the `IgxSliderComponent`.
     * ```typescript
     *  @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let sliderMin = this.slider.minValue;
     * }
     * ```
     */
    get minValue() {
      if (this.labelsViewEnabled) {
        return 0;
      }
      return this._minValue;
    }
    /**
     * Sets the minimal displayed track value for the `IgxSliderComponent`.
     * The default minimal value is 0.
     * ```html
     * <igx-slider [type]="sliderType" [minValue]="56" [maxValue]="100">
     * ```
     */
    set minValue(value) {
      if (value >= this.maxValue) {
        return;
      } else {
        this._minValue = value;
      }
      if (value > this._upperBound) {
        this.updateUpperBoundAndMaxTravelZone();
        this.lowerBound = value;
      }
      // Refresh min travel zone limit.
      this._pMin = 0;
      // Recalculate step distance.
      this.positionHandlersAndUpdateTrack();
      if (this._hasViewInit) {
        this.stepDistance = this.calculateStepDistance();
        this.setTickInterval();
      }
    }
    /**
     * Returns the maximum displayed track value for the {@link IgxSliderComponent}.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let sliderMax = this.slider.maxValue;
     * }
     *  ```
     */
    get maxValue() {
      return this.labelsViewEnabled ? this.labels.length - 1 : this._maxValue;
    }
    /**
     * Sets the maximal displayed track value for the `IgxSliderComponent`.
     * The default maximum value is 100.
     * ```html
     * <igx-slider [type]="sliderType" [minValue]="56" [maxValue]="256">
     * ```
     */
    set maxValue(value) {
      if (value <= this._minValue) {
        return;
      } else {
        this._maxValue = value;
      }
      if (value < this._lowerBound) {
        this.updateLowerBoundAndMinTravelZone();
        this.upperBound = value;
      }
      // refresh max travel zone limits.
      this._pMax = 1;
      // recalculate step distance.
      this.positionHandlersAndUpdateTrack();
      if (this._hasViewInit) {
        this.stepDistance = this.calculateStepDistance();
        this.setTickInterval();
      }
    }
    /**
     * Returns the lower boundary of settable values of the `IgxSliderComponent`.
     * If not set, will return `minValue`.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let sliderLowBound = this.slider.lowerBound;
     * }
     * ```
     */
    get lowerBound() {
      if (!Number.isNaN(this._lowerBound) && this._lowerBound !== undefined) {
        return this.valueInRange(this._lowerBound, this.minValue, this.maxValue);
      }
      return this.minValue;
    }
    /**
     * Sets the lower boundary of settable values of the `IgxSliderComponent`.
     * If not set is the same as min value.
     * ```html
     * <igx-slider [step]="5" [lowerBound]="20">
     * ```
     */
    set lowerBound(value) {
      if (value >= this.upperBound || this.labelsViewEnabled && value < 0) {
        return;
      }
      this._lowerBound = this.valueInRange(value, this.minValue, this.maxValue);
      // Refresh min travel zone.
      this._pMin = this.valueToFraction(this._lowerBound, 0, 1);
      this.positionHandlersAndUpdateTrack();
    }
    /**
     * Returns the upper boundary of settable values of the `IgxSliderComponent`.
     * If not set, will return `maxValue`
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *    let sliderUpBound = this.slider.upperBound;
     * }
     * ```
     */
    get upperBound() {
      if (!Number.isNaN(this._upperBound) && this._upperBound !== undefined) {
        return this.valueInRange(this._upperBound, this.minValue, this.maxValue);
      }
      return this.maxValue;
    }
    /**
     * Sets the upper boundary of the `IgxSliderComponent`.
     * If not set is the same as max value.
     * ```html
     * <igx-slider [step]="5" [upperBound]="20">
     * ```
     */
    set upperBound(value) {
      if (value <= this.lowerBound || this.labelsViewEnabled && value > this.labels.length - 1) {
        return;
      }
      this._upperBound = this.valueInRange(value, this.minValue, this.maxValue);
      // Refresh time travel zone.
      this._pMax = this.valueToFraction(this._upperBound, 0, 1);
      this.positionHandlersAndUpdateTrack();
    }
    /**
     * Returns the slider value. If the slider is of type {@link IgxSliderType.SLIDER} the returned value is number.
     * If the slider type is {@link IgxSliderType.RANGE}.
     * The returned value represents an object of {@link lowerValue} and {@link upperValue}.
     * ```typescript
     * @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * public sliderValue(event){
     *     let sliderVal = this.slider.value;
     * }
     * ```
     */
    get value() {
      if (this.isRange) {
        return {
          lower: this.valueInRange(this.lowerValue, this.lowerBound, this.upperBound),
          upper: this.valueInRange(this.upperValue, this.lowerBound, this.upperBound)
        };
      } else {
        return this.valueInRange(this.upperValue, this.lowerBound, this.upperBound);
      }
    }
    /**
     * Sets the slider value.
     * If the slider is of type {@link IgxSliderType.SLIDER}.
     * The argument is number. By default the {@link value} gets the {@link lowerBound}.
     * If the slider type is {@link IgxSliderType.RANGE} the argument
     * represents an object of {@link lowerValue} and {@link upperValue} properties.
     * By default the object is associated with the {@link lowerBound} and {@link upperBound} property values.
     * ```typescript
     * rangeValue = {
     *   lower: 30,
     *   upper: 60
     * };
     * ```
     * ```html
     * <igx-slider [type]="sliderType" [(ngModel)]="rangeValue" [minValue]="56" [maxValue]="256">
     * ```
     */
    set value(value) {
      this.normalizeByStep(value);
      if (this._hasViewInit) {
        this.setValue(this._value, true);
        this.positionHandlersAndUpdateTrack();
      }
    }
    /**
     * Returns the number of the presented primary ticks.
     * ```typescript
     * const primaryTicks = this.slider.primaryTicks;
     * ```
     */
    get primaryTicks() {
      if (this.labelsViewEnabled) {
        return this._primaryTicks = this.labels.length;
      }
      return this._primaryTicks;
    }
    /**
     * Sets the number of primary ticks. If {@link @labels} is enabled, this property won't function.
     * Insted enable ticks by {@link showTicks} property.
     * ```typescript
     * this.slider.primaryTicks = 5;
     * ```
     */
    set primaryTicks(val) {
      if (val <= 1) {
        return;
      }
      this._primaryTicks = val;
    }
    /**
     * Returns the number of the presented secondary ticks.
     * ```typescript
     * const secondaryTicks = this.slider.secondaryTicks;
     * ```
     */
    get secondaryTicks() {
      return this._secondaryTicks;
    }
    /**
     * Sets the number of secondary ticks. The property functions even when {@link labels} is enabled,
     * but all secondary ticks won't present any tick labels.
     * ```typescript
     * this.slider.secondaryTicks = 5;
     * ```
     */
    set secondaryTicks(val) {
      if (val < 1) {
        return;
      }
      this._secondaryTicks = val;
    }
    /**
     * @hidden
     */
    get deactivateThumbLabel() {
      return (this.primaryTicks && this.primaryTickLabels || this.secondaryTicks && this.secondaryTickLabels) && (this.ticksOrientation === TicksOrientation.Top || this.ticksOrientation === TicksOrientation.Mirror);
    }
    constructor(renderer, _el, _cdr, _ngZone, _dir) {
      this.renderer = renderer;
      this._el = _el;
      this._cdr = _cdr;
      this._ngZone = _ngZone;
      this._dir = _dir;
      /**
       * @hidden
       */
      this.slierClass = true;
      /**
       * Sets the value of the `id` attribute.
       * If not provided it will be automatically generated.
       * ```html
       * <igx-slider [id]="'igx-slider-32'" [(ngModel)]="task.percentCompleted" [step]="5" [lowerBound]="20">
       * ```
       */
      this.id = `igx-slider-${NEXT_ID$2++}`;
      /**
       * Sets the duration visibility of thumbs labels. The default value is 750 milliseconds.
       * ```html
       * <igx-slider #slider [thumbLabelVisibilityDuration]="3000" [(ngModel)]="task.percentCompleted" [step]="5">
       * ```
       */
      this.thumbLabelVisibilityDuration = 750;
      /**
       * Show/hide slider ticks
       * ```html
       * <igx-slier [showTicks]="true" [primaryTicks]="5"></igx-slier>
       * ```
       */
      this.showTicks = false;
      /**
       * show/hide primary tick labels
       * ```html
       * <igx-slider [primaryTicks]="5" [primaryTickLabels]="false"></igx-slider>
       * ```
       */
      this.primaryTickLabels = true;
      /**
       * show/hide secondary tick labels
       * ```html
       * <igx-slider [secondaryTicks]="5" [secondaryTickLabels]="false"></igx-slider>
       * ```
       */
      this.secondaryTickLabels = true;
      /**
       * Changes ticks orientation:
       * bottom - The default orienation, below the slider track.
       * top - Above the slider track
       * mirror - combines top and bottom orientation.
       * ```html
       * <igx-slider [primaryTicks]="5" [ticksOrientation]="ticksOrientation"></igx-slider>
       * ```
       */
      this.ticksOrientation = TicksOrientation.Bottom;
      /**
       * Changes tick labels rotation:
       * horizontal - The default rotation
       * toptobottom - Rotates tick labels vertically to 90deg
       * bottomtotop - Rotate tick labels vertically to -90deg
       * ```html
       * <igx-slider [primaryTicks]="5" [secondaryTicks]="3" [tickLabelsOrientation]="tickLabelsOrientaiton"></igx-slider>
       * ```
       */
      this.tickLabelsOrientation = TickLabelsOrientation.Horizontal;
      /**
       * This event is emitted every time the value is changed.
       * ```typescript
       * public change(event){
       *    alert("The value has been changed!");
       * }
       * ```
       * ```html
       * <igx-slider (valueChange)="change($event)" #slider [(ngModel)]="task.percentCompleted" [step]="5">
       * ```
       */
      this.valueChange = new EventEmitter();
      /**
       * This event is emitted every time the lower value of a range slider is changed.
       * ```typescript
       * public change(value){
       *    alert(`The lower value has been changed to ${value}`);
       * }
       * ```
       * ```html
       * <igx-slider [(lowerValue)]="model.lowervalue" (lowerValueChange)="change($event)" [step]="5">
       * ```
       */
      this.lowerValueChange = new EventEmitter();
      /**
       * This event is emitted every time the upper value of a range slider is changed.
       * ```typescript
       * public change(value){
       *    alert(`The upper value has been changed to ${value}`);
       * }
       * ```
       * ```html
       * <igx-slider [(upperValue)]="model.uppervalue" (upperValueChange)="change($event)" [step]="5">
       * ```
       */
      this.upperValueChange = new EventEmitter();
      /**
       * This event is emitted at the end of every slide interaction.
       * ```typescript
       * public change(event){
       *    alert("The value has been changed!");
       * }
       * ```
       * ```html
       * <igx-slider (dragFinished)="change($event)" #slider [(ngModel)]="task.percentCompleted" [step]="5">
       * ```
       */
      this.dragFinished = new EventEmitter();
      /**
       * @hidden
       */
      this.thumbs = new QueryList();
      /**
       * @hidden
       */
      this.labelRefs = new QueryList();
      /**
       * @hidden
       */
      this.onPan = new Subject();
      // Limit handle travel zone
      this._pMin = 0;
      this._pMax = 1;
      // From/upperValue in percent values
      this._hasViewInit = false;
      this._minValue = 0;
      this._maxValue = 100;
      this._continuous = false;
      this._disabled = false;
      this._step = 1;
      this._value = 0;
      // ticks
      this._primaryTicks = 0;
      this._secondaryTicks = 0;
      this._sliding = false;
      this._labels = new Array();
      this._type = IgxSliderType.SLIDER;
      this._destroyer$ = new Subject();
      this._indicatorsDestroyer$ = new Subject();
      this._onChangeCallback = noop;
      this._onTouchedCallback = noop;
      this.stepDistance = this._step;
    }
    /**
     * @hidden
     */
    onFocus() {
      this.toggleSliderIndicators();
    }
    /**
     * Returns whether the `IgxSliderComponent` type is RANGE.
     * ```typescript
     *  @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * ngAfterViewInit(){
     *     let sliderRange = this.slider.isRange;
     * }
     * ```
     */
    get isRange() {
      return this.type === IgxSliderType.RANGE;
    }
    /**
     * Returns the lower value of a RANGE `IgxSliderComponent`.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * public lowValue(event){
     *    let sliderLowValue = this.slider.lowerValue;
     * }
     * ```
     */
    get lowerValue() {
      if (!Number.isNaN(this._lowerValue) && this._lowerValue !== undefined && this._lowerValue >= this.lowerBound) {
        return this._lowerValue;
      }
      return this.lowerBound;
    }
    /**
     * Sets the lower value of a RANGE `IgxSliderComponent`.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * public lowValue(event){
     *    this.slider.lowerValue = value;
     * }
     * ```
     */
    set lowerValue(value) {
      const adjustedValue = this.valueInRange(value, this.lowerBound, this.upperBound);
      if (this._lowerValue !== adjustedValue) {
        this._lowerValue = adjustedValue;
        this.lowerValueChange.emit(this._lowerValue);
        this.value = {
          lower: this._lowerValue,
          upper: this._upperValue
        };
      }
    }
    /**
     * Returns the upper value of a RANGE `IgxSliderComponent`.
     * Returns `value` of a SLIDER `IgxSliderComponent`
     * ```typescript
     *  @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * public upperValue(event){
     *     let upperValue = this.slider.upperValue;
     * }
     * ```
     */
    get upperValue() {
      if (!Number.isNaN(this._upperValue) && this._upperValue !== undefined && this._upperValue <= this.upperBound) {
        return this._upperValue;
      }
      return this.upperBound;
    }
    /**
     * Sets the upper value of a RANGE `IgxSliderComponent`.
     * ```typescript
     *  @ViewChild("slider2")
     * public slider: IgxSliderComponent;
     * public upperValue(event){
     *     this.slider.upperValue = value;
     * }
     * ```
     */
    set upperValue(value) {
      const adjustedValue = this.valueInRange(value, this.lowerBound, this.upperBound);
      if (this._upperValue !== adjustedValue) {
        this._upperValue = adjustedValue;
        this.upperValueChange.emit(this._upperValue);
        this.value = {
          lower: this._lowerValue,
          upper: this._upperValue
        };
      }
    }
    /**
     * Returns the value corresponding the lower label.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * let label = this.slider.lowerLabel;
     * ```
     */
    get lowerLabel() {
      return this.labelsViewEnabled ? this.labels[this.lowerValue] : this.lowerValue;
    }
    /**
     * Returns the value corresponding the upper label.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * let label = this.slider.upperLabel;
     * ```
     */
    get upperLabel() {
      return this.labelsViewEnabled ? this.labels[this.upperValue] : this.upperValue;
    }
    /**
     * Returns if label view is enabled.
     * If the {@link labels} is set, the view is automatically activated.
     * ```typescript
     * @ViewChild("slider")
     * public slider: IgxSliderComponent;
     * let labelView = this.slider.labelsViewEnabled;
     * ```
     */
    get labelsViewEnabled() {
      return !!(this.labels && this.labels.length > 1);
    }
    /**
     * @hidden
     */
    get showTopTicks() {
      return this.ticksOrientation === TicksOrientation.Top || this.ticksOrientation === TicksOrientation.Mirror;
    }
    /**
     * @hidden
     */
    get showBottomTicks() {
      return this.ticksOrientation === TicksOrientation.Bottom || this.ticksOrientation === TicksOrientation.Mirror;
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      if (changes.minValue && changes.maxValue && changes.minValue.currentValue < changes.maxValue.currentValue) {
        this._maxValue = changes.maxValue.currentValue;
        this._minValue = changes.minValue.currentValue;
      }
      if (changes.step && changes.step.isFirstChange()) {
        this.normalizeByStep(this._value);
      }
    }
    /**
     * @hidden
     */
    ngOnInit() {
      /**
       * if {@link SliderType.SLIDER} than the initial value shold be the lowest one.
       */
      if (!this.isRange) {
        this._upperValue = this.lowerBound;
      }
      // Set track travel zone
      this._pMin = this.valueToFraction(this.lowerBound) || 0;
      this._pMax = this.valueToFraction(this.upperBound) || 1;
    }
    ngAfterContentInit() {
      this.setValue(this._value, false);
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this._hasViewInit = true;
      this.stepDistance = this.calculateStepDistance();
      this.positionHandlersAndUpdateTrack();
      this.setTickInterval();
      this.changeThumbFocusableState(this.disabled);
      this.subscribeToEvents(this.thumbFrom);
      this.subscribeToEvents(this.thumbTo);
      this.thumbs.changes.pipe(takeUntil(this._destroyer$)).subscribe(change => {
        const thumbFrom = change.find(thumb => thumb.type === SliderHandle.FROM);
        this.positionHandler(thumbFrom, null, this.lowerValue);
        this.subscribeToEvents(thumbFrom);
        this.changeThumbFocusableState(this.disabled);
      });
      this.labelRefs.changes.pipe(takeUntil(this._destroyer$)).subscribe(() => {
        const labelFrom = this.labelRefs.find(label => label.type === SliderHandle.FROM);
        this.positionHandler(null, labelFrom, this.lowerValue);
      });
      this._ngZone.runOutsideAngular(() => {
        resizeObservable(this._el.nativeElement).pipe(throttleTime(40), takeUntil(this._destroyer$)).subscribe(() => this._ngZone.run(() => {
          this.stepDistance = this.calculateStepDistance();
        }));
        fromEvent(this._el.nativeElement, 'pointermove').pipe(throttle(() => interval(0, animationFrameScheduler)), takeUntil(this._destroyer$)).subscribe($event => this._ngZone.run(() => {
          this.onPointerMove($event);
        }));
      });
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      this._destroyer$.next(true);
      this._destroyer$.complete();
      this._indicatorsDestroyer$.next(true);
      this._indicatorsDestroyer$.complete();
    }
    /**
     * @hidden
     */
    writeValue(value) {
      if (this.isNullishButNotZero(value)) {
        return;
      }
      this.normalizeByStep(value);
      this.setValue(this._value, false);
      this.positionHandlersAndUpdateTrack();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
      this._onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
      this._onTouchedCallback = fn;
    }
    /** @hidden */
    getEditElement() {
      return this.isRange ? this.thumbFrom.nativeElement : this.thumbTo.nativeElement;
    }
    /**
     *
     * @hidden
     */
    update(mouseX) {
      if (this.disabled) {
        return;
      }
      // Update To/From Values
      this.onPan.next(mouseX);
      // Finally do positionHandlersAndUpdateTrack the DOM
      // based on data values
      this.positionHandlersAndUpdateTrack();
    }
    /**
     * @hidden
     */
    thumbChanged(value, thumbType) {
      const oldValue = this.value;
      if (this.isRange) {
        if (thumbType === SliderHandle.FROM) {
          if (this.lowerValue + value > this.upperValue) {
            this.upperValue = this.lowerValue + value;
          }
          this.lowerValue += value;
        } else {
          if (this.upperValue + value < this.lowerValue) {
            this.lowerValue = this.upperValue + value;
          }
          this.upperValue += value;
        }
        const newVal = {
          lower: this.lowerValue,
          upper: this.upperValue
        };
        // Swap the thumbs if a collision appears.
        // if (newVal.lower == newVal.upper) {
        //     this.toggleThumb();
        // }
        this.value = newVal;
      } else {
        const newVal = this.value + value;
        if (newVal >= this.lowerBound && newVal <= this.upperBound) {
          this.value = newVal;
        }
      }
      if (this.hasValueChanged(oldValue)) {
        this.emitValueChange(oldValue);
      }
    }
    /**
     * @hidden
     */
    onThumbChange() {
      this.toggleSliderIndicators();
    }
    /**
     * @hidden
     */
    onHoverChange(state) {
      return state ? this.showSliderIndicators() : this.hideSliderIndicators();
    }
    setValue(value, triggerChange) {
      let res;
      if (!this.isRange) {
        value = value;
        if (!isNaN(value)) {
          this._upperValue = value - value % this.step;
          res = this.upperValue;
        }
      } else {
        value = this.validateInitialValue(value);
        this._upperValue = value.upper;
        this._lowerValue = value.lower;
        res = {
          lower: this.lowerValue,
          upper: this.upperValue
        };
      }
      if (triggerChange) {
        this._onChangeCallback(res);
      }
    }
    onPointerDown($event) {
      this.findClosestThumb($event);
      if (!this.thumbTo.isActive && this.thumbFrom === undefined) {
        return;
      }
      this._sliding = true;
      const activeThumb = this.thumbTo.isActive ? this.thumbTo : this.thumbFrom;
      activeThumb.nativeElement.setPointerCapture($event.pointerId);
      this.showSliderIndicators();
      $event.preventDefault();
    }
    onPointerMove($event) {
      if (this._sliding) {
        this.update($event.clientX);
      }
    }
    onPointerUp($event) {
      if (!this.thumbTo.isActive && this.thumbFrom === undefined) {
        return;
      }
      const activeThumb = this.thumbTo.isActive ? this.thumbTo : this.thumbFrom;
      activeThumb.nativeElement.releasePointerCapture($event.pointerId);
      this._sliding = false;
      this.hideSliderIndicators();
      this.dragFinished.emit(this.value);
    }
    validateInitialValue(value) {
      if (value.upper < value.lower) {
        const temp = value.upper;
        value.upper = value.lower;
        value.lower = temp;
      }
      if (value.lower < this.lowerBound) {
        value.lower = this.lowerBound;
      }
      if (value.upper > this.upperBound) {
        value.upper = this.upperBound;
      }
      return value;
    }
    findClosestThumb(event) {
      if (this.isRange) {
        this.closestHandle(event);
      } else {
        this.thumbTo.nativeElement.focus();
      }
      this.update(event.clientX);
    }
    updateLowerBoundAndMinTravelZone() {
      this.lowerBound = this.minValue;
      this._pMin = 0;
    }
    updateUpperBoundAndMaxTravelZone() {
      this.upperBound = this.maxValue;
      this._pMax = 1;
    }
    calculateStepDistance() {
      return this._el.nativeElement.getBoundingClientRect().width / (this.maxValue - this.minValue) * this.step;
    }
    // private toggleThumb() {
    //     return this.thumbFrom.isActive ?
    //         this.thumbTo.nativeElement.focus() :
    //         this.thumbFrom.nativeElement.focus();
    // }
    valueInRange(value, min = 0, max = 100) {
      return Math.max(Math.min(value, max), min);
    }
    positionHandler(thumbHandle, labelHandle, position) {
      const percent = `${this.valueToFraction(position) * 100}%`;
      const dir = this._dir.rtl ? 'right' : 'left';
      if (thumbHandle) {
        thumbHandle.nativeElement.style[dir] = percent;
      }
      if (labelHandle) {
        labelHandle.nativeElement.style[dir] = percent;
      }
    }
    positionHandlersAndUpdateTrack() {
      if (!this.isRange) {
        this.positionHandler(this.thumbTo, this.labelTo, this.value);
      } else {
        this.positionHandler(this.thumbTo, this.labelTo, this.value.upper);
        this.positionHandler(this.thumbFrom, this.labelFrom, this.value.lower);
      }
      if (this._hasViewInit) {
        this.updateTrack();
      }
    }
    closestHandle(event) {
      const fromOffset = this.thumbFrom.nativeElement.offsetLeft + this.thumbFrom.nativeElement.offsetWidth / 2;
      const toOffset = this.thumbTo.nativeElement.offsetLeft + this.thumbTo.nativeElement.offsetWidth / 2;
      const xPointer = event.clientX - this._el.nativeElement.getBoundingClientRect().left;
      const match = this.closestTo(xPointer, [fromOffset, toOffset]);
      if (fromOffset === toOffset && toOffset < xPointer) {
        this.thumbTo.nativeElement.focus();
      } else if (fromOffset === toOffset && toOffset > xPointer) {
        this.thumbFrom.nativeElement.focus();
      } else if (match === fromOffset) {
        this.thumbFrom.nativeElement.focus();
      } else {
        this.thumbTo.nativeElement.focus();
      }
    }
    setTickInterval() {
      let tickInterval;
      const trackProgress = 100;
      if (this.labelsViewEnabled) {
        // Calc ticks depending on the labels length;
        tickInterval = trackProgress / (this.labels.length - 1) * 10 / 10;
      } else {
        const trackRange = this.maxValue - this.minValue;
        tickInterval = this.step > 1 ? trackProgress / (trackRange / this.step) * 10 / 10 : null;
      }
      this.renderer.setStyle(this.ticks.nativeElement, 'stroke-dasharray', `0, ${tickInterval * Math.sqrt(2)}%`);
      this.renderer.setStyle(this.ticks.nativeElement, 'visibility', this.continuous || tickInterval === null ? 'hidden' : 'visible');
    }
    showSliderIndicators() {
      if (this.disabled) {
        return;
      }
      if (this._indicatorsTimer) {
        this._indicatorsDestroyer$.next(true);
        this._indicatorsTimer = null;
      }
      this.thumbTo.showThumbIndicators();
      this.labelTo.active = true;
      if (this.thumbFrom) {
        this.thumbFrom.showThumbIndicators();
      }
      if (this.labelFrom) {
        this.labelFrom.active = true;
      }
    }
    hideSliderIndicators() {
      if (this.disabled) {
        return;
      }
      this._indicatorsTimer = timer(this.thumbLabelVisibilityDuration);
      this._indicatorsTimer.pipe(takeUntil(this._indicatorsDestroyer$)).subscribe(() => {
        this.thumbTo.hideThumbIndicators();
        this.labelTo.active = false;
        if (this.thumbFrom) {
          this.thumbFrom.hideThumbIndicators();
        }
        if (this.labelFrom) {
          this.labelFrom.active = false;
        }
      });
    }
    toggleSliderIndicators() {
      this.showSliderIndicators();
      this.hideSliderIndicators();
    }
    changeThumbFocusableState(state) {
      const value = state ? -1 : 0;
      if (this.isRange) {
        this.thumbFrom.tabindex = value;
      }
      this.thumbTo.tabindex = value;
      this._cdr.detectChanges();
    }
    closestTo(goal, positions) {
      return positions.reduce((previous, current) => Math.abs(goal - current) < Math.abs(goal - previous) ? current : previous);
    }
    valueToFraction(value, pMin = this._pMin, pMax = this._pMax) {
      return this.valueInRange((value - this.minValue) / (this.maxValue - this.minValue), pMin, pMax);
    }
    isNullishButNotZero(value) {
      return !value && value !== 0;
    }
    /**
     * @hidden
     * Normalizе the value when two-way data bind is used and {@link this.step} is set.
     * @param value
     */
    normalizeByStep(value) {
      if (this.isRange) {
        this._value = {
          lower: Math.floor(value.lower / this.step) * this.step,
          upper: Math.floor(value.upper / this.step) * this.step
        };
      } else {
        this._value = Math.floor(value / this.step) * this.step;
      }
    }
    updateTrack() {
      const fromPosition = this.valueToFraction(this.lowerValue);
      const toPosition = this.valueToFraction(this.upperValue);
      const positionGap = toPosition - fromPosition;
      let trackLeftIndention = fromPosition;
      if (this.isRange) {
        if (positionGap) {
          trackLeftIndention = Math.round(1 / positionGap * fromPosition * 100);
        }
        trackLeftIndention = this._dir.rtl ? -trackLeftIndention : trackLeftIndention;
        this.renderer.setStyle(this.trackRef.nativeElement, 'transform', `scaleX(${positionGap}) translateX(${trackLeftIndention}%)`);
      } else {
        this.renderer.setStyle(this.trackRef.nativeElement, 'transform', `scaleX(${toPosition})`);
      }
    }
    subscribeToEvents(thumb) {
      if (!thumb) {
        return;
      }
      thumb.thumbValueChange.pipe(takeUntil(this.unsubscriber(thumb))).subscribe(value => this.thumbChanged(value, thumb.type));
      thumb.thumbBlur.pipe(takeUntil(this.unsubscriber(thumb))).subscribe(() => this._onTouchedCallback());
    }
    unsubscriber(thumb) {
      return merge(this._destroyer$, thumb.destroy);
    }
    hasValueChanged(oldValue) {
      const isSliderWithDifferentValue = !this.isRange && oldValue !== this.value;
      const isRangeWithOneDifferentValue = this.isRange && (oldValue.lower !== this.value.lower || oldValue.upper !== this.value.upper);
      return isSliderWithDifferentValue || isRangeWithOneDifferentValue;
    }
    emitValueChange(oldValue) {
      this.valueChange.emit({
        oldValue,
        value: this.value
      });
    }
    static {
      this.ɵfac = function IgxSliderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSliderComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IgxDirectionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSliderComponent,
        selectors: [["igx-slider"]],
        contentQueries: function IgxSliderComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxThumbFromTemplateDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxThumbToTemplateDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxTickLabelTemplateDirective, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.thumbFromTemplateRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.thumbToTemplateRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tickLabelTemplateRef = _t.first);
          }
        },
        viewQuery: function IgxSliderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c294, 7);
            i0.ɵɵviewQuery(_c295, 7);
            i0.ɵɵviewQuery(IgxSliderThumbComponent, 5);
            i0.ɵɵviewQuery(IgxThumbLabelComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trackRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ticks = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.thumbs = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelRefs = _t);
          }
        },
        hostVars: 5,
        hostBindings: function IgxSliderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function IgxSliderComponent_focus_HostBindingHandler() {
              return ctx.onFocus();
            })("pointerdown", function IgxSliderComponent_pointerdown_HostBindingHandler($event) {
              return ctx.onPointerDown($event);
            })("pointerup", function IgxSliderComponent_pointerup_HostBindingHandler($event) {
              return ctx.onPointerUp($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵclassProp("igx-slider", ctx.slierClass)("igx-slider--disabled", ctx.disabledClass);
          }
        },
        inputs: {
          id: "id",
          thumbLabelVisibilityDuration: "thumbLabelVisibilityDuration",
          type: "type",
          labels: "labels",
          step: "step",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          continuous: [2, "continuous", "continuous", booleanAttribute],
          minValue: "minValue",
          maxValue: "maxValue",
          lowerBound: "lowerBound",
          upperBound: "upperBound",
          value: "value",
          primaryTicks: "primaryTicks",
          secondaryTicks: "secondaryTicks",
          showTicks: [2, "showTicks", "showTicks", booleanAttribute],
          primaryTickLabels: [2, "primaryTickLabels", "primaryTickLabels", booleanAttribute],
          secondaryTickLabels: [2, "secondaryTickLabels", "secondaryTickLabels", booleanAttribute],
          ticksOrientation: "ticksOrientation",
          tickLabelsOrientation: "tickLabelsOrientation",
          lowerValue: "lowerValue",
          upperValue: "upperValue"
        },
        outputs: {
          valueChange: "valueChange",
          lowerValueChange: "lowerValueChange",
          upperValueChange: "upperValueChange",
          dragFinished: "dragFinished"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxSliderComponent,
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 16,
        vars: 23,
        consts: [["track", ""], ["ticks", ""], ["thumbTo", ""], ["thumbFrom", ""], ["ticksOrientation", "top", 3, "primaryTicks", "secondaryTicks", "primaryTickLabels", "secondaryTickLabels", "tickLabelsOrientation", "labelsViewEnabled", "labels", "tickLabelTemplateRef", "minValue", "maxValue"], [1, "igx-slider__track"], [1, "igx-slider__track-inactive"], [1, "igx-slider__track-fill"], [1, "igx-slider__track-steps"], ["width", "100%", "height", "100%"], ["x1", "0", "y1", "2", "x2", "100%", "y2", "2"], [1, "igx-slider__thumbs"], ["type", "from", 3, "value", "templateRef", "continuous", "context", "deactiveState", "thumb"], ["type", "from", 3, "value", "min", "max", "disabled", "continuous", "onPan", "stepDistance", "step", "templateRef", "context", "labels", "deactiveState", "thumbLabelVisibilityDuration"], ["type", "to", 3, "value", "templateRef", "continuous", "context", "deactiveState", "thumb"], ["type", "to", 3, "thumbChange", "hoverChange", "value", "min", "max", "disabled", "continuous", "onPan", "stepDistance", "step", "templateRef", "context", "labels", "deactiveState", "thumbLabelVisibilityDuration"], ["ticksOrientation", "bottom", 3, "primaryTicks", "secondaryTicks", "primaryTickLabels", "secondaryTickLabels", "tickLabelsOrientation", "labelsViewEnabled", "labels", "tickLabelTemplateRef", "minValue", "maxValue"], ["type", "from", 3, "thumbChange", "hoverChange", "value", "min", "max", "disabled", "continuous", "onPan", "stepDistance", "step", "templateRef", "context", "labels", "deactiveState", "thumbLabelVisibilityDuration"]],
        template: function IgxSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, IgxSliderComponent_Conditional_0_Template, 2, 13, "igx-ticks", 4);
            i0.ɵɵelementStart(1, "div", 5);
            i0.ɵɵelement(2, "div", 6)(3, "div", 7, 0);
            i0.ɵɵelementStart(5, "div", 8);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(6, "svg", 9);
            i0.ɵɵelement(7, "line", 10, 1);
            i0.ɵɵelementEnd()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(9, "div", 11);
            i0.ɵɵtemplate(10, IgxSliderComponent_Conditional_10_Template, 1, 6, "igx-thumb-label", 12)(11, IgxSliderComponent_Conditional_11_Template, 2, 13, "igx-thumb", 13);
            i0.ɵɵelement(12, "igx-thumb-label", 14);
            i0.ɵɵelementStart(13, "igx-thumb", 15, 2);
            i0.ɵɵlistener("thumbChange", function IgxSliderComponent_Template_igx_thumb_thumbChange_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onThumbChange());
            })("hoverChange", function IgxSliderComponent_Template_igx_thumb_hoverChange_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onHoverChange($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, IgxSliderComponent_Conditional_15_Template, 2, 13, "igx-ticks", 16);
          }
          if (rf & 2) {
            const thumbTo_r4 = i0.ɵɵreference(14);
            i0.ɵɵconditional(ctx.showTicks && ctx.showTopTicks ? 0 : -1);
            i0.ɵɵadvance(10);
            i0.ɵɵconditional(ctx.isRange ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isRange ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.upperLabel)("templateRef", ctx.thumbToTemplateRef)("continuous", ctx.continuous)("context", ctx.context)("deactiveState", ctx.deactivateThumbLabel)("thumb", thumbTo_r4);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.upperLabel)("min", ctx.minValue)("max", ctx.maxValue)("disabled", ctx.disabled)("continuous", ctx.continuous)("onPan", ctx.onPan)("stepDistance", ctx.stepDistance)("step", ctx.step)("templateRef", ctx.thumbToTemplateRef)("context", ctx.context)("labels", ctx.labels)("deactiveState", ctx.deactivateThumbLabel)("thumbLabelVisibilityDuration", ctx.thumbLabelVisibilityDuration);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showTicks && ctx.showBottomTicks ? 15 : -1);
          }
        },
        dependencies: [IgxTicksComponent, IgxThumbLabelComponent, IgxSliderThumbComponent, IgxTickLabelsPipe],
        encapsulation: 2
      });
    }
  }
  return IgxSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Slider directives collection for ease-of-use import in standalone components scenario */
const IGX_SLIDER_DIRECTIVES = [IgxSliderComponent, IgxThumbFromTemplateDirective, IgxThumbToTemplateDirective, IgxTickLabelTemplateDirective];

/**
 *
 * The Switch component is a binary choice selection component.
 *
 * @igxModule IgxSwitchModule
 *
 * @igxTheme igx-switch-theme, igx-tooltip-theme
 *
 * @igxKeywords switch, states, tooltip
 *
 * @igxGroup Data Entry & Display
 * @remarks
 *
 * The Ignite UI Switch lets the user toggle between on/off or true/false states.
 *
 * @example
 * ```html
 * <igx-switch [checked]="true">
 *   Simple switch
 * </igx-switch>
 * ```
 */
let IgxSwitchComponent = /*#__PURE__*/(() => {
  class IgxSwitchComponent extends CheckboxBaseDirective {
    constructor() {
      super(...arguments);
      /**
       * Returns the class of the switch component.
       *
       * @example
       * ```typescript
       * let switchClass = this.switch.cssClass;
       * ```
       */
      this.cssClass = 'igx-switch';
      /**
       * Sets/gets the `disabled` attribute.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-switch disabled><igx-switch>
       * ```
       */
      this.disabled = false;
      /**
       * Sets/gets whether the switch component is invalid.
       * Default value is `false`.
       *
       * @example
       * ```html
       * <igx-switch invalid></igx-switch>
       * ```
       * ```typescript
       * let isInvalid = this.switch.invalid;
       * ```
       */
      this.invalid = false;
      /**
       * Sets/gets whether the switch component is on focus.
       * Default value is `false`.
       *
       * @example
       * ```typescript
       * this.switch.focused = true;
       * ```
       */
      this.focused = false;
    }
    /**
     * Sets/gets whether the switch is on or off.
     * Default value is 'false'.
     *
     * @example
     * ```html
     *  <igx-switch [checked]="true"></igx-switch>
     * ```
     */
    set checked(value) {
      super.checked = value;
    }
    get checked() {
      return super.checked;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxSwitchComponent_BaseFactory;
        return function IgxSwitchComponent_Factory(__ngFactoryType__) {
          return (ɵIgxSwitchComponent_BaseFactory || (ɵIgxSwitchComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxSwitchComponent)))(__ngFactoryType__ || IgxSwitchComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSwitchComponent,
        selectors: [["igx-switch"]],
        hostVars: 10,
        hostBindings: function IgxSwitchComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-switch", ctx.cssClass)("igx-switch--checked", ctx.checked)("igx-switch--disabled", ctx.disabled)("igx-switch--invalid", ctx.invalid)("igx-switch--focused", ctx.focused);
          }
        },
        inputs: {
          checked: "checked",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          invalid: [2, "invalid", "invalid", booleanAttribute]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: EDITOR_PROVIDER,
          useExisting: IgxSwitchComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 10,
        vars: 18,
        consts: [["checkbox", ""], ["label", ""], ["placeholderLabel", ""], ["type", "checkbox", 1, "igx-switch__input", 3, "change", "blur", "id", "name", "value", "tabindex", "disabled", "checked", "required"], ["igxRipple", "", "igxRippleTarget", ".igx-switch__ripple", 1, "igx-switch__composite", 3, "igxRippleDisabled", "igxRippleCentered", "igxRippleDuration"], [1, "igx-switch__composite-thumb"], [1, "igx-switch__ripple"], [1, "igx-switch__thumb"], [3, "id"]],
        template: function IgxSwitchComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "input", 3, 0);
            i0.ɵɵlistener("change", function IgxSwitchComponent_Template_input_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onCheckboxChange($event));
            })("blur", function IgxSwitchComponent_Template_input_blur_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span", 4, 1)(4, "div", 5);
            i0.ɵɵelement(5, "div", 6)(6, "div", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "span", 8, 2);
            i0.ɵɵprojection(9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.inputId)("name", ctx.name)("value", ctx.value)("tabindex", ctx.tabindex)("disabled", ctx.disabled)("checked", ctx.checked)("required", ctx.required);
            i0.ɵɵattribute("aria-required", ctx.required)("aria-invalid", ctx.invalid)("aria-checked", ctx.checked)("aria-labelledby", ctx.ariaLabel ? null : ctx.ariaLabelledBy)("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("igxRippleDisabled", ctx.disableRipple)("igxRippleCentered", true)("igxRippleDuration", 300);
            i0.ɵɵadvance(5);
            i0.ɵɵclassMap(ctx.labelClass);
            i0.ɵɵproperty("id", ctx.labelId);
          }
        },
        dependencies: [IgxRippleDirective],
        encapsulation: 2
      });
    }
  }
  return IgxSwitchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
class IgxTabsBase {}
/** @hidden */
class IgxTabItemBase {}
/** @hidden */
class IgxTabHeaderBase {}
/** @hidden */
class IgxTabContentBase {}
let IgxTabItemDirective = /*#__PURE__*/(() => {
  class IgxTabItemDirective {
    /**
     * Gets/Sets whether an item is selected.
     */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (this._selected !== value) {
        this._selected = value;
        this.tabs.selectTab(this, this._selected);
        this.selectedChange.emit(this._selected);
      }
    }
    /** @hidden */
    constructor(tabs) {
      this.tabs = tabs;
      /**
       * Output to enable support for two-way binding on [(selected)]
       */
      this.selectedChange = new EventEmitter();
      /**
       * Disables the item.
       */
      this.disabled = false;
      /** @hidden */
      this.direction = Direction.NONE;
      this._selected = false;
    }
    static {
      this.ɵfac = function IgxTabItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabItemDirective)(i0.ɵɵdirectiveInject(IgxTabsBase));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabItemDirective,
        contentQueries: function IgxTabItemDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxTabHeaderBase, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxTabContentBase, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panelComponent = _t.first);
          }
        },
        viewQuery: function IgxTabItemDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c252, 7);
            i0.ɵɵviewQuery(_c296, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panelTemplate = _t.first);
          }
        },
        inputs: {
          disabled: [2, "disabled", "disabled", booleanAttribute],
          selected: [2, "selected", "selected", booleanAttribute]
        },
        outputs: {
          selectedChange: "selectedChange"
        }
      });
    }
  }
  return IgxTabItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabContentDirective = /*#__PURE__*/(() => {
  class IgxTabContentDirective {
    /** @hidden */
    constructor(tab, elementRef) {
      this.tab = tab;
      this.elementRef = elementRef;
      /** @hidden */
      this.role = 'tabpanel';
    }
    /** @hidden */
    get tabIndex() {
      return this.tab.selected ? 0 : -1;
    }
    /** @hidden */
    get zIndex() {
      return this.tab.selected ? 'auto' : -1;
    }
    /** @hidden */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    static {
      this.ɵfac = function IgxTabContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabContentDirective)(i0.ɵɵdirectiveInject(IgxTabItemDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabContentDirective,
        hostVars: 4,
        hostBindings: function IgxTabContentDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("tabindex", ctx.tabIndex);
            i0.ɵɵstyleProp("z-index", ctx.zIndex);
          }
        }
      });
    }
  }
  return IgxTabContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBottomNavContentComponent = /*#__PURE__*/(() => {
  class IgxBottomNavContentComponent extends IgxTabContentDirective {
    constructor() {
      super(...arguments);
      /** @hidden */
      this.defaultClass = true;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxBottomNavContentComponent_BaseFactory;
        return function IgxBottomNavContentComponent_Factory(__ngFactoryType__) {
          return (ɵIgxBottomNavContentComponent_BaseFactory || (ɵIgxBottomNavContentComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxBottomNavContentComponent)))(__ngFactoryType__ || IgxBottomNavContentComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBottomNavContentComponent,
        selectors: [["igx-bottom-nav-content"]],
        hostVars: 2,
        hostBindings: function IgxBottomNavContentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-bottom-nav__panel", ctx.defaultClass);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabContentBase,
          useExisting: IgxBottomNavContentComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        template: function IgxBottomNavContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxBottomNavContentComponent_Conditional_0_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.tab.selected || ctx.tab.previous ? 0 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxBottomNavContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabHeaderDirective = /*#__PURE__*/(() => {
  class IgxTabHeaderDirective {
    /** @hidden */
    constructor(tabs, tab, elementRef, platform) {
      this.tabs = tabs;
      this.tab = tab;
      this.elementRef = elementRef;
      this.platform = platform;
      /** @hidden */
      this.role = 'tab';
    }
    /** @hidden */
    get tabIndex() {
      return this.tab.selected ? 0 : -1;
    }
    /** @hidden */
    get ariaSelected() {
      return this.tab.selected;
    }
    /** @hidden */
    get ariaDisabled() {
      return this.tab.disabled;
    }
    /** @hidden */
    onClick() {
      if (this.tab.panelComponent) {
        this.tabs.selectTab(this.tab, true);
      }
    }
    /** @hidden */
    get nativeElement() {
      return this.elementRef.nativeElement;
    }
    static {
      this.ɵfac = function IgxTabHeaderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabHeaderDirective)(i0.ɵɵdirectiveInject(IgxTabsBase), i0.ɵɵdirectiveInject(IgxTabItemDirective), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabHeaderDirective,
        hostVars: 4,
        hostBindings: function IgxTabHeaderDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function IgxTabHeaderDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("tabindex", ctx.tabIndex)("aria-selected", ctx.ariaSelected)("aria-disabled", ctx.ariaDisabled);
          }
        }
      });
    }
  }
  return IgxTabHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBottomNavHeaderComponent = /*#__PURE__*/(() => {
  class IgxBottomNavHeaderComponent extends IgxTabHeaderDirective {
    /** @hidden */
    get cssClassSelected() {
      return this.tab.selected;
    }
    /** @hidden */
    get cssClassDisabled() {
      return this.tab.disabled;
    }
    /** @hidden */
    get cssClass() {
      return !this.tab.disabled && !this.tab.selected;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxBottomNavHeaderComponent_BaseFactory;
        return function IgxBottomNavHeaderComponent_Factory(__ngFactoryType__) {
          return (ɵIgxBottomNavHeaderComponent_BaseFactory || (ɵIgxBottomNavHeaderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxBottomNavHeaderComponent)))(__ngFactoryType__ || IgxBottomNavHeaderComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBottomNavHeaderComponent,
        selectors: [["igx-bottom-nav-header"]],
        hostVars: 6,
        hostBindings: function IgxBottomNavHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-bottom-nav__menu-item--selected", ctx.cssClassSelected)("igx-bottom-nav__menu-item--disabled", ctx.cssClassDisabled)("igx-bottom-nav__menu-item", ctx.cssClass);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabHeaderBase,
          useExisting: IgxBottomNavHeaderComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxBottomNavHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxBottomNavHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBottomNavItemComponent = /*#__PURE__*/(() => {
  class IgxBottomNavItemComponent extends IgxTabItemDirective {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxBottomNavItemComponent_BaseFactory;
        return function IgxBottomNavItemComponent_Factory(__ngFactoryType__) {
          return (ɵIgxBottomNavItemComponent_BaseFactory || (ɵIgxBottomNavItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxBottomNavItemComponent)))(__ngFactoryType__ || IgxBottomNavItemComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBottomNavItemComponent,
        selectors: [["igx-bottom-nav-item"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabItemDirective,
          useExisting: IgxBottomNavItemComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c298,
        decls: 4,
        vars: 0,
        consts: [["headerTemplate", ""], ["panelTemplate", ""]],
        template: function IgxBottomNavItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c297);
            i0.ɵɵtemplate(0, IgxBottomNavItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxBottomNavItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxBottomNavItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabsDirective = /*#__PURE__*/(() => {
  class IgxTabsDirective extends IgxCarouselComponentBase {
    /**
     * Gets/Sets the index of the selected item.
     * Default value is 0 if contents are defined otherwise defaults to -1.
     */
    get selectedIndex() {
      return this._selectedIndex;
    }
    set selectedIndex(value) {
      if (this._selectedIndex !== value) {
        let newIndex = value;
        const oldIndex = this._selectedIndex;
        const args = {
          owner: this,
          cancel: false,
          oldIndex,
          newIndex
        };
        this.selectedIndexChanging.emit(args);
        if (!args.cancel) {
          newIndex = args.newIndex;
          this._selectedIndex = newIndex;
          this.selectedIndexChange.emit(this._selectedIndex);
        }
        this.updateSelectedTabs(oldIndex);
      }
    }
    /**
     * Gets the selected item.
     */
    get selectedItem() {
      return this.items && this.selectedIndex >= 0 && this.selectedIndex < this.items.length ? this.items.get(this.selectedIndex) : null;
    }
    /** @hidden */
    constructor(animationService, cdr, dir) {
      super(animationService, cdr);
      this.dir = dir;
      /**
       * Enables/disables the transition animation of the contents.
       */
      this.disableAnimation = false;
      /**
       * Output to enable support for two-way binding on [(selectedIndex)]
       */
      this.selectedIndexChange = new EventEmitter();
      /**
       * Emitted when the selected index is about to change.
       */
      this.selectedIndexChanging = new EventEmitter();
      /**
       * Emitted when the selected item is changed.
       */
      this.selectedItemChange = new EventEmitter();
      this._selectedIndex = -1;
    }
    /** @hidden */
    ngAfterViewInit() {
      if (this._selectedIndex === -1) {
        const hasSelectedTab = this.items.some((tab, i) => {
          if (tab.selected) {
            this._selectedIndex = i;
          }
          return tab.selected;
        });
        if (!hasSelectedTab && this.hasPanels) {
          this._selectedIndex = 0;
        }
      }
      // Use promise to avoid expression changed after check error
      Promise.resolve().then(() => {
        this.updateSelectedTabs(null, false);
      });
      this._itemChanges$ = this.items.changes.subscribe(() => {
        this.onItemChanges();
      });
      this.setAttributes();
    }
    /** @hidden */
    ngOnDestroy() {
      if (this._itemChanges$) {
        this._itemChanges$.unsubscribe();
      }
    }
    /** @hidden */
    selectTab(tab, selected) {
      if (!this.items) {
        return;
      }
      const tabs = this.items.toArray();
      if (selected) {
        const index = tabs.indexOf(tab);
        if (index > -1) {
          this.selectedIndex = index;
        }
      } else {
        if (tabs.every(t => !t.selected)) {
          this.selectedIndex = -1;
        }
      }
    }
    /** @hidden */
    getPreviousElement() {
      return this.previousItem.panelComponent.nativeElement;
    }
    /** @hidden */
    getCurrentElement() {
      return this.currentItem.panelComponent.nativeElement;
    }
    /** @hidden */
    scrollTabHeaderIntoView() {}
    /** @hidden */
    onItemChanges() {
      this.setAttributes();
      // Check if there is selected tab
      let selectedIndex = -1;
      this.items.some((tab, i) => {
        if (tab.selected) {
          selectedIndex = i;
        }
        return tab.selected;
      });
      if (selectedIndex >= 0) {
        // Set the selected index to the tab that has selected=true
        Promise.resolve().then(() => {
          this.selectedIndex = selectedIndex;
        });
      } else {
        if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
          // Select the tab on the same index the previous selected tab was
          Promise.resolve().then(() => {
            this.updateSelectedTabs(null);
          });
        } else if (this.selectedIndex >= this.items.length) {
          // Select the last tab
          Promise.resolve().then(() => {
            this.selectedIndex = this.items.length - 1;
          });
        }
      }
    }
    setAttributes() {
      this.items.forEach(item => {
        if (item.panelComponent && !item.headerComponent.nativeElement.getAttribute('id')) {
          const id = this.getNextTabId();
          const tabHeaderId = `${this.componentName}-header-${id}`;
          const tabPanelId = `${this.componentName}-content-${id}`;
          this.setHeaderAttribute(item, 'id', tabHeaderId);
          this.setHeaderAttribute(item, 'aria-controls', tabPanelId);
          this.setPanelAttribute(item, 'id', tabPanelId);
          this.setPanelAttribute(item, 'aria-labelledby', tabHeaderId);
        }
      });
    }
    setHeaderAttribute(item, attrName, value) {
      item.headerComponent.nativeElement.setAttribute(attrName, value);
    }
    setPanelAttribute(item, attrName, value) {
      item.panelComponent.nativeElement.setAttribute(attrName, value);
    }
    get hasPanels() {
      return this.panels && this.panels.length;
    }
    updateSelectedTabs(oldSelectedIndex, raiseEvent = true) {
      if (!this.items) {
        return;
      }
      let newTab;
      const oldTab = this.currentItem;
      // First select the new tab
      if (this._selectedIndex >= 0 && this._selectedIndex < this.items.length) {
        newTab = this.items.get(this._selectedIndex);
        newTab.selected = true;
      }
      // Then unselect the other tabs
      this.items.forEach((tab, i) => {
        if (i !== this._selectedIndex) {
          tab.selected = false;
        }
      });
      if (this._selectedIndex !== oldSelectedIndex) {
        this.scrollTabHeaderIntoView();
        this.triggerPanelAnimations(oldSelectedIndex);
        if (raiseEvent && newTab !== oldTab) {
          this.selectedItemChange.emit({
            owner: this,
            newItem: newTab,
            oldItem: oldTab
          });
        }
      }
    }
    triggerPanelAnimations(oldSelectedIndex) {
      const item = this.items.get(this._selectedIndex);
      if (item && !this.disableAnimation && this.hasPanels && this.currentItem && !this.currentItem.selected) {
        item.direction = !this.dir.rtl && this._selectedIndex > oldSelectedIndex || this.dir.rtl && this._selectedIndex < oldSelectedIndex ? Direction.NEXT : Direction.PREV;
        if (this.previousItem && this.previousItem.previous) {
          this.previousItem.previous = false;
        }
        this.currentItem.direction = item.direction;
        this.previousItem = this.currentItem;
        this.currentItem = item;
        this.triggerAnimations();
      } else {
        this.currentItem = item;
      }
    }
    static {
      this.ɵfac = function IgxTabsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabsDirective)(i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxDirectionality));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabsDirective,
        contentQueries: function IgxTabsDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxTabItemDirective, 4);
            i0.ɵɵcontentQuery(dirIndex, IgxTabContentBase, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panels = _t);
          }
        },
        inputs: {
          selectedIndex: "selectedIndex",
          disableAnimation: [2, "disableAnimation", "disableAnimation", booleanAttribute]
        },
        outputs: {
          selectedIndexChange: "selectedIndexChange",
          selectedIndexChanging: "selectedIndexChanging",
          selectedItemChange: "selectedItemChange"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return IgxTabsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @hidden */
let NEXT_BOTTOM_NAV_ITEM_ID = 0;
/**
 * Bottom Navigation component enables the user to navigate among a number of contents displayed in a single view.
 *
 * @igxModule IgxBottomNavModule
 *
 * @igxTheme igx-bottom-nav-theme
 *
 * @igxKeywords bottom navigation
 *
 * @igxGroup Layouts
 *
 * @remarks
 * The Ignite UI for Angular Bottom Navigation component enables the user to navigate among a number of contents
 * displayed in a single view. The navigation through the contents is accomplished with the tab buttons located at bottom.
 *
 * @example
 * ```html
 * <igx-bottom-nav>
 *     <igx-bottom-nav-item>
 *         <igx-bottom-nav-header>
 *             <igx-icon igxBottomNavHeaderIcon>folder</igx-icon>
 *             <span igxBottomNavHeaderLabel>Tab 1</span>
 *         </igx-bottom-nav-header>
 *         <igx-bottom-nav-content>
 *             Content 1
 *         </igx-bottom-nav-content>
 *     </igx-bottom-nav-item>
 *     ...
 * </igx-bottom-nav>
 * ```
 */
let IgxBottomNavComponent = /*#__PURE__*/(() => {
  class IgxBottomNavComponent extends IgxTabsDirective {
    constructor() {
      super(...arguments);
      /** @hidden */
      this.disableAnimation = true;
      /** @hidden */
      this.componentName = 'igx-bottom-nav';
    }
    /** @hidden */
    getNextTabId() {
      return NEXT_BOTTOM_NAV_ITEM_ID++;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxBottomNavComponent_BaseFactory;
        return function IgxBottomNavComponent_Factory(__ngFactoryType__) {
          return (ɵIgxBottomNavComponent_BaseFactory || (ɵIgxBottomNavComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxBottomNavComponent)))(__ngFactoryType__ || IgxBottomNavComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxBottomNavComponent,
        selectors: [["igx-bottom-nav"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabsBase,
          useExisting: IgxBottomNavComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 0,
        consts: [["tablist", ""], ["role", "tablist", "aria-orientation", "horizontal", 1, "igx-bottom-nav__menu", "igx-bottom-nav__menu--bottom"], [4, "ngTemplateOutlet"]],
        template: function IgxBottomNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, IgxBottomNavComponent_For_1_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(2, "div", 1, 0);
            i0.ɵɵrepeaterCreate(4, IgxBottomNavComponent_For_5_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.items);
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxBottomNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBottomNavHeaderLabelDirective = /*#__PURE__*/(() => {
  class IgxBottomNavHeaderLabelDirective {
    static {
      this.ɵfac = function IgxBottomNavHeaderLabelDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBottomNavHeaderLabelDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxBottomNavHeaderLabelDirective,
        selectors: [["igx-bottom-nav-header-label"], ["", "igxBottomNavHeaderLabel", ""]]
      });
    }
  }
  return IgxBottomNavHeaderLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxBottomNavHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxBottomNavHeaderIconDirective {
    static {
      this.ɵfac = function IgxBottomNavHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBottomNavHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxBottomNavHeaderIconDirective,
        selectors: [["igx-bottom-nav-header-icon"], ["", "igxBottomNavHeaderIcon", ""]]
      });
    }
  }
  return IgxBottomNavHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Bottom navigation directives collection for ease-of-use import in standalone components scenario */
const IGX_BOTTOM_NAV_DIRECTIVES = [IgxBottomNavComponent, IgxBottomNavItemComponent, IgxBottomNavHeaderComponent, IgxBottomNavContentComponent, IgxBottomNavHeaderLabelDirective, IgxBottomNavHeaderIconDirective];
let IgxTabContentComponent = /*#__PURE__*/(() => {
  class IgxTabContentComponent extends IgxTabContentDirective {
    constructor() {
      super(...arguments);
      /** @hidden */
      this.cssClass = true;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTabContentComponent_BaseFactory;
        return function IgxTabContentComponent_Factory(__ngFactoryType__) {
          return (ɵIgxTabContentComponent_BaseFactory || (ɵIgxTabContentComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTabContentComponent)))(__ngFactoryType__ || IgxTabContentComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTabContentComponent,
        selectors: [["igx-tab-content"]],
        hostVars: 2,
        hostBindings: function IgxTabContentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-tabs__panel", ctx.cssClass);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabContentBase,
          useExisting: IgxTabContentComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        template: function IgxTabContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, IgxTabContentComponent_Conditional_0_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.tab.selected || ctx.tab.previous ? 0 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxTabContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IgxTabsAlignment = /*@__PURE__*/mkenum({
  start: 'start',
  end: 'end',
  center: 'center',
  justify: 'justify'
});
/** @hidden */
let NEXT_TAB_ID = 0;
/**
 * Tabs component is used to organize or switch between similar data sets.
 *
 * @igxModule IgxTabsModule
 *
 * @igxTheme igx-tabs-theme
 *
 * @igxKeywords tabs
 *
 * @igxGroup Layouts
 *
 * @remarks
 * The Ignite UI for Angular Tabs component places tabs at the top and allows for scrolling when there are multiple tab items on the screen.
 *
 * @example
 * ```html
 * <igx-tabs>
 *     <igx-tab-item>
 *         <igx-tab-header>
 *             <igx-icon igxTabHeaderIcon>folder</igx-icon>
 *             <span igxTabHeaderLabel>Tab 1</span>
 *         </igx-tab-header>
 *         <igx-tab-content>
 *             Content 1
 *         </igx-tab-content>
 *     </igx-tab-item>
 *     ...
 * </igx-tabs>
 * ```
 */
let IgxTabsComponent = /*#__PURE__*/(() => {
  class IgxTabsComponent extends IgxTabsDirective {
    /**
     * Gets/Sets the tab alignment. Defaults to `start`.
     */
    get tabAlignment() {
      return this._tabAlignment;
    }
    set tabAlignment(value) {
      this._tabAlignment = value;
      requestAnimationFrame(() => {
        this.updateScrollButtons();
        this.realignSelectedIndicator();
      });
    }
    constructor(animationService, cdr, ngZone, dir, platform) {
      super(animationService, cdr, dir);
      this.ngZone = ngZone;
      this.platform = platform;
      /**
       * Determines the tab activation.
       * When set to auto, the tab is instantly selected while navigating with the Left/Right Arrows, Home or End keys and the corresponding panel is displayed.
       * When set to manual, the tab is only focused. The selection happens after pressing Space or Enter.
       * Defaults is auto.
       */
      this.activation = 'auto';
      /** @hidden */
      this.defaultClass = true;
      /**  @hidden */
      this.offset = 0;
      /** @hidden */
      this.componentName = 'igx-tabs';
      this._tabAlignment = 'start';
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.ngZone.runOutsideAngular(() => {
        if (this.platform.isBrowser) {
          this._resizeObserver = new (getResizeObserver())(() => {
            this.updateScrollButtons();
            this.realignSelectedIndicator();
          });
          this._resizeObserver.observe(this.headerContainer.nativeElement);
          this._resizeObserver.observe(this.viewPort.nativeElement);
        }
      });
    }
    /** @hidden @internal */
    ngOnDestroy() {
      super.ngOnDestroy();
      this.ngZone.runOutsideAngular(() => {
        this._resizeObserver?.disconnect();
      });
    }
    /** @hidden */
    scrollPrev() {
      this.scroll(false);
    }
    /** @hidden */
    scrollNext() {
      this.scroll(true);
    }
    /** @hidden */
    realignSelectedIndicator() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
        const header = this.items.get(this.selectedIndex).headerComponent.nativeElement;
        this.alignSelectedIndicator(header, 0);
      }
    }
    /** @hidden */
    resolveHeaderScrollClasses() {
      return {
        'igx-tabs__header-scroll--start': this.tabAlignment === 'start',
        'igx-tabs__header-scroll--end': this.tabAlignment === 'end',
        'igx-tabs__header-scroll--center': this.tabAlignment === 'center',
        'igx-tabs__header-scroll--justify': this.tabAlignment === 'justify'
      };
    }
    /** @hidden */
    scrollTabHeaderIntoView() {
      if (this.selectedIndex >= 0) {
        const tabItems = this.items.toArray();
        const tabHeaderNativeElement = tabItems[this.selectedIndex].headerComponent.nativeElement;
        // Scroll left if there is need
        if (this.getElementOffset(tabHeaderNativeElement) < this.offset) {
          this.scrollElement(tabHeaderNativeElement, false);
        }
        // Scroll right if there is need
        const viewPortOffsetWidth = this.viewPort.nativeElement.offsetWidth;
        const delta = this.getElementOffset(tabHeaderNativeElement) + tabHeaderNativeElement.offsetWidth - (viewPortOffsetWidth + this.offset);
        // Fix for IE 11, a difference is accumulated from the widths calculations
        if (delta > 1) {
          this.scrollElement(tabHeaderNativeElement, true);
        }
        this.alignSelectedIndicator(tabHeaderNativeElement);
      } else {
        this.hideSelectedIndicator();
      }
    }
    /** @hidden */
    getNextTabId() {
      return NEXT_TAB_ID++;
    }
    /** @hidden */
    onItemChanges() {
      super.onItemChanges();
      Promise.resolve().then(() => {
        this.updateScrollButtons();
      });
    }
    alignSelectedIndicator(element, duration = 0.3) {
      if (this.selectedIndicator) {
        this.selectedIndicator.nativeElement.style.visibility = 'visible';
        this.selectedIndicator.nativeElement.style.transitionDuration = duration > 0 ? `${duration}s` : 'initial';
        this.selectedIndicator.nativeElement.style.width = `${element.offsetWidth}px`;
        this.selectedIndicator.nativeElement.style.transform = `translate(${element.offsetLeft}px)`;
      }
    }
    hideSelectedIndicator() {
      if (this.selectedIndicator) {
        this.selectedIndicator.nativeElement.style.visibility = 'hidden';
      }
    }
    scroll(scrollNext) {
      const tabsArray = this.items.toArray();
      for (let index = 0; index < tabsArray.length; index++) {
        const tab = tabsArray[index];
        const element = tab.headerComponent.nativeElement;
        if (scrollNext) {
          if (element.offsetWidth + this.getElementOffset(element) > this.viewPort.nativeElement.offsetWidth + this.offset) {
            this.scrollElement(element, scrollNext);
            break;
          }
        } else {
          if (this.getElementOffset(element) >= this.offset) {
            this.scrollElement(tabsArray[index - 1].headerComponent.nativeElement, scrollNext);
            break;
          }
        }
      }
    }
    scrollElement(element, scrollNext) {
      const viewPortWidth = this.viewPort.nativeElement.offsetWidth;
      this.offset = scrollNext ? element.offsetWidth + this.getElementOffset(element) - viewPortWidth : this.getElementOffset(element);
      this.viewPort.nativeElement.scrollLeft = this.getOffset(this.offset);
      this.updateScrollButtons();
    }
    updateScrollButtons() {
      const itemsContainerWidth = this.getTabItemsContainerWidth();
      const scrollPrevButtonStyle = this.resolveLeftScrollButtonStyle(itemsContainerWidth);
      this.setScrollButtonStyle(this.scrollPrevButton.nativeElement, scrollPrevButtonStyle);
      const scrollNextButtonStyle = this.resolveRightScrollButtonStyle(itemsContainerWidth);
      this.setScrollButtonStyle(this.scrollNextButton.nativeElement, scrollNextButtonStyle);
    }
    setScrollButtonStyle(button, buttonStyle) {
      if (buttonStyle === "enabled" /* TabScrollButtonStyle.Enabled */) {
        button.disabled = false;
        button.style.display = '';
      } else if (buttonStyle === "disabled" /* TabScrollButtonStyle.Disabled */) {
        button.disabled = true;
        button.style.display = '';
      } else if (buttonStyle === "not_displayed" /* TabScrollButtonStyle.NotDisplayed */) {
        button.style.display = 'none';
      }
    }
    resolveLeftScrollButtonStyle(itemsContainerWidth) {
      const headerContainerWidth = this.headerContainer.nativeElement.offsetWidth;
      const offset = this.offset;
      if (offset === 0) {
        // Fix for IE 11, a difference is accumulated from the widths calculations.
        if (itemsContainerWidth - headerContainerWidth <= 1) {
          return "not_displayed" /* TabScrollButtonStyle.NotDisplayed */;
        }
        return "disabled" /* TabScrollButtonStyle.Disabled */;
      } else {
        return "enabled" /* TabScrollButtonStyle.Enabled */;
      }
    }
    resolveRightScrollButtonStyle(itemsContainerWidth) {
      const viewPortWidth = this.viewPort.nativeElement.offsetWidth;
      const headerContainerWidth = this.headerContainer.nativeElement.offsetWidth;
      const offset = this.offset;
      const total = offset + viewPortWidth;
      // Fix for IE 11, a difference is accumulated from the widths calculations.
      if (itemsContainerWidth - headerContainerWidth <= 1 && offset === 0) {
        return "not_displayed" /* TabScrollButtonStyle.NotDisplayed */;
      }
      if (itemsContainerWidth > total) {
        return "enabled" /* TabScrollButtonStyle.Enabled */;
      } else {
        return "disabled" /* TabScrollButtonStyle.Disabled */;
      }
    }
    getTabItemsContainerWidth() {
      // We use this hacky way to get the width of the itemsContainer,
      // because there is inconsistency in IE we cannot use offsetWidth or scrollOffset.
      const itemsContainerChildrenCount = this.itemsContainer.nativeElement.children.length;
      let itemsContainerWidth = 0;
      if (itemsContainerChildrenCount > 1) {
        const lastTab = this.itemsContainer.nativeElement.children[itemsContainerChildrenCount - 1];
        itemsContainerWidth = this.getElementOffset(lastTab) + lastTab.offsetWidth;
      }
      return itemsContainerWidth;
    }
    getOffset(offset) {
      return this.dir.rtl ? -offset : offset;
    }
    getElementOffset(element) {
      return this.dir.rtl ? this.itemsWrapper.nativeElement.offsetWidth - element.offsetLeft - element.offsetWidth : element.offsetLeft;
    }
    static {
      this.ɵfac = function IgxTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabsComponent)(i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IgxDirectionality), i0.ɵɵdirectiveInject(PlatformUtil));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTabsComponent,
        selectors: [["igx-tabs"]],
        viewQuery: function IgxTabsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c299, 7);
            i0.ɵɵviewQuery(_c300, 7);
            i0.ɵɵviewQuery(_c301, 7);
            i0.ɵɵviewQuery(_c302, 7);
            i0.ɵɵviewQuery(_c303, 5);
            i0.ɵɵviewQuery(_c304, 5);
            i0.ɵɵviewQuery(_c305, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewPort = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsWrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectedIndicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollPrevButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollNextButton = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxTabsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-tabs", ctx.defaultClass);
          }
        },
        inputs: {
          tabAlignment: "tabAlignment",
          activation: "activation"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabsBase,
          useExisting: IgxTabsComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 20,
        vars: 2,
        consts: [["headerContainer", ""], ["scrollPrevButton", ""], ["viewPort", ""], ["itemsWrapper", ""], ["itemsContainer", ""], ["scrollNextButton", ""], ["selectedIndicator", ""], [1, "igx-tabs__header"], ["type", "button", "igxIconButton", "flat", "igxRipple", "", "tabindex", "-1", 1, "igx-tabs__header-button", 3, "click"], ["family", "default", "name", "prev"], [1, "igx-tabs__header-content"], ["role", "tablist", 1, "igx-tabs__header-wrapper"], [1, "igx-tabs__header-scroll", 3, "ngClass"], [1, "igx-tabs__header-active-indicator"], ["family", "default", "name", "next"], [1, "igx-tabs__panels"], [4, "ngTemplateOutlet"]],
        template: function IgxTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 7, 0)(2, "button", 8, 1);
            i0.ɵɵlistener("click", function IgxTabsComponent_Template_button_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.scrollPrev());
            });
            i0.ɵɵelement(4, "igx-icon", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 10, 2)(7, "div", 11, 3)(9, "div", 12, 4);
            i0.ɵɵrepeaterCreate(11, IgxTabsComponent_For_12_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, IgxTabsComponent_Conditional_13_Template, 2, 0, "div", 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "button", 8, 5);
            i0.ɵɵlistener("click", function IgxTabsComponent_Template_button_click_14_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.scrollNext());
            });
            i0.ɵɵelement(16, "igx-icon", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15);
            i0.ɵɵrepeaterCreate(18, IgxTabsComponent_For_19_Template, 1, 1, "ng-container", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngClass", ctx.resolveHeaderScrollClasses());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.items);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.items.length > 0 ? 13 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [IgxRippleDirective, IgxIconComponent, NgClass, NgTemplateOutlet, IgxIconButtonDirective],
        encapsulation: 2
      });
    }
  }
  return IgxTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabHeaderComponent = /*#__PURE__*/(() => {
  class IgxTabHeaderComponent extends IgxTabHeaderDirective {
    /** @hidden @internal */
    get provideCssClassSelected() {
      return this.tab.selected;
    }
    /** @hidden @internal */
    get provideCssClassDisabled() {
      return this.tab.disabled;
    }
    /** @hidden @internal */
    constructor(tabs, tab, elementRef, platform, ngZone, dir) {
      super(tabs, tab, elementRef, platform);
      this.tabs = tabs;
      this.ngZone = ngZone;
      this.dir = dir;
      /** @hidden @internal */
      this.cssClass = true;
    }
    /** @hidden @internal */
    keyDown(event) {
      let unsupportedKey = false;
      const itemsArray = this.tabs.items.toArray();
      const previousIndex = itemsArray.indexOf(this.tab);
      let newIndex = previousIndex;
      const hasDisabledItems = itemsArray.some(item => item.disabled);
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_RIGHT:
          newIndex = this.getNewSelectionIndex(newIndex, itemsArray, event.key, hasDisabledItems);
          break;
        case this.platform.KEYMAP.ARROW_LEFT:
          newIndex = this.getNewSelectionIndex(newIndex, itemsArray, event.key, hasDisabledItems);
          break;
        case this.platform.KEYMAP.HOME:
          event.preventDefault();
          newIndex = 0;
          while (itemsArray[newIndex].disabled && newIndex < itemsArray.length) {
            newIndex = newIndex === itemsArray.length - 1 ? 0 : newIndex + 1;
          }
          break;
        case this.platform.KEYMAP.END:
          event.preventDefault();
          newIndex = itemsArray.length - 1;
          while (hasDisabledItems && itemsArray[newIndex].disabled && newIndex > 0) {
            newIndex = newIndex === 0 ? itemsArray.length - 1 : newIndex - 1;
          }
          break;
        case this.platform.KEYMAP.ENTER:
        case this.platform.KEYMAP.SPACE:
          event.preventDefault();
          if (this.tabs.activation === 'manual') {
            this.nativeElement.click();
          }
          unsupportedKey = true;
          break;
        default:
          unsupportedKey = true;
          break;
      }
      if (!unsupportedKey) {
        itemsArray[newIndex].headerComponent.nativeElement.focus({
          preventScroll: true
        });
        if (this.tabs.activation === 'auto') {
          this.tabs.selectedIndex = newIndex;
        }
      }
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.ngZone.runOutsideAngular(() => {
        if (this.platform.isBrowser) {
          this._resizeObserver = new (getResizeObserver())(() => {
            this.tabs.realignSelectedIndicator();
          });
          this._resizeObserver.observe(this.nativeElement);
        }
      });
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.ngZone.runOutsideAngular(() => {
        this._resizeObserver?.disconnect();
      });
    }
    getNewSelectionIndex(newIndex, itemsArray, key, hasDisabledItems) {
      if (key === this.platform.KEYMAP.ARROW_RIGHT && !this.dir.rtl || key === this.platform.KEYMAP.ARROW_LEFT && this.dir.rtl) {
        newIndex = newIndex === itemsArray.length - 1 ? 0 : newIndex + 1;
        while (hasDisabledItems && itemsArray[newIndex].disabled && newIndex < itemsArray.length) {
          newIndex = newIndex === itemsArray.length - 1 ? 0 : newIndex + 1;
        }
      } else {
        newIndex = newIndex === 0 ? itemsArray.length - 1 : newIndex - 1;
        while (hasDisabledItems && itemsArray[newIndex].disabled && newIndex >= 0) {
          newIndex = newIndex === 0 ? itemsArray.length - 1 : newIndex - 1;
        }
      }
      return newIndex;
    }
    static {
      this.ɵfac = function IgxTabHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabHeaderComponent)(i0.ɵɵdirectiveInject(IgxTabsComponent), i0.ɵɵdirectiveInject(IgxTabItemDirective), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IgxDirectionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTabHeaderComponent,
        selectors: [["igx-tab-header"]],
        hostVars: 6,
        hostBindings: function IgxTabHeaderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxTabHeaderComponent_keydown_HostBindingHandler($event) {
              return ctx.keyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-tabs__header-item--selected", ctx.provideCssClassSelected)("igx-tabs__header-item--disabled", ctx.provideCssClassDisabled)("igx-tabs__header-item", ctx.cssClass);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabHeaderBase,
          useExisting: IgxTabHeaderComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c53,
        decls: 4,
        vars: 0,
        consts: [[1, "igx-tabs__header-item-inner"]],
        template: function IgxTabHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c52);
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "div", 0);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(3, 2);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxTabHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabItemComponent = /*#__PURE__*/(() => {
  class IgxTabItemComponent extends IgxTabItemDirective {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxTabItemComponent_BaseFactory;
        return function IgxTabItemComponent_Factory(__ngFactoryType__) {
          return (ɵIgxTabItemComponent_BaseFactory || (ɵIgxTabItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxTabItemComponent)))(__ngFactoryType__ || IgxTabItemComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxTabItemComponent,
        selectors: [["igx-tab-item"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxTabItemDirective,
          useExisting: IgxTabItemComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c307,
        decls: 4,
        vars: 0,
        consts: [["headerTemplate", ""], ["panelTemplate", ""]],
        template: function IgxTabItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c306);
            i0.ɵɵtemplate(0, IgxTabItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxTabItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxTabItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabHeaderLabelDirective = /*#__PURE__*/(() => {
  class IgxTabHeaderLabelDirective {
    static {
      this.ɵfac = function IgxTabHeaderLabelDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabHeaderLabelDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabHeaderLabelDirective,
        selectors: [["igx-tab-header-label"], ["", "igxTabHeaderLabel", ""]]
      });
    }
  }
  return IgxTabHeaderLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IgxTabHeaderIconDirective = /*#__PURE__*/(() => {
  class IgxTabHeaderIconDirective {
    static {
      this.ɵfac = function IgxTabHeaderIconDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabHeaderIconDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxTabHeaderIconDirective,
        selectors: [["igx-tab-header-icon"], ["", "igxTabHeaderIcon", ""]]
      });
    }
  }
  return IgxTabHeaderIconDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Tabs directives collection for ease-of-use import in standalone components scenario */
const IGX_TABS_DIRECTIVES = [IgxTabsComponent, IgxTabItemComponent, IgxTabHeaderComponent, IgxTabContentComponent, IgxTabHeaderLabelDirective, IgxTabHeaderIconDirective, IgxPrefixDirective, IgxSuffixDirective];

/* NOTE: Time picker directives collection for ease-of-use import in standalone components scenario */
const IGX_TIME_PICKER_DIRECTIVES = [IgxTimePickerComponent, IgxPickerActionsDirective, IgxPickerToggleComponent, IgxPickerClearComponent, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];
let NEXT_ID$1 = 0;
/**
 * **Ignite UI for Angular Toast** -
 * [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/toast)
 *
 * The Ignite UI Toast provides information and warning messages that are non-interactive and cannot
 * be dismissed by the user. Toasts can be displayed at the bottom, middle, or top of the page.
 *
 * Example:
 * ```html
 * <button type="button" igxButton (click)="toast.open()">Show notification</button>
 * <igx-toast #toast displayTime="1000">
 *      Notification displayed
 * </igx-toast>
 * ```
 */
let IgxToastComponent = /*#__PURE__*/(() => {
  class IgxToastComponent extends IgxNotificationsDirective {
    /**
     * Get the position and animation settings used by the toast.
     * ```typescript
     * @ViewChild('toast', { static: true }) public toast: IgxToastComponent;
     * let currentPosition: PositionSettings = this.toast.positionSettings
     * ```
     */
    get positionSettings() {
      return this._positionSettings;
    }
    /**
     * Set the position and animation settings used by the toast.
     * ```html
     * <igx-toast [positionSettings]="newPositionSettings"></igx-toast>
     * ```
     * ```typescript
     * import { slideInTop, slideOutBottom } from 'igniteui-angular';
     * ...
     * @ViewChild('toast', { static: true }) public toast: IgxToastComponent;
     *  public newPositionSettings: PositionSettings = {
     *      openAnimation: useAnimation(slideInTop, { params: { duration: '1000ms', fromPosition: 'translateY(100%)'}}),
     *      closeAnimation: useAnimation(slideOutBottom, { params: { duration: '1000ms', fromPosition: 'translateY(0)'}}),
     *      horizontalDirection: HorizontalAlignment.Left,
     *      verticalDirection: VerticalAlignment.Middle,
     *      horizontalStartPoint: HorizontalAlignment.Left,
     *      verticalStartPoint: VerticalAlignment.Middle
     *  };
     * this.toast.positionSettings = this.newPositionSettings;
     * ```
     */
    set positionSettings(settings) {
      this._positionSettings = settings;
    }
    /**
     * Gets the nativeElement of the toast.
     * ```typescript
     * let nativeElement = this.toast.element;
     * ```
     *
     * @memberof IgxToastComponent
     */
    get element() {
      return this._element.nativeElement;
    }
    constructor(_element, cdr, navService, overlayService) {
      super(_element, cdr, overlayService, navService);
      this._element = _element;
      /**
       * @hidden
       */
      this.cssClass = 'igx-toast';
      /**
       * Sets/gets the `id` of the toast.
       * If not set, the `id` will have value `"igx-toast-0"`.
       * ```html
       * <igx-toast id = "my-first-toast"></igx-toast>
       * ```
       * ```typescript
       * let toastId = this.toast.id;
       * ```
       */
      this.id = `igx-toast-${NEXT_ID$1++}`;
      /**
       * Sets/gets the `role` attribute.
       * If not set, `role` will have value `"alert"`.
       * ```html
       * <igx-toast [role] = "'notify'"></igx-toast>
       * ```
       * ```typescript
       * let toastRole = this.toast.role;
       * ```
       *
       * @memberof IgxToastComponent
       */
      this.role = 'alert';
      /**
       * @hidden
       */
      this.isVisibleChange = new EventEmitter();
      this._positionSettings = {
        horizontalDirection: HorizontalAlignment.Center,
        verticalDirection: VerticalAlignment.Bottom,
        openAnimation: useAnimation(fadeIn),
        closeAnimation: useAnimation(fadeOut)
      };
    }
    /**
     * Shows the toast.
     * If `autoHide` is enabled, the toast will hide after `displayTime` is over.
     *
     * ```typescript
     * this.toast.open();
     * ```
     */
    open(message, settings) {
      if (message !== undefined) {
        this.textMessage = message;
      }
      if (settings !== undefined) {
        this.positionSettings = settings;
      }
      this.strategy = new GlobalPositionStrategy(this.positionSettings);
      super.open();
    }
    /**
     * Opens or closes the toast, depending on its current state.
     *
     * ```typescript
     * this.toast.toggle();
     * ```
     */
    toggle() {
      if (this.collapsed || this.isClosing) {
        this.open();
      } else {
        this.close();
      }
    }
    /**
     * @hidden
     */
    ngOnInit() {
      this.opened.pipe(takeUntil(this.destroy$)).subscribe(() => {
        const openedEventArgs = {
          owner: this,
          id: this._overlayId
        };
        this.isVisibleChange.emit(openedEventArgs);
      });
      this.closed.pipe(takeUntil(this.destroy$)).subscribe(() => {
        const closedEventArgs = {
          owner: this,
          id: this._overlayId
        };
        this.isVisibleChange.emit(closedEventArgs);
      });
    }
    static {
      this.ɵfac = function IgxToastComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxToastComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxNavigationService, 8), i0.ɵɵdirectiveInject(IgxOverlayService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxToastComponent,
        selectors: [["igx-toast"]],
        hostVars: 4,
        hostBindings: function IgxToastComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("role", ctx.role);
            i0.ɵɵclassProp("igx-toast", ctx.cssClass);
          }
        },
        inputs: {
          id: "id",
          role: "role",
          positionSettings: "positionSettings"
        },
        outputs: {
          isVisibleChange: "isVisibleChange"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 1,
        template: function IgxToastComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.textMessage);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxToastComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The `<igx-select-item>` is a container intended for row items in
 * a `<igx-select>` container.
 */
let IgxSelectGroupComponent = /*#__PURE__*/(() => {
  class IgxSelectGroupComponent extends IgxDropDownGroupComponent {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxSelectGroupComponent_BaseFactory;
        return function IgxSelectGroupComponent_Factory(__ngFactoryType__) {
          return (ɵIgxSelectGroupComponent_BaseFactory || (ɵIgxSelectGroupComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxSelectGroupComponent)))(__ngFactoryType__ || IgxSelectGroupComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSelectGroupComponent,
        selectors: [["igx-select-item-group"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c309,
        decls: 3,
        vars: 2,
        consts: [[3, "id"]],
        template: function IgxSelectGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c308);
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(2);
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("id", ctx.labelId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxSelectGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Select directives collection for ease-of-use import in standalone components scenario */
const IGX_SELECT_DIRECTIVES = [IgxSelectComponent, IgxSelectItemComponent, IgxSelectGroupComponent, IgxSelectHeaderDirective, IgxSelectFooterDirective, IgxSelectToggleIconDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];

/**
 * Represents individual resizable/collapsible panes.
 *
 * @igxModule IgxSplitterModule
 *
 * @igxParent IgxSplitterComponent
 *
 * @igxKeywords pane
 *
 * @igxGroup presentation
 *
 * @remarks
 *  Users can control the resize behavior via the min and max size properties.
 */
let IgxSplitterPaneComponent = /*#__PURE__*/(() => {
  class IgxSplitterPaneComponent {
    /**
     * Gets/Sets the minimum allowed size of the current pane.
     *
     * @example
     * ```html
     * <igx-splitter>
     *  <igx-splitter-pane [minSize]='minSize'>...</igx-splitter-pane>
     * </igx-splitter>
     * ```
     */
    get minSize() {
      return this._minSize;
    }
    set minSize(value) {
      this._minSize = value;
      if (this.owner) {
        this.owner.panes.notifyOnChanges();
      }
    }
    /**
     * Gets/Set the maximum allowed size of the current pane.
     *
     * @example
     * ```html
     * <igx-splitter>
     *  <igx-splitter-pane [maxSize]='maxSize'>...</igx-splitter-pane>
     * </igx-splitter>
     * ```
     */
    get maxSize() {
      return this._maxSize;
    }
    set maxSize(value) {
      this._maxSize = value;
      if (this.owner) {
        this.owner.panes.notifyOnChanges();
      }
    }
    /**
     * Gets/Sets the size of the current pane.
     *  * @example
     * ```html
     * <igx-splitter>
     *  <igx-splitter-pane [size]='size'>...</igx-splitter-pane>
     * </igx-splitter>
     * ```
     */
    get size() {
      return this._size;
    }
    set size(value) {
      this._size = value;
      this.el.nativeElement.style.flex = this.flex;
    }
    /** @hidden @internal */
    get isPercentageSize() {
      return this.size === 'auto' || this.size.indexOf('%') !== -1;
    }
    /** @hidden @internal */
    get dragSize() {
      return this._dragSize;
    }
    set dragSize(val) {
      this._dragSize = val;
      this.el.nativeElement.style.flex = this.flex;
    }
    /**
     *
     * @hidden @internal
     * Gets the host native element.
     */
    get element() {
      return this.el.nativeElement;
    }
    /**
     * @hidden @internal
     * Gets the `flex` property of the current `IgxSplitterPaneComponent`.
     */
    get flex() {
      const size = this.dragSize || this.size;
      const grow = this.isPercentageSize && !this.dragSize ? 1 : 0;
      return `${grow} ${grow} ${size}`;
    }
    /**
     * Gets/Sets whether current pane is collapsed.
     *
     * @example
     * ```typescript
     * const isCollapsed = pane.collapsed;
     * ```
     */
    set collapsed(value) {
      if (this.owner) {
        // reset sibling sizes when pane collapse state changes.
        this._getSiblings().forEach(sibling => {
          sibling.size = 'auto';
          sibling.dragSize = null;
        });
      }
      this._collapsed = value;
      this.display = this._collapsed ? 'none' : 'flex';
      this.collapsedChange.emit(this._collapsed);
    }
    get collapsed() {
      return this._collapsed;
    }
    constructor(el) {
      this.el = el;
      /**
       * @hidden @internal
       * Gets/Sets the 'display' property of the current pane.
       */
      this.display = 'flex';
      /**
       * Gets/Sets whether pane is resizable.
       *
       * @example
       * ```html
       * <igx-splitter>
       *  <igx-splitter-pane [resizable]='false'>...</igx-splitter-pane>
       * </igx-splitter>
       * ```
       * @remarks
       * If pane is not resizable its related splitter bar cannot be dragged.
       */
      this.resizable = true;
      /**
       * Event fired when collapsed state of pane is changed.
       *
       * @example
       * ```html
       * <igx-splitter>
       *  <igx-splitter-pane (collapsedChange)='paneCollapsedChange($event)'>...</igx-splitter-pane>
       * </igx-splitter>
       * ```
       */
      this.collapsedChange = new EventEmitter();
      /**
       * @hidden @internal
       * Gets/Sets the `overflow`.
       */
      this.overflow = 'auto';
      /**
       * @hidden @internal
       * Get/Sets the `minWidth` properties of the current pane.
       */
      this.minWidth = '0';
      /**
       * @hidden @internal
       * Get/Sets the `maxWidth` properties of the current pane.
       */
      this.maxWidth = '100%';
      /**
       * @hidden @internal
       * Gets/Sets the `minHeight` properties of the current pane.
       */
      this.minHeight = '0';
      /**
       * @hidden @internal
       * Gets/Sets the `maxHeight` properties of the current `IgxSplitterPaneComponent`.
       */
      this.maxHeight = '100%';
      this._size = 'auto';
      this._collapsed = false;
    }
    /**
     * Toggles the collapsed state of the pane.
     *
     * @example
     * ```typescript
     * pane.toggle();
     * ```
     */
    toggle() {
      this.collapsed = !this.collapsed;
    }
    /** @hidden @internal */
    _getSiblings() {
      const panes = this.owner.panes.toArray();
      const index = panes.indexOf(this);
      const siblings = [];
      if (index !== 0) {
        siblings.push(panes[index - 1]);
      }
      if (index !== panes.length - 1) {
        siblings.push(panes[index + 1]);
      }
      return siblings;
    }
    static {
      this.ɵfac = function IgxSplitterPaneComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSplitterPaneComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSplitterPaneComponent,
        selectors: [["igx-splitter-pane"]],
        hostVars: 16,
        hostBindings: function IgxSplitterPaneComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", ctx.display)("order", ctx.order)("overflow", ctx.overflow)("min-width", ctx.minWidth)("max-width", ctx.maxWidth)("min-height", ctx.minHeight)("max-height", ctx.maxHeight)("flex", ctx.flex);
          }
        },
        inputs: {
          minSize: "minSize",
          maxSize: "maxSize",
          resizable: [2, "resizable", "resizable", booleanAttribute],
          size: "size",
          collapsed: [2, "collapsed", "collapsed", booleanAttribute]
        },
        outputs: {
          collapsedChange: "collapsedChange"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function IgxSplitterPaneComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return IgxSplitterPaneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * An enumeration that defines the `SplitterComponent` panes orientation.
 */
var SplitterType = /*#__PURE__*/function (SplitterType) {
  SplitterType[SplitterType["Horizontal"] = 0] = "Horizontal";
  SplitterType[SplitterType["Vertical"] = 1] = "Vertical";
  return SplitterType;
}(SplitterType || {});
/**
 * Provides a framework for a simple layout, splitting the view horizontally or vertically
 * into multiple smaller resizable and collapsible areas.
 *
 * @igxModule IgxSplitterModule
 *
 * @igxParent Layouts
 *
 * @igxTheme igx-splitter-theme
 *
 * @igxKeywords splitter panes layout
 *
 * @igxGroup presentation
 *
 * @example
 * ```html
 * <igx-splitter>
 *  <igx-splitter-pane>
 *      ...
 *  </igx-splitter-pane>
 *  <igx-splitter-pane>
 *      ...
 *  </igx-splitter-pane>
 * </igx-splitter>
 * ```
 */
let IgxSplitterComponent = /*#__PURE__*/(() => {
  class IgxSplitterComponent {
    /**
     * @hidden
     * @internal
     */
    get orientation() {
      return this.type === SplitterType.Horizontal ? 'horizontal' : 'vertical';
    }
    constructor(document, elementRef) {
      this.document = document;
      this.elementRef = elementRef;
      /**
      * @hidden
      * @internal
      */
      this.cssClass = 'igx-splitter';
      /**
       * @hidden @internal
       * Gets/Sets the `overflow` property of the current splitter.
       */
      this.overflow = 'hidden';
      /**
       * @hidden @internal
       * Sets/Gets the `display` property of the current splitter.
       */
      this.display = 'flex';
      /**
       * Event fired when resizing of panes starts.
       *
       * @example
       * ```html
       * <igx-splitter (resizeStart)='resizeStart($event)'>
       *  <igx-splitter-pane>...</igx-splitter-pane>
       * </igx-splitter>
       * ```
       */
      this.resizeStart = new EventEmitter();
      /**
       * Event fired when resizing of panes is in progress.
       *
       * @example
       * ```html
       * <igx-splitter (resizing)='resizing($event)'>
       *  <igx-splitter-pane>...</igx-splitter-pane>
       * </igx-splitter>
       * ```
       */
      this.resizing = new EventEmitter();
      /**
       * Event fired when resizing of panes ends.
       *
       * @example
       * ```html
       * <igx-splitter (resizeEnd)='resizeEnd($event)'>
       *  <igx-splitter-pane>...</igx-splitter-pane>
       * </igx-splitter>
       * ```
       */
      this.resizeEnd = new EventEmitter();
      this._type = SplitterType.Horizontal;
      /**
       * Sets the visibility of the handle and expanders in the splitter bar.
       * False by default
       *
       * @example
       * ```html
       * <igx-splitter [nonCollapsible]='true'>
       * </igx-splitter>
       * ```
       */
      this.nonCollapsible = false; // Input to toggle showing/hiding expanders
    }
    /**
     * Gets/Sets the splitter orientation.
     *
     * @example
     * ```html
     * <igx-splitter [type]="type">...</igx-splitter>
     * ```
     */
    get type() {
      return this._type;
    }
    set type(value) {
      this._type = value;
      this.resetPaneSizes();
      this.panes?.notifyOnChanges();
    }
    /**
     * @hidden @internal
     * Gets the `flex-direction` property of the current `SplitterComponent`.
     */
    get direction() {
      return this.type === SplitterType.Horizontal ? 'row' : 'column';
    }
    /** @hidden @internal */
    ngAfterContentInit() {
      this.initPanes();
      this.panes.changes.subscribe(() => {
        this.initPanes();
      });
    }
    /**
     * @hidden @internal
     * This method performs  initialization logic when the user starts dragging the splitter bar between each pair of panes.
     * @param pane - the main pane associated with the currently dragged bar.
     */
    onMoveStart(pane) {
      const panes = this.panes.toArray();
      this.pane = pane;
      this.sibling = panes[panes.indexOf(this.pane) + 1];
      const paneRect = this.pane.element.getBoundingClientRect();
      this.initialPaneSize = this.type === SplitterType.Horizontal ? paneRect.width : paneRect.height;
      const siblingRect = this.sibling.element.getBoundingClientRect();
      this.initialSiblingSize = this.type === SplitterType.Horizontal ? siblingRect.width : siblingRect.height;
      const args = {
        pane: this.pane,
        sibling: this.sibling
      };
      this.resizeStart.emit(args);
    }
    /**
     * @hidden @internal
     * This method performs calculations concerning the sizes of each pair of panes when the bar between them is dragged.
     * @param delta - The difference along the X (or Y) axis between the initial and the current point when dragging the bar.
     */
    onMoving(delta) {
      const [paneSize, siblingSize] = this.calcNewSizes(delta);
      this.pane.dragSize = paneSize + 'px';
      this.sibling.dragSize = siblingSize + 'px';
      const args = {
        pane: this.pane,
        sibling: this.sibling
      };
      this.resizing.emit(args);
    }
    onMoveEnd(delta) {
      const [paneSize, siblingSize] = this.calcNewSizes(delta);
      if (this.pane.isPercentageSize) {
        // handle % resizes
        const totalSize = this.getTotalSize();
        const percentPaneSize = paneSize / totalSize * 100;
        this.pane.size = percentPaneSize + '%';
      } else {
        // px resize
        this.pane.size = paneSize + 'px';
      }
      if (this.sibling.isPercentageSize) {
        // handle % resizes
        const totalSize = this.getTotalSize();
        const percentSiblingPaneSize = siblingSize / totalSize * 100;
        this.sibling.size = percentSiblingPaneSize + '%';
      } else {
        // px resize
        this.sibling.size = siblingSize + 'px';
      }
      this.pane.dragSize = null;
      this.sibling.dragSize = null;
      const args = {
        pane: this.pane,
        sibling: this.sibling
      };
      this.resizeEnd.emit(args);
    }
    /** @hidden @internal */
    getPaneSiblingsByOrder(order, barIndex) {
      const panes = this.panes.toArray();
      const prevPane = panes[order - barIndex - 1];
      const nextPane = panes[order - barIndex];
      const siblings = [prevPane, nextPane];
      return siblings;
    }
    getTotalSize() {
      const computed = this.document.defaultView.getComputedStyle(this.elementRef.nativeElement);
      const totalSize = this.type === SplitterType.Horizontal ? computed.getPropertyValue('width') : computed.getPropertyValue('height');
      return parseFloat(totalSize);
    }
    /**
     * @hidden @internal
     * This method inits panes with properties.
     */
    initPanes() {
      this.panes.forEach(pane => {
        pane.owner = this;
        if (this.type === SplitterType.Horizontal) {
          pane.minWidth = pane.minSize ?? '0';
          pane.maxWidth = pane.maxSize ?? '100%';
        } else {
          pane.minHeight = pane.minSize ?? '0';
          pane.maxHeight = pane.maxSize ?? '100%';
        }
      });
      this.assignFlexOrder();
      if (this.panes.filter(x => x.collapsed).length > 0) {
        // if any panes are collapsed, reset sizes.
        this.resetPaneSizes();
      }
    }
    /**
     * @hidden @internal
     * This method reset pane sizes.
     */
    resetPaneSizes() {
      if (this.panes) {
        // if type is changed runtime, should reset sizes.
        this.panes.forEach(x => {
          x.size = 'auto';
          x.minWidth = '0';
          x.maxWidth = '100%';
          x.minHeight = '0';
          x.maxHeight = '100%';
        });
      }
    }
    /**
     * @hidden @internal
     * This method assigns the order of each pane.
     */
    assignFlexOrder() {
      let k = 0;
      this.panes.forEach(pane => {
        pane.order = k;
        k += 2;
      });
    }
    /**
     * @hidden @internal
     * Calculates new sizes for the panes based on move delta and initial sizes
     */
    calcNewSizes(delta) {
      const min = parseInt(this.pane.minSize, 10) || 0;
      const minSibling = parseInt(this.sibling.minSize, 10) || 0;
      const max = parseInt(this.pane.maxSize, 10) || this.initialPaneSize + this.initialSiblingSize - minSibling;
      const maxSibling = parseInt(this.sibling.maxSize, 10) || this.initialPaneSize + this.initialSiblingSize - min;
      if (delta < 0) {
        const maxPossibleDelta = Math.min(max - this.initialPaneSize, this.initialSiblingSize - minSibling);
        delta = Math.min(maxPossibleDelta, Math.abs(delta)) * -1;
      } else {
        const maxPossibleDelta = Math.min(this.initialPaneSize - min, maxSibling - this.initialSiblingSize);
        delta = Math.min(maxPossibleDelta, Math.abs(delta));
      }
      return [this.initialPaneSize - delta, this.initialSiblingSize + delta];
    }
    static {
      this.ɵfac = function IgxSplitterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSplitterComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSplitterComponent,
        selectors: [["igx-splitter"]],
        contentQueries: function IgxSplitterComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxSplitterPaneComponent, 4, IgxSplitterPaneComponent);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panes = _t);
          }
        },
        hostVars: 9,
        hostBindings: function IgxSplitterComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-orientation", ctx.orientation);
            i0.ɵɵstyleProp("overflow", ctx.overflow)("display", ctx.display)("flex-direction", ctx.direction);
            i0.ɵɵclassProp("igx-splitter", ctx.cssClass);
          }
        },
        inputs: {
          type: "type",
          nonCollapsible: [2, "nonCollapsible", "nonCollapsible", booleanAttribute]
        },
        outputs: {
          resizeStart: "resizeStart",
          resizing: "resizing",
          resizeEnd: "resizeEnd"
        },
        ngContentSelectors: _c311,
        decls: 3,
        vars: 0,
        consts: [["role", "separator", 3, "order", "type", "pane", "siblings", "nonCollapsible"], ["role", "separator", 3, "moveStart", "moving", "movingEnd", "order", "type", "pane", "siblings", "nonCollapsible"]],
        template: function IgxSplitterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c310);
            i0.ɵɵprojection(0);
            i0.ɵɵrepeaterCreate(1, IgxSplitterComponent_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.panes);
          }
        },
        dependencies: () => [IgxSplitBarComponent],
        encapsulation: 2
      });
    }
  }
  return IgxSplitterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @hidden @internal
 * Represents the draggable bar that visually separates panes and allows for changing their sizes.
 */
let IgxSplitBarComponent = /*#__PURE__*/(() => {
  class IgxSplitBarComponent {
    constructor() {
      /**
       * Set css class to the host element.
       */
      this.cssClass = 'igx-splitter-bar-host';
      /**
       * Gets/Sets the orientation.
       */
      this.type = SplitterType.Horizontal;
      /**
       * An event that is emitted whenever we start dragging the current `SplitBarComponent`.
       */
      this.moveStart = new EventEmitter();
      /**
       * An event that is emitted while we are dragging the current `SplitBarComponent`.
       */
      this.moving = new EventEmitter();
      this.movingEnd = new EventEmitter();
      this.interactionKeys = new Set('right down left up arrowright arrowdown arrowleft arrowup'.split(' '));
    }
    /**
     * @hidden
     * @internal
     */
    get tabindex() {
      return this.resizeDisallowed ? null : 0;
    }
    /**
     * @hidden
     * @internal
     */
    get orientation() {
      return this.type === SplitterType.Horizontal ? 'horizontal' : 'vertical';
    }
    /**
     * @hidden
     * @internal
     */
    get cursor() {
      if (this.resizeDisallowed) {
        return '';
      }
      return this.type === SplitterType.Horizontal ? 'col-resize' : 'row-resize';
    }
    /**
     * @hidden @internal
     */
    get prevButtonHidden() {
      return this.siblings[0].collapsed && !this.siblings[1].collapsed;
    }
    /**
     * @hidden @internal
     */
    keyEvent(event) {
      const key = event.key.toLowerCase();
      const ctrl = event.ctrlKey;
      event.stopPropagation();
      if (this.interactionKeys.has(key)) {
        event.preventDefault();
      }
      switch (key) {
        case 'arrowup':
        case 'up':
          if (this.type === SplitterType.Vertical) {
            if (ctrl) {
              this.onCollapsing(false);
              break;
            }
            if (!this.resizeDisallowed) {
              event.preventDefault();
              this.moveStart.emit(this.pane);
              this.moving.emit(10);
            }
          }
          break;
        case 'arrowdown':
        case 'down':
          if (this.type === SplitterType.Vertical) {
            if (ctrl) {
              this.onCollapsing(true);
              break;
            }
            if (!this.resizeDisallowed) {
              event.preventDefault();
              this.moveStart.emit(this.pane);
              this.moving.emit(-10);
            }
          }
          break;
        case 'arrowleft':
        case 'left':
          if (this.type === SplitterType.Horizontal) {
            if (ctrl) {
              this.onCollapsing(false);
              break;
            }
            if (!this.resizeDisallowed) {
              event.preventDefault();
              this.moveStart.emit(this.pane);
              this.moving.emit(10);
            }
          }
          break;
        case 'arrowright':
        case 'right':
          if (this.type === SplitterType.Horizontal) {
            if (ctrl) {
              this.onCollapsing(true);
              break;
            }
            if (!this.resizeDisallowed) {
              event.preventDefault();
              this.moveStart.emit(this.pane);
              this.moving.emit(-10);
            }
          }
          break;
        default:
          break;
      }
    }
    /**
     * @hidden @internal
     */
    get dragDir() {
      return this.type === SplitterType.Horizontal ? DragDirection.VERTICAL : DragDirection.HORIZONTAL;
    }
    /**
     * @hidden @internal
     */
    get nextButtonHidden() {
      return this.siblings[1].collapsed && !this.siblings[0].collapsed;
    }
    /**
     * @hidden @internal
     */
    onDragStart(event) {
      if (this.resizeDisallowed) {
        event.cancel = true;
        return;
      }
      this.startPoint = this.type === SplitterType.Horizontal ? event.startX : event.startY;
      this.moveStart.emit(this.pane);
    }
    /**
     * @hidden @internal
     */
    onDragMove(event) {
      const isHorizontal = this.type === SplitterType.Horizontal;
      const curr = isHorizontal ? event.pageX : event.pageY;
      const delta = this.startPoint - curr;
      if (delta !== 0) {
        this.moving.emit(delta);
        event.cancel = true;
        event.owner.element.nativeElement.style.transform = '';
      }
    }
    onDragEnd(event) {
      const isHorizontal = this.type === SplitterType.Horizontal;
      const curr = isHorizontal ? event.pageX : event.pageY;
      const delta = this.startPoint - curr;
      if (delta !== 0) {
        this.movingEnd.emit(delta);
      }
    }
    get resizeDisallowed() {
      const relatedTabs = this.siblings;
      return !!relatedTabs.find(x => x.resizable === false || x.collapsed === true);
    }
    /**
     * @hidden @internal
     */
    onCollapsing(next) {
      const prevSibling = this.siblings[0];
      const nextSibling = this.siblings[1];
      let target;
      if (next) {
        // if next is clicked when prev pane is hidden, show prev pane, else hide next pane.
        target = prevSibling.collapsed ? prevSibling : nextSibling;
      } else {
        // if prev is clicked when next pane is hidden, show next pane, else hide prev pane.
        target = nextSibling.collapsed ? nextSibling : prevSibling;
      }
      target.toggle();
    }
    static {
      this.ɵfac = function IgxSplitBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSplitBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxSplitBarComponent,
        selectors: [["igx-splitter-bar"]],
        hostVars: 6,
        hostBindings: function IgxSplitBarComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxSplitBarComponent_keydown_HostBindingHandler($event) {
              return ctx.keyEvent($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.tabindex)("aria-orientation", ctx.orientation);
            i0.ɵɵstyleProp("order", ctx.order);
            i0.ɵɵclassProp("igx-splitter-bar-host", ctx.cssClass);
          }
        },
        inputs: {
          nonCollapsible: [2, "nonCollapsible", "nonCollapsible", booleanAttribute],
          type: "type",
          order: "order",
          pane: "pane",
          siblings: "siblings"
        },
        outputs: {
          moveStart: "moveStart",
          moving: "moving",
          movingEnd: "movingEnd"
        },
        decls: 4,
        vars: 10,
        consts: [["igxDrag", "", 1, "igx-splitter-bar", 3, "dragStart", "dragMove", "dragEnd", "ghost", "dragDirection"], ["igxDragIgnore", "", 1, "igx-splitter-bar__expander--start", 3, "click", "hidden"], [1, "igx-splitter-bar__handle"], ["igxDragIgnore", "", 1, "igx-splitter-bar__expander--end", 3, "click", "hidden"]],
        template: function IgxSplitBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("dragStart", function IgxSplitBarComponent_Template_div_dragStart_0_listener($event) {
              return ctx.onDragStart($event);
            })("dragMove", function IgxSplitBarComponent_Template_div_dragMove_0_listener($event) {
              return ctx.onDragMove($event);
            })("dragEnd", function IgxSplitBarComponent_Template_div_dragEnd_0_listener($event) {
              return ctx.onDragEnd($event);
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵlistener("click", function IgxSplitBarComponent_Template_div_click_1_listener() {
              return ctx.onCollapsing(false);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵlistener("click", function IgxSplitBarComponent_Template_div_click_3_listener() {
              return ctx.onCollapsing(true);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("cursor", ctx.cursor);
            i0.ɵɵclassProp("igx-splitter-bar--vertical", ctx.type === 0)("igx-splitter-bar--collapsible", !ctx.nonCollapsible);
            i0.ɵɵproperty("ghost", false)("dragDirection", ctx.dragDir);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.prevButtonHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.nextButtonHidden);
          }
        },
        dependencies: [IgxDragDirective, IgxDragIgnoreDirective],
        encapsulation: 2
      });
    }
  }
  return IgxSplitBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Splitter directives collection for ease-of-use import in standalone components scenario */
const IGX_SPLITTER_DIRECTIVES = [IgxSplitterComponent, IgxSplitterPaneComponent, IgxSplitBarComponent];

// Enums
const IgxStepperOrientation = {
  Horizontal: 'horizontal',
  Vertical: 'vertical'
};
const IgxStepType = {
  Indicator: 'indicator',
  Title: 'title',
  Full: 'full'
};
const IgxStepperTitlePosition = {
  Bottom: 'bottom',
  Top: 'top',
  End: 'end',
  Start: 'start'
};
const VerticalAnimationType = {
  Grow: 'grow',
  Fade: 'fade',
  None: 'none'
};
const HorizontalAnimationType = {
  ...CarouselAnimationType
};
// Token
const IGX_STEPPER_COMPONENT = /*@__PURE__*/new InjectionToken('IgxStepperToken');
const IGX_STEP_COMPONENT = /*@__PURE__*/new InjectionToken('IgxStepToken');

/** @hidden @internal */
let IgxStepperService = /*#__PURE__*/(() => {
  class IgxStepperService {
    constructor() {
      this.collapsingSteps = new Set();
      this.linearDisabledSteps = new Set();
      this.visitedSteps = new Set();
    }
    /**
     * Activates the step, fires the steps change event and plays animations.
     */
    expand(step) {
      if (this.activeStep === step) {
        return;
      }
      const cancel = this.emitActivatingEvent(step);
      if (cancel) {
        return;
      }
      this.collapsingSteps.delete(step);
      this.previousActiveStep = this.activeStep;
      this.activeStep = step;
      this.activeStep.activeChange.emit(true);
      this.collapsingSteps.add(this.previousActiveStep);
      this.visitedSteps.add(this.activeStep);
      if (this.stepper.orientation === IgxStepperOrientation.Vertical) {
        this.previousActiveStep.playCloseAnimation(this.previousActiveStep.contentContainer);
        this.activeStep.cdr.detectChanges();
        this.activeStep.playOpenAnimation(this.activeStep.contentContainer);
      } else {
        this.activeStep.cdr.detectChanges();
        this.stepper.playHorizontalAnimations();
      }
    }
    /**
     * Activates the step and fires the steps change event without playing animations.
     */
    expandThroughApi(step) {
      if (this.activeStep === step) {
        return;
      }
      this.collapsingSteps.clear();
      this.previousActiveStep = this.activeStep;
      this.activeStep = step;
      if (this.previousActiveStep) {
        this.previousActiveStep.tabIndex = -1;
      }
      this.activeStep.tabIndex = 0;
      this.visitedSteps.add(this.activeStep);
      this.activeStep.cdr.markForCheck();
      this.previousActiveStep?.cdr.markForCheck();
      this.activeStep.activeChange.emit(true);
      this.previousActiveStep?.activeChange.emit(false);
    }
    /**
     * Collapses the currently active step and fires the change event.
     */
    collapse(step) {
      if (this.activeStep === step) {
        return;
      }
      step.activeChange.emit(false);
      this.collapsingSteps.delete(step);
    }
    /**
     * Determines the steps that should be marked as visited based on the active step.
     */
    calculateVisitedSteps() {
      this.stepper.steps.forEach(step => {
        if (step.index <= this.activeStep.index) {
          this.visitedSteps.add(step);
        } else {
          this.visitedSteps.delete(step);
        }
      });
    }
    /**
     * Determines the steps that should be disabled in linear mode based on the validity of the active step.
     */
    calculateLinearDisabledSteps() {
      if (!this.activeStep) {
        return;
      }
      if (this.activeStep.isValid) {
        const firstRequiredIndex = this.getNextRequiredStep();
        if (firstRequiredIndex !== -1) {
          this.updateLinearDisabledSteps(firstRequiredIndex);
        } else {
          this.linearDisabledSteps.clear();
        }
      } else {
        this.stepper.steps.forEach(s => {
          if (s.index > this.activeStep.index) {
            this.linearDisabledSteps.add(s);
          }
        });
      }
    }
    emitActivatingEvent(step) {
      const args = {
        owner: this.stepper,
        newIndex: step.index,
        oldIndex: this.activeStep.index,
        cancel: false
      };
      this.stepper.activeStepChanging.emit(args);
      return args.cancel;
    }
    /**
     * Updates the linearDisabled steps from the current active step to the next required invalid step.
     *
     * @param toIndex the index of the last step that should be enabled.
     */
    updateLinearDisabledSteps(toIndex) {
      this.stepper.steps.forEach(s => {
        if (s.index > this.activeStep.index) {
          if (s.index <= toIndex) {
            this.linearDisabledSteps.delete(s);
          } else {
            this.linearDisabledSteps.add(s);
          }
        }
      });
    }
    getNextRequiredStep() {
      if (!this.activeStep) {
        return;
      }
      return this.stepper.steps.findIndex(s => s.index > this.activeStep.index && !s.optional && !s.disabled && !s.isValid);
    }
    static {
      this.ɵfac = function IgxStepperService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepperService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IgxStepperService,
        factory: IgxStepperService.ɵfac
      });
    }
  }
  return IgxStepperService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Allows a custom element to be added as an active step indicator.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <ng-template igxStepActiveIndicator>
 *          <igx-icon>edit</igx-icon>
 *       </ng-template>
 * </igx-stepper>
 */
let IgxStepActiveIndicatorDirective = /*#__PURE__*/(() => {
  class IgxStepActiveIndicatorDirective {
    static {
      this.ɵfac = function IgxStepActiveIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepActiveIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepActiveIndicatorDirective,
        selectors: [["", "igxStepActiveIndicator", ""]]
      });
    }
  }
  return IgxStepActiveIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as a complete step indicator.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <ng-template igxStepCompletedIndicator>
 *          <igx-icon>check</igx-icon>
 *       </ng-template>
 * </igx-stepper>
 */
let IgxStepCompletedIndicatorDirective = /*#__PURE__*/(() => {
  class IgxStepCompletedIndicatorDirective {
    static {
      this.ɵfac = function IgxStepCompletedIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepCompletedIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepCompletedIndicatorDirective,
        selectors: [["", "igxStepCompletedIndicator", ""]]
      });
    }
  }
  return IgxStepCompletedIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as an invalid step indicator.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <ng-template igxStepInvalidIndicator>
 *          <igx-icon>error</igx-icon>
 *       </ng-template>
 * </igx-stepper>
 */
let IgxStepInvalidIndicatorDirective = /*#__PURE__*/(() => {
  class IgxStepInvalidIndicatorDirective {
    static {
      this.ɵfac = function IgxStepInvalidIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepInvalidIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepInvalidIndicatorDirective,
        selectors: [["", "igxStepInvalidIndicator", ""]]
      });
    }
  }
  return IgxStepInvalidIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as a step indicator.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <igx-step>
 *         <igx-icon igxStepIndicator>home</igx-icon>
 *     </igx-step>
 * </igx-stepper>
 */
let IgxStepIndicatorDirective = /*#__PURE__*/(() => {
  class IgxStepIndicatorDirective {
    static {
      this.ɵfac = function IgxStepIndicatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepIndicatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepIndicatorDirective,
        selectors: [["", "igxStepIndicator", ""]]
      });
    }
  }
  return IgxStepIndicatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as a step title.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <igx-step>
 *         <p igxStepTitle>Home</p>
 *     </igx-step>
 * </igx-stepper>
 */
let IgxStepTitleDirective = /*#__PURE__*/(() => {
  class IgxStepTitleDirective {
    constructor() {
      this.defaultClass = true;
    }
    static {
      this.ɵfac = function IgxStepTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepTitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepTitleDirective,
        selectors: [["", "igxStepTitle", ""]],
        hostVars: 2,
        hostBindings: function IgxStepTitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-stepper__step-title", ctx.defaultClass);
          }
        }
      });
    }
  }
  return IgxStepTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as a step subtitle.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <igx-step>
 *         <p igxStepSubtitle>Home Subtitle</p>
 *     </igx-step>
 * </igx-stepper>
 */
let IgxStepSubtitleDirective = /*#__PURE__*/(() => {
  class IgxStepSubtitleDirective {
    constructor() {
      this.defaultClass = true;
    }
    static {
      this.ɵfac = function IgxStepSubtitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepSubtitleDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepSubtitleDirective,
        selectors: [["", "igxStepSubtitle", ""]],
        hostVars: 2,
        hostBindings: function IgxStepSubtitleDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("igx-stepper__step-subtitle", ctx.defaultClass);
          }
        }
      });
    }
  }
  return IgxStepSubtitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Allows a custom element to be added as a step content.
 *
 * @igxModule IgxStepperModule
 * @igxTheme igx-stepper-theme
 * @igxKeywords stepper
 * @igxGroup Layouts
 *
 * @example
 * <igx-stepper>
 *     <igx-step>
 *         <div igxStepContent>...</div>
 *     </igx-step>
 * </igx-stepper>
 */
let IgxStepContentDirective = /*#__PURE__*/(() => {
  class IgxStepContentDirective {
    get target() {
      return this.step;
    }
    get stepId() {
      return this.target.id;
    }
    get tabIndex() {
      if (this._tabIndex !== null) {
        return this._tabIndex;
      }
      return this.stepperService.activeStep === this.target ? 0 : -1;
    }
    set tabIndex(val) {
      this._tabIndex = val;
    }
    constructor(step, stepperService, elementRef) {
      this.step = step;
      this.stepperService = stepperService;
      this.elementRef = elementRef;
      this.defaultClass = true;
      this.role = 'tabpanel';
      this.id = this.target.id.replace('step', 'content');
      this._tabIndex = null;
    }
    static {
      this.ɵfac = function IgxStepContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepContentDirective)(i0.ɵɵdirectiveInject(IGX_STEP_COMPONENT), i0.ɵɵdirectiveInject(IgxStepperService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxStepContentDirective,
        selectors: [["", "igxStepContent", ""]],
        hostVars: 6,
        hostBindings: function IgxStepContentDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role)("aria-labelledby", ctx.stepId)("id", ctx.id)("tabindex", ctx.tabIndex);
            i0.ɵɵclassProp("igx-stepper__step-content", ctx.defaultClass);
          }
        },
        inputs: {
          id: "id",
          tabIndex: "tabIndex"
        }
      });
    }
  }
  return IgxStepContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NEXT_ID = 0;
/**
 * The IgxStepComponent is used within the `igx-stepper` element and it holds the content of each step.
 * It also supports custom indicators, title and subtitle.
 *
 * @igxModule IgxStepperModule
 *
 * @igxKeywords step
 *
 * @example
 * ```html
 *  <igx-stepper>
 *  ...
 *    <igx-step [active]="true" [completed]="true">
 *      ...
 *    </igx-step>
 *  ...
 *  </igx-stepper>
 * ```
 */
let IgxStepComponent = /*#__PURE__*/(() => {
  class IgxStepComponent extends ToggleAnimationPlayer {
    /**
     * Get/Set whether the step is interactable.
     *
     * ```html
     * <igx-stepper>
     * ...
     *     <igx-step [disabled]="true"></igx-step>
     * ...
     * </igx-stepper>
     * ```
     *
     * ```typescript
     * this.stepper.steps[1].disabled = true;
     * ```
     */
    set disabled(value) {
      this._disabled = value;
      if (this.stepper.linear) {
        this.stepperService.calculateLinearDisabledSteps();
      }
    }
    get disabled() {
      return this._disabled;
    }
    /**
     * Get/Set whether the step is valid.
     *```html
     * <igx-step [isValid]="form.form.valid">
     *      ...
     *      <div igxStepContent>
     *          <form #form="ngForm">
     *              ...
     *          </form>
     *      </div>
     * </igx-step>
     * ```
     */
    get isValid() {
      return this._valid;
    }
    set isValid(value) {
      this._valid = value;
      if (this.stepper.linear && this.index !== undefined) {
        this.stepperService.calculateLinearDisabledSteps();
      }
    }
    /**
     * Get/Set the active state of the step
     *
     * ```html
     * <igx-step [active]="true"></igx-step>
     * ```
     *
     * ```typescript
     * this.stepper.steps[1].active = true;
     * ```
     *
     * @param value: boolean
     */
    set active(value) {
      if (value) {
        this.stepperService.expandThroughApi(this);
      } else {
        this.stepperService.collapse(this);
      }
    }
    get active() {
      return this.stepperService.activeStep === this;
    }
    /** @hidden @internal */
    set tabIndex(value) {
      this._tabIndex = value;
    }
    get tabIndex() {
      return this._tabIndex;
    }
    /** @hidden @internal */
    get contentId() {
      return this.content?.id;
    }
    /** @hidden @internal */
    get generalDisabled() {
      return this.disabled || this.linearDisabled;
    }
    /** @hidden @internal */
    get titlePositionTop() {
      if (this.stepper.stepType !== IgxStepType.Full) {
        return 'igx-stepper__step--simple';
      }
      return `igx-stepper__step--${this.titlePosition}`;
    }
    /**
     * Get the step index inside of the stepper.
     *
     * ```typescript
     * const step = this.stepper.steps[1];
     * const stepIndex: number = step.index;
     * ```
     */
    get index() {
      return this._index;
    }
    /** @hidden @internal */
    get indicatorTemplate() {
      if (this.active && this.stepper.activeIndicatorTemplate) {
        return this.stepper.activeIndicatorTemplate;
      }
      if (!this.isValid && this.stepper.invalidIndicatorTemplate) {
        return this.stepper.invalidIndicatorTemplate;
      }
      if (this.completed && this.stepper.completedIndicatorTemplate) {
        return this.stepper.completedIndicatorTemplate;
      }
      if (this.indicator) {
        return this.customIndicatorTemplate;
      }
      return null;
    }
    /** @hidden @internal */
    get direction() {
      return this.stepperService.previousActiveStep && this.stepperService.previousActiveStep.index > this.index ? Direction.PREV : Direction.NEXT;
    }
    /** @hidden @internal */
    get isAccessible() {
      return !this.disabled && !this.linearDisabled;
    }
    /** @hidden @internal */
    get isHorizontal() {
      return this.stepper.orientation === IgxStepperOrientation.Horizontal;
    }
    /** @hidden @internal */
    get isTitleVisible() {
      return this.stepper.stepType !== IgxStepType.Indicator;
    }
    /** @hidden @internal */
    get isIndicatorVisible() {
      return this.stepper.stepType !== IgxStepType.Title;
    }
    /** @hidden @internal */
    get titlePosition() {
      return this.stepper.titlePosition ? this.stepper.titlePosition : this.stepper._defaultTitlePosition;
    }
    /** @hidden @internal */
    get linearDisabled() {
      return this.stepperService.linearDisabledSteps.has(this);
    }
    /** @hidden @internal */
    get collapsing() {
      return this.stepperService.collapsingSteps.has(this);
    }
    /** @hidden @internal */
    get animationSettings() {
      return this.stepper.verticalAnimationSettings;
    }
    /** @hidden @internal */
    get contentClasses() {
      if (this.isHorizontal) {
        return {
          'igx-stepper__body-content': true,
          'igx-stepper__body-content--active': this.active
        };
      } else {
        return 'igx-stepper__step-content';
      }
    }
    /** @hidden @internal */
    get stepHeaderClasses() {
      return {
        'igx-stepper__step--optional': this.optional,
        'igx-stepper__step-header--current': this.active,
        'igx-stepper__step-header--invalid': !this.isValid && this.stepperService.visitedSteps.has(this) && !this.active && this.isAccessible
      };
    }
    /** @hidden @internal */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(stepper, cdr, renderer, platform, stepperService, animationService, element, dir) {
      super(animationService);
      this.stepper = stepper;
      this.cdr = cdr;
      this.renderer = renderer;
      this.platform = platform;
      this.stepperService = stepperService;
      this.element = element;
      this.dir = dir;
      /**
       * Get/Set the `id` of the step component.
       * Default value is `"igx-step-0"`;
       * ```html
       * <igx-step id="my-first-step"></igx-step>
       * ```
       * ```typescript
       * const stepId = this.step.id;
       * ```
       */
      this.id = `igx-step-${NEXT_ID++}`;
      /**
       * Get/Set whether the step is completed.
       *
       * @remarks
       * When set to `true` the following separator is styled `solid`.
       *
       * ```html
       * <igx-stepper>
       * ...
       *     <igx-step [completed]="true"></igx-step>
       * ...
       * </igx-stepper>
       * ```
       *
       * ```typescript
       * this.stepper.steps[1].completed = true;
       * ```
       */
      this.completed = false;
      /**
       * Get/Set whether the step is optional.
       *
       * @remarks
       * Optional steps validity does not affect the default behavior when the stepper is in linear mode i.e.
       * if optional step is invalid the user could still move to the next step.
       *
       * ```html
       * <igx-step [optional]="true"></igx-step>
       * ```
       * ```typescript
       * this.stepper.steps[1].optional = true;
       * ```
       */
      this.optional = false;
      /** @hidden @internal **/
      this.role = 'tab';
      /** @hidden @internal */
      this.cssClass = true;
      /**
       * Emitted when the step's `active` property changes. Can be used for two-way binding.
       *
       * ```html
       * <igx-step [(active)]="this.isActive">
       * </igx-step>
       * ```
       *
       * ```typescript
       * const step: IgxStepComponent = this.stepper.step[0];
       * step.activeChange.subscribe((e: boolean) => console.log("Step active state change to ", e))
       * ```
       */
      this.activeChange = new EventEmitter();
      this._tabIndex = -1;
      this._valid = true;
      this._focused = false;
      this._disabled = false;
    }
    /** @hidden @internal */
    onFocus() {
      this._focused = true;
      this.stepperService.focusedStep = this;
      if (this.stepperService.focusedStep !== this.stepperService.activeStep) {
        this.stepperService.activeStep.tabIndex = -1;
      }
    }
    /** @hidden @internal */
    onBlur() {
      this._focused = false;
      this.stepperService.activeStep.tabIndex = 0;
    }
    /** @hidden @internal */
    handleKeydown(event) {
      if (!this._focused) {
        return;
      }
      const key = event.key;
      if (this.stepper.orientation === IgxStepperOrientation.Horizontal) {
        if (key === this.platform.KEYMAP.ARROW_UP || key === this.platform.KEYMAP.ARROW_DOWN) {
          return;
        }
      }
      if (!(this.platform.isNavigationKey(key) || this.platform.isActivationKey(event))) {
        return;
      }
      event.preventDefault();
      this.handleNavigation(key);
    }
    /** @hidden @internal */
    ngAfterViewInit() {
      this.openAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.stepperService.activeStep === this) {
          this.stepper.activeStepChanged.emit({
            owner: this.stepper,
            index: this.index
          });
        }
      });
      this.closeAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.stepperService.collapse(this);
        this.cdr.markForCheck();
      });
    }
    /** @hidden @internal */
    onPointerDown(event) {
      event.stopPropagation();
      if (this.isHorizontal) {
        this.changeHorizontalActiveStep();
      } else {
        this.changeVerticalActiveStep();
      }
    }
    /** @hidden @internal */
    handleNavigation(key) {
      switch (key) {
        case this.platform.KEYMAP.HOME:
          this.stepper.steps.filter(s => s.isAccessible)[0]?.nativeElement.focus();
          break;
        case this.platform.KEYMAP.END:
          this.stepper.steps.filter(s => s.isAccessible).pop()?.nativeElement.focus();
          break;
        case this.platform.KEYMAP.ARROW_UP:
          this.previousStep?.nativeElement.focus();
          break;
        case this.platform.KEYMAP.ARROW_LEFT:
          if (this.dir.rtl && this.stepper.orientation === IgxStepperOrientation.Horizontal) {
            this.nextStep?.nativeElement.focus();
          } else {
            this.previousStep?.nativeElement.focus();
          }
          break;
        case this.platform.KEYMAP.ARROW_DOWN:
          this.nextStep?.nativeElement.focus();
          break;
        case this.platform.KEYMAP.ARROW_RIGHT:
          if (this.dir.rtl && this.stepper.orientation === IgxStepperOrientation.Horizontal) {
            this.previousStep?.nativeElement.focus();
          } else {
            this.nextStep?.nativeElement.focus();
          }
          break;
        case this.platform.KEYMAP.SPACE:
        case this.platform.KEYMAP.ENTER:
          if (this.isHorizontal) {
            this.changeHorizontalActiveStep();
          } else {
            this.changeVerticalActiveStep();
          }
          break;
        default:
          return;
      }
    }
    /** @hidden @internal */
    changeHorizontalActiveStep() {
      if (this.stepper.animationType === HorizontalAnimationType.none && this.stepperService.activeStep !== this) {
        const argsCanceled = this.stepperService.emitActivatingEvent(this);
        if (argsCanceled) {
          return;
        }
        this.active = true;
        this.stepper.activeStepChanged.emit({
          owner: this.stepper,
          index: this.index
        });
        return;
      }
      this.stepperService.expand(this);
      if (this.stepper.animationType === HorizontalAnimationType.fade) {
        if (this.stepperService.collapsingSteps.has(this.stepperService.previousActiveStep)) {
          this.stepperService.previousActiveStep.active = false;
        }
      }
    }
    get nextStep() {
      const focusedStep = this.stepperService.focusedStep;
      if (focusedStep) {
        if (focusedStep.index === this.stepper.steps.length - 1) {
          return this.stepper.steps.find(s => s.isAccessible);
        }
        const nextAccessible = this.stepper.steps.find((s, i) => i > focusedStep.index && s.isAccessible);
        return nextAccessible ? nextAccessible : this.stepper.steps.find(s => s.isAccessible);
      }
      return null;
    }
    get previousStep() {
      const focusedStep = this.stepperService.focusedStep;
      if (focusedStep) {
        if (focusedStep.index === 0) {
          return this.stepper.steps.filter(s => s.isAccessible).pop();
        }
        let prevStep;
        for (let i = focusedStep.index - 1; i >= 0; i--) {
          const step = this.stepper.steps[i];
          if (step.isAccessible) {
            prevStep = step;
            break;
          }
        }
        return prevStep ? prevStep : this.stepper.steps.filter(s => s.isAccessible).pop();
      }
      return null;
    }
    changeVerticalActiveStep() {
      this.stepperService.expand(this);
      if (!this.animationSettings.closeAnimation) {
        this.stepperService.previousActiveStep?.openAnimationPlayer?.finish();
      }
      if (!this.animationSettings.openAnimation) {
        this.stepperService.activeStep.closeAnimationPlayer?.finish();
      }
    }
    static {
      this.ɵfac = function IgxStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepComponent)(i0.ɵɵdirectiveInject(IGX_STEPPER_COMPONENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(IgxStepperService), i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(IgxDirectionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxStepComponent,
        selectors: [["igx-step"]],
        contentQueries: function IgxStepComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxStepIndicatorDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxStepContentDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indicator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        viewQuery: function IgxStepComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c312, 7);
            i0.ɵɵviewQuery(_c313, 7);
            i0.ɵɵviewQuery(_c314, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentContainer = _t.first);
          }
        },
        hostVars: 13,
        hostBindings: function IgxStepComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function IgxStepComponent_focus_HostBindingHandler() {
              return ctx.onFocus();
            })("blur", function IgxStepComponent_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("keydown", function IgxStepComponent_keydown_HostBindingHandler($event) {
              return ctx.handleKeydown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("aria-selected", ctx.active)("tabindex", ctx.tabIndex)("role", ctx.role)("aria-controls", ctx.contentId);
            i0.ɵɵclassMap(ctx.titlePositionTop);
            i0.ɵɵclassProp("igx-stepper__step--completed", ctx.completed)("igx-stepper__step", ctx.cssClass)("igx-stepper__step--disabled", ctx.generalDisabled);
          }
        },
        inputs: {
          id: "id",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          completed: [2, "completed", "completed", booleanAttribute],
          isValid: [2, "isValid", "isValid", booleanAttribute],
          optional: [2, "optional", "optional", booleanAttribute],
          active: [2, "active", "active", booleanAttribute],
          tabIndex: "tabIndex"
        },
        outputs: {
          activeChange: "activeChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IGX_STEP_COMPONENT,
          useExisting: IgxStepComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c316,
        decls: 13,
        vars: 4,
        consts: [["defaultTitle", ""], ["contentTemplate", ""], ["defaultIndicator", ""], ["customIndicator", ""], ["contentContainer", ""], ["igxRipple", "", 1, "igx-stepper__step-header", 3, "keydown", "click", "ngClass"], [1, "igx-stepper__step-indicator"], [1, "igx-stepper__step-title-wrapper"], [4, "ngTemplateOutlet"], [1, "igx-stepper__step-content-wrapper"], [3, "ngClass"]],
        template: function IgxStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c315);
            i0.ɵɵtemplate(0, IgxStepComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, IgxStepComponent_ng_template_2_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, IgxStepComponent_ng_template_4_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, IgxStepComponent_ng_template_6_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(8, "div", 5);
            i0.ɵɵlistener("keydown", function IgxStepComponent_Template_div_keydown_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleKeydown($event));
            })("click", function IgxStepComponent_Template_div_click_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPointerDown($event));
            });
            i0.ɵɵtemplate(9, IgxStepComponent_Conditional_9_Template, 2, 1, "div", 6);
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵtemplate(11, IgxStepComponent_ng_container_11_Template, 1, 0, "ng-container", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, IgxStepComponent_Conditional_12_Template, 2, 1, "div", 9);
          }
          if (rf & 2) {
            const defaultTitle_r5 = i0.ɵɵreference(1);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngClass", ctx.stepHeaderClasses);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isIndicatorVisible ? 9 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", defaultTitle_r5);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isHorizontal ? 12 : -1);
          }
        },
        dependencies: [NgClass, IgxRippleDirective, NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: common interface between IgxCarouselComponentBase and ToggleAnimationPlayer?
/**
 * IgxStepper provides a wizard-like workflow by dividing content into logical steps.
 *
 * @igxModule IgxStepperModule
 *
 * @igxKeywords stepper
 *
 * @igxGroup Layouts
 *
 * @remarks
 * The Ignite UI for Angular Stepper component allows the user to navigate between multiple steps.
 * It supports horizontal and vertical orientation as well as keyboard navigation and provides API methods to control the active step.
 * The component offers keyboard navigation and API to control the active step.
 *
 * @example
 * ```html
 * <igx-stepper>
 *  <igx-step [active]="true">
 *      <igx-icon igxStepIndicator>home</igx-icon>
 *      <p igxStepTitle>Home</p>
 *      <div igxStepContent>
 *         ...
 *      </div>
 *  </igx-step>
 *  <igx-step [optional]="true">
 *      <div igxStepContent>
 *          ...
 *      </div>
 *  </igx-step>
 *  <igx-step>
 *      <div igxStepContent>
 *          ...
 *      </div>
 *  </igx-step>
 * </igx-stepper>
 * ```
 */
let IgxStepperComponent = /*#__PURE__*/(() => {
  class IgxStepperComponent extends IgxCarouselComponentBase {
    /**
     * Get/Set the animation type of the stepper when the orientation direction is vertical.
     *
     * @remarks
     * Default value is `grow`. Other possible values are `fade` and `none`.
     *
     * ```html
     * <igx-stepper verticalAnimationType="none">
     * <igx-stepper>
     * ```
     */
    get verticalAnimationType() {
      return this._verticalAnimationType;
    }
    set verticalAnimationType(value) {
      // TODO: activeChange event is not emitted for the collapsing steps (loop through collapsing steps and emit)
      this.stepperService.collapsingSteps.clear();
      this._verticalAnimationType = value;
      switch (value) {
        case 'grow':
          this.verticalAnimationSettings = this.updateVerticalAnimationSettings(growVerIn, growVerOut);
          break;
        case 'fade':
          this.verticalAnimationSettings = this.updateVerticalAnimationSettings(fadeIn, null);
          break;
        case 'none':
          this.verticalAnimationSettings = this.updateVerticalAnimationSettings(null, null);
          break;
      }
    }
    /**
     * Get/Set the animation type of the stepper when the orientation direction is horizontal.
     *
     * @remarks
     * Default value is `grow`. Other possible values are `fade` and `none`.
     *
     * ```html
     * <igx-stepper animationType="none">
     * <igx-stepper>
     * ```
     */
    get horizontalAnimationType() {
      return this.animationType;
    }
    set horizontalAnimationType(value) {
      // TODO: activeChange event is not emitted for the collapsing steps (loop through collapsing steps and emit)
      this.stepperService.collapsingSteps.clear();
      this.animationType = value;
    }
    /**
     * Get/Set the animation duration.
     * ```html
     * <igx-stepper [animationDuration]="500">
     * <igx-stepper>
     * ```
     */
    get animationDuration() {
      return this.defaultAnimationDuration;
    }
    set animationDuration(value) {
      if (value && value > 0) {
        this.defaultAnimationDuration = value;
        return;
      }
      this.defaultAnimationDuration = this._defaultAnimationDuration;
    }
    /**
     * Get/Set whether the stepper is linear.
     *
     * @remarks
     * If the stepper is in linear mode and if the active step is valid only then the user is able to move forward.
     *
     * ```html
     * <igx-stepper [linear]="true"></igx-stepper>
     * ```
     */
    get linear() {
      return this._linear;
    }
    set linear(value) {
      this._linear = value;
      if (this._linear && this.steps.length > 0) {
        // when the stepper is in linear mode we should calculate which steps should be disabled
        // and which are visited i.e. their validity should be correctly displayed.
        this.stepperService.calculateVisitedSteps();
        this.stepperService.calculateLinearDisabledSteps();
      } else {
        this.stepperService.linearDisabledSteps.clear();
      }
    }
    /**
     * Get/Set the stepper orientation.
     *
     * ```typescript
     * this.stepper.orientation = IgxStepperOrientation.Vertical;
     * ```
     */
    get orientation() {
      return this._orientation;
    }
    set orientation(value) {
      if (this._orientation === value) {
        return;
      }
      // TODO: activeChange event is not emitted for the collapsing steps
      this.stepperService.collapsingSteps.clear();
      this._orientation = value;
      this._defaultTitlePosition = this._orientation === IgxStepperOrientation.Horizontal ? IgxStepperTitlePosition.Bottom : IgxStepperTitlePosition.End;
    }
    /** @hidden @internal **/
    get directionClass() {
      return this.orientation === IgxStepperOrientation.Horizontal;
    }
    /**
     * Get all steps.
     *
     * ```typescript
     * const steps: IgxStepComponent[] = this.stepper.steps;
     * ```
     */
    get steps() {
      return this._steps?.toArray() || [];
    }
    /** @hidden @internal */
    get nativeElement() {
      return this.element.nativeElement;
    }
    constructor(cdr, animationService, stepperService, element) {
      super(animationService, cdr);
      this.stepperService = stepperService;
      this.element = element;
      /**
       * Get/Set the type of the steps.
       *
       * ```typescript
       * this.stepper.stepType = IgxStepType.Indicator;
       * ```
       */
      this.stepType = IgxStepType.Full;
      /**
       * Get/Set whether the content is displayed above the steps.
       *
       * @remarks
       * Default value is `false` and the content is below the steps.
       *
       * ```typescript
       * this.stepper.contentTop = true;
       * ```
       */
      this.contentTop = false;
      /**
       * Get/Set the position of the steps title.
       *
       * @remarks
       * The default value when the stepper is horizontally orientated is `bottom`.
       * In vertical layout the default title position is `end`.
       *
       * ```typescript
       * this.stepper.titlePosition = IgxStepperTitlePosition.Top;
       * ```
       */
      this.titlePosition = null;
      /** @hidden @internal **/
      this.cssClass = 'igx-stepper';
      /** @hidden @internal **/
      this.role = 'tablist';
      /**
       * Emitted when the stepper's active step is changing.
       *
       *```html
       * <igx-stepper (activeStepChanging)="handleActiveStepChanging($event)">
       * </igx-stepper>
       * ```
       *
       *```typescript
       * public handleActiveStepChanging(event: IStepChangingEventArgs) {
       *  if (event.newIndex < event.oldIndex) {
       *      event.cancel = true;
       *  }
       * }
       *```
       */
      this.activeStepChanging = new EventEmitter();
      /**
       * Emitted when the active step is changed.
       *
       * @example
       * ```
       * <igx-stepper (activeStepChanged)="handleActiveStepChanged($event)"></igx-stepper>
       * ```
       */
      this.activeStepChanged = new EventEmitter();
      /** @hidden @internal */
      this.verticalAnimationSettings = {
        openAnimation: growVerIn,
        closeAnimation: growVerOut
      };
      /** @hidden @internal */
      this._defaultTitlePosition = IgxStepperTitlePosition.Bottom;
      this.destroy$ = new Subject();
      this._orientation = IgxStepperOrientation.Horizontal;
      this._verticalAnimationType = VerticalAnimationType.Grow;
      this._linear = false;
      this._defaultAnimationDuration = 350;
      this.stepperService.stepper = this;
    }
    /** @hidden @internal */
    ngOnChanges(changes) {
      if (changes['animationDuration']) {
        this.verticalAnimationType = this._verticalAnimationType;
      }
    }
    /** @hidden @internal */
    ngOnInit() {
      this.enterAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.activeStepChanged.emit({
          owner: this,
          index: this.stepperService.activeStep.index
        });
      });
      this.leaveAnimationDone.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.stepperService.collapsingSteps.size === 1) {
          this.stepperService.collapse(this.stepperService.previousActiveStep);
        } else {
          Array.from(this.stepperService.collapsingSteps).slice(0, this.stepperService.collapsingSteps.size - 1).forEach(step => this.stepperService.collapse(step));
        }
      });
    }
    /** @hidden @internal */
    ngAfterContentInit() {
      let activeStep;
      this.steps.forEach((step, index) => {
        this.updateStepAria(step, index);
        if (!activeStep && step.active) {
          activeStep = step;
        }
      });
      if (!activeStep) {
        this.activateFirstStep(true);
      }
      if (this.linear) {
        this.stepperService.calculateLinearDisabledSteps();
      }
      this.handleStepChanges();
    }
    /** @hidden @internal */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Activates the step at a given index.
     *
     *```typescript
     * this.stepper.navigateTo(1);
     *```
     */
    navigateTo(index) {
      const step = this.steps[index];
      if (!step || this.stepperService.activeStep === step) {
        return;
      }
      this.activateStep(step);
    }
    /**
     * Activates the next enabled step.
     *
     *```typescript
     * this.stepper.next();
     *```
     */
    next() {
      this.moveToNextStep();
    }
    /**
     * Activates the previous enabled step.
     *
     *```typescript
     * this.stepper.prev();
     *```
     */
    prev() {
      this.moveToNextStep(false);
    }
    /**
     * Resets the stepper to its initial state i.e. activates the first step.
     *
     * @remarks
     * The steps' content will not be automatically reset.
     *```typescript
     * this.stepper.reset();
     *```
     */
    reset() {
      this.stepperService.visitedSteps.clear();
      const activeStep = this.steps.find(s => !s.disabled);
      if (activeStep) {
        this.activateStep(activeStep);
      }
    }
    /** @hidden @internal */
    playHorizontalAnimations() {
      this.previousItem = this.stepperService.previousActiveStep;
      this.currentItem = this.stepperService.activeStep;
      this.triggerAnimations();
    }
    getPreviousElement() {
      return this.stepperService.previousActiveStep?.contentContainer.nativeElement;
    }
    getCurrentElement() {
      return this.stepperService.activeStep.contentContainer.nativeElement;
    }
    updateVerticalAnimationSettings(openAnimation, closeAnimation) {
      const customCloseAnimation = useAnimation(closeAnimation, {
        params: {
          duration: this.animationDuration + 'ms'
        }
      });
      const customOpenAnimation = useAnimation(openAnimation, {
        params: {
          duration: this.animationDuration + 'ms'
        }
      });
      return {
        openAnimation: openAnimation ? customOpenAnimation : null,
        closeAnimation: closeAnimation ? customCloseAnimation : null
      };
    }
    updateStepAria(step, index) {
      step._index = index;
      step.renderer.setAttribute(step.nativeElement, 'aria-setsize', this.steps.length.toString());
      step.renderer.setAttribute(step.nativeElement, 'aria-posinset', (index + 1).toString());
    }
    handleStepChanges() {
      this._steps.changes.pipe(takeUntil(this.destroy$)).subscribe(steps => {
        Promise.resolve().then(() => {
          steps.forEach((step, index) => {
            this.updateStepAria(step, index);
          });
          // when the active step is removed
          const hasActiveStep = this.steps.find(s => s === this.stepperService.activeStep);
          if (!hasActiveStep) {
            this.activateFirstStep();
          }
          // TO DO: mark step added before the active as visited?
          if (this.linear) {
            this.stepperService.calculateLinearDisabledSteps();
          }
        });
      });
    }
    activateFirstStep(activateInitially = false) {
      const firstEnabledStep = this.steps.find(s => !s.disabled);
      if (firstEnabledStep) {
        firstEnabledStep.active = true;
        if (activateInitially) {
          firstEnabledStep.activeChange.emit(true);
          this.activeStepChanged.emit({
            owner: this,
            index: firstEnabledStep.index
          });
        }
      }
    }
    activateStep(step) {
      if (this.orientation === IgxStepperOrientation.Horizontal) {
        step.changeHorizontalActiveStep();
      } else {
        this.stepperService.expand(step);
      }
    }
    moveToNextStep(next = true) {
      let steps = this.steps;
      let activeStepIndex = this.stepperService.activeStep.index;
      if (!next) {
        steps = this.steps.reverse();
        activeStepIndex = steps.findIndex(s => s === this.stepperService.activeStep);
      }
      const nextStep = steps.find((s, i) => i > activeStepIndex && s.isAccessible);
      if (nextStep) {
        this.activateStep(nextStep);
      }
    }
    static {
      this.ɵfac = function IgxStepperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepperComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxAngularAnimationService), i0.ɵɵdirectiveInject(IgxStepperService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxStepperComponent,
        selectors: [["igx-stepper"]],
        contentQueries: function IgxStepperComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxStepInvalidIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxStepCompletedIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxStepActiveIndicatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxStepComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invalidIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.completedIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.activeIndicatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._steps = _t);
          }
        },
        hostVars: 6,
        hostBindings: function IgxStepperComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-orientation", ctx.orientation)("role", ctx.role);
            i0.ɵɵclassProp("igx-stepper", ctx.cssClass)("igx-stepper--horizontal", ctx.directionClass);
          }
        },
        inputs: {
          verticalAnimationType: "verticalAnimationType",
          horizontalAnimationType: "horizontalAnimationType",
          animationDuration: "animationDuration",
          linear: [2, "linear", "linear", booleanAttribute],
          orientation: "orientation",
          stepType: "stepType",
          contentTop: [2, "contentTop", "contentTop", booleanAttribute],
          titlePosition: "titlePosition"
        },
        outputs: {
          activeStepChanging: "activeStepChanging",
          activeStepChanged: "activeStepChanged"
        },
        features: [i0.ɵɵProvidersFeature([IgxStepperService, {
          provide: IGX_STEPPER_COMPONENT,
          useExisting: IgxStepperComponent
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c318,
        decls: 5,
        vars: 3,
        consts: [["stepTemplate", ""], [1, "igx-stepper__header"], [1, "igx-stepper__body"], [4, "ngTemplateOutlet"]],
        template: function IgxStepperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c317);
            i0.ɵɵtemplate(0, IgxStepperComponent_Conditional_0_Template, 2, 1, "div", 1)(1, IgxStepperComponent_Conditional_1_Template, 3, 0, "div", 2)(2, IgxStepperComponent_Conditional_2_Template, 2, 1, "div", 1)(3, IgxStepperComponent_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.contentTop || ctx.orientation !== "horizontal" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.orientation === "horizontal" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.contentTop && ctx.orientation === "horizontal" ? 2 : -1);
          }
        },
        dependencies: [NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return IgxStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Stepper directives collection for ease-of-use import in standalone components scenario */
const IGX_STEPPER_DIRECTIVES = [IgxStepComponent, IgxStepperComponent, IgxStepTitleDirective, IgxStepSubtitleDirective, IgxStepIndicatorDirective, IgxStepContentDirective, IgxStepActiveIndicatorDirective, IgxStepCompletedIndicatorDirective, IgxStepInvalidIndicatorDirective];

/** @hidden @internal */
let DateRangePickerFormatPipe = /*#__PURE__*/(() => {
  class DateRangePickerFormatPipe {
    transform(values, appliedFormat, locale, formatter) {
      if (!values || !values.start && !values.end) {
        return '';
      }
      if (formatter) {
        return formatter(values);
      }
      let {
        start,
        end
      } = values;
      if (!isDate(start)) {
        start = DateTimeUtil.parseIsoDate(start);
      }
      if (!isDate(end)) {
        end = DateTimeUtil.parseIsoDate(end);
      }
      const startDate = appliedFormat ? DateTimeUtil.formatDate(start, appliedFormat, locale || 'en') : start?.toLocaleDateString();
      const endDate = appliedFormat ? DateTimeUtil.formatDate(end, appliedFormat, locale || 'en') : end?.toLocaleDateString();
      let formatted;
      if (start) {
        formatted = `${startDate} - `;
        if (end) {
          formatted += endDate;
        }
      }
      return formatted ? formatted : '';
    }
    static {
      this.ɵfac = function DateRangePickerFormatPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DateRangePickerFormatPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dateRange",
        type: DateRangePickerFormatPipe,
        pure: true
      });
    }
  }
  return DateRangePickerFormatPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** @hidden @internal */
let IgxDateRangeInputsBaseComponent = /*#__PURE__*/(() => {
  class IgxDateRangeInputsBaseComponent extends IgxInputGroupComponent {
    /** @hidden @internal */
    get nativeElement() {
      return this.element.nativeElement;
    }
    /** @hidden @internal */
    setFocus() {
      this.input.focus();
    }
    /** @hidden @internal */
    updateInputValue(value) {
      if (this.ngControl) {
        this.ngControl.control.setValue(value);
      } else {
        this.dateTimeEditor.value = value;
      }
    }
    /** @hidden @internal */
    updateInputValidity(state) {
      this.inputDirective.valid = state;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxDateRangeInputsBaseComponent_BaseFactory;
        return function IgxDateRangeInputsBaseComponent_Factory(__ngFactoryType__) {
          return (ɵIgxDateRangeInputsBaseComponent_BaseFactory || (ɵIgxDateRangeInputsBaseComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxDateRangeInputsBaseComponent)))(__ngFactoryType__ || IgxDateRangeInputsBaseComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDateRangeInputsBaseComponent,
        selectors: [["igx-date-range-base"]],
        contentQueries: function IgxDateRangeInputsBaseComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxDateTimeEditorDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxInputDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, NgControl, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateTimeEditor = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputDirective = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngControl = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxInputGroupBase,
          useExisting: IgxDateRangeInputsBaseComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function IgxDateRangeInputsBaseComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return IgxDateRangeInputsBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the start input for a date range picker
 *
 * @igxModule IgxDateRangePickerModule
 *
 * @igxTheme igx-input-group-theme, igx-calendar-theme, igx-date-range-picker-theme
 *
 * @igxKeywords date, range, date range, date picker
 *
 * @igxGroup scheduling
 *
 * @remarks
 * When templating, start input has to be templated separately
 *
 * @example
 * ```html
 * <igx-date-range-picker mode="dropdown">
 *      <igx-date-range-start>
 *          <input igxInput igxDateTimeEditor type="text">
 *      </igx-date-range-start>
 *      ...
 * </igx-date-range-picker>
 * ```
 */
let IgxDateRangeStartComponent = /*#__PURE__*/(() => {
  class IgxDateRangeStartComponent extends IgxDateRangeInputsBaseComponent {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxDateRangeStartComponent_BaseFactory;
        return function IgxDateRangeStartComponent_Factory(__ngFactoryType__) {
          return (ɵIgxDateRangeStartComponent_BaseFactory || (ɵIgxDateRangeStartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxDateRangeStartComponent)))(__ngFactoryType__ || IgxDateRangeStartComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDateRangeStartComponent,
        selectors: [["igx-date-range-start"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxInputGroupBase,
          useExisting: IgxDateRangeStartComponent
        }, {
          provide: IgxDateRangeInputsBaseComponent,
          useExisting: IgxDateRangeStartComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 26,
        vars: 1,
        consts: [["label", ""], ["input", ""], ["prefix", ""], ["uploadButton", ""], ["files", ""], ["clear", ""], ["suffix", ""], ["materialBundle", ""], ["fluentBundle", ""], ["bootstrapBundle", ""], ["bundle", ""], [1, "igx-input-group__wrapper"], [1, "igx-input-group__hint", 3, "click"], [4, "ngTemplateOutlet"], [1, "igx-input-group__upload-button"], ["igxButton", "contained", "type", "button", 3, "click", "disabled", "ngClass"], [1, "igx-input-group__file-input", 3, "title"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon", 3, "click", "keydown.Enter"], ["family", "default", "name", "input_clear"], [1, "igx-input-group__bundle"], [1, "igx-input-group__bundle-start"], [1, "igx-input-group__notch"], [1, "igx-input-group__bundle-main"], [1, "igx-input-group__filler"], [1, "igx-input-group__bundle-end"], [1, "igx-input-group__line"]],
        template: function IgxDateRangeStartComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, IgxDateRangeStartComponent_Conditional_0_Template, 2, 1, "div", 11)(1, IgxDateRangeStartComponent_Conditional_1_Template, 1, 1, "ng-container");
            i0.ɵɵelementStart(2, "div", 12);
            i0.ɵɵlistener("click", function IgxDateRangeStartComponent_Template_div_click_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hintClickHandler($event));
            });
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, IgxDateRangeStartComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, IgxDateRangeStartComponent_ng_template_6_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(8, IgxDateRangeStartComponent_ng_template_8_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(10, IgxDateRangeStartComponent_ng_template_10_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(12, IgxDateRangeStartComponent_ng_template_12_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(14, IgxDateRangeStartComponent_ng_template_14_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(16, IgxDateRangeStartComponent_ng_template_16_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(18, IgxDateRangeStartComponent_ng_template_18_Template, 15, 8, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(20, IgxDateRangeStartComponent_ng_template_20_Template, 12, 8, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(22, IgxDateRangeStartComponent_ng_template_22_Template, 10, 7, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(24, IgxDateRangeStartComponent_ng_template_24_Template, 4, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isTypeBox ? 0 : 1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxPrefixDirective, IgxButtonDirective, NgClass, IgxSuffixDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxDateRangeStartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Defines the end input for a date range picker
 *
 * @igxModule IgxDateRangePickerModule
 *
 * @igxTheme igx-input-group-theme, igx-calendar-theme, igx-date-range-picker-theme
 *
 * @igxKeywords date, range, date range, date picker
 *
 * @igxGroup scheduling
 *
 * @remarks
 * When templating, end input has to be template separately
 *
 * @example
 * ```html
 * <igx-date-range-picker mode="dropdown">
 *      ...
 *      <igx-date-range-end>
 *          <input igxInput igxDateTimeEditor type="text">
 *      </igx-date-range-end>
 * </igx-date-range-picker>
 * ```
 */
let IgxDateRangeEndComponent = /*#__PURE__*/(() => {
  class IgxDateRangeEndComponent extends IgxDateRangeInputsBaseComponent {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵIgxDateRangeEndComponent_BaseFactory;
        return function IgxDateRangeEndComponent_Factory(__ngFactoryType__) {
          return (ɵIgxDateRangeEndComponent_BaseFactory || (ɵIgxDateRangeEndComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IgxDateRangeEndComponent)))(__ngFactoryType__ || IgxDateRangeEndComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDateRangeEndComponent,
        selectors: [["igx-date-range-end"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: IgxInputGroupBase,
          useExisting: IgxDateRangeEndComponent
        }, {
          provide: IgxDateRangeInputsBaseComponent,
          useExisting: IgxDateRangeEndComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 26,
        vars: 1,
        consts: [["label", ""], ["input", ""], ["prefix", ""], ["uploadButton", ""], ["files", ""], ["clear", ""], ["suffix", ""], ["materialBundle", ""], ["fluentBundle", ""], ["bootstrapBundle", ""], ["bundle", ""], [1, "igx-input-group__wrapper"], [1, "igx-input-group__hint", 3, "click"], [4, "ngTemplateOutlet"], [1, "igx-input-group__upload-button"], ["igxButton", "contained", "type", "button", 3, "click", "disabled", "ngClass"], [1, "igx-input-group__file-input", 3, "title"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon"], ["title", "clear files", "tabindex", "0", 1, "igx-input-group__clear-icon", 3, "click", "keydown.Enter"], ["family", "default", "name", "input_clear"], [1, "igx-input-group__bundle"], [1, "igx-input-group__bundle-start"], [1, "igx-input-group__notch"], [1, "igx-input-group__bundle-main"], [1, "igx-input-group__filler"], [1, "igx-input-group__bundle-end"], [1, "igx-input-group__line"]],
        template: function IgxDateRangeEndComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, IgxDateRangeEndComponent_Conditional_0_Template, 2, 1, "div", 11)(1, IgxDateRangeEndComponent_Conditional_1_Template, 1, 1, "ng-container");
            i0.ɵɵelementStart(2, "div", 12);
            i0.ɵɵlistener("click", function IgxDateRangeEndComponent_Template_div_click_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hintClickHandler($event));
            });
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, IgxDateRangeEndComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, IgxDateRangeEndComponent_ng_template_6_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(8, IgxDateRangeEndComponent_ng_template_8_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(10, IgxDateRangeEndComponent_ng_template_10_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(12, IgxDateRangeEndComponent_ng_template_12_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(14, IgxDateRangeEndComponent_ng_template_14_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(16, IgxDateRangeEndComponent_ng_template_16_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(18, IgxDateRangeEndComponent_ng_template_18_Template, 15, 8, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(20, IgxDateRangeEndComponent_ng_template_20_Template, 12, 8, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(22, IgxDateRangeEndComponent_ng_template_22_Template, 10, 7, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(24, IgxDateRangeEndComponent_ng_template_24_Template, 4, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isTypeBox ? 0 : 1);
          }
        },
        dependencies: [NgTemplateOutlet, IgxPrefixDirective, IgxButtonDirective, NgClass, IgxSuffixDirective, IgxIconComponent],
        encapsulation: 2
      });
    }
  }
  return IgxDateRangeEndComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Replaces the default separator `to` with the provided value
 *
 * @igxModule IgxDateRangePickerModule
 *
 * @igxTheme igx-date-range-picker-theme
 *
 * @igxKeywords date, range, date range, date picker
 *
 * @igxGroup scheduling
 *
 * @example
 * ```html
 * <igx-date-range-picker>
 *      <igx-date-range-start>
 *          <input igxInput igxDateTimeEditor type="text">
 *      </igx-date-range-start>
 *
 *      <ng-template igxDateRangeSeparator>-</ng-template>
 *
 *      <igx-date-range-end>
 *          <input igxInput igxDateTimeEditor type="text">
 *      </igx-date-range-end>
 *      ...
 * </igx-date-range-picker>
 * ```
 */
let IgxDateRangeSeparatorDirective = /*#__PURE__*/(() => {
  class IgxDateRangeSeparatorDirective {
    static {
      this.ɵfac = function IgxDateRangeSeparatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDateRangeSeparatorDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IgxDateRangeSeparatorDirective,
        selectors: [["", "igxDateRangeSeparator", ""]]
      });
    }
  }
  return IgxDateRangeSeparatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DateRangePickerResourceStringsEN = {
  igx_date_range_picker_date_separator: 'to',
  igx_date_range_picker_done_button: 'Done'
};
const SingleInputDatesConcatenationString = ' - ';
/**
 * Provides the ability to select a range of dates from a calendar UI or editable inputs.
 *
 * @igxModule IgxDateRangeModule
 *
 * @igxTheme igx-input-group-theme, igx-calendar-theme, igx-date-range-picker-theme
 *
 * @igxKeywords date, range, date range, date picker
 *
 * @igxGroup scheduling
 *
 * @remarks
 * It displays the range selection in a single or two input fields.
 * The default template displays a single *readonly* input field
 * while projecting `igx-date-range-start` and `igx-date-range-end`
 * displays two *editable* input fields.
 *
 * @example
 * ```html
 * <igx-date-range-picker mode="dropdown"></igx-date-range-picker>
 * ```
 */
let IgxDateRangePickerComponent = /*#__PURE__*/(() => {
  class IgxDateRangePickerComponent extends PickerBaseDirective {
    /**
     * Overrides the default text of the calendar dialog **Done** button.
     *
     * @remarks
     * Defaults to the value from resource strings, `"Done"` for the built-in EN.
     * The button will only show up in `dialog` mode.
     *
     * @example
     * ```html
     * <igx-date-range-picker doneButtonText="完了"></igx-date-range-picker>
     * ```
     */
    set doneButtonText(value) {
      this._doneButtonText = value;
    }
    get doneButtonText() {
      if (this._doneButtonText === null) {
        return this.resourceStrings.igx_date_range_picker_done_button;
      }
      return this._doneButtonText;
    }
    /**
     * The minimum value in a valid range.
     *
     * @example
     * <igx-date-range-picker [minValue]="minDate"></igx-date-range-picker>
     */
    set minValue(value) {
      this._minValue = value;
      this.onValidatorChange();
    }
    get minValue() {
      return this._minValue;
    }
    /**
     * The maximum value in a valid range.
     *
     * @example
     * <igx-date-range-picker [maxValue]="maxDate"></igx-date-range-picker>
     */
    set maxValue(value) {
      this._maxValue = value;
      this.onValidatorChange();
    }
    get maxValue() {
      return this._maxValue;
    }
    /**
     * An accessor that sets the resource strings.
     * By default it uses EN resources.
     */
    set resourceStrings(value) {
      this._resourceStrings = Object.assign({}, this._resourceStrings, value);
    }
    /**
     * An accessor that returns the resource strings.
     */
    get resourceStrings() {
      return this._resourceStrings;
    }
    /** @hidden @internal */
    get dateSeparator() {
      if (this._dateSeparator === null) {
        return this.resourceStrings.igx_date_range_picker_date_separator;
      }
      return this._dateSeparator;
    }
    /** @hidden @internal */
    get appliedFormat() {
      return DateTimeUtil.getLocaleDateFormat(this.locale, this.displayFormat) || DateTimeUtil.DEFAULT_INPUT_FORMAT;
    }
    /**
     * @example
     * ```html
     * <igx-date-range-picker locale="jp"></igx-date-range-picker>
     * ```
     */
    /**
     * Gets the `locale` of the date-range-picker.
     * If not set, defaults to application's locale.
     */
    get locale() {
      return this._locale;
    }
    /**
     * Sets the `locale` of the date-picker.
     * Expects a valid BCP 47 language tag.
     */
    set locale(value) {
      this._locale = value;
      // if value is invalid, set it back to _localeId
      try {
        getLocaleFirstDayOfWeek(this._locale);
      } catch (e) {
        this._locale = this._localeId;
      }
      if (this.hasProjectedInputs) {
        this.updateInputLocale();
        this.updateDisplayFormat();
      }
    }
    /** @hidden @internal */
    get singleInputFormat() {
      if (this.placeholder !== '') {
        return this.placeholder;
      }
      const format = this.appliedFormat;
      return `${format}${SingleInputDatesConcatenationString}${format}`;
    }
    /**
     * Gets calendar state.
     *
     * ```typescript
     * let state = this.dateRange.collapsed;
     * ```
     */
    get collapsed() {
      return this._collapsed;
    }
    /**
     * The currently selected value / range from the calendar
     *
     * @remarks
     * The current value is of type `DateRange`
     *
     * @example
     * ```typescript
     * const newValue: DateRange = { start: new Date("2/2/2012"), end: new Date("3/3/2013")};
     * this.dateRangePicker.value = newValue;
     * ```
     */
    get value() {
      return this._value;
    }
    set value(value) {
      this.updateValue(value);
      this.onChangeCallback(value);
      this.valueChange.emit(value);
    }
    /** @hidden @internal */
    get hasProjectedInputs() {
      return this.projectedInputs?.length > 0;
    }
    /** @hidden @internal */
    get separatorClass() {
      return 'igx-date-range-picker__label';
    }
    get toggleContainer() {
      return this._calendarContainer;
    }
    get required() {
      if (this._ngControl && this._ngControl.control && this._ngControl.control.validator) {
        const error = this._ngControl.control.validator({});
        return error && error.required ? true : false;
      }
      return false;
    }
    get calendar() {
      return this._calendar;
    }
    get dropdownOverlaySettings() {
      return Object.assign({}, this._dropDownOverlaySettings, this.overlaySettings);
    }
    get dialogOverlaySettings() {
      return Object.assign({}, this._dialogOverlaySettings, this.overlaySettings);
    }
    constructor(element, _localeId, platform, _injector, _cdr, _overlayService, _inputGroupType) {
      super(element, _localeId, _inputGroupType);
      this.platform = platform;
      this._injector = _injector;
      this._cdr = _cdr;
      this._overlayService = _overlayService;
      /**
       * The number of displayed month views.
       *
       * @remarks
       * Default is `2`.
       *
       * @example
       * ```html
       * <igx-date-range-picker [displayMonthsCount]="3"></igx-date-range-picker>
       * ```
       */
      this.displayMonthsCount = 2;
      /**
       * Sets the `placeholder` for single-input `IgxDateRangePickerComponent`.
       *
       *   @example
       * ```html
       * <igx-date-range-picker [placeholder]="'Choose your dates'"></igx-date-range-picker>
       * ```
       */
      this.placeholder = '';
      /**
       * Show/hide week numbers
       *
       * @remarks
       * Default is `false`.
       *
       * @example
       * ```html
       * <igx-date-range-picker [showWeekNumbers]="true"></igx-date-range-picker>
       * ``
       */
      this.showWeekNumbers = false;
      /**
       * Emitted when the picker's value changes. Used for two-way binding.
       *
       * @example
       * ```html
       * <igx-date-range-picker [(value)]="date"></igx-date-range-picker>
       * ```
       */
      this.valueChange = new EventEmitter();
      /** @hidden @internal */
      this.cssClass = 'igx-date-range-picker';
      this._resourceStrings = getCurrentResourceStrings(DateRangePickerResourceStringsEN);
      this._doneButtonText = null;
      this._dateSeparator = null;
      this._overlaySubFilter = [filter(x => x.id === this._overlayId), takeUntil(merge(this._destroy$, this.closed))];
      this._dialogOverlaySettings = {
        closeOnOutsideClick: true,
        modal: true,
        closeOnEscape: true
      };
      this._dropDownOverlaySettings = {
        closeOnOutsideClick: true,
        modal: false,
        closeOnEscape: true
      };
      this.onChangeCallback = noop;
      this.onTouchCallback = noop;
      this.onValidatorChange = noop;
      this.onStatusChanged = () => {
        if (this.inputGroup) {
          this.setValidityState(this.inputDirective, this.inputGroup.isFocused);
        } else if (this.hasProjectedInputs) {
          this.projectedInputs.forEach(i => {
            this.setValidityState(i.inputDirective, i.isFocused);
          });
        }
        this.setRequiredToInputs();
      };
      this.locale = this.locale || this._localeId;
    }
    /** @hidden @internal */
    onKeyDown(event) {
      switch (event.key) {
        case this.platform.KEYMAP.ARROW_UP:
          if (event.altKey) {
            this.close();
          }
          break;
        case this.platform.KEYMAP.ARROW_DOWN:
          if (event.altKey) {
            this.open();
          }
          break;
      }
    }
    /**
     * Opens the date range picker's dropdown or dialog.
     *
     * @example
     * ```html
     * <igx-date-range-picker #dateRange></igx-date-range-picker>
     *
     * <button type="button" igxButton (click)="dateRange.open()">Open Dialog</button
     * ```
     */
    open(overlaySettings) {
      if (!this.collapsed || this.disabled) {
        return;
      }
      const settings = Object.assign({}, this.isDropdown ? this.dropdownOverlaySettings : this.dialogOverlaySettings, overlaySettings);
      this._overlayId = this._overlayService.attach(IgxCalendarContainerComponent, this.viewContainerRef, settings);
      this.subscribeToOverlayEvents();
      this._overlayService.show(this._overlayId);
    }
    /**
     * Closes the date range picker's dropdown or dialog.
     *
     * @example
     * ```html
     * <igx-date-range-picker #dateRange></igx-date-range-picker>
     *
     * <button type="button" igxButton (click)="dateRange.close()">Close Dialog</button>
     * ```
     */
    close() {
      if (!this.collapsed) {
        this._overlayService.hide(this._overlayId);
      }
    }
    /**
     * Toggles the date range picker's dropdown or dialog
     *
     * @example
     * ```html
     * <igx-date-range-picker #dateRange></igx-date-range-picker>
     *
     * <button type="button" igxButton (click)="dateRange.toggle()">Toggle Dialog</button>
     * ```
     */
    toggle(overlaySettings) {
      if (!this.collapsed) {
        this.close();
      } else {
        this.open(overlaySettings);
      }
    }
    /**
     * Selects a range of dates. If no `endDate` is passed, range is 1 day (only `startDate`)
     *
     * @example
     * ```typescript
     * public selectFiveDayRange() {
     *  const today = new Date();
     *  const inFiveDays = new Date(new Date().setDate(today.getDate() + 5));
     *  this.dateRange.select(today, inFiveDays);
     * }
     * ```
     */
    select(startDate, endDate) {
      endDate = endDate ?? startDate;
      const dateRange = [startDate, endDate];
      this.handleSelection(dateRange);
    }
    /** @hidden @internal */
    writeValue(value) {
      this.updateValue(value);
    }
    /** @hidden @internal */
    registerOnChange(fn) {
      this.onChangeCallback = fn;
    }
    /** @hidden @internal */
    registerOnTouched(fn) {
      this.onTouchCallback = fn;
    }
    /** @hidden @internal */
    validate(control) {
      const value = control.value;
      const errors = {};
      if (value) {
        if (this.hasProjectedInputs) {
          const startInput = this.projectedInputs.find(i => i instanceof IgxDateRangeStartComponent);
          const endInput = this.projectedInputs.find(i => i instanceof IgxDateRangeEndComponent);
          if (!startInput.dateTimeEditor.value) {
            Object.assign(errors, {
              startValue: true
            });
          }
          if (!endInput.dateTimeEditor.value) {
            Object.assign(errors, {
              endValue: true
            });
          }
        }
        const min = parseDate(this.minValue);
        const max = parseDate(this.maxValue);
        const start = parseDate(value.start);
        const end = parseDate(value.end);
        if (min && start && DateTimeUtil.lessThanMinValue(start, min, false) || min && end && DateTimeUtil.lessThanMinValue(end, min, false)) {
          Object.assign(errors, {
            minValue: true
          });
        }
        if (max && start && DateTimeUtil.greaterThanMaxValue(start, max, false) || max && end && DateTimeUtil.greaterThanMaxValue(end, max, false)) {
          Object.assign(errors, {
            maxValue: true
          });
        }
      }
      return Object.keys(errors).length > 0 ? errors : null;
    }
    /** @hidden @internal */
    registerOnValidatorChange(fn) {
      this.onValidatorChange = fn;
    }
    /** @hidden @internal */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    /** @hidden */
    ngOnInit() {
      this._ngControl = this._injector.get(NgControl, null);
      this.locale = this.locale || this._localeId;
    }
    /** @hidden */
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this.subscribeToDateEditorEvents();
      this.configPositionStrategy();
      this.configOverlaySettings();
      this.cacheFocusedInput();
      this.attachOnTouched();
      this.setRequiredToInputs();
      if (this._ngControl) {
        this._statusChanges$ = this._ngControl.statusChanges.subscribe(this.onStatusChanged.bind(this));
      }
      // delay invocations until the current change detection cycle has completed
      Promise.resolve().then(() => {
        this.updateDisabledState();
        this.initialSetValue();
        this.updateInputs();
        // B.P. 07 July 2021 - IgxDateRangePicker not showing initial disabled state with ChangeDetectionStrategy.OnPush #9776
        /**
         * if disabled is placed on the range picker element and there are projected inputs
         * run change detection since igxInput will initially set the projected inputs' disabled to false
         */
        if (this.hasProjectedInputs && this.disabled) {
          this._cdr.markForCheck();
        }
      });
      this.updateDisplayFormat();
      this.updateInputFormat();
    }
    /** @hidden @internal */
    ngOnChanges(changes) {
      if (changes['displayFormat'] && this.hasProjectedInputs) {
        this.updateDisplayFormat();
      }
      if (changes['inputFormat'] && this.hasProjectedInputs) {
        this.updateInputFormat();
      }
      if (changes['disabled']) {
        this.updateDisabledState();
      }
    }
    /** @hidden @internal */
    ngOnDestroy() {
      super.ngOnDestroy();
      if (this._statusChanges$) {
        this._statusChanges$.unsubscribe();
      }
      if (this._overlayId) {
        this._overlayService.detach(this._overlayId);
      }
    }
    /** @hidden @internal */
    getEditElement() {
      return this.inputDirective.nativeElement;
    }
    setValidityState(inputDirective, isFocused) {
      if (this._ngControl && !this._ngControl.disabled && this.isTouchedOrDirty) {
        if (this.hasValidators && isFocused) {
          inputDirective.valid = this._ngControl.valid ? IgxInputState.VALID : IgxInputState.INVALID;
        } else {
          inputDirective.valid = this._ngControl.valid ? IgxInputState.INITIAL : IgxInputState.INVALID;
        }
      } else {
        inputDirective.valid = IgxInputState.INITIAL;
      }
    }
    get isTouchedOrDirty() {
      return this._ngControl.control.touched || this._ngControl.control.dirty;
    }
    get hasValidators() {
      return !!this._ngControl.control.validator || !!this._ngControl.control.asyncValidator;
    }
    handleSelection(selectionData) {
      let newValue = this.extractRange(selectionData);
      if (!newValue.start && !newValue.end) {
        newValue = null;
      }
      this.value = newValue;
      if (this.isDropdown && selectionData?.length > 1) {
        this.close();
      }
    }
    handleClosing(e) {
      const args = {
        owner: this,
        cancel: e?.cancel,
        event: e?.event
      };
      this.closing.emit(args);
      e.cancel = args.cancel;
      if (args.cancel) {
        return;
      }
      if (this.isDropdown && e?.event && !this.isFocused) {
        // outside click
        this.updateValidityOnBlur();
      } else {
        this.onTouchCallback();
        // input click
        if (this.hasProjectedInputs && this._focusedInput) {
          this._focusedInput.setFocus();
        }
        if (this.inputDirective) {
          this.inputDirective.focus();
        }
      }
    }
    subscribeToOverlayEvents() {
      this._overlayService.opening.pipe(...this._overlaySubFilter).subscribe(e => {
        const overlayEvent = e;
        const args = {
          owner: this,
          cancel: overlayEvent?.cancel,
          event: e.event
        };
        this.opening.emit(args);
        if (args.cancel) {
          this._overlayService.detach(this._overlayId);
          overlayEvent.cancel = true;
          return;
        }
        this._initializeCalendarContainer(e.componentRef.instance);
        this._calendarContainer = e.componentRef.location.nativeElement;
        this._collapsed = false;
        this.updateCalendar();
      });
      this._overlayService.opened.pipe(...this._overlaySubFilter).subscribe(() => {
        this.calendar.wrapper.nativeElement.focus();
        this.opened.emit({
          owner: this
        });
      });
      this._overlayService.closing.pipe(...this._overlaySubFilter).subscribe(e => {
        this.handleClosing(e);
      });
      this._overlayService.closed.pipe(...this._overlaySubFilter).subscribe(() => {
        this._overlayService.detach(this._overlayId);
        this._collapsed = true;
        this._overlayId = null;
        this._calendar = null;
        this._calendarContainer = undefined;
        this.closed.emit({
          owner: this
        });
      });
    }
    updateValue(value) {
      this._value = value ? value : null;
      this.updateInputs();
      this.updateCalendar();
    }
    updateValidityOnBlur() {
      this._focusedInput = null;
      this.onTouchCallback();
      if (this._ngControl) {
        if (this.hasProjectedInputs) {
          this.projectedInputs.forEach(i => {
            if (!this._ngControl.valid) {
              i.updateInputValidity(IgxInputState.INVALID);
            } else {
              i.updateInputValidity(IgxInputState.INITIAL);
            }
          });
        }
        if (this.inputDirective) {
          if (!this._ngControl.valid) {
            this.inputDirective.valid = IgxInputState.INVALID;
          } else {
            this.inputDirective.valid = IgxInputState.INITIAL;
          }
        }
      }
    }
    updateDisabledState() {
      if (this.hasProjectedInputs) {
        const start = this.projectedInputs.find(i => i instanceof IgxDateRangeStartComponent);
        const end = this.projectedInputs.find(i => i instanceof IgxDateRangeEndComponent);
        start.inputDirective.disabled = this.disabled;
        end.inputDirective.disabled = this.disabled;
        return;
      }
    }
    setRequiredToInputs() {
      // workaround for igxInput setting required
      Promise.resolve().then(() => {
        const isRequired = this.required;
        if (this.inputGroup && this.inputGroup.isRequired !== isRequired) {
          this.inputGroup.isRequired = isRequired;
        } else if (this.hasProjectedInputs && this._ngControl) {
          this.projectedInputs.forEach(i => i.isRequired = isRequired);
        }
      });
    }
    parseMinValue(value) {
      let minValue = parseDate(value);
      if (!minValue && this.hasProjectedInputs) {
        const start = this.projectedInputs.filter(i => i instanceof IgxDateRangeStartComponent)[0];
        if (start) {
          minValue = parseDate(start.dateTimeEditor.minValue);
        }
      }
      return minValue;
    }
    parseMaxValue(value) {
      let maxValue = parseDate(value);
      if (!maxValue && this.projectedInputs) {
        const end = this.projectedInputs.filter(i => i instanceof IgxDateRangeEndComponent)[0];
        if (end) {
          maxValue = parseDate(end.dateTimeEditor.maxValue);
        }
      }
      return maxValue;
    }
    updateCalendar() {
      if (!this.calendar) {
        return;
      }
      this.calendar.disabledDates = [];
      const minValue = this.parseMinValue(this.minValue);
      if (minValue) {
        this.calendar.disabledDates.push({
          type: DateRangeType.Before,
          dateRange: [minValue]
        });
      }
      const maxValue = this.parseMaxValue(this.maxValue);
      if (maxValue) {
        this.calendar.disabledDates.push({
          type: DateRangeType.After,
          dateRange: [maxValue]
        });
      }
      const range = [];
      if (this.value?.start && this.value?.end) {
        const _value = this.toRangeOfDates(this.value);
        if (DateTimeUtil.greaterThanMaxValue(_value.start, _value.end)) {
          this.swapEditorDates();
        }
        if (this.valueInRange(this.value, minValue, maxValue)) {
          range.push(_value.start, _value.end);
        }
      }
      if (range.length > 0) {
        this.calendar.selectDate(range);
      } else if (range.length === 0 && this.calendar.monthViews) {
        this.calendar.deselectDate();
      }
      this.calendar.viewDate = range[0] || new Date();
    }
    swapEditorDates() {
      if (this.hasProjectedInputs) {
        const start = this.projectedInputs.find(i => i instanceof IgxDateRangeStartComponent);
        const end = this.projectedInputs.find(i => i instanceof IgxDateRangeEndComponent);
        [start.dateTimeEditor.value, end.dateTimeEditor.value] = [end.dateTimeEditor.value, start.dateTimeEditor.value];
        [this.value.start, this.value.end] = [this.value.end, this.value.start];
      }
    }
    valueInRange(value, minValue, maxValue) {
      const _value = this.toRangeOfDates(value);
      if (minValue && DateTimeUtil.lessThanMinValue(_value.start, minValue, false)) {
        return false;
      }
      if (maxValue && DateTimeUtil.greaterThanMaxValue(_value.end, maxValue, false)) {
        return false;
      }
      return true;
    }
    extractRange(selection) {
      return {
        start: selection[0] || null,
        end: selection.length > 0 ? selection[selection.length - 1] : null
      };
    }
    toRangeOfDates(range) {
      let start;
      let end;
      if (!isDate(range.start)) {
        start = DateTimeUtil.parseIsoDate(range.start);
      }
      if (!isDate(range.end)) {
        end = DateTimeUtil.parseIsoDate(range.end);
      }
      if (start || end) {
        return {
          start,
          end
        };
      }
      return {
        start: range.start,
        end: range.end
      };
    }
    subscribeToDateEditorEvents() {
      if (this.hasProjectedInputs) {
        const start = this.projectedInputs.find(i => i instanceof IgxDateRangeStartComponent);
        const end = this.projectedInputs.find(i => i instanceof IgxDateRangeEndComponent);
        if (start && end) {
          start.dateTimeEditor.valueChange.pipe(takeUntil(this._destroy$)).subscribe(value => {
            if (this.value) {
              this.value = {
                start: value,
                end: this.value.end
              };
            } else {
              this.value = {
                start: value,
                end: null
              };
            }
          });
          end.dateTimeEditor.valueChange.pipe(takeUntil(this._destroy$)).subscribe(value => {
            if (this.value) {
              this.value = {
                start: this.value.start,
                end: value
              };
            } else {
              this.value = {
                start: null,
                end: value
              };
            }
          });
        }
      }
    }
    attachOnTouched() {
      if (this.hasProjectedInputs) {
        this.projectedInputs.forEach(i => {
          fromEvent(i.dateTimeEditor.nativeElement, 'blur').pipe(takeUntil(this._destroy$)).subscribe(() => {
            if (this.collapsed) {
              this.updateValidityOnBlur();
            }
          });
        });
      } else {
        fromEvent(this.inputDirective.nativeElement, 'blur').pipe(takeUntil(this._destroy$)).subscribe(() => {
          if (this.collapsed) {
            this.updateValidityOnBlur();
          }
        });
      }
    }
    cacheFocusedInput() {
      if (this.hasProjectedInputs) {
        this.projectedInputs.forEach(i => {
          fromEvent(i.dateTimeEditor.nativeElement, 'focus').pipe(takeUntil(this._destroy$)).subscribe(() => this._focusedInput = i);
        });
      }
    }
    configPositionStrategy() {
      this._positionSettings = {
        openAnimation: fadeIn,
        closeAnimation: fadeOut
      };
      this._dropDownOverlaySettings.positionStrategy = new AutoPositionStrategy(this._positionSettings);
      this._dropDownOverlaySettings.target = this.element.nativeElement;
    }
    configOverlaySettings() {
      if (this.overlaySettings !== null) {
        this._dropDownOverlaySettings = Object.assign({}, this._dropDownOverlaySettings, this.overlaySettings);
        this._dialogOverlaySettings = Object.assign({}, this._dialogOverlaySettings, this.overlaySettings);
      }
    }
    initialSetValue() {
      // if there is no value and no ngControl on the picker but we have inputs we may have value set through
      // their ngModels - we should generate our initial control value
      if ((!this.value || !this.value.start && !this.value.end) && this.hasProjectedInputs && !this._ngControl) {
        const start = this.projectedInputs.find(i => i instanceof IgxDateRangeStartComponent);
        const end = this.projectedInputs.find(i => i instanceof IgxDateRangeEndComponent);
        this._value = {
          start: start.dateTimeEditor.value,
          end: end.dateTimeEditor.value
        };
      }
    }
    updateInputs() {
      const start = this.projectedInputs?.find(i => i instanceof IgxDateRangeStartComponent);
      const end = this.projectedInputs?.find(i => i instanceof IgxDateRangeEndComponent);
      if (start && end) {
        const _value = this.value ? this.toRangeOfDates(this.value) : null;
        start.updateInputValue(_value?.start || null);
        end.updateInputValue(_value?.end || null);
      }
    }
    updateDisplayFormat() {
      this.projectedInputs.forEach(i => {
        const input = i;
        input.dateTimeEditor.displayFormat = this.displayFormat;
      });
    }
    updateInputFormat() {
      this.projectedInputs.forEach(i => {
        const input = i;
        if (input.dateTimeEditor.inputFormat !== this.inputFormat) {
          input.dateTimeEditor.inputFormat = this.inputFormat;
        }
      });
    }
    updateInputLocale() {
      this.projectedInputs.forEach(i => {
        const input = i;
        input.dateTimeEditor.locale = this.locale;
      });
    }
    _initializeCalendarContainer(componentInstance) {
      this._calendar = componentInstance.calendar;
      this.calendar.hasHeader = false;
      this.calendar.locale = this.locale;
      this.calendar.selection = CalendarSelection.RANGE;
      this.calendar.weekStart = this.weekStart;
      this.calendar.hideOutsideDays = this.hideOutsideDays;
      this.calendar.monthsViewNumber = this.displayMonthsCount;
      this.calendar.showWeekNumbers = this.showWeekNumbers;
      this.calendar.selected.pipe(takeUntil(this._destroy$)).subscribe(ev => this.handleSelection(ev));
      componentInstance.mode = this.mode;
      componentInstance.closeButtonLabel = !this.isDropdown ? this.doneButtonText : null;
      componentInstance.pickerActions = this.pickerActions;
      componentInstance.calendarClose.pipe(takeUntil(this._destroy$)).subscribe(() => this.close());
    }
    static {
      this.ɵfac = function IgxDateRangePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDateRangePickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(PlatformUtil), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IgxOverlayService), i0.ɵɵdirectiveInject(IGX_INPUT_GROUP_TYPE, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IgxDateRangePickerComponent,
        selectors: [["igx-date-range-picker"]],
        contentQueries: function IgxDateRangePickerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, IgxLabelDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxPickerActionsDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, IgxDateRangeSeparatorDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, IgxDateRangeInputsBaseComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pickerActions = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateSeparatorTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.projectedInputs = _t);
          }
        },
        viewQuery: function IgxDateRangePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(IgxInputGroupComponent, 5, ViewContainerRef);
            i0.ɵɵviewQuery(IgxInputDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputDirective = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function IgxDateRangePickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function IgxDateRangePickerComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("igx-date-range-picker", ctx.cssClass);
          }
        },
        inputs: {
          displayMonthsCount: "displayMonthsCount",
          hideOutsideDays: [2, "hideOutsideDays", "hideOutsideDays", booleanAttribute],
          formatter: "formatter",
          doneButtonText: "doneButtonText",
          overlaySettings: "overlaySettings",
          displayFormat: "displayFormat",
          inputFormat: "inputFormat",
          minValue: "minValue",
          maxValue: "maxValue",
          resourceStrings: "resourceStrings",
          placeholder: "placeholder",
          outlet: "outlet",
          showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute],
          locale: "locale",
          value: "value"
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: IgxDateRangePickerComponent,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: IgxDateRangePickerComponent,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c320,
        decls: 11,
        vars: 1,
        consts: [["singleTemplate", ""], ["startEndTemplate", ""], ["defIcon", ""], ["defDateSeparatorTemplate", ""], ["defTemplate", ""], ["singleInput", ""], [4, "ngTemplateOutlet"], [1, "content-wrap", 3, "click"], [3, "className"], ["family", "default", "name", "date_range"], [3, "click", "type"], ["igxInput", "", "type", "text", "readonly", "", "role", "combobox", "aria-haspopup", "grid", 3, "disabled", "placeholder", "value"], ["ngProjectAs", "[igxLabel]", 5, ["", "igxLabel", ""]], ["ngProjectAs", "igx-prefix", 5, ["igx-prefix"]], ["ngProjectAs", "igx-suffix", 5, ["igx-suffix"]], ["ngProjectAs", "igx-hint", 5, ["igx-hint"]]],
        template: function IgxDateRangePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c319);
            i0.ɵɵtemplate(0, IgxDateRangePickerComponent_ng_container_0_Template, 1, 0, "ng-container", 6)(1, IgxDateRangePickerComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, IgxDateRangePickerComponent_ng_template_3_Template, 4, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, IgxDateRangePickerComponent_ng_template_5_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, IgxDateRangePickerComponent_ng_template_7_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(9, IgxDateRangePickerComponent_ng_template_9_Template, 13, 12, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const startEndTemplate_r6 = i0.ɵɵreference(4);
            const defTemplate_r7 = i0.ɵɵreference(10);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.hasProjectedInputs ? startEndTemplate_r6 : defTemplate_r7);
          }
        },
        dependencies: [NgTemplateOutlet, IgxIconComponent, IgxInputGroupComponent, IgxInputDirective, IgxPrefixDirective, DateRangePickerFormatPipe],
        encapsulation: 2
      });
    }
  }
  return IgxDateRangePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* NOTE: Date-range picker directives collection for ease-of-use import in standalone components scenario */
const IGX_DATE_RANGE_PICKER_DIRECTIVES = [IgxDateRangePickerComponent, IgxPickerToggleComponent, IgxDateRangeStartComponent, IgxDateRangeEndComponent, IgxDateRangeSeparatorDirective, IgxLabelDirective, IgxPrefixDirective, IgxSuffixDirective, IgxHintDirective];

/* NOTE: Tree directives collection for ease-of-use import in standalone components scenario */
const IGX_TREE_DIRECTIVES = [IgxTreeComponent, IgxTreeNodeComponent, IgxTreeNodeLinkDirective, IgxTreeExpandIndicatorDirective];

/* NOTE: Query builder directives collection for ease-of-use import in standalone components scenario */
const IGX_QUERY_BUILDER_DIRECTIVES = [IgxQueryBuilderComponent, IgxQueryBuilderHeaderComponent, IgxQueryBuilderSearchValueTemplateDirective];

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxAccordionModule = /*#__PURE__*/(() => {
  class IgxAccordionModule {
    static {
      this.ɵfac = function IgxAccordionModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAccordionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxAccordionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxAccordionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxActionStripModule = /*#__PURE__*/(() => {
  class IgxActionStripModule {
    static {
      this.ɵfac = function IgxActionStripModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxActionStripModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxActionStripModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxActionStripModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxAvatarModule = /*#__PURE__*/(() => {
  class IgxAvatarModule {
    static {
      this.ɵfac = function IgxAvatarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAvatarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxAvatarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxAvatarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxBadgeModule = /*#__PURE__*/(() => {
  class IgxBadgeModule {
    static {
      this.ɵfac = function IgxBadgeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBadgeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxBadgeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxBadgeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxBannerModule = /*#__PURE__*/(() => {
  class IgxBannerModule {
    static {
      this.ɵfac = function IgxBannerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBannerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxBannerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxBannerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxButtonGroupModule = /*#__PURE__*/(() => {
  class IgxButtonGroupModule {
    static {
      this.ɵfac = function IgxButtonGroupModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxButtonGroupModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxButtonGroupModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxButtonGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxCalendarModule = /*#__PURE__*/(() => {
  class IgxCalendarModule {
    static {
      this.ɵfac = function IgxCalendarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCalendarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxCalendarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxCalendarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxCardModule = /*#__PURE__*/(() => {
  class IgxCardModule {
    static {
      this.ɵfac = function IgxCardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxCardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxCardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxCarouselModule = /*#__PURE__*/(() => {
  class IgxCarouselModule {
    static {
      this.ɵfac = function IgxCarouselModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCarouselModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxCarouselModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxCarouselModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxCheckboxModule = /*#__PURE__*/(() => {
  class IgxCheckboxModule {
    static {
      this.ɵfac = function IgxCheckboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxCheckboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxCheckboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxCheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxChipsModule = /*#__PURE__*/(() => {
  class IgxChipsModule {
    static {
      this.ɵfac = function IgxChipsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxChipsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxChipsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxChipsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxComboModule = /*#__PURE__*/(() => {
  class IgxComboModule {
    static {
      this.ɵfac = function IgxComboModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxComboModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxComboModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxComboComponent]
      });
    }
  }
  return IgxComboModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDatePickerModule = /*#__PURE__*/(() => {
  class IgxDatePickerModule {
    static {
      this.ɵfac = function IgxDatePickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDatePickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDatePickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDatePickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDateRangePickerModule = /*#__PURE__*/(() => {
  class IgxDateRangePickerModule {
    static {
      this.ɵfac = function IgxDateRangePickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDateRangePickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDateRangePickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDateRangePickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDialogModule = /*#__PURE__*/(() => {
  class IgxDialogModule {
    static {
      this.ɵfac = function IgxDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxAutocompleteModule = /*#__PURE__*/(() => {
  class IgxAutocompleteModule {
    static {
      this.ɵfac = function IgxAutocompleteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxAutocompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxAutocompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxAutocompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxButtonModule = /*#__PURE__*/(() => {
  class IgxButtonModule {
    static {
      this.ɵfac = function IgxButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDateTimeEditorModule = /*#__PURE__*/(() => {
  class IgxDateTimeEditorModule {
    static {
      this.ɵfac = function IgxDateTimeEditorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDateTimeEditorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDateTimeEditorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDateTimeEditorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDividerModule = /*#__PURE__*/(() => {
  class IgxDividerModule {
    static {
      this.ɵfac = function IgxDividerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDividerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDividerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDividerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDragDropModule = /*#__PURE__*/(() => {
  class IgxDragDropModule {
    static {
      this.ɵfac = function IgxDragDropModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDragDropModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDragDropModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDragDropModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxFilterModule = /*#__PURE__*/(() => {
  class IgxFilterModule {
    static {
      this.ɵfac = function IgxFilterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFilterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxFilterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxFocusModule = /*#__PURE__*/(() => {
  class IgxFocusModule {
    static {
      this.ɵfac = function IgxFocusModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFocusModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxFocusModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxFocusModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxFocusTrapModule = /*#__PURE__*/(() => {
  class IgxFocusTrapModule {
    static {
      this.ɵfac = function IgxFocusTrapModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxFocusTrapModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxFocusTrapModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxFocusTrapModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxForOfModule = /*#__PURE__*/(() => {
  class IgxForOfModule {
    static {
      this.ɵfac = function IgxForOfModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxForOfModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxForOfModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxForOfModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgcFormsModule = /*#__PURE__*/(() => {
  class IgcFormsModule {
    static {
      this.ɵfac = function IgcFormsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgcFormsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgcFormsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgcFormsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxLayoutModule = /*#__PURE__*/(() => {
  class IgxLayoutModule {
    static {
      this.ɵfac = function IgxLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxMaskModule = /*#__PURE__*/(() => {
  class IgxMaskModule {
    static {
      this.ɵfac = function IgxMaskModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxMaskModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxMaskModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxMaskModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxRadioModule = /*#__PURE__*/(() => {
  class IgxRadioModule {
    static {
      this.ɵfac = function IgxRadioModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRadioModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxRadioModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxRadioModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxRippleModule = /*#__PURE__*/(() => {
  class IgxRippleModule {
    static {
      this.ɵfac = function IgxRippleModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxRippleModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxRippleModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxRippleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxScrollInertiaModule = /*#__PURE__*/(() => {
  class IgxScrollInertiaModule {
    static {
      this.ɵfac = function IgxScrollInertiaModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxScrollInertiaModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxScrollInertiaModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxScrollInertiaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTextHighlightModule = /*#__PURE__*/(() => {
  class IgxTextHighlightModule {
    static {
      this.ɵfac = function IgxTextHighlightModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTextHighlightModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTextHighlightModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTextHighlightModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTextSelectionModule = /*#__PURE__*/(() => {
  class IgxTextSelectionModule {
    static {
      this.ɵfac = function IgxTextSelectionModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTextSelectionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTextSelectionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTextSelectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxToggleModule = /*#__PURE__*/(() => {
  class IgxToggleModule {
    static {
      this.ɵfac = function IgxToggleModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxToggleModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxToggleModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxToggleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTooltipModule = /*#__PURE__*/(() => {
  class IgxTooltipModule {
    static {
      this.ɵfac = function IgxTooltipModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTooltipModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTooltipModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxDropDownModule = /*#__PURE__*/(() => {
  class IgxDropDownModule {
    static {
      this.ɵfac = function IgxDropDownModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxDropDownModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxDropDownModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxDropDownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxExpansionPanelModule = /*#__PURE__*/(() => {
  class IgxExpansionPanelModule {
    static {
      this.ɵfac = function IgxExpansionPanelModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxExpansionPanelModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxExpansionPanelModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxExpansionPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxGridModule = /*#__PURE__*/(() => {
  class IgxGridModule {
    static {
      this.ɵfac = function IgxGridModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxGridModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxGridModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxGridComponent, IgxAdvancedFilteringDialogComponent, IgxColumnActionsComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleSearchComponent, IgxPaginatorComponent, IgxPageSizeSelectorComponent]
      });
    }
  }
  return IgxGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTreeGridModule = /*#__PURE__*/(() => {
  class IgxTreeGridModule {
    static {
      this.ɵfac = function IgxTreeGridModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeGridModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTreeGridModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxTreeGridComponent, IgxAdvancedFilteringDialogComponent, IgxColumnActionsComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleSearchComponent, IgxPaginatorComponent, IgxPageSizeSelectorComponent]
      });
    }
  }
  return IgxTreeGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxHierarchicalGridModule = /*#__PURE__*/(() => {
  class IgxHierarchicalGridModule {
    static {
      this.ɵfac = function IgxHierarchicalGridModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxHierarchicalGridModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxHierarchicalGridModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxHierarchicalGridComponent, IgxAdvancedFilteringDialogComponent, IgxColumnActionsComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleSearchComponent, IgxPaginatorComponent, IgxPageSizeSelectorComponent]
      });
    }
  }
  return IgxHierarchicalGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxPivotGridModule = /*#__PURE__*/(() => {
  class IgxPivotGridModule {
    static {
      this.ɵfac = function IgxPivotGridModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPivotGridModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxPivotGridModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxPivotGridComponent, IgxAdvancedFilteringDialogComponent, IgxColumnActionsComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridExcelStyleFilteringComponent, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleSearchComponent]
      });
    }
  }
  return IgxPivotGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxIconModule = /*#__PURE__*/(() => {
  class IgxIconModule {
    static {
      this.ɵfac = function IgxIconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxIconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxIconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxIconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxInputGroupModule = /*#__PURE__*/(() => {
  class IgxInputGroupModule {
    static {
      this.ɵfac = function IgxInputGroupModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxInputGroupModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxInputGroupModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxInputGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxListModule = /*#__PURE__*/(() => {
  class IgxListModule {
    static {
      this.ɵfac = function IgxListModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxNavbarModule = /*#__PURE__*/(() => {
  class IgxNavbarModule {
    static {
      this.ɵfac = function IgxNavbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxNavbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxNavbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let IgxNavigationDrawerModule = /*#__PURE__*/(() => {
  class IgxNavigationDrawerModule {
    static {
      this.ɵfac = function IgxNavigationDrawerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxNavigationDrawerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxNavigationDrawerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxNavigationDrawerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxPaginatorModule = /*#__PURE__*/(() => {
  class IgxPaginatorModule {
    static {
      this.ɵfac = function IgxPaginatorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxPaginatorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxPaginatorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxPaginatorComponent, IgxPageSizeSelectorComponent]
      });
    }
  }
  return IgxPaginatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxProgressBarModule = /*#__PURE__*/(() => {
  class IgxProgressBarModule {
    static {
      this.ɵfac = function IgxProgressBarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxProgressBarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxProgressBarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxQueryBuilderModule = /*#__PURE__*/(() => {
  class IgxQueryBuilderModule {
    static {
      this.ɵfac = function IgxQueryBuilderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxQueryBuilderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxQueryBuilderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IgxQueryBuilderComponent]
      });
    }
  }
  return IgxQueryBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSelectModule = /*#__PURE__*/(() => {
  class IgxSelectModule {
    static {
      this.ɵfac = function IgxSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSimpleComboModule = /*#__PURE__*/(() => {
  class IgxSimpleComboModule {
    static {
      this.ɵfac = function IgxSimpleComboModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSimpleComboModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSimpleComboModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSimpleComboModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSliderModule = /*#__PURE__*/(() => {
  class IgxSliderModule {
    static {
      this.ɵfac = function IgxSliderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSliderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSliderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSliderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSnackbarModule = /*#__PURE__*/(() => {
  class IgxSnackbarModule {
    static {
      this.ɵfac = function IgxSnackbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSnackbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSnackbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSnackbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSplitterModule = /*#__PURE__*/(() => {
  class IgxSplitterModule {
    static {
      this.ɵfac = function IgxSplitterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSplitterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSplitterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSplitterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxStepperModule = /*#__PURE__*/(() => {
  class IgxStepperModule {
    static {
      this.ɵfac = function IgxStepperModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxStepperModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxStepperModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxStepperModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxSwitchModule = /*#__PURE__*/(() => {
  class IgxSwitchModule {
    static {
      this.ɵfac = function IgxSwitchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxSwitchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxSwitchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxSwitchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxBottomNavModule = /*#__PURE__*/(() => {
  class IgxBottomNavModule {
    static {
      this.ɵfac = function IgxBottomNavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxBottomNavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxBottomNavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxBottomNavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTabsModule = /*#__PURE__*/(() => {
  class IgxTabsModule {
    static {
      this.ɵfac = function IgxTabsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTabsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTabsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTabsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTimePickerModule = /*#__PURE__*/(() => {
  class IgxTimePickerModule {
    static {
      this.ɵfac = function IgxTimePickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTimePickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTimePickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTimePickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxToastModule = /*#__PURE__*/(() => {
  class IgxToastModule {
    static {
      this.ɵfac = function IgxToastModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxToastModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxToastModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxToastModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * IMPORTANT: The following is NgModule exported for backwards-compatibility before standalone components
 */
let IgxTreeModule = /*#__PURE__*/(() => {
  class IgxTreeModule {
    static {
      this.ɵfac = function IgxTreeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IgxTreeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IgxTreeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IgxTreeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of igniteui-angular
 */
/**
 * Animations
 * MOVED TO @infragistics/igniteui-angular/animations
 */
//export * from './lib/animations/main';
/**
 * Directives
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbsolutePosition, AbsoluteScrollStrategy, ActionStripResourceStringsEN, AutoPositionStrategy, BannerResourceStringsEN, BaseFilteringStrategy, BlockScrollStrategy, ButtonGroupAlignment, CachedDataCloneStrategy, Calendar, CalendarResourceStringsEN, CalendarSelection, CarouselAnimationType, CarouselHammerConfig, CarouselIndicatorsOrientation, CarouselResourceStringsEN, ChipResourceStringsEN, CloseScrollStrategy, ColumnDisplayOrder, ColumnPinningPosition, ComboResourceStringsEN, ConnectedPositioningStrategy, ContainerPositionStrategy, CsvFileTypes, DEFAULT_OWNER, DEFAULT_PIVOT_KEYS, DataType, DataUtil, DatePart, DatePickerResourceStringsEN, DateRangePickerFormatPipe, DateRangePickerResourceStringsEN, DateRangeType, DefaultDataCloneStrategy, DefaultPivotGridRecordSortingStrategy, DefaultPivotSortingStrategy, DefaultSortingStrategy, DimensionValuesFilteringStrategy, Direction, DragDirection, ElasticPositionStrategy, ExpansionPanelHeaderIconPosition, ExportHeaderType, ExportRecordType, ExpressionsTreeUtil, FilterMode, FilterUtil, FilteringExpressionsTree, FilteringExpressionsTreeType, FilteringLogic, FilteringStrategy, FormattedValuesFilteringStrategy, FormattedValuesSortingStrategy, GRID_LEVEL_COL, GRID_PARENT, GRID_ROOT_SUMMARY, GlobalPositionStrategy, GridColumnDataType, GridPagingMode, GridResourceStringsEN, GridSelectionMode, GridSummaryCalculationMode, GridSummaryPosition, GroupMemberCountSortingStrategy, GroupedRecords, HorizontalAlignment, HorizontalAnimationType, IGX_ACCORDION_DIRECTIVES, IGX_ACTION_STRIP_DIRECTIVES, IGX_BANNER_DIRECTIVES, IGX_BOTTOM_NAV_DIRECTIVES, IGX_BUTTON_GROUP_DIRECTIVES, IGX_CALENDAR_DIRECTIVES, IGX_CALENDAR_VIEW_ITEM, IGX_CARD_DIRECTIVES, IGX_CAROUSEL_DIRECTIVES, IGX_CHIPS_DIRECTIVES, IGX_CIRCULAR_PROGRESS_BAR_DIRECTIVES, IGX_COMBO_DIRECTIVES, IGX_DATE_PICKER_DIRECTIVES, IGX_DATE_RANGE_PICKER_DIRECTIVES, IGX_DIALOG_DIRECTIVES, IGX_DRAG_DROP_DIRECTIVES, IGX_DROP_DOWN_DIRECTIVES, IGX_EXPANSION_PANEL_DIRECTIVES, IGX_GRID_ACTION_STRIP_DIRECTIVES, IGX_GRID_BASE, IGX_GRID_COMMON_DIRECTIVES, IGX_GRID_DIRECTIVES, IGX_GRID_SERVICE_BASE, IGX_GRID_VALIDATION_DIRECTIVES, IGX_HIERARCHICAL_GRID_DIRECTIVES, IGX_INPUT_GROUP_DIRECTIVES, IGX_INPUT_GROUP_TYPE, IGX_LINEAR_PROGRESS_BAR_DIRECTIVES, IGX_LIST_DIRECTIVES, IGX_NAVBAR_DIRECTIVES, IGX_NAVIGATION_DRAWER_DIRECTIVES, IGX_PAGINATOR_DIRECTIVES, IGX_PIVOT_GRID_DIRECTIVES, IGX_PROGRESS_BAR_DIRECTIVES, IGX_QUERY_BUILDER_DIRECTIVES, IGX_RADIO_GROUP_DIRECTIVES, IGX_SELECT_DIRECTIVES, IGX_SIMPLE_COMBO_DIRECTIVES, IGX_SLIDER_DIRECTIVES, IGX_SPLITTER_DIRECTIVES, IGX_STEPPER_DIRECTIVES, IGX_TABS_DIRECTIVES, IGX_TIME_PICKER_DIRECTIVES, IGX_TOOLTIP_DIRECTIVES, IGX_TREE_DIRECTIVES, IGX_TREE_GRID_DIRECTIVES, ITreeGridAggregation, IgSizeDirective, IgcFormControlDirective, IgcFormsModule, IgxAccordionComponent, IgxAccordionModule, IgxActionStripComponent, IgxActionStripMenuItemDirective, IgxActionStripModule, IgxAdvancedFilteringDialogComponent, IgxAppendDropStrategy, IgxAutocompleteDirective, IgxAutocompleteModule, IgxAvatarComponent, IgxAvatarModule, IgxAvatarSize, IgxAvatarType, IgxBadgeComponent, IgxBadgeModule, IgxBadgeType, IgxBannerActionsDirective, IgxBannerComponent, IgxBannerModule, IgxBaseExporter, IgxBaseTransactionService, IgxBooleanFilteringOperand, IgxBottomNavComponent, IgxBottomNavContentComponent, IgxBottomNavHeaderComponent, IgxBottomNavHeaderIconDirective, IgxBottomNavHeaderLabelDirective, IgxBottomNavItemComponent, IgxBottomNavModule, IgxButtonDirective, IgxButtonGroupComponent, IgxButtonGroupModule, IgxButtonModule, IgxCSVTextDirective, IgxCalendarComponent, IgxCalendarHeaderTemplateDirective, IgxCalendarHeaderTitleTemplateDirective, IgxCalendarModule, IgxCalendarMonthDirective, IgxCalendarScrollPageDirective, IgxCalendarSubheaderTemplateDirective, IgxCalendarView, IgxCalendarViewBaseDirective, IgxCalendarYearDirective, IgxCardActionsComponent, IgxCardActionsLayout, IgxCardComponent, IgxCardContentDirective, IgxCardFooterDirective, IgxCardHeaderComponent, IgxCardHeaderSubtitleDirective, IgxCardHeaderTitleDirective, IgxCardMediaDirective, IgxCardModule, IgxCardThumbnailDirective, IgxCarouselComponent, IgxCarouselIndicatorDirective, IgxCarouselModule, IgxCarouselNextButtonDirective, IgxCarouselPrevButtonDirective, IgxCellEditorTemplateDirective, IgxCellFooterTemplateDirective, IgxCellHeaderTemplateDirective, IgxCellTemplateDirective, IgxCellValidationErrorDirective, IgxCheckboxComponent, IgxCheckboxModule, IgxChildGridRowComponent, IgxChipComponent, IgxChipTypeVariant, IgxChipsAreaComponent, IgxChipsModule, IgxCircularProgressBarComponent, IgxCollapsibleIndicatorTemplateDirective, IgxColumPatternValidatorDirective, IgxColumnActionsBaseDirective, IgxColumnActionsComponent, IgxColumnComponent, IgxColumnEmailValidatorDirective, IgxColumnGroupComponent, IgxColumnHidingDirective, IgxColumnLayoutComponent, IgxColumnMaxLengthValidatorDirective, IgxColumnMaxValidatorDirective, IgxColumnMinLengthValidatorDirective, IgxColumnMinValidatorDirective, IgxColumnPinningDirective, IgxColumnRequiredValidatorDirective, IgxComboAddItemDirective, IgxComboClearIconDirective, IgxComboComponent, IgxComboEmptyDirective, IgxComboFooterDirective, IgxComboHeaderDirective, IgxComboHeaderItemDirective, IgxComboItemDirective, IgxComboModule, IgxComboToggleIconDirective, IgxCsvExporterOptions, IgxCsvExporterService, IgxDataLoadingTemplateDirective, IgxDataRecordSorting, IgxDateFilteringOperand, IgxDatePickerComponent, IgxDatePickerModule, IgxDateRangeEndComponent, IgxDateRangeInputsBaseComponent, IgxDateRangePickerComponent, IgxDateRangePickerModule, IgxDateRangeSeparatorDirective, IgxDateRangeStartComponent, IgxDateSummaryOperand, IgxDateTimeEditorDirective, IgxDateTimeEditorModule, IgxDateTimeFilteringOperand, IgxDaysViewComponent, IgxDefaultDropStrategy, IgxDialogActionsDirective, IgxDialogComponent, IgxDialogModule, IgxDialogTitleDirective, IgxDividerDirective, IgxDividerModule, IgxDividerType, IgxDragDirective, IgxDragDropModule, IgxDragHandleDirective, IgxDragIgnoreDirective, IgxDragIndicatorIconDirective, IgxDragLocation, IgxDropDirective, IgxDropDownComponent, IgxDropDownGroupComponent, IgxDropDownItemComponent, IgxDropDownItemNavigationDirective, IgxDropDownModule, IgxEmptyListTemplateDirective, IgxExcelExporterOptions, IgxExcelExporterService, IgxExcelStyleClearFiltersComponent, IgxExcelStyleColumnOperationsTemplateDirective, IgxExcelStyleConditionalFilterComponent, IgxExcelStyleDateExpressionComponent, IgxExcelStyleFilterOperationsTemplateDirective, IgxExcelStyleHeaderComponent, IgxExcelStyleHeaderIconDirective, IgxExcelStyleHidingComponent, IgxExcelStyleLoadingValuesTemplateDirective, IgxExcelStyleMovingComponent, IgxExcelStylePinningComponent, IgxExcelStyleSearchComponent, IgxExcelStyleSelectingComponent, IgxExcelStyleSortingComponent, IgxExcelTextDirective, IgxExpansionPanelBodyComponent, IgxExpansionPanelComponent, IgxExpansionPanelDescriptionDirective, IgxExpansionPanelHeaderComponent, IgxExpansionPanelIconDirective, IgxExpansionPanelModule, IgxExpansionPanelTitleDirective, IgxExporterOptionsBase, IgxFilterCellTemplateDirective, IgxFilterDirective, IgxFilterModule, IgxFilterOptions, IgxFilterPipe, IgxFilteringOperand, IgxFlatTransactionFactory, IgxFlexDirective, IgxFocusDirective, IgxFocusModule, IgxFocusTrapDirective, IgxFocusTrapModule, IgxForOfContext, IgxForOfDirective, IgxForOfModule, IgxGridActionButtonComponent, IgxGridActionsBaseDirective, IgxGridCell, IgxGridComponent, IgxGridDetailTemplateDirective, IgxGridEditingActionsComponent, IgxGridExcelStyleFilteringComponent, IgxGridFooterComponent, IgxGridForOfContext, IgxGridForOfDirective, IgxGridHeaderComponent, IgxGridHeaderGroupComponent, IgxGridHeaderRowComponent, IgxGridModule, IgxGridPinningActionsComponent, IgxGridRow, IgxGridStateDirective, IgxGridToolbarActionsComponent, IgxGridToolbarAdvancedFilteringComponent, IgxGridToolbarComponent, IgxGridToolbarDirective, IgxGridToolbarExporterComponent, IgxGridToolbarHidingComponent, IgxGridToolbarPinningComponent, IgxGridToolbarTitleComponent, IgxGridTransaction, IgxGroupAreaDropDirective, IgxGroupByRow, IgxGroupByRowSelectorDirective, IgxGroupByRowTemplateDirective, IgxGroupedTreeGridSorting, IgxGrouping, IgxHeadSelectorDirective, IgxHeaderCollapsedIndicatorDirective, IgxHeaderExpandedIndicatorDirective, IgxHierarchicalGridComponent, IgxHierarchicalGridModule, IgxHierarchicalGridRow, IgxHierarchicalTransactionFactory, IgxHierarchicalTransactionService, IgxHintDirective, IgxIconButtonDirective, IgxIconComponent, IgxIconModule, IgxIconService, IgxInputDirective, IgxInputGroupComponent, IgxInputGroupModule, IgxInputState, IgxInsertDropStrategy, IgxItemListDirective, IgxLabelDirective, IgxLayoutDirective, IgxLayoutModule, IgxLinearProgressBarComponent, IgxListActionDirective, IgxListBaseDirective, IgxListComponent, IgxListItemComponent, IgxListItemLeftPanningTemplateDirective, IgxListItemRightPanningTemplateDirective, IgxListLineDirective, IgxListLineSubTitleDirective, IgxListLineTitleDirective, IgxListModule, IgxListPanState, IgxListThumbnailDirective, IgxMaskDirective, IgxMaskModule, IgxMonthPickerComponent, IgxMonthsViewComponent, IgxNavDrawerItemDirective, IgxNavDrawerMiniTemplateDirective, IgxNavDrawerTemplateDirective, IgxNavbarActionDirective, IgxNavbarComponent, IgxNavbarModule, IgxNavbarTitleDirective, IgxNavigationCloseDirective, IgxNavigationDrawerComponent, IgxNavigationDrawerModule, IgxNavigationService, IgxNavigationToggleDirective, IgxNumberFilteringOperand, IgxNumberSummaryOperand, IgxOverlayOutletDirective, IgxOverlayService, IgxPageNavigationComponent, IgxPageSizeSelectorComponent, IgxPaginatorComponent, IgxPaginatorContentDirective, IgxPaginatorDirective, IgxPaginatorModule, IgxPickerActionsDirective, IgxPickerClearComponent, IgxPickerToggleComponent, IgxPivotAggregate, IgxPivotDataSelectorComponent, IgxPivotDateAggregate, IgxPivotDateDimension, IgxPivotGridComponent, IgxPivotGridModule, IgxPivotNumericAggregate, IgxPivotRowDimensionHeaderTemplateDirective, IgxPivotTimeAggregate, IgxPivotValueChipTemplateDirective, IgxPrefixDirective, IgxPrependDropStrategy, IgxProgressBarGradientDirective, IgxProgressBarModule, IgxProgressBarTextTemplateDirective, IgxProgressType, IgxQueryBuilderComponent, IgxQueryBuilderHeaderComponent, IgxQueryBuilderModule, IgxQueryBuilderSearchValueTemplateDirective, IgxRadioComponent, IgxRadioGroupDirective, IgxRadioModule, IgxRippleDirective, IgxRippleModule, IgxRowAddTextDirective, IgxRowCollapsedIndicatorDirective, IgxRowDirective, IgxRowDragGhostDirective, IgxRowEditActionsDirective, IgxRowEditTabStopDirective, IgxRowEditTextDirective, IgxRowExpandedIndicatorDirective, IgxRowIslandComponent, IgxRowSelectorDirective, IgxScrollInertiaDirective, IgxScrollInertiaModule, IgxSelectComponent, IgxSelectFooterDirective, IgxSelectGroupComponent, IgxSelectHeaderDirective, IgxSelectItemComponent, IgxSelectModule, IgxSelectToggleIconDirective, IgxSimpleComboComponent, IgxSimpleComboModule, IgxSlideComponent, IgxSliderComponent, IgxSliderModule, IgxSliderType, IgxSnackbarComponent, IgxSnackbarModule, IgxSortAscendingHeaderIconDirective, IgxSortDescendingHeaderIconDirective, IgxSortHeaderIconDirective, IgxSorting, IgxSplitBarComponent, IgxSplitterComponent, IgxSplitterModule, IgxSplitterPaneComponent, IgxStepActiveIndicatorDirective, IgxStepCompletedIndicatorDirective, IgxStepComponent, IgxStepContentDirective, IgxStepIndicatorDirective, IgxStepInvalidIndicatorDirective, IgxStepSubtitleDirective, IgxStepTitleDirective, IgxStepType, IgxStepperComponent, IgxStepperModule, IgxStepperOrientation, IgxStepperTitlePosition, IgxStringFilteringOperand, IgxSuffixDirective, IgxSummaryOperand, IgxSummaryRow, IgxSummaryTemplateDirective, IgxSwitchComponent, IgxSwitchModule, IgxTabContentComponent, IgxTabHeaderComponent, IgxTabHeaderIconDirective, IgxTabHeaderLabelDirective, IgxTabItemComponent, IgxTabsAlignment, IgxTabsComponent, IgxTabsModule, IgxTemplateOutletDirective, IgxTextAlign, IgxTextHighlightDirective, IgxTextHighlightModule, IgxTextHighlightService, IgxTextSelectionDirective, IgxTextSelectionModule, IgxThumbFromTemplateDirective, IgxThumbToTemplateDirective, IgxTickLabelTemplateDirective, IgxTimeFilteringOperand, IgxTimeItemDirective, IgxTimePickerComponent, IgxTimePickerModule, IgxTimeSummaryOperand, IgxToastComponent, IgxToastModule, IgxToggleActionDirective, IgxToggleDirective, IgxToggleModule, IgxTooltipDirective, IgxTooltipModule, IgxTooltipTargetDirective, IgxTransactionService, IgxTreeComponent, IgxTreeExpandIndicatorDirective, IgxTreeGridComponent, IgxTreeGridGroupByAreaComponent, IgxTreeGridGroupingPipe, IgxTreeGridModule, IgxTreeGridRow, IgxTreeModule, IgxTreeNodeComponent, IgxTreeNodeLinkDirective, IgxTreeSelectionType, IgxYearsViewComponent, IndigoIcons, InputResourceStringsEN, LabelPosition, ListResourceStringsEN, NoOpScrollStrategy, NoopFilteringStrategy, NoopPivotDimensionsStrategy, NoopSortingStrategy, PaginatorResourceStringsEN, PagingError, PickerInteractionMode, PivotColumnDimensionsStrategy, PivotDimensionType, PivotRowDimensionsStrategy, PivotRowLayoutType, PivotSummaryPosition, Point, QueryBuilderResourceStringsEN, RadioGroupAlignment, RelativePosition, RelativePositionStrategy, RowPinningPosition, ScrollStrategy, Size, SliderHandle, SortingDirection, SplitterType, THEME_TOKEN, ThemeToken, TickLabelsOrientation, TicksOrientation, TimePickerResourceStringsEN, TransactionEventOrigin, TransactionType, TreeGridFilteringStrategy, TreeGridFormattedValuesFilteringStrategy, TreeGridMatchingRecordsOnlyFilteringStrategy, TreeResourceStringsEN, VerticalAlignment, VerticalAnimationType, WEEKDAYS, changei18n, comboIgnoreDiacriticsFilter, igxI18N, isLeap, monthRange, range, weekDay };
